/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3315);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(439);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(735), __esModule: true };

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(720);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(719);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(274);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(274);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(581);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(21)
  , core      = __webpack_require__(87)
  , hide      = __webpack_require__(57)
  , redefine  = __webpack_require__(58)
  , ctx       = __webpack_require__(88)
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE]
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE] || (exports[PROTOTYPE] = {})
    , key, own, out, exp;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if(target)redefine(target, key, out, type & $export.U);
    // export
    if(exports[key] != out)hide(exports, key, exp);
    if(IS_PROTO && expProto[key] != out)expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library` 
module.exports = $export;

/***/ }),
/* 7 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
var stylesInDom = {},
	memoize = function(fn) {
		var memo;
		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	},
	isOldIE = memoize(function() {
		// Test for IE <= 9 as proposed by Browserhacks
		// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
		// Tests for existence of standard globals is to allow style-loader 
		// to operate correctly into non-standard environments
		// @see https://github.com/webpack-contrib/style-loader/issues/177
		return window && document && document.all && !window.atob;
	}),
	getElement = (function(fn) {
		var memo = {};
		return function(selector) {
			if (typeof memo[selector] === "undefined") {
				memo[selector] = fn.call(this, selector);
			}
			return memo[selector]
		};
	})(function (styleTarget) {
		return document.querySelector(styleTarget)
	}),
	singletonElement = null,
	singletonCounter = 0,
	styleElementsInsertedAtTop = [],
	fixUrls = __webpack_require__(1169);

module.exports = function(list, options) {
	if(typeof DEBUG !== "undefined" && DEBUG) {
		if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};
	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (typeof options.singleton === "undefined") options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (typeof options.insertInto === "undefined") options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

	var styles = listToStyles(list);
	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			domStyle.refs--;
			mayRemove.push(domStyle);
		}
		if(newList) {
			var newStyles = listToStyles(newList);
			addStylesToDom(newStyles, options);
		}
		for(var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];
			if(domStyle.refs === 0) {
				for(var j = 0; j < domStyle.parts.length; j++)
					domStyle.parts[j]();
				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom(styles, options) {
	for(var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];
		if(domStyle) {
			domStyle.refs++;
			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}
			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];
			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}
			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles(list) {
	var styles = [];
	var newStyles = {};
	for(var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};
		if(!newStyles[id])
			styles.push(newStyles[id] = {id: id, parts: [part]});
		else
			newStyles[id].parts.push(part);
	}
	return styles;
}

function insertStyleElement(options, styleElement) {
	var styleTarget = getElement(options.insertInto)
	if (!styleTarget) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}
	var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
	if (options.insertAt === "top") {
		if(!lastStyleElementInsertedAtTop) {
			styleTarget.insertBefore(styleElement, styleTarget.firstChild);
		} else if(lastStyleElementInsertedAtTop.nextSibling) {
			styleTarget.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			styleTarget.appendChild(styleElement);
		}
		styleElementsInsertedAtTop.push(styleElement);
	} else if (options.insertAt === "bottom") {
		styleTarget.appendChild(styleElement);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(styleElement) {
	styleElement.parentNode.removeChild(styleElement);
	var idx = styleElementsInsertedAtTop.indexOf(styleElement);
	if(idx >= 0) {
		styleElementsInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var styleElement = document.createElement("style");
	options.attrs.type = "text/css";

	attachTagAttrs(styleElement, options.attrs);
	insertStyleElement(options, styleElement);
	return styleElement;
}

function createLinkElement(options) {
	var linkElement = document.createElement("link");
	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	attachTagAttrs(linkElement, options.attrs);
	insertStyleElement(options, linkElement);
	return linkElement;
}

function attachTagAttrs(element, attrs) {
	Object.keys(attrs).forEach(function (key) {
		element.setAttribute(key, attrs[key]);
	});
}

function addStyle(obj, options) {
	var styleElement, update, remove;

	if (options.singleton) {
		var styleIndex = singletonCounter++;
		styleElement = singletonElement || (singletonElement = createStyleElement(options));
		update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
		remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
	} else if(obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function") {
		styleElement = createLinkElement(options);
		update = updateLink.bind(null, styleElement, options);
		remove = function() {
			removeStyleElement(styleElement);
			if(styleElement.href)
				URL.revokeObjectURL(styleElement.href);
		};
	} else {
		styleElement = createStyleElement(options);
		update = applyToTag.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if(newObj) {
			if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
				return;
			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;
		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag(styleElement, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (styleElement.styleSheet) {
		styleElement.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = styleElement.childNodes;
		if (childNodes[index]) styleElement.removeChild(childNodes[index]);
		if (childNodes.length) {
			styleElement.insertBefore(cssNode, childNodes[index]);
		} else {
			styleElement.appendChild(cssNode);
		}
	}
}

function applyToTag(styleElement, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		styleElement.setAttribute("media", media)
	}

	if(styleElement.styleSheet) {
		styleElement.styleSheet.cssText = css;
	} else {
		while(styleElement.firstChild) {
			styleElement.removeChild(styleElement.firstChild);
		}
		styleElement.appendChild(document.createTextNode(css));
	}
}

function updateLink(linkElement, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/* If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
	and there is no publicPath defined then lets turn convertToAbsoluteUrls
	on by default.  Otherwise default to the convertToAbsoluteUrls option
	directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls){
		css = fixUrls(css);
	}

	if(sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = linkElement.href;

	linkElement.href = URL.createObjectURL(blob);

	if(oldSrc)
		URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @module FactoryMaker
 */


Object.defineProperty(exports, "__esModule", {
    value: true
});
var FactoryMaker = (function () {

    var instance = undefined;
    var extensions = [];
    var singletonContexts = [];

    function extend(name, childInstance, override, context) {
        var extensionContext = getExtensionContext(context);
        if (!extensionContext[name] && childInstance) {
            extensionContext[name] = { instance: childInstance, override: override };
        }
    }

    /**
     * Use this method from your extended object.  this.factory is injected into your object.
     * this.factory.getSingletonInstance(this.context, 'VideoModel')
     * will return the video model for use in the extended object.
     *
     * @param {Object} context - injected into extended object as this.context
     * @param {string} className - string name found in all dash.js objects
     * with name __dashjs_factory_name Will be at the bottom. Will be the same as the object's name.
     * @returns {*} Context aware instance of specified singleton name.
     * @memberof module:FactoryMaker
     * @instance
     */
    function getSingletonInstance(context, className) {
        for (var i in singletonContexts) {
            var obj = singletonContexts[i];
            if (obj.context === context && obj.name === className) {
                return obj.instance;
            }
        }
        return null;
    }

    /**
     * Use this method to add an singleton instance to the system.  Useful for unit testing to mock objects etc.
     *
     * @param {Object} context
     * @param {string} className
     * @param {Object} instance
     * @memberof module:FactoryMaker
     * @instance
     */
    function setSingletonInstance(context, className, instance) {
        for (var i in singletonContexts) {
            var obj = singletonContexts[i];
            if (obj.context === context && obj.name === className) {
                singletonContexts[i].instance = instance;
                return;
            }
        }
        singletonContexts.push({ name: className, context: context, instance: instance });
    }

    function getClassFactory(classConstructor) {
        return function (context) {
            if (context === undefined) {
                context = {};
            }
            return {
                create: function create() {
                    return merge(classConstructor.__dashjs_factory_name, classConstructor.apply({ context: context }, arguments), context, arguments);
                }
            };
        };
    }

    function getSingletonFactory(classConstructor) {
        return function (context) {
            var instance = undefined;
            if (context === undefined) {
                context = {};
            }
            return {
                getInstance: function getInstance() {
                    // If we don't have an instance yet check for one on the context
                    if (!instance) {
                        instance = getSingletonInstance(context, classConstructor.__dashjs_factory_name);
                    }
                    // If there's no instance on the context then create one
                    if (!instance) {
                        instance = merge(classConstructor.__dashjs_factory_name, classConstructor.apply({ context: context }, arguments), context, arguments);
                        singletonContexts.push({ name: classConstructor.__dashjs_factory_name, context: context, instance: instance });
                    }
                    return instance;
                }
            };
        };
    }

    function merge(name, classConstructor, context, args) {
        var extensionContext = getExtensionContext(context);
        var extensionObject = extensionContext[name];
        if (extensionObject) {
            var extension = extensionObject.instance;
            if (extensionObject.override) {
                //Override public methods in parent but keep parent.
                extension = extension.apply({ context: context, factory: instance, parent: classConstructor }, args);
                for (var prop in extension) {
                    if (classConstructor.hasOwnProperty(prop)) {
                        classConstructor[prop] = extension[prop];
                    }
                }
            } else {
                //replace parent object completely with new object. Same as dijon.
                return extension.apply({ context: context, factory: instance }, args);
            }
        }
        return classConstructor;
    }

    function getExtensionContext(context) {
        var extensionContext = undefined;
        extensions.forEach(function (obj) {
            if (obj === context) {
                extensionContext = obj;
            }
        });
        if (!extensionContext) {
            extensionContext = extensions.push(context);
        }
        return extensionContext;
    }

    instance = {
        extend: extend,
        getSingletonInstance: getSingletonInstance,
        setSingletonInstance: setSingletonInstance,
        getSingletonFactory: getSingletonFactory,
        getClassFactory: getClassFactory
    };

    return instance;
})();

exports["default"] = FactoryMaker;
module.exports = exports["default"];
//# sourceMappingURL=FactoryMaker.js.map


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return addLocaleData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return intlShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return injectIntl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defineMessages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return IntlProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FormattedDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FormattedTime; });
/* unused harmony export FormattedRelative */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FormattedNumber; });
/* unused harmony export FormattedPlural */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormattedMessage; });
/* unused harmony export FormattedHTMLMessage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_data_index_js__ = __webpack_require__(1193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_data_index_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__locale_data_index_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat__ = __webpack_require__(988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_intl_relativeformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_intl_format_cache__ = __webpack_require__(978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_intl_format_cache__);
/*
 * Copyright 2017, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */









// GENERATED FILE
var defaultLocaleData = { "locale": "en", "pluralRuleFunction": function pluralRuleFunction(n, ord) {
    var s = String(n).split("."),
        v0 = !s[1],
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1),
        n100 = t0 && s[0].slice(-2);if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";return n == 1 && v0 ? "one" : "other";
  }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "minute": { "displayName": "minute", "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } } } };

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function addLocaleData() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var locales = Array.isArray(data) ? data : [data];

    locales.forEach(function (localeData) {
        if (localeData && localeData.locale) {
            __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.__addLocaleData(localeData);
            __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.__addLocaleData(localeData);
        }
    });
}

function hasLocaleData(locale) {
    var localeParts = (locale || '').split('-');

    while (localeParts.length > 0) {
        if (hasIMFAndIRFLocaleData(localeParts.join('-'))) {
            return true;
        }

        localeParts.pop();
    }

    return false;
}

function hasIMFAndIRFLocaleData(locale) {
    var normalizedLocale = locale && locale.toLowerCase();

    return !!(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.__localeData__[normalizedLocale] && __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.__localeData__[normalizedLocale]);
}

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};



















var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var bool = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool;
var number = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number;
var string = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string;
var func = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func;
var object = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object;
var oneOf = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf;
var shape = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape;
var any = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any;

var localeMatcher = oneOf(['best fit', 'lookup']);
var narrowShortLong = oneOf(['narrow', 'short', 'long']);
var numeric2digit = oneOf(['numeric', '2-digit']);
var funcReq = func.isRequired;

var intlConfigPropTypes = {
    locale: string,
    formats: object,
    messages: object,
    textComponent: any,

    defaultLocale: string,
    defaultFormats: object
};

var intlFormatPropTypes = {
    formatDate: funcReq,
    formatTime: funcReq,
    formatRelative: funcReq,
    formatNumber: funcReq,
    formatPlural: funcReq,
    formatMessage: funcReq,
    formatHTMLMessage: funcReq
};

var intlShape = shape(_extends({}, intlConfigPropTypes, intlFormatPropTypes, {
    formatters: object,
    now: funcReq
}));

var messageDescriptorPropTypes = {
    id: string.isRequired,
    description: string,
    defaultMessage: string
};

var dateTimeFormatPropTypes = {
    localeMatcher: localeMatcher,
    formatMatcher: oneOf(['basic', 'best fit']),

    timeZone: string,
    hour12: bool,

    weekday: narrowShortLong,
    era: narrowShortLong,
    year: numeric2digit,
    month: oneOf(['numeric', '2-digit', 'narrow', 'short', 'long']),
    day: numeric2digit,
    hour: numeric2digit,
    minute: numeric2digit,
    second: numeric2digit,
    timeZoneName: oneOf(['short', 'long'])
};

var numberFormatPropTypes = {
    localeMatcher: localeMatcher,

    style: oneOf(['decimal', 'currency', 'percent']),
    currency: string,
    currencyDisplay: oneOf(['symbol', 'code', 'name']),
    useGrouping: bool,

    minimumIntegerDigits: number,
    minimumFractionDigits: number,
    maximumFractionDigits: number,
    minimumSignificantDigits: number,
    maximumSignificantDigits: number
};

var relativeFormatPropTypes = {
    style: oneOf(['best fit', 'numeric']),
    units: oneOf(['second', 'minute', 'hour', 'day', 'month', 'year'])
};

var pluralFormatPropTypes = {
    style: oneOf(['cardinal', 'ordinal'])
};

/*
HTML escaping and shallow-equals implementations are the same as React's
(on purpose.) Therefore, it has the following Copyright and Licensing:

Copyright 2013-2014, Facebook, Inc.
All rights reserved.

This source code is licensed under the BSD-style license found in the LICENSE
file in the root directory of React's source tree.
*/

var intlConfigPropNames = Object.keys(intlConfigPropTypes);

var ESCAPED_CHARS = {
    '&': '&amp;',
    '>': '&gt;',
    '<': '&lt;',
    '"': '&quot;',
    '\'': '&#x27;'
};

var UNSAFE_CHARS_REGEX = /[&><"']/g;

function escape(str) {
    return ('' + str).replace(UNSAFE_CHARS_REGEX, function (match) {
        return ESCAPED_CHARS[match];
    });
}

function filterProps(props, whitelist) {
    var defaults$$1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    return whitelist.reduce(function (filtered, name) {
        if (props.hasOwnProperty(name)) {
            filtered[name] = props[name];
        } else if (defaults$$1.hasOwnProperty(name)) {
            filtered[name] = defaults$$1[name];
        }

        return filtered;
    }, {});
}

function invariantIntlContext() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        intl = _ref.intl;

    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(intl, '[React Intl] Could not find required `intl` object. ' + '<IntlProvider> needs to exist in the component ancestry.');
}

function shallowEquals(objA, objB) {
    if (objA === objB) {
        return true;
    }

    if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
        return false;
    }

    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);

    if (keysA.length !== keysB.length) {
        return false;
    }

    // Test for A's keys different from B.
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    for (var i = 0; i < keysA.length; i++) {
        if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
            return false;
        }
    }

    return true;
}

function shouldIntlComponentUpdate(_ref2, nextProps, nextState) {
    var props = _ref2.props,
        state = _ref2.state,
        _ref2$context = _ref2.context,
        context = _ref2$context === undefined ? {} : _ref2$context;
    var nextContext = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var _context$intl = context.intl,
        intl = _context$intl === undefined ? {} : _context$intl;
    var _nextContext$intl = nextContext.intl,
        nextIntl = _nextContext$intl === undefined ? {} : _nextContext$intl;


    return !shallowEquals(nextProps, props) || !shallowEquals(nextState, state) || !(nextIntl === intl || shallowEquals(filterProps(nextIntl, intlConfigPropNames), filterProps(intl, intlConfigPropNames)));
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// Inspired by react-redux's `connect()` HOC factory function implementation:
// https://github.com/rackt/react-redux

function getDisplayName(Component$$1) {
    return Component$$1.displayName || Component$$1.name || 'Component';
}

function injectIntl(WrappedComponent) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$intlPropName = options.intlPropName,
        intlPropName = _options$intlPropName === undefined ? 'intl' : _options$intlPropName,
        _options$withRef = options.withRef,
        withRef = _options$withRef === undefined ? false : _options$withRef;

    var InjectIntl = function (_Component) {
        inherits(InjectIntl, _Component);

        function InjectIntl(props, context) {
            classCallCheck(this, InjectIntl);

            var _this = possibleConstructorReturn(this, (InjectIntl.__proto__ || Object.getPrototypeOf(InjectIntl)).call(this, props, context));

            invariantIntlContext(context);
            return _this;
        }

        createClass(InjectIntl, [{
            key: 'getWrappedInstance',
            value: function getWrappedInstance() {
                __WEBPACK_IMPORTED_MODULE_5_invariant___default()(withRef, '[React Intl] To access the wrapped instance, ' + 'the `{withRef: true}` option must be set when calling: ' + '`injectIntl()`');

                return this.refs.wrappedInstance;
            }
        }, {
            key: 'render',
            value: function render() {
                return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(WrappedComponent, _extends({}, this.props, defineProperty({}, intlPropName, this.context.intl), {
                    ref: withRef ? 'wrappedInstance' : null
                }));
            }
        }]);
        return InjectIntl;
    }(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

    InjectIntl.displayName = 'InjectIntl(' + getDisplayName(WrappedComponent) + ')';
    InjectIntl.contextTypes = {
        intl: intlShape
    };
    InjectIntl.WrappedComponent = WrappedComponent;


    return InjectIntl;
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function defineMessages(messageDescriptors) {
  // This simply returns what's passed-in because it's meant to be a hook for
  // babel-plugin-react-intl.
  return messageDescriptors;
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// This is a "hack" until a proper `intl-pluralformat` package is created.

function resolveLocale(locales) {
    // IntlMessageFormat#_resolveLocale() does not depend on `this`.
    return __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.prototype._resolveLocale(locales);
}

function findPluralFunction(locale) {
    // IntlMessageFormat#_findPluralFunction() does not depend on `this`.
    return __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.prototype._findPluralRuleFunction(locale);
}

var IntlPluralFormat = function IntlPluralFormat(locales) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    classCallCheck(this, IntlPluralFormat);

    var useOrdinal = options.style === 'ordinal';
    var pluralFn = findPluralFunction(resolveLocale(locales));

    this.format = function (value) {
        return pluralFn(value, useOrdinal);
    };
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var DATE_TIME_FORMAT_OPTIONS = Object.keys(dateTimeFormatPropTypes);
var NUMBER_FORMAT_OPTIONS = Object.keys(numberFormatPropTypes);
var RELATIVE_FORMAT_OPTIONS = Object.keys(relativeFormatPropTypes);
var PLURAL_FORMAT_OPTIONS = Object.keys(pluralFormatPropTypes);

var RELATIVE_FORMAT_THRESHOLDS = {
    second: 60, // seconds to minute
    minute: 60, // minutes to hour
    hour: 24, // hours to day
    day: 30, // days to month
    month: 12 };

function updateRelativeFormatThresholds(newThresholds) {
    var thresholds = __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.thresholds;
    thresholds.second = newThresholds.second;
    thresholds.minute = newThresholds.minute;
    thresholds.hour = newThresholds.hour;
    thresholds.day = newThresholds.day;
    thresholds.month = newThresholds.month;
}

function getNamedFormat(formats, type, name) {
    var format = formats && formats[type] && formats[type][name];
    if (format) {
        return format;
    }

    if (false) {
        console.error('[React Intl] No ' + type + ' format named: ' + name);
    }
}

function formatDate(config, state, value) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var locale = config.locale,
        formats = config.formats;
    var format = options.format;


    var date = new Date(value);
    var defaults$$1 = format && getNamedFormat(formats, 'date', format);
    var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

    try {
        return state.getDateTimeFormat(locale, filteredOptions).format(date);
    } catch (e) {
        if (false) {
            console.error('[React Intl] Error formatting date.\n' + e);
        }
    }

    return String(date);
}

function formatTime(config, state, value) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var locale = config.locale,
        formats = config.formats;
    var format = options.format;


    var date = new Date(value);
    var defaults$$1 = format && getNamedFormat(formats, 'time', format);
    var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

    if (!filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second) {
        // Add default formatting options if hour, minute, or second isn't defined.
        filteredOptions = _extends({}, filteredOptions, { hour: 'numeric', minute: 'numeric' });
    }

    try {
        return state.getDateTimeFormat(locale, filteredOptions).format(date);
    } catch (e) {
        if (false) {
            console.error('[React Intl] Error formatting time.\n' + e);
        }
    }

    return String(date);
}

function formatRelative(config, state, value) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var locale = config.locale,
        formats = config.formats;
    var format = options.format;


    var date = new Date(value);
    var now = new Date(options.now);
    var defaults$$1 = format && getNamedFormat(formats, 'relative', format);
    var filteredOptions = filterProps(options, RELATIVE_FORMAT_OPTIONS, defaults$$1);

    // Capture the current threshold values, then temporarily override them with
    // specific values just for this render.
    var oldThresholds = _extends({}, __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.thresholds);
    updateRelativeFormatThresholds(RELATIVE_FORMAT_THRESHOLDS);

    try {
        return state.getRelativeFormat(locale, filteredOptions).format(date, {
            now: isFinite(now) ? now : state.now()
        });
    } catch (e) {
        if (false) {
            console.error('[React Intl] Error formatting relative time.\n' + e);
        }
    } finally {
        updateRelativeFormatThresholds(oldThresholds);
    }

    return String(date);
}

function formatNumber(config, state, value) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var locale = config.locale,
        formats = config.formats;
    var format = options.format;


    var defaults$$1 = format && getNamedFormat(formats, 'number', format);
    var filteredOptions = filterProps(options, NUMBER_FORMAT_OPTIONS, defaults$$1);

    try {
        return state.getNumberFormat(locale, filteredOptions).format(value);
    } catch (e) {
        if (false) {
            console.error('[React Intl] Error formatting number.\n' + e);
        }
    }

    return String(value);
}

function formatPlural(config, state, value) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var locale = config.locale;


    var filteredOptions = filterProps(options, PLURAL_FORMAT_OPTIONS);

    try {
        return state.getPluralFormat(locale, filteredOptions).format(value);
    } catch (e) {
        if (false) {
            console.error('[React Intl] Error formatting plural.\n' + e);
        }
    }

    return 'other';
}

function formatMessage(config, state) {
    var messageDescriptor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var values = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var locale = config.locale,
        formats = config.formats,
        messages = config.messages,
        defaultLocale = config.defaultLocale,
        defaultFormats = config.defaultFormats;
    var id = messageDescriptor.id,
        defaultMessage = messageDescriptor.defaultMessage;

    // `id` is a required field of a Message Descriptor.

    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(id, '[React Intl] An `id` must be provided to format a message.');

    var message = messages && messages[id];
    var hasValues = Object.keys(values).length > 0;

    // Avoid expensive message formatting for simple messages without values. In
    // development messages will always be formatted in case of missing values.
    if (!hasValues && 'production' === 'production') {
        return message || defaultMessage || id;
    }

    var formattedMessage = void 0;

    if (message) {
        try {
            var formatter = state.getMessageFormat(message, locale, formats);

            formattedMessage = formatter.format(values);
        } catch (e) {
            if (false) {
                console.error('[React Intl] Error formatting message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : '') + ('\n' + e));
            }
        }
    } else {
        if (false) {
            // This prevents warnings from littering the console in development
            // when no `messages` are passed into the <IntlProvider> for the
            // default locale, and a default message is in the source.
            if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) {

                console.error('[React Intl] Missing message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : ''));
            }
        }
    }

    if (!formattedMessage && defaultMessage) {
        try {
            var _formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats);

            formattedMessage = _formatter.format(values);
        } catch (e) {
            if (false) {
                console.error('[React Intl] Error formatting the default message for: "' + id + '"' + ('\n' + e));
            }
        }
    }

    if (!formattedMessage) {
        if (false) {
            console.error('[React Intl] Cannot format message: "' + id + '", ' + ('using message ' + (message || defaultMessage ? 'source' : 'id') + ' as fallback.'));
        }
    }

    return formattedMessage || message || defaultMessage || id;
}

function formatHTMLMessage(config, state, messageDescriptor) {
    var rawValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    // Process all the values before they are used when formatting the ICU
    // Message string. Since the formatted message might be injected via
    // `innerHTML`, all String-based values need to be HTML-escaped.
    var escapedValues = Object.keys(rawValues).reduce(function (escaped, name) {
        var value = rawValues[name];
        escaped[name] = typeof value === 'string' ? escape(value) : value;
        return escaped;
    }, {});

    return formatMessage(config, state, messageDescriptor, escapedValues);
}



var format = Object.freeze({
	formatDate: formatDate,
	formatTime: formatTime,
	formatRelative: formatRelative,
	formatNumber: formatNumber,
	formatPlural: formatPlural,
	formatMessage: formatMessage,
	formatHTMLMessage: formatHTMLMessage
});

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var intlConfigPropNames$1 = Object.keys(intlConfigPropTypes);
var intlFormatPropNames = Object.keys(intlFormatPropTypes);

// These are not a static property on the `IntlProvider` class so the intl
// config values can be inherited from an <IntlProvider> ancestor.
var defaultProps = {
    formats: {},
    messages: {},
    textComponent: 'span',

    defaultLocale: 'en',
    defaultFormats: {}
};

var IntlProvider = function (_Component) {
    inherits(IntlProvider, _Component);

    function IntlProvider(props) {
        var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        classCallCheck(this, IntlProvider);

        var _this = possibleConstructorReturn(this, (IntlProvider.__proto__ || Object.getPrototypeOf(IntlProvider)).call(this, props, context));

        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(typeof Intl !== 'undefined', '[React Intl] The `Intl` APIs must be available in the runtime, ' + 'and do not appear to be built-in. An `Intl` polyfill should be loaded.\n' + 'See: http://formatjs.io/guides/runtime-environments/');

        var intlContext = context.intl;

        // Used to stabilize time when performing an initial rendering so that
        // all relative times use the same reference "now" time.

        var initialNow = void 0;
        if (isFinite(props.initialNow)) {
            initialNow = Number(props.initialNow);
        } else {
            // When an `initialNow` isn't provided via `props`, look to see an
            // <IntlProvider> exists in the ancestry and call its `now()`
            // function to propagate its value for "now".
            initialNow = intlContext ? intlContext.now() : Date.now();
        }

        // Creating `Intl*` formatters is expensive. If there's a parent
        // `<IntlProvider>`, then its formatters will be used. Otherwise, this
        // memoize the `Intl*` constructors and cache them for the lifecycle of
        // this IntlProvider instance.

        var _ref = intlContext || {},
            _ref$formatters = _ref.formatters,
            formatters = _ref$formatters === undefined ? {
            getDateTimeFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(Intl.DateTimeFormat),
            getNumberFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(Intl.NumberFormat),
            getMessageFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a),
            getRelativeFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(__WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a),
            getPluralFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(IntlPluralFormat)
        } : _ref$formatters;

        _this.state = _extends({}, formatters, {

            // Wrapper to provide stable "now" time for initial render.
            now: function now() {
                return _this._didDisplay ? Date.now() : initialNow;
            }
        });
        return _this;
    }

    createClass(IntlProvider, [{
        key: 'getConfig',
        value: function getConfig() {
            var intlContext = this.context.intl;

            // Build a whitelisted config object from `props`, defaults, and
            // `context.intl`, if an <IntlProvider> exists in the ancestry.

            var config = filterProps(this.props, intlConfigPropNames$1, intlContext);

            // Apply default props. This must be applied last after the props have
            // been resolved and inherited from any <IntlProvider> in the ancestry.
            // This matches how React resolves `defaultProps`.
            for (var propName in defaultProps) {
                if (config[propName] === undefined) {
                    config[propName] = defaultProps[propName];
                }
            }

            if (!hasLocaleData(config.locale)) {
                var _config = config,
                    locale = _config.locale,
                    defaultLocale = _config.defaultLocale,
                    defaultFormats = _config.defaultFormats;


                if (false) {
                    console.error('[React Intl] Missing locale data for locale: "' + locale + '". ' + ('Using default locale: "' + defaultLocale + '" as fallback.'));
                }

                // Since there's no registered locale data for `locale`, this will
                // fallback to the `defaultLocale` to make sure things can render.
                // The `messages` are overridden to the `defaultProps` empty object
                // to maintain referential equality across re-renders. It's assumed
                // each <FormattedMessage> contains a `defaultMessage` prop.
                config = _extends({}, config, {
                    locale: defaultLocale,
                    formats: defaultFormats,
                    messages: defaultProps.messages
                });
            }

            return config;
        }
    }, {
        key: 'getBoundFormatFns',
        value: function getBoundFormatFns(config, state) {
            return intlFormatPropNames.reduce(function (boundFormatFns, name) {
                boundFormatFns[name] = format[name].bind(null, config, state);
                return boundFormatFns;
            }, {});
        }
    }, {
        key: 'getChildContext',
        value: function getChildContext() {
            var config = this.getConfig();

            // Bind intl factories and current config to the format functions.
            var boundFormatFns = this.getBoundFormatFns(config, this.state);

            var _state = this.state,
                now = _state.now,
                formatters = objectWithoutProperties(_state, ['now']);


            return {
                intl: _extends({}, config, boundFormatFns, {
                    formatters: formatters,
                    now: now
                })
            };
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate() {
            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
                next[_key] = arguments[_key];
            }

            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this._didDisplay = true;
        }
    }, {
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_4_react__["Children"].only(this.props.children);
        }
    }]);
    return IntlProvider;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

IntlProvider.displayName = 'IntlProvider';
IntlProvider.contextTypes = {
    intl: intlShape
};
IntlProvider.childContextTypes = {
    intl: intlShape.isRequired
};
 false ? IntlProvider.propTypes = _extends({}, intlConfigPropTypes, {
    children: PropTypes.element.isRequired,
    initialNow: PropTypes.any
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedDate = function (_Component) {
    inherits(FormattedDate, _Component);

    function FormattedDate(props, context) {
        classCallCheck(this, FormattedDate);

        var _this = possibleConstructorReturn(this, (FormattedDate.__proto__ || Object.getPrototypeOf(FormattedDate)).call(this, props, context));

        invariantIntlContext(context);
        return _this;
    }

    createClass(FormattedDate, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate() {
            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
                next[_key] = arguments[_key];
            }

            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
        }
    }, {
        key: 'render',
        value: function render() {
            var _context$intl = this.context.intl,
                formatDate = _context$intl.formatDate,
                Text = _context$intl.textComponent;
            var _props = this.props,
                value = _props.value,
                children = _props.children;


            var formattedDate = formatDate(value, this.props);

            if (typeof children === 'function') {
                return children(formattedDate);
            }

            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                Text,
                null,
                formattedDate
            );
        }
    }]);
    return FormattedDate;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedDate.displayName = 'FormattedDate';
FormattedDate.contextTypes = {
    intl: intlShape
};
 false ? FormattedDate.propTypes = _extends({}, dateTimeFormatPropTypes, {
    value: PropTypes.any.isRequired,
    format: PropTypes.string,
    children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedTime = function (_Component) {
    inherits(FormattedTime, _Component);

    function FormattedTime(props, context) {
        classCallCheck(this, FormattedTime);

        var _this = possibleConstructorReturn(this, (FormattedTime.__proto__ || Object.getPrototypeOf(FormattedTime)).call(this, props, context));

        invariantIntlContext(context);
        return _this;
    }

    createClass(FormattedTime, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate() {
            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
                next[_key] = arguments[_key];
            }

            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
        }
    }, {
        key: 'render',
        value: function render() {
            var _context$intl = this.context.intl,
                formatTime = _context$intl.formatTime,
                Text = _context$intl.textComponent;
            var _props = this.props,
                value = _props.value,
                children = _props.children;


            var formattedTime = formatTime(value, this.props);

            if (typeof children === 'function') {
                return children(formattedTime);
            }

            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                Text,
                null,
                formattedTime
            );
        }
    }]);
    return FormattedTime;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedTime.displayName = 'FormattedTime';
FormattedTime.contextTypes = {
    intl: intlShape
};
 false ? FormattedTime.propTypes = _extends({}, dateTimeFormatPropTypes, {
    value: PropTypes.any.isRequired,
    format: PropTypes.string,
    children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var SECOND = 1000;
var MINUTE = 1000 * 60;
var HOUR = 1000 * 60 * 60;
var DAY = 1000 * 60 * 60 * 24;

// The maximum timer delay value is a 32-bit signed integer.
// See: https://mdn.io/setTimeout
var MAX_TIMER_DELAY = 2147483647;

function selectUnits(delta) {
    var absDelta = Math.abs(delta);

    if (absDelta < MINUTE) {
        return 'second';
    }

    if (absDelta < HOUR) {
        return 'minute';
    }

    if (absDelta < DAY) {
        return 'hour';
    }

    // The maximum scheduled delay will be measured in days since the maximum
    // timer delay is less than the number of milliseconds in 25 days.
    return 'day';
}

function getUnitDelay(units) {
    switch (units) {
        case 'second':
            return SECOND;
        case 'minute':
            return MINUTE;
        case 'hour':
            return HOUR;
        case 'day':
            return DAY;
        default:
            return MAX_TIMER_DELAY;
    }
}

function isSameDate(a, b) {
    if (a === b) {
        return true;
    }

    var aTime = new Date(a).getTime();
    var bTime = new Date(b).getTime();

    return isFinite(aTime) && isFinite(bTime) && aTime === bTime;
}

var FormattedRelative = function (_Component) {
    inherits(FormattedRelative, _Component);

    function FormattedRelative(props, context) {
        classCallCheck(this, FormattedRelative);

        var _this = possibleConstructorReturn(this, (FormattedRelative.__proto__ || Object.getPrototypeOf(FormattedRelative)).call(this, props, context));

        invariantIntlContext(context);

        var now = isFinite(props.initialNow) ? Number(props.initialNow) : context.intl.now();

        // `now` is stored as state so that `render()` remains a function of
        // props + state, instead of accessing `Date.now()` inside `render()`.
        _this.state = { now: now };
        return _this;
    }

    createClass(FormattedRelative, [{
        key: 'scheduleNextUpdate',
        value: function scheduleNextUpdate(props, state) {
            var _this2 = this;

            // Cancel and pending update because we're scheduling a new update.
            clearTimeout(this._timer);

            var value = props.value,
                units = props.units,
                updateInterval = props.updateInterval;

            var time = new Date(value).getTime();

            // If the `updateInterval` is falsy, including `0` or we don't have a
            // valid date, then auto updates have been turned off, so we bail and
            // skip scheduling an update.
            if (!updateInterval || !isFinite(time)) {
                return;
            }

            var delta = time - state.now;
            var unitDelay = getUnitDelay(units || selectUnits(delta));
            var unitRemainder = Math.abs(delta % unitDelay);

            // We want the largest possible timer delay which will still display
            // accurate information while reducing unnecessary re-renders. The delay
            // should be until the next "interesting" moment, like a tick from
            // "1 minute ago" to "2 minutes ago" when the delta is 120,000ms.
            var delay = delta < 0 ? Math.max(updateInterval, unitDelay - unitRemainder) : Math.max(updateInterval, unitRemainder);

            this._timer = setTimeout(function () {
                _this2.setState({ now: _this2.context.intl.now() });
            }, delay);
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.scheduleNextUpdate(this.props, this.state);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref) {
            var nextValue = _ref.value;

            // When the `props.value` date changes, `state.now` needs to be updated,
            // and the next update can be rescheduled.
            if (!isSameDate(nextValue, this.props.value)) {
                this.setState({ now: this.context.intl.now() });
            }
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate() {
            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
                next[_key] = arguments[_key];
            }

            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
        }
    }, {
        key: 'componentWillUpdate',
        value: function componentWillUpdate(nextProps, nextState) {
            this.scheduleNextUpdate(nextProps, nextState);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            clearTimeout(this._timer);
        }
    }, {
        key: 'render',
        value: function render() {
            var _context$intl = this.context.intl,
                formatRelative = _context$intl.formatRelative,
                Text = _context$intl.textComponent;
            var _props = this.props,
                value = _props.value,
                children = _props.children;


            var formattedRelative = formatRelative(value, _extends({}, this.props, this.state));

            if (typeof children === 'function') {
                return children(formattedRelative);
            }

            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                Text,
                null,
                formattedRelative
            );
        }
    }]);
    return FormattedRelative;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedRelative.displayName = 'FormattedRelative';
FormattedRelative.contextTypes = {
    intl: intlShape
};
FormattedRelative.defaultProps = {
    updateInterval: 1000 * 10
};
 false ? FormattedRelative.propTypes = _extends({}, relativeFormatPropTypes, {
    value: PropTypes.any.isRequired,
    format: PropTypes.string,
    updateInterval: PropTypes.number,
    initialNow: PropTypes.any,
    children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedNumber = function (_Component) {
    inherits(FormattedNumber, _Component);

    function FormattedNumber(props, context) {
        classCallCheck(this, FormattedNumber);

        var _this = possibleConstructorReturn(this, (FormattedNumber.__proto__ || Object.getPrototypeOf(FormattedNumber)).call(this, props, context));

        invariantIntlContext(context);
        return _this;
    }

    createClass(FormattedNumber, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate() {
            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
                next[_key] = arguments[_key];
            }

            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
        }
    }, {
        key: 'render',
        value: function render() {
            var _context$intl = this.context.intl,
                formatNumber = _context$intl.formatNumber,
                Text = _context$intl.textComponent;
            var _props = this.props,
                value = _props.value,
                children = _props.children;


            var formattedNumber = formatNumber(value, this.props);

            if (typeof children === 'function') {
                return children(formattedNumber);
            }

            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                Text,
                null,
                formattedNumber
            );
        }
    }]);
    return FormattedNumber;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedNumber.displayName = 'FormattedNumber';
FormattedNumber.contextTypes = {
    intl: intlShape
};
 false ? FormattedNumber.propTypes = _extends({}, numberFormatPropTypes, {
    value: PropTypes.any.isRequired,
    format: PropTypes.string,
    children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedPlural = function (_Component) {
    inherits(FormattedPlural, _Component);

    function FormattedPlural(props, context) {
        classCallCheck(this, FormattedPlural);

        var _this = possibleConstructorReturn(this, (FormattedPlural.__proto__ || Object.getPrototypeOf(FormattedPlural)).call(this, props, context));

        invariantIntlContext(context);
        return _this;
    }

    createClass(FormattedPlural, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate() {
            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
                next[_key] = arguments[_key];
            }

            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
        }
    }, {
        key: 'render',
        value: function render() {
            var _context$intl = this.context.intl,
                formatPlural = _context$intl.formatPlural,
                Text = _context$intl.textComponent;
            var _props = this.props,
                value = _props.value,
                other = _props.other,
                children = _props.children;


            var pluralCategory = formatPlural(value, this.props);
            var formattedPlural = this.props[pluralCategory] || other;

            if (typeof children === 'function') {
                return children(formattedPlural);
            }

            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                Text,
                null,
                formattedPlural
            );
        }
    }]);
    return FormattedPlural;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedPlural.displayName = 'FormattedPlural';
FormattedPlural.contextTypes = {
    intl: intlShape
};
FormattedPlural.defaultProps = {
    style: 'cardinal'
};
 false ? FormattedPlural.propTypes = _extends({}, pluralFormatPropTypes, {
    value: PropTypes.any.isRequired,

    other: PropTypes.node.isRequired,
    zero: PropTypes.node,
    one: PropTypes.node,
    two: PropTypes.node,
    few: PropTypes.node,
    many: PropTypes.node,

    children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedMessage = function (_Component) {
    inherits(FormattedMessage, _Component);

    function FormattedMessage(props, context) {
        classCallCheck(this, FormattedMessage);

        var _this = possibleConstructorReturn(this, (FormattedMessage.__proto__ || Object.getPrototypeOf(FormattedMessage)).call(this, props, context));

        invariantIntlContext(context);
        return _this;
    }

    createClass(FormattedMessage, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            var values = this.props.values;
            var nextValues = nextProps.values;


            if (!shallowEquals(nextValues, values)) {
                return true;
            }

            // Since `values` has already been checked, we know they're not
            // different, so the current `values` are carried over so the shallow
            // equals comparison on the other props isn't affected by the `values`.
            var nextPropsToCheck = _extends({}, nextProps, {
                values: values
            });

            for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                next[_key - 1] = arguments[_key];
            }

            return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
        }
    }, {
        key: 'render',
        value: function render() {
            var _context$intl = this.context.intl,
                formatMessage = _context$intl.formatMessage,
                Text = _context$intl.textComponent;
            var _props = this.props,
                id = _props.id,
                description = _props.description,
                defaultMessage = _props.defaultMessage,
                values = _props.values,
                _props$tagName = _props.tagName,
                Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
                children = _props.children;


            var tokenDelimiter = void 0;
            var tokenizedValues = void 0;
            var elements = void 0;

            var hasValues = values && Object.keys(values).length > 0;
            if (hasValues) {
                // Creates a token with a random UID that should not be guessable or
                // conflict with other parts of the `message` string.
                var uid = Math.floor(Math.random() * 0x10000000000).toString(16);

                var generateToken = function () {
                    var counter = 0;
                    return function () {
                        return 'ELEMENT-' + uid + '-' + (counter += 1);
                    };
                }();

                // Splitting with a delimiter to support IE8. When using a regex
                // with a capture group IE8 does not include the capture group in
                // the resulting array.
                tokenDelimiter = '@__' + uid + '__@';
                tokenizedValues = {};
                elements = {};

                // Iterates over the `props` to keep track of any React Element
                // values so they can be represented by the `token` as a placeholder
                // when the `message` is formatted. This allows the formatted
                // message to then be broken-up into parts with references to the
                // React Elements inserted back in.
                Object.keys(values).forEach(function (name) {
                    var value = values[name];

                    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react__["isValidElement"])(value)) {
                        var token = generateToken();
                        tokenizedValues[name] = tokenDelimiter + token + tokenDelimiter;
                        elements[token] = value;
                    } else {
                        tokenizedValues[name] = value;
                    }
                });
            }

            var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
            var formattedMessage = formatMessage(descriptor, tokenizedValues || values);

            var nodes = void 0;

            var hasElements = elements && Object.keys(elements).length > 0;
            if (hasElements) {
                // Split the message into parts so the React Element values captured
                // above can be inserted back into the rendered message. This
                // approach allows messages to render with React Elements while
                // keeping React's virtual diffing working properly.
                nodes = formattedMessage.split(tokenDelimiter).filter(function (part) {
                    return !!part;
                }).map(function (part) {
                    return elements[part] || part;
                });
            } else {
                nodes = [formattedMessage];
            }

            if (typeof children === 'function') {
                return children.apply(undefined, toConsumableArray(nodes));
            }

            // Needs to use `createElement()` instead of JSX, otherwise React will
            // warn about a missing `key` prop with rich-text message formatting.
            return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"].apply(undefined, [Component$$1, null].concat(toConsumableArray(nodes)));
        }
    }]);
    return FormattedMessage;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedMessage.displayName = 'FormattedMessage';
FormattedMessage.contextTypes = {
    intl: intlShape
};
FormattedMessage.defaultProps = {
    values: {}
};
 false ? FormattedMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
    values: PropTypes.object,
    tagName: PropTypes.string,
    children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedHTMLMessage = function (_Component) {
    inherits(FormattedHTMLMessage, _Component);

    function FormattedHTMLMessage(props, context) {
        classCallCheck(this, FormattedHTMLMessage);

        var _this = possibleConstructorReturn(this, (FormattedHTMLMessage.__proto__ || Object.getPrototypeOf(FormattedHTMLMessage)).call(this, props, context));

        invariantIntlContext(context);
        return _this;
    }

    createClass(FormattedHTMLMessage, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            var values = this.props.values;
            var nextValues = nextProps.values;


            if (!shallowEquals(nextValues, values)) {
                return true;
            }

            // Since `values` has already been checked, we know they're not
            // different, so the current `values` are carried over so the shallow
            // equals comparison on the other props isn't affected by the `values`.
            var nextPropsToCheck = _extends({}, nextProps, {
                values: values
            });

            for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                next[_key - 1] = arguments[_key];
            }

            return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
        }
    }, {
        key: 'render',
        value: function render() {
            var _context$intl = this.context.intl,
                formatHTMLMessage = _context$intl.formatHTMLMessage,
                Text = _context$intl.textComponent;
            var _props = this.props,
                id = _props.id,
                description = _props.description,
                defaultMessage = _props.defaultMessage,
                rawValues = _props.values,
                _props$tagName = _props.tagName,
                Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
                children = _props.children;


            var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
            var formattedHTMLMessage = formatHTMLMessage(descriptor, rawValues);

            if (typeof children === 'function') {
                return children(formattedHTMLMessage);
            }

            // Since the message presumably has HTML in it, we need to set
            // `innerHTML` in order for it to be rendered and not escaped by React.
            // To be safe, all string prop values were escaped when formatting the
            // message. It is assumed that the message is not UGC, and came from the
            // developer making it more like a template.
            //
            // Note: There's a perf impact of using this component since there's no
            // way for React to do its virtual DOM diffing.
            var html = { __html: formattedHTMLMessage };
            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component$$1, { dangerouslySetInnerHTML: html });
        }
    }]);
    return FormattedHTMLMessage;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedHTMLMessage.displayName = 'FormattedHTMLMessage';
FormattedHTMLMessage.contextTypes = {
    intl: intlShape
};
FormattedHTMLMessage.defaultProps = {
    values: {}
};
 false ? FormattedHTMLMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
    values: PropTypes.object,
    tagName: PropTypes.string,
    children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(defaultLocaleData);

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(__WEBPACK_IMPORTED_MODULE_0__locale_data_index_js___default.a);




/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = VODCSSModules;
/* harmony export (immutable) */ __webpack_exports__["c"] = VODBiEvents;
/* harmony export (immutable) */ __webpack_exports__["a"] = WixConnect;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_css_modules__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__get_component_display_name__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_redux_client_actions_bi__ = __webpack_require__(663);








function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}









// window.wix.reactIntlLocaleData is loaded using expose-loader. see webpack config
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_intl__["c" /* addLocaleData */])(window.wix.reactIntlLocaleData);

function VODCSSModules(styles) {
  if (!styles) {
    return _.identity;
  }

  return __WEBPACK_IMPORTED_MODULE_10_react_css_modules___default()(styles, {
    allowMultiple: true,
    errorWhenNotFound: false
  });
}

function VODBiEvents() {
  return function (WrappedComponent) {
    var _dec, _class, _desc, _value, _class2, _class3, _temp;

    var VODBiEventsWrapper = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_redux__["a" /* connect */])(null, { sendBiEvent: __WEBPACK_IMPORTED_MODULE_12_shared_redux_client_actions_bi__["a" /* sendBiEvent */], sendBiError: __WEBPACK_IMPORTED_MODULE_12_shared_redux_client_actions_bi__["b" /* sendBiError */] }), _dec(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
      __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(VODBiEventsWrapper, _React$Component);

      function VODBiEventsWrapper() {
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, VODBiEventsWrapper);

        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (VODBiEventsWrapper.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(VODBiEventsWrapper)).apply(this, arguments));
      }

      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(VODBiEventsWrapper, [{
        key: 'biEvent',
        value: function biEvent(name, params) {
          return this.props.sendBiEvent(name, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.context.defaultBiParams, params));
        }
      }, {
        key: 'biError',
        value: function biError(name, params) {
          return this.props.sendBiError(name, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.context.defaultBiParams, params));
        }
      }, {
        key: 'render',
        value: function render() {
          var props = _({}).assign(this.props, {
            biEvent: this.biEvent,
            biError: this.biError
          }).omit('sendBiEvent', 'sendBiError').value();

          return React.createElement(WrappedComponent, props);
        }
      }]);

      return VODBiEventsWrapper;
    }(React.Component), _class3.displayName = 'VODBiEventsWrapper(' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__get_component_display_name__["a" /* default */])(WrappedComponent) + ')', _class3.propTypes = {
      sendBiEvent: React.PropTypes.func,
      sendBiError: React.PropTypes.func
    }, _class3.contextTypes = {
      defaultBiParams: React.PropTypes.object
    }, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'biEvent', [__WEBPACK_IMPORTED_MODULE_9_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'biEvent'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'biError', [__WEBPACK_IMPORTED_MODULE_9_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'biError'), _class2.prototype)), _class2)) || _class);


    VODBiEventsWrapper.WixWrappedComponent = WrappedComponent;

    return VODBiEventsWrapper;
  };
}

/*
 * Injects these behaviours: CSSModules, biEvent|biError, Intl
 */

function WixConnect(styles) {
  return function (WrappedComponent) {
    var _dec2, _class4, _desc2, _value2, _class5, _class6, _temp2;

    WrappedComponent = VODCSSModules(styles)(WrappedComponent);

    var ConnectWixStuff = (_dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_redux__["a" /* connect */])(null, { sendBiEvent: __WEBPACK_IMPORTED_MODULE_12_shared_redux_client_actions_bi__["a" /* sendBiEvent */], sendBiError: __WEBPACK_IMPORTED_MODULE_12_shared_redux_client_actions_bi__["b" /* sendBiError */] }), _dec2(_class4 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_intl__["d" /* injectIntl */])(_class4 = (_class5 = (_temp2 = _class6 = function (_React$Component2) {
      __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(ConnectWixStuff, _React$Component2);

      function ConnectWixStuff() {
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ConnectWixStuff);

        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ConnectWixStuff.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(ConnectWixStuff)).apply(this, arguments));
      }

      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(ConnectWixStuff, [{
        key: 'biEvent',
        value: function biEvent(name, params) {
          return this.props.sendBiEvent(name, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.context.defaultBiParams, params));
        }
      }, {
        key: 'biError',
        value: function biError(name, params) {
          return this.props.sendBiError(name, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.context.defaultBiParams, params));
        }
      }, {
        key: 'render',
        value: function render() {
          var settings = this.context.settings;
          var _props = this.props,
              intl = _props.intl,
              propsSettings = _props.settings;


          var props = _({}).assign(this.props, {
            settings: propsSettings || settings,
            intl: intl,
            biEvent: this.biEvent,
            biError: this.biError
          }).omit('sendBiEvent', 'sendBiError').value();

          return React.createElement(WrappedComponent, props);
        }
      }]);

      return ConnectWixStuff;
    }(React.Component), _class6.displayName = 'ConnectWixStuff(' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__get_component_display_name__["a" /* default */])(WrappedComponent) + ')', _class6.propTypes = {
      settings: React.PropTypes.object,
      intl: __WEBPACK_IMPORTED_MODULE_8_react_intl__["e" /* intlShape */],
      sendBiEvent: React.PropTypes.func,
      sendBiError: React.PropTypes.func
    }, _class6.contextTypes = {
      settings: React.PropTypes.object,
      store: React.PropTypes.object,
      defaultBiParams: React.PropTypes.object
    }, _temp2), (_applyDecoratedDescriptor(_class5.prototype, 'biEvent', [__WEBPACK_IMPORTED_MODULE_9_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class5.prototype, 'biEvent'), _class5.prototype), _applyDecoratedDescriptor(_class5.prototype, 'biError', [__WEBPACK_IMPORTED_MODULE_9_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class5.prototype, 'biError'), _class5.prototype)), _class5)) || _class4) || _class4);


    ConnectWixStuff.WixWrappedComponent = WrappedComponent;

    return ConnectWixStuff;
  };
}

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(734), __esModule: true };

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = autobind;

var _utils = __webpack_require__(259);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var defineProperty = Object.defineProperty,
    getPrototypeOf = Object.getPrototypeOf;


function bind(fn, context) {
  if (fn.bind) {
    return fn.bind(context);
  } else {
    return function __autobind__() {
      return fn.apply(context, arguments);
    };
  }
}

var mapStore = void 0;

function getBoundSuper(obj, fn) {
  if (typeof WeakMap === 'undefined') {
    throw new Error('Using @autobind on ' + fn.name + '() requires WeakMap support due to its use of super.' + fn.name + '()\n      See https://github.com/jayphelps/core-decorators.js/issues/20');
  }

  if (!mapStore) {
    mapStore = new WeakMap();
  }

  if (mapStore.has(obj) === false) {
    mapStore.set(obj, new WeakMap());
  }

  var superStore = mapStore.get(obj);

  if (superStore.has(fn) === false) {
    superStore.set(fn, bind(fn, obj));
  }

  return superStore.get(fn);
}

function autobindClass(klass) {
  var descs = (0, _utils.getOwnPropertyDescriptors)(klass.prototype);
  var keys = (0, _utils.getOwnKeys)(descs);

  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    var desc = descs[key];

    if (typeof desc.value !== 'function' || key === 'constructor') {
      continue;
    }

    defineProperty(klass.prototype, key, autobindMethod(klass.prototype, key, desc));
  }
}

function autobindMethod(target, key, _ref) {
  var fn = _ref.value,
      configurable = _ref.configurable,
      enumerable = _ref.enumerable;

  if (typeof fn !== 'function') {
    throw new SyntaxError('@autobind can only be used on functions, not: ' + fn);
  }

  var constructor = target.constructor;


  return {
    configurable: configurable,
    enumerable: enumerable,

    get: function get() {
      // Class.prototype.key lookup
      // Someone accesses the property directly on the prototype on which it is
      // actually defined on, i.e. Class.prototype.hasOwnProperty(key)
      if (this === target) {
        return fn;
      }

      // Class.prototype.key lookup
      // Someone accesses the property directly on a prototype but it was found
      // up the chain, not defined directly on it
      // i.e. Class.prototype.hasOwnProperty(key) == false && key in Class.prototype
      if (this.constructor !== constructor && getPrototypeOf(this).constructor === constructor) {
        return fn;
      }

      // Autobound method calling super.sameMethod() which is also autobound and so on.
      if (this.constructor !== constructor && key in this.constructor.prototype) {
        return getBoundSuper(this, fn);
      }

      var boundFn = bind(fn, this);

      defineProperty(this, key, {
        configurable: true,
        writable: true,
        // NOT enumerable when it's a bound method
        enumerable: false,
        value: boundFn
      });

      return boundFn;
    },

    set: (0, _utils.createDefaultSetter)(key)
  };
}

function handle(args) {
  if (args.length === 1) {
    return autobindClass.apply(undefined, _toConsumableArray(args));
  } else {
    return autobindMethod.apply(undefined, _toConsumableArray(args));
  }
}

function autobind() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  if (args.length === 0) {
    return function () {
      return handle(arguments);
    };
  } else {
    return handle(args);
  }
}

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(439);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = React;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(737), __esModule: true };

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(1131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(1132);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),
/* 19 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(28);
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),
/* 21 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @class
 * @ignore
 */


Object.defineProperty(exports, '__esModule', {
  value: true
});

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _CoreEvents2 = __webpack_require__(1322);

var _CoreEvents3 = _interopRequireDefault(_CoreEvents2);

var Events = (function (_CoreEvents) {
  _inherits(Events, _CoreEvents);

  function Events() {
    _classCallCheck(this, Events);

    _get(Object.getPrototypeOf(Events.prototype), 'constructor', this).apply(this, arguments);
  }

  return Events;
})(_CoreEvents3['default']);

var events = new Events();
exports['default'] = events;
module.exports = exports['default'];
//# sourceMappingURL=Events.js.map


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.combineActions = exports.handleActions = exports.handleAction = exports.createActions = exports.createAction = undefined;

var _createAction = __webpack_require__(530);

var _createAction2 = _interopRequireDefault(_createAction);

var _handleAction = __webpack_require__(531);

var _handleAction2 = _interopRequireDefault(_handleAction);

var _handleActions = __webpack_require__(1160);

var _handleActions2 = _interopRequireDefault(_handleActions);

var _combineActions = __webpack_require__(529);

var _combineActions2 = _interopRequireDefault(_combineActions);

var _createActions = __webpack_require__(1159);

var _createActions2 = _interopRequireDefault(_createActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.createAction = _createAction2.default;
exports.createActions = _createActions2.default;
exports.handleAction = _handleAction2.default;
exports.handleActions = _handleActions2.default;
exports.combineActions = _combineActions2.default;

/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_constants_view_modes__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_constants_default_locale__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_constants_device_types__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__attempt__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__guid__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__settings__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_bi_bi__ = __webpack_require__(95);











var IMAGE_SOURCE_NAME = null;
var JPEG_PARAMS = {
  q: 85,
  usm: '0.66_1.00_0.01'
};

function forceSSL(func) {
  return function () {
    var url = func.apply(undefined, arguments);
    return url.replace(/^http:\/\//, 'https://');
  };
}

function isJPEG(extension) {
  return (/^jpe?g$/i.test(extension)
  );
}

var WixSDKOriginal = window.Wix;

var WixSDK = WixSDKOriginal ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, WixSDKOriginal, {

  addEventListener: _.get(WixSDKOriginal, 'addEventListener', _.noop),
  removeEventListener: WixSDKOriginal.removeEventListener || _.noop,

  currentMember: function currentMember() {
    if (WixSDKOriginal.Utils.getViewMode() === __WEBPACK_IMPORTED_MODULE_2_shared_constants_view_modes__["a" /* default */].SITE) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(WixSDKOriginal.currentMember);
    }

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(null);
  },
  getCtToken: function getCtToken() {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(WixSDKOriginal.getCtToken).then(function (ctToken) {
      if (!ctToken) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(null);
      }

      return ctToken;
    });
  },
  logOutCurrentMember: function logOutCurrentMember() {
    __WEBPACK_IMPORTED_MODULE_8_shared_bi_bi__["a" /* default */].logWidgetSystem('user.logOut.requested');
    WixSDKOriginal.logOutCurrentMember();
  },
  getBoundingRectAndOffsets: function getBoundingRectAndOffsets() {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(WixSDKOriginal.getBoundingRectAndOffsets);
  },
  getSiteUrl: function getSiteUrl() {
    var viewMode = WixSDKOriginal.Utils.getViewMode();

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
      if (viewMode === __WEBPACK_IMPORTED_MODULE_2_shared_constants_view_modes__["a" /* default */].STANDALONE || viewMode === __WEBPACK_IMPORTED_MODULE_2_shared_constants_view_modes__["a" /* default */].DASHBOARD) {
        return WixSDKOriginal.Dashboard.getSiteViewUrl(function (siteViewUrl) {
          return resolve(siteViewUrl.base);
        });
      }

      WixSDKOriginal.Settings.getSiteInfo(function (siteInfo) {
        return resolve(siteInfo.baseUrl);
      });
    });
  },


  Activities: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, WixSDKOriginal.Activities, {
    getUserSessionToken: function getUserSessionToken() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(WixSDKOriginal.Activities.getUserSessionToken);
    }
  }),

  Dashboard: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, WixSDKOriginal.Dashboard, {
    getEditorUrl: function getEditorUrl() {
      var getEditorUrl = _.get(WixSDKOriginal, 'Dashboard.getEditorUrl');
      if (getEditorUrl) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(getEditorUrl);
      }

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(null);
    }
  }),

  Events: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, WixSDKOriginal.Events),

  PubSub: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, WixSDKOriginal.PubSub, {
    subscribe: _.get(WixSDKOriginal, 'PubSub.subscribe', _.noop),
    unsubscribe: _.get(WixSDKOriginal, 'PubSub.unsubscribe', _.noop)
  }),

  Settings: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, WixSDKOriginal.Settings, {
    setExternalId: function setExternalId(id) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        return WixSDKOriginal.Settings.setExternalId(id, resolve, reject);
      });
    },
    getSiteInfo: function getSiteInfo() {
      var viewMode = WixSDKOriginal.Utils.getViewMode();

      if (viewMode === __WEBPACK_IMPORTED_MODULE_2_shared_constants_view_modes__["a" /* default */].STANDALONE || viewMode === __WEBPACK_IMPORTED_MODULE_2_shared_constants_view_modes__["a" /* default */].DASHBOARD) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve({
          url: window.location.href
        });
      }

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(WixSDKOriginal.Settings.getSiteInfo);
    },
    getDashboardAppUrl: function getDashboardAppUrl() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(WixSDKOriginal.Settings.getDashboardAppUrl);
    }
  }),

  Styles: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, WixSDKOriginal.Styles, {
    getStyleParams: function getStyleParams() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(WixSDKOriginal.Styles.getStyleParams);
    },
    setFontParam: function setFontParam(key, value) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(_.partial(WixSDKOriginal.Styles.setFontParam, key, { value: value }));
    },
    setStyleParams: function setStyleParams(params) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(_.partial(WixSDKOriginal.Styles.setStyleParams, params));
    }
  }),

  Utils: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, WixSDKOriginal.Utils, {

    getCompId: _.get(WixSDKOriginal, 'Utils.getCompId', _.noop),
    getOrigCompId: _.get(WixSDKOriginal, 'Utils.getOrigCompId', _.noop),
    getDeviceType: _.get(WixSDKOriginal, 'Utils.getDeviceType', _.constant(__WEBPACK_IMPORTED_MODULE_4_shared_constants_device_types__["a" /* default */].DESKTOP)),

    getLocale: function getLocale() {
      // I really don't know why do we need here try/catch, but I'll leave it as it was
      try {
        var originalGetLocale = _.get(WixSDKOriginal, 'Utils.getLocale', _.noop);
        var locale = originalGetLocale();

        if (!locale || locale.length > 2) {
          // prevent xss
          return __WEBPACK_IMPORTED_MODULE_3_shared_constants_default_locale__["a" /* default */];
        }

        return locale;
      } catch (error) {
        return __WEBPACK_IMPORTED_MODULE_3_shared_constants_default_locale__["a" /* default */];
      }
    },
    getInstance: function getInstance() {
      try {
        return location.search.match(/(?:\?|&)instance=([^&]+)/)[1];
      } catch (error) {
        return null;
      }
    },


    getInstanceId: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__attempt__["b" /* invokeSafely */])(global.WMP.wixUtils.getInstanceId, null),

    getInstanceValue: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__attempt__["b" /* invokeSafely */])(function (key) {
      // if biToken is missing for any reason, global.WMP.wixUtils.getBiToken will generate fake one
      if (key === 'biToken') {
        return global.WMP.wixUtils.getBiToken();
      }

      var result = WixSDKOriginal.Utils.getInstanceValue(key);
      if (key === 'siteOwnerId' && !result) {
        return WixSDKOriginal.Utils.getInstanceValue('uid');
      }
      return result;
    }),

    getMetaSiteIdFromBiToken: function getMetaSiteIdFromBiToken() {
      var biToken = void 0;
      var instanceId = void 0;
      try {
        biToken = WixSDK.Utils.getInstanceValue('biToken');
        instanceId = WixSDK.Utils.getInstanceId();
      } catch (error) {
        // do nothing
      }

      if (biToken && instanceId) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__guid__["a" /* xor */])(biToken, instanceId);
      }
    },
    getMetaSiteId: function getMetaSiteId() {
      var metaSiteId = WixSDK.Utils.getMetaSiteIdFromBiToken();
      if (metaSiteId) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(metaSiteId);
      }

      var viewMode = WixSDK.Utils.getViewMode();
      if (viewMode === __WEBPACK_IMPORTED_MODULE_2_shared_constants_view_modes__["a" /* default */].STANDALONE) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject('Unable to get metaSiteId in standalone view mode');
      }

      if (viewMode === __WEBPACK_IMPORTED_MODULE_2_shared_constants_view_modes__["a" /* default */].EDITOR) {
        return WixSDK.Settings.getDashboardAppUrl().then(function (url) {
          return url.match(/\/sites\/([^/]+)/)[1];
        });
      }

      return WixSDK.Dashboard.getEditorUrl().then(function (url) {
        return url.match(/metaSiteId=([^&]+)/)[1];
      });
    },
    getUid: function getUid() {
      try {
        return WixSDKOriginal.Utils.getUid();
      } catch (error) {}

      try {
        return document.cookie.match(/wixClient=([^;]+)/)[1].split('|')[6];
      } catch (error) {}

      return null;
    },


    getViewMode: _.get(WixSDKOriginal, 'Utils.getViewMode', _.noop),

    isEditor: function isEditor() {
      return WixSDK.Utils.getViewMode() === __WEBPACK_IMPORTED_MODULE_2_shared_constants_view_modes__["a" /* default */].EDITOR;
    },


    Media: {
      getImageUrl: function getImageUrl(relativeUrl) {
        return '' + __WEBPACK_IMPORTED_MODULE_7__settings__["a" /* default */].hosts.image + relativeUrl;
      },


      getResizedImageUrl: forceSSL(function (url, width) {
        var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : width;
        var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

        if (!url) {
          return '';
        }

        width = Math.round(width);
        height = Math.round(height);

        if (/vimeocdn/.test(url)) {
          return url.replace(/(_\d+(x\d+)?)?\.jpg/, '_' + width + 'x' + height + '.jpg');
        }

        if (/^(https?:)?\/\//.test(url)) {
          return url;
        }

        var fullFilename = url.split('/').pop();
        var imagePath = url.replace(fullFilename, '');

        var filenameSplitted = fullFilename.split('.');
        var filename = filenameSplitted.slice(0, -1).join('.');
        var ext = filenameSplitted[filenameSplitted.length - 1];
        var imageUrlEnd = IMAGE_SOURCE_NAME ? filename + '_' + IMAGE_SOURCE_NAME + '.' + ext : filename + '.' + ext;

        params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, params, {
          w: width,
          h: height
        });

        if (isJPEG(ext)) {
          params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, params, JPEG_PARAMS);
        }

        var imageParamsPath = _.map(params, function (value, key) {
          return key + '_' + value;
        }).join(',');

        var fullImagePath = imagePath + 'v1/fill/' + imageParamsPath + '/' + imageUrlEnd;
        return WixSDK.Utils.Media.getImageUrl(fullImagePath);
      })
    }
  })
}) : null;

/* harmony default export */ __webpack_exports__["a"] = (WixSDK);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(19)))

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULT_NAMES */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_actions__);



var DEFAULT_NAMES = ['START', 'SUCCESS', 'FAIL'];

function toPayload() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var response = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var payload = { params: params };
  if (response) {
    payload.response = response;
  }
  return payload;
}

function toMeta(params, response) {
  var meta = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  if (meta && _.isArray(meta.analytics)) {
    return meta;
  }
  if (meta && meta.analytics && !meta.analytics.payload) {
    var _meta$analytics = meta.analytics,
        type = _meta$analytics.type,
        payload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_meta$analytics, ['type']);

    meta.analytics = { type: type, payload: payload };
  }
  return meta;
}

/* harmony default export */ __webpack_exports__["a"] = (function (namespace) {
  var actionsNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_NAMES;

  var NAMES = _.reduce(actionsNames, function (res, name) {
    res[name] = namespace + '.' + name;
    return res;
  }, {});

  return _.reduce(actionsNames, function (res, name) {
    res[name] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["createAction"])(NAMES[name], toPayload, toMeta);
    return res;
  }, { NAMES: NAMES });
});

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _FactoryMaker = __webpack_require__(9);

var _FactoryMaker2 = _interopRequireDefault(_FactoryMaker);

var EVENT_PRIORITY_LOW = 0;
var EVENT_PRIORITY_HIGH = 5000;

function EventBus() {

    var handlers = {};

    function on(type, listener, scope) {
        var priority = arguments.length <= 3 || arguments[3] === undefined ? EVENT_PRIORITY_LOW : arguments[3];

        if (!type) {
            throw new Error('event type cannot be null or undefined');
        }
        if (!listener || typeof listener !== 'function') {
            throw new Error('listener must be a function: ' + listener);
        }

        if (getHandlerIdx(type, listener, scope) >= 0) return;

        handlers[type] = handlers[type] || [];

        var handler = {
            callback: listener,
            scope: scope,
            priority: priority
        };

        var inserted = handlers[type].some(function (item, idx) {
            if (item && priority > item.priority) {
                handlers[type].splice(idx, 0, handler);
                return true;
            }
        });

        if (!inserted) {
            handlers[type].push(handler);
        }
    }

    function off(type, listener, scope) {
        if (!type || !listener || !handlers[type]) return;
        var idx = getHandlerIdx(type, listener, scope);
        if (idx < 0) return;
        handlers[type][idx] = null;
    }

    function trigger(type, payload) {
        if (!type || !handlers[type]) return;

        payload = payload || {};

        if (payload.hasOwnProperty('type')) throw new Error('\'type\' is a reserved word for event dispatching');

        payload.type = type;

        handlers[type] = handlers[type].filter(function (item) {
            return item;
        });
        handlers[type].forEach(function (handler) {
            return handler.callback.call(handler.scope, payload);
        });
    }

    function getHandlerIdx(type, listener, scope) {

        var idx = -1;

        if (!handlers[type]) return idx;

        handlers[type].some(function (item, index) {
            if (item && item.callback === listener && (!scope || scope === item.scope)) {
                idx = index;
                return true;
            }
        });
        return idx;
    }

    function reset() {
        handlers = {};
    }

    var instance = {
        on: on,
        off: off,
        trigger: trigger,
        reset: reset
    };

    return instance;
}

EventBus.__dashjs_factory_name = 'EventBus';
var factory = _FactoryMaker2['default'].getSingletonFactory(EventBus);
factory.EVENT_PRIORITY_LOW = EVENT_PRIORITY_LOW;
factory.EVENT_PRIORITY_HIGH = EVENT_PRIORITY_HIGH;
exports['default'] = factory;
module.exports = exports['default'];
//# sourceMappingURL=EventBus.js.map


/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var store      = __webpack_require__(225)('wks')
  , uid        = __webpack_require__(127)
  , Symbol     = __webpack_require__(21).Symbol
  , USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function(name){
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _EventBus = __webpack_require__(27);

var _EventBus2 = _interopRequireDefault(_EventBus);

var _eventsEvents = __webpack_require__(22);

var _eventsEvents2 = _interopRequireDefault(_eventsEvents);

var _FactoryMaker = __webpack_require__(9);

var _FactoryMaker2 = _interopRequireDefault(_FactoryMaker);

/**
 * @module Debug
 */
function Debug() {

    var context = this.context;
    var eventBus = (0, _EventBus2['default'])(context).getInstance();

    var instance = undefined,
        logToBrowserConsole = undefined,
        showLogTimestamp = undefined,
        startTime = undefined;

    function setup() {
        logToBrowserConsole = true;
        showLogTimestamp = true;
        startTime = new Date().getTime();
    }

    /**
     * Prepends a timestamp in milliseconds to each log message.
     * @param {boolean} value Set to true if you want to see a timestamp in each log message.
     * @default false
     * @memberof module:Debug
     * @instance
     */
    function setLogTimestampVisible(value) {
        showLogTimestamp = value;
    }
    /**
     * Toggles logging to the browser's javascript console.  If you set to false you will still receive a log event with the same message.
     * @param {boolean} value Set to false if you want to turn off logging to the browser's console.
     * @default true
     * @memberof module:Debug
     * @instance
     */
    function setLogToBrowserConsole(value) {
        logToBrowserConsole = value;
    }
    /**
     * Use this method to get the state of logToBrowserConsole.
     * @returns {boolean} The current value of logToBrowserConsole
     * @memberof module:Debug
     * @instance
     */
    function getLogToBrowserConsole() {
        return logToBrowserConsole;
    }
    /**
     * This method will allow you send log messages to either the browser's console and/or dispatch an event to capture at the media player level.
     * @param {...*} arguments The message you want to log. The Arguments object is supported for this method so you can send in comma separated logging items.
     * @memberof module:Debug
     * @instance
     */
    function log() {

        var message = '';
        var logTime = null;

        if (showLogTimestamp) {
            logTime = new Date().getTime();
            message += '[' + (logTime - startTime) + ']';
        }

        if (message.length > 0) {
            message += ' ';
        }

        Array.apply(null, arguments).forEach(function (item) {
            message += item + ' ';
        });

        if (logToBrowserConsole) {
            console.log(message);
        }

        eventBus.trigger(_eventsEvents2['default'].LOG, { message: message });
    }

    instance = {
        log: log,
        setLogTimestampVisible: setLogTimestampVisible,
        setLogToBrowserConsole: setLogToBrowserConsole,
        getLogToBrowserConsole: getLogToBrowserConsole
    };

    setup();

    return instance;
}

Debug.__dashjs_factory_name = 'Debug';
exports['default'] = _FactoryMaker2['default'].getSingletonFactory(Debug);
module.exports = exports['default'];
//# sourceMappingURL=Debug.js.map


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function noop() {}

var fakeLogger = {
  trace: noop,
  debug: noop,
  log: noop,
  warn: noop,
  info: noop,
  error: noop
};

var exportedLogger = fakeLogger;

/*globals self: false */

//let lastCallTime;
// function formatMsgWithTimeInfo(type, msg) {
//   const now = Date.now();
//   const diff = lastCallTime ? '+' + (now - lastCallTime) : '0';
//   lastCallTime = now;
//   msg = (new Date(now)).toISOString() + ' | [' +  type + '] > ' + msg + ' ( ' + diff + ' ms )';
//   return msg;
// }

function formatMsg(type, msg) {
  msg = '[' + type + '] > ' + msg;
  return msg;
}

function consolePrintFn(type) {
  var func = self.console[type];
  if (func) {
    return function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (args[0]) {
        args[0] = formatMsg(type, args[0]);
      }
      func.apply(self.console, args);
    };
  }
  return noop;
}

function exportLoggerFunctions(debugConfig) {
  for (var _len2 = arguments.length, functions = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    functions[_key2 - 1] = arguments[_key2];
  }

  functions.forEach(function (type) {
    exportedLogger[type] = debugConfig[type] ? debugConfig[type].bind(debugConfig) : consolePrintFn(type);
  });
}

var enableLogs = exports.enableLogs = function enableLogs(debugConfig) {
  if (debugConfig === true || (typeof debugConfig === 'undefined' ? 'undefined' : _typeof(debugConfig)) === 'object') {
    exportLoggerFunctions(debugConfig,
    // Remove out from list here to hard-disable a log-level
    //'trace',
    'debug', 'log', 'info', 'warn', 'error');
    // Some browsers don't allow to use bind on console object anyway
    // fallback to default if needed
    try {
      exportedLogger.log();
    } catch (e) {
      exportedLogger = fakeLogger;
    }
  } else {
    exportedLogger = fakeLogger;
  }
};

var logger = exports.logger = exportedLogger;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(24)(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var anObject       = __webpack_require__(20)
  , IE8_DOM_DEFINE = __webpack_require__(461)
  , toPrimitive    = __webpack_require__(80)
  , dP             = Object.defineProperty;

exports.f = __webpack_require__(32) ? Object.defineProperty : function defineProperty(O, P, Attributes){
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if(IE8_DOM_DEFINE)try {
    return dP(O, P, Attributes);
  } catch(e){ /* empty */ }
  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
  if('value' in Attributes)O[P] = Attributes.value;
  return O;
};

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_transport__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_settings__ = __webpack_require__(110);




var vodAdapterSettings = {
  apiUrl: __WEBPACK_IMPORTED_MODULE_1_shared_settings__["a" /* default */].hosts.catalog,
  filesUrl: __WEBPACK_IMPORTED_MODULE_1_shared_settings__["a" /* default */].hosts.files,
  uploadLimits: {
    secureVideo: 16106127360
  }
};

var vodAdapter = void 0;
try {
  vodAdapter = new __WEBPACK_IMPORTED_MODULE_0_transport__["b" /* Adapter */](__WEBPACK_IMPORTED_MODULE_0_transport__["c" /* adapters */].VOD, vodAdapterSettings);
} catch (error) {}

/* harmony default export */ __webpack_exports__["a"] = (vodAdapter);

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GenericButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LinkButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return LinkPremiumButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PrimaryButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SecondaryButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DangerPrimaryButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DangerSecondaryButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return PremiumPrimaryButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return PremiumSecondaryButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return TransparentWhiteButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return WhiteBlueButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return TooltipPrimaryButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_components_with_tooltip_with_tooltip__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__button_styl__ = __webpack_require__(1170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__button_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__button_styl__);








var _dec, _class, _desc, _value, _class2, _class3, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}










var GenericButton = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_11__button_styl___default.a), _dec(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(GenericButton, _React$Component);

  function GenericButton() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, GenericButton);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (GenericButton.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(GenericButton)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(GenericButton, [{
    key: 'handleLinkClick',
    value: function handleLinkClick(event) {
      event.preventDefault();
      this.props.onClick(event);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          label = _props.label,
          children = _props.children,
          roundedRect = _props.roundedRect,
          getRef = _props.getRef,
          renderAsLink = _props.renderAsLink;


      var styleNames = __WEBPACK_IMPORTED_MODULE_8_classnames___default()('button', {
        'rounded-rect': roundedRect
      });

      var props = _({}).assign(this.props).assign({
        children: label || children,
        styleName: styleNames,
        ref: getRef
      }).omit(['styles', 'label', 'roundedRect', 'renderAsLink', 'getRef', 'intl', 'settings', 'biEvent', 'biError', 'dataHook']).value();

      if (!renderAsLink) {
        return React.createElement('button', props);
      }

      return React.createElement('a', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ href: ''
      }, props, {
        onClick: this.handleLinkClick }));
    }
  }]);

  return GenericButton;
}(React.Component), _class3.propTypes = {
  label: React.PropTypes.any,
  children: React.PropTypes.any,
  roundedRect: React.PropTypes.bool,
  renderAsLink: React.PropTypes.bool,
  onClick: React.PropTypes.func,
  getRef: React.PropTypes.func,
  dataHook: React.PropTypes.string
}, _class3.defaultProps = {
  roundedRect: false,
  renderAsLink: false,
  onClick: _.noop,
  getRef: _.noop
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'handleLinkClick', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handleLinkClick'), _class2.prototype)), _class2)) || _class);

function generateButtonVariant(styleName) {
  var _dec2, _class4;

  var ButtonVariant = (_dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_11__button_styl___default.a), _dec2(_class4 = function (_React$Component2) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(ButtonVariant, _React$Component2);

    function ButtonVariant() {
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ButtonVariant);

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ButtonVariant.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(ButtonVariant)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(ButtonVariant, [{
      key: 'render',
      value: function render() {
        var props = _.omit(this.props, 'styles');

        return React.createElement(GenericButton, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, props, {
          styleName: styleName }));
      }
    }]);

    return ButtonVariant;
  }(React.Component)) || _class4);


  return ButtonVariant;
}

var LinkButton = generateButtonVariant('link-button');
var LinkPremiumButton = generateButtonVariant('link-button link-premium-button');
var PrimaryButton = generateButtonVariant('primary-button');
var SecondaryButton = generateButtonVariant('secondary-button');
var DangerPrimaryButton = generateButtonVariant('danger-primary-button');
var DangerSecondaryButton = generateButtonVariant('danger-secondary-button');
var PremiumPrimaryButton = generateButtonVariant('premium-primary-button');
var PremiumSecondaryButton = generateButtonVariant('premium-secondary-button');
var TransparentWhiteButton = generateButtonVariant('transparent-white-button');
var WhiteBlueButton = generateButtonVariant('white-blue-button');

var TooltipPrimaryButton = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_shared_components_with_tooltip_with_tooltip__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_shared_components_with_tooltip_with_tooltip__["b" /* adaptShowStatePropsToClassName */])(PrimaryButton));

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1120)();
}


/***/ }),
/* 37 */
/***/ (function(module, exports) {

var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  // fired before MediaSource is attaching to media element - data: { media }
  MEDIA_ATTACHING: 'hlsMediaAttaching',
  // fired when MediaSource has been succesfully attached to media element - data: { }
  MEDIA_ATTACHED: 'hlsMediaAttached',
  // fired before detaching MediaSource from media element - data: { }
  MEDIA_DETACHING: 'hlsMediaDetaching',
  // fired when MediaSource has been detached from media element - data: { }
  MEDIA_DETACHED: 'hlsMediaDetached',
  // fired when we buffer is going to be reset - data: { }
  BUFFER_RESET: 'hlsBufferReset',
  // fired when we know about the codecs that we need buffers for to push into - data: {tracks : { container, codec, levelCodec, initSegment, metadata }}
  BUFFER_CODECS: 'hlsBufferCodecs',
  // fired when sourcebuffers have been created - data: { tracks : tracks }
  BUFFER_CREATED: 'hlsBufferCreated',
  // fired when we append a segment to the buffer - data: { segment: segment object }
  BUFFER_APPENDING: 'hlsBufferAppending',
  // fired when we are done with appending a media segment to the buffer - data : { parent : segment parent that triggered BUFFER_APPENDING, pending : nb of segments waiting for appending for this segment parent}
  BUFFER_APPENDED: 'hlsBufferAppended',
  // fired when the stream is finished and we want to notify the media buffer that there will be no more data - data: { }
  BUFFER_EOS: 'hlsBufferEos',
  // fired when the media buffer should be flushed - data { startOffset, endOffset }
  BUFFER_FLUSHING: 'hlsBufferFlushing',
  // fired when the media buffer has been flushed - data: { }
  BUFFER_FLUSHED: 'hlsBufferFlushed',
  // fired to signal that a manifest loading starts - data: { url : manifestURL}
  MANIFEST_LOADING: 'hlsManifestLoading',
  // fired after manifest has been loaded - data: { levels : [available quality levels], audioTracks : [ available audio tracks], url : manifestURL, stats : { trequest, tfirst, tload, mtime}}
  MANIFEST_LOADED: 'hlsManifestLoaded',
  // fired after manifest has been parsed - data: { levels : [available quality levels], firstLevel : index of first quality level appearing in Manifest}
  MANIFEST_PARSED: 'hlsManifestParsed',
  // fired when a level switch is requested - data: { level : id of new level } // deprecated in favor LEVEL_SWITCHING
  LEVEL_SWITCH: 'hlsLevelSwitch',
  // fired when a level switch is requested - data: { level : id of new level }
  LEVEL_SWITCHING: 'hlsLevelSwitching',
  // fired when a level switch is effective - data: { level : id of new level }
  LEVEL_SWITCHED: 'hlsLevelSwitched',
  // fired when a level playlist loading starts - data: { url : level URL, level : id of level being loaded}
  LEVEL_LOADING: 'hlsLevelLoading',
  // fired when a level playlist loading finishes - data: { details : levelDetails object, level : id of loaded level, stats : { trequest, tfirst, tload, mtime} }
  LEVEL_LOADED: 'hlsLevelLoaded',
  // fired when a level's details have been updated based on previous details, after it has been loaded - data: { details : levelDetails object, level : id of updated level }
  LEVEL_UPDATED: 'hlsLevelUpdated',
  // fired when a level's PTS information has been updated after parsing a fragment - data: { details : levelDetails object, level : id of updated level, drift: PTS drift observed when parsing last fragment }
  LEVEL_PTS_UPDATED: 'hlsLevelPtsUpdated',
  // fired to notify that audio track lists has been updated - data: { audioTracks : audioTracks }
  AUDIO_TRACKS_UPDATED: 'hlsAudioTracksUpdated',
  // fired when an audio track switch occurs - data: { id : audio track id } // deprecated in favor AUDIO_TRACK_SWITCHING
  AUDIO_TRACK_SWITCH: 'hlsAudioTrackSwitch',
  // fired when an audio track switching is requested - data: { id : audio track id }
  AUDIO_TRACK_SWITCHING: 'hlsAudioTrackSwitching',
  // fired when an audio track switch actually occurs - data: { id : audio track id }
  AUDIO_TRACK_SWITCHED: 'hlsAudioTrackSwitched',
  // fired when an audio track loading starts - data: { url : audio track URL, id : audio track id }
  AUDIO_TRACK_LOADING: 'hlsAudioTrackLoading',
  // fired when an audio track loading finishes - data: { details : levelDetails object, id : audio track id, stats : { trequest, tfirst, tload, mtime } }
  AUDIO_TRACK_LOADED: 'hlsAudioTrackLoaded',
  // fired to notify that subtitle track lists has been updated - data: { subtitleTracks : subtitleTracks }
  SUBTITLE_TRACKS_UPDATED: 'hlsSubtitleTracksUpdated',
  // fired when an subtitle track switch occurs - data: { id : subtitle track id }
  SUBTITLE_TRACK_SWITCH: 'hlsSubtitleTrackSwitch',
  // fired when a subtitle track loading starts - data: { url : subtitle track URL, id : subtitle track id }
  SUBTITLE_TRACK_LOADING: 'hlsSubtitleTrackLoading',
  // fired when a subtitle track loading finishes - data: { details : levelDetails object, id : subtitle track id, stats : { trequest, tfirst, tload, mtime } }
  SUBTITLE_TRACK_LOADED: 'hlsSubtitleTrackLoaded',
  // fired when a subtitle fragment has been processed - data: { success : boolean, frag : the processed frag }
  SUBTITLE_FRAG_PROCESSED: 'hlsSubtitleFragProcessed',
  // fired when the first timestamp is found - data: { id : demuxer id, initPTS: initPTS, frag : fragment object }
  INIT_PTS_FOUND: 'hlsInitPtsFound',
  // fired when a fragment loading starts - data: { frag : fragment object }
  FRAG_LOADING: 'hlsFragLoading',
  // fired when a fragment loading is progressing - data: { frag : fragment object, { trequest, tfirst, loaded } }
  FRAG_LOAD_PROGRESS: 'hlsFragLoadProgress',
  // Identifier for fragment load aborting for emergency switch down - data: { frag : fragment object }
  FRAG_LOAD_EMERGENCY_ABORTED: 'hlsFragLoadEmergencyAborted',
  // fired when a fragment loading is completed - data: { frag : fragment object, payload : fragment payload, stats : { trequest, tfirst, tload, length } }
  FRAG_LOADED: 'hlsFragLoaded',
  // fired when a fragment has finished decrypting - data: { id : demuxer id, frag: fragment object, stats : { tstart, tdecrypt } }
  FRAG_DECRYPTED: 'hlsFragDecrypted',
  // fired when Init Segment has been extracted from fragment - data: { id : demuxer id, frag: fragment object, moov : moov MP4 box, codecs : codecs found while parsing fragment }
  FRAG_PARSING_INIT_SEGMENT: 'hlsFragParsingInitSegment',
  // fired when parsing sei text is completed - data: { id : demuxer id, frag: fragment object, samples : [ sei samples pes ] }
  FRAG_PARSING_USERDATA: 'hlsFragParsingUserdata',
  // fired when parsing id3 is completed - data: { id : demuxer id, frag: fragment object, samples : [ id3 samples pes ] }
  FRAG_PARSING_METADATA: 'hlsFragParsingMetadata',
  // fired when data have been extracted from fragment - data: { id : demuxer id, frag: fragment object, data1 : moof MP4 box or TS fragments, data2 : mdat MP4 box or null}
  FRAG_PARSING_DATA: 'hlsFragParsingData',
  // fired when fragment parsing is completed - data: { id : demuxer id, frag: fragment object }
  FRAG_PARSED: 'hlsFragParsed',
  // fired when fragment remuxed MP4 boxes have all been appended into SourceBuffer - data: { id : demuxer id, frag : fragment object, stats : { trequest, tfirst, tload, tparsed, tbuffered, length, bwEstimate } }
  FRAG_BUFFERED: 'hlsFragBuffered',
  // fired when fragment matching with current media position is changing - data : { id : demuxer id, frag : fragment object }
  FRAG_CHANGED: 'hlsFragChanged',
  // Identifier for a FPS drop event - data: { curentDropped, currentDecoded, totalDroppedFrames }
  FPS_DROP: 'hlsFpsDrop',
  //triggered when FPS drop triggers auto level capping - data: { level, droppedlevel }
  FPS_DROP_LEVEL_CAPPING: 'hlsFpsDropLevelCapping',
  // Identifier for an error event - data: { type : error type, details : error details, fatal : if true, hls.js cannot/will not try to recover, if false, hls.js will try to recover,other error specific data }
  ERROR: 'hlsError',
  // fired when hls.js instance starts destroying. Different from MEDIA_DETACHED as one could want to detach and reattach a media to the instance of hls.js to handle mid-rolls for example - data: { }
  DESTROYING: 'hlsDestroying',
  // fired when a decrypt key loading starts - data: { frag : fragment object }
  KEY_LOADING: 'hlsKeyLoading',
  // fired when a decrypt key loading is completed - data: { frag : fragment object, payload : key payload, stats : { trequest, tfirst, tload, length } }
  KEY_LOADED: 'hlsKeyLoaded',
  // fired upon stream controller state transitions - data: { previousState, nextState }
  STREAM_STATE_TRANSITION: 'hlsStreamStateTransition'
};

/***/ }),
/* 40 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 41 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAllSettings;
/* harmony export (immutable) */ __webpack_exports__["w"] = getEditMode;
/* harmony export (immutable) */ __webpack_exports__["e"] = getRequestedWidgetSize;
/* harmony export (immutable) */ __webpack_exports__["k"] = getIsInitialWidgetSizeWasSet;
/* harmony export (immutable) */ __webpack_exports__["I"] = getNumberOfRows;
/* harmony export (immutable) */ __webpack_exports__["v"] = getVideosInRowCount;
/* harmony export (immutable) */ __webpack_exports__["H"] = getVideoInfoPosition;
/* harmony export (immutable) */ __webpack_exports__["M"] = getInfoActionVisibility;
/* unused harmony export getLayoutStyle */
/* harmony export (immutable) */ __webpack_exports__["f"] = getSiteUrl;
/* harmony export (immutable) */ __webpack_exports__["g"] = getCompId;
/* harmony export (immutable) */ __webpack_exports__["m"] = getInstance;
/* harmony export (immutable) */ __webpack_exports__["Q"] = getPlayType;
/* harmony export (immutable) */ __webpack_exports__["O"] = getCompactMainActionStyleType;
/* harmony export (immutable) */ __webpack_exports__["j"] = getChannelLayout;
/* harmony export (immutable) */ __webpack_exports__["C"] = getMainItemOverlayOpacity;
/* harmony export (immutable) */ __webpack_exports__["L"] = getVideoListVisibility;
/* harmony export (immutable) */ __webpack_exports__["J"] = getCompactShowVideoListType;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return isCompactLayout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return isStripLayout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return isClassicLayout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return canShowSearch; });
/* harmony export (immutable) */ __webpack_exports__["c"] = canShowMainItemTitle;
/* harmony export (immutable) */ __webpack_exports__["E"] = canShowActionBar;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return canShowChannelInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return canShowChannelShare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return canShowSignIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return canShowVideoList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return canShowMainItemPublisher; });
/* harmony export (immutable) */ __webpack_exports__["y"] = isPreviewHover;
/* harmony export (immutable) */ __webpack_exports__["z"] = isVideoListPreviewHover;
/* unused harmony export getVideoListPublisherVisibility */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return canShowVideoListItemPublisher; });
/* harmony export (immutable) */ __webpack_exports__["K"] = getChannelIdFromAppSettings;
/* harmony export (immutable) */ __webpack_exports__["F"] = canShowVideoListItemTitle;
/* harmony export (immutable) */ __webpack_exports__["h"] = canShowFullInfo;
/* harmony export (immutable) */ __webpack_exports__["i"] = canShareVideo;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return canShowChannelTags; });
/* harmony export (immutable) */ __webpack_exports__["P"] = getMainItemType;
/* unused harmony export isMainItemFeaturedVideo */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return areElementsRounded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return isCompactPlayInFrame; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return isCompactMainActionsOnlyIcons; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return isVideosListInfoAlwaysShown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return isVideosListInfoNeverShown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return isVideosListInfoShownOnHover; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_default_settings__ = __webpack_require__(64);



function getAllSettings(state) {
  return state.appSettings;
}

function getEditMode(state) {
  return _.get(state, 'appSettings.editMode');
}

function getRequestedWidgetSize(state) {
  return _.get(state, 'appSettings.requestedWidgetSize', {});
}

function getIsInitialWidgetSizeWasSet(state) {
  return Boolean(getRequestedWidgetSize(state).width);
}

function getNumberOfRows(state) {
  return _.get(state, 'appSettings.numbers.numberOfRows', __WEBPACK_IMPORTED_MODULE_1_default_settings__["c" /* default */].numbers.numberOfRows);
}

function getVideosInRowCount(state) {
  return _.get(state, 'appSettings.numbers.videosInRow', __WEBPACK_IMPORTED_MODULE_1_default_settings__["c" /* default */].numbers.videosInRow);
}

function getVideoInfoPosition(state) {
  return _.get(state, 'appSettings.numbers.videoInfoPosition', __WEBPACK_IMPORTED_MODULE_1_default_settings__["c" /* default */].numbers.videoInfoPosition);
}

function getInfoActionVisibility(state) {
  return _.get(state, 'appSettings.numbers.showInfoAction', __WEBPACK_IMPORTED_MODULE_1_default_settings__["c" /* default */].numbers.showInfoAction);
}

function getLayoutStyle(state) {
  return _.get(state, 'appSettings.numbers.layoutStyle', __WEBPACK_IMPORTED_MODULE_1_default_settings__["c" /* default */].numbers.layoutStyle);
}

function getSiteUrl(state) {
  return _.get(state, 'appSettings.siteUrl');
}

function getCompId(state) {
  return _.get(state, 'appSettings.compId');
}

function getInstance(state) {
  return _.get(state, 'appSettings.instance');
}

function getPlayType(state) {
  return _.get(state, 'appSettings.numbers.playType', __WEBPACK_IMPORTED_MODULE_1_default_settings__["c" /* default */].numbers.playType);
}

function getCompactMainActionStyleType(state) {
  return _.get(state, 'appSettings.numbers.mainActionStyleType', __WEBPACK_IMPORTED_MODULE_1_default_settings__["c" /* default */].numbers.mainActionStyleType);
}

function getChannelLayout(state) {
  return _.get(state, 'appSettings.numbers.channelLayout', __WEBPACK_IMPORTED_MODULE_1_default_settings__["c" /* default */].numbers.channelLayout);
}

function getMainItemOverlayOpacity(state) {
  return _.get(state, 'appSettings.numbers.mainItemOverlayOpacity', __WEBPACK_IMPORTED_MODULE_1_default_settings__["c" /* default */].numbers.mainItemOverlayOpacity);
}

function getVideoListVisibility(state) {
  return _.get(state, 'appSettings.numbers.videoListVisibility', __WEBPACK_IMPORTED_MODULE_1_default_settings__["c" /* default */].numbers.videoListVisibility);
}

function getCompactShowVideoListType(state) {
  return _.get(state, 'appSettings.numbers.compactShowVideoListType', __WEBPACK_IMPORTED_MODULE_1_default_settings__["c" /* default */].numbers.compactShowVideoListType);
}

function getShowSearch(state) {
  return _.get(state, 'appSettings.booleans.showSearch', __WEBPACK_IMPORTED_MODULE_1_default_settings__["c" /* default */].booleans.showSearch);
}

var isCompactLayout = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getChannelLayout, function (channelLayout) {
  return channelLayout === __WEBPACK_IMPORTED_MODULE_1_default_settings__["d" /* channelLayoutValues */].COMPACT;
});

var isStripLayout = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getChannelLayout, function (channelLayout) {
  return channelLayout === __WEBPACK_IMPORTED_MODULE_1_default_settings__["d" /* channelLayoutValues */].STRIP;
});

var isClassicLayout = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getChannelLayout, function (channelLayout) {
  return channelLayout === __WEBPACK_IMPORTED_MODULE_1_default_settings__["d" /* channelLayoutValues */].CLASSIC;
});

var canShowSearch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getShowSearch, isCompactLayout, function (isSearchVisible, isCompact) {
  return isSearchVisible && !isCompact;
});

function canShowMainItemTitle(state) {
  return _.get(state, 'appSettings.booleans.showTitleForMainItem', __WEBPACK_IMPORTED_MODULE_1_default_settings__["c" /* default */].booleans.showTitleForMainItem);
}

function canShowActionBar(state) {
  return _.get(state, 'appSettings.booleans.showActionBar', __WEBPACK_IMPORTED_MODULE_1_default_settings__["c" /* default */].booleans.showActionBar);
}

function getCanShowChannelInfo(state) {
  return _.get(state, 'appSettings.booleans.showChannelInfo', __WEBPACK_IMPORTED_MODULE_1_default_settings__["c" /* default */].booleans.showChannelInfo);
}

var canShowChannelInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(isCompactLayout, canShowActionBar, getCanShowChannelInfo, function (isCompact, isActionBarVisible, isChannelInfoVisible) {
  if (isCompact) {
    return isActionBarVisible && isChannelInfoVisible;
  }
  return isChannelInfoVisible;
});

function getCanShowChannelShare(state) {
  return _.get(state, 'appSettings.booleans.showChannelShare', __WEBPACK_IMPORTED_MODULE_1_default_settings__["c" /* default */].booleans.showChannelShare);
}

var canShowChannelShare = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(isCompactLayout, canShowActionBar, getCanShowChannelShare, function (isCompact, isActionBarVisible, isChannelShareVisible) {
  if (isCompact) {
    return isActionBarVisible && isChannelShareVisible;
  }
  return isChannelShareVisible;
});

function getCanShowSignIn(state) {
  return _.get(state, 'appSettings.booleans.showSignIn', __WEBPACK_IMPORTED_MODULE_1_default_settings__["c" /* default */].booleans.showSignIn);
}

var canShowSignIn = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(isCompactLayout, canShowActionBar, getCanShowSignIn, function (isCompact, isActionBarVisible, isSignInVisible) {
  if (isCompact) {
    return isActionBarVisible && isSignInVisible;
  }
  return isSignInVisible;
});

var canShowVideoList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getCompactShowVideoListType, function (compactShowVideoListType) {
  return compactShowVideoListType !== __WEBPACK_IMPORTED_MODULE_1_default_settings__["e" /* COMPACT_SHOW_VIDEO_LIST_VALUES */].NEVER_SHOW;
});

function getMainItemPublisherVisibility(state) {
  return _.get(state, 'appSettings.booleans.showPublisherForMainItem', __WEBPACK_IMPORTED_MODULE_1_default_settings__["c" /* default */].booleans.showPublisherForMainItem);
}

var canShowMainItemPublisher = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getMainItemPublisherVisibility, isCompactLayout, function (isPublisherVisible, isCompact) {
  return isPublisherVisible && !isCompact;
});

function isPreviewHover(state) {
  return _.get(state, 'appSettings.booleans.previewHover', false);
}

function isVideoListPreviewHover(state) {
  return _.get(state, 'appSettings.booleans.videoListPreviewHover', false);
}

function getVideoListPublisherVisibility(state) {
  return _.get(state, 'appSettings.booleans.showVideoPublisherInList', __WEBPACK_IMPORTED_MODULE_1_default_settings__["c" /* default */].booleans.showVideoPublisherInList);
}

var canShowVideoListItemPublisher = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getVideoListPublisherVisibility, isCompactLayout, function (isPublisherVisible, isCompact) {
  return isPublisherVisible && !isCompact;
});

function getChannelIdFromAppSettings(state) {
  return _.get(state, 'appSettings.fonts.channelId');
}

function canShowVideoListItemTitle(state) {
  return _.get(state, 'appSettings.booleans.showVideoTitleInList', __WEBPACK_IMPORTED_MODULE_1_default_settings__["c" /* default */].booleans.showVideoTitleInList);
}

function canShowFullInfo(state) {
  return _.get(state, 'appSettings.booleans.showFullInfo', __WEBPACK_IMPORTED_MODULE_1_default_settings__["c" /* default */].booleans.showFullInfo);
}

function canShareVideo(state) {
  return _.get(state, 'appSettings.booleans.enableVideosSharing', __WEBPACK_IMPORTED_MODULE_1_default_settings__["c" /* default */].booleans.enableVideosSharing);
}

var canShowChannelTags = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([canShowSearch, function (state) {
  return _.get(state, 'appSettings.booleans.showChannelTags', __WEBPACK_IMPORTED_MODULE_1_default_settings__["c" /* default */].booleans.showChannelTags);
}], function (canShowSearch, canShowTags) {
  return canShowSearch && canShowTags;
});

function getMainItemType(state) {
  return _.get(state, 'appSettings.numbers.mainItemType', __WEBPACK_IMPORTED_MODULE_1_default_settings__["c" /* default */].numbers.mainItemType);
}

var isMainItemFeaturedVideo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getMainItemType], function (mainItemType) {
  return mainItemType === __WEBPACK_IMPORTED_MODULE_1_default_settings__["a" /* mainItemTypeValues */].FEATURED_VIDEO;
});

var areElementsRounded = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getLayoutStyle], function (layoutStyle) {
  return layoutStyle === __WEBPACK_IMPORTED_MODULE_1_default_settings__["f" /* layoutStyleValues */].ROUND;
});

var isCompactPlayInFrame = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getPlayType], function (playType) {
  return playType === __WEBPACK_IMPORTED_MODULE_1_default_settings__["g" /* COMPACT_PLAY_TYPE_VALUES */].IN_FRAME;
});

var isCompactMainActionsOnlyIcons = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getCompactMainActionStyleType], function (styleType) {
  return styleType === __WEBPACK_IMPORTED_MODULE_1_default_settings__["h" /* MAIN_ACTION_STYLE_TYPES */].ICON;
});

var isVideosListInfoAlwaysShown = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getInfoActionVisibility], function (visibilityType) {
  return visibilityType === __WEBPACK_IMPORTED_MODULE_1_default_settings__["i" /* showInfoValues */].ALWAYS;
});

var isVideosListInfoNeverShown = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getInfoActionVisibility], function (visibilityType) {
  return visibilityType === __WEBPACK_IMPORTED_MODULE_1_default_settings__["i" /* showInfoValues */].NEVER;
});

var isVideosListInfoShownOnHover = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getInfoActionVisibility], function (visibilityType) {
  return visibilityType === __WEBPACK_IMPORTED_MODULE_1_default_settings__["i" /* showInfoValues */].ON_MOUSE_OVER;
});

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(103)
  , min       = Math.min;
module.exports = function(it){
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["encode"] = encode;
/* harmony export (immutable) */ __webpack_exports__["normalizeUrl"] = normalizeUrl;
/* harmony export (immutable) */ __webpack_exports__["buildUrl"] = buildUrl;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "get", function() { return get; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "post", function() { return post; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "put", function() { return put; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "del", function() { return del; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cache__ = __webpack_require__(709);




var defaultOptions = {
  withCredentials: true,
  cache: true,
  headers: {}
};

function encode(value) {
  return encodeURIComponent(value).replace(/%40/gi, '@').replace(/%3A/gi, ':').replace(/%24/gi, '$').replace(/%2C/gi, ',').replace(/%20/gi, '+');
}

function normalizeUrl(url) {
  return url.replace(/([a-z\-_0-9]+)\/\//gi, '$1/');
}

function buildUrl(url, params) {
  if (!params) {
    return url;
  }

  var parts = _(params).map(function (value, key) {
    if (_.isNil(value)) {
      return '';
    }

    if (_.isDate(value) && !isNaN(value.valueOf())) {
      value = value.toISOString();
    } else if (_.isObject(value)) {
      value = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(value);
    }

    return encode(key) + '=' + encode(value);
  }).compact().value();

  if (parts.length !== 0) {
    url += (_.includes(url, '?') ? '&' : '?') + parts.join('&');
  }

  return url;
}

function addCaching(sendRequest) {
  return function (_ref) {
    var method = _ref.method,
        url = _ref.url;

    var cachedPromise = __WEBPACK_IMPORTED_MODULE_2__cache__["a" /* get */](url);
    if (method === 'GET' && cachedPromise) {
      return cachedPromise;
    }

    var promise = sendRequest.apply(undefined, arguments);

    __WEBPACK_IMPORTED_MODULE_2__cache__["b" /* setExpirable */](url, promise);

    return promise;
  };
}

var sendRequest = addCaching(function (_ref2) {
  var method = _ref2.method,
      url = _ref2.url,
      data = _ref2.data,
      options = _ref2.options;


  options = _.merge({}, defaultOptions, options);

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var request = new XMLHttpRequest();

    request.addEventListener('load', function () {
      if (/^2/.test(request.status)) {
        handlePromise(resolve)();
      } else {
        handlePromise(reject)();
      }
    });

    request.addEventListener('error', handlePromise(reject));
    request.addEventListener('abort', handlePromise(reject));

    var _options = options,
        cache = _options.cache,
        responseType = _options.responseType,
        withCredentials = _options.withCredentials,
        headers = _options.headers;


    if (cache === false) {
      var cacheKiller = '_=' + Date.now();
      url += (_.includes(url, '?') ? '&' : '?') + cacheKiller;
    }

    request.open(method, url);

    if (responseType) {
      request.responseType = responseType;
    }
    request.withCredentials = withCredentials;

    _(headers).keys().forEach(function (name) {
      request.setRequestHeader(name, headers[name]);
    });

    request.send(data);

    function handlePromise(resolveReject) {
      return function () {
        var status = request.status,
            responseText = request.responseText;


        var data = responseText;
        try {
          data = JSON.parse(responseText);
        } catch (error) {}

        resolveReject({
          status: status,
          data: data,
          url: url
        });
      };
    }
  });
});

function createRequestTriggerer() {
  var method = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'GET';

  method = method.toUpperCase();

  return function (url) {
    var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref3$params = _ref3.params,
        params = _ref3$params === undefined ? null : _ref3$params,
        _ref3$data = _ref3.data,
        data = _ref3$data === undefined ? null : _ref3$data,
        _ref3$options = _ref3.options,
        options = _ref3$options === undefined ? defaultOptions : _ref3$options;

    if (data && _.isObject(data) && data instanceof FormData === false) {
      data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data);
    }

    url = buildUrl(url, params);
    url = normalizeUrl(url);

    return sendRequest({ method: method, url: url, data: data, options: options });
  };
}

var get = createRequestTriggerer('GET');
var post = createRequestTriggerer('POST');
var put = createRequestTriggerer('PUT');
var del = createRequestTriggerer('DELETE');

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(75);
module.exports = function(it){
  return Object(defined(it));
};

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Icon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RoundedIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TooltipIcon; });
/* unused harmony export TooltipRoundedIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_components_with_tooltip_with_tooltip__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__icon_styl__ = __webpack_require__(1172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__icon_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__icon_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_fontello_css_fontello_codes_css__ = __webpack_require__(1176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_fontello_css_fontello_codes_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_shared_fontello_css_fontello_codes_css__);







var _dec, _class, _class2, _temp, _dec2, _class3;








var Icon = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_8__icon_styl___default.a, __WEBPACK_IMPORTED_MODULE_9_shared_fontello_css_fontello_codes_css___default.a)), _dec(_class = (_temp = _class2 = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Icon, _React$PureComponent);

  function Icon() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Icon);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Icon.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Icon)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Icon, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          name = _props.name,
          getRef = _props.getRef;

      var props = _.omit(this.props, ['styles', 'styleName', 'intl', 'settings', 'getRef', 'biEvent', 'biError', 'closePortal', 'children']);

      return React.createElement('span', __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({ ref: getRef,
        styleName: 'icon icon--' + name
      }, props, {
        style: this.iconStyle }));
    }
  }, {
    key: 'iconStyle',
    get: function get() {
      var size = this.props.size;

      if (!size) {
        return null;
      }

      return {
        fontSize: size
      };
    }
  }]);

  return Icon;
}(React.PureComponent), _class2.propTypes = {
  size: React.PropTypes.number,
  name: React.PropTypes.string,
  className: React.PropTypes.string,
  getRef: React.PropTypes.func
}, _class2.defaultProps = {
  getRef: _.noop
}, _temp)) || _class);


var RoundedIcon = (_dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_8__icon_styl___default.a), _dec2(_class3 = function (_React$PureComponent2) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(RoundedIcon, _React$PureComponent2);

  function RoundedIcon() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, RoundedIcon);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (RoundedIcon.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(RoundedIcon)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(RoundedIcon, [{
    key: 'render',
    value: function render() {
      var props = _.omit(this.props, 'styles');

      return React.createElement(Icon, __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, props, {
        styleName: 'rounded-icon' }));
    }
  }]);

  return RoundedIcon;
}(React.PureComponent)) || _class3);

var TooltipIcon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_shared_components_with_tooltip_with_tooltip__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_shared_components_with_tooltip_with_tooltip__["b" /* adaptShowStatePropsToClassName */])(Icon));
var TooltipRoundedIcon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_shared_components_with_tooltip_with_tooltip__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_shared_components_with_tooltip_with_tooltip__["b" /* adaptShowStatePropsToClassName */])(RoundedIcon));

/***/ }),
/* 47 */,
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var store      = __webpack_require__(286)('wks')
  , uid        = __webpack_require__(215)
  , Symbol     = __webpack_require__(55).Symbol
  , USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function(name){
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = getResult;
/* harmony export (immutable) */ __webpack_exports__["d"] = normalizeVideo;
/* harmony export (immutable) */ __webpack_exports__["c"] = normalizeArrayOfVideos;
/* harmony export (immutable) */ __webpack_exports__["b"] = normalizeArrayOfPaymentInfoVideos;
/* harmony export (immutable) */ __webpack_exports__["e"] = normalizeChannel;
/* harmony export (immutable) */ __webpack_exports__["a"] = normalizePaymentInfoChannel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_normalizr__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_normalizr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_normalizr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_schemas__ = __webpack_require__(150);



function getResult(state, _ref) {
  var payload = _ref.payload;

  return _.get(payload, 'response.data.result');
}

function normalizeVideo(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_normalizr__["normalize"])(data, __WEBPACK_IMPORTED_MODULE_1_shared_schemas__["a" /* video */]);
}

function normalizeArrayOfVideos(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_normalizr__["normalize"])(data, __WEBPACK_IMPORTED_MODULE_1_shared_schemas__["b" /* arrayOfVideos */]);
}

function normalizeArrayOfPaymentInfoVideos(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_normalizr__["normalize"])(data, __WEBPACK_IMPORTED_MODULE_1_shared_schemas__["c" /* arrayOfPaymentInfoVideos */]);
}

function normalizeChannel(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_normalizr__["normalize"])(data, __WEBPACK_IMPORTED_MODULE_1_shared_schemas__["d" /* channel */]);
}

function normalizePaymentInfoChannel(data) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_normalizr__["normalize"])(data, __WEBPACK_IMPORTED_MODULE_1_shared_schemas__["e" /* paymentInfoChannel */]);
}

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = WixConnect;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_css_modules__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_css_modules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_css_modules__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_utils_get_component_display_name__ = __webpack_require__(237);










function WixConnect(styles) {
  return function (WrappedComponent) {
    var _class, _class2, _temp;

    if (styles) {
      WrappedComponent = __WEBPACK_IMPORTED_MODULE_5_react_css_modules___default()(styles, {
        allowMultiple: true,
        errorWhenNotFound: false
      })(WrappedComponent);
    }

    var ConnectWixStuff = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_intl__["d" /* injectIntl */])(_class = (_temp = _class2 = function (_React$Component) {
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ConnectWixStuff, _React$Component);

      function ConnectWixStuff() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ConnectWixStuff);

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ConnectWixStuff.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ConnectWixStuff)).apply(this, arguments));
      }

      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ConnectWixStuff, [{
        key: 'render',
        value: function render() {
          var appSettings = this.context.appSettings;
          var _props = this.props,
              intl = _props.intl,
              propsSettings = _props.appSettings;


          var props = _.assign({}, this.props, {
            appSettings: propsSettings || appSettings,
            intl: intl
          });

          return React.createElement(WrappedComponent, props);
        }
      }]);

      return ConnectWixStuff;
    }(React.Component), _class2.displayName = 'ConnectWixStuff(' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_shared_utils_get_component_display_name__["a" /* default */])(WrappedComponent) + ')', _class2.propTypes = {
      appSettings: React.PropTypes.object,
      intl: __WEBPACK_IMPORTED_MODULE_6_react_intl__["e" /* intlShape */]
    }, _class2.contextTypes = {
      appSettings: React.PropTypes.object
    }, _temp)) || _class;

    return ConnectWixStuff;
  };
}

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["transformObjectKeys"] = transformObjectKeys;
/* harmony export (immutable) */ __webpack_exports__["keysToCamelCase"] = keysToCamelCase;
/* harmony export (immutable) */ __webpack_exports__["keysToSnakeCase"] = keysToSnakeCase;
/* harmony export (immutable) */ __webpack_exports__["removeUndefinedValues"] = removeUndefinedValues;
function transformObjectKeys(obj) {
  var trasformer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _.identity;


  if (_.isArray(obj)) {
    return _.map(obj, function (val) {
      return transformObjectKeys(val, trasformer);
    });
  }

  if (_.isPlainObject(obj)) {
    return _.reduce(obj, function (acc, value, key) {
      acc[trasformer(key)] = transformObjectKeys(value, trasformer);
      return acc;
    }, {});
  }

  return obj;
}

function keysToCamelCase(obj) {
  return transformObjectKeys(obj, _.camelCase);
}

function keysToSnakeCase(obj) {
  return transformObjectKeys(obj, _.snakeCase);
}

function removeUndefinedValues(obj) {
  return _.omitBy(obj, _.isUndefined);
}

/***/ }),
/* 52 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(438);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = isFetching;
/* harmony export (immutable) */ __webpack_exports__["g"] = getVideoIds;
/* harmony export (immutable) */ __webpack_exports__["b"] = getVideoById;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getVideoWithDealInfoFromSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getVideoWithChannelDataById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getVideosGroupedByIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getVideosByIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getVideosByIdsWithoutCurrent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getVideosGroupedByIdsProps; });
/* unused harmony export areAllVideosUploaded */
/* unused harmony export getVideosFromComputer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return hasVideosFromComputer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_denormalizr__ = __webpack_require__(969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_denormalizr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_denormalizr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_schemas__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_utils_video_helpers_statuses__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_ui_selectors_video_video_origin__ = __webpack_require__(112);








function withDealInfoFromSettings(state, video) {
  if (!video) {
    return video;
  }

  // TODO: move to entities reducer
  video.dealInfo = _.isEmpty(video.dealInfo) ? _.get(state, 'vodSettings.dealInfo') : video.dealInfo;
  video.memberOnly = _.isUndefined(video.memberOnly) ? _.get(state, 'vodSettings.memberOnly') : video.memberOnly;
  return video;
}

function getStateVideosGroupedByIds(state) {
  return state.entities.videos;
}

function isFetching(state) {
  return state.videos.activeRequests !== 0;
}

function getVideoIds(state) {
  return state.videos.ids;
}

function getVideoById(state, videoId) {
  return state.entities.videos[videoId];
}

var getVideoWithDealInfoFromSettings = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([function (state) {
  return state;
}, getVideoById], function (state, videoData) {
  return withDealInfoFromSettings(state, videoData);
});

/**
 * @param state
 * @param videoId {String}
 * @returns {Object} video
 */
var getVideoWithChannelDataById = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([function (state) {
  return state;
}, getVideoById], function (state, videoData) {
  return (
    // TODO remove denormalize. Used to add channel data to usedInLists
    withDealInfoFromSettings(state, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_denormalizr__["denormalize"])(videoData, state.entities, __WEBPACK_IMPORTED_MODULE_3_shared_schemas__["a" /* video */]))
  );
});

/**
 * @param state
 * @returns {Object} {id: video}
 */
var getVideosGroupedByIds = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([function (state) {
  return state;
}, getStateVideosGroupedByIds], function (state, videosByIds) {
  return _.mapValues(videosByIds, _.partial(withDealInfoFromSettings, state));
});

/**
 * @param state
 * @param ids {String[]}
 * @returns {Object[]} videos list
 */
var getVideosByIds = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([getVideosGroupedByIds, function (state, ids) {
  return ids;
}], _.pick);

/**
 * @param state
 * @param ids {String[]}
 * @param currentVideoId {String}
 * @returns {Object[]} videos list
 */
var getVideosByIdsWithoutCurrent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([getVideosByIds, function (state, ids, currentVideoId) {
  return currentVideoId;
}], _.omit);

/**
 * @param state
 * @param props {String[]}
 * @returns {Object} {id: videoProps}
 */
var getVideosGroupedByIdsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([getVideosGroupedByIds, function (state, props) {
  return props;
}], function (videosByIds) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return _.mapValues(videosByIds, function (video) {
    return _.pick(video, ['id'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(props)));
  });
});

/**
 * @param state
 * @returns {Boolean}
 */
var areAllVideosUploaded = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([getStateVideosGroupedByIds, getVideoIds], function (videoByIds, ids) {
  return !_.isEmpty(videoByIds) && _.every(ids, function (id) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_utils_video_helpers_statuses__["a" /* isUploaded */])(videoByIds[id]);
  });
});

/**
 * @param state
 * @returns {Object[]} videos list
 */
var getVideosFromComputer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([getVideosGroupedByIds], function (videoByIds) {
  return _.filter(videoByIds, function (_ref) {
    var videoSource = _ref.videoSource;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_shared_ui_selectors_video_video_origin__["a" /* isVideoFromComputer */])(videoSource);
  });
});

/**
 * @param state
 * @returns {Boolean}
 */
var hasVideosFromComputer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([getVideosFromComputer], function (uploadedVideosDataList) {
  return Boolean(uploadedVideosDataList.length);
});

/***/ }),
/* 55 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 56 */
/***/ (function(module, exports) {

module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var dP         = __webpack_require__(33)
  , createDesc = __webpack_require__(102);
module.exports = __webpack_require__(32) ? function(object, key, value){
  return dP.f(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(21)
  , hide      = __webpack_require__(57)
  , has       = __webpack_require__(52)
  , SRC       = __webpack_require__(127)('src')
  , TO_STRING = 'toString'
  , $toString = Function[TO_STRING]
  , TPL       = ('' + $toString).split(TO_STRING);

__webpack_require__(87).inspectSource = function(it){
  return $toString.call(it);
};

(module.exports = function(O, key, val, safe){
  var isFunction = typeof val == 'function';
  if(isFunction)has(val, 'name') || hide(val, 'name', key);
  if(O[key] === val)return;
  if(isFunction)has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if(O === global){
    O[key] = val;
  } else {
    if(!safe){
      delete O[key];
      hide(O, key, val);
    } else {
      if(O[key])O[key] = val;
      else hide(O, key, val);
    }
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString(){
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(6)
  , fails   = __webpack_require__(24)
  , defined = __webpack_require__(75)
  , quot    = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function(string, tag, attribute, value) {
  var S  = String(defined(string))
    , p1 = '<' + tag;
  if(attribute !== '')p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function(NAME, exec){
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function(){
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(175)
  , defined = __webpack_require__(75);
module.exports = function(it){
  return IObject(defined(it));
};

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sides; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return trianglePositions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return popoutPositions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return openOn; });
var sides = {
  TOP: 'top',
  LEFT: 'left',
  RIGHT: 'right',
  BOTTOM: 'bottom',
  NONE: 'none'
};

var trianglePositions = {
  START: 'start',
  CENTER: 'center',
  END: 'end'
};

var popoutPositions = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right',
  TOP: 'top'
};

var openOn = {
  CLICK: 'click',
  HOVER: 'hover'
};

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = pickContextTypes;
var contextTypes = {
  // The public methods that all controls should be able to use
  updateStateFromVideo: React.PropTypes.func,
  togglePause: React.PropTypes.func,
  toggleMute: React.PropTypes.func,
  toggleError: React.PropTypes.func,
  toggleBeenPlayed: React.PropTypes.func,
  toggleEnded: React.PropTypes.func,
  exitFullScreen: React.PropTypes.func,
  toggleFullScreenByUser: React.PropTypes.func,
  toggleInfoOverlay: React.PropTypes.func,
  setQuality: React.PropTypes.func,
  afterShareClicked: React.PropTypes.func,

  simple: React.PropTypes.bool,
  mobileMode: React.PropTypes.bool,

  play: React.PropTypes.func,
  pause: React.PropTypes.func,
  mute: React.PropTypes.func,
  unmute: React.PropTypes.func,
  seek: React.PropTypes.func,
  resetSeek: React.PropTypes.func,
  setVolume: React.PropTypes.func,

  videoItem: React.PropTypes.object,
  channelData: React.PropTypes.object,
  appSettings: React.PropTypes.object,
  showChannelCover: React.PropTypes.bool,
  canShowChannelCover: React.PropTypes.bool,
  videoUrls: React.PropTypes.object,
  storyboardUrl: React.PropTypes.string,
  quality: React.PropTypes.string,
  openPreviewPrompt: React.PropTypes.func,
  showControls: React.PropTypes.bool,

  // Standard video properties
  duration: React.PropTypes.number,
  currentTime: React.PropTypes.number,
  userTime: React.PropTypes.number,
  buffered: React.PropTypes.object,
  fullScreen: React.PropTypes.bool,
  infoOverlay: React.PropTypes.any,
  infoOverlayProps: React.PropTypes.object,
  paused: React.PropTypes.bool,
  muted: React.PropTypes.bool,
  loop: React.PropTypes.bool,
  volume: React.PropTypes.number,
  readyState: React.PropTypes.number,
  width: React.PropTypes.number,
  height: React.PropTypes.number,

  // Non-standard state computed from properties
  percentageBuffered: React.PropTypes.number,
  percentagePlayed: React.PropTypes.number,
  error: React.PropTypes.bool,
  loading: React.PropTypes.bool,
  beenPlayed: React.PropTypes.bool,
  ended: React.PropTypes.bool,
  fadeControls: React.PropTypes.bool
};

/* harmony default export */ __webpack_exports__["a"] = (contextTypes);

function pickContextTypes() {
  for (var _len = arguments.length, types = Array(_len), _key = 0; _key < _len; _key++) {
    types[_key] = arguments[_key];
  }

  return _.pick(contextTypes, types);
}

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ErrorTypes = exports.ErrorTypes = {
  // Identifier for a network error (loading error / timeout ...)
  NETWORK_ERROR: 'networkError',
  // Identifier for a media Error (video/parsing/mediasource error)
  MEDIA_ERROR: 'mediaError',
  // Identifier for a mux Error (demuxing/remuxing)
  MUX_ERROR: 'muxError',
  // Identifier for all other errors
  OTHER_ERROR: 'otherError'
};

var ErrorDetails = exports.ErrorDetails = {
  // Identifier for a manifest load error - data: { url : faulty URL, response : { code: error code, text: error text }}
  MANIFEST_LOAD_ERROR: 'manifestLoadError',
  // Identifier for a manifest load timeout - data: { url : faulty URL, response : { code: error code, text: error text }}
  MANIFEST_LOAD_TIMEOUT: 'manifestLoadTimeOut',
  // Identifier for a manifest parsing error - data: { url : faulty URL, reason : error reason}
  MANIFEST_PARSING_ERROR: 'manifestParsingError',
  // Identifier for a manifest with only incompatible codecs error - data: { url : faulty URL, reason : error reason}
  MANIFEST_INCOMPATIBLE_CODECS_ERROR: 'manifestIncompatibleCodecsError',
  // Identifier for a level load error - data: { url : faulty URL, response : { code: error code, text: error text }}
  LEVEL_LOAD_ERROR: 'levelLoadError',
  // Identifier for a level load timeout - data: { url : faulty URL, response : { code: error code, text: error text }}
  LEVEL_LOAD_TIMEOUT: 'levelLoadTimeOut',
  // Identifier for a level switch error - data: { level : faulty level Id, event : error description}
  LEVEL_SWITCH_ERROR: 'levelSwitchError',
  // Identifier for an audio track load error - data: { url : faulty URL, response : { code: error code, text: error text }}
  AUDIO_TRACK_LOAD_ERROR: 'audioTrackLoadError',
  // Identifier for an audio track load timeout - data: { url : faulty URL, response : { code: error code, text: error text }}
  AUDIO_TRACK_LOAD_TIMEOUT: 'audioTrackLoadTimeOut',
  // Identifier for fragment load error - data: { frag : fragment object, response : { code: error code, text: error text }}
  FRAG_LOAD_ERROR: 'fragLoadError',
  // Identifier for fragment loop loading error - data: { frag : fragment object}
  FRAG_LOOP_LOADING_ERROR: 'fragLoopLoadingError',
  // Identifier for fragment load timeout error - data: { frag : fragment object}
  FRAG_LOAD_TIMEOUT: 'fragLoadTimeOut',
  // Identifier for a fragment decryption error event - data: {id : demuxer Id,frag: fragment object, reason : parsing error description }
  FRAG_DECRYPT_ERROR: 'fragDecryptError',
  // Identifier for a fragment parsing error event - data: { id : demuxer Id, reason : parsing error description }
  // will be renamed DEMUX_PARSING_ERROR and switched to MUX_ERROR in the next major release
  FRAG_PARSING_ERROR: 'fragParsingError',
  // Identifier for a remux alloc error event - data: { id : demuxer Id, frag : fragment object, bytes : nb of bytes on which allocation failed , reason : error text }
  REMUX_ALLOC_ERROR: 'remuxAllocError',
  // Identifier for decrypt key load error - data: { frag : fragment object, response : { code: error code, text: error text }}
  KEY_LOAD_ERROR: 'keyLoadError',
  // Identifier for decrypt key load timeout error - data: { frag : fragment object}
  KEY_LOAD_TIMEOUT: 'keyLoadTimeOut',
  // Triggered when an exception occurs while adding a sourceBuffer to MediaSource - data : {  err : exception , mimeType : mimeType }
  BUFFER_ADD_CODEC_ERROR: 'bufferAddCodecError',
  // Identifier for a buffer append error - data: append error description
  BUFFER_APPEND_ERROR: 'bufferAppendError',
  // Identifier for a buffer appending error event - data: appending error description
  BUFFER_APPENDING_ERROR: 'bufferAppendingError',
  // Identifier for a buffer stalled error event
  BUFFER_STALLED_ERROR: 'bufferStalledError',
  // Identifier for a buffer full event
  BUFFER_FULL_ERROR: 'bufferFullError',
  // Identifier for a buffer seek over hole event
  BUFFER_SEEK_OVER_HOLE: 'bufferSeekOverHole',
  // Identifier for a buffer nudge on stall (playback is stuck although currentTime is in a buffered area)
  BUFFER_NUDGE_ON_STALL: 'bufferNudgeOnStall',
  // Identifier for an internal exception happening inside hls.js while handling an event
  INTERNAL_EXCEPTION: 'internalException',
  // Malformed WebVTT contents
  WEBVTT_EXCEPTION: 'webVTTException'
};

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__channel_layout_values__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__channel_video_list_values__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__compact_play_type__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__compact_show_video_list__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__info_position_values__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__layout_style_values__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__main_action_style_types__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__main_item_type_values__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__poster_position_values__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__show_info_values__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__show_media_type_values__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__title_position_values__ = __webpack_require__(652);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__channel_layout_values__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_1__channel_video_list_values__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_2__compact_play_type__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__compact_show_video_list__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__info_position_values__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__layout_style_values__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_6__main_action_style_types__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_7__main_item_type_values__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_8__poster_position_values__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_9__show_info_values__["a"]; });
/* unused harmony reexport showMediaTypeValues */
/* unused harmony reexport titlePositionValues */


























/* harmony default export */ __webpack_exports__["c"] = ({
  booleans: {
    enableVideosSharing: true,
    showChannelCategories: true,
    showChannelShare: true,
    showChannelTitle: true,
    showChannelInfo: false,
    showSearch: true,
    showSignIn: true,
    showChannelTags: true,
    showChannelVideos: true,
    showFullInfo: true,
    showVideoPublisherInList: true,
    showVideoTitleInList: true,
    showTitleForMainItem: true,
    showPublisherForMainItem: true,
    showActionBar: true
  },
  numbers: {
    videoInfoPosition: __WEBPACK_IMPORTED_MODULE_4__info_position_values__["a" /* default */].ON_VIDEOS,
    showInfoAction: __WEBPACK_IMPORTED_MODULE_9__show_info_values__["a" /* default */].ON_MOUSE_OVER,
    layoutStyle: __WEBPACK_IMPORTED_MODULE_5__layout_style_values__["a" /* default */].SQUARE,
    channelLayout: __WEBPACK_IMPORTED_MODULE_0__channel_layout_values__["a" /* default */].CLASSIC,
    mainItemType: __WEBPACK_IMPORTED_MODULE_7__main_item_type_values__["a" /* default */].CHANNEL_COVER,
    mainItemTitlePosition: __WEBPACK_IMPORTED_MODULE_11__title_position_values__["a" /* default */].CENTER,
    videoListVisibility: __WEBPACK_IMPORTED_MODULE_1__channel_video_list_values__["a" /* default */].EXPAND_ON_CLICK,
    videosInRow: 4,
    mainItemOverlayOpacity: 35,
    showMediaType: __WEBPACK_IMPORTED_MODULE_10__show_media_type_values__["a" /* default */].COVER_IMAGE,
    numberOfRows: 1,
    playType: __WEBPACK_IMPORTED_MODULE_2__compact_play_type__["a" /* default */].IN_FRAME,
    compactShowVideoListType: __WEBPACK_IMPORTED_MODULE_3__compact_show_video_list__["a" /* default */].EXPAND_ON_CLICK,
    mainActionStyleType: __WEBPACK_IMPORTED_MODULE_6__main_action_style_types__["a" /* default */].ICON_WITH_TEXT
  },
  editMode: 'site'
});

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var pIE            = __webpack_require__(176)
  , createDesc     = __webpack_require__(102)
  , toIObject      = __webpack_require__(60)
  , toPrimitive    = __webpack_require__(80)
  , has            = __webpack_require__(52)
  , IE8_DOM_DEFINE = __webpack_require__(461)
  , gOPD           = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(32) ? gOPD : function getOwnPropertyDescriptor(O, P){
  O = toIObject(O);
  P = toPrimitive(P, true);
  if(IE8_DOM_DEFINE)try {
    return gOPD(O, P);
  } catch(e){ /* empty */ }
  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
};

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has         = __webpack_require__(52)
  , toObject    = __webpack_require__(45)
  , IE_PROTO    = __webpack_require__(308)('IE_PROTO')
  , ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function(O){
  O = toObject(O);
  if(has(O, IE_PROTO))return O[IE_PROTO];
  if(typeof O.constructor == 'function' && O instanceof O.constructor){
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _voMetricsHTTPRequest = __webpack_require__(84);

var DEFAULT_UTC_TIMING_SOURCE = { scheme: 'urn:mpeg:dash:utc:http-xsdate:2014', value: 'http://time.akamai.com/?iso' };
var LIVE_DELAY_FRAGMENT_COUNT = 4;

var DEFAULT_LOCAL_STORAGE_BITRATE_EXPIRATION = 360000;
var DEFAULT_LOCAL_STORAGE_MEDIA_SETTINGS_EXPIRATION = 360000;

var BANDWIDTH_SAFETY_FACTOR = 0.9;
var ABANDON_LOAD_TIMEOUT = 10000;

var BUFFER_TO_KEEP = 30;
var BUFFER_PRUNING_INTERVAL = 30;
var DEFAULT_MIN_BUFFER_TIME = 12;
var DEFAULT_MIN_BUFFER_TIME_FAST_SWITCH = 20;
var BUFFER_TIME_AT_TOP_QUALITY = 30;
var BUFFER_TIME_AT_TOP_QUALITY_LONG_FORM = 60;
var LONG_FORM_CONTENT_DURATION_THRESHOLD = 600;
var RICH_BUFFER_THRESHOLD = 20;

var FRAGMENT_RETRY_ATTEMPTS = 3;
var FRAGMENT_RETRY_INTERVAL = 1000;

var MANIFEST_RETRY_ATTEMPTS = 3;
var MANIFEST_RETRY_INTERVAL = 500;

var XLINK_RETRY_ATTEMPTS = 1;
var XLINK_RETRY_INTERVAL = 500;

//This value influences the startup time for live (in ms).
var WALLCLOCK_TIME_UPDATE_INTERVAL = 50;

var DEFAULT_XHR_WITH_CREDENTIALS = false;

function MediaPlayerModel() {

    var instance = undefined,
        useManifestDateHeaderTimeSource = undefined,
        useSuggestedPresentationDelay = undefined,
        UTCTimingSources = undefined,
        liveDelayFragmentCount = undefined,
        liveDelay = undefined,
        scheduleWhilePaused = undefined,
        bufferToKeep = undefined,
        bufferPruningInterval = undefined,
        lastBitrateCachingInfo = undefined,
        lastMediaSettingsCachingInfo = undefined,
        stableBufferTime = undefined,
        bufferTimeAtTopQuality = undefined,
        bufferTimeAtTopQualityLongForm = undefined,
        longFormContentDurationThreshold = undefined,
        richBufferThreshold = undefined,
        bandwidthSafetyFactor = undefined,
        abandonLoadTimeout = undefined,
        retryAttempts = undefined,
        retryIntervals = undefined,
        wallclockTimeUpdateInterval = undefined,
        bufferOccupancyABREnabled = undefined,
        xhrWithCredentials = undefined,
        fastSwitchEnabled = undefined;

    function setup() {
        var _retryAttempts, _retryIntervals;

        UTCTimingSources = [];
        useSuggestedPresentationDelay = false;
        useManifestDateHeaderTimeSource = true;
        scheduleWhilePaused = true;
        bufferOccupancyABREnabled = false;
        fastSwitchEnabled = false;
        lastBitrateCachingInfo = { enabled: true, ttl: DEFAULT_LOCAL_STORAGE_BITRATE_EXPIRATION };
        lastMediaSettingsCachingInfo = { enabled: true, ttl: DEFAULT_LOCAL_STORAGE_MEDIA_SETTINGS_EXPIRATION };
        liveDelayFragmentCount = LIVE_DELAY_FRAGMENT_COUNT;
        liveDelay = undefined; // Explicitly state that default is undefined
        bufferToKeep = BUFFER_TO_KEEP;
        bufferPruningInterval = BUFFER_PRUNING_INTERVAL;
        stableBufferTime = NaN;
        bufferTimeAtTopQuality = BUFFER_TIME_AT_TOP_QUALITY;
        bufferTimeAtTopQualityLongForm = BUFFER_TIME_AT_TOP_QUALITY_LONG_FORM;
        longFormContentDurationThreshold = LONG_FORM_CONTENT_DURATION_THRESHOLD;
        richBufferThreshold = RICH_BUFFER_THRESHOLD;
        bandwidthSafetyFactor = BANDWIDTH_SAFETY_FACTOR;
        abandonLoadTimeout = ABANDON_LOAD_TIMEOUT;
        wallclockTimeUpdateInterval = WALLCLOCK_TIME_UPDATE_INTERVAL;
        xhrWithCredentials = { 'default': DEFAULT_XHR_WITH_CREDENTIALS };

        retryAttempts = (_retryAttempts = {}, _defineProperty(_retryAttempts, _voMetricsHTTPRequest.HTTPRequest.MPD_TYPE, MANIFEST_RETRY_ATTEMPTS), _defineProperty(_retryAttempts, _voMetricsHTTPRequest.HTTPRequest.XLINK_EXPANSION_TYPE, XLINK_RETRY_ATTEMPTS), _defineProperty(_retryAttempts, _voMetricsHTTPRequest.HTTPRequest.MEDIA_SEGMENT_TYPE, FRAGMENT_RETRY_ATTEMPTS), _defineProperty(_retryAttempts, _voMetricsHTTPRequest.HTTPRequest.INIT_SEGMENT_TYPE, FRAGMENT_RETRY_ATTEMPTS), _defineProperty(_retryAttempts, _voMetricsHTTPRequest.HTTPRequest.BITSTREAM_SWITCHING_SEGMENT_TYPE, FRAGMENT_RETRY_ATTEMPTS), _defineProperty(_retryAttempts, _voMetricsHTTPRequest.HTTPRequest.INDEX_SEGMENT_TYPE, FRAGMENT_RETRY_ATTEMPTS), _defineProperty(_retryAttempts, _voMetricsHTTPRequest.HTTPRequest.OTHER_TYPE, FRAGMENT_RETRY_ATTEMPTS), _retryAttempts);

        retryIntervals = (_retryIntervals = {}, _defineProperty(_retryIntervals, _voMetricsHTTPRequest.HTTPRequest.MPD_TYPE, MANIFEST_RETRY_INTERVAL), _defineProperty(_retryIntervals, _voMetricsHTTPRequest.HTTPRequest.XLINK_EXPANSION_TYPE, XLINK_RETRY_INTERVAL), _defineProperty(_retryIntervals, _voMetricsHTTPRequest.HTTPRequest.MEDIA_SEGMENT_TYPE, FRAGMENT_RETRY_INTERVAL), _defineProperty(_retryIntervals, _voMetricsHTTPRequest.HTTPRequest.INIT_SEGMENT_TYPE, FRAGMENT_RETRY_INTERVAL), _defineProperty(_retryIntervals, _voMetricsHTTPRequest.HTTPRequest.BITSTREAM_SWITCHING_SEGMENT_TYPE, FRAGMENT_RETRY_INTERVAL), _defineProperty(_retryIntervals, _voMetricsHTTPRequest.HTTPRequest.INDEX_SEGMENT_TYPE, FRAGMENT_RETRY_INTERVAL), _defineProperty(_retryIntervals, _voMetricsHTTPRequest.HTTPRequest.OTHER_TYPE, FRAGMENT_RETRY_INTERVAL), _retryIntervals);
    }

    //TODO Should we use Object.define to have setters/getters? makes more readable code on other side.
    function setBufferOccupancyABREnabled(value) {
        bufferOccupancyABREnabled = value;
    }

    function getBufferOccupancyABREnabled() {
        return bufferOccupancyABREnabled;
    }

    function setBandwidthSafetyFactor(value) {
        bandwidthSafetyFactor = value;
    }

    function getBandwidthSafetyFactor() {
        return bandwidthSafetyFactor;
    }

    function setAbandonLoadTimeout(value) {
        abandonLoadTimeout = value;
    }

    function getAbandonLoadTimeout() {
        return abandonLoadTimeout;
    }

    function setStableBufferTime(value) {
        stableBufferTime = value;
    }

    function getStableBufferTime() {
        return !isNaN(stableBufferTime) ? stableBufferTime : fastSwitchEnabled ? DEFAULT_MIN_BUFFER_TIME_FAST_SWITCH : DEFAULT_MIN_BUFFER_TIME;
    }

    function setBufferTimeAtTopQuality(value) {
        bufferTimeAtTopQuality = value;
    }

    function getBufferTimeAtTopQuality() {
        return bufferTimeAtTopQuality;
    }

    function setBufferTimeAtTopQualityLongForm(value) {
        bufferTimeAtTopQualityLongForm = value;
    }

    function getBufferTimeAtTopQualityLongForm() {
        return bufferTimeAtTopQualityLongForm;
    }

    function setLongFormContentDurationThreshold(value) {
        longFormContentDurationThreshold = value;
    }

    function getLongFormContentDurationThreshold() {
        return longFormContentDurationThreshold;
    }

    function setRichBufferThreshold(value) {
        richBufferThreshold = value;
    }

    function getRichBufferThreshold() {
        return richBufferThreshold;
    }

    function setBufferToKeep(value) {
        bufferToKeep = value;
    }

    function getBufferToKeep() {
        return bufferToKeep;
    }

    function setLastBitrateCachingInfo(enable, ttl) {
        lastBitrateCachingInfo.enabled = enable;
        if (ttl !== undefined && !isNaN(ttl) && typeof ttl === 'number') {
            lastBitrateCachingInfo.ttl = ttl;
        }
    }

    function getLastBitrateCachingInfo() {
        return lastBitrateCachingInfo;
    }

    function setLastMediaSettingsCachingInfo(enable, ttl) {
        lastMediaSettingsCachingInfo.enabled = enable;
        if (ttl !== undefined && !isNaN(ttl) && typeof ttl === 'number') {
            lastMediaSettingsCachingInfo.ttl = ttl;
        }
    }

    function getLastMediaSettingsCachingInfo() {
        return lastMediaSettingsCachingInfo;
    }

    function setBufferPruningInterval(value) {
        bufferPruningInterval = value;
    }

    function getBufferPruningInterval() {
        return bufferPruningInterval;
    }

    function setFragmentRetryAttempts(value) {
        retryAttempts[_voMetricsHTTPRequest.HTTPRequest.MEDIA_SEGMENT_TYPE] = value;
    }

    function setRetryAttemptsForType(type, value) {
        retryAttempts[type] = value;
    }

    function getFragmentRetryAttempts() {
        return retryAttempts[_voMetricsHTTPRequest.HTTPRequest.MEDIA_SEGMENT_TYPE];
    }

    function getRetryAttemptsForType(type) {
        return retryAttempts[type];
    }

    function setFragmentRetryInterval(value) {
        retryIntervals[_voMetricsHTTPRequest.HTTPRequest.MEDIA_SEGMENT_TYPE] = value;
    }

    function setRetryIntervalForType(type, value) {
        retryIntervals[type] = value;
    }

    function getFragmentRetryInterval() {
        return retryIntervals[_voMetricsHTTPRequest.HTTPRequest.MEDIA_SEGMENT_TYPE];
    }

    function getRetryIntervalForType(type) {
        return retryIntervals[type];
    }

    function setWallclockTimeUpdateInterval(value) {
        wallclockTimeUpdateInterval = value;
    }

    function getWallclockTimeUpdateInterval() {
        return wallclockTimeUpdateInterval;
    }

    function setScheduleWhilePaused(value) {
        scheduleWhilePaused = value;
    }

    function getScheduleWhilePaused() {
        return scheduleWhilePaused;
    }

    function setLiveDelayFragmentCount(value) {
        liveDelayFragmentCount = value;
    }

    function setLiveDelay(value) {
        liveDelay = value;
    }

    function getLiveDelayFragmentCount() {
        return liveDelayFragmentCount;
    }

    function getLiveDelay() {
        return liveDelay;
    }

    function setUseManifestDateHeaderTimeSource(value) {
        useManifestDateHeaderTimeSource = value;
    }

    function getUseManifestDateHeaderTimeSource() {
        return useManifestDateHeaderTimeSource;
    }

    function setUseSuggestedPresentationDelay(value) {
        useSuggestedPresentationDelay = value;
    }

    function getUseSuggestedPresentationDelay() {
        return useSuggestedPresentationDelay;
    }

    function setUTCTimingSources(value) {
        UTCTimingSources = value;
    }

    function getUTCTimingSources() {
        return UTCTimingSources;
    }

    function setXHRWithCredentialsForType(type, value) {
        if (!type) {
            Object.keys(xhrWithCredentials).forEach(function (key) {
                setXHRWithCredentialsForType(key, value);
            });
        } else {
            xhrWithCredentials[type] = !!value;
        }
    }

    function getXHRWithCredentialsForType(type) {
        var useCreds = xhrWithCredentials[type];

        if (useCreds === undefined) {
            return xhrWithCredentials['default'];
        }

        return useCreds;
    }

    function getFastSwitchEnabled() {
        return fastSwitchEnabled;
    }

    function setFastSwitchEnabled(value) {
        fastSwitchEnabled = value;
    }

    function reset() {
        //TODO need to figure out what props to persist across sessions and which to reset if any.
        //setup();
    }

    instance = {
        setBufferOccupancyABREnabled: setBufferOccupancyABREnabled,
        getBufferOccupancyABREnabled: getBufferOccupancyABREnabled,
        setBandwidthSafetyFactor: setBandwidthSafetyFactor,
        getBandwidthSafetyFactor: getBandwidthSafetyFactor,
        setAbandonLoadTimeout: setAbandonLoadTimeout,
        getAbandonLoadTimeout: getAbandonLoadTimeout,
        setLastBitrateCachingInfo: setLastBitrateCachingInfo,
        getLastBitrateCachingInfo: getLastBitrateCachingInfo,
        setLastMediaSettingsCachingInfo: setLastMediaSettingsCachingInfo,
        getLastMediaSettingsCachingInfo: getLastMediaSettingsCachingInfo,
        setStableBufferTime: setStableBufferTime,
        getStableBufferTime: getStableBufferTime,
        setBufferTimeAtTopQuality: setBufferTimeAtTopQuality,
        getBufferTimeAtTopQuality: getBufferTimeAtTopQuality,
        setBufferTimeAtTopQualityLongForm: setBufferTimeAtTopQualityLongForm,
        getBufferTimeAtTopQualityLongForm: getBufferTimeAtTopQualityLongForm,
        setLongFormContentDurationThreshold: setLongFormContentDurationThreshold,
        getLongFormContentDurationThreshold: getLongFormContentDurationThreshold,
        setRichBufferThreshold: setRichBufferThreshold,
        getRichBufferThreshold: getRichBufferThreshold,
        setBufferToKeep: setBufferToKeep,
        getBufferToKeep: getBufferToKeep,
        setBufferPruningInterval: setBufferPruningInterval,
        getBufferPruningInterval: getBufferPruningInterval,
        setFragmentRetryAttempts: setFragmentRetryAttempts,
        getFragmentRetryAttempts: getFragmentRetryAttempts,
        setRetryAttemptsForType: setRetryAttemptsForType,
        getRetryAttemptsForType: getRetryAttemptsForType,
        setFragmentRetryInterval: setFragmentRetryInterval,
        getFragmentRetryInterval: getFragmentRetryInterval,
        setRetryIntervalForType: setRetryIntervalForType,
        getRetryIntervalForType: getRetryIntervalForType,
        setWallclockTimeUpdateInterval: setWallclockTimeUpdateInterval,
        getWallclockTimeUpdateInterval: getWallclockTimeUpdateInterval,
        setScheduleWhilePaused: setScheduleWhilePaused,
        getScheduleWhilePaused: getScheduleWhilePaused,
        getUseSuggestedPresentationDelay: getUseSuggestedPresentationDelay,
        setUseSuggestedPresentationDelay: setUseSuggestedPresentationDelay,
        setLiveDelayFragmentCount: setLiveDelayFragmentCount,
        getLiveDelayFragmentCount: getLiveDelayFragmentCount,
        getLiveDelay: getLiveDelay,
        setLiveDelay: setLiveDelay,
        setUseManifestDateHeaderTimeSource: setUseManifestDateHeaderTimeSource,
        getUseManifestDateHeaderTimeSource: getUseManifestDateHeaderTimeSource,
        setUTCTimingSources: setUTCTimingSources,
        getUTCTimingSources: getUTCTimingSources,
        setXHRWithCredentialsForType: setXHRWithCredentialsForType,
        getXHRWithCredentialsForType: getXHRWithCredentialsForType,
        setFastSwitchEnabled: setFastSwitchEnabled,
        getFastSwitchEnabled: getFastSwitchEnabled,
        reset: reset
    };

    setup();

    return instance;
}

//TODO see if you can move this and not export and just getter to get default value.
MediaPlayerModel.__dashjs_factory_name = 'MediaPlayerModel';
var factory = _coreFactoryMaker2['default'].getSingletonFactory(MediaPlayerModel);
factory.DEFAULT_UTC_TIMING_SOURCE = DEFAULT_UTC_TIMING_SOURCE;
exports['default'] = factory;
module.exports = exports['default'];
//# sourceMappingURL=MediaPlayerModel.js.map


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     * All objects in the event handling chain should inherit from this class
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     */

var _logger = __webpack_require__(31);

var _errors = __webpack_require__(63);

var _events = __webpack_require__(39);

var _events2 = _interopRequireDefault(_events);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EventHandler = function () {
  function EventHandler(hls) {
    _classCallCheck(this, EventHandler);

    this.hls = hls;
    this.onEvent = this.onEvent.bind(this);

    for (var _len = arguments.length, events = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      events[_key - 1] = arguments[_key];
    }

    this.handledEvents = events;
    this.useGenericHandler = true;

    this.registerListeners();
  }

  _createClass(EventHandler, [{
    key: 'destroy',
    value: function destroy() {
      this.unregisterListeners();
    }
  }, {
    key: 'isEventHandler',
    value: function isEventHandler() {
      return _typeof(this.handledEvents) === 'object' && this.handledEvents.length && typeof this.onEvent === 'function';
    }
  }, {
    key: 'registerListeners',
    value: function registerListeners() {
      if (this.isEventHandler()) {
        this.handledEvents.forEach(function (event) {
          if (event === 'hlsEventGeneric') {
            throw new Error('Forbidden event name: ' + event);
          }
          this.hls.on(event, this.onEvent);
        }.bind(this));
      }
    }
  }, {
    key: 'unregisterListeners',
    value: function unregisterListeners() {
      if (this.isEventHandler()) {
        this.handledEvents.forEach(function (event) {
          this.hls.off(event, this.onEvent);
        }.bind(this));
      }
    }

    /**
     * arguments: event (string), data (any)
     */

  }, {
    key: 'onEvent',
    value: function onEvent(event, data) {
      this.onEventGeneric(event, data);
    }
  }, {
    key: 'onEventGeneric',
    value: function onEventGeneric(event, data) {
      var eventToFunction = function eventToFunction(event, data) {
        var funcName = 'on' + event.replace('hls', '');
        if (typeof this[funcName] !== 'function') {
          throw new Error('Event ' + event + ' has no generic handler in this ' + this.constructor.name + ' class (tried ' + funcName + ')');
        }
        return this[funcName].bind(this, data);
      };
      try {
        eventToFunction.call(this, event, data).call();
      } catch (err) {
        _logger.logger.error('internal error happened while processing ' + event + ':' + err.message);
        this.hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.OTHER_ERROR, details: _errors.ErrorDetails.INTERNAL_EXCEPTION, fatal: false, event: event, err: err });
      }
    }
  }]);

  return EventHandler;
}();

exports.default = EventHandler;

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Router__ = __webpack_require__(1146);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Link__ = __webpack_require__(521);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IndexLink__ = __webpack_require__(1142);
/* unused harmony reexport IndexLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__withRouter__ = __webpack_require__(1157);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__withRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IndexRedirect__ = __webpack_require__(1143);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_4__IndexRedirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IndexRoute__ = __webpack_require__(1144);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_5__IndexRoute__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(523);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(1145);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RouteUtils__ = __webpack_require__(108);
/* unused harmony reexport createRoutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RouterContext__ = __webpack_require__(347);
/* unused harmony reexport RouterContext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PropTypes__ = __webpack_require__(346);
/* unused harmony reexport locationShape */
/* unused harmony reexport routerShape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__match__ = __webpack_require__(1155);
/* unused harmony reexport match */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__useRouterHistory__ = __webpack_require__(528);
/* unused harmony reexport useRouterHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PatternUtils__ = __webpack_require__(147);
/* unused harmony reexport formatPattern */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__applyRouterMiddleware__ = __webpack_require__(1148);
/* unused harmony reexport applyRouterMiddleware */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__browserHistory__ = __webpack_require__(1149);
/* unused harmony reexport browserHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__hashHistory__ = __webpack_require__(1153);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_16__hashHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__createMemoryHistory__ = __webpack_require__(525);
/* unused harmony reexport createMemoryHistory */
/* components */









/* components (configuration) */










/* utils */















/* histories */








/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(718);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(549);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getChannelIds;
/* harmony export (immutable) */ __webpack_exports__["f"] = getChannelById;
/* harmony export (immutable) */ __webpack_exports__["c"] = isFetching;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getChannels; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getAllChannelsGroupedByIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getChannelsGroupedByIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getChannelForWidget; });
/* unused harmony export getDGSInfo */
/* unused harmony export getDealInfo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reselect__);



function getChannelIds(state) {
  return state.channels.ids;
}

function getChannelById(state, channelId) {
  return state.entities.channels[channelId];
}

function isFetching(state) {
  return state.channels.activeRequests !== 0;
}

/**
 * @param state
 * @returns {Object[]} channels list
 */
var getChannels = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([function (state) {
  return state;
}, getChannelIds], function (state, ids) {
  return _.map(ids, _.partial(getChannelById, state));
});

var getAllChannelsGroupedByIds = function getAllChannelsGroupedByIds(state) {
  return state.entities.channels;
};

/**
 * @param state
 * @returns {Object} {id: channel}
 */
var getChannelsGroupedByIds = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([getAllChannelsGroupedByIds, getChannelIds], _.pick);

/**
 * @param state
 * @returns {Object} channel
 */
var getChannelForWidget = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([function (_ref) {
  var channelInfo = _ref.channelInfo;
  return _.get(channelInfo, 'info');
}, function (_ref2) {
  var channelInfo = _ref2.channelInfo;
  return _.get(channelInfo, 'paymentInfo');
}], function (info, paymentInfo) {
  if (!info && !paymentInfo) {
    return null;
  }
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, info, paymentInfo);
});

/**
 * @param state
 * @returns {Object} dgs info
 */
var getDGSInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([getChannelForWidget], function (_ref3) {
  var dgsInfo = _ref3.dgsInfo;
  return dgsInfo;
});

/**
 * @param state
 * @returns {Object} deal info
 */
var getDealInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([getChannelForWidget], function (_ref4) {
  var dealInfo = _ref4.dealInfo;
  return dealInfo;
});

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(55)
  , core      = __webpack_require__(37)
  , ctx       = __webpack_require__(97)
  , hide      = __webpack_require__(98)
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , IS_WRAP   = type & $export.W
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE]
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
    , key, own, out;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if(own && key in exports)continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function(C){
      var F = function(a, b, c){
        if(this instanceof C){
          switch(arguments.length){
            case 0: return new C;
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if(IS_PROTO){
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library` 
module.exports = $export;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var anObject       = __webpack_require__(86)
  , IE8_DOM_DEFINE = __webpack_require__(441)
  , toPrimitive    = __webpack_require__(288)
  , dP             = Object.defineProperty;

exports.f = __webpack_require__(77) ? Object.defineProperty : function defineProperty(O, P, Attributes){
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if(IE8_DOM_DEFINE)try {
    return dP(O, P, Attributes);
  } catch(e){ /* empty */ }
  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
  if('value' in Attributes)O[P] = Attributes.value;
  return O;
};

/***/ }),
/* 74 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};

/***/ }),
/* 75 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(24);

module.exports = function(method, arg){
  return !!method && fails(function(){
    arg ? method.call(null, function(){}, 1) : method.call(null);
  });
};

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(117)(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx      = __webpack_require__(88)
  , IObject  = __webpack_require__(175)
  , toObject = __webpack_require__(45)
  , toLength = __webpack_require__(43)
  , asc      = __webpack_require__(779);
module.exports = function(TYPE, $create){
  var IS_MAP        = TYPE == 1
    , IS_FILTER     = TYPE == 2
    , IS_SOME       = TYPE == 3
    , IS_EVERY      = TYPE == 4
    , IS_FIND_INDEX = TYPE == 6
    , NO_HOLES      = TYPE == 5 || IS_FIND_INDEX
    , create        = $create || asc;
  return function($this, callbackfn, that){
    var O      = toObject($this)
      , self   = IObject(O)
      , f      = ctx(callbackfn, that, 3)
      , length = toLength(self.length)
      , index  = 0
      , result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined
      , val, res;
    for(;length > index; index++)if(NO_HOLES || index in self){
      val = self[index];
      res = f(val, index, O);
      if(TYPE){
        if(IS_MAP)result[index] = res;            // map
        else if(res)switch(TYPE){
          case 3: return true;                    // some
          case 5: return val;                     // find
          case 6: return index;                   // findIndex
          case 2: result.push(val);               // filter
        } else if(IS_EVERY)return false;          // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(6)
  , core    = __webpack_require__(87)
  , fails   = __webpack_require__(24);
module.exports = function(KEY, exec){
  var fn  = (core.Object || {})[KEY] || Object[KEY]
    , exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
};

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(28);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S){
  if(!isObject(it))return it;
  var fn, val;
  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(499);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = getMinPriceInfo;
/* harmony export (immutable) */ __webpack_exports__["e"] = hasEnabledPriceInfo;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getSubscriptionPriceInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getSalePriceInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getRentPriceInfo; });
function getMinPriceInfo(dealInfo) {
  var enabledDealInfo = _.filter(dealInfo, { enabled: true });
  if (!enabledDealInfo.length) {
    return null;
  }

  return _.minBy(enabledDealInfo, 'price');
}

function hasEnabledPriceInfo(dealInfo) {
  return _.some(dealInfo, { enabled: true });
}

function buildGetPriceInfo(type) {
  var query = {
    enabled: true,
    type: type
  };

  return function (dealInfo) {
    return _.find(dealInfo, query) || null;
  };
}

var getSubscriptionPriceInfo = buildGetPriceInfo('subscription');
var getSalePriceInfo = buildGetPriceInfo('sale');
var getRentPriceInfo = buildGetPriceInfo('rent');

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(1165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(1164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(1163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(348);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @classdesc This Object holds reference to the HTTPRequest for manifest, fragment and xlink loading.
 * Members which are not defined in ISO23009-1 Annex D should be prefixed by a _ so that they are ignored
 * by Metrics Reporting code.
 */


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var HTTPRequest =
/**
 * @class
 */
function HTTPRequest() {
  _classCallCheck(this, HTTPRequest);

  /**
   * Identifier of the TCP connection on which the HTTP request was sent.
   * @public
   */
  this.tcpid = null;
  /**
   * This is an optional parameter and should not be included in HTTP request/response transactions for progressive download.
   * The type of the request:
   * - MPD
   * - XLink expansion
   * - Initialization Fragment
   * - Index Fragment
   * - Media Fragment
   * - Bitstream Switching Fragment
   * - other
   * @public
   */
  this.type = null;
  /**
   * The original URL (before any redirects or failures)
   * @public
   */
  this.url = null;
  /**
   * The actual URL requested, if different from above
   * @public
   */
  this.actualurl = null;
  /**
   * The contents of the byte-range-spec part of the HTTP Range header.
   * @public
   */
  this.range = null;
  /**
   * Real-Time | The real time at which the request was sent.
   * @public
   */
  this.trequest = null;
  /**
   * Real-Time | The real time at which the first byte of the response was received.
   * @public
   */
  this.tresponse = null;
  /**
   * The HTTP response code.
   * @public
   */
  this.responsecode = null;
  /**
   * The duration of the throughput trace intervals (ms), for successful requests only.
   * @public
   */
  this.interval = null;
  /**
   * Throughput traces, for successful requests only.
   * @public
   */
  this.trace = [];

  /**
   * Type of stream ("audio" | "video" etc..)
   * @public
   */
  this._stream = null;
  /**
   * Real-Time | The real time at which the request finished.
   * @public
   */
  this._tfinish = null;
  /**
   * The duration of the media requests, if available, in milliseconds.
   * @public
   */
  this._mediaduration = null;
  /**
   * all the response headers from request.
   * @public
   */
  this._responseHeaders = null;
  /**
   * The selected service location for the request. string.
   * @public
   */
  this._serviceLocation = null;
}

/**
 * @classdesc This Object holds reference to the progress of the HTTPRequest.
 */
;

var HTTPRequestTrace =
/**
* @class
*/
function HTTPRequestTrace() {
  _classCallCheck(this, HTTPRequestTrace);

  /**
   * Real-Time | Measurement stream start.
   * @public
   */
  this.s = null;
  /**
   * Measurement stream duration (ms).
   * @public
   */
  this.d = null;
  /**
   * List of integers counting the bytes received in each trace interval within the measurement stream.
   * @public
   */
  this.b = [];
};

HTTPRequest.MPD_TYPE = 'MPD';
HTTPRequest.XLINK_EXPANSION_TYPE = 'XLinkExpansion';
HTTPRequest.INIT_SEGMENT_TYPE = 'InitializationSegment';
HTTPRequest.INDEX_SEGMENT_TYPE = 'IndexSegment';
HTTPRequest.MEDIA_SEGMENT_TYPE = 'MediaSegment';
HTTPRequest.BITSTREAM_SWITCHING_SEGMENT_TYPE = 'BitstreamSwitchingSegment';
HTTPRequest.OTHER_TYPE = 'other';

exports.HTTPRequest = HTTPRequest;
exports.HTTPRequestTrace = HTTPRequestTrace;
//# sourceMappingURL=HTTPRequest.js.map


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.defaultMemoize = defaultMemoize;
exports.createSelectorCreator = createSelectorCreator;
exports.createStructuredSelector = createStructuredSelector;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function defaultEqualityCheck(a, b) {
  return a === b;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length <= 1 || arguments[1] === undefined ? defaultEqualityCheck : arguments[1];

  var lastArgs = null;
  var lastResult = null;
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (lastArgs === null || lastArgs.length !== args.length || !args.every(function (value, index) {
      return equalityCheck(value, lastArgs[index]);
    })) {
      lastResult = func.apply(undefined, args);
    }
    lastArgs = args;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len2 = arguments.length, memoizeOptions = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    memoizeOptions[_key2 - 1] = arguments[_key2];
  }

  return function () {
    for (var _len3 = arguments.length, funcs = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      funcs[_key3] = arguments[_key3];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      return resultFunc.apply(undefined, arguments);
    }].concat(memoizeOptions));

    var selector = function selector(state, props) {
      for (var _len4 = arguments.length, args = Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
        args[_key4 - 2] = arguments[_key4];
      }

      var params = dependencies.map(function (dependency) {
        return dependency.apply(undefined, [state, props].concat(args));
      });
      return memoizedResultFunc.apply(undefined, _toConsumableArray(params));
    };

    selector.resultFunc = resultFunc;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length <= 1 || arguments[1] === undefined ? createSelector : arguments[1];

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len5 = arguments.length, values = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      values[_key5] = arguments[_key5];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(99);
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),
/* 87 */
/***/ (function(module, exports) {

var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(56);
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var Map     = __webpack_require__(477)
  , $export = __webpack_require__(6)
  , shared  = __webpack_require__(225)('metadata')
  , store   = shared.store || (shared.store = new (__webpack_require__(480)));

var getOrCreateMetadataMap = function(target, targetKey, create){
  var targetMetadata = store.get(target);
  if(!targetMetadata){
    if(!create)return undefined;
    store.set(target, targetMetadata = new Map);
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if(!keyMetadata){
    if(!create)return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map);
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function(MetadataKey, O, P){
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function(MetadataKey, O, P){
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function(MetadataKey, MetadataValue, O, P){
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function(target, targetKey){
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false)
    , keys        = [];
  if(metadataMap)metadataMap.forEach(function(_, key){ keys.push(key); });
  return keys;
};
var toMetaKey = function(it){
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function(O){
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if(__webpack_require__(32)){
  var LIBRARY             = __webpack_require__(120)
    , global              = __webpack_require__(21)
    , fails               = __webpack_require__(24)
    , $export             = __webpack_require__(6)
    , $typed              = __webpack_require__(226)
    , $buffer             = __webpack_require__(315)
    , ctx                 = __webpack_require__(88)
    , anInstance          = __webpack_require__(119)
    , propertyDesc        = __webpack_require__(102)
    , hide                = __webpack_require__(57)
    , redefineAll         = __webpack_require__(124)
    , toInteger           = __webpack_require__(103)
    , toLength            = __webpack_require__(43)
    , toIndex             = __webpack_require__(126)
    , toPrimitive         = __webpack_require__(80)
    , has                 = __webpack_require__(52)
    , same                = __webpack_require__(474)
    , classof             = __webpack_require__(174)
    , isObject            = __webpack_require__(28)
    , toObject            = __webpack_require__(45)
    , isArrayIter         = __webpack_require__(300)
    , create              = __webpack_require__(121)
    , getPrototypeOf      = __webpack_require__(66)
    , gOPN                = __webpack_require__(122).f
    , getIterFn           = __webpack_require__(317)
    , uid                 = __webpack_require__(127)
    , wks                 = __webpack_require__(29)
    , createArrayMethod   = __webpack_require__(78)
    , createArrayIncludes = __webpack_require__(216)
    , speciesConstructor  = __webpack_require__(309)
    , ArrayIterators      = __webpack_require__(318)
    , Iterators           = __webpack_require__(143)
    , $iterDetect         = __webpack_require__(222)
    , setSpecies          = __webpack_require__(125)
    , arrayFill           = __webpack_require__(293)
    , arrayCopyWithin     = __webpack_require__(454)
    , $DP                 = __webpack_require__(33)
    , $GOPD               = __webpack_require__(65)
    , dP                  = $DP.f
    , gOPD                = $GOPD.f
    , RangeError          = global.RangeError
    , TypeError           = global.TypeError
    , Uint8Array          = global.Uint8Array
    , ARRAY_BUFFER        = 'ArrayBuffer'
    , SHARED_BUFFER       = 'Shared' + ARRAY_BUFFER
    , BYTES_PER_ELEMENT   = 'BYTES_PER_ELEMENT'
    , PROTOTYPE           = 'prototype'
    , ArrayProto          = Array[PROTOTYPE]
    , $ArrayBuffer        = $buffer.ArrayBuffer
    , $DataView           = $buffer.DataView
    , arrayForEach        = createArrayMethod(0)
    , arrayFilter         = createArrayMethod(2)
    , arraySome           = createArrayMethod(3)
    , arrayEvery          = createArrayMethod(4)
    , arrayFind           = createArrayMethod(5)
    , arrayFindIndex      = createArrayMethod(6)
    , arrayIncludes       = createArrayIncludes(true)
    , arrayIndexOf        = createArrayIncludes(false)
    , arrayValues         = ArrayIterators.values
    , arrayKeys           = ArrayIterators.keys
    , arrayEntries        = ArrayIterators.entries
    , arrayLastIndexOf    = ArrayProto.lastIndexOf
    , arrayReduce         = ArrayProto.reduce
    , arrayReduceRight    = ArrayProto.reduceRight
    , arrayJoin           = ArrayProto.join
    , arraySort           = ArrayProto.sort
    , arraySlice          = ArrayProto.slice
    , arrayToString       = ArrayProto.toString
    , arrayToLocaleString = ArrayProto.toLocaleString
    , ITERATOR            = wks('iterator')
    , TAG                 = wks('toStringTag')
    , TYPED_CONSTRUCTOR   = uid('typed_constructor')
    , DEF_CONSTRUCTOR     = uid('def_constructor')
    , ALL_CONSTRUCTORS    = $typed.CONSTR
    , TYPED_ARRAY         = $typed.TYPED
    , VIEW                = $typed.VIEW
    , WRONG_LENGTH        = 'Wrong length!';

  var $map = createArrayMethod(1, function(O, length){
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function(){
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function(){
    new Uint8Array(1).set({});
  });

  var strictToLength = function(it, SAME){
    if(it === undefined)throw TypeError(WRONG_LENGTH);
    var number = +it
      , length = toLength(it);
    if(SAME && !same(number, length))throw RangeError(WRONG_LENGTH);
    return length;
  };

  var toOffset = function(it, BYTES){
    var offset = toInteger(it);
    if(offset < 0 || offset % BYTES)throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function(it){
    if(isObject(it) && TYPED_ARRAY in it)return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function(C, length){
    if(!(isObject(C) && TYPED_CONSTRUCTOR in C)){
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function(O, list){
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function(C, list){
    var index  = 0
      , length = list.length
      , result = allocate(C, length);
    while(length > index)result[index] = list[index++];
    return result;
  };

  var addGetter = function(it, key, internal){
    dP(it, key, {get: function(){ return this._d[internal]; }});
  };

  var $from = function from(source /*, mapfn, thisArg */){
    var O       = toObject(source)
      , aLen    = arguments.length
      , mapfn   = aLen > 1 ? arguments[1] : undefined
      , mapping = mapfn !== undefined
      , iterFn  = getIterFn(O)
      , i, length, values, result, step, iterator;
    if(iterFn != undefined && !isArrayIter(iterFn)){
      for(iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++){
        values.push(step.value);
      } O = values;
    }
    if(mapping && aLen > 2)mapfn = ctx(mapfn, arguments[2], 2);
    for(i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++){
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/*...items*/){
    var index  = 0
      , length = arguments.length
      , result = allocate(this, length);
    while(length > index)result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function(){ arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString(){
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /*, end */){
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /*, thisArg */){
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /*, start, end */){ // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /*, thisArg */){
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /*, thisArg */){
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /*, thisArg */){
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /*, thisArg */){
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /*, fromIndex */){
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /*, fromIndex */){
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator){ // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /*, fromIndex */){ // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /*, thisArg */){
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /*, initialValue */){ // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /*, initialValue */){ // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse(){
      var that   = this
        , length = validate(that).length
        , middle = Math.floor(length / 2)
        , index  = 0
        , value;
      while(index < middle){
        value         = that[index];
        that[index++] = that[--length];
        that[length]  = value;
      } return that;
    },
    some: function some(callbackfn /*, thisArg */){
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn){
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end){
      var O      = validate(this)
        , length = O.length
        , $begin = toIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end){
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /*, offset */){
    validate(this);
    var offset = toOffset(arguments[1], 1)
      , length = this.length
      , src    = toObject(arrayLike)
      , len    = toLength(src.length)
      , index  = 0;
    if(len + offset > length)throw RangeError(WRONG_LENGTH);
    while(index < len)this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries(){
      return arrayEntries.call(validate(this));
    },
    keys: function keys(){
      return arrayKeys.call(validate(this));
    },
    values: function values(){
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function(target, key){
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key){
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc){
    if(isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ){
      target[key] = desc.value;
      return target;
    } else return dP(target, key, desc);
  };

  if(!ALL_CONSTRUCTORS){
    $GOPD.f = $getDesc;
    $DP.f   = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty:           $setDesc
  });

  if(fails(function(){ arrayToString.call({}); })){
    arrayToString = arrayToLocaleString = function toString(){
      return arrayJoin.call(this);
    }
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice:          $slice,
    set:            $set,
    constructor:    function(){ /* noop */ },
    toString:       arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function(){ return this[TYPED_ARRAY]; }
  });

  module.exports = function(KEY, BYTES, wrapper, CLAMPED){
    CLAMPED = !!CLAMPED;
    var NAME       = KEY + (CLAMPED ? 'Clamped' : '') + 'Array'
      , ISNT_UINT8 = NAME != 'Uint8Array'
      , GETTER     = 'get' + KEY
      , SETTER     = 'set' + KEY
      , TypedArray = global[NAME]
      , Base       = TypedArray || {}
      , TAC        = TypedArray && getPrototypeOf(TypedArray)
      , FORCED     = !TypedArray || !$typed.ABV
      , O          = {}
      , TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function(that, index){
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function(that, index, value){
      var data = that._d;
      if(CLAMPED)value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function(that, index){
      dP(that, index, {
        get: function(){
          return getter(this, index);
        },
        set: function(value){
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if(FORCED){
      TypedArray = wrapper(function(that, data, $offset, $length){
        anInstance(that, TypedArray, NAME, '_d');
        var index  = 0
          , offset = 0
          , buffer, byteLength, length, klass;
        if(!isObject(data)){
          length     = strictToLength(data, true)
          byteLength = length * BYTES;
          buffer     = new $ArrayBuffer(byteLength);
        } else if(data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER){
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if($length === undefined){
            if($len % BYTES)throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if(byteLength < 0)throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if(byteLength + offset > $len)throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if(TYPED_ARRAY in data){
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while(index < length)addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if(!$iterDetect(function(iter){
      // V8 works with iterators, but fails in many other cases
      // https://code.google.com/p/v8/issues/detail?id=4552
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)){
      TypedArray = wrapper(function(that, data, $offset, $length){
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if(!isObject(data))return new Base(strictToLength(data, ISNT_UINT8));
        if(data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER){
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if(TYPED_ARRAY in data)return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function(key){
        if(!(key in TypedArray))hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if(!LIBRARY)TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator   = TypedArrayPrototype[ITERATOR]
      , CORRECT_ITER_NAME = !!$nativeIterator && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined)
      , $iterator         = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if(CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)){
      dP(TypedArrayPrototype, TAG, {
        get: function(){ return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES,
      from: $from,
      of: $of
    });

    if(!(BYTES_PER_ELEMENT in TypedArrayPrototype))hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, {set: $set});

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    $export($export.P + $export.F * (TypedArrayPrototype.toString != arrayToString), NAME, {toString: arrayToString});

    $export($export.P + $export.F * fails(function(){
      new TypedArray(1).slice();
    }), NAME, {slice: $slice});

    $export($export.P + $export.F * (fails(function(){
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString()
    }) || !fails(function(){
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, {toLocaleString: $toLocaleString});

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if(!LIBRARY && !CORRECT_ITER_NAME)hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function(){ /* empty */ };

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var React = __webpack_require__(15);
var factory = __webpack_require__(958);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 92 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DISMISSED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CANCELLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ModalBase; });
/* unused harmony export SimpleModalContent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Modal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MobileModal; });
/* unused harmony export getModalPromise */
/* harmony export (immutable) */ __webpack_exports__["e"] = isClose;
/* harmony export (immutable) */ __webpack_exports__["c"] = closeCatcher;
/* harmony export (immutable) */ __webpack_exports__["b"] = openModal;
/* harmony export (immutable) */ __webpack_exports__["i"] = openDangerModal;
/* harmony export (immutable) */ __webpack_exports__["d"] = openIFrameModal;
/* harmony export (immutable) */ __webpack_exports__["a"] = closeModal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_symbol__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_utils_memoized_partial__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_shared_utils_wix_sdk__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_shared_utils_pubsub__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_shared_constants_modal_types__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_shared_constants_device_types__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__header_header__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__header_header_mobile__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_shared_components_button_button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_mobile_overlay_components_fixed_in_iframe_fixed_in_iframe__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_shared_constants_events__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__modal_styl__ = __webpack_require__(1219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__modal_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__modal_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__modal_mobile_styl__ = __webpack_require__(1485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__modal_mobile_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__modal_mobile_styl__);











var _desc, _value, _class, _class2, _temp2, _dec, _class3, _class4, _temp3, _dec2, _class5, _class6, _temp4;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}






















var closeOnOverlayClick = false;
var DISMISSED = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_symbol___default()('dismissed');
var CANCELLED = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_symbol___default()('cancelled');

var ModalBase = (_class = (_temp2 = _class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits___default()(ModalBase, _React$Component);

  function ModalBase() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, ModalBase);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = ModalBase.__proto__ || __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default()(ModalBase)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false,
      closeOnOverlayClick: closeOnOverlayClick,
      title: null,
      content: null
    }, _temp), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(ModalBase, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.openModalUnsubscribe = __WEBPACK_IMPORTED_MODULE_15_shared_utils_pubsub__["a" /* default */].subscribe(__WEBPACK_IMPORTED_MODULE_22_shared_constants_events__["a" /* default */].MODAL.OPEN, this.openModal);
      this.closeModalUnsubscribe = __WEBPACK_IMPORTED_MODULE_15_shared_utils_pubsub__["a" /* default */].subscribe(__WEBPACK_IMPORTED_MODULE_22_shared_constants_events__["a" /* default */].MODAL.CLOSE, this.closeModal);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.openModalUnsubscribe();
      this.closeModalUnsubscribe();
    }
  }, {
    key: 'openModal',
    value: function openModal(config) {
      var _this2 = this;

      this.setState(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
        title: null,
        content: null,
        Header: __WEBPACK_IMPORTED_MODULE_18__header_header__["a" /* default */],
        closeOnOverlayClick: closeOnOverlayClick,
        className: '',
        windowClassName: '',
        contentClassName: '',
        buttonsClassName: '',
        buttons: {}, // {primary: {label, onClick, Button}, secondary: {...}}

        resolve: _.noop,
        reject: _.noop,

        modalType: __WEBPACK_IMPORTED_MODULE_16_shared_constants_modal_types__["a" /* default */].POPUP,
        noCloseButton: false
      }, config));

      setTimeout(function () {
        _this2.setState({
          open: true
        });
      }, 0);
    }
  }, {
    key: 'closeModal',
    value: function closeModal() {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this3.setState({ open: false }, function () {
          setTimeout(function () {
            _this3.setState({ content: null }, resolve);
          }, 200);
        });
      });
    }
  }, {
    key: 'handleBackdropClick',
    value: function handleBackdropClick() {
      var closeOnOverlayClick = this.state.closeOnOverlayClick;

      if (closeOnOverlayClick) {
        this.$modal.dismiss();
      }
    }
  }, {
    key: 'handleCloseButtonClick',
    value: function handleCloseButtonClick() {
      this.$modal.dismiss();
    }
  }, {
    key: 'stopEventPropagation',
    value: function stopEventPropagation(event) {
      event.stopPropagation();
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }, {
    key: '$modal',
    get: function get() {
      var _this4 = this;

      var _state = this.state,
          _resolve = _state.resolve,
          _reject = _state.reject;


      return {
        resolve: function resolve(data) {
          _resolve({ data: data, $modal: _this4.$modal });
        },
        reject: function reject() {
          var reason = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DISMISSED;

          _reject(reason);
        },

        close: function close(data) {
          _this4.closeModal().then(function () {
            return _resolve(data);
          });
        },
        dismiss: function dismiss() {
          var reason = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DISMISSED;

          _this4.closeModal().then(function () {
            return _reject(reason);
          });
        }
      };
    }
  }]);

  return ModalBase;
}(React.Component), _class2.propTypes = {
  title: React.PropTypes.any,
  content: React.PropTypes.any,
  className: React.PropTypes.string,
  windowClassName: React.PropTypes.string,
  contentClassName: React.PropTypes.string,
  buttonsClassName: React.PropTypes.string,
  closeOnOverlayClick: React.PropTypes.bool
}, _class2.defaultProps = {
  closeOnOverlayClick: closeOnOverlayClick
}, _temp2), (_applyDecoratedDescriptor(_class.prototype, 'openModal', [__WEBPACK_IMPORTED_MODULE_10_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'openModal'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'closeModal', [__WEBPACK_IMPORTED_MODULE_10_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'closeModal'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleBackdropClick', [__WEBPACK_IMPORTED_MODULE_10_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'handleBackdropClick'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleCloseButtonClick', [__WEBPACK_IMPORTED_MODULE_10_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'handleCloseButtonClick'), _class.prototype)), _class);

var SimpleModalContent = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_shared_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_23__modal_styl___default.a), _dec(_class3 = (_temp3 = _class4 = function (_React$Component2) {
  __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits___default()(SimpleModalContent, _React$Component2);

  function SimpleModalContent() {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, SimpleModalContent);

    return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SimpleModalContent.__proto__ || __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default()(SimpleModalContent)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(SimpleModalContent, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { styleName: 'simple-modal-content' },
        this.props.children
      );
    }
  }]);

  return SimpleModalContent;
}(React.Component), _class4.propTypes = {
  children: React.PropTypes.any
}, _temp3)) || _class3);

var Modal = (_dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_shared_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_23__modal_styl___default.a), _dec2(_class5 = (_temp4 = _class6 = function (_ModalBase) {
  __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits___default()(Modal, _ModalBase);

  function Modal() {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, Modal);

    return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Modal.__proto__ || __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default()(Modal)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(Modal, [{
    key: 'render',
    value: function render() {
      var _state2 = this.state,
          open = _state2.open,
          content = _state2.content,
          modalType = _state2.modalType;


      if (modalType !== __WEBPACK_IMPORTED_MODULE_16_shared_constants_modal_types__["a" /* default */].POPUP) {
        return null;
      }

      if (!open && !content) {
        return null;
      }

      var _state3 = this.state,
          InheritHeader = _state3.Header,
          title = _state3.title,
          className = _state3.className,
          windowClassName = _state3.windowClassName,
          contentClassName = _state3.contentClassName;


      var styleNames = __WEBPACK_IMPORTED_MODULE_11_classnames___default()('modal', {
        open: open && content
      });

      return React.createElement(
        'div',
        { styleName: styleNames,
          className: className,
          onClick: this.handleBackdropClick },
        React.createElement(
          'div',
          { styleName: 'window',
            className: windowClassName,
            onClick: this.stopEventPropagation },
          InheritHeader && React.createElement(InheritHeader, { title: title,
            onButtonClick: this.handleCloseButtonClick }),
          React.createElement(
            'section',
            { styleName: 'content',
              className: contentClassName },
            React.cloneElement(content, { $modal: this.$modal })
          ),
          this.buttons
        )
      );
    }
  }, {
    key: 'buttons',
    get: function get() {
      var _this7 = this;

      var _state4 = this.state,
          buttons = _state4.buttons,
          buttonsClassName = _state4.buttonsClassName;


      if (!_.keys(buttons).length) {
        return null;
      }

      return React.createElement(
        'div',
        { styleName: 'buttons',
          className: buttonsClassName },
        _.map(buttons, function (_ref2, key) {
          var Button = _ref2.Button,
              label = _ref2.label,
              onClick = _ref2.onClick;
          return React.createElement(Button, { key: key,
            label: label,
            onClick: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_shared_utils_memoized_partial__["a" /* default */])(onClick, _this7.$modal),
            styleName: 'button' });
        })
      );
    }
  }]);

  return Modal;
}(ModalBase), _class6.displayName = 'Modal', _temp4)) || _class5);



var MobileModal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_shared_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_24__modal_mobile_styl___default.a)(function (props) {
  return React.createElement(
    __WEBPACK_IMPORTED_MODULE_21_mobile_overlay_components_fixed_in_iframe_fixed_in_iframe__["a" /* default */],
    { styleName: 'fixed-iframe' },
    React.createElement(Modal, props)
  );
});

function injectButtonComponentsIntoConfig(config, buttonComponents) {
  var buttons = config.buttons;


  buttons = _.mapValues(buttons, function (value, key) {
    if (value.Button) {
      return value;
    }

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, value, { Button: buttonComponents[key] });
  });

  return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, config, { buttons: buttons });
}

var modalPromise = void 0;
function getModalPromise() {
  return modalPromise;
}

function isClose(reason) {
  return reason === DISMISSED;
}

function closeCatcher(reason) {
  if (isClose(reason)) {
    return;
  }
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(reason);
}

function openModal(config) {
  config = injectButtonComponentsIntoConfig(config, {
    primary: __WEBPACK_IMPORTED_MODULE_20_shared_components_button_button__["a" /* PrimaryButton */],
    secondary: __WEBPACK_IMPORTED_MODULE_20_shared_components_button_button__["b" /* SecondaryButton */]
  });

  if (__WEBPACK_IMPORTED_MODULE_14_shared_utils_wix_sdk__["a" /* default */].Utils.getDeviceType() === __WEBPACK_IMPORTED_MODULE_17_shared_constants_device_types__["a" /* default */].MOBILE) {
    config = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
      Header: __WEBPACK_IMPORTED_MODULE_19__header_header_mobile__["a" /* default */],
      className: __WEBPACK_IMPORTED_MODULE_24__modal_mobile_styl___default.a['modal-mobile'],
      windowClassName: __WEBPACK_IMPORTED_MODULE_24__modal_mobile_styl___default.a['modal-mobile-window'],
      contentClassName: __WEBPACK_IMPORTED_MODULE_24__modal_mobile_styl___default.a['modal-mobile-content'],
      closeOnOverlayClick: true
    }, config);
  }

  modalPromise = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_15_shared_utils_pubsub__["a" /* default */].publish(__WEBPACK_IMPORTED_MODULE_22_shared_constants_events__["a" /* default */].MODAL.OPEN, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, config, {
      resolve: resolve,
      reject: reject
    }));
  });

  return modalPromise;
}

function openDangerModal(config) {
  config = injectButtonComponentsIntoConfig(config, {
    primary: __WEBPACK_IMPORTED_MODULE_20_shared_components_button_button__["c" /* DangerPrimaryButton */],
    secondary: __WEBPACK_IMPORTED_MODULE_20_shared_components_button_button__["d" /* DangerSecondaryButton */]
  });

  return openModal(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, config, {
    Header: __WEBPACK_IMPORTED_MODULE_18__header_header__["b" /* DangerModalHeader */]
  }));
}

function openIFrameModal(url) {
  var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var windowClassName = _ref3.windowClassName,
      contentClassName = _ref3.contentClassName,
      otherConfig = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_ref3, ['windowClassName', 'contentClassName']);

  return openModal(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, otherConfig, {
    windowClassName: __WEBPACK_IMPORTED_MODULE_11_classnames___default()(__WEBPACK_IMPORTED_MODULE_23__modal_styl___default.a['iframe-modal-window'], windowClassName),
    contentClassName: __WEBPACK_IMPORTED_MODULE_11_classnames___default()(__WEBPACK_IMPORTED_MODULE_23__modal_styl___default.a['iframe-modal-content'], contentClassName),
    Header: __WEBPACK_IMPORTED_MODULE_18__header_header__["c" /* IFrameModalHeader */],
    content: React.createElement(
      SimpleModalContent,
      null,
      React.createElement('iframe', { src: url,
        className: __WEBPACK_IMPORTED_MODULE_23__modal_styl___default.a.iframe })
    )
  }));
}

function closeModal() {
  __WEBPACK_IMPORTED_MODULE_15_shared_utils_pubsub__["a" /* default */].publish(__WEBPACK_IMPORTED_MODULE_22_shared_constants_events__["a" /* default */].MODAL.CLOSE);
}

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isForMemberOnly */
/* harmony export (immutable) */ __webpack_exports__["b"] = canAccessFullVideo;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FULL_ACCESS_ACTION_NAMES; });
/* harmony export (immutable) */ __webpack_exports__["d"] = getFullAccessActionName;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return AVAILABLE_VIDEO_TYPES; });
/* harmony export (immutable) */ __webpack_exports__["f"] = getAvailableVideoType;
/* harmony export (immutable) */ __webpack_exports__["a"] = canPlayFullOrPreview;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_ui_selectors_video_pricing__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_ui_selectors_channel_pricing__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_constants_preview_types__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_ui_selectors_video_preview__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__channel_access__ = __webpack_require__(1291);






function isLoggedIn(currentSiteUser) {
  return !_.isEmpty(currentSiteUser);
}

function isForMemberOnly(video) {
  return Boolean(video.memberOnly);
}

function canAccessFullVideo(channel, video, currentSiteUser) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_ui_selectors_video_pricing__["c" /* isFree */])(video) && (!isForMemberOnly(video) || isLoggedIn(currentSiteUser)) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_ui_selectors_video_pricing__["a" /* isRented */])(video) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_ui_selectors_video_pricing__["b" /* isBought */])(video) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__channel_access__["a" /* canAccessChannelWithSubscription */])(channel);
}

// What user need to do to get access to full video
var FULL_ACCESS_ACTION_NAMES = {
  SIGN_IN: 'needs-sign-in',
  SUBSCRIBE: 'needs-subscription',
  BUY: 'need-to-buy',
  RENT: 'need-to-rent',
  BUY_OR_RENT: 'need-to-buy-or-rent'
};

function getFullAccessActionName(channel, video, currentSiteUser) {
  if (canAccessFullVideo(channel, video, currentSiteUser)) {
    return null;
  }

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_ui_selectors_video_pricing__["c" /* isFree */])(video) && isForMemberOnly(video)) {
    return FULL_ACCESS_ACTION_NAMES.SIGN_IN;
  }

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_ui_selectors_channel_pricing__["a" /* isSubscriptionEnabled */])(channel) && channel.subscriptionOnly) {
    return FULL_ACCESS_ACTION_NAMES.SUBSCRIBE;
  }

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_ui_selectors_video_pricing__["d" /* isRentEnabled */])(video) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_ui_selectors_video_pricing__["e" /* isSaleEnabled */])(video)) {
    return FULL_ACCESS_ACTION_NAMES.BUY_OR_RENT;
  }

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_ui_selectors_video_pricing__["d" /* isRentEnabled */])(video)) {
    return FULL_ACCESS_ACTION_NAMES.RENT;
  }

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_ui_selectors_video_pricing__["e" /* isSaleEnabled */])(video)) {
    return FULL_ACCESS_ACTION_NAMES.BUY;
  }
}

var AVAILABLE_VIDEO_TYPES = {
  FULL: 'full-video',
  TRAILER: 'trailer',
  FIRST_20_SEC: 'preview'
};

function getAvailableVideoType(channel, video, currentSiteUser) {
  if (canAccessFullVideo(channel, video, currentSiteUser)) {
    return AVAILABLE_VIDEO_TYPES.FULL;
  }

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_ui_selectors_video_pricing__["c" /* isFree */])(video) && isForMemberOnly(video)) {
    return;
  }

  var previewType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_ui_selectors_video_preview__["a" /* getPreviewType */])(video);
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_ui_selectors_video_preview__["b" /* hasTrailer */])(video) && previewType === __WEBPACK_IMPORTED_MODULE_2_shared_constants_preview_types__["a" /* previewTypes */].TRAILER) {
    return AVAILABLE_VIDEO_TYPES.TRAILER;
  }

  if (previewType === __WEBPACK_IMPORTED_MODULE_2_shared_constants_preview_types__["a" /* previewTypes */].FIRST_20_SEC) {
    return AVAILABLE_VIDEO_TYPES.FIRST_20_SEC;
  }
}

function canPlayFullOrPreview(channel, video, currentSiteUser) {
  return Boolean(getAvailableVideoType(channel, video, currentSiteUser));
}

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_web_bi_logger__ = __webpack_require__(1181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_web_bi_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_web_bi_logger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_utils_attempt__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_bi_events__ = __webpack_require__(1190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_bi_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shared_bi_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_bi_user_transactions__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bi_vod__ = __webpack_require__(262);
/* global ENV_CONFIG */






var WixSDK = window.Wix;

var VOD_SRC_ID = 71;

var knownEvents = _.mapValues(__WEBPACK_IMPORTED_MODULE_2_shared_bi_events___default.a, function (evid) {
  return { evid: evid };
});

var defaults = {
  src: VOD_SRC_ID,
  biToken: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_utils_attempt__["a" /* attempt */])(function () {
    return WixSDK.Utils.getInstanceValue('biToken');
  }), // same as sid, but we use biToken everywhere
  videoInstanceID: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_utils_attempt__["a" /* attempt */])(function () {
    return WixSDK.Utils.getInstanceId();
  }),
  compId: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_utils_attempt__["a" /* attempt */])(function () {
    return WixSDK.Utils.getOrigCompId();
  }) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_utils_attempt__["a" /* attempt */])(function () {
    return WixSDK.Utils.getCompId();
  })
};

var biFactory = __WEBPACK_IMPORTED_MODULE_0_web_bi_logger___default.a.factory({ endpoint: 'video' }).setDefaults(defaults).setEvents(knownEvents);

if ({"disableBi":false,"logBiSend":false}.disableBi) {
  biFactory._publishers.splice(0, 1);
}

if ({"disableBi":false,"logBiSend":false}.logBiSend) {
  biFactory.addPublisher(function (event) {
    console.warn('bi:', _.findKey(knownEvents, { evid: event.evid }), event); // eslint-disable-line no-console
  });
}

var biLoggerInstance = biFactory.logger();

/*
  @param eventName
  @param options
  @param options.previousEventName - use this one for transactions, aka:
  if @previousEventName is set to 'widget.show.requested' event will not fire if previousEvent was not fired yet.
  there is a contract on transaction starting events to end with '.requested'
 */
biLoggerInstance.logWidgetSystem = function (eventName) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      previousEventName = _ref.previousEventName;

  if (__WEBPACK_IMPORTED_MODULE_3_shared_bi_user_transactions__["a" /* default */].isTransaction({ eventName: eventName, previousEventName: previousEventName })) {
    var shouldSendEvent = __WEBPACK_IMPORTED_MODULE_3_shared_bi_user_transactions__["a" /* default */].getTransactionResult({ eventName: eventName });
    if (!shouldSendEvent) {
      return;
    }
  }

  biLoggerInstance.log('widget-system', {
    eventName: eventName,
    visitorID: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__bi_vod__["c" /* getVisitorId */])()
  });
};

/* harmony default export */ __webpack_exports__["a"] = (biLoggerInstance);

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_object__ = __webpack_require__(51);



function AdapterError(status, url, error) {
  this.status = status;
  this.error = error;
  this.url = url;
  this.name = this.constructor.name;
}

AdapterError.prototype = _.create(Error.prototype);

function getUrl(response) {
  var urlFromWixMP = _.get(response, 'config.url');
  return urlFromWixMP || response.url;
}

function toError() {
  var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (response instanceof AdapterError) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
  }

  var code = response.code,
      status = response.status,
      _response$data = response.data,
      data = _response$data === undefined ? {} : _response$data,
      message = response.message;

  var url = getUrl(response);

  var dataWithCamelCase = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_object__["keysToCamelCase"])(data);
  var errorCode = dataWithCamelCase.errorCode,
      _dataWithCamelCase$er = dataWithCamelCase.errorDescription,
      errorDescription = _dataWithCamelCase$er === undefined ? message : _dataWithCamelCase$er;


  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new AdapterError(status || code, url, {
    code: errorCode,
    data: dataWithCamelCase,
    message: errorDescription
  }));
}

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(275);
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var dP         = __webpack_require__(73)
  , createDesc = __webpack_require__(171);
module.exports = __webpack_require__(77) ? function(object, key, value){
  return dP.f(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(279)
  , defined = __webpack_require__(209);
module.exports = function(it){
  return IObject(defined(it));
};

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var META     = __webpack_require__(127)('meta')
  , isObject = __webpack_require__(28)
  , has      = __webpack_require__(52)
  , setDesc  = __webpack_require__(33).f
  , id       = 0;
var isExtensible = Object.isExtensible || function(){
  return true;
};
var FREEZE = !__webpack_require__(24)(function(){
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function(it){
  setDesc(it, META, {value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  }});
};
var fastKey = function(it, create){
  // return primitive with prefix
  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return 'F';
    // not necessary to add metadata
    if(!create)return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function(it, create){
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return true;
    // not necessary to add metadata
    if(!create)return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function(it){
  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY:      META,
  NEED:     false,
  fastKey:  fastKey,
  getWeak:  getWeak,
  onFreeze: onFreeze
};

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};

/***/ }),
/* 103 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil  = Math.ceil
  , floor = Math.floor;
module.exports = function(it){
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;

var _warning = __webpack_require__(109);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
  var _parsePath = parsePath(path),
      pathname = _parsePath.pathname,
      search = _parsePath.search,
      hash = _parsePath.hash;

  return createPath({
    pathname: pathname,
    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
    hash: hash
  });
};

var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
  var _parsePath2 = parsePath(path),
      pathname = _parsePath2.pathname,
      search = _parsePath2.search,
      hash = _parsePath2.hash;

  return createPath({
    pathname: pathname,
    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
      return prefix === '?' ? prefix : suffix;
    }),
    hash: hash
  });
};

var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
  var _parsePath3 = parsePath(path),
      search = _parsePath3.search;

  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
  return match && match[1];
};

var extractPath = function extractPath(string) {
  var match = string.match(/^(https?:)?\/\/[^\/]*/);
  return match == null ? string : string.substring(match[0].length);
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = extractPath(path);
  var search = '';
  var hash = '';

   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substring(hashIndex);
    pathname = pathname.substring(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substring(searchIndex);
    pathname = pathname.substring(0, searchIndex);
  }

  if (pathname === '') pathname = '/';

  return {
    pathname: pathname,
    search: search,
    hash: hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  if (location == null || typeof location === 'string') return location;

  var basename = location.basename,
      pathname = location.pathname,
      search = location.search,
      hash = location.hash;

  var path = (basename || '') + pathname;

  if (search && search !== '?') path += search;

  if (hash) path += hash;

  return path;
};

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(184),
    getRawTag = __webpack_require__(1052),
    objectToString = __webpack_require__(1081);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(107),
    isLength = __webpack_require__(341);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(105),
    isObject = __webpack_require__(41);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isReactChildren;
/* harmony export (immutable) */ __webpack_exports__["c"] = createRouteFromReactElement;
/* unused harmony export createRoutesFromReactChildren */
/* harmony export (immutable) */ __webpack_exports__["b"] = createRoutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function isValidChild(object) {
  return object == null || __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(object);
}

function isReactChildren(object) {
  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
}

function createRoute(defaultProps, props) {
  return _extends({}, defaultProps, props);
}

function createRouteFromReactElement(element) {
  var type = element.type;
  var route = createRoute(type.defaultProps, element.props);

  if (route.children) {
    var childRoutes = createRoutesFromReactChildren(route.children, route);

    if (childRoutes.length) route.childRoutes = childRoutes;

    delete route.children;
  }

  return route;
}

/**
 * Creates and returns a routes object from the given ReactChildren. JSX
 * provides a convenient way to visualize how routes in the hierarchy are
 * nested.
 *
 *   import { Route, createRoutesFromReactChildren } from 'react-router'
 *
 *   const routes = createRoutesFromReactChildren(
 *     <Route component={App}>
 *       <Route path="home" component={Dashboard}/>
 *       <Route path="news" component={NewsFeed}/>
 *     </Route>
 *   )
 *
 * Note: This method is automatically used when you provide <Route> children
 * to a <Router> component.
 */
function createRoutesFromReactChildren(children, parentRoute) {
  var routes = [];

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
    if (__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
      // Component classes may have a static create* method.
      if (element.type.createRouteFromReactElement) {
        var route = element.type.createRouteFromReactElement(element, parentRoute);

        if (route) routes.push(route);
      } else {
        routes.push(createRouteFromReactElement(element));
      }
    }
  });

  return routes;
}

/**
 * Creates and returns an array of routes from the given object which
 * may be a JSX route, a plain object route, or an array of either.
 */
function createRoutes(routes) {
  if (isReactChildren(routes)) {
    routes = createRoutesFromReactChildren(routes);
  } else if (routes && !Array.isArray(routes)) {
    routes = [routes];
  }

  return routes;
}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  hosts: {"catalog":"//vod.wix.com/","files":"//vod-meta.wix.com/","image":"//images-vod.wixmp.com/","video":"//storage.googleapis.com/wixmp-vod/","paypal":"//dgs.wixapps.net/","statsQuery":"//vod.wix.com/","statsCollector":"//video-counters.wix.com"}
});

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @class
 * @ignore
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Error = function Error(code, message, data) {
  _classCallCheck(this, Error);

  this.code = code || null;
  this.message = message || null;
  this.data = data || null;
};

exports["default"] = Error;
module.exports = exports["default"];
//# sourceMappingURL=Error.js.map


/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isExternalVideo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isVideoFromComputer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_constants_video_sources__ = __webpack_require__(114);


var isExternalVideo = function isExternalVideo(video) {
  return Boolean(video.mediaExternUrl);
};
var isVideoFromComputer = function isVideoFromComputer(_ref) {
  var videoSource = _ref.videoSource;
  return videoSource === __WEBPACK_IMPORTED_MODULE_0_shared_constants_video_sources__["a" /* default */].COMPUTER;
};

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResizedImage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_utils_wix_sdk__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_widget_utils_normalize_image_dimensions__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__resized_image_styl__ = __webpack_require__(1174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__resized_image_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__resized_image_styl__);










var _dec, _class, _desc, _value, _class2, _class3, _temp2;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}










var ResizedImage = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_13__resized_image_styl___default.a), _dec(_class = (_class2 = (_temp2 = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits___default()(ResizedImage, _React$Component);

  function ResizedImage() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, ResizedImage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = ResizedImage.__proto__ || __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default()(ResizedImage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      resizedThumbnailUrl: null
    }, _this.preloadImagePromise = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.resolve(), _this.lastLoadedImage = null, _this.preloadTimeout = null, _temp), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(ResizedImage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.replaceResizedImage(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.replaceResizedImage(nextProps);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.preloadTimeout);
    }
  }, {
    key: 'replaceResizedImage',
    value: function replaceResizedImage(_ref2) {
      var _WixSDK$Utils$Media,
          _this2 = this;

      var src = _ref2.src,
          width = _ref2.width,
          height = _ref2.height,
          params = _ref2.params;

      var dimensions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_widget_utils_normalize_image_dimensions__["a" /* getNormalizedCachedDimensions */])(src, {
        containerWidth: width,
        containerHeight: height
      });

      var url = (_WixSDK$Utils$Media = __WEBPACK_IMPORTED_MODULE_11_shared_utils_wix_sdk__["a" /* default */].Utils.Media).getResizedImageUrl.apply(_WixSDK$Utils$Media, [src].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(dimensions), [params]));

      if (this.lastLoadedImage === url) {
        return;
      }

      this.lastLoadedImage = url;

      clearTimeout(this.preloadTimeout);

      // to avoid unnecessary requests, because of channel cover rendered initially,
      // and only after it removed we got video cover loading.
      this.preloadTimeout = setTimeout(function () {
        _this2.preloadImagePromise.then(function () {
          return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
            var image = new Image();
            image.onload = function () {
              return resolve(url);
            };
            image.src = url;
          });
        }).then(function (loadedImageUrl) {
          if (!_this2.resizedImageRef) {
            return;
          }
          _this2.setState({ resizedThumbnailUrl: loadedImageUrl });
        });
      });
    }
  }, {
    key: 'handleRefUpdate',
    value: function handleRefUpdate(resizedImageRef) {
      this.resizedImageRef = resizedImageRef;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          width = _props.width,
          height = _props.height,
          style = _props.style,
          children = _props.children;


      var styles = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
        width: width,
        height: height
      }, style);

      var resizedThumbnailUrl = this.state.resizedThumbnailUrl;


      if (resizedThumbnailUrl) {
        styles.backgroundImage = 'url(' + resizedThumbnailUrl + ')';
      }

      return React.createElement(
        'div',
        { styleName: 'resized-image',
          className: className,
          style: styles,
          ref: this.handleRefUpdate },
        children
      );
    }
  }]);

  return ResizedImage;
}(React.Component), _class3.propTypes = {
  src: React.PropTypes.string,
  width: React.PropTypes.number,
  height: React.PropTypes.number,
  params: React.PropTypes.object,
  style: React.PropTypes.object,
  className: React.PropTypes.string,
  children: React.PropTypes.any
}, _class3.defaultProps = {
  params: {},
  style: {}
}, _temp2), (_applyDecoratedDescriptor(_class2.prototype, 'handleRefUpdate', [__WEBPACK_IMPORTED_MODULE_9_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handleRefUpdate'), _class2.prototype)), _class2)) || _class);


/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return externalVideoSources; });
var videoSources = {
  COMPUTER: 'computer',
  DROPBOX: 'dropbox',
  GOOGLE_DRIVE: 'drive',
  YOUTUBE: 'youtube',
  VIMEO: 'vimeo',
  FACEBOOK: 'facebook'
};

var externalVideoSources = [videoSources.YOUTUBE, videoSources.VIMEO, videoSources.FACEBOOK];

/* harmony default export */ __webpack_exports__["a"] = (videoSources);

/***/ }),
/* 115 */,
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  IN_QUEUE: 'IN-QUEUE',
  PENDING: 'PENDING',
  INPROGRESS: 'INPROGRESS',
  PREVIEW_READY: 'PREVIEW_READY',
  READY: 'READY',
  FAILED: 'FAILED',
  NONE: 'NONE'
});

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};

/***/ }),
/* 118 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};

/***/ }),
/* 119 */
/***/ (function(module, exports) {

module.exports = function(it, Constructor, name, forbiddenField){
  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports = false;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject    = __webpack_require__(20)
  , dPs         = __webpack_require__(467)
  , enumBugKeys = __webpack_require__(296)
  , IE_PROTO    = __webpack_require__(308)('IE_PROTO')
  , Empty       = function(){ /* empty */ }
  , PROTOTYPE   = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function(){
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(295)('iframe')
    , i      = enumBugKeys.length
    , lt     = '<'
    , gt     = '>'
    , iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(298).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties){
  var result;
  if(O !== null){
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty;
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys      = __webpack_require__(469)
  , hiddenKeys = __webpack_require__(296).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
  return $keys(O, hiddenKeys);
};

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys       = __webpack_require__(469)
  , enumBugKeys = __webpack_require__(296);

module.exports = Object.keys || function keys(O){
  return $keys(O, enumBugKeys);
};

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(58);
module.exports = function(target, src, safe){
  for(var key in src)redefine(target, key, src[key], safe);
  return target;
};

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global      = __webpack_require__(21)
  , dP          = __webpack_require__(33)
  , DESCRIPTORS = __webpack_require__(32)
  , SPECIES     = __webpack_require__(29)('species');

module.exports = function(KEY){
  var C = global[KEY];
  if(DESCRIPTORS && C && !C[SPECIES])dP.f(C, SPECIES, {
    configurable: true,
    get: function(){ return this; }
  });
};

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(103)
  , max       = Math.max
  , min       = Math.min;
module.exports = function(index, length){
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ }),
/* 127 */
/***/ (function(module, exports) {

var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var NO_CHANGE = -1;

function SwitchRequest(v, r) {
    //TODO refactor all the calls to this to use config to be like everything else.
    var value = v === undefined ? NO_CHANGE : v;
    var reason = r === undefined ? null : r;

    var instance = {
        value: value,
        reason: reason
    };

    return instance;
}

SwitchRequest.__dashjs_factory_name = 'SwitchRequest';
var factory = _coreFactoryMaker2['default'].getClassFactory(SwitchRequest);
factory.NO_CHANGE = NO_CHANGE;
exports['default'] = factory;
module.exports = exports['default'];
//# sourceMappingURL=SwitchRequest.js.map


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(1020),
    getValue = __webpack_require__(1054);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 130 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(495);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  WAITING: 'WAITING',
  UPLOADING: 'UPLOADING',
  PROCESSING: 'PROCESSING',
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED'
});

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(729), __esModule: true };

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* defineMessages */])({
  getSubscription: {
    id: 'widget.overlay-buttons.get-subscription',
    defaultMessage: 'Subscribe {price}/mo.'
  },
  getSubscriptionSmall: {
    id: 'widget.overlay-buttons.get-subscription-small',
    defaultMessage: 'Subscribe'
  },
  buyFrom: {
    id: 'widget.overlay-buttons.buy-from',
    defaultMessage: 'Buy from {price}'
  },
  buy: {
    id: 'widget.overlay-buttons.buy',
    defaultMessage: 'Buy {price}'
  },
  rent: {
    id: 'widget.overlay-buttons.rent',
    defaultMessage: 'Rent {price}'
  },
  watchPreview: {
    id: 'widget.overlay-buttons.watch-preview',
    defaultMessage: 'Watch Preview'
  },
  watchTrailer: {
    id: 'widget.overlay-buttons.watch-trailer',
    defaultMessage: 'Watch Trailer'
  },
  startWatching: {
    id: 'widget.overlay-buttons.start-watching',
    defaultMessage: 'Watch Now'
  },
  playVideo: {
    id: 'widget.overlay-buttons.play-video',
    defaultMessage: 'Play Video'
  },
  nextVideo: {
    id: 'widget.overlay-buttons.next-video',
    defaultMessage: 'Next Video'
  },
  preview: {
    id: 'widget.overlay-buttons.preview',
    defaultMessage: 'Preview'
  },
  trailer: {
    id: 'widget.overlay-buttons.trailer',
    defaultMessage: 'Trailer'
  },
  allVideos: {
    id: 'widget.overlay-buttons.all-videos',
    defaultMessage: 'All videos'
  },
  continueWatching: {
    id: 'widget.overlay-buttons.continue-watching',
    defaultMessage: 'Resume Video'
  }
}));

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _voMetricsList = __webpack_require__(1423);

var _voMetricsList2 = _interopRequireDefault(_voMetricsList);

var _voMetricsTCPConnection = __webpack_require__(1437);

var _voMetricsTCPConnection2 = _interopRequireDefault(_voMetricsTCPConnection);

var _voMetricsHTTPRequest = __webpack_require__(84);

var _voMetricsRepresentationSwitch = __webpack_require__(1434);

var _voMetricsRepresentationSwitch2 = _interopRequireDefault(_voMetricsRepresentationSwitch);

var _voMetricsBufferLevel = __webpack_require__(1429);

var _voMetricsBufferLevel2 = _interopRequireDefault(_voMetricsBufferLevel);

var _voMetricsBufferState = __webpack_require__(1430);

var _voMetricsBufferState2 = _interopRequireDefault(_voMetricsBufferState);

var _voMetricsDVRInfo = __webpack_require__(1431);

var _voMetricsDVRInfo2 = _interopRequireDefault(_voMetricsDVRInfo);

var _voMetricsDroppedFrames = __webpack_require__(1432);

var _voMetricsDroppedFrames2 = _interopRequireDefault(_voMetricsDroppedFrames);

var _voMetricsManifestUpdate = __webpack_require__(1433);

var _voMetricsSchedulingInfo = __webpack_require__(1436);

var _voMetricsSchedulingInfo2 = _interopRequireDefault(_voMetricsSchedulingInfo);

var _coreEventBus = __webpack_require__(27);

var _coreEventBus2 = _interopRequireDefault(_coreEventBus);

var _voMetricsRequestsQueue = __webpack_require__(1435);

var _voMetricsRequestsQueue2 = _interopRequireDefault(_voMetricsRequestsQueue);

var _coreEventsEvents = __webpack_require__(22);

var _coreEventsEvents2 = _interopRequireDefault(_coreEventsEvents);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _voMetricsBolaState = __webpack_require__(1428);

var _voMetricsBolaState2 = _interopRequireDefault(_voMetricsBolaState);

function MetricsModel() {

    var MAXIMUM_LIST_DEPTH = 1000;

    var context = this.context;
    var eventBus = (0, _coreEventBus2['default'])(context).getInstance();

    var instance = undefined,
        adapter = undefined,
        streamMetrics = undefined;

    function setup() {
        streamMetrics = {};
    }

    function setConfig(config) {
        if (!config) return;

        if (config.adapter) {
            adapter = config.adapter;
        }
    }

    function metricsChanged() {
        eventBus.trigger(_coreEventsEvents2['default'].METRICS_CHANGED);
    }

    function metricChanged(mediaType) {
        eventBus.trigger(_coreEventsEvents2['default'].METRIC_CHANGED, { mediaType: mediaType });
        metricsChanged();
    }

    function metricUpdated(mediaType, metricType, vo) {
        eventBus.trigger(_coreEventsEvents2['default'].METRIC_UPDATED, { mediaType: mediaType, metric: metricType, value: vo });
        metricChanged(mediaType);
    }

    function metricAdded(mediaType, metricType, vo) {
        eventBus.trigger(_coreEventsEvents2['default'].METRIC_ADDED, { mediaType: mediaType, metric: metricType, value: vo });
        metricChanged(mediaType);
    }

    function clearCurrentMetricsForType(type) {
        delete streamMetrics[type];
        metricChanged(type);
    }

    function clearAllCurrentMetrics() {
        streamMetrics = {};
        metricsChanged();
    }

    function getReadOnlyMetricsFor(type) {
        if (streamMetrics.hasOwnProperty(type)) {
            return streamMetrics[type];
        }

        return null;
    }

    function getMetricsFor(type) {
        var metrics;

        if (streamMetrics.hasOwnProperty(type)) {
            metrics = streamMetrics[type];
        } else {
            metrics = new _voMetricsList2['default']();
            streamMetrics[type] = metrics;
        }

        return metrics;
    }

    function pushMetrics(type, list, value) {
        var metrics = getMetricsFor(type);
        metrics[list].push(value);
        if (metrics[list].length > MAXIMUM_LIST_DEPTH) {
            metrics[list].shift();
        }
    }

    function addTcpConnection(mediaType, tcpid, dest, topen, tclose, tconnect) {
        var vo = new _voMetricsTCPConnection2['default']();

        vo.tcpid = tcpid;
        vo.dest = dest;
        vo.topen = topen;
        vo.tclose = tclose;
        vo.tconnect = tconnect;

        pushAndNotify(mediaType, adapter.metricsList.TCP_CONNECTION, vo);

        return vo;
    }

    function appendHttpTrace(httpRequest, s, d, b) {
        var vo = new _voMetricsHTTPRequest.HTTPRequestTrace();

        vo.s = s;
        vo.d = d;
        vo.b = b;

        httpRequest.trace.push(vo);

        if (!httpRequest.interval) {
            httpRequest.interval = 0;
        }

        httpRequest.interval += d;

        return vo;
    }

    function addHttpRequest(mediaType, tcpid, type, url, actualurl, serviceLocation, range, trequest, tresponse, tfinish, responsecode, mediaduration, responseHeaders, traces) {
        var vo = new _voMetricsHTTPRequest.HTTPRequest();

        // ISO 23009-1 D.4.3 NOTE 2:
        // All entries for a given object will have the same URL and range
        // and so can easily be correlated. If there were redirects or
        // failures there will be one entry for each redirect/failure.
        // The redirect-to URL or alternative url (where multiple have been
        // provided in the MPD) will appear as the actualurl of the next
        // entry with the same url value.
        if (actualurl && actualurl !== url) {

            // given the above, add an entry for the original request
            addHttpRequest(mediaType, null, type, url, null, null, range, trequest, null, // unknown
            null, // unknown
            null, // unknown, probably a 302
            mediaduration, null, null);

            vo.actualurl = actualurl;
        }

        vo.tcpid = tcpid;
        vo.type = type;
        vo.url = url;
        vo.range = range;
        vo.trequest = trequest;
        vo.tresponse = tresponse;
        vo.responsecode = responsecode;

        vo._tfinish = tfinish;
        vo._stream = mediaType;
        vo._mediaduration = mediaduration;
        vo._responseHeaders = responseHeaders;
        vo._serviceLocation = serviceLocation;

        if (traces) {
            traces.forEach(function (trace) {
                appendHttpTrace(vo, trace.s, trace.d, trace.b);
            });
        } else {
            // The interval and trace shall be absent for redirect and failure records.
            delete vo.interval;
            delete vo.trace;
        }

        pushAndNotify(mediaType, adapter.metricsList.HTTP_REQUEST, vo);

        return vo;
    }

    function addRepresentationSwitch(mediaType, t, mt, to, lto) {
        var vo = new _voMetricsRepresentationSwitch2['default']();

        vo.t = t;
        vo.mt = mt;
        vo.to = to;

        if (lto) {
            vo.lto = lto;
        } else {
            delete vo.lto;
        }

        pushAndNotify(mediaType, adapter.metricsList.TRACK_SWITCH, vo);

        return vo;
    }

    function pushAndNotify(mediaType, metricType, metricObject) {
        pushMetrics(mediaType, metricType, metricObject);
        metricAdded(mediaType, metricType, metricObject);
    }

    function addBufferLevel(mediaType, t, level) {
        var vo = new _voMetricsBufferLevel2['default']();
        vo.t = t;
        vo.level = level;

        pushAndNotify(mediaType, adapter.metricsList.BUFFER_LEVEL, vo);

        return vo;
    }

    function addBufferState(mediaType, state, target) {
        var vo = new _voMetricsBufferState2['default']();
        vo.target = target;
        vo.state = state;

        pushAndNotify(mediaType, adapter.metricsList.BUFFER_STATE, vo);

        return vo;
    }

    function addDVRInfo(mediaType, currentTime, mpd, range) {
        var vo = new _voMetricsDVRInfo2['default']();
        vo.time = currentTime;
        vo.range = range;
        vo.manifestInfo = mpd;

        pushAndNotify(mediaType, adapter.metricsList.DVR_INFO, vo);

        return vo;
    }

    function addDroppedFrames(mediaType, quality) {
        var vo = new _voMetricsDroppedFrames2['default']();
        var list = getMetricsFor(mediaType).DroppedFrames;

        vo.time = quality.creationTime;
        vo.droppedFrames = quality.droppedVideoFrames;

        if (list.length > 0 && list[list.length - 1] == vo) {
            return list[list.length - 1];
        }

        pushAndNotify(mediaType, adapter.metricsList.DROPPED_FRAMES, vo);

        return vo;
    }

    function addSchedulingInfo(mediaType, t, type, startTime, availabilityStartTime, duration, quality, range, state) {
        var vo = new _voMetricsSchedulingInfo2['default']();

        vo.mediaType = mediaType;
        vo.t = t;

        vo.type = type;
        vo.startTime = startTime;
        vo.availabilityStartTime = availabilityStartTime;
        vo.duration = duration;
        vo.quality = quality;
        vo.range = range;

        vo.state = state;

        pushAndNotify(mediaType, adapter.metricsList.SCHEDULING_INFO, vo);

        return vo;
    }

    function addRequestsQueue(mediaType, loadingRequests, executedRequests) {
        var vo = new _voMetricsRequestsQueue2['default']();
        vo.loadingRequests = loadingRequests;
        vo.executedRequests = executedRequests;

        getMetricsFor(mediaType).RequestsQueue = vo;
        metricAdded(mediaType, adapter.metricsList.REQUESTS_QUEUE, vo);
    }

    function addManifestUpdate(mediaType, type, requestTime, fetchTime, availabilityStartTime, presentationStartTime, clientTimeOffset, currentTime, buffered, latency) {
        var vo = new _voMetricsManifestUpdate.ManifestUpdate();

        vo.mediaType = mediaType;
        vo.type = type;
        vo.requestTime = requestTime; // when this manifest update was requested
        vo.fetchTime = fetchTime; // when this manifest update was received
        vo.availabilityStartTime = availabilityStartTime;
        vo.presentationStartTime = presentationStartTime; // the seek point (liveEdge for dynamic, Stream[0].startTime for static)
        vo.clientTimeOffset = clientTimeOffset; // the calculated difference between the server and client wall clock time
        vo.currentTime = currentTime; // actual element.currentTime
        vo.buffered = buffered; // actual element.ranges
        vo.latency = latency; // (static is fixed value of zero. dynamic should be ((Now-@availabilityStartTime) - currentTime)

        pushMetrics('stream', 'ManifestUpdate', vo);
        metricAdded(mediaType, adapter.metricsList.MANIFEST_UPDATE, vo);

        return vo;
    }

    function updateManifestUpdateInfo(manifestUpdate, updatedFields) {
        if (manifestUpdate) {
            for (var field in updatedFields) {
                manifestUpdate[field] = updatedFields[field];
            }

            metricUpdated(manifestUpdate.mediaType, adapter.metricsList.MANIFEST_UPDATE, manifestUpdate);
        }
    }

    function addManifestUpdateStreamInfo(manifestUpdate, id, index, start, duration) {
        if (manifestUpdate) {
            var vo = new _voMetricsManifestUpdate.ManifestUpdateStreamInfo();

            vo.id = id;
            vo.index = index;
            vo.start = start;
            vo.duration = duration;

            manifestUpdate.streamInfo.push(vo);
            metricUpdated(manifestUpdate.mediaType, adapter.metricsList.MANIFEST_UPDATE_STREAM_INFO, manifestUpdate);

            return vo;
        }
        return null;
    }

    function addManifestUpdateRepresentationInfo(manifestUpdate, id, index, streamIndex, mediaType, presentationTimeOffset, startNumber, fragmentInfoType) {
        if (manifestUpdate) {
            var vo = new _voMetricsManifestUpdate.ManifestUpdateTrackInfo();

            vo.id = id;
            vo.index = index;
            vo.streamIndex = streamIndex;
            vo.mediaType = mediaType;
            vo.startNumber = startNumber;
            vo.fragmentInfoType = fragmentInfoType;
            vo.presentationTimeOffset = presentationTimeOffset;

            manifestUpdate.trackInfo.push(vo);
            metricUpdated(manifestUpdate.mediaType, adapter.metricsList.MANIFEST_UPDATE_TRACK_INFO, manifestUpdate);

            return vo;
        }
        return null;
    }

    function addPlayList(vo) {
        var type = 'stream';

        if (vo.trace && Array.isArray(vo.trace)) {
            vo.trace.forEach(function (trace) {
                if (trace.hasOwnProperty('subreplevel') && !trace.subreplevel) {
                    delete trace.subreplevel;
                }
            });
        } else {
            delete vo.trace;
        }

        pushAndNotify(type, adapter.metricsList.PLAY_LIST, vo);

        return vo;
    }

    function addDVBErrors(vo) {
        var type = 'stream';

        pushAndNotify(type, adapter.metricsList.DVB_ERRORS, vo);

        return vo;
    }

    function updateBolaState(mediaType, _s) {
        var vo = new _voMetricsBolaState2['default']();
        vo._s = _s;
        getMetricsFor(mediaType).BolaState = [vo];

        metricAdded(mediaType, 'BolaState', vo);
        return vo;
    }

    instance = {
        metricsChanged: metricsChanged,
        metricChanged: metricChanged,
        metricUpdated: metricUpdated,
        metricAdded: metricAdded,
        clearCurrentMetricsForType: clearCurrentMetricsForType,
        clearAllCurrentMetrics: clearAllCurrentMetrics,
        getReadOnlyMetricsFor: getReadOnlyMetricsFor,
        getMetricsFor: getMetricsFor,
        addTcpConnection: addTcpConnection,
        addHttpRequest: addHttpRequest,
        addRepresentationSwitch: addRepresentationSwitch,
        addBufferLevel: addBufferLevel,
        addBufferState: addBufferState,
        addDVRInfo: addDVRInfo,
        addDroppedFrames: addDroppedFrames,
        addSchedulingInfo: addSchedulingInfo,
        addRequestsQueue: addRequestsQueue,
        addManifestUpdate: addManifestUpdate,
        updateManifestUpdateInfo: updateManifestUpdateInfo,
        addManifestUpdateStreamInfo: addManifestUpdateStreamInfo,
        addManifestUpdateRepresentationInfo: addManifestUpdateRepresentationInfo,
        addPlayList: addPlayList,
        addDVBErrors: addDVBErrors,
        updateBolaState: updateBolaState,
        setConfig: setConfig
    };

    setup();
    return instance;
}

MetricsModel.__dashjs_factory_name = 'MetricsModel';
exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(MetricsModel);
module.exports = exports['default'];
//# sourceMappingURL=MetricsModel.js.map


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreEventBus = __webpack_require__(27);

var _coreEventBus2 = _interopRequireDefault(_coreEventBus);

var _coreEventsEvents = __webpack_require__(22);

var _coreEventsEvents2 = _interopRequireDefault(_coreEventsEvents);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var CAPABILITY_ERROR_MEDIASOURCE = 'mediasource';
var CAPABILITY_ERROR_MEDIAKEYS = 'mediakeys';

var DOWNLOAD_ERROR_ID_MANIFEST = 'manifest';
var DOWNLOAD_ERROR_ID_SIDX = 'SIDX';
var DOWNLOAD_ERROR_ID_CONTENT = 'content';
var DOWNLOAD_ERROR_ID_INITIALIZATION = 'initialization';
var DOWNLOAD_ERROR_ID_XLINK = 'xlink';

var MANIFEST_ERROR_ID_CODEC = 'codec';
var MANIFEST_ERROR_ID_PARSE = 'parse';
var MANIFEST_ERROR_ID_NOSTREAMS = 'nostreams';

var TIMED_TEXT_ERROR_ID_PARSE = 'parse';

function ErrorHandler() {

    var instance = undefined;
    var context = this.context;
    var eventBus = (0, _coreEventBus2['default'])(context).getInstance();

    // "mediasource"|"mediakeys"
    function capabilityError(err) {
        eventBus.trigger(_coreEventsEvents2['default'].ERROR, { error: 'capability', event: err });
    }

    // {id: "manifest"|"SIDX"|"content"|"initialization"|"xlink", url: "", request: {XMLHttpRequest instance}}
    function downloadError(id, url, request) {
        eventBus.trigger(_coreEventsEvents2['default'].ERROR, { error: 'download', event: { id: id, url: url, request: request } });
    }

    // {message: "", id: "codec"|"parse"|"nostreams", manifest: {parsed manifest}}
    function manifestError(message, id, manifest, err) {
        eventBus.trigger(_coreEventsEvents2['default'].ERROR, { error: 'manifestError', event: { message: message, id: id, manifest: manifest, event: err } });
    }

    // {message: '', id: 'parse', cc: ''}
    function timedTextError(message, id, ccContent) {
        eventBus.trigger(_coreEventsEvents2['default'].ERROR, { error: 'cc', event: { message: message, id: id, cc: ccContent } });
    }

    function mediaSourceError(err) {
        eventBus.trigger(_coreEventsEvents2['default'].ERROR, { error: 'mediasource', event: err });
    }

    function mediaKeySessionError(err) {
        eventBus.trigger(_coreEventsEvents2['default'].ERROR, { error: 'key_session', event: err });
    }

    function mediaKeyMessageError(err) {
        eventBus.trigger(_coreEventsEvents2['default'].ERROR, { error: 'key_message', event: err });
    }

    instance = {
        capabilityError: capabilityError,
        downloadError: downloadError,
        manifestError: manifestError,
        timedTextError: timedTextError,
        mediaSourceError: mediaSourceError,
        mediaKeySessionError: mediaKeySessionError,
        mediaKeyMessageError: mediaKeyMessageError
    };

    return instance;
}

ErrorHandler.__dashjs_factory_name = 'ErrorHandler';

var factory = _coreFactoryMaker2['default'].getSingletonFactory(ErrorHandler);

factory.CAPABILITY_ERROR_MEDIASOURCE = CAPABILITY_ERROR_MEDIASOURCE;
factory.CAPABILITY_ERROR_MEDIAKEYS = CAPABILITY_ERROR_MEDIAKEYS;
factory.DOWNLOAD_ERROR_ID_MANIFEST = DOWNLOAD_ERROR_ID_MANIFEST;
factory.DOWNLOAD_ERROR_ID_SIDX = DOWNLOAD_ERROR_ID_SIDX;
factory.DOWNLOAD_ERROR_ID_CONTENT = DOWNLOAD_ERROR_ID_CONTENT;
factory.DOWNLOAD_ERROR_ID_INITIALIZATION = DOWNLOAD_ERROR_ID_INITIALIZATION;
factory.DOWNLOAD_ERROR_ID_XLINK = DOWNLOAD_ERROR_ID_XLINK;
factory.MANIFEST_ERROR_ID_CODEC = MANIFEST_ERROR_ID_CODEC;
factory.MANIFEST_ERROR_ID_PARSE = MANIFEST_ERROR_ID_PARSE;
factory.MANIFEST_ERROR_ID_NOSTREAMS = MANIFEST_ERROR_ID_NOSTREAMS;
factory.TIMED_TEXT_ERROR_ID_PARSE = TIMED_TEXT_ERROR_ID_PARSE;

exports['default'] = factory;
module.exports = exports['default'];
//# sourceMappingURL=ErrorHandler.js.map


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  VIDEO: 'video',
  CHANNEL: 'channel',
  USER_NAME: 'username',
  PLAYLIST: 'playlist'
});

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Icon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__icon_styl__ = __webpack_require__(1488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__icon_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__icon_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_widget_player_widget_fontello_css_fontello_codes_css__ = __webpack_require__(1506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_widget_player_widget_fontello_css_fontello_codes_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_widget_player_widget_fontello_css_fontello_codes_css__);








var _dec, _class, _desc, _value, _class2, _class3, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}








var Icon = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_9__icon_styl___default.a, __WEBPACK_IMPORTED_MODULE_10_widget_player_widget_fontello_css_fontello_codes_css___default.a)), _dec(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Icon, _React$Component);

  function Icon() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Icon);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Icon.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Icon)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Icon, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.node.addEventListener('click', this.props.onClick);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.node.removeEventListener('click', this.props.onClick);
    }
  }, {
    key: 'setNodeRef',
    value: function setNodeRef(node) {
      this.node = node;
    }
  }, {
    key: 'render',
    value: function render() {
      var name = this.props.name;


      var props = _.omit(this.props, 'styles', 'styleName', 'name', 'intl', 'appSettings');

      return React.createElement('span', __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({ styleName: 'icon icon--' + name,
        ref: this.setNodeRef
      }, props));
    }
  }]);

  return Icon;
}(React.Component), _class3.propTypes = {
  onClick: React.PropTypes.func,
  name: React.PropTypes.string
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'setNodeRef', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'setNodeRef'), _class2.prototype)), _class2)) || _class);


/***/ }),
/* 139 */
/***/ (function(module, exports) {

module.exports = {};

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at  = __webpack_require__(760)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(280)(String, 'String', function(iterated){
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , index = this._i
    , point;
  if(index >= O.length)return {value: undefined, done: true};
  point = $at(O, index);
  this._i += point.length;
  return {value: point, done: false};
});

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(29)('unscopables')
  , ArrayProto  = Array.prototype;
if(ArrayProto[UNSCOPABLES] == undefined)__webpack_require__(57)(ArrayProto, UNSCOPABLES, {});
module.exports = function(key){
  ArrayProto[UNSCOPABLES][key] = true;
};

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var ctx         = __webpack_require__(88)
  , call        = __webpack_require__(463)
  , isArrayIter = __webpack_require__(300)
  , anObject    = __webpack_require__(20)
  , toLength    = __webpack_require__(43)
  , getIterFn   = __webpack_require__(317)
  , BREAK       = {}
  , RETURN      = {};
var exports = module.exports = function(iterable, entries, fn, that, ITERATOR){
  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)
    , f      = ctx(fn, that, entries ? 2 : 1)
    , index  = 0
    , length, step, iterator, result;
  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if(result === BREAK || result === RETURN)return result;
  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
    result = call(iterator, f, step.value, entries);
    if(result === BREAK || result === RETURN)return result;
  }
};
exports.BREAK  = BREAK;
exports.RETURN = RETURN;

/***/ }),
/* 143 */
/***/ (function(module, exports) {

module.exports = {};

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(33).f
  , has = __webpack_require__(52)
  , TAG = __webpack_require__(29)('toStringTag');

module.exports = function(it, tag, stat){
  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
};

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(6)
  , defined = __webpack_require__(75)
  , fails   = __webpack_require__(24)
  , spaces  = __webpack_require__(313)
  , space   = '[' + spaces + ']'
  , non     = '\u200b\u0085'
  , ltrim   = RegExp('^' + space + space + '*')
  , rtrim   = RegExp(space + space + '*$');

var exporter = function(KEY, exec, ALIAS){
  var exp   = {};
  var FORCE = fails(function(){
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if(ALIAS)exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function(string, TYPE){
  string = String(defined(string));
  if(TYPE & 1)string = string.replace(ltrim, '');
  if(TYPE & 2)string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(38);

var _invariant2 = _interopRequireDefault(_invariant);

var _warning = __webpack_require__(109);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(104);

var _Actions = __webpack_require__(227);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createQuery = exports.createQuery = function createQuery(props) {
  return _extends(Object.create(null), props);
};

var createLocation = exports.createLocation = function createLocation() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Actions.POP;
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;

   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;

  var pathname = object.pathname || '/';
  var search = object.search || '';
  var hash = object.hash || '';
  var state = object.state;

  return {
    pathname: pathname,
    search: search,
    hash: hash,
    state: state,
    action: action,
    key: key
  };
};

var isDate = function isDate(object) {
  return Object.prototype.toString.call(object) === '[object Date]';
};

var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
  if (a === b) return true;

  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (typeofA !== typeofB) return false;

  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;

  // Not the same object, but same type.
  if (typeofA === 'object') {
    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;

    if (!Array.isArray(a)) {
      var keysofA = Object.keys(a);
      var keysofB = Object.keys(b);
      return keysofA.length === keysofB.length && keysofA.every(function (key) {
        return statesAreEqual(a[key], b[key]);
      });
    }

    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return statesAreEqual(item, b[index]);
    });
  }

  // All other serializable types (string, number, boolean)
  // should be strict equal.
  return false;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.key === b.key &&
  // a.action === b.action && // Different action !== location change.
  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
};

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export compilePattern */
/* harmony export (immutable) */ __webpack_exports__["b"] = matchPattern;
/* harmony export (immutable) */ __webpack_exports__["a"] = getParamNames;
/* unused harmony export getParams */
/* harmony export (immutable) */ __webpack_exports__["c"] = formatPattern;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);


function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function _compilePattern(pattern) {
  var regexpSource = '';
  var paramNames = [];
  var tokens = [];

  var match = void 0,
      lastIndex = 0,
      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
  while (match = matcher.exec(pattern)) {
    if (match.index !== lastIndex) {
      tokens.push(pattern.slice(lastIndex, match.index));
      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
    }

    if (match[1]) {
      regexpSource += '([^/]+)';
      paramNames.push(match[1]);
    } else if (match[0] === '**') {
      regexpSource += '(.*)';
      paramNames.push('splat');
    } else if (match[0] === '*') {
      regexpSource += '(.*?)';
      paramNames.push('splat');
    } else if (match[0] === '(') {
      regexpSource += '(?:';
    } else if (match[0] === ')') {
      regexpSource += ')?';
    } else if (match[0] === '\\(') {
      regexpSource += '\\(';
    } else if (match[0] === '\\)') {
      regexpSource += '\\)';
    }

    tokens.push(match[0]);

    lastIndex = matcher.lastIndex;
  }

  if (lastIndex !== pattern.length) {
    tokens.push(pattern.slice(lastIndex, pattern.length));
    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
  }

  return {
    pattern: pattern,
    regexpSource: regexpSource,
    paramNames: paramNames,
    tokens: tokens
  };
}

var CompiledPatternsCache = Object.create(null);

function compilePattern(pattern) {
  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);

  return CompiledPatternsCache[pattern];
}

/**
 * Attempts to match a pattern on the given pathname. Patterns may use
 * the following special characters:
 *
 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
 *                  captured string is considered a "param"
 * - ()             Wraps a segment of the URL that is optional
 * - *              Consumes (non-greedy) all characters up to the next
 *                  character in the pattern, or to the end of the URL if
 *                  there is none
 * - **             Consumes (greedy) all characters up to the next character
 *                  in the pattern, or to the end of the URL if there is none
 *
 *  The function calls callback(error, matched) when finished.
 * The return value is an object with the following properties:
 *
 * - remainingPathname
 * - paramNames
 * - paramValues
 */
function matchPattern(pattern, pathname) {
  // Ensure pattern starts with leading slash for consistency with pathname.
  if (pattern.charAt(0) !== '/') {
    pattern = '/' + pattern;
  }

  var _compilePattern2 = compilePattern(pattern),
      regexpSource = _compilePattern2.regexpSource,
      paramNames = _compilePattern2.paramNames,
      tokens = _compilePattern2.tokens;

  if (pattern.charAt(pattern.length - 1) !== '/') {
    regexpSource += '/?'; // Allow optional path separator at end.
  }

  // Special-case patterns like '*' for catch-all routes.
  if (tokens[tokens.length - 1] === '*') {
    regexpSource += '$';
  }

  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
  if (match == null) {
    return null;
  }

  var matchedPath = match[0];
  var remainingPathname = pathname.substr(matchedPath.length);

  if (remainingPathname) {
    // Require that the match ends at a path separator, if we didn't match
    // the full path, so any remaining pathname is a new path segment.
    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
      return null;
    }

    // If there is a remaining pathname, treat the path separator as part of
    // the remaining pathname for properly continuing the match.
    remainingPathname = '/' + remainingPathname;
  }

  return {
    remainingPathname: remainingPathname,
    paramNames: paramNames,
    paramValues: match.slice(1).map(function (v) {
      return v && decodeURIComponent(v);
    })
  };
}

function getParamNames(pattern) {
  return compilePattern(pattern).paramNames;
}

function getParams(pattern, pathname) {
  var match = matchPattern(pattern, pathname);
  if (!match) {
    return null;
  }

  var paramNames = match.paramNames,
      paramValues = match.paramValues;

  var params = {};

  paramNames.forEach(function (paramName, index) {
    params[paramName] = paramValues[index];
  });

  return params;
}

/**
 * Returns a version of the given pattern with params interpolated. Throws
 * if there is a dynamic segment of the pattern for which there is no param.
 */
function formatPattern(pattern, params) {
  params = params || {};

  var _compilePattern3 = compilePattern(pattern),
      tokens = _compilePattern3.tokens;

  var parenCount = 0,
      pathname = '',
      splatIndex = 0,
      parenHistory = [];

  var token = void 0,
      paramName = void 0,
      paramValue = void 0;
  for (var i = 0, len = tokens.length; i < len; ++i) {
    token = tokens[i];

    if (token === '*' || token === '**') {
      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;

      !(paramValue != null || parenCount > 0) ?  false ? invariant(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      if (paramValue != null) pathname += encodeURI(paramValue);
    } else if (token === '(') {
      parenHistory[parenCount] = '';
      parenCount += 1;
    } else if (token === ')') {
      var parenText = parenHistory.pop();
      parenCount -= 1;

      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
    } else if (token === '\\(') {
      pathname += '(';
    } else if (token === '\\)') {
      pathname += ')';
    } else if (token.charAt(0) === ':') {
      paramName = token.substring(1);
      paramValue = params[paramName];

      !(paramValue != null || parenCount > 0) ?  false ? invariant(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      if (paramValue == null) {
        if (parenCount) {
          parenHistory[parenCount - 1] = '';

          var curTokenIdx = tokens.indexOf(token);
          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
          var nextParenIdx = -1;

          for (var _i = 0; _i < tokensSubset.length; _i++) {
            if (tokensSubset[_i] == ')') {
              nextParenIdx = _i;
              break;
            }
          }

          !(nextParenIdx > 0) ?  false ? invariant(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

          // jump to ending paren
          i = curTokenIdx + nextParenIdx - 1;
        }
      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
    } else {
      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
    }
  }

  !(parenCount <= 0) ?  false ? invariant(false, 'Path "%s" is missing end paren', pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

  return pathname.replace(/\/+/g, '/');
}

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* unused harmony export _resetWarned */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var warned = {};

function routerWarning(falseToWarn, message) {
  // Only issue deprecation warnings once.
  if (message.indexOf('deprecated') !== -1) {
    if (warned[message]) {
      return;
    }

    warned[message] = true;
  }

  message = '[react-router] ' + message;

  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  __WEBPACK_IMPORTED_MODULE_0_warning___default.a.apply(undefined, [falseToWarn, message].concat(args));
}

function _resetWarned() {
  warned = {};
}

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NAMES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return listPublic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_redux_helpers_create_async_actions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_utils_adapters_vod__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_redux_helpers_normalized__ = __webpack_require__(49);






var ACTIONS = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_redux_helpers_create_async_actions__["a" /* default */])('SERVER.CHANNEL.VIDEOS.LIST');
var NAMES = ACTIONS.NAMES;
var START = ACTIONS.START,
    SUCCESS = ACTIONS.SUCCESS,
    FAIL = ACTIONS.FAIL;


function getVideos(method, id) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};


  options = _.merge({
    sort: { order: 'custom', direction: 'asc' },
    paging: { size: 1000 }
  }, options);

  return function (dispatch) {
    var params = { id: id, options: options };
    dispatch(START(params));

    var promise = __WEBPACK_IMPORTED_MODULE_2_shared_utils_adapters_vod__["a" /* default */].listItems[method](id, options);

    return promise.then(function (response) {
      response = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, response, {
        data: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_redux_helpers_normalized__["c" /* normalizeArrayOfVideos */])(response.data)
      });

      dispatch(SUCCESS(params, response));
      return response;
    }, function (response) {
      dispatch(FAIL(params, response, { analytics: { type: 'error', name: 'shared.channel.videos.list' } }));
    });
  };
}

/* harmony default export */ __webpack_exports__["c"] = (_.partial(getVideos, 'list'));

var listPublic = _.partial(getVideos, 'listPublic');

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return channel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return paymentInfoChannel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return arrayOfChannels; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return video; });
/* unused harmony export paymentInfoVideo */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return arrayOfVideos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return arrayOfPaymentInfoVideos; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_normalizr__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_normalizr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_normalizr__);


var channel = new __WEBPACK_IMPORTED_MODULE_0_normalizr__["Schema"]('channels');
var paymentInfoChannel = new __WEBPACK_IMPORTED_MODULE_0_normalizr__["Schema"]('channels', { idAttribute: 'listId' });
var arrayOfChannels = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_normalizr__["arrayOf"])(channel);

var video = new __WEBPACK_IMPORTED_MODULE_0_normalizr__["Schema"]('videos');
var paymentInfoVideo = new __WEBPACK_IMPORTED_MODULE_0_normalizr__["Schema"]('videos', { idAttribute: 'itemId' });
var arrayOfVideos = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_normalizr__["arrayOf"])(video);
var arrayOfPaymentInfoVideos = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_normalizr__["arrayOf"])(paymentInfoVideo);

channel.define({
  featuredItem: video
});

video.define({
  usedInLists: arrayOfChannels
});



/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jBone v1.2.0 - 2016-04-13 - Library for DOM manipulation
 *
 * http://jbone.js.org
 *
 * Copyright 2016 Alexey Kupriyanenko
 * Released under the MIT license.
 */

(function (win) {

var
// cache previous versions
_$ = win.$,
_jBone = win.jBone,

// Quick match a standalone tag
rquickSingleTag = /^<(\w+)\s*\/?>$/,

// A simple way to check for HTML strings
// Prioritize #id over <tag> to avoid XSS via location.hash
rquickExpr = /^(?:[^#<]*(<[\w\W]+>)[^>]*$|#([\w\-]*)$)/,

// Alias for function
slice = [].slice,
splice = [].splice,
keys = Object.keys,

// Alias for global variables
doc = document,

isString = function(el) {
    return typeof el === "string";
},
isObject = function(el) {
    return el instanceof Object;
},
isFunction = function(el) {
    return ({}).toString.call(el) === "[object Function]";
},
isArray = function(el) {
    return Array.isArray(el);
},
jBone = function(element, data) {
    return new fn.init(element, data);
},
fn;

// set previous values and return the instance upon calling the no-conflict mode
jBone.noConflict = function() {
    win.$ = _$;
    win.jBone = _jBone;

    return jBone;
};

fn = jBone.fn = jBone.prototype = {
    init: function(element, data) {
        var elements, tag, wraper, fragment;

        if (!element) {
            return this;
        }
        if (isString(element)) {
            // Create single DOM element
            if (tag = rquickSingleTag.exec(element)) {
                this[0] = doc.createElement(tag[1]);
                this.length = 1;

                if (isObject(data)) {
                    this.attr(data);
                }

                return this;
            }
            // Create DOM collection
            if ((tag = rquickExpr.exec(element)) && tag[1]) {
                fragment = doc.createDocumentFragment();
                wraper = doc.createElement("div");
                wraper.innerHTML = element;
                while (wraper.lastChild) {
                    fragment.appendChild(wraper.firstChild);
                }
                elements = slice.call(fragment.childNodes);

                return jBone.merge(this, elements);
            }
            // Find DOM elements with querySelectorAll
            if (jBone.isElement(data)) {
                return jBone(data).find(element);
            }

            try {
                elements = doc.querySelectorAll(element);

                return jBone.merge(this, elements);
            } catch (e) {
                return this;
            }
        }
        // Wrap DOMElement
        if (element.nodeType) {
            this[0] = element;
            this.length = 1;

            return this;
        }
        // Run function
        if (isFunction(element)) {
            return element();
        }
        // Return jBone element as is
        if (element instanceof jBone) {
            return element;
        }

        // Return element wrapped by jBone
        return jBone.makeArray(element, this);
    },

    pop: [].pop,
    push: [].push,
    reverse: [].reverse,
    shift: [].shift,
    sort: [].sort,
    splice: [].splice,
    slice: [].slice,
    indexOf: [].indexOf,
    forEach: [].forEach,
    unshift: [].unshift,
    concat: [].concat,
    join: [].join,
    every: [].every,
    some: [].some,
    filter: [].filter,
    map: [].map,
    reduce: [].reduce,
    reduceRight: [].reduceRight,
    length: 0
};

fn.constructor = jBone;

fn.init.prototype = fn;

jBone.setId = function(el) {
    var jid = el.jid;

    if (el === win) {
        jid = "window";
    } else if (el.jid === undefined) {
        el.jid = jid = ++jBone._cache.jid;
    }

    if (!jBone._cache.events[jid]) {
        jBone._cache.events[jid] = {};
    }
};

jBone.getData = function(el) {
    el = el instanceof jBone ? el[0] : el;

    var jid = el === win ? "window" : el.jid;

    return {
        jid: jid,
        events: jBone._cache.events[jid]
    };
};

jBone.isElement = function(el) {
    return el && el instanceof jBone || el instanceof HTMLElement || isString(el);
};

jBone._cache = {
    events: {},
    jid: 0
};

function isArraylike(obj) {
    var length = obj.length,
        type = typeof obj;

    if (isFunction(type) || obj === win) {
        return false;
    }

    if (obj.nodeType === 1 && length) {
        return true;
    }

    return isArray(type) || length === 0 ||
        typeof length === "number" && length > 0 && (length - 1) in obj;
}

fn.pushStack = function(elems) {
    var ret = jBone.merge(this.constructor(), elems);

    return ret;
};

jBone.merge = function(first, second) {
    var l = second.length,
        i = first.length,
        j = 0;

    while (j < l) {
        first[i++] = second[j++];
    }

    first.length = i;

    return first;
};

jBone.contains = function(container, contained) {
    return container.contains(contained);
};

jBone.extend = function(target) {
    var tg;

    splice.call(arguments, 1).forEach(function(source) {
        tg = target; //caching target for perf improvement

        if (source) {
            for (var prop in source) {
                tg[prop] = source[prop];
            }
        }
    });

    return target;
};

jBone.makeArray = function(arr, results) {
    var ret = results || [];

    if (arr !== null) {
        if (isArraylike(arr)) {
            jBone.merge(ret, isString(arr) ? [arr] : arr);
        } else {
            ret.push(arr);
        }
    }

    return ret;
};

jBone.unique = function(array) {
    if (array == null) {
        return [];
    }

    var result = [];

    for (var i = 0, length = array.length; i < length; i++) {
        var value = array[i];
        if (result.indexOf(value) < 0) {
            result.push(value);
        }
    }
    return result;
};

function BoneEvent(e, data) {
    var key, setter;

    this.originalEvent = e;

    setter = function(key, e) {
        if (key === "preventDefault") {
            this[key] = function() {
                this.defaultPrevented = true;
                return e[key]();
            };
        } else if (key === "stopImmediatePropagation") {
            this[key] = function() {
                this.immediatePropagationStopped = true;
                return e[key]();
            };
        } else if (isFunction(e[key])) {
            this[key] = function() {
                return e[key]();
            };
        } else {
            this[key] = e[key];
        }
    };

    for (key in e) {
        if (e[key] || typeof e[key] === "function") {
            setter.call(this, key, e);
        }
    }

    jBone.extend(this, data, {
        isImmediatePropagationStopped: function() {
            return !!this.immediatePropagationStopped;
        }
    });
}

jBone.Event = function(event, data) {
    var namespace, eventType;

    if (event.type && !data) {
        data = event;
        event = event.type;
    }

    namespace = event.split(".").splice(1).join(".");
    eventType = event.split(".")[0];

    event = doc.createEvent("Event");
    event.initEvent(eventType, true, true);

    return jBone.extend(event, {
        namespace: namespace,
        isDefaultPrevented: function() {
            return event.defaultPrevented;
        }
    }, data);
};

jBone.event = {

    /**
     * Attach a handler to an event for the elements
     * @param {Node}        el         - Events will be attached to this DOM Node
     * @param {String}      types      - One or more space-separated event types and optional namespaces
     * @param {Function}    handler    - A function to execute when the event is triggered
     * @param {Object}      [data]     - Data to be passed to the handler in event.data
     * @param {String}      [selector] - A selector string to filter the descendants of the selected elements
     */
    add: function(el, types, handler, data, selector) {
        jBone.setId(el);

        var eventHandler = function(e) {
                jBone.event.dispatch.call(el, e);
            },
            events = jBone.getData(el).events,
            eventType, t, event;

        types = types.split(" ");
        t = types.length;
        while (t--) {
            event = types[t];

            eventType = event.split(".")[0];
            events[eventType] = events[eventType] || [];

            if (events[eventType].length) {
                // override with previous event handler
                eventHandler = events[eventType][0].fn;
            } else {
                el.addEventListener && el.addEventListener(eventType, eventHandler, false);
            }

            events[eventType].push({
                namespace: event.split(".").splice(1).join("."),
                fn: eventHandler,
                selector: selector,
                data: data,
                originfn: handler
            });
        }
    },

    /**
     * Remove an event handler
     * @param  {Node}       el        - Events will be deattached from this DOM Node
     * @param  {String}     types     - One or more space-separated event types and optional namespaces
     * @param  {Function}   handler   - A handler function previously attached for the event(s)
     * @param  {String}     [selector] - A selector string to filter the descendants of the selected elements
     */
    remove: function(el, types, handler, selector) {
        var removeListener = function(events, eventType, index, el, e) {
                var callback;

                // get callback
                if ((handler && e.originfn === handler) || !handler) {
                    callback = e.fn;
                }

                if (events[eventType][index].fn === callback) {
                    // remove handler from cache
                    events[eventType].splice(index, 1);

                    if (!events[eventType].length) {
                        el.removeEventListener(eventType, callback);
                    }
                }
            },
            events = jBone.getData(el).events,
            l,
            eventsByType;

        if (!events) {
            return;
        }

        // remove all events
        if (!types && events) {
            return keys(events).forEach(function(eventType) {
                eventsByType = events[eventType];
                l = eventsByType.length;

                while(l--) {
                    removeListener(events, eventType, l, el, eventsByType[l]);
                }
            });
        }

        types.split(" ").forEach(function(eventName) {
            var eventType = eventName.split(".")[0],
                namespace = eventName.split(".").splice(1).join("."),
                e;

            // remove named events
            if (events[eventType]) {
                eventsByType = events[eventType];
                l = eventsByType.length;

                while(l--) {
                    e = eventsByType[l];
                    if ((!namespace || (namespace && e.namespace === namespace)) &&
                        (!selector  || (selector  && e.selector === selector))) {
                        removeListener(events, eventType, l, el, e);
                    }
                }
            }
            // remove all namespaced events
            else if (namespace) {
                keys(events).forEach(function(eventType) {
                    eventsByType = events[eventType];
                    l = eventsByType.length;

                    while(l--) {
                        e = eventsByType[l];
                        if (e.namespace.split(".")[0] === namespace.split(".")[0]) {
                            removeListener(events, eventType, l, el, e);
                        }
                    }
                });
            }
        });
    },

    /**
     * Execute all handlers and behaviors attached to the matched elements for the given event type.
     * @param  {Node}       el       - Events will be triggered for thie DOM Node
     * @param  {String}     event    - One or more space-separated event types and optional namespaces
     */
    trigger: function(el, event) {
        var events = [];

        if (isString(event)) {
            events = event.split(" ").map(function(event) {
                return jBone.Event(event);
            });
        } else {
            event = event instanceof Event ? event : jBone.Event(event);
            events = [event];
        }

        events.forEach(function(event) {
            if (!event.type) {
                return;
            }

            el.dispatchEvent && el.dispatchEvent(event);
        });
    },

    dispatch: function(e) {
        var i = 0,
            j = 0,
            el = this,
            handlers = jBone.getData(el).events[e.type],
            length = handlers.length,
            handlerQueue = [],
            targets = [],
            l,
            expectedTarget,
            handler,
            event,
            eventOptions;

        // cache all events handlers, fix issue with multiple handlers (issue #45)
        for (; i < length; i++) {
            handlerQueue.push(handlers[i]);
        }

        i = 0;
        length = handlerQueue.length;

        for (;
            // if event exists
            i < length &&
            // if handler is not removed from stack
            ~handlers.indexOf(handlerQueue[i]) &&
            // if propagation is not stopped
            !(event && event.isImmediatePropagationStopped());
        i++) {
            expectedTarget = null;
            eventOptions = {};
            handler = handlerQueue[i];
            handler.data && (eventOptions.data = handler.data);

            // event handler without selector
            if (!handler.selector) {
                event = new BoneEvent(e, eventOptions);

                if (!(e.namespace && e.namespace !== handler.namespace)) {
                    handler.originfn.call(el, event);
                }
            }
            // event handler with selector
            else if (
                // if target and selected element the same
                ~(targets = jBone(el).find(handler.selector)).indexOf(e.target) && (expectedTarget = e.target) ||
                // if one of element matched with selector contains target
                (el !== e.target && el.contains(e.target))
            ) {
                // get element matched with selector
                if (!expectedTarget) {
                    l = targets.length;
                    j = 0;

                    for (; j < l; j++) {
                        if (targets[j] && targets[j].contains(e.target)) {
                            expectedTarget = targets[j];
                        }
                    }
                }

                if (!expectedTarget) {
                    continue;
                }

                eventOptions.currentTarget = expectedTarget;
                event = new BoneEvent(e, eventOptions);

                if (!(e.namespace && e.namespace !== handler.namespace)) {
                    handler.originfn.call(expectedTarget, event);
                }
            }
        }
    }
};

fn.on = function(types, selector, data, fn) {
    var length = this.length,
        i = 0;

    if (data == null && fn == null) {
        // (types, fn)
        fn = selector;
        data = selector = undefined;
    } else if (fn == null) {
        if (typeof selector === "string") {
            // (types, selector, fn)
            fn = data;
            data = undefined;
        } else {
            // (types, data, fn)
            fn = data;
            data = selector;
            selector = undefined;
        }
    }

    if (!fn) {
        return this;
    }

    for (; i < length; i++) {
        jBone.event.add(this[i], types, fn, data, selector);
    }

    return this;
};

fn.one = function(event) {
    var args = arguments,
        i = 0,
        length = this.length,
        oneArgs = slice.call(args, 1, args.length - 1),
        callback = slice.call(args, -1)[0],
        addListener;

    addListener = function(el) {
        var $el = jBone(el);

        event.split(" ").forEach(function(event) {
            var fn = function(e) {
                $el.off(event, fn);
                callback.call(el, e);
            };

            $el.on.apply($el, [event].concat(oneArgs, fn));
        });
    };

    for (; i < length; i++) {
        addListener(this[i]);
    }

    return this;
};

fn.trigger = function(event) {
    var i = 0,
        length = this.length;

    if (!event) {
        return this;
    }

    for (; i < length; i++) {
        jBone.event.trigger(this[i], event);
    }

    return this;
};

fn.off = function(types, selector, handler) {
    var i = 0,
        length = this.length;

    if (isFunction(selector)) {
        handler = selector;
        selector = undefined;
    }

    for (; i < length; i++) {
        jBone.event.remove(this[i], types, handler, selector);
    }

    return this;
};

fn.find = function(selector) {
    var results = [],
        i = 0,
        length = this.length,
        finder = function(el) {
            if (isFunction(el.querySelectorAll)) {
                [].forEach.call(el.querySelectorAll(selector), function(found) {
                    results.push(found);
                });
            }
        };

    for (; i < length; i++) {
        finder(this[i]);
    }

    return jBone(results);
};

fn.get = function(index) {
    return index != null ?

        // Return just one element from the set
        (index < 0 ? this[index + this.length] : this[index]) :

        // Return all the elements in a clean array
        slice.call(this);
};

fn.eq = function(index) {
    return jBone(this[index]);
};

fn.parent = function() {
    var results = [],
        parent,
        i = 0,
        length = this.length;

    for (; i < length; i++) {
        if (!~results.indexOf(parent = this[i].parentElement) && parent) {
            results.push(parent);
        }
    }

    return jBone(results);
};

fn.toArray = function() {
    return slice.call(this);
};

fn.is = function() {
    var args = arguments;

    return this.some(function(el) {
        return el.tagName.toLowerCase() === args[0];
    });
};

fn.has = function() {
    var args = arguments;

    return this.some(function(el) {
        return el.querySelectorAll(args[0]).length;
    });
};

fn.add = function(selector, context) {
    return this.pushStack(
        jBone.unique(
            jBone.merge(this.get(), jBone(selector, context))
        )
    );
};

fn.attr = function(key, value) {
    var args = arguments,
        i = 0,
        length = this.length,
        setter;

    if (isString(key) && args.length === 1) {
        return this[0] && this[0].getAttribute(key);
    }

    if (args.length === 2) {
        setter = function(el) {
            el.setAttribute(key, value);
        };
    } else if (isObject(key)) {
        setter = function(el) {
            keys(key).forEach(function(name) {
                el.setAttribute(name, key[name]);
            });
        };
    }

    for (; i < length; i++) {
        setter(this[i]);
    }

    return this;
};

fn.removeAttr = function(key) {
    var i = 0,
        length = this.length;

    for (; i < length; i++) {
        this[i].removeAttribute(key);
    }

    return this;
};

fn.val = function(value) {
    var i = 0,
        length = this.length;

    if (arguments.length === 0) {
        return this[0] && this[0].value;
    }

    for (; i < length; i++) {
        this[i].value = value;
    }

    return this;
};

fn.css = function(key, value) {
    var args = arguments,
        i = 0,
        length = this.length,
        setter;

    // Get attribute
    if (isString(key) && args.length === 1) {
        return this[0] && win.getComputedStyle(this[0])[key];
    }

    // Set attributes
    if (args.length === 2) {
        setter = function(el) {
            el.style[key] = value;
        };
    } else if (isObject(key)) {
        setter = function(el) {
            keys(key).forEach(function(name) {
                el.style[name] = key[name];
            });
        };
    }

    for (; i < length; i++) {
        setter(this[i]);
    }

    return this;
};

fn.data = function(key, value) {
    var args = arguments, data = {},
        i = 0,
        length = this.length,
        setter,
        setValue = function(el, key, value) {
            if (isObject(value)) {
                el.jdata = el.jdata || {};
                el.jdata[key] = value;
            } else {
                el.dataset[key] = value;
            }
        },
        getValue = function(value) {
            if (value === "true") {
                return true;
            } else if (value === "false") {
                return false;
            } else {
                return value;
            }
        };

    // Get all data
    if (args.length === 0) {
        this[0].jdata && (data = this[0].jdata);

        keys(this[0].dataset).forEach(function(key) {
            data[key] = getValue(this[0].dataset[key]);
        }, this);

        return data;
    }
    // Get data by name
    if (args.length === 1 && isString(key)) {
        return this[0] && getValue(this[0].dataset[key] || this[0].jdata && this[0].jdata[key]);
    }

    // Set data
    if (args.length === 1 && isObject(key)) {
        setter = function(el) {
            keys(key).forEach(function(name) {
                setValue(el, name, key[name]);
            });
        };
    } else if (args.length === 2) {
        setter = function(el) {
            setValue(el, key, value);
        };
    }

    for (; i < length; i++) {
        setter(this[i]);
    }

    return this;
};

fn.removeData = function(key) {
    var i = 0,
        length = this.length,
        jdata, dataset;

    for (; i < length; i++) {
        jdata = this[i].jdata;
        dataset = this[i].dataset;

        if (key) {
            jdata && jdata[key] && delete jdata[key];
            delete dataset[key];
        } else {
            for (key in jdata) {
                delete jdata[key];
            }

            for (key in dataset) {
                delete dataset[key];
            }
        }
    }

    return this;
};

fn.addClass = function(className) {
    var i = 0,
        j = 0,
        length = this.length,
        classes = className ? className.trim().split(/\s+/) : [];

    for (; i < length; i++) {
        j = 0;

        for (j = 0; j < classes.length; j++) {
            this[i].classList.add(classes[j]);
        }
    }

    return this;
};

fn.removeClass = function(className) {
    var i = 0,
        j = 0,
        length = this.length,
        classes = className ? className.trim().split(/\s+/) : [];

    for (; i < length; i++) {
        j = 0;

        for (j = 0; j < classes.length; j++) {
            this[i].classList.remove(classes[j]);
        }
    }

    return this;
};

fn.toggleClass = function(className, force) {
    var i = 0,
        length = this.length,
        method = "toggle";

    force === true && (method = "add") || force === false && (method = "remove");

    if (className) {
        for (; i < length; i++) {
            this[i].classList[method](className);
        }
    }

    return this;
};

fn.hasClass = function(className) {
    var i = 0, length = this.length;

    if (className) {
        for (; i < length; i++) {
            if (this[i].classList.contains(className)) {
                return true;
            }
        }
    }

    return false;
};

fn.html = function(value) {
    var args = arguments,
        el;

    // add HTML into elements
    if (args.length === 1 && value !== undefined) {
        return this.empty().append(value);
    }
    // get HTML from element
    else if (args.length === 0 && (el = this[0])) {
        return el.innerHTML;
    }

    return this;
};

fn.append = function(appended) {
    var i = 0,
        length = this.length,
        setter;

    // create jBone object and then append
    if (isString(appended) && rquickExpr.exec(appended)) {
        appended = jBone(appended);
    }
    // create text node for insertion
    else if (!isObject(appended)) {
        appended = document.createTextNode(appended);
    }

    appended = appended instanceof jBone ? appended : jBone(appended);

    setter = function(el, i) {
        appended.forEach(function(node) {
            if (i) {
                el.appendChild(node.cloneNode(true));
            } else {
                el.appendChild(node);
            }
        });
    };

    for (; i < length; i++) {
        setter(this[i], i);
    }

    return this;
};

fn.appendTo = function(to) {
    jBone(to).append(this);

    return this;
};

fn.empty = function() {
    var i = 0,
        length = this.length,
        el;

    for (; i < length; i++) {
        el = this[i];

        while (el.lastChild) {
            el.removeChild(el.lastChild);
        }
    }

    return this;
};

fn.remove = function() {
    var i = 0,
        length = this.length,
        el;

    // remove all listeners
    this.off();

    for (; i < length; i++) {
        el = this[i];

        // remove data and nodes
        delete el.jdata;
        el.parentNode && el.parentNode.removeChild(el);
    }

    return this;
};

if (typeof module === "object" && module && typeof module.exports === "object") {
    // Expose jBone as module.exports in loaders that implement the Node
    // module pattern (including browserify). Do not create the global, since
    // the user will be storing it themselves locally, and globals are frowned
    // upon in the Node module world.
    module.exports = jBone;
}
// Register as a AMD module
else if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
        return jBone;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

    win.jBone = win.$ = jBone;
} else if (typeof win === "object" && typeof win.document === "object") {
    win.jBone = win.$ = jBone;
}

}(window));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(181)(module)))

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Schema = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.arrayOf = arrayOf;
exports.valuesOf = valuesOf;
exports.unionOf = unionOf;
exports.normalize = normalize;

var _EntitySchema = __webpack_require__(509);

var _EntitySchema2 = _interopRequireDefault(_EntitySchema);

var _IterableSchema = __webpack_require__(510);

var _IterableSchema2 = _interopRequireDefault(_IterableSchema);

var _UnionSchema = __webpack_require__(342);

var _UnionSchema2 = _interopRequireDefault(_UnionSchema);

var _isEqual = __webpack_require__(566);

var _isEqual2 = _interopRequireDefault(_isEqual);

var _isObject = __webpack_require__(41);

var _isObject2 = _interopRequireDefault(_isObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function defaultAssignEntity(normalized, key, entity) {
  normalized[key] = entity;
}

function visitObject(obj, schema, bag, options, collectionKey) {
  var _options$assignEntity = options.assignEntity,
      assignEntity = _options$assignEntity === undefined ? defaultAssignEntity : _options$assignEntity;


  var defaults = schema && schema.getDefaults && schema.getDefaults();
  var schemaAssignEntity = schema && schema.getAssignEntity && schema.getAssignEntity();
  var normalized = (0, _isObject2.default)(defaults) ? _extends({}, defaults) : {};
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      var resolvedSchema = typeof schema[key] === 'function' ? schema[key].call(null, obj) : schema[key];
      var entity = visit(obj[key], resolvedSchema, bag, options, collectionKey);
      assignEntity.call(null, normalized, key, entity, obj, schema);
      if (schemaAssignEntity) {
        schemaAssignEntity.call(null, normalized, key, entity, obj, schema);
      }
    }
  }
  return normalized;
}

function defaultMapper(iterableSchema, itemSchema, bag, options) {
  return function (obj, key) {
    return visit(obj, itemSchema, bag, options, key);
  };
}

function polymorphicMapper(iterableSchema, itemSchema, bag, options) {
  return function (obj, key) {
    var schemaKey = iterableSchema.getSchemaKey(obj);
    var result = visit(obj, itemSchema[schemaKey], bag, options, key);
    return { id: result, schema: schemaKey };
  };
}

function visitIterable(obj, iterableSchema, bag, options) {
  var itemSchema = iterableSchema.getItemSchema();
  var curriedItemMapper = defaultMapper(iterableSchema, itemSchema, bag, options);

  if (Array.isArray(obj)) {
    return obj.map(curriedItemMapper);
  } else {
    return Object.keys(obj).reduce(function (objMap, key) {
      objMap[key] = curriedItemMapper(obj[key], key);
      return objMap;
    }, {});
  }
}

function visitUnion(obj, unionSchema, bag, options) {
  var itemSchema = unionSchema.getItemSchema();
  return polymorphicMapper(unionSchema, itemSchema, bag, options)(obj);
}

function defaultMergeIntoEntity(entityA, entityB, entityKey) {
  for (var key in entityB) {
    if (!entityB.hasOwnProperty(key)) {
      continue;
    }

    if (!entityA.hasOwnProperty(key) || (0, _isEqual2.default)(entityA[key], entityB[key])) {
      entityA[key] = entityB[key];
      continue;
    }

    console.warn('When merging two ' + entityKey + ', found unequal data in their "' + key + '" values. Using the earlier value.', entityA[key], entityB[key]);
  }
}

function visitEntity(entity, entitySchema, bag, options, collectionKey) {
  var _options$mergeIntoEnt = options.mergeIntoEntity,
      mergeIntoEntity = _options$mergeIntoEnt === undefined ? defaultMergeIntoEntity : _options$mergeIntoEnt;


  var entityKey = entitySchema.getKey();
  var id = entitySchema.getId(entity, collectionKey);

  if (!bag.hasOwnProperty(entityKey)) {
    bag[entityKey] = {};
  }

  if (!bag[entityKey].hasOwnProperty(id)) {
    bag[entityKey][id] = {};
  }

  var stored = bag[entityKey][id];
  var normalized = visitObject(entity, entitySchema, bag, options, collectionKey);
  mergeIntoEntity(stored, normalized, entityKey);

  return id;
}

function visit(obj, schema, bag, options, collectionKey) {
  if (!(0, _isObject2.default)(obj) || !(0, _isObject2.default)(schema)) {
    return obj;
  }

  if (schema instanceof _EntitySchema2.default) {
    return visitEntity(obj, schema, bag, options, collectionKey);
  } else if (schema instanceof _IterableSchema2.default) {
    return visitIterable(obj, schema, bag, options);
  } else if (schema instanceof _UnionSchema2.default) {
    return visitUnion(obj, schema, bag, options);
  } else {
    return visitObject(obj, schema, bag, options, collectionKey);
  }
}

function normalizeResult(result) {
  if ((0, _isObject2.default)(result) && (0, _isEqual2.default)(Object.keys(result), Object.keys(result).map(function (key) {
    return result[key];
  }))) {
    return Object.keys(result);
  }
  return result;
}

function arrayOf(schema, options) {
  return new _IterableSchema2.default(schema, options);
}

function valuesOf(schema, options) {
  return new _IterableSchema2.default(schema, options);
}

function unionOf(schema, options) {
  return new _UnionSchema2.default(schema, options);
}

exports.Schema = _EntitySchema2.default;
function normalize(obj, schema) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!(0, _isObject2.default)(obj)) {
    throw new Error('Normalize accepts an object or an array as its input.');
  }

  if (!(0, _isObject2.default)(schema) || Array.isArray(schema)) {
    throw new Error('Normalize accepts an object for schema.');
  }

  var bag = {};
  var result = visit(obj, schema, bag, options);

  return {
    entities: bag,
    result: normalizeResult(result)
  };
}

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var UI_EVENTS = {
  PLAY_TRIGGERED: 'ui-play-triggered',
  PLAY_OVERLAY_TRIGGERED: 'ui-play-overlay-triggered',
  PAUSE_TRIGGERED: 'ui-pause-triggered',
  PROGRESS_CHANGE_TRIGGERED: 'ui-progress-change-triggered',
  VOLUME_CHANGE_TRIGGERED: 'ui-volume-change-triggered',
  MUTE_STATUS_TRIGGERED: 'ui-mute-status-triggered',
  FULLSCREEN_ENTER_TRIGGERED: 'ui-fullscreen-enter-triggered',
  FULLSCREEN_EXIT_TRIGGERED: 'ui-fullscreen-exit-triggered',
  FULLSCREEN_STATUS_CHANGED: 'ui-fullscreen-status-changed',
  MOUSE_ENTER_ON_PLAYER_TRIGGERED: 'ui-mouse-enter-on-player-triggered',
  MOUSE_MOVE_ON_PLAYER_TRIGGERED: 'ui-mouse-move-on-player-triggered',
  MOUSE_LEAVE_ON_PLAYER_TRIGGERED: 'ui-mouse-leave-on-player-triggered',
  CONTROL_BLOCK_HIDE_TRIGGERED: 'control-block-hide-triggered',
  CONTROL_BLOCK_SHOW_TRIGGERED: 'control-block-show-triggered',
  PROGRESS_MANIPULATION_STARTED: 'ui-progress-manipulation-started',
  PROGRESS_MANIPULATION_ENDED: 'ui-progress-manipulation-ended',
  ENGINE_CONTROL_THROUGH_KEYBOARD_TRIGGERED: 'engine-control-through-keyboard-triggered'
};

exports.default = UI_EVENTS;
//# sourceMappingURL=ui.js.map


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var VIDEO_EVENTS = {
  ERROR: 'error',
  CAN_PLAY: 'can-play',
  STATE_CHANGED: 'state-changed',
  CHUNK_LOADED: 'chunk-loaded',
  METADATA_LOADED: 'metadata-loaded',
  CURRENT_TIME_UPDATED: 'current-time-updated',
  DURATION_UPDATED: 'duration-updated',
  LOAD_STARTED: 'load-started',
  LOADED_FIRST_CHUNK: 'loaded-first-chunk',
  SEEK_STARTED: 'seek-started',
  SEEK_ENDED: 'seek-ended',
  SET_CURRENT_TIME: 'set-current-time',
  VOLUME_STATUS_CHANGED: 'volume-status-changed',
  UPLOAD_STALLED: 'upload-stalled',
  UPLOAD_SUSPEND: 'upload-suspend'
};

exports.default = VIDEO_EVENTS;
//# sourceMappingURL=video.js.map


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var View = function () {
  function View() {
    _classCallCheck(this, View);
  }

  _createClass(View, [{
    key: "styleNames",
    get: function get() {
      return this.constructor._styles;
    }
  }, {
    key: "translations",
    get: function get() {
      return this.constructor._translations;
    }
  }], [{
    key: "extendStyleNames",
    value: function extendStyleNames(styles) {
      this._styles = _extends({}, this._styles, styles);
    }
  }, {
    key: "extendTranslations",
    value: function extendTranslations(translations) {
      this._translations = _extends({}, this._translations, translations);
    }
  }]);

  return View;
}();

View._styles = {};
View._translations = {};
exports.default = View;
//# sourceMappingURL=view.js.map


/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["g"] = isCancelled;
/* harmony export (immutable) */ __webpack_exports__["b"] = isFake;
/* harmony export (immutable) */ __webpack_exports__["h"] = canCancelUpload;
/* harmony export (immutable) */ __webpack_exports__["i"] = isUploadFailed;
/* harmony export (immutable) */ __webpack_exports__["l"] = isTranscodingFailed;
/* harmony export (immutable) */ __webpack_exports__["d"] = isTranscoded;
/* harmony export (immutable) */ __webpack_exports__["a"] = isUploaded;
/* harmony export (immutable) */ __webpack_exports__["e"] = isFailed;
/* harmony export (immutable) */ __webpack_exports__["c"] = isQuotaExceeded;
/* unused harmony export isQuotaExceededByError */
/* harmony export (immutable) */ __webpack_exports__["f"] = isInTranscoding;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return UPLOAD_ERROR_TYPES; });
/* harmony export (immutable) */ __webpack_exports__["j"] = getUploadErrorType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_constants_transcoding_statuses__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_constants_uploading_statuses__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_constants_upload_error_types__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_constants_dashboard__ = __webpack_require__(556);





var TRANSCODING_PROGRESS_STATUSES = [__WEBPACK_IMPORTED_MODULE_0_shared_constants_transcoding_statuses__["a" /* default */].IN_QUEUE, __WEBPACK_IMPORTED_MODULE_0_shared_constants_transcoding_statuses__["a" /* default */].PENDING, __WEBPACK_IMPORTED_MODULE_0_shared_constants_transcoding_statuses__["a" /* default */].INPROGRESS, __WEBPACK_IMPORTED_MODULE_0_shared_constants_transcoding_statuses__["a" /* default */].PREVIEW_READY];

function isCancelled(videoData) {
  return _.get(videoData, 'error.code') === __WEBPACK_IMPORTED_MODULE_3_shared_constants_dashboard__["a" /* default */].UPLOADING_CANCEL_CODE;
}

function isFake(_ref) {
  var id = _ref.id;

  return (/FAKE/.test(id)
  );
}

function canCancelUpload(_ref2) {
  var uploadingStatus = _ref2.uploadingStatus;

  return _.includes([__WEBPACK_IMPORTED_MODULE_1_shared_constants_uploading_statuses__["a" /* default */].WAITING, __WEBPACK_IMPORTED_MODULE_1_shared_constants_uploading_statuses__["a" /* default */].UPLOADING], uploadingStatus);
}

function isUploadFailed(_ref3) {
  var transcodingStatus = _ref3.transcodingStatus,
      uploadingStatus = _ref3.uploadingStatus;

  return !uploadingStatus && transcodingStatus === __WEBPACK_IMPORTED_MODULE_0_shared_constants_transcoding_statuses__["a" /* default */].NONE || uploadingStatus === __WEBPACK_IMPORTED_MODULE_1_shared_constants_uploading_statuses__["a" /* default */].FAILED;
}

function isTranscodingFailed(_ref4) {
  var transcodingStatus = _ref4.transcodingStatus;

  return transcodingStatus === __WEBPACK_IMPORTED_MODULE_0_shared_constants_transcoding_statuses__["a" /* default */].FAILED;
}

function isTranscoded(_ref5) {
  var transcodingStatus = _ref5.transcodingStatus;

  return transcodingStatus === __WEBPACK_IMPORTED_MODULE_0_shared_constants_transcoding_statuses__["a" /* default */].READY;
}

function isUploaded(_ref6) {
  var transcodingStatus = _ref6.transcodingStatus,
      uploadingStatus = _ref6.uploadingStatus;

  return uploadingStatus === __WEBPACK_IMPORTED_MODULE_1_shared_constants_uploading_statuses__["a" /* default */].SUCCEEDED || !uploadingStatus && transcodingStatus && transcodingStatus !== __WEBPACK_IMPORTED_MODULE_0_shared_constants_transcoding_statuses__["a" /* default */].NONE;
}

function isFailed(videoData) {
  return isUploadFailed(videoData) || isTranscodingFailed(videoData);
}

function isQuotaExceeded(videoData) {
  return isFailed(videoData) && isQuotaExceededByError(_.get(videoData, 'error'));
}

function isQuotaExceededByError(error) {
  return _.get(error, 'data.errorInfo.key') === __WEBPACK_IMPORTED_MODULE_2_shared_constants_upload_error_types__["a" /* default */].QUOTA_EXCEEDED;
}

function isInTranscoding(_ref7) {
  var transcodingStatus = _ref7.transcodingStatus;

  return _.includes(TRANSCODING_PROGRESS_STATUSES, transcodingStatus);
}

var UPLOAD_ERROR_TYPES = {
  FAILED: 'failed',
  QUOTA_EXCEEDED: 'quota_exceeded'
};

function getUploadErrorType(error) {
  if (isQuotaExceededByError(error)) {
    return UPLOAD_ERROR_TYPES.QUOTA_EXCEEDED;
  }
  return UPLOAD_ERROR_TYPES.FAILED;
}

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _streamingVoMetricsHTTPRequest = __webpack_require__(84);

var _streamingModelsManifestModel = __webpack_require__(325);

var _streamingModelsManifestModel2 = _interopRequireDefault(_streamingModelsManifestModel);

var _modelsDashManifestModel = __webpack_require__(158);

var _modelsDashManifestModel2 = _interopRequireDefault(_modelsDashManifestModel);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _constantsDashMetricsList = __webpack_require__(585);

var MetricsList = _interopRequireWildcard(_constantsDashMetricsList);

var _round10 = __webpack_require__(1481);

/**
 * @module DashMetrics
 */
function DashMetrics() {

    var instance = undefined;
    var context = this.context;
    var manifestModel = (0, _streamingModelsManifestModel2['default'])(context).getInstance(); //TODO Need to pass this in not bake in

    function getBandwidthForRepresentation(representationId, periodId) {
        var representation;
        var manifest = manifestModel.getValue();
        var period = manifest.Period_asArray[periodId];

        representation = findRepresentation(period, representationId);

        if (representation === null) {
            return null;
        }

        return representation.bandwidth;
    }

    /**
     *
     * @param {string} representationId
     * @param {number} periodIdx
     * @returns {*}
     */
    function getIndexForRepresentation(representationId, periodIdx) {
        var representationIndex;
        var manifest = manifestModel.getValue();
        var period = manifest.Period_asArray[periodIdx];

        representationIndex = findRepresentationIndex(period, representationId);
        return representationIndex;
    }

    /**
     * This method returns the current max index based on what is defined in the MPD.
     *
     * @param {string} bufferType - String 'audio' or 'video',
     * @param {number} periodIdx - Make sure this is the period index not id
     * @return {number}
     * @memberof module:DashMetrics
     * @instance
     */
    function getMaxIndexForBufferType(bufferType, periodIdx) {
        var maxIndex;
        var manifest = manifestModel.getValue();
        var period = manifest.Period_asArray[periodIdx];

        maxIndex = findMaxBufferIndex(period, bufferType);
        return maxIndex;
    }

    /**
     * @param {MetricsList} metrics
     * @returns {*}
     * @memberof module:DashMetrics
     * @instance
     */
    function getCurrentRepresentationSwitch(metrics) {
        return getCurrent(metrics, MetricsList.TRACK_SWITCH);
    }

    /**
     * @param {MetricsList} metrics
     * @returns {*}
     * @memberof module:DashMetrics
     * @instance
     */
    function getLatestBufferLevelVO(metrics) {
        return getCurrent(metrics, MetricsList.BUFFER_LEVEL);
    }

    /**
     * @param {MetricsList} metrics
     * @returns {number}
     * @memberof module:DashMetrics
     * @instance
     */
    function getCurrentBufferLevel(metrics) {
        var vo = getLatestBufferLevelVO(metrics);

        if (vo) {
            return (0, _round10.round10)(vo.level / 1000, -3);
        }

        return 0;
    }

    /**
     * @param {MetricsList} metrics
     * @returns {null|*|vo}
     * @memberof module:DashMetrics
     * @instance
     */
    function getRequestsQueue(metrics) {
        return metrics.RequestsQueue;
    }

    /**
     * @param {MetricsList} metrics
     * @returns {*}
     * @memberof module:DashMetrics
     * @instance
     */
    function getCurrentHttpRequest(metrics) {
        if (metrics === null) {
            return null;
        }

        var httpList = metrics.HttpList;
        var currentHttpList = null;

        var httpListLength, httpListLastIndex;

        if (httpList === null || httpList.length <= 0) {
            return null;
        }

        httpListLength = httpList.length;
        httpListLastIndex = httpListLength - 1;

        while (httpListLastIndex >= 0) {
            if (httpList[httpListLastIndex].responsecode) {
                currentHttpList = httpList[httpListLastIndex];
                break;
            }
            httpListLastIndex--;
        }
        return currentHttpList;
    }

    /**
     * @param {MetricsList} metrics
     * @returns {*}
     * @memberof module:DashMetrics
     * @instance
     */
    function getHttpRequests(metrics) {
        if (metrics === null) {
            return [];
        }

        return !!metrics.HttpList ? metrics.HttpList : [];
    }

    /**
     * @param {MetricsList} metrics
     * @param {string} metricName
     * @returns {*}
     * @memberof module:DashMetrics
     * @instance
     */
    function getCurrent(metrics, metricName) {
        if (metrics === null) {
            return null;
        }

        var list = metrics[metricName];

        if (list === null) {
            return null;
        }

        var length = list.length;

        if (length <= 0) {
            return null;
        }

        return list[length - 1];
    }

    /**
     * @param {MetricsList} metrics
     * @returns {*}
     * @memberof module:DashMetrics
     * @instance
     */
    function getCurrentDroppedFrames(metrics) {
        return getCurrent(metrics, MetricsList.DROPPED_FRAMES);
    }

    /**
     * @param {MetricsList} metrics
     * @returns {*}
     * @memberof module:DashMetrics
     * @instance
     */
    function getCurrentSchedulingInfo(metrics) {
        return getCurrent(metrics, MetricsList.SCHEDULING_INFO);
    }

    /**
     * @param {MetricsList} metrics
     * @returns {*}
     * @memberof module:DashMetrics
     * @instance
     */
    function getCurrentManifestUpdate(metrics) {
        return getCurrent(metrics, MetricsList.MANIFEST_UPDATE);
    }

    /**
     * @param {MetricsList} metrics
     * @returns {*}
     * @memberof module:DashMetrics
     * @instance
     */
    function getCurrentDVRInfo(metrics) {
        return getCurrent(metrics, MetricsList.DVR_INFO);
    }

    /**
     * @param {MetricsList} metrics
     * @param {string} id
     * @returns {*}
     * @memberof module:DashMetrics
     * @instance
     */
    function getLatestMPDRequestHeaderValueByID(metrics, id) {
        var headers = {};
        var httpRequestList, httpRequest, i;

        if (metrics === null) {
            return null;
        }

        httpRequestList = getHttpRequests(metrics);

        for (i = httpRequestList.length - 1; i >= 0; i--) {
            httpRequest = httpRequestList[i];

            if (httpRequest.type === _streamingVoMetricsHTTPRequest.HTTPRequest.MPD_TYPE) {
                headers = parseResponseHeaders(httpRequest._responseHeaders);
                break;
            }
        }

        return headers[id] === undefined ? null : headers[id];
    }

    /**
     * @param {MetricsList} metrics
     * @param {string} id
     * @returns {*}
     * @memberof module:DashMetrics
     * @instance
     */
    function getLatestFragmentRequestHeaderValueByID(metrics, id) {

        if (metrics === null) return null;

        var httpRequest = getCurrentHttpRequest(metrics);
        var headers;

        if (httpRequest === null || httpRequest._responseHeaders === null) return null;

        headers = parseResponseHeaders(httpRequest._responseHeaders);
        return headers[id] === undefined ? null : headers[id];
    }

    function parseResponseHeaders(headerStr) {
        var headers = {};
        if (!headerStr) {
            return headers;
        }

        // Trim headerStr to fix a MS Edge bug with xhr.getAllResponseHeaders method
        // which send a string starting with a "\n" character
        var headerPairs = headerStr.trim().split('\r\n');
        for (var i = 0, ilen = headerPairs.length; i < ilen; i++) {
            var headerPair = headerPairs[i];
            var index = headerPair.indexOf(': ');
            if (index > 0) {
                headers[headerPair.substring(0, index)] = headerPair.substring(index + 2);
            }
        }
        return headers;
    }

    function findRepresentationIndex(period, representationId) {
        var index = findRepresentation(period, representationId, true);

        if (index !== null) {
            return index;
        }

        return -1;
    }

    function findRepresentation(period, representationId, returnIndex) {
        var adaptationSet, adaptationSetArray, representation, representationArray, adaptationSetArrayIndex, representationArrayIndex;

        if (period) {
            adaptationSetArray = period.AdaptationSet_asArray;
            for (adaptationSetArrayIndex = 0; adaptationSetArrayIndex < adaptationSetArray.length; adaptationSetArrayIndex = adaptationSetArrayIndex + 1) {
                adaptationSet = adaptationSetArray[adaptationSetArrayIndex];
                representationArray = adaptationSet.Representation_asArray;
                for (representationArrayIndex = 0; representationArrayIndex < representationArray.length; representationArrayIndex = representationArrayIndex + 1) {
                    representation = representationArray[representationArrayIndex];
                    if (representationId === representation.id) {
                        if (returnIndex) {
                            return representationArrayIndex;
                        } else {
                            return representation;
                        }
                    }
                }
            }
        }

        return null;
    }

    function adaptationIsType(adaptation, bufferType) {
        return (0, _modelsDashManifestModel2['default'])(context).getInstance().getIsTypeOf(adaptation, bufferType);
    }

    function findMaxBufferIndex(period, bufferType) {
        var adaptationSet, adaptationSetArray, representationArray, adaptationSetArrayIndex;

        if (!period || !bufferType) return -1;

        adaptationSetArray = period.AdaptationSet_asArray;
        for (adaptationSetArrayIndex = 0; adaptationSetArrayIndex < adaptationSetArray.length; adaptationSetArrayIndex = adaptationSetArrayIndex + 1) {
            adaptationSet = adaptationSetArray[adaptationSetArrayIndex];
            representationArray = adaptationSet.Representation_asArray;
            if (adaptationIsType(adaptationSet, bufferType)) {
                return representationArray.length;
            }
        }

        return -1;
    }

    instance = {
        getBandwidthForRepresentation: getBandwidthForRepresentation,
        getIndexForRepresentation: getIndexForRepresentation,
        getMaxIndexForBufferType: getMaxIndexForBufferType,
        getCurrentRepresentationSwitch: getCurrentRepresentationSwitch,
        getLatestBufferLevelVO: getLatestBufferLevelVO,
        getCurrentBufferLevel: getCurrentBufferLevel,
        getCurrentHttpRequest: getCurrentHttpRequest,
        getHttpRequests: getHttpRequests,
        getCurrentDroppedFrames: getCurrentDroppedFrames,
        getCurrentSchedulingInfo: getCurrentSchedulingInfo,
        getCurrentDVRInfo: getCurrentDVRInfo,
        getCurrentManifestUpdate: getCurrentManifestUpdate,
        getLatestFragmentRequestHeaderValueByID: getLatestFragmentRequestHeaderValueByID,
        getLatestMPDRequestHeaderValueByID: getLatestMPDRequestHeaderValueByID,
        getRequestsQueue: getRequestsQueue
    };

    return instance;
}

DashMetrics.__dashjs_factory_name = 'DashMetrics';
exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(DashMetrics);
module.exports = exports['default'];
//# sourceMappingURL=DashMetrics.js.map


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _voRepresentation = __webpack_require__(396);

var _voRepresentation2 = _interopRequireDefault(_voRepresentation);

var _voAdaptationSet = __webpack_require__(1340);

var _voAdaptationSet2 = _interopRequireDefault(_voAdaptationSet);

var _voPeriod = __webpack_require__(1343);

var _voPeriod2 = _interopRequireDefault(_voPeriod);

var _voMpd = __webpack_require__(1342);

var _voMpd2 = _interopRequireDefault(_voMpd);

var _voUTCTiming = __webpack_require__(589);

var _voUTCTiming2 = _interopRequireDefault(_voUTCTiming);

var _utilsTimelineConverter = __webpack_require__(395);

var _utilsTimelineConverter2 = _interopRequireDefault(_utilsTimelineConverter);

var _streamingControllersMediaController = __webpack_require__(188);

var _streamingControllersMediaController2 = _interopRequireDefault(_streamingControllersMediaController);

var _DashAdapter = __webpack_require__(394);

var _DashAdapter2 = _interopRequireDefault(_DashAdapter);

var _voEvent = __webpack_require__(588);

var _voEvent2 = _interopRequireDefault(_voEvent);

var _voBaseURL = __webpack_require__(587);

var _voBaseURL2 = _interopRequireDefault(_voBaseURL);

var _voEventStream = __webpack_require__(1341);

var _voEventStream2 = _interopRequireDefault(_voEventStream);

var _streamingUtilsURLUtils = __webpack_require__(242);

var _streamingUtilsURLUtils2 = _interopRequireDefault(_streamingUtilsURLUtils);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

function DashManifestModel() {

    var instance = undefined;
    var context = this.context;
    var timelineConverter = (0, _utilsTimelineConverter2['default'])(context).getInstance(); //TODO Need to pass this in not bake in
    var mediaController = (0, _streamingControllersMediaController2['default'])(context).getInstance();
    var adaptor = (0, _DashAdapter2['default'])(context).getInstance();

    var urlUtils = (0, _streamingUtilsURLUtils2['default'])(context).getInstance();

    function getIsTypeOf(adaptation, type) {

        var i, len, representation;
        var result = false;
        var found = false;

        var col = adaptation.ContentComponent_asArray;
        var mimeTypeRegEx = type !== 'text' ? new RegExp(type) : new RegExp('(vtt|ttml)');

        if (adaptation.Representation_asArray.length > 0 && adaptation.Representation_asArray[0].hasOwnProperty('codecs')) {
            // Just check the start of the codecs string
            var codecs = adaptation.Representation_asArray[0].codecs;
            if (codecs.search('stpp') === 0 || codecs.search('wvtt') === 0) {
                return type === 'fragmentedText';
            }
        }

        if (col) {
            if (col.length > 1) {
                return type === 'muxed';
            } else if (col[0] && col[0].contentType === type) {
                result = true;
                found = true;
            }
        }

        if (adaptation.hasOwnProperty('mimeType')) {
            result = mimeTypeRegEx.test(adaptation.mimeType);
            found = true;
        }

        // couldn't find on adaptationset, so check a representation
        if (!found) {
            i = 0;
            len = adaptation.Representation_asArray.length;
            while (!found && i < len) {
                representation = adaptation.Representation_asArray[i];

                if (representation.hasOwnProperty('mimeType')) {
                    result = mimeTypeRegEx.test(representation.mimeType);
                    found = true;
                }

                i++;
            }
        }

        return result;
    }

    function getIsAudio(adaptation) {
        return getIsTypeOf(adaptation, 'audio');
    }

    function getIsVideo(adaptation) {
        return getIsTypeOf(adaptation, 'video');
    }

    function getIsFragmentedText(adaptation) {
        return getIsTypeOf(adaptation, 'fragmentedText');
    }

    function getIsText(adaptation) {
        return getIsTypeOf(adaptation, 'text');
    }

    function getIsMuxed(adaptation) {
        return getIsTypeOf(adaptation, 'muxed');
    }

    function getIsTextTrack(type) {
        return type === 'text/vtt' || type === 'application/ttml+xml';
    }

    function getLanguageForAdaptation(adaptation) {
        var lang = '';

        if (adaptation.hasOwnProperty('lang')) {
            //Filter out any other characters not allowed according to RFC5646
            lang = adaptation.lang.replace(/[^A-Za-z0-9-]/g, '');
        }

        return lang;
    }

    function getViewpointForAdaptation(adaptation) {
        return adaptation.hasOwnProperty('Viewpoint') ? adaptation.Viewpoint : null;
    }

    function getRolesForAdaptation(adaptation) {
        return adaptation.hasOwnProperty('Role_asArray') ? adaptation.Role_asArray : [];
    }

    function getAccessibilityForAdaptation(adaptation) {
        return adaptation.hasOwnProperty('Accessibility_asArray') ? adaptation.Accessibility_asArray : [];
    }

    function getAudioChannelConfigurationForAdaptation(adaptation) {
        return adaptation.hasOwnProperty('AudioChannelConfiguration_asArray') ? adaptation.AudioChannelConfiguration_asArray : [];
    }

    function getIsMain(adaptation) {
        return getRolesForAdaptation(adaptation).filter(function (role) {
            return role.value === 'main';
        })[0];
    }

    function getRepresentationSortFunction() {
        return function (a, b) {
            return a.bandwidth - b.bandwidth;
        };
    }

    function processAdaptation(adaptation) {
        if (adaptation.Representation_asArray !== undefined && adaptation.Representation_asArray !== null) {
            adaptation.Representation_asArray.sort(getRepresentationSortFunction());
        }

        return adaptation;
    }

    function getAdaptationForId(id, manifest, periodIndex) {

        var adaptations = manifest.Period_asArray[periodIndex].AdaptationSet_asArray;
        var i, len;

        for (i = 0, len = adaptations.length; i < len; i++) {
            if (adaptations[i].hasOwnProperty('id') && adaptations[i].id === id) {
                return adaptations[i];
            }
        }

        return null;
    }

    function getAdaptationForIndex(index, manifest, periodIndex) {
        var adaptations = manifest.Period_asArray[periodIndex].AdaptationSet_asArray;
        return adaptations[index];
    }

    function getIndexForAdaptation(adaptation, manifest, periodIndex) {

        var adaptations = manifest.Period_asArray[periodIndex].AdaptationSet_asArray;
        var i, len;

        for (i = 0, len = adaptations.length; i < len; i++) {
            if (adaptations[i] === adaptation) {
                return i;
            }
        }

        return -1;
    }

    function getAdaptationsForType(manifest, periodIndex, type) {

        var adaptationSet = manifest.Period_asArray[periodIndex].AdaptationSet_asArray;
        var i, len;
        var adaptations = [];

        for (i = 0, len = adaptationSet.length; i < len; i++) {
            if (getIsTypeOf(adaptationSet[i], type)) {
                adaptations.push(processAdaptation(adaptationSet[i]));
            }
        }

        return adaptations;
    }

    function getAdaptationForType(manifest, periodIndex, type, streamInfo) {

        var adaptations = getAdaptationsForType(manifest, periodIndex, type);

        if (!adaptations || adaptations.length === 0) return null;

        if (adaptations.length > 1 && streamInfo) {
            var currentTrack = mediaController.getCurrentTrackFor(type, streamInfo);
            var allMediaInfoForType = adaptor.getAllMediaInfoForType(manifest, streamInfo, type);
            for (var i = 0, ln = adaptations.length; i < ln; i++) {
                if (currentTrack && mediaController.isTracksEqual(currentTrack, allMediaInfoForType[i])) {
                    return adaptations[i];
                }
                if (getIsMain(adaptations[i])) {
                    return adaptations[i];
                }
            }
        }

        return adaptations[0];
    }

    function getCodec(adaptation) {
        var representation = adaptation.Representation_asArray[0];
        return representation.mimeType + ';codecs="' + representation.codecs + '"';
    }

    function getMimeType(adaptation) {
        return adaptation.Representation_asArray[0].mimeType;
    }

    function getKID(adaptation) {
        if (!adaptation || !adaptation.hasOwnProperty('cenc:default_KID')) {
            return null;
        }
        return adaptation['cenc:default_KID'];
    }

    function getContentProtectionData(adaptation) {
        if (!adaptation || !adaptation.hasOwnProperty('ContentProtection_asArray') || adaptation.ContentProtection_asArray.length === 0) {
            return null;
        }
        return adaptation.ContentProtection_asArray;
    }

    function getIsDynamic(manifest) {
        var isDynamic = false;
        if (manifest.hasOwnProperty('type')) {
            isDynamic = manifest.type === 'dynamic';
        }
        return isDynamic;
    }

    function getIsDVR(manifest) {
        var isDynamic = getIsDynamic(manifest);
        var containsDVR, isDVR;

        containsDVR = !isNaN(manifest.timeShiftBufferDepth);
        isDVR = isDynamic && containsDVR;

        return isDVR;
    }

    function hasProfile(manifest, profile) {
        var has = false;

        if (manifest.profiles && manifest.profiles.length > 0) {
            has = manifest.profiles.indexOf(profile) !== -1;
        }

        return has;
    }

    function getIsOnDemand(manifest) {
        return hasProfile(manifest, 'urn:mpeg:dash:profile:isoff-on-demand:2011');
    }

    function getIsDVB(manifest) {
        return hasProfile(manifest, 'urn:dvb:dash:profile:dvb-dash:2014');
    }

    function getDuration(manifest) {
        var mpdDuration;
        //@mediaPresentationDuration specifies the duration of the entire Media Presentation.
        //If the attribute is not present, the duration of the Media Presentation is unknown.
        if (manifest.hasOwnProperty('mediaPresentationDuration')) {
            mpdDuration = manifest.mediaPresentationDuration;
        } else {
            mpdDuration = Number.MAX_VALUE;
        }

        return mpdDuration;
    }

    function getBandwidth(representation) {
        return representation.bandwidth;
    }

    function getManifestUpdatePeriod(manifest) {
        var latencyOfLastUpdate = arguments.length <= 1 || arguments[1] === undefined ? 0 : arguments[1];

        var delay = NaN;
        if (manifest.hasOwnProperty('minimumUpdatePeriod')) {
            delay = manifest.minimumUpdatePeriod;
        }
        return isNaN(delay) ? delay : Math.max(delay - latencyOfLastUpdate, 1);
    }

    function getRepresentationCount(adaptation) {
        return adaptation.Representation_asArray.length;
    }

    function getBitrateListForAdaptation(adaptation) {
        if (!adaptation || !adaptation.Representation_asArray || !adaptation.Representation_asArray.length) return null;

        var a = processAdaptation(adaptation);
        var reps = a.Representation_asArray;
        var ln = reps.length;
        var bitrateList = [];

        for (var i = 0; i < ln; i++) {
            bitrateList.push({
                bandwidth: reps[i].bandwidth,
                width: reps[i].width || 0,
                height: reps[i].height || 0
            });
        }

        return bitrateList;
    }

    function getRepresentationFor(index, adaptation) {
        return adaptation.Representation_asArray[index];
    }

    function getRepresentationsForAdaptation(manifest, adaptation) {
        var a = processAdaptation(manifest.Period_asArray[adaptation.period.index].AdaptationSet_asArray[adaptation.index]);
        var representations = [];
        var representation, initialization, segmentInfo, r, s;

        for (var i = 0; i < a.Representation_asArray.length; i++) {
            r = a.Representation_asArray[i];
            representation = new _voRepresentation2['default']();
            representation.index = i;
            representation.adaptation = adaptation;

            if (r.hasOwnProperty('id')) {
                representation.id = r.id;
            }

            if (r.hasOwnProperty('codecs')) {
                representation.codecs = r.codecs;
            }
            if (r.hasOwnProperty('codecPrivateData')) {
                representation.codecPrivateData = r.codecPrivateData;
            }

            if (r.hasOwnProperty('bandwidth')) {
                representation.bandwidth = r.bandwidth;
            }
            if (r.hasOwnProperty('width')) {
                representation.width = r.width;
            }
            if (r.hasOwnProperty('height')) {
                representation.height = r.height;
            }
            if (r.hasOwnProperty('maxPlayoutRate')) {
                representation.maxPlayoutRate = r.maxPlayoutRate;
            }
            if (r.hasOwnProperty('SegmentBase')) {
                segmentInfo = r.SegmentBase;
                representation.segmentInfoType = 'SegmentBase';
            } else if (r.hasOwnProperty('SegmentList')) {
                segmentInfo = r.SegmentList;

                if (segmentInfo.hasOwnProperty('SegmentTimeline')) {
                    representation.segmentInfoType = 'SegmentTimeline';
                    s = segmentInfo.SegmentTimeline.S_asArray[segmentInfo.SegmentTimeline.S_asArray.length - 1];
                    if (!s.hasOwnProperty('r') || s.r >= 0) {
                        representation.useCalculatedLiveEdgeTime = true;
                    }
                } else {
                    representation.segmentInfoType = 'SegmentList';
                    representation.useCalculatedLiveEdgeTime = true;
                }
            } else if (r.hasOwnProperty('SegmentTemplate')) {
                segmentInfo = r.SegmentTemplate;

                if (segmentInfo.hasOwnProperty('SegmentTimeline')) {
                    representation.segmentInfoType = 'SegmentTimeline';
                    s = segmentInfo.SegmentTimeline.S_asArray[segmentInfo.SegmentTimeline.S_asArray.length - 1];
                    if (!s.hasOwnProperty('r') || s.r >= 0) {
                        representation.useCalculatedLiveEdgeTime = true;
                    }
                } else {
                    representation.segmentInfoType = 'SegmentTemplate';
                }

                if (segmentInfo.hasOwnProperty('initialization')) {
                    representation.initialization = segmentInfo.initialization.split('$Bandwidth$').join(r.bandwidth).split('$RepresentationID$').join(r.id);
                }
            } else {
                representation.segmentInfoType = 'BaseURL';
            }

            if (segmentInfo) {
                if (segmentInfo.hasOwnProperty('Initialization')) {
                    initialization = segmentInfo.Initialization;
                    if (initialization.hasOwnProperty('sourceURL')) {
                        representation.initialization = initialization.sourceURL;
                    } else if (initialization.hasOwnProperty('range')) {
                        representation.range = initialization.range;
                        // initialization source url will be determined from
                        // BaseURL when resolved at load time.
                    }
                } else if (r.hasOwnProperty('mimeType') && getIsTextTrack(r.mimeType)) {
                        representation.range = 0;
                    }

                if (segmentInfo.hasOwnProperty('timescale')) {
                    representation.timescale = segmentInfo.timescale;
                }
                if (segmentInfo.hasOwnProperty('duration')) {
                    // TODO according to the spec @maxSegmentDuration specifies the maximum duration of any Segment in any Representation in the Media Presentation
                    // It is also said that for a SegmentTimeline any @d value shall not exceed the value of MPD@maxSegmentDuration, but nothing is said about
                    // SegmentTemplate @duration attribute. We need to find out if @maxSegmentDuration should be used instead of calculated duration if the the duration
                    // exceeds @maxSegmentDuration
                    //representation.segmentDuration = Math.min(segmentInfo.duration / representation.timescale, adaptation.period.mpd.maxSegmentDuration);
                    representation.segmentDuration = segmentInfo.duration / representation.timescale;
                }
                if (segmentInfo.hasOwnProperty('startNumber')) {
                    representation.startNumber = segmentInfo.startNumber;
                }
                if (segmentInfo.hasOwnProperty('indexRange')) {
                    representation.indexRange = segmentInfo.indexRange;
                }
                if (segmentInfo.hasOwnProperty('presentationTimeOffset')) {
                    representation.presentationTimeOffset = segmentInfo.presentationTimeOffset / representation.timescale;
                }
            }

            representation.MSETimeOffset = timelineConverter.calcMSETimeOffset(representation);

            representation.path = [adaptation.period.index, adaptation.index, i];

            representations.push(representation);
        }

        return representations;
    }

    function getAdaptationsForPeriod(manifest, period) {
        var p = manifest.Period_asArray[period.index];
        var adaptations = [];
        var adaptationSet, a;

        for (var i = 0; i < p.AdaptationSet_asArray.length; i++) {
            a = p.AdaptationSet_asArray[i];
            adaptationSet = new _voAdaptationSet2['default']();

            if (a.hasOwnProperty('id')) {
                adaptationSet.id = a.id;
            }

            adaptationSet.index = i;
            adaptationSet.period = period;

            if (getIsMuxed(a)) {
                adaptationSet.type = 'muxed';
            } else if (getIsAudio(a)) {
                adaptationSet.type = 'audio';
            } else if (getIsVideo(a)) {
                adaptationSet.type = 'video';
            } else if (getIsFragmentedText(a)) {
                adaptationSet.type = 'fragmentedText';
            } else {
                adaptationSet.type = 'text';
            }

            adaptations.push(adaptationSet);
        }

        return adaptations;
    }

    function getRegularPeriods(manifest, mpd) {
        var isDynamic = getIsDynamic(manifest);
        var periods = [];
        var p1 = null;
        var p = null;
        var vo1 = null;
        var vo = null;
        var len, i;

        for (i = 0, len = manifest.Period_asArray.length; i < len; i++) {
            p = manifest.Period_asArray[i];

            // If the attribute @start is present in the Period, then the
            // Period is a regular Period and the PeriodStart is equal
            // to the value of this attribute.
            if (p.hasOwnProperty('start')) {
                vo = new _voPeriod2['default']();
                vo.start = p.start;
            }
            // If the @start attribute is absent, but the previous Period
            // element contains a @duration attribute then then this new
            // Period is also a regular Period. The start time of the new
            // Period PeriodStart is the sum of the start time of the previous
            // Period PeriodStart and the value of the attribute @duration
            // of the previous Period.
            else if (p1 !== null && p.hasOwnProperty('duration') && vo1 !== null) {
                    vo = new _voPeriod2['default']();
                    vo.start = vo1.start + vo1.duration;
                    vo.duration = p.duration;
                }
                // If (i) @start attribute is absent, and (ii) the Period element
                // is the first in the MPD, and (iii) the MPD@type is 'static',
                // then the PeriodStart time shall be set to zero.
                else if (i === 0 && !isDynamic) {
                        vo = new _voPeriod2['default']();
                        vo.start = 0;
                    }

            // The Period extends until the PeriodStart of the next Period.
            // The difference between the PeriodStart time of a Period and
            // the PeriodStart time of the following Period.
            if (vo1 !== null && isNaN(vo1.duration)) {
                vo1.duration = vo.start - vo1.start;
            }

            if (vo !== null) {
                vo.id = getPeriodId(p, i);
            }

            if (vo !== null && p.hasOwnProperty('duration')) {
                vo.duration = p.duration;
            }

            if (vo !== null) {
                vo.index = i;
                vo.mpd = mpd;
                periods.push(vo);
                p1 = p;
                vo1 = vo;
            }

            p = null;
            vo = null;
        }

        if (periods.length === 0) {
            return periods;
        }

        // The last Period extends until the end of the Media Presentation.
        // The difference between the PeriodStart time of the last Period
        // and the mpd duration
        if (vo1 !== null && isNaN(vo1.duration)) {
            vo1.duration = getEndTimeForLastPeriod(manifest, vo1) - vo1.start;
        }

        return periods;
    }

    function getPeriodId(p, i) {
        if (!p) {
            throw new Error('Period cannot be null or undefined');
        }

        var id = _voPeriod2['default'].DEFAULT_ID + '_' + i;

        if (p.hasOwnProperty('id') && p.id !== '__proto__') {
            id = p.id;
        }

        return id;
    }

    function getMpd(manifest) {
        var mpd = new _voMpd2['default']();

        mpd.manifest = manifest;

        if (manifest.hasOwnProperty('availabilityStartTime')) {
            mpd.availabilityStartTime = new Date(manifest.availabilityStartTime.getTime());
        } else {
            mpd.availabilityStartTime = new Date(manifest.loadedTime.getTime());
        }

        if (manifest.hasOwnProperty('availabilityEndTime')) {
            mpd.availabilityEndTime = new Date(manifest.availabilityEndTime.getTime());
        }

        if (manifest.hasOwnProperty('minimumUpdatePeriod')) {
            mpd.minimumUpdatePeriod = manifest.minimumUpdatePeriod;
        }

        if (manifest.hasOwnProperty('mediaPresentationDuration')) {
            mpd.mediaPresentationDuration = manifest.mediaPresentationDuration;
        }

        if (manifest.hasOwnProperty('suggestedPresentationDelay')) {
            mpd.suggestedPresentationDelay = manifest.suggestedPresentationDelay;
        }

        if (manifest.hasOwnProperty('timeShiftBufferDepth')) {
            mpd.timeShiftBufferDepth = manifest.timeShiftBufferDepth;
        }

        if (manifest.hasOwnProperty('maxSegmentDuration')) {
            mpd.maxSegmentDuration = manifest.maxSegmentDuration;
        }

        return mpd;
    }

    function getEndTimeForLastPeriod(manifest, period) {
        var isDynamic = getIsDynamic(manifest);

        var periodEnd = undefined;
        if (manifest.mediaPresentationDuration) {
            periodEnd = manifest.mediaPresentationDuration;
        } else if (period.duration) {
            periodEnd = period.duration;
        } else if (isDynamic) {
            periodEnd = Number.POSITIVE_INFINITY;
        } else {
            throw new Error('Must have @mediaPresentationDuratio on MPD or an explicit @duration on the last period.');
        }

        return periodEnd;
    }

    function getEventsForPeriod(manifest, period) {

        var periodArray = manifest.Period_asArray;
        var eventStreams = periodArray[period.index].EventStream_asArray;
        var events = [];

        if (eventStreams) {
            for (var i = 0; i < eventStreams.length; i++) {
                var eventStream = new _voEventStream2['default']();
                eventStream.period = period;
                eventStream.timescale = 1;

                if (eventStreams[i].hasOwnProperty('schemeIdUri')) {
                    eventStream.schemeIdUri = eventStreams[i].schemeIdUri;
                } else {
                    throw new Error('Invalid EventStream. SchemeIdUri has to be set');
                }
                if (eventStreams[i].hasOwnProperty('timescale')) {
                    eventStream.timescale = eventStreams[i].timescale;
                }
                if (eventStreams[i].hasOwnProperty('value')) {
                    eventStream.value = eventStreams[i].value;
                }
                for (var j = 0; j < eventStreams[i].Event_asArray.length; j++) {
                    var event = new _voEvent2['default']();
                    event.presentationTime = 0;
                    event.eventStream = eventStream;

                    if (eventStreams[i].Event_asArray[j].hasOwnProperty('presentationTime')) {
                        event.presentationTime = eventStreams[i].Event_asArray[j].presentationTime;
                    }
                    if (eventStreams[i].Event_asArray[j].hasOwnProperty('duration')) {
                        event.duration = eventStreams[i].Event_asArray[j].duration;
                    }
                    if (eventStreams[i].Event_asArray[j].hasOwnProperty('id')) {
                        event.id = eventStreams[i].Event_asArray[j].id;
                    }
                    events.push(event);
                }
            }
        }

        return events;
    }

    function getEventStreams(inbandStreams, representation) {
        var eventStreams = [];

        if (!inbandStreams) return eventStreams;

        for (var i = 0; i < inbandStreams.length; i++) {
            var eventStream = new _voEventStream2['default']();
            eventStream.timescale = 1;
            eventStream.representation = representation;

            if (inbandStreams[i].hasOwnProperty('schemeIdUri')) {
                eventStream.schemeIdUri = inbandStreams[i].schemeIdUri;
            } else {
                throw new Error('Invalid EventStream. SchemeIdUri has to be set');
            }
            if (inbandStreams[i].hasOwnProperty('timescale')) {
                eventStream.timescale = inbandStreams[i].timescale;
            }
            if (inbandStreams[i].hasOwnProperty('value')) {
                eventStream.value = inbandStreams[i].value;
            }
            eventStreams.push(eventStream);
        }

        return eventStreams;
    }

    function getEventStreamForAdaptationSet(manifest, adaptation) {
        if (!adaptation || !manifest) return [];
        var inbandStreams = manifest.Period_asArray[adaptation.period.index].AdaptationSet_asArray[adaptation.index].InbandEventStream_asArray;

        return getEventStreams(inbandStreams, null);
    }

    function getEventStreamForRepresentation(manifest, representation) {
        var inbandStreams = manifest.Period_asArray[representation.adaptation.period.index].AdaptationSet_asArray[representation.adaptation.index].Representation_asArray[representation.index].InbandEventStream_asArray;

        return getEventStreams(inbandStreams, representation);
    }

    function getUTCTimingSources(manifest) {

        var isDynamic = getIsDynamic(manifest);
        var hasAST = manifest.hasOwnProperty('availabilityStartTime');
        var utcTimingsArray = manifest.UTCTiming_asArray;
        var utcTimingEntries = [];

        // do not bother synchronizing the clock unless MPD is live,
        // or it is static and has availabilityStartTime attribute
        if (isDynamic || hasAST) {
            if (utcTimingsArray) {
                // the order is important here - 23009-1 states that the order
                // in the manifest "indicates relative preference, first having
                // the highest, and the last the lowest priority".
                utcTimingsArray.forEach(function (utcTiming) {
                    var entry = new _voUTCTiming2['default']();

                    if (utcTiming.hasOwnProperty('schemeIdUri')) {
                        entry.schemeIdUri = utcTiming.schemeIdUri;
                    } else {
                        // entries of type DescriptorType with no schemeIdUri
                        // are meaningless. let's just ignore this entry and
                        // move on.
                        return;
                    }

                    // this is (incorrectly) interpreted as a number - schema
                    // defines it as a string
                    if (utcTiming.hasOwnProperty('value')) {
                        entry.value = utcTiming.value.toString();
                    } else {
                        // without a value, there's not a lot we can do with
                        // this entry. let's just ignore this one and move on
                        return;
                    }

                    // we're not interested in the optional id or any other
                    // attributes which might be attached to the entry

                    utcTimingEntries.push(entry);
                });
            }
        }

        return utcTimingEntries;
    }

    function getBaseURLsFromElement(node) {
        var baseUrls = [];
        // if node.BaseURL_asArray and node.baseUri are undefined entries
        // will be [undefined] which entries.some will just skip
        var entries = node.BaseURL_asArray || [node.baseUri];
        var earlyReturn = false;

        entries.some(function (entry) {
            if (entry) {
                var baseUrl = new _voBaseURL2['default']();
                var text = entry.__text || entry;

                if (urlUtils.isRelative(text)) {
                    // it doesn't really make sense to have relative and
                    // absolute URLs at the same level, or multiple
                    // relative URLs at the same level, so assume we are
                    // done from this level of the MPD
                    earlyReturn = true;

                    // deal with the specific case where the MPD@BaseURL
                    // is specified and is relative. when no MPD@BaseURL
                    // entries exist, that case is handled by the
                    // [node.baseUri] in the entries definition.
                    if (node.baseUri) {
                        text = node.baseUri + text;
                    }
                }

                baseUrl.url = text;

                // serviceLocation is optional, but we need it in order
                // to blacklist correctly. if it's not available, use
                // anything unique since there's no relationship to any
                // other BaseURL and, in theory, the url should be
                // unique so use this instead.
                if (entry.hasOwnProperty('serviceLocation') && entry.serviceLocation.length) {
                    baseUrl.serviceLocation = entry.serviceLocation;
                } else {
                    baseUrl.serviceLocation = text;
                }

                if (entry.hasOwnProperty('dvb:priority')) {
                    baseUrl.dvb_priority = entry['dvb:priority'];
                }

                if (entry.hasOwnProperty('dvb:weight')) {
                    baseUrl.dvb_weight = entry['dvb:weight'];
                }

                /* NOTE: byteRange, availabilityTimeOffset,
                 * availabilityTimeComplete currently unused
                 */

                baseUrls.push(baseUrl);

                return earlyReturn;
            }
        });

        return baseUrls;
    }

    function getLocation(manifest) {
        if (manifest.hasOwnProperty('Location')) {
            // for now, do not support multiple Locations -
            // just set Location to the first Location.
            manifest.Location = manifest.Location_asArray[0];
        }

        // may well be undefined
        return manifest.Location;
    }

    instance = {
        getIsTypeOf: getIsTypeOf,
        getIsAudio: getIsAudio,
        getIsVideo: getIsVideo,
        getIsText: getIsText,
        getIsMuxed: getIsMuxed,
        getIsTextTrack: getIsTextTrack,
        getIsFragmentedText: getIsFragmentedText,
        getIsMain: getIsMain,
        getLanguageForAdaptation: getLanguageForAdaptation,
        getViewpointForAdaptation: getViewpointForAdaptation,
        getRolesForAdaptation: getRolesForAdaptation,
        getAccessibilityForAdaptation: getAccessibilityForAdaptation,
        getAudioChannelConfigurationForAdaptation: getAudioChannelConfigurationForAdaptation,
        processAdaptation: processAdaptation,
        getAdaptationForIndex: getAdaptationForIndex,
        getIndexForAdaptation: getIndexForAdaptation,
        getAdaptationForId: getAdaptationForId,
        getAdaptationsForType: getAdaptationsForType,
        getAdaptationForType: getAdaptationForType,
        getCodec: getCodec,
        getMimeType: getMimeType,
        getKID: getKID,
        getContentProtectionData: getContentProtectionData,
        getIsDynamic: getIsDynamic,
        getIsDVR: getIsDVR,
        getIsOnDemand: getIsOnDemand,
        getIsDVB: getIsDVB,
        getDuration: getDuration,
        getBandwidth: getBandwidth,
        getManifestUpdatePeriod: getManifestUpdatePeriod,
        getRepresentationCount: getRepresentationCount,
        getBitrateListForAdaptation: getBitrateListForAdaptation,
        getRepresentationFor: getRepresentationFor,
        getRepresentationsForAdaptation: getRepresentationsForAdaptation,
        getAdaptationsForPeriod: getAdaptationsForPeriod,
        getRegularPeriods: getRegularPeriods,
        getMpd: getMpd,
        getEventsForPeriod: getEventsForPeriod,
        getEventStreams: getEventStreams,
        getEventStreamForAdaptationSet: getEventStreamForAdaptationSet,
        getEventStreamForRepresentation: getEventStreamForRepresentation,
        getUTCTimingSources: getUTCTimingSources,
        getBaseURLsFromElement: getBaseURLsFromElement,
        getRepresentationSortFunction: getRepresentationSortFunction,
        getLocation: getLocation
    };

    return instance;
}

DashManifestModel.__dashjs_factory_name = 'DashManifestModel';
exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(DashManifestModel);
module.exports = exports['default'];
//# sourceMappingURL=DashManifestModel.js.map


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _voBitrateInfo = __webpack_require__(1417);

var _voBitrateInfo2 = _interopRequireDefault(_voBitrateInfo);

var _utilsDOMStorage = __webpack_require__(407);

var _utilsDOMStorage2 = _interopRequireDefault(_utilsDOMStorage);

var _modelsMediaPlayerModel = __webpack_require__(67);

var _modelsMediaPlayerModel2 = _interopRequireDefault(_modelsMediaPlayerModel);

var _modelsFragmentModel = __webpack_require__(324);

var _modelsFragmentModel2 = _interopRequireDefault(_modelsFragmentModel);

var _coreEventBus = __webpack_require__(27);

var _coreEventBus2 = _interopRequireDefault(_coreEventBus);

var _coreEventsEvents = __webpack_require__(22);

var _coreEventsEvents2 = _interopRequireDefault(_coreEventsEvents);

var _MediaPlayerEventsJs = __webpack_require__(238);

var _MediaPlayerEventsJs2 = _interopRequireDefault(_MediaPlayerEventsJs);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _modelsManifestModel = __webpack_require__(325);

var _modelsManifestModel2 = _interopRequireDefault(_modelsManifestModel);

var _dashModelsDashManifestModel = __webpack_require__(158);

var _dashModelsDashManifestModel2 = _interopRequireDefault(_dashModelsDashManifestModel);

var _modelsVideoModel = __webpack_require__(240);

var _modelsVideoModel2 = _interopRequireDefault(_modelsVideoModel);

var _rulesRulesContextJs = __webpack_require__(1393);

var _rulesRulesContextJs2 = _interopRequireDefault(_rulesRulesContextJs);

var _rulesSwitchRequestJs = __webpack_require__(128);

var _rulesSwitchRequestJs2 = _interopRequireDefault(_rulesSwitchRequestJs);

var _rulesSwitchRequestHistoryJs = __webpack_require__(1394);

var _rulesSwitchRequestHistoryJs2 = _interopRequireDefault(_rulesSwitchRequestHistoryJs);

var _rulesDroppedFramesHistoryJs = __webpack_require__(1392);

var _rulesDroppedFramesHistoryJs2 = _interopRequireDefault(_rulesDroppedFramesHistoryJs);

var _modelsMetricsModelJs = __webpack_require__(135);

var _modelsMetricsModelJs2 = _interopRequireDefault(_modelsMetricsModelJs);

var _dashDashMetricsJs = __webpack_require__(157);

var _dashDashMetricsJs2 = _interopRequireDefault(_dashDashMetricsJs);

var _coreDebug = __webpack_require__(30);

var _coreDebug2 = _interopRequireDefault(_coreDebug);

var ABANDON_LOAD = 'abandonload';
var ALLOW_LOAD = 'allowload';
var DEFAULT_VIDEO_BITRATE = 1000;
var DEFAULT_AUDIO_BITRATE = 100;
var QUALITY_DEFAULT = 0;

function AbrController() {

    var context = this.context;
    var debug = (0, _coreDebug2['default'])(context).getInstance();
    var log = debug.log;
    var eventBus = (0, _coreEventBus2['default'])(context).getInstance();

    var instance = undefined,
        abrRulesCollection = undefined,
        streamController = undefined,
        autoSwitchBitrate = undefined,
        topQualities = undefined,
        qualityDict = undefined,
        bitrateDict = undefined,
        ratioDict = undefined,
        averageThroughputDict = undefined,
        streamProcessorDict = undefined,
        abandonmentStateDict = undefined,
        abandonmentTimeout = undefined,
        limitBitrateByPortal = undefined,
        usePixelRatioInLimitBitrateByPortal = undefined,
        windowResizeEventCalled = undefined,
        elementWidth = undefined,
        elementHeight = undefined,
        manifestModel = undefined,
        dashManifestModel = undefined,
        videoModel = undefined,
        mediaPlayerModel = undefined,
        domStorage = undefined,
        playbackIndex = undefined,
        switchHistoryDict = undefined,
        droppedFramesHistory = undefined,
        metricsModel = undefined,
        dashMetrics = undefined,
        lastSwitchTime = undefined;

    function setup() {
        autoSwitchBitrate = { video: true, audio: true };
        topQualities = {};
        qualityDict = {};
        bitrateDict = {};
        ratioDict = {};
        averageThroughputDict = {};
        abandonmentStateDict = {};
        streamProcessorDict = {};
        switchHistoryDict = {};
        limitBitrateByPortal = false;
        usePixelRatioInLimitBitrateByPortal = false;
        if (windowResizeEventCalled === undefined) {
            windowResizeEventCalled = false;
        }
        domStorage = (0, _utilsDOMStorage2['default'])(context).getInstance();
        mediaPlayerModel = (0, _modelsMediaPlayerModel2['default'])(context).getInstance();
        manifestModel = (0, _modelsManifestModel2['default'])(context).getInstance();
        dashManifestModel = (0, _dashModelsDashManifestModel2['default'])(context).getInstance();
        videoModel = (0, _modelsVideoModel2['default'])(context).getInstance();
        metricsModel = (0, _modelsMetricsModelJs2['default'])(context).getInstance();
        dashMetrics = (0, _dashDashMetricsJs2['default'])(context).getInstance();
        lastSwitchTime = new Date().getTime() / 1000;
    }

    function initialize(type, streamProcessor) {
        switchHistoryDict[type] = (0, _rulesSwitchRequestHistoryJs2['default'])(context).create();
        streamProcessorDict[type] = streamProcessor;
        abandonmentStateDict[type] = abandonmentStateDict[type] || {};
        abandonmentStateDict[type].state = ALLOW_LOAD;
        eventBus.on(_coreEventsEvents2['default'].LOADING_PROGRESS, onFragmentLoadProgress, this);
        if (type == 'video') {
            eventBus.on(_MediaPlayerEventsJs2['default'].QUALITY_CHANGE_RENDERED, onQualityChangeRendered, this);
            droppedFramesHistory = (0, _rulesDroppedFramesHistoryJs2['default'])(context).create();
            setElementSize();
        }
    }

    function reset() {
        eventBus.off(_coreEventsEvents2['default'].LOADING_PROGRESS, onFragmentLoadProgress, this);
        eventBus.off(_MediaPlayerEventsJs2['default'].QUALITY_CHANGE_RENDERED, onQualityChangeRendered, this);
        playbackIndex = undefined;
        droppedFramesHistory = undefined;
        clearTimeout(abandonmentTimeout);
        abandonmentTimeout = null;
        setup();
    }

    function setConfig(config) {
        if (!config) return;

        if (config.abrRulesCollection) {
            abrRulesCollection = config.abrRulesCollection;
        }
        if (config.streamController) {
            streamController = config.streamController;
        }
    }

    function onQualityChangeRendered(e) {
        if (e.mediaType === 'video') {
            playbackIndex = e.newQuality;
            droppedFramesHistory.push(playbackIndex, videoModel.getPlaybackQuality());
        }
    }

    function getTopQualityIndexFor(type, id) {
        var idx;
        topQualities[id] = topQualities[id] || {};

        if (!topQualities[id].hasOwnProperty(type)) {
            topQualities[id][type] = 0;
        }

        idx = checkMaxBitrate(topQualities[id][type], type);
        idx = checkMaxRepresentationRatio(idx, type, topQualities[id][type]);
        idx = checkPortalSize(idx, type);
        return idx;
    }

    /**
     * @param {string} type
     * @returns {number} A value of the initial bitrate, kbps
     * @memberof AbrController#
     */
    function getInitialBitrateFor(type) {

        var savedBitrate = domStorage.getSavedBitrateSettings(type);

        if (!bitrateDict.hasOwnProperty(type)) {
            if (ratioDict.hasOwnProperty(type)) {
                var manifest = manifestModel.getValue();
                var representation = dashManifestModel.getAdaptationForType(manifest, 0, type).Representation;

                if (Array.isArray(representation)) {
                    var repIdx = Math.max(Math.round(representation.length * ratioDict[type]) - 1, 0);
                    bitrateDict[type] = representation[repIdx].bandwidth;
                } else {
                    bitrateDict[type] = 0;
                }
            } else if (!isNaN(savedBitrate)) {
                bitrateDict[type] = savedBitrate;
            } else {
                bitrateDict[type] = type === 'video' ? DEFAULT_VIDEO_BITRATE : DEFAULT_AUDIO_BITRATE;
            }
        }

        return bitrateDict[type];
    }

    /**
     * @param {string} type
     * @param {number} value A value of the initial bitrate, kbps
     * @memberof AbrController#
     */
    function setInitialBitrateFor(type, value) {
        bitrateDict[type] = value;
    }

    function getInitialRepresentationRatioFor(type) {
        if (!ratioDict.hasOwnProperty(type)) {
            return null;
        }

        return ratioDict[type];
    }

    function setInitialRepresentationRatioFor(type, value) {
        ratioDict[type] = value;
    }

    function getMaxAllowedBitrateFor(type) {
        if (bitrateDict.hasOwnProperty('max') && bitrateDict.max.hasOwnProperty(type)) {
            return bitrateDict.max[type];
        }
        return NaN;
    }

    function getMinAllowedBitrateFor(type) {
        if (bitrateDict.hasOwnProperty('min') && bitrateDict.min.hasOwnProperty(type)) {
            return bitrateDict.min[type];
        }
        return NaN;
    }

    //TODO  change bitrateDict structure to hold one object for video and audio with initial and max values internal.
    // This means you need to update all the logic around initial bitrate DOMStorage, RebController etc...
    function setMaxAllowedBitrateFor(type, value) {
        bitrateDict.max = bitrateDict.max || {};
        bitrateDict.max[type] = value;
    }

    function setMinAllowedBitrateFor(type, value) {
        bitrateDict.min = bitrateDict.min || {};
        bitrateDict.min[type] = value;
    }

    function getMaxAllowedRepresentationRatioFor(type) {
        if (ratioDict.hasOwnProperty('max') && ratioDict.max.hasOwnProperty(type)) {
            return ratioDict.max[type];
        }
        return 1;
    }

    function setMaxAllowedRepresentationRatioFor(type, value) {
        ratioDict.max = ratioDict.max || {};
        ratioDict.max[type] = value;
    }

    function getAutoSwitchBitrateFor(type) {
        return autoSwitchBitrate[type];
    }

    function setAutoSwitchBitrateFor(type, value) {
        autoSwitchBitrate[type] = value;
    }

    function getLimitBitrateByPortal() {
        return limitBitrateByPortal;
    }

    function setLimitBitrateByPortal(value) {
        limitBitrateByPortal = value;
    }

    function getUsePixelRatioInLimitBitrateByPortal() {
        return usePixelRatioInLimitBitrateByPortal;
    }

    function setUsePixelRatioInLimitBitrateByPortal(value) {
        usePixelRatioInLimitBitrateByPortal = value;
    }

    function getPlaybackQuality(streamProcessor) {
        var type = streamProcessor.getType();
        var streamInfo = streamProcessor.getStreamInfo();
        var streamId = streamInfo.id;
        var oldQuality = getQualityFor(type, streamInfo);
        var rulesContext = (0, _rulesRulesContextJs2['default'])(context).create({
            streamProcessor: streamProcessor,
            currentValue: oldQuality,
            playbackIndex: playbackIndex,
            switchHistory: switchHistoryDict[type],
            droppedFramesHistory: droppedFramesHistory,
            hasRichBuffer: hasRichBuffer(type)
        });

        if (droppedFramesHistory) {
            droppedFramesHistory.push(playbackIndex, videoModel.getPlaybackQuality());
        }

        //log("ABR enabled? (" + autoSwitchBitrate + ")");
        if (getAutoSwitchBitrateFor(type)) {
            var topQualityIdx = getTopQualityIndexFor(type, streamId);
            var switchRequest = abrRulesCollection.getMaxQuality(rulesContext);
            var newQuality = switchRequest.value;
            if (newQuality > topQualityIdx) {
                newQuality = topQualityIdx;
            }
            switchHistoryDict[type].push({ oldValue: oldQuality, newValue: newQuality });

            if (newQuality > _rulesSwitchRequestJs2['default'].NO_CHANGE && newQuality != oldQuality) {
                if (abandonmentStateDict[type].state === ALLOW_LOAD || newQuality > oldQuality) {
                    changeQuality(type, streamInfo, oldQuality, newQuality, topQualityIdx, switchRequest.reason);
                }
            } else if (debug.getLogToBrowserConsole()) {
                var bufferLevel = dashMetrics.getCurrentBufferLevel(metricsModel.getReadOnlyMetricsFor(type));
                log('AbrController (' + type + ') stay on ' + oldQuality + '/' + topQualityIdx + ' (buffer: ' + bufferLevel + ')');
            }
        }
    }

    function setPlaybackQuality(type, streamInfo, newQuality, reason) {
        var id = streamInfo.id;
        var oldQuality = getQualityFor(type, streamInfo);
        var isInt = newQuality !== null && !isNaN(newQuality) && newQuality % 1 === 0;

        if (!isInt) throw new Error('argument is not an integer');

        var topQualityIdx = getTopQualityIndexFor(type, id);
        if (newQuality !== oldQuality && newQuality >= 0 && newQuality <= topQualityIdx) {
            changeQuality(type, streamInfo, oldQuality, newQuality, topQualityIdx, reason);
        }
    }

    function changeQuality(type, streamInfo, oldQuality, newQuality, topQualityIdx, reason) {
        if (debug.getLogToBrowserConsole()) {
            var bufferLevel = dashMetrics.getCurrentBufferLevel(metricsModel.getReadOnlyMetricsFor(type));
            log('AbrController (' + type + ') switch from ' + oldQuality + ' to ' + newQuality + '/' + topQualityIdx + ' (buffer: ' + bufferLevel + ')\n' + JSON.stringify(reason));
        }
        setQualityFor(type, streamInfo.id, newQuality);
        eventBus.trigger(_coreEventsEvents2['default'].QUALITY_CHANGE_REQUESTED, { mediaType: type, streamInfo: streamInfo, oldQuality: oldQuality, newQuality: newQuality, reason: reason });
    }

    function setAbandonmentStateFor(type, state) {
        abandonmentStateDict[type].state = state;
    }

    function getAbandonmentStateFor(type) {
        return abandonmentStateDict[type].state;
    }

    /**
     * @param {MediaInfo} mediaInfo
     * @param {number} bitrate A bitrate value, kbps
     * @param {number} latency Expected latency of connection, ms
     * @returns {number} A quality index <= for the given bitrate
     * @memberof AbrController#
     */
    function getQualityForBitrate(mediaInfo, bitrate, latency) {
        if (latency && streamProcessorDict[mediaInfo.type].getCurrentRepresentationInfo() && streamProcessorDict[mediaInfo.type].getCurrentRepresentationInfo().fragmentDuration) {
            latency = latency / 1000;
            var fragmentDuration = streamProcessorDict[mediaInfo.type].getCurrentRepresentationInfo().fragmentDuration;
            if (latency > fragmentDuration) {
                return 0;
            } else {
                var deadTimeRatio = latency / fragmentDuration;
                bitrate = bitrate * (1 - deadTimeRatio);
            }
        }

        var bitrateList = getBitrateList(mediaInfo);
        if (!bitrateList || bitrateList.length === 0) {
            return QUALITY_DEFAULT;
        }

        for (var i = bitrateList.length - 1; i >= 0; i--) {
            var bitrateInfo = bitrateList[i];
            if (bitrate * 1000 >= bitrateInfo.bitrate) {
                return i;
            }
        }
        return 0;
    }

    /**
     * @param {MediaInfo} mediaInfo
     * @returns {Array|null} A list of {@link BitrateInfo} objects
     * @memberof AbrController#
     */
    function getBitrateList(mediaInfo) {
        if (!mediaInfo || !mediaInfo.bitrateList) return null;

        var bitrateList = mediaInfo.bitrateList;
        var type = mediaInfo.type;

        var infoList = [];
        var bitrateInfo;

        for (var i = 0, ln = bitrateList.length; i < ln; i++) {
            bitrateInfo = new _voBitrateInfo2['default']();
            bitrateInfo.mediaType = type;
            bitrateInfo.qualityIndex = i;
            bitrateInfo.bitrate = bitrateList[i].bandwidth;
            bitrateInfo.width = bitrateList[i].width;
            bitrateInfo.height = bitrateList[i].height;
            infoList.push(bitrateInfo);
        }

        return infoList;
    }

    function hasRichBuffer(type) {
        var metrics = metricsModel.getReadOnlyMetricsFor(type);
        var bufferLevel = dashMetrics.getCurrentBufferLevel(metrics);
        var bufferState = metrics.BufferState.length > 0 ? metrics.BufferState[metrics.BufferState.length - 1] : null;
        var isBufferRich = false;

        // This will happen when another rule tries to switch down from highest quality index
        // If there is enough buffer why not try to stay at high level
        if (bufferState && bufferLevel > bufferState.target) {
            // Are we currently over the buffer target by at least RICH_BUFFER_THRESHOLD?
            isBufferRich = bufferLevel > bufferState.target + mediaPlayerModel.getRichBufferThreshold();
        }

        return isBufferRich;
    }

    function setAverageThroughput(type, value) {
        averageThroughputDict[type] = value;
    }

    function getAverageThroughput(type) {
        return averageThroughputDict[type];
    }

    function updateTopQualityIndex(mediaInfo) {
        var type = mediaInfo.type;
        var streamId = mediaInfo.streamInfo.id;
        var max = mediaInfo.representationCount - 1;

        setTopQualityIndex(type, streamId, max);

        return max;
    }

    function isPlayingAtTopQuality(streamInfo) {
        var isAtTop;
        var streamId = streamInfo.id;
        var audioQuality = getQualityFor('audio', streamInfo);
        var videoQuality = getQualityFor('video', streamInfo);

        isAtTop = audioQuality === getTopQualityIndexFor('audio', streamId) && videoQuality === getTopQualityIndexFor('video', streamId);

        return isAtTop;
    }

    function getQualityFor(type, streamInfo) {
        var id = streamInfo.id;
        var quality;

        qualityDict[id] = qualityDict[id] || {};

        if (!qualityDict[id].hasOwnProperty(type)) {
            qualityDict[id][type] = QUALITY_DEFAULT;
        }

        quality = qualityDict[id][type];
        return quality;
    }

    function setQualityFor(type, id, value) {
        qualityDict[id] = qualityDict[id] || {};
        qualityDict[id][type] = value;
    }

    function setTopQualityIndex(type, id, value) {
        topQualities[id] = topQualities[id] || {};
        topQualities[id][type] = value;
    }

    function checkMaxBitrate(idx, type) {
        var newIdx = idx;

        if (!streamProcessorDict[type]) {
            return newIdx;
        }

        var minBitrate = getMinAllowedBitrateFor(type);
        if (minBitrate) {
            var minIdx = getQualityForBitrate(streamProcessorDict[type].getMediaInfo(), minBitrate);
            newIdx = Math.max(idx, minIdx);
        }

        var maxBitrate = getMaxAllowedBitrateFor(type);
        if (maxBitrate) {
            var maxIdx = getQualityForBitrate(streamProcessorDict[type].getMediaInfo(), maxBitrate);
            newIdx = Math.min(newIdx, maxIdx);
        }

        return newIdx;
    }

    function checkMaxRepresentationRatio(idx, type, maxIdx) {
        var maxRepresentationRatio = getMaxAllowedRepresentationRatioFor(type);
        if (isNaN(maxRepresentationRatio) || maxRepresentationRatio >= 1 || maxRepresentationRatio < 0) {
            return idx;
        }
        return Math.min(idx, Math.round(maxIdx * maxRepresentationRatio));
    }

    function setWindowResizeEventCalled(value) {
        windowResizeEventCalled = value;
    }

    function setElementSize() {
        var element = videoModel.getElement();
        if (element !== undefined) {
            var hasPixelRatio = usePixelRatioInLimitBitrateByPortal && window.hasOwnProperty('devicePixelRatio');
            var pixelRatio = hasPixelRatio ? window.devicePixelRatio : 1;
            elementWidth = element.clientWidth * pixelRatio;
            elementHeight = element.clientHeight * pixelRatio;
        }
    }

    function checkPortalSize(idx, type) {
        if (type !== 'video' || !limitBitrateByPortal || !streamProcessorDict[type]) {
            return idx;
        }

        if (!windowResizeEventCalled) {
            setElementSize();
        }

        var manifest = manifestModel.getValue();
        var representation = dashManifestModel.getAdaptationForType(manifest, 0, type).Representation;
        var newIdx = idx;

        if (elementWidth > 0 && elementHeight > 0) {
            while (newIdx > 0 && representation[newIdx] && elementWidth < representation[newIdx].width && elementWidth - representation[newIdx - 1].width < representation[newIdx].width - elementWidth) {
                newIdx = newIdx - 1;
            }

            if (representation.length - 2 >= newIdx && representation[newIdx].width === representation[newIdx + 1].width) {
                newIdx = Math.min(idx, newIdx + 1);
            }
        }

        return newIdx;
    }

    function onFragmentLoadProgress(e) {
        var type = e.request.mediaType;
        if (getAutoSwitchBitrateFor(type)) {
            var scheduleController = streamProcessorDict[type].getScheduleController();
            if (!scheduleController) return; // There may be a fragment load in progress when we switch periods and recreated some controllers.

            var rulesContext = (0, _rulesRulesContextJs2['default'])(context).create({
                streamProcessor: streamProcessorDict[type],
                currentRequest: e.request,
                currentValue: getQualityFor(type, streamController.getActiveStreamInfo()),
                hasRichBuffer: hasRichBuffer(type)
            });
            var switchRequest = abrRulesCollection.shouldAbandonFragment(rulesContext);
            //Removed overrideFunc
            //    function (currentValue, newValue) {
            //        return newValue;
            //    });

            if (switchRequest.value > _rulesSwitchRequestJs2['default'].NO_CHANGE) {
                var fragmentModel = scheduleController.getFragmentModel();
                var request = fragmentModel.getRequests({ state: _modelsFragmentModel2['default'].FRAGMENT_MODEL_LOADING, index: e.request.index })[0];
                if (request) {
                    //TODO Check if we should abort or if better to finish download. check bytesLoaded/Total
                    fragmentModel.abortRequests();
                    setAbandonmentStateFor(type, ABANDON_LOAD);
                    switchHistoryDict[type].reset();
                    switchHistoryDict[type].push({ oldValue: getQualityFor(type, streamController.getActiveStreamInfo()), newValue: switchRequest.value, confidence: 1, reason: switchRequest.reason });
                    setPlaybackQuality(type, streamController.getActiveStreamInfo(), switchRequest.value, switchRequest.reason);
                    eventBus.trigger(_coreEventsEvents2['default'].FRAGMENT_LOADING_ABANDONED, { streamProcessor: streamProcessorDict[type], request: request, mediaType: type });

                    clearTimeout(abandonmentTimeout);
                    abandonmentTimeout = setTimeout(function () {
                        setAbandonmentStateFor(type, ALLOW_LOAD);abandonmentTimeout = null;
                    }, mediaPlayerModel.getAbandonLoadTimeout());
                }
            }
        }
    }

    instance = {
        isPlayingAtTopQuality: isPlayingAtTopQuality,
        updateTopQualityIndex: updateTopQualityIndex,
        getAverageThroughput: getAverageThroughput,
        getBitrateList: getBitrateList,
        getQualityForBitrate: getQualityForBitrate,
        getMaxAllowedBitrateFor: getMaxAllowedBitrateFor,
        getMinAllowedBitrateFor: getMinAllowedBitrateFor,
        setMaxAllowedBitrateFor: setMaxAllowedBitrateFor,
        setMinAllowedBitrateFor: setMinAllowedBitrateFor,
        getMaxAllowedRepresentationRatioFor: getMaxAllowedRepresentationRatioFor,
        setMaxAllowedRepresentationRatioFor: setMaxAllowedRepresentationRatioFor,
        getInitialBitrateFor: getInitialBitrateFor,
        setInitialBitrateFor: setInitialBitrateFor,
        getInitialRepresentationRatioFor: getInitialRepresentationRatioFor,
        setInitialRepresentationRatioFor: setInitialRepresentationRatioFor,
        setAutoSwitchBitrateFor: setAutoSwitchBitrateFor,
        getAutoSwitchBitrateFor: getAutoSwitchBitrateFor,
        setLimitBitrateByPortal: setLimitBitrateByPortal,
        getLimitBitrateByPortal: getLimitBitrateByPortal,
        getUsePixelRatioInLimitBitrateByPortal: getUsePixelRatioInLimitBitrateByPortal,
        setUsePixelRatioInLimitBitrateByPortal: setUsePixelRatioInLimitBitrateByPortal,
        getQualityFor: getQualityFor,
        getAbandonmentStateFor: getAbandonmentStateFor,
        setAbandonmentStateFor: setAbandonmentStateFor,
        setPlaybackQuality: setPlaybackQuality,
        getPlaybackQuality: getPlaybackQuality,
        setAverageThroughput: setAverageThroughput,
        getTopQualityIndexFor: getTopQualityIndexFor,
        setElementSize: setElementSize,
        setWindowResizeEventCalled: setWindowResizeEventCalled,
        initialize: initialize,
        setConfig: setConfig,
        reset: reset
    };

    setup();

    return instance;
}

AbrController.__dashjs_factory_name = 'AbrController';
var factory = _coreFactoryMaker2['default'].getSingletonFactory(AbrController);
factory.ABANDON_LOAD = ABANDON_LOAD;
factory.QUALITY_DEFAULT = QUALITY_DEFAULT;
exports['default'] = factory;
module.exports = exports['default'];
//# sourceMappingURL=AbrController.js.map


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _modelsFragmentModel = __webpack_require__(324);

var _modelsFragmentModel2 = _interopRequireDefault(_modelsFragmentModel);

var _modelsMediaPlayerModel = __webpack_require__(67);

var _modelsMediaPlayerModel2 = _interopRequireDefault(_modelsMediaPlayerModel);

var _SourceBufferController = __webpack_require__(322);

var _SourceBufferController2 = _interopRequireDefault(_SourceBufferController);

var _AbrController = __webpack_require__(159);

var _AbrController2 = _interopRequireDefault(_AbrController);

var _PlaybackController = __webpack_require__(161);

var _PlaybackController2 = _interopRequireDefault(_PlaybackController);

var _MediaController = __webpack_require__(188);

var _MediaController2 = _interopRequireDefault(_MediaController);

var _coreEventBus = __webpack_require__(27);

var _coreEventBus2 = _interopRequireDefault(_coreEventBus);

var _coreEventsEvents = __webpack_require__(22);

var _coreEventsEvents2 = _interopRequireDefault(_coreEventsEvents);

var _utilsBoxParser = __webpack_require__(406);

var _utilsBoxParser2 = _interopRequireDefault(_utilsBoxParser);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _coreDebug = __webpack_require__(30);

var _coreDebug2 = _interopRequireDefault(_coreDebug);

var _utilsInitCache = __webpack_require__(408);

var _utilsInitCache2 = _interopRequireDefault(_utilsInitCache);

var BUFFER_LOADED = 'bufferLoaded';
var BUFFER_EMPTY = 'bufferStalled';
var STALL_THRESHOLD = 0.5;

function BufferController(config) {

    var context = this.context;
    var log = (0, _coreDebug2['default'])(context).getInstance().log;
    var eventBus = (0, _coreEventBus2['default'])(context).getInstance();
    var metricsModel = config.metricsModel;
    var manifestModel = config.manifestModel;
    var sourceBufferController = config.sourceBufferController;
    var errHandler = config.errHandler;
    var streamController = config.streamController;
    var mediaController = config.mediaController;
    var adapter = config.adapter;
    var textController = config.textController;

    var instance = undefined,
        requiredQuality = undefined,
        isBufferingCompleted = undefined,
        bufferLevel = undefined,
        criticalBufferLevel = undefined,
        mediaSource = undefined,
        maxAppendedIndex = undefined,
        lastIndex = undefined,
        type = undefined,
        buffer = undefined,
        bufferState = undefined,
        appendedBytesInfo = undefined,
        wallclockTicked = undefined,
        appendingMediaChunk = undefined,
        isAppendingInProgress = undefined,
        isPruningInProgress = undefined,
        inbandEventFound = undefined,
        playbackController = undefined,
        streamProcessor = undefined,
        abrController = undefined,
        scheduleController = undefined,
        mediaPlayerModel = undefined,
        initCache = undefined;

    function setup() {
        requiredQuality = _AbrController2['default'].QUALITY_DEFAULT;
        isBufferingCompleted = false;
        bufferLevel = 0;
        criticalBufferLevel = Number.POSITIVE_INFINITY;
        maxAppendedIndex = 0;
        lastIndex = Number.POSITIVE_INFINITY;
        buffer = null;
        bufferState = BUFFER_EMPTY;
        wallclockTicked = 0;
        appendingMediaChunk = false;
        isAppendingInProgress = false;
        isPruningInProgress = false;
        inbandEventFound = false;
    }

    function initialize(Type, Source, StreamProcessor) {
        type = Type;
        setMediaSource(Source);
        streamProcessor = StreamProcessor;
        mediaPlayerModel = (0, _modelsMediaPlayerModel2['default'])(context).getInstance();
        playbackController = (0, _PlaybackController2['default'])(context).getInstance();
        abrController = (0, _AbrController2['default'])(context).getInstance();
        initCache = (0, _utilsInitCache2['default'])(context).getInstance();
        scheduleController = streamProcessor.getScheduleController();
        requiredQuality = abrController.getQualityFor(type, streamProcessor.getStreamInfo());

        eventBus.on(_coreEventsEvents2['default'].DATA_UPDATE_COMPLETED, onDataUpdateCompleted, this);
        eventBus.on(_coreEventsEvents2['default'].INIT_FRAGMENT_LOADED, onInitFragmentLoaded, this);
        eventBus.on(_coreEventsEvents2['default'].MEDIA_FRAGMENT_LOADED, onMediaFragmentLoaded, this);
        eventBus.on(_coreEventsEvents2['default'].QUALITY_CHANGE_REQUESTED, onQualityChanged, this);
        eventBus.on(_coreEventsEvents2['default'].STREAM_COMPLETED, onStreamCompleted, this);
        eventBus.on(_coreEventsEvents2['default'].PLAYBACK_PROGRESS, onPlaybackProgression, this);
        eventBus.on(_coreEventsEvents2['default'].PLAYBACK_TIME_UPDATED, onPlaybackProgression, this);
        eventBus.on(_coreEventsEvents2['default'].PLAYBACK_RATE_CHANGED, onPlaybackRateChanged, this);
        eventBus.on(_coreEventsEvents2['default'].PLAYBACK_SEEKING, onPlaybackSeeking, this);
        eventBus.on(_coreEventsEvents2['default'].WALLCLOCK_TIME_UPDATED, onWallclockTimeUpdated, this);
        eventBus.on(_coreEventsEvents2['default'].CURRENT_TRACK_CHANGED, onCurrentTrackChanged, this, _coreEventBus2['default'].EVENT_PRIORITY_HIGH);
        eventBus.on(_coreEventsEvents2['default'].SOURCEBUFFER_APPEND_COMPLETED, onAppended, this);
        eventBus.on(_coreEventsEvents2['default'].SOURCEBUFFER_REMOVE_COMPLETED, onRemoved, this);
    }

    function createBuffer(mediaInfo) {
        if (!mediaInfo || !mediaSource || !streamProcessor) return null;

        var sourceBuffer = null;

        try {
            sourceBuffer = sourceBufferController.createSourceBuffer(mediaSource, mediaInfo);

            if (sourceBuffer && sourceBuffer.hasOwnProperty('initialize')) {
                sourceBuffer.initialize(type, this);
            }
        } catch (e) {
            errHandler.mediaSourceError('Error creating ' + type + ' source buffer.');
        }
        setBuffer(sourceBuffer);
        updateBufferTimestampOffset(streamProcessor.getRepresentationInfoForQuality(requiredQuality).MSETimeOffset);
        return sourceBuffer;
    }

    function isActive() {
        return streamProcessor && streamController ? streamProcessor.getStreamInfo().id === streamController.getActiveStreamInfo().id : false;
    }

    function onInitFragmentLoaded(e) {
        if (e.fragmentModel !== streamProcessor.getFragmentModel()) return;
        log('Init fragment finished loading saving to', type + '\'s init cache');
        initCache.save(e.chunk);
        appendToBuffer(e.chunk);
    }

    function switchInitData(streamId, representationId) {
        var chunk = initCache.extract(streamId, representationId);
        if (chunk) {
            appendToBuffer(chunk);
        } else {
            eventBus.trigger(_coreEventsEvents2['default'].INIT_REQUESTED, { sender: instance });
        }
    }

    function onMediaFragmentLoaded(e) {
        if (e.fragmentModel !== streamProcessor.getFragmentModel()) return;

        var chunk = e.chunk;
        var bytes = chunk.bytes;
        var quality = chunk.quality;
        var currentRepresentation = streamProcessor.getRepresentationInfoForQuality(quality);
        var manifest = manifestModel.getValue();
        var eventStreamMedia = adapter.getEventsFor(manifest, currentRepresentation.mediaInfo, streamProcessor);
        var eventStreamTrack = adapter.getEventsFor(manifest, currentRepresentation, streamProcessor);

        if (eventStreamMedia && eventStreamMedia.length > 0 || eventStreamTrack && eventStreamTrack.length > 0) {
            var request = streamProcessor.getFragmentModel().getRequests({
                state: _modelsFragmentModel2['default'].FRAGMENT_MODEL_EXECUTED,
                quality: quality,
                index: chunk.index
            })[0];
            var events = handleInbandEvents(bytes, request, eventStreamMedia, eventStreamTrack);
            streamProcessor.getEventController().addInbandEvents(events);
        }

        chunk.bytes = deleteInbandEvents(bytes);
        appendToBuffer(chunk);
    }

    function appendToBuffer(chunk) {
        isAppendingInProgress = true;
        appendedBytesInfo = chunk;
        sourceBufferController.append(buffer, chunk);

        if (chunk.mediaInfo.type === 'video') {
            eventBus.trigger(_coreEventsEvents2['default'].VIDEO_CHUNK_RECEIVED, { chunk: chunk });
        }
    }

    function onAppended(e) {
        if (buffer === e.buffer) {
            if (e.error || !hasEnoughSpaceToAppend()) {
                if (e.error.code === _SourceBufferController2['default'].QUOTA_EXCEEDED_ERROR_CODE) {
                    criticalBufferLevel = sourceBufferController.getTotalBufferedTime(buffer) * 0.8;
                }
                if (e.error.code === _SourceBufferController2['default'].QUOTA_EXCEEDED_ERROR_CODE || !hasEnoughSpaceToAppend()) {
                    eventBus.trigger(_coreEventsEvents2['default'].QUOTA_EXCEEDED, { sender: instance, criticalBufferLevel: criticalBufferLevel }); //Tells ScheduleController to stop scheduling.
                    clearBuffer(getClearRange()); // Then we clear the buffer and onCleared event will tell ScheduleController to start scheduling again.
                }
                return;
            }

            if (appendedBytesInfo && !isNaN(appendedBytesInfo.index)) {
                maxAppendedIndex = Math.max(appendedBytesInfo.index, maxAppendedIndex);
                checkIfBufferingCompleted();
            }

            var ranges = sourceBufferController.getAllRanges(buffer);
            if (ranges && ranges.length > 0) {
                for (var i = 0, len = ranges.length; i < len; i++) {
                    log('Buffered Range for type:', type, ':', ranges.start(i), ' - ', ranges.end(i));
                }
            }

            onPlaybackProgression();
            isAppendingInProgress = false;
            if (appendedBytesInfo) {
                eventBus.trigger(_coreEventsEvents2['default'].BYTES_APPENDED, {
                    sender: instance,
                    quality: appendedBytesInfo.quality,
                    startTime: appendedBytesInfo.start,
                    index: appendedBytesInfo.index,
                    bufferedRanges: ranges
                });
            }
        }
    }

    function onQualityChanged(e) {
        if (requiredQuality === e.newQuality || type !== e.mediaType || streamProcessor.getStreamInfo().id !== e.streamInfo.id) return;

        updateBufferTimestampOffset(streamProcessor.getRepresentationInfoForQuality(e.newQuality).MSETimeOffset);
        requiredQuality = e.newQuality;
    }

    //**********************************************************************
    // START Buffer Level, State & Sufficiency Handling.
    //**********************************************************************
    function onPlaybackSeeking() {
        lastIndex = Number.POSITIVE_INFINITY;
        isBufferingCompleted = false;
        onPlaybackProgression();
    }

    function onPlaybackProgression() {
        updateBufferLevel();
        addBufferMetrics();
    }

    function updateBufferLevel() {
        if (playbackController) {
            bufferLevel = sourceBufferController.getBufferLength(buffer, playbackController.getTime());
            eventBus.trigger(_coreEventsEvents2['default'].BUFFER_LEVEL_UPDATED, { sender: instance, bufferLevel: bufferLevel });
            checkIfSufficientBuffer();
        }
    }

    function addBufferMetrics() {
        if (!isActive()) return;
        metricsModel.addBufferState(type, bufferState, scheduleController.getBufferTarget());
        metricsModel.addBufferLevel(type, new Date(), bufferLevel * 1000);
    }

    function checkIfBufferingCompleted() {
        var isLastIdxAppended = maxAppendedIndex >= lastIndex - 1; // Handles 0 and non 0 based request index
        if (isLastIdxAppended && !isBufferingCompleted) {
            isBufferingCompleted = true;
            eventBus.trigger(_coreEventsEvents2['default'].BUFFERING_COMPLETED, { sender: instance, streamInfo: streamProcessor.getStreamInfo() });
        }
    }

    function checkIfSufficientBuffer() {
        if (bufferLevel < STALL_THRESHOLD && !isBufferingCompleted) {
            notifyBufferStateChanged(BUFFER_EMPTY);
        } else {
            notifyBufferStateChanged(BUFFER_LOADED);
        }
    }

    function notifyBufferStateChanged(state) {
        if (bufferState === state || type === 'fragmentedText' && textController.getAllTracksAreDisabled()) return;
        bufferState = state;
        addBufferMetrics();
        eventBus.trigger(_coreEventsEvents2['default'].BUFFER_LEVEL_STATE_CHANGED, { sender: instance, state: state, mediaType: type, streamInfo: streamProcessor.getStreamInfo() });
        eventBus.trigger(state === BUFFER_LOADED ? _coreEventsEvents2['default'].BUFFER_LOADED : _coreEventsEvents2['default'].BUFFER_EMPTY, { mediaType: type });
        log(state === BUFFER_LOADED ? 'Got enough buffer to start.' : 'Waiting for more buffer before starting playback.');
    }

    function handleInbandEvents(data, request, mediaInbandEvents, trackInbandEvents) {

        var fragmentStartTime = Math.max(isNaN(request.startTime) ? 0 : request.startTime, 0);
        var eventStreams = [];
        var events = [];

        inbandEventFound = false; //TODO Discuss why this is hear!
        /* Extract the possible schemeIdUri : If a DASH client detects an event message box with a scheme that is not defined in MPD, the client is expected to ignore it */
        var inbandEvents = mediaInbandEvents.concat(trackInbandEvents);
        for (var i = 0, ln = inbandEvents.length; i < ln; i++) {
            eventStreams[inbandEvents[i].schemeIdUri] = inbandEvents[i];
        }

        var isoFile = (0, _utilsBoxParser2['default'])(context).getInstance().parse(data);
        var eventBoxes = isoFile.getBoxes('emsg');

        for (var i = 0, ln = eventBoxes.length; i < ln; i++) {
            var _event = adapter.getEvent(eventBoxes[i], eventStreams, fragmentStartTime);

            if (_event) {
                events.push(_event);
            }
        }

        return events;
    }

    function deleteInbandEvents(data) {

        if (!inbandEventFound) {
            //TODO Discuss why this is here. inbandEventFound is never set to true!!
            return data;
        }

        var length = data.length;
        var expTwo = Math.pow(256, 2);
        var expThree = Math.pow(256, 3);
        var modData = new Uint8Array(data.length);

        var i = 0;
        var j = 0;

        while (i < length) {

            var identifier = String.fromCharCode(data[i + 4], data[i + 5], data[i + 6], data[i + 7]);
            var size = data[i] * expThree + data[i + 1] * expTwo + data[i + 2] * 256 + data[i + 3] * 1;

            if (identifier != 'emsg') {
                for (var l = i; l < i + size; l++) {
                    modData[j] = data[l];
                    j++;
                }
            }
            i += size;
        }

        return modData.subarray(0, j);
    }

    function hasEnoughSpaceToAppend() {
        var totalBufferedTime = sourceBufferController.getTotalBufferedTime(buffer);
        return totalBufferedTime < criticalBufferLevel;
    }

    /* prune buffer on our own in background to avoid browsers pruning buffer silently */
    function pruneBuffer() {
        if (!buffer) return;
        if (type === 'fragmentedText') return;
        var start = buffer.buffered.length ? buffer.buffered.start(0) : 0;
        var bufferToPrune = playbackController.getTime() - start - mediaPlayerModel.getBufferToKeep();
        if (bufferToPrune > 0) {
            log('pruning buffer: ' + bufferToPrune + ' seconds.');
            isPruningInProgress = true;
            sourceBufferController.remove(buffer, 0, Math.round(start + bufferToPrune), mediaSource);
        }
    }

    function getClearRange(threshold) {

        if (!buffer) return null;

        // we need to remove data that is more than one fragment before the video currentTime
        var currentTime = playbackController.getTime();
        var req = streamProcessor.getFragmentModel().getRequests({ state: _modelsFragmentModel2['default'].FRAGMENT_MODEL_EXECUTED, time: currentTime, threshold: threshold })[0];
        var range = sourceBufferController.getBufferRange(buffer, currentTime);

        var removeEnd = req && !isNaN(req.startTime) ? req.startTime : Math.floor(currentTime);
        if (range === null && buffer.buffered.length > 0) {
            removeEnd = buffer.buffered.end(buffer.buffered.length - 1);
        }

        return { start: buffer.buffered.start(0), end: removeEnd };
    }

    function clearBuffer(range) {
        if (!range || !buffer) return;
        sourceBufferController.remove(buffer, range.start, range.end, mediaSource);
    }

    function onRemoved(e) {
        if (buffer !== e.buffer) return;

        if (isPruningInProgress) {
            isPruningInProgress = false;
        }

        updateBufferLevel();
        eventBus.trigger(_coreEventsEvents2['default'].BUFFER_CLEARED, { sender: instance, from: e.from, to: e.to, hasEnoughSpaceToAppend: hasEnoughSpaceToAppend() });
        //TODO - REMEMBER removed a timerout hack calling clearBuffer after manifestInfo.minBufferTime * 1000 if !hasEnoughSpaceToAppend() Aug 04 2016
    }

    function updateBufferTimestampOffset(MSETimeOffset) {
        // Each track can have its own @presentationTimeOffset, so we should set the offset
        // if it has changed after switching the quality or updating an mpd
        if (buffer && buffer.timestampOffset !== MSETimeOffset && !isNaN(MSETimeOffset)) {
            buffer.timestampOffset = MSETimeOffset;
        }
    }

    function onDataUpdateCompleted(e) {
        if (e.sender.getStreamProcessor() !== streamProcessor || e.error) return;
        updateBufferTimestampOffset(e.currentRepresentation.MSETimeOffset);
    }

    function onStreamCompleted(e) {
        if (e.fragmentModel !== streamProcessor.getFragmentModel()) return;
        lastIndex = e.request.index;
        checkIfBufferingCompleted();
    }

    function onCurrentTrackChanged(e) {
        if (!buffer || e.newMediaInfo.type !== type || e.newMediaInfo.streamInfo.id !== streamProcessor.getStreamInfo().id) return;
        if (mediaController.getSwitchMode(type) === _MediaController2['default'].TRACK_SWITCH_MODE_ALWAYS_REPLACE) {
            clearBuffer(getClearRange(0));
        }
    }

    function onWallclockTimeUpdated() {
        wallclockTicked++;
        var secondsElapsed = wallclockTicked * (mediaPlayerModel.getWallclockTimeUpdateInterval() / 1000);
        if (secondsElapsed >= mediaPlayerModel.getBufferPruningInterval() && !isAppendingInProgress) {
            wallclockTicked = 0;
            pruneBuffer();
        }
    }

    function onPlaybackRateChanged() {
        checkIfSufficientBuffer();
    }

    function getType() {
        return type;
    }

    function getStreamProcessor() {
        return streamProcessor;
    }

    function setStreamProcessor(value) {
        streamProcessor = value;
    }

    function getBuffer() {
        return buffer;
    }

    function setBuffer(value) {
        buffer = value;
    }

    function getBufferLevel() {
        return bufferLevel;
    }

    function getCriticalBufferLevel() {
        return criticalBufferLevel;
    }

    function setMediaSource(value) {
        mediaSource = value;
    }

    function getMediaSource() {
        return mediaSource;
    }

    function getIsBufferingCompleted() {
        return isBufferingCompleted;
    }

    function reset(errored) {

        eventBus.off(_coreEventsEvents2['default'].DATA_UPDATE_COMPLETED, onDataUpdateCompleted, this);
        eventBus.off(_coreEventsEvents2['default'].QUALITY_CHANGE_REQUESTED, onQualityChanged, this);
        eventBus.off(_coreEventsEvents2['default'].INIT_FRAGMENT_LOADED, onInitFragmentLoaded, this);
        eventBus.off(_coreEventsEvents2['default'].MEDIA_FRAGMENT_LOADED, onMediaFragmentLoaded, this);
        eventBus.off(_coreEventsEvents2['default'].STREAM_COMPLETED, onStreamCompleted, this);
        eventBus.off(_coreEventsEvents2['default'].CURRENT_TRACK_CHANGED, onCurrentTrackChanged, this);
        eventBus.off(_coreEventsEvents2['default'].PLAYBACK_PROGRESS, onPlaybackProgression, this);
        eventBus.off(_coreEventsEvents2['default'].PLAYBACK_TIME_UPDATED, onPlaybackProgression, this);
        eventBus.off(_coreEventsEvents2['default'].PLAYBACK_RATE_CHANGED, onPlaybackRateChanged, this);
        eventBus.off(_coreEventsEvents2['default'].PLAYBACK_SEEKING, onPlaybackSeeking, this);
        eventBus.off(_coreEventsEvents2['default'].WALLCLOCK_TIME_UPDATED, onWallclockTimeUpdated, this);
        eventBus.off(_coreEventsEvents2['default'].SOURCEBUFFER_APPEND_COMPLETED, onAppended, this);
        eventBus.off(_coreEventsEvents2['default'].SOURCEBUFFER_REMOVE_COMPLETED, onRemoved, this);

        criticalBufferLevel = Number.POSITIVE_INFINITY;
        bufferState = BUFFER_EMPTY;
        requiredQuality = _AbrController2['default'].QUALITY_DEFAULT;
        lastIndex = Number.POSITIVE_INFINITY;
        maxAppendedIndex = 0;
        appendedBytesInfo = null;
        appendingMediaChunk = false;
        isBufferingCompleted = false;
        isAppendingInProgress = false;
        isPruningInProgress = false;
        playbackController = null;
        streamProcessor = null;
        abrController = null;
        scheduleController = null;

        if (!errored) {
            sourceBufferController.abort(mediaSource, buffer);
            sourceBufferController.removeSourceBuffer(mediaSource, buffer);
        }

        buffer = null;
    }

    instance = {
        initialize: initialize,
        createBuffer: createBuffer,
        getType: getType,
        getStreamProcessor: getStreamProcessor,
        setStreamProcessor: setStreamProcessor,
        getBuffer: getBuffer,
        setBuffer: setBuffer,
        getBufferLevel: getBufferLevel,
        getCriticalBufferLevel: getCriticalBufferLevel,
        setMediaSource: setMediaSource,
        getMediaSource: getMediaSource,
        getIsBufferingCompleted: getIsBufferingCompleted,
        switchInitData: switchInitData,
        reset: reset
    };

    setup();
    return instance;
}

BufferController.__dashjs_factory_name = 'BufferController';
var factory = _coreFactoryMaker2['default'].getClassFactory(BufferController);
factory.BUFFER_LOADED = BUFFER_LOADED;
factory.BUFFER_EMPTY = BUFFER_EMPTY;
exports['default'] = factory;
module.exports = exports['default'];
//# sourceMappingURL=BufferController.js.map


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _BufferController = __webpack_require__(160);

var _BufferController2 = _interopRequireDefault(_BufferController);

var _modelsURIQueryAndFragmentModel = __webpack_require__(399);

var _modelsURIQueryAndFragmentModel2 = _interopRequireDefault(_modelsURIQueryAndFragmentModel);

var _streamingModelsMediaPlayerModel = __webpack_require__(67);

var _streamingModelsMediaPlayerModel2 = _interopRequireDefault(_streamingModelsMediaPlayerModel);

var _coreEventBus = __webpack_require__(27);

var _coreEventBus2 = _interopRequireDefault(_coreEventBus);

var _coreEventsEvents = __webpack_require__(22);

var _coreEventsEvents2 = _interopRequireDefault(_coreEventsEvents);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _coreDebug = __webpack_require__(30);

var _coreDebug2 = _interopRequireDefault(_coreDebug);

function PlaybackController() {

    var context = this.context;
    var log = (0, _coreDebug2['default'])(context).getInstance().log;
    var eventBus = (0, _coreEventBus2['default'])(context).getInstance();

    var instance = undefined,
        element = undefined,
        streamController = undefined,
        timelineConverter = undefined,
        metricsModel = undefined,
        dashMetrics = undefined,
        manifestModel = undefined,
        dashManifestModel = undefined,
        adapter = undefined,
        videoModel = undefined,
        currentTime = undefined,
        liveStartTime = undefined,
        wallclockTimeIntervalId = undefined,
        commonEarliestTime = undefined,
        streamInfo = undefined,
        isDynamic = undefined,
        mediaPlayerModel = undefined,
        playOnceInitialized = undefined;

    function setup() {
        currentTime = 0;
        liveStartTime = NaN;
        wallclockTimeIntervalId = null;
        isDynamic = null;
        playOnceInitialized = false;
        commonEarliestTime = {};
        mediaPlayerModel = (0, _streamingModelsMediaPlayerModel2['default'])(context).getInstance();
    }

    function initialize(StreamInfo) {
        streamInfo = StreamInfo;
        element = videoModel.getElement();
        addAllListeners();
        isDynamic = streamInfo.manifestInfo.isDynamic;
        liveStartTime = streamInfo.start;
        eventBus.on(_coreEventsEvents2['default'].DATA_UPDATE_COMPLETED, onDataUpdateCompleted, this);
        eventBus.on(_coreEventsEvents2['default'].BYTES_APPENDED, onBytesAppended, this);
        eventBus.on(_coreEventsEvents2['default'].BUFFER_LEVEL_STATE_CHANGED, onBufferLevelStateChanged, this);
        eventBus.on(_coreEventsEvents2['default'].PERIOD_SWITCH_STARTED, onPeriodSwitchStarted, this);

        if (playOnceInitialized) {
            playOnceInitialized = false;
            play();
        }
    }

    function onPeriodSwitchStarted(e) {
        if (!isDynamic && e.fromStreamInfo && commonEarliestTime[e.fromStreamInfo.id]) {
            delete commonEarliestTime[e.fromStreamInfo.id];
        }
    }

    function getTimeToStreamEnd() {
        var startTime = getStreamStartTime(true);
        var offset = isDynamic ? startTime - streamInfo.start : 0;
        return startTime + (streamInfo.duration - offset) - getTime();
    }

    function isPlaybackStarted() {
        return getTime() > 0;
    }

    function getStreamId() {
        return streamInfo.id;
    }

    function play() {
        if (element) {
            element.autoplay = true;
            var p = element.play();
            if (p && typeof Promise !== 'undefined' && p instanceof Promise) {
                p['catch'](function (e) {
                    if (e.name === 'NotAllowedError') {
                        eventBus.trigger(_coreEventsEvents2['default'].PLAYBACK_NOT_ALLOWED);
                    }
                    log('Caught pending play exception - continuing (' + e + ')');
                });
            }
        } else {
            playOnceInitialized = true;
        }
    }

    function isPaused() {
        if (!element) return;
        return element.paused;
    }

    function pause() {
        if (!element) return;
        element.pause();
        element.autoplay = false;
    }

    function isSeeking() {
        if (!element) return;
        return element.seeking;
    }

    function seek(time) {
        if (!videoModel) return;
        log('Requesting seek to time: ' + time);
        videoModel.setCurrentTime(time);
    }

    function getTime() {
        if (!element) return;
        return element.currentTime;
    }

    function getPlaybackRate() {
        if (!element) return;
        return element.playbackRate;
    }

    function getPlayedRanges() {
        if (!element) return;
        return element.played;
    }

    function getEnded() {
        if (!element) return;
        return element.ended;
    }

    function getIsDynamic() {
        return isDynamic;
    }

    function setLiveStartTime(value) {
        liveStartTime = value;
    }

    function getLiveStartTime() {
        return liveStartTime;
    }

    /**
     * Computes the desirable delay for the live edge to avoid a risk of getting 404 when playing at the bleeding edge
     * @param {number} fragmentDuration - seconds?
     * @param {number} dvrWindowSize - seconds?
     * @returns {number} object
     * @memberof PlaybackController#
     */
    function computeLiveDelay(fragmentDuration, dvrWindowSize) {
        var mpd = dashManifestModel.getMpd(manifestModel.getValue());

        var delay = undefined;
        var END_OF_PLAYLIST_PADDING = 10;

        if (mediaPlayerModel.getUseSuggestedPresentationDelay() && mpd.hasOwnProperty('suggestedPresentationDelay')) {
            delay = mpd.suggestedPresentationDelay;
        } else if (mediaPlayerModel.getLiveDelay()) {
            delay = mediaPlayerModel.getLiveDelay(); // If set by user, this value takes precedence
        } else if (!isNaN(fragmentDuration)) {
                delay = fragmentDuration * mediaPlayerModel.getLiveDelayFragmentCount();
            } else {
                delay = streamInfo.manifestInfo.minBufferTime * 2;
            }

        // cap target latency to:
        // - dvrWindowSize / 2 for short playlists
        // - dvrWindowSize - END_OF_PLAYLIST_PADDING for longer playlists
        var targetDelayCapping = Math.max(dvrWindowSize - END_OF_PLAYLIST_PADDING, dvrWindowSize / 2);

        return Math.min(delay, targetDelayCapping);
    }

    function reset() {
        if (videoModel && element) {
            eventBus.off(_coreEventsEvents2['default'].DATA_UPDATE_COMPLETED, onDataUpdateCompleted, this);
            eventBus.off(_coreEventsEvents2['default'].BUFFER_LEVEL_STATE_CHANGED, onBufferLevelStateChanged, this);
            eventBus.off(_coreEventsEvents2['default'].BYTES_APPENDED, onBytesAppended, this);
            stopUpdatingWallclockTime();
            removeAllListeners();
        }
        videoModel = null;
        streamInfo = null;
        element = null;
        isDynamic = null;
        setup();
    }

    function setConfig(config) {
        if (!config) return;

        if (config.streamController) {
            streamController = config.streamController;
        }
        if (config.timelineConverter) {
            timelineConverter = config.timelineConverter;
        }
        if (config.metricsModel) {
            metricsModel = config.metricsModel;
        }
        if (config.dashMetrics) {
            dashMetrics = config.dashMetrics;
        }
        if (config.manifestModel) {
            manifestModel = config.manifestModel;
        }
        if (config.dashManifestModel) {
            dashManifestModel = config.dashManifestModel;
        }
        if (config.adapter) {
            adapter = config.adapter;
        }
        if (config.videoModel) {
            videoModel = config.videoModel;
        }
    }

    /**
     * @param {boolean} ignoreStartOffset - ignore URL fragment start offset if true
     * @returns {number} object
     * @memberof PlaybackController#
     */
    function getStreamStartTime(ignoreStartOffset) {
        var presentationStartTime = undefined;
        var fragData = (0, _modelsURIQueryAndFragmentModel2['default'])(context).getInstance().getURIFragmentData();
        var fragS = parseInt(fragData.s, 10);
        var fragT = parseInt(fragData.t, 10);
        var startTimeOffset = NaN;

        if (!ignoreStartOffset) {
            startTimeOffset = !isNaN(fragS) ? fragS : fragT;
        }

        if (isDynamic) {
            if (!isNaN(startTimeOffset) && startTimeOffset > 1262304000) {

                presentationStartTime = startTimeOffset - streamInfo.manifestInfo.availableFrom.getTime() / 1000;

                if (presentationStartTime > liveStartTime || presentationStartTime < liveStartTime - streamInfo.manifestInfo.DVRWindowSize) {
                    presentationStartTime = null;
                }
            }
            presentationStartTime = presentationStartTime || liveStartTime;
        } else {
            if (!isNaN(startTimeOffset) && startTimeOffset < Math.max(streamInfo.manifestInfo.duration, streamInfo.duration) && startTimeOffset >= 0) {
                presentationStartTime = startTimeOffset;
            } else {
                var earliestTime = commonEarliestTime[streamInfo.id]; //set by ready bufferStart after first onBytesAppended
                if (earliestTime === undefined) {
                    earliestTime = streamController.getActiveStreamCommonEarliestTime(); //deal with calculated PST that is none 0 when streamInfo.start is 0
                }
                presentationStartTime = Math.max(earliestTime, streamInfo.start);
            }
        }

        return presentationStartTime;
    }

    function getActualPresentationTime(currentTime) {
        var metrics = metricsModel.getReadOnlyMetricsFor('video') || metricsModel.getReadOnlyMetricsFor('audio');
        var DVRMetrics = dashMetrics.getCurrentDVRInfo(metrics);
        var DVRWindow = DVRMetrics ? DVRMetrics.range : null;
        var actualTime;

        if (!DVRWindow) return NaN;
        if (currentTime > DVRWindow.end) {
            actualTime = Math.max(DVRWindow.end - streamInfo.manifestInfo.minBufferTime * 2, DVRWindow.start);
        } else if (currentTime < DVRWindow.start) {
            actualTime = DVRWindow.start;
        } else {
            return currentTime;
        }

        return actualTime;
    }

    function startUpdatingWallclockTime() {
        if (wallclockTimeIntervalId !== null) return;

        var tick = function tick() {
            onWallclockTime();
        };

        wallclockTimeIntervalId = setInterval(tick, mediaPlayerModel.getWallclockTimeUpdateInterval());
    }

    function stopUpdatingWallclockTime() {
        clearInterval(wallclockTimeIntervalId);
        wallclockTimeIntervalId = null;
    }

    function seekToStartTimeOffset() {
        var initialSeekTime = getStreamStartTime(false);
        if (initialSeekTime > 0) {
            seek(initialSeekTime);
            log('Starting playback at offset: ' + initialSeekTime);
        }
    }

    function updateCurrentTime() {
        if (isPaused() || !isDynamic || element.readyState === 0) return;
        var currentTime = getTime();
        var actualTime = getActualPresentationTime(currentTime);
        var timeChanged = !isNaN(actualTime) && actualTime !== currentTime;
        if (timeChanged) {
            seek(actualTime);
        }
    }

    function onDataUpdateCompleted(e) {
        if (e.error) return;

        var representationInfo = adapter.convertDataToTrack(manifestModel.getValue(), e.currentRepresentation);
        var info = representationInfo.mediaInfo.streamInfo;

        if (streamInfo.id !== info.id) return;
        streamInfo = info;

        updateCurrentTime();
    }

    function onCanPlay() {
        eventBus.trigger(_coreEventsEvents2['default'].CAN_PLAY);
    }

    function onPlaybackStart() {
        log('Native video element event: play');
        updateCurrentTime();
        startUpdatingWallclockTime();
        eventBus.trigger(_coreEventsEvents2['default'].PLAYBACK_STARTED, { startTime: getTime() });
    }

    function onPlaybackPlaying() {
        log('Native video element event: playing');
        eventBus.trigger(_coreEventsEvents2['default'].PLAYBACK_PLAYING, { playingTime: getTime() });
    }

    function onPlaybackPaused() {
        log('Native video element event: pause');
        eventBus.trigger(_coreEventsEvents2['default'].PLAYBACK_PAUSED, { ended: getEnded() });
    }

    function onPlaybackSeeking() {
        var seekTime = getTime();
        log('Seeking to: ' + seekTime);
        startUpdatingWallclockTime();
        eventBus.trigger(_coreEventsEvents2['default'].PLAYBACK_SEEKING, { seekTime: seekTime });
    }

    function onPlaybackSeeked() {
        log('Native video element event: seeked');
        eventBus.trigger(_coreEventsEvents2['default'].PLAYBACK_SEEKED);
    }

    function onPlaybackTimeUpdated() {
        //log("Native video element event: timeupdate");
        var time = getTime();
        if (time === currentTime) return;
        currentTime = time;
        eventBus.trigger(_coreEventsEvents2['default'].PLAYBACK_TIME_UPDATED, { timeToEnd: getTimeToStreamEnd(), time: time });
    }

    function onPlaybackProgress() {
        //log("Native video element event: progress");
        eventBus.trigger(_coreEventsEvents2['default'].PLAYBACK_PROGRESS);
    }

    function onPlaybackRateChanged() {
        var rate = getPlaybackRate();
        log('Native video element event: ratechange: ', rate);
        eventBus.trigger(_coreEventsEvents2['default'].PLAYBACK_RATE_CHANGED, { playbackRate: rate });
    }

    function onPlaybackMetaDataLoaded() {
        log('Native video element event: loadedmetadata');
        if (!isDynamic && streamInfo.isFirst || timelineConverter.isTimeSyncCompleted()) {
            seekToStartTimeOffset();
        }
        eventBus.trigger(_coreEventsEvents2['default'].PLAYBACK_METADATA_LOADED);
        startUpdatingWallclockTime();
    }

    function onPlaybackEnded() {
        log('Native video element event: ended');
        pause();
        stopUpdatingWallclockTime();
        eventBus.trigger(_coreEventsEvents2['default'].PLAYBACK_ENDED);
    }

    function onPlaybackError(event) {
        var target = event.target || event.srcElement;
        eventBus.trigger(_coreEventsEvents2['default'].PLAYBACK_ERROR, { error: target.error });
    }

    function onWallclockTime() {
        eventBus.trigger(_coreEventsEvents2['default'].WALLCLOCK_TIME_UPDATED, { isDynamic: isDynamic, time: new Date() });
    }

    function onBytesAppended(e) {
        var ranges = e.bufferedRanges;
        if (!ranges || !ranges.length) return;
        var bufferedStart = Math.max(ranges.start(0), streamInfo.start);
        var earliestTime = commonEarliestTime[streamInfo.id] === undefined ? bufferedStart : Math.max(commonEarliestTime[streamInfo.id], bufferedStart);
        if (earliestTime === commonEarliestTime[streamInfo.id]) return;
        if (!isDynamic && getStreamStartTime(true) < earliestTime && getTime() < earliestTime) {
            seek(earliestTime);
        }
        commonEarliestTime[streamInfo.id] = earliestTime;
    }

    function onBufferLevelStateChanged(e) {
        // do not stall playback when get an event from Stream that is not active
        if (e.streamInfo.id !== streamInfo.id) return;
        videoModel.setStallState(e.mediaType, e.state === _BufferController2['default'].BUFFER_EMPTY);
    }

    function addAllListeners() {
        element.addEventListener('canplay', onCanPlay);
        element.addEventListener('play', onPlaybackStart);
        element.addEventListener('playing', onPlaybackPlaying);
        element.addEventListener('pause', onPlaybackPaused);
        element.addEventListener('error', onPlaybackError);
        element.addEventListener('seeking', onPlaybackSeeking);
        element.addEventListener('seeked', onPlaybackSeeked);
        element.addEventListener('timeupdate', onPlaybackTimeUpdated);
        element.addEventListener('progress', onPlaybackProgress);
        element.addEventListener('ratechange', onPlaybackRateChanged);
        element.addEventListener('loadedmetadata', onPlaybackMetaDataLoaded);
        element.addEventListener('ended', onPlaybackEnded);
    }

    function removeAllListeners() {
        element.removeEventListener('canplay', onCanPlay);
        element.removeEventListener('play', onPlaybackStart);
        element.removeEventListener('playing', onPlaybackPlaying);
        element.removeEventListener('pause', onPlaybackPaused);
        element.removeEventListener('error', onPlaybackError);
        element.removeEventListener('seeking', onPlaybackSeeking);
        element.removeEventListener('seeked', onPlaybackSeeked);
        element.removeEventListener('timeupdate', onPlaybackTimeUpdated);
        element.removeEventListener('progress', onPlaybackProgress);
        element.removeEventListener('ratechange', onPlaybackRateChanged);
        element.removeEventListener('loadedmetadata', onPlaybackMetaDataLoaded);
        element.removeEventListener('ended', onPlaybackEnded);
    }

    instance = {
        initialize: initialize,
        setConfig: setConfig,
        getStreamStartTime: getStreamStartTime,
        getTimeToStreamEnd: getTimeToStreamEnd,
        isPlaybackStarted: isPlaybackStarted,
        getStreamId: getStreamId,
        getTime: getTime,
        getPlaybackRate: getPlaybackRate,
        getPlayedRanges: getPlayedRanges,
        getEnded: getEnded,
        getIsDynamic: getIsDynamic,
        setLiveStartTime: setLiveStartTime,
        getLiveStartTime: getLiveStartTime,
        computeLiveDelay: computeLiveDelay,
        play: play,
        isPaused: isPaused,
        pause: pause,
        isSeeking: isSeeking,
        seek: seek,
        reset: reset
    };

    setup();

    return instance;
}

PlaybackController.__dashjs_factory_name = 'PlaybackController';
exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(PlaybackController);
module.exports = exports['default'];
//# sourceMappingURL=PlaybackController.js.map


/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NAMES; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_redux_helpers_create_async_actions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_utils_adapters_vod__ = __webpack_require__(34);




var ACTIONS = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_redux_helpers_create_async_actions__["a" /* default */])('SERVER.VOD-SETTINGS.UPDATE');
var NAMES = ACTIONS.NAMES;
var START = ACTIONS.START,
    SUCCESS = ACTIONS.SUCCESS,
    FAIL = ACTIONS.FAIL;


/* harmony default export */ __webpack_exports__["a"] = (function (settings) {
  return function (dispatch, getState) {
    var _getState = getState(),
        vodSettings = _getState.vodSettings;

    if (_.isEmpty(settings)) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(vodSettings);
    }

    settings = _.merge({}, vodSettings, settings);

    if (_.isEqual(settings, vodSettings)) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(vodSettings);
    }

    dispatch(START(settings));

    return __WEBPACK_IMPORTED_MODULE_2_shared_utils_adapters_vod__["a" /* default */].settings.update(settings).then(function (result) {
      dispatch(SUCCESS(settings, result));
      return result;
    }, function () {
      dispatch(FAIL(settings, null, { analytics: { type: 'error', name: 'shared.vod-settings.update' } }));
    });
  };
});

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = attempt;
/* harmony export (immutable) */ __webpack_exports__["b"] = invokeSafely;
function attempt(fn, defaultValue) {
  try {
    return fn();
  } catch (ex) {
    return defaultValue;
  }
}

function invokeSafely(fn) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return function () {
    try {
      return fn.apply(this, arguments); // eslint-disable-line no-invalid-this
    } catch (ex) {
      return defaultValue;
    }
  };
}

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NAMES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return playVideo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return pauseVideo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return resetPlaybackStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setPlaybackStatus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);


var NAMES = {
  PLAY: 'CLIENT.VIDEO.PLAYBACK_STATUS.SET_PLAY',
  REQUEST_PLAY: 'CLIENT.VIDEO.PLAYBACK_STATUS.REQUEST_PLAY',
  PAUSE: 'CLIENT.VIDEO.PLAYBACK_STATUS.SET_PAUSE',
  REQUEST_PAUSE: 'CLIENT.VIDEO.PLAYBACK_STATUS.REQUEST_PAUSE',
  RESET: 'CLIENT.VIDEO.PLAYBACK_STATUS.RESET',
  END: 'CLIENT.VIDEO.PLAYBACK_STATUS.SET_END',
  SET: 'CLIENT.VIDEO.PLAYBACK_STATUS.SET'
};

var playVideo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(NAMES.REQUEST_PLAY);
var pauseVideo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(NAMES.REQUEST_PAUSE);
var resetPlaybackStatus = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(NAMES.RESET);
// Oh boy, don't even try to use it anywhere.
var setPlaybackStatus = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(NAMES.SET);

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys       = __webpack_require__(449)
  , enumBugKeys = __webpack_require__(278);

module.exports = Object.keys || function keys(O){
  return $keys(O, enumBugKeys);
};

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(209);
module.exports = function(it){
  return Object(defined(it));
};

/***/ }),
/* 167 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["toTwoDigitsNumber"] = toTwoDigitsNumber;
/* harmony export (immutable) */ __webpack_exports__["convertMMSSToSS"] = convertMMSSToSS;
/* harmony export (immutable) */ __webpack_exports__["convertISO8601ToMMSS"] = convertISO8601ToMMSS;
/* harmony export (immutable) */ __webpack_exports__["convertISO8601ToSS"] = convertISO8601ToSS;
/* harmony export (immutable) */ __webpack_exports__["convertSSToMMSS"] = convertSSToMMSS;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toArray__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toArray__);


function toTwoDigitsNumber(number) {
  return number <= 9 ? '0' + number : String(number);
}

function convertMMSSToSS(durationStr) {
  if (!durationStr) {
    return 0;
  }

  return _(durationStr).split(':').reverse().reduce(function (duration, chunk, i) {
    return duration + chunk * Math.pow(60, i);
  }, 0);
}

function convertISO8601ToMMSS(durationStr) {
  if (!durationStr) {
    return '00:00';
  }

  var _durationStr$match = durationStr.match(/^P(?:(\d+)D)?T(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/),
      _durationStr$match2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toArray___default()(_durationStr$match),
      parts = _durationStr$match2.slice(1);

  parts = _.map(parts, function (part) {
    return Number(part) || 0;
  });

  var days = parts[0];

  var _parts = parts,
      _parts2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_parts, 4),
      hours = _parts2[1],
      minutes = _parts2[2],
      seconds = _parts2[3];

  var _$map = _.map([days * 24 + hours, minutes, seconds], toTwoDigitsNumber);

  var _$map2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_$map, 3);

  hours = _$map2[0];
  minutes = _$map2[1];
  seconds = _$map2[2];


  if (hours === '00') {
    return minutes + ':' + seconds;
  }

  return hours + ':' + minutes + ':' + seconds;
}

function convertISO8601ToSS(durationStr) {
  if (!durationStr) {
    return 0;
  }

  return convertMMSSToSS(convertISO8601ToMMSS(durationStr));
}

function convertSSToMMSS(durationSec) {
  durationSec = Math.floor(durationSec || 0);

  var chunks = [];
  do {
    chunks.unshift(toTwoDigitsNumber(durationSec % 60));

    durationSec = Math.floor(durationSec / 60);
  } while (durationSec > 0);

  if (chunks.length < 2) {
    chunks.unshift('00');
  }

  return chunks.join(':');
}

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = notForPreview;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_widget_components_preview_prompt_preview_prompt__ = __webpack_require__(358);



function notForPreview(target, key, descriptor) {
  if (_.isFunction(target)) {
    return function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_widget_components_preview_prompt_preview_prompt__["b" /* isPreviewMode */])()) {
        var event = args[0];


        if (_.get(event, 'preventDefault') && _.get(event, 'stopPropagation')) {
          event.preventDefault();
          event.stopPropagation();
        }

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_widget_components_preview_prompt_preview_prompt__["a" /* openPreviewPrompt */])();
        return;
      }

      return target.apply(undefined, args);
    };
  }

  var originMethod = target[key];

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, descriptor, {
    value: function value(event) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_widget_components_preview_prompt_preview_prompt__["b" /* isPreviewMode */])()) {
        if (_.get(event, 'preventDefault') && _.get(event, 'stopPropagation')) {
          event.preventDefault();
          event.stopPropagation();
        }

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_widget_components_preview_prompt_preview_prompt__["a" /* openPreviewPrompt */])();
        return null;
      }

      return originMethod.apply(this, arguments);
    }
  });
}

/***/ }),
/* 170 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};

/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(73).f
  , has = __webpack_require__(118)
  , TAG = __webpack_require__(48)('toStringTag');

module.exports = function(it, tag, stat){
  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
};

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(765);
var global        = __webpack_require__(55)
  , hide          = __webpack_require__(98)
  , Iterators     = __webpack_require__(139)
  , TO_STRING_TAG = __webpack_require__(48)('toStringTag');

for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
  var NAME       = collections[i]
    , Collection = global[NAME]
    , proto      = Collection && Collection.prototype;
  if(proto && !proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(74)
  , TAG = __webpack_require__(29)('toStringTag')
  // ES3 wrong here
  , ARG = cof(function(){ return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function(it, key){
  try {
    return it[key];
  } catch(e){ /* empty */ }
};

module.exports = function(it){
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(74);
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),
/* 176 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;

/***/ }),
/* 177 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(105),
    isObjectLike = __webpack_require__(92);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(488),
    baseKeys = __webpack_require__(493),
    isArrayLike = __webpack_require__(106);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = falsy;
/* unused harmony export history */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return component; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return components; });
/* unused harmony export route */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return routes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


function falsy(props, propName, componentName) {
  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
}

var history = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  listen: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  push: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  replace: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  go: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goBack: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goForward: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired
});

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["func"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]]);
var components = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([component, __WEBPACK_IMPORTED_MODULE_0_prop_types__["object"]]);
var route = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["object"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["element"]]);
var routes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([route, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["arrayOf"])(route)]);

/***/ }),
/* 181 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  CHANNEL: 'channel',
  YOUTUBE_FEED: 'youtube-feed'
});

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  DASHBOARD: {
    BEFORE_CLOSE: 'vod.dashboard.before-close',
    PREVENT_CLOSE: 'vod.dashboard.prevent-close',
    CLOSE: 'vod.dashboard.close',
    CLOSED: 'vod.dashboard.closed'
  },
  MODAL: {
    OPEN: 'vod.modal.open',
    CLOSE: 'vod.modal.close'
  },
  TRANSCODING: {
    READY: 'vod.transcoding.ready'
  },
  TOOLTIP: {
    SHOW: 'vod.tooltip.show',
    HIDE: 'vod.tooltip.hide',
    DID_SHOW: 'vod.tooltip.did-show',
    DID_HIDE: 'vod.tooltip.did-hide'
  },
  POPOUT: {
    SHOW: 'vod.popout.show',
    HIDE: 'vod.popout.hide'
  },
  PAYMENT: {
    PAYMENT_SUCCESS: 'vod.payment.payment-success',
    CANCEL_SUBSCRIPTION: 'vod.payment.cancel-subscription'
  },
  SESSION: {
    LOGOUT_USER: 'vod.session.logout-user'
  }
});

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(81);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(1016),
    isObjectLike = __webpack_require__(92);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sideShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return trianglePositionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return popoutPositionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return openOnShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_constants_popout__ = __webpack_require__(61);


var sideShape = React.PropTypes.oneOf(_.values(__WEBPACK_IMPORTED_MODULE_0_shared_constants_popout__["a" /* sides */]));
var trianglePositionShape = React.PropTypes.oneOf(_.values(__WEBPACK_IMPORTED_MODULE_0_shared_constants_popout__["b" /* trianglePositions */]));
var popoutPositionShape = React.PropTypes.oneOf(_.values(__WEBPACK_IMPORTED_MODULE_0_shared_constants_popout__["c" /* popoutPositions */]));
var openOnShape = React.PropTypes.oneOf(_.values(__WEBPACK_IMPORTED_MODULE_0_shared_constants_popout__["d" /* openOn */]));

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getCurrentSiteUser;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCurrentUserEmail; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);


function getCurrentSiteUser(state) {
  return state.currentSiteUser;
}

var getCurrentUserEmail = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getCurrentSiteUser, function (currentSiteUser) {
  return _.get(currentSiteUser, 'email', '');
});

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreEventsEvents = __webpack_require__(22);

var _coreEventsEvents2 = _interopRequireDefault(_coreEventsEvents);

var _coreEventBus = __webpack_require__(27);

var _coreEventBus2 = _interopRequireDefault(_coreEventBus);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _coreDebug = __webpack_require__(30);

var _coreDebug2 = _interopRequireDefault(_coreDebug);

var _textTextController = __webpack_require__(189);

var _textTextController2 = _interopRequireDefault(_textTextController);

var _utilsDOMStorage = __webpack_require__(407);

var _utilsDOMStorage2 = _interopRequireDefault(_utilsDOMStorage);

var TRACK_SWITCH_MODE_NEVER_REPLACE = 'neverReplace';
var TRACK_SWITCH_MODE_ALWAYS_REPLACE = 'alwaysReplace';
var TRACK_SELECTION_MODE_HIGHEST_BITRATE = 'highestBitrate';
var TRACK_SELECTION_MODE_WIDEST_RANGE = 'widestRange';
var DEFAULT_INIT_TRACK_SELECTION_MODE = TRACK_SELECTION_MODE_HIGHEST_BITRATE;

function MediaController() {

    var context = this.context;
    var log = (0, _coreDebug2['default'])(context).getInstance().log;
    var eventBus = (0, _coreEventBus2['default'])(context).getInstance();
    var textController = (0, _textTextController2['default'])(context).getInstance();
    var domStorage = (0, _utilsDOMStorage2['default'])(context).getInstance();

    var instance = undefined,
        tracks = undefined,
        initialSettings = undefined,
        selectionMode = undefined,
        switchMode = undefined,
        errHandler = undefined;

    var validTrackSwitchModes = [TRACK_SWITCH_MODE_ALWAYS_REPLACE, TRACK_SWITCH_MODE_NEVER_REPLACE];

    var validTrackSelectionModes = [TRACK_SELECTION_MODE_HIGHEST_BITRATE, TRACK_SELECTION_MODE_WIDEST_RANGE];

    function initialize() {
        tracks = {};
        resetInitialSettings();
        resetSwitchMode();
    }

    /**
     * @param {string} type
     * @param {StreamInfo} streamInfo
     * @memberof MediaController#
     */
    function checkInitialMediaSettingsForType(type, streamInfo) {
        var settings = getInitialSettings(type);
        var tracksForType = getTracksFor(type, streamInfo);
        var tracks = [];

        if (type === 'fragmentedText') {
            // Choose the first track
            setTrack(tracksForType[0]);
            return;
        }

        if (!settings) {
            settings = domStorage.getSavedMediaSettings(type);
            setInitialSettings(type, settings);
        }

        if (!tracksForType || tracksForType.length === 0) return;

        if (settings) {
            tracksForType.forEach(function (track) {
                if (matchSettings(settings, track)) {
                    tracks.push(track);
                }
            });
        }

        if (tracks.length === 0) {
            setTrack(selectInitialTrack(tracksForType));
        } else {
            if (tracks.length > 1) {
                setTrack(selectInitialTrack(tracks));
            } else {
                setTrack(tracks[0]);
            }
        }
    }

    /**
     * @param {MediaInfo} track
     * @returns {boolean}
     * @memberof MediaController#
     */
    function addTrack(track) {
        var mediaType = track ? track.type : null;
        var streamId = track ? track.streamInfo.id : null;
        var initSettings = getInitialSettings(mediaType);

        if (!track || !isMultiTrackSupportedByType(mediaType)) return false;

        tracks[streamId] = tracks[streamId] || createTrackInfo();

        if (tracks[streamId][mediaType].list.indexOf(track) >= 0) return false;

        tracks[streamId][mediaType].list.push(track);

        if (initSettings && matchSettings(initSettings, track) && !getCurrentTrackFor(mediaType, track.streamInfo)) {
            setTrack(track);
        }

        return true;
    }

    /**
     * @param {string} type
     * @param {StreamInfo} streamInfo
     * @returns {Array}
     * @memberof MediaController#
     */
    function getTracksFor(type, streamInfo) {
        if (!type || !streamInfo) return [];

        var id = streamInfo.id;

        if (!tracks[id] || !tracks[id][type]) return [];

        return tracks[id][type].list;
    }

    /**
     * @param {string} type
     * @param {StreamInfo} streamInfo
     * @returns {Object|null}
     * @memberof MediaController#
     */
    function getCurrentTrackFor(type, streamInfo) {
        if (!type || !streamInfo || streamInfo && !tracks[streamInfo.id]) return null;
        return tracks[streamInfo.id][type].current;
    }

    /**
     * @param {MediaInfo} track
     * @returns {boolean}
     * @memberof MediaController#
     */
    function isCurrentTrack(track) {
        var type = track.type;
        var id = track.streamInfo.id;

        return tracks[id] && tracks[id][type] && isTracksEqual(tracks[id][type].current, track);
    }

    /**
     * @param {MediaInfo} track
     * @memberof MediaController#
     */
    function setTrack(track) {
        if (!track) return;

        var type = track.type;
        var streamInfo = track.streamInfo;
        var id = streamInfo.id;
        var current = getCurrentTrackFor(type, streamInfo);

        if (!tracks[id] || !tracks[id][type] || current && isTracksEqual(track, current)) return;

        tracks[id][type].current = track;

        if (current) {
            eventBus.trigger(_coreEventsEvents2['default'].CURRENT_TRACK_CHANGED, { oldMediaInfo: current, newMediaInfo: track, switchMode: switchMode[type] });
        }

        var settings = extractSettings(track);

        if (!settings || !tracks[id][type].storeLastSettings) return;

        if (settings.roles) {
            settings.role = settings.roles[0];
            delete settings.roles;
        }

        if (settings.accessibility) {
            settings.accessibility = settings.accessibility[0];
        }

        if (settings.audioChannelConfiguration) {
            settings.audioChannelConfiguration = settings.audioChannelConfiguration[0];
        }

        domStorage.setSavedMediaSettings(type, settings);
    }

    /**
     * @param {string} type
     * @param {Object} value
     * @memberof MediaController#
     */
    function setInitialSettings(type, value) {
        if (!type || !value) return;

        initialSettings[type] = value;
    }

    /**
     * @param {string} type
     * @returns {Object|null}
     * @memberof MediaController#
     */
    function getInitialSettings(type) {
        if (!type) return null;

        return initialSettings[type];
    }

    /**
     * @param {string} type
     * @param {string} mode
     * @memberof MediaController#
     */
    function setSwitchMode(type, mode) {
        var isModeSupported = validTrackSwitchModes.indexOf(mode) !== -1;

        if (!isModeSupported) {
            log('track switch mode is not supported: ' + mode);
            return;
        }

        switchMode[type] = mode;
    }

    /**
     * @param {string} type
     * @returns {string} mode
     * @memberof MediaController#
     */
    function getSwitchMode(type) {
        return switchMode[type];
    }

    /**
     * @param {string} mode
     * @memberof MediaController#
     */
    function setSelectionModeForInitialTrack(mode) {
        var isModeSupported = validTrackSelectionModes.indexOf(mode) !== -1;

        if (!isModeSupported) {
            log('track selection mode is not supported: ' + mode);
            return;
        }
        selectionMode = mode;
    }

    /**
     * @returns {string} mode
     * @memberof MediaController#
     */
    function getSelectionModeForInitialTrack() {
        return selectionMode || DEFAULT_INIT_TRACK_SELECTION_MODE;
    }

    /**
     * @param {string} type
     * @returns {boolean}
     * @memberof MediaController#
     */
    function isMultiTrackSupportedByType(type) {
        return type === 'audio' || type === 'video' || type === 'text' || type === 'fragmentedText';
    }

    /**
     * @param {MediaInfo} t1 - first track to compare
     * @param {MediaInfo} t2 - second track to compare
     * @returns {boolean}
     * @memberof MediaController#
     */
    function isTracksEqual(t1, t2) {
        var sameId = t1.id === t2.id;
        var sameViewpoint = t1.viewpoint === t2.viewpoint;
        var sameLang = t1.lang === t2.lang;
        var sameRoles = t1.roles.toString() === t2.roles.toString();
        var sameAccessibility = t1.accessibility.toString() === t2.accessibility.toString();
        var sameAudioChannelConfiguration = t1.audioChannelConfiguration.toString() === t2.audioChannelConfiguration.toString();

        return sameId && sameViewpoint && sameLang && sameRoles && sameAccessibility && sameAudioChannelConfiguration;
    }

    function setConfig(config) {
        if (!config) return;

        if (config.errHandler) {
            errHandler = config.errHandler;
        }
    }

    /**
     * @memberof MediaController#
     */
    function reset() {
        initialize();
        textController.reset();
    }

    function extractSettings(mediaInfo) {
        var settings = {
            lang: mediaInfo.lang,
            viewpoint: mediaInfo.viewpoint,
            roles: mediaInfo.roles,
            accessibility: mediaInfo.accessibility,
            audioChannelConfiguration: mediaInfo.audioChannelConfiguration
        };
        var notEmpty = settings.lang || settings.viewpoint || settings.role && settings.role.length > 0 || settings.accessibility && settings.accessibility.length > 0 || settings.audioChannelConfiguration && settings.audioChannelConfiguration.length > 0;

        return notEmpty ? settings : null;
    }

    function matchSettings(settings, track) {
        var matchLang = !settings.lang || settings.lang === track.lang;
        var matchViewPoint = !settings.viewpoint || settings.viewpoint === track.viewpoint;
        var matchRole = !settings.role || !!track.roles.filter(function (item) {
            return item === settings.role;
        })[0];
        var matchAccessibility = !settings.accessibility || !!track.accessibility.filter(function (item) {
            return item === settings.accessibility;
        })[0];
        var matchAudioChannelConfiguration = !settings.audioChannelConfiguration || !!track.audioChannelConfiguration.filter(function (item) {
            return item === settings.audioChannelConfiguration;
        })[0];

        return matchLang && matchViewPoint && matchRole && matchAccessibility && matchAudioChannelConfiguration;
    }

    function resetSwitchMode() {
        switchMode = {
            audio: TRACK_SWITCH_MODE_ALWAYS_REPLACE,
            video: TRACK_SWITCH_MODE_NEVER_REPLACE
        };
    }

    function resetInitialSettings() {
        initialSettings = {
            audio: null,
            video: null
        };
    }

    function selectInitialTrack(tracks) {
        var mode = getSelectionModeForInitialTrack();
        var tmpArr = [];
        var getTracksWithHighestBitrate = function getTracksWithHighestBitrate(trackArr) {
            var max = 0;
            var result = [];
            var tmp;

            trackArr.forEach(function (track) {
                tmp = Math.max.apply(Math, track.bitrateList.map(function (obj) {
                    return obj.bandwidth;
                }));

                if (tmp > max) {
                    max = tmp;
                    result = [track];
                } else if (tmp === max) {
                    result.push(track);
                }
            });

            return result;
        };
        var getTracksWithWidestRange = function getTracksWithWidestRange(trackArr) {
            var max = 0;
            var result = [];
            var tmp;

            trackArr.forEach(function (track) {
                tmp = track.representationCount;

                if (tmp > max) {
                    max = tmp;
                    result = [track];
                } else if (tmp === max) {
                    result.push(track);
                }
            });

            return result;
        };

        switch (mode) {
            case TRACK_SELECTION_MODE_HIGHEST_BITRATE:
                tmpArr = getTracksWithHighestBitrate(tracks);

                if (tmpArr.length > 1) {
                    tmpArr = getTracksWithWidestRange(tmpArr);
                }
                break;
            case TRACK_SELECTION_MODE_WIDEST_RANGE:
                tmpArr = getTracksWithWidestRange(tracks);

                if (tmpArr.length > 1) {
                    tmpArr = getTracksWithHighestBitrate(tracks);
                }
                break;
            default:
                log('track selection mode is not supported: ' + mode);
                break;
        }

        return tmpArr[0];
    }

    function createTrackInfo() {
        return {
            audio: {
                list: [],
                storeLastSettings: true,
                current: null
            },
            video: {
                list: [],
                storeLastSettings: true,
                current: null
            },
            text: {
                list: [],
                storeLastSettings: true,
                current: null
            },
            fragmentedText: {
                list: [],
                storeLastSettings: true,
                current: null
            }
        };
    }

    instance = {
        initialize: initialize,
        checkInitialMediaSettingsForType: checkInitialMediaSettingsForType,
        addTrack: addTrack,
        getTracksFor: getTracksFor,
        getCurrentTrackFor: getCurrentTrackFor,
        isCurrentTrack: isCurrentTrack,
        setTrack: setTrack,
        setInitialSettings: setInitialSettings,
        getInitialSettings: getInitialSettings,
        setSwitchMode: setSwitchMode,
        getSwitchMode: getSwitchMode,
        setSelectionModeForInitialTrack: setSelectionModeForInitialTrack,
        getSelectionModeForInitialTrack: getSelectionModeForInitialTrack,
        isMultiTrackSupportedByType: isMultiTrackSupportedByType,
        isTracksEqual: isTracksEqual,
        setConfig: setConfig,
        reset: reset
    };

    return instance;
}

MediaController.__dashjs_factory_name = 'MediaController';
var factory = _coreFactoryMaker2['default'].getSingletonFactory(MediaController);
factory.TRACK_SWITCH_MODE_NEVER_REPLACE = TRACK_SWITCH_MODE_NEVER_REPLACE;
factory.TRACK_SWITCH_MODE_ALWAYS_REPLACE = TRACK_SWITCH_MODE_ALWAYS_REPLACE;
factory.TRACK_SELECTION_MODE_HIGHEST_BITRATE = TRACK_SELECTION_MODE_HIGHEST_BITRATE;
factory.TRACK_SELECTION_MODE_WIDEST_RANGE = TRACK_SELECTION_MODE_WIDEST_RANGE;
factory.DEFAULT_INIT_TRACK_SELECTION_MODE = DEFAULT_INIT_TRACK_SELECTION_MODE;
exports['default'] = factory;
module.exports = exports['default'];
//# sourceMappingURL=MediaController.js.map


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _TextSourceBuffer = __webpack_require__(1407);

var _TextSourceBuffer2 = _interopRequireDefault(_TextSourceBuffer);

var _TextTracks = __webpack_require__(405);

var _TextTracks2 = _interopRequireDefault(_TextTracks);

var _utilsVTTParser = __webpack_require__(1414);

var _utilsVTTParser2 = _interopRequireDefault(_utilsVTTParser);

var _utilsTTMLParser = __webpack_require__(1413);

var _utilsTTMLParser2 = _interopRequireDefault(_utilsTTMLParser);

function TextController() {

    var context = this.context;
    var instance = undefined;
    var textSourceBuffer = undefined;

    var allTracksAreDisabled = undefined,
        errHandler = undefined,
        dashManifestModel = undefined,
        mediaController = undefined,
        videoModel = undefined,
        streamController = undefined,
        textTracks = undefined,
        vttParser = undefined,
        ttmlParser = undefined;

    function setup() {

        textTracks = (0, _TextTracks2['default'])(context).getInstance();
        vttParser = (0, _utilsVTTParser2['default'])(context).getInstance();
        ttmlParser = (0, _utilsTTMLParser2['default'])(context).getInstance();
        textSourceBuffer = (0, _TextSourceBuffer2['default'])(context).getInstance();

        textTracks.initialize();
        allTracksAreDisabled = false;
    }

    function setConfig(config) {
        if (!config) {
            return;
        }
        if (config.errHandler) {
            errHandler = config.errHandler;
        }
        if (config.dashManifestModel) {
            dashManifestModel = config.dashManifestModel;
        }
        if (config.mediaController) {
            mediaController = config.mediaController;
        }
        if (config.videoModel) {
            videoModel = config.videoModel;
        }
        if (config.streamController) {
            streamController = config.streamController;
        }
        if (config.textTracks) {
            textTracks = config.textTracks;
        }
        if (config.vttParser) {
            vttParser = config.vttParser;
        }
        if (config.ttmlParser) {
            ttmlParser = config.ttmlParser;
        }

        // create config for source buffer
        textSourceBuffer.setConfig({
            errHandler: errHandler,
            dashManifestModel: dashManifestModel,
            mediaController: mediaController,
            videoModel: videoModel,
            streamController: streamController,
            textTracks: textTracks,
            vttParser: vttParser,
            ttmlParser: ttmlParser
        });
    }

    function getTextSourceBuffer() {
        return textSourceBuffer;
    }

    function getAllTracksAreDisabled() {
        return allTracksAreDisabled;
    }

    function addEmbeddedTrack(mediaInfo) {
        textSourceBuffer.addEmbeddedTrack(mediaInfo);
    }

    function setTextTrack() {

        var config = textSourceBuffer.getConfig();
        var fragmentModel = config.fragmentModel;
        var embeddedTracks = config.embeddedTracks;
        var isFragmented = config.isFragmented;
        var fragmentedTracks = config.fragmentedTracks;
        var allTracksAreDisabled = config.allTracksAreDisabled;

        var el = videoModel.getElement();
        var tracks = el.textTracks;
        var ln = tracks.length;
        var nrNonEmbeddedTracks = ln - embeddedTracks.length;
        var oldTrackIdx = textTracks.getCurrentTrackIdx();

        for (var i = 0; i < ln; i++) {
            var track = tracks[i];
            allTracksAreDisabled = track.mode !== 'showing';
            if (track.mode === 'showing') {
                if (oldTrackIdx !== i) {
                    // do not reset track if already the current track.  This happens when all captions get turned off via UI and then turned on again and with videojs.
                    textTracks.setCurrentTrackIdx(i);
                    textTracks.addCaptions(i, 0, null); // Make sure that previously queued captions are added as cues

                    // specific to fragmented texe
                    if (isFragmented && i < nrNonEmbeddedTracks) {
                        var currentFragTrack = mediaController.getCurrentTrackFor('fragmentedText', streamController.getActiveStreamInfo());
                        var newFragTrack = fragmentedTracks[i];
                        if (newFragTrack !== currentFragTrack) {
                            fragmentModel.abortRequests();
                            textTracks.deleteTrackCues(currentFragTrack);
                            mediaController.setTrack(newFragTrack);
                            textSourceBuffer.setCurrentFragmentedTrackIdx(i);
                        }
                    }
                }
                break;
            }
        }

        if (allTracksAreDisabled) {
            textTracks.setCurrentTrackIdx(-1);
        }
    }

    function getCurrentTrackIdx() {
        var textTracks = textSourceBuffer.getConfig().textTracks;
        return textTracks.getCurrentTrackIdx();
    }

    function reset() {
        allTracksAreDisabled = false;
        textSourceBuffer.resetEmbedded();
    }

    instance = {
        setConfig: setConfig,
        getTextSourceBuffer: getTextSourceBuffer,
        getAllTracksAreDisabled: getAllTracksAreDisabled,
        addEmbeddedTrack: addEmbeddedTrack,
        setTextTrack: setTextTrack,
        getCurrentTrackIdx: getCurrentTrackIdx,
        reset: reset
    };
    setup();
    return instance;
}

TextController.__dashjs_factory_name = 'TextController';
exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(TextController);
module.exports = exports['default'];
//# sourceMappingURL=TextController.js.map


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @class
 * @ignore
 */


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var FragmentRequest = function FragmentRequest() {
  _classCallCheck(this, FragmentRequest);

  this.action = FragmentRequest.ACTION_DOWNLOAD;
  this.startTime = NaN;
  this.mediaType = null;
  this.mediaInfo = null;
  this.type = null;
  this.duration = NaN;
  this.timescale = NaN;
  this.range = null;
  this.url = null;
  this.serviceLocation = null;
  this.requestStartDate = null;
  this.firstByteDate = null;
  this.requestEndDate = null;
  this.quality = NaN;
  this.index = NaN;
  this.availabilityStartTime = null;
  this.availabilityEndTime = null;
  this.wallStartTime = null;
  this.bytesLoaded = NaN;
  this.bytesTotal = NaN;
  this.delayLoadingTime = NaN;
  this.responseType = 'arraybuffer';
  this.representationId = null;
};

FragmentRequest.ACTION_DOWNLOAD = 'download';
FragmentRequest.ACTION_COMPLETE = 'complete';

exports['default'] = FragmentRequest;
module.exports = exports['default'];
//# sourceMappingURL=FragmentRequest.js.map


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(178);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(1521));
__export(__webpack_require__(1520));
__export(__webpack_require__(1518));
__export(__webpack_require__(1519));
//# sourceMappingURL=index.js.map

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

;(function () {
  function factory(globalPromise) {
    var bluebird_extended, utils_mappers, utils_utils, utils_http, events_notifier, sources_Source, sources_bigstock_settings, sources_bigstock_mappers_folder, sources_bigstock_parsers_folders, sources_bigstock_folders, sources_bigstock_mappers_item, sources_bigstock_parsers_items, sources_bigstock_parsers_error, sources_bigstock_items, sources_decorators, events_list, sources_bigstock_BigStock, sources_shutterstock_settings, sources_shutterstock_mappers_folder, sources_shutterstock_parsers_folders, sources_shutterstock_folders, sources_shutterstock_mappers_item, sources_shutterstock_parsers_items, sources_shutterstock_parsers_error, sources_shutterstock_items, sources_shutterstock_ShutterStock, sources_public_mappers_folder, sources_public_parsers_folders, sources_public_parsers_error, sources_public_folders, services_thumbnail_generator_resize, services_thumbnail_generator_get_wix_thumbnails_urls, services_thumbnail_generator_get_wix_video_preview_urls, sources_public_mappers_item, sources_public_parsers_items, sources_public_items, sources_public_item, sources_public_settings, sources_public_Public, sources_private_mappers_folder, sources_private_parsers_error, sources_private_folders, sources_private_validators_new_props, sources_private_folder, sources_private_mappers_item, sources_private_items, constants_transcoding_statuses, sources_private_item, sources_private_trash, sources_private_itemstrash, sources_private_itemssite_media, sources_private_folderstrash, sources_private_settings, services_channel_channel, services_new_relic, services_channel_black_arrow, sources_private_refresh_token_wrapper, services_polling, services_crc32, services_upload_file_to_upload, services_upload_upload_collection, services_bi_send_request, services_bi_event_ids, services_resumable, sources_private_Private, sources_platform_mappers_folder, sources_platform_parsers_error, sources_platform_folders, sources_platform_validators_new_props, sources_platform_folder, sources_platform_mappers_item, sources_platform_items, sources_platform_item, sources_platform_trash, sources_platform_itemstrash, sources_platform_itemssite_media, sources_platform_folderstrash, sources_platform_settings, sources_platform_Platform, sources_picasa_settings, sources_picasa_mappers_folder, sources_picasa_parsers_folders, sources_picasa_parsers_error, sources_picasa_folders, sources_picasa_mappers_item, sources_picasa_parsers_items, sources_picasa_items, sources_picasa_Picasa, sources_drive_settings, sources_drive_mappers_folder, sources_drive_parsers_folders, sources_drive_parsers_error, sources_drive_folders, sources_drive_mappers_item, sources_drive_parsers_items, sources_drive_items, sources_drive_Drive, sources_dropbox_settings, sources_dropbox_mappers_folder, sources_dropbox_parsers_folders, sources_dropbox_parsers_error, sources_dropbox_folders, sources_dropbox_mappers_item, sources_dropbox_parsers_items, sources_dropbox_items, sources_dropbox_Dropbox, sources_instagram_settings, sources_instagram_mappers_folder, sources_instagram_parsers_folders, sources_instagram_parsers_error, sources_instagram_folders, sources_instagram_mappers_item, sources_instagram_parsers_items, sources_instagram_items, sources_instagram_Instagram, sources_instagram_video_settings, sources_instagram_video_mappers_folder, sources_instagram_video_parsers_folders, sources_instagram_video_folders, sources_instagram_video_mappers_item, sources_instagram_video_parsers_items, sources_instagram_video_parsers_error, sources_instagram_video_items, sources_instagram_video_InstagramVideo, sources_facebook_settings, sources_facebook_mappers_folder, sources_facebook_parsers_folders, sources_facebook_parsers_error, sources_facebook_folders, sources_facebook_mappers_item, sources_facebook_parsers_items, sources_facebook_items, sources_facebook_Facebook, sources_facebook_video_settings, sources_facebook_video_mappers_folder, sources_facebook_video_parsers_folders, sources_facebook_video_folders, sources_facebook_video_mappers_item, sources_facebook_video_parsers_items, sources_facebook_video_parsers_error, sources_facebook_video_items, sources_facebook_video_FacebookVideo, sources_flickr_settings, sources_flickr_mappers_folder, sources_flickr_parsers_folders, sources_flickr_parsers_error, sources_flickr_folders, sources_flickr_mappers_item, sources_flickr_parsers_items, sources_flickr_items, sources_flickr_Flickr, sources_flickr_search_settings, sources_flickr_search_mappers_item, sources_flickr_search_parsers_items, sources_flickr_search_parsers_error, sources_flickr_search_items, sources_flickr_search_FlickrSearch, sources_google_search_settings, sources_google_search_mappers_item, sources_google_search_parsers_items, sources_google_search_parsers_error, sources_google_search_items, sources_google_search_GoogleSearch, sources_collection_settings, sources_collection_mappers_folder, sources_collection_parsers_selector, sources_collection_parsers_folders, sources_collection_parsers_error, sources_collection_folders, sources_collection_mappers_item, sources_collection_parsers_items, sources_collection_items, sources_collection_Collection, sources_vimeo_settings, sources_vimeo_mappers_folder, sources_vimeo_parsers_folders, sources_vimeo_folders, sources_vimeo_mappers_item, sources_vimeo_parsers_items, sources_vimeo_parsers_error, sources_vimeo_items, sources_vimeo_Vimeo, sources_vimeo_search_settings, sources_vimeo_search_mappers_item, sources_vimeo_search_parsers_items, sources_vimeo_search_parsers_error, sources_vimeo_search_items, sources_vimeo_search_VimeoSearch, sources_youtube_settings, sources_youtube_mappers_folder, sources_youtube_parsers_folders, sources_youtube_parsers_error, sources_youtube_folders, sources_youtube_mappers_item, sources_youtube_parsers_items, sources_youtube_items, sources_youtube_YouTube, sources_youtube_search_settings, sources_youtube_search_mappers_item, sources_youtube_search_parsers_items, sources_youtube_search_parsers_error, sources_youtube_search_items, sources_youtube_search_YouTubeSearch, sources_showbox_mappers_folder, sources_showbox_parsers_error, sources_showbox_folders, sources_showbox_mappers_item, sources_showbox_items, sources_showbox_item, sources_showbox_settings, sources_showbox_Showbox, sources_list, events_events, connector_connector_settings, connector_connector, services_bi_benchmarks, services_bi_errors, services_bi_upload_queue, services_bi_bi, services_thumbnail_generator_thumbnail_generator, wixmp;
var cancellationErrorCode = -7799;
bluebird_extended = function () {
  var Promise = globalPromise;
  function CancellationError() {
    Promise.CancellationError.apply(this, arguments);
    this.data = {
      errorCode: cancellationErrorCode,
      errorDescription: 'Canceled by user',
      errorInfo: {
        key: 'wmp_error.canceled_by_user',
        args: []
      }
    };
  }
  if (Promise.CancellationError) {
    CancellationError.prototype = Object.create(Promise.CancellationError.prototype);
  }
  Promise.newAbortable = function (func) {
    var reject;
    var promise = new Promise(function () {
      reject = arguments[1];
      return func.apply(this, arguments);
    });
    if (promise.cancellable) {
      promise = promise.cancellable();
      promise.abort = function () {
        this.cancel(new CancellationError());
      };
    } else {
      promise.abort = function () {
        reject(new CancellationError());
      };
    }
    return promise;
  };
  Promise.defer = function () {
    var resolve, reject;
    var promise = Promise.newAbortable(function () {
      resolve = arguments[0];
      reject = arguments[1];
    });
    return {
      resolve: resolve,
      reject: reject,
      promise: promise
    };
  };
  if (!Promise.CancellationError) {
    Promise.CancellationError = function () {
      Error.apply(this, arguments);
    };
    Promise.CancellationError.prototype = Object.create(Error.prototype);
  }
  [
    'then',
    'catch'
  ].forEach(function (name) {
    var original = Promise.prototype[name];
    Promise.prototype[name] = function () {
      var promise = original.apply(this, arguments);
      if (!promise.abort) {
        promise.abort = this.abort;
      }
      return promise;
    };
  });
  Promise.prototype.progress = function (callback) {
    this._progressCallback = callback;
    return this;
  };
  Promise.prototype.notify = function (message) {
    if (typeof this._progressCallback === 'function') {
      this._progressCallback(message);
    }
    return this;
  };
  return Promise;
}();
utils_mappers = {
  toObject: function (data) {
    if (!data) {
      return null;
    }
    if (typeof data === 'string') {
      if ([
          '{',
          '['
        ].indexOf(data[0]) >= 0) {
        try {
          return JSON.parse(data);
        } catch (err) {
          return {
            error_code: -100,
            error_description: 'Can`t parse JSON',
            error_info: { key: 'wmp_error.cant_parse_json' }
          };
        }
      }
      return { message: data };
    }
    return data;
  },
  toError: function (error) {
    var errorObject = new Error();
    errorObject.code = error.status || error.code;
    errorObject.message = error.statusText || error.message || error.data.message || error.data.error && error.data.error.message || '';
    errorObject.data = error.data && (error.data.errors || error.data.error || error.data);
    errorObject.config = error.config;
    return errorObject;
  }
};
utils_utils = function (Promise, mappers) {
  function minMaxFinder(method, arr, predicate) {
    var mappedArr;
    if (predicate) {
      mappedArr = arr.map(predicate);
      return arr[mappedArr.indexOf(Math[method].apply(null, mappedArr))];
    }
    return Math[method].apply(this, arr);
  }
  var utils = {
    /**
     * Extend object values with sources objects data
     * @param dest {Object}
     * @param source.. {Object}
     * @returns {*}
     */
    extend: function (dest) {
      dest = dest || {};
      var sources = Array.prototype.slice.call(arguments, 1);
      sources.forEach(function (source) {
        if (typeof source === 'object' && source !== null) {
          Object.keys(source).forEach(function (key) {
            dest[key] = source[key];
          });
        }
      });
      return dest;
    },
    /**
     * Extend deep objects
     * @param object {Object}
     * @returns {Object}
     * @description Deep merge objects, works like lodash merge.
     */
    extendDeep: function extendDeep(object) {
      object = object || {};
      for (var i = 1, len = arguments.length; i < len; ++i) {
        var obj = arguments[i];
        if (!obj) {
          continue;
        }
        for (var key in obj) {
          if (!obj.hasOwnProperty(key)) {
            continue;
          }
          if (obj[key] === undefined) {
            continue;
          }
          if (Object.prototype.toString.call(obj[key]) === '[object Object]') {
            object[key] = extendDeep(object[key], obj[key]);
            continue;
          }
          object[key] = obj[key];
        }
      }
      return object;
    },
    /**
     * Gets the value at path of object.
     * If the resolved value is undefined, the defaultValue is returned in its place.
     * @param object
     * @param path
     * @param defaultValue
     * @returns {*}
     */
    get: function (object, path, defaultValue) {
      if (!object || !path) {
        return defaultValue;
      }
      var paths = Array.isArray(path) ? path : path.split(/[\.\[\]]/);
      paths = paths.filter(function (path) {
        return path;
      });
      var result = paths.reduce(function (prevValue, currentNamespace) {
        if (prevValue && prevValue[currentNamespace]) {
          return prevValue[currentNamespace];
        }
        return undefined;
      }, object);
      if (result) {
        return result;
      }
      return defaultValue;
    },
    /**
     * Merge
     * @returns {*}
     */
    merge: function () {
      var hop = Object.prototype.hasOwnProperty;
      return Array.prototype.reduce.call(arguments, function (result, source) {
        Object.keys(result).forEach(function (key) {
          if (hop.call(source, key)) {
            result[key] = source[key];
          }
        });
        Object.keys(source).forEach(function (key) {
          result[key] = source[key];
        });
        return result;
      }, {});
    },
    bytesToSize: function (bytes) {
      if (bytes === 0) {
        return '0 Byte';
      }
      var k = 1024;
      var sizes = [
        'Bytes',
        'KB',
        'MB',
        'GB',
        'TB',
        'PB',
        'EB',
        'ZB',
        'YB'
      ];
      var i = Math.floor(Math.log(bytes) / Math.log(k));
      return (bytes / Math.pow(k, i)).toPrecision(3) + ' ' + sizes[i];
    },
    /**
     * Return function with preset arguments
     * @param func {Function}
     * @param [argument..] {*}
     * @returns {Function}
     */
    partial: function (func) {
      var partialArguments = Array.prototype.slice.call(arguments, 1);
      return function () {
        var args = Array.prototype.slice.call(arguments);
        return func.apply(this, partialArguments.concat(args));
      };
    },
    /**
     * Return parameter value from search string
     * @param searchString {String}
     * @param name {String}
     * @returns {String}
     */
    getParameterByName: function (searchString, name) {
      var regex, results;
      name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
      regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
      results = regex.exec(searchString);
      if (!results) {
        return '';
      }
      return decodeURIComponent(results[1].replace(/\+/g, ' '));
    },
    /**
     * Return camel case string from snake case string
     * @param string {String}
     * @returns {String}
     */
    snakeToCamel: function (string) {
      string = string[0].toLowerCase() + string.slice(1);
      return string.replace(/[_]+$/g, '').replace(/([^_]?)[_]+([^_])/g, function ($0, $1, $2) {
        if (!$1) {
          return $2.toLowerCase();
        }
        return $1.toLowerCase() + $2.toUpperCase();
      });
    },
    /**
     * Return snake case string from camel case string
     * @param string {String}
     * @returns {String}
     */
    camelToSnake: function (string) {
      return string.replace(/([a-z]?)([A-Z])/g, function ($0, $1, $2) {
        if (!$1) {
          return $0.toLowerCase();
        }
        return $1 + '_' + $2.toLowerCase();
      });
    },
    find: function (arr, predicate) {
      var found;
      arr.some(function (el) {
        if (predicate(el) === true) {
          found = el;
          return true;
        }
      });
      return found;
    },
    encodeParams: function (a) {
      var s = [], add = function (key, value) {
          s[s.length] = encodeURIComponent(key) + '=' + encodeURIComponent(value);
        };
      Object.keys(a).forEach(function (entity) {
        add(entity, a[entity]);
      });
      return s.join('&').replace(/%20/g, '+');
    },
    splitTags: function (tags) {
      if (!tags) {
        return [];
      }
      if (Array.isArray(tags)) {
        return tags;
      }
      return tags.split(/\s*,\s*/);
    },
    normalizeUri: function (uri) {
      if (typeof uri !== 'string') {
        throw new Error('URI is not a string');
      }
      return uri.replace(/([a-z\-_0-9]+)\/\//gi, '$1/');
    },
    getScript: function (src) {
      return Promise.newAbortable(function (resolve, reject) {
        var head = document.getElementsByTagName('head')[0];
        var script = document.createElement('script');
        var done = false;
        script.src = src;
        script.onload = script.onreadystatechange = function () {
          if (!done && (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete')) {
            done = true;
            resolve();
            script.onload = script.onreadystatechange = null;
            if (head && script.parentNode) {
              head.removeChild(script);
            }
          } else {
            reject(mappers.toError());
          }
        };
        head.insertBefore(script, head.firstChild);
      });
    },
    startsWithGuid: function (guid) {
      return /^\w{8}-(\w{4}-){3}\w{12}/.test(guid);
    },
    endsWith: function (string, suffix) {
      return string.indexOf(suffix, string.length - suffix.length) !== -1;
    },
    /**
     * sortBy like lodash _.sortBy
     * @param {Object[]} arrayOfObjects
     * @param {String} key
     * @param {String} [sortOrder='asc']
     * @returns {Object[]} sorted array
     */
    sortBy: function (arrayOfObjects, key, sortOrder) {
      return arrayOfObjects.slice().sort(function (a, b) {
        var order = 0;
        if (a[key] < b[key]) {
          order = -1;
        } else if (a[key] > b[key]) {
          order = 1;
        }
        if (sortOrder === 'desc') {
          return -order;
        }
        return order;
      });
    },
    /**
     * objectValues doesn't work like a native Object.values
     * @param {Object} object
     * @returns {Array} Array of given object property values
     */
    objectValues: function (object) {
      if (!object) {
        return [];
      }
      return Object.keys(object).map(function (key) {
        return object[key];
      });
    },
    /**
     * getThumbnailsUrlsFromList
     * @param {Array} sourceSizes
     * @param {Object} requiredSizes
     * @returns {Object.<thumbnailUrl, previewUrl>}
     */
    getThumbnailsUrlsFromList: function (sourceSizes, requiredSizes) {
      if (!sourceSizes.length) {
        return {};
      }
      function canFill(sizes, sizesToTest) {
        return sizesToTest.width >= sizes.width && sizesToTest.height >= sizes.height;
      }
      function canFit(sizes, sizesToTest) {
        return sizesToTest.width >= sizes.width || sizesToTest.height >= sizes.height;
      }
      var sourceSizesSorted = utils.sortBy(sourceSizes, 'width');
      return Object.keys(requiredSizes).reduce(function (urls, sizeName) {
        var requiredSize = requiredSizes[sizeName];
        var currentSize = utils.find(sourceSizesSorted, function (size) {
          return requiredSize.mode === 'fill' ? canFill(requiredSize, size) : canFit(requiredSize, size);
        });
        urls[sizeName + 'Url'] = currentSize ? currentSize.url : sourceSizesSorted[sourceSizesSorted.length - 1].url;
        return urls;
      }, {});
    },
    /**
     * replaceHtml
     * @param {String} htmlString
     * @returns {String}
     */
    replaceHtml: function (htmlString) {
      return (htmlString || '').replace(/<\/?[a-z]+.*?>/gi, '');
    },
    /**
     * toTimeStamp
     * @param {String} date
     * @returns {Number} time stamp in seconds
     */
    toTimeStamp: function (date) {
      return !date ? null : Math.floor(new Date(date).getTime() / 1000);
    }
  };
  utils.min = utils.partial(minMaxFinder, 'min');
  utils.max = utils.partial(minMaxFinder, 'max');
  return utils;
}(bluebird_extended, utils_mappers);
utils_http = function (Promise, utils, mappers) {
  var contentTypes = {
    JSON: 'application/json',
    URL_ENCODED: 'application/x-www-form-urlencoded',
    MULTIPART: 'multipart/form-data'
  };
  var defaultOptions = {
    withCredentials: false,
    cache: true,
    headers: { Accept: 'application/json, text/plain, */*' }
  };
  function parseResponseData(response) {
    if (typeof response === 'string') {
      if ([
          '{',
          '['
        ].indexOf(response[0]) >= 0) {
        response = JSON.parse(response);
      } else {
        response = { message: response };
      }
    }
    return response;
  }
  function parseResponse(request) {
    return {
      status: request.status,
      statusText: request.statusText,
      responseSize: request.responseText.length,
      data: parseResponseData(request.responseText)
    };
  }
  function encode(val) {
    return encodeURIComponent(val).replace(/%40/gi, '@').replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
  }
  function buildUrl(url, params) {
    if (!params) {
      return url;
    }
    var parts = [];
    Object.keys(params).forEach(function (key) {
      var val = params[key];
      if (val === null || typeof val === 'undefined') {
        return;
      }
      if (!(val instanceof Array)) {
        val = [val];
      }
      val.forEach(function (v) {
        if (v instanceof Date && !isNaN(v.valueOf())) {
          v = v.toISOString();
        } else if (typeof v === 'object') {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });
    if (parts.length > 0) {
      url += (url.indexOf('?') === -1 ? '?' : '&') + parts.join('&');
    }
    return url;
  }
  function encodeRequestData(data, contentType) {
    if (contentType.indexOf(contentTypes.JSON) !== -1) {
      return JSON.stringify(data);
    }
    if (contentType.indexOf(contentTypes.URL_ENCODED) !== -1) {
      return utils.encodeParams(data);
    }
    if (contentType.indexOf(contentTypes.MULTIPART) !== -1) {
      var formData = new FormData();
      Object.keys(data).forEach(function (name) {
        var value = data[name];
        var args = name === 'file' ? [
          name,
          value,
          value.name
        ] : [
          name,
          value
        ];
        return formData.append.apply(formData, args);
      });
      return formData;
    }
  }
  return function (options) {
    var requestOptions = utils.extend({}, options);
    function setRequestOptions(settings) {
      requestOptions = utils.extendDeep(requestOptions, settings);
    }
    function wrapRequestWithPromise(request, callSend, hasProgress) {
      var promise = Promise.newAbortable(function (resolve, reject) {
        request.addEventListener('error', function () {
          reject(mappers.toError(utils.extend({}, request, {
            message: 'error',
            code: 0,
            errorInfo: { key: request.responseText || 'internal_server_error' }
          })));
        }, false);
        request.addEventListener('timeout', function () {
          reject(mappers.toError(utils.extend({}, request, {
            message: 'timeout_has_exceeded',
            code: 408
          })));
        }, false);
        request.addEventListener('load', function () {
          if (request.status.toString().match(/^2\d+/i)) {
            resolve(parseResponse(request));
          } else {
            reject(mappers.toError(utils.extend({}, request, {
              message: 'error',
              code: request.status,
              data: mappers.toObject(request.responseText),
              errorInfo: { key: request.responseText || 'load_error' }
            })));
          }
        }, false);
      });
      if (hasProgress) {
        request.upload.onprogress = function (event) {
          var progress = Math.round(event.lengthComputable ? event.loaded * 100 / event.total : 0);
          var status = progress <= 99 ? 'uploading' : 'processing';
          promise.notify({
            status: status,
            total: event.total,
            loaded: event.loaded
          });
        };
      } else {
        request.addEventListener('loadstart', function (event) {
          if (!event) {
            return;
          }
          promise.notify({
            status: 'uploading',
            total: event.total,
            loaded: event.loaded
          });
        }, false);
        request.addEventListener('loadend', function (event) {
          if (!event) {
            return;
          }
          promise.notify({
            status: 'processing',
            total: event.total,
            loaded: event.loaded
          });
        }, false);
      }
      promise.catch(function (err) {
        if (err instanceof Promise.CancellationError) {
          request.abort();
        }
      });
      callSend();
      return promise;
    }
    function openRequest(method, url, options) {
      var request = new XMLHttpRequest();
      if (options.cache === false) {
        url += (url.indexOf('?') === -1 ? '?' : '&') + '_=' + Date.now();
      }
      request.open(method.toUpperCase(), utils.normalizeUri(url));
      if (options.responseType) {
        request.responseType = options.responseType;
      }
      request.withCredentials = options.withCredentials;
      Object.keys(options.headers).forEach(function (name) {
        request.setRequestHeader(name, options.headers[name]);
      });
      request.config = utils.extend({
        url: url,
        method: method
      }, options);
      return request;
    }
    function get(url, params, options) {
      params = utils.extend({}, params, requestOptions.params);
      var request = openRequest('get', buildUrl(url, params), utils.extendDeep({}, defaultOptions, requestOptions, options));
      return wrapRequestWithPromise(request, function () {
        request.send(null);
      });
    }
    /**
     * POST request
     * @param url {String}
     * @param data {Object} Post data
     * @param params {Object} Url get params
     * @param options {Object} Options
     * @returns {*}
     */
    function post(url, data, params, options) {
      data = data || {};
      params = params || {};
      options = options || {};
      var userOptions = utils.extendDeep({}, defaultOptions, { headers: { 'Content-Type': 'application/json; charset=utf-8' } }, requestOptions, options);
      data = utils.extend({}, data, requestOptions.params);
      data = encodeRequestData(data, userOptions.headers['Content-Type']);
      var request = openRequest('post', buildUrl(url, params), userOptions);
      return wrapRequestWithPromise(request, function () {
        request.send(data);
      });
    }
    function upload(url, multipart, options) {
      var userOptions = utils.extendDeep({}, defaultOptions, options);
      var request = openRequest('post', url, userOptions);
      var multipartData = utils.extend({}, multipart, requestOptions.params);
      multipartData = encodeRequestData(multipartData, contentTypes.MULTIPART);
      return wrapRequestWithPromise(request, function () {
        request.send(multipartData);
      }, true);
    }
    function catchError(method, onError) {
      return function () {
        var self = this;
        var args = arguments;
        var firstPromise;
        function callOriginalMethod() {
          return method.apply(self, args);
        }
        firstPromise = callOriginalMethod();
        var promise = Promise.newAbortable(function (resolve, reject) {
          firstPromise.then(resolve, function (reason) {
            if (onError !== undefined) {
              return onError.call(this, reason, callOriginalMethod);
            }
            return reason;
          }).then(resolve, reject);
        });
        firstPromise.progress(function (progress) {
          promise.notify(progress);
        });
        promise.catch(function (err) {
          if (err instanceof Promise.CancellationError) {
            firstPromise.abort();
          }
        });
        return promise;
      };
    }
    function makeRetriable(method) {
      return catchError(method, function (reason, callOriginalMethod) {
        if (reason instanceof Promise.CancellationError || reason.code === 406 || reason.code === 403) {
          return Promise.reject(reason);
        }
        return callOriginalMethod();
      });
    }
    return {
      get: makeRetriable(get),
      post: makeRetriable(post),
      upload: makeRetriable(upload),
      catchError: catchError,
      setRequestOptions: setRequestOptions
    };
  };
}(bluebird_extended, utils_utils, utils_mappers);
events_notifier = function (Promise) {
  var listeners = {};
  function noop() {
  }
  function callEach(functions, data) {
    functions.forEach(function (currentFunction) {
      currentFunction(data);
    });
  }
  function callEachAtIndex(functions, index, data) {
    functions.forEach(function (functions) {
      functions[index](data);
    });
  }
  function emitWithArrayOfPromises(eventTarget, eventName, params) {
    // no listeners
    if (typeof listeners[eventName] === 'undefined') {
      return {
        resolveAt: noop,
        rejectAt: noop
      };
    }
    var resolvers = [], rejectors = [];
    listeners[eventName].forEach(function (listener) {
      var thisEventResolvers = [], thisEventRejectors = [];
      var eventPromises = params.promises.map(function () {
        return new Promise(function (resolve, reject) {
          thisEventResolvers.push(resolve);
          thisEventRejectors.push(reject);
        });
      });
      resolvers.push(thisEventResolvers);
      rejectors.push(thisEventRejectors);
      listener(eventPromises, params);
    });
    return {
      resolveAt: function (index, data) {
        callEachAtIndex(resolvers, index, data);
      },
      rejectAt: function (index, data) {
        callEachAtIndex(rejectors, index, data);
      }
    };
  }
  function emit(eventTarget, eventName, params) {
    if (typeof eventTarget !== 'object' || eventTarget === null) {
      throw new Error('target should be a function');
    }
    if (typeof eventName !== 'string') {
      throw new Error('eventName should be a string');
    }
    params = params || {};
    params.eventTarget = eventTarget;
    params.eventName = eventName;
    if (params.promises && params.promises.length) {
      return emitWithArrayOfPromises(eventTarget, eventName, params);
    }
    // no listeners
    if (typeof listeners[eventName] === 'undefined') {
      return {
        resolve: noop,
        reject: noop
      };
    }
    var resolvers = [], rejectors = [];
    listeners[eventName].forEach(function (listener) {
      var promise = new Promise(function (resolveCurrent, rejectCurrent) {
        resolvers.push(resolveCurrent);
        rejectors.push(rejectCurrent);
      });
      listener(promise, params);
    });
    return {
      resolve: function (data) {
        callEach(resolvers, data);
      },
      reject: function (reason) {
        callEach(rejectors, reason);
      }
    };
  }
  function emitResolve(eventTarget, eventName, params, result) {
    var promise = new Promise(function (resolve) {
      resolve(result);
    });
    params.promises = [promise];
    var event = emit(eventTarget, eventName, params);
    promise.then(function (data) {
      event.resolveAt(0, data);
    });
    return event;
  }
  /**
   * @summary Subscribe listener to event
   * @name on
   * @memberof wixmp.events
   * @method
   * @param eventName {String} Event name
   * @param listener {Function} Callback function that is when corresponding method is fired
   */
  function addListener(eventName, listener) {
    if (typeof listeners[eventName] === 'undefined') {
      listeners[eventName] = [];
    }
    listeners[eventName].push(listener);
  }
  /**
   * @summary Unsubscribe listener from event
   * @name off
   * @memberof wixmp.events
   * @method
   * @param eventName {String} Event name
   * @param listener {Function} Callback function
   */
  function removeListener(eventName, listener) {
    if (listeners[eventName]) {
      var index = listeners[eventName].indexOf(listener);
      listeners[eventName].splice(index, 1);
    }
  }
  return {
    emit: emit,
    emitResolve: emitResolve,
    addListener: addListener,
    removeListener: removeListener
  };
}(bluebird_extended);
sources_Source = function (initHttp, notifier) {
  /**
   * @summary The constructor function of a source
   * @namespace Source
   * @class
   * @memberof wixmp
   * @param {Function} Source constructor function
   * @param {Object} Source settings
   */
  return function (SourceConstructor, settings) {
    if (typeof SourceConstructor !== 'function') {
      throw new Error('Source constructor should be a function');
    }
    if (typeof settings !== 'undefined' && (typeof settings !== 'object' || settings === null)) {
      throw new Error('Source settings should be an object');
    }
    var http = initHttp();
    return new SourceConstructor(settings, notifier.emit, http);
  };
}(utils_http, events_notifier);
sources_bigstock_settings = { apiUrl: '//pix.wix.com/services/bigstock' };
sources_bigstock_mappers_folder = function (data) {
  return {
    id: data.id,
    name: data.name,
    mediaType: 'picture',
    parentId: null,
    filesCount: null,
    createdAt: null
  };
};
sources_bigstock_parsers_folders = function (toFolder) {
  return function (res) {
    res.data = (res.data || []).map(toFolder);
    return res;
  };
}(sources_bigstock_mappers_folder);
sources_bigstock_folders = function (mapFolderList, Promise) {
  return function () {
    var folders = mapFolderList({
      data: [
        {
          id: null,
          name: 'All'
        },
        {
          id: 'Abstract',
          name: 'Abstract'
        },
        {
          id: 'Animals',
          name: 'Animals'
        },
        {
          id: 'Architecture',
          name: 'Architecture'
        },
        {
          id: 'Backgrounds',
          name: 'Backgrounds'
        },
        {
          id: 'Business',
          name: 'Business'
        },
        {
          id: 'Communication',
          name: 'Communication'
        },
        {
          id: 'Computers',
          name: 'Computers'
        },
        {
          id: 'Conceptual',
          name: 'Conceptual'
        },
        {
          id: 'Editorial',
          name: 'Editorial'
        },
        {
          id: 'Education',
          name: 'Education'
        },
        {
          id: 'Food',
          name: 'Food'
        },
        {
          id: 'Health',
          name: 'Health'
        },
        {
          id: 'Holidays',
          name: 'Holidays'
        },
        {
          id: 'Industry',
          name: 'Industry'
        },
        {
          id: 'Internet',
          name: 'Internet'
        },
        {
          id: 'Landscapes',
          name: 'Landscapes'
        },
        {
          id: 'Maps',
          name: 'Maps'
        },
        {
          id: 'Miscellaneous',
          name: 'Miscellaneous'
        },
        {
          id: 'Musical',
          name: 'Musical'
        },
        {
          id: 'Nature',
          name: 'Nature'
        },
        {
          id: 'Objects',
          name: 'Objects'
        },
        {
          id: 'People',
          name: 'People'
        },
        {
          id: 'Places',
          name: 'Places'
        },
        {
          id: 'Sports',
          name: 'Sports'
        },
        {
          id: 'Transportation',
          name: 'Transportation'
        }
      ]
    });
    function list() {
      return Promise.resolve(folders);
    }
    return { list: list };
  };
}(sources_bigstock_parsers_folders, bluebird_extended);
sources_bigstock_mappers_item = function (utils) {
  return function (data) {
    var size = utils.find(data.formats, function (format) {
      return format.size_code === 'l';
    });
    if (!size) {
      size = data.formats.pop();
    }
    return {
      id: data.id,
      name: data.title,
      folderId: null,
      mediaType: 'picture',
      fileUrl: null,
      thumbnailUrl: utils.normalizeUri(data.large_thumb.url),
      previewUrl: utils.normalizeUri(data.preview.url),
      createdAt: null,
      tags: [],
      width: size.width,
      height: size.height
    };
  };
}(utils_utils);
sources_bigstock_parsers_items = function (toItem) {
  return function (res) {
    var data = res.data.data;
    var cursor = data.paging && data.paging.page < data.paging.total_pages ? data.paging.page + 1 : null;
    var size = Number(data.paging.items_per_page);
    res.data = (data.images || []).map(toItem);
    res.paging = {
      cursor: cursor,
      size: size
    };
    return res;
  };
}(sources_bigstock_mappers_item);
sources_bigstock_parsers_error = function (Promise) {
  return function (response) {
    if (response.code === 503 && response.data && response.data.code === 'search-critical') {
      return {
        data: [],
        status: response.code,
        error: response.data
      };
    }
    response.data = response.data || {};
    var data = response.data;
    var code;
    if (Array.isArray(data)) {
      code = data[0].code || data[0];
    } else {
      code = data.code;
    }
    response.data.message = code;
    return Promise.reject(response);
  };
}(bluebird_extended);
sources_bigstock_items = function (mapItemList, toError) {
  return function (settings, http) {
    function list(folderId, options) {
      options = options || {};
      options.paging = options.paging || {};
      options.sort = options.sort || {};
      var requestOptions = {
        limit: options.paging.size || 50,
        page: options.paging.cursor || null,
        order: options.sort.field || null,
        category: folderId || null,
        orientation: options.orientation || null
      };
      return http.get(settings.apiUrl + '/search', requestOptions, { headers: options.headers || {} }).then(mapItemList).catch(toError);
    }
    function search(folderId, query, options) {
      options = options || {};
      options.paging = options.paging || {};
      options.sort = options.sort || {};
      var requestOptions = {
        q: query || null,
        limit: options.paging.size || 50,
        page: options.paging.cursor || null,
        order: options.sort.field || null,
        category: folderId || null,
        orientation: options.orientation || null
      };
      return http.get(settings.apiUrl + '/search', requestOptions, { headers: options.headers || {} }).then(mapItemList).catch(toError);
    }
    return {
      list: list,
      search: search
    };
  };
}(sources_bigstock_parsers_items, sources_bigstock_parsers_error);
sources_decorators = function (Promise, notifier, utils) {
  function addEvents(eventsTarget, events, methods) {
    var methodsWithEvents = {};
    Object.keys(events).forEach(function (eventKey) {
      var methodName = utils.snakeToCamel(eventKey.toLowerCase());
      if (typeof methods[methodName] === 'object' && methods[methodName] !== null && typeof events[eventKey] === 'object' && events[eventKey] !== null) {
        methodsWithEvents[methodName] = addEvents(eventsTarget, events[eventKey], methods[methodName]);
        return;
      } else if (typeof methods[methodName] !== 'function') {
        return;
      }
      // define new method with event generation
      methodsWithEvents[methodName] = function () {
        // emit before event and call native method
        //var event = notifier.emit(eventsTarget, events[eventKey], {arguments: arguments});
        var args = [].slice.call(arguments);
        var promise = methods[methodName].apply(methods, args);
        var params = { arguments: args };
        var event;
        var wrapped;
        if (Array.isArray(promise)) {
          params.promises = promise;
          event = notifier.emit(eventsTarget, events[eventKey], params);
          promise.forEach(function (promise, index) {
            var wrappedInner = promise.then(function (data) {
              event.resolveAt(index, data);
            }, function (reason) {
              event.rejectAt(index, reason);
            });
            promise.progress(function (progress) {
              wrappedInner.notify(progress);
            });
          });
          return promise;
        }
        event = notifier.emit(eventsTarget, events[eventKey], params);
        wrapped = promise.then(function (data) {
          event.resolve(data);
          return data;
        }, function (reason) {
          event.reject(reason);
          return Promise.reject(reason);
        });
        promise.progress(function (progress) {
          wrapped.notify(progress);
        });
        return wrapped;
      };
    });
    return methodsWithEvents;
  }
  return { addEvents: addEvents };
}(bluebird_extended, events_notifier, utils_utils);
events_list = {
  /**
   * @summary List of possible folders events
   * @enum
   * @memberof wixmp.events
   */
  FOLDERS: {
    LIST: 'folders.list',
    REMOVE: 'folders.remove',
    /**
     * @summary List of possible trashed folders events
     * @enum
     * @memberof wixmp.events.folders
     */
    TRASH: {
      LIST: 'folders.trash.list',
      RESTORE: 'folders.trash.restore',
      REMOVE: 'folders.trash.remove'
    }
  },
  /**
   * @summary List of possible folder events
   * @enum
   * @memberof wixmp.events
   */
  FOLDER: {
    CREATE: 'folder.create',
    UPDATE: 'folder.update'
  },
  /**
   * @summary List of possible items events
   * @enum
   * @memberof wixmp.events
   */
  ITEMS: {
    LIST: 'items.list',
    REMOVE: 'items.remove',
    SEARCH: 'items.search',
    SEARCH_BY_TAG: 'items.searchByTag',
    /**
     * @summary List of possible trashed items events
     * @enum
     * @memberof wixmp.events.items
     */
    TRASH: {
      LIST: 'items.trash.list',
      RESTORE: 'items.trash.restore',
      REMOVE: 'items.trash.remove'
    },
    /**
     * @summary List of possible site_media items events
     * @enum
     * @memberof wixmp.events.items
     */
    SITE_MEDIA: {
      LIST: 'items.siteMedia.list',
      REMOVE: 'items.siteMedia.remove',
      ADD: 'items.siteMedia.add'
    }
  },
  /**
   * @summary List of possible item events
   * @enum
   * @memberof wixmp.events
   */
  ITEM: {
    GET: 'item.get',
    UPDATE: 'item.update',
    UPLOAD: 'item.upload',
    UPLOAD_RESUMABLE: 'item.uploadResumable',
    UPLOAD_BY_URL: 'item.uploadByUrl'
  },
  /**
   * @summary List of possible trash events
   * @enum
   * @memberof wixmp.events
   */
  TRASH: {
    REMOVE: 'trash.remove',
    RESTORE: 'trash.restore'
  }
};
sources_bigstock_BigStock = function (defaultSettings, initFolders, initItems, initHttp, utils, decorators, eventsList) {
  return function (userSettings) {
    var settings = utils.extend({}, defaultSettings, userSettings);
    var http = initHttp();
    var folders = initFolders(settings, http);
    var items = initItems(settings, http);
    this.name = 'bigstock';
    this.folders = decorators.addEvents(this, eventsList.FOLDERS, folders);
    this.items = decorators.addEvents(this, eventsList.ITEMS, items);
  };
}(sources_bigstock_settings, sources_bigstock_folders, sources_bigstock_items, utils_http, utils_utils, sources_decorators, events_list);
sources_shutterstock_settings = {
  apiUrl: '//pix.wix.com/services/shutterstock',
  itemsLimit: 50
};
sources_shutterstock_mappers_folder = function (data) {
  return {
    id: data.id,
    name: data.name,
    mediaType: 'picture',
    parentId: null,
    filesCount: null,
    createdAt: null
  };
};
sources_shutterstock_parsers_folders = function (toFolder) {
  return function (res) {
    res.data = (res.data || []).map(toFolder);
    return res;
  };
}(sources_shutterstock_mappers_folder);
sources_shutterstock_folders = function (mapFolderList, Promise) {
  return function () {
    var folders = mapFolderList({
      data: [
        {
          id: null,
          name: 'All'
        },
        {
          id: 0,
          name: 'Transportation'
        },
        {
          id: 1,
          name: 'Animals/Wildlife'
        },
        {
          id: 2,
          name: 'Buildings/Landmarks'
        },
        {
          id: 3,
          name: 'Backgrounds/Textures'
        },
        {
          id: 4,
          name: 'Business/Finance'
        },
        {
          id: 5,
          name: 'Education'
        },
        {
          id: 6,
          name: 'Food and Drink'
        },
        {
          id: 7,
          name: 'Healthcare/Medical'
        },
        {
          id: 8,
          name: 'Holidays'
        },
        {
          id: 9,
          name: 'Objects'
        },
        {
          id: 10,
          name: 'Industrial'
        },
        {
          id: 11,
          name: 'The Arts'
        },
        {
          id: 12,
          name: 'Nature'
        },
        {
          id: 13,
          name: 'People'
        },
        {
          id: 14,
          name: 'Religion'
        },
        {
          id: 15,
          name: 'Science'
        },
        {
          id: 16,
          name: 'Technology'
        },
        {
          id: 17,
          name: 'Signs/Symbols'
        },
        {
          id: 18,
          name: 'Sports/Recreation'
        },
        {
          id: 21,
          name: 'Interiors'
        },
        {
          id: 22,
          name: 'Miscellaneous'
        },
        // {id: 23, name: 'Illustrations/Clip-Art'},
        {
          id: 24,
          name: 'Vintage'
        },
        {
          id: 25,
          name: 'Parks/Outdoor'
        },
        {
          id: 26,
          name: 'Abstract'
        },
        {
          id: 27,
          name: 'Beauty/Fashion'
        },
        // {id: 28, name: 'Editorial'},
        // {id: 29, name: 'Vectors'},
        {
          id: 30,
          name: 'Model Released Only'
        },
        {
          id: 31,
          name: 'Celebrities'
        }
      ]
    });
    function list() {
      return Promise.resolve(folders);
    }
    return { list: list };
  };
}(sources_shutterstock_parsers_folders, bluebird_extended);
sources_shutterstock_mappers_item = function (utils) {
  return function (data) {
    var thumbnailUrl = utils.normalizeUri(data.mosaic_url);
    var previewUrl = utils.normalizeUri(utils.get(data, 'assets.preview.url'));
    return {
      id: data.id,
      name: data.description,
      folderId: null,
      mediaType: 'picture',
      fileUrl: null,
      thumbnailUrl: thumbnailUrl,
      previewUrl: previewUrl,
      createdAt: null,
      tags: [],
      width: null,
      height: null
    };
  };
}(utils_utils);
sources_shutterstock_parsers_items = function (toItem) {
  return function (res) {
    var data = res.data;
    var remainingItemsCount = data.total_count - data.page * data.per_page;
    var cursor = remainingItemsCount > 0 ? data.page + 1 : null;
    var size = data.per_page;
    res.data = (data.data || []).map(toItem);
    res.paging = {
      cursor: cursor,
      size: size
    };
    return res;
  };
}(sources_shutterstock_mappers_item);
sources_shutterstock_parsers_error = function (Promise) {
  return function (response) {
    response.data = response.data || {};
    var data = response.data;
    var code;
    if (Array.isArray(data)) {
      code = data[0].code || data[0];
    } else {
      code = data.code;
    }
    response.data.message = code;
    return Promise.reject(response);
  };
}(bluebird_extended);
sources_shutterstock_items = function (mapItemList, toError) {
  return function (settings, http) {
    function formatCategory(id) {
      if (id === null || typeof id === 'undefined') {
        return null;
      }
      return id;
    }
    function list(folderId, options) {
      options = options || {};
      options.paging = options.paging || {};
      options.sort = options.sort || {};
      var requestOptions = {
        per_page: options.paging.size || settings.itemsLimit,
        page: options.paging.cursor || null,
        order: options.sort.field || null,
        category: formatCategory(folderId),
        orientation: options.orientation || null
      };
      return http.get(settings.apiUrl + '/search', requestOptions, { headers: options.headers || {} }).then(mapItemList).catch(toError);
    }
    function search(folderId, query, options) {
      options = options || {};
      options.paging = options.paging || {};
      options.sort = options.sort || {};
      var requestOptions = {
        query: query || null,
        per_page: options.paging.size || settings.itemsLimit,
        page: options.paging.cursor || null,
        order: options.sort.field || null,
        category: formatCategory(folderId),
        orientation: options.orientation || null
      };
      return http.get(settings.apiUrl + '/search', requestOptions, { headers: options.headers || {} }).then(mapItemList).catch(toError);
    }
    return {
      list: list,
      search: search
    };
  };
}(sources_shutterstock_parsers_items, sources_shutterstock_parsers_error);
sources_shutterstock_ShutterStock = function (defaultSettings, initFolders, initItems, initHttp, utils, decorators, eventsList) {
  return function (userSettings) {
    var settings = utils.extend({}, defaultSettings, userSettings);
    var http = initHttp();
    var folders = initFolders(settings, http);
    var items = initItems(settings, http);
    this.name = 'shutterstock';
    this.folders = decorators.addEvents(this, eventsList.FOLDERS, folders);
    this.items = decorators.addEvents(this, eventsList.ITEMS, items);
  };
}(sources_shutterstock_settings, sources_shutterstock_folders, sources_shutterstock_items, utils_http, utils_utils, sources_decorators, events_list);
sources_public_mappers_folder = function (data, parentId) {
  return {
    id: data.guid,
    name: data.title,
    mediaType: data.mediaType,
    parentId: parentId || null,
    filesCount: null,
    createdAt: null
  };
};
sources_public_parsers_folders = function (toFolder) {
  return function (res) {
    res.data = (res.data.category.children || []).map(toFolder);
    return res;
  };
}(sources_public_mappers_folder);
sources_public_parsers_error = function (Promise) {
  return function (response) {
    response.data = response.data || {};
    response.data.message = response.message;
    return Promise.reject(response);
  };
}(bluebird_extended);
sources_public_folders = function (utils, mapFolderList, toError) {
  return function (settings, http) {
    function list(folderId, options) {
      options = options || {};
      var data = {
        levels: 1,
        language: options.language
      };
      if (settings.wixUser) {
        folderId += ':wix';
      }
      data.guid = folderId;
      return http.get(settings.apiUrl + '/categories', data, {
        withCredentials: true,
        headers: options.headers || {}
      }).then(mapFolderList).catch(toError);
    }
    return { list: list };
  };
}(utils_utils, sources_public_parsers_folders, sources_public_parsers_error);
services_thumbnail_generator_resize = function (utils) {
  function isResizable(url) {
    return /\.(png|jpe?g|gif)/i.test(url);
  }
  function getFullName(url) {
    var path = url.split('/');
    return path.pop() || '';
  }
  function getFolderUrl(url) {
    var path = url.split('/');
    if (path.length <= 1) {
      return '';
    }
    path.pop();
    return path.join('/') + '/';
  }
  var vangoghModes = {
    fill: 'srz',
    fit: 'srb'
  };
  function transformModeToVangogh(mode) {
    return vangoghModes[mode] || mode;
  }
  function createRegexp(t, options) {
    t = t.replace(/[()\[\]\.^$|?+]/g, '\\$&');
    return new RegExp(t, options);
  }
  function insertDataInTemplate(template, data) {
    Object.keys(data).forEach(function (key) {
      var regExp = createRegexp('#' + key + '#', 'g');
      template = template.replace(regExp, data[key]);
    });
    return template;
  }
  var compilers = {
    // //some.server.com/folder/123.jpg >>
    // //some.server.com/folder/123.jpg_srz_100_200_75_22_0.5_1.20_0.00_jpg_srz
    vangogh: function (sourceUrl) {
      return getFolderUrl(sourceUrl) + getFullName(sourceUrl) + '_#mode#_#width#_#height#_75_22_0.5_1.20_0.00_jpg_#mode#';
    },
    // //some.server.com/folder/123/file.jpg >>
    // //some.server.com/folder/123/v1/fill/w_100,h_200/file.jpg'
    // //some.server.com/folder/123/123.jpg >>
    // //some.server.com/folder/123/v1/fill/w_100,h_200/123.jpg'
    rembrandt: function (sourceUrl) {
      return getFolderUrl(sourceUrl) + 'v1/#mode#/w_#width#,h_#height#/' + getFullName(sourceUrl);
    },
    // //some.server.com/folder/123.jpg >>
    // //some.server.com/folder/123.jpg/v1/fill/w_100,h_200/123.jpg
    vanbrandt: function (sourceUrl) {
      return getFolderUrl(sourceUrl) + getFullName(sourceUrl) + '/v1/#mode#/w_#width#,h_#height#/' + getFullName(sourceUrl);
    }
  };
  var REGEXPS = {
    VANGOGH: /_sr[bz]_(?:[0-9\.]+_)+[a-z0-9]+_sr[bz]$/i,
    VANBRANDT: /([a-z0-9_\-]+\.[a-z0-9]+)\/v[0-9]+\/(?:fill|fit)\/[^\/]+\/\1$/i,
    REMBRANDT: /([a-z0-9_\-]+)\/v[0-9]+\/(?:fill|fit)\/[^\/]+(\/(?:\1|file)\.[a-z0-9_]+)$/i
  };
  function restoreUrlIfResized(sourceUrl) {
    return sourceUrl.replace(REGEXPS.VANGOGH, '').replace(REGEXPS.VANBRANDT, '$1').replace(REGEXPS.REMBRANDT, '$1$2');
  }
  /**
   * Resize image
   * @param sourceUrl {string}
   * @param settings {object}
   * @param settings.width {number} default 200
   * @param settings.height {number} default 200
   * @param settings.mode {string} from this.MODES, default 'fill'
   * @param apiName {string} from this.APIS, default 'rembrandt'
   * @return {string|undefined} URL for resized image or undefined if can`t resize
   */
  return function (sourceUrl, settings, apiName) {
    sourceUrl = restoreUrlIfResized(sourceUrl);
    if (!isResizable(sourceUrl)) {
      return undefined;
    }
    apiName = apiName || 'rembrandt';
    settings = utils.extend({
      width: 200,
      height: 200,
      mode: 'fill'
    }, settings);
    if (apiName === 'vangogh') {
      settings.mode = transformModeToVangogh(settings.mode);
    }
    var templateUrl = compilers[apiName](sourceUrl);
    var compiledUrl = insertDataInTemplate(templateUrl, settings);
    return utils.normalizeUri(compiledUrl);
  };
}(utils_utils);
services_thumbnail_generator_get_wix_thumbnails_urls = function (utils, resize) {
  function getUrlForResize(item, filesUrl) {
    if (item.thumbnailUrl) {
      return filesUrl + '/' + item.thumbnailUrl;
    }
    switch (item.mediaType) {
    case 'picture':
    case 'site_icon':
    case 'watermark':
    case 'secure_picture':
      return filesUrl + '/' + item.fileUrl;
    case 'video':
    case 'secure_video':
      if (item.fileOutput && item.fileOutput.image && item.fileOutput.image[2] && item.fileOutput.image[2].url) {
        return filesUrl + '/' + item.fileOutput.image[2].url;
      }
      break;
    case 'ufont':
      if (item.fileOutput && item.fileOutput.image && item.fileOutput.image[0] && item.fileOutput.image[0].url) {
        return filesUrl + '/' + item.fileOutput.image[0].url;
      }
      break;
    default:
      break;
    }
  }
  function getSameUrls(thumbnailSizes, url) {
    return Object.keys(thumbnailSizes).reduce(function (urls, sizeName) {
      urls[sizeName + 'Url'] = url;
      return urls;
    }, {});
  }
  function getResizedUrls(thumbnailSizes, urlForResize, imageOperationsApi) {
    return Object.keys(thumbnailSizes).reduce(function (urls, sizeName) {
      var url = resize(urlForResize, thumbnailSizes[sizeName], imageOperationsApi);
      if (url) {
        urls[sizeName + 'Url'] = url;
      }
      return urls;
    }, {});
  }
  return function (item, thumbnailSizes, settings) {
    var urlForResize = getUrlForResize(item, settings.filesUrl);
    var urls = {};
    if (item.mediaType === 'shape') {
      //item.thumbnailUrl = utils.normalizeUri(settings.filesUrl + '/' + item.fileUrl);
      //item.previewUrl = utils.normalizeUri(settings.filesUrl + '/' + item.fileUrl);
      urls = getSameUrls(thumbnailSizes, utils.normalizeUri(settings.filesUrl + '/' + item.fileUrl));
    } else if (urlForResize) {
      urls = getResizedUrls(thumbnailSizes, urlForResize, settings.imageOperationsApi);
    }
    if (item.fileUrl) {
      urls.originalUrl = utils.normalizeUri(settings.filesUrl + '/' + item.fileUrl);
    }
    return urls;
  };
}(utils_utils, services_thumbnail_generator_resize);
services_thumbnail_generator_get_wix_video_preview_urls = function (utils) {
  return function (item, settings) {
    if (!item.fileOutput || !item.fileOutput.video) {
      return null;
    }
    return item.fileOutput.video.filter(function (video) {
      return video.quality <= settings.videoPreviewQuality;
    }).map(function (video) {
      return utils.normalizeUri(settings.videoFilesUrl + '/' + video.url);
    });
  };
}(utils_utils);
sources_public_mappers_item = function (utils, getWixThumbnailsUrls, getWixVideoPreviewUrls) {
  return function (itemData, settings, thumbnailSizes) {
    var item = {
      id: itemData.guid,
      name: itemData.title,
      mediaType: itemData.mediaType,
      fileName: itemData.fileName,
      fileUrl: itemData.fileUrl,
      createdAt: null,
      tags: utils.splitTags(itemData.tags),
      tagsEn: utils.splitTags(itemData.tagsEn),
      width: itemData.width,
      height: itemData.height,
      fileOutput: itemData.fileOutput || null,
      fileInput: itemData.fileInput || null,
      vendor: itemData.vendor || null,
      reference: itemData.reference || null,
      creator: itemData.creator || null,
      externalId: itemData.externalId || null,
      subtype: itemData.subtype || null
    };
    if (itemData.thumbnailUrl && itemData.fileUrl) {
      var folderName = itemData.fileUrl.split('/')[0];
      item.thumbnailUrl = folderName + '/' + itemData.thumbnailUrl;
    }
    item.videoPreviewUrls = getWixVideoPreviewUrls(item, settings);
    var sizes = utils.extend({}, settings.thumbnailSizes, thumbnailSizes);
    utils.extend(item, getWixThumbnailsUrls(item, sizes, settings));
    return item;
  };
}(utils_utils, services_thumbnail_generator_get_wix_thumbnails_urls, services_thumbnail_generator_get_wix_video_preview_urls);
sources_public_parsers_items = function (utils, toItem) {
  return function (res, settings, thumbnailSizes) {
    res.data.nextPage = res.data.nextPage || '';
    var cursor = utils.getParameterByName(res.data.nextPage, 'pageNumber') || null;
    var size = utils.getParameterByName(res.data.nextPage, 'pageSize') || null;
    res.data = (res.data.items || []).map(function (itemData) {
      return toItem(itemData, settings, thumbnailSizes);
    });
    res.paging = {
      cursor: cursor,
      size: size
    };
    return res;
  };
}(utils_utils, sources_public_mappers_item);
sources_public_items = function (utils, mapItemList, toError) {
  return function (settings, http) {
    function requestItems(action, requestOptions, thumbSizeData, headers) {
      return http.get(settings.apiUrl + action, requestOptions, {
        withCredentials: true,
        headers: headers || {}
      }).then(function (response) {
        return mapItemList(response, settings, thumbSizeData);
      }).catch(toError);
    }
    /**
     * Gets list of items
     * @param folderId
     * @param options
     * @returns {Promise}
     * @fulfill {Items}
     * @reject {Error}
     */
    function list(folderId, options) {
      options = options || {};
      options.paging = options.paging || {};
      var requestOptions = {
        guid: folderId || null,
        language: options.language,
        pageSize: options.paging.size || settings.itemsLimit,
        pageNumber: options.paging.cursor || 1
      };
      return requestItems('/items', requestOptions, options.thumbnails, options.headers);
    }
    function search(folderId, query, options) {
      options = options || {};
      options.paging = options.paging || {};
      var mediaType = options.mediaType || 'picture';
      var requestOptions = {
        guid: folderId || null,
        language: options.language,
        searchString: query || '',
        pageSize: options.paging.size || settings.itemsLimit,
        pageNumber: options.paging.cursor || 1
      };
      var path = '/search';
      if (mediaType === 'picture' || mediaType === 'shape') {
        path = '/search2';
      }
      //return requestItems('/search2', requestOptions, options.thumbnails, options.headers);
      return requestItems(path, requestOptions, options.thumbnails, options.headers);
    }
    return {
      list: list,
      search: search
    };
  };
}(utils_utils, sources_public_parsers_items, sources_public_parsers_error);
sources_public_item = function (utils, mapItemList, toError) {
  return function (settings, http) {
    function getMulti(itemIds, options) {
      options = options || {};
      if (Array.isArray(itemIds)) {
        itemIds = itemIds.join(',');
      }
      var postData = {
        guid: itemIds,
        language: options.language
      };
      var headers = utils.extend(options.headers || {}, { 'Content-Type': 'application/x-www-form-urlencoded' });
      return http.post(settings.apiUrl + '/item', postData, {}, {
        withCredentials: true,
        headers: headers
      }).then(function (response) {
        return mapItemList(response, settings, options.thumbnails);
      }).catch(toError);
    }
    return { get: getMulti };
  };
}(utils_utils, sources_public_parsers_items, sources_public_parsers_error);
sources_public_settings = {
  apiUrl: '//publicmedia.wix.com/public',
  itemsLimit: 50,
  imageOperationsApi: 'vangogh',
  filesUrl: '//static.wixstatic.com',
  videoFilesUrl: '//video.wixstatic.com',
  thumbnailSizes: {
    thumbnail: {
      width: 210,
      height: 210,
      mode: 'fill'
    },
    preview: {
      width: 375,
      height: 375,
      mode: 'fit'
    }
  },
  videoPreviewQuality: '480p',
  wixUser: false
};
sources_public_Public = function (initFolders, initItems, initItem, initHttp, defaultSettings, utils, decorators, eventsList) {
  return function (userSettings) {
    var settings = utils.extend({}, defaultSettings, userSettings);
    var http = initHttp();
    var folders = initFolders(settings, http);
    var items = initItems(settings, http);
    var item = initItem(settings, http);
    this.name = 'public';
    this.folders = decorators.addEvents(this, eventsList.FOLDERS, folders);
    this.items = decorators.addEvents(this, eventsList.ITEMS, items);
    this.item = decorators.addEvents(this, eventsList.ITEM, item);
  };
}(sources_public_folders, sources_public_items, sources_public_item, utils_http, sources_public_settings, utils_utils, sources_decorators, events_list);
sources_private_mappers_folder = function (folderData) {
  /**
   * Folder
   * {String} id
   * {String} parentId
   * {String} name
   * {String} mediaType
   * {Number} filesCount
   * {Number} createdAt
   */
  return {
    id: folderData.folder_id,
    parentId: folderData.parent_folder_id || null,
    name: folderData.folder_name,
    mediaType: folderData.media_type,
    filesCount: folderData.files_count,
    createdAt: folderData.created_ts
  };
};
sources_private_parsers_error = function (Promise) {
  return function (reason) {
    if (reason && reason.status === 403 && reason.data && reason.data.error_description === 'Missing Wix session') {
      reason.status = 401;
      reason.data.message = 'Wix Session required';
    }
    return Promise.reject(reason);
  };
}(bluebird_extended);
sources_private_folders = function (toFolder, toError) {
  return function (settings, http) {
    function mapFolderList(res) {
      res.data = (res.data.folders || []).map(toFolder);
      return res;
    }
    /**
     * @summary Return the list of folders
     * @memberof source.folders
     * @param {String} folderId
     * @param {ListSettings} options
     * @returns {Promise}
     * @fulfill {List[]} List with Folders
     * @reject {Error}
     */
    function list(folderId, options) {
      options = options || {};
      return http.get(settings.apiUrl + '/folders', {
        media_type: options.mediaType || 'picture',
        folder_id: folderId || null
      }, { headers: options.headers || {} }).then(mapFolderList).catch(toError);
    }
    function removeFolder(folderId, options) {
      var url = settings.apiUrl + '/folders/' + folderId + '/delete';
      var postOptions = { headers: options.headers || {} };
      return http.post(url, null, null, postOptions).then(function (res) {
        res.data = { id: folderId };
        return res;
      }).catch(toError);
    }
    /**
     * @summary Removes the list of folders with given ids
     * @memberof source.folders
     * @param {string[]} folderIds Array of folder ids
     * @param {Object} options
     * @returns {Promise[]}
     */
    function remove(folderIds, options) {
      options = options || {};
      return folderIds.map(function (folderId) {
        return removeFolder(folderId, options);
      });
    }
    return {
      list: list,
      remove: remove
    };
  };
}(sources_private_mappers_folder, sources_private_parsers_error);
sources_private_validators_new_props = function (newProps) {
  if (typeof newProps !== 'object' || newProps === null) {
    return {
      valid: false,
      message: 'Please specify new props'
    };
  }
  if (typeof newProps.name !== 'undefined' && !newProps.name) {
    return {
      valid: false,
      message: 'Please specify name'
    };
  }
  if (typeof newProps.folderId !== 'undefined' && !newProps.folderId) {
    return {
      valid: false,
      message: 'Please specify folder id'
    };
  }
  if (typeof newProps.parentId !== 'undefined' && !newProps.parentId) {
    return {
      valid: false,
      message: 'Please specify parent folder id'
    };
  }
  if (typeof newProps.tags !== 'undefined' && !Array.isArray(newProps.tags)) {
    return {
      valid: false,
      message: 'Tags should be an array'
    };
  }
  return { valid: true };
};
sources_private_folder = function (mappers, utils, toFolder, toError, validateNewProps) {
  return function (settings, http) {
    function mapFolder(res) {
      res.data = toFolder(res.data);
      return res;
    }
    /**
     * @summary Create a new folder with given name and parameters
     * @memberof source.folder
     * @param {string} folderName
     * @param {object} options
     * @param {string} options.mediaType
     * @param {string} options.parentId
     * @returns {Promise}
     * @fulfill {Folder} New folder object
     * @reject {Error}
     */
    function create(folderName, options) {
      if (!folderName) {
        return toError(mappers.toError({
          status: -200,
          statusText: 'Internal JS Error',
          data: { message: 'Please specify name' }
        }));
      }
      options = options || {};
      var url = settings.apiUrl + '/folders';
      var data = {
        folder_name: folderName,
        media_type: options.mediaType || 'picture',
        parent_folder_id: options.parentId || null
      };
      var postOptions = { headers: options.headers || {} };
      return http.post(url, data, null, postOptions).then(mapFolder).catch(toError);
    }
    /**
     * @summary Updates the folder with given diff object
     * @memberof source.folder
     * @param {Folder} folder Current folder object that should be updated
     * @param {object} newFolderProps
     * @param {object} options
     * @returns {Promise}
     * @fulfill {Folder} Modified folder object
     * @reject {Error}
     */
    function update(folder, newFolderProps, options) {
      var arePropsValid = validateNewProps(newFolderProps);
      if (arePropsValid.valid === false) {
        return toError(mappers.toError({
          status: -200,
          statusText: 'Internal JS Error',
          data: { message: arePropsValid.message }
        }));
      }
      var data = {};
      if (newFolderProps.name) {
        data.folder_name = newFolderProps.name;
      }
      if (newFolderProps.parentId) {
        data.parent_folder_id = newFolderProps.parentId;
      }
      options = options || {};
      var url = settings.apiUrl + '/folders/' + folder.id + '/put';
      var postOptions = { headers: options.headers || {} };
      return http.post(url, data, null, postOptions).then(function (res) {
        res.data = utils.extend({}, folder, newFolderProps);
        return res;
      }).catch(toError);
    }
    return {
      create: create,
      update: update
    };
  };
}(utils_mappers, utils_utils, sources_private_mappers_folder, sources_private_parsers_error, sources_private_validators_new_props);
sources_private_mappers_item = function (mappers, utils, getWixThumbnailsUrls, getWixVideoPreviewUrls) {
  return function (itemData, settings, thumbnailSizes) {
    var normalizeUri = utils.normalizeUri;
    var item = {
      id: itemData.file_name,
      folderId: itemData.parent_folder_id || null,
      fileSize: itemData.file_size,
      name: itemData.original_file_name,
      mediaType: itemData.media_type,
      fileUrl: itemData.file_url ? normalizeUri(itemData.file_url) : null,
      createdAt: itemData.created_ts,
      readOnly: itemData.read_only || null,
      labels: itemData.labels || [],
      tags: utils.splitTags(itemData.tags),
      width: itemData.width || null,
      height: itemData.height || null,
      fileInfo: itemData.file_info ? mappers.toObject(itemData.file_info) : null,
      fileInput: itemData.file_input ? mappers.toObject(itemData.file_input) : null,
      fileOutput: itemData.file_output ? mappers.toObject(itemData.file_output) : null,
      transcodingStatus: itemData.op_status
    };
    var sizes = utils.extend({}, settings.thumbnailSizes, thumbnailSizes);
    utils.extend(item, getWixThumbnailsUrls(item, sizes, settings));
    if (sizes.thumbnail && !item.thumbnailUrl && itemData.icon_url) {
      item.thumbnailUrl = normalizeUri(settings.filesUrl + '/' + itemData.icon_url);
    }
    Object.keys(sizes).forEach(function (thumbType) {
      if (!item[thumbType + 'Url']) {
        item[thumbType + 'Url'] = item.thumbnailUrl;
      }
    });
    Object.keys(item).forEach(function (prop) {
      if (item[prop] === undefined) {
        delete item[prop];
      }
    });
    item.videoPreviewUrls = getWixVideoPreviewUrls(item, settings) || null;
    return item;
  };
}(utils_mappers, utils_utils, services_thumbnail_generator_get_wix_thumbnails_urls, services_thumbnail_generator_get_wix_video_preview_urls);
sources_private_items = function (Promise, utils, toItem, toError) {
  return function (settings, http) {
    function mapItemList(res, thumbnailSizes) {
      res.data = (res.data.files || []).map(function (data) {
        return toItem(data, settings, thumbnailSizes);
      });
      return res;
    }
    var defaultPaging = {
      size: 50,
      cursor: null
    };
    var defaultSort = {
      order: 'date',
      direction: 'desc'
    };
    var previousCursor = null;
    /**
     * @summary Returns the list of items from the given folder
     * @memberof source.items
     * @param {string} folderId
     * @param {ListSettings} options
     * @returns {Promise}
     * @fulfill {List}
     * @reject {Error}
     */
    function list(folderId, options) {
      options = options || {};
      var sort = utils.extend({}, defaultSort, options.sort);
      var paging = utils.extend({}, defaultPaging, options.paging);
      var queryParams = {
        page_size: paging.size,
        cursor: paging.cursor,
        parent_folder_id: folderId,
        media_type: options.mediaType || 'picture'
      };
      queryParams.order = sort.direction === 'desc' ? '-' + sort.order : sort.order;
      return http.get(settings.apiUrl + '/files/getpage', queryParams, { headers: options.headers || {} }).then(function (response) {
        response.paging = {
          size: paging.size,
          cursor: previousCursor === response.data.cursor ? null : response.data.cursor
        };
        previousCursor = response.data.cursor;
        return mapItemList(response, options.thumbnails);
      }).catch(toError);
    }
    function removeItem(itemId, options) {
      var queryParams = {};
      if (settings.ns) {
        queryParams.ns = settings.ns;
      }
      var url = settings.apiUrl + '/files/' + itemId + '/delete';
      var postOptions = { headers: options.headers || {} };
      return http.post(url, null, queryParams, postOptions).then(function (res) {
        res.data = { id: itemId };
        return res;
      }).catch(toError);
    }
    /**
     * @summary Removes the items with given ids
     * @memberof source.items
     * @param {Array} itemIds
     * @returns {Array}
     */
    function remove(itemIds, options) {
      options = options || {};
      return itemIds.map(function (itemId) {
        return removeItem(itemId, options);
      });
    }
    /**
     * @summary Return list of items found by tag
     * @memberof source.items
     * @param {string} tag
     * @param {ListSettings} options
     * @returns {Promise}
     * @fulfill {List}
     * @reject {Error}
     */
    function searchByTag(tag, options) {
      options = options || {};
      var sort = utils.extend({}, defaultSort, options.sort);
      var paging = utils.extend({}, defaultPaging, options.paging);
      var queryParams = {
        page_size: paging.size,
        cursor: paging.cursor,
        media_type: options.mediaType || 'picture',
        order: sort.direction === 'desc' ? '-' + sort.order : sort.order
      };
      return http.get(settings.apiUrl + '/files/get?tag=' + tag, queryParams, {
        cache: false,
        headers: options.headers || {}
      }).then(function (response) {
        response.paging = {
          size: paging.size,
          cursor: response.data.cursor
        };
        return mapItemList(response, options.thumbnails);
      }).catch(toError);
    }
    /**
     * @summary Return list of items found by text query
     * @memberof source.items
     * @param {string} folderId
     * @param {string} query
     * @param {ListSettings} options
     * @returns {Promise}
     * @fulfill {List}
     * @reject {Error}
     */
    function search(folderId, query, options) {
      options = options || {};
      var sort = utils.extend({}, defaultSort, options.sort);
      var paging = utils.extend({}, defaultPaging, options.paging);
      query = encodeURIComponent(query);
      var queryParams = {
        page_size: paging.size,
        cursor: paging.cursor,
        media_type: options.mediaType || 'picture',
        parent_folder_id: folderId,
        order: sort.direction === 'desc' ? '-' + sort.order : sort.order
      };
      return http.get(settings.apiUrl + '/files/search/getpage?query=' + query, queryParams, {
        cache: false,
        headers: options.headers || {}
      }).then(function (response) {
        response.paging = {
          size: paging.size,
          cursor: response.data.cursor
        };
        return mapItemList(response, options.thumbnails);
      }).catch(toError);
    }
    return {
      list: list,
      remove: remove,
      searchByTag: searchByTag,
      search: search
    };
  };
}(bluebird_extended, utils_utils, sources_private_mappers_item, sources_private_parsers_error);
constants_transcoding_statuses = {
  FAILED: 'FAILED',
  IN_QUEUE: 'IN-QUEUE',
  INPROGRESS: 'INPROGRESS',
  PREVIEW_READY: 'PREVIEW_READY',
  READY: 'READY'
};
sources_private_item = function (Promise, utils, toItem, toError, validateNewProps, mappers, TRANSCODING_STATUSES) {
  var POLLING_TIMEOUT = 15 * 1000;
  var TIMEOUT_BEFORE_REJECT = 10 * 60 * 1000;
  var MIN_FONT_SIZE = 4096;
  return function (settings, http, socket, pollItem, resumableUpload) {
    var isPromiseResolved;
    var rejectTimeoutId;
    var funcToUnsubscribe;
    function getFilesSizeLimit(mediaType) {
      return settings.uploadLimits[utils.snakeToCamel(mediaType)];
    }
    function fileSizeIsInvalid(fileSource) {
      return fileSource.file.size >= getFilesSizeLimit(fileSource.mediaType);
    }
    function mapItem(res, thumbnailsSizes) {
      res.data = toItem(res.data, settings, thumbnailsSizes);
      return res;
    }
    function cleanUp() {
      isPromiseResolved = true;
      clearTimeout(rejectTimeoutId);
      socket.off('message', funcToUnsubscribe);
    }
    function resolveItemIdFromSocketMessage(itemIdFromResponse, resolve) {
      return function (message) {
        var itemId = utils.get(message, 'file.file_name');
        if (message.type === 'status_update' && utils.get(message, 'file.op_status') === TRANSCODING_STATUSES.READY && itemId === itemIdFromResponse) {
          resolve(itemId);
        }
      };
    }
    function checkItemStatus(itemId, resolve) {
      setTimeout(function () {
        if (isPromiseResolved) {
          return;
        }
        get(itemId).then(function (response) {
          if (utils.get(response, 'data.transcodingStatus') !== TRANSCODING_STATUSES.READY) {
            return Promise.reject();
          }
          resolve(itemId);
        }).catch(function () {
          checkItemStatus(itemId, resolve);
        });
      }, POLLING_TIMEOUT);
    }
    function resolveItemIdFromResponse(itemId) {
      return new Promise(function (resolve, reject) {
        if (!itemId) {
          reject();
          return;
        }
        checkItemStatus(itemId, resolve);
      });
    }
    function waitForItemFromStorage(response) {
      isPromiseResolved = false;
      var itemId = utils.get(response, 'data.payload.file_name') || utils.get(response, 'data.file_name');
      var resolveItemIdFromSocket = new Promise(function (resolve) {
        funcToUnsubscribe = resolveItemIdFromSocketMessage(itemId, resolve);
        socket.on('message', funcToUnsubscribe);
      });
      var rejectNotReadyItem = new Promise(function (resolve, reject) {
        rejectTimeoutId = setTimeout(function () {
          reject({
            status: 406,
            data: { message: 'Not ready item' }
          });
        }, TIMEOUT_BEFORE_REJECT);
      });
      return Promise.race([
        resolveItemIdFromSocket,
        resolveItemIdFromResponse(itemId),
        rejectNotReadyItem
      ]).then(function (itemId) {
        cleanUp();
        return Promise.resolve(itemId);
      }).catch(function (error) {
        cleanUp();
        return Promise.reject(error);
      });
    }
    function getUploadUrl(fileSource) {
      function getEndpoint(mediaType) {
        if (mediaType === 'secure_music') {
          return 'music-goods/upload';
        } else if (mediaType === 'video') {
          return 'video/upload';
        }
        return 'upload';
      }
      var file = fileSource.file;
      var url = settings.apiUrl + '/files/' + getEndpoint(fileSource.mediaType) + '/url';
      var data = {
        media_type: fileSource.mediaType,
        // we just need an extension here
        file_name: file.name.toLowerCase(),
        // file_name: '_.' + file.name.split('.').pop().toLowerCase(),
        file_size: file.size,
        content_type: file.type
      };
      var postOptions = {
        withCredentials: true,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      };
      return http.post(url, data, null, postOptions);
    }
    function uploadByUrl(fileSource, options, skipWaitingItemFromStorage) {
      options = options || {};
      var data = {
        url: utils.normalizeUri(fileSource.url),
        media_type: fileSource.mediaType,
        name: fileSource.name || 'Untitled',
        tags: fileSource.tags ? fileSource.tags.join(',') : null,
        parent_folder_id: fileSource.folderId || null
      };
      // some sources as Google Drive requires auth headers to allow downloading files via url
      if (fileSource.headers) {
        data.headers = JSON.stringify(fileSource.headers);
      }
      if (fileSource.catalogCallbackUrl) {
        data.cat_callback_url = fileSource.catalogCallbackUrl;
      }
      if (settings.siteMediaToken) {
        data.siteMediaToken = settings.siteMediaToken;
      }
      var apiUrl = settings.apiUrl + '/files/upload/external';
      if (settings.asyncUploadByUrl || skipWaitingItemFromStorage) {
        socket.open();
        var apiUrlAsync = apiUrl + '/async';
        var headers = utils.extend({}, options.headers, { 'Content-Type': 'application/x-www-form-urlencoded' });
        var postOptions = { headers: headers };
        return http.post(apiUrlAsync, data, null, postOptions).then(function (response) {
          if (skipWaitingItemFromStorage) {
            pollItem(response.data.payload.file_name);
            response.data = toItem(response.data.payload, settings);
            return response;
          }
          return waitForItemFromStorage(response).then(get);
        }).catch(toError);
      }
      var uploadPromise = http.get(apiUrl, data, { headers: options.headers || {} }).progress(function (progress) {
        uploadPromise.notify(progress);
      }).then(function (res) {
        return mapItem(res, options.thumbnails);
      });
      return uploadPromise;
    }
    function upload(fileSource, options) {
      options = options || {};
      var data = {
        parent_folder_id: fileSource.folderId || null,
        file: fileSource.file,
        media_type: fileSource.mediaType
      };
      if (fileSource.catalogCallbackUrl) {
        data.cat_callback_url = fileSource.catalogCallbackUrl;
      }
      if (fileSource.encodingOptions) {
        data.encoding_options = JSON.stringify(fileSource.encodingOptions);
      }
      if (settings.vision) {
        data.vision = settings.vision.join(',');
      }
      if (settings.siteMediaToken) {
        data.siteMediaToken = settings.siteMediaToken;
      }
      if (fileSizeIsInvalid(fileSource)) {
        var limit = utils.bytesToSize(getFilesSizeLimit(fileSource.mediaType));
        var fileSize = utils.bytesToSize(fileSource.file.size);
        return Promise.reject(mappers.toError({
          status: -406,
          statusText: 'Not Acceptable',
          data: {
            error_code: -7752,
            error_description: 'File size ' + fileSize + ' exceeds upload limit of ' + limit,
            error_info: {
              key: 'wmp_error.file_size_exceeded_limit',
              args: [
                fileSize,
                limit
              ]
            }
          }
        }));
      }
      var isAsyncFontUploadAllowed = settings.asyncFontUpload;
      var isUploadFont = data.media_type === 'ufont';
      var isBigFile = utils.get(data, 'file.size') > MIN_FONT_SIZE;
      var isAsyncFontUpload = isAsyncFontUploadAllowed && isUploadFont && isBigFile;
      var uploadPromiseChain = getUploadUrl(fileSource).then(function (response) {
        var responseData = response.data;
        data.upload_token = responseData.upload_token;
        if (isAsyncFontUpload) {
          socket.open();
          data.upload_async = true;
        }
        return http.upload(responseData.upload_url, data, { headers: options.headers || {} }).progress(function (progress) {
          uploadPromiseChain.notify(progress);
        });
      }).then(function (response) {
        response.data = response.data[0];
        if (isAsyncFontUpload) {
          return waitForItemFromStorage(response).then(get);
        }
        var status = utils.get(response, 'data.op_status');
        if (settings.asyncTranscoding && status && status !== TRANSCODING_STATUSES.READY) {
          socket.open();
          pollItem(response.data.file_name);
        }
        response.data = toItem(response.data, settings);
        return response;
      }).catch(toError);
      return uploadPromiseChain;
    }
    function uploadResumable(fileSource, options) {
      if (fileSizeIsInvalid(fileSource)) {
        var limit = utils.bytesToSize(getFilesSizeLimit(fileSource.mediaType));
        var fileSize = utils.bytesToSize(fileSource.file.size);
        return Promise.reject(mappers.toError({
          status: -406,
          statusText: 'Not Acceptable',
          data: {
            error_code: -7752,
            error_description: 'File size ' + fileSize + ' exceeds upload limit of ' + limit,
            error_info: {
              key: 'wmp_error.file_size_exceeded_limit',
              args: [
                fileSize,
                limit
              ]
            }
          }
        }));
      }
      var data = {
        parent_folder_id: fileSource.folderId || null,
        file: fileSource.file,
        media_type: fileSource.mediaType || 'picture'
      };
      return resumableUpload(data, options);
    }
    /**
     * @summary Returns item
     * @memberof source.item
     * @param {String} itemId
     * @param {Object} [options]
     * @returns {Promise}
     * @fulfill {Item}
     * @reject {Error}
     */
    function get(itemId, options) {
      options = options || {};
      return http.get(settings.apiUrl + '/files/' + itemId, null, {
        cache: false,
        headers: options.headers || {}
      }).then(function (res) {
        return mapItem(res, options.thumbnails);
      }).catch(toError);
    }
    /**
     * @summary Updates the item with given diff object
     * @memberof source.item
     * @param {Item} item Current item object that should be updated
     * @param {object} newItemProps
     * @param {Object} options
     * @returns {Promise}
     * @fulfill {Item} Modified item object
     * @reject {Error}
     */
    function update(item, newItemProps, options) {
      var arePropsValid = validateNewProps(newItemProps);
      if (arePropsValid.valid === false) {
        return toError(mappers.toError({
          status: -200,
          statusText: 'Internal JS Error',
          data: { message: arePropsValid.message }
        }));
      }
      var data = {};
      if (newItemProps.name) {
        data.original_file_name = newItemProps.name;
      }
      if (newItemProps.folderId) {
        data.parent_folder_id = newItemProps.folderId;
      }
      if (newItemProps.tags) {
        data.tags = newItemProps.tags.join(',');
      }
      options = options || {};
      var url = settings.apiUrl + '/files/' + item.id + '/put';
      var postOptions = { headers: options.headers || {} };
      return http.post(url, data, null, postOptions).then(function (res) {
        res.data = utils.extend({}, item, newItemProps);
        return res;
      }).catch(toError);
    }
    return {
      upload: upload,
      uploadResumable: uploadResumable,
      uploadByUrl: uploadByUrl,
      get: get,
      update: update
    };
  };
}(bluebird_extended, utils_utils, sources_private_mappers_item, sources_private_parsers_error, sources_private_validators_new_props, utils_mappers, constants_transcoding_statuses);
sources_private_trash = function (toError) {
  return function (settings, http) {
    /**
     * @summary Remove all items in trash
     * @memberof source.trash
     * @param options
     * @returns {Promise}
     * @reject {Error}
     */
    function remove(options) {
      var url = settings.apiUrl + '/trash/delete';
      var data = {
        media_type: options.mediaType || 'picture',
        all_files: true
      };
      return http.post(url, data).catch(toError);
    }
    /**
     * @summary Restore all items in trash
     * @memberof source.trash
     * @param options
     * @returns {Promise}
     * @reject {Error}
     */
    function restore(options) {
      var url = settings.apiUrl + '/trash/restore';
      var data = {
        media_type: options.mediaType || 'picture',
        all_files: true
      };
      return http.post(url, data).catch(toError);
    }
    return {
      remove: remove,
      restore: restore
    };
  };
}(sources_private_parsers_error);
sources_private_itemstrash = function (Promise, utils, toItem, toError) {
  return function (settings, http) {
    function mapItemList(res, thumbnailSizes) {
      res.data = (res.data.trash_files || []).map(function (_item) {
        var item = toItem(_item, settings, thumbnailSizes);
        item.isInTrash = true;
        return item;
      });
      return res;
    }
    var defaultPaging = {
      size: 50,
      cursor: null
    };
    var defaultSort = {
      order: 'date',
      direction: 'desc'
    };
    function list(folderId, options) {
      options = options || {};
      var sort = utils.extend({}, defaultSort, options.sort);
      var paging = utils.extend({}, defaultPaging, options.paging);
      var queryParams = {
        page_size: paging.size,
        cursor: paging.cursor,
        parent_folder_id: folderId,
        media_type: options.mediaType || 'picture'
      };
      queryParams.order = sort.direction === 'desc' ? '-' + sort.order : sort.order;
      return http.get(settings.apiUrl + '/files/getpage/trash', queryParams, { headers: options.headers || {} }).then(function (response) {
        response.paging = {
          size: paging.size,
          cursor: response.data.cursor
        };
        return mapItemList(response, options.thumbnails);
      }).catch(toError);
    }
    function removeItem(itemId, options) {
      var url = settings.apiUrl + '/trash/files/' + itemId + '/delete';
      var postOptions = { headers: options.headers || {} };
      return http.post(url, null, null, postOptions).then(function (res) {
        res.data = { id: itemId };
        return res;
      }).catch(toError);
    }
    function remove(itemIds, options) {
      options = options || {};
      return itemIds.map(function (itemId) {
        return removeItem(itemId, options);
      });
    }
    function restoreItem(itemId, options) {
      var url = settings.apiUrl + '/trash/files/' + itemId + '/restore';
      var postOptions = { headers: options.headers || {} };
      return http.post(url, null, null, postOptions).then(function (res) {
        res.data = { id: itemId };
        return res;
      }).catch(toError);
    }
    /**
     * Restore items from trash
     * @param itemIds
     * @param options
     * @returns [Promise] Array of Promise
     */
    function restore(itemIds, options) {
      options = options || {};
      return itemIds.map(function (itemId) {
        return restoreItem(itemId, options);
      });
    }
    return {
      list: list,
      remove: remove,
      restore: restore
    };
  };
}(bluebird_extended, utils_utils, sources_private_mappers_item, sources_private_parsers_error);
sources_private_itemssite_media = function (Promise, utils, toItem, toError) {
  return function (settings, http) {
    function mapItemList(res, thumbnailSizes) {
      res.data = (res.data.files || []).map(function (_item) {
        var item = toItem(_item, settings, thumbnailSizes);
        item.isInSiteMedia = true;
        return item;
      });
      return res;
    }
    var defaultPaging = {
      size: 50,
      cursor: null
    };
    var defaultSort = {
      order: 'date',
      direction: 'desc'
    };
    function list(folderId, options) {
      options = options || {};
      var sort = utils.extend({}, defaultSort, options.sort);
      var paging = utils.extend({}, defaultPaging, options.paging);
      var queryParams = {
        page_size: paging.size,
        cursor: paging.cursor,
        parent_folder_id: folderId,
        media_type: options.mediaType || 'picture',
        siteMediaToken: settings.siteMediaToken
      };
      queryParams.order = sort.direction === 'desc' ? '-' + sort.order : sort.order;
      return http.get(settings.apiUrl + '/files/getpage/site', queryParams, { headers: options.headers || {} }).then(function (response) {
        response.paging = {
          size: paging.size,
          cursor: response.data.cursor
        };
        return mapItemList(response, options.thumbnails);
      }).catch(toError);
    }
    function removeItem(itemId, options) {
      var data = { files: [itemId] };
      var url = settings.apiUrl + '/files/site/remove?siteMediaToken=' + settings.siteMediaToken;
      var postOptions = { headers: options.headers || {} };
      return http.post(url, data, null, postOptions).then(function (res) {
        res.data = { id: itemId };
        return res;
      }).catch(toError);
    }
    /**
     * Remove items from siteMedia
     * @param itemIds Array of item ids
     * @param options
     * @returns [Promise] Array of Promise
     */
    function remove(itemIds, options) {
      options = options || {};
      return itemIds.map(function (itemId) {
        return removeItem(itemId, options);
      });
    }
    /**
     * Add items to siteMedia
     * @param itemIds Array of item ids
     * @param options
     * @returns Promise
     */
    function add(itemIds, options) {
      options = options || {};
      var data = { files: itemIds };
      var url = settings.apiUrl + '/files/site/add?siteMediaToken=' + settings.siteMediaToken;
      var postOptions = { headers: options.headers || {} };
      return http.post(url, data, null, postOptions).catch(toError);
    }
    return {
      list: list,
      remove: remove,
      add: add
    };
  };
}(bluebird_extended, utils_utils, sources_private_mappers_item, sources_private_parsers_error);
sources_private_folderstrash = function (Promise, utils, toFolder, toError) {
  return function (settings, http) {
    function mapFolderList(res) {
      res.data = (res.data.trash_folders || []).map(function (_folder) {
        var folder = toFolder(_folder);
        folder.isInTrash = true;
        return folder;
      });
      return res;
    }
    function list(folderId, options) {
      options = options || {};
      var queryParams = {
        media_type: options.mediaType || 'picture',
        folder_id: folderId || null,
        trash_type: 'folder'
      };
      return http.get(settings.apiUrl + '/files/getpage/trash', queryParams, { headers: options.headers || {} }).then(mapFolderList).catch(toError);
    }
    function removeFolder(folderId, options) {
      var url = settings.apiUrl + '/trash/folders/' + folderId + '/delete';
      var postOptions = { headers: options.headers || {} };
      return http.post(url, null, null, postOptions).then(function (res) {
        res.data = { id: folderId };
        return res;
      }).catch(toError);
    }
    function remove(folderIds, options) {
      options = options || {};
      return folderIds.map(function (folderId) {
        return removeFolder(folderId, options);
      });
    }
    function restoreFolder(folderId, options) {
      var url = settings.apiUrl + '/trash/folders/' + folderId + '/restore';
      var postOptions = { headers: options.headers || {} };
      return http.post(url, null, null, postOptions).then(function (res) {
        res.data = { id: folderId };
        return res;
      }).catch(toError);
    }
    function restore(folderIds, options) {
      options = options || {};
      return folderIds.map(function (folderId) {
        return restoreFolder(folderId, options);
      });
    }
    return {
      list: list,
      remove: remove,
      restore: restore
    };
  };
}(bluebird_extended, utils_utils, sources_private_mappers_folder, sources_private_parsers_error);
sources_private_settings = {
  apiUrl: '//files.wix.com',
  imageOperationsApi: 'vangogh',
  filesUrl: '//static.wixstatic.com',
  videoFilesUrl: '//video.wixstatic.com',
  refreshTokenUrl: null,
  requestOptions: { withCredentials: true },
  uploadLimits: {
    default: 15728640,
    document: 15728640,
    picture: 15728640,
    music: 52428800,
    secureMusic: 377487360,
    video: 524288000,
    secureVideo: 1610612736
  },
  thumbnailSizes: {
    thumbnail: {
      width: 210,
      height: 210,
      mode: 'fill'
    },
    preview: {
      width: 375,
      height: 375,
      mode: 'fit'
    },
    original: {
      width: 1000,
      height: 1000,
      mode: 'fit'
    }
  },
  channel: {
    withCredentials: true,
    jsapiUrl: '/_ah/channel/jsapi',
    tokenUrl: '/users/channel'
  },
  blackArrow: {
    enabled: false,
    wsUrl: 'wss://ws.wixmp.com/ws',
    messageUrl: 'https://ws.wixmp.com/message',
    tokenUrl: '/users/get-batoken'
  },
  asyncFontUpload: false,
  asyncUploadByUrl: false,
  asyncTranscoding: false,
  videoPreviewQuality: '480p'
};
services_channel_channel = function (Promise, initHttp, utils, notifier, eventsList, TRANSCODING_STATUSES) {
  var REFRESH_INTERVAL = 25 * 60 * 1000;
  var REOPEN_CHANNEL_TIMEOUT = 20 * 1000;
  return function (settings, adapter, itemMapper) {
    var http = initHttp();
    var socket = null;
    var jsApiAlreadyLoaded = false;
    var autoRefreshInterval = null;
    function emitItemUpdateEvent(result) {
      var event = notifier.emit(adapter, eventsList.ITEM.UPDATE, {
        arguments: [
          result.data,
          result.data
        ]
      });
      event.resolve(result);
    }
    function onMessage(message) {
      if (message.data === 'server connected') {
        return;
      }
      try {
        message = JSON.parse(message.data);
      } catch (reason) {
        return;
      }
      if (message.type === 'status_update') {
        if (utils.get(message, 'file.op_status') === TRANSCODING_STATUSES.READY) {
          adapter.item.get(utils.get(message, 'file.file_name')).then(emitItemUpdateEvent);
        } else {
          var result = itemMapper(message.file, settings, {}, true);
          emitItemUpdateEvent({ data: result });
        }
      }
    }
    function reopenSocket() {
      if (socket) {
        close();
        openSocket();
      }
    }
    function loadJSLib() {
      if (jsApiAlreadyLoaded) {
        return Promise.resolve();
      }
      var url = utils.get(settings, 'channel.jsapiUrl');
      if (url.indexOf('http') === -1) {
        url = settings.apiUrl + url;
      }
      return utils.getScript(url).then(function () {
        jsApiAlreadyLoaded = true;
      });
    }
    function openSocket() {
      var url = settings.apiUrl + utils.get(settings, 'channel.tokenUrl');
      var withCredentials = utils.get(settings, 'channel.withCredentials');
      var promise = http.get(url, null, { withCredentials: withCredentials });
      return promise.then(function (tokenData) {
        var channel = new goog.appengine.Channel(tokenData.data.token);
        socket = channel.open();
        socket.onmessage = onMessage;
        socket.onclose = reopenSocket;
        socket.onerror = reopenSocket;
        autoRefreshInterval = setInterval(reopenSocket, REFRESH_INTERVAL);
        return socket;
      }).catch(function (reason) {
        return Promise.reject(reason);
      });
    }
    // Retry if user internet connection is overloaded and channel can not be opened
    function reopenChannel() {
      return new Promise(function (resolve) {
        setTimeout(function () {
          resolve(open());
        }, REOPEN_CHANNEL_TIMEOUT);
      });
    }
    function open() {
      if (socket) {
        return Promise.resolve();
      }
      return loadJSLib().then(openSocket).catch(reopenChannel);
    }
    function close() {
      if (socket) {
        socket.close();
        socket = null;
        if (autoRefreshInterval) {
          clearInterval(autoRefreshInterval);
        }
      }
    }
    return {
      open: open,
      close: close
    };
  };
}(bluebird_extended, utils_http, utils_utils, events_notifier, events_list, constants_transcoding_statuses);
services_new_relic = function () {
  function sendNewRelicError(message, details) {
    if (!window.newrelic) {
      return;
    }
    window.newrelic.addPageAction('error', {
      source: 'wixmp-sdk',
      message: message,
      details: details
    });
  }
  return { sendError: sendNewRelicError };
}();
services_channel_black_arrow = function (Promise, initHttp, utils, newRelic, notifier, eventsList, toError, TRANSCODING_STATUSES) {
  var OPEN_REJECT_TIMEOUT = 5 * 1000;
  var REOPEN_TIMEOUT = 30 * 1000;
  function cachePromise(factory) {
    var pending;
    return function () {
      if (pending) {
        return pending;
      }
      pending = factory.apply(this, arguments).catch(function (reason) {
        pending = null;
        return Promise.reject(reason);
      });
      return pending;
    };
  }
  return function (settings, adapter, itemMapper, requestOptions) {
    var http = initHttp(requestOptions);
    var socket = null;
    var openStarted;
    var openTimeout;
    var socketOpeningPromise;
    var status = 'INIT';
    var supportedEvents = [
      'open',
      'close',
      'message'
    ];
    var events = [];
    var getToken = cachePromise(function getToken() {
      return http.get(settings.apiUrl + settings.blackArrow.tokenUrl, null, { withCredentials: true }).then(function (response) {
        status = 'GOT_TOKEN';
        return utils.get(response, 'data.token', '');
      }).catch(function (response) {
        status = 'GET_TOKEN_FAILED';
        newRelic.sendError('can not get black arrow token', {
          code: response.code,
          body: response.responseText
        });
        return toError(response);
      });
    });
    function emitItemUpdateEvent(result) {
      var event = notifier.emit(adapter, eventsList.ITEM.UPDATE, {
        arguments: [
          result.data,
          result.data
        ]
      });
      event.resolve(result);
    }
    function filterEvents(eventName) {
      return function (event) {
        return event.name === eventName;
      };
    }
    function on(eventNames, callback) {
      if (typeof eventNames === 'string') {
        eventNames = [eventNames];
      }
      eventNames.forEach(function (eventName) {
        if (supportedEvents.indexOf(eventName) < 0) {
          throw new Error('This event ' + eventName + ' is not supported by websocket');
        }
        events.push({
          name: eventName,
          fn: callback
        });
      });
    }
    function off(eventNames, callback) {
      if (typeof eventNames === 'string') {
        eventNames = [eventNames];
      }
      events = events.filter(function (event) {
        return !eventNames.some(function (eventName) {
          return event.name === eventName && (!callback || event.fn === callback);
        });
      });
    }
    function emit(eventName, args) {
      var __slice = [].slice;
      args = arguments.length >= 2 ? __slice.call(arguments, 1) : [];
      events.filter(filterEvents(eventName)).forEach(function (event) {
        event.fn.apply({ event: eventName }, args);
      });
    }
    function open() {
      if (!settings.blackArrow.enabled) {
        newRelic.sendError('black arrow disabled');
        return Promise.reject('black arrow disabled');
      }
      if (socket) {
        return Promise.resolve(socket);
      }
      if (openStarted) {
        return socketOpeningPromise;
      }
      openStarted = true;
      status = 'OPEN_STARTED';
      socketOpeningPromise = getToken().then(openSocket).catch(function (reason) {
        console.log(reason);
        newRelic.sendError('can not open black arrow', {
          code: reason.code,
          body: reason.responseText || reason.message
        });
        return toError(reason);
      });
      return socketOpeningPromise;
    }
    function reopenSocket() {
      if (!openStarted) {
        return;
      }
      status = 'REOPEN_STARTED';
      openTimeout = setTimeout(openSocket, REOPEN_TIMEOUT);
    }
    function openSocket(token) {
      socket = new WebSocket(settings.blackArrow.wsUrl + '?token=' + token);
      socket.onmessage = onMessage;
      socket.onerror = function () {
        newRelic.sendError('websockets on error');
        reopenSocket();
      };
      socket.onopen = function () {
        status = 'OPENED';
        emit('open');
      };
      socket.onclose = function (closeEvent) {
        socket = null;
        newRelic.sendError('websockets on close', {
          code: closeEvent.code,
          message: closeEvent.reason
        });
        emit('close');
      };
      return new Promise(function (resolve, reject) {
        var rejectTimeoutId;
        on('open', function () {
          resolve(socket);
          clearTimeout(rejectTimeoutId);
        });
        rejectTimeoutId = setTimeout(function () {
          newRelic.sendError('reject by inner timeout');
          reject({
            code: 0,
            message: 'reject by inner timeout'
          });
        }, OPEN_REJECT_TIMEOUT);
      });
    }
    function close() {
      openStarted = false;
      if (openTimeout) {
        clearTimeout(openTimeout);
        openTimeout = null;
      }
      if (socket) {
        status = 'CLOSED';
        socket.close();
        return new Promise(function (resolve) {
          on('close', function () {
            resolve('closed');
          });
        });
      }
      newRelic.sendError('websockets: no socket to close', { message: reason });
      return Promise.reject('no socket');
    }
    function onMessage(message) {
      try {
        message = JSON.parse(message.data);
      } catch (error) {
        newRelic.sendError('parse web sockets message failed', { message: error });
        return;
      }
      if (message.type === 'status_update' && settings.asyncTranscoding) {
        if (utils.get(message, 'file.op_status') === TRANSCODING_STATUSES.READY) {
          adapter.item.get(utils.get(message, 'file.file_name')).then(emitItemUpdateEvent);
        } else {
          emitItemUpdateEvent({ data: itemMapper(message.file, settings, {}, true) });
        }
      }
      if (message.type === 'trash_file') {
        notifier.emitResolve(adapter, eventsList.ITEMS.REMOVE, { arguments: [[message.file_name]] }, { data: { id: message.file_name } });
      }
      if (message.type === 'item_update') {
        var item = itemMapper(message.file, settings, {}, true);
        var event = notifier.emit(adapter, eventsList.ITEM.UPDATE, {
          arguments: [
            item,
            item
          ]
        });
        event.resolve({ data: item });  //notifier.emitResolve(adapter, eventsList.ITEM.UPDATE,
                                        //  {arguments: [[item, item]]},
                                        //  {data: item}
                                        //);
      }
      emit('message', message);
    }
    function send(message, action, method) {
      return getToken().then(function (token) {
        if (!token) {
          newRelic.sendError('websockets: try to send message without token');
          return Promise.reject('no token');
        }
        if (!message) {
          newRelic.sendError('websockets: try to send message without message');
          return Promise.reject('no message');
        }
        action = action || 'send';
        var data = { action: action };
        if (method === 'post' || !socket) {
          data = utils.extend(data, {
            message: JSON.stringify(message),
            token: token
          });
          var options = { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } };
          return http.post(settings.blackArrow.messageUrl, data, null, options).catch(function (reason) {
            newRelic.sendError('websockets: black arrow test failed', {
              code: reason.code,
              body: reason.responseText
            });
            return toError(reason);
          });
        }
        data = utils.extend(data, { message: message });
        socket.send(JSON.stringify(data));
        return message;
      });
    }
    return {
      open: open,
      close: close,
      send: send,
      on: on,
      off: off,
      getStatus: function () {
        return status;
      },
      getOpenStarted: function () {
        return openStarted;
      }
    };
  };
}(bluebird_extended, utils_http, utils_utils, services_new_relic, events_notifier, events_list, sources_private_parsers_error, constants_transcoding_statuses);
sources_private_refresh_token_wrapper = function (Promise, initHttp, utils) {
  var http = initHttp();
  return function (refreshTokenUrl) {
    var authHeaders = {};
    var refreshedAt = 0;
    function isRecentlyRefreshed() {
      return new Date().valueOf() - refreshedAt < 10000;
    }
    // wrap request with refresh auth token
    return function (method) {
      // add auth token to request
      var methodWithAuthHeaders = function () {
        var originalHeaders = (arguments[2] || {}).headers || {};
        return method.call(this, arguments[0], arguments[1] || {}, utils.merge(arguments[2] || {}, { headers: utils.merge(authHeaders, originalHeaders) }));
      };
      // refresh token on auth error and retry call
      return http.catchError(methodWithAuthHeaders, function (reason, callMethod) {
        if (reason.code === 403 && !isRecentlyRefreshed()) {
          return http.post(refreshTokenUrl).then(function (response) {
            authHeaders = response.data.set_headers || {};
            refreshedAt = new Date().valueOf();
            return callMethod();
          });
        }
        return Promise.reject(reason);
      });
    };
  };
}(bluebird_extended, utils_http, utils_utils);
services_polling = function (Promise, utils, notifier, eventsList, itemMapper, TRANSCODING_STATUSES) {
  var POLLING_TIMEOUT = 60 * 1000;
  return function (settings, adapter, itemMapper, http) {
    return function (itemId) {
      function emitItemUpdateEvent(result) {
        var event = notifier.emit(adapter, eventsList.ITEM.UPDATE, {
          arguments: [
            result.data,
            result.data
          ]
        });
        event.resolve(result);
      }
      return new Promise(function (resolve, reject) {
        function checkItemStatus() {
          setTimeout(function () {
            http.get(settings.apiUrl + '/files/' + itemId, null, { cache: false }).then(function (response) {
              var status = response.data.op_status;
              if (status === TRANSCODING_STATUSES.READY) {
                var responseItemId = response.data.file_name;
                adapter.item.get(responseItemId).then(emitItemUpdateEvent);
                resolve(responseItemId);
                return;
              }
              var result = itemMapper(response.data, settings, {}, true);
              emitItemUpdateEvent({ data: result });
              if (status === TRANSCODING_STATUSES.FAILED) {
                reject('Item transcoding failed');
                return;
              }
              checkItemStatus();
            }).catch(checkItemStatus);
          }, POLLING_TIMEOUT);
        }
        checkItemStatus();
      });
    };
  };
}(bluebird_extended, utils_utils, events_notifier, events_list, sources_private_mappers_item, constants_transcoding_statuses);
services_crc32 = function () {
  /*eslint-disable*/
  /* crc32.js (C) 2014-present SheetJS -- http://sheetjs.com */
  /* vim: set ts=2: */
  /*exported CRC32 */
  var CRC32 = {};
  CRC32.version = '1.0.1';
  /* see perf/crc32table.js */
  /*global Int32Array */
  function signed_crc_table() {
    var c = 0, table = new Array(256);
    for (var n = 0; n != 256; ++n) {
      c = n;
      c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
      c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
      c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
      c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
      c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
      c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
      c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
      c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
      table[n] = c;
    }
    return typeof Int32Array !== 'undefined' ? new Int32Array(table) : table;
  }
  var T = signed_crc_table();
  function crc32_bstr(bstr, seed) {
    var C = seed ^ -1, L = bstr.length - 1;
    for (var i = 0; i < L;) {
      C = C >>> 8 ^ T[(C ^ bstr.charCodeAt(i++)) & 255];
      C = C >>> 8 ^ T[(C ^ bstr.charCodeAt(i++)) & 255];
    }
    if (i === L)
      C = C >>> 8 ^ T[(C ^ bstr.charCodeAt(i)) & 255];
    return C;
  }
  function crc32_buf(buf, seed) {
    if (buf.length > 10000)
      return crc32_buf_8(buf, seed);
    var C = seed ^ -1, L = buf.length - 3;
    for (var i = 0; i < L;) {
      C = C >>> 8 ^ T[(C ^ buf[i++]) & 255];
      C = C >>> 8 ^ T[(C ^ buf[i++]) & 255];
      C = C >>> 8 ^ T[(C ^ buf[i++]) & 255];
      C = C >>> 8 ^ T[(C ^ buf[i++]) & 255];
    }
    while (i < L + 3)
      C = C >>> 8 ^ T[(C ^ buf[i++]) & 255];
    return C;
  }
  function crc32_buf_8(buf, seed) {
    var C = seed ^ -1, L = buf.length - 7;
    for (var i = 0; i < L;) {
      C = C >>> 8 ^ T[(C ^ buf[i++]) & 255];
      C = C >>> 8 ^ T[(C ^ buf[i++]) & 255];
      C = C >>> 8 ^ T[(C ^ buf[i++]) & 255];
      C = C >>> 8 ^ T[(C ^ buf[i++]) & 255];
      C = C >>> 8 ^ T[(C ^ buf[i++]) & 255];
      C = C >>> 8 ^ T[(C ^ buf[i++]) & 255];
      C = C >>> 8 ^ T[(C ^ buf[i++]) & 255];
      C = C >>> 8 ^ T[(C ^ buf[i++]) & 255];
    }
    while (i < L + 7)
      C = C >>> 8 ^ T[(C ^ buf[i++]) & 255];
    return C;
  }
  function crc32_str(str, seed) {
    var C = seed ^ -1;
    for (var i = 0, L = str.length, c, d; i < L;) {
      c = str.charCodeAt(i++);
      if (c < 128) {
        C = C >>> 8 ^ T[(C ^ c) & 255];
      } else if (c < 2048) {
        C = C >>> 8 ^ T[(C ^ (192 | c >> 6 & 31)) & 255];
        C = C >>> 8 ^ T[(C ^ (128 | c & 63)) & 255];
      } else if (c >= 55296 && c < 57344) {
        c = (c & 1023) + 64;
        d = str.charCodeAt(i++) & 1023;
        C = C >>> 8 ^ T[(C ^ (240 | c >> 8 & 7)) & 255];
        C = C >>> 8 ^ T[(C ^ (128 | c >> 2 & 63)) & 255];
        C = C >>> 8 ^ T[(C ^ (128 | d >> 6 & 15 | (c & 3) << 4)) & 255];
        C = C >>> 8 ^ T[(C ^ (128 | d & 63)) & 255];
      } else {
        C = C >>> 8 ^ T[(C ^ (224 | c >> 12 & 15)) & 255];
        C = C >>> 8 ^ T[(C ^ (128 | c >> 6 & 63)) & 255];
        C = C >>> 8 ^ T[(C ^ (128 | c & 63)) & 255];
      }
    }
    return C;
  }
  CRC32.table = T;
  CRC32.bstr = crc32_bstr;
  CRC32.buf = crc32_buf;
  CRC32.str = crc32_str;
  return CRC32;
}();
services_upload_file_to_upload = function (Promise) {
  function promisify(value) {
    if (value.then) {
      return value;
    }
    return Promise.resolve(value);
  }
  function canAbort(fileToUpload) {
    return fileToUpload.status === 'waiting' || fileToUpload.status === 'uploading' && Promise.prototype.cancellable;
  }
  function abortEarly(fileToUpload) {
    fileToUpload.deferred.promise.catch(function (reason) {
      fileToUpload.status = 'failed';
      fileToUpload.error = reason;
    });
    fileToUpload.deferred.promise.abort();
  }
  function initUpload(fileToUpload, data) {
    fileToUpload.status = 'uploading';
    fileToUpload.uploadPromise = promisify(data.uploadFn(fileToUpload.source)).progress(function (progress) {
      fileToUpload.deferred.promise.notify(progress);
    }).then(function (res) {
      fileToUpload.deferred.resolve(res);
    }).catch(function (reason) {
      fileToUpload.status = 'failed';
      fileToUpload.error = reason;
      fileToUpload.deferred.reject(reason);
    });
    fileToUpload.uploadPromise.notify({
      status: fileToUpload.status,
      total: fileToUpload.getFileSize(),
      loaded: 0
    });
  }
  function createDeferred() {
    return Promise.defer();
  }
  function map(data) {
    return {
      source: data.source,
      status: 'waiting',
      bytesLoaded: 0,
      currentChunkBytesLoaded: 0,
      deferred: createDeferred(),
      isAborted: false,
      error: {},
      upload: function () {
        if (!this.isAborted) {
          initUpload(this, data);
        }
        return this.deferred.promise;
      },
      abort: function () {
        if (!canAbort(this)) {
          return;
        }
        this.isAborted = true;
        if (this.status === 'waiting') {
          abortEarly(this);
          return;
        }
        this.uploadPromise.abort();
      },
      canRetry: function () {
        if (this.error instanceof Promise.CancellationError) {
          return true;
        }
        var codesToRetry = [
          -201,
          401,
          403,
          408
        ];
        return this.status === 'failed' && codesToRetry.indexOf(this.error.code) !== -1;
      },
      signUpForRetry: function () {
        this.status = 'waiting';
        this.isAborted = false;
        this.error = {};
        this.deferred = createDeferred();
      },
      canAbort: function () {
        return canAbort(this);
      },
      getFileSize: function () {
        return this.source.file ? this.source.file.size : 1;
      }
    };
  }
  return map;
}(bluebird_extended);
services_upload_upload_collection = function (Promise, utils, fileToUploadMapper) {
  var maxParallelUploads = 1;
  var uploadQueue = [];
  var uploadIsInProgress = false;
  var currentUploadedTotal = 0;
  var deferred;
  var supportedEvents = [
    'queueChanged',
    'fileStatusChanged',
    'uploadQueueStarted',
    'uploadQueueFinished'
  ];
  var events = [];
  function filterEvents(eventName) {
    return function (event) {
      return event.name === eventName;
    };
  }
  function on(eventNames, callback) {
    if (typeof eventNames === 'string') {
      eventNames = [eventNames];
    }
    eventNames.forEach(function (eventName) {
      if (supportedEvents.indexOf(eventName) === -1) {
        throw new Error('This event ' + eventName + ' is not supported by multiple file uploader');
      }
      events.push({
        name: eventName,
        fn: callback
      });
    });
  }
  function off(eventNames, callback) {
    if (typeof eventNames === 'string') {
      eventNames = [eventNames];
    }
    for (var i = events.length - 1; i >= 0; i -= 1) {
      var event = events[i];
      eventNames.forEach(function (eventName) {
        if (event.name === eventName && (!callback || event.fn === callback)) {
          events.splice(i, 1);
        }
      });
    }
  }
  function emit(eventName, args) {
    var __slice = [].slice;
    args = arguments.length >= 2 ? __slice.call(arguments, 1) : [];
    events.filter(filterEvents(eventName)).forEach(function (event) {
      event.fn.apply({ event: eventName }, args);
    });
  }
  function hasWaitingFiles() {
    return uploadQueue.some(function (fileToUpload) {
      return fileToUpload.status === 'waiting';
    });
  }
  function getWaitingFiles() {
    return uploadQueue.filter(function (fileToUpload) {
      return fileToUpload.status === 'waiting';
    });
  }
  function hasRetryableFiles() {
    return uploadQueue.some(function (fileToUpload) {
      return fileToUpload.canRetry();
    });
  }
  function getInProgressFilesCount() {
    return uploadQueue.filter(function (fileToUpload) {
      return [
        'uploading',
        'processing'
      ].indexOf(fileToUpload.status) >= 0;
    }).length;
  }
  function hasInProgressFiles() {
    return uploadQueue.some(function (fileToUpload) {
      return [
        'uploading',
        'processing'
      ].indexOf(fileToUpload.status) >= 0;
    });
  }
  function dynamicPromiseReduce() {
    if (!hasWaitingFiles() && !hasInProgressFiles()) {
      deferred.resolve();
    }
    var availableSlots = maxParallelUploads - getInProgressFilesCount();
    if (availableSlots <= 0) {
      return deferred.promise;
    }
    var filesToStartUpload = getWaitingFiles().slice(0, availableSlots);
    filesToStartUpload.forEach(function (fileToUpload) {
      fileToUpload.upload().then(function (res) {
        dynamicPromiseReduce();
        return res;
      }).catch(function (err) {
        dynamicPromiseReduce();
        console.warn(err);
      });
    });
    return deferred.promise;
  }
  function getBytesTotal() {
    return uploadQueue.reduce(function (sum, fileToUpload) {
      return sum + fileToUpload.getFileSize();
    }, 0);
  }
  function calculateItemBytesLoaded(fileToUpload, progress) {
    switch (progress.status) {
    case 'uploading':
      if (progress.loaded <= fileToUpload.getFileSize()) {
        return progress.loaded;
      }
      return fileToUpload.getFileSize();
    case 'succeeded':
    case 'processing':
      return fileToUpload.getFileSize();
    case 'failed':
      return 0;
    default:
      return 0;
    }
  }
  function processItemProgress(fileToUpload) {
    return function (progress) {
      if ([
          'failed',
          'succeeded'
        ].indexOf(fileToUpload.status) === -1) {
        fileToUpload.status = progress.status;
      } else {
        progress.status = fileToUpload.status;
      }
      var fileSize = fileToUpload.getFileSize();
      fileToUpload.bytesLoaded = progress.loaded >= fileSize ? fileSize : progress.loaded;
      progress.file = fileToUpload;
      emit('fileStatusChanged', {
        bytesTotalUploaded: currentUploadedTotal + calculateItemBytesLoaded(fileToUpload, progress),
        bytesTotal: getBytesTotal(),
        currentFileProgress: progress,
        currentFileQueueIdx: uploadQueue.indexOf(fileToUpload),
        queue: uploadQueue
      });
    };
  }
  function startUploadQueue() {
    if (uploadIsInProgress) {
      dynamicPromiseReduce();
      return;
    }
    deferred = Promise.defer();
    uploadIsInProgress = true;
    emit('uploadQueueStarted', uploadQueue);
    dynamicPromiseReduce().then(function () {
      uploadIsInProgress = false;
      emit('uploadQueueFinished', uploadQueue);
    }).catch(function (err) {
      console.warn(err);
    });
  }
  function addProgressNotifications(fileToUpload) {
    var processCurrentItemProgress = processItemProgress(fileToUpload);
    var fileSize = fileToUpload.getFileSize();
    fileToUpload.deferred.promise.progress(processCurrentItemProgress).then(function (result) {
      fileToUpload.serverResponse = result;
      processCurrentItemProgress({
        status: 'succeeded',
        total: fileSize,
        loaded: fileSize
      });
      currentUploadedTotal += fileSize;
    }).catch(function (reason) {
      fileToUpload.serverResponse = reason;
      processCurrentItemProgress({
        status: 'failed',
        total: fileSize,
        loaded: 0
      });
    });
  }
  function addRestartOnRetry(fileToUpload) {
    var nativeRetry = fileToUpload.signUpForRetry;
    fileToUpload.signUpForRetry = function () {
      nativeRetry.apply(this, arguments);
      addProgressNotifications(fileToUpload);
      startUploadQueue();
    };
  }
  function clearQueue() {
    if (uploadIsInProgress) {
      throw new Error('Upload queue can not be cleared while upload is running');
    }
    uploadQueue.length = 0;
    currentUploadedTotal = 0;
  }
  function upload(fileSources) {
    fileSources = fileSources || [];
    if (!uploadIsInProgress && !hasRetryableFiles()) {
      clearQueue();
    }
    var mappedFiles = fileSources.map(fileToUploadMapper).map(function (fileToUpload) {
      addProgressNotifications(fileToUpload);
      addRestartOnRetry(fileToUpload);
      uploadQueue.push(fileToUpload);
      return fileToUpload;
    });
    emit('queueChanged', uploadQueue);
    startUploadQueue();
    return mappedFiles;
  }
  return {
    on: on,
    off: off,
    upload: upload,
    clearQueue: clearQueue,
    set maxParallelUploads(number) {
      maxParallelUploads = Number(number) || 1;
    },
    get maxParallelUploads() {
      return maxParallelUploads;
    },
    get uploadQueue() {
      return uploadQueue;
    },
    get uploadIsInProgress() {
      return uploadIsInProgress;
    },
    get currentUploadedTotal() {
      return currentUploadedTotal;
    }
  };
}(bluebird_extended, utils_utils, services_upload_file_to_upload);
services_bi_send_request = function (utils) {
  function getBaseHost() {
    //return '//frog.wixpress.com';
    return /\.wixpress\.com/i.test(document.location.host) || /local\./i.test(document.location.host) ? '//frog.wixpress.com' : '//frog.wix.com';
  }
  return function (url, data) {
    var biImage = document.createElement('img');
    biImage.setAttribute('src', getBaseHost() + url + '?' + utils.encodeParams(data) + '&_=' + new Date().getTime());
    biImage = null;
  };
}(utils_utils);
services_bi_event_ids = {
  severity: {
    info: 10,
    warning: 20,
    error: 30,
    fatal: 40
  },
  BIEventsIds: {
    responseTime: '110',
    uploadSpeed: '142',
    uploadQueueStarted: '303',
    uploadQueueFinished: '304',
    resumableUploadStarted: '155',
    resumableUploadFinished: '156',
    resumableChunkUploadStarted: '157',
    resumableChunkUploadFinished: '158'
  },
  BIAdaptersIds: {
    private: '01',
    public: '02',
    facebook: '03',
    flickr: '04',
    instagram: '05',
    picasa: '06',
    flickrSearch: '07',
    googleSearch: '08',
    bigStock: '09',
    collection: '10',
    drive: '11',
    dropbox: '12',
    facebookVideo: '13',
    instagramVideo: '14',
    vimeo: '15',
    vimeoSearch: '16',
    youtube: '17',
    youtubeSearch: '18'
  },
  BIAdaptersRequestsIds: {
    'folders.list': '01',
    'folders.remove': '02',
    'folders.trash.list': '03',
    'folders.trash.restore': '04',
    'folders.trash.remove': '05',
    'folder.create': '06',
    'folder.update': '07',
    'items.list': '11',
    'items.remove': '12',
    'items.search': '13',
    'items.searchByTag': '14',
    'items.trash.list': '15',
    'items.trash.restore': '16',
    'items.trash.remove': '17',
    'item.get': '18',
    'item.update': '19',
    'item.upload': '20',
    'item.uploadByUrl': '21',
    'trash.remove': '22',
    'trash.restore': '23'
  }
};
services_resumable = function (Promise, utils, crc32, Uploader, sendBi, BIEventIds, toError) {
  var HASH_SIZE = 1024 * 1024;
  function getCurrentTime() {
    return new Date().getTime();
  }
  function getBlobArrayBuffer(blob) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.readAsArrayBuffer(blob);
      reader.onload = function (event) {
        var arrayBuffer = new Int32Array(event.target.result);
        resolve(arrayBuffer);
      };
      reader.onerror = function (reason) {
        reject(reason);
      };
    });
  }
  function getHash(blob) {
    var startedAt = getCurrentTime();
    return getBlobArrayBuffer(blob.slice(0, HASH_SIZE)).then(function (arrayBuffer) {
      console.log('time to get hash', getCurrentTime() - startedAt);
      return crc32.buf(arrayBuffer).toString(16);
    }, toError);
  }
  function getSliceFunction(file) {
    var funcToSlice;
    if (file.slice) {
      funcToSlice = 'slice';
    } else if (file.mozSlice) {
      funcToSlice = 'mozSlice';
    } else if (file.webkitSlice) {
      funcToSlice = 'webkitSlice';
    } else {
      funcToSlice = 'slice';
    }
    return funcToSlice;
  }
  function getBytesToUpload(chunksToUpload) {
    return chunksToUpload.reduce(function (prevValue, nextValue) {
      return prevValue + utils.get(nextValue, 'data.resumableCurrentChunkSize', 0);
    }, 0);
  }
  function getFileId(file, chunksLength) {
    var startHash = getHash(file.file.slice(0, HASH_SIZE));
    var endHash = getHash(file.file.slice(-HASH_SIZE));
    return Promise.all([
      startHash,
      endHash
    ]).then(function (response) {
      return response[0] + '_' + response[1] + '_' + chunksLength;
    }, toError);
  }
  function getChunkSize(size) {
    // 100MB
    if (size < 104857600) {
      return 10485760;  // 10MB
    }
    // 500MB
    if (size < 524288000) {
      return 26214400;  // 25MB
    }
    // 2GB
    if (size < 2147483648) {
      return 52428800;  // 50MB
    }
    // 5GB
    if (size < 5368709120) {
      return 104857600;  // 100MB
    }
    return Math.ceil(size / 100);
  }
  function getChunksFromFile(fileSource) {
    var file = fileSource.file;
    var funcToSlice = getSliceFunction(file);
    var chunks = [];
    var startBytes = 0;
    var chunkSize = getChunkSize(file.size);
    console.log('chunkSize', chunkSize);
    while (startBytes < file.size) {
      chunks.push(file[funcToSlice](startBytes, startBytes + chunkSize));
      startBytes += chunkSize;
    }
    return chunks;
  }
  function getNotReadyChunks(chunksStatuses) {
    return chunksStatuses.filter(function (chunk) {
      return chunk.status !== 'READY';
    });
  }
  return function (settings, adapter, itemMapper, http) {
    /*
        function checkChunkUploadStatus(fileId, chunkNumber, options) {
          var data = {
            resumableIdentifier: fileId,
            resumableChunkNumber: chunkNumber
          };
    
          return http
            .get(settings.apiUrl + '/resumable/chunk/status', data, options)
            .then(function (response) {
              console.log('response', response);
              return response;
            }, function (error) {
              console.log('error', error);
              return toError(error);
            });
        }
        */
    function checkAllChunks(fileId, chunks) {
      var url = settings.apiUrl + '/resumable/chunk/status';
      var data = {
        resumableIdentifier: fileId,
        resumableTotalChunks: chunks.length
      };
      var options = {
        withCredentials: true,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      };
      return http.post(url, data, null, options).then(function (response) {
        return response.data.resumableChunks;
      }, toError);
    }
    function uploadChunks(chunksToUpload, allChunksLength, file, fileId, resumableUploadPromise, options) {
      var bytesTotalUploaded = 0;
      var currentChunkBytesLoaded = 0;
      if (allChunksLength !== chunksToUpload.length) {
        bytesTotalUploaded = file.file.size - getBytesToUpload(chunksToUpload);
      }
      var fileToUpload = utils.find(Uploader.uploadQueue, function (el) {
        return el.source.file === file.file;
      });
      console.log('start chunks upload');
      var uploadedChunkResponses = [];
      return new Promise(function (resolve, reject) {
        function uploadChunk(chunkId) {
          var chunk = chunksToUpload[chunkId];
          if (!chunk) {
            resolve(uploadedChunkResponses);
            return;
          }
          sendBi('/mg', {
            src: 26,
            evid: BIEventIds.BIEventsIds.resumableChunkUploadStarted,
            chunk_size: utils.get(chunk, 'data.chunk.size', -1),
            file_id: fileId,
            file_size: file.file.size,
            total_chunks: allChunksLength
          });
          var chunkUploadStartedAt = getCurrentTime();
          var uploadChunkPromise = http.upload(chunk.uploadUrl, chunk.data, options).progress(function (progress) {
            var chunkBytesLoaded = progress.loaded >= progress.total ? progress.total : progress.loaded;
            bytesTotalUploaded += chunkBytesLoaded - currentChunkBytesLoaded;
            currentChunkBytesLoaded = chunkBytesLoaded;
            var progressStatus = 'uploading';
            if (bytesTotalUploaded >= file.file.size) {
              progressStatus = 'processing';
            }
            resumableUploadPromise.notify({
              loaded: bytesTotalUploaded,
              status: progressStatus,
              total: file.file.size
            });
          }).then(function (response) {
            var chunkUploadTime = (getCurrentTime() - chunkUploadStartedAt) / 1000;
            sendBi('/mg', {
              src: 26,
              evid: BIEventIds.BIEventsIds.resumableChunkUploadFinished,
              chunk_size: utils.get(chunk, 'data.chunk.size', -1),
              file_id: fileId,
              file_size: file.file.size,
              total_chunks: allChunksLength,
              upload_speed: Math.floor(file.file.size / chunkUploadTime),
              upload_time: Math.floor(chunkUploadTime)
            });
            currentChunkBytesLoaded = 0;
            uploadedChunkResponses.push(response.data);
            console.log('chunk', chunkId, 'was uploaded');
            uploadChunk(chunkId + 1);
          }, function (reason) {
            // TODO: add support to get new uploading url
            console.warn('upload file error', reason);
            if (reason instanceof Promise.CancellationError) {
              return Promise.reject(reason);
            }
            resumableUploadPromise.notify({
              loaded: bytesTotalUploaded,
              status: 'failed',
              total: file.file.size
            });
            return Promise.reject(reason);  /*
                                                            if (utils.get(reason, 'data.message') === 'link expired') {
                                                              console.log('chunk', chunkId, 'upload link was expired');
                                            
                                                              var uploadApiUrl = settings.apiUrl + '/resumable/chunk/url';
                                                              var data = {
                                                                count: 1
                                                              };
                                            
                                                              http
                                                                .post(uploadApiUrl, data, null, options)
                                                                .then(
                                                                  function (response) {
                                                                    var uploadUrl = _.get(response, 'data.upload_urls[0]');
                                            
                                                                    http
                                                                      .upload(uploadUrl, chunk.data, options)
                                                                      .then(
                                                                        function (response) {
                                                                          uploadedChunkResponses.push(response.data);
                                            
                                                                          console.log('chunk', chunkId, 'was uploaded with new link');
                                                                          uploadChunk(chunkId + 1);
                                                                        }
                                                                      );
                                                                  }
                                                                );
                                                            }
                                                            */
          }).catch(function (reason) {
            console.warn('error file upload!!!', reason);
            reject(reason);
          });
          fileToUpload.uploadPromise.abort = function () {
            uploadChunkPromise.abort();
          };
          return uploadChunkPromise;
        }
        uploadChunk(0);
      });
    }
    function finalizeItem(fileId, fileSource) {
      var params = {
        resumableIdentifier: fileId,
        content_type: fileSource.file.type,
        file_name: fileSource.file.name,
        media_type: fileSource.media_type,
        parent_folder_id: fileSource.parent_folder_id
      };
      return http.get(settings.apiUrl + '/resumable/finalize', params);
    }
    return function (fileSource, options) {
      console.log('resumable upload started');
      options = options || {};
      var fileUploadStartedAt = getCurrentTime();
      var fileId;
      var chunks = getChunksFromFile(fileSource);
      console.log('chunks', chunks.length);
      console.log('chunks', chunks);
      var resumableUploadPromise;
      resumableUploadPromise = new Promise(function (resolve, reject) {
        getFileId(fileSource, chunks.length).then(function (responseFileId) {
          fileId = responseFileId;
          console.log('fileId', fileId);
        }).then(function () {
          return checkAllChunks(fileId, chunks).then(getNotReadyChunks, toError);
        }).then(function (notReadyChunks) {
          console.log('notReadyChunks', notReadyChunks);
          sendBi('/mg', {
            src: 26,
            evid: BIEventIds.BIEventsIds.resumableUploadStarted,
            file_id: fileId,
            file_size: fileSource.file.size,
            uploaded_chunks: chunks.length - notReadyChunks.length,
            total_chunks: chunks.length,
            chunks_status_time: Math.floor((getCurrentTime() - fileUploadStartedAt) / 1000)
          });
          var defaultData = {
            resumableIdentifier: fileId,
            resumableTotalChunks: chunks.length,
            parent_folder_id: fileSource.folderId || null,
            media_type: fileSource.media_type
          };
          var chunksToUpload = notReadyChunks.map(function (chunk) {
            var chunkData = utils.merge(defaultData, {
              chunk: chunks[chunk.chunkNumber],
              resumableChunkNumber: chunk.chunkNumber,
              resumableCurrentChunkSize: chunks[chunk.chunkNumber].size
            });
            return {
              uploadUrl: chunk.uploadUrl,
              data: chunkData
            };
          });
          return uploadChunks(chunksToUpload, chunks.length, fileSource, fileId, resumableUploadPromise, options);
        }).then(function (uploadedChunkResponses) {
          console.log('all chunks were uploaded');
          console.log('all uploaded chunks responses', uploadedChunkResponses);
          var chunksUploadedInCurrentSession = uploadedChunkResponses.length;
          return finalizeItem(fileId, fileSource).then(function (response) {
            console.log('chunksUploadedInCurrentSession', chunksUploadedInCurrentSession);
            console.log('finalizeItem response', response);
            var fileSize = fileSource.file.size;
            var uploadTime = (getCurrentTime() - fileUploadStartedAt) / 1000;
            sendBi('/mg', {
              src: 26,
              evid: BIEventIds.BIEventsIds.resumableUploadFinished,
              file_id: fileId,
              file_size: fileSource.file.size,
              uploaded_chunks: chunksUploadedInCurrentSession,
              total_chunks: chunks.length,
              upload_speed: Math.floor(fileSize / uploadTime),
              upload_time: Math.floor(uploadTime)
            });
            return resolve(response);
          }, function (reason) {
            console.warn('finalize error', reason);
            return Promise.reject(reason);
          });
        }).catch(function (reason) {
          console.warn('resumable', reason);
          reject(reason);
        });
      });
      return resumableUploadPromise;
    };
  };
}(bluebird_extended, utils_utils, services_crc32, services_upload_upload_collection, services_bi_send_request, services_bi_event_ids, sources_private_parsers_error);
sources_private_Private = function (initFolders, initFolder, initItems, initItem, initTrash, initItemsTrash, initItemsSiteMedia, initFoldersTrash, itemMapper, defaultSettings, utils, decorators, eventsList, initChannel, initBlackArrow, initRefreshTokenWrapper, initHttp, initPolling, initResumable) {
  return function (userSettings) {
    var settings = utils.extendDeep({}, defaultSettings, userSettings);
    var withRefreshToken = initRefreshTokenWrapper(settings.refreshTokenUrl);
    var requestOptions = settings.requestOptions;
    if (utils.get(requestOptions, 'params.ns')) {
      settings.ns = requestOptions.params.ns;
    }
    var http = initHttp(requestOptions);
    var blackArrow = initBlackArrow(settings, this, itemMapper);
    var polling = initPolling(settings, this, itemMapper, http);
    var resumable = initResumable(settings, this, itemMapper, http);
    var settingsWithRefreshToken = {
      get: withRefreshToken(http.get),
      post: withRefreshToken(http.post),
      upload: withRefreshToken(http.upload)
    };
    var httpWithRefreshToken = settings.refreshTokenUrl ? settingsWithRefreshToken : http;
    var folders = initFolders(settings, httpWithRefreshToken);
    var folder = initFolder(settings, httpWithRefreshToken);
    var items = initItems(settings, httpWithRefreshToken);
    var item = initItem(settings, httpWithRefreshToken, blackArrow, polling, resumable);
    var trash = initTrash(settings, httpWithRefreshToken);
    var itemsTrash = initItemsTrash(settings, httpWithRefreshToken);
    var itemsSiteMedia = initItemsSiteMedia(settings, httpWithRefreshToken);
    var foldersTrash = initFoldersTrash(settings, httpWithRefreshToken);
    var channel = initChannel(settings, this, itemMapper, http);
    folders.trash = foldersTrash;
    items.trash = itemsTrash;
    items.siteMedia = itemsSiteMedia;
    this.name = 'private';
    this.folders = decorators.addEvents(this, eventsList.FOLDERS, folders);
    this.folder = decorators.addEvents(this, eventsList.FOLDER, folder);
    this.item = decorators.addEvents(this, eventsList.ITEM, item);
    this.items = decorators.addEvents(this, eventsList.ITEMS, items);
    this.trash = decorators.addEvents(this, eventsList.TRASH, trash);
    this.blackArrow = blackArrow;
    this.channel = channel;
  };
}(sources_private_folders, sources_private_folder, sources_private_items, sources_private_item, sources_private_trash, sources_private_itemstrash, sources_private_itemssite_media, sources_private_folderstrash, sources_private_mappers_item, sources_private_settings, utils_utils, sources_decorators, events_list, services_channel_channel, services_channel_black_arrow, sources_private_refresh_token_wrapper, utils_http, services_polling, services_resumable);
sources_platform_mappers_folder = function (folderData) {
  /**
   * Folder
   * {String} id
   * {String} parentId
   * {String} name
   * {String} mediaType
   * {Number} filesCount
   * {Number} createdAt
   */
  return {
    id: folderData.id,
    parentId: folderData.parent || null,
    name: folderData.title,
    mediaType: folderData.media_type,
    //filesCount: folderData.files_count,
    createdAt: Date.parse(folderData.created_at)
  };
};
sources_platform_parsers_error = function (Promise) {
  return function (response) {
    if (response.status === 403 && response.data && response.data.error_description === 'Missing Wix session') {
      response.status = 401;
      response.data.message = 'Wix Session required';
    }
    return Promise.reject(response);
  };
}(bluebird_extended);
sources_platform_folders = function (toFolder, toError) {
  return function (settings, http) {
    function mapFolderList(res) {
      res.data = (res.data.objects || []).map(toFolder);
      return res;
    }
    /**
     * @summary Return the list of folders
     * @memberof source.folders
     * @param {String} folderId
     * @param {ListSettings} options
     * @returns {Promise}
     * @fulfill {List[]} List with Folders
     * @reject {Error}
     */
    function list(folderId, options) {
      options = options || {};
      return http.get(settings.apiUrl + '/objects/folders/', {
        media_type: options.mediaType || 'picture',
        folder_id: folderId || null
      }, { headers: options.headers || {} }).then(mapFolderList).catch(toError);
    }
    function removeFolder(folderId, options) {
      var url = settings.apiUrl + '/objects/folders/' + folderId + '/delete';
      var postOptions = { headers: options.headers || {} };
      return http.post(url, null, null, postOptions).then(function (res) {
        res.data = { id: folderId };
        return res;
      }).catch(toError);
    }
    /**
     * @summary Removes the list of folders with given ids
     * @memberof source.folders
     * @param {string[]} folderIds Array of folder ids
     * @param {Object} options
     * @returns {Promise[]}
     */
    function remove(folderIds, options) {
      options = options || {};
      return folderIds.map(function (folderId) {
        return removeFolder(folderId, options);
      });
    }
    return {
      list: list,
      remove: remove
    };
  };
}(sources_platform_mappers_folder, sources_platform_parsers_error);
sources_platform_validators_new_props = function (newProps) {
  if (typeof newProps !== 'object' || newProps === null) {
    return {
      valid: false,
      message: 'Please specify new props'
    };
  }
  if (typeof newProps.name !== 'undefined' && !newProps.name) {
    return {
      valid: false,
      message: 'Please specify name'
    };
  }
  if (typeof newProps.folderId !== 'undefined' && !newProps.folderId) {
    return {
      valid: false,
      message: 'Please specify folder id'
    };
  }
  if (typeof newProps.parentId !== 'undefined' && !newProps.parentId) {
    return {
      valid: false,
      message: 'Please specify parent folder id'
    };
  }
  if (typeof newProps.tags !== 'undefined' && !Array.isArray(newProps.tags)) {
    return {
      valid: false,
      message: 'Tags should be an array'
    };
  }
  return { valid: true };
};
sources_platform_folder = function (mappers, utils, toFolder, toError, validateNewProps) {
  return function (settings, http) {
    function mapFolder(res) {
      res.data = toFolder(res.data.object);
      return res;
    }
    /**
     * @summary Create a new folder with given name and parameters
     * @memberof source.folder
     * @param {string} folderName
     * @param {object} options
     * @param {string} options.mediaType
     * @param {string} options.parentId
     * @returns {Promise}
     * @fulfill {Folder} New folder object
     * @reject {Error}
     */
    function create(folderName, options) {
      if (!folderName) {
        return toError(mappers.toError({
          status: -200,
          statusText: 'Internal JS Error',
          data: { message: 'Please specify name' }
        }));
      }
      options = options || {};
      var url = settings.apiUrl + '/objects/folders/';
      var data = {
        title: folderName,
        media_type: options.mediaType || 'picture',
        parent: options.parentId || null
      };
      var postOptions = { headers: options.headers || {} };
      return http.post(url, data, null, postOptions).then(mapFolder).catch(toError);
    }
    /**
     * @summary Updates the folder with given diff object
     * @memberof source.folder
     * @param {Folder} folder Current folder object that should be updated
     * @param {object} newFolderProps
     * @param {object} options
     * @returns {Promise}
     * @fulfill {Folder} Modified folder object
     * @reject {Error}
     */
    function update(folder, newFolderProps, options) {
      var arePropsValid = validateNewProps(newFolderProps);
      if (arePropsValid.valid === false) {
        return toError(mappers.toError({
          status: -200,
          statusText: 'Internal JS Error',
          data: { message: arePropsValid.message }
        }));
      }
      var data = {};
      if (newFolderProps.name) {
        data.folder_name = newFolderProps.name;
      }
      if (newFolderProps.parentId) {
        data.parent_folder_id = newFolderProps.parentId;
      }
      options = options || {};
      var url = settings.apiUrl + '/objects/folders/' + folder.id + '/';
      var postOptions = { headers: options.headers || {} };
      return http.post(url, data, null, postOptions).then(function (res) {
        res.data = utils.extend({}, folder, newFolderProps);
        return res;
      }).catch(toError);
    }
    return {
      create: create,
      update: update
    };
  };
}(utils_mappers, utils_utils, sources_platform_mappers_folder, sources_platform_parsers_error, sources_platform_validators_new_props);
sources_platform_mappers_item = function (TRANSCODING_STATUSES, mappers, utils, getWixThumbnailsUrls) {
  return function (itemData, settings, thumbnailSizes) {
    var normalizeUri = utils.normalizeUri;
    var item = {
      id: itemData.id,
      folderId: itemData.folder || null,
      fileSize: itemData.file_size,
      name: itemData.title,
      mediaType: itemData.media_type,
      fileUrl: utils.get(itemData, 'meta.fileDescriptor.path'),
      fileRefId: utils.get(itemData, 'meta.fileDescriptor.id'),
      createdAt: Date.parse(itemData.created_at),
      //readOnly: itemData.read_only || null,
      labels: utils.get(itemData, 'meta.features.labels', []).map(function (label) {
        return label.name;
      }),
      //tags: utils.splitTags(itemData.tags),
      width: utils.get(itemData, 'meta.basic.width'),
      height: utils.get(itemData, 'meta.basic.height'),
      //fileInfo: itemData.file_info ? mappers.toObject(itemData.file_info) : null,
      //fileInput: itemData.file_input ? mappers.toObject(itemData.file_input) : null,
      //fileOutput: itemData.file_output ? mappers.toObject(itemData.file_output) : null,
      meta: itemData.meta || null,
      transcodingStatus: getTranscodingStatusFromTranscodingJobs(utils.get(itemData, 'meta.videoTranscodingJobs', []))
    };
    function getTranscodingStatusFromTranscodingJobs(transcodingJobs) {
      if (!transcodingJobs.length) {
        return TRANSCODING_STATUSES.IN_QUEUE;
      }
      var firstVideoTranscodingJobStatus = transcodingJobs[0].status;
      if (transcodingJobs.length === 1) {
        return firstVideoTranscodingJobStatus;
      }
      var isAllTranscodingStatusesTheSame = transcodingJobs.some(function (job) {
        return job.status === firstVideoTranscodingJobStatus;
      });
      if (isAllTranscodingStatusesTheSame) {
        return firstVideoTranscodingJobStatus;
      }
      return TRANSCODING_STATUSES.INPROGRESS;
    }
    function getVideoPreviewUrls(item) {
      var videoTranscodingJobs = utils.get(item, 'meta.videoTranscodingJobs');
      if (videoTranscodingJobs && videoTranscodingJobs[0]) {
        var videoOutputs = utils.get(videoTranscodingJobs[0], 'info.outputs.videoOutputs');
        if (videoOutputs && videoOutputs[0] && videoOutputs[0].url) {
          return [settings.filesUrl + videoOutputs[0].url];
        }
      }
      return null;
    }
    if (item.mediaType === 'video') {
      item.thumbnailUrl = normalizeUri(item.fileUrl + '.output/posters/' + item.fileRefId + '002.jpg');
    }
    var sizes = utils.extend({}, settings.thumbnailSizes, thumbnailSizes);
    utils.extend(item, getWixThumbnailsUrls(item, sizes, settings));
    //if (sizes.thumbnail && !item.thumbnailUrl && itemData.icon_url) {
    //  item.thumbnailUrl = normalizeUri(settings.filesUrl + '/' + itemData.icon_url);
    //}
    Object.keys(sizes).forEach(function (thumbType) {
      if (!item[thumbType + 'Url']) {
        item[thumbType + 'Url'] = item.thumbnailUrl;
      }
    });
    Object.keys(item).forEach(function (prop) {
      if (item[prop] === undefined) {
        delete item[prop];
      }
    });
    item.videoPreviewUrls = getVideoPreviewUrls(item);
    return item;
  };
}(constants_transcoding_statuses, utils_mappers, utils_utils, services_thumbnail_generator_get_wix_thumbnails_urls);
sources_platform_items = function (Promise, utils, toItem, toError) {
  return function (settings, http) {
    function mapItemList(res, thumbnailSizes) {
      res.data = (res.data.objects || []).map(function (data) {
        return toItem(data, settings, thumbnailSizes);
      });
      return res;
    }
    var defaultPaging = {
      size: 50,
      cursor: null
    };
    var defaultSort = {
      order: 'date',
      direction: 'desc'
    };
    /**
     * @summary Returns the list of items from the given folder
     * @memberof source.items
     * @param {string} folderId
     * @param {ListSettings} options
     * @returns {Promise}
     * @fulfill {List}
     * @reject {Error}
     */
    function list(folderId, options) {
      options = options || {};
      var sort = utils.extend({}, defaultSort, options.sort);
      var paging = utils.extend({}, defaultPaging, options.paging);
      var queryParams = {
        page_size: paging.size,
        cursor: paging.cursor,
        folder: folderId,
        media_type: options.mediaType || 'picture'
      };
      queryParams.order = sort.direction === 'desc' ? '-' + sort.order : sort.order;
      return http.get(settings.apiUrl + '/objects/items/', queryParams, { headers: options.headers || {} }).then(function (response) {
        response.paging = {
          size: paging.size,
          cursor: response.data.cursor
        };
        return mapItemList(response, options.thumbnails);
      }).catch(toError);
    }
    function removeItem(itemId, options) {
      var queryParams = {};
      if (settings.ns) {
        queryParams.ns = settings.ns;
      }
      var url = settings.apiUrl + '/objects/items/' + itemId + '/delete';
      var postOptions = { headers: options.headers || {} };
      return http.post(url, null, queryParams, postOptions).then(function (res) {
        res.data = { id: itemId };
        return res;
      }).catch(toError);
    }
    /**
     * @summary Removes the items with given ids
     * @memberof source.items
     * @param {Array} itemIds
     * @returns {Array}
     */
    function remove(itemIds, options) {
      options = options || {};
      return itemIds.map(function (itemId) {
        return removeItem(itemId, options);
      });
    }
    /**
     * @summary Return list of items found by tag
     * @memberof source.items
     * @param {string} tag
     * @param {ListSettings} options
     * @returns {Promise}
     * @fulfill {List}
     * @reject {Error}
     */
    function searchByTag(tag, options) {
      options = options || {};
      var sort = utils.extend({}, defaultSort, options.sort);
      var paging = utils.extend({}, defaultPaging, options.paging);
      var queryParams = {
        page_size: paging.size,
        cursor: paging.cursor,
        media_type: options.mediaType || 'picture',
        order: sort.direction === 'desc' ? '-' + sort.order : sort.order
      };
      return http.get(settings.apiUrl + '/files/get?tag=' + tag, queryParams, {
        cache: false,
        headers: options.headers || {}
      }).then(function (response) {
        response.paging = {
          size: paging.size,
          cursor: response.data.cursor
        };
        return mapItemList(response, options.thumbnails);
      }).catch(toError);
    }
    /**
     * @summary Return list of items found by text query
     * @memberof source.items
     * @param {string} folderId
     * @param {string} query
     * @param {ListSettings} options
     * @returns {Promise}
     * @fulfill {List}
     * @reject {Error}
     */
    function search(folderId, query, options) {
      options = options || {};
      var sort = utils.extend({}, defaultSort, options.sort);
      var paging = utils.extend({}, defaultPaging, options.paging);
      query = encodeURIComponent(query);
      var queryParams = {
        query: query,
        page_size: paging.size,
        cursor: paging.cursor,
        media_type: options.mediaType || 'picture',
        folder: folderId,
        order: sort.direction === 'desc' ? '-' + sort.order : sort.order
      };
      return http.get(settings.apiUrl + '/search/items', queryParams, {
        cache: false,
        headers: options.headers || {}
      }).then(function (response) {
        response.paging = {
          size: paging.size,
          cursor: response.data.cursor
        };
        return mapItemList(response, options.thumbnails);
      }).catch(toError);
    }
    return {
      list: list,
      remove: remove,
      searchByTag: searchByTag,
      search: search
    };
  };
}(bluebird_extended, utils_utils, sources_platform_mappers_item, sources_platform_parsers_error);
sources_platform_item = function (Promise, utils, toItem, toError, validateNewProps, mappers, TRANSCODING_STATUSES) {
  var POLLING_TIMEOUT = 15 * 1000;
  var TIMEOUT_BEFORE_REJECT = 10 * 60 * 1000;
  var MIN_FONT_SIZE = 4096;
  return function (settings, http, socket, pollItem) {
    var isPromiseResolved;
    var rejectTimeoutId;
    var funcToUnsubscribe;
    function getFilesSizeLimit(mediaType) {
      return settings.uploadLimits[utils.snakeToCamel(mediaType)];
    }
    function fileSizeIsInvalid(fileSource) {
      return fileSource.file.size >= getFilesSizeLimit(fileSource.mediaType);
    }
    function mapItem(res, thumbnailsSizes) {
      res.data = toItem(res.data, settings, thumbnailsSizes);
      return res;
    }
    function cleanUp() {
      isPromiseResolved = true;
      clearTimeout(rejectTimeoutId);
      socket.off('message', funcToUnsubscribe);
    }
    function resolveItemIdFromSocketMessage(itemIdFromResponse, resolve) {
      return function (message) {
        var itemId = utils.get(message, 'file.file_name');
        if (message.type === 'status_update' && utils.get(message, 'file.op_status') === TRANSCODING_STATUSES.READY && itemId === itemIdFromResponse) {
          resolve(itemId);
        }
      };
    }
    function checkItemStatus(itemId, resolve) {
      setTimeout(function () {
        if (isPromiseResolved) {
          return;
        }
        get(itemId).then(function (response) {
          if (utils.get(response, 'data.transcodingStatus') !== TRANSCODING_STATUSES.READY) {
            return Promise.reject();
          }
          resolve(itemId);
        }).catch(function () {
          checkItemStatus(itemId, resolve);
        });
      }, POLLING_TIMEOUT);
    }
    function resolveItemIdFromResponse(itemId) {
      return new Promise(function (resolve, reject) {
        if (!itemId) {
          reject();
          return;
        }
        checkItemStatus(itemId, resolve);
      });
    }
    function waitForItemFromStorage(response) {
      isPromiseResolved = false;
      var itemId = utils.get(response, 'data.payload.file_name') || utils.get(response, 'data.file_name');
      var resolveItemIdFromSocket = new Promise(function (resolve) {
        funcToUnsubscribe = resolveItemIdFromSocketMessage(itemId, resolve);
        socket.on('message', funcToUnsubscribe);
      });
      var rejectNotReadyItem = new Promise(function (resolve, reject) {
        rejectTimeoutId = setTimeout(function () {
          reject({
            status: 406,
            data: { message: 'Not ready item' }
          });
        }, TIMEOUT_BEFORE_REJECT);
      });
      return Promise.race([
        resolveItemIdFromSocket,
        resolveItemIdFromResponse(itemId),
        rejectNotReadyItem
      ]).then(function (itemId) {
        cleanUp();
        return Promise.resolve(itemId);
      }).catch(function (error) {
        cleanUp();
        return Promise.reject(error);
      });
    }
    function getUploadUrl(fileSource) {
      //function getEndpoint(mediaType) {
      //  if (mediaType === 'secure_music') {
      //    return 'music-goods/upload';
      //  } else if (mediaType === 'video') {
      //    return 'video/upload';
      //  }
      //  return 'upload';
      //}
      var file = fileSource.file;
      //var url = settings.apiUrl + '/files/' + getEndpoint(fileSource.mediaType) + '/url';
      var url = settings.apiUrl + '/upload/url';
      var data = {
        media_type: fileSource.mediaType,
        // we just need an extension here
        file_name: file.name.toLowerCase(),
        // file_name: '_.' + file.name.split('.').pop().toLowerCase(),
        file_size: file.size,
        content_type: file.type
      };
      var postOptions = {
        withCredentials: true,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      };
      return http.post(url, data, null, postOptions);
    }
    function uploadByUrl(fileSource, options, skipWaitingItemFromStorage) {
      options = options || {};
      var data = {
        url: utils.normalizeUri(fileSource.url),
        media_type: fileSource.mediaType,
        name: fileSource.name || 'Untitled',
        tags: fileSource.tags ? fileSource.tags.join(',') : null,
        folder: fileSource.folderId || null
      };
      // some sources as Google Drive requires auth headers to allow downloading files via url
      if (fileSource.headers) {
        data.headers = JSON.stringify(fileSource.headers);
      }
      if (fileSource.catalogCallbackUrl) {
        data.cat_callback_url = fileSource.catalogCallbackUrl;
      }
      if (settings.siteMediaToken) {
        data.siteMediaToken = settings.siteMediaToken;
      }
      var apiUrl = settings.apiUrl + '/files/upload/external';
      if (settings.asyncUploadByUrl || skipWaitingItemFromStorage) {
        socket.open();
        var apiUrlAsync = apiUrl + '/async';
        var headers = utils.extend({}, options.headers, { 'Content-Type': 'application/x-www-form-urlencoded' });
        var postOptions = { headers: headers };
        return http.post(apiUrlAsync, data, null, postOptions).then(function (response) {
          if (skipWaitingItemFromStorage) {
            pollItem(response.data.payload.file_name);
            response.data = toItem(response.data.payload, settings);
            return response;
          }
          return waitForItemFromStorage(response).then(get);
        }).catch(toError);
      }
      var uploadPromise = http.get(apiUrl, data, { headers: options.headers || {} }).progress(function (progress) {
        uploadPromise.notify(progress);
      }).then(function (res) {
        return mapItem(res, options.thumbnails);
      });
      return uploadPromise;
    }
    function upload(fileSource, options) {
      options = options || {};
      var mediaType = fileSource.mediaType;
      var data = {
        file: fileSource.file,
        media_type: mediaType
      };
      if (fileSource.catalogCallbackUrl) {
        data.cat_callback_url = fileSource.catalogCallbackUrl;
      }
      if (fileSource.encodingOptions) {
        data.encoding_options = JSON.stringify(fileSource.encodingOptions);
      }
      if (settings.vision) {
        data.vision = settings.vision.join(',');
      }
      if (settings.siteMediaToken) {
        data.siteMediaToken = settings.siteMediaToken;
      }
      if (fileSizeIsInvalid(fileSource)) {
        var limit = utils.bytesToSize(getFilesSizeLimit(fileSource.mediaType));
        var fileSize = utils.bytesToSize(fileSource.file.size);
        return Promise.reject(mappers.toError({
          status: -406,
          statusText: 'Not Acceptable',
          data: {
            error_code: -7752,
            error_description: 'File size ' + fileSize + ' exceeds upload limit of ' + limit,
            error_info: {
              key: 'wmp_error.file_size_exceeded_limit',
              args: [
                fileSize,
                limit
              ]
            }
          }
        }));
      }
      var title = utils.get(fileSource, 'file.name', '');
      var folderId = fileSource.folderId || null;
      var isAsyncFontUploadAllowed = settings.asyncFontUpload;
      var isUploadFont = data.media_type === 'ufont';
      var isBigFile = utils.get(data, 'file.size') > MIN_FONT_SIZE;
      var isAsyncFontUpload = isAsyncFontUploadAllowed && isUploadFont && isBigFile;
      var uploadPromiseChain = getUploadUrl(fileSource).then(function (response) {
        var responseData = response.data;
        data.directory = responseData.path;
        data.uploadToken = responseData.payload.uploadToken;
        if (isAsyncFontUpload) {
          socket.open();
          data.upload_async = true;
        }
        return http.upload(responseData.payload.uploadUrl, data, { headers: options.headers || {} }).progress(function (progress) {
          uploadPromiseChain.notify(progress);
        });
      }).then(function (response) {
        var refId = utils.get(response, 'data.payload') && response.data.payload[0] && response.data.payload[0].id;
        if (!refId) {
          return Promise.reject('No ref id');
        }
        return http.post(settings.apiUrl + '/objects/items/', {
          title: title,
          folder: folderId,
          media_type: mediaType,
          ref_id: refId
        });
      }).then(function (response) {
        response.data = response.data.object;
        // if (isAsyncFontUpload) {
        //   return waitForItemFromStorage(response)
        //     .then(get);
        // }
        // var status = utils.get(response, 'data.op_status');
        // if (settings.asyncTranscoding && status && status !== TRANSCODING_STATUSES.READY) {
        //   socket.open();
        //   pollItem(response.data.file_name);
        // }
        response.data = toItem(response.data, settings);
        return response;
      }).catch(toError);
      return uploadPromiseChain;
    }
    /**
     * @summary Returns item
     * @memberof source.item
     * @param {String} itemId
     * @param {Object} [options]
     * @returns {Promise}
     * @fulfill {Item}
     * @reject {Error}
     */
    function get(itemId, options) {
      options = options || {};
      return http.get(settings.apiUrl + '/files/' + itemId, null, {
        cache: false,
        headers: options.headers || {}
      }).then(function (res) {
        return mapItem(res, options.thumbnails);
      }).catch(toError);
    }
    /**
     * @summary Updates the item with given diff object
     * @memberof source.item
     * @param {Item} item Current item object that should be updated
     * @param {object} newItemProps
     * @param {Object} options
     * @returns {Promise}
     * @fulfill {Item} Modified item object
     * @reject {Error}
     */
    function update(item, newItemProps, options) {
      var arePropsValid = validateNewProps(newItemProps);
      if (arePropsValid.valid === false) {
        return toError(mappers.toError({
          status: -200,
          statusText: 'Internal JS Error',
          data: { message: arePropsValid.message }
        }));
      }
      var data = {};
      if (newItemProps.name) {
        data.title = newItemProps.name;
      }
      if (newItemProps.folderId) {
        data.folder = newItemProps.folderId;
      }
      if (newItemProps.tags) {
        data.tags = newItemProps.tags.join(',');
      }
      options = options || {};
      var url = settings.apiUrl + '/objects/items/' + item.id + '/';
      var postOptions = { headers: options.headers || {} };
      return http.post(url, data, null, postOptions).then(function (res) {
        res.data = utils.extend({}, item, newItemProps);
        return res;
      }).catch(toError);
    }
    return {
      upload: upload,
      uploadByUrl: uploadByUrl,
      get: get,
      update: update
    };
  };
}(bluebird_extended, utils_utils, sources_platform_mappers_item, sources_platform_parsers_error, sources_platform_validators_new_props, utils_mappers, constants_transcoding_statuses);
sources_platform_trash = function (toError) {
  return function (settings, http) {
    /**
     * @summary Remove all items in trash
     * @memberof source.trash
     * @param options
     * @returns {Promise}
     * @reject {Error}
     */
    function remove(options) {
      var url = settings.apiUrl + '/trash/delete';
      var data = {
        media_type: options.mediaType || 'picture',
        all_files: true
      };
      return http.post(url, data).catch(toError);
    }
    /**
     * @summary Restore all items in trash
     * @memberof source.trash
     * @param options
     * @returns {Promise}
     * @reject {Error}
     */
    function restore(options) {
      var url = settings.apiUrl + '/trash/restore';
      var data = {
        media_type: options.mediaType || 'picture',
        all_files: true
      };
      return http.post(url, data).catch(toError);
    }
    return {
      remove: remove,
      restore: restore
    };
  };
}(sources_platform_parsers_error);
sources_platform_itemstrash = function (Promise, utils, toItem, toError) {
  return function (settings, http) {
    function mapItemList(res, thumbnailSizes) {
      res.data = (res.data.trash_files || []).map(function (_item) {
        var item = toItem(_item, settings, thumbnailSizes);
        item.isInTrash = true;
        return item;
      });
      return res;
    }
    var defaultPaging = {
      size: 50,
      cursor: null
    };
    var defaultSort = {
      order: 'date',
      direction: 'desc'
    };
    function list(folderId, options) {
      options = options || {};
      var sort = utils.extend({}, defaultSort, options.sort);
      var paging = utils.extend({}, defaultPaging, options.paging);
      var queryParams = {
        page_size: paging.size,
        cursor: paging.cursor,
        parent_folder_id: folderId,
        media_type: options.mediaType || 'picture'
      };
      queryParams.order = sort.direction === 'desc' ? '-' + sort.order : sort.order;
      return http.get(settings.apiUrl + '/files/getpage/trash', queryParams, { headers: options.headers || {} }).then(function (response) {
        response.paging = {
          size: paging.size,
          cursor: response.data.cursor
        };
        return mapItemList(response, options.thumbnails);
      }).catch(toError);
    }
    function removeItem(itemId, options) {
      var url = settings.apiUrl + '/trash/files/' + itemId + '/delete';
      var postOptions = { headers: options.headers || {} };
      return http.post(url, null, null, postOptions).then(function (res) {
        res.data = { id: itemId };
        return res;
      }).catch(toError);
    }
    function remove(itemIds, options) {
      options = options || {};
      return itemIds.map(function (itemId) {
        return removeItem(itemId, options);
      });
    }
    function restoreItem(itemId, options) {
      var url = settings.apiUrl + '/trash/files/' + itemId + '/restore';
      var postOptions = { headers: options.headers || {} };
      return http.post(url, null, null, postOptions).then(function (res) {
        res.data = { id: itemId };
        return res;
      }).catch(toError);
    }
    /**
     * Restore items from trash
     * @param itemIds
     * @param options
     * @returns [Promise] Array of Promise
     */
    function restore(itemIds, options) {
      options = options || {};
      return itemIds.map(function (itemId) {
        return restoreItem(itemId, options);
      });
    }
    return {
      list: list,
      remove: remove,
      restore: restore
    };
  };
}(bluebird_extended, utils_utils, sources_platform_mappers_item, sources_platform_parsers_error);
sources_platform_itemssite_media = function (Promise, utils, toItem, toError) {
  return function (settings, http) {
    function mapItemList(res, thumbnailSizes) {
      res.data = (res.data.files || []).map(function (_item) {
        var item = toItem(_item, settings, thumbnailSizes);
        item.isInSiteMedia = true;
        return item;
      });
      return res;
    }
    var defaultPaging = {
      size: 50,
      cursor: null
    };
    var defaultSort = {
      order: 'date',
      direction: 'desc'
    };
    function list(folderId, options) {
      options = options || {};
      var sort = utils.extend({}, defaultSort, options.sort);
      var paging = utils.extend({}, defaultPaging, options.paging);
      var queryParams = {
        page_size: paging.size,
        cursor: paging.cursor,
        parent_folder_id: folderId,
        media_type: options.mediaType || 'picture',
        siteMediaToken: settings.siteMediaToken
      };
      queryParams.order = sort.direction === 'desc' ? '-' + sort.order : sort.order;
      return http.get(settings.apiUrl + '/files/getpage/site', queryParams, { headers: options.headers || {} }).then(function (response) {
        response.paging = {
          size: paging.size,
          cursor: response.data.cursor
        };
        return mapItemList(response, options.thumbnails);
      }).catch(toError);
    }
    function removeItem(itemId, options) {
      var data = { files: [itemId] };
      var url = settings.apiUrl + '/files/site/remove?siteMediaToken=' + settings.siteMediaToken;
      var postOptions = { headers: options.headers || {} };
      return http.post(url, data, null, postOptions).then(function (res) {
        res.data = { id: itemId };
        return res;
      }).catch(toError);
    }
    /**
     * Remove items from siteMedia
     * @param itemIds Array of item ids
     * @param options
     * @returns [Promise] Array of Promise
     */
    function remove(itemIds, options) {
      options = options || {};
      return itemIds.map(function (itemId) {
        return removeItem(itemId, options);
      });
    }
    /**
     * Add items to siteMedia
     * @param itemIds Array of item ids
     * @param options
     * @returns Promise
     */
    function add(itemIds, options) {
      options = options || {};
      var data = { files: itemIds };
      var url = settings.apiUrl + '/files/site/add?siteMediaToken=' + settings.siteMediaToken;
      var postOptions = { headers: options.headers || {} };
      return http.post(url, data, null, postOptions).catch(toError);
    }
    return {
      list: list,
      remove: remove,
      add: add
    };
  };
}(bluebird_extended, utils_utils, sources_platform_mappers_item, sources_platform_parsers_error);
sources_platform_folderstrash = function (Promise, utils, toFolder, toError) {
  return function (settings, http) {
    function mapFolderList(res) {
      res.data = (res.data.trash_folders || []).map(function (_folder) {
        var folder = toFolder(_folder);
        folder.isInTrash = true;
        return folder;
      });
      return res;
    }
    function list(folderId, options) {
      options = options || {};
      var queryParams = {
        media_type: options.mediaType || 'picture',
        folder_id: folderId || null,
        trash_type: 'folder'
      };
      return http.get(settings.apiUrl + '/files/getpage/trash', queryParams, { headers: options.headers || {} }).then(mapFolderList).catch(toError);
    }
    function removeFolder(folderId, options) {
      var url = settings.apiUrl + '/trash/folders/' + folderId + '/delete';
      var postOptions = { headers: options.headers || {} };
      return http.post(url, null, null, postOptions).then(function (res) {
        res.data = { id: folderId };
        return res;
      }).catch(toError);
    }
    function remove(folderIds, options) {
      options = options || {};
      return folderIds.map(function (folderId) {
        return removeFolder(folderId, options);
      });
    }
    function restoreFolder(folderId, options) {
      var url = settings.apiUrl + '/trash/folders/' + folderId + '/restore';
      var postOptions = { headers: options.headers || {} };
      return http.post(url, null, null, postOptions).then(function (res) {
        res.data = { id: folderId };
        return res;
      }).catch(toError);
    }
    function restore(folderIds, options) {
      options = options || {};
      return folderIds.map(function (folderId) {
        return restoreFolder(folderId, options);
      });
    }
    return {
      list: list,
      remove: remove,
      restore: restore
    };
  };
}(bluebird_extended, utils_utils, sources_platform_mappers_folder, sources_platform_parsers_error);
sources_platform_settings = {
  apiUrl: '//files.wix.com',
  imageOperationsApi: 'vangogh',
  filesUrl: '//static.wixstatic.com',
  videoFilesUrl: '//video.wixstatic.com',
  refreshTokenUrl: null,
  requestOptions: { withCredentials: true },
  uploadLimits: {
    default: 15728640,
    document: 15728640,
    picture: 15728640,
    music: 52428800,
    secureMusic: 377487360,
    video: 524288000,
    secureVideo: 1610612736
  },
  thumbnailSizes: {
    thumbnail: {
      width: 210,
      height: 210,
      mode: 'fill'
    },
    preview: {
      width: 375,
      height: 375,
      mode: 'fit'
    },
    original: {
      width: 1000,
      height: 1000,
      mode: 'fit'
    }
  },
  channel: {
    withCredentials: true,
    jsapiUrl: '/_ah/channel/jsapi',
    tokenUrl: '/users/channel'
  },
  blackArrow: {
    enabled: false,
    wsUrl: 'wss://ws.wixmp.com/ws',
    messageUrl: 'https://ws.wixmp.com/message',
    tokenUrl: '/get-batoken'
  },
  asyncFontUpload: false,
  asyncUploadByUrl: false,
  asyncTranscoding: false,
  videoPreviewQuality: '480p'
};
sources_platform_Platform = function (initFolders, initFolder, initItems, initItem, initTrash, initItemsTrash, initItemsSiteMedia, initFoldersTrash, itemMapper, defaultSettings, utils, decorators, eventsList, initBlackArrow, initHttp, initPolling) {
  return function (userSettings) {
    var settings = utils.extendDeep({}, defaultSettings, userSettings);
    var requestOptions = settings.requestOptions;
    var http = initHttp(requestOptions);
    var blackArrow = initBlackArrow(settings, this, itemMapper, requestOptions);
    var polling = initPolling(settings, this, itemMapper, http);
    var folders = initFolders(settings, http);
    var folder = initFolder(settings, http);
    var items = initItems(settings, http);
    var item = initItem(settings, http, blackArrow, polling);
    var trash = initTrash(settings, http);
    var itemsTrash = initItemsTrash(settings, http);
    var itemsSiteMedia = initItemsSiteMedia(settings, http);
    var foldersTrash = initFoldersTrash(settings, http);
    folders.trash = foldersTrash;
    items.trash = itemsTrash;
    items.siteMedia = itemsSiteMedia;
    this.name = 'platform';
    this.folders = decorators.addEvents(this, eventsList.FOLDERS, folders);
    this.folder = decorators.addEvents(this, eventsList.FOLDER, folder);
    this.item = decorators.addEvents(this, eventsList.ITEM, item);
    this.items = decorators.addEvents(this, eventsList.ITEMS, items);
    this.trash = decorators.addEvents(this, eventsList.TRASH, trash);
    this.blackArrow = blackArrow;
  };
}(sources_platform_folders, sources_platform_folder, sources_platform_items, sources_platform_item, sources_platform_trash, sources_platform_itemstrash, sources_platform_itemssite_media, sources_platform_folderstrash, sources_platform_mappers_item, sources_platform_settings, utils_utils, sources_decorators, events_list, services_channel_black_arrow, utils_http, services_polling);
sources_picasa_settings = {
  apiUrl: '//pix.wix.com/services/google',
  foldersLimit: 500,
  itemsLimit: 50
};
sources_picasa_mappers_folder = function (data) {
  return {
    id: data.gphoto$id.$t,
    name: data.title.$t,
    mediaType: 'picture',
    thumbnailUrl: data.media$group.media$thumbnail[0].url,
    parentId: null,
    filesCount: data.gphoto$numphotos.$t,
    createdAt: data.published.$t
  };
};
sources_picasa_parsers_folders = function (toFolder) {
  return function (res) {
    res.data = (res.data.feed.entry || []).map(toFolder);
    return res;
  };
}(sources_picasa_mappers_folder);
sources_picasa_parsers_error = function (Promise) {
  return function (response) {
    return Promise.reject(response);
  };
}(bluebird_extended);
sources_picasa_folders = function (mapFolderList, toError) {
  return function (settings, http) {
    function list(folderId, options) {
      options = options || {};
      options.paging = options.paging || {};
      var requestOptions = {
        thumbsize: '150c',
        'max-results': options.paging.size || settings.foldersLimit,
        'start-index': options.paging.cursor || 1
      };
      return http.get(settings.apiUrl + '/albums', requestOptions, {
        withCredentials: true,
        headers: options.headers || {}
      }).then(mapFolderList).catch(toError);
    }
    return { list: list };
  };
}(sources_picasa_parsers_folders, sources_picasa_parsers_error);
sources_picasa_mappers_item = function (utils) {
  function getLastImage(mediaGroup) {
    var images = mediaGroup.media$thumbnail.filter(function (item) {
      return !item.medium || item.medium !== 'video';
    });
    return images[images.length - 1].url || '';
  }
  return function (data) {
    var lastImage, width, height, bigImage, preview;
    lastImage = getLastImage(data.media$group);
    width = Number(data.gphoto$width.$t || 1024);
    height = Number(data.gphoto$height.$t || 768);
    // hack. API does not provide really full images
    // w1024-h768-no is used by google at slideshows
    bigImage = lastImage.replace(/\/s[0-9]+/, '/w' + width + '-h' + height + '-no');
    // sizes: 128, 200, 220, 288, 320, 400, 512, 576, 640, 720, 800, 912, 1024, 1152, 1280, 1440, 1600
    if (width > 400) {
      preview = lastImage.replace(/\/s[0-9]+(-c)?/, '/s400');
    } else {
      preview = bigImage;
    }
    return {
      id: data.id.$t,
      name: data.summary.$t || data.title.$t,
      mediaType: 'picture',
      fileUrl: utils.normalizeUri(bigImage),
      thumbnailUrl: utils.normalizeUri(lastImage),
      previewUrl: utils.normalizeUri(preview),
      createdAt: data.published.$t,
      tags: [],
      width: width,
      height: height
    };
  };
}(utils_utils);
sources_picasa_parsers_items = function (toItem) {
  return function (res) {
    var paging = {
      cursor: res.data.feed.openSearch$startIndex.$t + res.data.feed.openSearch$itemsPerPage.$t,
      size: res.data.feed.openSearch$itemsPerPage.$t
    };
    res.data = (res.data.feed.entry || []).map(toItem);
    res.paging = paging;
    return res;
  };
}(sources_picasa_mappers_item);
sources_picasa_items = function (mapItemList, toError) {
  return function (settings, http) {
    function list(folderId, options) {
      options = options || {};
      options.paging = options.paging || {};
      var requestOptions = {
        album_id: folderId || null,
        kind: 'photo',
        thumbsize: '150c',
        'max-results': options.paging.size || settings.itemsLimit,
        'start-index': options.paging.cursor || 1
      };
      return http.get(settings.apiUrl + '/photos', requestOptions, {
        withCredentials: true,
        headers: options.headers || {}
      }).then(mapItemList).catch(toError);
    }
    return { list: list };
  };
}(sources_picasa_parsers_items, sources_picasa_parsers_error);
sources_picasa_Picasa = function (settings, initFolders, initItems, initHttp, decorators, eventsList) {
  return function () {
    var http = initHttp();
    var folders = initFolders(settings, http);
    var items = initItems(settings, http);
    this.name = 'picasa';
    // rename picasa google photos
    this.translationKey = 'google-photos';
    this.folders = decorators.addEvents(this, eventsList.FOLDERS, folders);
    this.items = decorators.addEvents(this, eventsList.ITEMS, items);
  };
}(sources_picasa_settings, sources_picasa_folders, sources_picasa_items, utils_http, sources_decorators, events_list);
sources_drive_settings = {
  apiUrl: '//pix.wix.com/services/gdrive',
  foldersLimit: 500,
  itemsLimit: 50
};
sources_drive_mappers_folder = function (data) {
  return {
    id: data.id,
    name: data.title,
    mediaType: 'picture',
    //thumbnailUrl: data.iconLink,
    parentId: data.parents[0].id,
    filesCount: 1,
    //data.gphoto$numphotos.$t,
    createdAt: data.createdDate
  };
};
sources_drive_parsers_folders = function (toFolder) {
  return function (res) {
    res.data = (res.data.items || []).map(toFolder);
    return res;
  };
}(sources_drive_mappers_folder);
sources_drive_parsers_error = function (Promise) {
  return function (response) {
    return Promise.reject(response);
  };
}(bluebird_extended);
sources_drive_folders = function (mapFolderList, toError) {
  return function (settings, http) {
    function list(folderId, options) {
      options = options || {};
      options.paging = options.paging || {};
      var requestOptions = {
        'max-results': options.paging.size || settings.foldersLimit,
        'start-index': options.paging.cursor || 1
      };
      if (folderId) {
        requestOptions.album_id = folderId;
      }
      return http.get(settings.apiUrl + '/albums', requestOptions, { withCredentials: true }).then(mapFolderList).catch(toError);
    }
    return { list: list };
  };
}(sources_drive_parsers_folders, sources_drive_parsers_error);
sources_drive_mappers_item = function (utils) {
  return function (data) {
    return {
      id: data.id,
      name: data.title,
      mediaType: 'picture',
      fileUrl: utils.normalizeUri(data.fixedDownloadUrl || data.webContentLink),
      thumbnailUrl: data.thumbnailLink ? utils.normalizeUri(data.thumbnailLink) : null,
      previewUrl: data.thumbnailLink ? utils.normalizeUri(data.thumbnailLink) : null,
      createdAt: data.createdDate,
      tags: [],
      width: data.imageMediaMetadata.width,
      height: data.imageMediaMetadata.height
    };
  };
}(utils_utils);
sources_drive_parsers_items = function (toItem) {
  return function (res) {
    res.data = (res.data.items || []).map(toItem);
    res.paging = {};
    return res;
  };
}(sources_drive_mappers_item);
sources_drive_items = function (mapItemList, toError) {
  return function (settings, http) {
    function list(folderId, options) {
      options = options || {};
      options.paging = options.paging || {};
      var requestOptions = {
        album_id: folderId || null,
        'max-results': options.paging.size || settings.itemsLimit,
        'start-index': options.paging.cursor || 1
      };
      return http.get(settings.apiUrl + '/photos', requestOptions, { withCredentials: true }).then(mapItemList, toError);
    }
    return { list: list };
  };
}(sources_drive_parsers_items, sources_drive_parsers_error);
sources_drive_Drive = function (settings, initFolders, initItems, initHttp, decorators, eventsList) {
  return function () {
    var http = initHttp();
    var folders = initFolders(settings, http);
    var items = initItems(settings, http);
    this.name = 'drive';
    this.folders = decorators.addEvents(this, eventsList.FOLDERS, folders);
    this.items = decorators.addEvents(this, eventsList.ITEMS, items);
  };
}(sources_drive_settings, sources_drive_folders, sources_drive_items, utils_http, sources_decorators, events_list);
sources_dropbox_settings = {
  apiUrl: '//pix.wix.com/services/dropbox2',
  foldersLimit: 500,
  itemsLimit: 50
};
sources_dropbox_mappers_folder = function (data) {
  return {
    id: data.path_lower,
    name: data.name,
    mediaType: 'picture',
    parentId: null,
    filesCount: 1,
    createdAt: null
  };
};
sources_dropbox_parsers_folders = function (toFolder) {
  function isFolder(e) {
    return e['.tag'] == 'folder';
  }
  return function (res) {
    res.data = (res.data.entries || []).filter(isFolder).map(toFolder);
    return res;
  };
}(sources_dropbox_mappers_folder);
sources_dropbox_parsers_error = function (Promise) {
  return function (response) {
    return Promise.reject(response);
  };
}(bluebird_extended);
sources_dropbox_folders = function (mapFolderList, toError) {
  return function (settings, http) {
    function list(folderId, options) {
      options = options || {};
      options.paging = options.paging || {};
      var requestOptions = {};
      if (folderId) {
        requestOptions.album_id = folderId;
      }
      return http.get(settings.apiUrl + '/albums', requestOptions, { withCredentials: true }).then(mapFolderList).catch(toError);
    }
    return { list: list };
  };
}(sources_dropbox_parsers_folders, sources_dropbox_parsers_error);
sources_dropbox_mappers_item = function (data) {
  function encodePath(uriComponent) {
    return encodeURIComponent(uriComponent).replace('\'', '%27');
  }
  return {
    id: data.path_lower,
    name: data.name,
    mediaType: 'picture',
    fileUrl: data.url,
    thumbnailUrl: '//pix.wix.com/services/dropbox2/thumbnail?path=' + encodePath(data.path_lower),
    previewUrl: '//pix.wix.com/services/dropbox2/thumbnail?path=' + encodePath(data.path_lower) + '&size=w640h480',
    createdAt: data.client_modified,
    tags: []
  };
};
sources_dropbox_parsers_items = function (utils, toItem) {
  function isImage(item) {
    var name = item.name.toLowerCase();
    return item['.tag'] === 'file' && (utils.endsWith(name, '.jpg') || utils.endsWith(name, '.jpeg') || utils.endsWith(name, '.png') || utils.endsWith(name, '.gif'));
  }
  return function (res) {
    var paging = { cursor: res.data.has_more ? res.data.cursor : null };
    res.data = utils.get(res, 'data.entries', []).filter(isImage).map(toItem);
    res.paging = paging;
    return res;
  };
}(utils_utils, sources_dropbox_mappers_item);
sources_dropbox_items = function (mapItemList, toError) {
  return function (settings, http) {
    function list(folderId, options) {
      options = options || {};
      options.paging = options.paging || {};
      var requestOptions = {
        album_id: folderId || null,
        cursor: options.paging.cursor || null
      };
      return http.get(settings.apiUrl + '/photos', requestOptions, { withCredentials: true }).then(mapItemList, toError);
    }
    return { list: list };
  };
}(sources_dropbox_parsers_items, sources_dropbox_parsers_error);
sources_dropbox_Dropbox = function (settings, initFolders, initItems, initHttp, decorators, eventsList) {
  return function () {
    var http = initHttp();
    var folders = initFolders(settings, http);
    var items = initItems(settings, http);
    this.name = 'dropbox';
    this.folders = decorators.addEvents(this, eventsList.FOLDERS, folders);
    this.items = decorators.addEvents(this, eventsList.ITEMS, items);
  };
}(sources_dropbox_settings, sources_dropbox_folders, sources_dropbox_items, utils_http, sources_decorators, events_list);
sources_instagram_settings = {
  apiUrl: '//pix.wix.com/services/instagram',
  api2Url: '//pix.wix.com/services/instagram2',
  itemsLimit: 50
};
sources_instagram_mappers_folder = function (data) {
  return {
    id: 'Instagram',
    name: 'Instagram',
    mediaType: 'picture',
    parentId: null,
    filesCount: data.counts.media,
    createdAt: null
  };
};
sources_instagram_parsers_folders = function (toFolder) {
  return function (data) {
    return { data: [toFolder(data)] };
  };
}(sources_instagram_mappers_folder);
sources_instagram_parsers_error = function (Promise) {
  return function (response) {
    if (response.code === 500) {
      response.code = 403;
      response.data = {
        message: 'Unauthorized',
        result: 'error'
      };
    }
    return Promise.reject(response);
  };
}(bluebird_extended);
sources_instagram_folders = function (toFolders, toError) {
  return function (settings, http) {
    function successHandler(response) {
      return toFolders(response.data);
    }
    function list(folderId, options) {
      options = options || {};
      return http.get(settings.apiUrl + '/user', null, {
        withCredentials: true,
        headers: options.headers || {}
      }).then(successHandler).catch(toError);
    }
    return { list: list };
  };
}(sources_instagram_parsers_folders, sources_instagram_parsers_error);
sources_instagram_mappers_item = function (utils) {
  return function (data) {
    if (!data.caption) {
      data.caption = { text: '' };
    }
    return {
      id: data.id,
      name: data.caption.text,
      mediaType: 'picture',
      fileUrl: utils.normalizeUri(data.images.standard_resolution.url),
      thumbnailUrl: utils.normalizeUri(data.images.low_resolution.url),
      previewUrl: utils.normalizeUri(data.images.standard_resolution.url),
      createdAt: Number(data.created_time) * 1000,
      tags: utils.splitTags(data.tags),
      width: data.images.standard_resolution.width,
      height: data.images.standard_resolution.height
    };
  };
}(utils_utils);
sources_instagram_parsers_items = function (toItem) {
  return function (res) {
    res.data.next = res.data.next || {};
    var cursor = res.data.next.max_id || null;
    var size = res.data.next.count || null;
    res.data = (res.data.photos || []).map(toItem);
    res.paging = {
      cursor: cursor,
      size: size
    };
    return res;
  };
}(sources_instagram_mappers_item);
sources_instagram_items = function (mapItemList, toError) {
  return function (settings, http) {
    function list(folderId, options) {
      options = options || {};
      options.paging = options.paging || {};
      var requestOptions = {
        count: options.paging.size || settings.itemsLimit,
        max_id: options.paging.cursor || null
      };
      return http.get(settings.api2Url + '/photos', requestOptions, {
        withCredentials: true,
        headers: options.headers || {}
      }).then(mapItemList).catch(toError);
    }
    return { list: list };
  };
}(sources_instagram_parsers_items, sources_instagram_parsers_error);
sources_instagram_Instagram = function (settings, initFolders, initItems, initHttp, decorators, eventsList) {
  return function () {
    var http = initHttp();
    var folders = initFolders(settings, http);
    var items = initItems(settings, http);
    this.name = 'instagram';
    this.folders = decorators.addEvents(this, eventsList.FOLDERS, folders);
    this.items = decorators.addEvents(this, eventsList.ITEMS, items);
  };
}(sources_instagram_settings, sources_instagram_folders, sources_instagram_items, utils_http, sources_decorators, events_list);
sources_instagram_video_settings = {
  apiUrl: '//pix.wix.com/services/instagram2',
  itemsLimit: 50,
  thumbnailSizes: {
    thumbnail: {
      width: 210,
      height: 210,
      mode: 'fill'
    },
    preview: {
      width: 375,
      height: 375,
      mode: 'fit'
    }
  }
};
sources_instagram_video_mappers_folder = function () {
  return {
    id: 'InstagramVideo',
    name: 'InstagramVideo',
    mediaType: 'video',
    parentId: null,
    filesCount: null,
    createdAt: null
  };
};
sources_instagram_video_parsers_folders = function (toFolder) {
  return function () {
    return { data: [toFolder()] };
  };
}(sources_instagram_video_mappers_folder);
sources_instagram_video_folders = function (toFolders, Promise) {
  return function () {
    function list() {
      return Promise.resolve(toFolders());
    }
    return { list: list };
  };
}(sources_instagram_video_parsers_folders, bluebird_extended);
sources_instagram_video_mappers_item = function (utils) {
  return function (settings, data) {
    var item = {
      id: data.id,
      name: utils.replaceHtml(data.caption ? data.caption.text : data.id),
      fileName: data.id,
      previewUrl: data.images.thumbnail.url,
      thumbnailUrl: data.images.thumbnail.url,
      videoPreviewUrl: [data.videos.standard_resolution.url],
      embedHtml: '<video controls width="' + data.videos.standard_resolution.width + '" height="' + data.videos.standard_resolution.height + '" poster="' + data.images.thumbnail.url + '"><source src="' + data.videos.standard_resolution.url + '" type="video/mp4" /></video>',
      width: Number(data.videos.standard_resolution.width),
      height: Number(data.videos.standard_resolution.height),
      createdAt: Number(data.created_time),
      externalSources: {
        videos: data.videos,
        images: data.images
      },
      folderId: null,
      mediaType: 'video'
    };
    if (!data.format) {
      return item;
    }
    var availableThumbnailsSizes = data.format.map(function (pictureSize) {
      return utils.extend({}, pictureSize, { url: pictureSize.picture });
    });
    var urls = utils.getThumbnailsUrlsFromList(availableThumbnailsSizes, settings.thumbnailSizes);
    return utils.extend(item, urls);
  };
}(utils_utils);
sources_instagram_video_parsers_items = function (toItem, utils) {
  return function (settings, res) {
    var cursor = null;
    var size = null;
    if (res.data.paging && res.data.paging.cursors && res.data.paging.cursors.after && res.data.paging.next) {
      cursor = res.data.paging.cursors.after;
      size = Number(utils.getParameterByName(res.data.paging.next, 'limit'));
    }
    res.data = (res.data.videos || []).map(utils.partial(toItem, settings));
    res.paging = {
      cursor: cursor,
      size: size
    };
    return res;
  };
}(sources_instagram_video_mappers_item, utils_utils);
sources_instagram_video_parsers_error = function (Promise) {
  return function (response) {
    return Promise.reject(response);
  };
}(bluebird_extended);
sources_instagram_video_items = function (utils, mapItemList, toError) {
  return function (settings, http) {
    function list(folderId, options) {
      options = options || {};
      options.paging = options.paging || {};
      var optionsThumbnailSizes = options.thumbnailSizes ? { thumbnailSizes: options.thumbnailSizes } : {};
      var listSettings = utils.merge({}, settings, optionsThumbnailSizes);
      var requestOptions = {
        limit: options.paging.size || settings.itemsLimit,
        after: options.paging.cursor || null
      };
      return http.get(settings.apiUrl + '/videos', requestOptions, {
        withCredentials: true,
        headers: options.headers || {}
      }).then(utils.partial(mapItemList, listSettings)).catch(toError);
    }
    return { list: list };
  };
}(utils_utils, sources_instagram_video_parsers_items, sources_instagram_video_parsers_error);
sources_instagram_video_InstagramVideo = function (defaultSettings, initFolders, initItems, initHttp, decorators, eventsList, utils) {
  return function (settings) {
    settings = utils.extend({}, defaultSettings, settings);
    var http = initHttp();
    var folders = initFolders(settings, http);
    var items = initItems(settings, http);
    this.name = 'instagramVideo';
    this.folders = decorators.addEvents(this, eventsList.FOLDERS, folders);
    this.items = decorators.addEvents(this, eventsList.ITEMS, items);
  };
}(sources_instagram_video_settings, sources_instagram_video_folders, sources_instagram_video_items, utils_http, sources_decorators, events_list, utils_utils);
sources_facebook_settings = {
  apiUrl: '//pix.wix.com/services/facebook2',
  foldersLimit: 50,
  itemsLimit: 50
};
sources_facebook_mappers_folder = function (utils) {
  return function (data, settings) {
    return {
      id: data.id,
      name: data.name,
      mediaType: 'picture',
      parentId: null,
      thumbnailUrl: utils.normalizeUri(settings.apiUrl + '/picture?type=album&album_id=' + data.id),
      filesCount: data.count,
      createdAt: data.created_time
    };
  };
}(utils_utils);
sources_facebook_parsers_folders = function (toFolder) {
  return function (settings, res) {
    res.data = (res.data.data || []).map(function (data) {
      return toFolder(data, settings);
    });
    return res;
  };
}(sources_facebook_mappers_folder);
sources_facebook_parsers_error = function (Promise) {
  return function (response) {
    if (response.code === 400 && response.data && response.data.code === 190) {
      response.code = 403;
    }
    return Promise.reject(response);
  };
}(bluebird_extended);
sources_facebook_folders = function (utils, mapFolderList, toError) {
  return function (settings, http) {
    function list(folderID, options) {
      options = options || {};
      options.paging = options.paging || {};
      var requestOptions = {
        limit: options.paging.size || settings.foldersLimit,
        after: options.paging.cursor || null
      };
      return http.get(settings.apiUrl + '/albums', requestOptions, {
        withCredentials: true,
        headers: options.headers || {}
      }).then(utils.partial(mapFolderList, settings)).catch(toError);
    }
    return { list: list };
  };
}(utils_utils, sources_facebook_parsers_folders, sources_facebook_parsers_error);
sources_facebook_mappers_item = function (utils) {
  function findThumbnailUrl(images, minWidth, minHeight) {
    minHeight = minHeight || 190;
    minWidth = minWidth || 190;
    var bigImages, biggestImage, smallestImage;
    if (images.length === 1) {
      return images[0].source;
    }
    bigImages = images.filter(function (image) {
      return image.width > minWidth && image.height > minHeight;
    });
    smallestImage = utils.min(bigImages, function (image) {
      return image.width + image.height;
    });
    if (smallestImage) {
      return smallestImage.source;
    }
    biggestImage = utils.max(images, function (image) {
      return image.width + image.height;
    });
    return biggestImage.source;
  }
  return function (data) {
    return {
      id: data.id,
      folderId: null,
      name: data.name || '',
      mediaType: 'picture',
      fileUrl: utils.normalizeUri(data.source),
      thumbnailUrl: utils.normalizeUri(findThumbnailUrl(data.images)),
      previewUrl: utils.normalizeUri(data.source),
      createdAt: data.created_time,
      tags: [],
      width: data.width,
      height: data.height
    };
  };
}(utils_utils);
sources_facebook_parsers_items = function (toItem) {
  return function (res) {
    var cursor;
    if (res.data.paging && res.data.paging.cursors) {
      cursor = res.data.paging.cursors.after;
    }
    res.data = (res.data.data || []).map(toItem);
    res.paging = {
      cursor: cursor || null,
      size: null
    };
    return res;
  };
}(sources_facebook_mappers_item);
sources_facebook_items = function (mapItemList, toError) {
  return function (settings, http) {
    function list(folderId, options) {
      options = options || {};
      options.paging = options.paging || {};
      var requestOptions = {
        album_id: folderId,
        limit: options.paging.size || settings.itemsLimit,
        after: options.paging.cursor || null
      };
      return http.get(settings.apiUrl + '/photos', requestOptions, {
        withCredentials: true,
        headers: options.headers || {}
      }).then(mapItemList).catch(toError);
    }
    return { list: list };
  };
}(sources_facebook_parsers_items, sources_facebook_parsers_error);
sources_facebook_Facebook = function (settings, initFolders, initItems, initHttp, decorators, eventsList) {
  return function () {
    var http = initHttp();
    var folders = initFolders(settings, http);
    var items = initItems(settings, http);
    this.name = 'facebook';
    this.folders = decorators.addEvents(this, eventsList.FOLDERS, folders);
    this.items = decorators.addEvents(this, eventsList.ITEMS, items);
  };
}(sources_facebook_settings, sources_facebook_folders, sources_facebook_items, utils_http, sources_decorators, events_list);
sources_facebook_video_settings = {
  apiUrl: '//pix.wix.com/services/facebook2',
  itemsLimit: 50,
  thumbnailSizes: {
    thumbnail: {
      width: 210,
      height: 210,
      mode: 'fill'
    },
    preview: {
      width: 375,
      height: 375,
      mode: 'fit'
    }
  }
};
sources_facebook_video_mappers_folder = function () {
  return {
    id: 'FacebookVideo',
    name: 'FacebookVideo',
    mediaType: 'video',
    parentId: null,
    filesCount: null,
    createdAt: null
  };
};
sources_facebook_video_parsers_folders = function (toFolder) {
  return function () {
    return { data: [toFolder()] };
  };
}(sources_facebook_video_mappers_folder);
sources_facebook_video_folders = function (toFolders, Promise) {
  return function () {
    function list() {
      return Promise.resolve(toFolders());
    }
    return { list: list };
  };
}(sources_facebook_video_parsers_folders, bluebird_extended);
sources_facebook_video_mappers_item = function (utils) {
  return function (settings, data) {
    function getAttribute(htmlElement, attributeName) {
      var regex = new RegExp(attributeName + '="(.+?)"', 'i');
      var res = htmlElement.match(regex);
      return res ? res[1] : '';
    }
    function toTimeStamp(date) {
      var correctDate = date.replace(/([+\-]\d\d)(\d\d)$/, '$1:$2');
      return utils.toTimeStamp(correctDate);
    }
    var item = {
      id: Number(data.id),
      name: utils.replaceHtml(data.title),
      iframeSrc: getAttribute(data.embed_html, 'src'),
      embedHtml: data.embed_html,
      width: Number(getAttribute(data.embed_html, 'width')),
      height: Number(getAttribute(data.embed_html, 'height')),
      createdAt: toTimeStamp(data.created_time),
      folderId: null,
      mediaType: 'video'
    };
    if (!data.format) {
      return item;
    }
    var availableThumbnailsSizes = data.format.map(function (pictureSize) {
      return utils.extend({}, pictureSize, { url: pictureSize.picture });
    });
    var urls = utils.getThumbnailsUrlsFromList(availableThumbnailsSizes, settings.thumbnailSizes);
    return utils.extend(item, urls);
  };
}(utils_utils);
sources_facebook_video_parsers_items = function (toItem, utils) {
  return function (settings, res) {
    var cursor = null;
    var size = null;
    if (res.data.paging && res.data.paging.cursors && res.data.paging.cursors.after && res.data.paging.next) {
      cursor = res.data.paging.cursors.after;
      size = Number(utils.getParameterByName(res.data.paging.next, 'limit'));
    }
    res.data = (res.data.data || []).map(utils.partial(toItem, settings));
    res.paging = {
      cursor: cursor,
      size: size
    };
    return res;
  };
}(sources_facebook_video_mappers_item, utils_utils);
sources_facebook_video_parsers_error = function (Promise) {
  return function (response) {
    return Promise.reject(response);
  };
}(bluebird_extended);
sources_facebook_video_items = function (utils, mapItemList, toError) {
  return function (settings, http) {
    function list(folderId, options) {
      var optionsThumbnailSizes = options.thumbnailSizes ? { thumbnailSizes: options.thumbnailSizes } : {};
      var listSettings = utils.merge({}, settings, optionsThumbnailSizes);
      options = options || {};
      options.paging = options.paging || {};
      var requestOptions = {
        limit: options.paging.size || settings.itemsLimit,
        after: options.paging.cursor || null
      };
      return http.get(settings.apiUrl + '/videos', requestOptions, {
        withCredentials: true,
        headers: options.headers || {}
      }).then(utils.partial(mapItemList, listSettings)).catch(toError);
    }
    return { list: list };
  };
}(utils_utils, sources_facebook_video_parsers_items, sources_facebook_video_parsers_error);
sources_facebook_video_FacebookVideo = function (defaultSettings, initFolders, initItems, initHttp, decorators, eventsList, utils) {
  return function (userSettings) {
    var settings = utils.extend({}, defaultSettings, userSettings);
    var http = initHttp();
    var folders = initFolders(settings, http);
    var items = initItems(settings, http);
    this.name = 'facebookVideo';
    this.folders = decorators.addEvents(this, eventsList.FOLDERS, folders);
    this.items = decorators.addEvents(this, eventsList.ITEMS, items);
  };
}(sources_facebook_video_settings, sources_facebook_video_folders, sources_facebook_video_items, utils_http, sources_decorators, events_list, utils_utils);
sources_flickr_settings = {
  apiUrl: '//pix.wix.com/services/flickr',
  foldersLimit: 50,
  itemsLimit: 50
};
sources_flickr_mappers_folder = function (data) {
  return {
    id: data.id,
    name: data.title._content,
    mediaType: 'picture',
    thumbnailUrl: data.primary_photo_extras.url_m || data.primary_photo_extras.url_s || data.primary_photo_extras.url_t,
    parentId: null,
    filesCount: Number(data.photos) + Number(data.videos),
    createdAt: Number(data.date_create) * 1000
  };
};
sources_flickr_parsers_folders = function (toFolder) {
  return function (res) {
    res.data = (res.data.photosets.photoset || []).map(toFolder);
    return res;
  };
}(sources_flickr_mappers_folder);
sources_flickr_parsers_error = function (Promise) {
  return function (response) {
    return Promise.reject(response);
  };
}(bluebird_extended);
sources_flickr_folders = function (mapFolderList, toError) {
  return function (settings, http) {
    function list(folderId, options) {
      options = options || {};
      options.paging = options.paging || {};
      var requestOptions = {
        primary_photo_extras: 'url_t,url_s,url_m,url_b,url_o',
        per_page: options.paging.size || settings.foldersLimit,
        page: options.paging.cursor || null
      };
      return http.get(settings.apiUrl + '/albums', requestOptions, {
        withCredentials: true,
        headers: options.headers || {}
      }).then(mapFolderList).catch(toError);
    }
    return { list: list };
  };
}(sources_flickr_parsers_folders, sources_flickr_parsers_error);
sources_flickr_mappers_item = function (utils) {
  function toThumbnails(photo) {
    var thumbnail = photo.url_m || photo.url_s || photo.url_t;
    var big = photo.url_b || thumbnail;
    var original = photo.url_o || big;
    return {
      fileUrl: original,
      thumbnailUrl: thumbnail,
      previewUrl: big
    };
  }
  return function (data) {
    var thumbnails = toThumbnails(data);
    return {
      id: data.id,
      name: data.title,
      folderId: null,
      mediaType: 'picture',
      fileUrl: utils.normalizeUri(thumbnails.fileUrl),
      thumbnailUrl: utils.normalizeUri(thumbnails.thumbnailUrl),
      previewUrl: utils.normalizeUri(thumbnails.previewUrl),
      createdAt: null,
      tags: [],
      width: Number(data.width_o || data.width_m || data.width_s || data.width_t),
      height: Number(data.height_o || data.height_m || data.height_s || data.height_t)
    };
  };
}(utils_utils);
sources_flickr_parsers_items = function (toItem) {
  return function (res) {
    var cursor = res.data.photoset.page < res.data.photoset.pages ? Number(res.data.photoset.page) + 1 : null;
    var size = Number(res.data.photoset.perpage);
    res.data = (res.data.photoset.photo || []).map(toItem);
    res.paging = {
      cursor: cursor,
      size: size
    };
    return res;
  };
}(sources_flickr_mappers_item);
sources_flickr_items = function (mapItemList, toError) {
  return function (settings, http) {
    function list(folderId, options) {
      options = options || {};
      options.paging = options.paging || {};
      var requestOptions = {
        extras: 'url_t,url_s,url_m,url_b,url_o',
        set_id: folderId,
        per_page: options.paging.size || settings.itemsLimit,
        page: options.paging.cursor || null
      };
      return http.get(settings.apiUrl + '/photoset', requestOptions, {
        withCredentials: true,
        headers: options.headers || {}
      }).then(mapItemList).catch(toError);
    }
    return { list: list };
  };
}(sources_flickr_parsers_items, sources_flickr_parsers_error);
sources_flickr_Flickr = function (settings, initFolders, initItems, initHttp, decorators, eventsList) {
  return function () {
    var http = initHttp();
    var folders = initFolders(settings, http);
    var items = initItems(settings, http);
    this.name = 'flickr';
    this.folders = decorators.addEvents(this, eventsList.FOLDERS, folders);
    this.items = decorators.addEvents(this, eventsList.ITEMS, items);
  };
}(sources_flickr_settings, sources_flickr_folders, sources_flickr_items, utils_http, sources_decorators, events_list);
sources_flickr_search_settings = {
  apiUrl: '//pix.wix.com/services/flickr',
  itemsLimit: 50
};
sources_flickr_search_mappers_item = function (utils) {
  function toThumbnails(photo) {
    var thumbnail = photo.url_m || photo.url_s || photo.url_t;
    var big = photo.url_b || thumbnail;
    var original = photo.url_o || big;
    return {
      fileUrl: original,
      thumbnailUrl: thumbnail,
      previewUrl: big
    };
  }
  return function (data) {
    var thumbnails = toThumbnails(data);
    return {
      id: data.id,
      name: data.title,
      folderId: null,
      mediaType: 'picture',
      fileUrl: utils.normalizeUri(thumbnails.fileUrl),
      thumbnailUrl: utils.normalizeUri(thumbnails.thumbnailUrl),
      previewUrl: utils.normalizeUri(thumbnails.previewUrl),
      createdAt: null,
      tags: [],
      width: Number(data.width_o || data.width_m || data.width_s || data.width_t),
      height: Number(data.height_o || data.height_m || data.height_s || data.height_t)
    };
  };
}(utils_utils);
sources_flickr_search_parsers_items = function (toItem) {
  return function (res) {
    var cursor = res.data.photos.page < res.data.photos.pages ? res.data.photos.page + 1 : null;
    var size = Number(res.data.photos.perpage);
    res.data = (res.data.photos.photo || []).map(toItem);
    res.paging = {
      cursor: cursor,
      size: size
    };
    return res;
  };
}(sources_flickr_search_mappers_item);
sources_flickr_search_parsers_error = function (Promise) {
  return function (response) {
    return Promise.reject(response);
  };
}(bluebird_extended);
sources_flickr_search_items = function (mapItemList, toError) {
  return function (settings, http) {
    function search(folderId, query, options) {
      options = options || {};
      options.paging = options.paging || {};
      var requestOptions = {
        extras: 'url_t,url_s,url_m,url_b,url_o',
        text: query,
        per_page: options.paging.size || settings.itemsLimit,
        page: options.paging.cursor || null
      };
      return http.get(settings.apiUrl + '/search', requestOptions, {
        withCredentials: false,
        headers: options.headers || {}
      }).then(mapItemList).catch(toError);
    }
    return { search: search };
  };
}(sources_flickr_search_parsers_items, sources_flickr_search_parsers_error);
sources_flickr_search_FlickrSearch = function (settings, initItems, initHttp, decorators, eventsList) {
  return function () {
    var http = initHttp();
    var items = initItems(settings, http);
    this.name = 'flickrSearch';
    this.items = decorators.addEvents(this, eventsList.ITEMS, items);
  };
}(sources_flickr_search_settings, sources_flickr_search_items, utils_http, sources_decorators, events_list);
sources_google_search_settings = {
  apiUrl: '//pix.wix.com/services/gcs',
  itemsLimit: 50
};
sources_google_search_mappers_item = function (utils) {
  return function (data) {
    return {
      id: data.link,
      name: utils.replaceHtml(data.title),
      folderId: null,
      mediaType: 'picture',
      fileUrl: utils.normalizeUri(data.link),
      thumbnailUrl: utils.normalizeUri(data.image.thumbnailLink || data.link),
      previewUrl: utils.normalizeUri(data.link),
      createdAt: null,
      tags: [],
      width: Number(data.image.width),
      height: Number(data.image.height)
    };
  };
}(utils_utils);
sources_google_search_parsers_items = function (toItem) {
  return function (res) {
    var cursor = null;
    var size = null;
    if (res.data.queries && res.data.queries.nextPage && res.data.queries.nextPage[0]) {
      cursor = res.data.queries.nextPage[0].startIndex;
      size = res.data.queries.nextPage[0].count;
    }
    res.data = (res.data.items || []).map(toItem);
    res.paging = {
      cursor: cursor >= 92 ? null : cursor,
      size: size
    };
    return res;
  };
}(sources_google_search_mappers_item);
sources_google_search_parsers_error = function (Promise) {
  return function (response) {
    return Promise.reject(response);
  };
}(bluebird_extended);
sources_google_search_items = function (mapItemList, toError) {
  return function (settings, http) {
    function search(folderId, query, options) {
      options = options || {};
      options.paging = options.paging || {};
      var requestOptions = {
        q: query,
        count: options.paging.size || settings.itemsLimit,
        start: options.paging.cursor || null
      };
      if (options.excludeQuery) {
        requestOptions.filter = options.excludeQuery;
      }
      return http.get(settings.apiUrl + '/images', requestOptions, {
        withCredentials: false,
        headers: options.headers || {}
      }).then(mapItemList).catch(toError);
    }
    return { search: search };
  };
}(sources_google_search_parsers_items, sources_google_search_parsers_error);
sources_google_search_GoogleSearch = function (settings, initItems, initHttp, decorators, eventsList) {
  return function () {
    var http = initHttp();
    var items = initItems(settings, http);
    this.name = 'googleSearch';
    this.items = decorators.addEvents(this, eventsList.ITEMS, items);
  };
}(sources_google_search_settings, sources_google_search_items, utils_http, sources_decorators, events_list);
sources_collection_settings = {
  apiUrl: '//collections.wixstatic.com/collections',
  filesUrl: '//static.wixstatic.com',
  collectionId: '68c4b99f-d5b7-4583-b1d1-e00e31605678',
  imageOperationsApi: 'vangogh',
  itemsLimit: 50
};
sources_collection_mappers_folder = function (utils, mapPrivateFolder) {
  return function (data, settings) {
    var privateFolderData = utils.extend({
      folder_id: data.id,
      folder_name: data.title,
      media_type: data.type,
      created_ts: data.date_created
    }, data.public_properties);
    var folder = mapPrivateFolder(privateFolderData);
    if (data.public_properties.thumbnail_url && !folder.thumbnailUrl) {
      folder.thumbnailUrl = utils.normalizeUri(settings.filesUrl + '/' + data.public_properties.thumbnail_url);
    }
    return folder;
  };
}(utils_utils, sources_private_mappers_folder);
sources_collection_parsers_selector = function (entities, parentId, isFolder) {
  return entities.filter(function (entity) {
    return isFolder ? !entity.public_properties.file_url && (parentId ? entity.public_properties.parent_id === parentId : !entity.public_properties.parent_id) : entity.public_properties.file_url && (parentId ? entity.public_properties.folder_id === parentId : !entity.public_properties.folder_id);
  });
};
sources_collection_parsers_folders = function (toFolder, select) {
  return function (res, folderId, currentPaging, settings) {
    var foldersData = select(res.data.collection.items, folderId, true);
    var paging = {
      cursor: currentPaging.cursor + currentPaging.size,
      size: foldersData.length - currentPaging.cursor
    };
    res.data = foldersData.map(function (data) {
      var folder = toFolder(data, settings);
      folder.filesCount = folder.filesCount || select(res.data.collection.items, folder.id, false).length;
      return folder;
    });
    if (paging.size > 0) {
      res.paging = paging;
    }
    return res;
  };
}(sources_collection_mappers_folder, sources_collection_parsers_selector);
sources_collection_parsers_error = function (Promise) {
  return function (response) {
    return Promise.reject(response);
  };
}(bluebird_extended);
sources_collection_folders = function (mapFolderList, toError) {
  return function (settings, http) {
    function list(folderId, options) {
      options = options || {};
      options.paging = options.paging || {};
      options.paging.cursor = options.paging.cursor || 0;
      options.paging.size = options.paging.size || settings.itemsLimit;
      return http.get(settings.apiUrl + '/' + settings.collectionId + '.json', {}, {
        withCredentials: false,
        headers: options.headers || {}
      }).then(function (res) {
        return mapFolderList(res, folderId, options.paging, settings);
      }).catch(toError);
    }
    return { list: list };
  };
}(sources_collection_parsers_folders, sources_collection_parsers_error);
sources_collection_mappers_item = function (mappers, utils, mapPrivateItem) {
  return function (data, settings, thumbnailSizes) {
    var privateItemData = utils.extend({
      file_name: data.id,
      original_file_name: data.title,
      media_type: data.type,
      created_ts: data.date_created
    }, data.public_properties);
    return mapPrivateItem(privateItemData, settings, thumbnailSizes);
  };
}(utils_mappers, utils_utils, sources_private_mappers_item);
sources_collection_parsers_items = function (toItem, select) {
  return function (res, folderId, currentPaging, settings, thumbnailSizes) {
    var itemsData = select(res.data.collection.items, folderId, false);
    var paging = {
      cursor: currentPaging.cursor + currentPaging.size,
      size: itemsData.length - currentPaging.cursor
    };
    res.data = itemsData.map(function (data) {
      return toItem(data, settings, thumbnailSizes);
    });
    if (paging.size > 0) {
      res.paging = paging;
    }
    return res;
  };
}(sources_collection_mappers_item, sources_collection_parsers_selector);
sources_collection_items = function (mapItemList, toError) {
  return function (settings, http) {
    function list(folderId, options) {
      options = options || {};
      options.paging = options.paging || {};
      options.paging.cursor = options.paging.cursor || 0;
      options.paging.size = options.paging.size || settings.itemsLimit;
      return http.get(settings.apiUrl + '/' + settings.collectionId + '.json', {}, {
        withCredentials: false,
        headers: options.headers || {}
      }).then(function (res) {
        return mapItemList(res, folderId, options.paging, settings, options.thumbnails);
      }).catch(toError);
    }
    return { list: list };
  };
}(sources_collection_parsers_items, sources_collection_parsers_error);
sources_collection_Collection = function (defaultSettings, initFolders, initItems, initHttp, decorators, utils, eventsList) {
  return function (userSettings) {
    var settings = utils.extend({}, defaultSettings, userSettings);
    var http = initHttp();
    var folders = initFolders(settings, http);
    var items = initItems(settings, http);
    this.name = 'collection';
    this.folders = decorators.addEvents(this, eventsList.FOLDERS, folders);
    this.items = decorators.addEvents(this, eventsList.ITEMS, items);
  };
}(sources_collection_settings, sources_collection_folders, sources_collection_items, utils_http, sources_decorators, utils_utils, events_list);
sources_vimeo_settings = {
  apiUrl: '//pix.wix.com/services/vimeo2',
  itemsLimit: 50,
  thumbnailSizes: {
    thumbnail: {
      width: 210,
      height: 210,
      mode: 'fill'
    },
    preview: {
      width: 375,
      height: 375,
      mode: 'fit'
    }
  }
};
sources_vimeo_mappers_folder = function () {
  return {
    id: 'Vimeo',
    name: 'Vimeo',
    mediaType: 'video',
    parentId: null,
    filesCount: null,
    createdAt: null
  };
};
sources_vimeo_parsers_folders = function (toFolder) {
  return function () {
    return { data: [toFolder()] };
  };
}(sources_vimeo_mappers_folder);
sources_vimeo_folders = function (toFolders, Promise) {
  return function () {
    function list() {
      return Promise.resolve(toFolders());
    }
    return { list: list };
  };
}(sources_vimeo_parsers_folders, bluebird_extended);
sources_vimeo_mappers_item = function (utils) {
  return function (settings, data) {
    function getIframeSrc(str) {
      var res = str.match(/src="(.+?)"/i);
      return res ? res[1] : '';
    }
    function toTimeStamp(date) {
      return Math.floor(new Date(date).getTime() / 1000);
    }
    function getTags(tags) {
      if (tags === null || !tags.length) {
        return [];
      }
      return tags.reduce(function (resultTags, tag) {
        if (tag) {
          resultTags.push(tag.tag);
        }
        return resultTags;
      }, []);
    }
    function getId(str) {
      return Number(str.match(/\/videos\/(\d+)/i)[1]);
    }
    var item = {
      id: getId(data.uri),
      name: utils.replaceHtml(data.name),
      description: utils.replaceHtml(data.description),
      link: utils.normalizeUri(data.link),
      iframeSrc: getIframeSrc(data.embed.html),
      embedHtml: data.embed.html,
      tags: getTags(data.tags),
      width: Number(data.width) || 0,
      height: Number(data.height) || 0,
      createdAt: toTimeStamp(data.created_time),
      folderId: null,
      mediaType: 'video'
    };
    if (!data.pictures || !data.pictures.sizes) {
      return item;
    }
    var availableThumbnailsSizes = data.pictures.sizes.map(function (pictureSize) {
      return utils.extend({}, pictureSize, { url: pictureSize.link });
    });
    var urls = utils.getThumbnailsUrlsFromList(availableThumbnailsSizes, settings.thumbnailSizes);
    return utils.extend(item, urls);
  };
}(utils_utils);
sources_vimeo_parsers_items = function (toItem, utils) {
  return function (settings, res) {
    var cursor = null;
    var size = null;
    if (res.data.paging && res.data.paging.next) {
      cursor = Number(res.data.paging.next.match(/\&page\=(\d+)/i)[1]);
      size = res.data.per_page;
    }
    res.data = (res.data.data || []).filter(function (item) {
      return item && item.embed && item.embed.html;
    }).map(utils.partial(toItem, settings));
    res.paging = {
      cursor: cursor,
      size: size
    };
    return res;
  };
}(sources_vimeo_mappers_item, utils_utils);
sources_vimeo_parsers_error = function (Promise) {
  return function (response) {
    return Promise.reject(response);
  };
}(bluebird_extended);
sources_vimeo_items = function (utils, mapItemList, toError) {
  return function (settings, http) {
    function list(folderId, options) {
      var optionsThumbnailSizes = options.thumbnailSizes ? { thumbnailSizes: options.thumbnailSizes } : {};
      var listSettings = utils.merge({}, settings, optionsThumbnailSizes);
      options = options || {};
      options.paging = options.paging || {};
      var requestOptions = {
        per_page: options.paging.size || settings.itemsLimit,
        page: options.paging.cursor || null
      };
      return http.get(settings.apiUrl + '/videos', requestOptions, {
        withCredentials: true,
        headers: options.headers || {}
      }).then(utils.partial(mapItemList, listSettings)).catch(toError);
    }
    return { list: list };
  };
}(utils_utils, sources_vimeo_parsers_items, sources_vimeo_parsers_error);
sources_vimeo_Vimeo = function (defaultSettings, initFolders, initItems, initHttp, decorators, eventsList, utils) {
  return function (userSettings) {
    var settings = utils.extend({}, defaultSettings, userSettings);
    var http = initHttp();
    var folders = initFolders(settings, http);
    var items = initItems(settings, http);
    this.name = 'vimeo';
    this.folders = decorators.addEvents(this, eventsList.FOLDERS, folders);
    this.items = decorators.addEvents(this, eventsList.ITEMS, items);
  };
}(sources_vimeo_settings, sources_vimeo_folders, sources_vimeo_items, utils_http, sources_decorators, events_list, utils_utils);
sources_vimeo_search_settings = {
  apiUrl: '//pix.wix.com/services/vimeo2',
  itemsLimit: 50,
  thumbnailSizes: {
    thumbnail: {
      width: 210,
      height: 210,
      mode: 'fill'
    },
    preview: {
      width: 375,
      height: 375,
      mode: 'fit'
    }
  }
};
sources_vimeo_search_mappers_item = function (utils) {
  return function (settings, data) {
    function getIframeSrc(str) {
      var res = str.match(/src="(.+?)"/i);
      return res ? res[1] : '';
    }
    function getTags(tags) {
      if (tags === null || !tags.length) {
        return [];
      }
      return tags.reduce(function (resultTags, tag) {
        if (tag) {
          resultTags.push(tag.tag);
        }
        return resultTags;
      }, []);
    }
    function getId(str) {
      return Number(str.match(/\/videos\/(\d+)/i)[1]);
    }
    var item = {
      id: getId(data.uri),
      name: utils.replaceHtml(data.name),
      description: utils.replaceHtml(data.description),
      link: utils.normalizeUri(data.link),
      iframeSrc: getIframeSrc(data.embed.html),
      embedHtml: data.embed.html,
      tags: getTags(data.tags),
      width: Number(data.width) || 0,
      height: Number(data.height) || 0,
      createdAt: utils.toTimeStamp(data.created_time),
      folderId: null,
      mediaType: 'video'
    };
    if (!data.pictures || !data.pictures.sizes) {
      return item;
    }
    var availableThumbnailsSizes = data.pictures.sizes.map(function (pictureSize) {
      return utils.extend({}, pictureSize, { url: pictureSize.link });
    });
    var urls = utils.getThumbnailsUrlsFromList(availableThumbnailsSizes, settings.thumbnailSizes);
    return utils.extend(item, urls);
  };
}(utils_utils);
sources_vimeo_search_parsers_items = function (toItem, utils) {
  return function (settings, res) {
    var cursor = null;
    var size = null;
    if (res.data.paging && res.data.paging.next) {
      cursor = Number(res.data.paging.next.match(/\&page\=(\d+)/i)[1]);
      size = res.data.per_page;
    }
    res.data = (res.data.data || []).filter(function (item) {
      return item && item.embed && item.embed.html;
    }).map(utils.partial(toItem, settings));
    res.paging = {
      cursor: cursor,
      size: size
    };
    return res;
  };
}(sources_vimeo_search_mappers_item, utils_utils);
sources_vimeo_search_parsers_error = function (Promise) {
  return function (response) {
    return Promise.reject(response);
  };
}(bluebird_extended);
sources_vimeo_search_items = function (utils, mapItemList, toError) {
  return function (settings, http) {
    function search(folderId, query, options) {
      var optionsThumbnailSizes = options.thumbnailSizes ? { thumbnailSizes: options.thumbnailSizes } : {};
      var listSettings = utils.merge({}, settings, optionsThumbnailSizes);
      options = options || {};
      options.paging = options.paging || {};
      var requestOptions = {
        query: query,
        per_page: options.paging.size || settings.itemsLimit,
        page: options.paging.cursor || null
      };
      return http.get(settings.apiUrl + '/search', requestOptions, {
        withCredentials: false,
        headers: options.headers || {}
      }).then(utils.partial(mapItemList, listSettings)).catch(toError);
    }
    return { search: search };
  };
}(utils_utils, sources_vimeo_search_parsers_items, sources_vimeo_search_parsers_error);
sources_vimeo_search_VimeoSearch = function (defaultSettings, initItems, initHttp, decorators, eventsList, utils) {
  return function (settings) {
    var http = initHttp();
    settings = utils.extend({}, defaultSettings, settings);
    var items = initItems(settings, http);
    this.name = 'vimeoSearch';
    this.items = decorators.addEvents(this, eventsList.ITEMS, items);
  };
}(sources_vimeo_search_settings, sources_vimeo_search_items, utils_http, sources_decorators, events_list, utils_utils);
sources_youtube_settings = {
  apiUrl: '//pix.wix.com/services/youtube',
  foldersLimit: 50,
  itemsLimit: 50,
  thumbnailSizes: {
    thumbnail: {
      width: 210,
      height: 210,
      mode: 'fill'
    },
    preview: {
      width: 375,
      height: 375,
      mode: 'fit'
    }
  }
};
sources_youtube_mappers_folder = function (utils) {
  return function (data, settings) {
    var snippet = data.snippet;
    var availableThumbnailsSizes = Object.keys(snippet.thumbnails).map(function (prop) {
      return snippet.thumbnails[prop];
    });
    var urls = utils.getThumbnailsUrlsFromList(availableThumbnailsSizes, settings.thumbnailSizes);
    return utils.extend({
      id: data.id,
      name: snippet.title,
      mediaType: 'video',
      parentId: null,
      filesCount: null,
      /* filesCount - from api contentDetails.itemCount. We can get it but its paid */
      createdAt: utils.toTimeStamp(snippet.publishedAt)
    }, urls);
  };
}(utils_utils);
sources_youtube_parsers_folders = function (toFolder) {
  return function (settings, res) {
    var cursor = null;
    var size = null;
    if (res.data && res.data.nextPageToken) {
      cursor = res.data.nextPageToken;
      size = res.data.pageInfo.resultsPerPage;
    }
    res.data = (res.data.items || []).map(function (data) {
      return toFolder(data, settings);
    });
    res.paging = {
      cursor: cursor,
      size: size
    };
    return res;
  };
}(sources_youtube_mappers_folder);
sources_youtube_parsers_error = function (Promise) {
  return function (response) {
    if (response.code === 404 && response.data && response.data.message === 'Channel not found.') {
      return {
        data: [],
        status: response.code,
        error: response.data
      };
    }
    return Promise.reject(response);
  };
}(bluebird_extended);
sources_youtube_folders = function (utils, mapFolderList, toError) {
  return function (settings, http) {
    function list(folderId, options) {
      var optionsThumbnailSizes = options.thumbnailSizes ? { thumbnailSizes: options.thumbnailSizes } : {};
      var listSettings = utils.merge({}, settings, optionsThumbnailSizes);
      options = options || {};
      options.paging = options.paging || {};
      var requestOptions = {
        maxResults: options.paging.size || settings.foldersLimit,
        pageToken: options.paging.cursor || null
      };
      return http.get(settings.apiUrl + '/myplaylists', requestOptions, {
        withCredentials: true,
        headers: options.headers || {}
      }).then(utils.partial(mapFolderList, listSettings)).catch(toError);
    }
    return { list: list };
  };
}(utils_utils, sources_youtube_parsers_folders, sources_youtube_parsers_error);
sources_youtube_mappers_item = function (utils) {
  return function (data, settings) {
    var snippet = data.snippet;
    var videoId = data.contentDetails.videoId;
    function getIframeSrc(videoId) {
      return '//www.youtube.com/embed/' + videoId;
    }
    var availableThumbnailsSizes = Object.keys(snippet.thumbnails).map(function (prop) {
      return snippet.thumbnails[prop];
    });
    var urls = utils.getThumbnailsUrlsFromList(availableThumbnailsSizes, settings.thumbnailSizes);
    return utils.extend({}, {
      id: videoId,
      name: utils.replaceHtml(snippet.title),
      iframeSrc: getIframeSrc(videoId),
      folderId: null,
      mediaType: 'video',
      createdAt: utils.toTimeStamp(snippet.publishedAt)
    }, urls);
  };
}(utils_utils);
sources_youtube_parsers_items = function (toItem) {
  return function (settings, res) {
    var cursor = null;
    var size = null;
    if (res.data && res.data.nextPageToken) {
      cursor = res.data.nextPageToken;
      size = res.data.pageInfo.resultsPerPage;
    }
    res.data = (res.data.items || []).filter(function (item) {
      return item && item.snippet && item.snippet.thumbnails;
    }).map(function (data) {
      return toItem(data, settings);
    });
    res.paging = {
      cursor: cursor,
      size: size
    };
    return res;
  };
}(sources_youtube_mappers_item);
sources_youtube_items = function (utils, mapItemList, toError) {
  return function (settings, http) {
    function list(folderId, options) {
      var optionsThumbnailSizes = options.thumbnailSizes ? { thumbnailSizes: options.thumbnailSizes } : {};
      var listSettings = utils.merge({}, settings, optionsThumbnailSizes);
      options = options || {};
      options.paging = options.paging || {};
      var requestOptions = {
        playlistId: folderId,
        maxResults: options.paging.size || settings.itemsLimit,
        pageToken: options.paging.cursor || null
      };
      return http.get(settings.apiUrl + '/myplaylistitems', requestOptions, {
        withCredentials: true,
        headers: options.headers || {}
      }).then(utils.partial(mapItemList, listSettings)).catch(toError);
    }
    return { list: list };
  };
}(utils_utils, sources_youtube_parsers_items, sources_youtube_parsers_error);
sources_youtube_YouTube = function (defaultSettings, initFolders, initItems, initHttp, decorators, eventsList, utils) {
  return function (userSettings) {
    var settings = utils.extend({}, defaultSettings, userSettings);
    var http = initHttp();
    var folders = initFolders(settings, http);
    var items = initItems(settings, http);
    this.name = 'youtube';
    this.folders = decorators.addEvents(this, eventsList.FOLDERS, folders);
    this.items = decorators.addEvents(this, eventsList.ITEMS, items);
  };
}(sources_youtube_settings, sources_youtube_folders, sources_youtube_items, utils_http, sources_decorators, events_list, utils_utils);
sources_youtube_search_settings = {
  apiUrl: '//pix.wix.com/services/youtube',
  itemsLimit: 50,
  thumbnailSizes: {
    thumbnail: {
      width: 210,
      height: 210,
      mode: 'fill'
    },
    preview: {
      width: 375,
      height: 375,
      mode: 'fit'
    }
  }
};
sources_youtube_search_mappers_item = function (utils) {
  return function (settings, data) {
    var snippet = data.snippet;
    var videoId = data.id.videoId;
    function getIframeSrc(videoId) {
      return '//www.youtube.com/embed/' + videoId;
    }
    var availableThumbnailsSizes = Object.keys(snippet.thumbnails).map(function (prop) {
      return snippet.thumbnails[prop];
    });
    var urls = utils.getThumbnailsUrlsFromList(availableThumbnailsSizes, settings.thumbnailSizes);
    return utils.extend({}, {
      id: videoId,
      name: utils.replaceHtml(snippet.title),
      iframeSrc: getIframeSrc(videoId),
      folderId: null,
      mediaType: 'video'
    }, urls);
  };
}(utils_utils);
sources_youtube_search_parsers_items = function (toItem, utils) {
  return function (settings, res) {
    var cursor = null;
    var size = null;
    if (res.data && res.data.nextPageToken) {
      cursor = res.data.nextPageToken;
      size = res.data.pageInfo.resultsPerPage;
    }
    res.data = (res.data.items || []).map(utils.partial(toItem, settings));
    res.paging = {
      cursor: cursor,
      size: size
    };
    return res;
  };
}(sources_youtube_search_mappers_item, utils_utils);
sources_youtube_search_parsers_error = function (Promise) {
  return function (response) {
    return Promise.reject(response);
  };
}(bluebird_extended);
sources_youtube_search_items = function (utils, mapItemList, toError) {
  return function (settings, http) {
    function search(folderId, query, options) {
      var optionsThumbnailSizes = options.thumbnailSizes ? { thumbnailSizes: options.thumbnailSizes } : {};
      var listSettings = utils.merge({}, settings, optionsThumbnailSizes);
      options = options || {};
      options.paging = options.paging || {};
      var requestOptions = {
        f: 'ext',
        q: query,
        maxResults: options.paging.size || settings.itemsLimit,
        pageToken: options.paging.cursor || null
      };
      return http.get(settings.apiUrl + '/search', requestOptions, {
        withCredentials: false,
        headers: options.headers || {}
      }).then(utils.partial(mapItemList, listSettings)).catch(toError);
    }
    return { search: search };
  };
}(utils_utils, sources_youtube_search_parsers_items, sources_youtube_search_parsers_error);
sources_youtube_search_YouTubeSearch = function (defaultSettings, initItems, initHttp, decorators, eventsList, utils) {
  return function (userSettings) {
    var settings = utils.extend({}, defaultSettings, userSettings);
    var http = initHttp();
    var items = initItems(settings, http);
    this.name = 'youtubeSearch';
    this.items = decorators.addEvents(this, eventsList.ITEMS, items);
  };
}(sources_youtube_search_settings, sources_youtube_search_items, utils_http, sources_decorators, events_list, utils_utils);
sources_showbox_mappers_folder = function (folderData) {
  /**
   * Folder
   * {String} id
   * {String} parentId
   * {String} name
   * {Number} createdAt
   */
  return {
    id: folderData.cms_id,
    parentId: folderData.parents.pop(),
    name: folderData.title,
    createdAt: folderData.created_at
  };
};
sources_showbox_parsers_error = function (Promise) {
  return function (response) {
    //if (response.status === 403 && response.data && response.data.error_description === 'Missing Wix session') {
    //  response.status = 401;
    //  response.data.message = 'Wix Session required';
    //}
    return Promise.reject(response);
  };
}(bluebird_extended);
sources_showbox_folders = function (toFolder, toError) {
  return function (settings, http) {
    function mapFolderList(res) {
      res.data = (res.data.collection || []).map(toFolder);
      return res;
    }
    /**
     * @summary Return the list of folders
     * @memberof source.folders
     * @param {String} folderId
     * @param {ListSettings} options
     * @returns {Promise}
     * @fulfill {List[]} List with Folders
     * @reject {Error}
     */
    function list(folderId, options) {
      options = options || {};
      var url = settings.apiUrl + '/taxonomy/';
      if (folderId) {
        url += 'cms_id/' + folderId;
      }
      return http.get(url, {}, {
        withCredentials: false,
        headers: options.headers || {}
      })  //.then(function (response) {
          //  if(folderId) {
          //    return mapFolderList(response.data.collection[0].children);
          //  }
          //  else {
          //    return mapFolderList(response.data);
          //  }
          //})
.then(mapFolderList).catch(toError);
    }
    return { list: list };
  };
}(sources_showbox_mappers_folder, sources_showbox_parsers_error);
sources_showbox_mappers_item = function (mappers, utils, getWixThumbnailsUrls, getWixVideoPreviewUrls, resize) {
  //function getResizedUrls(thumbnailSizes, urlForResize, imageOperationsApi) {
  //  return Object.keys(thumbnailSizes).reduce(function (urls, sizeName) {
  //    var url = resize(urlForResize, thumbnailSizes[sizeName], imageOperationsApi);
  //
  //    if (url) {
  //      urls[sizeName + 'Url'] = url;
  //    }
  //    return urls;
  //  }, {});
  //}
  return function (itemData, settings, thumbnailSizes) {
    var normalizeUri = utils.normalizeUri;
    //noinspection UnnecessaryLocalVariableJS
    var item = {
      mediaType: 'showbox_template',
      id: [
        itemData.cms_id,
        itemData.format,
        itemData.package
      ].join(':'),
      fileUrl: itemData.cms_id,
      folderId: itemData.category[0] || null,
      name: itemData.title,
      width: utils.get(itemData, 'aux.width'),
      height: utils.get(itemData, 'aux.height'),
      thumbnailUrl: itemData.thumbnail || null,
      previewUrl: itemData.thumbnail || null,
      video: itemData.video || null,
      fileOutput: utils.get(itemData, 'aux.file_output'),
      fileInput: utils.get(itemData, 'aux.file_input')
    };
    //var sizes = utils.extend({}, settings.thumbnailSizes, thumbnailSizes);
    //item.thumbnailUrl = getResizedUrls(sizes, itemData.thumbnail, settings.imageOperationsApi);
    //console.log(resize(itemData.thumbnail, sizes[sizeName], imageOperationsApi));
    //console.log(getResizedUrls(sizes, itemData.thumbnail, settings.imageOperationsApi));
    item.videoPreviewUrls = getWixVideoPreviewUrls(item, settings);
    return item;
  };
}(utils_mappers, utils_utils, services_thumbnail_generator_get_wix_thumbnails_urls, services_thumbnail_generator_get_wix_video_preview_urls, services_thumbnail_generator_resize);
sources_showbox_items = function (Promise, utils, toItem, toError) {
  return function (settings, http) {
    function mapItemList(res, thumbnailSizes) {
      res.data = (res.data.collection || []).map(function (data) {
        return toItem(data, settings, thumbnailSizes);
      });
      return res;
    }
    var defaultPaging = {
      size: 50,
      cursor: null
    };
    var defaultSort = {
      order: 'date',
      direction: 'desc'
    };
    /**
     * @summary Returns the list of items from the given folder
     * @memberof source.items
     * @param {string} folderId
     * @param {ListSettings} options
     * @returns {Promise}
     * @fulfill {List}
     * @reject {Error}
     */
    function list(folderId, options) {
      options = options || {};
      var sort = utils.extend({}, defaultSort, options.sort);
      var paging = utils.extend({}, defaultPaging, options.paging);
      var queryParams = { cursor: paging.cursor };
      queryParams.order = sort.direction === 'desc' ? '-' + sort.order : sort.order;
      var url = settings.apiUrl + '/taxonomy/cms_id/' + folderId;
      return http.get(url, queryParams, {
        withCredentials: false,
        headers: options.headers || {}
      }).then(function (response) {
        response.paging = { cursor: response.data.cursor };
        return mapItemList(response, options.thumbnails);
      }).catch(toError);
    }
    /**
     * @summary Return list of items found by text query
     * @memberof source.items
     * @param {string} folderId
     * @param {string} query
     * @param {ListSettings} options
     * @returns {Promise}
     * @fulfill {List}
     * @reject {Error}
     */
    function search(folderId, query, options) {
      options = options || {};
      var sort = utils.extend({}, defaultSort, options.sort);
      var paging = utils.extend({}, defaultPaging, options.paging);
      query = encodeURIComponent(query);
      var queryParams = {
        query: query,
        page_size: paging.size,
        cursor: paging.cursor,
        media_type: options.mediaType || 'picture',
        folder: folderId,
        order: sort.direction === 'desc' ? '-' + sort.order : sort.order
      };
      return http.get(settings.apiUrl + '/search/items', queryParams, {
        cache: false,
        headers: options.headers || {}
      }).then(function (response) {
        response.paging = {
          size: paging.size,
          cursor: response.data.cursor
        };
        return mapItemList(response, options.thumbnails);
      }).catch(toError);
    }
    return {
      list: list,
      search: search
    };
  };
}(bluebird_extended, utils_utils, sources_showbox_mappers_item, sources_showbox_parsers_error);
sources_showbox_item = function (utils, toError) {
  return function (settings, http) {
    function mapItem(res) {
      //res.data = toItem(res.data, settings, thumbnailsSizes);
      return res;
    }
    function getExtra(itemId, options) {
      options = options || {};
      // 58b7ed57255844bb3bb2bba1:wix_slideshow_test2:space_out
      var url = settings.pixUrl + '/services/showbox/videodata';
      var query = { template_id: itemId };
      return http.get(url, query, {
        withCredentials: true,
        headers: options.headers || {}
      }).then(mapItem).catch(toError);
    }
    return { get: getExtra };
  };
}(utils_utils, sources_showbox_parsers_error);
sources_showbox_settings = {
  apiUrl: '//api.showbox.com/',
  imageOperationsApi: 'rembrandt',
  filesUrl: '//video-showbox.wixmp.com',
  pixUrl: '//pix.wix.com',
  videoFilesUrl: '//video-showbox.wixmp.com',
  refreshTokenUrl: null,
  requestOptions: { withCredentials: true },
  thumbnailSizes: {
    thumbnail: {
      width: 210,
      height: 210,
      mode: 'fill'
    },
    preview: {
      width: 375,
      height: 375,
      mode: 'fit'
    },
    original: {
      width: 1000,
      height: 1000,
      mode: 'fit'
    }
  },
  asyncFontUpload: false,
  asyncUploadByUrl: false,
  asyncTranscoding: false,
  videoPreviewQuality: '480p'
};
sources_showbox_Showbox = function (initFolders, initItems, initItem, defaultSettings, utils, decorators, eventsList, initHttp) {
  return function (userSettings) {
    this.name = 'showbox';
    var settings = utils.extendDeep({}, defaultSettings, userSettings);
    var requestOptions = settings.requestOptions;
    var http = initHttp(requestOptions);
    var folders = initFolders(settings, http);
    var items = initItems(settings, http);
    var item = initItem(settings, http);
    this.folders = decorators.addEvents(this, eventsList.FOLDERS, folders);
    this.items = decorators.addEvents(this, eventsList.ITEMS, items);
    this.item = decorators.addEvents(this, eventsList.ITEM, item);
  };
}(sources_showbox_folders, sources_showbox_items, sources_showbox_item, sources_showbox_settings, utils_utils, sources_decorators, events_list, utils_http);
sources_list = function (BigStock, ShutterStock, Public, Private, Platform, Picasa, Drive, Dropbox, Instagram, InstagramVideo, Facebook, FacebookVideo, Flickr, FlickrSearch, GoogleSearch, Collection, Vimeo, VimeoSearch, YouTube, YouTubeSearch, Showbox) {
  /**
   * @summary The list of available source constructors
   * @enum
   * @memberof wixmp
   */
  var sources = {
    BIGSTOCK: BigStock,
    SHUTTERSTOCK: ShutterStock,
    PUBLIC: Public,
    PRIVATE: Private,
    PLATFORM: Platform,
    PICASA: Picasa,
    DRIVE: Drive,
    DROPBOX: Dropbox,
    INSTAGRAM: Instagram,
    INSTAGRAM_VIDEO: InstagramVideo,
    FACEBOOK: Facebook,
    FACEBOOK_VIDEO: FacebookVideo,
    FLICKR: Flickr,
    FLICKR_SEARCH: FlickrSearch,
    GOOGLE_SEARCH: GoogleSearch,
    COLLECTION: Collection,
    VIMEO: Vimeo,
    VIMEO_SEARCH: VimeoSearch,
    YOUTUBE: YouTube,
    YOUTUBE_SEARCH: YouTubeSearch,
    SHOWBOX: Showbox
  };
  return sources;
}(sources_bigstock_BigStock, sources_shutterstock_ShutterStock, sources_public_Public, sources_private_Private, sources_platform_Platform, sources_picasa_Picasa, sources_drive_Drive, sources_dropbox_Dropbox, sources_instagram_Instagram, sources_instagram_video_InstagramVideo, sources_facebook_Facebook, sources_facebook_video_FacebookVideo, sources_flickr_Flickr, sources_flickr_search_FlickrSearch, sources_google_search_GoogleSearch, sources_collection_Collection, sources_vimeo_Vimeo, sources_vimeo_search_VimeoSearch, sources_youtube_YouTube, sources_youtube_search_YouTubeSearch, sources_showbox_Showbox);
events_events = function (notifier, list, utils) {
  var events = utils.merge(list);
  function defineNonEnumerableProperty(name, value) {
    Object.defineProperty(events, name, {
      enumerable: false,
      value: value
    });
  }
  defineNonEnumerableProperty('on', notifier.addListener);
  defineNonEnumerableProperty('off', notifier.removeListener);
  return events;
}(events_notifier, events_list, utils_utils);
connector_connector_settings = {
  PICASA: {
    connectUrl: '//pix.wix.com/services/google/connect',
    disconnectUrl: '//pix.wix.com/services/google/disconnect',
    parameterName: 'goglact'
  },
  DRIVE: {
    connectUrl: '//pix.wix.com/services/gdrive/connect',
    disconnectUrl: '//pix.wix.com/services/gdrive/disconnect',
    parameterName: 'gdrvact'
  },
  DROPBOX: {
    connectUrl: '//pix.wix.com/services/dropbox/connect',
    disconnectUrl: '//pix.wix.com/services/dropbox/disconnect',
    parameterName: 'dbact'
  },
  INSTAGRAM: {
    connectUrl: '//pix.wix.com/services/instagram/connect',
    disconnectUrl: '//pix.wix.com/services/instagram/disconnect',
    parameterName: 'instact'
  },
  INSTAGRAM_VIDEO: {
    connectUrl: '//pix.wix.com/services/instagram/connect',
    disconnectUrl: '//pix.wix.com/services/instagram/disconnect',
    parameterName: 'instact'
  },
  FACEBOOK: {
    connectUrl: '//pix.wix.com/services/facebook/connect',
    disconnectUrl: '//pix.wix.com/services/facebook/disconnect',
    parameterName: 'fbact'
  },
  FACEBOOK_VIDEO: {
    connectUrl: '//pix.wix.com/services/facebook/connect',
    disconnectUrl: '//pix.wix.com/services/facebook/disconnect',
    parameterName: 'fbact'
  },
  FLICKR: {
    connectUrl: '//pix.wix.com/services/flickr/connect',
    disconnectUrl: '//pix.wix.com/services/flickr/disconnect',
    parameterName: 'flact'
  },
  YOUTUBE: {
    connectUrl: '//pix.wix.com/services/youtube/connect',
    disconnectUrl: '//pix.wix.com/services/youtube/disconnect',
    parameterName: 'ytact'
  },
  VIMEO: {
    connectUrl: '//pix.wix.com/services/vimeo/connect',
    disconnectUrl: '//pix.wix.com/services/vimeo/disconnect',
    parameterName: 'vmact'
  }
};
connector_connector = function (Promise, connectorSettings, initHttp, utils, mappers) {
  return function (adapterName, userSettings) {
    var settings = connectorSettings[adapterName];
    var http = initHttp();
    if (typeof settings !== 'object') {
      throw new Error('Invalid source');
    }
    function getParameterName() {
      return settings.parameterName;
    }
    function isConnected() {
      return Boolean(localStorage.getItem(settings.parameterName));
    }
    function disconnect() {
      localStorage.removeItem(settings.parameterName);
      return http.get(settings.disconnectUrl, null, { withCredentials: true });
    }
    function connect() {
      var promise;
      window.open(settings.connectUrl + '?return_url=' + userSettings.redirectUrl, 'connector', 'width=950,height=550');
      promise = new Promise(function (resolve, reject) {
        window.connectService = function (data) {
          var token, status;
          token = utils.getParameterByName(data, getParameterName());
          status = utils.getParameterByName(data, 'status');
          if (token && (!status || status !== 'FAIL')) {
            resolve(token);
          } else {
            reject(mappers.toError({
              code: 401,
              message: 'Not Authorized'
            }));
          }
        };
      });
      promise.then(function (token) {
        localStorage.setItem(settings.parameterName, token);
      }, function (reason) {
        return reason;
      });
      return promise;
    }
    return {
      isConnected: isConnected,
      disconnect: disconnect,
      connect: connect
    };
  };
}(bluebird_extended, connector_connector_settings, utils_http, utils_utils, utils_mappers);
services_bi_benchmarks = function (BIEventIds, sendBi) {
  function getCurrentTime() {
    return new Date().getTime();
  }
  function notifyResponseTime(adapter, eventName, data) {
    var requestName = adapter.name + '(' + eventName + ')';
    var responseTime = getCurrentTime() - data.startedAt;
    // TODO: if responseTime and responseSize
    //console.log('BI: [',requestName, '] ',responseTime, ' ms');
    if (responseTime > 0 && data.responseSize > 0) {
      sendBi('/mg', {
        src: 26,
        evid: BIEventIds.BIEventsIds.responseTime,
        call_name: requestName || '',
        result: data.isSuccess ? 'success' : 'fail',
        response_speed: Math.floor((data.responseSize || 0) / (responseTime / 1000)),
        response_time: responseTime || 0,
        response_size: data.responseSize
      });
    }
  }
  function benchmarkResponse(promise, params) {
    var startedAt = getCurrentTime();
    promise.then(function (result) {
      notifyResponseTime(params.eventTarget, params.eventName, {
        startedAt: startedAt,
        responseSize: result.responseSize,
        isSuccess: true
      });
    }).catch(function (result) {
      notifyResponseTime(params.eventTarget, params.eventName, {
        startedAt: startedAt,
        responseSize: result.responseSize,
        isSuccess: false
      });
    });
  }
  function benchmarkUpload(promise, params) {
    var startedAt = getCurrentTime();
    var fileSize = params.arguments[0].file.size;
    if (fileSize < 10240) {
      return;
    }
    promise.then(function () {
      var responseTime = (getCurrentTime() - startedAt) / 1000;
      if (responseTime < 1) {
        return;
      }
      sendBi('/mg', {
        src: 26,
        evid: BIEventIds.BIEventsIds.uploadSpeed,
        time_seconds: Math.floor(responseTime),
        size_bytes: fileSize,
        bytes_per_second: Math.floor(fileSize / responseTime)
      });
    }).catch(function (err) {
      console.warn(err);
    });
  }
  return {
    response: benchmarkResponse,
    upload: benchmarkUpload
  };
}(services_bi_event_ids, services_bi_send_request);
services_bi_errors = function (BIEventIds, sendBi, utils) {
  var catalogIds = {
    default: 0,
    private: 1,
    public: 2,
    // static - unused
    bigstock: 4,
    drive: 5,
    dropbox: 6,
    facebook: 7,
    flickr: 8,
    instagram: 9,
    picasa: 10
  };
  return function (adapterName, eventName, response, options) {
    var httpCode = response.code || '000';
    var adapterCode = BIEventIds.BIAdaptersIds[adapterName] || '00';
    var requestCode = BIEventIds.BIAdaptersRequestsIds[eventName] || '00';
    var errorDesc = adapterName + ' ' + eventName + ': ' + response.message;
    var errorCode = adapterCode + requestCode + httpCode;
    var errorName = adapterName + '.' + eventName + '.' + httpCode;
    // error code string
    return sendBi('/trg', {
      src: 25,
      evid: 10,
      cat: catalogIds[adapterName] || catalogIds.default,
      // event type
      iss: 1,
      // issue (sub-category)
      sev: BIEventIds.severity.error,
      errc: errorCode || '0000000',
      errn: errorName || '',
      ver: options.version || 'VERSION',
      did: options.siteId || '',
      p1: httpCode || '000',
      p2: utils.get(response, 'data.error_code') || '',
      p3: utils.get(response, 'data.error_info.key') || '',
      //p4: '',  // media type
      ts: options.requestTimeMs || '',
      dsc: errorDesc || ''
    });
  };
}(services_bi_event_ids, services_bi_send_request, utils_utils);
services_bi_upload_queue = function (BIEventIds, sendBi) {
  var currentUploadId = '';
  // 00000000-0000-0000-0000-000000000000 - 32 digits
  function generateId() {
    var id = '';
    while (id.length < 32) {
      id += Math.floor(Math.random() * 10000000000000000);
    }
    return [
      id.slice(0, 8),
      id.slice(8, 12),
      id.slice(12, 16),
      id.slice(16, 20),
      id.slice(20, 32)
    ].join('-');
  }
  function sendUploadStart() {
    currentUploadId = generateId();
    sendBi('/mg', {
      src: 26,
      evid: BIEventIds.BIEventsIds.uploadQueueStarted,
      upload_queue_id: currentUploadId
    });
  }
  function sendUploadFinish(queue) {
    sendBi('/mg', {
      src: 26,
      evid: BIEventIds.BIEventsIds.uploadQueueFinished,
      upload_queue_id: currentUploadId,
      files_count: queue.length
    });
  }
  return {
    start: sendUploadStart,
    finish: sendUploadFinish
  };
}(services_bi_event_ids, services_bi_send_request);
services_bi_bi = function (notifier, eventsList, benchmarks, sendError, Uploader, uploadQueue, utils) {
  return function (isEnabled, options) {
    function getCurrentTime() {
      return new Date().getTime();
    }
    var biListener = function (promise, params) {
      // params.eventTarget
      // params.eventName
      // if called by emitWithArrayOfPromises
      if (Array.isArray(promise)) {
        promise = Promise.all(promise);
      }
      benchmarks.response(promise, params);
      var reportSuccess = function () {
      };
      var requestStartTime = getCurrentTime();
      var reportError = function (response) {
        var currentOptions = utils.extend({ requestTimeMs: getCurrentTime() - requestStartTime }, options);
        sendError(params.eventTarget.name, params.eventName, response, currentOptions);
      };
      return promise.then(reportSuccess, reportError);
    };
    Object.keys(eventsList).forEach(function (group) {
      Object.keys(eventsList[group]).forEach(function (action) {
        if (isEnabled === true) {
          notifier.addListener(eventsList[group][action], biListener);
        } else {
          notifier.removeListener(eventsList[group][action], biListener);
        }
      });
    });
    if (isEnabled === true) {
      notifier.addListener(eventsList.ITEM.UPLOAD, benchmarks.upload);
    } else {
      notifier.removeListener(eventsList.ITEM.UPLOAD, benchmarks.upload);
    }
    if (isEnabled === true) {
      Uploader.on('uploadQueueStarted', uploadQueue.start);
      Uploader.on('uploadQueueFinished', uploadQueue.finish);
    }
  };
}(events_notifier, events_list, services_bi_benchmarks, services_bi_errors, services_upload_upload_collection, services_bi_upload_queue, utils_utils);
services_thumbnail_generator_thumbnail_generator = function (resize, getWixThumbnailsUrls, getWixVideoPreviewUrls) {
  return {
    resize: resize,
    getWixThumbnailsUrls: getWixThumbnailsUrls,
    getWixVideoPreviewUrls: getWixVideoPreviewUrls,
    APIS: {
      REMBRANDT: 'rembrandt',
      VANBRANDT: 'vanbrandt',
      VANGOGH: 'vangogh'
    },
    MODES: {
      FILL: 'fill',
      FIT: 'fit'
    }
  };
}(services_thumbnail_generator_resize, services_thumbnail_generator_get_wix_thumbnails_urls, services_thumbnail_generator_get_wix_video_preview_urls);
wixmp = function (Source, sources, events, externalSourceConnector, enableBI, Uploader, thumbnailGenerator) {
  /**
   * @namespace wixmp
   */
  return {
    Source: Source,
    sources: sources,
    events: events,
    thumbnailGenerator: thumbnailGenerator,
    bi: enableBI,
    connectExternalSource: externalSourceConnector,
    Uploader: Uploader
  };
}(sources_Source, sources_list, events_events, connector_connector, services_bi_bi, services_upload_upload_collection, services_thumbnail_generator_thumbnail_generator);
    return wixmp;
  };

  if (true) {
    var globalPromise = window.Promise;

    try {
      globalPromise = __webpack_require__(722);
    } catch (error) {
      console.warn('Bluebird is not available, requests cancellation will not work');
    }

    module.exports = factory(globalPromise);
  } else if (typeof define === 'function' && define.amd) {
    define('wixmp', ['require'], function (_require) {
      var globalPromise = window.Promise;

      try {
        globalPromise = _require('bluebird');
      } catch (error) {
        console.log('Bluebird is not available, requests cancellation will not work');
      }

      return factory(globalPromise);
    });
  } else {
    if (window.Promise !== window.P) {
      console.warn('Bluebird is not available, requests cancellation will not work');
    }

    window.wixmp = factory(window.Promise);
  }
})();


/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  SITE: 'site',
  EDITOR: 'editor',
  PREVIEW: 'preview',
  DASHBOARD: 'dashboard',
  STANDALONE: 'standalone'
});

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);



function find(map, keyToFind) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(map), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _step$value = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_step.value, 2),
          key = _step$value[0],
          value = _step$value[1];

      if (_.isEqual(keyToFind, key)) {
        return value;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

/* harmony default export */ __webpack_exports__["a"] = (function (fn) {
  var memoizedPartialFn = void 0;

  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  if (fn._memoizeCache) {
    memoizedPartialFn = find(fn._memoizeCache, args);
  } else {
    fn._memoizeCache = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a();
  }

  if (!memoizedPartialFn) {
    var _ref;

    memoizedPartialFn = (_ref = _).partial.apply(_ref, [fn].concat(args));
    fn._memoizeCache.set(args, memoizedPartialFn);
  }
  return memoizedPartialFn;
});

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IconButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TooltipIconButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_components_icon_icon__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_components_with_tooltip_with_tooltip__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__icon_styl__ = __webpack_require__(1171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__icon_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__icon_styl__);








var _dec, _class, _class2, _temp;











var IconButton = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_12__icon_styl___default.a), _dec(_class = (_temp = _class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(IconButton, _React$Component);

  function IconButton() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, IconButton);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (IconButton.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(IconButton)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(IconButton, [{
    key: 'render',
    value: function render() {
      var _ref;

      var _props = this.props,
          Button = _props.Button,
          name = _props.name,
          size = _props.size,
          iconClassName = _props.iconClassName,
          className = _props.className;

      var props = (_ref = _).omit.apply(_ref, [this.props, 'intl', 'styles', 'settings'].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(_.keys(IconButton.propTypes))));

      var label = this.label;

      var styleNames = __WEBPACK_IMPORTED_MODULE_7_classnames___default()('icon-button', {
        'icon-only': !label,
        generic: Button === __WEBPACK_IMPORTED_MODULE_9__button__["f" /* GenericButton */]
      });

      return React.createElement(
        Button,
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
          styleName: styleNames,
          className: className }),
        React.createElement(__WEBPACK_IMPORTED_MODULE_10_shared_components_icon_icon__["a" /* default */], { name: name,
          size: size,
          styleName: 'icon',
          className: iconClassName }),
        label
      );
    }
  }, {
    key: 'label',
    get: function get() {
      var _props2 = this.props,
          label = _props2.label,
          children = _props2.children;

      var text = _.isUndefined(label) ? children : label;

      if (!text) {
        return null;
      }

      return React.createElement(
        'span',
        { styleName: 'text' },
        text
      );
    }
  }]);

  return IconButton;
}(React.Component), _class2.propTypes = {
  Button: React.PropTypes.func,
  name: React.PropTypes.string,
  size: React.PropTypes.number,
  label: React.PropTypes.any,
  children: React.PropTypes.any,
  className: React.PropTypes.string,
  iconClassName: React.PropTypes.string
}, _class2.defaultProps = {
  Button: __WEBPACK_IMPORTED_MODULE_9__button__["f" /* GenericButton */]
}, _temp)) || _class);



var TooltipIconButton = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_shared_components_with_tooltip_with_tooltip__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_shared_components_with_tooltip_with_tooltip__["b" /* adaptShowStatePropsToClassName */])(IconButton));

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withTooltip;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return adaptShowStatePropsToClassName; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_utils_get_component_display_name__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_constants_popout__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_shapes_popout__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_shared_utils_pubsub__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_shared_constants_events__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_shared_components_tooltip_tooltip_popout__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__with_tooltip_styl__ = __webpack_require__(1175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__with_tooltip_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__with_tooltip_styl__);









function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

















function withTooltip(WrappedComponent) {
  var _dec, _class, _desc, _value, _class2, _class3, _temp2;

  var ComponentWithTooltip = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_shared_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_17__with_tooltip_styl___default.a), _dec(_class = (_class2 = (_temp2 = _class3 = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(ComponentWithTooltip, _React$Component);

    function ComponentWithTooltip() {
      var _ref;

      var _temp, _this, _ret;

      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, ComponentWithTooltip);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = ComponentWithTooltip.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(ComponentWithTooltip)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        tooltipIsShown: false
      }, _temp), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(ComponentWithTooltip, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this._tooltipId = _.uniqueId('with-tooltip-');
        this._tooltipDidShowUnsub = __WEBPACK_IMPORTED_MODULE_14_shared_utils_pubsub__["a" /* default */].subscribe(__WEBPACK_IMPORTED_MODULE_15_shared_constants_events__["a" /* default */].TOOLTIP.DID_SHOW, this.didShowTooltip);
        this._tooltipDidHideUnsub = __WEBPACK_IMPORTED_MODULE_14_shared_utils_pubsub__["a" /* default */].subscribe(__WEBPACK_IMPORTED_MODULE_15_shared_constants_events__["a" /* default */].TOOLTIP.DID_HIDE, this.didHideTooltip);
      }
    }, {
      key: 'componentWillUpdate',
      value: function componentWillUpdate(nextProps) {
        var noTooltip = nextProps.noTooltip;

        if (noTooltip !== this.props.noTooltip) {
          if (noTooltip) {
            this.hideTooltipPopout();
          } else {
            this.showTooltipPopout();
          }
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this._tooltipDidShowUnsub();
        this._tooltipDidHideUnsub();
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_shared_components_tooltip_tooltip_popout__["a" /* hideTooltip */])();
      }
    }, {
      key: 'didShowTooltip',
      value: function didShowTooltip(tooltipId) {
        if (tooltipId === this._tooltipId) {
          this.setState({ tooltipIsShown: true });
        }
      }
    }, {
      key: 'didHideTooltip',
      value: function didHideTooltip(tooltipId) {
        if (tooltipId === this._tooltipId) {
          this.setState({ tooltipIsShown: false });
        }
      }
    }, {
      key: 'showTooltipPopout',
      value: function showTooltipPopout(event) {
        var _props = this.props,
            noTooltip = _props.noTooltip,
            popoutSide = _props.popoutSide,
            preventHideOnHover = _props.preventHideOnHover,
            innerClassName = _props.innerClassName,
            text = _props.text,
            children = _props.children,
            onMouseEnter = _props.onMouseEnter;

        onMouseEnter(event);

        if (noTooltip) {
          return;
        }

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_shared_components_tooltip_tooltip_popout__["b" /* showTooltip */])({
          tooltipId: this._tooltipId,
          popoutSide: popoutSide,
          preventHideOnHover: preventHideOnHover,
          innerClassName: __WEBPACK_IMPORTED_MODULE_9_classnames___default()(__WEBPACK_IMPORTED_MODULE_17__with_tooltip_styl___default.a['tooltip-inner'], innerClassName),
          content: text || children,
          referenceElement: this.wrappedComponent
        });
      }
    }, {
      key: 'hideTooltipPopout',
      value: function hideTooltipPopout(event) {
        this.props.onMouseLeave(event);

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_shared_components_tooltip_tooltip_popout__["a" /* hideTooltip */])();
      }
    }, {
      key: 'getWrapperComponentRef',
      value: function getWrapperComponentRef(node) {
        this.props.getRef(node);
        this.wrappedComponent = node;
      }
    }, {
      key: 'render',
      value: function render() {
        var props = _.omit(this.props, ['styles', 'text', 'noTooltip', 'popoutSide', 'innerClassName', 'preventHideOnHover']);

        var shownStateClassName = __WEBPACK_IMPORTED_MODULE_9_classnames___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, this.props.shownStateClassName, this.state.tooltipIsShown));

        return React.createElement(WrappedComponent, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, props, {
          shownStateClassName: shownStateClassName,
          getRef: this.getWrapperComponentRef,
          onMouseEnter: this.showTooltipPopout,
          onMouseLeave: this.hideTooltipPopout }));
      }
    }]);

    return ComponentWithTooltip;
  }(React.Component), _class3.displayName = 'withTooltip(' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_shared_utils_get_component_display_name__["a" /* default */])(WrappedComponent) + ')', _class3.propTypes = {
    name: React.PropTypes.string,
    popoutSide: __WEBPACK_IMPORTED_MODULE_13_shared_shapes_popout__["a" /* sideShape */],
    preventHideOnHover: React.PropTypes.bool,
    innerClassName: React.PropTypes.string,
    shownStateClassName: React.PropTypes.string,
    text: React.PropTypes.any,
    noTooltip: React.PropTypes.bool,
    children: React.PropTypes.any,
    getRef: React.PropTypes.func,
    onMouseEnter: React.PropTypes.func,
    onMouseLeave: React.PropTypes.func
  }, _class3.defaultProps = {
    popoutSide: __WEBPACK_IMPORTED_MODULE_12_shared_constants_popout__["a" /* sides */].TOP,
    preventHideOnHover: false,
    shownStateClassName: '',
    noTooltip: false,
    getRef: _.noop,
    onMouseEnter: _.noop,
    onMouseLeave: _.noop
  }, _temp2), (_applyDecoratedDescriptor(_class2.prototype, 'didShowTooltip', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'didShowTooltip'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'didHideTooltip', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'didHideTooltip'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'showTooltipPopout', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'showTooltipPopout'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'hideTooltipPopout', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'hideTooltipPopout'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'getWrapperComponentRef', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'getWrapperComponentRef'), _class2.prototype)), _class2)) || _class);


  return ComponentWithTooltip;
}

var adaptProps = function adaptProps(convertFunction) {
  return function (Component) {
    return function (props) {
      var adaptedProps = _.isFunction(convertFunction) ? convertFunction(props) : null;

      return React.createElement(Component, adaptedProps);
    };
  };
};

var joinShownStateWithClassName = function joinShownStateWithClassName(props) {
  var shownStateClassName = props.shownStateClassName,
      className = props.className;

  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _.omit(props, 'shownStateClassName'), {
    className: __WEBPACK_IMPORTED_MODULE_9_classnames___default()(className, shownStateClassName)
  });
};

var adaptShowStatePropsToClassName = adaptProps(joinShownStateWithClassName);

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var topics = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  subscribe: function subscribe(topic, listener) {
    if (!topics[topic]) {
      topics[topic] = [];
    }

    var index = topics[topic].push(listener) - 1;

    return function () {
      topics[topic].splice(index, 1);
    };
  },
  publish: function publish(topic) {
    for (var _len = arguments.length, data = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      data[_key - 1] = arguments[_key];
    }

    if (!topics[topic]) {
      return;
    }

    _.forEach(topics[topic], function (item) {
      item.apply(undefined, data);
    });
  }
});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_event_emitter__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types_transcoding__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types_file__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types_item__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types_items__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types_list__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__types_list_items__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__types_lists__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__types_premium__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__types_uploading_progress__ = __webpack_require__(694);












function wrapWithRequestStates(eventsGroups) {
  return _.mapValues(eventsGroups, function (eventsByNames) {
    return _.mapValues(eventsByNames, function (event) {
      return {
        BEFORE: event + '.BEFORE',
        SUCCESS: event + '.SUCCESS',
        FAIL: event + '.FAIL'
      };
    });
  });
}

var requestEvents = {
  FILE: __WEBPACK_IMPORTED_MODULE_2__types_file__["a" /* default */],
  ITEM: __WEBPACK_IMPORTED_MODULE_3__types_item__["a" /* default */],
  ITEMS: __WEBPACK_IMPORTED_MODULE_4__types_items__["a" /* default */],
  LIST: __WEBPACK_IMPORTED_MODULE_5__types_list__["a" /* default */],
  LIST_ITEMS: __WEBPACK_IMPORTED_MODULE_6__types_list_items__["a" /* default */],
  LISTS: __WEBPACK_IMPORTED_MODULE_7__types_lists__["a" /* default */],
  PREMIUM: __WEBPACK_IMPORTED_MODULE_8__types_premium__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (_.assign(new __WEBPACK_IMPORTED_MODULE_0__utils_event_emitter__["a" /* default */](), {
  TRANSCODING: __WEBPACK_IMPORTED_MODULE_1__types_transcoding__["a" /* default */],
  UPLOADING_PROGRESS: __WEBPACK_IMPORTED_MODULE_9__types_uploading_progress__["a" /* default */]
}, wrapWithRequestStates(requestEvents)));

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_time__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_object__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_normalize_id__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_transcoding_statuses__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_free_deal_info__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_video_sources__ = __webpack_require__(205);








/* harmony default export */ __webpack_exports__["a"] = (function (adapterMethods, itemData) {

  if (!itemData) {
    return null;
  }

  itemData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_object__["keysToCamelCase"])(itemData);

  var _itemData = itemData,
      itemId = _itemData.itemId,
      externalId = _itemData.externalId,
      listId = _itemData.listId,
      mediaStatus = _itemData.mediaStatus,
      trailerStatus = _itemData.trailerStatus,
      mediaInfo = _itemData.mediaInfo,
      mediaExternUrl = _itemData.mediaExternUrl,
      _itemData$videoSource = _itemData.videoSource,
      videoSource = _itemData$videoSource === undefined ? __WEBPACK_IMPORTED_MODULE_5__constants_video_sources__["a" /* default */].COMPUTER : _itemData$videoSource;


  var id = itemId && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_normalize_id__["a" /* normalizeId */])(itemId) || externalId;

  var _itemData2 = itemData,
      customCoverUrl = _itemData2.customCoverUrl,
      createdTs = _itemData2.createdTs,
      updatedTs = _itemData2.updatedTs,
      publishTs = _itemData2.publishTs,
      dealInfo = _itemData2.dealInfo,
      usedInLists = _itemData2.usedInLists,
      durationSec = _itemData2.durationSec,
      durationStr = _itemData2.durationStr,
      _itemData2$tags = _itemData2.tags,
      tags = _itemData2$tags === undefined ? [] : _itemData2$tags,
      _itemData2$categories = _itemData2.categories,
      categories = _itemData2$categories === undefined ? [] : _itemData2$categories;


  customCoverUrl = customCoverUrl || null;

  createdTs = new Date(createdTs * 1000);
  updatedTs = new Date(updatedTs * 1000);
  if (publishTs) {
    publishTs = new Date(publishTs * 1000);
  }

  usedInLists = _.map(usedInLists, function (_ref) {
    var itemId = _ref.itemId,
        title = _ref.title;
    return {
      id: itemId,
      title: title
    };
  });

  var fileInputDurationSec = _.get(mediaInfo, 'fileInput.duration', 0);
  if (fileInputDurationSec) {
    durationSec = Math.floor(fileInputDurationSec / 1000);
    durationStr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_time__["convertSSToMMSS"])(durationSec);
  }
  if (!durationStr) {
    durationStr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_time__["convertSSToMMSS"])(durationSec);
  }

  var getVideoUrls = _.partial(adapterMethods.item.getVideoUrls, _.noop, itemId);
  var getVideoUrlsByFileName = _.partial(adapterMethods.item.getVideoUrlsByFileName, _.noop);

  var transcodingStatus = mediaExternUrl ? __WEBPACK_IMPORTED_MODULE_3__constants_transcoding_statuses__["a" /* default */].READY : mediaStatus || __WEBPACK_IMPORTED_MODULE_3__constants_transcoding_statuses__["a" /* default */].NONE;

  // external videos should be free
  if (mediaExternUrl) {
    dealInfo = __WEBPACK_IMPORTED_MODULE_4__constants_free_deal_info__["a" /* default */];
  }

  tags = _.uniq(tags);
  categories = _.uniq(categories);

  // TODO: add mapping instead assign
  itemData = _({}).assign(itemData, {
    id: id,
    listId: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_normalize_id__["a" /* normalizeId */])(listId),
    customCoverUrl: customCoverUrl,
    transcodingStatus: transcodingStatus,
    trailerTranscodingStatus: trailerStatus || __WEBPACK_IMPORTED_MODULE_3__constants_transcoding_statuses__["a" /* default */].NONE,
    dealInfo: dealInfo,
    durationSec: durationSec,
    durationStr: durationStr,
    createdTs: createdTs,
    updatedTs: updatedTs,
    publishTs: publishTs,
    usedInLists: usedInLists,
    getVideoUrls: getVideoUrls,
    getVideoUrlsByFileName: getVideoUrlsByFileName,
    videoSource: videoSource,
    tags: tags,
    categories: categories
  }).omit('itemId', 'mediaStatus', 'trailerStatus').value();

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_object__["removeUndefinedValues"])(itemData);
});

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = triggerProgressWhileTranscoding;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_transcoding_statuses__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__channels_channels__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__events_index__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_wixmp_sdk__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_wixmp_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_wixmp_sdk__);






var itemsTranscodingStatuses = {};

var LISTENER_NAME = 'transcoding';

var TRANSCODING_PROGRESS_STATUSES = [__WEBPACK_IMPORTED_MODULE_0__constants_transcoding_statuses__["a" /* default */].IN_QUEUE, __WEBPACK_IMPORTED_MODULE_0__constants_transcoding_statuses__["a" /* default */].PENDING, __WEBPACK_IMPORTED_MODULE_0__constants_transcoding_statuses__["a" /* default */].INPROGRESS, __WEBPACK_IMPORTED_MODULE_0__constants_transcoding_statuses__["a" /* default */].PREVIEW_READY];

function isNotInTranscoding(transcodingStatus) {
  return !_.includes(TRANSCODING_PROGRESS_STATUSES, transcodingStatus);
}

function stopListenTranscoding() {
  if (_.every(itemsTranscodingStatuses, isNotInTranscoding)) {
    __WEBPACK_IMPORTED_MODULE_1__channels_channels__["a" /* default */].stopListen(LISTENER_NAME);
  }
}

if (__WEBPACK_IMPORTED_MODULE_3_wixmp_sdk___default.a) {
  __WEBPACK_IMPORTED_MODULE_3_wixmp_sdk___default.a.events.on(__WEBPACK_IMPORTED_MODULE_3_wixmp_sdk___default.a.events.ITEM.UPDATE, function (eventPromise, event) {
    if (event.eventTarget !== __WEBPACK_IMPORTED_MODULE_1__channels_channels__["a" /* default */].privateMedia) {
      return;
    }

    eventPromise.then(function (_ref) {
      var data = _ref.data;

      // don't remove this console.info call for now
      console.info('CHANNELS API', data); // eslint-disable-line no-console

      var transcodingStatus = data.transcodingStatus.toUpperCase();
      itemsTranscodingStatuses[data.id] = transcodingStatus;

      __WEBPACK_IMPORTED_MODULE_2__events_index__["a" /* default */].trigger(__WEBPACK_IMPORTED_MODULE_2__events_index__["a" /* default */].TRANSCODING.UPDATE, {
        id: data.id,
        transcodingStatus: transcodingStatus
      });
      stopListenTranscoding();
    });
  });
}

function triggerProgressWhileTranscoding(items) {
  // TODO: handle small files uploading

  if (items) {
    if (_.every(items, function (_ref2) {
      var transcodingStatus = _ref2.transcodingStatus,
          trailerTranscodingStatus = _ref2.trailerTranscodingStatus;

      return isNotInTranscoding(transcodingStatus) && isNotInTranscoding(trailerTranscodingStatus);
    })) {
      return;
    }

    _.forEach(items, function (_ref3) {
      var mediaFileName = _ref3.mediaFileName,
          trailerFileName = _ref3.trailerFileName,
          transcodingStatus = _ref3.transcodingStatus,
          trailerTranscodingStatus = _ref3.trailerTranscodingStatus;

      if (mediaFileName) {
        itemsTranscodingStatuses[mediaFileName] = transcodingStatus;
      }
      if (trailerFileName) {
        itemsTranscodingStatuses[trailerFileName] = trailerTranscodingStatus;
      }
    });
  }

  __WEBPACK_IMPORTED_MODULE_1__channels_channels__["a" /* default */].startListen(LISTENER_NAME);
}

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = InternalError;
/* harmony export (immutable) */ __webpack_exports__["a"] = parseError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

function InternalError(status, code, message) {
  this.status = status;
  this.code = code;
  this.message = message;
  this.name = this.constructor.name;
}

InternalError.prototype = _.create(Error.prototype);

function parseError(response) {
  if (response instanceof InternalError) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(parseInternalError(response));
  }

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(parseNativeError(response));
}

function parseNativeError(response) {
  var status = response.status,
      error = response.error,
      _response$data = response.data,
      data = _response$data === undefined ? {} : _response$data;


  if (error) {
    return response;
  }

  var _data$error = data.error,
      code = _data$error.code,
      errors = _data$error.errors;


  var message = _(errors).map(function (error) {
    return error.reason + ': ' + error.message;
  }).join(';\n');

  return {
    status: status,
    error: {
      code: code,
      message: message
    }
  };
}

function parseInternalError() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      status = _ref.status,
      code = _ref.code,
      message = _ref.message;

  return {
    status: status,
    error: {
      code: code,
      message: message
    }
  };
}

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  CHANNEL: 'channel',
  YOUTUBE_FEED: 'youtube-feed'
});

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{ type: 'rent', price: 0.01, enabled: false, period: 24 }, { type: 'sale', price: 0.01, enabled: false, period: 0 }]);

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  COMPUTER: 'computer',
  DROPBOX: 'dropbox',
  GOOGLE_DRIVE: 'google-drive',
  YOUTUBE: 'youtube',
  VIMEO: 'vimeo',
  FACEBOOK: 'facebook'
});

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SELECTED_VIDEO_ACTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return selectVideo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return resetSelectedVideo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);


var SELECTED_VIDEO_ACTIONS = {
  SET: 'CLIENT.SELECTED_VIDEO.SET',
  RESET: 'CLIENT.SELECTED_VIDEO.RESET'
};

var selectVideo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(SELECTED_VIDEO_ACTIONS.SET);
var resetSelectedVideo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(SELECTED_VIDEO_ACTIONS.RESET);

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(738), __esModule: true };

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(170)
  , TAG = __webpack_require__(48)('toStringTag')
  // ES3 wrong here
  , ARG = cof(function(){ return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function(it, key){
  try {
    return it[key];
  } catch(e){ /* empty */ }
};

module.exports = function(it){
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

/***/ }),
/* 209 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

var ctx         = __webpack_require__(97)
  , call        = __webpack_require__(444)
  , isArrayIter = __webpack_require__(442)
  , anObject    = __webpack_require__(86)
  , toLength    = __webpack_require__(214)
  , getIterFn   = __webpack_require__(291)
  , BREAK       = {}
  , RETURN      = {};
var exports = module.exports = function(iterable, entries, fn, that, ITERATOR){
  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)
    , f      = ctx(fn, that, entries ? 2 : 1)
    , index  = 0
    , length, step, iterator, result;
  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if(result === BREAK || result === RETURN)return result;
  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
    result = call(iterator, f, step.value, entries);
    if(result === BREAK || result === RETURN)return result;
  }
};
exports.BREAK  = BREAK;
exports.RETURN = RETURN;

/***/ }),
/* 211 */
/***/ (function(module, exports) {

module.exports = true;

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject    = __webpack_require__(86)
  , dPs         = __webpack_require__(756)
  , enumBugKeys = __webpack_require__(278)
  , IE_PROTO    = __webpack_require__(285)('IE_PROTO')
  , Empty       = function(){ /* empty */ }
  , PROTOTYPE   = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function(){
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(277)('iframe')
    , i      = enumBugKeys.length
    , lt     = '<'
    , gt     = '>'
    , iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(440).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties){
  var result;
  if(O !== null){
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty;
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 213 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(287)
  , min       = Math.min;
module.exports = function(it){
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),
/* 215 */
/***/ (function(module, exports) {

var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(60)
  , toLength  = __webpack_require__(43)
  , toIndex   = __webpack_require__(126);
module.exports = function(IS_INCLUDES){
  return function($this, el, fromIndex){
    var O      = toIObject($this)
      , length = toLength(O.length)
      , index  = toIndex(fromIndex, length)
      , value;
    // Array#includes uses SameValueZero equality algorithm
    if(IS_INCLUDES && el != el)while(length > index){
      value = O[index++];
      if(value != value)return true;
    // Array#toIndex ignores holes, Array#includes - not
    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
      if(O[index] === el)return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global            = __webpack_require__(21)
  , $export           = __webpack_require__(6)
  , redefine          = __webpack_require__(58)
  , redefineAll       = __webpack_require__(124)
  , meta              = __webpack_require__(101)
  , forOf             = __webpack_require__(142)
  , anInstance        = __webpack_require__(119)
  , isObject          = __webpack_require__(28)
  , fails             = __webpack_require__(24)
  , $iterDetect       = __webpack_require__(222)
  , setToStringTag    = __webpack_require__(144)
  , inheritIfRequired = __webpack_require__(299);

module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
  var Base  = global[NAME]
    , C     = Base
    , ADDER = IS_MAP ? 'set' : 'add'
    , proto = C && C.prototype
    , O     = {};
  var fixMethod = function(KEY){
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function(a){
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a){
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a){
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a){ fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b){ fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if(typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
    new C().entries().next();
  }))){
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance             = new C
      // early implementations not supports chaining
      , HASNT_CHAINING       = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance
      // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
      , THROWS_ON_PRIMITIVES = fails(function(){ instance.has(1); })
      // most early implementations doesn't supports iterables, most modern - not close it correctly
      , ACCEPT_ITERABLES     = $iterDetect(function(iter){ new C(iter); }) // eslint-disable-line no-new
      // for early implementations -0 and +0 not the same
      , BUGGY_ZERO = !IS_WEAK && fails(function(){
        // V8 ~ Chromium 42- fails only with 5+ elements
        var $instance = new C()
          , index     = 5;
        while(index--)$instance[ADDER](index, index);
        return !$instance.has(-0);
      });
    if(!ACCEPT_ITERABLES){ 
      C = wrapper(function(target, iterable){
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base, target, C);
        if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if(THROWS_ON_PRIMITIVES || BUGGY_ZERO){
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if(BUGGY_ZERO || HASNT_CHAINING)fixMethod(ADDER);
    // weak collections should not contains .clear method
    if(IS_WEAK && proto.clear)delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);

  return C;
};

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var hide     = __webpack_require__(57)
  , redefine = __webpack_require__(58)
  , fails    = __webpack_require__(24)
  , defined  = __webpack_require__(75)
  , wks      = __webpack_require__(29);

module.exports = function(KEY, length, exec){
  var SYMBOL   = wks(KEY)
    , fns      = exec(defined, SYMBOL, ''[KEY])
    , strfn    = fns[0]
    , rxfn     = fns[1];
  if(fails(function(){
    var O = {};
    O[SYMBOL] = function(){ return 7; };
    return ''[KEY](O) != 7;
  })){
    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function(string, arg){ return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function(string){ return rxfn.call(string, this); }
    );
  }
};

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(20);
module.exports = function(){
  var that   = anObject(this)
    , result = '';
  if(that.global)     result += 'g';
  if(that.ignoreCase) result += 'i';
  if(that.multiline)  result += 'm';
  if(that.unicode)    result += 'u';
  if(that.sticky)     result += 'y';
  return result;
};

/***/ }),
/* 220 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function(fn, args, that){
  var un = that === undefined;
  switch(args.length){
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return              fn.apply(that, args);
};

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(28)
  , cof      = __webpack_require__(74)
  , MATCH    = __webpack_require__(29)('match');
module.exports = function(it){
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR     = __webpack_require__(29)('iterator')
  , SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function(){ SAFE_CLOSING = true; };
  Array.from(riter, function(){ throw 2; });
} catch(e){ /* empty */ }

module.exports = function(exec, skipClosing){
  if(!skipClosing && !SAFE_CLOSING)return false;
  var safe = false;
  try {
    var arr  = [7]
      , iter = arr[ITERATOR]();
    iter.next = function(){ return {done: safe = true}; };
    arr[ITERATOR] = function(){ return iter; };
    exec(arr);
  } catch(e){ /* empty */ }
  return safe;
};

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(120)|| !__webpack_require__(24)(function(){
  var K = Math.random();
  // In FF throws only define methods
  __defineSetter__.call(null, K, function(){ /* empty */});
  delete __webpack_require__(21)[K];
});

/***/ }),
/* 224 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(21)
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(21)
  , hide   = __webpack_require__(57)
  , uid    = __webpack_require__(127)
  , TYPED  = uid('typed_array')
  , VIEW   = uid('view')
  , ABV    = !!(global.ArrayBuffer && global.DataView)
  , CONSTR = ABV
  , i = 0, l = 9, Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while(i < l){
  if(Typed = global[TypedArrayConstructors[i++]]){
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV:    ABV,
  CONSTR: CONSTR,
  TYPED:  TYPED,
  VIEW:   VIEW
};

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/**
 * Indicates that navigation was caused by a call to history.push.
 */
var PUSH = exports.PUSH = 'PUSH';

/**
 * Indicates that navigation was caused by a call to history.replace.
 */
var REPLACE = exports.REPLACE = 'REPLACE';

/**
 * Indicates that navigation was caused by some other action such
 * as using a browser's back/forward buttons and/or manually manipulating
 * the URL in a browser's location bar. This is the default.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
 * for more information.
 */
var POP = exports.POP = 'POP';

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(1066),
    listCacheDelete = __webpack_require__(1067),
    listCacheGet = __webpack_require__(1068),
    listCacheHas = __webpack_require__(1069),
    listCacheSet = __webpack_require__(1070);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(167);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(1064);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(129);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(81),
    stubFalse = __webpack_require__(1110);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(181)(module)))

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(1021),
    baseUnary = __webpack_require__(611),
    nodeUtil = __webpack_require__(1080);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 235 */,
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DataLoader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_component__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind__);








var _desc, _value, _class;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}




var DataLoader = (_class = function (_DataComponent) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(DataLoader, _DataComponent);

  function DataLoader() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, DataLoader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = DataLoader.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(DataLoader)).call.apply(_ref, [this].concat(args))), _this), _this.dependencies = [], _this.isNeedReload = false, _this.currentLoadingPromise = null, _this.state = {
      isFetching: false
    }, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(DataLoader, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.loadDataDebounced(false);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.willBeSomethingChanged(prevProps, this.dependencies)) {
        this.loadDataDebounced(true);
      }
    }
  }, {
    key: 'willBeSomethingChanged',
    value: function willBeSomethingChanged(nextProps, dependencies) {
      var _this2 = this;

      return _.some(dependencies, function (namespace) {
        var currentValue = _.get(_this2.props, namespace);
        var nextValue = _.get(nextProps, namespace);

        return !_.isEqual(currentValue, nextValue);
      });
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      return null;
    }
  }, {
    key: 'resetStateAndReload',
    value: function resetStateAndReload(force) {
      this.currentLoadingPromise = null;
      if (this.isNeedReload) {
        this.isNeedReload = false;
        this.loadDataDebounced(force);
      }
      this.setState({
        isFetching: false
      });
    }
  }, {
    key: 'loadDataDebounced',
    value: function loadDataDebounced(force) {
      var _this3 = this;

      if (this.currentLoadingPromise) {
        this.isNeedReload = true;
        return;
      }

      var promise = this.loadData(force);
      if (!promise) {
        return;
      }

      this.setState({
        isFetching: true
      });

      this.currentLoadingPromise = promise.then(function (res) {
        _this3.resetStateAndReload(force);
        return res;
      }, function (err) {
        _this3.resetStateAndReload(force);
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
      });
    }
  }, {
    key: 'onceAtTime',
    value: function onceAtTime(fn) {
      var _this4 = this;

      return function () {
        if (_this4._loading) {
          return;
        }
        _this4._loading = true;
        fn.apply(undefined, arguments).then(function () {
          _this4._loading = false;
        }).catch(function () {
          _this4._loading = false;
        });
      };
    }
  }]);

  return DataLoader;
}(__WEBPACK_IMPORTED_MODULE_7__data_component__["a" /* default */]), (_applyDecoratedDescriptor(_class.prototype, 'loadDataDebounced', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'loadDataDebounced'), _class.prototype)), _class);


/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDisplayName;
function getDisplayName(Component) {
  return Component.displayName || Component.name || 'Component';
}

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
  value: true
});

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _coreEventsEventsBase = __webpack_require__(319);

var _coreEventsEventsBase2 = _interopRequireDefault(_coreEventsEventsBase);

/**
 * @class
 *
 */

var MediaPlayerEvents = (function (_EventsBase) {
  _inherits(MediaPlayerEvents, _EventsBase);

  /**
   * @description Public facing external events to be used when developing a player that implements dash.js.
   */

  function MediaPlayerEvents() {
    _classCallCheck(this, MediaPlayerEvents);

    _get(Object.getPrototypeOf(MediaPlayerEvents.prototype), 'constructor', this).call(this);
    /**
     * Triggered when playback will not start yet
     * as the MPD's availabilityStartTime is in the future.
     * Check delay property in payload to determine time before playback will start.
     */
    this.AST_IN_FUTURE = 'astInFuture';
    /**
     * Triggered when the video element's buffer state changes to stalled.
     * Check mediaType in payload to determine type (Video, Audio, FragmentedText).
     * @event MediaPlayerEvents#BUFFER_EMPTY
     */
    this.BUFFER_EMPTY = 'bufferStalled';
    /**
     * Triggered when the video element's buffer state changes to loaded.
     * Check mediaType in payload to determine type (Video, Audio, FragmentedText).
     * @event MediaPlayerEvents#BUFFER_LOADED
     */
    this.BUFFER_LOADED = 'bufferLoaded';

    /**
     * Triggered when the video element's buffer state changes, either stalled or loaded. Check payload for state.
     * @event MediaPlayerEvents#BUFFER_LEVEL_STATE_CHANGED
     */
    this.BUFFER_LEVEL_STATE_CHANGED = 'bufferStateChanged';

    /**
    * Triggered when there is an error from the element or MSE source buffer.
    * @event MediaPlayerEvents#ERROR
    */
    this.ERROR = 'error';

    /**
    * Triggered when a fragment download has completed.
    * @event MediaPlayerEvents#FRAGMENT_LOADING_COMPLETED
    */
    this.FRAGMENT_LOADING_COMPLETED = 'fragmentLoadingCompleted';
    /**
    * Triggered when a fragment download has started.
    * @event MediaPlayerEvents#FRAGMENT_LOADING_STARTED
    */
    this.FRAGMENT_LOADING_STARTED = 'fragmentLoadingStarted';
    /**
    * Triggered when a fragment download is abandoned due to detection of slow download base on the ABR abandon rule..
    * @event MediaPlayerEvents#FRAGMENT_LOADING_ABANDONED
    */
    this.FRAGMENT_LOADING_ABANDONED = 'fragmentLoadingAbandoned';
    /**
     * Triggered when {@link module:Debug} log method is called.
     * @event MediaPlayerEvents#LOG
     */
    this.LOG = 'log';
    //TODO refactor with internal event
    /**
     * Triggered when the manifest load is complete
     * @event MediaPlayerEvents#MANIFEST_LOADED
     */
    this.MANIFEST_LOADED = 'manifestLoaded';
    /**
     * Triggered anytime there is a change to the overall metrics.
     * @event MediaPlayerEvents#METRICS_CHANGED
     */
    this.METRICS_CHANGED = 'metricsChanged';
    /**
     * Triggered when an individual metric is added, updated or cleared.
     * @event MediaPlayerEvents#METRIC_CHANGED
     */
    this.METRIC_CHANGED = 'metricChanged';
    /**
     * Triggered every time a new metric is added.
     * @event MediaPlayerEvents#METRIC_ADDED
     */
    this.METRIC_ADDED = 'metricAdded';
    /**
     * Triggered every time a metric is updated.
     * @event MediaPlayerEvents#METRIC_UPDATED
     */
    this.METRIC_UPDATED = 'metricUpdated';
    /**
     * Triggered at the stream end of a period.
     * @event MediaPlayerEvents#PERIOD_SWITCH_COMPLETED
     */
    this.PERIOD_SWITCH_COMPLETED = 'periodSwitchCompleted';
    /**
     * Triggered when a new period starts.
     * @event MediaPlayerEvents#PERIOD_SWITCH_STARTED
     */
    this.PERIOD_SWITCH_STARTED = 'periodSwitchStarted';

    /**
     * Triggered when an ABR up /down switch is initialed; either by user in manual mode or auto mode via ABR rules.
     * @event MediaPlayerEvents#QUALITY_CHANGE_REQUESTED
     */
    this.QUALITY_CHANGE_REQUESTED = 'qualityChangeRequested';

    /**
     * Triggered when the new ABR quality is being rendered on-screen.
     * @event MediaPlayerEvents#QUALITY_CHANGE_RENDERED
     */
    this.QUALITY_CHANGE_RENDERED = 'qualityChangeRendered';

    /**
     * Triggered when the stream is setup and ready.
     * @event MediaPlayerEvents#STREAM_INITIALIZED
     */
    this.STREAM_INITIALIZED = 'streamInitialized';
    /**
     * Triggered once all text tracks detected in the MPD are added to the video element.
     * @event MediaPlayerEvents#TEXT_TRACKS_ADDED
     */
    this.TEXT_TRACKS_ADDED = 'allTextTracksAdded';
    /**
     * Triggered when a text track is added to the video element's TextTrackList
     * @event MediaPlayerEvents#TEXT_TRACK_ADDED
     */
    this.TEXT_TRACK_ADDED = 'textTrackAdded';

    /**
     * Sent when enough data is available that the media can be played,
     * at least for a couple of frames.  This corresponds to the
     * HAVE_ENOUGH_DATA readyState.
     * @event MediaPlayerEvents#CAN_PLAY
     */
    this.CAN_PLAY = 'canPlay';

    /**
     * Sent when playback completes.
     * @event MediaPlayerEvents#PLAYBACK_ENDED
     */
    this.PLAYBACK_ENDED = 'playbackEnded';

    /**
     * Sent when an error occurs.  The element's error
     * attribute contains more information.
     * @event MediaPlayerEvents#PLAYBACK_ERROR
     */
    this.PLAYBACK_ERROR = 'playbackError';
    /**
     * Sent when playback is not allowed (for example if user gesture is needed).
     * @event MediaPlayerEvents#PLAYBACK_NOT_ALLOWED
     */
    this.PLAYBACK_NOT_ALLOWED = 'playbackNotAllowed';
    /**
     * The media's metadata has finished loading; all attributes now
     * contain as much useful information as they're going to.
     * @event MediaPlayerEvents#PLAYBACK_METADATA_LOADED
     */
    this.PLAYBACK_METADATA_LOADED = 'playbackMetaDataLoaded';
    /**
     * Sent when playback is paused.
     * @event MediaPlayerEvents#PLAYBACK_PAUSED
     */
    this.PLAYBACK_PAUSED = 'playbackPaused';
    /**
     * Sent when the media begins to play (either for the first time, after having been paused,
     * or after ending and then restarting).
     *
     * @event MediaPlayerEvents#PLAYBACK_PLAYING
     */
    this.PLAYBACK_PLAYING = 'playbackPlaying';
    /**
     * Sent periodically to inform interested parties of progress downloading
     * the media. Information about the current amount of the media that has
     * been downloaded is available in the media element's buffered attribute.
     * @event MediaPlayerEvents#PLAYBACK_PROGRESS
     */
    this.PLAYBACK_PROGRESS = 'playbackProgress';
    /**
     * Sent when the playback speed changes.
     * @event MediaPlayerEvents#PLAYBACK_RATE_CHANGED
     */
    this.PLAYBACK_RATE_CHANGED = 'playbackRateChanged';
    /**
     * Sent when a seek operation completes.
     * @event MediaPlayerEvents#PLAYBACK_SEEKED
     */
    this.PLAYBACK_SEEKED = 'playbackSeeked';
    /**
     * Sent when a seek operation begins.
     * @event MediaPlayerEvents#PLAYBACK_SEEKING
     */
    this.PLAYBACK_SEEKING = 'playbackSeeking';
    /**
     * Sent when playback of the media starts after having been paused;
     * that is, when playback is resumed after a prior pause event.
     *
     * @event MediaPlayerEvents#PLAYBACK_STARTED
     */
    this.PLAYBACK_STARTED = 'playbackStarted';
    /**
     * The time indicated by the element's currentTime attribute has changed.
     * @event MediaPlayerEvents#PLAYBACK_TIME_UPDATED
     */
    this.PLAYBACK_TIME_UPDATED = 'playbackTimeUpdated';
  }

  return MediaPlayerEvents;
})(_coreEventsEventsBase2['default']);

var mediaPlayerEvents = new MediaPlayerEvents();
exports['default'] = mediaPlayerEvents;
module.exports = exports['default'];
//# sourceMappingURL=MediaPlayerEvents.js.map


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _voMetricsHTTPRequest = __webpack_require__(84);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _modelsMediaPlayerModel = __webpack_require__(67);

var _modelsMediaPlayerModel2 = _interopRequireDefault(_modelsMediaPlayerModel);

var _utilsErrorHandlerJs = __webpack_require__(136);

var _utilsErrorHandlerJs2 = _interopRequireDefault(_utilsErrorHandlerJs);

/**
 * @module XHRLoader
 * @description Manages download of resources via HTTP.
 * @param {Object} cfg - dependancies from parent
 */
function XHRLoader(cfg) {
    var context = this.context;

    //const log = Debug(context).getInstance().log;
    var mediaPlayerModel = (0, _modelsMediaPlayerModel2['default'])(context).getInstance();

    var errHandler = cfg.errHandler;
    var metricsModel = cfg.metricsModel;
    var requestModifier = cfg.requestModifier;

    var instance = undefined;
    var xhrs = undefined;
    var delayedXhrs = undefined;
    var retryTimers = undefined;
    var downloadErrorToRequestTypeMap = undefined;

    function setup() {
        var _downloadErrorToRequestTypeMap;

        xhrs = [];
        delayedXhrs = [];
        retryTimers = [];

        downloadErrorToRequestTypeMap = (_downloadErrorToRequestTypeMap = {}, _defineProperty(_downloadErrorToRequestTypeMap, _voMetricsHTTPRequest.HTTPRequest.MPD_TYPE, _utilsErrorHandlerJs2['default'].DOWNLOAD_ERROR_ID_MANIFEST), _defineProperty(_downloadErrorToRequestTypeMap, _voMetricsHTTPRequest.HTTPRequest.XLINK_EXPANSION_TYPE, _utilsErrorHandlerJs2['default'].DOWNLOAD_ERROR_ID_XLINK), _defineProperty(_downloadErrorToRequestTypeMap, _voMetricsHTTPRequest.HTTPRequest.INIT_SEGMENT_TYPE, _utilsErrorHandlerJs2['default'].DOWNLOAD_ERROR_ID_INITIALIZATION), _defineProperty(_downloadErrorToRequestTypeMap, _voMetricsHTTPRequest.HTTPRequest.MEDIA_SEGMENT_TYPE, _utilsErrorHandlerJs2['default'].DOWNLOAD_ERROR_ID_CONTENT), _defineProperty(_downloadErrorToRequestTypeMap, _voMetricsHTTPRequest.HTTPRequest.INDEX_SEGMENT_TYPE, _utilsErrorHandlerJs2['default'].DOWNLOAD_ERROR_ID_CONTENT), _defineProperty(_downloadErrorToRequestTypeMap, _voMetricsHTTPRequest.HTTPRequest.BITSTREAM_SWITCHING_SEGMENT_TYPE, _utilsErrorHandlerJs2['default'].DOWNLOAD_ERROR_ID_CONTENT), _defineProperty(_downloadErrorToRequestTypeMap, _voMetricsHTTPRequest.HTTPRequest.OTHER_TYPE, _utilsErrorHandlerJs2['default'].DOWNLOAD_ERROR_ID_CONTENT), _downloadErrorToRequestTypeMap);
    }

    function internalLoad(config, remainingAttempts) {

        var request = config.request;
        var xhr = new XMLHttpRequest();
        var traces = [];
        var firstProgress = true;
        var needFailureReport = true;
        var requestStartTime = new Date();
        var lastTraceTime = requestStartTime;
        var lastTraceReceivedCount = 0;

        var handleLoaded = function handleLoaded(success) {
            needFailureReport = false;

            request.requestStartDate = requestStartTime;
            request.requestEndDate = new Date();
            request.firstByteDate = request.firstByteDate || requestStartTime;

            if (!request.checkExistenceOnly) {
                metricsModel.addHttpRequest(request.mediaType, null, request.type, request.url, xhr.responseURL || null, request.serviceLocation || null, request.range || null, request.requestStartDate, request.firstByteDate, request.requestEndDate, xhr.status, request.duration, xhr.getAllResponseHeaders(), success ? traces : null);
            }
        };

        var onloadend = function onloadend() {
            if (xhrs.indexOf(xhr) === -1) {
                return;
            } else {
                xhrs.splice(xhrs.indexOf(xhr), 1);
            }

            if (needFailureReport) {
                handleLoaded(false);

                if (remainingAttempts > 0) {
                    remainingAttempts--;
                    retryTimers.push(setTimeout(function () {
                        internalLoad(config, remainingAttempts);
                    }, mediaPlayerModel.getRetryIntervalForType(request.type)));
                } else {
                    errHandler.downloadError(downloadErrorToRequestTypeMap[request.type], request.url, request);

                    if (config.error) {
                        config.error(request, 'error', xhr.statusText);
                    }

                    if (config.complete) {
                        config.complete(request, xhr.statusText);
                    }
                }
            }
        };

        var progress = function progress(event) {
            var currentTime = new Date();

            if (firstProgress) {
                firstProgress = false;
                if (!event.lengthComputable || event.lengthComputable && event.total !== event.loaded) {
                    request.firstByteDate = currentTime;
                }
            }

            if (event.lengthComputable) {
                request.bytesLoaded = event.loaded;
                request.bytesTotal = event.total;
            }

            traces.push({
                s: lastTraceTime,
                d: currentTime.getTime() - lastTraceTime.getTime(),
                b: [event.loaded ? event.loaded - lastTraceReceivedCount : 0]
            });

            lastTraceTime = currentTime;
            lastTraceReceivedCount = event.loaded;

            if (config.progress) {
                config.progress();
            }
        };

        var onload = function onload() {
            if (xhr.status >= 200 && xhr.status <= 299) {
                handleLoaded(true);

                if (config.success) {
                    config.success(xhr.response, xhr.statusText, xhr);
                }

                if (config.complete) {
                    config.complete(request, xhr.statusText);
                }
            }
        };

        try {
            var modifiedUrl = requestModifier.modifyRequestURL(request.url);
            var verb = request.checkExistenceOnly ? 'HEAD' : 'GET';

            xhr.open(verb, modifiedUrl, true);

            if (request.responseType) {
                xhr.responseType = request.responseType;
            }

            if (request.range) {
                xhr.setRequestHeader('Range', 'bytes=' + request.range);
            }

            if (!request.requestStartDate) {
                request.requestStartDate = requestStartTime;
            }

            xhr = requestModifier.modifyRequestHeader(xhr);

            xhr.withCredentials = mediaPlayerModel.getXHRWithCredentialsForType(request.type);

            xhr.onload = onload;
            xhr.onloadend = onloadend;
            xhr.onerror = onloadend;
            xhr.onprogress = progress;

            // Adds the ability to delay single fragment loading time to control buffer.
            var now = new Date().getTime();
            if (isNaN(request.delayLoadingTime) || now >= request.delayLoadingTime) {
                // no delay - just send xhr

                xhrs.push(xhr);
                xhr.send();
            } else {
                (function () {
                    // delay
                    var delayedXhr = { xhr: xhr };
                    delayedXhrs.push(delayedXhr);
                    delayedXhr.delayTimeout = setTimeout(function () {
                        if (delayedXhrs.indexOf(delayedXhr) === -1) {
                            return;
                        } else {
                            delayedXhrs.splice(delayedXhrs.indexOf(delayedXhr), 1);
                        }
                        try {
                            xhrs.push(delayedXhr.xhr);
                            delayedXhr.xhr.send();
                        } catch (e) {
                            delayedXhr.xhr.onerror();
                        }
                    }, request.delayLoadingTime - now);
                })();
            }
        } catch (e) {
            xhr.onerror();
        }
    }

    /**
     * Initiates a download of the resource described by config.request
     * @param {Object} config - contains request (FragmentRequest or derived type), and callbacks
     * @memberof module:XHRLoader
     * @instance
     */
    function load(config) {
        if (config.request) {
            internalLoad(config, mediaPlayerModel.getRetryAttemptsForType(config.request.type));
        }
    }

    /**
     * Aborts any inflight downloads
     * @memberof module:XHRLoader
     * @instance
     */
    function abort() {
        retryTimers.forEach(function (t) {
            return clearTimeout(t);
        });
        retryTimers = [];

        delayedXhrs.forEach(function (x) {
            return clearTimeout(x.delayTimeout);
        });
        delayedXhrs = [];

        xhrs.forEach(function (x) {
            // abort will trigger onloadend which we don't want
            // when deliberately aborting inflight requests -
            // set them to undefined so they are not called
            x.onloadend = x.onerror = x.onprogress = undefined;
            x.abort();
        });
        xhrs = [];
    }

    instance = {
        load: load,
        abort: abort
    };

    setup();

    return instance;
}

XHRLoader.__dashjs_factory_name = 'XHRLoader';

var factory = _coreFactoryMaker2['default'].getClassFactory(XHRLoader);
exports['default'] = factory;
module.exports = exports['default'];
//# sourceMappingURL=XHRLoader.js.map


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

function VideoModel() {

    var instance = undefined,
        element = undefined,
        TTMLRenderingDiv = undefined,
        videoContainer = undefined,
        stalledStreams = undefined,
        previousPlaybackRate = undefined;

    function initialize() {
        stalledStreams = [];
    }

    function onPlaybackCanPlay() {
        element.playbackRate = previousPlaybackRate || 1;
        element.removeEventListener('canplay', onPlaybackCanPlay);
    }

    function setPlaybackRate(value) {
        if (!element) return;
        if (element.readyState <= 2 && value > 0) {
            // If media element hasn't loaded enough data to play yet, wait until it has
            element.addEventListener('canplay', onPlaybackCanPlay);
        } else {
            element.playbackRate = value;
        }
    }

    //TODO Move the DVR window calculations from MediaPlayer to Here.
    function setCurrentTime(currentTime) {
        //_currentTime = currentTime;

        // We don't set the same currentTime because it can cause firing unexpected Pause event in IE11
        // providing playbackRate property equals to zero.
        if (element.currentTime == currentTime) return;

        // TODO Despite the fact that MediaSource 'open' event has been fired IE11 cannot set videoElement.currentTime
        // immediately (it throws InvalidStateError). It seems that this is related to videoElement.readyState property
        // Initially it is 0, but soon after 'open' event it goes to 1 and setting currentTime is allowed. Chrome allows to
        // set currentTime even if readyState = 0.
        // setTimeout is used to workaround InvalidStateError in IE11
        try {
            element.currentTime = currentTime;
        } catch (e) {
            if (element.readyState === 0 && e.code === e.INVALID_STATE_ERR) {
                setTimeout(function () {
                    element.currentTime = currentTime;
                }, 400);
            }
        }
    }

    function getElement() {
        return element;
    }

    function setElement(value) {
        element = value;
        // Workaround to force Firefox to fire the canplay event.
        element.preload = 'auto';
    }

    function setSource(source) {
        if (source) {
            element.src = source;
        } else {
            element.removeAttribute('src');
            element.load();
        }
    }

    function getSource() {
        return element.src;
    }

    function getVideoContainer() {
        return videoContainer;
    }

    function setVideoContainer(value) {
        videoContainer = value;
    }

    function getTTMLRenderingDiv() {
        return TTMLRenderingDiv;
    }

    function setTTMLRenderingDiv(div) {
        TTMLRenderingDiv = div;
        // The styling will allow the captions to match the video window size and position.
        TTMLRenderingDiv.style.position = 'absolute';
        TTMLRenderingDiv.style.display = 'flex';
        TTMLRenderingDiv.style.overflow = 'hidden';
        TTMLRenderingDiv.style.pointerEvents = 'none';
        TTMLRenderingDiv.style.top = 0;
        TTMLRenderingDiv.style.left = 0;
    }

    function setStallState(type, state) {
        stallStream(type, state);
    }

    function isStalled() {
        return stalledStreams.length > 0;
    }

    function addStalledStream(type) {

        var event = undefined;

        if (type === null || element.seeking || stalledStreams.indexOf(type) !== -1) {
            return;
        }

        stalledStreams.push(type);
        if (stalledStreams.length === 1) {
            // Halt playback until nothing is stalled.
            event = document.createEvent('Event');
            event.initEvent('waiting', true, false);
            previousPlaybackRate = element.playbackRate;
            setPlaybackRate(0);
            element.dispatchEvent(event);
        }
    }

    function removeStalledStream(type) {
        var index = stalledStreams.indexOf(type);
        var event = undefined;

        if (type === null) {
            return;
        }
        if (index !== -1) {
            stalledStreams.splice(index, 1);
        }
        // If nothing is stalled resume playback.
        if (isStalled() === false && element.playbackRate === 0) {
            setPlaybackRate(previousPlaybackRate || 1);
            if (!element.paused) {
                event = document.createEvent('Event');
                event.initEvent('playing', true, false);
                element.dispatchEvent(event);
            }
        }
    }

    function stallStream(type, isStalled) {
        if (isStalled) {
            addStalledStream(type);
        } else {
            removeStalledStream(type);
        }
    }

    function getPlaybackQuality() {
        var hasWebKit = 'webkitDroppedFrameCount' in element && 'webkitDecodedFrameCount' in element;
        var hasQuality = ('getVideoPlaybackQuality' in element);
        var result = null;

        if (hasQuality) {
            result = element.getVideoPlaybackQuality();
        } else if (hasWebKit) {
            result = {
                droppedVideoFrames: element.webkitDroppedFrameCount,
                totalVideoFrames: element.webkitDroppedFrameCount + element.webkitDecodedFrameCount,
                creationTime: new Date()
            };
        }

        return result;
    }

    instance = {
        initialize: initialize,
        setCurrentTime: setCurrentTime,
        setStallState: setStallState,
        getElement: getElement,
        setElement: setElement,
        setSource: setSource,
        getSource: getSource,
        getVideoContainer: getVideoContainer,
        setVideoContainer: setVideoContainer,
        getTTMLRenderingDiv: getTTMLRenderingDiv,
        setTTMLRenderingDiv: setTTMLRenderingDiv,
        getPlaybackQuality: getPlaybackQuality
    };

    return instance;
}

VideoModel.__dashjs_factory_name = 'VideoModel';
exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(VideoModel);
module.exports = exports['default'];
//# sourceMappingURL=VideoModel.js.map


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



Object.defineProperty(exports, '__esModule', {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _externalsBase64 = __webpack_require__(392);

var _externalsBase642 = _interopRequireDefault(_externalsBase64);

var CommonEncryption = (function () {
    function CommonEncryption() {
        _classCallCheck(this, CommonEncryption);
    }

    _createClass(CommonEncryption, null, [{
        key: 'findCencContentProtection',

        /**
         * Find and return the ContentProtection element in the given array
         * that indicates support for MPEG Common Encryption
         *
         * @param {Array} cpArray array of content protection elements
         * @returns {Object|null} the Common Encryption content protection element or
         * null if one was not found
         */
        value: function findCencContentProtection(cpArray) {
            var retVal = null;
            for (var i = 0; i < cpArray.length; ++i) {
                var cp = cpArray[i];
                if (cp.schemeIdUri.toLowerCase() === 'urn:mpeg:dash:mp4protection:2011' && cp.value.toLowerCase() === 'cenc') retVal = cp;
            }
            return retVal;
        }

        /**
         * Returns just the data portion of a single PSSH
         *
         * @param {ArrayBuffer} pssh - the PSSH
         * @return {ArrayBuffer} data portion of the PSSH
         */
    }, {
        key: 'getPSSHData',
        value: function getPSSHData(pssh) {
            var offset = 8; // Box size and type fields
            var view = new DataView(pssh);

            // Read version
            var version = view.getUint8(offset);

            offset += 20; // Version (1), flags (3), system ID (16)

            if (version > 0) {
                offset += 4 + 16 * view.getUint32(offset); // Key ID count (4) and All key IDs (16*count)
            }

            offset += 4; // Data size
            return pssh.slice(offset);
        }

        /**
         * Returns the PSSH associated with the given key system from the concatenated
         * list of PSSH boxes in the given initData
         *
         * @param {KeySystem} keySystem the desired
         * key system
         * @param {ArrayBuffer} initData 'cenc' initialization data.  Concatenated list of PSSH.
         * @returns {ArrayBuffer|null} The PSSH box data corresponding to the given key system, null if not found
         * or null if a valid association could not be found.
         */
    }, {
        key: 'getPSSHForKeySystem',
        value: function getPSSHForKeySystem(keySystem, initData) {
            var psshList = CommonEncryption.parsePSSHList(initData);
            if (psshList.hasOwnProperty(keySystem.uuid.toLowerCase())) {
                return psshList[keySystem.uuid.toLowerCase()];
            }
            return null;
        }

        /**
         * Parse a standard common encryption PSSH which contains a simple
         * base64-encoding of the init data
         *
         * @param {Object} cpData the ContentProtection element
         * @returns {ArrayBuffer|null} the init data or null if not found
         */
    }, {
        key: 'parseInitDataFromContentProtection',
        value: function parseInitDataFromContentProtection(cpData) {
            if ('pssh' in cpData) {
                return _externalsBase642['default'].decodeArray(cpData.pssh.__text).buffer;
            }
            return null;
        }

        /**
         * Parses list of PSSH boxes into keysystem-specific PSSH data
         *
         * @param {ArrayBuffer} data - the concatenated list of PSSH boxes as provided by
         * CDM as initialization data when CommonEncryption content is detected
         * @returns {Object|Array} an object that has a property named according to each of
         * the detected key system UUIDs (e.g. 00000000-0000-0000-0000-0000000000)
         * and a ArrayBuffer (the entire PSSH box) as the property value
         */
    }, {
        key: 'parsePSSHList',
        value: function parsePSSHList(data) {

            if (data === null) return [];

            var dv = new DataView(data);
            var done = false;
            var pssh = {};

            // TODO: Need to check every data read for end of buffer
            var byteCursor = 0;
            while (!done) {

                var size, nextBox, version, systemID, psshDataSize;
                var boxStart = byteCursor;

                if (byteCursor >= dv.buffer.byteLength) break;

                /* Box size */
                size = dv.getUint32(byteCursor);
                nextBox = byteCursor + size;
                byteCursor += 4;

                /* Verify PSSH */
                if (dv.getUint32(byteCursor) !== 0x70737368) {
                    byteCursor = nextBox;
                    continue;
                }
                byteCursor += 4;

                /* Version must be 0 or 1 */
                version = dv.getUint8(byteCursor);
                if (version !== 0 && version !== 1) {
                    byteCursor = nextBox;
                    continue;
                }
                byteCursor++;

                byteCursor += 3; /* skip flags */

                // 16-byte UUID/SystemID
                systemID = '';
                var i, val;
                for (i = 0; i < 4; i++) {
                    val = dv.getUint8(byteCursor + i).toString(16);
                    systemID += val.length === 1 ? '0' + val : val;
                }
                byteCursor += 4;
                systemID += '-';
                for (i = 0; i < 2; i++) {
                    val = dv.getUint8(byteCursor + i).toString(16);
                    systemID += val.length === 1 ? '0' + val : val;
                }
                byteCursor += 2;
                systemID += '-';
                for (i = 0; i < 2; i++) {
                    val = dv.getUint8(byteCursor + i).toString(16);
                    systemID += val.length === 1 ? '0' + val : val;
                }
                byteCursor += 2;
                systemID += '-';
                for (i = 0; i < 2; i++) {
                    val = dv.getUint8(byteCursor + i).toString(16);
                    systemID += val.length === 1 ? '0' + val : val;
                }
                byteCursor += 2;
                systemID += '-';
                for (i = 0; i < 6; i++) {
                    val = dv.getUint8(byteCursor + i).toString(16);
                    systemID += val.length === 1 ? '0' + val : val;
                }
                byteCursor += 6;

                systemID = systemID.toLowerCase();

                /* PSSH Data Size */
                psshDataSize = dv.getUint32(byteCursor);
                byteCursor += 4;

                /* PSSH Data */
                pssh[systemID] = dv.buffer.slice(boxStart, nextBox);
                byteCursor = nextBox;
            }

            return pssh;
        }
    }]);

    return CommonEncryption;
})();

exports['default'] = CommonEncryption;
module.exports = exports['default'];
//# sourceMappingURL=CommonEncryption.js.map


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

/**
 * @module URLUtils
 * @description Provides utility functions for operating on URLs.
 * Initially this is simply a method to determine the Base URL of a URL, but
 * should probably include other things provided all over the place such as
 * determining whether a URL is relative/absolute, resolving two paths etc.
 */
function URLUtils() {

    var resolveFunction = undefined;

    var schemeRegex = /^[a-z][a-z0-9+\-.]*:/i;
    var httpUrlRegex = /^https?:\/\//i;
    var originRegex = /^([a-z][a-z0-9+\-.]*:\/\/[^\/]+)\/?/i;

    /**
     * Resolves a url given an optional base url
     * Uses window.URL to do the resolution.
     *
     * @param {string} url
     * @param {string} [baseUrl]
     * @return {string}
     * @memberof module:URLUtils
     * @instance
     * @private
     */
    var nativeURLResolver = function nativeURLResolver(url, baseUrl) {
        try {
            // this will throw if baseurl is undefined, invalid etc
            return new window.URL(url, baseUrl).toString();
        } catch (e) {
            return url;
        }
    };

    /**
     * Resolves a url given an optional base url
     * Does not resolve ./, ../ etc but will do enough to construct something
     * which will satisfy XHR etc when window.URL is not available ie
     * IE11/node etc.
     *
     * @param {string} url
     * @param {string} [baseUrl]
     * @return {string}
     * @memberof module:URLUtils
     * @instance
     * @private
     */
    var dumbURLResolver = function dumbURLResolver(url, baseUrl) {
        var baseUrlParseFunc = parseBaseUrl;

        if (!baseUrl) {
            return url;
        }

        if (!isRelative(url)) {
            return url;
        }

        if (isPathAbsolute(url)) {
            baseUrlParseFunc = parseOrigin;
        }

        if (isSchemeRelative(url)) {
            baseUrlParseFunc = parseScheme;
        }

        var base = baseUrlParseFunc(baseUrl);
        var joinChar = base.charAt(base.length - 1) !== '/' && url.charAt(0) !== '/' ? '/' : '';

        return [base, url].join(joinChar);
    };

    function setup() {
        try {
            var u = new window.URL('x', 'http://y'); //jshint ignore:line
            resolveFunction = nativeURLResolver;
        } catch (e) {
            // must be IE11/Node etc
        } finally {
            resolveFunction = resolveFunction || dumbURLResolver;
        }
    }

    /**
     * Returns a string that contains the Base URL of a URL, if determinable.
     * @param {string} url - full url
     * @return {string}
     * @memberof module:URLUtils
     * @instance
     */
    function parseBaseUrl(url) {
        var slashIndex = url.indexOf('/');
        var lastSlashIndex = url.lastIndexOf('/');

        if (slashIndex !== -1) {
            // if there is only '//'
            if (lastSlashIndex === slashIndex + 1) {
                return url;
            }

            if (url.indexOf('?') !== -1) {
                url = url.substring(0, url.indexOf('?'));
            }

            return url.substring(0, lastSlashIndex + 1);
        }

        return '';
    }

    /**
     * Returns a string that contains the scheme and origin of a URL,
     * if determinable.
     * @param {string} url - full url
     * @return {string}
     * @memberof module:URLUtils
     * @instance
     */
    function parseOrigin(url) {
        var matches = url.match(originRegex);

        if (matches) {
            return matches[1];
        }

        return '';
    }

    /**
     * Returns a string that contains the scheme of a URL, if determinable.
     * @param {string} url - full url
     * @return {string}
     * @memberof module:URLUtils
     * @instance
     */
    function parseScheme(url) {
        var matches = url.match(schemeRegex);

        if (matches) {
            return matches[0];
        }

        return '';
    }

    /**
     * Determines whether the url is relative.
     * @return {bool}
     * @param {string} url
     * @memberof module:URLUtils
     * @instance
     */
    function isRelative(url) {
        return !schemeRegex.test(url);
    }

    /**
     * Determines whether the url is path-absolute.
     * @return {bool}
     * @param {string} url
     * @memberof module:URLUtils
     * @instance
     */
    function isPathAbsolute(url) {
        return isRelative(url) && url.charAt(0) === '/';
    }

    /**
     * Determines whether the url is scheme-relative.
     * @return {bool}
     * @param {string} url
     * @memberof module:URLUtils
     * @instance
     */
    function isSchemeRelative(url) {
        return url.indexOf('//') === 0;
    }

    /**
     * Determines whether the url is an HTTP-URL as defined in ISO/IEC
     * 23009-1:2014 3.1.15. ie URL with a fixed scheme of http or https
     * @return {bool}
     * @param {string} url
     * @memberof module:URLUtils
     * @instance
     */
    function isHTTPURL(url) {
        return httpUrlRegex.test(url);
    }

    /**
     * Resolves a url given an optional base url
     * @return {string}
     * @param {string} url
     * @param {string} [baseUrl]
     * @memberof module:URLUtils
     * @instance
     */
    function resolve(url, baseUrl) {
        return resolveFunction(url, baseUrl);
    }

    setup();

    var instance = {
        parseBaseUrl: parseBaseUrl,
        parseOrigin: parseOrigin,
        parseScheme: parseScheme,
        isRelative: isRelative,
        isPathAbsolute: isPathAbsolute,
        isSchemeRelative: isSchemeRelative,
        isHTTPURL: isHTTPURL,
        resolve: resolve
    };

    return instance;
}

URLUtils.__dashjs_factory_name = 'URLUtils';
exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(URLUtils);
module.exports = exports['default'];
//# sourceMappingURL=URLUtils.js.map


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    arguments: true,
    arity: true
};

var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
        var keys = Object.getOwnPropertyNames(sourceComponent);

        /* istanbul ignore else */
        if (isGetOwnPropertySymbolsAvailable) {
            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                try {
                    targetComponent[keys[i]] = sourceComponent[keys[i]];
                } catch (error) {

                }
            }
        }
    }

    return targetComponent;
};


/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_transport__ = __webpack_require__(271);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_transport__["a" /* http */]);

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = debounce;

var _utils = __webpack_require__(259);

var DEFAULT_TIMEOUT = 300;

function handleDescriptor(target, key, descriptor, _ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      _ref2$ = _ref2[0],
      wait = _ref2$ === undefined ? DEFAULT_TIMEOUT : _ref2$,
      _ref2$2 = _ref2[1],
      immediate = _ref2$2 === undefined ? false : _ref2$2;

  var callback = descriptor.value;

  if (typeof callback !== 'function') {
    throw new SyntaxError('Only functions can be debounced');
  }

  return _extends({}, descriptor, {
    value: function value() {
      var _this = this;

      var _metaFor = (0, _utils.metaFor)(this),
          debounceTimeoutIds = _metaFor.debounceTimeoutIds;

      var timeout = debounceTimeoutIds[key];
      var callNow = immediate && !timeout;
      var args = arguments;

      clearTimeout(timeout);

      debounceTimeoutIds[key] = setTimeout(function () {
        delete debounceTimeoutIds[key];
        if (!immediate) {
          callback.apply(_this, args);
        }
      }, wait);

      if (callNow) {
        callback.apply(this, args);
      }
    }
  });
}

function debounce() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return (0, _utils.decorate)(handleDescriptor, args);
}

/***/ }),
/* 246 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(105),
    getPrototype = __webpack_require__(500),
    isObjectLike = __webpack_require__(92);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(105),
    isArray = __webpack_require__(40),
    isObjectLike = __webpack_require__(92);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 249 */
/***/ (function(module, exports) {

// http://codepen.io/Merri/pen/Dsuim
/**
 * TextOverflowClamp.js
 *
 * Updated 2013-05-09 to remove jQuery dependency.
 * But be careful with webfonts!
 */


// the actual meat is here
module.exports = (function (d) {
  var measure, text, lineWidth,
    lineStart, lineCount, wordStart,
    line, lineText, wasNewLine,
    ce = d.createElement.bind(d),
    ctn = d.createTextNode.bind(d);

  // measurement element is made a child of the clamped element to get it's style
  measure = ce('span');

  Object.assign(measure.style, {
    position: 'absolute', // prevent page reflow
    whiteSpace: 'pre', // cross-browser width results
    visibility: 'hidden' // prevent drawing
  });

  return function clamp(el, options) {
    // make sure the element belongs to the document
    if (!el || !el.ownerDocument || !el.ownerDocument === d) {
      return;
    }

    options = options || {};
    var lineClamp = options.lineClamp || 2;
    var truncateText = options.truncateText || '';
    var textAlign = options.textAlign || 'flex-start';

    // reset to safe starting values
    lineStart = wordStart = 0;
    lineCount = 1;
    wasNewLine = false;
    lineWidth = el.clientWidth;

    // remove truncate span first
    if (el.lineContainer && el.truncSpan) {
      el.lineContainer.removeChild(el.truncSpan);
    }

    // get all the text, remove any line changes
    text = (el.textContent || el.innerText).replace(/\n/g, ' ') + ' ';

    // remove all content
    while (el.firstChild !== null) {
      el.removeChild(el.firstChild);
    }

    // add measurement element within so it inherits styles
    el.appendChild(measure);

    // http://ejohn.org/blog/search-and-dont-replace/
    text.replace(/ /g, function (m, pos) {
      // ignore any further processing if we have total lines
      if (lineCount === lineClamp) {
        return;
      }

      // create a text node and place it in the measurement element
      measure.appendChild(ctn(text.substr(lineStart, pos - lineStart)));

      // have we exceeded allowed line width?
      if (lineWidth < measure.clientWidth) {
        if (wasNewLine) {
          // we have a long word so it gets a line of it's own
          lineText = text.substr(lineStart, pos + 1 - lineStart);
          // next line start position
          lineStart = pos + 1;
        } else {
          // grab the text until this word
          lineText = text.substr(lineStart, wordStart - lineStart);
          // next line start position
          lineStart = wordStart;
        }

        // create a line element
        line = ce('span');
        // add text to the line element
        line.appendChild(ctn(lineText));
        // add the line element to the container
        el.appendChild(line);
        // yes, we created a new line
        wasNewLine = true;
        lineCount++;
      } else {
        // did not create a new line
        wasNewLine = false;
      }

      // remember last word start position
      wordStart = pos + 1;

      // clear measurement element
      measure.removeChild(measure.firstChild);
    });

    // remove the measurement element from the container
    el.removeChild(measure);

    // create truncation span element
    var truncSpan;
    if (truncateText) {
      truncSpan = ce('span');
      truncSpan.appendChild(ctn(truncateText));

      Object.assign(truncSpan.style, {
        flex: '0 0 auto',
        whiteSpace: 'pre'
      });

      el.truncSpan = truncSpan;
    }

    // create last line container
    var lineContainer = ce('span');

    var lineContainerStyle = {
      display: 'flex',
      width: '100%'
    };
    if (truncSpan) {
      lineContainerStyle.justifyContent = textAlign;
    }
    Object.assign(lineContainer.style, lineContainerStyle);

    // save references
    el.lineContainer = lineContainer;

    // create the last line element
    line = ce('span');

    // give styles required for text-overflow to kick in
    var lineStyle = {
      display: 'block',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      paddingRight: '1ch',
      marginRight: '-1ch'
    };
    if (!truncSpan) {
      lineStyle.flex = '1 1 auto';
    }
    Object.assign(line.style, lineStyle);

    // add all remaining text to the line element
    line.appendChild(ctn(text.substr(lineStart)));

    // add remaining text and truncation text to div
    lineContainer.appendChild(line);
    if (truncSpan) {
      lineContainer.appendChild(truncSpan);
    }

    // add the line element to the container
    el.appendChild(lineContainer);
  };
})(document);


/***/ }),
/* 250 */,
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NAMES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getPublic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_redux_helpers_create_async_actions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_redux_helpers_normalized__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_utils_adapters_vod__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_constants_channel_deal_info__ = __webpack_require__(382);







var ACTIONS = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_redux_helpers_create_async_actions__["a" /* default */])('SERVER.CHANNEL.GET');
var NAMES = ACTIONS.NAMES;
var START = ACTIONS.START,
    SUCCESS = ACTIONS.SUCCESS,
    FAIL = ACTIONS.FAIL;


function getChannel(method, id, options) {
  return function (dispatch, getState) {
    var params = { id: id, options: options };
    dispatch(START(params));

    return __WEBPACK_IMPORTED_MODULE_3_shared_utils_adapters_vod__["a" /* default */].list[method](id, options).then(function (response) {
      var data = response.data;

      var _getState = getState(),
          vodSettings = _getState.vodSettings;

      if (!_.get(data, 'dealInfo.length') && vodSettings) {
        data.dealInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_constants_channel_deal_info__["a" /* default */])(vodSettings.currency);
      }

      response = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, response, {
        data: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_redux_helpers_normalized__["e" /* normalizeChannel */])(data)
      });

      dispatch(SUCCESS(params, response));
      return response;
    }, function (response) {
      dispatch(FAIL(params, response, { analytics: { type: 'error', name: 'shared.channel.video.get' } }));
    });
  };
}

/* unused harmony default export */ var _unused_webpack_default_export = (_.partial(getChannel, 'get'));

var getPublic = _.partial(getChannel, 'getPublic');

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NAMES; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_normalizr__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_normalizr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_normalizr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_schemas__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_redux_helpers_create_async_actions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_utils_adapters_vod__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_constants_channel_deal_info__ = __webpack_require__(382);










var ACTIONS = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_redux_helpers_create_async_actions__["a" /* default */])('SERVER.CHANNELS.LIST');
var NAMES = ACTIONS.NAMES;
var START = ACTIONS.START,
    SUCCESS = ACTIONS.SUCCESS,
    FAIL = ACTIONS.FAIL;


/* harmony default export */ __webpack_exports__["b"] = (function (options) {

  options = _.merge({ paging: { size: 1000 } }, options);

  return function (dispatch, getState) {
    dispatch(START());

    return __WEBPACK_IMPORTED_MODULE_5_shared_utils_adapters_vod__["a" /* default */].lists.list(options).then(function (response) {
      var _getState = getState(),
          vodSettings = _getState.vodSettings;

      var data = _.map(response.data, function (data) {
        if (!_.get(data, 'dealInfo.length') && vodSettings) {
          data.dealInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_shared_constants_channel_deal_info__["a" /* default */])(vodSettings.currency);
        }
        return data;
      });

      response = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, response, {
        data: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_normalizr__["normalize"])(data, __WEBPACK_IMPORTED_MODULE_3_shared_schemas__["f" /* arrayOfChannels */])
      });

      dispatch(SUCCESS({}, response));
      return response;
    }, function (reason) {
      dispatch(FAIL({}, reason, { analytics: { type: 'error', name: 'shared.channels.list' } }));
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(reason);
    });
  };
});

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getChannelVideoIds;
/* harmony export (immutable) */ __webpack_exports__["a"] = isFetching;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getChannelVideosByChannelId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getVideosCountByChannelIds; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__videos__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channels__ = __webpack_require__(71);





function getChannelVideoIds(state) {
  return state.channelVideos.ids;
}

function isFetching(state) {
  return state.channelVideos.activeRequests !== 0;
}

/**
 * @param state
 * @param channelId {String}
 * @returns {Object[]} videos list
 */
var getChannelVideosByChannelId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function (state) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__videos__["a" /* getVideosGroupedByIds */])(state);
}, function (state, channelId) {
  return channelId;
}], function (videoByIds, channelId) {
  return _.filter(videoByIds, function (video) {
    return _.includes(video.usedInLists, channelId);
  });
});

/**
 * @param state
 * @param channelId {String}
 * @returns {Object[]} videos list
 */
var getVideosCountByChannelIds = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function (state) {
  return state;
}, __WEBPACK_IMPORTED_MODULE_2__channels__["b" /* getChannelIds */], function (state) {
  return _.partial(getChannelVideosByChannelId, state);
}], function (state, channelIds, getVideosByChannelId) {
  return _.zipObject(channelIds, _.map(channelIds, function (id) {
    return _.size(getVideosByChannelId(id));
  }));
});

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parse;
/* harmony export (immutable) */ __webpack_exports__["b"] = stringify;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);

function parse(str) {
  if (!str) {
    return {};
  }

  return _(str).split('&').reduce(function (acc, param) {
    var _param$split = param.split('='),
        _param$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_param$split, 2),
        key = _param$split2[0],
        value = _param$split2[1];

    acc[key] = value;
    return acc;
  }, {});
}

function stringify(obj) {
  var query = _(obj).keys().map(function (arg) {
    return arg + '=' + obj[arg];
  }).join('&');

  return query ? '?' + query : query;
}

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NAMES; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_redux_helpers_create_async_actions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_utils_adapters_vod__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_redux_server_actions_channel_publish__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_redux_helpers_normalized__ = __webpack_require__(49);








var ACTIONS = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_redux_helpers_create_async_actions__["a" /* default */])('SERVER.CHANNEL.UPDATE');
var NAMES = ACTIONS.NAMES;
var START = ACTIONS.START,
    SUCCESS = ACTIONS.SUCCESS,
    FAIL = ACTIONS.FAIL;


/* harmony default export */ __webpack_exports__["b"] = (function (data) {
  return function (dispatch) {
    dispatch(START(data, { data: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_redux_helpers_normalized__["e" /* normalizeChannel */])(data) }));

    var channelId = data.id;
    var isNewChannel = !channelId;

    var promise = isNewChannel ? __WEBPACK_IMPORTED_MODULE_2_shared_utils_adapters_vod__["a" /* default */].list.create(data) : __WEBPACK_IMPORTED_MODULE_2_shared_utils_adapters_vod__["a" /* default */].list.update(data);

    return promise.then(function (response) {
      var normData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_redux_helpers_normalized__["e" /* normalizeChannel */])(response.data);

      response = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, response, {
        data: normData
      });

      dispatch(SUCCESS(data, response));

      if (!isNewChannel) {
        return response;
      }

      // new channel - need to publish it
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_redux_server_actions_channel_publish__["a" /* default */])(normData.result)).then(function () {
        return response;
      });
    }, function (error) {
      dispatch(FAIL(data, null, { analytics: { type: 'error', name: 'shared.channel.update' } }));
      return error;
    });
  };
});

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isEnabled; });
/* harmony export (immutable) */ __webpack_exports__["g"] = isHideVideoTitleOnMainItemEnabled;
/* harmony export (immutable) */ __webpack_exports__["a"] = isNewPlayerEnabled;
/* harmony export (immutable) */ __webpack_exports__["c"] = isNoCoverForEmbedEnabled;
/* harmony export (immutable) */ __webpack_exports__["f"] = isShoutoutEnabled;
/* harmony export (immutable) */ __webpack_exports__["e"] = isVideoPreviewEnabled;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getEnabledExperimentsList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);


function getExperiments(state) {
  return state.experiments;
}

/**
 * @param state
 * @param experimentName
 * @returns {Boolean} Is experiment enabled
 */
var isEnabled = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getExperiments, function (state, experimentName) {
  return experimentName;
}], function (experiments, experimentName) {
  return _.get(experiments, experimentName) === 'true';
});

function isHideVideoTitleOnMainItemEnabled(state) {
  return isEnabled(state, 'hideVideoTitleOnMainItem');
}

function isNewPlayerEnabled(state) {
  return isEnabled(state, 'newPlayer');
}

function isNoCoverForEmbedEnabled(state) {
  return isEnabled(state, 'noCoverForEmbed');
}

function isShoutoutEnabled(state) {
  return isEnabled(state, 'shoutout');
}

function isVideoPreviewEnabled(state) {
  return isEnabled(state, 'videoPreview');
}

/**
 * @param state
 * @returns {String[]} Enabled experiment names list
 */
var getEnabledExperimentsList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getExperiments], function (experiments) {
  return _(experiments).pickBy(function (val) {
    return val === 'true';
  }).keys().value();
});

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = openMobileOverlay;
/* harmony export (immutable) */ __webpack_exports__["a"] = openFullScreenOverlay;
/* harmony export (immutable) */ __webpack_exports__["c"] = openFullScreenSubscribeOverlay;
/* harmony export (immutable) */ __webpack_exports__["d"] = openFullScreenPurchaseOverlay;
/* harmony export (immutable) */ __webpack_exports__["b"] = openFullScreenMemberOnlyOverlay;
/* harmony export (immutable) */ __webpack_exports__["f"] = openFullScreenChannelOverlay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_utils_wix_sdk__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_constants_payments__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_full_screen_modals_constants_close_reasons__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_bi_bi__ = __webpack_require__(95);







var MOBILE_OVERLAY_ENTRY = 'mobile-overlay.html';
var FULL_SCREEN_OVERLAY_ENTRY = 'full-screen-modals.html';

function getHostAndPath(withProtocol) {
  var protocol = withProtocol ? location.protocol : '';
  var host = location.host;
  var pathName = location.pathname.replace(/[^/]+$/, '');
  return protocol + '//' + host + pathName;
}

function openPopup(path, width, height, theme, onClose) {
  var opener = function opener(restoreScroll) {
    __WEBPACK_IMPORTED_MODULE_0_shared_utils_wix_sdk__["a" /* default */].openPopup(path, width, height, { origin: __WEBPACK_IMPORTED_MODULE_0_shared_utils_wix_sdk__["a" /* default */].WindowOrigin.FIXED, placement: __WEBPACK_IMPORTED_MODULE_0_shared_utils_wix_sdk__["a" /* default */].WindowPlacement.CENTER }, function (response) {
      if (_.isFunction(onClose)) {
        onClose(response && response.message);
      }
      restoreScroll();
    }, theme);
  };

  openPopupOrModal(opener);
}

function openModal(path, width, height, theme, onClose) {
  var opener = function opener(restoreScroll) {
    __WEBPACK_IMPORTED_MODULE_0_shared_utils_wix_sdk__["a" /* default */].openModal(path, width, height, function (response) {
      if (_.isFunction(onClose)) {
        onClose(response && response.message);
      }
      restoreScroll();
    }, theme);
  };

  openPopupOrModal(opener);
}

function openPopupOrModal(opener) {
  __WEBPACK_IMPORTED_MODULE_0_shared_utils_wix_sdk__["a" /* default */].getBoundingRectAndOffsets().then(function (rectAndOffsets) {
    var offsets = rectAndOffsets.offsets;
    var rect = rectAndOffsets.rect;

    function restoreScroll() {
      __WEBPACK_IMPORTED_MODULE_0_shared_utils_wix_sdk__["a" /* default */].scrollTo(offsets.x, offsets.y - rect.top);
    }

    opener(restoreScroll);
  });
}

function openMobileOverlay(subPath, onClose) {
  subPath = subPath ? '' + subPath : '';
  var modalPath = '' + getHostAndPath(true) + MOBILE_OVERLAY_ENTRY + subPath;
  openModal(modalPath, '100%', '100%', __WEBPACK_IMPORTED_MODULE_0_shared_utils_wix_sdk__["a" /* default */].Theme.BARE, onClose);
}

function openFullScreenOverlay(subPath) {
  var onClose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _.noop;

  subPath = subPath ? '' + subPath : '';
  var modalPath = '' + getHostAndPath(true) + FULL_SCREEN_OVERLAY_ENTRY + subPath;
  openPopup(modalPath, '100%', '100%', __WEBPACK_IMPORTED_MODULE_0_shared_utils_wix_sdk__["a" /* default */].Theme.BARE, function (_ref) {
    var reason = _ref.reason;
    return onClose(reason);
  });
}

/**
 * Opens full-screen overlay with channel subscription info
 * @param channelId
 * @param onCloseByUser
 */
function openFullScreenSubscribeOverlay(channelId) {
  var onCloseByUser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _.noop;

  __WEBPACK_IMPORTED_MODULE_3_shared_bi_bi__["a" /* default */].logWidgetSystem('channel.subscribeInfo.fullscreenModal.requested');
  openFullScreenOverlay('#/payment/' + __WEBPACK_IMPORTED_MODULE_1_shared_constants_payments__["a" /* PAYMENT_TYPE */].SUBSCRIPTION + '/' + channelId, function (reason) {
    if (reason === __WEBPACK_IMPORTED_MODULE_2_full_screen_modals_constants_close_reasons__["a" /* default */].CLOSED_BY_USER) {
      onCloseByUser();
    }
  });
}

/**
 * Opens full-screen overlay with video purchase info
 * @param channelId
 * @param videoId
 */
function openFullScreenPurchaseOverlay(channelId, videoId) {
  __WEBPACK_IMPORTED_MODULE_3_shared_bi_bi__["a" /* default */].logWidgetSystem('video.purchaseInfo.fullscreenModal.requested');
  openFullScreenOverlay('#/payment/' + __WEBPACK_IMPORTED_MODULE_1_shared_constants_payments__["a" /* PAYMENT_TYPE */].PURCHASE + '/' + channelId + '/' + videoId);
}

/**
 * Opens full-screen overlay with member only video info
 * @param channelId
 * @param videoId
 * @param onClose
 */
function openFullScreenMemberOnlyOverlay(channelId, videoId, onClose) {
  __WEBPACK_IMPORTED_MODULE_3_shared_bi_bi__["a" /* default */].logWidgetSystem('video.memberOnlyInfo.fullscreenModal.requested');
  openFullScreenOverlay('#/payment/' + __WEBPACK_IMPORTED_MODULE_1_shared_constants_payments__["a" /* PAYMENT_TYPE */].MEMBER_ONLY + '/' + channelId + '/' + videoId, onClose);
}

/**
 * Opens full-screen overlay with channel info
 * @param channelId
 */
function openFullScreenChannelOverlay(channelId) {
  __WEBPACK_IMPORTED_MODULE_3_shared_bi_bi__["a" /* default */].logWidgetSystem('channel.info.fullscreenModal.requested');
  openFullScreenOverlay('#/channel/' + channelId + '/info');
}

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOwnKeys = undefined;

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;

exports.isDescriptor = isDescriptor;
exports.decorate = decorate;
exports.metaFor = metaFor;
exports.getOwnPropertyDescriptors = getOwnPropertyDescriptors;
exports.createDefaultSetter = createDefaultSetter;

var _lazyInitialize = __webpack_require__(724);

var _lazyInitialize2 = _interopRequireDefault(_lazyInitialize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var defineProperty = Object.defineProperty,
    getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor,
    getOwnPropertyNames = Object.getOwnPropertyNames,
    getOwnPropertySymbols = Object.getOwnPropertySymbols;
function isDescriptor(desc) {
  if (!desc || !desc.hasOwnProperty) {
    return false;
  }

  var keys = ['value', 'initializer', 'get', 'set'];

  for (var i = 0, l = keys.length; i < l; i++) {
    if (desc.hasOwnProperty(keys[i])) {
      return true;
    }
  }

  return false;
}

function decorate(handleDescriptor, entryArgs) {
  if (isDescriptor(entryArgs[entryArgs.length - 1])) {
    return handleDescriptor.apply(undefined, _toConsumableArray(entryArgs).concat([[]]));
  } else {
    return function () {
      return handleDescriptor.apply(undefined, Array.prototype.slice.call(arguments).concat([entryArgs]));
    };
  }
}

var Meta = (_class = function Meta() {
  _classCallCheck(this, Meta);

  _initDefineProp(this, 'debounceTimeoutIds', _descriptor, this);

  _initDefineProp(this, 'throttleTimeoutIds', _descriptor2, this);

  _initDefineProp(this, 'throttlePreviousTimestamps', _descriptor3, this);

  _initDefineProp(this, 'throttleTrailingArgs', _descriptor4, this);
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'debounceTimeoutIds', [_lazyInitialize2.default], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'throttleTimeoutIds', [_lazyInitialize2.default], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'throttlePreviousTimestamps', [_lazyInitialize2.default], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'throttleTrailingArgs', [_lazyInitialize2.default], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
})), _class);


var META_KEY = typeof Symbol === 'function' ? Symbol('__core_decorators__') : '__core_decorators__';

function metaFor(obj) {
  if (obj.hasOwnProperty(META_KEY) === false) {
    defineProperty(obj, META_KEY, {
      // Defaults: NOT enumerable, configurable, or writable
      value: new Meta()
    });
  }

  return obj[META_KEY];
}

var getOwnKeys = exports.getOwnKeys = getOwnPropertySymbols ? function (object) {
  return getOwnPropertyNames(object).concat(getOwnPropertySymbols(object));
} : getOwnPropertyNames;

function getOwnPropertyDescriptors(obj) {
  var descs = {};

  getOwnKeys(obj).forEach(function (key) {
    return descs[key] = getOwnPropertyDescriptor(obj, key);
  });

  return descs;
}

function createDefaultSetter(key) {
  return function set(newValue) {
    Object.defineProperty(this, key, {
      configurable: true,
      writable: true,
      // IS enumerable when reassigned by the outside word
      enumerable: true,
      value: newValue
    });

    return newValue;
  };
}

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(1012),
    baseIsNaN = __webpack_require__(1019),
    strictIndexOf = __webpack_require__(1090);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(40),
    isKey = __webpack_require__(340),
    stringToPath = __webpack_require__(1091),
    toString = __webpack_require__(131);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = getVisitorId;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return event; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sendError; });
/* harmony export (immutable) */ __webpack_exports__["d"] = enableEventLogging;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_utils_wix_sdk__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bi_core__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_utils_attempt__ = __webpack_require__(163);






var VOID_SRC_ID = 71;
var ADAPTER = 'video';

function getDefaultParams() {
  return {
    biToken: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_utils_attempt__["a" /* attempt */])(function () {
      return __WEBPACK_IMPORTED_MODULE_2_shared_utils_wix_sdk__["a" /* default */].Utils.getInstanceValue('biToken');
    }), // same as sid, but we use biToken everywhere
    videoInstanceID: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_utils_attempt__["a" /* attempt */])(function () {
      return __WEBPACK_IMPORTED_MODULE_2_shared_utils_wix_sdk__["a" /* default */].Utils.getInstanceId();
    }),
    visitorID: getVisitorId()
  };
}

function getVisitorId() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_utils_attempt__["a" /* attempt */])(function () {
    return __WEBPACK_IMPORTED_MODULE_2_shared_utils_wix_sdk__["a" /* default */].Utils.getInstanceValue('uid');
  }) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_utils_attempt__["a" /* attempt */])(function () {
    return __WEBPACK_IMPORTED_MODULE_2_shared_utils_wix_sdk__["a" /* default */].Utils.getInstanceValue('aid');
  }) || '';
}

function makeRestriction(fields) {
  return _.mapValues(fields, function (restriction) {
    return _.isString(restriction) ? { type: restriction } : restriction;
  });
}

function addDefaultParams(next) {
  return function (eventDef, params) {
    var defaultParams = getDefaultParams();

    if (!defaultParams.visitorID || !defaultParams.videoInstanceID) {
      console.warn('Missing visitorID or videoInstanceID'); // eslint-disable-line no-console
      return false;
    }

    var eventParams = _(eventDef.fields).keys().reduce(function (acc, name) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, acc, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, name, _.isUndefined(params[name]) ? defaultParams[name] : params[name]));
    }, {});
    return next(eventDef, eventParams);
  };
}

function validate(next) {
  return function (eventDef, params) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__bi_core__["a" /* validateBiEventArgs */])(params, _.keys(eventDef.fields), makeRestriction(eventDef.fields), eventDef.id);
    return next(eventDef, params);
  };
}

function addObligatoryFields(next) {
  return function (eventDef, params) {
    return next(eventDef, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
      evid: eventDef.id
    }, params, {
      adapter: ADAPTER,
      src: VOID_SRC_ID,
      _: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__bi_core__["b" /* now */])()
    }));
  };
}

var logEventEnabled = false;
function createLogger(type) {
  return function (next) {
    return function (eventDef, params) {
      return next(eventDef, params).then(function (data) {
        if (logEventEnabled) {
          console.warn('bi ' + type + ':', eventDef.name, params); // eslint-disable-line no-console
        }
        return data;
      });
    };
  };
}

function formatEvent(next) {
  return function (eventDef, params) {
    return next(params);
  };
}

function createError(next) {
  return function (eventData, params) {
    return next(eventData, {
      errc: eventData.id,
      errn: eventData.name,
      iss: params.iss,
      sev: params.severity || __WEBPACK_IMPORTED_MODULE_3__bi_core__["c" /* ErrorSeverity */].ERROR,
      adapter: 'trg',
      src: VOID_SRC_ID,
      cat: 1,
      p1: eventData.service,
      p2: params.application,
      cid: getVisitorId()
    });
  };
}

var event = addDefaultParams(validate(addObligatoryFields(createLogger('event')(formatEvent(__WEBPACK_IMPORTED_MODULE_3__bi_core__["d" /* event */])))));
var sendError = createError(createLogger('error')(formatEvent(__WEBPACK_IMPORTED_MODULE_3__bi_core__["e" /* error */])));

function enableEventLogging() {
  logEventEnabled = true;
}

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = createSender;
/* harmony export (immutable) */ __webpack_exports__["c"] = createErrorSender;
/* harmony export (immutable) */ __webpack_exports__["a"] = getBiDefaultParams;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_bi_bi_facade__ = __webpack_require__(419);



function createSender(state) {
  var biDefaultParams = getBiDefaultParams(state);
  return function (name, params) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_bi_bi_facade__["a" /* sendEvent */])(name, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, biDefaultParams, params));
  };
}

function createErrorSender(state) {
  var biDefaultParams = getBiDefaultParams(state);
  return function (name, params) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_bi_bi_facade__["b" /* sendError */])(name, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, biDefaultParams, params));
  };
}

function getBiDefaultParams(state) {
  return _.mapValues(state.biDefaultParams, function (value) {
    return _.isFunction(value) ? value(state) : value;
  });
}

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = showPopout;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Popout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return YellowStripePopout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PurpleStripePopout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CalendarPopout; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_utils_pubsub__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_utils_popout_invert_side__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_utils_device_screen__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_constants_events__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_shared_constants_popout__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_shared_shapes_popout__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__popout_styl__ = __webpack_require__(1173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__popout_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__popout_styl__);








var _dec, _class, _desc, _value, _class2, _class3, _temp, _dec2, _class4, _class5, _temp2, _dec3, _class6, _class7, _temp3, _dec4, _class8, _class9, _temp4, _dec5, _class10, _class11, _temp5;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}
















var _propTypes = {
  className: React.PropTypes.string,
  style: React.PropTypes.object,
  innerClassName: React.PropTypes.string,
  children: React.PropTypes.any,
  popoutSide: __WEBPACK_IMPORTED_MODULE_15_shared_shapes_popout__["a" /* sideShape */],
  popoutPosition: __WEBPACK_IMPORTED_MODULE_15_shared_shapes_popout__["b" /* popoutPositionShape */],
  trianglePosition: __WEBPACK_IMPORTED_MODULE_15_shared_shapes_popout__["c" /* trianglePositionShape */],
  triangleClassName: React.PropTypes.string,
  getRef: React.PropTypes.func,
  onMouseEnter: React.PropTypes.func,
  onMouseLeave: React.PropTypes.func,
  onClickOutside: React.PropTypes.func,
  height: React.PropTypes.number
};

var _defaultProps = {
  popoutSide: __WEBPACK_IMPORTED_MODULE_14_shared_constants_popout__["a" /* sides */].TOP,
  popoutPosition: __WEBPACK_IMPORTED_MODULE_14_shared_constants_popout__["c" /* popoutPositions */].CENTER,
  trianglePosition: __WEBPACK_IMPORTED_MODULE_14_shared_constants_popout__["b" /* trianglePositions */].CENTER,
  getRef: _.noop,
  onMouseEnter: _.noop,
  onMouseLeave: _.noop,
  onClickOutside: _.noop
};

function showPopout(popout) {
  __WEBPACK_IMPORTED_MODULE_10_shared_utils_pubsub__["a" /* default */].publish(__WEBPACK_IMPORTED_MODULE_13_shared_constants_events__["a" /* default */].POPOUT.SHOW, popout);
}

var PopoutBase = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_16__popout_styl___default.a), _dec(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(PopoutBase, _React$Component);

  function PopoutBase() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, PopoutBase);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PopoutBase.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(PopoutBase)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(PopoutBase, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('blur', this.handleClickOutside);

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_shared_utils_device_screen__["a" /* isMobile */])() || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_shared_utils_device_screen__["b" /* isTablet */])()) {
        document.addEventListener('touchstart', this.handleClickOutside);
      } else {
        document.addEventListener('click', this.handleClickOutside);
      }

      this.unsubscribeHide = __WEBPACK_IMPORTED_MODULE_10_shared_utils_pubsub__["a" /* default */].subscribe(__WEBPACK_IMPORTED_MODULE_13_shared_constants_events__["a" /* default */].POPOUT.SHOW, this.hideAllButOnePopout);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('blur', this.handleClickOutside);
      document.removeEventListener('click', this.handleClickOutside);
      document.removeEventListener('touchstart', this.handleClickOutside);

      if (this.unsubscribeHide) {
        this.unsubscribeHide();
      }
    }
  }, {
    key: 'handleClickOutside',
    value: function handleClickOutside(event) {
      var target = event.target;

      if (target !== window && this.popout && this.popout.contains(target)) {
        return;
      }

      this.props.onClickOutside({ event: event });
    }
  }, {
    key: 'hideAllButOnePopout',
    value: function hideAllButOnePopout(popoutToShow) {
      if (popoutToShow && this.popout && !this.popout.contains(popoutToShow)) {
        this.props.onClickOutside();
      }
    }
  }, {
    key: 'getRef',
    value: function getRef(node) {
      this.popout = node;
      this.props.getRef(node);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          onMouseEnter = _props.onMouseEnter,
          onMouseLeave = _props.onMouseLeave,
          triangleClassName = _props.triangleClassName,
          height = _props.height;
      var style = this.props.style;


      if (height) {
        style = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, style, { height: height });
      }

      return React.createElement(
        'div',
        { ref: this.getRef,
          styleName: this.styleNames,
          className: className,
          style: style,
          onMouseEnter: onMouseEnter,
          onMouseLeave: onMouseLeave },
        React.createElement('div', { className: triangleClassName,
          styleName: 'triangle before' }),
        children,
        React.createElement('div', { className: triangleClassName,
          styleName: 'triangle after' })
      );
    }
  }, {
    key: 'styleNames',
    get: function get() {
      var _props2 = this.props,
          popoutSide = _props2.popoutSide,
          trianglePosition = _props2.trianglePosition;

      return __WEBPACK_IMPORTED_MODULE_8_classnames___default()('content', 'triangle-' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_shared_utils_popout_invert_side__["a" /* default */])(popoutSide), 'triangle-' + trianglePosition);
    }
  }]);

  return PopoutBase;
}(React.Component), _class3.propTypes = _propTypes, _class3.defaultProps = _defaultProps, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'handleClickOutside', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handleClickOutside'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'hideAllButOnePopout', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'hideAllButOnePopout'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'getRef', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'getRef'), _class2.prototype)), _class2)) || _class);
var Popout = (_dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_16__popout_styl___default.a), _dec2(_class4 = (_temp2 = _class5 = function (_React$Component2) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Popout, _React$Component2);

  function Popout() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Popout);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Popout.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Popout)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Popout, [{
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          innerClassName = _props3.innerClassName,
          children = _props3.children;

      var props = _.omit(this.props, 'styles', 'innerClassName', 'children');

      return React.createElement(
        PopoutBase,
        props,
        React.createElement(
          'div',
          { styleName: 'inner',
            className: innerClassName },
          children
        )
      );
    }
  }]);

  return Popout;
}(React.Component), _class5.propTypes = _propTypes, _class5.defaultProps = _defaultProps, _temp2)) || _class4);


var YellowStripePopout = (_dec3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_16__popout_styl___default.a), _dec3(_class6 = (_temp3 = _class7 = function (_React$Component3) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(YellowStripePopout, _React$Component3);

  function YellowStripePopout() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, YellowStripePopout);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (YellowStripePopout.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(YellowStripePopout)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(YellowStripePopout, [{
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          innerClassName = _props4.innerClassName,
          children = _props4.children;

      var props = _.omit(this.props, 'styles', 'innerClassName', 'children');

      return React.createElement(
        PopoutBase,
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, props, {
          styleName: 'yellow-stripe' }),
        React.createElement('div', { styleName: 'stripe stripe-yellow' }),
        React.createElement('div', { styleName: 'stripe stripe-white' }),
        React.createElement(
          'div',
          { styleName: 'inner',
            className: innerClassName },
          children
        )
      );
    }
  }]);

  return YellowStripePopout;
}(React.Component), _class7.propTypes = _propTypes, _class7.defaultProps = _defaultProps, _temp3)) || _class6);

var PurpleStripePopout = (_dec4 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_16__popout_styl___default.a), _dec4(_class8 = (_temp4 = _class9 = function (_React$Component4) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(PurpleStripePopout, _React$Component4);

  function PurpleStripePopout() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, PurpleStripePopout);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PurpleStripePopout.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(PurpleStripePopout)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(PurpleStripePopout, [{
    key: 'render',
    value: function render() {
      var _props5 = this.props,
          innerClassName = _props5.innerClassName,
          children = _props5.children;

      var props = _.omit(this.props, 'styles', 'innerClassName', 'children');

      return React.createElement(
        PopoutBase,
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, props, {
          styleName: 'purple-stripe' }),
        React.createElement('div', { styleName: 'stripe stripe-purple' }),
        React.createElement('div', { styleName: 'stripe stripe-white' }),
        React.createElement(
          'div',
          { styleName: 'inner',
            className: innerClassName },
          children
        )
      );
    }
  }]);

  return PurpleStripePopout;
}(React.Component), _class9.propTypes = _propTypes, _class9.defaultProps = _defaultProps, _temp4)) || _class8);

var CalendarPopout = (_dec5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_16__popout_styl___default.a), _dec5(_class10 = (_temp5 = _class11 = function (_React$Component5) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(CalendarPopout, _React$Component5);

  function CalendarPopout() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, CalendarPopout);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CalendarPopout.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(CalendarPopout)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(CalendarPopout, [{
    key: 'render',
    value: function render() {
      var _props6 = this.props,
          innerClassName = _props6.innerClassName,
          children = _props6.children;

      var props = _.omit(this.props, 'styles', 'innerClassName', 'children');

      return React.createElement(
        PopoutBase,
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, props, {
          styleName: 'blue-stripe' }),
        React.createElement('div', { styleName: 'stripe stripe-blue' }),
        React.createElement(
          'div',
          { styleName: 'inner',
            className: innerClassName },
          children
        )
      );
    }
  }]);

  return CalendarPopout;
}(React.Component), _class11.propTypes = _propTypes, _class11.defaultProps = _defaultProps, _temp5)) || _class10);

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_CURRENCY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return defaultCurrencyInfo; });
var DEFAULT_CURRENCY = 'USD';

var currenciesInfo = {
  AUD: {
    symbol: '$',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 350,
      default: 6.49
    },
    rent: {
      min: 0.01,
      max: 350,
      default: 3.79
    },
    sale: {
      min: 0.01,
      max: 350,
      default: 3.79
    }
  },
  BRL: {
    symbol: 'R$',
    offset: 2,
    subscription: {
      min: 0.05,
      max: 810,
      default: 16.79
    },
    rent: {
      min: 0.05,
      max: 810,
      default: 9.79
    },
    sale: {
      min: 0.05,
      max: 810,
      default: 9.79
    }
  },
  CAD: {
    symbol: '$',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 350,
      default: 5.79
    },
    rent: {
      min: 0.01,
      max: 350,
      default: 3.49
    },
    sale: {
      min: 0.01,
      max: 350,
      default: 3.49
    }
  },
  CHF: {
    symbol: 'CHF',
    offset: 2,
    subscription: {
      min: 0.05,
      max: 247,
      default: 4.99
    },
    rent: {
      min: 0.05,
      max: 247,
      default: 2.99
    },
    sale: {
      min: 0.05,
      max: 247,
      default: 2.99
    }
  },
  CZK: {
    symbol: 'Kč',
    offset: 2,
    subscription: {
      min: 1,
      max: 6740,
      default: 121.49
    },
    rent: {
      min: 1,
      max: 6740,
      default: 72.49
    },
    sale: {
      min: 1,
      max: 6740,
      default: 72.49
    }
  },
  DKK: {
    symbol: 'kr',
    offset: 2,
    subscription: {
      min: 0.05,
      max: 1670,
      default: 33.99
    },
    rent: {
      min: 0.05,
      max: 1670,
      default: 19.99
    },
    sale: {
      min: 0.05,
      max: 1670,
      default: 19.99
    }
  },
  EUR: {
    symbol: '\u20AC',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 250,
      default: 4.99
    },
    rent: {
      min: 0.01,
      max: 250,
      default: 2.99
    },
    sale: {
      min: 0.01,
      max: 250,
      default: 2.99
    }
  },
  GBP: {
    symbol: '\xA3',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 150,
      default: 3.99
    },
    rent: {
      min: 0.01,
      max: 150,
      default: 2.29
    },
    sale: {
      min: 0.01,
      max: 150,
      default: 2.29
    }
  },
  HKD: {
    symbol: '$',
    offset: 2,
    subscription: {
      min: 0.1,
      max: 1940,
      default: 39
    },
    rent: {
      min: 0.1,
      max: 1940,
      default: 24
    },
    sale: {
      min: 0.1,
      max: 1940,
      default: 24
    }
  },
  HUF: {
    symbol: 'Ft',
    offset: 2,
    subscription: {
      min: 5,
      max: 70000,
      default: 1389.49
    },
    rent: {
      min: 5,
      max: 70000,
      default: 833.49
    },
    sale: {
      min: 5,
      max: 70000,
      default: 833.49
    }
  },
  ILS: {
    symbol: '\u20AA',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 1000,
      default: 17.9
    },
    rent: {
      min: 0.01,
      max: 1000,
      default: 10.9
    },
    sale: {
      min: 0.01,
      max: 1000,
      default: 10.9
    }
  },
  JPY: {
    symbol: '\xA5',
    offset: 0,
    subscription: {
      min: 1,
      max: 30000,
      default: 420
    },
    rent: {
      min: 1,
      max: 30000,
      default: 360
    },
    sale: {
      min: 1,
      max: 30000,
      default: 360
    }
  },
  MXN: {
    symbol: '$',
    offset: 2,
    subscription: {
      min: 0.5,
      max: 4724,
      default: 94.49
    },
    rent: {
      min: 0.5,
      max: 4724,
      default: 56.49
    },
    sale: {
      min: 0.5,
      max: 4724,
      default: 56.49
    }
  },
  MYR: {
    symbol: 'RM',
    offset: 2,
    subscription: {
      min: 0.05,
      max: 1025,
      default: 20.49
    },
    rent: {
      min: 0.05,
      max: 1025,
      default: 12.49
    },
    sale: {
      min: 0.05,
      max: 1025,
      default: 12.49
    }
  },
  NOK: {
    symbol: 'kr',
    offset: 2,
    subscription: {
      min: 1,
      max: 2090,
      default: 41.99
    },
    rent: {
      min: 1,
      max: 2090,
      default: 24.99
    },
    sale: {
      min: 1,
      max: 2090,
      default: 24.99
    }
  },
  NZD: {
    symbol: '$',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 380,
      default: 6.49
    },
    rent: {
      min: 0.01,
      max: 380,
      default: 3.79
    },
    sale: {
      min: 0.01,
      max: 380,
      default: 3.79
    }
  },
  PHP: {
    symbol: '₱',
    offset: 2,
    subscription: {
      min: 1,
      max: 11690,
      default: 233.99
    },
    rent: {
      min: 1,
      max: 11690,
      default: 139.99
    },
    sale: {
      min: 1,
      max: 11690,
      default: 139.99
    }
  },
  PLN: {
    symbol: 'zł',
    offset: 2,
    subscription: {
      min: 1,
      max: 980,
      default: 19.79
    },
    rent: {
      min: 1,
      max: 980,
      default: 11.79
    },
    sale: {
      min: 1,
      max: 980,
      default: 11.79
    }
  },
  RUB: {
    symbol: '\u20BD',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 15000,
      default: 279
    },
    rent: {
      min: 0.01,
      max: 15000,
      default: 169
    },
    sale: {
      min: 0.01,
      max: 15000,
      default: 169
    }
  },
  SEK: {
    symbol: 'kr',
    offset: 2,
    subscription: {
      min: 1,
      max: 2148,
      default: 42.79
    },
    rent: {
      min: 1,
      max: 2148,
      default: 25.79
    },
    sale: {
      min: 1,
      max: 2148,
      default: 25.79
    }
  },
  SGD: {
    symbol: '$',
    offset: 2,
    subscription: {
      min: 0.05,
      max: 340,
      default: 6.79
    },
    rent: {
      min: 0.05,
      max: 340,
      default: 4.79
    },
    sale: {
      min: 0.05,
      max: 340,
      default: 4.79
    }
  },
  THB: {
    symbol: '฿',
    offset: 2,
    subscription: {
      min: 0.5,
      max: 8660,
      default: 172.79
    },
    rent: {
      min: 0.5,
      max: 8660,
      default: 103.49
    },
    sale: {
      min: 0.5,
      max: 8660,
      default: 103.49
    }
  },
  TWD: {
    symbol: 'NT$',
    offset: 2,
    subscription: {
      min: 1,
      max: 7936,
      default: 158.49
    },
    rent: {
      min: 1,
      max: 7936,
      default: 94.99
    },
    sale: {
      min: 1,
      max: 7936,
      default: 94.99
    }
  },
  USD: {
    symbol: '$',
    offset: 2,
    subscription: {
      min: 0.01,
      max: 250,
      default: 4.99
    },
    rent: {
      min: 0.01,
      max: 250,
      default: 2.99
    },
    sale: {
      min: 0.01,
      max: 250,
      default: 2.99
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (currenciesInfo);

var defaultCurrencyInfo = currenciesInfo[DEFAULT_CURRENCY];

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sendPerformanceInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addSingleMeasurement; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_utils_wix_sdk__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_analytics_new_relic__ = __webpack_require__(353);



var perf = global.vodPerformance || {
  now: _.noop,

  addVar: _.noop,
  addTimestamp: _.noop,

  stamps: {},
  vars: {}
};

var addVar = perf.addVar,
    addTimestamp = perf.addTimestamp,
    stamps = perf.stamps,
    vars = perf.vars,
    now = perf.now,
    isReady = perf.isReady;


var sendPerformanceInfo = _.once(function () {
  __WEBPACK_IMPORTED_MODULE_0_shared_utils_wix_sdk__["a" /* default */].Performance.applicationLoaded();

  if (!isReady) {
    return;
  }

  try {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_analytics_new_relic__["a" /* getNewRelic */])().addPageAction('performance', vars);
  } catch (err) {
    // new relic is no initiated
  }
});

var addSingleMeasurement = function addSingleMeasurement(name) {
  var fromTimestamp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'navigationStart';

  if (!stamps[name]) {
    addTimestamp(name, now());
  }

  if (!vars[name]) {
    addVar(name, now() - stamps[fromTimestamp]);
  }
};

/* harmony default export */ __webpack_exports__["c"] = (perf);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(19)))

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return lists; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return listItems; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__youtube_index__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_channel_types__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__youtube_url_types__ = __webpack_require__(137);


var _lists, _listItems;






var youtubeAdapter = new __WEBPACK_IMPORTED_MODULE_1__youtube_index__["a" /* default */]();

var lists = (_lists = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lists, __WEBPACK_IMPORTED_MODULE_2__constants_channel_types__["a" /* default */].YOUTUBE_FEED + '.' + __WEBPACK_IMPORTED_MODULE_3__youtube_url_types__["a" /* default */].PLAYLIST, youtubeAdapter.playlists.get), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_lists, __WEBPACK_IMPORTED_MODULE_2__constants_channel_types__["a" /* default */].YOUTUBE_FEED + '.' + __WEBPACK_IMPORTED_MODULE_3__youtube_url_types__["a" /* default */].CHANNEL, youtubeAdapter.channels.get), _lists);

var listItems = (_listItems = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_listItems, __WEBPACK_IMPORTED_MODULE_2__constants_channel_types__["a" /* default */].YOUTUBE_FEED + '.' + __WEBPACK_IMPORTED_MODULE_3__youtube_url_types__["a" /* default */].PLAYLIST, youtubeAdapter.videos.getByPlaylistId), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_listItems, __WEBPACK_IMPORTED_MODULE_2__constants_channel_types__["a" /* default */].YOUTUBE_FEED + '.' + __WEBPACK_IMPORTED_MODULE_3__youtube_url_types__["a" /* default */].CHANNEL, youtubeAdapter.videos.getByChannelId), _listItems);

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return excludedFields; });
/* harmony export (immutable) */ __webpack_exports__["c"] = prepareItemForSending;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parsers_item__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parsers_error__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__trigger_progress_while_transcoding__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_http__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_object__ = __webpack_require__(51);









// TODO: switch to whitelist instead of blacklist
var excludedFields = ['updateUrl', 'listId', 'qualities', 'mediaInfo', 'itemType', 'createdTs', 'updatedTs', 'usedInLists', 'getVideoUrls', 'getVideoUrlsByFileName', 'transcodingStatus', 'trailerTranscodingStatus', 'uploadingStatus', 'trailerInfo', 'trailerStatus', 'id', 'channelId', 'channelData', 'usedCount', 'isNew', 'error', 'errorInfo', 'currentFileProgress', 'uploadedSize', 'fileSize'];

function _trimAndUniq(array) {
  return _(array).map(_.trim).uniq().value();
}

function prepareItemForSending(itemData) {
  itemData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_object__["keysToCamelCase"])(itemData);

  var _itemData = itemData,
      publishTs = _itemData.publishTs;


  if (publishTs) {
    itemData.publishTs = Math.round(publishTs.valueOf() / 1000);
  }

  itemData.categories = _trimAndUniq(itemData.categories);
  itemData.tags = _trimAndUniq(itemData.tags);

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_object__["keysToSnakeCase"])(_.omit(itemData, excludedFields));
}

/* harmony default export */ __webpack_exports__["a"] = (function (settings, adapterMethods) {

  var toItem = _.partial(__WEBPACK_IMPORTED_MODULE_2__parsers_item__["a" /* default */], adapterMethods);

  function _parseSuccessResponse(response) {
    var data = response.data;


    if (_.isArray(data)) {
      data = data[0];
    }

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, response, {
      data: toItem(data)
    });
  }

  function _connectItemToList(trigger, itemResponse, listId) {
    if (!listId || _.find(itemResponse.data.usedInLists, { itemId: listId })) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(itemResponse);
    }

    return adapterMethods.list.get(trigger, listId).then(_.property('data.title')).then(function (listTitle) {
      return adapterMethods.listItems.add(trigger, listId, itemResponse.data.id).then(function () {
        itemResponse.data.usedInLists = [{
          id: listId,
          title: listTitle
        }];
      });
    }).then(function () {
      return adapterMethods.list.publish(trigger, listId);
    });
  }

  function _tryToCreateInList(trigger, itemData) {
    var file = itemData.file,
        title = itemData.title,
        listId = itemData.listId,
        _itemData$mediaType = itemData.mediaType,
        mediaType = _itemData$mediaType === undefined ? settings.mediaType : _itemData$mediaType;


    var creationData = {
      title: title,
      mediaType: mediaType,
      listId: listId
    };

    return adapterMethods.file.canUploadVideo(trigger, file).then(function () {
      return adapterMethods.item.createInList(trigger, creationData, listId);
    }).catch(__WEBPACK_IMPORTED_MODULE_3__parsers_error__["a" /* default */]);
  }

  function get(trigger, itemId) {
    if (!itemId) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__parsers_error__["a" /* default */])({
        status: 500,
        data: {
          errorCode: 500,
          errorDescription: 'no id provided'
        }
      });
    }

    return __WEBPACK_IMPORTED_MODULE_5__utils_http__["get"](settings.apiUrl + '/catalog/items/' + itemId).then(_parseSuccessResponse).then(function (parsedResponse) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__trigger_progress_while_transcoding__["a" /* default */])([parsedResponse.data]);
      return parsedResponse;
    }).catch(__WEBPACK_IMPORTED_MODULE_3__parsers_error__["a" /* default */]);
  }

  function create(trigger, itemData) {
    return adapterMethods.items.create(trigger, [itemData]).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, response, {
        data: response.data[0]
      });
    });
  }

  function createInList(trigger, itemData, listId) {
    return adapterMethods.item.create(trigger, itemData).then(function (itemResponse) {
      return _connectItemToList(trigger, itemResponse, listId).then(function () {
        return itemResponse;
      }).catch(function () {
        return itemResponse;
      });
    }).catch(__WEBPACK_IMPORTED_MODULE_3__parsers_error__["a" /* default */]);
  }

  function update(trigger, itemData) {
    var id = itemData.id;

    var data = prepareItemForSending(itemData);

    return __WEBPACK_IMPORTED_MODULE_5__utils_http__["put"](settings.apiUrl + '/catalog/items/' + id, { data: data }).then(_parseSuccessResponse).catch(__WEBPACK_IMPORTED_MODULE_3__parsers_error__["a" /* default */]);
  }

  function upload(trigger, itemData) {
    var file = itemData.file,
        _itemData$mediaType2 = itemData.mediaType,
        mediaType = _itemData$mediaType2 === undefined ? settings.mediaType : _itemData$mediaType2;


    return _tryToCreateInList(trigger, itemData).then(function (itemResponse) {
      var catalogCallbackUrl = itemResponse.data.updateUrl;
      return adapterMethods.file.uploadVideo(trigger, { catalogCallbackUrl: catalogCallbackUrl, file: file, mediaType: mediaType }).then(function () {
        return itemResponse;
      });
    }).then(function (itemResponse) {
      return adapterMethods.item.get(trigger, itemResponse.data.id);
    });
  }

  function uploadByUrl(trigger, itemData) {
    var file = itemData.file,
        _itemData$mediaType3 = itemData.mediaType,
        mediaType = _itemData$mediaType3 === undefined ? settings.mediaType : _itemData$mediaType3;


    return _tryToCreateInList(trigger, itemData).then(function (itemResponse) {
      var catalogCallbackUrl = itemResponse.data.updateUrl;
      var uploadFn = adapterMethods.file.uploadByUrl;
      var fileProps = _.omit(file, 'duration');

      return adapterMethods.file.uploadVideo(trigger, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ catalogCallbackUrl: catalogCallbackUrl, mediaType: mediaType }, fileProps), uploadFn).then(function (videoFile) {
        return { videoFile: videoFile, itemResponse: itemResponse };
      });
    });
  }

  function reupload(trigger, uploadData) {
    var file = uploadData.file,
        itemId = uploadData.itemId,
        listId = uploadData.listId,
        _uploadData$mediaType = uploadData.mediaType,
        mediaType = _uploadData$mediaType === undefined ? settings.mediaType : _uploadData$mediaType,
        catalogCallbackUrl = uploadData.updateUrl;


    return adapterMethods.file.canUploadVideo(trigger, file).then(function () {
      return adapterMethods.item.get(trigger, itemId);
    }).then(function (itemResponse) {
      // fields can be changed while lists requests in progress
      itemResponse.data = _.omit(itemResponse.data, ['transcodingStatus', 'uploadingStatus']);
      return _connectItemToList(trigger, itemResponse, listId).then(function () {
        return itemResponse;
      }).catch(function () {
        return itemResponse;
      });
    }).then(function () {
      return adapterMethods.file.uploadVideo(trigger, { catalogCallbackUrl: catalogCallbackUrl, file: file, mediaType: mediaType });
    }).then(function (fileResponse) {
      return adapterMethods.item.update(trigger, {
        id: itemId,
        mediaFileName: fileResponse.data.id
      });
    }).catch(__WEBPACK_IMPORTED_MODULE_3__parsers_error__["a" /* default */]);
  }

  function getVideoUrls(trigger, itemId, instance) {
    var params = {
      instance: instance
    };

    return __WEBPACK_IMPORTED_MODULE_5__utils_http__["get"](settings.apiUrl + '/public/play/' + itemId, { params: params }).then(_.property('data')).catch(__WEBPACK_IMPORTED_MODULE_3__parsers_error__["a" /* default */]);
  }

  function getVideoUrlsByFileName(trigger, fileName) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (!fileName) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject();
    }

    return __WEBPACK_IMPORTED_MODULE_5__utils_http__["get"](settings.apiUrl + '/catalog/videos/' + fileName + '/play', { params: params }).then(_.property('data')).catch(__WEBPACK_IMPORTED_MODULE_3__parsers_error__["a" /* default */]);
  }

  return {
    get: get,
    create: create,
    createInList: createInList,
    update: update,
    upload: upload,
    reupload: reupload,
    uploadByUrl: uploadByUrl,
    getVideoUrls: getVideoUrls,
    getVideoUrlsByFileName: getVideoUrlsByFileName
  };
});

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Youtube;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parse_url__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__videos__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channels__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__playlists__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__settings__ = __webpack_require__(706);







function Youtube(userSettings) {
  var settings = _.assign({}, __WEBPACK_IMPORTED_MODULE_4__settings__["a" /* default */], userSettings);

  var adapterMethods = {
    parseUrl: __WEBPACK_IMPORTED_MODULE_0__parse_url__["a" /* default */]
  };

  adapterMethods.videos = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__videos__["a" /* default */])(settings, adapterMethods);
  adapterMethods.channels = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__channels__["a" /* default */])(settings, adapterMethods);
  adapterMethods.playlists = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__playlists__["a" /* default */])(settings, adapterMethods);

  _.assign(this, adapterMethods);
}

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseUrl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parsers_error__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__url_types__ = __webpack_require__(137);




function parseUrl(url) {
  var skipVideos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var idRegexp = '([\\w\\-]+)';
  var matched = void 0;

  if (!skipVideos) {

    /* Try to parse url as video */
    // Parse https://youtu.be/2IH-8tNQA_zSs format
    matched = new RegExp('youtu\\.be\\/' + idRegexp).exec(url);

    // Parse https://www.youtube.com/watch?v=2IH-8tNQA_zSs&feature=youtu.be format
    if (!matched) {
      matched = new RegExp('youtube\\.com\\/watch\\?.*v=' + idRegexp).exec(url);
    }

    if (!matched) {
      matched = new RegExp('youtube\\.com\\/(?:v|embed)\\/' + idRegexp).exec(url);
    }

    if (matched) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve({
        id: matched[1],
        type: __WEBPACK_IMPORTED_MODULE_2__url_types__["a" /* default */].VIDEO
      });
    }
  }

  /* Try to parse url as playlist */
  // Parse https://www.youtube.com/playlist?list=PLEAPYCvF3PpFGPDGD_AHR9m8zqNxrky_j format
  matched = new RegExp('youtube\\.com\\/.*list=' + idRegexp).exec(url);

  if (matched) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve({
      id: matched[1],
      type: __WEBPACK_IMPORTED_MODULE_2__url_types__["a" /* default */].PLAYLIST
    });
  }

  /* Try to parse url as channel */
  // Parse https://www.youtube.com/channel/UCAwuAYBCPm7l-Drg7rktLhQ format
  matched = new RegExp('youtube\\.com\\/channel\\/' + idRegexp).exec(url);

  if (matched) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve({
      id: matched[1],
      type: __WEBPACK_IMPORTED_MODULE_2__url_types__["a" /* default */].CHANNEL
    });
  }

  /* Try to parse url as user */
  // Parse https://www.youtube.com/user/vlogbrothers format
  matched = new RegExp('youtube\\.com\\/user\\/' + idRegexp).exec(url);

  if (matched) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve({
      id: matched[1],
      type: __WEBPACK_IMPORTED_MODULE_2__url_types__["a" /* default */].USER_NAME
    });
  }

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new __WEBPACK_IMPORTED_MODULE_1__parsers_error__["b" /* InternalError */](400, 'wpm_error.malformed_external_link', 'External link was not formatted properly'));
}

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adapters_index__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__adapters_Adapter__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_object__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_time__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_http__ = __webpack_require__(44);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__adapters_index__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__adapters_Adapter__["a"]; });
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__utils_object__; });
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__utils_time__; });
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__utils_http__; });








/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = normalizeId;
function normalizeId(id) {
  if (!id) {
    return id;
  }

  return id.split('-').pop();
}

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  FACEBOOK: 'facebook',
  TWITTER: 'twitter',
  PINTEREST: 'pinterest',
  TUMBLR: 'tumblr',
  LINK: 'link'
});

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(721);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(207);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 275 */
/***/ (function(module, exports) {

module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),
/* 276 */
/***/ (function(module, exports) {

module.exports = function(it, Constructor, name, forbiddenField){
  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(99)
  , document = __webpack_require__(55).document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};

/***/ }),
/* 278 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(170);
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY        = __webpack_require__(211)
  , $export        = __webpack_require__(72)
  , redefine       = __webpack_require__(450)
  , hide           = __webpack_require__(98)
  , has            = __webpack_require__(118)
  , Iterators      = __webpack_require__(139)
  , $iterCreate    = __webpack_require__(752)
  , setToStringTag = __webpack_require__(172)
  , getPrototypeOf = __webpack_require__(448)
  , ITERATOR       = __webpack_require__(48)('iterator')
  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
  , FF_ITERATOR    = '@@iterator'
  , KEYS           = 'keys'
  , VALUES         = 'values';

var returnThis = function(){ return this; };

module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
  $iterCreate(Constructor, NAME, next);
  var getMethod = function(kind){
    if(!BUGGY && kind in proto)return proto[kind];
    switch(kind){
      case KEYS: return function keys(){ return new Constructor(this, kind); };
      case VALUES: return function values(){ return new Constructor(this, kind); };
    } return function entries(){ return new Constructor(this, kind); };
  };
  var TAG        = NAME + ' Iterator'
    , DEF_VALUES = DEFAULT == VALUES
    , VALUES_BUG = false
    , proto      = Base.prototype
    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
    , $default   = $native || getMethod(DEFAULT)
    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
    , methods, key, IteratorPrototype;
  // Fix native
  if($anyNative){
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
    if(IteratorPrototype !== Object.prototype){
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if(DEF_VALUES && $native && $native.name !== VALUES){
    VALUES_BUG = true;
    $default = function values(){ return $native.call(this); };
  }
  // Define iterator
  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG]  = returnThis;
  if(DEFAULT){
    methods = {
      values:  DEF_VALUES ? $default : getMethod(VALUES),
      keys:    IS_SET     ? $default : getMethod(KEYS),
      entries: $entries
    };
    if(FORCED)for(key in methods){
      if(!(key in proto))redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

var META     = __webpack_require__(215)('meta')
  , isObject = __webpack_require__(99)
  , has      = __webpack_require__(118)
  , setDesc  = __webpack_require__(73).f
  , id       = 0;
var isExtensible = Object.isExtensible || function(){
  return true;
};
var FREEZE = !__webpack_require__(117)(function(){
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function(it){
  setDesc(it, META, {value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  }});
};
var fastKey = function(it, create){
  // return primitive with prefix
  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return 'F';
    // not necessary to add metadata
    if(!create)return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function(it, create){
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return true;
    // not necessary to add metadata
    if(!create)return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function(it){
  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY:      META,
  NEED:     false,
  fastKey:  fastKey,
  getWeak:  getWeak,
  onFreeze: onFreeze
};

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

var pIE            = __webpack_require__(213)
  , createDesc     = __webpack_require__(171)
  , toIObject      = __webpack_require__(100)
  , toPrimitive    = __webpack_require__(288)
  , has            = __webpack_require__(118)
  , IE8_DOM_DEFINE = __webpack_require__(441)
  , gOPD           = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(77) ? gOPD : function getOwnPropertyDescriptor(O, P){
  O = toIObject(O);
  P = toPrimitive(P, true);
  if(IE8_DOM_DEFINE)try {
    return gOPD(O, P);
  } catch(e){ /* empty */ }
  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
};

/***/ }),
/* 283 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(98);
module.exports = function(target, src, safe){
  for(var key in src){
    if(safe && target[key])target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(286)('keys')
  , uid    = __webpack_require__(215);
module.exports = function(key){
  return shared[key] || (shared[key] = uid(key));
};

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(55)
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};

/***/ }),
/* 287 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil  = Math.ceil
  , floor = Math.floor;
module.exports = function(it){
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(99);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S){
  if(!isObject(it))return it;
  var fn, val;
  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

var global         = __webpack_require__(55)
  , core           = __webpack_require__(37)
  , LIBRARY        = __webpack_require__(211)
  , wksExt         = __webpack_require__(290)
  , defineProperty = __webpack_require__(73).f;
module.exports = function(name){
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
};

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(48);

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

var classof   = __webpack_require__(208)
  , ITERATOR  = __webpack_require__(48)('iterator')
  , Iterators = __webpack_require__(139);
module.exports = __webpack_require__(37).getIteratorMethod = function(it){
  if(it != undefined)return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};

/***/ }),
/* 292 */
/***/ (function(module, exports) {



/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(45)
  , toIndex  = __webpack_require__(126)
  , toLength = __webpack_require__(43);
module.exports = function fill(value /*, start = 0, end = @length */){
  var O      = toObject(this)
    , length = toLength(O.length)
    , aLen   = arguments.length
    , index  = toIndex(aLen > 1 ? arguments[1] : undefined, length)
    , end    = aLen > 2 ? arguments[2] : undefined
    , endPos = end === undefined ? length : toIndex(end, length);
  while(endPos > index)O[index++] = value;
  return O;
};

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(33)
  , createDesc      = __webpack_require__(102);

module.exports = function(object, index, value){
  if(index in object)$defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(28)
  , document = __webpack_require__(21).document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};

/***/ }),
/* 296 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(29)('match');
module.exports = function(KEY){
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch(e){
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch(f){ /* empty */ }
  } return true;
};

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(21).document && document.documentElement;

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

var isObject       = __webpack_require__(28)
  , setPrototypeOf = __webpack_require__(307).set;
module.exports = function(that, target, C){
  var P, S = target.constructor;
  if(S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf){
    setPrototypeOf(that, P);
  } return that;
};

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators  = __webpack_require__(143)
  , ITERATOR   = __webpack_require__(29)('iterator')
  , ArrayProto = Array.prototype;

module.exports = function(it){
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(74);
module.exports = Array.isArray || function isArray(arg){
  return cof(arg) == 'Array';
};

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create         = __webpack_require__(121)
  , descriptor     = __webpack_require__(102)
  , setToStringTag = __webpack_require__(144)
  , IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(57)(IteratorPrototype, __webpack_require__(29)('iterator'), function(){ return this; });

module.exports = function(Constructor, NAME, next){
  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
  setToStringTag(Constructor, NAME + ' Iterator');
};

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY        = __webpack_require__(120)
  , $export        = __webpack_require__(6)
  , redefine       = __webpack_require__(58)
  , hide           = __webpack_require__(57)
  , has            = __webpack_require__(52)
  , Iterators      = __webpack_require__(143)
  , $iterCreate    = __webpack_require__(302)
  , setToStringTag = __webpack_require__(144)
  , getPrototypeOf = __webpack_require__(66)
  , ITERATOR       = __webpack_require__(29)('iterator')
  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
  , FF_ITERATOR    = '@@iterator'
  , KEYS           = 'keys'
  , VALUES         = 'values';

var returnThis = function(){ return this; };

module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
  $iterCreate(Constructor, NAME, next);
  var getMethod = function(kind){
    if(!BUGGY && kind in proto)return proto[kind];
    switch(kind){
      case KEYS: return function keys(){ return new Constructor(this, kind); };
      case VALUES: return function values(){ return new Constructor(this, kind); };
    } return function entries(){ return new Constructor(this, kind); };
  };
  var TAG        = NAME + ' Iterator'
    , DEF_VALUES = DEFAULT == VALUES
    , VALUES_BUG = false
    , proto      = Base.prototype
    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
    , $default   = $native || getMethod(DEFAULT)
    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
    , methods, key, IteratorPrototype;
  // Fix native
  if($anyNative){
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
    if(IteratorPrototype !== Object.prototype){
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if(DEF_VALUES && $native && $native.name !== VALUES){
    VALUES_BUG = true;
    $default = function values(){ return $native.call(this); };
  }
  // Define iterator
  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG]  = returnThis;
  if(DEFAULT){
    methods = {
      values:  DEF_VALUES ? $default : getMethod(VALUES),
      keys:    IS_SET     ? $default : getMethod(KEYS),
      entries: $entries
    };
    if(FORCED)for(key in methods){
      if(!(key in proto))redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

/***/ }),
/* 304 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x){
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;

/***/ }),
/* 305 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x){
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(21)
  , macrotask = __webpack_require__(314).set
  , Observer  = global.MutationObserver || global.WebKitMutationObserver
  , process   = global.process
  , Promise   = global.Promise
  , isNode    = __webpack_require__(74)(process) == 'process';

module.exports = function(){
  var head, last, notify;

  var flush = function(){
    var parent, fn;
    if(isNode && (parent = process.domain))parent.exit();
    while(head){
      fn   = head.fn;
      head = head.next;
      try {
        fn();
      } catch(e){
        if(head)notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if(parent)parent.enter();
  };

  // Node.js
  if(isNode){
    notify = function(){
      process.nextTick(flush);
    };
  // browsers with MutationObserver
  } else if(Observer){
    var toggle = true
      , node   = document.createTextNode('');
    new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
    notify = function(){
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if(Promise && Promise.resolve){
    var promise = Promise.resolve();
    notify = function(){
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function(){
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function(fn){
    var task = {fn: fn, next: undefined};
    if(last)last.next = task;
    if(!head){
      head = task;
      notify();
    } last = task;
  };
};

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(28)
  , anObject = __webpack_require__(20);
var check = function(O, proto){
  anObject(O);
  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function(test, buggy, set){
      try {
        set = __webpack_require__(88)(Function.call, __webpack_require__(65).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch(e){ buggy = true; }
      return function setPrototypeOf(O, proto){
        check(O, proto);
        if(buggy)O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(225)('keys')
  , uid    = __webpack_require__(127);
module.exports = function(key){
  return shared[key] || (shared[key] = uid(key));
};

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject  = __webpack_require__(20)
  , aFunction = __webpack_require__(56)
  , SPECIES   = __webpack_require__(29)('species');
module.exports = function(O, D){
  var C = anObject(O).constructor, S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(103)
  , defined   = __webpack_require__(75);
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING){
  return function(that, pos){
    var s = String(defined(that))
      , i = toInteger(pos)
      , l = s.length
      , a, b;
    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(221)
  , defined  = __webpack_require__(75);

module.exports = function(that, searchString, NAME){
  if(isRegExp(searchString))throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(103)
  , defined   = __webpack_require__(75);

module.exports = function repeat(count){
  var str = String(defined(this))
    , res = ''
    , n   = toInteger(count);
  if(n < 0 || n == Infinity)throw RangeError("Count can't be negative");
  for(;n > 0; (n >>>= 1) && (str += str))if(n & 1)res += str;
  return res;
};

/***/ }),
/* 313 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

var ctx                = __webpack_require__(88)
  , invoke             = __webpack_require__(220)
  , html               = __webpack_require__(298)
  , cel                = __webpack_require__(295)
  , global             = __webpack_require__(21)
  , process            = global.process
  , setTask            = global.setImmediate
  , clearTask          = global.clearImmediate
  , MessageChannel     = global.MessageChannel
  , counter            = 0
  , queue              = {}
  , ONREADYSTATECHANGE = 'onreadystatechange'
  , defer, channel, port;
var run = function(){
  var id = +this;
  if(queue.hasOwnProperty(id)){
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function(event){
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if(!setTask || !clearTask){
  setTask = function setImmediate(fn){
    var args = [], i = 1;
    while(arguments.length > i)args.push(arguments[i++]);
    queue[++counter] = function(){
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id){
    delete queue[id];
  };
  // Node.js 0.8-
  if(__webpack_require__(74)(process) == 'process'){
    defer = function(id){
      process.nextTick(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if(MessageChannel){
    channel = new MessageChannel;
    port    = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
    defer = function(id){
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if(ONREADYSTATECHANGE in cel('script')){
    defer = function(id){
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function(id){
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set:   setTask,
  clear: clearTask
};

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global         = __webpack_require__(21)
  , DESCRIPTORS    = __webpack_require__(32)
  , LIBRARY        = __webpack_require__(120)
  , $typed         = __webpack_require__(226)
  , hide           = __webpack_require__(57)
  , redefineAll    = __webpack_require__(124)
  , fails          = __webpack_require__(24)
  , anInstance     = __webpack_require__(119)
  , toInteger      = __webpack_require__(103)
  , toLength       = __webpack_require__(43)
  , gOPN           = __webpack_require__(122).f
  , dP             = __webpack_require__(33).f
  , arrayFill      = __webpack_require__(293)
  , setToStringTag = __webpack_require__(144)
  , ARRAY_BUFFER   = 'ArrayBuffer'
  , DATA_VIEW      = 'DataView'
  , PROTOTYPE      = 'prototype'
  , WRONG_LENGTH   = 'Wrong length!'
  , WRONG_INDEX    = 'Wrong index!'
  , $ArrayBuffer   = global[ARRAY_BUFFER]
  , $DataView      = global[DATA_VIEW]
  , Math           = global.Math
  , RangeError     = global.RangeError
  , Infinity       = global.Infinity
  , BaseBuffer     = $ArrayBuffer
  , abs            = Math.abs
  , pow            = Math.pow
  , floor          = Math.floor
  , log            = Math.log
  , LN2            = Math.LN2
  , BUFFER         = 'buffer'
  , BYTE_LENGTH    = 'byteLength'
  , BYTE_OFFSET    = 'byteOffset'
  , $BUFFER        = DESCRIPTORS ? '_b' : BUFFER
  , $LENGTH        = DESCRIPTORS ? '_l' : BYTE_LENGTH
  , $OFFSET        = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
var packIEEE754 = function(value, mLen, nBytes){
  var buffer = Array(nBytes)
    , eLen   = nBytes * 8 - mLen - 1
    , eMax   = (1 << eLen) - 1
    , eBias  = eMax >> 1
    , rt     = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0
    , i      = 0
    , s      = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0
    , e, m, c;
  value = abs(value)
  if(value != value || value === Infinity){
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if(value * (c = pow(2, -e)) < 1){
      e--;
      c *= 2;
    }
    if(e + eBias >= 1){
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if(value * c >= 2){
      e++;
      c /= 2;
    }
    if(e + eBias >= eMax){
      m = 0;
      e = eMax;
    } else if(e + eBias >= 1){
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for(; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for(; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
};
var unpackIEEE754 = function(buffer, mLen, nBytes){
  var eLen  = nBytes * 8 - mLen - 1
    , eMax  = (1 << eLen) - 1
    , eBias = eMax >> 1
    , nBits = eLen - 7
    , i     = nBytes - 1
    , s     = buffer[i--]
    , e     = s & 127
    , m;
  s >>= 7;
  for(; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for(; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if(e === 0){
    e = 1 - eBias;
  } else if(e === eMax){
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
};

var unpackI32 = function(bytes){
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
};
var packI8 = function(it){
  return [it & 0xff];
};
var packI16 = function(it){
  return [it & 0xff, it >> 8 & 0xff];
};
var packI32 = function(it){
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
};
var packF64 = function(it){
  return packIEEE754(it, 52, 8);
};
var packF32 = function(it){
  return packIEEE754(it, 23, 4);
};

var addGetter = function(C, key, internal){
  dP(C[PROTOTYPE], key, {get: function(){ return this[internal]; }});
};

var get = function(view, bytes, index, isLittleEndian){
  var numIndex = +index
    , intIndex = toInteger(numIndex);
  if(numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH])throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b
    , start = intIndex + view[$OFFSET]
    , pack  = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
};
var set = function(view, bytes, index, conversion, value, isLittleEndian){
  var numIndex = +index
    , intIndex = toInteger(numIndex);
  if(numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH])throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b
    , start = intIndex + view[$OFFSET]
    , pack  = conversion(+value);
  for(var i = 0; i < bytes; i++)store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
};

var validateArrayBufferArguments = function(that, length){
  anInstance(that, $ArrayBuffer, ARRAY_BUFFER);
  var numberLength = +length
    , byteLength   = toLength(numberLength);
  if(numberLength != byteLength)throw RangeError(WRONG_LENGTH);
  return byteLength;
};

if(!$typed.ABV){
  $ArrayBuffer = function ArrayBuffer(length){
    var byteLength = validateArrayBufferArguments(this, length);
    this._b       = arrayFill.call(Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength){
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH]
      , offset       = toInteger(byteOffset);
    if(offset < 0 || offset > bufferLength)throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if(offset + byteLength > bufferLength)throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if(DESCRIPTORS){
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset){
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset){
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /*, littleEndian */){
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /*, littleEndian */){
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /*, littleEndian */){
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /*, littleEndian */){
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /*, littleEndian */){
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /*, littleEndian */){
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value){
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value){
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /*, littleEndian */){
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /*, littleEndian */){
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /*, littleEndian */){
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /*, littleEndian */){
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /*, littleEndian */){
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /*, littleEndian */){
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if(!fails(function(){
    new $ArrayBuffer;     // eslint-disable-line no-new
  }) || !fails(function(){
    new $ArrayBuffer(.5); // eslint-disable-line no-new
  })){
    $ArrayBuffer = function ArrayBuffer(length){
      return new BaseBuffer(validateArrayBufferArguments(this, length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for(var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j; ){
      if(!((key = keys[j++]) in $ArrayBuffer))hide($ArrayBuffer, key, BaseBuffer[key]);
    };
    if(!LIBRARY)ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2))
    , $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if(view.getInt8(0) || !view.getInt8(1))redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value){
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value){
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var global         = __webpack_require__(21)
  , core           = __webpack_require__(87)
  , LIBRARY        = __webpack_require__(120)
  , wksExt         = __webpack_require__(476)
  , defineProperty = __webpack_require__(33).f;
module.exports = function(name){
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
};

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

var classof   = __webpack_require__(174)
  , ITERATOR  = __webpack_require__(29)('iterator')
  , Iterators = __webpack_require__(143);
module.exports = __webpack_require__(87).getIteratorMethod = function(it){
  if(it != undefined)return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(141)
  , step             = __webpack_require__(464)
  , Iterators        = __webpack_require__(143)
  , toIObject        = __webpack_require__(60);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(303)(Array, 'Array', function(iterated, kind){
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , kind  = this._k
    , index = this._i++;
  if(!O || index >= O.length){
    this._t = undefined;
    return step(1);
  }
  if(kind == 'keys'  )return step(0, index);
  if(kind == 'values')return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @class
 * @ignore
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var EventsBase = (function () {
    function EventsBase() {
        _classCallCheck(this, EventsBase);
    }

    _createClass(EventsBase, [{
        key: 'extend',
        value: function extend(events, config) {
            if (!events) return;

            var override = config ? config.override : false;
            var publicOnly = config ? config.publicOnly : false;

            for (var evt in events) {
                if (!events.hasOwnProperty(evt) || this[evt] && !override) continue;
                if (publicOnly && events[evt].indexOf('public_') === -1) continue;
                this[evt] = events[evt];
            }
        }
    }]);

    return EventsBase;
})();

exports['default'] = EventsBase;
module.exports = exports['default'];
//# sourceMappingURL=EventsBase.js.map


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @classdesc a base type for matching and converting types in manifest to
 * something more useful
 */



Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BaseMatcher = (function () {
    function BaseMatcher(test, converter) {
        _classCallCheck(this, BaseMatcher);

        this._test = test;
        this._converter = converter;
    }

    _createClass(BaseMatcher, [{
        key: "test",
        get: function get() {
            return this._test;
        }
    }, {
        key: "converter",
        get: function get() {
            return this._converter;
        }
    }]);

    return BaseMatcher;
})();

exports["default"] = BaseMatcher;
module.exports = exports["default"];
//# sourceMappingURL=BaseMatcher.js.map


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



Object.defineProperty(exports, '__esModule', {
    value: true
});
exports.replaceTokenForTemplate = replaceTokenForTemplate;
exports.getIndexBasedSegment = getIndexBasedSegment;
exports.getTimeBasedSegment = getTimeBasedSegment;
exports.getSegmentByIndex = getSegmentByIndex;
exports.decideSegmentListRangeForTimeline = decideSegmentListRangeForTimeline;
exports.decideSegmentListRangeForTemplate = decideSegmentListRangeForTemplate;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _voSegment = __webpack_require__(397);

var _voSegment2 = _interopRequireDefault(_voSegment);

function zeroPadToLength(numStr, minStrLength) {
    while (numStr.length < minStrLength) {
        numStr = '0' + numStr;
    }
    return numStr;
}

function getNumberForSegment(segment, segmentIndex) {
    return segment.representation.startNumber + segmentIndex;
}

function replaceTokenForTemplate(url, token, value) {
    var formatTag = '%0';

    var startPos, endPos, formatTagPos, specifier, width, paddedValue;

    var tokenLen = token.length;
    var formatTagLen = formatTag.length;

    if (!url) {
        return url;
    }

    // keep looping round until all instances of <token> have been
    // replaced. once that has happened, startPos below will be -1
    // and the completed url will be returned.
    while (true) {

        // check if there is a valid $<token>...$ identifier
        // if not, return the url as is.
        startPos = url.indexOf('$' + token);
        if (startPos < 0) {
            return url;
        }

        // the next '$' must be the end of the identifier
        // if there isn't one, return the url as is.
        endPos = url.indexOf('$', startPos + tokenLen);
        if (endPos < 0) {
            return url;
        }

        // now see if there is an additional format tag suffixed to
        // the identifier within the enclosing '$' characters
        formatTagPos = url.indexOf(formatTag, startPos + tokenLen);
        if (formatTagPos > startPos && formatTagPos < endPos) {

            specifier = url.charAt(endPos - 1);
            width = parseInt(url.substring(formatTagPos + formatTagLen, endPos - 1), 10);

            // support the minimum specifiers required by IEEE 1003.1
            // (d, i , o, u, x, and X) for completeness
            switch (specifier) {
                // treat all int types as uint,
                // hence deliberate fallthrough
                case 'd':
                case 'i':
                case 'u':
                    paddedValue = zeroPadToLength(value.toString(), width);
                    break;
                case 'x':
                    paddedValue = zeroPadToLength(value.toString(16), width);
                    break;
                case 'X':
                    paddedValue = zeroPadToLength(value.toString(16), width).toUpperCase();
                    break;
                case 'o':
                    paddedValue = zeroPadToLength(value.toString(8), width);
                    break;
                default:
                    //TODO: commented out logging to supress jshint warning -- `log` is undefined here
                    //log('Unsupported/invalid IEEE 1003.1 format identifier string in URL');
                    return url;
            }
        } else {
            paddedValue = value;
        }

        url = url.substring(0, startPos) + paddedValue + url.substring(endPos + 1);
    }
}

function getIndexBasedSegment(timelineConverter, isDynamic, representation, index) {
    var seg, duration, presentationStartTime, presentationEndTime;

    duration = representation.segmentDuration;

    /*
     * From spec - If neither @duration attribute nor SegmentTimeline element is present, then the Representation
     * shall contain exactly one Media Segment. The MPD start time is 0 and the MPD duration is obtained
     * in the same way as for the last Media Segment in the Representation.
     */
    if (isNaN(duration)) {
        duration = representation.adaptation.period.duration;
    }

    presentationStartTime = representation.adaptation.period.start + index * duration;
    presentationEndTime = presentationStartTime + duration;

    seg = new _voSegment2['default']();

    seg.representation = representation;
    seg.duration = duration;
    seg.presentationStartTime = presentationStartTime;

    seg.mediaStartTime = timelineConverter.calcMediaTimeFromPresentationTime(seg.presentationStartTime, representation);

    seg.availabilityStartTime = timelineConverter.calcAvailabilityStartTimeFromPresentationTime(seg.presentationStartTime, representation.adaptation.period.mpd, isDynamic);
    seg.availabilityEndTime = timelineConverter.calcAvailabilityEndTimeFromPresentationTime(presentationEndTime, representation.adaptation.period.mpd, isDynamic);

    // at this wall clock time, the video element currentTime should be seg.presentationStartTime
    seg.wallStartTime = timelineConverter.calcWallTimeForSegment(seg, isDynamic);

    seg.replacementNumber = getNumberForSegment(seg, index);
    seg.availabilityIdx = index;

    return seg;
}

function getTimeBasedSegment(timelineConverter, isDynamic, representation, time, duration, fTimescale, url, range, index) {
    var scaledTime = time / fTimescale;
    var scaledDuration = Math.min(duration / fTimescale, representation.adaptation.period.mpd.maxSegmentDuration);

    var presentationStartTime, presentationEndTime, seg;

    presentationStartTime = timelineConverter.calcPresentationTimeFromMediaTime(scaledTime, representation);
    presentationEndTime = presentationStartTime + scaledDuration;

    seg = new _voSegment2['default']();

    seg.representation = representation;
    seg.duration = scaledDuration;
    seg.mediaStartTime = scaledTime;

    seg.presentationStartTime = presentationStartTime;

    // For SegmentTimeline every segment is available at loadedTime
    seg.availabilityStartTime = representation.adaptation.period.mpd.manifest.loadedTime;
    seg.availabilityEndTime = timelineConverter.calcAvailabilityEndTimeFromPresentationTime(presentationEndTime, representation.adaptation.period.mpd, isDynamic);

    // at this wall clock time, the video element currentTime should be seg.presentationStartTime
    seg.wallStartTime = timelineConverter.calcWallTimeForSegment(seg, isDynamic);

    seg.replacementTime = time;

    seg.replacementNumber = getNumberForSegment(seg, index);

    url = replaceTokenForTemplate(url, 'Number', seg.replacementNumber);
    url = replaceTokenForTemplate(url, 'Time', seg.replacementTime);
    seg.media = url;
    seg.mediaRange = range;
    seg.availabilityIdx = index;

    return seg;
}

function getSegmentByIndex(index, representation) {
    if (!representation || !representation.segments) return null;

    var ln = representation.segments.length;
    var seg, i;

    if (index < ln) {
        seg = representation.segments[index];
        if (seg && seg.availabilityIdx === index) {
            return seg;
        }
    }

    for (i = 0; i < ln; i++) {
        seg = representation.segments[i];

        if (seg && seg.availabilityIdx === index) {
            return seg;
        }
    }

    return null;
}

function decideSegmentListRangeForTimeline(timelineConverter, isDynamic, requestedTime, index, givenAvailabilityUpperLimit) {
    var availabilityLowerLimit = 2;
    var availabilityUpperLimit = givenAvailabilityUpperLimit || 10;
    var firstIdx = 0;
    var lastIdx = Number.POSITIVE_INFINITY;

    var start, end, range;

    if (isDynamic && !timelineConverter.isTimeSyncCompleted()) {
        range = { start: firstIdx, end: lastIdx };
        return range;
    }

    if (!isDynamic && requestedTime || index < 0) return null;

    // segment list should not be out of the availability window range
    start = Math.max(index - availabilityLowerLimit, firstIdx);
    end = Math.min(index + availabilityUpperLimit, lastIdx);

    range = { start: start, end: end };

    return range;
}

function decideSegmentListRangeForTemplate(timelineConverter, isDynamic, representation, requestedTime, index, givenAvailabilityUpperLimit) {
    var duration = representation.segmentDuration;
    var minBufferTime = representation.adaptation.period.mpd.manifest.minBufferTime;
    var availabilityWindow = representation.segmentAvailabilityRange;
    var periodRelativeRange = {
        start: timelineConverter.calcPeriodRelativeTimeFromMpdRelativeTime(representation, availabilityWindow.start),
        end: timelineConverter.calcPeriodRelativeTimeFromMpdRelativeTime(representation, availabilityWindow.end)
    };
    var currentSegmentList = representation.segments;
    var availabilityLowerLimit = 2 * duration;
    var availabilityUpperLimit = givenAvailabilityUpperLimit || Math.max(2 * minBufferTime, 10 * duration);

    var originAvailabilityTime = NaN;
    var originSegment = null;

    var start, end, range;

    periodRelativeRange.start = Math.max(periodRelativeRange.start, 0);

    if (isDynamic && !timelineConverter.isTimeSyncCompleted()) {
        start = Math.floor(periodRelativeRange.start / duration);
        end = Math.floor(periodRelativeRange.end / duration);
        range = { start: start, end: end };
        return range;
    }

    // if segments exist we should try to find the latest buffered time, which is the presentation time of the
    // segment for the current index
    if (currentSegmentList && currentSegmentList.length > 0) {
        originSegment = getSegmentByIndex(index, representation);
        if (originSegment) {
            originAvailabilityTime = timelineConverter.calcPeriodRelativeTimeFromMpdRelativeTime(representation, originSegment.presentationStartTime);
        } else {
            originAvailabilityTime = index > 0 ? index * duration : timelineConverter.calcPeriodRelativeTimeFromMpdRelativeTime(representation, requestedTime);
        }
    } else {
        // If no segments exist, but index > 0, it means that we switch to the other representation, so
        // we should proceed from this time.
        // Otherwise we should start from the beginning for static mpds or from the end (live edge) for dynamic mpds
        originAvailabilityTime = index > 0 ? index * duration : isDynamic ? periodRelativeRange.end : periodRelativeRange.start;
    }

    // segment list should not be out of the availability window range
    start = Math.floor(Math.max(originAvailabilityTime - availabilityLowerLimit, periodRelativeRange.start) / duration);
    end = Math.floor(Math.min(start + availabilityUpperLimit / duration, periodRelativeRange.end / duration));

    range = { start: start, end: end };

    return range;
}
//# sourceMappingURL=SegmentsUtils.js.map


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _textTextController = __webpack_require__(189);

var _textTextController2 = _interopRequireDefault(_textTextController);

var _voError = __webpack_require__(111);

var _voError2 = _interopRequireDefault(_voError);

var _coreEventBus = __webpack_require__(27);

var _coreEventBus2 = _interopRequireDefault(_coreEventBus);

var _coreEventsEvents = __webpack_require__(22);

var _coreEventsEvents2 = _interopRequireDefault(_coreEventsEvents);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var QUOTA_EXCEEDED_ERROR_CODE = 22;

function SourceBufferController() {

    var context = this.context;
    var eventBus = (0, _coreEventBus2['default'])(context).getInstance();

    var instance = undefined,
        dashManifestModel = undefined;

    function createSourceBuffer(mediaSource, mediaInfo) {

        var codec = mediaInfo.codec;
        var buffer = null;

        try {
            // Safari claims to support anything starting 'application/mp4'.
            // it definitely doesn't understand 'application/mp4;codecs="stpp"'
            // - currently no browser does, so check for it and use our own
            // implementation. The same is true for codecs="wvtt".
            if (codec.match(/application\/mp4;\s*codecs="(stpp|wvtt).*"/i)) {
                throw new _voError2['default']('not really supported');
            }

            buffer = mediaSource.addSourceBuffer(codec);
        } catch (ex) {
            // Note that in the following, the quotes are open to allow for extra text after stpp and wvtt
            if (mediaInfo.isText || codec.indexOf('codecs="stpp') !== -1 || codec.indexOf('codecs="wvtt') !== -1) {
                var textController = (0, _textTextController2['default'])(context).getInstance();
                buffer = textController.getTextSourceBuffer();
            } else {
                throw ex;
            }
        }

        return buffer;
    }

    function removeSourceBuffer(mediaSource, buffer) {
        try {
            mediaSource.removeSourceBuffer(buffer);
        } catch (ex) {}
    }

    function getBufferRange(buffer, time, tolerance) {
        var ranges = null;
        var start = 0;
        var end = 0;
        var firstStart = null;
        var lastEnd = null;
        var gap = 0;

        var len, i;

        var toler = tolerance || 0.15;

        try {
            ranges = buffer.buffered;
        } catch (ex) {
            return null;
        }

        if (ranges !== null && ranges !== undefined) {
            for (i = 0, len = ranges.length; i < len; i++) {
                start = ranges.start(i);
                end = ranges.end(i);
                if (firstStart === null) {
                    gap = Math.abs(start - time);
                    if (time >= start && time < end) {
                        // start the range
                        firstStart = start;
                        lastEnd = end;
                    } else if (gap <= toler) {
                        // start the range even though the buffer does not contain time 0
                        firstStart = start;
                        lastEnd = end;
                    }
                } else {
                    gap = start - lastEnd;
                    if (gap <= toler) {
                        // the discontinuity is smaller than the tolerance, combine the ranges
                        lastEnd = end;
                    } else {
                        break;
                    }
                }
            }

            if (firstStart !== null) {
                return {
                    start: firstStart,
                    end: lastEnd
                };
            }
        }

        return null;
    }

    function getAllRanges(buffer) {
        var ranges = null;

        try {
            ranges = buffer.buffered;
            return ranges;
        } catch (ex) {
            return null;
        }
    }

    function getTotalBufferedTime(buffer) {
        var ranges = getAllRanges(buffer);
        var totalBufferedTime = 0;
        var ln, i;

        if (!ranges) return totalBufferedTime;

        for (i = 0, ln = ranges.length; i < ln; i++) {
            totalBufferedTime += ranges.end(i) - ranges.start(i);
        }

        return totalBufferedTime;
    }

    function getBufferLength(buffer, time, tolerance) {

        var range, length;

        range = getBufferRange(buffer, time, tolerance);

        if (range === null) {
            length = 0;
        } else {
            length = range.end - time;
        }

        return length;
    }

    function getRangeDifference(currentRanges, buffer) {
        if (!buffer) return null;

        //TODO we may need to look for a more elegant and robust method
        // The logic below checks that is the difference between currentRanges and actual SourceBuffer ranges

        var newRanges = getAllRanges(buffer);
        var newStart, newEnd, equalStart, equalEnd, currentRange, nextCurrentRange, nextNewRange, hasRange, diff;

        if (!newRanges) return null;

        for (var i = 0, ln = newRanges.length; i < ln; i++) {
            hasRange = currentRanges.length > i;
            currentRange = hasRange ? {
                start: currentRanges.start(i),
                end: currentRanges.end(i)
            } : null;
            newStart = newRanges.start(i);
            newEnd = newRanges.end(i);

            // if there is no range with the same index it means that a new range has been added. This range is
            // the difference we are looking for
            // Example
            // current ranges
            // 0|---range1---|4  8|--range2--|12
            // new ranges
            // 0|---range1---|4| 8|--range2--|12  16|--range3--|20

            if (!currentRange) {
                diff = {
                    start: newStart,
                    end: newEnd
                };
                return diff;
            }

            equalStart = currentRange.start === newStart;
            equalEnd = currentRange.end === newEnd;

            // if ranges are equal do nothing here and go the next ranges
            if (equalStart && equalEnd) continue;

            // start or/and end of the range has been changed
            if (equalStart) {
                diff = {
                    start: currentRange.end,
                    end: newEnd
                };
            } else if (equalEnd) {
                diff = {
                    start: newStart,
                    end: currentRange.start
                };
            } else {
                // new range has been added before the current one
                diff = {
                    start: newStart,
                    end: newEnd
                };
                return diff;
            }

            // if there is next current range but no next new range (it it is not equal the next current range) it means
            // that the ranges have been merged
            // Example 1
            // current ranges
            // 0|---range1---|4  8|--range2--|12  16|---range3---|
            // new ranges
            // 0|-----------range1-----------|12  16|---range3--|
            nextCurrentRange = currentRanges.length > i + 1 ? {
                start: currentRanges.start(i + 1),
                end: currentRanges.end(i + 1)
            } : null;
            nextNewRange = i + 1 < ln ? {
                start: newRanges.start(i + 1),
                end: newRanges.end(i + 1)
            } : null;

            if (nextCurrentRange && (!nextNewRange || nextNewRange.start !== nextCurrentRange.start || nextNewRange.end !== nextCurrentRange.end)) {
                diff.end = nextCurrentRange.start;
            }

            return diff;
        }

        return null;
    }

    function append(buffer, chunk) {
        var bytes = chunk.bytes;
        var appendMethod = 'append' in buffer ? 'append' : 'appendBuffer' in buffer ? 'appendBuffer' : null;
        // our user-defined sourcebuffer-like object has Object as its
        // prototype whereas built-in SourceBuffers will have something
        // more sensible. do not pass chunk to built-in append.
        var acceptsChunk = Object.prototype.toString.call(buffer).slice(8, -1) === 'Object';

        if (!appendMethod) return;

        waitForUpdateEnd(buffer, function () {
            try {
                if (acceptsChunk) {
                    // chunk.start is used in calculations by TextSourceBuffer
                    buffer[appendMethod](bytes, chunk);
                } else {
                    buffer[appendMethod](bytes);
                }
                // updating is in progress, we should wait for it to complete before signaling that this operation is done
                waitForUpdateEnd(buffer, function () {
                    eventBus.trigger(_coreEventsEvents2['default'].SOURCEBUFFER_APPEND_COMPLETED, {
                        buffer: buffer,
                        bytes: bytes
                    });
                });
            } catch (err) {
                eventBus.trigger(_coreEventsEvents2['default'].SOURCEBUFFER_APPEND_COMPLETED, {
                    buffer: buffer,
                    bytes: bytes,
                    error: new _voError2['default'](err.code, err.message, null)
                });
            }
        });
    }

    function remove(buffer, start, end, mediaSource) {

        // make sure that the given time range is correct. Otherwise we will get InvalidAccessError
        waitForUpdateEnd(buffer, function () {
            try {
                if (start >= 0 && end > start && mediaSource.readyState !== 'ended') {
                    buffer.remove(start, end);
                }
                // updating is in progress, we should wait for it to complete before signaling that this operation is done
                waitForUpdateEnd(buffer, function () {
                    eventBus.trigger(_coreEventsEvents2['default'].SOURCEBUFFER_REMOVE_COMPLETED, {
                        buffer: buffer,
                        from: start,
                        to: end
                    });
                });
            } catch (err) {
                eventBus.trigger(_coreEventsEvents2['default'].SOURCEBUFFER_REMOVE_COMPLETED, {
                    buffer: buffer,
                    from: start,
                    to: end,
                    error: new _voError2['default'](err.code, err.message, null)
                });
            }
        });
    }

    function abort(mediaSource, buffer) {
        try {
            if (mediaSource.readyState === 'open') {
                buffer.abort();
            } else if (buffer.setTextTrack && mediaSource.readyState === 'ended') {
                buffer.abort(); //The cues need to be removed from the TextSourceBuffer via a call to abort()
            }
        } catch (ex) {}
    }

    function setConfig(config) {
        if (!config) return;

        if (config.dashManifestModel) {
            dashManifestModel = config.dashManifestModel;
        }
    }

    function waitForUpdateEnd(buffer, callback) {
        var intervalId;
        var CHECK_INTERVAL = 50;

        var checkIsUpdateEnded = function checkIsUpdateEnded() {
            // if updating is still in progress do nothing and wait for the next check again.
            if (buffer.updating) return;
            // updating is completed, now we can stop checking and resolve the promise
            clearInterval(intervalId);
            callback();
        };

        var updateEndHandler = function updateEndHandler() {
            if (buffer.updating) return;

            buffer.removeEventListener('updateend', updateEndHandler, false);
            callback();
        };

        if (!buffer.updating) {
            callback();
            return;
        }

        // use updateend event if possible
        if (typeof buffer.addEventListener === 'function') {
            try {
                buffer.addEventListener('updateend', updateEndHandler, false);
            } catch (err) {
                // use setInterval to periodically check if updating has been completed
                intervalId = setInterval(checkIsUpdateEnded, CHECK_INTERVAL);
            }
        } else {
            // use setInterval to periodically check if updating has been completed
            intervalId = setInterval(checkIsUpdateEnded, CHECK_INTERVAL);
        }
    }

    instance = {
        append: append,
        remove: remove,
        abort: abort,
        createSourceBuffer: createSourceBuffer,
        removeSourceBuffer: removeSourceBuffer,
        getBufferRange: getBufferRange,
        getAllRanges: getAllRanges,
        getTotalBufferedTime: getTotalBufferedTime,
        getBufferLength: getBufferLength,
        getRangeDifference: getRangeDifference,
        setConfig: setConfig
    };

    return instance;
}

SourceBufferController.__dashjs_factory_name = 'SourceBufferController';
var factory = _coreFactoryMaker2['default'].getSingletonFactory(SourceBufferController);
factory.QUOTA_EXCEEDED_ERROR_CODE = QUOTA_EXCEEDED_ERROR_CODE;
exports['default'] = factory;
module.exports = exports['default'];
//# sourceMappingURL=SourceBufferController.js.map


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _coreEventsEventsBase = __webpack_require__(319);

var _coreEventsEventsBase2 = _interopRequireDefault(_coreEventsEventsBase);

var MetricsReportingEvents = (function (_EventsBase) {
    _inherits(MetricsReportingEvents, _EventsBase);

    function MetricsReportingEvents() {
        _classCallCheck(this, MetricsReportingEvents);

        _get(Object.getPrototypeOf(MetricsReportingEvents.prototype), 'constructor', this).call(this);

        this.METRICS_INITIALISATION_COMPLETE = 'internal_metricsReportingInitialized';
        this.BECAME_REPORTING_PLAYER = 'internal_becameReportingPlayer';
    }

    return MetricsReportingEvents;
})(_coreEventsEventsBase2['default']);

var metricsReportingEvents = new MetricsReportingEvents();
exports['default'] = metricsReportingEvents;
module.exports = exports['default'];
//# sourceMappingURL=MetricsReportingEvents.js.map


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreEventBus = __webpack_require__(27);

var _coreEventBus2 = _interopRequireDefault(_coreEventBus);

var _coreEventsEvents = __webpack_require__(22);

var _coreEventsEvents2 = _interopRequireDefault(_coreEventsEvents);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _voFragmentRequest = __webpack_require__(190);

var _voFragmentRequest2 = _interopRequireDefault(_voFragmentRequest);

var _coreDebug = __webpack_require__(30);

var _coreDebug2 = _interopRequireDefault(_coreDebug);

var FRAGMENT_MODEL_LOADING = 'loading';
var FRAGMENT_MODEL_EXECUTED = 'executed';
var FRAGMENT_MODEL_CANCELED = 'canceled';
var FRAGMENT_MODEL_FAILED = 'failed';

function FragmentModel(config) {

    var context = this.context;
    var log = (0, _coreDebug2['default'])(context).getInstance().log;
    var eventBus = (0, _coreEventBus2['default'])(context).getInstance();
    var metricsModel = config.metricsModel;

    var instance = undefined,
        scheduleController = undefined,
        executedRequests = undefined,
        loadingRequests = undefined,
        fragmentLoader = undefined;

    function setup() {
        scheduleController = null;
        fragmentLoader = null;
        executedRequests = [];
        loadingRequests = [];
        eventBus.on(_coreEventsEvents2['default'].LOADING_COMPLETED, onLoadingCompleted, instance);
    }

    function setLoader(value) {
        fragmentLoader = value;
    }

    function isFragmentLoaded(request) {
        var isEqualComplete = function isEqualComplete(req1, req2) {
            return req1.action === _voFragmentRequest2['default'].ACTION_COMPLETE && req1.action === req2.action;
        };

        var isEqualMedia = function isEqualMedia(req1, req2) {
            return !isNaN(req1.index) && req1.startTime === req2.startTime && req1.adaptationIndex === req2.adaptationIndex;
        };

        var isEqualInit = function isEqualInit(req1, req2) {
            return isNaN(req1.index) && isNaN(req2.index) && req1.quality === req2.quality;
        };

        var check = function check(requests) {
            var isLoaded = false;
            requests.some(function (req) {
                if (isEqualMedia(request, req) || isEqualInit(request, req) || isEqualComplete(request, req)) {
                    isLoaded = true;
                    return isLoaded;
                }
            });
            return isLoaded;
        };

        return check(executedRequests);
    }

    /**
     *
     * Gets an array of {@link FragmentRequest} objects
     *
     * @param {Object} filter The object with properties by which the method filters the requests to be returned.
     *  the only mandatory property is state, which must be a value from
     *  other properties should match the properties of {@link FragmentRequest}. E.g.:
     *  getRequests({state: FragmentModel.FRAGMENT_MODEL_EXECUTED, quality: 0}) - returns
     *  all the requests from executedRequests array where requests.quality = filter.quality
     *
     * @returns {Array}
     * @memberof FragmentModel#
     */
    function getRequests(filter) {

        var states = filter.state instanceof Array ? filter.state : [filter.state];

        var filteredRequests = [];
        states.forEach(function (state) {
            var requests = getRequestsForState(state);
            filteredRequests = filteredRequests.concat(filterRequests(requests, filter));
        });

        return filteredRequests;
    }

    function removeExecutedRequestsBeforeTime(time) {
        executedRequests = executedRequests.filter(function (req) {
            return isNaN(req.startTime) || req.startTime >= time;
        });
    }

    function abortRequests() {
        fragmentLoader.abort();
        loadingRequests = [];
    }

    function executeRequest(request) {

        switch (request.action) {
            case _voFragmentRequest2['default'].ACTION_COMPLETE:
                executedRequests.push(request);
                addSchedulingInfoMetrics(request, FRAGMENT_MODEL_EXECUTED);
                eventBus.trigger(_coreEventsEvents2['default'].STREAM_COMPLETED, { request: request, fragmentModel: this });
                break;
            case _voFragmentRequest2['default'].ACTION_DOWNLOAD:
                addSchedulingInfoMetrics(request, FRAGMENT_MODEL_LOADING);
                loadingRequests.push(request);
                loadCurrentFragment(request);
                break;
            default:
                log('Unknown request action.');
        }
    }

    function loadCurrentFragment(request) {
        eventBus.trigger(_coreEventsEvents2['default'].FRAGMENT_LOADING_STARTED, { sender: instance, request: request });
        fragmentLoader.load(request);
    }

    function getRequestForTime(arr, time, threshold) {
        // loop through the executed requests and pick the one for which the playback interval matches the given time
        var lastIdx = arr.length - 1;
        for (var i = lastIdx; i >= 0; i--) {
            var req = arr[i];
            var start = req.startTime;
            var end = start + req.duration;
            threshold = threshold !== undefined ? threshold : req.duration / 2;
            if (!isNaN(start) && !isNaN(end) && time + threshold >= start && time - threshold < end || isNaN(start) && isNaN(time)) {
                return req;
            }
        }
        return null;
    }

    function filterRequests(arr, filter) {
        // for time use a specific filtration function
        if (filter.hasOwnProperty('time')) {
            return [getRequestForTime(arr, filter.time, filter.threshold)];
        }

        return arr.filter(function (request) {
            for (var prop in filter) {
                if (prop === 'state') continue;
                if (filter.hasOwnProperty(prop) && request[prop] != filter[prop]) return false;
            }

            return true;
        });
    }

    function getRequestsForState(state) {

        var requests = undefined;
        switch (state) {
            case FRAGMENT_MODEL_LOADING:
                requests = loadingRequests;
                break;
            case FRAGMENT_MODEL_EXECUTED:
                requests = executedRequests;
                break;
            default:
                requests = [];
        }
        return requests;
    }

    function addSchedulingInfoMetrics(request, state) {

        metricsModel.addSchedulingInfo(request.mediaType, new Date(), request.type, request.startTime, request.availabilityStartTime, request.duration, request.quality, request.range, state);

        metricsModel.addRequestsQueue(request.mediaType, loadingRequests, executedRequests);
    }

    function onLoadingCompleted(e) {
        if (e.sender !== fragmentLoader) return;

        loadingRequests.splice(loadingRequests.indexOf(e.request), 1);

        if (e.response && !e.error) {
            executedRequests.push(e.request);
        }

        addSchedulingInfoMetrics(e.request, e.error ? FRAGMENT_MODEL_FAILED : FRAGMENT_MODEL_EXECUTED);

        eventBus.trigger(_coreEventsEvents2['default'].FRAGMENT_LOADING_COMPLETED, {
            request: e.request,
            response: e.response,
            error: e.error,
            sender: this
        });
    }

    function reset() {
        eventBus.off(_coreEventsEvents2['default'].LOADING_COMPLETED, onLoadingCompleted, this);

        if (fragmentLoader) {
            fragmentLoader.reset();
            fragmentLoader = null;
        }

        executedRequests = [];
        loadingRequests = [];
    }

    instance = {
        setLoader: setLoader,
        getRequests: getRequests,
        isFragmentLoaded: isFragmentLoaded,
        removeExecutedRequestsBeforeTime: removeExecutedRequestsBeforeTime,
        abortRequests: abortRequests,
        executeRequest: executeRequest,
        reset: reset
    };

    setup();
    return instance;
}

FragmentModel.__dashjs_factory_name = 'FragmentModel';
var factory = _coreFactoryMaker2['default'].getClassFactory(FragmentModel);
factory.FRAGMENT_MODEL_LOADING = FRAGMENT_MODEL_LOADING;
factory.FRAGMENT_MODEL_EXECUTED = FRAGMENT_MODEL_EXECUTED;
factory.FRAGMENT_MODEL_CANCELED = FRAGMENT_MODEL_CANCELED;
factory.FRAGMENT_MODEL_FAILED = FRAGMENT_MODEL_FAILED;
exports['default'] = factory;
module.exports = exports['default'];
//# sourceMappingURL=FragmentModel.js.map


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreEventBus = __webpack_require__(27);

var _coreEventBus2 = _interopRequireDefault(_coreEventBus);

var _coreEventsEvents = __webpack_require__(22);

var _coreEventsEvents2 = _interopRequireDefault(_coreEventsEvents);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

function ManifestModel() {

    var context = this.context;
    var eventBus = (0, _coreEventBus2['default'])(context).getInstance();

    var instance = undefined,
        manifest = undefined;

    function getValue() {
        return manifest;
    }

    function setValue(value) {
        manifest = value;
        if (value) {
            eventBus.trigger(_coreEventsEvents2['default'].MANIFEST_LOADED, { data: value });
        }
    }

    instance = {
        getValue: getValue,
        setValue: setValue
    };

    return instance;
}

ManifestModel.__dashjs_factory_name = 'ManifestModel';
exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(ManifestModel);
module.exports = exports['default'];
//# sourceMappingURL=ManifestModel.js.map


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _CommonEncryption = __webpack_require__(241);

var _CommonEncryption2 = _interopRequireDefault(_CommonEncryption);

var _drmKeySystemClearKey = __webpack_require__(1381);

var _drmKeySystemClearKey2 = _interopRequireDefault(_drmKeySystemClearKey);

var _drmKeySystemWidevine = __webpack_require__(1383);

var _drmKeySystemWidevine2 = _interopRequireDefault(_drmKeySystemWidevine);

var _drmKeySystemPlayReady = __webpack_require__(1382);

var _drmKeySystemPlayReady2 = _interopRequireDefault(_drmKeySystemPlayReady);

var _serversDRMToday = __webpack_require__(1388);

var _serversDRMToday2 = _interopRequireDefault(_serversDRMToday);

var _serversPlayReady = __webpack_require__(1389);

var _serversPlayReady2 = _interopRequireDefault(_serversPlayReady);

var _serversWidevine = __webpack_require__(1390);

var _serversWidevine2 = _interopRequireDefault(_serversWidevine);

var _serversClearKey = __webpack_require__(1387);

var _serversClearKey2 = _interopRequireDefault(_serversClearKey);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

/**
 * @module ProtectionKeyController
 * @description Media protection key system functionality that can be modified/overridden by applications
 */
function ProtectionKeyController() {

    var context = this.context;

    var instance = undefined,
        log = undefined,
        keySystems = undefined,
        clearkeyKeySystem = undefined;

    function setConfig(config) {
        if (!config) return;

        if (config.log) {
            log = config.log;
        }
    }

    function initialize() {
        keySystems = [];

        var keySystem;

        // PlayReady
        keySystem = (0, _drmKeySystemPlayReady2['default'])(context).getInstance();
        keySystems.push(keySystem);

        // Widevine
        keySystem = (0, _drmKeySystemWidevine2['default'])(context).getInstance();
        keySystems.push(keySystem);

        // ClearKey
        keySystem = (0, _drmKeySystemClearKey2['default'])(context).getInstance();
        keySystems.push(keySystem);
        clearkeyKeySystem = keySystem;
    }

    /**
     * Returns a prioritized list of key systems supported
     * by this player (not necessarily those supported by the
     * user agent)
     *
     * @returns {Array.<KeySystem>} a prioritized
     * list of key systems
     * @memberof module:ProtectionKeyController
     * @instance
     */
    function getKeySystems() {
        return keySystems;
    }

    /**
     * Returns the key system associated with the given key system string
     * name (i.e. 'org.w3.clearkey')
     *
     * @param {string} systemString the system string
     * @returns {KeySystem|null} the key system
     * or null if no supported key system is associated with the given key
     * system string
     * @memberof module:ProtectionKeyController
     * @instance
     */
    function getKeySystemBySystemString(systemString) {
        for (var i = 0; i < keySystems.length; i++) {
            if (keySystems[i].systemString === systemString) {
                return keySystems[i];
            }
        }
        return null;
    }

    /**
     * Determines whether the given key system is ClearKey.  This is
     * necessary because the EME spec defines ClearKey and its method
     * for providing keys to the key session; and this method has changed
     * between the various API versions.  Our EME-specific ProtectionModels
     * must know if the system is ClearKey so that it can format the keys
     * according to the particular spec version.
     *
     * @param {Object} keySystem the key
     * @returns {boolean} true if this is the ClearKey key system, false
     * otherwise
     * @memberof module:ProtectionKeyController
     * @instance
     */
    function isClearKey(keySystem) {
        return keySystem === clearkeyKeySystem;
    }

    /**
     * Check equality of initData array buffers.
     *
     * @param {ArrayBuffer} initData1 - first initData
     * @param {ArrayBuffer} initData2 - second initData
     * @returns {boolean} true if the initData arrays are equal in size and
     * contents, false otherwise
     * @memberof module:ProtectionKeyController
     * @instance
     */
    function initDataEquals(initData1, initData2) {
        if (initData1.byteLength === initData2.byteLength) {
            var data1 = new Uint8Array(initData1);
            var data2 = new Uint8Array(initData2);

            for (var j = 0; j < data1.length; j++) {
                if (data1[j] !== data2[j]) {
                    return false;
                }
            }
            return true;
        }
        return false;
    }

    /**
     * Returns a set of supported key systems and CENC initialization data
     * from the given array of ContentProtection elements.  Only
     * key systems that are supported by this player will be returned.
     * Key systems are returned in priority order (highest first).
     *
     * @param {Array.<Object>} cps - array of content protection elements parsed
     * from the manifest
     * @returns {Array.<Object>} array of objects indicating which supported key
     * systems were found.  Empty array is returned if no
     * supported key systems were found
     * @memberof module:ProtectionKeyController
     * @instance
     */
    function getSupportedKeySystemsFromContentProtection(cps) {
        var cp, ks, ksIdx, cpIdx;
        var supportedKS = [];

        if (cps) {
            for (ksIdx = 0; ksIdx < keySystems.length; ++ksIdx) {
                ks = keySystems[ksIdx];
                for (cpIdx = 0; cpIdx < cps.length; ++cpIdx) {
                    cp = cps[cpIdx];
                    if (cp.schemeIdUri.toLowerCase() === ks.schemeIdURI) {

                        // Look for DRM-specific ContentProtection
                        var initData = ks.getInitData(cp);
                        if (!!initData) {
                            supportedKS.push({
                                ks: keySystems[ksIdx],
                                initData: initData
                            });
                        }
                    }
                }
            }
        }
        return supportedKS;
    }

    /**
     * Returns key systems supported by this player for the given PSSH
     * initializationData. Only key systems supported by this player
     * that have protection data present will be returned.  Key systems are returned in priority order
     * (highest priority first)
     *
     * @param {ArrayBuffer} initData Concatenated PSSH data for all DRMs
     * supported by the content
     * @param {ProtectionData} protDataSet user specified protection data - license server url etc
     * supported by the content
     * @returns {Array.<Object>} array of objects indicating which supported key
     * systems were found.  Empty array is returned if no
     * supported key systems were found
     * @memberof module:ProtectionKeyController
     * @instance
     */
    function getSupportedKeySystems(initData, protDataSet) {
        var ksIdx;
        var supportedKS = [];
        var pssh = _CommonEncryption2['default'].parsePSSHList(initData);

        for (ksIdx = 0; ksIdx < keySystems.length; ++ksIdx) {
            var keySystemString = keySystems[ksIdx].systemString;
            var shouldNotFilterOutKeySystem = protDataSet ? keySystemString in protDataSet : true;

            if (keySystems[ksIdx].uuid in pssh && shouldNotFilterOutKeySystem) {
                supportedKS.push({
                    ks: keySystems[ksIdx],
                    initData: pssh[keySystems[ksIdx].uuid]
                });
            }
        }
        return supportedKS;
    }

    /**
     * Returns the license server implementation data that should be used for this request.
     *
     * @param {KeySystem} keySystem the key system
     * associated with this license request
     * @param {ProtectionData} protData protection data to use for the
     * request
     * @param {string} [messageType="license-request"] the message type associated with this
     * request.  Supported message types can be found
     * {@link https://w3c.github.io/encrypted-media/#idl-def-MediaKeyMessageType|here}.
     * @returns {LicenseServer|null} the license server
     * implementation that should be used for this request or null if the player should not
     * pass messages of the given type to a license server
     * @memberof module:ProtectionKeyController
     * @instance
     *
     */
    function getLicenseServer(keySystem, protData, messageType) {

        // Our default server implementations do not do anything with "license-release" or
        // "individualization-request" messages, so we just send a success event
        if (messageType === 'license-release' || messageType === 'individualization-request') {
            return null;
        }

        var licenseServerData = null;
        if (protData && protData.hasOwnProperty('drmtoday')) {
            licenseServerData = (0, _serversDRMToday2['default'])(context).getInstance();
        } else if (keySystem.systemString === 'com.widevine.alpha') {
            licenseServerData = (0, _serversWidevine2['default'])(context).getInstance();
        } else if (keySystem.systemString === 'com.microsoft.playready') {
            licenseServerData = (0, _serversPlayReady2['default'])(context).getInstance();
        } else if (keySystem.systemString === 'org.w3.clearkey') {
            licenseServerData = (0, _serversClearKey2['default'])(context).getInstance();
        }

        return licenseServerData;
    }

    /**
     * Allows application-specific retrieval of ClearKey keys.
     *
     * @param {ProtectionData} protData protection data to use for the
     * request
     * @param {ArrayBuffer} message the key message from the CDM
     * @return {ClearKeyKeySet|null} the clear keys associated with
     * the request or null if no keys can be returned by this function
     * @memberof module:ProtectionKeyController
     * @instance
     */
    function processClearKeyLicenseRequest(protData, message) {
        try {
            return clearkeyKeySystem.getClearKeysFromProtectionData(protData, message);
        } catch (error) {
            log('Failed to retrieve clearkeys from ProtectionData');
            return null;
        }
    }

    instance = {
        initialize: initialize,
        isClearKey: isClearKey,
        initDataEquals: initDataEquals,
        getKeySystems: getKeySystems,
        getKeySystemBySystemString: getKeySystemBySystemString,
        getSupportedKeySystemsFromContentProtection: getSupportedKeySystemsFromContentProtection,
        getSupportedKeySystems: getSupportedKeySystems,
        getLicenseServer: getLicenseServer,
        processClearKeyLicenseRequest: processClearKeyLicenseRequest,
        setConfig: setConfig
    };

    return instance;
}

ProtectionKeyController.__dashjs_factory_name = 'ProtectionKeyController';
exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(ProtectionKeyController);
module.exports = exports['default'];
//# sourceMappingURL=ProtectionKeyController.js.map


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

function RequestModifier() {

    var instance = undefined;

    function modifyRequestURL(url) {
        return url;
    }

    function modifyRequestHeader(request) {
        return request;
    }

    instance = {
        modifyRequestURL: modifyRequestURL,
        modifyRequestHeader: modifyRequestHeader
    };

    return instance;
}

RequestModifier.__dashjs_factory_name = 'RequestModifier';
exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(RequestModifier);
module.exports = exports['default'];
//# sourceMappingURL=RequestModifier.js.map


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;

var _LocationUtils = __webpack_require__(146);

var _DOMUtils = __webpack_require__(228);

var _DOMStateStorage = __webpack_require__(481);

var _PathUtils = __webpack_require__(104);

var _ExecutionEnvironment = __webpack_require__(329);

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();

var _createLocation = function _createLocation(historyState) {
  var key = historyState && historyState.key;

  return (0, _LocationUtils.createLocation)({
    pathname: window.location.pathname,
    search: window.location.search,
    hash: window.location.hash,
    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
  }, undefined, key);
};

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
  var historyState = void 0;
  try {
    historyState = window.history.state || {};
  } catch (error) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    historyState = {};
  }

  return _createLocation(historyState);
};

var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

var startListener = exports.startListener = function startListener(listener) {
  var handlePopState = function handlePopState(event) {
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) // Ignore extraneous popstate events in WebKit
      return;
    listener(_createLocation(event.state));
  };

  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
    return listener(getCurrentLocation());
  };

  if (needsHashchangeListener) {
    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
  }

  return function () {
    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

    if (needsHashchangeListener) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
    }
  };
};

var updateLocation = function updateLocation(location, updateState) {
  var state = location.state,
      key = location.key;


  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);

  updateState({ key: key }, (0, _PathUtils.createPath)(location));
};

var pushLocation = exports.pushLocation = function pushLocation(location) {
  return updateLocation(location, function (state, path) {
    return window.history.pushState(state, null, path);
  });
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
  return updateLocation(location, function (state, path) {
    return window.history.replaceState(state, null, path);
  });
};

var go = exports.go = function go(n) {
  if (n) window.history.go(n);
};

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _AsyncUtils = __webpack_require__(972);

var _PathUtils = __webpack_require__(104);

var _runTransitionHook = __webpack_require__(331);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _Actions = __webpack_require__(227);

var _LocationUtils = __webpack_require__(146);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createHistory = function createHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getCurrentLocation = options.getCurrentLocation,
      getUserConfirmation = options.getUserConfirmation,
      pushLocation = options.pushLocation,
      replaceLocation = options.replaceLocation,
      go = options.go,
      keyLength = options.keyLength;


  var currentLocation = void 0;
  var pendingLocation = void 0;
  var beforeListeners = [];
  var listeners = [];
  var allKeys = [];

  var getCurrentIndex = function getCurrentIndex() {
    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);

    if (currentLocation) return allKeys.indexOf(currentLocation.key);

    return -1;
  };

  var updateLocation = function updateLocation(nextLocation) {
    var currentIndex = getCurrentIndex();

    currentLocation = nextLocation;

    if (currentLocation.action === _Actions.PUSH) {
      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
    } else if (currentLocation.action === _Actions.REPLACE) {
      allKeys[currentIndex] = currentLocation.key;
    }

    listeners.forEach(function (listener) {
      return listener(currentLocation);
    });
  };

  var listenBefore = function listenBefore(listener) {
    beforeListeners.push(listener);

    return function () {
      return beforeListeners = beforeListeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var listen = function listen(listener) {
    listeners.push(listener);

    return function () {
      return listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
        return result != null ? done(result) : next();
      });
    }, function (message) {
      if (getUserConfirmation && typeof message === 'string') {
        getUserConfirmation(message, function (ok) {
          return callback(ok !== false);
        });
      } else {
        callback(message !== false);
      }
    });
  };

  var transitionTo = function transitionTo(nextLocation) {
    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do

    pendingLocation = nextLocation;

    confirmTransitionTo(nextLocation, function (ok) {
      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation

      pendingLocation = null;

      if (ok) {
        // Treat PUSH to same path like REPLACE to be consistent with browsers
        if (nextLocation.action === _Actions.PUSH) {
          var prevPath = (0, _PathUtils.createPath)(currentLocation);
          var nextPath = (0, _PathUtils.createPath)(nextLocation);

          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
        }

        if (nextLocation.action === _Actions.POP) {
          updateLocation(nextLocation);
        } else if (nextLocation.action === _Actions.PUSH) {
          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
        } else if (nextLocation.action === _Actions.REPLACE) {
          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
        }
      } else if (currentLocation && nextLocation.action === _Actions.POP) {
        var prevIndex = allKeys.indexOf(currentLocation.key);
        var nextIndex = allKeys.indexOf(nextLocation.key);

        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
      }
    });
  };

  var push = function push(input) {
    return transitionTo(createLocation(input, _Actions.PUSH));
  };

  var replace = function replace(input) {
    return transitionTo(createLocation(input, _Actions.REPLACE));
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength || 6);
  };

  var createHref = function createHref(location) {
    return (0, _PathUtils.createPath)(location);
  };

  var createLocation = function createLocation(location, action) {
    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createKey();
    return (0, _LocationUtils.createLocation)(location, action, key);
  };

  return {
    getCurrentLocation: getCurrentLocation,
    listenBefore: listenBefore,
    listen: listen,
    transitionTo: transitionTo,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    createKey: createKey,
    createPath: _PathUtils.createPath,
    createHref: createHref,
    createLocation: createLocation
  };
};

exports.default = createHistory;

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(109);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var runTransitionHook = function runTransitionHook(hook, location, callback) {
  var result = hook(location, callback);

  if (hook.length < 2) {
    // Assume the hook runs synchronously and automatically
    // call the callback with the return value.
    callback(result);
  } else {
     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
  }
};

exports.default = runTransitionHook;

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Buffer Helper utils, providing methods dealing buffer length retrieval
*/

var BufferHelper = {
  isBuffered: function isBuffered(media, position) {
    if (media) {
      var buffered = media.buffered;
      for (var i = 0; i < buffered.length; i++) {
        if (position >= buffered.start(i) && position <= buffered.end(i)) {
          return true;
        }
      }
    }
    return false;
  },

  bufferInfo: function bufferInfo(media, pos, maxHoleDuration) {
    if (media) {
      var vbuffered = media.buffered,
          buffered = [],
          i;
      for (i = 0; i < vbuffered.length; i++) {
        buffered.push({ start: vbuffered.start(i), end: vbuffered.end(i) });
      }
      return this.bufferedInfo(buffered, pos, maxHoleDuration);
    } else {
      return { len: 0, start: pos, end: pos, nextStart: undefined };
    }
  },

  bufferedInfo: function bufferedInfo(buffered, pos, maxHoleDuration) {
    var buffered2 = [],

    // bufferStart and bufferEnd are buffer boundaries around current video position
    bufferLen,
        bufferStart,
        bufferEnd,
        bufferStartNext,
        i;
    // sort on buffer.start/smaller end (IE does not always return sorted buffered range)
    buffered.sort(function (a, b) {
      var diff = a.start - b.start;
      if (diff) {
        return diff;
      } else {
        return b.end - a.end;
      }
    });
    // there might be some small holes between buffer time range
    // consider that holes smaller than maxHoleDuration are irrelevant and build another
    // buffer time range representations that discards those holes
    for (i = 0; i < buffered.length; i++) {
      var buf2len = buffered2.length;
      if (buf2len) {
        var buf2end = buffered2[buf2len - 1].end;
        // if small hole (value between 0 or maxHoleDuration ) or overlapping (negative)
        if (buffered[i].start - buf2end < maxHoleDuration) {
          // merge overlapping time ranges
          // update lastRange.end only if smaller than item.end
          // e.g.  [ 1, 15] with  [ 2,8] => [ 1,15] (no need to modify lastRange.end)
          // whereas [ 1, 8] with  [ 2,15] => [ 1,15] ( lastRange should switch from [1,8] to [1,15])
          if (buffered[i].end > buf2end) {
            buffered2[buf2len - 1].end = buffered[i].end;
          }
        } else {
          // big hole
          buffered2.push(buffered[i]);
        }
      } else {
        // first value
        buffered2.push(buffered[i]);
      }
    }
    for (i = 0, bufferLen = 0, bufferStart = bufferEnd = pos; i < buffered2.length; i++) {
      var start = buffered2[i].start,
          end = buffered2[i].end;
      //logger.log('buf start/end:' + buffered.start(i) + '/' + buffered.end(i));
      if (pos + maxHoleDuration >= start && pos < end) {
        // play position is inside this buffer TimeRange, retrieve end of buffer position and buffer length
        bufferStart = start;
        bufferEnd = end;
        bufferLen = bufferEnd - pos;
      } else if (pos + maxHoleDuration < start) {
        bufferStartNext = start;
        break;
      }
    }
    return { len: bufferLen, start: bufferStart, end: bufferEnd, nextStart: bufferStartNext };
  }
};

module.exports = BufferHelper;

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(1001);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(129),
    root = __webpack_require__(81);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(1071),
    mapCacheDelete = __webpack_require__(1072),
    mapCacheGet = __webpack_require__(1073),
    mapCacheHas = __webpack_require__(1074),
    mapCacheSet = __webpack_require__(1075);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(229),
    stackClear = __webpack_require__(1085),
    stackDelete = __webpack_require__(1086),
    stackGet = __webpack_require__(1087),
    stackHas = __webpack_require__(1088),
    stackSet = __webpack_require__(1089);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(497);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(1013),
    createBaseEach = __webpack_require__(1043);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(1017),
    isObjectLike = __webpack_require__(92);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(40),
    isSymbol = __webpack_require__(178);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 341 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _isObject = __webpack_require__(41);

var _isObject2 = _interopRequireDefault(_isObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UnionSchema = function () {
  function UnionSchema(itemSchema, options) {
    _classCallCheck(this, UnionSchema);

    if (!(0, _isObject2.default)(itemSchema)) {
      throw new Error('UnionSchema requires item schema to be an object.');
    }

    if (!options || !options.schemaAttribute) {
      throw new Error('UnionSchema requires schemaAttribute option.');
    }

    this._itemSchema = itemSchema;

    var schemaAttribute = options.schemaAttribute;
    this._getSchema = typeof schemaAttribute === 'function' ? schemaAttribute : function (x) {
      return x[schemaAttribute];
    };
  }

  _createClass(UnionSchema, [{
    key: 'getItemSchema',
    value: function getItemSchema() {
      return this._itemSchema;
    }
  }, {
    key: 'getSchemaKey',
    value: function getSchemaKey(item) {
      return this._getSchema(item);
    }
  }]);

  return UnionSchema;
}();

exports.default = UnionSchema;

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = loopAsync;
/* harmony export (immutable) */ __webpack_exports__["a"] = mapAsync;
function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var sync = false,
      hasNext = false,
      doneArgs = void 0;

  function done() {
    isDone = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      doneArgs = [].concat(Array.prototype.slice.call(arguments));
      return;
    }

    callback.apply(this, arguments);
  }

  function next() {
    if (isDone) {
      return;
    }

    hasNext = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      return;
    }

    sync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work.call(this, currentTurn++, next, done);
    }

    sync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(this, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  }

  next();
}

function mapAsync(array, work, callback) {
  var length = array.length;
  var values = [];

  if (length === 0) return callback(null, values);

  var isDone = false,
      doneCount = 0;

  function done(index, error, value) {
    if (isDone) return;

    if (error) {
      isDone = true;
      callback(error);
    } else {
      values[index] = value;

      isDone = ++doneCount === length;

      if (isDone) callback(null, values);
    }
  }

  array.forEach(function (item, index) {
    work(item, index, function (error, value) {
      done(index, error, value);
    });
  });
}

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ContextProvider;
/* harmony export (immutable) */ __webpack_exports__["b"] = ContextSubscriber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


// Works around issues with context updates failing to propagate.
// Caveat: the context value is expected to never change its identity.
// https://github.com/facebook/react/issues/2517
// https://github.com/reactjs/react-router/issues/470

var contextProviderShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  eventIndex: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired
});

function makeContextName(name) {
  return '@@contextSubscriber/' + name;
}

function ContextProvider(name) {
  var _childContextTypes, _ref2;

  var contextName = makeContextName(name);
  var listenersKey = contextName + '/listeners';
  var eventIndexKey = contextName + '/eventIndex';
  var subscribeKey = contextName + '/subscribe';

  return _ref2 = {
    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),

    getChildContext: function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextName] = {
        eventIndex: this[eventIndexKey],
        subscribe: this[subscribeKey]
      }, _ref;
    },
    componentWillMount: function componentWillMount() {
      this[listenersKey] = [];
      this[eventIndexKey] = 0;
    },
    componentWillReceiveProps: function componentWillReceiveProps() {
      this[eventIndexKey]++;
    },
    componentDidUpdate: function componentDidUpdate() {
      var _this = this;

      this[listenersKey].forEach(function (listener) {
        return listener(_this[eventIndexKey]);
      });
    }
  }, _ref2[subscribeKey] = function (listener) {
    var _this2 = this;

    // No need to immediately call listener here.
    this[listenersKey].push(listener);

    return function () {
      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
        return item !== listener;
      });
    };
  }, _ref2;
}

function ContextSubscriber(name) {
  var _contextTypes, _ref4;

  var contextName = makeContextName(name);
  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
  var handleContextUpdateKey = contextName + '/handleContextUpdate';
  var unsubscribeKey = contextName + '/unsubscribe';

  return _ref4 = {
    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),

    getInitialState: function getInitialState() {
      var _ref3;

      if (!this.context[contextName]) {
        return {};
      }

      return _ref3 = {}, _ref3[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref3;
    },
    componentDidMount: function componentDidMount() {
      if (!this.context[contextName]) {
        return;
      }

      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
    },
    componentWillReceiveProps: function componentWillReceiveProps() {
      var _setState;

      if (!this.context[contextName]) {
        return;
      }

      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
    },
    componentWillUnmount: function componentWillUnmount() {
      if (!this[unsubscribeKey]) {
        return;
      }

      this[unsubscribeKey]();
      this[unsubscribeKey] = null;
    }
  }, _ref4[handleContextUpdateKey] = function (eventIndex) {
    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
      var _setState2;

      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
    }
  }, _ref4;
}

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return routerShape; });
/* unused harmony export locationShape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var routerShape = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  push: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  replace: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  go: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goBack: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goForward: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  setRouteLeaveHook: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  isActive: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired
});

var locationShape = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  pathname: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  search: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  state: __WEBPACK_IMPORTED_MODULE_0_prop_types__["object"],
  action: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  key: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]
});

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getRouteParams__ = __webpack_require__(1152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContextUtils__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RouteUtils__ = __webpack_require__(108);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };










/**
 * A <RouterContext> renders the component tree for a given router state
 * and sets the history object and the current location in context.
 */
var RouterContext = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'RouterContext',

  mixins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__ContextUtils__["a" /* ContextProvider */])('router')],

  propTypes: {
    router: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired,
    location: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired,
    routes: __WEBPACK_IMPORTED_MODULE_3_prop_types__["array"].isRequired,
    params: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired,
    components: __WEBPACK_IMPORTED_MODULE_3_prop_types__["array"].isRequired,
    createElement: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"].isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      createElement: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement
    };
  },


  childContextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired
  },

  getChildContext: function getChildContext() {
    return {
      router: this.props.router
    };
  },
  createElement: function createElement(component, props) {
    return component == null ? null : this.props.createElement(component, props);
  },
  render: function render() {
    var _this = this;

    var _props = this.props,
        location = _props.location,
        routes = _props.routes,
        params = _props.params,
        components = _props.components,
        router = _props.router;

    var element = null;

    if (components) {
      element = components.reduceRight(function (element, components, index) {
        if (components == null) return element; // Don't create new children; use the grandchildren.

        var route = routes[index];
        var routeParams = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__getRouteParams__["a" /* default */])(route, params);
        var props = {
          location: location,
          params: params,
          route: route,
          router: router,
          routeParams: routeParams,
          routes: routes
        };

        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__RouteUtils__["a" /* isReactChildren */])(element)) {
          props.children = element;
        } else if (element) {
          for (var prop in element) {
            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
          }
        }

        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
          var elements = {};

          for (var key in components) {
            if (Object.prototype.hasOwnProperty.call(components, key)) {
              // Pass through the key as a prop to createElement to allow
              // custom createElement functions to know which named component
              // they're rendering, for e.g. matching up to fetched data.
              elements[key] = _this.createElement(components[key], _extends({
                key: key }, props));
            }
          }

          return elements;
        }

        return _this.createElement(components, props);
      }, element);
    }

    !(element === null || element === false || __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(element)) ?  false ? invariant(false, 'The root route must render a single element') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

    return element;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (RouterContext);

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = showTooltip;
/* harmony export (immutable) */ __webpack_exports__["a"] = hideTooltip;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TooltipPopout; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_utils_pubsub__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_utils_popout_calculate_position__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_constants_events__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_constants_popout__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_shared_components_popout_popout__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__tooltip_styl__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__tooltip_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__tooltip_styl__);








var _dec, _class, _desc, _value, _class2;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}















var HIDE_TIMEOUT = 200;
var hideTimeoutId = void 0;

function showTooltip(config) {
  __WEBPACK_IMPORTED_MODULE_10_shared_utils_pubsub__["a" /* default */].publish(__WEBPACK_IMPORTED_MODULE_12_shared_constants_events__["a" /* default */].TOOLTIP.SHOW, config);
}

function hideTooltip() {
  __WEBPACK_IMPORTED_MODULE_10_shared_utils_pubsub__["a" /* default */].publish(__WEBPACK_IMPORTED_MODULE_12_shared_constants_events__["a" /* default */].TOOLTIP.HIDE);
}

var TooltipPopout = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_15__tooltip_styl___default.a), _dec(_class = (_class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(TooltipPopout, _React$Component);

  function TooltipPopout() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, TooltipPopout);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = TooltipPopout.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(TooltipPopout)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      popoutComponent: __WEBPACK_IMPORTED_MODULE_14_shared_components_popout_popout__["a" /* default */],
      visible: false
    }, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(TooltipPopout, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.showTooltipUnsubscribe = __WEBPACK_IMPORTED_MODULE_10_shared_utils_pubsub__["a" /* default */].subscribe(__WEBPACK_IMPORTED_MODULE_12_shared_constants_events__["a" /* default */].TOOLTIP.SHOW, this.showTooltip);
      this.hideTooltipUnsubscribe = __WEBPACK_IMPORTED_MODULE_10_shared_utils_pubsub__["a" /* default */].subscribe(__WEBPACK_IMPORTED_MODULE_12_shared_constants_events__["a" /* default */].TOOLTIP.HIDE, this.hideTooltip);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _state = this.state,
          visible = _state.visible,
          tooltipId = _state.tooltipId;


      if (visible && !_.isEqual(this.state, prevState)) {
        // update position if popout is visible
        this.updatePosition();
      }

      if (visible !== prevState.visible) {
        var eventId = visible ? __WEBPACK_IMPORTED_MODULE_12_shared_constants_events__["a" /* default */].TOOLTIP.DID_SHOW : __WEBPACK_IMPORTED_MODULE_12_shared_constants_events__["a" /* default */].TOOLTIP.DID_HIDE;

        __WEBPACK_IMPORTED_MODULE_10_shared_utils_pubsub__["a" /* default */].publish(eventId, tooltipId);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.showTooltipUnsubscribe();
      this.hideTooltipUnsubscribe();
    }
  }, {
    key: 'showTooltip',
    value: function showTooltip(config) {
      this.preventHide();

      this.setState(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
        visible: true,

        preventHideOnHover: false,
        popoutComponent: __WEBPACK_IMPORTED_MODULE_14_shared_components_popout_popout__["a" /* default */],
        className: '',
        innerClassName: '',
        triangleClassName: '',
        content: null,
        popoutSide: __WEBPACK_IMPORTED_MODULE_13_shared_constants_popout__["a" /* sides */].RIGHT,
        popoutPosition: __WEBPACK_IMPORTED_MODULE_13_shared_constants_popout__["c" /* popoutPositions */].CENTER,
        trianglePosition: __WEBPACK_IMPORTED_MODULE_13_shared_constants_popout__["b" /* trianglePositions */].CENTER,
        referenceElement: null

      }, config));
    }
  }, {
    key: 'hideTooltip',
    value: function hideTooltip() {
      var _this2 = this;

      var timeout = this.state.preventHideOnHover ? HIDE_TIMEOUT : 0;

      hideTimeoutId = setTimeout(function () {
        _this2.setState({
          visible: false
        });
      }, timeout);
    }
  }, {
    key: 'preventHide',
    value: function preventHide() {
      clearTimeout(hideTimeoutId);
    }
  }, {
    key: 'handleMouseEnter',
    value: function handleMouseEnter() {
      if (this.state.preventHideOnHover) {
        this.preventHide();
      }
    }
  }, {
    key: 'handleMouseLeave',
    value: function handleMouseLeave() {
      this.hideTooltip();
    }
  }, {
    key: 'calculatePosition',
    value: function calculatePosition() {
      var _state2 = this.state,
          referenceElement = _state2.referenceElement,
          popoutSide = _state2.popoutSide,
          popoutPosition = _state2.popoutPosition,
          trianglePosition = _state2.trianglePosition;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_shared_utils_popout_calculate_position__["a" /* byPopoutSide */])(referenceElement, this.popout, { popoutSide: popoutSide, popoutPosition: popoutPosition, trianglePosition: trianglePosition });
    }
  }, {
    key: 'updatePosition',
    value: function updatePosition() {
      var _calculatePosition = this.calculatePosition(),
          top = _calculatePosition.top,
          left = _calculatePosition.left,
          offsetX = _calculatePosition.offsetX;

      this.popout.style.top = top + 'px';
      this.popout.style.left = left + 'px';

      var transformStyle = 'translateX(' + offsetX + 'px) rotate(45deg)';
      var before = this.popout.firstElementChild;
      var after = this.popout.lastElementChild;

      before.style.transform = transformStyle;
      after.style.transform = transformStyle;
    }
  }, {
    key: 'getPopoutRef',
    value: function getPopoutRef(node) {
      this.popout = node;
    }
  }, {
    key: 'render',
    value: function render() {
      var _state3 = this.state,
          visible = _state3.visible,
          content = _state3.content,
          left = _state3.left,
          top = _state3.top,
          className = _state3.className,
          innerClassName = _state3.innerClassName,
          triangleClassName = _state3.triangleClassName,
          popoutSide = _state3.popoutSide,
          popoutPosition = _state3.popoutPosition,
          trianglePosition = _state3.trianglePosition,
          onClickOutside = _state3.onClickOutside;


      var styleNames = __WEBPACK_IMPORTED_MODULE_8_classnames___default()('popout', {
        positioned: visible
      });
      var innerClassNames = __WEBPACK_IMPORTED_MODULE_8_classnames___default()(__WEBPACK_IMPORTED_MODULE_15__tooltip_styl___default.a['popout-inner'], innerClassName);

      return React.createElement(
        this.Popout,
        { getRef: this.getPopoutRef,
          onClickOutside: onClickOutside,
          popoutSide: popoutSide,
          popoutPosition: popoutPosition,
          trianglePosition: trianglePosition,
          styleName: styleNames,
          className: className,
          innerClassName: innerClassNames,
          triangleClassName: triangleClassName,
          style: { left: left, top: top },
          onMouseEnter: this.handleMouseEnter,
          onMouseLeave: this.handleMouseLeave },
        content
      );
    }
  }, {
    key: 'Popout',
    get: function get() {
      return this.state.popoutComponent;
    }
  }]);

  return TooltipPopout;
}(React.Component), (_applyDecoratedDescriptor(_class2.prototype, 'showTooltip', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'showTooltip'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'hideTooltip', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'hideTooltip'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleMouseEnter', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handleMouseEnter'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleMouseLeave', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handleMouseLeave'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'getPopoutRef', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'getPopoutRef'), _class2.prototype)), _class2)) || _class);


/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  IN_QUEUE: 'IN-QUEUE',
  PENDING: 'PENDING',
  INPROGRESS: 'INPROGRESS',
  PREVIEW_READY: 'PREVIEW_READY',
  READY: 'READY',
  FAILED: 'FAILED',
  NONE: 'NONE'
});

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_selectors_app_settings__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_components_button_button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__button_styl__ = __webpack_require__(1661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__button_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__button_styl__);







var _dec, _dec2, _class, _class2, _temp;












var Button = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_redux__["a" /* connect */])(function (state) {
  return {
    isRounded: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_shared_selectors_app_settings__["b" /* areElementsRounded */])(state)
  };
}), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_11__button_styl___default.a), _dec(_class = _dec2(_class = (_temp = _class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Button, _React$Component);

  function Button() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Button);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Button.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Button)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Button, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isRounded = _props.isRounded,
          disableRoundBorders = _props.disableRoundBorders,
          disableTheme = _props.disableTheme;

      var props = _.omit(this.props, 'isRounded', 'styles', 'dispatch', 'disableRoundBorders', 'disableTheme');

      var styleNames = __WEBPACK_IMPORTED_MODULE_6_classnames___default()('button', {
        'disable-theme': disableTheme,
        rounded: !disableRoundBorders && isRounded
      });

      return React.createElement(__WEBPACK_IMPORTED_MODULE_10_shared_components_button_button__["f" /* GenericButton */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        styleName: styleNames }));
    }
  }]);

  return Button;
}(React.Component), _class2.propTypes = {
  isRounded: React.PropTypes.bool,
  disableRoundBorders: React.PropTypes.bool,
  disableTheme: React.PropTypes.bool
}, _class2.defaultProps = {
  disableRoundBorders: false,
  disableTheme: false
}, _temp)) || _class) || _class);


/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return APP_SETTINGS_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return updateAppSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchAppSettings; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_actions__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_utils_wix_sdk__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_utils_comp_id__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_utils_update_css__ = __webpack_require__(1256);









var APP_SETTINGS_UPDATE = 'CLIENT.APP_SETTINGS.SET';

var updateAppSettings = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_redux_actions__["createAction"])(APP_SETTINGS_UPDATE);

var fetchAppSettings = function fetchAppSettings() {
  return function (dispatch) {
    var compId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_shared_utils_comp_id__["a" /* getCompId */])();

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_4_shared_utils_wix_sdk__["a" /* default */].Styles.getStyleParams(), __WEBPACK_IMPORTED_MODULE_4_shared_utils_wix_sdk__["a" /* default */].Settings.getSiteInfo()]).then(function (_ref) {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
          styles = _ref2[0],
          url = _ref2[1].url;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_shared_utils_update_css__["a" /* updateCSS */])(styles);

      dispatch(updateAppSettings(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, styles, {
        compId: compId,
        siteUrl: url,
        instance: __WEBPACK_IMPORTED_MODULE_4_shared_utils_wix_sdk__["a" /* default */].Utils.getInstance(),
        editMode: __WEBPACK_IMPORTED_MODULE_4_shared_utils_wix_sdk__["a" /* default */].Utils.getViewMode()
      })));

      return styles;
    });
  };
};

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ __webpack_exports__["b"] = initNewRelic;
/* harmony export (immutable) */ __webpack_exports__["a"] = getNewRelic;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_utils_wix_sdk__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__new_relic__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_utils_attempt__ = __webpack_require__(163);




var newRelic = void 0;
function initNewRelic(customAttributes) {
  newRelic = new __WEBPACK_IMPORTED_MODULE_1__new_relic__["a" /* default */](global.newrelic, location.host);
  newRelic.setCustomAttribute('viewMode', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_utils_attempt__["a" /* attempt */])(function () {
    return __WEBPACK_IMPORTED_MODULE_0_shared_utils_wix_sdk__["a" /* default */].Utils.getViewMode();
  }));

  _.forEach(customAttributes, function (value, name) {
    return newRelic.setCustomAttribute(name, value);
  });

  global.addEventListener('error', function (event) {
    newRelic.logError(event.error);
  });

  var previousOnunhandledrejection = global.onunhandledrejection;

  global.onunhandledrejection = function (event) {
    newRelic.logError(event.reason);
    console.error('Unhandled promise rejection', event.reason); // eslint-disable-line no-console
    if (previousOnunhandledrejection) {
      previousOnunhandledrejection(event);
    }
  };
}

function getNewRelic() {
  if (!newRelic) {
    throw new Error('new relic was not inited');
  }
  return newRelic;
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(19)))

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Spinner; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loading_spinner_styl__ = __webpack_require__(1486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__loading_spinner_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__loading_spinner_styl__);






var _dec, _class, _class2, _temp;





var Spinner = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_6__loading_spinner_styl___default.a), _dec(_class = (_temp = _class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Spinner, _React$Component);

  function Spinner() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Spinner);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Spinner.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Spinner)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Spinner, [{
    key: 'render',
    value: function render() {
      var className = this.props.className;


      return React.createElement('div', { className: className,
        styleName: 'circle' });
    }
  }]);

  return Spinner;
}(React.Component), _class2.propTypes = {
  className: React.PropTypes.string
}, _temp)) || _class);


/***/ }),
/* 355 */,
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = increment;
/* harmony export (immutable) */ __webpack_exports__["b"] = decrement;
function increment() {
  var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  return n + 1;
}

function decrement() {
  var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  return n - 1;
}

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = invertSide;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_constants_popout__ = __webpack_require__(61);



function invertSide(side) {
  var _sides$TOP$sides$LEFT;

  return (_sides$TOP$sides$LEFT = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_sides$TOP$sides$LEFT, __WEBPACK_IMPORTED_MODULE_1_shared_constants_popout__["a" /* sides */].TOP, __WEBPACK_IMPORTED_MODULE_1_shared_constants_popout__["a" /* sides */].BOTTOM), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_sides$TOP$sides$LEFT, __WEBPACK_IMPORTED_MODULE_1_shared_constants_popout__["a" /* sides */].LEFT, __WEBPACK_IMPORTED_MODULE_1_shared_constants_popout__["a" /* sides */].RIGHT), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_sides$TOP$sides$LEFT, __WEBPACK_IMPORTED_MODULE_1_shared_constants_popout__["a" /* sides */].RIGHT, __WEBPACK_IMPORTED_MODULE_1_shared_constants_popout__["a" /* sides */].LEFT), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_sides$TOP$sides$LEFT, __WEBPACK_IMPORTED_MODULE_1_shared_constants_popout__["a" /* sides */].BOTTOM, __WEBPACK_IMPORTED_MODULE_1_shared_constants_popout__["a" /* sides */].TOP), _sides$TOP$sides$LEFT)[side] || __WEBPACK_IMPORTED_MODULE_1_shared_constants_popout__["a" /* sides */].NONE;
}

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = isPreviewMode;
/* harmony export (immutable) */ __webpack_exports__["a"] = openPreviewPrompt;
/* unused harmony export handlePreview */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_constants_view_modes__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_utils_wix_sdk__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_components_modal_modal__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_components_button_button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__preview_prompt_styl__ = __webpack_require__(1487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__preview_prompt_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__preview_prompt_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__translations__ = __webpack_require__(1261);






var _dec, _class;














var PreviewModePrompt = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_11__preview_prompt_styl___default.a), _dec(_class = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(PreviewModePrompt, _React$Component);

  function PreviewModePrompt() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, PreviewModePrompt);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PreviewModePrompt.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(PreviewModePrompt)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(PreviewModePrompt, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { styleName: 'prompt-wrapper',
          className: 'qa-widget-preview-prompt' },
        React.createElement(
          'div',
          { styleName: 'first-message' },
          React.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */], __WEBPACK_IMPORTED_MODULE_12__translations__["a" /* default */].youInPreview1)
        ),
        React.createElement(
          'div',
          { styleName: 'second-message' },
          React.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */], __WEBPACK_IMPORTED_MODULE_12__translations__["a" /* default */].youInPreview2)
        ),
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_10_shared_components_button_button__["a" /* PrimaryButton */],
          { styleName: 'close-button',
            onClick: __WEBPACK_IMPORTED_MODULE_9_shared_components_modal_modal__["a" /* closeModal */] },
          React.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */], __WEBPACK_IMPORTED_MODULE_12__translations__["a" /* default */].gotIt)
        )
      );
    }
  }]);

  return PreviewModePrompt;
}(React.Component)) || _class);


function isPreviewMode() {
  return __WEBPACK_IMPORTED_MODULE_8_shared_utils_wix_sdk__["a" /* default */].Utils.getViewMode() === __WEBPACK_IMPORTED_MODULE_6_shared_constants_view_modes__["a" /* default */].PREVIEW;
}

function openPreviewPrompt() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_shared_components_modal_modal__["b" /* openModal */])({
    contentClassName: __WEBPACK_IMPORTED_MODULE_11__preview_prompt_styl___default.a['modal-content'],
    className: __WEBPACK_IMPORTED_MODULE_11__preview_prompt_styl___default.a.modal,
    closeOnOverlayClick: true,
    title: React.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */], __WEBPACK_IMPORTED_MODULE_12__translations__["a" /* default */].previewMode),
    content: React.createElement(PreviewModePrompt, null)
  }).catch(__WEBPACK_IMPORTED_MODULE_9_shared_components_modal_modal__["c" /* closeCatcher */]);
}

function handlePreview(callBack) {
  return function () {
    if (isPreviewMode()) {
      openPreviewPrompt();
      return null;
    }

    callBack();
  };
}

/***/ }),
/* 359 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(337),
    eq = __webpack_require__(167);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(261),
    toKey = __webpack_require__(191);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toFakeVideoData;
/* harmony export (immutable) */ __webpack_exports__["b"] = addDataToSameChannelVideos;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_constants_uploading_statuses__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_selectors_videos__ = __webpack_require__(54);




function toFakeVideoData(file) {
  var now = new Date();

  var fakeVideoData = {
    id: _.uniqueId('FAKE-'),
    uploadingStatus: __WEBPACK_IMPORTED_MODULE_1_shared_constants_uploading_statuses__["a" /* default */].WAITING,
    createdTs: now,
    updatedTs: now
  };

  if (file) {
    var name = file.name,
        size = file.size;

    fakeVideoData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, fakeVideoData, {
      title: name.replace(/(.+)\.[a-z0-9]+$/i, '$1'),
      uploadedSize: 0,
      fileSize: size
    });
  }

  return fakeVideoData;
}

function addDataToSameChannelVideos(normalizedData, state) {
  var currentVideoId = normalizedData.result;

  var videoByIds = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_selectors_videos__["a" /* getVideosGroupedByIds */])(state);
  var channelVideoIds = _(videoByIds).filter(function (_ref) {
    var baseItemId = _ref.baseItemId;
    return baseItemId === currentVideoId;
  }).map('id').value();

  var currentVideoData = _.pick(normalizedData.entities.videos[currentVideoId], ['coverUrl', 'durationSec', 'durationStr', 'getVideoUrls', 'getVideoUrlsByFileName', 'error', 'mediaFileName', 'mediaInfo', 'mediaType', 'title', 'transcodingStatus', 'uploadingStatus', 'updatedTs']);

  _.forEach(channelVideoIds, function (videoId) {
    normalizedData.entities.videos[videoId] = currentVideoData;
  });
}

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NAMES; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_redux_helpers_create_async_actions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_utils_adapters_vod__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_redux_helpers_normalized__ = __webpack_require__(49);





var ACTIONS = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_redux_helpers_create_async_actions__["a" /* default */])('SERVER.VIDEOS.LIST');
var NAMES = ACTIONS.NAMES;
var START = ACTIONS.START,
    SUCCESS = ACTIONS.SUCCESS,
    FAIL = ACTIONS.FAIL;


/* harmony default export */ __webpack_exports__["b"] = (function (options) {

  options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, options, {
    paging: { size: 1000 }
  });

  return function (dispatch) {
    dispatch(START());

    var promise = __WEBPACK_IMPORTED_MODULE_2_shared_utils_adapters_vod__["a" /* default */].items.list(options);

    return promise.then(function (response) {
      response = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, response, {
        data: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_redux_helpers_normalized__["c" /* normalizeArrayOfVideos */])(response.data)
      });

      dispatch(SUCCESS({}, response));
      return response;
    }, function (response) {
      dispatch(FAIL({}, response, { analytics: { type: 'error', name: 'dashboard.videos.list' } }));
    });
  };
});

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BackOfficeDropdown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WidgetDropdown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StripWidgetDropdown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BareDropdown; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_scrollparent__ = __webpack_require__(1744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_scrollparent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_scrollparent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_utils_popout_invert_side__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_utils_popout_calculate_position__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_shared_constants_popout__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_shared_shapes_dropdown_options__ = __webpack_require__(1815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_shared_components_icon_icon__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_shared_components_popout_popout__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_shared_components_scrollbar_wrapper_scrollbar_wrapper__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__dropdown_styl__ = __webpack_require__(1882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__dropdown_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__dropdown_styl__);









var _dec, _class, _desc, _value, _class2, _class3, _temp, _dec2, _class4, _desc2, _value2, _class5, _class6, _temp3, _dec3, _class7, _dec4, _class8, _dec5, _class9, _dec6, _class10;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}



















var Option = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_shared_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_19__dropdown_styl___default.a), _dec(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(Option, _React$Component);

  function Option() {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, Option);

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Option.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(Option)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(Option, [{
    key: 'handleClick',
    value: function handleClick() {
      var _props = this.props,
          value = _props.value,
          onClick = _props.onClick;

      onClick(value);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          selected = _props2.selected,
          className = _props2.className,
          label = _props2.label,
          height = _props2.height;


      var styleNames = __WEBPACK_IMPORTED_MODULE_9_classnames___default()('option', {
        selected: selected
      });

      var heightStyle = { height: height };

      return React.createElement(
        'div',
        { styleName: styleNames,
          className: className,
          'data-hook': 'dropdown-option',
          title: label,
          onClick: this.handleClick,
          style: heightStyle },
        label
      );
    }
  }]);

  return Option;
}(React.Component), _class3.propTypes = {
  selected: React.PropTypes.bool,
  label: React.PropTypes.string,
  value: React.PropTypes.any,
  onClick: React.PropTypes.func,
  className: React.PropTypes.string,
  height: React.PropTypes.number
}, _class3.defaultProps = {
  selected: false
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'handleClick', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handleClick'), _class2.prototype)), _class2)) || _class);
var BaseDropdown = (_dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_shared_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_19__dropdown_styl___default.a), _dec2(_class4 = (_class5 = (_temp3 = _class6 = function (_React$Component2) {
  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(BaseDropdown, _React$Component2);

  function BaseDropdown() {
    var _ref;

    var _temp2, _this2, _ret;

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, BaseDropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp2 = (_this2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = BaseDropdown.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(BaseDropdown)).call.apply(_ref, [this].concat(args))), _this2), _this2.state = {
      open: false,
      hidePopout: true
    }, _temp2), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(_this2, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(BaseDropdown, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.updatePopoutPosition();
    }
  }, {
    key: 'calculatePosition',
    value: function calculatePosition() {
      var _props3 = this.props,
          triangleSide = _props3.popoutTriangleSide,
          popoutPosition = _props3.popoutPosition;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_shared_utils_popout_calculate_position__["b" /* byTriangleSide */])(this.triangle, this.popout, { triangleSide: triangleSide, popoutPosition: popoutPosition });
    }
  }, {
    key: 'updatePopoutPosition',
    value: function updatePopoutPosition() {
      if (!this.props.enablePopoutPositioningUpdate) {
        return;
      }

      var wrapperRect = this.wrapper.getBoundingClientRect();

      // getting scroll parent twice, becase first is not enough

      var _getScrollParent = __WEBPACK_IMPORTED_MODULE_10_scrollparent___default()(__WEBPACK_IMPORTED_MODULE_10_scrollparent___default()(this.wrapper)),
          scrollLeft = _getScrollParent.scrollLeft;

      var _calculatePosition = this.calculatePosition(),
          left = _calculatePosition.left,
          top = _calculatePosition.top,
          offsetX = _calculatePosition.offsetX;

      left -= scrollLeft + wrapperRect.left - offsetX;
      top -= wrapperRect.top;

      this.popout.style.left = left + 'px';
      this.popout.style.top = top + 'px';
    }
  }, {
    key: 'handleClickOutside',
    value: function handleClickOutside() {
      if (this.state.open) {
        this.setOpenState(false);
      }
    }
  }, {
    key: 'handleLabelClick',
    value: function handleLabelClick(event) {
      event.nativeEvent.stopImmediatePropagation();
      this.setOpenState(!this.state.open);
    }
  }, {
    key: 'setOpenState',
    value: function setOpenState(open) {
      var _this3 = this;

      if (open) {
        this.setState({
          open: open,
          hidePopout: false
        });

        this.props.onOpen();
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17_shared_components_popout_popout__["b" /* showPopout */])(this.popout);
      } else {
        this.setState({
          open: open
        });

        setTimeout(function () {
          _this3.setState({
            hidePopout: true
          });
        }, 200);
      }
    }
  }, {
    key: 'handleOptionClick',
    value: function handleOptionClick(value) {
      var onChange = this.props.onChange;

      var didValueChange = value !== this.props.value;

      this.setOpenState(false);

      if (didValueChange) {
        onChange(value);
      }
    }
  }, {
    key: 'getTriangleRef',
    value: function getTriangleRef(node) {
      this.triangle = node;
    }
  }, {
    key: 'getPopoutRef',
    value: function getPopoutRef(node) {
      this.popout = node;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props4 = this.props,
          value = _props4.value,
          rounded = _props4.rounded,
          disabled = _props4.disabled,
          popoutTriangleSide = _props4.popoutTriangleSide,
          popoutPosition = _props4.popoutPosition,
          className = _props4.className,
          optionsClassName = _props4.optionsClassName,
          optionClassName = _props4.optionClassName,
          selectedOptionClassName = _props4.selectedOptionClassName,
          labelClassName = _props4.labelClassName,
          triangleClassName = _props4.triangleClassName,
          ScrollbarWrapper = _props4.ScrollbarWrapper,
          height = _props4.height,
          maxOptionsVisible = _props4.maxOptionsVisible,
          placeholder = _props4.placeholder,
          enablePopoutPositioningUpdate = _props4.enablePopoutPositioningUpdate,
          dataHook = _props4.dataHook;
      var options = this.props.options;
      var _state = this.state,
          open = _state.open,
          hidePopout = _state.hidePopout;


      var styleNames = __WEBPACK_IMPORTED_MODULE_9_classnames___default()('dropdown', {
        open: open,
        'hide-popout': hidePopout,
        rounded: rounded,
        disabled: disabled
      });

      var selectedOption = _.find(options, function (option) {
        return _.isEqual(option.value, value);
      });
      var label = void 0;

      if (selectedOption) {
        label = selectedOption.label;
      } else {
        label = React.createElement(
          'span',
          { styleName: 'placeholder' },
          placeholder
        );
      }

      var heightStyle = { height: height };

      options = _.map(options, function (option, i) {
        if (option.categoryLabel) {
          return React.createElement(
            'div',
            { key: 'category-' + option.categoryLabel,
              styleName: 'category' },
            option.categoryLabel
          );
        }

        var isSelected = _.isEqual(value, option.value);
        var classNames = __WEBPACK_IMPORTED_MODULE_9_classnames___default()(optionClassName, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, selectedOptionClassName, selectedOptionClassName && isSelected));

        return React.createElement(Option, { key: i,
          label: option.label,
          value: option.value,
          selected: isSelected,
          className: classNames,
          height: height,
          onClick: _this4.handleOptionClick });
      });

      var popoutHeightStyle = 0;
      if (options.length > maxOptionsVisible) {
        options = React.createElement(
          ScrollbarWrapper,
          null,
          options
        );

        popoutHeightStyle = height * maxOptionsVisible;
      }

      var stickStyleNames = enablePopoutPositioningUpdate ? {} : {
        'stick-to-left': popoutPosition === __WEBPACK_IMPORTED_MODULE_14_shared_constants_popout__["c" /* popoutPositions */].LEFT,
        'stick-to-center': popoutPosition === __WEBPACK_IMPORTED_MODULE_14_shared_constants_popout__["c" /* popoutPositions */].CENTER,
        'stick-to-right': popoutPosition === __WEBPACK_IMPORTED_MODULE_14_shared_constants_popout__["c" /* popoutPositions */].RIGHT,
        'stick-to-bottom': popoutPosition === __WEBPACK_IMPORTED_MODULE_14_shared_constants_popout__["c" /* popoutPositions */].TOP
      };

      var optionsStyleNames = __WEBPACK_IMPORTED_MODULE_9_classnames___default()('options', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        single: options.length === 1
      }, stickStyleNames));

      return React.createElement(
        'div',
        { ref: function ref(node) {
            return _this4.wrapper = node;
          },
          styleName: styleNames,
          className: className,
          'data-hook': dataHook,
          style: heightStyle },
        React.createElement(
          'div',
          { styleName: 'label',
            'data-hook': 'dropdown-label',
            className: labelClassName,
            style: heightStyle,
            onClick: this.handleLabelClick },
          React.createElement(
            'span',
            { styleName: 'value',
              title: label },
            label
          ),
          React.createElement(__WEBPACK_IMPORTED_MODULE_16_shared_components_icon_icon__["a" /* default */], { getRef: this.getTriangleRef,
            styleName: 'triangle-down',
            className: triangleClassName,
            name: 'triangle-down' })
        ),
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_17_shared_components_popout_popout__["a" /* default */],
          { getRef: this.getPopoutRef,
            styleName: optionsStyleNames,
            className: optionsClassName,
            innerClassName: __WEBPACK_IMPORTED_MODULE_19__dropdown_styl___default.a['options-inner'],
            popoutSide: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_shared_utils_popout_invert_side__["a" /* default */])(popoutTriangleSide),
            height: popoutHeightStyle,
            onClickOutside: this.handleClickOutside },
          options
        )
      );
    }
  }]);

  return BaseDropdown;
}(React.Component), _class6.propTypes = {
  value: React.PropTypes.any,
  options: __WEBPACK_IMPORTED_MODULE_15_shared_shapes_dropdown_options__["a" /* default */],
  placeholder: React.PropTypes.string,
  onChange: React.PropTypes.func,
  onOpen: React.PropTypes.func,
  rounded: React.PropTypes.bool,
  className: React.PropTypes.string,
  dataHook: React.PropTypes.string,
  labelClassName: React.PropTypes.string,
  triangleClassName: React.PropTypes.string,
  optionsClassName: React.PropTypes.string,
  optionClassName: React.PropTypes.string,
  selectedOptionClassName: React.PropTypes.string,
  popoutTriangleSide: React.PropTypes.string,
  popoutPosition: React.PropTypes.string,
  height: React.PropTypes.number,
  disabled: React.PropTypes.bool,
  maxOptionsVisible: React.PropTypes.number,
  enablePopoutPositioningUpdate: React.PropTypes.bool,
  ScrollbarWrapper: React.PropTypes.oneOf([__WEBPACK_IMPORTED_MODULE_18_shared_components_scrollbar_wrapper_scrollbar_wrapper__["a" /* WidgetScrollbarWrapper */], __WEBPACK_IMPORTED_MODULE_18_shared_components_scrollbar_wrapper_scrollbar_wrapper__["b" /* BackOfficeScrollbarWrapper */]])
}, _class6.defaultProps = {
  height: 32,
  maxOptionsVisible: 5,
  onChange: _.noop,
  onOpen: _.noop,
  rounded: false,
  disabled: false,
  popoutTriangleSide: __WEBPACK_IMPORTED_MODULE_14_shared_constants_popout__["a" /* sides */].NONE,
  popoutPosition: __WEBPACK_IMPORTED_MODULE_14_shared_constants_popout__["c" /* popoutPositions */].LEFT,
  enablePopoutPositioningUpdate: false,
  ScrollbarWrapper: __WEBPACK_IMPORTED_MODULE_18_shared_components_scrollbar_wrapper_scrollbar_wrapper__["b" /* BackOfficeScrollbarWrapper */]
}, _temp3), (_applyDecoratedDescriptor(_class5.prototype, 'handleClickOutside', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class5.prototype, 'handleClickOutside'), _class5.prototype), _applyDecoratedDescriptor(_class5.prototype, 'handleLabelClick', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class5.prototype, 'handleLabelClick'), _class5.prototype), _applyDecoratedDescriptor(_class5.prototype, 'handleOptionClick', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class5.prototype, 'handleOptionClick'), _class5.prototype), _applyDecoratedDescriptor(_class5.prototype, 'getTriangleRef', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class5.prototype, 'getTriangleRef'), _class5.prototype), _applyDecoratedDescriptor(_class5.prototype, 'getPopoutRef', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class5.prototype, 'getPopoutRef'), _class5.prototype)), _class5)) || _class4);
var BackOfficeDropdown = (_dec3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_shared_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_19__dropdown_styl___default.a), _dec3(_class7 = function (_React$Component3) {
  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(BackOfficeDropdown, _React$Component3);

  function BackOfficeDropdown() {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, BackOfficeDropdown);

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (BackOfficeDropdown.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(BackOfficeDropdown)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(BackOfficeDropdown, [{
    key: 'render',
    value: function render() {
      var props = _.omit(this.props, 'styles');

      return React.createElement(BaseDropdown, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        height: 36,
        styleName: 'backoffice',
        ScrollbarWrapper: __WEBPACK_IMPORTED_MODULE_18_shared_components_scrollbar_wrapper_scrollbar_wrapper__["b" /* BackOfficeScrollbarWrapper */] }));
    }
  }]);

  return BackOfficeDropdown;
}(React.Component)) || _class7);


var WidgetDropdown = (_dec4 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_shared_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_19__dropdown_styl___default.a), _dec4(_class8 = function (_React$Component4) {
  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(WidgetDropdown, _React$Component4);

  function WidgetDropdown() {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, WidgetDropdown);

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (WidgetDropdown.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(WidgetDropdown)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(WidgetDropdown, [{
    key: 'render',
    value: function render() {
      var props = _.omit(this.props, 'styles');

      return React.createElement(BaseDropdown, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        styleName: 'widget',
        ScrollbarWrapper: __WEBPACK_IMPORTED_MODULE_18_shared_components_scrollbar_wrapper_scrollbar_wrapper__["a" /* WidgetScrollbarWrapper */] }));
    }
  }]);

  return WidgetDropdown;
}(React.Component)) || _class8);

var StripWidgetDropdown = (_dec5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_shared_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_19__dropdown_styl___default.a), _dec5(_class9 = function (_React$Component5) {
  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(StripWidgetDropdown, _React$Component5);

  function StripWidgetDropdown() {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, StripWidgetDropdown);

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (StripWidgetDropdown.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(StripWidgetDropdown)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(StripWidgetDropdown, [{
    key: 'render',
    value: function render() {
      var props = _.omit(this.props, 'styles');

      return React.createElement(BaseDropdown, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        styleName: 'widget strip',
        ScrollbarWrapper: __WEBPACK_IMPORTED_MODULE_18_shared_components_scrollbar_wrapper_scrollbar_wrapper__["a" /* WidgetScrollbarWrapper */] }));
    }
  }]);

  return StripWidgetDropdown;
}(React.Component)) || _class9);

var BareDropdown = (_dec6 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_shared_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_19__dropdown_styl___default.a), _dec6(_class10 = function (_React$Component6) {
  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(BareDropdown, _React$Component6);

  function BareDropdown() {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, BareDropdown);

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (BareDropdown.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(BareDropdown)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(BareDropdown, [{
    key: 'render',
    value: function render() {
      var props = _.omit(this.props, 'styles');

      return React.createElement(BaseDropdown, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        styleName: 'bare',
        enablePopoutPositioningUpdate: true,
        popoutPosition: __WEBPACK_IMPORTED_MODULE_14_shared_constants_popout__["c" /* popoutPositions */].CENTER,
        popoutTriangleSide: __WEBPACK_IMPORTED_MODULE_14_shared_constants_popout__["a" /* sides */].TOP }));
    }
  }]);

  return BareDropdown;
}(React.Component)) || _class10);

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tooltip; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_constants_popout__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_shapes_popout__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_components_icon_icon__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_components_popout_popout__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__tooltip_popout__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_shared_utils_device_screen__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__tooltip_styl__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__tooltip_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__tooltip_styl__);








var _dec, _class, _desc, _value, _class2, _class3, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}
















var Tooltip = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_shared_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_15__tooltip_styl___default.a), _dec(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Tooltip, _React$Component);

  function Tooltip() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Tooltip);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Tooltip.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Tooltip)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Tooltip, [{
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      var noTooltip = nextProps.noTooltip;

      if (noTooltip !== this.props.noTooltip) {
        if (noTooltip) {
          this.hideTooltipPopout();
        } else {
          this.showTooltipPopout();
        }
      }
    }
  }, {
    key: 'showTooltipPopout',
    value: function showTooltipPopout() {
      var _props = this.props,
          popoutSide = _props.popoutSide,
          popoutPosition = _props.popoutPosition,
          trianglePosition = _props.trianglePosition,
          preventHideOnHover = _props.preventHideOnHover,
          popoutComponent = _props.popoutComponent,
          popoutClassName = _props.popoutClassName,
          popoutTriangleClassName = _props.popoutTriangleClassName,
          popoutInnerClassName = _props.popoutInnerClassName,
          text = _props.text,
          noTooltip = _props.noTooltip,
          children = _props.children,
          onTooltipShow = _props.onTooltipShow;


      if (noTooltip) {
        return;
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__tooltip_popout__["b" /* showTooltip */])(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
        preventHideOnHover: preventHideOnHover,
        popoutComponent: popoutComponent,

        popoutSide: popoutSide,
        popoutPosition: popoutPosition,
        trianglePosition: trianglePosition,

        className: popoutClassName,
        innerClassName: popoutInnerClassName,
        triangleClassName: popoutTriangleClassName,

        content: text || children,
        referenceElement: this.icon

      }, this.tooltipPropsForDevice));

      onTooltipShow();
    }
  }, {
    key: 'hideTooltipPopout',
    value: function hideTooltipPopout() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__tooltip_popout__["a" /* hideTooltip */])();
    }
  }, {
    key: 'getRef',
    value: function getRef(node) {
      this.icon = node;
      this.props.getRef(node);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          iconName = _props2.iconName,
          className = _props2.className;


      return React.createElement(__WEBPACK_IMPORTED_MODULE_11_shared_components_icon_icon__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ getRef: this.getRef,
        name: iconName,
        styleName: 'icon',
        className: className,
        onClick: this.showTooltipPopout
      }, this.behaviorProps));
    }
  }, {
    key: 'behaviorProps',
    get: function get() {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_shared_utils_device_screen__["a" /* isMobile */])() || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_shared_utils_device_screen__["b" /* isTablet */])()) {
        return {
          onTouchStart: this.showTooltipPopout
        };
      }

      return {
        onMouseEnter: this.showTooltipPopout,
        onMouseLeave: this.hideTooltipPopout
      };
    }
  }, {
    key: 'tooltipPropsForDevice',
    get: function get() {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_shared_utils_device_screen__["a" /* isMobile */])() || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_shared_utils_device_screen__["b" /* isTablet */])()) {
        return {
          onClickOutside: this.hideTooltipPopout
        };
      }

      return {};
    }
  }]);

  return Tooltip;
}(React.Component), _class3.propTypes = {
  iconName: React.PropTypes.string,
  preventHideOnHover: React.PropTypes.bool,
  noTooltip: React.PropTypes.bool,
  popoutComponent: React.PropTypes.func,
  popoutSide: __WEBPACK_IMPORTED_MODULE_10_shared_shapes_popout__["a" /* sideShape */],
  popoutPosition: __WEBPACK_IMPORTED_MODULE_10_shared_shapes_popout__["b" /* popoutPositionShape */],
  trianglePosition: __WEBPACK_IMPORTED_MODULE_10_shared_shapes_popout__["c" /* trianglePositionShape */],
  className: React.PropTypes.string,
  popoutClassName: React.PropTypes.string,
  popoutTriangleClassName: React.PropTypes.string,
  popoutInnerClassName: React.PropTypes.string,
  getRef: React.PropTypes.func,
  onTooltipShow: React.PropTypes.func,
  text: React.PropTypes.any,
  children: React.PropTypes.any
}, _class3.defaultProps = {
  iconName: 'info',
  preventHideOnHover: false,
  noTooltip: false,
  popoutComponent: __WEBPACK_IMPORTED_MODULE_12_shared_components_popout_popout__["a" /* default */],
  popoutSide: __WEBPACK_IMPORTED_MODULE_9_shared_constants_popout__["a" /* sides */].RIGHT,
  popoutPosition: __WEBPACK_IMPORTED_MODULE_9_shared_constants_popout__["c" /* popoutPositions */].CENTER,
  trianglePosition: __WEBPACK_IMPORTED_MODULE_9_shared_constants_popout__["b" /* trianglePositions */].CENTER,
  getRef: _.noop,
  onTooltipShow: _.noop
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'showTooltipPopout', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'showTooltipPopout'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'getRef', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'getRef'), _class2.prototype)), _class2)) || _class);


/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  MOBILE: 'mobile',
  DESKTOP: 'desktop'
});

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PAYMENT_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PAYMENT_PERMS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _PAYMENT_PERMS;

var PAYMENT_TYPE = {
  SUBSCRIPTION: 'subscription',
  RENT: 'rent',
  PURCHASE: 'sale',
  MEMBER_ONLY: 'memberOnly'
};

var PAYMENT_PERMS = (_PAYMENT_PERMS = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PAYMENT_PERMS, PAYMENT_TYPE.SUBSCRIPTION, ['unlimitedStreaming', 'instantAccess', 'monthlyPayment']), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PAYMENT_PERMS, PAYMENT_TYPE.PURCHASE, ['singleVideo', 'onePayment', 'unlimitedStreaming']), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PAYMENT_PERMS, PAYMENT_TYPE.RENT, ['singleVideoStreaming', 'streamingPeriod']), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PAYMENT_PERMS, PAYMENT_TYPE.MEMBER_ONLY, ['singleVideo', 'unlimitedStreaming']), _PAYMENT_PERMS);

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return previewTypes; });
var previewTypes = {
  FIRST_20_SEC: 'first-20-sec',
  TRAILER: 'trailer',
  // type 'url' is temporarily commented, will return in vod phase 2
  // URL: 'url',
  NONE: 'none'
};

/* harmony default export */ __webpack_exports__["b"] = (_.values(previewTypes));

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  INITIAL: 'initial',
  PLAY_REQUESTED: 'play-requested',
  PLAYING: 'playing',
  PAUSE_REQUESTED: 'pause-requested',
  PAUSED: 'paused',
  ENDED: 'ended'
});

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DATA_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PaginatedChannelVideosLoader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_multireducer__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_multireducer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_multireducer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_selectors_videos__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_selectors_channel_videos__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_widget_redux_client_actions_paginated_channel_videos__ = __webpack_require__(1209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_data_components_data_loader__ = __webpack_require__(236);








var _dec, _class, _class2, _temp2;










var DATA_KEY = 'paginated-videos';

var PaginatedChannelVideosLoader = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_redux__["a" /* connect */])(function (state) {
  return {
    videoByIds: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_shared_selectors_videos__["a" /* getVideosGroupedByIds */])(state),
    paginatedChannelVideos: state.lazyVideoLists[DATA_KEY],
    isFetching: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_shared_selectors_channel_videos__["a" /* isFetching */])(state)
  };
}, function (dispatch) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_multireducer__["bindActionCreators"])({
    loadFirstPage: __WEBPACK_IMPORTED_MODULE_11_widget_redux_client_actions_paginated_channel_videos__["b" /* loadFirstPage */],
    toFirstPage: __WEBPACK_IMPORTED_MODULE_11_widget_redux_client_actions_paginated_channel_videos__["c" /* toFirstPage */],
    goBack: __WEBPACK_IMPORTED_MODULE_11_widget_redux_client_actions_paginated_channel_videos__["d" /* goBack */],
    goForward: __WEBPACK_IMPORTED_MODULE_11_widget_redux_client_actions_paginated_channel_videos__["e" /* goForward */]
  }, dispatch, DATA_KEY);
}), _dec(_class = (_temp2 = _class2 = function (_DataLoader) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(PaginatedChannelVideosLoader, _DataLoader);

  function PaginatedChannelVideosLoader() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, PaginatedChannelVideosLoader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = PaginatedChannelVideosLoader.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(PaginatedChannelVideosLoader)).call.apply(_ref, [this].concat(args))), _this), _this.dependencies = ['channelId', 'videosPerUIPage', 'searchQuery', 'searchQueryField'], _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(PaginatedChannelVideosLoader, [{
    key: 'loadData',
    value: function loadData() {
      var _props = this.props,
          searchQuery = _props.searchQuery,
          searchQueryField = _props.searchQueryField,
          videosPerUIPage = _props.videosPerUIPage,
          channelId = _props.channelId,
          loadFirstPage = _props.loadFirstPage;


      if (!channelId || !videosPerUIPage) {
        return;
      }

      // TODO: move loadFirstPage code here
      return loadFirstPage(channelId, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({
        perUIPage: videosPerUIPage
      }, searchQueryField, searchQuery));
    }
  }, {
    key: 'childProps',
    get: function get() {
      // FIXME: why do we need videoByIds? I see the same in reducer entities.videos
      var _props2 = this.props,
          videoByIds = _props2.videoByIds,
          isFetching = _props2.isFetching,
          toFirstPage = _props2.toFirstPage,
          goBack = _props2.goBack,
          goForward = _props2.goForward,
          paginatedChannelVideos = _props2.paginatedChannelVideos;

      return { videoByIds: videoByIds, paginatedChannelVideos: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, paginatedChannelVideos, {
          isFetching: isFetching,
          toFirstPage: toFirstPage,
          goBack: goBack,
          goForward: goForward,
          fetch: this.loadDataDebounced
        })
      };
    }
  }]);

  return PaginatedChannelVideosLoader;
}(__WEBPACK_IMPORTED_MODULE_12_shared_data_components_data_loader__["a" /* default */]), _class2.displayName = 'PaginatedChannelVideosLoader', _class2.propTypes = {
  paginatedChannelVideos: React.PropTypes.object,
  loadFirstPage: React.PropTypes.func,
  toFirstPage: React.PropTypes.func,
  goBack: React.PropTypes.func,
  goForward: React.PropTypes.func,
  channelId: React.PropTypes.string,
  videosPerUIPage: React.PropTypes.number,
  searchQuery: React.PropTypes.string,
  searchQueryField: React.PropTypes.string
}, _temp2)) || _class);


/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isVideoPlaying */
/* unused harmony export isVideoPaused */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isVideoPlayRequested; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isVideoPauseRequested; });
/* unused harmony export isVideoEnded */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isVideoPlayingOptimistic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isVideoPausedOptimistic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_widget_constants_video_playback_status__ = __webpack_require__(369);


var isVideoPlaying = function isVideoPlaying(state) {
  return state.videoPlaybackStatus === __WEBPACK_IMPORTED_MODULE_0_widget_constants_video_playback_status__["a" /* default */].PLAYING;
};
var isVideoPaused = function isVideoPaused(state) {
  return state.videoPlaybackStatus === __WEBPACK_IMPORTED_MODULE_0_widget_constants_video_playback_status__["a" /* default */].PAUSED;
};
var isVideoPlayRequested = function isVideoPlayRequested(state) {
  return state.videoPlaybackStatus === __WEBPACK_IMPORTED_MODULE_0_widget_constants_video_playback_status__["a" /* default */].PLAY_REQUESTED;
};
var isVideoPauseRequested = function isVideoPauseRequested(state) {
  return state.videoPlaybackStatus === __WEBPACK_IMPORTED_MODULE_0_widget_constants_video_playback_status__["a" /* default */].PAUSE_REQUESTED;
};

var isVideoEnded = function isVideoEnded(state) {
  return state.videoPlaybackStatus === __WEBPACK_IMPORTED_MODULE_0_widget_constants_video_playback_status__["a" /* default */].ENDED;
};

var isVideoPlayingOptimistic = function isVideoPlayingOptimistic(state) {
  return isVideoPlaying(state) || isVideoPlayRequested(state);
};
var isVideoPausedOptimistic = function isVideoPausedOptimistic(state) {
  return isVideoPaused(state) || isVideoPauseRequested(state);
};

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(730), __esModule: true };

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 375 */,
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = __webpack_require__(192);
exports.MediaStreamTypes = types_1.MediaStreamTypes;
var vidi_1 = __webpack_require__(1524);
exports.Vidi = vidi_1.Vidi;
exports.default = vidi_1.Vidi;
//# sourceMappingURL=index.js.map

/***/ }),
/* 377 */,
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NAMES; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_redux_helpers_create_async_actions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_utils_adapters_vod__ = __webpack_require__(34);



var ACTIONS = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_redux_helpers_create_async_actions__["a" /* default */])('SERVER.CHANNEL.REMOVE');
var NAMES = ACTIONS.NAMES;
var START = ACTIONS.START,
    SUCCESS = ACTIONS.SUCCESS,
    FAIL = ACTIONS.FAIL;


/* harmony default export */ __webpack_exports__["b"] = (function (id) {
  return function (dispatch) {
    var params = { id: id };
    dispatch(START(params));

    return __WEBPACK_IMPORTED_MODULE_1_shared_utils_adapters_vod__["a" /* default */].lists.remove(id).then(function (response) {
      dispatch(SUCCESS(params, response));
      return response;
    }, function (response) {
      dispatch(FAIL(params, response, { analytics: { type: 'error', name: 'dashboard.channel.remove' } }));
    });
  };
});

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  EXPAND_ON_CLICK: 1,
  ALWAYS_SHOW: 2,
  NEVER_SHOW: 3
});

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModalHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DangerModalHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return EmptyModalHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SimpleModalHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return IFrameModalHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ModalHeaderWithHelp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_constants_help_articles__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_components_button_icon_icon__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_components_button_button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_components_modal_modal__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__header_styl__ = __webpack_require__(1484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__header_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__header_styl__);








var _dec, _class, _desc, _value, _class2, _class3, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}














var ModalHeader = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_14__header_styl___default.a), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_router__["f" /* withRouter */])(_class = _dec(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(ModalHeader, _React$Component);

  function ModalHeader() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ModalHeader);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ModalHeader.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(ModalHeader)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(ModalHeader, [{
    key: 'openHelpModal',
    value: function openHelpModal() {
      var isActive = this.props.router.isActive;

      var helpLink = void 0;

      if (isActive('/video-library')) {
        helpLink = __WEBPACK_IMPORTED_MODULE_10_shared_constants_help_articles__["a" /* DASHBOARD */].LIBRARY;
      } else if (isActive('/channels')) {
        helpLink = __WEBPACK_IMPORTED_MODULE_10_shared_constants_help_articles__["a" /* DASHBOARD */].CHANNELS;
      } else if (isActive('/stats')) {
        helpLink = __WEBPACK_IMPORTED_MODULE_10_shared_constants_help_articles__["a" /* DASHBOARD */].STATS;
      } else if (isActive('/settings')) {
        helpLink = __WEBPACK_IMPORTED_MODULE_10_shared_constants_help_articles__["a" /* DASHBOARD */].SETTINGS;
      } else if (isActive('/email-marketing')) {
        helpLink = __WEBPACK_IMPORTED_MODULE_10_shared_constants_help_articles__["a" /* DASHBOARD */].EMAIL_MARKETING;
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_shared_components_modal_modal__["d" /* openIFrameModal */])('' + __WEBPACK_IMPORTED_MODULE_10_shared_constants_help_articles__["b" /* HELP_LINK_PREFIX */] + helpLink).catch(__WEBPACK_IMPORTED_MODULE_13_shared_components_modal_modal__["c" /* closeCatcher */]);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          onButtonClick = _props.onButtonClick,
          className = _props.className,
          buttonClassName = _props.buttonClassName;


      return React.createElement(
        'header',
        { styleName: 'header',
          className: className },
        this.title,
        this.helpLink,
        React.createElement(__WEBPACK_IMPORTED_MODULE_11_shared_components_button_icon_icon__["a" /* default */], { styleName: 'button close-button',
          className: buttonClassName,
          onClick: onButtonClick,
          name: 'close' })
      );
    }
  }, {
    key: 'helpLink',
    get: function get() {
      var showHelpLink = this.props.showHelpLink;


      if (!showHelpLink) {
        return null;
      }

      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_12_shared_components_button_button__["e" /* LinkButton */],
        { onClick: this.openHelpModal,
          styleName: 'button help-button' },
        '?'
      );
    }
  }, {
    key: 'title',
    get: function get() {
      var _props2 = this.props,
          title = _props2.title,
          titleClassName = _props2.titleClassName;


      if (!title) {
        return null;
      }

      return React.createElement(
        'h1',
        { styleName: 'title',
          className: titleClassName },
        title
      );
    }
  }]);

  return ModalHeader;
}(React.Component), _class3.propTypes = {
  router: React.PropTypes.object,
  title: React.PropTypes.any,
  className: React.PropTypes.string,
  buttonClassName: React.PropTypes.string,
  titleClassName: React.PropTypes.string,
  onButtonClick: React.PropTypes.func,
  showHelpLink: React.PropTypes.bool
}, _class3.defaultProps = {
  onButtonClick: _.noop,
  showHelpLink: true
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'openHelpModal', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'openHelpModal'), _class2.prototype)), _class2)) || _class) || _class);



function generateHeaderVariant(styleName) {
  var _dec2, _class4;

  var HeaderVariant = (_dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_14__header_styl___default.a), _dec2(_class4 = function (_React$Component2) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(HeaderVariant, _React$Component2);

    function HeaderVariant() {
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, HeaderVariant);

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (HeaderVariant.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(HeaderVariant)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(HeaderVariant, [{
      key: 'render',
      value: function render() {
        var props = _.omit(this.props, 'styles');

        return React.createElement(ModalHeader, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
          styleName: styleName }));
      }
    }]);

    return HeaderVariant;
  }(React.Component)) || _class4);


  return HeaderVariant;
}

var DangerModalHeader = generateHeaderVariant('danger');
var EmptyModalHeader = generateHeaderVariant('empty');
var SimpleModalHeader = generateHeaderVariant('simple');
var IFrameModalHeader = generateHeaderVariant('iframe');
var ModalHeaderWithHelp = generateHeaderVariant('help');

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PaymentEvents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_widget_constants_payment_message_proxy__ = __webpack_require__(1204);








var _desc, _value, _class, _class2, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}





var PaymentEvents = (_class = (_temp = _class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(PaymentEvents, _React$Component);

  function PaymentEvents() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, PaymentEvents);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PaymentEvents.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(PaymentEvents)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(PaymentEvents, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('message', this.handlePaymentProxyMessage, false);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('message', this.handlePaymentProxyMessage, false);
    }
  }, {
    key: 'handlePaymentProxyMessage',
    value: function handlePaymentProxyMessage(event) {
      var _PAYMENT_MESSAGE_PROX;

      if (event.origin !== window.location.origin) {
        return;
      }
      if (event.data.id !== __WEBPACK_IMPORTED_MODULE_8_widget_constants_payment_message_proxy__["a" /* default */].ID) {
        return;
      }

      var paymentMessage = event.data.message;
      var handler = (_PAYMENT_MESSAGE_PROX = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_PAYMENT_MESSAGE_PROX, __WEBPACK_IMPORTED_MODULE_8_widget_constants_payment_message_proxy__["a" /* default */].TYPES.SALE, this.handleSale), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_PAYMENT_MESSAGE_PROX, __WEBPACK_IMPORTED_MODULE_8_widget_constants_payment_message_proxy__["a" /* default */].TYPES.RENT, this.handleRent), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_PAYMENT_MESSAGE_PROX, __WEBPACK_IMPORTED_MODULE_8_widget_constants_payment_message_proxy__["a" /* default */].TYPES.SUBSCRIPTION, this.handleSubscription), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_PAYMENT_MESSAGE_PROX, __WEBPACK_IMPORTED_MODULE_8_widget_constants_payment_message_proxy__["a" /* default */].TYPES.SUBSCRIPTION_CANCEL, this.handleSubscriptionCancel), _PAYMENT_MESSAGE_PROX)[paymentMessage.type];

      if (handler) {
        handler(paymentMessage);
      }
    }
  }, {
    key: 'handleSale',
    value: function handleSale(message) {
      var _props = this.props,
          onSale = _props.onSale,
          onAnyEvent = _props.onAnyEvent;

      if (message.completed) {
        onAnyEvent(message);
        onSale(message);
      }
    }
  }, {
    key: 'handleRent',
    value: function handleRent(message) {
      var _props2 = this.props,
          onRent = _props2.onRent,
          onAnyEvent = _props2.onAnyEvent;

      if (message.completed) {
        onAnyEvent(message);
        onRent(message);
      }
    }
  }, {
    key: 'handleSubscription',
    value: function handleSubscription(message) {
      var _props3 = this.props,
          onSubscription = _props3.onSubscription,
          onAnyEvent = _props3.onAnyEvent;

      if (message.completed) {
        onAnyEvent(message);
        onSubscription(message);
      }
    }
  }, {
    key: 'handleSubscriptionCancel',
    value: function handleSubscriptionCancel(message) {
      var _props4 = this.props,
          onSubscriptionCancel = _props4.onSubscriptionCancel,
          onAnyEvent = _props4.onAnyEvent;

      if (message.completed) {
        onAnyEvent(message);
        onSubscriptionCancel(message);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return PaymentEvents;
}(React.Component), _class2.propTypes = {
  onSale: React.PropTypes.func,
  onRent: React.PropTypes.func,
  onSubscription: React.PropTypes.func,
  onSubscriptionCancel: React.PropTypes.func,
  onAnyEvent: React.PropTypes.func
}, _class2.defaultProps = {
  onSale: _.noop,
  onRent: _.noop,
  onSubscription: _.noop,
  onSubscriptionCancel: _.noop,
  onAnyEvent: _.noop
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'handlePaymentProxyMessage', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'handlePaymentProxyMessage'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleSale', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'handleSale'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleRent', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'handleRent'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleSubscription', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'handleSubscription'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleSubscriptionCancel', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'handleSubscriptionCancel'), _class.prototype)), _class);


/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDefaultChannelDealInfo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__currencies__ = __webpack_require__(265);


function getDefaultChannelDealInfo(currency) {
  return [{
    type: 'subscription',
    price: __WEBPACK_IMPORTED_MODULE_0__currencies__["a" /* default */][currency].subscription.default,
    enabled: false
  }];
}

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NAMES; });
/* harmony export (immutable) */ __webpack_exports__["a"] = publish;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_redux_helpers_create_async_actions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_utils_adapters_vod__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_redux_helpers_normalized__ = __webpack_require__(49);






var ACTIONS = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_redux_helpers_create_async_actions__["a" /* default */])('SERVER.CHANNEL.PUBLISH');
var NAMES = ACTIONS.NAMES;
var START = ACTIONS.START,
    SUCCESS = ACTIONS.SUCCESS;


function checkPublishStatus(taskId) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
    __WEBPACK_IMPORTED_MODULE_2_shared_utils_adapters_vod__["a" /* default */].list.checkPublish(taskId).then(resolve, function () {
      setTimeout(function () {
        checkPublishStatus(taskId).then(resolve);
      }, 2000);
    });
  });
}

function publish(id) {
  var shouldCheckPublish = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!id) {
    return;
  }

  var data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_redux_helpers_normalized__["e" /* normalizeChannel */])({ id: id, hasChangesToPublish: false });

  return function (dispatch) {
    dispatch(START({ id: id }, { data: data }));

    return __WEBPACK_IMPORTED_MODULE_2_shared_utils_adapters_vod__["a" /* default */].list.publish(id).then(shouldCheckPublish ? checkPublishStatus : _.noop).then(function () {
      dispatch(SUCCESS({}, { data: data }));
    });
  };
}

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NAMES; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_normalizr__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_normalizr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_normalizr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_schemas__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_redux_helpers_create_async_actions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_utils_adapters_vod__ = __webpack_require__(34);







var ACTIONS = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_redux_helpers_create_async_actions__["a" /* default */])('SERVER.CHANNELS.SEARCH');
var NAMES = ACTIONS.NAMES;
var START = ACTIONS.START,
    SUCCESS = ACTIONS.SUCCESS,
    FAIL = ACTIONS.FAIL;


/* harmony default export */ __webpack_exports__["b"] = (function (query, options) {

  options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, options, {
    paging: { size: 1000 }
  });

  return function (dispatch) {
    dispatch(START());

    return __WEBPACK_IMPORTED_MODULE_4_shared_utils_adapters_vod__["a" /* default */].lists.search(query, options).then(function (response) {
      response = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, response, {
        data: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_normalizr__["normalize"])(response.data, __WEBPACK_IMPORTED_MODULE_2_shared_schemas__["f" /* arrayOfChannels */])
      });

      dispatch(SUCCESS({}, response));
      return response;
    }, function (response) {
      dispatch(FAIL({}, response, { analytics: { type: 'error', name: 'shared.channels.search' } }));
    });
  };
});

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isMobile;
/* harmony export (immutable) */ __webpack_exports__["b"] = isTablet;
/* harmony export (immutable) */ __webpack_exports__["c"] = getScreenSizeByUserAgent;
/* harmony export (immutable) */ __webpack_exports__["d"] = isLandscape;
/* unused harmony export isPortrait */
var MOBILE_MAX_WIDTH = 600;
var TABLET_MAX_WIDTH = 1280;

function isMobile() {
  var _getScreenSizeByUserA = getScreenSizeByUserAgent(),
      width = _getScreenSizeByUserA.width,
      height = _getScreenSizeByUserA.height;

  var screenWidth = isLandscape() ? height : width;

  var isMobileScreenSize = screenWidth < MOBILE_MAX_WIDTH;
  var isMobileDetectedByClient = isMobileScreenSize && (isTouchScreen() || isMSMobileDevice());
  return isMobileDetectedByClient;
}

function isTablet() {
  var _getScreenSizeByUserA2 = getScreenSizeByUserAgent(),
      width = _getScreenSizeByUserA2.width,
      height = _getScreenSizeByUserA2.height;

  var screenWidth = isPortrait() ? height : width;

  return !isMobile() && screenWidth >= MOBILE_MAX_WIDTH && screenWidth <= TABLET_MAX_WIDTH && isTouchScreen();
}

function isMSMobileDevice() {
  return (/iemobile/i.test(getUserAgent())
  );
}

function isTouchScreen() {
  return Boolean('ontouchstart' in window || window.DocumentTouch && window.document instanceof window.DocumentTouch);
}

function getUserAgent() {
  return window.navigator.userAgent.toLowerCase();
}

function getScreenSizeByUserAgent() {
  var userAgent = getUserAgent();

  var specificAndroidParams = paramsForSpecificAndroidDevices(userAgent);

  var width = void 0;
  var height = void 0;

  var screenDimensions = getScreenDimensions();

  if (specificAndroidParams) {
    width = specificAndroidParams.width;
    height = specificAndroidParams.height;
  } else if (isPortrait()) {
    width = Math.min(screenDimensions.width, screenDimensions.height);
    height = Math.max(screenDimensions.width, screenDimensions.height);
  } else {
    width = Math.max(screenDimensions.width, screenDimensions.height);
    height = Math.min(screenDimensions.width, screenDimensions.height);
  }

  return { width: width, height: height };
}

function paramsForSpecificAndroidDevices(userAgent) {

  /* eslint-disable max-len */
  switch (true) {
    case /(GT-S5300B|GT-S5360|GT-S5367|GT-S5570I|GT-S6102B|LG-E400f|LG-E400g|LG-E405f|LG-L38C|LGL35G)/i.test(userAgent):
      return { width: 240, height: 320 };
    case /(Ls 670|GT-S5830|GT-S5839i|GT-S6500D|GT-S6802B|GT-S7500L|H866C|Huawei-U8665|LG-C800|LG-MS695|LG-VM696|LGL55C|M865|Prism|SCH-R720|SCH-R820|SCH-S720C|SPH-M820-BST|SPH-M930BST|U8667|X501_USA_Cricket|ZTE-Z990G)/i.test(userAgent):
      return { width: 320, height: 480 };
    case /(5860E|ADR6300|ADR6330VW|ADR8995|APA9292KT|C771|GT-I8160|GT-I9070|GT-I9100|HTC-A9192|myTouch4G|N860|PantechP9070|PC36100|pcdadr6350|SAMSUNG-SGH-I727|SAMSUNG-SGH-I777|SAMSUNG-SGH-I997|SC-03D|SCH-I405|SCH-I500|SCH-I510|SCH-R760|SGH-S959G|SGH-T679|SGH-T769|SGH-T959V|SGH-T989|SPH-D700)/i.test(userAgent):
      return { width: 480, height: 800 };
    case /(DROIDX|SonyEricssonSO-02C|SonyEricssonST25i)/i.test(userAgent):
      return { width: 480, height: 854 };
    case /(DROID3|MB855)/i.test(userAgent):
      return { width: 540, height: 960 };
    case /F-05D/i.test(userAgent):
      return { width: 720, height: 1280 };
    default:
      return null;
  }

  /* eslint-enable max-len */
}

function getScreenDimensions() {
  return { width: window.screen.width, height: window.screen.height };
}

function isLandscape() {
  return !isPortrait();
}

function isPortrait() {

  /*
   Correct solution would be 'window.innerHeight > window.innerWidth' but we don't have access
   to real innerHeight and innerWidth so set to null
   */
  var isPortraitByScreenSize = null;
  var _window = window,
      orientation = _window.orientation;


  return orientation === 0 || orientation === 180 || isPortraitByScreenSize;
}

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["g"] = isChannelInfoVisible;
/* unused harmony export isTitleVisible */
/* harmony export (immutable) */ __webpack_exports__["h"] = isChannelShareVisible;
/* harmony export (immutable) */ __webpack_exports__["d"] = isVideoShareVisible;
/* harmony export (immutable) */ __webpack_exports__["e"] = isSignInVisible;
/* harmony export (immutable) */ __webpack_exports__["c"] = isTagsVisible;
/* harmony export (immutable) */ __webpack_exports__["f"] = isCategoriesDropdownVisible;
/* harmony export (immutable) */ __webpack_exports__["i"] = isSearchInputVisible;
/* harmony export (immutable) */ __webpack_exports__["b"] = isClassicLayoutSearchBarVisible;
/* harmony export (immutable) */ __webpack_exports__["a"] = isClassicLayoutHeaderVisible;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_utils_channel_helpers__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_widget_components_overlay_texts_channel_subscribe_button_text__ = __webpack_require__(544);



/*
  THIS FUNCTIONS IS DEPRECATED
  use app-settings selector instead
  TODO: move to app-settings selector
  https://jira.wixpress.com/browse/VOD-303
*/

function isChannelInfoVisible(appSettings) {
  return appSettings.booleans.showChannelInfo;
}

function isTitleVisible(appSettings) {
  return appSettings.booleans.showChannelTitle;
}

function isChannelShareVisible(appSettings) {
  return appSettings.booleans.showChannelShare;
}

function isVideoShareVisible(appSettings) {
  return appSettings.booleans.enableVideosSharing;
}

function isSignInVisible(appSettings) {
  return appSettings.booleans.showSignIn;
}

function isTagsVisible(appSettings) {
  return appSettings.booleans.showChannelTags;
}

function isCategoriesDropdownVisible(appSettings) {
  var channelData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_utils_channel_helpers__["a" /* isVODChannel */])(channelData) && appSettings.booleans.showChannelCategories;
}

function isSearchInputVisible(appSettings) {
  var channelData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_utils_channel_helpers__["a" /* isVODChannel */])(channelData) && appSettings.booleans.showSearch;
}

// TODO: move to classic only selectors
function isClassicLayoutSearchBarVisible(appSettings) {
  var channelData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return isCategoriesDropdownVisible(appSettings, channelData) || isSearchInputVisible(appSettings, channelData);
}

// TODO: move to classic only selectors
function isClassicLayoutHeaderVisible(appSettings) {
  var channelData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return isTitleVisible(appSettings) || isChannelShareVisible(appSettings) || isChannelInfoVisible(appSettings) || isSignInVisible(appSettings) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_widget_components_overlay_texts_channel_subscribe_button_text__["a" /* isVisible */])({ channel: channelData });
}

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ControlButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_widget_player_widget_utils_wix_connect__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__control_button_styl__ = __webpack_require__(1490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__control_button_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__control_button_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__context_types__ = __webpack_require__(62);







var _dec, _class, _desc, _value, _class2, _class3, _temp2;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}










var ControlButton = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_widget_player_widget_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_9__control_button_styl___default.a), _dec(_class = (_class2 = (_temp2 = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ControlButton, _React$Component);

  function ControlButton() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ControlButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = ControlButton.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(ControlButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      menuOpen: false
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ControlButton, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('blur', this.handleClickOutside, false);
      document.addEventListener('click', this.handleClickOutside, false);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('blur', this.handleClickOutside, false);
      document.removeEventListener('click', this.handleClickOutside, false);
    }
  }, {
    key: 'handleClickOutside',
    value: function handleClickOutside(event) {
      var target = event.target;

      if (target !== window && this.wrapper && this.wrapper.contains(target)) {
        return;
      }

      this.toggleMenu(false);
    }
  }, {
    key: 'toggleMenu',
    value: function toggleMenu(menuOpen) {
      var _props = this.props,
          menu = _props.menu,
          onMenuToggle = _props.onMenuToggle;


      if (!menu) {
        return;
      }

      if (!_.isBoolean(menuOpen)) {
        menuOpen = !this.state.menuOpen;
      }

      this.setState({
        menuOpen: menuOpen
      });

      if (onMenuToggle) {
        onMenuToggle(menuOpen);
      }
    }
  }, {
    key: 'renderPopout',
    value: function renderPopout(type, _ref2) {
      var className = _ref2.className,
          content = _ref2.content,
          _ref2$position = _ref2.position,
          position = _ref2$position === undefined ? 'center' : _ref2$position;

      var outerStyleNames = __WEBPACK_IMPORTED_MODULE_7_classnames___default()('popout', 'popout--' + type, 'popout--' + position);
      var innerStyleNames = __WEBPACK_IMPORTED_MODULE_7_classnames___default()('popout--inner', type);

      return React.createElement(
        'span',
        { styleName: outerStyleNames },
        React.createElement(
          'span',
          { styleName: innerStyleNames,
            className: className },
          content
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          tooltip = _props2.tooltip,
          menu = _props2.menu,
          children = _props2.children;

      var otherProps = _.omit(this.props, ['tooltip', 'menu', 'children']);
      var menuOpen = this.state.menuOpen;
      var fullScreen = this.context.fullScreen;


      var props = _({}).assign(otherProps, {
        ref: function ref(node) {
          return _this2.wrapper = node;
        },
        styleName: __WEBPACK_IMPORTED_MODULE_7_classnames___default()('control-button', {
          'menu-open': menuOpen,
          'at-full-screen': fullScreen
        }),
        onMouseDown: this.toggleMenu
      }).omit('intl', 'appSettings', 'styles').value();

      return React.createElement(
        'span',
        props,
        tooltip && this.renderPopout('tooltip', tooltip),
        menu && this.renderPopout('tooltip', menu),
        children
      );
    }
  }]);

  return ControlButton;
}(React.Component), _class3.contextTypes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__context_types__["b" /* pickContextTypes */])('fullScreen'), _class3.propTypes = {
  children: React.PropTypes.any,
  onMenuToggle: React.PropTypes.func,
  tooltip: React.PropTypes.shape({
    content: React.PropTypes.any,
    position: React.PropTypes.oneOf(['center', 'left', 'right'])
  }),
  menu: React.PropTypes.shape({
    content: React.PropTypes.any,
    position: React.PropTypes.oneOf(['center', 'left', 'right'])
  })
}, _temp2), (_applyDecoratedDescriptor(_class2.prototype, 'handleClickOutside', [__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handleClickOutside'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'toggleMenu', [__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'toggleMenu'), _class2.prototype)), _class2)) || _class);


/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OVERLAY_ACTION_TYPES; });
/* harmony export (immutable) */ __webpack_exports__["b"] = getOverlayActions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_utils_deal_info_helpers__ = __webpack_require__(82);


var OVERLAY_ACTION_TYPES = {
  TIMER: 'timer',
  FILM: 'film',
  BUY_RENT: 'buy-rent',
  INFO: 'info',
  SHARE: 'share',
  SUBSCRIBE: 'subscribe'
};

function getOverlayActions(settings, channel, videoItem) {
  var dealInfo = videoItem.dealInfo,
      dgsInfo = videoItem.dgsInfo;


  var actions = [];
  var minVideoPriceInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_utils_deal_info_helpers__["d" /* getMinPriceInfo */])(dealInfo);
  var isSubscribed = Boolean(_.get(channel, 'dgsInfo.subscription'));
  var isSubscriptionEnabled = Boolean(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_utils_deal_info_helpers__["a" /* getSubscriptionPriceInfo */])(channel.dealInfo));

  if (dgsInfo) {
    var rentInfo = _.get(dgsInfo, 'rent');
    var saleInfo = _.get(dgsInfo, 'sale');

    if (rentInfo && rentInfo.expirationTs) {
      actions.push(OVERLAY_ACTION_TYPES.TIMER);
    }

    if (saleInfo) {
      actions.push(OVERLAY_ACTION_TYPES.FILM);
    }
  }

  if (minVideoPriceInfo && !isSubscribed && !dgsInfo) {
    if (isSubscriptionEnabled && channel.subscriptionOnly) {
      actions.push(OVERLAY_ACTION_TYPES.SUBSCRIBE);
    } else {
      actions.push(OVERLAY_ACTION_TYPES.BUY_RENT);
    }
  }

  if (settings.booleans.showFullInfo) {
    actions.push(OVERLAY_ACTION_TYPES.INFO);
  }

  if (settings.booleans.enableVideosSharing) {
    actions.push(OVERLAY_ACTION_TYPES.SHARE);
  }

  return actions;
}

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SocialShare; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_selectors_app_settings__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_widget_constants_social_networks__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__social_button_social_button__ = __webpack_require__(1284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__social_share_styl__ = __webpack_require__(1505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__social_share_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__social_share_styl__);






var _dec, _dec2, _class, _class2, _temp;













var SocialShare = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["a" /* connect */])(function (state) {
  return {
    areElementsRounded: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_shared_selectors_app_settings__["b" /* areElementsRounded */])(state)
  };
}), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_11__social_share_styl___default.a), _dec(_class = _dec2(_class = (_temp = _class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(SocialShare, _React$Component);

  function SocialShare() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SocialShare);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SocialShare.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(SocialShare)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(SocialShare, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          areElementsRounded = _props.areElementsRounded,
          networks = _props.networks,
          content = _props.content,
          className = _props.className,
          popoutOuterClassName = _props.popoutOuterClassName,
          popoutInnerClassName = _props.popoutInnerClassName,
          buttonClassName = _props.buttonClassName,
          networksClassNames = _props.networksClassNames,
          linkClassName = _props.linkClassName,
          onShare = _props.onShare;


      return React.createElement(
        'div',
        { styleName: 'social-share',
          className: className },
        _.map(networks, function (network) {
          return React.createElement(__WEBPACK_IMPORTED_MODULE_10__social_button_social_button__["a" /* default */], { styleName: 'social-button',
            popoutOuterClassName: popoutOuterClassName,
            popoutInnerClassName: popoutInnerClassName,
            className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()(buttonClassName, networksClassNames[network]),
            rounded: areElementsRounded,
            key: network,
            network: network,
            content: content,
            linkClassName: linkClassName,
            onClick: onShare });
        })
      );
    }
  }]);

  return SocialShare;
}(React.Component), _class2.propTypes = {
  areElementsRounded: React.PropTypes.bool,
  networks: React.PropTypes.arrayOf(React.PropTypes.string),
  content: React.PropTypes.shape({
    siteUrl: React.PropTypes.string,
    title: React.PropTypes.string,
    description: React.PropTypes.string,
    thumbnailUrl: React.PropTypes.string
  }),
  className: React.PropTypes.string,
  buttonClassName: React.PropTypes.string,
  linkClassName: React.PropTypes.string,
  popoutOuterClassName: React.PropTypes.string,
  popoutInnerClassName: React.PropTypes.string,
  networksClassNames: React.PropTypes.object,
  onShare: React.PropTypes.func
}, _class2.defaultProps = {
  networks: _.values(__WEBPACK_IMPORTED_MODULE_9_widget_constants_social_networks__["a" /* default */]),
  networksClassNames: {},
  onShare: _.noop
}, _temp)) || _class) || _class);


/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = attachScript;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

function attachScript(src) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
    var _document = document,
        body = _document.body;

    var script = document.createElement('script');
    script.src = src;

    var done = false;

    // Attach handlers for all browsers
    script.onload = script.onreadystatechange = function () {
      if (!done && (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete')) {
        done = true;

        resolve();

        script.onload = script.onreadystatechange = null;
        if (body && script.parentNode) {
          body.removeChild(script);
        }
      }
    };

    body.appendChild(script);
  });
}

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(72)
  , core    = __webpack_require__(37)
  , fails   = __webpack_require__(117);
module.exports = function(KEY, exec){
  var fn  = (core.Object || {})[KEY] || Object[KEY]
    , exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
};

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* $Date: 2007-06-12 18:02:31 $ */

// from: http://bannister.us/weblog/2007/06/09/simple-base64-encodedecode-javascript/
// Handles encode/decode of ASCII and Unicode strings.



var UTF8 = {};
UTF8.encode = function (s) {
    var u = [];
    for (var i = 0; i < s.length; ++i) {
        var c = s.charCodeAt(i);
        if (c < 0x80) {
            u.push(c);
        } else if (c < 0x800) {
            u.push(0xC0 | c >> 6);
            u.push(0x80 | 63 & c);
        } else if (c < 0x10000) {
            u.push(0xE0 | c >> 12);
            u.push(0x80 | 63 & c >> 6);
            u.push(0x80 | 63 & c);
        } else {
            u.push(0xF0 | c >> 18);
            u.push(0x80 | 63 & c >> 12);
            u.push(0x80 | 63 & c >> 6);
            u.push(0x80 | 63 & c);
        }
    }
    return u;
};
UTF8.decode = function (u) {
    var a = [];
    var i = 0;
    while (i < u.length) {
        var v = u[i++];
        if (v < 0x80) {
            // no need to mask byte
        } else if (v < 0xE0) {
                v = (31 & v) << 6;
                v |= 63 & u[i++];
            } else if (v < 0xF0) {
                v = (15 & v) << 12;
                v |= (63 & u[i++]) << 6;
                v |= 63 & u[i++];
            } else {
                v = (7 & v) << 18;
                v |= (63 & u[i++]) << 12;
                v |= (63 & u[i++]) << 6;
                v |= 63 & u[i++];
            }
        a.push(String.fromCharCode(v));
    }
    return a.join('');
};

var BASE64 = {};
(function (T) {
    var encodeArray = function encodeArray(u) {
        var i = 0;
        var a = [];
        var n = 0 | u.length / 3;
        while (0 < n--) {
            var v = (u[i] << 16) + (u[i + 1] << 8) + u[i + 2];
            i += 3;
            a.push(T.charAt(63 & v >> 18));
            a.push(T.charAt(63 & v >> 12));
            a.push(T.charAt(63 & v >> 6));
            a.push(T.charAt(63 & v));
        }
        if (2 == u.length - i) {
            var v = (u[i] << 16) + (u[i + 1] << 8);
            a.push(T.charAt(63 & v >> 18));
            a.push(T.charAt(63 & v >> 12));
            a.push(T.charAt(63 & v >> 6));
            a.push('=');
        } else if (1 == u.length - i) {
            var v = u[i] << 16;
            a.push(T.charAt(63 & v >> 18));
            a.push(T.charAt(63 & v >> 12));
            a.push('==');
        }
        return a.join('');
    };
    var R = (function () {
        var a = [];
        for (var i = 0; i < T.length; ++i) {
            a[T.charCodeAt(i)] = i;
        }
        a['='.charCodeAt(0)] = 0;
        return a;
    })();
    var decodeArray = function decodeArray(s) {
        var i = 0;
        var u = [];
        var n = 0 | s.length / 4;
        while (0 < n--) {
            var v = (R[s.charCodeAt(i)] << 18) + (R[s.charCodeAt(i + 1)] << 12) + (R[s.charCodeAt(i + 2)] << 6) + R[s.charCodeAt(i + 3)];
            u.push(255 & v >> 16);
            u.push(255 & v >> 8);
            u.push(255 & v);
            i += 4;
        }
        if (u) {
            if ('=' == s.charAt(i - 2)) {
                u.pop();
                u.pop();
            } else if ('=' == s.charAt(i - 1)) {
                u.pop();
            }
        }
        return u;
    };
    var ASCII = {};
    ASCII.encode = function (s) {
        var u = [];
        for (var i = 0; i < s.length; ++i) {
            u.push(s.charCodeAt(i));
        }
        return u;
    };
    ASCII.decode = function (u) {
        for (var i = 0; i < s.length; ++i) {
            a[i] = String.fromCharCode(a[i]);
        }
        return a.join('');
    };
    BASE64.decodeArray = function (s) {
        var u = decodeArray(s);
        return new Uint8Array(u);
    };
    BASE64.encodeASCII = function (s) {
        var u = ASCII.encode(s);
        return encodeArray(u);
    };
    BASE64.decodeASCII = function (s) {
        var a = decodeArray(s);
        return ASCII.decode(a);
    };
    BASE64.encode = function (s) {
        var u = UTF8.encode(s);
        return encodeArray(u);
    };
    BASE64.decode = function (s) {
        var u = decodeArray(s);
        return UTF8.decode(u);
    };
})("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/");

/*The following polyfills are not used in dash.js but have caused multiplayer integration issues.
 Therefore commenting them out.
if (undefined === btoa) {
    var btoa = BASE64.encode;
}
if (undefined === atob) {
    var atob = BASE64.decode;
}
*/

if (true) {
    exports.decode = BASE64.decode;
    exports.decodeArray = BASE64.decodeArray;
}
//# sourceMappingURL=base64.js.map


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 Copyright 2011-2013 Abdulla Abdurakhmanov
 Original sources are available at https://code.google.com/p/x2js/

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
 */

/*
  Further modified for dashjs to:
  - keep track of children nodes in order in attribute __children.
  - add type conversion matchers
  - re-add ignoreRoot
  - allow zero-length attributePrefix
  - don't add white-space text nodes
  - remove explicit RequireJS support
*/



Object.defineProperty(exports, "__esModule", {
    value: true
});
function X2JS(config) {
    'use strict';

    var VERSION = "1.2.0";

    config = config || {};
    initConfigDefaults();
    initRequiredPolyfills();

    function initConfigDefaults() {
        if (config.escapeMode === undefined) {
            config.escapeMode = true;
        }

        if (config.attributePrefix === undefined) {
            config.attributePrefix = "_";
        }

        config.arrayAccessForm = config.arrayAccessForm || "none";
        config.emptyNodeForm = config.emptyNodeForm || "text";

        if (config.enableToStringFunc === undefined) {
            config.enableToStringFunc = true;
        }
        config.arrayAccessFormPaths = config.arrayAccessFormPaths || [];
        if (config.skipEmptyTextNodesForObj === undefined) {
            config.skipEmptyTextNodesForObj = true;
        }
        if (config.stripWhitespaces === undefined) {
            config.stripWhitespaces = true;
        }
        config.datetimeAccessFormPaths = config.datetimeAccessFormPaths || [];

        if (config.useDoubleQuotes === undefined) {
            config.useDoubleQuotes = false;
        }

        config.xmlElementsFilter = config.xmlElementsFilter || [];
        config.jsonPropertiesFilter = config.jsonPropertiesFilter || [];

        if (config.keepCData === undefined) {
            config.keepCData = false;
        }

        if (config.ignoreRoot === undefined) {
            config.ignoreRoot = false;
        }
    }

    var DOMNodeTypes = {
        ELEMENT_NODE: 1,
        TEXT_NODE: 3,
        CDATA_SECTION_NODE: 4,
        COMMENT_NODE: 8,
        DOCUMENT_NODE: 9
    };

    function initRequiredPolyfills() {}

    function getNodeLocalName(node) {
        var nodeLocalName = node.localName;
        if (nodeLocalName == null) // Yeah, this is IE!!
            nodeLocalName = node.baseName;
        if (nodeLocalName == null || nodeLocalName == "") // =="" is IE too
            nodeLocalName = node.nodeName;
        return nodeLocalName;
    }

    function getNodePrefix(node) {
        return node.prefix;
    }

    function escapeXmlChars(str) {
        if (typeof str == "string") return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&apos;');else return str;
    }

    function unescapeXmlChars(str) {
        return str.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&apos;/g, "'").replace(/&amp;/g, '&');
    }

    function checkInStdFiltersArrayForm(stdFiltersArrayForm, obj, name, path) {
        var idx = 0;
        for (; idx < stdFiltersArrayForm.length; idx++) {
            var filterPath = stdFiltersArrayForm[idx];
            if (typeof filterPath === "string") {
                if (filterPath == path) break;
            } else if (filterPath instanceof RegExp) {
                if (filterPath.test(path)) break;
            } else if (typeof filterPath === "function") {
                if (filterPath(obj, name, path)) break;
            }
        }
        return idx != stdFiltersArrayForm.length;
    }

    function toArrayAccessForm(obj, childName, path) {
        switch (config.arrayAccessForm) {
            case "property":
                if (!(obj[childName] instanceof Array)) obj[childName + "_asArray"] = [obj[childName]];else obj[childName + "_asArray"] = obj[childName];
                break;
            /*case "none":
                break;*/
        }

        if (!(obj[childName] instanceof Array) && config.arrayAccessFormPaths.length > 0) {
            if (checkInStdFiltersArrayForm(config.arrayAccessFormPaths, obj, childName, path)) {
                obj[childName] = [obj[childName]];
            }
        }
    }

    function fromXmlDateTime(prop) {
        // Implementation based up on http://stackoverflow.com/questions/8178598/xml-datetime-to-javascript-date-object
        // Improved to support full spec and optional parts
        var bits = prop.split(/[-T:+Z]/g);

        var d = new Date(bits[0], bits[1] - 1, bits[2]);
        var secondBits = bits[5].split("\.");
        d.setHours(bits[3], bits[4], secondBits[0]);
        if (secondBits.length > 1) d.setMilliseconds(secondBits[1]);

        // Get supplied time zone offset in minutes
        if (bits[6] && bits[7]) {
            var offsetMinutes = bits[6] * 60 + Number(bits[7]);
            var sign = /\d\d-\d\d:\d\d$/.test(prop) ? '-' : '+';

            // Apply the sign
            offsetMinutes = 0 + (sign == '-' ? -1 * offsetMinutes : offsetMinutes);

            // Apply offset and local timezone
            d.setMinutes(d.getMinutes() - offsetMinutes - d.getTimezoneOffset());
        } else if (prop.indexOf("Z", prop.length - 1) !== -1) {
            d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds()));
        }

        // d is now a local time equivalent to the supplied time
        return d;
    }

    function checkFromXmlDateTimePaths(value, childName, fullPath) {
        if (config.datetimeAccessFormPaths.length > 0) {
            var path = fullPath.split("\.#")[0];
            if (checkInStdFiltersArrayForm(config.datetimeAccessFormPaths, value, childName, path)) {
                return fromXmlDateTime(value);
            } else return value;
        } else return value;
    }

    function checkXmlElementsFilter(obj, childType, childName, childPath) {
        if (childType == DOMNodeTypes.ELEMENT_NODE && config.xmlElementsFilter.length > 0) {
            return checkInStdFiltersArrayForm(config.xmlElementsFilter, obj, childName, childPath);
        } else return true;
    }

    function parseDOMChildren(node, path) {
        if (node.nodeType == DOMNodeTypes.DOCUMENT_NODE) {
            var result = new Object();
            var nodeChildren = node.childNodes;
            // Alternative for firstElementChild which is not supported in some environments
            for (var cidx = 0; cidx < nodeChildren.length; cidx++) {
                var child = nodeChildren[cidx];
                if (child.nodeType == DOMNodeTypes.ELEMENT_NODE) {
                    if (config.ignoreRoot) {
                        result = parseDOMChildren(child);
                    } else {
                        result = {};
                        var childName = getNodeLocalName(child);
                        result[childName] = parseDOMChildren(child);
                    }
                }
            }
            return result;
        } else if (node.nodeType == DOMNodeTypes.ELEMENT_NODE) {
            var result = new Object();
            result.__cnt = 0;

            var children = [];
            var nodeChildren = node.childNodes;

            // Children nodes
            for (var cidx = 0; cidx < nodeChildren.length; cidx++) {
                var child = nodeChildren[cidx];
                var childName = getNodeLocalName(child);

                if (child.nodeType != DOMNodeTypes.COMMENT_NODE) {
                    var childPath = path + "." + childName;
                    if (checkXmlElementsFilter(result, child.nodeType, childName, childPath)) {
                        result.__cnt++;
                        if (result[childName] == null) {
                            var c = parseDOMChildren(child, childPath);
                            if (childName != "#text" || /[^\s]/.test(c)) {
                                var o = {};
                                o[childName] = c;
                                children.push(o);
                            }
                            result[childName] = c;
                            toArrayAccessForm(result, childName, childPath);
                        } else {
                            if (result[childName] != null) {
                                if (!(result[childName] instanceof Array)) {
                                    result[childName] = [result[childName]];
                                    toArrayAccessForm(result, childName, childPath);
                                }
                            }

                            var c = parseDOMChildren(child, childPath);
                            if (childName != "#text" || /[^\s]/.test(c)) {
                                // Don't add white-space text nodes
                                var o = {};
                                o[childName] = c;
                                children.push(o);
                            }
                            result[childName][result[childName].length] = c;
                        }
                    }
                }
            }

            result.__children = children;

            // Attributes
            var nodeLocalName = getNodeLocalName(node);
            for (var aidx = 0; aidx < node.attributes.length; aidx++) {
                var attr = node.attributes[aidx];
                result.__cnt++;

                var value2 = attr.value;
                for (var m = 0, ml = config.matchers.length; m < ml; m++) {
                    var matchobj = config.matchers[m];
                    if (matchobj.test(attr, nodeLocalName)) value2 = matchobj.converter(attr.value);
                }

                result[config.attributePrefix + attr.name] = value2;
            }

            // Node namespace prefix
            var nodePrefix = getNodePrefix(node);
            if (nodePrefix != null && nodePrefix != "") {
                result.__cnt++;
                result.__prefix = nodePrefix;
            }

            if (result["#text"] != null) {
                result.__text = result["#text"];
                if (result.__text instanceof Array) {
                    result.__text = result.__text.join("\n");
                }
                //if(config.escapeMode)
                //	result.__text = unescapeXmlChars(result.__text);
                if (config.stripWhitespaces) result.__text = result.__text.trim();
                delete result["#text"];
                if (config.arrayAccessForm == "property") delete result["#text_asArray"];
                result.__text = checkFromXmlDateTimePaths(result.__text, childName, path + "." + childName);
            }
            if (result["#cdata-section"] != null) {
                result.__cdata = result["#cdata-section"];
                delete result["#cdata-section"];
                if (config.arrayAccessForm == "property") delete result["#cdata-section_asArray"];
            }

            if (result.__cnt == 0 && config.emptyNodeForm == "text") {
                result = '';
            } else if (result.__cnt == 1 && result.__text != null) {
                result = result.__text;
            } else if (result.__cnt == 1 && result.__cdata != null && !config.keepCData) {
                result = result.__cdata;
            } else if (result.__cnt > 1 && result.__text != null && config.skipEmptyTextNodesForObj) {
                if (config.stripWhitespaces && result.__text == "" || result.__text.trim() == "") {
                    delete result.__text;
                }
            }
            delete result.__cnt;

            if (config.enableToStringFunc && (result.__text != null || result.__cdata != null)) {
                result.toString = function () {
                    return (this.__text != null ? this.__text : '') + (this.__cdata != null ? this.__cdata : '');
                };
            }

            return result;
        } else if (node.nodeType == DOMNodeTypes.TEXT_NODE || node.nodeType == DOMNodeTypes.CDATA_SECTION_NODE) {
            return node.nodeValue;
        }
    }

    function startTag(jsonObj, element, attrList, closed) {
        var resultStr = "<" + (jsonObj != null && jsonObj.__prefix != null ? jsonObj.__prefix + ":" : "") + element;
        if (attrList != null) {
            for (var aidx = 0; aidx < attrList.length; aidx++) {
                var attrName = attrList[aidx];
                var attrVal = jsonObj[attrName];
                if (config.escapeMode) attrVal = escapeXmlChars(attrVal);
                resultStr += " " + attrName.substr(config.attributePrefix.length) + "=";
                if (config.useDoubleQuotes) resultStr += '"' + attrVal + '"';else resultStr += "'" + attrVal + "'";
            }
        }
        if (!closed) resultStr += ">";else resultStr += "/>";
        return resultStr;
    }

    function endTag(jsonObj, elementName) {
        return "</" + (jsonObj.__prefix != null ? jsonObj.__prefix + ":" : "") + elementName + ">";
    }

    function endsWith(str, suffix) {
        return str.indexOf(suffix, str.length - suffix.length) !== -1;
    }

    function jsonXmlSpecialElem(jsonObj, jsonObjField) {
        if (config.arrayAccessForm == "property" && endsWith(jsonObjField.toString(), "_asArray") || jsonObjField.toString().indexOf(config.attributePrefix) == 0 || jsonObjField.toString().indexOf("__") == 0 || jsonObj[jsonObjField] instanceof Function) return true;else return false;
    }

    function jsonXmlElemCount(jsonObj) {
        var elementsCnt = 0;
        if (jsonObj instanceof Object) {
            for (var it in jsonObj) {
                if (jsonXmlSpecialElem(jsonObj, it)) continue;
                elementsCnt++;
            }
        }
        return elementsCnt;
    }

    function checkJsonObjPropertiesFilter(jsonObj, propertyName, jsonObjPath) {
        return config.jsonPropertiesFilter.length == 0 || jsonObjPath == "" || checkInStdFiltersArrayForm(config.jsonPropertiesFilter, jsonObj, propertyName, jsonObjPath);
    }

    function parseJSONAttributes(jsonObj) {
        var attrList = [];
        if (jsonObj instanceof Object) {
            for (var ait in jsonObj) {
                if (ait.toString().indexOf("__") == -1 && ait.toString().indexOf(config.attributePrefix) == 0) {
                    attrList.push(ait);
                }
            }
        }
        return attrList;
    }

    function parseJSONTextAttrs(jsonTxtObj) {
        var result = "";

        if (jsonTxtObj.__cdata != null) {
            result += "<![CDATA[" + jsonTxtObj.__cdata + "]]>";
        }

        if (jsonTxtObj.__text != null) {
            if (config.escapeMode) result += escapeXmlChars(jsonTxtObj.__text);else result += jsonTxtObj.__text;
        }
        return result;
    }

    function parseJSONTextObject(jsonTxtObj) {
        var result = "";

        if (jsonTxtObj instanceof Object) {
            result += parseJSONTextAttrs(jsonTxtObj);
        } else if (jsonTxtObj != null) {
            if (config.escapeMode) result += escapeXmlChars(jsonTxtObj);else result += jsonTxtObj;
        }

        return result;
    }

    function getJsonPropertyPath(jsonObjPath, jsonPropName) {
        if (jsonObjPath === "") {
            return jsonPropName;
        } else return jsonObjPath + "." + jsonPropName;
    }

    function parseJSONArray(jsonArrRoot, jsonArrObj, attrList, jsonObjPath) {
        var result = "";
        if (jsonArrRoot.length == 0) {
            result += startTag(jsonArrRoot, jsonArrObj, attrList, true);
        } else {
            for (var arIdx = 0; arIdx < jsonArrRoot.length; arIdx++) {
                result += startTag(jsonArrRoot[arIdx], jsonArrObj, parseJSONAttributes(jsonArrRoot[arIdx]), false);
                result += parseJSONObject(jsonArrRoot[arIdx], getJsonPropertyPath(jsonObjPath, jsonArrObj));
                result += endTag(jsonArrRoot[arIdx], jsonArrObj);
            }
        }
        return result;
    }

    function parseJSONObject(jsonObj, jsonObjPath) {
        var result = "";

        var elementsCnt = jsonXmlElemCount(jsonObj);

        if (elementsCnt > 0) {
            for (var it in jsonObj) {

                if (jsonXmlSpecialElem(jsonObj, it) || jsonObjPath != "" && !checkJsonObjPropertiesFilter(jsonObj, it, getJsonPropertyPath(jsonObjPath, it))) continue;

                var subObj = jsonObj[it];

                var attrList = parseJSONAttributes(subObj);

                if (subObj == null || subObj == undefined) {
                    result += startTag(subObj, it, attrList, true);
                } else if (subObj instanceof Object) {

                    if (subObj instanceof Array) {
                        result += parseJSONArray(subObj, it, attrList, jsonObjPath);
                    } else if (subObj instanceof Date) {
                        result += startTag(subObj, it, attrList, false);
                        result += subObj.toISOString();
                        result += endTag(subObj, it);
                    } else {
                        var subObjElementsCnt = jsonXmlElemCount(subObj);
                        if (subObjElementsCnt > 0 || subObj.__text != null || subObj.__cdata != null) {
                            result += startTag(subObj, it, attrList, false);
                            result += parseJSONObject(subObj, getJsonPropertyPath(jsonObjPath, it));
                            result += endTag(subObj, it);
                        } else {
                            result += startTag(subObj, it, attrList, true);
                        }
                    }
                } else {
                    result += startTag(subObj, it, attrList, false);
                    result += parseJSONTextObject(subObj);
                    result += endTag(subObj, it);
                }
            }
        }
        result += parseJSONTextObject(jsonObj);

        return result;
    }

    this.parseXmlString = function (xmlDocStr) {
        var isIEParser = window.ActiveXObject || "ActiveXObject" in window;
        if (xmlDocStr === undefined) {
            return null;
        }
        var xmlDoc;
        if (window.DOMParser) {
            var parser = new window.DOMParser();
            var parsererrorNS = null;
            // IE9+ now is here
            if (!isIEParser) {
                try {
                    parsererrorNS = parser.parseFromString("INVALID", "text/xml").getElementsByTagName("parsererror")[0].namespaceURI;
                } catch (err) {
                    parsererrorNS = null;
                }
            }
            try {
                xmlDoc = parser.parseFromString(xmlDocStr, "text/xml");
                if (parsererrorNS != null && xmlDoc.getElementsByTagNameNS(parsererrorNS, "parsererror").length > 0) {
                    //throw new Error('Error parsing XML: '+xmlDocStr);
                    xmlDoc = null;
                }
            } catch (err) {
                xmlDoc = null;
            }
        } else {
            // IE :(
            if (xmlDocStr.indexOf("<?") == 0) {
                xmlDocStr = xmlDocStr.substr(xmlDocStr.indexOf("?>") + 2);
            }
            xmlDoc = new ActiveXObject("Microsoft.XMLDOM");
            xmlDoc.async = "false";
            xmlDoc.loadXML(xmlDocStr);
        }
        return xmlDoc;
    };

    this.asArray = function (prop) {
        if (prop === undefined || prop == null) return [];else if (prop instanceof Array) return prop;else return [prop];
    };

    this.toXmlDateTime = function (dt) {
        if (dt instanceof Date) return dt.toISOString();else if (typeof dt === 'number') return new Date(dt).toISOString();else return null;
    };

    this.asDateTime = function (prop) {
        if (typeof prop == "string") {
            return fromXmlDateTime(prop);
        } else return prop;
    };

    this.xml2json = function (xmlDoc) {
        return parseDOMChildren(xmlDoc);
    };

    this.xml_str2json = function (xmlDocStr) {
        var xmlDoc = this.parseXmlString(xmlDocStr);
        if (xmlDoc != null) return this.xml2json(xmlDoc);else return null;
    };

    this.json2xml_str = function (jsonObj) {
        return parseJSONObject(jsonObj, "");
    };

    this.json2xml = function (jsonObj) {
        var xmlDocStr = this.json2xml_str(jsonObj);
        return this.parseXmlString(xmlDocStr);
    };

    this.getVersion = function () {
        return VERSION;
    };
}

exports["default"] = X2JS;
module.exports = exports["default"];
//# sourceMappingURL=xml2json.js.map


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _streamingVoTrackInfo = __webpack_require__(1426);

var _streamingVoTrackInfo2 = _interopRequireDefault(_streamingVoTrackInfo);

var _streamingVoMediaInfo = __webpack_require__(1422);

var _streamingVoMediaInfo2 = _interopRequireDefault(_streamingVoMediaInfo);

var _streamingVoStreamInfo = __webpack_require__(1424);

var _streamingVoStreamInfo2 = _interopRequireDefault(_streamingVoStreamInfo);

var _streamingVoManifestInfo = __webpack_require__(1421);

var _streamingVoManifestInfo2 = _interopRequireDefault(_streamingVoManifestInfo);

var _voEvent = __webpack_require__(588);

var _voEvent2 = _interopRequireDefault(_voEvent);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _externalsCea608Parser = __webpack_require__(583);

var _externalsCea608Parser2 = _interopRequireDefault(_externalsCea608Parser);

var _constantsDashMetricsList = __webpack_require__(585);

var METRIC_LIST = _interopRequireWildcard(_constantsDashMetricsList);

function DashAdapter() {

    //let context = this.context;

    var instance = undefined,
        dashManifestModel = undefined,
        periods = undefined,
        adaptations = undefined;

    function setConfig(config) {
        if (!config) return;

        if (config.dashManifestModel) {
            dashManifestModel = config.dashManifestModel;
        }
    }

    function initialize() {
        periods = [];
        adaptations = {};
    }

    function getRepresentationForTrackInfo(trackInfo, representationController) {
        return representationController.getRepresentationForQuality(trackInfo.quality);
    }

    function getAdaptationForMediaInfo(mediaInfo) {
        if (!adaptations || !mediaInfo || !adaptations[mediaInfo.streamInfo.id]) return null;
        return adaptations[mediaInfo.streamInfo.id][mediaInfo.index];
    }

    function getPeriodForStreamInfo(streamInfo) {
        var ln = periods.length;

        for (var i = 0; i < ln; i++) {
            var period = periods[i];

            if (streamInfo.id === period.id) return period;
        }

        return null;
    }

    function convertRepresentationToTrackInfo(manifest, representation) {
        var trackInfo = new _streamingVoTrackInfo2['default']();
        var a = representation.adaptation.period.mpd.manifest.Period_asArray[representation.adaptation.period.index].AdaptationSet_asArray[representation.adaptation.index];
        var r = dashManifestModel.getRepresentationFor(representation.index, a);

        trackInfo.id = representation.id;
        trackInfo.quality = representation.index;
        trackInfo.bandwidth = dashManifestModel.getBandwidth(r);
        trackInfo.DVRWindow = representation.segmentAvailabilityRange;
        trackInfo.fragmentDuration = representation.segmentDuration || (representation.segments && representation.segments.length > 0 ? representation.segments[0].duration : NaN);
        trackInfo.MSETimeOffset = representation.MSETimeOffset;
        trackInfo.useCalculatedLiveEdgeTime = representation.useCalculatedLiveEdgeTime;
        trackInfo.mediaInfo = convertAdaptationToMediaInfo(manifest, representation.adaptation);

        return trackInfo;
    }

    function convertAdaptationToMediaInfo(manifest, adaptation) {
        var mediaInfo = new _streamingVoMediaInfo2['default']();
        var a = adaptation.period.mpd.manifest.Period_asArray[adaptation.period.index].AdaptationSet_asArray[adaptation.index];
        var viewpoint;

        mediaInfo.id = adaptation.id;
        mediaInfo.index = adaptation.index;
        mediaInfo.type = adaptation.type;
        mediaInfo.streamInfo = convertPeriodToStreamInfo(manifest, adaptation.period);
        mediaInfo.representationCount = dashManifestModel.getRepresentationCount(a);
        mediaInfo.lang = dashManifestModel.getLanguageForAdaptation(a);
        viewpoint = dashManifestModel.getViewpointForAdaptation(a);
        mediaInfo.viewpoint = viewpoint ? viewpoint.value : undefined;
        mediaInfo.accessibility = dashManifestModel.getAccessibilityForAdaptation(a).map(function (accessibility) {
            var accessibilityValue = accessibility.value;
            var accessibilityData = accessibilityValue;
            if (accessibility.schemeIdUri && accessibility.schemeIdUri.search('cea-608') >= 0 && typeof _externalsCea608Parser2['default'] !== 'undefined') {
                if (accessibilityValue) {
                    accessibilityData = 'cea-608:' + accessibilityValue;
                } else {
                    accessibilityData = 'cea-608';
                }
                mediaInfo.embeddedCaptions = true;
            }
            return accessibilityData;
        });
        mediaInfo.audioChannelConfiguration = dashManifestModel.getAudioChannelConfigurationForAdaptation(a).map(function (audioChannelConfiguration) {
            return audioChannelConfiguration.value;
        });
        mediaInfo.roles = dashManifestModel.getRolesForAdaptation(a).map(function (role) {
            return role.value;
        });
        mediaInfo.codec = dashManifestModel.getCodec(a);
        mediaInfo.mimeType = dashManifestModel.getMimeType(a);
        mediaInfo.contentProtection = dashManifestModel.getContentProtectionData(a);
        mediaInfo.bitrateList = dashManifestModel.getBitrateListForAdaptation(a);

        if (mediaInfo.contentProtection) {
            mediaInfo.contentProtection.forEach(function (item) {
                item.KID = dashManifestModel.getKID(item);
            });
        }

        mediaInfo.isText = dashManifestModel.getIsTextTrack(mediaInfo.mimeType);

        return mediaInfo;
    }

    function convertVideoInfoToEmbeddedTextInfo(mediaInfo, channel, lang) {
        mediaInfo.id = channel; // CC1, CC2, CC3, or CC4
        mediaInfo.index = 100 + parseInt(channel.substring(2, 3));
        mediaInfo.type = 'embeddedText';
        mediaInfo.codec = 'cea-608-in-SEI';
        mediaInfo.isText = true;
        mediaInfo.isEmbedded = true;
        mediaInfo.lang = channel + ' ' + lang;
        mediaInfo.roles = ['caption'];
    }

    function convertPeriodToStreamInfo(manifest, period) {
        var streamInfo = new _streamingVoStreamInfo2['default']();
        var THRESHOLD = 1;

        streamInfo.id = period.id;
        streamInfo.index = period.index;
        streamInfo.start = period.start;
        streamInfo.duration = period.duration;
        streamInfo.manifestInfo = convertMpdToManifestInfo(manifest, period.mpd);
        streamInfo.isLast = manifest.Period_asArray.length === 1 || Math.abs(streamInfo.start + streamInfo.duration - streamInfo.manifestInfo.duration) < THRESHOLD;
        streamInfo.isFirst = manifest.Period_asArray.length === 1 || dashManifestModel.getRegularPeriods(manifest, dashManifestModel.getMpd(manifest))[0].id === period.id;

        return streamInfo;
    }

    function convertMpdToManifestInfo(manifest, mpd) {
        var manifestInfo = new _streamingVoManifestInfo2['default']();

        manifestInfo.DVRWindowSize = mpd.timeShiftBufferDepth;
        manifestInfo.loadedTime = mpd.manifest.loadedTime;
        manifestInfo.availableFrom = mpd.availabilityStartTime;
        manifestInfo.minBufferTime = mpd.manifest.minBufferTime;
        manifestInfo.maxFragmentDuration = mpd.maxSegmentDuration;
        manifestInfo.duration = dashManifestModel.getDuration(manifest);
        manifestInfo.isDynamic = dashManifestModel.getIsDynamic(manifest);

        return manifestInfo;
    }

    function getMediaInfoForType(manifest, streamInfo, type) {

        var data = dashManifestModel.getAdaptationForType(manifest, streamInfo.index, type, streamInfo);
        if (!data) return null;

        var periodInfo = getPeriodForStreamInfo(streamInfo);
        var periodId = periodInfo.id;
        var idx = dashManifestModel.getIndexForAdaptation(data, manifest, streamInfo.index);

        adaptations[periodId] = adaptations[periodId] || dashManifestModel.getAdaptationsForPeriod(manifest, periodInfo);

        return convertAdaptationToMediaInfo(manifest, adaptations[periodId][idx]);
    }

    function getAllMediaInfoForType(manifest, streamInfo, type) {
        var periodInfo = getPeriodForStreamInfo(streamInfo);
        var periodId = periodInfo.id;
        var adaptationsForType = dashManifestModel.getAdaptationsForType(manifest, streamInfo.index, type !== 'embeddedText' ? type : 'video');

        var mediaArr = [];

        var data, media, idx, i, j, ln;

        if (!adaptationsForType) return mediaArr;

        adaptations[periodId] = adaptations[periodId] || dashManifestModel.getAdaptationsForPeriod(manifest, periodInfo);

        for (i = 0, ln = adaptationsForType.length; i < ln; i++) {
            data = adaptationsForType[i];
            idx = dashManifestModel.getIndexForAdaptation(data, manifest, streamInfo.index);
            media = convertAdaptationToMediaInfo(manifest, adaptations[periodId][idx]);

            if (type === 'embeddedText') {
                var accessibilityLength = media.accessibility.length;
                for (j = 0; j < accessibilityLength; j++) {
                    if (!media) {
                        continue;
                    }
                    var accessibility = media.accessibility[j];
                    if (accessibility.indexOf('cea-608:') === 0) {
                        var value = accessibility.substring(8);
                        var parts = value.split(';');
                        if (parts[0].substring(0, 2) === 'CC') {
                            for (j = 0; j < parts.length; j++) {
                                if (!media) {
                                    media = convertAdaptationToMediaInfo.call(this, manifest, adaptations[periodId][idx]);
                                }
                                convertVideoInfoToEmbeddedTextInfo(media, parts[j].substring(0, 3), parts[j].substring(4));
                                mediaArr.push(media);
                                media = null;
                            }
                        } else {
                            for (j = 0; j < parts.length; j++) {
                                // Only languages for CC1, CC2, ...
                                if (!media) {
                                    media = convertAdaptationToMediaInfo.call(this, manifest, adaptations[periodId][idx]);
                                }
                                convertVideoInfoToEmbeddedTextInfo(media, 'CC' + (j + 1), parts[j]);
                                mediaArr.push(media);
                                media = null;
                            }
                        }
                    } else if (accessibility.indexOf('cea-608') === 0) {
                        // Nothing known. We interpret it as CC1=eng
                        convertVideoInfoToEmbeddedTextInfo(media, 'CC1', 'eng');
                        mediaArr.push(media);
                        media = null;
                    }
                }
            }
            if (media && type !== 'embeddedText') {
                mediaArr.push(media);
            }
        }

        return mediaArr;
    }

    function getStreamsInfo(manifest) {

        if (!manifest) return null;

        var streams = [];
        var mpd = dashManifestModel.getMpd(manifest);

        periods = dashManifestModel.getRegularPeriods(manifest, mpd);
        adaptations = {};

        for (var i = 0, ln = periods.length; i < ln; i++) {
            streams.push(convertPeriodToStreamInfo(manifest, periods[i]));
        }

        return streams;
    }

    function getManifestInfo(manifest) {
        var mpd = dashManifestModel.getMpd(manifest);
        return convertMpdToManifestInfo(manifest, mpd);
    }

    function getInitRequest(streamProcessor, quality) {
        var representation = streamProcessor.getRepresentationController().getRepresentationForQuality(quality);
        return streamProcessor.getIndexHandler().getInitRequest(representation);
    }

    function getNextFragmentRequest(streamProcessor, trackInfo) {
        var representation = getRepresentationForTrackInfo(trackInfo, streamProcessor.getRepresentationController());
        return streamProcessor.getIndexHandler().getNextSegmentRequest(representation);
    }

    function getFragmentRequestForTime(streamProcessor, trackInfo, time, options) {
        var representation = getRepresentationForTrackInfo(trackInfo, streamProcessor.getRepresentationController());
        return streamProcessor.getIndexHandler().getSegmentRequestForTime(representation, time, options);
    }

    function generateFragmentRequestForTime(streamProcessor, trackInfo, time) {
        var representation = getRepresentationForTrackInfo(trackInfo, streamProcessor.getRepresentationController());
        return streamProcessor.getIndexHandler().generateSegmentRequestForTime(representation, time);
    }

    function getIndexHandlerTime(streamProcessor) {
        return streamProcessor.getIndexHandler().getCurrentTime();
    }

    function setIndexHandlerTime(streamProcessor, value) {
        return streamProcessor.getIndexHandler().setCurrentTime(value);
    }

    function updateData(manifest, streamProcessor) {
        var periodInfo = getPeriodForStreamInfo(streamProcessor.getStreamInfo());
        var mediaInfo = streamProcessor.getMediaInfo();
        var adaptation = getAdaptationForMediaInfo(mediaInfo);
        var type = streamProcessor.getType();

        var id, data;

        id = mediaInfo.id;
        data = id ? dashManifestModel.getAdaptationForId(id, manifest, periodInfo.index) : dashManifestModel.getAdaptationForIndex(mediaInfo.index, manifest, periodInfo.index);
        streamProcessor.getRepresentationController().updateData(data, adaptation, type);
    }

    function getRepresentationInfoForQuality(manifest, representationController, quality) {
        var representation = representationController.getRepresentationForQuality(quality);
        return representation ? convertRepresentationToTrackInfo(manifest, representation) : null;
    }

    function getCurrentRepresentationInfo(manifest, representationController) {
        var representation = representationController.getCurrentRepresentation();
        return representation ? convertRepresentationToTrackInfo(manifest, representation) : null;
    }

    function getEvent(eventBox, eventStreams, startTime) {
        var event = new _voEvent2['default']();
        var schemeIdUri = eventBox.scheme_id_uri;
        var value = eventBox.value;
        var timescale = eventBox.timescale;
        var presentationTimeDelta = eventBox.presentation_time_delta;
        var duration = eventBox.event_duration;
        var id = eventBox.id;
        var messageData = eventBox.message_data;
        var presentationTime = startTime * timescale + presentationTimeDelta;

        if (!eventStreams[schemeIdUri]) return null;

        event.eventStream = eventStreams[schemeIdUri];
        event.eventStream.value = value;
        event.eventStream.timescale = timescale;
        event.duration = duration;
        event.id = id;
        event.presentationTime = presentationTime;
        event.messageData = messageData;
        event.presentationTimeDelta = presentationTimeDelta;

        return event;
    }

    function getEventsFor(manifest, info, streamProcessor) {
        var events = [];

        if (info instanceof _streamingVoStreamInfo2['default']) {
            events = dashManifestModel.getEventsForPeriod(manifest, getPeriodForStreamInfo(info));
        } else if (info instanceof _streamingVoMediaInfo2['default']) {
            events = dashManifestModel.getEventStreamForAdaptationSet(manifest, getAdaptationForMediaInfo(info));
        } else if (info instanceof _streamingVoTrackInfo2['default']) {
            events = dashManifestModel.getEventStreamForRepresentation(manifest, getRepresentationForTrackInfo(info, streamProcessor.getRepresentationController()));
        }

        return events;
    }

    function reset() {
        periods = [];
        adaptations = {};
    }

    instance = {
        initialize: initialize,
        convertDataToTrack: convertRepresentationToTrackInfo,
        convertDataToMedia: convertAdaptationToMediaInfo,
        convertDataToStream: convertPeriodToStreamInfo,
        getDataForTrack: getRepresentationForTrackInfo,
        getDataForMedia: getAdaptationForMediaInfo,
        getDataForStream: getPeriodForStreamInfo,
        getStreamsInfo: getStreamsInfo,
        getManifestInfo: getManifestInfo,
        getMediaInfoForType: getMediaInfoForType,
        getAllMediaInfoForType: getAllMediaInfoForType,
        getCurrentRepresentationInfo: getCurrentRepresentationInfo,
        getRepresentationInfoForQuality: getRepresentationInfoForQuality,
        updateData: updateData,
        getInitRequest: getInitRequest,
        getNextFragmentRequest: getNextFragmentRequest,
        getFragmentRequestForTime: getFragmentRequestForTime,
        generateFragmentRequestForTime: generateFragmentRequestForTime,
        getIndexHandlerTime: getIndexHandlerTime,
        setIndexHandlerTime: setIndexHandlerTime,
        getEventsFor: getEventsFor,
        getEvent: getEvent,
        setConfig: setConfig,
        reset: reset,
        metricsList: METRIC_LIST
    };

    return instance;
}

DashAdapter.__dashjs_factory_name = 'DashAdapter';
exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(DashAdapter);
module.exports = exports['default'];
//# sourceMappingURL=DashAdapter.js.map


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreEventBus = __webpack_require__(27);

var _coreEventBus2 = _interopRequireDefault(_coreEventBus);

var _coreEventsEvents = __webpack_require__(22);

var _coreEventsEvents2 = _interopRequireDefault(_coreEventsEvents);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

function TimelineConverter() {

    var context = this.context;
    var eventBus = (0, _coreEventBus2['default'])(context).getInstance();

    var instance = undefined,
        clientServerTimeShift = undefined,
        isClientServerTimeSyncCompleted = undefined,
        expectedLiveEdge = undefined;

    function initialize() {

        clientServerTimeShift = 0;
        isClientServerTimeSyncCompleted = false;
        expectedLiveEdge = NaN;
        eventBus.on(_coreEventsEvents2['default'].TIME_SYNCHRONIZATION_COMPLETED, onTimeSyncComplete, this);
    }

    function isTimeSyncCompleted() {
        return isClientServerTimeSyncCompleted;
    }

    function setTimeSyncCompleted(value) {
        isClientServerTimeSyncCompleted = value;
    }

    function getClientTimeOffset() {
        return clientServerTimeShift;
    }

    function setClientTimeOffset(value) {
        clientServerTimeShift = value;
    }

    function getExpectedLiveEdge() {
        return expectedLiveEdge;
    }

    function setExpectedLiveEdge(value) {
        expectedLiveEdge = value;
    }

    function calcAvailabilityTimeFromPresentationTime(presentationTime, mpd, isDynamic, calculateEnd) {
        var availabilityTime = NaN;

        if (calculateEnd) {
            //@timeShiftBufferDepth specifies the duration of the time shifting buffer that is guaranteed
            // to be available for a Media Presentation with type 'dynamic'.
            // When not present, the value is infinite.
            if (isDynamic && mpd.timeShiftBufferDepth != Number.POSITIVE_INFINITY) {
                availabilityTime = new Date(mpd.availabilityStartTime.getTime() + (presentationTime + mpd.timeShiftBufferDepth) * 1000);
            } else {
                availabilityTime = mpd.availabilityEndTime;
            }
        } else {
            if (isDynamic) {
                availabilityTime = new Date(mpd.availabilityStartTime.getTime() + (presentationTime - clientServerTimeShift) * 1000);
            } else {
                // in static mpd, all segments are available at the same time
                availabilityTime = mpd.availabilityStartTime;
            }
        }

        return availabilityTime;
    }

    function calcAvailabilityStartTimeFromPresentationTime(presentationTime, mpd, isDynamic) {
        return calcAvailabilityTimeFromPresentationTime.call(this, presentationTime, mpd, isDynamic);
    }

    function calcAvailabilityEndTimeFromPresentationTime(presentationTime, mpd, isDynamic) {
        return calcAvailabilityTimeFromPresentationTime.call(this, presentationTime, mpd, isDynamic, true);
    }

    function calcPresentationTimeFromWallTime(wallTime, period) {
        //console.log("XXX", wallTime.getTime() - period.mpd.availabilityStartTime.getTime(), clientServerTimeShift * 1000, clientServerTimeShift, period.mpd.availabilityStartTime.getTime())
        return (wallTime.getTime() - period.mpd.availabilityStartTime.getTime() + clientServerTimeShift * 1000) / 1000;
    }

    function calcPresentationTimeFromMediaTime(mediaTime, representation) {
        var periodStart = representation.adaptation.period.start;
        var presentationOffset = representation.presentationTimeOffset;

        return mediaTime + (periodStart - presentationOffset);
    }

    function calcMediaTimeFromPresentationTime(presentationTime, representation) {
        var periodStart = representation.adaptation.period.start;
        var presentationOffset = representation.presentationTimeOffset;

        return presentationTime - periodStart + presentationOffset;
    }

    function calcWallTimeForSegment(segment, isDynamic) {
        var suggestedPresentationDelay, displayStartTime, wallTime;

        if (isDynamic) {
            suggestedPresentationDelay = segment.representation.adaptation.period.mpd.suggestedPresentationDelay;
            displayStartTime = segment.presentationStartTime + suggestedPresentationDelay;
            wallTime = new Date(segment.availabilityStartTime.getTime() + displayStartTime * 1000);
        }

        return wallTime;
    }

    function calcSegmentAvailabilityRange(representation, isDynamic) {

        // Static Range Finder
        var period = representation.adaptation.period;
        var range = { start: period.start, end: period.start + period.duration };
        if (!isDynamic) return range;

        if (!isClientServerTimeSyncCompleted && representation.segmentAvailabilityRange) {
            return representation.segmentAvailabilityRange;
        }

        //Dyanmic Range Finder
        var d = representation.segmentDuration || (representation.segments && representation.segments.length ? representation.segments[representation.segments.length - 1].duration : 0);
        var now = calcPresentationTimeFromWallTime(new Date(), period);
        var periodEnd = period.start + period.duration;
        range.start = Math.max(now - period.mpd.timeShiftBufferDepth, period.start);
        range.end = now >= periodEnd && now - d < periodEnd ? periodEnd - d : now - d;

        return range;
    }

    function calcPeriodRelativeTimeFromMpdRelativeTime(representation, mpdRelativeTime) {
        var periodStartTime = representation.adaptation.period.start;
        return mpdRelativeTime - periodStartTime;
    }

    function calcMpdRelativeTimeFromPeriodRelativeTime(representation, periodRelativeTime) {
        var periodStartTime = representation.adaptation.period.start;

        return periodRelativeTime + periodStartTime;
    }

    /*
    * We need to figure out if we want to timesync for segmentTimeine where useCalculatedLiveEdge = true
    * seems we figure out client offset based on logic in liveEdgeFinder getLiveEdge timelineConverter.setClientTimeOffset(liveEdge - representationInfo.DVRWindow.end);
    * FYI StreamController's onManifestUpdated entry point to timeSync
    * */
    function onTimeSyncComplete(e) {

        if (isClientServerTimeSyncCompleted) return;

        if (e.offset !== undefined) {

            setClientTimeOffset(e.offset / 1000);
            isClientServerTimeSyncCompleted = true;
        }
    }

    function calcMSETimeOffset(representation) {
        // The MSEOffset is offset from AST for media. It is Period@start - presentationTimeOffset
        var presentationOffset = representation.presentationTimeOffset;
        var periodStart = representation.adaptation.period.start;
        return periodStart - presentationOffset;
    }

    function reset() {
        eventBus.off(_coreEventsEvents2['default'].TIME_SYNCHRONIZATION_COMPLETED, onTimeSyncComplete, this);
        clientServerTimeShift = 0;
        isClientServerTimeSyncCompleted = false;
        expectedLiveEdge = NaN;
    }

    instance = {
        initialize: initialize,
        isTimeSyncCompleted: isTimeSyncCompleted,
        setTimeSyncCompleted: setTimeSyncCompleted,
        getClientTimeOffset: getClientTimeOffset,
        setClientTimeOffset: setClientTimeOffset,
        getExpectedLiveEdge: getExpectedLiveEdge,
        setExpectedLiveEdge: setExpectedLiveEdge,
        calcAvailabilityStartTimeFromPresentationTime: calcAvailabilityStartTimeFromPresentationTime,
        calcAvailabilityEndTimeFromPresentationTime: calcAvailabilityEndTimeFromPresentationTime,
        calcPresentationTimeFromWallTime: calcPresentationTimeFromWallTime,
        calcPresentationTimeFromMediaTime: calcPresentationTimeFromMediaTime,
        calcPeriodRelativeTimeFromMpdRelativeTime: calcPeriodRelativeTimeFromMpdRelativeTime,
        calcMpdRelativeTimeFromPeriodRelativeTime: calcMpdRelativeTimeFromPeriodRelativeTime,
        calcMediaTimeFromPresentationTime: calcMediaTimeFromPresentationTime,
        calcSegmentAvailabilityRange: calcSegmentAvailabilityRange,
        calcWallTimeForSegment: calcWallTimeForSegment,
        calcMSETimeOffset: calcMSETimeOffset,
        reset: reset
    };

    return instance;
}

TimelineConverter.__dashjs_factory_name = 'TimelineConverter';
exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(TimelineConverter);
module.exports = exports['default'];
//# sourceMappingURL=TimelineConverter.js.map


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @class
 * @ignore
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var Representation = (function () {
    function Representation() {
        _classCallCheck(this, Representation);

        this.id = null;
        this.index = -1;
        this.adaptation = null;
        this.segmentInfoType = null;
        this.initialization = null;
        this.codecs = null;
        this.codecPrivateData = null;
        this.segmentDuration = NaN;
        this.timescale = 1;
        this.startNumber = 1;
        this.indexRange = null;
        this.range = null;
        this.presentationTimeOffset = 0;
        // Set the source buffer timeOffset to this
        this.MSETimeOffset = NaN;
        this.segmentAvailabilityRange = null;
        this.availableSegmentsNumber = 0;
        this.bandwidth = NaN;
        this.width = NaN;
        this.height = NaN;
        this.maxPlayoutRate = NaN;
    }

    _createClass(Representation, null, [{
        key: 'hasInitialization',
        value: function hasInitialization(r) {
            return r.initialization !== null || (r.segmentInfoType !== 'BaseURL' || r.segmentInfoType !== 'SegmentBase') && r.range !== null;
        }
    }, {
        key: 'hasSegments',
        value: function hasSegments(r) {
            return r.segmentInfoType !== 'BaseURL' && r.segmentInfoType !== 'SegmentBase' && !r.indexRange;
        }
    }]);

    return Representation;
})();

exports['default'] = Representation;
module.exports = exports['default'];
//# sourceMappingURL=Representation.js.map


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @class
 * @ignore
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Segment = function Segment() {
  _classCallCheck(this, Segment);

  this.indexRange = null;
  this.index = null;
  this.mediaRange = null;
  this.media = null;
  this.duration = NaN;
  // this is the time that should be inserted into the media url
  this.replacementTime = null;
  // this is the number that should be inserted into the media url
  this.replacementNumber = NaN;
  // This is supposed to match the time encoded in the media Segment
  this.mediaStartTime = NaN;
  // When the source buffer timeOffset is set to MSETimeOffset this is the
  // time that will match the seekTarget and video.currentTime
  this.presentationStartTime = NaN;
  // Do not schedule this segment until
  this.availabilityStartTime = NaN;
  // Ignore and  discard this segment after
  this.availabilityEndTime = NaN;
  // The index of the segment inside the availability window
  this.availabilityIdx = NaN;
  // For dynamic mpd's, this is the wall clock time that the video
  // element currentTime should be presentationStartTime
  this.wallStartTime = NaN;
  this.representation = null;
};

exports["default"] = Segment;
module.exports = exports["default"];
//# sourceMappingURL=Segment.js.map


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _PlaybackController = __webpack_require__(161);

var _PlaybackController2 = _interopRequireDefault(_PlaybackController);

var _Stream = __webpack_require__(1348);

var _Stream2 = _interopRequireDefault(_Stream);

var _ManifestUpdater = __webpack_require__(1346);

var _ManifestUpdater2 = _interopRequireDefault(_ManifestUpdater);

var _coreEventBus = __webpack_require__(27);

var _coreEventBus2 = _interopRequireDefault(_coreEventBus);

var _coreEventsEvents = __webpack_require__(22);

var _coreEventsEvents2 = _interopRequireDefault(_coreEventsEvents);

var _modelsURIQueryAndFragmentModel = __webpack_require__(399);

var _modelsURIQueryAndFragmentModel2 = _interopRequireDefault(_modelsURIQueryAndFragmentModel);

var _modelsVideoModel = __webpack_require__(240);

var _modelsVideoModel2 = _interopRequireDefault(_modelsVideoModel);

var _modelsMediaPlayerModel = __webpack_require__(67);

var _modelsMediaPlayerModel2 = _interopRequireDefault(_modelsMediaPlayerModel);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _voMetricsPlayList = __webpack_require__(600);

var _coreDebug = __webpack_require__(30);

var _coreDebug2 = _interopRequireDefault(_coreDebug);

var _utilsInitCache = __webpack_require__(408);

var _utilsInitCache2 = _interopRequireDefault(_utilsInitCache);

function StreamController() {

    var STREAM_END_THRESHOLD = 0.1;

    var context = this.context;
    var log = (0, _coreDebug2['default'])(context).getInstance().log;
    var eventBus = (0, _coreEventBus2['default'])(context).getInstance();

    var instance = undefined,
        capabilities = undefined,
        manifestUpdater = undefined,
        manifestLoader = undefined,
        manifestModel = undefined,
        dashManifestModel = undefined,
        adapter = undefined,
        metricsModel = undefined,
        dashMetrics = undefined,
        liveEdgeFinder = undefined,
        mediaSourceController = undefined,
        timeSyncController = undefined,
        baseURLController = undefined,
        initCache = undefined,
        errHandler = undefined,
        timelineConverter = undefined,
        streams = undefined,
        activeStream = undefined,
        protectionController = undefined,
        protectionData = undefined,
        autoPlay = undefined,
        isStreamSwitchingInProgress = undefined,
        isUpdating = undefined,
        hasMediaError = undefined,
        hasInitialisationError = undefined,
        mediaSource = undefined,
        videoModel = undefined,
        playbackController = undefined,
        mediaPlayerModel = undefined,
        isPaused = undefined,
        initialPlayback = undefined,
        playListMetrics = undefined,
        videoTrackDetected = undefined;

    function setup() {
        protectionController = null;
        streams = [];
        mediaPlayerModel = (0, _modelsMediaPlayerModel2['default'])(context).getInstance();
        autoPlay = true;
        isStreamSwitchingInProgress = false;
        isUpdating = false;
        isPaused = false;
        initialPlayback = true;
        playListMetrics = null;
        hasMediaError = false;
        hasInitialisationError = false;
    }

    function initialize(autoPl, protData) {
        autoPlay = autoPl;
        protectionData = protData;
        timelineConverter.initialize();
        initCache = (0, _utilsInitCache2['default'])(context).getInstance();

        manifestUpdater = (0, _ManifestUpdater2['default'])(context).getInstance();
        manifestUpdater.setConfig({
            manifestModel: manifestModel,
            dashManifestModel: dashManifestModel
        });
        manifestUpdater.initialize(manifestLoader);

        videoModel = (0, _modelsVideoModel2['default'])(context).getInstance();
        playbackController = (0, _PlaybackController2['default'])(context).getInstance();
        playbackController.setConfig({
            streamController: instance,
            timelineConverter: timelineConverter,
            metricsModel: metricsModel,
            dashMetrics: dashMetrics,
            manifestModel: manifestModel,
            dashManifestModel: dashManifestModel,
            adapter: adapter,
            videoModel: videoModel
        });

        eventBus.on(_coreEventsEvents2['default'].TIME_SYNCHRONIZATION_COMPLETED, onTimeSyncCompleted, this);
        eventBus.on(_coreEventsEvents2['default'].PLAYBACK_SEEKING, onPlaybackSeeking, this);
        eventBus.on(_coreEventsEvents2['default'].PLAYBACK_TIME_UPDATED, onPlaybackTimeUpdated, this);
        eventBus.on(_coreEventsEvents2['default'].PLAYBACK_ENDED, onEnded, this);
        eventBus.on(_coreEventsEvents2['default'].PLAYBACK_ERROR, onPlaybackError, this);
        eventBus.on(_coreEventsEvents2['default'].PLAYBACK_STARTED, onPlaybackStarted, this);
        eventBus.on(_coreEventsEvents2['default'].PLAYBACK_PAUSED, onPlaybackPaused, this);
        eventBus.on(_coreEventsEvents2['default'].MANIFEST_UPDATED, onManifestUpdated, this);
        eventBus.on(_coreEventsEvents2['default'].STREAM_BUFFERING_COMPLETED, onStreamBufferingCompleted, this);
    }

    /*
     * Called when current playback position is changed.
     * Used to determine the time current stream is finished and we should switch to the next stream.
     */
    function onPlaybackTimeUpdated(e) {

        if (isVideoTrackPresent()) {
            var playbackQuality = videoModel.getPlaybackQuality();
            if (playbackQuality) {
                metricsModel.addDroppedFrames('video', playbackQuality);
            }
        }

        // Sometimes after seeking timeUpdateHandler is called before seekingHandler and a new stream starts
        // from beginning instead of from a chosen position. So we do nothing if the player is in the seeking state
        if (playbackController.isSeeking()) return;

        if (e.timeToEnd <= STREAM_END_THRESHOLD) {
            //only needed for multiple period content when the native event does not fire due to duration manipulation.
            onEnded();
        }
    }

    function onPlaybackSeeking(e) {
        var seekingStream = getStreamForTime(e.seekTime);

        if (seekingStream && seekingStream !== activeStream) {
            flushPlaylistMetrics(_voMetricsPlayList.PlayListTrace.END_OF_PERIOD_STOP_REASON);
            switchStream(activeStream, seekingStream, e.seekTime);
        } else {
            flushPlaylistMetrics(_voMetricsPlayList.PlayListTrace.USER_REQUEST_STOP_REASON);
        }

        addPlaylistMetrics(_voMetricsPlayList.PlayList.SEEK_START_REASON);
    }

    function onPlaybackStarted() /*e*/{
        if (initialPlayback) {
            initialPlayback = false;
            addPlaylistMetrics(_voMetricsPlayList.PlayList.INITIAL_PLAYOUT_START_REASON);
        } else {
            if (isPaused) {
                isPaused = false;
                addPlaylistMetrics(_voMetricsPlayList.PlayList.RESUME_FROM_PAUSE_START_REASON);
            }
        }
    }

    function onPlaybackPaused(e) {
        if (!e.ended) {
            isPaused = true;
            flushPlaylistMetrics(_voMetricsPlayList.PlayListTrace.USER_REQUEST_STOP_REASON);
        }
    }

    function onStreamBufferingCompleted() {
        var isLast = getActiveStreamInfo().isLast;
        if (mediaSource && isLast) {
            mediaSourceController.signalEndOfStream(mediaSource);
        }
    }

    function getStreamForTime(time) {
        var duration = 0;
        var stream = null;

        var ln = streams.length;

        if (ln > 0) {
            duration += streams[0].getStartTime();
        }

        for (var i = 0; i < ln; i++) {
            stream = streams[i];
            duration += stream.getDuration();

            if (time < duration) {
                return stream;
            }
        }

        return null;
    }

    /**
     * Returns a playhead time, in seconds, converted to be relative
     * to the start of an identified stream/period or null if no such stream
     * @param {number} time
     * @param {string} id
     * @returns {number|null}
     */
    function getTimeRelativeToStreamId(time, id) {
        var stream = null;
        var baseStart = 0;
        var streamStart = 0;
        var streamDur = null;

        var ln = streams.length;

        for (var i = 0; i < ln; i++) {
            stream = streams[i];
            streamStart = stream.getStartTime();
            streamDur = stream.getDuration();

            // use start time, if not undefined or NaN or similar
            if (Number.isFinite(streamStart)) {
                baseStart = streamStart;
            }

            if (stream.getId() === id) {
                return time - baseStart;
            } else {
                // use duration if not undefined or NaN or similar
                if (Number.isFinite(streamDur)) {
                    baseStart += streamDur;
                }
            }
        }

        return null;
    }

    function getActiveStreamCommonEarliestTime() {
        var commonEarliestTime = [];
        activeStream.getProcessors().forEach(function (p) {
            commonEarliestTime.push(p.getIndexHandler().getEarliestTime());
        });
        return Math.min.apply(Math, commonEarliestTime);
    }

    function onEnded() {
        var nextStream = getNextStream();
        if (nextStream) {
            switchStream(activeStream, nextStream, NaN);
        }
        flushPlaylistMetrics(nextStream ? _voMetricsPlayList.PlayListTrace.END_OF_PERIOD_STOP_REASON : _voMetricsPlayList.PlayListTrace.END_OF_CONTENT_STOP_REASON);
    }

    function getNextStream() {
        if (activeStream) {
            var _ret = (function () {
                var start = activeStream.getStreamInfo().start;
                var duration = activeStream.getStreamInfo().duration;

                return {
                    v: streams.filter(function (stream) {
                        return stream.getStreamInfo().start === start + duration;
                    })[0]
                };
            })();

            if (typeof _ret === 'object') return _ret.v;
        }
    }

    function switchStream(oldStream, newStream, seekTime) {

        if (isStreamSwitchingInProgress || !newStream || oldStream === newStream) return;
        isStreamSwitchingInProgress = true;

        eventBus.trigger(_coreEventsEvents2['default'].PERIOD_SWITCH_STARTED, {
            fromStreamInfo: oldStream ? oldStream.getStreamInfo() : null,
            toStreamInfo: newStream.getStreamInfo()
        });

        if (oldStream) oldStream.deactivate();
        activeStream = newStream;
        playbackController.initialize(activeStream.getStreamInfo());

        //TODO detect if we should close and repose or jump to activateStream.
        openMediaSource(seekTime);
    }

    function openMediaSource(seekTime) {

        var sourceUrl = undefined;

        function onMediaSourceOpen() {
            log('MediaSource is open!');
            window.URL.revokeObjectURL(sourceUrl);
            mediaSource.removeEventListener('sourceopen', onMediaSourceOpen);
            mediaSource.removeEventListener('webkitsourceopen', onMediaSourceOpen);
            setMediaDuration();
            activateStream(seekTime);
        }

        if (!mediaSource) {
            mediaSource = mediaSourceController.createMediaSource();
        } else {
            mediaSourceController.detachMediaSource(videoModel);
        }

        mediaSource.addEventListener('sourceopen', onMediaSourceOpen, false);
        mediaSource.addEventListener('webkitsourceopen', onMediaSourceOpen, false);
        sourceUrl = mediaSourceController.attachMediaSource(mediaSource, videoModel);
        log('MediaSource attached to element.  Waiting on open...');
    }

    function activateStream(seekTime) {

        activeStream.activate(mediaSource);

        if (!initialPlayback) {
            if (!isNaN(seekTime)) {
                playbackController.seek(seekTime); //we only need to call seek here, IndexHandlerTime was set from seeking event
            } else {
                    (function () {
                        var startTime = playbackController.getStreamStartTime(true);
                        activeStream.getProcessors().forEach(function (p) {
                            adapter.setIndexHandlerTime(p, startTime);
                        });
                        playbackController.seek(startTime); //seek to period start time
                    })();
                }
        } else {
                videoTrackDetected = checkVideoPresence();
            }

        activeStream.startEventController();
        if (autoPlay || !initialPlayback) {
            playbackController.play();
        }

        isStreamSwitchingInProgress = false;
        eventBus.trigger(_coreEventsEvents2['default'].PERIOD_SWITCH_COMPLETED, { toStreamInfo: activeStream.getStreamInfo() });
    }

    function setMediaDuration() {
        var manifestDuration = activeStream.getStreamInfo().manifestInfo.duration;
        var mediaDuration = mediaSourceController.setDuration(mediaSource, manifestDuration);
        log('Duration successfully set to: ' + mediaDuration);
    }

    function getComposedStream(streamInfo) {
        for (var i = 0, ln = streams.length; i < ln; i++) {
            if (streams[i].getId() === streamInfo.id) {
                return streams[i];
            }
        }
        return null;
    }

    function composeStreams(manifest) {

        try {
            var streamsInfo = adapter.getStreamsInfo(manifest);
            if (streamsInfo.length === 0) {
                throw new Error('There are no streams');
            }

            var manifestUpdateInfo = dashMetrics.getCurrentManifestUpdate(metricsModel.getMetricsFor('stream'));
            metricsModel.updateManifestUpdateInfo(manifestUpdateInfo, {
                currentTime: playbackController.getTime(),
                buffered: videoModel.getElement().buffered,
                presentationStartTime: streamsInfo[0].start,
                clientTimeOffset: timelineConverter.getClientTimeOffset()
            });

            for (var i = 0, ln = streamsInfo.length; i < ln; i++) {

                // If the Stream object does not exist we probably loaded the manifest the first time or it was
                // introduced in the updated manifest, so we need to create a new Stream and perform all the initialization operations
                var streamInfo = streamsInfo[i];
                var stream = getComposedStream(streamInfo);

                if (!stream) {

                    stream = (0, _Stream2['default'])(context).create({
                        manifestModel: manifestModel,
                        manifestUpdater: manifestUpdater,
                        adapter: adapter,
                        timelineConverter: timelineConverter,
                        capabilities: capabilities,
                        errHandler: errHandler,
                        baseURLController: baseURLController
                    });
                    streams.push(stream);
                    stream.initialize(streamInfo, protectionController);
                } else {
                    stream.updateData(streamInfo);
                }

                metricsModel.addManifestUpdateStreamInfo(manifestUpdateInfo, streamInfo.id, streamInfo.index, streamInfo.start, streamInfo.duration);
            }

            if (!activeStream) {
                //const initStream = streamsInfo[0].manifestInfo.isDynamic ? streams[streams.length -1] : streams[0];
                //TODO we need to figure out what the correct starting period is here and not just go to first or last in array.
                switchStream(null, streams[0], NaN);
            }

            eventBus.trigger(_coreEventsEvents2['default'].STREAMS_COMPOSED);
        } catch (e) {
            errHandler.manifestError(e.message, 'nostreamscomposed', manifest);
            hasInitialisationError = true;
            reset();
        }
    }

    function onTimeSyncCompleted() /*e*/{
        var manifest = manifestModel.getValue();
        //TODO check if we can move this to initialize??
        if (protectionController) {
            eventBus.trigger(_coreEventsEvents2['default'].PROTECTION_CREATED, { controller: protectionController, manifest: manifest });
            protectionController.setMediaElement(videoModel.getElement());
            if (protectionData) {
                protectionController.setProtectionData(protectionData);
            }
        }

        composeStreams(manifest);
    }

    function onManifestUpdated(e) {
        if (!e.error) {
            //Since streams are not composed yet , need to manually look up useCalculatedLiveEdgeTime to detect if stream
            //is SegmentTimeline to avoid using time source
            var manifest = e.manifest;
            var streamInfo = adapter.getStreamsInfo(manifest)[0];
            var mediaInfo = adapter.getMediaInfoForType(manifest, streamInfo, 'video') || adapter.getMediaInfoForType(manifest, streamInfo, 'audio');

            var adaptation, useCalculatedLiveEdgeTime;

            if (mediaInfo) {
                adaptation = adapter.getDataForMedia(mediaInfo);
                useCalculatedLiveEdgeTime = dashManifestModel.getRepresentationsForAdaptation(manifest, adaptation)[0].useCalculatedLiveEdgeTime;

                if (useCalculatedLiveEdgeTime) {
                    log('SegmentTimeline detected using calculated Live Edge Time');
                    mediaPlayerModel.setUseManifestDateHeaderTimeSource(false);
                }
            }

            var manifestUTCTimingSources = dashManifestModel.getUTCTimingSources(e.manifest);
            var allUTCTimingSources = !dashManifestModel.getIsDynamic(manifest) || useCalculatedLiveEdgeTime ? manifestUTCTimingSources : manifestUTCTimingSources.concat(mediaPlayerModel.getUTCTimingSources());
            var isHTTPS = (0, _modelsURIQueryAndFragmentModel2['default'])(context).getInstance().isManifestHTTPS();

            //If https is detected on manifest then lets apply that protocol to only the default time source(s). In the future we may find the need to apply this to more then just default so left code at this level instead of in MediaPlayer.
            allUTCTimingSources.forEach(function (item) {
                if (item.value.replace(/.*?:\/\//g, '') === _modelsMediaPlayerModel2['default'].DEFAULT_UTC_TIMING_SOURCE.value.replace(/.*?:\/\//g, '')) {
                    item.value = item.value.replace(isHTTPS ? new RegExp(/^(http:)?\/\//i) : new RegExp(/^(https:)?\/\//i), isHTTPS ? 'https://' : 'http://');
                    log('Matching default timing source protocol to manifest protocol: ', item.value);
                }
            });

            baseURLController.initialize(manifest);

            timeSyncController.setConfig({
                metricsModel: metricsModel,
                dashMetrics: dashMetrics
            });
            timeSyncController.initialize(allUTCTimingSources, mediaPlayerModel.getUseManifestDateHeaderTimeSource());
        } else {
            hasInitialisationError = true;
            reset();
        }
    }

    function isVideoTrackPresent() {
        if (videoTrackDetected === undefined) {
            videoTrackDetected = checkVideoPresence();
        }
        return videoTrackDetected;
    }

    function checkVideoPresence() {
        var isVideoDetected = false;
        activeStream.getProcessors().forEach(function (p) {
            if (p.getMediaInfo().type === 'video') {
                isVideoDetected = true;
            }
        });
        return isVideoDetected;
    }

    function flushPlaylistMetrics(reason, time) {
        time = time || new Date();

        if (playListMetrics) {
            if (activeStream) {
                activeStream.getProcessors().forEach(function (p) {
                    var ctrlr = p.getScheduleController();
                    if (ctrlr) {
                        ctrlr.finalisePlayList(time, reason);
                    }
                });
            }
            metricsModel.addPlayList(playListMetrics);
            playListMetrics = null;
        }
    }

    function addPlaylistMetrics(startReason) {
        playListMetrics = new _voMetricsPlayList.PlayList();
        playListMetrics.start = new Date();
        playListMetrics.mstart = playbackController.getTime() * 1000;
        playListMetrics.starttype = startReason;

        if (activeStream) {
            activeStream.getProcessors().forEach(function (p) {
                var ctrlr = p.getScheduleController();
                if (ctrlr) {
                    ctrlr.setPlayList(playListMetrics);
                }
            });
        }
    }

    function onPlaybackError(e) {

        if (!e.error) return;

        var msg = '';

        switch (e.error.code) {
            case 1:
                msg = 'MEDIA_ERR_ABORTED';
                break;
            case 2:
                msg = 'MEDIA_ERR_NETWORK';
                break;
            case 3:
                msg = 'MEDIA_ERR_DECODE';
                break;
            case 4:
                msg = 'MEDIA_ERR_SRC_NOT_SUPPORTED';
                break;
            case 5:
                msg = 'MEDIA_ERR_ENCRYPTED';
                break;
            default:
                msg = 'UNKNOWN';
                break;
        }

        hasMediaError = true;

        if (e.error.message) {
            msg += ' (' + e.error.message + ')';
        }

        if (e.error.msExtendedCode) {
            msg += ' (0x' + (e.error.msExtendedCode >>> 0).toString(16).toUpperCase() + ')';
        }

        log('Video Element Error: ' + msg);
        if (e.error) {
            log(e.error);
        }
        errHandler.mediaSourceError(msg);
        reset();
    }

    function getAutoPlay() {
        return autoPlay;
    }

    function getActiveStreamInfo() {
        return activeStream ? activeStream.getStreamInfo() : null;
    }

    function isStreamActive(streamInfo) {
        return activeStream.getId() === streamInfo.id;
    }

    function getStreamById(id) {
        return streams.filter(function (item) {
            return item.getId() === id;
        })[0];
    }

    function load(url) {
        manifestLoader.load(url);
    }

    function loadWithManifest(manifest) {
        manifestUpdater.setManifest(manifest);
    }

    function setConfig(config) {
        if (!config) return;

        if (config.capabilities) {
            capabilities = config.capabilities;
        }
        if (config.manifestLoader) {
            manifestLoader = config.manifestLoader;
        }
        if (config.manifestModel) {
            manifestModel = config.manifestModel;
        }
        if (config.dashManifestModel) {
            dashManifestModel = config.dashManifestModel;
        }
        if (config.protectionController) {
            protectionController = config.protectionController;
        }
        if (config.adapter) {
            adapter = config.adapter;
        }
        if (config.metricsModel) {
            metricsModel = config.metricsModel;
        }
        if (config.dashMetrics) {
            dashMetrics = config.dashMetrics;
        }
        if (config.liveEdgeFinder) {
            liveEdgeFinder = config.liveEdgeFinder;
        }
        if (config.mediaSourceController) {
            mediaSourceController = config.mediaSourceController;
        }
        if (config.timeSyncController) {
            timeSyncController = config.timeSyncController;
        }
        if (config.baseURLController) {
            baseURLController = config.baseURLController;
        }
        if (config.errHandler) {
            errHandler = config.errHandler;
        }
        if (config.timelineConverter) {
            timelineConverter = config.timelineConverter;
        }
    }

    function reset() {
        timeSyncController.reset();

        flushPlaylistMetrics(hasMediaError || hasInitialisationError ? _voMetricsPlayList.PlayListTrace.FAILURE_STOP_REASON : _voMetricsPlayList.PlayListTrace.USER_REQUEST_STOP_REASON);

        for (var i = 0, ln = streams.length; i < ln; i++) {
            var stream = streams[i];
            stream.reset(hasMediaError);
        }

        streams = [];

        eventBus.off(_coreEventsEvents2['default'].PLAYBACK_TIME_UPDATED, onPlaybackTimeUpdated, this);
        eventBus.off(_coreEventsEvents2['default'].PLAYBACK_SEEKING, onPlaybackSeeking, this);
        eventBus.off(_coreEventsEvents2['default'].PLAYBACK_ERROR, onPlaybackError, this);
        eventBus.off(_coreEventsEvents2['default'].PLAYBACK_STARTED, onPlaybackStarted, this);
        eventBus.off(_coreEventsEvents2['default'].PLAYBACK_PAUSED, onPlaybackPaused, this);
        eventBus.off(_coreEventsEvents2['default'].PLAYBACK_ENDED, onEnded, this);
        eventBus.off(_coreEventsEvents2['default'].MANIFEST_UPDATED, onManifestUpdated, this);
        eventBus.off(_coreEventsEvents2['default'].STREAM_BUFFERING_COMPLETED, onStreamBufferingCompleted, this);

        baseURLController.reset();
        manifestUpdater.reset();
        metricsModel.clearAllCurrentMetrics();
        manifestModel.setValue(null);
        manifestLoader.reset();
        timelineConverter.reset();
        liveEdgeFinder.reset();
        adapter.reset();
        initCache.reset();
        isStreamSwitchingInProgress = false;
        isUpdating = false;
        activeStream = null;
        hasMediaError = false;
        hasInitialisationError = false;
        videoTrackDetected = undefined;
        initialPlayback = true;
        isPaused = false;

        if (mediaSource) {
            mediaSourceController.detachMediaSource(videoModel);
            mediaSource = null;
        }
        videoModel = null;
        if (protectionController) {
            protectionController.setMediaElement(null);
            protectionController = null;
            protectionData = null;
            if (manifestModel.getValue()) {
                eventBus.trigger(_coreEventsEvents2['default'].PROTECTION_DESTROYED, { data: manifestModel.getValue().url });
            }
        }

        eventBus.trigger(_coreEventsEvents2['default'].STREAM_TEARDOWN_COMPLETE);
    }

    instance = {
        initialize: initialize,
        getAutoPlay: getAutoPlay,
        getActiveStreamInfo: getActiveStreamInfo,
        isStreamActive: isStreamActive,
        isVideoTrackPresent: isVideoTrackPresent,
        getStreamById: getStreamById,
        getTimeRelativeToStreamId: getTimeRelativeToStreamId,
        load: load,
        loadWithManifest: loadWithManifest,
        getActiveStreamCommonEarliestTime: getActiveStreamCommonEarliestTime,
        setConfig: setConfig,
        reset: reset
    };

    setup();

    return instance;
}

StreamController.__dashjs_factory_name = 'StreamController';

exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(StreamController);
module.exports = exports['default'];
//# sourceMappingURL=StreamController.js.map


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _voURIFragmentData = __webpack_require__(1427);

var _voURIFragmentData2 = _interopRequireDefault(_voURIFragmentData);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

function URIQueryAndFragmentModel() {

    var instance = undefined,
        URIFragmentDataVO = undefined,
        URIQueryData = undefined,
        isHTTPS = undefined;

    function initialize() {
        URIFragmentDataVO = new _voURIFragmentData2['default']();
        URIQueryData = [];
        isHTTPS = false;
    }

    function getURIFragmentData() {
        return URIFragmentDataVO;
    }

    function getURIQueryData() {
        return URIQueryData;
    }

    function isManifestHTTPS() {
        return isHTTPS;
    }

    function parseURI(uri) {
        if (!uri) return null;

        var URIFragmentData = [];
        var mappedArr;

        var testQuery = new RegExp(/[?]/);
        var testFragment = new RegExp(/[#]/);
        var testHTTPS = new RegExp(/^(https:)?\/\//i);
        var isQuery = testQuery.test(uri);
        var isFragment = testFragment.test(uri);

        isHTTPS = testHTTPS.test(uri);

        function reduceArray(previousValue, currentValue, index, array) {
            var arr = array[0].split(/[=]/);
            array.push({ key: arr[0], value: arr[1] });
            array.shift();
            return array;
        }

        function mapArray(currentValue, index, array) {
            if (index > 0) {
                if (isQuery && URIQueryData.length === 0) {
                    URIQueryData = array[index].split(/[&]/);
                } else if (isFragment) {
                    URIFragmentData = array[index].split(/[&]/);
                }
            }

            return array;
        }

        mappedArr = uri.split(/[?#]/).map(mapArray);

        if (URIQueryData.length > 0) {
            URIQueryData = URIQueryData.reduce(reduceArray, null);
        }

        if (URIFragmentData.length > 0) {
            URIFragmentData = URIFragmentData.reduce(reduceArray, null);
            URIFragmentData.forEach(function (object) {
                URIFragmentDataVO[object.key] = object.value;
            });
        }

        return uri;
    }

    instance = {
        initialize: initialize,
        parseURI: parseURI,
        getURIFragmentData: getURIFragmentData,
        getURIQueryData: getURIQueryData,
        isManifestHTTPS: isManifestHTTPS
    };

    return instance;
}

URIQueryAndFragmentModel.__dashjs_factory_name = 'URIQueryAndFragmentModel';
exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(URIQueryAndFragmentModel);
module.exports = exports['default'];
//# sourceMappingURL=URIQueryAndFragmentModel.js.map


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @classdesc EME-independent KeyError
 * @ignore
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KeyError =
/**
 * @param {Object} sessionToken the key session to which this error is associated
 * @param {string} errorString an informational error message
 * @class
 * @deprecated Newest versions of EME APIs will not use this error object
 */
function KeyError(sessionToken, errorString) {
  _classCallCheck(this, KeyError);

  this.sessionToken = sessionToken;
  this.error = errorString;
};

exports["default"] = KeyError;
module.exports = exports["default"];
//# sourceMappingURL=KeyError.js.map


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @classdesc EME-independent KeyMessage
 * @ignore
 */


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var KeyMessage =
/**
 * @param {SessionToken} sessionToken the session
 * to which the key message is associated
 * @param {ArrayBuffer} message the key message
 * @param {string} defaultURL license acquisition URL provided by the CDM
 * @param {string} messageType Supported message types can be found
 * {@link https://w3c.github.io/encrypted-media/#idl-def-MediaKeyMessageType|here}.
 * @class
 */
function KeyMessage(sessionToken, message, defaultURL, messageType) {
  _classCallCheck(this, KeyMessage);

  this.sessionToken = sessionToken;
  this.message = message;
  this.defaultURL = defaultURL;
  this.messageType = messageType ? messageType : 'license-request';
};

exports['default'] = KeyMessage;
module.exports = exports['default'];
//# sourceMappingURL=KeyMessage.js.map


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @classdesc Creates a new key system access token.  Represents a valid key system for
 * given piece of content and key system requirements.  Used to initialize license
 * acquisition operations.
 * @ignore
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KeySystemAccess =
/**
 * @param {MediaPlayer.dependencies.protection.KeySystem} keySystem the key system
 * @param {KeySystemConfiguration} ksConfiguration the
 * subset of configurations passed to the key system access request that are supported
 * by this user agent
 * @class
 * @ignore
 */
function KeySystemAccess(keySystem, ksConfiguration) {
  _classCallCheck(this, KeySystemAccess);

  this.keySystem = keySystem;
  this.ksConfiguration = ksConfiguration;
};

exports["default"] = KeySystemAccess;
module.exports = exports["default"];
//# sourceMappingURL=KeySystemAccess.js.map


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @classdesc Represents a set of configurations that describe the capabilities desired for
 *  support by a given CDM
 * @ignore
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var KeySystemConfiguration =
/**
 * @param {Array.<MediaCapability>} audioCapabilities array of
 * desired audio capabilities.  Higher preference capabilities should be placed earlier
 * in the array.
 * @param {Array.<MediaCapability>} videoCapabilities array of
 * desired video capabilities.  Higher preference capabilities should be placed earlier
 * in the array.
 * @param {string} distinctiveIdentifier desired use of distinctive identifiers.
 * One of "required", "optional", or "not-allowed"
 * @param {string} persistentState desired support for persistent storage of
 * key systems.  One of "required", "optional", or "not-allowed"
 * @param {Array.<string>} sessionTypes List of session types that must
 * be supported by the key system
 * @class
 */
function KeySystemConfiguration(audioCapabilities, videoCapabilities, distinctiveIdentifier, persistentState, sessionTypes) {
    _classCallCheck(this, KeySystemConfiguration);

    this.initDataTypes = ['cenc'];
    if (audioCapabilities && audioCapabilities.length) {
        this.audioCapabilities = audioCapabilities;
    }
    if (videoCapabilities && videoCapabilities.length) {
        this.videoCapabilities = videoCapabilities;
    }
    this.distinctiveIdentifier = distinctiveIdentifier;
    this.persistentState = persistentState;
    this.sessionTypes = sessionTypes;
};

exports['default'] = KeySystemConfiguration;
module.exports = exports['default'];
//# sourceMappingURL=KeySystemConfiguration.js.map


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @classdesc NeedKey
 * @ignore
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var NeedKey =
/**
 * @param {ArrayBuffer} initData the initialization data
 * @param {string} initDataType initialization data type
 * @class
 */
function NeedKey(initData, initDataType) {
  _classCallCheck(this, NeedKey);

  this.initData = initData;
  this.initDataType = initDataType;
};

exports["default"] = NeedKey;
module.exports = exports["default"];
//# sourceMappingURL=NeedKey.js.map


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreEventBus = __webpack_require__(27);

var _coreEventBus2 = _interopRequireDefault(_coreEventBus);

var _coreEventsEvents = __webpack_require__(22);

var _coreEventsEvents2 = _interopRequireDefault(_coreEventsEvents);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _coreDebug = __webpack_require__(30);

var _coreDebug2 = _interopRequireDefault(_coreDebug);

function TextTracks() {

    var context = this.context;
    var eventBus = (0, _coreEventBus2['default'])(context).getInstance();
    var log = (0, _coreDebug2['default'])(context).getInstance().log;

    var instance = undefined,
        Cue = undefined,
        videoModel = undefined,
        video = undefined,
        textTrackQueue = undefined,
        trackElementArr = undefined,
        currentTrackIdx = undefined,
        actualVideoLeft = undefined,
        actualVideoTop = undefined,
        actualVideoWidth = undefined,
        actualVideoHeight = undefined,
        captionContainer = undefined,
        videoSizeCheckInterval = undefined,
        isChrome = undefined,
        fullscreenAttribute = undefined,
        displayCCOnTop = undefined,
        topZIndex = undefined;

    function initialize() {
        if (typeof window === 'undefined' || typeof navigator === 'undefined') {
            return;
        }

        Cue = window.VTTCue || window.TextTrackCue;
        textTrackQueue = [];
        trackElementArr = [];
        currentTrackIdx = -1;
        actualVideoLeft = 0;
        actualVideoTop = 0;
        actualVideoWidth = 0;
        actualVideoHeight = 0;
        captionContainer = null;
        videoSizeCheckInterval = null;
        displayCCOnTop = false;
        topZIndex = 2147483647;

        //TODO Check if IE has resolved issues: Then revert to not using the addTextTrack API for all browsers.
        // https://connect.microsoft.com/IE/feedbackdetail/view/1660701/text-tracks-do-not-fire-change-addtrack-or-removetrack-events
        // https://connect.microsoft.com/IE/feedback/details/1573380/htmltrackelement-track-addcue-throws-invalidstateerror-when-adding-new-cue
        // Same issue with Firefox.
        //isIE11orEdge = !!navigator.userAgent.match(/Trident.*rv[ :]*11\./) || navigator.userAgent.match(/Edge/);
        //isFirefox = !!navigator.userAgent.match(/Firefox/);
        isChrome = !!navigator.userAgent.match(/Chrome/) && !navigator.userAgent.match(/Edge/);
        if (document.fullscreenElement !== undefined) {
            fullscreenAttribute = 'fullscreenElement'; // Standard and Edge
        } else if (document.webkitIsFullScreen !== undefined) {
                fullscreenAttribute = 'webkitIsFullScreen'; // Chrome and Safari (and Edge)
            } else if (document.msFullscreenElement) {
                    // IE11
                    fullscreenAttribute = 'msFullscreenElement';
                } else if (document.mozFullScreen) {
                    // Firefox
                    fullscreenAttribute = 'mozFullScreen';
                }
    }

    function createTrackForUserAgent(i) {
        var kind = textTrackQueue[i].kind;
        var label = textTrackQueue[i].label !== undefined ? textTrackQueue[i].label : textTrackQueue[i].lang;
        var lang = textTrackQueue[i].lang;
        var track = isChrome ? document.createElement('track') : video.addTextTrack(kind, label, lang);

        if (isChrome) {
            track.kind = kind;
            track.label = label;
            track.srclang = lang;
        }

        return track;
    }

    function displayCConTop(value) {
        displayCCOnTop = value;
        if (!captionContainer || document[fullscreenAttribute]) {
            return;
        }
        captionContainer.style.zIndex = value ? topZIndex : null;
    }

    function addTextTrack(textTrackInfoVO, totalTextTracks) {

        if (textTrackQueue.length === totalTextTracks) {
            log('Trying to add too many tracks.');
            return;
        }

        textTrackQueue.push(textTrackInfoVO);
        if (video === undefined) {
            video = textTrackInfoVO.video;
        }

        if (textTrackQueue.length === totalTextTracks) {
            textTrackQueue.sort(function (a, b) {
                //Sort in same order as in manifest
                return a.index - b.index;
            });
            captionContainer = videoModel.getTTMLRenderingDiv();
            var defaultIndex = -1;
            for (var i = 0; i < textTrackQueue.length; i++) {
                var track = createTrackForUserAgent.call(this, i);
                trackElementArr.push(track); //used to remove tracks from video element when added manually

                if (textTrackQueue[i].defaultTrack) {
                    // track.default is an object property identifier that is a reserved word
                    // The following jshint directive is used to suppressed the warning "Expected an identifier and instead saw 'default' (a reserved word)"
                    /*jshint -W024 */
                    track['default'] = true;
                    defaultIndex = i;
                }
                if (isChrome) {
                    video.appendChild(track);
                }
                var textTrack = video.textTracks[i];
                textTrack.nonAddedCues = [];
                if (captionContainer && (textTrackQueue[i].isTTML || textTrackQueue[i].isEmbedded)) {
                    textTrack.renderingType = 'html';
                } else {
                    textTrack.renderingType = 'default';
                }
                this.addCaptions(i, 0, textTrackQueue[i].captionData);
                eventBus.trigger(_coreEventsEvents2['default'].TEXT_TRACK_ADDED);
            }
            setCurrentTrackIdx.call(this, defaultIndex);
            if (defaultIndex >= 0) {
                for (var idx = 0; idx < video.textTracks.length; idx++) {
                    video.textTracks[idx].mode = idx === defaultIndex ? 'showing' : 'hidden';
                }
                this.addCaptions(defaultIndex, 0, null);
            }
            eventBus.trigger(_coreEventsEvents2['default'].TEXT_TRACKS_ADDED, {
                index: currentTrackIdx,
                tracks: textTrackQueue
            }); //send default idx.
        }
    }

    function getVideoVisibleVideoSize(viewWidth, viewHeight, videoWidth, videoHeight, aspectRatio, use80Percent) {
        var viewAspectRatio = viewWidth / viewHeight;
        var videoAspectRatio = videoWidth / videoHeight;

        var videoPictureWidth = 0;
        var videoPictureHeight = 0;

        if (viewAspectRatio > videoAspectRatio) {
            videoPictureHeight = viewHeight;
            videoPictureWidth = videoPictureHeight / videoHeight * videoWidth;
        } else {
            videoPictureWidth = viewWidth;
            videoPictureHeight = videoPictureWidth / videoWidth * videoHeight;
        }

        var videoPictureXAspect = 0;
        var videoPictureYAspect = 0;
        var videoPictureWidthAspect = 0;
        var videoPictureHeightAspect = 0;
        var videoPictureAspect = videoPictureWidth / videoPictureHeight;

        if (videoPictureAspect > aspectRatio) {
            videoPictureHeightAspect = videoPictureHeight;
            videoPictureWidthAspect = videoPictureHeight / (1 / aspectRatio);
            videoPictureXAspect = (viewWidth - videoPictureWidthAspect) / 2;
            videoPictureYAspect = 0;
        } else {
            videoPictureWidthAspect = videoPictureWidth;
            videoPictureHeightAspect = videoPictureWidth / aspectRatio;
            videoPictureXAspect = 0;
            videoPictureYAspect = (viewHeight - videoPictureHeightAspect) / 2;
        }

        if (use80Percent) {
            return {
                x: videoPictureXAspect + videoPictureWidthAspect * 0.1,
                y: videoPictureYAspect + videoPictureHeightAspect * 0.1,
                w: videoPictureWidthAspect * 0.8,
                h: videoPictureHeightAspect * 0.8
            }; /* Maximal picture size in videos aspect ratio */
        } else {
                return {
                    x: videoPictureXAspect,
                    y: videoPictureYAspect,
                    w: videoPictureWidthAspect,
                    h: videoPictureHeightAspect
                }; /* Maximal picture size in videos aspect ratio */
            }
    }

    function checkVideoSize() {
        var track = this.getCurrentTextTrack();
        if (track && track.renderingType === 'html') {
            var aspectRatio = video.clientWidth / video.clientHeight;
            var use80Percent = false;
            if (track.isFromCEA608) {
                // If this is CEA608 then use predefined aspect ratio
                aspectRatio = 3.5 / 3.0;
                use80Percent = true;
            }

            var realVideoSize = getVideoVisibleVideoSize.call(this, video.clientWidth, video.clientHeight, video.videoWidth, video.videoHeight, aspectRatio, use80Percent);

            var newVideoWidth = realVideoSize.w;
            var newVideoHeight = realVideoSize.h;

            if (newVideoWidth != actualVideoWidth || newVideoHeight != actualVideoHeight) {
                actualVideoLeft = realVideoSize.x;
                actualVideoTop = realVideoSize.y;
                actualVideoWidth = newVideoWidth;
                actualVideoHeight = newVideoHeight;
                captionContainer.style.left = actualVideoLeft + 'px';
                captionContainer.style.top = actualVideoTop + 'px';
                captionContainer.style.width = actualVideoWidth + 'px';
                captionContainer.style.height = actualVideoHeight + 'px';

                // Video view has changed size, so resize any active cues
                for (var i = 0; track.activeCues && i < track.activeCues.length; ++i) {
                    var cue = track.activeCues[i];
                    cue.scaleCue(cue);
                }

                if (fullscreenAttribute && document[fullscreenAttribute] || displayCCOnTop) {
                    captionContainer.style.zIndex = topZIndex;
                } else {
                    captionContainer.style.zIndex = null;
                }
            }
        }
    }

    function convertToPixels(percentage, pixelMeasure) {
        var percentString = Math.round(0.01 * percentage * pixelMeasure).toString() + 'px';
        return percentString;
    }

    function scaleImageCue(activeCue) {
        var videoWidth = actualVideoWidth;
        var videoHeight = actualVideoHeight;

        if (videoWidth * videoHeight === 0) {
            return; //At least one of the measures is still zero
        }

        if (activeCue.layout) {
            var layout = activeCue.layout;
            var left = convertToPixels(layout.left, videoWidth);
            var _top = convertToPixels(layout.top, videoHeight);
            var width = convertToPixels(layout.width, videoWidth);
            var height = convertToPixels(layout.height, videoHeight);
            captionContainer.style.left = left;
            captionContainer.style.top = _top;
            captionContainer.style.width = width;
            captionContainer.style.height = height;
            var image = captionContainer.firstChild;
            if (image && image.style) {
                image.style.left = '0px';
                image.style.top = '0px';
                image.style.width = width;
                image.style.height = height;
                if (fullscreenAttribute && document[fullscreenAttribute] || displayCCOnTop) {
                    image.style.zIndex = topZIndex;
                } else {
                    image.style.zIndex = null;
                }
            }
        }
    }

    function scaleCue(activeCue) {
        var videoWidth = actualVideoWidth;
        var videoHeight = actualVideoHeight;
        var key, replaceValue, valueFontSize, valueLineHeight, elements;

        var cellUnit = [videoWidth / activeCue.cellResolution[0], videoHeight / activeCue.cellResolution[1]];
        if (activeCue.linePadding) {
            for (key in activeCue.linePadding) {
                if (activeCue.linePadding.hasOwnProperty(key)) {
                    var valueLinePadding = activeCue.linePadding[key];
                    replaceValue = (valueLinePadding * cellUnit[0]).toString();
                    // Compute the CellResolution unit in order to process properties using sizing (fontSize, linePadding, etc).
                    var elementsSpan = document.getElementsByClassName('spanPadding');
                    for (var i = 0; i < elementsSpan.length; i++) {
                        elementsSpan[i].style.cssText = elementsSpan[i].style.cssText.replace(/(padding-left\s*:\s*)[\d.,]+(?=\s*px)/gi, '$1' + replaceValue);
                        elementsSpan[i].style.cssText = elementsSpan[i].style.cssText.replace(/(padding-right\s*:\s*)[\d.,]+(?=\s*px)/gi, '$1' + replaceValue);
                    }
                }
            }
        }

        if (activeCue.fontSize) {
            for (key in activeCue.fontSize) {
                if (activeCue.fontSize.hasOwnProperty(key)) {
                    if (activeCue.fontSize[key][0] === '%') {
                        valueFontSize = activeCue.fontSize[key][1] / 100;
                    } else if (activeCue.fontSize[key][0] === 'c') {
                        valueFontSize = activeCue.fontSize[key][1];
                    }

                    replaceValue = (valueFontSize * cellUnit[1]).toString();

                    if (key !== 'defaultFontSize') {
                        elements = document.getElementsByClassName(key);
                    } else {
                        elements = document.getElementsByClassName('paragraph');
                    }

                    for (var j = 0; j < elements.length; j++) {
                        elements[j].style.cssText = elements[j].style.cssText.replace(/(font-size\s*:\s*)[\d.,]+(?=\s*px)/gi, '$1' + replaceValue);
                    }
                }
            }
        }

        if (activeCue.lineHeight) {
            for (key in activeCue.lineHeight) {
                if (activeCue.lineHeight.hasOwnProperty(key)) {
                    if (activeCue.lineHeight[key][0] === '%') {
                        valueLineHeight = activeCue.lineHeight[key][1] / 100;
                    } else if (activeCue.fontSize[key][0] === 'c') {
                        valueLineHeight = activeCue.lineHeight[key][1];
                    }

                    replaceValue = (valueLineHeight * cellUnit[1]).toString();
                    elements = document.getElementsByClassName(key);
                    for (var k = 0; k < elements.length; k++) {
                        elements[k].style.cssText = elements[k].style.cssText.replace(/(line-height\s*:\s*)[\d.,]+(?=\s*px)/gi, '$1' + replaceValue);
                    }
                }
            }
        }
    }

    /*
     * Add captions to track, store for later adding, or add captions added before
     */
    function addCaptions(trackIdx, timeOffset, captionData) {
        var track = trackIdx >= 0 ? video.textTracks[trackIdx] : null;
        var self = this;

        if (!track) {
            return;
        }
        if (track.mode !== 'showing') {
            if (captionData && captionData.length > 0) {
                track.nonAddedCues = track.nonAddedCues.concat(captionData);
            }
            return;
        }

        if (!captionData) {
            captionData = track.nonAddedCues;
            track.nonAddedCues = [];
        }

        if (!captionData || captionData.length === 0) {
            return;
        }

        for (var item in captionData) {
            var cue;
            var currentItem = captionData[item];

            track.cellResolution = currentItem.cellResolution;
            track.isFromCEA608 = currentItem.isFromCEA608;

            if (!videoSizeCheckInterval && (currentItem.type === 'html' || currentItem.type === 'image')) {
                videoSizeCheckInterval = setInterval(checkVideoSize.bind(this), 500);
            }

            //image subtitle extracted from TTML
            if (currentItem.type === 'image') {
                cue = new Cue(currentItem.start - timeOffset, currentItem.end - timeOffset, '');
                cue.image = currentItem.data;
                cue.id = currentItem.id;
                cue.size = 0; //discard the native display for this subtitles
                cue.type = 'image'; // active image overlay
                cue.layout = currentItem.layout;
                cue.scaleCue = scaleImageCue.bind(self);
                cue.onenter = function () {
                    if (!captionContainer) {
                        // Does not support image captions without a container
                        return;
                    }
                    if (track.mode === 'showing') {
                        var img = new Image();
                        img.id = 'ttmlImage_' + this.id;
                        img.src = this.image;
                        //img.className = 'cue-image';
                        img.style.cssText = 'pointer-events: none; display: block; visibility: visible !important; position: relative !important;';
                        captionContainer.appendChild(img);
                        scaleImageCue.call(self, this);
                    }
                };

                cue.onexit = function () {
                    if (!captionContainer) {
                        return;
                    }
                    var imgs = captionContainer.childNodes;
                    for (var i = 0; i < imgs.length; i++) {
                        if (imgs[i].id === 'ttmlImage_' + this.id) {
                            captionContainer.removeChild(imgs[i]);
                        }
                    }
                };
            } else if (currentItem.type === 'html') {
                cue = new Cue(currentItem.start - timeOffset, currentItem.end - timeOffset, '');
                cue.cueHTMLElement = currentItem.cueHTMLElement;
                cue.regions = currentItem.regions;
                cue.regionID = currentItem.regionID;
                cue.cueID = currentItem.cueID;
                cue.videoWidth = currentItem.videoWidth;
                cue.videoHeight = currentItem.videoHeight;
                cue.cellResolution = currentItem.cellResolution;
                cue.fontSize = currentItem.fontSize;
                cue.lineHeight = currentItem.lineHeight;
                cue.linePadding = currentItem.linePadding;
                cue.scaleCue = scaleCue.bind(self);
                captionContainer.style.left = actualVideoLeft + 'px';
                captionContainer.style.top = actualVideoTop + 'px';
                captionContainer.style.width = actualVideoWidth + 'px';
                captionContainer.style.height = actualVideoHeight + 'px';

                cue.onenter = function () {
                    if (track.mode === 'showing') {
                        log('Cue ' + this.startTime + '-' + this.endTime + ' : ' + this.cueHTMLElement.id + ' : ' + this.cueHTMLElement.innerText);
                        captionContainer.appendChild(this.cueHTMLElement);
                        scaleCue.call(self, this);
                    }
                };

                cue.onexit = function () {
                    var divs = captionContainer.childNodes;
                    for (var i = 0; i < divs.length; ++i) {
                        if (divs[i].id === this.cueID) {
                            captionContainer.removeChild(divs[i]);
                        }
                    }
                };
            } else {
                cue = new Cue(currentItem.start - timeOffset, currentItem.end - timeOffset, currentItem.data);
                if (currentItem.styles) {
                    if (currentItem.styles.align !== undefined && 'align' in cue) {
                        cue.align = currentItem.styles.align;
                    }
                    if (currentItem.styles.line !== undefined && 'line' in cue) {
                        cue.line = currentItem.styles.line;
                    }
                    if (currentItem.styles.position !== undefined && 'position' in cue) {
                        cue.position = currentItem.styles.position;
                    }
                    if (currentItem.styles.size !== undefined && 'size' in cue) {
                        cue.size = currentItem.styles.size;
                    }
                }
            }

            track.addCue(cue);
        }
    }

    function getCurrentTextTrack() {
        return currentTrackIdx >= 0 ? video.textTracks[currentTrackIdx] : null;
    }

    function getCurrentTrackIdx() {
        return currentTrackIdx;
    }

    function getTrackIdxForId(trackId) {
        var idx = -1;
        for (var i = 0; i < video.textTracks.length; i++) {
            if (video.textTracks[i].label === trackId) {
                idx = i;
                break;
            }
        }
        return idx;
    }

    function setCurrentTrackIdx(idx) {
        currentTrackIdx = idx;
        clearCaptionContainer.call(this);
        if (idx >= 0) {
            var track = video.textTracks[idx];
            if (track.renderingType === 'html') {
                setNativeCueStyle.call(this);
            } else {
                removeNativeCueStyle.call(this);
            }
        } else {
            removeNativeCueStyle.call(this);
        }
    }

    function getTextTrack(idx) {
        return video.textTracks[idx];
    }

    function deleteTrackCues(track) {
        if (track.cues) {
            var cues = track.cues;
            var lastIdx = cues.length - 1;

            for (var r = lastIdx; r >= 0; r--) {
                track.removeCue(cues[r]);
            }

            track.mode = 'disabled';
        }
    }

    function deleteAllTextTracks() {
        var ln = trackElementArr.length;
        for (var i = 0; i < ln; i++) {
            if (isChrome) {
                video.removeChild(trackElementArr[i]);
            } else {
                var track = getTextTrack.call(this, i);
                track.nonAddedCues = [];
                deleteTrackCues.call(this, track);
            }
        }
        trackElementArr = [];
        textTrackQueue = [];
        if (videoSizeCheckInterval) {
            clearInterval(videoSizeCheckInterval);
            videoSizeCheckInterval = null;
        }
        clearCaptionContainer.call(this);
    }

    function deleteTextTrack(idx) {
        video.removeChild(trackElementArr[idx]);
        trackElementArr.splice(idx, 1);
    }

    /* Set native cue style to transparent background to avoid it being displayed. */
    function setNativeCueStyle() {
        if (!isChrome) {
            return;
        }
        var styleElement = document.getElementById('native-cue-style');
        if (styleElement) {
            return; //Already set
        }

        styleElement = document.createElement('style');
        styleElement.id = 'native-cue-style';
        document.head.appendChild(styleElement);
        var stylesheet = styleElement.sheet;
        if (video.id) {
            stylesheet.insertRule('#' + video.id + '::cue {background: transparent}', 0);
        } else if (video.classList.length !== 0) {
            stylesheet.insertRule('.' + video.className + '::cue {background: transparent}', 0);
        } else {
            stylesheet.insertRule('video::cue {background: transparent}', 0);
        }
    }

    /* Remove the extra cue style with transparent background for native cues. */
    function removeNativeCueStyle() {
        if (!isChrome) {
            return;
        }
        var styleElement = document.getElementById('native-cue-style');
        if (styleElement) {
            document.head.removeChild(styleElement);
        }
    }

    function clearCaptionContainer() {
        if (captionContainer) {
            while (captionContainer.firstChild) {
                captionContainer.removeChild(captionContainer.firstChild);
            }
        }
    }

    function setConfig(config) {
        if (!config) {
            return;
        }
        if (config.videoModel) {
            videoModel = config.videoModel;
        }
    }

    instance = {
        initialize: initialize,
        displayCConTop: displayCConTop,
        addTextTrack: addTextTrack,
        addCaptions: addCaptions,
        getTextTrack: getTextTrack,
        getCurrentTextTrack: getCurrentTextTrack,
        getCurrentTrackIdx: getCurrentTrackIdx,
        setCurrentTrackIdx: setCurrentTrackIdx,
        getTrackIdxForId: getTrackIdxForId,
        deleteTrackCues: deleteTrackCues,
        deleteAllTextTracks: deleteAllTextTracks,
        deleteTextTrack: deleteTextTrack,
        setConfig: setConfig
    };

    return instance;
}

TextTracks.__dashjs_factory_name = 'TextTracks';
exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(TextTracks);
module.exports = exports['default'];
//# sourceMappingURL=TextTracks.js.map


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _IsoFile = __webpack_require__(1411);

var _IsoFile2 = _interopRequireDefault(_IsoFile);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _codemIsoboxer = __webpack_require__(582);

var _codemIsoboxer2 = _interopRequireDefault(_codemIsoboxer);

function BoxParser() /*config*/{

    var instance = undefined;
    var context = this.context;

    /**
     * @param {ArrayBuffer} data
     * @returns {IsoFile|null}
     * @memberof BoxParser#
     */
    function parse(data) {
        if (!data) return null;

        if (data.fileStart === undefined) {
            data.fileStart = 0;
        }

        var parsedFile = _codemIsoboxer2['default'].parseBuffer(data);
        var dashIsoFile = (0, _IsoFile2['default'])(context).create();

        dashIsoFile.setData(parsedFile);

        return dashIsoFile;
    }

    instance = {
        parse: parse
    };

    return instance;
}
BoxParser.__dashjs_factory_name = 'BoxParser';
exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(BoxParser);
module.exports = exports['default'];
//# sourceMappingURL=BoxParser.js.map


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _modelsMediaPlayerModel = __webpack_require__(67);

var _modelsMediaPlayerModel2 = _interopRequireDefault(_modelsMediaPlayerModel);

var _coreDebug = __webpack_require__(30);

var _coreDebug2 = _interopRequireDefault(_coreDebug);

var legacyKeysAndReplacements = [{ oldKey: 'dashjs_vbitrate', newKey: 'dashjs_video_bitrate' }, { oldKey: 'dashjs_abitrate', newKey: 'dashjs_audio_bitrate' }, { oldKey: 'dashjs_vsettings', newKey: 'dashjs_video_settings' }, { oldKey: 'dashjs_asettings', newKey: 'dashjs_audio_settings' }];

var LOCAL_STORAGE_BITRATE_KEY_TEMPLATE = 'dashjs_?_bitrate';
var LOCAL_STORAGE_SETTINGS_KEY_TEMPLATE = 'dashjs_?_settings';

var STORAGE_TYPE_LOCAL = 'localStorage';
var STORAGE_TYPE_SESSION = 'sessionStorage';

function DOMStorage() {

    var context = this.context;
    var log = (0, _coreDebug2['default'])(context).getInstance().log;

    var instance = undefined,
        supported = undefined,
        mediaPlayerModel = undefined;

    //type can be local, session
    function isSupported(type) {
        if (supported !== undefined) return supported;

        supported = false;

        var testKey = '1';
        var testValue = '1';
        var storage;

        try {
            if (typeof window !== 'undefined') {
                storage = window[type];
            }
        } catch (error) {
            log('Warning: DOMStorage access denied: ' + error.message);
            return supported;
        }

        if (!storage || type !== STORAGE_TYPE_LOCAL && type !== STORAGE_TYPE_SESSION) {
            return supported;
        }

        /* When Safari (OS X or iOS) is in private browsing mode, it appears as though localStorage is available, but trying to call setItem throws an exception.
         http://stackoverflow.com/questions/14555347/html5-localstorage-error-with-safari-quota-exceeded-err-dom-exception-22-an
          Check if the storage can be used
         */
        try {
            storage.setItem(testKey, testValue);
            storage.removeItem(testKey);
            supported = true;
        } catch (error) {
            log('Warning: DOMStorage is supported, but cannot be used: ' + error.message);
        }

        return supported;
    }

    function translateLegacyKeys() {
        if (isSupported(STORAGE_TYPE_LOCAL)) {
            legacyKeysAndReplacements.forEach(function (entry) {
                var value = localStorage.getItem(entry.oldKey);

                if (value) {
                    localStorage.removeItem(entry.oldKey);

                    try {
                        localStorage.setItem(entry.newKey, value);
                    } catch (e) {
                        log(e.message);
                    }
                }
            });
        }
    }

    function setup() {
        mediaPlayerModel = (0, _modelsMediaPlayerModel2['default'])(context).getInstance();

        translateLegacyKeys();
    }

    // Return current epoch time, ms, rounded to the nearest 10m to avoid fingerprinting user
    function getTimestamp() {
        var ten_minutes_ms = 60 * 1000 * 10;
        return Math.round(new Date().getTime() / ten_minutes_ms) * ten_minutes_ms;
    }

    function canStore(storageType, key) {
        return isSupported(storageType) && mediaPlayerModel['get' + key + 'CachingInfo']().enabled;
    }

    function getSavedMediaSettings(type) {
        //Checks local storage to see if there is valid, non-expired media settings
        if (!canStore(STORAGE_TYPE_LOCAL, 'LastMediaSettings')) return null;

        var key = LOCAL_STORAGE_SETTINGS_KEY_TEMPLATE.replace(/\?/, type);
        var obj = JSON.parse(localStorage.getItem(key)) || {};
        var isExpired = new Date().getTime() - parseInt(obj.timestamp, 10) >= mediaPlayerModel.getLastMediaSettingsCachingInfo().ttl || false;
        var settings = obj.settings;

        if (isExpired) {
            localStorage.removeItem(key);
            settings = null;
        }

        return settings;
    }

    function getSavedBitrateSettings(type) {
        var savedBitrate = NaN;
        //Checks local storage to see if there is valid, non-expired bit rate
        //hinting from the last play session to use as a starting bit rate.
        if (canStore(STORAGE_TYPE_LOCAL, 'LastBitrate')) {
            var key = LOCAL_STORAGE_BITRATE_KEY_TEMPLATE.replace(/\?/, type);
            var obj = JSON.parse(localStorage.getItem(key)) || {};
            var isExpired = new Date().getTime() - parseInt(obj.timestamp, 10) >= mediaPlayerModel.getLastBitrateCachingInfo().ttl || false;
            var bitrate = parseInt(obj.bitrate, 10);

            if (!isNaN(bitrate) && !isExpired) {
                savedBitrate = bitrate;
                log('Last saved bitrate for ' + type + ' was ' + bitrate);
            } else if (isExpired) {
                localStorage.removeItem(key);
            }
        }
        return savedBitrate;
    }

    function setSavedMediaSettings(type, value) {
        if (canStore(STORAGE_TYPE_LOCAL, 'LastMediaSettings')) {
            var key = LOCAL_STORAGE_SETTINGS_KEY_TEMPLATE.replace(/\?/, type);
            try {
                localStorage.setItem(key, JSON.stringify({ settings: value, timestamp: getTimestamp() }));
            } catch (e) {
                log(e.message);
            }
        }
    }

    function setSavedBitrateSettings(type, bitrate) {
        if (canStore(STORAGE_TYPE_LOCAL, 'LastBitrate') && bitrate) {
            var key = LOCAL_STORAGE_BITRATE_KEY_TEMPLATE.replace(/\?/, type);
            try {
                localStorage.setItem(key, JSON.stringify({ bitrate: bitrate / 1000, timestamp: getTimestamp() }));
            } catch (e) {
                log(e.message);
            }
        }
    }

    instance = {
        getSavedBitrateSettings: getSavedBitrateSettings,
        setSavedBitrateSettings: setSavedBitrateSettings,
        getSavedMediaSettings: getSavedMediaSettings,
        setSavedMediaSettings: setSavedMediaSettings,
        isSupported: isSupported
    };

    setup();
    return instance;
}

DOMStorage.__dashjs_factory_name = 'DOMStorage';
var factory = _coreFactoryMaker2['default'].getSingletonFactory(DOMStorage);
exports['default'] = factory;
module.exports = exports['default'];
//# sourceMappingURL=DOMStorage.js.map


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * Represents data structure to keep and drive {DataChunk}
 */



Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

function InitCache() {

    var data = {};

    function save(chunk) {
        var id = chunk.streamId;
        var representationId = chunk.representationId;

        data[id] = data[id] || {};
        data[id][representationId] = chunk;
    }

    function extract(streamId, representationId) {
        if (data && data[streamId] && data[streamId][representationId]) {
            return data[streamId][representationId];
        } else {
            return null;
        }
    }

    function reset() {
        data = {};
    }

    var instance = {
        save: save,
        extract: extract,
        reset: reset
    };

    return instance;
}

InitCache.__dashjs_factory_name = 'InitCache';
exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(InitCache);
module.exports = exports['default'];
//# sourceMappingURL=InitCache.js.map


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

/**
 *
 * @returns {{initialize: initialize, getLiveEdge: getLiveEdge, reset: reset}|*}
 * @constructor
 */
function LiveEdgeFinder() {

    var instance = undefined,
        timelineConverter = undefined,
        streamProcessor = undefined;

    function initialize(TimelineConverter, StreamProcessor) {
        timelineConverter = TimelineConverter;
        streamProcessor = StreamProcessor;
    }

    function getLiveEdge() {
        var representationInfo = streamProcessor.getCurrentRepresentationInfo();
        var liveEdge = representationInfo.DVRWindow.end;
        if (representationInfo.useCalculatedLiveEdgeTime) {
            liveEdge = timelineConverter.getExpectedLiveEdge();
            timelineConverter.setClientTimeOffset(liveEdge - representationInfo.DVRWindow.end);
        }
        return liveEdge;
    }

    function reset() {
        timelineConverter = null;
        streamProcessor = null;
    }

    instance = {
        initialize: initialize,
        getLiveEdge: getLiveEdge,
        reset: reset
    };

    return instance;
}
LiveEdgeFinder.__dashjs_factory_name = 'LiveEdgeFinder';
var factory = _coreFactoryMaker2['default'].getSingletonFactory(LiveEdgeFinder);
exports['default'] = factory;
module.exports = exports['default'];
//# sourceMappingURL=LiveEdgeFinder.js.map


/***/ }),
/* 410 */
/***/ (function(module, exports) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function(n) {
  if (!isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error ||
        (isObject(this._events.error) && !this._events.error.length)) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
    }
  }

  handler = this._events[type];

  if (isUndefined(handler))
    return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function(type, listener) {
  var m;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' +
                    'leak detected. %d listeners added. ' +
                    'Use emitter.setMaxListeners() to increase limit.',
                    this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function(type) {
  if (this._events) {
    var evlistener = this._events[type];

    if (isFunction(evlistener))
      return 1;
    else if (evlistener)
      return evlistener.length;
  }
  return 0;
};

EventEmitter.listenerCount = function(emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}


/***/ }),
/* 411 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(360),
    baseAssignValue = __webpack_require__(337);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(494),
    isIterateeCall = __webpack_require__(1063);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(488),
    baseKeysIn = __webpack_require__(1022),
    isArrayLike = __webpack_require__(106);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrapAction = exports.wrapDispatch = exports.bindActionCreators = undefined;

var _plainMultireducer = __webpack_require__(1655);

var _plainMultireducer2 = _interopRequireDefault(_plainMultireducer);

var _bindActionCreators = __webpack_require__(1652);

var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);

var _wrapDispatch = __webpack_require__(1218);

var _wrapDispatch2 = _interopRequireDefault(_wrapDispatch);

var _wrapAction = __webpack_require__(1217);

var _wrapAction2 = _interopRequireDefault(_wrapAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.bindActionCreators = _bindActionCreators2.default;
exports.wrapDispatch = _wrapDispatch2.default;
exports.wrapAction = _wrapAction2.default;
exports.default = _plainMultireducer2.default;

/***/ }),
/* 416 */,
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  CLASSIC: 1,
  STRIP: 2,
  COMPACT: 3
});

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ErrorSeverity; });
/* unused harmony export Categories */
/* harmony export (immutable) */ __webpack_exports__["f"] = disableBiSend;
/* harmony export (immutable) */ __webpack_exports__["b"] = now;
/* harmony export (immutable) */ __webpack_exports__["d"] = event;
/* harmony export (immutable) */ __webpack_exports__["e"] = error;
/* harmony export (immutable) */ __webpack_exports__["a"] = validateBiEventArgs;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bi_parsers__ = __webpack_require__(656);





var ErrorSeverity = {
  RECOVERABLE: 10,
  WARNING: 20,
  ERROR: 30,
  FATAL: 40
};

var Categories = {
  EDITOR: 1,
  VIEWER: 2,
  TIMEOUTS: 3,
  SERVER: 4
};

var disabled = false;

function disableBiSend() {
  disabled = true;
}

function now() {
  return new Date().getTime();
}
var startTime = now();

var defaultErrorArgs = {
  _: now,
  ts: function ts() {
    return now() - startTime;
  },

  cat: Categories.VIEWER,
  sev: ErrorSeverity.WARNING,
  iss: 1,
  ver: '1'
};

var _initOptions = {
  // The BI server's hostname
  hostName: 'frog.wix.com',

  // The default event args that will be sent with each BI log call (src, time?)
  defaultEventArgs: {},

  // The default event args that will be sent with each error log (src, cat, iss, ver)
  defaultErrorArgs: {},

  // The BI server URL
  biUrl: '//frog.wix.com/',

  // Schemas validators, should look like this:
  // {match: () => true, execute: () => undefined}
  schemaValidators: [],

  // The BI adapter (maps to a path in the url)
  adapter: '',

  // error output stream
  error: function error(str) {
    console.warn(str); // eslint-disable-line no-console
  },


  sendInvalidEvents: true
};

var EVENT_IDS = {
  ERROR: 10,
  ON_READY: 302,
  ROUTE_CHANGE: 300
};

function _extend(dst) {
  for (var i = 1; i < arguments.length; i += 1) {
    var extending = arguments[i];
    if (extending) {
      for (var key in extending) {
        if (extending.hasOwnProperty(key)) {
          dst[key] = extending[key];
        }
      }
    }
  }
  return dst;
}

var _options = _extend({}, _initOptions);

function event(eventArgs) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _.noop;
  var defaultEventArgs = arguments[2];

  var _biFieldsRestrictions = {
    src: { type: 'number' },
    evid: { type: 'number' }
  };

  var eventParams = _extend({}, defaultEventArgs, _options.defaultEventArgs, eventArgs);

  var schemaValidators = _options.schemaValidators || [];
  var validatorsResult = schemaValidators.length > 0 ? _.some(schemaValidators, function (validator) {
    return validator.match(eventParams) && (validator.execute(eventParams) || true);
  }) : true;

  if (!validatorsResult) {
    throw new Error('No validator accepted the event');
  }
  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    if (!validateBiEventArgs(eventParams, ['evid'], _biFieldsRestrictions) && !_options.sendInvalidEvents) {
      reject('Event is invalid');
      return;
    }
    sendBiEvent(eventParams, function () {
      resolve();
      callback.apply(undefined, arguments);
    });
  });
}

function error(errorArgs) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _.noop;

  var _requiredErrorFields = ['evid', 'cat', 'iss', 'sev', 'errc', 'ver'];
  var _errorFieldsRestrictions = {
    src: { type: 'number' },
    evid: { type: 'number', values: [EVENT_IDS.ERROR] },
    cat: {
      type: 'number',
      values: [Categories.EDITOR, Categories.VIEWER, Categories.TIMEOUTS, Categories.SERVER]
    },
    iss: { type: 'number' },
    sev: {
      type: 'number',
      values: [ErrorSeverity.RECOVERABLE, ErrorSeverity.WARNING, ErrorSeverity.ERROR, ErrorSeverity.FATAL]
    },
    errc: { type: 'number' },
    httpc: { type: 'number' },
    ver: { type: 'string', maxLength: 16 },
    errscp: { type: 'string', subStr: 64 },
    trgt: { type: 'string', subStr: 64 },
    gsi: { type: 'string', length: 36 },
    ts: { type: 'number' },
    uid: { type: 'number' },
    ut: { type: 'string', maxLength: 16 },
    did: { type: 'string', maxLength: 36 },
    cid: { type: 'string', length: 36 },
    lng: { type: 'string', maxLength: 5 },
    dsc: { type: 'string', subStr: 512 }
  };

  var errorParams = _extend({}, defaultErrorArgs, _options.defaultErrorArgs, errorArgs, { evid: EVENT_IDS.ERROR });

  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    if (!validateBiEventArgs(errorParams, _requiredErrorFields, _errorFieldsRestrictions) && !_options.sendInvalidEvents) {
      reject('Error event is invalid');
      return;
    }
    sendBiEvent(errorParams, function () {
      resolve();
      callback.apply(undefined, arguments);
    });
  });
}

function validateBiEventArgs(eventArgs, requiredArgs, restrictions, id) {
  var missingRequiredArgs = requiredArgs.slice(0);
  for (var key in eventArgs) {
    if (eventArgs.hasOwnProperty(key)) {
      // validate & parse the key
      var currentRestrictions = restrictions[key] || {};

      eventArgs[key] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__bi_parsers__["a" /* parse */])(eventArgs[key], currentRestrictions);
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__bi_parsers__["b" /* valid */])(eventArgs[key], currentRestrictions)) {
        _options.error(['\t' + id + '. Bad event param (key: ' + key + ', value: ' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(eventArgs[key]) + ')', '\tCurrent restrictions: ' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(restrictions[key]) + '\n'].join('\n'));
        return;
      }

      // remove the key from the required fields
      var missingIndex = missingRequiredArgs.indexOf(key);
      if (missingIndex > -1) {
        missingRequiredArgs.splice(missingIndex, 1);
      }
    }
  }

  if (missingRequiredArgs.length > 0) {
    _options.error('Missing required params: ' + missingRequiredArgs.join(', '));
    return false;
  }

  return true;
}

function addUrlParams(url, params) {
  var delimiter = url.match(/\?./) ? '&' : '?';
  return url.replace(/\?$/, '') + delimiter + _(params).keys().filter(function (key) {
    return !_options.removeUndefinedValues || !_.isUndefined(params[key]);
  }).map(function (key) {
    return [encodeURIComponent(key), '=', encodeURIComponent(params[key])].join('');
  }).join('&');
}

function sendBiEvent(_ref) {
  var onComplete = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _.noop;

  var _ref$adapter = _ref.adapter,
      adapter = _ref$adapter === undefined ? _options.adapter : _ref$adapter,
      eventArgs = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['adapter']);

  /* eslint-disable no-console */
  /* uncomment this to log sent BI */
  // console.info(
  //   JSON.stringify(eventArgs, null, 2)
  //     .replace(/"/g, '')
  // );

  if (disabled) {
    onComplete(_options.biUrl);
    return;
  }
  var url = addUrlParams(_options.biUrl + adapter, eventArgs);

  // The magic line
  var biImage = new Image(0, 0);
  biImage.onload = onComplete;
  biImage.onerror = onComplete;
  biImage.src = url;
}

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sendEvent;
/* harmony export (immutable) */ __webpack_exports__["b"] = sendError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_bi_bi_vod__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_bi_bi_events_catalog__ = __webpack_require__(1189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_bi_bi_events_catalog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shared_bi_bi_events_catalog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_bi_bi_errors_catalog__ = __webpack_require__(1188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_bi_bi_errors_catalog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_shared_bi_bi_errors_catalog__);





function sendEvent(nameFromCatalog, params) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve().then(function () {
    // catch all possible errors, to continue work event if bi event has some problems
    var eventDef = _.get(__WEBPACK_IMPORTED_MODULE_2_shared_bi_bi_events_catalog___default.a, nameFromCatalog);

    if (!eventDef) {
      throw new Error('\'' + nameFromCatalog + '\' bi event was not found in catalog');
    }

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_bi_bi_vod__["a" /* event */])(eventDef, params);
  });
}

function sendError(nameFromCatalog, params) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve().then(function () {
    // catch all possible errors, to continue work event if bi event has some problems
    var eventDef = _.get(__WEBPACK_IMPORTED_MODULE_3_shared_bi_bi_errors_catalog___default.a, nameFromCatalog);

    if (!eventDef) {
      throw new Error('\'' + nameFromCatalog + '\' bi event was not found in catalog');
    }

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_bi_bi_vod__["b" /* sendError */])(eventDef, params);
  });
}

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export sendBiEvent */
/* harmony export (immutable) */ __webpack_exports__["a"] = withBiEvent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_utils_wix_sdk__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_bi_bi_handler__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_utils_comp_id__ = __webpack_require__(424);




function sendBiEvent(eventName, params) {
  __WEBPACK_IMPORTED_MODULE_0_shared_utils_wix_sdk__["a" /* default */].PubSub.publish(__WEBPACK_IMPORTED_MODULE_1_shared_bi_bi_handler__["a" /* BI_EVENT */], {
    eventName: eventName,
    params: params,
    targetCompId: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_utils_comp_id__["a" /* getCompId */])()
  });
}

function withBiEvent(eventName) {
  var getParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _.noop;

  return function (target, name, descriptor) {
    var originalMethod = descriptor.value;

    descriptor.value = function wrappedMethod() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      sendBiEvent(eventName, getParams.apply(this, args));
      originalMethod.apply(this, args);
    };

    return descriptor;
  };
}

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BackOfficeScrollbarWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WidgetScrollbarWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__scrollbar_wrapper_styl__ = __webpack_require__(1659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__scrollbar_wrapper_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__scrollbar_wrapper_styl__);








var _dec, _class, _desc, _value, _class2, _class3, _temp, _dec2, _class4, _dec3, _class5;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}







var ScrollbarWrapper = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_10__scrollbar_wrapper_styl___default.a), _dec(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(ScrollbarWrapper, _React$Component);

  function ScrollbarWrapper() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ScrollbarWrapper);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ScrollbarWrapper.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(ScrollbarWrapper)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(ScrollbarWrapper, [{
    key: 'getRef',
    value: function getRef(node) {
      if (!node) {
        return;
      }

      this.props.getRef(node);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          onlyOnHover = _props.onlyOnHover,
          scrollX = _props.scrollX,
          scrollY = _props.scrollY;

      var props = _.pick(this.props, 'className', 'children');

      var classNames = __WEBPACK_IMPORTED_MODULE_7_classnames___default()('scrollbar-wrapper', {
        'only-on-hover': onlyOnHover,
        'scroll-x': scrollX,
        'scroll-y': scrollY
      });

      return React.createElement('div', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, props, {
        ref: this.getRef,
        styleName: classNames }));
    }
  }]);

  return ScrollbarWrapper;
}(React.Component), _class3.propTypes = {
  scrollX: React.PropTypes.bool,
  scrollY: React.PropTypes.bool,
  onlyOnHover: React.PropTypes.bool,
  getRef: React.PropTypes.func
}, _class3.defaultProps = {
  scrollX: false,
  scrollY: true,
  onlyOnHover: false,
  getRef: _.noop
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'getRef', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'getRef'), _class2.prototype)), _class2)) || _class);

var BackOfficeScrollbarWrapper = (_dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_10__scrollbar_wrapper_styl___default.a), _dec2(_class4 = function (_React$Component2) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(BackOfficeScrollbarWrapper, _React$Component2);

  function BackOfficeScrollbarWrapper() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, BackOfficeScrollbarWrapper);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (BackOfficeScrollbarWrapper.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(BackOfficeScrollbarWrapper)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(BackOfficeScrollbarWrapper, [{
    key: 'render',
    value: function render() {
      var props = _.omit(this.props, 'styles');

      return React.createElement(ScrollbarWrapper, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, props, {
        styleName: 'backoffice' }));
    }
  }]);

  return BackOfficeScrollbarWrapper;
}(React.Component)) || _class4);

var WidgetScrollbarWrapper = (_dec3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_10__scrollbar_wrapper_styl___default.a), _dec3(_class5 = function (_React$Component3) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(WidgetScrollbarWrapper, _React$Component3);

  function WidgetScrollbarWrapper() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, WidgetScrollbarWrapper);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (WidgetScrollbarWrapper.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(WidgetScrollbarWrapper)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(WidgetScrollbarWrapper, [{
    key: 'render',
    value: function render() {
      var props = _.omit(this.props, 'styles');

      return React.createElement(ScrollbarWrapper, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, props, {
        styleName: 'widget' }));
    }
  }]);

  return WidgetScrollbarWrapper;
}(React.Component)) || _class5);

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return APP_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DASHBOARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HELP_LINK_PREFIX; });
/* unused harmony export GFPP */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_constants_app_settings_tabs__ = __webpack_require__(621);


var _APP_SETTINGS;



var prefix = '/widget/cb6480f3-768b-4737-ab8f-10fe2e4fa2ab/article/';

var APP_SETTINGS = (_APP_SETTINGS = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_APP_SETTINGS, __WEBPACK_IMPORTED_MODULE_1_shared_constants_app_settings_tabs__["a" /* TAB_NAMES */].MAIN, '758dcf00-c1fd-49db-a765-20dc9e38dd83'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_APP_SETTINGS, __WEBPACK_IMPORTED_MODULE_1_shared_constants_app_settings_tabs__["a" /* TAB_NAMES */].CHANNEL, 'd76eaf25-334a-4e3c-a126-69d7de75bfc3'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_APP_SETTINGS, __WEBPACK_IMPORTED_MODULE_1_shared_constants_app_settings_tabs__["a" /* TAB_NAMES */].LAYOUT, '660b2a10-ff77-42ca-aa47-74bf895fef63'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_APP_SETTINGS, __WEBPACK_IMPORTED_MODULE_1_shared_constants_app_settings_tabs__["a" /* TAB_NAMES */].SETTINGS, '5c6d9ef8-4e72-4654-9335-26a5aed788c7'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_APP_SETTINGS, __WEBPACK_IMPORTED_MODULE_1_shared_constants_app_settings_tabs__["a" /* TAB_NAMES */].DESIGN, '5dbb9fa8-6b65-4c5d-804c-6363cb0454d0'), _APP_SETTINGS);

var DASHBOARD = {
  LIBRARY: prefix + 'a9755854-f70e-4875-9114-1c4361e75b23',
  CHANNELS: prefix + 'd76eaf25-334a-4e3c-a126-69d7de75bfc3',
  STATS: prefix + '3b8e4c51-916f-4e62-b678-c2875dc57312',
  SETTINGS: prefix + 'd60e85d5-320e-4181-845b-66d3e7de87e1',
  EMAIL_MARKETING: prefix + 'caa7bf38-3b47-4d02-810a-01c68e087a59'
};

var HELP_LINK_PREFIX = 'https://www.wix.com/support/html5';

var GFPP = prefix + '70c76129-820f-4cf3-ba75-c8eebb39f955';

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DataComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);







var _class, _temp;

function addChildProps(child, props) {
  if (!child) {
    return null;
  }
  if (_.isString(child.type)) {
    // this is DOM element
    return child;
  }
  return React.cloneElement(child, props);
}

var DataComponent = (_temp = _class = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(DataComponent, _React$Component);

  function DataComponent() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, DataComponent);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (DataComponent.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(DataComponent)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(DataComponent, [{
    key: 'render',
    value: function render() {
      var childProps = this.childProps;
      var children = this.props.children;


      if (!childProps || !children) {
        return null;
      }

      var props = _.omit(this.props, ['isFetching', 'children']);

      var combinedProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, childProps);

      if (!_.isArray(children)) {
        return addChildProps(children, combinedProps);
      }

      return React.createElement(
        'section',
        null,
        React.Children.map(children, function (child) {
          return addChildProps(child, combinedProps);
        })
      );
    }
  }, {
    key: 'childProps',
    get: function get() {
      return null;
    }
  }]);

  return DataComponent;
}(React.Component), _class.propTypes = {
  children: React.PropTypes.any
}, _temp);


/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCompId; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_utils_wix_sdk__ = __webpack_require__(25);


var getCompId = function getCompId() {
  return __WEBPACK_IMPORTED_MODULE_0_shared_utils_wix_sdk__["a" /* default */].Utils.getOrigCompId() || __WEBPACK_IMPORTED_MODULE_0_shared_utils_wix_sdk__["a" /* default */].Utils.getCompId();
};

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_utils_query_string__ = __webpack_require__(254);




/* harmony default export */ __webpack_exports__["a"] = (function (videoItem, settings) {
  var id = videoItem.id;
  var siteUrl = settings.siteUrl,
      compId = settings.compId;

  var _siteUrl$split = siteUrl.split('?'),
      _siteUrl$split2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_siteUrl$split, 2),
      host = _siteUrl$split2[0],
      _siteUrl$split2$ = _siteUrl$split2[1],
      queryAndHash = _siteUrl$split2$ === undefined ? '' : _siteUrl$split2$;

  var _queryAndHash$split = queryAndHash.split('#'),
      _queryAndHash$split2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_queryAndHash$split, 2),
      _queryAndHash$split2$ = _queryAndHash$split2[0],
      query = _queryAndHash$split2$ === undefined ? '' : _queryAndHash$split2$,
      _queryAndHash$split2$2 = _queryAndHash$split2[1],
      hash = _queryAndHash$split2$2 === undefined ? '' : _queryAndHash$split2$2;

  var queryParams = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_utils_query_string__["a" /* parse */])(query);
  var videoArgs = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, queryParams, {
    'wix-vod-video-id': id
  });

  if (compId) {
    videoArgs['wix-vod-comp-id'] = compId;
  }

  var videoQueryString = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_utils_query_string__["b" /* stringify */])(videoArgs);

  return '' + host + videoQueryString + '#' + hash;
});

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = InternalError;
/* harmony export (immutable) */ __webpack_exports__["a"] = parseError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

function InternalError(status, code, message) {
  this.status = status;
  this.code = code;
  this.message = message;
  this.name = this.constructor.name;
}

InternalError.prototype = _.create(Error.prototype);

function parseError(response) {
  if (response instanceof InternalError) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(parseInternalError(response));
  }

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(parseNativeError(response));
}

function parseInternalError() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      status = _ref.status,
      code = _ref.code,
      message = _ref.message;

  return {
    status: status,
    error: {
      code: code,
      message: message
    }
  };
}

function parseNativeError(response) {
  var status = response.status,
      data = response.data;


  return {
    status: status,
    error: data.error
  };
}

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = InternalError;
/* harmony export (immutable) */ __webpack_exports__["a"] = parseError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

function InternalError(status, code, message) {
  this.status = status;
  this.code = code;
  this.message = message;
  this.name = this.constructor.name;
}

InternalError.prototype = _.create(Error.prototype);

function parseError(response) {
  if (response instanceof InternalError) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(parseInternalError(response));
  }

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(parseNativeError(response));
}

function parseInternalError() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      status = _ref.status,
      code = _ref.code,
      message = _ref.message;

  return {
    status: status,
    error: {
      code: code,
      message: message
    }
  };
}

function parseNativeError(response) {
  var status = response.status,
      data = response.data;


  return {
    status: status,
    error: data.error
  };
}

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_decorators_lib_autobind__);





var _desc, _value, _class;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}



var INACTIVE_CHANNEL_TIMEOUT = 2 * 60 * 1000;

var Channels = (_class = function () {
  function Channels() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Channels);

    this.privateMedia = null;
    this.openingPromises = null;
    this.isOpened = false;
    this.autoCloseTimeout = null;

    this.listeners = [];
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Channels, [{
    key: 'setup',
    value: function setup(options) {
      this.privateMedia = options.wixPrivateMedia;
    }
  }, {
    key: 'closeByTimeout',
    value: function closeByTimeout() {
      clearTimeout(this.autoCloseTimeout);
      this.autoCloseTimeout = setTimeout(this.close, INACTIVE_CHANNEL_TIMEOUT);
    }
  }, {
    key: 'startListen',
    value: function startListen(listenerName) {
      clearTimeout(this.autoCloseTimeout);

      if (!this.isOpened) {
        this.open();
      }

      if (!_.includes(this.listeners, listenerName)) {
        this.listeners.push(listenerName);
      }
    }
  }, {
    key: 'stopListen',
    value: function stopListen(listenerName) {
      this.listeners = _.without(this.listeners, listenerName);

      if (_.isEmpty(this.listeners)) {
        this.closeByTimeout();
      }
    }
  }, {
    key: 'open',
    value: function open() {
      var _this = this;

      if (!this.privateMedia) {
        throw new Error('`privateMedia` should be setted. see setup() method.');
      }

      if (this.isOpened) {
        return;
      }

      if (!this.openingPromises) {
        console.log('channel & web-sockets opened'); // eslint-disable-line no-console

        this.openingPromises = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.race([this.privateMedia.channel.open(), this.privateMedia.blackArrow.open()]);

        this.openingPromises.then(function () {
          _this.isOpened = true;
        });
      }
    }
  }, {
    key: 'close',
    value: function close() {
      if (!this.isOpened) {
        return;
      }

      console.log('channel & web-sockets closed'); // eslint-disable-line no-console
      this.privateMedia.channel.close();
      this.privateMedia.blackArrow.close();
      this.isOpened = false;
      this.openingPromises = null;
    }
  }]);

  return Channels;
}(), (_applyDecoratedDescriptor(_class.prototype, 'close', [__WEBPACK_IMPORTED_MODULE_4_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'close'), _class.prototype)), _class);


/* harmony default export */ __webpack_exports__["a"] = (new Channels());

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__item__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_channel_types__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_transcoding_statuses__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_object__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_normalize_id__ = __webpack_require__(272);








/* harmony default export */ __webpack_exports__["a"] = (function (adapterMethods, listData) {
  listData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_object__["keysToCamelCase"])(listData);

  var _listData = listData,
      id = _listData.itemId,
      customCoverUrl = _listData.customCoverUrl,
      videosCount = _listData.usedCount,
      hasChangesToPublish = _listData.publishChanges,
      featuredItem = _listData.featuredItem,
      _listData$urlType = _listData.urlType,
      urlType = _listData$urlType === undefined ? '' : _listData$urlType,
      _listData$channelType = _listData.channelType,
      channelType = _listData$channelType === undefined ? __WEBPACK_IMPORTED_MODULE_1__constants_channel_types__["a" /* default */].CHANNEL : _listData$channelType;
  var _listData2 = listData,
      createdTs = _listData2.createdTs,
      externalCreatedTs = _listData2.externalCreatedTs,
      updatedTs = _listData2.updatedTs,
      _listData2$publishedT = _listData2.publishedTs,
      publishedTs = _listData2$publishedT === undefined ? createdTs : _listData2$publishedT,
      statsInfo = _listData2.statsInfo;


  createdTs = new Date(createdTs * 1000);
  externalCreatedTs = new Date(externalCreatedTs * 1000);
  updatedTs = new Date(updatedTs * 1000);
  if (publishedTs) {
    publishedTs = new Date(publishedTs * 1000);
  }

  if (statsInfo) {
    statsInfo = _.mapValues(statsInfo, function (list) {
      return _.uniqBy(list, 'value');
    });
  }

  // TODO: add mapping instead assign
  listData = _({}).assign(listData, {
    id: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_normalize_id__["a" /* normalizeId */])(id),
    customCoverUrl: customCoverUrl || null,
    videosCount: videosCount,
    createdTs: createdTs,
    externalCreatedTs: externalCreatedTs,
    updatedTs: updatedTs,
    publishedTs: publishedTs,
    hasChangesToPublish: hasChangesToPublish,
    urlType: urlType,
    channelType: channelType,
    featuredItem: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__item__["a" /* default */])(adapterMethods, featuredItem),
    statsInfo: statsInfo
  }).omit('itemId', 'usedCount', 'publishChanges').value();

  // TODO: remove after add filtering on server side. Fix failed video, marked as featured
  if (listData.featuredItem && listData.featuredItem.transcodingStatus === __WEBPACK_IMPORTED_MODULE_2__constants_transcoding_statuses__["a" /* default */].NONE) {
    listData = _.omit(listData, 'featuredItem');

    if (listData.videosCount) {
      listData.videosCount += -1;
    }
  }

  if (channelType !== __WEBPACK_IMPORTED_MODULE_1__constants_channel_types__["a" /* default */].CHANNEL) {
    listData = _.omit(listData, 'videosCount');
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_object__["removeUndefinedValues"])(listData);
});

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseChannel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_object__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_thumbnail__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_channel_types__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__url_types__ = __webpack_require__(137);







function parseChannel(urlType, channelData) {
  var externalId = channelData.id,
      _channelData$snippet = channelData.snippet,
      snippet = _channelData$snippet === undefined ? {} : _channelData$snippet,
      _channelData$contentD = channelData.contentDetails,
      contentDetails = _channelData$contentD === undefined ? {} : _channelData$contentD,
      _channelData$statisti = channelData.statistics,
      statistics = _channelData$statisti === undefined ? {} : _channelData$statisti,
      _channelData$branding = channelData.brandingSettings,
      brandingSettings = _channelData$branding === undefined ? {} : _channelData$branding,
      _channelData$isExtern = channelData.isExternalRemoved,
      isExternalRemoved = _channelData$isExtern === undefined ? false : _channelData$isExtern;
  var title = snippet.title,
      description = snippet.description,
      thumbnails = snippet.thumbnails,
      publishedAt = snippet.publishedAt;
  var itemCount = contentDetails.itemCount,
      _contentDetails$relat = contentDetails.relatedPlaylists,
      relatedPlaylists = _contentDetails$relat === undefined ? {} : _contentDetails$relat;

  var videosCount = Number(itemCount || statistics.videoCount) || 0;

  var coverUrl = _.get(brandingSettings, 'image.bannerTvImageUrl') || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__get_thumbnail__["a" /* default */])(thumbnails) || null;
  if (urlType === __WEBPACK_IMPORTED_MODULE_3__url_types__["a" /* default */].PLAYLIST && videosCount === 0) {
    coverUrl = null;
  }

  return __WEBPACK_IMPORTED_MODULE_0__utils_object__["removeUndefinedValues"]({
    externalId: externalId,
    uploadsPlaylistId: relatedPlaylists.uploads,
    title: title,
    description: description,
    coverUrl: coverUrl,
    videosCount: videosCount,
    externalCreatedTs: new Date(publishedAt),
    channelType: __WEBPACK_IMPORTED_MODULE_2__constants_channel_types__["a" /* default */].YOUTUBE_FEED,
    urlType: urlType,
    isExternalRemoved: isExternalRemoved
  });
}

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getThumbnail;
function getThumbnail(thumbnails) {
  if (!thumbnails) {
    return;
  }

  var biggestThumbnail = _(thumbnails).values().maxBy('width');

  return biggestThumbnail.url.replace(/^https?:/, '');
}

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (data) {
  return _.isArray(data) ? data : [data];
});

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventEmitter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var EventEmitter = function () {
  function EventEmitter() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, EventEmitter);

    this.events = {};
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(EventEmitter, [{
    key: "on",
    value: function on(eventName, fn) {
      this.events[eventName] = this.events[eventName] || [];
      this.events[eventName].push(fn);
    }
  }, {
    key: "off",
    value: function off(eventName, fn) {
      if (eventName in this.events === false) {
        return;
      }

      if (arguments.length === 1) {
        this.events[eventName] = [];
        return;
      }

      this.events[eventName] = _.without(this.events[eventName], fn);
    }
  }, {
    key: "trigger",
    value: function trigger(eventName) {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (eventName in this.events === false) {
        return;
      }

      _.forEach(this.events[eventName], function (event) {
        return event.apply(_this, args);
      });
    }
  }]);

  return EventEmitter;
}();



/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CHUNK_SIZE; });
/* harmony export (immutable) */ __webpack_exports__["a"] = getVideoDuration;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__http__ = __webpack_require__(44);




// CHUNK_SIZE = 1MB
var CHUNK_SIZE = 1024 * 1024;
var MAX_MILLISECONDS_ALLOWED_FOR_CLIENT_CHECK = 10 * 60 * 1000; // max 10 mins is allowed

function _sliceFile(file) {
  var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : file.size;

  var method = file.webkitSlice || file.mozSlice || file.slice;
  if (!method) {
    return null;
  }

  var type = file.type;

  return method.call(file, start, end, type);
}

function probeExternalVideo(_ref) {
  var url = _ref.url,
      settings = _ref.settings,
      headers = _ref.headers;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__http__["post"])(settings.filesUrl + '/files/video/probe-external', {
    data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
      url: url,
      headers: headers
    })
  }).then(function (response) {
    return _.get(response, 'data.video_duration');
  });
}

function probe(_ref2) {
  var file = _ref2.file,
      settings = _ref2.settings,
      chunkSize = _ref2.chunkSize;
  var size = file.size;

  var firstChunk = file;
  var lastChunk = null;

  if (size > chunkSize * 2) {
    // file is large enough to chunk it - get first and last chunks
    firstChunk = _sliceFile(file, 0, chunkSize) || file;
    lastChunk = _sliceFile(file, -chunkSize);
  }

  var formData = new FormData();
  formData.append('size', file.size);
  formData.append('first_chunk', firstChunk, 'first_chunk');

  if (lastChunk) {
    formData.append('last_chunk', lastChunk, 'last_chunk');
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__http__["post"])(settings.filesUrl + '/files/video/probe', { data: formData }).then(function (response) {
    return _.get(response, 'data.video_duration');
  });
}

function getProbe(_ref3) {
  var fileIsUrl = _ref3.fileIsUrl,
      file = _ref3.file,
      settings = _ref3.settings,
      chunkSize = _ref3.chunkSize,
      headers = _ref3.headers;

  return fileIsUrl ? probeExternalVideo({ url: file, settings: settings, headers: headers }) : probe({ file: file, settings: settings, chunkSize: chunkSize });
}

var loadMetaData = function loadMetaData(fileUrl) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (res, rej) {
    var video = document.createElement('video');

    video.addEventListener('loadedmetadata', function () {
      video.removeEventListener('error', rej);
      res(video.duration * 1000);
    });

    video.addEventListener('error', rej);
    video.src = fileUrl;
  });
};

function getVideoDuration(file, settings) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _options$skipProbe = options.skipProbe,
      skipProbe = _options$skipProbe === undefined ? false : _options$skipProbe,
      _options$chunkSize = options.chunkSize,
      chunkSize = _options$chunkSize === undefined ? CHUNK_SIZE : _options$chunkSize,
      headers = options.headers;


  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var fileIsUrl = _.isString(file);
    var fileUrl = fileIsUrl ? file : URL.createObjectURL(file);

    function resolveWithDuration(duration) {
      duration = Math.floor(duration);

      if (!fileIsUrl) {
        file.duration = duration;
      }

      resolve(duration);
      return duration;
    }

    loadMetaData(fileUrl).then(function (duration) {
      if (skipProbe || duration <= MAX_MILLISECONDS_ALLOWED_FOR_CLIENT_CHECK) {
        return duration;
      }
      return getProbe({ fileIsUrl: fileIsUrl, file: file, settings: settings, chunkSize: chunkSize, headers: headers });
    }, function () {
      return getProbe({ fileIsUrl: fileIsUrl, file: file, settings: settings, chunkSize: chunkSize, headers: headers });
    }).then(function (duration) {
      return resolveWithDuration(duration);
    }).catch(reject);
  });
}

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_wixmp_sdk__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_wixmp_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_wixmp_sdk__);


var wixPrivateMedia = void 0;

/* harmony default export */ __webpack_exports__["a"] = (function (settings) {
  var filesUrl = settings.filesUrl,
      uploadLimits = settings.uploadLimits;

  var privateMediaSettings = {
    apiUrl: filesUrl,
    uploadLimits: uploadLimits,
    blackArrow: {
      enabled: true
    },
    asyncTranscoding: true
  };

  if (!wixPrivateMedia) {
    try {
      wixPrivateMedia = __WEBPACK_IMPORTED_MODULE_0_wixmp_sdk___default.a.Source(__WEBPACK_IMPORTED_MODULE_0_wixmp_sdk___default.a.sources.PRIVATE, privateMediaSettings);
    } catch (error) {}
  }

  return wixPrivateMedia;
});

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_widget_player_widget_utils_url__ = __webpack_require__(1289);



var IMAGE_SOURCE_NAME = null;
var JPEG_PARAMS = {
  q: 85,
  usm: '0.66_1.00_0.01'
};

function isJPEG(extension) {
  return (/^jpe?g$/i.test(extension)
  );
}

/* harmony default export */ __webpack_exports__["a"] = (function (url) {
  var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : width;
  var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  if (!url) {
    return '';
  }

  width = Math.round(width);
  height = Math.round(height);

  if (/vimeocdn/.test(url)) {
    return url.replace(/(_\d+(x\d+)?)?\.jpg/, '_' + width + 'x' + height + '.jpg');
  }

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_widget_player_widget_utils_url__["a" /* isAbsoluteUrl */])(url)) {
    return url;
  }

  if (!width || !height) {
    return url.replace(/\.[^.]+$/, '');
  }

  var fullFilename = url.split('/').pop();
  var imagePath = url.replace(fullFilename, '');

  var filenameSplitted = fullFilename.split('.');
  var filename = filenameSplitted.slice(0, -1).join('.');
  var ext = filenameSplitted[filenameSplitted.length - 1];
  var imageUrlEnd = IMAGE_SOURCE_NAME ? filename + '_' + IMAGE_SOURCE_NAME + '.' + ext : filename + '.' + ext;

  params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params, {
    w: width,
    h: height
  });

  if (isJPEG(ext)) {
    params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params, JPEG_PARAMS);
  }

  var imageParamsPath = _.map(params, function (value, key) {
    return key + '_' + value;
  }).join(',');

  return imagePath + 'v1/fill/' + imageParamsPath + '/' + imageUrlEnd;
});

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REFRESH_EVENT; });
/* harmony export (immutable) */ __webpack_exports__["a"] = storeForReload;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_utils_wix_sdk__ = __webpack_require__(25);


var uid = __WEBPACK_IMPORTED_MODULE_0_shared_utils_wix_sdk__["a" /* default */].Utils.getInstanceValue('uid');
var instanceId = __WEBPACK_IMPORTED_MODULE_0_shared_utils_wix_sdk__["a" /* default */].Utils.getInstanceId();
var REFRESH_EVENT = 'refreshOnLoginEvents';

function storeForReload(data) {
  __WEBPACK_IMPORTED_MODULE_0_shared_utils_wix_sdk__["a" /* default */].PubSub.publish(REFRESH_EVENT, {
    uid: uid,
    instanceId: instanceId,
    stored: data
  }, true);
}

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(726), __esModule: true };

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(733), __esModule: true };

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(55).document && document.documentElement;

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(77) && !__webpack_require__(117)(function(){
  return Object.defineProperty(__webpack_require__(277)('div'), 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators  = __webpack_require__(139)
  , ITERATOR   = __webpack_require__(48)('iterator')
  , ArrayProto = Array.prototype;

module.exports = function(it){
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(170);
module.exports = Array.isArray || function isArray(arg){
  return cof(arg) == 'Array';
};

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(86);
module.exports = function(iterator, fn, value, entries){
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch(e){
    var ret = iterator['return'];
    if(ret !== undefined)anObject(ret.call(iterator));
    throw e;
  }
};

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR     = __webpack_require__(48)('iterator')
  , SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function(){ SAFE_CLOSING = true; };
  Array.from(riter, function(){ throw 2; });
} catch(e){ /* empty */ }

module.exports = function(exec, skipClosing){
  if(!skipClosing && !SAFE_CLOSING)return false;
  var safe = false;
  try {
    var arr  = [7]
      , iter = arr[ITERATOR]();
    iter.next = function(){ return {done: safe = true}; };
    arr[ITERATOR] = function(){ return iter; };
    exec(arr);
  } catch(e){ /* empty */ }
  return safe;
};

/***/ }),
/* 446 */
/***/ (function(module, exports) {

module.exports = function(done, value){
  return {value: value, done: !!done};
};

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys      = __webpack_require__(449)
  , hiddenKeys = __webpack_require__(278).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
  return $keys(O, hiddenKeys);
};

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has         = __webpack_require__(118)
  , toObject    = __webpack_require__(166)
  , IE_PROTO    = __webpack_require__(285)('IE_PROTO')
  , ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function(O){
  O = toObject(O);
  if(has(O, IE_PROTO))return O[IE_PROTO];
  if(typeof O.constructor == 'function' && O instanceof O.constructor){
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

var has          = __webpack_require__(118)
  , toIObject    = __webpack_require__(100)
  , arrayIndexOf = __webpack_require__(742)(false)
  , IE_PROTO     = __webpack_require__(285)('IE_PROTO');

module.exports = function(object, names){
  var O      = toIObject(object)
    , i      = 0
    , result = []
    , key;
  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while(names.length > i)if(has(O, key = names[i++])){
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(98);

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global      = __webpack_require__(55)
  , core        = __webpack_require__(37)
  , dP          = __webpack_require__(73)
  , DESCRIPTORS = __webpack_require__(77)
  , SPECIES     = __webpack_require__(48)('species');

module.exports = function(KEY){
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if(DESCRIPTORS && C && !C[SPECIES])dP.f(C, SPECIES, {
    configurable: true,
    get: function(){ return this; }
  });
};

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

var ctx                = __webpack_require__(97)
  , invoke             = __webpack_require__(751)
  , html               = __webpack_require__(440)
  , cel                = __webpack_require__(277)
  , global             = __webpack_require__(55)
  , process            = global.process
  , setTask            = global.setImmediate
  , clearTask          = global.clearImmediate
  , MessageChannel     = global.MessageChannel
  , counter            = 0
  , queue              = {}
  , ONREADYSTATECHANGE = 'onreadystatechange'
  , defer, channel, port;
var run = function(){
  var id = +this;
  if(queue.hasOwnProperty(id)){
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function(event){
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if(!setTask || !clearTask){
  setTask = function setImmediate(fn){
    var args = [], i = 1;
    while(arguments.length > i)args.push(arguments[i++]);
    queue[++counter] = function(){
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id){
    delete queue[id];
  };
  // Node.js 0.8-
  if(__webpack_require__(170)(process) == 'process'){
    defer = function(id){
      process.nextTick(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if(MessageChannel){
    channel = new MessageChannel;
    port    = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
    defer = function(id){
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if(ONREADYSTATECHANGE in cel('script')){
    defer = function(id){
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function(id){
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set:   setTask,
  clear: clearTask
};

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(74);
module.exports = function(it, msg){
  if(typeof it != 'number' && cof(it) != 'Number')throw TypeError(msg);
  return +it;
};

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(45)
  , toIndex  = __webpack_require__(126)
  , toLength = __webpack_require__(43);

module.exports = [].copyWithin || function copyWithin(target/*= 0*/, start/*= 0, end = @length*/){
  var O     = toObject(this)
    , len   = toLength(O.length)
    , to    = toIndex(target, len)
    , from  = toIndex(start, len)
    , end   = arguments.length > 2 ? arguments[2] : undefined
    , count = Math.min((end === undefined ? len : toIndex(end, len)) - from, len - to)
    , inc   = 1;
  if(from < to && to < from + count){
    inc  = -1;
    from += count - 1;
    to   += count - 1;
  }
  while(count-- > 0){
    if(from in O)O[to] = O[from];
    else delete O[to];
    to   += inc;
    from += inc;
  } return O;
};

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(142);

module.exports = function(iter, ITERATOR){
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(56)
  , toObject  = __webpack_require__(45)
  , IObject   = __webpack_require__(175)
  , toLength  = __webpack_require__(43);

module.exports = function(that, callbackfn, aLen, memo, isRight){
  aFunction(callbackfn);
  var O      = toObject(that)
    , self   = IObject(O)
    , length = toLength(O.length)
    , index  = isRight ? length - 1 : 0
    , i      = isRight ? -1 : 1;
  if(aLen < 2)for(;;){
    if(index in self){
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if(isRight ? index < 0 : length <= index){
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for(;isRight ? index >= 0 : length > index; index += i)if(index in self){
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction  = __webpack_require__(56)
  , isObject   = __webpack_require__(28)
  , invoke     = __webpack_require__(220)
  , arraySlice = [].slice
  , factories  = {};

var construct = function(F, len, args){
  if(!(len in factories)){
    for(var n = [], i = 0; i < len; i++)n[i] = 'a[' + i + ']';
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /*, args... */){
  var fn       = aFunction(this)
    , partArgs = arraySlice.call(arguments, 1);
  var bound = function(/* args... */){
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if(isObject(fn.prototype))bound.prototype = fn.prototype;
  return bound;
};

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP          = __webpack_require__(33).f
  , create      = __webpack_require__(121)
  , redefineAll = __webpack_require__(124)
  , ctx         = __webpack_require__(88)
  , anInstance  = __webpack_require__(119)
  , defined     = __webpack_require__(75)
  , forOf       = __webpack_require__(142)
  , $iterDefine = __webpack_require__(303)
  , step        = __webpack_require__(464)
  , setSpecies  = __webpack_require__(125)
  , DESCRIPTORS = __webpack_require__(32)
  , fastKey     = __webpack_require__(101).fastKey
  , SIZE        = DESCRIPTORS ? '_s' : 'size';

var getEntry = function(that, key){
  // fast case
  var index = fastKey(key), entry;
  if(index !== 'F')return that._i[index];
  // frozen object case
  for(entry = that._f; entry; entry = entry.n){
    if(entry.k == key)return entry;
  }
};

module.exports = {
  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
    var C = wrapper(function(that, iterable){
      anInstance(that, C, NAME, '_i');
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear(){
        for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){
          entry.r = true;
          if(entry.p)entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function(key){
        var that  = this
          , entry = getEntry(that, key);
        if(entry){
          var next = entry.n
            , prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if(prev)prev.n = next;
          if(next)next.p = prev;
          if(that._f == entry)that._f = next;
          if(that._l == entry)that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /*, that = undefined */){
        anInstance(this, C, 'forEach');
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)
          , entry;
        while(entry = entry ? entry.n : this._f){
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while(entry && entry.r)entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key){
        return !!getEntry(this, key);
      }
    });
    if(DESCRIPTORS)dP(C.prototype, 'size', {
      get: function(){
        return defined(this[SIZE]);
      }
    });
    return C;
  },
  def: function(that, key, value){
    var entry = getEntry(that, key)
      , prev, index;
    // change existing entry
    if(entry){
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if(!that._f)that._f = entry;
      if(prev)prev.n = entry;
      that[SIZE]++;
      // add to index
      if(index !== 'F')that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function(C, NAME, IS_MAP){
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function(iterated, kind){
      this._t = iterated;  // target
      this._k = kind;      // kind
      this._l = undefined; // previous
    }, function(){
      var that  = this
        , kind  = that._k
        , entry = that._l;
      // revert to the last existing entry
      while(entry && entry.r)entry = entry.p;
      // get next entry
      if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if(kind == 'keys'  )return step(0, entry.k);
      if(kind == 'values')return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(174)
  , from    = __webpack_require__(455);
module.exports = function(NAME){
  return function toJSON(){
    if(classof(this) != NAME)throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll       = __webpack_require__(124)
  , getWeak           = __webpack_require__(101).getWeak
  , anObject          = __webpack_require__(20)
  , isObject          = __webpack_require__(28)
  , anInstance        = __webpack_require__(119)
  , forOf             = __webpack_require__(142)
  , createArrayMethod = __webpack_require__(78)
  , $has              = __webpack_require__(52)
  , arrayFind         = createArrayMethod(5)
  , arrayFindIndex    = createArrayMethod(6)
  , id                = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function(that){
  return that._l || (that._l = new UncaughtFrozenStore);
};
var UncaughtFrozenStore = function(){
  this.a = [];
};
var findUncaughtFrozen = function(store, key){
  return arrayFind(store.a, function(it){
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function(key){
    var entry = findUncaughtFrozen(this, key);
    if(entry)return entry[1];
  },
  has: function(key){
    return !!findUncaughtFrozen(this, key);
  },
  set: function(key, value){
    var entry = findUncaughtFrozen(this, key);
    if(entry)entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function(key){
    var index = arrayFindIndex(this.a, function(it){
      return it[0] === key;
    });
    if(~index)this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
    var C = wrapper(function(that, iterable){
      anInstance(that, C, NAME, '_i');
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function(key){
        if(!isObject(key))return false;
        var data = getWeak(key);
        if(data === true)return uncaughtFrozenStore(this)['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key){
        if(!isObject(key))return false;
        var data = getWeak(key);
        if(data === true)return uncaughtFrozenStore(this).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function(that, key, value){
    var data = getWeak(anObject(key), true);
    if(data === true)uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(32) && !__webpack_require__(24)(function(){
  return Object.defineProperty(__webpack_require__(295)('div'), 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(28)
  , floor    = Math.floor;
module.exports = function isInteger(it){
  return !isObject(it) && isFinite(it) && floor(it) === it;
};

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(20);
module.exports = function(iterator, fn, value, entries){
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch(e){
    var ret = iterator['return'];
    if(ret !== undefined)anObject(ret.call(iterator));
    throw e;
  }
};

/***/ }),
/* 464 */
/***/ (function(module, exports) {

module.exports = function(done, value){
  return {value: value, done: !!done};
};

/***/ }),
/* 465 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x){
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys  = __webpack_require__(123)
  , gOPS     = __webpack_require__(224)
  , pIE      = __webpack_require__(176)
  , toObject = __webpack_require__(45)
  , IObject  = __webpack_require__(175)
  , $assign  = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(24)(function(){
  var A = {}
    , B = {}
    , S = Symbol()
    , K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function(k){ B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
  var T     = toObject(target)
    , aLen  = arguments.length
    , index = 1
    , getSymbols = gOPS.f
    , isEnum     = pIE.f;
  while(aLen > index){
    var S      = IObject(arguments[index++])
      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
      , length = keys.length
      , j      = 0
      , key;
    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
  } return T;
} : $assign;

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

var dP       = __webpack_require__(33)
  , anObject = __webpack_require__(20)
  , getKeys  = __webpack_require__(123);

module.exports = __webpack_require__(32) ? Object.defineProperties : function defineProperties(O, Properties){
  anObject(O);
  var keys   = getKeys(Properties)
    , length = keys.length
    , i = 0
    , P;
  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
  return O;
};

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(60)
  , gOPN      = __webpack_require__(122).f
  , toString  = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function(it){
  try {
    return gOPN(it);
  } catch(e){
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it){
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

var has          = __webpack_require__(52)
  , toIObject    = __webpack_require__(60)
  , arrayIndexOf = __webpack_require__(216)(false)
  , IE_PROTO     = __webpack_require__(308)('IE_PROTO');

module.exports = function(object, names){
  var O      = toIObject(object)
    , i      = 0
    , result = []
    , key;
  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while(names.length > i)if(has(O, key = names[i++])){
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys   = __webpack_require__(123)
  , toIObject = __webpack_require__(60)
  , isEnum    = __webpack_require__(176).f;
module.exports = function(isEntries){
  return function(it){
    var O      = toIObject(it)
      , keys   = getKeys(O)
      , length = keys.length
      , i      = 0
      , result = []
      , key;
    while(length > i)if(isEnum.call(O, key = keys[i++])){
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN     = __webpack_require__(122)
  , gOPS     = __webpack_require__(224)
  , anObject = __webpack_require__(20)
  , Reflect  = __webpack_require__(21).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it){
  var keys       = gOPN.f(anObject(it))
    , getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(21).parseFloat
  , $trim       = __webpack_require__(145).trim;

module.exports = 1 / $parseFloat(__webpack_require__(313) + '-0') !== -Infinity ? function parseFloat(str){
  var string = $trim(String(str), 3)
    , result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(21).parseInt
  , $trim     = __webpack_require__(145).trim
  , ws        = __webpack_require__(313)
  , hex       = /^[\-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix){
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;

/***/ }),
/* 474 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y){
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(43)
  , repeat   = __webpack_require__(312)
  , defined  = __webpack_require__(75);

module.exports = function(that, maxLength, fillString, left){
  var S            = String(defined(that))
    , stringLength = S.length
    , fillStr      = fillString === undefined ? ' ' : String(fillString)
    , intMaxLength = toLength(maxLength);
  if(intMaxLength <= stringLength || fillStr == '')return S;
  var fillLen = intMaxLength - stringLength
    , stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if(stringFiller.length > fillLen)stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(29);

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(458);

// 23.1 Map Objects
module.exports = __webpack_require__(217)('Map', function(get){
  return function Map(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key){
    var entry = strong.getEntry(this, key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value){
    return strong.def(this, key === 0 ? 0 : key, value);
  }
}, strong, true);

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if(__webpack_require__(32) && /./g.flags != 'g')__webpack_require__(33).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(219)
});

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(458);

// 23.2 Set Objects
module.exports = __webpack_require__(217)('Set', function(get){
  return function Set(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value){
    return strong.def(this, value = value === 0 ? 0 : value, value);
  }
}, strong);

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var each         = __webpack_require__(78)(0)
  , redefine     = __webpack_require__(58)
  , meta         = __webpack_require__(101)
  , assign       = __webpack_require__(466)
  , weak         = __webpack_require__(460)
  , isObject     = __webpack_require__(28)
  , getWeak      = meta.getWeak
  , isExtensible = Object.isExtensible
  , uncaughtFrozenStore = weak.ufstore
  , tmp          = {}
  , InternalMap;

var wrapper = function(get){
  return function WeakMap(){
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key){
    if(isObject(key)){
      var data = getWeak(key);
      if(data === true)return uncaughtFrozenStore(this).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value){
    return weak.def(this, key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(217)('WeakMap', wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if(new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7){
  InternalMap = weak.getConstructor(wrapper);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function(key){
    var proto  = $WeakMap.prototype
      , method = proto[key];
    redefine(proto, key, function(a, b){
      // store frozen objects on internal weakmap shim
      if(isObject(a) && !isExtensible(a)){
        if(!this._f)this._f = new InternalMap;
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.readState = exports.saveState = undefined;

var _warning = __webpack_require__(109);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuotaExceededErrors = {
  QuotaExceededError: true,
  QUOTA_EXCEEDED_ERR: true
};

var SecurityErrors = {
  SecurityError: true
};

var KeyPrefix = '@@History/';

var createKey = function createKey(key) {
  return KeyPrefix + key;
};

var saveState = exports.saveState = function saveState(key, state) {
  if (!window.sessionStorage) {
    // Session storage is not available or hidden.
    // sessionStorage is undefined in Internet Explorer when served via file protocol.
     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;

    return;
  }

  try {
    if (state == null) {
      window.sessionStorage.removeItem(createKey(key));
    } else {
      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
    }
  } catch (error) {
    if (SecurityErrors[error.name]) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;

      return;
    }

    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
      // Safari "private mode" throws QuotaExceededError.
       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;

      return;
    }

    throw error;
  }
};

var readState = exports.readState = function readState(key) {
  var json = void 0;
  try {
    json = window.sessionStorage.getItem(createKey(key));
  } catch (error) {
    if (SecurityErrors[error.name]) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;

      return undefined;
    }
  }

  if (json) {
    try {
      return JSON.parse(json);
    } catch (error) {
      // Ignore invalid JSON.
    }
  }

  return undefined;
};

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _runTransitionHook = __webpack_require__(331);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _PathUtils = __webpack_require__(104);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useBasename = function useBasename(createHistory) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var history = createHistory(options);
    var basename = options.basename;


    var addBasename = function addBasename(location) {
      if (!location) return location;

      if (basename && location.basename == null) {
        if (location.pathname.toLowerCase().indexOf(basename.toLowerCase()) === 0) {
          location.pathname = location.pathname.substring(basename.length);
          location.basename = basename;

          if (location.pathname === '') location.pathname = '/';
        } else {
          location.basename = '';
        }
      }

      return location;
    };

    var prependBasename = function prependBasename(location) {
      if (!basename) return location;

      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
      var pname = object.pathname;
      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
      var pathname = normalizedBasename + normalizedPathname;

      return _extends({}, object, {
        pathname: pathname
      });
    };

    // Override all read methods with basename-aware versions.
    var getCurrentLocation = function getCurrentLocation() {
      return addBasename(history.getCurrentLocation());
    };

    var listenBefore = function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
      });
    };

    var listen = function listen(listener) {
      return history.listen(function (location) {
        return listener(addBasename(location));
      });
    };

    // Override all write methods with basename-aware versions.
    var push = function push(location) {
      return history.push(prependBasename(location));
    };

    var replace = function replace(location) {
      return history.replace(prependBasename(location));
    };

    var createPath = function createPath(location) {
      return history.createPath(prependBasename(location));
    };

    var createHref = function createHref(location) {
      return history.createHref(prependBasename(location));
    };

    var createLocation = function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
    };

    return _extends({}, history, {
      getCurrentLocation: getCurrentLocation,
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation
    });
  };
};

exports.default = useBasename;

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _queryString = __webpack_require__(1122);

var _runTransitionHook = __webpack_require__(331);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _LocationUtils = __webpack_require__(146);

var _PathUtils = __webpack_require__(104);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStringifyQuery = function defaultStringifyQuery(query) {
  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
};

var defaultParseQueryString = _queryString.parse;

/**
 * Returns a new createHistory function that may be used to create
 * history objects that know how to handle URL queries.
 */
var useQueries = function useQueries(createHistory) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var history = createHistory(options);
    var stringifyQuery = options.stringifyQuery,
        parseQueryString = options.parseQueryString;


    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;

    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;

    var decodeQuery = function decodeQuery(location) {
      if (!location) return location;

      if (location.query == null) location.query = parseQueryString(location.search.substring(1));

      return location;
    };

    var encodeQuery = function encodeQuery(location, query) {
      if (query == null) return location;

      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
      var queryString = stringifyQuery(query);
      var search = queryString ? '?' + queryString : '';

      return _extends({}, object, {
        search: search
      });
    };

    // Override all read methods with query-aware versions.
    var getCurrentLocation = function getCurrentLocation() {
      return decodeQuery(history.getCurrentLocation());
    };

    var listenBefore = function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
      });
    };

    var listen = function listen(listener) {
      return history.listen(function (location) {
        return listener(decodeQuery(location));
      });
    };

    // Override all write methods with query-aware versions.
    var push = function push(location) {
      return history.push(encodeQuery(location, location.query));
    };

    var replace = function replace(location) {
      return history.replace(encodeQuery(location, location.query));
    };

    var createPath = function createPath(location) {
      return history.createPath(encodeQuery(location, location.query));
    };

    var createHref = function createHref(location) {
      return history.createHref(encodeQuery(location, location.query));
    };

    var createLocation = function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));

      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);

      return decodeQuery(newLocation);
    };

    return _extends({}, history, {
      getCurrentLocation: getCurrentLocation,
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation
    });
  };
};

exports.default = useQueries;

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlMessageFormat = __webpack_require__(985)['default'];

// Add all locale data to `IntlMessageFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(1191);

// Re-export `IntlMessageFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlMessageFormat;
exports['default'] = exports;


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports.extend = extend;
var hop = Object.prototype.hasOwnProperty;

function extend(obj) {
    var sources = Array.prototype.slice.call(arguments, 1),
        i, len, source, key;

    for (i = 0, len = sources.length; i < len; i += 1) {
        source = sources[i];
        if (!source) { continue; }

        for (key in source) {
            if (hop.call(source, key)) {
                obj[key] = source[key];
            }
        }
    }

    return obj;
}
exports.hop = hop;

//# sourceMappingURL=utils.js.map

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(1000);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(81);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(1033),
    isArguments = __webpack_require__(185),
    isArray = __webpack_require__(40),
    isBuffer = __webpack_require__(233),
    isIndex = __webpack_require__(246),
    isTypedArray = __webpack_require__(234);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 489 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(337),
    eq = __webpack_require__(167);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(1044);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(1023),
    baseMatchesProperty = __webpack_require__(1024),
    identity = __webpack_require__(130),
    isArray = __webpack_require__(40),
    property = __webpack_require__(1108);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(177),
    nativeKeys = __webpack_require__(1078);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(130),
    overRest = __webpack_require__(563),
    setToString = __webpack_require__(564);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(184),
    arrayMap = __webpack_require__(359),
    isArray = __webpack_require__(40),
    isSymbol = __webpack_require__(178);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(1032);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(129);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(561),
    arraySome = __webpack_require__(1007),
    cacheHas = __webpack_require__(562);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(505);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(1002),
    Map = __webpack_require__(334),
    Promise = __webpack_require__(1004),
    Set = __webpack_require__(638),
    WeakMap = __webpack_require__(1005),
    baseGetTag = __webpack_require__(105),
    toSource = __webpack_require__(507);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 502 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(41);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 504 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 505 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(1008),
    hasUnicode = __webpack_require__(502),
    unicodeToArray = __webpack_require__(1092);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),
/* 507 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(489),
    baseEach = __webpack_require__(338),
    baseIteratee = __webpack_require__(492),
    baseReduce = __webpack_require__(1030),
    isArray = __webpack_require__(40);

/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */
function reduce(collection, iteratee, accumulator) {
  var func = isArray(collection) ? arrayReduce : baseReduce,
      initAccum = arguments.length < 3;

  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
}

module.exports = reduce;


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EntitySchema = function () {
  function EntitySchema(key) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, EntitySchema);

    if (!key || typeof key !== 'string') {
      throw new Error('A string non-empty key is required');
    }

    this._key = key;
    this._assignEntity = options.assignEntity;

    var idAttribute = options.idAttribute || 'id';
    this._getId = typeof idAttribute === 'function' ? idAttribute : function (x) {
      return x[idAttribute];
    };
    this._idAttribute = idAttribute;
    this._meta = options.meta;
    this._defaults = options.defaults;
  }

  _createClass(EntitySchema, [{
    key: 'getAssignEntity',
    value: function getAssignEntity() {
      return this._assignEntity;
    }
  }, {
    key: 'getKey',
    value: function getKey() {
      return this._key;
    }
  }, {
    key: 'getId',
    value: function getId(entity, key) {
      return this._getId(entity, key);
    }
  }, {
    key: 'getIdAttribute',
    value: function getIdAttribute() {
      return this._idAttribute;
    }
  }, {
    key: 'getMeta',
    value: function getMeta(prop) {
      if (!prop || typeof prop !== 'string') {
        throw new Error('A string non-empty property name is required');
      }
      return this._meta && this._meta[prop];
    }
  }, {
    key: 'getDefaults',
    value: function getDefaults() {
      return this._defaults;
    }
  }, {
    key: 'define',
    value: function define(nestedSchema) {
      for (var key in nestedSchema) {
        if (nestedSchema.hasOwnProperty(key)) {
          this[key] = nestedSchema[key];
        }
      }
    }
  }]);

  return EntitySchema;
}();

exports.default = EntitySchema;

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _isObject = __webpack_require__(41);

var _isObject2 = _interopRequireDefault(_isObject);

var _UnionSchema = __webpack_require__(342);

var _UnionSchema2 = _interopRequireDefault(_UnionSchema);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ArraySchema = function () {
  function ArraySchema(itemSchema) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, ArraySchema);

    if (!(0, _isObject2.default)(itemSchema)) {
      throw new Error('ArraySchema requires item schema to be an object.');
    }

    if (options.schemaAttribute) {
      var schemaAttribute = options.schemaAttribute;
      this._itemSchema = new _UnionSchema2.default(itemSchema, { schemaAttribute: schemaAttribute });
    } else {
      this._itemSchema = itemSchema;
    }
  }

  _createClass(ArraySchema, [{
    key: 'getItemSchema',
    value: function getItemSchema() {
      return this._itemSchema;
    }
  }]);

  return ArraySchema;
}();

exports.default = ArraySchema;

/***/ }),
/* 511 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isObject2 = __webpack_require__(41);

var _isObject3 = _interopRequireDefault(_isObject2);

var _isArray2 = __webpack_require__(40);

var _isArray3 = _interopRequireDefault(_isArray2);

var _react = __webpack_require__(15);

var _react2 = _interopRequireDefault(_react);

var _objectUnfreeze = __webpack_require__(1119);

var _objectUnfreeze2 = _interopRequireDefault(_objectUnfreeze);

var _isIterable = __webpack_require__(1126);

var _isIterable2 = _interopRequireDefault(_isIterable);

var _parseStyleName = __webpack_require__(1128);

var _parseStyleName2 = _interopRequireDefault(_parseStyleName);

var _generateAppendClassName = __webpack_require__(1125);

var _generateAppendClassName2 = _interopRequireDefault(_generateAppendClassName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var linkElement = function linkElement(element, styles, configuration) {
  var appendClassName = void 0;
  var elementIsFrozen = void 0;
  var elementShallowCopy = void 0;

  elementShallowCopy = element;

  if (Object.isFrozen && Object.isFrozen(elementShallowCopy)) {
    elementIsFrozen = true;

    // https://github.com/facebook/react/blob/v0.13.3/src/classic/element/ReactElement.js#L131
    elementShallowCopy = (0, _objectUnfreeze2.default)(elementShallowCopy);
    elementShallowCopy.props = (0, _objectUnfreeze2.default)(elementShallowCopy.props);
  }

  var styleNames = (0, _parseStyleName2.default)(elementShallowCopy.props.styleName || '', configuration.allowMultiple);

  if (_react2.default.isValidElement(elementShallowCopy.props.children)) {
    elementShallowCopy.props.children = linkElement(_react2.default.Children.only(elementShallowCopy.props.children), styles, configuration);
  } else if ((0, _isArray3.default)(elementShallowCopy.props.children) || (0, _isIterable2.default)(elementShallowCopy.props.children)) {
    elementShallowCopy.props.children = _react2.default.Children.map(elementShallowCopy.props.children, function (node) {
      if (_react2.default.isValidElement(node)) {
        return linkElement(node, styles, configuration);
      } else {
        return node;
      }
    });
  }

  if (styleNames.length) {
    appendClassName = (0, _generateAppendClassName2.default)(styles, styleNames, configuration.errorWhenNotFound);

    if (appendClassName) {
      if (elementShallowCopy.props.className) {
        appendClassName = elementShallowCopy.props.className + ' ' + appendClassName;
      }

      elementShallowCopy.props.className = appendClassName;
    }
  }

  delete elementShallowCopy.props.styleName;

  if (elementIsFrozen) {
    Object.freeze(elementShallowCopy.props);
    Object.freeze(elementShallowCopy);
  }

  return elementShallowCopy;
};

/**
 * @param {ReactElement} element
 * @param {Object} styles CSS modules class map.
 * @param {CSSModules~Options} configuration
 */

exports.default = function (element) {
  var styles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var configuration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  // @see https://github.com/gajus/react-css-modules/pull/30
  if (!(0, _isObject3.default)(element)) {
    return element;
  }

  return linkElement(element, styles, configuration);
};

module.exports = exports['default'];

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (version) {
  var major = version.split('.')[0];

  return parseInt(major, 10) < 15 ? _react2.default.createElement('noscript') : null;
};

var _react = __webpack_require__(15);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(1138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(516);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + ('connect. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidMount` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          if (this.subscription) this.subscription.tryUnsubscribe();
          this.initSubscription();
          if (shouldHandleStateChanges) this.subscription.trySubscribe();
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(517);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(343);



function verifyPlainObject(value, displayName, methodName) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(value)) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * This action type will be dispatched by the history actions below.
 * If you're writing a middleware to watch for navigation events, be sure to
 * look for actions of this type.
 */
var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';

function updateLocation(method) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return {
      type: CALL_HISTORY_METHOD,
      payload: { method: method, args: args }
    };
  };
}

/**
 * These actions correspond to the history API.
 * The associated routerMiddleware will capture these events before they get to
 * your reducer and reissue them as the matching function on your history.
 */
var push = exports.push = updateLocation('push');
var replace = exports.replace = updateLocation('replace');
var go = exports.go = updateLocation('go');
var goBack = exports.goBack = updateLocation('goBack');
var goForward = exports.goForward = updateLocation('goForward');

var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.syncHistoryWithStore = undefined;

var _reducer = __webpack_require__(520);

Object.defineProperty(exports, 'LOCATION_CHANGE', {
  enumerable: true,
  get: function get() {
    return _reducer.LOCATION_CHANGE;
  }
});
Object.defineProperty(exports, 'routerReducer', {
  enumerable: true,
  get: function get() {
    return _reducer.routerReducer;
  }
});

var _actions = __webpack_require__(518);

Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
  enumerable: true,
  get: function get() {
    return _actions.CALL_HISTORY_METHOD;
  }
});
Object.defineProperty(exports, 'push', {
  enumerable: true,
  get: function get() {
    return _actions.push;
  }
});
Object.defineProperty(exports, 'replace', {
  enumerable: true,
  get: function get() {
    return _actions.replace;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _actions.go;
  }
});
Object.defineProperty(exports, 'goBack', {
  enumerable: true,
  get: function get() {
    return _actions.goBack;
  }
});
Object.defineProperty(exports, 'goForward', {
  enumerable: true,
  get: function get() {
    return _actions.goForward;
  }
});
Object.defineProperty(exports, 'routerActions', {
  enumerable: true,
  get: function get() {
    return _actions.routerActions;
  }
});

var _sync = __webpack_require__(1141);

var _sync2 = _interopRequireDefault(_sync);

var _middleware = __webpack_require__(1140);

var _middleware2 = _interopRequireDefault(_middleware);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports.syncHistoryWithStore = _sync2['default'];
exports.routerMiddleware = _middleware2['default'];

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.routerReducer = routerReducer;
/**
 * This action type will be dispatched when your history
 * receives a location change.
 */
var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

var initialState = {
  locationBeforeTransitions: null
};

/**
 * This reducer will update the state with the most recent location history
 * has transitioned to. This may not be in sync with the router, particularly
 * if you have asynchronously-loaded routes, so reading from and relying on
 * this state is discouraged.
 */
function routerReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      payload = _ref.payload;

  if (type === LOCATION_CHANGE) {
    return _extends({}, state, { locationBeforeTransitions: payload });
  }

  return state;
}

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PropTypes__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContextUtils__ = __webpack_require__(345);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
function isEmptyObject(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
  }return true;
}

function resolveToLocation(to, router) {
  return typeof to === 'function' ? to(router.location) : to;
}

/**
 * A <Link> is used to create an <a> element that links to a route.
 * When that route is active, the link gets the value of its
 * activeClassName prop.
 *
 * For example, assuming you have the following route:
 *
 *   <Route path="/posts/:postID" component={Post} />
 *
 * You could use the following component to link to that route:
 *
 *   <Link to={`/posts/${post.id}`} />
 */
var Link = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'Link',

  mixins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__ContextUtils__["b" /* ContextSubscriber */])('router')],

  contextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_4__PropTypes__["a" /* routerShape */]
  },

  propTypes: {
    to: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_2_prop_types__["string"], __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"], __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"]]),
    activeStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"],
    activeClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"],
    onlyActiveOnIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types__["bool"].isRequired,
    onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"],
    target: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"]
  },

  getDefaultProps: function getDefaultProps() {
    return {
      onlyActiveOnIndex: false,
      style: {}
    };
  },
  handleClick: function handleClick(event) {
    if (this.props.onClick) this.props.onClick(event);

    if (event.defaultPrevented) return;

    var router = this.context.router;

    !router ?  false ? invariant(false, '<Link>s rendered outside of a router context cannot navigate.') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;

    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;

    // If target prop is set (e.g. to "_blank"), let browser handle link.
    /* istanbul ignore if: untestable with Karma */
    if (this.props.target) return;

    event.preventDefault();

    router.push(resolveToLocation(this.props.to, router));
  },
  render: function render() {
    var _props = this.props,
        to = _props.to,
        activeClassName = _props.activeClassName,
        activeStyle = _props.activeStyle,
        onlyActiveOnIndex = _props.onlyActiveOnIndex,
        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);

    // Ignore if rendered outside the context of router to simplify unit testing.


    var router = this.context.router;


    if (router) {
      // If user does not specify a `to` prop, return an empty anchor tag.
      if (!to) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', props);
      }

      var toLocation = resolveToLocation(to, router);
      props.href = router.createHref(toLocation);

      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
        if (router.isActive(toLocation, onlyActiveOnIndex)) {
          if (activeClassName) {
            if (props.className) {
              props.className += ' ' + activeClassName;
            } else {
              props.className = activeClassName;
            }
          }

          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
        }
      }
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPromise;
function isPromise(obj) {
  return obj && typeof obj.then === 'function';
}

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RouteUtils__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PatternUtils__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(180);







/**
 * A <Redirect> is used to declare another URL path a client should
 * be sent to when they request a given URL.
 *
 * Redirects are placed alongside routes in the route configuration
 * and are traversed in the same manner.
 */
/* eslint-disable react/require-render-return */
var Redirect = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'Redirect',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element) {
      var route = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__RouteUtils__["c" /* createRouteFromReactElement */])(element);

      if (route.from) route.path = route.from;

      route.onEnter = function (nextState, replace) {
        var location = nextState.location,
            params = nextState.params;


        var pathname = void 0;
        if (route.to.charAt(0) === '/') {
          pathname = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__PatternUtils__["c" /* formatPattern */])(route.to, params);
        } else if (!route.to) {
          pathname = location.pathname;
        } else {
          var routeIndex = nextState.routes.indexOf(route);
          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
          pathname = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__PatternUtils__["c" /* formatPattern */])(pattern, params);
        }

        replace({
          pathname: pathname,
          query: route.query || location.query,
          state: route.state || location.state
        });
      };

      return route;
    },
    getRoutePattern: function getRoutePattern(routes, routeIndex) {
      var parentPattern = '';

      for (var i = routeIndex; i >= 0; i--) {
        var route = routes[i];
        var pattern = route.path || '';

        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;

        if (pattern.indexOf('/') === 0) break;
      }

      return '/' + parentPattern;
    }
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
    from: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"], // Alias for path
    to: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"].isRequired,
    query: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    state: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    onEnter: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<Redirect> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createRouterObject;
/* harmony export (immutable) */ __webpack_exports__["b"] = assignRouterState;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function createRouterObject(history, transitionManager, state) {
  var router = _extends({}, history, {
    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
    isActive: transitionManager.isActive
  });

  return assignRouterState(router, state);
}

function assignRouterState(router, _ref) {
  var location = _ref.location,
      params = _ref.params,
      routes = _ref.routes;

  router.location = location;
  router.params = params;
  router.routes = routes;

  return router;
}

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createMemoryHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory__ = __webpack_require__(977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory__);




function createMemoryHistory(options) {
  // signatures and type checking differ between `useQueries` and
  // `createMemoryHistory`, have to create `memoryHistory` first because
  // `useQueries` doesn't understand the signature
  var memoryHistory = __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory___default()(options);
  var createHistory = function createHistory() {
    return memoryHistory;
  };
  var history = __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default()(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default()(createHistory))(options);
  return history;
}

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createRouterHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__useRouterHistory__ = __webpack_require__(528);


var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

function createRouterHistory(createHistory) {
  var history = void 0;
  if (canUseDOM) history = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__useRouterHistory__["a" /* default */])(createHistory)();
  return history;
}

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTransitionManager;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routerWarning__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__ = __webpack_require__(1150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TransitionUtils__ = __webpack_require__(1147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isActive__ = __webpack_require__(1154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getComponents__ = __webpack_require__(1151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__matchRoutes__ = __webpack_require__(1156);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function hasAnyProperties(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
  }return false;
}

function createTransitionManager(history, routes) {
  var state = {};

  var _getTransitionUtils = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__TransitionUtils__["a" /* default */])(),
      runEnterHooks = _getTransitionUtils.runEnterHooks,
      runChangeHooks = _getTransitionUtils.runChangeHooks,
      runLeaveHooks = _getTransitionUtils.runLeaveHooks;

  // Signature should be (location, indexOnly), but needs to support (path,
  // query, indexOnly)


  function isActive(location, indexOnly) {
    location = history.createLocation(location);

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__isActive__["a" /* default */])(location, indexOnly, state.location, state.routes, state.params);
  }

  var partialNextState = void 0;

  function match(location, callback) {
    if (partialNextState && partialNextState.location === location) {
      // Continue from where we left off.
      finishMatch(partialNextState, callback);
    } else {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__matchRoutes__["a" /* default */])(routes, location, function (error, nextState) {
        if (error) {
          callback(error);
        } else if (nextState) {
          finishMatch(_extends({}, nextState, { location: location }), callback);
        } else {
          callback();
        }
      });
    }
  }

  function finishMatch(nextState, callback) {
    var _computeChangedRoutes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__["a" /* default */])(state, nextState),
        leaveRoutes = _computeChangedRoutes.leaveRoutes,
        changeRoutes = _computeChangedRoutes.changeRoutes,
        enterRoutes = _computeChangedRoutes.enterRoutes;

    runLeaveHooks(leaveRoutes, state);

    // Tear down confirmation hooks for left routes
    leaveRoutes.filter(function (route) {
      return enterRoutes.indexOf(route) === -1;
    }).forEach(removeListenBeforeHooksForRoute);

    // change and enter hooks are run in series
    runChangeHooks(changeRoutes, state, nextState, function (error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      runEnterHooks(enterRoutes, nextState, finishEnterHooks);
    });

    function finishEnterHooks(error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      // TODO: Fetch components after state is updated.
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__getComponents__["a" /* default */])(nextState, function (error, components) {
        if (error) {
          callback(error);
        } else {
          // TODO: Make match a pure function and have some other API
          // for "match and update state".
          callback(null, null, state = _extends({}, nextState, { components: components }));
        }
      });
    }

    function handleErrorOrRedirect(error, redirectInfo) {
      if (error) callback(error);else callback(null, redirectInfo);
    }
  }

  var RouteGuid = 1;

  function getRouteID(route) {
    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return route.__id__ || create && (route.__id__ = RouteGuid++);
  }

  var RouteHooks = Object.create(null);

  function getRouteHooksForRoutes(routes) {
    return routes.map(function (route) {
      return RouteHooks[getRouteID(route)];
    }).filter(function (hook) {
      return hook;
    });
  }

  function transitionHook(location, callback) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__matchRoutes__["a" /* default */])(routes, location, function (error, nextState) {
      if (nextState == null) {
        // TODO: We didn't actually match anything, but hang
        // onto error/nextState so we don't have to matchRoutes
        // again in the listen callback.
        callback();
        return;
      }

      // Cache some state here so we don't have to
      // matchRoutes() again in the listen callback.
      partialNextState = _extends({}, nextState, { location: location });

      var hooks = getRouteHooksForRoutes(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__["a" /* default */])(state, partialNextState).leaveRoutes);

      var result = void 0;
      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
        // Passing the location arg here indicates to
        // the user that this is a transition hook.
        result = hooks[i](location);
      }

      callback(result);
    });
  }

  /* istanbul ignore next: untestable with Karma */
  function beforeUnloadHook() {
    // Synchronously check to see if any route hooks want
    // to prevent the current window/tab from closing.
    if (state.routes) {
      var hooks = getRouteHooksForRoutes(state.routes);

      var message = void 0;
      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
        // Passing no args indicates to the user that this is a
        // beforeunload hook. We don't know the next location.
        message = hooks[i]();
      }

      return message;
    }
  }

  var unlistenBefore = void 0,
      unlistenBeforeUnload = void 0;

  function removeListenBeforeHooksForRoute(route) {
    var routeID = getRouteID(route);
    if (!routeID) {
      return;
    }

    delete RouteHooks[routeID];

    if (!hasAnyProperties(RouteHooks)) {
      // teardown transition & beforeunload hooks
      if (unlistenBefore) {
        unlistenBefore();
        unlistenBefore = null;
      }

      if (unlistenBeforeUnload) {
        unlistenBeforeUnload();
        unlistenBeforeUnload = null;
      }
    }
  }

  /**
   * Registers the given hook function to run before leaving the given route.
   *
   * During a normal transition, the hook function receives the next location
   * as its only argument and can return either a prompt message (string) to show the user,
   * to make sure they want to leave the page; or `false`, to prevent the transition.
   * Any other return value will have no effect.
   *
   * During the beforeunload event (in browsers) the hook receives no arguments.
   * In this case it must return a prompt message to prevent the transition.
   *
   * Returns a function that may be used to unbind the listener.
   */
  function listenBeforeLeavingRoute(route, hook) {
    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
    var routeID = getRouteID(route, true);

    RouteHooks[routeID] = hook;

    if (thereWereNoRouteHooks) {
      // setup transition & beforeunload hooks
      unlistenBefore = history.listenBefore(transitionHook);

      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
    }

    return function () {
      removeListenBeforeHooksForRoute(route);
    };
  }

  /**
   * This is the API for stateful environments. As the location
   * changes, we update state and call the listener. We can also
   * gracefully handle errors and redirects.
   */
  function listen(listener) {
    function historyListener(location) {
      if (state.location === location) {
        listener(null, state);
      } else {
        match(location, function (error, redirectLocation, nextState) {
          if (error) {
            listener(error);
          } else if (redirectLocation) {
            history.replace(redirectLocation);
          } else if (nextState) {
            listener(null, nextState);
          } else {
             false ? warning(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
          }
        });
      }
    }

    // TODO: Only use a single history listener. Otherwise we'll end up with
    // multiple concurrent calls to match.

    // Set up the history listener first in case the initial match redirects.
    var unsubscribe = history.listen(historyListener);

    if (state.location) {
      // Picking up on a matchContext.
      listener(null, state);
    } else {
      historyListener(history.getCurrentLocation());
    }

    return unsubscribe;
  }

  return {
    isActive: isActive,
    match: match,
    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
    listen: listen
  };
}

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useRouterHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__);



function useRouterHistory(createHistory) {
  return function (options) {
    var history = __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default()(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default()(createHistory))(options);
    return history;
  };
}

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ACTION_TYPE_DELIMITER = undefined;
exports.default = combineActions;

var _isString = __webpack_require__(248);

var _isString2 = _interopRequireDefault(_isString);

var _isFunction = __webpack_require__(107);

var _isFunction2 = _interopRequireDefault(_isFunction);

var _isEmpty = __webpack_require__(1104);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _toString = __webpack_require__(131);

var _toString2 = _interopRequireDefault(_toString);

var _isSymbol = __webpack_require__(178);

var _isSymbol2 = _interopRequireDefault(_isSymbol);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ACTION_TYPE_DELIMITER = exports.ACTION_TYPE_DELIMITER = '||';

function isValidActionType(actionType) {
  return (0, _isString2.default)(actionType) || (0, _isFunction2.default)(actionType) || (0, _isSymbol2.default)(actionType);
}

function isValidActionTypes(actionTypes) {
  if ((0, _isEmpty2.default)(actionTypes)) {
    return false;
  }
  return actionTypes.every(isValidActionType);
}

function combineActions() {
  for (var _len = arguments.length, actionsTypes = Array(_len), _key = 0; _key < _len; _key++) {
    actionsTypes[_key] = arguments[_key];
  }

  if (!isValidActionTypes(actionsTypes)) {
    throw new TypeError('Expected action types to be strings, symbols, or action creators');
  }

  var combinedActionType = actionsTypes.map(_toString2.default).join(ACTION_TYPE_DELIMITER);

  return { toString: function toString() {
      return combinedActionType;
    } };
}

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createAction;

var _identity = __webpack_require__(130);

var _identity2 = _interopRequireDefault(_identity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createAction(type, payloadCreator, metaCreator) {
  var finalPayloadCreator = typeof payloadCreator === 'function' ? payloadCreator : _identity2.default;

  var actionCreator = function actionCreator() {
    var hasError = (arguments.length <= 0 ? undefined : arguments[0]) instanceof Error;

    var action = {
      type: type
    };

    var payload = hasError ? arguments.length <= 0 ? undefined : arguments[0] : finalPayloadCreator.apply(undefined, arguments);
    if (!(payload === null || payload === undefined)) {
      action.payload = payload;
    }

    if (hasError || payload instanceof Error) {
      // Handle FSA errors where the payload is an Error object. Set error.
      action.error = true;
    }

    if (typeof metaCreator === 'function') {
      action.meta = metaCreator.apply(undefined, arguments);
    }

    return action;
  };

  actionCreator.toString = function () {
    return type.toString();
  };

  return actionCreator;
}

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = handleAction;

var _isFunction = __webpack_require__(107);

var _isFunction2 = _interopRequireDefault(_isFunction);

var _identity = __webpack_require__(130);

var _identity2 = _interopRequireDefault(_identity);

var _isNil = __webpack_require__(1105);

var _isNil2 = _interopRequireDefault(_isNil);

var _includes = __webpack_require__(1102);

var _includes2 = _interopRequireDefault(_includes);

var _combineActions = __webpack_require__(529);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function handleAction(actionType, reducers, defaultState) {
  var actionTypes = actionType.toString().split(_combineActions.ACTION_TYPE_DELIMITER);

  var _ref = (0, _isFunction2.default)(reducers) ? [reducers, reducers] : [reducers.next, reducers.throw].map(function (reducer) {
    return (0, _isNil2.default)(reducer) ? _identity2.default : reducer;
  });

  var _ref2 = _slicedToArray(_ref, 2);

  var nextReducer = _ref2[0];
  var throwReducer = _ref2[1];


  return function () {
    var state = arguments.length <= 0 || arguments[0] === undefined ? defaultState : arguments[0];
    var action = arguments[1];

    if (!(0, _includes2.default)(actionTypes, action.type.toString())) {
      return state;
    }

    return (action.error === true ? throwReducer : nextReducer)(state, action);
  };
}

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_symbol_observable__);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = observable, _ref2;
}

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AssertionError = function (_Error) {
  _inherits(AssertionError, _Error);

  function AssertionError(message) {
    _classCallCheck(this, AssertionError);

    var _this = _possibleConstructorReturn(this, (AssertionError.__proto__ || Object.getPrototypeOf(AssertionError)).call(this, message));

    _this.name = _this.constructor.name;
    return _this;
  }

  return AssertionError;
}(Error);

function assertDefined(target, message) {
  if (target === undefined) {
    throw new AssertionError(message);
  }
}

function assertObject(target, message) {
  if (target !== undefined && ((typeof target === 'undefined' ? 'undefined' : _typeof(target)) !== 'object' || Array.isArray(target) || target === null)) {
    throw new AssertionError(message);
  }
}

function assertOk(target, message) {
  if (!target) {
    throw new AssertionError(message);
  }
}

module.exports.defined = assertDefined;
module.exports.object = assertObject;
module.exports.ok = assertOk;
module.exports.AssertionError = AssertionError;
//# sourceMappingURL=assert.js.map

/***/ }),
/* 535 */,
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NAMES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return upload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return uploadByUrl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_redux_helpers_create_async_actions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_utils_adapters_vod__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_constants_uploading_statuses__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_redux_helpers_normalized__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dashboard_utils_progress_update_utils__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_dashboard_redux_helpers_upload__ = __webpack_require__(362);












var ACTIONS = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_redux_helpers_create_async_actions__["a" /* default */])('SERVER.VIDEO.UPLOAD', ['START', 'ITEM_CREATED', 'PROGRESS', 'SUCCESS', 'FAIL']);
var NAMES = ACTIONS.NAMES;
var START = ACTIONS.START,
    ITEM_CREATED = ACTIONS.ITEM_CREATED,
    PROGRESS = ACTIONS.PROGRESS,
    SUCCESS = ACTIONS.SUCCESS,
    FAIL = ACTIONS.FAIL;


function createNewItem(response, state, fakeVideoData, dispatch, analytics) {
  response = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, response, {
    // mark item as newly created
    data: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_shared_redux_helpers_normalized__["d" /* normalizeVideo */])(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, response.data, { isNew: true }))
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_dashboard_redux_helpers_upload__["b" /* addDataToSameChannelVideos */])(response.data, state);

  dispatch(SUCCESS(fakeVideoData, response, {
    analytics: {
      type: 'bi',
      payload: analytics
    }
  }));
  return response;
}

function handleError(response, state, videoId, fakeVideoData, dispatch, analytics) {
  var status = response.status,
      error = response.error;

  var data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_shared_redux_helpers_normalized__["d" /* normalizeVideo */])({
    id: videoId,
    error: error,
    uploadingStatus: __WEBPACK_IMPORTED_MODULE_5_shared_constants_uploading_statuses__["a" /* default */].FAILED
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_dashboard_redux_helpers_upload__["b" /* addDataToSameChannelVideos */])(data, state);
  dispatch(FAIL(fakeVideoData, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, response, { data: data }), {
    analytics: _.filter([{ type: 'bi', payload: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({ response: response }, analytics) }, { // for NewRelic
      type: 'detailed-error',
      payload: { name: 'upload-error', errorData: response }
    }, status > 500 || !error ? {
      type: 'error',
      payload: { name: 'dashboard.video.upload' }
    } : null])
  }));
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, response, { data: data }));
}

function upload(file, uiAnalytics) {
  return function (dispatch, getState) {
    var uploadKey = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol___default()('upload-key');
    var analytics = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({ uploadKey: uploadKey, file: file }, uiAnalytics);
    var fakeVideoData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_dashboard_redux_helpers_upload__["a" /* toFakeVideoData */])(file);

    var _getState = getState(),
        vodSettings = _getState.vodSettings;

    var defaultChannelId = vodSettings.defaultChannelId;


    var uploadPromise = __WEBPACK_IMPORTED_MODULE_4_shared_utils_adapters_vod__["a" /* default */].item.upload({
      file: file,
      title: fakeVideoData.title,
      listId: defaultChannelId
    });

    var on = uploadPromise.on,
        off = uploadPromise.off;

    _.assign(fakeVideoData, { on: on, off: off });

    dispatch(START(fakeVideoData, { data: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_shared_redux_helpers_normalized__["d" /* normalizeVideo */])(fakeVideoData) }, { analytics: { type: 'bi', payload: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({ uploadPromise: uploadPromise }, analytics) } }));

    var videoId = fakeVideoData.id;
    on(__WEBPACK_IMPORTED_MODULE_4_shared_utils_adapters_vod__["a" /* default */].events.ITEM.CREATE.SUCCESS, function (response) {
      videoId = response.data.id;
      response = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, response, {
        data: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_shared_redux_helpers_normalized__["d" /* normalizeVideo */])(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, fakeVideoData, response.data))
      });
      dispatch(ITEM_CREATED(fakeVideoData, response));
    });

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_dashboard_utils_progress_update_utils__["a" /* subscribeOnProgressUpdate */])(uploadPromise, function (_ref) {
      var uploadingStatus = _ref.uploadingStatus;

      // TODO: move to video and channelVideo reducers, subscribed to all ACTIONS
      var data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_shared_redux_helpers_normalized__["d" /* normalizeVideo */])({
        id: videoId,
        uploadingStatus: uploadingStatus
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_dashboard_redux_helpers_upload__["b" /* addDataToSameChannelVideos */])(data, getState());

      dispatch(PROGRESS(fakeVideoData, { data: data }));
    });

    return uploadPromise.then(function (response) {
      return createNewItem(response, getState(), fakeVideoData, dispatch, analytics);
    }, function (error) {
      return handleError(error, getState(), videoId, fakeVideoData, dispatch, analytics);
    });
  };
}

function uploadByUrl(file, uiAnalytics) {
  return function (dispatch, getState) {
    var uploadKey = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_symbol___default()('upload-key');
    var analytics = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({ uploadKey: uploadKey, file: file }, uiAnalytics);
    var fakeVideoData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_dashboard_redux_helpers_upload__["a" /* toFakeVideoData */])(file);

    var _getState2 = getState(),
        vodSettings = _getState2.vodSettings;

    var defaultChannelId = vodSettings.defaultChannelId;


    var uploadPromise = __WEBPACK_IMPORTED_MODULE_4_shared_utils_adapters_vod__["a" /* default */].item.uploadByUrl({
      file: file,
      title: fakeVideoData.title,
      listId: defaultChannelId
    });

    var on = uploadPromise.on,
        off = uploadPromise.off;

    _.assign(fakeVideoData, { on: on, off: off });

    dispatch(START(fakeVideoData, { data: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_shared_redux_helpers_normalized__["d" /* normalizeVideo */])(fakeVideoData) }, { analytics: { type: 'bi', payload: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({ uploadPromise: uploadPromise }, analytics) } }));

    var videoId = fakeVideoData.id;
    on(__WEBPACK_IMPORTED_MODULE_4_shared_utils_adapters_vod__["a" /* default */].events.ITEM.CREATE.SUCCESS, function (response) {
      videoId = response.data.id;
      response = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, response, {
        data: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_shared_redux_helpers_normalized__["d" /* normalizeVideo */])(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, fakeVideoData, response.data)),
        uploadingStatus: __WEBPACK_IMPORTED_MODULE_5_shared_constants_uploading_statuses__["a" /* default */].UPLOADING
      });
      dispatch(ITEM_CREATED(fakeVideoData, response));
    });

    var unsubscribeFn = void 0;

    return uploadPromise.then(function (_ref2) {
      var videoFile = _ref2.videoFile,
          itemResponse = _ref2.itemResponse;

      var fileId = _.get(videoFile, 'data.id');

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        unsubscribeFn = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_dashboard_utils_progress_update_utils__["b" /* subscribeOnAsyncUpdates */])(fileId, function (_ref3) {
          var uploadingStatus = _ref3.uploadingStatus;

          var data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_shared_redux_helpers_normalized__["d" /* normalizeVideo */])({
            id: videoId,
            uploadingStatus: uploadingStatus
          });
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_dashboard_redux_helpers_upload__["b" /* addDataToSameChannelVideos */])(data, getState());

          dispatch(PROGRESS(fakeVideoData, { data: data }));

          if (uploadingStatus === __WEBPACK_IMPORTED_MODULE_5_shared_constants_uploading_statuses__["a" /* default */].SUCCEEDED) {
            // video file successfully uploaded
            unsubscribeFn();
            resolve(itemResponse);
          } else if (uploadingStatus === __WEBPACK_IMPORTED_MODULE_5_shared_constants_uploading_statuses__["a" /* default */].FAILED) {
            // something went wrong
            unsubscribeFn();

            reject({
              data: {
                result: fileId,
                error: __WEBPACK_IMPORTED_MODULE_5_shared_constants_uploading_statuses__["a" /* default */].FAILED
              }
            });
          }
        });
      });
    })
    // upload updated item
    .then(function (itemResponse) {
      return __WEBPACK_IMPORTED_MODULE_4_shared_utils_adapters_vod__["a" /* default */].item.get(itemResponse.data.id);
    }).then(function (response) {
      return createNewItem(response, getState(), fakeVideoData, dispatch, analytics);
    }, function (error) {
      return handleError(error, getState(), videoId, fakeVideoData, dispatch, analytics);
    });
  };
}



/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NAMES; });
/* unused harmony export SUCCESS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_redux_helpers_create_async_actions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_utils_adapters_vod__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_constants_uploading_statuses__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_redux_helpers_normalized__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dashboard_redux_helpers_upload__ = __webpack_require__(362);










var ACTIONS = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_redux_helpers_create_async_actions__["a" /* default */])('SERVER.VIDEOS.CREATE', ['START', 'ITEM_CREATED', 'SUCCESS', 'FAIL']);
var NAMES = ACTIONS.NAMES;
var START = ACTIONS.START,
    ITEM_CREATED = ACTIONS.ITEM_CREATED,
    SUCCESS = ACTIONS.SUCCESS,
    FAIL = ACTIONS.FAIL;




/* harmony default export */ __webpack_exports__["b"] = (function (videoDataList, meta) {
  return function (dispatch, getState) {
    var _getState = getState(),
        vodSettings = _getState.vodSettings;

    var defaultChannelId = vodSettings.defaultChannelId;


    var fakeVideoDataList = _.map(videoDataList, function (videoData) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_dashboard_redux_helpers_upload__["a" /* toFakeVideoData */])(), videoData);
    });

    dispatch(START(fakeVideoDataList, { data: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_redux_helpers_normalized__["c" /* normalizeArrayOfVideos */])(fakeVideoDataList) }, meta));

    var createPromise = __WEBPACK_IMPORTED_MODULE_2_shared_utils_adapters_vod__["a" /* default */].items.createInList(videoDataList, defaultChannelId);

    createPromise.on(__WEBPACK_IMPORTED_MODULE_2_shared_utils_adapters_vod__["a" /* default */].events.ITEMS.CREATE.SUCCESS, function (response) {
      var data = _.map(response.data, function (data, i) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, fakeVideoDataList[i], data, {
          uploadingStatus: __WEBPACK_IMPORTED_MODULE_3_shared_constants_uploading_statuses__["a" /* default */].SUCCEEDED
        });
      });

      response = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, response, { data: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_redux_helpers_normalized__["c" /* normalizeArrayOfVideos */])(data) });
      dispatch(ITEM_CREATED(fakeVideoDataList, response, meta));
    });

    return createPromise.then(function (response) {
      var data = _.map(response.data, function (data) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, {
          uploadingStatus: __WEBPACK_IMPORTED_MODULE_3_shared_constants_uploading_statuses__["a" /* default */].SUCCEEDED
        });
      });

      response = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, response, { data: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_redux_helpers_normalized__["c" /* normalizeArrayOfVideos */])(data) });

      dispatch(SUCCESS(fakeVideoDataList, response, meta));
      return response;
    }, function (error) {
      dispatch(FAIL(fakeVideoDataList, error, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, meta, {
        analytics: [{ type: 'error', name: 'dashboard.video.create' }, {
          type: 'detailed-error',
          payload: { name: 'upload-error', errorData: error }
        }]
      })));
      return error;
    });
  };
});

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = subscribeOnAsyncUpdates;
/* harmony export (immutable) */ __webpack_exports__["a"] = subscribeOnProgressUpdate;
/* unused harmony export subscribeOnUploadStart */
/* harmony export (immutable) */ __webpack_exports__["c"] = subscribeOnActiveStatusChanged;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_utils_adapters_vod__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_constants_uploading_statuses__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_constants_async_uploading_statuses__ = __webpack_require__(658);




var UPDATE_PROGRESS_EVENT = __WEBPACK_IMPORTED_MODULE_0_shared_utils_adapters_vod__["a" /* default */].events.UPLOADING_PROGRESS.UPDATE;
var events = __WEBPACK_IMPORTED_MODULE_0_shared_utils_adapters_vod__["a" /* default */].events;


function getUploadingStatusFromTranscoding(transcodingStatus) {
  if (transcodingStatus === __WEBPACK_IMPORTED_MODULE_2_shared_constants_async_uploading_statuses__["a" /* default */].FAILED) {
    return __WEBPACK_IMPORTED_MODULE_1_shared_constants_uploading_statuses__["a" /* default */].FAILED;
  } else if (transcodingStatus === __WEBPACK_IMPORTED_MODULE_2_shared_constants_async_uploading_statuses__["a" /* default */].INPROGRESS || transcodingStatus === __WEBPACK_IMPORTED_MODULE_2_shared_constants_async_uploading_statuses__["a" /* default */].PREVIEW_READY || transcodingStatus === __WEBPACK_IMPORTED_MODULE_2_shared_constants_async_uploading_statuses__["a" /* default */].READY) {
    return __WEBPACK_IMPORTED_MODULE_1_shared_constants_uploading_statuses__["a" /* default */].SUCCEEDED;
  } else if (transcodingStatus === __WEBPACK_IMPORTED_MODULE_2_shared_constants_async_uploading_statuses__["a" /* default */].UPLOADING || transcodingStatus === __WEBPACK_IMPORTED_MODULE_2_shared_constants_async_uploading_statuses__["a" /* default */].IN_STORAGE || transcodingStatus === __WEBPACK_IMPORTED_MODULE_2_shared_constants_async_uploading_statuses__["a" /* default */].IN_QUEUE) {
    return __WEBPACK_IMPORTED_MODULE_1_shared_constants_uploading_statuses__["a" /* default */].PROCESSING;
  }

  return __WEBPACK_IMPORTED_MODULE_1_shared_constants_uploading_statuses__["a" /* default */].UPLOADING;
}

function subscribeOnAsyncUpdates(fileId, callback) {
  var onUpdate = function onUpdate(_ref) {
    var id = _ref.id,
        transcodingStatus = _ref.transcodingStatus;

    if (id === fileId) {
      return callback({
        uploadingStatus: getUploadingStatusFromTranscoding(transcodingStatus.toUpperCase())
      });
    }
  };

  events.on(events.TRANSCODING.UPDATE, onUpdate);

  // return unsubscribe function
  return function () {
    return events.off(events.TRANSCODING.UPDATE, onUpdate);
  };
}

function subscribeOnProgressUpdate(uploadPromise, callback) {
  if (!_.isFunction(callback)) {
    return;
  }

  var on = uploadPromise.on;

  var prevUploadingStatus = null;

  on(UPDATE_PROGRESS_EVENT, function (progress) {
    var uploadingStatus = progress.uploadingStatus;

    if (
    // fix slow app render
    uploadingStatus === prevUploadingStatus ||
    // for cancellation error recognition. Status will be applied at catch
    uploadingStatus === __WEBPACK_IMPORTED_MODULE_1_shared_constants_uploading_statuses__["a" /* default */].FAILED) {
      return;
    }
    prevUploadingStatus = uploadingStatus;

    callback(progress);
  });
}

function subscribeOnUploadStart(uploadPromise, callback) {
  if (!_.isFunction(callback)) {
    return;
  }

  var on = uploadPromise.on,
      off = uploadPromise.off;

  var progressFn = function progressFn(progress) {
    off(UPDATE_PROGRESS_EVENT, progressFn);
    callback(progress);
  };

  on(UPDATE_PROGRESS_EVENT, progressFn);
}

var activeStauses = [__WEBPACK_IMPORTED_MODULE_1_shared_constants_uploading_statuses__["a" /* default */].UPLOADING, __WEBPACK_IMPORTED_MODULE_1_shared_constants_uploading_statuses__["a" /* default */].PROCESSING];

function subscribeOnActiveStatusChanged(uploadPromise, callback) {
  if (!_.isFunction(callback)) {
    return;
  }

  var currentStatus = 'unknown';

  var progressFn = function progressFn(_ref2) {
    var uploadingStatus = _ref2.uploadingStatus;

    if (currentStatus === uploadingStatus || !_.includes(activeStauses, uploadingStatus)) {
      return;
    }
    currentStatus = uploadingStatus;
    callback(currentStatus);
  };

  uploadPromise.on(UPDATE_PROGRESS_EVENT, progressFn);
}

/***/ }),
/* 539 */,
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NAMES; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_redux_helpers_create_async_actions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_utils_http__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_utils_get_query_params__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_utils_wix_sdk__ = __webpack_require__(25);









var ACTIONS = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_redux_helpers_create_async_actions__["a" /* default */])('SERVER.EXPERIMENTS');
var NAMES = ACTIONS.NAMES;
var START = ACTIONS.START,
    SUCCESS = ACTIONS.SUCCESS,
    FAIL = ACTIONS.FAIL;


function getExperimentsFromUrl() {
  return __WEBPACK_IMPORTED_MODULE_7_shared_utils_wix_sdk__["a" /* default */].Settings.getSiteInfo().then(function (_ref) {
    var url = _ref.url;

    var queryParams = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_shared_utils_get_query_params__["a" /* default */])(url);

    var _queryParams$experime = queryParams.experiments,
        experiments = _queryParams$experime === undefined ? '' : _queryParams$experime;

    return _.reduce(experiments.split(','), function (acc, name) {
      if (name) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, acc, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, name, 'true'));
      }
      return acc;
    }, {});
  });
}

/* harmony default export */ __webpack_exports__["b"] = (function () {
  return function (dispatch) {
    dispatch(START());

    var experimentsUrl = 'https://www.wix.com/_api/wix-laboratory-server/laboratory/conductAllInScope?scope=vod';

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_5_shared_utils_http__["a" /* default */].get(experimentsUrl), getExperimentsFromUrl()]).then(function (_ref2) {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref2, 2),
          response = _ref3[0],
          expsFromUrl = _ref3[1];

      dispatch(SUCCESS({}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, response.data, expsFromUrl)));
    }, function (response) {
      dispatch(FAIL({}, response, { analytics: { type: 'error', name: 'shared.experiments.get' } }));
    });
  };
});

/***/ }),
/* 541 */,
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return categories; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__ = __webpack_require__(1197);


var _defineMessages, _defineMessages2;





/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* defineMessages */])((_defineMessages = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].DIRECTOR, {
  id: 'shared.crew.director',
  defaultMessage: 'Director'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].CO_DIRECTOR, {
  id: 'shared.crew.co-director',
  defaultMessage: 'Co-Director'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].PRODUCER, {
  id: 'shared.crew.producer',
  defaultMessage: 'Producer'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].EXECUTIVE_PRODUCER, {
  id: 'shared.crew.executive-producer',
  defaultMessage: 'Executive Producer'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].CO_PRODUCER, {
  id: 'shared.crew.co-producer',
  defaultMessage: 'Co-Producer'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].ASSOCIATE_PRODUCER, {
  id: 'shared.crew.associate-producer',
  defaultMessage: 'Associate Producer'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].COLLABORATING_DIRECTOR, {
  id: 'shared.crew.collaborating-director',
  defaultMessage: 'Collaborating Director'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].PRODUCTION_MANAGER, {
  id: 'shared.crew.production-manager',
  defaultMessage: 'Production Manager'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].PRODUCTION_COORDINATOR, {
  id: 'shared.crew.production-coordinator',
  defaultMessage: 'Production Coordinator'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].PRODUCTION_ASSISTANT, {
  id: 'shared.crew.production-assistant',
  defaultMessage: 'Production Assistant'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].ASSISTANT_DIRECTOR, {
  id: 'shared.crew.assistant-director',
  defaultMessage: 'Assistant Director'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */]['2ND_ASSISTANT_DIRECTOR'], {
  id: 'shared.crew.2nd-assistant-director',
  defaultMessage: '2nd Assistant Director'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].SCRIPT_SUPERVISOR, {
  id: 'shared.crew.script-supervisor',
  defaultMessage: 'Script Supervisor'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].LOCATION_MANAGER, {
  id: 'shared.crew.location-manager',
  defaultMessage: 'Location Manager'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].WRITER, {
  id: 'shared.crew.writer',
  defaultMessage: 'Writer'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].CO_WRITER, {
  id: 'shared.crew.co-writer',
  defaultMessage: 'Co-Writer'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].STORY, {
  id: 'shared.crew.story',
  defaultMessage: 'Story'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].ADAPTATION, {
  id: 'shared.crew.adaptation',
  defaultMessage: 'Adaptation'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].AUTHOR_OF_ADAPTED_MATERIAL, {
  id: 'shared.crew.author-of-adapted-material',
  defaultMessage: 'Author of Adapted Material'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].CINEMATOGRAPHER_DP, {
  id: 'shared.crew.cinematographer-dp',
  defaultMessage: 'Cinematographer/DP'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].ASSISTANT_CAMERA, {
  id: 'shared.crew.assistant-camera',
  defaultMessage: 'Assistant Camera'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].ADDITIONAL_PHOTOGRAPHY, {
  id: 'shared.crew.additional-photography',
  defaultMessage: 'Additional Photography'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */]['2ND_UNIT_DIR_OF_PHOTOGRAPHY'], {
  id: 'shared.crew.2nd-unit-dir-of-photography',
  defaultMessage: '2nd Unit Dir of Photography'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].CAMERA_OPERATOR, {
  id: 'shared.crew.camera-operator',
  defaultMessage: 'Camera Operator'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].GAFFER, {
  id: 'shared.crew.gaffer',
  defaultMessage: 'Gaffer'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].BEST_BOY, {
  id: 'shared.crew.best-boy',
  defaultMessage: 'Best Boy'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].KEY_GRIP, {
  id: 'shared.crew.key-grip',
  defaultMessage: 'Key Grip'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].ADDITIONAL_GRIP, {
  id: 'shared.crew.additional-grip',
  defaultMessage: 'Additional Grip'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].DOLLY_GRIP, {
  id: 'shared.crew.dolly-grip',
  defaultMessage: 'Dolly Grip'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].GRIP, {
  id: 'shared.crew.grip',
  defaultMessage: 'Grip'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].SOUND_MIXER, {
  id: 'shared.crew.sound-mixer',
  defaultMessage: 'Sound Mixer'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].BOOM_OPERATOR, {
  id: 'shared.crew.boom-operator',
  defaultMessage: 'Boom Operator'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].CABLE_PERSON, {
  id: 'shared.crew.cable-person',
  defaultMessage: 'Cable Person'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].VIDEO_OPERATOR, {
  id: 'shared.crew.video-operator',
  defaultMessage: 'Video Operator'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].ART_DIRECTOR, {
  id: 'shared.crew.art-director',
  defaultMessage: 'Art Director'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].ASSISTANT_ART_DIRECTOR, {
  id: 'shared.crew.assistant-art-director',
  defaultMessage: 'Assistant Art Director'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].COSTUME_DESIGNER, {
  id: 'shared.crew.costume-designer',
  defaultMessage: 'Costume Designer'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].COSTUMER, {
  id: 'shared.crew.costumer',
  defaultMessage: 'Costumer'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].HAIRSTYLIST, {
  id: 'shared.crew.hairstylist',
  defaultMessage: 'Hairstylist'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].LEAD_PERSON, {
  id: 'shared.crew.lead-person',
  defaultMessage: 'Lead Person'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].MAKEUP_ARTIST, {
  id: 'shared.crew.makeup-artist',
  defaultMessage: 'Makeup Artist'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].MAKEUP_EFFECTS, {
  id: 'shared.crew.makeup-effects',
  defaultMessage: 'Makeup Effects'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].PRODUCTION_DESIGNER, {
  id: 'shared.crew.production-designer',
  defaultMessage: 'Production Designer'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].PROPERTY_MASTER, {
  id: 'shared.crew.property-master',
  defaultMessage: 'Property Master'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].SET_DECORATOR, {
  id: 'shared.crew.set-decorator',
  defaultMessage: 'Set Decorator'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].SET_DESIGNER, {
  id: 'shared.crew.set-designer',
  defaultMessage: 'Set Designer'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].SWING_GANG, {
  id: 'shared.crew.swing-gang',
  defaultMessage: 'Swing Gang'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].ANIMAL_TRAINER, {
  id: 'shared.crew.animal-trainer',
  defaultMessage: 'Animal Trainer'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].CHOREOGRAPHER, {
  id: 'shared.crew.choreographer',
  defaultMessage: 'Choreographer'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].SPECIAL_EFFECTS, {
  id: 'shared.crew.special-effects',
  defaultMessage: 'Special Effects'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].STUNT_COORDINATOR, {
  id: 'shared.crew.stunt-coordinator',
  defaultMessage: 'Stunt Coordinator'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].TECHNICAL_ADVISOR, {
  id: 'shared.crew.technical-advisor',
  defaultMessage: 'Technical Advisor'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].EDITOR, {
  id: 'shared.crew.editor',
  defaultMessage: 'Editor'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].ASSISTANT_EDITOR, {
  id: 'shared.crew.assistant-editor',
  defaultMessage: 'Assistant Editor'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].SOUND_EDITOR, {
  id: 'shared.crew.sound-editor',
  defaultMessage: 'Sound Editor'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].DIGITAL_EFFECTS, {
  id: 'shared.crew.digital-effects',
  defaultMessage: 'Digital Effects'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].ORIGINAL_MUSIC_COMPOSER, {
  id: 'shared.crew.original-music-composer',
  defaultMessage: 'Original Music/Composer'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].ANIMATOR, {
  id: 'shared.crew.animator',
  defaultMessage: 'Animator'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].AGENT, {
  id: 'shared.crew.agent',
  defaultMessage: 'Agent'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].MANAGER, {
  id: 'shared.crew.manager',
  defaultMessage: 'Manager'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].PUBLICIST, {
  id: 'shared.crew.publicist',
  defaultMessage: 'Publicist'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].PRINT_SHIPPER, {
  id: 'shared.crew.print-shipper',
  defaultMessage: 'Print Shipper'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].PRINT_RETURN, {
  id: 'shared.crew.print-return',
  defaultMessage: 'Print Return'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].PREVIEW_RETURN, {
  id: 'shared.crew.preview-return',
  defaultMessage: 'Preview Return'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].ACADEMIC_ADVISOR, {
  id: 'shared.crew.academic-advisor',
  defaultMessage: 'Academic Advisor'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["a" /* roles */].SCHOOL_ADMINISTRATOR, {
  id: 'shared.crew.school-administrator',
  defaultMessage: 'School Administrator'
}), _defineMessages)));

var categories = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* defineMessages */])((_defineMessages2 = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages2, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["b" /* categories */].POPULAR, {
  id: 'shared.crew-category.popular',
  defaultMessage: 'Popular'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages2, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["b" /* categories */].PRODUCTION, {
  id: 'shared.crew-category.production',
  defaultMessage: 'Production'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages2, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["b" /* categories */].WRITING, {
  id: 'shared.crew-category.writing',
  defaultMessage: 'Writing'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages2, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["b" /* categories */].CAMERA, {
  id: 'shared.crew-category.camera',
  defaultMessage: 'Camera'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages2, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["b" /* categories */].ELECTRICS, {
  id: 'shared.crew-category.electrics',
  defaultMessage: 'Electrics'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages2, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["b" /* categories */].GRIP, {
  id: 'shared.crew-category.grip',
  defaultMessage: 'Grip'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages2, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["b" /* categories */].SOUND_AND_VIDEO, {
  id: 'shared.crew-category.sound-and-video',
  defaultMessage: 'Sound and video'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages2, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["b" /* categories */].ART, {
  id: 'shared.crew-category.art',
  defaultMessage: 'Art'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages2, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["b" /* categories */].SPECIALIZED, {
  id: 'shared.crew-category.specialized',
  defaultMessage: 'Specialized'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages2, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["b" /* categories */].POST_PRODUCTION, {
  id: 'shared.crew-category.post-production',
  defaultMessage: 'Post Production'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages2, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["b" /* categories */].ANIMATION, {
  id: 'shared.crew-category.animation',
  defaultMessage: 'Animation'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages2, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["b" /* categories */].REPRESENTATION, {
  id: 'shared.crew-category.representation',
  defaultMessage: 'Representation'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages2, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["b" /* categories */].PRINT_TRAFFIC, {
  id: 'shared.crew-category.print-traffic',
  defaultMessage: 'Print Traffic'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages2, __WEBPACK_IMPORTED_MODULE_2_shared_constants_crew__["b" /* categories */].ACADEMIC, {
  id: 'shared.crew-category.academic',
  defaultMessage: 'Academic'
}), _defineMessages2));

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = isSubscribedTo;
/* harmony export (immutable) */ __webpack_exports__["a"] = isSubscriptionEnabled;
/* harmony export (immutable) */ __webpack_exports__["c"] = getDealInfo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_utils_deal_info_helpers__ = __webpack_require__(82);


function isSubscribedTo(channel) {
  return Boolean(_.get(channel, 'dgsInfo.subscription'));
}

function isSubscriptionEnabled(channel) {
  return Boolean(__WEBPACK_IMPORTED_MODULE_0_shared_utils_deal_info_helpers__["a" /* getSubscriptionPriceInfo */](channel.dealInfo));
}

function getDealInfo(props) {
  return _.get(props, 'channelData.dealInfo');
}

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isVisible;
/* harmony export (immutable) */ __webpack_exports__["b"] = renderSubscribeButtonText;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_utils_deal_info_helpers__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_translations_overlay_common_translations__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__format_message_with_deal_info__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_ui_selectors_channel_pricing__ = __webpack_require__(543);





/**
 * Is video subscribe button visible
 * @param props {Object}
 * @param props.channel {Object}
 * @return {Boolean}
 */
function isVisible(_ref) {
  var channel = _ref.channel;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_ui_selectors_channel_pricing__["a" /* isSubscriptionEnabled */])(channel) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_ui_selectors_channel_pricing__["b" /* isSubscribedTo */])(channel);
}

/**
 * Video sign in to play button text
 * @param props {Object}
 * @param props.channel {Object}
 * @param props.translation {Object} default is commonTranslations.getSubscription
 * @return {React.Component}
 */
function renderSubscribeButtonText(props) {
  if (!isVisible(props)) {
    return null;
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__format_message_with_deal_info__["a" /* default */])(props.translation || __WEBPACK_IMPORTED_MODULE_1_shared_translations_overlay_common_translations__["a" /* default */].getSubscription, __WEBPACK_IMPORTED_MODULE_0_shared_utils_deal_info_helpers__["a" /* getSubscriptionPriceInfo */](props.channel.dealInfo));
}

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* defineMessages */])({
  subscribe: {
    id: 'actions.subscribe',
    defaultMessage: 'Subscribe {price}/month'
  },
  buy: {
    id: 'actions.buy',
    defaultMessage: 'Buy {price}'
  },
  rent: {
    id: 'actions.rent',
    defaultMessage: 'Rent {price}'
  },
  buyFrom: {
    id: 'actions.buy-from',
    defaultMessage: 'Buy from {price}'
  },
  purchased: {
    id: 'actions.purchased',
    defaultMessage: 'You own this video'
  },
  rented: {
    id: 'actions.rented',
    defaultMessage: 'Rented until {date}'
  }
}));

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getMainVideoId; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_selectors_channels__ = __webpack_require__(71);




var getSelectedVideoIdFromStore = function getSelectedVideoIdFromStore(state) {
  return state.selectedVideoId;
};
var getFeaturedVideoId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([__WEBPACK_IMPORTED_MODULE_1_shared_selectors_channels__["a" /* getChannelForWidget */]], function (channel) {
  return _.get(channel, 'featuredItem');
});
var getFirstVideoFromList = function getFirstVideoFromList(state, listType) {
  return _.get(state.lazyVideoLists[listType], 'idChunks[0][0]') || _.get(state.lazyVideoLists[listType], 'videoIds[0]');
};

var getMainVideoId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getSelectedVideoIdFromStore, getFeaturedVideoId, getFirstVideoFromList], function (selectedVideoId, featuredVideoId, firstVideoId) {
  return selectedVideoId || featuredVideoId || firstVideoId;
});

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return BUY_BUTTON_DISPLAY_TYPES; });
/* unused harmony export PLAY_BUTTON_DISPLAY_TYPES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PLAY_BUTTON_TYPES; });
/* harmony export (immutable) */ __webpack_exports__["d"] = getBuyButtonDisplayTypeWhenInOverlay;
/* unused harmony export canAccessFullVersionOfVideo */
/* harmony export (immutable) */ __webpack_exports__["g"] = getBuyButtonDisplayType;
/* unused harmony export getBuyButtonDisplayTypeForPaidVideo */
/* harmony export (immutable) */ __webpack_exports__["e"] = shouldShowSubscribeButton;
/* harmony export (immutable) */ __webpack_exports__["h"] = mainItemIsChannelCover;
/* harmony export (immutable) */ __webpack_exports__["a"] = shouldShowChannelCover;
/* harmony export (immutable) */ __webpack_exports__["b"] = getPlayButtonType;
/* unused harmony export isSubscribedToChannel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_utils_deal_info_helpers__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_default_settings__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_ui_selectors_video_pricing__ = __webpack_require__(573);




var BUY_BUTTON_DISPLAY_TYPES = {
  BUY: 'buy',
  RENT: 'rent',
  BUY_FROM: 'from',
  NONE: 'none'
};

var PLAY_BUTTON_DISPLAY_TYPES = {
  PLAY_VIDEO: 'play-video',
  WATCH_NOW: 'watch-now',
  WATCH_TRAILER: 'watch-trailer',
  WATCH_PREVIEW: 'watch-preview',
  NONE: 'none'
};

var PLAY_BUTTON_TYPES = {
  PLAY: 'play',
  TRAILER_OR_PREVIEW: 'trailer_or_preview'
};

// Todo: remove. Use widget/ui-selectors/video-access
function getBuyButtonDisplayTypeWhenInOverlay(_ref) {
  var settings = _ref.settings,
      videoItem = _ref.videoItem,
      channelData = _ref.channelData,
      showChannelCover = _ref.showChannelCover;

  // case when user has not yet selected any video
  if (showChannelCover) {
    // only show buy button for featured video or when a video is ended. Otherwise no buy button
    if (mainItemIsChannelCover(settings)) {
      return BUY_BUTTON_DISPLAY_TYPES.NONE;
    }
  }

  return getBuyButtonDisplayType(channelData, videoItem);
}

function canAccessPaidVideo(channelData, videoItem) {
  if (isSubscribedToChannel(channelData) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_ui_selectors_video_pricing__["a" /* isRented */])(videoItem) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_ui_selectors_video_pricing__["b" /* isBought */])(videoItem)) {
    return true;
  }
}

function canAccessFullVersionOfVideo(channelData, videoItem) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_ui_selectors_video_pricing__["c" /* isFree */])(videoItem) || canAccessPaidVideo(channelData, videoItem);
}

function getBuyButtonDisplayType(channelData, videoItem) {
  if (canAccessPaidVideo(channelData, videoItem)) {
    return BUY_BUTTON_DISPLAY_TYPES.NONE;
  }

  return getBuyButtonDisplayTypeForPaidVideo(videoItem);
}

function getBuyButtonDisplayTypeForPaidVideo(videoItem) {
  var _isRentEnabled = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_ui_selectors_video_pricing__["d" /* isRentEnabled */])(videoItem);
  var _isSaleEnabled = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_ui_selectors_video_pricing__["e" /* isSaleEnabled */])(videoItem);

  if (_isRentEnabled && _isSaleEnabled) {
    return BUY_BUTTON_DISPLAY_TYPES.BUY_FROM;
  } else if (_isSaleEnabled) {
    return BUY_BUTTON_DISPLAY_TYPES.BUY;
  } else if (_isRentEnabled) {
    return BUY_BUTTON_DISPLAY_TYPES.RENT;
  }

  return BUY_BUTTON_DISPLAY_TYPES.NONE;
}

// Todo: remove. Use widget/ui-selectors/video-access and overlay-texts
function shouldShowSubscribeButton(_ref2) {
  var settings = _ref2.settings,
      videoItem = _ref2.videoItem,
      channelData = _ref2.channelData,
      showChannelCover = _ref2.showChannelCover;

  var hasChannelSubscription = isSubscribedToChannel(channelData);

  return hasSubscriptionPriceInfo(channelData) && !hasChannelSubscription && (!hasChannelSubscription && shouldShowChannelCover(settings, showChannelCover) || channelData.subscriptionOnly && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_ui_selectors_video_pricing__["c" /* isFree */])(videoItem) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_ui_selectors_video_pricing__["a" /* isRented */])(videoItem) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_ui_selectors_video_pricing__["b" /* isBought */])(videoItem));
}

function mainItemIsChannelCover(settings) {
  return settings.numbers.mainItemType === __WEBPACK_IMPORTED_MODULE_1_default_settings__["a" /* mainItemTypeValues */].CHANNEL_COVER;
}

function shouldShowChannelCover(settings, showChannelCover) {
  return showChannelCover && mainItemIsChannelCover(settings);
}

// Todo: remove. Use widget/ui-selectors/video-access and overlay-texts
function getPlayButtonType(channelData, videoItem) {
  if (canAccessFullVersionOfVideo(channelData, videoItem)) {
    return PLAY_BUTTON_TYPES.PLAY;
  }
  return PLAY_BUTTON_TYPES.TRAILER_OR_PREVIEW;
}

function hasSubscriptionPriceInfo(channelData) {
  return channelData && Boolean(__WEBPACK_IMPORTED_MODULE_0_shared_utils_deal_info_helpers__["a" /* getSubscriptionPriceInfo */](channelData.dealInfo));
}

function isSubscribedToChannel(channelData) {
  return _.has(channelData, 'dgsInfo.subscription');
}

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MIN_WIDGET_WIDTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MAX_WIDGET_WIDTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VIDEO_HEIGHT_RATIO; });
/* unused harmony export MOBILE_VIDEO_HEIGHT_RATIO */
/* harmony export (immutable) */ __webpack_exports__["h"] = classicLayoutWidgetHeight;
/* harmony export (immutable) */ __webpack_exports__["c"] = playerSize;
/* harmony export (immutable) */ __webpack_exports__["d"] = playerSizeMobile;
/* harmony export (immutable) */ __webpack_exports__["e"] = playerSizeMobileMainItemForNewUX;
/* harmony export (immutable) */ __webpack_exports__["j"] = stripLayoutThumbnailSize;
/* harmony export (immutable) */ __webpack_exports__["i"] = listThumbnailSize;
/* harmony export (immutable) */ __webpack_exports__["g"] = videosPerPage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_default_settings__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_utils_layout_helpers__ = __webpack_require__(386);



var WIDGET_PADDING = 20;
var HEADER_HEIGHT = 55;
var SEARCH_BAR_HEIGHT = 72;
var VIDEOS_LIST_DESCRIPTION_LINE_HEIGHT = 18;
var VIDEOS_LIST_DESCRIPTION_SPACING = 8;
var VIDEOS_LIST_SPACING = 10;
var VIDEOS_LIST_PADDING_BOTTOM = 10;
var VIDEOS_LIST_PAGINATION_HEIGHT = 57;
var MIN_WIDGET_WIDTH = 680;
var MAX_WIDGET_WIDTH = 980;
var VIDEO_HEIGHT_RATIO = 9 / 16;
var MOBILE_VIDEO_HEIGHT_RATIO = 250 / 320;

function roundAsBrowser(number) {
  return Math.floor(number * 100) / 100;
}

// TODO: move to classic only selectors
function classicLayoutHeaderHeight(appSettings, channelData) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_utils_layout_helpers__["a" /* isClassicLayoutHeaderVisible */])(appSettings, channelData) ? HEADER_HEIGHT : WIDGET_PADDING;
}

// TODO: move to classic only selectors
function classicLayoutSearchLineHeight(appSettings, channelData) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_utils_layout_helpers__["b" /* isClassicLayoutSearchBarVisible */])(appSettings, channelData) ? SEARCH_BAR_HEIGHT : WIDGET_PADDING;
}

function videosListDescriptionHeight(appSettings) {
  if (appSettings.numbers.videoInfoPosition !== __WEBPACK_IMPORTED_MODULE_0_default_settings__["b" /* infoPositionValues */].BELOW_VIDEOS) {
    return 0;
  }

  var height = 0;
  if (appSettings.booleans.showVideoTitleInList || appSettings.booleans.showVideoPublisherInList) {
    height += VIDEOS_LIST_DESCRIPTION_SPACING;
  }

  if (appSettings.booleans.showVideoTitleInList) {
    height += VIDEOS_LIST_DESCRIPTION_LINE_HEIGHT;
  }
  if (appSettings.booleans.showVideoPublisherInList) {
    height += VIDEOS_LIST_DESCRIPTION_LINE_HEIGHT;
  }

  return height;
}

function videosListHeight(appSettings, widgetWidth, videosInRow, rowsCount) {
  var descriptionHeight = videosListDescriptionHeight(appSettings);
  var thumbnailHeight = listThumbnailSize(widgetWidth, videosInRow).height;
  return (thumbnailHeight + descriptionHeight + VIDEOS_LIST_SPACING) * rowsCount;
}

function videosListPaginationHeight(allVideosCount, rowsCount, videosInRow) {
  return allVideosCount > rowsCount * videosInRow ? VIDEOS_LIST_PAGINATION_HEIGHT : WIDGET_PADDING + VIDEOS_LIST_PADDING_BOTTOM;
}

// TODO: move to classic only selectors
function classicLayoutWidgetHeight(widgetWidth, videosInRow, allVideosCount, rowsCount, appSettings, channelData) {
  return classicLayoutHeaderHeight(appSettings, channelData) + playerSize(widgetWidth).height + classicLayoutSearchLineHeight(appSettings, channelData) + videosListHeight(appSettings, widgetWidth, videosInRow, rowsCount) + videosListPaginationHeight(allVideosCount, rowsCount, videosInRow);
}

function playerHeightWithRatio(width) {
  return width * VIDEO_HEIGHT_RATIO;
}

function playerSize(widgetWidth) {
  var widgetPadding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : WIDGET_PADDING;

  var width = widgetWidth - widgetPadding * 2;
  return {
    width: roundAsBrowser(width),
    height: roundAsBrowser(playerHeightWithRatio(width))
  };
}

// TODO: move to mobile only selectors
function playerSizeMobile(widgetWidth) {
  return playerSize(widgetWidth, 0);
}

// TODO: move to mobile only selectors
function playerSizeMobileMainItemForNewUX(widgetWidth) {
  return {
    width: roundAsBrowser(widgetWidth),
    height: roundAsBrowser(widgetWidth * MOBILE_VIDEO_HEIGHT_RATIO)
  };
}

// TODO: move to strip only selectors
function stripLayoutThumbnailSize(widgetWidth, videosInRow) {
  var width = widgetWidth / videosInRow;

  return {
    width: roundAsBrowser(width),
    height: roundAsBrowser(playerHeightWithRatio(width))
  };
}

function listThumbnailSize(widgetWidth, videosInRow) {
  var listWidth = widgetWidth - WIDGET_PADDING * 2;
  var width = (listWidth - (videosInRow - 1) * VIDEOS_LIST_SPACING) / videosInRow;

  return {
    width: roundAsBrowser(width),
    height: roundAsBrowser(playerHeightWithRatio(width))
  };
}

function maxVideosAtHeight(appSettings, height, widgetWidth, videosInRow) {
  var videosHeight = videosListHeight(appSettings, widgetWidth, videosInRow, 1);
  var rowsCount = Math.floor(height / videosHeight);

  if (rowsCount <= 0) {
    rowsCount = 1;
  }

  return rowsCount * videosInRow;
}

function videosPerPage(widgetSize, videosInRow, allVideosCount, appSettings, channelData) {
  var availableListHeight = widgetSize.height - (classicLayoutHeaderHeight(appSettings, channelData) + playerSize(widgetSize.width).height + classicLayoutSearchLineHeight(appSettings, channelData) + WIDGET_PADDING + VIDEOS_LIST_PADDING_BOTTOM);

  var videosPerPage = maxVideosAtHeight(appSettings, availableListHeight, widgetSize.width, videosInRow);

  // all available videos at one page
  if (allVideosCount && allVideosCount <= videosPerPage) {
    return videosPerPage;
  }

  availableListHeight += WIDGET_PADDING + VIDEOS_LIST_PADDING_BOTTOM - VIDEOS_LIST_PAGINATION_HEIGHT;

  return maxVideosAtHeight(appSettings, availableListHeight, widgetSize.width, videosInRow);
}

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(727), __esModule: true };

/***/ }),
/* 550 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(106),
    isObjectLike = __webpack_require__(92);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isFunction2 = __webpack_require__(107);

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _extendReactClass = __webpack_require__(1124);

var _extendReactClass2 = _interopRequireDefault(_extendReactClass);

var _wrapStatelessFunction = __webpack_require__(1129);

var _wrapStatelessFunction2 = _interopRequireDefault(_wrapStatelessFunction);

var _makeConfiguration = __webpack_require__(1127);

var _makeConfiguration2 = _interopRequireDefault(_makeConfiguration);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Determines if the given object has the signature of a class that inherits React.Component.
 */


/**
 * @see https://github.com/gajus/react-css-modules#options
 */
var isReactComponent = function isReactComponent(maybeReactComponent) {
  return 'prototype' in maybeReactComponent && (0, _isFunction3.default)(maybeReactComponent.prototype.render);
};

/**
 * When used as a function.
 */
var functionConstructor = function functionConstructor(Component, defaultStyles, options) {
  var decoratedClass = void 0;

  var configuration = (0, _makeConfiguration2.default)(options);

  if (isReactComponent(Component)) {
    decoratedClass = (0, _extendReactClass2.default)(Component, defaultStyles, configuration);
  } else {
    decoratedClass = (0, _wrapStatelessFunction2.default)(Component, defaultStyles, configuration);
  }

  if (Component.displayName) {
    decoratedClass.displayName = Component.displayName;
  } else {
    decoratedClass.displayName = Component.name;
  }

  return decoratedClass;
};

/**
 * When used as a ES7 decorator.
 */
var decoratorConstructor = function decoratorConstructor(defaultStyles, options) {
  return function (Component) {
    return functionConstructor(Component, defaultStyles, options);
  };
};

exports.default = function () {
  if ((0, _isFunction3.default)(arguments.length <= 0 ? undefined : arguments[0])) {
    return functionConstructor(arguments.length <= 0 ? undefined : arguments[0], arguments.length <= 1 ? undefined : arguments[1], arguments.length <= 2 ? undefined : arguments[2]);
  } else {
    return decoratorConstructor(arguments.length <= 0 ? undefined : arguments[0], arguments.length <= 1 ? undefined : arguments[1]);
  }
};

module.exports = exports['default'];

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NAMES; });
/* harmony export (immutable) */ __webpack_exports__["b"] = search;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_normalizr__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_normalizr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_normalizr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_schemas__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_redux_helpers_create_async_actions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_utils_adapters_vod__ = __webpack_require__(34);







var ACTIONS = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_redux_helpers_create_async_actions__["a" /* default */])('SERVER.VIDEOS.SEARCH');
var NAMES = ACTIONS.NAMES;
var START = ACTIONS.START,
    SUCCESS = ACTIONS.SUCCESS,
    FAIL = ACTIONS.FAIL;


function search(query, options) {

  options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, options, {
    paging: { size: 1000 }
  });

  return function (dispatch) {
    var params = { query: query };
    dispatch(START(params));

    var promise = __WEBPACK_IMPORTED_MODULE_4_shared_utils_adapters_vod__["a" /* default */].items.search(query, options);

    return promise.then(function (response) {
      response = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, response, {
        data: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_normalizr__["normalize"])(response.data, __WEBPACK_IMPORTED_MODULE_2_shared_schemas__["b" /* arrayOfVideos */])
      });

      dispatch(SUCCESS(params, response));
      return response;
    }, function (response) {
      dispatch(FAIL(params, response, { analytics: { type: 'error', name: 'dashboard.videos.search' } }));
    });
  };
}

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CLASSIC_SHOW_INFO_VALUES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return STRIP_SHOW_INFO_VALUES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return COMPACT_SHOW_INFO_VALUES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PER_LAYOUT_SHOW_INFO_VALUES; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel_layout_values__ = __webpack_require__(417);



var _PER_LAYOUT_SHOW_INFO;



var ON_MOUSE_OVER = 1;
var ALWAYS = 2;
var NEVER = 3;

var CLASSIC_SHOW_INFO_VALUES = [ON_MOUSE_OVER, ALWAYS];

var STRIP_SHOW_INFO_VALUES = [].concat(CLASSIC_SHOW_INFO_VALUES, [NEVER]);

var COMPACT_SHOW_INFO_VALUES = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(STRIP_SHOW_INFO_VALUES));

/* harmony default export */ __webpack_exports__["a"] = ({
  ON_MOUSE_OVER: ON_MOUSE_OVER,
  ALWAYS: ALWAYS,
  NEVER: NEVER
});

var PER_LAYOUT_SHOW_INFO_VALUES = (_PER_LAYOUT_SHOW_INFO = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PER_LAYOUT_SHOW_INFO, __WEBPACK_IMPORTED_MODULE_2__channel_layout_values__["a" /* default */].CLASSIC, CLASSIC_SHOW_INFO_VALUES), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PER_LAYOUT_SHOW_INFO, __WEBPACK_IMPORTED_MODULE_2__channel_layout_values__["a" /* default */].STRIP, STRIP_SHOW_INFO_VALUES), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PER_LAYOUT_SHOW_INFO, __WEBPACK_IMPORTED_MODULE_2__channel_layout_values__["a" /* default */].COMPACT, COMPACT_SHOW_INFO_VALUES), _PER_LAYOUT_SHOW_INFO);

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return translations; });
var translations = _.get(window, 'wix.translations', {});

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  HEIGHT: 700,
  WIDTH: 1236,
  FILENAME: 'dashboard.html',
  SERVICE_CONNECTED: 'service-connected.html',
  UPLOADING_CANCEL_CODE: -7799,
  HELP_URL: 'https://www.wix.com/support/html5/wix-video/getting-started-with-wix-video'
});

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = clear;
/* harmony export (immutable) */ __webpack_exports__["c"] = excludeVideoIdsFromPrams;
/* harmony export (immutable) */ __webpack_exports__["b"] = replaceIds;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);

/*
 state: [id1, id2, ..]
 */

function clear() {
  return [];
}

function excludeVideoIdsFromPrams(state, _ref) {
  var _ref2;

  var payload = _ref.payload;
  var videoIds = payload.params.videoIds;

  return (_ref2 = _).without.apply(_ref2, [state].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(videoIds)));
}

function replaceIds(state, oldIds, newIds) {
  oldIds = _.castArray(oldIds);
  newIds = _.castArray(newIds);

  return _.map(state, function (id) {
    var indexInOldIds = _.indexOf(oldIds, id);
    if (indexInOldIds === -1) {
      // video hasn't been just added
      return id;
    }

    return newIds[indexInOldIds];
  });
}

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_constants_genres__ = __webpack_require__(1198);


var _defineMessages;





/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* defineMessages */])((_defineMessages = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_genres__["a" /* genres */].ACTION, {
  id: 'shared.genres.action',
  defaultMessage: 'Action'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_genres__["a" /* genres */].ADVENTURE, {
  id: 'shared.genres.adventure',
  defaultMessage: 'Adventure'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_genres__["a" /* genres */].ANIMATION, {
  id: 'shared.genres.animation',
  defaultMessage: 'Animation'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_genres__["a" /* genres */].AFRICAN, {
  id: 'shared.genres.african',
  defaultMessage: 'African'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_genres__["a" /* genres */].AFRICAN_AMERICAN, {
  id: 'shared.genres.african-american',
  defaultMessage: 'African American'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_genres__["a" /* genres */].ASIAN, {
  id: 'shared.genres.asian',
  defaultMessage: 'Asian'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_genres__["a" /* genres */].ASIAN_AMERICAN, {
  id: 'shared.genres.asian-american',
  defaultMessage: 'Asian American'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_genres__["a" /* genres */].BLACK, {
  id: 'shared.genres.black',
  defaultMessage: 'Black'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_genres__["a" /* genres */].BUDDHIST, {
  id: 'shared.genres.buddhist',
  defaultMessage: 'Buddhist'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_genres__["a" /* genres */].BIOGRAPHY, {
  id: 'shared.genres.biography',
  defaultMessage: 'Biography'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_genres__["a" /* genres */].CHILDREN, {
  id: 'shared.genres.children',
  defaultMessage: 'Children'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_genres__["a" /* genres */].CHRISTIAN, {
  id: 'shared.genres.christian',
  defaultMessage: 'Christian'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_genres__["a" /* genres */].COMEDY, {
  id: 'shared.genres.comedy',
  defaultMessage: 'Comedy'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_genres__["a" /* genres */].CRIME, {
  id: 'shared.genres.crime',
  defaultMessage: 'Crime'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_genres__["a" /* genres */].DIY, {
  id: 'shared.genres.diy',
  defaultMessage: 'DIY'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_genres__["a" /* genres */].DEVELOPING_NATIONS, {
  id: 'shared.genres.developing-nations',
  defaultMessage: 'Developing Nations'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_genres__["a" /* genres */].DISABILITY_CULTURE, {
  id: 'shared.genres.disability-culture',
  defaultMessage: 'Disability Culture'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_genres__["a" /* genres */].DOCUMENTARY, {
  id: 'shared.genres.documentary',
  defaultMessage: 'Documentary'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_genres__["a" /* genres */].DRAMA, {
  id: 'shared.genres.drama',
  defaultMessage: 'Drama'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_genres__["a" /* genres */].EDUCATION, {
  id: 'shared.genres.education',
  defaultMessage: 'Education'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_genres__["a" /* genres */].FAMILY, {
  id: 'shared.genres.family',
  defaultMessage: 'Family'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_genres__["a" /* genres */].FANTASY, {
  id: 'shared.genres.fantasy',
  defaultMessage: 'Fantasy'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_genres__["a" /* genres */].FILM_NOIR, {
  id: 'shared.genres.film-noir',
  defaultMessage: 'Film-Noir'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_genres__["a" /* genres */].GAME_SHOW, {
  id: 'shared.genres.game-show',
  defaultMessage: 'Game-Show'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_genres__["a" /* genres */].HISPANIC, {
  id: 'shared.genres.hispanic',
  defaultMessage: 'Hispanic'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_genres__["a" /* genres */].HISTORY, {
  id: 'shared.genres.history',
  defaultMessage: 'History'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_genres__["a" /* genres */].HORROR, {
  id: 'shared.genres.horror',
  defaultMessage: 'Horror'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_genres__["a" /* genres */].INSTRUCTIONAL, {
  id: 'shared.genres.instructional',
  defaultMessage: 'Instructional'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_genres__["a" /* genres */].ISLAMIC, {
  id: 'shared.genres.islamic',
  defaultMessage: 'Islamic'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_genres__["a" /* genres */].JEWISH, {
  id: 'shared.genres.jewish',
  defaultMessage: 'Jewish'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_genres__["a" /* genres */].LGBTQ, {
  id: 'shared.genres.lgbtq',
  defaultMessage: 'LGBTQ'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_genres__["a" /* genres */].LATINO, {
  id: 'shared.genres.latino',
  defaultMessage: 'Latino'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_genres__["a" /* genres */].MATURE_ADULT, {
  id: 'shared.genres.mature-adult',
  defaultMessage: 'Mature/Adult'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_genres__["a" /* genres */].MUSIC, {
  id: 'shared.genres.music',
  defaultMessage: 'Music'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_genres__["a" /* genres */].MUSICAL, {
  id: 'shared.genres.musical',
  defaultMessage: 'Musical'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_genres__["a" /* genres */].MYSTERY, {
  id: 'shared.genres.mystery',
  defaultMessage: 'Mystery'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_genres__["a" /* genres */].NEWS, {
  id: 'shared.genres.news',
  defaultMessage: 'News'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_genres__["a" /* genres */].NATIVE_AMERICAN, {
  id: 'shared.genres.native-american',
  defaultMessage: 'Native American'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_genres__["a" /* genres */].NATIVE_ABORIGINAL_PEOPLE, {
  id: 'shared.genres.native-aboriginal-people',
  defaultMessage: 'Native/Aboriginal People'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_genres__["a" /* genres */].PERSONAL, {
  id: 'shared.genres.personal',
  defaultMessage: 'Personal'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_genres__["a" /* genres */].REALITY_TV, {
  id: 'shared.genres.reality-tv',
  defaultMessage: 'Reality-TV'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_genres__["a" /* genres */].ROMANCE, {
  id: 'shared.genres.romance',
  defaultMessage: 'Romance'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_genres__["a" /* genres */].SCI_FI, {
  id: 'shared.genres.sci-fi',
  defaultMessage: 'Sci-Fi'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_genres__["a" /* genres */].SENIOR_AGING, {
  id: 'shared.genres.senior-aging',
  defaultMessage: 'Senior/Aging'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_genres__["a" /* genres */].SPORT, {
  id: 'shared.genres.sport',
  defaultMessage: 'Sport'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_genres__["a" /* genres */].STUDENT, {
  id: 'shared.genres.student',
  defaultMessage: 'Student'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_genres__["a" /* genres */].TALK_SHOW, {
  id: 'shared.genres.talk-show',
  defaultMessage: 'Talk-Show'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_genres__["a" /* genres */].THRILLER, {
  id: 'shared.genres.thriller',
  defaultMessage: 'Thriller'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_genres__["a" /* genres */].WAR, {
  id: 'shared.genres.war',
  defaultMessage: 'War'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_genres__["a" /* genres */].WESTERN, {
  id: 'shared.genres.western',
  defaultMessage: 'Western'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_genres__["a" /* genres */].WOMEN, {
  id: 'shared.genres.women',
  defaultMessage: 'Women'
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_defineMessages, __WEBPACK_IMPORTED_MODULE_2_shared_constants_genres__["a" /* genres */].YOUTH_TEEN, {
  id: 'shared.genres.youth-teen',
  defaultMessage: 'Youth/Teen'
}), _defineMessages)));

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NAMES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return resetCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return updateCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loadFirstPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loadMore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_redux_server_actions_channel_videos_list__ = __webpack_require__(149);




var NAMES = {
  UPDATE: 'CLIENT.CHANNEL.VIDEOS_LAZY_LIST.UPDATE',
  VIDEOS_RESET: 'CLIENT.CHANNEL.VIDEOS_LAZY_LIST.VIDEOS_RESET',
  CATEGORY_RESET: 'CLIENT.CHANNEL.VIDEOS_LAZY_LIST.CATEGORY.RESET',
  CATEGORY_UPDATE: 'CLIENT.CHANNEL.VIDEOS_LAZY_LIST.CATEGORY.UPDATE'
};

var resetVideos = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(NAMES.VIDEOS_RESET);
var resetCategory = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(NAMES.CATEGORY_RESET);
var updateCategory = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(NAMES.CATEGORY_UPDATE);

var loadFirstPage = function loadFirstPage(numberToLoadFirst, _ref) {
  var category = _ref.category,
      tag = _ref.tag,
      query = _ref.query;
  return function (dispatch, getState) {
    dispatch(resetVideos({}));

    var state = getState();

    var nextPageOptions = {
      paging: {
        size: numberToLoadFirst,
        cursor: null
      },
      query: query,
      tag: tag,
      category: category
    };

    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_redux_server_actions_channel_videos_list__["a" /* listPublic */])(state.currentChannelId, nextPageOptions));
  };
};

// FIXME: pass category to loadMore
var loadMore = function loadMore(loadMoreNumber, nextVideosCursor) {
  return function (dispatch, getState) {
    var state = getState();
    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_redux_server_actions_channel_videos_list__["a" /* listPublic */])(state.currentChannelId, {
      paging: {
        size: loadMoreNumber,
        cursor: nextVideosCursor
      }
    }));
  };
};

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(438);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  return Array.isArray(arr) ? arr : (0, _from2.default)(arr);
};

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(335),
    setCacheAdd = __webpack_require__(1082),
    setCacheHas = __webpack_require__(1083);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 562 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(639);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(1031),
    shortOut = __webpack_require__(1084);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(1015),
    hasPath = __webpack_require__(1055);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(339);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NAMES; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_redux_helpers_create_async_actions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_utils_adapters_vod__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_redux_helpers_normalized__ = __webpack_require__(49);






var ACTIONS = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_redux_helpers_create_async_actions__["a" /* default */])('SERVER.VIDEO.GET');
var NAMES = ACTIONS.NAMES;
var START = ACTIONS.START,
    SUCCESS = ACTIONS.SUCCESS,
    FAIL = ACTIONS.FAIL;


/* harmony default export */ __webpack_exports__["b"] = (function (id) {
  return function (dispatch) {
    var params = { id: id };
    dispatch(START(params));

    var promise = __WEBPACK_IMPORTED_MODULE_2_shared_utils_adapters_vod__["a" /* default */].item.get(id);

    return promise.then(function (response) {
      response = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, response, {
        data: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_redux_helpers_normalized__["d" /* normalizeVideo */])(response.data)
      });

      dispatch(SUCCESS(params, response));
      return response;
    }, function (response) {
      dispatch(FAIL(params, response, { analytics: { type: 'error', name: 'dashboard.video.get' } }));
    });
  };
});

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NAMES; });
/* harmony export (immutable) */ __webpack_exports__["b"] = remove;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_redux_helpers_create_async_actions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_utils_adapters_vod__ = __webpack_require__(34);



var ACTIONS = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_redux_helpers_create_async_actions__["a" /* default */])('SERVER.VIDEOS.REMOVE');
var NAMES = ACTIONS.NAMES;
var START = ACTIONS.START,
    SUCCESS = ACTIONS.SUCCESS,
    FAIL = ACTIONS.FAIL;


function remove(videoIds) {
  return function (dispatch) {
    dispatch(START({ videoIds: videoIds }));

    return __WEBPACK_IMPORTED_MODULE_1_shared_utils_adapters_vod__["a" /* default */].items.remove(videoIds).then(function (response) {
      dispatch(SUCCESS({ videoIds: videoIds }, response));
      return response;
    }, function (response) {
      dispatch(FAIL({ videoIds: videoIds }, response, { analytics: { type: 'error', name: 'dashboard.videos.remove' } }));
    });
  };
}

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NewRelic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__new_relic_stub__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_circular_json__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_circular_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_circular_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_utils_wix_sdk__ = __webpack_require__(25);










var logger = {
  debug: console.info.bind(console), // eslint-disable-line no-console
  error: console.error.bind(console) // eslint-disable-line no-console
};

var serializers = [{
  test: _.isError,
  serialize: function serialize(error) {
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()({
      stack: error.stack,
      message: error.message,
      name: error.name,
      details: error.details
    });
  }
}, {
  test: _.constant(true),
  serialize: __WEBPACK_IMPORTED_MODULE_5_circular_json___default.a.stringify.bind(__WEBPACK_IMPORTED_MODULE_5_circular_json___default.a)
}];

function prettifyName(name) {
  return _.chain(name).replace(/-/g, ' ').split('/').compact().map(_.capitalize).join(' → ').value();
}

var NewRelic = function () {
  function NewRelic(newrelic, host) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, NewRelic);

    this._host = host || location.host;
    this._newrelic = newrelic || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__new_relic_stub__["a" /* createStub */])();
    this.init();
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(NewRelic, [{
    key: 'init',
    value: function init() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_6_react_router__["a" /* hashHistory */].listen(function (location) {
        _this._updatePageData(location.pathname);
        _this.finished();
      });

      this._newrelic.setCustomAttribute('sessionId', 's-' + Date.now());
      this._newrelic.setCustomAttribute('uid', __WEBPACK_IMPORTED_MODULE_7_shared_utils_wix_sdk__["a" /* default */].Utils.getUid());
      this._newrelic.setCustomAttribute('instanceId', __WEBPACK_IMPORTED_MODULE_7_shared_utils_wix_sdk__["a" /* default */].Utils.getInstanceId());
      this._newrelic.setCustomAttribute('biToken', __WEBPACK_IMPORTED_MODULE_7_shared_utils_wix_sdk__["a" /* default */].Utils.getInstanceValue('biToken'));

      __WEBPACK_IMPORTED_MODULE_7_shared_utils_wix_sdk__["a" /* default */].Utils.getMetaSiteId().then(function (metaSiteId) {
        _this._newrelic.setCustomAttribute('metaSiteId', metaSiteId);
      });
    }
  }, {
    key: 'addPageAction',
    value: function addPageAction(name, attributes) {
      var _newrelic;

      logger.debug('NewRelic page action: \'' + name + '\'', attributes);
      (_newrelic = this._newrelic).addPageAction.apply(_newrelic, arguments);
    }
  }, {
    key: 'addToTrace',
    value: function addToTrace(options) {
      var _newrelic2;

      logger.debug('NewRelic trace: \'' + options.name + '\'', options);
      (_newrelic2 = this._newrelic).addToTrace.apply(_newrelic2, arguments);
    }
  }, {
    key: 'trackEvent',
    value: function trackEvent(name, attributes) {
      if ('type' in attributes) {
        throw new Error('Event \'' + name + '\' should not have type');
      }

      this.addPageAction('' + name, attributes);
      this.addToTrace(_.assign({ name: name }, attributes));
    }
  }, {
    key: 'logError',
    value: function logError() {
      var _this2 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (_.isError(options)) {
        return this.logError({ error: options });
      }

      if (_.isString(options)) {
        return this.logError({ message: options });
      }

      var error = options.error || this._createError({ message: options.message, context: this.logError });
      var message = options.message || error.message;
      var details = _.assign({}, error.details, options.details);
      var type = options.type || 'custom';
      var additionalRootFields = _.omit(options, 'error', 'message', 'details', 'type');

      var errorInfo = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, additionalRootFields, {
        message: message,
        type: type,
        errorMessage: error.message,
        errorStack: error.stack,
        errorName: error.name,
        errorCode: error.code,
        errorId: error.id,
        details: _.mapValues(details, function (detail) {
          return _this2._serializeError(detail);
        })
      });

      logger.error('NewRelic error:', errorInfo);
      this.addPageAction('error', errorInfo);
      this._noticeError(error);
    }
  }, {
    key: '_serializeError',
    value: function _serializeError(arg) {
      var serializer = _.find(serializers, function (_serializer) {
        return _serializer.test(arg);
      });
      return serializer.serialize(arg);
    }
  }, {
    key: '_noticeError',
    value: function _noticeError(error) {
      logger.debug('Log error', error);
      this._newrelic.noticeError(error);
    }
  }, {
    key: 'finished',
    value: function finished() {
      this._newrelic.finished();
    }
  }, {
    key: 'setPageName',
    value: function setPageName(name) {
      this._newrelic.setPageViewName(name, this._host);
    }
  }, {
    key: 'setCustomAttribute',
    value: function setCustomAttribute(key, value) {
      this._newrelic.setCustomAttribute(key, value);
    }
  }, {
    key: '_updatePageData',
    value: function _updatePageData(pathname) {
      this._newrelic.setCustomAttribute('stateName', pathname);
      this.setPageName(prettifyName(pathname));
    }
  }, {
    key: '_createError',
    value: function _createError(_ref) {
      var _ref$message = _ref.message,
          message = _ref$message === undefined ? 'general-error' : _ref$message,
          _ref$context = _ref.context,
          context = _ref$context === undefined ? this._createError : _ref$context;

      try {
        throw new Error(message);
      } catch (ex) {
        if (Error.captureStackTrace) {
          // second param - local context. Will not be displayed in stack
          Error.captureStackTrace(ex, context);
        }
        return ex;
      }
    }
  }]);

  return NewRelic;
}();



/***/ }),
/* 570 */,
/* 571 */,
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = buildReport;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_utils_wix_sdk__ = __webpack_require__(25);


var _events;



var ownerId = __WEBPACK_IMPORTED_MODULE_1_shared_utils_wix_sdk__["a" /* default */].Utils.getInstanceValue('siteOwnerId');

var EVENT_NAMES = {
  VIDEO_PLAY_TRAILER: 'VIDEO_PLAY_TRAILER',
  VIDEO_PLAY_COMPLETE: 'VIDEO_PLAY_COMPLETE',
  VIDEO_SHARE: 'VIDEO_SHARE',
  CHANNEL_SHARE: 'CHANNEL_SHARE'
};

var events = (_events = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_events, EVENT_NAMES.VIDEO_PLAY_TRAILER, {
  messageId: function messageId() {
    return Date.now();
  },

  metrics: [{
    type: 'video',
    reportMetrics: [{ name: 'view', value: 1 }],
    properties: {
      view_type: 'trailer',
      user_id: ownerId,
      video_id: function video_id(_ref) {
        var videoItem = _ref.videoItem;

        return videoItem.baseItemId;
      },
      channel_id: function channel_id(_ref2) {
        var channel = _ref2.channel;

        return channel.id;
      }
    }
  }]
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_events, EVENT_NAMES.VIDEO_PLAY_COMPLETE, {
  messageId: function messageId() {
    return Date.now();
  },

  metrics: [{
    type: 'video',
    reportMetrics: [{ name: 'view', value: 1 }],
    properties: {
      view_type: 'video',
      user_id: ownerId,
      video_id: function video_id(_ref3) {
        var videoItem = _ref3.videoItem;

        return videoItem.baseItemId;
      },
      channel_id: function channel_id(_ref4) {
        var channel = _ref4.channel;

        return channel.id;
      }
    }
  }]
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_events, EVENT_NAMES.VIDEO_SHARE, {
  messageId: function messageId() {
    return Date.now();
  },

  metrics: [{
    type: 'video',
    reportMetrics: [{ name: 'share', value: 1 }],
    properties: {
      user_id: ownerId,
      video_id: function video_id(_ref5) {
        var videoItem = _ref5.videoItem;

        return videoItem.baseItemId;
      },
      channel_id: function channel_id(_ref6) {
        var channel = _ref6.channel;

        return channel.id;
      },
      social: function social(_ref7) {
        var network = _ref7.network;

        return network.name;
      }
    }
  }]
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_events, EVENT_NAMES.CHANNEL_SHARE, {
  messageId: function messageId() {
    return Date.now();
  },

  metrics: [{
    type: 'channel',
    reportMetrics: [{ name: 'share', value: 1 }],
    properties: {
      user_id: ownerId,
      channel_id: function channel_id(_ref8) {
        var channel = _ref8.channel;

        return channel.id;
      },
      social: function social(_ref9) {
        var network = _ref9.network;

        return network.name;
      }
    }
  }]
}), _events);

function fillParams(eventParams, data) {
  return _.mapValues(eventParams, function (value) {
    if (_.isFunction(value)) {
      return value(data);
    } else if (_.isArray(value)) {
      return _.map(value, function (item) {
        return fillParams(item, data);
      });
    } else if (_.isObject(value)) {
      return fillParams(value, data);
    }

    return value;
  });
}

function buildReport(eventName, data) {
  var event = events[eventName];

  if (!event) {
    return;
  }

  data = _.merge({}, data, { ownerId: ownerId });

  return fillParams(event, data);
}

/* harmony default export */ __webpack_exports__["a"] = (EVENT_NAMES);

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = isSaleEnabled;
/* harmony export (immutable) */ __webpack_exports__["d"] = isRentEnabled;
/* harmony export (immutable) */ __webpack_exports__["b"] = isBought;
/* harmony export (immutable) */ __webpack_exports__["a"] = isRented;
/* harmony export (immutable) */ __webpack_exports__["f"] = isOwned;
/* harmony export (immutable) */ __webpack_exports__["c"] = isFree;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_utils_deal_info_helpers__ = __webpack_require__(82);


function isSaleEnabled(video) {
  return Boolean(video && __WEBPACK_IMPORTED_MODULE_0_shared_utils_deal_info_helpers__["b" /* getSalePriceInfo */](video.dealInfo));
}

function isRentEnabled(video) {
  return Boolean(video && __WEBPACK_IMPORTED_MODULE_0_shared_utils_deal_info_helpers__["c" /* getRentPriceInfo */](video.dealInfo));
}

function isBought(video) {
  return Boolean(_.get(video, 'dgsInfo.sale'));
}

function isRented(video) {
  return Boolean(_.get(video, 'dgsInfo.rent'));
}

function isOwned(video) {
  return isRented(video) || isBought(video);
}

function isFree(video) {
  return !isSaleEnabled(video) && !isRentEnabled(video);
}

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = dashify;
/* harmony export (immutable) */ __webpack_exports__["a"] = xor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);

function dashify(val) {
  return val.replace(/([0-9a-f]{8})([0-9a-f]{4})([0-9a-f]{4})([0-9a-f]{4})([0-9a-f]{12})/, '$1-$2-$3-$4-$5');
}

function xor(str, key) {
  if (!str || !key) {
    return null;
  }

  return _.reduce(_.zip(str.split(''), key.split('')), function (acc, _ref) {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
        a = _ref2[0],
        b = _ref2[1];

    a = parseInt(a, 16);
    b = parseInt(b, 16);

    if (!isNaN(a) && !isNaN(b)) {
      return acc + (a ^ b).toString(16); // eslint-disable-line no-bitwise
    }
    return acc + '-';
  }, '');
}

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = openPopup;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__open_tab__ = __webpack_require__(1202);



var DEFAULT_POPUP_PARAMS = {
  toolbar: false,
  location: false,
  directories: false,
  status: false,
  menubar: false,
  scrollbars: true,
  resizable: true,
  copyhistory: false
};

function openPopup(url) {
  var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 980;
  var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 600;

  var left = (window.screen.width - width) / 2;
  var top = (window.screen.height - height) / 2;

  var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, DEFAULT_POPUP_PARAMS, { width: width, height: height, top: top, left: left });

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__open_tab__["a" /* default */])(url, params);
}

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  appFullyRendered: 'appFullyRendered',
  appFirstPreview: 'appFirstPreview'
});

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = byPopoutSide;
/* harmony export (immutable) */ __webpack_exports__["b"] = byTriangleSide;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_constants_popout__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__invert_side__ = __webpack_require__(357);





var POPOUT_OFFSET = 12;
var POPOUT_OVERSHOOT = 23;

var defaultPositioning = {
  triangleSide: __WEBPACK_IMPORTED_MODULE_1_shared_constants_popout__["a" /* sides */].TOP,
  popoutSide: __WEBPACK_IMPORTED_MODULE_1_shared_constants_popout__["a" /* sides */].BOTTOM,
  popoutPosition: __WEBPACK_IMPORTED_MODULE_1_shared_constants_popout__["c" /* popoutPositions */].CENTER,
  trianglePosition: __WEBPACK_IMPORTED_MODULE_1_shared_constants_popout__["b" /* trianglePositions */].CENTER
};

function byPopoutSide(referenceElement, popoutElement) {
  var positioning = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultPositioning;


  if (!referenceElement || !popoutElement) {
    return { left: 0, top: 0, offsetX: 0 };
  }

  var _defaultPositioning$p = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, defaultPositioning, positioning),
      popoutSide = _defaultPositioning$p.popoutSide,
      popoutPosition = _defaultPositioning$p.popoutPosition,
      trianglePosition = _defaultPositioning$p.trianglePosition;

  var referenceRect = referenceElement.getBoundingClientRect();
  var popoutRect = popoutElement.getBoundingClientRect();

  var referenceTop = referenceRect.top,
      referenceLeft = referenceRect.left,
      referenceWidth = referenceRect.width,
      referenceHeight = referenceRect.height;
  var popoutWidth = popoutRect.width,
      popoutHeight = popoutRect.height;
  var _window = window,
      windowWidth = _window.innerWidth,
      windowScrollX = _window.pageXOffset;


  var top = referenceTop;
  var left = referenceLeft + windowScrollX;

  if (popoutSide === __WEBPACK_IMPORTED_MODULE_1_shared_constants_popout__["a" /* sides */].TOP) {
    top -= popoutHeight + POPOUT_OFFSET;
  } else if (popoutSide === __WEBPACK_IMPORTED_MODULE_1_shared_constants_popout__["a" /* sides */].LEFT) {
    top -= popoutHeight / 2 - referenceHeight / 2;
    left -= popoutWidth + POPOUT_OFFSET;
  } else if (popoutSide === __WEBPACK_IMPORTED_MODULE_1_shared_constants_popout__["a" /* sides */].RIGHT) {
    top -= popoutHeight / 2 - referenceHeight / 2;
    left += referenceWidth + POPOUT_OFFSET;
  } else if (popoutSide === __WEBPACK_IMPORTED_MODULE_1_shared_constants_popout__["a" /* sides */].BOTTOM) {
    top += referenceHeight + POPOUT_OFFSET;
  }

  if (popoutSide === __WEBPACK_IMPORTED_MODULE_1_shared_constants_popout__["a" /* sides */].TOP || popoutSide === __WEBPACK_IMPORTED_MODULE_1_shared_constants_popout__["a" /* sides */].BOTTOM) {
    if (popoutPosition === __WEBPACK_IMPORTED_MODULE_1_shared_constants_popout__["c" /* popoutPositions */].RIGHT) {
      left += referenceWidth - popoutWidth + POPOUT_OVERSHOOT;
    } else if (popoutPosition === __WEBPACK_IMPORTED_MODULE_1_shared_constants_popout__["c" /* popoutPositions */].LEFT) {
      left -= POPOUT_OVERSHOOT;
    } else {
      left -= popoutWidth / 2 - referenceWidth / 2;
    }
  }

  var offsetX = 0;
  if (trianglePosition === __WEBPACK_IMPORTED_MODULE_1_shared_constants_popout__["b" /* trianglePositions */].CENTER && windowScrollX + windowWidth < left + popoutWidth) {
    offsetX = left + popoutWidth + POPOUT_OFFSET - (windowScrollX + windowWidth);
    left -= offsetX;
  }

  return { top: top, left: left, offsetX: offsetX };
}

function byTriangleSide(referenceElement, popoutElement) {
  var positioning = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultPositioning;

  positioning = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, positioning, {
    popoutSide: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__invert_side__["a" /* default */])(positioning.triangleSide)
  });
  return byPopoutSide(referenceElement, popoutElement, positioning);
}

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatMessageWithDealInfo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(10);



function formatMessageWithDealInfo(message, dealInfo) {
  var values = {
    price: React.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["f" /* FormattedNumber */], { value: dealInfo.price,
      style: "currency",
      currency: dealInfo.currency })
  };

  return React.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, message, {
    values: values }));
}

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProgressBar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_widget_player_widget_utils_wix_connect__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__progress_bar_styl__ = __webpack_require__(1502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__progress_bar_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__progress_bar_styl__);








var _dec, _class, _desc, _value, _class2, _class3, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}







var ProgressBar = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_widget_player_widget_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_9__progress_bar_styl___default.a), _dec(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(ProgressBar, _React$Component);

  function ProgressBar() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ProgressBar);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ProgressBar.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(ProgressBar)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(ProgressBar, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // 'orient' is not supported by React but
      // is required for Firefox. Setting manually.
      // https://github.com/facebook/react/issues/2453
      this.rangeInput.setAttribute('orient', this.props.orientation);
      this.rangeInput.addEventListener('input', this.props.onChange);
      // TODO: remove after React 16 release
      // https://github.com/facebook/react/issues/554
      this.rangeInput.addEventListener('change', this.props.onChange);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.rangeInput.value = nextProps.progress;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.rangeInput.removeEventListener('change', this.props.onChange);
      this.rangeInput.removeEventListener('input', this.props.onChange);
    }
  }, {
    key: 'setRef',
    value: function setRef(ref) {
      this.rangeInput = ref;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          fillClassName = _props.fillClassName,
          inputClassName = _props.inputClassName,
          orientation = _props.orientation,
          progress = _props.progress,
          step = _props.step,
          onBlur = _props.onBlur,
          onFocus = _props.onFocus;


      var progressProp = orientation === 'horizontal' ? 'width' : 'height';

      return React.createElement(
        'div',
        { styleName: 'progress-bar progress-bar--' + orientation,
          className: className },
        React.createElement('div', { styleName: 'progress-bar__fill',
          className: fillClassName,
          style: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, progressProp, progress + '%') }),
        React.createElement('input', { styleName: 'progress-bar__input',
          ref: this.setRef,
          type: 'range',
          min: '0',
          max: '100',
          className: inputClassName,
          defaultValue: progress,
          step: step,
          onBlur: onBlur,
          onFocus: onFocus })
      );
    }
  }]);

  return ProgressBar;
}(React.Component), _class3.propTypes = {
  className: React.PropTypes.string,
  fillClassName: React.PropTypes.string,
  inputClassName: React.PropTypes.string,
  orientation: React.PropTypes.string,
  step: React.PropTypes.number,
  progress: React.PropTypes.number,
  onChange: React.PropTypes.func,
  onFocus: React.PropTypes.func,
  onBlur: React.PropTypes.func
}, _class3.defaultProps = {
  orientation: 'horizontal',
  step: 0.05,
  progress: 0,
  onBlur: _.noop,
  onFocus: _.noop,
  onChange: _.noop
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'setRef', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'setRef'), _class2.prototype)), _class2)) || _class);


/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_utils_http__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_settings__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_utils_open_popup__ = __webpack_require__(575);




/* harmony default export */ __webpack_exports__["a"] = ({
  paypal: function paypal(options) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_utils_open_popup__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_shared_utils_http__["a" /* default */].buildUrl(__WEBPACK_IMPORTED_MODULE_1_shared_settings__["a" /* default */].hosts.paypal + 'vod/pp/start', options));
  },
  cancelSubscription: function cancelSubscription(channelId, siteUrl, instance) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_utils_open_popup__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_shared_utils_http__["a" /* default */].buildUrl(__WEBPACK_IMPORTED_MODULE_1_shared_settings__["a" /* default */].hosts.paypal + 'vod/pp/subscribe/cancel_profile', {
      type: 'subscription',
      channelId: channelId,
      ref: siteUrl,
      instance: instance
    }));
  }
});

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(731), __esModule: true };

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

/*! codem-isoboxer v0.3.4 https://github.com/madebyhiro/codem-isoboxer/blob/master/LICENSE.txt */
var ISOBoxer = {};

ISOBoxer.parseBuffer = function(arrayBuffer) {
  return new ISOFile(arrayBuffer).parse();
};

ISOBoxer.addBoxProcessor = function(type, parser) {
  if (typeof type !== 'string' || typeof parser !== 'function') {
    return;
  }
  ISOBox.prototype._boxProcessors[type] = parser;
};

ISOBoxer.createFile = function() {
  return new ISOFile();
};

// See ISOBoxer.append() for 'pos' parameter syntax
ISOBoxer.createBox = function(type, parent, pos) {
  var newBox = ISOBox.create(type);
  if (parent) {
    parent.append(newBox, pos);
  }
  return newBox;
};

// See ISOBoxer.append() for 'pos' parameter syntax
ISOBoxer.createFullBox = function(type, parent, pos) {
  var newBox = ISOBoxer.createBox(type, parent, pos);
  newBox.version = 0;
  newBox.flags = 0;
  return newBox;
};

ISOBoxer.Utils = {};
ISOBoxer.Utils.dataViewToString = function(dataView, encoding) {
  var impliedEncoding = encoding || 'utf-8';
  if (typeof TextDecoder !== 'undefined') {
    return new TextDecoder(impliedEncoding).decode(dataView);
  }
  var a = [];
  var i = 0;

  if (impliedEncoding === 'utf-8') {
    /* The following algorithm is essentially a rewrite of the UTF8.decode at
    http://bannister.us/weblog/2007/simple-base64-encodedecode-javascript/
    */

    while (i < dataView.byteLength) {
      var c = dataView.getUint8(i++);
      if (c < 0x80) {
        // 1-byte character (7 bits)
      } else if (c < 0xe0) {
        // 2-byte character (11 bits)
        c = (c & 0x1f) << 6;
        c |= (dataView.getUint8(i++) & 0x3f);
      } else if (c < 0xf0) {
        // 3-byte character (16 bits)
        c = (c & 0xf) << 12;
        c |= (dataView.getUint8(i++) & 0x3f) << 6;
        c |= (dataView.getUint8(i++) & 0x3f);
      } else {
        // 4-byte character (21 bits)
        c = (c & 0x7) << 18;
        c |= (dataView.getUint8(i++) & 0x3f) << 12;
        c |= (dataView.getUint8(i++) & 0x3f) << 6;
        c |= (dataView.getUint8(i++) & 0x3f);
      }
      a.push(String.fromCharCode(c));
    }
  } else { // Just map byte-by-byte (probably wrong)
    while (i < dataView.byteLength) {
      a.push(String.fromCharCode(dataView.getUint8(i++)));
    }
  }
  return a.join('');
};

ISOBoxer.Utils.utf8ToByteArray = function(string) {
  // Only UTF-8 encoding is supported by TextEncoder
  var u, i;
  if (typeof TextEncoder !== 'undefined') {
    u = new TextEncoder().encode(string);
  } else {
    u = [];
    for (i = 0; i < string.length; ++i) {
      var c = string.charCodeAt(i);
      if (c < 0x80) {
        u.push(c);
      } else if (c < 0x800) {
        u.push(0xC0 | (c >> 6));
        u.push(0x80 | (63 & c));
      } else if (c < 0x10000) {
        u.push(0xE0 | (c >> 12));
        u.push(0x80 | (63 & (c >> 6)));
        u.push(0x80 | (63 & c));
      } else {
        u.push(0xF0 | (c >> 18));
        u.push(0x80 | (63 & (c >> 12)));
        u.push(0x80 | (63 & (c >> 6)));
        u.push(0x80 | (63 & c));
      }
    }
  }
  return u;
};

// Method to append a box in the list of child boxes
// The 'pos' parameter can be either:
//   - (number) a position index at which to insert the new box
//   - (string) the type of the box after which to insert the new box
//   - (object) the box after which to insert the new box
ISOBoxer.Utils.appendBox = function(parent, box, pos) {
  box._offset = parent._cursor.offset;
  box._root = (parent._root ? parent._root : parent);
  box._raw = parent._raw;
  box._parent = parent;

  if (pos === -1) {
    // The new box is a sub-box of the parent but not added in boxes array,
    // for example when the new box is set as an entry (see dref and stsd for example)
    return;
  }

  if (pos === undefined || pos === null) {
    parent.boxes.push(box);
    return;
  }

  var index = -1,
      type;

  if (typeof pos === "number") {
    index = pos;
  } else {
    if (typeof pos === "string") {
      type = pos;
    } else if (typeof pos === "object" && pos.type) {
      type = pos.type;
    } else {
      parent.boxes.push(box);
      return;
    }

    for (var i = 0; i < parent.boxes.length; i++) {
      if (type === parent.boxes[i].type) {
        index = i + 1;
        break;
      }
    }
  }
  parent.boxes.splice(index, 0, box);
};

if (true) {
  exports.parseBuffer     = ISOBoxer.parseBuffer;
  exports.addBoxProcessor = ISOBoxer.addBoxProcessor;
  exports.createFile      = ISOBoxer.createFile;
  exports.createBox       = ISOBoxer.createBox;
  exports.createFullBox   = ISOBoxer.createFullBox;
  exports.Utils           = ISOBoxer.Utils;
}

ISOBoxer.Cursor = function(initialOffset) {
  this.offset = (typeof initialOffset == 'undefined' ? 0 : initialOffset);
};

var ISOFile = function(arrayBuffer) {
  this._cursor = new ISOBoxer.Cursor();
  this.boxes = [];
  if (arrayBuffer) {
    this._raw = new DataView(arrayBuffer);
  }
};

ISOFile.prototype.fetch = function(type) {
  var result = this.fetchAll(type, true);
  return (result.length ? result[0] : null);
};

ISOFile.prototype.fetchAll = function(type, returnEarly) {
  var result = [];
  ISOFile._sweep.call(this, type, result, returnEarly);
  return result;
};

ISOFile.prototype.parse = function() {
  this._cursor.offset = 0;
  this.boxes = [];
  while (this._cursor.offset < this._raw.byteLength) {
    var box = ISOBox.parse(this);

    // Box could not be parsed
    if (typeof box.type === 'undefined') break;

    this.boxes.push(box);
  }
  return this;
};

ISOFile._sweep = function(type, result, returnEarly) {
  if (this.type && this.type == type) result.push(this);
  for (var box in this.boxes) {
    if (result.length && returnEarly) return;
    ISOFile._sweep.call(this.boxes[box], type, result, returnEarly);
  }
};

ISOFile.prototype.write = function() {

  var length = 0,
      i;

  for (i = 0; i < this.boxes.length; i++) {
    length += this.boxes[i].getLength(false);
  }

  var bytes = new Uint8Array(length);
  this._rawo = new DataView(bytes.buffer);
  this.bytes = bytes;
  this._cursor.offset = 0;

  for (i = 0; i < this.boxes.length; i++) {
    this.boxes[i].write();
  }

  return bytes.buffer;
};

ISOFile.prototype.append = function(box, pos) {
  ISOBoxer.Utils.appendBox(this, box, pos);
};
var ISOBox = function() {
  this._cursor = new ISOBoxer.Cursor();
};

ISOBox.parse = function(parent) {
  var newBox = new ISOBox();
  newBox._offset = parent._cursor.offset;
  newBox._root = (parent._root ? parent._root : parent);
  newBox._raw = parent._raw;
  newBox._parent = parent;
  newBox._parseBox();
  parent._cursor.offset = newBox._raw.byteOffset + newBox._raw.byteLength;
  return newBox;
};

ISOBox.create = function(type) {
  var newBox = new ISOBox();
  newBox.type = type;
  newBox.boxes = [];
  return newBox;
};

ISOBox.prototype._boxContainers = ['dinf', 'edts', 'mdia', 'meco', 'mfra', 'minf', 'moof', 'moov', 'mvex', 'stbl', 'strk', 'traf', 'trak', 'tref', 'udta', 'vttc', 'sinf', 'schi', 'encv', 'enca'];

ISOBox.prototype._boxProcessors = {};

///////////////////////////////////////////////////////////////////////////////////////////////////
// Generic read/write functions

ISOBox.prototype._procField = function (name, type, size) {
  if (this._parsing) {
    this[name] = this._readField(type, size);
  }
  else {
    this._writeField(type, size, this[name]);
  }
};

ISOBox.prototype._procFieldArray = function (name, length, type, size) {
  var i;
  if (this._parsing) {
    this[name] = [];
    for (i = 0; i < length; i++) {
      this[name][i] = this._readField(type, size);
    }
  }
  else {
    for (i = 0; i < this[name].length; i++) {
      this._writeField(type, size, this[name][i]);
    }
  }
};

ISOBox.prototype._procFullBox = function() {
  this._procField('version', 'uint', 8);
  this._procField('flags', 'uint', 24);
};

ISOBox.prototype._procEntries = function(name, length, fn) {
  var i;
  if (this._parsing) {
    this[name] = [];
    for (i = 0; i < length; i++) {
      this[name].push({});
      fn.call(this, this[name][i]);
    }
  }
  else {
    for (i = 0; i < length; i++) {
      fn.call(this, this[name][i]);
    }
  }
};

ISOBox.prototype._procSubEntries = function(entry, name, length, fn) {
  var i;
  if (this._parsing) {
    entry[name] = [];
    for (i = 0; i < length; i++) {
      entry[name].push({});
      fn.call(this, entry[name][i]);
    }
  }
  else {
    for (i = 0; i < length; i++) {
      fn.call(this, entry[name][i]);
    }
  }
};

ISOBox.prototype._procEntryField = function (entry, name, type, size) {
  if (this._parsing) {
    entry[name] = this._readField(type, size);
  }
  else {
    this._writeField(type, size, entry[name]);
  }
};

ISOBox.prototype._procSubBoxes = function(name, length) {
  var i;
  if (this._parsing) {
    this[name] = [];
    for (i = 0; i < length; i++) {
      this[name].push(ISOBox.parse(this));
    }
  }
  else {
    for (i = 0; i < length; i++) {
      if (this._rawo) {
        this[name][i].write();
      } else {
        this.size += this[name][i].getLength();
      }
    }
  }
};

///////////////////////////////////////////////////////////////////////////////////////////////////
// Read/parse functions

ISOBox.prototype._readField = function(type, size) {
  switch (type) {
    case 'uint':
      return this._readUint(size);
    case 'int':
      return this._readInt(size);
    case 'template':
      return this._readTemplate(size);
    case 'string':
      return (size === -1) ? this._readTerminatedString() : this._readString(size);
    case 'data':
      return this._readData(size);
    case 'utf8':
      return this._readUTF8String();
    default:
      return -1;
  }
};

ISOBox.prototype._readInt = function(size) {
  var result = null,
      offset = this._cursor.offset - this._raw.byteOffset;
  switch(size) {
  case 8:
    result = this._raw.getInt8(offset);
    break;
  case 16:
    result = this._raw.getInt16(offset);
    break;
  case 32:
    result = this._raw.getInt32(offset);
    break;
  case 64:
    // Warning: JavaScript cannot handle 64-bit integers natively.
    // This will give unexpected results for integers >= 2^53
    var s1 = this._raw.getInt32(offset);
    var s2 = this._raw.getInt32(offset + 4);
    result = (s1 * Math.pow(2,32)) + s2;
    break;
  }
  this._cursor.offset += (size >> 3);
  return result;
};

ISOBox.prototype._readUint = function(size) {
  var result = null,
      offset = this._cursor.offset - this._raw.byteOffset,
      s1, s2;
  switch(size) {
  case 8:
    result = this._raw.getUint8(offset);
    break;
  case 16:
    result = this._raw.getUint16(offset);
    break;
  case 24:
    s1 = this._raw.getUint16(offset);
    s2 = this._raw.getUint8(offset + 2);
    result = (s1 << 8) + s2;
    break;
  case 32:
    result = this._raw.getUint32(offset);
    break;
  case 64:
    // Warning: JavaScript cannot handle 64-bit integers natively.
    // This will give unexpected results for integers >= 2^53
    s1 = this._raw.getUint32(offset);
    s2 = this._raw.getUint32(offset + 4);
    result = (s1 * Math.pow(2,32)) + s2;
    break;
  }
  this._cursor.offset += (size >> 3);
  return result;
};

ISOBox.prototype._readString = function(length) {
  var str = '';
  for (var c = 0; c < length; c++) {
    var char = this._readUint(8);
    str += String.fromCharCode(char);
  }
  return str;
};

ISOBox.prototype._readTemplate = function(size) {
  var pre = this._readUint(size / 2);
  var post = this._readUint(size / 2);
  return pre + (post / Math.pow(2, size / 2));
};

ISOBox.prototype._readTerminatedString = function() {
  var str = '';
  while (this._cursor.offset - this._offset < this._raw.byteLength) {
    var char = this._readUint(8);
    if (char === 0) break;
    str += String.fromCharCode(char);
  }
  return str;
};

ISOBox.prototype._readData = function(size) {
  var length = (size > 0) ? size : (this._raw.byteLength - (this._cursor.offset - this._offset));
  var data = new DataView(this._raw.buffer, this._cursor.offset, length);
  this._cursor.offset += length;
  return data;
};

ISOBox.prototype._readUTF8String = function() {
  var data = this._readData();
  return ISOBoxer.Utils.dataViewToString(data);
};

ISOBox.prototype._parseBox = function() {
  this._parsing = true;
  this._cursor.offset = this._offset;

  // return immediately if there are not enough bytes to read the header
  if (this._offset + 8 > this._raw.buffer.byteLength) {
    this._root._incomplete = true;
    return;
  }

  this._procField('size', 'uint', 32);
  this._procField('type', 'string', 4);

  if (this.size === 1)      { this._procField('largesize', 'uint', 64); }
  if (this.type === 'uuid') { this._procFieldArray('usertype', 16, 'uint', 8); }

  switch(this.size) {
  case 0:
    this._raw = new DataView(this._raw.buffer, this._offset, (this._raw.byteLength - this._cursor.offset + 8));
    break;
  case 1:
    if (this._offset + this.size > this._raw.buffer.byteLength) {
      this._incomplete = true;
      this._root._incomplete = true;
    } else {
      this._raw = new DataView(this._raw.buffer, this._offset, this.largesize);
    }
    break;
  default:
    if (this._offset + this.size > this._raw.buffer.byteLength) {
      this._incomplete = true;
      this._root._incomplete = true;
    } else {
      this._raw = new DataView(this._raw.buffer, this._offset, this.size);
    }
  }

  // additional parsing
  if (!this._incomplete) {
    if (this._boxProcessors[this.type]) {
      this._boxProcessors[this.type].call(this);
    }
    if (this._boxContainers.indexOf(this.type) !== -1) {
      this._parseContainerBox();
    } else{
      // Unknown box => read and store box content
      this._data = this._readData();
    }
  }
};

ISOBox.prototype._parseFullBox = function() {
  this.version = this._readUint(8);
  this.flags = this._readUint(24);
};

ISOBox.prototype._parseContainerBox = function() {
  this.boxes = [];
  while (this._cursor.offset - this._raw.byteOffset < this._raw.byteLength) {
    this.boxes.push(ISOBox.parse(this));
  }
};

///////////////////////////////////////////////////////////////////////////////////////////////////
// Write functions

ISOBox.prototype.append = function(box, pos) {
  ISOBoxer.Utils.appendBox(this, box, pos);
};

ISOBox.prototype.getLength = function() {
  this._parsing = false;
  this._rawo = null;

  this.size = 0;
  this._procField('size', 'uint', 32);
  this._procField('type', 'string', 4);

  if (this.size === 1)      { this._procField('largesize', 'uint', 64); }
  if (this.type === 'uuid') { this._procFieldArray('usertype', 16, 'uint', 8); }

  if (this._boxProcessors[this.type]) {
    this._boxProcessors[this.type].call(this);
  }

  if (this._boxContainers.indexOf(this.type) !== -1) {
    for (var i = 0; i < this.boxes.length; i++) {
      this.size += this.boxes[i].getLength();
    }
  } 

  if (this._data) {
    this._writeData(this._data);
  }

  return this.size;
};

ISOBox.prototype.write = function() {
  this._parsing = false;
  this._cursor.offset = this._parent._cursor.offset;

  switch(this.size) {
  case 0:
    this._rawo = new DataView(this._parent._rawo.buffer, this._cursor.offset, (this.parent._rawo.byteLength - this._cursor.offset));
    break;
  case 1:
      this._rawo = new DataView(this._parent._rawo.buffer, this._cursor.offset, this.largesize);
    break;
  default:
      this._rawo = new DataView(this._parent._rawo.buffer, this._cursor.offset, this.size);
  }

  this._procField('size', 'uint', 32);
  this._procField('type', 'string', 4);

  if (this.size === 1)      { this._procField('largesize', 'uint', 64); }
  if (this.type === 'uuid') { this._procFieldArray('usertype', 16, 'uint', 8); }

  if (this._boxProcessors[this.type]) {
    this._boxProcessors[this.type].call(this);
  }

  if (this._boxContainers.indexOf(this.type) !== -1) {
    for (var i = 0; i < this.boxes.length; i++) {
      this.boxes[i].write();
    }
  } 

  if (this._data) {
    this._writeData(this._data);
  }

  this._parent._cursor.offset += this.size;

  return this.size;
};

ISOBox.prototype._writeInt = function(size, value) {
  if (this._rawo) {
    var offset = this._cursor.offset - this._rawo.byteOffset;
    switch(size) {
    case 8:
      this._rawo.setInt8(offset, value);
      break;
    case 16:
      this._rawo.setInt16(offset, value);
      break;
    case 32:
      this._rawo.setInt32(offset, value);
      break;
    case 64:
      // Warning: JavaScript cannot handle 64-bit integers natively.
      // This will give unexpected results for integers >= 2^53
      var s1 = Math.floor(value / Math.pow(2,32));
      var s2 = value - (s1 * Math.pow(2,32));
      this._rawo.setUint32(offset, s1);
      this._rawo.setUint32(offset + 4, s2);
      break;
    }
    this._cursor.offset += (size >> 3);
  } else {
    this.size += (size >> 3);
  }
};

ISOBox.prototype._writeUint = function(size, value) {

  if (this._rawo) {
    var offset = this._cursor.offset - this._rawo.byteOffset,
        s1, s2;
    switch(size) {
    case 8:
      this._rawo.setUint8(offset, value);
      break;
    case 16:
      this._rawo.setUint16(offset, value);
      break;
    case 24:
      s1 = (value & 0xFFFF00) >> 8;
      s2 = (value & 0x0000FF);
      this._rawo.setUint16(offset, s1);
      this._rawo.setUint8(offset + 2, s2);
      break;
    case 32:
      this._rawo.setUint32(offset, value);
      break;
    case 64:
      // Warning: JavaScript cannot handle 64-bit integers natively.
      // This will give unexpected results for integers >= 2^53
      s1 = Math.floor(value / Math.pow(2,32));
      s2 = value - (s1 * Math.pow(2,32));
      this._rawo.setUint32(offset, s1);
      this._rawo.setUint32(offset + 4, s2);
      break;
    }
    this._cursor.offset += (size >> 3);
  } else {
    this.size += (size >> 3);
  }
};

ISOBox.prototype._writeString = function(size, str) {
  for (var c = 0; c < size; c++) {
    this._writeUint(8, str.charCodeAt(c));
  }
};

ISOBox.prototype._writeTerminatedString = function(str) {
  if (str.length === 0) {
    return;
  }
  for (var c = 0; c < str.length; c++) {
    this._writeUint(8, str.charCodeAt(c));
  }
  this._writeUint(8, 0);
};

ISOBox.prototype._writeTemplate = function(size, value) {
  var pre = Math.floor(value);
  var post = (value - pre) * Math.pow(2, size / 2);
  this._writeUint(size / 2, pre);
  this._writeUint(size / 2, post);
};

ISOBox.prototype._writeData = function(data) {
  var i;
  if (data instanceof Array) {
    if (!Uint8Array.from) {
      var typedArray = new Uint8Array(data.length);
      for (i = 0; i < data.length; i++) {
        typedArray[i] = data[i];
      }
      data = new DataView(typedArray.buffer);
    } else {
      data = new DataView(Uint8Array.from(data).buffer);
    }
  }
  if (data instanceof Uint8Array) {
    data = new DataView(data.buffer);
  }
  if (this._rawo) {
    var offset = this._cursor.offset - this._rawo.byteOffset;
    for (i = 0; i < data.byteLength; i++) {
        this._rawo.setUint8(offset + i, data.getUint8(i));
    }
    this._cursor.offset += data.byteLength;
  } else {
    this.size += data.byteLength;
  }
};

ISOBox.prototype._writeUTF8String = function(string) {
  var u = ISOBoxer.Utils.utf8ToByteArray(string);
  if (this._rawo) {
    var dataView = new DataView(this._rawo.buffer, this._cursor.offset, u.length);
    for (var i = 0; i < u.length; i++) {
      dataView.setUint8(i, u[i]);
    }
  } else {
    this.size += u.length;
  }
};

ISOBox.prototype._writeField = function(type, size, value) {
  switch (type) {
  case 'uint':
    this._writeUint(size, value);
    break;
  case 'int':
    this._writeInt(size, value);
    break;
  case 'template':
    this._writeTemplate(size, value);
    break;
  case 'string':
      if (size == -1) {
        this._writeTerminatedString(value);
      } else {
        this._writeString(size, value);
      }
      break;
  case 'data':
    this._writeData(value);
    break;
  case 'utf8':
    this._writeUTF8String(value);
    break;
  default:
    break;
  }
};

// ISO/IEC 14496-15:2014 - avc1 box
ISOBox.prototype._boxProcessors['avc1'] = ISOBox.prototype._boxProcessors['encv'] = function() {
  // SampleEntry fields
  this._procFieldArray('reserved1', 6,    'uint', 8);
  this._procField('data_reference_index', 'uint', 16);
  // VisualSampleEntry fields
  this._procField('pre_defined1',         'uint',     16);
  this._procField('reserved2',            'uint',     16);
  this._procFieldArray('pre_defined2', 3, 'uint',     32);
  this._procField('width',                'uint',     16);
  this._procField('height',               'uint',     16);
  this._procField('horizresolution',      'template', 32);
  this._procField('vertresolution',       'template', 32);
  this._procField('reserved3',            'uint',     32);
  this._procField('frame_count',          'uint',     16);
  this._procFieldArray('compressorname', 32,'uint',    8);
  this._procField('depth',                'uint',     16);
  this._procField('pre_defined3',         'int',      16);
  // AVCSampleEntry fields
  this._procField('config', 'data', -1);
};

// ISO/IEC 14496-12:2012 - 8.7.2 Data Reference Box
ISOBox.prototype._boxProcessors['dref'] = function() {
  this._procFullBox();
  this._procField('entry_count', 'uint', 32);
  this._procSubBoxes('entries', this.entry_count);
};

// ISO/IEC 14496-12:2012 - 8.6.6 Edit List Box
ISOBox.prototype._boxProcessors['elst'] = function() {
  this._procFullBox();
  this._procField('entry_count', 'uint', 32);
  this._procEntries('entries', this.entry_count, function(entry) {
    this._procEntryField(entry, 'segment_duration',     'uint', (this.version === 1) ? 64 : 32);
    this._procEntryField(entry, 'media_time',           'int',  (this.version === 1) ? 64 : 32);
    this._procEntryField(entry, 'media_rate_integer',   'int',  16);
    this._procEntryField(entry, 'media_rate_fraction',  'int',  16);
  });
};

// ISO/IEC 23009-1:2014 - 5.10.3.3 Event Message Box
ISOBox.prototype._boxProcessors['emsg'] = function() {
  this._procFullBox();
  this._procField('scheme_id_uri',            'string', -1);
  this._procField('value',                    'string', -1);
  this._procField('timescale',                'uint',   32);
  this._procField('presentation_time_delta',  'uint',   32);
  this._procField('event_duration',           'uint',   32);
  this._procField('id',                       'uint',   32);
  this._procField('message_data',             'data',   -1);
};

// ISO/IEC 14496-12:2012 - 8.1.2 Free Space Box
ISOBox.prototype._boxProcessors['free'] = ISOBox.prototype._boxProcessors['skip'] = function() {
  this._procField('data', 'data', -1);
};

// ISO/IEC 14496-12:2012 - 8.12.2 Original Format Box
ISOBox.prototype._boxProcessors['frma'] = function() {
  this._procField('data_format', 'uint', 32);
};
// ISO/IEC 14496-12:2012 - 4.3 File Type Box / 8.16.2 Segment Type Box
ISOBox.prototype._boxProcessors['ftyp'] =
ISOBox.prototype._boxProcessors['styp'] = function() {
  this._procField('major_brand', 'string', 4);
  this._procField('minor_version', 'uint', 32);
  var nbCompatibleBrands = -1;
  if (this._parsing) {
    nbCompatibleBrands = (this._raw.byteLength - (this._cursor.offset - this._raw.byteOffset)) / 4;
  }
  this._procFieldArray('compatible_brands', nbCompatibleBrands, 'string', 4);
};

// ISO/IEC 14496-12:2012 - 8.4.3 Handler Reference Box
ISOBox.prototype._boxProcessors['hdlr'] = function() {
  this._procFullBox();
  this._procField('pre_defined',      'uint',   32);
  this._procField('handler_type',     'string', 4);
  this._procFieldArray('reserved', 3, 'uint', 32);
  this._procField('name',             'string', -1);
};

// ISO/IEC 14496-12:2012 - 8.1.1 Media Data Box
ISOBox.prototype._boxProcessors['mdat'] = function() {
  this._procField('data', 'data', -1);
};

// ISO/IEC 14496-12:2012 - 8.4.2 Media Header Box
ISOBox.prototype._boxProcessors['mdhd'] = function() {
  this._procFullBox();
  this._procField('creation_time',      'uint', (this.version == 1) ? 64 : 32);
  this._procField('modification_time',  'uint', (this.version == 1) ? 64 : 32);
  this._procField('timescale',          'uint', 32);
  this._procField('duration',           'uint', (this.version == 1) ? 64 : 32);
  if (!this._parsing && typeof this.language === 'string') {
    // In case of writing and language has been set as a string, then convert it into char codes array
    this.language = ((this.language.charCodeAt(0) - 0x60) << 10) |
                    ((this.language.charCodeAt(1) - 0x60) << 5) |
                    ((this.language.charCodeAt(2) - 0x60));
  }
  this._procField('language',           'uint', 16);
  if (this._parsing) {
    this.language = String.fromCharCode(((this.language >> 10) & 0x1F) + 0x60,
                                        ((this.language >> 5) & 0x1F) + 0x60,
                                        (this.language & 0x1F) + 0x60);
  }
  this._procField('pre_defined',        'uint', 16);
};

// ISO/IEC 14496-12:2012 - 8.8.2 Movie Extends Header Box
ISOBox.prototype._boxProcessors['mehd'] = function() {
  this._procFullBox();
  this._procField('fragment_duration', 'uint', (this.version == 1) ? 64 : 32);
};

// ISO/IEC 14496-12:2012 - 8.8.5 Movie Fragment Header Box
ISOBox.prototype._boxProcessors['mfhd'] = function() {
  this._procFullBox();
  this._procField('sequence_number', 'uint', 32);
};

// ISO/IEC 14496-12:2012 - 8.8.11 Movie Fragment Random Access Box
ISOBox.prototype._boxProcessors['mfro'] = function() {
  this._procFullBox();
  this._procField('mfra_size', 'uint', 32); // Called mfra_size to distinguish from the normal "size" attribute of a box
};


// ISO/IEC 14496-12:2012 - 8.5.2.2 mp4a box (use AudioSampleEntry definition and naming)
ISOBox.prototype._boxProcessors['mp4a'] = ISOBox.prototype._boxProcessors['enca'] = function() {
  // SampleEntry fields
  this._procFieldArray('reserved1', 6,    'uint', 8);
  this._procField('data_reference_index', 'uint', 16);
  // AudioSampleEntry fields
  this._procFieldArray('reserved2', 2,    'uint', 32);
  this._procField('channelcount',         'uint', 16);
  this._procField('samplesize',           'uint', 16);
  this._procField('pre_defined',          'uint', 16);
  this._procField('reserved3',            'uint', 16);
  this._procField('samplerate',           'template', 32);
  // ESDescriptor fields
  this._procField('esds',                 'data', -1);
};

// ISO/IEC 14496-12:2012 - 8.2.2 Movie Header Box
ISOBox.prototype._boxProcessors['mvhd'] = function() {
  this._procFullBox();
  this._procField('creation_time',      'uint',     (this.version == 1) ? 64 : 32);
  this._procField('modification_time',  'uint',     (this.version == 1) ? 64 : 32);
  this._procField('timescale',          'uint',     32);
  this._procField('duration',           'uint',     (this.version == 1) ? 64 : 32);
  this._procField('rate',               'template', 32);
  this._procField('volume',             'template', 16);
  this._procField('reserved1',          'uint',  16);
  this._procFieldArray('reserved2', 2,  'uint',     32);
  this._procFieldArray('matrix', 9,     'template', 32);
  this._procFieldArray('pre_defined', 6,'uint',   32);
  this._procField('next_track_ID',      'uint',     32);
};

// ISO/IEC 14496-30:2014 - WebVTT Cue Payload Box.
ISOBox.prototype._boxProcessors['payl'] = function() {
  this._procField('cue_text', 'utf8');
};

//ISO/IEC 23001-7:2011 - 8.1 Protection System Specific Header Box
ISOBox.prototype._boxProcessors['pssh'] = function() {
  this._procFullBox();
  
  this._procFieldArray('SystemID', 16, 'uint', 8);
  this._procField('DataSize', 'uint', 32);
  this._procFieldArray('Data', this.DataSize, 'uint', 8);
};
// ISO/IEC 14496-12:2012 - 8.12.5 Scheme Type Box
ISOBox.prototype._boxProcessors['schm'] = function() {
    this._procFullBox();
    
    this._procField('scheme_type', 'uint', 32);
    this._procField('scheme_version', 'uint', 32);

    if (this.flags & 0x000001) {
        this._procField('scheme_uri', 'string', -1);
    }
};
// ISO/IEC 14496-12:2012 - 8.6.4.1 sdtp box 
ISOBox.prototype._boxProcessors['sdtp'] = function() {
  this._procFullBox();

  var sample_count = -1;
  if (this._parsing) {
    sample_count = (this._raw.byteLength - (this._cursor.offset - this._raw.byteOffset));
  }

  this._procFieldArray('sample_dependency_table', sample_count, 'uint', 8);
};

// ISO/IEC 14496-12:2012 - 8.16.3 Segment Index Box
ISOBox.prototype._boxProcessors['sidx'] = function() {
  this._procFullBox();
  this._procField('reference_ID', 'uint', 32);
  this._procField('timescale', 'uint', 32);
  this._procField('earliest_presentation_time', 'uint', (this.version == 1) ? 64 : 32);
  this._procField('first_offset', 'uint', (this.version == 1) ? 64 : 32);
  this._procField('reserved', 'uint', 16);
  this._procField('reference_count', 'uint', 16);
  this._procEntries('references', this.reference_count, function(entry) {
    if (!this._parsing) {
      entry.reference  = (entry.reference_type  & 0x00000001) << 31;
      entry.reference |= (entry.referenced_size & 0x7FFFFFFF);
      entry.sap  = (entry.starts_with_SAP & 0x00000001) << 31;
      entry.sap |= (entry.SAP_type        & 0x00000003) << 28;
      entry.sap |= (entry.SAP_delta_time  & 0x0FFFFFFF);
    }
    this._procEntryField(entry, 'reference', 'uint', 32);
    this._procEntryField(entry, 'subsegment_duration', 'uint', 32);
    this._procEntryField(entry, 'sap', 'uint', 32);
    if (this._parsing) {
      entry.reference_type = (entry.reference >> 31) & 0x00000001;
      entry.referenced_size = entry.reference & 0x7FFFFFFF;
      entry.starts_with_SAP  = (entry.sap >> 31) & 0x00000001;
      entry.SAP_type = (entry.sap >> 28) & 0x00000007;
      entry.SAP_delta_time = (entry.sap  & 0x0FFFFFFF);
    }
  });
};

// ISO/IEC 14496-12:2012 - 8.4.5.3 Sound Media Header Box
ISOBox.prototype._boxProcessors['smhd'] = function() {
  this._procFullBox();
  this._procField('balance',  'uint', 16);
  this._procField('reserved', 'uint', 16);
};

// ISO/IEC 14496-12:2012 - 8.16.4 Subsegment Index Box
ISOBox.prototype._boxProcessors['ssix'] = function() {
  this._procFullBox();
  this._procField('subsegment_count', 'uint', 32);
  this._procEntries('subsegments', this.subsegment_count, function(subsegment) {
    this._procEntryField(subsegment, 'ranges_count', 'uint', 32);
    this._procSubEntries(subsegment, 'ranges', subsegment.ranges_count, function(range) {
      this._procEntryField(range, 'level', 'uint', 8);
      this._procEntryField(range, 'range_size', 'uint', 24);
    });
  });
};

// ISO/IEC 14496-12:2012 - 8.5.2 Sample Description Box
ISOBox.prototype._boxProcessors['stsd'] = function() {
  this._procFullBox();
  this._procField('entry_count', 'uint', 32);
  this._procSubBoxes('entries', this.entry_count);
};

// ISO/IEC 14496-12:2015 - 8.7.7 Sub-Sample Information Box
ISOBox.prototype._boxProcessors['subs'] = function () {
  this._procFullBox();
  this._procField('entry_count', 'uint', 32);
  this._procEntries('entries', this.entry_count, function(entry) {
    this._procEntryField(entry, 'sample_delta', 'uint', 32);
    this._procEntryField(entry, 'subsample_count', 'uint', 16);
    this._procSubEntries(entry, 'subsamples', entry.subsample_count, function(subsample) {
      this._procEntryField(subsample, 'subsample_size', 'uint', (this.version === 1) ? 32 : 16);
      this._procEntryField(subsample, 'subsample_priority', 'uint', 8);
      this._procEntryField(subsample, 'discardable', 'uint', 8);
      this._procEntryField(subsample, 'codec_specific_parameters', 'uint', 32);
    });
  });
};

//ISO/IEC 23001-7:2011 - 8.2 Track Encryption Box
ISOBox.prototype._boxProcessors['tenc'] = function() {
    this._procFullBox();

    this._procField('default_IsEncrypted', 'uint', 24);
    this._procField('default_IV_size', 'uint', 8);
    this._procFieldArray('default_KID', 16,    'uint', 8);
 };

// ISO/IEC 14496-12:2012 - 8.8.12 Track Fragmnent Decode Time
ISOBox.prototype._boxProcessors['tfdt'] = function() {
  this._procFullBox();
  this._procField('baseMediaDecodeTime', 'uint', (this.version == 1) ? 64 : 32);
};

// ISO/IEC 14496-12:2012 - 8.8.7 Track Fragment Header Box
ISOBox.prototype._boxProcessors['tfhd'] = function() {
  this._procFullBox();
  this._procField('track_ID', 'uint', 32);
  if (this.flags & 0x01) this._procField('base_data_offset',          'uint', 64);
  if (this.flags & 0x02) this._procField('sample_description_offset', 'uint', 32);
  if (this.flags & 0x08) this._procField('default_sample_duration',   'uint', 32);
  if (this.flags & 0x10) this._procField('default_sample_size',       'uint', 32);
  if (this.flags & 0x20) this._procField('default_sample_flags',      'uint', 32);
};

// ISO/IEC 14496-12:2012 - 8.8.10 Track Fragment Random Access Box
ISOBox.prototype._boxProcessors['tfra'] = function() {
  this._procFullBox();
  this._procField('track_ID', 'uint', 32);
  if (!this._parsing) {
    this.reserved = 0;
    this.reserved |= (this.length_size_of_traf_num  & 0x00000030) << 4;
    this.reserved |= (this.length_size_of_trun_num  & 0x0000000C) << 2;
    this.reserved |= (this.length_size_of_sample_num  & 0x00000003);
  }
  this._procField('reserved', 'uint', 32);
  if (this._parsing) {
    this.length_size_of_traf_num = (this.reserved & 0x00000030) >> 4;
    this.length_size_of_trun_num = (this.reserved & 0x0000000C) >> 2;
    this.length_size_of_sample_num = (this.reserved & 0x00000003);
  }
  this._procField('number_of_entry', 'uint', 32);
  this._procEntries('entries', this.number_of_entry, function(entry) {
    this._procEntryField(entry, 'time', 'uint', (this.version === 1) ? 64 : 32);
    this._procEntryField(entry, 'moof_offset', 'uint', (this.version === 1) ? 64 : 32);
    this._procEntryField(entry, 'traf_number', 'uint', (this.length_size_of_traf_num + 1) * 8);
    this._procEntryField(entry, 'trun_number', 'uint', (this.length_size_of_trun_num + 1) * 8);
    this._procEntryField(entry, 'sample_number', 'uint', (this.length_size_of_sample_num + 1) * 8);
  });
};

// ISO/IEC 14496-12:2012 - 8.3.2 Track Header Box
ISOBox.prototype._boxProcessors['tkhd'] = function() {
  this._procFullBox();
  this._procField('creation_time',      'uint',     (this.version == 1) ? 64 : 32);
  this._procField('modification_time',  'uint',     (this.version == 1) ? 64 : 32);
  this._procField('track_ID',           'uint',     32);
  this._procField('reserved1',          'uint',     32);
  this._procField('duration',           'uint',     (this.version == 1) ? 64 : 32);
  this._procFieldArray('reserved2', 2,  'uint',     32);
  this._procField('layer',              'uint',     16);
  this._procField('alternate_group',    'uint',     16);
  this._procField('volume',             'template', 16);
  this._procField('reserved3',          'uint',     16);
  this._procFieldArray('matrix', 9,     'template', 32);
  this._procField('width',              'template', 32);
  this._procField('height',             'template', 32);
};

// ISO/IEC 14496-12:2012 - 8.8.3 Track Extends Box
ISOBox.prototype._boxProcessors['trex'] = function() {
  this._procFullBox();
  this._procField('track_ID',                         'uint', 32);
  this._procField('default_sample_description_index', 'uint', 32);
  this._procField('default_sample_duration',          'uint', 32);
  this._procField('default_sample_size',              'uint', 32);
  this._procField('default_sample_flags',             'uint', 32);
};

// ISO/IEC 14496-12:2012 - 8.8.8 Track Run Box
// Note: the 'trun' box has a direct relation to the 'tfhd' box for defaults.
// These defaults are not set explicitly here, but are left to resolve for the user.
ISOBox.prototype._boxProcessors['trun'] = function() {
  this._procFullBox();
  this._procField('sample_count', 'uint', 32);
  if (this.flags & 0x1) this._procField('data_offset', 'int', 32);
  if (this.flags & 0x4) this._procField('first_sample_flags', 'uint', 32);
  this._procEntries('samples', this.sample_count, function(sample) {
    if (this.flags & 0x100) this._procEntryField(sample, 'sample_duration', 'uint', 32);
    if (this.flags & 0x200) this._procEntryField(sample, 'sample_size', 'uint', 32);
    if (this.flags & 0x400) this._procEntryField(sample, 'sample_flags', 'uint', 32);
    if (this.flags & 0x800) this._procEntryField(sample, 'sample_composition_time_offset', (this.version === 1) ? 'int' : 'uint',  32);
  });
};

// ISO/IEC 14496-12:2012 - 8.7.2 Data Reference Box
ISOBox.prototype._boxProcessors['url '] = ISOBox.prototype._boxProcessors['urn '] = function() {
  this._procFullBox();
  if (this.type === 'urn ') {
    this._procField('name', 'string', -1);
  }
  this._procField('location', 'string', -1);
};

// ISO/IEC 14496-30:2014 - WebVTT Source Label Box
ISOBox.prototype._boxProcessors['vlab'] = function() {
  this._procField('source_label', 'utf8');
};

// ISO/IEC 14496-12:2012 - 8.4.5.2 Video Media Header Box
ISOBox.prototype._boxProcessors['vmhd'] = function() {
  this._procFullBox();
  this._procField('graphicsmode', 'uint', 16);
  this._procFieldArray('opcolor', 3, 'uint', 16);
};

// ISO/IEC 14496-30:2014 - WebVTT Configuration Box
ISOBox.prototype._boxProcessors['vttC'] = function() {
  this._procField('config', 'utf8');
};

// ISO/IEC 14496-30:2014 - WebVTT Empty Sample Box
ISOBox.prototype._boxProcessors['vtte'] = function() {
  // Nothing should happen here.
};


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2015-2016, DASH Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  1. Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  2. Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


(function (exports) {

    "use strict";

    /**
     *  Exceptions from regular ASCII. CodePoints are mapped to UTF-16 codes
     */

    var specialCea608CharsCodes = {
        0x2a: 0xe1, // lowercase a, acute accent
        0x5c: 0xe9, // lowercase e, acute accent
        0x5e: 0xed, // lowercase i, acute accent
        0x5f: 0xf3, // lowercase o, acute accent
        0x60: 0xfa, // lowercase u, acute accent
        0x7b: 0xe7, // lowercase c with cedilla
        0x7c: 0xf7, // division symbol
        0x7d: 0xd1, // uppercase N tilde
        0x7e: 0xf1, // lowercase n tilde
        0x7f: 0x2588, // Full block
        // THIS BLOCK INCLUDES THE 16 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
        // THAT COME FROM HI BYTE=0x11 AND LOW BETWEEN 0x30 AND 0x3F
        // THIS MEANS THAT \x50 MUST BE ADDED TO THE VALUES
        0x80: 0xae, // Registered symbol (R)
        0x81: 0xb0, // degree sign
        0x82: 0xbd, // 1/2 symbol
        0x83: 0xbf, // Inverted (open) question mark
        0x84: 0x2122, // Trademark symbol (TM)
        0x85: 0xa2, // Cents symbol
        0x86: 0xa3, // Pounds sterling
        0x87: 0x266a, // Music 8'th note
        0x88: 0xe0, // lowercase a, grave accent
        0x89: 0x20, // transparent space (regular)
        0x8a: 0xe8, // lowercase e, grave accent
        0x8b: 0xe2, // lowercase a, circumflex accent
        0x8c: 0xea, // lowercase e, circumflex accent
        0x8d: 0xee, // lowercase i, circumflex accent
        0x8e: 0xf4, // lowercase o, circumflex accent
        0x8f: 0xfb, // lowercase u, circumflex accent
        // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
        // THAT COME FROM HI BYTE=0x12 AND LOW BETWEEN 0x20 AND 0x3F
        0x90: 0xc1, // capital letter A with acute
        0x91: 0xc9, // capital letter E with acute
        0x92: 0xd3, // capital letter O with acute
        0x93: 0xda, // capital letter U with acute
        0x94: 0xdc, // capital letter U with diaresis
        0x95: 0xfc, // lowercase letter U with diaeresis
        0x96: 0x2018, // opening single quote
        0x97: 0xa1, // inverted exclamation mark
        0x98: 0x2a, // asterisk
        0x99: 0x2019, // closing single quote
        0x9a: 0x2501, // box drawings heavy horizontal
        0x9b: 0xa9, // copyright sign
        0x9c: 0x2120, // Service mark
        0x9d: 0x2022, // (round) bullet
        0x9e: 0x201c, // Left double quotation mark
        0x9f: 0x201d, // Right double quotation mark
        0xa0: 0xc0, // uppercase A, grave accent
        0xa1: 0xc2, // uppercase A, circumflex
        0xa2: 0xc7, // uppercase C with cedilla
        0xa3: 0xc8, // uppercase E, grave accent
        0xa4: 0xca, // uppercase E, circumflex
        0xa5: 0xcb, // capital letter E with diaresis
        0xa6: 0xeb, // lowercase letter e with diaresis
        0xa7: 0xce, // uppercase I, circumflex
        0xa8: 0xcf, // uppercase I, with diaresis
        0xa9: 0xef, // lowercase i, with diaresis
        0xaa: 0xd4, // uppercase O, circumflex
        0xab: 0xd9, // uppercase U, grave accent
        0xac: 0xf9, // lowercase u, grave accent
        0xad: 0xdb, // uppercase U, circumflex
        0xae: 0xab, // left-pointing double angle quotation mark
        0xaf: 0xbb, // right-pointing double angle quotation mark
        // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
        // THAT COME FROM HI BYTE=0x13 AND LOW BETWEEN 0x20 AND 0x3F
        0xb0: 0xc3, // Uppercase A, tilde
        0xb1: 0xe3, // Lowercase a, tilde
        0xb2: 0xcd, // Uppercase I, acute accent
        0xb3: 0xcc, // Uppercase I, grave accent
        0xb4: 0xec, // Lowercase i, grave accent
        0xb5: 0xd2, // Uppercase O, grave accent
        0xb6: 0xf2, // Lowercase o, grave accent
        0xb7: 0xd5, // Uppercase O, tilde
        0xb8: 0xf5, // Lowercase o, tilde
        0xb9: 0x7b, // Open curly brace
        0xba: 0x7d, // Closing curly brace
        0xbb: 0x5c, // Backslash
        0xbc: 0x5e, // Caret
        0xbd: 0x5f, // Underscore
        0xbe: 0x7c, // Pipe (vertical line)
        0xbf: 0x223c, // Tilde operator
        0xc0: 0xc4, // Uppercase A, umlaut
        0xc1: 0xe4, // Lowercase A, umlaut
        0xc2: 0xd6, // Uppercase O, umlaut
        0xc3: 0xf6, // Lowercase o, umlaut
        0xc4: 0xdf, // Esszett (sharp S)
        0xc5: 0xa5, // Yen symbol
        0xc6: 0xa4, // Generic currency sign
        0xc7: 0x2503, // Box drawings heavy vertical
        0xc8: 0xc5, // Uppercase A, ring
        0xc9: 0xe5, // Lowercase A, ring
        0xca: 0xd8, // Uppercase O, stroke
        0xcb: 0xf8, // Lowercase o, strok
        0xcc: 0x250f, // Box drawings heavy down and right
        0xcd: 0x2513, // Box drawings heavy down and left
        0xce: 0x2517, // Box drawings heavy up and right
        0xcf: 0x251b // Box drawings heavy up and left
    };

    /**
     * Get Unicode Character from CEA-608 byte code
     */
    var getCharForByte = function getCharForByte(byte) {
        var charCode = byte;
        if (specialCea608CharsCodes.hasOwnProperty(byte)) {
            charCode = specialCea608CharsCodes[byte];
        }
        return String.fromCharCode(charCode);
    };

    var NR_ROWS = 15,
        NR_COLS = 32;
    // Tables to look up row from PAC data
    var rowsLowCh1 = { 0x11: 1, 0x12: 3, 0x15: 5, 0x16: 7, 0x17: 9, 0x10: 11, 0x13: 12, 0x14: 14 };
    var rowsHighCh1 = { 0x11: 2, 0x12: 4, 0x15: 6, 0x16: 8, 0x17: 10, 0x13: 13, 0x14: 15 };
    var rowsLowCh2 = { 0x19: 1, 0x1A: 3, 0x1D: 5, 0x1E: 7, 0x1F: 9, 0x18: 11, 0x1B: 12, 0x1C: 14 };
    var rowsHighCh2 = { 0x19: 2, 0x1A: 4, 0x1D: 6, 0x1E: 8, 0x1F: 10, 0x1B: 13, 0x1C: 15 };

    var backgroundColors = ['white', 'green', 'blue', 'cyan', 'red', 'yellow', 'magenta', 'black', 'transparent'];

    /**
     * Simple logger class to be able to write with time-stamps and filter on level.
     */
    var logger = {
        verboseFilter: { 'DATA': 3, 'DEBUG': 3, 'INFO': 2, 'WARNING': 2, 'TEXT': 1, 'ERROR': 0 },
        time: null,
        verboseLevel: 0, // Only write errors
        setTime: function setTime(newTime) {
            this.time = newTime;
        },
        log: function log(severity, msg) {
            var minLevel = this.verboseFilter[severity];
            if (this.verboseLevel >= minLevel) {
                console.log(this.time + " [" + severity + "] " + msg);
            }
        }
    };

    var numArrayToHexArray = function numArrayToHexArray(numArray) {
        var hexArray = [];
        for (var j = 0; j < numArray.length; j++) {
            hexArray.push(numArray[j].toString(16));
        }
        return hexArray;
    };

    /**
     * State of CEA-608 pen or character
     * @constructor
     */
    var PenState = function PenState(foreground, underline, italics, background, flash) {
        this.foreground = foreground || "white";
        this.underline = underline || false;
        this.italics = italics || false;
        this.background = background || "black";
        this.flash = flash || false;
    };

    PenState.prototype = {

        reset: function reset() {
            this.foreground = "white";
            this.underline = false;
            this.italics = false;
            this.background = "black";
            this.flash = false;
        },

        setStyles: function setStyles(styles) {
            var attribs = ["foreground", "underline", "italics", "background", "flash"];
            for (var i = 0; i < attribs.length; i++) {
                var style = attribs[i];
                if (styles.hasOwnProperty(style)) {
                    this[style] = styles[style];
                }
            }
        },

        isDefault: function isDefault() {
            return this.foreground === "white" && !this.underline && !this.italics && this.background === "black" && !this.flash;
        },

        equals: function equals(other) {
            return this.foreground === other.foreground && this.underline === other.underline && this.italics === other.italics && this.background === other.background && this.flash === other.flash;
        },

        copy: function copy(newPenState) {
            this.foreground = newPenState.foreground;
            this.underline = newPenState.underline;
            this.italics = newPenState.italics;
            this.background = newPenState.background;
            this.flash = newPenState.flash;
        },

        toString: function toString() {
            return "color=" + this.foreground + ", underline=" + this.underline + ", italics=" + this.italics + ", background=" + this.background + ", flash=" + this.flash;
        }
    };

    /**
     * Unicode character with styling and background.
     * @constructor
     */
    var StyledUnicodeChar = function StyledUnicodeChar(uchar, foreground, underline, italics, background, flash) {
        this.uchar = uchar || ' '; // unicode character
        this.penState = new PenState(foreground, underline, italics, background, flash);
    };

    StyledUnicodeChar.prototype = {

        reset: function reset() {
            this.uchar = ' ';
            this.penState.reset();
        },

        setChar: function setChar(uchar, newPenState) {
            this.uchar = uchar;
            this.penState.copy(newPenState);
        },

        setPenState: function setPenState(newPenState) {
            this.penState.copy(newPenState);
        },

        equals: function equals(other) {
            return this.uchar === other.uchar && this.penState.equals(other.penState);
        },

        copy: function copy(newChar) {
            this.uchar = newChar.uchar;
            this.penState.copy(newChar.penState);
        },

        isEmpty: function isEmpty() {
            return this.uchar === ' ' && this.penState.isDefault();
        }
    };

    /**
     * CEA-608 row consisting of NR_COLS instances of StyledUnicodeChar.
     * @constructor
     */
    var Row = function Row() {
        this.chars = [];
        for (var i = 0; i < NR_COLS; i++) {
            this.chars.push(new StyledUnicodeChar());
        }
        this.pos = 0;
        this.currPenState = new PenState();
    };

    Row.prototype = {

        equals: function equals(other) {
            var equal = true;
            for (var i = 0; i < NR_COLS; i++) {
                if (!this.chars[i].equals(other.chars[i])) {
                    equal = false;
                    break;
                }
            }
            return equal;
        },

        copy: function copy(other) {
            for (var i = 0; i < NR_COLS; i++) {
                this.chars[i].copy(other.chars[i]);
            }
        },

        isEmpty: function isEmpty() {
            var empty = true;
            for (var i = 0; i < NR_COLS; i++) {
                if (!this.chars[i].isEmpty()) {
                    empty = false;
                    break;
                }
            }
            return empty;
        },

        /**
         *  Set the cursor to a valid column.
         */
        setCursor: function setCursor(absPos) {
            if (this.pos !== absPos) {
                this.pos = absPos;
            }
            if (this.pos < 0) {
                logger.log("ERROR", "Negative cursor position " + this.pos);
                this.pos = 0;
            } else if (this.pos > NR_COLS) {
                logger.log("ERROR", "Too large cursor position " + this.pos);
                this.pos = NR_COLS;
            }
        },

        /** 
         * Move the cursor relative to current position.
         */
        moveCursor: function moveCursor(relPos) {
            var newPos = this.pos + relPos;
            if (relPos > 1) {
                for (var i = this.pos + 1; i < newPos + 1; i++) {
                    this.chars[i].setPenState(this.currPenState);
                }
            }
            this.setCursor(newPos);
        },

        /**
         * Backspace, move one step back and clear character.
         */
        backSpace: function backSpace() {
            this.moveCursor(-1);
            this.chars[this.pos].setChar(' ', this.currPenState);
        },

        insertChar: function insertChar(byte) {
            if (byte >= 0x90) {
                //Extended char
                this.backSpace();
            }
            var char = getCharForByte(byte);
            if (this.pos >= NR_COLS) {
                logger.log("ERROR", "Cannot insert " + byte.toString(16) + " (" + char + ") at position " + this.pos + ". Skipping it!");
                return;
            }
            this.chars[this.pos].setChar(char, this.currPenState);
            this.moveCursor(1);
        },

        clearFromPos: function clearFromPos(startPos) {
            var i;
            for (i = startPos; i < NR_COLS; i++) {
                this.chars[i].reset();
            }
        },

        clear: function clear() {
            this.clearFromPos(0);
            this.pos = 0;
            this.currPenState.reset();
        },

        clearToEndOfRow: function clearToEndOfRow() {
            this.clearFromPos(this.pos);
        },

        getTextString: function getTextString() {
            var chars = [];
            var empty = true;
            for (var i = 0; i < NR_COLS; i++) {
                var char = this.chars[i].uchar;
                if (char !== " ") {
                    empty = false;
                }
                chars.push(char);
            }
            if (empty) {
                return "";
            } else {
                return chars.join("");
            }
        },

        setPenStyles: function setPenStyles(styles) {
            this.currPenState.setStyles(styles);
            var currChar = this.chars[this.pos];
            currChar.setPenState(this.currPenState);
        }
    };

    /**
     * Keep a CEA-608 screen of 32x15 styled characters
     * @constructor
    */
    var CaptionScreen = function CaptionScreen() {

        this.rows = [];
        for (var i = 0; i < NR_ROWS; i++) {
            this.rows.push(new Row()); // Note that we use zero-based numbering (0-14)
        }
        this.currRow = NR_ROWS - 1;
        this.nrRollUpRows = null;
        this.reset();
    };

    CaptionScreen.prototype = {

        reset: function reset() {
            for (var i = 0; i < NR_ROWS; i++) {
                this.rows[i].clear();
            }
            this.currRow = NR_ROWS - 1;
        },

        equals: function equals(other) {
            var equal = true;
            for (var i = 0; i < NR_ROWS; i++) {
                if (!this.rows[i].equals(other.rows[i])) {
                    equal = false;
                    break;
                }
            }
            return equal;
        },

        copy: function copy(other) {
            for (var i = 0; i < NR_ROWS; i++) {
                this.rows[i].copy(other.rows[i]);
            }
        },

        isEmpty: function isEmpty() {
            var empty = true;
            for (var i = 0; i < NR_ROWS; i++) {
                if (!this.rows[i].isEmpty()) {
                    empty = false;
                    break;
                }
            }
            return empty;
        },

        backSpace: function backSpace() {
            var row = this.rows[this.currRow];
            row.backSpace();
        },

        clearToEndOfRow: function clearToEndOfRow() {
            var row = this.rows[this.currRow];
            row.clearToEndOfRow();
        },

        /**
         * Insert a character (without styling) in the current row.
         */
        insertChar: function insertChar(char) {
            var row = this.rows[this.currRow];
            row.insertChar(char);
        },

        setPen: function setPen(styles) {
            var row = this.rows[this.currRow];
            row.setPenStyles(styles);
        },

        moveCursor: function moveCursor(relPos) {
            var row = this.rows[this.currRow];
            row.moveCursor(relPos);
        },

        setCursor: function setCursor(absPos) {
            logger.log("INFO", "setCursor: " + absPos);
            var row = this.rows[this.currRow];
            row.setCursor(absPos);
        },

        setPAC: function setPAC(pacData) {
            logger.log("INFO", "pacData = " + JSON.stringify(pacData));
            var newRow = pacData.row - 1;
            if (this.nrRollUpRows && newRow < this.nrRollUpRows - 1) {
                newRow = this.nrRollUpRows - 1;
            }
            this.currRow = newRow;
            var row = this.rows[this.currRow];
            if (pacData.indent !== null) {
                var indent = pacData.indent;
                var prevPos = Math.max(indent - 1, 0);
                row.setCursor(pacData.indent);
                pacData.color = row.chars[prevPos].penState.foreground;
            }
            var styles = { foreground: pacData.color, underline: pacData.underline, italics: pacData.italics, background: 'black', flash: false };
            this.setPen(styles);
        },

        /**
         * Set background/extra foreground, but first do back_space, and then insert space (backwards compatibility).
         */
        setBkgData: function setBkgData(bkgData) {

            logger.log("INFO", "bkgData = " + JSON.stringify(bkgData));
            this.backSpace();
            this.setPen(bkgData);
            this.insertChar(0x20); //Space
        },

        setRollUpRows: function setRollUpRows(nrRows) {
            this.nrRollUpRows = nrRows;
        },

        rollUp: function rollUp() {
            if (this.nrRollUpRows === null) {
                logger.log("DEBUG", "roll_up but nrRollUpRows not set yet");
                return; //Not properly setup
            }
            logger.log("TEXT", this.getDisplayText());
            var topRowIndex = this.currRow + 1 - this.nrRollUpRows;
            var topRow = this.rows.splice(topRowIndex, 1)[0];
            topRow.clear();
            this.rows.splice(this.currRow, 0, topRow);
            logger.log("INFO", "Rolling up");
            //logger.log("TEXT", this.get_display_text())
        },

        /**
         * Get all non-empty rows with as unicode text. 
         */
        getDisplayText: function getDisplayText(asOneRow) {
            asOneRow = asOneRow || false;
            var displayText = [];
            var text = "";
            var rowNr = -1;
            for (var i = 0; i < NR_ROWS; i++) {
                var rowText = this.rows[i].getTextString();
                if (rowText) {
                    rowNr = i + 1;
                    if (asOneRow) {
                        displayText.push("Row " + rowNr + ': "' + rowText + '"');
                    } else {
                        displayText.push(rowText.trim());
                    }
                }
            }
            if (displayText.length > 0) {
                if (asOneRow) {
                    text = "[" + displayText.join(" | ") + "]";
                } else {
                    text = displayText.join("\n");
                }
            }
            return text;
        },

        getTextAndFormat: function getTextAndFormat() {
            return this.rows;
        }
    };

    /**
     * Handle a CEA-608 channel and send decoded data to outputFilter
     * @constructor
     * @param {Number} channelNumber (1 or 2)
     * @param {CueHandler} outputFilter Output from channel1 newCue(startTime, endTime, captionScreen)
    */
    var Cea608Channel = function Cea608Channel(channelNumber, outputFilter) {

        this.chNr = channelNumber;
        this.outputFilter = outputFilter;
        this.mode = null;
        this.verbose = 0;
        this.displayedMemory = new CaptionScreen();
        this.nonDisplayedMemory = new CaptionScreen();
        this.lastOutputScreen = new CaptionScreen();
        this.currRollUpRow = this.displayedMemory.rows[NR_ROWS - 1];
        this.writeScreen = this.displayedMemory;
        this.mode = null;
        this.cueStartTime = null; // Keeps track of where a cue started.
    };

    Cea608Channel.prototype = {

        modes: ["MODE_ROLL-UP", "MODE_POP-ON", "MODE_PAINT-ON", "MODE_TEXT"],

        reset: function reset() {
            this.mode = null;
            this.displayedMemory.reset();
            this.nonDisplayedMemory.reset();
            this.lastOutputScreen.reset();
            this.currRollUpRow = this.displayedMemory.rows[NR_ROWS - 1];
            this.writeScreen = this.displayedMemory;
            this.mode = null;
            this.cueStartTime = null;
            this.lastCueEndTime = null;
        },

        getHandler: function getHandler() {
            return this.outputFilter;
        },

        setHandler: function setHandler(newHandler) {
            this.outputFilter = newHandler;
        },

        setPAC: function setPAC(pacData) {
            this.writeScreen.setPAC(pacData);
        },

        setBkgData: function setBkgData(bkgData) {
            this.writeScreen.setBkgData(bkgData);
        },

        setMode: function setMode(newMode) {
            if (newMode === this.mode) {
                return;
            }
            this.mode = newMode;
            logger.log("INFO", "MODE=" + newMode);
            if (this.mode == "MODE_POP-ON") {
                this.writeScreen = this.nonDisplayedMemory;
            } else {
                this.writeScreen = this.displayedMemory;
                this.writeScreen.reset();
            }
            if (this.mode !== "MODE_ROLL-UP") {
                this.displayedMemory.nrRollUpRows = null;
                this.nonDisplayedMemory.nrRollUpRows = null;
            }
            this.mode = newMode;
        },

        insertChars: function insertChars(chars) {
            for (var i = 0; i < chars.length; i++) {
                this.writeScreen.insertChar(chars[i]);
            }
            var screen = this.writeScreen === this.displayedMemory ? "DISP" : "NON_DISP";
            logger.log("INFO", screen + ": " + this.writeScreen.getDisplayText(true));
            if (this.mode === "MODE_PAINT-ON" || this.mode === "MODE_ROLL-UP") {
                logger.log("TEXT", "DISPLAYED: " + this.displayedMemory.getDisplayText(true));
                this.outputDataUpdate();
            }
        },

        cc_RCL: function cc_RCL() {
            // Resume Caption Loading (switch mode to Pop On)
            logger.log("INFO", "RCL - Resume Caption Loading");
            this.setMode("MODE_POP-ON");
        },
        cc_BS: function cc_BS() {
            // BackSpace
            logger.log("INFO", "BS - BackSpace");
            if (this.mode === "MODE_TEXT") {
                return;
            }
            this.writeScreen.backSpace();
            if (this.writeScreen === this.displayedMemory) {
                this.outputDataUpdate();
            }
        },
        cc_AOF: function cc_AOF() {
            // Reserved (formerly Alarm Off)
            return;
        },
        cc_AON: function cc_AON() {
            // Reserved (formerly Alarm On)
            return;
        },
        cc_DER: function cc_DER() {
            // Delete to End of Row
            logger.log("INFO", "DER- Delete to End of Row");
            this.writeScreen.clearToEndOfRow();
            this.outputDataUpdate();
        },
        cc_RU: function cc_RU(nrRows) {
            //Roll-Up Captions-2,3,or 4 Rows
            logger.log("INFO", "RU(" + nrRows + ") - Roll Up");
            this.writeScreen = this.displayedMemory;
            this.setMode("MODE_ROLL-UP");
            this.writeScreen.setRollUpRows(nrRows);
        },
        cc_FON: function cc_FON() {
            //Flash On
            logger.log("INFO", "FON - Flash On");
            this.writeScreen.setPen({ flash: true });
        },
        cc_RDC: function cc_RDC() {
            // Resume Direct Captioning (switch mode to PaintOn)
            logger.log("INFO", "RDC - Resume Direct Captioning");
            this.setMode("MODE_PAINT-ON");
        },
        cc_TR: function cc_TR() {
            // Text Restart in text mode (not supported, however)
            logger.log("INFO", "TR");
            this.setMode("MODE_TEXT");
        },
        cc_RTD: function cc_RTD() {
            // Resume Text Display in Text mode (not supported, however)
            logger.log("INFO", "RTD");
            this.setMode("MODE_TEXT");
        },
        cc_EDM: function cc_EDM() {
            // Erase Displayed Memory
            logger.log("INFO", "EDM - Erase Displayed Memory");
            this.displayedMemory.reset();
            this.outputDataUpdate();
        },
        cc_CR: function cc_CR() {
            // Carriage Return
            logger.log("CR - Carriage Return");
            this.writeScreen.rollUp();
            this.outputDataUpdate();
        },
        cc_ENM: function cc_ENM() {
            //Erase Non-Displayed Memory
            logger.log("INFO", "ENM - Erase Non-displayed Memory");
            this.nonDisplayedMemory.reset();
        },
        cc_EOC: function cc_EOC() {
            //End of Caption (Flip Memories)
            logger.log("INFO", "EOC - End Of Caption");
            if (this.mode === "MODE_POP-ON") {
                var tmp = this.displayedMemory;
                this.displayedMemory = this.nonDisplayedMemory;
                this.nonDisplayedMemory = tmp;
                this.writeScreen = this.nonDisplayedMemory;
                logger.log("TEXT", "DISP: " + this.displayedMemory.getDisplayText());
            }
            this.outputDataUpdate();
        },
        cc_TO: function cc_TO(nrCols) {
            // Tab Offset 1,2, or 3 columns
            logger.log("INFO", "TO(" + nrCols + ") - Tab Offset");
            this.writeScreen.moveCursor(nrCols);
        },
        cc_MIDROW: function cc_MIDROW(secondByte) {
            // Parse MIDROW command
            var styles = { flash: false };
            styles.underline = secondByte % 2 === 1;
            styles.italics = secondByte >= 0x2e;
            if (!styles.italics) {
                var colorIndex = Math.floor(secondByte / 2) - 0x10;
                var colors = ["white", "green", "blue", "cyan", "red", "yellow", "magenta"];
                styles.foreground = colors[colorIndex];
            } else {
                styles.foreground = "white";
            }
            logger.log("INFO", "MIDROW: " + JSON.stringify(styles));
            this.writeScreen.setPen(styles);
        },

        outputDataUpdate: function outputDataUpdate() {
            var t = logger.time;
            if (t === null) {
                return;
            }
            if (this.outputFilter) {
                if (this.outputFilter.updateData) {
                    this.outputFilter.updateData(t, this.displayedMemory);
                }
                if (this.cueStartTime === null && !this.displayedMemory.isEmpty()) {
                    // Start of a new cue
                    this.cueStartTime = t;
                } else {
                    if (!this.displayedMemory.equals(this.lastOutputScreen)) {
                        if (this.outputFilter.newCue) {
                            this.outputFilter.newCue(this.cueStartTime, t, this.lastOutputScreen);
                        }
                        this.cueStartTime = this.displayedMemory.isEmpty() ? null : t;
                    }
                }
                this.lastOutputScreen.copy(this.displayedMemory);
            }
        },

        cueSplitAtTime: function cueSplitAtTime(t) {
            if (this.outputFilter) {
                if (!this.displayedMemory.isEmpty()) {
                    if (this.outputFilter.newCue) {
                        this.outputFilter.newCue(this.cueStartTime, t, this.displayedMemory);
                    }
                    this.cueStartTime = t;
                }
            }
        }
    };

    /**
     * Parse CEA-608 data and send decoded data to out1 and out2.
     * @constructor
     * @param {Number} field  CEA-608 field (1 or 2)
     * @param {CueHandler} out1 Output from channel1 newCue(startTime, endTime, captionScreen)
     * @param {CueHandler} out2 Output from channel2 newCue(startTime, endTime, captionScreen)
     */
    var Cea608Parser = function Cea608Parser(field, out1, out2) {
        this.field = field || 1;
        this.outputs = [out1, out2];
        this.channels = [new Cea608Channel(1, out1), new Cea608Channel(2, out2)];
        this.currChNr = -1; // Will be 1 or 2
        this.lastCmdA = null; // First byte of last command
        this.lastCmdB = null; // Second byte of last command
        this.bufferedData = [];
        this.startTime = null;
        this.lastTime = null;
        this.dataCounters = { 'padding': 0, 'char': 0, 'cmd': 0, 'other': 0 };
    };

    Cea608Parser.prototype = {

        getHandler: function getHandler(index) {
            return this.channels[index].getHandler();
        },

        setHandler: function setHandler(index, newHandler) {
            this.channels[index].setHandler(newHandler);
        },

        /**
         * Add data for time t in forms of list of bytes (unsigned ints). The bytes are treated as pairs.
         */
        addData: function addData(t, byteList) {
            var cmdFound,
                a,
                b,
                charsFound = false;

            this.lastTime = t;
            logger.setTime(t);

            for (var i = 0; i < byteList.length; i += 2) {
                a = byteList[i] & 0x7f;
                b = byteList[i + 1] & 0x7f;
                if (a === 0 && b === 0) {
                    this.dataCounters.padding += 2;
                    continue;
                } else {
                    logger.log("DATA", "[" + numArrayToHexArray([byteList[i], byteList[i + 1]]) + "] -> (" + numArrayToHexArray([a, b]) + ")");
                }
                cmdFound = this.parseCmd(a, b);
                if (!cmdFound) {
                    cmdFound = this.parseMidrow(a, b);
                }
                if (!cmdFound) {
                    cmdFound = this.parsePAC(a, b);
                }
                if (!cmdFound) {
                    cmdFound = this.parseBackgroundAttributes(a, b);
                }
                if (!cmdFound) {
                    charsFound = this.parseChars(a, b);
                    if (charsFound) {
                        if (this.currChNr && this.currChNr >= 0) {
                            var channel = this.channels[this.currChNr - 1];
                            channel.insertChars(charsFound);
                        } else {
                            logger.log("WARNING", "No channel found yet. TEXT-MODE?");
                        }
                    }
                }
                if (cmdFound) {
                    this.dataCounters.cmd += 2;
                } else if (charsFound) {
                    this.dataCounters.char += 2;
                } else {
                    this.dataCounters.other += 2;
                    logger.log("WARNING", "Couldn't parse cleaned data " + numArrayToHexArray([a, b]) + " orig: " + numArrayToHexArray([byteList[i], byteList[i + 1]]));
                }
            }
        },

        /**
         * Parse Command.
         * @returns {Boolean} Tells if a command was found
         */
        parseCmd: function parseCmd(a, b) {
            var chNr = null;

            var cond1 = (a === 0x14 || a === 0x1C) && 0x20 <= b && b <= 0x2F;
            var cond2 = (a === 0x17 || a === 0x1F) && 0x21 <= b && b <= 0x23;
            if (!(cond1 || cond2)) {
                return false;
            }

            if (a === this.lastCmdA && b === this.lastCmdB) {
                this.lastCmdA = null;
                this.lastCmdB = null; // Repeated commands are dropped (once)
                logger.log("DEBUG", "Repeated command (" + numArrayToHexArray([a, b]) + ") is dropped");
                return true;
            }

            if (a === 0x14 || a === 0x17) {
                chNr = 1;
            } else {
                chNr = 2; // (a === 0x1C || a=== 0x1f)
            }

            var channel = this.channels[chNr - 1];

            if (a === 0x14 || a === 0x1C) {
                if (b === 0x20) {
                    channel.cc_RCL();
                } else if (b === 0x21) {
                    channel.cc_BS();
                } else if (b === 0x22) {
                    channel.cc_AOF();
                } else if (b === 0x23) {
                    channel.cc_AON();
                } else if (b === 0x24) {
                    channel.cc_DER();
                } else if (b === 0x25) {
                    channel.cc_RU(2);
                } else if (b === 0x26) {
                    channel.cc_RU(3);
                } else if (b === 0x27) {
                    channel.cc_RU(4);
                } else if (b === 0x28) {
                    channel.cc_FON();
                } else if (b === 0x29) {
                    channel.cc_RDC();
                } else if (b === 0x2A) {
                    channel.cc_TR();
                } else if (b === 0x2B) {
                    channel.cc_RTD();
                } else if (b === 0x2C) {
                    channel.cc_EDM();
                } else if (b === 0x2D) {
                    channel.cc_CR();
                } else if (b === 0x2E) {
                    channel.cc_ENM();
                } else if (b === 0x2F) {
                    channel.cc_EOC();
                }
            } else {
                //a == 0x17 || a == 0x1F
                channel.cc_TO(b - 0x20);
            }
            this.lastCmdA = a;
            this.lastCmdB = b;
            this.currChNr = chNr;
            return true;
        },

        /**
         * Parse midrow styling command
         * @returns {Boolean}
         */
        parseMidrow: function parseMidrow(a, b) {
            var chNr = null;

            if ((a === 0x11 || a === 0x19) && 0x20 <= b && b <= 0x2f) {
                if (a === 0x11) {
                    chNr = 1;
                } else {
                    chNr = 2;
                }
                if (chNr !== this.currChNr) {
                    logger.log("ERROR", "Mismatch channel in midrow parsing");
                    return false;
                }
                var channel = this.channels[chNr - 1];
                channel.cc_MIDROW(b);
                logger.log("DEBUG", "MIDROW (" + numArrayToHexArray([a, b]) + ")");
                return true;
            }
            return false;
        },
        /**
         * Parse Preable Access Codes (Table 53).
         * @returns {Boolean} Tells if PAC found
         */
        parsePAC: function parsePAC(a, b) {

            var chNr = null;
            var row = null;

            var case1 = (0x11 <= a && a <= 0x17 || 0x19 <= a && a <= 0x1F) && 0x40 <= b && b <= 0x7F;
            var case2 = (a === 0x10 || a === 0x18) && 0x40 <= b && b <= 0x5F;
            if (!(case1 || case2)) {
                return false;
            }

            if (a === this.lastCmdA && b === this.lastCmdB) {
                this.lastCmdA = null;
                this.lastCmdB = null;
                return true; // Repeated commands are dropped (once)
            }

            chNr = a <= 0x17 ? 1 : 2;

            if (0x40 <= b && b <= 0x5F) {
                row = chNr === 1 ? rowsLowCh1[a] : rowsLowCh2[a];
            } else {
                // 0x60 <= b <= 0x7F
                row = chNr === 1 ? rowsHighCh1[a] : rowsHighCh2[a];
            }
            var pacData = this.interpretPAC(row, b);
            var channel = this.channels[chNr - 1];
            channel.setPAC(pacData);
            this.lastCmdA = a;
            this.lastCmdB = b;
            this.currChNr = chNr;
            return true;
        },

        /**
         * Interpret the second byte of the pac, and return the information.
         * @returns {Object} pacData with style parameters.
         */
        interpretPAC: function interpretPAC(row, byte) {
            var pacIndex = byte;
            var pacData = { color: null, italics: false, indent: null, underline: false, row: row };

            if (byte > 0x5F) {
                pacIndex = byte - 0x60;
            } else {
                pacIndex = byte - 0x40;
            }
            pacData.underline = (pacIndex & 1) === 1;
            if (pacIndex <= 0xd) {
                pacData.color = ['white', 'green', 'blue', 'cyan', 'red', 'yellow', 'magenta', 'white'][Math.floor(pacIndex / 2)];
            } else if (pacIndex <= 0xf) {
                pacData.italics = true;
                pacData.color = 'white';
            } else {
                pacData.indent = Math.floor((pacIndex - 0x10) / 2) * 4;
            }
            return pacData; // Note that row has zero offset. The spec uses 1.
        },

        /**
         * Parse characters.
         * @returns An array with 1 to 2 codes corresponding to chars, if found. null otherwise.
         */
        parseChars: function parseChars(a, b) {

            var channelNr = null,
                charCodes = null,
                charCode1 = null,
                charCode2 = null;

            if (a >= 0x19) {
                channelNr = 2;
                charCode1 = a - 8;
            } else {
                channelNr = 1;
                charCode1 = a;
            }
            if (0x11 <= charCode1 && charCode1 <= 0x13) {
                // Special character
                var oneCode = b;
                if (charCode1 === 0x11) {
                    oneCode = b + 0x50;
                } else if (charCode1 === 0x12) {
                    oneCode = b + 0x70;
                } else {
                    oneCode = b + 0x90;
                }
                logger.log("INFO", "Special char '" + getCharForByte(oneCode) + "' in channel " + channelNr);
                charCodes = [oneCode];
            } else if (0x20 <= a && a <= 0x7f) {
                charCodes = b === 0 ? [a] : [a, b];
            }
            if (charCodes) {
                var hexCodes = numArrayToHexArray(charCodes);
                logger.log("DEBUG", "Char codes =  " + hexCodes.join(","));
                this.lastCmdA = null;
                this.lastCmdB = null;
            }
            return charCodes;
        },

        /**
        * Parse extended background attributes as well as new foreground color black.
        * @returns{Boolean} Tells if background attributes are found
        */
        parseBackgroundAttributes: function parseBackgroundAttributes(a, b) {
            var bkgData, index, chNr, channel;

            var case1 = (a === 0x10 || a === 0x18) && 0x20 <= b && b <= 0x2f;
            var case2 = (a === 0x17 || a === 0x1f) && 0x2d <= b && b <= 0x2f;
            if (!(case1 || case2)) {
                return false;
            }
            bkgData = {};
            if (a === 0x10 || a === 0x18) {
                index = Math.floor((b - 0x20) / 2);
                bkgData.background = backgroundColors[index];
                if (b % 2 === 1) {
                    bkgData.background = bkgData.background + "_semi";
                }
            } else if (b === 0x2d) {
                bkgData.background = "transparent";
            } else {
                bkgData.foreground = "black";
                if (b === 0x2f) {
                    bkgData.underline = true;
                }
            }
            chNr = a < 0x18 ? 1 : 2;
            channel = this.channels[chNr - 1];
            channel.setBkgData(bkgData);
            this.lastCmdA = null;
            this.lastCmdB = null;
            return true;
        },

        /**
         * Reset state of parser and its channels.
         */
        reset: function reset() {
            for (var i = 0; i < this.channels.length; i++) {
                if (this.channels[i]) {
                    this.channels[i].reset();
                }
            }
            this.lastCmdA = null;
            this.lastCmdB = null;
        },

        /**
         * Trigger the generation of a cue, and the start of a new one if displayScreens are not empty.
         */
        cueSplitAtTime: function cueSplitAtTime(t) {
            for (var i = 0; i < this.channels.length; i++) {
                if (this.channels[i]) {
                    this.channels[i].cueSplitAtTime(t);
                }
            }
        }
    };

    /**
     * Find ranges corresponding to SEA CEA-608 NALUS in sizeprepended NALU array.
     * @param {raw} dataView of binary data
     * @param {startPos} start position in raw
     * @param {size} total size of data in raw to consider
     * @returns 
     */
    var findCea608Nalus = function findCea608Nalus(raw, startPos, size) {
        var nalSize = 0,
            cursor = startPos,
            nalType = 0,
            cea608NaluRanges = [],

        // Check SEI data according to ANSI-SCTE 128
        isCEA608SEI = function isCEA608SEI(payloadType, payloadSize, raw, pos) {
            if (payloadType !== 4 || payloadSize < 8) {
                return null;
            }
            var countryCode = raw.getUint8(pos);
            var providerCode = raw.getUint16(pos + 1);
            var userIdentifier = raw.getUint32(pos + 3);
            var userDataTypeCode = raw.getUint8(pos + 7);
            return countryCode == 0xB5 && providerCode == 0x31 && userIdentifier == 0x47413934 && userDataTypeCode == 0x3;
        };
        while (cursor < startPos + size) {
            nalSize = raw.getUint32(cursor);
            nalType = raw.getUint8(cursor + 4) & 0x1F;
            //console.log(time + "  NAL " + nalType);
            if (nalType === 6) {
                // SEI NAL Unit. The NAL header is the first byte
                //console.log("SEI NALU of size " + nalSize + " at time " + time);
                var pos = cursor + 5;
                var payloadType = -1;
                while (pos < cursor + 4 + nalSize - 1) {
                    // The last byte should be rbsp_trailing_bits
                    payloadType = 0;
                    var b = 0xFF;
                    while (b === 0xFF) {
                        b = raw.getUint8(pos);
                        payloadType += b;
                        pos++;
                    }
                    var payloadSize = 0;
                    b = 0xFF;
                    while (b === 0xFF) {
                        b = raw.getUint8(pos);
                        payloadSize += b;
                        pos++;
                    }
                    if (isCEA608SEI(payloadType, payloadSize, raw, pos)) {
                        //console.log("CEA608 SEI " + time + " " + payloadSize);
                        cea608NaluRanges.push([pos, payloadSize]);
                    }
                    pos += payloadSize;
                }
            }
            cursor += nalSize + 4;
        }
        return cea608NaluRanges;
    };

    var extractCea608DataFromRange = function extractCea608DataFromRange(raw, cea608Range) {
        var pos = cea608Range[0];
        var fieldData = [[], []];

        pos += 8; // Skip the identifier up to userDataTypeCode
        var ccCount = raw.getUint8(pos) & 0x1f;
        pos += 2; // Advance 1 and skip reserved byte

        for (var i = 0; i < ccCount; i++) {
            var byte = raw.getUint8(pos);
            var ccValid = byte & 0x4;
            var ccType = byte & 0x3;
            pos++;
            var ccData1 = raw.getUint8(pos); // Keep parity bit
            pos++;
            var ccData2 = raw.getUint8(pos); // Keep parity bit
            pos++;
            if (ccValid && (ccData1 & 0x7f) + (ccData2 & 0x7f) !== 0) {
                //Check validity and non-empty data
                if (ccType === 0) {
                    fieldData[0].push(ccData1);
                    fieldData[0].push(ccData2);
                } else if (ccType === 1) {
                    fieldData[1].push(ccData1);
                    fieldData[1].push(ccData2);
                }
            }
        }
        return fieldData;
    };

    exports.logger = logger;
    exports.PenState = PenState;
    exports.CaptionScreen = CaptionScreen;
    exports.Cea608Parser = Cea608Parser;
    exports.findCea608Nalus = findCea608Nalus;
    exports.extractCea608DataFromRange = extractCea608DataFromRange;
})( false ? undefined.cea608parser = {} : exports);
//# sourceMappingURL=cea608-parser.js.map


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
    value: true
});
exports.getVersionString = getVersionString;
var VERSION = '2.5.0';

function getVersionString() {
    return VERSION;
}
//# sourceMappingURL=Version.js.map


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



Object.defineProperty(exports, '__esModule', {
  value: true
});
var TCP_CONNECTION = 'TcpList';
exports.TCP_CONNECTION = TCP_CONNECTION;
var HTTP_REQUEST = 'HttpList';
exports.HTTP_REQUEST = HTTP_REQUEST;
var TRACK_SWITCH = 'RepSwitchList';
exports.TRACK_SWITCH = TRACK_SWITCH;
var BUFFER_LEVEL = 'BufferLevel';
exports.BUFFER_LEVEL = BUFFER_LEVEL;
var BUFFER_STATE = 'BufferState';
exports.BUFFER_STATE = BUFFER_STATE;
var DVR_INFO = 'DVRInfo';
exports.DVR_INFO = DVR_INFO;
var DROPPED_FRAMES = 'DroppedFrames';
exports.DROPPED_FRAMES = DROPPED_FRAMES;
var SCHEDULING_INFO = 'SchedulingInfo';
exports.SCHEDULING_INFO = SCHEDULING_INFO;
var REQUESTS_QUEUE = 'RequestsQueue';
exports.REQUESTS_QUEUE = REQUESTS_QUEUE;
var MANIFEST_UPDATE = 'ManifestUpdate';
exports.MANIFEST_UPDATE = MANIFEST_UPDATE;
var MANIFEST_UPDATE_STREAM_INFO = 'ManifestUpdatePeriodInfo';
exports.MANIFEST_UPDATE_STREAM_INFO = MANIFEST_UPDATE_STREAM_INFO;
var MANIFEST_UPDATE_TRACK_INFO = 'ManifestUpdateRepresentationInfo';
exports.MANIFEST_UPDATE_TRACK_INFO = MANIFEST_UPDATE_TRACK_INFO;
var PLAY_LIST = 'PlayList';
exports.PLAY_LIST = PLAY_LIST;
var DVB_ERRORS = 'DVBErrors';
exports.DVB_ERRORS = DVB_ERRORS;
//# sourceMappingURL=DashMetricsList.js.map


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @classdesc a node at some level in a ValueMap
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _CommonProperty = __webpack_require__(1328);

var _CommonProperty2 = _interopRequireDefault(_CommonProperty);

var MapNode = (function () {
    function MapNode(name, properties, children, isRoot, isArray) {
        var _this = this;

        _classCallCheck(this, MapNode);

        this._name = name || '';
        this._properties = [];
        this._children = children || [];
        this._isRoot = isRoot || false;
        this._isArray = isArray || true;

        if (Array.isArray(properties)) {
            properties.forEach(function (p) {
                _this._properties.push(new _CommonProperty2['default'](p));
            });
        }
    }

    _createClass(MapNode, [{
        key: 'name',
        get: function get() {
            return this._name;
        }
    }, {
        key: 'isRoot',
        get: function get() {
            return this._isRoot;
        }
    }, {
        key: 'isArray',
        get: function get() {
            return this._isArray;
        }
    }, {
        key: 'children',
        get: function get() {
            return this._children;
        }
    }, {
        key: 'properties',
        get: function get() {
            return this._properties;
        }
    }]);

    return MapNode;
})();

exports['default'] = MapNode;
module.exports = exports['default'];
//# sourceMappingURL=MapNode.js.map


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @class
 * @ignore
 */



Object.defineProperty(exports, '__esModule', {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var DEFAULT_DVB_PRIORITY = 1;
var DEFAULT_DVB_WEIGHT = 1;

var BaseURL = function BaseURL(url, serviceLocation, priority, weight) {
  _classCallCheck(this, BaseURL);

  this.url = url || '';
  this.serviceLocation = serviceLocation || url || '';

  // DVB extensions
  this.dvb_priority = priority || DEFAULT_DVB_PRIORITY;
  this.dvb_weight = weight || DEFAULT_DVB_WEIGHT;

  /* currently unused:
   * byteRange,
   * availabilityTimeOffset,
   * availabilityTimeComplete
   */
};

BaseURL.DEFAULT_DVB_PRIORITY = DEFAULT_DVB_PRIORITY;
BaseURL.DEFAULT_DVB_WEIGHT = DEFAULT_DVB_WEIGHT;

exports['default'] = BaseURL;
module.exports = exports['default'];
//# sourceMappingURL=BaseURL.js.map


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @class
 * @ignore
 */


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var Event = function Event() {
  _classCallCheck(this, Event);

  this.duration = NaN;
  this.presentationTime = NaN;
  this.id = NaN;
  this.messageData = '';
  this.eventStream = null;
  this.presentationTimeDelta = NaN; // Specific EMSG Box parameter
};

exports['default'] = Event;
module.exports = exports['default'];
//# sourceMappingURL=Event.js.map


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @class
 * @ignore
 */


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var UTCTiming = function UTCTiming() {
  _classCallCheck(this, UTCTiming);

  // UTCTiming is a DescriptorType and doesn't have any additional fields
  this.schemeIdUri = '';
  this.value = '';
};

exports['default'] = UTCTiming;
module.exports = exports['default'];
//# sourceMappingURL=UTCTiming.js.map


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _dashVoUTCTiming = __webpack_require__(589);

var _dashVoUTCTiming2 = _interopRequireDefault(_dashVoUTCTiming);

var _controllersPlaybackController = __webpack_require__(161);

var _controllersPlaybackController2 = _interopRequireDefault(_controllersPlaybackController);

var _controllersStreamController = __webpack_require__(398);

var _controllersStreamController2 = _interopRequireDefault(_controllersStreamController);

var _controllersMediaController = __webpack_require__(188);

var _controllersMediaController2 = _interopRequireDefault(_controllersMediaController);

var _ManifestLoader = __webpack_require__(1345);

var _ManifestLoader2 = _interopRequireDefault(_ManifestLoader);

var _utilsLiveEdgeFinder = __webpack_require__(409);

var _utilsLiveEdgeFinder2 = _interopRequireDefault(_utilsLiveEdgeFinder);

var _utilsErrorHandler = __webpack_require__(136);

var _utilsErrorHandler2 = _interopRequireDefault(_utilsErrorHandler);

var _utilsCapabilities = __webpack_require__(1409);

var _utilsCapabilities2 = _interopRequireDefault(_utilsCapabilities);

var _textTextTracks = __webpack_require__(405);

var _textTextTracks2 = _interopRequireDefault(_textTextTracks);

var _controllersSourceBufferController = __webpack_require__(322);

var _controllersSourceBufferController2 = _interopRequireDefault(_controllersSourceBufferController);

var _utilsRequestModifier = __webpack_require__(327);

var _utilsRequestModifier2 = _interopRequireDefault(_utilsRequestModifier);

var _textTextController = __webpack_require__(189);

var _textTextController2 = _interopRequireDefault(_textTextController);

var _modelsURIQueryAndFragmentModel = __webpack_require__(399);

var _modelsURIQueryAndFragmentModel2 = _interopRequireDefault(_modelsURIQueryAndFragmentModel);

var _modelsManifestModel = __webpack_require__(325);

var _modelsManifestModel2 = _interopRequireDefault(_modelsManifestModel);

var _modelsMediaPlayerModel = __webpack_require__(67);

var _modelsMediaPlayerModel2 = _interopRequireDefault(_modelsMediaPlayerModel);

var _modelsMetricsModel = __webpack_require__(135);

var _modelsMetricsModel2 = _interopRequireDefault(_modelsMetricsModel);

var _controllersAbrController = __webpack_require__(159);

var _controllersAbrController2 = _interopRequireDefault(_controllersAbrController);

var _controllersTimeSyncController = __webpack_require__(1357);

var _controllersTimeSyncController2 = _interopRequireDefault(_controllersTimeSyncController);

var _rulesAbrABRRulesCollection = __webpack_require__(1395);

var _rulesAbrABRRulesCollection2 = _interopRequireDefault(_rulesAbrABRRulesCollection);

var _modelsVideoModel = __webpack_require__(240);

var _modelsVideoModel2 = _interopRequireDefault(_modelsVideoModel);

var _controllersMediaSourceController = __webpack_require__(1355);

var _controllersMediaSourceController2 = _interopRequireDefault(_controllersMediaSourceController);

var _controllersBaseURLController = __webpack_require__(1351);

var _controllersBaseURLController2 = _interopRequireDefault(_controllersBaseURLController);

var _coreDebug = __webpack_require__(30);

var _coreDebug2 = _interopRequireDefault(_coreDebug);

var _coreEventBus = __webpack_require__(27);

var _coreEventBus2 = _interopRequireDefault(_coreEventBus);

var _coreEventsEvents = __webpack_require__(22);

var _coreEventsEvents2 = _interopRequireDefault(_coreEventsEvents);

var _MediaPlayerEvents = __webpack_require__(238);

var _MediaPlayerEvents2 = _interopRequireDefault(_MediaPlayerEvents);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _coreVersion = __webpack_require__(584);

//Dash

var _dashDashAdapter = __webpack_require__(394);

var _dashDashAdapter2 = _interopRequireDefault(_dashDashAdapter);

var _dashModelsDashManifestModel = __webpack_require__(158);

var _dashModelsDashManifestModel2 = _interopRequireDefault(_dashModelsDashManifestModel);

var _dashDashMetrics = __webpack_require__(157);

var _dashDashMetrics2 = _interopRequireDefault(_dashDashMetrics);

var _dashUtilsTimelineConverter = __webpack_require__(395);

var _dashUtilsTimelineConverter2 = _interopRequireDefault(_dashUtilsTimelineConverter);

/**
 * @module MediaPlayer
 * @description The MediaPlayer is the primary dash.js Module and a Facade to build your player around.
 * It will allow you access to all the important dash.js properties/methods via the public API and all the
 * events to build a robust DASH media player.
 */
function MediaPlayer() {

    var PLAYBACK_NOT_INITIALIZED_ERROR = 'You must first call play() to init playback before calling this method';
    var ELEMENT_NOT_ATTACHED_ERROR = 'You must first call attachView() to set the video element before calling this method';
    var SOURCE_NOT_ATTACHED_ERROR = 'You must first call attachSource() with a valid source before calling this method';
    var MEDIA_PLAYER_NOT_INITIALIZED_ERROR = 'MediaPlayer not initialized!';

    var context = this.context;
    var eventBus = (0, _coreEventBus2['default'])(context).getInstance();
    var debug = (0, _coreDebug2['default'])(context).getInstance();
    var log = debug.log;

    var instance = undefined,
        source = undefined,
        protectionData = undefined,
        mediaPlayerInitialized = undefined,
        playbackInitialized = undefined,
        autoPlay = undefined,
        abrController = undefined,
        mediaController = undefined,
        protectionController = undefined,
        metricsReportingController = undefined,
        mssHandler = undefined,
        adapter = undefined,
        metricsModel = undefined,
        mediaPlayerModel = undefined,
        errHandler = undefined,
        capabilities = undefined,
        streamController = undefined,
        playbackController = undefined,
        dashMetrics = undefined,
        dashManifestModel = undefined,
        videoModel = undefined,
        textController = undefined;

    function setup() {
        mediaPlayerInitialized = false;
        playbackInitialized = false;
        autoPlay = true;
        protectionController = null;
        protectionData = null;
        adapter = null;
        _coreEventsEvents2['default'].extend(_MediaPlayerEvents2['default']);
        mediaPlayerModel = (0, _modelsMediaPlayerModel2['default'])(context).getInstance();
    }

    /**
     * Upon creating the MediaPlayer you must call initialize before you call anything else.
     * There is one exception to this rule. It is crucial to call {@link module:MediaPlayer#extend extend()}
     * with all your extensions prior to calling initialize.
     *
     * ALL arguments are optional and there are individual methods to set each argument later on.
     * The args in this method are just for convenience and should only be used for a simple player setup.
     *
     * @param {HTML5MediaElement=} view - Optional arg to set the video element. {@link module:MediaPlayer#attachView attachView()}
     * @param {string=} source - Optional arg to set the media source. {@link module:MediaPlayer#attachSource attachSource()}
     * @param {boolean=} AutoPlay - Optional arg to set auto play. {@link module:MediaPlayer#setAutoPlay setAutoPlay()}
     * @see {@link module:MediaPlayer#attachView attachView()}
     * @see {@link module:MediaPlayer#attachSource attachSource()}
     * @see {@link module:MediaPlayer#setAutoPlay setAutoPlay()}
     * @memberof module:MediaPlayer
     * @instance
     */
    function initialize(view, source, AutoPlay) {

        capabilities = (0, _utilsCapabilities2['default'])(context).getInstance();
        errHandler = (0, _utilsErrorHandler2['default'])(context).getInstance();

        if (!capabilities.supportsMediaSource()) {
            errHandler.capabilityError('mediasource');
            return;
        }

        if (mediaPlayerInitialized) return;
        mediaPlayerInitialized = true;

        abrController = (0, _controllersAbrController2['default'])(context).getInstance();

        playbackController = (0, _controllersPlaybackController2['default'])(context).getInstance();
        mediaController = (0, _controllersMediaController2['default'])(context).getInstance();
        mediaController.initialize();
        dashManifestModel = (0, _dashModelsDashManifestModel2['default'])(context).getInstance();
        dashMetrics = (0, _dashDashMetrics2['default'])(context).getInstance();
        metricsModel = (0, _modelsMetricsModel2['default'])(context).getInstance();
        metricsModel.setConfig({
            adapter: createAdaptor()
        });

        restoreDefaultUTCTimingSources();
        setAutoPlay(AutoPlay !== undefined ? AutoPlay : true);

        if (view) {
            attachView(view);
        }

        if (source) {
            attachSource(source);
        }

        log('[dash.js ' + getVersion() + '] ' + 'MediaPlayer has been initialized');
    }

    /**
     * The ready state of the MediaPlayer based on both the video element and MPD source being defined.
     *
     * @returns {boolean} The current ready state of the MediaPlayer
     * @see {@link module:MediaPlayer#attachView attachView()}
     * @see {@link module:MediaPlayer#attachSource attachSource()}
     * @memberof module:MediaPlayer
     * @instance
     */
    function isReady() {
        return !!videoModel && !!source;
    }

    /**
     * The play method initiates playback of the media defined by the {@link module:MediaPlayer#attachSource attachSource()} method.
     * This method will call play on the native Video Element.
     *
     * @see {@link module:MediaPlayer#attachSource attachSource()}
     * @memberof module:MediaPlayer
     * @instance
     */
    function play() {
        if (!playbackInitialized) {
            throw PLAYBACK_NOT_INITIALIZED_ERROR;
        }
        if (!autoPlay || isPaused() && playbackInitialized) {
            playbackController.play();
        }
    }

    /**
     * This method will call pause on the native Video Element.
     *
     * @memberof module:MediaPlayer
     * @instance
     */
    function pause() {
        if (!playbackInitialized) {
            throw PLAYBACK_NOT_INITIALIZED_ERROR;
        }
        playbackController.pause();
    }

    /**
     * Returns a Boolean that indicates whether the Video Element is paused.
     * @return {boolean}
     * @memberof module:MediaPlayer
     * @instance
     */
    function isPaused() {
        if (!playbackInitialized) {
            throw PLAYBACK_NOT_INITIALIZED_ERROR;
        }
        return playbackController.isPaused();
    }

    /**
     * Returns a Boolean that indicates whether the media is in the process of seeking to a new position.
     * @return {boolean}
     * @memberof module:MediaPlayer
     * @instance
     */
    function isSeeking() {
        if (!playbackInitialized) {
            throw PLAYBACK_NOT_INITIALIZED_ERROR;
        }
        return playbackController.isSeeking();
    }

    /**
     * Returns a Boolean that indicates whether the media is in the process of dynamic.
     * @return {boolean}
     * @memberof module:MediaPlayer
     * @instance
     */
    function isDynamic() {
        if (!playbackInitialized) {
            throw PLAYBACK_NOT_INITIALIZED_ERROR;
        }
        return playbackController.getIsDynamic();
    }

    /**
     * Use this method to set the native Video Element's muted state. Takes a Boolean that determines whether audio is muted. true if the audio is muted and false otherwise.
     * @param {boolean} value
     * @memberof module:MediaPlayer
     * @instance
     */
    function setMute(value) {
        if (!videoModel) {
            throw ELEMENT_NOT_ATTACHED_ERROR;
        }
        getVideoElement().muted = value;
    }

    /**
     * A Boolean that determines whether audio is muted.
     * @returns {boolean}
     * @memberof module:MediaPlayer
     * @instance
     */
    function isMuted() {
        if (!videoModel) {
            throw ELEMENT_NOT_ATTACHED_ERROR;
        }
        return getVideoElement().muted;
    }

    /**
     * A double indicating the audio volume, from 0.0 (silent) to 1.0 (loudest).
     * @param {number} value
     * @memberof module:MediaPlayer
     * @instance
     */
    function setVolume(value) {
        if (!videoModel) {
            throw ELEMENT_NOT_ATTACHED_ERROR;
        }
        getVideoElement().volume = value;
    }

    /**
     * Returns the current audio volume, from 0.0 (silent) to 1.0 (loudest).
     * @returns {number}
     * @memberof module:MediaPlayer
     * @instance
     */
    function getVolume() {
        if (!videoModel) {
            throw ELEMENT_NOT_ATTACHED_ERROR;
        }
        return getVideoElement().volume;
    }

    /**
     * The length of the buffer for a given media type, in seconds. Valid media
     * types are "video", "audio" and "fragmentedText". If no type is passed
     * in, then the minimum of video, audio and fragmentedText buffer length is
     * returned. NaN is returned if an invalid type is requested, the
     * presentation does not contain that type, or if no arguments are passed
     * and the presentation does not include any adaption sets of valid media
     * type.
     *
     * @param {string} type - the media type of the buffer
     * @returns {number} The length of the buffer for the given media type, in
     *  seconds, or NaN
     * @memberof module:MediaPlayer
     * @instance
     */
    function getBufferLength(type) {
        var types = ['video', 'audio', 'fragmentedText'];
        if (!type) {
            return types.map(function (t) {
                return getTracksFor(t).length > 0 ? getDashMetrics().getCurrentBufferLevel(getMetricsFor(t)) : Number.MAX_VALUE;
            }).reduce(function (p, c) {
                return Math.min(p, c);
            });
        } else {
            if (types.indexOf(type) !== -1) {
                var buffer = getDashMetrics().getCurrentBufferLevel(getMetricsFor(type));
                return buffer ? buffer : NaN;
            } else {
                log('Warning  - getBufferLength requested for invalid type');
                return NaN;
            }
        }
    }

    /**
     * The timeShiftBufferLength (DVR Window), in seconds.
     *
     * @returns {number} The window of allowable play time behind the live point of a live stream.
     * @memberof module:MediaPlayer
     * @instance
     */
    function getDVRWindowSize() {
        var metric = getDVRInfoMetric();
        if (!metric) {
            return 0;
        }
        return metric.manifestInfo.DVRWindowSize;
    }

    /**
     * This method should only be used with a live stream that has a valid timeShiftBufferLength (DVR Window).
     * NOTE - If you do not need the raw offset value (i.e. media analytics, tracking, etc) consider using the {@link module:MediaPlayer#seek seek()} method
     * which will calculate this value for you and set the video element's currentTime property all in one simple call.
     *
     * @param {number} value - A relative time, in seconds, based on the return value of the {@link module:MediaPlayer#duration duration()} method is expected.
     * @returns {number} A value that is relative the available range within the timeShiftBufferLength (DVR Window).
     * @see {@link module:MediaPlayer#seek seek()}
     * @memberof module:MediaPlayer
     * @instance
     */
    function getDVRSeekOffset(value) {
        var metric = getDVRInfoMetric();

        if (!metric) {
            return 0;
        }

        var val = metric.range.start + value;

        if (val > metric.range.end) {
            val = metric.range.end;
        }

        return val;
    }

    /**
     * Sets the currentTime property of the attached video element.  If it is a live stream with a
     * timeShiftBufferLength, then the DVR window offset will be automatically calculated.
     *
     * @param {number} value - A relative time, in seconds, based on the return value of the {@link module:MediaPlayer#duration duration()} method is expected
     * @see {@link module:MediaPlayer#getDVRSeekOffset getDVRSeekOffset()}
     * @memberof module:MediaPlayer
     * @instance
     */
    function seek(value) {
        if (!playbackInitialized) {
            throw PLAYBACK_NOT_INITIALIZED_ERROR;
        }
        var s = playbackController.getIsDynamic() ? getDVRSeekOffset(value) : value;
        playbackController.seek(s);
    }

    /**
     * Current time of the playhead, in seconds.
     *
     * If called with no arguments then the returned time value is time elapsed since the start point of the first stream, or if it is a live stream, then the time will be based on the return value of the {@link module:MediaPlayer#duration duration()} method.
     * However if a stream ID is supplied then time is relative to the start of that stream, or is null if there is no such stream id in the manifest.
     *
     * @param {string} streamId - The ID of a stream that the returned playhead time must be relative to the start of. If undefined, then playhead time is relative to the first stream.
     * @returns {number} The current playhead time of the media, or null.
     * @memberof module:MediaPlayer
     * @instance
     */
    function time(streamId) {
        if (!playbackInitialized) {
            throw PLAYBACK_NOT_INITIALIZED_ERROR;
        }
        var t = getVideoElement().currentTime;

        if (streamId !== undefined) {
            t = streamController.getTimeRelativeToStreamId(t, streamId);
        } else if (playbackController.getIsDynamic()) {
            var metric = getDVRInfoMetric();
            t = metric === null ? 0 : duration() - (metric.range.end - metric.time);
        }

        return t;
    }

    /**
     * Duration of the media's playback, in seconds.
     *
     * @returns {number} The current duration of the media.
     * @memberof module:MediaPlayer
     * @instance
     */
    function duration() {
        if (!playbackInitialized) {
            throw PLAYBACK_NOT_INITIALIZED_ERROR;
        }
        var d = getVideoElement().duration;

        if (playbackController.getIsDynamic()) {

            var metric = getDVRInfoMetric();
            var range;

            if (!metric) {
                return 0;
            }

            range = metric.range.end - metric.range.start;
            d = range < metric.manifestInfo.DVRWindowSize ? range : metric.manifestInfo.DVRWindowSize;
        }
        return d;
    }

    /**
     * Use this method to get the current playhead time as an absolute value, the time in seconds since midnight UTC, Jan 1 1970.
     * Note - this property only has meaning for live streams. If called before play() has begun, it will return a value of NaN.
     *
     * @returns {number} The current playhead time as UTC timestamp.
     * @memberof module:MediaPlayer
     * @instance
     */
    function timeAsUTC() {
        if (!playbackInitialized) {
            throw PLAYBACK_NOT_INITIALIZED_ERROR;
        }
        if (time() < 0) {
            return NaN;
        }
        return getAsUTC(time());
    }

    /**
     * Use this method to get the current duration as an absolute value, the time in seconds since midnight UTC, Jan 1 1970.
     * Note - this property only has meaning for live streams.
     *
     * @returns {number} The current duration as UTC timestamp.
     * @memberof module:MediaPlayer
     * @instance
     */
    function durationAsUTC() {
        if (!playbackInitialized) {
            throw PLAYBACK_NOT_INITIALIZED_ERROR;
        }
        return getAsUTC(duration());
    }

    /**
     * A utility methods which converts UTC timestamp value into a valid time and date string.
     *
     * @param {number} time - UTC timestamp to be converted into date and time.
     * @param {string} locales - a region identifier (i.e. en_US).
     * @param {boolean} hour12 - 12 vs 24 hour. Set to true for 12 hour time formatting.
     * @param {boolean} withDate - default is false. Set to true to append current date to UTC time format.
     * @returns {string} A formatted time and date string.
     * @memberof module:MediaPlayer
     * @instance
     */
    function formatUTC(time, locales, hour12) {
        var withDate = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];

        var dt = new Date(time * 1000);
        var d = dt.toLocaleDateString(locales);
        var t = dt.toLocaleTimeString(locales, {
            hour12: hour12
        });
        return withDate ? t + ' ' + d : t;
    }

    /**
     * A utility method which converts seconds into TimeCode (i.e. 300 --> 05:00).
     *
     * @param {number} value - A number in seconds to be converted into a formatted time code.
     * @returns {string} A formatted time code string.
     * @memberof module:MediaPlayer
     * @instance
     */
    function convertToTimeCode(value) {
        value = Math.max(value, 0);

        var h = Math.floor(value / 3600);
        var m = Math.floor(value % 3600 / 60);
        var s = Math.floor(value % 3600 % 60);
        return (h === 0 ? '' : h < 10 ? '0' + h.toString() + ':' : h.toString() + ':') + (m < 10 ? '0' + m.toString() : m.toString()) + ':' + (s < 10 ? '0' + s.toString() : s.toString());
    }

    /**
     * This method should be used to extend or replace internal dash.js objects.
     * There are two ways to extend dash.js (determined by the override argument):
     * <ol>
     * <li>If you set override to true any public method or property in your custom object will
     * override the dash.js parent object's property(ies) and will be used instead but the
     * dash.js parent module will still be created.</li>
     *
     * <li>If you set override to false your object will completely replace the dash.js object.
     * (Note: This is how it was in 1.x of Dash.js with Dijon).</li>
     * </ol>
     * <b>When you extend you get access to this.context, this.factory and this.parent to operate with in your custom object.</b>
     * <ul>
     * <li><b>this.context</b> - can be used to pass context for singleton access.</li>
     * <li><b>this.factory</b> - can be used to call factory.getSingletonInstance().</li>
     * <li><b>this.parent</b> - is the reference of the parent object to call other public methods. (this.parent is excluded if you extend with override set to false or option 2)</li>
     * </ul>
     * <b>You must call extend before you call initialize</b>
     * @see {@link module:MediaPlayer#initialize initialize()}
     * @param {string} parentNameString - name of parent module
     * @param {Object} childInstance - overriding object
     * @param {boolean} override - replace only some methods (true) or the whole object (false)
     * @memberof module:MediaPlayer
     * @instance
     */
    function extend(parentNameString, childInstance, override) {
        _coreFactoryMaker2['default'].extend(parentNameString, childInstance, override, context);
    }

    /**
     * Use the on method to listen for public events found in MediaPlayer.events. {@link MediaPlayerEvents}
     *
     * @param {string} type - {@link MediaPlayerEvents}
     * @param {Function} listener - callback method when the event fires.
     * @param {Object} scope - context of the listener so it can be removed properly.
     * @memberof module:MediaPlayer
     * @instance
     */
    function on(type, listener, scope) {
        eventBus.on(type, listener, scope);
    }

    /**
     * Use the off method to remove listeners for public events found in MediaPlayer.events. {@link MediaPlayerEvents}
     *
     * @param {string} type - {@link MediaPlayerEvents}
     * @param {Function} listener - callback method when the event fires.
     * @param {Object} scope - context of the listener so it can be removed properly.
     * @memberof module:MediaPlayer
     * @instance
     */
    function off(type, listener, scope) {
        eventBus.off(type, listener, scope);
    }

    /**
     * Current version of Dash.js
     * @returns {string} the current dash.js version string.
     * @memberof module:MediaPlayer
     * @instance
     */
    function getVersion() {
        return (0, _coreVersion.getVersionString)();
    }

    /**
     * Use this method to access the dash.js logging class.
     *
     * @returns {Debug}
     * @memberof module:MediaPlayer
     * @instance
     */
    function getDebug() {
        return debug;
    }

    /**
     * @deprecated Since version 2.1.0.  <b>Instead use:</b>
     * <ul>
     * <li>{@link module:MediaPlayer#getVideoElement getVideoElement()}</li>
     * <li>{@link module:MediaPlayer#getSource getSource()}</li>
     * <li>{@link module:MediaPlayer#getVideoContainer getVideoContainer()}</li>
     * <li>{@link module:MediaPlayer#getTTMLRenderingDiv getTTMLRenderingDiv()}</li>
     * </ul>
     *
     * @returns {VideoModel}
     * @memberof module:MediaPlayer
     * @instance
     */
    function getVideoModel() {
        if (!videoModel) {
            throw ELEMENT_NOT_ATTACHED_ERROR;
        }
        return videoModel;
    }

    /**
     * <p>Changing this value will lower or increase live stream latency.  The detected segment duration will be multiplied by this value
     * to define a time in seconds to delay a live stream from the live edge.</p>
     * <p>Lowering this value will lower latency but may decrease the player's ability to build a stable buffer.</p>
     *
     * @param {number} value - Represents how many segment durations to delay the live stream.
     * @default 4
     * @memberof module:MediaPlayer
     * @see {@link module:MediaPlayer#useSuggestedPresentationDelay useSuggestedPresentationDelay()}
     * @instance
     */
    function setLiveDelayFragmentCount(value) {
        mediaPlayerModel.setLiveDelayFragmentCount(value);
    }

    /**
     * <p>Equivalent in seconds of setLiveDelayFragmentCount</p>
     * <p>Lowering this value will lower latency but may decrease the player's ability to build a stable buffer.</p>
     * <p>This value should be less than the manifest duration by a couple of segment durations to avoid playback issues</p>
     * <p>If set, this parameter will take precedence over setLiveDelayFragmentCount and manifest info</p>
     *
     * @param {number} value - Represents how many seconds to delay the live stream.
     * @default undefined
     * @memberof module:MediaPlayer
     * @see {@link module:MediaPlayer#useSuggestedPresentationDelay useSuggestedPresentationDelay()}
     * @instance
     */
    function setLiveDelay(value) {
        mediaPlayerModel.setLiveDelay(value);
    }

    /**
     * @memberof module:MediaPlayer
     * @see {@link module:MediaPlayer#setLiveDelay setLiveDelay()}
     * @instance
     * @returns {number|undefined} Current live stream delay in seconds when previously set, or `undefined`
     */
    function getLiveDelay() {
        return mediaPlayerModel.getLiveDelay();
    }

    /**
     * <p>Set to true if you would like to override the default live delay and honor the SuggestedPresentationDelay attribute in by the manifest.</p>
     * @param {boolean} value
     * @default false
     * @memberof module:MediaPlayer
     * @see {@link module:MediaPlayer#setLiveDelayFragmentCount setLiveDelayFragmentCount()}
     * @instance
     */
    function useSuggestedPresentationDelay(value) {
        mediaPlayerModel.setUseSuggestedPresentationDelay(value);
    }

    /**
     * Set to false if you would like to disable the last known bit rate from being stored during playback and used
     * to set the initial bit rate for subsequent playback within the expiration window.
     *
     * The default expiration is one hour, defined in milliseconds. If expired, the default initial bit rate (closest to 1000 kbps) will be used
     * for that session and a new bit rate will be stored during that session.
     *
     * @param {boolean} enable - Will toggle if feature is enabled. True to enable, False to disable.
     * @param {number=} ttl - (Optional) A value defined in milliseconds representing how long to cache the bit rate for. Time to live.
     * @default enable = True, ttl = 360000 (1 hour)
     * @memberof module:MediaPlayer
     * @instance
     *
     */
    function enableLastBitrateCaching(enable, ttl) {
        mediaPlayerModel.setLastBitrateCachingInfo(enable, ttl);
    }

    /**
     * Set to false if you would like to disable the last known lang for audio (or camera angle for video) from being stored during playback and used
     * to set the initial settings for subsequent playback within the expiration window.
     *
     * The default expiration is one hour, defined in milliseconds. If expired, the default settings will be used
     * for that session and a new settings will be stored during that session.
     *
     * @param {boolean} enable - Will toggle if feature is enabled. True to enable, False to disable.
     * @param {number=} [ttl] - (Optional) A value defined in milliseconds representing how long to cache the settings for. Time to live.
     * @default enable = True, ttl = 360000 (1 hour)
     * @memberof module:MediaPlayer
     * @instance
     *
     */
    function enableLastMediaSettingsCaching(enable, ttl) {
        mediaPlayerModel.setLastMediaSettingsCachingInfo(enable, ttl);
    }

    /**
     * When switching multi-bitrate content (auto or manual mode) this property specifies the maximum bitrate allowed.
     * If you set this property to a value lower than that currently playing, the switching engine will switch down to
     * satisfy this requirement. If you set it to a value that is lower than the lowest bitrate, it will still play
     * that lowest bitrate.
     *
     * You can set or remove this bitrate cap at anytime before or during playback.  To clear this setting you must use the API
     * and set the value param to NaN.
     *
     * This feature is typically used to reserve higher bitrates for playback only when the player is in large or full-screen format.
     *
     * @param {string} type - 'video' or 'audio' are the type options.
     * @param {number} value - Value in kbps representing the maximum bitrate allowed.
     * @memberof module:MediaPlayer
     * @instance
     */
    function setMaxAllowedBitrateFor(type, value) {
        abrController.setMaxAllowedBitrateFor(type, value);
    }

    /**
     * When switching multi-bitrate content (auto or manual mode) this property specifies the minimum bitrate allowed.
     * If you set this property to a value higher than that currently playing, the switching engine will switch up to
     * satisfy this requirement. If you set it to a value that is lower than the lowest bitrate, it will still play
     * that lowest bitrate.
     *
     * You can set or remove this bitrate limit at anytime before or during playback. To clear this setting you must use the API
     * and set the value param to NaN.
     *
     * This feature is used to force higher quality playback.
     *
     * @param {string} type - 'video' or 'audio' are the type options.
     * @param {number} value - Value in kbps representing the minimum bitrate allowed.
     * @memberof module:MediaPlayer
     * @instance
     */
    function setMinAllowedBitrateFor(type, value) {
        abrController.setMinAllowedBitrateFor(type, value);
    }

    /**
     * @param {string} type - 'video' or 'audio' are the type options.
     * @memberof module:MediaPlayer
     * @see {@link module:MediaPlayer#setMaxAllowedBitrateFor setMaxAllowedBitrateFor()}
     * @instance
     */
    function getMaxAllowedBitrateFor(type) {
        return abrController.getMaxAllowedBitrateFor(type);
    }

    /**
     * @param {string} type - 'video' or 'audio' are the type options.
     * @memberof module:MediaPlayer
     * @see {@link module:MediaPlayer#setMinAllowedBitrateFor setMinAllowedBitrateFor()}
     * @instance
     */
    function getMinAllowedBitrateFor(type) {
        return abrController.getMinAllowedBitrateFor(type);
    }

    /**
     * When switching multi-bitrate content (auto or manual mode) this property specifies the maximum representation allowed,
     * as a proportion of the size of the representation set.
     *
     * You can set or remove this cap at anytime before or during playback. To clear this setting you must use the API
     * and set the value param to NaN.
     *
     * If both this and maxAllowedBitrate are defined, maxAllowedBitrate is evaluated first, then maxAllowedRepresentation,
     * i.e. the lowest value from executing these rules is used.
     *
     * This feature is typically used to reserve higher representations for playback only when connected over a fast connection.
     *
     * @param {string} type - 'video' or 'audio' are the type options.
     * @param {number} value - number between 0 and 1, where 1 is allow all representations, and 0 is allow only the lowest.
     * @memberof module:MediaPlayer
     * @instance
     */
    function setMaxAllowedRepresentationRatioFor(type, value) {
        abrController.setMaxAllowedRepresentationRatioFor(type, value);
    }

    /**
     * @param {string} type - 'video' or 'audio' are the type options.
     * @returns {number} The current representation ratio cap.
     * @memberof module:MediaPlayer
     * @see {@link MediaPlayer#setMaxAllowedRepresentationRatioFor setMaxAllowedRepresentationRatioFor()}
     * @instance
     */
    function getMaxAllowedRepresentationRatioFor(type) {
        return abrController.getMaxAllowedRepresentationRatioFor(type);
    }

    /**
     * <p>Set to false to prevent stream from auto-playing when the view is attached.</p>
     *
     * @param {boolean} value
     * @default true
     * @memberof module:MediaPlayer
     * @see {@link module:MediaPlayer#attachView attachView()}
     * @instance
     *
     */
    function setAutoPlay(value) {
        autoPlay = value;
    }

    /**
     * @returns {boolean} The current autoPlay state.
     * @memberof module:MediaPlayer
     * @instance
     */
    function getAutoPlay() {
        return autoPlay;
    }

    /**
     * Set to true if you would like dash.js to keep downloading fragments in the background
     * when the video element is paused.
     *
     * @default true
     * @param {boolean} value
     * @memberof module:MediaPlayer
     * @instance
     */
    function setScheduleWhilePaused(value) {
        mediaPlayerModel.setScheduleWhilePaused(value);
    }

    /**
     * Returns a boolean of the current state of ScheduleWhilePaused.
     * @returns {boolean}
     * @see {@link module:MediaPlayer#setScheduleWhilePaused setScheduleWhilePaused()}
     * @memberof module:MediaPlayer
     * @instance
     */
    function getScheduleWhilePaused() {
        return mediaPlayerModel.getScheduleWhilePaused();
    }

    /**
     * Returns the DashMetrics.js Module. You use this Module to get access to all the public metrics
     * stored in dash.js
     *
     * @see {@link module:DashMetrics}
     * @returns {Object}
     * @memberof module:MediaPlayer
     * @instance
     */
    function getDashMetrics() {
        return dashMetrics;
    }

    /**
     *
     * @param {string} type
     * @returns {Object}
     * @memberof module:MediaPlayer
     * @instance
     */
    function getMetricsFor(type) {
        return metricsModel.getReadOnlyMetricsFor(type);
    }

    /**
     * @param {string} type
     * @returns {Object}
     * @memberof module:MediaPlayer
     * @instance
     */
    function getQualityFor(type) {
        if (!playbackInitialized) {
            throw PLAYBACK_NOT_INITIALIZED_ERROR;
        }
        return abrController.getQualityFor(type, streamController.getActiveStreamInfo());
    }

    /**
     * Sets the current quality for media type instead of letting the ABR Heuristics automatically selecting it..
     *
     * @param {string} type
     * @param {number} value
     * @memberof module:MediaPlayer
     * @instance
     */
    function setQualityFor(type, value) {
        if (!playbackInitialized) {
            throw PLAYBACK_NOT_INITIALIZED_ERROR;
        }
        abrController.setPlaybackQuality(type, streamController.getActiveStreamInfo(), value);
    }

    /**
     * Update the video element size variables
     * Should be called on window resize (or any other time player is resized). Fullscreen does trigger a window resize event.
     *
     * Once windowResizeEventCalled = true, abrController.checkPortalSize() will use element size variables rather than querying clientWidth every time.
     *
     * @memberof module:MediaPlayer
     * @instance
     */
    function updatePortalSize() {
        abrController.setElementSize();
        abrController.setWindowResizeEventCalled(true);
    }

    /**
     * @memberof module:MediaPlayer
     * @instance
     */
    function getLimitBitrateByPortal() {
        return abrController.getLimitBitrateByPortal();
    }

    /**
     * Sets whether to limit the representation used based on the size of the playback area
     *
     * @param {boolean} value
     * @memberof module:MediaPlayer
     * @instance
     */
    function setLimitBitrateByPortal(value) {
        abrController.setLimitBitrateByPortal(value);
    }

    /**
     * @memberof module:MediaPlayer
     * @instance
     */
    function getUsePixelRatioInLimitBitrateByPortal() {
        return abrController.getUsePixelRatioInLimitBitrateByPortal();
    }

    /**
     * Sets whether to take into account the device's pixel ratio when defining the portal dimensions.
     * Useful on, for example, retina displays.
     *
     * @param {boolean} value
     * @memberof module:MediaPlayer
     * @instance
     * @default {boolean} false
     */
    function setUsePixelRatioInLimitBitrateByPortal(value) {
        abrController.setUsePixelRatioInLimitBitrateByPortal(value);
    }

    /**
     * Use this method to change the current text track for both external time text files and fragmented text tracks. There is no need to
     * set the track mode on the video object to switch a track when using this method.
     *
     * @param {number} idx - Index of track based on the order of the order the tracks are added Use -1 to disable all tracks. (turn captions off).  Use module:MediaPlayer#dashjs.MediaPlayer.events.TEXT_TRACK_ADDED.
     * @see {@link module:MediaPlayer#dashjs.MediaPlayer.events.TEXT_TRACK_ADDED}
     * @memberof module:MediaPlayer
     * @instance
     */
    function setTextTrack(idx) {
        if (!playbackInitialized) {
            throw PLAYBACK_NOT_INITIALIZED_ERROR;
        }
        //For external time text file,  the only action needed to change a track is marking the track mode to showing.
        // Fragmented text tracks need the additional step of calling TextController.setTextTrack();
        if (textController === undefined) {
            textController = (0, _textTextController2['default'])(context).getInstance();
        }

        var tracks = getVideoElement().textTracks;
        var ln = tracks.length;

        for (var i = 0; i < ln; i++) {
            var track = tracks[i];
            var mode = idx === i ? 'showing' : 'hidden';

            if (track.mode !== mode) {
                //checking that mode is not already set by 3rd Party player frameworks that set mode to prevent event retrigger.
                track.mode = mode;
            }
        }

        textController.setTextTrack();
    }

    function getCurrentTextTrackIndex() {
        var idx = NaN;
        if (textController) {
            idx = textController.getCurrentTrackIdx();
        }
        return idx;
    }

    /**
     * @param {string} type
     * @returns {Array}
     * @memberof module:MediaPlayer
     * @instance
     */
    function getBitrateInfoListFor(type) {
        if (!playbackInitialized) {
            throw PLAYBACK_NOT_INITIALIZED_ERROR;
        }
        var stream = getActiveStream();
        return stream ? stream.getBitrateListFor(type) : [];
    }

    /**
     * Use this method to explicitly set the starting bitrate for audio | video
     *
     * @param {string} type
     * @param {number} value - A value of the initial bitrate, kbps
     * @memberof module:MediaPlayer
     * @instance
     */
    function setInitialBitrateFor(type, value) {
        abrController.setInitialBitrateFor(type, value);
    }

    /**
     * @param {string} type
     * @returns {number} A value of the initial bitrate, kbps
     * @memberof module:MediaPlayer
     * @instance
     */
    function getInitialBitrateFor(type) {
        if (!playbackInitialized) {
            throw PLAYBACK_NOT_INITIALIZED_ERROR; //abrController.getInitialBitrateFor is overloaded with ratioDict logic that needs manifest force it to not be callable pre play.
        }
        return abrController.getInitialBitrateFor(type);
    }

    /**
     * @param {string} type
     * @param {number} value - A value of the initial Representation Ratio
     * @memberof module:MediaPlayer
     * @instance
     */
    function setInitialRepresentationRatioFor(type, value) {
        abrController.setInitialRepresentationRatioFor(type, value);
    }

    /**
     * @param {string} type
     * @returns {number} A value of the initial Representation Ratio
     * @memberof module:MediaPlayer
     * @instance
     */
    function getInitialRepresentationRatioFor(type) {
        return abrController.getInitialRepresentationRatioFor(type);
    }

    /**
     * This method returns the list of all available streams from a given manifest
     * @param {Object} manifest
     * @returns {Array} list of {@link StreamInfo}
     * @memberof module:MediaPlayer
     * @instance
     */
    function getStreamsFromManifest(manifest) {
        if (!playbackInitialized) {
            throw PLAYBACK_NOT_INITIALIZED_ERROR;
        }
        return adapter.getStreamsInfo(manifest);
    }

    /**
     * This method returns the list of all available tracks for a given media type
     * @param {string} type
     * @returns {Array} list of {@link MediaInfo}
     * @memberof module:MediaPlayer
     * @instance
     */
    function getTracksFor(type) {
        if (!playbackInitialized) {
            throw PLAYBACK_NOT_INITIALIZED_ERROR;
        }
        var streamInfo = streamController.getActiveStreamInfo();
        if (!streamInfo) return [];
        return mediaController.getTracksFor(type, streamInfo);
    }

    /**
     * This method returns the list of all available tracks for a given media type and streamInfo from a given manifest
     * @param {string} type
     * @param {Object} manifest
     * @param {Object} streamInfo
     * @returns {Array} list of {@link MediaInfo}
     * @memberof module:MediaPlayer
     * @instance
     */
    function getTracksForTypeFromManifest(type, manifest, streamInfo) {
        if (!playbackInitialized) {
            throw PLAYBACK_NOT_INITIALIZED_ERROR;
        }

        streamInfo = streamInfo || adapter.getStreamsInfo(manifest)[0];

        return streamInfo ? adapter.getAllMediaInfoForType(manifest, streamInfo, type) : [];
    }

    /**
     * @param {string} type
     * @returns {Object|null} {@link MediaInfo}
     * @memberof module:MediaPlayer
     * @instance
     */
    function getCurrentTrackFor(type) {
        if (!playbackInitialized) {
            throw PLAYBACK_NOT_INITIALIZED_ERROR;
        }
        var streamInfo = streamController.getActiveStreamInfo();

        if (!streamInfo) return null;

        return mediaController.getCurrentTrackFor(type, streamInfo);
    }

    /**
     * This method allows to set media settings that will be used to pick the initial track. Format of the settings
     * is following:
     * {lang: langValue,
     *  viewpoint: viewpointValue,
     *  audioChannelConfiguration: audioChannelConfigurationValue,
     *  accessibility: accessibilityValue,
     *  role: roleValue}
     *
     *
     * @param {string} type
     * @param {Object} value
     * @memberof module:MediaPlayer
     * @instance
     */
    function setInitialMediaSettingsFor(type, value) {
        mediaController.setInitialSettings(type, value);
    }

    /**
     * This method returns media settings that is used to pick the initial track. Format of the settings
     * is following:
     * {lang: langValue,
     *  viewpoint: viewpointValue,
     *  audioChannelConfiguration: audioChannelConfigurationValue,
     *  accessibility: accessibilityValue,
     *  role: roleValue}
     * @param {string} type
     * @returns {Object}
     * @memberof module:MediaPlayer
     * @instance
     */
    function getInitialMediaSettingsFor(type) {
        return mediaController.getInitialSettings(type);
    }

    /**
     * @param {MediaInfo} track - instance of {@link MediaInfo}
     * @memberof module:MediaPlayer
     * @instance
     */
    function setCurrentTrack(track) {
        if (!playbackInitialized) {
            throw PLAYBACK_NOT_INITIALIZED_ERROR;
        }
        mediaController.setTrack(track);
    }

    /**
     * This method returns the current track switch mode.
     *
     * @param {string} type
     * @returns {string} mode
     * @memberof module:MediaPlayer
     * @instance
     */
    function getTrackSwitchModeFor(type) {
        return mediaController.getSwitchMode(type);
    }

    /**
     * This method sets the current track switch mode. Available options are:
     *
     * MediaController.TRACK_SWITCH_MODE_NEVER_REPLACE
     * (used to forbid clearing the buffered data (prior to current playback position) after track switch. Default for video)
     *
     * MediaController.TRACK_SWITCH_MODE_ALWAYS_REPLACE
     * (used to clear the buffered data (prior to current playback position) after track switch. Default for audio)
     *
     * @param {string} type
     * @param {string} mode
     * @memberof module:MediaPlayer
     * @instance
     */
    function setTrackSwitchModeFor(type, mode) {
        mediaController.setSwitchMode(type, mode);
    }

    /**
     * This method sets the selection mode for the initial track. This mode defines how the initial track will be selected
     * if no initial media settings are set. If initial media settings are set this parameter will be ignored. Available options are:
     *
     * MediaController.TRACK_SELECTION_MODE_HIGHEST_BITRATE
     * this mode makes the player select the track with a highest bitrate. This mode is a default mode.
     *
     * MediaController.TRACK_SELECTION_MODE_WIDEST_RANGE
     * this mode makes the player select the track with a widest range of bitrates
     *
     * @param {string} mode
     * @memberof module:MediaPlayer
     * @instance
     */
    function setSelectionModeForInitialTrack(mode) {
        mediaController.setSelectionModeForInitialTrack(mode);
    }

    /**
     * This method returns the track selection mode.
     *
     * @returns {string} mode
     * @memberof module:MediaPlayer
     * @instance
     */
    function getSelectionModeForInitialTrack() {
        return mediaController.getSelectionModeForInitialTrack();
    }

    /**
     * @deprecated since version 2.0 Instead use {@link module:MediaPlayer#getAutoSwitchQualityFor getAutoSwitchQualityFor()}.
     * @returns {boolean} Current state of adaptive bitrate switching
     * @memberof module:MediaPlayer
     * @instance
     */
    function getAutoSwitchQuality() {
        return abrController.getAutoSwitchBitrateFor('video') || abrController.getAutoSwitchBitrateFor('audio');
    }

    /**
     * Set to false to switch off adaptive bitrate switching.
     *
     * @deprecated since version 2.0 Instead use {@link module:MediaPlayer#setAutoSwitchQualityFor setAutoSwitchQualityFor()}.
     * @param {boolean} value
     * @default {boolean} true
     * @memberof module:MediaPlayer
     * @instance
     */
    function setAutoSwitchQuality(value) {
        abrController.setAutoSwitchBitrateFor('video', value);
        abrController.setAutoSwitchBitrateFor('audio', value);
    }

    /**
     * @param {string} type - 'audio' | 'video'
     * @returns {boolean} Current state of adaptive bitrate switching
     * @memberof module:MediaPlayer
     * @instance
     */
    function getAutoSwitchQualityFor(type) {
        return abrController.getAutoSwitchBitrateFor(type);
    }

    /**
     * Set to false to switch off adaptive bitrate switching.
     *
     * @param {string} type - 'audio' | 'video'
     * @param {boolean} value
     * @default {boolean} true
     * @memberof module:MediaPlayer
     * @instance
     */
    function setAutoSwitchQualityFor(type, value) {
        abrController.setAutoSwitchBitrateFor(type, value);
    }

    /**
     * When enabled, after an ABR up-switch in quality, instead of requesting and appending the next fragment
     * at the end of the current buffer range it is requested and appended closer to the current time
     * When enabled, The maximum time to render a higher quality is current time + (1.5 * fragment duration).
     *
     * Note, WHen ABR down-switch is detected, we appended the lower quality at the end of the buffer range to preserve the
     * higher quality media for as long as possible.
     *
     * If enabled, it should be noted there are a few cases when the client will not replace inside buffer range but rather
     * just append at the end.  1. When the buffer level is less than one fragment duration 2.  The client
     * is in an Abandonment State due to recent fragment abandonment event.
     *
     * Known issues:
     * 1. In IE11 with auto switching off, if a user switches to a quality they can not downloaded in time the
     * fragment may be appended in the same range as the playhead or even in past, in IE11 it may cause a stutter
     * or stall in playback.
     *
     *
     * @param {boolean} value
     * @default {boolean} false
     * @memberof module:MediaPlayer
     * @instance
     */
    function setFastSwitchEnabled(value) {
        //TODO we need to look at track switches for adaptation sets.  If always replace it works much like this but clears buffer. Maybe too many ways to do same thing.
        mediaPlayerModel.setFastSwitchEnabled(value);
    }

    /**
     * Enabled by default. Will return the current state of Fast Switch.
     * @return {boolean} Returns true if FastSwitch ABR is enabled.
     * @see {@link module:MediaPlayer#setFastSwitchEnabled setFastSwitchEnabled()}
     * @memberof module:MediaPlayer
     * @instance
     */
    function getFastSwitchEnabled() {
        return mediaPlayerModel.getFastSwitchEnabled();
    }

    /**
     * Enabling buffer-occupancy ABR will switch to the *experimental* implementation of BOLA,
     * replacing the throughput-based ABR rule set (ThroughputRule, BufferOccupancyRule,
     * InsufficientBufferRule and AbandonRequestsRule) with the buffer-occupancy-based
     * BOLA rule set (BolaRule, BolaAbandonRule).
     *
     * @see {@link http://arxiv.org/abs/1601.06748 BOLA WhitePaper.}
     * @see {@link https://github.com/Dash-Industry-Forum/dash.js/wiki/BOLA-status More details about the implementation status.}
     * @param {boolean} value
     * @default false
     * @memberof module:MediaPlayer
     * @instance
     */
    function enableBufferOccupancyABR(value) {
        mediaPlayerModel.setBufferOccupancyABREnabled(value);
    }

    /**
     * Allows application to retrieve a manifest.  Manifest loading is asynchro
     * nous and
     * requires the app-provided callback function
     *
     * @param {string} url - url the manifest url
     * @param {function} callback - A Callback function provided when retrieving manifests
     * @memberof module:MediaPlayer
     * @instance
     */
    function retrieveManifest(url, callback) {
        var manifestLoader = createManifestLoader();
        var self = this;

        var handler = function handler(e) {
            if (!e.error) {
                callback(e.manifest);
            } else {
                callback(null, e.error);
            }
            eventBus.off(_coreEventsEvents2['default'].INTERNAL_MANIFEST_LOADED, handler, self);
            manifestLoader.reset();
        };

        eventBus.on(_coreEventsEvents2['default'].INTERNAL_MANIFEST_LOADED, handler, self);

        var uriQueryFragModel = (0, _modelsURIQueryAndFragmentModel2['default'])(context).getInstance();
        uriQueryFragModel.initialize();
        manifestLoader.load(uriQueryFragModel.parseURI(url));
    }

    /**
     * <p>Allows you to set a scheme and server source for UTC live edge detection for dynamic streams.
     * If UTCTiming is defined in the manifest, it will take precedence over any time source manually added.</p>
     * <p>If you have exposed the Date header, use the method {@link module:MediaPlayer#clearDefaultUTCTimingSources clearDefaultUTCTimingSources()}.
     * This will allow the date header on the manifest to be used instead of a time server</p>
     * @param {string} schemeIdUri - <ul>
     * <li>urn:mpeg:dash:utc:http-head:2014</li>
     * <li>urn:mpeg:dash:utc:http-xsdate:2014</li>
     * <li>urn:mpeg:dash:utc:http-iso:2014</li>
     * <li>urn:mpeg:dash:utc:direct:2014</li>
     * </ul>
     * <p>Some specs referencing early ISO23009-1 drafts incorrectly use
     * 2012 in the URI, rather than 2014. support these for now.</p>
     * <ul>
     * <li>urn:mpeg:dash:utc:http-head:2012</li>
     * <li>urn:mpeg:dash:utc:http-xsdate:2012</li>
     * <li>urn:mpeg:dash:utc:http-iso:2012</li>
     * <li>urn:mpeg:dash:utc:direct:2012</li>
     * </ul>
     * @param {string} value - Path to a time source.
     * @default
     * <ul>
     *     <li>schemeIdUri:urn:mpeg:dash:utc:http-xsdate:2014</li>
     *     <li>value:http://time.akamai.com</li>
     * </ul>
     * @memberof module:MediaPlayer
     * @see {@link module:MediaPlayer#removeUTCTimingSource removeUTCTimingSource()}
     * @instance
     */
    function addUTCTimingSource(schemeIdUri, value) {
        removeUTCTimingSource(schemeIdUri, value); //check if it already exists and remove if so.
        var vo = new _dashVoUTCTiming2['default']();
        vo.schemeIdUri = schemeIdUri;
        vo.value = value;
        mediaPlayerModel.getUTCTimingSources().push(vo);
    }

    /**
     * <p>Allows you to remove a UTC time source. Both schemeIdUri and value need to match the Dash.vo.UTCTiming properties in order for the
     * entry to be removed from the array</p>
     * @param {string} schemeIdUri - see {@link module:MediaPlayer#addUTCTimingSource addUTCTimingSource()}
     * @param {string} value - see {@link module:MediaPlayer#addUTCTimingSource addUTCTimingSource()}
     * @memberof module:MediaPlayer
     * @see {@link module:MediaPlayer#clearDefaultUTCTimingSources clearDefaultUTCTimingSources()}
     * @instance
     */
    function removeUTCTimingSource(schemeIdUri, value) {
        var UTCTimingSources = mediaPlayerModel.getUTCTimingSources();
        UTCTimingSources.forEach(function (obj, idx) {
            if (obj.schemeIdUri === schemeIdUri && obj.value === value) {
                UTCTimingSources.splice(idx, 1);
            }
        });
    }

    /**
     * <p>Allows you to clear the stored array of time sources.</p>
     * <p>Example use: If you have exposed the Date header, calling this method
     * will allow the date header on the manifest to be used instead of the time server.</p>
     * <p>Example use: Calling this method, assuming there is not an exposed date header on the manifest,  will default back
     * to using a binary search to discover the live edge</p>
     *
     * @memberof module:MediaPlayer
     * @see {@link module:MediaPlayer#restoreDefaultUTCTimingSources restoreDefaultUTCTimingSources()}
     * @instance
     */
    function clearDefaultUTCTimingSources() {
        mediaPlayerModel.setUTCTimingSources([]);
    }

    /**
     * <p>Allows you to restore the default time sources after calling {@link module:MediaPlayer#clearDefaultUTCTimingSources clearDefaultUTCTimingSources()}</p>
     *
     * @default
     * <ul>
     *     <li>schemeIdUri:urn:mpeg:dash:utc:http-xsdate:2014</li>
     *     <li>value:http://time.akamai.com</li>
     * </ul>
     *
     * @memberof module:MediaPlayer
     * @see {@link module:MediaPlayer#addUTCTimingSource addUTCTimingSource()}
     * @instance
     */
    function restoreDefaultUTCTimingSources() {
        addUTCTimingSource(_modelsMediaPlayerModel2['default'].DEFAULT_UTC_TIMING_SOURCE.scheme, _modelsMediaPlayerModel2['default'].DEFAULT_UTC_TIMING_SOURCE.value);
    }

    /**
     * <p>Allows you to enable the use of the Date Header, if exposed with CORS, as a timing source for live edge detection. The
     * use of the date header will happen only after the other timing source that take precedence fail or are omitted as described.
     * {@link module:MediaPlayer#clearDefaultUTCTimingSources clearDefaultUTCTimingSources()} </p>
     *
     * @param {boolean} value - true to enable
     * @default {boolean} True
     * @memberof module:MediaPlayer
     * @see {@link module:MediaPlayer#addUTCTimingSource addUTCTimingSource()}
     * @instance
     */
    function enableManifestDateHeaderTimeSource(value) {
        mediaPlayerModel.setUseManifestDateHeaderTimeSource(value);
    }

    /**
     * This value influences the buffer pruning logic.
     * Allows you to modify the buffer that is kept in source buffer in seconds.
     *  0|-----------bufferToPrune-----------|-----bufferToKeep-----|currentTime|
     *
     * @default 30 seconds
     * @param {int} value
     * @memberof module:MediaPlayer
     * @instance
     */
    function setBufferToKeep(value) {
        mediaPlayerModel.setBufferToKeep(value);
    }

    /**
     * This value influences the buffer pruning logic.
     * Allows you to modify the interval of pruning buffer in seconds.
     *
     * @default 30 seconds
     * @param {int} value
     * @memberof module:MediaPlayer
     * @instance
     */
    function setBufferPruningInterval(value) {
        mediaPlayerModel.setBufferPruningInterval(value);
    }

    /**
     * The time that the internal buffer target will be set to post startup/seeks (NOT top quality).
     *
     * When the time is set higher than the default you will have to wait longer
     * to see automatic bitrate switches but will have a larger buffer which
     * will increase stability.
     *
     * @default 12 seconds.
     * @param {int} value
     * @memberof module:MediaPlayer
     * @instance
     */
    function setStableBufferTime(value) {
        mediaPlayerModel.setStableBufferTime(value);
    }

    /**
     * The time that the internal buffer target will be set to once playing the top quality.
     * If there are multiple bitrates in your adaptation, and the media is playing at the highest
     * bitrate, then we try to build a larger buffer at the top quality to increase stability
     * and to maintain media quality.
     *
     * @default 30 seconds.
     * @param {int} value
     * @memberof module:MediaPlayer
     * @instance
     */
    function setBufferTimeAtTopQuality(value) {
        mediaPlayerModel.setBufferTimeAtTopQuality(value);
    }

    /**
     * The time that the internal buffer target will be set to once playing the top quality for long form content.
     *
     * @default 60 seconds.
     * @see {@link module:MediaPlayer#setLongFormContentDurationThreshold setLongFormContentDurationThreshold()}
     * @see {@link module:MediaPlayer#setBufferTimeAtTopQuality setBufferTimeAtTopQuality()}
     * @param {int} value
     * @memberof module:MediaPlayer
     * @instance
     */
    function setBufferTimeAtTopQualityLongForm(value) {
        mediaPlayerModel.setBufferTimeAtTopQualityLongForm(value);
    }

    /**
     * The threshold which defines if the media is considered long form content.
     * This will directly affect the buffer targets when playing back at the top quality.
     *
     * @see {@link module:MediaPlayer#setBufferTimeAtTopQualityLongForm setBufferTimeAtTopQualityLongForm()}
     * @default 600 seconds (10 minutes).
     * @param {number} value
     * @memberof module:MediaPlayer
     * @instance
     */
    function setLongFormContentDurationThreshold(value) {
        mediaPlayerModel.setLongFormContentDurationThreshold(value);
    }

    /**
     * A threshold, in seconds, of when dashjs abr becomes less conservative since we have a
     * larger "rich" buffer.
     * The BufferOccupancyRule.js rule will override the ThroughputRule's decision when the
     * buffer level surpasses this value and while it remains greater than this value.
     *
     * @default 20 seconds
     * @param {number} value
     * @memberof module:MediaPlayer
     * @instance
     */
    function setRichBufferThreshold(value) {
        mediaPlayerModel.setRichBufferThreshold(value);
    }

    /**
     * A percentage between 0.0 and 1 to reduce the measured throughput calculations.
     * The default is 0.9. The lower the value the more conservative and restricted the
     * measured throughput calculations will be. please use carefully. This will directly
     * affect the ABR logic in dash.js
     *
     * @param {number} value
     * @memberof module:MediaPlayer
     * @instance
     */
    function setBandwidthSafetyFactor(value) {
        mediaPlayerModel.setBandwidthSafetyFactor(value);
    }

    /**
     * Returns the number of the current BandwidthSafetyFactor
     *
     * @return {number} value
     * @see {@link module:MediaPlayer#setBandwidthSafetyFactor setBandwidthSafetyFactor()}
     * @memberof module:MediaPlayer
     * @instance
     */
    function getBandwidthSafetyFactor() {
        return mediaPlayerModel.getBandwidthSafetyFactor();
    }

    /**
     * A timeout value in seconds, which during the ABRController will block switch-up events.
     * This will only take effect after an abandoned fragment event occurs.
     *
     * @default 10 seconds
     * @param {int} value
     * @memberof module:MediaPlayer
     * @instance
     */
    function setAbandonLoadTimeout(value) {
        mediaPlayerModel.setAbandonLoadTimeout(value);
    }

    /**
     * Total number of retry attempts that will occur on a fragment load before it fails.
     * Increase this value to a maximum in order to achieve an automatic playback resume
     * in case of completely lost internet connection.
     *
     * @default 3
     * @param {int} value
     * @memberof module:MediaPlayer
     * @instance
     */
    function setFragmentLoaderRetryAttempts(value) {
        mediaPlayerModel.setFragmentRetryAttempts(value);
    }

    /**
     * Time in milliseconds of which to reload a failed fragment load attempt.
     *
     * @default 1000 milliseconds
     * @param {int} value
     * @memberof module:MediaPlayer
     * @instance
     */
    function setFragmentLoaderRetryInterval(value) {
        mediaPlayerModel.setFragmentRetryInterval(value);
    }

    /**
     * Sets whether withCredentials on all XHR requests is true or false
     *
     * @default false
     * @param {boolean} value
     * @memberof module:MediaPlayer
     * @instance
     * @deprecated since version 2.4 - use setXHRWithCredentialsForType
     */
    function setXHRWithCredentials(value) {
        setXHRWithCredentialsForType(undefined, value);
    }

    /**
     * Sets whether withCredentials on XHR requests for a particular request
     * type is true or false
     *
     * @default false
     * @param {string} type - one of HTTPRequest.*_TYPE
     * @param {boolean} value
     * @memberof module:MediaPlayer
     * @instance
     */
    function setXHRWithCredentialsForType(type, value) {
        mediaPlayerModel.setXHRWithCredentialsForType(type, value);
    }

    /**
     * Gets whether withCredentials on XHR requests for a particular request
     * type is true or false
     *
     * @param {string} type - one of HTTPRequest.*_TYPE
     * @return {boolean}
     * @memberof module:MediaPlayer
     * @instance
     */
    function getXHRWithCredentialsForType(type) {
        return mediaPlayerModel.getXHRWithCredentialsForType(type);
    }

    /**
     * Detects if Protection is included and returns an instance of ProtectionController.js
     * @memberof module:MediaPlayer
     * @instance
     */
    function getProtectionController() {
        return detectProtection();
    }

    /**
     * Will override dash.js protection controller.
     * @param {ProtectionController} value - valid protection controller instance.
     * @memberof module:MediaPlayer
     * @instance
     */
    function attachProtectionController(value) {
        protectionController = value;
    }

    /**
     * @param {ProtectionData} value - object containing
     * property names corresponding to key system name strings and associated
     * values being instances of.
     * @memberof module:MediaPlayer
     * @instance
     */
    function setProtectionData(value) {
        protectionData = value;
    }

    /**
     * This method serves to control captions z-index value. If 'true' is passed, the captions will have the highest z-index and be
     * displayed on top of other html elements. Default value is 'false' (z-index is not set).
     * @param {boolean} value
     * @memberof module:MediaPlayer
     * @instance
     */
    function displayCaptionsOnTop(value) {
        var textTracks = (0, _textTextTracks2['default'])(context).getInstance();
        textTracks.setConfig({
            videoModel: videoModel
        });
        textTracks.initialize();
        textTracks.displayCConTop(value);
    }

    /**
     * Returns instance of Video Container that was attached by calling attachVideoContainer()
     * @returns {Object}
     * @memberof module:MediaPlayer
     * @instance
     */
    function getVideoContainer() {
        return videoModel ? videoModel.getVideoContainer() : null;
    }

    /**
     * Use this method to attach an HTML5 element that wraps the video element.
     *
     * @param {HTMLElement} container - The HTML5 element containing the video element.
     * @memberof module:MediaPlayer
     * @instance
     */
    function attachVideoContainer(container) {
        if (!videoModel) {
            throw ELEMENT_NOT_ATTACHED_ERROR;
        }
        videoModel.setVideoContainer(container);
    }

    /**
     * Returns instance of Video Element that was attached by calling attachView()
     * @returns {Object}
     * @memberof module:MediaPlayer
     * @instance
     */
    function getVideoElement() {
        if (!videoModel) {
            throw ELEMENT_NOT_ATTACHED_ERROR;
        }
        return videoModel.getElement();
    }

    /**
     * Use this method to attach an HTML5 VideoElement for dash.js to operate upon.
     *
     * @param {Object} element - An HTMLMediaElement that has already been defined in the DOM (or equivalent stub).
     * @memberof module:MediaPlayer
     * @instance
     */
    function attachView(element) {
        if (!mediaPlayerInitialized) {
            throw MEDIA_PLAYER_NOT_INITIALIZED_ERROR;
        }
        videoModel = null;
        if (element) {
            videoModel = (0, _modelsVideoModel2['default'])(context).getInstance();
            videoModel.initialize();
            videoModel.setElement(element);
            detectProtection();
            detectMetricsReporting();
            detectMss();
        }
        resetAndInitializePlayback();
    }

    /**
     * Returns instance of Div that was attached by calling attachTTMLRenderingDiv()
     * @returns {Object}
     * @memberof module:MediaPlayer
     * @instance
     */
    function getTTMLRenderingDiv() {
        return videoModel ? videoModel.getTTMLRenderingDiv() : null;
    }

    /**
     * Use this method to attach an HTML5 div for dash.js to render rich TTML subtitles.
     *
     * @param {HTMLDivElement} div - An unstyled div placed after the video element. It will be styled to match the video size and overlay z-order.
     * @memberof module:MediaPlayer
     * @instance
     */
    function attachTTMLRenderingDiv(div) {
        if (!videoModel) {
            throw ELEMENT_NOT_ATTACHED_ERROR;
        }
        videoModel.setTTMLRenderingDiv(div);
    }

    /**
     * Returns the source string or manifest that was attached by calling attachSource()
     * @returns {string | manifest}
     * @memberof module:MediaPlayer
     * @instance
     */
    function getSource() {
        if (!source) {
            throw SOURCE_NOT_ATTACHED_ERROR;
        }
        return source;
    }

    /**
     * Use this method to set a source URL to a valid MPD manifest file OR
     * a previously downloaded and parsed manifest object.  Optionally, can
     * also provide protection information
     *
     * @param {string|Object} urlOrManifest - A URL to a valid MPD manifest file, or a
     * parsed manifest object.
     *
     *
     * @throws "MediaPlayer not initialized!"
     *
     * @memberof module:MediaPlayer
     * @instance
     */
    function attachSource(urlOrManifest) {
        if (!mediaPlayerInitialized) {
            throw MEDIA_PLAYER_NOT_INITIALIZED_ERROR;
        }

        if (typeof urlOrManifest === 'string') {
            var uriQueryFragModel = (0, _modelsURIQueryAndFragmentModel2['default'])(context).getInstance();
            uriQueryFragModel.initialize();
            source = uriQueryFragModel.parseURI(urlOrManifest);
        } else {
            source = urlOrManifest;
        }

        resetAndInitializePlayback();
    }

    /**
     * Sets the MPD source and the video element to null. You can also reset the MediaPlayer by
     * calling attachSource with a new source file.
     *
     * @memberof module:MediaPlayer
     * @instance
     */
    function reset() {
        attachSource(null);
        attachView(null);
        protectionData = null;
        protectionController = null;
    }

    //***********************************
    // PRIVATE METHODS
    //***********************************

    function resetAndInitializePlayback() {
        if (playbackInitialized) {
            playbackInitialized = false;
            adapter.reset();
            streamController.reset();
            playbackController.reset();
            abrController.reset();
            mediaController.reset();
            textController.reset();
            streamController = null;
            metricsReportingController = null;
            if (isReady()) {
                initializePlayback();
            }
        } else if (isReady()) {
            initializePlayback();
        }
    }

    function createControllers() {

        var abrRulesCollection = (0, _rulesAbrABRRulesCollection2['default'])(context).getInstance();
        abrRulesCollection.initialize();

        var sourceBufferController = (0, _controllersSourceBufferController2['default'])(context).getInstance();
        sourceBufferController.setConfig({ dashManifestModel: dashManifestModel });

        mediaController.initialize();
        mediaController.setConfig({
            errHandler: errHandler
        });

        streamController = (0, _controllersStreamController2['default'])(context).getInstance();
        streamController.setConfig({
            capabilities: capabilities,
            manifestLoader: createManifestLoader(),
            manifestModel: (0, _modelsManifestModel2['default'])(context).getInstance(),
            dashManifestModel: dashManifestModel,
            protectionController: protectionController,
            adapter: adapter,
            metricsModel: metricsModel,
            dashMetrics: dashMetrics,
            liveEdgeFinder: (0, _utilsLiveEdgeFinder2['default'])(context).getInstance(),
            mediaSourceController: (0, _controllersMediaSourceController2['default'])(context).getInstance(),
            timeSyncController: (0, _controllersTimeSyncController2['default'])(context).getInstance(),
            baseURLController: (0, _controllersBaseURLController2['default'])(context).getInstance(),
            errHandler: errHandler,
            timelineConverter: (0, _dashUtilsTimelineConverter2['default'])(context).getInstance()
        });
        streamController.initialize(autoPlay, protectionData);

        abrController.setConfig({
            abrRulesCollection: abrRulesCollection,
            streamController: streamController
        });

        textController = (0, _textTextController2['default'])(context).getInstance();
        textController.setConfig({
            errHandler: errHandler,
            dashManifestModel: dashManifestModel,
            mediaController: mediaController,
            streamController: streamController,
            videoModel: videoModel
        });
    }

    function createManifestLoader() {
        return (0, _ManifestLoader2['default'])(context).create({
            errHandler: errHandler,
            metricsModel: metricsModel,
            requestModifier: (0, _utilsRequestModifier2['default'])(context).getInstance(),
            mssHandler: mssHandler
        });
    }

    function createAdaptor() {
        //TODO-Refactor Need to be able to switch this create out so will need API to set which adapter to use? Handler is created is inside streamProcessor so need to figure that out as well
        adapter = (0, _dashDashAdapter2['default'])(context).getInstance();
        adapter.initialize();
        adapter.setConfig({
            dashManifestModel: dashManifestModel
        });
        return adapter;
    }

    function detectProtection() {
        if (protectionController) {
            return protectionController;
        }
        // do not require Protection as dependencies as this is optional and intended to be loaded separately
        var Protection = dashjs.Protection; /* jshint ignore:line */
        if (typeof Protection === 'function') {
            //TODO need a better way to register/detect plugin components
            var protection = Protection(context).create();
            _coreEventsEvents2['default'].extend(Protection.events);
            _MediaPlayerEvents2['default'].extend(Protection.events, {
                publicOnly: true
            });
            protectionController = protection.createProtectionSystem({
                log: log,
                videoModel: videoModel,
                capabilities: capabilities,
                eventBus: eventBus,
                adapter: adapter
            });
            return protectionController;
        }

        return null;
    }

    function detectMetricsReporting() {
        if (metricsReportingController) {
            return metricsReportingController;
        }
        // do not require MetricsReporting as dependencies as this is optional and intended to be loaded separately
        var MetricsReporting = dashjs.MetricsReporting; /* jshint ignore:line */
        if (typeof MetricsReporting === 'function') {
            //TODO need a better way to register/detect plugin components
            var metricsReporting = MetricsReporting(context).create();

            metricsReportingController = metricsReporting.createMetricsReporting({
                log: log,
                eventBus: eventBus,
                mediaElement: getVideoElement(),
                dashManifestModel: dashManifestModel,
                metricsModel: metricsModel
            });

            return metricsReportingController;
        }

        return null;
    }

    function detectMss() {
        if (mssHandler) {
            return mssHandler;
        }
        // do not require MssHandler as dependencies as this is optional and intended to be loaded separately
        var MssHandler = dashjs.MssHandler; /* jshint ignore:line */
        if (typeof MssHandler === 'function') {
            //TODO need a better way to register/detect plugin components
            mssHandler = MssHandler(context).create({
                eventBus: eventBus,
                mediaPlayerModel: mediaPlayerModel
            });
            return mssHandler;
        }

        return null;
    }

    function getDVRInfoMetric() {
        var metric = metricsModel.getReadOnlyMetricsFor('video') || metricsModel.getReadOnlyMetricsFor('audio');
        return dashMetrics.getCurrentDVRInfo(metric);
    }

    function getAsUTC(valToConvert) {
        var metric = getDVRInfoMetric();
        var availableFrom, utcValue;

        if (!metric) {
            return 0;
        }
        availableFrom = metric.manifestInfo.availableFrom.getTime() / 1000;
        utcValue = valToConvert + (availableFrom + metric.range.start);
        return utcValue;
    }

    function getActiveStream() {
        if (!playbackInitialized) {
            throw PLAYBACK_NOT_INITIALIZED_ERROR;
        }
        var streamInfo = streamController.getActiveStreamInfo();
        return streamInfo ? streamController.getStreamById(streamInfo.id) : null;
    }

    function initializePlayback() {
        if (!playbackInitialized) {
            playbackInitialized = true;
            log('Playback Initialized');
            createControllers();
            if (typeof source === 'string') {
                streamController.load(source);
            } else {
                streamController.loadWithManifest(source);
            }
        }
    }

    instance = {
        initialize: initialize,
        on: on,
        off: off,
        extend: extend,
        attachView: attachView,
        attachSource: attachSource,
        isReady: isReady,
        play: play,
        isPaused: isPaused,
        pause: pause,
        isSeeking: isSeeking,
        isDynamic: isDynamic,
        seek: seek,
        setMute: setMute,
        isMuted: isMuted,
        setVolume: setVolume,
        getVolume: getVolume,
        time: time,
        duration: duration,
        timeAsUTC: timeAsUTC,
        durationAsUTC: durationAsUTC,
        getActiveStream: getActiveStream,
        getDVRWindowSize: getDVRWindowSize,
        getDVRSeekOffset: getDVRSeekOffset,
        convertToTimeCode: convertToTimeCode,
        formatUTC: formatUTC,
        getVersion: getVersion,
        getDebug: getDebug,
        getBufferLength: getBufferLength,
        getVideoModel: getVideoModel,
        getVideoContainer: getVideoContainer,
        getTTMLRenderingDiv: getTTMLRenderingDiv,
        getVideoElement: getVideoElement,
        getSource: getSource,
        setLiveDelayFragmentCount: setLiveDelayFragmentCount,
        setLiveDelay: setLiveDelay,
        getLiveDelay: getLiveDelay,
        useSuggestedPresentationDelay: useSuggestedPresentationDelay,
        enableLastBitrateCaching: enableLastBitrateCaching,
        enableLastMediaSettingsCaching: enableLastMediaSettingsCaching,
        setMaxAllowedBitrateFor: setMaxAllowedBitrateFor,
        getMaxAllowedBitrateFor: getMaxAllowedBitrateFor,
        setMinAllowedBitrateFor: setMinAllowedBitrateFor,
        getMinAllowedBitrateFor: getMinAllowedBitrateFor,
        setMaxAllowedRepresentationRatioFor: setMaxAllowedRepresentationRatioFor,
        getMaxAllowedRepresentationRatioFor: getMaxAllowedRepresentationRatioFor,
        setAutoPlay: setAutoPlay,
        getAutoPlay: getAutoPlay,
        setScheduleWhilePaused: setScheduleWhilePaused,
        getScheduleWhilePaused: getScheduleWhilePaused,
        getDashMetrics: getDashMetrics,
        getMetricsFor: getMetricsFor,
        getQualityFor: getQualityFor,
        setQualityFor: setQualityFor,
        updatePortalSize: updatePortalSize,
        getLimitBitrateByPortal: getLimitBitrateByPortal,
        setLimitBitrateByPortal: setLimitBitrateByPortal,
        getUsePixelRatioInLimitBitrateByPortal: getUsePixelRatioInLimitBitrateByPortal,
        setUsePixelRatioInLimitBitrateByPortal: setUsePixelRatioInLimitBitrateByPortal,
        setTextTrack: setTextTrack,
        getBitrateInfoListFor: getBitrateInfoListFor,
        setInitialBitrateFor: setInitialBitrateFor,
        getInitialBitrateFor: getInitialBitrateFor,
        setInitialRepresentationRatioFor: setInitialRepresentationRatioFor,
        getInitialRepresentationRatioFor: getInitialRepresentationRatioFor,
        getStreamsFromManifest: getStreamsFromManifest,
        getTracksFor: getTracksFor,
        getTracksForTypeFromManifest: getTracksForTypeFromManifest,
        getCurrentTrackFor: getCurrentTrackFor,
        setInitialMediaSettingsFor: setInitialMediaSettingsFor,
        getInitialMediaSettingsFor: getInitialMediaSettingsFor,
        setCurrentTrack: setCurrentTrack,
        getTrackSwitchModeFor: getTrackSwitchModeFor,
        setTrackSwitchModeFor: setTrackSwitchModeFor,
        setSelectionModeForInitialTrack: setSelectionModeForInitialTrack,
        getSelectionModeForInitialTrack: getSelectionModeForInitialTrack,
        getAutoSwitchQuality: getAutoSwitchQuality,
        setAutoSwitchQuality: setAutoSwitchQuality,
        setFastSwitchEnabled: setFastSwitchEnabled,
        getFastSwitchEnabled: getFastSwitchEnabled,
        getAutoSwitchQualityFor: getAutoSwitchQualityFor,
        setAutoSwitchQualityFor: setAutoSwitchQualityFor,
        enableBufferOccupancyABR: enableBufferOccupancyABR,
        setBandwidthSafetyFactor: setBandwidthSafetyFactor,
        getBandwidthSafetyFactor: getBandwidthSafetyFactor,
        setAbandonLoadTimeout: setAbandonLoadTimeout,
        retrieveManifest: retrieveManifest,
        addUTCTimingSource: addUTCTimingSource,
        removeUTCTimingSource: removeUTCTimingSource,
        clearDefaultUTCTimingSources: clearDefaultUTCTimingSources,
        restoreDefaultUTCTimingSources: restoreDefaultUTCTimingSources,
        setBufferToKeep: setBufferToKeep,
        setBufferPruningInterval: setBufferPruningInterval,
        setStableBufferTime: setStableBufferTime,
        setBufferTimeAtTopQuality: setBufferTimeAtTopQuality,
        setFragmentLoaderRetryAttempts: setFragmentLoaderRetryAttempts,
        setFragmentLoaderRetryInterval: setFragmentLoaderRetryInterval,
        setXHRWithCredentials: setXHRWithCredentials,
        setXHRWithCredentialsForType: setXHRWithCredentialsForType,
        getXHRWithCredentialsForType: getXHRWithCredentialsForType,
        setBufferTimeAtTopQualityLongForm: setBufferTimeAtTopQualityLongForm,
        setLongFormContentDurationThreshold: setLongFormContentDurationThreshold,
        setRichBufferThreshold: setRichBufferThreshold,
        getProtectionController: getProtectionController,
        attachProtectionController: attachProtectionController,
        setProtectionData: setProtectionData,
        enableManifestDateHeaderTimeSource: enableManifestDateHeaderTimeSource,
        displayCaptionsOnTop: displayCaptionsOnTop,
        attachVideoContainer: attachVideoContainer,
        attachTTMLRenderingDiv: attachTTMLRenderingDiv,
        getCurrentTextTrackIndex: getCurrentTextTrackIndex,
        reset: reset
    };

    setup();

    return instance;
}

MediaPlayer.__dashjs_factory_name = 'MediaPlayer';
var factory = _coreFactoryMaker2['default'].getClassFactory(MediaPlayer);
factory.events = _MediaPlayerEvents2['default'];
exports['default'] = factory;
module.exports = exports['default'];
//# sourceMappingURL=MediaPlayer.js.map


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _handlersBufferLevelHandler = __webpack_require__(1365);

var _handlersBufferLevelHandler2 = _interopRequireDefault(_handlersBufferLevelHandler);

var _handlersDVBErrorsHandler = __webpack_require__(1366);

var _handlersDVBErrorsHandler2 = _interopRequireDefault(_handlersDVBErrorsHandler);

var _handlersHttpListHandler = __webpack_require__(1368);

var _handlersHttpListHandler2 = _interopRequireDefault(_handlersHttpListHandler);

var _handlersGenericMetricHandler = __webpack_require__(1367);

var _handlersGenericMetricHandler2 = _interopRequireDefault(_handlersGenericMetricHandler);

function MetricsHandlerFactory(config) {

    var instance = undefined;
    var log = config.log;

    // group 1: key, [group 3: n [, group 5: type]]
    var keyRegex = /([a-zA-Z]*)(\(([0-9]*)(\,\s*([a-zA-Z]*))?\))?/;

    var context = this.context;
    var knownFactoryProducts = {
        BufferLevel: _handlersBufferLevelHandler2['default'],
        DVBErrors: _handlersDVBErrorsHandler2['default'],
        HttpList: _handlersHttpListHandler2['default'],
        PlayList: _handlersGenericMetricHandler2['default'],
        RepSwitchList: _handlersGenericMetricHandler2['default'],
        TcpList: _handlersGenericMetricHandler2['default']
    };

    function create(listType, reportingController) {
        var matches = listType.match(keyRegex);
        var handler;

        if (!matches) {
            return;
        }

        try {
            handler = knownFactoryProducts[matches[1]](context).create({
                eventBus: config.eventBus
            });

            handler.initialize(matches[1], reportingController, matches[3], matches[5]);
        } catch (e) {
            handler = null;

            log('MetricsHandlerFactory: Could not create handler for type ' + matches[1] + ' with args ' + matches[3] + ', ' + matches[5] + ' (' + e.message + ')');
        }

        return handler;
    }

    function register(key, handler) {
        knownFactoryProducts[key] = handler;
    }

    function unregister(key) {
        delete knownFactoryProducts[key];
    }

    instance = {
        create: create,
        register: register,
        unregister: unregister
    };

    return instance;
}

MetricsHandlerFactory.__dashjs_factory_name = 'MetricsHandlerFactory';
exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(MetricsHandlerFactory);
module.exports = exports['default'];
//# sourceMappingURL=MetricsHandlerFactory.js.map


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _reportersDVBReporting = __webpack_require__(1369);

var _reportersDVBReporting2 = _interopRequireDefault(_reportersDVBReporting);

function ReportingFactory(config) {

    var knownReportingSchemeIdUris = {
        'urn:dvb:dash:reporting:2014': _reportersDVBReporting2['default']
    };

    var context = this.context;
    var log = config.log;
    var instance = undefined;

    function create(entry, rangeController) {
        var reporting;

        try {
            reporting = knownReportingSchemeIdUris[entry.schemeIdUri](context).create();

            reporting.initialize(entry, rangeController);
        } catch (e) {
            reporting = null;

            log('ReportingFactory: could not create Reporting with schemeIdUri ' + entry.schemeIdUri + ' (' + e.message + ')');
        }

        return reporting;
    }

    function register(schemeIdUri, moduleName) {
        knownReportingSchemeIdUris[schemeIdUri] = moduleName;
    }

    function unregister(schemeIdUri) {
        delete knownReportingSchemeIdUris[schemeIdUri];
    }

    instance = {
        create: create,
        register: register,
        unregister: unregister
    };

    return instance;
}

ReportingFactory.__dashjs_factory_name = 'ReportingFactory';
exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(ReportingFactory);
module.exports = exports['default'];
//# sourceMappingURL=ReportingFactory.js.map


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

function HandlerHelpers() {
    return {
        reconstructFullMetricName: function reconstructFullMetricName(key, n, type) {
            var mn = key;

            if (n) {
                mn += '(' + n;

                if (type && type.length) {
                    mn += ',' + type;
                }

                mn += ')';
            }

            return mn;
        },

        validateN: function validateN(n_ms) {
            if (!n_ms) {
                throw new Error('missing n');
            }

            if (isNaN(n_ms)) {
                throw new Error('n is NaN');
            }

            // n is a positive integer is defined to refer to the metric
            // in which the buffer level is recorded every n ms.
            if (n_ms < 0) {
                throw new Error('n must be positive');
            }

            return n_ms;
        }
    };
}

HandlerHelpers.__dashjs_factory_name = 'HandlerHelpers';
exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(HandlerHelpers);
module.exports = exports['default'];
//# sourceMappingURL=HandlerHelpers.js.map


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _controllersProtectionController = __webpack_require__(1380);

var _controllersProtectionController2 = _interopRequireDefault(_controllersProtectionController);

var _controllersProtectionKeyController = __webpack_require__(326);

var _controllersProtectionKeyController2 = _interopRequireDefault(_controllersProtectionKeyController);

var _ProtectionEvents = __webpack_require__(1379);

var _ProtectionEvents2 = _interopRequireDefault(_ProtectionEvents);

var _modelsProtectionModel_21Jan2015 = __webpack_require__(1385);

var _modelsProtectionModel_21Jan20152 = _interopRequireDefault(_modelsProtectionModel_21Jan2015);

var _modelsProtectionModel_3Feb2014 = __webpack_require__(1386);

var _modelsProtectionModel_3Feb20142 = _interopRequireDefault(_modelsProtectionModel_3Feb2014);

var _modelsProtectionModel_01b = __webpack_require__(1384);

var _modelsProtectionModel_01b2 = _interopRequireDefault(_modelsProtectionModel_01b);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var APIS_ProtectionModel_01b = [
// Un-prefixed as per spec
{
    // Video Element
    generateKeyRequest: 'generateKeyRequest',
    addKey: 'addKey',
    cancelKeyRequest: 'cancelKeyRequest',

    // Events
    needkey: 'needkey',
    keyerror: 'keyerror',
    keyadded: 'keyadded',
    keymessage: 'keymessage'
},
// Webkit-prefixed (early Chrome versions and Chrome with EME disabled in chrome://flags)
{
    // Video Element
    generateKeyRequest: 'webkitGenerateKeyRequest',
    addKey: 'webkitAddKey',
    cancelKeyRequest: 'webkitCancelKeyRequest',

    // Events
    needkey: 'webkitneedkey',
    keyerror: 'webkitkeyerror',
    keyadded: 'webkitkeyadded',
    keymessage: 'webkitkeymessage'
}];

var APIS_ProtectionModel_3Feb2014 = [
// Un-prefixed as per spec
// Chrome 38-39 (and some earlier versions) with chrome://flags -- Enable Encrypted Media Extensions
{
    // Video Element
    setMediaKeys: 'setMediaKeys',
    // MediaKeys
    MediaKeys: 'MediaKeys',
    // MediaKeySession
    release: 'close',

    // Events
    needkey: 'needkey',
    error: 'keyerror',
    message: 'keymessage',
    ready: 'keyadded',
    close: 'keyclose'
},
// MS-prefixed (IE11, Windows 8.1)
{
    // Video Element
    setMediaKeys: 'msSetMediaKeys',
    // MediaKeys
    MediaKeys: 'MSMediaKeys',
    // MediaKeySession
    release: 'close',
    // Events
    needkey: 'msneedkey',
    error: 'mskeyerror',
    message: 'mskeymessage',
    ready: 'mskeyadded',
    close: 'mskeyclose'
}];

function Protection() {

    var instance = undefined;
    var context = this.context;

    /**
     * Create a ProtectionController and associated ProtectionModel for use with
     * a single piece of content.
     *
     * @param {Object} config
     * @return {ProtectionController} protection controller
     *
     */
    function createProtectionSystem(config) {

        var controller = null;

        var protectionKeyController = (0, _controllersProtectionKeyController2['default'])(context).getInstance();
        protectionKeyController.setConfig({ log: config.log });
        protectionKeyController.initialize();

        var protectionModel = getProtectionModel(config);

        if (!controller && protectionModel) {
            //TODO add ability to set external controller if still needed at all?
            controller = (0, _controllersProtectionController2['default'])(context).create({
                protectionModel: protectionModel,
                protectionKeyController: protectionKeyController,
                adapter: config.adapter,
                eventBus: config.eventBus,
                log: config.log
            });
            config.capabilities.setEncryptedMediaSupported(true);
        }
        return controller;
    }

    function getProtectionModel(config) {

        var log = config.log;
        var eventBus = config.eventBus;
        var videoElement = config.videoModel.getElement();

        if (videoElement.onencrypted !== undefined && videoElement.mediaKeys !== undefined && navigator.requestMediaKeySystemAccess !== undefined && typeof navigator.requestMediaKeySystemAccess === 'function') {

            log('EME detected on this user agent! (ProtectionModel_21Jan2015)');
            return (0, _modelsProtectionModel_21Jan20152['default'])(context).create({ log: log, eventBus: eventBus });
        } else if (getAPI(videoElement, APIS_ProtectionModel_3Feb2014)) {

            log('EME detected on this user agent! (ProtectionModel_3Feb2014)');
            return (0, _modelsProtectionModel_3Feb20142['default'])(context).create({ log: log, eventBus: eventBus, api: getAPI(videoElement, APIS_ProtectionModel_3Feb2014) });
        } else if (getAPI(videoElement, APIS_ProtectionModel_01b)) {

            log('EME detected on this user agent! (ProtectionModel_01b)');
            return (0, _modelsProtectionModel_01b2['default'])(context).create({ log: log, eventBus: eventBus, api: getAPI(videoElement, APIS_ProtectionModel_01b) });
        } else {

            log('No supported version of EME detected on this user agent! - Attempts to play encrypted content will fail!');
            return null;
        }
    }

    function getAPI(videoElement, apis) {

        for (var i = 0; i < apis.length; i++) {
            var api = apis[i];
            // detect if api is supported by browser
            // check only first function in api -> should be fine
            if (typeof videoElement[api[Object.keys(api)[0]]] !== 'function') {
                continue;
            }

            return api;
        }

        return null;
    }

    instance = {
        createProtectionSystem: createProtectionSystem
    };

    return instance;
}

Protection.__dashjs_factory_name = 'Protection';
var factory = _coreFactoryMaker2['default'].getClassFactory(Protection);
factory.events = _ProtectionEvents2['default'];
exports['default'] = factory;
module.exports = exports['default'];
//# sourceMappingURL=Protection.js.map


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @classdesc A collection of ClearKey encryption keys with an (optional) associated
 *  type
 * @ignore
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var ClearKeyKeySet = (function () {
    /**
     * @param {Array.<KeyPair>} keyPairs
     * @param {string} type the type of keys in this set.  One of either 'persistent'
     * or 'temporary'.  Can also be null or undefined.
     * @class
     * @ignore
     */

    function ClearKeyKeySet(keyPairs, type) {
        _classCallCheck(this, ClearKeyKeySet);

        if (type && type !== 'persistent' && type !== 'temporary') throw new Error('Invalid ClearKey key set type!  Must be one of \'persistent\' or \'temporary\'');
        this.keyPairs = keyPairs;
        this.type = type;
    }

    /**
     * Convert this key set to its JSON Web Key (JWK) representation
     *
     * @return {ArrayBuffer} JWK object UTF-8 encoded as ArrayBuffer
     */

    _createClass(ClearKeyKeySet, [{
        key: 'toJWK',
        value: function toJWK() {
            var i;
            var numKeys = this.keyPairs.length;
            var jwk = { keys: [] };

            for (i = 0; i < numKeys; i++) {
                var key = {
                    kty: 'oct',
                    alg: 'A128KW',
                    kid: this.keyPairs[i].keyID,
                    k: this.keyPairs[i].key
                };
                jwk.keys.push(key);
            }
            if (this.type) {
                jwk.type = this.type;
            }
            var jwkString = JSON.stringify(jwk);
            var len = jwkString.length;

            // Convert JSON string to ArrayBuffer
            var buf = new ArrayBuffer(len);
            var bView = new Uint8Array(buf);
            for (i = 0; i < len; i++) bView[i] = jwkString.charCodeAt(i);
            return buf;
        }
    }]);

    return ClearKeyKeySet;
})();

exports['default'] = ClearKeyKeySet;
module.exports = exports['default'];
//# sourceMappingURL=ClearKeyKeySet.js.map


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @classdesc Represents a 128-bit keyID and 128-bit encryption key
 * @ignore
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KeyPair =
/**
 * @param {string} keyID 128-bit key ID, base64 encoded, with no padding
 * @param {string} key 128-bit encryption key, base64 encoded, with no padding
 * @class
 * @ignore
 */
function KeyPair(keyID, key) {
  _classCallCheck(this, KeyPair);

  this.keyID = keyID;
  this.key = key;
};

exports["default"] = KeyPair;
module.exports = exports["default"];
//# sourceMappingURL=KeyPair.js.map


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2016, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

// For a description of the BOLA adaptive bitrate (ABR) algorithm, see http://arxiv.org/abs/1601.06748



Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _SwitchRequest = __webpack_require__(128);

var _SwitchRequest2 = _interopRequireDefault(_SwitchRequest);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _modelsMediaPlayerModel = __webpack_require__(67);

var _modelsMediaPlayerModel2 = _interopRequireDefault(_modelsMediaPlayerModel);

var _voMetricsHTTPRequest = __webpack_require__(84);

var _dashDashAdapter = __webpack_require__(394);

var _dashDashAdapter2 = _interopRequireDefault(_dashDashAdapter);

var _coreEventBus = __webpack_require__(27);

var _coreEventBus2 = _interopRequireDefault(_coreEventBus);

var _coreEventsEvents = __webpack_require__(22);

var _coreEventsEvents2 = _interopRequireDefault(_coreEventsEvents);

var _coreDebug = __webpack_require__(30);

var _coreDebug2 = _interopRequireDefault(_coreDebug);

// BOLA_STATE_ONE_BITRATE   : If there is only one bitrate (or initialization failed), always return NO_CHANGE.
// BOLA_STATE_STARTUP       : Set placeholder buffer such that we download fragments at most recently measured throughput.
// BOLA_STATE_STEADY        : Buffer primed, we switch to steady operation.
// TODO: add BOLA_STATE_SEEK and tune Bola behavior on seeking
var BOLA_STATE_ONE_BITRATE = 0;
var BOLA_STATE_STARTUP = 1;
var BOLA_STATE_STEADY = 2;
var BOLA_DEBUG = false; // TODO: remove

var MINIMUM_BUFFER_S = 10; // BOLA should never add artificial delays if buffer is less than MINIMUM_BUFFER_S.
var BUFFER_TARGET_S = 30; // If Schedule Controller does not allow buffer level to reach BUFFER_TARGET_S, this can be a placeholder buffer level.
var REBUFFER_SAFETY_FACTOR = 0.5; // Used when buffer level is dangerously low, might happen often in live streaming.

function BolaRule(config) {

    var AVERAGE_THROUGHPUT_SAMPLE_AMOUNT_LIVE = 2;
    var AVERAGE_THROUGHPUT_SAMPLE_AMOUNT_VOD = 3;

    var context = this.context;
    var log = (0, _coreDebug2['default'])(context).getInstance().log;
    var dashMetrics = config.dashMetrics;
    var metricsModel = config.metricsModel;
    var eventBus = (0, _coreEventBus2['default'])(context).getInstance();

    var instance = undefined,
        lastCallTimeDict = undefined,
        lastFragmentLoadedDict = undefined,
        lastFragmentWasSwitchDict = undefined,
        eventMediaTypes = undefined,
        mediaPlayerModel = undefined,
        adapter = undefined;

    function setup() {
        lastCallTimeDict = {};
        lastFragmentLoadedDict = {};
        lastFragmentWasSwitchDict = {};
        eventMediaTypes = [];
        mediaPlayerModel = (0, _modelsMediaPlayerModel2['default'])(context).getInstance();
        adapter = (0, _dashDashAdapter2['default'])(context).getInstance();
        eventBus.on(_coreEventsEvents2['default'].BUFFER_EMPTY, onBufferEmpty, instance);
        eventBus.on(_coreEventsEvents2['default'].PLAYBACK_SEEKING, onPlaybackSeeking, instance);
        eventBus.on(_coreEventsEvents2['default'].PERIOD_SWITCH_STARTED, onPeriodSwitchStarted, instance);
        eventBus.on(_coreEventsEvents2['default'].MEDIA_FRAGMENT_LOADED, onMediaFragmentLoaded, instance);
    }

    function utilitiesFromBitrates(bitrates) {
        return bitrates.map(function (b) {
            return Math.log(b);
        });
        // no need to worry about offset, any offset will be compensated for by gp
    }

    // NOTE: in live streaming, the real buffer level can drop below minimumBufferS, but bola should not stick to lowest bitrate by using a placeholder buffer level
    function calculateParameters(minimumBufferS, bufferTargetS, bitrates, utilities) {
        var highestUtilityIndex = NaN;
        if (!utilities) {
            utilities = utilitiesFromBitrates(bitrates);
            highestUtilityIndex = utilities.length - 1;
        } else {
            highestUtilityIndex = 0;
            utilities.forEach(function (u, i) {
                if (u > utilities[highestUtilityIndex]) highestUtilityIndex = i;
            });
        }

        if (highestUtilityIndex === 0) {
            // if highestUtilityIndex === 0, then always use lowest bitrate
            return null;
        }

        // TODO: Investigate if following can be better if utilities are not the default Math.log utilities.
        // If using Math.log utilities, we can choose Vp and gp to always prefer bitrates[0] at minimumBufferS and bitrates[max] at bufferTargetS.
        // (Vp * (utility + gp) - bufferLevel) / bitrate has the maxima described when:
        // Vp * (utilities[0] + gp - 1) = minimumBufferS and Vp * (utilities[max] + gp - 1) = bufferTargetS
        // giving:
        var gp = 1 - utilities[0] + (utilities[highestUtilityIndex] - utilities[0]) / (bufferTargetS / minimumBufferS - 1);
        var Vp = minimumBufferS / (utilities[0] + gp - 1);

        return { utilities: utilities, gp: gp, Vp: Vp };
    }

    function calculateInitialState(rulesContext) {
        var initialState = {};

        var mediaInfo = rulesContext.getMediaInfo();

        var streamProcessor = rulesContext.getStreamProcessor();
        var streamInfo = rulesContext.getStreamInfo();
        var trackInfo = rulesContext.getTrackInfo();

        var isDynamic = streamProcessor.isDynamic();
        var duration = streamInfo.manifestInfo.duration;
        var fragmentDuration = trackInfo.fragmentDuration;

        var bitrates = mediaInfo.bitrateList.map(function (b) {
            return b.bandwidth;
        });
        var params = calculateParameters(MINIMUM_BUFFER_S, BUFFER_TARGET_S, bitrates, null);
        if (params === null) {
            // The best soloution is to always use the lowest bitrate...
            initialState.state = BOLA_STATE_ONE_BITRATE;
            return initialState;
        }

        initialState.state = BOLA_STATE_STARTUP;

        initialState.bitrates = bitrates;
        initialState.utilities = params.utilities;
        initialState.Vp = params.Vp;
        initialState.gp = params.gp;

        initialState.isDynamic = isDynamic;
        initialState.movieDuration = duration;
        initialState.fragmentDuration = fragmentDuration;
        initialState.bandwidthSafetyFactor = mediaPlayerModel.getBandwidthSafetyFactor();
        initialState.rebufferSafetyFactor = REBUFFER_SAFETY_FACTOR;
        initialState.bufferTarget = mediaPlayerModel.getStableBufferTime();

        initialState.lastQuality = 0;
        initialState.placeholderBuffer = 0;
        initialState.throughputCount = isDynamic ? AVERAGE_THROUGHPUT_SAMPLE_AMOUNT_LIVE : AVERAGE_THROUGHPUT_SAMPLE_AMOUNT_VOD;

        if (BOLA_DEBUG) {
            var info = '';
            for (var i = 0; i < bitrates.length; ++i) {
                var u = params.utilities[i];
                var b = bitrates[i];
                var th = 0;
                if (i > 0) {
                    var u1 = params.utilities[i - 1];
                    var b1 = bitrates[i - 1];
                    th = params.Vp * ((u1 * b - u * b1) / (b - b1) + params.gp);
                }
                var z = params.Vp * (u + params.gp);
                info += '\n' + i + ':' + (0.000001 * bitrates[i]).toFixed(3) + 'Mbps ' + th.toFixed(3) + '/' + z.toFixed(3);
            }
            log('BolaDebug ' + mediaInfo.type + ' bitrates' + info);
        }

        return initialState;
    }

    function getQualityFromBufferLevel(bolaState, bufferLevel) {
        var bitrateCount = bolaState.bitrates.length;
        var quality = NaN;
        var score = NaN;
        for (var i = 0; i < bitrateCount; ++i) {
            var s = (bolaState.Vp * (bolaState.utilities[i] + bolaState.gp) - bufferLevel) / bolaState.bitrates[i];
            if (isNaN(score) || s >= score) {
                score = s;
                quality = i;
            }
        }
        return quality;
    }

    function getLastHttpRequests(metrics, count) {
        var allHttpRequests = dashMetrics.getHttpRequests(metrics);
        var httpRequests = [];

        for (var i = allHttpRequests.length - 1; i >= 0 && httpRequests.length < count; --i) {
            var request = allHttpRequests[i];
            if (request.type === _voMetricsHTTPRequest.HTTPRequest.MEDIA_SEGMENT_TYPE && request._tfinish && request.tresponse && request.trace) {
                httpRequests.push(request);
            }
        }

        return httpRequests;
    }

    function getRecentThroughput(metrics, count, mediaType) {
        // TODO: mediaType only used for debugging, remove it
        var lastRequests = getLastHttpRequests(metrics, count);
        if (lastRequests.length === 0) {
            return 0;
        }

        var totalInverse = 0;
        var msg = '';
        for (var i = 0; i < lastRequests.length; ++i) {
            // The RTT delay results in a lower throughput. We can avoid this delay in the calculation, but we do not want to.
            var downloadSeconds = 0.001 * (lastRequests[i]._tfinish.getTime() - lastRequests[i].trequest.getTime());
            var downloadBits = 8 * lastRequests[i].trace.reduce(function (prev, cur) {
                return prev + cur.b[0];
            }, 0);
            if (BOLA_DEBUG) msg += ' ' + (0.000001 * downloadBits).toFixed(3) + '/' + downloadSeconds.toFixed(3) + '=' + (0.000001 * downloadBits / downloadSeconds).toFixed(3) + 'Mbps';
            totalInverse += downloadSeconds / downloadBits;
        }

        if (BOLA_DEBUG) log('BolaDebug ' + mediaType + ' BolaRule recent throughput = ' + (lastRequests.length / (1000000 * totalInverse)).toFixed(3) + 'Mbps:' + msg);

        return lastRequests.length / totalInverse;
    }

    function getQualityFromThroughput(bolaState, throughput) {
        // do not factor in bandwidthSafetyFactor here - it is factored at point of function invocation

        var q = 0;

        bolaState.bitrates.some(function (value, index) {
            if (value > throughput) {
                return true;
            }
            q = index;
            return false;
        });

        return q;
    }

    function getPlaceholderIncrementInSeconds(metrics, mediaType) {
        // find out if there was delay because of
        // 1. lack of availability in live streaming or
        // 2. bufferLevel > bufferTarget or
        // 3. fast switching

        var nowMs = Date.now();
        var lctMs = lastCallTimeDict[mediaType];
        var wasSwitch = lastFragmentWasSwitchDict[mediaType];
        var lastRequestFinishMs = NaN;

        lastCallTimeDict[mediaType] = nowMs;
        lastFragmentWasSwitchDict[mediaType] = false;

        if (!wasSwitch) {
            var lastRequests = getLastHttpRequests(metrics, 1);
            if (lastRequests.length > 0) {
                lastRequestFinishMs = lastRequests[0]._tfinish.getTime();
                if (lastRequestFinishMs > nowMs) {
                    // this shouldn't happen, try to handle gracefully
                    lastRequestFinishMs = nowMs;
                }
            }
        }

        // return the time since the finish of the last request.
        // The return will be added cumulatively to the placeholder buffer, so we must be sure not to add the same delay twice.

        var delayMs = 0;
        if (wasSwitch || lctMs > lastRequestFinishMs) {
            delayMs = nowMs - lctMs;
        } else {
            delayMs = nowMs - lastRequestFinishMs;
        }

        if (isNaN(delayMs) || delayMs <= 0) return 0;
        return 0.001 * delayMs;
    }

    function onBufferEmpty() {
        if (BOLA_DEBUG) log('BolaDebug BUFFER_EMPTY');
        // if we rebuffer, we don't want the placeholder buffer to artificially raise BOLA quality
        eventMediaTypes.forEach(function (mediaType) {
            var metrics = metricsModel.getReadOnlyMetricsFor(mediaType);
            if (metrics.BolaState.length !== 0) {
                var bolaState = metrics.BolaState[0]._s;
                if (bolaState.state === BOLA_STATE_STEADY) {
                    bolaState.placeholderBuffer = 0;
                    metricsModel.updateBolaState(mediaType, bolaState);
                }
            }
        });
    }

    function onPlaybackSeeking(e) {
        if (BOLA_DEBUG) log('BolaDebug PLAYBACK_SEEKING ' + e.seekTime.toFixed(3));
        // TODO: 1. Verify what happens if we seek mid-fragment.
        // TODO: 2. If e.g. we have 10s fragments and seek, we might want to download the first fragment at a lower quality to restart playback quickly.
        eventMediaTypes.forEach(function (mediaType) {
            var metrics = metricsModel.getReadOnlyMetricsFor(mediaType);
            if (metrics.BolaState.length !== 0) {
                var bolaState = metrics.BolaState[0]._s;
                if (bolaState.state !== BOLA_STATE_ONE_BITRATE) {
                    bolaState.state = BOLA_STATE_STARTUP;
                }
                metricsModel.updateBolaState(mediaType, bolaState);
            }
        });

        lastFragmentLoadedDict = {};
        lastFragmentWasSwitchDict = {};
    }

    function onPeriodSwitchStarted() {
        // TODO
    }

    function onMediaFragmentLoaded(e) {
        if (e && e.chunk && e.chunk.mediaInfo) {
            var type = e.chunk.mediaInfo.type;
            var start = e.chunk.start;
            if (type !== undefined && !isNaN(start)) {
                if (start <= lastFragmentLoadedDict[type]) {
                    lastFragmentWasSwitchDict[type] = true;
                    // keep lastFragmentLoadedDict[type] e.g. last fragment start 10, switch fragment 8, last is still 10
                } else {
                        // isNaN(lastFragmentLoadedDict[type]) also falls here
                        lastFragmentWasSwitchDict[type] = false;
                        lastFragmentLoadedDict[type] = start;
                    }
            }
        }
    }

    function getMaxIndex(rulesContext) {
        var streamProcessor = rulesContext.getStreamProcessor();
        streamProcessor.getScheduleController().setTimeToLoadDelay(0);

        var switchRequest = (0, _SwitchRequest2['default'])(context).create(_SwitchRequest2['default'].NO_CHANGE, { name: BolaRule.__dashjs_factory_name });
        var mediaInfo = rulesContext.getMediaInfo();
        var mediaType = mediaInfo.type;
        var metrics = metricsModel.getReadOnlyMetricsFor(mediaType);

        if (metrics.BolaState.length === 0) {
            // initialization

            if (BOLA_DEBUG) log('BolaDebug ' + mediaType + '\nBolaDebug ' + mediaType + ' BolaRule for state=- fragmentStart=' + adapter.getIndexHandlerTime(rulesContext.getStreamProcessor()).toFixed(3));

            var initState = calculateInitialState(rulesContext);
            metricsModel.updateBolaState(mediaType, initState);

            var q = 0;
            if (initState.state !== BOLA_STATE_ONE_BITRATE) {
                // initState.state === BOLA_STATE_STARTUP

                eventMediaTypes.push(mediaType);

                // Bola is not invoked by dash.js to determine the bitrate quality for the first fragment. We might estimate the throughput level here, but the metric related to the HTTP request for the first fragment is usually not available.
                // TODO: at some point, we may want to consider a tweak that redownloads the first fragment at a higher quality

                var initThroughput = getRecentThroughput(metrics, initState.throughputCount, mediaType);
                if (initThroughput === 0) {
                    // We don't have information about any download yet - let someone else decide quality.
                    if (BOLA_DEBUG) log('BolaDebug ' + mediaType + ' BolaRule quality unchanged for INITIALIZE');
                    return switchRequest;
                }
                q = getQualityFromThroughput(initState, initThroughput * initState.bandwidthSafetyFactor);
                initState.lastQuality = q;
                switchRequest.value = q;
                switchRequest.reason.state = initState.state;
                switchRequest.reason.throughput = initThroughput;
            }

            if (BOLA_DEBUG) log('BolaDebug ' + mediaType + ' BolaRule quality ' + q + ' for INITIALIZE');
            return switchRequest;
        } // initialization

        // metrics.BolaState.length > 0
        var bolaState = metrics.BolaState[0]._s;
        // TODO: does changing bolaState conform to coding style, or should we clone?

        if (bolaState.state === BOLA_STATE_ONE_BITRATE) {
            if (BOLA_DEBUG) log('BolaDebug ' + mediaType + ' BolaRule quality 0 for ONE_BITRATE');
            return switchRequest;
        }

        var bitrates = bolaState.bitrates;
        var utilities = bolaState.utilities;

        if (BOLA_DEBUG) log('BolaDebug ' + mediaType + '\nBolaDebug ' + mediaType + ' EXECUTE BolaRule for state=' + bolaState.state + ' fragmentStart=' + adapter.getIndexHandlerTime(rulesContext.getStreamProcessor()).toFixed(3));

        var bufferLevel = dashMetrics.getCurrentBufferLevel(metrics) ? dashMetrics.getCurrentBufferLevel(metrics) : 0;
        var recentThroughput = getRecentThroughput(metrics, bolaState.throughputCount, mediaType);

        if (bufferLevel <= 0.1) {
            // rebuffering occurred, reset placeholder buffer
            bolaState.placeholderBuffer = 0;
        }

        // find out if there was delay because of lack of availability or because buffer level > bufferTarget or because of fast switching
        var placeholderInc = getPlaceholderIncrementInSeconds(metrics, mediaType);
        if (placeholderInc > 0) {
            // TODO: maybe we should set some positive threshold here
            bolaState.placeholderBuffer += placeholderInc;
        }
        if (bolaState.placeholderBuffer < 0) {
            bolaState.placeholderBuffer = 0;
        }

        var effectiveBufferLevel = bufferLevel + bolaState.placeholderBuffer;
        var bolaQuality = getQualityFromBufferLevel(bolaState, effectiveBufferLevel);

        if (BOLA_DEBUG) log('BolaDebug ' + mediaType + ' BolaRule bufferLevel=' + bufferLevel.toFixed(3) + '(+' + bolaState.placeholderBuffer.toFixed(3) + '=' + effectiveBufferLevel.toFixed(3) + ') recentThroughput=' + (0.000001 * recentThroughput).toFixed(3) + ' tentativeQuality=' + bolaQuality);

        if (bolaState.state === BOLA_STATE_STARTUP) {
            // in startup phase, use some throughput estimation

            var q = getQualityFromThroughput(bolaState, recentThroughput * bolaState.bandwidthSafetyFactor);

            if (bufferLevel > bolaState.fragmentDuration / REBUFFER_SAFETY_FACTOR) {
                // only switch to steady state if we believe we have enough buffer to not trigger quality drop to a safeBitrate
                bolaState.state = BOLA_STATE_STEADY;

                var wantEffectiveBuffer = 0;
                for (var i = 0; i < q; ++i) {
                    // We want minimum effective buffer (bufferLevel + placeholderBuffer) that gives a higher score for q when compared with any other i < q.
                    // We want
                    //     (Vp * (utilities[q] + gp) - bufferLevel) / bitrates[q]
                    // to be >= any score for i < q.
                    // We get score equality for q and i when:
                    var b = bolaState.Vp * (bolaState.gp + (bitrates[q] * utilities[i] - bitrates[i] * utilities[q]) / (bitrates[q] - bitrates[i]));
                    if (b > wantEffectiveBuffer) {
                        wantEffectiveBuffer = b;
                    }
                }
                if (wantEffectiveBuffer > bufferLevel) {
                    bolaState.placeholderBuffer = wantEffectiveBuffer - bufferLevel;
                }
            }

            if (BOLA_DEBUG) log('BolaDebug ' + mediaType + ' BolaRule quality ' + q + ' for STARTUP');
            bolaState.lastQuality = q;
            metricsModel.updateBolaState(mediaType, bolaState);
            switchRequest.value = q;
            switchRequest.reason.state = BOLA_STATE_STARTUP;
            switchRequest.reason.throughput = recentThroughput;
            return switchRequest;
        }

        // steady state

        // we want to avoid oscillations
        // We implement the "BOLA-O" variant: when network bandwidth lies between two encoded bitrate levels, stick to the lowest level.
        if (bolaQuality > bolaState.lastQuality) {
            // do not multiply throughput by bandwidthSafetyFactor here: we are not using throughput estimation but capping bitrate to avoid oscillations
            var q = getQualityFromThroughput(bolaState, recentThroughput);
            if (bolaQuality > q) {
                // only intervene if we are trying to *increase* quality to an *unsustainable* level

                if (q < bolaState.lastQuality) {
                    // we are only avoid oscillations - do not drop below last quality
                    q = bolaState.lastQuality;
                }
                // We are dropping to an encoding bitrate which is a little less than the network bandwidth because bitrate levels are discrete. Quality q might lead to buffer inflation, so we deflate buffer to the level that q gives postive utility. This delay will be added below.
                bolaQuality = q;
            }
        }

        // Try to make sure that we can download a chunk without rebuffering. This is especially important for live streaming.
        if (recentThroughput > 0) {
            // We can only perform this check if we have a throughput estimate.
            var safeBitrate = REBUFFER_SAFETY_FACTOR * recentThroughput * bufferLevel / bolaState.fragmentDuration;
            while (bolaQuality > 0 && bitrates[bolaQuality] > safeBitrate) {
                --bolaQuality;
            }
        }

        // We do not want to overfill buffer with low quality chunks.
        // Note that there will be no delay if buffer level is below MINIMUM_BUFFER_S, probably even with some margin higher than MINIMUM_BUFFER_S.
        var delaySeconds = 0;
        var wantBufferLevel = bolaState.Vp * (utilities[bolaQuality] + bolaState.gp);
        delaySeconds = effectiveBufferLevel - wantBufferLevel;
        if (delaySeconds > 0) {
            // First reduce placeholder buffer.
            // Note that this "delay" is the main mechanism of depleting placeholderBuffer - the real buffer is depleted by playback.
            if (delaySeconds > bolaState.placeholderBuffer) {
                delaySeconds -= bolaState.placeholderBuffer;
                bolaState.placeholderBuffer = 0;
            } else {
                bolaState.placeholderBuffer -= delaySeconds;
                delaySeconds = 0;
            }
        }
        if (delaySeconds > 0) {
            // After depleting all placeholder buffer, set delay.
            if (bolaQuality === bitrates.length - 1) {
                // At top quality, allow schedule controller to decide how far to fill buffer.
                delaySeconds = 0;
            } else {
                streamProcessor.getScheduleController().setTimeToLoadDelay(1000 * delaySeconds);
            }
        } else {
            delaySeconds = 0;
        }

        bolaState.lastQuality = bolaQuality;
        metricsModel.updateBolaState(mediaType, bolaState);

        switchRequest.value = bolaQuality;
        switchRequest.reason.state = bolaState.state;
        switchRequest.reason.throughput = recentThroughput;
        switchRequest.reason.bufferLevel = bufferLevel;

        if (BOLA_DEBUG) log('BolaDebug ' + mediaType + ' BolaRule quality ' + bolaQuality + ' delay=' + delaySeconds.toFixed(3) + ' for STEADY');
        return switchRequest;
    }

    function reset() {
        eventBus.off(_coreEventsEvents2['default'].BUFFER_EMPTY, onBufferEmpty, instance);
        eventBus.off(_coreEventsEvents2['default'].PLAYBACK_SEEKING, onPlaybackSeeking, instance);
        eventBus.off(_coreEventsEvents2['default'].PERIOD_SWITCH_STARTED, onPeriodSwitchStarted, instance);
        eventBus.off(_coreEventsEvents2['default'].MEDIA_FRAGMENT_LOADED, onMediaFragmentLoaded, instance);
        setup();
    }

    instance = {
        getMaxIndex: getMaxIndex,
        reset: reset
    };

    setup();
    return instance;
}

BolaRule.__dashjs_factory_name = 'BolaRule';
var factory = _coreFactoryMaker2['default'].getClassFactory(BolaRule);
factory.BOLA_STATE_ONE_BITRATE = BOLA_STATE_ONE_BITRATE;
factory.BOLA_STATE_STARTUP = BOLA_STATE_STARTUP;
factory.BOLA_STATE_STEADY = BOLA_STATE_STEADY;
factory.BOLA_DEBUG = BOLA_DEBUG; // TODO: remove
exports['default'] = factory;
module.exports = exports['default'];
//# sourceMappingURL=BolaRule.js.map


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
* The copyright in this software is being made available under the BSD License,
* included below. This software may be subject to other third party and contributor
* rights, including patent rights, and no such rights are granted under this license.
*
* Copyright (c) 2013, Dash Industry Forum.
* All rights reserved.
*
* Redistribution and use in source and binary forms, with or without modification,
* are permitted provided that the following conditions are met:
*  * Redistributions of source code must retain the above copyright notice, this
*  list of conditions and the following disclaimer.
*  * Redistributions in binary form must reproduce the above copyright notice,
*  this list of conditions and the following disclaimer in the documentation and/or
*  other materials provided with the distribution.
*  * Neither the name of Dash Industry Forum nor the names of its
*  contributors may be used to endorse or promote products derived from this software
*  without specific prior written permission.
*
*  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
*  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
*  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
*  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
*  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
*  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
*  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
*  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
*  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
*  POSSIBILITY OF SUCH DAMAGE.
*/


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

function CustomTimeRanges() /*config*/{
    var customTimeRangeArray = [];
    var length = 0;

    function add(start, end) {
        var i = 0;

        for (i = 0; i < this.customTimeRangeArray.length && start > this.customTimeRangeArray[i].start; i++);

        this.customTimeRangeArray.splice(i, 0, { start: start, end: end });

        for (i = 0; i < this.customTimeRangeArray.length - 1; i++) {
            if (this.mergeRanges(i, i + 1)) {
                i--;
            }
        }
        this.length = this.customTimeRangeArray.length;
    }

    function clear() {
        this.customTimeRangeArray = [];
        this.length = 0;
    }

    function remove(start, end) {
        for (var i = 0; i < this.customTimeRangeArray.length; i++) {
            if (start <= this.customTimeRangeArray[i].start && end >= this.customTimeRangeArray[i].end) {
                //      |--------------Range i-------|
                //|---------------Range to remove ---------------|
                //    or
                //|--------------Range i-------|
                //|--------------Range to remove ---------------|
                //    or
                //                 |--------------Range i-------|
                //|--------------Range to remove ---------------|
                this.customTimeRangeArray.splice(i, 1);
                i--;
            } else if (start > this.customTimeRangeArray[i].start && end < this.customTimeRangeArray[i].end) {
                //|-----------------Range i----------------|
                //        |-------Range to remove -----|
                this.customTimeRangeArray.splice(i + 1, 0, { start: end, end: this.customTimeRangeArray[i].end });
                this.customTimeRangeArray[i].end = start;
                break;
            } else if (start > this.customTimeRangeArray[i].start && start < this.customTimeRangeArray[i].end) {
                //|-----------Range i----------|
                //                    |---------Range to remove --------|
                //    or
                //|-----------------Range i----------------|
                //            |-------Range to remove -----|
                this.customTimeRangeArray[i].end = start;
            } else if (end > this.customTimeRangeArray[i].start && end < this.customTimeRangeArray[i].end) {
                //                     |-----------Range i----------|
                //|---------Range to remove --------|
                //            or
                //|-----------------Range i----------------|
                //|-------Range to remove -----|
                this.customTimeRangeArray[i].start = end;
            }
        }

        this.length = this.customTimeRangeArray.length;
    }

    function mergeRanges(rangeIndex1, rangeIndex2) {
        var range1 = this.customTimeRangeArray[rangeIndex1];
        var range2 = this.customTimeRangeArray[rangeIndex2];

        if (range1.start <= range2.start && range2.start <= range1.end && range1.end <= range2.end) {
            //|-----------Range1----------|
            //                    |-----------Range2----------|
            range1.end = range2.end;
            this.customTimeRangeArray.splice(rangeIndex2, 1);
            return true;
        } else if (range2.start <= range1.start && range1.start <= range2.end && range2.end <= range1.end) {
            //                |-----------Range1----------|
            //|-----------Range2----------|
            range1.start = range2.start;
            this.customTimeRangeArray.splice(rangeIndex2, 1);
            return true;
        } else if (range2.start <= range1.start && range1.start <= range2.end && range1.end <= range2.end) {
            //      |--------Range1-------|
            //|---------------Range2--------------|
            this.customTimeRangeArray.splice(rangeIndex1, 1);
            return true;
        } else if (range1.start <= range2.start && range2.start <= range1.end && range2.end <= range1.end) {
            //|-----------------Range1--------------|
            //        |-----------Range2----------|
            this.customTimeRangeArray.splice(rangeIndex2, 1);
            return true;
        }
        return false;
    }

    function start(index) {
        return this.customTimeRangeArray[index].start;
    }

    function end(index) {
        return this.customTimeRangeArray[index].end;
    }

    return {
        customTimeRangeArray: customTimeRangeArray,
        length: length,
        add: add,
        clear: clear,
        remove: remove,
        mergeRanges: mergeRanges,
        start: start,
        end: end
    };
}
CustomTimeRanges.__dashjs_factory_name = 'CustomTimeRanges';
exports['default'] = _coreFactoryMaker2['default'].getClassFactory(CustomTimeRanges);
module.exports = exports['default'];
//# sourceMappingURL=CustomTimeRanges.js.map


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @class
 * @ignore
 */


Object.defineProperty(exports, '__esModule', {
  value: true
});

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _FragmentRequest2 = __webpack_require__(190);

var _FragmentRequest3 = _interopRequireDefault(_FragmentRequest2);

var TextRequest = (function (_FragmentRequest) {
  _inherits(TextRequest, _FragmentRequest);

  function TextRequest(url, type) {
    _classCallCheck(this, TextRequest);

    _get(Object.getPrototypeOf(TextRequest.prototype), 'constructor', this).call(this);
    this.url = url || null;
    this.type = type || null;
    this.mediaType = 'stream';
    this.responseType = 'text';
  }

  return TextRequest;
})(_FragmentRequest3['default']);

exports['default'] = TextRequest;
module.exports = exports['default'];
//# sourceMappingURL=TextRequest.js.map


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @classdesc a PlayList from ISO23009-1 Annex D, this Object holds reference to the playback session information
 */


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var PlayList =
/**
 * @class
 */
function PlayList() {
  _classCallCheck(this, PlayList);

  /**
   * Timestamp of the user action that starts the playback stream...
   * @public
   */
  this.start = null;
  /**
   * Presentation time at which playout was requested by the user...
   * @public
   */
  this.mstart = null;
  /**
   * Type of user action which triggered playout
   * - New playout request (e.g. initial playout or seeking)
   * - Resume from pause
   * - Other user request (e.g. user-requested quality change)
   * - Start of a metrics collection stream (hence earlier entries in the play list not collected)
   * @public
   */
  this.starttype = null;

  /**
   * List of streams of continuous rendering of decoded samples.
   * @public
   */
  this.trace = [];
}

/* Public Static Constants */
;

PlayList.INITIAL_PLAYOUT_START_REASON = 'initial_playout';
PlayList.SEEK_START_REASON = 'seek';
PlayList.RESUME_FROM_PAUSE_START_REASON = 'resume';
PlayList.METRICS_COLLECTION_START_REASON = 'metrics_collection_start';

/**
 * @classdesc a PlayList.Trace from ISO23009-1 Annex D
 */

var PlayListTrace =
/**
 * @class
 */
function PlayListTrace() {
  _classCallCheck(this, PlayListTrace);

  /**
   * The value of the Representation@id of the Representation from which the samples were taken.
   * @type {string}
   * @public
   */
  this.representationid = null;
  /**
   * If not present, this metrics concerns the Representation as a whole.
   * If present, subreplevel indicates the greatest value of any
   * Subrepresentation@level being rendered.
   * @type {number}
   * @public
   */
  this.subreplevel = null;
  /**
   * The time at which the first sample was rendered
   * @type {number}
   * @public
   */
  this.start = null;
  /**
   * The presentation time of the first sample rendered.
   * @type {number}
   * @public
   */
  this.mstart = null;
  /**
   * The duration of the continuously presented samples (which is the same in real time and media time). "Continuously presented" means that the media clock continued to advance at the playout speed throughout the interval. NOTE: the spec does not call out the units, but all other durations etc are in ms, and we use ms too.
   * @type {number}
   * @public
   */
  this.duration = null;
  /**
   * The playback speed relative to normal playback speed (i.e.normal forward playback speed is 1.0).
   * @type {number}
   * @public
   */
  this.playbackspeed = null;
  /**
   * The reason why continuous presentation of this Representation was stopped.
   * representation switch
   * rebuffering
   * user request
   * end of Period
   * end of Stream
   * end of content
   * end of a metrics collection period
   *
   * @type {string}
   * @public
   */
  this.stopreason = null;
};

PlayListTrace.REPRESENTATION_SWITCH_STOP_REASON = 'representation_switch';
PlayListTrace.REBUFFERING_REASON = 'rebuffering';
PlayListTrace.USER_REQUEST_STOP_REASON = 'user_request';
PlayListTrace.END_OF_PERIOD_STOP_REASON = 'end_of_period';
PlayListTrace.END_OF_CONTENT_STOP_REASON = 'end_of_content';
PlayListTrace.METRICS_COLLECTION_STOP_REASON = 'metrics_collection_end';
PlayListTrace.FAILURE_STOP_REASON = 'failure';

exports.PlayList = PlayList;
exports.PlayListTrace = PlayListTrace;
//# sourceMappingURL=PlayList.js.map


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _aesCrypto = __webpack_require__(1451);

var _aesCrypto2 = _interopRequireDefault(_aesCrypto);

var _fastAesKey = __webpack_require__(1453);

var _fastAesKey2 = _interopRequireDefault(_fastAesKey);

var _aesDecryptor = __webpack_require__(1452);

var _aesDecryptor2 = _interopRequireDefault(_aesDecryptor);

var _errors = __webpack_require__(63);

var _logger = __webpack_require__(31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*globals self: false */

var Decrypter = function () {
  function Decrypter(observer, config) {
    _classCallCheck(this, Decrypter);

    this.observer = observer;
    this.config = config;
    this.logEnabled = true;
    try {
      var browserCrypto = crypto ? crypto : self.crypto;
      this.subtle = browserCrypto.subtle || browserCrypto.webkitSubtle;
    } catch (e) {}
    this.disableWebCrypto = !this.subtle;
  }

  _createClass(Decrypter, [{
    key: 'isSync',
    value: function isSync() {
      return this.disableWebCrypto && this.config.enableSoftwareAES;
    }
  }, {
    key: 'decrypt',
    value: function decrypt(data, key, iv, callback) {
      var _this = this;

      if (this.disableWebCrypto && this.config.enableSoftwareAES) {
        if (this.logEnabled) {
          _logger.logger.log('JS AES decrypt');
          this.logEnabled = false;
        }
        var decryptor = this.decryptor;
        if (!decryptor) {
          this.decryptor = decryptor = new _aesDecryptor2.default();
        }
        decryptor.expandKey(key);
        callback(decryptor.decrypt(data, 0, iv));
      } else {
        if (this.logEnabled) {
          _logger.logger.log('WebCrypto AES decrypt');
          this.logEnabled = false;
        }
        var subtle = this.subtle;
        if (this.key !== key) {
          this.key = key;
          this.fastAesKey = new _fastAesKey2.default(subtle, key);
        }

        this.fastAesKey.expandKey().then(function (aesKey) {
          // decrypt using web crypto
          var crypto = new _aesCrypto2.default(subtle, iv);
          crypto.decrypt(data, aesKey).catch(function (err) {
            _this.onWebCryptoError(err, data, key, iv, callback);
          }).then(function (result) {
            callback(result);
          });
        }).catch(function (err) {
          _this.onWebCryptoError(err, data, key, iv, callback);
        });
      }
    }
  }, {
    key: 'onWebCryptoError',
    value: function onWebCryptoError(err, data, key, iv, callback) {
      if (this.config.enableSoftwareAES) {
        _logger.logger.log('WebCrypto Error, disable WebCrypto API');
        this.disableWebCrypto = true;
        this.logEnabled = true;
        this.decrypt(data, key, iv, callback);
      } else {
        _logger.logger.error('decrypting error : ' + err.message);
        this.observer.trigger(Event.ERROR, { type: _errors.ErrorTypes.MEDIA_ERROR, details: _errors.ErrorDetails.FRAG_DECRYPT_ERROR, fatal: true, reason: err.message });
      }
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      var decryptor = this.decryptor;
      if (decryptor) {
        decryptor.destroy();
        this.decryptor = undefined;
      }
    }
  }]);

  return Decrypter;
}();

exports.default = Decrypter;

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _logger = __webpack_require__(31);

var _errors = __webpack_require__(63);

/**
 *  ADTS parser helper
 */
var ADTS = {
  getAudioConfig: function getAudioConfig(observer, data, offset, audioCodec) {
    var adtsObjectType,
        // :int
    adtsSampleingIndex,
        // :int
    adtsExtensionSampleingIndex,
        // :int
    adtsChanelConfig,
        // :int
    config,
        userAgent = navigator.userAgent.toLowerCase(),
        manifestCodec = audioCodec,
        adtsSampleingRates = [96000, 88200, 64000, 48000, 44100, 32000, 24000, 22050, 16000, 12000, 11025, 8000, 7350];
    // byte 2
    adtsObjectType = ((data[offset + 2] & 0xC0) >>> 6) + 1;
    adtsSampleingIndex = (data[offset + 2] & 0x3C) >>> 2;
    if (adtsSampleingIndex > adtsSampleingRates.length - 1) {
      observer.trigger(Event.ERROR, { type: _errors.ErrorTypes.MEDIA_ERROR, details: _errors.ErrorDetails.FRAG_PARSING_ERROR, fatal: true, reason: 'invalid ADTS sampling index:' + adtsSampleingIndex });
      return;
    }
    adtsChanelConfig = (data[offset + 2] & 0x01) << 2;
    // byte 3
    adtsChanelConfig |= (data[offset + 3] & 0xC0) >>> 6;
    _logger.logger.log('manifest codec:' + audioCodec + ',ADTS data:type:' + adtsObjectType + ',sampleingIndex:' + adtsSampleingIndex + '[' + adtsSampleingRates[adtsSampleingIndex] + 'Hz],channelConfig:' + adtsChanelConfig);
    // firefox: freq less than 24kHz = AAC SBR (HE-AAC)
    if (/firefox/i.test(userAgent)) {
      if (adtsSampleingIndex >= 6) {
        adtsObjectType = 5;
        config = new Array(4);
        // HE-AAC uses SBR (Spectral Band Replication) , high frequencies are constructed from low frequencies
        // there is a factor 2 between frame sample rate and output sample rate
        // multiply frequency by 2 (see table below, equivalent to substract 3)
        adtsExtensionSampleingIndex = adtsSampleingIndex - 3;
      } else {
        adtsObjectType = 2;
        config = new Array(2);
        adtsExtensionSampleingIndex = adtsSampleingIndex;
      }
      // Android : always use AAC
    } else if (userAgent.indexOf('android') !== -1) {
      adtsObjectType = 2;
      config = new Array(2);
      adtsExtensionSampleingIndex = adtsSampleingIndex;
    } else {
      /*  for other browsers (Chrome/Vivaldi/Opera ...)
          always force audio type to be HE-AAC SBR, as some browsers do not support audio codec switch properly (like Chrome ...)
      */
      adtsObjectType = 5;
      config = new Array(4);
      // if (manifest codec is HE-AAC or HE-AACv2) OR (manifest codec not specified AND frequency less than 24kHz)
      if (audioCodec && (audioCodec.indexOf('mp4a.40.29') !== -1 || audioCodec.indexOf('mp4a.40.5') !== -1) || !audioCodec && adtsSampleingIndex >= 6) {
        // HE-AAC uses SBR (Spectral Band Replication) , high frequencies are constructed from low frequencies
        // there is a factor 2 between frame sample rate and output sample rate
        // multiply frequency by 2 (see table below, equivalent to substract 3)
        adtsExtensionSampleingIndex = adtsSampleingIndex - 3;
      } else {
        // if (manifest codec is AAC) AND (frequency less than 24kHz AND nb channel is 1) OR (manifest codec not specified and mono audio)
        // Chrome fails to play back with low frequency AAC LC mono when initialized with HE-AAC.  This is not a problem with stereo.
        if (audioCodec && audioCodec.indexOf('mp4a.40.2') !== -1 && adtsSampleingIndex >= 6 && adtsChanelConfig === 1 || !audioCodec && adtsChanelConfig === 1) {
          adtsObjectType = 2;
          config = new Array(2);
        }
        adtsExtensionSampleingIndex = adtsSampleingIndex;
      }
    }
    /* refer to http://wiki.multimedia.cx/index.php?title=MPEG-4_Audio#Audio_Specific_Config
        ISO 14496-3 (AAC).pdf - Table 1.13 — Syntax of AudioSpecificConfig()
      Audio Profile / Audio Object Type
      0: Null
      1: AAC Main
      2: AAC LC (Low Complexity)
      3: AAC SSR (Scalable Sample Rate)
      4: AAC LTP (Long Term Prediction)
      5: SBR (Spectral Band Replication)
      6: AAC Scalable
     sampling freq
      0: 96000 Hz
      1: 88200 Hz
      2: 64000 Hz
      3: 48000 Hz
      4: 44100 Hz
      5: 32000 Hz
      6: 24000 Hz
      7: 22050 Hz
      8: 16000 Hz
      9: 12000 Hz
      10: 11025 Hz
      11: 8000 Hz
      12: 7350 Hz
      13: Reserved
      14: Reserved
      15: frequency is written explictly
      Channel Configurations
      These are the channel configurations:
      0: Defined in AOT Specifc Config
      1: 1 channel: front-center
      2: 2 channels: front-left, front-right
    */
    // audioObjectType = profile => profile, the MPEG-4 Audio Object Type minus 1
    config[0] = adtsObjectType << 3;
    // samplingFrequencyIndex
    config[0] |= (adtsSampleingIndex & 0x0E) >> 1;
    config[1] |= (adtsSampleingIndex & 0x01) << 7;
    // channelConfiguration
    config[1] |= adtsChanelConfig << 3;
    if (adtsObjectType === 5) {
      // adtsExtensionSampleingIndex
      config[1] |= (adtsExtensionSampleingIndex & 0x0E) >> 1;
      config[2] = (adtsExtensionSampleingIndex & 0x01) << 7;
      // adtsObjectType (force to 2, chrome is checking that object type is less than 5 ???
      //    https://chromium.googlesource.com/chromium/src.git/+/master/media/formats/mp4/aac.cc
      config[2] |= 2 << 2;
      config[3] = 0;
    }
    return { config: config, samplerate: adtsSampleingRates[adtsSampleingIndex], channelCount: adtsChanelConfig, codec: 'mp4a.40.' + adtsObjectType, manifestCodec: manifestCodec };
  }
};

module.exports = ADTS;

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*  inline demuxer.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *   probe fragments and instantiate appropriate demuxer depending on content type (TSDemuxer, AACDemuxer, ...)
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _events = __webpack_require__(39);

var _events2 = _interopRequireDefault(_events);

var _errors = __webpack_require__(63);

var _decrypter = __webpack_require__(601);

var _decrypter2 = _interopRequireDefault(_decrypter);

var _aacdemuxer = __webpack_require__(1454);

var _aacdemuxer2 = _interopRequireDefault(_aacdemuxer);

var _mp4demuxer = __webpack_require__(1458);

var _mp4demuxer2 = _interopRequireDefault(_mp4demuxer);

var _tsdemuxer = __webpack_require__(1460);

var _tsdemuxer2 = _interopRequireDefault(_tsdemuxer);

var _mp3demuxer = __webpack_require__(1457);

var _mp3demuxer2 = _interopRequireDefault(_mp3demuxer);

var _mp4Remuxer = __webpack_require__(1468);

var _mp4Remuxer2 = _interopRequireDefault(_mp4Remuxer);

var _passthroughRemuxer = __webpack_require__(1469);

var _passthroughRemuxer2 = _interopRequireDefault(_passthroughRemuxer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DemuxerInline = function () {
  function DemuxerInline(observer, typeSupported, config, vendor) {
    _classCallCheck(this, DemuxerInline);

    this.observer = observer;
    this.typeSupported = typeSupported;
    this.config = config;
    this.vendor = vendor;
  }

  _createClass(DemuxerInline, [{
    key: 'destroy',
    value: function destroy() {
      var demuxer = this.demuxer;
      if (demuxer) {
        demuxer.destroy();
      }
    }
  }, {
    key: 'push',
    value: function push(data, decryptdata, initSegment, audioCodec, videoCodec, timeOffset, discontinuity, trackSwitch, contiguous, duration, accurateTimeOffset, defaultInitPTS) {
      if (data.byteLength > 0 && decryptdata != null && decryptdata.key != null && decryptdata.method === 'AES-128') {
        var decrypter = this.decrypter;
        if (decrypter == null) {
          decrypter = this.decrypter = new _decrypter2.default(this.observer, this.config);
        }
        var localthis = this;
        // performance.now() not available on WebWorker, at least on Safari Desktop
        var startTime;
        try {
          startTime = performance.now();
        } catch (error) {
          startTime = Date.now();
        }
        decrypter.decrypt(data, decryptdata.key.buffer, decryptdata.iv.buffer, function (decryptedData) {
          var endTime;
          try {
            endTime = performance.now();
          } catch (error) {
            endTime = Date.now();
          }
          localthis.observer.trigger(_events2.default.FRAG_DECRYPTED, { stats: { tstart: startTime, tdecrypt: endTime } });
          localthis.pushDecrypted(new Uint8Array(decryptedData), decryptdata, new Uint8Array(initSegment), audioCodec, videoCodec, timeOffset, discontinuity, trackSwitch, contiguous, duration, accurateTimeOffset, defaultInitPTS);
        });
      } else {
        this.pushDecrypted(new Uint8Array(data), decryptdata, new Uint8Array(initSegment), audioCodec, videoCodec, timeOffset, discontinuity, trackSwitch, contiguous, duration, accurateTimeOffset, defaultInitPTS);
      }
    }
  }, {
    key: 'pushDecrypted',
    value: function pushDecrypted(data, decryptdata, initSegment, audioCodec, videoCodec, timeOffset, discontinuity, trackSwitch, contiguous, duration, accurateTimeOffset, defaultInitPTS) {
      var demuxer = this.demuxer;
      if (!demuxer ||
      // in case of continuity change, we might switch from content type (AAC container to TS container for example)
      // so let's check that current demuxer is still valid
      discontinuity && !this.probe(data)) {
        var observer = this.observer;
        var typeSupported = this.typeSupported;
        var config = this.config;
        var muxConfig = [{ demux: _tsdemuxer2.default, remux: _mp4Remuxer2.default }, { demux: _mp3demuxer2.default, remux: _mp4Remuxer2.default }, { demux: _aacdemuxer2.default, remux: _mp4Remuxer2.default }, { demux: _mp4demuxer2.default, remux: _passthroughRemuxer2.default }];

        // probe for content type
        for (var i in muxConfig) {
          var mux = muxConfig[i];
          var probe = mux.demux.probe;
          if (probe(data)) {
            var _remuxer = this.remuxer = new mux.remux(observer, config, typeSupported, this.vendor);
            demuxer = new mux.demux(observer, _remuxer, config, typeSupported);
            this.probe = probe;
            break;
          }
        }
        if (!demuxer) {
          observer.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.MEDIA_ERROR, details: _errors.ErrorDetails.FRAG_PARSING_ERROR, fatal: true, reason: 'no demux matching with content found' });
          return;
        }
        this.demuxer = demuxer;
      }
      var remuxer = this.remuxer;

      if (discontinuity || trackSwitch) {
        demuxer.resetInitSegment(initSegment, audioCodec, videoCodec, duration);
        remuxer.resetInitSegment();
      }
      if (discontinuity) {
        demuxer.resetTimeStamp();
        remuxer.resetTimeStamp(defaultInitPTS);
      }
      if (typeof demuxer.setDecryptData === 'function') {
        demuxer.setDecryptData(decryptdata);
      }
      demuxer.append(data, timeOffset, contiguous, accurateTimeOffset);
    }
  }]);

  return DemuxerInline;
}();

exports.default = DemuxerInline;

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events = __webpack_require__(39);

var _events2 = _interopRequireDefault(_events);

var _demuxerInline = __webpack_require__(603);

var _demuxerInline2 = _interopRequireDefault(_demuxerInline);

var _demuxerWorker = __webpack_require__(1455);

var _demuxerWorker2 = _interopRequireDefault(_demuxerWorker);

var _logger = __webpack_require__(31);

var _errors = __webpack_require__(63);

var _events3 = __webpack_require__(410);

var _events4 = _interopRequireDefault(_events3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Demuxer = function () {
  function Demuxer(hls, id) {
    _classCallCheck(this, Demuxer);

    this.hls = hls;
    this.id = id;
    // observer setup
    var observer = this.observer = new _events4.default();
    var config = hls.config;
    observer.trigger = function trigger(event) {
      for (var _len = arguments.length, data = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        data[_key - 1] = arguments[_key];
      }

      observer.emit.apply(observer, [event, event].concat(data));
    };

    observer.off = function off(event) {
      for (var _len2 = arguments.length, data = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        data[_key2 - 1] = arguments[_key2];
      }

      observer.removeListener.apply(observer, [event].concat(data));
    };

    var forwardMessage = function (ev, data) {
      data = data || {};
      data.frag = this.frag;
      data.id = this.id;
      hls.trigger(ev, data);
    }.bind(this);

    // forward events to main thread
    observer.on(_events2.default.FRAG_DECRYPTED, forwardMessage);
    observer.on(_events2.default.FRAG_PARSING_INIT_SEGMENT, forwardMessage);
    observer.on(_events2.default.FRAG_PARSING_DATA, forwardMessage);
    observer.on(_events2.default.FRAG_PARSED, forwardMessage);
    observer.on(_events2.default.ERROR, forwardMessage);
    observer.on(_events2.default.FRAG_PARSING_METADATA, forwardMessage);
    observer.on(_events2.default.FRAG_PARSING_USERDATA, forwardMessage);
    observer.on(_events2.default.INIT_PTS_FOUND, forwardMessage);

    var typeSupported = {
      mp4: MediaSource.isTypeSupported('video/mp4'),
      mpeg: MediaSource.isTypeSupported('audio/mpeg'),
      mp3: MediaSource.isTypeSupported('audio/mp4; codecs="mp3"')
    };
    // navigator.vendor is not always available in Web Worker
    // refer to https://developer.mozilla.org/en-US/docs/Web/API/WorkerGlobalScope/navigator
    var vendor = navigator.vendor;
    if (config.enableWorker && typeof Worker !== 'undefined') {
      _logger.logger.log('demuxing in webworker');
      var w = void 0;
      try {
        var work = __webpack_require__(1525);
        w = this.w = work(_demuxerWorker2.default);
        this.onwmsg = this.onWorkerMessage.bind(this);
        w.addEventListener('message', this.onwmsg);
        w.onerror = function (event) {
          hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.OTHER_ERROR, details: _errors.ErrorDetails.INTERNAL_EXCEPTION, fatal: true, event: 'demuxerWorker', err: { message: event.message + ' (' + event.filename + ':' + event.lineno + ')' } });
        };
        w.postMessage({ cmd: 'init', typeSupported: typeSupported, vendor: vendor, id: id, config: JSON.stringify(config) });
      } catch (err) {
        _logger.logger.error('error while initializing DemuxerWorker, fallback on DemuxerInline');
        if (w) {
          // revoke the Object URL that was used to create demuxer worker, so as not to leak it
          URL.revokeObjectURL(w.objectURL);
        }
        this.demuxer = new _demuxerInline2.default(observer, typeSupported, config, vendor);
        this.w = undefined;
      }
    } else {
      this.demuxer = new _demuxerInline2.default(observer, typeSupported, config, vendor);
    }
  }

  _createClass(Demuxer, [{
    key: 'destroy',
    value: function destroy() {
      var w = this.w;
      if (w) {
        w.removeEventListener('message', this.onwmsg);
        w.terminate();
        this.w = null;
      } else {
        var demuxer = this.demuxer;
        if (demuxer) {
          demuxer.destroy();
          this.demuxer = null;
        }
      }
      var observer = this.observer;
      if (observer) {
        observer.removeAllListeners();
        this.observer = null;
      }
    }
  }, {
    key: 'push',
    value: function push(data, initSegment, audioCodec, videoCodec, frag, duration, accurateTimeOffset, defaultInitPTS) {
      var w = this.w;
      var timeOffset = !isNaN(frag.startDTS) ? frag.startDTS : frag.start;
      var decryptdata = frag.decryptdata;
      var lastFrag = this.frag;
      var discontinuity = !(lastFrag && frag.cc === lastFrag.cc);
      var trackSwitch = !(lastFrag && frag.level === lastFrag.level);
      var nextSN = lastFrag && frag.sn === lastFrag.sn + 1;
      var contiguous = !trackSwitch && nextSN;
      if (discontinuity) {
        _logger.logger.log(this.id + ':discontinuity detected');
      }
      if (trackSwitch) {
        _logger.logger.log(this.id + ':switch detected');
      }
      this.frag = frag;
      if (w) {
        // post fragment payload as transferable objects (no copy)
        w.postMessage({ cmd: 'demux', data: data, decryptdata: decryptdata, initSegment: initSegment, audioCodec: audioCodec, videoCodec: videoCodec, timeOffset: timeOffset, discontinuity: discontinuity, trackSwitch: trackSwitch, contiguous: contiguous, duration: duration, accurateTimeOffset: accurateTimeOffset, defaultInitPTS: defaultInitPTS }, [data]);
      } else {
        var demuxer = this.demuxer;
        if (demuxer) {
          demuxer.push(data, decryptdata, initSegment, audioCodec, videoCodec, timeOffset, discontinuity, trackSwitch, contiguous, duration, accurateTimeOffset, defaultInitPTS);
        }
      }
    }
  }, {
    key: 'onWorkerMessage',
    value: function onWorkerMessage(ev) {
      var data = ev.data,
          hls = this.hls;
      //console.log('onWorkerMessage:' + data.event);
      switch (data.event) {
        case 'init':
          // revoke the Object URL that was used to create demuxer worker, so as not to leak it
          URL.revokeObjectURL(this.w.objectURL);
          break;
        // special case for FRAG_PARSING_DATA: data1 and data2 are transferable objects
        case _events2.default.FRAG_PARSING_DATA:
          data.data.data1 = new Uint8Array(data.data1);
          if (data.data2) {
            data.data.data2 = new Uint8Array(data.data2);
          }
        /* falls through */
        default:
          data.data = data.data || {};
          data.data.frag = this.frag;
          data.data.id = this.id;
          hls.trigger(data.event, data.data);
          break;
      }
    }
  }]);

  return Demuxer;
}();

exports.default = Demuxer;

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * ID3 parser
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */


var _logger = __webpack_require__(31);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//import Hex from '../utils/hex';

var ID3 = function () {
  function ID3(data) {
    _classCallCheck(this, ID3);

    this._hasTimeStamp = false;
    this._length = 0;
    var offset = 0,
        byte1,
        byte2,
        byte3,
        byte4,
        tagSize,
        endPos,
        header,
        len;
    do {
      header = this.readUTF(data, offset, 3);
      offset += 3;
      // first check for ID3 header
      if (header === 'ID3') {
        // skip 24 bits
        offset += 3;
        // retrieve tag(s) length
        byte1 = data[offset++] & 0x7f;
        byte2 = data[offset++] & 0x7f;
        byte3 = data[offset++] & 0x7f;
        byte4 = data[offset++] & 0x7f;
        tagSize = (byte1 << 21) + (byte2 << 14) + (byte3 << 7) + byte4;
        endPos = offset + tagSize;
        //logger.log(`ID3 tag found, size/end: ${tagSize}/${endPos}`);

        // read ID3 tags
        this._parseID3Frames(data, offset, endPos);
        offset = endPos;
      } else if (header === '3DI') {
        // http://id3.org/id3v2.4.0-structure chapter 3.4.   ID3v2 footer
        offset += 7;
        _logger.logger.log('3DI footer found, end: ' + offset);
      } else {
        offset -= 3;
        len = offset;
        if (len) {
          //logger.log(`ID3 len: ${len}`);
          if (!this.hasTimeStamp) {
            _logger.logger.warn('ID3 tag found, but no timestamp');
          }
          this._length = len;
          this._payload = data.subarray(0, len);
        }
        return;
      }
    } while (true);
  }

  _createClass(ID3, [{
    key: 'readUTF',
    value: function readUTF(data, start, len) {

      var result = '',
          offset = start,
          end = start + len;
      do {
        result += String.fromCharCode(data[offset++]);
      } while (offset < end);
      return result;
    }
  }, {
    key: '_parseID3Frames',
    value: function _parseID3Frames(data, offset, endPos) {
      var tagId, tagLen, tagStart, tagFlags, timestamp;
      while (offset + 8 <= endPos) {
        tagId = this.readUTF(data, offset, 4);
        offset += 4;

        tagLen = data[offset++] << 24 + data[offset++] << 16 + data[offset++] << 8 + data[offset++];

        tagFlags = data[offset++] << 8 + data[offset++];

        tagStart = offset;
        //logger.log("ID3 tag id:" + tagId);
        switch (tagId) {
          case 'PRIV':
            //logger.log('parse frame:' + Hex.hexDump(data.subarray(offset,endPos)));
            // owner should be "com.apple.streaming.transportStreamTimestamp"
            if (this.readUTF(data, offset, 44) === 'com.apple.streaming.transportStreamTimestamp') {
              offset += 44;
              // smelling even better ! we found the right descriptor
              // skip null character (string end) + 3 first bytes
              offset += 4;

              // timestamp is 33 bit expressed as a big-endian eight-octet number, with the upper 31 bits set to zero.
              var pts33Bit = data[offset++] & 0x1;
              this._hasTimeStamp = true;

              timestamp = ((data[offset++] << 23) + (data[offset++] << 15) + (data[offset++] << 7) + data[offset++]) / 45;

              if (pts33Bit) {
                timestamp += 47721858.84; // 2^32 / 90
              }
              timestamp = Math.round(timestamp);
              _logger.logger.trace('ID3 timestamp found: ' + timestamp);
              this._timeStamp = timestamp;
            }
            break;
          default:
            break;
        }
      }
    }
  }, {
    key: 'hasTimeStamp',
    get: function get() {
      return this._hasTimeStamp;
    }
  }, {
    key: 'timeStamp',
    get: function get() {
      return this._timeStamp;
    }
  }, {
    key: 'length',
    get: function get() {
      return this._length;
    }
  }, {
    key: 'payload',
    get: function get() {
      return this._payload;
    }
  }]);

  return ID3;
}();

exports.default = ID3;

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _logger = __webpack_require__(31);

var MpegAudio = {

    onFrame: function onFrame(track, data, bitRate, sampleRate, channelCount, frameIndex, pts) {
        var frameDuration = 1152 * 90000 / sampleRate;
        var stamp = pts + frameIndex * frameDuration;

        track.config = [];
        track.channelCount = channelCount;
        track.samplerate = sampleRate;
        track.samples.push({ unit: data, pts: stamp, dts: stamp });
        track.len += data.length;
    },

    onNoise: function onNoise(data) {
        _logger.logger.warn('mpeg audio has noise: ' + data.length + ' bytes');
    },

    parseFrames: function parseFrames(track, data, start, end, frameIndex, pts) {
        var BitratesMap = [32, 64, 96, 128, 160, 192, 224, 256, 288, 320, 352, 384, 416, 448, 32, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 384, 32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 32, 48, 56, 64, 80, 96, 112, 128, 144, 160, 176, 192, 224, 256, 8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160];
        var SamplingRateMap = [44100, 48000, 32000, 22050, 24000, 16000, 11025, 12000, 8000];

        if (start + 2 > end) {
            return -1; // we need at least 2 bytes to detect sync pattern
        }
        if (data[start] === 0xFF || (data[start + 1] & 0xE0) === 0xE0) {
            // Using http://www.datavoyage.com/mpgscript/mpeghdr.htm as a reference
            if (start + 24 > end) {
                return -1;
            }
            var headerB = data[start + 1] >> 3 & 3;
            var headerC = data[start + 1] >> 1 & 3;
            var headerE = data[start + 2] >> 4 & 15;
            var headerF = data[start + 2] >> 2 & 3;
            var headerG = !!(data[start + 2] & 2);
            if (headerB !== 1 && headerE !== 0 && headerE !== 15 && headerF !== 3) {
                var columnInBitrates = headerB === 3 ? 3 - headerC : headerC === 3 ? 3 : 4;
                var bitRate = BitratesMap[columnInBitrates * 14 + headerE - 1] * 1000;
                var columnInSampleRates = headerB === 3 ? 0 : headerB === 2 ? 1 : 2;
                var sampleRate = SamplingRateMap[columnInSampleRates * 3 + headerF];
                var padding = headerG ? 1 : 0;
                var channelCount = data[start + 3] >> 6 === 3 ? 1 : 2; // If bits of channel mode are `11` then it is a single channel (Mono)
                var frameLength = headerC === 3 ? (headerB === 3 ? 12 : 6) * bitRate / sampleRate + padding << 2 : (headerB === 3 ? 144 : 72) * bitRate / sampleRate + padding | 0;
                if (start + frameLength > end) {
                    return -1;
                }

                this.onFrame(track, data.subarray(start, start + frameLength), bitRate, sampleRate, channelCount, frameIndex, pts);

                return frameLength;
            }
        }
        // noise or ID3, trying to skip
        var offset = start + 2;
        while (offset < end) {
            if (data[offset - 1] === 0xFF && (data[offset] & 0xE0) === 0xE0) {
                // sync pattern is found
                this.onNoise(data.subarray(start, offset - 1));

                return offset - start - 1;
            }
            offset++;
        }
        return -1;
    },

    parse: function parse(track, data, offset, pts) {
        var length = data.length;
        var frameIndex = 0;
        var parsed;

        while (offset < length && (parsed = this.parseFrames(track, data, offset, length, frameIndex++, pts)) > 0) {
            offset += parsed;
        }
    }
}; /**
    *  MPEG parser helper
    */


module.exports = MpegAudio;

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _logger = __webpack_require__(31);

var LevelHelper = {

  mergeDetails: function mergeDetails(oldDetails, newDetails) {
    var start = Math.max(oldDetails.startSN, newDetails.startSN) - newDetails.startSN,
        end = Math.min(oldDetails.endSN, newDetails.endSN) - newDetails.startSN,
        delta = newDetails.startSN - oldDetails.startSN,
        oldfragments = oldDetails.fragments,
        newfragments = newDetails.fragments,
        ccOffset = 0,
        PTSFrag;

    // check if old/new playlists have fragments in common
    if (end < start) {
      newDetails.PTSKnown = false;
      return;
    }
    // loop through overlapping SN and update startPTS , cc, and duration if any found
    for (var i = start; i <= end; i++) {
      var oldFrag = oldfragments[delta + i],
          newFrag = newfragments[i];
      if (newFrag && oldFrag) {
        ccOffset = oldFrag.cc - newFrag.cc;
        if (!isNaN(oldFrag.startPTS)) {
          newFrag.start = newFrag.startPTS = oldFrag.startPTS;
          newFrag.endPTS = oldFrag.endPTS;
          newFrag.duration = oldFrag.duration;
          PTSFrag = newFrag;
        }
      }
    }

    if (ccOffset) {
      _logger.logger.log('discontinuity sliding from playlist, take drift into account');
      for (i = 0; i < newfragments.length; i++) {
        newfragments[i].cc += ccOffset;
      }
    }

    // if at least one fragment contains PTS info, recompute PTS information for all fragments
    if (PTSFrag) {
      LevelHelper.updateFragPTSDTS(newDetails, PTSFrag, PTSFrag.startPTS, PTSFrag.endPTS, PTSFrag.startDTS, PTSFrag.endDTS);
    } else {
      // ensure that delta is within oldfragments range
      // also adjust sliding in case delta is 0 (we could have old=[50-60] and new=old=[50-61])
      // in that case we also need to adjust start offset of all fragments
      if (delta >= 0 && delta < oldfragments.length) {
        // adjust start by sliding offset
        var sliding = oldfragments[delta].start;
        for (i = 0; i < newfragments.length; i++) {
          newfragments[i].start += sliding;
        }
      }
    }
    // if we are here, it means we have fragments overlapping between
    // old and new level. reliable PTS info is thus relying on old level
    newDetails.PTSKnown = oldDetails.PTSKnown;
    return;
  },

  updateFragPTSDTS: function updateFragPTSDTS(details, frag, startPTS, endPTS, startDTS, endDTS) {
    // update frag PTS/DTS
    if (!isNaN(frag.startPTS)) {
      // delta PTS between audio and video
      var deltaPTS = Math.abs(frag.startPTS - startPTS);
      if (isNaN(frag.deltaPTS)) {
        frag.deltaPTS = deltaPTS;
      } else {
        frag.deltaPTS = Math.max(deltaPTS, frag.deltaPTS);
      }
      startPTS = Math.min(startPTS, frag.startPTS);
      endPTS = Math.max(endPTS, frag.endPTS);
      startDTS = Math.min(startDTS, frag.startDTS);
      endDTS = Math.max(endDTS, frag.endDTS);
    }

    var drift = startPTS - frag.start;
    frag.start = frag.startPTS = startPTS;
    frag.endPTS = endPTS;
    frag.startDTS = startDTS;
    frag.endDTS = endDTS;
    frag.duration = endPTS - startPTS;

    var sn = frag.sn;
    // exit if sn out of range
    if (!details || sn < details.startSN || sn > details.endSN) {
      return 0;
    }
    var fragIdx, fragments, i;
    fragIdx = sn - details.startSN;
    fragments = details.fragments;
    frag = fragments[fragIdx];
    // adjust fragment PTS/duration from seqnum-1 to frag 0
    for (i = fragIdx; i > 0; i--) {
      LevelHelper.updatePTS(fragments, i, i - 1);
    }

    // adjust fragment PTS/duration from seqnum to last frag
    for (i = fragIdx; i < fragments.length - 1; i++) {
      LevelHelper.updatePTS(fragments, i, i + 1);
    }
    details.PTSKnown = true;
    //logger.log(`                                            frag start/end:${startPTS.toFixed(3)}/${endPTS.toFixed(3)}`);

    return drift;
  },

  updatePTS: function updatePTS(fragments, fromIdx, toIdx) {
    var fragFrom = fragments[fromIdx],
        fragTo = fragments[toIdx],
        fragToPTS = fragTo.startPTS;
    // if we know startPTS[toIdx]
    if (!isNaN(fragToPTS)) {
      // update fragment duration.
      // it helps to fix drifts between playlist reported duration and fragment real duration
      if (toIdx > fromIdx) {
        fragFrom.duration = fragToPTS - fragFrom.start;
        if (fragFrom.duration < 0) {
          _logger.logger.warn('negative duration computed for frag ' + fragFrom.sn + ',level ' + fragFrom.level + ', there should be some duration drift between playlist and fragment!');
        }
      } else {
        fragTo.duration = fragFrom.start - fragToPTS;
        if (fragTo.duration < 0) {
          _logger.logger.warn('negative duration computed for frag ' + fragTo.sn + ',level ' + fragTo.level + ', there should be some duration drift between playlist and fragment!');
        }
      }
    } else {
      // we dont know startPTS[toIdx]
      if (toIdx > fromIdx) {
        fragTo.start = fragFrom.start + fragFrom.duration;
      } else {
        fragTo.start = Math.max(fragFrom.start - fragTo.duration, 0);
      }
    }
  }
}; /**
    * Level Helper class, providing methods dealing with playlist sliding and drift
   */

module.exports = LevelHelper;

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BinarySearch = {
    /**
     * Searches for an item in an array which matches a certain condition.
     * This requires the condition to only match one item in the array,
     * and for the array to be ordered.
     *
     * @param {Array} list The array to search.
     * @param {Function} comparisonFunction
     *      Called and provided a candidate item as the first argument.
     *      Should return:
     *          > -1 if the item should be located at a lower index than the provided item.
     *          > 1 if the item should be located at a higher index than the provided item.
     *          > 0 if the item is the item you're looking for.
     *
     * @return {*} The object if it is found or null otherwise.
     */
    search: function search(list, comparisonFunction) {
        var minIndex = 0;
        var maxIndex = list.length - 1;
        var currentIndex = null;
        var currentElement = null;

        while (minIndex <= maxIndex) {
            currentIndex = (minIndex + maxIndex) / 2 | 0;
            currentElement = list[currentIndex];

            var comparisonResult = comparisonFunction(currentElement);
            if (comparisonResult > 0) {
                minIndex = currentIndex + 1;
            } else if (comparisonResult < 0) {
                maxIndex = currentIndex - 1;
            } else {
                return currentElement;
            }
        }

        return null;
    }
};

module.exports = BinarySearch;

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 *  TimeRanges to string helper
 */

var TimeRanges = {
  toString: function toString(r) {
    var log = '',
        len = r.length;
    for (var i = 0; i < len; i++) {
      log += '[' + r.start(i).toFixed(3) + ',' + r.end(i).toFixed(3) + ']';
    }
    return log;
  }
};

module.exports = TimeRanges;

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fixLineBreaks = undefined;

var _vttcue = __webpack_require__(1475);

var _vttcue2 = _interopRequireDefault(_vttcue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StringDecoder = function StringDecoder() {
  return {
    decode: function decode(data) {
      if (!data) {
        return '';
      }
      if (typeof data !== 'string') {
        throw new Error('Error - expected string data.');
      }
      return decodeURIComponent(encodeURIComponent(data));
    }
  };
}; /*
    * Source: https://github.com/mozilla/vtt.js/blob/master/dist/vtt.js#L1716
    */

function VTTParser() {
  this.window = window;
  this.state = 'INITIAL';
  this.buffer = '';
  this.decoder = new StringDecoder();
  this.regionList = [];
}

// Try to parse input as a time stamp.
function parseTimeStamp(input) {

  function computeSeconds(h, m, s, f) {
    return (h | 0) * 3600 + (m | 0) * 60 + (s | 0) + (f | 0) / 1000;
  }

  var m = input.match(/^(\d+):(\d{2})(:\d{2})?\.(\d{3})/);
  if (!m) {
    return null;
  }

  if (m[3]) {
    // Timestamp takes the form of [hours]:[minutes]:[seconds].[milliseconds]
    return computeSeconds(m[1], m[2], m[3].replace(':', ''), m[4]);
  } else if (m[1] > 59) {
    // Timestamp takes the form of [hours]:[minutes].[milliseconds]
    // First position is hours as it's over 59.
    return computeSeconds(m[1], m[2], 0, m[4]);
  } else {
    // Timestamp takes the form of [minutes]:[seconds].[milliseconds]
    return computeSeconds(0, m[1], m[2], m[4]);
  }
}

// A settings object holds key/value pairs and will ignore anything but the first
// assignment to a specific key.
function Settings() {
  this.values = Object.create(null);
}

Settings.prototype = {
  // Only accept the first assignment to any key.
  set: function set(k, v) {
    if (!this.get(k) && v !== '') {
      this.values[k] = v;
    }
  },
  // Return the value for a key, or a default value.
  // If 'defaultKey' is passed then 'dflt' is assumed to be an object with
  // a number of possible default values as properties where 'defaultKey' is
  // the key of the property that will be chosen; otherwise it's assumed to be
  // a single value.
  get: function get(k, dflt, defaultKey) {
    if (defaultKey) {
      return this.has(k) ? this.values[k] : dflt[defaultKey];
    }
    return this.has(k) ? this.values[k] : dflt;
  },
  // Check whether we have a value for a key.
  has: function has(k) {
    return k in this.values;
  },
  // Accept a setting if its one of the given alternatives.
  alt: function alt(k, v, a) {
    for (var n = 0; n < a.length; ++n) {
      if (v === a[n]) {
        this.set(k, v);
        break;
      }
    }
  },
  // Accept a setting if its a valid (signed) integer.
  integer: function integer(k, v) {
    if (/^-?\d+$/.test(v)) {
      // integer
      this.set(k, parseInt(v, 10));
    }
  },
  // Accept a setting if its a valid percentage.
  percent: function percent(k, v) {
    var m;
    if (m = v.match(/^([\d]{1,3})(\.[\d]*)?%$/)) {
      v = parseFloat(v);
      if (v >= 0 && v <= 100) {
        this.set(k, v);
        return true;
      }
    }
    return false;
  }
};

// Helper function to parse input into groups separated by 'groupDelim', and
// interprete each group as a key/value pair separated by 'keyValueDelim'.
function parseOptions(input, callback, keyValueDelim, groupDelim) {
  var groups = groupDelim ? input.split(groupDelim) : [input];
  for (var i in groups) {
    if (typeof groups[i] !== 'string') {
      continue;
    }
    var kv = groups[i].split(keyValueDelim);
    if (kv.length !== 2) {
      continue;
    }
    var k = kv[0];
    var v = kv[1];
    callback(k, v);
  }
}

var defaults = new _vttcue2.default(0, 0, 0);
// 'middle' was changed to 'center' in the spec: https://github.com/w3c/webvtt/pull/244
// Chrome and Safari don't yet support this change, but FF does
var center = defaults.align === 'middle' ? 'middle' : 'center';

function parseCue(input, cue, regionList) {
  // Remember the original input if we need to throw an error.
  var oInput = input;
  // 4.1 WebVTT timestamp
  function consumeTimeStamp() {
    var ts = parseTimeStamp(input);
    if (ts === null) {
      throw new Error('Malformed timestamp: ' + oInput);
    }
    // Remove time stamp from input.
    input = input.replace(/^[^\sa-zA-Z-]+/, '');
    return ts;
  }

  // 4.4.2 WebVTT cue settings
  function consumeCueSettings(input, cue) {
    var settings = new Settings();

    parseOptions(input, function (k, v) {
      switch (k) {
        case 'region':
          // Find the last region we parsed with the same region id.
          for (var i = regionList.length - 1; i >= 0; i--) {
            if (regionList[i].id === v) {
              settings.set(k, regionList[i].region);
              break;
            }
          }
          break;
        case 'vertical':
          settings.alt(k, v, ['rl', 'lr']);
          break;
        case 'line':
          var vals = v.split(','),
              vals0 = vals[0];
          settings.integer(k, vals0);
          if (settings.percent(k, vals0)) {
            settings.set('snapToLines', false);
          }
          settings.alt(k, vals0, ['auto']);
          if (vals.length === 2) {
            settings.alt('lineAlign', vals[1], ['start', center, 'end']);
          }
          break;
        case 'position':
          vals = v.split(',');
          settings.percent(k, vals[0]);
          if (vals.length === 2) {
            settings.alt('positionAlign', vals[1], ['start', center, 'end', 'line-left', 'line-right', 'auto']);
          }
          break;
        case 'size':
          settings.percent(k, v);
          break;
        case 'align':
          settings.alt(k, v, ['start', center, 'end', 'left', 'right']);
          break;
      }
    }, /:/, /\s/);

    // Apply default values for any missing fields.
    cue.region = settings.get('region', null);
    cue.vertical = settings.get('vertical', '');
    var line = settings.get('line', 'auto');
    if (line === 'auto' && defaults.line === -1) {
      // set numeric line number for Safari
      line = -1;
    }
    cue.line = line;
    cue.lineAlign = settings.get('lineAlign', 'start');
    cue.snapToLines = settings.get('snapToLines', true);
    cue.size = settings.get('size', 100);
    cue.align = settings.get('align', center);
    var position = settings.get('position', 'auto');
    if (position === 'auto' && defaults.position === 50) {
      // set numeric position for Safari
      position = cue.align === 'start' || cue.align === 'left' ? 0 : cue.align === 'end' || cue.align === 'right' ? 100 : 50;
    }
    cue.position = position;
  }

  function skipWhitespace() {
    input = input.replace(/^\s+/, '');
  }

  // 4.1 WebVTT cue timings.
  skipWhitespace();
  cue.startTime = consumeTimeStamp(); // (1) collect cue start time
  skipWhitespace();
  if (input.substr(0, 3) !== '-->') {
    // (3) next characters must match '-->'
    throw new Error('Malformed time stamp (time stamps must be separated by \'-->\'): ' + oInput);
  }
  input = input.substr(3);
  skipWhitespace();
  cue.endTime = consumeTimeStamp(); // (5) collect cue end time

  // 4.1 WebVTT cue settings list.
  skipWhitespace();
  consumeCueSettings(input, cue);
}

function fixLineBreaks(input) {
  return input.replace(/<br(?: \/)?>/gi, '\n');
}

VTTParser.prototype = {
  parse: function parse(data) {
    var self = this;

    // If there is no data then we won't decode it, but will just try to parse
    // whatever is in buffer already. This may occur in circumstances, for
    // example when flush() is called.
    if (data) {
      // Try to decode the data that we received.
      self.buffer += self.decoder.decode(data, { stream: true });
    }

    function collectNextLine() {
      var buffer = self.buffer;
      var pos = 0;

      buffer = fixLineBreaks(buffer);

      while (pos < buffer.length && buffer[pos] !== '\r' && buffer[pos] !== '\n') {
        ++pos;
      }
      var line = buffer.substr(0, pos);
      // Advance the buffer early in case we fail below.
      if (buffer[pos] === '\r') {
        ++pos;
      }
      if (buffer[pos] === '\n') {
        ++pos;
      }
      self.buffer = buffer.substr(pos);
      return line;
    }

    // 3.2 WebVTT metadata header syntax
    function parseHeader(input) {
      parseOptions(input, function (k, v) {
        switch (k) {
          case 'Region':
            // 3.3 WebVTT region metadata header syntax
            console.log('parse region', v);
            //parseRegion(v);
            break;
        }
      }, /:/);
    }

    // 5.1 WebVTT file parsing.
    try {
      var line;
      if (self.state === 'INITIAL') {
        // We can't start parsing until we have the first line.
        if (!/\r\n|\n/.test(self.buffer)) {
          return this;
        }

        line = collectNextLine();

        var m = line.match(/^WEBVTT([ \t].*)?$/);
        if (!m || !m[0]) {
          throw new Error('Malformed WebVTT signature.');
        }

        self.state = 'HEADER';
      }

      var alreadyCollectedLine = false;
      while (self.buffer) {
        // We can't parse a line until we have the full line.
        if (!/\r\n|\n/.test(self.buffer)) {
          return this;
        }

        if (!alreadyCollectedLine) {
          line = collectNextLine();
        } else {
          alreadyCollectedLine = false;
        }

        switch (self.state) {
          case 'HEADER':
            // 13-18 - Allow a header (metadata) under the WEBVTT line.
            if (/:/.test(line)) {
              parseHeader(line);
            } else if (!line) {
              // An empty line terminates the header and starts the body (cues).
              self.state = 'ID';
            }
            continue;
          case 'NOTE':
            // Ignore NOTE blocks.
            if (!line) {
              self.state = 'ID';
            }
            continue;
          case 'ID':
            // Check for the start of NOTE blocks.
            if (/^NOTE($|[ \t])/.test(line)) {
              self.state = 'NOTE';
              break;
            }
            // 19-29 - Allow any number of line terminators, then initialize new cue values.
            if (!line) {
              continue;
            }
            self.cue = new _vttcue2.default(0, 0, '');
            self.state = 'CUE';
            // 30-39 - Check if self line contains an optional identifier or timing data.
            if (line.indexOf('-->') === -1) {
              self.cue.id = line;
              continue;
            }
          // Process line as start of a cue.
          /*falls through*/
          case 'CUE':
            // 40 - Collect cue timings and settings.
            try {
              parseCue(line, self.cue, self.regionList);
            } catch (e) {
              // In case of an error ignore rest of the cue.
              self.cue = null;
              self.state = 'BADCUE';
              continue;
            }
            self.state = 'CUETEXT';
            continue;
          case 'CUETEXT':
            var hasSubstring = line.indexOf('-->') !== -1;
            // 34 - If we have an empty line then report the cue.
            // 35 - If we have the special substring '-->' then report the cue,
            // but do not collect the line as we need to process the current
            // one as a new cue.
            if (!line || hasSubstring && (alreadyCollectedLine = true)) {
              // We are done parsing self cue.
              if (self.oncue) {
                self.oncue(self.cue);
              }
              self.cue = null;
              self.state = 'ID';
              continue;
            }
            if (self.cue.text) {
              self.cue.text += '\n';
            }
            self.cue.text += line;
            continue;
          case 'BADCUE':
            // BADCUE
            // 54-62 - Collect and discard the remaining cue.
            if (!line) {
              self.state = 'ID';
            }
            continue;
        }
      }
    } catch (e) {

      // If we are currently parsing a cue, report what we have.
      if (self.state === 'CUETEXT' && self.cue && self.oncue) {
        self.oncue(self.cue);
      }
      self.cue = null;
      // Enter BADWEBVTT state if header was not parsed correctly otherwise
      // another exception occurred so enter BADCUE state.
      self.state = self.state === 'INITIAL' ? 'BADWEBVTT' : 'BADCUE';
    }
    return this;
  },
  flush: function flush() {
    var self = this;
    try {
      // Finish decoding the stream.
      self.buffer += self.decoder.decode();
      // Synthesize the end of the current cue or region.
      if (self.cue || self.state === 'HEADER') {
        self.buffer += '\n\n';
        self.parse();
      }
      // If we've flushed, parsed, and we're still on the INITIAL state then
      // that means we don't have enough of the stream to parse the first
      // line.
      if (self.state === 'INITIAL') {
        throw new Error('Malformed WebVTT signature.');
      }
    } catch (e) {
      throw e;
    }
    if (self.onflush) {
      self.onflush();
    }
    return this;
  }
};

exports.fixLineBreaks = fixLineBreaks;
exports.default = VTTParser;

/***/ }),
/* 611 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 612 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(964);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./tooltip.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./tooltip.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

// see https://tools.ietf.org/html/rfc1808

/* jshint ignore:start */
(function(root) { 
/* jshint ignore:end */

  var URL_REGEX = /^((?:[^\/;?#]+:)?)(\/\/[^\/\;?#]*)?(.*?)??(;.*?)?(\?.*?)?(#.*?)?$/;
  var FIRST_SEGMENT_REGEX = /^([^\/;?#]*)(.*)$/;
  var SLASH_DOT_REGEX = /(?:\/|^)\.(?=\/)/g;
  var SLASH_DOT_DOT_REGEX = /(?:\/|^)\.\.\/(?!\.\.\/).*?(?=\/)/g;

  var URLToolkit = { // jshint ignore:line
    // If opts.alwaysNormalize is true then the path will always be normalized even when it starts with / or //
    // E.g
    // With opts.alwaysNormalize = false (default, spec compliant)
    // http://a.com/b/cd + /e/f/../g => http://a.com/e/f/../g
    // With opts.alwaysNormalize = true (default, not spec compliant)
    // http://a.com/b/cd + /e/f/../g => http://a.com/e/g
    buildAbsoluteURL: function(baseURL, relativeURL, opts) {
      opts = opts || {};
      // remove any remaining space and CRLF
      baseURL = baseURL.trim();
      relativeURL = relativeURL.trim();
      if (!relativeURL) {
        // 2a) If the embedded URL is entirely empty, it inherits the
        // entire base URL (i.e., is set equal to the base URL)
        // and we are done.
        if (!opts.alwaysNormalize) {
          return baseURL;
        }
        var basePartsForNormalise = this.parseURL(baseURL);
        if (!baseParts) {
          throw new Error('Error trying to parse base URL.');
        }
        basePartsForNormalise.path = URLToolkit.normalizePath(basePartsForNormalise.path);
        return URLToolkit.buildURLFromParts(basePartsForNormalise);
      }
      var relativeParts = this.parseURL(relativeURL);
      if (!relativeParts) {
        throw new Error('Error trying to parse relative URL.');
      }
      if (relativeParts.scheme) {
        // 2b) If the embedded URL starts with a scheme name, it is
        // interpreted as an absolute URL and we are done.
        if (!opts.alwaysNormalize) {
          return relativeURL;
        }
        relativeParts.path = URLToolkit.normalizePath(relativeParts.path);
        return URLToolkit.buildURLFromParts(relativeParts);
      }
      var baseParts = this.parseURL(baseURL);
      if (!baseParts) {
        throw new Error('Error trying to parse base URL.');
      }
      if (!baseParts.netLoc && baseParts.path && baseParts.path[0] !== '/') {
        // If netLoc missing and path doesn't start with '/', assume everthing before the first '/' is the netLoc
        // This causes 'example.com/a' to be handled as '//example.com/a' instead of '/example.com/a'
        var pathParts = FIRST_SEGMENT_REGEX.exec(baseParts.path);
        baseParts.netLoc = pathParts[1];
        baseParts.path = pathParts[2];
      }
      if (baseParts.netLoc && !baseParts.path) {
        baseParts.path = '/';
      }
      var builtParts = {
        // 2c) Otherwise, the embedded URL inherits the scheme of
        // the base URL.
        scheme: baseParts.scheme,
        netLoc: relativeParts.netLoc,
        path: null,
        params: relativeParts.params,
        query: relativeParts.query,
        fragment: relativeParts.fragment
      };
      if (!relativeParts.netLoc) {
        // 3) If the embedded URL's <net_loc> is non-empty, we skip to
        // Step 7.  Otherwise, the embedded URL inherits the <net_loc>
        // (if any) of the base URL.
        builtParts.netLoc = baseParts.netLoc;
        // 4) If the embedded URL path is preceded by a slash "/", the
        // path is not relative and we skip to Step 7.
        if (relativeParts.path[0] !== '/') {
          if (!relativeParts.path) {
            // 5) If the embedded URL path is empty (and not preceded by a
            // slash), then the embedded URL inherits the base URL path
            builtParts.path = baseParts.path;
            // 5a) if the embedded URL's <params> is non-empty, we skip to
            // step 7; otherwise, it inherits the <params> of the base
            // URL (if any) and
            if (!relativeParts.params) {
              builtParts.params = baseParts.params;
              // 5b) if the embedded URL's <query> is non-empty, we skip to
              // step 7; otherwise, it inherits the <query> of the base
              // URL (if any) and we skip to step 7.
              if (!relativeParts.query) {
                builtParts.query = baseParts.query;
              }
            }
          } else {
            // 6) The last segment of the base URL's path (anything
            // following the rightmost slash "/", or the entire path if no
            // slash is present) is removed and the embedded URL's path is
            // appended in its place.
            var baseURLPath = baseParts.path;
            var newPath = baseURLPath.substring(0, baseURLPath.lastIndexOf('/') + 1) + relativeParts.path;
            builtParts.path = URLToolkit.normalizePath(newPath);
          }
        }
      }
      if (builtParts.path === null) {
        builtParts.path = opts.alwaysNormalize ? URLToolkit.normalizePath(relativeParts.path) : relativeParts.path;
      }
      return URLToolkit.buildURLFromParts(builtParts);
    },
    parseURL: function(url) {
      var parts = URL_REGEX.exec(url);
      if (!parts) {
        return null;
      }
      return {
        scheme: parts[1] || '',
        netLoc: parts[2] || '',
        path: parts[3] || '',
        params: parts[4] || '',
        query: parts[5] || '',
        fragment: parts[6] || ''
      };
    },
    normalizePath: function(path) {
      // The following operations are
      // then applied, in order, to the new path:
      // 6a) All occurrences of "./", where "." is a complete path
      // segment, are removed.
      // 6b) If the path ends with "." as a complete path segment,
      // that "." is removed.
      path = path.split('').reverse().join('').replace(SLASH_DOT_REGEX, '');
      // 6c) All occurrences of "<segment>/../", where <segment> is a
      // complete path segment not equal to "..", are removed.
      // Removal of these path segments is performed iteratively,
      // removing the leftmost matching pattern on each iteration,
      // until no matching pattern remains.
      // 6d) If the path ends with "<segment>/..", where <segment> is a
      // complete path segment not equal to "..", that
      // "<segment>/.." is removed.
      while (path.length !== (path = path.replace(SLASH_DOT_DOT_REGEX, '')).length) {} // jshint ignore:line
      return path.split('').reverse().join('');
    },
    buildURLFromParts: function(parts) {
      return parts.scheme + parts.netLoc + parts.path + parts.params + parts.query + parts.fragment;
    }
  };

/* jshint ignore:start */
  if(true)
    module.exports = URLToolkit;
  else if(typeof define === 'function' && define.amd)
    define([], function() { return URLToolkit; });
  else if(typeof exports === 'object')
    exports["URLToolkit"] = URLToolkit;
  else
    root["URLToolkit"] = URLToolkit;
})(this);
/* jshint ignore:end */


/***/ }),
/* 615 */,
/* 616 */,
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NAMES; });
/* unused harmony export SUCCESS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_redux_helpers_create_async_actions__ = __webpack_require__(26);


var ACTIONS = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_redux_helpers_create_async_actions__["a" /* default */])('CLIENT.VIDEO.REMOVE', ['SUCCESS']);
var NAMES = ACTIONS.NAMES;
var SUCCESS = ACTIONS.SUCCESS;




/* harmony default export */ __webpack_exports__["b"] = (function (videoIds) {
  return function (dispatch) {
    dispatch(SUCCESS({ videoIds: videoIds }, {}));
  };
});

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  IN_FRAME: 1,
  EXPANDED_VIEW: 2
});

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  FEATURED_VIDEO: 1,
  CHANNEL_COVER: 2
});

/***/ }),
/* 620 */,
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TAB_NAMES; });
var TAB_NAMES = {
  MAIN: 'main',
  CHANNEL: 'channel',
  LAYOUT: 'layout',
  SETTINGS: 'settings',
  DESIGN: 'design'
};

/* harmony default export */ __webpack_exports__["b"] = ([TAB_NAMES.MAIN, TAB_NAMES.CHANNEL, TAB_NAMES.LAYOUT, TAB_NAMES.SETTINGS, TAB_NAMES.DESIGN]);

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ('en');

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  NOT_SUPPORTED: 'notSupported',
  QUOTA_EXCEEDED: 'wmp_error.quota_exceeded',
  INVALID_FILE: 'wmp_error.invalid_file',
  INCORRECT_FILE_INFO: 'wmp_error.incorrect_file_info',
  FILE_SIZE_EXCEEDED_LIMIT: 'wmp_error.file_size_exceeded_limit',
  UNSUPPORTED_CODEC: 'wmp_error.unsupported_codec',
  NETWORK_ISSUE: 'wmp_error.network_issue'
});

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = hasTrailer;
/* harmony export (immutable) */ __webpack_exports__["c"] = isPreviewEnabled;
/* harmony export (immutable) */ __webpack_exports__["a"] = getPreviewType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_constants_preview_types__ = __webpack_require__(368);


function hasTrailer(video) {
  return Boolean(video.trailerFileName);
}

function isPreviewEnabled(video) {
  return video.previewType !== __WEBPACK_IMPORTED_MODULE_0_shared_constants_preview_types__["a" /* previewTypes */].NONE;
}

function getPreviewType(video) {
  return video.previewType || __WEBPACK_IMPORTED_MODULE_0_shared_constants_preview_types__["a" /* previewTypes */].FIRST_20_SEC;
}

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getTrailerTypeString */
/* harmony export (immutable) */ __webpack_exports__["b"] = getPlayButtonTypeString;
/* harmony export (immutable) */ __webpack_exports__["a"] = getOpenedEventParams;
/* harmony export (immutable) */ __webpack_exports__["c"] = getVideoSelectedEventParams;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_constants_preview_types__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_utils_performance__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_widget_utils_overlay_buttons_utils__ = __webpack_require__(547);





function getTrailerTypeString(videoItem) {
  if (!videoItem) {
    return 'none';
  }

  var trailerType = videoItem.trailerType;

  trailerType = trailerType || __WEBPACK_IMPORTED_MODULE_0_shared_constants_preview_types__["a" /* previewTypes */].FIRST_20_SEC;

  switch (trailerType) {
    case __WEBPACK_IMPORTED_MODULE_0_shared_constants_preview_types__["a" /* previewTypes */].FIRST_20_SEC:
      return 'preview';
    case __WEBPACK_IMPORTED_MODULE_0_shared_constants_preview_types__["a" /* previewTypes */].TRAILER:
      return 'trailer';
    case __WEBPACK_IMPORTED_MODULE_0_shared_constants_preview_types__["a" /* previewTypes */].NONE:
    default:
      return 'none';
  }
}

function getMainItemString(settings, showChannelCover) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_widget_utils_overlay_buttons_utils__["a" /* shouldShowChannelCover */])(settings, showChannelCover) ? 'channelCover' : 'featuredVid';
}

function getPlayButtonTypeString(channelData, videoItem) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_widget_utils_overlay_buttons_utils__["b" /* getPlayButtonType */])(channelData, videoItem) === __WEBPACK_IMPORTED_MODULE_2_widget_utils_overlay_buttons_utils__["c" /* PLAY_BUTTON_TYPES */].PLAY ? 'playVid' : getTrailerTypeString(videoItem);
}

function getOpenedEventParams(settings, channelData, videoItem, showChannelCover) {
  var playType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_widget_utils_overlay_buttons_utils__["b" /* getPlayButtonType */])(channelData, videoItem);

  return {
    loading_time: __WEBPACK_IMPORTED_MODULE_1_shared_utils_performance__["c" /* default */].vars.appFullyRendered,
    buyTypeDisplayed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_widget_utils_overlay_buttons_utils__["d" /* getBuyButtonDisplayTypeWhenInOverlay */])({
      settings: settings,
      videoItem: videoItem,
      channelData: channelData,
      showChannelCover: showChannelCover
    }),
    trailerType: getTrailerTypeString(videoItem),
    isTrailerBtn: playType === __WEBPACK_IMPORTED_MODULE_2_widget_utils_overlay_buttons_utils__["c" /* PLAY_BUTTON_TYPES */].TRAILER_OR_PREVIEW,
    isSubscriptionBtn: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_widget_utils_overlay_buttons_utils__["e" /* shouldShowSubscribeButton */])({ settings: settings, videoItem: videoItem, channelData: channelData, showChannelCover: showChannelCover }),
    mainItem: getMainItemString(settings, showChannelCover)
  };
}

function getVideoSelectedEventParams(_ref) {
  var appSettings = _ref.appSettings,
      channelData = _ref.channelData,
      videoItem = _ref.videoItem;

  var buyType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_widget_utils_overlay_buttons_utils__["d" /* getBuyButtonDisplayTypeWhenInOverlay */])({
    settings: appSettings,
    videoItem: videoItem,
    channelData: channelData,
    showChannelCover: false
  });
  var playType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_widget_utils_overlay_buttons_utils__["b" /* getPlayButtonType */])(channelData, videoItem);

  return {
    buyType: buyType,
    channelID: channelData.id,
    trailerType: getTrailerTypeString(videoItem),
    buyBtn: buyType === __WEBPACK_IMPORTED_MODULE_2_widget_utils_overlay_buttons_utils__["f" /* BUY_BUTTON_DISPLAY_TYPES */].BUY,
    trailerBtn: playType === __WEBPACK_IMPORTED_MODULE_2_widget_utils_overlay_buttons_utils__["c" /* PLAY_BUTTON_TYPES */].TRAILER_OR_PREVIEW,
    playBtn: playType === __WEBPACK_IMPORTED_MODULE_2_widget_utils_overlay_buttons_utils__["c" /* PLAY_BUTTON_TYPES */].PLAY,
    videoID: videoItem.id
  };
}

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getQueryParams;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__query_string__ = __webpack_require__(254);


function getQueryParams(url) {
  if (!url) {
    return {};
  }
  var query = url.match(/(?:\?|$)([^#]*)/)[1];
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__query_string__["a" /* parse */])(query);
}

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_TRANSLATIONS; });
/* unused harmony export isVisible */
/* harmony export (immutable) */ __webpack_exports__["a"] = renderPurchaseButtonText;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_utils_deal_info_helpers__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_translations_overlay_common_translations__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__format_message_with_deal_info__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_widget_ui_selectors_video_access__ = __webpack_require__(94);


var _DEFAULT_TRANSLATIONS;






var DEFAULT_TRANSLATIONS = (_DEFAULT_TRANSLATIONS = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DEFAULT_TRANSLATIONS, __WEBPACK_IMPORTED_MODULE_4_widget_ui_selectors_video_access__["c" /* FULL_ACCESS_ACTION_NAMES */].BUY, __WEBPACK_IMPORTED_MODULE_2_shared_translations_overlay_common_translations__["a" /* default */].buy), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DEFAULT_TRANSLATIONS, __WEBPACK_IMPORTED_MODULE_4_widget_ui_selectors_video_access__["c" /* FULL_ACCESS_ACTION_NAMES */].RENT, __WEBPACK_IMPORTED_MODULE_2_shared_translations_overlay_common_translations__["a" /* default */].rent), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DEFAULT_TRANSLATIONS, __WEBPACK_IMPORTED_MODULE_4_widget_ui_selectors_video_access__["c" /* FULL_ACCESS_ACTION_NAMES */].BUY_OR_RENT, __WEBPACK_IMPORTED_MODULE_2_shared_translations_overlay_common_translations__["a" /* default */].buyFrom), _DEFAULT_TRANSLATIONS);

var PURCHASE_ACTION_NAMES = _.keys(DEFAULT_TRANSLATIONS);

/**
 * Is purchase video button visible
 * @param props {Object}
 * @param props.channel {Object}
 * @param props.video {Object}
 * @return {Boolean}
 */
function isVisible(_ref) {
  var channel = _ref.channel,
      video = _ref.video;

  return _.includes(PURCHASE_ACTION_NAMES, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_widget_ui_selectors_video_access__["d" /* getFullAccessActionName */])(channel, video));
}

/**
 * Purchase video button text
 * @param props {Object}
 * @param props.channel {Object}
 * @param props.video {Object}
 * @param props.translations {Object} see DEFAULT_TRANSLATIONS
 * @return {React.Component}
 */
function renderPurchaseButtonText(_ref2) {
  var channel = _ref2.channel,
      video = _ref2.video,
      _ref2$translations = _ref2.translations,
      translations = _ref2$translations === undefined ? DEFAULT_TRANSLATIONS : _ref2$translations;

  switch (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_widget_ui_selectors_video_access__["d" /* getFullAccessActionName */])(channel, video)) {
    case __WEBPACK_IMPORTED_MODULE_4_widget_ui_selectors_video_access__["c" /* FULL_ACCESS_ACTION_NAMES */].BUY:
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__format_message_with_deal_info__["a" /* default */])(translations[__WEBPACK_IMPORTED_MODULE_4_widget_ui_selectors_video_access__["c" /* FULL_ACCESS_ACTION_NAMES */].BUY], __WEBPACK_IMPORTED_MODULE_1_shared_utils_deal_info_helpers__["b" /* getSalePriceInfo */](video.dealInfo));
    case __WEBPACK_IMPORTED_MODULE_4_widget_ui_selectors_video_access__["c" /* FULL_ACCESS_ACTION_NAMES */].RENT:
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__format_message_with_deal_info__["a" /* default */])(translations[__WEBPACK_IMPORTED_MODULE_4_widget_ui_selectors_video_access__["c" /* FULL_ACCESS_ACTION_NAMES */].RENT], __WEBPACK_IMPORTED_MODULE_1_shared_utils_deal_info_helpers__["c" /* getRentPriceInfo */](video.dealInfo));
    case __WEBPACK_IMPORTED_MODULE_4_widget_ui_selectors_video_access__["c" /* FULL_ACCESS_ACTION_NAMES */].BUY_OR_RENT:
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__format_message_with_deal_info__["a" /* default */])(translations[__WEBPACK_IMPORTED_MODULE_4_widget_ui_selectors_video_access__["c" /* FULL_ACCESS_ACTION_NAMES */].BUY_OR_RENT], __WEBPACK_IMPORTED_MODULE_1_shared_utils_deal_info_helpers__["d" /* getMinPriceInfo */](video.dealInfo));
    default:
      return null;
  }
}

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_TRANSLATIONS; });
/* harmony export (immutable) */ __webpack_exports__["c"] = isVisible;
/* harmony export (immutable) */ __webpack_exports__["a"] = renderPlayButtonText;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_translations_overlay_common_translations__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_widget_ui_selectors_video_access__ = __webpack_require__(94);


var _DEFAULT_TRANSLATIONS;

/* eslint-disable react/prop-types */





var DEFAULT_TRANSLATIONS = (_DEFAULT_TRANSLATIONS = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DEFAULT_TRANSLATIONS, __WEBPACK_IMPORTED_MODULE_3_widget_ui_selectors_video_access__["e" /* AVAILABLE_VIDEO_TYPES */].FULL, __WEBPACK_IMPORTED_MODULE_2_shared_translations_overlay_common_translations__["a" /* default */].playVideo), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DEFAULT_TRANSLATIONS, __WEBPACK_IMPORTED_MODULE_3_widget_ui_selectors_video_access__["e" /* AVAILABLE_VIDEO_TYPES */].TRAILER, __WEBPACK_IMPORTED_MODULE_2_shared_translations_overlay_common_translations__["a" /* default */].watchTrailer), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DEFAULT_TRANSLATIONS, __WEBPACK_IMPORTED_MODULE_3_widget_ui_selectors_video_access__["e" /* AVAILABLE_VIDEO_TYPES */].FIRST_20_SEC, __WEBPACK_IMPORTED_MODULE_2_shared_translations_overlay_common_translations__["a" /* default */].watchPreview), _DEFAULT_TRANSLATIONS);

/**
 * Is channel play button visible
 * @param props {Object}
 * @param props.channel {Object}
 * @param props.video {Object}
 * @param props.currentSiteUser {Object}
 * @return {Boolean}
 */
function isVisible(_ref) {
  var channel = _ref.channel,
      video = _ref.video,
      currentSiteUser = _ref.currentSiteUser;

  return Boolean(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_widget_ui_selectors_video_access__["f" /* getAvailableVideoType */])(channel, video, currentSiteUser));
}

/**
 * Channel play button text
 * @param props {Object}
 * @param props.channel {Object}
 * @param props.video {Object}
 * @param props.currentSiteUser {Object}
 * @param props.translations {Object} see DEFAULT_TRANSLATIONS
 * @return {React.Component}
 */
function renderPlayButtonText(_ref2) {
  var channel = _ref2.channel,
      video = _ref2.video,
      currentSiteUser = _ref2.currentSiteUser,
      _ref2$translations = _ref2.translations,
      translations = _ref2$translations === undefined ? DEFAULT_TRANSLATIONS : _ref2$translations;

  var type = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_widget_ui_selectors_video_access__["f" /* getAvailableVideoType */])(channel, video, currentSiteUser);

  if (!type) {
    return null;
  }
  return React.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedMessage */], translations[type]);
}

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* defineMessages */])({
  publisher: {
    id: 'info-overlay.created-by',
    defaultMessage: 'By {author}'
  },
  cast: {
    id: 'info-overlay.cast',
    defaultMessage: 'cast'
  },
  crew: {
    id: 'info-overlay.crew',
    defaultMessage: 'crew'
  }
}));

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* defineMessages */])({
  share: {
    id: 'share-overlay.share',
    defaultMessage: 'Share this video'
  }
}));

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FacebookExternal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_widget_player_widget_utils_attach_script__ = __webpack_require__(390);







var _desc, _value, _class, _class2, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}






var scriptApiUrl = 'https://connect.facebook.net/en_US/sdk.js';
var scriptPromise = null;

var FacebookExternal = (_class = (_temp = _class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(FacebookExternal, _React$Component);

  function FacebookExternal(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, FacebookExternal);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (FacebookExternal.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(FacebookExternal)).call(this, props));

    _this.didSubscribe = false;


    _this.player = null;

    _this.state = {
      isReady: false
    };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(FacebookExternal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.fbAsyncInit = this.fbAsyncInit;

      // load once
      if (this.isScriptLoaded) {
        this.fbAsyncInit();
      } else if (!scriptPromise) {
        scriptPromise = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_widget_player_widget_utils_attach_script__["a" /* default */])(scriptApiUrl);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.src === this.props.src) {
        this.setSettings(nextProps, this.props);
      } else {
        this.setState({ isReady: false });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var propsToPick = ['src', 'width', 'height'];
      var prev = _.pick(prevProps, propsToPick);
      var current = _.pick(this.props, propsToPick);

      if (!_.isEqual(prev, current)) {
        this.fbAsyncInit();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.fbAsyncInit = null;
      window.FB.Event.unsubscribe('xfbml.ready', this.handleFacebookReady);
    }
  }, {
    key: 'fbAsyncInit',
    value: function fbAsyncInit() {
      window.FB.init({
        xfbml: true,
        version: 'v2.5'
      });

      if (this.didSubscribe) {
        return;
      }

      window.FB.Event.subscribe('xfbml.ready', this.handleFacebookReady);
      this.didSubscribe = true;
    }
  }, {
    key: 'handleFacebookReady',
    value: function handleFacebookReady(message) {
      if (message.type === 'video') {
        this.onReady(message.instance);
      }
    }
  }, {
    key: 'onReady',
    value: function onReady(player) {
      this.player = player;
      this.setState({ isReady: true });
      this.setSettings(this.props);
    }
  }, {
    key: 'setSettings',
    value: function setSettings(_ref) {
      var paused = _ref.paused,
          muted = _ref.muted;
      var prevProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!this.player || !this.state.isReady) {
        return null;
      }

      if (prevProps.paused !== paused) {
        this.togglePaused(paused);
      }

      this.toggleMute(muted);
    }
  }, {
    key: 'togglePaused',
    value: function togglePaused(paused) {
      if (paused) {
        this.player.pause();
      } else {
        this.player.play();
      }
    }
  }, {
    key: 'toggleMute',
    value: function toggleMute(muted) {
      if (muted) {
        this.player.mute();
      } else {
        this.player.unmute();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          src = _props.src,
          className = _props.className,
          width = _props.width,
          height = _props.height;


      return React.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()('fb-video', className),
        'data-href': src,
        'data-width': Math.ceil(width),
        'data-height': Math.ceil(height),
        'data-allowfullscreen': 'true' });
    }
  }, {
    key: 'isScriptLoaded',
    get: function get() {
      return _.has(window, 'FB');
    }
  }]);

  return FacebookExternal;
}(React.Component), _class2.propTypes = {
  src: React.PropTypes.string.isRequired,
  onPlay: React.PropTypes.func,
  width: React.PropTypes.number,
  height: React.PropTypes.number,
  className: React.PropTypes.string,
  simple: React.PropTypes.bool,
  mobileMode: React.PropTypes.bool,
  showControls: React.PropTypes.bool,
  paused: React.PropTypes.bool,
  loop: React.PropTypes.bool,
  muted: React.PropTypes.bool
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'fbAsyncInit', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'fbAsyncInit'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleFacebookReady', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'handleFacebookReady'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'onReady', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'onReady'), _class.prototype)), _class);


/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VimeoExternal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_widget_player_widget_utils_attach_script__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_utils_query_string__ = __webpack_require__(254);








var _desc, _value, _class, _class2, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}






var scriptApiUrl = 'https://player.vimeo.com/api/player.js';
var DEFAULT_VOLUME = 1;

var scriptPromise = null;

var VimeoExternal = (_class = (_temp = _class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(VimeoExternal, _React$Component);

  function VimeoExternal(props) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, VimeoExternal);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (VimeoExternal.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(VimeoExternal)).call(this, props));

    _this.player = null;
    _this.__volume = 0;

    // load once
    scriptPromise = scriptPromise || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_widget_player_widget_utils_attach_script__["a" /* default */])(scriptApiUrl);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(VimeoExternal, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.src === this.props.src) {
        this.setSettings(nextProps, this.props);
      }
    }
  }, {
    key: 'setSettings',
    value: function setSettings(_ref) {
      var paused = _ref.paused,
          loop = _ref.loop,
          muted = _ref.muted;
      var prevProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!this.player) {
        return null;
      }

      if (prevProps.paused !== paused) {
        this.togglePaused(paused);
      }

      this.toggleLoop(loop);
      this.toggleMute(muted);
    }
  }, {
    key: 'togglePaused',
    value: function togglePaused(paused) {
      var _this2 = this;

      this.player.getPaused().then(function (currentPaused) {
        if (paused && !currentPaused) {
          _this2.player.pause();
        }

        if (!paused && currentPaused) {
          _this2.player.play();
        }
      });
    }
  }, {
    key: 'toggleLoop',
    value: function toggleLoop(loop) {
      if (loop) {
        this.player.setLoop(true);
      } else {
        this.player.setLoop(false);
      }
    }
  }, {
    key: 'toggleMute',
    value: function toggleMute(muted) {
      var _this3 = this;

      if (muted) {
        this.player.getVolume().then(function (volume) {
          _this3.__volume = volume;
        });
        this.player.setVolume(0);
      } else {
        var volume = this.__volume === 0 ? DEFAULT_VOLUME : this.__volume;
        this.player.setVolume(volume);
        this.__volume = 0;
      }
    }
  }, {
    key: 'buildUrl',
    value: function buildUrl(_ref2) {
      var src = _ref2.src,
          simple = _ref2.simple,
          mobileMode = _ref2.mobileMode;

      var query = {};

      if (simple || mobileMode) {
        query.badge = '0';
        query.portrait = '0';
        query.title = '0';
      }

      return '' + src + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_shared_utils_query_string__["b" /* stringify */])(query);
    }
  }, {
    key: 'setIFrame',
    value: function setIFrame(node) {
      var _this4 = this;

      if (!node) {
        this.player = null;
        return;
      }

      this.iframe = node;

      scriptPromise.then(function () {
        // Vimeo Player ready
        _this4.player = new window.Vimeo.Player(node);
        _this4.setSettings(_this4.props);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var props = _.pick(this.props, 'className', 'width', 'height');

      return React.createElement('iframe', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, props, {
        src: this.buildUrl(this.props),
        frameBorder: '0',
        allowFullScreen: true,
        ref: this.setIFrame }));
    }
  }]);

  return VimeoExternal;
}(React.Component), _class2.propTypes = {
  src: React.PropTypes.string.isRequired,
  onPlay: React.PropTypes.func,
  width: React.PropTypes.number,
  height: React.PropTypes.number,
  className: React.PropTypes.string,
  simple: React.PropTypes.bool,
  mobileMode: React.PropTypes.bool,
  showControls: React.PropTypes.bool,
  paused: React.PropTypes.bool,
  loop: React.PropTypes.bool,
  muted: React.PropTypes.bool
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'setIFrame', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'setIFrame'), _class.prototype)), _class);


/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return YoutubeExternal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_utils_wix_sdk__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_widget_player_widget_utils_attach_script__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_utils_query_string__ = __webpack_require__(254);








var _desc, _value, _class, _class2, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}








var locale = __WEBPACK_IMPORTED_MODULE_8_shared_utils_wix_sdk__["a" /* default */].Utils.getLocale();

var scriptApiUrl = 'https://www.youtube.com/iframe_api';
var scriptPromise = null;

var YoutubeExternal = (_class = (_temp = _class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(YoutubeExternal, _React$Component);

  function YoutubeExternal(props) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, YoutubeExternal);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (YoutubeExternal.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(YoutubeExternal)).call(this, props));

    _this.player = null;

    _this.state = {
      isReady: false
    };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(YoutubeExternal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.onYouTubeIframeAPIReady = this.onYouTubeIframeAPIReady;

      // load once
      if (this.isScriptLoaded) {
        this.onYouTubeIframeAPIReady();
      } else if (!scriptPromise) {
        scriptPromise = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_widget_player_widget_utils_attach_script__["a" /* default */])(scriptApiUrl);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.src === this.props.src) {
        this.setSettings(nextProps, this.props);
      } else {
        this.setState({ isReady: false });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.onYouTubeIframeAPIReady = null;
    }
  }, {
    key: 'onYouTubeIframeAPIReady',
    value: function onYouTubeIframeAPIReady() {
      void new window.YT.Player(this.iframe, {
        events: {
          onReady: this.onReady
        }
      });
    }
  }, {
    key: 'onReady',
    value: function onReady(_ref) {
      var target = _ref.target;

      this.player = target;
      this.setState({ isReady: true });
      this.setSettings(this.props);
    }
  }, {
    key: 'setSettings',
    value: function setSettings(_ref2) {
      var paused = _ref2.paused,
          loop = _ref2.loop,
          muted = _ref2.muted;
      var prevProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!this.player || !this.state.isReady) {
        return null;
      }

      if (prevProps.paused !== paused) {
        this.togglePaused(paused);
      }

      this.toggleLoop(loop);
      this.toggleMute(muted);
    }
  }, {
    key: 'togglePaused',
    value: function togglePaused(paused) {
      if (paused) {
        this.player.pauseVideo();
      } else {
        this.player.playVideo();
      }
    }
  }, {
    key: 'toggleLoop',
    value: function toggleLoop(loop) {
      if (loop) {
        var _player$getVideoData = this.player.getVideoData(),
            video_id = _player$getVideoData.video_id;
        // need load playlist to set loop to true
        // but loadPlay list sets video to the beginning


        this.player.loadPlaylist(video_id);
        this.player.setLoop(true);
      } else {
        this.player.setLoop(false);
      }
    }
  }, {
    key: 'toggleMute',
    value: function toggleMute(muted) {
      if (muted) {
        this.player.mute();
      } else {
        this.player.unMute();
      }
    }
  }, {
    key: 'buildUrl',
    value: function buildUrl(_ref3) {
      var src = _ref3.src,
          simple = _ref3.simple,
          mobileMode = _ref3.mobileMode,
          showControls = _ref3.showControls;
      var _window$location = window.location,
          protocol = _window$location.protocol,
          hostname = _window$location.hostname,
          port = _window$location.port;


      var origin = protocol + '//' + hostname + (port ? ':' : '') + port;

      var query = {
        enablejsapi: '1',
        hl: locale,
        rel: '0',
        origin: origin
      };

      if (simple || mobileMode) {
        query.showinfo = '0';
      }
      if (mobileMode) {
        query.playsinline = '0';
      }
      if (!showControls) {
        query.controls = '0';
      }

      return '' + src + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_shared_utils_query_string__["b" /* stringify */])(query);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var props = _.pick(this.props, 'className', 'width', 'height');

      return React.createElement('iframe', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, props, {
        src: this.buildUrl(this.props),
        frameBorder: '0',
        allowFullScreen: true,
        ref: function ref(node) {
          return _this2.iframe = node;
        } }));
    }
  }, {
    key: 'isScriptLoaded',
    get: function get() {
      return _.has(window, 'YT.Player');
    }
  }]);

  return YoutubeExternal;
}(React.Component), _class2.propTypes = {
  src: React.PropTypes.string.isRequired,
  onPlay: React.PropTypes.func,
  width: React.PropTypes.number,
  height: React.PropTypes.number,
  className: React.PropTypes.string,
  simple: React.PropTypes.bool,
  mobileMode: React.PropTypes.bool,
  showControls: React.PropTypes.bool,
  paused: React.PropTypes.bool,
  loop: React.PropTypes.bool,
  muted: React.PropTypes.bool
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onYouTubeIframeAPIReady', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'onYouTubeIframeAPIReady'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'onReady', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'onReady'), _class.prototype)), _class);


/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScrollbarWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_widget_player_widget_utils_wix_connect__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__scrollbar_wrapper_styl__ = __webpack_require__(1503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__scrollbar_wrapper_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__scrollbar_wrapper_styl__);






var _dec, _class, _class2, _temp;





var ScrollbarWrapper = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_widget_player_widget_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_6__scrollbar_wrapper_styl___default.a), _dec(_class = (_temp = _class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ScrollbarWrapper, _React$Component);

  function ScrollbarWrapper() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ScrollbarWrapper);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ScrollbarWrapper.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ScrollbarWrapper)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ScrollbarWrapper, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          children = _props.children;


      return React.createElement(
        'div',
        { styleName: 'scrollbar-wrapper',
          className: className },
        children
      );
    }
  }]);

  return ScrollbarWrapper;
}(React.Component), _class2.propTypes = {
  children: React.PropTypes.any,
  className: React.PropTypes.string
}, _temp)) || _class);


/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_widget_player_widget_components_player_player__ = __webpack_require__(1280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_widget_player_widget_components_social_share_social_share__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_widget_player_widget_components_player_overlay_actions_overlay_action_utils__ = __webpack_require__(388);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0_widget_player_widget_components_player_player__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1_widget_player_widget_components_social_share_social_share__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2_widget_player_widget_components_player_overlay_actions_overlay_action_utils__["a"]; });







/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_widget_player_widget_components_player_player__["a" /* default */]);

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _getOwnPropertyDescriptor = __webpack_require__(12);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);

  if (desc === undefined) {
    var parent = (0, _getPrototypeOf2.default)(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty
  , prefix = '~';

/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @api private
 */
function Events() {}

//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
  Events.prototype = Object.create(null);

  //
  // This hack is needed because the `__proto__` property is still inherited in
  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
  //
  if (!new Events().__proto__) prefix = false;
}

/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {Mixed} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @api private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @api public
 */
function EventEmitter() {
  this._events = new Events();
  this._eventsCount = 0;
}

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @api public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var names = []
    , events
    , name;

  if (this._eventsCount === 0) return names;

  for (name in (events = this._events)) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Boolean} exists Only check if there are listeners.
 * @returns {Array|Boolean}
 * @api public
 */
EventEmitter.prototype.listeners = function listeners(event, exists) {
  var evt = prefix ? prefix + event : event
    , available = this._events[evt];

  if (exists) return !!available;
  if (!available) return [];
  if (available.fn) return [available.fn];

  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
    ee[i] = available[i].fn;
  }

  return ee;
};

/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @api public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return false;

  var listeners = this._events[evt]
    , len = arguments.length
    , args
    , i;

  if (listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1: return listeners.fn.call(listeners.context), true;
      case 2: return listeners.fn.call(listeners.context, a1), true;
      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len -1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length
      , j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1: listeners[i].fn.call(listeners[i].context); break;
        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
        default:
          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Add a listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  var listener = new EE(fn, context || this)
    , evt = prefix ? prefix + event : event;

  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
  else if (!this._events[evt].fn) this._events[evt].push(listener);
  else this._events[evt] = [this._events[evt], listener];

  return this;
};

/**
 * Add a one-time listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  var listener = new EE(fn, context || this, true)
    , evt = prefix ? prefix + event : event;

  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
  else if (!this._events[evt].fn) this._events[evt].push(listener);
  else this._events[evt] = [this._events[evt], listener];

  return this;
};

/**
 * Remove the listeners of a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {Mixed} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return this;
  if (!fn) {
    if (--this._eventsCount === 0) this._events = new Events();
    else delete this._events[evt];
    return this;
  }

  var listeners = this._events[evt];

  if (listeners.fn) {
    if (
         listeners.fn === fn
      && (!once || listeners.once)
      && (!context || listeners.context === context)
    ) {
      if (--this._eventsCount === 0) this._events = new Events();
      else delete this._events[evt];
    }
  } else {
    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
      if (
           listeners[i].fn !== fn
        || (once && !listeners[i].once)
        || (context && listeners[i].context !== context)
      ) {
        events.push(listeners[i]);
      }
    }

    //
    // Reset the array, or remove it completely if we have no more listeners.
    //
    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
    else if (--this._eventsCount === 0) this._events = new Events();
    else delete this._events[evt];
  }

  return this;
};

/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {String|Symbol} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  var evt;

  if (event) {
    evt = prefix ? prefix + event : event;
    if (this._events[evt]) {
      if (--this._eventsCount === 0) this._events = new Events();
      else delete this._events[evt];
    }
  } else {
    this._events = new Events();
    this._eventsCount = 0;
  }

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// This function doesn't apply anymore.
//
EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
  return this;
};

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;

//
// Expose the module.
//
if (true) {
  module.exports = EventEmitter;
}


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(129),
    root = __webpack_require__(81);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 639 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(335);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(966);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js??ref--2-3!./core.styl", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js??ref--2-3!./core.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1177);


/***/ }),
/* 643 */
/***/ (function(module, exports) {

module.exports = ReactDOM;

/***/ }),
/* 644 */,
/* 645 */,
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_default_settings_channel_video_list_values__ = __webpack_require__(379);


/* harmony default export */ __webpack_exports__["a"] = ({
  EXPAND_ON_CLICK: __WEBPACK_IMPORTED_MODULE_0_default_settings_channel_video_list_values__["a" /* default */].EXPAND_ON_CLICK,
  NEVER_SHOW: __WEBPACK_IMPORTED_MODULE_0_default_settings_channel_video_list_values__["a" /* default */].NEVER_SHOW
});

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  ON_VIDEOS: 1,
  BELOW_VIDEOS: 2
});

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  SQUARE: 1,
  ROUND: 2
});

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  ICON_WITH_TEXT: 1,
  ICON: 2
});

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  TOP_RIGHT: 'tr',
  TOP: 't',
  TOP_LEFT: 'tr',
  RIGHT: 'r',
  CENTER: 'c',
  LEFT: 'l',
  BOTTOM_RIGHT: 'br',
  BOTTOM: 'b',
  BOTTOM_LEFT: 'bl'
});

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  VIDEO_PREVIEW: 1,
  COVER_IMAGE: 2
});

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  CENTER: 1,
  BOTTOM: 2
});

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = FixedInIFrame;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_portal__ = __webpack_require__(1479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_portal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_portal__);


var fixedStyle = {
  position: 'fixed'
};

function FixedInIFrame(_ref) {
  var children = _ref.children,
      className = _ref.className,
      style = _ref.style;

  return React.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react_portal___default.a,
    { isOpened: true },
    React.createElement(
      'div',
      { style: _.assign({}, style, fixedStyle),
        className: className },
      children
    )
  );
}

FixedInIFrame.propTypes = {
  children: React.PropTypes.element,
  className: React.PropTypes.string,
  style: React.PropTypes.object
};

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createStub; });
var NEW_RELIC_METHODS = ['addPageAction', 'addToTrace', 'finished', 'noticeError', 'setCustomAttribute', 'setErrorHandler', 'setPageViewName'];

function stubCreator(methods) {
  return function createStub() {
    return _.reduce(methods, function (stub, method) {
      stub[method] = _.noop;
      return stub;
    }, {});
  };
}

var createStub = stubCreator(NEW_RELIC_METHODS);

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_bi_bi_with_state_defaults__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_redux_server_actions_vod_settings_update__ = __webpack_require__(162);



var sendBiEvent = void 0;

/* harmony default export */ __webpack_exports__["a"] = (function (biHandlers) {
  return function (_ref) {
    var getState = _ref.getState,
        dispatch = _ref.dispatch;
    return function (next) {
      return function (action) {
        var previousState = getState();
        var returnValue = next(action); // eslint-disable-line callback-return
        var type = action.type;

        var handler = biHandlers[type];

        if (!sendBiEvent) {
          sendBiEvent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_bi_bi_with_state_defaults__["b" /* createSender */])(getState());
        }

        if (handler) {
          handler({
            sendBiEvent: sendBiEvent,
            state: getState(),
            previousState: previousState,
            action: action,
            updateVodSettings: function updateVodSettings(data) {
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_redux_server_actions_vod_settings_update__["a" /* default */])(data)(dispatch, getState);
            }
          });
        }

        return returnValue;
      };
    };
  };
});

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = valid;
/* harmony export (immutable) */ __webpack_exports__["a"] = parse;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

// some params (like bi token) look like GUID but there are not valid GUIDS
var GUID_LIKE_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

var typeValidators = {
  guid: function guid(val) {
    return val && _.isString(val) && GUID_LIKE_RE.test(val);
  },
  bool: function bool(val) {
    return _.isBoolean(val);
  },
  numeric: function numeric(val) {
    return _.isNumber(val);
  }
};

var validators = {
  length: function length(val, _length) {
    return val && !_.isUndefined(val.length) && val.length === _length;
  },
  maxLength: function maxLength(val, _maxLength) {
    return val && !_.isUndefined(val.length) && val.length <= _maxLength;
  },
  values: function values(val, _values) {
    return _values && _.includes(_values, val);
  },
  type: function type(val, _type) {
    if (typeValidators[_type]) {
      return typeValidators[_type](val);
    }
    return (typeof val === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(val)) === _type;
  }
};

var parsers = {
  subStr: function subStr(val, length) {
    if (val && val.substr) {
      return val.substr(0, Math.min(val.length, length));
    }
    return val;
  }
};

function valid(value, restrictions) {
  for (var key in restrictions) {
    if (validators[key] && !validators[key](value, restrictions[key])) {
      return false;
    }
  }
  return true;
}

function parse(value, restrictions) {
  if (_.isFunction(value)) {
    value = value();
  }
  for (var key in restrictions) {
    if (restrictions.hasOwnProperty(key)) {
      value = parsers[key] ? parsers[key](value, restrictions[key]) : value;
    }
  }
  return value;
}

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var TRANSACTION_START_TYPE = 'requested';

var userTransactions = {
  status: {},

  getEventName: function getEventName(_ref) {
    var eventName = _ref.eventName;

    return eventName.split('.').slice(0, -1).join('.');
  },
  getTransactionType: function getTransactionType(_ref2) {
    var eventName = _ref2.eventName;

    return _.last(eventName.split('.'));
  },
  isTransaction: function isTransaction(_ref3) {
    var eventName = _ref3.eventName,
        previousEventName = _ref3.previousEventName;

    var isTransactionStartEvent = userTransactions.getTransactionType({ eventName: eventName }) === TRANSACTION_START_TYPE;
    return isTransactionStartEvent || previousEventName;
  },
  hasActive: function hasActive(eventName) {
    return Boolean(userTransactions.status[eventName]);
  },
  start: function start(eventName) {
    userTransactions.status[eventName] = true;
  },
  complete: function complete(eventName) {
    return delete userTransactions.status[eventName];
  },
  getTransactionResult: function getTransactionResult(event) {
    var eventName = userTransactions.getEventName(event);
    var transactionType = userTransactions.getTransactionType(event);

    if (transactionType === TRANSACTION_START_TYPE) {
      if (!userTransactions.hasActive(eventName)) {
        userTransactions.start(eventName);
      }
      return true;
    }

    if (!userTransactions.hasActive(eventName)) {
      return false;
    }

    return userTransactions.complete(eventName);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (userTransactions);

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transcoding_statuses__ = __webpack_require__(350);


var IN_QUEUE = __WEBPACK_IMPORTED_MODULE_0__transcoding_statuses__["a" /* default */].IN_QUEUE,
    INPROGRESS = __WEBPACK_IMPORTED_MODULE_0__transcoding_statuses__["a" /* default */].INPROGRESS,
    PREVIEW_READY = __WEBPACK_IMPORTED_MODULE_0__transcoding_statuses__["a" /* default */].PREVIEW_READY,
    READY = __WEBPACK_IMPORTED_MODULE_0__transcoding_statuses__["a" /* default */].READY,
    FAILED = __WEBPACK_IMPORTED_MODULE_0__transcoding_statuses__["a" /* default */].FAILED;


/* harmony default export */ __webpack_exports__["a"] = ({
  DOWNLOADING: 'DOWNLOADING',
  UPLOADING: 'UPLOADING',
  IN_STORAGE: 'IN-STORAGE',
  IN_QUEUE: IN_QUEUE,
  INPROGRESS: INPROGRESS,
  PREVIEW_READY: PREVIEW_READY,
  READY: READY,
  FAILED: FAILED
});

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  POPUP: 'popup',
  OVERLAY: 'overlay'
});

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Root; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_utils_wix_sdk__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_i18n_translations__ = __webpack_require__(555);






var _class, _temp;








var Root = (_temp = _class = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Root, _React$Component);

  function Root() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Root);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Root.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Root)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Root, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          history = _props.history,
          routes = _props.routes;


      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* Provider */],
        { store: this.props.store },
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_7_react_intl__["h" /* IntlProvider */],
          { messages: __WEBPACK_IMPORTED_MODULE_9_i18n_translations__["a" /* translations */],
            locale: __WEBPACK_IMPORTED_MODULE_8_shared_utils_wix_sdk__["a" /* default */].Utils.getLocale() },
          React.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_router__["g" /* Router */],
            { history: history },
            routes
          )
        )
      );
    }
  }]);

  return Root;
}(React.Component), _class.propTypes = {
  history: React.PropTypes.object.isRequired,
  routes: React.PropTypes.element.isRequired,
  store: React.PropTypes.object.isRequired
}, _temp);


/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExperimentsLoader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_redux_server_actions_experiments_get__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_selectors_experiments__ = __webpack_require__(257);






var _dec, _class, _class2, _temp;






var ExperimentsLoader = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["a" /* connect */])(function (state) {
  return {
    isLoaded: Boolean(state.experiments),
    enabledExperiments: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_shared_selectors_experiments__["b" /* getEnabledExperimentsList */])(state).join(', ')
  };
}, {
  getExperiments: __WEBPACK_IMPORTED_MODULE_6_shared_redux_server_actions_experiments_get__["b" /* default */]
}), _dec(_class = (_temp = _class2 = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ExperimentsLoader, _React$PureComponent);

  function ExperimentsLoader() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ExperimentsLoader);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ExperimentsLoader.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ExperimentsLoader)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ExperimentsLoader, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.getExperiments();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      document.body.setAttribute('data-experiments', this.props.enabledExperiments);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          isLoaded = _props.isLoaded,
          children = _props.children;


      if (!isLoaded) {
        return null;
      }

      return React.createElement(
        'span',
        null,
        children
      );
    }
  }]);

  return ExperimentsLoader;
}(React.PureComponent), _class2.propTypes = {
  getExperiments: React.PropTypes.func,
  enabledExperiments: React.PropTypes.string,
  isLoaded: React.PropTypes.bool,
  children: React.PropTypes.any
}, _temp)) || _class);


/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setupEnv; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bi_bi_core__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bi_bi_vod__ = __webpack_require__(262);
/* global ENV_CONFIG */



function setup() {
  if ({"disableBi":false,"logBiSend":false}.disableBi) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__bi_bi_core__["f" /* disableBiSend */])();
  }
  if ({"disableBi":false,"logBiSend":false}.logBiSend) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__bi_bi_vod__["d" /* enableEventLogging */])();
  }
}

var setupEnv = function setupEnv() {
  try {
    setup();
  } catch (er) {
    console.error('Cannot setup environment', er); // eslint-disable-line no-console
  }
};

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sendBiEvent;
/* harmony export (immutable) */ __webpack_exports__["b"] = sendBiError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_bi_bi_facade__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_bi_bi_with_state_defaults__ = __webpack_require__(263);




function sendBiEvent(name, eventParams) {
  return function (dispatch, getState) {
    var state = getState();
    var defaultBiParams = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_bi_bi_with_state_defaults__["a" /* getBiDefaultParams */])(state);
    var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, defaultBiParams, eventParams);
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_bi_bi_facade__["a" /* sendEvent */])(name, params);
  };
}

function sendBiError(name, eventParams) {
  return function (dispatch, getState) {
    var state = getState();
    var defaultBiParams = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_bi_bi_with_state_defaults__["a" /* getBiDefaultParams */])(state);
    var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, defaultBiParams, eventParams);
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_bi_bi_facade__["b" /* sendError */])(name, params);
  };
}

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_redux_helpers_counter__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_redux_server_actions_channels_list__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_redux_server_actions_channels_search__ = __webpack_require__(384);


var _handleActions;








/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["handleActions"])((_handleActions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_3_shared_redux_server_actions_channels_list__["a" /* NAMES */].START, __WEBPACK_IMPORTED_MODULE_2_shared_redux_helpers_counter__["a" /* increment */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_4_shared_redux_server_actions_channels_search__["a" /* NAMES */].START, __WEBPACK_IMPORTED_MODULE_2_shared_redux_helpers_counter__["a" /* increment */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_3_shared_redux_server_actions_channels_list__["a" /* NAMES */].SUCCESS, __WEBPACK_IMPORTED_MODULE_2_shared_redux_helpers_counter__["b" /* decrement */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_4_shared_redux_server_actions_channels_search__["a" /* NAMES */].SUCCESS, __WEBPACK_IMPORTED_MODULE_2_shared_redux_helpers_counter__["b" /* decrement */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_3_shared_redux_server_actions_channels_list__["a" /* NAMES */].FAIL, __WEBPACK_IMPORTED_MODULE_2_shared_redux_helpers_counter__["b" /* decrement */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_4_shared_redux_server_actions_channels_search__["a" /* NAMES */].FAIL, __WEBPACK_IMPORTED_MODULE_2_shared_redux_helpers_counter__["b" /* decrement */]), _handleActions), 0));

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_redux_helpers_normalized__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_redux_server_actions_channels_list__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_redux_server_actions_channels_search__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_redux_server_actions_channel_update__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dashboard_redux_server_actions_channel_remove__ = __webpack_require__(378);



var _handleActions;










/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])((_handleActions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_4_shared_redux_server_actions_channels_list__["a" /* NAMES */].SUCCESS, __WEBPACK_IMPORTED_MODULE_3_shared_redux_helpers_normalized__["f" /* getResult */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_5_shared_redux_server_actions_channels_search__["a" /* NAMES */].SUCCESS, __WEBPACK_IMPORTED_MODULE_3_shared_redux_helpers_normalized__["f" /* getResult */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_7_dashboard_redux_server_actions_channel_remove__["a" /* NAMES */].SUCCESS, function (state, _ref) {
  var payload = _ref.payload;
  var id = payload.params.id;


  return _.without(state, id);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_6_shared_redux_server_actions_channel_update__["a" /* NAMES */].SUCCESS, function (state, _ref2) {
  var payload = _ref2.payload;
  var result = payload.response.data.result;

  return [result].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(_.without(state, result)));
}), _handleActions), []));

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ids__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__active_requests__ = __webpack_require__(664);





/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])({
  ids: __WEBPACK_IMPORTED_MODULE_1__ids__["a" /* default */],
  activeRequests: __WEBPACK_IMPORTED_MODULE_2__active_requests__["a" /* default */]
}));

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_redux_server_actions_experiments_get__ = __webpack_require__(540);



var _handleActions;





var defaultExperiments = {
  enableUpgradeCounterPanelExp: 'false',
  enableDropbox: 'false',
  videoCoverMultiselect: 'false',
  hideVideoTitleOnMainItem: 'false',
  compactLayout: 'false',
  newPlayer: 'false',
  videoPreview: 'false'
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])((_handleActions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_3_shared_redux_server_actions_experiments_get__["a" /* NAMES */].SUCCESS, function (state, _ref) {
  var response = _ref.payload.response;
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, defaultExperiments, response);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_3_shared_redux_server_actions_experiments_get__["a" /* NAMES */].FAIL, _.constant(defaultExperiments)), _handleActions), null));

/***/ }),
/* 668 */,
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isVODChannel;
/* harmony export (immutable) */ __webpack_exports__["d"] = isYouTubeFeed;
/* harmony export (immutable) */ __webpack_exports__["c"] = hasTags;
/* unused harmony export hasDescription */
/* harmony export (immutable) */ __webpack_exports__["b"] = hasVideos;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_constants_channel_types__ = __webpack_require__(182);


function isVODChannel(channelData) {
  return channelData.channelType === __WEBPACK_IMPORTED_MODULE_0_shared_constants_channel_types__["a" /* default */].CHANNEL;
}

function isYouTubeFeed(channelData) {
  return channelData.channelType === __WEBPACK_IMPORTED_MODULE_0_shared_constants_channel_types__["a" /* default */].YOUTUBE_FEED;
}

function hasTags(channelData) {
  var tags = _.get(channelData, 'statsInfo.tags');
  return !_.isEmpty(tags);
}

function hasDescription(channelData) {
  return Boolean(channelData.description);
}

function hasVideos(channelData) {
  return channelData.videosCount > 0;
}

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return requestLogin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_utils_wix_sdk__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_bi_bi__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_constants_request_login_modes__ = __webpack_require__(1571);



var _systemEventsPerLogin;





var systemEventsPerLoginMode = (_systemEventsPerLogin = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_systemEventsPerLogin, __WEBPACK_IMPORTED_MODULE_4_shared_constants_request_login_modes__["a" /* default */].SIGN_UP, {
  requested: 'user.signup.requested',
  succeeded: 'user.signup.succeeded',
  cancelled: 'user.signup.cancelled'
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_systemEventsPerLogin, __WEBPACK_IMPORTED_MODULE_4_shared_constants_request_login_modes__["a" /* default */].LOGIN, {
  requested: 'user.logIn.requested',
  succeeded: 'user.logIn.succeeded',
  cancelled: 'user.logIn.cancelled'
}), _systemEventsPerLogin);

var requestLogin = function requestLogin() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$isLogin = _ref.isLogin,
      isLogin = _ref$isLogin === undefined ? false : _ref$isLogin;

  var mode = isLogin ? __WEBPACK_IMPORTED_MODULE_4_shared_constants_request_login_modes__["a" /* default */].LOGIN : __WEBPACK_IMPORTED_MODULE_4_shared_constants_request_login_modes__["a" /* default */].SIGN_UP;

  var systemEvents = systemEventsPerLoginMode[mode];

  __WEBPACK_IMPORTED_MODULE_3_shared_bi_bi__["a" /* default */].logWidgetSystem(systemEvents.requested);

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var onLogin = function onLogin(loggedInUserData) {
      if (loggedInUserData.authResponse) {
        __WEBPACK_IMPORTED_MODULE_3_shared_bi_bi__["a" /* default */].logWidgetSystem(systemEvents.succeeded, {
          previousEventName: systemEvents.requested
        });
        resolve(loggedInUserData);
      }
    };

    var onError = function onError(error) {
      if (_.get(error, 'wasCancelled')) {
        __WEBPACK_IMPORTED_MODULE_3_shared_bi_bi__["a" /* default */].logWidgetSystem(systemEvents.cancelled, {
          previousEventName: systemEvents.requested
        });
        return;
      }
      reject(error);
    };

    __WEBPACK_IMPORTED_MODULE_2_shared_utils_wix_sdk__["a" /* default */].requestLogin({
      language: __WEBPACK_IMPORTED_MODULE_2_shared_utils_wix_sdk__["a" /* default */].Utils.getLocale(),
      mode: mode
    }, onLogin, onError);
  });
};

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NotFoundView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(69);







var NotFoundView = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(NotFoundView, _React$Component);

  function NotFoundView() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, NotFoundView);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (NotFoundView.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(NotFoundView)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(NotFoundView, [{
    key: "render",
    value: function render() {
      return React.createElement(
        "div",
        { className: "container text-center" },
        React.createElement(
          "h1",
          null,
          "This is a demo 404 page!"
        ),
        React.createElement("hr", null),
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_router__["e" /* Link */],
          { to: "/" },
          "Back To Home View"
        )
      );
    }
  }]);

  return NotFoundView;
}(React.Component);



/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_http__ = __webpack_require__(44);


/* harmony default export */ __webpack_exports__["a"] = (function (AdapterConstructor, settings) {
  if (!_.isFunction(AdapterConstructor)) {
    throw new Error('Adapter constructor should be a function');
  }

  if (!_.isUndefined(settings) && (!_.isObject(settings) || _.isNull(settings))) {
    throw new Error('Adapter settings should be an object');
  }

  return new AdapterConstructor(settings, __WEBPACK_IMPORTED_MODULE_0__utils_http__);
});

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Facebook;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__videos__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__settings__ = __webpack_require__(676);




function Facebook(userSettings) {
  var settings = _.assign({}, __WEBPACK_IMPORTED_MODULE_1__settings__["a" /* default */], userSettings);

  var videos = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__videos__["a" /* default */])(settings);

  _.assign(this, {
    videos: videos
  });
}

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseUrl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parsers_error__ = __webpack_require__(426);



function parseUrl(url) {
  // possible formats:
  // https://www.facebook.com/thisisinsiderdesign/videos/384893281852307/?hc_ref=NEWSFEED
  // https://www.facebook.com/thisisinsiderdesign/videos/vb.228803477461289/384893281852307/?type=2&theater
  // https://www.facebook.com/video.php?v=1790717287849662

  url = decodeURIComponent(url);

  var matched = url.match(/\.facebook\.com\/[^/]+\/videos\/(?:[^/]+\/)?(\d+)\/?/);

  if (!matched) {
    matched = url.match(/\.facebook\.com\/video\.php\?v=(\d+)/);
  }

  if (!matched) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new __WEBPACK_IMPORTED_MODULE_1__parsers_error__["b" /* InternalError */](400, 'wpm_error.malformed_external_link', 'External link was not formatted properly'));
  }

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(matched[1]);
}

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseVideo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_object__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_get_video_duration__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_time__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_transcoding_statuses__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_video_sources__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_free_deal_info__ = __webpack_require__(204);









function parseVideo(videoData, settings) {

  if (!videoData) {
    return null;
  }

  videoData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_object__["keysToCamelCase"])(videoData);

  var _videoData = videoData,
      id = _videoData.id,
      format = _videoData.format,
      embedHtml = _videoData.embedHtml,
      description = _videoData.description,
      publisher = _videoData.from.name,
      name = _videoData.name,
      _videoData$title = _videoData.title,
      title = _videoData$title === undefined ? name || description || publisher : _videoData$title,
      source = _videoData.source;


  var externalId = String(id);

  var coverUrl = void 0;
  if (format) {
    coverUrl = _.find(format, { filter: 'native' }).picture.replace(/^https?:/, '');
  }

  var width = embedHtml && Number(embedHtml.match(/width="(\d+)/)[1]);
  var height = embedHtml && Number(embedHtml.match(/height="(\d+)/)[1]);

  var mediaExternUrl = '//www.facebook.com/video.php?v=' + externalId;

  // no source for live videos
  var durationPromise = source ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_get_video_duration__["a" /* default */])(source, settings, { skipProbe: true }) : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(0);

  return durationPromise.then(function (duration) {
    var durationSec = Math.round(duration / 1000);
    var durationStr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_time__["convertSSToMMSS"])(durationSec);

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_object__["removeUndefinedValues"])({
      externalId: externalId,
      coverUrl: coverUrl,
      width: width,
      height: height,
      description: description,
      publisher: publisher,
      title: title,
      mediaExternUrl: mediaExternUrl,
      mediaStatus: __WEBPACK_IMPORTED_MODULE_4__constants_transcoding_statuses__["a" /* default */].READY,
      dealInfo: __WEBPACK_IMPORTED_MODULE_6__constants_free_deal_info__["a" /* default */],
      durationSec: durationSec,
      durationStr: durationStr,
      videoSource: __WEBPACK_IMPORTED_MODULE_5__constants_video_sources__["a" /* default */].FACEBOOK
    });
  });
}

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  apiUrl: '//graph.facebook.com',
  fallbackApiUrl: '//pix.wix.com/services/facebook2',
  redirectUrl: 'service-connected.html'
});

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_wixmp_sdk__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_wixmp_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_wixmp_sdk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parsers_video__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parsers_error__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parse_url__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_http__ = __webpack_require__(44);











/* harmony default export */ __webpack_exports__["a"] = (function (settings) {

  var facebookConnector = __WEBPACK_IMPORTED_MODULE_2_wixmp_sdk___default.a.connectExternalSource('FACEBOOK', settings);

  function _sendVideoGraphRequest(videoId) {
    return __WEBPACK_IMPORTED_MODULE_6__utils_http__["get"](settings.apiUrl + '/' + videoId, {
      params: {
        fields: 'description,embed_html,format,from,id,name,source'
      },
      options: { withCredentials: false }
    });
  }

  function _sendVideoPixRequest(videoId) {
    return __WEBPACK_IMPORTED_MODULE_6__utils_http__["get"](settings.fallbackApiUrl + '/video', {
      params: { video_id: videoId }
    });
  }

  function _parseResponse(response) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__parsers_video__["a" /* default */])(response.data, settings).then(_.castArray).then(function (data) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, response, { data: data });
    });
  }

  function getByUrl(url) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parse_url__["a" /* default */])(url).then(function (videoId) {
      return _sendVideoGraphRequest(videoId).then(_parseResponse);
    }).catch(__WEBPACK_IMPORTED_MODULE_4__parsers_error__["a" /* default */]);
  }

  function getByUrlWithFBAuth(url) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parse_url__["a" /* default */])(url).then(function (videoId) {
      return _sendVideoGraphRequest(videoId).catch(function () {
        return _sendVideoPixRequest(videoId);
      }).catch(function (response) {
        if (response.status !== 403) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
        }

        return facebookConnector.connect().then(function () {
          return _sendVideoPixRequest(videoId);
        });
      }).then(_parseResponse);
    }).catch(__WEBPACK_IMPORTED_MODULE_4__parsers_error__["a" /* default */]);
  }

  return {
    getByUrl: getByUrl,
    getByUrlWithFBAuth: getByUrlWithFBAuth
  };
});

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vod_index__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__youtube_index__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vimeo_index__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__facebook_index__ = __webpack_require__(673);





var adaptersList = {
  VOD: __WEBPACK_IMPORTED_MODULE_0__vod_index__["a" /* default */],
  YouTube: __WEBPACK_IMPORTED_MODULE_1__youtube_index__["a" /* default */],
  Vimeo: __WEBPACK_IMPORTED_MODULE_2__vimeo_index__["a" /* default */],
  Facebook: __WEBPACK_IMPORTED_MODULE_3__facebook_index__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (adaptersList);

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Vimeo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__videos__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__settings__ = __webpack_require__(682);




function Vimeo(userSettings) {
  var settings = _.assign({}, __WEBPACK_IMPORTED_MODULE_1__settings__["a" /* default */], userSettings);

  var videos = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__videos__["a" /* default */])(settings);

  _.assign(this, {
    videos: videos
  });
}

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseUrl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parsers_error__ = __webpack_require__(427);



function parseUrl(url) {
  // possible formats:
  // https://vimeo.com/148520418
  // https://vimeo.com/channels/staffpicks/149008769
  // https://vimeo.com/ondemand/almostthere

  if (!/vimeo\.com/.test(url)) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(new __WEBPACK_IMPORTED_MODULE_1__parsers_error__["b" /* InternalError */](400, 'wpm_error.malformed_external_link', 'External link was not formatted properly'));
  }

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(url);
}

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseVideo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_object__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_time__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_transcoding_statuses__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_video_sources__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_free_deal_info__ = __webpack_require__(204);







function parseVideo(videoData) {

  if (!videoData) {
    return null;
  }

  videoData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_object__["keysToCamelCase"])(videoData);

  var _videoData = videoData,
      width = _videoData.width,
      height = _videoData.height,
      description = _videoData.description,
      publisher = _videoData.authorName,
      title = _videoData.title,
      durationSec = _videoData.duration;
  var _videoData2 = videoData,
      externalId = _videoData2.videoId,
      coverUrl = _videoData2.thumbnailUrl;


  externalId = String(externalId);
  coverUrl = coverUrl.replace(/^https?:/, '').replace(/(_\d+(x\d+)?)?\.\w+$/, '.jpg');

  var mediaExternUrl = '//player.vimeo.com/video/' + externalId;

  var durationStr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_time__["convertSSToMMSS"])(durationSec);

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_object__["removeUndefinedValues"])({
    externalId: externalId,
    coverUrl: coverUrl,
    width: width,
    height: height,
    description: description,
    publisher: publisher,
    title: title,
    mediaExternUrl: mediaExternUrl,
    mediaStatus: __WEBPACK_IMPORTED_MODULE_2__constants_transcoding_statuses__["a" /* default */].READY,
    dealInfo: __WEBPACK_IMPORTED_MODULE_4__constants_free_deal_info__["a" /* default */],
    durationSec: durationSec,
    durationStr: durationStr,
    videoSource: __WEBPACK_IMPORTED_MODULE_3__constants_video_sources__["a" /* default */].VIMEO
  });
}

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  apiUrl: '//vimeo.com/api'
});

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parsers_video__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parsers_error__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parse_url__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_http__ = __webpack_require__(44);









var requestOptions = { withCredentials: false };

/* harmony default export */ __webpack_exports__["a"] = (function (settings) {

  function getByUrl(url) {

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__parse_url__["a" /* default */])(url).then(function (url) {
      return __WEBPACK_IMPORTED_MODULE_5__utils_http__["get"](settings.apiUrl + '/oembed.json', {
        params: { url: url },
        options: requestOptions
      }).then(function (response) {
        var data = response.data;


        if (data.type !== 'video') {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject();
        }

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, response, {
          data: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__parsers_video__["a" /* default */])(data)]
        });
      });
    }).catch(__WEBPACK_IMPORTED_MODULE_3__parsers_error__["a" /* default */]);
  }

  return {
    getByUrl: getByUrl
  };
});

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parsers_error__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_http__ = __webpack_require__(44);




/* harmony default export */ __webpack_exports__["a"] = (function (settings) {

  function get() {
    return __WEBPACK_IMPORTED_MODULE_1__utils_http__["get"](settings.apiUrl + '/catalog/users/stats').then(function (response) {
      var _response$data = response.data,
          _response$data$tags = _response$data.tags,
          tags = _response$data$tags === undefined ? [] : _response$data$tags,
          _response$data$catego = _response$data.categories,
          categories = _response$data$catego === undefined ? [] : _response$data$catego;

      return {
        tags: _.map(tags, 'value'),
        categories: _.map(categories, 'value')
      };
    }).catch(__WEBPACK_IMPORTED_MODULE_0__parsers_error__["a" /* default */]);
  }

  return {
    get: get
  };
});

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  apiUrl: '//vod-test.wix.com/',
  filesUrl: '//vod-meta-test.wix.com/',
  mediaType: 'secure_video'
});

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  UPLOAD: 'VOD.FILE.UPLOAD',
  UPLOAD_VIDEO: 'VOD.FILE.UPLOAD_VIDEO',
  GET_VIDEO_DURATION: 'VOD.FILE.GET_VIDEO_DURATION',
  CAN_UPLOAD_VIDEO: 'VOD.FILE.CAN_UPLOAD_VIDEO'
});

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  GET: 'VOD.ITEM.GET',
  CREATE: 'VOD.ITEM.CREATE',
  UPDATE: 'VOD.ITEM.UPDATE',
  REUPLOAD: 'VOD.ITEM.REUPLOAD',
  UPLOAD: 'VOD.ITEM.UPLOAD',
  GET_VIDEO_URLS: 'VOD.ITEM.GET_VIDEO_URLS',
  GET_VIDEO_URLS_BY_FILE_NAME: 'VOD.ITEM.GET_VIDEO_URLS_BY_FILE_NAME'
});

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  LIST: 'VOD.ITEMS.LIST',
  SEARCH: 'VOD.ITEMS.SEARCH',
  CREATE: 'VOD.ITEMS.CREATE',
  UPDATE: 'VOD.ITEMS.UPDATE',
  REMOVE: 'VOD.ITEMS.REMOVE'
});

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  LIST: 'VOD.LIST_ITEMS.LIST',
  LIST_PUBLIC: 'VOD.LIST_ITEMS.LIST_PUBLIC',
  LIST_NEXT_IN_CHANNEL: 'VOD.LIST_ITEMS.LIST_NEXT_IN_CHANNEL',
  ADD: 'VOD.LIST_ITEMS.ADD',
  GET: 'VOD.LIST_ITEMS.GET',
  GET_PUBLIC: 'VOD.LIST_ITEMS.GET_PUBLIC',
  UPDATE: 'VOD.LIST_ITEMS.UPDATE',
  REMOVE: 'VOD.LIST_ITEMS.REMOVE',
  REMOVE_BY_BASE_ITEM_ID: 'VOD.LIST_ITEMS.REMOVE_BY_BASE_ITEM_ID',
  MOVE: 'VOD.LIST_ITEMS.MOVE'
});

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  GET: 'VOD.LIST.GET',
  GET_PUBLIC: 'VOD.LIST.GET_PUBLIC',
  GET_PAYMENT_INFO: 'VOD.LIST.GET_PAYMENT_INFO',
  CREATE: 'VOD.LIST.CREATE',
  UPDATE: 'VOD.LIST.UPDATE',
  CHECK_PUBLISH: 'VOD.LIST.CHECK_PUBLISH',
  PUBLISH: 'VOD.LIST.PUBLISH'
});

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  LIST: 'VOD.LISTS.LIST',
  SEARCH: 'VOD.LISTS.SEARCH',
  REMOVE: 'VOD.LISTS.REMOVE'
});

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  GET_PREMIUM_INFO: 'VOD.PREMIUM.GET_PREMIUM_INFO',
  GET_USAGE: 'VOD.PREMIUM.GET_USAGE'
});

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  UPDATE: 'VOD.TRANSCODING.UPDATE'
});

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  UPDATE: 'VOD.UPLOADING.PROGRESS.UPDATE'
});

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_wix_private_media__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_wixmp_sdk__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_wixmp_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_wixmp_sdk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_get_video_duration__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__events_index__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__parsers_error__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__trigger_progress_while_transcoding__ = __webpack_require__(201);











var uploadQueue = [];

if (__WEBPACK_IMPORTED_MODULE_3_wixmp_sdk___default.a) {
  __WEBPACK_IMPORTED_MODULE_3_wixmp_sdk___default.a.Uploader.on('queueChanged', function (queue) {
    uploadQueue = queue;
  });
}

var checkVideoPromise = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve();

var loadDuration = function loadDuration(_ref) {
  var file = _ref.file,
      settings = _ref.settings,
      isFreeUser = _ref.isFreeUser;
  var size = file.size,
      headers = file.headers;

  var videoSource = file.url || file;
  var fileIsUrl = _.isString(videoSource);

  if (!isFreeUser) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(0);
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_get_video_duration__["a" /* default */])(videoSource, settings, { chunkSize: __WEBPACK_IMPORTED_MODULE_4__utils_get_video_duration__["b" /* CHUNK_SIZE */], headers: headers }).catch(function (reason) {
    if (fileIsUrl || size <= __WEBPACK_IMPORTED_MODULE_4__utils_get_video_duration__["b" /* CHUNK_SIZE */] * 2) {
      // if file is url no need to retry, it will fail
      // file is small, we sent it whole already, no need to send it again, it will fail again
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(reason);
    }

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_get_video_duration__["a" /* default */])(videoSource, settings, { chunkSize: __WEBPACK_IMPORTED_MODULE_4__utils_get_video_duration__["b" /* CHUNK_SIZE */] * 3, headers: headers });
  });
};

/* harmony default export */ __webpack_exports__["a"] = (function (settings, adapterMethods) {
  var wixPrivateMedia = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_wix_private_media__["a" /* default */])(settings);

  function _triggerUploadProgress(trigger, fileToUpload, data) {
    var currentFileQueueIdx = data.currentFileQueueIdx;


    if (uploadQueue[currentFileQueueIdx] !== fileToUpload) {
      return;
    }

    var currentFileProgress = data.currentFileProgress;
    var status = currentFileProgress.status,
        total = currentFileProgress.total,
        loaded = currentFileProgress.loaded;


    trigger(__WEBPACK_IMPORTED_MODULE_5__events_index__["a" /* default */].UPLOADING_PROGRESS.UPDATE, {
      uploadingStatus: status.toUpperCase(),
      fileSize: total,
      uploadedSize: loaded
    });
  }

  function upload(trigger, source) {
    var uploadData = {
      uploadFn: wixPrivateMedia.item.upload,
      source: source
    };

    var fileToUpload = __WEBPACK_IMPORTED_MODULE_3_wixmp_sdk___default.a.Uploader.upload([uploadData])[0];

    __WEBPACK_IMPORTED_MODULE_3_wixmp_sdk___default.a.Uploader.on('fileStatusChanged', _.partial(_triggerUploadProgress, trigger, fileToUpload));

    return fileToUpload.deferred.promise.catch(__WEBPACK_IMPORTED_MODULE_6__parsers_error__["a" /* default */]);
  }

  function uploadByUrl(trigger, source) {
    var uploadData = {
      // skip waiting
      uploadFn: function uploadFn(fileSource, options) {
        return wixPrivateMedia.item.uploadByUrl(fileSource, options, true);
      },
      source: source
    };

    var fileToUpload = __WEBPACK_IMPORTED_MODULE_3_wixmp_sdk___default.a.Uploader.upload([uploadData])[0];

    return fileToUpload.deferred.promise.catch(__WEBPACK_IMPORTED_MODULE_6__parsers_error__["a" /* default */]);
  }

  function uploadVideo(trigger, source) {
    var uploadFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : upload;

    return uploadFn(trigger, source).then(function (fileResponse) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__trigger_progress_while_transcoding__["a" /* default */])();
      return fileResponse;
    });
  }

  function canUploadVideo(trigger, file) {
    // duration ms
    var size = file.size,
        duration = file.duration;


    var promise = checkVideoPromise.then(function () {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([adapterMethods.premium.getPremiumInfo(), adapterMethods.premium.getUsage()]);
    }).then(function (_ref2) {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref2, 2),
          premiumInfo = _ref3[0],
          usageInfo = _ref3[1];

      var product = premiumInfo.product,
          itemMilliseconds = premiumInfo.itemMilliseconds;

      var isFreeUser = Boolean(itemMilliseconds);

      return duration ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(duration) : loadDuration({ file: file, settings: settings, isFreeUser: isFreeUser }).then(function (duration) {
        var exceeded = [];
        var estimatedUsage = usageInfo.estimated;

        var timeLeft = premiumInfo.milliseconds - estimatedUsage.milliseconds;
        var spaceLeft = premiumInfo.bytes - estimatedUsage.bytes;

        if (size > spaceLeft) {
          exceeded.push('total-space');
        }

        if (isFreeUser) {
          if (duration > itemMilliseconds) {
            exceeded.push('item-time');
          }
          if (duration > timeLeft) {
            exceeded.push('total-time');
          }
        } else if (timeLeft <= 0) {
          exceeded.push('total-time');
        }

        if (exceeded.length) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject({
            status: 500,
            data: {
              errorCode: -1810,
              errorDescription: 'quota exceeded',
              errorInfo: {
                key: 'wmp_error.quota_exceeded',
                isFree: !product,
                args: exceeded
              }
            }
          });
        }

        return {
          size: size,
          duration: duration
        };
      });
    });

    checkVideoPromise = promise.catch(_.noop);

    return promise;
  }

  return {
    upload: upload,
    uploadByUrl: uploadByUrl,
    uploadVideo: uploadVideo,
    canUploadVideo: canUploadVideo
  };
});

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = VOD;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_with_events_triggering__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_provide_each_call_events__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__file__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__premium__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__list__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lists__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__item__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__items__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__list_items__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__settings__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__autocomplete__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_wix_private_media__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__events_index__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__channels_channels__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__default_settings__ = __webpack_require__(685);




















function addEventsTriggering(methodsGroups) {
  _.forEach(methodsGroups, function (methods, groupName) {
    groupName = _.snakeCase(groupName).toUpperCase();
    _.forEach(methods, function (method, key) {
      var name = _.snakeCase(key).toUpperCase();
      methods[key] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_with_events_triggering__["a" /* default */])(method, 'VOD.' + groupName + '.' + name);
    });
  });
}

function wrapWithEventsProviding(methodsGroups, globalTrigger) {
  return _.mapValues(methodsGroups, function (methods) {
    return _.mapValues(methods, function (method) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_provide_each_call_events__["a" /* default */])(method, globalTrigger);
    });
  });
}

function VOD(userSettings) {
  var _settings = _.assign({}, __WEBPACK_IMPORTED_MODULE_14__default_settings__["a" /* default */], userSettings);
  var wixPrivateMedia = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_wix_private_media__["a" /* default */])(_settings);
  __WEBPACK_IMPORTED_MODULE_13__channels_channels__["a" /* default */].setup({ wixPrivateMedia: wixPrivateMedia });

  var methodsGroups = {};
  methodsGroups.file = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__file__["a" /* default */])(_settings, methodsGroups);
  methodsGroups.premium = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__premium__["a" /* default */])(_settings, methodsGroups);
  methodsGroups.list = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__list__["a" /* default */])(_settings, methodsGroups);
  methodsGroups.lists = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lists__["a" /* default */])(_settings, methodsGroups);
  methodsGroups.item = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__item__["a" /* default */])(_settings, methodsGroups);
  methodsGroups.items = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__items__["a" /* default */])(_settings, methodsGroups);
  methodsGroups.listItems = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__list_items__["a" /* default */])(_settings, methodsGroups);
  methodsGroups.settings = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__settings__["a" /* default */])(_settings, methodsGroups);
  methodsGroups.autocomplete = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__autocomplete__["a" /* default */])(_settings, methodsGroups);
  addEventsTriggering(methodsGroups);

  _.assign(this, { events: __WEBPACK_IMPORTED_MODULE_12__events_index__["a" /* default */] }, wrapWithEventsProviding(methodsGroups, function () {
    return __WEBPACK_IMPORTED_MODULE_12__events_index__["a" /* default */].trigger.apply(__WEBPACK_IMPORTED_MODULE_12__events_index__["a" /* default */], arguments);
  }));
}

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parsers_item__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parsers_error__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__trigger_progress_while_transcoding__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__item__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_http__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_object__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_cast_aray__ = __webpack_require__(432);











var defaultPaging = {
  size: 30,
  cursor: null
};

var defaultSort = {
  order: 'date',
  direction: 'desc'
};

/* harmony default export */ __webpack_exports__["a"] = (function (settings, adapterMethods) {

  var toItem = _.partial(__WEBPACK_IMPORTED_MODULE_2__parsers_item__["a" /* default */], adapterMethods);

  function _parseSuccessResponse(response) {
    var data = response.data;


    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, response, {
      data: _.map(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_cast_aray__["a" /* default */])(data), toItem)
    });
  }

  function _connectItemsToList(trigger, itemsResponse, listId) {
    if (!listId) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(itemsResponse);
    }

    return adapterMethods.list.get(trigger, listId).then(_.property('data.title')).then(function (listTitle) {
      return adapterMethods.listItems.add(trigger, listId, _.map(itemsResponse.data, 'id')).then(function () {
        itemsResponse.data = _.map(itemsResponse.data, function (data) {
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, data, {
            usedInLists: [{
              id: listId,
              title: listTitle
            }]
          });
        });
      });
    }).then(function () {
      return adapterMethods.list.publish(trigger, listId);
    });
  }

  function list(trigger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var query = options.query,
        tag = options.tag,
        category = options.category,
        _options$mediaType = options.mediaType,
        mediaType = _options$mediaType === undefined ? settings.mediaType : _options$mediaType;
    var sort = options.sort,
        paging = options.paging;


    sort = _.merge({}, defaultSort, sort);
    paging = _.merge({}, defaultPaging, paging);

    var _paging = paging,
        size = _paging.size,
        cursor = _paging.cursor;
    var _sort = sort,
        direction = _sort.direction,
        order = _sort.order;


    var params = {
      query: query,
      tag: tag,
      category: category,
      media_type: mediaType,
      page_size: size,
      cursor: cursor,
      order: direction === 'desc' ? '-' + order : order
    };

    return __WEBPACK_IMPORTED_MODULE_6__utils_http__["get"](settings.apiUrl + '/catalog/items', { params: params }).then(function (response) {
      var items = _.map(response.data.items, toItem);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__trigger_progress_while_transcoding__["a" /* default */])(items);

      return _.assign({}, response, {
        sort: sort,
        paging: {
          size: size,
          cursor: response.data.cursor || null
        },
        data: items
      });
    }).catch(__WEBPACK_IMPORTED_MODULE_3__parsers_error__["a" /* default */]);
  }

  function search(trigger, query) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    return list(trigger, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, options, { query: query }));
  }

  function create(trigger, itemsData) {
    var items = _.map(itemsData, function (itemData) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__item__["c" /* prepareItemForSending */])(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
        mediaType: settings.mediaType
      }, itemData));
    });

    return __WEBPACK_IMPORTED_MODULE_6__utils_http__["post"](settings.apiUrl + '/catalog/items', {
      data: { items: items }
    }).then(_parseSuccessResponse).catch(__WEBPACK_IMPORTED_MODULE_3__parsers_error__["a" /* default */]);
  }

  function createInList(trigger, itemsData, listId) {
    return adapterMethods.items.create(trigger, itemsData).then(function (itemsResponse) {
      return _connectItemsToList(trigger, itemsResponse, listId).then(function () {
        return itemsResponse;
      }).catch(function () {
        return itemsResponse;
      });
    }).catch(__WEBPACK_IMPORTED_MODULE_3__parsers_error__["a" /* default */]);
  }

  function update(trigger, itemIds, itemData) {
    var data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__item__["c" /* prepareItemForSending */])(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, itemData, {
      items: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_cast_aray__["a" /* default */])(itemIds)
    }));

    return __WEBPACK_IMPORTED_MODULE_6__utils_http__["put"](settings.apiUrl + '/catalog/items', { data: data }).then(_parseSuccessResponse).catch(__WEBPACK_IMPORTED_MODULE_3__parsers_error__["a" /* default */]);
  }

  function remove(trigger, itemIds) {
    var data = {
      items: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_cast_aray__["a" /* default */])(itemIds)
    };

    return __WEBPACK_IMPORTED_MODULE_6__utils_http__["post"](settings.apiUrl + '/catalog/items/delete', { data: data }).then(__WEBPACK_IMPORTED_MODULE_7__utils_object__["keysToCamelCase"]).catch(__WEBPACK_IMPORTED_MODULE_3__parsers_error__["a" /* default */]);
  }

  return {
    list: list,
    search: search,
    create: create,
    createInList: createInList,
    update: update,
    remove: remove
  };
});

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parsers_item__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parsers_error__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__trigger_progress_while_transcoding__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__item__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_http__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_cast_aray__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_object__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_normalize_id__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_task_sequence__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__youtube_index__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__external_requests__ = __webpack_require__(267);

















var defaultPaging = {
  size: 30,
  cursor: null
};

var defaultSort = {
  order: 'custom',
  direction: 'asc'
};

var youtubeAdapter = new __WEBPACK_IMPORTED_MODULE_11__youtube_index__["a" /* default */]();

var channelDataCache = {};

/* harmony default export */ __webpack_exports__["a"] = (function (settings, adapterMethods) {

  var toItem = _.partial(__WEBPACK_IMPORTED_MODULE_2__parsers_item__["a" /* default */], adapterMethods);

  function _optionsToParams(options) {
    var query = options.query,
        tag = options.tag,
        category = options.category,
        _options$mediaType = options.mediaType,
        mediaType = _options$mediaType === undefined ? settings.mediaType : _options$mediaType;
    var sort = options.sort,
        paging = options.paging;

    sort = _.merge({}, defaultSort, sort);
    paging = _.merge({}, defaultPaging, paging);

    return {
      query: query,
      tag: tag,
      category: category,
      media_type: mediaType,
      page_size: paging.size,
      cursor: paging.cursor,
      order: sort.direction === 'desc' ? '-' + sort.order : sort.order
    };
  }

  function _parseSuccessResponse(response) {
    var data = response.data;


    return _.assign({}, response, {
      data: toItem(data)
    });
  }

  function _parseListResponse(response, options) {
    var items = _.map(response.data.items, toItem);

    var sort = options.sort,
        paging = options.paging;


    return _.assign({}, response, {
      sort: sort,
      paging: {
        size: paging.size,
        cursor: response.data.cursor || null
      },
      data: items
    });
  }

  function _fetchExternalVideos(channelData, options) {
    options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, options, {
      noExtraChannelData: true
    });

    var externalId = channelData.externalId,
        channelType = channelData.channelType,
        urlType = channelData.urlType;


    var key = channelType + '.' + urlType;
    var externalRequestMethod = __WEBPACK_IMPORTED_MODULE_12__external_requests__["a" /* listItems */][key];

    if (!externalRequestMethod) {
      return {
        status: 200,
        data: {
          items: []
        }
      };
    }

    return externalRequestMethod(externalId, options).then(function (externalResponse) {
      return {
        status: 200,
        data: {
          cursor: externalResponse.paging.cursor,
          items: _.map(externalResponse.data, function (item) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, item, { id: item.externalId });
          })
        }
      };
    }).catch(function () {
      return {
        status: 200,
        data: {
          items: []
        }
      };
    });
  }

  function _fetchRawList(trigger, listId) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _options$noAdditional = options.noAdditionalRequests,
        noAdditionalRequests = _options$noAdditional === undefined ? false : _options$noAdditional;

    var params = _optionsToParams(options);

    return __WEBPACK_IMPORTED_MODULE_6__utils_http__["get"](settings.apiUrl + '/public/lists/' + listId, { params: params }).then(function (response) {
      if (noAdditionalRequests) {
        return response;
      }

      if (response.data.items.length) {
        return response;
      }

      return adapterMethods.list.getPublic(trigger, listId).then(function (channelResponse) {
        var channelData = channelResponse.data;
        channelDataCache[listId] = channelData;

        return _fetchExternalVideos(channelData, options);
      });
    }, function (reason) {
      if (noAdditionalRequests) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(reason);
      }

      // invalid cursor means that it's external channel, e.g. youtube feed
      var isInvalidCursor = _(reason).get('data.error_description').startsWith('Invalid cursor');

      var channelData = channelDataCache[listId];

      if (isInvalidCursor && channelData) {
        return _fetchExternalVideos(channelData, options);
      }

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(reason);
    });
  }

  function _loadStartingFromVideoId(trigger, videoId, listId, options) {
    return _fetchRawList(trigger, listId, options).then(function (response) {
      var indexOfVideo = videoId ? _.findIndex(response.data.items, function (item) {
        return (item.externalId || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_normalize_id__["a" /* normalizeId */])(item.item_id)) === videoId;
      }) : 0;

      if (indexOfVideo >= 0) {
        var firstPart = response.data.items.slice(0);
        firstPart.splice(indexOfVideo, 1);

        // videoId is in current response -> load more to reach paging.size and concatenate results.
        if (response.data.cursor) {
          return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            var videoCountLeftToLoad = indexOfVideo + 1;

            var nextPageOptions = _.assign({}, options, {
              paging: {
                size: videoCountLeftToLoad,
                cursor: response.data.cursor
              }
            });

            _fetchRawList(trigger, listId, nextPageOptions).then(function (nextPageResponse) {
              nextPageResponse.data.items = firstPart.concat(nextPageResponse.data.items);
              resolve(nextPageResponse);
            }).catch(reject);
          });
        }

        response.data.items = firstPart;
        return response;
      }

      if (response.data.cursor) {
        var nextPageOptions = _.merge({}, options, {
          paging: {
            cursor: response.data.cursor
          }
        });

        return _loadStartingFromVideoId(trigger, videoId, listId, nextPageOptions);
      }

      return _.assign({}, response, {
        data: { items: [] }
      });
    });
  }

  // TODO: move to listItem
  function get(trigger, listId, itemId) {
    return __WEBPACK_IMPORTED_MODULE_6__utils_http__["get"](settings.apiUrl + '/catalog/lists/' + listId + '/items/' + itemId).then(function (response) {
      return _.assign({}, response, {
        data: toItem(response.data)
      });
    }).then(function (parsedResponse) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__trigger_progress_while_transcoding__["a" /* default */])([parsedResponse.data]);
      return parsedResponse;
    }).catch(__WEBPACK_IMPORTED_MODULE_3__parsers_error__["a" /* default */]);
  }

  function _tryGetYouTubeVideo(itemId) {
    return youtubeAdapter.videos.get(itemId).then(function (response) {
      var videoItem = response.data[0];

      response = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, response, {
        data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, videoItem, {
          id: videoItem.externalId
        })
      });

      return response;
    });
  }

  function getPublic(trigger, listId, itemId) {
    return __WEBPACK_IMPORTED_MODULE_6__utils_http__["get"](settings.apiUrl + '/public/lists/' + listId + '/items/' + itemId + '/info').then(_parseSuccessResponse, function () {
      return _tryGetYouTubeVideo(itemId);
    }).catch(__WEBPACK_IMPORTED_MODULE_3__parsers_error__["a" /* default */]);
  }

  function list(trigger, listId) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var params = _optionsToParams(options);

    return __WEBPACK_IMPORTED_MODULE_6__utils_http__["get"](settings.apiUrl + '/catalog/lists/' + listId + '/items', { params: params }).then(function (response) {
      return _parseListResponse(response, options);
    }).then(function (response) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__trigger_progress_while_transcoding__["a" /* default */])(response.data);
      return response;
    }).catch(__WEBPACK_IMPORTED_MODULE_3__parsers_error__["a" /* default */]);
  }

  function listPublic(trigger, listId) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    return _fetchRawList(trigger, listId, options).then(function (response) {
      return _parseListResponse(response, options);
    }).catch(__WEBPACK_IMPORTED_MODULE_3__parsers_error__["a" /* default */]);
  }

  function listNextInChannel(trigger, listId) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var videoId = options.videoId,
        paging = options.paging;


    if (paging && paging.cursor || !videoId) {
      return adapterMethods.listItems.listPublic(trigger, listId, options);
    }

    return _loadStartingFromVideoId(trigger, videoId, listId, options).then(function (response) {
      return _parseListResponse(response, options);
    }).catch(__WEBPACK_IMPORTED_MODULE_3__parsers_error__["a" /* default */]);
  }

  function add(trigger, listId, itemIds, data) {
    itemIds = _.compact(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_cast_aray__["a" /* default */])(itemIds));

    if (_.isEmpty(itemIds)) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__parsers_error__["a" /* default */])({
        status: 500,
        data: {
          errorCode: 500,
          errorDescription: 'no item ids provided'
        }
      });
    }

    data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_object__["keysToSnakeCase"])(data), {
      items: itemIds
    });

    return __WEBPACK_IMPORTED_MODULE_6__utils_http__["post"](settings.apiUrl + '/catalog/lists/' + listId + '/items', { data: data }).then(function (response) {
      var items = _.map(response.data, toItem);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__trigger_progress_while_transcoding__["a" /* default */])(items);

      return _.assign({}, response, { data: items });
    }).catch(__WEBPACK_IMPORTED_MODULE_3__parsers_error__["a" /* default */]);
  }

  function update(trigger, listId, itemData) {
    itemData = _.assign({}, itemData);

    var _itemData = itemData,
        id = _itemData.id,
        publishTs = _itemData.publishTs;


    if (publishTs) {
      itemData.publishTs = Math.round(publishTs.valueOf() / 1000);
    }

    var data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_object__["keysToSnakeCase"])(_.omit(itemData, __WEBPACK_IMPORTED_MODULE_5__item__["b" /* excludedFields */]));

    return __WEBPACK_IMPORTED_MODULE_6__utils_http__["put"](settings.apiUrl + '/catalog/lists/' + listId + '/items/' + id, { data: data }).then(_parseSuccessResponse).catch(__WEBPACK_IMPORTED_MODULE_3__parsers_error__["a" /* default */]);
  }

  function _performListItemsRemoveRequest(listId, data) {
    return __WEBPACK_IMPORTED_MODULE_6__utils_http__["post"](settings.apiUrl + '/catalog/lists/' + listId + '/items/delete', { data: data }).catch(__WEBPACK_IMPORTED_MODULE_3__parsers_error__["a" /* default */]);
  }

  function remove(trigger, listId, itemIds) {
    var data = {
      items: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_cast_aray__["a" /* default */])(itemIds)
    };

    return _performListItemsRemoveRequest(listId, data);
  }

  function removeByBaseItemId(trigger, listId, itemIds) {
    var data = {
      base_items: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_cast_aray__["a" /* default */])(itemIds)
    };

    return _performListItemsRemoveRequest(listId, data);
  }

  var moveSequence = new __WEBPACK_IMPORTED_MODULE_10__utils_task_sequence__["a" /* default */]();

  function move(trigger, listId, itemIds, moveData) {
    var data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_object__["keysToSnakeCase"])(moveData), {
      items: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_cast_aray__["a" /* default */])(itemIds)
    });

    return moveSequence.runSequentially(function () {
      return __WEBPACK_IMPORTED_MODULE_6__utils_http__["post"](settings.apiUrl + '/catalog/lists/' + listId + '/items-move', { data: data }).then(_parseSuccessResponse).catch(__WEBPACK_IMPORTED_MODULE_3__parsers_error__["a" /* default */]);
    });
  }

  return {
    list: list,
    listPublic: listPublic,
    listNextInChannel: listNextInChannel,
    add: add,
    get: get,
    getPublic: getPublic,
    update: update,
    remove: remove,
    removeByBaseItemId: removeByBaseItemId,
    move: move
  };
});

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export prepareListForSending */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parsers_list__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parsers_error__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_http__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_object__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_publish_statuses__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_channel_types__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__external_requests__ = __webpack_require__(267);













var excludedFields = ['videosCount', 'items', 'updatedTs', 'createdTs', 'id', 'itemType', 'mediaStatus', 'featuredItem', 'hasChangesToPublish', 'publishedTs'];

function prepareListForSending(listData) {
  listData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_object__["keysToCamelCase"])(listData);

  var _listData = listData,
      externalCreatedTs = _listData.externalCreatedTs,
      channelType = _listData.channelType;


  if (externalCreatedTs) {
    listData.externalCreatedTs = Math.round(externalCreatedTs.valueOf() / 1000);
  }

  var fieldsToExclude = excludedFields;
  if (!channelType || channelType === __WEBPACK_IMPORTED_MODULE_7__constants_channel_types__["a" /* default */].CHANNEL) {
    fieldsToExclude = [].concat(excludedFields, ['coverUrl']);
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_object__["keysToSnakeCase"])(_.omit(listData, fieldsToExclude));
}

/* harmony default export */ __webpack_exports__["a"] = (function (settings, adapterMethods) {

  var toList = _.partial(__WEBPACK_IMPORTED_MODULE_2__parsers_list__["a" /* default */], adapterMethods);

  function _getItemCoverUrl() {
    var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var customCoverUrl = item.customCoverUrl,
        coverUrl = item.coverUrl;

    return customCoverUrl || coverUrl;
  }

  function _parseSuccessResponse(response) {
    var data = response.data;


    return _.assign({}, response, {
      data: toList(data)
    });
  }

  function _loadExternalListData(response) {
    var data = response.data;
    var externalId = data.externalId,
        channelType = data.channelType,
        urlType = data.urlType;


    var externalRequestMethod = __WEBPACK_IMPORTED_MODULE_8__external_requests__["b" /* lists */][channelType + '.' + urlType];

    if (!externalRequestMethod) {
      return response;
    }

    return externalRequestMethod(externalId, { noExtraChannelData: true }).then(function (externalResponse) {
      var externalData = _.omit(externalResponse.data[0], 'id', 'title', 'description');
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, response, {
        data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, response.data, externalData)
      });
    });
  }

  function get(trigger, listId) {
    if (!listId) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__parsers_error__["a" /* default */])({
        status: 500,
        data: {
          errorCode: 500,
          errorDescription: 'no id provided'
        }
      });
    }

    return __WEBPACK_IMPORTED_MODULE_4__utils_http__["get"](settings.apiUrl + '/catalog/lists/' + listId).then(_parseSuccessResponse).then(_loadExternalListData).catch(__WEBPACK_IMPORTED_MODULE_3__parsers_error__["a" /* default */]);
  }

  function getPublic(trigger, listId) {
    return __WEBPACK_IMPORTED_MODULE_4__utils_http__["get"](settings.apiUrl + '/public/lists/' + listId + '/info').then(_parseSuccessResponse).then(function (response) {

      // fix server bug - coverUrl is always null,
      // need to get cover url of featured of first video
      if (!response.data.customCoverUrl) {
        if (!response.data.coverUrl) {
          response.data.coverUrl = _getItemCoverUrl(response.data.featuredItem || {});
        }

        if (!response.data.coverUrl) {
          return adapterMethods.listItems.listPublic(trigger, listId, {
            noAdditionalRequests: true,
            paging: { size: 1 }
          }).then(function (_ref) {
            var _ref$data = _ref.data,
                data = _ref$data === undefined ? [] : _ref$data;

            response.data.coverUrl = _getItemCoverUrl(data[0]);
            return response;
          }).catch(function () {
            return response;
          });
        }
      }
      return response;
    }).then(_loadExternalListData).catch(__WEBPACK_IMPORTED_MODULE_3__parsers_error__["a" /* default */]);
  }

  function getPaymentInfo(trigger, listId, data) {
    var instance = data.instance;


    return __WEBPACK_IMPORTED_MODULE_4__utils_http__["post"](settings.apiUrl + '/public/lists/' + listId + '/member/info', {
      params: { instance: instance },
      data: {}
    }).then(__WEBPACK_IMPORTED_MODULE_5__utils_object__["keysToCamelCase"]).catch(__WEBPACK_IMPORTED_MODULE_3__parsers_error__["a" /* default */]);
  }

  function create(trigger, listData) {
    listData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
      mediaType: settings.mediaType
    }, listData);

    var data = prepareListForSending(listData);

    return __WEBPACK_IMPORTED_MODULE_4__utils_http__["post"](settings.apiUrl + '/catalog/lists', { data: data }).then(_parseSuccessResponse).then(function (response) {
      return _.merge({ data: listData }, response);
    }).catch(__WEBPACK_IMPORTED_MODULE_3__parsers_error__["a" /* default */]);
  }

  function update(trigger, listData) {
    var id = listData.id;


    var data = prepareListForSending(listData);

    return __WEBPACK_IMPORTED_MODULE_4__utils_http__["put"](settings.apiUrl + '/catalog/lists/' + id, { data: data }).then(_parseSuccessResponse).then(function (response) {
      return _.merge({ data: listData }, response);
    }).catch(__WEBPACK_IMPORTED_MODULE_3__parsers_error__["a" /* default */]);
  }

  function checkPublish(trigger, taskId) {
    return __WEBPACK_IMPORTED_MODULE_4__utils_http__["get"](settings.apiUrl + '/publisher/bg-op/tasks/' + taskId).catch(function (response) {
      if (response.status === 404) {
        // task not found === it's already finished
        return { data: { status: __WEBPACK_IMPORTED_MODULE_6__constants_publish_statuses__["a" /* default */].SUCCEEDED } };
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response);
    }).then(function (response) {
      if (response.data.status !== __WEBPACK_IMPORTED_MODULE_6__constants_publish_statuses__["a" /* default */].SUCCEEDED) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject();
      }
    });
  }

  function publish(trigger, listId) {
    return __WEBPACK_IMPORTED_MODULE_4__utils_http__["post"](settings.apiUrl + '/publisher/lists/' + listId + '/publish').then(_.property('data.task_id'));
  }

  return {
    get: get,
    getPublic: getPublic,
    getPaymentInfo: getPaymentInfo,
    create: create,
    update: update,
    checkPublish: checkPublish,
    publish: publish
  };
});

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parsers_list__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parsers_error__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__external_requests__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_http__ = __webpack_require__(44);









var defaultPaging = {
  size: 30,
  cursor: null
};

var defaultSort = {
  order: 'date',
  direction: 'desc'
};

/* harmony default export */ __webpack_exports__["a"] = (function (settings, adapterMethods) {

  var toList = _.partial(__WEBPACK_IMPORTED_MODULE_2__parsers_list__["a" /* default */], adapterMethods);

  function list(trigger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var query = options.query,
        tag = options.tag,
        category = options.category,
        _options$noExternalDa = options.noExternalData,
        noExternalData = _options$noExternalDa === undefined ? false : _options$noExternalDa,
        _options$mediaType = options.mediaType,
        mediaType = _options$mediaType === undefined ? settings.mediaType : _options$mediaType;
    var sort = options.sort,
        paging = options.paging;

    sort = _.merge({}, defaultSort, sort);
    paging = _.merge({}, defaultPaging, paging);

    var _paging = paging,
        size = _paging.size,
        cursor = _paging.cursor;
    var _sort = sort,
        direction = _sort.direction,
        order = _sort.order;


    var params = {
      query: query,
      tag: tag,
      category: category,
      media_type: mediaType,
      page_size: size,
      cursor: cursor,
      order: direction === 'desc' ? '-' + order : order
    };

    return __WEBPACK_IMPORTED_MODULE_5__utils_http__["get"](settings.apiUrl + '/catalog/lists', { params: params }).then(function (response) {
      var data = response.data;


      var parsedListItems = _.map(data.items, toList);

      if (noExternalData) {
        return _buildResponse();
      }

      var externalRequestsOptions = { shouldThrowWhenNoItems: false };

      var externalRequests = _(parsedListItems).groupBy(function (item) {
        return item.channelType + '.' + item.urlType;
      }).map(function (items, key) {
        var ids = _.map(items, 'externalId');
        var requestMethod = __WEBPACK_IMPORTED_MODULE_4__external_requests__["b" /* lists */][key];

        if (!requestMethod) {
          return null;
        }

        return requestMethod(ids, externalRequestsOptions);
      }).compact().value();

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(externalRequests).then(function (externalResponses) {

        externalResponses = _.flatMap(externalResponses, 'data');

        parsedListItems = _.map(parsedListItems, function (listItem) {
          var externalData = _.find(externalResponses, function (_ref) {
            var externalId = _ref.externalId;

            return listItem.externalId && listItem.externalId === externalId;
          });

          if (!externalData) {
            return listItem;
          }

          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, listItem, _.omit(externalData, 'id', 'title', 'description'));
        });

        return _buildResponse();
      });

      function _buildResponse() {
        return _.assign({}, response, {
          sort: sort,
          paging: {
            size: size,
            cursor: data.cursor || null
          },
          data: parsedListItems
        });
      }
    }).catch(__WEBPACK_IMPORTED_MODULE_3__parsers_error__["a" /* default */]);
  }

  function search(trigger, query) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    return list(trigger, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, options, { query: query }));
  }

  function remove(trigger, itemId) {
    return __WEBPACK_IMPORTED_MODULE_5__utils_http__["del"](settings.apiUrl + '/catalog/lists/' + itemId).catch(__WEBPACK_IMPORTED_MODULE_3__parsers_error__["a" /* default */]);
  }

  return {
    list: list,
    search: search,
    remove: remove
  };
});

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_http__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_object__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_transcoding_statuses__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__events_index__ = __webpack_require__(199);







var sizesDurations = {};
var premiumInfo = null;
var usage = null;

function _adjustUsage(usageDelta) {
  var _usage = usage,
      _usage$bytes = _usage.bytes,
      bytes = _usage$bytes === undefined ? 0 : _usage$bytes,
      _usage$milliseconds = _usage.milliseconds,
      milliseconds = _usage$milliseconds === undefined ? 0 : _usage$milliseconds;


  bytes += usageDelta.bytes;
  milliseconds += usageDelta.milliseconds;

  _setUsage({ bytes: bytes, milliseconds: milliseconds });
}

function _adjustUsageFromFile(file) {
  var multiplier = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  if (!file) {
    return;
  }

  var duration = file.duration,
      size = file.size;

  _adjustUsage({
    bytes: size * multiplier,
    milliseconds: duration * multiplier
  });
}

function _increaseUsageFromFile(file) {
  _adjustUsageFromFile(file, 1);
}

function _decreaseUsageFromFile(file) {
  _adjustUsageFromFile(file, -1);
}

function _setUsage(newUsage) {
  usage = newUsage;
  return usage;
}

function _addSizeDurationToCache(itemData) {
  var mediaFileName = itemData.mediaFileName,
      mediaInfo = itemData.mediaInfo;


  var fileInput = _.get(mediaInfo, 'fileInput');
  if (!fileInput) {
    return;
  }

  var duration = fileInput.duration,
      size = fileInput.fileSize;


  sizesDurations[mediaFileName] = {
    duration: duration,
    size: size
  };
}

function _setPremiumInfo(newPremiumInfo) {
  premiumInfo = newPremiumInfo;
  return premiumInfo;
}

__WEBPACK_IMPORTED_MODULE_4__events_index__["a" /* default */].on(__WEBPACK_IMPORTED_MODULE_4__events_index__["a" /* default */].FILE.CAN_UPLOAD_VIDEO.SUCCESS, function (file) {
  return _increaseUsageFromFile(file);
});

_.forEach([__WEBPACK_IMPORTED_MODULE_4__events_index__["a" /* default */].ITEM.UPLOAD.SUCCESS, __WEBPACK_IMPORTED_MODULE_4__events_index__["a" /* default */].ITEM.REUPLOAD.SUCCESS], function (event) {
  __WEBPACK_IMPORTED_MODULE_4__events_index__["a" /* default */].on(event, function (_ref) {
    var data = _ref.data;

    _addSizeDurationToCache(data);
  });
});

_.forEach([__WEBPACK_IMPORTED_MODULE_4__events_index__["a" /* default */].ITEM.UPLOAD.FAIL, __WEBPACK_IMPORTED_MODULE_4__events_index__["a" /* default */].ITEM.REUPLOAD.FAIL], function (event) {
  __WEBPACK_IMPORTED_MODULE_4__events_index__["a" /* default */].on(event, function (response, itemData) {
    if (_.get(response, 'error.data.errorCode') === -1810) {
      // don't react on quota exceeded errors
      return;
    }

    _decreaseUsageFromFile(itemData.file);
  });
});

__WEBPACK_IMPORTED_MODULE_4__events_index__["a" /* default */].on(__WEBPACK_IMPORTED_MODULE_4__events_index__["a" /* default */].TRANSCODING.UPDATE, function (_ref2) {
  var id = _ref2.id,
      transcodingStatus = _ref2.transcodingStatus;

  var file = sizesDurations[id];

  if (transcodingStatus === __WEBPACK_IMPORTED_MODULE_3__constants_transcoding_statuses__["a" /* default */].FAILED) {
    _decreaseUsageFromFile(file);
  }
});

__WEBPACK_IMPORTED_MODULE_4__events_index__["a" /* default */].on(__WEBPACK_IMPORTED_MODULE_4__events_index__["a" /* default */].ITEMS.LIST.SUCCESS, function (_ref3) {
  var data = _ref3.data;

  _.forEach(data, _addSizeDurationToCache);
});

/* harmony default export */ __webpack_exports__["a"] = (function (settings, adapterMethods) {

  function getPremiumInfo(trigger) {
    var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (premiumInfo && !force) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(premiumInfo);
    }

    return __WEBPACK_IMPORTED_MODULE_1__utils_http__["get"](settings.apiUrl + '/billing/info').then(_.property('data')).then(__WEBPACK_IMPORTED_MODULE_2__utils_object__["keysToCamelCase"]).then(_setPremiumInfo);
  }

  function getUsage(trigger) {
    return getUsageFromBackend(trigger).then(function (confirmedUsage) {
      if (!usage) {
        _setUsage(confirmedUsage);
      }

      return {
        confirmed: confirmedUsage,
        estimated: usage
      };
    });
  }

  function getUsageFromBackend() {
    return __WEBPACK_IMPORTED_MODULE_1__utils_http__["get"](settings.apiUrl + '/catalog/users/usage').then(_.property('data.usage')).then(__WEBPACK_IMPORTED_MODULE_2__utils_object__["keysToCamelCase"]).then(function (_ref4) {
      var totalVideoBytes = _ref4.totalVideoBytes,
          totalVideoDuration = _ref4.totalVideoDuration;

      return {
        bytes: totalVideoBytes || 0,
        milliseconds: totalVideoDuration || 0
      };
    });
  }

  __WEBPACK_IMPORTED_MODULE_4__events_index__["a" /* default */].on(__WEBPACK_IMPORTED_MODULE_4__events_index__["a" /* default */].ITEMS.REMOVE.SUCCESS, function () {
    setTimeout(function () {
      return adapterMethods.premium.getUsage(_.noop, true);
    }, 1000);
  });

  return {
    getPremiumInfo: getPremiumInfo,
    getUsage: getUsage
  };
});

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parsers_error__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_http__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_object__ = __webpack_require__(51);






/* harmony default export */ __webpack_exports__["a"] = (function (settings) {

  function _parseSuccessResponse(_ref) {
    var data = _ref.data;

    data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_object__["keysToCamelCase"])(data || {});

    var _data = data,
        createdTs = _data.createdTs,
        updatedTs = _data.updatedTs;


    createdTs = new Date(createdTs * 1000);
    updatedTs = new Date(updatedTs * 1000);

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, {
      createdTs: createdTs,
      updatedTs: updatedTs
    });
  }

  function get() {
    return __WEBPACK_IMPORTED_MODULE_2__utils_http__["get"](settings.apiUrl + '/catalog/settings').then(_parseSuccessResponse).catch(function () {
      return {};
    });
  }

  function update(trigger, data) {
    data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_object__["keysToSnakeCase"])(data);

    return __WEBPACK_IMPORTED_MODULE_2__utils_http__["post"](settings.apiUrl + '/catalog/settings', { data: data }).then(_parseSuccessResponse).catch(__WEBPACK_IMPORTED_MODULE_1__parsers_error__["a" /* default */]);
  }

  function reset() {
    return __WEBPACK_IMPORTED_MODULE_2__utils_http__["del"](settings.apiUrl + '/catalog/settings').then(_parseSuccessResponse).catch(__WEBPACK_IMPORTED_MODULE_1__parsers_error__["a" /* default */]);
  }

  return {
    get: get,
    update: update,
    reset: reset
  };
});

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parsers_channel__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parsers_error__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parse_url__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__url_types__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_http__ = __webpack_require__(44);












var defaultPaging = {
  cursor: null
};

var defaultSort = {
  order: 'relevance'
};

// split by 50 ids per request
var MAX_IDS_IN_REQUEST = 50;

/* harmony default export */ __webpack_exports__["a"] = (function (settings, adapterMethods) {

  var parseChannel = _.partial(__WEBPACK_IMPORTED_MODULE_3__parsers_channel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__url_types__["a" /* default */].CHANNEL);

  function _getChannelFirstVideoCover(uploadsPlaylistId) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return adapterMethods.videos.getByPlaylistId(uploadsPlaylistId, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, options, {
      noVideoData: true,
      paging: {
        size: 1
      }
    })).then(_.property('data[0].coverUrl'));
  }

  function getByUrl(url) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parse_url__["a" /* default */])(url, true).then(function (_ref) {
      var id = _ref.id,
          type = _ref.type;

      switch (type) {
        case __WEBPACK_IMPORTED_MODULE_6__url_types__["a" /* default */].CHANNEL:
          return get(id);

        case __WEBPACK_IMPORTED_MODULE_6__url_types__["a" /* default */].PLAYLIST:
          return adapterMethods.playlists.get(id);

        case __WEBPACK_IMPORTED_MODULE_6__url_types__["a" /* default */].USER_NAME:
          return getByUsername(id);

        default:
          return null;
      }
    }).catch(__WEBPACK_IMPORTED_MODULE_4__parsers_error__["a" /* default */]);
  }

  function get(channelIds) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};


    channelIds = _.castArray(channelIds);

    if (!channelIds.length) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve({
        status: 200,
        data: []
      });
    }

    var _options$noExtraChann = options.noExtraChannelData,
        noExtraChannelData = _options$noExtraChann === undefined ? false : _options$noExtraChann;


    var channelRequests = _(channelIds).uniq().chunk(MAX_IDS_IN_REQUEST).map(function (chunkChannelIds) {
      var params = {
        id: chunkChannelIds.join(',')
      };
      return __WEBPACK_IMPORTED_MODULE_7__utils_http__["get"](settings.apiUrl + '/channels', { params: params });
    }).value();

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(channelRequests).then(function (responses) {
      var channels = _.flatMap(responses, 'data.items');

      var parsedChannels = _.map(channels, parseChannel);

      if (noExtraChannelData) {
        return {
          status: responses[0].status,
          data: parsedChannels
        };
      }

      var parsedChannelIds = _.map(parsedChannels, 'externalId');

      var missingIds = _.difference(channelIds, parsedChannelIds);
      var channelsWithoutCover = _.reject(parsedChannels, 'coverUrl');

      var missingChannels = _.map(missingIds, function (id) {
        return parseChannel({ id: id, isExternalRemoved: true });
      });

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(_.map(channelsWithoutCover, function (_ref2) {
        var uploadsPlaylistId = _ref2.uploadsPlaylistId;

        return _getChannelFirstVideoCover(uploadsPlaylistId, options);
      })).then(function (videoCovers) {
        var coverUrlByChannelId = _.zipObject(_.map(channelsWithoutCover, 'externalId'), videoCovers);

        parsedChannels = _.map(parsedChannels, function (parsedChannel) {
          var externalId = parsedChannel.externalId,
              coverUrl = parsedChannel.coverUrl;

          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, parsedChannel, {
            coverUrl: coverUrlByChannelId[externalId] || coverUrl || null
          });
        });

        return {
          status: responses[0].status,
          data: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(parsedChannels), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(missingChannels))
        };
      });
    }).catch(__WEBPACK_IMPORTED_MODULE_4__parsers_error__["a" /* default */]);
  }

  function getByUsername(forUsername) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var params = {
      forUsername: forUsername
    };

    return __WEBPACK_IMPORTED_MODULE_7__utils_http__["get"](settings.apiUrl + '/channels', { params: params }).then(function (response) {
      return {
        status: response.status,
        data: _.map(response.data.items, parseChannel)
      };
    }).then(function (response) {
      var channelData = response.data[0];

      var coverUrl = channelData.coverUrl;


      if (coverUrl) {
        return response;
      }

      return _getChannelFirstVideoCover(channelData.uploadsPlaylistId, options).then(function (coverUrl) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, response, {
          data: [__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, channelData, {
            coverUrl: coverUrl
          })]
        });
      });
    }).catch(__WEBPACK_IMPORTED_MODULE_4__parsers_error__["a" /* default */]);
  }

  function list() {
    var searchParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var sort = _.merge({}, defaultSort, options.sort);
    var paging = _.merge({}, defaultPaging, options.paging);

    var params = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
      pageToken: paging.cursor,
      order: sort.order,
      maxResults: MAX_IDS_IN_REQUEST
    }, searchParams);

    return __WEBPACK_IMPORTED_MODULE_7__utils_http__["get"](settings.apiUrl + '/channels', { params: params }).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, response, {
        data: _.map(response.data.items, parseChannel)
      });
    }).catch(__WEBPACK_IMPORTED_MODULE_4__parsers_error__["a" /* default */]);
  }

  return {
    get: get,
    getByUrl: getByUrl,
    getByUsername: getByUsername,
    list: list
  };
});

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseVideo;
/* harmony export (immutable) */ __webpack_exports__["b"] = addChannelData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_time__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_object__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_transcoding_statuses__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_video_sources__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_free_deal_info__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__get_thumbnail__ = __webpack_require__(431);










function parseVideo(videoData) {
  var _videoData$player = videoData.player,
      player = _videoData$player === undefined ? {} : _videoData$player,
      _videoData$snippet = videoData.snippet,
      snippet = _videoData$snippet === undefined ? {} : _videoData$snippet,
      _videoData$contentDet = videoData.contentDetails,
      contentDetails = _videoData$contentDet === undefined ? {} : _videoData$contentDet;
  var externalId = videoData.id;
  var embedHtml = player.embedHtml;
  var channelId = snippet.channelId,
      title = snippet.title,
      description = snippet.description,
      thumbnails = snippet.thumbnails;
  var duration = contentDetails.duration,
      videoId = contentDetails.videoId;


  var width = embedHtml && Number(embedHtml.match(/width="(\d+)/)[1]);
  var height = embedHtml && Number(embedHtml.match(/height="(\d+)/)[1]);

  // >_<
  if (_.isObject(externalId)) {
    externalId = externalId.videoId;
  }
  externalId = externalId || videoId;

  var mediaExternUrl = '//www.youtube.com/embed/' + externalId;
  var coverUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__get_thumbnail__["a" /* default */])(thumbnails);

  var durationSec = void 0;
  var durationStr = void 0;
  if (duration) {
    durationSec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_time__["convertISO8601ToSS"])(duration);
    durationStr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_time__["convertISO8601ToMMSS"])(duration);
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_object__["removeUndefinedValues"])({
    externalId: externalId,
    coverUrl: coverUrl,
    width: width,
    height: height,
    description: description,
    title: title,
    mediaExternUrl: mediaExternUrl,
    mediaStatus: __WEBPACK_IMPORTED_MODULE_3__constants_transcoding_statuses__["a" /* default */].READY,
    channelId: channelId,
    dealInfo: __WEBPACK_IMPORTED_MODULE_5__constants_free_deal_info__["a" /* default */],
    durationSec: durationSec,
    durationStr: durationStr,
    videoSource: __WEBPACK_IMPORTED_MODULE_4__constants_video_sources__["a" /* default */].YOUTUBE
  });
}

function addChannelData(videoData, channelData) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, videoData, {
    publisher: channelData.title,
    channelData: channelData
  });
}

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parsers_channel__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parsers_error__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__url_types__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_http__ = __webpack_require__(44);









// split by 50 ids per request
var MAX_IDS_IN_REQUEST = 50;

/* harmony default export */ __webpack_exports__["a"] = (function (settings) {

  var parsePlaylist = _.partial(__WEBPACK_IMPORTED_MODULE_2__parsers_channel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__url_types__["a" /* default */].PLAYLIST);

  function get(playlistIds) {

    playlistIds = _.castArray(playlistIds);

    if (!playlistIds.length) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve({
        status: 200,
        data: []
      });
    }

    var playlistRequests = _(playlistIds).uniq().chunk(MAX_IDS_IN_REQUEST).map(function (chunkPlaylistIds) {
      var params = {
        id: chunkPlaylistIds.join(',')
      };
      return __WEBPACK_IMPORTED_MODULE_5__utils_http__["get"](settings.apiUrl + '/playlists', { params: params });
    }).value();

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(playlistRequests).then(function (responses) {
      var playlists = _.flatMap(responses, 'data.items');
      var parsedPlaylists = _.map(playlists, parsePlaylist);

      var missingIds = _.difference(playlistIds, _.map(parsedPlaylists, 'externalId'));

      var missingPlaylists = _.map(missingIds, function (id) {
        return parsePlaylist({ id: id, isExternalRemoved: true });
      });

      return {
        status: responses[0].status,
        data: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(parsedPlaylists), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(missingPlaylists))
      };
    }).catch(__WEBPACK_IMPORTED_MODULE_3__parsers_error__["a" /* default */]);
  }

  return {
    get: get
  };
});

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  apiUrl: '//pix.wix.com/services/youtube'
});

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parsers_video__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parsers_error__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parse_url__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__url_types__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_http__ = __webpack_require__(44);












var MAX_IDS_IN_REQUEST = 50;

var defaultPaging = {
  size: MAX_IDS_IN_REQUEST,
  cursor: null
};

var defaultSort = {
  order: 'relevance'
};

/* harmony default export */ __webpack_exports__["a"] = (function (settings, adapterMethods) {

  function _internalGet(videoIds) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};


    videoIds = _.castArray(videoIds);

    var videosRequests = _(videoIds).uniq().chunk(MAX_IDS_IN_REQUEST).map(function (chunkVideoIds) {
      var params = {
        id: chunkVideoIds.join(',')
      };

      return __WEBPACK_IMPORTED_MODULE_7__utils_http__["get"](settings.apiUrl + '/videos', { params: params }).then(_.partialRight(_extractVideoItems, options));
    }).value();

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(videosRequests).then(function (itemsFromResponses) {
      var videos = _.flatten(itemsFromResponses);

      return {
        status: 200,
        data: _.map(videos, __WEBPACK_IMPORTED_MODULE_3__parsers_video__["a" /* default */])
      };
    });
  }

  function _parsePaginatedResponse(response) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var sort = _.merge({}, defaultSort, options.sort);
    var paging = _.merge({}, defaultPaging, options.paging);

    var _options$noVideoData = options.noVideoData,
        noVideoData = _options$noVideoData === undefined ? false : _options$noVideoData,
        _options$noChannelDat = options.noChannelData,
        noChannelData = _options$noChannelDat === undefined ? false : _options$noChannelDat;


    var videos = _extractVideoItems(response, options);

    var nextPageToken = response.data.nextPageToken;


    if (noVideoData) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, response, {
        data: _.map(videos, __WEBPACK_IMPORTED_MODULE_3__parsers_video__["a" /* default */]),
        sort: sort,
        paging: {
          size: paging.size,
          cursor: nextPageToken || null
        }
      });
    }

    var videoIds = _getVideoIds(videos);

    var loadMethod = noChannelData ? _internalGet : getWithChannelData;

    return loadMethod(videoIds, options).then(function (videosResponse) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, videosResponse, {
        sort: sort,
        paging: {
          size: paging.size,
          cursor: nextPageToken || null
        }
      });
    });
  }

  function getByUrl(url) {
    var skipVideos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__parse_url__["a" /* default */])(url, skipVideos).then(function (_ref) {
      var id = _ref.id,
          type = _ref.type;

      var options = { noExtraChannelData: true };

      switch (type) {
        case __WEBPACK_IMPORTED_MODULE_6__url_types__["a" /* default */].CHANNEL:
          return getByChannelId(id, options);

        case __WEBPACK_IMPORTED_MODULE_6__url_types__["a" /* default */].PLAYLIST:
          return getByPlaylistId(id, options);

        case __WEBPACK_IMPORTED_MODULE_6__url_types__["a" /* default */].USER_NAME:
          return getByUsername(id, options);

        case __WEBPACK_IMPORTED_MODULE_6__url_types__["a" /* default */].VIDEO:
          return getWithChannelData(id, options);

        default:
          return null;
      }
    }).catch(__WEBPACK_IMPORTED_MODULE_4__parsers_error__["a" /* default */]);
  }

  function getByChannelId(channelId) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return adapterMethods.channels.get(channelId, options).then(_.property('data[0].uploadsPlaylistId')).then(_.partialRight(getByPlaylistId, options));
  }

  function getByUsername(username, options) {
    return adapterMethods.channels.list({
      forUsername: username
    }).then(_.property('data[0].externalId')).then(_.partialRight(getByChannelId, options)).catch(__WEBPACK_IMPORTED_MODULE_4__parsers_error__["a" /* default */]);
  }

  function getWithChannelData(videoIds) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return _internalGet(videoIds, options).then(function (response) {
      var videos = response.data;
      var channelIds = _.map(videos, 'channelId');

      return adapterMethods.channels.get(channelIds, options).then(function (channelsResponse) {
        var channelsData = _.keyBy(channelsResponse.data, 'externalId');

        videos = _.map(videos, function (video) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__parsers_video__["b" /* addChannelData */])(video, channelsData[video.channelId]);
        });

        response = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, response, {
          data: videos
        });

        return response;
      });
    }).catch(__WEBPACK_IMPORTED_MODULE_4__parsers_error__["a" /* default */]);
  }

  function _getVideoIds(items) {
    return _(items).map(__WEBPACK_IMPORTED_MODULE_3__parsers_video__["a" /* default */]).map('externalId').value();
  }

  function _extractVideoItems(response, options) {
    var items = response.data.items;
    var _options$shouldThrowW = options.shouldThrowWhenNoItems,
        shouldThrowWhenNoItems = _options$shouldThrowW === undefined ? true : _options$shouldThrowW;


    if (shouldThrowWhenNoItems && _.size(items) === 0) {
      throw new __WEBPACK_IMPORTED_MODULE_4__parsers_error__["b" /* InternalError */](404, 'wpm_error.no_external_video_found', 'No external video was found');
    }

    return items;
  }

  function getByPlaylistId(playlistId) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var prevResponse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    var currentPaging = _.merge({}, defaultPaging, options.paging);

    var pageToken = currentPaging.cursor;
    var maxResults = _.min([currentPaging.size, MAX_IDS_IN_REQUEST]);

    var params = {
      playlistId: playlistId,
      pageToken: pageToken,
      maxResults: maxResults
    };

    if (!prevResponse) {
      prevResponse = { data: [], paging: currentPaging };
    }

    return __WEBPACK_IMPORTED_MODULE_7__utils_http__["get"](settings.apiUrl + '/playlistitems', { params: params }).then(function (response) {
      return _parsePaginatedResponse(response, options);
    }).then(function (currentResponse) {

      currentResponse = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, currentResponse, {
        paging: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, currentResponse.paging, {
          size: prevResponse.paging.size
        }),
        data: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(prevResponse.data), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(currentResponse.data))
      });

      var nextOptions = {
        paging: {
          cursor: currentResponse.paging.cursor,
          size: currentPaging.size - maxResults
        }
      };

      if (!_.every(nextOptions.paging)) {
        // if size is 0 or cursor is null - return final response
        return currentResponse;
      }

      return getByPlaylistId(playlistId, nextOptions, currentResponse);
    }).catch(__WEBPACK_IMPORTED_MODULE_4__parsers_error__["a" /* default */]);
  }

  function search(query) {
    var searchParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var sort = _.merge({}, defaultSort, options.sort);
    var paging = _.merge({}, defaultPaging, options.paging);

    var params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
      q: query,
      order: sort.order,
      pageToken: paging.cursor,
      maxResults: paging.size
    }, searchParams);

    return __WEBPACK_IMPORTED_MODULE_7__utils_http__["get"](settings.apiUrl + '/search', { params: params }).then(function (response) {
      return _parsePaginatedResponse(response, options);
    }).catch(__WEBPACK_IMPORTED_MODULE_4__parsers_error__["a" /* default */]);
  }

  function get(videoIds) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return _internalGet(videoIds, options).catch(__WEBPACK_IMPORTED_MODULE_4__parsers_error__["a" /* default */]);
  }

  return {
    get: get,
    getWithChannelData: getWithChannelData,
    getByUrl: getByUrl,
    getByPlaylistId: getByPlaylistId,
    getByChannelId: getByChannelId,
    getByUsername: getByUsername,
    search: search
  };
});

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  INPROGRESS: 'in-progress',
  SUCCEEDED: 'succeeded'
});

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export set */
/* unused harmony export unset */
/* harmony export (immutable) */ __webpack_exports__["a"] = get;
/* harmony export (immutable) */ __webpack_exports__["b"] = setExpirable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);

var CACHE_TIME = 5 * 1000; // 5 seconds

var cache = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a();

function set(key, value) {
  cache.set(key, value);
}

function unset(key) {
  cache.delete(key);
}

function get(key) {
  return cache.get(key);
}

function setExpirable(key, value) {
  var time = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : CACHE_TIME;

  set(key, value);
  setTimeout(function () {
    unset(key);
  }, time);
}

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__event_emitter__ = __webpack_require__(433);



/* harmony default export */ __webpack_exports__["a"] = (function (method, parentTrigger) {
  return function () {
    var methodEvents = new __WEBPACK_IMPORTED_MODULE_1__event_emitter__["a" /* default */]();

    function trigger() {
      methodEvents.trigger.apply(methodEvents, arguments);
      parentTrigger.apply(undefined, arguments);
    }

    var promise = method.apply(undefined, [trigger].concat(Array.prototype.slice.call(arguments))).then(function (res) {
      methodEvents.off();
      return res;
    }).catch(function (res) {
      methodEvents.off();
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res);
    });

    _.forEach(['on', 'off'], function (methodName) {
      promise[methodName] = function () {
        return methodEvents[methodName].apply(methodEvents, arguments);
      };
    });

    return promise;
  };
});

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TaskSequence; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_decorators_lib_autobind__);





var _desc, _value, _class, _desc2, _value2, _class2;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}



var DeferredTask = (_class = function () {
  function DeferredTask(task) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, DeferredTask);

    this.task = task;
    this.promise = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(this.attachPromiseMethods);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(DeferredTask, [{
    key: 'attachPromiseMethods',
    value: function attachPromiseMethods(resolve, reject) {
      this.resolve = resolve;
      this.reject = reject;
    }
  }, {
    key: 'run',
    value: function run() {
      this.task().then(this.resolve, this.reject);
    }
  }]);

  return DeferredTask;
}(), (_applyDecoratedDescriptor(_class.prototype, 'attachPromiseMethods', [__WEBPACK_IMPORTED_MODULE_4_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'attachPromiseMethods'), _class.prototype)), _class);
var TaskSequence = (_class2 = function () {
  function TaskSequence() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, TaskSequence);

    this.tasksStack = [];
    this.isInProgress = false;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(TaskSequence, [{
    key: 'runFirstTask',
    value: function runFirstTask() {
      if (this.tasksStack.length) {
        this.isInProgress = true;
        this.tasksStack.shift().run();
      } else {
        this.isInProgress = false;
      }
    }
  }, {
    key: 'runSequentially',
    value: function runSequentially(task) {
      var deferredTask = new DeferredTask(task);
      this.tasksStack.push(deferredTask);

      if (!this.isInProgress) {
        this.runFirstTask();
      }

      return deferredTask.promise.then(this.runFirstTask, this.runFirstTask);
    }
  }]);

  return TaskSequence;
}(), (_applyDecoratedDescriptor(_class2.prototype, 'runFirstTask', [__WEBPACK_IMPORTED_MODULE_4_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'runFirstTask'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'runSequentially', [__WEBPACK_IMPORTED_MODULE_4_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'runSequentially'), _class2.prototype)), _class2);


/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

/* harmony default export */ __webpack_exports__["a"] = (function (func, namespace) {
  return function () {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var trigger = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _.noop;


    trigger.apply(undefined, [namespace + ".BEFORE"].concat(args));

    return func.apply(undefined, [trigger].concat(args)).then(function (res) {
      trigger.apply(undefined, [namespace + ".SUCCESS", res].concat(args));
      return res;
    }).catch(function (res) {
      trigger.apply(undefined, [namespace + ".FAIL", res].concat(args));
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(res);
    });
  };
});

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = isVisible;
/* harmony export (immutable) */ __webpack_exports__["a"] = renderSignInToWatchButtonText;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_translations_overlay_common_translations__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_widget_ui_selectors_video_access__ = __webpack_require__(94);
/* eslint-disable react/prop-types */





/**
 * Is channel sign in to play button visible
 * @param props {Object}
 * @param props.channel {Object}
 * @param props.video {Object}
 * @return {Boolean}
 */
function isVisible(_ref) {
  var channel = _ref.channel,
      video = _ref.video;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_widget_ui_selectors_video_access__["d" /* getFullAccessActionName */])(channel, video) === __WEBPACK_IMPORTED_MODULE_2_widget_ui_selectors_video_access__["c" /* FULL_ACCESS_ACTION_NAMES */].SIGN_IN;
}

/**
 * Channel sign in to play button text
 * @param props {Object}
 * @param props.channel {Object}
 * @param props.video {Object}
 * @param props.translation {Object} default is commonTranslations.playVideo
 * @return {React.Component}
 */
function renderSignInToWatchButtonText(props) {
  if (!isVisible(props)) {
    return null;
  }

  var translation = props.translation || __WEBPACK_IMPORTED_MODULE_1_shared_translations_overlay_common_translations__["a" /* default */].playVideo;
  return React.createElement(__WEBPACK_IMPORTED_MODULE_0_react_intl__["a" /* FormattedMessage */], translation);
}

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AVAILABLE_IMAGE_WIDTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MAX_IMAGE_WIDTH; });
var AVAILABLE_IMAGE_WIDTH = [90, 180, 360, 540, 768, 1024, 1280, 1366, 1440, 1600, 1680, 1920, 2560];
var MAX_IMAGE_WIDTH = _.last(AVAILABLE_IMAGE_WIDTH);

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NAMES; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_redux_helpers_create_async_actions__ = __webpack_require__(26);


var ACTIONS = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_redux_helpers_create_async_actions__["a" /* default */])('CLIENT.VIDEO_URLS.GET');
var NAMES = ACTIONS.NAMES;
var START = ACTIONS.START,
    SUCCESS = ACTIONS.SUCCESS,
    FAIL = ACTIONS.FAIL;


var fetchVideoUrls = function fetchVideoUrls(videoItem) {
  var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function (dispatch, getState) {
    var _getState = getState(),
        videoUrlsCache = _getState.videoUrlsCache,
        appSettings = _getState.appSettings;

    if (!force && (!videoItem || videoUrlsCache[videoItem.id])) {
      return;
    }

    var params = { videoItem: videoItem };

    dispatch(START(params));

    return videoItem.getVideoUrls(appSettings.instance).then(function (response) {
      dispatch(SUCCESS(params, response));
      return response;
    }, function (response) {
      dispatch(FAIL(params, response));
    });
  };
};

/* harmony default export */ __webpack_exports__["a"] = (fetchVideoUrls);

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getNormalizedCachedDimensions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_widget_constants_image_sizes__ = __webpack_require__(714);


var isGif = function isGif(coverUrl) {
  return (/.gif$/.test(coverUrl)
  );
};
var round100 = function round100(width, height) {
  return Math.round(width / height * 100) / 100;
};

var cache = {};

function getNormalizedCachedDimensions(coverUrl, _ref) {
  var containerWidth = _ref.containerWidth,
      containerHeight = _ref.containerHeight;

  var aspectRatio = round100(containerWidth, containerHeight);
  var cachedSizes = _.get(cache[aspectRatio], [coverUrl]);

  var loadedImageWidth = _.get(cachedSizes, 'width', 0);
  var loadedImageHeight = _.get(cachedSizes, 'height', 0);

  var widthCandidate = _.find(__WEBPACK_IMPORTED_MODULE_0_widget_constants_image_sizes__["a" /* AVAILABLE_IMAGE_WIDTH */], function (size) {
    return size >= containerWidth;
  });
  var width = isGif(coverUrl) ? __WEBPACK_IMPORTED_MODULE_0_widget_constants_image_sizes__["b" /* MAX_IMAGE_WIDTH */] : Math.max(widthCandidate, loadedImageWidth);

  var heightCandidate = Math.round(width / aspectRatio);
  var height = Math.max(heightCandidate, loadedImageHeight);

  if (!cache[aspectRatio]) {
    cache[aspectRatio] = {};
  }

  cache[aspectRatio][coverUrl] = { width: width, height: height };

  return [width, height];
}

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(957);

__webpack_require__(1166);

__webpack_require__(725);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(728), __esModule: true };

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(732), __esModule: true };

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(736), __esModule: true };

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(739), __esModule: true };

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global, setImmediate) {/* @preserve
 * The MIT License (MIT)
 * 
 * Copyright (c) 2013-2015 Petka Antonov
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 * 
 */
/**
 * bluebird build version 2.11.0
 * Features enabled: core, race, call_get, generators, map, nodeify, promisify, props, reduce, settle, some, cancel, using, filter, any, each, timers
*/
!function(e){if(true)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{var f;"undefined"!=typeof window?f=window:"undefined"!=typeof global?f=global:"undefined"!=typeof self&&(f=self),f.Promise=e()}}(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof _dereq_=="function"&&_dereq_;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof _dereq_=="function"&&_dereq_;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
var SomePromiseArray = Promise._SomePromiseArray;
function any(promises) {
    var ret = new SomePromiseArray(promises);
    var promise = ret.promise();
    ret.setHowMany(1);
    ret.setUnwrap();
    ret.init();
    return promise;
}

Promise.any = function (promises) {
    return any(promises);
};

Promise.prototype.any = function () {
    return any(this);
};

};

},{}],2:[function(_dereq_,module,exports){
"use strict";
var firstLineError;
try {throw new Error(); } catch (e) {firstLineError = e;}
var schedule = _dereq_("./schedule.js");
var Queue = _dereq_("./queue.js");
var util = _dereq_("./util.js");

function Async() {
    this._isTickUsed = false;
    this._lateQueue = new Queue(16);
    this._normalQueue = new Queue(16);
    this._trampolineEnabled = true;
    var self = this;
    this.drainQueues = function () {
        self._drainQueues();
    };
    this._schedule =
        schedule.isStatic ? schedule(this.drainQueues) : schedule;
}

Async.prototype.disableTrampolineIfNecessary = function() {
    if (util.hasDevTools) {
        this._trampolineEnabled = false;
    }
};

Async.prototype.enableTrampoline = function() {
    if (!this._trampolineEnabled) {
        this._trampolineEnabled = true;
        this._schedule = function(fn) {
            setTimeout(fn, 0);
        };
    }
};

Async.prototype.haveItemsQueued = function () {
    return this._normalQueue.length() > 0;
};

Async.prototype.throwLater = function(fn, arg) {
    if (arguments.length === 1) {
        arg = fn;
        fn = function () { throw arg; };
    }
    if (typeof setTimeout !== "undefined") {
        setTimeout(function() {
            fn(arg);
        }, 0);
    } else try {
        this._schedule(function() {
            fn(arg);
        });
    } catch (e) {
        throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/m3OTXk\u000a");
    }
};

function AsyncInvokeLater(fn, receiver, arg) {
    this._lateQueue.push(fn, receiver, arg);
    this._queueTick();
}

function AsyncInvoke(fn, receiver, arg) {
    this._normalQueue.push(fn, receiver, arg);
    this._queueTick();
}

function AsyncSettlePromises(promise) {
    this._normalQueue._pushOne(promise);
    this._queueTick();
}

if (!util.hasDevTools) {
    Async.prototype.invokeLater = AsyncInvokeLater;
    Async.prototype.invoke = AsyncInvoke;
    Async.prototype.settlePromises = AsyncSettlePromises;
} else {
    if (schedule.isStatic) {
        schedule = function(fn) { setTimeout(fn, 0); };
    }
    Async.prototype.invokeLater = function (fn, receiver, arg) {
        if (this._trampolineEnabled) {
            AsyncInvokeLater.call(this, fn, receiver, arg);
        } else {
            this._schedule(function() {
                setTimeout(function() {
                    fn.call(receiver, arg);
                }, 100);
            });
        }
    };

    Async.prototype.invoke = function (fn, receiver, arg) {
        if (this._trampolineEnabled) {
            AsyncInvoke.call(this, fn, receiver, arg);
        } else {
            this._schedule(function() {
                fn.call(receiver, arg);
            });
        }
    };

    Async.prototype.settlePromises = function(promise) {
        if (this._trampolineEnabled) {
            AsyncSettlePromises.call(this, promise);
        } else {
            this._schedule(function() {
                promise._settlePromises();
            });
        }
    };
}

Async.prototype.invokeFirst = function (fn, receiver, arg) {
    this._normalQueue.unshift(fn, receiver, arg);
    this._queueTick();
};

Async.prototype._drainQueue = function(queue) {
    while (queue.length() > 0) {
        var fn = queue.shift();
        if (typeof fn !== "function") {
            fn._settlePromises();
            continue;
        }
        var receiver = queue.shift();
        var arg = queue.shift();
        fn.call(receiver, arg);
    }
};

Async.prototype._drainQueues = function () {
    this._drainQueue(this._normalQueue);
    this._reset();
    this._drainQueue(this._lateQueue);
};

Async.prototype._queueTick = function () {
    if (!this._isTickUsed) {
        this._isTickUsed = true;
        this._schedule(this.drainQueues);
    }
};

Async.prototype._reset = function () {
    this._isTickUsed = false;
};

module.exports = new Async();
module.exports.firstLineError = firstLineError;

},{"./queue.js":28,"./schedule.js":31,"./util.js":38}],3:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL, tryConvertToPromise) {
var rejectThis = function(_, e) {
    this._reject(e);
};

var targetRejected = function(e, context) {
    context.promiseRejectionQueued = true;
    context.bindingPromise._then(rejectThis, rejectThis, null, this, e);
};

var bindingResolved = function(thisArg, context) {
    if (this._isPending()) {
        this._resolveCallback(context.target);
    }
};

var bindingRejected = function(e, context) {
    if (!context.promiseRejectionQueued) this._reject(e);
};

Promise.prototype.bind = function (thisArg) {
    var maybePromise = tryConvertToPromise(thisArg);
    var ret = new Promise(INTERNAL);
    ret._propagateFrom(this, 1);
    var target = this._target();

    ret._setBoundTo(maybePromise);
    if (maybePromise instanceof Promise) {
        var context = {
            promiseRejectionQueued: false,
            promise: ret,
            target: target,
            bindingPromise: maybePromise
        };
        target._then(INTERNAL, targetRejected, ret._progress, ret, context);
        maybePromise._then(
            bindingResolved, bindingRejected, ret._progress, ret, context);
    } else {
        ret._resolveCallback(target);
    }
    return ret;
};

Promise.prototype._setBoundTo = function (obj) {
    if (obj !== undefined) {
        this._bitField = this._bitField | 131072;
        this._boundTo = obj;
    } else {
        this._bitField = this._bitField & (~131072);
    }
};

Promise.prototype._isBound = function () {
    return (this._bitField & 131072) === 131072;
};

Promise.bind = function (thisArg, value) {
    var maybePromise = tryConvertToPromise(thisArg);
    var ret = new Promise(INTERNAL);

    ret._setBoundTo(maybePromise);
    if (maybePromise instanceof Promise) {
        maybePromise._then(function() {
            ret._resolveCallback(value);
        }, ret._reject, ret._progress, ret, null);
    } else {
        ret._resolveCallback(value);
    }
    return ret;
};
};

},{}],4:[function(_dereq_,module,exports){
"use strict";
var old;
if (typeof Promise !== "undefined") old = Promise;
function noConflict() {
    try { if (Promise === bluebird) Promise = old; }
    catch (e) {}
    return bluebird;
}
var bluebird = _dereq_("./promise.js")();
bluebird.noConflict = noConflict;
module.exports = bluebird;

},{"./promise.js":23}],5:[function(_dereq_,module,exports){
"use strict";
var cr = Object.create;
if (cr) {
    var callerCache = cr(null);
    var getterCache = cr(null);
    callerCache[" size"] = getterCache[" size"] = 0;
}

module.exports = function(Promise) {
var util = _dereq_("./util.js");
var canEvaluate = util.canEvaluate;
var isIdentifier = util.isIdentifier;

var getMethodCaller;
var getGetter;
if (false) {
var makeMethodCaller = function (methodName) {
    return new Function("ensureMethod", "                                    \n\
        return function(obj) {                                               \n\
            'use strict'                                                     \n\
            var len = this.length;                                           \n\
            ensureMethod(obj, 'methodName');                                 \n\
            switch(len) {                                                    \n\
                case 1: return obj.methodName(this[0]);                      \n\
                case 2: return obj.methodName(this[0], this[1]);             \n\
                case 3: return obj.methodName(this[0], this[1], this[2]);    \n\
                case 0: return obj.methodName();                             \n\
                default:                                                     \n\
                    return obj.methodName.apply(obj, this);                  \n\
            }                                                                \n\
        };                                                                   \n\
        ".replace(/methodName/g, methodName))(ensureMethod);
};

var makeGetter = function (propertyName) {
    return new Function("obj", "                                             \n\
        'use strict';                                                        \n\
        return obj.propertyName;                                             \n\
        ".replace("propertyName", propertyName));
};

var getCompiled = function(name, compiler, cache) {
    var ret = cache[name];
    if (typeof ret !== "function") {
        if (!isIdentifier(name)) {
            return null;
        }
        ret = compiler(name);
        cache[name] = ret;
        cache[" size"]++;
        if (cache[" size"] > 512) {
            var keys = Object.keys(cache);
            for (var i = 0; i < 256; ++i) delete cache[keys[i]];
            cache[" size"] = keys.length - 256;
        }
    }
    return ret;
};

getMethodCaller = function(name) {
    return getCompiled(name, makeMethodCaller, callerCache);
};

getGetter = function(name) {
    return getCompiled(name, makeGetter, getterCache);
};
}

function ensureMethod(obj, methodName) {
    var fn;
    if (obj != null) fn = obj[methodName];
    if (typeof fn !== "function") {
        var message = "Object " + util.classString(obj) + " has no method '" +
            util.toString(methodName) + "'";
        throw new Promise.TypeError(message);
    }
    return fn;
}

function caller(obj) {
    var methodName = this.pop();
    var fn = ensureMethod(obj, methodName);
    return fn.apply(obj, this);
}
Promise.prototype.call = function (methodName) {
    var $_len = arguments.length;var args = new Array($_len - 1); for(var $_i = 1; $_i < $_len; ++$_i) {args[$_i - 1] = arguments[$_i];}
    if (false) {
        if (canEvaluate) {
            var maybeCaller = getMethodCaller(methodName);
            if (maybeCaller !== null) {
                return this._then(
                    maybeCaller, undefined, undefined, args, undefined);
            }
        }
    }
    args.push(methodName);
    return this._then(caller, undefined, undefined, args, undefined);
};

function namedGetter(obj) {
    return obj[this];
}
function indexedGetter(obj) {
    var index = +this;
    if (index < 0) index = Math.max(0, index + obj.length);
    return obj[index];
}
Promise.prototype.get = function (propertyName) {
    var isIndex = (typeof propertyName === "number");
    var getter;
    if (!isIndex) {
        if (canEvaluate) {
            var maybeGetter = getGetter(propertyName);
            getter = maybeGetter !== null ? maybeGetter : namedGetter;
        } else {
            getter = namedGetter;
        }
    } else {
        getter = indexedGetter;
    }
    return this._then(getter, undefined, undefined, propertyName, undefined);
};
};

},{"./util.js":38}],6:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
var errors = _dereq_("./errors.js");
var async = _dereq_("./async.js");
var CancellationError = errors.CancellationError;

Promise.prototype._cancel = function (reason) {
    if (!this.isCancellable()) return this;
    var parent;
    var promiseToReject = this;
    while ((parent = promiseToReject._cancellationParent) !== undefined &&
        parent.isCancellable()) {
        promiseToReject = parent;
    }
    this._unsetCancellable();
    promiseToReject._target()._rejectCallback(reason, false, true);
};

Promise.prototype.cancel = function (reason) {
    if (!this.isCancellable()) return this;
    if (reason === undefined) reason = new CancellationError();
    async.invokeLater(this._cancel, this, reason);
    return this;
};

Promise.prototype.cancellable = function () {
    if (this._cancellable()) return this;
    async.enableTrampoline();
    this._setCancellable();
    this._cancellationParent = undefined;
    return this;
};

Promise.prototype.uncancellable = function () {
    var ret = this.then();
    ret._unsetCancellable();
    return ret;
};

Promise.prototype.fork = function (didFulfill, didReject, didProgress) {
    var ret = this._then(didFulfill, didReject, didProgress,
                         undefined, undefined);

    ret._setCancellable();
    ret._cancellationParent = undefined;
    return ret;
};
};

},{"./async.js":2,"./errors.js":13}],7:[function(_dereq_,module,exports){
"use strict";
module.exports = function() {
var async = _dereq_("./async.js");
var util = _dereq_("./util.js");
var bluebirdFramePattern =
    /[\\\/]bluebird[\\\/]js[\\\/](main|debug|zalgo|instrumented)/;
var stackFramePattern = null;
var formatStack = null;
var indentStackFrames = false;
var warn;

function CapturedTrace(parent) {
    this._parent = parent;
    var length = this._length = 1 + (parent === undefined ? 0 : parent._length);
    captureStackTrace(this, CapturedTrace);
    if (length > 32) this.uncycle();
}
util.inherits(CapturedTrace, Error);

CapturedTrace.prototype.uncycle = function() {
    var length = this._length;
    if (length < 2) return;
    var nodes = [];
    var stackToIndex = {};

    for (var i = 0, node = this; node !== undefined; ++i) {
        nodes.push(node);
        node = node._parent;
    }
    length = this._length = i;
    for (var i = length - 1; i >= 0; --i) {
        var stack = nodes[i].stack;
        if (stackToIndex[stack] === undefined) {
            stackToIndex[stack] = i;
        }
    }
    for (var i = 0; i < length; ++i) {
        var currentStack = nodes[i].stack;
        var index = stackToIndex[currentStack];
        if (index !== undefined && index !== i) {
            if (index > 0) {
                nodes[index - 1]._parent = undefined;
                nodes[index - 1]._length = 1;
            }
            nodes[i]._parent = undefined;
            nodes[i]._length = 1;
            var cycleEdgeNode = i > 0 ? nodes[i - 1] : this;

            if (index < length - 1) {
                cycleEdgeNode._parent = nodes[index + 1];
                cycleEdgeNode._parent.uncycle();
                cycleEdgeNode._length =
                    cycleEdgeNode._parent._length + 1;
            } else {
                cycleEdgeNode._parent = undefined;
                cycleEdgeNode._length = 1;
            }
            var currentChildLength = cycleEdgeNode._length + 1;
            for (var j = i - 2; j >= 0; --j) {
                nodes[j]._length = currentChildLength;
                currentChildLength++;
            }
            return;
        }
    }
};

CapturedTrace.prototype.parent = function() {
    return this._parent;
};

CapturedTrace.prototype.hasParent = function() {
    return this._parent !== undefined;
};

CapturedTrace.prototype.attachExtraTrace = function(error) {
    if (error.__stackCleaned__) return;
    this.uncycle();
    var parsed = CapturedTrace.parseStackAndMessage(error);
    var message = parsed.message;
    var stacks = [parsed.stack];

    var trace = this;
    while (trace !== undefined) {
        stacks.push(cleanStack(trace.stack.split("\n")));
        trace = trace._parent;
    }
    removeCommonRoots(stacks);
    removeDuplicateOrEmptyJumps(stacks);
    util.notEnumerableProp(error, "stack", reconstructStack(message, stacks));
    util.notEnumerableProp(error, "__stackCleaned__", true);
};

function reconstructStack(message, stacks) {
    for (var i = 0; i < stacks.length - 1; ++i) {
        stacks[i].push("From previous event:");
        stacks[i] = stacks[i].join("\n");
    }
    if (i < stacks.length) {
        stacks[i] = stacks[i].join("\n");
    }
    return message + "\n" + stacks.join("\n");
}

function removeDuplicateOrEmptyJumps(stacks) {
    for (var i = 0; i < stacks.length; ++i) {
        if (stacks[i].length === 0 ||
            ((i + 1 < stacks.length) && stacks[i][0] === stacks[i+1][0])) {
            stacks.splice(i, 1);
            i--;
        }
    }
}

function removeCommonRoots(stacks) {
    var current = stacks[0];
    for (var i = 1; i < stacks.length; ++i) {
        var prev = stacks[i];
        var currentLastIndex = current.length - 1;
        var currentLastLine = current[currentLastIndex];
        var commonRootMeetPoint = -1;

        for (var j = prev.length - 1; j >= 0; --j) {
            if (prev[j] === currentLastLine) {
                commonRootMeetPoint = j;
                break;
            }
        }

        for (var j = commonRootMeetPoint; j >= 0; --j) {
            var line = prev[j];
            if (current[currentLastIndex] === line) {
                current.pop();
                currentLastIndex--;
            } else {
                break;
            }
        }
        current = prev;
    }
}

function cleanStack(stack) {
    var ret = [];
    for (var i = 0; i < stack.length; ++i) {
        var line = stack[i];
        var isTraceLine = stackFramePattern.test(line) ||
            "    (No stack trace)" === line;
        var isInternalFrame = isTraceLine && shouldIgnore(line);
        if (isTraceLine && !isInternalFrame) {
            if (indentStackFrames && line.charAt(0) !== " ") {
                line = "    " + line;
            }
            ret.push(line);
        }
    }
    return ret;
}

function stackFramesAsArray(error) {
    var stack = error.stack.replace(/\s+$/g, "").split("\n");
    for (var i = 0; i < stack.length; ++i) {
        var line = stack[i];
        if ("    (No stack trace)" === line || stackFramePattern.test(line)) {
            break;
        }
    }
    if (i > 0) {
        stack = stack.slice(i);
    }
    return stack;
}

CapturedTrace.parseStackAndMessage = function(error) {
    var stack = error.stack;
    var message = error.toString();
    stack = typeof stack === "string" && stack.length > 0
                ? stackFramesAsArray(error) : ["    (No stack trace)"];
    return {
        message: message,
        stack: cleanStack(stack)
    };
};

CapturedTrace.formatAndLogError = function(error, title) {
    if (typeof console !== "undefined") {
        var message;
        if (typeof error === "object" || typeof error === "function") {
            var stack = error.stack;
            message = title + formatStack(stack, error);
        } else {
            message = title + String(error);
        }
        if (typeof warn === "function") {
            warn(message);
        } else if (typeof console.log === "function" ||
            typeof console.log === "object") {
            console.log(message);
        }
    }
};

CapturedTrace.unhandledRejection = function (reason) {
    CapturedTrace.formatAndLogError(reason, "^--- With additional stack trace: ");
};

CapturedTrace.isSupported = function () {
    return typeof captureStackTrace === "function";
};

CapturedTrace.fireRejectionEvent =
function(name, localHandler, reason, promise) {
    var localEventFired = false;
    try {
        if (typeof localHandler === "function") {
            localEventFired = true;
            if (name === "rejectionHandled") {
                localHandler(promise);
            } else {
                localHandler(reason, promise);
            }
        }
    } catch (e) {
        async.throwLater(e);
    }

    var globalEventFired = false;
    try {
        globalEventFired = fireGlobalEvent(name, reason, promise);
    } catch (e) {
        globalEventFired = true;
        async.throwLater(e);
    }

    var domEventFired = false;
    if (fireDomEvent) {
        try {
            domEventFired = fireDomEvent(name.toLowerCase(), {
                reason: reason,
                promise: promise
            });
        } catch (e) {
            domEventFired = true;
            async.throwLater(e);
        }
    }

    if (!globalEventFired && !localEventFired && !domEventFired &&
        name === "unhandledRejection") {
        CapturedTrace.formatAndLogError(reason, "Unhandled rejection ");
    }
};

function formatNonError(obj) {
    var str;
    if (typeof obj === "function") {
        str = "[function " +
            (obj.name || "anonymous") +
            "]";
    } else {
        str = obj.toString();
        var ruselessToString = /\[object [a-zA-Z0-9$_]+\]/;
        if (ruselessToString.test(str)) {
            try {
                var newStr = JSON.stringify(obj);
                str = newStr;
            }
            catch(e) {

            }
        }
        if (str.length === 0) {
            str = "(empty array)";
        }
    }
    return ("(<" + snip(str) + ">, no stack trace)");
}

function snip(str) {
    var maxChars = 41;
    if (str.length < maxChars) {
        return str;
    }
    return str.substr(0, maxChars - 3) + "...";
}

var shouldIgnore = function() { return false; };
var parseLineInfoRegex = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;
function parseLineInfo(line) {
    var matches = line.match(parseLineInfoRegex);
    if (matches) {
        return {
            fileName: matches[1],
            line: parseInt(matches[2], 10)
        };
    }
}
CapturedTrace.setBounds = function(firstLineError, lastLineError) {
    if (!CapturedTrace.isSupported()) return;
    var firstStackLines = firstLineError.stack.split("\n");
    var lastStackLines = lastLineError.stack.split("\n");
    var firstIndex = -1;
    var lastIndex = -1;
    var firstFileName;
    var lastFileName;
    for (var i = 0; i < firstStackLines.length; ++i) {
        var result = parseLineInfo(firstStackLines[i]);
        if (result) {
            firstFileName = result.fileName;
            firstIndex = result.line;
            break;
        }
    }
    for (var i = 0; i < lastStackLines.length; ++i) {
        var result = parseLineInfo(lastStackLines[i]);
        if (result) {
            lastFileName = result.fileName;
            lastIndex = result.line;
            break;
        }
    }
    if (firstIndex < 0 || lastIndex < 0 || !firstFileName || !lastFileName ||
        firstFileName !== lastFileName || firstIndex >= lastIndex) {
        return;
    }

    shouldIgnore = function(line) {
        if (bluebirdFramePattern.test(line)) return true;
        var info = parseLineInfo(line);
        if (info) {
            if (info.fileName === firstFileName &&
                (firstIndex <= info.line && info.line <= lastIndex)) {
                return true;
            }
        }
        return false;
    };
};

var captureStackTrace = (function stackDetection() {
    var v8stackFramePattern = /^\s*at\s*/;
    var v8stackFormatter = function(stack, error) {
        if (typeof stack === "string") return stack;

        if (error.name !== undefined &&
            error.message !== undefined) {
            return error.toString();
        }
        return formatNonError(error);
    };

    if (typeof Error.stackTraceLimit === "number" &&
        typeof Error.captureStackTrace === "function") {
        Error.stackTraceLimit = Error.stackTraceLimit + 6;
        stackFramePattern = v8stackFramePattern;
        formatStack = v8stackFormatter;
        var captureStackTrace = Error.captureStackTrace;

        shouldIgnore = function(line) {
            return bluebirdFramePattern.test(line);
        };
        return function(receiver, ignoreUntil) {
            Error.stackTraceLimit = Error.stackTraceLimit + 6;
            captureStackTrace(receiver, ignoreUntil);
            Error.stackTraceLimit = Error.stackTraceLimit - 6;
        };
    }
    var err = new Error();

    if (typeof err.stack === "string" &&
        err.stack.split("\n")[0].indexOf("stackDetection@") >= 0) {
        stackFramePattern = /@/;
        formatStack = v8stackFormatter;
        indentStackFrames = true;
        return function captureStackTrace(o) {
            o.stack = new Error().stack;
        };
    }

    var hasStackAfterThrow;
    try { throw new Error(); }
    catch(e) {
        hasStackAfterThrow = ("stack" in e);
    }
    if (!("stack" in err) && hasStackAfterThrow &&
        typeof Error.stackTraceLimit === "number") {
        stackFramePattern = v8stackFramePattern;
        formatStack = v8stackFormatter;
        return function captureStackTrace(o) {
            Error.stackTraceLimit = Error.stackTraceLimit + 6;
            try { throw new Error(); }
            catch(e) { o.stack = e.stack; }
            Error.stackTraceLimit = Error.stackTraceLimit - 6;
        };
    }

    formatStack = function(stack, error) {
        if (typeof stack === "string") return stack;

        if ((typeof error === "object" ||
            typeof error === "function") &&
            error.name !== undefined &&
            error.message !== undefined) {
            return error.toString();
        }
        return formatNonError(error);
    };

    return null;

})([]);

var fireDomEvent;
var fireGlobalEvent = (function() {
    if (util.isNode) {
        return function(name, reason, promise) {
            if (name === "rejectionHandled") {
                return process.emit(name, promise);
            } else {
                return process.emit(name, reason, promise);
            }
        };
    } else {
        var customEventWorks = false;
        var anyEventWorks = true;
        try {
            var ev = new self.CustomEvent("test");
            customEventWorks = ev instanceof CustomEvent;
        } catch (e) {}
        if (!customEventWorks) {
            try {
                var event = document.createEvent("CustomEvent");
                event.initCustomEvent("testingtheevent", false, true, {});
                self.dispatchEvent(event);
            } catch (e) {
                anyEventWorks = false;
            }
        }
        if (anyEventWorks) {
            fireDomEvent = function(type, detail) {
                var event;
                if (customEventWorks) {
                    event = new self.CustomEvent(type, {
                        detail: detail,
                        bubbles: false,
                        cancelable: true
                    });
                } else if (self.dispatchEvent) {
                    event = document.createEvent("CustomEvent");
                    event.initCustomEvent(type, false, true, detail);
                }

                return event ? !self.dispatchEvent(event) : false;
            };
        }

        var toWindowMethodNameMap = {};
        toWindowMethodNameMap["unhandledRejection"] = ("on" +
            "unhandledRejection").toLowerCase();
        toWindowMethodNameMap["rejectionHandled"] = ("on" +
            "rejectionHandled").toLowerCase();

        return function(name, reason, promise) {
            var methodName = toWindowMethodNameMap[name];
            var method = self[methodName];
            if (!method) return false;
            if (name === "rejectionHandled") {
                method.call(self, promise);
            } else {
                method.call(self, reason, promise);
            }
            return true;
        };
    }
})();

if (typeof console !== "undefined" && typeof console.warn !== "undefined") {
    warn = function (message) {
        console.warn(message);
    };
    if (util.isNode && process.stderr.isTTY) {
        warn = function(message) {
            process.stderr.write("\u001b[31m" + message + "\u001b[39m\n");
        };
    } else if (!util.isNode && typeof (new Error().stack) === "string") {
        warn = function(message) {
            console.warn("%c" + message, "color: red");
        };
    }
}

return CapturedTrace;
};

},{"./async.js":2,"./util.js":38}],8:[function(_dereq_,module,exports){
"use strict";
module.exports = function(NEXT_FILTER) {
var util = _dereq_("./util.js");
var errors = _dereq_("./errors.js");
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;
var keys = _dereq_("./es5.js").keys;
var TypeError = errors.TypeError;

function CatchFilter(instances, callback, promise) {
    this._instances = instances;
    this._callback = callback;
    this._promise = promise;
}

function safePredicate(predicate, e) {
    var safeObject = {};
    var retfilter = tryCatch(predicate).call(safeObject, e);

    if (retfilter === errorObj) return retfilter;

    var safeKeys = keys(safeObject);
    if (safeKeys.length) {
        errorObj.e = new TypeError("Catch filter must inherit from Error or be a simple predicate function\u000a\u000a    See http://goo.gl/o84o68\u000a");
        return errorObj;
    }
    return retfilter;
}

CatchFilter.prototype.doFilter = function (e) {
    var cb = this._callback;
    var promise = this._promise;
    var boundTo = promise._boundValue();
    for (var i = 0, len = this._instances.length; i < len; ++i) {
        var item = this._instances[i];
        var itemIsErrorType = item === Error ||
            (item != null && item.prototype instanceof Error);

        if (itemIsErrorType && e instanceof item) {
            var ret = tryCatch(cb).call(boundTo, e);
            if (ret === errorObj) {
                NEXT_FILTER.e = ret.e;
                return NEXT_FILTER;
            }
            return ret;
        } else if (typeof item === "function" && !itemIsErrorType) {
            var shouldHandle = safePredicate(item, e);
            if (shouldHandle === errorObj) {
                e = errorObj.e;
                break;
            } else if (shouldHandle) {
                var ret = tryCatch(cb).call(boundTo, e);
                if (ret === errorObj) {
                    NEXT_FILTER.e = ret.e;
                    return NEXT_FILTER;
                }
                return ret;
            }
        }
    }
    NEXT_FILTER.e = e;
    return NEXT_FILTER;
};

return CatchFilter;
};

},{"./errors.js":13,"./es5.js":14,"./util.js":38}],9:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, CapturedTrace, isDebugging) {
var contextStack = [];
function Context() {
    this._trace = new CapturedTrace(peekContext());
}
Context.prototype._pushContext = function () {
    if (!isDebugging()) return;
    if (this._trace !== undefined) {
        contextStack.push(this._trace);
    }
};

Context.prototype._popContext = function () {
    if (!isDebugging()) return;
    if (this._trace !== undefined) {
        contextStack.pop();
    }
};

function createContext() {
    if (isDebugging()) return new Context();
}

function peekContext() {
    var lastIndex = contextStack.length - 1;
    if (lastIndex >= 0) {
        return contextStack[lastIndex];
    }
    return undefined;
}

Promise.prototype._peekContext = peekContext;
Promise.prototype._pushContext = Context.prototype._pushContext;
Promise.prototype._popContext = Context.prototype._popContext;

return createContext;
};

},{}],10:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, CapturedTrace) {
var getDomain = Promise._getDomain;
var async = _dereq_("./async.js");
var Warning = _dereq_("./errors.js").Warning;
var util = _dereq_("./util.js");
var canAttachTrace = util.canAttachTrace;
var unhandledRejectionHandled;
var possiblyUnhandledRejection;
var debugging = false || (util.isNode &&
                    (!!process.env["BLUEBIRD_DEBUG"] ||
                     'production' === "development"));

if (util.isNode && process.env["BLUEBIRD_DEBUG"] == 0) debugging = false;

if (debugging) {
    async.disableTrampolineIfNecessary();
}

Promise.prototype._ignoreRejections = function() {
    this._unsetRejectionIsUnhandled();
    this._bitField = this._bitField | 16777216;
};

Promise.prototype._ensurePossibleRejectionHandled = function () {
    if ((this._bitField & 16777216) !== 0) return;
    this._setRejectionIsUnhandled();
    async.invokeLater(this._notifyUnhandledRejection, this, undefined);
};

Promise.prototype._notifyUnhandledRejectionIsHandled = function () {
    CapturedTrace.fireRejectionEvent("rejectionHandled",
                                  unhandledRejectionHandled, undefined, this);
};

Promise.prototype._notifyUnhandledRejection = function () {
    if (this._isRejectionUnhandled()) {
        var reason = this._getCarriedStackTrace() || this._settledValue;
        this._setUnhandledRejectionIsNotified();
        CapturedTrace.fireRejectionEvent("unhandledRejection",
                                      possiblyUnhandledRejection, reason, this);
    }
};

Promise.prototype._setUnhandledRejectionIsNotified = function () {
    this._bitField = this._bitField | 524288;
};

Promise.prototype._unsetUnhandledRejectionIsNotified = function () {
    this._bitField = this._bitField & (~524288);
};

Promise.prototype._isUnhandledRejectionNotified = function () {
    return (this._bitField & 524288) > 0;
};

Promise.prototype._setRejectionIsUnhandled = function () {
    this._bitField = this._bitField | 2097152;
};

Promise.prototype._unsetRejectionIsUnhandled = function () {
    this._bitField = this._bitField & (~2097152);
    if (this._isUnhandledRejectionNotified()) {
        this._unsetUnhandledRejectionIsNotified();
        this._notifyUnhandledRejectionIsHandled();
    }
};

Promise.prototype._isRejectionUnhandled = function () {
    return (this._bitField & 2097152) > 0;
};

Promise.prototype._setCarriedStackTrace = function (capturedTrace) {
    this._bitField = this._bitField | 1048576;
    this._fulfillmentHandler0 = capturedTrace;
};

Promise.prototype._isCarryingStackTrace = function () {
    return (this._bitField & 1048576) > 0;
};

Promise.prototype._getCarriedStackTrace = function () {
    return this._isCarryingStackTrace()
        ? this._fulfillmentHandler0
        : undefined;
};

Promise.prototype._captureStackTrace = function () {
    if (debugging) {
        this._trace = new CapturedTrace(this._peekContext());
    }
    return this;
};

Promise.prototype._attachExtraTrace = function (error, ignoreSelf) {
    if (debugging && canAttachTrace(error)) {
        var trace = this._trace;
        if (trace !== undefined) {
            if (ignoreSelf) trace = trace._parent;
        }
        if (trace !== undefined) {
            trace.attachExtraTrace(error);
        } else if (!error.__stackCleaned__) {
            var parsed = CapturedTrace.parseStackAndMessage(error);
            util.notEnumerableProp(error, "stack",
                parsed.message + "\n" + parsed.stack.join("\n"));
            util.notEnumerableProp(error, "__stackCleaned__", true);
        }
    }
};

Promise.prototype._warn = function(message) {
    var warning = new Warning(message);
    var ctx = this._peekContext();
    if (ctx) {
        ctx.attachExtraTrace(warning);
    } else {
        var parsed = CapturedTrace.parseStackAndMessage(warning);
        warning.stack = parsed.message + "\n" + parsed.stack.join("\n");
    }
    CapturedTrace.formatAndLogError(warning, "");
};

Promise.onPossiblyUnhandledRejection = function (fn) {
    var domain = getDomain();
    possiblyUnhandledRejection =
        typeof fn === "function" ? (domain === null ? fn : domain.bind(fn))
                                 : undefined;
};

Promise.onUnhandledRejectionHandled = function (fn) {
    var domain = getDomain();
    unhandledRejectionHandled =
        typeof fn === "function" ? (domain === null ? fn : domain.bind(fn))
                                 : undefined;
};

Promise.longStackTraces = function () {
    if (async.haveItemsQueued() &&
        debugging === false
   ) {
        throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/DT1qyG\u000a");
    }
    debugging = CapturedTrace.isSupported();
    if (debugging) {
        async.disableTrampolineIfNecessary();
    }
};

Promise.hasLongStackTraces = function () {
    return debugging && CapturedTrace.isSupported();
};

if (!CapturedTrace.isSupported()) {
    Promise.longStackTraces = function(){};
    debugging = false;
}

return function() {
    return debugging;
};
};

},{"./async.js":2,"./errors.js":13,"./util.js":38}],11:[function(_dereq_,module,exports){
"use strict";
var util = _dereq_("./util.js");
var isPrimitive = util.isPrimitive;

module.exports = function(Promise) {
var returner = function () {
    return this;
};
var thrower = function () {
    throw this;
};
var returnUndefined = function() {};
var throwUndefined = function() {
    throw undefined;
};

var wrapper = function (value, action) {
    if (action === 1) {
        return function () {
            throw value;
        };
    } else if (action === 2) {
        return function () {
            return value;
        };
    }
};


Promise.prototype["return"] =
Promise.prototype.thenReturn = function (value) {
    if (value === undefined) return this.then(returnUndefined);

    if (isPrimitive(value)) {
        return this._then(
            wrapper(value, 2),
            undefined,
            undefined,
            undefined,
            undefined
       );
    } else if (value instanceof Promise) {
        value._ignoreRejections();
    }
    return this._then(returner, undefined, undefined, value, undefined);
};

Promise.prototype["throw"] =
Promise.prototype.thenThrow = function (reason) {
    if (reason === undefined) return this.then(throwUndefined);

    if (isPrimitive(reason)) {
        return this._then(
            wrapper(reason, 1),
            undefined,
            undefined,
            undefined,
            undefined
       );
    }
    return this._then(thrower, undefined, undefined, reason, undefined);
};
};

},{"./util.js":38}],12:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var PromiseReduce = Promise.reduce;

Promise.prototype.each = function (fn) {
    return PromiseReduce(this, fn, null, INTERNAL);
};

Promise.each = function (promises, fn) {
    return PromiseReduce(promises, fn, null, INTERNAL);
};
};

},{}],13:[function(_dereq_,module,exports){
"use strict";
var es5 = _dereq_("./es5.js");
var Objectfreeze = es5.freeze;
var util = _dereq_("./util.js");
var inherits = util.inherits;
var notEnumerableProp = util.notEnumerableProp;

function subError(nameProperty, defaultMessage) {
    function SubError(message) {
        if (!(this instanceof SubError)) return new SubError(message);
        notEnumerableProp(this, "message",
            typeof message === "string" ? message : defaultMessage);
        notEnumerableProp(this, "name", nameProperty);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, this.constructor);
        } else {
            Error.call(this);
        }
    }
    inherits(SubError, Error);
    return SubError;
}

var _TypeError, _RangeError;
var Warning = subError("Warning", "warning");
var CancellationError = subError("CancellationError", "cancellation error");
var TimeoutError = subError("TimeoutError", "timeout error");
var AggregateError = subError("AggregateError", "aggregate error");
try {
    _TypeError = TypeError;
    _RangeError = RangeError;
} catch(e) {
    _TypeError = subError("TypeError", "type error");
    _RangeError = subError("RangeError", "range error");
}

var methods = ("join pop push shift unshift slice filter forEach some " +
    "every map indexOf lastIndexOf reduce reduceRight sort reverse").split(" ");

for (var i = 0; i < methods.length; ++i) {
    if (typeof Array.prototype[methods[i]] === "function") {
        AggregateError.prototype[methods[i]] = Array.prototype[methods[i]];
    }
}

es5.defineProperty(AggregateError.prototype, "length", {
    value: 0,
    configurable: false,
    writable: true,
    enumerable: true
});
AggregateError.prototype["isOperational"] = true;
var level = 0;
AggregateError.prototype.toString = function() {
    var indent = Array(level * 4 + 1).join(" ");
    var ret = "\n" + indent + "AggregateError of:" + "\n";
    level++;
    indent = Array(level * 4 + 1).join(" ");
    for (var i = 0; i < this.length; ++i) {
        var str = this[i] === this ? "[Circular AggregateError]" : this[i] + "";
        var lines = str.split("\n");
        for (var j = 0; j < lines.length; ++j) {
            lines[j] = indent + lines[j];
        }
        str = lines.join("\n");
        ret += str + "\n";
    }
    level--;
    return ret;
};

function OperationalError(message) {
    if (!(this instanceof OperationalError))
        return new OperationalError(message);
    notEnumerableProp(this, "name", "OperationalError");
    notEnumerableProp(this, "message", message);
    this.cause = message;
    this["isOperational"] = true;

    if (message instanceof Error) {
        notEnumerableProp(this, "message", message.message);
        notEnumerableProp(this, "stack", message.stack);
    } else if (Error.captureStackTrace) {
        Error.captureStackTrace(this, this.constructor);
    }

}
inherits(OperationalError, Error);

var errorTypes = Error["__BluebirdErrorTypes__"];
if (!errorTypes) {
    errorTypes = Objectfreeze({
        CancellationError: CancellationError,
        TimeoutError: TimeoutError,
        OperationalError: OperationalError,
        RejectionError: OperationalError,
        AggregateError: AggregateError
    });
    notEnumerableProp(Error, "__BluebirdErrorTypes__", errorTypes);
}

module.exports = {
    Error: Error,
    TypeError: _TypeError,
    RangeError: _RangeError,
    CancellationError: errorTypes.CancellationError,
    OperationalError: errorTypes.OperationalError,
    TimeoutError: errorTypes.TimeoutError,
    AggregateError: errorTypes.AggregateError,
    Warning: Warning
};

},{"./es5.js":14,"./util.js":38}],14:[function(_dereq_,module,exports){
var isES5 = (function(){
    "use strict";
    return this === undefined;
})();

if (isES5) {
    module.exports = {
        freeze: Object.freeze,
        defineProperty: Object.defineProperty,
        getDescriptor: Object.getOwnPropertyDescriptor,
        keys: Object.keys,
        names: Object.getOwnPropertyNames,
        getPrototypeOf: Object.getPrototypeOf,
        isArray: Array.isArray,
        isES5: isES5,
        propertyIsWritable: function(obj, prop) {
            var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
            return !!(!descriptor || descriptor.writable || descriptor.set);
        }
    };
} else {
    var has = {}.hasOwnProperty;
    var str = {}.toString;
    var proto = {}.constructor.prototype;

    var ObjectKeys = function (o) {
        var ret = [];
        for (var key in o) {
            if (has.call(o, key)) {
                ret.push(key);
            }
        }
        return ret;
    };

    var ObjectGetDescriptor = function(o, key) {
        return {value: o[key]};
    };

    var ObjectDefineProperty = function (o, key, desc) {
        o[key] = desc.value;
        return o;
    };

    var ObjectFreeze = function (obj) {
        return obj;
    };

    var ObjectGetPrototypeOf = function (obj) {
        try {
            return Object(obj).constructor.prototype;
        }
        catch (e) {
            return proto;
        }
    };

    var ArrayIsArray = function (obj) {
        try {
            return str.call(obj) === "[object Array]";
        }
        catch(e) {
            return false;
        }
    };

    module.exports = {
        isArray: ArrayIsArray,
        keys: ObjectKeys,
        names: ObjectKeys,
        defineProperty: ObjectDefineProperty,
        getDescriptor: ObjectGetDescriptor,
        freeze: ObjectFreeze,
        getPrototypeOf: ObjectGetPrototypeOf,
        isES5: isES5,
        propertyIsWritable: function() {
            return true;
        }
    };
}

},{}],15:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var PromiseMap = Promise.map;

Promise.prototype.filter = function (fn, options) {
    return PromiseMap(this, fn, options, INTERNAL);
};

Promise.filter = function (promises, fn, options) {
    return PromiseMap(promises, fn, options, INTERNAL);
};
};

},{}],16:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, NEXT_FILTER, tryConvertToPromise) {
var util = _dereq_("./util.js");
var isPrimitive = util.isPrimitive;
var thrower = util.thrower;

function returnThis() {
    return this;
}
function throwThis() {
    throw this;
}
function return$(r) {
    return function() {
        return r;
    };
}
function throw$(r) {
    return function() {
        throw r;
    };
}
function promisedFinally(ret, reasonOrValue, isFulfilled) {
    var then;
    if (isPrimitive(reasonOrValue)) {
        then = isFulfilled ? return$(reasonOrValue) : throw$(reasonOrValue);
    } else {
        then = isFulfilled ? returnThis : throwThis;
    }
    return ret._then(then, thrower, undefined, reasonOrValue, undefined);
}

function finallyHandler(reasonOrValue) {
    var promise = this.promise;
    var handler = this.handler;

    var ret = promise._isBound()
                    ? handler.call(promise._boundValue())
                    : handler();

    if (ret !== undefined) {
        var maybePromise = tryConvertToPromise(ret, promise);
        if (maybePromise instanceof Promise) {
            maybePromise = maybePromise._target();
            return promisedFinally(maybePromise, reasonOrValue,
                                    promise.isFulfilled());
        }
    }

    if (promise.isRejected()) {
        NEXT_FILTER.e = reasonOrValue;
        return NEXT_FILTER;
    } else {
        return reasonOrValue;
    }
}

function tapHandler(value) {
    var promise = this.promise;
    var handler = this.handler;

    var ret = promise._isBound()
                    ? handler.call(promise._boundValue(), value)
                    : handler(value);

    if (ret !== undefined) {
        var maybePromise = tryConvertToPromise(ret, promise);
        if (maybePromise instanceof Promise) {
            maybePromise = maybePromise._target();
            return promisedFinally(maybePromise, value, true);
        }
    }
    return value;
}

Promise.prototype._passThroughHandler = function (handler, isFinally) {
    if (typeof handler !== "function") return this.then();

    var promiseAndHandler = {
        promise: this,
        handler: handler
    };

    return this._then(
            isFinally ? finallyHandler : tapHandler,
            isFinally ? finallyHandler : undefined, undefined,
            promiseAndHandler, undefined);
};

Promise.prototype.lastly =
Promise.prototype["finally"] = function (handler) {
    return this._passThroughHandler(handler, true);
};

Promise.prototype.tap = function (handler) {
    return this._passThroughHandler(handler, false);
};
};

},{"./util.js":38}],17:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise,
                          apiRejection,
                          INTERNAL,
                          tryConvertToPromise) {
var errors = _dereq_("./errors.js");
var TypeError = errors.TypeError;
var util = _dereq_("./util.js");
var errorObj = util.errorObj;
var tryCatch = util.tryCatch;
var yieldHandlers = [];

function promiseFromYieldHandler(value, yieldHandlers, traceParent) {
    for (var i = 0; i < yieldHandlers.length; ++i) {
        traceParent._pushContext();
        var result = tryCatch(yieldHandlers[i])(value);
        traceParent._popContext();
        if (result === errorObj) {
            traceParent._pushContext();
            var ret = Promise.reject(errorObj.e);
            traceParent._popContext();
            return ret;
        }
        var maybePromise = tryConvertToPromise(result, traceParent);
        if (maybePromise instanceof Promise) return maybePromise;
    }
    return null;
}

function PromiseSpawn(generatorFunction, receiver, yieldHandler, stack) {
    var promise = this._promise = new Promise(INTERNAL);
    promise._captureStackTrace();
    this._stack = stack;
    this._generatorFunction = generatorFunction;
    this._receiver = receiver;
    this._generator = undefined;
    this._yieldHandlers = typeof yieldHandler === "function"
        ? [yieldHandler].concat(yieldHandlers)
        : yieldHandlers;
}

PromiseSpawn.prototype.promise = function () {
    return this._promise;
};

PromiseSpawn.prototype._run = function () {
    this._generator = this._generatorFunction.call(this._receiver);
    this._receiver =
        this._generatorFunction = undefined;
    this._next(undefined);
};

PromiseSpawn.prototype._continue = function (result) {
    if (result === errorObj) {
        return this._promise._rejectCallback(result.e, false, true);
    }

    var value = result.value;
    if (result.done === true) {
        this._promise._resolveCallback(value);
    } else {
        var maybePromise = tryConvertToPromise(value, this._promise);
        if (!(maybePromise instanceof Promise)) {
            maybePromise =
                promiseFromYieldHandler(maybePromise,
                                        this._yieldHandlers,
                                        this._promise);
            if (maybePromise === null) {
                this._throw(
                    new TypeError(
                        "A value %s was yielded that could not be treated as a promise\u000a\u000a    See http://goo.gl/4Y4pDk\u000a\u000a".replace("%s", value) +
                        "From coroutine:\u000a" +
                        this._stack.split("\n").slice(1, -7).join("\n")
                    )
                );
                return;
            }
        }
        maybePromise._then(
            this._next,
            this._throw,
            undefined,
            this,
            null
       );
    }
};

PromiseSpawn.prototype._throw = function (reason) {
    this._promise._attachExtraTrace(reason);
    this._promise._pushContext();
    var result = tryCatch(this._generator["throw"])
        .call(this._generator, reason);
    this._promise._popContext();
    this._continue(result);
};

PromiseSpawn.prototype._next = function (value) {
    this._promise._pushContext();
    var result = tryCatch(this._generator.next).call(this._generator, value);
    this._promise._popContext();
    this._continue(result);
};

Promise.coroutine = function (generatorFunction, options) {
    if (typeof generatorFunction !== "function") {
        throw new TypeError("generatorFunction must be a function\u000a\u000a    See http://goo.gl/6Vqhm0\u000a");
    }
    var yieldHandler = Object(options).yieldHandler;
    var PromiseSpawn$ = PromiseSpawn;
    var stack = new Error().stack;
    return function () {
        var generator = generatorFunction.apply(this, arguments);
        var spawn = new PromiseSpawn$(undefined, undefined, yieldHandler,
                                      stack);
        spawn._generator = generator;
        spawn._next(undefined);
        return spawn.promise();
    };
};

Promise.coroutine.addYieldHandler = function(fn) {
    if (typeof fn !== "function") throw new TypeError("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
    yieldHandlers.push(fn);
};

Promise.spawn = function (generatorFunction) {
    if (typeof generatorFunction !== "function") {
        return apiRejection("generatorFunction must be a function\u000a\u000a    See http://goo.gl/6Vqhm0\u000a");
    }
    var spawn = new PromiseSpawn(generatorFunction, this);
    var ret = spawn.promise();
    spawn._run(Promise.spawn);
    return ret;
};
};

},{"./errors.js":13,"./util.js":38}],18:[function(_dereq_,module,exports){
"use strict";
module.exports =
function(Promise, PromiseArray, tryConvertToPromise, INTERNAL) {
var util = _dereq_("./util.js");
var canEvaluate = util.canEvaluate;
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;
var reject;

if (false) {
if (canEvaluate) {
    var thenCallback = function(i) {
        return new Function("value", "holder", "                             \n\
            'use strict';                                                    \n\
            holder.pIndex = value;                                           \n\
            holder.checkFulfillment(this);                                   \n\
            ".replace(/Index/g, i));
    };

    var caller = function(count) {
        var values = [];
        for (var i = 1; i <= count; ++i) values.push("holder.p" + i);
        return new Function("holder", "                                      \n\
            'use strict';                                                    \n\
            var callback = holder.fn;                                        \n\
            return callback(values);                                         \n\
            ".replace(/values/g, values.join(", ")));
    };
    var thenCallbacks = [];
    var callers = [undefined];
    for (var i = 1; i <= 5; ++i) {
        thenCallbacks.push(thenCallback(i));
        callers.push(caller(i));
    }

    var Holder = function(total, fn) {
        this.p1 = this.p2 = this.p3 = this.p4 = this.p5 = null;
        this.fn = fn;
        this.total = total;
        this.now = 0;
    };

    Holder.prototype.callers = callers;
    Holder.prototype.checkFulfillment = function(promise) {
        var now = this.now;
        now++;
        var total = this.total;
        if (now >= total) {
            var handler = this.callers[total];
            promise._pushContext();
            var ret = tryCatch(handler)(this);
            promise._popContext();
            if (ret === errorObj) {
                promise._rejectCallback(ret.e, false, true);
            } else {
                promise._resolveCallback(ret);
            }
        } else {
            this.now = now;
        }
    };

    var reject = function (reason) {
        this._reject(reason);
    };
}
}

Promise.join = function () {
    var last = arguments.length - 1;
    var fn;
    if (last > 0 && typeof arguments[last] === "function") {
        fn = arguments[last];
        if (false) {
            if (last < 6 && canEvaluate) {
                var ret = new Promise(INTERNAL);
                ret._captureStackTrace();
                var holder = new Holder(last, fn);
                var callbacks = thenCallbacks;
                for (var i = 0; i < last; ++i) {
                    var maybePromise = tryConvertToPromise(arguments[i], ret);
                    if (maybePromise instanceof Promise) {
                        maybePromise = maybePromise._target();
                        if (maybePromise._isPending()) {
                            maybePromise._then(callbacks[i], reject,
                                               undefined, ret, holder);
                        } else if (maybePromise._isFulfilled()) {
                            callbacks[i].call(ret,
                                              maybePromise._value(), holder);
                        } else {
                            ret._reject(maybePromise._reason());
                        }
                    } else {
                        callbacks[i].call(ret, maybePromise, holder);
                    }
                }
                return ret;
            }
        }
    }
    var $_len = arguments.length;var args = new Array($_len); for(var $_i = 0; $_i < $_len; ++$_i) {args[$_i] = arguments[$_i];}
    if (fn) args.pop();
    var ret = new PromiseArray(args).promise();
    return fn !== undefined ? ret.spread(fn) : ret;
};

};

},{"./util.js":38}],19:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise,
                          PromiseArray,
                          apiRejection,
                          tryConvertToPromise,
                          INTERNAL) {
var getDomain = Promise._getDomain;
var async = _dereq_("./async.js");
var util = _dereq_("./util.js");
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;
var PENDING = {};
var EMPTY_ARRAY = [];

function MappingPromiseArray(promises, fn, limit, _filter) {
    this.constructor$(promises);
    this._promise._captureStackTrace();
    var domain = getDomain();
    this._callback = domain === null ? fn : domain.bind(fn);
    this._preservedValues = _filter === INTERNAL
        ? new Array(this.length())
        : null;
    this._limit = limit;
    this._inFlight = 0;
    this._queue = limit >= 1 ? [] : EMPTY_ARRAY;
    async.invoke(init, this, undefined);
}
util.inherits(MappingPromiseArray, PromiseArray);
function init() {this._init$(undefined, -2);}

MappingPromiseArray.prototype._init = function () {};

MappingPromiseArray.prototype._promiseFulfilled = function (value, index) {
    var values = this._values;
    var length = this.length();
    var preservedValues = this._preservedValues;
    var limit = this._limit;
    if (values[index] === PENDING) {
        values[index] = value;
        if (limit >= 1) {
            this._inFlight--;
            this._drainQueue();
            if (this._isResolved()) return;
        }
    } else {
        if (limit >= 1 && this._inFlight >= limit) {
            values[index] = value;
            this._queue.push(index);
            return;
        }
        if (preservedValues !== null) preservedValues[index] = value;

        var callback = this._callback;
        var receiver = this._promise._boundValue();
        this._promise._pushContext();
        var ret = tryCatch(callback).call(receiver, value, index, length);
        this._promise._popContext();
        if (ret === errorObj) return this._reject(ret.e);

        var maybePromise = tryConvertToPromise(ret, this._promise);
        if (maybePromise instanceof Promise) {
            maybePromise = maybePromise._target();
            if (maybePromise._isPending()) {
                if (limit >= 1) this._inFlight++;
                values[index] = PENDING;
                return maybePromise._proxyPromiseArray(this, index);
            } else if (maybePromise._isFulfilled()) {
                ret = maybePromise._value();
            } else {
                return this._reject(maybePromise._reason());
            }
        }
        values[index] = ret;
    }
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= length) {
        if (preservedValues !== null) {
            this._filter(values, preservedValues);
        } else {
            this._resolve(values);
        }

    }
};

MappingPromiseArray.prototype._drainQueue = function () {
    var queue = this._queue;
    var limit = this._limit;
    var values = this._values;
    while (queue.length > 0 && this._inFlight < limit) {
        if (this._isResolved()) return;
        var index = queue.pop();
        this._promiseFulfilled(values[index], index);
    }
};

MappingPromiseArray.prototype._filter = function (booleans, values) {
    var len = values.length;
    var ret = new Array(len);
    var j = 0;
    for (var i = 0; i < len; ++i) {
        if (booleans[i]) ret[j++] = values[i];
    }
    ret.length = j;
    this._resolve(ret);
};

MappingPromiseArray.prototype.preservedValues = function () {
    return this._preservedValues;
};

function map(promises, fn, options, _filter) {
    var limit = typeof options === "object" && options !== null
        ? options.concurrency
        : 0;
    limit = typeof limit === "number" &&
        isFinite(limit) && limit >= 1 ? limit : 0;
    return new MappingPromiseArray(promises, fn, limit, _filter);
}

Promise.prototype.map = function (fn, options) {
    if (typeof fn !== "function") return apiRejection("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");

    return map(this, fn, options, null).promise();
};

Promise.map = function (promises, fn, options, _filter) {
    if (typeof fn !== "function") return apiRejection("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
    return map(promises, fn, options, _filter).promise();
};


};

},{"./async.js":2,"./util.js":38}],20:[function(_dereq_,module,exports){
"use strict";
module.exports =
function(Promise, INTERNAL, tryConvertToPromise, apiRejection) {
var util = _dereq_("./util.js");
var tryCatch = util.tryCatch;

Promise.method = function (fn) {
    if (typeof fn !== "function") {
        throw new Promise.TypeError("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
    }
    return function () {
        var ret = new Promise(INTERNAL);
        ret._captureStackTrace();
        ret._pushContext();
        var value = tryCatch(fn).apply(this, arguments);
        ret._popContext();
        ret._resolveFromSyncValue(value);
        return ret;
    };
};

Promise.attempt = Promise["try"] = function (fn, args, ctx) {
    if (typeof fn !== "function") {
        return apiRejection("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
    }
    var ret = new Promise(INTERNAL);
    ret._captureStackTrace();
    ret._pushContext();
    var value = util.isArray(args)
        ? tryCatch(fn).apply(ctx, args)
        : tryCatch(fn).call(ctx, args);
    ret._popContext();
    ret._resolveFromSyncValue(value);
    return ret;
};

Promise.prototype._resolveFromSyncValue = function (value) {
    if (value === util.errorObj) {
        this._rejectCallback(value.e, false, true);
    } else {
        this._resolveCallback(value, true);
    }
};
};

},{"./util.js":38}],21:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
var util = _dereq_("./util.js");
var async = _dereq_("./async.js");
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;

function spreadAdapter(val, nodeback) {
    var promise = this;
    if (!util.isArray(val)) return successAdapter.call(promise, val, nodeback);
    var ret =
        tryCatch(nodeback).apply(promise._boundValue(), [null].concat(val));
    if (ret === errorObj) {
        async.throwLater(ret.e);
    }
}

function successAdapter(val, nodeback) {
    var promise = this;
    var receiver = promise._boundValue();
    var ret = val === undefined
        ? tryCatch(nodeback).call(receiver, null)
        : tryCatch(nodeback).call(receiver, null, val);
    if (ret === errorObj) {
        async.throwLater(ret.e);
    }
}
function errorAdapter(reason, nodeback) {
    var promise = this;
    if (!reason) {
        var target = promise._target();
        var newReason = target._getCarriedStackTrace();
        newReason.cause = reason;
        reason = newReason;
    }
    var ret = tryCatch(nodeback).call(promise._boundValue(), reason);
    if (ret === errorObj) {
        async.throwLater(ret.e);
    }
}

Promise.prototype.asCallback =
Promise.prototype.nodeify = function (nodeback, options) {
    if (typeof nodeback == "function") {
        var adapter = successAdapter;
        if (options !== undefined && Object(options).spread) {
            adapter = spreadAdapter;
        }
        this._then(
            adapter,
            errorAdapter,
            undefined,
            this,
            nodeback
        );
    }
    return this;
};
};

},{"./async.js":2,"./util.js":38}],22:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, PromiseArray) {
var util = _dereq_("./util.js");
var async = _dereq_("./async.js");
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;

Promise.prototype.progressed = function (handler) {
    return this._then(undefined, undefined, handler, undefined, undefined);
};

Promise.prototype._progress = function (progressValue) {
    if (this._isFollowingOrFulfilledOrRejected()) return;
    this._target()._progressUnchecked(progressValue);

};

Promise.prototype._progressHandlerAt = function (index) {
    return index === 0
        ? this._progressHandler0
        : this[(index << 2) + index - 5 + 2];
};

Promise.prototype._doProgressWith = function (progression) {
    var progressValue = progression.value;
    var handler = progression.handler;
    var promise = progression.promise;
    var receiver = progression.receiver;

    var ret = tryCatch(handler).call(receiver, progressValue);
    if (ret === errorObj) {
        if (ret.e != null &&
            ret.e.name !== "StopProgressPropagation") {
            var trace = util.canAttachTrace(ret.e)
                ? ret.e : new Error(util.toString(ret.e));
            promise._attachExtraTrace(trace);
            promise._progress(ret.e);
        }
    } else if (ret instanceof Promise) {
        ret._then(promise._progress, null, null, promise, undefined);
    } else {
        promise._progress(ret);
    }
};


Promise.prototype._progressUnchecked = function (progressValue) {
    var len = this._length();
    var progress = this._progress;
    for (var i = 0; i < len; i++) {
        var handler = this._progressHandlerAt(i);
        var promise = this._promiseAt(i);
        if (!(promise instanceof Promise)) {
            var receiver = this._receiverAt(i);
            if (typeof handler === "function") {
                handler.call(receiver, progressValue, promise);
            } else if (receiver instanceof PromiseArray &&
                       !receiver._isResolved()) {
                receiver._promiseProgressed(progressValue, promise);
            }
            continue;
        }

        if (typeof handler === "function") {
            async.invoke(this._doProgressWith, this, {
                handler: handler,
                promise: promise,
                receiver: this._receiverAt(i),
                value: progressValue
            });
        } else {
            async.invoke(progress, promise, progressValue);
        }
    }
};
};

},{"./async.js":2,"./util.js":38}],23:[function(_dereq_,module,exports){
"use strict";
module.exports = function() {
var makeSelfResolutionError = function () {
    return new TypeError("circular promise resolution chain\u000a\u000a    See http://goo.gl/LhFpo0\u000a");
};
var reflect = function() {
    return new Promise.PromiseInspection(this._target());
};
var apiRejection = function(msg) {
    return Promise.reject(new TypeError(msg));
};

var util = _dereq_("./util.js");

var getDomain;
if (util.isNode) {
    getDomain = function() {
        var ret = process.domain;
        if (ret === undefined) ret = null;
        return ret;
    };
} else {
    getDomain = function() {
        return null;
    };
}
util.notEnumerableProp(Promise, "_getDomain", getDomain);

var UNDEFINED_BINDING = {};
var async = _dereq_("./async.js");
var errors = _dereq_("./errors.js");
var TypeError = Promise.TypeError = errors.TypeError;
Promise.RangeError = errors.RangeError;
Promise.CancellationError = errors.CancellationError;
Promise.TimeoutError = errors.TimeoutError;
Promise.OperationalError = errors.OperationalError;
Promise.RejectionError = errors.OperationalError;
Promise.AggregateError = errors.AggregateError;
var INTERNAL = function(){};
var APPLY = {};
var NEXT_FILTER = {e: null};
var tryConvertToPromise = _dereq_("./thenables.js")(Promise, INTERNAL);
var PromiseArray =
    _dereq_("./promise_array.js")(Promise, INTERNAL,
                                    tryConvertToPromise, apiRejection);
var CapturedTrace = _dereq_("./captured_trace.js")();
var isDebugging = _dereq_("./debuggability.js")(Promise, CapturedTrace);
 /*jshint unused:false*/
var createContext =
    _dereq_("./context.js")(Promise, CapturedTrace, isDebugging);
var CatchFilter = _dereq_("./catch_filter.js")(NEXT_FILTER);
var PromiseResolver = _dereq_("./promise_resolver.js");
var nodebackForPromise = PromiseResolver._nodebackForPromise;
var errorObj = util.errorObj;
var tryCatch = util.tryCatch;

function Promise(resolver) {
    if (typeof resolver !== "function") {
        throw new TypeError("the promise constructor requires a resolver function\u000a\u000a    See http://goo.gl/EC22Yn\u000a");
    }
    if (this.constructor !== Promise) {
        throw new TypeError("the promise constructor cannot be invoked directly\u000a\u000a    See http://goo.gl/KsIlge\u000a");
    }
    this._bitField = 0;
    this._fulfillmentHandler0 = undefined;
    this._rejectionHandler0 = undefined;
    this._progressHandler0 = undefined;
    this._promise0 = undefined;
    this._receiver0 = undefined;
    this._settledValue = undefined;
    if (resolver !== INTERNAL) this._resolveFromResolver(resolver);
}

Promise.prototype.toString = function () {
    return "[object Promise]";
};

Promise.prototype.caught = Promise.prototype["catch"] = function (fn) {
    var len = arguments.length;
    if (len > 1) {
        var catchInstances = new Array(len - 1),
            j = 0, i;
        for (i = 0; i < len - 1; ++i) {
            var item = arguments[i];
            if (typeof item === "function") {
                catchInstances[j++] = item;
            } else {
                return Promise.reject(
                    new TypeError("Catch filter must inherit from Error or be a simple predicate function\u000a\u000a    See http://goo.gl/o84o68\u000a"));
            }
        }
        catchInstances.length = j;
        fn = arguments[i];
        var catchFilter = new CatchFilter(catchInstances, fn, this);
        return this._then(undefined, catchFilter.doFilter, undefined,
            catchFilter, undefined);
    }
    return this._then(undefined, fn, undefined, undefined, undefined);
};

Promise.prototype.reflect = function () {
    return this._then(reflect, reflect, undefined, this, undefined);
};

Promise.prototype.then = function (didFulfill, didReject, didProgress) {
    if (isDebugging() && arguments.length > 0 &&
        typeof didFulfill !== "function" &&
        typeof didReject !== "function") {
        var msg = ".then() only accepts functions but was passed: " +
                util.classString(didFulfill);
        if (arguments.length > 1) {
            msg += ", " + util.classString(didReject);
        }
        this._warn(msg);
    }
    return this._then(didFulfill, didReject, didProgress,
        undefined, undefined);
};

Promise.prototype.done = function (didFulfill, didReject, didProgress) {
    var promise = this._then(didFulfill, didReject, didProgress,
        undefined, undefined);
    promise._setIsFinal();
};

Promise.prototype.spread = function (didFulfill, didReject) {
    return this.all()._then(didFulfill, didReject, undefined, APPLY, undefined);
};

Promise.prototype.isCancellable = function () {
    return !this.isResolved() &&
        this._cancellable();
};

Promise.prototype.toJSON = function () {
    var ret = {
        isFulfilled: false,
        isRejected: false,
        fulfillmentValue: undefined,
        rejectionReason: undefined
    };
    if (this.isFulfilled()) {
        ret.fulfillmentValue = this.value();
        ret.isFulfilled = true;
    } else if (this.isRejected()) {
        ret.rejectionReason = this.reason();
        ret.isRejected = true;
    }
    return ret;
};

Promise.prototype.all = function () {
    return new PromiseArray(this).promise();
};

Promise.prototype.error = function (fn) {
    return this.caught(util.originatesFromRejection, fn);
};

Promise.getNewLibraryCopy = module.exports;

Promise.is = function (val) {
    return val instanceof Promise;
};

Promise.fromNode = function(fn) {
    var ret = new Promise(INTERNAL);
    var result = tryCatch(fn)(nodebackForPromise(ret));
    if (result === errorObj) {
        ret._rejectCallback(result.e, true, true);
    }
    return ret;
};

Promise.all = function (promises) {
    return new PromiseArray(promises).promise();
};

Promise.defer = Promise.pending = function () {
    var promise = new Promise(INTERNAL);
    return new PromiseResolver(promise);
};

Promise.cast = function (obj) {
    var ret = tryConvertToPromise(obj);
    if (!(ret instanceof Promise)) {
        var val = ret;
        ret = new Promise(INTERNAL);
        ret._fulfillUnchecked(val);
    }
    return ret;
};

Promise.resolve = Promise.fulfilled = Promise.cast;

Promise.reject = Promise.rejected = function (reason) {
    var ret = new Promise(INTERNAL);
    ret._captureStackTrace();
    ret._rejectCallback(reason, true);
    return ret;
};

Promise.setScheduler = function(fn) {
    if (typeof fn !== "function") throw new TypeError("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
    var prev = async._schedule;
    async._schedule = fn;
    return prev;
};

Promise.prototype._then = function (
    didFulfill,
    didReject,
    didProgress,
    receiver,
    internalData
) {
    var haveInternalData = internalData !== undefined;
    var ret = haveInternalData ? internalData : new Promise(INTERNAL);

    if (!haveInternalData) {
        ret._propagateFrom(this, 4 | 1);
        ret._captureStackTrace();
    }

    var target = this._target();
    if (target !== this) {
        if (receiver === undefined) receiver = this._boundTo;
        if (!haveInternalData) ret._setIsMigrated();
    }

    var callbackIndex = target._addCallbacks(didFulfill,
                                             didReject,
                                             didProgress,
                                             ret,
                                             receiver,
                                             getDomain());

    if (target._isResolved() && !target._isSettlePromisesQueued()) {
        async.invoke(
            target._settlePromiseAtPostResolution, target, callbackIndex);
    }

    return ret;
};

Promise.prototype._settlePromiseAtPostResolution = function (index) {
    if (this._isRejectionUnhandled()) this._unsetRejectionIsUnhandled();
    this._settlePromiseAt(index);
};

Promise.prototype._length = function () {
    return this._bitField & 131071;
};

Promise.prototype._isFollowingOrFulfilledOrRejected = function () {
    return (this._bitField & 939524096) > 0;
};

Promise.prototype._isFollowing = function () {
    return (this._bitField & 536870912) === 536870912;
};

Promise.prototype._setLength = function (len) {
    this._bitField = (this._bitField & -131072) |
        (len & 131071);
};

Promise.prototype._setFulfilled = function () {
    this._bitField = this._bitField | 268435456;
};

Promise.prototype._setRejected = function () {
    this._bitField = this._bitField | 134217728;
};

Promise.prototype._setFollowing = function () {
    this._bitField = this._bitField | 536870912;
};

Promise.prototype._setIsFinal = function () {
    this._bitField = this._bitField | 33554432;
};

Promise.prototype._isFinal = function () {
    return (this._bitField & 33554432) > 0;
};

Promise.prototype._cancellable = function () {
    return (this._bitField & 67108864) > 0;
};

Promise.prototype._setCancellable = function () {
    this._bitField = this._bitField | 67108864;
};

Promise.prototype._unsetCancellable = function () {
    this._bitField = this._bitField & (~67108864);
};

Promise.prototype._setIsMigrated = function () {
    this._bitField = this._bitField | 4194304;
};

Promise.prototype._unsetIsMigrated = function () {
    this._bitField = this._bitField & (~4194304);
};

Promise.prototype._isMigrated = function () {
    return (this._bitField & 4194304) > 0;
};

Promise.prototype._receiverAt = function (index) {
    var ret = index === 0
        ? this._receiver0
        : this[
            index * 5 - 5 + 4];
    if (ret === UNDEFINED_BINDING) {
        return undefined;
    } else if (ret === undefined && this._isBound()) {
        return this._boundValue();
    }
    return ret;
};

Promise.prototype._promiseAt = function (index) {
    return index === 0
        ? this._promise0
        : this[index * 5 - 5 + 3];
};

Promise.prototype._fulfillmentHandlerAt = function (index) {
    return index === 0
        ? this._fulfillmentHandler0
        : this[index * 5 - 5 + 0];
};

Promise.prototype._rejectionHandlerAt = function (index) {
    return index === 0
        ? this._rejectionHandler0
        : this[index * 5 - 5 + 1];
};

Promise.prototype._boundValue = function() {
    var ret = this._boundTo;
    if (ret !== undefined) {
        if (ret instanceof Promise) {
            if (ret.isFulfilled()) {
                return ret.value();
            } else {
                return undefined;
            }
        }
    }
    return ret;
};

Promise.prototype._migrateCallbacks = function (follower, index) {
    var fulfill = follower._fulfillmentHandlerAt(index);
    var reject = follower._rejectionHandlerAt(index);
    var progress = follower._progressHandlerAt(index);
    var promise = follower._promiseAt(index);
    var receiver = follower._receiverAt(index);
    if (promise instanceof Promise) promise._setIsMigrated();
    if (receiver === undefined) receiver = UNDEFINED_BINDING;
    this._addCallbacks(fulfill, reject, progress, promise, receiver, null);
};

Promise.prototype._addCallbacks = function (
    fulfill,
    reject,
    progress,
    promise,
    receiver,
    domain
) {
    var index = this._length();

    if (index >= 131071 - 5) {
        index = 0;
        this._setLength(0);
    }

    if (index === 0) {
        this._promise0 = promise;
        if (receiver !== undefined) this._receiver0 = receiver;
        if (typeof fulfill === "function" && !this._isCarryingStackTrace()) {
            this._fulfillmentHandler0 =
                domain === null ? fulfill : domain.bind(fulfill);
        }
        if (typeof reject === "function") {
            this._rejectionHandler0 =
                domain === null ? reject : domain.bind(reject);
        }
        if (typeof progress === "function") {
            this._progressHandler0 =
                domain === null ? progress : domain.bind(progress);
        }
    } else {
        var base = index * 5 - 5;
        this[base + 3] = promise;
        this[base + 4] = receiver;
        if (typeof fulfill === "function") {
            this[base + 0] =
                domain === null ? fulfill : domain.bind(fulfill);
        }
        if (typeof reject === "function") {
            this[base + 1] =
                domain === null ? reject : domain.bind(reject);
        }
        if (typeof progress === "function") {
            this[base + 2] =
                domain === null ? progress : domain.bind(progress);
        }
    }
    this._setLength(index + 1);
    return index;
};

Promise.prototype._setProxyHandlers = function (receiver, promiseSlotValue) {
    var index = this._length();

    if (index >= 131071 - 5) {
        index = 0;
        this._setLength(0);
    }
    if (index === 0) {
        this._promise0 = promiseSlotValue;
        this._receiver0 = receiver;
    } else {
        var base = index * 5 - 5;
        this[base + 3] = promiseSlotValue;
        this[base + 4] = receiver;
    }
    this._setLength(index + 1);
};

Promise.prototype._proxyPromiseArray = function (promiseArray, index) {
    this._setProxyHandlers(promiseArray, index);
};

Promise.prototype._resolveCallback = function(value, shouldBind) {
    if (this._isFollowingOrFulfilledOrRejected()) return;
    if (value === this)
        return this._rejectCallback(makeSelfResolutionError(), false, true);
    var maybePromise = tryConvertToPromise(value, this);
    if (!(maybePromise instanceof Promise)) return this._fulfill(value);

    var propagationFlags = 1 | (shouldBind ? 4 : 0);
    this._propagateFrom(maybePromise, propagationFlags);
    var promise = maybePromise._target();
    if (promise._isPending()) {
        var len = this._length();
        for (var i = 0; i < len; ++i) {
            promise._migrateCallbacks(this, i);
        }
        this._setFollowing();
        this._setLength(0);
        this._setFollowee(promise);
    } else if (promise._isFulfilled()) {
        this._fulfillUnchecked(promise._value());
    } else {
        this._rejectUnchecked(promise._reason(),
            promise._getCarriedStackTrace());
    }
};

Promise.prototype._rejectCallback =
function(reason, synchronous, shouldNotMarkOriginatingFromRejection) {
    if (!shouldNotMarkOriginatingFromRejection) {
        util.markAsOriginatingFromRejection(reason);
    }
    var trace = util.ensureErrorObject(reason);
    var hasStack = trace === reason;
    this._attachExtraTrace(trace, synchronous ? hasStack : false);
    this._reject(reason, hasStack ? undefined : trace);
};

Promise.prototype._resolveFromResolver = function (resolver) {
    var promise = this;
    this._captureStackTrace();
    this._pushContext();
    var synchronous = true;
    var r = tryCatch(resolver)(function(value) {
        if (promise === null) return;
        promise._resolveCallback(value);
        promise = null;
    }, function (reason) {
        if (promise === null) return;
        promise._rejectCallback(reason, synchronous);
        promise = null;
    });
    synchronous = false;
    this._popContext();

    if (r !== undefined && r === errorObj && promise !== null) {
        promise._rejectCallback(r.e, true, true);
        promise = null;
    }
};

Promise.prototype._settlePromiseFromHandler = function (
    handler, receiver, value, promise
) {
    if (promise._isRejected()) return;
    promise._pushContext();
    var x;
    if (receiver === APPLY && !this._isRejected()) {
        x = tryCatch(handler).apply(this._boundValue(), value);
    } else {
        x = tryCatch(handler).call(receiver, value);
    }
    promise._popContext();

    if (x === errorObj || x === promise || x === NEXT_FILTER) {
        var err = x === promise ? makeSelfResolutionError() : x.e;
        promise._rejectCallback(err, false, true);
    } else {
        promise._resolveCallback(x);
    }
};

Promise.prototype._target = function() {
    var ret = this;
    while (ret._isFollowing()) ret = ret._followee();
    return ret;
};

Promise.prototype._followee = function() {
    return this._rejectionHandler0;
};

Promise.prototype._setFollowee = function(promise) {
    this._rejectionHandler0 = promise;
};

Promise.prototype._cleanValues = function () {
    if (this._cancellable()) {
        this._cancellationParent = undefined;
    }
};

Promise.prototype._propagateFrom = function (parent, flags) {
    if ((flags & 1) > 0 && parent._cancellable()) {
        this._setCancellable();
        this._cancellationParent = parent;
    }
    if ((flags & 4) > 0 && parent._isBound()) {
        this._setBoundTo(parent._boundTo);
    }
};

Promise.prototype._fulfill = function (value) {
    if (this._isFollowingOrFulfilledOrRejected()) return;
    this._fulfillUnchecked(value);
};

Promise.prototype._reject = function (reason, carriedStackTrace) {
    if (this._isFollowingOrFulfilledOrRejected()) return;
    this._rejectUnchecked(reason, carriedStackTrace);
};

Promise.prototype._settlePromiseAt = function (index) {
    var promise = this._promiseAt(index);
    var isPromise = promise instanceof Promise;

    if (isPromise && promise._isMigrated()) {
        promise._unsetIsMigrated();
        return async.invoke(this._settlePromiseAt, this, index);
    }
    var handler = this._isFulfilled()
        ? this._fulfillmentHandlerAt(index)
        : this._rejectionHandlerAt(index);

    var carriedStackTrace =
        this._isCarryingStackTrace() ? this._getCarriedStackTrace() : undefined;
    var value = this._settledValue;
    var receiver = this._receiverAt(index);
    this._clearCallbackDataAtIndex(index);

    if (typeof handler === "function") {
        if (!isPromise) {
            handler.call(receiver, value, promise);
        } else {
            this._settlePromiseFromHandler(handler, receiver, value, promise);
        }
    } else if (receiver instanceof PromiseArray) {
        if (!receiver._isResolved()) {
            if (this._isFulfilled()) {
                receiver._promiseFulfilled(value, promise);
            }
            else {
                receiver._promiseRejected(value, promise);
            }
        }
    } else if (isPromise) {
        if (this._isFulfilled()) {
            promise._fulfill(value);
        } else {
            promise._reject(value, carriedStackTrace);
        }
    }

    if (index >= 4 && (index & 31) === 4)
        async.invokeLater(this._setLength, this, 0);
};

Promise.prototype._clearCallbackDataAtIndex = function(index) {
    if (index === 0) {
        if (!this._isCarryingStackTrace()) {
            this._fulfillmentHandler0 = undefined;
        }
        this._rejectionHandler0 =
        this._progressHandler0 =
        this._receiver0 =
        this._promise0 = undefined;
    } else {
        var base = index * 5 - 5;
        this[base + 3] =
        this[base + 4] =
        this[base + 0] =
        this[base + 1] =
        this[base + 2] = undefined;
    }
};

Promise.prototype._isSettlePromisesQueued = function () {
    return (this._bitField &
            -1073741824) === -1073741824;
};

Promise.prototype._setSettlePromisesQueued = function () {
    this._bitField = this._bitField | -1073741824;
};

Promise.prototype._unsetSettlePromisesQueued = function () {
    this._bitField = this._bitField & (~-1073741824);
};

Promise.prototype._queueSettlePromises = function() {
    async.settlePromises(this);
    this._setSettlePromisesQueued();
};

Promise.prototype._fulfillUnchecked = function (value) {
    if (value === this) {
        var err = makeSelfResolutionError();
        this._attachExtraTrace(err);
        return this._rejectUnchecked(err, undefined);
    }
    this._setFulfilled();
    this._settledValue = value;
    this._cleanValues();

    if (this._length() > 0) {
        this._queueSettlePromises();
    }
};

Promise.prototype._rejectUncheckedCheckError = function (reason) {
    var trace = util.ensureErrorObject(reason);
    this._rejectUnchecked(reason, trace === reason ? undefined : trace);
};

Promise.prototype._rejectUnchecked = function (reason, trace) {
    if (reason === this) {
        var err = makeSelfResolutionError();
        this._attachExtraTrace(err);
        return this._rejectUnchecked(err);
    }
    this._setRejected();
    this._settledValue = reason;
    this._cleanValues();

    if (this._isFinal()) {
        async.throwLater(function(e) {
            if ("stack" in e) {
                async.invokeFirst(
                    CapturedTrace.unhandledRejection, undefined, e);
            }
            throw e;
        }, trace === undefined ? reason : trace);
        return;
    }

    if (trace !== undefined && trace !== reason) {
        this._setCarriedStackTrace(trace);
    }

    if (this._length() > 0) {
        this._queueSettlePromises();
    } else {
        this._ensurePossibleRejectionHandled();
    }
};

Promise.prototype._settlePromises = function () {
    this._unsetSettlePromisesQueued();
    var len = this._length();
    for (var i = 0; i < len; i++) {
        this._settlePromiseAt(i);
    }
};


util.notEnumerableProp(Promise,
                       "_makeSelfResolutionError",
                       makeSelfResolutionError);

_dereq_("./progress.js")(Promise, PromiseArray);
_dereq_("./method.js")(Promise, INTERNAL, tryConvertToPromise, apiRejection);
_dereq_("./bind.js")(Promise, INTERNAL, tryConvertToPromise);
_dereq_("./finally.js")(Promise, NEXT_FILTER, tryConvertToPromise);
_dereq_("./direct_resolve.js")(Promise);
_dereq_("./synchronous_inspection.js")(Promise);
_dereq_("./join.js")(Promise, PromiseArray, tryConvertToPromise, INTERNAL);
Promise.version = "2.11.0";
Promise.Promise = Promise;
_dereq_('./map.js')(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL);
_dereq_('./cancel.js')(Promise);
_dereq_('./using.js')(Promise, apiRejection, tryConvertToPromise, createContext);
_dereq_('./generators.js')(Promise, apiRejection, INTERNAL, tryConvertToPromise);
_dereq_('./nodeify.js')(Promise);
_dereq_('./call_get.js')(Promise);
_dereq_('./props.js')(Promise, PromiseArray, tryConvertToPromise, apiRejection);
_dereq_('./race.js')(Promise, INTERNAL, tryConvertToPromise, apiRejection);
_dereq_('./reduce.js')(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL);
_dereq_('./settle.js')(Promise, PromiseArray);
_dereq_('./some.js')(Promise, PromiseArray, apiRejection);
_dereq_('./promisify.js')(Promise, INTERNAL);
_dereq_('./any.js')(Promise);
_dereq_('./each.js')(Promise, INTERNAL);
_dereq_('./timers.js')(Promise, INTERNAL);
_dereq_('./filter.js')(Promise, INTERNAL);
                                                         
    util.toFastProperties(Promise);                                          
    util.toFastProperties(Promise.prototype);                                
    function fillTypes(value) {                                              
        var p = new Promise(INTERNAL);                                       
        p._fulfillmentHandler0 = value;                                      
        p._rejectionHandler0 = value;                                        
        p._progressHandler0 = value;                                         
        p._promise0 = value;                                                 
        p._receiver0 = value;                                                
        p._settledValue = value;                                             
    }                                                                        
    // Complete slack tracking, opt out of field-type tracking and           
    // stabilize map                                                         
    fillTypes({a: 1});                                                       
    fillTypes({b: 2});                                                       
    fillTypes({c: 3});                                                       
    fillTypes(1);                                                            
    fillTypes(function(){});                                                 
    fillTypes(undefined);                                                    
    fillTypes(false);                                                        
    fillTypes(new Promise(INTERNAL));                                        
    CapturedTrace.setBounds(async.firstLineError, util.lastLineError);       
    return Promise;                                                          

};

},{"./any.js":1,"./async.js":2,"./bind.js":3,"./call_get.js":5,"./cancel.js":6,"./captured_trace.js":7,"./catch_filter.js":8,"./context.js":9,"./debuggability.js":10,"./direct_resolve.js":11,"./each.js":12,"./errors.js":13,"./filter.js":15,"./finally.js":16,"./generators.js":17,"./join.js":18,"./map.js":19,"./method.js":20,"./nodeify.js":21,"./progress.js":22,"./promise_array.js":24,"./promise_resolver.js":25,"./promisify.js":26,"./props.js":27,"./race.js":29,"./reduce.js":30,"./settle.js":32,"./some.js":33,"./synchronous_inspection.js":34,"./thenables.js":35,"./timers.js":36,"./using.js":37,"./util.js":38}],24:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL, tryConvertToPromise,
    apiRejection) {
var util = _dereq_("./util.js");
var isArray = util.isArray;

function toResolutionValue(val) {
    switch(val) {
    case -2: return [];
    case -3: return {};
    }
}

function PromiseArray(values) {
    var promise = this._promise = new Promise(INTERNAL);
    var parent;
    if (values instanceof Promise) {
        parent = values;
        promise._propagateFrom(parent, 1 | 4);
    }
    this._values = values;
    this._length = 0;
    this._totalResolved = 0;
    this._init(undefined, -2);
}
PromiseArray.prototype.length = function () {
    return this._length;
};

PromiseArray.prototype.promise = function () {
    return this._promise;
};

PromiseArray.prototype._init = function init(_, resolveValueIfEmpty) {
    var values = tryConvertToPromise(this._values, this._promise);
    if (values instanceof Promise) {
        values = values._target();
        this._values = values;
        if (values._isFulfilled()) {
            values = values._value();
            if (!isArray(values)) {
                var err = new Promise.TypeError("expecting an array, a promise or a thenable\u000a\u000a    See http://goo.gl/s8MMhc\u000a");
                this.__hardReject__(err);
                return;
            }
        } else if (values._isPending()) {
            values._then(
                init,
                this._reject,
                undefined,
                this,
                resolveValueIfEmpty
           );
            return;
        } else {
            this._reject(values._reason());
            return;
        }
    } else if (!isArray(values)) {
        this._promise._reject(apiRejection("expecting an array, a promise or a thenable\u000a\u000a    See http://goo.gl/s8MMhc\u000a")._reason());
        return;
    }

    if (values.length === 0) {
        if (resolveValueIfEmpty === -5) {
            this._resolveEmptyArray();
        }
        else {
            this._resolve(toResolutionValue(resolveValueIfEmpty));
        }
        return;
    }
    var len = this.getActualLength(values.length);
    this._length = len;
    this._values = this.shouldCopyValues() ? new Array(len) : this._values;
    var promise = this._promise;
    for (var i = 0; i < len; ++i) {
        var isResolved = this._isResolved();
        var maybePromise = tryConvertToPromise(values[i], promise);
        if (maybePromise instanceof Promise) {
            maybePromise = maybePromise._target();
            if (isResolved) {
                maybePromise._ignoreRejections();
            } else if (maybePromise._isPending()) {
                maybePromise._proxyPromiseArray(this, i);
            } else if (maybePromise._isFulfilled()) {
                this._promiseFulfilled(maybePromise._value(), i);
            } else {
                this._promiseRejected(maybePromise._reason(), i);
            }
        } else if (!isResolved) {
            this._promiseFulfilled(maybePromise, i);
        }
    }
};

PromiseArray.prototype._isResolved = function () {
    return this._values === null;
};

PromiseArray.prototype._resolve = function (value) {
    this._values = null;
    this._promise._fulfill(value);
};

PromiseArray.prototype.__hardReject__ =
PromiseArray.prototype._reject = function (reason) {
    this._values = null;
    this._promise._rejectCallback(reason, false, true);
};

PromiseArray.prototype._promiseProgressed = function (progressValue, index) {
    this._promise._progress({
        index: index,
        value: progressValue
    });
};


PromiseArray.prototype._promiseFulfilled = function (value, index) {
    this._values[index] = value;
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= this._length) {
        this._resolve(this._values);
    }
};

PromiseArray.prototype._promiseRejected = function (reason, index) {
    this._totalResolved++;
    this._reject(reason);
};

PromiseArray.prototype.shouldCopyValues = function () {
    return true;
};

PromiseArray.prototype.getActualLength = function (len) {
    return len;
};

return PromiseArray;
};

},{"./util.js":38}],25:[function(_dereq_,module,exports){
"use strict";
var util = _dereq_("./util.js");
var maybeWrapAsError = util.maybeWrapAsError;
var errors = _dereq_("./errors.js");
var TimeoutError = errors.TimeoutError;
var OperationalError = errors.OperationalError;
var haveGetters = util.haveGetters;
var es5 = _dereq_("./es5.js");

function isUntypedError(obj) {
    return obj instanceof Error &&
        es5.getPrototypeOf(obj) === Error.prototype;
}

var rErrorKey = /^(?:name|message|stack|cause)$/;
function wrapAsOperationalError(obj) {
    var ret;
    if (isUntypedError(obj)) {
        ret = new OperationalError(obj);
        ret.name = obj.name;
        ret.message = obj.message;
        ret.stack = obj.stack;
        var keys = es5.keys(obj);
        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!rErrorKey.test(key)) {
                ret[key] = obj[key];
            }
        }
        return ret;
    }
    util.markAsOriginatingFromRejection(obj);
    return obj;
}

function nodebackForPromise(promise) {
    return function(err, value) {
        if (promise === null) return;

        if (err) {
            var wrapped = wrapAsOperationalError(maybeWrapAsError(err));
            promise._attachExtraTrace(wrapped);
            promise._reject(wrapped);
        } else if (arguments.length > 2) {
            var $_len = arguments.length;var args = new Array($_len - 1); for(var $_i = 1; $_i < $_len; ++$_i) {args[$_i - 1] = arguments[$_i];}
            promise._fulfill(args);
        } else {
            promise._fulfill(value);
        }

        promise = null;
    };
}


var PromiseResolver;
if (!haveGetters) {
    PromiseResolver = function (promise) {
        this.promise = promise;
        this.asCallback = nodebackForPromise(promise);
        this.callback = this.asCallback;
    };
}
else {
    PromiseResolver = function (promise) {
        this.promise = promise;
    };
}
if (haveGetters) {
    var prop = {
        get: function() {
            return nodebackForPromise(this.promise);
        }
    };
    es5.defineProperty(PromiseResolver.prototype, "asCallback", prop);
    es5.defineProperty(PromiseResolver.prototype, "callback", prop);
}

PromiseResolver._nodebackForPromise = nodebackForPromise;

PromiseResolver.prototype.toString = function () {
    return "[object PromiseResolver]";
};

PromiseResolver.prototype.resolve =
PromiseResolver.prototype.fulfill = function (value) {
    if (!(this instanceof PromiseResolver)) {
        throw new TypeError("Illegal invocation, resolver resolve/reject must be called within a resolver context. Consider using the promise constructor instead.\u000a\u000a    See http://goo.gl/sdkXL9\u000a");
    }
    this.promise._resolveCallback(value);
};

PromiseResolver.prototype.reject = function (reason) {
    if (!(this instanceof PromiseResolver)) {
        throw new TypeError("Illegal invocation, resolver resolve/reject must be called within a resolver context. Consider using the promise constructor instead.\u000a\u000a    See http://goo.gl/sdkXL9\u000a");
    }
    this.promise._rejectCallback(reason);
};

PromiseResolver.prototype.progress = function (value) {
    if (!(this instanceof PromiseResolver)) {
        throw new TypeError("Illegal invocation, resolver resolve/reject must be called within a resolver context. Consider using the promise constructor instead.\u000a\u000a    See http://goo.gl/sdkXL9\u000a");
    }
    this.promise._progress(value);
};

PromiseResolver.prototype.cancel = function (err) {
    this.promise.cancel(err);
};

PromiseResolver.prototype.timeout = function () {
    this.reject(new TimeoutError("timeout"));
};

PromiseResolver.prototype.isResolved = function () {
    return this.promise.isResolved();
};

PromiseResolver.prototype.toJSON = function () {
    return this.promise.toJSON();
};

module.exports = PromiseResolver;

},{"./errors.js":13,"./es5.js":14,"./util.js":38}],26:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var THIS = {};
var util = _dereq_("./util.js");
var nodebackForPromise = _dereq_("./promise_resolver.js")
    ._nodebackForPromise;
var withAppended = util.withAppended;
var maybeWrapAsError = util.maybeWrapAsError;
var canEvaluate = util.canEvaluate;
var TypeError = _dereq_("./errors").TypeError;
var defaultSuffix = "Async";
var defaultPromisified = {__isPromisified__: true};
var noCopyProps = [
    "arity",    "length",
    "name",
    "arguments",
    "caller",
    "callee",
    "prototype",
    "__isPromisified__"
];
var noCopyPropsPattern = new RegExp("^(?:" + noCopyProps.join("|") + ")$");

var defaultFilter = function(name) {
    return util.isIdentifier(name) &&
        name.charAt(0) !== "_" &&
        name !== "constructor";
};

function propsFilter(key) {
    return !noCopyPropsPattern.test(key);
}

function isPromisified(fn) {
    try {
        return fn.__isPromisified__ === true;
    }
    catch (e) {
        return false;
    }
}

function hasPromisified(obj, key, suffix) {
    var val = util.getDataPropertyOrDefault(obj, key + suffix,
                                            defaultPromisified);
    return val ? isPromisified(val) : false;
}
function checkValid(ret, suffix, suffixRegexp) {
    for (var i = 0; i < ret.length; i += 2) {
        var key = ret[i];
        if (suffixRegexp.test(key)) {
            var keyWithoutAsyncSuffix = key.replace(suffixRegexp, "");
            for (var j = 0; j < ret.length; j += 2) {
                if (ret[j] === keyWithoutAsyncSuffix) {
                    throw new TypeError("Cannot promisify an API that has normal methods with '%s'-suffix\u000a\u000a    See http://goo.gl/iWrZbw\u000a"
                        .replace("%s", suffix));
                }
            }
        }
    }
}

function promisifiableMethods(obj, suffix, suffixRegexp, filter) {
    var keys = util.inheritedDataKeys(obj);
    var ret = [];
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var value = obj[key];
        var passesDefaultFilter = filter === defaultFilter
            ? true : defaultFilter(key, value, obj);
        if (typeof value === "function" &&
            !isPromisified(value) &&
            !hasPromisified(obj, key, suffix) &&
            filter(key, value, obj, passesDefaultFilter)) {
            ret.push(key, value);
        }
    }
    checkValid(ret, suffix, suffixRegexp);
    return ret;
}

var escapeIdentRegex = function(str) {
    return str.replace(/([$])/, "\\$");
};

var makeNodePromisifiedEval;
if (false) {
var switchCaseArgumentOrder = function(likelyArgumentCount) {
    var ret = [likelyArgumentCount];
    var min = Math.max(0, likelyArgumentCount - 1 - 3);
    for(var i = likelyArgumentCount - 1; i >= min; --i) {
        ret.push(i);
    }
    for(var i = likelyArgumentCount + 1; i <= 3; ++i) {
        ret.push(i);
    }
    return ret;
};

var argumentSequence = function(argumentCount) {
    return util.filledRange(argumentCount, "_arg", "");
};

var parameterDeclaration = function(parameterCount) {
    return util.filledRange(
        Math.max(parameterCount, 3), "_arg", "");
};

var parameterCount = function(fn) {
    if (typeof fn.length === "number") {
        return Math.max(Math.min(fn.length, 1023 + 1), 0);
    }
    return 0;
};

makeNodePromisifiedEval =
function(callback, receiver, originalName, fn) {
    var newParameterCount = Math.max(0, parameterCount(fn) - 1);
    var argumentOrder = switchCaseArgumentOrder(newParameterCount);
    var shouldProxyThis = typeof callback === "string" || receiver === THIS;

    function generateCallForArgumentCount(count) {
        var args = argumentSequence(count).join(", ");
        var comma = count > 0 ? ", " : "";
        var ret;
        if (shouldProxyThis) {
            ret = "ret = callback.call(this, {{args}}, nodeback); break;\n";
        } else {
            ret = receiver === undefined
                ? "ret = callback({{args}}, nodeback); break;\n"
                : "ret = callback.call(receiver, {{args}}, nodeback); break;\n";
        }
        return ret.replace("{{args}}", args).replace(", ", comma);
    }

    function generateArgumentSwitchCase() {
        var ret = "";
        for (var i = 0; i < argumentOrder.length; ++i) {
            ret += "case " + argumentOrder[i] +":" +
                generateCallForArgumentCount(argumentOrder[i]);
        }

        ret += "                                                             \n\
        default:                                                             \n\
            var args = new Array(len + 1);                                   \n\
            var i = 0;                                                       \n\
            for (var i = 0; i < len; ++i) {                                  \n\
               args[i] = arguments[i];                                       \n\
            }                                                                \n\
            args[i] = nodeback;                                              \n\
            [CodeForCall]                                                    \n\
            break;                                                           \n\
        ".replace("[CodeForCall]", (shouldProxyThis
                                ? "ret = callback.apply(this, args);\n"
                                : "ret = callback.apply(receiver, args);\n"));
        return ret;
    }

    var getFunctionCode = typeof callback === "string"
                                ? ("this != null ? this['"+callback+"'] : fn")
                                : "fn";

    return new Function("Promise",
                        "fn",
                        "receiver",
                        "withAppended",
                        "maybeWrapAsError",
                        "nodebackForPromise",
                        "tryCatch",
                        "errorObj",
                        "notEnumerableProp",
                        "INTERNAL","'use strict';                            \n\
        var ret = function (Parameters) {                                    \n\
            'use strict';                                                    \n\
            var len = arguments.length;                                      \n\
            var promise = new Promise(INTERNAL);                             \n\
            promise._captureStackTrace();                                    \n\
            var nodeback = nodebackForPromise(promise);                      \n\
            var ret;                                                         \n\
            var callback = tryCatch([GetFunctionCode]);                      \n\
            switch(len) {                                                    \n\
                [CodeForSwitchCase]                                          \n\
            }                                                                \n\
            if (ret === errorObj) {                                          \n\
                promise._rejectCallback(maybeWrapAsError(ret.e), true, true);\n\
            }                                                                \n\
            return promise;                                                  \n\
        };                                                                   \n\
        notEnumerableProp(ret, '__isPromisified__', true);                   \n\
        return ret;                                                          \n\
        "
        .replace("Parameters", parameterDeclaration(newParameterCount))
        .replace("[CodeForSwitchCase]", generateArgumentSwitchCase())
        .replace("[GetFunctionCode]", getFunctionCode))(
            Promise,
            fn,
            receiver,
            withAppended,
            maybeWrapAsError,
            nodebackForPromise,
            util.tryCatch,
            util.errorObj,
            util.notEnumerableProp,
            INTERNAL
        );
};
}

function makeNodePromisifiedClosure(callback, receiver, _, fn) {
    var defaultThis = (function() {return this;})();
    var method = callback;
    if (typeof method === "string") {
        callback = fn;
    }
    function promisified() {
        var _receiver = receiver;
        if (receiver === THIS) _receiver = this;
        var promise = new Promise(INTERNAL);
        promise._captureStackTrace();
        var cb = typeof method === "string" && this !== defaultThis
            ? this[method] : callback;
        var fn = nodebackForPromise(promise);
        try {
            cb.apply(_receiver, withAppended(arguments, fn));
        } catch(e) {
            promise._rejectCallback(maybeWrapAsError(e), true, true);
        }
        return promise;
    }
    util.notEnumerableProp(promisified, "__isPromisified__", true);
    return promisified;
}

var makeNodePromisified = canEvaluate
    ? makeNodePromisifiedEval
    : makeNodePromisifiedClosure;

function promisifyAll(obj, suffix, filter, promisifier) {
    var suffixRegexp = new RegExp(escapeIdentRegex(suffix) + "$");
    var methods =
        promisifiableMethods(obj, suffix, suffixRegexp, filter);

    for (var i = 0, len = methods.length; i < len; i+= 2) {
        var key = methods[i];
        var fn = methods[i+1];
        var promisifiedKey = key + suffix;
        if (promisifier === makeNodePromisified) {
            obj[promisifiedKey] =
                makeNodePromisified(key, THIS, key, fn, suffix);
        } else {
            var promisified = promisifier(fn, function() {
                return makeNodePromisified(key, THIS, key, fn, suffix);
            });
            util.notEnumerableProp(promisified, "__isPromisified__", true);
            obj[promisifiedKey] = promisified;
        }
    }
    util.toFastProperties(obj);
    return obj;
}

function promisify(callback, receiver) {
    return makeNodePromisified(callback, receiver, undefined, callback);
}

Promise.promisify = function (fn, receiver) {
    if (typeof fn !== "function") {
        throw new TypeError("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
    }
    if (isPromisified(fn)) {
        return fn;
    }
    var ret = promisify(fn, arguments.length < 2 ? THIS : receiver);
    util.copyDescriptors(fn, ret, propsFilter);
    return ret;
};

Promise.promisifyAll = function (target, options) {
    if (typeof target !== "function" && typeof target !== "object") {
        throw new TypeError("the target of promisifyAll must be an object or a function\u000a\u000a    See http://goo.gl/9ITlV0\u000a");
    }
    options = Object(options);
    var suffix = options.suffix;
    if (typeof suffix !== "string") suffix = defaultSuffix;
    var filter = options.filter;
    if (typeof filter !== "function") filter = defaultFilter;
    var promisifier = options.promisifier;
    if (typeof promisifier !== "function") promisifier = makeNodePromisified;

    if (!util.isIdentifier(suffix)) {
        throw new RangeError("suffix must be a valid identifier\u000a\u000a    See http://goo.gl/8FZo5V\u000a");
    }

    var keys = util.inheritedDataKeys(target);
    for (var i = 0; i < keys.length; ++i) {
        var value = target[keys[i]];
        if (keys[i] !== "constructor" &&
            util.isClass(value)) {
            promisifyAll(value.prototype, suffix, filter, promisifier);
            promisifyAll(value, suffix, filter, promisifier);
        }
    }

    return promisifyAll(target, suffix, filter, promisifier);
};
};


},{"./errors":13,"./promise_resolver.js":25,"./util.js":38}],27:[function(_dereq_,module,exports){
"use strict";
module.exports = function(
    Promise, PromiseArray, tryConvertToPromise, apiRejection) {
var util = _dereq_("./util.js");
var isObject = util.isObject;
var es5 = _dereq_("./es5.js");

function PropertiesPromiseArray(obj) {
    var keys = es5.keys(obj);
    var len = keys.length;
    var values = new Array(len * 2);
    for (var i = 0; i < len; ++i) {
        var key = keys[i];
        values[i] = obj[key];
        values[i + len] = key;
    }
    this.constructor$(values);
}
util.inherits(PropertiesPromiseArray, PromiseArray);

PropertiesPromiseArray.prototype._init = function () {
    this._init$(undefined, -3) ;
};

PropertiesPromiseArray.prototype._promiseFulfilled = function (value, index) {
    this._values[index] = value;
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= this._length) {
        var val = {};
        var keyOffset = this.length();
        for (var i = 0, len = this.length(); i < len; ++i) {
            val[this._values[i + keyOffset]] = this._values[i];
        }
        this._resolve(val);
    }
};

PropertiesPromiseArray.prototype._promiseProgressed = function (value, index) {
    this._promise._progress({
        key: this._values[index + this.length()],
        value: value
    });
};

PropertiesPromiseArray.prototype.shouldCopyValues = function () {
    return false;
};

PropertiesPromiseArray.prototype.getActualLength = function (len) {
    return len >> 1;
};

function props(promises) {
    var ret;
    var castValue = tryConvertToPromise(promises);

    if (!isObject(castValue)) {
        return apiRejection("cannot await properties of a non-object\u000a\u000a    See http://goo.gl/OsFKC8\u000a");
    } else if (castValue instanceof Promise) {
        ret = castValue._then(
            Promise.props, undefined, undefined, undefined, undefined);
    } else {
        ret = new PropertiesPromiseArray(castValue).promise();
    }

    if (castValue instanceof Promise) {
        ret._propagateFrom(castValue, 4);
    }
    return ret;
}

Promise.prototype.props = function () {
    return props(this);
};

Promise.props = function (promises) {
    return props(promises);
};
};

},{"./es5.js":14,"./util.js":38}],28:[function(_dereq_,module,exports){
"use strict";
function arrayMove(src, srcIndex, dst, dstIndex, len) {
    for (var j = 0; j < len; ++j) {
        dst[j + dstIndex] = src[j + srcIndex];
        src[j + srcIndex] = void 0;
    }
}

function Queue(capacity) {
    this._capacity = capacity;
    this._length = 0;
    this._front = 0;
}

Queue.prototype._willBeOverCapacity = function (size) {
    return this._capacity < size;
};

Queue.prototype._pushOne = function (arg) {
    var length = this.length();
    this._checkCapacity(length + 1);
    var i = (this._front + length) & (this._capacity - 1);
    this[i] = arg;
    this._length = length + 1;
};

Queue.prototype._unshiftOne = function(value) {
    var capacity = this._capacity;
    this._checkCapacity(this.length() + 1);
    var front = this._front;
    var i = (((( front - 1 ) &
                    ( capacity - 1) ) ^ capacity ) - capacity );
    this[i] = value;
    this._front = i;
    this._length = this.length() + 1;
};

Queue.prototype.unshift = function(fn, receiver, arg) {
    this._unshiftOne(arg);
    this._unshiftOne(receiver);
    this._unshiftOne(fn);
};

Queue.prototype.push = function (fn, receiver, arg) {
    var length = this.length() + 3;
    if (this._willBeOverCapacity(length)) {
        this._pushOne(fn);
        this._pushOne(receiver);
        this._pushOne(arg);
        return;
    }
    var j = this._front + length - 3;
    this._checkCapacity(length);
    var wrapMask = this._capacity - 1;
    this[(j + 0) & wrapMask] = fn;
    this[(j + 1) & wrapMask] = receiver;
    this[(j + 2) & wrapMask] = arg;
    this._length = length;
};

Queue.prototype.shift = function () {
    var front = this._front,
        ret = this[front];

    this[front] = undefined;
    this._front = (front + 1) & (this._capacity - 1);
    this._length--;
    return ret;
};

Queue.prototype.length = function () {
    return this._length;
};

Queue.prototype._checkCapacity = function (size) {
    if (this._capacity < size) {
        this._resizeTo(this._capacity << 1);
    }
};

Queue.prototype._resizeTo = function (capacity) {
    var oldCapacity = this._capacity;
    this._capacity = capacity;
    var front = this._front;
    var length = this._length;
    var moveItemsCount = (front + length) & (oldCapacity - 1);
    arrayMove(this, 0, this, oldCapacity, moveItemsCount);
};

module.exports = Queue;

},{}],29:[function(_dereq_,module,exports){
"use strict";
module.exports = function(
    Promise, INTERNAL, tryConvertToPromise, apiRejection) {
var isArray = _dereq_("./util.js").isArray;

var raceLater = function (promise) {
    return promise.then(function(array) {
        return race(array, promise);
    });
};

function race(promises, parent) {
    var maybePromise = tryConvertToPromise(promises);

    if (maybePromise instanceof Promise) {
        return raceLater(maybePromise);
    } else if (!isArray(promises)) {
        return apiRejection("expecting an array, a promise or a thenable\u000a\u000a    See http://goo.gl/s8MMhc\u000a");
    }

    var ret = new Promise(INTERNAL);
    if (parent !== undefined) {
        ret._propagateFrom(parent, 4 | 1);
    }
    var fulfill = ret._fulfill;
    var reject = ret._reject;
    for (var i = 0, len = promises.length; i < len; ++i) {
        var val = promises[i];

        if (val === undefined && !(i in promises)) {
            continue;
        }

        Promise.cast(val)._then(fulfill, reject, undefined, ret, null);
    }
    return ret;
}

Promise.race = function (promises) {
    return race(promises, undefined);
};

Promise.prototype.race = function () {
    return race(this, undefined);
};

};

},{"./util.js":38}],30:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise,
                          PromiseArray,
                          apiRejection,
                          tryConvertToPromise,
                          INTERNAL) {
var getDomain = Promise._getDomain;
var async = _dereq_("./async.js");
var util = _dereq_("./util.js");
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;
function ReductionPromiseArray(promises, fn, accum, _each) {
    this.constructor$(promises);
    this._promise._captureStackTrace();
    this._preservedValues = _each === INTERNAL ? [] : null;
    this._zerothIsAccum = (accum === undefined);
    this._gotAccum = false;
    this._reducingIndex = (this._zerothIsAccum ? 1 : 0);
    this._valuesPhase = undefined;
    var maybePromise = tryConvertToPromise(accum, this._promise);
    var rejected = false;
    var isPromise = maybePromise instanceof Promise;
    if (isPromise) {
        maybePromise = maybePromise._target();
        if (maybePromise._isPending()) {
            maybePromise._proxyPromiseArray(this, -1);
        } else if (maybePromise._isFulfilled()) {
            accum = maybePromise._value();
            this._gotAccum = true;
        } else {
            this._reject(maybePromise._reason());
            rejected = true;
        }
    }
    if (!(isPromise || this._zerothIsAccum)) this._gotAccum = true;
    var domain = getDomain();
    this._callback = domain === null ? fn : domain.bind(fn);
    this._accum = accum;
    if (!rejected) async.invoke(init, this, undefined);
}
function init() {
    this._init$(undefined, -5);
}
util.inherits(ReductionPromiseArray, PromiseArray);

ReductionPromiseArray.prototype._init = function () {};

ReductionPromiseArray.prototype._resolveEmptyArray = function () {
    if (this._gotAccum || this._zerothIsAccum) {
        this._resolve(this._preservedValues !== null
                        ? [] : this._accum);
    }
};

ReductionPromiseArray.prototype._promiseFulfilled = function (value, index) {
    var values = this._values;
    values[index] = value;
    var length = this.length();
    var preservedValues = this._preservedValues;
    var isEach = preservedValues !== null;
    var gotAccum = this._gotAccum;
    var valuesPhase = this._valuesPhase;
    var valuesPhaseIndex;
    if (!valuesPhase) {
        valuesPhase = this._valuesPhase = new Array(length);
        for (valuesPhaseIndex=0; valuesPhaseIndex<length; ++valuesPhaseIndex) {
            valuesPhase[valuesPhaseIndex] = 0;
        }
    }
    valuesPhaseIndex = valuesPhase[index];

    if (index === 0 && this._zerothIsAccum) {
        this._accum = value;
        this._gotAccum = gotAccum = true;
        valuesPhase[index] = ((valuesPhaseIndex === 0)
            ? 1 : 2);
    } else if (index === -1) {
        this._accum = value;
        this._gotAccum = gotAccum = true;
    } else {
        if (valuesPhaseIndex === 0) {
            valuesPhase[index] = 1;
        } else {
            valuesPhase[index] = 2;
            this._accum = value;
        }
    }
    if (!gotAccum) return;

    var callback = this._callback;
    var receiver = this._promise._boundValue();
    var ret;

    for (var i = this._reducingIndex; i < length; ++i) {
        valuesPhaseIndex = valuesPhase[i];
        if (valuesPhaseIndex === 2) {
            this._reducingIndex = i + 1;
            continue;
        }
        if (valuesPhaseIndex !== 1) return;
        value = values[i];
        this._promise._pushContext();
        if (isEach) {
            preservedValues.push(value);
            ret = tryCatch(callback).call(receiver, value, i, length);
        }
        else {
            ret = tryCatch(callback)
                .call(receiver, this._accum, value, i, length);
        }
        this._promise._popContext();

        if (ret === errorObj) return this._reject(ret.e);

        var maybePromise = tryConvertToPromise(ret, this._promise);
        if (maybePromise instanceof Promise) {
            maybePromise = maybePromise._target();
            if (maybePromise._isPending()) {
                valuesPhase[i] = 4;
                return maybePromise._proxyPromiseArray(this, i);
            } else if (maybePromise._isFulfilled()) {
                ret = maybePromise._value();
            } else {
                return this._reject(maybePromise._reason());
            }
        }

        this._reducingIndex = i + 1;
        this._accum = ret;
    }

    this._resolve(isEach ? preservedValues : this._accum);
};

function reduce(promises, fn, initialValue, _each) {
    if (typeof fn !== "function") return apiRejection("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
    var array = new ReductionPromiseArray(promises, fn, initialValue, _each);
    return array.promise();
}

Promise.prototype.reduce = function (fn, initialValue) {
    return reduce(this, fn, initialValue, null);
};

Promise.reduce = function (promises, fn, initialValue, _each) {
    return reduce(promises, fn, initialValue, _each);
};
};

},{"./async.js":2,"./util.js":38}],31:[function(_dereq_,module,exports){
"use strict";
var schedule;
var util = _dereq_("./util");
var noAsyncScheduler = function() {
    throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/m3OTXk\u000a");
};
if (util.isNode && typeof MutationObserver === "undefined") {
    var GlobalSetImmediate = global.setImmediate;
    var ProcessNextTick = process.nextTick;
    schedule = util.isRecentNode
                ? function(fn) { GlobalSetImmediate.call(global, fn); }
                : function(fn) { ProcessNextTick.call(process, fn); };
} else if ((typeof MutationObserver !== "undefined") &&
          !(typeof window !== "undefined" &&
            window.navigator &&
            window.navigator.standalone)) {
    schedule = function(fn) {
        var div = document.createElement("div");
        var observer = new MutationObserver(fn);
        observer.observe(div, {attributes: true});
        return function() { div.classList.toggle("foo"); };
    };
    schedule.isStatic = true;
} else if (typeof setImmediate !== "undefined") {
    schedule = function (fn) {
        setImmediate(fn);
    };
} else if (typeof setTimeout !== "undefined") {
    schedule = function (fn) {
        setTimeout(fn, 0);
    };
} else {
    schedule = noAsyncScheduler;
}
module.exports = schedule;

},{"./util":38}],32:[function(_dereq_,module,exports){
"use strict";
module.exports =
    function(Promise, PromiseArray) {
var PromiseInspection = Promise.PromiseInspection;
var util = _dereq_("./util.js");

function SettledPromiseArray(values) {
    this.constructor$(values);
}
util.inherits(SettledPromiseArray, PromiseArray);

SettledPromiseArray.prototype._promiseResolved = function (index, inspection) {
    this._values[index] = inspection;
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= this._length) {
        this._resolve(this._values);
    }
};

SettledPromiseArray.prototype._promiseFulfilled = function (value, index) {
    var ret = new PromiseInspection();
    ret._bitField = 268435456;
    ret._settledValue = value;
    this._promiseResolved(index, ret);
};
SettledPromiseArray.prototype._promiseRejected = function (reason, index) {
    var ret = new PromiseInspection();
    ret._bitField = 134217728;
    ret._settledValue = reason;
    this._promiseResolved(index, ret);
};

Promise.settle = function (promises) {
    return new SettledPromiseArray(promises).promise();
};

Promise.prototype.settle = function () {
    return new SettledPromiseArray(this).promise();
};
};

},{"./util.js":38}],33:[function(_dereq_,module,exports){
"use strict";
module.exports =
function(Promise, PromiseArray, apiRejection) {
var util = _dereq_("./util.js");
var RangeError = _dereq_("./errors.js").RangeError;
var AggregateError = _dereq_("./errors.js").AggregateError;
var isArray = util.isArray;


function SomePromiseArray(values) {
    this.constructor$(values);
    this._howMany = 0;
    this._unwrap = false;
    this._initialized = false;
}
util.inherits(SomePromiseArray, PromiseArray);

SomePromiseArray.prototype._init = function () {
    if (!this._initialized) {
        return;
    }
    if (this._howMany === 0) {
        this._resolve([]);
        return;
    }
    this._init$(undefined, -5);
    var isArrayResolved = isArray(this._values);
    if (!this._isResolved() &&
        isArrayResolved &&
        this._howMany > this._canPossiblyFulfill()) {
        this._reject(this._getRangeError(this.length()));
    }
};

SomePromiseArray.prototype.init = function () {
    this._initialized = true;
    this._init();
};

SomePromiseArray.prototype.setUnwrap = function () {
    this._unwrap = true;
};

SomePromiseArray.prototype.howMany = function () {
    return this._howMany;
};

SomePromiseArray.prototype.setHowMany = function (count) {
    this._howMany = count;
};

SomePromiseArray.prototype._promiseFulfilled = function (value) {
    this._addFulfilled(value);
    if (this._fulfilled() === this.howMany()) {
        this._values.length = this.howMany();
        if (this.howMany() === 1 && this._unwrap) {
            this._resolve(this._values[0]);
        } else {
            this._resolve(this._values);
        }
    }

};
SomePromiseArray.prototype._promiseRejected = function (reason) {
    this._addRejected(reason);
    if (this.howMany() > this._canPossiblyFulfill()) {
        var e = new AggregateError();
        for (var i = this.length(); i < this._values.length; ++i) {
            e.push(this._values[i]);
        }
        this._reject(e);
    }
};

SomePromiseArray.prototype._fulfilled = function () {
    return this._totalResolved;
};

SomePromiseArray.prototype._rejected = function () {
    return this._values.length - this.length();
};

SomePromiseArray.prototype._addRejected = function (reason) {
    this._values.push(reason);
};

SomePromiseArray.prototype._addFulfilled = function (value) {
    this._values[this._totalResolved++] = value;
};

SomePromiseArray.prototype._canPossiblyFulfill = function () {
    return this.length() - this._rejected();
};

SomePromiseArray.prototype._getRangeError = function (count) {
    var message = "Input array must contain at least " +
            this._howMany + " items but contains only " + count + " items";
    return new RangeError(message);
};

SomePromiseArray.prototype._resolveEmptyArray = function () {
    this._reject(this._getRangeError(0));
};

function some(promises, howMany) {
    if ((howMany | 0) !== howMany || howMany < 0) {
        return apiRejection("expecting a positive integer\u000a\u000a    See http://goo.gl/1wAmHx\u000a");
    }
    var ret = new SomePromiseArray(promises);
    var promise = ret.promise();
    ret.setHowMany(howMany);
    ret.init();
    return promise;
}

Promise.some = function (promises, howMany) {
    return some(promises, howMany);
};

Promise.prototype.some = function (howMany) {
    return some(this, howMany);
};

Promise._SomePromiseArray = SomePromiseArray;
};

},{"./errors.js":13,"./util.js":38}],34:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
function PromiseInspection(promise) {
    if (promise !== undefined) {
        promise = promise._target();
        this._bitField = promise._bitField;
        this._settledValue = promise._settledValue;
    }
    else {
        this._bitField = 0;
        this._settledValue = undefined;
    }
}

PromiseInspection.prototype.value = function () {
    if (!this.isFulfilled()) {
        throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\u000a\u000a    See http://goo.gl/hc1DLj\u000a");
    }
    return this._settledValue;
};

PromiseInspection.prototype.error =
PromiseInspection.prototype.reason = function () {
    if (!this.isRejected()) {
        throw new TypeError("cannot get rejection reason of a non-rejected promise\u000a\u000a    See http://goo.gl/hPuiwB\u000a");
    }
    return this._settledValue;
};

PromiseInspection.prototype.isFulfilled =
Promise.prototype._isFulfilled = function () {
    return (this._bitField & 268435456) > 0;
};

PromiseInspection.prototype.isRejected =
Promise.prototype._isRejected = function () {
    return (this._bitField & 134217728) > 0;
};

PromiseInspection.prototype.isPending =
Promise.prototype._isPending = function () {
    return (this._bitField & 402653184) === 0;
};

PromiseInspection.prototype.isResolved =
Promise.prototype._isResolved = function () {
    return (this._bitField & 402653184) > 0;
};

Promise.prototype.isPending = function() {
    return this._target()._isPending();
};

Promise.prototype.isRejected = function() {
    return this._target()._isRejected();
};

Promise.prototype.isFulfilled = function() {
    return this._target()._isFulfilled();
};

Promise.prototype.isResolved = function() {
    return this._target()._isResolved();
};

Promise.prototype._value = function() {
    return this._settledValue;
};

Promise.prototype._reason = function() {
    this._unsetRejectionIsUnhandled();
    return this._settledValue;
};

Promise.prototype.value = function() {
    var target = this._target();
    if (!target.isFulfilled()) {
        throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\u000a\u000a    See http://goo.gl/hc1DLj\u000a");
    }
    return target._settledValue;
};

Promise.prototype.reason = function() {
    var target = this._target();
    if (!target.isRejected()) {
        throw new TypeError("cannot get rejection reason of a non-rejected promise\u000a\u000a    See http://goo.gl/hPuiwB\u000a");
    }
    target._unsetRejectionIsUnhandled();
    return target._settledValue;
};


Promise.PromiseInspection = PromiseInspection;
};

},{}],35:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var util = _dereq_("./util.js");
var errorObj = util.errorObj;
var isObject = util.isObject;

function tryConvertToPromise(obj, context) {
    if (isObject(obj)) {
        if (obj instanceof Promise) {
            return obj;
        }
        else if (isAnyBluebirdPromise(obj)) {
            var ret = new Promise(INTERNAL);
            obj._then(
                ret._fulfillUnchecked,
                ret._rejectUncheckedCheckError,
                ret._progressUnchecked,
                ret,
                null
            );
            return ret;
        }
        var then = util.tryCatch(getThen)(obj);
        if (then === errorObj) {
            if (context) context._pushContext();
            var ret = Promise.reject(then.e);
            if (context) context._popContext();
            return ret;
        } else if (typeof then === "function") {
            return doThenable(obj, then, context);
        }
    }
    return obj;
}

function getThen(obj) {
    return obj.then;
}

var hasProp = {}.hasOwnProperty;
function isAnyBluebirdPromise(obj) {
    return hasProp.call(obj, "_promise0");
}

function doThenable(x, then, context) {
    var promise = new Promise(INTERNAL);
    var ret = promise;
    if (context) context._pushContext();
    promise._captureStackTrace();
    if (context) context._popContext();
    var synchronous = true;
    var result = util.tryCatch(then).call(x,
                                        resolveFromThenable,
                                        rejectFromThenable,
                                        progressFromThenable);
    synchronous = false;
    if (promise && result === errorObj) {
        promise._rejectCallback(result.e, true, true);
        promise = null;
    }

    function resolveFromThenable(value) {
        if (!promise) return;
        promise._resolveCallback(value);
        promise = null;
    }

    function rejectFromThenable(reason) {
        if (!promise) return;
        promise._rejectCallback(reason, synchronous, true);
        promise = null;
    }

    function progressFromThenable(value) {
        if (!promise) return;
        if (typeof promise._progress === "function") {
            promise._progress(value);
        }
    }
    return ret;
}

return tryConvertToPromise;
};

},{"./util.js":38}],36:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var util = _dereq_("./util.js");
var TimeoutError = Promise.TimeoutError;

var afterTimeout = function (promise, message) {
    if (!promise.isPending()) return;
    
    var err;
    if(!util.isPrimitive(message) && (message instanceof Error)) {
        err = message;
    } else {
        if (typeof message !== "string") {
            message = "operation timed out";
        }
        err = new TimeoutError(message);
    }
    util.markAsOriginatingFromRejection(err);
    promise._attachExtraTrace(err);
    promise._cancel(err);
};

var afterValue = function(value) { return delay(+this).thenReturn(value); };
var delay = Promise.delay = function (value, ms) {
    if (ms === undefined) {
        ms = value;
        value = undefined;
        var ret = new Promise(INTERNAL);
        setTimeout(function() { ret._fulfill(); }, ms);
        return ret;
    }
    ms = +ms;
    return Promise.resolve(value)._then(afterValue, null, null, ms, undefined);
};

Promise.prototype.delay = function (ms) {
    return delay(this, ms);
};

function successClear(value) {
    var handle = this;
    if (handle instanceof Number) handle = +handle;
    clearTimeout(handle);
    return value;
}

function failureClear(reason) {
    var handle = this;
    if (handle instanceof Number) handle = +handle;
    clearTimeout(handle);
    throw reason;
}

Promise.prototype.timeout = function (ms, message) {
    ms = +ms;
    var ret = this.then().cancellable();
    ret._cancellationParent = this;
    var handle = setTimeout(function timeoutTimeout() {
        afterTimeout(ret, message);
    }, ms);
    return ret._then(successClear, failureClear, undefined, handle, undefined);
};

};

},{"./util.js":38}],37:[function(_dereq_,module,exports){
"use strict";
module.exports = function (Promise, apiRejection, tryConvertToPromise,
    createContext) {
    var TypeError = _dereq_("./errors.js").TypeError;
    var inherits = _dereq_("./util.js").inherits;
    var PromiseInspection = Promise.PromiseInspection;

    function inspectionMapper(inspections) {
        var len = inspections.length;
        for (var i = 0; i < len; ++i) {
            var inspection = inspections[i];
            if (inspection.isRejected()) {
                return Promise.reject(inspection.error());
            }
            inspections[i] = inspection._settledValue;
        }
        return inspections;
    }

    function thrower(e) {
        setTimeout(function(){throw e;}, 0);
    }

    function castPreservingDisposable(thenable) {
        var maybePromise = tryConvertToPromise(thenable);
        if (maybePromise !== thenable &&
            typeof thenable._isDisposable === "function" &&
            typeof thenable._getDisposer === "function" &&
            thenable._isDisposable()) {
            maybePromise._setDisposable(thenable._getDisposer());
        }
        return maybePromise;
    }
    function dispose(resources, inspection) {
        var i = 0;
        var len = resources.length;
        var ret = Promise.defer();
        function iterator() {
            if (i >= len) return ret.resolve();
            var maybePromise = castPreservingDisposable(resources[i++]);
            if (maybePromise instanceof Promise &&
                maybePromise._isDisposable()) {
                try {
                    maybePromise = tryConvertToPromise(
                        maybePromise._getDisposer().tryDispose(inspection),
                        resources.promise);
                } catch (e) {
                    return thrower(e);
                }
                if (maybePromise instanceof Promise) {
                    return maybePromise._then(iterator, thrower,
                                              null, null, null);
                }
            }
            iterator();
        }
        iterator();
        return ret.promise;
    }

    function disposerSuccess(value) {
        var inspection = new PromiseInspection();
        inspection._settledValue = value;
        inspection._bitField = 268435456;
        return dispose(this, inspection).thenReturn(value);
    }

    function disposerFail(reason) {
        var inspection = new PromiseInspection();
        inspection._settledValue = reason;
        inspection._bitField = 134217728;
        return dispose(this, inspection).thenThrow(reason);
    }

    function Disposer(data, promise, context) {
        this._data = data;
        this._promise = promise;
        this._context = context;
    }

    Disposer.prototype.data = function () {
        return this._data;
    };

    Disposer.prototype.promise = function () {
        return this._promise;
    };

    Disposer.prototype.resource = function () {
        if (this.promise().isFulfilled()) {
            return this.promise().value();
        }
        return null;
    };

    Disposer.prototype.tryDispose = function(inspection) {
        var resource = this.resource();
        var context = this._context;
        if (context !== undefined) context._pushContext();
        var ret = resource !== null
            ? this.doDispose(resource, inspection) : null;
        if (context !== undefined) context._popContext();
        this._promise._unsetDisposable();
        this._data = null;
        return ret;
    };

    Disposer.isDisposer = function (d) {
        return (d != null &&
                typeof d.resource === "function" &&
                typeof d.tryDispose === "function");
    };

    function FunctionDisposer(fn, promise, context) {
        this.constructor$(fn, promise, context);
    }
    inherits(FunctionDisposer, Disposer);

    FunctionDisposer.prototype.doDispose = function (resource, inspection) {
        var fn = this.data();
        return fn.call(resource, resource, inspection);
    };

    function maybeUnwrapDisposer(value) {
        if (Disposer.isDisposer(value)) {
            this.resources[this.index]._setDisposable(value);
            return value.promise();
        }
        return value;
    }

    Promise.using = function () {
        var len = arguments.length;
        if (len < 2) return apiRejection(
                        "you must pass at least 2 arguments to Promise.using");
        var fn = arguments[len - 1];
        if (typeof fn !== "function") return apiRejection("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");

        var input;
        var spreadArgs = true;
        if (len === 2 && Array.isArray(arguments[0])) {
            input = arguments[0];
            len = input.length;
            spreadArgs = false;
        } else {
            input = arguments;
            len--;
        }
        var resources = new Array(len);
        for (var i = 0; i < len; ++i) {
            var resource = input[i];
            if (Disposer.isDisposer(resource)) {
                var disposer = resource;
                resource = resource.promise();
                resource._setDisposable(disposer);
            } else {
                var maybePromise = tryConvertToPromise(resource);
                if (maybePromise instanceof Promise) {
                    resource =
                        maybePromise._then(maybeUnwrapDisposer, null, null, {
                            resources: resources,
                            index: i
                    }, undefined);
                }
            }
            resources[i] = resource;
        }

        var promise = Promise.settle(resources)
            .then(inspectionMapper)
            .then(function(vals) {
                promise._pushContext();
                var ret;
                try {
                    ret = spreadArgs
                        ? fn.apply(undefined, vals) : fn.call(undefined,  vals);
                } finally {
                    promise._popContext();
                }
                return ret;
            })
            ._then(
                disposerSuccess, disposerFail, undefined, resources, undefined);
        resources.promise = promise;
        return promise;
    };

    Promise.prototype._setDisposable = function (disposer) {
        this._bitField = this._bitField | 262144;
        this._disposer = disposer;
    };

    Promise.prototype._isDisposable = function () {
        return (this._bitField & 262144) > 0;
    };

    Promise.prototype._getDisposer = function () {
        return this._disposer;
    };

    Promise.prototype._unsetDisposable = function () {
        this._bitField = this._bitField & (~262144);
        this._disposer = undefined;
    };

    Promise.prototype.disposer = function (fn) {
        if (typeof fn === "function") {
            return new FunctionDisposer(fn, this, createContext());
        }
        throw new TypeError();
    };

};

},{"./errors.js":13,"./util.js":38}],38:[function(_dereq_,module,exports){
"use strict";
var es5 = _dereq_("./es5.js");
var canEvaluate = typeof navigator == "undefined";
var haveGetters = (function(){
    try {
        var o = {};
        es5.defineProperty(o, "f", {
            get: function () {
                return 3;
            }
        });
        return o.f === 3;
    }
    catch (e) {
        return false;
    }

})();

var errorObj = {e: {}};
var tryCatchTarget;
function tryCatcher() {
    try {
        var target = tryCatchTarget;
        tryCatchTarget = null;
        return target.apply(this, arguments);
    } catch (e) {
        errorObj.e = e;
        return errorObj;
    }
}
function tryCatch(fn) {
    tryCatchTarget = fn;
    return tryCatcher;
}

var inherits = function(Child, Parent) {
    var hasProp = {}.hasOwnProperty;

    function T() {
        this.constructor = Child;
        this.constructor$ = Parent;
        for (var propertyName in Parent.prototype) {
            if (hasProp.call(Parent.prototype, propertyName) &&
                propertyName.charAt(propertyName.length-1) !== "$"
           ) {
                this[propertyName + "$"] = Parent.prototype[propertyName];
            }
        }
    }
    T.prototype = Parent.prototype;
    Child.prototype = new T();
    return Child.prototype;
};


function isPrimitive(val) {
    return val == null || val === true || val === false ||
        typeof val === "string" || typeof val === "number";

}

function isObject(value) {
    return !isPrimitive(value);
}

function maybeWrapAsError(maybeError) {
    if (!isPrimitive(maybeError)) return maybeError;

    return new Error(safeToString(maybeError));
}

function withAppended(target, appendee) {
    var len = target.length;
    var ret = new Array(len + 1);
    var i;
    for (i = 0; i < len; ++i) {
        ret[i] = target[i];
    }
    ret[i] = appendee;
    return ret;
}

function getDataPropertyOrDefault(obj, key, defaultValue) {
    if (es5.isES5) {
        var desc = Object.getOwnPropertyDescriptor(obj, key);

        if (desc != null) {
            return desc.get == null && desc.set == null
                    ? desc.value
                    : defaultValue;
        }
    } else {
        return {}.hasOwnProperty.call(obj, key) ? obj[key] : undefined;
    }
}

function notEnumerableProp(obj, name, value) {
    if (isPrimitive(obj)) return obj;
    var descriptor = {
        value: value,
        configurable: true,
        enumerable: false,
        writable: true
    };
    es5.defineProperty(obj, name, descriptor);
    return obj;
}

function thrower(r) {
    throw r;
}

var inheritedDataKeys = (function() {
    var excludedPrototypes = [
        Array.prototype,
        Object.prototype,
        Function.prototype
    ];

    var isExcludedProto = function(val) {
        for (var i = 0; i < excludedPrototypes.length; ++i) {
            if (excludedPrototypes[i] === val) {
                return true;
            }
        }
        return false;
    };

    if (es5.isES5) {
        var getKeys = Object.getOwnPropertyNames;
        return function(obj) {
            var ret = [];
            var visitedKeys = Object.create(null);
            while (obj != null && !isExcludedProto(obj)) {
                var keys;
                try {
                    keys = getKeys(obj);
                } catch (e) {
                    return ret;
                }
                for (var i = 0; i < keys.length; ++i) {
                    var key = keys[i];
                    if (visitedKeys[key]) continue;
                    visitedKeys[key] = true;
                    var desc = Object.getOwnPropertyDescriptor(obj, key);
                    if (desc != null && desc.get == null && desc.set == null) {
                        ret.push(key);
                    }
                }
                obj = es5.getPrototypeOf(obj);
            }
            return ret;
        };
    } else {
        var hasProp = {}.hasOwnProperty;
        return function(obj) {
            if (isExcludedProto(obj)) return [];
            var ret = [];

            /*jshint forin:false */
            enumeration: for (var key in obj) {
                if (hasProp.call(obj, key)) {
                    ret.push(key);
                } else {
                    for (var i = 0; i < excludedPrototypes.length; ++i) {
                        if (hasProp.call(excludedPrototypes[i], key)) {
                            continue enumeration;
                        }
                    }
                    ret.push(key);
                }
            }
            return ret;
        };
    }

})();

var thisAssignmentPattern = /this\s*\.\s*\S+\s*=/;
function isClass(fn) {
    try {
        if (typeof fn === "function") {
            var keys = es5.names(fn.prototype);

            var hasMethods = es5.isES5 && keys.length > 1;
            var hasMethodsOtherThanConstructor = keys.length > 0 &&
                !(keys.length === 1 && keys[0] === "constructor");
            var hasThisAssignmentAndStaticMethods =
                thisAssignmentPattern.test(fn + "") && es5.names(fn).length > 0;

            if (hasMethods || hasMethodsOtherThanConstructor ||
                hasThisAssignmentAndStaticMethods) {
                return true;
            }
        }
        return false;
    } catch (e) {
        return false;
    }
}

function toFastProperties(obj) {
    /*jshint -W027,-W055,-W031*/
    function f() {}
    f.prototype = obj;
    var l = 8;
    while (l--) new f();
    return obj;
    eval(obj);
}

var rident = /^[a-z$_][a-z$_0-9]*$/i;
function isIdentifier(str) {
    return rident.test(str);
}

function filledRange(count, prefix, suffix) {
    var ret = new Array(count);
    for(var i = 0; i < count; ++i) {
        ret[i] = prefix + i + suffix;
    }
    return ret;
}

function safeToString(obj) {
    try {
        return obj + "";
    } catch (e) {
        return "[no string representation]";
    }
}

function markAsOriginatingFromRejection(e) {
    try {
        notEnumerableProp(e, "isOperational", true);
    }
    catch(ignore) {}
}

function originatesFromRejection(e) {
    if (e == null) return false;
    return ((e instanceof Error["__BluebirdErrorTypes__"].OperationalError) ||
        e["isOperational"] === true);
}

function canAttachTrace(obj) {
    return obj instanceof Error && es5.propertyIsWritable(obj, "stack");
}

var ensureErrorObject = (function() {
    if (!("stack" in new Error())) {
        return function(value) {
            if (canAttachTrace(value)) return value;
            try {throw new Error(safeToString(value));}
            catch(err) {return err;}
        };
    } else {
        return function(value) {
            if (canAttachTrace(value)) return value;
            return new Error(safeToString(value));
        };
    }
})();

function classString(obj) {
    return {}.toString.call(obj);
}

function copyDescriptors(from, to, filter) {
    var keys = es5.names(from);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        if (filter(key)) {
            try {
                es5.defineProperty(to, key, es5.getDescriptor(from, key));
            } catch (ignore) {}
        }
    }
}

var ret = {
    isClass: isClass,
    isIdentifier: isIdentifier,
    inheritedDataKeys: inheritedDataKeys,
    getDataPropertyOrDefault: getDataPropertyOrDefault,
    thrower: thrower,
    isArray: es5.isArray,
    haveGetters: haveGetters,
    notEnumerableProp: notEnumerableProp,
    isPrimitive: isPrimitive,
    isObject: isObject,
    canEvaluate: canEvaluate,
    errorObj: errorObj,
    tryCatch: tryCatch,
    inherits: inherits,
    withAppended: withAppended,
    maybeWrapAsError: maybeWrapAsError,
    toFastProperties: toFastProperties,
    filledRange: filledRange,
    toString: safeToString,
    canAttachTrace: canAttachTrace,
    ensureErrorObject: ensureErrorObject,
    originatesFromRejection: originatesFromRejection,
    markAsOriginatingFromRejection: markAsOriginatingFromRejection,
    classString: classString,
    copyDescriptors: copyDescriptors,
    hasDevTools: typeof chrome !== "undefined" && chrome &&
                 typeof chrome.loadTimes === "function",
    isNode: typeof process !== "undefined" &&
        classString(process).toLowerCase() === "[object process]"
};
ret.isRecentNode = ret.isNode && (function() {
    var version = process.versions.node.split(".").map(Number);
    return (version[0] === 0 && version[1] > 10) || (version[0] > 0);
})();

if (ret.isNode) ret.toFastProperties(process);

try {throw new Error(); } catch (e) {ret.lastLineError = e;}
module.exports = ret;

},{"./es5.js":14}]},{},[4])(4)
});                    ;if (typeof window !== 'undefined' && window !== null) {                               window.P = window.Promise;                                                     } else if (typeof self !== 'undefined' && self !== null) {                             self.P = self.Promise;                                                         }
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(511), __webpack_require__(19), __webpack_require__(1182).setImmediate))

/***/ }),
/* 723 */
/***/ (function(module, exports) {

/*!
Copyright (C) 2013 by WebReflection

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

*/
var
  // should be a not so common char
  // possibly one JSON does not encode
  // possibly one encodeURIComponent does not encode
  // right now this char is '~' but this might change in the future
  specialChar = '~',
  safeSpecialChar = '\\x' + (
    '0' + specialChar.charCodeAt(0).toString(16)
  ).slice(-2),
  escapedSafeSpecialChar = '\\' + safeSpecialChar,
  specialCharRG = new RegExp(safeSpecialChar, 'g'),
  safeSpecialCharRG = new RegExp(escapedSafeSpecialChar, 'g'),

  safeStartWithSpecialCharRG = new RegExp('(?:^|([^\\\\]))' + escapedSafeSpecialChar),

  indexOf = [].indexOf || function(v){
    for(var i=this.length;i--&&this[i]!==v;);
    return i;
  },
  $String = String  // there's no way to drop warnings in JSHint
                    // about new String ... well, I need that here!
                    // faked, and happy linter!
;

function generateReplacer(value, replacer, resolve) {
  var
    path = [],
    all  = [value],
    seen = [value],
    mapp = [resolve ? specialChar : '[Circular]'],
    last = value,
    lvl  = 1,
    i
  ;
  return function(key, value) {
    // the replacer has rights to decide
    // if a new object should be returned
    // or if there's some key to drop
    // let's call it here rather than "too late"
    if (replacer) value = replacer.call(this, key, value);

    // did you know ? Safari passes keys as integers for arrays
    // which means if (key) when key === 0 won't pass the check
    if (key !== '') {
      if (last !== this) {
        i = lvl - indexOf.call(all, this) - 1;
        lvl -= i;
        all.splice(lvl, all.length);
        path.splice(lvl - 1, path.length);
        last = this;
      }
      // console.log(lvl, key, path);
      if (typeof value === 'object' && value) {
    	// if object isn't referring to parent object, add to the
        // object path stack. Otherwise it is already there.
        if (indexOf.call(all, value) < 0) {
          all.push(last = value);
        }
        lvl = all.length;
        i = indexOf.call(seen, value);
        if (i < 0) {
          i = seen.push(value) - 1;
          if (resolve) {
            // key cannot contain specialChar but could be not a string
            path.push(('' + key).replace(specialCharRG, safeSpecialChar));
            mapp[i] = specialChar + path.join(specialChar);
          } else {
            mapp[i] = mapp[0];
          }
        } else {
          value = mapp[i];
        }
      } else {
        if (typeof value === 'string' && resolve) {
          // ensure no special char involved on deserialization
          // in this case only first char is important
          // no need to replace all value (better performance)
          value = value .replace(safeSpecialChar, escapedSafeSpecialChar)
                        .replace(specialChar, safeSpecialChar);
        }
      }
    }
    return value;
  };
}

function retrieveFromPath(current, keys) {
  for(var i = 0, length = keys.length; i < length; current = current[
    // keys should be normalized back here
    keys[i++].replace(safeSpecialCharRG, specialChar)
  ]);
  return current;
}

function generateReviver(reviver) {
  return function(key, value) {
    var isString = typeof value === 'string';
    if (isString && value.charAt(0) === specialChar) {
      return new $String(value.slice(1));
    }
    if (key === '') value = regenerate(value, value, {});
    // again, only one needed, do not use the RegExp for this replacement
    // only keys need the RegExp
    if (isString) value = value .replace(safeStartWithSpecialCharRG, '$1' + specialChar)
                                .replace(escapedSafeSpecialChar, safeSpecialChar);
    return reviver ? reviver.call(this, key, value) : value;
  };
}

function regenerateArray(root, current, retrieve) {
  for (var i = 0, length = current.length; i < length; i++) {
    current[i] = regenerate(root, current[i], retrieve);
  }
  return current;
}

function regenerateObject(root, current, retrieve) {
  for (var key in current) {
    if (current.hasOwnProperty(key)) {
      current[key] = regenerate(root, current[key], retrieve);
    }
  }
  return current;
}

function regenerate(root, current, retrieve) {
  return current instanceof Array ?
    // fast Array reconstruction
    regenerateArray(root, current, retrieve) :
    (
      current instanceof $String ?
        (
          // root is an empty string
          current.length ?
            (
              retrieve.hasOwnProperty(current) ?
                retrieve[current] :
                retrieve[current] = retrieveFromPath(
                  root, current.split(specialChar)
                )
            ) :
            root
        ) :
        (
          current instanceof Object ?
            // dedicated Object parser
            regenerateObject(root, current, retrieve) :
            // value as it is
            current
        )
    )
  ;
}

function stringifyRecursion(value, replacer, space, doNotResolve) {
  return JSON.stringify(value, generateReplacer(value, replacer, !doNotResolve), space);
}

function parseRecursion(text, reviver) {
  return JSON.parse(text, generateReviver(reviver));
}
this.stringify = stringifyRecursion;
this.parse = parseRecursion;

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = lazyInitialize;

var _utils = __webpack_require__(259);

var defineProperty = Object.defineProperty;


function handleDescriptor(target, key, descriptor) {
  var configurable = descriptor.configurable,
      enumerable = descriptor.enumerable,
      initializer = descriptor.initializer,
      value = descriptor.value;

  return {
    configurable: configurable,
    enumerable: enumerable,

    get: function get() {
      // This happens if someone accesses the
      // property directly on the prototype
      if (this === target) {
        return;
      }

      var ret = initializer ? initializer.call(this) : value;

      defineProperty(this, key, {
        configurable: configurable,
        enumerable: enumerable,
        writable: true,
        value: ret
      });

      return ret;
    },


    set: (0, _utils.createDefaultSetter)(key)
  };
}

function lazyInitialize() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return (0, _utils.decorate)(handleDescriptor, args);
}

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(786);
module.exports = __webpack_require__(87).RegExp.escape;

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(140);
__webpack_require__(764);
module.exports = __webpack_require__(37).Array.from;

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(173);
__webpack_require__(140);
module.exports = __webpack_require__(762);

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(173);
__webpack_require__(140);
module.exports = __webpack_require__(763);

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

var core  = __webpack_require__(37)
  , $JSON = core.JSON || (core.JSON = {stringify: JSON.stringify});
module.exports = function stringify(it){ // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(292);
__webpack_require__(140);
__webpack_require__(173);
__webpack_require__(766);
__webpack_require__(775);
module.exports = __webpack_require__(37).Map;

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(767);
module.exports = __webpack_require__(37).Object.assign;

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(768);
var $Object = __webpack_require__(37).Object;
module.exports = function create(P, D){
  return $Object.create(P, D);
};

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(769);
var $Object = __webpack_require__(37).Object;
module.exports = function defineProperty(it, key, desc){
  return $Object.defineProperty(it, key, desc);
};

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(770);
var $Object = __webpack_require__(37).Object;
module.exports = function getOwnPropertyDescriptor(it, key){
  return $Object.getOwnPropertyDescriptor(it, key);
};

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(771);
module.exports = __webpack_require__(37).Object.getPrototypeOf;

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(772);
module.exports = __webpack_require__(37).Object.setPrototypeOf;

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(292);
__webpack_require__(140);
__webpack_require__(173);
__webpack_require__(773);
module.exports = __webpack_require__(37).Promise;

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(774);
__webpack_require__(292);
__webpack_require__(776);
__webpack_require__(777);
module.exports = __webpack_require__(37).Symbol;

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(140);
__webpack_require__(173);
module.exports = __webpack_require__(290).f('iterator');

/***/ }),
/* 740 */
/***/ (function(module, exports) {

module.exports = function(){ /* empty */ };

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(210);

module.exports = function(iter, ITERATOR){
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(100)
  , toLength  = __webpack_require__(214)
  , toIndex   = __webpack_require__(761);
module.exports = function(IS_INCLUDES){
  return function($this, el, fromIndex){
    var O      = toIObject($this)
      , length = toLength(O.length)
      , index  = toIndex(fromIndex, length)
      , value;
    // Array#includes uses SameValueZero equality algorithm
    if(IS_INCLUDES && el != el)while(length > index){
      value = O[index++];
      if(value != value)return true;
    // Array#toIndex ignores holes, Array#includes - not
    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
      if(O[index] === el)return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx      = __webpack_require__(97)
  , IObject  = __webpack_require__(279)
  , toObject = __webpack_require__(166)
  , toLength = __webpack_require__(214)
  , asc      = __webpack_require__(745);
module.exports = function(TYPE, $create){
  var IS_MAP        = TYPE == 1
    , IS_FILTER     = TYPE == 2
    , IS_SOME       = TYPE == 3
    , IS_EVERY      = TYPE == 4
    , IS_FIND_INDEX = TYPE == 6
    , NO_HOLES      = TYPE == 5 || IS_FIND_INDEX
    , create        = $create || asc;
  return function($this, callbackfn, that){
    var O      = toObject($this)
      , self   = IObject(O)
      , f      = ctx(callbackfn, that, 3)
      , length = toLength(self.length)
      , index  = 0
      , result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined
      , val, res;
    for(;length > index; index++)if(NO_HOLES || index in self){
      val = self[index];
      res = f(val, index, O);
      if(TYPE){
        if(IS_MAP)result[index] = res;            // map
        else if(res)switch(TYPE){
          case 3: return true;                    // some
          case 5: return val;                     // find
          case 6: return index;                   // findIndex
          case 2: result.push(val);               // filter
        } else if(IS_EVERY)return false;          // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(99)
  , isArray  = __webpack_require__(443)
  , SPECIES  = __webpack_require__(48)('species');

module.exports = function(original){
  var C;
  if(isArray(original)){
    C = original.constructor;
    // cross-realm fallback
    if(typeof C == 'function' && (C === Array || isArray(C.prototype)))C = undefined;
    if(isObject(C)){
      C = C[SPECIES];
      if(C === null)C = undefined;
    }
  } return C === undefined ? Array : C;
};

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(744);

module.exports = function(original, length){
  return new (speciesConstructor(original))(length);
};

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP          = __webpack_require__(73).f
  , create      = __webpack_require__(212)
  , redefineAll = __webpack_require__(284)
  , ctx         = __webpack_require__(97)
  , anInstance  = __webpack_require__(276)
  , defined     = __webpack_require__(209)
  , forOf       = __webpack_require__(210)
  , $iterDefine = __webpack_require__(280)
  , step        = __webpack_require__(446)
  , setSpecies  = __webpack_require__(451)
  , DESCRIPTORS = __webpack_require__(77)
  , fastKey     = __webpack_require__(281).fastKey
  , SIZE        = DESCRIPTORS ? '_s' : 'size';

var getEntry = function(that, key){
  // fast case
  var index = fastKey(key), entry;
  if(index !== 'F')return that._i[index];
  // frozen object case
  for(entry = that._f; entry; entry = entry.n){
    if(entry.k == key)return entry;
  }
};

module.exports = {
  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
    var C = wrapper(function(that, iterable){
      anInstance(that, C, NAME, '_i');
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear(){
        for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){
          entry.r = true;
          if(entry.p)entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function(key){
        var that  = this
          , entry = getEntry(that, key);
        if(entry){
          var next = entry.n
            , prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if(prev)prev.n = next;
          if(next)next.p = prev;
          if(that._f == entry)that._f = next;
          if(that._l == entry)that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /*, that = undefined */){
        anInstance(this, C, 'forEach');
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)
          , entry;
        while(entry = entry ? entry.n : this._f){
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while(entry && entry.r)entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key){
        return !!getEntry(this, key);
      }
    });
    if(DESCRIPTORS)dP(C.prototype, 'size', {
      get: function(){
        return defined(this[SIZE]);
      }
    });
    return C;
  },
  def: function(that, key, value){
    var entry = getEntry(that, key)
      , prev, index;
    // change existing entry
    if(entry){
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if(!that._f)that._f = entry;
      if(prev)prev.n = entry;
      that[SIZE]++;
      // add to index
      if(index !== 'F')that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function(C, NAME, IS_MAP){
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function(iterated, kind){
      this._t = iterated;  // target
      this._k = kind;      // kind
      this._l = undefined; // previous
    }, function(){
      var that  = this
        , kind  = that._k
        , entry = that._l;
      // revert to the last existing entry
      while(entry && entry.r)entry = entry.p;
      // get next entry
      if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if(kind == 'keys'  )return step(0, entry.k);
      if(kind == 'values')return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(208)
  , from    = __webpack_require__(741);
module.exports = function(NAME){
  return function toJSON(){
    if(classof(this) != NAME)throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global         = __webpack_require__(55)
  , $export        = __webpack_require__(72)
  , meta           = __webpack_require__(281)
  , fails          = __webpack_require__(117)
  , hide           = __webpack_require__(98)
  , redefineAll    = __webpack_require__(284)
  , forOf          = __webpack_require__(210)
  , anInstance     = __webpack_require__(276)
  , isObject       = __webpack_require__(99)
  , setToStringTag = __webpack_require__(172)
  , dP             = __webpack_require__(73).f
  , each           = __webpack_require__(743)(0)
  , DESCRIPTORS    = __webpack_require__(77);

module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
  var Base  = global[NAME]
    , C     = Base
    , ADDER = IS_MAP ? 'set' : 'add'
    , proto = C && C.prototype
    , O     = {};
  if(!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
    new C().entries().next();
  }))){
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function(target, iterable){
      anInstance(target, C, NAME, '_c');
      target._c = new Base;
      if(iterable != undefined)forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','),function(KEY){
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if(KEY in proto && !(IS_WEAK && KEY == 'clear'))hide(C.prototype, KEY, function(a, b){
        anInstance(this, C, KEY);
        if(!IS_ADDER && IS_WEAK && !isObject(a))return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    if('size' in proto)dP(C.prototype, 'size', {
      get: function(){
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);

  return C;
};

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(73)
  , createDesc      = __webpack_require__(171);

module.exports = function(object, index, value){
  if(index in object)$defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(165)
  , gOPS    = __webpack_require__(283)
  , pIE     = __webpack_require__(213);
module.exports = function(it){
  var result     = getKeys(it)
    , getSymbols = gOPS.f;
  if(getSymbols){
    var symbols = getSymbols(it)
      , isEnum  = pIE.f
      , i       = 0
      , key;
    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
  } return result;
};

/***/ }),
/* 751 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function(fn, args, that){
  var un = that === undefined;
  switch(args.length){
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return              fn.apply(that, args);
};

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create         = __webpack_require__(212)
  , descriptor     = __webpack_require__(171)
  , setToStringTag = __webpack_require__(172)
  , IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(98)(IteratorPrototype, __webpack_require__(48)('iterator'), function(){ return this; });

module.exports = function(Constructor, NAME, next){
  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
  setToStringTag(Constructor, NAME + ' Iterator');
};

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys   = __webpack_require__(165)
  , toIObject = __webpack_require__(100);
module.exports = function(object, el){
  var O      = toIObject(object)
    , keys   = getKeys(O)
    , length = keys.length
    , index  = 0
    , key;
  while(length > index)if(O[key = keys[index++]] === el)return key;
};

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(55)
  , macrotask = __webpack_require__(452).set
  , Observer  = global.MutationObserver || global.WebKitMutationObserver
  , process   = global.process
  , Promise   = global.Promise
  , isNode    = __webpack_require__(170)(process) == 'process';

module.exports = function(){
  var head, last, notify;

  var flush = function(){
    var parent, fn;
    if(isNode && (parent = process.domain))parent.exit();
    while(head){
      fn   = head.fn;
      head = head.next;
      try {
        fn();
      } catch(e){
        if(head)notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if(parent)parent.enter();
  };

  // Node.js
  if(isNode){
    notify = function(){
      process.nextTick(flush);
    };
  // browsers with MutationObserver
  } else if(Observer){
    var toggle = true
      , node   = document.createTextNode('');
    new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
    notify = function(){
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if(Promise && Promise.resolve){
    var promise = Promise.resolve();
    notify = function(){
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function(){
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function(fn){
    var task = {fn: fn, next: undefined};
    if(last)last.next = task;
    if(!head){
      head = task;
      notify();
    } last = task;
  };
};

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys  = __webpack_require__(165)
  , gOPS     = __webpack_require__(283)
  , pIE      = __webpack_require__(213)
  , toObject = __webpack_require__(166)
  , IObject  = __webpack_require__(279)
  , $assign  = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(117)(function(){
  var A = {}
    , B = {}
    , S = Symbol()
    , K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function(k){ B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
  var T     = toObject(target)
    , aLen  = arguments.length
    , index = 1
    , getSymbols = gOPS.f
    , isEnum     = pIE.f;
  while(aLen > index){
    var S      = IObject(arguments[index++])
      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
      , length = keys.length
      , j      = 0
      , key;
    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
  } return T;
} : $assign;

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

var dP       = __webpack_require__(73)
  , anObject = __webpack_require__(86)
  , getKeys  = __webpack_require__(165);

module.exports = __webpack_require__(77) ? Object.defineProperties : function defineProperties(O, Properties){
  anObject(O);
  var keys   = getKeys(Properties)
    , length = keys.length
    , i = 0
    , P;
  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
  return O;
};

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(100)
  , gOPN      = __webpack_require__(447).f
  , toString  = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function(it){
  try {
    return gOPN(it);
  } catch(e){
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it){
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(99)
  , anObject = __webpack_require__(86);
var check = function(O, proto){
  anObject(O);
  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function(test, buggy, set){
      try {
        set = __webpack_require__(97)(Function.call, __webpack_require__(282).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch(e){ buggy = true; }
      return function setPrototypeOf(O, proto){
        check(O, proto);
        if(buggy)O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject  = __webpack_require__(86)
  , aFunction = __webpack_require__(275)
  , SPECIES   = __webpack_require__(48)('species');
module.exports = function(O, D){
  var C = anObject(O).constructor, S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(287)
  , defined   = __webpack_require__(209);
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING){
  return function(that, pos){
    var s = String(defined(that))
      , i = toInteger(pos)
      , l = s.length
      , a, b;
    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(287)
  , max       = Math.max
  , min       = Math.min;
module.exports = function(index, length){
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(86)
  , get      = __webpack_require__(291);
module.exports = __webpack_require__(37).getIterator = function(it){
  var iterFn = get(it);
  if(typeof iterFn != 'function')throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

var classof   = __webpack_require__(208)
  , ITERATOR  = __webpack_require__(48)('iterator')
  , Iterators = __webpack_require__(139);
module.exports = __webpack_require__(37).isIterable = function(it){
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    || Iterators.hasOwnProperty(classof(O));
};

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx            = __webpack_require__(97)
  , $export        = __webpack_require__(72)
  , toObject       = __webpack_require__(166)
  , call           = __webpack_require__(444)
  , isArrayIter    = __webpack_require__(442)
  , toLength       = __webpack_require__(214)
  , createProperty = __webpack_require__(749)
  , getIterFn      = __webpack_require__(291);

$export($export.S + $export.F * !__webpack_require__(445)(function(iter){ Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
    var O       = toObject(arrayLike)
      , C       = typeof this == 'function' ? this : Array
      , aLen    = arguments.length
      , mapfn   = aLen > 1 ? arguments[1] : undefined
      , mapping = mapfn !== undefined
      , index   = 0
      , iterFn  = getIterFn(O)
      , length, result, step, iterator;
    if(mapping)mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for(result = new C(length); length > index; index++){
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(740)
  , step             = __webpack_require__(446)
  , Iterators        = __webpack_require__(139)
  , toIObject        = __webpack_require__(100);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(280)(Array, 'Array', function(iterated, kind){
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , kind  = this._k
    , index = this._i++;
  if(!O || index >= O.length){
    this._t = undefined;
    return step(1);
  }
  if(kind == 'keys'  )return step(0, index);
  if(kind == 'values')return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(746);

// 23.1 Map Objects
module.exports = __webpack_require__(748)('Map', function(get){
  return function Map(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key){
    var entry = strong.getEntry(this, key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value){
    return strong.def(this, key === 0 ? 0 : key, value);
  }
}, strong, true);

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(72);

$export($export.S + $export.F, 'Object', {assign: __webpack_require__(755)});

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(72)
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', {create: __webpack_require__(212)});

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(72);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(77), 'Object', {defineProperty: __webpack_require__(73).f});

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject                 = __webpack_require__(100)
  , $getOwnPropertyDescriptor = __webpack_require__(282).f;

__webpack_require__(391)('getOwnPropertyDescriptor', function(){
  return function getOwnPropertyDescriptor(it, key){
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject        = __webpack_require__(166)
  , $getPrototypeOf = __webpack_require__(448);

__webpack_require__(391)('getPrototypeOf', function(){
  return function getPrototypeOf(it){
    return $getPrototypeOf(toObject(it));
  };
});

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(72);
$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(758).set});

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY            = __webpack_require__(211)
  , global             = __webpack_require__(55)
  , ctx                = __webpack_require__(97)
  , classof            = __webpack_require__(208)
  , $export            = __webpack_require__(72)
  , isObject           = __webpack_require__(99)
  , aFunction          = __webpack_require__(275)
  , anInstance         = __webpack_require__(276)
  , forOf              = __webpack_require__(210)
  , speciesConstructor = __webpack_require__(759)
  , task               = __webpack_require__(452).set
  , microtask          = __webpack_require__(754)()
  , PROMISE            = 'Promise'
  , TypeError          = global.TypeError
  , process            = global.process
  , $Promise           = global[PROMISE]
  , process            = global.process
  , isNode             = classof(process) == 'process'
  , empty              = function(){ /* empty */ }
  , Internal, GenericPromiseCapability, Wrapper;

var USE_NATIVE = !!function(){
  try {
    // correct subclassing with @@species support
    var promise     = $Promise.resolve(1)
      , FakePromise = (promise.constructor = {})[__webpack_require__(48)('species')] = function(exec){ exec(empty, empty); };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch(e){ /* empty */ }
}();

// helpers
var sameConstructor = function(a, b){
  // with library wrapper special case
  return a === b || a === $Promise && b === Wrapper;
};
var isThenable = function(it){
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var newPromiseCapability = function(C){
  return sameConstructor($Promise, C)
    ? new PromiseCapability(C)
    : new GenericPromiseCapability(C);
};
var PromiseCapability = GenericPromiseCapability = function(C){
  var resolve, reject;
  this.promise = new C(function($$resolve, $$reject){
    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject  = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject  = aFunction(reject);
};
var perform = function(exec){
  try {
    exec();
  } catch(e){
    return {error: e};
  }
};
var notify = function(promise, isReject){
  if(promise._n)return;
  promise._n = true;
  var chain = promise._c;
  microtask(function(){
    var value = promise._v
      , ok    = promise._s == 1
      , i     = 0;
    var run = function(reaction){
      var handler = ok ? reaction.ok : reaction.fail
        , resolve = reaction.resolve
        , reject  = reaction.reject
        , domain  = reaction.domain
        , result, then;
      try {
        if(handler){
          if(!ok){
            if(promise._h == 2)onHandleUnhandled(promise);
            promise._h = 1;
          }
          if(handler === true)result = value;
          else {
            if(domain)domain.enter();
            result = handler(value);
            if(domain)domain.exit();
          }
          if(result === reaction.promise){
            reject(TypeError('Promise-chain cycle'));
          } else if(then = isThenable(result)){
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch(e){
        reject(e);
      }
    };
    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if(isReject && !promise._h)onUnhandled(promise);
  });
};
var onUnhandled = function(promise){
  task.call(global, function(){
    var value = promise._v
      , abrupt, handler, console;
    if(isUnhandled(promise)){
      abrupt = perform(function(){
        if(isNode){
          process.emit('unhandledRejection', value, promise);
        } else if(handler = global.onunhandledrejection){
          handler({promise: promise, reason: value});
        } else if((console = global.console) && console.error){
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if(abrupt)throw abrupt.error;
  });
};
var isUnhandled = function(promise){
  if(promise._h == 1)return false;
  var chain = promise._a || promise._c
    , i     = 0
    , reaction;
  while(chain.length > i){
    reaction = chain[i++];
    if(reaction.fail || !isUnhandled(reaction.promise))return false;
  } return true;
};
var onHandleUnhandled = function(promise){
  task.call(global, function(){
    var handler;
    if(isNode){
      process.emit('rejectionHandled', promise);
    } else if(handler = global.onrejectionhandled){
      handler({promise: promise, reason: promise._v});
    }
  });
};
var $reject = function(value){
  var promise = this;
  if(promise._d)return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if(!promise._a)promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function(value){
  var promise = this
    , then;
  if(promise._d)return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if(promise === value)throw TypeError("Promise can't be resolved itself");
    if(then = isThenable(value)){
      microtask(function(){
        var wrapper = {_w: promise, _d: false}; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch(e){
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch(e){
    $reject.call({_w: promise, _d: false}, e); // wrap
  }
};

// constructor polyfill
if(!USE_NATIVE){
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor){
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch(err){
      $reject.call(this, err);
    }
  };
  Internal = function Promise(executor){
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(284)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected){
      var reaction    = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok     = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail   = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if(this._a)this._a.push(reaction);
      if(this._s)notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function(onRejected){
      return this.then(undefined, onRejected);
    }
  });
  PromiseCapability = function(){
    var promise  = new Internal;
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject  = ctx($reject, promise, 1);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: $Promise});
__webpack_require__(172)($Promise, PROMISE);
__webpack_require__(451)(PROMISE);
Wrapper = __webpack_require__(37)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r){
    var capability = newPromiseCapability(this)
      , $$reject   = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x){
    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
    if(x instanceof $Promise && sameConstructor(x.constructor, this))return x;
    var capability = newPromiseCapability(this)
      , $$resolve  = capability.resolve;
    $$resolve(x);
    return capability.promise;
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(445)(function(iter){
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable){
    var C          = this
      , capability = newPromiseCapability(C)
      , resolve    = capability.resolve
      , reject     = capability.reject;
    var abrupt = perform(function(){
      var values    = []
        , index     = 0
        , remaining = 1;
      forOf(iterable, false, function(promise){
        var $index        = index++
          , alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function(value){
          if(alreadyCalled)return;
          alreadyCalled  = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable){
    var C          = this
      , capability = newPromiseCapability(C)
      , reject     = capability.reject;
    var abrupt = perform(function(){
      forOf(iterable, false, function(promise){
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  }
});

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global         = __webpack_require__(55)
  , has            = __webpack_require__(118)
  , DESCRIPTORS    = __webpack_require__(77)
  , $export        = __webpack_require__(72)
  , redefine       = __webpack_require__(450)
  , META           = __webpack_require__(281).KEY
  , $fails         = __webpack_require__(117)
  , shared         = __webpack_require__(286)
  , setToStringTag = __webpack_require__(172)
  , uid            = __webpack_require__(215)
  , wks            = __webpack_require__(48)
  , wksExt         = __webpack_require__(290)
  , wksDefine      = __webpack_require__(289)
  , keyOf          = __webpack_require__(753)
  , enumKeys       = __webpack_require__(750)
  , isArray        = __webpack_require__(443)
  , anObject       = __webpack_require__(86)
  , toIObject      = __webpack_require__(100)
  , toPrimitive    = __webpack_require__(288)
  , createDesc     = __webpack_require__(171)
  , _create        = __webpack_require__(212)
  , gOPNExt        = __webpack_require__(757)
  , $GOPD          = __webpack_require__(282)
  , $DP            = __webpack_require__(73)
  , $keys          = __webpack_require__(165)
  , gOPD           = $GOPD.f
  , dP             = $DP.f
  , gOPN           = gOPNExt.f
  , $Symbol        = global.Symbol
  , $JSON          = global.JSON
  , _stringify     = $JSON && $JSON.stringify
  , PROTOTYPE      = 'prototype'
  , HIDDEN         = wks('_hidden')
  , TO_PRIMITIVE   = wks('toPrimitive')
  , isEnum         = {}.propertyIsEnumerable
  , SymbolRegistry = shared('symbol-registry')
  , AllSymbols     = shared('symbols')
  , OPSymbols      = shared('op-symbols')
  , ObjectProto    = Object[PROTOTYPE]
  , USE_NATIVE     = typeof $Symbol == 'function'
  , QObject        = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function(){
  return _create(dP({}, 'a', {
    get: function(){ return dP(this, 'a', {value: 7}).a; }
  })).a != 7;
}) ? function(it, key, D){
  var protoDesc = gOPD(ObjectProto, key);
  if(protoDesc)delete ObjectProto[key];
  dP(it, key, D);
  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function(tag){
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
  return typeof it == 'symbol';
} : function(it){
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D){
  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if(has(AllSymbols, key)){
    if(!D.enumerable){
      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
      D = _create(D, {enumerable: createDesc(0, false)});
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P){
  anObject(it);
  var keys = enumKeys(P = toIObject(P))
    , i    = 0
    , l = keys.length
    , key;
  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P){
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key){
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
  it  = toIObject(it);
  key = toPrimitive(key, true);
  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
  var D = gOPD(it, key);
  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it){
  var names  = gOPN(toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
  var IS_OP  = it === ObjectProto
    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if(!USE_NATIVE){
  $Symbol = function Symbol(){
    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function(value){
      if(this === ObjectProto)$set.call(OPSymbols, value);
      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f   = $defineProperty;
  __webpack_require__(447).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(213).f  = $propertyIsEnumerable;
  __webpack_require__(283).f = $getOwnPropertySymbols;

  if(DESCRIPTORS && !__webpack_require__(211)){
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function(name){
    return wrap(wks(name));
  }
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});

for(var symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);

for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function(key){
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(key){
    if(isSymbol(key))return keyOf(SymbolRegistry, key);
    throw TypeError(key + ' is not a symbol!');
  },
  useSetter: function(){ setter = true; },
  useSimple: function(){ setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it){
    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
    var args = [it]
      , i    = 1
      , replacer, $replacer;
    while(arguments.length > i)args.push(arguments[i++]);
    replacer = args[1];
    if(typeof replacer == 'function')$replacer = replacer;
    if($replacer || !isArray(replacer))replacer = function(key, value){
      if($replacer)value = $replacer.call(this, key, value);
      if(!isSymbol(value))return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(98)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export  = __webpack_require__(72);

$export($export.P + $export.R, 'Map', {toJSON: __webpack_require__(747)('Map')});

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(289)('asyncIterator');

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(289)('observable');

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(28)
  , isArray  = __webpack_require__(301)
  , SPECIES  = __webpack_require__(29)('species');

module.exports = function(original){
  var C;
  if(isArray(original)){
    C = original.constructor;
    // cross-realm fallback
    if(typeof C == 'function' && (C === Array || isArray(C.prototype)))C = undefined;
    if(isObject(C)){
      C = C[SPECIES];
      if(C === null)C = undefined;
    }
  } return C === undefined ? Array : C;
};

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(778);

module.exports = function(original, length){
  return new (speciesConstructor(original))(length);
};

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject    = __webpack_require__(20)
  , toPrimitive = __webpack_require__(80)
  , NUMBER      = 'number';

module.exports = function(hint){
  if(hint !== 'string' && hint !== NUMBER && hint !== 'default')throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(123)
  , gOPS    = __webpack_require__(224)
  , pIE     = __webpack_require__(176);
module.exports = function(it){
  var result     = getKeys(it)
    , getSymbols = gOPS.f;
  if(getSymbols){
    var symbols = getSymbols(it)
      , isEnum  = pIE.f
      , i       = 0
      , key;
    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
  } return result;
};

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys   = __webpack_require__(123)
  , toIObject = __webpack_require__(60);
module.exports = function(object, el){
  var O      = toIObject(object)
    , keys   = getKeys(O)
    , length = keys.length
    , index  = 0
    , key;
  while(length > index)if(O[key = keys[index++]] === el)return key;
};

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var path      = __webpack_require__(784)
  , invoke    = __webpack_require__(220)
  , aFunction = __webpack_require__(56);
module.exports = function(/* ...pargs */){
  var fn     = aFunction(this)
    , length = arguments.length
    , pargs  = Array(length)
    , i      = 0
    , _      = path._
    , holder = false;
  while(length > i)if((pargs[i] = arguments[i++]) === _)holder = true;
  return function(/* ...args */){
    var that = this
      , aLen = arguments.length
      , j = 0, k = 0, args;
    if(!holder && !aLen)return invoke(fn, pargs, that);
    args = pargs.slice();
    if(holder)for(;length > j; j++)if(args[j] === _)args[j] = arguments[k++];
    while(aLen > k)args.push(arguments[k++]);
    return invoke(fn, args, that);
  };
};

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(21);

/***/ }),
/* 785 */
/***/ (function(module, exports) {

module.exports = function(regExp, replace){
  var replacer = replace === Object(replace) ? function(part){
    return replace[part];
  } : replace;
  return function(it){
    return String(it).replace(regExp, replacer);
  };
};

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(6)
  , $re     = __webpack_require__(785)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', {escape: function escape(it){ return $re(it); }});


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(6);

$export($export.P, 'Array', {copyWithin: __webpack_require__(454)});

__webpack_require__(141)('copyWithin');

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(6)
  , $every  = __webpack_require__(78)(4);

$export($export.P + $export.F * !__webpack_require__(76)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */){
    return $every(this, callbackfn, arguments[1]);
  }
});

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(6);

$export($export.P, 'Array', {fill: __webpack_require__(293)});

__webpack_require__(141)('fill');

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(6)
  , $filter = __webpack_require__(78)(2);

$export($export.P + $export.F * !__webpack_require__(76)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */){
    return $filter(this, callbackfn, arguments[1]);
  }
});

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(6)
  , $find   = __webpack_require__(78)(6)
  , KEY     = 'findIndex'
  , forced  = true;
// Shouldn't skip holes
if(KEY in [])Array(1)[KEY](function(){ forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn/*, that = undefined */){
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(141)(KEY);

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(6)
  , $find   = __webpack_require__(78)(5)
  , KEY     = 'find'
  , forced  = true;
// Shouldn't skip holes
if(KEY in [])Array(1)[KEY](function(){ forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn/*, that = undefined */){
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(141)(KEY);

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export  = __webpack_require__(6)
  , $forEach = __webpack_require__(78)(0)
  , STRICT   = __webpack_require__(76)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */){
    return $forEach(this, callbackfn, arguments[1]);
  }
});

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx            = __webpack_require__(88)
  , $export        = __webpack_require__(6)
  , toObject       = __webpack_require__(45)
  , call           = __webpack_require__(463)
  , isArrayIter    = __webpack_require__(300)
  , toLength       = __webpack_require__(43)
  , createProperty = __webpack_require__(294)
  , getIterFn      = __webpack_require__(317);

$export($export.S + $export.F * !__webpack_require__(222)(function(iter){ Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
    var O       = toObject(arrayLike)
      , C       = typeof this == 'function' ? this : Array
      , aLen    = arguments.length
      , mapfn   = aLen > 1 ? arguments[1] : undefined
      , mapping = mapfn !== undefined
      , index   = 0
      , iterFn  = getIterFn(O)
      , length, result, step, iterator;
    if(mapping)mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for(result = new C(length); length > index; index++){
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export       = __webpack_require__(6)
  , $indexOf      = __webpack_require__(216)(false)
  , $native       = [].indexOf
  , NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(76)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /*, fromIndex = 0 */){
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(6);

$export($export.S, 'Array', {isArray: __webpack_require__(301)});

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export   = __webpack_require__(6)
  , toIObject = __webpack_require__(60)
  , arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(175) != Object || !__webpack_require__(76)(arrayJoin)), 'Array', {
  join: function join(separator){
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export       = __webpack_require__(6)
  , toIObject     = __webpack_require__(60)
  , toInteger     = __webpack_require__(103)
  , toLength      = __webpack_require__(43)
  , $native       = [].lastIndexOf
  , NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(76)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /*, fromIndex = @[*-1] */){
    // convert -0 to +0
    if(NEGATIVE_ZERO)return $native.apply(this, arguments) || 0;
    var O      = toIObject(this)
      , length = toLength(O.length)
      , index  = length - 1;
    if(arguments.length > 1)index = Math.min(index, toInteger(arguments[1]));
    if(index < 0)index = length + index;
    for(;index >= 0; index--)if(index in O)if(O[index] === searchElement)return index || 0;
    return -1;
  }
});

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(6)
  , $map    = __webpack_require__(78)(1);

$export($export.P + $export.F * !__webpack_require__(76)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */){
    return $map(this, callbackfn, arguments[1]);
  }
});

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export        = __webpack_require__(6)
  , createProperty = __webpack_require__(294);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(24)(function(){
  function F(){}
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */){
    var index  = 0
      , aLen   = arguments.length
      , result = new (typeof this == 'function' ? this : Array)(aLen);
    while(aLen > index)createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(6)
  , $reduce = __webpack_require__(456);

$export($export.P + $export.F * !__webpack_require__(76)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */){
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(6)
  , $reduce = __webpack_require__(456);

$export($export.P + $export.F * !__webpack_require__(76)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */){
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export    = __webpack_require__(6)
  , html       = __webpack_require__(298)
  , cof        = __webpack_require__(74)
  , toIndex    = __webpack_require__(126)
  , toLength   = __webpack_require__(43)
  , arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(24)(function(){
  if(html)arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end){
    var len   = toLength(this.length)
      , klass = cof(this);
    end = end === undefined ? len : end;
    if(klass == 'Array')return arraySlice.call(this, begin, end);
    var start  = toIndex(begin, len)
      , upTo   = toIndex(end, len)
      , size   = toLength(upTo - start)
      , cloned = Array(size)
      , i      = 0;
    for(; i < size; i++)cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(6)
  , $some   = __webpack_require__(78)(3);

$export($export.P + $export.F * !__webpack_require__(76)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */){
    return $some(this, callbackfn, arguments[1]);
  }
});

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export   = __webpack_require__(6)
  , aFunction = __webpack_require__(56)
  , toObject  = __webpack_require__(45)
  , fails     = __webpack_require__(24)
  , $sort     = [].sort
  , test      = [1, 2, 3];

$export($export.P + $export.F * (fails(function(){
  // IE8-
  test.sort(undefined);
}) || !fails(function(){
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(76)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn){
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(125)('Array');

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(6);

$export($export.S, 'Date', {now: function(){ return new Date().getTime(); }});

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(6)
  , fails   = __webpack_require__(24)
  , getTime = Date.prototype.getTime;

var lz = function(num){
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (fails(function(){
  return new Date(-5e13 - 1).toISOString() != '0385-07-25T07:06:39.999Z';
}) || !fails(function(){
  new Date(NaN).toISOString();
})), 'Date', {
  toISOString: function toISOString(){
    if(!isFinite(getTime.call(this)))throw RangeError('Invalid time value');
    var d = this
      , y = d.getUTCFullYear()
      , m = d.getUTCMilliseconds()
      , s = y < 0 ? '-' : y > 9999 ? '+' : '';
    return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
      '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
      'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
      ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
  }
});

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export     = __webpack_require__(6)
  , toObject    = __webpack_require__(45)
  , toPrimitive = __webpack_require__(80);

$export($export.P + $export.F * __webpack_require__(24)(function(){
  return new Date(NaN).toJSON() !== null || Date.prototype.toJSON.call({toISOString: function(){ return 1; }}) !== 1;
}), 'Date', {
  toJSON: function toJSON(key){
    var O  = toObject(this)
      , pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(29)('toPrimitive')
  , proto        = Date.prototype;

if(!(TO_PRIMITIVE in proto))__webpack_require__(57)(proto, TO_PRIMITIVE, __webpack_require__(780));

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto    = Date.prototype
  , INVALID_DATE = 'Invalid Date'
  , TO_STRING    = 'toString'
  , $toString    = DateProto[TO_STRING]
  , getTime      = DateProto.getTime;
if(new Date(NaN) + '' != INVALID_DATE){
  __webpack_require__(58)(DateProto, TO_STRING, function toString(){
    var value = getTime.call(this);
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(6);

$export($export.P, 'Function', {bind: __webpack_require__(457)});

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject       = __webpack_require__(28)
  , getPrototypeOf = __webpack_require__(66)
  , HAS_INSTANCE   = __webpack_require__(29)('hasInstance')
  , FunctionProto  = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if(!(HAS_INSTANCE in FunctionProto))__webpack_require__(33).f(FunctionProto, HAS_INSTANCE, {value: function(O){
  if(typeof this != 'function' || !isObject(O))return false;
  if(!isObject(this.prototype))return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while(O = getPrototypeOf(O))if(this.prototype === O)return true;
  return false;
}});

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

var dP         = __webpack_require__(33).f
  , createDesc = __webpack_require__(102)
  , has        = __webpack_require__(52)
  , FProto     = Function.prototype
  , nameRE     = /^\s*function ([^ (]*)/
  , NAME       = 'name';

var isExtensible = Object.isExtensible || function(){
  return true;
};

// 19.2.4.2 name
NAME in FProto || __webpack_require__(32) && dP(FProto, NAME, {
  configurable: true,
  get: function(){
    try {
      var that = this
        , name = ('' + that).match(nameRE)[1];
      has(that, NAME) || !isExtensible(that) || dP(that, NAME, createDesc(5, name));
      return name;
    } catch(e){
      return '';
    }
  }
});

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(6)
  , log1p   = __webpack_require__(465)
  , sqrt    = Math.sqrt
  , $acosh  = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN 
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x){
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(6)
  , $asinh  = Math.asinh;

function asinh(x){
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0 
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', {asinh: asinh});

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(6)
  , $atanh  = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0 
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x){
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(6)
  , sign    = __webpack_require__(305);

$export($export.S, 'Math', {
  cbrt: function cbrt(x){
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(6);

$export($export.S, 'Math', {
  clz32: function clz32(x){
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(6)
  , exp     = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x){
    return (exp(x = +x) + exp(-x)) / 2;
  }
});

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(6)
  , $expm1  = __webpack_require__(304);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', {expm1: $expm1});

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export   = __webpack_require__(6)
  , sign      = __webpack_require__(305)
  , pow       = Math.pow
  , EPSILON   = pow(2, -52)
  , EPSILON32 = pow(2, -23)
  , MAX32     = pow(2, 127) * (2 - EPSILON32)
  , MIN32     = pow(2, -126);

var roundTiesToEven = function(n){
  return n + 1 / EPSILON - 1 / EPSILON;
};


$export($export.S, 'Math', {
  fround: function fround(x){
    var $abs  = Math.abs(x)
      , $sign = sign(x)
      , a, result;
    if($abs < MIN32)return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
    a = (1 + EPSILON32 / EPSILON) * $abs;
    result = a - (a - $abs);
    if(result > MAX32 || result != result)return $sign * Infinity;
    return $sign * result;
  }
});

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(6)
  , abs     = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2){ // eslint-disable-line no-unused-vars
    var sum  = 0
      , i    = 0
      , aLen = arguments.length
      , larg = 0
      , arg, div;
    while(i < aLen){
      arg = abs(arguments[i++]);
      if(larg < arg){
        div  = larg / arg;
        sum  = sum * div * div + 1;
        larg = arg;
      } else if(arg > 0){
        div  = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(6)
  , $imul   = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(24)(function(){
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y){
    var UINT16 = 0xffff
      , xn = +x
      , yn = +y
      , xl = UINT16 & xn
      , yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(6);

$export($export.S, 'Math', {
  log10: function log10(x){
    return Math.log(x) / Math.LN10;
  }
});

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(6);

$export($export.S, 'Math', {log1p: __webpack_require__(465)});

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(6);

$export($export.S, 'Math', {
  log2: function log2(x){
    return Math.log(x) / Math.LN2;
  }
});

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(6);

$export($export.S, 'Math', {sign: __webpack_require__(305)});

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(6)
  , expm1   = __webpack_require__(304)
  , exp     = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(24)(function(){
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x){
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(6)
  , expm1   = __webpack_require__(304)
  , exp     = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x){
    var a = expm1(x = +x)
      , b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(6);

$export($export.S, 'Math', {
  trunc: function trunc(it){
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global            = __webpack_require__(21)
  , has               = __webpack_require__(52)
  , cof               = __webpack_require__(74)
  , inheritIfRequired = __webpack_require__(299)
  , toPrimitive       = __webpack_require__(80)
  , fails             = __webpack_require__(24)
  , gOPN              = __webpack_require__(122).f
  , gOPD              = __webpack_require__(65).f
  , dP                = __webpack_require__(33).f
  , $trim             = __webpack_require__(145).trim
  , NUMBER            = 'Number'
  , $Number           = global[NUMBER]
  , Base              = $Number
  , proto             = $Number.prototype
  // Opera ~12 has broken Object#toString
  , BROKEN_COF        = cof(__webpack_require__(121)(proto)) == NUMBER
  , TRIM              = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function(argument){
  var it = toPrimitive(argument, false);
  if(typeof it == 'string' && it.length > 2){
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0)
      , third, radix, maxCode;
    if(first === 43 || first === 45){
      third = it.charCodeAt(2);
      if(third === 88 || third === 120)return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if(first === 48){
      switch(it.charCodeAt(1)){
        case 66 : case 98  : radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79 : case 111 : radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default : return +it;
      }
      for(var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++){
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if(code < 48 || code > maxCode)return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if(!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')){
  $Number = function Number(value){
    var it = arguments.length < 1 ? 0 : value
      , that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function(){ proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for(var keys = __webpack_require__(32) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++){
    if(has(Base, key = keys[j]) && !has($Number, key)){
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(58)(global, NUMBER, $Number);
}

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(6);

$export($export.S, 'Number', {EPSILON: Math.pow(2, -52)});

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export   = __webpack_require__(6)
  , _isFinite = __webpack_require__(21).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it){
    return typeof it == 'number' && _isFinite(it);
  }
});

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(6);

$export($export.S, 'Number', {isInteger: __webpack_require__(462)});

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(6);

$export($export.S, 'Number', {
  isNaN: function isNaN(number){
    return number != number;
  }
});

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export   = __webpack_require__(6)
  , isInteger = __webpack_require__(462)
  , abs       = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number){
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(6);

$export($export.S, 'Number', {MAX_SAFE_INTEGER: 0x1fffffffffffff});

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(6);

$export($export.S, 'Number', {MIN_SAFE_INTEGER: -0x1fffffffffffff});

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

var $export     = __webpack_require__(6)
  , $parseFloat = __webpack_require__(472);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', {parseFloat: $parseFloat});

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

var $export   = __webpack_require__(6)
  , $parseInt = __webpack_require__(473);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', {parseInt: $parseInt});

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export      = __webpack_require__(6)
  , toInteger    = __webpack_require__(103)
  , aNumberValue = __webpack_require__(453)
  , repeat       = __webpack_require__(312)
  , $toFixed     = 1..toFixed
  , floor        = Math.floor
  , data         = [0, 0, 0, 0, 0, 0]
  , ERROR        = 'Number.toFixed: incorrect invocation!'
  , ZERO         = '0';

var multiply = function(n, c){
  var i  = -1
    , c2 = c;
  while(++i < 6){
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function(n){
  var i = 6
    , c = 0;
  while(--i >= 0){
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function(){
  var i = 6
    , s = '';
  while(--i >= 0){
    if(s !== '' || i === 0 || data[i] !== 0){
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function(x, n, acc){
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function(x){
  var n  = 0
    , x2 = x;
  while(x2 >= 4096){
    n += 12;
    x2 /= 4096;
  }
  while(x2 >= 2){
    n  += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128..toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(24)(function(){
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits){
    var x = aNumberValue(this, ERROR)
      , f = toInteger(fractionDigits)
      , s = ''
      , m = ZERO
      , e, z, j, k;
    if(f < 0 || f > 20)throw RangeError(ERROR);
    if(x != x)return 'NaN';
    if(x <= -1e21 || x >= 1e21)return String(x);
    if(x < 0){
      s = '-';
      x = -x;
    }
    if(x > 1e-21){
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if(e > 0){
        multiply(0, z);
        j = f;
        while(j >= 7){
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while(j >= 23){
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if(f > 0){
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export      = __webpack_require__(6)
  , $fails       = __webpack_require__(24)
  , aNumberValue = __webpack_require__(453)
  , $toPrecision = 1..toPrecision;

$export($export.P + $export.F * ($fails(function(){
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function(){
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision){
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision); 
  }
});

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(6);

$export($export.S + $export.F, 'Object', {assign: __webpack_require__(466)});

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(6)
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', {create: __webpack_require__(121)});

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(6);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(32), 'Object', {defineProperties: __webpack_require__(467)});

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(6);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(32), 'Object', {defineProperty: __webpack_require__(33).f});

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(28)
  , meta     = __webpack_require__(101).onFreeze;

__webpack_require__(79)('freeze', function($freeze){
  return function freeze(it){
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject                 = __webpack_require__(60)
  , $getOwnPropertyDescriptor = __webpack_require__(65).f;

__webpack_require__(79)('getOwnPropertyDescriptor', function(){
  return function getOwnPropertyDescriptor(it, key){
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(79)('getOwnPropertyNames', function(){
  return __webpack_require__(468).f;
});

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject        = __webpack_require__(45)
  , $getPrototypeOf = __webpack_require__(66);

__webpack_require__(79)('getPrototypeOf', function(){
  return function getPrototypeOf(it){
    return $getPrototypeOf(toObject(it));
  };
});

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(28);

__webpack_require__(79)('isExtensible', function($isExtensible){
  return function isExtensible(it){
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(28);

__webpack_require__(79)('isFrozen', function($isFrozen){
  return function isFrozen(it){
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(28);

__webpack_require__(79)('isSealed', function($isSealed){
  return function isSealed(it){
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(6);
$export($export.S, 'Object', {is: __webpack_require__(474)});

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(45)
  , $keys    = __webpack_require__(123);

__webpack_require__(79)('keys', function(){
  return function keys(it){
    return $keys(toObject(it));
  };
});

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(28)
  , meta     = __webpack_require__(101).onFreeze;

__webpack_require__(79)('preventExtensions', function($preventExtensions){
  return function preventExtensions(it){
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(28)
  , meta     = __webpack_require__(101).onFreeze;

__webpack_require__(79)('seal', function($seal){
  return function seal(it){
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(6);
$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(307).set});

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(174)
  , test    = {};
test[__webpack_require__(29)('toStringTag')] = 'z';
if(test + '' != '[object z]'){
  __webpack_require__(58)(Object.prototype, 'toString', function toString(){
    return '[object ' + classof(this) + ']';
  }, true);
}

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

var $export     = __webpack_require__(6)
  , $parseFloat = __webpack_require__(472);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), {parseFloat: $parseFloat});

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

var $export   = __webpack_require__(6)
  , $parseInt = __webpack_require__(473);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), {parseInt: $parseInt});

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY            = __webpack_require__(120)
  , global             = __webpack_require__(21)
  , ctx                = __webpack_require__(88)
  , classof            = __webpack_require__(174)
  , $export            = __webpack_require__(6)
  , isObject           = __webpack_require__(28)
  , aFunction          = __webpack_require__(56)
  , anInstance         = __webpack_require__(119)
  , forOf              = __webpack_require__(142)
  , speciesConstructor = __webpack_require__(309)
  , task               = __webpack_require__(314).set
  , microtask          = __webpack_require__(306)()
  , PROMISE            = 'Promise'
  , TypeError          = global.TypeError
  , process            = global.process
  , $Promise           = global[PROMISE]
  , process            = global.process
  , isNode             = classof(process) == 'process'
  , empty              = function(){ /* empty */ }
  , Internal, GenericPromiseCapability, Wrapper;

var USE_NATIVE = !!function(){
  try {
    // correct subclassing with @@species support
    var promise     = $Promise.resolve(1)
      , FakePromise = (promise.constructor = {})[__webpack_require__(29)('species')] = function(exec){ exec(empty, empty); };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch(e){ /* empty */ }
}();

// helpers
var sameConstructor = function(a, b){
  // with library wrapper special case
  return a === b || a === $Promise && b === Wrapper;
};
var isThenable = function(it){
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var newPromiseCapability = function(C){
  return sameConstructor($Promise, C)
    ? new PromiseCapability(C)
    : new GenericPromiseCapability(C);
};
var PromiseCapability = GenericPromiseCapability = function(C){
  var resolve, reject;
  this.promise = new C(function($$resolve, $$reject){
    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject  = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject  = aFunction(reject);
};
var perform = function(exec){
  try {
    exec();
  } catch(e){
    return {error: e};
  }
};
var notify = function(promise, isReject){
  if(promise._n)return;
  promise._n = true;
  var chain = promise._c;
  microtask(function(){
    var value = promise._v
      , ok    = promise._s == 1
      , i     = 0;
    var run = function(reaction){
      var handler = ok ? reaction.ok : reaction.fail
        , resolve = reaction.resolve
        , reject  = reaction.reject
        , domain  = reaction.domain
        , result, then;
      try {
        if(handler){
          if(!ok){
            if(promise._h == 2)onHandleUnhandled(promise);
            promise._h = 1;
          }
          if(handler === true)result = value;
          else {
            if(domain)domain.enter();
            result = handler(value);
            if(domain)domain.exit();
          }
          if(result === reaction.promise){
            reject(TypeError('Promise-chain cycle'));
          } else if(then = isThenable(result)){
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch(e){
        reject(e);
      }
    };
    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if(isReject && !promise._h)onUnhandled(promise);
  });
};
var onUnhandled = function(promise){
  task.call(global, function(){
    var value = promise._v
      , abrupt, handler, console;
    if(isUnhandled(promise)){
      abrupt = perform(function(){
        if(isNode){
          process.emit('unhandledRejection', value, promise);
        } else if(handler = global.onunhandledrejection){
          handler({promise: promise, reason: value});
        } else if((console = global.console) && console.error){
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if(abrupt)throw abrupt.error;
  });
};
var isUnhandled = function(promise){
  if(promise._h == 1)return false;
  var chain = promise._a || promise._c
    , i     = 0
    , reaction;
  while(chain.length > i){
    reaction = chain[i++];
    if(reaction.fail || !isUnhandled(reaction.promise))return false;
  } return true;
};
var onHandleUnhandled = function(promise){
  task.call(global, function(){
    var handler;
    if(isNode){
      process.emit('rejectionHandled', promise);
    } else if(handler = global.onrejectionhandled){
      handler({promise: promise, reason: promise._v});
    }
  });
};
var $reject = function(value){
  var promise = this;
  if(promise._d)return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if(!promise._a)promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function(value){
  var promise = this
    , then;
  if(promise._d)return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if(promise === value)throw TypeError("Promise can't be resolved itself");
    if(then = isThenable(value)){
      microtask(function(){
        var wrapper = {_w: promise, _d: false}; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch(e){
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch(e){
    $reject.call({_w: promise, _d: false}, e); // wrap
  }
};

// constructor polyfill
if(!USE_NATIVE){
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor){
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch(err){
      $reject.call(this, err);
    }
  };
  Internal = function Promise(executor){
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(124)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected){
      var reaction    = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok     = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail   = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if(this._a)this._a.push(reaction);
      if(this._s)notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function(onRejected){
      return this.then(undefined, onRejected);
    }
  });
  PromiseCapability = function(){
    var promise  = new Internal;
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject  = ctx($reject, promise, 1);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: $Promise});
__webpack_require__(144)($Promise, PROMISE);
__webpack_require__(125)(PROMISE);
Wrapper = __webpack_require__(87)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r){
    var capability = newPromiseCapability(this)
      , $$reject   = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x){
    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
    if(x instanceof $Promise && sameConstructor(x.constructor, this))return x;
    var capability = newPromiseCapability(this)
      , $$resolve  = capability.resolve;
    $$resolve(x);
    return capability.promise;
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(222)(function(iter){
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable){
    var C          = this
      , capability = newPromiseCapability(C)
      , resolve    = capability.resolve
      , reject     = capability.reject;
    var abrupt = perform(function(){
      var values    = []
        , index     = 0
        , remaining = 1;
      forOf(iterable, false, function(promise){
        var $index        = index++
          , alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function(value){
          if(alreadyCalled)return;
          alreadyCalled  = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable){
    var C          = this
      , capability = newPromiseCapability(C)
      , reject     = capability.reject;
    var abrupt = perform(function(){
      forOf(iterable, false, function(promise){
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  }
});

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export   = __webpack_require__(6)
  , aFunction = __webpack_require__(56)
  , anObject  = __webpack_require__(20)
  , rApply    = (__webpack_require__(21).Reflect || {}).apply
  , fApply    = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(24)(function(){
  rApply(function(){});
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList){
    var T = aFunction(target)
      , L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export    = __webpack_require__(6)
  , create     = __webpack_require__(121)
  , aFunction  = __webpack_require__(56)
  , anObject   = __webpack_require__(20)
  , isObject   = __webpack_require__(28)
  , fails      = __webpack_require__(24)
  , bind       = __webpack_require__(457)
  , rConstruct = (__webpack_require__(21).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function(){
  function F(){}
  return !(rConstruct(function(){}, [], F) instanceof F);
});
var ARGS_BUG = !fails(function(){
  rConstruct(function(){});
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /*, newTarget*/){
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if(ARGS_BUG && !NEW_TARGET_BUG)return rConstruct(Target, args, newTarget);
    if(Target == newTarget){
      // w/o altered newTarget, optimization for 0-4 arguments
      switch(args.length){
        case 0: return new Target;
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args));
    }
    // with altered newTarget, not support built-in constructors
    var proto    = newTarget.prototype
      , instance = create(isObject(proto) ? proto : Object.prototype)
      , result   = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP          = __webpack_require__(33)
  , $export     = __webpack_require__(6)
  , anObject    = __webpack_require__(20)
  , toPrimitive = __webpack_require__(80);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(24)(function(){
  Reflect.defineProperty(dP.f({}, 1, {value: 1}), 1, {value: 2});
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes){
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch(e){
      return false;
    }
  }
});

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export  = __webpack_require__(6)
  , gOPD     = __webpack_require__(65).f
  , anObject = __webpack_require__(20);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey){
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export  = __webpack_require__(6)
  , anObject = __webpack_require__(20);
var Enumerate = function(iterated){
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = []       // keys
    , key;
  for(key in iterated)keys.push(key);
};
__webpack_require__(302)(Enumerate, 'Object', function(){
  var that = this
    , keys = that._k
    , key;
  do {
    if(that._i >= keys.length)return {value: undefined, done: true};
  } while(!((key = keys[that._i++]) in that._t));
  return {value: key, done: false};
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target){
    return new Enumerate(target);
  }
});

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD     = __webpack_require__(65)
  , $export  = __webpack_require__(6)
  , anObject = __webpack_require__(20);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey){
    return gOPD.f(anObject(target), propertyKey);
  }
});

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export  = __webpack_require__(6)
  , getProto = __webpack_require__(66)
  , anObject = __webpack_require__(20);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target){
    return getProto(anObject(target));
  }
});

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD           = __webpack_require__(65)
  , getPrototypeOf = __webpack_require__(66)
  , has            = __webpack_require__(52)
  , $export        = __webpack_require__(6)
  , isObject       = __webpack_require__(28)
  , anObject       = __webpack_require__(20);

function get(target, propertyKey/*, receiver*/){
  var receiver = arguments.length < 3 ? target : arguments[2]
    , desc, proto;
  if(anObject(target) === receiver)return target[propertyKey];
  if(desc = gOPD.f(target, propertyKey))return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if(isObject(proto = getPrototypeOf(target)))return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', {get: get});

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(6);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey){
    return propertyKey in target;
  }
});

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export       = __webpack_require__(6)
  , anObject      = __webpack_require__(20)
  , $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target){
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(6);

$export($export.S, 'Reflect', {ownKeys: __webpack_require__(471)});

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export            = __webpack_require__(6)
  , anObject           = __webpack_require__(20)
  , $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target){
    anObject(target);
    try {
      if($preventExtensions)$preventExtensions(target);
      return true;
    } catch(e){
      return false;
    }
  }
});

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export  = __webpack_require__(6)
  , setProto = __webpack_require__(307);

if(setProto)$export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto){
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch(e){
      return false;
    }
  }
});

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP             = __webpack_require__(33)
  , gOPD           = __webpack_require__(65)
  , getPrototypeOf = __webpack_require__(66)
  , has            = __webpack_require__(52)
  , $export        = __webpack_require__(6)
  , createDesc     = __webpack_require__(102)
  , anObject       = __webpack_require__(20)
  , isObject       = __webpack_require__(28);

function set(target, propertyKey, V/*, receiver*/){
  var receiver = arguments.length < 4 ? target : arguments[3]
    , ownDesc  = gOPD.f(anObject(target), propertyKey)
    , existingDescriptor, proto;
  if(!ownDesc){
    if(isObject(proto = getPrototypeOf(target))){
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if(has(ownDesc, 'value')){
    if(ownDesc.writable === false || !isObject(receiver))return false;
    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
    existingDescriptor.value = V;
    dP.f(receiver, propertyKey, existingDescriptor);
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', {set: set});

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

var global            = __webpack_require__(21)
  , inheritIfRequired = __webpack_require__(299)
  , dP                = __webpack_require__(33).f
  , gOPN              = __webpack_require__(122).f
  , isRegExp          = __webpack_require__(221)
  , $flags            = __webpack_require__(219)
  , $RegExp           = global.RegExp
  , Base              = $RegExp
  , proto             = $RegExp.prototype
  , re1               = /a/g
  , re2               = /a/g
  // "new" creates a new object, old webkit buggy here
  , CORRECT_NEW       = new $RegExp(re1) !== re1;

if(__webpack_require__(32) && (!CORRECT_NEW || __webpack_require__(24)(function(){
  re2[__webpack_require__(29)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))){
  $RegExp = function RegExp(p, f){
    var tiRE = this instanceof $RegExp
      , piRE = isRegExp(p)
      , fiU  = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function(key){
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function(){ return Base[key]; },
      set: function(it){ Base[key] = it; }
    });
  };
  for(var keys = gOPN(Base), i = 0; keys.length > i; )proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(58)(global, 'RegExp', $RegExp);
}

__webpack_require__(125)('RegExp');

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

// @@match logic
__webpack_require__(218)('match', 1, function(defined, MATCH, $match){
  // 21.1.3.11 String.prototype.match(regexp)
  return [function match(regexp){
    'use strict';
    var O  = defined(this)
      , fn = regexp == undefined ? undefined : regexp[MATCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
  }, $match];
});

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

// @@replace logic
__webpack_require__(218)('replace', 2, function(defined, REPLACE, $replace){
  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
  return [function replace(searchValue, replaceValue){
    'use strict';
    var O  = defined(this)
      , fn = searchValue == undefined ? undefined : searchValue[REPLACE];
    return fn !== undefined
      ? fn.call(searchValue, O, replaceValue)
      : $replace.call(String(O), searchValue, replaceValue);
  }, $replace];
});

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

// @@search logic
__webpack_require__(218)('search', 1, function(defined, SEARCH, $search){
  // 21.1.3.15 String.prototype.search(regexp)
  return [function search(regexp){
    'use strict';
    var O  = defined(this)
      , fn = regexp == undefined ? undefined : regexp[SEARCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
  }, $search];
});

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

// @@split logic
__webpack_require__(218)('split', 2, function(defined, SPLIT, $split){
  'use strict';
  var isRegExp   = __webpack_require__(221)
    , _split     = $split
    , $push      = [].push
    , $SPLIT     = 'split'
    , LENGTH     = 'length'
    , LAST_INDEX = 'lastIndex';
  if(
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ){
    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
    // based on es5-shim implementation, need to rework it
    $split = function(separator, limit){
      var string = String(this);
      if(separator === undefined && limit === 0)return [];
      // If `separator` is not a regex, use native split
      if(!isRegExp(separator))return _split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var separator2, match, lastIndex, lastLength, i;
      // Doesn't need flags gy, but they don't hurt
      if(!NPCG)separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
      while(match = separatorCopy.exec(string)){
        // `separatorCopy.lastIndex` is not reliable cross-browser
        lastIndex = match.index + match[0][LENGTH];
        if(lastIndex > lastLastIndex){
          output.push(string.slice(lastLastIndex, match.index));
          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
          if(!NPCG && match[LENGTH] > 1)match[0].replace(separator2, function(){
            for(i = 1; i < arguments[LENGTH] - 2; i++)if(arguments[i] === undefined)match[i] = undefined;
          });
          if(match[LENGTH] > 1 && match.index < string[LENGTH])$push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if(output[LENGTH] >= splitLimit)break;
        }
        if(separatorCopy[LAST_INDEX] === match.index)separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if(lastLastIndex === string[LENGTH]){
        if(lastLength || !separatorCopy.test(''))output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if('0'[$SPLIT](undefined, 0)[LENGTH]){
    $split = function(separator, limit){
      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
    };
  }
  // 21.1.3.17 String.prototype.split(separator, limit)
  return [function split(separator, limit){
    var O  = defined(this)
      , fn = separator == undefined ? undefined : separator[SPLIT];
    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
  }, $split];
});

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(478);
var anObject    = __webpack_require__(20)
  , $flags      = __webpack_require__(219)
  , DESCRIPTORS = __webpack_require__(32)
  , TO_STRING   = 'toString'
  , $toString   = /./[TO_STRING];

var define = function(fn){
  __webpack_require__(58)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if(__webpack_require__(24)(function(){ return $toString.call({source: 'a', flags: 'b'}) != '/a/b'; })){
  define(function toString(){
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if($toString.name != TO_STRING){
  define(function toString(){
    return $toString.call(this);
  });
}

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(59)('anchor', function(createHTML){
  return function anchor(name){
    return createHTML(this, 'a', 'name', name);
  }
});

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(59)('big', function(createHTML){
  return function big(){
    return createHTML(this, 'big', '', '');
  }
});

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(59)('blink', function(createHTML){
  return function blink(){
    return createHTML(this, 'blink', '', '');
  }
});

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(59)('bold', function(createHTML){
  return function bold(){
    return createHTML(this, 'b', '', '');
  }
});

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(6)
  , $at     = __webpack_require__(310)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos){
    return $at(this, pos);
  }
});

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export   = __webpack_require__(6)
  , toLength  = __webpack_require__(43)
  , context   = __webpack_require__(311)
  , ENDS_WITH = 'endsWith'
  , $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(297)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /*, endPosition = @length */){
    var that = context(this, searchString, ENDS_WITH)
      , endPosition = arguments.length > 1 ? arguments[1] : undefined
      , len    = toLength(that.length)
      , end    = endPosition === undefined ? len : Math.min(toLength(endPosition), len)
      , search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(59)('fixed', function(createHTML){
  return function fixed(){
    return createHTML(this, 'tt', '', '');
  }
});

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(59)('fontcolor', function(createHTML){
  return function fontcolor(color){
    return createHTML(this, 'font', 'color', color);
  }
});

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(59)('fontsize', function(createHTML){
  return function fontsize(size){
    return createHTML(this, 'font', 'size', size);
  }
});

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

var $export        = __webpack_require__(6)
  , toIndex        = __webpack_require__(126)
  , fromCharCode   = String.fromCharCode
  , $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x){ // eslint-disable-line no-unused-vars
    var res  = []
      , aLen = arguments.length
      , i    = 0
      , code;
    while(aLen > i){
      code = +arguments[i++];
      if(toIndex(code, 0x10ffff) !== code)throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export  = __webpack_require__(6)
  , context  = __webpack_require__(311)
  , INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(297)(INCLUDES), 'String', {
  includes: function includes(searchString /*, position = 0 */){
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(59)('italics', function(createHTML){
  return function italics(){
    return createHTML(this, 'i', '', '');
  }
});

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at  = __webpack_require__(310)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(303)(String, 'String', function(iterated){
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , index = this._i
    , point;
  if(index >= O.length)return {value: undefined, done: true};
  point = $at(O, index);
  this._i += point.length;
  return {value: point, done: false};
});

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(59)('link', function(createHTML){
  return function link(url){
    return createHTML(this, 'a', 'href', url);
  }
});

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

var $export   = __webpack_require__(6)
  , toIObject = __webpack_require__(60)
  , toLength  = __webpack_require__(43);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite){
    var tpl  = toIObject(callSite.raw)
      , len  = toLength(tpl.length)
      , aLen = arguments.length
      , res  = []
      , i    = 0;
    while(len > i){
      res.push(String(tpl[i++]));
      if(i < aLen)res.push(String(arguments[i]));
    } return res.join('');
  }
});

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(6);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(312)
});

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(59)('small', function(createHTML){
  return function small(){
    return createHTML(this, 'small', '', '');
  }
});

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export     = __webpack_require__(6)
  , toLength    = __webpack_require__(43)
  , context     = __webpack_require__(311)
  , STARTS_WITH = 'startsWith'
  , $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(297)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /*, position = 0 */){
    var that   = context(this, searchString, STARTS_WITH)
      , index  = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length))
      , search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(59)('strike', function(createHTML){
  return function strike(){
    return createHTML(this, 'strike', '', '');
  }
});

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(59)('sub', function(createHTML){
  return function sub(){
    return createHTML(this, 'sub', '', '');
  }
});

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(59)('sup', function(createHTML){
  return function sup(){
    return createHTML(this, 'sup', '', '');
  }
});

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(145)('trim', function($trim){
  return function trim(){
    return $trim(this, 3);
  };
});

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global         = __webpack_require__(21)
  , has            = __webpack_require__(52)
  , DESCRIPTORS    = __webpack_require__(32)
  , $export        = __webpack_require__(6)
  , redefine       = __webpack_require__(58)
  , META           = __webpack_require__(101).KEY
  , $fails         = __webpack_require__(24)
  , shared         = __webpack_require__(225)
  , setToStringTag = __webpack_require__(144)
  , uid            = __webpack_require__(127)
  , wks            = __webpack_require__(29)
  , wksExt         = __webpack_require__(476)
  , wksDefine      = __webpack_require__(316)
  , keyOf          = __webpack_require__(782)
  , enumKeys       = __webpack_require__(781)
  , isArray        = __webpack_require__(301)
  , anObject       = __webpack_require__(20)
  , toIObject      = __webpack_require__(60)
  , toPrimitive    = __webpack_require__(80)
  , createDesc     = __webpack_require__(102)
  , _create        = __webpack_require__(121)
  , gOPNExt        = __webpack_require__(468)
  , $GOPD          = __webpack_require__(65)
  , $DP            = __webpack_require__(33)
  , $keys          = __webpack_require__(123)
  , gOPD           = $GOPD.f
  , dP             = $DP.f
  , gOPN           = gOPNExt.f
  , $Symbol        = global.Symbol
  , $JSON          = global.JSON
  , _stringify     = $JSON && $JSON.stringify
  , PROTOTYPE      = 'prototype'
  , HIDDEN         = wks('_hidden')
  , TO_PRIMITIVE   = wks('toPrimitive')
  , isEnum         = {}.propertyIsEnumerable
  , SymbolRegistry = shared('symbol-registry')
  , AllSymbols     = shared('symbols')
  , OPSymbols      = shared('op-symbols')
  , ObjectProto    = Object[PROTOTYPE]
  , USE_NATIVE     = typeof $Symbol == 'function'
  , QObject        = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function(){
  return _create(dP({}, 'a', {
    get: function(){ return dP(this, 'a', {value: 7}).a; }
  })).a != 7;
}) ? function(it, key, D){
  var protoDesc = gOPD(ObjectProto, key);
  if(protoDesc)delete ObjectProto[key];
  dP(it, key, D);
  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function(tag){
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
  return typeof it == 'symbol';
} : function(it){
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D){
  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if(has(AllSymbols, key)){
    if(!D.enumerable){
      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
      D = _create(D, {enumerable: createDesc(0, false)});
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P){
  anObject(it);
  var keys = enumKeys(P = toIObject(P))
    , i    = 0
    , l = keys.length
    , key;
  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P){
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key){
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
  it  = toIObject(it);
  key = toPrimitive(key, true);
  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
  var D = gOPD(it, key);
  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it){
  var names  = gOPN(toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
  var IS_OP  = it === ObjectProto
    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if(!USE_NATIVE){
  $Symbol = function Symbol(){
    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function(value){
      if(this === ObjectProto)$set.call(OPSymbols, value);
      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f   = $defineProperty;
  __webpack_require__(122).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(176).f  = $propertyIsEnumerable;
  __webpack_require__(224).f = $getOwnPropertySymbols;

  if(DESCRIPTORS && !__webpack_require__(120)){
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function(name){
    return wrap(wks(name));
  }
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});

for(var symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);

for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function(key){
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(key){
    if(isSymbol(key))return keyOf(SymbolRegistry, key);
    throw TypeError(key + ' is not a symbol!');
  },
  useSetter: function(){ setter = true; },
  useSimple: function(){ setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it){
    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
    var args = [it]
      , i    = 1
      , replacer, $replacer;
    while(arguments.length > i)args.push(arguments[i++]);
    replacer = args[1];
    if(typeof replacer == 'function')$replacer = replacer;
    if($replacer || !isArray(replacer))replacer = function(key, value){
      if($replacer)value = $replacer.call(this, key, value);
      if(!isSymbol(value))return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(57)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export      = __webpack_require__(6)
  , $typed       = __webpack_require__(226)
  , buffer       = __webpack_require__(315)
  , anObject     = __webpack_require__(20)
  , toIndex      = __webpack_require__(126)
  , toLength     = __webpack_require__(43)
  , isObject     = __webpack_require__(28)
  , ArrayBuffer  = __webpack_require__(21).ArrayBuffer
  , speciesConstructor = __webpack_require__(309)
  , $ArrayBuffer = buffer.ArrayBuffer
  , $DataView    = buffer.DataView
  , $isView      = $typed.ABV && ArrayBuffer.isView
  , $slice       = $ArrayBuffer.prototype.slice
  , VIEW         = $typed.VIEW
  , ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), {ArrayBuffer: $ArrayBuffer});

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it){
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(24)(function(){
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end){
    if($slice !== undefined && end === undefined)return $slice.call(anObject(this), start); // FF fix
    var len    = anObject(this).byteLength
      , first  = toIndex(start, len)
      , final  = toIndex(end === undefined ? len : end, len)
      , result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first))
      , viewS  = new $DataView(this)
      , viewT  = new $DataView(result)
      , index  = 0;
    while(first < final){
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(125)(ARRAY_BUFFER);

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(6);
$export($export.G + $export.W + $export.F * !__webpack_require__(226).ABV, {
  DataView: __webpack_require__(315).DataView
});

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(90)('Float32', 4, function(init){
  return function Float32Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(90)('Float64', 8, function(init){
  return function Float64Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(90)('Int16', 2, function(init){
  return function Int16Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(90)('Int32', 4, function(init){
  return function Int32Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(90)('Int8', 1, function(init){
  return function Int8Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(90)('Uint16', 2, function(init){
  return function Uint16Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(90)('Uint32', 4, function(init){
  return function Uint32Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(90)('Uint8', 1, function(init){
  return function Uint8Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(90)('Uint8', 1, function(init){
  return function Uint8ClampedArray(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
}, true);

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(460);

// 23.4 WeakSet Objects
__webpack_require__(217)('WeakSet', function(get){
  return function WeakSet(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value){
    return weak.def(this, value, true);
  }
}, weak, false, true);

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export   = __webpack_require__(6)
  , $includes = __webpack_require__(216)(true);

$export($export.P, 'Array', {
  includes: function includes(el /*, fromIndex = 0 */){
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(141)('includes');

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export   = __webpack_require__(6)
  , microtask = __webpack_require__(306)()
  , process   = __webpack_require__(21).process
  , isNode    = __webpack_require__(74)(process) == 'process';

$export($export.G, {
  asap: function asap(fn){
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(6)
  , cof     = __webpack_require__(74);

$export($export.S, 'Error', {
  isError: function isError(it){
    return cof(it) === 'Error';
  }
});

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export  = __webpack_require__(6);

$export($export.P + $export.R, 'Map', {toJSON: __webpack_require__(459)('Map')});

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(6);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1){
    var $x0 = x0 >>> 0
      , $x1 = x1 >>> 0
      , $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(6);

$export($export.S, 'Math', {
  imulh: function imulh(u, v){
    var UINT16 = 0xffff
      , $u = +u
      , $v = +v
      , u0 = $u & UINT16
      , v0 = $v & UINT16
      , u1 = $u >> 16
      , v1 = $v >> 16
      , t  = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(6);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1){
    var $x0 = x0 >>> 0
      , $x1 = x1 >>> 0
      , $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(6);

$export($export.S, 'Math', {
  umulh: function umulh(u, v){
    var UINT16 = 0xffff
      , $u = +u
      , $v = +v
      , u0 = $u & UINT16
      , v0 = $v & UINT16
      , u1 = $u >>> 16
      , v1 = $v >>> 16
      , t  = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export         = __webpack_require__(6)
  , toObject        = __webpack_require__(45)
  , aFunction       = __webpack_require__(56)
  , $defineProperty = __webpack_require__(33);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(32) && $export($export.P + __webpack_require__(223), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter){
    $defineProperty.f(toObject(this), P, {get: aFunction(getter), enumerable: true, configurable: true});
  }
});

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export         = __webpack_require__(6)
  , toObject        = __webpack_require__(45)
  , aFunction       = __webpack_require__(56)
  , $defineProperty = __webpack_require__(33);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(32) && $export($export.P + __webpack_require__(223), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter){
    $defineProperty.f(toObject(this), P, {set: aFunction(setter), enumerable: true, configurable: true});
  }
});

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export  = __webpack_require__(6)
  , $entries = __webpack_require__(470)(true);

$export($export.S, 'Object', {
  entries: function entries(it){
    return $entries(it);
  }
});

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export        = __webpack_require__(6)
  , ownKeys        = __webpack_require__(471)
  , toIObject      = __webpack_require__(60)
  , gOPD           = __webpack_require__(65)
  , createProperty = __webpack_require__(294);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object){
    var O       = toIObject(object)
      , getDesc = gOPD.f
      , keys    = ownKeys(O)
      , result  = {}
      , i       = 0
      , key;
    while(keys.length > i)createProperty(result, key = keys[i++], getDesc(O, key));
    return result;
  }
});

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export                  = __webpack_require__(6)
  , toObject                 = __webpack_require__(45)
  , toPrimitive              = __webpack_require__(80)
  , getPrototypeOf           = __webpack_require__(66)
  , getOwnPropertyDescriptor = __webpack_require__(65).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(32) && $export($export.P + __webpack_require__(223), 'Object', {
  __lookupGetter__: function __lookupGetter__(P){
    var O = toObject(this)
      , K = toPrimitive(P, true)
      , D;
    do {
      if(D = getOwnPropertyDescriptor(O, K))return D.get;
    } while(O = getPrototypeOf(O));
  }
});

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export                  = __webpack_require__(6)
  , toObject                 = __webpack_require__(45)
  , toPrimitive              = __webpack_require__(80)
  , getPrototypeOf           = __webpack_require__(66)
  , getOwnPropertyDescriptor = __webpack_require__(65).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(32) && $export($export.P + __webpack_require__(223), 'Object', {
  __lookupSetter__: function __lookupSetter__(P){
    var O = toObject(this)
      , K = toPrimitive(P, true)
      , D;
    do {
      if(D = getOwnPropertyDescriptor(O, K))return D.set;
    } while(O = getPrototypeOf(O));
  }
});

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(6)
  , $values = __webpack_require__(470)(false);

$export($export.S, 'Object', {
  values: function values(it){
    return $values(it);
  }
});

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export     = __webpack_require__(6)
  , global      = __webpack_require__(21)
  , core        = __webpack_require__(87)
  , microtask   = __webpack_require__(306)()
  , OBSERVABLE  = __webpack_require__(29)('observable')
  , aFunction   = __webpack_require__(56)
  , anObject    = __webpack_require__(20)
  , anInstance  = __webpack_require__(119)
  , redefineAll = __webpack_require__(124)
  , hide        = __webpack_require__(57)
  , forOf       = __webpack_require__(142)
  , RETURN      = forOf.RETURN;

var getMethod = function(fn){
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function(subscription){
  var cleanup = subscription._c;
  if(cleanup){
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function(subscription){
  return subscription._o === undefined;
};

var closeSubscription = function(subscription){
  if(!subscriptionClosed(subscription)){
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function(observer, subscriber){
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup      = subscriber(observer)
      , subscription = cleanup;
    if(cleanup != null){
      if(typeof cleanup.unsubscribe === 'function')cleanup = function(){ subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch(e){
    observer.error(e);
    return;
  } if(subscriptionClosed(this))cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe(){ closeSubscription(this); }
});

var SubscriptionObserver = function(subscription){
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value){
    var subscription = this._s;
    if(!subscriptionClosed(subscription)){
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if(m)return m.call(observer, value);
      } catch(e){
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value){
    var subscription = this._s;
    if(subscriptionClosed(subscription))throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if(!m)throw value;
      value = m.call(observer, value);
    } catch(e){
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value){
    var subscription = this._s;
    if(!subscriptionClosed(subscription)){
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch(e){
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber){
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer){
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn){
    var that = this;
    return new (core.Promise || global.Promise)(function(resolve, reject){
      aFunction(fn);
      var subscription = that.subscribe({
        next : function(value){
          try {
            return fn(value);
          } catch(e){
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x){
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if(method){
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function(observer){
        return observable.subscribe(observer);
      });
    }
    return new C(function(observer){
      var done = false;
      microtask(function(){
        if(!done){
          try {
            if(forOf(x, false, function(it){
              observer.next(it);
              if(done)return RETURN;
            }) === RETURN)return;
          } catch(e){
            if(done)throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function(){ done = true; };
    });
  },
  of: function of(){
    for(var i = 0, l = arguments.length, items = Array(l); i < l;)items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function(observer){
      var done = false;
      microtask(function(){
        if(!done){
          for(var i = 0; i < items.length; ++i){
            observer.next(items[i]);
            if(done)return;
          } observer.complete();
        }
      });
      return function(){ done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function(){ return this; });

$export($export.G, {Observable: $Observable});

__webpack_require__(125)('Observable');

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

var metadata                  = __webpack_require__(89)
  , anObject                  = __webpack_require__(20)
  , toMetaKey                 = metadata.key
  , ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey){
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
}});

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

var metadata               = __webpack_require__(89)
  , anObject               = __webpack_require__(20)
  , toMetaKey              = metadata.key
  , getOrCreateMetadataMap = metadata.map
  , store                  = metadata.store;

metadata.exp({deleteMetadata: function deleteMetadata(metadataKey, target /*, targetKey */){
  var targetKey   = arguments.length < 3 ? undefined : toMetaKey(arguments[2])
    , metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if(metadataMap === undefined || !metadataMap['delete'](metadataKey))return false;
  if(metadataMap.size)return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
}});

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

var Set                     = __webpack_require__(479)
  , from                    = __webpack_require__(455)
  , metadata                = __webpack_require__(89)
  , anObject                = __webpack_require__(20)
  , getPrototypeOf          = __webpack_require__(66)
  , ordinaryOwnMetadataKeys = metadata.keys
  , toMetaKey               = metadata.key;

var ordinaryMetadataKeys = function(O, P){
  var oKeys  = ordinaryOwnMetadataKeys(O, P)
    , parent = getPrototypeOf(O);
  if(parent === null)return oKeys;
  var pKeys  = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({getMetadataKeys: function getMetadataKeys(target /*, targetKey */){
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
}});

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

var metadata               = __webpack_require__(89)
  , anObject               = __webpack_require__(20)
  , getPrototypeOf         = __webpack_require__(66)
  , ordinaryHasOwnMetadata = metadata.has
  , ordinaryGetOwnMetadata = metadata.get
  , toMetaKey              = metadata.key;

var ordinaryGetMetadata = function(MetadataKey, O, P){
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if(hasOwn)return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({getMetadata: function getMetadata(metadataKey, target /*, targetKey */){
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
}});

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

var metadata                = __webpack_require__(89)
  , anObject                = __webpack_require__(20)
  , ordinaryOwnMetadataKeys = metadata.keys
  , toMetaKey               = metadata.key;

metadata.exp({getOwnMetadataKeys: function getOwnMetadataKeys(target /*, targetKey */){
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
}});

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

var metadata               = __webpack_require__(89)
  , anObject               = __webpack_require__(20)
  , ordinaryGetOwnMetadata = metadata.get
  , toMetaKey              = metadata.key;

metadata.exp({getOwnMetadata: function getOwnMetadata(metadataKey, target /*, targetKey */){
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
}});

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

var metadata               = __webpack_require__(89)
  , anObject               = __webpack_require__(20)
  , getPrototypeOf         = __webpack_require__(66)
  , ordinaryHasOwnMetadata = metadata.has
  , toMetaKey              = metadata.key;

var ordinaryHasMetadata = function(MetadataKey, O, P){
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if(hasOwn)return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({hasMetadata: function hasMetadata(metadataKey, target /*, targetKey */){
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
}});

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

var metadata               = __webpack_require__(89)
  , anObject               = __webpack_require__(20)
  , ordinaryHasOwnMetadata = metadata.has
  , toMetaKey              = metadata.key;

metadata.exp({hasOwnMetadata: function hasOwnMetadata(metadataKey, target /*, targetKey */){
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
}});

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

var metadata                  = __webpack_require__(89)
  , anObject                  = __webpack_require__(20)
  , aFunction                 = __webpack_require__(56)
  , toMetaKey                 = metadata.key
  , ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({metadata: function metadata(metadataKey, metadataValue){
  return function decorator(target, targetKey){
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
}});

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export  = __webpack_require__(6);

$export($export.P + $export.R, 'Set', {toJSON: __webpack_require__(459)('Set')});

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(6)
  , $at     = __webpack_require__(310)(true);

$export($export.P, 'String', {
  at: function at(pos){
    return $at(this, pos);
  }
});

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export     = __webpack_require__(6)
  , defined     = __webpack_require__(75)
  , toLength    = __webpack_require__(43)
  , isRegExp    = __webpack_require__(221)
  , getFlags    = __webpack_require__(219)
  , RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function(regexp, string){
  this._r = regexp;
  this._s = string;
};

__webpack_require__(302)($RegExpStringIterator, 'RegExp String', function next(){
  var match = this._r.exec(this._s);
  return {value: match, done: match === null};
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp){
    defined(this);
    if(!isRegExp(regexp))throw TypeError(regexp + ' is not a regexp!');
    var S     = String(this)
      , flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp)
      , rx    = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(6)
  , $pad    = __webpack_require__(475);

$export($export.P, 'String', {
  padEnd: function padEnd(maxLength /*, fillString = ' ' */){
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(6)
  , $pad    = __webpack_require__(475);

$export($export.P, 'String', {
  padStart: function padStart(maxLength /*, fillString = ' ' */){
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(145)('trimLeft', function($trim){
  return function trimLeft(){
    return $trim(this, 1);
  };
}, 'trimStart');

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(145)('trimRight', function($trim){
  return function trimRight(){
    return $trim(this, 2);
  };
}, 'trimEnd');

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(316)('asyncIterator');

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(316)('observable');

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-global
var $export = __webpack_require__(6);

$export($export.S, 'System', {global: __webpack_require__(21)});

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators    = __webpack_require__(318)
  , redefine      = __webpack_require__(58)
  , global        = __webpack_require__(21)
  , hide          = __webpack_require__(57)
  , Iterators     = __webpack_require__(143)
  , wks           = __webpack_require__(29)
  , ITERATOR      = wks('iterator')
  , TO_STRING_TAG = wks('toStringTag')
  , ArrayValues   = Iterators.Array;

for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
  var NAME       = collections[i]
    , Collection = global[NAME]
    , proto      = Collection && Collection.prototype
    , key;
  if(proto){
    if(!proto[ITERATOR])hide(proto, ITERATOR, ArrayValues);
    if(!proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    for(key in $iterators)if(!proto[key])redefine(proto, key, $iterators[key], true);
  }
}

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(6)
  , $task   = __webpack_require__(314);
$export($export.G + $export.B, {
  setImmediate:   $task.set,
  clearImmediate: $task.clear
});

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global     = __webpack_require__(21)
  , $export    = __webpack_require__(6)
  , invoke     = __webpack_require__(220)
  , partial    = __webpack_require__(783)
  , navigator  = global.navigator
  , MSIE       = !!navigator && /MSIE .\./.test(navigator.userAgent); // <- dirty ie9- check
var wrap = function(set){
  return MSIE ? function(fn, time /*, ...args */){
    return set(invoke(
      partial,
      [].slice.call(arguments, 2),
      typeof fn == 'function' ? fn : Function(fn)
    ), time);
  } : set;
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout:  wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(906);
__webpack_require__(845);
__webpack_require__(847);
__webpack_require__(846);
__webpack_require__(849);
__webpack_require__(851);
__webpack_require__(856);
__webpack_require__(850);
__webpack_require__(848);
__webpack_require__(858);
__webpack_require__(857);
__webpack_require__(853);
__webpack_require__(854);
__webpack_require__(852);
__webpack_require__(844);
__webpack_require__(855);
__webpack_require__(859);
__webpack_require__(860);
__webpack_require__(812);
__webpack_require__(814);
__webpack_require__(813);
__webpack_require__(862);
__webpack_require__(861);
__webpack_require__(832);
__webpack_require__(842);
__webpack_require__(843);
__webpack_require__(833);
__webpack_require__(834);
__webpack_require__(835);
__webpack_require__(836);
__webpack_require__(837);
__webpack_require__(838);
__webpack_require__(839);
__webpack_require__(840);
__webpack_require__(841);
__webpack_require__(815);
__webpack_require__(816);
__webpack_require__(817);
__webpack_require__(818);
__webpack_require__(819);
__webpack_require__(820);
__webpack_require__(821);
__webpack_require__(822);
__webpack_require__(823);
__webpack_require__(824);
__webpack_require__(825);
__webpack_require__(826);
__webpack_require__(827);
__webpack_require__(828);
__webpack_require__(829);
__webpack_require__(830);
__webpack_require__(831);
__webpack_require__(893);
__webpack_require__(898);
__webpack_require__(905);
__webpack_require__(896);
__webpack_require__(888);
__webpack_require__(889);
__webpack_require__(894);
__webpack_require__(899);
__webpack_require__(901);
__webpack_require__(884);
__webpack_require__(885);
__webpack_require__(886);
__webpack_require__(887);
__webpack_require__(890);
__webpack_require__(891);
__webpack_require__(892);
__webpack_require__(895);
__webpack_require__(897);
__webpack_require__(900);
__webpack_require__(902);
__webpack_require__(903);
__webpack_require__(904);
__webpack_require__(807);
__webpack_require__(809);
__webpack_require__(808);
__webpack_require__(811);
__webpack_require__(810);
__webpack_require__(796);
__webpack_require__(794);
__webpack_require__(800);
__webpack_require__(797);
__webpack_require__(803);
__webpack_require__(805);
__webpack_require__(793);
__webpack_require__(799);
__webpack_require__(790);
__webpack_require__(804);
__webpack_require__(788);
__webpack_require__(802);
__webpack_require__(801);
__webpack_require__(795);
__webpack_require__(798);
__webpack_require__(787);
__webpack_require__(789);
__webpack_require__(792);
__webpack_require__(791);
__webpack_require__(806);
__webpack_require__(318);
__webpack_require__(878);
__webpack_require__(883);
__webpack_require__(478);
__webpack_require__(879);
__webpack_require__(880);
__webpack_require__(881);
__webpack_require__(882);
__webpack_require__(863);
__webpack_require__(477);
__webpack_require__(479);
__webpack_require__(480);
__webpack_require__(918);
__webpack_require__(907);
__webpack_require__(908);
__webpack_require__(913);
__webpack_require__(916);
__webpack_require__(917);
__webpack_require__(911);
__webpack_require__(914);
__webpack_require__(912);
__webpack_require__(915);
__webpack_require__(909);
__webpack_require__(910);
__webpack_require__(864);
__webpack_require__(865);
__webpack_require__(866);
__webpack_require__(867);
__webpack_require__(868);
__webpack_require__(871);
__webpack_require__(869);
__webpack_require__(870);
__webpack_require__(872);
__webpack_require__(873);
__webpack_require__(874);
__webpack_require__(875);
__webpack_require__(877);
__webpack_require__(876);
__webpack_require__(919);
__webpack_require__(945);
__webpack_require__(948);
__webpack_require__(947);
__webpack_require__(949);
__webpack_require__(950);
__webpack_require__(946);
__webpack_require__(951);
__webpack_require__(952);
__webpack_require__(930);
__webpack_require__(933);
__webpack_require__(929);
__webpack_require__(927);
__webpack_require__(928);
__webpack_require__(931);
__webpack_require__(932);
__webpack_require__(922);
__webpack_require__(944);
__webpack_require__(953);
__webpack_require__(921);
__webpack_require__(923);
__webpack_require__(925);
__webpack_require__(924);
__webpack_require__(926);
__webpack_require__(935);
__webpack_require__(936);
__webpack_require__(938);
__webpack_require__(937);
__webpack_require__(940);
__webpack_require__(939);
__webpack_require__(941);
__webpack_require__(942);
__webpack_require__(943);
__webpack_require__(920);
__webpack_require__(934);
__webpack_require__(956);
__webpack_require__(955);
__webpack_require__(954);
module.exports = __webpack_require__(87);

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(374);

var emptyObject = __webpack_require__(971);
var _invariant = __webpack_require__(373);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }
    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isInherited = name in Constructor;
      _invariant(
        !isInherited,
        'ReactClass: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be ' +
          'due to a mixin.',
        name
      );
      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".button__button__3p-kS{display:inline-block;height:36px;padding:0 16px;vertical-align:middle;font-family:HelveticaNeueW01-45Ligh,HelveticaNeueW02-45Ligh,HelveticaNeueW10-45Ligh,Helvetica Neue,ruble,Helvetica,Arial,sans-serif;font-size:16px;line-height:1;font-weight:300;text-align:center;text-decoration:none;border-radius:999px;border:1px solid transparent;background:none;outline:none;-ms-touch-action:manipulation;touch-action:manipulation;cursor:pointer;white-space:nowrap;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;transition:background .2s,color .2s,border .2s}.button__button__3p-kS.button__disabled__32Iqs,.button__button__3p-kS[disabled],fieldset[disabled] .button__button__3p-kS{cursor:not-allowed;pointer-events:none}.button__rounded-rect__3qgG9{border-radius:4px}.button__link-button__30goi{height:auto;padding:0;vertical-align:baseline;border:none;background:none;color:#3899ec;font:inherit}.button__link-button__30goi.button__disabled__32Iqs,.button__link-button__30goi[disabled],fieldset[disabled] .button__link-button__30goi{color:#c8c8c8}.button__link-premium-button__2ctZM{color:#aa4dc8}.button__primary-button__3rzNI,.button__primary-button__3rzNI:active{color:#fff;background-color:#3899ec;border-color:transparent}.button__primary-button__3rzNI:focus,.button__primary-button__3rzNI:hover{color:#fff;background-color:#4eb7f5;border-color:transparent}.button__primary-button__3rzNI.button__disabled__32Iqs,.button__primary-button__3rzNI.button__disabled__32Iqs:active,.button__primary-button__3rzNI.button__disabled__32Iqs:focus,.button__primary-button__3rzNI.button__disabled__32Iqs:hover,.button__primary-button__3rzNI[disabled],.button__primary-button__3rzNI[disabled]:active,.button__primary-button__3rzNI[disabled]:focus,.button__primary-button__3rzNI[disabled]:hover,fieldset[disabled] .button__primary-button__3rzNI,fieldset[disabled] .button__primary-button__3rzNI:active,fieldset[disabled] .button__primary-button__3rzNI:focus,fieldset[disabled] .button__primary-button__3rzNI:hover{color:#fff;background-color:#c8c8c8;border-color:transparent}.button__secondary-button__eg-R6{color:#3899ec;background-color:transparent;border-color:#6eb7fd}.button__secondary-button__eg-R6:focus,.button__secondary-button__eg-R6:hover{color:#fff;background-color:#4eb7f5;border-color:transparent}.button__secondary-button__eg-R6:active{color:#fff;background-color:#3899ec;border-color:transparent}.button__secondary-button__eg-R6.button__disabled__32Iqs,.button__secondary-button__eg-R6.button__disabled__32Iqs:active,.button__secondary-button__eg-R6.button__disabled__32Iqs:focus,.button__secondary-button__eg-R6.button__disabled__32Iqs:hover,.button__secondary-button__eg-R6[disabled],.button__secondary-button__eg-R6[disabled]:active,.button__secondary-button__eg-R6[disabled]:focus,.button__secondary-button__eg-R6[disabled]:hover,fieldset[disabled] .button__secondary-button__eg-R6,fieldset[disabled] .button__secondary-button__eg-R6:active,fieldset[disabled] .button__secondary-button__eg-R6:focus,fieldset[disabled] .button__secondary-button__eg-R6:hover{color:#c8c8c8;background-color:transparent;border-color:#c8c8c8}.button__danger-primary-button__3FaUZ,.button__danger-primary-button__3FaUZ:active{color:#fff;background-color:#ee5951;border-color:transparent}.button__danger-primary-button__3FaUZ:focus,.button__danger-primary-button__3FaUZ:hover{color:#fff;background-color:#f66;border-color:transparent}.button__danger-primary-button__3FaUZ.button__disabled__32Iqs,.button__danger-primary-button__3FaUZ.button__disabled__32Iqs:active,.button__danger-primary-button__3FaUZ.button__disabled__32Iqs:focus,.button__danger-primary-button__3FaUZ.button__disabled__32Iqs:hover,.button__danger-primary-button__3FaUZ[disabled],.button__danger-primary-button__3FaUZ[disabled]:active,.button__danger-primary-button__3FaUZ[disabled]:focus,.button__danger-primary-button__3FaUZ[disabled]:hover,fieldset[disabled] .button__danger-primary-button__3FaUZ,fieldset[disabled] .button__danger-primary-button__3FaUZ:active,fieldset[disabled] .button__danger-primary-button__3FaUZ:focus,fieldset[disabled] .button__danger-primary-button__3FaUZ:hover{color:#fff;background-color:#c8c8c8;border-color:transparent}.button__danger-secondary-button__3lrHk{color:#ec4d4d;background-color:transparent;border-color:#f1726b}.button__danger-secondary-button__3lrHk:focus,.button__danger-secondary-button__3lrHk:hover{color:#fff;background-color:#f66;border-color:transparent}.button__danger-secondary-button__3lrHk:active{color:#fff;background-color:#ee5951;border-color:transparent}.button__danger-secondary-button__3lrHk.button__disabled__32Iqs,.button__danger-secondary-button__3lrHk.button__disabled__32Iqs:active,.button__danger-secondary-button__3lrHk.button__disabled__32Iqs:focus,.button__danger-secondary-button__3lrHk.button__disabled__32Iqs:hover,.button__danger-secondary-button__3lrHk[disabled],.button__danger-secondary-button__3lrHk[disabled]:active,.button__danger-secondary-button__3lrHk[disabled]:focus,.button__danger-secondary-button__3lrHk[disabled]:hover,fieldset[disabled] .button__danger-secondary-button__3lrHk,fieldset[disabled] .button__danger-secondary-button__3lrHk:active,fieldset[disabled] .button__danger-secondary-button__3lrHk:focus,fieldset[disabled] .button__danger-secondary-button__3lrHk:hover{color:#c8c8c8;background-color:transparent;border-color:#c8c8c8}.button__premium-primary-button__HG6jx,.button__premium-primary-button__HG6jx:active{color:#fff;background-color:#aa4dc8;border-color:transparent}.button__premium-primary-button__HG6jx:focus,.button__premium-primary-button__HG6jx:hover{color:#fff;background-color:#cd68ed;border-color:transparent}.button__premium-primary-button__HG6jx.button__disabled__32Iqs,.button__premium-primary-button__HG6jx.button__disabled__32Iqs:active,.button__premium-primary-button__HG6jx.button__disabled__32Iqs:focus,.button__premium-primary-button__HG6jx.button__disabled__32Iqs:hover,.button__premium-primary-button__HG6jx[disabled],.button__premium-primary-button__HG6jx[disabled]:active,.button__premium-primary-button__HG6jx[disabled]:focus,.button__premium-primary-button__HG6jx[disabled]:hover,fieldset[disabled] .button__premium-primary-button__HG6jx,fieldset[disabled] .button__premium-primary-button__HG6jx:active,fieldset[disabled] .button__premium-primary-button__HG6jx:focus,fieldset[disabled] .button__premium-primary-button__HG6jx:hover{color:#fff;background-color:#c8c8c8;border-color:transparent}.button__premium-secondary-button__3KG2c{color:#aa4dc8;background-color:transparent;border-color:#aa4dc8}.button__premium-secondary-button__3KG2c:focus,.button__premium-secondary-button__3KG2c:hover{color:#fff;background-color:#cd68ed;border-color:transparent}.button__premium-secondary-button__3KG2c:active{color:#fff;background-color:#aa4dc8;border-color:transparent}.button__premium-secondary-button__3KG2c.button__disabled__32Iqs,.button__premium-secondary-button__3KG2c.button__disabled__32Iqs:active,.button__premium-secondary-button__3KG2c.button__disabled__32Iqs:focus,.button__premium-secondary-button__3KG2c.button__disabled__32Iqs:hover,.button__premium-secondary-button__3KG2c[disabled],.button__premium-secondary-button__3KG2c[disabled]:active,.button__premium-secondary-button__3KG2c[disabled]:focus,.button__premium-secondary-button__3KG2c[disabled]:hover,fieldset[disabled] .button__premium-secondary-button__3KG2c,fieldset[disabled] .button__premium-secondary-button__3KG2c:active,fieldset[disabled] .button__premium-secondary-button__3KG2c:focus,fieldset[disabled] .button__premium-secondary-button__3KG2c:hover{color:#c8c8c8;background-color:transparent;border-color:#c8c8c8}.button__transparent-white-button__Wjab-,.button__transparent-white-button__Wjab-:active{color:#fff;background-color:transparent;border-color:#fff}.button__transparent-white-button__Wjab-:focus,.button__transparent-white-button__Wjab-:hover{color:#fff;background-color:hsla(0,0%,100%,.75);border-color:#fff}.button__transparent-white-button__Wjab-.button__disabled__32Iqs,.button__transparent-white-button__Wjab-.button__disabled__32Iqs:active,.button__transparent-white-button__Wjab-.button__disabled__32Iqs:focus,.button__transparent-white-button__Wjab-.button__disabled__32Iqs:hover,.button__transparent-white-button__Wjab-[disabled],.button__transparent-white-button__Wjab-[disabled]:active,.button__transparent-white-button__Wjab-[disabled]:focus,.button__transparent-white-button__Wjab-[disabled]:hover,fieldset[disabled] .button__transparent-white-button__Wjab-,fieldset[disabled] .button__transparent-white-button__Wjab-:active,fieldset[disabled] .button__transparent-white-button__Wjab-:focus,fieldset[disabled] .button__transparent-white-button__Wjab-:hover{color:#c8c8c8;background-color:transparent;border-color:#c8c8c8}.button__white-blue-button__3RKvO{color:#4eb7f5;background-color:#fff;border-color:#fff}.button__white-blue-button__3RKvO:active,.button__white-blue-button__3RKvO:focus,.button__white-blue-button__3RKvO:hover{color:#3899ec;background-color:#fff;border-color:#fff}.button__white-blue-button__3RKvO.button__disabled__32Iqs,.button__white-blue-button__3RKvO.button__disabled__32Iqs:active,.button__white-blue-button__3RKvO.button__disabled__32Iqs:focus,.button__white-blue-button__3RKvO.button__disabled__32Iqs:hover,.button__white-blue-button__3RKvO[disabled],.button__white-blue-button__3RKvO[disabled]:active,.button__white-blue-button__3RKvO[disabled]:focus,.button__white-blue-button__3RKvO[disabled]:hover,fieldset[disabled] .button__white-blue-button__3RKvO,fieldset[disabled] .button__white-blue-button__3RKvO:active,fieldset[disabled] .button__white-blue-button__3RKvO:focus,fieldset[disabled] .button__white-blue-button__3RKvO:hover{color:#c8c8c8;background-color:#fff;border-color:#fff}", ""]);

// exports
exports.locals = {
	"button": "button__button__3p-kS",
	"disabled": "button__disabled__32Iqs",
	"rounded-rect": "button__rounded-rect__3qgG9",
	"roundedRect": "button__rounded-rect__3qgG9",
	"link-button": "button__link-button__30goi",
	"linkButton": "button__link-button__30goi",
	"link-premium-button": "button__link-premium-button__2ctZM",
	"linkPremiumButton": "button__link-premium-button__2ctZM",
	"primary-button": "button__primary-button__3rzNI",
	"primaryButton": "button__primary-button__3rzNI",
	"secondary-button": "button__secondary-button__eg-R6",
	"secondaryButton": "button__secondary-button__eg-R6",
	"danger-primary-button": "button__danger-primary-button__3FaUZ",
	"dangerPrimaryButton": "button__danger-primary-button__3FaUZ",
	"danger-secondary-button": "button__danger-secondary-button__3lrHk",
	"dangerSecondaryButton": "button__danger-secondary-button__3lrHk",
	"premium-primary-button": "button__premium-primary-button__HG6jx",
	"premiumPrimaryButton": "button__premium-primary-button__HG6jx",
	"premium-secondary-button": "button__premium-secondary-button__3KG2c",
	"premiumSecondaryButton": "button__premium-secondary-button__3KG2c",
	"transparent-white-button": "button__transparent-white-button__Wjab-",
	"transparentWhiteButton": "button__transparent-white-button__Wjab-",
	"white-blue-button": "button__white-blue-button__3RKvO",
	"whiteBlueButton": "button__white-blue-button__3RKvO"
};

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".icon__generic__2N-mH{width:35px;height:35px;padding:0;border:none;color:#6eb7fd;background:#fff;transition-property:border,background,color,opacity;transition-duration:.2s;text-align:center;vertical-align:middle}.icon__generic__2N-mH:hover{color:#3899ec;background:#eaf7ff}.icon__text__1CDKw{margin-left:8px}", ""]);

// exports
exports.locals = {
	"generic": "icon__generic__2N-mH",
	"text": "icon__text__1CDKw"
};

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".icon__icon__1DH8U{font-family:fontello-vod;font-style:normal;font-weight:400;speak:none;text-decoration:inherit;font-variant:normal;text-transform:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.icon__rounded-icon__37CwH{display:-ms-inline-flexbox;display:inline-flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;border:1px solid #000;border-radius:50%}", ""]);

// exports
exports.locals = {
	"icon": "icon__icon__1DH8U",
	"rounded-icon": "icon__rounded-icon__37CwH",
	"roundedIcon": "icon__rounded-icon__37CwH"
};

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".popout__content__2wF0V{position:absolute;z-index:1000;width:330px;min-height:100px}.popout__triangle__3q-Sr{position:absolute;width:12px;height:12px;background:#fff;transform:rotate(45deg)}.popout__before__cDV2N{z-index:1;box-shadow:0 0 11px 0 rgba(0,0,0,.21)}.popout__after__vPjC2{z-index:3}.popout__inner__PCBv0{position:relative;z-index:2;min-height:100px;padding:13px 10px 18px;border-radius:6px;background:#fff;box-shadow:0 0 11px 0 rgba(0,0,0,.21)}.popout__inner__PCBv0>section{height:100%;border-radius:6px;overflow:auto}.popout__triangle-none__2sblF>.popout__triangle__3q-Sr{display:none}.popout__triangle-top__35qWm>.popout__triangle__3q-Sr{top:-4px;left:calc(50% - 6px)}.popout__triangle-right__13Rb7>.popout__triangle__3q-Sr{right:-4px;top:calc(50% - 6px)}.popout__triangle-bottom__3Gk2x>.popout__triangle__3q-Sr{bottom:-4px;left:calc(50% - 6px)}.popout__triangle-left__gHT5L>.popout__triangle__3q-Sr{left:-4px;top:calc(50% - 6px)}.popout__triangle-end__1XiX2.popout__triangle-top__35qWm>.popout__triangle__3q-Sr{left:calc(100% - 37px)}.popout__triangle-end__1XiX2.popout__triangle-right__13Rb7>.popout__triangle__3q-Sr{top:calc(100% - 37px)}.popout__triangle-end__1XiX2.popout__triangle-bottom__3Gk2x>.popout__triangle__3q-Sr{left:calc(100% - 37px)}.popout__triangle-end__1XiX2.popout__triangle-left__gHT5L>.popout__triangle__3q-Sr{top:calc(100% - 37px)}.popout__triangle-start__3CsWE.popout__triangle-top__35qWm>.popout__triangle__3q-Sr{left:25px}.popout__triangle-start__3CsWE.popout__triangle-right__13Rb7>.popout__triangle__3q-Sr{top:25px}.popout__triangle-start__3CsWE.popout__triangle-bottom__3Gk2x>.popout__triangle__3q-Sr{left:25px}.popout__triangle-start__3CsWE.popout__triangle-left__gHT5L>.popout__triangle__3q-Sr{top:25px}.popout__yellow-stripe__uigmj.popout__triangle-left__gHT5L>.popout__triangle__3q-Sr{background:#fcbc40}.popout__yellow-stripe__uigmj .popout__stripe__3A2i6{position:absolute;z-index:4;top:0;left:0;bottom:0}.popout__yellow-stripe__uigmj .popout__stripe-yellow__1tCOf{width:5px;border-top-left-radius:6px;border-bottom-left-radius:6px;background:#fcbc40}.popout__yellow-stripe__uigmj .popout__stripe-white__l4ucY{left:5px;width:5px;background:#fff}.popout__purple-stripe__2IuVK.popout__triangle-left__gHT5L>.popout__triangle__3q-Sr{background:#aa4dc8}.popout__purple-stripe__2IuVK .popout__stripe__3A2i6{position:absolute;z-index:4;top:0;left:0;bottom:0}.popout__purple-stripe__2IuVK .popout__stripe-purple__m9Mll{width:5px;border-top-left-radius:6px;border-bottom-left-radius:6px;background:#aa4dc8}.popout__purple-stripe__2IuVK .popout__stripe-white__l4ucY{left:5px;width:5px;background:#fff}.popout__blue-stripe__DPU62>.popout__inner__PCBv0{padding:16px 0 23px}.popout__blue-stripe__DPU62.popout__triangle-top__35qWm>.popout__triangle__3q-Sr{background:#3899ec}.popout__blue-stripe__DPU62>.popout__stripe__3A2i6{position:absolute;z-index:4;top:0;left:0;right:0}.popout__blue-stripe__DPU62>.popout__stripe-blue__2uhID{height:16px;border-top-left-radius:6px;border-top-right-radius:6px;background:#3899ec}", ""]);

// exports
exports.locals = {
	"content": "popout__content__2wF0V",
	"triangle": "popout__triangle__3q-Sr",
	"before": "popout__before__cDV2N",
	"after": "popout__after__vPjC2",
	"inner": "popout__inner__PCBv0",
	"triangle-none": "popout__triangle-none__2sblF",
	"triangleNone": "popout__triangle-none__2sblF",
	"triangle-top": "popout__triangle-top__35qWm",
	"triangleTop": "popout__triangle-top__35qWm",
	"triangle-right": "popout__triangle-right__13Rb7",
	"triangleRight": "popout__triangle-right__13Rb7",
	"triangle-bottom": "popout__triangle-bottom__3Gk2x",
	"triangleBottom": "popout__triangle-bottom__3Gk2x",
	"triangle-left": "popout__triangle-left__gHT5L",
	"triangleLeft": "popout__triangle-left__gHT5L",
	"triangle-end": "popout__triangle-end__1XiX2",
	"triangleEnd": "popout__triangle-end__1XiX2",
	"triangle-start": "popout__triangle-start__3CsWE",
	"triangleStart": "popout__triangle-start__3CsWE",
	"yellow-stripe": "popout__yellow-stripe__uigmj",
	"yellowStripe": "popout__yellow-stripe__uigmj",
	"stripe": "popout__stripe__3A2i6",
	"stripe-yellow": "popout__stripe-yellow__1tCOf",
	"stripeYellow": "popout__stripe-yellow__1tCOf",
	"stripe-white": "popout__stripe-white__l4ucY",
	"stripeWhite": "popout__stripe-white__l4ucY",
	"purple-stripe": "popout__purple-stripe__2IuVK",
	"purpleStripe": "popout__purple-stripe__2IuVK",
	"stripe-purple": "popout__stripe-purple__m9Mll",
	"stripePurple": "popout__stripe-purple__m9Mll",
	"blue-stripe": "popout__blue-stripe__DPU62",
	"blueStripe": "popout__blue-stripe__DPU62",
	"stripe-blue": "popout__stripe-blue__2uhID",
	"stripeBlue": "popout__stripe-blue__2uhID"
};

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".resized-image__resized-image__3OS6E{background-size:cover;background-position:50%;background-repeat:no-repeat}", ""]);

// exports
exports.locals = {
	"resized-image": "resized-image__resized-image__3OS6E",
	"resizedImage": "resized-image__resized-image__3OS6E"
};

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".tooltip__icon__2vxdf{display:-ms-inline-flexbox;display:inline-flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:19px;height:19px;border-radius:50%;color:#3899ec;font-size:11px;background:#ebf8ff}.tooltip__popout__3ot-d{position:absolute;top:0;left:0;z-index:10000;-ms-flex:0 0 auto;flex:0 0 auto;width:auto;min-height:0;color:#20455e;font-family:HelveticaNeueW01-45Ligh,HelveticaNeueW02-45Ligh,HelveticaNeueW10-45Ligh,Helvetica Neue,ruble,Helvetica,Arial,sans-serif;font-size:14px;line-height:20px;font-weight:300;visibility:hidden;opacity:0;transition:visibility .2s,opacity .2s}.tooltip__popout__3ot-d.tooltip__positioned__B9Q87{visibility:visible;opacity:1}.tooltip__popout-inner__2Lac9{min-height:0;padding:15px 18px;white-space:pre-line}", ""]);

// exports
exports.locals = {
	"icon": "tooltip__icon__2vxdf",
	"popout": "tooltip__popout__3ot-d",
	"positioned": "tooltip__positioned__B9Q87",
	"popout-inner": "tooltip__popout-inner__2Lac9",
	"popoutInner": "tooltip__popout-inner__2Lac9"
};

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".with-tooltip__tooltip-inner__3Upbz{padding:13px 16px 15px;white-space:nowrap}", ""]);

// exports
exports.locals = {
	"tooltip-inner": "with-tooltip__tooltip-inner__3Upbz",
	"tooltipInner": "with-tooltip__tooltip-inner__3Upbz"
};

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, "html{font-family:sans-serif;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background-color:transparent}a:active,a:hover{outline:0}abbr[title]{border-bottom:1px dotted}b,strong{font-weight:700}dfn{font-style:italic}h1{font-size:2em;margin:.67em 0}mark{background:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}img{border:0}svg:not(:root){overflow:hidden}figure{margin:1em 40px}hr{box-sizing:content-box;height:0}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}button,input,optgroup,select,textarea{color:inherit;font:inherit;margin:0}button{overflow:visible}button,select{text-transform:none}button,html input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:default}button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0}input{line-height:normal}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{-webkit-appearance:textfield;box-sizing:content-box}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}fieldset{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}legend{border:0;padding:0}textarea{overflow:auto}optgroup{font-weight:700}table{border-collapse:collapse;border-spacing:0}td,th{padding:0}@font-face{font-family:fontello-vod;src:url(" + __webpack_require__(1179) + ") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:ruble;src:url(" + __webpack_require__(1180) + ") format(\"woff\");font-weight:400;font-style:normal}html{box-sizing:border-box}body,html{margin:0;padding:0;height:100%;font-family:Helvetica Neue}:not(input):not(textarea){-webkit-user-select:auto;-moz-user-select:auto;-ms-user-select:auto;user-select:auto}input::-ms-clear{display:none}*,:after,:before{box-sizing:inherit}", ""]);

// exports


/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".fontello-codes__icon--feedback__S7_Dt:before{content:\"\\E800\"}.fontello-codes__icon--help__33_FP:before{content:\"\\E801\"}.fontello-codes__icon--edit__2W476:before{content:\"\\E802\"}.fontello-codes__icon--add__3SOoY:before{content:\"\\E803\"}.fontello-codes__icon--toggle-on__16wRm:before{content:\"\\E804\"}.fontello-codes__icon--toggle-off__FlxTF:before{content:\"\\E805\"}.fontello-codes__icon--close__3KzNc:before{content:\"\\E806\"}.fontello-codes__icon--eye__2YE8q:before{content:\"\\E807\"}.fontello-codes__icon--add-circle__3F481:before{content:\"\\E808\"}.fontello-codes__icon--check__3VM-u:before{content:\"\\E809\"}.fontello-codes__icon--arrow-upload__3PRM2:before{content:\"\\E80A\"}.fontello-codes__icon--exclamation__2sD9I:before{content:\"\\E80B\"}.fontello-codes__icon--triangle-right__35Ap0:before{content:\"\\E80C\"}.fontello-codes__icon--triangle-down__3_oYM:before{content:\"\\E80D\"}.fontello-codes__icon--remove__2m6Fm:before{content:\"\\E80E\"}.fontello-codes__icon--remove-transparent__d_USp:before{content:\"\\E80F\"}.fontello-codes__icon--exit__NwxeF:before{content:\"\\E810\"}.fontello-codes__icon--video-small__39Jdl:before{content:\"\\E811\"}.fontello-codes__icon--videos-small__fDnE0:before{content:\"\\E812\"}.fontello-codes__icon--stats__2MHAW:before{content:\"\\E813\"}.fontello-codes__icon--search-long__2Vbm1:before{content:\"\\E814\"}.fontello-codes__icon--info__1o0m2:before{content:\"\\E815\"}.fontello-codes__icon--arrow-left__C0O02:before{content:\"\\E816\"}.fontello-codes__icon--search-clear__2yrZ0:before{content:\"\\E817\"}.fontello-codes__icon--search-arrow__IYcC9:before{content:\"\\E818\"}.fontello-codes__icon--price-tag__LUeDZ:before{content:\"\\E819\"}.fontello-codes__icon--paid__30ls7:before{content:\"\\E81A\"}.fontello-codes__icon--calendar__CF1kt:before{content:\"\\E81B\"}.fontello-codes__icon--star__1Top0:before{content:\"\\E81C\"}.fontello-codes__icon--share__3qeKh:before{content:\"\\E81D\"}.fontello-codes__icon--info-1__27_6Z:before{content:\"\\E81E\"}.fontello-codes__icon--search__sGptj:before{content:\"\\E81F\"}.fontello-codes__icon--permit-search__323G3:before{content:\"\\E820\"}.fontello-codes__icon--search-bar__1orV4:before{content:\"\\E821\"}.fontello-codes__icon--checked__1ha50:before{content:\"\\E822\"}.fontello-codes__icon--arrow-right-filled__3FT8j:before{content:\"\\E823\"}.fontello-codes__icon--clear-search__1z9I5:before{content:\"\\E824\"}.fontello-codes__icon--actionbuttoninfo__1bcyJ:before{content:\"\\E825\"}.fontello-codes__icon--facebook__2Kz02:before{content:\"\\E828\"}.fontello-codes__icon--pinterest__2L1CJ:before{content:\"\\E829\"}.fontello-codes__icon--tumblr__hGTIW:before{content:\"\\E82A\"}.fontello-codes__icon--twitter__8P_MF:before{content:\"\\E82B\"}.fontello-codes__icon--coins__1gqNP:before{content:\"\\E82C\"}.fontello-codes__icon--more__2GHH1:before{content:\"\\E82E\"}.fontello-codes__icon--sort-arrow__1NmPS:before{content:\"\\E82F\"}.fontello-codes__icon--video-facebook__2xWsj:before{content:\"\\E832\"}.fontello-codes__icon--video-vimeo__1Xq1R:before{content:\"\\E833\"}.fontello-codes__icon--video-computer__19aMc:before{content:\"\\E837\"}.fontello-codes__icon--video-youtube__2gFsz:before{content:\"\\E83C\"}.fontello-codes__icon--cancel-upload__3OA5X:before{content:\"\\E84A\"}.fontello-codes__icon--crown__OVEZ5:before{content:\"\\E84B\"}.fontello-codes__icon--plus__1ujsq:before{content:\"\\E86C\"}.fontello-codes__icon--replace__3MKq7:before{content:\"\\E86D\"}.fontello-codes__icon--avatar__23YbC:before{content:\"\\E873\"}.fontello-codes__icon--view__3Y0tZ:before{content:\"\\E874\"}.fontello-codes__icon--arrow-strip__BExM7:before{content:\"\\E87F\"}.fontello-codes__icon--thin-x__3rpzm:before{content:\"\\E8C3\"}", ""]);

// exports
exports.locals = {
	"icon--feedback": "fontello-codes__icon--feedback__S7_Dt",
	"iconFeedback": "fontello-codes__icon--feedback__S7_Dt",
	"icon--help": "fontello-codes__icon--help__33_FP",
	"iconHelp": "fontello-codes__icon--help__33_FP",
	"icon--edit": "fontello-codes__icon--edit__2W476",
	"iconEdit": "fontello-codes__icon--edit__2W476",
	"icon--add": "fontello-codes__icon--add__3SOoY",
	"iconAdd": "fontello-codes__icon--add__3SOoY",
	"icon--toggle-on": "fontello-codes__icon--toggle-on__16wRm",
	"iconToggleOn": "fontello-codes__icon--toggle-on__16wRm",
	"icon--toggle-off": "fontello-codes__icon--toggle-off__FlxTF",
	"iconToggleOff": "fontello-codes__icon--toggle-off__FlxTF",
	"icon--close": "fontello-codes__icon--close__3KzNc",
	"iconClose": "fontello-codes__icon--close__3KzNc",
	"icon--eye": "fontello-codes__icon--eye__2YE8q",
	"iconEye": "fontello-codes__icon--eye__2YE8q",
	"icon--add-circle": "fontello-codes__icon--add-circle__3F481",
	"iconAddCircle": "fontello-codes__icon--add-circle__3F481",
	"icon--check": "fontello-codes__icon--check__3VM-u",
	"iconCheck": "fontello-codes__icon--check__3VM-u",
	"icon--arrow-upload": "fontello-codes__icon--arrow-upload__3PRM2",
	"iconArrowUpload": "fontello-codes__icon--arrow-upload__3PRM2",
	"icon--exclamation": "fontello-codes__icon--exclamation__2sD9I",
	"iconExclamation": "fontello-codes__icon--exclamation__2sD9I",
	"icon--triangle-right": "fontello-codes__icon--triangle-right__35Ap0",
	"iconTriangleRight": "fontello-codes__icon--triangle-right__35Ap0",
	"icon--triangle-down": "fontello-codes__icon--triangle-down__3_oYM",
	"iconTriangleDown": "fontello-codes__icon--triangle-down__3_oYM",
	"icon--remove": "fontello-codes__icon--remove__2m6Fm",
	"iconRemove": "fontello-codes__icon--remove__2m6Fm",
	"icon--remove-transparent": "fontello-codes__icon--remove-transparent__d_USp",
	"iconRemoveTransparent": "fontello-codes__icon--remove-transparent__d_USp",
	"icon--exit": "fontello-codes__icon--exit__NwxeF",
	"iconExit": "fontello-codes__icon--exit__NwxeF",
	"icon--video-small": "fontello-codes__icon--video-small__39Jdl",
	"iconVideoSmall": "fontello-codes__icon--video-small__39Jdl",
	"icon--videos-small": "fontello-codes__icon--videos-small__fDnE0",
	"iconVideosSmall": "fontello-codes__icon--videos-small__fDnE0",
	"icon--stats": "fontello-codes__icon--stats__2MHAW",
	"iconStats": "fontello-codes__icon--stats__2MHAW",
	"icon--search-long": "fontello-codes__icon--search-long__2Vbm1",
	"iconSearchLong": "fontello-codes__icon--search-long__2Vbm1",
	"icon--info": "fontello-codes__icon--info__1o0m2",
	"iconInfo": "fontello-codes__icon--info__1o0m2",
	"icon--arrow-left": "fontello-codes__icon--arrow-left__C0O02",
	"iconArrowLeft": "fontello-codes__icon--arrow-left__C0O02",
	"icon--search-clear": "fontello-codes__icon--search-clear__2yrZ0",
	"iconSearchClear": "fontello-codes__icon--search-clear__2yrZ0",
	"icon--search-arrow": "fontello-codes__icon--search-arrow__IYcC9",
	"iconSearchArrow": "fontello-codes__icon--search-arrow__IYcC9",
	"icon--price-tag": "fontello-codes__icon--price-tag__LUeDZ",
	"iconPriceTag": "fontello-codes__icon--price-tag__LUeDZ",
	"icon--paid": "fontello-codes__icon--paid__30ls7",
	"iconPaid": "fontello-codes__icon--paid__30ls7",
	"icon--calendar": "fontello-codes__icon--calendar__CF1kt",
	"iconCalendar": "fontello-codes__icon--calendar__CF1kt",
	"icon--star": "fontello-codes__icon--star__1Top0",
	"iconStar": "fontello-codes__icon--star__1Top0",
	"icon--share": "fontello-codes__icon--share__3qeKh",
	"iconShare": "fontello-codes__icon--share__3qeKh",
	"icon--info-1": "fontello-codes__icon--info-1__27_6Z",
	"iconInfo1": "fontello-codes__icon--info-1__27_6Z",
	"icon--search": "fontello-codes__icon--search__sGptj",
	"iconSearch": "fontello-codes__icon--search__sGptj",
	"icon--permit-search": "fontello-codes__icon--permit-search__323G3",
	"iconPermitSearch": "fontello-codes__icon--permit-search__323G3",
	"icon--search-bar": "fontello-codes__icon--search-bar__1orV4",
	"iconSearchBar": "fontello-codes__icon--search-bar__1orV4",
	"icon--checked": "fontello-codes__icon--checked__1ha50",
	"iconChecked": "fontello-codes__icon--checked__1ha50",
	"icon--arrow-right-filled": "fontello-codes__icon--arrow-right-filled__3FT8j",
	"iconArrowRightFilled": "fontello-codes__icon--arrow-right-filled__3FT8j",
	"icon--clear-search": "fontello-codes__icon--clear-search__1z9I5",
	"iconClearSearch": "fontello-codes__icon--clear-search__1z9I5",
	"icon--actionbuttoninfo": "fontello-codes__icon--actionbuttoninfo__1bcyJ",
	"iconActionbuttoninfo": "fontello-codes__icon--actionbuttoninfo__1bcyJ",
	"icon--facebook": "fontello-codes__icon--facebook__2Kz02",
	"iconFacebook": "fontello-codes__icon--facebook__2Kz02",
	"icon--pinterest": "fontello-codes__icon--pinterest__2L1CJ",
	"iconPinterest": "fontello-codes__icon--pinterest__2L1CJ",
	"icon--tumblr": "fontello-codes__icon--tumblr__hGTIW",
	"iconTumblr": "fontello-codes__icon--tumblr__hGTIW",
	"icon--twitter": "fontello-codes__icon--twitter__8P_MF",
	"iconTwitter": "fontello-codes__icon--twitter__8P_MF",
	"icon--coins": "fontello-codes__icon--coins__1gqNP",
	"iconCoins": "fontello-codes__icon--coins__1gqNP",
	"icon--more": "fontello-codes__icon--more__2GHH1",
	"iconMore": "fontello-codes__icon--more__2GHH1",
	"icon--sort-arrow": "fontello-codes__icon--sort-arrow__1NmPS",
	"iconSortArrow": "fontello-codes__icon--sort-arrow__1NmPS",
	"icon--video-facebook": "fontello-codes__icon--video-facebook__2xWsj",
	"iconVideoFacebook": "fontello-codes__icon--video-facebook__2xWsj",
	"icon--video-vimeo": "fontello-codes__icon--video-vimeo__1Xq1R",
	"iconVideoVimeo": "fontello-codes__icon--video-vimeo__1Xq1R",
	"icon--video-computer": "fontello-codes__icon--video-computer__19aMc",
	"iconVideoComputer": "fontello-codes__icon--video-computer__19aMc",
	"icon--video-youtube": "fontello-codes__icon--video-youtube__2gFsz",
	"iconVideoYoutube": "fontello-codes__icon--video-youtube__2gFsz",
	"icon--cancel-upload": "fontello-codes__icon--cancel-upload__3OA5X",
	"iconCancelUpload": "fontello-codes__icon--cancel-upload__3OA5X",
	"icon--crown": "fontello-codes__icon--crown__OVEZ5",
	"iconCrown": "fontello-codes__icon--crown__OVEZ5",
	"icon--plus": "fontello-codes__icon--plus__1ujsq",
	"iconPlus": "fontello-codes__icon--plus__1ujsq",
	"icon--replace": "fontello-codes__icon--replace__3MKq7",
	"iconReplace": "fontello-codes__icon--replace__3MKq7",
	"icon--avatar": "fontello-codes__icon--avatar__23YbC",
	"iconAvatar": "fontello-codes__icon--avatar__23YbC",
	"icon--view": "fontello-codes__icon--view__3Y0tZ",
	"iconView": "fontello-codes__icon--view__3Y0tZ",
	"icon--arrow-strip": "fontello-codes__icon--arrow-strip__BExM7",
	"iconArrowStrip": "fontello-codes__icon--arrow-strip__BExM7",
	"icon--thin-x": "fontello-codes__icon--thin-x__3rpzm",
	"iconThinX": "fontello-codes__icon--thin-x__3rpzm"
};

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isImmutable = isImmutable;
exports.getIn = getIn;
exports.setIn = setIn;
exports.moveUnionToSchema = moveUnionToSchema;

var _reduce = __webpack_require__(508);

var _reduce2 = _interopRequireDefault(_reduce);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Helpers to enable Immutable-JS compatibility.
 */

function stringifiedArray(array) {
  return array.map(function (item) {
    return item && item.toString();
  });
}

/**
 * To avoid including immutable-js as a dependency, check if an object is
 * immutable by checking if it implements the getIn method.
 *
 * @param  {Any} object
 * @return {Boolean}
 */
function isImmutable(object) {
  return object && !!object.getIn;
}

/**
 * If the object responds to getIn, that's called directly. Otherwise
 * recursively apply object/array access to get the value.
 *
 * @param  {Object, Immutable.Map, Immutable.Record} object
 * @param  {Array<string, number>} keyPath
 * @return {Any}
 */
function getIn(object, keyPath) {
  if (object.getIn) {
    return object.getIn(stringifiedArray(keyPath));
  }

  return (0, _reduce2.default)(keyPath, function (memo, key) {
    return memo[key];
  }, object);
}

/**
 * If the object responds to setIn, that's called directly. Otherwise
 * recursively apply object/array access and set the value at that location.
 *
 * @param  {Object, Immutable.Map, Immutable.Record} object
 * @param  {Array<string, number>} keyPath
 * @param  {Any} value
 * @return {Any}
 */
function setIn(object, keyPath, value) {
  if (object.setIn) {
    return object.setIn(stringifiedArray(keyPath), value);
  }

  var lastKey = keyPath.pop();
  var location = getIn(object, keyPath);

  location[lastKey] = value;

  return object;
}

/**
 * Moves the union to a property with the appropriate schema name.
 *
 * @param  {Object, Immutable.Map, Immutable.Record} object
 * @return {Any}
 */
function moveUnionToSchema(entity) {
  if (isImmutable(entity)) {
    return _defineProperty({}, entity.get('schema'), entity.get('id'));
  }

  return Object.assign({}, entity, _defineProperty({}, entity.schema, entity.id));
}

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.denormalize = denormalize;

var _IterableSchema = __webpack_require__(510);

var _IterableSchema2 = _interopRequireDefault(_IterableSchema);

var _EntitySchema = __webpack_require__(509);

var _EntitySchema2 = _interopRequireDefault(_EntitySchema);

var _UnionSchema = __webpack_require__(342);

var _UnionSchema2 = _interopRequireDefault(_UnionSchema);

var _merge = __webpack_require__(1107);

var _merge2 = _interopRequireDefault(_merge);

var _isObject = __webpack_require__(41);

var _isObject2 = _interopRequireDefault(_isObject);

var _ImmutableUtils = __webpack_require__(968);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Take either an entity or id and derive the other.
 *
 * @param   {object|Immutable.Map|number|string} entityOrId
 * @param   {object|Immutable.Map} entities
 * @param   {Schema} schema
 * @returns {object}
 */
function resolveEntityOrId(entityOrId, entities, schema) {
  var key = schema.getKey();

  var entity = entityOrId;
  var id = entityOrId;

  if ((0, _isObject2.default)(entityOrId)) {
    id = (0, _ImmutableUtils.getIn)(entity, [schema.getIdAttribute()]);
  } else {
    entity = (0, _ImmutableUtils.getIn)(entities, [key, id]);
  }

  return { entity: entity, id: id };
}

/**
 * Denormalizes each entity in the given array.
 *
 * @param   {Array|Immutable.List} items
 * @param   {object|Immutable.Map} entities
 * @param   {Schema} schema
 * @param   {object} bag
 * @returns {Array|Immutable.List}
 */
function denormalizeIterable(items, entities, schema, bag) {
  var itemSchema = schema.getItemSchema();
  var isMappable = typeof items.map === 'function';

  // Handle arrayOf iterables
  if (isMappable) {
    return items.map(function (o) {
      return denormalize(o, entities, itemSchema, bag);
    });
  }

  // Handle valuesOf iterables
  var denormalized = {};
  Object.keys(items).forEach(function (key) {
    denormalized[key] = denormalize(items[key], entities, itemSchema, bag);
  });
  return denormalized;
}

/**
 * @param   {object|Immutable.Map|number|string} entity
 * @param   {object|Immutable.Map} entities
 * @param   {Schema} schema
 * @param   {object} bag
 * @returns {object|Immutable.Map}
 */
function denormalizeUnion(entity, entities, schema, bag) {
  var itemSchema = schema.getItemSchema();
  var denormalized = denormalize((0, _ImmutableUtils.moveUnionToSchema)(entity), entities, itemSchema, bag);
  return (0, _ImmutableUtils.getIn)(denormalized, [(0, _ImmutableUtils.isImmutable)(entity) ? entity.get('schema') : entity.schema]);
}

/**
 * Takes an object and denormalizes it.
 *
 * Note: For non-immutable objects, this will mutate the object. This is
 * necessary for handling circular dependencies. In order to not mutate the
 * original object, the caller should copy the object before passing it here.
 *
 * @param   {object|Immutable.Map} obj
 * @param   {object|Immutable.Map} entities
 * @param   {Schema} schema
 * @param   {object} bag
 * @returns {object|Immutable.Map}
 */
function denormalizeObject(obj, entities, schema, bag) {
  var denormalized = obj;

  Object.keys(schema).filter(function (attribute) {
    return attribute.substring(0, 1) !== '_';
  }).filter(function (attribute) {
    return typeof (0, _ImmutableUtils.getIn)(obj, [attribute]) !== 'undefined';
  }).forEach(function (attribute) {
    var item = (0, _ImmutableUtils.getIn)(obj, [attribute]);
    var itemSchema = (0, _ImmutableUtils.getIn)(schema, [attribute]);

    denormalized = (0, _ImmutableUtils.setIn)(denormalized, [attribute], denormalize(item, entities, itemSchema, bag));
  });

  return denormalized;
}

/**
 * Takes an entity, saves a reference to it in the 'bag' and then denormalizes
 * it. Saving the reference is necessary for circular dependencies.
 *
 * @param   {object|Immutable.Map|number|string} entityOrId
 * @param   {object|Immutable.Map} entities
 * @param   {Schema} schema
 * @param   {object} bag
 * @returns {object|Immutable.Map}
 */
function denormalizeEntity(entityOrId, entities, schema, bag) {
  var key = schema.getKey();

  var _resolveEntityOrId = resolveEntityOrId(entityOrId, entities, schema),
      entity = _resolveEntityOrId.entity,
      id = _resolveEntityOrId.id;

  if (!bag.hasOwnProperty(key)) {
    bag[key] = {};
  }

  if (!bag[key].hasOwnProperty(id)) {
    // Ensure we don't mutate it non-immutable objects
    var obj = (0, _ImmutableUtils.isImmutable)(entity) ? entity : (0, _merge2.default)({}, entity);

    // Need to set this first so that if it is referenced within the call to
    // denormalizeObject, it will already exist.
    bag[key][id] = obj;
    bag[key][id] = denormalizeObject(obj, entities, schema, bag);
  }

  return bag[key][id];
}

/**
 * Takes an object, array, or id and returns a denormalized copy of it. For
 * an object or array, the same data type is returned. For an id, an object
 * will be returned.
 *
 * If the passed object is null or undefined or if no schema is provided, the
 * passed object will be returned.
 *
 * @param   {object|Immutable.Map|array|Immutable.list|number|string} obj
 * @param   {object|Immutable.Map} entities
 * @param   {Schema} schema
 * @param   {object} bag
 * @returns {object|Immutable.Map|array|Immutable.list}
 */
function denormalize(obj, entities, schema) {
  var bag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  if (obj === null || typeof obj === 'undefined' || !(0, _isObject2.default)(schema)) {
    return obj;
  }

  if (schema instanceof _EntitySchema2.default) {
    return denormalizeEntity(obj, entities, schema, bag);
  } else if (schema instanceof _IterableSchema2.default) {
    return denormalizeIterable(obj, entities, schema, bag);
  } else if (schema instanceof _UnionSchema2.default) {
    return denormalizeUnion(obj, entities, schema, bag);
  }
  // Ensure we don't mutate it non-immutable objects
  var entity = (0, _ImmutableUtils.isImmutable)(obj) ? obj : (0, _merge2.default)({}, obj);
  return denormalizeObject(entity, entities, schema, bag);
}

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var isSync = false,
      hasNext = false,
      doneArgs = void 0;

  var done = function done() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    isDone = true;

    if (isSync) {
      // Iterate instead of recursing if possible.
      doneArgs = args;
      return;
    }

    callback.apply(undefined, args);
  };

  var next = function next() {
    if (isDone) return;

    hasNext = true;

    if (isSync) return; // Iterate instead of recursing if possible.

    isSync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work(currentTurn++, next, done);
    }

    isSync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(undefined, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  };

  next();
};

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;

var _BrowserProtocol = __webpack_require__(328);

Object.defineProperty(exports, 'getUserConfirmation', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.getUserConfirmation;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.go;
  }
});

var _warning = __webpack_require__(109);

var _warning2 = _interopRequireDefault(_warning);

var _LocationUtils = __webpack_require__(146);

var _DOMUtils = __webpack_require__(228);

var _DOMStateStorage = __webpack_require__(481);

var _PathUtils = __webpack_require__(104);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
  var path = pathCoder.decodePath(getHashPath());
  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);

  var state = void 0;
  if (key) {
    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
    state = (0, _DOMStateStorage.readState)(key);
  }

  var init = (0, _PathUtils.parsePath)(path);
  init.state = state;

  return (0, _LocationUtils.createLocation)(init, undefined, key);
};

var prevLocation = void 0;

var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = pathCoder.encodePath(path);

    if (path !== encodedPath) {
      // Always be sure we have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var currentLocation = getCurrentLocation(pathCoder, queryKey);

      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events

      prevLocation = currentLocation;

      listener(currentLocation);
    }
  };

  // Ensure the hash is encoded properly.
  var path = getHashPath();
  var encodedPath = pathCoder.encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);

  return function () {
    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
  };
};

var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
  var state = location.state,
      key = location.key;


  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));

  if (state !== undefined) {
    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
    (0, _DOMStateStorage.saveState)(key, state);
  }

  prevLocation = location;

  updateHash(path);
};

var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
  return updateLocation(location, pathCoder, queryKey, function (path) {
    if (getHashPath() !== path) {
      pushHashPath(path);
    } else {
       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
    }
  });
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
  return updateLocation(location, pathCoder, queryKey, function (path) {
    if (getHashPath() !== path) replaceHashPath(path);
  });
};

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;

var _BrowserProtocol = __webpack_require__(328);

Object.defineProperty(exports, 'getUserConfirmation', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.getUserConfirmation;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.go;
  }
});

var _LocationUtils = __webpack_require__(146);

var _PathUtils = __webpack_require__(104);

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
  return (0, _LocationUtils.createLocation)(window.location);
};

var pushLocation = exports.pushLocation = function pushLocation(location) {
  window.location.href = (0, _PathUtils.createPath)(location);
  return false; // Don't update location
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
  window.location.replace((0, _PathUtils.createPath)(location));
  return false; // Don't update location
};

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(38);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(329);

var _BrowserProtocol = __webpack_require__(328);

var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);

var _RefreshProtocol = __webpack_require__(974);

var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);

var _DOMUtils = __webpack_require__(228);

var _createHistory = __webpack_require__(330);

var _createHistory2 = _interopRequireDefault(_createHistory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates and returns a history object that uses HTML5's history API
 * (pushState, replaceState, and the popstate event) to manage history.
 * This is the recommended method of managing history in browsers because
 * it provides the cleanest URLs.
 *
 * Note: In browsers that do not support the HTML5 history API full
 * page reloads will be used to preserve clean URLs. You can force this
 * behavior using { forceRefresh: true } in options.
 */
var createBrowserHistory = function createBrowserHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;

  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;

  var getUserConfirmation = Protocol.getUserConfirmation,
      getCurrentLocation = Protocol.getCurrentLocation,
      pushLocation = Protocol.pushLocation,
      replaceLocation = Protocol.replaceLocation,
      go = Protocol.go;


  var history = (0, _createHistory2.default)(_extends({
    getUserConfirmation: getUserConfirmation }, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: go
  }));

  var listenerCount = 0,
      stopListener = void 0;

  var startListener = function startListener(listener, before) {
    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);

    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopListener();
    };
  };

  var listenBefore = function listenBefore(listener) {
    return startListener(listener, true);
  };

  var listen = function listen(listener) {
    return startListener(listener, false);
  };

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen
  });
};

exports.default = createBrowserHistory;

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(109);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(38);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(329);

var _DOMUtils = __webpack_require__(228);

var _HashProtocol = __webpack_require__(973);

var HashProtocol = _interopRequireWildcard(_HashProtocol);

var _createHistory = __webpack_require__(330);

var _createHistory2 = _interopRequireDefault(_createHistory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DefaultQueryKey = '_k';

var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!' + path;
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substring(1) : path;
    }
  },
  noslash: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '/' ? path.substring(1) : path;
    },
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

var createHashHistory = function createHashHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;

  var queryKey = options.queryKey,
      hashType = options.hashType;


   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;

  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;

  if (hashType == null) hashType = 'slash';

  if (!(hashType in HashPathCoders)) {
     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;

    hashType = 'slash';
  }

  var pathCoder = HashPathCoders[hashType];

  var getUserConfirmation = HashProtocol.getUserConfirmation;


  var getCurrentLocation = function getCurrentLocation() {
    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
  };

  var pushLocation = function pushLocation(location) {
    return HashProtocol.pushLocation(location, pathCoder, queryKey);
  };

  var replaceLocation = function replaceLocation(location) {
    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
  };

  var history = (0, _createHistory2.default)(_extends({
    getUserConfirmation: getUserConfirmation }, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: HashProtocol.go
  }));

  var listenerCount = 0,
      stopListener = void 0;

  var startListener = function startListener(listener, before) {
    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);

    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopListener();
    };
  };

  var listenBefore = function listenBefore(listener) {
    return startListener(listener, true);
  };

  var listen = function listen(listener) {
    return startListener(listener, false);
  };

  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var go = function go(n) {
     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;

    history.go(n);
  };

  var createHref = function createHref(path) {
    return '#' + pathCoder.encodePath(history.createHref(path));
  };

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen,
    go: go,
    createHref: createHref
  });
};

exports.default = createHashHistory;

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(109);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(38);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(146);

var _PathUtils = __webpack_require__(104);

var _createHistory = __webpack_require__(330);

var _createHistory2 = _interopRequireDefault(_createHistory);

var _Actions = __webpack_require__(227);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createStateStorage = function createStateStorage(entries) {
  return entries.filter(function (entry) {
    return entry.state;
  }).reduce(function (memo, entry) {
    memo[entry.key] = entry.state;
    return memo;
  }, {});
};

var createMemoryHistory = function createMemoryHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (Array.isArray(options)) {
    options = { entries: options };
  } else if (typeof options === 'string') {
    options = { entries: [options] };
  }

  var getCurrentLocation = function getCurrentLocation() {
    var entry = entries[current];
    var path = (0, _PathUtils.createPath)(entry);

    var key = void 0,
        state = void 0;
    if (entry.key) {
      key = entry.key;
      state = readState(key);
    }

    var init = (0, _PathUtils.parsePath)(path);

    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
  };

  var canGo = function canGo(n) {
    var index = current + n;
    return index >= 0 && index < entries.length;
  };

  var go = function go(n) {
    if (!n) return;

    if (!canGo(n)) {
       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;

      return;
    }

    current += n;
    var currentLocation = getCurrentLocation();

    // Change action to POP
    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
  };

  var pushLocation = function pushLocation(location) {
    current += 1;

    if (current < entries.length) entries.splice(current);

    entries.push(location);

    saveState(location.key, location.state);
  };

  var replaceLocation = function replaceLocation(location) {
    entries[current] = location;
    saveState(location.key, location.state);
  };

  var history = (0, _createHistory2.default)(_extends({}, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: go
  }));

  var _options = options,
      entries = _options.entries,
      current = _options.current;


  if (typeof entries === 'string') {
    entries = [entries];
  } else if (!Array.isArray(entries)) {
    entries = ['/'];
  }

  entries = entries.map(function (entry) {
    return (0, _LocationUtils.createLocation)(entry);
  });

  if (current == null) {
    current = entries.length - 1;
  } else {
    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
  }

  var storage = createStateStorage(entries);

  var saveState = function saveState(key, state) {
    return storage[key] = state;
  };

  var readState = function readState(key) {
    return storage[key];
  };

  return _extends({}, history, {
    canGo: canGo
  });
};

exports.default = createMemoryHistory;

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports = module.exports = __webpack_require__(980)['default'];
exports['default'] = exports;


/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */

// Function.prototype.bind implementation from Mozilla Developer Network:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind#Polyfill

var bind = Function.prototype.bind || function (oThis) {
    if (typeof this !== 'function') {
      // closest thing possible to the ECMAScript 5
      // internal IsCallable function
      throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
    }

    var aArgs   = Array.prototype.slice.call(arguments, 1),
        fToBind = this,
        fNOP    = function() {},
        fBound  = function() {
          return fToBind.apply(this instanceof fNOP
                 ? this
                 : oThis,
                 aArgs.concat(Array.prototype.slice.call(arguments)));
        };

    if (this.prototype) {
      // native functions don't have a prototype
      fNOP.prototype = this.prototype;
    }
    fBound.prototype = new fNOP();

    return fBound;
};

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var hop = Object.prototype.hasOwnProperty;

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

exports.bind = bind, exports.defineProperty = defineProperty, exports.objCreate = objCreate;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var src$es5$$ = __webpack_require__(979);
exports["default"] = createFormatCache;

// -----------------------------------------------------------------------------

function createFormatCache(FormatConstructor) {
    var cache = src$es5$$.objCreate(null);

    return function () {
        var args    = Array.prototype.slice.call(arguments);
        var cacheId = getCacheId(args);
        var format  = cacheId && cache[cacheId];

        if (!format) {
            format = new (src$es5$$.bind.apply(FormatConstructor, [null].concat(args)))();

            if (cacheId) {
                cache[cacheId] = format;
            }
        }

        return format;
    };
}

// -- Utilities ----------------------------------------------------------------

function getCacheId(inputs) {
    // When JSON is not available in the runtime, we will not create a cache id.
    if (typeof JSON === 'undefined') { return; }

    var cacheId = [];

    var i, len, input;

    for (i = 0, len = inputs.length; i < len; i += 1) {
        input = inputs[i];

        if (input && typeof input === 'object') {
            cacheId.push(orderedProps(input));
        } else {
            cacheId.push(input);
        }
    }

    return JSON.stringify(cacheId);
}

function orderedProps(obj) {
    var props = [],
        keys  = [];

    var key, i, len, prop;

    for (key in obj) {
        if (obj.hasOwnProperty(key)) {
            keys.push(key);
        }
    }

    var orderedKeys = keys.sort();

    for (i = 0, len = orderedKeys.length; i < len; i += 1) {
        key  = orderedKeys[i];
        prop = {};

        prop[key] = obj[key];
        props[i]  = prop;
    }

    return props;
}

//# sourceMappingURL=memoizer.js.map

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports["default"] = Compiler;

function Compiler(locales, formats, pluralFn) {
    this.locales  = locales;
    this.formats  = formats;
    this.pluralFn = pluralFn;
}

Compiler.prototype.compile = function (ast) {
    this.pluralStack        = [];
    this.currentPlural      = null;
    this.pluralNumberFormat = null;

    return this.compileMessage(ast);
};

Compiler.prototype.compileMessage = function (ast) {
    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new Error('Message AST is not of type: "messageFormatPattern"');
    }

    var elements = ast.elements,
        pattern  = [];

    var i, len, element;

    for (i = 0, len = elements.length; i < len; i += 1) {
        element = elements[i];

        switch (element.type) {
            case 'messageTextElement':
                pattern.push(this.compileMessageText(element));
                break;

            case 'argumentElement':
                pattern.push(this.compileArgument(element));
                break;

            default:
                throw new Error('Message element does not have a valid type');
        }
    }

    return pattern;
};

Compiler.prototype.compileMessageText = function (element) {
    // When this `element` is part of plural sub-pattern and its value contains
    // an unescaped '#', use a `PluralOffsetString` helper to properly output
    // the number with the correct offset in the string.
    if (this.currentPlural && /(^|[^\\])#/g.test(element.value)) {
        // Create a cache a NumberFormat instance that can be reused for any
        // PluralOffsetString instance in this message.
        if (!this.pluralNumberFormat) {
            this.pluralNumberFormat = new Intl.NumberFormat(this.locales);
        }

        return new PluralOffsetString(
                this.currentPlural.id,
                this.currentPlural.format.offset,
                this.pluralNumberFormat,
                element.value);
    }

    // Unescape the escaped '#'s in the message text.
    return element.value.replace(/\\#/g, '#');
};

Compiler.prototype.compileArgument = function (element) {
    var format = element.format;

    if (!format) {
        return new StringFormat(element.id);
    }

    var formats  = this.formats,
        locales  = this.locales,
        pluralFn = this.pluralFn,
        options;

    switch (format.type) {
        case 'numberFormat':
            options = formats.number[format.style];
            return {
                id    : element.id,
                format: new Intl.NumberFormat(locales, options).format
            };

        case 'dateFormat':
            options = formats.date[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'timeFormat':
            options = formats.time[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'pluralFormat':
            options = this.compileOptions(element);
            return new PluralFormat(
                element.id, format.ordinal, format.offset, options, pluralFn
            );

        case 'selectFormat':
            options = this.compileOptions(element);
            return new SelectFormat(element.id, options);

        default:
            throw new Error('Message element does not have a valid format type');
    }
};

Compiler.prototype.compileOptions = function (element) {
    var format      = element.format,
        options     = format.options,
        optionsHash = {};

    // Save the current plural element, if any, then set it to a new value when
    // compiling the options sub-patterns. This conforms the spec's algorithm
    // for handling `"#"` syntax in message text.
    this.pluralStack.push(this.currentPlural);
    this.currentPlural = format.type === 'pluralFormat' ? element : null;

    var i, len, option;

    for (i = 0, len = options.length; i < len; i += 1) {
        option = options[i];

        // Compile the sub-pattern and save it under the options's selector.
        optionsHash[option.selector] = this.compileMessage(option.value);
    }

    // Pop the plural stack to put back the original current plural value.
    this.currentPlural = this.pluralStack.pop();

    return optionsHash;
};

// -- Compiler Helper Classes --------------------------------------------------

function StringFormat(id) {
    this.id = id;
}

StringFormat.prototype.format = function (value) {
    if (!value) {
        return '';
    }

    return typeof value === 'string' ? value : String(value);
};

function PluralFormat(id, useOrdinal, offset, options, pluralFn) {
    this.id         = id;
    this.useOrdinal = useOrdinal;
    this.offset     = offset;
    this.options    = options;
    this.pluralFn   = pluralFn;
}

PluralFormat.prototype.getOption = function (value) {
    var options = this.options;

    var option = options['=' + value] ||
            options[this.pluralFn(value - this.offset, this.useOrdinal)];

    return option || options.other;
};

function PluralOffsetString(id, offset, numberFormat, string) {
    this.id           = id;
    this.offset       = offset;
    this.numberFormat = numberFormat;
    this.string       = string;
}

PluralOffsetString.prototype.format = function (value) {
    var number = this.numberFormat.format(value - this.offset);

    return this.string
            .replace(/(^|[^\\])#/g, '$1' + number)
            .replace(/\\#/g, '#');
};

function SelectFormat(id, options) {
    this.id      = id;
    this.options = options;
}

SelectFormat.prototype.getOption = function (value) {
    var options = this.options;
    return options[value] || options.other;
};

//# sourceMappingURL=compiler.js.map

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(485), src$es5$$ = __webpack_require__(984), src$compiler$$ = __webpack_require__(981), intl$messageformat$parser$$ = __webpack_require__(986);
exports["default"] = MessageFormat;

// -- MessageFormat --------------------------------------------------------

function MessageFormat(message, locales, formats) {
    // Parse string messages into an AST.
    var ast = typeof message === 'string' ?
            MessageFormat.__parse(message) : message;

    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new TypeError('A message must be provided as a String or AST.');
    }

    // Creates a new object with the specified `formats` merged with the default
    // formats.
    formats = this._mergeFormats(MessageFormat.formats, formats);

    // Defined first because it's used to build the format pattern.
    src$es5$$.defineProperty(this, '_locale',  {value: this._resolveLocale(locales)});

    // Compile the `ast` to a pattern that is highly optimized for repeated
    // `format()` invocations. **Note:** This passes the `locales` set provided
    // to the constructor instead of just the resolved locale.
    var pluralFn = this._findPluralRuleFunction(this._locale);
    var pattern  = this._compilePattern(ast, locales, formats, pluralFn);

    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var messageFormat = this;
    this.format = function (values) {
        return messageFormat._format(pattern, values);
    };
}

// Default format options used as the prototype of the `formats` provided to the
// constructor. These are used when constructing the internal Intl.NumberFormat
// and Intl.DateTimeFormat instances.
src$es5$$.defineProperty(MessageFormat, 'formats', {
    enumerable: true,

    value: {
        number: {
            'currency': {
                style: 'currency'
            },

            'percent': {
                style: 'percent'
            }
        },

        date: {
            'short': {
                month: 'numeric',
                day  : 'numeric',
                year : '2-digit'
            },

            'medium': {
                month: 'short',
                day  : 'numeric',
                year : 'numeric'
            },

            'long': {
                month: 'long',
                day  : 'numeric',
                year : 'numeric'
            },

            'full': {
                weekday: 'long',
                month  : 'long',
                day    : 'numeric',
                year   : 'numeric'
            }
        },

        time: {
            'short': {
                hour  : 'numeric',
                minute: 'numeric'
            },

            'medium':  {
                hour  : 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },

            'long': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            },

            'full': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            }
        }
    }
});

// Define internal private properties for dealing with locale data.
src$es5$$.defineProperty(MessageFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
src$es5$$.defineProperty(MessageFormat, '__addLocaleData', {value: function (data) {
    if (!(data && data.locale)) {
        throw new Error(
            'Locale data provided to IntlMessageFormat is missing a ' +
            '`locale` property'
        );
    }

    MessageFormat.__localeData__[data.locale.toLowerCase()] = data;
}});

// Defines `__parse()` static method as an exposed private.
src$es5$$.defineProperty(MessageFormat, '__parse', {value: intl$messageformat$parser$$["default"].parse});

// Define public `defaultLocale` property which defaults to English, but can be
// set by the developer.
src$es5$$.defineProperty(MessageFormat, 'defaultLocale', {
    enumerable: true,
    writable  : true,
    value     : undefined
});

MessageFormat.prototype.resolvedOptions = function () {
    // TODO: Provide anything else?
    return {
        locale: this._locale
    };
};

MessageFormat.prototype._compilePattern = function (ast, locales, formats, pluralFn) {
    var compiler = new src$compiler$$["default"](locales, formats, pluralFn);
    return compiler.compile(ast);
};

MessageFormat.prototype._findPluralRuleFunction = function (locale) {
    var localeData = MessageFormat.__localeData__;
    var data       = localeData[locale.toLowerCase()];

    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find a `pluralRuleFunction` to return.
    while (data) {
        if (data.pluralRuleFunction) {
            return data.pluralRuleFunction;
        }

        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }

    throw new Error(
        'Locale data added to IntlMessageFormat is missing a ' +
        '`pluralRuleFunction` for :' + locale
    );
};

MessageFormat.prototype._format = function (pattern, values) {
    var result = '',
        i, len, part, id, value;

    for (i = 0, len = pattern.length; i < len; i += 1) {
        part = pattern[i];

        // Exist early for string parts.
        if (typeof part === 'string') {
            result += part;
            continue;
        }

        id = part.id;

        // Enforce that all required values are provided by the caller.
        if (!(values && src$utils$$.hop.call(values, id))) {
            throw new Error('A value must be provided for: ' + id);
        }

        value = values[id];

        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if (part.options) {
            result += this._format(part.getOption(value), values);
        } else {
            result += part.format(value);
        }
    }

    return result;
};

MessageFormat.prototype._mergeFormats = function (defaults, formats) {
    var mergedFormats = {},
        type, mergedType;

    for (type in defaults) {
        if (!src$utils$$.hop.call(defaults, type)) { continue; }

        mergedFormats[type] = mergedType = src$es5$$.objCreate(defaults[type]);

        if (formats && src$utils$$.hop.call(formats, type)) {
            src$utils$$.extend(mergedType, formats[type]);
        }
    }

    return mergedFormats;
};

MessageFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }

    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(MessageFormat.defaultLocale);

    var localeData = MessageFormat.__localeData__;
    var i, len, localeParts, data;

    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');

        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }

            localeParts.pop();
        }
    }

    var defaultLocale = locales.pop();
    throw new Error(
        'No locale data has been added to IntlMessageFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale
    );
};

//# sourceMappingURL=core.js.map

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// GENERATED FILE

exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"}};

//# sourceMappingURL=en.js.map

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(485);

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!src$utils$$.hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (src$utils$$.hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};
exports.defineProperty = defineProperty, exports.objCreate = objCreate;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jslint esnext: true */


var src$core$$ = __webpack_require__(982), src$en$$ = __webpack_require__(983);

src$core$$["default"].__addLocaleData(src$en$$["default"]);
src$core$$["default"].defaultLocale = 'en';

exports["default"] = src$core$$["default"];

//# sourceMappingURL=main.js.map

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports = module.exports = __webpack_require__(987)['default'];
exports['default'] = exports;


/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports["default"] = (function() {
  /*
   * Generated by PEG.js 0.8.0.
   *
   * http://pegjs.majda.cz/
   */

  function peg$subclass(child, parent) {
    function ctor() { this.constructor = child; }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
  }

  function SyntaxError(message, expected, found, offset, line, column) {
    this.message  = message;
    this.expected = expected;
    this.found    = found;
    this.offset   = offset;
    this.line     = line;
    this.column   = column;

    this.name     = "SyntaxError";
  }

  peg$subclass(SyntaxError, Error);

  function parse(input) {
    var options = arguments.length > 1 ? arguments[1] : {},

        peg$FAILED = {},

        peg$startRuleFunctions = { start: peg$parsestart },
        peg$startRuleFunction  = peg$parsestart,

        peg$c0 = [],
        peg$c1 = function(elements) {
                return {
                    type    : 'messageFormatPattern',
                    elements: elements
                };
            },
        peg$c2 = peg$FAILED,
        peg$c3 = function(text) {
                var string = '',
                    i, j, outerLen, inner, innerLen;

                for (i = 0, outerLen = text.length; i < outerLen; i += 1) {
                    inner = text[i];

                    for (j = 0, innerLen = inner.length; j < innerLen; j += 1) {
                        string += inner[j];
                    }
                }

                return string;
            },
        peg$c4 = function(messageText) {
                return {
                    type : 'messageTextElement',
                    value: messageText
                };
            },
        peg$c5 = /^[^ \t\n\r,.+={}#]/,
        peg$c6 = { type: "class", value: "[^ \\t\\n\\r,.+={}#]", description: "[^ \\t\\n\\r,.+={}#]" },
        peg$c7 = "{",
        peg$c8 = { type: "literal", value: "{", description: "\"{\"" },
        peg$c9 = null,
        peg$c10 = ",",
        peg$c11 = { type: "literal", value: ",", description: "\",\"" },
        peg$c12 = "}",
        peg$c13 = { type: "literal", value: "}", description: "\"}\"" },
        peg$c14 = function(id, format) {
                return {
                    type  : 'argumentElement',
                    id    : id,
                    format: format && format[2]
                };
            },
        peg$c15 = "number",
        peg$c16 = { type: "literal", value: "number", description: "\"number\"" },
        peg$c17 = "date",
        peg$c18 = { type: "literal", value: "date", description: "\"date\"" },
        peg$c19 = "time",
        peg$c20 = { type: "literal", value: "time", description: "\"time\"" },
        peg$c21 = function(type, style) {
                return {
                    type : type + 'Format',
                    style: style && style[2]
                };
            },
        peg$c22 = "plural",
        peg$c23 = { type: "literal", value: "plural", description: "\"plural\"" },
        peg$c24 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: false,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options
                };
            },
        peg$c25 = "selectordinal",
        peg$c26 = { type: "literal", value: "selectordinal", description: "\"selectordinal\"" },
        peg$c27 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: true,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options
                }
            },
        peg$c28 = "select",
        peg$c29 = { type: "literal", value: "select", description: "\"select\"" },
        peg$c30 = function(options) {
                return {
                    type   : 'selectFormat',
                    options: options
                };
            },
        peg$c31 = "=",
        peg$c32 = { type: "literal", value: "=", description: "\"=\"" },
        peg$c33 = function(selector, pattern) {
                return {
                    type    : 'optionalFormatPattern',
                    selector: selector,
                    value   : pattern
                };
            },
        peg$c34 = "offset:",
        peg$c35 = { type: "literal", value: "offset:", description: "\"offset:\"" },
        peg$c36 = function(number) {
                return number;
            },
        peg$c37 = function(offset, options) {
                return {
                    type   : 'pluralFormat',
                    offset : offset,
                    options: options
                };
            },
        peg$c38 = { type: "other", description: "whitespace" },
        peg$c39 = /^[ \t\n\r]/,
        peg$c40 = { type: "class", value: "[ \\t\\n\\r]", description: "[ \\t\\n\\r]" },
        peg$c41 = { type: "other", description: "optionalWhitespace" },
        peg$c42 = /^[0-9]/,
        peg$c43 = { type: "class", value: "[0-9]", description: "[0-9]" },
        peg$c44 = /^[0-9a-f]/i,
        peg$c45 = { type: "class", value: "[0-9a-f]i", description: "[0-9a-f]i" },
        peg$c46 = "0",
        peg$c47 = { type: "literal", value: "0", description: "\"0\"" },
        peg$c48 = /^[1-9]/,
        peg$c49 = { type: "class", value: "[1-9]", description: "[1-9]" },
        peg$c50 = function(digits) {
            return parseInt(digits, 10);
        },
        peg$c51 = /^[^{}\\\0-\x1F \t\n\r]/,
        peg$c52 = { type: "class", value: "[^{}\\\\\\0-\\x1F \\t\\n\\r]", description: "[^{}\\\\\\0-\\x1F \\t\\n\\r]" },
        peg$c53 = "\\\\",
        peg$c54 = { type: "literal", value: "\\\\", description: "\"\\\\\\\\\"" },
        peg$c55 = function() { return '\\'; },
        peg$c56 = "\\#",
        peg$c57 = { type: "literal", value: "\\#", description: "\"\\\\#\"" },
        peg$c58 = function() { return '\\#'; },
        peg$c59 = "\\{",
        peg$c60 = { type: "literal", value: "\\{", description: "\"\\\\{\"" },
        peg$c61 = function() { return '\u007B'; },
        peg$c62 = "\\}",
        peg$c63 = { type: "literal", value: "\\}", description: "\"\\\\}\"" },
        peg$c64 = function() { return '\u007D'; },
        peg$c65 = "\\u",
        peg$c66 = { type: "literal", value: "\\u", description: "\"\\\\u\"" },
        peg$c67 = function(digits) {
                return String.fromCharCode(parseInt(digits, 16));
            },
        peg$c68 = function(chars) { return chars.join(''); },

        peg$currPos          = 0,
        peg$reportedPos      = 0,
        peg$cachedPos        = 0,
        peg$cachedPosDetails = { line: 1, column: 1, seenCR: false },
        peg$maxFailPos       = 0,
        peg$maxFailExpected  = [],
        peg$silentFails      = 0,

        peg$result;

    if ("startRule" in options) {
      if (!(options.startRule in peg$startRuleFunctions)) {
        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
      }

      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
    }

    function text() {
      return input.substring(peg$reportedPos, peg$currPos);
    }

    function offset() {
      return peg$reportedPos;
    }

    function line() {
      return peg$computePosDetails(peg$reportedPos).line;
    }

    function column() {
      return peg$computePosDetails(peg$reportedPos).column;
    }

    function expected(description) {
      throw peg$buildException(
        null,
        [{ type: "other", description: description }],
        peg$reportedPos
      );
    }

    function error(message) {
      throw peg$buildException(message, null, peg$reportedPos);
    }

    function peg$computePosDetails(pos) {
      function advance(details, startPos, endPos) {
        var p, ch;

        for (p = startPos; p < endPos; p++) {
          ch = input.charAt(p);
          if (ch === "\n") {
            if (!details.seenCR) { details.line++; }
            details.column = 1;
            details.seenCR = false;
          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
            details.line++;
            details.column = 1;
            details.seenCR = true;
          } else {
            details.column++;
            details.seenCR = false;
          }
        }
      }

      if (peg$cachedPos !== pos) {
        if (peg$cachedPos > pos) {
          peg$cachedPos = 0;
          peg$cachedPosDetails = { line: 1, column: 1, seenCR: false };
        }
        advance(peg$cachedPosDetails, peg$cachedPos, pos);
        peg$cachedPos = pos;
      }

      return peg$cachedPosDetails;
    }

    function peg$fail(expected) {
      if (peg$currPos < peg$maxFailPos) { return; }

      if (peg$currPos > peg$maxFailPos) {
        peg$maxFailPos = peg$currPos;
        peg$maxFailExpected = [];
      }

      peg$maxFailExpected.push(expected);
    }

    function peg$buildException(message, expected, pos) {
      function cleanupExpected(expected) {
        var i = 1;

        expected.sort(function(a, b) {
          if (a.description < b.description) {
            return -1;
          } else if (a.description > b.description) {
            return 1;
          } else {
            return 0;
          }
        });

        while (i < expected.length) {
          if (expected[i - 1] === expected[i]) {
            expected.splice(i, 1);
          } else {
            i++;
          }
        }
      }

      function buildMessage(expected, found) {
        function stringEscape(s) {
          function hex(ch) { return ch.charCodeAt(0).toString(16).toUpperCase(); }

          return s
            .replace(/\\/g,   '\\\\')
            .replace(/"/g,    '\\"')
            .replace(/\x08/g, '\\b')
            .replace(/\t/g,   '\\t')
            .replace(/\n/g,   '\\n')
            .replace(/\f/g,   '\\f')
            .replace(/\r/g,   '\\r')
            .replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(ch) { return '\\x0' + hex(ch); })
            .replace(/[\x10-\x1F\x80-\xFF]/g,    function(ch) { return '\\x'  + hex(ch); })
            .replace(/[\u0180-\u0FFF]/g,         function(ch) { return '\\u0' + hex(ch); })
            .replace(/[\u1080-\uFFFF]/g,         function(ch) { return '\\u'  + hex(ch); });
        }

        var expectedDescs = new Array(expected.length),
            expectedDesc, foundDesc, i;

        for (i = 0; i < expected.length; i++) {
          expectedDescs[i] = expected[i].description;
        }

        expectedDesc = expected.length > 1
          ? expectedDescs.slice(0, -1).join(", ")
              + " or "
              + expectedDescs[expected.length - 1]
          : expectedDescs[0];

        foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";

        return "Expected " + expectedDesc + " but " + foundDesc + " found.";
      }

      var posDetails = peg$computePosDetails(pos),
          found      = pos < input.length ? input.charAt(pos) : null;

      if (expected !== null) {
        cleanupExpected(expected);
      }

      return new SyntaxError(
        message !== null ? message : buildMessage(expected, found),
        expected,
        found,
        pos,
        posDetails.line,
        posDetails.column
      );
    }

    function peg$parsestart() {
      var s0;

      s0 = peg$parsemessageFormatPattern();

      return s0;
    }

    function peg$parsemessageFormatPattern() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsemessageFormatElement();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsemessageFormatElement();
      }
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c1(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsemessageFormatElement() {
      var s0;

      s0 = peg$parsemessageTextElement();
      if (s0 === peg$FAILED) {
        s0 = peg$parseargumentElement();
      }

      return s0;
    }

    function peg$parsemessageText() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$currPos;
      s3 = peg$parse_();
      if (s3 !== peg$FAILED) {
        s4 = peg$parsechars();
        if (s4 !== peg$FAILED) {
          s5 = peg$parse_();
          if (s5 !== peg$FAILED) {
            s3 = [s3, s4, s5];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$c2;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$c2;
        }
      } else {
        peg$currPos = s2;
        s2 = peg$c2;
      }
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$currPos;
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            s4 = peg$parsechars();
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s3 = [s3, s4, s5];
                s2 = s3;
              } else {
                peg$currPos = s2;
                s2 = peg$c2;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$c2;
            }
          } else {
            peg$currPos = s2;
            s2 = peg$c2;
          }
        }
      } else {
        s1 = peg$c2;
      }
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c3(s1);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parsews();
        if (s1 !== peg$FAILED) {
          s1 = input.substring(s0, peg$currPos);
        }
        s0 = s1;
      }

      return s0;
    }

    function peg$parsemessageTextElement() {
      var s0, s1;

      s0 = peg$currPos;
      s1 = peg$parsemessageText();
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c4(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parseargument() {
      var s0, s1, s2;

      s0 = peg$parsenumber();
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = [];
        if (peg$c5.test(input.charAt(peg$currPos))) {
          s2 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c6); }
        }
        if (s2 !== peg$FAILED) {
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            if (peg$c5.test(input.charAt(peg$currPos))) {
              s2 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c6); }
            }
          }
        } else {
          s1 = peg$c2;
        }
        if (s1 !== peg$FAILED) {
          s1 = input.substring(s0, peg$currPos);
        }
        s0 = s1;
      }

      return s0;
    }

    function peg$parseargumentElement() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 123) {
        s1 = peg$c7;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c8); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parseargument();
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$currPos;
              if (input.charCodeAt(peg$currPos) === 44) {
                s6 = peg$c10;
                peg$currPos++;
              } else {
                s6 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c11); }
              }
              if (s6 !== peg$FAILED) {
                s7 = peg$parse_();
                if (s7 !== peg$FAILED) {
                  s8 = peg$parseelementFormat();
                  if (s8 !== peg$FAILED) {
                    s6 = [s6, s7, s8];
                    s5 = s6;
                  } else {
                    peg$currPos = s5;
                    s5 = peg$c2;
                  }
                } else {
                  peg$currPos = s5;
                  s5 = peg$c2;
                }
              } else {
                peg$currPos = s5;
                s5 = peg$c2;
              }
              if (s5 === peg$FAILED) {
                s5 = peg$c9;
              }
              if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                if (s6 !== peg$FAILED) {
                  if (input.charCodeAt(peg$currPos) === 125) {
                    s7 = peg$c12;
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$c13); }
                  }
                  if (s7 !== peg$FAILED) {
                    peg$reportedPos = s0;
                    s1 = peg$c14(s3, s5);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$c2;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$c2;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$c2;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c2;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parseelementFormat() {
      var s0;

      s0 = peg$parsesimpleFormat();
      if (s0 === peg$FAILED) {
        s0 = peg$parsepluralFormat();
        if (s0 === peg$FAILED) {
          s0 = peg$parseselectOrdinalFormat();
          if (s0 === peg$FAILED) {
            s0 = peg$parseselectFormat();
          }
        }
      }

      return s0;
    }

    function peg$parsesimpleFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c15) {
        s1 = peg$c15;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c16); }
      }
      if (s1 === peg$FAILED) {
        if (input.substr(peg$currPos, 4) === peg$c17) {
          s1 = peg$c17;
          peg$currPos += 4;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c18); }
        }
        if (s1 === peg$FAILED) {
          if (input.substr(peg$currPos, 4) === peg$c19) {
            s1 = peg$c19;
            peg$currPos += 4;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c20); }
          }
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 44) {
            s4 = peg$c10;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c11); }
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parse_();
            if (s5 !== peg$FAILED) {
              s6 = peg$parsechars();
              if (s6 !== peg$FAILED) {
                s4 = [s4, s5, s6];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$c2;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$c2;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$c2;
          }
          if (s3 === peg$FAILED) {
            s3 = peg$c9;
          }
          if (s3 !== peg$FAILED) {
            peg$reportedPos = s0;
            s1 = peg$c21(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parsepluralFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c22) {
        s1 = peg$c22;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c23); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c10;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c11); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$reportedPos = s0;
                s1 = peg$c24(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$c2;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c2;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parseselectOrdinalFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 13) === peg$c25) {
        s1 = peg$c25;
        peg$currPos += 13;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c26); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c10;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c11); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$reportedPos = s0;
                s1 = peg$c27(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$c2;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c2;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parseselectFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c28) {
        s1 = peg$c28;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c29); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c10;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c11); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = [];
              s6 = peg$parseoptionalFormatPattern();
              if (s6 !== peg$FAILED) {
                while (s6 !== peg$FAILED) {
                  s5.push(s6);
                  s6 = peg$parseoptionalFormatPattern();
                }
              } else {
                s5 = peg$c2;
              }
              if (s5 !== peg$FAILED) {
                peg$reportedPos = s0;
                s1 = peg$c30(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$c2;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c2;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parseselector() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      s1 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 61) {
        s2 = peg$c31;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c32); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parsenumber();
        if (s3 !== peg$FAILED) {
          s2 = [s2, s3];
          s1 = s2;
        } else {
          peg$currPos = s1;
          s1 = peg$c2;
        }
      } else {
        peg$currPos = s1;
        s1 = peg$c2;
      }
      if (s1 !== peg$FAILED) {
        s1 = input.substring(s0, peg$currPos);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$parsechars();
      }

      return s0;
    }

    function peg$parseoptionalFormatPattern() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      s1 = peg$parse_();
      if (s1 !== peg$FAILED) {
        s2 = peg$parseselector();
        if (s2 !== peg$FAILED) {
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 123) {
              s4 = peg$c7;
              peg$currPos++;
            } else {
              s4 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c8); }
            }
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s6 = peg$parsemessageFormatPattern();
                if (s6 !== peg$FAILED) {
                  s7 = peg$parse_();
                  if (s7 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 125) {
                      s8 = peg$c12;
                      peg$currPos++;
                    } else {
                      s8 = peg$FAILED;
                      if (peg$silentFails === 0) { peg$fail(peg$c13); }
                    }
                    if (s8 !== peg$FAILED) {
                      peg$reportedPos = s0;
                      s1 = peg$c33(s2, s6);
                      s0 = s1;
                    } else {
                      peg$currPos = s0;
                      s0 = peg$c2;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$c2;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$c2;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$c2;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c2;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parseoffset() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 7) === peg$c34) {
        s1 = peg$c34;
        peg$currPos += 7;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c35); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parsenumber();
          if (s3 !== peg$FAILED) {
            peg$reportedPos = s0;
            s1 = peg$c36(s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parsepluralStyle() {
      var s0, s1, s2, s3, s4;

      s0 = peg$currPos;
      s1 = peg$parseoffset();
      if (s1 === peg$FAILED) {
        s1 = peg$c9;
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = [];
          s4 = peg$parseoptionalFormatPattern();
          if (s4 !== peg$FAILED) {
            while (s4 !== peg$FAILED) {
              s3.push(s4);
              s4 = peg$parseoptionalFormatPattern();
            }
          } else {
            s3 = peg$c2;
          }
          if (s3 !== peg$FAILED) {
            peg$reportedPos = s0;
            s1 = peg$c37(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parsews() {
      var s0, s1;

      peg$silentFails++;
      s0 = [];
      if (peg$c39.test(input.charAt(peg$currPos))) {
        s1 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c40); }
      }
      if (s1 !== peg$FAILED) {
        while (s1 !== peg$FAILED) {
          s0.push(s1);
          if (peg$c39.test(input.charAt(peg$currPos))) {
            s1 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c40); }
          }
        }
      } else {
        s0 = peg$c2;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c38); }
      }

      return s0;
    }

    function peg$parse_() {
      var s0, s1, s2;

      peg$silentFails++;
      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsews();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsews();
      }
      if (s1 !== peg$FAILED) {
        s1 = input.substring(s0, peg$currPos);
      }
      s0 = s1;
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c41); }
      }

      return s0;
    }

    function peg$parsedigit() {
      var s0;

      if (peg$c42.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c43); }
      }

      return s0;
    }

    function peg$parsehexDigit() {
      var s0;

      if (peg$c44.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c45); }
      }

      return s0;
    }

    function peg$parsenumber() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 48) {
        s1 = peg$c46;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c47); }
      }
      if (s1 === peg$FAILED) {
        s1 = peg$currPos;
        s2 = peg$currPos;
        if (peg$c48.test(input.charAt(peg$currPos))) {
          s3 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c49); }
        }
        if (s3 !== peg$FAILED) {
          s4 = [];
          s5 = peg$parsedigit();
          while (s5 !== peg$FAILED) {
            s4.push(s5);
            s5 = peg$parsedigit();
          }
          if (s4 !== peg$FAILED) {
            s3 = [s3, s4];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$c2;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$c2;
        }
        if (s2 !== peg$FAILED) {
          s2 = input.substring(s1, peg$currPos);
        }
        s1 = s2;
      }
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c50(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsechar() {
      var s0, s1, s2, s3, s4, s5, s6, s7;

      if (peg$c51.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c52); }
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 2) === peg$c53) {
          s1 = peg$c53;
          peg$currPos += 2;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c54); }
        }
        if (s1 !== peg$FAILED) {
          peg$reportedPos = s0;
          s1 = peg$c55();
        }
        s0 = s1;
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          if (input.substr(peg$currPos, 2) === peg$c56) {
            s1 = peg$c56;
            peg$currPos += 2;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c57); }
          }
          if (s1 !== peg$FAILED) {
            peg$reportedPos = s0;
            s1 = peg$c58();
          }
          s0 = s1;
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 2) === peg$c59) {
              s1 = peg$c59;
              peg$currPos += 2;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c60); }
            }
            if (s1 !== peg$FAILED) {
              peg$reportedPos = s0;
              s1 = peg$c61();
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              if (input.substr(peg$currPos, 2) === peg$c62) {
                s1 = peg$c62;
                peg$currPos += 2;
              } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c63); }
              }
              if (s1 !== peg$FAILED) {
                peg$reportedPos = s0;
                s1 = peg$c64();
              }
              s0 = s1;
              if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (input.substr(peg$currPos, 2) === peg$c65) {
                  s1 = peg$c65;
                  peg$currPos += 2;
                } else {
                  s1 = peg$FAILED;
                  if (peg$silentFails === 0) { peg$fail(peg$c66); }
                }
                if (s1 !== peg$FAILED) {
                  s2 = peg$currPos;
                  s3 = peg$currPos;
                  s4 = peg$parsehexDigit();
                  if (s4 !== peg$FAILED) {
                    s5 = peg$parsehexDigit();
                    if (s5 !== peg$FAILED) {
                      s6 = peg$parsehexDigit();
                      if (s6 !== peg$FAILED) {
                        s7 = peg$parsehexDigit();
                        if (s7 !== peg$FAILED) {
                          s4 = [s4, s5, s6, s7];
                          s3 = s4;
                        } else {
                          peg$currPos = s3;
                          s3 = peg$c2;
                        }
                      } else {
                        peg$currPos = s3;
                        s3 = peg$c2;
                      }
                    } else {
                      peg$currPos = s3;
                      s3 = peg$c2;
                    }
                  } else {
                    peg$currPos = s3;
                    s3 = peg$c2;
                  }
                  if (s3 !== peg$FAILED) {
                    s3 = input.substring(s2, peg$currPos);
                  }
                  s2 = s3;
                  if (s2 !== peg$FAILED) {
                    peg$reportedPos = s0;
                    s1 = peg$c67(s2);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$c2;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$c2;
                }
              }
            }
          }
        }
      }

      return s0;
    }

    function peg$parsechars() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsechar();
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$parsechar();
        }
      } else {
        s1 = peg$c2;
      }
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c68(s1);
      }
      s0 = s1;

      return s0;
    }

    peg$result = peg$startRuleFunction();

    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
      return peg$result;
    } else {
      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
        peg$fail({ type: "end", description: "end of input" });
      }

      throw peg$buildException(null, peg$maxFailExpected, peg$maxFailPos);
    }
  }

  return {
    SyntaxError: SyntaxError,
    parse:       parse
  };
})();

//# sourceMappingURL=parser.js.map

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlRelativeFormat = __webpack_require__(993)['default'];

// Add all locale data to `IntlRelativeFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(1192);

// Re-export `IntlRelativeFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlRelativeFormat;
exports['default'] = exports;


/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var intl$messageformat$$ = __webpack_require__(484), src$diff$$ = __webpack_require__(990), src$es5$$ = __webpack_require__(992);
exports["default"] = RelativeFormat;

// -----------------------------------------------------------------------------

var FIELDS = ['second', 'minute', 'hour', 'day', 'month', 'year'];
var STYLES = ['best fit', 'numeric'];

// -- RelativeFormat -----------------------------------------------------------

function RelativeFormat(locales, options) {
    options = options || {};

    // Make a copy of `locales` if it's an array, so that it doesn't change
    // since it's used lazily.
    if (src$es5$$.isArray(locales)) {
        locales = locales.concat();
    }

    src$es5$$.defineProperty(this, '_locale', {value: this._resolveLocale(locales)});
    src$es5$$.defineProperty(this, '_options', {value: {
        style: this._resolveStyle(options.style),
        units: this._isValidUnits(options.units) && options.units
    }});

    src$es5$$.defineProperty(this, '_locales', {value: locales});
    src$es5$$.defineProperty(this, '_fields', {value: this._findFields(this._locale)});
    src$es5$$.defineProperty(this, '_messages', {value: src$es5$$.objCreate(null)});

    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var relativeFormat = this;
    this.format = function format(date, options) {
        return relativeFormat._format(date, options);
    };
}

// Define internal private properties for dealing with locale data.
src$es5$$.defineProperty(RelativeFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
src$es5$$.defineProperty(RelativeFormat, '__addLocaleData', {value: function (data) {
    if (!(data && data.locale)) {
        throw new Error(
            'Locale data provided to IntlRelativeFormat is missing a ' +
            '`locale` property value'
        );
    }

    RelativeFormat.__localeData__[data.locale.toLowerCase()] = data;

    // Add data to IntlMessageFormat.
    intl$messageformat$$["default"].__addLocaleData(data);
}});

// Define public `defaultLocale` property which can be set by the developer, or
// it will be set when the first RelativeFormat instance is created by
// leveraging the resolved locale from `Intl`.
src$es5$$.defineProperty(RelativeFormat, 'defaultLocale', {
    enumerable: true,
    writable  : true,
    value     : undefined
});

// Define public `thresholds` property which can be set by the developer, and
// defaults to relative time thresholds from moment.js.
src$es5$$.defineProperty(RelativeFormat, 'thresholds', {
    enumerable: true,

    value: {
        second: 45,  // seconds to minute
        minute: 45,  // minutes to hour
        hour  : 22,  // hours to day
        day   : 26,  // days to month
        month : 11   // months to year
    }
});

RelativeFormat.prototype.resolvedOptions = function () {
    return {
        locale: this._locale,
        style : this._options.style,
        units : this._options.units
    };
};

RelativeFormat.prototype._compileMessage = function (units) {
    // `this._locales` is the original set of locales the user specified to the
    // constructor, while `this._locale` is the resolved root locale.
    var locales        = this._locales;
    var resolvedLocale = this._locale;

    var field        = this._fields[units];
    var relativeTime = field.relativeTime;
    var future       = '';
    var past         = '';
    var i;

    for (i in relativeTime.future) {
        if (relativeTime.future.hasOwnProperty(i)) {
            future += ' ' + i + ' {' +
                relativeTime.future[i].replace('{0}', '#') + '}';
        }
    }

    for (i in relativeTime.past) {
        if (relativeTime.past.hasOwnProperty(i)) {
            past += ' ' + i + ' {' +
                relativeTime.past[i].replace('{0}', '#') + '}';
        }
    }

    var message = '{when, select, future {{0, plural, ' + future + '}}' +
                                 'past {{0, plural, ' + past + '}}}';

    // Create the synthetic IntlMessageFormat instance using the original
    // locales value specified by the user when constructing the the parent
    // IntlRelativeFormat instance.
    return new intl$messageformat$$["default"](message, locales);
};

RelativeFormat.prototype._getMessage = function (units) {
    var messages = this._messages;

    // Create a new synthetic message based on the locale data from CLDR.
    if (!messages[units]) {
        messages[units] = this._compileMessage(units);
    }

    return messages[units];
};

RelativeFormat.prototype._getRelativeUnits = function (diff, units) {
    var field = this._fields[units];

    if (field.relative) {
        return field.relative[diff];
    }
};

RelativeFormat.prototype._findFields = function (locale) {
    var localeData = RelativeFormat.__localeData__;
    var data       = localeData[locale.toLowerCase()];

    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find `fields` to return.
    while (data) {
        if (data.fields) {
            return data.fields;
        }

        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }

    throw new Error(
        'Locale data added to IntlRelativeFormat is missing `fields` for :' +
        locale
    );
};

RelativeFormat.prototype._format = function (date, options) {
    var now = options && options.now !== undefined ? options.now : src$es5$$.dateNow();

    if (date === undefined) {
        date = now;
    }

    // Determine if the `date` and optional `now` values are valid, and throw a
    // similar error to what `Intl.DateTimeFormat#format()` would throw.
    if (!isFinite(now)) {
        throw new RangeError(
            'The `now` option provided to IntlRelativeFormat#format() is not ' +
            'in valid range.'
        );
    }

    if (!isFinite(date)) {
        throw new RangeError(
            'The date value provided to IntlRelativeFormat#format() is not ' +
            'in valid range.'
        );
    }

    var diffReport  = src$diff$$["default"](now, date);
    var units       = this._options.units || this._selectUnits(diffReport);
    var diffInUnits = diffReport[units];

    if (this._options.style !== 'numeric') {
        var relativeUnits = this._getRelativeUnits(diffInUnits, units);
        if (relativeUnits) {
            return relativeUnits;
        }
    }

    return this._getMessage(units).format({
        '0' : Math.abs(diffInUnits),
        when: diffInUnits < 0 ? 'past' : 'future'
    });
};

RelativeFormat.prototype._isValidUnits = function (units) {
    if (!units || src$es5$$.arrIndexOf.call(FIELDS, units) >= 0) {
        return true;
    }

    if (typeof units === 'string') {
        var suggestion = /s$/.test(units) && units.substr(0, units.length - 1);
        if (suggestion && src$es5$$.arrIndexOf.call(FIELDS, suggestion) >= 0) {
            throw new Error(
                '"' + units + '" is not a valid IntlRelativeFormat `units` ' +
                'value, did you mean: ' + suggestion
            );
        }
    }

    throw new Error(
        '"' + units + '" is not a valid IntlRelativeFormat `units` value, it ' +
        'must be one of: "' + FIELDS.join('", "') + '"'
    );
};

RelativeFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }

    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(RelativeFormat.defaultLocale);

    var localeData = RelativeFormat.__localeData__;
    var i, len, localeParts, data;

    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');

        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }

            localeParts.pop();
        }
    }

    var defaultLocale = locales.pop();
    throw new Error(
        'No locale data has been added to IntlRelativeFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale
    );
};

RelativeFormat.prototype._resolveStyle = function (style) {
    // Default to "best fit" style.
    if (!style) {
        return STYLES[0];
    }

    if (src$es5$$.arrIndexOf.call(STYLES, style) >= 0) {
        return style;
    }

    throw new Error(
        '"' + style + '" is not a valid IntlRelativeFormat `style` value, it ' +
        'must be one of: "' + STYLES.join('", "') + '"'
    );
};

RelativeFormat.prototype._selectUnits = function (diffReport) {
    var i, l, units;

    for (i = 0, l = FIELDS.length; i < l; i += 1) {
        units = FIELDS[i];

        if (Math.abs(diffReport[units]) < RelativeFormat.thresholds[units]) {
            break;
        }
    }

    return units;
};

//# sourceMappingURL=core.js.map

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */



var round = Math.round;

function daysToYears(days) {
    // 400 years have 146097 days (taking into account leap year rules)
    return days * 400 / 146097;
}

exports["default"] = function (from, to) {
    // Convert to ms timestamps.
    from = +from;
    to   = +to;

    var millisecond = round(to - from),
        second      = round(millisecond / 1000),
        minute      = round(second / 60),
        hour        = round(minute / 60),
        day         = round(hour / 24),
        week        = round(day / 7);

    var rawYears = daysToYears(day),
        month    = round(rawYears * 12),
        year     = round(rawYears);

    return {
        millisecond: millisecond,
        second     : second,
        minute     : minute,
        hour       : hour,
        day        : day,
        week       : week,
        month      : month,
        year       : year
    };
};

//# sourceMappingURL=diff.js.map

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// GENERATED FILE

exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"},"fields":{"year":{"displayName":"year","relative":{"0":"this year","1":"next year","-1":"last year"},"relativeTime":{"future":{"one":"in {0} year","other":"in {0} years"},"past":{"one":"{0} year ago","other":"{0} years ago"}}},"month":{"displayName":"month","relative":{"0":"this month","1":"next month","-1":"last month"},"relativeTime":{"future":{"one":"in {0} month","other":"in {0} months"},"past":{"one":"{0} month ago","other":"{0} months ago"}}},"day":{"displayName":"day","relative":{"0":"today","1":"tomorrow","-1":"yesterday"},"relativeTime":{"future":{"one":"in {0} day","other":"in {0} days"},"past":{"one":"{0} day ago","other":"{0} days ago"}}},"hour":{"displayName":"hour","relativeTime":{"future":{"one":"in {0} hour","other":"in {0} hours"},"past":{"one":"{0} hour ago","other":"{0} hours ago"}}},"minute":{"displayName":"minute","relativeTime":{"future":{"one":"in {0} minute","other":"in {0} minutes"},"past":{"one":"{0} minute ago","other":"{0} minutes ago"}}},"second":{"displayName":"second","relative":{"0":"now"},"relativeTime":{"future":{"one":"in {0} second","other":"in {0} seconds"},"past":{"one":"{0} second ago","other":"{0} seconds ago"}}}}};

//# sourceMappingURL=en.js.map

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */



// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var hop = Object.prototype.hasOwnProperty;
var toString = Object.prototype.toString;

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

var arrIndexOf = Array.prototype.indexOf || function (search, fromIndex) {
    /*jshint validthis:true */
    var arr = this;
    if (!arr.length) {
        return -1;
    }

    for (var i = fromIndex || 0, max = arr.length; i < max; i++) {
        if (arr[i] === search) {
            return i;
        }
    }

    return -1;
};

var isArray = Array.isArray || function (obj) {
    return toString.call(obj) === '[object Array]';
};

var dateNow = Date.now || function () {
    return new Date().getTime();
};
exports.defineProperty = defineProperty, exports.objCreate = objCreate, exports.arrIndexOf = arrIndexOf, exports.isArray = isArray, exports.dateNow = dateNow;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jslint esnext: true */


var src$core$$ = __webpack_require__(989), src$en$$ = __webpack_require__(991);

src$core$$["default"].__addLocaleData(src$en$$["default"]);
src$core$$["default"].defaultLocale = 'en';

exports["default"] = src$core$$["default"];

//# sourceMappingURL=main.js.map

/***/ }),
/* 994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(998);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(19)))

/***/ }),
/* 996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(999);


/** Built-in value references. */
var getPrototype = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(486);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 1000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(995);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 1001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(129),
    root = __webpack_require__(81);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(1057),
    hashDelete = __webpack_require__(1058),
    hashGet = __webpack_require__(1059),
    hashHas = __webpack_require__(1060),
    hashSet = __webpack_require__(1061);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(129),
    root = __webpack_require__(81);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(129),
    root = __webpack_require__(81);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 1006 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 1007 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 1008 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),
/* 1009 */
/***/ (function(module, exports) {

/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

module.exports = asciiWords;


/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(41);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(338);

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  baseEach(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

module.exports = baseFilter;


/***/ }),
/* 1012 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(491),
    keys = __webpack_require__(179);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(550),
    isArray = __webpack_require__(40);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 1015 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(105),
    isObjectLike = __webpack_require__(92);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(336),
    equalArrays = __webpack_require__(498),
    equalByTag = __webpack_require__(1048),
    equalObjects = __webpack_require__(1049),
    getTag = __webpack_require__(501),
    isArray = __webpack_require__(40),
    isBuffer = __webpack_require__(233),
    isTypedArray = __webpack_require__(234);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(336),
    baseIsEqual = __webpack_require__(339);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 1019 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(107),
    isMasked = __webpack_require__(1065),
    isObject = __webpack_require__(41),
    toSource = __webpack_require__(507);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(105),
    isLength = __webpack_require__(341),
    isObjectLike = __webpack_require__(92);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(41),
    isPrototype = __webpack_require__(177),
    nativeKeysIn = __webpack_require__(1079);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(1018),
    getMatchData = __webpack_require__(1051),
    matchesStrictComparable = __webpack_require__(504);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(339),
    get = __webpack_require__(1101),
    hasIn = __webpack_require__(565),
    isKey = __webpack_require__(340),
    isStrictComparable = __webpack_require__(503),
    matchesStrictComparable = __webpack_require__(504),
    toKey = __webpack_require__(191);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(336),
    assignMergeValue = __webpack_require__(490),
    baseFor = __webpack_require__(491),
    baseMergeDeep = __webpack_require__(1026),
    isObject = __webpack_require__(41),
    keysIn = __webpack_require__(414);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    if (isObject(srcValue)) {
      stack || (stack = new Stack);
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(object[key], srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

var assignMergeValue = __webpack_require__(490),
    cloneBuffer = __webpack_require__(1039),
    cloneTypedArray = __webpack_require__(1040),
    copyArray = __webpack_require__(1041),
    initCloneObject = __webpack_require__(1062),
    isArguments = __webpack_require__(185),
    isArray = __webpack_require__(40),
    isArrayLikeObject = __webpack_require__(551),
    isBuffer = __webpack_require__(233),
    isFunction = __webpack_require__(107),
    isObject = __webpack_require__(41),
    isPlainObject = __webpack_require__(247),
    isTypedArray = __webpack_require__(234),
    toPlainObject = __webpack_require__(1114);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = object[key],
      srcValue = source[key],
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),
/* 1027 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(361);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 1029 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

module.exports = basePropertyOf;


/***/ }),
/* 1030 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */
function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
  eachFunc(collection, function(value, index, collection) {
    accumulator = initAccum
      ? (initAccum = false, value)
      : iteratee(accumulator, value, index, collection);
  });
  return accumulator;
}

module.exports = baseReduce;


/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(1097),
    defineProperty = __webpack_require__(497),
    identity = __webpack_require__(130);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 1032 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 1033 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(359);

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(130);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(260);

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the last unmatched string symbol.
 */
function charsEndIndex(strSymbols, chrSymbols) {
  var index = strSymbols.length;

  while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

module.exports = charsEndIndex;


/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(260);

/**
 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the first unmatched string symbol.
 */
function charsStartIndex(strSymbols, chrSymbols) {
  var index = -1,
      length = strSymbols.length;

  while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

module.exports = charsStartIndex;


/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(487);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(81);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(181)(module)))

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(1038);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 1041 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(81);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(106);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 1044 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

var castSlice = __webpack_require__(496),
    hasUnicode = __webpack_require__(502),
    stringToArray = __webpack_require__(506),
    toString = __webpack_require__(131);

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

module.exports = createCaseFirst;


/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(489),
    deburr = __webpack_require__(1098),
    words = __webpack_require__(1118);

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]";

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

module.exports = createCompounder;


/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

var basePropertyOf = __webpack_require__(1029);

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 's'
};

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = basePropertyOf(deburredLetters);

module.exports = deburrLetter;


/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(184),
    Uint8Array = __webpack_require__(487),
    eq = __webpack_require__(167),
    equalArrays = __webpack_require__(498),
    mapToArray = __webpack_require__(1076),
    setToArray = __webpack_require__(612);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(1050);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(1014),
    getSymbols = __webpack_require__(1053),
    keys = __webpack_require__(179);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(503),
    keys = __webpack_require__(179);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(184);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(411),
    stubArray = __webpack_require__(1109);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 1054 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(261),
    isArguments = __webpack_require__(185),
    isArray = __webpack_require__(40),
    isIndex = __webpack_require__(246),
    isLength = __webpack_require__(341),
    toKey = __webpack_require__(191);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 1056 */
/***/ (function(module, exports) {

/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

module.exports = hasUnicodeWord;


/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(232);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 1058 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(232);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(232);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(232);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(1010),
    getPrototype = __webpack_require__(500),
    isPrototype = __webpack_require__(177);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(167),
    isArrayLike = __webpack_require__(106),
    isIndex = __webpack_require__(246),
    isObject = __webpack_require__(41);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 1064 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(1042);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 1066 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(230);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(230);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(230);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(230);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(1003),
    ListCache = __webpack_require__(229),
    Map = __webpack_require__(334);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(231);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(231);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(231);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(231);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 1076 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(640);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(505);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 1079 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(499);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(181)(module)))

/***/ }),
/* 1081 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 1082 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 1083 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 1084 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(229);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 1086 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 1087 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 1088 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(229),
    Map = __webpack_require__(334),
    MapCache = __webpack_require__(335);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 1090 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(1077);

/** Used to match property names within property paths. */
var reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 1092 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),
/* 1093 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsOrdLower = '\\d*(?:(?:1st|2nd|3rd|(?![123])\\dth)\\b)',
    rsOrdUpper = '\\d*(?:(?:1ST|2ND|3RD|(?![123])\\dTH)\\b)',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
  rsUpper + '+' + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

module.exports = unicodeWords;


/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(360),
    copyObject = __webpack_require__(412),
    createAssigner = __webpack_require__(413),
    isArrayLike = __webpack_require__(106),
    isPrototype = __webpack_require__(177),
    keys = __webpack_require__(179);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

module.exports = assign;


/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

var capitalize = __webpack_require__(1096),
    createCompounder = __webpack_require__(1046);

/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */
var camelCase = createCompounder(function(result, word, index) {
  word = word.toLowerCase();
  return result + (index ? capitalize(word) : word);
});

module.exports = camelCase;


/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(131),
    upperFirst = __webpack_require__(1116);

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
  return upperFirst(toString(string).toLowerCase());
}

module.exports = capitalize;


/***/ }),
/* 1097 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

var deburrLetter = __webpack_require__(1047),
    toString = __webpack_require__(131);

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;

/** Used to compose unicode capture groups. */
var rsCombo = '[' + rsComboRange + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

module.exports = deburr;


/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(411),
    baseFilter = __webpack_require__(1011),
    baseIteratee = __webpack_require__(492),
    isArray = __webpack_require__(40);

/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 */
function filter(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = filter;


/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(1006),
    baseEach = __webpack_require__(338),
    castFunction = __webpack_require__(1035),
    isArray = __webpack_require__(40);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(361);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(260),
    isArrayLike = __webpack_require__(106),
    isString = __webpack_require__(248),
    toInteger = __webpack_require__(1112),
    values = __webpack_require__(1117);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes(collection, value, fromIndex, guard) {
  collection = isArrayLike(collection) ? collection : values(collection);
  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = nativeMax(length + fromIndex, 0);
  }
  return isString(collection)
    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
}

module.exports = includes;


/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(105),
    isObjectLike = __webpack_require__(92);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]';

/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */
function isBoolean(value) {
  return value === true || value === false ||
    (isObjectLike(value) && baseGetTag(value) == boolTag);
}

module.exports = isBoolean;


/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__(493),
    getTag = __webpack_require__(501),
    isArguments = __webpack_require__(185),
    isArray = __webpack_require__(40),
    isArrayLike = __webpack_require__(106),
    isBuffer = __webpack_require__(233),
    isPrototype = __webpack_require__(177),
    isTypedArray = __webpack_require__(234);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),
/* 1105 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

module.exports = isNil;


/***/ }),
/* 1106 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */
function isUndefined(value) {
  return value === undefined;
}

module.exports = isUndefined;


/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__(1025),
    createAssigner = __webpack_require__(413);

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;


/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(1027),
    basePropertyDeep = __webpack_require__(1028),
    isKey = __webpack_require__(340),
    toKey = __webpack_require__(191);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 1109 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 1110 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(1113);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(1111);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(41),
    isSymbol = __webpack_require__(178);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(412),
    keysIn = __webpack_require__(414);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(495),
    castSlice = __webpack_require__(496),
    charsEndIndex = __webpack_require__(1036),
    charsStartIndex = __webpack_require__(1037),
    stringToArray = __webpack_require__(506),
    toString = __webpack_require__(131);

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/**
 * Removes leading and trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trim('  abc  ');
 * // => 'abc'
 *
 * _.trim('-_-abc-_-', '_-');
 * // => 'abc'
 *
 * _.map(['  foo  ', '  bar  '], _.trim);
 * // => ['foo', 'bar']
 */
function trim(string, chars, guard) {
  string = toString(string);
  if (string && (guard || chars === undefined)) {
    return string.replace(reTrim, '');
  }
  if (!string || !(chars = baseToString(chars))) {
    return string;
  }
  var strSymbols = stringToArray(string),
      chrSymbols = stringToArray(chars),
      start = charsStartIndex(strSymbols, chrSymbols),
      end = charsEndIndex(strSymbols, chrSymbols) + 1;

  return castSlice(strSymbols, start, end).join('');
}

module.exports = trim;


/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

var createCaseFirst = __webpack_require__(1045);

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

module.exports = upperFirst;


/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

var baseValues = __webpack_require__(1034),
    keys = __webpack_require__(179);

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;


/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

var asciiWords = __webpack_require__(1009),
    hasUnicodeWord = __webpack_require__(1056),
    toString = __webpack_require__(131),
    unicodeWords = __webpack_require__(1093);

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

module.exports = words;


/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

/**
 * Make a shallow copy of the object maintaining the prototype.
 */

exports.default = function (source) {
    var target = void 0;

    if (source.constructor === Array) {
        target = source.map(function (element) {
            return element;
        });
    } else {
        target = {};
        for (var property in source) {
            if (source.hasOwnProperty(property)) {
                target[property] = source[property];
            }
        }
    }

    _defaults(target, Object.getPrototypeOf(source));

    return target;
};

module.exports = exports['default'];
//# sourceMappingURL=objectUnfreeze.js.map


/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(970);
var invariant = __webpack_require__(373);
var ReactPropTypesSecret = __webpack_require__(1121);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(1168);
var objectAssign = __webpack_require__(374);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _class = function () {
  function _class() {
    _classCallCheck(this, _class);

    this.size = 0;
    this.keys = [];
    this.values = [];
  }

  _class.prototype.get = function get(key) {
    var index = this.keys.indexOf(key);

    return this.values[index];
  };

  _class.prototype.set = function set(key, value) {
    this.keys.push(key);
    this.values.push(value);
    this.size = this.keys.length;

    return value;
  };

  return _class;
}();

exports.default = _class;
module.exports = exports["default"];

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isObject2 = __webpack_require__(41);

var _isObject3 = _interopRequireDefault(_isObject2);

var _react = __webpack_require__(15);

var _react2 = _interopRequireDefault(_react);

var _hoistNonReactStatics = __webpack_require__(243);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _linkClass = __webpack_require__(512);

var _linkClass2 = _interopRequireDefault(_linkClass);

var _renderNothing = __webpack_require__(513);

var _renderNothing2 = _interopRequireDefault(_renderNothing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); } /* eslint-disable react/prop-types */

/**
 * @param {ReactClass} Component
 * @param {Object} defaultStyles
 * @param {Object} options
 * @returns {ReactClass}
 */
exports.default = function (Component, defaultStyles, options) {
  var WrappedComponent = function (_Component) {
    _inherits(WrappedComponent, _Component);

    function WrappedComponent() {
      _classCallCheck(this, WrappedComponent);

      return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    WrappedComponent.prototype.render = function render() {
      var styles = void 0;

      var hasDefaultstyles = (0, _isObject3.default)(defaultStyles);

      if (this.props.styles || hasDefaultstyles) {
        var props = Object.assign({}, this.props);

        if (this.props.styles) {
          styles = this.props.styles;
        } else if (hasDefaultstyles) {
          styles = defaultStyles;
          delete this.props.styles;
        }

        Object.defineProperty(props, 'styles', {
          configurable: true,
          enumerable: false,
          value: styles,
          writable: false
        });

        this.props = props;
      } else {
        styles = {};
      }

      var renderResult = _Component.prototype.render.call(this);

      if (renderResult) {
        return (0, _linkClass2.default)(renderResult, styles, options);
      }

      return (0, _renderNothing2.default)(_react2.default.version);
    };

    return WrappedComponent;
  }(Component);

  return (0, _hoistNonReactStatics2.default)(WrappedComponent, Component);
};

module.exports = exports['default'];

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SimpleMap = __webpack_require__(1123);

var _SimpleMap2 = _interopRequireDefault(_SimpleMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomMap = typeof Map === 'undefined' ? _SimpleMap2.default : Map;

var stylesIndex = new CustomMap();

exports.default = function (styles, styleNames, errorWhenNotFound) {
  var appendClassName = void 0;
  var stylesIndexMap = void 0;

  stylesIndexMap = stylesIndex.get(styles);

  if (stylesIndexMap) {
    var styleNameIndex = stylesIndexMap.get(styleNames);

    if (styleNameIndex) {
      return styleNameIndex;
    }
  } else {
    stylesIndexMap = new CustomMap();
    stylesIndex.set(styles, new CustomMap());
  }

  appendClassName = '';

  for (var styleName in styleNames) {
    if (styleNames.hasOwnProperty(styleName)) {
      var className = styles[styleNames[styleName]];

      if (className) {
        appendClassName += ' ' + className;
      } else if (errorWhenNotFound === true) {
        throw new Error('"' + styleNames[styleName] + '" CSS module is undefined.');
      }
    }
  }

  appendClassName = appendClassName.trim();

  stylesIndexMap.set(styleNames, appendClassName);

  return appendClassName;
};

module.exports = exports['default'];

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isObject2 = __webpack_require__(41);

var _isObject3 = _interopRequireDefault(_isObject2);

var _isFunction2 = __webpack_require__(107);

var _isFunction3 = _interopRequireDefault(_isFunction2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ITERATOR_SYMBOL = typeof Symbol !== 'undefined' && (0, _isFunction3.default)(Symbol) && Symbol.iterator;
var OLD_ITERATOR_SYMBOL = '@@iterator';

/**
 * @see https://github.com/lodash/lodash/issues/1668
 * @see https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Iteration_protocols
 */

exports.default = function (maybeIterable) {
  var iterator = void 0;

  if (!(0, _isObject3.default)(maybeIterable)) {
    return false;
  }

  if (ITERATOR_SYMBOL) {
    iterator = maybeIterable[ITERATOR_SYMBOL];
  } else {
    iterator = maybeIterable[OLD_ITERATOR_SYMBOL];
  }

  return (0, _isFunction3.default)(iterator);
};

module.exports = exports['default'];

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isBoolean2 = __webpack_require__(1103);

var _isBoolean3 = _interopRequireDefault(_isBoolean2);

var _isUndefined2 = __webpack_require__(1106);

var _isUndefined3 = _interopRequireDefault(_isUndefined2);

var _forEach2 = __webpack_require__(1100);

var _forEach3 = _interopRequireDefault(_forEach2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @typedef CSSModules~Options
 * @see {@link https://github.com/gajus/react-css-modules#options}
 * @property {boolean} allowMultiple
 * @property {boolean} errorWhenNotFound
 */

/**
 * @param {CSSModules~Options} userConfiguration
 * @returns {CSSModules~Options}
 */
exports.default = function () {
  var userConfiguration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var configuration = {
    allowMultiple: false,
    errorWhenNotFound: true
  };

  (0, _forEach3.default)(userConfiguration, function (value, name) {
    if ((0, _isUndefined3.default)(configuration[name])) {
      throw new Error('Unknown configuration property "' + name + '".');
    }

    if (!(0, _isBoolean3.default)(value)) {
      throw new Error('"' + name + '" property value must be a boolean.');
    }

    configuration[name] = value;
  });

  return configuration;
};

module.exports = exports['default'];

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _filter2 = __webpack_require__(1099);

var _filter3 = _interopRequireDefault(_filter2);

var _trim2 = __webpack_require__(1115);

var _trim3 = _interopRequireDefault(_trim2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styleNameIndex = {};

exports.default = function (styleNamePropertyValue, allowMultiple) {
  var styleNames = void 0;

  if (styleNameIndex[styleNamePropertyValue]) {
    styleNames = styleNameIndex[styleNamePropertyValue];
  } else {
    styleNames = (0, _trim3.default)(styleNamePropertyValue).split(/\s+/);
    styleNames = (0, _filter3.default)(styleNames);

    styleNameIndex[styleNamePropertyValue] = styleNames;
  }

  if (allowMultiple === false && styleNames.length > 1) {
    throw new Error('ReactElement styleName property defines multiple module names ("' + styleNamePropertyValue + '").');
  }

  return styleNames;
};

module.exports = exports['default'];

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign2 = __webpack_require__(1094);

var _assign3 = _interopRequireDefault(_assign2);

var _isObject2 = __webpack_require__(41);

var _isObject3 = _interopRequireDefault(_isObject2);

var _react = __webpack_require__(15);

var _react2 = _interopRequireDefault(_react);

var _linkClass = __webpack_require__(512);

var _linkClass2 = _interopRequireDefault(_linkClass);

var _renderNothing = __webpack_require__(513);

var _renderNothing2 = _interopRequireDefault(_renderNothing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @see https://facebook.github.io/react/blog/2015/09/10/react-v0.14-rc1.html#stateless-function-components
 */
exports.default = function (Component, defaultStyles, options) {
  var WrappedComponent = function WrappedComponent() {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var styles = void 0;
    var useProps = void 0;
    var hasDefaultstyles = (0, _isObject3.default)(defaultStyles);

    if (props.styles || hasDefaultstyles) {
      useProps = Object.assign({}, props);

      if (props.styles) {
        styles = props.styles;
      } else {
        styles = defaultStyles;
      }

      Object.defineProperty(useProps, 'styles', {
        configurable: true,
        enumerable: false,
        value: styles,
        writable: false
      });
    } else {
      useProps = props;
      styles = {};
    }

    var renderResult = Component.apply(undefined, [useProps].concat(args));

    if (renderResult) {
      return (0, _linkClass2.default)(renderResult, styles, options);
    }

    return (0, _renderNothing2.default)(_react2.default.version);
  };

  (0, _assign3.default)(WrappedComponent, Component);

  return WrappedComponent;
}; /* eslint-disable react/prop-types */

module.exports = exports['default'];

/***/ }),
/* 1130 */,
/* 1131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(343);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  Provider.displayName = 'Provider';

  return Provider;
}

/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 1132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(1139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(1133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(1134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(1135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(1136);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 1133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(515);



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsConstant */])(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsConstant */])(function (dispatch) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 1134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(515);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 1135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(517);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 1136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(1137);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 1137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(343);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 1138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 1139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = routerMiddleware;

var _actions = __webpack_require__(518);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
 * provided history object. This will prevent these actions from reaching your
 * reducer or any middleware that comes after this one.
 */
function routerMiddleware(history) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type !== _actions.CALL_HISTORY_METHOD) {
          return next(action);
        }

        var _action$payload = action.payload,
            method = _action$payload.method,
            args = _action$payload.args;

        history[method].apply(history, _toConsumableArray(args));
      };
    };
  };
}

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = syncHistoryWithStore;

var _reducer = __webpack_require__(520);

var defaultSelectLocationState = function defaultSelectLocationState(state) {
  return state.routing;
};

/**
 * This function synchronizes your history state with the Redux store.
 * Location changes flow from history to the store. An enhanced history is
 * returned with a listen method that responds to store updates for location.
 *
 * When this history is provided to the router, this means the location data
 * will flow like this:
 * history.push -> store.dispatch -> enhancedHistory.listen -> router
 * This ensures that when the store state changes due to a replay or other
 * event, the router will be updated appropriately and can transition to the
 * correct router state.
 */
function syncHistoryWithStore(history, store) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$selectLocationSt = _ref.selectLocationState,
      selectLocationState = _ref$selectLocationSt === undefined ? defaultSelectLocationState : _ref$selectLocationSt,
      _ref$adjustUrlOnRepla = _ref.adjustUrlOnReplay,
      adjustUrlOnReplay = _ref$adjustUrlOnRepla === undefined ? true : _ref$adjustUrlOnRepla;

  // Ensure that the reducer is mounted on the store and functioning properly.
  if (typeof selectLocationState(store.getState()) === 'undefined') {
    throw new Error('Expected the routing state to be available either as `state.routing` ' + 'or as the custom expression you can specify as `selectLocationState` ' + 'in the `syncHistoryWithStore()` options. ' + 'Ensure you have added the `routerReducer` to your store\'s ' + 'reducers via `combineReducers` or whatever method you use to isolate ' + 'your reducers.');
  }

  var initialLocation = void 0;
  var isTimeTraveling = void 0;
  var unsubscribeFromStore = void 0;
  var unsubscribeFromHistory = void 0;
  var currentLocation = void 0;

  // What does the store say about current location?
  var getLocationInStore = function getLocationInStore(useInitialIfEmpty) {
    var locationState = selectLocationState(store.getState());
    return locationState.locationBeforeTransitions || (useInitialIfEmpty ? initialLocation : undefined);
  };

  // Init initialLocation with potential location in store
  initialLocation = getLocationInStore();

  // If the store is replayed, update the URL in the browser to match.
  if (adjustUrlOnReplay) {
    var handleStoreChange = function handleStoreChange() {
      var locationInStore = getLocationInStore(true);
      if (currentLocation === locationInStore || initialLocation === locationInStore) {
        return;
      }

      // Update address bar to reflect store state
      isTimeTraveling = true;
      currentLocation = locationInStore;
      history.transitionTo(_extends({}, locationInStore, {
        action: 'PUSH'
      }));
      isTimeTraveling = false;
    };

    unsubscribeFromStore = store.subscribe(handleStoreChange);
    handleStoreChange();
  }

  // Whenever location changes, dispatch an action to get it in the store
  var handleLocationChange = function handleLocationChange(location) {
    // ... unless we just caused that location change
    if (isTimeTraveling) {
      return;
    }

    // Remember where we are
    currentLocation = location;

    // Are we being called for the first time?
    if (!initialLocation) {
      // Remember as a fallback in case state is reset
      initialLocation = location;

      // Respect persisted location, if any
      if (getLocationInStore()) {
        return;
      }
    }

    // Tell the store to update by dispatching an action
    store.dispatch({
      type: _reducer.LOCATION_CHANGE,
      payload: location
    });
  };
  unsubscribeFromHistory = history.listen(handleLocationChange);

  // History 3.x doesn't call listen synchronously, so fire the initial location change ourselves
  if (history.getCurrentLocation) {
    handleLocationChange(history.getCurrentLocation());
  }

  // The enhanced history uses store as source of truth
  return _extends({}, history, {
    // The listeners are subscribed to the store instead of history
    listen: function listen(listener) {
      // Copy of last location.
      var lastPublishedLocation = getLocationInStore(true);

      // Keep track of whether we unsubscribed, as Redux store
      // only applies changes in subscriptions on next dispatch
      var unsubscribed = false;
      var unsubscribeFromStore = store.subscribe(function () {
        var currentLocation = getLocationInStore(true);
        if (currentLocation === lastPublishedLocation) {
          return;
        }
        lastPublishedLocation = currentLocation;
        if (!unsubscribed) {
          listener(lastPublishedLocation);
        }
      });

      // History 2.x listeners expect a synchronous call. Make the first call to the
      // listener after subscribing to the store, in case the listener causes a
      // location change (e.g. when it redirects)
      if (!history.getCurrentLocation) {
        listener(lastPublishedLocation);
      }

      // Let user unsubscribe later
      return function () {
        unsubscribed = true;
        unsubscribeFromStore();
      };
    },


    // It also provides a way to destroy internal listeners
    unsubscribe: function unsubscribe() {
      if (adjustUrlOnReplay) {
        unsubscribeFromStore();
      }
      unsubscribeFromHistory();
    }
  });
}

/***/ }),
/* 1142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(521);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/**
 * An <IndexLink> is used to link to an <IndexRoute>.
 */
var IndexLink = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'IndexLink',

  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Link__["a" /* default */], _extends({}, this.props, { onlyActiveOnIndex: true }));
  }
});

/* unused harmony default export */ var _unused_webpack_default_export = (IndexLink);

/***/ }),
/* 1143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redirect__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(180);







/**
 * An <IndexRedirect> is used to redirect from an indexRoute.
 */
/* eslint-disable react/require-render-return */
var IndexRedirect = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'IndexRedirect',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = __WEBPACK_IMPORTED_MODULE_4__Redirect__["a" /* default */].createRouteFromReactElement(element);
      } else {
         false ? warning(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    to: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"].isRequired,
    query: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    state: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    onEnter: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (IndexRedirect);

/***/ }),
/* 1144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(180);







/**
 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
 * a JSX route config.
 */
/* eslint-disable react/require-render-return */
var IndexRoute = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'IndexRoute',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["c" /* createRouteFromReactElement */])(element);
      } else {
         false ? warning(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    component: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["a" /* component */],
    components: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["b" /* components */],
    getComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
    getComponents: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (IndexRoute);

/***/ }),
/* 1145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RouteUtils__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__ = __webpack_require__(180);






/**
 * A <Route> is used to declare which components are rendered to the
 * page when the URL matches a given pattern.
 *
 * Routes are arranged in a nested tree structure. When a new URL is
 * requested, the tree is searched depth-first to find a route whose
 * path matches the URL.  When one is found, all routes in the tree
 * that lead to it are considered "active" and their components are
 * rendered into the DOM, nested in the same order as in the tree.
 */
/* eslint-disable react/require-render-return */
var Route = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'Route',

  statics: {
    createRouteFromReactElement: __WEBPACK_IMPORTED_MODULE_3__RouteUtils__["c" /* createRouteFromReactElement */]
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
    component: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["a" /* component */],
    components: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["b" /* components */],
    getComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
    getComponents: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<Route> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 1146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RouterContext__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RouteUtils__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RouterUtils__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__routerWarning__ = __webpack_require__(148);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }













var propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"],
  children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["d" /* routes */],
  routes: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["d" /* routes */], // alias for children
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  createElement: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onError: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onUpdate: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],

  // PRIVATE: For client-side rehydration of server match.
  matchContext: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"]
};

/**
 * A <Router> is a high-level API for automatically setting up
 * a router that renders a <RouterContext> with all the props
 * it needs each time the URL changes.
 */
var Router = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'Router',

  propTypes: propTypes,

  getDefaultProps: function getDefaultProps() {
    return {
      render: function render(props) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__RouterContext__["a" /* default */], props);
      }
    };
  },
  getInitialState: function getInitialState() {
    return {
      location: null,
      routes: null,
      params: null,
      components: null
    };
  },
  handleError: function handleError(error) {
    if (this.props.onError) {
      this.props.onError.call(this, error);
    } else {
      // Throw errors by default so we don't silently swallow them!
      throw error; // This error probably occurred in getChildRoutes or getComponents.
    }
  },
  createRouterObject: function createRouterObject(state) {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext.router;
    }

    var history = this.props.history;

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__RouterUtils__["a" /* createRouterObject */])(history, this.transitionManager, state);
  },
  createTransitionManager: function createTransitionManager() {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext.transitionManager;
    }

    var history = this.props.history;
    var _props = this.props,
        routes = _props.routes,
        children = _props.children;


    !history.getCurrentLocation ?  false ? invariant(false, 'You have provided a history object created with history v4.x or v2.x ' + 'and earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please change to history v3.x.') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])(history, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__RouteUtils__["b" /* createRoutes */])(routes || children));
  },
  componentWillMount: function componentWillMount() {
    var _this = this;

    this.transitionManager = this.createTransitionManager();
    this.router = this.createRouterObject(this.state);

    this._unlisten = this.transitionManager.listen(function (error, state) {
      if (error) {
        _this.handleError(error);
      } else {
        // Keep the identity of this.router because of a caveat in ContextUtils:
        // they only work if the object identity is preserved.
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__RouterUtils__["b" /* assignRouterState */])(_this.router, state);
        _this.setState(state, _this.props.onUpdate);
      }
    });
  },


  /* istanbul ignore next: sanity check */
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
     false ? warning(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;

     false ? warning((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
  },
  componentWillUnmount: function componentWillUnmount() {
    if (this._unlisten) this._unlisten();
  },
  render: function render() {
    var _state = this.state,
        location = _state.location,
        routes = _state.routes,
        params = _state.params,
        components = _state.components;

    var _props2 = this.props,
        createElement = _props2.createElement,
        render = _props2.render,
        props = _objectWithoutProperties(_props2, ['createElement', 'render']);

    if (location == null) return null; // Async match

    // Only forward non-Router-specific props to routing context, as those are
    // the only ones that might be custom routing context props.
    Object.keys(propTypes).forEach(function (propType) {
      return delete props[propType];
    });

    return render(_extends({}, props, {
      router: this.router,
      location: location,
      routes: routes,
      params: params,
      components: components,
      createElement: createElement
    }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 1147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTransitionUtils;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(344);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var PendingHooks = function PendingHooks() {
  var _this = this;

  _classCallCheck(this, PendingHooks);

  this.hooks = [];

  this.add = function (hook) {
    return _this.hooks.push(hook);
  };

  this.remove = function (hook) {
    return _this.hooks = _this.hooks.filter(function (h) {
      return h !== hook;
    });
  };

  this.has = function (hook) {
    return _this.hooks.indexOf(hook) !== -1;
  };

  this.clear = function () {
    return _this.hooks = [];
  };
};

function getTransitionUtils() {
  var enterHooks = new PendingHooks();
  var changeHooks = new PendingHooks();

  function createTransitionHook(hook, route, asyncArity, pendingHooks) {
    var isSync = hook.length < asyncArity;

    var transitionHook = function transitionHook() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      hook.apply(route, args);

      if (isSync) {
        var callback = args[args.length - 1];
        // Assume hook executes synchronously and
        // automatically call the callback.
        callback();
      }
    };

    pendingHooks.add(transitionHook);

    return transitionHook;
  }

  function getEnterHooks(routes) {
    return routes.reduce(function (hooks, route) {
      if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
      return hooks;
    }, []);
  }

  function getChangeHooks(routes) {
    return routes.reduce(function (hooks, route) {
      if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
      return hooks;
    }, []);
  }

  function runTransitionHooks(length, iter, callback) {
    if (!length) {
      callback();
      return;
    }

    var redirectInfo = void 0;
    function replace(location) {
      redirectInfo = location;
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["b" /* loopAsync */])(length, function (index, next, done) {
      iter(index, replace, function (error) {
        if (error || redirectInfo) {
          done(error, redirectInfo); // No need to continue.
        } else {
          next();
        }
      });
    }, callback);
  }

  /**
   * Runs all onEnter hooks in the given array of routes in order
   * with onEnter(nextState, replace, callback) and calls
   * callback(error, redirectInfo) when finished. The first hook
   * to use replace short-circuits the loop.
   *
   * If a hook needs to run asynchronously, it may use the callback
   * function. However, doing so will cause the transition to pause,
   * which could lead to a non-responsive UI if the hook is slow.
   */
  function runEnterHooks(routes, nextState, callback) {
    enterHooks.clear();
    var hooks = getEnterHooks(routes);
    return runTransitionHooks(hooks.length, function (index, replace, next) {
      var wrappedNext = function wrappedNext() {
        if (enterHooks.has(hooks[index])) {
          next.apply(undefined, arguments);
          enterHooks.remove(hooks[index]);
        }
      };
      hooks[index](nextState, replace, wrappedNext);
    }, callback);
  }

  /**
   * Runs all onChange hooks in the given array of routes in order
   * with onChange(prevState, nextState, replace, callback) and calls
   * callback(error, redirectInfo) when finished. The first hook
   * to use replace short-circuits the loop.
   *
   * If a hook needs to run asynchronously, it may use the callback
   * function. However, doing so will cause the transition to pause,
   * which could lead to a non-responsive UI if the hook is slow.
   */
  function runChangeHooks(routes, state, nextState, callback) {
    changeHooks.clear();
    var hooks = getChangeHooks(routes);
    return runTransitionHooks(hooks.length, function (index, replace, next) {
      var wrappedNext = function wrappedNext() {
        if (changeHooks.has(hooks[index])) {
          next.apply(undefined, arguments);
          changeHooks.remove(hooks[index]);
        }
      };
      hooks[index](state, nextState, replace, wrappedNext);
    }, callback);
  }

  /**
   * Runs all onLeave hooks in the given array of routes in order.
   */
  function runLeaveHooks(routes, prevState) {
    for (var i = 0, len = routes.length; i < len; ++i) {
      if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
    }
  }

  return {
    runEnterHooks: runEnterHooks,
    runChangeHooks: runChangeHooks,
    runLeaveHooks: runLeaveHooks
  };
}

/***/ }),
/* 1148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RouterContext__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(148);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/* unused harmony default export */ var _unused_webpack_default_export = (function () {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  if (false) {
    middlewares.forEach(function (middleware, index) {
      process.env.NODE_ENV !== 'production' ? warning(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
    });
  }

  var withContext = middlewares.map(function (middleware) {
    return middleware.renderRouterContext;
  }).filter(Boolean);
  var withComponent = middlewares.map(function (middleware) {
    return middleware.renderRouteComponent;
  }).filter(Boolean);

  var makeCreateElement = function makeCreateElement() {
    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"];
    return function (Component, props) {
      return withComponent.reduceRight(function (previous, renderRouteComponent) {
        return renderRouteComponent(previous, props);
      }, baseCreateElement(Component, props));
    };
  };

  return function (renderProps) {
    return withContext.reduceRight(function (previous, renderRouterContext) {
      return renderRouterContext(previous, renderProps);
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__RouterContext__["a" /* default */], _extends({}, renderProps, {
      createElement: makeCreateElement(renderProps.createElement)
    })));
  };
});

/***/ }),
/* 1149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory__ = __webpack_require__(975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createRouterHistory__ = __webpack_require__(526);


/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__createRouterHistory__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory___default.a));

/***/ }),
/* 1150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(147);


function routeParamsChanged(route, prevState, nextState) {
  if (!route.path) return false;

  var paramNames = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["a" /* getParamNames */])(route.path);

  return paramNames.some(function (paramName) {
    return prevState.params[paramName] !== nextState.params[paramName];
  });
}

/**
 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
 * the change from prevState to nextState. We leave routes if either
 * 1) they are not in the next state or 2) they are in the next state
 * but their params have changed (i.e. /users/123 => /users/456).
 *
 * leaveRoutes are ordered starting at the leaf route of the tree
 * we're leaving up to the common parent route. enterRoutes are ordered
 * from the top of the tree we're entering down to the leaf route.
 *
 * changeRoutes are any routes that didn't leave or enter during
 * the transition.
 */
function computeChangedRoutes(prevState, nextState) {
  var prevRoutes = prevState && prevState.routes;
  var nextRoutes = nextState.routes;

  var leaveRoutes = void 0,
      changeRoutes = void 0,
      enterRoutes = void 0;
  if (prevRoutes) {
    var parentIsLeaving = false;
    leaveRoutes = prevRoutes.filter(function (route) {
      if (parentIsLeaving) {
        return true;
      } else {
        var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
        if (isLeaving) parentIsLeaving = true;
        return isLeaving;
      }
    });

    // onLeave hooks start at the leaf route.
    leaveRoutes.reverse();

    enterRoutes = [];
    changeRoutes = [];

    nextRoutes.forEach(function (route) {
      var isNew = prevRoutes.indexOf(route) === -1;
      var paramsChanged = leaveRoutes.indexOf(route) !== -1;

      if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
    });
  } else {
    leaveRoutes = [];
    changeRoutes = [];
    enterRoutes = nextRoutes;
  }

  return {
    leaveRoutes: leaveRoutes,
    changeRoutes: changeRoutes,
    enterRoutes: enterRoutes
  };
}

/* harmony default export */ __webpack_exports__["a"] = (computeChangedRoutes);

/***/ }),
/* 1151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PromiseUtils__ = __webpack_require__(522);



function getComponentsForRoute(nextState, route, callback) {
  if (route.component || route.components) {
    callback(null, route.component || route.components);
    return;
  }

  var getComponent = route.getComponent || route.getComponents;
  if (getComponent) {
    var componentReturn = getComponent.call(route, nextState, callback);
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(componentReturn)) componentReturn.then(function (component) {
      return callback(null, component);
    }, callback);
  } else {
    callback();
  }
}

/**
 * Asynchronously fetches all components needed for the given router
 * state and calls callback(error, components) when finished.
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getComponents method.
 */
function getComponents(nextState, callback) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["a" /* mapAsync */])(nextState.routes, function (route, index, callback) {
    getComponentsForRoute(nextState, route, callback);
  }, callback);
}

/* harmony default export */ __webpack_exports__["a"] = (getComponents);

/***/ }),
/* 1152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(147);


/**
 * Extracts an object of params the given route cares about from
 * the given params object.
 */
function getRouteParams(route, params) {
  var routeParams = {};

  if (!route.path) return routeParams;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["a" /* getParamNames */])(route.path).forEach(function (p) {
    if (Object.prototype.hasOwnProperty.call(params, p)) {
      routeParams[p] = params[p];
    }
  });

  return routeParams;
}

/* harmony default export */ __webpack_exports__["a"] = (getRouteParams);

/***/ }),
/* 1153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createRouterHistory__ = __webpack_require__(526);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__createRouterHistory__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory___default.a));

/***/ }),
/* 1154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isActive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(147);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



function deepEqual(a, b) {
  if (a == b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return deepEqual(item, b[index]);
    });
  }

  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
    for (var p in a) {
      if (!Object.prototype.hasOwnProperty.call(a, p)) {
        continue;
      }

      if (a[p] === undefined) {
        if (b[p] !== undefined) {
          return false;
        }
      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
        return false;
      } else if (!deepEqual(a[p], b[p])) {
        return false;
      }
    }

    return true;
  }

  return String(a) === String(b);
}

/**
 * Returns true if the current pathname matches the supplied one, net of
 * leading and trailing slash normalization. This is sufficient for an
 * indexOnly route match.
 */
function pathIsActive(pathname, currentPathname) {
  // Normalize leading slash for consistency. Leading slash on pathname has
  // already been normalized in isActive. See caveat there.
  if (currentPathname.charAt(0) !== '/') {
    currentPathname = '/' + currentPathname;
  }

  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
  // `/foo` as active, but in this case, we would already have failed the
  // match.
  if (pathname.charAt(pathname.length - 1) !== '/') {
    pathname += '/';
  }
  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
    currentPathname += '/';
  }

  return currentPathname === pathname;
}

/**
 * Returns true if the given pathname matches the active routes and params.
 */
function routeIsActive(pathname, routes, params) {
  var remainingPathname = pathname,
      paramNames = [],
      paramValues = [];

  // for...of would work here but it's probably slower post-transpilation.
  for (var i = 0, len = routes.length; i < len; ++i) {
    var route = routes[i];
    var pattern = route.path || '';

    if (pattern.charAt(0) === '/') {
      remainingPathname = pathname;
      paramNames = [];
      paramValues = [];
    }

    if (remainingPathname !== null && pattern) {
      var matched = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["b" /* matchPattern */])(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }

      if (remainingPathname === '') {
        // We have an exact match on the route. Just check that all the params
        // match.
        // FIXME: This doesn't work on repeated params.
        return paramNames.every(function (paramName, index) {
          return String(paramValues[index]) === String(params[paramName]);
        });
      }
    }
  }

  return false;
}

/**
 * Returns true if all key/value pairs in the given query are
 * currently active.
 */
function queryIsActive(query, activeQuery) {
  if (activeQuery == null) return query == null;

  if (query == null) return true;

  return deepEqual(query, activeQuery);
}

/**
 * Returns true if a <Link> to the given pathname/query combination is
 * currently active.
 */
function isActive(_ref, indexOnly, currentLocation, routes, params) {
  var pathname = _ref.pathname,
      query = _ref.query;

  if (currentLocation == null) return false;

  // TODO: This is a bit ugly. It keeps around support for treating pathnames
  // without preceding slashes as absolute paths, but possibly also works
  // around the same quirks with basenames as in matchRoutes.
  if (pathname.charAt(0) !== '/') {
    pathname = '/' + pathname;
  }

  if (!pathIsActive(pathname, currentLocation.pathname)) {
    // The path check is necessary and sufficient for indexOnly, but otherwise
    // we still need to check the routes.
    if (indexOnly || !routeIsActive(pathname, routes, params)) {
      return false;
    }
  }

  return queryIsActive(query, currentLocation.query);
}

/***/ }),
/* 1155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RouterUtils__ = __webpack_require__(524);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









/**
 * A high-level API to be used for server-side rendering.
 *
 * This function matches a location to a set of routes and calls
 * callback(error, redirectLocation, renderProps) when finished.
 *
 * Note: You probably don't want to use this in a browser unless you're using
 * server-side rendering with async routes.
 */
function match(_ref, callback) {
  var history = _ref.history,
      routes = _ref.routes,
      location = _ref.location,
      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);

  !(history || location) ?  false ? invariant(false, 'match needs a history or a location') : __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false) : void 0;

  history = history ? history : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__["a" /* default */])(options);
  var transitionManager = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])(history, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(routes));

  if (location) {
    // Allow match({ location: '/the/path', ... })
    location = history.createLocation(location);
  } else {
    location = history.getCurrentLocation();
  }

  transitionManager.match(location, function (error, redirectLocation, nextState) {
    var renderProps = void 0;

    if (nextState) {
      var router = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__RouterUtils__["a" /* createRouterObject */])(history, transitionManager, nextState);
      renderProps = _extends({}, nextState, {
        router: router,
        matchContext: { transitionManager: transitionManager, router: router }
      });
    }

    callback(error, redirectLocation && history.createLocation(redirectLocation, __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__["REPLACE"]), renderProps);
  });
}

/* unused harmony default export */ var _unused_webpack_default_export = (match);

/***/ }),
/* 1156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = matchRoutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PromiseUtils__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PatternUtils__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routerWarning__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(108);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







function getChildRoutes(route, location, paramNames, paramValues, callback) {
  if (route.childRoutes) {
    return [null, route.childRoutes];
  }
  if (!route.getChildRoutes) {
    return [];
  }

  var sync = true,
      result = void 0;

  var partialNextState = {
    location: location,
    params: createParams(paramNames, paramValues)
  };

  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
    childRoutes = !error && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(childRoutes);
    if (sync) {
      result = [error, childRoutes];
      return;
    }

    callback(error, childRoutes);
  });

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
    return callback(null, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(childRoutes));
  }, callback);

  sync = false;
  return result; // Might be undefined.
}

function getIndexRoute(route, location, paramNames, paramValues, callback) {
  if (route.indexRoute) {
    callback(null, route.indexRoute);
  } else if (route.getIndexRoute) {
    var partialNextState = {
      location: location,
      params: createParams(paramNames, paramValues)
    };

    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
      callback(error, !error && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(indexRoute)[0]);
    });

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
      return callback(null, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["b" /* createRoutes */])(indexRoute)[0]);
    }, callback);
  } else if (route.childRoutes || route.getChildRoutes) {
    var onChildRoutes = function onChildRoutes(error, childRoutes) {
      if (error) {
        callback(error);
        return;
      }

      var pathless = childRoutes.filter(function (childRoute) {
        return !childRoute.path;
      });

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["b" /* loopAsync */])(pathless.length, function (index, next, done) {
        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
          if (error || indexRoute) {
            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
            done(error, routes);
          } else {
            next();
          }
        });
      }, function (err, routes) {
        callback(null, routes);
      });
    };

    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
    if (result) {
      onChildRoutes.apply(undefined, result);
    }
  } else {
    callback();
  }
}

function assignParams(params, paramNames, paramValues) {
  return paramNames.reduce(function (params, paramName, index) {
    var paramValue = paramValues && paramValues[index];

    if (Array.isArray(params[paramName])) {
      params[paramName].push(paramValue);
    } else if (paramName in params) {
      params[paramName] = [params[paramName], paramValue];
    } else {
      params[paramName] = paramValue;
    }

    return params;
  }, params);
}

function createParams(paramNames, paramValues) {
  return assignParams({}, paramNames, paramValues);
}

function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
  var pattern = route.path || '';

  if (pattern.charAt(0) === '/') {
    remainingPathname = location.pathname;
    paramNames = [];
    paramValues = [];
  }

  // Only try to match the path if the route actually has a pattern, and if
  // we're not just searching for potential nested absolute paths.
  if (remainingPathname !== null && pattern) {
    try {
      var matched = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__PatternUtils__["b" /* matchPattern */])(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }
    } catch (error) {
      callback(error);
    }

    // By assumption, pattern is non-empty here, which is the prerequisite for
    // actually terminating a match.
    if (remainingPathname === '') {
      var match = {
        routes: [route],
        params: createParams(paramNames, paramValues)
      };

      getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
        if (error) {
          callback(error);
        } else {
          if (Array.isArray(indexRoute)) {
            var _match$routes;

             false ? warning(indexRoute.every(function (route) {
              return !route.path;
            }), 'Index routes should not have paths') : void 0;
            (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
          } else if (indexRoute) {
             false ? warning(!indexRoute.path, 'Index routes should not have paths') : void 0;
            match.routes.push(indexRoute);
          }

          callback(null, match);
        }
      });

      return;
    }
  }

  if (remainingPathname != null || route.childRoutes) {
    // Either a) this route matched at least some of the path or b)
    // we don't have to load this route's children asynchronously. In
    // either case continue checking for matches in the subtree.
    var onChildRoutes = function onChildRoutes(error, childRoutes) {
      if (error) {
        callback(error);
      } else if (childRoutes) {
        // Check the child routes to see if any of them match.
        matchRoutes(childRoutes, location, function (error, match) {
          if (error) {
            callback(error);
          } else if (match) {
            // A child route matched! Augment the match and pass it up the stack.
            match.routes.unshift(route);
            callback(null, match);
          } else {
            callback();
          }
        }, remainingPathname, paramNames, paramValues);
      } else {
        callback();
      }
    };

    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
    if (result) {
      onChildRoutes.apply(undefined, result);
    }
  } else {
    callback();
  }
}

/**
 * Asynchronously matches the given location to a set of routes and calls
 * callback(error, state) when finished. The state object will have the
 * following properties:
 *
 * - routes       An array of routes that matched, in hierarchical order
 * - params       An object of URL parameters
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getChildRoutes method.
 */
function matchRoutes(routes, location, callback, remainingPathname) {
  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];

  if (remainingPathname === undefined) {
    // TODO: This is a little bit ugly, but it works around a quirk in history
    // that strips the leading slash from pathnames when using basenames with
    // trailing slashes.
    if (location.pathname.charAt(0) !== '/') {
      location = _extends({}, location, {
        pathname: '/' + location.pathname
      });
    }
    remainingPathname = location.pathname;
  }

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["b" /* loopAsync */])(routes.length, function (index, next, done) {
    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
      if (error || match) {
        done(error, match);
      } else {
        next();
      }
    });
  }, callback);
}

/***/ }),
/* 1157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withRouter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContextUtils__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PropTypes__ = __webpack_require__(346);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function withRouter(WrappedComponent, options) {
  var withRef = options && options.withRef;

  var WithRouter = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
    displayName: 'WithRouter',

    mixins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__ContextUtils__["b" /* ContextSubscriber */])('router')],

    contextTypes: { router: __WEBPACK_IMPORTED_MODULE_5__PropTypes__["a" /* routerShape */] },
    propTypes: { router: __WEBPACK_IMPORTED_MODULE_5__PropTypes__["a" /* routerShape */] },

    getWrappedInstance: function getWrappedInstance() {
      !withRef ?  false ? invariant(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      return this.wrappedInstance;
    },
    render: function render() {
      var _this = this;

      var router = this.props.router || this.context.router;
      if (!router) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, this.props);
      }

      var params = router.params,
          location = router.location,
          routes = router.routes;

      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });

      if (withRef) {
        props.ref = function (c) {
          _this.wrappedInstance = c;
        };
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, props);
    }
  });

  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
  WithRouter.WrappedComponent = WrappedComponent;

  return __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default()(WithRouter, WrappedComponent);
}

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = reduceReducers;

function reduceReducers() {
  for (var _len = arguments.length, reducers = Array(_len), _key = 0; _key < _len; _key++) {
    reducers[_key] = arguments[_key];
  }

  return function (previous, current) {
    return reducers.reduce(function (p, r) {
      return r(p, current);
    }, previous);
  };
}

module.exports = exports["default"];

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = createActions;

var _identity = __webpack_require__(130);

var _identity2 = _interopRequireDefault(_identity);

var _camelCase = __webpack_require__(1095);

var _camelCase2 = _interopRequireDefault(_camelCase);

var _isPlainObject = __webpack_require__(247);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _isArray = __webpack_require__(40);

var _isArray2 = _interopRequireDefault(_isArray);

var _reduce = __webpack_require__(508);

var _reduce2 = _interopRequireDefault(_reduce);

var _isString = __webpack_require__(248);

var _isString2 = _interopRequireDefault(_isString);

var _isFunction = __webpack_require__(107);

var _isFunction2 = _interopRequireDefault(_isFunction);

var _createAction = __webpack_require__(530);

var _createAction2 = _interopRequireDefault(_createAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createActions(actionsMap) {
  for (var _len = arguments.length, identityActions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    identityActions[_key - 1] = arguments[_key];
  }

  if (identityActions.every(_isString2.default)) {
    if ((0, _isString2.default)(actionsMap)) {
      return fromIdentityActions([actionsMap].concat(identityActions));
    } else if ((0, _isPlainObject2.default)(actionsMap)) {
      return _extends({}, fromActionsMap(actionsMap), fromIdentityActions(identityActions));
    }
  }

  throw new TypeError('Expected optional object followed by string action types');
}

function isValidActionsMapValue(actionsMapValue) {
  if ((0, _isFunction2.default)(actionsMapValue)) {
    return true;
  } else if ((0, _isArray2.default)(actionsMapValue)) {
    var _actionsMapValue = _slicedToArray(actionsMapValue, 2);

    var _actionsMapValue$ = _actionsMapValue[0];
    var payload = _actionsMapValue$ === undefined ? _identity2.default : _actionsMapValue$;
    var meta = _actionsMapValue[1];


    return (0, _isFunction2.default)(payload) && (0, _isFunction2.default)(meta);
  }
  return false;
}

function fromActionsMap(actionsMap) {
  return (0, _reduce2.default)(actionsMap, function (actionCreatorsMap, actionsMapValue, type) {
    if (!isValidActionsMapValue(actionsMapValue)) {
      throw new TypeError('Expected function, undefined, or array with payload and meta ' + ('functions for ' + type));
    }

    var actionCreator = (0, _isArray2.default)(actionsMapValue) ? _createAction2.default.apply(undefined, [type].concat(_toConsumableArray(actionsMapValue))) : (0, _createAction2.default)(type, actionsMapValue);

    return _extends({}, actionCreatorsMap, _defineProperty({}, (0, _camelCase2.default)(type), actionCreator));
  }, {});
}

function fromIdentityActions(identityActions) {
  return fromActionsMap(identityActions.reduce(function (actionsMap, actionType) {
    return _extends({}, actionsMap, _defineProperty({}, actionType, _identity2.default));
  }, {}));
}

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = handleActions;

var _handleAction = __webpack_require__(531);

var _handleAction2 = _interopRequireDefault(_handleAction);

var _ownKeys = __webpack_require__(1161);

var _ownKeys2 = _interopRequireDefault(_ownKeys);

var _reduceReducers = __webpack_require__(1158);

var _reduceReducers2 = _interopRequireDefault(_reduceReducers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function handleActions(handlers, defaultState) {
  var reducers = (0, _ownKeys2.default)(handlers).map(function (type) {
    return (0, _handleAction2.default)(type, handlers[type]);
  });
  var reducer = _reduceReducers2.default.apply(undefined, _toConsumableArray(reducers));

  return function () {
    var state = arguments.length <= 0 || arguments[0] === undefined ? defaultState : arguments[0];
    var action = arguments[1];
    return reducer(state, action);
  };
}

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ownKeys;
function ownKeys(object) {
  if (typeof Reflect !== 'undefined' && typeof Reflect.ownKeys === 'function') {
    return Reflect.ownKeys(object);
  }

  var keys = Object.getOwnPropertyNames(object);

  if (typeof Object.getOwnPropertySymbols === 'function') {
    keys = keys.concat(Object.getOwnPropertySymbols(object));
  }

  return keys;
}

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

exports['default'] = thunk;

/***/ }),
/* 1163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(532);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 1164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(348);


function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    } else {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('bindActionCreators expected a function actionCreator for key \'' + key + '\', instead received type \'' + typeof actionCreator + '\'.');
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 1165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(348);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19), __webpack_require__(511)))

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 1169 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(959);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./button.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./button.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(960);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./icon.styl", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./icon.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(961);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./icon.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./icon.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(962);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./popout.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./popout.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(963);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./resized-image.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./resized-image.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(965);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./with-tooltip.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./with-tooltip.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(967);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--3-1!../../../../node_modules/postcss-loader/index.js??ref--3-2!./fontello-codes.css", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--3-1!../../../../node_modules/postcss-loader/index.js??ref--3-2!./fontello-codes.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ponyfill = __webpack_require__(1178);

var _ponyfill2 = _interopRequireDefault(_ponyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var root; /* global window */


if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = (0, _ponyfill2['default'])(root);
exports['default'] = result;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19), __webpack_require__(181)(module)))

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports['default'] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var _Symbol = root.Symbol;

	if (typeof _Symbol === 'function') {
		if (_Symbol.observable) {
			result = _Symbol.observable;
		} else {
			result = _Symbol('observable');
			_Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "6ca0253cd9b16fcb5dcf9e7f7ca6c1ef.woff";

/***/ }),
/* 1180 */
/***/ (function(module, exports) {

module.exports = "data:application/font-woff;base64,d09GRgABAAAAAAWEAA0AAAAAB8QAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAABGRlRNAAABMAAAABsAAAAcdNCgdkdERUYAAAFMAAAAHgAAAB4AKQAKT1MvMgAAAWwAAABLAAAAYGOhh9VjbWFwAAABuAAAAD4AAAFCAA8kaGdhc3AAAAH4AAAACAAAAAj//wADZ2x5ZgAAAgAAAAEQAAABEO+zGgBoZWFkAAADEAAAADAAAAA2B2rQ/2hoZWEAAANAAAAAHgAAACQMFwN1aG10eAAAA2AAAAAQAAAAEAu8AP5sb2NhAAADcAAAAAoAAAAKAN4ArG1heHAAAAN8AAAAEwAAACAACQA5bmFtZQAAA5AAAAHQAAADJPuntGJwb3N0AAAFYAAAACMAAAAysEc6PXicY2BgYGQAgou57W1gemO3EoTuPQsASkkHWAAAAQAAAAwAAAAWAAAAAgABAAMAAwABAAQAAAACAAAAAHicY2BmFWKcwMDKwME6i9WYgYFRGkIzX2RIYxJiYGACSmEHHj4KCgwMCnsV9rLO+pfGcJZtC+MioDAjSI6FgXUWkFJgYAQA6PwLWAB4nGNgYGBmgGAZBkYGELAB8hjBfBYGBSDNAoRAvsLe//8h5H03qEoGRjYGGJOBkQlIMDGgAkaGYQ8AMWgHlwAAAAAAAf//AAIABABkAAADnAWaAAMABwAkADgAADMRIRElIREhFzY3NjMyFhUUBgcOARUUFyMmNTQSNTQmIyIHBgcTNzYzMh8BFhUUDwEGIyIvASY1NGQDOPz6AtT9LK8fGzU7XHAuQD9IGCAjo0I6Jh8aHkA5CwkKDDgJCjgOBwsJPQcFmvpmMgU27BwPHl9QMWNQUGgvJl9hM0wBHEs5QhEPGfz/OgoLPAsJCws+DgpHCQkKAAIAmgAABIMFnAAWAB8AAAEjNTM1IzUzESEyFxYVECEjFSEVIREjEzMgETQnJisBASGHh4eHAdGsanv9cxcCe/2Fvr5CAZdSRGTfARmRj5IC0VVhv/4UkZH+5wLLAUx8QjcAAHicY2BkYGAA4vaTgmnx/DZfGbg5GEDg4qbDxnA6hYGBpZl1DpDLwcAEEgUAI14KBHicY2BkYGDb8i+O4R6rEAMQsDQzMDKgAhYAYwkDmQAABAAAZAAAAAACqgAABRIAmgAAAFYAVgBWAIgAAHicY2BkYGBgYbAEYqwAAAaYAEMAeJx1kc1q20AUhY8cxU1TKO0LlEtWCXWEbGoI2ZQQCCFkZYz3E2UkT5E1ZkZK8Kav0HU37TqbPkKXfZg+Qxc9Gg9pIFRCM99c3Z8z9wJ4g19IsH0+4FPkBCkeIg/wAj8j7+AtfkdOkSbDyLt4nxSRh7R/jbyPj4N3jErSlzwtQ4aeE+zhe+QBXuNH5B0cUM+WU/r8ibyLRfIq8hB7yZfI+/icfMMcG6yhUUKh4C7ULjik1aKDIxekFX0UGlqPkNE2QY4xpoHPUPMVzGBQUWcLH06au2aGO663wHyz1qUqtDzI4cZ2Tgq7Wqtmc5TJJB9PMzmra5mZatl6mWmv3Z1mlKOIG5aD62649lkrmmqqcTzqqquV++d2ikWo6anFUq9QZUat+TbB6UI7b2wj4yzPnyX/X6jgio5NaM6Elx49aUDPhv8Mr20oqm+Eo2fNT4UG4GlNueoaLZPpKNx5JKYxrVG1OF1r5fUzSXP204R+lkFUS7oPifu5uFCkDf0VBvogpSJfRO/zRx8bZnkSrtRnc2Gqgss4tWNc01LxVNBnO3PMl8ZLaZtW7pWXwmnV6lvpvGkquaD5vLdYJydZLqWzK7nk/I6vbWWKjOPFX5G/kEF4nGNgYgCDfxMZpjFgAyxAzMjAxMjEXpqXaWTg5AIAYwIEbQA="

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _biLoggerFactory = __webpack_require__(1183);

var _biLoggerFactory2 = _interopRequireDefault(_biLoggerFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cacheKillerCounter = 0;

function addParam(url, key, value) {
  var separator = url.indexOf('?') === -1 ? '?' : '&';
  return '' + url + separator + encodeURIComponent(key) + '=' + encodeURIComponent(value);
}

function buildUrl(host, endpoint, params) {
  params._ = '' + new Date().getTime() + cacheKillerCounter++;

  var prefix = '//' + host + '/' + endpoint;
  return Object.keys(params).reduce(function (url, key) {
    return addParam(url, key, params[key]);
  }, prefix);
}

function browserLogger(opts) {
  var options = opts || {};
  return function (params, context) {
    return new Promise(function (resolve, reject) {
      var biImage = context && context.image || new Image(0, 0);
      biImage.onload = resolve;
      biImage.onerror = reject;
      biImage.src = buildUrl(options.host || 'frog.wix.com', options.endpoint || '', params);
    });
  };
}

exports.default = { factory: function factory(x) {
    return new _biLoggerFactory2.default().addPublisher(browserLogger(x));
  } };
//# sourceMappingURL=logger.js.map


/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(1167);
exports.setImmediate = setImmediate;
exports.clearImmediate = clearImmediate;


/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var assert = __webpack_require__(534);
var BiLogger = __webpack_require__(1184);

var BiLoggerFactory = function () {
  function BiLoggerFactory() {
    _classCallCheck(this, BiLoggerFactory);

    this._publishers = [];
    this._validators = [];
    this._defaults = {};
    this._events = {};
  }

  _createClass(BiLoggerFactory, [{
    key: 'addPublisher',
    value: function addPublisher(publisher) {
      assert.defined(publisher, 'Publisher must be provided');
      assert.ok(typeof publisher === 'function', 'Expected a publisher function');
      this._publishers.push(publisher);
      return this;
    }
  }, {
    key: 'addValidator',
    value: function addValidator(validator) {
      assert.defined(validator, 'Validator must be provided');
      assert.ok((typeof validator === 'undefined' ? 'undefined' : _typeof(validator)) === 'object' && validator, 'Expected a validator object');
      assert.ok(validator.execute && validator.match, 'Provided validator does not match the interface');
      this._validators.push(validator);
      return this;
    }
  }, {
    key: 'setDefaults',
    value: function setDefaults(defaults) {
      assert.defined(defaults, 'Defaults must be provided');
      assert.object(defaults, 'Defaults must be an object');
      this._defaults = defaults;
      return this;
    }
  }, {
    key: 'updateDefaults',
    value: function updateDefaults(defaults) {
      assert.defined(defaults, 'Defaults must be provided');
      assert.object(defaults, 'Defaults must be an object');
      Object.assign(this._defaults, defaults);
      return this;
    }
  }, {
    key: 'setEvents',
    value: function setEvents(events) {
      assert.defined(events, 'Events must be provided');
      assert.object(events, 'Events must be an object');
      this._events = events;
      return this;
    }
  }, {
    key: 'setDefaultValueTimeout',
    value: function setDefaultValueTimeout(defaultValueTimeout) {
      assert.defined(defaultValueTimeout, 'Default Value Timeout must be provided');
      this._defaultValueTimeout = defaultValueTimeout;
      return this;
    }
  }, {
    key: 'setDefaultContinueOnFail',
    value: function setDefaultContinueOnFail(defaultContinueOnFail) {
      assert.defined(defaultContinueOnFail, 'Default Continue On Fail must be provided');
      this._defaultContinueOnFail = defaultContinueOnFail;
      return this;
    }
  }, {
    key: 'logger',
    value: function logger(context) {
      return new BiLogger({
        publishers: this._publishers,
        validators: this._validators,
        defaults: this._defaults,
        events: this._events,
        defaultValueTimeout: this._defaultValueTimeout,
        defaultContinueOnFail: this._defaultContinueOnFail
      }, context);
    }
  }]);

  return BiLoggerFactory;
}();

module.exports = BiLoggerFactory;
//# sourceMappingURL=bi-logger-factory.js.map

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var assert = __webpack_require__(534);

var _require = __webpack_require__(1185),
    mapValues = _require.mapValues;

var promise = __webpack_require__(1187);

var _require2 = __webpack_require__(1186),
    log = _require2.log;

var BiLogger = function () {
  //TODO: validate args
  function BiLogger(options, context) {
    _classCallCheck(this, BiLogger);

    this._publishers = options.publishers;
    this._validators = options.validators || [];
    this._defaults = options.defaults;
    this._events = options.events || {};
    this._context = context;
    this._defaultValueTimeout = options.defaultValueTimeout || 5000;
    this._defaultContinueOnFail = options.defaultContinueOnFail || false;
  }

  _createClass(BiLogger, [{
    key: 'log',
    value: function log(eventOrKey, eventOrUndefined) {
      var _this = this;

      assert.defined(eventOrKey, 'Event object or event key must be provided.');
      var event = this._eventOrExtractFromEvents(eventOrKey, eventOrUndefined);

      var validatorsResult = this._validators.length === 0 ? true : this._validators.some(function (validator) {
        return validator.match(event) && (validator.execute(event) || true);
      });

      if (!validatorsResult) {
        throw new Error('No validator accepted the event');
      }

      return this._getDefaults().then(function (defaults) {
        return Promise.all(_this._publishers.map(function (publish) {
          var cloned = Object.assign({}, defaults, event);

          return Promise.resolve().then(function () {
            return publish(cloned, _this._context);
          }).catch(function (error) {
            if (error && error.message && error.stack) {
              error.message = 'Publisher \'' + publish.name + '\' failed with error: \'' + error.message + '\'';
            }

            return Promise.reject(error);
          });
        }));
      });
    }
  }, {
    key: '_eventOrExtractFromEvents',
    value: function _eventOrExtractFromEvents(eventOrKey, eventOrUndefined) {
      if (typeof eventOrKey !== 'string') {
        return eventOrKey;
      }
      var event = this._events[eventOrKey];
      if (!event) {
        throw new assert.AssertionError('Event with key \'' + eventOrKey + '\' not found in event map.');
      }

      if (eventOrUndefined) {
        return Object.assign({}, event, eventOrUndefined);
      } else {
        return event;
      }
    }
  }, {
    key: '_getDefaults',
    value: function _getDefaults() {
      var _this2 = this;

      if (!this._defaults) {
        return Promise.resolve({});
      }

      var promises = mapValues(this._defaults, function (value, key) {
        if (value && typeof value.then !== 'function') {
          return value;
        }
        return promise.timedPromise(value, {
          message: 'Cannot get default value \'' + key + ' for BI Event\'',
          timeout: _this2._defaultValueTimeout
        }).catch(function (err) {
          if (_this2._defaultContinueOnFail) {
            log.error(err);
            return null;
          }
          return Promise.reject(err);
        });
      });

      return promise.allAsObject(promises);
    }
  }]);

  return BiLogger;
}();

module.exports = BiLogger;
//# sourceMappingURL=bi-logger.js.map

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * This callback type is called `requestCallback` and is displayed as a global symbol.
 *
 * @callback iterateeCallback
 * @param {*} Value
 * @param {string} Key
 * @param {object} Original object
 */
/**
 * Iterates over object values
 * @param {Object} collection
 * @param {iterateeCallback} iteratee
 * @return {Object} iterated object
 */
module.exports.mapValues = function (collection, iteratee) {
  if (!collection) {
    return {};
  }
  return Object.keys(collection).reduce(function (acc, key) {
    acc[key] = iteratee(collection[key], key, collection);
    return acc;
  }, {});
};
//# sourceMappingURL=collections.js.map

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports.log = {
  error: function error() {
    if (console && console.error) {
      var _console;

      (_console = console).error.apply(_console, arguments);
    }
  }
};
//# sourceMappingURL=log.js.map

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * rejects original promise after specified timeout
 * @param {Promise<R>} promise Original promise
 * @param {string} [message] Additional message for timeout reject
 * @param {number} timeout Time for reject
 * @return {Promise<R>}
 */
module.exports.timedPromise = function (promise, _ref) {
  var message = _ref.message,
      timeout = _ref.timeout;

  var timeoutPromise = new Promise(function (resolve, reject) {
    setTimeout(reject, timeout, message ? 'Timeout: ' + message : 'Timeout');
  });
  return Promise.race([promise, timeoutPromise]);
};

/**
 * Works like Promise.all expect uses object insetead of array.
 * @param {Object} promiseObject
 * @return {Promise} Promise wiht original keys and resolved values
 */
module.exports.allAsObject = function (promiseObject) {
  var keys = Object.keys(promiseObject);
  return Promise.all(keys.map(function (key) {
    return promiseObject[key];
  })).then(function (resolved) {
    return resolved.reduce(function (acc, value, i) {
      acc[keys[i]] = value;
      return acc;
    }, {});
  });
};
//# sourceMappingURL=promise.js.map

/***/ }),
/* 1188 */
/***/ (function(module, exports) {

module.exports = {
	"shared": {
		"vod-settings": {
			"get": {
				"name": "shared.vod-settings.get",
				"service": "catalog",
				"id": 1010
			},
			"update": {
				"name": "shared.vod-settings.update",
				"service": "catalog",
				"id": 1011
			}
		},
		"channel": {
			"get": {
				"id": 1012,
				"name": "shared.channel.get",
				"service": "catalog"
			},
			"update": {
				"id": 1013,
				"name": "shared.channel.update",
				"service": "catalog"
			},
			"video": {
				"get": {
					"id": 1014,
					"name": "shared.channel.video.get",
					"service": "catalog"
				}
			},
			"payment": {
				"get": {
					"id": 1016,
					"name": "shared.channel.payment.get",
					"service": "catalog"
				}
			},
			"videos": {
				"list": {
					"id": 1017,
					"name": "shared.channel.videos.list",
					"service": "catalog"
				}
			}
		},
		"channels": {
			"list": {
				"id": 1018,
				"name": "shared.channels.list",
				"service": "catalog"
			},
			"search": {
				"id": 1019,
				"name": "shared.channels.search",
				"service": "catalog"
			}
		},
		"payments": {
			"paypal": {
				"get": {
					"id": 2019,
					"name": "shared.payments.paypal.get",
					"service": "dgs"
				},
				"disconnect": {
					"id": 2020,
					"name": "shared.payments.paypal.disconnect",
					"service": "dgs"
				}
			}
		},
		"premium-info": {
			"get": {
				"id": 3021,
				"name": "shared.premium-info.get",
				"service": "billing"
			}
		},
		"general": {
			"unhandled-exception": {
				"id": 4000,
				"name": "unhandled-exception",
				"service": "unknown"
			}
		},
		"experiments": {
			"get": {
				"id": 1018,
				"name": "shared.experiments.get",
				"service": "catalog"
			}
		}
	},
	"widget": {
		"stats": {
			"report": {
				"id": 14011,
				"name": "widget.stats.report",
				"service": "counters"
			}
		}
	},
	"dashboard": {
		"channel": {
			"remove": {
				"id": 31010,
				"name": "dashboard.channel.remove",
				"service": "catalog"
			},
			"video": {
				"update": {
					"id": 31011,
					"name": "dashboard.channel.video.update",
					"service": "catalog"
				}
			},
			"videos": {
				"add": {
					"id": 31012,
					"name": "dashboard.channel.videos.add",
					"service": "catalog"
				},
				"move": {
					"id": 31013,
					"name": "dashboard.channel.videos.move",
					"service": "catalog"
				},
				"remove": {
					"id": 31014,
					"name": "dashboard.channel.videos.remove",
					"service": "catalog"
				}
			}
		},
		"file": {
			"upload": {
				"id": 35015,
				"name": "dashboard.file.upload",
				"service": "files"
			}
		},
		"stats": {
			"overview": {
				"top_videos": {
					"get": {
						"id": 34016,
						"name": "dashboard.stats.overview.top_videos.get",
						"service": "counters"
					}
				}
			}
		},
		"video": {
			"get": {
				"id": 31017,
				"name": "dashboard.video.get",
				"service": "catalog"
			},
			"update": {
				"id": 31018,
				"name": "dashboard.video.update",
				"service": "catalog"
			},
			"upload": {
				"id": 31022,
				"name": "dashboard.video.upload",
				"service": "catalog"
			},
			"reupload": {
				"id": 31023,
				"name": "dashboard.video.reupload",
				"service": "catalog"
			}
		},
		"videos": {
			"list": {
				"id": 31019,
				"name": "dashboard.videos.list",
				"service": "catalog"
			},
			"search": {
				"id": 31020,
				"name": "dashboard.videos.search",
				"service": "catalog"
			},
			"update": {
				"id": 31021,
				"name": "dashboard.videos.update",
				"service": "catalog"
			},
			"remove": {
				"id": 31024,
				"name": "dashboard.videos.remove",
				"service": "catalog"
			}
		},
		"autocomplete": {
			"get": {
				"id": 32001,
				"name": "dashboard.autocomplete.get",
				"service": "catalog"
			}
		}
	}
};

/***/ }),
/* 1189 */
/***/ (function(module, exports) {

module.exports = {
	"upgrade": {
		"button": {
			"click": {
				"id": 2,
				"name": "upgrade.button.click",
				"fields": {
					"videoInstanceID": "guid",
					"biToken": "guid",
					"origin": "string",
					"compId": "string"
				}
			}
		}
	},
	"appSet": {
		"chooseChannel": {
			"changed": {
				"id": 3,
				"name": "appSet.chooseChannel.changed",
				"fields": {
					"channelID": "string",
					"channelType": {
						"values": [
							"channel",
							"youtube-feed"
						]
					},
					"videoInstanceID": "guid",
					"isFirst": "bool",
					"biToken": "guid",
					"compId": "string"
				}
			}
		},
		"main": {
			"newChannel": {
				"clicked": {
					"id": 4,
					"name": "appSet.main.newChannel.clicked",
					"fields": {
						"videoInstanceID": "guid",
						"isFirst": "bool",
						"biToken": "guid",
						"compId": "string"
					}
				}
			},
			"manageVideos": {
				"clicked": {
					"id": 5,
					"name": "appSet.main.manageVideos.clicked",
					"fields": {
						"videoInstanceID": "guid",
						"isFirst": "bool",
						"biToken": "guid",
						"compId": "string"
					}
				}
			}
		},
		"layout": {
			"layoutChanged": {
				"id": 6,
				"name": "appSet.layout.layoutChanged",
				"fields": {
					"videoInstanceID": "guid",
					"biToken": "guid",
					"compId": "string",
					"selection": {
						"values": [
							"classic",
							"strip"
						]
					}
				}
			},
			"layoutWidth": {
				"changed": {
					"id": 7,
					"name": "appSet.layout.layoutWidth.changed",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"compId": "string",
						"selection": {
							"values": [
								"full_width",
								"page_width"
							]
						}
					}
				}
			},
			"actionBar": {
				"showVideoListType": {
					"changed": {
						"id": 174,
						"name": "appSet.layout.actionBar.showVideoListType.changed",
						"fields": {
							"selection": {
								"values": [
									"when_clicked",
									"never",
									"always"
								]
							},
							"layoutType": "string",
							"origin": "string",
							"videoInstanceID": "guid",
							"biToken": "guid",
							"compId": "string"
						}
					}
				},
				"showActionBar": {
					"changed": {
						"id": 173,
						"name": "appSet.layout.actionBar.showActionBar.changed",
						"fields": {
							"toggle": "bool",
							"layoutType": "string",
							"origin": "string",
							"videoInstanceID": "guid",
							"biToken": "guid",
							"compId": "string"
						}
					}
				}
			},
			"videoList": {
				"showVideoTitles": {
					"changed": {
						"id": 175,
						"name": "appSet.layout.videoList.showVideoTitles.changed",
						"fields": {
							"selection": {
								"values": [
									"on_hover",
									"always",
									"never"
								]
							},
							"layoutType": "string",
							"origin": "string",
							"videoInstanceID": "guid",
							"biToken": "guid",
							"compId": "string"
						}
					}
				}
			}
		},
		"design": {
			"mainItem": {
				"showMainActionsAs": {
					"changed": {
						"id": 176,
						"name": "appSet.design.mainItem.showMainActionsAs.changed",
						"fields": {
							"layoutType": "string",
							"selection": {
								"values": [
									"text",
									"icon_buttons"
								]
							},
							"origin": "string",
							"videoInstanceID": "guid",
							"biToken": "guid",
							"compId": "string"
						}
					}
				}
			}
		},
		"settings": {
			"channelOptions": {
				"share": {
					"changed": {
						"id": 8,
						"name": "appSet.settings.channelOptions.share.changed",
						"fields": {
							"videoInstanceID": "guid",
							"isShare": "bool",
							"biToken": "guid",
							"compId": "string"
						}
					}
				},
				"ShowVideoList": {
					"changed": {
						"id": 9,
						"name": "appSet.settings.channelOptions.ShowVideoList.changed",
						"fields": {
							"videoInstanceID": "guid",
							"isShowVideoList": "bool",
							"biToken": "guid",
							"compId": "string"
						}
					}
				},
				"showCategories": {
					"changed": {
						"id": 11,
						"name": "appSet.settings.channelOptions.showCategories.changed",
						"fields": {
							"videoInstanceID": "guid",
							"isCategories": "bool",
							"biToken": "guid",
							"compId": "string"
						}
					}
				},
				"tags": {
					"changed": {
						"id": 12,
						"name": "appSet.settings.channelOptions.tags.changed",
						"fields": {
							"videoInstanceID": "guid",
							"isTags": "bool",
							"biToken": "guid",
							"compId": "string"
						}
					}
				}
			},
			"shareVids": {
				"changed": {
					"id": 13,
					"name": "appSet.settings.shareVids.changed",
					"fields": {
						"videoInstanceID": "guid",
						"isShareVids": "bool",
						"biToken": "guid",
						"compId": "string"
					}
				}
			},
			"showInfo": {
				"changed": {
					"id": 14,
					"name": "appSet.settings.showInfo.changed",
					"fields": {
						"videoInstanceID": "guid",
						"isShowInfo": "bool",
						"biToken": "guid",
						"compId": "string"
					}
				}
			},
			"mainItemType": {
				"changed": {
					"id": 170,
					"name": "appSet.settings.mainItemType.changed",
					"fields": {
						"selection": {
							"values": [
								"channel_cover",
								"featured_video"
							]
						},
						"layoutType": "string",
						"origin": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"compId": "string"
					}
				}
			},
			"mainItem": {
				"showTitleForMainItem": {
					"changed": {
						"id": 171,
						"name": "appSet.settings.mainItem.showTitleForMainItem.changed",
						"fields": {
							"toggle": "bool",
							"layoutType": "string",
							"origin": "string",
							"videoInstanceID": "guid",
							"biToken": "guid",
							"compId": "string"
						}
					}
				}
			},
			"playType": {
				"changed": {
					"id": 172,
					"name": "appSet.settings.playType.changed",
					"fields": {
						"selection": {
							"values": [
								"in_frame",
								"expanded_view"
							]
						},
						"layoutType": "string",
						"origin": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"compId": "string"
					}
				}
			}
		},
		"Upgrade": {
			"clicked": {
				"id": 15,
				"name": "appSet.Upgrade.clicked",
				"fields": {
					"videoInstanceID": "guid",
					"isFirst": "bool",
					"biToken": "guid",
					"compId": "string"
				}
			}
		},
		"ResetDesign": {
			"clicked": {
				"id": 16,
				"name": "appSet.ResetDesign.clicked",
				"fields": {
					"videoInstanceID": "guid",
					"isFirst": "bool",
					"biToken": "guid",
					"compId": "string"
				}
			}
		},
		"welcomeScreen": {
			"clicked": {
				"id": 17,
				"name": "appSet.welcomeScreen.clicked",
				"fields": {
					"videoInstanceID": "guid",
					"biToken": "guid",
					"origin": "string",
					"compId": "string",
					"selection": {
						"values": [
							"DesignMyChannel",
							"StartNow"
						]
					}
				}
			}
		},
		"tab": {
			"clicked": {
				"id": 18,
				"name": "appSet.tab.clicked",
				"fields": {
					"videoInstanceID": "guid",
					"biToken": "guid",
					"compId": "string",
					"newTabName": {
						"values": [
							"main",
							"channel",
							"settings",
							"layout",
							"design"
						]
					}
				}
			}
		},
		"loaded": {
			"id": 99,
			"name": "appSet.loaded",
			"fields": {
				"videoInstanceID": "guid",
				"biToken": "guid",
				"compId": "string"
			}
		},
		"opened": {
			"id": 100,
			"name": "appSet.opened",
			"fields": {
				"videoInstanceID": "guid",
				"isFirst": "bool",
				"loading_time": "numeric",
				"biToken": "guid",
				"origin": "string",
				"compId": "string"
			}
		},
		"PayPalState": {
			"id": 101,
			"name": "appSet.PayPalState",
			"fields": {
				"videoInstanceID": "guid",
				"biToken": "guid",
				"compId": "string"
			}
		}
	},
	"bo": {
		"stats": {
			"topVidsList": {
				"sorting": {
					"changed": {
						"id": 19,
						"name": "bo.stats.topVidsList.sorting.changed",
						"fields": {
							"videoInstanceID": "guid",
							"biToken": "guid",
							"compId": "string",
							"sortingParameter": {
								"values": [
									"Views",
									"Sales (units)"
								]
							}
						}
					}
				}
			},
			"timeframe": {
				"changed": {
					"id": 20,
					"name": "bo.stats.timeframe.changed",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"compId": "string",
						"tabName": {
							"values": [
								"QuickStats",
								"Channels",
								"Videos"
							]
						},
						"timeFrame": {
							"values": [
								"All time",
								"Last year",
								"Last month",
								"Last week",
								"Today (hours)"
							]
						}
					}
				}
			},
			"channels": {
				"chStats": {
					"clicked": {
						"id": 21,
						"name": "bo.stats.channels.chStats.clicked",
						"fields": {
							"channelID": "string",
							"videoInstanceID": "guid",
							"biToken": "guid",
							"compId": "string"
						}
					}
				}
			},
			"videos": {
				"chStats": {
					"clicked": {
						"id": 22,
						"name": "bo.stats.videos.chStats.clicked",
						"fields": {
							"videoInstanceID": "guid",
							"biToken": "guid",
							"compId": "string",
							"videoID": "string"
						}
					}
				}
			},
			"exportCSV": {
				"clicked": {
					"id": 23,
					"name": "bo.stats.exportCSV.clicked",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"compId": "string",
						"tabName": {
							"values": [
								"Channels",
								"Videos"
							]
						}
					}
				}
			},
			"graph": {
				"tab": {
					"clicked": {
						"id": 24,
						"name": "bo.stats.graph.tab.clicked",
						"fields": {
							"videoInstanceID": "guid",
							"biToken": "guid",
							"compId": "string",
							"newTabName": {
								"values": [
									"Views",
									"Shares",
									"Sales"
								]
							}
						}
					}
				}
			},
			"tab": {
				"clicked": {
					"id": 25,
					"name": "bo.stats.tab.clicked",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"compId": "string",
						"newTabName": {
							"values": [
								"QuickStats",
								"Channels",
								"Videos"
							]
						}
					}
				}
			},
			"nosStats": {
				"display": {
					"id": 95,
					"name": "bo.stats.nosStats.display",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"compId": "string"
					}
				}
			}
		},
		"settings": {
			"PayPalDisconnect": {
				"clicked": {
					"id": 26,
					"name": "bo.settings.PayPalDisconnect.clicked",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string"
					}
				},
				"Completed": {
					"id": 89,
					"name": "bo.settings.PayPalDisconnect.Completed",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string",
						"uuid": "guid"
					}
				}
			},
			"PayPalCreateAccount": {
				"clicked": {
					"id": 27,
					"name": "bo.settings.PayPalCreateAccount.clicked",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string"
					}
				}
			},
			"currency": {
				"changed": {
					"id": 28,
					"name": "bo.settings.currency.changed",
					"fields": {
						"currency": "string",
						"videoInstanceID": "guid",
						"isFirst": "bool",
						"biToken": "guid",
						"origin": "string",
						"compId": "string"
					}
				}
			},
			"defaultPrice": {
				"open": {
					"id": 29,
					"name": "bo.settings.defaultPrice.open",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string"
					}
				},
				"cancelButton": {
					"clicked": {
						"id": 30,
						"name": "bo.settings.defaultPrice.cancelButton.clicked",
						"fields": {
							"videoInstanceID": "guid",
							"biToken": "guid",
							"origin": "string",
							"compId": "string"
						}
					}
				},
				"saveButton": {
					"clicked": {
						"id": 31,
						"name": "bo.settings.defaultPrice.saveButton.clicked",
						"fields": {
							"videoInstanceID": "guid",
							"isPurchasable": "bool",
							"isRental": "bool",
							"biToken": "guid",
							"origin": "string",
							"compId": "string",
							"pricingSelection": {
								"values": [
									"free",
									"paid"
								]
							},
							"pricingSelectionChange": "bool",
							"purchasableChange": "bool",
							"purchasePricinig": "numeric",
							"purchasePricinigChange": "bool",
							"rentalChange": "bool",
							"rentalPeriod": {
								"values": [
									"24",
									"48",
									"72"
								]
							},
							"rentalPeriodChange": "bool",
							"rentalPricinig": "numeric",
							"rentalPricinigChange": "bool"
						}
					}
				},
				"saveCompleted": {
					"id": 32,
					"name": "bo.settings.defaultPrice.saveCompleted",
					"fields": {
						"videoInstanceID": "guid",
						"isPurchasable": "bool",
						"isRental": "bool",
						"biToken": "guid",
						"origin": "string",
						"compId": "string",
						"pricingSelection": {
							"values": [
								"free",
								"paid"
							]
						},
						"pricingSelectionChange": "bool",
						"purchasableChange": "bool",
						"purchasePricinig": "numeric",
						"purchasePricinigChange": "bool",
						"rentalChange": "bool",
						"rentalPeriod": {
							"values": [
								"24",
								"48",
								"72"
							]
						},
						"rentalPeriodChange": "bool",
						"rentalPricinig": "numeric",
						"rentalPricinigChange": "bool"
					}
				}
			},
			"defaultCh": {
				"changed": {
					"id": 33,
					"name": "bo.settings.defaultCh.changed",
					"fields": {
						"channelID": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string"
					}
				}
			},
			"emailLang": {
				"changed": {
					"id": 34,
					"name": "bo.settings.emailLang.changed",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string",
						"selectedLang": "string"
					}
				}
			},
			"emailPreview": {
				"clicked": {
					"id": 35,
					"name": "bo.settings.emailPreview.clicked",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string"
					}
				}
			},
			"emailWhenSale": {
				"changed": {
					"id": 36,
					"name": "bo.settings.emailWhenSale.changed",
					"fields": {
						"emailWhenSale": "bool",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string"
					}
				}
			},
			"reviewContacts": {
				"clicked": {
					"id": 37,
					"name": "bo.settings.reviewContacts.clicked",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string"
					}
				}
			},
			"PayPalConnectBtn": {
				"connected": {
					"id": 38,
					"name": "bo.settings.PayPalConnectBtn.connected",
					"fields": {
						"videoInstanceID": "guid",
						"isFirst": "bool",
						"biToken": "guid",
						"origin": "string",
						"compId": "string",
						"uuid": "guid"
					}
				},
				"clicked": {
					"id": 39,
					"name": "bo.settings.PayPalConnectBtn.clicked",
					"fields": {
						"videoInstanceID": "guid",
						"isFirst": "bool",
						"biToken": "guid",
						"origin": "string",
						"compId": "string"
					}
				}
			}
		},
		"general": {
			"helpBtn": {
				"clicked": {
					"id": 40,
					"name": "bo.general.helpBtn.clicked",
					"fields": {
						"fromTab": {
							"values": [
								"video-library",
								"channels",
								"stats",
								"settings"
							]
						},
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string"
					}
				}
			},
			"cancelUploadPopUp": {
				"click": {
					"id": 41,
					"name": "bo.general.cancelUploadPopUp.click",
					"fields": {
						"button": {
							"values": [
								"Delete",
								"Cancel"
							]
						},
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string"
					}
				}
			},
			"cancelUpload": {
				"click": {
					"id": 42,
					"name": "bo.general.cancelUpload.click",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string"
					}
				}
			},
			"upgradeBtn": {
				"clicked": {
					"id": 94,
					"name": "bo.general.upgradeBtn.clicked",
					"fields": {
						"ctaId": {
							"values": [
								"upgrade",
								"contactUs"
							]
						},
						"fromTab": {
							"values": [
								"library",
								"channels",
								"settings",
								"stats",
								"settings-counter",
								"email-marketing"
							]
						},
						"videoInstanceID": "guid",
						"location": {
							"values": [
								"From where in the bo the user clicked on upgrade button (menu",
								"upgradeCounter)"
							]
						},
						"biToken": "guid",
						"origin": "string",
						"compId": "string"
					}
				}
			},
			"error": {
				"notCompleteAction": {
					"id": 98,
					"name": "bo.general.error.notCompleteAction",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"compId": "string"
					}
				}
			},
			"PayPalState": {
				"id": 102,
				"name": "bo.general.PayPalState",
				"fields": {
					"videoInstanceID": "guid",
					"biToken": "guid",
					"compId": "string"
				}
			}
		},
		"uploadSuccessPopUp": {
			"triggered": {
				"id": 43,
				"name": "bo.uploadSuccessPopUp.triggered",
				"fields": {
					"videoInstanceID": "guid",
					"biToken": "guid",
					"origin": "string",
					"compId": "string"
				}
			},
			"buttonClick": {
				"id": 44,
				"name": "bo.uploadSuccessPopUp.buttonClick",
				"fields": {
					"button": {
						"values": [
							"rmanageChannels",
							"notNow"
						]
					},
					"videoInstanceID": "guid",
					"biToken": "guid",
					"origin": "string",
					"compId": "string"
				}
			}
		},
		"meetChannelsPopUp": {
			"opened": {
				"id": 45,
				"name": "bo.meetChannelsPopUp.opened",
				"fields": {
					"videoInstanceID": "guid",
					"biToken": "guid",
					"origin": "string",
					"compId": "string"
				}
			}
		},
		"lib": {
			"vid": {
				"clicked": {
					"id": 46,
					"name": "bo.lib.vid.clicked",
					"fields": {
						"editMode": {
							"values": [
								"batch",
								"single"
							]
						},
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string",
						"videoID": "string"
					}
				}
			},
			"search": {
				"clicked": {
					"id": 47,
					"name": "bo.lib.search.clicked",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string"
					}
				}
			},
			"pricing": {
				"clicked": {
					"id": 48,
					"name": "bo.lib.pricing.clicked",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"numberVideos": "numeric",
						"origin": "string",
						"compId": "string",
						"videoID": "string"
					}
				},
				"saveClicked": {
					"id": 49,
					"name": "bo.lib.pricing.saveClicked",
					"fields": {
						"videoInstanceID": "guid",
						"isPurchasable": "bool",
						"isRental": "bool",
						"biToken": "guid",
						"numberVideos": "numeric",
						"origin": "string",
						"compId": "string",
						"pricingSelection": {
							"values": [
								"free",
								"paid"
							]
						},
						"pricingSelectionChange": "bool",
						"purchasableChange": "bool",
						"purchasePricinig": "numeric",
						"purchasePricinigChange": "bool",
						"rentalChange": "bool",
						"rentalPeriod": {
							"values": [
								"24",
								"48",
								"72"
							]
						},
						"rentalPeriodChange": "bool",
						"rentalPricinig": "numeric",
						"rentalPricinigChange": "bool",
						"videoID": "string"
					}
				},
				"saveCompleted": {
					"id": 50,
					"name": "bo.lib.pricing.saveCompleted",
					"fields": {
						"videoInstanceID": "guid",
						"isPurchasable": "bool",
						"isRental": "bool",
						"biToken": "guid",
						"numberVideos": "numeric",
						"origin": "string",
						"compId": "string",
						"pricingSelection": {
							"values": [
								"free",
								"paid"
							]
						},
						"pricingSelectionChange": "bool",
						"purchasableChange": "bool",
						"purchasePricinig": "numeric",
						"purchasePricinigChange": "bool",
						"rentalChange": "bool",
						"rentalPeriod": {
							"values": [
								"24",
								"48",
								"72"
							]
						},
						"rentalPeriodChange": "bool",
						"rentalPricinig": "numeric",
						"rentalPricinigChange": "bool",
						"videoID": "string"
					}
				}
			},
			"deleteVideo": {
				"clicked": {
					"id": 51,
					"name": "bo.lib.deleteVideo.clicked",
					"fields": {
						"button": {
							"values": [
								"batch",
								"video-page"
							]
						},
						"videoInstanceID": "guid",
						"biToken": "guid",
						"numberVideos": "numeric",
						"origin": "string",
						"compId": "string",
						"videoID": "string"
					}
				},
				"popup": {
					"cancelBtn": {
						"clicked": {
							"id": 54,
							"name": "bo.lib.deleteVideo.popup.cancelBtn.clicked",
							"fields": {
								"videoInstanceID": "guid",
								"biToken": "guid",
								"origin": "string",
								"compId": "string"
							}
						}
					},
					"deleteBtn": {
						"clicked": {
							"id": 55,
							"name": "bo.lib.deleteVideo.popup.deleteBtn.clicked",
							"fields": {
								"button": {
									"values": [
										"batch",
										"video page"
									]
								},
								"videoInstanceID": "guid",
								"biToken": "guid",
								"numberVideos": "numeric",
								"origin": "string",
								"compId": "string",
								"videoID": "string"
							}
						}
					}
				}
			},
			"addToChannel": {
				"Btn": {
					"clicked": {
						"id": 56,
						"name": "bo.lib.addToChannel.Btn.clicked",
						"fields": {
							"videoInstanceID": "guid",
							"biToken": "guid",
							"numberVideos": "numeric",
							"origin": "string",
							"compId": "string",
							"videoID": "string"
						}
					}
				},
				"saveBtn": {
					"clicked": {
						"id": 57,
						"name": "bo.lib.addToChannel.saveBtn.clicked",
						"fields": {
							"channelID": "string",
							"videoInstanceID": "guid",
							"biToken": "guid",
							"numberChannels": "numeric",
							"numberVideos": "numeric",
							"origin": "string",
							"compId": "string",
							"videoID": "string"
						}
					}
				},
				"cancelBtn": {
					"clicked": {
						"id": 58,
						"name": "bo.lib.addToChannel.cancelBtn.clicked",
						"fields": {
							"videoInstanceID": "guid",
							"biToken": "guid",
							"origin": "string",
							"compId": "string"
						}
					}
				}
			},
			"upload": {
				"error": {
					"id": 90,
					"name": "bo.lib.upload.error",
					"fields": {
						"errorType": {
							"values": [
								"Unsupported format",
								"Invalid video file",
								"File exceeds max size",
								"Unsupported code",
								"Network connection issue",
								"Unknown error"
							]
						},
						"videoInstanceID": "guid",
						"biToken": "guid",
						"compId": "string",
						"videoID": "string"
					},
					"btn": {
						"click": {
							"id": 91,
							"name": "bo.lib.upload.error.btn.click",
							"fields": {
								"button": {
									"values": [
										"Replace file",
										"Clear",
										"Try again"
									]
								},
								"errorType": {
									"values": [
										"Unsupported format",
										"Invalid video file",
										"File exceeds max size",
										"Unsupported codec",
										"Network connection issue",
										"Unknown error"
									]
								},
								"videoInstanceID": "guid",
								"biToken": "guid",
								"compId": "string",
								"videoID": "string"
							}
						}
					}
				}
			},
			"upgrade": {
				"state": {
					"id": 92,
					"name": "bo.lib.upgrade.state",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string",
						"upgradeState": {
							"values": [
								"free_more_than_10",
								"free_more_30_min_package",
								"exceeds_package_limit"
							]
						},
						"videoID": "string"
					},
					"button": {
						"click": {
							"id": 93,
							"name": "bo.lib.upgrade.state.button.click",
							"fields": {
								"button": {
									"values": [
										"Upgrade_Now",
										"Clear"
									]
								},
								"buttonType": {
									"values": [
										"state",
										"tool_tip"
									]
								},
								"videoInstanceID": "guid",
								"biToken": "guid",
								"origin": "string",
								"compId": "string",
								"upgradeState": {
									"values": [
										"free_more_than_10",
										"free_more_30_min_package",
										"exceeds_package_limit"
									]
								},
								"videoID": "string"
							}
						}
					}
				}
			},
			"signUpToWatch": {
				"clicked": {
					"id": 114,
					"name": "bo.lib.signUpToWatch.clicked",
					"fields": {
						"buttonOrigin": {
							"values": [
								"from where the user click on it (settings",
								"on video",
								"set pricing",
								"video info)"
							]
						},
						"videoInstanceID": "guid",
						"biToken": "guid",
						"numberVideos": "numeric",
						"origin": "string",
						"compId": "string",
						"toggle": "bool",
						"videoID": "string"
					}
				}
			},
			"goToChannels": {
				"clicked": {
					"id": 140,
					"name": "bo.lib.goToChannels.clicked",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"compId": "string"
					}
				}
			}
		},
		"upload": {
			"start": {
				"id": 52,
				"name": "bo.upload.start",
				"fields": {
					"button": {
						"values": [
							"drag&drop",
							"upload"
						]
					},
					"videoInstanceID": "guid",
					"isFirst": "bool",
					"biToken": "guid",
					"origin": "string",
					"compId": "string",
					"source": {
						"values": [
							"upload",
							"drive",
							"dropbox"
						]
					},
					"tracksUploaded": "string"
				}
			},
			"completed": {
				"id": 53,
				"name": "bo.upload.completed",
				"fields": {
					"button": {
						"values": [
							"drag&drop",
							"upload"
						]
					},
					"status_code": "numeric",
					"errorKey": "string",
					"errorScope": {
						"values": [
							"OK",
							"failedChecking",
							"failedRequirement",
							"failedTransmission",
							"failedByUseAction",
							"failedProcessing"
						]
					},
					"errorType": {
						"values": [
							"OK",
							"networkError",
							"serverError",
							"unknownError",
							"userClosedDashboard",
							"quotaExceeded",
							"invalidFile",
							"notSupported",
							"exceedsMaxSize"
						]
					},
					"videoInstanceID": "guid",
					"isFirst": "bool",
					"isSuccess": "bool",
					"biToken": "guid",
					"origin": "string",
					"path": "string",
					"compId": "string",
					"source": {
						"values": [
							"upload",
							"drive",
							"dropbox"
						]
					},
					"tracksUploaded": "string"
				}
			},
			"totalComplete": {
				"id": 105,
				"name": "bo.upload.totalComplete",
				"fields": {
					"button": {
						"values": [
							"drag&drop",
							"upload"
						]
					},
					"videoInstanceID": "guid",
					"isFirst": "bool",
					"isSuccess": "bool",
					"biToken": "guid",
					"numberOfFailedUploads": "numeric",
					"numberOfSuccessfulUploads": "numeric",
					"origin": "string",
					"compId": "string",
					"source": {
						"values": [
							"upload",
							"drive",
							"dropbox"
						]
					}
				}
			},
			"attempted": {
				"id": 106,
				"name": "bo.upload.attempted",
				"fields": {
					"button": {
						"values": [
							"drag-n-drop",
							"upload"
						]
					},
					"videoInstanceID": "guid",
					"isFirst": "bool",
					"biToken": "guid",
					"origin": "string",
					"compId": "string",
					"source": {
						"values": [
							"upload",
							"drive",
							"dropbox"
						]
					},
					"tracksUploaded": "string"
				}
			},
			"addVideos": {
				"clicked": {
					"id": 107,
					"name": "bo.upload.addVideos.clicked",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"compId": "string"
					}
				},
				"hovered": {
					"id": 108,
					"name": "bo.upload.addVideos.hovered",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"compId": "string"
					}
				},
				"videoSource": {
					"clicked": {
						"id": 109,
						"name": "bo.upload.addVideos.videoSource.clicked",
						"fields": {
							"videoInstanceID": "guid",
							"biToken": "guid",
							"origin": "string",
							"compId": "string",
							"source": {
								"values": [
									"computer",
									"youtube",
									"vimeo",
									"drive",
									"dropbox"
								]
							},
							"type": {
								"values": [
									"upload",
									"embed"
								]
							}
						}
					}
				},
				"embedVideo": {
					"enterUrl": {
						"id": 110,
						"name": "bo.upload.addVideos.embedVideo.enterUrl",
						"fields": {
							"videoInstanceID": "guid",
							"biToken": "guid",
							"origin": "string",
							"compId": "string",
							"source": {
								"values": [
									"youtube",
									"vimeo"
								]
							}
						},
						"parsingCompleted": {
							"id": 113,
							"name": "bo.upload.addVideos.embedVideo.enterUrl.parsingCompleted",
							"fields": {
								"errorCode": "numeric",
								"errorMsg": "string",
								"videoInstanceID": "guid",
								"isSuccess": "bool",
								"biToken": "guid",
								"origin": "string",
								"url": "string",
								"compId": "string",
								"source": {
									"values": [
										"youtube",
										"vimeo"
									]
								}
							}
						}
					},
					"button": {
						"clicked": {
							"id": 111,
							"name": "bo.upload.addVideos.embedVideo.button.clicked",
							"fields": {
								"button_name": {
									"values": [
										"add_to_library",
										"cancel",
										"close"
									]
								},
								"videoInstanceID": "guid",
								"biToken": "guid",
								"origin": "string",
								"compId": "string",
								"source": {
									"values": [
										"youtube",
										"vimeo"
									]
								}
							}
						}
					},
					"completed": {
						"id": 112,
						"name": "bo.upload.addVideos.embedVideo.completed",
						"fields": {
							"errorCode": "numeric",
							"videoInstanceID": "guid",
							"isFirst": "bool",
							"errorMsg": "string",
							"biToken": "guid",
							"num_videos_embedded": "numeric",
							"origin": "string",
							"url": "string",
							"compId": "string",
							"source": {
								"values": [
									"youtube",
									"vimeo"
								]
							},
							"isSuccess": "bool"
						}
					}
				}
			}
		},
		"vid": {
			"deleteVidBtn": {
				"clicked": {
					"id": 59,
					"name": "bo.vid.deleteVidBtn.clicked",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string",
						"videoID": "string"
					}
				}
			},
			"deleteVidPopupBtn": {
				"clicked": {
					"id": 60,
					"name": "bo.vid.deleteVidPopupBtn.clicked",
					"fields": {
						"button": {
							"values": [
								"delete",
								"cancel"
							]
						},
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string",
						"videoID": "string"
					}
				}
			},
			"changeVideo": {
				"clicked": {
					"id": 61,
					"name": "bo.vid.changeVideo.clicked",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string",
						"videoID": "string"
					}
				},
				"completed": {
					"id": 62,
					"name": "bo.vid.changeVideo.completed",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string",
						"videoID": "string"
					}
				}
			},
			"changeCover": {
				"clicked": {
					"id": 63,
					"name": "bo.vid.changeCover.clicked",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string",
						"videoID": "string"
					}
				},
				"completed": {
					"id": 64,
					"name": "bo.vid.changeCover.completed",
					"fields": {
						"coverOrigin": {
							"values": [
								"upload",
								"exist"
							]
						},
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string",
						"videoID": "string"
					}
				},
				"setAsCover": {
					"clicked": {
						"id": 125,
						"name": "bo.vid.changeCover.setAsCover.clicked",
						"fields": {
							"videoInstanceID": "guid",
							"biToken": "guid",
							"compId": "string"
						}
					}
				}
			}
		},
		"vidPage": {
			"trailer": {
				"upload": {
					"start": {
						"id": 65,
						"name": "bo.vidPage.trailer.upload.start",
						"fields": {
							"button": {
								"values": [
									"drag-n-drop",
									"upload"
								]
							},
							"videoInstanceID": "guid",
							"biToken": "guid",
							"origin": "string",
							"compId": "string",
							"trailerID": "string",
							"videoID": "string"
						}
					},
					"completed": {
						"id": 66,
						"name": "bo.vidPage.trailer.upload.completed",
						"fields": {
							"button": {
								"values": [
									"drag-n-drop",
									"upload"
								]
							},
							"videoInstanceID": "guid",
							"isSuccess": "bool",
							"biToken": "guid",
							"origin": "string",
							"compId": "string",
							"trailerID": "string",
							"videoID": "string"
						}
					}
				}
			},
			"save": {
				"click": {
					"id": 67,
					"name": "bo.vidPage.save.click",
					"fields": {
						"audience": {
							"values": [
								"all",
								"mature"
							]
						},
						"audienceChanged": "bool",
						"categoryExists": "bool",
						"coverUploaded": "bool",
						"descriptionExists": "bool",
						"genre": "string",
						"genreChanged": "bool",
						"videoInstanceID": "guid",
						"isPurchasable": "bool",
						"isRental": "bool",
						"biToken": "guid",
						"numOfCastMembers": "numeric",
						"numOfCrewMembers": "numeric",
						"numOfTags": "numeric",
						"numVideoEdit": "numeric",
						"origin": "string",
						"compId": "string",
						"posterExists": "bool",
						"pricingSelection": {
							"values": [
								"free",
								"paid"
							]
						},
						"pricingSelectionChange": "bool",
						"publisherExists": "bool",
						"purchasableChange": "bool",
						"purchasePricinig": "numeric",
						"purchasePricinigChange": "bool",
						"rentalChange": "bool",
						"rentalPeriod": {
							"values": [
								"24",
								"48",
								"72"
							]
						},
						"rentalPeriodChange": "bool",
						"rentalPricinig": "numeric",
						"rentalPricinigChange": "bool",
						"trailer": {
							"values": [
								"preview",
								"traliler",
								"DontShow"
							]
						},
						"trailerChanged": "bool",
						"videoID": "string",
						"videoType": "string",
						"videoTypeChanged": "bool"
					}
				},
				"saveCompleted": {
					"id": 68,
					"name": "bo.vidPage.save.saveCompleted",
					"fields": {
						"audience": {
							"values": [
								"all",
								"mature"
							]
						},
						"audienceChanged": "bool",
						"categoryExists": "bool",
						"coverUploaded": "bool",
						"descriptionExists": "bool",
						"genre": "string",
						"genreChanged": "bool",
						"videoInstanceID": "guid",
						"isPurchasable": "bool",
						"isRental": "bool",
						"biToken": "guid",
						"numOfCastMembers": "numeric",
						"numOfCrewMembers": "numeric",
						"numOfTags": "numeric",
						"numVideoEdit": "numeric",
						"origin": "string",
						"compId": "string",
						"posterExists": "bool",
						"pricingSelection": {
							"values": [
								"free",
								"paid"
							]
						},
						"pricingSelectionChange": "bool",
						"publisherExists": "bool",
						"purchasableChange": "bool",
						"purchasePricinig": "numeric",
						"purchasePricinigChange": "bool",
						"rentalChange": "bool",
						"rentalPeriod": {
							"values": [
								"24",
								"48",
								"72"
							]
						},
						"rentalPeriodChange": "bool",
						"rentalPricinig": "numeric",
						"rentalPricinigChange": "bool",
						"trailer": {
							"values": [
								"preview",
								"traliler",
								"DontShow"
							]
						},
						"trailerChanged": "bool",
						"videoID": "string",
						"videoType": "string",
						"videoTypeChanged": "bool"
					}
				}
			},
			"error": {
				"id": 96,
				"name": "bo.vidPage.error",
				"fields": {
					"errorType": {
						"values": [
							"No title",
							"Missing trailer"
						]
					},
					"videoInstanceID": "guid",
					"biToken": "guid",
					"compId": "string",
					"videoID": "string"
				}
			},
			"priceError": {
				"id": 97,
				"name": "bo.vidPage.priceError",
				"fields": {
					"buyType": {
						"values": [
							"subscription",
							"video"
						]
					},
					"errorType": {
						"values": [
							"Price too high",
							"Price too low"
						]
					},
					"videoInstanceID": "guid",
					"biToken": "guid",
					"compId": "string",
					"videoID": "string"
				}
			}
		},
		"ch": {
			"newChannel": {
				"clicked": {
					"id": 69,
					"name": "bo.ch.newChannel.clicked",
					"fields": {
						"button": {
							"values": [
								"button",
								"box"
							]
						},
						"channelType": {
							"values": [
								"channel",
								"youtube-feed"
							]
						},
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string"
					}
				}
			},
			"search": {
				"clicked": {
					"id": 70,
					"name": "bo.ch.search.clicked",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string"
					}
				}
			},
			"statsBtn": {
				"clicked": {
					"id": 71,
					"name": "bo.ch.statsBtn.clicked",
					"fields": {
						"channelID": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string"
					}
				}
			},
			"defaultChTooltipSettings": {
				"hover": {
					"id": 72,
					"name": "bo.ch.defaultChTooltipSettings.hover",
					"fields": {
						"channelID": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string"
					}
				}
			},
			"connectFeed": {
				"completed": {
					"id": 124,
					"name": "bo.ch.connectFeed.completed",
					"fields": {
						"errorCode": "numeric",
						"videoInstanceID": "guid",
						"isFirst": "bool",
						"errorMsg": "string",
						"biToken": "guid",
						"origin": "string",
						"url": "string",
						"compId": "string",
						"source": "string",
						"isSuccess": "bool"
					}
				}
			},
			"ytlist": {
				"next": {
					"button": {
						"clicked": {
							"id": 126,
							"name": "bo.ch.ytlist.next.button.clicked",
							"fields": {
								"videoInstanceID": "guid",
								"isFirst": "bool",
								"biToken": "guid",
								"compId": "string",
								"source": {
									"values": [
										"youtube",
										"vimeo",
										"facebook"
									]
								}
							}
						}
					}
				}
			}
		},
		"chEdit": {
			"opened": {
				"id": 73,
				"name": "bo.chEdit.opened",
				"fields": {
					"channelID": "string",
					"channelType": {
						"values": [
							"channel",
							"youtube-feed"
						]
					},
					"videoInstanceID": "guid",
					"biToken": "guid",
					"origin": "string",
					"compId": "string"
				}
			},
			"deleteCh": {
				"clicked": {
					"id": 74,
					"name": "bo.chEdit.deleteCh.clicked",
					"fields": {
						"channelID": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string"
					}
				},
				"popUpBtn": {
					"clicked": {
						"id": 75,
						"name": "bo.chEdit.deleteCh.popUpBtn.clicked",
						"fields": {
							"button": {
								"values": [
									"delete",
									"cancel"
								]
							},
							"channelID": "string",
							"videoInstanceID": "guid",
							"biToken": "guid",
							"origin": "string",
							"compId": "string"
						}
					}
				}
			},
			"updateChanges": {
				"clicked": {
					"id": 76,
					"name": "bo.chEdit.updateChanges.clicked",
					"fields": {
						"button": {
							"values": [
								"popup",
								"button"
							]
						},
						"channelID": "string",
						"coverAdded": "bool",
						"descriptionExists": "bool",
						"featuredSelected": "bool",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"numOfTags": "numeric",
						"numberVideos": "numeric",
						"origin": "string",
						"compId": "string",
						"scheduledExists": "bool",
						"subscriptionEnabledChange": "bool",
						"subscriptionEnabled": "bool",
						"subscriptionPricing": "numeric",
						"subscriptionPricingChange": "bool",
						"titleAdded": "bool",
						"videoID": "string"
					}
				},
				"Completed": {
					"id": 77,
					"name": "bo.chEdit.updateChanges.Completed",
					"fields": {
						"button": {
							"values": [
								"popup",
								"button"
							]
						},
						"channelID": "string",
						"coverAdded": "bool",
						"descriptionExists": "bool",
						"featuredSelected": "bool",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"numOfTags": "numeric",
						"numberVideos": "numeric",
						"origin": "string",
						"compId": "string",
						"scheduledExists": "bool",
						"subscriptionEnabledChange": "bool",
						"subscriptionEnabled": "bool",
						"subscriptionPricing": "numeric",
						"subscriptionPricingChange": "bool",
						"titleAdded": "bool",
						"videoID": "string"
					}
				}
			},
			"laterBtn": {
				"clicked": {
					"id": 78,
					"name": "bo.chEdit.laterBtn.clicked",
					"fields": {
						"channelID": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string"
					}
				}
			},
			"schedule": {
				"clicked": {
					"id": 79,
					"name": "bo.chEdit.schedule.clicked",
					"fields": {
						"channelID": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string",
						"videoID": "string"
					}
				},
				"saved": {
					"id": 80,
					"name": "bo.chEdit.schedule.saved",
					"fields": {
						"channelID": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string",
						"videoID": "string"
					}
				}
			},
			"remove": {
				"clicked": {
					"id": 81,
					"name": "bo.chEdit.remove.clicked",
					"fields": {
						"channelID": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string",
						"videoID": "string"
					}
				},
				"popUpBtn": {
					"clicked": {
						"id": 82,
						"name": "bo.chEdit.remove.popUpBtn.clicked",
						"fields": {
							"button": {
								"values": [
									"delete",
									"cancel"
								]
							},
							"channelID": "string",
							"videoInstanceID": "guid",
							"biToken": "guid",
							"origin": "string",
							"compId": "string",
							"videoID": "string"
						}
					}
				}
			},
			"addVids": {
				"click": {
					"id": 83,
					"name": "bo.chEdit.addVids.click",
					"fields": {
						"channelID": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string"
					}
				},
				"completed": {
					"id": 84,
					"name": "bo.chEdit.addVids.completed",
					"fields": {
						"channelID": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string",
						"videoID": "string"
					}
				}
			},
			"chCover": {
				"upload": {
					"id": 85,
					"name": "bo.chEdit.chCover.upload",
					"fields": {
						"button": {
							"values": [
								"drag-n-drop",
								"upload"
							]
						},
						"channelID": "string",
						"coverID": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string"
					}
				},
				"Completed": {
					"id": 86,
					"name": "bo.chEdit.chCover.Completed",
					"fields": {
						"button": {
							"values": [
								"drag-n-drop",
								"upload"
							]
						},
						"channelID": "string",
						"coverID": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string"
					}
				}
			},
			"vid": {
				"reordered": {
					"id": 87,
					"name": "bo.chEdit.vid.reordered",
					"fields": {
						"channelID": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string",
						"videoID": "string"
					}
				}
			},
			"findVid": {
				"clicked": {
					"id": 88,
					"name": "bo.chEdit.findVid.clicked",
					"fields": {
						"channelID": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string"
					}
				}
			},
			"channelSubscriptionOnly": {
				"checkBox": {
					"click": {
						"id": 115,
						"name": "bo.chEdit.channelSubscriptionOnly.checkBox.click",
						"fields": {
							"check_box": "bool",
							"videoInstanceID": "guid",
							"biToken": "guid",
							"origin": "string",
							"compId": "string"
						}
					}
				}
			},
			"connectFeed": {
				"enterUrl": {
					"id": 116,
					"name": "bo.chEdit.connectFeed.enterUrl",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"origin": "string",
						"compId": "string",
						"source": "string"
					},
					"parsingCompleted": {
						"id": 117,
						"name": "bo.chEdit.connectFeed.enterUrl.parsingCompleted",
						"fields": {
							"errorCode": "numeric",
							"errorMsg": "string",
							"videoInstanceID": "guid",
							"isSuccess": "bool",
							"biToken": "guid",
							"origin": "string",
							"url": "string",
							"compId": "string",
							"source": "string"
						}
					},
					"button": {
						"clicked": {
							"id": 118,
							"name": "bo.chEdit.connectFeed.enterUrl.button.clicked",
							"fields": {
								"button_name": {
									"values": [
										"connect",
										"cancel",
										"close",
										"change_feed"
									]
								},
								"videoInstanceID": "guid",
								"biToken": "guid",
								"origin": "string",
								"compId": "string",
								"source": "string"
							}
						}
					}
				}
			}
		},
		"close": {
			"popup": {
				"cancelUpload": {
					"clicked": {
						"id": 103,
						"name": "bo.close.popup.cancelUpload.clicked",
						"fields": {
							"button": {
								"values": [
									"Go back",
									"Cancel Uploads"
								]
							},
							"videoInstanceID": "guid",
							"biToken": "guid",
							"origin": "string",
							"compId": "string"
						}
					}
				},
				"upgradedChannel": {
					"clicked": {
						"id": 104,
						"name": "bo.close.popup.upgradedChannel.clicked",
						"fields": {
							"button": {
								"values": [
									"No, Thanks",
									"Yes Cancel Changes"
								]
							},
							"videoInstanceID": "guid",
							"biToken": "guid",
							"origin": "string",
							"compId": "string"
						}
					}
				}
			},
			"clicked": {
				"id": 123,
				"name": "bo.close.clicked",
				"fields": {
					"videoInstanceID": "guid",
					"biToken": "guid",
					"compId": "string"
				}
			}
		},
		"loaded": {
			"id": 119,
			"name": "bo.loaded",
			"fields": {
				"videoInstanceID": "guid",
				"biToken": "guid",
				"compId": "string"
			}
		},
		"opened": {
			"id": 120,
			"name": "bo.opened",
			"fields": {
				"videoInstanceID": "guid",
				"isFirst": "bool",
				"loading_time": "numeric",
				"biToken": "guid",
				"origin": "string",
				"compId": "string"
			}
		},
		"tab": {
			"clicked": {
				"id": 121,
				"name": "bo.tab.clicked",
				"fields": {
					"videoInstanceID": "guid",
					"biToken": "guid",
					"origin": "string",
					"compId": "string",
					"newTabName": {
						"values": [
							"video-library",
							"channels",
							"email-marketing",
							"stats",
							"settings"
						]
					}
				}
			}
		},
		"welcomeScreen": {
			"clicked": {
				"id": 122,
				"name": "bo.welcomeScreen.clicked",
				"fields": {
					"videoInstanceID": "guid",
					"biToken": "guid",
					"origin": "string",
					"compId": "string"
				}
			}
		},
		"onboarding": {
			"opend": {
				"id": 127,
				"name": "bo.onboarding.opend",
				"fields": {
					"videoInstanceID": "guid",
					"isFirst": "bool",
					"loading_time": "numeric",
					"biToken": "guid",
					"origin": "string",
					"compId": "string"
				}
			}
		},
		"emailMarketing": {
			"useThisTemplate": {
				"clicked": {
					"id": 150,
					"name": "bo.emailMarketing.useThisTemplate.clicked",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"compId": "string",
						"templateType": "string"
					}
				},
				"choose": {
					"continue": {
						"click": {
							"id": 154,
							"name": "bo.emailMarketing.useThisTemplate.choose.continue.click",
							"fields": {
								"videoInstanceID": "guid",
								"biToken": "guid",
								"compId": "string",
								"templateType": "string",
								"entityId": "string"
							}
						}
					},
					"cancel": {
						"click": {
							"id": 155,
							"name": "bo.emailMarketing.useThisTemplate.choose.cancel.click",
							"fields": {
								"videoInstanceID": "guid",
								"biToken": "guid",
								"compId": "string",
								"templateType": "string"
							}
						}
					},
					"close": {
						"click": {
							"id": 156,
							"name": "bo.emailMarketing.useThisTemplate.choose.close.click",
							"fields": {
								"videoInstanceID": "guid",
								"biToken": "guid",
								"compId": "string",
								"templateType": "string"
							}
						}
					}
				}
			},
			"preview": {
				"clicked": {
					"id": 151,
					"name": "bo.emailMarketing.preview.clicked",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"compId": "string",
						"templateType": "string"
					}
				},
				"promote": {
					"choose": {
						"click": {
							"id": 157,
							"name": "bo.emailMarketing.preview.promote.choose.click",
							"fields": {
								"videoInstanceID": "guid",
								"biToken": "guid",
								"compId": "string",
								"templateType": "string"
							}
						}
					},
					"close": {
						"click": {
							"id": 158,
							"name": "bo.emailMarketing.preview.promote.close.click",
							"fields": {
								"videoInstanceID": "guid",
								"biToken": "guid",
								"compId": "string",
								"templateType": "string"
							}
						}
					}
				}
			},
			"startFromScratch": {
				"clicked": {
					"id": 152,
					"name": "bo.emailMarketing.startFromScratch.clicked",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"compId": "string"
					}
				}
			},
			"shoutOutDashboard": {
				"clicked": {
					"id": 153,
					"name": "bo.emailMarketing.shoutOutDashboard.clicked",
					"fields": {
						"videoInstanceID": "guid",
						"biToken": "guid",
						"compId": "string"
					}
				}
			}
		}
	},
	"widget": {
		"vid": {
			"clicked": {
				"id": 128,
				"name": "widget.vid.clicked",
				"fields": {
					"channelID": "string",
					"videoInstanceID": "guid",
					"biToken": "guid",
					"compId": "string",
					"videoType": {
						"values": [
							"facebook",
							"youtube",
							"computer",
							"vimeo"
						]
					},
					"visitorID": "guid"
				}
			},
			"start": {
				"play": {
					"id": 129,
					"name": "widget.vid.start.play",
					"fields": {
						"button": {
							"values": [
								"thumbnail",
								"main"
							]
						},
						"channelID": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"compId": "string",
						"videoID": "string",
						"videoType": {
							"values": [
								"computer",
								"vimeo",
								"facebook",
								"youtube"
							]
						},
						"visitorID": "guid"
					}
				}
			},
			"played": {
				"id": 218,
				"name": "widget.vid.played",
				"fields": {
					"button": {
						"values": [
							"thumbnail",
							"main"
						]
					},
					"channelID": "string",
					"videoInstanceID": "guid",
					"biToken": "guid",
					"compId": "string",
					"videoID": "string",
					"visitorID": "guid"
				}
			},
			"buy": {
				"displayed": {
					"id": 219,
					"name": "widget.vid.buy.displayed",
					"fields": {
						"button": {
							"values": [
								"thumbnail",
								"main"
							]
						},
						"buyType": {
							"values": [
								"buy",
								"rent",
								"buyFrom"
							]
						},
						"channelID": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"compId": "string",
						"videoID": "string",
						"visitorID": "guid"
					}
				},
				"clicked": {
					"id": 220,
					"name": "widget.vid.buy.clicked",
					"fields": {
						"button": {
							"values": [
								"thumbnail",
								"main"
							]
						},
						"buyType": {
							"values": [
								"buy",
								"rent",
								"buyFrom"
							]
						},
						"channelID": "string",
						"currency": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"compId": "string",
						"price": "numeric",
						"videoID": "string",
						"visitorID": "guid"
					}
				},
				"success": {
					"id": 221,
					"name": "widget.vid.buy.success",
					"fields": {
						"buyType": {
							"values": [
								"buy",
								"rent",
								"buyFrom"
							]
						},
						"channelID": "string",
						"currency": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"compId": "string",
						"price": "numeric",
						"videoID": "string",
						"visitorID": "guid"
					}
				}
			},
			"info": {
				"displayed": {
					"id": 222,
					"name": "widget.vid.info.displayed",
					"fields": {
						"channelID": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"compId": "string",
						"videoID": "string",
						"visitorID": "guid"
					}
				},
				"clicked": {
					"id": 223,
					"name": "widget.vid.info.clicked",
					"fields": {
						"channelID": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"compId": "string",
						"videoID": "string",
						"visitorID": "guid"
					}
				}
			},
			"share": {
				"displayed": {
					"id": 224,
					"name": "widget.vid.share.displayed",
					"fields": {
						"channelID": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"compId": "string",
						"videoID": "string",
						"visitorID": "guid"
					}
				},
				"clicked": {
					"id": 225,
					"name": "widget.vid.share.clicked",
					"fields": {
						"button": {
							"values": [
								"facebook",
								"twitter",
								"pinterest",
								"tumblr"
							]
						},
						"channelID": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"compId": "string",
						"videoID": "string",
						"visitorID": "guid"
					}
				}
			},
			"fullScreen": {
				"clicked": {
					"id": 226,
					"name": "widget.vid.fullScreen.clicked",
					"fields": {
						"channelID": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"compId": "string",
						"videoID": "string",
						"visitorID": "guid"
					}
				}
			},
			"cancelBuy": {
				"Completed": {
					"id": 227,
					"name": "widget.vid.cancelBuy.Completed",
					"fields": {
						"buyType": {
							"values": [
								"buy",
								"rent",
								"buyFrom"
							]
						},
						"channelID": "string",
						"currency": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"compId": "string",
						"price": "numeric",
						"videoID": "string",
						"visitorID": "guid"
					}
				}
			},
			"error": {
				"id": 229,
				"name": "widget.vid.error",
				"fields": {
					"channelID": "string",
					"errorType": {
						"values": [
							"Video is not available",
							"Video is processing"
						]
					},
					"videoInstanceID": "guid",
					"biToken": "guid",
					"compId": "string",
					"videoID": "string",
					"visitorID": "guid"
				}
			}
		},
		"loaded": {
			"id": 199,
			"name": "widget.loaded",
			"fields": {
				"channelID": "string",
				"videoInstanceID": "guid",
				"biToken": "guid",
				"compId": "string",
				"visitorID": "guid"
			}
		},
		"opened": {
			"id": 200,
			"name": "widget.opened",
			"fields": {
				"buyTypeDisplayed": {
					"values": [
						"rent",
						"buyFrom",
						"buy",
						"none"
					]
				},
				"channelID": "string",
				"videoInstanceID": "guid",
				"isSubscriptionBtn": "bool",
				"isTrailerBtn": "bool",
				"loading_time": "numeric",
				"mainItem": {
					"values": [
						"featuredVid",
						"channelCover"
					]
				},
				"biToken": "guid",
				"compId": "string",
				"trailerType": {
					"values": [
						"preview",
						"trailer"
					]
				},
				"visitorID": "guid"
			}
		},
		"signIn": {
			"clicked": {
				"id": 201,
				"name": "widget.signIn.clicked",
				"fields": {
					"videoInstanceID": "guid",
					"biToken": "guid",
					"compId": "string",
					"visitorID": "guid"
				}
			}
		},
		"signInPopUp": {
			"BtnClicked": {
				"id": 202,
				"name": "widget.signInPopUp.BtnClicked",
				"fields": {
					"button": {
						"values": [
							"proceed",
							"cancel"
						]
					},
					"videoInstanceID": "guid",
					"biToken": "guid",
					"compId": "string",
					"visitorID": "guid"
				}
			}
		},
		"VidSelected": {
			"displayed": {
				"id": 203,
				"name": "widget.VidSelected.displayed",
				"fields": {
					"buyBtn": "bool",
					"buyType": {
						"values": [
							"rent",
							"from",
							"none"
						]
					},
					"channelID": "string",
					"videoInstanceID": "guid",
					"biToken": "guid",
					"playBtn": "bool",
					"compId": "string",
					"trailerBtn": "bool",
					"trailerType": {
						"values": [
							"preview",
							"trailer"
						]
					},
					"videoID": "string",
					"visitorID": "guid"
				}
			},
			"btn": {
				"clicked": {
					"id": 204,
					"name": "widget.VidSelected.btn.clicked",
					"fields": {
						"button": {
							"values": [
								"playVid",
								"buy",
								"rent",
								"buyFrom",
								"trailer",
								"preview"
							]
						},
						"buttonType": {
							"values": [
								"thumbnail",
								"main"
							]
						},
						"channelID": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"compId": "string",
						"videoID": "string",
						"visitorID": "guid"
					}
				}
			}
		},
		"chCover": {
			"btn": {
				"clicked": {
					"id": 205,
					"name": "widget.chCover.btn.clicked",
					"fields": {
						"button": {
							"values": [
								"startWatching",
								"watchPreview",
								"subscribe"
							]
						},
						"channelID": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"compId": "string",
						"visitorID": "guid"
					}
				}
			}
		},
		"subscription": {
			"displayed": {
				"id": 206,
				"name": "widget.subscription.displayed",
				"fields": {
					"channelID": "string",
					"videoInstanceID": "guid",
					"biToken": "guid",
					"compId": "string",
					"visitorID": "guid",
					"whereDisplayed": {
						"values": [
							"widget",
							"cover"
						]
					}
				}
			},
			"clicked": {
				"id": 208,
				"name": "widget.subscription.clicked",
				"fields": {
					"channelID": "string",
					"videoInstanceID": "guid",
					"biToken": "guid",
					"compId": "string",
					"visitorID": "guid"
				}
			}
		},
		"subscriptionPopUp": {
			"Completed": {
				"id": 207,
				"name": "widget.subscriptionPopUp.Completed",
				"fields": {
					"channelID": "string",
					"videoInstanceID": "guid",
					"errorMsg": "string",
					"biToken": "guid",
					"compId": "string",
					"result": {
						"values": [
							"success",
							"canceled",
							"failed"
						]
					},
					"visitorID": "guid"
				}
			}
		},
		"search": {
			"clicked": {
				"id": 209,
				"name": "widget.search.clicked",
				"fields": {
					"channelID": "string",
					"videoInstanceID": "guid",
					"biToken": "guid",
					"compId": "string",
					"visitorID": "guid"
				}
			}
		},
		"tags": {
			"clicked": {
				"id": 210,
				"name": "widget.tags.clicked",
				"fields": {
					"channelID": "string",
					"videoInstanceID": "guid",
					"biToken": "guid",
					"compId": "string",
					"visitorID": "guid"
				}
			},
			"selected": {
				"id": 211,
				"name": "widget.tags.selected",
				"fields": {
					"channelID": "string",
					"videoInstanceID": "guid",
					"biToken": "guid",
					"compId": "string",
					"visitorID": "guid"
				}
			}
		},
		"categories": {
			"selected": {
				"id": 212,
				"name": "widget.categories.selected",
				"fields": {
					"channelID": "string",
					"videoInstanceID": "guid",
					"biToken": "guid",
					"compId": "string",
					"visitorID": "guid"
				}
			},
			"clicked": {
				"id": 213,
				"name": "widget.categories.clicked",
				"fields": {
					"channelID": "string",
					"videoInstanceID": "guid",
					"biToken": "guid",
					"compId": "string",
					"visitorID": "guid"
				}
			}
		},
		"aboutCh": {
			"displayed": {
				"id": 214,
				"name": "widget.aboutCh.displayed",
				"fields": {
					"channelID": "string",
					"videoInstanceID": "guid",
					"biToken": "guid",
					"compId": "string",
					"visitorID": "guid"
				}
			},
			"clicked": {
				"id": 215,
				"name": "widget.aboutCh.clicked",
				"fields": {
					"channelID": "string",
					"videoInstanceID": "guid",
					"biToken": "guid",
					"compId": "string",
					"visitorID": "guid"
				}
			}
		},
		"signup": {
			"clicked": {
				"id": 216,
				"name": "widget.signup.clicked",
				"fields": {
					"channelID": "string",
					"videoInstanceID": "guid",
					"biToken": "guid",
					"compId": "string",
					"visitorID": "guid"
				}
			}
		},
		"share": {
			"clicked": {
				"id": 217,
				"name": "widget.share.clicked",
				"fields": {
					"channelID": "string",
					"videoInstanceID": "guid",
					"biToken": "guid",
					"compId": "string",
					"typeShare": {
						"values": [
							"facebook",
							"twitter",
							"pinterest",
							"tumblr"
						]
					},
					"visitorID": "guid"
				}
			}
		},
		"exploreThisChannel": {
			"clicked": {
				"id": 228,
				"name": "widget.exploreThisChannel.clicked",
				"fields": {
					"channelID": "string",
					"videoInstanceID": "guid",
					"biToken": "guid",
					"compId": "string",
					"visitorID": "guid"
				}
			}
		},
		"popup": {
			"errorPayPal": {
				"id": 230,
				"name": "widget.popup.errorPayPal",
				"fields": {
					"channelID": "string",
					"errorType": {
						"values": [
							"Video is not available",
							"Video is processing"
						]
					},
					"videoInstanceID": "guid",
					"biToken": "guid",
					"compId": "string",
					"videoID": "string",
					"visitorID": "guid"
				}
			}
		},
		"actionBar": {
			"open": {
				"click": {
					"id": 231,
					"name": "widget.actionBar.open.click",
					"fields": {
						"channelID": "string",
						"videoInstanceID": "guid",
						"biToken": "guid",
						"compId": "string",
						"visitorID": "guid"
					}
				}
			}
		}
	}
};

/***/ }),
/* 1190 */
/***/ (function(module, exports) {

module.exports = {
	"widget-system": 232
};

/***/ }),
/* 1191 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1192 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1193 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1194 */,
/* 1195 */,
/* 1196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BIUnhandledErrorLogger; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_utils_wix_connect__ = __webpack_require__(11);







var _dec, _class, _desc, _value, _class2, _class3, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}




var BIUnhandledErrorLogger = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_shared_utils_wix_connect__["a" /* WixConnect */])(), _dec(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(BIUnhandledErrorLogger, _React$Component);

  function BIUnhandledErrorLogger() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, BIUnhandledErrorLogger);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (BIUnhandledErrorLogger.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(BIUnhandledErrorLogger)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(BIUnhandledErrorLogger, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      global.addEventListener('error', this.sendBIError);

      var previousOnUnhandledRejection = global.onunhandledrejection;

      global.onunhandledrejection = function (event) {
        _this2.sendBIError();
        if (previousOnUnhandledRejection) {
          previousOnUnhandledRejection(event);
        }
      };
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      global.removeEventListener('error', this.sendBIError);
    }
  }, {
    key: 'sendBIError',
    value: function sendBIError() {
      try {
        this.props.biError('shared.general.unhandled-exception').catch(_.noop);
      } catch (error) {
        // this is really bad if this section was reached
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return BIUnhandledErrorLogger;
}(React.Component), _class3.propTypes = {
  biError: React.PropTypes.func
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'sendBIError', [__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'sendBIError'), _class2.prototype)), _class2)) || _class);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(19)))

/***/ }),
/* 1197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return roles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return categories; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return categoryValues; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _categoryValues;

var roles = {
  DIRECTOR: 'director',
  CO_DIRECTOR: 'co-director',
  PRODUCER: 'producer',
  EXECUTIVE_PRODUCER: 'executive-producer',
  CO_PRODUCER: 'co-producer',
  ASSOCIATE_PRODUCER: 'associate-producer',
  COLLABORATING_DIRECTOR: 'collaborating-director',
  PRODUCTION_MANAGER: 'production-manager',
  PRODUCTION_COORDINATOR: 'production-coordinator',
  PRODUCTION_ASSISTANT: 'production-assistant',
  ASSISTANT_DIRECTOR: 'assistant-director',
  '2ND_ASSISTANT_DIRECTOR': '2nd-assistant-director',
  SCRIPT_SUPERVISOR: 'script-supervisor',
  LOCATION_MANAGER: 'location-manager',
  WRITER: 'writer',
  CO_WRITER: 'co-writer',
  STORY: 'story',
  ADAPTATION: 'adaptation',
  AUTHOR_OF_ADAPTED_MATERIAL: 'author-of-adapted-material',
  CINEMATOGRAPHER_DP: 'cinematographer-dp',
  ASSISTANT_CAMERA: 'assistant-camera',
  ADDITIONAL_PHOTOGRAPHY: 'additional-photography',
  '2ND_UNIT_DIR_OF_PHOTOGRAPHY': '2nd-unit-dir-of-photography',
  CAMERA_OPERATOR: 'camera-operator',
  GAFFER: 'gaffer',
  BEST_BOY: 'best-boy',
  KEY_GRIP: 'key-grip',
  ADDITIONAL_GRIP: 'additional-grip',
  DOLLY_GRIP: 'dolly-grip',
  GRIP: 'grip',
  SOUND_MIXER: 'sound-mixer',
  BOOM_OPERATOR: 'boom-operator',
  CABLE_PERSON: 'cable-person',
  VIDEO_OPERATOR: 'video-operator',
  ART_DIRECTOR: 'art-director',
  ASSISTANT_ART_DIRECTOR: 'assistant-art-director',
  COSTUME_DESIGNER: 'costume-designer',
  COSTUMER: 'costumer',
  HAIRSTYLIST: 'hairstylist',
  LEAD_PERSON: 'lead-person',
  MAKEUP_ARTIST: 'makeup-artist',
  MAKEUP_EFFECTS: 'makeup-effects',
  PRODUCTION_DESIGNER: 'production-designer',
  PROPERTY_MASTER: 'property-master',
  SET_DECORATOR: 'set decorator',
  SET_DESIGNER: 'set-designer',
  SWING_GANG: 'swing-gang',
  ANIMAL_TRAINER: 'animal-trainer',
  CHOREOGRAPHER: 'choreographer',
  SPECIAL_EFFECTS: 'special-effects',
  STUNT_COORDINATOR: 'stunt-coordinator',
  TECHNICAL_ADVISOR: 'technical-advisor',
  EDITOR: 'editor',
  ASSISTANT_EDITOR: 'assistant-editor',
  SOUND_EDITOR: 'sound-editor',
  DIGITAL_EFFECTS: 'digital-effects',
  ORIGINAL_MUSIC_COMPOSER: 'original-music-composer',
  ANIMATOR: 'animator',
  AGENT: 'agent',
  MANAGER: 'manager',
  PUBLICIST: 'publicist',
  PRINT_SHIPPER: 'print-shipper',
  PRINT_RETURN: 'print-return',
  PREVIEW_RETURN: 'preview-return',
  ACADEMIC_ADVISOR: 'academic-advisor',
  SCHOOL_ADMINISTRATOR: 'school-administrator'
};

var categories = {
  POPULAR: 'popular',
  PRODUCTION: 'production',
  WRITING: 'writing',
  CAMERA: 'camera',
  ELECTRICS: 'electrics',
  GRIP: 'grip',
  SOUND_AND_VIDEO: 'sound_and_video',
  ART: 'art',
  SPECIALIZED: 'specialized',
  POST_PRODUCTION: 'post_production',
  ANIMATION: 'animation',
  REPRESENTATION: 'representation',
  PRINT_TRAFFIC: 'print_traffic',
  ACADEMIC: 'academic'
};

/* unused harmony default export */ var _unused_webpack_default_export = (_.values(roles));

var categoryValues = (_categoryValues = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_categoryValues, categories.POPULAR, [roles.DIRECTOR, roles.CO_DIRECTOR, roles.PRODUCER, roles.EXECUTIVE_PRODUCER, roles.CO_PRODUCER, roles.ASSOCIATE_PRODUCER, roles.COLLABORATING_DIRECTOR, roles.ART_DIRECTOR, roles.ASSISTANT_DIRECTOR, roles.ASSISTANT_CAMERA, roles.CINEMATOGRAPHER_DP, roles.WRITER, roles.GAFFER, roles.SOUND_MIXER, roles.PRODUCTION_DESIGNER, roles.EDITOR, roles.AGENT, roles.MANAGER, roles.PUBLICIST]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_categoryValues, categories.PRODUCTION, [roles.DIRECTOR, roles.CO_DIRECTOR, roles.PRODUCER, roles.EXECUTIVE_PRODUCER, roles.CO_PRODUCER, roles.ASSOCIATE_PRODUCER, roles.COLLABORATING_DIRECTOR, roles.PRODUCTION_MANAGER, roles.PRODUCTION_COORDINATOR, roles.PRODUCTION_ASSISTANT, roles.ASSISTANT_DIRECTOR, roles['2ND_ASSISTANT_DIRECTOR'], roles.SCRIPT_SUPERVISOR, roles.LOCATION_MANAGER]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_categoryValues, categories.WRITING, [roles.WRITER, roles.CO_WRITER, roles.STORY, roles.ADAPTATION, roles.AUTHOR_OF_ADAPTED_MATERIAL]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_categoryValues, categories.CAMERA, [roles.CINEMATOGRAPHER_DP, roles.ASSISTANT_CAMERA, roles.ADDITIONAL_PHOTOGRAPHY, roles['2ND_UNIT_DIR_OF_PHOTOGRAPHY'], roles.CAMERA_OPERATOR]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_categoryValues, categories.ELECTRICS, [roles.GAFFER, roles.BEST_BOY]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_categoryValues, categories.GRIP, [roles.KEY_GRIP, roles.ADDITIONAL_GRIP, roles.DOLLY_GRIP, roles.GRIP]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_categoryValues, categories.SOUND_AND_VIDEO, [roles.SOUND_MIXER, roles.BOOM_OPERATOR, roles.CABLE_PERSON, roles.VIDEO_OPERATOR]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_categoryValues, categories.ART, [roles.ART_DIRECTOR, roles.ASSISTANT_ART_DIRECTOR, roles.COSTUME_DESIGNER, roles.COSTUMER, roles.HAIRSTYLIST, roles.LEAD_PERSON, roles.MAKEUP_ARTIST, roles.MAKEUP_EFFECTS, roles.PRODUCTION_DESIGNER, roles.PROPERTY_MASTER, roles.SET_DECORATOR, roles.SET_DESIGNER, roles.SWING_GANG]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_categoryValues, categories.SPECIALIZED, [roles.ANIMAL_TRAINER, roles.CHOREOGRAPHER, roles.SPECIAL_EFFECTS, roles.STUNT_COORDINATOR, roles.TECHNICAL_ADVISOR]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_categoryValues, categories.POST_PRODUCTION, [roles.EDITOR, roles.ASSISTANT_EDITOR, roles.SOUND_EDITOR, roles.DIGITAL_EFFECTS, roles.ORIGINAL_MUSIC_COMPOSER]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_categoryValues, categories.ANIMATION, [roles.ANIMATOR]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_categoryValues, categories.REPRESENTATION, [roles.AGENT, roles.MANAGER, roles.PUBLICIST]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_categoryValues, categories.PRINT_TRAFFIC, [roles.PRINT_SHIPPER, roles.PRINT_RETURN, roles.PREVIEW_RETURN]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_categoryValues, categories.ACADEMIC, [roles.ACADEMIC_ADVISOR, roles.SCHOOL_ADMINISTRATOR]), _categoryValues);

/***/ }),
/* 1198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return genres; });
/* unused harmony export popular */
var genres = {
  ACTION: 'action',
  ADVENTURE: 'adventure',
  ANIMATION: 'animation',
  AFRICAN: 'african',
  AFRICAN_AMERICAN: 'african-american',
  ASIAN: 'asian',
  ASIAN_AMERICAN: 'asian-american',
  BLACK: 'black',
  BUDDHIST: 'buddhist',
  BIOGRAPHY: 'biography',
  CHILDREN: 'children',
  CHRISTIAN: 'christian',
  COMEDY: 'comedy',
  CRIME: 'crime',
  DIY: 'diy',
  DEVELOPING_NATIONS: 'developing-nations',
  DISABILITY_CULTURE: 'disability-culture',
  DOCUMENTARY: 'documentary',
  DRAMA: 'drama',
  EDUCATION: 'education',
  FAMILY: 'family',
  FANTASY: 'fantasy',
  FILM_NOIR: 'film-noir',
  GAME_SHOW: 'game-show',
  HISPANIC: 'hispanic',
  HISTORY: 'history',
  HORROR: 'horror',
  INSTRUCTIONAL: 'instructional',
  ISLAMIC: 'islamic',
  JEWISH: 'jewish',
  LGBTQ: 'lgbtq',
  LATINO: 'latino',
  MATURE_ADULT: 'mature-adult',
  MUSIC: 'music',
  MUSICAL: 'musical',
  MYSTERY: 'mystery',
  NEWS: 'news',
  NATIVE_AMERICAN: 'native-american',
  NATIVE_ABORIGINAL_PEOPLE: 'native-aboriginal-people',
  PERSONAL: 'personal',
  REALITY_TV: 'reality-tv',
  ROMANCE: 'romance',
  SCI_FI: 'sci-fi',
  SENIOR_AGING: 'senior-aging',
  SPORT: 'sport',
  STUDENT: 'student',
  TALK_SHOW: 'talk-show',
  THRILLER: 'thriller',
  WAR: 'war',
  WESTERN: 'western',
  WOMEN: 'women',
  YOUTH_TEEN: 'youth-teen'
};

/* harmony default export */ __webpack_exports__["b"] = (_.values(genres));

var popular = [genres.ACTION, genres.ADVENTURE, genres.ANIMATION, genres.BIOGRAPHY, genres.CHILDREN, genres.COMEDY, genres.CRIME, genres.INSTRUCTIONAL, genres.DOCUMENTARY, genres.DRAMA, genres.EDUCATION, genres.FAMILY, genres.FANTASY, genres.HISTORY, genres.HORROR, genres.MUSIC, genres.MUSICAL, genres.MYSTERY, genres.NEWS, genres.PERSONAL, genres.REALITY_TV, genres.ROMANCE, genres.SCI_FI, genres.SPORT, genres.TALK_SHOW, genres.THRILLER, genres.WAR, genres.WESTERN];

/***/ }),
/* 1199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COLLECTOR_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return QUERY_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return QUERY_TOP_SERVICE; });
var COLLECTOR_SERVICE = '/collector/rest/collect-js';
var QUERY_SERVICE = '/billing/counters/queryservice/query';
var QUERY_TOP_SERVICE = '/billing/counters/topservice/query';

/***/ }),
/* 1200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NAMES; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_utils_wix_sdk__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_redux_helpers_create_async_actions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_redux_helpers_normalized__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_utils_adapters_vod__ = __webpack_require__(34);









var ACTIONS = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_redux_helpers_create_async_actions__["a" /* default */])('SERVER.CHANNEL.PAYMENT');
var NAMES = ACTIONS.NAMES;
var START = ACTIONS.START,
    SUCCESS = ACTIONS.SUCCESS,
    FAIL = ACTIONS.FAIL;


/* harmony default export */ __webpack_exports__["a"] = (function (id) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return function (dispatch, getState) {

    var state = getState();

    var items = state.channelVideos.ids;

    options = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
      instance: __WEBPACK_IMPORTED_MODULE_3_shared_utils_wix_sdk__["a" /* default */].Utils.getInstance()
    }, options, {
      items: items
    });

    var params = { id: id, options: options };
    dispatch(START(params));

    return __WEBPACK_IMPORTED_MODULE_6_shared_utils_adapters_vod__["a" /* default */].list.getPaymentInfo(id, options).then(function (response) {
      var items = _.get(response, 'data.items', []);

      if (!items.length) {
        dispatch(SUCCESS(params, response));
        return response;
      }

      var _$partition = _.partition(items, function (item) {
        return !item.itemId;
      }),
          _$partition2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_$partition, 2),
          channelData = _$partition2[0],
          videoDataList = _$partition2[1];

      var channel = _.get(channelData, '[0]');
      var videos = _.map(videoDataList, function (video) {
        return _.pick(video, 'dgsInfo', 'itemId', 'listId');
      });

      var normalizeChannel = {};

      if (channel) {
        normalizeChannel = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_shared_redux_helpers_normalized__["a" /* normalizePaymentInfoChannel */])(_.pick(channel, 'dgsInfo', 'listId')));
      }

      response = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, response, {
        data: _.merge({}, normalizeChannel, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_shared_redux_helpers_normalized__["b" /* normalizeArrayOfPaymentInfoVideos */])(videos))
      });

      dispatch(SUCCESS(params, response));
      return response;
    }, function (reason) {
      var meta = { analytics: { type: 'error', name: 'shared.channel.payment.get' } };

      if (_.isError(reason)) {
        dispatch(FAIL(reason, null, meta));
      } else {
        dispatch(FAIL(params, reason, meta));
      }

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(reason);
    });
  };
});

/***/ }),
/* 1201 */,
/* 1202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = openTab;
/* harmony export (immutable) */ __webpack_exports__["b"] = openBlankTab;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

var DEFAULT_PARAMS = {
  toolbar: true,
  location: true,
  directories: false,
  status: false,
  menubar: false,
  scrollbars: true,
  resizable: false,
  copyhistory: false,
  width: 0,
  height: 0,
  top: 0,
  left: 0
};

function buildParams(params) {
  return _(params).map(function (value, key) {
    if (value === true) {
      value = 'yes';
    } else if (value === false) {
      value = 'no';
    }

    return key + '=' + value;
  }).join(',');
}

function openTab(url) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '_blank';

  params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, DEFAULT_PARAMS, params);

  var _params = buildParams(params);

  var tab = window.open(url, name, _params);

  if (tab) {
    if (tab.moveTo) {
      tab.moveTo(params.left, params.top);
    }

    tab.focus();
  }
}

function openBlankTab(url) {
  window.open(url, '_blank');
}

/***/ }),
/* 1203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseOverlay; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_utils_deal_info_helpers__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_default_settings__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_widget_utils_not_for_preview__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_utils_open_overlay__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_widget_utils_overlay_buttons_utils__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_utils_bi_video_overlay_events_params__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_widget_components_preview_prompt_preview_prompt__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_widget_ui_selectors_video_access__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_widget_components_overlay_texts_video_play_button_text__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_widget_components_overlay_texts_video_sign_in_to_watch_button_text__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_widget_components_overlay_texts_video_subscribe_button_text__ = __webpack_require__(1259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_widget_components_overlay_texts_channel_play_button_text__ = __webpack_require__(1258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_widget_components_overlay_texts_channel_sign_in_to_watch_button_text__ = __webpack_require__(1544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_widget_components_overlay_texts_channel_subscribe_button_text__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_widget_components_overlay_texts_channel_open_video_without_preview_button_text__ = __webpack_require__(1543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_widget_components_overlay_texts_purchase_button_text__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__title_title__ = __webpack_require__(1547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_shared_translations_overlay_common_translations__ = __webpack_require__(134);







var _desc, _value, _class, _class2, _temp2;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}



























var BaseOverlay = (_class = (_temp2 = _class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(BaseOverlay, _React$Component);

  function BaseOverlay() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, BaseOverlay);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = BaseOverlay.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(BaseOverlay)).call.apply(_ref, [this].concat(args))), _this), _this.clampOptions = {
      lineClamp: 2
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(BaseOverlay, [{
    key: 'sendPlayButtonBI',
    value: function sendPlayButtonBI() {
      var _props = this.props,
          channelData = _props.channelData,
          videoItem = _props.videoItem,
          biEvent = _props.biEvent,
          currentSiteUser = _props.currentSiteUser;

      if (this.isChannelCoverView) {
        var button = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_widget_ui_selectors_video_access__["b" /* canAccessFullVideo */])(channelData, videoItem, currentSiteUser) ? 'startWatching' : 'watchPreview';

        sendChCoverButtonClickedBI(this.props, button);
      } else {
        sendVideoButtonClickedBI(this.props, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_shared_utils_bi_video_overlay_events_params__["b" /* getPlayButtonTypeString */])(channelData, videoItem, currentSiteUser));
      }

      var id = videoItem.id,
          videoSource = videoItem.videoSource;

      biEvent('widget.vid.clicked', {
        channelID: channelData.id,
        videoID: id,
        videoType: videoSource
      });
    }

    // TODO: this component should call prop onPlayClick without additional logic. Move to view

  }, {
    key: 'playSelectedVideo',
    value: function playSelectedVideo(event) {
      event.preventDefault();
      event.stopPropagation();

      var _props2 = this.props,
          playSelectedVideo = _props2.playSelectedVideo,
          videoItem = _props2.videoItem;


      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_widget_components_preview_prompt_preview_prompt__["b" /* isPreviewMode */])() && videoItem.memberOnly) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_widget_components_preview_prompt_preview_prompt__["a" /* openPreviewPrompt */])();
        return;
      }

      this.sendPlayButtonBI();

      playSelectedVideo(videoItem);
    }
  }, {
    key: 'playNextVideo',
    value: function playNextVideo(event) {
      event.preventDefault();
      event.stopPropagation();

      this.props.playNextVideo();
    }
  }, {
    key: 'sendSubscribeClickedBI',
    value: function sendSubscribeClickedBI() {
      sendChCoverButtonClickedBI(this.props, 'subscribe');
    }
  }, {
    key: 'openSubscription',
    value: function openSubscription(event) {
      event.preventDefault();
      event.stopPropagation();
      this.sendSubscribeClickedBI();

      var _props3 = this.props,
          channelData = _props3.channelData,
          biEvent = _props3.biEvent;


      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_shared_utils_open_overlay__["c" /* openFullScreenSubscribeOverlay */])(channelData.id, function () {
        biEvent('widget.subscriptionPopUp.Completed', { result: 'canceled', errorMsg: '' });
      });
    }
  }, {
    key: 'openPurchase',
    value: function openPurchase(event) {
      event.preventDefault();
      event.stopPropagation();
      this.sendOpenPurchaseBI();
      var _props4 = this.props,
          channelData = _props4.channelData,
          videoItem = _props4.videoItem;


      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_shared_utils_open_overlay__["d" /* openFullScreenPurchaseOverlay */])(channelData.id, videoItem.id);
    }
  }, {
    key: 'sendOpenPurchaseBI',
    value: function sendOpenPurchaseBI() {
      sendVideoButtonClickedBI(this.props, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_widget_utils_overlay_buttons_utils__["d" /* getBuyButtonDisplayTypeWhenInOverlay */])(this.props));
    }
  }, {
    key: 'getOpacityStyles',
    value: function getOpacityStyles() {
      var appSettings = this.props.appSettings;

      var opacityPercents = _.isNumber(appSettings.numbers.mainItemOverlayOpacity) ? appSettings.numbers.mainItemOverlayOpacity : __WEBPACK_IMPORTED_MODULE_8_default_settings__["c" /* default */].numbers.mainItemOverlayOpacity;
      var opacity = _.round(opacityPercents / 100, 2);

      return {
        backgroundColor: 'rgba(0,0,0,' + opacity + ')'
      };
    }
  }, {
    key: 'subscriptionPriceInfo',
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_7_shared_utils_deal_info_helpers__["a" /* getSubscriptionPriceInfo */](this.props.channelData.dealInfo);
    }
  }, {
    key: 'minVideoPriceInfo',
    get: function get() {
      var videoItem = this.props.videoItem;

      if (!videoItem) {
        return null;
      }
      return __WEBPACK_IMPORTED_MODULE_7_shared_utils_deal_info_helpers__["d" /* getMinPriceInfo */](videoItem.dealInfo);
    }
  }, {
    key: 'saleDealInfo',
    get: function get() {
      var videoItem = this.props.videoItem;

      if (!videoItem) {
        return null;
      }
      return __WEBPACK_IMPORTED_MODULE_7_shared_utils_deal_info_helpers__["b" /* getSalePriceInfo */](videoItem.dealInfo);
    }
  }, {
    key: 'rentDealInfo',
    get: function get() {
      var videoItem = this.props.videoItem;

      if (!videoItem) {
        return null;
      }
      return __WEBPACK_IMPORTED_MODULE_7_shared_utils_deal_info_helpers__["c" /* getRentPriceInfo */](videoItem.dealInfo);
    }
  }, {
    key: 'hasNextVideo',
    get: function get() {
      var nextVideoId = this.props.nextVideoId;

      return Boolean(nextVideoId);
    }
  }, {
    key: 'titleText',
    get: function get() {
      var _props5 = this.props,
          channelData = _props5.channelData,
          videoItem = _props5.videoItem;

      return this.isChannelCoverView ? channelData.title : videoItem.title;
    }
  }, {
    key: 'publisherText',
    get: function get() {
      if (this.isChannelCoverView) {
        return null;
      }

      var videoItem = this.props.videoItem;

      return videoItem.publisher;
    }
  }, {
    key: 'shouldShowTitle',
    get: function get() {
      return this.props.canShowMainItemTitle;
    }
  }, {
    key: 'title',
    get: function get() {
      if (!this.shouldShowTitle) {
        return null;
      }

      var titleText = this.titleText;

      if (!titleText) {
        return null;
      }

      return React.createElement(__WEBPACK_IMPORTED_MODULE_24__title_title__["a" /* default */], { styleName: 'title',
        text: titleText,
        clampOptions: this.clampOptions });
    }
  }, {
    key: 'publisher',
    get: function get() {
      if (!this.props.canShowMainItemPublisher) {
        return null;
      }

      var publisherText = this.publisherText;

      if (!publisherText) {
        return null;
      }

      return React.createElement(
        'div',
        { styleName: 'publisher',
          className: 'qa-widget-overlay-publisher' },
        publisherText
      );
    }
  }, {
    key: 'isChannelCoverView',
    get: function get() {
      var _props6 = this.props,
          appSettings = _props6.appSettings,
          showChannelCover = _props6.showChannelCover;
      // Todo: move to connect

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_widget_utils_overlay_buttons_utils__["a" /* shouldShowChannelCover */])(appSettings, showChannelCover);
    }
  }, {
    key: 'buttonTextProps',
    get: function get() {
      var _props7 = this.props,
          channelData = _props7.channelData,
          videoItem = _props7.videoItem,
          currentSiteUser = _props7.currentSiteUser;


      return {
        channel: channelData,
        video: videoItem,
        currentSiteUser: currentSiteUser
      };
    }
  }, {
    key: 'playButtonText',
    get: function get() {
      var props = this.buttonTextProps;

      // Todo: move each button type to separate methods and use at views
      if (this.isChannelCoverView) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19_widget_components_overlay_texts_channel_play_button_text__["a" /* default */])(props) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_widget_components_overlay_texts_channel_sign_in_to_watch_button_text__["a" /* default */])(props) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_widget_components_overlay_texts_channel_open_video_without_preview_button_text__["a" /* default */])(props);
      }
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_widget_components_overlay_texts_video_play_button_text__["a" /* default */])(props) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17_widget_components_overlay_texts_video_sign_in_to_watch_button_text__["a" /* default */])(props);
    }
  }, {
    key: 'playNextButtonText',
    get: function get() {
      var ended = this.props.ended;


      if (ended && !this.minVideoPriceInfo && this.hasNextVideo) {
        return React.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */], __WEBPACK_IMPORTED_MODULE_25_shared_translations_overlay_common_translations__["a" /* default */].nextVideo);
      }

      return null;
    }
  }, {
    key: 'subscribeButtonText',
    get: function get() {
      // Todo: move each button type to separate methods and use at views

      var props = this.buttonTextProps;
      if (this.isChannelCoverView) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_widget_components_overlay_texts_channel_subscribe_button_text__["b" /* default */])(props);
      }

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18_widget_components_overlay_texts_video_subscribe_button_text__["a" /* default */])(props);
    }
  }, {
    key: 'purchaseButtonText',
    get: function get() {
      if (this.isChannelCoverView) {
        return null;
      }
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23_widget_components_overlay_texts_purchase_button_text__["a" /* default */])(this.buttonTextProps);
    }
  }]);

  return BaseOverlay;
}(React.Component), _class2.propTypes = {
  channelData: React.PropTypes.object,
  videoItem: React.PropTypes.object,
  appSettings: React.PropTypes.object.isRequired,
  currentSiteUser: React.PropTypes.object,
  showChannelCover: React.PropTypes.bool,
  beenPlayed: React.PropTypes.bool,
  ended: React.PropTypes.bool,
  className: React.PropTypes.string,
  onPlayClick: React.PropTypes.func,
  playSelectedVideo: React.PropTypes.func,
  playVideoItem: React.PropTypes.func, // comes dome player
  playNextVideo: React.PropTypes.func,
  nextVideoId: React.PropTypes.string,
  biEvent: React.PropTypes.func,
  canShowMainItemPublisher: React.PropTypes.bool,
  canShowMainItemTitle: React.PropTypes.bool
}, _class2.defaultProps = {
  beenPlayed: false,
  ended: false,
  showChannelCover: false,
  onPlayClick: _.noop,
  playSelectedVideo: _.noop,
  playNextVideo: _.noop
}, _temp2), (_applyDecoratedDescriptor(_class.prototype, 'playSelectedVideo', [__WEBPACK_IMPORTED_MODULE_9_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'playSelectedVideo'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'playNextVideo', [__WEBPACK_IMPORTED_MODULE_9_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'playNextVideo'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'openSubscription', [__WEBPACK_IMPORTED_MODULE_9_core_decorators_lib_autobind___default.a, __WEBPACK_IMPORTED_MODULE_10_widget_utils_not_for_preview__["a" /* notForPreview */]], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'openSubscription'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'openPurchase', [__WEBPACK_IMPORTED_MODULE_9_core_decorators_lib_autobind___default.a, __WEBPACK_IMPORTED_MODULE_10_widget_utils_not_for_preview__["a" /* notForPreview */]], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'openPurchase'), _class.prototype)), _class);

// FIXME: all components should connect BE for that, it's really not expected


function sendChCoverButtonClickedBI(props, button) {
  var biEvent = props.biEvent;


  biEvent('widget.chCover.btn.clicked', { button: button });
}

function sendVideoButtonClickedBI(props, button) {
  var videoItem = props.videoItem,
      biEvent = props.biEvent;


  biEvent('widget.VidSelected.btn.clicked', {
    button: button,
    buttonType: 'main',
    videoID: videoItem.id
  });
}

/***/ }),
/* 1204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  ID: 'wix-vod-payment',
  TYPES: {
    SALE: 'sale',
    RENT: 'rent',
    SUBSCRIPTION: 'subscription',
    SUBSCRIPTION_CANCEL: 'subscription-cancel'
  }
});

/***/ }),
/* 1205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  PENDING: 'pending',
  FAILED: 'failed',
  RESOLVED: 'resolved'
});

/***/ }),
/* 1206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChannelVideoLoader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_selectors_videos__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_redux_server_actions_channel_video_get__ = __webpack_require__(1573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_data_components_data_loader__ = __webpack_require__(236);








var _dec, _class, _desc, _value, _class2, _class3, _temp2;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}









var ChannelVideoLoader = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_redux__["a" /* connect */])(function (state, ownProps) {
  return {
    channelVideoData: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_shared_selectors_videos__["b" /* getVideoById */])(state, ownProps.videoId),
    isFetching: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_shared_selectors_videos__["c" /* isFetching */])(state)
  };
}, {
  getVideo: __WEBPACK_IMPORTED_MODULE_10_shared_redux_server_actions_channel_video_get__["a" /* getPublic */]
}), _dec(_class = (_class2 = (_temp2 = _class3 = function (_DataLoader) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(ChannelVideoLoader, _DataLoader);

  function ChannelVideoLoader() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ChannelVideoLoader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = ChannelVideoLoader.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(ChannelVideoLoader)).call.apply(_ref, [this].concat(args))), _this), _this.dependencies = ['channelId', 'videoId'], _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(ChannelVideoLoader, [{
    key: 'loadData',
    value: function loadData(forceLoad) {
      var _props = this.props,
          channelId = _props.channelId,
          videoId = _props.videoId,
          getVideo = _props.getVideo,
          channelVideoData = _props.channelVideoData;


      if (!channelId || !videoId) {
        return;
      }

      if (channelVideoData && !forceLoad) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(channelVideoData);
      }

      return getVideo(channelId, videoId);
    }
  }, {
    key: 'forceFetch',
    value: function forceFetch() {
      this.loadDataDebounced(true);
    }
  }, {
    key: 'childProps',
    get: function get() {
      var _props2 = this.props,
          channelVideoData = _props2.channelVideoData,
          isFetching = _props2.isFetching;

      return {
        channelVideoData: channelVideoData,
        channelVideo: { isFetching: isFetching, fetch: this.forceFetch }
      };
    }
  }]);

  return ChannelVideoLoader;
}(__WEBPACK_IMPORTED_MODULE_11_shared_data_components_data_loader__["a" /* default */]), _class3.displayName = 'ChannelVideoLoader', _class3.propTypes = {
  channelVideoData: React.PropTypes.object,
  getVideo: React.PropTypes.func,
  channelId: React.PropTypes.string,
  videoId: React.PropTypes.string,
  lazyChannelVideos: React.PropTypes.object
}, _temp2), (_applyDecoratedDescriptor(_class2.prototype, 'forceFetch', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'forceFetch'), _class2.prototype)), _class2)) || _class);


/***/ }),
/* 1207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MOBILE_WIDGET_DATA_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MOBILE_SEARCH_DATA_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MOBILE_OVERLAY_DATA_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LazyChannelVideosLoader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_multireducer__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_multireducer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_multireducer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_selectors_videos__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_selectors_channel_videos__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_widget_redux_client_actions_channel_videos_lazy_load__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_data_components_data_loader__ = __webpack_require__(236);







var _dec, _class, _class2, _temp2;











var MOBILE_WIDGET_DATA_KEY = 'mobileWidget';
var MOBILE_SEARCH_DATA_KEY = 'mobileSearch';
var MOBILE_OVERLAY_DATA_KEY = 'mobileOverlay';

var LazyChannelVideosLoader = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["a" /* connect */])(function (state, _ref) {
  var as = _ref.as;
  return {
    videoByIds: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_shared_selectors_videos__["e" /* getVideosByIds */])(state, state.lazyVideoLists[as].videoIds),
    ids: state.lazyVideoLists[as].videoIds,
    nextVideosCursor: state.lazyVideoLists[as].nextVideosCursor,
    category: state.lazyVideoLists[as].category,
    isFetching: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_shared_selectors_channel_videos__["a" /* isFetching */])(state)
  };
}, function (dispatch, _ref2) {
  var as = _ref2.as;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_multireducer__["bindActionCreators"])({
    loadFirstPage: __WEBPACK_IMPORTED_MODULE_10_widget_redux_client_actions_channel_videos_lazy_load__["a" /* loadFirstPage */],
    loadMore: __WEBPACK_IMPORTED_MODULE_10_widget_redux_client_actions_channel_videos_lazy_load__["b" /* loadMore */]
  }, dispatch, as);
}), _dec(_class = (_temp2 = _class2 = function (_DataLoader) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(LazyChannelVideosLoader, _DataLoader);

  function LazyChannelVideosLoader() {
    var _ref3;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, LazyChannelVideosLoader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref3 = LazyChannelVideosLoader.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(LazyChannelVideosLoader)).call.apply(_ref3, [this].concat(args))), _this), _this.dependencies = ['channelId', 'category', 'tag', 'query'], _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(LazyChannelVideosLoader, [{
    key: 'loadData',
    value: function loadData() {
      var _props = this.props,
          channelId = _props.channelId,
          loadFirstPage = _props.loadFirstPage,
          numberToLoadMore = _props.numberToLoadMore,
          category = _props.category,
          tag = _props.tag,
          query = _props.query;


      if (!channelId) {
        return;
      }

      // TODO: move getChannel code here
      return loadFirstPage(numberToLoadMore, {
        category: category,
        tag: tag,
        query: query
      });
    }
  }, {
    key: 'childProps',
    get: function get() {
      var _props2 = this.props,
          videoByIds = _props2.videoByIds,
          ids = _props2.ids,
          isFetching = _props2.isFetching,
          loadMore = _props2.loadMore,
          numberToLoadMore = _props2.numberToLoadMore,
          nextVideosCursor = _props2.nextVideosCursor;

      // TODO: move this logic to view components

      var loadMoreWrapped = function loadMoreWrapped(itemsShown) {
        var threshold = numberToLoadMore / 2;
        if (nextVideosCursor && _.size(ids) - itemsShown < threshold) {
          return loadMore(numberToLoadMore, nextVideosCursor);
        }
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      };
      var loadMoreWrappedNoSimultaneous = this.onceAtTime(loadMoreWrapped);

      return {
        videoByIds: videoByIds,
        lazyChannelVideos: {
          ids: ids,
          isFetching: isFetching,
          fetch: this.loadDataDebounced,
          //TODO: use actions to call loadMore
          loadMore: loadMoreWrappedNoSimultaneous
        }
      };
    }
  }]);

  return LazyChannelVideosLoader;
}(__WEBPACK_IMPORTED_MODULE_11_shared_data_components_data_loader__["a" /* default */]), _class2.displayName = 'LazyChannelVideosLoader', _class2.propTypes = {
  loadFirstPage: React.PropTypes.func,
  numberToLoadMore: React.PropTypes.number,
  nextVideosCursor: React.PropTypes.string,
  category: React.PropTypes.string,
  tag: React.PropTypes.string,
  query: React.PropTypes.string,
  channelId: React.PropTypes.string
}, _class2.defaultProps = {
  numberToLoadMore: 8
}, _temp2)) || _class);


/***/ }),
/* 1208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PaymentInfoLoader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_selectors_app_settings__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_redux_server_actions_channel_payment__ = __webpack_require__(1200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_data_components_data_loader__ = __webpack_require__(236);







var _dec, _class, _class2, _temp2;









var PaymentInfoLoader = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["a" /* connect */])(function (state) {
  return {
    appSettings: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_shared_selectors_app_settings__["a" /* getAllSettings */])(state)
  };
}, {
  getPaymentInfo: __WEBPACK_IMPORTED_MODULE_8_shared_redux_server_actions_channel_payment__["a" /* default */]
}), _dec(_class = (_temp2 = _class2 = function (_DataLoader) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(PaymentInfoLoader, _DataLoader);

  function PaymentInfoLoader() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, PaymentInfoLoader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = PaymentInfoLoader.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(PaymentInfoLoader)).call.apply(_ref, [this].concat(args))), _this), _this.dependencies = ['channelId'], _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(PaymentInfoLoader, [{
    key: 'loadData',
    value: function loadData() {
      var _props = this.props,
          channelId = _props.channelId,
          getPaymentInfo = _props.getPaymentInfo,
          instance = _props.appSettings.instance;


      if (!channelId) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject();
      }

      return getPaymentInfo(channelId, {
        instance: instance
      });
    }
  }, {
    key: 'childProps',
    get: function get() {
      var isFetching = this.state.isFetching;

      return { channelPaymentData: { isFetching: isFetching, fetch: this.loadDataDebounced } };
    }
  }]);

  return PaymentInfoLoader;
}(__WEBPACK_IMPORTED_MODULE_9_shared_data_components_data_loader__["a" /* default */]), _class2.displayName = 'PaymentInfoLoader', _class2.propTypes = {
  getPaymentInfo: React.PropTypes.func,
  appSettings: React.PropTypes.object,
  channelId: React.PropTypes.string
}, _temp2)) || _class);


/***/ }),
/* 1209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NAMES; });
/* harmony export (immutable) */ __webpack_exports__["e"] = goForward;
/* harmony export (immutable) */ __webpack_exports__["d"] = goBack;
/* harmony export (immutable) */ __webpack_exports__["c"] = toFirstPage;
/* harmony export (immutable) */ __webpack_exports__["b"] = loadFirstPage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_redux_server_actions_channel_videos_list__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_widget_data_components_paginated_channel_videos__ = __webpack_require__(370);






var NAMES = {
  RESET: 'CLIENT.CHANNEL.PAGINATED_VIDEOS.RESET',
  UPDATE: 'CLIENT.CHANNEL.PAGINATED_VIDEOS.UPDATE'
};

var RESET = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(NAMES.RESET);
var UPDATE = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(NAMES.UPDATE);

var PRELOAD_PAGES = 2;

var currentUIPage = 0;
var channelId = null;
var nextPageOptions = {
  paging: {
    size: null,
    cursor: null
  },
  query: null
};

function saveNextPageCursor(response) {
  if (response) {
    nextPageOptions.paging.cursor = response.paging.cursor;
  }
}

function goForward() {
  return function (dispatch, getState) {
    var loadedUIPagesCount = getState().lazyVideoLists[__WEBPACK_IMPORTED_MODULE_2_widget_data_components_paginated_channel_videos__["a" /* DATA_KEY */]].loadedUIPagesCount;


    if (currentUIPage === loadedUIPagesCount - 1) {
      return;
    }

    currentUIPage += 1;

    if (loadedUIPagesCount - currentUIPage < PRELOAD_PAGES + 1 && nextPageOptions.paging.cursor) {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_redux_server_actions_channel_videos_list__["a" /* listPublic */])(channelId, nextPageOptions)).then(saveNextPageCursor);
    }

    dispatch(UPDATE({ currentUIPage: currentUIPage }));
  };
}

function goBack() {
  return function (dispatch) {
    if (currentUIPage === 0) {
      return;
    }

    currentUIPage -= 1;
    dispatch(UPDATE({ currentUIPage: currentUIPage }));
  };
}
function toFirstPage() {
  return function (dispatch) {
    if (currentUIPage === 0) {
      return;
    }
    currentUIPage = 0;
    dispatch(UPDATE({ currentUIPage: currentUIPage }));
  };
}

function loadFirstPage(currentChannelId, _ref) {
  var perUIPage = _ref.perUIPage,
      query = _ref.query,
      tag = _ref.tag,
      category = _ref.category;

  return function (dispatch) {
    currentUIPage = 0;
    channelId = currentChannelId;
    dispatch(RESET({ currentUIPage: currentUIPage, perUIPage: perUIPage }));

    nextPageOptions = {
      paging: {
        size: perUIPage * (PRELOAD_PAGES + 1),
        cursor: null
      },
      query: query,
      tag: tag,
      category: category
    };

    return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_redux_server_actions_channel_videos_list__["a" /* listPublic */])(channelId, nextPageOptions)).then(saveNextPageCursor);
  };
}

/***/ }),
/* 1210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NAMES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clearVideoUrlsCacheForAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return clearVideoUrlsCacheForItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);


var NAMES = {
  ALL: 'CLIENT.VIDEO_URLS.CLEAR_ALL',
  FOR_ITEM: 'CLIENT.VIDEO_URLS.CLEAR_FOR_ITEM'
};

var clearVideoUrlsCacheForAll = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(NAMES.ALL);
var clearVideoUrlsCacheForItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(NAMES.FOR_ITEM);

/***/ }),
/* 1211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NAMES; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_redux_helpers_create_async_actions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_utils_wix_sdk__ = __webpack_require__(25);



var ACTIONS = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_redux_helpers_create_async_actions__["a" /* default */])('SERVER.USERS.CURRENT-SITE-USER');
var NAMES = ACTIONS.NAMES;
var START = ACTIONS.START,
    SUCCESS = ACTIONS.SUCCESS,
    FAIL = ACTIONS.FAIL;


/* harmony default export */ __webpack_exports__["a"] = (function () {
  return function (dispatch) {
    dispatch(START());

    return __WEBPACK_IMPORTED_MODULE_1_shared_utils_wix_sdk__["a" /* default */].currentMember().then(function (currentUserData) {
      dispatch(SUCCESS({}, currentUserData));
      return currentUserData;
    }, function (response) {
      dispatch(FAIL({}, response));
    });
  };
});

/***/ }),
/* 1212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NAMES */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_settings__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_utils_wix_sdk__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_utils_http__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_constants_stats_endpoints_url__ = __webpack_require__(1199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_constants_stats_events__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_redux_helpers_create_async_actions__ = __webpack_require__(26);











var statsCollector = __WEBPACK_IMPORTED_MODULE_1_shared_settings__["a" /* default */].hosts.statsCollector;

var reportUrl = '' + statsCollector + __WEBPACK_IMPORTED_MODULE_4_shared_constants_stats_endpoints_url__["a" /* COLLECTOR_SERVICE */];

var ACTIONS = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_shared_redux_helpers_create_async_actions__["a" /* default */])('SERVER.STATS.REPORT');
var NAMES = ACTIONS.NAMES;
var START = ACTIONS.START,
    SUCCESS = ACTIONS.SUCCESS,
    FAIL = ACTIONS.FAIL;


/* harmony default export */ __webpack_exports__["a"] = (function (event, eventData) {
  return function (dispatch) {
    dispatch(START());

    var analytics = { analytics: { type: 'error', name: 'widget.stats.report' } };

    return __WEBPACK_IMPORTED_MODULE_2_shared_utils_wix_sdk__["a" /* default */].getCtToken().then(function (ctToken) {
      var data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_shared_constants_stats_events__["b" /* buildReport */])(event, eventData);

      return __WEBPACK_IMPORTED_MODULE_3_shared_utils_http__["a" /* default */].post(reportUrl, {
        params: {
          ctToken: ctToken
        },
        options: {
          headers: {
            'Content-Type': 'application/json'
          }
        },
        data: data
      }).then(function (result) {
        if (!_.get(result, 'data.success')) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(result);
        }

        dispatch(SUCCESS(data, result));
      }).catch(function (error) {
        dispatch(FAIL(data, error, analytics));
      });
    }).catch(function () {
      dispatch(FAIL({ event: event, eventData: eventData }, null, analytics));
    });
  };
});

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Copyright Marc J. Schmidt. See the LICENSE file at the top-level
 * directory of this distribution and at
 * https://github.com/marcj/css-element-queries/blob/master/LICENSE.
 */
;
(function (root, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports === "object") {
        module.exports = factory();
    } else {
        root.ResizeSensor = factory();
    }
}(this, function () {

    //Make sure it does not throw in a SSR (Server Side Rendering) situation
    if (typeof window === "undefined") {
        return null;
    }
    // Only used for the dirty checking, so the event callback count is limted to max 1 call per fps per sensor.
    // In combination with the event based resize sensor this saves cpu time, because the sensor is too fast and
    // would generate too many unnecessary events.
    var requestAnimationFrame = window.requestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        function (fn) {
            return window.setTimeout(fn, 20);
        };

    /**
     * Iterate over each of the provided element(s).
     *
     * @param {HTMLElement|HTMLElement[]} elements
     * @param {Function}                  callback
     */
    function forEachElement(elements, callback){
        var elementsType = Object.prototype.toString.call(elements);
        var isCollectionTyped = ('[object Array]' === elementsType
            || ('[object NodeList]' === elementsType)
            || ('[object HTMLCollection]' === elementsType)
            || ('[object Object]' === elementsType)
            || ('undefined' !== typeof jQuery && elements instanceof jQuery) //jquery
            || ('undefined' !== typeof Elements && elements instanceof Elements) //mootools
        );
        var i = 0, j = elements.length;
        if (isCollectionTyped) {
            for (; i < j; i++) {
                callback(elements[i]);
            }
        } else {
            callback(elements);
        }
    }

    /**
     * Class for dimension change detection.
     *
     * @param {Element|Element[]|Elements|jQuery} element
     * @param {Function} callback
     *
     * @constructor
     */
    var ResizeSensor = function(element, callback) {
        /**
         *
         * @constructor
         */
        function EventQueue() {
            var q = [];
            this.add = function(ev) {
                q.push(ev);
            };

            var i, j;
            this.call = function() {
                for (i = 0, j = q.length; i < j; i++) {
                    q[i].call();
                }
            };

            this.remove = function(ev) {
                var newQueue = [];
                for(i = 0, j = q.length; i < j; i++) {
                    if(q[i] !== ev) newQueue.push(q[i]);
                }
                q = newQueue;
            }

            this.length = function() {
                return q.length;
            }
        }

        /**
         * @param {HTMLElement} element
         * @param {String}      prop
         * @returns {String|Number}
         */
        function getComputedStyle(element, prop) {
            if (element.currentStyle) {
                return element.currentStyle[prop];
            } else if (window.getComputedStyle) {
                return window.getComputedStyle(element, null).getPropertyValue(prop);
            } else {
                return element.style[prop];
            }
        }

        /**
         *
         * @param {HTMLElement} element
         * @param {Function}    resized
         */
        function attachResizeEvent(element, resized) {
            if (!element.resizedAttached) {
                element.resizedAttached = new EventQueue();
                element.resizedAttached.add(resized);
            } else if (element.resizedAttached) {
                element.resizedAttached.add(resized);
                return;
            }

            element.resizeSensor = document.createElement('div');
            element.resizeSensor.className = 'resize-sensor';
            var style = 'position: absolute; left: 0; top: 0; right: 0; bottom: 0; overflow: hidden; z-index: -1; visibility: hidden;';
            var styleChild = 'position: absolute; left: 0; top: 0; transition: 0s;';

            element.resizeSensor.style.cssText = style;
            element.resizeSensor.innerHTML =
                '<div class="resize-sensor-expand" style="' + style + '">' +
                    '<div style="' + styleChild + '"></div>' +
                '</div>' +
                '<div class="resize-sensor-shrink" style="' + style + '">' +
                    '<div style="' + styleChild + ' width: 200%; height: 200%"></div>' +
                '</div>';
            element.appendChild(element.resizeSensor);

            if (getComputedStyle(element, 'position') == 'static') {
                element.style.position = 'relative';
            }

            var expand = element.resizeSensor.childNodes[0];
            var expandChild = expand.childNodes[0];
            var shrink = element.resizeSensor.childNodes[1];
            var dirty, rafId, newWidth, newHeight;
            var lastWidth = element.offsetWidth;
            var lastHeight = element.offsetHeight;

            var reset = function() {
                expandChild.style.width = '100000px';
                expandChild.style.height = '100000px';

                expand.scrollLeft = 100000;
                expand.scrollTop = 100000;

                shrink.scrollLeft = 100000;
                shrink.scrollTop = 100000;
            };

            reset();

            var onResized = function() {
                rafId = 0;

                if (!dirty) return;

                lastWidth = newWidth;
                lastHeight = newHeight;

                if (element.resizedAttached) {
                    element.resizedAttached.call();
                }
            };

            var onScroll = function() {
                newWidth = element.offsetWidth;
                newHeight = element.offsetHeight;
                dirty = newWidth != lastWidth || newHeight != lastHeight;

                if (dirty && !rafId) {
                    rafId = requestAnimationFrame(onResized);
                }

                reset();
            };

            var addEvent = function(el, name, cb) {
                if (el.attachEvent) {
                    el.attachEvent('on' + name, cb);
                } else {
                    el.addEventListener(name, cb);
                }
            };

            addEvent(expand, 'scroll', onScroll);
            addEvent(shrink, 'scroll', onScroll);
        }

        forEachElement(element, function(elem){
            attachResizeEvent(elem, callback);
        });

        this.detach = function(ev) {
            ResizeSensor.detach(element, ev);
        };
    };

    ResizeSensor.detach = function(element, ev) {
        forEachElement(element, function(elem){
            if(elem.resizedAttached && typeof ev == "function"){
                elem.resizedAttached.remove(ev);
                if(elem.resizedAttached.length()) return;
            }
            if (elem.resizeSensor) {
                if (elem.contains(elem.resizeSensor)) {
                    elem.removeChild(elem.resizeSensor);
                }
                delete elem.resizeSensor;
                delete elem.resizedAttached;
            }
        });
    };

    return ResizeSensor;

}));


/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(550),
    isFlattenable = __webpack_require__(1478);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 1215 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var key = '__multireducerKey';

exports.default = key;

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = wrapAction;

var _key = __webpack_require__(1216);

var _key2 = _interopRequireDefault(_key);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function wrapAction(action, reducerKey) {
  return _extends({}, action, {
    meta: _extends({}, action.meta, _defineProperty({}, _key2.default, reducerKey))
  });
}

/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = wrapDispatch;

var _wrapAction = __webpack_require__(1217);

var _wrapAction2 = _interopRequireDefault(_wrapAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function wrapDispatch(dispatch, reducerKey) {
  var wrappedDispatch = function wrappedDispatch(action) {
    var wrappedAction = void 0;
    if (typeof action === 'function') {
      wrappedAction = function wrappedAction(globalDispatch, getState, extraArgument) {
        return action(wrappedDispatch, getState, globalDispatch, reducerKey, extraArgument);
      };
    } else if ((typeof action === 'undefined' ? 'undefined' : _typeof(action)) === 'object') {
      wrappedAction = (0, _wrapAction2.default)(action, reducerKey);
    }
    return dispatch(wrappedAction);
  };

  return wrappedDispatch;
}

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1297);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./modal.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./modal.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1311);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./share.styl", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./share.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.Player = undefined;

var _wrapper = __webpack_require__(1690);

var _wrapper2 = _interopRequireDefault(_wrapper);

var _videoPlayer = __webpack_require__(1223);

var Player = _interopRequireWildcard(_videoPlayer);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Player = Player;
exports.Wrapper = _wrapper2.default;
exports.default = _wrapper2.default;
//# sourceMappingURL=index.js.map


/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DELAYED_REPORT_TYPES = exports.REPORT_REASONS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _video = __webpack_require__(154);

var _video2 = _interopRequireDefault(_video);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var REPORT_REASONS = exports.REPORT_REASONS = {
  LONG_INITIAL_VIDEO_PARTS_LOADING: 'long-initial-video-parts-loading',
  LONG_METADATA_LOADING: 'long-metadata-loading',
  LONG_SEEK_PROCESSING: 'long-seek-processing',
  BUFFER_EMPTY_FOR_CURRENT_SEGMENT: 'buffer-empty-for-current-segment',
  LONG_PLAY_REQUESTED_PROCESSING: 'long-play-requested-processing'
};

var DELAYED_REPORT_TYPES = exports.DELAYED_REPORT_TYPES = {
  INITIAL_VIDEO_PARTS_LOADING: { id: '_initialVideoPartsLoading', timeoutTime: 2000 },
  METADATA_LOADING: { id: '_metadataLoading', timeoutTime: 2000 },
  RUNTIME_LOADING: { id: '_runtimeLoading', timeoutTime: 2000 }
};

var AnomalyBloodhound = function () {
  function AnomalyBloodhound(_ref) {
    var engine = _ref.engine,
        eventEmitter = _ref.eventEmitter,
        config = _ref.config;

    _classCallCheck(this, AnomalyBloodhound);

    this._config = config;
    this._engine = engine;
    this._eventEmitter = eventEmitter;

    this._timeoutContainer = Object.create(null);

    this._bindEvents();
  }

  _createClass(AnomalyBloodhound, [{
    key: '_bindEvents',
    value: function _bindEvents() {
      this._eventEmitter.on(_video2.default.STATE_CHANGED, this._processStateChange, this);
    }
  }, {
    key: '_unbindEvents',
    value: function _unbindEvents() {
      this._eventEmitter.off(_video2.default.STATE_CHANGED, this._processStateChange, this);
    }
  }, {
    key: '_processStateChange',
    value: function _processStateChange(_ref2) {
      var prevState = _ref2.prevState,
          nextState = _ref2.nextState;
      var STATES = this._engine.STATES;


      switch (nextState) {
        case STATES.LOAD_STARTED:
          if (this._engine.getAutoPlay() || this._engine.getPreload() !== 'none') {
            this.startDelayedReport(DELAYED_REPORT_TYPES.METADATA_LOADING, REPORT_REASONS.LONG_METADATA_LOADING);
          }
          break;

        case STATES.METADATA_LOADED:
          if (this.isDelayedReportExist(DELAYED_REPORT_TYPES.METADATA_LOADING)) {
            this.stopDelayedReport(DELAYED_REPORT_TYPES.METADATA_LOADING);

            if (this._engine.getPreload() !== 'metadata') {
              this.startDelayedReport(DELAYED_REPORT_TYPES.INITIAL_VIDEO_PARTS_LOADING, REPORT_REASONS.LONG_INITIAL_VIDEO_PARTS_LOADING);
            }
          }
          break;

        case STATES.READY_TO_PLAY:
          if (this.isDelayedReportExist(DELAYED_REPORT_TYPES.INITIAL_VIDEO_PARTS_LOADING)) {
            this.stopDelayedReport(DELAYED_REPORT_TYPES.INITIAL_VIDEO_PARTS_LOADING);
          }
          if (this.isDelayedReportExist(DELAYED_REPORT_TYPES.RUNTIME_LOADING)) {
            this.stopDelayedReport(DELAYED_REPORT_TYPES.RUNTIME_LOADING);
          }
          break;

        case STATES.SEEK_STARTED:
          if (prevState === STATES.PAUSED) {
            this.startDelayedReport(DELAYED_REPORT_TYPES.RUNTIME_LOADING, REPORT_REASONS.LONG_SEEK_PROCESSING);
          }
          break;

        case STATES.WAITING:
          switch (prevState) {
            case STATES.PLAYING:
              this.reportDebugInfo({ reason: REPORT_REASONS.BUFFER_EMPTY_FOR_CURRENT_SEGMENT });
              break;

            case STATES.PLAY_REQUESTED:
              if (!this.isDelayedReportExist(DELAYED_REPORT_TYPES.RUNTIME_LOADING)) {
                this.startDelayedReport(DELAYED_REPORT_TYPES.RUNTIME_LOADING, REPORT_REASONS.LONG_PLAY_REQUESTED_PROCESSING);
              }
              break;

            default:
              break;
          }
          break;

        default:
          break;
      }
    }
  }, {
    key: 'isDelayedReportExist',
    value: function isDelayedReportExist(type) {
      return Boolean(this._timeoutContainer[type.id]);
    }
  }, {
    key: 'startDelayedReport',
    value: function startDelayedReport(type, reason) {
      var _this = this;

      if (this.isDelayedReportExist(type)) {
        this.stopDelayedReport(type);
      }

      var startTS = Date.now();
      this._timeoutContainer[type.id] = setTimeout(function () {
        var endTS = Date.now();
        _this._timeoutContainer[type.id] = null;
        _this.reportDebugInfo({
          reason: reason,
          startTS: startTS,
          endTS: endTS
        });
      }, type.timeoutTime);
    }
  }, {
    key: 'stopDelayedReport',
    value: function stopDelayedReport(type) {
      clearTimeout(this._timeoutContainer[type.id]);
      this._timeoutContainer[type.id] = null;
    }
  }, {
    key: 'stopAllDelayedReports',
    value: function stopAllDelayedReports() {
      var _this2 = this;

      Object.keys(this._timeoutContainer).forEach(function (key) {
        clearTimeout(_this2._timeoutContainer[key]);
        _this2._timeoutContainer[key] = null;
      });
    }
  }, {
    key: 'reportDebugInfo',
    value: function reportDebugInfo(_ref3) {
      var reason = _ref3.reason,
          startTS = _ref3.startTS,
          endTS = _ref3.endTS;

      if (typeof this._config.callback === 'function') {
        this._config.callback(_extends({
          reason: reason,
          startTS: startTS,
          endTS: endTS
        }, this._engine.getDebugInfo()));
      } else {
        console.log( // eslint-disable-line no-console
        'REASON: ' + reason + '; startTS: ' + startTS + '; endTS: ' + endTS, this._engine.getDebugInfo());
      }
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.stopAllDelayedReports();

      this._unbindEvents();

      delete this._eventEmitter;
      delete this._engine;
      delete this._timeoutContainer;
      delete this._config;
    }
  }]);

  return AnomalyBloodhound;
}();

exports.default = AnomalyBloodhound;
//# sourceMappingURL=anomaly-bloodhound.js.map


/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Player = exports.MediaStreamTypes = exports.ENGINE_STATES = exports.VIDEO_EVENTS = exports.UI_EVENTS = exports.DefaultModules = exports.DefaultControls = exports.DefaultUIComponents = undefined;

var _vidi = __webpack_require__(376);

var _player = __webpack_require__(1694);

var _player2 = _interopRequireDefault(_player);

var _ui = __webpack_require__(153);

var _ui2 = _interopRequireDefault(_ui);

var _video = __webpack_require__(154);

var _video2 = _interopRequireDefault(_video);

var _playbackEngine = __webpack_require__(1224);

var _defaultControls = __webpack_require__(1696);

var _defaultControls2 = _interopRequireDefault(_defaultControls);

var _overlay = __webpack_require__(1232);

var _overlay2 = _interopRequireDefault(_overlay);

var _loader = __webpack_require__(1231);

var _loader2 = _interopRequireDefault(_loader);

var _screen = __webpack_require__(1233);

var _screen2 = _interopRequireDefault(_screen);

var _controls = __webpack_require__(1225);

var _controls2 = _interopRequireDefault(_controls);

var _anomalyBloodhound = __webpack_require__(1222);

var _anomalyBloodhound2 = _interopRequireDefault(_anomalyBloodhound);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DefaultUIComponents = {
  Screen: _screen2.default,
  Overlay: _overlay2.default,
  ControlBlock: _controls2.default,
  Loader: _loader2.default
};

var DefaultModules = {
  AnomalyBloodhound: _anomalyBloodhound2.default
};

exports.DefaultUIComponents = DefaultUIComponents;
exports.DefaultControls = _defaultControls2.default;
exports.DefaultModules = DefaultModules;
exports.UI_EVENTS = _ui2.default;
exports.VIDEO_EVENTS = _video2.default;
exports.ENGINE_STATES = _playbackEngine.STATES;
exports.MediaStreamTypes = _vidi.MediaStreamTypes;
exports.Player = _player2.default;
exports.default = {
  DefaultUIComponents: DefaultUIComponents,
  DefaultControls: _defaultControls2.default,
  DefaultModules: DefaultModules,
  UI_EVENTS: _ui2.default,
  VIDEO_EVENTS: _video2.default,
  ENGINE_STATES: _playbackEngine.STATES,
  MediaStreamTypes: _vidi.MediaStreamTypes,
  Player: _player2.default
};
//# sourceMappingURL=index.js.map


/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STATES = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _vidi = __webpack_require__(376);

var _vidi2 = _interopRequireDefault(_vidi);

var _videoData = __webpack_require__(1235);

var _video2 = __webpack_require__(154);

var _video3 = _interopRequireDefault(_video2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//TODO: Find source of problem with native HLS on Safari, when playing state triggered but actual playing is delayed

var STATES = exports.STATES = {
  SRC_SET: 'src-set',
  LOAD_STARTED: 'load-started',
  METADATA_LOADED: 'metadata-loaded',
  READY_TO_PLAY: 'ready-to-play',
  SEEK_STARTED: 'seek-started',
  PLAY_REQUESTED: 'play-requested',
  WAITING: 'waiting',
  SEEK_ENDED: 'seek-ended',
  PLAYING: 'playing',
  PAUSED: 'paused',
  ENDED: 'ended'
};

var Engine = function () {
  function Engine(_ref) {
    var eventEmitter = _ref.eventEmitter;

    _classCallCheck(this, Engine);

    this._eventEmitter = eventEmitter;
    this._video = document.createElement('video');
    this._vidi = new _vidi2.default(this._video);

    this._currentState = null;

    this._bindCallbacks();
    this._bindEvents();

    this.STATES = STATES;
  }

  _createClass(Engine, [{
    key: 'getNode',
    value: function getNode() {
      return this._video;
    }
  }, {
    key: '_sendError',
    value: function _sendError(error) {
      this._eventEmitter.emit(_video3.default.ERROR, error);
    }
  }, {
    key: '_bindCallbacks',
    value: function _bindCallbacks() {
      this._processEventFromVideo = this._processEventFromVideo.bind(this);
      this._sendError = this._sendError.bind(this);
    }
  }, {
    key: '_bindEvents',
    value: function _bindEvents() {
      this._vidi.on('error', this._sendError);

      this._video.addEventListener('loadstart', this._processEventFromVideo);
      this._video.addEventListener('loadedmetadata', this._processEventFromVideo);
      this._video.addEventListener('canplay', this._processEventFromVideo);
      this._video.addEventListener('progress', this._processEventFromVideo);
      this._video.addEventListener('play', this._processEventFromVideo);
      this._video.addEventListener('playing', this._processEventFromVideo);
      this._video.addEventListener('pause', this._processEventFromVideo);
      this._video.addEventListener('ended', this._processEventFromVideo);
      this._video.addEventListener('stalled', this._processEventFromVideo);
      this._video.addEventListener('suspend', this._processEventFromVideo);
      this._video.addEventListener('waiting', this._processEventFromVideo);
      this._video.addEventListener('durationchange', this._processEventFromVideo);
      this._video.addEventListener('timeupdate', this._processEventFromVideo);
      this._video.addEventListener('seeking', this._processEventFromVideo);
      this._video.addEventListener('seeked', this._processEventFromVideo);
      this._video.addEventListener('volumechange', this._processEventFromVideo);
    }
  }, {
    key: '_unbindEvents',
    value: function _unbindEvents() {
      this._vidi.off('error', this._sendError);

      this._video.removeEventListener('loadstart', this._processEventFromVideo);
      this._video.removeEventListener('loadedmetadata', this._processEventFromVideo);
      this._video.removeEventListener('canplay', this._processEventFromVideo);
      this._video.removeEventListener('progress', this._processEventFromVideo);
      this._video.removeEventListener('play', this._processEventFromVideo);
      this._video.removeEventListener('playing', this._processEventFromVideo);
      this._video.removeEventListener('pause', this._processEventFromVideo);
      this._video.removeEventListener('ended', this._processEventFromVideo);
      this._video.removeEventListener('stalled', this._processEventFromVideo);
      this._video.removeEventListener('suspend', this._processEventFromVideo);
      this._video.removeEventListener('waiting', this._processEventFromVideo);
      this._video.removeEventListener('durationchange', this._processEventFromVideo);
      this._video.removeEventListener('timeupdate', this._processEventFromVideo);
      this._video.removeEventListener('seeking', this._processEventFromVideo);
      this._video.removeEventListener('seeked', this._processEventFromVideo);
      this._video.removeEventListener('volumechange', this._processEventFromVideo);
    }
  }, {
    key: '_processEventFromVideo',
    value: function _processEventFromVideo(event) {
      var videoEl = this._video;

      switch (event.type) {
        case 'loadstart':
          {
            this._setState(STATES.LOAD_STARTED);
            break;
          }
        case 'loadedmetadata':
          {
            this._setState(STATES.METADATA_LOADED);
            break;
          }
        case 'canplay':
          {
            this._setState(STATES.READY_TO_PLAY);
            break;
          }
        case 'play':
          {
            this._setState(STATES.PLAY_REQUESTED);
            break;
          }
        case 'playing':
          {
            this._setState(STATES.PLAYING);
            break;
          }
        case 'waiting':
          {
            this._setState(STATES.WAITING);
            break;
          }
        case 'pause':
          {
            this._setState(STATES.PAUSED);
            break;
          }
        case 'ended':
          {
            this._setState(STATES.ENDED);
            break;
          }
        case 'progress':
          {
            this._eventEmitter.emit(_video3.default.CHUNK_LOADED);
            break;
          }
        case 'stalled':
          {
            this._eventEmitter.emit(_video3.default.UPLOAD_STALLED);
            break;
          }
        case 'suspend':
          {
            this._eventEmitter.emit(_video3.default.UPLOAD_SUSPEND);
            break;
          }
        case 'durationchange':
          {
            this._eventEmitter.emit(_video3.default.DURATION_UPDATED, videoEl.duration);
            break;
          }
        case 'timeupdate':
          {
            this._eventEmitter.emit(_video3.default.CURRENT_TIME_UPDATED, videoEl.currentTime);
            break;
          }
        case 'seeking':
          {
            this._setState(STATES.SEEK_STARTED);
            break;
          }
        case 'seeked':
          {
            this._setState(STATES.SEEK_ENDED);
            break;
          }
        case 'volumechange':
          {
            this._eventEmitter.emit(_video3.default.VOLUME_STATUS_CHANGED, {
              volume: videoEl.volume,
              muted: videoEl.muted
            });
            break;
          }
        default:
          break;
      }
    }
  }, {
    key: '_setState',
    value: function _setState(state) {
      this._eventEmitter.emit(_video3.default.STATE_CHANGED, { prevState: this._currentState, nextState: state });
      this._currentState = state;
    }
  }, {
    key: 'getDebugInfo',
    value: function getDebugInfo() {
      var attachedStream = this._vidi.attachedStream;
      var _video = this._video,
          networkState = _video.networkState,
          readyState = _video.readyState;

      var data = void 0;

      if (attachedStream.hls) {
        data = this._getHLSInfo(attachedStream.hls);
      } else if (attachedStream.dashPlayer) {
        data = this._getDashInfo(attachedStream.dashPlayer);
      } else {
        data = this._getNativeInfo(this._vidi);
      }

      return _extends({
        attachedStreamName: attachedStream.constructor.name
      }, data, {
        networkState: networkState,
        readyState: readyState
      });
    }
  }, {
    key: '_getDashInfo',
    value: function _getDashInfo(dashPlayer) {
      var currentStream = dashPlayer.getActiveStream();
      var currentTime = dashPlayer.time(currentStream.getId());
      var bitrates = dashPlayer.getBitrateInfoListFor('video');
      var currentBitrate = bitrates[dashPlayer.getQualityFor('video')];
      var overallBufferLength = dashPlayer.getBufferLength('video');
      var currentTrack = dashPlayer.getCurrentTrackFor('video');
      var nearestBufferSegInfo = (0, _videoData.getNearestBufferSegmentInfo)(dashPlayer.getVideoElement().buffered, currentTime);

      return {
        dashInfo: {
          bitrates: bitrates,
          currentTime: currentTime,
          currentBitrate: currentBitrate,
          overallBufferLength: overallBufferLength,
          currentTrack: currentTrack,
          nearestBufferSegInfo: nearestBufferSegInfo
        }
      };
    }
  }, {
    key: '_getHLSInfo',
    value: function _getHLSInfo(hls) {
      var overallBufferLength = (0, _videoData.geOverallBufferLength)(hls.streamController.mediaBuffer.buffered);
      var bitrates = hls.levelController.levels;
      var currentBitrate = bitrates[hls.levelController.level];
      var currentTime = hls.streamController.lastCurrentTime;
      var nearestBufferSegInfo = (0, _videoData.getNearestBufferSegmentInfo)(hls.streamController.mediaBuffer.buffered, currentTime);

      return {
        hlsInfo: {
          bitrates: bitrates,
          currentTime: currentTime,
          currentBitrate: currentBitrate,
          overallBufferLength: overallBufferLength,
          nearestBufferSegInfo: nearestBufferSegInfo
        }
      };
    }
  }, {
    key: '_getNativeInfo',
    value: function _getNativeInfo(vidi) {
      var _vidi$videoElement = vidi.videoElement,
          buffered = _vidi$videoElement.buffered,
          currentTime = _vidi$videoElement.currentTime;


      var overallBufferLength = (0, _videoData.geOverallBufferLength)(buffered);
      var nearestBufferSegInfo = (0, _videoData.getNearestBufferSegmentInfo)(buffered, currentTime);

      return {
        nativeInfo: {
          bitrates: vidi.attachedStream.mediaStreams,
          currentBitrate: vidi.attachedStream.mediaStreams[0],
          currentTime: currentTime,
          overallBufferLength: overallBufferLength,
          nearestBufferSegInfo: nearestBufferSegInfo
        }
      };
    }
  }, {
    key: 'setSrc',
    value: function setSrc(src) {
      if (this._vidi.src !== src) {
        this._vidi.src = src;
        this._setState(STATES.SRC_SET);
      }
    }
  }, {
    key: 'getState',
    value: function getState() {
      return this._currentState;
    }
  }, {
    key: 'goForward',
    value: function goForward(sec) {
      var duration = this.getDurationTime();

      if (duration) {
        var current = this.getCurrentTime();
        this.setCurrentTime(Math.min(current + sec, duration));
      }
    }
  }, {
    key: 'goBackward',
    value: function goBackward(sec) {
      var duration = this.getDurationTime();

      if (duration) {
        var current = this.getCurrentTime();
        this.setCurrentTime(Math.max(current - sec, 0));
      }
    }
  }, {
    key: 'decreaseVolume',
    value: function decreaseVolume(value) {
      this.setVolume(this.getVolume() - value);
    }
  }, {
    key: 'increaseVolume',
    value: function increaseVolume(value) {
      this.setVolume(this.getVolume() + value);
    }
  }, {
    key: 'setAutoPlay',
    value: function setAutoPlay(isAutoPlay) {
      this._video.autoplay = Boolean(isAutoPlay);
    }
  }, {
    key: 'getAutoPlay',
    value: function getAutoPlay() {
      return this._video.autoplay;
    }
  }, {
    key: 'setLoop',
    value: function setLoop(isLoop) {
      this._video.loop = Boolean(isLoop);
    }
  }, {
    key: 'getLoop',
    value: function getLoop() {
      return this._video.loop;
    }
  }, {
    key: 'setMute',
    value: function setMute(isMuted) {
      this._video.muted = Boolean(isMuted);
    }
  }, {
    key: 'getMute',
    value: function getMute() {
      return this._video.muted;
    }
  }, {
    key: 'setVolume',
    value: function setVolume(volume) {
      var parsedVolume = Number(volume);
      this._video.volume = isNaN(parsedVolume) ? 1 : Math.max(0, Math.min(Number(volume), 1));
    }
  }, {
    key: 'getVolume',
    value: function getVolume() {
      return this._video.volume;
    }
  }, {
    key: 'setPlaybackRate',
    value: function setPlaybackRate(rate) {
      this._video.playbackRate = rate;
    }
  }, {
    key: 'getPlaybackRate',
    value: function getPlaybackRate() {
      return this._video.playbackRate;
    }
  }, {
    key: 'setPreload',
    value: function setPreload(preload) {
      this._video.preload = preload || 'auto';
    }
  }, {
    key: 'getPreload',
    value: function getPreload() {
      return this._video.preload;
    }
  }, {
    key: 'getReadyState',
    value: function getReadyState() {
      return this._video.readyState;
    }
  }, {
    key: 'getCurrentTime',
    value: function getCurrentTime() {
      return this._video.currentTime;
    }
  }, {
    key: 'setCurrentTime',
    value: function setCurrentTime(time) {
      this._video.currentTime = time;
    }
  }, {
    key: 'getDurationTime',
    value: function getDurationTime() {
      return this._video.duration || 0;
    }
  }, {
    key: 'getBuffered',
    value: function getBuffered() {
      return this._video.buffered;
    }
  }, {
    key: 'setPlayInline',
    value: function setPlayInline(isPlayInline) {
      return this._video.setAttribute('playsInline', isPlayInline);
    }
  }, {
    key: 'getPlayInline',
    value: function getPlayInline() {
      return this._video.getAttribute('playsInline');
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this._unbindEvents();
      this._video.remove();

      delete this._eventEmitter;
      delete this._video;

      this._vidi.setVideoElement();
      delete this._vidi;
    }
  }, {
    key: 'play',
    value: function play() {
      this._vidi.play();
    }
  }, {
    key: 'pause',
    value: function pause() {
      this._vidi.pause();
    }
  }]);

  return Engine;
}();

exports.default = Engine;
//# sourceMappingURL=playback-engine.js.map


/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _video = __webpack_require__(154);

var _video2 = _interopRequireDefault(_video);

var _ui = __webpack_require__(153);

var _ui2 = _interopRequireDefault(_ui);

var _controls = __webpack_require__(1695);

var _controls2 = _interopRequireDefault(_controls);

var _progress = __webpack_require__(1228);

var _progress2 = _interopRequireDefault(_progress);

var _play = __webpack_require__(1227);

var _play2 = _interopRequireDefault(_play);

var _time = __webpack_require__(1229);

var _time2 = _interopRequireDefault(_time);

var _volume = __webpack_require__(1230);

var _volume2 = _interopRequireDefault(_volume);

var _fullScreen = __webpack_require__(1226);

var _fullScreen2 = _interopRequireDefault(_fullScreen);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DEFAULT_CONFIG = {
  list: [_play2.default, _time2.default, _progress2.default, _volume2.default, _fullScreen2.default],
  view: null
};

var HIDE_CONTROLS_BLOCK_TIMEOUT = 2000;

var ControlBlock = function () {
  function ControlBlock(_ref) {
    var engine = _ref.engine,
        ui = _ref.ui,
        eventEmitter = _ref.eventEmitter,
        config = _ref.config;

    _classCallCheck(this, ControlBlock);

    this._eventEmitter = eventEmitter;
    this._engine = engine;
    this._ui = ui;
    this.config = _extends({}, DEFAULT_CONFIG, config);

    this.isHidden = false;
    this._isVideoPaused = false;
    this._delayedToggleVideoPlaybackTimeout = null;
    this._hideControlsTimeout = null;
    this._isControlsFocused = false;
    this._controls = [];

    this._bindViewCallbacks();
    this._initUI();
    this._initControls();
    this._bindEvents();
  }

  _createClass(ControlBlock, [{
    key: '_initUI',
    value: function _initUI() {
      var view = this.config.view;

      var config = {
        callbacks: {
          onControlsBlockMouseMove: this._setFocusState,
          onControlsBlockMouseOut: this._removeFocusState
        }
      };
      if (view) {
        this.view = new view(config);
      } else {
        this.view = new this.constructor.View(config);
      }
    }
  }, {
    key: '_initControls',
    value: function _initControls() {
      var _this = this;

      this.config.list.forEach(function (Control) {
        var control = new Control({
          engine: _this._engine,
          eventEmitter: _this._eventEmitter
        });

        _this._controls.push(control);
        _this.view.appendControlNode(control.node || control.getNode());
      });
    }
  }, {
    key: '_bindViewCallbacks',
    value: function _bindViewCallbacks() {
      this._startHideControlsTimeout = this._startHideControlsTimeout.bind(this);
      this._setFocusState = this._setFocusState.bind(this);
      this._removeFocusState = this._removeFocusState.bind(this);
      this._showContent = this._showContent.bind(this);
      this._hideContent = this._hideContent.bind(this);
    }
  }, {
    key: '_bindEvents',
    value: function _bindEvents() {
      this._eventEmitter.on(_ui2.default.MOUSE_MOVE_ON_PLAYER_TRIGGERED, this._startHideControlsTimeout);
      this._eventEmitter.on(_ui2.default.MOUSE_LEAVE_ON_PLAYER_TRIGGERED, this._hideContent);
      this._eventEmitter.on(_ui2.default.ENGINE_CONTROL_THROUGH_KEYBOARD_TRIGGERED, this._startHideControlsTimeout);

      this._eventEmitter.on(_video2.default.STATE_CHANGED, this._updatePlayingStatus, this);
    }
  }, {
    key: '_startHideControlsTimeout',
    value: function _startHideControlsTimeout() {
      this._stopHideControlsTimeout();

      this._showContent();

      if (!this._isControlsFocused) {
        this._hideControlsTimeout = setTimeout(this._hideContent, HIDE_CONTROLS_BLOCK_TIMEOUT);
      }
    }
  }, {
    key: '_stopHideControlsTimeout',
    value: function _stopHideControlsTimeout() {
      if (this._hideControlsTimeout) {
        clearTimeout(this._hideControlsTimeout);
      }
    }
  }, {
    key: '_setFocusState',
    value: function _setFocusState() {
      this._isControlsFocused = true;
    }
  }, {
    key: '_removeFocusState',
    value: function _removeFocusState() {
      this._isControlsFocused = false;
    }
  }, {
    key: '_showContent',
    value: function _showContent() {
      this._eventEmitter.emit(_ui2.default.CONTROL_BLOCK_SHOW_TRIGGERED);

      this.view.showControlsBlock();
    }
  }, {
    key: '_hideContent',
    value: function _hideContent() {
      if (!this._isVideoPaused) {
        this._eventEmitter.emit(_ui2.default.CONTROL_BLOCK_HIDE_TRIGGERED);

        this.view.hideControlsBlock();
      }
    }
  }, {
    key: '_updatePlayingStatus',
    value: function _updatePlayingStatus(_ref2) {
      var nextState = _ref2.nextState;

      if (nextState === this._engine.STATES.PLAY_REQUESTED) {
        this._isVideoPaused = false;
        this._startHideControlsTimeout();
      } else if (nextState === this._engine.STATES.ENDED) {
        this._isVideoPaused = false;
        this._hideContent();
      } else if (nextState === this._engine.STATES.PAUSED) {
        this._isVideoPaused = true;
        this._showContent();
      }
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.isHidden = true;
      this.view.hide();
    }
  }, {
    key: 'show',
    value: function show() {
      this.isHidden = false;
      this.view.show();
    }
  }, {
    key: '_unbindEvents',
    value: function _unbindEvents() {
      this._eventEmitter.off(_ui2.default.MOUSE_MOVE_ON_PLAYER_TRIGGERED, this._startHideControlsTimeout);
      this._eventEmitter.off(_ui2.default.MOUSE_LEAVE_ON_PLAYER_TRIGGERED, this._hideContent);
      this._eventEmitter.off(_ui2.default.ENGINE_CONTROL_THROUGH_KEYBOARD_TRIGGERED, this._startHideControlsTimeout);

      this._eventEmitter.off(_video2.default.STATE_CHANGED, this._updatePlayingStatus, this);
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this._stopHideControlsTimeout();
      this._unbindEvents();
      this.view.destroy();
      delete this.view;

      this._controls.forEach(function (control) {
        return control.destroy();
      });
      delete this._controls;

      delete this._eventEmitter;
      delete this._engine;
      delete this._ui;
      delete this.config;

      this.isHidden = null;
      this._isVideoPaused = null;
      this._hideControlsTimeout = null;
      this._isControlsFocused = null;
      this._delayedToggleVideoPlaybackTimeout = null;
    }
  }, {
    key: 'node',
    get: function get() {
      return this.view.getNode();
    }
  }]);

  return ControlBlock;
}();

ControlBlock.View = _controls2.default;
exports.default = ControlBlock;
//# sourceMappingURL=controls.controler.js.map


/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ui = __webpack_require__(153);

var _ui2 = _interopRequireDefault(_ui);

var _fullScreen = __webpack_require__(1697);

var _fullScreen2 = _interopRequireDefault(_fullScreen);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FullScreenControl = function () {
  function FullScreenControl(_ref) {
    var eventEmitter = _ref.eventEmitter;

    _classCallCheck(this, FullScreenControl);

    this._eventEmitter = eventEmitter;
    this._isInFullScreen = null;

    this._bindCallbacks();

    this._initUI();

    this._bindEvents();

    this.setControlStatus(false);
  }

  _createClass(FullScreenControl, [{
    key: '_bindCallbacks',
    value: function _bindCallbacks() {
      this._toggleFullScreen = this._toggleFullScreen.bind(this);
    }
  }, {
    key: '_bindEvents',
    value: function _bindEvents() {
      this._eventEmitter.on(_ui2.default.FULLSCREEN_STATUS_CHANGED, this.setControlStatus, this);
    }
  }, {
    key: '_initUI',
    value: function _initUI() {
      var config = {
        callbacks: {
          onToggleFullScreenButtonClick: this._toggleFullScreen
        }
      };

      this.view = new this.constructor.View(config);
    }
  }, {
    key: '_toggleFullScreen',
    value: function _toggleFullScreen() {
      if (this._isInFullScreen) {
        this._exitFullScreen();
      } else {
        this._enterFullScreen();
      }
    }
  }, {
    key: '_enterFullScreen',
    value: function _enterFullScreen() {
      this._eventEmitter.emit(_ui2.default.FULLSCREEN_ENTER_TRIGGERED);
    }
  }, {
    key: '_exitFullScreen',
    value: function _exitFullScreen() {
      this._eventEmitter.emit(_ui2.default.FULLSCREEN_EXIT_TRIGGERED);
    }
  }, {
    key: 'setControlStatus',
    value: function setControlStatus(isInFullScreen) {
      this._isInFullScreen = isInFullScreen;
      this.view.setState({ isInFullScreen: this._isInFullScreen });
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.isHidden = true;
      this.view.hide();
    }
  }, {
    key: 'show',
    value: function show() {
      this.isHidden = false;
      this.view.show();
    }
  }, {
    key: '_unbindEvents',
    value: function _unbindEvents() {
      this._eventEmitter.off(_ui2.default.FULLSCREEN_STATUS_CHANGED, this.setControlStatus, this);
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this._unbindEvents();
      this.view.destroy();
      delete this.view;

      delete this._eventEmitter;

      delete this.isHidden;
    }
  }, {
    key: 'node',
    get: function get() {
      return this.view.getNode();
    }
  }]);

  return FullScreenControl;
}();

FullScreenControl.View = _fullScreen2.default;
exports.default = FullScreenControl;
//# sourceMappingURL=full-screen.controler.js.map


/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _play = __webpack_require__(1698);

var _play2 = _interopRequireDefault(_play);

var _video = __webpack_require__(154);

var _video2 = _interopRequireDefault(_video);

var _ui = __webpack_require__(153);

var _ui2 = _interopRequireDefault(_ui);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PlayControl = function () {
  function PlayControl(_ref) {
    var engine = _ref.engine,
        eventEmitter = _ref.eventEmitter;

    _classCallCheck(this, PlayControl);

    this._engine = engine;
    this._eventEmitter = eventEmitter;

    this._isPlaying = null;

    this._bindCallbacks();
    this._initUI();
    this._bindEvents();

    this.setControlStatus(false);
  }

  _createClass(PlayControl, [{
    key: '_bindCallbacks',
    value: function _bindCallbacks() {
      this._togglePlayback = this._togglePlayback.bind(this);
    }
  }, {
    key: '_bindEvents',
    value: function _bindEvents() {
      this._eventEmitter.on(_video2.default.STATE_CHANGED, this._updatePlayingStatus, this);
    }
  }, {
    key: '_togglePlayback',
    value: function _togglePlayback() {
      if (this._isPlaying) {
        this._pauseVideo();
      } else {
        this._playVideo();
      }
    }
  }, {
    key: '_playVideo',
    value: function _playVideo() {
      this._engine.play();

      this._eventEmitter.emit(_ui2.default.PLAY_TRIGGERED);
    }
  }, {
    key: '_pauseVideo',
    value: function _pauseVideo() {
      this._engine.pause();

      this._eventEmitter.emit(_ui2.default.PAUSE_TRIGGERED);
    }
  }, {
    key: '_updatePlayingStatus',
    value: function _updatePlayingStatus(_ref2) {
      var nextState = _ref2.nextState;

      if (nextState === this._engine.STATES.SRC_SET) {
        this.reset();
      } else if (nextState === this._engine.STATES.PLAY_REQUESTED) {
        this.setControlStatus(true);
      } else if (nextState === this._engine.STATES.PAUSED || nextState === this._engine.STATES.ENDED) {
        this.setControlStatus(false);
      }
    }
  }, {
    key: '_initUI',
    value: function _initUI() {
      var config = {
        callbacks: {
          onTogglePlaybackButtonClick: this._togglePlayback
        }
      };

      this.view = new this.constructor.View(config);
    }
  }, {
    key: 'setControlStatus',
    value: function setControlStatus(isPlaying) {
      this._isPlaying = isPlaying;
      this.view.setState({ isPlaying: this._isPlaying });
    }
  }, {
    key: '_unbindEvents',
    value: function _unbindEvents() {
      this._eventEmitter.off(_video2.default.STATE_CHANGED, this._updatePlayingStatus, this);
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.setControlStatus(false);
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this._unbindEvents();
      this.view.destroy();
      delete this.view;

      delete this._eventEmitter;
      delete this._engine;
    }
  }, {
    key: 'node',
    get: function get() {
      return this.view.getNode();
    }
  }]);

  return PlayControl;
}();

PlayControl.View = _play2.default;
exports.default = PlayControl;
//# sourceMappingURL=play.controler.js.map


/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _progress = __webpack_require__(1699);

var _progress2 = _interopRequireDefault(_progress);

var _videoData = __webpack_require__(1235);

var _video = __webpack_require__(154);

var _video2 = _interopRequireDefault(_video);

var _ui = __webpack_require__(153);

var _ui2 = _interopRequireDefault(_ui);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UPDATE_INTERVAL_DELAY = 1000 / 60;

var ProgressControl = function () {
  function ProgressControl(_ref) {
    var engine = _ref.engine,
        eventEmitter = _ref.eventEmitter;

    _classCallCheck(this, ProgressControl);

    this._engine = engine;
    this._eventEmitter = eventEmitter;

    this._isUserInteracting = false;
    this._currentProgress = 0;

    this._bindCallbacks();
    this._initUI();
    this._bindEvents();
    this.view.setState({
      played: 0,
      buffered: 0
    });
  }

  _createClass(ProgressControl, [{
    key: '_bindEvents',
    value: function _bindEvents() {
      this._eventEmitter.on(_video2.default.STATE_CHANGED, this._toggleIntervalUpdates, this);
      this._eventEmitter.on(_video2.default.CHUNK_LOADED, this._updateBufferIndicator, this);
    }
  }, {
    key: '_initUI',
    value: function _initUI() {
      var config = {
        callbacks: {
          onChangePlayedProgress: this._changePlayedProgress,
          onUserInteractionStart: this._onUserInteractionStarts,
          onUserInteractionEnd: this._onUserInteractionEnds
        }
      };

      this.view = new this.constructor.View(config);
    }
  }, {
    key: '_bindCallbacks',
    value: function _bindCallbacks() {
      this._updateControlOnInterval = this._updateControlOnInterval.bind(this);
      this._changePlayedProgress = this._changePlayedProgress.bind(this);
      this._onUserInteractionStarts = this._onUserInteractionStarts.bind(this);
      this._onUserInteractionEnds = this._onUserInteractionEnds.bind(this);
      this._toggleIntervalUpdates = this._toggleIntervalUpdates.bind(this);
      this._playVideoOnProgressManipulationEnd = this._playVideoOnProgressManipulationEnd.bind(this);
    }
  }, {
    key: '_changePlayedProgress',
    value: function _changePlayedProgress(value) {
      if (this._currentProgress === value) {
        return;
      }

      this._currentProgress = value;
      this._changeCurrentTimeOfVideo(this._currentProgress / 100);
    }
  }, {
    key: '_startIntervalUpdates',
    value: function _startIntervalUpdates() {
      if (this._updateControlInterval) {
        this._stopIntervalUpdates();
      }

      this._updateControlInterval = setInterval(this._updateControlOnInterval, UPDATE_INTERVAL_DELAY);
    }
  }, {
    key: '_stopIntervalUpdates',
    value: function _stopIntervalUpdates() {
      clearInterval(this._updateControlInterval);
      this._updateControlInterval = null;
    }
  }, {
    key: '_onUserInteractionStarts',
    value: function _onUserInteractionStarts() {
      if (!this._isUserInteracting) {
        this._isUserInteracting = true;
        this._pauseVideoOnProgressManipulationStart();
      }
    }
  }, {
    key: '_onUserInteractionEnds',
    value: function _onUserInteractionEnds() {
      if (this._isUserInteracting) {
        this._isUserInteracting = false;
        setTimeout(this._playVideoOnProgressManipulationEnd, 100);
      }
    }
  }, {
    key: '_updateControlOnInterval',
    value: function _updateControlOnInterval() {
      this._updatePlayedIndicator();
      this._updateBufferIndicator();
    }
  }, {
    key: '_toggleIntervalUpdates',
    value: function _toggleIntervalUpdates(_ref2) {
      var nextState = _ref2.nextState;
      var STATES = this._engine.STATES;


      switch (nextState) {
        case STATES.SRC_SET:
          this.reset();
          break;
        case STATES.PLAYING:
          this._startIntervalUpdates();
          break;
        case STATES.SEEK_STARTED:
          this._updatePlayedIndicator();
          this._updateBufferIndicator();
          break;
        default:
          this._stopIntervalUpdates();
          break;
      }
    }
  }, {
    key: '_changeCurrentTimeOfVideo',
    value: function _changeCurrentTimeOfVideo(percent) {
      var duration = this._engine.getDurationTime();

      this._engine.setCurrentTime(duration * percent);

      this._eventEmitter.emit(_ui2.default.PROGRESS_CHANGE_TRIGGERED, percent);
    }
  }, {
    key: '_pauseVideoOnProgressManipulationStart',
    value: function _pauseVideoOnProgressManipulationStart() {
      this._previousPlaybackState = this._engine.getState();
      this._engine.pause();

      this._eventEmitter.emit(_ui2.default.PROGRESS_MANIPULATION_STARTED);
    }
  }, {
    key: '_playVideoOnProgressManipulationEnd',
    value: function _playVideoOnProgressManipulationEnd() {
      if (this._previousPlaybackState === this._engine.STATES.PLAYING || this._previousPlaybackState === this._engine.STATES.PLAY_REQUESTED) {
        this._engine.play();
      }

      this._previousPlaybackState = null;
      this._eventEmitter.emit(_ui2.default.PROGRESS_MANIPULATION_ENDED);
    }
  }, {
    key: '_updateBufferIndicator',
    value: function _updateBufferIndicator() {
      var currentTime = this._engine.getCurrentTime();
      var buffered = this._engine.getBuffered();
      var duration = this._engine.getDurationTime();

      this.updateBuffered((0, _videoData.getOverallBufferedPercent)(buffered, currentTime, duration));
    }
  }, {
    key: '_updatePlayedIndicator',
    value: function _updatePlayedIndicator() {
      var currentTime = this._engine.getCurrentTime();
      var duration = this._engine.getDurationTime();

      this.updatePlayed((0, _videoData.getOverallPlayedPercent)(currentTime, duration));
    }
  }, {
    key: 'updatePlayed',
    value: function updatePlayed(percent) {
      if (!this._isUserInteracting) {
        this._currentProgress = percent;
        this.view.setState({ played: this._currentProgress });
      }
    }
  }, {
    key: 'updateBuffered',
    value: function updateBuffered(percent) {
      this.view.setState({ buffered: percent });
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.isHidden = true;
      this.view.hide();
    }
  }, {
    key: 'show',
    value: function show() {
      this.isHidden = false;
      this.view.show();
    }
  }, {
    key: '_unbindEvents',
    value: function _unbindEvents() {
      this._eventEmitter.off(_video2.default.STATE_CHANGED, this._toggleIntervalUpdates, this);
      this._eventEmitter.off(_video2.default.CHUNK_LOADED, this._updateBufferIndicator, this);
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.updatePlayed(0);
      this.updateBuffered(0);
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this._stopIntervalUpdates();
      this._unbindEvents();
      this.view.destroy();
      delete this.view;

      delete this._eventEmitter;
      delete this._engine;

      this._isUserInteracting = null;
      this._currentProgress = null;
      this.isHidden = null;
    }
  }, {
    key: 'node',
    get: function get() {
      return this.view.getNode();
    }
  }]);

  return ProgressControl;
}();

ProgressControl.View = _progress2.default;
exports.default = ProgressControl;
//# sourceMappingURL=progress.controler.js.map


/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _time = __webpack_require__(1700);

var _time2 = _interopRequireDefault(_time);

var _video = __webpack_require__(154);

var _video2 = _interopRequireDefault(_video);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UPDATE_INTERVAL_DELAY = 500;

var TimeControl = function () {
  function TimeControl(_ref) {
    var eventEmitter = _ref.eventEmitter,
        engine = _ref.engine;

    _classCallCheck(this, TimeControl);

    this._eventEmitter = eventEmitter;
    this._engine = engine;

    this._bindCallbacks();
    this._initUI();
    this._bindEvents();

    this.setCurrentTime(0);
    this.setDurationTime(0);
  }

  _createClass(TimeControl, [{
    key: '_bindCallbacks',
    value: function _bindCallbacks() {
      this._updateCurrentTime = this._updateCurrentTime.bind(this);
      this._updateDurationTime = this._updateDurationTime.bind(this);
    }
  }, {
    key: '_bindEvents',
    value: function _bindEvents() {
      this._eventEmitter.on(_video2.default.STATE_CHANGED, this._toggleIntervalUpdates, this);
      this._eventEmitter.on(_video2.default.DURATION_UPDATED, this._updateDurationTime, this);
    }
  }, {
    key: '_initUI',
    value: function _initUI() {
      this.view = new this.constructor.View();
    }
  }, {
    key: '_startIntervalUpdates',
    value: function _startIntervalUpdates() {
      if (this._updateControlInterval) {
        this._stopIntervalUpdates();
      }
      this._updateControlInterval = setInterval(this._updateCurrentTime, UPDATE_INTERVAL_DELAY);
    }
  }, {
    key: '_stopIntervalUpdates',
    value: function _stopIntervalUpdates() {
      clearInterval(this._updateControlInterval);
      this._updateControlInterval = null;
    }
  }, {
    key: '_toggleIntervalUpdates',
    value: function _toggleIntervalUpdates(_ref2) {
      var nextState = _ref2.nextState;
      var STATES = this._engine.STATES;


      switch (nextState) {
        case STATES.SRC_SET:
          this.reset();
          break;
        case STATES.PLAYING:
          this._startIntervalUpdates();
          break;
        case STATES.SEEK_STARTED:
          this._updateCurrentTime();
          break;
        default:
          this._stopIntervalUpdates();
          break;
      }
    }
  }, {
    key: '_updateDurationTime',
    value: function _updateDurationTime() {
      this.setDurationTime(this._engine.getDurationTime());
    }
  }, {
    key: '_updateCurrentTime',
    value: function _updateCurrentTime() {
      this.setCurrentTime(this._engine.getCurrentTime());
    }
  }, {
    key: 'setDurationTime',
    value: function setDurationTime(time) {
      this.view.setState({ duration: time });
    }
  }, {
    key: 'setCurrentTime',
    value: function setCurrentTime(time) {
      this.view.setState({ current: time });
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.isHidden = true;
      this.view.hide();
    }
  }, {
    key: 'show',
    value: function show() {
      this.isHidden = false;
      this.view.show();
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.setDurationTime(0);
      this.setCurrentTime(0);
    }
  }, {
    key: '_unbindEvents',
    value: function _unbindEvents() {
      this._eventEmitter.off(_video2.default.STATE_CHANGED, this._toggleIntervalUpdates, this);
      this._eventEmitter.off(_video2.default.DURATION_UPDATED, this._updateDurationTime, this);
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this._stopIntervalUpdates();
      this._unbindEvents();
      this.view.destroy();
      delete this.view;

      delete this._eventEmitter;
      delete this._engine;

      this.isHidden = null;
    }
  }, {
    key: 'node',
    get: function get() {
      return this.view.getNode();
    }
  }]);

  return TimeControl;
}();

TimeControl.View = _time2.default;
exports.default = TimeControl;
//# sourceMappingURL=time.controler.js.map


/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _volume = __webpack_require__(1701);

var _volume2 = _interopRequireDefault(_volume);

var _video = __webpack_require__(154);

var _video2 = _interopRequireDefault(_video);

var _ui = __webpack_require__(153);

var _ui2 = _interopRequireDefault(_ui);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VolumeControl = function () {
  function VolumeControl(_ref) {
    var engine = _ref.engine,
        eventEmitter = _ref.eventEmitter;

    _classCallCheck(this, VolumeControl);

    this._engine = engine;
    this._eventEmitter = eventEmitter;

    this._isMuted = this._engine.getMute();
    this._volumeLevel = this._convertVideoVolumeToVolumeLevel(this._engine.getVolume());

    this._bindCallbacks();

    this._initUI();

    this._bindEvents();

    this.view.setState({
      volume: this._volumeLevel,
      isMuted: this._isMuted
    });
  }

  _createClass(VolumeControl, [{
    key: '_initUI',
    value: function _initUI() {
      var config = {
        callbacks: {
          onVolumeLevelChangeFromInput: this._getVolumeLevelFromInput,
          onVolumeLevelChangeFromWheel: this._getVolumeLevelFromWheel,
          onToggleMuteClick: this._toggleMuteStatus
        }
      };

      this.view = new this.constructor.View(config);
    }
  }, {
    key: '_bindEvents',
    value: function _bindEvents() {
      this._eventEmitter.on(_video2.default.VOLUME_STATUS_CHANGED, this._updateVolumeStatus, this);
    }
  }, {
    key: '_bindCallbacks',
    value: function _bindCallbacks() {
      this._getVolumeLevelFromInput = this._getVolumeLevelFromInput.bind(this);
      this._toggleMuteStatus = this._toggleMuteStatus.bind(this);
      this._getVolumeLevelFromWheel = this._getVolumeLevelFromWheel.bind(this);
    }
  }, {
    key: '_convertVolumeLevelToVideoVolume',
    value: function _convertVolumeLevelToVideoVolume(level) {
      return level / 100;
    }
  }, {
    key: '_convertVideoVolumeToVolumeLevel',
    value: function _convertVideoVolumeToVolumeLevel(level) {
      return level * 100;
    }
  }, {
    key: '_changeVolumeLevel',
    value: function _changeVolumeLevel(level) {
      this._engine.setVolume(level);
      this._eventEmitter.emit(_ui2.default.VOLUME_CHANGE_TRIGGERED, level);
    }
  }, {
    key: '_toggleMuteStatus',
    value: function _toggleMuteStatus() {
      this._engine.setMute(!this._isMuted);
      this._eventEmitter.emit(_ui2.default.MUTE_STATUS_TRIGGERED, !this._isMuted);
    }
  }, {
    key: '_getVolumeLevelFromWheel',
    value: function _getVolumeLevelFromWheel(delta) {
      var adjustedVolume = this._volumeLevel + delta / 10;
      var validatedVolume = Math.min(100, Math.max(0, adjustedVolume));

      this._changeVolumeStatus(validatedVolume);
    }
  }, {
    key: '_getVolumeLevelFromInput',
    value: function _getVolumeLevelFromInput(level) {
      this._changeVolumeStatus(level);
    }
  }, {
    key: '_changeVolumeStatus',
    value: function _changeVolumeStatus(level) {
      this._changeVolumeLevel(this._convertVolumeLevelToVideoVolume(level));
      if (this._isMuted) {
        this._toggleMuteStatus();
      }
    }
  }, {
    key: '_updateVolumeStatus',
    value: function _updateVolumeStatus() {
      this.setVolumeLevel(this._engine.getVolume());
      this.setMuteStatus(this._engine.getMute());
    }
  }, {
    key: 'setVolumeLevel',
    value: function setVolumeLevel(level) {
      if (level === this._volumeLevel) {
        return;
      }

      this._volumeLevel = this._convertVideoVolumeToVolumeLevel(level);

      this.view.setState({
        volume: this._volumeLevel,
        isMuted: !this._volumeLevel
      });
    }
  }, {
    key: 'setMuteStatus',
    value: function setMuteStatus(isMuted) {
      if (isMuted === this._isMuted) {
        return;
      }

      this._isMuted = isMuted;

      this.view.setState({
        volume: this._isMuted ? 0 : this._volumeLevel,
        isMuted: this._isMuted || !this._volumeLevel
      });
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.isHidden = true;
      this.view.hide();
    }
  }, {
    key: 'show',
    value: function show() {
      this.isHidden = false;
      this.view.show();
    }
  }, {
    key: '_unbindEvents',
    value: function _unbindEvents() {
      this._eventEmitter.off(_video2.default.VOLUME_STATUS_CHANGED, this._updateVolumeStatus, this);
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this._unbindEvents();
      this.view.destroy();
      delete this.view;

      delete this._eventEmitter;
      delete this._engine;

      this.isHidden = null;
      this._isMuted = null;
      this._volumeLevel = null;
    }
  }, {
    key: 'node',
    get: function get() {
      return this.view.getNode();
    }
  }]);

  return VolumeControl;
}();

VolumeControl.View = _volume2.default;
exports.default = VolumeControl;
//# sourceMappingURL=volume.controler.js.map


/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _video = __webpack_require__(154);

var _video2 = _interopRequireDefault(_video);

var _loader = __webpack_require__(1702);

var _loader2 = _interopRequireDefault(_loader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DELAY_FOR_SHOW_ON_WAITING_STATE = 100;

var Loader = function () {
  function Loader(_ref) {
    var config = _ref.config,
        eventEmitter = _ref.eventEmitter,
        engine = _ref.engine;

    _classCallCheck(this, Loader);

    this._eventEmitter = eventEmitter;
    this.isHidden = false;
    this._engine = engine;
    this.config = _extends({}, config);

    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);

    this._initUI();
    this._bindEvents();
  }

  _createClass(Loader, [{
    key: '_bindEvents',
    value: function _bindEvents() {
      this._eventEmitter.on(_video2.default.STATE_CHANGED, this._checkForWaitingState, this);
      this._eventEmitter.on(_video2.default.UPLOAD_SUSPEND, this.hide, this);
    }
  }, {
    key: '_checkForWaitingState',
    value: function _checkForWaitingState(_ref2) {
      var nextState = _ref2.nextState;
      var STATES = this._engine.STATES;

      switch (nextState) {
        case STATES.SEEK_STARTED:
          this._startDelayedShow();
          break;
        case STATES.SEEK_ENDED:
          this._stopDelayedShow();
          this.hide();
          break;
        case STATES.WAITING:
          this._startDelayedShow();
          break;
        case STATES.LOAD_STARTED:
          this.show();
          break;
        case STATES.READY_TO_PLAY:
          this._stopDelayedShow();
          this.hide();
          break;
        case STATES.PLAYING:
          this._stopDelayedShow();
          this.hide();
          break;

        default:
          break;
      }
    }
  }, {
    key: '_initUI',
    value: function _initUI() {
      var view = this.config.view;


      if (view) {
        this.view = new view();
      } else {
        this.view = new this.constructor.View();
      }
    }
  }, {
    key: 'hide',
    value: function hide() {
      if (!this.isHidden) {
        this.view.hide();
        this.isHidden = true;
      }
    }
  }, {
    key: 'show',
    value: function show() {
      if (this.isHidden) {
        this.view.show();
        this.isHidden = false;
      }
    }
  }, {
    key: '_startDelayedShow',
    value: function _startDelayedShow() {
      this._stopDelayedShow();
      this._delayedShowTimeout = setTimeout(this.show, DELAY_FOR_SHOW_ON_WAITING_STATE);
    }
  }, {
    key: '_stopDelayedShow',
    value: function _stopDelayedShow() {
      clearTimeout(this._delayedShowTimeout);
      this._delayedShowTimeout = null;
    }
  }, {
    key: '_unbindEvents',
    value: function _unbindEvents() {
      this._eventEmitter.off(_video2.default.STATE_CHANGED, this._checkForWaitingState, this);
      this._eventEmitter.off(_video2.default.UPLOAD_SUSPEND, this.hide, this);
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this._unbindEvents();
      this._stopDelayedShow();

      this.view.destroy();

      delete this.view;

      delete this._eventEmitter;
      delete this._engine;
    }
  }, {
    key: 'node',
    get: function get() {
      return this.view.getNode();
    }
  }]);

  return Loader;
}();

Loader.View = _loader2.default;
exports.default = Loader;
//# sourceMappingURL=loader.controler.js.map


/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _video = __webpack_require__(154);

var _video2 = _interopRequireDefault(_video);

var _ui = __webpack_require__(153);

var _ui2 = _interopRequireDefault(_ui);

var _overlay = __webpack_require__(1703);

var _overlay2 = _interopRequireDefault(_overlay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DEFAULT_CONFIG = {
  poster: ''
};

var Overlay = function () {
  function Overlay(_ref) {
    var config = _ref.config,
        eventEmitter = _ref.eventEmitter,
        engine = _ref.engine;

    _classCallCheck(this, Overlay);

    this._eventEmitter = eventEmitter;
    this.isHidden = false;
    this.isContentHidden = false;
    this.enabled = true;
    this.config = _extends({}, DEFAULT_CONFIG, config);
    this._engine = engine;

    this._bindEvents();
    this._initUI(this.config.poster);
  }

  _createClass(Overlay, [{
    key: '_initUI',
    value: function _initUI(src) {
      var view = this.config.view;

      var config = {
        callbacks: {
          onPlayClick: this._playVideo
        },
        src: src
      };

      if (view) {
        this.view = new view(config);
      } else {
        this.view = new this.constructor.View(config);
      }
    }
  }, {
    key: '_bindEvents',
    value: function _bindEvents() {
      this._playVideo = this._playVideo.bind(this);

      this._eventEmitter.on(_video2.default.STATE_CHANGED, this._updatePlayingStatus, this);
    }
  }, {
    key: '_updatePlayingStatus',
    value: function _updatePlayingStatus(_ref2) {
      var nextState = _ref2.nextState;

      if (nextState === this._engine.STATES.PLAY_REQUESTED) {
        this._hideContent();
      } else if (nextState === this._engine.STATES.ENDED) {
        this._showContent();
      }
    }
  }, {
    key: '_playVideo',
    value: function _playVideo() {
      this._engine.play();
      this._hideContent();

      this._eventEmitter.emit(_ui2.default.PLAY_OVERLAY_TRIGGERED);
    }
  }, {
    key: '_hideContent',
    value: function _hideContent() {
      this.isContentHidden = true;
      this.view.hide();
    }
  }, {
    key: '_showContent',
    value: function _showContent() {
      this.isContentHidden = false;
      this.view.show();
    }
  }, {
    key: 'setBackgroundSrc',
    value: function setBackgroundSrc(src) {
      this.view.setBackgroundSrc(src);
    }
  }, {
    key: '_unbindEvents',
    value: function _unbindEvents() {
      this._eventEmitter.off(_video2.default.STATE_CHANGED, this._updatePlayingStatus, this);
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this._unbindEvents();
      this.view.destroy();
      delete this.view;

      delete this._eventEmitter;
      delete this._engine;
    }
  }, {
    key: 'node',
    get: function get() {
      return this.view.getNode();
    }
  }]);

  return Overlay;
}();

Overlay.View = _overlay2.default;
exports.default = Overlay;
//# sourceMappingURL=overlay.controler.js.map


/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ui = __webpack_require__(153);

var _ui2 = _interopRequireDefault(_ui);

var _screen = __webpack_require__(1704);

var _screen2 = _interopRequireDefault(_screen);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PLAYBACK_CHANGE_TIMEOUT = 300;
var SPACE_BAR_KEYCODE = 32;
var LEFT_ARROW_KEYCODE = 37;
var RIGHT_ARROW_KEYCODE = 39;
var UP_ARROW_KEYCODE = 38;
var DOWN_ARROW_KEYCODE = 40;
var AMOUNT_TO_SKIP_SECONDS = 5;
var AMOUNT_TO_CHANGE_VOLUME = 0.1;

var Screen = function () {
  function Screen(_ref) {
    var config = _ref.config,
        eventEmitter = _ref.eventEmitter,
        engine = _ref.engine,
        ui = _ref.ui;

    _classCallCheck(this, Screen);

    this._ui = ui;
    this._eventEmitter = eventEmitter;
    this._isInFullScreen = false;
    this.isHidden = false;
    this._engine = engine;
    this._delayedToggleVideoPlaybackTimeout = null;
    this.config = _extends({}, config);

    this._bindCallbacks();
    this._initUI();
    this.view.appendPlaybackViewNode(this._engine.getNode());
    this._bindEvents();
  }

  _createClass(Screen, [{
    key: '_bindCallbacks',
    value: function _bindCallbacks() {
      this._processNodeClick = this._processNodeClick.bind(this);
      this._processKeyboardInput = this._processKeyboardInput.bind(this);
      this._toggleVideoPlayback = this._toggleVideoPlayback.bind(this);
    }
  }, {
    key: '_initUI',
    value: function _initUI() {
      var config = {
        indicateScreenClick: this.config.indicateScreenClick,
        nativeControls: this.config.nativeControls,
        callbacks: {
          onWrapperKeyPress: this._processKeyboardInput
        }
      };

      if (!this.config.disableClickProcessing) {
        config.callbacks.onWrapperMouseClick = this._processNodeClick;
      }

      this.view = new _screen2.default(config);
    }
  }, {
    key: '_bindEvents',
    value: function _bindEvents() {
      this._eventEmitter.on(_ui2.default.FULLSCREEN_STATUS_CHANGED, this._setFullScreenStatus, this);
      this._eventEmitter.on(_ui2.default.PLAY_OVERLAY_TRIGGERED, this.view.focusOnNode, this.view);
    }
  }, {
    key: '_unbindEvents',
    value: function _unbindEvents() {
      this._eventEmitter.off(_ui2.default.FULLSCREEN_STATUS_CHANGED, this._setFullScreenStatus, this);
      this._eventEmitter.off(_ui2.default.PLAY_OVERLAY_TRIGGERED, this.view.focusOnNode, this.view);
    }
  }, {
    key: '_setFullScreenStatus',
    value: function _setFullScreenStatus(isInFullScreen) {
      this._isInFullScreen = isInFullScreen;
    }
  }, {
    key: '_processKeyboardInput',
    value: function _processKeyboardInput(e) {
      switch (e.keyCode) {
        case SPACE_BAR_KEYCODE:
          this._eventEmitter.emit(_ui2.default.ENGINE_CONTROL_THROUGH_KEYBOARD_TRIGGERED);
          this._showPlaybackChangeIndicator();
          this._toggleVideoPlayback();
          break;
        case LEFT_ARROW_KEYCODE:
          this._eventEmitter.emit(_ui2.default.ENGINE_CONTROL_THROUGH_KEYBOARD_TRIGGERED);
          this.view.activateRewindIcon();
          this._engine.goBackward(AMOUNT_TO_SKIP_SECONDS);
          break;
        case RIGHT_ARROW_KEYCODE:
          this._eventEmitter.emit(_ui2.default.ENGINE_CONTROL_THROUGH_KEYBOARD_TRIGGERED);
          this.view.activateForwardIcon();
          this._engine.goForward(AMOUNT_TO_SKIP_SECONDS);
          break;
        case UP_ARROW_KEYCODE:
          this._eventEmitter.emit(_ui2.default.ENGINE_CONTROL_THROUGH_KEYBOARD_TRIGGERED);
          this.view.activateIncreaseVolumeIcon();
          this._engine.increaseVolume(AMOUNT_TO_CHANGE_VOLUME);
          break;
        case DOWN_ARROW_KEYCODE:
          this._eventEmitter.emit(_ui2.default.ENGINE_CONTROL_THROUGH_KEYBOARD_TRIGGERED);
          this.view.activateDecreaseVolumeIcon();
          this._engine.decreaseVolume(AMOUNT_TO_CHANGE_VOLUME);
          break;
        default:
          break;
      }
    }
  }, {
    key: '_processNodeClick',
    value: function _processNodeClick() {
      if (this._delayedToggleVideoPlaybackTimeout) {
        clearTimeout(this._delayedToggleVideoPlaybackTimeout);
        this._delayedToggleVideoPlaybackTimeout = null;

        this._hideDelayedPlaybackChangeIndicator();

        this._toggleFullScreen();
      } else {
        this._showPlaybackChangeIndicator();
        this._delayedToggleVideoPlaybackTimeout = setTimeout(this._toggleVideoPlayback, PLAYBACK_CHANGE_TIMEOUT);
      }
    }
  }, {
    key: '_showPlaybackChangeIndicator',
    value: function _showPlaybackChangeIndicator() {
      if (this.config.indicateScreenClick) {
        var state = this._engine.getState();

        if (state === this._engine.STATES.PLAY_REQUESTED || state === this._engine.STATES.PLAYING) {
          this.view.activatePauseIcon();
        } else {
          this.view.activatePlayIcon();
        }
      }
    }
  }, {
    key: '_hideDelayedPlaybackChangeIndicator',
    value: function _hideDelayedPlaybackChangeIndicator() {
      if (this.config.indicateScreenClick) {
        this.view.deactivateIcon();
      }
    }
  }, {
    key: '_toggleVideoPlayback',
    value: function _toggleVideoPlayback() {
      this._delayedToggleVideoPlaybackTimeout = null;

      var state = this._engine.getState();

      if (state === this._engine.STATES.PLAY_REQUESTED || state === this._engine.STATES.PLAYING) {
        this._engine.pause();
      } else {
        this._engine.play();
      }
    }
  }, {
    key: '_toggleFullScreen',
    value: function _toggleFullScreen() {
      if (this._isInFullScreen) {
        this._exitFullScreen();
      } else {
        this._enterFullScreen();
      }
    }
  }, {
    key: 'hide',
    value: function hide() {
      if (!this.isHidden) {
        this.view.hide();
        this.isHidden = true;
      }
    }
  }, {
    key: 'show',
    value: function show() {
      if (this.isHidden) {
        this.view.show();
        this.isHidden = false;
      }
    }
  }, {
    key: '_enterFullScreen',
    value: function _enterFullScreen() {
      this._eventEmitter.emit(_ui2.default.FULLSCREEN_ENTER_TRIGGERED);
    }
  }, {
    key: '_exitFullScreen',
    value: function _exitFullScreen() {
      this._eventEmitter.emit(_ui2.default.FULLSCREEN_EXIT_TRIGGERED);
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this._unbindEvents();

      clearTimeout(this._delayedToggleVideoPlaybackTimeout);
      this.view.destroy();
      delete this.view;

      delete this._eventEmitter;
      delete this._engine;
      delete this._ui;
    }
  }, {
    key: 'node',
    get: function get() {
      return this.view.getNode();
    }
  }]);

  return Screen;
}();

Screen.View = _screen2.default;
exports.default = Screen;
//# sourceMappingURL=screen.controler.js.map


/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var iPhone = exports.iPhone = /iPhone/.test(navigator.userAgent) && !window.MSStream;
var iPod = exports.iPod = /iPod/.test(navigator.userAgent) && !window.MSStream;
var iPad = exports.iPad = /iPad/.test(navigator.userAgent) && !window.MSStream;
var Android = exports.Android = /(android)/i.test(navigator.userAgent);
//# sourceMappingURL=device-detection.js.map


/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOverallBufferedPercent = getOverallBufferedPercent;
exports.getOverallPlayedPercent = getOverallPlayedPercent;
exports.geOverallBufferLength = geOverallBufferLength;
exports.getNearestBufferSegmentInfo = getNearestBufferSegmentInfo;
function getOverallBufferedPercent(buffered) {
  var currentTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  if (!buffered || !buffered.length || !duration) {
    return 0;
  }

  var info = getNearestBufferSegmentInfo(buffered, currentTime);

  return (info.end / duration * 100).toFixed(1);
}

function getOverallPlayedPercent() {
  var currentTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (!duration) {
    return 0;
  }

  return (currentTime / duration * 100).toFixed(1);
}

function geOverallBufferLength(buffered) {
  var size = 0;

  if (!buffered || !buffered.length) {
    return size;
  }

  for (var i = 0; i < buffered.length; i += 1) {
    size += buffered.end(i) - buffered.start(i);
  }

  return size;
}

function getNearestBufferSegmentInfo(buffered, currentTime) {
  var i = 0;

  if (!buffered || !buffered.length) {
    return null;
  }

  while (i < buffered.length - 1 && !(buffered.start(i) <= currentTime && currentTime <= buffered.end(i))) {
    i += 1;
  }

  return {
    start: buffered.start(i),
    end: buffered.end(i)
  };
}
//# sourceMappingURL=video-data.js.map


/***/ }),
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_default_settings__ = __webpack_require__(64);


// This settings will set only for new widget installations
// old installations will use old settings
// IMPORTANT! Use it for overriding existed settings only
/* harmony default export */ __webpack_exports__["a"] = (_.merge({}, __WEBPACK_IMPORTED_MODULE_0_default_settings__["c" /* default */], {
  numbers: {
    settingsVersion: 1
  },
  booleans: {
    showChannelCategories: false
  }
}));

/***/ }),
/* 1241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  CLOSED_BY_USER: 'closed-by-user',
  SUCCEED: 'succeed'
});

/***/ }),
/* 1242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BI_EVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BiHandler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_utils_wix_sdk__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_bi_bi_with_state_defaults__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_utils_comp_id__ = __webpack_require__(424);







var _dec, _class, _desc, _value, _class2, _class3, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}







var BI_EVENT = 'BI_EVENT';
var currentCompId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_shared_utils_comp_id__["a" /* getCompId */])();

/*
  ATTENTION:
  This class is designed to use in widget only yet.
  Do not use in overlays (full screen modals) just to have ONLY SINGLE INSTANCE of BiHandler per app.
 */
var BiHandler = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["a" /* connect */])(function (store) {
  return {
    sendEvent: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_shared_bi_bi_with_state_defaults__["b" /* createSender */])(store)
  };
}), _dec(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(BiHandler, _React$Component);

  function BiHandler() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, BiHandler);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (BiHandler.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(BiHandler)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(BiHandler, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      __WEBPACK_IMPORTED_MODULE_7_shared_utils_wix_sdk__["a" /* default */].PubSub.subscribe(BI_EVENT, this.sendBiEvent);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      __WEBPACK_IMPORTED_MODULE_7_shared_utils_wix_sdk__["a" /* default */].PubSub.unsubscribe(BI_EVENT, this.sendBiEvent);
    }
  }, {
    key: 'sendBiEvent',
    value: function sendBiEvent(_ref) {
      var data = _ref.data;
      var eventName = data.eventName,
          params = data.params,
          targetCompId = data.targetCompId;

      if (targetCompId === currentCompId) {
        this.props.sendEvent(eventName, params);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return BiHandler;
}(React.Component), _class3.propTypes = {
  sendEvent: React.PropTypes.func
}, _class3.contextTypes = {
  store: React.PropTypes.object
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'sendBiEvent', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'sendBiEvent'), _class2.prototype)), _class2)) || _class);


/***/ }),
/* 1243 */,
/* 1244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_components_modal_header_header__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__header_mobile_styl__ = __webpack_require__(1483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__header_mobile_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__header_mobile_styl__);





/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return React.createElement(__WEBPACK_IMPORTED_MODULE_1_shared_components_modal_header_header__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
    className: __WEBPACK_IMPORTED_MODULE_2__header_mobile_styl___default.a.header,
    titleClassName: __WEBPACK_IMPORTED_MODULE_2__header_mobile_styl___default.a.title,
    buttonClassName: __WEBPACK_IMPORTED_MODULE_2__header_mobile_styl___default.a['close-button'],
    showHelpLink: false }));
});

/***/ }),
/* 1245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  WIDGET: 'widget',
  FULL_SCREEN_MODALS: 'full-screen-modals'
});

/***/ }),
/* 1246 */,
/* 1247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  QUERY: 'query',
  TAG: 'tag',
  CATEGORY: 'category'
});

/***/ }),
/* 1248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_redux_helpers_counter__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_redux_server_actions_channel_videos_list__ = __webpack_require__(149);


var _handleActions;







/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["handleActions"])((_handleActions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_3_shared_redux_server_actions_channel_videos_list__["b" /* NAMES */].START, __WEBPACK_IMPORTED_MODULE_2_shared_redux_helpers_counter__["a" /* increment */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_3_shared_redux_server_actions_channel_videos_list__["b" /* NAMES */].SUCCESS, __WEBPACK_IMPORTED_MODULE_2_shared_redux_helpers_counter__["b" /* decrement */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_3_shared_redux_server_actions_channel_videos_list__["b" /* NAMES */].FAIL, __WEBPACK_IMPORTED_MODULE_2_shared_redux_helpers_counter__["b" /* decrement */]), _handleActions), 0));

/***/ }),
/* 1249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_redux_helpers_normalized__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_redux_helpers_ids__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_redux_server_actions_channel_videos_list__ = __webpack_require__(149);


var _handleActions;








/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["handleActions"])((_handleActions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_4_shared_redux_server_actions_channel_videos_list__["b" /* NAMES */].START, __WEBPACK_IMPORTED_MODULE_3_shared_redux_helpers_ids__["a" /* clear */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_4_shared_redux_server_actions_channel_videos_list__["b" /* NAMES */].SUCCESS, __WEBPACK_IMPORTED_MODULE_2_shared_redux_helpers_normalized__["f" /* getResult */]), _handleActions), []));

/***/ }),
/* 1250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ids__ = __webpack_require__(1249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__active_requests__ = __webpack_require__(1248);





/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])({
  ids: __WEBPACK_IMPORTED_MODULE_1__ids__["a" /* default */],
  activeRequests: __WEBPACK_IMPORTED_MODULE_2__active_requests__["a" /* default */]
}));

/***/ }),
/* 1251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_redux_helpers_counter__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dashboard_redux_server_actions_videos_list__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dashboard_redux_server_actions_videos_search__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dashboard_redux_server_actions_video_get__ = __webpack_require__(567);


var _handleActions;









/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["handleActions"])((_handleActions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_3_dashboard_redux_server_actions_videos_list__["a" /* NAMES */].START, __WEBPACK_IMPORTED_MODULE_2_shared_redux_helpers_counter__["a" /* increment */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_4_dashboard_redux_server_actions_videos_search__["a" /* NAMES */].START, __WEBPACK_IMPORTED_MODULE_2_shared_redux_helpers_counter__["a" /* increment */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_5_dashboard_redux_server_actions_video_get__["a" /* NAMES */].START, __WEBPACK_IMPORTED_MODULE_2_shared_redux_helpers_counter__["a" /* increment */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_3_dashboard_redux_server_actions_videos_list__["a" /* NAMES */].SUCCESS, __WEBPACK_IMPORTED_MODULE_2_shared_redux_helpers_counter__["b" /* decrement */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_4_dashboard_redux_server_actions_videos_search__["a" /* NAMES */].SUCCESS, __WEBPACK_IMPORTED_MODULE_2_shared_redux_helpers_counter__["b" /* decrement */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_5_dashboard_redux_server_actions_video_get__["a" /* NAMES */].SUCCESS, __WEBPACK_IMPORTED_MODULE_2_shared_redux_helpers_counter__["b" /* decrement */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_3_dashboard_redux_server_actions_videos_list__["a" /* NAMES */].FAIL, __WEBPACK_IMPORTED_MODULE_2_shared_redux_helpers_counter__["b" /* decrement */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_4_dashboard_redux_server_actions_videos_search__["a" /* NAMES */].FAIL, __WEBPACK_IMPORTED_MODULE_2_shared_redux_helpers_counter__["b" /* decrement */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_5_dashboard_redux_server_actions_video_get__["a" /* NAMES */].FAIL, __WEBPACK_IMPORTED_MODULE_2_shared_redux_helpers_counter__["b" /* decrement */]), _handleActions), 0));

/***/ }),
/* 1252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_redux_helpers_normalized__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_redux_helpers_ids__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_utils_video_helpers_statuses__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dashboard_redux_server_actions_videos_list__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dashboard_redux_server_actions_videos_search__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_dashboard_redux_server_actions_videos_remove__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_dashboard_redux_server_actions_videos_create__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_dashboard_redux_client_actions_videos_remove__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_dashboard_redux_server_actions_video_upload__ = __webpack_require__(536);



var _handleActions;














function responseWithFakeIds(state, _ref) {
  var payload = _ref.payload;
  var result = payload.response.data.result;

  var fakeIds = _.filter(state, function (id) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_shared_utils_video_helpers_statuses__["b" /* isFake */])({ id: id });
  });
  return _.uniq([].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(fakeIds), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(result)));
}

function prependResult(state, _ref2) {
  var payload = _ref2.payload;
  var result = payload.response.data.result;

  return _.uniq([].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(_.castArray(result)), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(state)));
}

function replaceIdsFromParamsWithResult(state, _ref3) {
  var payload = _ref3.payload;

  var ids = _.map(_.castArray(payload.params), 'id');
  var result = _.castArray(payload.response.data.result);

  return _.uniq(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_redux_helpers_ids__["b" /* replaceIds */])(state, ids, result));
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])((_handleActions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_6_dashboard_redux_server_actions_videos_list__["a" /* NAMES */].SUCCESS, responseWithFakeIds), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_7_dashboard_redux_server_actions_videos_search__["a" /* NAMES */].SUCCESS, __WEBPACK_IMPORTED_MODULE_3_shared_redux_helpers_normalized__["f" /* getResult */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_10_dashboard_redux_client_actions_videos_remove__["a" /* NAMES */].SUCCESS, __WEBPACK_IMPORTED_MODULE_4_shared_redux_helpers_ids__["c" /* excludeVideoIdsFromPrams */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_8_dashboard_redux_server_actions_videos_remove__["a" /* NAMES */].START, __WEBPACK_IMPORTED_MODULE_4_shared_redux_helpers_ids__["c" /* excludeVideoIdsFromPrams */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_11_dashboard_redux_server_actions_video_upload__["a" /* NAMES */].START, prependResult), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_9_dashboard_redux_server_actions_videos_create__["a" /* NAMES */].START, prependResult), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_11_dashboard_redux_server_actions_video_upload__["a" /* NAMES */].ITEM_CREATED, replaceIdsFromParamsWithResult), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_9_dashboard_redux_server_actions_videos_create__["a" /* NAMES */].ITEM_CREATED, replaceIdsFromParamsWithResult), _handleActions), []));

/***/ }),
/* 1253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ids__ = __webpack_require__(1252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__active_requests__ = __webpack_require__(1251);





/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])({
  ids: __WEBPACK_IMPORTED_MODULE_1__ids__["a" /* default */],
  activeRequests: __WEBPACK_IMPORTED_MODULE_2__active_requests__["a" /* default */]
}));

/***/ }),
/* 1254 */,
/* 1255 */,
/* 1256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = updateCSS;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toArray__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__colors__ = __webpack_require__(1579);





var REGEXPS = {
  get VARIABLE() {
    return (/([^*])(-wix-([\w.-]+))/g
    );
  },
  get REPLACED_VARIABLE() {
    return (/([^*])\/\*\*\/.+?\/\*(-wix-([\w.-]+))\*\//g
    );
  },
  get OPACITY() {
    return (/-(\d{1,3})$/
    );
  },
  get COLOR() {
    return (/rgb|^#/i
    );
  },
  get FONT_PROPERTY() {
    return (/-(family|style|weight|size|decoration)$/i
    );
  }
};

function isColor(value) {
  return REGEXPS.COLOR.test(value);
}

function isFont(value) {
  return REGEXPS.FONT_PROPERTY.test(value);
}

function hasOpacity(value) {
  return REGEXPS.OPACITY.test(value);
}

function getStyleValue(propName, styles) {
  var regexp = new RegExp(propName + ':\\s*([^;]+)(?:;|$)', 'i');

  var matched = regexp.exec(styles);

  if (!matched) {
    return null;
  }

  var value = matched[1];

  // just text-decoration - return value
  if (propName === 'text-decoration') {
    return value;
  }

  // font value - split it and return needed path

  var _value$split = value.split(' '),
      _value$split2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toArray___default()(_value$split),
      style = _value$split2[0],
      weight = _value$split2[2],
      sizeLH = _value$split2[3],
      family = _value$split2.slice(4);

  var _sizeLH$split = sizeLH.split('/'),
      _sizeLH$split2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_sizeLH$split, 2),
      size = _sizeLH$split2[0],
      lineHeight = _sizeLH$split2[1];

  var joinedFamily = family.join(' ') + ',ruble';

  return {
    style: style,
    weight: weight,
    size: size,
    'line-height': lineHeight,
    family: joinedFamily
  };
}

function getFontPropertyValue(styles, variableName) {
  var propName = REGEXPS.FONT_PROPERTY.exec(variableName)[1];

  switch (propName) {
    case 'decoration':
      return getStyleValue('text-decoration', styles);
    default:
      return getStyleValue('font', styles)[propName];
  }
}

function addOpacity(color, variableName) {
  var opacity = Number(REGEXPS.OPACITY.exec(variableName)[1]);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__colors__["a" /* makeRGBA */])(color, opacity / 100);
}

function replaceVariables(settings, replaceableText, prefix, name, path) {
  path = path.replace(/-$/, '').replace(REGEXPS.OPACITY, '').replace(REGEXPS.FONT_PROPERTY, '').split('-');

  var value = _.get(settings, [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(path), ['value'])) || _.get(settings, path);

  if (!_.isString(value)) {
    return replaceableText;
  }

  if (isColor(value) && hasOpacity(name)) {
    value = addOpacity(value, name);
  }

  if (isFont(name)) {
    value = getFontPropertyValue(value, name);
  }

  return prefix + '/**/' + value + '/*' + name + '*/';
}

function updateDefautValues(settings) {
  settings = _.clone(settings);

  _.forEach(['colors', 'fonts'], function (prop) {
    settings[prop] = settings[prop] || {};

    try {
      var text = document.getElementById('default-' + prop).innerHTML.replace('/*', '').replace('*/', '').replace(/'.*?'/g, function (o) {
        return o.replace(/"/g, '\\"');
      }).replace(/'/g, '"');

      var obj = JSON.parse(text);
      _.forEach(obj, function (value, key) {
        settings[prop][key] = value;
      });
    } catch (error) {
      // do nothing
    }
  });

  return settings;
}

function updateCSS(settings) {
  settings = updateDefautValues(settings);

  _(document.querySelectorAll('style')).reject('id').filter(function (_ref) {
    var innerHTML = _ref.innerHTML;
    return REGEXPS.VARIABLE.test(innerHTML) || REGEXPS.REPLACED_VARIABLE.test(innerHTML);
  }).forEach(function (styleTag) {

    var replaceFromCurrentSettings = _.partial(replaceVariables, settings);
    var newCss = styleTag.innerHTML.replace(REGEXPS.REPLACED_VARIABLE, replaceFromCurrentSettings).replace(REGEXPS.VARIABLE, replaceFromCurrentSettings);

    if (styleTag.styleSheet) {
      styleTag.styleSheet.cssText = newCss;
    } else {
      styleTag.innerHTML = newCss;
    }
  });
}

/***/ }),
/* 1257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* defineMessages */])({
  signIn: {
    id: 'widget.account.sign-in',
    defaultMessage: 'Sign in'
  },
  signInToComplete1: {
    id: 'widget.account.sign-in-to-complete.part-1',
    defaultMessage: 'Sign in to complete'
  },
  signInToComplete2: {
    id: 'widget.account.sign-in-to-complete.part-2',
    defaultMessage: 'your purchase'
  },
  signInToWatch1: {
    id: 'widget.account.sign-in-to-watch.part-1',
    defaultMessage: 'Sign up to watch this video.'
  },
  signInToWatch2: {
    id: 'widget.account.sign-in-to-watch.part-2',
    defaultMessage: 'It\'ll only take a sec.'
  },
  signUp: {
    id: 'widget.account.sign-up',
    defaultMessage: 'Sign up'
  },
  logout: {
    id: 'widget.account.logout',
    defaultMessage: 'Log out'
  },
  forgotPassword: {
    id: 'widget.account.forgot-password',
    defaultMessage: 'Forgot Password'
  },
  myAccount: {
    id: 'widget.account.my-account',
    defaultMessage: 'My account'
  },
  email: {
    id: 'widget.account.email',
    defaultMessage: 'Email'
  },
  password: {
    id: 'widget.account.password',
    defaultMessage: 'Password'
  },
  notHaveAccount: {
    id: 'widget.account.not-have-account',
    defaultMessage: 'Don’t have an account?'
  },
  haveAccount: {
    id: 'widget.account.have-account',
    defaultMessage: 'Already have an account?'
  },
  forgotPasswordQuestion: {
    id: 'widget.account.forgot-password.question',
    defaultMessage: 'Forgot password?'
  },
  forgotPasswordMessage1: {
    id: 'widget.account.forgot-password.message1',
    defaultMessage: 'Fill in the email address you signed up with and we will email you a reset link.'
  },
  forgotPasswordMessage2: {
    id: 'widget.account.forgot-password.message2',
    defaultMessage: 'No worries, everything will be here when you return to complete you purchase.'
  },
  forgotPasswordSubmitted1: {
    id: 'widget.account.forgot-password.submitted1',
    defaultMessage: 'We’ve emailed a link to reset your password to "{email}".'
  },
  forgotPasswordSubmitted2: {
    id: 'widget.account.forgot-password.submitted2',
    defaultMessage: 'We’ll be snacking some popcorn until you are done.'
  },
  gotIt: {
    id: 'widget.account.forgot-password.got-it',
    defaultMessage: 'Got it!'
  },
  back: {
    id: 'widget.account.back',
    defaultMessage: 'Back'
  },
  backToSignIn: {
    id: 'widget.account.back-to-sign-in',
    defaultMessage: 'Back to sign in'
  },
  sendLink: {
    id: 'widget.account.send-link',
    defaultMessage: 'Send me a link'
  },
  resetPassword: {
    id: 'widget.account.reset-password',
    defaultMessage: 'Reset Password'
  },
  resetPasswordMessage: {
    id: 'widget.account.reset-password.linkText',
    defaultMessage: 'To set your new password, please enter it in both fields below.'
  },
  resetPasswordButton: {
    id: 'widget.account.reset-password.button',
    defaultMessage: 'Reset password'
  },
  enterNewPassword: {
    id: 'widget.account.reset-password.enter-new-password',
    defaultMessage: 'Enter a new password'
  },
  verifyPassword: {
    id: 'widget.account.reset-password.verify-password',
    defaultMessage: 'Verify password'
  },
  resetComplete: {
    id: 'widget.account.reset-password.complete',
    defaultMessage: 'You’ve successfully reset your password!'
  },
  continueToSite: {
    id: 'widget.account.reset-password.continue-to-site',
    defaultMessage: 'Continue to site'
  },
  readyAction: {
    id: 'widget.account.ready-action',
    defaultMessage: 'Ready for action!'
  },
  signedAs: {
    id: 'widget.account.signed-as',
    defaultMessage: 'You are signed in as:'
  },
  notYourAccount: {
    id: 'widget.account.not-your-account',
    defaultMessage: 'Not your account?'
  }
}));

/***/ }),
/* 1258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_TRANSLATIONS; });
/* unused harmony export isVisible */
/* harmony export (immutable) */ __webpack_exports__["a"] = renderPlayButtonText;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_translations_overlay_common_translations__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_widget_ui_selectors_video_access__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__video_play_button_text__ = __webpack_require__(628);






var DEFAULT_TRANSLATIONS = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_4__video_play_button_text__["b" /* DEFAULT_TRANSLATIONS */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_3_widget_ui_selectors_video_access__["e" /* AVAILABLE_VIDEO_TYPES */].FULL, __WEBPACK_IMPORTED_MODULE_2_shared_translations_overlay_common_translations__["a" /* default */].startWatching));

/**
 * Is video play button visible
 * @param props {Object}
 * @param props.channel {Object}
 * @param props.video {Object}
 * @param props.currentSiteUser {Object}
 * @return {Boolean}
 */
var isVisible = __WEBPACK_IMPORTED_MODULE_4__video_play_button_text__["c" /* isVisible */];

/**
 * Video play button text
 * @param props {Object}
 * @param props.channel {Object}
 * @param props.video {Object}
 * @param props.currentSiteUser {Object}
 * @param props.translations {Object} see DEFAULT_TRANSLATIONS
 * @return {React.Component}
 */
function renderPlayButtonText(props) {
  props.translations = props.translations || DEFAULT_TRANSLATIONS;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__video_play_button_text__["a" /* default */])(props);
}

/***/ }),
/* 1259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = isVisible;
/* harmony export (immutable) */ __webpack_exports__["a"] = renderSubscribeButtonText;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_utils_deal_info_helpers__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_translations_overlay_common_translations__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__format_message_with_deal_info__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_widget_ui_selectors_video_access__ = __webpack_require__(94);





/**
 * Is channel subscribe button visible
 * @param props {Object}
 * @param props.channel {Object}
 * @param props.video {Object}
 * @return {Boolean}
 */
function isVisible(_ref) {
  var channel = _ref.channel,
      video = _ref.video;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_widget_ui_selectors_video_access__["d" /* getFullAccessActionName */])(channel, video) === __WEBPACK_IMPORTED_MODULE_3_widget_ui_selectors_video_access__["c" /* FULL_ACCESS_ACTION_NAMES */].SUBSCRIBE;
}

/**
 * Channel subscribe button text
 * @param props {Object}
 * @param props.channel {Object}
 * @param props.video {Object}
 * @param props.translation {Object} default is commonTranslations.getSubscription
 * @return {React.Component}
 */
function renderSubscribeButtonText(props) {
  if (!isVisible(props)) {
    return null;
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__format_message_with_deal_info__["a" /* default */])(props.translation || __WEBPACK_IMPORTED_MODULE_1_shared_translations_overlay_common_translations__["a" /* default */].getSubscription, __WEBPACK_IMPORTED_MODULE_0_shared_utils_deal_info_helpers__["a" /* getSubscriptionPriceInfo */](props.channel.dealInfo));
}

/***/ }),
/* 1260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MobilePlayer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__player_wrapper__ = __webpack_require__(1548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_widget_components_player_overlay_mobile_member_only__ = __webpack_require__(1582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_widget_redux_client_actions_change_playback_status__ = __webpack_require__(164);








var _dec, _class, _desc, _value, _class2, _class3, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}









function getDependentProps(paused) {
  return {
    playAtFullScreen: !paused,
    showInitialOverlay: paused
  };
}

// TODO: Move to HOC PlayAtFullScreenOnly and use at components instead of nesting
// https://jira.wixpress.com/browse/VOD-209
var MobilePlayer = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_redux__["a" /* connect */])(null, function () {
  return {
    pauseVideo: __WEBPACK_IMPORTED_MODULE_11_widget_redux_client_actions_change_playback_status__["e" /* pauseVideo */]
  };
}), _dec(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(MobilePlayer, _React$Component);

  function MobilePlayer(props) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, MobilePlayer);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (MobilePlayer.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(MobilePlayer)).call(this, props));

    _this.state = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, getDependentProps(props.paused), {
      paused: props.paused
    });
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(MobilePlayer, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var paused = nextProps.paused;
      var isInFullScreen = this.state.isInFullScreen;

      if (this.props.paused !== paused) {
        var newState = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, getDependentProps(paused), {
          paused: paused
        });

        // do not show overlay when in full screen (android case)
        if (paused && isInFullScreen) {
          newState.showInitialOverlay = false;
        }

        this.setState(newState);
      }
    }
  }, {
    key: 'onPlayStart',
    value: function onPlayStart() {
      this.props.onPlayStart();

      this.setState(getDependentProps(false));
    }
  }, {
    key: 'onFullScreenChanged',
    value: function onFullScreenChanged(isInFullScreen) {
      this.props.onFullScreenChanged(isInFullScreen);

      var state = {
        isInFullScreen: isInFullScreen
      };

      if (!isInFullScreen) {
        this.props.pauseVideo();
        var newPaused = true;

        state = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state, {
          paused: newPaused
        }, getDependentProps(newPaused));
      }

      this.setState(state);
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          playAtFullScreen = _state.playAtFullScreen,
          paused = _state.paused,
          showInitialOverlay = _state.showInitialOverlay;
      var memberOnlyOverlay = this.props.memberOnlyOverlay;


      var props = _.omit(this.props, 'paused', 'mobileMode', 'playAtFullScreen', 'onFullScreenChanged', 'memberOnlyOverlay', 'onPurchaseClick', 'onSubscribeClick');

      return React.createElement(__WEBPACK_IMPORTED_MODULE_9__player_wrapper__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, props, {
        mobileMode: true,
        paused: paused,
        playAtFullScreen: playAtFullScreen,
        showInitialOverlay: showInitialOverlay,
        onPlayStart: this.onPlayStart,
        onFullScreenChanged: this.onFullScreenChanged,
        memberOnlyOverlay: memberOnlyOverlay || React.createElement(__WEBPACK_IMPORTED_MODULE_10_widget_components_player_overlay_mobile_member_only__["b" /* default */], null) }));
    }
  }]);

  return MobilePlayer;
}(React.Component), _class3.propTypes = _.omit(__WEBPACK_IMPORTED_MODULE_9__player_wrapper__["a" /* default */].propTypes, ['mobileMode', 'playAtFullScreen', 'showInitialOverlay', 'onPurchaseClick', 'onSubscribeClick']), _class3.defaultProps = {
  onFullScreenChanged: _.noop,
  onPlayStart: _.noop
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onPlayStart', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'onPlayStart'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onFullScreenChanged', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'onFullScreenChanged'), _class2.prototype)), _class2)) || _class);


/***/ }),
/* 1261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* defineMessages */])({
  previewMode: {
    id: 'widget.preview-prompt.preview-mode',
    defaultMessage: 'Preview Mode'
  },
  youInPreview1: {
    id: 'widget.preview-prompt.you-in-preview.line1',
    defaultMessage: 'Hey, you’re in Preview mode.'
  },
  youInPreview2: {
    id: 'widget.preview-prompt.you-in-preview.line2',
    defaultMessage: 'This feature works on your live site once it’s published.'
  },
  gotIt: {
    id: 'widget.preview-prompt.got-it',
    defaultMessage: 'Got it!'
  }
}));

/***/ }),
/* 1262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DATA_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NextChannelVideosLoader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_multireducer__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_multireducer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_multireducer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_selectors_channel_videos__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_widget_redux_client_actions_channel_videos_lazy_load__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_data_components_data_loader__ = __webpack_require__(236);






var _dec, _class, _class2, _temp2;










var DATA_KEY = 'next-videos';
var PER_PAGE_COUNT = 20;

var NextChannelVideosLoader = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["a" /* connect */])(function (state) {
  return {
    ids: state.lazyVideoLists[DATA_KEY].videoIds,
    nextVideosCursor: state.lazyVideoLists[DATA_KEY].nextVideosCursor,
    isFetching: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_shared_selectors_channel_videos__["a" /* isFetching */])(state)
  };
}, function (dispatch) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_multireducer__["bindActionCreators"])({
    loadFirstPage: __WEBPACK_IMPORTED_MODULE_8_widget_redux_client_actions_channel_videos_lazy_load__["a" /* loadFirstPage */],
    loadMore: __WEBPACK_IMPORTED_MODULE_8_widget_redux_client_actions_channel_videos_lazy_load__["b" /* loadMore */]
  }, dispatch, DATA_KEY);
}), _dec(_class = (_temp2 = _class2 = function (_DataLoader) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(NextChannelVideosLoader, _DataLoader);

  function NextChannelVideosLoader() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, NextChannelVideosLoader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = NextChannelVideosLoader.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(NextChannelVideosLoader)).call.apply(_ref, [this].concat(args))), _this), _this.dependencies = ['channelId', 'currentVideoId', 'nextVideosCursor'], _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(NextChannelVideosLoader, [{
    key: 'loadData',
    value: function loadData() {
      var _props = this.props,
          channelId = _props.channelId,
          loadFirstPage = _props.loadFirstPage,
          loadMore = _props.loadMore,
          ids = _props.ids,
          currentVideoId = _props.currentVideoId,
          nextVideosCursor = _props.nextVideosCursor;


      if (!channelId || !currentVideoId) {
        return;
      }

      if (!ids || !ids.length) {
        return loadFirstPage(PER_PAGE_COUNT, {});
      }

      if (!this.isAllVideosLoaded && !this.nextVideoId) {
        return loadMore(PER_PAGE_COUNT, nextVideosCursor);
      }
    }
  }, {
    key: 'currentIdIndex',
    get: function get() {
      var _props2 = this.props,
          ids = _props2.ids,
          currentVideoId = _props2.currentVideoId;

      return ids.indexOf(currentVideoId);
    }
  }, {
    key: 'isAllVideosLoaded',
    get: function get() {
      return !this.props.nextVideosCursor;
    }
  }, {
    key: 'prevVideoId',
    get: function get() {
      var ids = this.props.ids;

      var currentIdIndex = this.currentIdIndex;

      if (currentIdIndex === -1) {
        return null;
      }

      var prevId = ids[currentIdIndex - 1];

      return prevId || null;
    }
  }, {
    key: 'nextVideoId',
    get: function get() {
      var ids = this.props.ids;

      var currentIdIndex = this.currentIdIndex;

      if (currentIdIndex === -1) {
        return null;
      }

      var nextId = ids[currentIdIndex + 1];

      return nextId || null;
    }
  }, {
    key: 'childProps',
    get: function get() {
      var _props3 = this.props,
          isFetching = _props3.isFetching,
          ids = _props3.ids;
      var currentIdIndex = this.currentIdIndex;


      return {
        nextChannelVideos: {
          prevId: this.prevVideoId,
          nextId: this.nextVideoId,
          loadedVideoIds: ids,
          currentIdIndex: currentIdIndex,
          isFetching: isFetching
        }
      };
    }
  }]);

  return NextChannelVideosLoader;
}(__WEBPACK_IMPORTED_MODULE_9_shared_data_components_data_loader__["a" /* default */]), _class2.displayName = 'NextVideosLoader', _class2.propTypes = {
  loadFirstPage: React.PropTypes.func,
  nextVideosCursor: React.PropTypes.string,
  channelId: React.PropTypes.string,
  currentVideoId: React.PropTypes.string
}, _temp2)) || _class);


/***/ }),
/* 1263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReloadChannelPaymentDataOnPayment; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_debounce__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_components_payment_events_payment_events__ = __webpack_require__(381);







var _desc, _value, _class, _class2, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}






var ReloadChannelPaymentDataOnPayment = (_class = (_temp = _class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ReloadChannelPaymentDataOnPayment, _React$Component);

  function ReloadChannelPaymentDataOnPayment() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ReloadChannelPaymentDataOnPayment);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ReloadChannelPaymentDataOnPayment.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(ReloadChannelPaymentDataOnPayment)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ReloadChannelPaymentDataOnPayment, [{
    key: 'fetchChannelPaymentData',
    value: function fetchChannelPaymentData() {
      var channelPaymentData = this.props.channelPaymentData;


      if (channelPaymentData) {
        channelPaymentData.fetch();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(__WEBPACK_IMPORTED_MODULE_8_shared_components_payment_events_payment_events__["a" /* default */], { onAnyEvent: this.fetchChannelPaymentData });
    }
  }]);

  return ReloadChannelPaymentDataOnPayment;
}(React.Component), _class2.propTypes = {
  channelPaymentData: React.PropTypes.object
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'fetchChannelPaymentData', [__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default.a, __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_debounce___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'fetchChannelPaymentData'), _class.prototype)), _class);


/***/ }),
/* 1264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_widget_player_widget_utils_wix_connect__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_widget_player_widget_components_icon_icon__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__action_button_styl__ = __webpack_require__(1489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__action_button_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__action_button_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__context_types__ = __webpack_require__(62);







var _dec, _class, _desc, _value, _class2, _class3, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}












var ActionButton = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_widget_player_widget_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_10__action_button_styl___default.a), _dec(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ActionButton, _React$Component);

  function ActionButton() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ActionButton);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ActionButton.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(ActionButton)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ActionButton, [{
    key: 'handleClick',
    value: function handleClick(event) {
      event.stopPropagation();
      event.preventDefault();

      this.props.onClick();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          rounded = _props.rounded,
          label = _props.label,
          icon = _props.icon,
          className = _props.className;
      var fullScreen = this.context.fullScreen;


      var styleNames = __WEBPACK_IMPORTED_MODULE_7_classnames___default()('action-button', {
        rounded: rounded,
        'with-label': Boolean(label),
        'at-full-screen': fullScreen
      });

      return React.createElement(
        'a',
        { href: '#',
          styleName: styleNames,
          className: className,
          onClick: this.handleClick },
        this.label,
        React.createElement(__WEBPACK_IMPORTED_MODULE_9_widget_player_widget_components_icon_icon__["a" /* default */], { styleName: 'icon',
          name: icon })
      );
    }
  }, {
    key: 'label',
    get: function get() {
      var label = this.props.label;

      if (!label) {
        return null;
      }

      return React.createElement(
        'span',
        { styleName: 'label' },
        label
      );
    }
  }]);

  return ActionButton;
}(React.Component), _class3.contextTypes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__context_types__["b" /* pickContextTypes */])('fullScreen'), _class3.propTypes = {
  rounded: React.PropTypes.bool,
  icon: React.PropTypes.string,
  label: React.PropTypes.any,
  onClick: React.PropTypes.func,
  children: React.PropTypes.element,
  className: React.PropTypes.string
}, _class3.defaultProps = {
  rounded: false,
  onClick: _.noop
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'handleClick', [__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handleClick'), _class2.prototype)), _class2)) || _class);


/***/ }),
/* 1265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Controls; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_widget_player_widget_utils_wix_connect__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__context_types__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__progress_progress__ = __webpack_require__(1269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__play_play__ = __webpack_require__(1268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__time_time__ = __webpack_require__(1270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__volume_volume__ = __webpack_require__(1271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__fullscreen_fullscreen__ = __webpack_require__(1266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__controls_styl__ = __webpack_require__(1491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__controls_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__controls_styl__);






var _dec, _class, _class2, _temp;














var Controls = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_widget_player_widget_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_13__controls_styl___default.a), _dec(_class = (_temp = _class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Controls, _React$Component);

  function Controls() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Controls);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Controls.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Controls)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Controls, [{
    key: 'render',
    value: function render() {
      var className = this.props.className;
      var _context = this.context,
          paused = _context.paused,
          beenPlayed = _context.beenPlayed,
          ended = _context.ended,
          simple = _context.simple,
          mobileMode = _context.mobileMode,
          fullScreen = _context.fullScreen;

      // in simple mode we always show controls

      if (!simple) {
        // in mobile mode we show controls only if video is in fullscreen mode
        if (mobileMode && !fullScreen) {
          return null;
        } else if (!beenPlayed || ended) {
          return null;
        }
      }

      var styleNames = __WEBPACK_IMPORTED_MODULE_5_classnames___default()('controls', {
        simple: simple,
        'mobile-mode': mobileMode,
        'at-full-screen': fullScreen,
        paused: paused,
        mobileMode: mobileMode
      });

      return React.createElement(
        'section',
        null,
        this.props.children,
        React.createElement(
          'section',
          { styleName: styleNames,
            className: className },
          React.createElement(
            'section',
            { styleName: 'controls-row',
              className: 'qa-player-controls-row' },
            React.createElement(__WEBPACK_IMPORTED_MODULE_9__play_play__["a" /* default */], { styleName: 'play',
              className: 'qa-player-play' }),
            React.createElement(__WEBPACK_IMPORTED_MODULE_10__time_time__["a" /* default */], { styleName: 'time',
              className: 'qa-player-time' }),
            React.createElement(__WEBPACK_IMPORTED_MODULE_8__progress_progress__["a" /* default */], { styleName: 'progress',
              className: 'qa-player-progress' }),
            React.createElement(__WEBPACK_IMPORTED_MODULE_11__volume_volume__["a" /* default */], { styleName: 'volume',
              className: 'qa-player-volume' }),
            React.createElement(__WEBPACK_IMPORTED_MODULE_12__fullscreen_fullscreen__["a" /* default */], { styleName: 'fullscreen' })
          )
        )
      );
    }
  }]);

  return Controls;
}(React.Component), _class2.contextTypes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__context_types__["b" /* pickContextTypes */])('paused', 'beenPlayed', 'ended', 'simple', 'mobileMode', 'fullScreen'), _class2.propTypes = {
  className: React.PropTypes.string,
  children: React.PropTypes.node
}, _temp)) || _class);


/***/ }),
/* 1266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Fullscreen; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_widget_player_widget_utils_wix_connect__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__context_types__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_widget_player_widget_components_icon_icon__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__control_button_control_button__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fullscreen_styl__ = __webpack_require__(1492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fullscreen_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__fullscreen_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__translations__ = __webpack_require__(1267);






var _dec, _class, _class2, _temp;













var Fullscreen = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_widget_player_widget_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_10__fullscreen_styl___default.a), _dec(_class = (_temp = _class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Fullscreen, _React$Component);

  function Fullscreen() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Fullscreen);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Fullscreen.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Fullscreen)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Fullscreen, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          formatMessage = _props.intl.formatMessage;
      var _context = this.context,
          toggleFullScreenByUser = _context.toggleFullScreenByUser,
          fullScreen = _context.fullScreen;


      var iconName = fullScreen ? 'exit-fullscreen' : 'fullscreen';
      var iconNameHover = iconName + '-hover';

      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_9__control_button_control_button__["a" /* default */],
        { styleName: 'fullscreen-button',
          className: className,
          onClick: toggleFullScreenByUser,
          tooltip: {
            content: formatMessage(__WEBPACK_IMPORTED_MODULE_11__translations__["a" /* default */].enter),
            position: 'left'
          } },
        React.createElement(__WEBPACK_IMPORTED_MODULE_8_widget_player_widget_components_icon_icon__["a" /* default */], { styleName: 'icon icon-' + iconName,
          name: iconName }),
        React.createElement(__WEBPACK_IMPORTED_MODULE_8_widget_player_widget_components_icon_icon__["a" /* default */], { styleName: 'icon icon-' + iconNameHover,
          name: iconNameHover })
      );
    }
  }]);

  return Fullscreen;
}(React.Component), _class2.propTypes = {
  className: React.PropTypes.string,
  intl: __WEBPACK_IMPORTED_MODULE_5_react_intl__["e" /* intlShape */]
}, _class2.contextTypes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__context_types__["b" /* pickContextTypes */])('toggleFullScreenByUser', 'fullScreen'), _temp)) || _class);


/***/ }),
/* 1267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* defineMessages */])({
  enter: {
    id: 'fullscreen.enter',
    defaultMessage: 'Full screen'
  },
  exit: {
    id: 'fullscreen.exit',
    defaultMessage: 'Exit full screen'
  }
}));

/***/ }),
/* 1268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Play; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_widget_player_widget_utils_wix_connect__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__context_types__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_widget_player_widget_components_icon_icon__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__control_button_control_button__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__play_styl__ = __webpack_require__(1493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__play_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__play_styl__);







var _dec, _class, _desc, _value, _class2, _class3, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}












var Play = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_widget_player_widget_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_12__play_styl___default.a), _dec(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Play, _React$Component);

  function Play() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Play);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Play.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Play)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Play, [{
    key: 'togglePause',
    value: function togglePause() {
      var _context = this.context,
          paused = _context.paused,
          togglePause = _context.togglePause;

      togglePause(!paused);
    }
  }, {
    key: 'render',
    value: function render() {
      var className = this.props.className;
      var fullScreen = this.context.fullScreen;


      var iconName = this.iconName;
      var styleNames = __WEBPACK_IMPORTED_MODULE_6_classnames___default()('play', 'play--' + iconName, {
        'at-full-screen': fullScreen
      });

      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_11__control_button_control_button__["a" /* default */],
        { styleName: styleNames,
          className: className,
          onClick: this.togglePause },
        React.createElement(__WEBPACK_IMPORTED_MODULE_10_widget_player_widget_components_icon_icon__["a" /* default */], { styleName: 'icon',
          name: iconName })
      );
    }
  }, {
    key: 'iconName',
    get: function get() {
      return this.context.paused ? 'play' : 'pause';
    }
  }]);

  return Play;
}(React.Component), _class3.propTypes = {
  className: React.PropTypes.string
}, _class3.contextTypes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__context_types__["b" /* pickContextTypes */])('togglePause', 'paused', 'fullScreen'), _temp), (_applyDecoratedDescriptor(_class2.prototype, 'togglePause', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'togglePause'), _class2.prototype)), _class2)) || _class);


/***/ }),
/* 1269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Progress; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_widget_player_widget_utils_wix_connect__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_widget_player_widget_components_progress_bar_progress_bar__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__context_types__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__progress_styl__ = __webpack_require__(1494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__progress_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__progress_styl__);







var _dec, _class, _desc, _value, _class2, _class3, _temp2;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}










var Progress = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_widget_player_widget_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_11__progress_styl___default.a), _dec(_class = (_class2 = (_temp2 = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Progress, _React$Component);

  function Progress() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Progress);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Progress.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Progress)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      focused: false
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Progress, [{
    key: 'seek',
    value: function seek(_ref2) {
      var target = _ref2.target;
      var _context = this.context,
          seek = _context.seek,
          duration = _context.duration;

      seek(target.value * duration / 100);
    }
  }, {
    key: 'onFocus',
    value: function onFocus() {
      this.setState({ focused: true });
    }
  }, {
    key: 'onBlur',
    value: function onBlur() {
      this.setState({ focused: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var className = this.props.className;
      var focused = this.state.focused;
      var _context2 = this.context,
          percentageBuffered = _context2.percentageBuffered,
          percentagePlayed = _context2.percentagePlayed;


      var styleNames = __WEBPACK_IMPORTED_MODULE_7_classnames___default()('seek', {
        focused: focused
      });

      return React.createElement(
        'div',
        { styleName: styleNames,
          className: className },
        React.createElement(
          'div',
          { styleName: 'container' },
          React.createElement('div', { styleName: 'buffer-bar',
            style: { width: percentageBuffered + '%' } }),
          React.createElement(__WEBPACK_IMPORTED_MODULE_9_widget_player_widget_components_progress_bar_progress_bar__["a" /* default */], { onBlur: this.onBlur,
            onFocus: this.onFocus,
            onChange: this.seek,
            progress: percentagePlayed,
            inputClassName: __WEBPACK_IMPORTED_MODULE_11__progress_styl___default.a['progress-input'],
            fillClassName: __WEBPACK_IMPORTED_MODULE_11__progress_styl___default.a['progress-bar'] })
        )
      );
    }
  }]);

  return Progress;
}(React.Component), _class3.propTypes = {
  className: React.PropTypes.string
}, _class3.contextTypes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__context_types__["b" /* pickContextTypes */])('seek', 'percentageBuffered', 'percentagePlayed', 'duration'), _temp2), (_applyDecoratedDescriptor(_class2.prototype, 'seek', [__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'seek'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onFocus', [__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'onFocus'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onBlur', [__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'onBlur'), _class2.prototype)), _class2)) || _class);


/***/ }),
/* 1270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Time; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_widget_player_widget_utils_wix_connect__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__context_types__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__time_styl__ = __webpack_require__(1495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__time_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__time_styl__);






var _dec, _class, _class2, _temp;








var Time = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_widget_player_widget_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_8__time_styl___default.a), _dec(_class = (_temp = _class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Time, _React$Component);

  function Time() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Time);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Time.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Time)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Time, [{
    key: 'formatTime',
    value: function formatTime(seconds) {
      var date = new Date(null);
      seconds = isNaN(seconds) || !isFinite(seconds) ? 0 : Math.floor(seconds);
      date.setSeconds(seconds);

      // get HH:mm:ss part, remove hours if they are "00:"
      return date.toISOString().substr(11, 8).replace(/^00:/, '');
    }
  }, {
    key: 'render',
    value: function render() {
      var className = this.props.className;
      var _context = this.context,
          currentTime = _context.currentTime,
          duration = _context.duration,
          fullScreen = _context.fullScreen;

      var styleNames = __WEBPACK_IMPORTED_MODULE_5_classnames___default()('time', {
        'at-full-screen': fullScreen
      });

      return React.createElement(
        'div',
        { styleName: styleNames,
          className: className },
        React.createElement(
          'span',
          { styleName: 'time__current' },
          this.formatTime(currentTime)
        ),
        '/',
        React.createElement(
          'span',
          { styleName: 'time__duration' },
          this.formatTime(duration)
        )
      );
    }
  }]);

  return Time;
}(React.Component), _class2.propTypes = {
  className: React.PropTypes.string
}, _class2.contextTypes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__context_types__["b" /* pickContextTypes */])('currentTime', 'duration', 'fullScreen'), _temp)) || _class);


/***/ }),
/* 1271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Volume; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_widget_player_widget_utils_wix_connect__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__context_types__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_widget_player_widget_components_icon_icon__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_widget_player_widget_components_progress_bar_progress_bar__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__control_button_control_button__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__volume_styl__ = __webpack_require__(1496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__volume_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__volume_styl__);







var _dec, _class, _desc, _value, _class2, _class3, _temp, _dec2, _class4, _class5, _temp2;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}













var Tooltip = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_widget_player_widget_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_13__volume_styl___default.a), _dec(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Tooltip, _React$Component);

  function Tooltip() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Tooltip);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Tooltip.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Tooltip)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Tooltip, [{
    key: 'changeVolume',
    value: function changeVolume(e) {
      var _context = this.context,
          toggleMute = _context.toggleMute,
          setVolume = _context.setVolume;


      setVolume(e.target.value / 100);
      toggleMute(false);
    }
  }, {
    key: 'stopEventPropagation',
    value: function stopEventPropagation(event) {
      event.stopPropagation();
    }
  }, {
    key: 'render',
    value: function render() {
      var _context2 = this.context,
          volume = _context2.volume,
          muted = _context2.muted;


      return React.createElement(
        'div',
        { styleName: 'mute__track',
          onClick: this.stopEventPropagation },
        React.createElement(__WEBPACK_IMPORTED_MODULE_11_widget_player_widget_components_progress_bar_progress_bar__["a" /* default */], { orientation: 'vertical',
          styleName: 'level',
          fillClassName: __WEBPACK_IMPORTED_MODULE_13__volume_styl___default.a['level-fill'],
          inputClassName: __WEBPACK_IMPORTED_MODULE_13__volume_styl___default.a['level-input'],
          onChange: this.changeVolume,
          progress: muted ? 0 : volume * 100 })
      );
    }
  }]);

  return Tooltip;
}(React.Component), _class3.contextTypes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__context_types__["b" /* pickContextTypes */])('toggleMute', 'setVolume', 'volume', 'muted'), _temp), (_applyDecoratedDescriptor(_class2.prototype, 'changeVolume', [__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'changeVolume'), _class2.prototype)), _class2)) || _class);
var Volume = (_dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_widget_player_widget_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_13__volume_styl___default.a), _dec2(_class4 = (_temp2 = _class5 = function (_React$Component2) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Volume, _React$Component2);

  function Volume() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Volume);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Volume.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Volume)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Volume, [{
    key: 'render',
    value: function render() {
      var className = this.props.className;
      var _context3 = this.context,
          toggleMute = _context3.toggleMute,
          fullScreen = _context3.fullScreen;

      var styleNames = __WEBPACK_IMPORTED_MODULE_7_classnames___default()('mute', {
        'at-full-screen': fullScreen
      });

      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_12__control_button_control_button__["a" /* default */],
        { styleName: styleNames,
          className: className,
          onClick: toggleMute,
          tooltip: { content: React.createElement(Tooltip, null), position: 'center' } },
        React.createElement(__WEBPACK_IMPORTED_MODULE_10_widget_player_widget_components_icon_icon__["a" /* default */], { styleName: 'icon',
          name: this.volumeIconName })
      );
    }
  }, {
    key: 'volumeIconName',
    get: function get() {
      var _context4 = this.context,
          muted = _context4.muted,
          volume = _context4.volume;

      if (muted || volume <= 0) {
        return 'volume-mute';
      }
      if (volume > 0 && volume <= 0.5) {
        return 'volume-50';
      }

      return 'volume-100';
    }
  }]);

  return Volume;
}(React.Component), _class5.propTypes = {
  className: React.PropTypes.string
}, _class5.contextTypes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__context_types__["b" /* pickContextTypes */])('toggleMute', 'volume', 'muted', 'fullScreen'), _temp2)) || _class4);


/***/ }),
/* 1272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FullscreenTracker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind__);







var _desc, _value, _class, _class2, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}



var fullScreenChangeEventsList = ['fullscreenchange', 'mozfullscreenchange', 'webkitfullscreenchange', 'msfullscreenchange'];
var iosFullscreenChangeEventsList = ['webkitbeginfullscreen', 'webkitendfullscreen'];

var FullscreenTracker = (_class = (_temp = _class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(FullscreenTracker, _React$Component);

  function FullscreenTracker() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, FullscreenTracker);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (FullscreenTracker.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(FullscreenTracker)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(FullscreenTracker, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.addFullscreenEventHandler();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var prevVideoRef = this.props.videoRef;
      var nextVideoRef = nextProps.videoRef;

      if (prevVideoRef !== nextVideoRef) {
        if (prevVideoRef) {
          this.removeFullscreenEventHandlerForIOS(prevVideoRef);
        }
        if (nextVideoRef) {
          this.addFullscreenEventHandlerForIOS(nextVideoRef);
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeFullscreenEventHandler();
      if (this.props.videoRef) {
        this.removeFullscreenEventHandlerForIOS(this.props.videoRef);
      }
    }
  }, {
    key: 'handleFullscreenChange',
    value: function handleFullscreenChange() {
      this.props.onFullscreenChanged();
    }
  }, {
    key: 'addFullscreenEventHandler',
    value: function addFullscreenEventHandler() {
      var _this2 = this;

      _.forEach(fullScreenChangeEventsList, function (eventName) {
        return document.addEventListener(eventName, _this2.handleFullscreenChange);
      });
    }
  }, {
    key: 'removeFullscreenEventHandler',
    value: function removeFullscreenEventHandler() {
      var _this3 = this;

      _.forEach(fullScreenChangeEventsList, function (eventName) {
        return document.removeEventListener(eventName, _this3.handleFullscreenChange);
      });
    }
  }, {
    key: 'addFullscreenEventHandlerForIOS',
    value: function addFullscreenEventHandlerForIOS(element) {
      var _this4 = this;

      _.forEach(iosFullscreenChangeEventsList, function (eventName) {
        return element.addEventListener(eventName, _this4.handleFullscreenChange);
      });
    }
  }, {
    key: 'removeFullscreenEventHandlerForIOS',
    value: function removeFullscreenEventHandlerForIOS(element) {
      var _this5 = this;

      _.forEach(iosFullscreenChangeEventsList, function (eventName) {
        return element.removeEventListener(eventName, _this5.handleFullscreenChange);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return FullscreenTracker;
}(React.Component), _class2.propTypes = {
  videoRef: React.PropTypes.any,
  onFullscreenChanged: _.noop
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'handleFullscreenChange', [__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'handleFullscreenChange'), _class.prototype)), _class);


/***/ }),
/* 1273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = isInFullscreen;
/* harmony export (immutable) */ __webpack_exports__["a"] = exitFullscreen;
/* harmony export (immutable) */ __webpack_exports__["b"] = requestFullscreen;
var HAVE_METADATA = 1;

function getFullscreenElement() {
  return document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement;
}

function videoElemIsInFullscreen(videoRef) {
  return Boolean(videoRef && videoRef.webkitDisplayingFullscreen);
}

function isInFullscreen(videoRef) {
  return Boolean(getFullscreenElement()) || videoElemIsInFullscreen(videoRef);
}

function exitFullscreen(videoRef) {
  if (!isInFullscreen(videoRef)) {
    return;
  }

  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen();
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  }

  // no need to exit from videoRef because it's only possible in ios, which hanles fullscreen button natively
}

function requestFullscreen(wrapperRef, videoRef) {
  if (isInFullscreen(videoRef)) {
    return;
  }

  if (wrapperRef.requestFullscreen) {
    wrapperRef.requestFullscreen();
  } else if (wrapperRef.msRequestFullscreen) {
    wrapperRef.msRequestFullscreen();
  } else if (wrapperRef.mozRequestFullScreen) {
    wrapperRef.mozRequestFullScreen();
  } else if (wrapperRef.webkitRequestFullscreen) {
    wrapperRef.webkitRequestFullscreen();
  } else if (videoRef && videoRef.webkitEnterFullscreen) {
    // iOS case, call video element directly
    // exitFullScreen should not handle it because on iOS we have native video player for fullScreen

    enterFullScreenOnIOS(videoRef);
  }
}

function enterFullScreenOnIOS(video) {
  try {
    video.webkitEnterFullscreen();
  } catch (e) {
    if (video.readyState < HAVE_METADATA) {
      var enterWhenHasMetaData = function enterWhenHasMetaData() {
        video.removeEventListener('loadedmetadata', enterWhenHasMetaData);
        video.webkitEnterFullscreen();
      };
      video.addEventListener('loadedmetadata', enterWhenHasMetaData);
    }
  }
}

/***/ }),
/* 1274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InfoOverlay; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_widget_player_widget_utils_wix_connect__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__context_types__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_widget_player_widget_components_icon_icon__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__info_overlay_styl__ = __webpack_require__(1497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__info_overlay_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__info_overlay_styl__);







var _dec, _class, _desc, _value, _class2, _class3, _temp2;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}












var InfoOverlay = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_widget_player_widget_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_11__info_overlay_styl___default.a), _dec(_class = (_class2 = (_temp2 = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(InfoOverlay, _React$Component);

  function InfoOverlay() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, InfoOverlay);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = InfoOverlay.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(InfoOverlay)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isVisibleInfoOverlay: false
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(InfoOverlay, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      setTimeout(function () {
        _this2.setState({
          isVisibleInfoOverlay: true
        });
      }, 0);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var closeOnBodyClick = this.props.closeOnBodyClick;


      this.backgroundOverlay.addEventListener('click', this.handleBodyClick);

      if (closeOnBodyClick) {
        document.body.addEventListener('click', this.handleBodyClick);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps, nextContext) {
      if (_.get(nextContext, 'videoItem.id') !== _.get(this.context, 'videoItem.id')) {
        this.close();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var closeOnBodyClick = this.props.closeOnBodyClick;


      this.backgroundOverlay.removeEventListener('click', this.handleBodyClick);

      if (closeOnBodyClick) {
        document.body.removeEventListener('click', this.handleBodyClick);
      }
    }
  }, {
    key: 'close',
    value: function close() {
      var toggleInfoOverlay = this.context.toggleInfoOverlay;


      this.setState({
        isVisibleInfoOverlay: false
      });

      setTimeout(toggleInfoOverlay, 200);
    }
  }, {
    key: 'handleBodyClick',
    value: function handleBodyClick() {
      this.close();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          content = _props.content,
          noPoster = _props.noPoster,
          isFullWidth = _props.isFullWidth;
      var isVisibleInfoOverlay = this.state.isVisibleInfoOverlay;
      var _context = this.context,
          posterUrl = _context.videoItem.posterUrl,
          fullScreen = _context.fullScreen;


      var styleNames = __WEBPACK_IMPORTED_MODULE_6_classnames___default()('info-overlay', {
        show: isVisibleInfoOverlay,
        'full-width': isFullWidth
      });

      var contentStyleNames = __WEBPACK_IMPORTED_MODULE_6_classnames___default()('content', {
        half: noPoster && !posterUrl,
        'at-full-screen': noPoster && fullScreen
      });

      return React.createElement(
        'div',
        { styleName: styleNames },
        this.closeButton,
        React.createElement(
          'div',
          { styleName: contentStyleNames },
          content
        ),
        React.createElement('div', { styleName: 'background-overlay',
          ref: function ref(node) {
            return _this3.backgroundOverlay = node;
          } })
      );
    }
  }, {
    key: 'closeButton',
    get: function get() {
      var fullScreen = this.context.fullScreen;


      var iconName = fullScreen ? 'thin-x' : 'exit';
      var styleName = __WEBPACK_IMPORTED_MODULE_6_classnames___default()('close', {
        'close-fullscreen': fullScreen
      });

      return React.createElement(__WEBPACK_IMPORTED_MODULE_10_widget_player_widget_components_icon_icon__["a" /* default */], { styleName: styleName,
        name: iconName,
        onClick: this.close });
    }
  }]);

  return InfoOverlay;
}(React.Component), _class3.contextTypes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__context_types__["b" /* pickContextTypes */])('toggleInfoOverlay', 'videoItem', 'fullScreen'), _class3.propTypes = {
  closeOnBodyClick: React.PropTypes.bool,
  noPoster: React.PropTypes.bool,
  isFullWidth: React.PropTypes.bool,
  content: React.PropTypes.element
}, _temp2), (_applyDecoratedDescriptor(_class2.prototype, 'close', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'close'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleBodyClick', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handleBodyClick'), _class2.prototype)), _class2)) || _class);


/***/ }),
/* 1275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InfoOverlayInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_text_overflow_clamp__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_text_overflow_clamp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_text_overflow_clamp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_widget_player_widget_utils_wix_connect__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_widget_player_widget_utils_resize_image__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_settings__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__context_types__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_widget_player_widget_components_scrollbar_wrapper_scrollbar_wrapper__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__info_styl__ = __webpack_require__(1498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__info_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__info_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__translations__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_shared_translations_crew__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_shared_translations_genres__ = __webpack_require__(558);







var _dec, _class, _desc, _value, _class2, _class3, _temp2;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}





















var POSTER_SIZE = {
  width: 303,
  height: 449
};

var POSTER_SIZE_FULLSCREEN = {
  width: 450,
  height: 667
};

var InfoOverlayInfo = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_widget_player_widget_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_15__info_styl___default.a), _dec(_class = (_class2 = (_temp2 = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(InfoOverlayInfo, _React$Component);

  function InfoOverlayInfo() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, InfoOverlayInfo);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = InfoOverlayInfo.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(InfoOverlayInfo)).call.apply(_ref, [this].concat(args))), _this), _this.title = null, _this.info = null, _this.posterEl = null, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(InfoOverlayInfo, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.clamp();

      window.addEventListener('resize', this.setPosterSize);
      this.setPosterSize();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.clamp();
      this.setPosterSize();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.setPosterSize);
    }
  }, {
    key: 'savePosterRef',
    value: function savePosterRef(node) {
      this.posterEl = node;
    }
  }, {
    key: 'saveTitleRef',
    value: function saveTitleRef(node) {
      this.title = node;
    }
  }, {
    key: 'clamp',
    value: function clamp() {
      __WEBPACK_IMPORTED_MODULE_9_text_overflow_clamp___default()(this.title, { lineClamp: 3 });
    }
  }, {
    key: 'getRoles',
    value: function getRoles(rolesType) {
      var formatMessage = this.formatMessage;
      var roles = this.context.videoItem[rolesType];


      if (!roles || !roles.length) {
        return null;
      }

      var roleElements = _.map(roles, function (_ref2, index) {
        var role = _ref2.role,
            name = _ref2.name;

        if (rolesType === 'crew') {
          role = formatMessage(__WEBPACK_IMPORTED_MODULE_17_shared_translations_crew__["a" /* default */][role]);
        }

        return React.createElement(
          'div',
          { key: index,
            styleName: 'role-item',
            className: 'qa-overlay-info-' + rolesType },
          React.createElement(
            'div',
            { styleName: 'role' },
            role
          ),
          React.createElement(
            'div',
            { styleName: 'name' },
            name
          )
        );
      });

      return React.createElement(
        'div',
        { styleName: 'roles-wrapper' },
        React.createElement(
          'div',
          { styleName: 'roles-title' },
          formatMessage(__WEBPACK_IMPORTED_MODULE_16__translations__["a" /* default */][rolesType])
        ),
        roleElements
      );
    }
  }, {
    key: 'setPosterSize',
    value: function setPosterSize() {
      var fullScreen = this.context.fullScreen;

      this.updatePosterStyle(fullScreen ? POSTER_SIZE_FULLSCREEN : POSTER_SIZE);
    }
  }, {
    key: 'updatePosterStyle',
    value: function updatePosterStyle(_ref3) {
      var width = _ref3.width,
          height = _ref3.height;

      var poster = this.posterEl;

      if (!poster) {
        return null;
      }

      poster.style.width = Math.floor(poster.offsetHeight / height * width) + 'px';
    }
  }, {
    key: 'getPosterImage',
    value: function getPosterImage(width, height, className) {
      var _context = this.context,
          posterUrl = _context.videoItem.posterUrl,
          fullScreen = _context.fullScreen;
      var hosts = __WEBPACK_IMPORTED_MODULE_12_shared_settings__["a" /* default */].hosts;


      if (!posterUrl) {
        return null;
      }

      var resizedPosterUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_widget_player_widget_utils_resize_image__["a" /* default */])(posterUrl, width * 2, height * 2);

      return React.createElement('div', { ref: this.savePosterRef,
        styleName: __WEBPACK_IMPORTED_MODULE_8_classnames___default()('poster', className, { fullscreen: fullScreen }),
        className: 'qa-overlay-info-poster',
        style: { backgroundImage: 'url(' + hosts.image + resizedPosterUrl + ')' } });
    }
  }, {
    key: 'render',
    value: function render() {
      var _context2 = this.context,
          title = _context2.videoItem.title,
          fullScreen = _context2.fullScreen;


      var styleNames = __WEBPACK_IMPORTED_MODULE_8_classnames___default()('wrapper', {
        'full-screen': fullScreen
      });

      return React.createElement(
        'div',
        { styleName: styleNames,
          className: 'qa-player-overlay-info' },
        this.poster,
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_14_widget_player_widget_components_scrollbar_wrapper_scrollbar_wrapper__["a" /* default */],
          { styleName: 'scrollbar-wrapper' },
          React.createElement(
            'div',
            { styleName: 'main-info' },
            React.createElement(
              'div',
              { ref: this.saveTitleRef,
                styleName: 'title',
                className: 'qa-overlay-info-title',
                title: title },
              title
            ),
            React.createElement(
              'div',
              { styleName: 'info' },
              this.publisher,
              this.genres,
              this.duration
            ),
            this.description,
            this.fullScreenPoster,
            this.getRoles('cast'),
            this.getRoles('crew'),
            this.compactPoster
          )
        )
      );
    }
  }, {
    key: 'formatMessage',
    get: function get() {
      return this.props.intl.formatMessage;
    }
  }, {
    key: 'compactPoster',
    get: function get() {
      var videoItem = this.context.videoItem;
      var posterUrl = videoItem.posterUrl;


      if (!posterUrl) {
        return null;
      }

      var resizedPosterUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_widget_player_widget_utils_resize_image__["a" /* default */])(posterUrl, POSTER_SIZE.width * 2, POSTER_SIZE.height * 2);

      var hosts = __WEBPACK_IMPORTED_MODULE_12_shared_settings__["a" /* default */].hosts;
      var title = videoItem.title;


      return React.createElement('img', { styleName: 'poster poster-compact',
        className: 'qa-overlay-info-poster-compact',
        src: '' + hosts.image + resizedPosterUrl,
        alt: title });
    }
  }, {
    key: 'poster',
    get: function get() {
      var fullScreen = this.context.fullScreen;


      if (fullScreen) {
        return null;
      }

      return this.getPosterImage(POSTER_SIZE.width, POSTER_SIZE.height);
    }
  }, {
    key: 'fullScreenPoster',
    get: function get() {
      var fullScreen = this.context.fullScreen;


      if (!fullScreen) {
        return null;
      }

      return this.getPosterImage(POSTER_SIZE_FULLSCREEN.width, POSTER_SIZE_FULLSCREEN.height);
    }
  }, {
    key: 'publisher',
    get: function get() {
      var publisher = this.context.videoItem.publisher;
      var formatMessage = this.formatMessage;


      if (!publisher) {
        return null;
      }

      return React.createElement(
        'div',
        { styleName: 'info-item',
          className: 'qa-overlay-info-publisher' },
        formatMessage(__WEBPACK_IMPORTED_MODULE_16__translations__["a" /* default */].publisher, { author: publisher })
      );
    }
  }, {
    key: 'genres',
    get: function get() {
      var genre = this.context.videoItem.genre;
      var formatMessage = this.formatMessage;


      if (!genre) {
        return null;
      }

      return React.createElement(
        'div',
        { styleName: 'info-item',
          className: 'qa-overlay-info-genres' },
        formatMessage(__WEBPACK_IMPORTED_MODULE_18_shared_translations_genres__["a" /* default */][genre])
      );
    }
  }, {
    key: 'duration',
    get: function get() {
      var durationStr = this.context.videoItem.durationStr;


      if (!durationStr) {
        return null;
      }

      return React.createElement(
        'div',
        { styleName: 'info-item',
          className: 'qa-overlay-info-duration' },
        ' ' + durationStr
      );
    }
  }, {
    key: 'description',
    get: function get() {
      var description = this.context.videoItem.description;


      if (!description) {
        return null;
      }

      return React.createElement(
        'div',
        { styleName: 'description',
          className: 'qa-overlay-info-description' },
        description
      );
    }
  }]);

  return InfoOverlayInfo;
}(React.Component), _class3.propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_6_react_intl__["e" /* intlShape */]
}, _class3.contextTypes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__context_types__["b" /* pickContextTypes */])('videoItem', 'fullScreen'), _temp2), (_applyDecoratedDescriptor(_class2.prototype, 'savePosterRef', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'savePosterRef'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'saveTitleRef', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'saveTitleRef'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setPosterSize', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'setPosterSize'), _class2.prototype)), _class2)) || _class);


/***/ }),
/* 1276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InfoOverlayShare; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_selectors_app_settings__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_utils_get_url_to_video__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_widget_player_widget_utils_wix_connect__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__context_types__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_widget_constants_social_networks__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_widget_player_widget_components_social_share_social_share__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__share_styl__ = __webpack_require__(1220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__share_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__share_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__translations__ = __webpack_require__(630);








var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}



















// TODO: Merge this and widget/views/desktop/compact/components/share-channel/share-channel.js into one
// after new player integrated completely and no this.context.afterShareClicked used anymore.
// https://jira.wixpress.com/browse/VOD-680
var InfoOverlayShare = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_react_redux__["a" /* connect */])(function (state) {
  return {
    appSettings: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_shared_selectors_app_settings__["a" /* getAllSettings */])(state)
  };
}), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_widget_player_widget_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_16__share_styl___default.a), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(InfoOverlayShare, _React$Component);

  function InfoOverlayShare() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, InfoOverlayShare);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (InfoOverlayShare.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(InfoOverlayShare)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(InfoOverlayShare, [{
    key: 'broadcastAfterClickToContext',
    value: function broadcastAfterClickToContext(network) {
      this.context.afterShareClicked(network);
    }
  }, {
    key: 'render',
    value: function render() {
      var _context = this.context,
          videoItem = _context.videoItem,
          openPreviewPrompt = _context.openPreviewPrompt;
      var appSettings = this.props.appSettings;


      var networksClassNames = _.pick(__WEBPACK_IMPORTED_MODULE_16__share_styl___default.a, _.values(__WEBPACK_IMPORTED_MODULE_14_widget_constants_social_networks__["a" /* default */]));

      var contentToShare = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, videoItem, {
        siteUrl: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_shared_utils_get_url_to_video__["a" /* default */])(videoItem, appSettings)
      });

      return React.createElement(
        'div',
        { styleName: 'share-overlay',
          className: 'qa-player-overlay-share' },
        React.createElement(
          'div',
          { styleName: 'title' },
          React.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], __WEBPACK_IMPORTED_MODULE_17__translations__["a" /* default */].share)
        ),
        React.createElement(__WEBPACK_IMPORTED_MODULE_15_widget_player_widget_components_social_share_social_share__["a" /* default */], { networks: _.values(__WEBPACK_IMPORTED_MODULE_14_widget_constants_social_networks__["a" /* default */]),
          content: contentToShare,
          onShare: this.broadcastAfterClickToContext,
          styleName: 'social-icons',
          buttonClassName: __WEBPACK_IMPORTED_MODULE_16__share_styl___default.a['share-icon'],
          popoutOuterClassName: __WEBPACK_IMPORTED_MODULE_16__share_styl___default.a['popout-outer'],
          popoutInnerClassName: __WEBPACK_IMPORTED_MODULE_16__share_styl___default.a['popout-inner'],
          linkClassName: __WEBPACK_IMPORTED_MODULE_16__share_styl___default.a['share-link'],
          networksClassNames: networksClassNames,
          openPreviewPrompt: openPreviewPrompt })
      );
    }
  }]);

  return InfoOverlayShare;
}(React.Component), _class3.contextTypes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__context_types__["b" /* pickContextTypes */])('videoItem', 'openPreviewPrompt', 'afterShareClicked'), _class3.propTypes = {
  network: React.PropTypes.string,
  appSettings: React.PropTypes.object
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'broadcastAfterClickToContext', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'broadcastAfterClickToContext'), _class2.prototype)), _class2)) || _class) || _class);


/***/ }),
/* 1277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OverlayActions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_widget_player_widget_utils_wix_connect__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_ui_selectors_video_video_origin__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_utils_deal_info_helpers__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_default_settings__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__overlay_action_utils__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__context_types__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__action_button_action_button__ = __webpack_require__(1264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__info_overlay_info_info__ = __webpack_require__(1275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__info_overlay_share_share__ = __webpack_require__(1276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__overlay_actions_styl__ = __webpack_require__(1499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__overlay_actions_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__overlay_actions_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__translations__ = __webpack_require__(545);








var _dec, _class, _desc, _value, _class2, _class3, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}






















var OverlayActions = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_widget_player_widget_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_19__overlay_actions_styl___default.a), _dec(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(OverlayActions, _React$Component);

  function OverlayActions() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, OverlayActions);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (OverlayActions.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(OverlayActions)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(OverlayActions, [{
    key: 'onPurchaseClickHandler',
    value: function onPurchaseClickHandler() {
      var onPurchaseClick = this.props.onPurchaseClick;
      var _context = this.context,
          togglePause = _context.togglePause,
          exitFullScreen = _context.exitFullScreen;


      togglePause(true);
      exitFullScreen();
      setTimeout(onPurchaseClick, 0);
    }
  }, {
    key: 'onSubscribeClickHandler',
    value: function onSubscribeClickHandler() {
      var onSubscribeClick = this.props.onSubscribeClick;
      var _context2 = this.context,
          togglePause = _context2.togglePause,
          exitFullScreen = _context2.exitFullScreen;


      togglePause(true);
      exitFullScreen();
      setTimeout(onSubscribeClick, 0);
    }
  }, {
    key: 'getTimer',
    value: function getTimer(actionName) {
      var rentInfo = _.get(this.context.videoItem.dgsInfo, 'rent');
      var date = React.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["g" /* FormattedDate */], { value: rentInfo.expirationTs * 1000,
        month: 'short',
        day: 'numeric' });

      return {
        icon: 'timer',
        actionName: actionName,
        label: React.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_20__translations__["a" /* default */].rented, {
          values: { date: date } }))
      };
    }
  }, {
    key: 'getFilm',
    value: function getFilm(actionName) {
      return {
        icon: 'film',
        actionName: actionName,
        label: React.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */], __WEBPACK_IMPORTED_MODULE_20__translations__["a" /* default */].purchased)
      };
    }
  }, {
    key: 'getSubscribe',
    value: function getSubscribe(actionName) {
      var dealInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_shared_utils_deal_info_helpers__["a" /* getSubscriptionPriceInfo */])(this.context.channelData.dealInfo);

      var price = React.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["f" /* FormattedNumber */], { value: dealInfo.price,
        style: 'currency',
        currency: dealInfo.currency });
      return {
        icon: 'buy-rent',
        className: 'qa-widget-overlay-buy-rent-button',
        actionName: actionName,
        label: React.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_20__translations__["a" /* default */].subscribe, {
          values: { price: price } })),
        onClick: this.onSubscribeClickHandler
      };
    }
  }, {
    key: 'getBuyRent',
    value: function getBuyRent(actionName) {
      var dealInfo = this.context.videoItem.dealInfo;


      var minVideoPriceInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_shared_utils_deal_info_helpers__["d" /* getMinPriceInfo */])(dealInfo);
      var saleDealInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_shared_utils_deal_info_helpers__["b" /* getSalePriceInfo */])(dealInfo);
      var rentDealInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_shared_utils_deal_info_helpers__["c" /* getRentPriceInfo */])(dealInfo);

      var rentSaleDealInfo = void 0;
      var message = void 0;

      if (saleDealInfo && rentDealInfo) {
        rentSaleDealInfo = minVideoPriceInfo;
        message = __WEBPACK_IMPORTED_MODULE_20__translations__["a" /* default */].buyFrom;
      } else if (saleDealInfo) {
        rentSaleDealInfo = saleDealInfo;
        message = __WEBPACK_IMPORTED_MODULE_20__translations__["a" /* default */].buy;
      } else if (rentDealInfo) {
        rentSaleDealInfo = rentDealInfo;
        message = __WEBPACK_IMPORTED_MODULE_20__translations__["a" /* default */].rent;
      }

      if (rentSaleDealInfo && message) {
        var values = {
          price: React.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["f" /* FormattedNumber */], { value: rentSaleDealInfo.price,
            style: 'currency',
            currency: rentSaleDealInfo.currency })
        };

        return {
          icon: 'buy-rent',
          className: 'qa-widget-overlay-buy-rent-button',
          actionName: actionName,
          label: React.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, message, {
            values: values })),
          onClick: this.onPurchaseClickHandler
        };
      }
      return null;
    }
  }, {
    key: 'getVideoInfo',
    value: function getVideoInfo(actionName) {
      var _context3 = this.context,
          toggleInfoOverlay = _context3.toggleInfoOverlay,
          videoItem = _context3.videoItem;


      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_shared_ui_selectors_video_video_origin__["b" /* isExternalVideo */])(videoItem)) {
        return null;
      }

      return {
        icon: 'info',
        className: 'qa-widget-overlay-info-button',
        actionName: actionName,
        onClick: function onClick() {
          toggleInfoOverlay(React.createElement(__WEBPACK_IMPORTED_MODULE_17__info_overlay_info_info__["a" /* default */], null), {
            noPoster: true
          });
        }
      };
    }
  }, {
    key: 'getVideoShare',
    value: function getVideoShare(actionName) {
      var toggleInfoOverlay = this.context.toggleInfoOverlay;

      return {
        icon: 'share',
        className: 'qa-widget-overlay-share-button',
        actionName: actionName,
        onClick: function onClick() {
          toggleInfoOverlay(React.createElement(__WEBPACK_IMPORTED_MODULE_18__info_overlay_share_share__["a" /* default */], null), {
            closeOnBodyClick: true,
            isFullWidth: true
          });
        }
      };
    }
  }, {
    key: 'addRounded',
    value: function addRounded(viewAction) {
      var appSettings = this.props.appSettings;

      var rounded = appSettings.numbers.layoutStyle === __WEBPACK_IMPORTED_MODULE_13_default_settings__["f" /* layoutStyleValues */].ROUND;
      viewAction.rounded = rounded;
      return viewAction;
    }
  }, {
    key: 'addClickCallback',
    value: function addClickCallback(viewAction) {
      var _this2 = this;

      if (viewAction.onClick && viewAction.action) {
        var target = viewAction.onClick;
        var actionName = viewAction.actionName;

        viewAction.onClick = function () {
          target.apply(undefined, arguments);
          _this2.props.onActionClicked(actionName);
        };
      }
      return viewAction;
    }
  }, {
    key: 'render',
    value: function render() {
      var _context4 = this.context,
          simple = _context4.simple,
          mobileMode = _context4.mobileMode,
          beenPlayed = _context4.beenPlayed,
          ended = _context4.ended,
          fullScreen = _context4.fullScreen;


      if (simple || mobileMode) {
        return null;
      }

      if (!beenPlayed || ended) {
        return null;
      }

      var styleNames = __WEBPACK_IMPORTED_MODULE_8_classnames___default()('actions', {
        'at-full-screen': fullScreen
      });

      return React.createElement(
        'div',
        { styleName: styleNames,
          className: 'qa-player-overlay-actions' },
        _.map(this.actions, function (action) {
          return React.createElement(__WEBPACK_IMPORTED_MODULE_16__action_button_action_button__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ styleName: 'action-button',
            key: action.icon
          }, action));
        })
      );
    }
  }, {
    key: 'actions',
    get: function get() {
      var _this3 = this;

      return _(this.props.actionsList).map(function (actionName) {
        switch (actionName) {
          case __WEBPACK_IMPORTED_MODULE_14__overlay_action_utils__["a" /* OVERLAY_ACTION_TYPES */].TIMER:
            return _this3.getTimer(actionName);

          case __WEBPACK_IMPORTED_MODULE_14__overlay_action_utils__["a" /* OVERLAY_ACTION_TYPES */].FILM:
            return _this3.getFilm(actionName);

          case __WEBPACK_IMPORTED_MODULE_14__overlay_action_utils__["a" /* OVERLAY_ACTION_TYPES */].SUBSCRIBE:
            return _this3.getSubscribe(actionName);

          case __WEBPACK_IMPORTED_MODULE_14__overlay_action_utils__["a" /* OVERLAY_ACTION_TYPES */].BUY_RENT:
            return _this3.getBuyRent(actionName);

          case __WEBPACK_IMPORTED_MODULE_14__overlay_action_utils__["a" /* OVERLAY_ACTION_TYPES */].INFO:
            return _this3.getVideoInfo(actionName);

          case __WEBPACK_IMPORTED_MODULE_14__overlay_action_utils__["a" /* OVERLAY_ACTION_TYPES */].SHARE:
            return _this3.getVideoShare(actionName);

          default:
            return null;
        }
      }).compact().map(this.addRounded).map(this.addClickCallback).value();
    }
  }]);

  return OverlayActions;
}(React.Component), _class3.contextTypes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__context_types__["b" /* pickContextTypes */])('toggleInfoOverlay', 'togglePause', 'exitFullScreen', 'videoItem', 'channelData', 'appSettings', 'simple', 'mobileMode', 'beenPlayed', 'ended', 'fullScreen'), _class3.propTypes = {
  intl: __WEBPACK_IMPORTED_MODULE_9_react_intl__["e" /* intlShape */],
  appSettings: React.PropTypes.object,
  onPurchaseClick: React.PropTypes.func,
  onSubscribeClick: React.PropTypes.func,
  actionsList: React.PropTypes.arrayOf(React.PropTypes.string),
  onActionClicked: React.PropTypes.func
}, _class3.defaultProps = {
  onActionClicked: _.noop
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onPurchaseClickHandler', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'onPurchaseClickHandler'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onSubscribeClickHandler', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'onSubscribeClickHandler'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'addRounded', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'addRounded'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'addClickCallback', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'addClickCallback'), _class2.prototype)), _class2)) || _class);


/***/ }),
/* 1278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Overlay; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_widget_player_widget_utils_wix_connect__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_ui_selectors_video_video_origin__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_components_spinner_loading_spinner__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__overlay_styl__ = __webpack_require__(1500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__overlay_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__overlay_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__context_types__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__translations__ = __webpack_require__(1279);






var _dec, _class, _class2, _temp;














var Overlay = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_widget_player_widget_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_10__overlay_styl___default.a), _dec(_class = (_temp = _class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Overlay, _React$Component);

  function Overlay() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Overlay);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Overlay.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Overlay)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Overlay, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          actions = _props.actions,
          className = _props.className;
      var _context = this.context,
          simple = _context.simple,
          mobileMode = _context.mobileMode,
          videoItem = _context.videoItem,
          error = _context.error,
          loading = _context.loading,
          togglePause = _context.togglePause,
          paused = _context.paused,
          ended = _context.ended,
          beenPlayed = _context.beenPlayed,
          videoUrls = _context.videoUrls,
          fullScreen = _context.fullScreen;


      if (simple || mobileMode) {
        return null;
      }

      var canPlay = !error && !loading;

      var styleNames = __WEBPACK_IMPORTED_MODULE_5_classnames___default()('overlay', {
        'video-url-loading': !videoUrls && !this.isExternalVideo,
        'not-been-played': !beenPlayed,
        'been-played': beenPlayed,
        'at-full-screen': fullScreen,
        ended: ended,
        paused: paused
      });

      var overlayOnClick = canPlay && beenPlayed ? togglePause : _.noop;

      return React.createElement(
        'div',
        { onClick: overlayOnClick,
          styleName: styleNames,
          className: className },
        this.beenPlayedContent,
        React.createElement(
          'div',
          { styleName: 'hover-content' },
          actions,
          React.createElement(
            'h1',
            { styleName: 'title',
              className: 'qa-overlay-title',
              'data-hook': 'playerTitle' },
            videoItem.title
          )
        )
      );
    }
  }, {
    key: 'errorMessage',
    get: function get() {
      var error = this.context.error;
      var formatMessage = this.props.intl.formatMessage;


      if (!error) {
        return null;
      }

      return React.createElement(
        'p',
        { styleName: 'error-text' },
        formatMessage(__WEBPACK_IMPORTED_MODULE_12__translations__["a" /* default */].sourceError)
      );
    }
  }, {
    key: 'loadingSpinner',
    get: function get() {
      var _context2 = this.context,
          ended = _context2.ended,
          error = _context2.error,
          loading = _context2.loading,
          videoUrls = _context2.videoUrls;

      if (ended || error) {
        return null;
      }

      if (videoUrls && (error || !loading)) {
        return null;
      }

      return React.createElement(__WEBPACK_IMPORTED_MODULE_9_shared_components_spinner_loading_spinner__["a" /* default */], null);
    }
  }, {
    key: 'isExternalVideo',
    get: function get() {
      var videoItem = this.context.videoItem;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_shared_ui_selectors_video_video_origin__["b" /* isExternalVideo */])(videoItem);
    }
  }, {
    key: 'beenPlayedContent',
    get: function get() {
      if (this.isExternalVideo) {
        return null;
      }

      return React.createElement(
        'div',
        { styleName: 'been-played-content' },
        this.errorMessage,
        this.loadingSpinner
      );
    }
  }]);

  return Overlay;
}(React.Component), _class2.contextTypes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__context_types__["b" /* pickContextTypes */])('videoItem', 'togglePause', 'error', 'paused', 'ended', 'loading', 'beenPlayed', 'videoUrls', 'fullScreen', 'simple', 'mobileMode'), _class2.propTypes = {
  actions: React.PropTypes.element,
  className: React.PropTypes.string,
  intl: __WEBPACK_IMPORTED_MODULE_6_react_intl__["e" /* intlShape */]
}, _temp)) || _class);


/***/ }),
/* 1279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* defineMessages */])({
  sourceError: {
    id: 'overlay.source-error',
    defaultMessage: 'Video cannot be played'
  },
  buyFrom: {
    id: 'overlay.buy-from',
    defaultMessage: 'Buy from {price}'
  }
}));

/***/ }),
/* 1280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Player; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_components_resized_image_resized_image__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_widget_utils_not_for_preview__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_shared_ui_selectors_video_video_origin__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_widget_constants_video_playback_status__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_default_settings__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_shared_constants_video_sources__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_widget_redux_client_actions_change_playback_status__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__video_video__ = __webpack_require__(1283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__controls_controls__ = __webpack_require__(1265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__overlay_overlay__ = __webpack_require__(1278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__overlay_actions_overlay_actions__ = __webpack_require__(1277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__info_overlay_info_overlay__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__overlay_actions_overlay_action_utils__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__fullscreen_fullscreen_changed_tracker__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__fullscreen_utils__ = __webpack_require__(1273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__player_styl__ = __webpack_require__(1501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__player_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__player_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__context_types__ = __webpack_require__(62);









var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}































var STORYBOARD_TYPE = 'storyboard';
var DELAY_BEFORE_HIDE_CONTROL = 3000;

var Player = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_react_redux__["a" /* connect */])(null, {
  setPlaybackStatus: __WEBPACK_IMPORTED_MODULE_18_widget_redux_client_actions_change_playback_status__["b" /* setPlaybackStatus */]
}), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_shared_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_27__player_styl___default.a), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(Player, _React$Component);

  function Player(props) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, Player);

    var _this = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Player.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(Player)).call(this, props));

    var _this$props = _this.props,
        videoUrls = _this$props.videoUrls,
        paused = _this$props.paused,
        muted = _this$props.muted,
        volume = _this$props.volume,
        loop = _this$props.loop,
        showControls = _this$props.showControls;


    _this.state = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
      paused: paused,
      muted: muted,
      volume: volume,
      loop: loop,
      showControls: showControls,
      currentTime: 0,
      userTime: 0,

      infoOverlay: null,

      fullScreen: false,
      error: false,
      loading: false,
      beenPlayed: false,
      ended: false,
      fadeControls: true

    }, _this.parseVideoUrls(videoUrls));
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(Player, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var props = _.pick(this.props, ['simple', 'mobileMode', 'videoItem', 'channelData', 'height', 'width', 'canShowChannelCover', 'showChannelCover', 'openPreviewPrompt', 'muted', 'loop']);

      var context = _.merge({
        updateStateFromVideo: this.updateStateFromVideo,
        togglePause: this.togglePause,
        toggleMute: this.toggleMute,
        toggleError: this.toggleError,
        exitFullScreen: this.exitFullScreen,
        toggleFullScreenByUser: this.toggleFullScreenByUser,
        toggleEnded: this.toggleEnded,
        toggleBeenPlayed: this.toggleBeenPlayed,
        toggleInfoOverlay: this.toggleInfoOverlay,
        setVolume: this.setVolume,
        seek: this.seek,
        resetSeek: this.resetSeek,
        afterShareClicked: this.afterShareClicked
      }, props, this.state);

      return context;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          videoItem = _props.videoItem,
          isFetchDisabled = _props.isFetchDisabled,
          paused = _props.paused,
          playAtFullScreen = _props.playAtFullScreen;
      var videoUrls = this.state.videoUrls;

      if (!videoUrls && !isFetchDisabled) {
        this.loadVideoUrls(videoItem);
      }
      if (this.shouldShowOverlay()) {
        this.props.onShowActions(this.actionsList);
      }

      if (playAtFullScreen && !paused) {
        this.requestFullScreen(videoItem);
      }

      this.wrapper.addEventListener('mousemove', this.handleMouseMove);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var videoItem = nextProps.videoItem,
          videoUrls = nextProps.videoUrls,
          nextPaused = nextProps.paused,
          isFetchDisabled = nextProps.isFetchDisabled,
          playAtFullScreen = nextProps.playAtFullScreen,
          currentTime = nextProps.currentTime,
          nextMuted = nextProps.muted,
          nextLoop = nextProps.loop,
          nextShowControls = nextProps.showControls;


      if (this.props.videoItem.id === videoItem.id) {
        if (isFetchDisabled) {
          this.setVideoUrls(videoUrls);
        }
      } else {
        this.toggleInfoOverlay();
        this.toggleEnded(false);
        this.toggleError(false);
        this.toggleBeenPlayed(false);
        this.seek(0);
        if (isFetchDisabled) {
          this.setVideoUrls(videoUrls);
        } else {
          this.loadVideoUrls(videoItem);
        }
      }

      if (this.state.paused !== nextPaused) {
        this.togglePause(nextPaused);
      }

      if (this.state.muted !== nextMuted) {
        this.toggleMute(nextMuted);
      }

      if (this.state.loop !== nextLoop) {
        this.toggleLoop(nextLoop);
      }

      if (this.state.showControls !== nextShowControls) {
        this.toggleControls(nextShowControls);
      }

      // requestFullScreen is a user generated command
      // only true can be received and handled in 'componentWillReceiveProps'
      if (playAtFullScreen && this.hasStartedPlaying(nextPaused, this.state.paused)) {
        this.requestFullScreen(videoItem);
      }

      this.seek(currentTime);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.shouldShowOverlay() && !this.shouldShowOverlay(prevProps, prevState)) {
        this.props.onShowActions(this.actionsList);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.wrapper.removeEventListener('mousemove', this.handleMouseMove);
    }
  }, {
    key: 'hasStartedPlaying',
    value: function hasStartedPlaying(nextPaused, currentPaused) {
      return !nextPaused && currentPaused;
    }
  }, {
    key: 'handleMouseMove',
    value: function handleMouseMove() {
      var _state = this.state,
          beenPlayed = _state.beenPlayed,
          paused = _state.paused,
          ended = _state.ended,
          fadeControls = _state.fadeControls;


      if (beenPlayed && !ended) {
        if (!fadeControls) {
          this.fadeInControls();
        }

        if (!paused) {
          this.updateFadeControlsTimer();
        }
      }
    }
  }, {
    key: 'updateFadeControlsTimer',
    value: function updateFadeControlsTimer() {
      this.removeFadeControlsTimer();
      this.controlsTimer = setTimeout(this.fadeOutControls, DELAY_BEFORE_HIDE_CONTROL);
    }
  }, {
    key: 'removeFadeControlsTimer',
    value: function removeFadeControlsTimer() {
      clearTimeout(this.controlsTimer);
      this.fadeInControls();
    }
  }, {
    key: 'fadeInControls',
    value: function fadeInControls() {
      if (!this.state.fadeControls) {
        this.setState({
          fadeControls: true
        });
      }
    }
  }, {
    key: 'fadeOutControls',
    value: function fadeOutControls() {
      if (this.state.fadeControls) {
        this.setState({
          fadeControls: false
        });
      }
    }
  }, {
    key: 'afterShareClicked',
    value: function afterShareClicked(networkName) {
      this.props.onActionClicked(__WEBPACK_IMPORTED_MODULE_24__overlay_actions_overlay_action_utils__["a" /* OVERLAY_ACTION_TYPES */].SHARE, { networkName: networkName });
    }
  }, {
    key: 'shouldShowOverlay',
    value: function shouldShowOverlay(props, state) {
      var _ref = props || this.props,
          simple = _ref.simple,
          mobileMode = _ref.mobileMode;

      return !this.shouldShowInitialOverlay(props, state) && !simple && !mobileMode;
    }
  }, {
    key: 'playVideo',
    value: function playVideo() {
      var videoItem = this.props.videoItem;
      var durationSec = videoItem.durationSec;


      this.togglePause(false);
      this.toggleEnded(false);
      this.toggleError(false);
      this.seek(0);
      this.setState({ duration: durationSec });
    }
  }, {
    key: 'updateStateFromVideo',
    value: function updateStateFromVideo(state) {
      this.setState(state);
    }
  }, {
    key: 'seek',
    value: function seek(time) {
      this.setState({
        userTime: time
      });
    }
  }, {
    key: 'resetSeek',
    value: function resetSeek() {
      this.seek(null);
    }
  }, {
    key: 'toggleStateBooleanField',
    value: function toggleStateBooleanField(name, value) {
      if (!_.isBoolean(value)) {
        value = !this.state[name];
      }

      this.setState(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, name, value));

      return value;
    }
  }, {
    key: 'handleFullScreenChange',
    value: function handleFullScreenChange() {
      var isInFullScreen = this.isInFullScreen;

      if (!isInFullScreen) {
        this.toggleInfoOverlay();
      }
      this.props.onFullScreenChanged(isInFullScreen);

      this.toggleStateBooleanField('fullScreen', isInFullScreen);
    }
  }, {
    key: 'exitFullScreen',
    value: function exitFullScreen() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__fullscreen_utils__["a" /* exitFullscreen */])(this.videoRef);
    }
  }, {
    key: 'requestFullScreen',
    value: function requestFullScreen(videoItem) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_shared_ui_selectors_video_video_origin__["b" /* isExternalVideo */])(videoItem)) {
        return;
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__fullscreen_utils__["b" /* requestFullscreen */])(this.wrapper, this.videoRef);
    }
  }, {
    key: 'toggleFullScreenByUser',
    value: function toggleFullScreenByUser() {
      var _props2 = this.props,
          onFullScreenClicked = _props2.onFullScreenClicked,
          videoItem = _props2.videoItem;

      var isInFullScreen = this.isInFullScreen;

      onFullScreenClicked(isInFullScreen);

      if (isInFullScreen) {
        this.exitFullScreen();
      } else {
        this.requestFullScreen(videoItem);
      }
    }
  }, {
    key: 'toggleLoading',
    value: function toggleLoading(loading) {
      this.toggleStateBooleanField('loading', loading);
    }
  }, {
    key: 'toggleError',
    value: function toggleError(error) {
      this.toggleStateBooleanField('error', error);
    }
  }, {
    key: 'toggleMute',
    value: function toggleMute(muted) {
      this.toggleStateBooleanField('muted', muted);
    }
  }, {
    key: 'toggleLoop',
    value: function toggleLoop(loop) {
      this.toggleStateBooleanField('loop', loop);
    }
  }, {
    key: 'toggleControls',
    value: function toggleControls(showControls) {
      this.toggleStateBooleanField('showControls', showControls);
    }
  }, {
    key: 'togglePause',
    value: function togglePause(nextPaused) {
      var _props3 = this.props,
          setPlaybackStatus = _props3.setPlaybackStatus,
          onPause = _props3.onPause,
          onResume = _props3.onResume;
      var _state2 = this.state,
          paused = _state2.paused,
          beenPlayed = _state2.beenPlayed;

      if (paused === nextPaused) {
        return;
      }

      this.toggleStateBooleanField('paused', nextPaused);

      if (nextPaused) {
        setPlaybackStatus(__WEBPACK_IMPORTED_MODULE_15_widget_constants_video_playback_status__["a" /* default */].PAUSED);
        onPause();
      } else {
        if (beenPlayed) {
          onResume();
        }
        setPlaybackStatus(__WEBPACK_IMPORTED_MODULE_15_widget_constants_video_playback_status__["a" /* default */].PLAYING);
      }

      if (nextPaused === true) {
        this.removeFadeControlsTimer();
      } else {
        this.updateFadeControlsTimer();
      }
    }
  }, {
    key: 'toggleBeenPlayed',
    value: function toggleBeenPlayed(beenPlayed) {
      var prevBeenPlayed = this.state.beenPlayed;


      if (beenPlayed && beenPlayed !== prevBeenPlayed) {
        this.props.onPlayStart();
      }

      this.toggleStateBooleanField('beenPlayed', beenPlayed);
    }
  }, {
    key: 'toggleEnded',
    value: function toggleEnded(ended) {
      var _props4 = this.props,
          setPlaybackStatus = _props4.setPlaybackStatus,
          onEnded = _props4.onEnded;

      if (ended) {
        this.exitFullScreen();
        setPlaybackStatus(__WEBPACK_IMPORTED_MODULE_15_widget_constants_video_playback_status__["a" /* default */].ENDED);
        onEnded();
        this.toggleBeenPlayed(false);
      }

      this.toggleStateBooleanField('ended', ended);
    }
  }, {
    key: 'toggleInfoOverlay',
    value: function toggleInfoOverlay() {
      var infoOverlay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var infoOverlayProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this.setState({
        infoOverlay: infoOverlay,
        infoOverlayProps: infoOverlayProps
      });
    }
  }, {
    key: 'setVolume',
    value: function setVolume() {
      var volume = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      this.setState({
        volume: volume
      });
    }
  }, {
    key: 'parseVideoUrls',
    value: function parseVideoUrls(videoUrls) {
      if (videoUrls) {
        return {
          videoUrls: _.omit(videoUrls, STORYBOARD_TYPE),
          storyboardUrl: videoUrls[STORYBOARD_TYPE]
        };
      }

      return {
        videoUrls: null,
        storyboardUrl: null
      };
    }
  }, {
    key: 'setVideoUrls',
    value: function setVideoUrls(videoUrls) {
      this.setState(this.parseVideoUrls(videoUrls));
    }
  }, {
    key: 'loadVideoUrls',
    value: function loadVideoUrls(videoItem) {
      var _this2 = this;

      this.setVideoUrls(null);

      var instance = this.props.appSettings.instance;
      var getVideoUrls = videoItem.getVideoUrls;


      if (this.shouldDisplayExternalPlayer || !getVideoUrls) {
        return;
      }

      getVideoUrls(instance).then(function (videoUrls) {
        _this2.setVideoUrls(videoUrls);
      }).catch(function () {
        _this2.toggleLoading(false);
        _this2.toggleError(true);
      });
    }
  }, {
    key: 'shouldShowInitialOverlay',
    value: function shouldShowInitialOverlay() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      var videoUrls = state.videoUrls,
          mobileMode = state.mobileMode,
          beenPlayed = state.beenPlayed,
          ended = state.ended,
          paused = state.paused;


      if (!videoUrls && mobileMode) {
        return false;
      }

      // turn on overlay manually
      if (props.showInitialOverlay) {
        return true;
      }

      if (props.playAtFullScreen || this.isInFullScreen) {
        return false;
      }

      if (beenPlayed && !ended) {
        return false;
      }

      if (!paused) {
        return false;
      }

      return true;
    }
  }, {
    key: 'setVideoRef',
    value: function setVideoRef(videoRef) {
      // TODO: move to state instead of 'this'
      this._videoRef = videoRef;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props5 = this.props,
          simple = _props5.simple,
          playAtFullScreen = _props5.playAtFullScreen,
          mobileMode = _props5.mobileMode,
          className = _props5.className;
      var _state3 = this.state,
          paused = _state3.paused,
          ended = _state3.ended,
          beenPlayed = _state3.beenPlayed,
          infoOverlay = _state3.infoOverlay,
          fadeControls = _state3.fadeControls;


      var styleNames = __WEBPACK_IMPORTED_MODULE_9_classnames___default()('player', {
        simple: simple,
        'not-been-played': !beenPlayed,
        'been-played': fadeControls && beenPlayed,
        'info-overlay-shown': fadeControls && (Boolean(infoOverlay) || playAtFullScreen && paused && !mobileMode && !this.isInFullScreen),
        ended: ended,
        paused: paused
      });

      return React.createElement(
        'section',
        { styleName: styleNames,
          className: className,
          style: this.styles,
          ref: function ref(node) {
            return _this3.wrapper = node;
          },
          'data-hook': 'player',
          'data-player-fullscreen': this.isInFullScreen,
          'data-player-state': paused ? 'paused' : 'playing' },
        React.createElement(__WEBPACK_IMPORTED_MODULE_25__fullscreen_fullscreen_changed_tracker__["a" /* default */], { videoRef: this.videoRef,
          onFullscreenChanged: this.handleFullScreenChange }),
        this.initialOverlay,
        this.video,
        this.poster,
        this.overlay,
        this.infoOverlay,
        this.controls
      );
    }
  }, {
    key: 'videoRef',
    get: function get() {
      return this._videoRef;
    }
  }, {
    key: 'isInFullScreen',
    get: function get() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__fullscreen_utils__["c" /* isInFullscreen */])(this.videoRef);
    }
  }, {
    key: 'shouldDisplayExternalPlayer',
    get: function get() {
      return _.includes([__WEBPACK_IMPORTED_MODULE_17_shared_constants_video_sources__["a" /* default */].VIMEO, __WEBPACK_IMPORTED_MODULE_17_shared_constants_video_sources__["a" /* default */].FACEBOOK], this.props.videoItem.videoSource);
    }
  }, {
    key: 'showChannelCover',
    get: function get() {
      var _props6 = this.props,
          appSettings = _props6.appSettings,
          canShowChannelCover = _props6.canShowChannelCover;

      return canShowChannelCover && appSettings.numbers.mainItemType === __WEBPACK_IMPORTED_MODULE_16_default_settings__["a" /* mainItemTypeValues */].CHANNEL_COVER;
    }
  }, {
    key: 'posterUrl',
    get: function get() {
      var _props7 = this.props,
          videoItem = _props7.videoItem,
          channelData = _props7.channelData;
      var customCoverUrl = videoItem.customCoverUrl;
      var coverUrl = videoItem.coverUrl;


      coverUrl = customCoverUrl || coverUrl;

      if (this.showChannelCover) {
        coverUrl = channelData.customCoverUrl || channelData.coverUrl || coverUrl;
      }

      return coverUrl;
    }

    // fix for Vidi

  }, {
    key: 'poster',
    get: function get() {
      var _props8 = this.props,
          simple = _props8.simple,
          showPoster = _props8.showPoster,
          videoItem = _props8.videoItem,
          width = _props8.width,
          height = _props8.height;


      if (!showPoster) {
        return null;
      }

      if (simple && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_shared_ui_selectors_video_video_origin__["b" /* isExternalVideo */])(videoItem)) {
        return null;
      }

      var posterUrl = this.posterUrl;

      if (!posterUrl) {
        return null;
      }

      if (!this.shouldShowInitialOverlay()) {
        return null;
      }

      return React.createElement(__WEBPACK_IMPORTED_MODULE_12_shared_components_resized_image_resized_image__["a" /* default */], { styleName: 'cover-image',
        src: posterUrl,
        width: width,
        height: height });
    }
  }, {
    key: 'video',
    get: function get() {
      var _state4 = this.state,
          videoUrls = _state4.videoUrls,
          beenPlayed = _state4.beenPlayed,
          paused = _state4.paused;
      var _props9 = this.props,
          width = _props9.width,
          height = _props9.height,
          videoItem = _props9.videoItem,
          onError = _props9.onError,
          simple = _props9.simple,
          mobileMode = _props9.mobileMode;

      // do not render player before user start playing

      if (!beenPlayed && paused && !simple && !mobileMode && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_shared_ui_selectors_video_video_origin__["b" /* isExternalVideo */])(videoItem)) {
        return null;
      }

      return React.createElement(__WEBPACK_IMPORTED_MODULE_19__video_video__["a" /* default */], { styleName: 'video',
        controls: true,
        onError: onError,
        width: width,
        height: height,
        videoItem: videoItem,
        refReceived: this.setVideoRef,
        videoUrls: videoUrls });
    }
  }, {
    key: 'styles',
    get: function get() {
      if (this.isInFullScreen) {
        return {
          width: 'auto',
          height: 'auto'
        };
      }

      var _props10 = this.props,
          width = _props10.width,
          height = _props10.height;

      return {
        width: width,
        height: height
      };
    }
  }, {
    key: 'infoOverlay',
    get: function get() {
      var _props11 = this.props,
          simple = _props11.simple,
          mobileMode = _props11.mobileMode,
          videoItem = _props11.videoItem;

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_shared_ui_selectors_video_video_origin__["b" /* isExternalVideo */])(videoItem)) {
        return null;
      }

      var _state5 = this.state,
          infoOverlay = _state5.infoOverlay,
          infoOverlayProps = _state5.infoOverlayProps;


      if (simple || mobileMode || infoOverlay === null) {
        return null;
      }

      return React.createElement(__WEBPACK_IMPORTED_MODULE_23__info_overlay_info_overlay__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({ content: infoOverlay
      }, infoOverlayProps));
    }
  }, {
    key: 'initialOverlay',
    get: function get() {
      var children = this.props.children;


      if (!children) {
        return null;
      }

      var channelData = this.props.channelData;
      var _state6 = this.state,
          error = _state6.error,
          beenPlayed = _state6.beenPlayed,
          ended = _state6.ended;

      var originProps = _.pick(this.props, 'showChannelCover', 'appSettings', 'videoItem');

      if (error) {
        return null;
      }

      if (!this.shouldShowInitialOverlay()) {
        return null;
      }

      return React.cloneElement(children, _.assign({
        channelData: channelData,
        showChannelCover: this.showChannelCover,
        beenPlayed: beenPlayed,
        ended: ended,
        playVideoItem: this.playVideo,
        togglePause: this.togglePause
      }, originProps));
    }
  }, {
    key: 'actionsList',
    get: function get() {
      var _props12 = this.props,
          appSettings = _props12.appSettings,
          channelData = _props12.channelData,
          videoItem = _props12.videoItem;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__overlay_actions_overlay_action_utils__["b" /* getOverlayActions */])(appSettings, channelData, videoItem);
    }
  }, {
    key: 'overlay',
    get: function get() {
      var _props13 = this.props,
          appSettings = _props13.appSettings,
          simple = _props13.simple,
          onPurchaseClick = _props13.onPurchaseClick,
          onSubscribeClick = _props13.onSubscribeClick,
          mobileMode = _props13.mobileMode,
          videoItem = _props13.videoItem;


      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_shared_ui_selectors_video_video_origin__["b" /* isExternalVideo */])(videoItem)) {
        return null;
      }

      if (simple || mobileMode) {
        return null;
      }

      return React.createElement(__WEBPACK_IMPORTED_MODULE_21__overlay_overlay__["a" /* default */], { styleName: 'overlay',
        actions: React.createElement(__WEBPACK_IMPORTED_MODULE_22__overlay_actions_overlay_actions__["a" /* default */], { actionsList: this.actionsList,
          appSettings: appSettings,
          onActionClicked: this.props.onActionClicked,
          onSubscribeClick: onSubscribeClick,
          onPurchaseClick: onPurchaseClick }) });
    }
  }, {
    key: 'controls',
    get: function get() {
      if (!this.state.showControls || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_shared_ui_selectors_video_video_origin__["b" /* isExternalVideo */])(this.props.videoItem)) {
        return null;
      }

      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_20__controls_controls__["a" /* default */],
        { styleName: 'controls' },
        React.createElement('section', { styleName: 'controls-background',
          onClick: this.togglePause })
      );
    }
  }]);

  return Player;
}(React.Component), _class3.propTypes = {
  children: React.PropTypes.any,
  videoItem: React.PropTypes.object.isRequired,
  videoUrls: React.PropTypes.object,
  channelData: React.PropTypes.object,
  appSettings: React.PropTypes.object,
  className: React.PropTypes.string,
  width: React.PropTypes.number,
  height: React.PropTypes.number,
  onError: React.PropTypes.func,
  onPlayStart: React.PropTypes.func,
  onPause: React.PropTypes.func,
  onResume: React.PropTypes.func,
  showChannelCover: React.PropTypes.bool,
  canShowChannelCover: React.PropTypes.bool,
  posterPosition: React.PropTypes.string,
  simple: React.PropTypes.bool,
  mobileMode: React.PropTypes.bool,
  onEnded: React.PropTypes.func,
  onPurchaseClick: React.PropTypes.func,
  onSubscribeClick: React.PropTypes.func,
  onFullScreenClicked: React.PropTypes.func,
  onFullScreenChanged: React.PropTypes.func,
  openPreviewPrompt: React.PropTypes.func,
  onShowActions: React.PropTypes.func,
  onActionClicked: React.PropTypes.func,
  isFetchDisabled: React.PropTypes.bool,

  setPlaybackStatus: React.PropTypes.func,

  volume: React.PropTypes.number,
  currentTime: React.PropTypes.number,
  paused: React.PropTypes.bool,
  playAtFullScreen: React.PropTypes.bool,
  muted: React.PropTypes.bool,
  loop: React.PropTypes.bool,
  showInitialOverlay: React.PropTypes.bool,
  showPoster: React.PropTypes.bool,
  showControls: React.PropTypes.bool
}, _class3.defaultProps = {
  onError: _.noop,
  onPlayStart: _.noop,
  onPause: _.noop,
  onResume: _.noop,
  openPreviewPrompt: _.noop,
  onShowActions: _.noop,
  onActionClicked: _.noop,
  onFullScreenClicked: _.noop,
  onFullScreenChanged: _.noop,
  onEnded: _.noop,
  paused: true,
  playAtFullScreen: false,
  muted: false,
  volume: 1,
  canShowChannelCover: false,
  posterPosition: __WEBPACK_IMPORTED_MODULE_16_default_settings__["j" /* posterPositionValues */].CENTER,
  simple: false,
  mobileMode: false,
  width: 640,
  height: 360,
  loop: false,
  showInitialOverlay: false,
  showPoster: true,
  showControls: true
}, _class3.childContextTypes = __WEBPACK_IMPORTED_MODULE_28__context_types__["a" /* default */], _temp), (_applyDecoratedDescriptor(_class2.prototype, 'handleMouseMove', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handleMouseMove'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'fadeOutControls', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'fadeOutControls'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'afterShareClicked', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'afterShareClicked'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'playVideo', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'playVideo'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateStateFromVideo', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'updateStateFromVideo'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'seek', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'seek'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'resetSeek', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'resetSeek'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'toggleStateBooleanField', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'toggleStateBooleanField'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleFullScreenChange', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handleFullScreenChange'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'exitFullScreen', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'exitFullScreen'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'requestFullScreen', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a, __WEBPACK_IMPORTED_MODULE_13_widget_utils_not_for_preview__["a" /* notForPreview */]], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'requestFullScreen'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'toggleFullScreenByUser', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'toggleFullScreenByUser'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'toggleLoading', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'toggleLoading'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'toggleError', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'toggleError'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'toggleMute', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'toggleMute'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'toggleLoop', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'toggleLoop'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'toggleControls', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'toggleControls'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'togglePause', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'togglePause'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'toggleBeenPlayed', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'toggleBeenPlayed'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'toggleEnded', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'toggleEnded'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'toggleInfoOverlay', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'toggleInfoOverlay'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setVolume', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'setVolume'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setVideoUrls', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'setVideoUrls'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'loadVideoUrls', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'loadVideoUrls'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setVideoRef', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'setVideoRef'), _class2.prototype)), _class2)) || _class) || _class);


/***/ }),
/* 1281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return External; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__context_types__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_constants_video_sources__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__vimeo__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__youtube__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__facebook__ = __webpack_require__(631);








var _playersMap, _class, _temp;








var playersMap = (_playersMap = {}, __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_playersMap, __WEBPACK_IMPORTED_MODULE_8_shared_constants_video_sources__["a" /* default */].YOUTUBE, __WEBPACK_IMPORTED_MODULE_10__youtube__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_playersMap, __WEBPACK_IMPORTED_MODULE_8_shared_constants_video_sources__["a" /* default */].VIMEO, __WEBPACK_IMPORTED_MODULE_9__vimeo__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_playersMap, __WEBPACK_IMPORTED_MODULE_8_shared_constants_video_sources__["a" /* default */].FACEBOOK, __WEBPACK_IMPORTED_MODULE_11__facebook__["a" /* default */]), _playersMap);

var getNextExternalUrl = function getNextExternalUrl(props) {
  return _.get(props, 'videoItem.mediaExternUrl');
};

var External = (_temp = _class = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(External, _React$Component);

  function External() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, External);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (External.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(External)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(External, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.context.toggleBeenPlayed(!this.context.paused);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps, nextContext) {
      var nextVideoUrl = getNextExternalUrl(nextProps);

      if (nextVideoUrl && nextVideoUrl !== getNextExternalUrl(this.props)) {
        this.context.toggleBeenPlayed(false);
      }

      if (!nextContext.paused && !nextContext.beenPlayed) {
        this.context.toggleBeenPlayed(true);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var videoItem = this.props.videoItem;


      if (!videoItem) {
        return null;
      }

      var id = videoItem.id,
          externalId = videoItem.externalId,
          mediaExternUrl = videoItem.mediaExternUrl,
          videoSource = videoItem.videoSource;


      var props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _.pick(this.props, 'className', 'width', 'height'), _.omit(this.context, 'videoItem', 'toggleBeenPlayed', 'beenPlayed'), {
        src: mediaExternUrl
      });

      var ExternalPlayer = playersMap[videoSource];

      if (!ExternalPlayer) {
        return null;
      }

      return React.createElement(ExternalPlayer, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        key: id || externalId }));
    }
  }]);

  return External;
}(React.Component), _class.propTypes = {
  videoItem: React.PropTypes.object.isRequired,
  width: React.PropTypes.number,
  height: React.PropTypes.number,
  className: React.PropTypes.string
}, _class.contextTypes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__context_types__["b" /* pickContextTypes */])('simple', 'mobileMode', 'paused', 'loop', 'muted', 'toggleBeenPlayed', 'beenPlayed', 'showControls'), _temp);


/***/ }),
/* 1282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InternalPlayer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vidi__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vidi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vidi__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_widget_player_widget_utils_wix_connect__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__context_types__ = __webpack_require__(62);








var _dec, _class, _desc, _value, _class2, _class3, _temp2;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}








var EVENTS = ['onAbort', 'onCanPlay', 'onCanPlayThrough', 'onDurationChange', 'onEmptied', 'onEncrypted', 'onEnded', 'onError', 'onLoadedData', 'onLoadedMetadata', 'onLoadStart', 'onPause', 'onPlay', 'onPlaying', 'onProgress', 'onRateChange', 'onSeeked', 'onSeeking', 'onStalled', 'onSuspend', 'onTimeUpdate', 'onVolumeChange', 'onWaiting'];

var InternalPlayer = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_widget_player_widget_utils_wix_connect__["a" /* WixConnect */])(), _dec(_class = (_class2 = (_temp2 = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(InternalPlayer, _React$Component);

  function InternalPlayer() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, InternalPlayer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = InternalPlayer.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(InternalPlayer)).call.apply(_ref, [this].concat(args))), _this), _this.vidi = new __WEBPACK_IMPORTED_MODULE_8_vidi___default.a(), _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(InternalPlayer, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      // Also bind 'this' as we call _updateStateFromVideo outside
      // of Reacts synthetic events as well.
      this._updateStateFromVideo = _.throttle(this.updateStateFromVideo, 100).bind(this);
      // Set up all React media events and call method
      // on props if provided.
      this.mediaEventProps = _.reduce(EVENTS, function (p, c) {
        p[c] = function () {
          if (c in _this2.props && _.isFunction(_this2.props[c])) {
            // A prop exists for this mediaEvent, call it.
            _this2.props[c]();
          }
          _this2._updateStateFromVideo();
        };

        return p;
      }, {});
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Add error event listener to video.
      this.vidi.on('error', this.handleVideoError);
      this.videoEl.addEventListener('ended', this.handleVideoEnd, true);
      this.videoEl.addEventListener('play', this.handleVideoPlay, true);
      this.videoEl.addEventListener('playing', this.handleVideoPlaying, true);
      this.videoEl.addEventListener('pause', this.handleVideoPause, false);
      this.videoEl.addEventListener('canplay', this.autoPlay, true);

      // to display loaded. Playing will started on canplay event
      var paused = this.context.paused;

      if (!paused) {
        this.togglePause(paused);
      }
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState, nextContext) {
      var nextVideoUrls = nextProps.videoUrls;
      var nextPaused = nextContext.paused;
      var videoUrls = this.props.videoUrls;
      var _context = this.context,
          paused = _context.paused,
          volume = _context.volume,
          userTime = _context.userTime,
          resetSeek = _context.resetSeek;


      this.setVolume(volume);

      if (!_.isEqual(nextVideoUrls, videoUrls)) {
        return;
      }

      if (_.isNumber(userTime) && userTime >= 0) {
        this.seek(userTime);
        resetSeek();
      }

      if (nextPaused !== paused) {
        this.togglePause(nextPaused);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var videoUrls = this.props.videoUrls;


      if (!_.isEqual(prevProps.videoUrls, videoUrls)) {
        this.setSrc(videoUrls);
      }
    }

    /**
     * Removes event listeners bound outside of React's synthetic events
     * @return {undefined}
     */

  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // Remove event listener from video.
      this.vidi.off('error', this.handleVideoError);
      this.videoEl.removeEventListener('ended', this.handleVideoEnd, true);
      this.videoEl.removeEventListener('play', this.handleVideoPlay, true);
      this.videoEl.removeEventListener('playing', this.handleVideoPlaying, true);
      this.videoEl.removeEventListener('pause', this.handleVideoPause, false);
      this.videoEl.removeEventListener('canplay', this.autoPlay, true);
    }
  }, {
    key: 'handleVideoError',
    value: function handleVideoError(error) {
      this.props.onError(error);

      if (!this.videoEl) {
        return;
      }

      var _videoEl = this.videoEl,
          networkState = _videoEl.networkState,
          NETWORK_NO_SOURCE = _videoEl.NETWORK_NO_SOURCE;


      if (networkState === NETWORK_NO_SOURCE && _.size(this.vidi.src) > 0) {
        this.context.toggleError(true);
      }
    }
  }, {
    key: 'handleVideoPlaying',
    value: function handleVideoPlaying() {
      this.context.toggleBeenPlayed(true);
    }
  }, {
    key: 'handleVideoEnd',
    value: function handleVideoEnd() {
      var _context2 = this.context,
          toggleEnded = _context2.toggleEnded,
          togglePause = _context2.togglePause;


      togglePause(true);
      toggleEnded(true);
    }
  }, {
    key: 'handleVideoPlay',
    value: function handleVideoPlay() {
      this.context.toggleEnded(false);
    }

    // fix. Vidi can`t recognize just list of urls with GET params

  }, {
    key: 'toVidiTypes',
    value: function toVidiTypes(url, type) {
      if (/mp4/i.test(type)) {
        return { url: url, type: __WEBPACK_IMPORTED_MODULE_8_vidi___default.a.MediaStreamTypes.MP4, name: /[0-9]+p/i.exec(type)[0] };
      }
      if (/mpd/i.test(type)) {
        return { url: url, type: __WEBPACK_IMPORTED_MODULE_8_vidi___default.a.MediaStreamTypes.DASH };
      }
      if (/m3u8/i.test(type)) {
        return { url: url, type: __WEBPACK_IMPORTED_MODULE_8_vidi___default.a.MediaStreamTypes.HLS };
      }
      if (/webm/i.test(type)) {
        return { url: url, type: __WEBPACK_IMPORTED_MODULE_8_vidi___default.a.MediaStreamTypes.WEBM };
      }
      return null;
    }
  }, {
    key: 'setSrc',
    value: function setSrc(urlsByVodTypes) {
      var vidiUrls = _.map(urlsByVodTypes, this.toVidiTypes);
      this.vidi.src = _.compact(vidiUrls);
    }
  }, {
    key: 'handleVideoPause',
    value: function handleVideoPause() {
      this.context.togglePause(true);
    }

    /**
     * Sets the video to fullscreen.
     * @return {undefined}
     */

  }, {
    key: 'goFullScreen',
    value: function goFullScreen() {
      if (this.videoEl.requestFullscreen) {
        this.videoEl.requestFullscreen();
      } else if (this.videoEl.msRequestFullscreen) {
        this.videoEl.msRequestFullscreen();
      } else if (this.videoEl.mozRequestFullScreen) {
        this.videoEl.mozRequestFullScreen();
      } else if (this.videoEl.webkitRequestFullscreen) {
        this.videoEl.webkitRequestFullscreen();
      }
    }

    /**
     * Plays the video if paused == false was set.
     * @return {undefined}
     */

  }, {
    key: 'autoPlay',
    value: function autoPlay() {
      var paused = this.context.paused;


      if (!paused) {
        if (this.videoEl.paused) {
          this.videoEl.play();
        }
      }
    }

    /**
     * Plays the video.
     * @return {undefined}
     */

  }, {
    key: 'play',
    value: function play() {
      this.videoEl.play();
    }

    /**
     * Pauses the video.
     * @return {undefined}
     */

  }, {
    key: 'pause',
    value: function pause() {
      this.videoEl.pause();
    }

    /**
     * Toggles the video to play and pause.
     * @return {undefined}
     */

  }, {
    key: 'togglePause',
    value: function togglePause(paused) {
      if (paused) {
        this.pause();
      } else {
        this.play();
      }
    }

    /**
     * Seeks the video timeline.
     * @param  {number} time The value in seconds to seek to
     * @return {undefined}
     */

  }, {
    key: 'seek',
    value: function seek(time) {
      this.videoEl.currentTime = time;
    }

    /**
     * Sets the video volume.
     * @param  {number} volume The volume level between 0 and 1.
     * @return {undefined}
     */

  }, {
    key: 'setVolume',
    value: function setVolume(volume) {
      if (!this.videoEl) {
        return;
      }

      this.videoEl.volume = volume;
    }

    /**
     * Updates the React component state from the DOM video properties.
     * This is where the magic happens.
     * @return {undefined}
     */

  }, {
    key: 'updateStateFromVideo',
    value: function updateStateFromVideo() {
      if (!this.videoEl) {
        return;
      }

      var updateStateFromVideo = this.context.updateStateFromVideo;


      var duration = this.videoEl.duration || 0;
      var bufferedLength = this.videoEl.buffered.length;

      updateStateFromVideo({
        // Standard video properties
        duration: duration,
        currentTime: this.videoEl.currentTime,
        buffered: this.videoEl.buffered,

        readyState: this.videoEl.readyState,

        // Non-standard state computed from properties
        percentageBuffered: bufferedLength && this.videoEl.buffered.end(bufferedLength - 1) / duration * 100,
        percentagePlayed: this.videoEl.currentTime / duration * 100,
        loading: this.videoEl.readyState < this.videoEl.HAVE_ENOUGH_DATA
      });
    }
  }, {
    key: 'handleRef',
    value: function handleRef(element) {
      this.props.refReceived(element);

      this.videoEl = element;
      this.vidi.setVideoElement(element);
      if (element) {
        this.setSrc(this.props.videoUrls);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var className = this.props.className;
      var _context3 = this.context,
          muted = _context3.muted,
          loop = _context3.loop;


      var props = {
        className: className,
        muted: muted,
        loop: loop
      };

      return React.createElement('video', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, props, this.mediaEventProps, {
        ref: this.handleRef }));
    }
  }]);

  return InternalPlayer;
}(React.Component), _class3.contextTypes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__context_types__["b" /* pickContextTypes */])('muted', 'loop', 'volume', 'duration', 'currentTime', 'userTime', 'controls', 'paused', 'resetSeek', 'updateStateFromVideo', 'togglePause', 'toggleError', 'toggleBeenPlayed', 'toggleEnded'), _class3.propTypes = {
  onError: React.PropTypes.func,
  className: React.PropTypes.string,
  videoUrls: React.PropTypes.object,
  refReceived: React.PropTypes.func
}, _class3.defaultProps = {
  refReceived: _.noop
}, _temp2), (_applyDecoratedDescriptor(_class2.prototype, 'handleVideoError', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handleVideoError'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleVideoPlaying', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handleVideoPlaying'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleVideoEnd', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handleVideoEnd'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleVideoPlay', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handleVideoPlay'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleVideoPause', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handleVideoPause'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'goFullScreen', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'goFullScreen'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'autoPlay', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'autoPlay'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'play', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'play'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'pause', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'pause'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'togglePause', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'togglePause'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'seek', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'seek'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setVolume', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'setVolume'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updateStateFromVideo', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'updateStateFromVideo'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleRef', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handleRef'), _class2.prototype)), _class2)) || _class);


/***/ }),
/* 1283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Video; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_widget_player_widget_utils_wix_connect__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_ui_selectors_video_video_origin__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__external_external__ = __webpack_require__(1281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__internal_internal__ = __webpack_require__(1282);






var _dec, _class, _class2, _temp;








var Video = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_widget_player_widget_utils_wix_connect__["a" /* WixConnect */])(), _dec(_class = (_temp = _class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Video, _React$Component);

  function Video() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Video);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Video.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Video)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Video, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          videoUrls = _props.videoUrls,
          videoItem = _props.videoItem;

      var isExternal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_shared_ui_selectors_video_video_origin__["b" /* isExternalVideo */])(videoItem);

      if (!isExternal && !videoUrls) {
        return null;
      }

      var PlayerComponent = isExternal ? __WEBPACK_IMPORTED_MODULE_7__external_external__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_8__internal_internal__["a" /* default */];

      var props = _.omit(this.props, 'intl', 'styles');

      return React.createElement(PlayerComponent, props);
    }
  }]);

  return Video;
}(React.Component), _class2.propTypes = {
  videoItem: React.PropTypes.object.isRequired,
  videoUrls: React.PropTypes.object
}, _temp)) || _class);


/***/ }),
/* 1284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SocialButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_settings__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_widget_utils_not_for_preview__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_widget_player_widget_utils_wix_connect__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_utils_open_popup__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__social_networks__ = __webpack_require__(1286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_widget_player_widget_components_icon_icon__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__social_button_styl__ = __webpack_require__(1504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__social_button_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__social_button_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__translations__ = __webpack_require__(1285);







var _dec, _class, _desc, _value, _class2, _class3, _temp2;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}


















var SocialButton = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_widget_player_widget_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_15__social_button_styl___default.a), _dec(_class = (_class2 = (_temp2 = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(SocialButton, _React$Component);

  function SocialButton() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, SocialButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = SocialButton.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(SocialButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      showPopout: false
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(SocialButton, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          network = _props.network,
          formatMessage = _props.intl.formatMessage;

      this.socialNetwork = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__social_networks__["a" /* default */])({
        formatMessage: formatMessage,
        hosts: __WEBPACK_IMPORTED_MODULE_9_shared_settings__["a" /* default */].hosts
      })[network];
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var link = this.link,
          popout = this.popout,
          copyLink = this.copyLink;
      // We use addEventListener because react`s elements are destroyed before onClick is fired

      if (popout) {
        copyLink.addEventListener('click', this.handleCopyToClipboard);
        popout.addEventListener('click', this.stopPropagation);
        link.addEventListener('click', this.togglePopout);
      } else {
        link.addEventListener('click', this.handleShareIconClick);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var link = this.link,
          popout = this.popout,
          copyLink = this.copyLink;


      if (popout) {
        copyLink.removeEventListener('click', this.handleCopyToClipboard);
        popout.removeEventListener('click', this.stopPropagation);
        link.removeEventListener('click', this.togglePopout);
      } else {
        link.removeEventListener('click', this.handleShareIconClick);
      }
    }
  }, {
    key: 'handleShareIconClick',
    value: function handleShareIconClick(event) {
      event.preventDefault();
      event.stopPropagation();

      this.openShareWindow();

      var _props2 = this.props,
          onClick = _props2.onClick,
          network = _props2.network;

      onClick(network);
    }
  }, {
    key: 'openShareWindow',
    value: function openShareWindow() {
      var content = this.props.content;
      var getShareUrl = this.socialNetwork.getShareUrl;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_shared_utils_open_popup__["a" /* default */])(getShareUrl(content));
    }
  }, {
    key: 'togglePopout',
    value: function togglePopout(event) {
      event.preventDefault();
      event.stopPropagation();

      var showPopout = this.state.showPopout;


      this.setState({
        showPopout: !showPopout
      });
    }
  }, {
    key: 'stopPropagation',
    value: function stopPropagation(event) {
      event.stopPropagation();
    }
  }, {
    key: 'handleCopyToClipboard',
    value: function handleCopyToClipboard(event) {
      event.preventDefault();

      if (document.queryCommandSupported('copy')) {
        this.input.select();
        document.execCommand('copy');
      }
    }
  }, {
    key: 'saveRef',
    value: function saveRef(name) {
      var _this2 = this;

      return function (element) {
        _this2[name] = element;
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          network = _props3.network,
          className = _props3.className,
          rounded = _props3.rounded,
          linkClassName = _props3.linkClassName,
          formatMessage = _props3.intl.formatMessage;
      var name = this.socialNetwork.name;


      var styleNames = __WEBPACK_IMPORTED_MODULE_7_classnames___default()('social-button', network, {
        rounded: rounded
      });

      return React.createElement(
        'span',
        { styleName: 'tooltip',
          className: className },
        React.createElement(
          'a',
          { href: '#',
            'data-hook': network,
            title: formatMessage(__WEBPACK_IMPORTED_MODULE_16__translations__["a" /* default */][name]),
            styleName: styleNames,
            className: linkClassName,
            ref: this.saveRef('link') },
          React.createElement(__WEBPACK_IMPORTED_MODULE_14_widget_player_widget_components_icon_icon__["a" /* default */], { name: network })
        ),
        this.popoutContent
      );
    }
  }, {
    key: 'popoutContent',
    get: function get() {
      var _props4 = this.props,
          content = _props4.content,
          network = _props4.network,
          popoutInnerClassName = _props4.popoutInnerClassName,
          popoutOuterClassName = _props4.popoutOuterClassName;
      var showPopout = this.state.showPopout;
      var getShareUrl = this.socialNetwork.getShareUrl;


      if (network !== 'link') {
        return null;
      }

      var url = getShareUrl(content);

      var styleNames = __WEBPACK_IMPORTED_MODULE_7_classnames___default()('popout', {
        hide: !showPopout
      });

      return React.createElement(
        'span',
        { className: popoutOuterClassName,
          styleName: styleNames,
          ref: this.saveRef('popout') },
        React.createElement(
          'span',
          { className: popoutInnerClassName,
            styleName: 'popout-inner' },
          React.createElement('input', { type: 'text',
            value: url,
            readOnly: true,
            styleName: 'copy-url-input',
            ref: this.saveRef('input') }),
          React.createElement(
            'a',
            { href: '#',
              styleName: 'copy-url-link',
              ref: this.saveRef('copyLink') },
            React.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["a" /* FormattedMessage */], __WEBPACK_IMPORTED_MODULE_16__translations__["a" /* default */].copy)
          )
        )
      );
    }
  }]);

  return SocialButton;
}(React.Component), _class3.propTypes = {
  network: React.PropTypes.string.isRequired,
  content: React.PropTypes.shape({
    siteUrl: React.PropTypes.string,
    title: React.PropTypes.string,
    description: React.PropTypes.string,
    thumbnailUrl: React.PropTypes.string
  }).isRequired,
  rounded: React.PropTypes.bool,
  className: React.PropTypes.string,
  popoutOuterClassName: React.PropTypes.string,
  popoutInnerClassName: React.PropTypes.string,
  linkClassName: React.PropTypes.string,
  tooltip: React.PropTypes.bool,
  onClick: React.PropTypes.func,
  intl: __WEBPACK_IMPORTED_MODULE_6_react_intl__["e" /* intlShape */]
}, _class3.defaultProps = {
  rounded: false,
  onClick: _.noop
}, _temp2), (_applyDecoratedDescriptor(_class2.prototype, 'handleShareIconClick', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handleShareIconClick'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'openShareWindow', [__WEBPACK_IMPORTED_MODULE_10_widget_utils_not_for_preview__["a" /* notForPreview */]], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'openShareWindow'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'togglePopout', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a, __WEBPACK_IMPORTED_MODULE_10_widget_utils_not_for_preview__["a" /* notForPreview */]], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'togglePopout'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleCopyToClipboard', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a, __WEBPACK_IMPORTED_MODULE_10_widget_utils_not_for_preview__["a" /* notForPreview */]], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handleCopyToClipboard'), _class2.prototype)), _class2)) || _class);


/***/ }),
/* 1285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* defineMessages */])({
  facebook: {
    id: 'social-button.facebook',
    defaultMessage: 'Facebook'
  },
  twitter: {
    id: 'social-button.twitter',
    defaultMessage: 'Twitter'
  },
  pinterest: {
    id: 'social-button.pinterest',
    defaultMessage: 'Pinterest'
  },
  tumblr: {
    id: 'social-button.tumblr',
    defaultMessage: 'Tumblr'
  },
  link: {
    id: 'social-button.link',
    defaultMessage: 'Link'
  },
  copy: {
    id: 'social-button.copy',
    defaultMessage: 'Copy'
  }
}));

/***/ }),
/* 1286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initSocialShare;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_widget_player_widget_utils_build_url__ = __webpack_require__(1288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_widget_player_widget_utils_resize_image__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_widget_constants_social_networks__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__translations__ = __webpack_require__(1287);







function initSocialShare(_ref) {
  var formatMessage = _ref.formatMessage,
      hosts = _ref.hosts;


  function buildImageUrl(coverUrl) {
    return 'https:' + hosts.image + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_widget_player_widget_utils_resize_image__["a" /* default */])(coverUrl);
  }

  return {
    facebook: {
      name: __WEBPACK_IMPORTED_MODULE_2_widget_constants_social_networks__["a" /* default */].FACEBOOK,
      getShareUrl: function getShareUrl(content) {
        var siteUrl = content.siteUrl,
            title = content.title,
            description = content.description,
            coverUrl = content.coverUrl;


        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_widget_player_widget_utils_build_url__["a" /* default */])('https://www.facebook.com/sharer/sharer.php', {
          ref: 'site',
          display: 'popup',
          picture: buildImageUrl(coverUrl),
          title: title,
          description: description,
          u: siteUrl,
          redirect_uri: 'http://musicwizard.wix.com/backend/assets/notify_parent.html'
        });
      }
    },
    twitter: {
      name: __WEBPACK_IMPORTED_MODULE_2_widget_constants_social_networks__["a" /* default */].TWITTER,
      getShareUrl: function getShareUrl(content) {
        var siteUrl = content.siteUrl,
            title = content.title;


        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_widget_player_widget_utils_build_url__["a" /* default */])('https://twitter.com/intent/tweet', {
          original_referer: siteUrl,
          text: formatMessage(__WEBPACK_IMPORTED_MODULE_3__translations__["a" /* default */].twitter, { title: title, siteUrl: siteUrl })
        });
      }
    },
    pinterest: {
      name: __WEBPACK_IMPORTED_MODULE_2_widget_constants_social_networks__["a" /* default */].PINTEREST,
      getShareUrl: function getShareUrl(content) {
        var siteUrl = content.siteUrl,
            coverUrl = content.coverUrl,
            title = content.title,
            description = content.description;


        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_widget_player_widget_utils_build_url__["a" /* default */])('https://www.pinterest.com/pin/create/button/', {
          url: siteUrl,
          media: buildImageUrl(coverUrl),
          description: formatMessage(__WEBPACK_IMPORTED_MODULE_3__translations__["a" /* default */].pinterest, { title: title, description: description })
        });
      }
    },
    tumblr: {
      name: __WEBPACK_IMPORTED_MODULE_2_widget_constants_social_networks__["a" /* default */].TUMBLR,
      getShareUrl: function getShareUrl(content) {
        var title = content.title,
            siteUrl = content.siteUrl,
            coverUrl = content.coverUrl;


        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_widget_player_widget_utils_build_url__["a" /* default */])('https://www.tumblr.com/widgets/share/tool', {
          posttype: 'photo',
          // todo: need to find a way to resize image for tumblr
          content: buildImageUrl(coverUrl),
          caption: formatMessage(__WEBPACK_IMPORTED_MODULE_3__translations__["a" /* default */].tumblr, { title: title, siteUrl: siteUrl }),
          url: siteUrl
        });
      }
    },
    link: {
      name: __WEBPACK_IMPORTED_MODULE_2_widget_constants_social_networks__["a" /* default */].LINK,
      getShareUrl: _.property('siteUrl')
    }
  };
}

/***/ }),
/* 1287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* defineMessages */])({
  twitter: {
    id: 'social-share.twitter',
    defaultMessage: 'Watch "{title}" on {siteUrl}'
  },
  pinterest: {
    id: 'social-share.pinterest',
    defaultMessage: '{title} - {description}'
  },
  tumblr: {
    id: 'social-share.tumblr',
    defaultMessage: '{title} - {siteUrl}'
  }
}));

/***/ }),
/* 1288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildUrl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

function encode(value) {
  return encodeURIComponent(value).replace(/%40/gi, '@').replace(/%3A/gi, ':').replace(/%24/gi, '$').replace(/%2C/gi, ',').replace(/%20/gi, '+');
}

function buildUrl(url, params) {
  if (!params) {
    return url;
  }

  var parts = _(params).map(function (value, key) {
    if (_.isNil(value)) {
      return '';
    }

    if (_.isDate(value) && !isNaN(value.valueOf())) {
      value = value.toISOString();
    } else if (_.isObject(value)) {
      value = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value);
    }

    return encode(key) + '=' + encode(value);
  }).compact().value();

  if (parts.length !== 0) {
    url += (_.includes(url, '?') ? '&' : '?') + parts.join('&');
  }

  return url;
}

/***/ }),
/* 1289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isAbsoluteUrl;
function isAbsoluteUrl(url) {
  return (/^(https?:)?\/\//.test(url)
  );
}

/***/ }),
/* 1290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NAMES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return resetSearch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);


var NAMES = {
  UPDATE_SEARCH: 'CLIENT.SEARCH.UPDATE_SEARCH',
  RESET_SEARCH: 'CLIENT.SEARCH.RESET_SEARCH'
};

var updateSearch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(NAMES.UPDATE_SEARCH);
var resetSearch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(NAMES.RESET_SEARCH);

/***/ }),
/* 1291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = canAccessChannelWithSubscription;
/* harmony export (immutable) */ __webpack_exports__["b"] = canSubscribeToChannel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_ui_selectors_channel_pricing__ = __webpack_require__(543);


function canAccessChannelWithSubscription(channel) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_ui_selectors_channel_pricing__["a" /* isSubscriptionEnabled */])(channel) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_ui_selectors_channel_pricing__["b" /* isSubscribedTo */])(channel);
}

function canSubscribeToChannel(channel) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_ui_selectors_channel_pricing__["a" /* isSubscriptionEnabled */])(channel) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_ui_selectors_channel_pricing__["b" /* isSubscribedTo */])(channel);
}

/***/ }),
/* 1292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Animate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__animate_styl__ = __webpack_require__(1671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__animate_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__animate_styl__);








var _dec, _class, _class2, _temp;





// TODO: can be moved to shared
var Animate = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_9__animate_styl___default.a), _dec(_class = (_temp = _class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Animate, _React$Component);

  function Animate() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Animate);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Animate.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Animate)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Animate, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$type = _props.type,
          type = _props$type === undefined ? 'fade-in' : _props$type,
          children = _props.children,
          when = _props.when,
          className = _props.className,
          activeClassName = _props.activeClassName,
          dataHook = _props.dataHook;


      if (!children) {
        return null;
      }

      var styleNames = __WEBPACK_IMPORTED_MODULE_7_classnames___default()(type, { active: when });
      var classNames = __WEBPACK_IMPORTED_MODULE_7_classnames___default()(className, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, activeClassName, when));

      return React.createElement(
        'div',
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, dataHook && when && { 'data-hook': dataHook }, {
          className: classNames,
          styleName: styleNames }),
        children
      );
    }
  }]);

  return Animate;
}(React.Component), _class2.propTypes = {
  className: React.PropTypes.string,
  activeClassName: React.PropTypes.string,

  dataHook: React.PropTypes.string,

  children: React.PropTypes.any,
  when: React.PropTypes.bool,
  type: React.PropTypes.oneOf(['fade-in', 'fade-in-out'])
}, _temp)) || _class);


/***/ }),
/* 1293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getPaidAccessButtonConfig;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_widget_ui_selectors_video_access__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translation_data__ = __webpack_require__(1621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__callback__ = __webpack_require__(1620);





function getPaidAccessButtonConfig(props) {
  var channelData = props.channelData,
      videoItem = props.videoItem,
      currentSiteUser = props.currentSiteUser;

  var fullAccessAction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_widget_ui_selectors_video_access__["d" /* getFullAccessActionName */])(channelData, videoItem, currentSiteUser);

  var callback = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__callback__["a" /* default */])(props, fullAccessAction);
  var translationData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__translation_data__["a" /* default */])(fullAccessAction, channelData, videoItem);

  if (translationData) {
    return {
      callback: callback,
      translationData: translationData
    };
  }

  return null;
}

/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".header-mobile__header__2MoeJ{color:#000;background:transparent}.header-mobile__title__2rMEn{margin:30px 0 25px;font-size:18px;font-weight:400;text-align:center}.header-mobile__close-button__1X650{position:absolute;top:-20px;right:0;width:auto;height:auto;font-size:14px;background:transparent;color:hsla(0,0%,100%,.6)}.header-mobile__close-button__1X650:hover{background:none}", ""]);

// exports
exports.locals = {
	"header": "header-mobile__header__2MoeJ",
	"title": "header-mobile__title__2rMEn",
	"close-button": "header-mobile__close-button__1X650",
	"closeButton": "header-mobile__close-button__1X650"
};

/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".header__header__UE0EM{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;-ms-flex:0 0 auto;flex:0 0 auto;height:60px;padding:0 18px 0 30px;color:#f0f3f5;background:#3899ec}.header__title__2W6OY{-ms-flex:1 1 auto;flex:1 1 auto;margin:0;font-family:HelveticaNeueW01-45Ligh,HelveticaNeueW02-45Ligh,HelveticaNeueW10-45Ligh,Helvetica Neue,ruble,Helvetica,Arial,sans-serif;font-size:18px;font-weight:300}.header__button__-w1X3{-ms-flex:0 0 auto;flex:0 0 auto;width:25px;height:25px;margin-left:10px;border-radius:50%;color:inherit;font-size:9px;background:rgba(22,45,61,.2)}.header__button__-w1X3:hover{color:inherit;background:#0d487f}.header__help-button__3_ozX{display:none}.header__help__3-9hB .header__help-button__3_ozX{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;font-family:HelveticaNeueW01-45Ligh,HelveticaNeueW02-45Ligh,HelveticaNeueW10-45Ligh,Helvetica Neue,ruble,Helvetica,Arial,sans-serif;font-size:16px;font-weight:300}.header__danger__2nJoN{background:#ee5951}.header__empty__300ai,.header__iframe__2AfGB{position:relative;height:0}.header__empty__300ai .header__title__2W6OY,.header__iframe__2AfGB .header__title__2W6OY{display:none}.header__empty__300ai .header__close-button__xGqmB,.header__iframe__2AfGB .header__close-button__xGqmB{position:absolute;top:12px;right:12px;z-index:10}.header__iframe__2AfGB .header__close-button__xGqmB{top:15px;right:15px}.header__empty__300ai .header__close-button__xGqmB{background:none;font-size:16px;color:#737373}.header__empty__300ai .header__close-button__xGqmB:hover{background:none}.header__simple__1KF8w{position:relative;height:0}.header__simple__1KF8w .header__title__2W6OY{display:none}.header__simple__1KF8w .header__close-button__xGqmB{position:absolute;top:18px;right:18px;z-index:10;border-radius:50%;background:#d3edff;color:#3899ec;font-size:9px}", ""]);

// exports
exports.locals = {
	"header": "header__header__UE0EM",
	"title": "header__title__2W6OY",
	"button": "header__button__-w1X3",
	"help-button": "header__help-button__3_ozX",
	"helpButton": "header__help-button__3_ozX",
	"help": "header__help__3-9hB",
	"danger": "header__danger__2nJoN",
	"empty": "header__empty__300ai",
	"iframe": "header__iframe__2AfGB",
	"close-button": "header__close-button__xGqmB",
	"closeButton": "header__close-button__xGqmB",
	"simple": "header__simple__1KF8w"
};

/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".modal-mobile__modal-mobile__2I8vt{background:rgba(0,0,0,.8)}.modal-mobile__modal-mobile-window__3pnJo{width:85%;min-width:85%;overflow:visible;border-radius:0;text-align:center}.modal-mobile__modal-mobile-content__1FcRl{padding:0;color:#000}.modal-mobile__fixed-iframe__4ISc3{z-index:9999}", ""]);

// exports
exports.locals = {
	"modal-mobile": "modal-mobile__modal-mobile__2I8vt",
	"modalMobile": "modal-mobile__modal-mobile__2I8vt",
	"modal-mobile-window": "modal-mobile__modal-mobile-window__3pnJo",
	"modalMobileWindow": "modal-mobile__modal-mobile-window__3pnJo",
	"modal-mobile-content": "modal-mobile__modal-mobile-content__1FcRl",
	"modalMobileContent": "modal-mobile__modal-mobile-content__1FcRl",
	"fixed-iframe": "modal-mobile__fixed-iframe__4ISc3",
	"fixedIframe": "modal-mobile__fixed-iframe__4ISc3"
};

/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".modal__modal__3_VLi{position:fixed;top:0;left:0;right:0;bottom:0;z-index:10000;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;background-color:rgba(22,45,61,.8);opacity:0;transition:opacity .2s}.modal__modal__3_VLi.modal__open__1tiA2{opacity:1}.modal__window__3I8Zz{position:relative;overflow:hidden;width:495px;max-width:calc(100% - 60px);border-radius:8px;background:#fff;box-shadow:0 0 14px 0 rgba(29,45,60,.3)}.modal__content__Q2mjk{padding:31px 30px 27px;color:#2b5672;font-family:HelveticaNeueW01-45Ligh,HelveticaNeueW02-45Ligh,HelveticaNeueW10-45Ligh,Helvetica Neue,ruble,Helvetica,Arial,sans-serif;font-size:16px;line-height:22px;font-weight:300}.modal__overlay-modal__24mD7{display:block;padding:26px 23px;background-color:#f9fdff}.modal__overlay-modal__24mD7 .modal__content__Q2mjk{height:100%;padding:14px 17px}.modal__overlay-modal__24mD7 .modal__close-button__1NwhM{position:absolute;z-index:1;top:14px;right:14px;width:14px;height:14px;border-radius:0;color:#2b2b2b;font-size:14px;background:none;opacity:.3;transition:opacity .2s}.modal__overlay-modal__24mD7 .modal__close-button__1NwhM:hover{background:none;opacity:.5}.modal__buttons__11ozG{display:-ms-flexbox;display:flex;-ms-flex-pack:end;justify-content:flex-end;padding:0 24px 30px}.modal__button__1bbiM{min-width:96px;height:30px;margin-left:18px;font-family:HelveticaNeueW01-55Roma,HelveticaNeueW02-55Roma,HelveticaNeueW10-55Roma,Helvetica Neue,ruble,Helvetica,Arial,sans-serif;font-size:14px}.modal__iframe-modal-window__3ghgr{width:500px;height:555px}.modal__iframe-modal-content__3OQu8{height:100%;padding:0}.modal__iframe__ZqQ7a{border:none;border-radius:8px}.modal__iframe__ZqQ7a,.modal__simple-modal-content__reCAs{width:100%;height:100%}", ""]);

// exports
exports.locals = {
	"modal": "modal__modal__3_VLi",
	"open": "modal__open__1tiA2",
	"window": "modal__window__3I8Zz",
	"content": "modal__content__Q2mjk",
	"overlay-modal": "modal__overlay-modal__24mD7",
	"overlayModal": "modal__overlay-modal__24mD7",
	"close-button": "modal__close-button__1NwhM",
	"closeButton": "modal__close-button__1NwhM",
	"buttons": "modal__buttons__11ozG",
	"button": "modal__button__1bbiM",
	"iframe-modal-window": "modal__iframe-modal-window__3ghgr",
	"iframeModalWindow": "modal__iframe-modal-window__3ghgr",
	"iframe-modal-content": "modal__iframe-modal-content__3OQu8",
	"iframeModalContent": "modal__iframe-modal-content__3OQu8",
	"iframe": "modal__iframe__ZqQ7a",
	"simple-modal-content": "modal__simple-modal-content__reCAs",
	"simpleModalContent": "modal__simple-modal-content__reCAs"
};

/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".loading-spinner__circle__1edF6{top:50%;left:50%;margin-top:-15px;margin-left:-15px;color:#fff;animation:loading-spinner__rotate__1Johv 1s linear infinite;width:30px;height:30px;position:absolute;clip:rect(0,36px,36px,18px)}.loading-spinner__circle__1edF6:after{clip:rect(4px,36px,36px,18px);animation:loading-spinner__clip__3hzVM 1s linear infinite}.loading-spinner__circle__1edF6:after,.loading-spinner__circle__1edF6:before{content:\"\";top:0;left:0;right:0;bottom:0;border:3px solid currentColor;border-radius:50%;position:absolute}.loading-spinner__circle__1edF6:before{clip:rect(0,36px,36px,18px);animation:loading-spinner__clip-reverse__3Zn6w 1s linear infinite}@keyframes loading-spinner__clip__3hzVM{50%{clip:rect(30px,36px,36px,18px);animation-timing-function:ease-in-out}}@keyframes loading-spinner__clip-reverse__3Zn6w{50%{clip:rect(0,36px,9px,18px);animation-timing-function:ease-in-out;transform:rotate(135deg)}}@keyframes loading-spinner__rotate__1Johv{0%{transform:rotate(0);animation-timing-function:ease-out}45%{transform:rotate(18deg);color:#fff}55%{transform:rotate(54deg)}to{transform:rotate(1turn)}}", ""]);

// exports
exports.locals = {
	"circle": "loading-spinner__circle__1edF6",
	"rotate": "loading-spinner__rotate__1Johv",
	"clip": "loading-spinner__clip__3hzVM",
	"clip-reverse": "loading-spinner__clip-reverse__3Zn6w",
	"clipReverse": "loading-spinner__clip-reverse__3Zn6w"
};

/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".preview-prompt__modal__1GlIK{background-color:rgba(22,45,61,.6)}.preview-prompt__modal-content__KDjSu{padding:0}.preview-prompt__prompt-wrapper__SvFMd{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:stretch;align-items:stretch;padding:40px 30px 30px}.preview-prompt__second-message__1-T-Q{margin-bottom:30px}.preview-prompt__close-button__X479Z{-ms-flex-item-align:end;align-self:flex-end;height:30px;padding:0 30px}", ""]);

// exports
exports.locals = {
	"modal": "preview-prompt__modal__1GlIK",
	"modal-content": "preview-prompt__modal-content__KDjSu",
	"modalContent": "preview-prompt__modal-content__KDjSu",
	"prompt-wrapper": "preview-prompt__prompt-wrapper__SvFMd",
	"promptWrapper": "preview-prompt__prompt-wrapper__SvFMd",
	"second-message": "preview-prompt__second-message__1-T-Q",
	"secondMessage": "preview-prompt__second-message__1-T-Q",
	"close-button": "preview-prompt__close-button__X479Z",
	"closeButton": "preview-prompt__close-button__X479Z"
};

/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, "@font-face{font-family:fontello-vod-widget;src:url(" + __webpack_require__(1508) + ") format(\"woff\");font-weight:400;font-style:normal}.icon__icon__39l-x{font-family:fontello-vod-widget;font-style:normal;font-weight:400;speak:none;text-decoration:inherit;font-variant:normal;text-transform:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;transition:all .2s}", ""]);

// exports
exports.locals = {
	"icon": "icon__icon__39l-x"
};

/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".action-button__action-button__16693{display:-ms-inline-flexbox;display:inline-flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:32px;height:32px;color:#fff;font-size:16px;text-decoration:none;white-space:nowrap;background-color:rgba(0,0,0,.5);transition:background-color .2s}.action-button__action-button__16693:focus{outline:none;text-decoration:none}.action-button__action-button__16693:hover{background-color:#000;text-decoration:none}.action-button__action-button__16693:active{background:#000;text-decoration:none}.action-button__action-button__16693.action-button__rounded__2RwbP{border-radius:999px}.action-button__action-button__16693.action-button__with-label__1d3jP{width:auto;padding:0 12px}.action-button__action-button__16693.action-button__at-full-screen__3Rz57{width:42px;height:42px;font-size:20px}.action-button__action-button__16693.action-button__at-full-screen__3Rz57.action-button__with-label__1d3jP{width:auto;padding:0 15px}.action-button__label__1_lIh{margin-right:8px;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family,Helvetica Neue,ruble,Helvetica,Arial,sans-serif;text-decoration:-wix-fonts-textFont-decoration;font-size:12px}.action-button__at-full-screen__3Rz57 .action-button__label__1_lIh{font-size:18px;margin-right:10px}@media (max-width:639px){.action-button__action-button__16693{width:28px;height:28px;font-size:14px}.action-button__label__1_lIh{margin-right:6px}}@media (max-width:449px){.action-button__with-label__1d3jP{width:28px;padding:0}.action-button__label__1_lIh{display:none}}", ""]);

// exports
exports.locals = {
	"action-button": "action-button__action-button__16693",
	"actionButton": "action-button__action-button__16693",
	"rounded": "action-button__rounded__2RwbP",
	"with-label": "action-button__with-label__1d3jP",
	"withLabel": "action-button__with-label__1d3jP",
	"at-full-screen": "action-button__at-full-screen__3Rz57",
	"atFullScreen": "action-button__at-full-screen__3Rz57",
	"label": "action-button__label__1_lIh"
};

/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".control-button__control-button__1AxMR{position:relative;display:-ms-inline-flexbox;display:inline-flex;height:100%;margin:0;box-sizing:border-box;padding:10px;border:none;color:#fff;font-size:14px;text-decoration:none;background:none;cursor:pointer}.control-button__control-button__1AxMR.control-button__at-full-screen__11sc1{font-size:21px}.control-button__control-button__1AxMR:focus{outline:none}.control-button__control-button__1AxMR.control-button__menu-open__hafD3 .control-button__popout--menu__1fHAi,.control-button__control-button__1AxMR:hover .control-button__popout--tooltip__rdhcJ{display:-ms-flexbox;display:flex}.control-button__control-button__1AxMR.control-button__menu-open__hafD3 .control-button__popout--tooltip__rdhcJ,.control-button__popout__3SZI7{display:none}.control-button__popout__3SZI7{box-sizing:border-box;-ms-flex-pack:center;justify-content:center;-ms-flex:0 0 auto;flex:0 0 auto;-ms-flex-align:end;align-items:flex-end;position:absolute;bottom:100%;height:0;padding-bottom:6px}.control-button__popout--menu__1fHAi .control-button__popout--inner__2NG98{padding:0}.control-button__popout--center__2j2Mo{width:100px;left:calc(-50px + 50%)}.control-button__popout--left__1dPYN{right:4px}.control-button__popout--inner__2NG98{padding:9px 10px;border-radius:4px;font-size:12px;background-color:rgba(0,0,0,.7);box-shadow:0 1px 10px 0 rgba(0,0,0,.3)}.control-button__at-full-screen__11sc1 .control-button__popout--inner__2NG98{font-size:14px}.control-button__tooltip__3_SWQ{font-family:HelveticaNeueW01-55Roma,HelveticaNeueW02-55Roma,HelveticaNeueW10-55Roma,Helvetica Neue,ruble,Helvetica,Arial,sans-serif;font-size:12px;white-space:nowrap}", ""]);

// exports
exports.locals = {
	"control-button": "control-button__control-button__1AxMR",
	"controlButton": "control-button__control-button__1AxMR",
	"at-full-screen": "control-button__at-full-screen__11sc1",
	"atFullScreen": "control-button__at-full-screen__11sc1",
	"menu-open": "control-button__menu-open__hafD3",
	"menuOpen": "control-button__menu-open__hafD3",
	"popout--menu": "control-button__popout--menu__1fHAi",
	"popoutMenu": "control-button__popout--menu__1fHAi",
	"popout--tooltip": "control-button__popout--tooltip__rdhcJ",
	"popoutTooltip": "control-button__popout--tooltip__rdhcJ",
	"popout": "control-button__popout__3SZI7",
	"popout--inner": "control-button__popout--inner__2NG98",
	"popoutInner": "control-button__popout--inner__2NG98",
	"popout--center": "control-button__popout--center__2j2Mo",
	"popoutCenter": "control-button__popout--center__2j2Mo",
	"popout--left": "control-button__popout--left__1dPYN",
	"popoutLeft": "control-button__popout--left__1dPYN",
	"tooltip": "control-button__tooltip__3_SWQ"
};

/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".controls__controls__2WtGC{position:absolute;z-index:3;left:0;right:0;bottom:0;height:auto;background:none}.controls__controls__2WtGC.controls__paused__3LCoz{opacity:1}.controls__controls-row__BFnxT{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;height:42px;padding-top:7px;padding-bottom:20px}.controls__fullscreen__FaSIs,.controls__play__1eapL,.controls__time__3Nncr,.controls__volume__2avvs{-ms-flex:0 0 auto;flex:0 0 auto}.controls__progress__1NcMK,.controls__simple__2BZ6D .controls__time__3Nncr{-ms-flex:1 1 auto;flex:1 1 auto}.controls__mobile-mode__3_Bdm .controls__volume__2avvs,.controls__simple__2BZ6D .controls__progress__1NcMK,.controls__simple__2BZ6D .controls__volume__2avvs{display:none!important}.controls__play__1eapL{width:45px;padding:0 12px 0 18px;border-right:1px solid hsla(0,0%,100%,.2)}.controls__time__3Nncr{margin-right:15px;padding:0 15px 0 12px}.controls__volume__2avvs{width:52px;margin-left:15px;padding:0 15px}.controls__fullscreen__FaSIs{width:56px;padding:0 18px 0 15px}.controls__at-full-screen__3DHz8 .controls__play__1eapL{width:65px;padding:0 18px 0 24px}.controls__at-full-screen__3DHz8 .controls__time__3Nncr{margin-right:15px;padding:0 15px 0 18px}.controls__at-full-screen__3DHz8 .controls__volume__2avvs{width:63px;margin-left:15px;padding:0 15px}.controls__at-full-screen__3DHz8 .controls__fullscreen__FaSIs{width:74px;padding:0 24px 0 15px}@media (max-width:639px){.controls__time__3Nncr{margin-right:9px;padding:0 9px 0 12px}.controls__volume__2avvs{width:40px;margin-left:9px;padding:0 9px}.controls__fullscreen__FaSIs{width:50px;padding:0 18px 0 9px}}", ""]);

// exports
exports.locals = {
	"controls": "controls__controls__2WtGC",
	"paused": "controls__paused__3LCoz",
	"controls-row": "controls__controls-row__BFnxT",
	"controlsRow": "controls__controls-row__BFnxT",
	"fullscreen": "controls__fullscreen__FaSIs",
	"play": "controls__play__1eapL",
	"time": "controls__time__3Nncr",
	"volume": "controls__volume__2avvs",
	"progress": "controls__progress__1NcMK",
	"simple": "controls__simple__2BZ6D",
	"mobile-mode": "controls__mobile-mode__3_Bdm",
	"mobileMode": "controls__mobile-mode__3_Bdm",
	"at-full-screen": "controls__at-full-screen__3DHz8",
	"atFullScreen": "controls__at-full-screen__3DHz8"
};

/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".fullscreen__fullscreen-button__2wW-_{-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.fullscreen__fullscreen-button__2wW-_:hover .fullscreen__icon__2OybO{opacity:1}.fullscreen__fullscreen-button__2wW-_:hover .fullscreen__icon-exit-fullscreen__sSUHt,.fullscreen__fullscreen-button__2wW-_:hover .fullscreen__icon-fullscreen__1oUz3{display:none}.fullscreen__fullscreen-button__2wW-_:hover .fullscreen__icon-exit-fullscreen-hover__2IzWE,.fullscreen__fullscreen-button__2wW-_:hover .fullscreen__icon-fullscreen-hover__1S9hL{display:block}.fullscreen__icon__2OybO{-ms-flex-item-align:center;-ms-grid-row-align:center;align-self:center;opacity:.8}.fullscreen__icon-exit-fullscreen-hover__2IzWE,.fullscreen__icon-fullscreen-hover__1S9hL{display:none}.fullscreen__icon-fullscreen__1oUz3{font-size:15px}.fullscreen__icon-fullscreen-hover__1S9hL{font-size:17px}.fullscreen__icon-exit-fullscreen-hover__2IzWE{font-size:21px}.fullscreen__icon-exit-fullscreen__sSUHt{font-size:25px}", ""]);

// exports
exports.locals = {
	"fullscreen-button": "fullscreen__fullscreen-button__2wW-_",
	"fullscreenButton": "fullscreen__fullscreen-button__2wW-_",
	"icon": "fullscreen__icon__2OybO",
	"icon-exit-fullscreen": "fullscreen__icon-exit-fullscreen__sSUHt",
	"iconExitFullscreen": "fullscreen__icon-exit-fullscreen__sSUHt",
	"icon-fullscreen": "fullscreen__icon-fullscreen__1oUz3",
	"iconFullscreen": "fullscreen__icon-fullscreen__1oUz3",
	"icon-exit-fullscreen-hover": "fullscreen__icon-exit-fullscreen-hover__2IzWE",
	"iconExitFullscreenHover": "fullscreen__icon-exit-fullscreen-hover__2IzWE",
	"icon-fullscreen-hover": "fullscreen__icon-fullscreen-hover__1S9hL",
	"iconFullscreenHover": "fullscreen__icon-fullscreen-hover__1S9hL"
};

/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".play__play__bW3Uj{box-sizing:border-box;-ms-flex-align:center;align-items:center}.play__play__bW3Uj .play__icon__1yPKz{opacity:.8;transition-property:opacity}.play__play__bW3Uj:hover .play__icon__1yPKz{opacity:1}.play__play--play__1SJBk .play__icon__1yPKz{font-size:17px}.play__play--pause__Hh_VX .play__icon__1yPKz{font-size:14px}.play__at-full-screen__2f1he.play__play--play__1SJBk .play__icon__1yPKz{font-size:24px}.play__at-full-screen__2f1he.play__play--pause__Hh_VX .play__icon__1yPKz{font-size:21px}", ""]);

// exports
exports.locals = {
	"play": "play__play__bW3Uj",
	"icon": "play__icon__1yPKz",
	"play--play": "play__play--play__1SJBk",
	"playPlay": "play__play--play__1SJBk",
	"play--pause": "play__play--pause__Hh_VX",
	"playPause": "play__play--pause__Hh_VX",
	"at-full-screen": "play__at-full-screen__2f1he",
	"atFullScreen": "play__at-full-screen__2f1he"
};

/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".progress__seek__2ReJw{position:relative;height:3px;padding:0}.progress__focused__h_5sr{outline:none}.progress__container__3F_ui{position:relative;width:100%;height:100%;background:hsla(0,0%,100%,.3);cursor:pointer}.progress__buffer-bar__34FJT{position:absolute;top:0;left:0;height:100%;background-color:hsla(0,0%,100%,.4)}.progress__progress-bar__3akFK{transition:background .2s;background-color:-wix-colors-buttonsAndLinksColor-70}.progress__container__3F_ui:hover .progress__progress-bar__3akFK{background-color:-wix-colors-buttonsAndLinksColor}.progress__progress-bar__3akFK:after{content:\"\";position:absolute;top:-5px;right:-5px;width:12px;height:12px;background-color:#fff;border-radius:50%}.progress__progress-input__3iwjK{height:12px;bottom:-5px;top:-5px}", ""]);

// exports
exports.locals = {
	"seek": "progress__seek__2ReJw",
	"focused": "progress__focused__h_5sr",
	"container": "progress__container__3F_ui",
	"buffer-bar": "progress__buffer-bar__34FJT",
	"bufferBar": "progress__buffer-bar__34FJT",
	"progress-bar": "progress__progress-bar__3akFK",
	"progressBar": "progress__progress-bar__3akFK",
	"progress-input": "progress__progress-input__3iwjK",
	"progressInput": "progress__progress-input__3iwjK"
};

/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".time__time__k_aVD{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;line-height:16px;color:hsla(0,0%,100%,.8);font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family,Helvetica Neue,ruble,Helvetica,Arial,sans-serif;text-decoration:-wix-fonts-textFont-decoration;font-size:12px}.time__time__k_aVD.time__at-full-screen__2GJxr{font-size:14px}.time__time__current__1P8cs{margin-right:5px}.time__time__duration__3Pmug{margin-left:5px}", ""]);

// exports
exports.locals = {
	"time": "time__time__k_aVD",
	"at-full-screen": "time__at-full-screen__2GJxr",
	"atFullScreen": "time__at-full-screen__2GJxr",
	"time__current": "time__time__current__1P8cs",
	"timeCurrent": "time__time__current__1P8cs",
	"time__duration": "time__time__duration__3Pmug",
	"timeDuration": "time__time__duration__3Pmug"
};

/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".volume__mute__30QM4{text-align:left}.volume__mute__30QM4 .volume__icon__36H0s{-ms-flex-item-align:center;-ms-grid-row-align:center;align-self:center;opacity:.8;font-size:17px}.volume__mute__30QM4.volume__at-full-screen__25W9z .volume__icon__36H0s{font-size:26px}.volume__mute__30QM4:hover .volume__icon__36H0s{opacity:1}.volume__mute__volume__1cbtc{position:absolute;left:50%;bottom:100%;display:none;width:24px;height:40px;margin-left:-12px;padding-top:8px;background-color:#1a1a1a}.volume__mute--focused__1I6eo .volume__mute__volume__1cbtc,.volume__mute__30QM4:hover .volume__mute__volume__1cbtc{display:block}.volume__mute__track__vZYGk{box-sizing:content-box;position:relative;height:86px;width:2px;padding:2px 7px}.volume__level__1Z_uU{background-color:hsla(207,7%,70%,.8)}.volume__level-fill__3sApa:after{content:\"\";position:absolute;top:-5px;right:-5px;width:12px;height:12px;background-color:#fff;border-radius:50%}.volume__level-input__1tGaJ{width:12px;left:-5px;right:-5px}", ""]);

// exports
exports.locals = {
	"mute": "volume__mute__30QM4",
	"icon": "volume__icon__36H0s",
	"at-full-screen": "volume__at-full-screen__25W9z",
	"atFullScreen": "volume__at-full-screen__25W9z",
	"mute__volume": "volume__mute__volume__1cbtc",
	"muteVolume": "volume__mute__volume__1cbtc",
	"mute--focused": "volume__mute--focused__1I6eo",
	"muteFocused": "volume__mute--focused__1I6eo",
	"mute__track": "volume__mute__track__vZYGk",
	"muteTrack": "volume__mute__track__vZYGk",
	"level": "volume__level__1Z_uU",
	"level-fill": "volume__level-fill__3sApa",
	"levelFill": "volume__level-fill__3sApa",
	"level-input": "volume__level-input__1tGaJ",
	"levelInput": "volume__level-input__1tGaJ"
};

/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".info-overlay__info-overlay__eRaQu{position:absolute;top:0;left:0;right:0;bottom:0;z-index:10;transition:opacity .2s;opacity:0}.info-overlay__info-overlay__eRaQu.info-overlay__show__3bGQN{opacity:1}.info-overlay__close__3HEpG{position:absolute;z-index:2;top:17px;right:17px;overflow:hidden;color:hsla(0,0%,100%,.7);font-size:20px;cursor:pointer}.info-overlay__close-fullscreen__1bzZl{font-size:41px}.info-overlay__content__26mq-{position:absolute;top:0;left:0;right:0;bottom:0;z-index:1;color:#fff;background-color:rgba(0,0,0,.85)}.info-overlay__content__26mq-.info-overlay__half__3p4PT{left:50%}.info-overlay__content__26mq-.info-overlay__at-full-screen__2pBpt{left:calc(100% - 630px)}.info-overlay__background-overlay__1Intr{position:absolute;top:0;left:0;right:0;bottom:0;background-color:transparent}@media (max-width:639px){.info-overlay__info-overlay__eRaQu{width:100%;max-width:480px;left:auto}.info-overlay__info-overlay__eRaQu.info-overlay__full-width__2AQ7z{max-width:none}.info-overlay__content__26mq-.info-overlay__at-full-screen__2pBpt,.info-overlay__content__26mq-.info-overlay__half__3p4PT{left:0}}", ""]);

// exports
exports.locals = {
	"info-overlay": "info-overlay__info-overlay__eRaQu",
	"infoOverlay": "info-overlay__info-overlay__eRaQu",
	"show": "info-overlay__show__3bGQN",
	"close": "info-overlay__close__3HEpG",
	"close-fullscreen": "info-overlay__close-fullscreen__1bzZl",
	"closeFullscreen": "info-overlay__close-fullscreen__1bzZl",
	"content": "info-overlay__content__26mq-",
	"half": "info-overlay__half__3p4PT",
	"at-full-screen": "info-overlay__at-full-screen__2pBpt",
	"atFullScreen": "info-overlay__at-full-screen__2pBpt",
	"background-overlay": "info-overlay__background-overlay__1Intr",
	"backgroundOverlay": "info-overlay__background-overlay__1Intr",
	"full-width": "info-overlay__full-width__2AQ7z",
	"fullWidth": "info-overlay__full-width__2AQ7z"
};

/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".info__wrapper__cqgq4{display:-ms-flexbox;display:flex;height:100%;padding:0 0 0 40px;font-size:14px;overflow:hidden}.info__scrollbar-wrapper__14rO3{-ms-flex-positive:1;flex-grow:1;overflow-x:hidden;overflow-y:scroll;overflow-y:overlay;-ms-overflow-style:-ms-autohiding-scrollbar}.info__scrollbar-wrapper__14rO3::-webkit-scrollbar-thumb{background-color:#636565}.info__scrollbar-wrapper__14rO3::-webkit-scrollbar-thumb:active,.info__scrollbar-wrapper__14rO3::-webkit-scrollbar-thumb:hover{background-color:#fff}.info__poster__2__1b{display:block;-ms-flex:0 0 auto;flex:0 0 auto;margin:40px 40px 40px 0;background:50% no-repeat;background-size:cover}.info__poster__2__1b.info__fullscreen__OqRqs,.info__poster__2__1b.info__poster-compact__3aa4G{display:none;margin:0}.info__main-info__WHBHI{width:100%;padding:40px 40px 0 0}.info__title__2_bUM{font-size:16px;line-height:20px}.info__info__3sCrS,.info__title__2_bUM{margin-bottom:20px;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family,Helvetica Neue,ruble,Helvetica,Arial,sans-serif;text-decoration:-wix-fonts-textFont-decoration}.info__info__3sCrS{line-height:14px;display:-ms-flexbox;display:flex}.info__info-item__3YlZe{margin-right:13px;padding-right:13px;border-right:1px solid #fff;text-transform:capitalize;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.info__info-item__3YlZe:last-child{margin-right:0;padding-right:0;border:none}.info__description__3R1Ge{margin-bottom:20px;color:hsla(0,0%,100%,.7);font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family,Helvetica Neue,ruble,Helvetica,Arial,sans-serif;text-decoration:-wix-fonts-textFont-decoration;white-space:pre-wrap}.info__roles-wrapper__QGev3{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:20px;padding-top:20px;border-top:1px solid hsla(0,0%,100%,.2);color:#fff}.info__roles-title__2fPM0{width:100%;font-size:12px;color:hsla(0,0%,100%,.5);text-transform:uppercase}.info__role-item__ogisM{-ms-flex:1 1 auto;flex:1 1 auto;width:45%;margin-top:20px;margin-right:5px}.info__role__1e9RJ{margin-bottom:5px}.info__name__OcPg8,.info__role__1e9RJ{text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.info__name__OcPg8{font-style:italic}.info__full-screen__1Un83{padding:80px 70px 40px 90px}.info__full-screen__1Un83 .info__main-info__WHBHI{padding:0 20px 0 0}.info__full-screen__1Un83 .info__title__2_bUM{margin-bottom:30px;font-size:42px;line-height:46px}.info__full-screen__1Un83 .info__description__3R1Ge{margin-bottom:40px}.info__full-screen__1Un83 .info__roles-wrapper__QGev3{margin-bottom:40px;padding-top:40px}.info__full-screen__1Un83 .info__roles-title__2fPM0{margin-bottom:5px}.info__full-screen__1Un83 .info__poster__2__1b.info__fullscreen__OqRqs{display:block;margin:40px 40px 40px 0}@media (max-width:639px){.info__wrapper__cqgq4{padding:0 0 0 30px}.info__main-info__WHBHI{padding:40px 30px 0 0}.info__poster__2__1b{display:none;margin:30px 30px 30px 0}.info__poster__2__1b.info__poster-compact__3aa4G{display:block;width:100%;padding:20px 0;border-top:1px solid hsla(0,0%,100%,.2)}}@media (max-width:449px){.info__role-item__ogisM{width:100%}}", ""]);

// exports
exports.locals = {
	"wrapper": "info__wrapper__cqgq4",
	"scrollbar-wrapper": "info__scrollbar-wrapper__14rO3",
	"scrollbarWrapper": "info__scrollbar-wrapper__14rO3",
	"poster": "info__poster__2__1b",
	"fullscreen": "info__fullscreen__OqRqs",
	"poster-compact": "info__poster-compact__3aa4G",
	"posterCompact": "info__poster-compact__3aa4G",
	"main-info": "info__main-info__WHBHI",
	"mainInfo": "info__main-info__WHBHI",
	"title": "info__title__2_bUM",
	"info": "info__info__3sCrS",
	"info-item": "info__info-item__3YlZe",
	"infoItem": "info__info-item__3YlZe",
	"description": "info__description__3R1Ge",
	"roles-wrapper": "info__roles-wrapper__QGev3",
	"rolesWrapper": "info__roles-wrapper__QGev3",
	"roles-title": "info__roles-title__2fPM0",
	"rolesTitle": "info__roles-title__2fPM0",
	"role-item": "info__role-item__ogisM",
	"roleItem": "info__role-item__ogisM",
	"role": "info__role__1e9RJ",
	"name": "info__name__OcPg8",
	"full-screen": "info__full-screen__1Un83",
	"fullScreen": "info__full-screen__1Un83"
};

/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".share__share-overlay__5AegS{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;-ms-flex-direction:column;flex-direction:column;height:100%}.share__title__nxMOB{font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family,Helvetica Neue,ruble,Helvetica,Arial,sans-serif;text-decoration:-wix-fonts-textFont-decoration;margin-bottom:20px;font-size:18px}@media (max-width:549px){.share__title__nxMOB{font-size:14px;margin:13px 0 0}}.share__social-icons__3Hnvy{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:325px}.share__share-icon__2WNxR{color:#fff;height:60px;font-size:38px;text-decoration:none}@media (max-width:549px){.share__share-icon__2WNxR{font-size:20px}}.share__share-link__njEdF{padding-left:20px;padding-right:20px}@media (max-width:549px){.share__share-link__njEdF{padding-left:11px;padding-right:11px}}.share__link__1GT2s:hover{color:-wix-colors-buttonsAndLinksColor}[data-layout=\"3\"] .share__link__1GT2s:hover{color:hsla(0,0%,100%,.5)}.share__tumblr__3QwFD:hover{color:#34465d}.share__pinterest__13EtM:hover{color:#bd081c}.share__facebook__2Pncv:hover{color:#3b5999}.share__twitter__OTnWt:hover{color:#55acee}[data-layout=\"3\"] .share__popout-outer__1HfHw{width:222px}[data-layout=\"3\"] .share__popout-inner__2_a9Z:hover{color:#000}", ""]);

// exports
exports.locals = {
	"share-overlay": "share__share-overlay__5AegS",
	"shareOverlay": "share__share-overlay__5AegS",
	"title": "share__title__nxMOB",
	"social-icons": "share__social-icons__3Hnvy",
	"socialIcons": "share__social-icons__3Hnvy",
	"share-icon": "share__share-icon__2WNxR",
	"shareIcon": "share__share-icon__2WNxR",
	"share-link": "share__share-link__njEdF",
	"shareLink": "share__share-link__njEdF",
	"link": "share__link__1GT2s",
	"tumblr": "share__tumblr__3QwFD",
	"pinterest": "share__pinterest__13EtM",
	"facebook": "share__facebook__2Pncv",
	"twitter": "share__twitter__OTnWt",
	"popout-outer": "share__popout-outer__1HfHw",
	"popoutOuter": "share__popout-outer__1HfHw",
	"popout-inner": "share__popout-inner__2_a9Z",
	"popoutInner": "share__popout-inner__2_a9Z"
};

/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".overlay-actions__actions__1M7Xe{position:absolute;top:12px;right:12px;display:-ms-flexbox;display:flex;-ms-flex-align:end;align-items:flex-end;-ms-flex-direction:column;flex-direction:column}.overlay-actions__actions__1M7Xe.overlay-actions__at-full-screen__206-a{top:24px;right:24px}.overlay-actions__action-button__du-2A{margin-bottom:12px}.overlay-actions__at-full-screen__206-a .overlay-actions__action-button__du-2A{margin-bottom:18px}@media (max-width:639px){.overlay-actions__action-button__du-2A{margin-bottom:10px}}", ""]);

// exports
exports.locals = {
	"actions": "overlay-actions__actions__1M7Xe",
	"at-full-screen": "overlay-actions__at-full-screen__206-a",
	"atFullScreen": "overlay-actions__at-full-screen__206-a",
	"action-button": "overlay-actions__action-button__du-2A",
	"actionButton": "overlay-actions__action-button__du-2A"
};

/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".overlay__overlay__uqOJg{position:absolute;z-index:1;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;padding-bottom:42px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;transition:background .2s;background:linear-gradient(0deg,transparent,rgba(0,0,0,.6)) no-repeat;background-size:100% 0}.overlay__not-been-played__4abCH{z-index:4;padding-bottom:0;background:none}.overlay__been-played__pqEZC.overlay__paused__HDDYz,.overlay__been-played__pqEZC:hover{background-size:100% 75px}.overlay__been-played__pqEZC.overlay__paused__HDDYz .overlay__hover-content__3CdNv,.overlay__been-played__pqEZC:hover .overlay__hover-content__3CdNv{opacity:1}.overlay__been-played__pqEZC.overlay__ended__37UwA{background:none}.overlay__been-played-content__2d18H{display:none}.overlay__been-played__pqEZC .overlay__been-played-content__2d18H,.overlay__video-url-loading__1-lKP .overlay__been-played-content__2d18H{display:block}.overlay__video-url-loading__1-lKP .overlay__hover-content__3CdNv{display:none}.overlay__hover-content__3CdNv{position:absolute;top:0;left:0;right:0;bottom:0;opacity:0;transition:opacity .25s cubic-bezier(.4,0,1,1)}.overlay__title__3APxY{position:absolute;top:18px;left:18px;right:205px;margin:0;color:#fff;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family;text-decoration:-wix-fonts-textFont-decoration;font-size:14px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.overlay__ended__37UwA .overlay__title__3APxY{display:none}.overlay__at-full-screen__2lEPZ .overlay__title__3APxY{top:24px;left:24px;right:276px;font-size:20px}.overlay__error-text__305tV{padding:10px 20px;border-radius:4px;color:#fff;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family;text-decoration:-wix-fonts-textFont-decoration;font-size:14px;background-color:rgba(0,0,0,.7)}@media (max-width:639px){.overlay__title__3APxY{right:178px}}@media (max-width:449px){.overlay__title__3APxY{right:76px}}", ""]);

// exports
exports.locals = {
	"overlay": "overlay__overlay__uqOJg",
	"not-been-played": "overlay__not-been-played__4abCH",
	"notBeenPlayed": "overlay__not-been-played__4abCH",
	"been-played": "overlay__been-played__pqEZC",
	"beenPlayed": "overlay__been-played__pqEZC",
	"paused": "overlay__paused__HDDYz",
	"hover-content": "overlay__hover-content__3CdNv",
	"hoverContent": "overlay__hover-content__3CdNv",
	"ended": "overlay__ended__37UwA",
	"been-played-content": "overlay__been-played-content__2d18H",
	"beenPlayedContent": "overlay__been-played-content__2d18H",
	"video-url-loading": "overlay__video-url-loading__1-lKP",
	"videoUrlLoading": "overlay__video-url-loading__1-lKP",
	"title": "overlay__title__3APxY",
	"at-full-screen": "overlay__at-full-screen__2lEPZ",
	"atFullScreen": "overlay__at-full-screen__2lEPZ",
	"error-text": "overlay__error-text__305tV",
	"errorText": "overlay__error-text__305tV"
};

/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".player__player__3pJFb{position:relative;background:#000}.player__player__3pJFb:-webkit-full-screen{width:100%!important;height:100%!important}.player__been-played__2Ksuj.player__paused__5vh-f .player__controls__6hBmk,.player__been-played__2Ksuj.player__paused__5vh-f .player__controls-background__3-tbi,.player__been-played__2Ksuj.player__paused__5vh-f .player__overlay__CUQ1F,.player__been-played__2Ksuj:hover .player__controls__6hBmk,.player__been-played__2Ksuj:hover .player__controls-background__3-tbi,.player__been-played__2Ksuj:hover .player__overlay__CUQ1F{opacity:1}.player__cover-image__3QPtI,.player__video__iqgHJ{width:100%;height:100%;line-height:normal}.player__video__iqgHJ::-webkit-media-controls-start-playback-button{display:none!important;-webkit-appearance:none}.player__cover-image__3QPtI{position:absolute;left:0;top:0;background:transparent 50% no-repeat;background-size:cover}.player__controls__6hBmk,.player__overlay__CUQ1F{opacity:0}.player__controls-background__3-tbi{opacity:0;position:absolute;z-index:2;left:0;right:0;bottom:0;height:130px;background:linear-gradient(180deg,transparent 0,rgba(0,0,0,.6)) no-repeat bottom;background-size:100% 130px}@media (max-width:549px){.player__controls-background__3-tbi{height:115px;background-size:100% 115px}}@media (max-width:449px){.player__controls-background__3-tbi{height:70px;background-size:100% 70px}}.player__controls__6hBmk,.player__controls-background__3-tbi,.player__overlay__CUQ1F{transition:opacity .25s cubic-bezier(.4,0,1,1)}.player__info-overlay-shown__hULaR .player__controls__6hBmk,.player__info-overlay-shown__hULaR .player__controls-background__3-tbi,.player__info-overlay-shown__hULaR .player__overlay__CUQ1F{opacity:0!important}.player__simple__sNGr1 .player__controls__6hBmk,.player__simple__sNGr1 .player__controls-background__3-tbi{opacity:1}", ""]);

// exports
exports.locals = {
	"player": "player__player__3pJFb",
	"been-played": "player__been-played__2Ksuj",
	"beenPlayed": "player__been-played__2Ksuj",
	"paused": "player__paused__5vh-f",
	"controls": "player__controls__6hBmk",
	"controls-background": "player__controls-background__3-tbi",
	"controlsBackground": "player__controls-background__3-tbi",
	"overlay": "player__overlay__CUQ1F",
	"cover-image": "player__cover-image__3QPtI",
	"coverImage": "player__cover-image__3QPtI",
	"video": "player__video__iqgHJ",
	"info-overlay-shown": "player__info-overlay-shown__hULaR",
	"infoOverlayShown": "player__info-overlay-shown__hULaR",
	"simple": "player__simple__sNGr1"
};

/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".progress-bar__progress-bar__1h675{position:relative;width:100%;height:100%}.progress-bar__progress-bar--vertical__aTQyc .progress-bar__progress-bar__fill__1dYUM{width:100%}.progress-bar__progress-bar--vertical__aTQyc .progress-bar__progress-bar__input__2wcj2{-webkit-appearance:slider-vertical;-ms-writing-mode:bt-lr}.progress-bar__progress-bar--horizontal__169nR .progress-bar__progress-bar__fill__1dYUM{height:100%}.progress-bar__progress-bar__fill__1dYUM{position:absolute;bottom:0;left:0;background-color:hsla(0,0%,100%,.9)}.progress-bar__progress-bar__input__2wcj2{position:absolute;top:0;left:0;right:0;bottom:0;width:100%;height:100%;padding:0;margin:0;border:0;cursor:pointer;outline:none;opacity:0}", ""]);

// exports
exports.locals = {
	"progress-bar": "progress-bar__progress-bar__1h675",
	"progressBar": "progress-bar__progress-bar__1h675",
	"progress-bar--vertical": "progress-bar__progress-bar--vertical__aTQyc",
	"progressBarVertical": "progress-bar__progress-bar--vertical__aTQyc",
	"progress-bar__fill": "progress-bar__progress-bar__fill__1dYUM",
	"progressBarFill": "progress-bar__progress-bar__fill__1dYUM",
	"progress-bar__input": "progress-bar__progress-bar__input__2wcj2",
	"progressBarInput": "progress-bar__progress-bar__input__2wcj2",
	"progress-bar--horizontal": "progress-bar__progress-bar--horizontal__169nR",
	"progressBarHorizontal": "progress-bar__progress-bar--horizontal__169nR"
};

/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".scrollbar-wrapper__scrollbar-wrapper__3ud2S{overflow:auto;width:100%;height:100%}.scrollbar-wrapper__scrollbar-wrapper__3ud2S::-webkit-scrollbar{background:transparent}.scrollbar-wrapper__scrollbar-wrapper__3ud2S::-webkit-scrollbar:vertical{width:14px}.scrollbar-wrapper__scrollbar-wrapper__3ud2S::-webkit-scrollbar:horizontal{height:14px}.scrollbar-wrapper__scrollbar-wrapper__3ud2S::-webkit-scrollbar-thumb{background-color:rgba(242,123,81,.3);background-clip:padding-box;border:4px solid transparent;border-radius:7px;transition:background-color .2s}.scrollbar-wrapper__scrollbar-wrapper__3ud2S::-webkit-scrollbar-thumb:active,.scrollbar-wrapper__scrollbar-wrapper__3ud2S::-webkit-scrollbar-thumb:hover{background-color:#f27b51}", ""]);

// exports
exports.locals = {
	"scrollbar-wrapper": "scrollbar-wrapper__scrollbar-wrapper__3ud2S",
	"scrollbarWrapper": "scrollbar-wrapper__scrollbar-wrapper__3ud2S"
};

/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".social-button__social-button__1ptdG{display:-ms-inline-flexbox;display:inline-flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:100%;height:100%;color:inherit;text-align:center;text-decoration:none;transition:background .2s}.social-button__rounded__1-26j{border-radius:50%}.social-button__tooltip__2i6vR{position:relative}.social-button__popout__3eWTC{position:absolute;top:100%;left:50%;transform:translate(-50%);width:310px;height:57px}.social-button__popout__3eWTC.social-button__hide__2QdoV{display:none}.social-button__popout-inner__3aqTR{position:relative;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex:0 0 auto;flex:0 0 auto;-ms-flex-align:center;align-items:center;width:100%;margin-top:10px;padding:8px;background-color:#fff;border-radius:4px;color:#000}.social-button__popout-inner__3aqTR:before{content:\"\";position:absolute;top:-5px;left:50%;transform:translate(-50%) rotate(45deg);width:10px;height:10px;background-color:#fff}.social-button__popout-inner__3aqTR:hover{color:-wix-colors-buttonsAndLinksColor}.social-button__copy-url-input__2tOvC{-ms-flex-positive:1;flex-grow:1;height:30px;margin-right:10px;padding:5px;border:1px solid #cdd0f6;border-radius:4px;color:inherit;font-family:HelveticaNeueW01-Thin,HelveticaNeueW02-Thin,HelveticaNeueW10-35Thin,Helvetica Neue,ruble,Helvetica,Arial,sans-serif;font-size:14px;font-weight:100}.social-button__copy-url-input__2tOvC::-moz-selection{background-color:#e5e5e5}.social-button__copy-url-input__2tOvC::selection{background-color:#e5e5e5}.social-button__copy-url-link__BXLjf{-ms-flex-positive:0;flex-grow:0;color:inherit;text-decoration:none;font-family:HelveticaNeueW01-Thin,HelveticaNeueW02-Thin,HelveticaNeueW10-35Thin,Helvetica Neue,ruble,Helvetica,Arial,sans-serif;font-size:14px;font-weight:100}", ""]);

// exports
exports.locals = {
	"social-button": "social-button__social-button__1ptdG",
	"socialButton": "social-button__social-button__1ptdG",
	"rounded": "social-button__rounded__1-26j",
	"tooltip": "social-button__tooltip__2i6vR",
	"popout": "social-button__popout__3eWTC",
	"hide": "social-button__hide__2QdoV",
	"popout-inner": "social-button__popout-inner__3aqTR",
	"popoutInner": "social-button__popout-inner__3aqTR",
	"copy-url-input": "social-button__copy-url-input__2tOvC",
	"copyUrlInput": "social-button__copy-url-input__2tOvC",
	"copy-url-link": "social-button__copy-url-link__BXLjf",
	"copyUrlLink": "social-button__copy-url-link__BXLjf"
};

/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".social-share__social-share__3OdnI{display:-ms-inline-flexbox;display:inline-flex;-ms-flex-align:stretch;align-items:stretch;-ms-flex-pack:justify;justify-content:space-between;height:auto}", ""]);

// exports
exports.locals = {
	"social-share": "social-share__social-share__3OdnI",
	"socialShare": "social-share__social-share__3OdnI"
};

/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".fontello-codes__icon--arrow-right__1ynFz:before{content:\"\\E800\"}.fontello-codes__icon--volume-mute__2SXBQ:before{content:\"\\E801\"}.fontello-codes__icon--buy-rent__3gOep:before{content:\"\\E802\"}.fontello-codes__icon--replay-button__3uh2f:before{content:\"\\E803\"}.fontello-codes__icon--quality-selector__FoKJd:before{content:\"\\E804\"}.fontello-codes__icon--replay-player___xZFq:before{content:\"\\E805\"}.fontello-codes__icon--buy__2p3ra:before{content:\"\\E806\"}.fontello-codes__icon--clear-enter__2WYQY:before{content:\"\\E807\"}.fontello-codes__icon--search-enter__1h2Wa:before{content:\"\\E808\"}.fontello-codes__icon--search__36uSS:before{content:\"\\E809\"}.fontello-codes__icon--download__2_kqz:before{content:\"\\E80A\"}.fontello-codes__icon--exit-fullscreen-hover__hH0uT:before{content:\"\\E80B\"}.fontello-codes__icon--share__2HdoI:before{content:\"\\E80C\"}.fontello-codes__icon--exit-fullscreen__21HIN:before{content:\"\\E80D\"}.fontello-codes__icon--triangle-down__215Ub:before{content:\"\\E80E\"}.fontello-codes__icon--tumblr__3kpbj:before{content:\"\\E80F\"}.fontello-codes__icon--exit__iXsnU:before{content:\"\\E810\"}.fontello-codes__icon--facebook__3wwTp:before{content:\"\\E811\"}.fontello-codes__icon--twitter__2hN7l:before{content:\"\\E812\"}.fontello-codes__icon--user__282GR:before{content:\"\\E813\"}.fontello-codes__icon--film__2XieP:before{content:\"\\E814\"}.fontello-codes__icon--fullscreen-hover__1W8UE:before{content:\"\\E815\"}.fontello-codes__icon--volume-50__3nQN0:before{content:\"\\E816\"}.fontello-codes__icon--volume-100__2v_Dx:before{content:\"\\E817\"}.fontello-codes__icon--fullscreen__2lVjD:before{content:\"\\E818\"}.fontello-codes__icon--gear__2InLN:before{content:\"\\E819\"}.fontello-codes__icon--hd__1GwNZ:before{content:\"\\E81A\"}.fontello-codes__icon--info__3Pv5X:before{content:\"\\E81B\"}.fontello-codes__icon--link__15dDv:before{content:\"\\E81C\"}.fontello-codes__icon--pause__iAM8T:before{content:\"\\E81D\"}.fontello-codes__icon--pinterest__U17Tx:before{content:\"\\E81E\"}.fontello-codes__icon--play__3zZ-b:before{content:\"\\E81F\"}.fontello-codes__icon--plus__MfCQL:before{content:\"\\E820\"}.fontello-codes__icon--overlay-play__1Dntt:before{content:\"\\E821\"}.fontello-codes__icon--timer__uBOUj:before{content:\"\\E822\"}.fontello-codes__icon--thin-x__23AO3:before{content:\"\\E8C3\"}", ""]);

// exports
exports.locals = {
	"icon--arrow-right": "fontello-codes__icon--arrow-right__1ynFz",
	"iconArrowRight": "fontello-codes__icon--arrow-right__1ynFz",
	"icon--volume-mute": "fontello-codes__icon--volume-mute__2SXBQ",
	"iconVolumeMute": "fontello-codes__icon--volume-mute__2SXBQ",
	"icon--buy-rent": "fontello-codes__icon--buy-rent__3gOep",
	"iconBuyRent": "fontello-codes__icon--buy-rent__3gOep",
	"icon--replay-button": "fontello-codes__icon--replay-button__3uh2f",
	"iconReplayButton": "fontello-codes__icon--replay-button__3uh2f",
	"icon--quality-selector": "fontello-codes__icon--quality-selector__FoKJd",
	"iconQualitySelector": "fontello-codes__icon--quality-selector__FoKJd",
	"icon--replay-player": "fontello-codes__icon--replay-player___xZFq",
	"iconReplayPlayer": "fontello-codes__icon--replay-player___xZFq",
	"icon--buy": "fontello-codes__icon--buy__2p3ra",
	"iconBuy": "fontello-codes__icon--buy__2p3ra",
	"icon--clear-enter": "fontello-codes__icon--clear-enter__2WYQY",
	"iconClearEnter": "fontello-codes__icon--clear-enter__2WYQY",
	"icon--search-enter": "fontello-codes__icon--search-enter__1h2Wa",
	"iconSearchEnter": "fontello-codes__icon--search-enter__1h2Wa",
	"icon--search": "fontello-codes__icon--search__36uSS",
	"iconSearch": "fontello-codes__icon--search__36uSS",
	"icon--download": "fontello-codes__icon--download__2_kqz",
	"iconDownload": "fontello-codes__icon--download__2_kqz",
	"icon--exit-fullscreen-hover": "fontello-codes__icon--exit-fullscreen-hover__hH0uT",
	"iconExitFullscreenHover": "fontello-codes__icon--exit-fullscreen-hover__hH0uT",
	"icon--share": "fontello-codes__icon--share__2HdoI",
	"iconShare": "fontello-codes__icon--share__2HdoI",
	"icon--exit-fullscreen": "fontello-codes__icon--exit-fullscreen__21HIN",
	"iconExitFullscreen": "fontello-codes__icon--exit-fullscreen__21HIN",
	"icon--triangle-down": "fontello-codes__icon--triangle-down__215Ub",
	"iconTriangleDown": "fontello-codes__icon--triangle-down__215Ub",
	"icon--tumblr": "fontello-codes__icon--tumblr__3kpbj",
	"iconTumblr": "fontello-codes__icon--tumblr__3kpbj",
	"icon--exit": "fontello-codes__icon--exit__iXsnU",
	"iconExit": "fontello-codes__icon--exit__iXsnU",
	"icon--facebook": "fontello-codes__icon--facebook__3wwTp",
	"iconFacebook": "fontello-codes__icon--facebook__3wwTp",
	"icon--twitter": "fontello-codes__icon--twitter__2hN7l",
	"iconTwitter": "fontello-codes__icon--twitter__2hN7l",
	"icon--user": "fontello-codes__icon--user__282GR",
	"iconUser": "fontello-codes__icon--user__282GR",
	"icon--film": "fontello-codes__icon--film__2XieP",
	"iconFilm": "fontello-codes__icon--film__2XieP",
	"icon--fullscreen-hover": "fontello-codes__icon--fullscreen-hover__1W8UE",
	"iconFullscreenHover": "fontello-codes__icon--fullscreen-hover__1W8UE",
	"icon--volume-50": "fontello-codes__icon--volume-50__3nQN0",
	"iconVolume50": "fontello-codes__icon--volume-50__3nQN0",
	"icon--volume-100": "fontello-codes__icon--volume-100__2v_Dx",
	"iconVolume100": "fontello-codes__icon--volume-100__2v_Dx",
	"icon--fullscreen": "fontello-codes__icon--fullscreen__2lVjD",
	"iconFullscreen": "fontello-codes__icon--fullscreen__2lVjD",
	"icon--gear": "fontello-codes__icon--gear__2InLN",
	"iconGear": "fontello-codes__icon--gear__2InLN",
	"icon--hd": "fontello-codes__icon--hd__1GwNZ",
	"iconHd": "fontello-codes__icon--hd__1GwNZ",
	"icon--info": "fontello-codes__icon--info__3Pv5X",
	"iconInfo": "fontello-codes__icon--info__3Pv5X",
	"icon--link": "fontello-codes__icon--link__15dDv",
	"iconLink": "fontello-codes__icon--link__15dDv",
	"icon--pause": "fontello-codes__icon--pause__iAM8T",
	"iconPause": "fontello-codes__icon--pause__iAM8T",
	"icon--pinterest": "fontello-codes__icon--pinterest__U17Tx",
	"iconPinterest": "fontello-codes__icon--pinterest__U17Tx",
	"icon--play": "fontello-codes__icon--play__3zZ-b",
	"iconPlay": "fontello-codes__icon--play__3zZ-b",
	"icon--plus": "fontello-codes__icon--plus__MfCQL",
	"iconPlus": "fontello-codes__icon--plus__MfCQL",
	"icon--overlay-play": "fontello-codes__icon--overlay-play__1Dntt",
	"iconOverlayPlay": "fontello-codes__icon--overlay-play__1Dntt",
	"icon--timer": "fontello-codes__icon--timer__uBOUj",
	"iconTimer": "fontello-codes__icon--timer__uBOUj",
	"icon--thin-x": "fontello-codes__icon--thin-x__23AO3",
	"iconThinX": "fontello-codes__icon--thin-x__23AO3"
};

/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * author Digital Primates
 * copyright dash-if 2012
 */

/*
 * var parent,
 *     child,
 *     properties = [
                    {
                        name: 'profiles',
                        merge: false
                    }
                ];
 *
 * parent = {};
 * parent.name = "ParentNode";
 * parent.isRoor = false;
 * parent.isArray = false;
 * parent.children = [];
 * parent.properties = properties;
 *
 * child = {};
 * child.name = "ChildNode";
 * child.isRoor = false;
 * child.isArray = true;
 * child.children = null;
 * child.properties = properties;
 * parent.children.push(child);
 *
 */



Object.defineProperty(exports, '__esModule', {
    value: true
});
function ObjectIron(map) {

    var lookup, len, i;

    // create a list of top level items to search for
    lookup = [];
    for (i = 0, len = map.length; i < len; i += 1) {
        if (map[i].isRoot) {
            lookup.push("root");
        } else {
            lookup.push(map[i].name);
        }
    }

    var mergeValues = function mergeValues(parentItem, childItem) {
        var name, parentValue, childValue;

        if (parentItem === null || childItem === null) {
            return;
        }

        for (name in parentItem) {
            if (parentItem.hasOwnProperty(name)) {
                if (!childItem.hasOwnProperty(name)) {
                    childItem[name] = parentItem[name];
                }
            }
        }
    },
        mapProperties = function mapProperties(properties, parent, child) {
        var i, len, property, parentValue, childValue;

        if (properties === null || properties.length === 0) {
            return;
        }

        for (i = 0, len = properties.length; i < len; i += 1) {
            property = properties[i];

            if (parent.hasOwnProperty(property.name)) {
                if (child.hasOwnProperty(property.name)) {
                    // check to see if we should merge
                    if (property.merge) {
                        parentValue = parent[property.name];
                        childValue = child[property.name];

                        // complex objects; merge properties
                        if (typeof parentValue === 'object' && typeof childValue === 'object') {
                            mergeValues(parentValue, childValue);
                        }
                        // simple objects; merge them together
                        else {
                                if (property.mergeFunction != null) {
                                    child[property.name] = property.mergeFunction(parentValue, childValue);
                                } else {
                                    child[property.name] = parentValue + childValue;
                                }
                            }
                    }
                } else {
                    // just add the property
                    child[property.name] = parent[property.name];
                }
            }
        }
    },
        mapItem = function mapItem(obj, node) {
        var item = obj,
            i,
            len,
            v,
            len2,
            array,
            childItem,
            childNode,
            property;

        if (item.children === null || item.children.length === 0) {
            return;
        }

        for (i = 0, len = item.children.length; i < len; i += 1) {
            childItem = item.children[i];

            if (node.hasOwnProperty(childItem.name)) {
                if (childItem.isArray) {
                    array = node[childItem.name + "_asArray"];
                    for (v = 0, len2 = array.length; v < len2; v += 1) {
                        childNode = array[v];
                        mapProperties(item.properties, node, childNode);
                        mapItem(childItem, childNode);
                    }
                } else {
                    childNode = node[childItem.name];
                    mapProperties(item.properties, node, childNode);
                    mapItem(childItem, childNode);
                }
            }
        }
    },
        performMapping = function performMapping(source) {
        var i, len, pi, pp, item, node, array;

        if (source === null) {
            return source;
        }

        if (typeof source !== 'object') {
            return source;
        }

        // first look to see if anything cares about the root node
        for (i = 0, len = lookup.length; i < len; i += 1) {
            if (lookup[i] === "root") {
                item = map[i];
                node = source;
                mapItem(item, node);
            }
        }

        // iterate over the objects and look for any of the items we care about
        for (pp in source) {
            if (source.hasOwnProperty(pp) && pp != "__children") {
                pi = lookup.indexOf(pp);
                if (pi !== -1) {
                    item = map[pi];

                    if (item.isArray) {
                        array = source[pp + "_asArray"];
                        for (i = 0, len = array.length; i < len; i += 1) {
                            node = array[i];
                            mapItem(item, node);
                        }
                    } else {
                        node = source[pp];
                        mapItem(item, node);
                    }
                }
                // now check this to see if he has any of the properties we care about
                performMapping(source[pp]);
            }
        }

        return source;
    };

    return {
        run: performMapping
    };
}

exports['default'] = ObjectIron;
module.exports = exports['default'];
//# sourceMappingURL=objectiron.js.map


/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _srcStreamingMediaPlayer = __webpack_require__(590);

var _srcStreamingMediaPlayer2 = _interopRequireDefault(_srcStreamingMediaPlayer);

var _srcStreamingProtectionProtection = __webpack_require__(594);

var _srcStreamingProtectionProtection2 = _interopRequireDefault(_srcStreamingProtectionProtection);

var _srcStreamingMetricsMetricsReporting = __webpack_require__(1359);

var _srcStreamingMetricsMetricsReporting2 = _interopRequireDefault(_srcStreamingMetricsMetricsReporting);

var _srcStreamingMediaPlayerFactory = __webpack_require__(1347);

var _srcStreamingMediaPlayerFactory2 = _interopRequireDefault(_srcStreamingMediaPlayerFactory);

var _srcCoreVersion = __webpack_require__(584);

// Shove both of these into the global scope
var context = typeof window !== 'undefined' && window || global;

var dashjs = context.dashjs;
if (!dashjs) {
  dashjs = context.dashjs = {};
}

dashjs.MediaPlayer = _srcStreamingMediaPlayer2['default'];
dashjs.Protection = _srcStreamingProtectionProtection2['default'];
dashjs.MetricsReporting = _srcStreamingMetricsMetricsReporting2['default'];
dashjs.MediaPlayerFactory = _srcStreamingMediaPlayerFactory2['default'];
dashjs.Version = (0, _srcCoreVersion.getVersionString)();

exports['default'] = dashjs;
exports.MediaPlayer = _srcStreamingMediaPlayer2['default'];
exports.Protection = _srcStreamingProtectionProtection2['default'];
exports.MetricsReporting = _srcStreamingMetricsMetricsReporting2['default'];
exports.MediaPlayerFactory = _srcStreamingMediaPlayerFactory2['default'];
//# sourceMappingURL=index.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _EventsBase2 = __webpack_require__(319);

var _EventsBase3 = _interopRequireDefault(_EventsBase2);

/**
 * These are internal events that should not be needed at the player level.
 * If you find and event in here that you would like access to from MediaPlayer level
 * please add an issue at https://github.com/Dash-Industry-Forum/dash.js/issues/new
 * @class
 * @ignore
 */

var CoreEvents = (function (_EventsBase) {
    _inherits(CoreEvents, _EventsBase);

    function CoreEvents() {
        _classCallCheck(this, CoreEvents);

        _get(Object.getPrototypeOf(CoreEvents.prototype), 'constructor', this).call(this);
        this.BUFFERING_COMPLETED = 'bufferingCompleted';
        this.BUFFER_CLEARED = 'bufferCleared';
        this.BUFFER_LEVEL_UPDATED = 'bufferLevelUpdated';
        this.BYTES_APPENDED = 'bytesAppended';
        this.CHECK_FOR_EXISTENCE_COMPLETED = 'checkForExistenceCompleted';
        this.CURRENT_TRACK_CHANGED = 'currentTrackChanged';
        this.DATA_UPDATE_COMPLETED = 'dataUpdateCompleted';
        this.DATA_UPDATE_STARTED = 'dataUpdateStarted';
        this.INITIALIZATION_LOADED = 'initializationLoaded';
        this.INIT_FRAGMENT_LOADED = 'initFragmentLoaded';
        this.INIT_REQUESTED = 'initRequested';
        this.INTERNAL_MANIFEST_LOADED = 'internalManifestLoaded';
        this.LIVE_EDGE_SEARCH_COMPLETED = 'liveEdgeSearchCompleted';
        this.LOADING_COMPLETED = 'loadingCompleted';
        this.LOADING_PROGRESS = 'loadingProgress';
        this.MANIFEST_UPDATED = 'manifestUpdated';
        this.MEDIA_FRAGMENT_LOADED = 'mediaFragmentLoaded';
        this.QUOTA_EXCEEDED = 'quotaExceeded';
        this.REPRESENTATION_UPDATED = 'representationUpdated';
        this.SEGMENTS_LOADED = 'segmentsLoaded';
        this.SERVICE_LOCATION_BLACKLIST_CHANGED = 'serviceLocationBlacklistChanged';
        this.SOURCEBUFFER_APPEND_COMPLETED = 'sourceBufferAppendCompleted';
        this.SOURCEBUFFER_REMOVE_COMPLETED = 'sourceBufferRemoveCompleted';
        this.STREAMS_COMPOSED = 'streamsComposed';
        this.STREAM_BUFFERING_COMPLETED = 'streamBufferingCompleted';
        this.STREAM_COMPLETED = 'streamCompleted';
        this.STREAM_TEARDOWN_COMPLETE = 'streamTeardownComplete';
        this.TIMED_TEXT_REQUESTED = 'timedTextRequested';
        this.TIME_SYNCHRONIZATION_COMPLETED = 'timeSynchronizationComplete';
        this.URL_RESOLUTION_FAILED = 'urlResolutionFailed';
        this.VIDEO_CHUNK_RECEIVED = 'videoChunkReceived';
        this.WALLCLOCK_TIME_UPDATED = 'wallclockTimeUpdated';
        this.XLINK_ELEMENT_LOADED = 'xlinkElementLoaded';
        this.XLINK_READY = 'xlinkReady';
    }

    return CoreEvents;
})(_EventsBase3['default']);

exports['default'] = CoreEvents;
module.exports = exports['default'];
//# sourceMappingURL=CoreEvents.js.map


/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _streamingVoFragmentRequest = __webpack_require__(190);

var _streamingVoFragmentRequest2 = _interopRequireDefault(_streamingVoFragmentRequest);

var _streamingVoError = __webpack_require__(111);

var _streamingVoError2 = _interopRequireDefault(_streamingVoError);

var _streamingVoMetricsHTTPRequest = __webpack_require__(84);

var _coreEventsEvents = __webpack_require__(22);

var _coreEventsEvents2 = _interopRequireDefault(_coreEventsEvents);

var _coreEventBus = __webpack_require__(27);

var _coreEventBus2 = _interopRequireDefault(_coreEventBus);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _coreDebug = __webpack_require__(30);

var _coreDebug2 = _interopRequireDefault(_coreDebug);

var _streamingUtilsURLUtils = __webpack_require__(242);

var _streamingUtilsURLUtils2 = _interopRequireDefault(_streamingUtilsURLUtils);

var _voRepresentation = __webpack_require__(396);

var _voRepresentation2 = _interopRequireDefault(_voRepresentation);

var _utilsSegmentsUtils = __webpack_require__(321);

var _utilsSegmentsGetter = __webpack_require__(1337);

var _utilsSegmentsGetter2 = _interopRequireDefault(_utilsSegmentsGetter);

var SEGMENTS_UNAVAILABLE_ERROR_CODE = 1;

function DashHandler(config) {

    var context = this.context;
    var log = (0, _coreDebug2['default'])(context).getInstance().log;
    var eventBus = (0, _coreEventBus2['default'])(context).getInstance();
    var urlUtils = (0, _streamingUtilsURLUtils2['default'])(context).getInstance();

    var segmentBaseLoader = config.segmentBaseLoader;
    var timelineConverter = config.timelineConverter;
    var dashMetrics = config.dashMetrics;
    var metricsModel = config.metricsModel;
    var baseURLController = config.baseURLController;

    var instance = undefined,
        index = undefined,
        requestedTime = undefined,
        isDynamic = undefined,
        type = undefined,
        currentTime = undefined,
        earliestTime = undefined,
        streamProcessor = undefined,
        segmentsGetter = undefined;

    function setup() {
        index = -1;
        currentTime = 0;
        earliestTime = NaN;
        eventBus.on(_coreEventsEvents2['default'].INITIALIZATION_LOADED, onInitializationLoaded, instance);
        eventBus.on(_coreEventsEvents2['default'].SEGMENTS_LOADED, onSegmentsLoaded, instance);
    }

    function initialize(StreamProcessor) {
        streamProcessor = StreamProcessor;
        type = streamProcessor.getType();
        isDynamic = streamProcessor.isDynamic();

        segmentsGetter = (0, _utilsSegmentsGetter2['default'])(context).create(config, isDynamic);
    }

    function getStreamProcessor() {
        return streamProcessor;
    }

    function setCurrentTime(value) {
        currentTime = value;
    }

    function getCurrentTime() {
        return currentTime;
    }

    function getCurrentIndex() {
        return index;
    }

    function getEarliestTime() {
        return earliestTime;
    }

    function reset() {
        segmentsGetter = null;
        currentTime = 0;
        earliestTime = NaN;
        requestedTime = NaN;
        index = -1;
        isDynamic = null;
        type = null;
        streamProcessor = null;
        eventBus.off(_coreEventsEvents2['default'].INITIALIZATION_LOADED, onInitializationLoaded, instance);
        eventBus.off(_coreEventsEvents2['default'].SEGMENTS_LOADED, onSegmentsLoaded, instance);
    }

    function unescapeDollarsInTemplate(url) {
        return url ? url.split('$$').join('$') : url;
    }

    function replaceIDForTemplate(url, value) {
        if (value === null || url === null || url.indexOf('$RepresentationID$') === -1) {
            return url;
        }
        var v = value.toString();
        return url.split('$RepresentationID$').join(v);
    }

    function setRequestUrl(request, destination, representation) {
        var baseURL = baseURLController.resolve(representation.path);
        var url;
        var serviceLocation;

        if (!baseURL || destination === baseURL.url || !urlUtils.isRelative(destination)) {
            url = destination;
        } else {
            url = baseURL.url;
            serviceLocation = baseURL.serviceLocation;

            if (destination) {
                url = urlUtils.resolve(destination, url);
            }
        }

        if (urlUtils.isRelative(url)) {
            return false;
        }

        request.url = url;
        request.serviceLocation = serviceLocation;

        return true;
    }

    function generateInitRequest(representation, mediaType) {

        var request = new _streamingVoFragmentRequest2['default']();
        var period = representation.adaptation.period;
        var presentationStartTime = period.start;

        request.mediaType = mediaType;
        request.type = _streamingVoMetricsHTTPRequest.HTTPRequest.INIT_SEGMENT_TYPE;
        request.range = representation.range;
        request.availabilityStartTime = timelineConverter.calcAvailabilityStartTimeFromPresentationTime(presentationStartTime, period.mpd, isDynamic);
        request.availabilityEndTime = timelineConverter.calcAvailabilityEndTimeFromPresentationTime(presentationStartTime + period.duration, period.mpd, isDynamic);
        request.quality = representation.index;
        request.mediaInfo = streamProcessor.getMediaInfo();
        request.representationId = representation.id;

        if (setRequestUrl(request, representation.initialization, representation)) {
            return request;
        }
    }

    function getInitRequest(representation) {
        if (!representation) return null;
        var request = generateInitRequest(representation, type);
        return request;
    }

    function isMediaFinished(representation) {

        var isFinished = false;

        if (!isDynamic && index === representation.availableSegmentsNumber) {
            isFinished = true;
        } else {
            var seg = (0, _utilsSegmentsUtils.getSegmentByIndex)(index, representation);
            if (seg) {
                var time = seg.presentationStartTime - representation.adaptation.period.start;
                var duration = representation.adaptation.period.duration;
                log(representation.segmentInfoType + ': ' + time + ' / ' + duration);
                isFinished = representation.segmentInfoType === 'SegmentTimeline' && isDynamic ? false : time >= duration;
            }
        }

        return isFinished;
    }

    function updateSegments(representation) {
        return segmentsGetter.getSegments(representation, requestedTime, index, onSegmentListUpdated);
    }

    function onSegmentListUpdated(representation, segments) {

        representation.segments = segments;

        if (segments && segments.length > 0) {
            earliestTime = isNaN(earliestTime) ? segments[0].presentationStartTime : Math.min(segments[0].presentationStartTime, earliestTime);
        }

        if (isDynamic && isNaN(timelineConverter.getExpectedLiveEdge())) {
            var lastSegment = segments[segments.length - 1];
            var liveEdge = lastSegment.presentationStartTime;
            var metrics = metricsModel.getMetricsFor('stream');
            // the last segment is the Expected, not calculated, live edge.
            timelineConverter.setExpectedLiveEdge(liveEdge);
            metricsModel.updateManifestUpdateInfo(dashMetrics.getCurrentManifestUpdate(metrics), { presentationStartTime: liveEdge });
        }
    }

    function updateSegmentList(representation) {

        if (!representation) {
            throw new _streamingVoError2['default']('no representation');
        }

        representation.segments = null;

        updateSegments(representation);

        return representation;
    }

    function updateRepresentation(representation, keepIdx) {
        var hasInitialization = _voRepresentation2['default'].hasInitialization(representation);
        var hasSegments = _voRepresentation2['default'].hasSegments(representation);
        var error;

        if (!representation.segmentDuration && !representation.segments) {
            updateSegmentList(representation);
        }

        representation.segmentAvailabilityRange = null;
        representation.segmentAvailabilityRange = timelineConverter.calcSegmentAvailabilityRange(representation, isDynamic);

        if (representation.segmentAvailabilityRange.end < representation.segmentAvailabilityRange.start && !representation.useCalculatedLiveEdgeTime) {
            error = new _streamingVoError2['default'](SEGMENTS_UNAVAILABLE_ERROR_CODE, 'no segments are available yet', { availabilityDelay: representation.segmentAvailabilityRange.start - representation.segmentAvailabilityRange.end });
            eventBus.trigger(_coreEventsEvents2['default'].REPRESENTATION_UPDATED, { sender: this, representation: representation, error: error });
            return;
        }

        if (!keepIdx) index = -1;

        if (representation.segmentDuration) {
            updateSegmentList(representation);
        }

        if (!hasInitialization) {
            segmentBaseLoader.loadInitialization(representation);
        }

        if (!hasSegments) {
            segmentBaseLoader.loadSegments(representation, type, representation.indexRange);
        }

        if (hasInitialization && hasSegments) {
            eventBus.trigger(_coreEventsEvents2['default'].REPRESENTATION_UPDATED, { sender: this, representation: representation });
        }
    }

    function getIndexForSegments(time, representation, timeThreshold) {
        var segments = representation.segments;
        var ln = segments ? segments.length : null;

        var idx = -1;
        var epsilon, frag, ft, fd, i;

        if (segments && ln > 0) {
            for (i = 0; i < ln; i++) {
                frag = segments[i];
                ft = frag.presentationStartTime;
                fd = frag.duration;
                epsilon = timeThreshold === undefined || timeThreshold === null ? fd / 2 : timeThreshold;
                if (time + epsilon >= ft && time - epsilon < ft + fd) {
                    idx = frag.availabilityIdx;
                    break;
                }
            }
        }

        return idx;
    }

    function getRequestForSegment(segment) {
        if (segment === null || segment === undefined) {
            return null;
        }

        var request = new _streamingVoFragmentRequest2['default']();
        var representation = segment.representation;
        var bandwidth = representation.adaptation.period.mpd.manifest.Period_asArray[representation.adaptation.period.index].AdaptationSet_asArray[representation.adaptation.index].Representation_asArray[representation.index].bandwidth;
        var url = segment.media;

        url = (0, _utilsSegmentsUtils.replaceTokenForTemplate)(url, 'Number', segment.replacementNumber);
        url = (0, _utilsSegmentsUtils.replaceTokenForTemplate)(url, 'Time', segment.replacementTime);
        url = (0, _utilsSegmentsUtils.replaceTokenForTemplate)(url, 'Bandwidth', bandwidth);
        url = replaceIDForTemplate(url, representation.id);
        url = unescapeDollarsInTemplate(url);

        request.mediaType = type;
        request.type = _streamingVoMetricsHTTPRequest.HTTPRequest.MEDIA_SEGMENT_TYPE;
        request.range = segment.mediaRange;
        request.startTime = segment.presentationStartTime;
        request.duration = segment.duration;
        request.timescale = representation.timescale;
        request.availabilityStartTime = segment.availabilityStartTime;
        request.availabilityEndTime = segment.availabilityEndTime;
        request.wallStartTime = segment.wallStartTime;
        request.quality = representation.index;
        request.index = segment.availabilityIdx;
        request.mediaInfo = streamProcessor.getMediaInfo();
        request.adaptationIndex = representation.adaptation.index;

        if (setRequestUrl(request, url, representation)) {
            return request;
        }
    }

    function getSegmentRequestForTime(representation, time, options) {
        var request, segment, finished;

        var idx = index;

        var keepIdx = options ? options.keepIdx : false;
        var timeThreshold = options ? options.timeThreshold : null;
        var ignoreIsFinished = options && options.ignoreIsFinished ? true : false;

        if (!representation) {
            return null;
        }

        if (requestedTime !== time) {
            // When playing at live edge with 0 delay we may loop back with same time and index until it is available. Reduces verboseness of logs.
            requestedTime = time;
            log('Getting the request for ' + type + ' time : ' + time);
        }

        updateSegments(representation);
        index = getIndexForSegments(time, representation, timeThreshold);
        //Index may be -1 if getSegments needs to update again.  So after getSegments is called and updated then try to get index again.
        if (index < 0) {
            updateSegments(representation);
            index = getIndexForSegments(time, representation, timeThreshold);
        }

        if (index > 0) {
            log('Index for ' + type + ' time ' + time + ' is ' + index);
        }

        finished = !ignoreIsFinished ? isMediaFinished(representation) : false;
        if (finished) {
            request = new _streamingVoFragmentRequest2['default']();
            request.action = _streamingVoFragmentRequest2['default'].ACTION_COMPLETE;
            request.index = index;
            request.mediaType = type;
            request.mediaInfo = streamProcessor.getMediaInfo();
            log('Signal complete.', request);
        } else {
            segment = (0, _utilsSegmentsUtils.getSegmentByIndex)(index, representation);
            request = getRequestForSegment(segment);
        }

        if (keepIdx && idx >= 0) {
            index = representation.segmentInfoType === 'SegmentTimeline' && isDynamic ? index : idx;
        }

        return request;
    }

    function generateSegmentRequestForTime(representation, time) {
        var step = (representation.segmentAvailabilityRange.end - representation.segmentAvailabilityRange.start) / 2;

        representation.segments = null;
        representation.segmentAvailabilityRange = { start: time - step, end: time + step };
        return getSegmentRequestForTime(representation, time, { keepIdx: false, ignoreIsFinished: true });
    }

    function getNextSegmentRequest(representation) {
        var request, segment, finished;

        if (!representation || index === -1) {
            return null;
        }

        requestedTime = null;
        index++;

        log('Getting the next request at index: ' + index);

        finished = isMediaFinished(representation);
        if (finished) {
            request = new _streamingVoFragmentRequest2['default']();
            request.action = _streamingVoFragmentRequest2['default'].ACTION_COMPLETE;
            request.index = index;
            request.mediaType = type;
            request.mediaInfo = streamProcessor.getMediaInfo();
            log('Signal complete.');
        } else {
            updateSegments(representation);
            segment = (0, _utilsSegmentsUtils.getSegmentByIndex)(index, representation);
            request = getRequestForSegment(segment);
            if (!segment && isDynamic) {
                /*
                 Sometimes when playing dynamic streams with 0 fragment delay at live edge we ask for
                 an index before it is available so we decrement index back and send null request
                 which triggers the validate loop to rerun and the next time the segment should be
                 available.
                 */
                index--;
            }
        }

        return request;
    }

    function onInitializationLoaded(e) {
        var representation = e.representation;
        //log("Got an initialization.");
        if (!representation.segments) return;

        eventBus.trigger(_coreEventsEvents2['default'].REPRESENTATION_UPDATED, { sender: this, representation: representation });
    }

    function onSegmentsLoaded(e) {
        if (e.error || type !== e.mediaType) return;

        var fragments = e.segments;
        var representation = e.representation;
        var segments = [];
        var count = 0;

        var i, len, s, seg;

        for (i = 0, len = fragments.length; i < len; i++) {
            s = fragments[i];

            seg = (0, _utilsSegmentsUtils.getTimeBasedSegment)(timelineConverter, isDynamic, representation, s.startTime, s.duration, s.timescale, s.media, s.mediaRange, count);

            segments.push(seg);
            seg = null;
            count++;
        }

        representation.segmentAvailabilityRange = { start: segments[0].presentationStartTime, end: segments[len - 1].presentationStartTime };
        representation.availableSegmentsNumber = len;

        onSegmentListUpdated(representation, segments);

        if (!_voRepresentation2['default'].hasInitialization(representation)) return;

        eventBus.trigger(_coreEventsEvents2['default'].REPRESENTATION_UPDATED, { sender: this, representation: representation });
    }

    instance = {
        initialize: initialize,
        getStreamProcessor: getStreamProcessor,
        getInitRequest: getInitRequest,
        getSegmentRequestForTime: getSegmentRequestForTime,
        getNextSegmentRequest: getNextSegmentRequest,
        generateSegmentRequestForTime: generateSegmentRequestForTime,
        updateRepresentation: updateRepresentation,
        setCurrentTime: setCurrentTime,
        getCurrentTime: getCurrentTime,
        getCurrentIndex: getCurrentIndex,
        getEarliestTime: getEarliestTime,
        reset: reset
    };

    setup();

    return instance;
}

DashHandler.__dashjs_factory_name = 'DashHandler';
var factory = _coreFactoryMaker2['default'].getClassFactory(DashHandler);
factory.SEGMENTS_UNAVAILABLE_ERROR_CODE = SEGMENTS_UNAVAILABLE_ERROR_CODE;
exports['default'] = factory;
module.exports = exports['default'];
//# sourceMappingURL=DashHandler.js.map


/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _streamingUtilsRequestModifier = __webpack_require__(327);

var _streamingUtilsRequestModifier2 = _interopRequireDefault(_streamingUtilsRequestModifier);

var _voSegment = __webpack_require__(397);

var _voSegment2 = _interopRequireDefault(_voSegment);

var _streamingVoError = __webpack_require__(111);

var _streamingVoError2 = _interopRequireDefault(_streamingVoError);

var _streamingUtilsErrorHandler = __webpack_require__(136);

var _streamingUtilsErrorHandler2 = _interopRequireDefault(_streamingUtilsErrorHandler);

var _coreEventsEvents = __webpack_require__(22);

var _coreEventsEvents2 = _interopRequireDefault(_coreEventsEvents);

var _coreEventBus = __webpack_require__(27);

var _coreEventBus2 = _interopRequireDefault(_coreEventBus);

var _streamingUtilsBoxParser = __webpack_require__(406);

var _streamingUtilsBoxParser2 = _interopRequireDefault(_streamingUtilsBoxParser);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _coreDebug = __webpack_require__(30);

var _coreDebug2 = _interopRequireDefault(_coreDebug);

var _streamingVoMetricsHTTPRequest = __webpack_require__(84);

var _streamingVoFragmentRequest = __webpack_require__(190);

var _streamingVoFragmentRequest2 = _interopRequireDefault(_streamingVoFragmentRequest);

var _streamingXHRLoader = __webpack_require__(239);

var _streamingXHRLoader2 = _interopRequireDefault(_streamingXHRLoader);

function SegmentBaseLoader() {

    var context = this.context;
    var log = (0, _coreDebug2['default'])(context).getInstance().log;
    var eventBus = (0, _coreEventBus2['default'])(context).getInstance();

    var instance = undefined,
        errHandler = undefined,
        boxParser = undefined,
        requestModifier = undefined,
        metricsModel = undefined,
        xhrLoader = undefined,
        baseURLController = undefined;

    function initialize() {
        errHandler = (0, _streamingUtilsErrorHandler2['default'])(context).getInstance();
        boxParser = (0, _streamingUtilsBoxParser2['default'])(context).getInstance();
        requestModifier = (0, _streamingUtilsRequestModifier2['default'])(context).getInstance();
        xhrLoader = (0, _streamingXHRLoader2['default'])(context).create({
            errHandler: errHandler,
            metricsModel: metricsModel,
            requestModifier: requestModifier
        });
    }

    function setConfig(config) {
        if (config.baseURLController) {
            baseURLController = config.baseURLController;
        }

        if (config.metricsModel) {
            metricsModel = config.metricsModel;
        }
    }

    function loadInitialization(representation, loadingInfo) {
        var initRange = null;
        var isoFile = null;
        var baseUrl = baseURLController.resolve(representation.path);
        var info = loadingInfo || {
            init: true,
            url: baseUrl ? baseUrl.url : undefined,
            range: {
                start: 0,
                end: 1500
            },
            searching: false,
            bytesLoaded: 0,
            bytesToLoad: 1500
        };

        log('Start searching for initialization.');

        var request = getFragmentRequest(info);

        var onload = function onload(response) {

            info.bytesLoaded = info.range.end;
            isoFile = boxParser.parse(response);
            initRange = findInitRange(isoFile);

            if (initRange) {
                representation.range = initRange;
                // note that we don't explicitly set rep.initialization as this
                // will be computed when all BaseURLs are resolved later
                eventBus.trigger(_coreEventsEvents2['default'].INITIALIZATION_LOADED, { representation: representation });
            } else {
                info.range.end = info.bytesLoaded + info.bytesToLoad;
                loadInitialization(representation, info);
            }
        };

        var onerror = function onerror() {
            eventBus.trigger(_coreEventsEvents2['default'].INITIALIZATION_LOADED, { representation: representation });
        };

        xhrLoader.load({ request: request, success: onload, error: onerror });

        log('Perform init search: ' + info.url);
    }

    function loadSegments(representation, type, range, loadingInfo, callback) {
        if (range && (range.start === undefined || range.end === undefined)) {
            var parts = range ? range.toString().split('-') : null;
            range = parts ? { start: parseFloat(parts[0]), end: parseFloat(parts[1]) } : null;
        }

        callback = !callback ? onLoaded : callback;
        var isoFile = null;
        var sidx = null;
        var hasRange = !!range;
        var baseUrl = baseURLController.resolve(representation.path);
        var info = {
            init: false,
            url: baseUrl ? baseUrl.url : undefined,
            range: hasRange ? range : { start: 0, end: 1500 },
            searching: !hasRange,
            bytesLoaded: loadingInfo ? loadingInfo.bytesLoaded : 0,
            bytesToLoad: 1500
        };

        var request = getFragmentRequest(info);

        var onload = function onload(response) {
            var extraBytes = info.bytesToLoad;
            var loadedLength = response.byteLength;

            info.bytesLoaded = info.range.end - info.range.start;
            isoFile = boxParser.parse(response);
            sidx = isoFile.getBox('sidx');

            if (!sidx || !sidx.isComplete) {
                if (sidx) {
                    info.range.start = sidx.offset || info.range.start;
                    info.range.end = info.range.start + (sidx.size || extraBytes);
                } else if (loadedLength < info.bytesLoaded) {
                    // if we have reached a search limit or if we have reached the end of the file we have to stop trying to find sidx
                    callback(null, representation, type);
                    return;
                } else {
                    var lastBox = isoFile.getLastBox();

                    if (lastBox && lastBox.size) {
                        info.range.start = lastBox.offset + lastBox.size;
                        info.range.end = info.range.start + extraBytes;
                    } else {
                        info.range.end += extraBytes;
                    }
                }
                loadSegments(representation, type, info.range, info, callback);
            } else {
                var ref = sidx.references;
                var loadMultiSidx, segments;

                if (ref !== null && ref !== undefined && ref.length > 0) {
                    loadMultiSidx = ref[0].reference_type === 1;
                }

                if (loadMultiSidx) {
                    log('Initiate multiple SIDX load.');
                    info.range.end = info.range.start + sidx.size;

                    var j, len, ss, se, r;
                    var segs = [];
                    var count = 0;
                    var offset = (sidx.offset || info.range.start) + sidx.size;
                    var tmpCallback = function tmpCallback(result) {
                        if (result) {
                            segs = segs.concat(result);
                            count++;

                            if (count >= len) {
                                callback(segs, representation, type);
                            }
                        } else {
                            callback(null, representation, type);
                        }
                    };

                    for (j = 0, len = ref.length; j < len; j++) {
                        ss = offset;
                        se = offset + ref[j].referenced_size - 1;
                        offset = offset + ref[j].referenced_size;
                        r = { start: ss, end: se };
                        loadSegments(representation, null, r, info, tmpCallback);
                    }
                } else {
                    log('Parsing segments from SIDX.');
                    segments = getSegmentsForSidx(sidx, info);
                    callback(segments, representation, type);
                }
            }
        };

        var onerror = function onerror() {
            callback(null, representation, type);
        };

        xhrLoader.load({ request: request, success: onload, error: onerror });
        log('Perform SIDX load: ' + info.url);
    }

    function reset() {
        xhrLoader.abort();
        xhrLoader = null;
        errHandler = null;
        boxParser = null;
        requestModifier = null;
    }

    function getSegmentsForSidx(sidx, info) {

        var refs = sidx.references;
        var len = refs.length;
        var timescale = sidx.timescale;
        var time = sidx.earliest_presentation_time;
        var start = info.range.start + sidx.offset + sidx.first_offset + sidx.size;
        var segments = [];
        var segment, end, duration, size;

        for (var i = 0; i < len; i++) {
            duration = refs[i].subsegment_duration;
            size = refs[i].referenced_size;

            segment = new _voSegment2['default']();
            // note that we don't explicitly set segment.media as this will be
            // computed when all BaseURLs are resolved later
            segment.duration = duration;
            segment.startTime = time;
            segment.timescale = timescale;
            end = start + size - 1;
            segment.mediaRange = start + '-' + end;
            segments.push(segment);
            time += duration;
            start += size;
        }

        return segments;
    }

    function findInitRange(isoFile) {
        var ftyp = isoFile.getBox('ftyp');
        var moov = isoFile.getBox('moov');

        var initRange = null;
        var start, end;

        log('Searching for initialization.');

        if (moov && moov.isComplete) {
            start = ftyp ? ftyp.offset : moov.offset;
            end = moov.offset + moov.size - 1;
            initRange = start + '-' + end;

            log('Found the initialization.  Range: ' + initRange);
        }

        return initRange;
    }

    function getFragmentRequest(info) {
        if (!info.url) {
            return;
        }

        var request = new _streamingVoFragmentRequest2['default']();

        request.type = info.init ? _streamingVoMetricsHTTPRequest.HTTPRequest.INIT_SEGMENT_TYPE : _streamingVoMetricsHTTPRequest.HTTPRequest.MEDIA_SEGMENT_TYPE;
        request.url = info.url;
        request.range = info.range.start + '-' + info.range.end;

        return request;
    }

    function onLoaded(segments, representation, type) {
        if (segments) {
            eventBus.trigger(_coreEventsEvents2['default'].SEGMENTS_LOADED, { segments: segments, representation: representation, mediaType: type });
        } else {
            eventBus.trigger(_coreEventsEvents2['default'].SEGMENTS_LOADED, { segments: null, representation: representation, mediaType: type, error: new _streamingVoError2['default'](null, 'error loading segments', null) });
        }
    }

    instance = {
        setConfig: setConfig,
        initialize: initialize,
        loadInitialization: loadInitialization,
        loadSegments: loadSegments,
        reset: reset
    };

    return instance;
}

SegmentBaseLoader.__dashjs_factory_name = 'SegmentBaseLoader';
exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(SegmentBaseLoader);
module.exports = exports['default'];
//# sourceMappingURL=SegmentBaseLoader.js.map


/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreEventsEvents = __webpack_require__(22);

var _coreEventsEvents2 = _interopRequireDefault(_coreEventsEvents);

var _coreEventBus = __webpack_require__(27);

var _coreEventBus2 = _interopRequireDefault(_coreEventBus);

var _streamingUtilsEBMLParser = __webpack_require__(1410);

var _streamingUtilsEBMLParser2 = _interopRequireDefault(_streamingUtilsEBMLParser);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _coreDebug = __webpack_require__(30);

var _coreDebug2 = _interopRequireDefault(_coreDebug);

var _streamingUtilsErrorHandler = __webpack_require__(136);

var _streamingUtilsErrorHandler2 = _interopRequireDefault(_streamingUtilsErrorHandler);

var _streamingUtilsRequestModifier = __webpack_require__(327);

var _streamingUtilsRequestModifier2 = _interopRequireDefault(_streamingUtilsRequestModifier);

var _voSegment = __webpack_require__(397);

var _voSegment2 = _interopRequireDefault(_voSegment);

var _streamingVoMetricsHTTPRequest = __webpack_require__(84);

var _streamingVoFragmentRequest = __webpack_require__(190);

var _streamingVoFragmentRequest2 = _interopRequireDefault(_streamingVoFragmentRequest);

var _streamingXHRLoader = __webpack_require__(239);

var _streamingXHRLoader2 = _interopRequireDefault(_streamingXHRLoader);

function WebmSegmentBaseLoader() {

    var context = this.context;
    var log = (0, _coreDebug2['default'])(context).getInstance().log;
    var eventBus = (0, _coreEventBus2['default'])(context).getInstance();

    var instance = undefined,
        WebM = undefined,
        errHandler = undefined,
        requestModifier = undefined,
        metricsModel = undefined,
        xhrLoader = undefined,
        baseURLController = undefined;

    function setup() {
        WebM = {
            EBML: {
                tag: 0x1A45DFA3,
                required: true
            },
            Segment: {
                tag: 0x18538067,
                required: true,
                SeekHead: {
                    tag: 0x114D9B74,
                    required: true
                },
                Info: {
                    tag: 0x1549A966,
                    required: true,
                    TimecodeScale: {
                        tag: 0x2AD7B1,
                        required: true,
                        parse: 'getMatroskaUint'
                    },
                    Duration: {
                        tag: 0x4489,
                        required: true,
                        parse: 'getMatroskaFloat'
                    }
                },
                Tracks: {
                    tag: 0x1654AE6B,
                    required: true
                },
                Cues: {
                    tag: 0x1C53BB6B,
                    required: true,
                    CuePoint: {
                        tag: 0xBB,
                        required: true,
                        CueTime: {
                            tag: 0xB3,
                            required: true,
                            parse: 'getMatroskaUint'
                        },
                        CueTrackPositions: {
                            tag: 0xB7,
                            required: true,
                            CueTrack: {
                                tag: 0xF7,
                                required: true,
                                parse: 'getMatroskaUint'
                            },
                            CueClusterPosition: {
                                tag: 0xF1,
                                required: true,
                                parse: 'getMatroskaUint'
                            },
                            CueBlockNumber: {
                                tag: 0x5378
                            }
                        }
                    }
                }
            },
            Void: {
                tag: 0xEC,
                required: true
            }
        };
    }

    function initialize() {
        errHandler = (0, _streamingUtilsErrorHandler2['default'])(context).getInstance();
        requestModifier = (0, _streamingUtilsRequestModifier2['default'])(context).getInstance();
        xhrLoader = (0, _streamingXHRLoader2['default'])(context).create({
            errHandler: errHandler,
            metricsModel: metricsModel,
            requestModifier: requestModifier
        });
    }

    function setConfig(config) {
        if (!config.baseURLController || !config.metricsModel) {
            throw new Error('Missing config parameter(s)');
        }

        baseURLController = config.baseURLController;
        metricsModel = config.metricsModel;
    }

    function parseCues(ab) {
        var cues = [];
        var cue = undefined;
        var cueSize = undefined;
        var cueTrack = undefined;
        var ebmlParser = (0, _streamingUtilsEBMLParser2['default'])(context).create({ data: ab });
        var numSize = undefined;

        ebmlParser.consumeTag(WebM.Segment.Cues);
        cueSize = ebmlParser.getMatroskaCodedNum();

        while (ebmlParser.moreData() && ebmlParser.consumeTagAndSize(WebM.Segment.Cues.CuePoint, true)) {
            cue = {};

            cue.CueTime = ebmlParser.parseTag(WebM.Segment.Cues.CuePoint.CueTime);

            cue.CueTracks = [];
            while (ebmlParser.moreData() && ebmlParser.consumeTagAndSize(WebM.Segment.Cues.CuePoint.CueTrackPositions, true)) {
                cueTrack = {};

                cueTrack.Track = ebmlParser.parseTag(WebM.Segment.Cues.CuePoint.CueTrackPositions.CueTrack);
                if (cueTrack.Track === 0) {
                    throw new Error('Cue track cannot be 0');
                }

                cueTrack.ClusterPosition = ebmlParser.parseTag(WebM.Segment.Cues.CuePoint.CueTrackPositions.CueClusterPosition);

                // block number is strictly optional.
                // we also have to make sure we don't go beyond the end
                // of the cues
                if (ebmlParser.getPos() + 4 > cueSize || !ebmlParser.consumeTag(WebM.Segment.Cues.CuePoint.CueTrackPositions.CueBlockNumber, true)) {
                    cue.CueTracks.push(cueTrack);
                } else {
                    // since we have already consumed the tag, get the size of
                    // the tag's payload, and manually parse an unsigned int
                    // from the bit stream
                    numSize = ebmlParser.getMatroskaCodedNum();
                    cueTrack.BlockNumber = ebmlParser.getMatroskaUint(numSize);

                    cue.CueTracks.push(cueTrack);
                }
            }

            if (cue.CueTracks.length === 0) {
                throw new Error('Mandatory cuetrack not found');
            }
            cues.push(cue);
        }

        if (cues.length === 0) {
            throw new Error('mandatory cuepoint not found');
        }
        return cues;
    }

    function parseSegments(data, segmentStart, segmentEnd, segmentDuration) {
        var duration = undefined;
        var parsed = undefined;
        var segments = undefined;
        var segment = undefined;
        var i = undefined;
        var len = undefined;
        var start = undefined;
        var end = undefined;

        parsed = parseCues(data);
        segments = [];

        // we are assuming one cue track per cue point
        // both duration and media range require the i + 1 segment
        // the final segment has to use global segment parameters
        for (i = 0, len = parsed.length; i < len; i += 1) {
            segment = new _voSegment2['default']();
            duration = 0;

            if (i < parsed.length - 1) {
                duration = parsed[i + 1].CueTime - parsed[i].CueTime;
            } else {
                duration = segmentDuration - parsed[i].CueTime;
            }

            // note that we don't explicitly set segment.media as this will be
            // computed when all BaseURLs are resolved later
            segment.duration = duration;
            segment.startTime = parsed[i].CueTime;
            segment.timescale = 1000; // hardcoded for ms
            start = parsed[i].CueTracks[0].ClusterPosition + segmentStart;

            if (i < parsed.length - 1) {
                end = parsed[i + 1].CueTracks[0].ClusterPosition + segmentStart - 1;
            } else {
                end = segmentEnd - 1;
            }

            segment.mediaRange = start + '-' + end;
            segments.push(segment);
        }

        log('Parsed cues: ' + segments.length + ' cues.');

        return segments;
    }

    function parseEbmlHeader(data, media, theRange, callback) {
        var ebmlParser = (0, _streamingUtilsEBMLParser2['default'])(context).create({ data: data });
        var duration = undefined;
        var segments = undefined;
        var parts = theRange.split('-');
        var request = null;
        var info = {
            url: media,
            range: {
                start: parseFloat(parts[0]),
                end: parseFloat(parts[1])
            },
            request: request
        };
        var segmentEnd = undefined;
        var segmentStart = undefined;

        log('Parse EBML header: ' + info.url);

        // skip over the header itself
        ebmlParser.skipOverElement(WebM.EBML);
        ebmlParser.consumeTag(WebM.Segment);

        // segments start here
        segmentEnd = ebmlParser.getMatroskaCodedNum();
        segmentEnd += ebmlParser.getPos();
        segmentStart = ebmlParser.getPos();

        // skip over any top level elements to get to the segment info
        while (ebmlParser.moreData() && !ebmlParser.consumeTagAndSize(WebM.Segment.Info, true)) {
            if (!(ebmlParser.skipOverElement(WebM.Segment.SeekHead, true) || ebmlParser.skipOverElement(WebM.Segment.Tracks, true) || ebmlParser.skipOverElement(WebM.Segment.Cues, true) || ebmlParser.skipOverElement(WebM.Void, true))) {
                throw new Error('no valid top level element found');
            }
        }

        // we only need one thing in segment info, duration
        while (duration === undefined) {
            var infoTag = ebmlParser.getMatroskaCodedNum(true);
            var infoElementSize = ebmlParser.getMatroskaCodedNum();

            switch (infoTag) {
                case WebM.Segment.Info.Duration.tag:
                    duration = ebmlParser[WebM.Segment.Info.Duration.parse](infoElementSize);
                    break;
                default:
                    ebmlParser.setPos(ebmlParser.getPos() + infoElementSize);
                    break;
            }
        }

        // once we have what we need from segment info, we jump right to the
        // cues

        request = getFragmentRequest(info);

        var onload = function onload(response) {
            segments = parseSegments(response, segmentStart, segmentEnd, duration);
            callback(segments);
        };

        var onloadend = function onloadend() {
            log('Download Error: Cues ' + info.url);
            callback(null);
        };

        xhrLoader.load({ request: request, success: onload, error: onloadend });

        log('Perform cues load: ' + info.url + ' bytes=' + info.range.start + '-' + info.range.end);
    }

    function loadInitialization(representation, loadingInfo) {
        var request = null;
        var baseUrl = baseURLController.resolve(representation.path);
        var media = baseUrl ? baseUrl.url : undefined;
        var initRange = representation.range.split('-');
        var info = loadingInfo || {
            range: {
                start: parseFloat(initRange[0]),
                end: parseFloat(initRange[1])
            },
            request: request,
            url: media,
            init: true
        };

        log('Start loading initialization.');

        request = getFragmentRequest(info);

        var onload = function onload() {
            // note that we don't explicitly set rep.initialization as this
            // will be computed when all BaseURLs are resolved later
            eventBus.trigger(_coreEventsEvents2['default'].INITIALIZATION_LOADED, { representation: representation });
        };

        var onloadend = function onloadend() {
            eventBus.trigger(_coreEventsEvents2['default'].INITIALIZATION_LOADED, { representation: representation });
        };

        xhrLoader.load({ request: request, success: onload, error: onloadend });

        log('Perform init load: ' + info.url);
    }

    function loadSegments(representation, type, theRange, callback) {
        var request = null;
        var baseUrl = baseURLController.resolve(representation.path);
        var media = baseUrl ? baseUrl.url : undefined;
        var bytesToLoad = 8192;
        var info = {
            bytesLoaded: 0,
            bytesToLoad: bytesToLoad,
            range: {
                start: 0,
                end: bytesToLoad
            },
            request: request,
            url: media,
            init: false
        };

        callback = !callback ? onLoaded : callback;
        request = getFragmentRequest(info);

        // first load the header, but preserve the manifest range so we can
        // load the cues after parsing the header
        // NOTE: we expect segment info to appear in the first 8192 bytes
        log('Parsing ebml header');

        var onload = function onload(response) {
            parseEbmlHeader(response, media, theRange, function (segments) {
                callback(segments, representation, type);
            });
        };

        var onloadend = function onloadend() {
            callback(null, representation, type);
        };

        xhrLoader.load({ request: request, success: onload, error: onloadend });
    }

    function onLoaded(segments, representation, type) {
        if (segments) {
            eventBus.trigger(_coreEventsEvents2['default'].SEGMENTS_LOADED, { segments: segments, representation: representation, mediaType: type });
        } else {
            eventBus.trigger(_coreEventsEvents2['default'].SEGMENTS_LOADED, { segments: null, representation: representation, mediaType: type, error: new Error(null, 'error loading segments', null) });
        }
    }

    function getFragmentRequest(info) {
        var request = new _streamingVoFragmentRequest2['default']();

        request.type = info.init ? _streamingVoMetricsHTTPRequest.HTTPRequest.INIT_SEGMENT_TYPE : _streamingVoMetricsHTTPRequest.HTTPRequest.MEDIA_SEGMENT_TYPE;
        request.url = info.url;
        request.range = info.range.start + '-' + info.range.end;

        return request;
    }

    function reset() {
        errHandler = null;
        requestModifier = null;
        log = null;
    }

    instance = {
        setConfig: setConfig,
        initialize: initialize,
        loadInitialization: loadInitialization,
        loadSegments: loadSegments,
        reset: reset
    };

    setup();

    return instance;
}

WebmSegmentBaseLoader.__dashjs_factory_name = 'WebmSegmentBaseLoader';
exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(WebmSegmentBaseLoader);
module.exports = exports['default'];
//# sourceMappingURL=WebmSegmentBaseLoader.js.map


/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _modelsDashManifestModel = __webpack_require__(158);

var _modelsDashManifestModel2 = _interopRequireDefault(_modelsDashManifestModel);

var _DashMetrics = __webpack_require__(157);

var _DashMetrics2 = _interopRequireDefault(_DashMetrics);

var _utilsTimelineConverter = __webpack_require__(395);

var _utilsTimelineConverter2 = _interopRequireDefault(_utilsTimelineConverter);

var _streamingControllersAbrController = __webpack_require__(159);

var _streamingControllersAbrController2 = _interopRequireDefault(_streamingControllersAbrController);

var _streamingControllersPlaybackController = __webpack_require__(161);

var _streamingControllersPlaybackController2 = _interopRequireDefault(_streamingControllersPlaybackController);

var _streamingModelsManifestModel = __webpack_require__(325);

var _streamingModelsManifestModel2 = _interopRequireDefault(_streamingModelsManifestModel);

var _streamingModelsMetricsModel = __webpack_require__(135);

var _streamingModelsMetricsModel2 = _interopRequireDefault(_streamingModelsMetricsModel);

var _streamingUtilsDOMStorage = __webpack_require__(407);

var _streamingUtilsDOMStorage2 = _interopRequireDefault(_streamingUtilsDOMStorage);

var _streamingVoError = __webpack_require__(111);

var _streamingVoError2 = _interopRequireDefault(_streamingVoError);

var _coreEventBus = __webpack_require__(27);

var _coreEventBus2 = _interopRequireDefault(_coreEventBus);

var _coreEventsEvents = __webpack_require__(22);

var _coreEventsEvents2 = _interopRequireDefault(_coreEventsEvents);

var _streamingMediaPlayerEvents = __webpack_require__(238);

var _streamingMediaPlayerEvents2 = _interopRequireDefault(_streamingMediaPlayerEvents);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _voRepresentation = __webpack_require__(396);

var _voRepresentation2 = _interopRequireDefault(_voRepresentation);

function RepresentationController() {

    var SEGMENTS_UPDATE_FAILED_ERROR_CODE = 1;

    var context = this.context;
    var eventBus = (0, _coreEventBus2['default'])(context).getInstance();

    var instance = undefined,
        data = undefined,
        dataIndex = undefined,
        updating = undefined,
        availableRepresentations = undefined,
        currentRepresentation = undefined,
        streamProcessor = undefined,
        abrController = undefined,
        indexHandler = undefined,
        playbackController = undefined,
        manifestModel = undefined,
        metricsModel = undefined,
        domStorage = undefined,
        timelineConverter = undefined,
        dashManifestModel = undefined,
        dashMetrics = undefined;

    function setup() {
        data = null;
        dataIndex = -1;
        updating = true;
        availableRepresentations = [];

        abrController = (0, _streamingControllersAbrController2['default'])(context).getInstance();
        playbackController = (0, _streamingControllersPlaybackController2['default'])(context).getInstance();
        manifestModel = (0, _streamingModelsManifestModel2['default'])(context).getInstance();
        metricsModel = (0, _streamingModelsMetricsModel2['default'])(context).getInstance();
        domStorage = (0, _streamingUtilsDOMStorage2['default'])(context).getInstance();
        timelineConverter = (0, _utilsTimelineConverter2['default'])(context).getInstance();
        dashManifestModel = (0, _modelsDashManifestModel2['default'])(context).getInstance();
        dashMetrics = (0, _DashMetrics2['default'])(context).getInstance();

        eventBus.on(_coreEventsEvents2['default'].QUALITY_CHANGE_REQUESTED, onQualityChanged, instance);
        eventBus.on(_coreEventsEvents2['default'].REPRESENTATION_UPDATED, onRepresentationUpdated, instance);
        eventBus.on(_coreEventsEvents2['default'].WALLCLOCK_TIME_UPDATED, onWallclockTimeUpdated, instance);
        eventBus.on(_coreEventsEvents2['default'].BUFFER_LEVEL_UPDATED, onBufferLevelUpdated, instance);
    }

    function setConfig(config) {
        // allow the abrController created in setup to be overidden
        if (config.abrController) {
            abrController = config.abrController;
        }
    }

    function initialize(StreamProcessor) {
        streamProcessor = StreamProcessor;
        indexHandler = streamProcessor.getIndexHandler();
    }

    function getStreamProcessor() {
        return streamProcessor;
    }

    function getData() {
        return data;
    }

    function getDataIndex() {
        return dataIndex;
    }

    function isUpdating() {
        return updating;
    }

    function getCurrentRepresentation() {
        return currentRepresentation;
    }

    function reset() {

        eventBus.off(_coreEventsEvents2['default'].QUALITY_CHANGE_REQUESTED, onQualityChanged, instance);
        eventBus.off(_coreEventsEvents2['default'].REPRESENTATION_UPDATED, onRepresentationUpdated, instance);
        eventBus.off(_coreEventsEvents2['default'].WALLCLOCK_TIME_UPDATED, onWallclockTimeUpdated, instance);
        eventBus.off(_coreEventsEvents2['default'].BUFFER_LEVEL_UPDATED, onBufferLevelUpdated, instance);

        data = null;
        dataIndex = -1;
        updating = true;
        availableRepresentations = [];
        abrController = null;
        playbackController = null;
        manifestModel = null;
        metricsModel = null;
        domStorage = null;
        timelineConverter = null;
        dashManifestModel = null;
        dashMetrics = null;
    }

    function updateData(dataValue, adaptation, type) {
        var quality, averageThroughput;

        var bitrate = null;
        var streamInfo = streamProcessor.getStreamInfo();
        var maxQuality = abrController.getTopQualityIndexFor(type, streamInfo.id);

        updating = true;
        eventBus.trigger(_coreEventsEvents2['default'].DATA_UPDATE_STARTED, { sender: this });

        availableRepresentations = updateRepresentations(adaptation);

        if (data === null && type !== 'fragmentedText') {
            averageThroughput = abrController.getAverageThroughput(type);
            bitrate = averageThroughput || abrController.getInitialBitrateFor(type, streamInfo);
            quality = abrController.getQualityForBitrate(streamProcessor.getMediaInfo(), bitrate);
        } else {
            quality = abrController.getQualityFor(type, streamInfo);
        }

        if (quality > maxQuality) {
            quality = maxQuality;
        }

        currentRepresentation = getRepresentationForQuality(quality);
        data = dataValue;

        if (type !== 'video' && type !== 'audio' && type !== 'fragmentedText') {
            updating = false;
            eventBus.trigger(_coreEventsEvents2['default'].DATA_UPDATE_COMPLETED, { sender: this, data: data, currentRepresentation: currentRepresentation });
            return;
        }

        for (var i = 0; i < availableRepresentations.length; i++) {
            indexHandler.updateRepresentation(availableRepresentations[i], true);
        }
    }

    function addRepresentationSwitch() {
        var now = new Date();
        var currentRepresentation = getCurrentRepresentation();
        var currentVideoTimeMs = playbackController.getTime() * 1000;

        metricsModel.addRepresentationSwitch(currentRepresentation.adaptation.type, now, currentVideoTimeMs, currentRepresentation.id);
    }

    function addDVRMetric() {
        var range = timelineConverter.calcSegmentAvailabilityRange(currentRepresentation, streamProcessor.isDynamic());
        metricsModel.addDVRInfo(streamProcessor.getType(), playbackController.getTime(), streamProcessor.getStreamInfo().manifestInfo, range);
    }

    function getRepresentationForQuality(quality) {
        return availableRepresentations[quality];
    }

    function getQualityForRepresentation(representation) {
        return availableRepresentations.indexOf(representation);
    }

    function isAllRepresentationsUpdated() {
        for (var i = 0, ln = availableRepresentations.length; i < ln; i++) {
            var segmentInfoType = availableRepresentations[i].segmentInfoType;
            if (availableRepresentations[i].segmentAvailabilityRange === null || !_voRepresentation2['default'].hasInitialization(availableRepresentations[i]) || (segmentInfoType === 'SegmentBase' || segmentInfoType === 'BaseURL') && !availableRepresentations[i].segments) {
                return false;
            }
        }

        return true;
    }

    function updateRepresentations(adaptation) {
        var reps;
        var manifest = manifestModel.getValue();

        dataIndex = dashManifestModel.getIndexForAdaptation(data, manifest, adaptation.period.index);
        reps = dashManifestModel.getRepresentationsForAdaptation(manifest, adaptation);

        return reps;
    }

    function updateAvailabilityWindow(isDynamic) {
        var rep;

        for (var i = 0, ln = availableRepresentations.length; i < ln; i++) {
            rep = availableRepresentations[i];
            rep.segmentAvailabilityRange = timelineConverter.calcSegmentAvailabilityRange(rep, isDynamic);
        }
    }

    function resetAvailabilityWindow() {
        availableRepresentations.forEach(function (rep) {
            rep.segmentAvailabilityRange = null;
        });
    }

    function postponeUpdate(postponeTimePeriod) {
        var delay = postponeTimePeriod;
        var update = function update() {
            if (isUpdating()) return;

            updating = true;
            eventBus.trigger(_coreEventsEvents2['default'].DATA_UPDATE_STARTED, { sender: instance });

            // clear the segmentAvailabilityRange for all reps.
            // this ensures all are updated before the live edge search starts
            resetAvailabilityWindow();

            for (var i = 0; i < availableRepresentations.length; i++) {
                indexHandler.updateRepresentation(availableRepresentations[i], true);
            }
        };

        updating = false;
        eventBus.trigger(_streamingMediaPlayerEvents2['default'].AST_IN_FUTURE, { delay: delay });
        setTimeout(update, delay);
    }

    function onRepresentationUpdated(e) {
        if (e.sender.getStreamProcessor() !== streamProcessor || !isUpdating()) return;

        var r = e.representation;
        var streamMetrics = metricsModel.getMetricsFor('stream');
        var metrics = metricsModel.getMetricsFor(getCurrentRepresentation().adaptation.type);
        var manifestUpdateInfo = dashMetrics.getCurrentManifestUpdate(streamMetrics);
        var alreadyAdded = false;
        var postponeTimePeriod = 0;
        var repInfo;
        var err;
        var repSwitch;

        if (r.adaptation.period.mpd.manifest.type === 'dynamic') {
            var segmentAvailabilityTimePeriod = r.segmentAvailabilityRange.end - r.segmentAvailabilityRange.start;
            // We must put things to sleep unless till e.g. the startTime calculation in ScheduleController.onLiveEdgeSearchCompleted fall after the segmentAvailabilityRange.start
            var liveDelay = playbackController.computeLiveDelay(currentRepresentation.segmentDuration, streamProcessor.getStreamInfo().manifestInfo.DVRWindowSize);
            postponeTimePeriod = (liveDelay - segmentAvailabilityTimePeriod) * 1000;
        }

        if (postponeTimePeriod > 0) {
            addDVRMetric();
            postponeUpdate(postponeTimePeriod);
            err = new _streamingVoError2['default'](SEGMENTS_UPDATE_FAILED_ERROR_CODE, 'Segments update failed', null);
            eventBus.trigger(_coreEventsEvents2['default'].DATA_UPDATE_COMPLETED, { sender: this, data: data, currentRepresentation: currentRepresentation, error: err });

            return;
        }

        if (manifestUpdateInfo) {
            for (var i = 0; i < manifestUpdateInfo.trackInfo.length; i++) {
                repInfo = manifestUpdateInfo.trackInfo[i];
                if (repInfo.index === r.index && repInfo.mediaType === streamProcessor.getType()) {
                    alreadyAdded = true;
                    break;
                }
            }

            if (!alreadyAdded) {
                metricsModel.addManifestUpdateRepresentationInfo(manifestUpdateInfo, r.id, r.index, r.adaptation.period.index, streamProcessor.getType(), r.presentationTimeOffset, r.startNumber, r.segmentInfoType);
            }
        }

        if (isAllRepresentationsUpdated()) {
            updating = false;
            abrController.setPlaybackQuality(streamProcessor.getType(), streamProcessor.getStreamInfo(), getQualityForRepresentation(currentRepresentation));
            metricsModel.updateManifestUpdateInfo(manifestUpdateInfo, { latency: currentRepresentation.segmentAvailabilityRange.end - playbackController.getTime() });

            repSwitch = dashMetrics.getCurrentRepresentationSwitch(metrics);

            if (!repSwitch) {
                addRepresentationSwitch();
            }

            eventBus.trigger(_coreEventsEvents2['default'].DATA_UPDATE_COMPLETED, { sender: this, data: data, currentRepresentation: currentRepresentation });
        }
    }

    function onWallclockTimeUpdated(e) {
        if (e.isDynamic) {
            updateAvailabilityWindow(e.isDynamic);
        }
    }

    function onBufferLevelUpdated(e) {
        if (e.sender.getStreamProcessor() !== streamProcessor) return;
        addDVRMetric();
    }

    function onQualityChanged(e) {
        if (e.mediaType !== streamProcessor.getType() || streamProcessor.getStreamInfo().id !== e.streamInfo.id) return;

        if (e.oldQuality !== e.newQuality) {
            currentRepresentation = getRepresentationForQuality(e.newQuality);
            domStorage.setSavedBitrateSettings(e.mediaType, currentRepresentation.bandwidth);
            addRepresentationSwitch();
        }
    }

    instance = {
        initialize: initialize,
        setConfig: setConfig,
        getData: getData,
        getDataIndex: getDataIndex,
        isUpdating: isUpdating,
        updateData: updateData,
        getStreamProcessor: getStreamProcessor,
        getCurrentRepresentation: getCurrentRepresentation,
        getRepresentationForQuality: getRepresentationForQuality,
        reset: reset
    };

    setup();
    return instance;
}

RepresentationController.__dashjs_factory_name = 'RepresentationController';
exports['default'] = _coreFactoryMaker2['default'].getClassFactory(RepresentationController);
module.exports = exports['default'];
//# sourceMappingURL=RepresentationController.js.map


/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _streamingUtilsErrorHandler = __webpack_require__(136);

var _streamingUtilsErrorHandler2 = _interopRequireDefault(_streamingUtilsErrorHandler);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _coreDebug = __webpack_require__(30);

var _coreDebug2 = _interopRequireDefault(_coreDebug);

var _externalsObjectiron = __webpack_require__(1320);

var _externalsObjectiron2 = _interopRequireDefault(_externalsObjectiron);

var _externalsXml2json = __webpack_require__(393);

var _externalsXml2json2 = _interopRequireDefault(_externalsXml2json);

var _matchersStringMatcher = __webpack_require__(1334);

var _matchersStringMatcher2 = _interopRequireDefault(_matchersStringMatcher);

var _matchersDurationMatcher = __webpack_require__(1332);

var _matchersDurationMatcher2 = _interopRequireDefault(_matchersDurationMatcher);

var _matchersDateTimeMatcher = __webpack_require__(1331);

var _matchersDateTimeMatcher2 = _interopRequireDefault(_matchersDateTimeMatcher);

var _matchersNumericMatcher = __webpack_require__(1333);

var _matchersNumericMatcher2 = _interopRequireDefault(_matchersNumericMatcher);

var _mapsRepresentationBaseValuesMap = __webpack_require__(1329);

var _mapsRepresentationBaseValuesMap2 = _interopRequireDefault(_mapsRepresentationBaseValuesMap);

var _mapsSegmentValuesMap = __webpack_require__(1330);

var _mapsSegmentValuesMap2 = _interopRequireDefault(_mapsSegmentValuesMap);

function DashParser() /*config*/{

    var context = this.context;
    var log = (0, _coreDebug2['default'])(context).getInstance().log;
    var errorHandler = (0, _streamingUtilsErrorHandler2['default'])(context).getInstance();

    var instance = undefined,
        matchers = undefined,
        converter = undefined,
        objectIron = undefined;

    function setup() {
        matchers = [new _matchersDurationMatcher2['default'](), new _matchersDateTimeMatcher2['default'](), new _matchersNumericMatcher2['default'](), new _matchersStringMatcher2['default']() // last in list to take precedence over NumericMatcher
        ];

        converter = new _externalsXml2json2['default']({
            escapeMode: false,
            attributePrefix: '',
            arrayAccessForm: 'property',
            emptyNodeForm: 'object',
            stripWhitespaces: false,
            enableToStringFunc: false,
            ignoreRoot: true,
            matchers: matchers
        });

        objectIron = new _externalsObjectiron2['default']([new _mapsRepresentationBaseValuesMap2['default'](), new _mapsSegmentValuesMap2['default']()]);
    }

    function parse(data, xlinkController) {
        var manifest;

        try {
            var startTime = window.performance.now();

            manifest = converter.xml_str2json(data);

            if (!manifest) {
                throw new Error('parser error');
            }

            var jsonTime = window.performance.now();

            objectIron.run(manifest);

            var ironedTime = window.performance.now();

            xlinkController.setMatchers(matchers);
            xlinkController.setIron(objectIron);

            log('Parsing complete: ( xml2json: ' + (jsonTime - startTime).toPrecision(3) + 'ms, objectiron: ' + (ironedTime - jsonTime).toPrecision(3) + 'ms, total: ' + ((ironedTime - startTime) / 1000).toPrecision(3) + 's)');
        } catch (err) {
            errorHandler.manifestError('parsing the manifest failed', 'parse', data, err);
            return null;
        }

        return manifest;
    }

    instance = {
        parse: parse
    };

    setup();

    return instance;
}

DashParser.__dashjs_factory_name = 'DashParser';
exports['default'] = _coreFactoryMaker2['default'].getClassFactory(DashParser);
module.exports = exports['default'];
//# sourceMappingURL=DashParser.js.map


/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @classdesc a property belonging to a MapNode
 */



Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CommonProperty = (function () {
    function CommonProperty(name, merge) {
        _classCallCheck(this, CommonProperty);

        var getDefaultMergeForName = function getDefaultMergeForName(n) {
            return n && n.length && n.charAt(0) === n.charAt(0).toUpperCase();
        };

        this._name = name;
        this._merge = merge !== undefined ? merge : getDefaultMergeForName(name);
    }

    _createClass(CommonProperty, [{
        key: "name",
        get: function get() {
            return this._name;
        }
    }, {
        key: "merge",
        get: function get() {
            return this._merge;
        }
    }]);

    return CommonProperty;
})();

exports["default"] = CommonProperty;
module.exports = exports["default"];
//# sourceMappingURL=CommonProperty.js.map


/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @classdesc a RepresentationBaseValuesMap type for input to objectiron
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _MapNode2 = __webpack_require__(586);

var _MapNode3 = _interopRequireDefault(_MapNode2);

var RepresentationBaseValuesMap = (function (_MapNode) {
    _inherits(RepresentationBaseValuesMap, _MapNode);

    function RepresentationBaseValuesMap() {
        _classCallCheck(this, RepresentationBaseValuesMap);

        var commonProperties = ['profiles', 'width', 'height', 'sar', 'frameRate', 'audioSamplingRate', 'mimeType', 'segmentProfiles', 'codecs', 'maximumSAPPeriod', 'startWithSAP', 'maxPlayoutRate', 'codingDependency', 'scanType', 'FramePacking', 'AudioChannelConfiguration', 'ContentProtection', 'EssentialProperty', 'SupplementalProperty', 'InbandEventStream'];

        _get(Object.getPrototypeOf(RepresentationBaseValuesMap.prototype), 'constructor', this).call(this, 'AdaptationSet', commonProperties, [new _MapNode3['default']('Representation', commonProperties, [new _MapNode3['default']('SubRepresentation', commonProperties)])]);
    }

    return RepresentationBaseValuesMap;
})(_MapNode3['default']);

exports['default'] = RepresentationBaseValuesMap;
module.exports = exports['default'];
//# sourceMappingURL=RepresentationBaseValuesMap.js.map


/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @classdesc a SegmentValuesMap type for input to objectiron
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _MapNode2 = __webpack_require__(586);

var _MapNode3 = _interopRequireDefault(_MapNode2);

var SegmentValuesMap = (function (_MapNode) {
    _inherits(SegmentValuesMap, _MapNode);

    function SegmentValuesMap() {
        _classCallCheck(this, SegmentValuesMap);

        var commonProperties = ['SegmentBase', 'SegmentTemplate', 'SegmentList'];

        _get(Object.getPrototypeOf(SegmentValuesMap.prototype), 'constructor', this).call(this, 'Period', commonProperties, [new _MapNode3['default']('AdaptationSet', commonProperties, [new _MapNode3['default']('Representation', commonProperties)])]);
    }

    return SegmentValuesMap;
})(_MapNode3['default']);

exports['default'] = SegmentValuesMap;
module.exports = exports['default'];
//# sourceMappingURL=SegmentValuesMap.js.map


/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @classdesc matches and converts xs:datetime to Date
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _BaseMatcher2 = __webpack_require__(320);

var _BaseMatcher3 = _interopRequireDefault(_BaseMatcher2);

var SECONDS_IN_MIN = 60;
var MINUTES_IN_HOUR = 60;
var MILLISECONDS_IN_SECONDS = 1000;

var datetimeRegex = /^([0-9]{4})-([0-9]{2})-([0-9]{2})T([0-9]{2}):([0-9]{2})(?::([0-9]*)(\.[0-9]*)?)?(?:([+-])([0-9]{2})(?::?)([0-9]{2}))?/;

var DateTimeMatcher = (function (_BaseMatcher) {
    _inherits(DateTimeMatcher, _BaseMatcher);

    function DateTimeMatcher() {
        _classCallCheck(this, DateTimeMatcher);

        _get(Object.getPrototypeOf(DateTimeMatcher.prototype), 'constructor', this).call(this, function (attr) {
            return datetimeRegex.test(attr.value);
        }, function (str) {
            var match = datetimeRegex.exec(str);
            var utcDate = undefined;

            // If the string does not contain a timezone offset different browsers can interpret it either
            // as UTC or as a local time so we have to parse the string manually to normalize the given date value for
            // all browsers
            utcDate = Date.UTC(parseInt(match[1], 10), parseInt(match[2], 10) - 1, // months start from zero
            parseInt(match[3], 10), parseInt(match[4], 10), parseInt(match[5], 10), match[6] && parseInt(match[6], 10) || 0, match[7] && parseFloat(match[7]) * MILLISECONDS_IN_SECONDS || 0);

            // If the date has timezone offset take it into account as well
            if (match[9] && match[10]) {
                var timezoneOffset = parseInt(match[9], 10) * MINUTES_IN_HOUR + parseInt(match[10], 10);
                utcDate += (match[8] === '+' ? -1 : +1) * timezoneOffset * SECONDS_IN_MIN * MILLISECONDS_IN_SECONDS;
            }

            return new Date(utcDate);
        });
    }

    return DateTimeMatcher;
})(_BaseMatcher3['default']);

exports['default'] = DateTimeMatcher;
module.exports = exports['default'];
//# sourceMappingURL=DateTimeMatcher.js.map


/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @classdesc matches and converts xs:duration to seconds
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _BaseMatcher2 = __webpack_require__(320);

var _BaseMatcher3 = _interopRequireDefault(_BaseMatcher2);

var durationRegex = /^([-])?P(([\d.]*)Y)?(([\d.]*)M)?(([\d.]*)D)?T?(([\d.]*)H)?(([\d.]*)M)?(([\d.]*)S)?/;

var SECONDS_IN_YEAR = 365 * 24 * 60 * 60;
var SECONDS_IN_MONTH = 30 * 24 * 60 * 60;
var SECONDS_IN_DAY = 24 * 60 * 60;
var SECONDS_IN_HOUR = 60 * 60;
var SECONDS_IN_MIN = 60;

var DurationMatcher = (function (_BaseMatcher) {
    _inherits(DurationMatcher, _BaseMatcher);

    function DurationMatcher() {
        _classCallCheck(this, DurationMatcher);

        _get(Object.getPrototypeOf(DurationMatcher.prototype), 'constructor', this).call(this, function (attr) {
            var attributeList = ['minBufferTime', 'mediaPresentationDuration', 'minimumUpdatePeriod', 'timeShiftBufferDepth', 'maxSegmentDuration', 'maxSubsegmentDuration', 'suggestedPresentationDelay', 'start', 'starttime', 'duration'];
            var len = attributeList.length;

            for (var i = 0; i < len; i++) {
                if (attr.nodeName === attributeList[i]) {
                    return durationRegex.test(attr.value);
                }
            }

            return false;
        }, function (str) {
            //str = "P10Y10M10DT10H10M10.1S";
            var match = durationRegex.exec(str);
            var result = parseFloat(match[2] || 0) * SECONDS_IN_YEAR + parseFloat(match[4] || 0) * SECONDS_IN_MONTH + parseFloat(match[6] || 0) * SECONDS_IN_DAY + parseFloat(match[8] || 0) * SECONDS_IN_HOUR + parseFloat(match[10] || 0) * SECONDS_IN_MIN + parseFloat(match[12] || 0);

            if (match[1] !== undefined) {
                result = -result;
            }

            return result;
        });
    }

    return DurationMatcher;
})(_BaseMatcher3['default']);

exports['default'] = DurationMatcher;
module.exports = exports['default'];
//# sourceMappingURL=DurationMatcher.js.map


/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @classdesc Matches and converts xs:numeric to float
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _BaseMatcher2 = __webpack_require__(320);

var _BaseMatcher3 = _interopRequireDefault(_BaseMatcher2);

var numericRegex = /^[-+]?[0-9]+[.]?[0-9]*([eE][-+]?[0-9]+)?$/;

var NumericMatcher = (function (_BaseMatcher) {
    _inherits(NumericMatcher, _BaseMatcher);

    function NumericMatcher() {
        _classCallCheck(this, NumericMatcher);

        _get(Object.getPrototypeOf(NumericMatcher.prototype), 'constructor', this).call(this, function (attr) {
            return numericRegex.test(attr.value);
        }, function (str) {
            return parseFloat(str);
        });
    }

    return NumericMatcher;
})(_BaseMatcher3['default']);

exports['default'] = NumericMatcher;
module.exports = exports['default'];
//# sourceMappingURL=NumericMatcher.js.map


/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @classdesc Matches and converts xs:string to string, but only for specific attributes on specific nodes
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _BaseMatcher2 = __webpack_require__(320);

var _BaseMatcher3 = _interopRequireDefault(_BaseMatcher2);

var StringMatcher = (function (_BaseMatcher) {
    _inherits(StringMatcher, _BaseMatcher);

    function StringMatcher() {
        _classCallCheck(this, StringMatcher);

        _get(Object.getPrototypeOf(StringMatcher.prototype), 'constructor', this).call(this, function (attr, nodeName) {
            var stringAttrsInElements = {
                'MPD': ['id', 'profiles'],
                'Period': ['id'],
                'BaseURL': ['serviceLocation', 'byteRange'],
                'SegmentBase': ['indexRange'],
                'Initialization': ['range'],
                'RepresentationIndex': ['range'],
                'SegmentList': ['indexRange'],
                'BitstreamSwitching': ['range'],
                'SegmentURL': ['mediaRange', 'indexRange'],
                'SegmentTemplate': ['indexRange', 'media', 'index', 'initialization', 'bitstreamSwitching'],
                'AssetIdentifier': ['value', 'id'],
                'EventStream': ['value'],
                'AdaptationSet': ['profiles', 'mimeType', 'segmentProfiles', 'codecs', 'contentType'],
                'FramePacking': ['value', 'id'],
                'AudioChannelConfiguration': ['value', 'id'],
                'ContentProtection': ['value', 'id'],
                'EssentialProperty': ['value', 'id'],
                'SupplementalProperty': ['value', 'id'],
                'InbandEventStream': ['value', 'id'],
                'Accessibility': ['value', 'id'],
                'Role': ['value', 'id'],
                'Rating': ['value', 'id'],
                'Viewpoint': ['value', 'id'],
                'ContentComponent': ['contentType'],
                'Representation': ['id', 'dependencyId', 'mediaStreamStructureId'],
                'Subset': ['id'],
                'Metrics': ['metrics'],
                'Reporting': ['value', 'id']
            };
            if (stringAttrsInElements.hasOwnProperty(nodeName)) {
                var attrNames = stringAttrsInElements[nodeName];
                if (attrNames !== undefined) {
                    return attrNames.indexOf(attr.name) >= 0;
                } else {
                    return false;
                }
            }
            return false;
        }, function (str) {
            return String(str);
        });
    }

    return StringMatcher;
})(_BaseMatcher3['default']);

exports['default'] = StringMatcher;
module.exports = exports['default'];
//# sourceMappingURL=StringMatcher.js.map


/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

function FragmentedTextBoxParser() {

    var instance = undefined,
        boxParser = undefined;

    function setConfig(config) {
        if (!config) return;

        if (config.boxParser) {
            boxParser = config.boxParser;
        }
    }

    function getSamplesInfo(ab) {
        var isoFile = boxParser.parse(ab);
        var tfhdBox = isoFile.getBox('tfhd');
        var tfdtBox = isoFile.getBox('tfdt');
        var trunBox = isoFile.getBox('trun');
        var moofBox = isoFile.getBox('moof');
        var mfhdBox = isoFile.getBox('mfhd');
        var subsBox = isoFile.getBox('subs');

        var sampleDuration, sampleCompositionTimeOffset, sampleCount, sampleSize, sampleDts, sampleList, sample, i, j, dataOffset, sequenceNumber, totalDuration;

        sequenceNumber = mfhdBox.sequence_number;
        sampleCount = trunBox.sample_count;
        sampleDts = tfdtBox.baseMediaDecodeTime;
        dataOffset = (tfhdBox.base_data_offset || 0) + (trunBox.data_offset || 0);

        sampleList = [];
        var subsIndex = -1;
        var nextSubsSample = -1;
        for (i = 0; i < sampleCount; i++) {
            sample = trunBox.samples[i];
            sampleDuration = sample.sample_duration !== undefined ? sample.sample_duration : tfhdBox.default_sample_duration;
            sampleSize = sample.sample_size !== undefined ? sample.sample_size : tfhdBox.default_sample_size;
            sampleCompositionTimeOffset = sample.sample_composition_time_offset !== undefined ? sample.sample_composition_time_offset : 0;
            var sampleData = {
                'dts': sampleDts,
                'cts': sampleDts + sampleCompositionTimeOffset,
                'duration': sampleDuration,
                'offset': moofBox.offset + dataOffset,
                'size': sampleSize,
                'subSizes': [sampleSize]
            };
            if (subsBox) {
                if (subsIndex < subsBox.entry_count && i > nextSubsSample) {
                    subsIndex++;
                    nextSubsSample += subsBox.entries[subsIndex].sample_delta;
                }
                if (i == nextSubsSample) {
                    sampleData.subSizes = [];
                    var entry = subsBox.entries[subsIndex];
                    for (j = 0; j < entry.subsample_count; j++) {
                        sampleData.subSizes.push(entry.subsamples[j].subsample_size);
                    }
                }
            }
            sampleList.push(sampleData);
            dataOffset += sampleSize;
            sampleDts += sampleDuration;
        }
        totalDuration = sampleDts - tfdtBox.baseMediaDecodeTime;
        return { sampleList: sampleList, sequenceNumber: sequenceNumber, totalDuration: totalDuration };
    }

    function getMediaTimescaleFromMoov(ab) {
        var isoFile = boxParser.parse(ab);
        var mdhdBox = isoFile.getBox('mdhd');

        return mdhdBox ? mdhdBox.timescale : NaN;
    }

    instance = {
        getSamplesInfo: getSamplesInfo,
        getMediaTimescaleFromMoov: getMediaTimescaleFromMoov,
        setConfig: setConfig
    };

    return instance;
}

FragmentedTextBoxParser.__dashjs_factory_name = 'FragmentedTextBoxParser';
exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(FragmentedTextBoxParser);
module.exports = exports['default'];
//# sourceMappingURL=FragmentedTextBoxParser.js.map


/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _SegmentsUtils = __webpack_require__(321);

function ListSegmentsGetter(config, isDynamic) {

    var timelineConverter = config.timelineConverter;

    var instance = undefined;

    function getSegmentsFromList(representation, requestedTime, index, availabilityUpperLimit) {
        var list = representation.adaptation.period.mpd.manifest.Period_asArray[representation.adaptation.period.index].AdaptationSet_asArray[representation.adaptation.index].Representation_asArray[representation.index].SegmentList;
        var len = list.SegmentURL_asArray.length;

        var segments = [];

        var periodSegIdx, seg, s, range, startIdx, endIdx, start;

        start = representation.startNumber;

        range = (0, _SegmentsUtils.decideSegmentListRangeForTemplate)(timelineConverter, isDynamic, representation, requestedTime, index, availabilityUpperLimit);
        startIdx = Math.max(range.start, 0);
        endIdx = Math.min(range.end, list.SegmentURL_asArray.length - 1);

        for (periodSegIdx = startIdx; periodSegIdx <= endIdx; periodSegIdx++) {
            s = list.SegmentURL_asArray[periodSegIdx];

            seg = (0, _SegmentsUtils.getIndexBasedSegment)(timelineConverter, isDynamic, representation, periodSegIdx);
            seg.replacementTime = (start + periodSegIdx - 1) * representation.segmentDuration;
            seg.media = s.media ? s.media : '';
            seg.mediaRange = s.mediaRange;
            seg.index = s.index;
            seg.indexRange = s.indexRange;

            segments.push(seg);
            seg = null;
        }

        representation.availableSegmentsNumber = len;

        return segments;
    }

    instance = {
        getSegments: getSegmentsFromList
    };

    return instance;
}

ListSegmentsGetter.__dashjs_factory_name = 'ListSegmentsGetter';
var factory = _coreFactoryMaker2['default'].getClassFactory(ListSegmentsGetter);
exports['default'] = factory;
module.exports = exports['default'];
//# sourceMappingURL=ListSegmentsGetter.js.map


/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _TimelineSegmentsGetter = __webpack_require__(1339);

var _TimelineSegmentsGetter2 = _interopRequireDefault(_TimelineSegmentsGetter);

var _TemplateSegmentsGetter = __webpack_require__(1338);

var _TemplateSegmentsGetter2 = _interopRequireDefault(_TemplateSegmentsGetter);

var _ListSegmentsGetter = __webpack_require__(1336);

var _ListSegmentsGetter2 = _interopRequireDefault(_ListSegmentsGetter);

function SegmentsGetter(config, isDynamic) {

    var context = this.context;

    var instance = undefined,
        timelineSegmentsGetter = undefined,
        templateSegmentsGetter = undefined,
        listSegmentsGetter = undefined;

    function setup() {
        timelineSegmentsGetter = (0, _TimelineSegmentsGetter2['default'])(context).create(config, isDynamic);
        templateSegmentsGetter = (0, _TemplateSegmentsGetter2['default'])(context).create(config, isDynamic);
        listSegmentsGetter = (0, _ListSegmentsGetter2['default'])(context).create(config, isDynamic);
    }

    function getSegments(representation, requestedTime, index, onSegmentListUpdatedCallback, availabilityUpperLimit) {
        var segments;
        var type = representation.segmentInfoType;

        // Already figure out the segments.
        if (type === 'SegmentBase' || type === 'BaseURL' || !isSegmentListUpdateRequired(representation, index)) {
            segments = representation.segments;
        } else {
            if (type === 'SegmentTimeline') {
                segments = timelineSegmentsGetter.getSegments(representation, requestedTime, index, availabilityUpperLimit);
            } else if (type === 'SegmentTemplate') {
                segments = templateSegmentsGetter.getSegments(representation, requestedTime, index, availabilityUpperLimit);
            } else if (type === 'SegmentList') {
                segments = listSegmentsGetter.getSegments(representation, requestedTime, index, availabilityUpperLimit);
            }

            if (onSegmentListUpdatedCallback) {
                onSegmentListUpdatedCallback(representation, segments);
            }
        }

        return segments;
    }

    function isSegmentListUpdateRequired(representation, index) {
        var segments = representation.segments;
        var updateRequired = false;

        var upperIdx, lowerIdx;

        if (!segments || segments.length === 0) {
            updateRequired = true;
        } else {
            lowerIdx = segments[0].availabilityIdx;
            upperIdx = segments[segments.length - 1].availabilityIdx;
            updateRequired = index < lowerIdx || index > upperIdx;
        }

        return updateRequired;
    }

    instance = {
        getSegments: getSegments
    };

    setup();

    return instance;
}

SegmentsGetter.__dashjs_factory_name = 'SegmentsGetter';
var factory = _coreFactoryMaker2['default'].getClassFactory(SegmentsGetter);
exports['default'] = factory;
module.exports = exports['default'];
//# sourceMappingURL=SegmentsGetter.js.map


/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _SegmentsUtils = __webpack_require__(321);

function TemplateSegmentsGetter(config, isDynamic) {

    var timelineConverter = config.timelineConverter;

    var instance = undefined;

    function getSegmentsFromTemplate(representation, requestedTime, index, availabilityUpperLimit) {
        var template = representation.adaptation.period.mpd.manifest.Period_asArray[representation.adaptation.period.index].AdaptationSet_asArray[representation.adaptation.index].Representation_asArray[representation.index].SegmentTemplate;
        var duration = representation.segmentDuration;
        var availabilityWindow = representation.segmentAvailabilityRange;

        var segments = [];
        var url = null;
        var seg = null;

        var segmentRange, periodSegIdx, startIdx, endIdx, start;

        start = representation.startNumber;

        if (isNaN(duration) && !isDynamic) {
            segmentRange = { start: start, end: start };
        } else {
            segmentRange = (0, _SegmentsUtils.decideSegmentListRangeForTemplate)(timelineConverter, isDynamic, representation, requestedTime, index, availabilityUpperLimit);
        }

        startIdx = segmentRange.start;
        endIdx = segmentRange.end;

        for (periodSegIdx = startIdx; periodSegIdx <= endIdx; periodSegIdx++) {

            seg = (0, _SegmentsUtils.getIndexBasedSegment)(timelineConverter, isDynamic, representation, periodSegIdx);
            seg.replacementTime = (start + periodSegIdx - 1) * representation.segmentDuration;
            url = template.media;
            url = (0, _SegmentsUtils.replaceTokenForTemplate)(url, 'Number', seg.replacementNumber);
            url = (0, _SegmentsUtils.replaceTokenForTemplate)(url, 'Time', seg.replacementTime);
            seg.media = url;

            segments.push(seg);
            seg = null;
        }

        if (isNaN(duration)) {
            representation.availableSegmentsNumber = 1;
        } else {
            representation.availableSegmentsNumber = Math.ceil((availabilityWindow.end - availabilityWindow.start) / duration);
        }

        return segments;
    }

    instance = {
        getSegments: getSegmentsFromTemplate
    };

    return instance;
}

TemplateSegmentsGetter.__dashjs_factory_name = 'TemplateSegmentsGetter';
var factory = _coreFactoryMaker2['default'].getClassFactory(TemplateSegmentsGetter);
exports['default'] = factory;
module.exports = exports['default'];
//# sourceMappingURL=TemplateSegmentsGetter.js.map


/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _SegmentsUtils = __webpack_require__(321);

function TimelineSegmentsGetter(config, isDynamic) {

    var timelineConverter = config.timelineConverter;

    var instance = undefined;

    function getSegmentsFromTimeline(representation, requestedTime, index, availabilityUpperLimit) {
        var base = representation.adaptation.period.mpd.manifest.Period_asArray[representation.adaptation.period.index].AdaptationSet_asArray[representation.adaptation.index].Representation_asArray[representation.index].SegmentTemplate || representation.adaptation.period.mpd.manifest.Period_asArray[representation.adaptation.period.index].AdaptationSet_asArray[representation.adaptation.index].Representation_asArray[representation.index].SegmentList;
        var timeline = base.SegmentTimeline;
        var list = base.SegmentURL_asArray;
        var isAvailableSegmentNumberCalculated = representation.availableSegmentsNumber > 0;

        var maxSegmentsAhead = 10;
        var time = 0;
        var scaledTime = 0;
        var availabilityIdx = -1;
        var segments = [];
        var isStartSegmentForRequestedTimeFound = false;

        var fragments, frag, i, len, j, repeat, repeatEndTime, nextFrag, calculatedRange, hasEnoughSegments, requiredMediaTime, startIdx, endIdx, fTimescale;

        var createSegment = function createSegment(s, i) {
            var media = base.media;
            var mediaRange = s.mediaRange;

            if (list) {
                media = list[i].media || '';
                mediaRange = list[i].mediaRange;
            }

            return (0, _SegmentsUtils.getTimeBasedSegment)(timelineConverter, isDynamic, representation, time, s.d, fTimescale, media, mediaRange, availabilityIdx);
        };

        fTimescale = representation.timescale;

        fragments = timeline.S_asArray;

        calculatedRange = (0, _SegmentsUtils.decideSegmentListRangeForTimeline)(timelineConverter, isDynamic, requestedTime, index, availabilityUpperLimit);

        // if calculatedRange exists we should generate segments that belong to this range.
        // Otherwise generate maxSegmentsAhead segments ahead of the requested time
        if (calculatedRange) {
            startIdx = calculatedRange.start;
            endIdx = calculatedRange.end;
        } else {
            requiredMediaTime = timelineConverter.calcMediaTimeFromPresentationTime(requestedTime || 0, representation);
        }

        for (i = 0, len = fragments.length; i < len; i++) {
            frag = fragments[i];
            repeat = 0;
            if (frag.hasOwnProperty('r')) {
                repeat = frag.r;
            }

            //For a repeated S element, t belongs only to the first segment
            if (frag.hasOwnProperty('t')) {
                time = frag.t;
                scaledTime = time / fTimescale;
            }

            //This is a special case: "A negative value of the @r attribute of the S element indicates that the duration indicated in @d attribute repeats until the start of the next S element, the end of the Period or until the
            // next MPD update."
            if (repeat < 0) {
                nextFrag = fragments[i + 1];

                if (nextFrag && nextFrag.hasOwnProperty('t')) {
                    repeatEndTime = nextFrag.t / fTimescale;
                } else {
                    var availabilityEnd = representation.segmentAvailabilityRange ? representation.segmentAvailabilityRange.end : timelineConverter.calcSegmentAvailabilityRange(representation, isDynamic).end;
                    repeatEndTime = timelineConverter.calcMediaTimeFromPresentationTime(availabilityEnd, representation);
                    representation.segmentDuration = frag.d / fTimescale;
                }

                repeat = Math.ceil((repeatEndTime - scaledTime) / (frag.d / fTimescale)) - 1;
            }

            // if we have enough segments in the list, but we have not calculated the total number of the segments yet we
            // should continue the loop and calc the number. Once it is calculated, we can break the loop.
            if (hasEnoughSegments) {
                if (isAvailableSegmentNumberCalculated) break;
                availabilityIdx += repeat + 1;
                continue;
            }

            for (j = 0; j <= repeat; j++) {
                availabilityIdx++;

                if (calculatedRange) {
                    if (availabilityIdx > endIdx) {
                        hasEnoughSegments = true;
                        if (isAvailableSegmentNumberCalculated) break;
                        continue;
                    }

                    if (availabilityIdx >= startIdx) {
                        segments.push(createSegment(frag, availabilityIdx));
                    }
                } else {
                    if (segments.length > maxSegmentsAhead) {
                        hasEnoughSegments = true;
                        if (isAvailableSegmentNumberCalculated) break;
                        continue;
                    }

                    // In some cases when requiredMediaTime = actual end time of the last segment
                    // it is possible that this time a bit exceeds the declared end time of the last segment.
                    // in this case we still need to include the last segment in the segment list. to do this we
                    // use a correction factor = 1.5. This number is used because the largest possible deviation is
                    // is 50% of segment duration.
                    if (isStartSegmentForRequestedTimeFound) {
                        segments.push(createSegment(frag, availabilityIdx));
                    } else if (scaledTime >= requiredMediaTime - frag.d / fTimescale * 1.5) {
                        isStartSegmentForRequestedTimeFound = true;
                        segments.push(createSegment(frag, availabilityIdx));
                    }
                }

                time += frag.d;
                scaledTime = time / fTimescale;
            }
        }

        if (!isAvailableSegmentNumberCalculated) {
            representation.availableSegmentsNumber = availabilityIdx + 1;
        }

        return segments;
    }

    instance = {
        getSegments: getSegmentsFromTimeline
    };

    return instance;
}

TimelineSegmentsGetter.__dashjs_factory_name = 'TimelineSegmentsGetter';
var factory = _coreFactoryMaker2['default'].getClassFactory(TimelineSegmentsGetter);
exports['default'] = factory;
module.exports = exports['default'];
//# sourceMappingURL=TimelineSegmentsGetter.js.map


/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @class
 * @ignore
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AdaptationSet = function AdaptationSet() {
  _classCallCheck(this, AdaptationSet);

  this.period = null;
  this.index = -1;
  this.type = null;
};

exports["default"] = AdaptationSet;
module.exports = exports["default"];
//# sourceMappingURL=AdaptationSet.js.map


/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @class
 * @ignore
 */


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var EventStream = function EventStream() {
  _classCallCheck(this, EventStream);

  this.adaptionSet = null;
  this.representation = null;
  this.period = null;
  this.timescale = 1;
  this.value = '';
  this.schemeIdUri = '';
};

exports['default'] = EventStream;
module.exports = exports['default'];
//# sourceMappingURL=EventStream.js.map


/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @class
 * @ignore
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Mpd = function Mpd() {
  _classCallCheck(this, Mpd);

  this.manifest = null;
  this.suggestedPresentationDelay = 0;
  this.availabilityStartTime = null;
  this.availabilityEndTime = Number.POSITIVE_INFINITY;
  this.timeShiftBufferDepth = Number.POSITIVE_INFINITY;
  this.maxSegmentDuration = Number.POSITIVE_INFINITY;
  this.minimumUpdatePeriod = NaN;
  this.mediaPresentationDuration = NaN;
};

exports["default"] = Mpd;
module.exports = exports["default"];
//# sourceMappingURL=Mpd.js.map


/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @class
 * @ignore
 */


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var Period = function Period() {
  _classCallCheck(this, Period);

  this.id = null;
  this.index = -1;
  this.duration = NaN;
  this.start = NaN;
  this.mpd = null;
};

Period.DEFAULT_ID = 'defaultId';

exports['default'] = Period;
module.exports = exports['default'];
//# sourceMappingURL=Period.js.map


/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _XHRLoader = __webpack_require__(239);

var _XHRLoader2 = _interopRequireDefault(_XHRLoader);

var _voHeadRequest = __webpack_require__(1419);

var _voHeadRequest2 = _interopRequireDefault(_voHeadRequest);

var _voError = __webpack_require__(111);

var _voError2 = _interopRequireDefault(_voError);

var _coreEventBus = __webpack_require__(27);

var _coreEventBus2 = _interopRequireDefault(_coreEventBus);

var _coreEventsEvents = __webpack_require__(22);

var _coreEventsEvents2 = _interopRequireDefault(_coreEventsEvents);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var FRAGMENT_LOADER_ERROR_LOADING_FAILURE = 1;
var FRAGMENT_LOADER_ERROR_NULL_REQUEST = 2;
var FRAGMENT_LOADER_MESSAGE_NULL_REQUEST = 'request is null';

function FragmentLoader(config) {

    var context = this.context;
    var eventBus = (0, _coreEventBus2['default'])(context).getInstance();

    var instance = undefined,
        xhrLoader = undefined;

    function setup() {
        xhrLoader = (0, _XHRLoader2['default'])(context).create({
            errHandler: config.errHandler,
            metricsModel: config.metricsModel,
            requestModifier: config.requestModifier
        });
    }

    function checkForExistence(request) {
        var report = function report(success) {
            eventBus.trigger(_coreEventsEvents2['default'].CHECK_FOR_EXISTENCE_COMPLETED, {
                request: request,
                exists: success
            });
        };

        if (request) {
            var headRequest = new _voHeadRequest2['default'](request.url);

            xhrLoader.load({
                request: headRequest,
                success: function success() {
                    report(true);
                },
                error: function error() {
                    report(false);
                }
            });
        } else {
            report(false);
        }
    }

    function load(request) {
        var report = function report(data, error) {
            eventBus.trigger(_coreEventsEvents2['default'].LOADING_COMPLETED, {
                request: request,
                response: data || null,
                error: error || null,
                sender: instance
            });
        };

        if (request) {
            xhrLoader.load({
                request: request,
                progress: function progress() {
                    eventBus.trigger(_coreEventsEvents2['default'].LOADING_PROGRESS, {
                        request: request
                    });
                },
                success: function success(data) {
                    report(data);
                },
                error: function error(xhr, statusText, errorText) {
                    report(undefined, new _voError2['default'](FRAGMENT_LOADER_ERROR_LOADING_FAILURE, errorText, statusText));
                }
            });
        } else {
            report(undefined, new _voError2['default'](FRAGMENT_LOADER_ERROR_NULL_REQUEST, FRAGMENT_LOADER_MESSAGE_NULL_REQUEST));
        }
    }

    function abort() {
        if (xhrLoader) {
            xhrLoader.abort();
        }
    }

    function reset() {
        if (xhrLoader) {
            xhrLoader.abort();
            xhrLoader = null;
        }
    }

    instance = {
        checkForExistence: checkForExistence,
        load: load,
        abort: abort,
        reset: reset
    };

    setup();

    return instance;
}

FragmentLoader.__dashjs_factory_name = 'FragmentLoader';

var factory = _coreFactoryMaker2['default'].getClassFactory(FragmentLoader);
factory.FRAGMENT_LOADER_ERROR_LOADING_FAILURE = FRAGMENT_LOADER_ERROR_LOADING_FAILURE;
factory.FRAGMENT_LOADER_ERROR_NULL_REQUEST = FRAGMENT_LOADER_ERROR_NULL_REQUEST;
exports['default'] = factory;
module.exports = exports['default'];
//# sourceMappingURL=FragmentLoader.js.map


/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _controllersXlinkController = __webpack_require__(1358);

var _controllersXlinkController2 = _interopRequireDefault(_controllersXlinkController);

var _XHRLoader = __webpack_require__(239);

var _XHRLoader2 = _interopRequireDefault(_XHRLoader);

var _utilsURLUtils = __webpack_require__(242);

var _utilsURLUtils2 = _interopRequireDefault(_utilsURLUtils);

var _utilsErrorHandler = __webpack_require__(136);

var _utilsErrorHandler2 = _interopRequireDefault(_utilsErrorHandler);

var _voTextRequest = __webpack_require__(599);

var _voTextRequest2 = _interopRequireDefault(_voTextRequest);

var _voError = __webpack_require__(111);

var _voError2 = _interopRequireDefault(_voError);

var _voMetricsHTTPRequest = __webpack_require__(84);

var _coreEventBus = __webpack_require__(27);

var _coreEventBus2 = _interopRequireDefault(_coreEventBus);

var _coreEventsEvents = __webpack_require__(22);

var _coreEventsEvents2 = _interopRequireDefault(_coreEventsEvents);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _dashParserDashParser = __webpack_require__(1327);

var _dashParserDashParser2 = _interopRequireDefault(_dashParserDashParser);

var MANIFEST_LOADER_ERROR_PARSING_FAILURE = 1;
var MANIFEST_LOADER_ERROR_LOADING_FAILURE = 2;
var MANIFEST_LOADER_MESSAGE_PARSING_FAILURE = 'parsing failed';

function ManifestLoader(config) {

    var context = this.context;
    var eventBus = (0, _coreEventBus2['default'])(context).getInstance();
    var urlUtils = (0, _utilsURLUtils2['default'])(context).getInstance();
    var errorHandler = (0, _utilsErrorHandler2['default'])(context).getInstance();

    var instance = undefined,
        xhrLoader = undefined,
        xlinkController = undefined,
        parser = undefined;
    var mssHandler = config.mssHandler;

    function setup() {
        eventBus.on(_coreEventsEvents2['default'].XLINK_READY, onXlinkReady, instance);

        xhrLoader = (0, _XHRLoader2['default'])(context).create({
            errHandler: config.errHandler,
            metricsModel: config.metricsModel,
            requestModifier: config.requestModifier
        });

        xlinkController = (0, _controllersXlinkController2['default'])(context).create({
            errHandler: config.errHandler,
            metricsModel: config.metricsModel,
            requestModifier: config.requestModifier
        });

        parser = null;
    }

    function onXlinkReady(event) {
        eventBus.trigger(_coreEventsEvents2['default'].INTERNAL_MANIFEST_LOADED, {
            manifest: event.manifest
        });
    }

    function createParser(data) {
        var parser = null;
        // Analyze manifest content to detect protocol and select appropriate parser
        if (data.indexOf('SmoothStreamingMedia') > -1) {
            //do some business to transform it into a Dash Manifest
            if (mssHandler) {
                parser = mssHandler.createMssParser();
                mssHandler.registerEvents();
            } else {
                errorHandler.manifestError('manifest type unsupported', 'createParser');
            }
            return parser;
        } else if (data.indexOf('MPD') > -1) {
            return (0, _dashParserDashParser2['default'])(context).create();
        } else {
            return parser;
        }
    }

    function load(url) {
        var request = new _voTextRequest2['default'](url, _voMetricsHTTPRequest.HTTPRequest.MPD_TYPE);

        xhrLoader.load({
            request: request,
            success: function success(data, textStatus, xhr) {
                var actualUrl;
                var baseUri;

                // Handle redirects for the MPD - as per RFC3986 Section 5.1.3
                // also handily resolves relative MPD URLs to absolute
                if (xhr.responseURL && xhr.responseURL !== url) {
                    baseUri = urlUtils.parseBaseUrl(xhr.responseURL);
                    actualUrl = xhr.responseURL;
                } else {
                    // usually this case will be caught and resolved by
                    // xhr.responseURL above but it is not available for IE11
                    // baseUri must be absolute for BaseURL resolution later
                    if (urlUtils.isRelative(url)) {
                        url = urlUtils.resolve(url, window.location.href);
                    }

                    baseUri = urlUtils.parseBaseUrl(url);
                }

                // Create parser according to manifest type
                if (parser === null) {
                    parser = createParser(data);
                }

                if (parser === null) {
                    eventBus.trigger(_coreEventsEvents2['default'].INTERNAL_MANIFEST_LOADED, {
                        manifest: null,
                        error: new _voError2['default'](MANIFEST_LOADER_ERROR_PARSING_FAILURE, 'Failed detecting manifest type: ' + url)
                    });
                    return;
                }

                var manifest = parser.parse(data, xlinkController);

                if (manifest) {
                    manifest.url = actualUrl || url;

                    // URL from which the MPD was originally retrieved (MPD updates will not change this value)
                    if (!manifest.originalUrl) {
                        manifest.originalUrl = manifest.url;
                    }

                    manifest.baseUri = baseUri;
                    manifest.loadedTime = new Date();
                    xlinkController.resolveManifestOnLoad(manifest);
                } else {
                    eventBus.trigger(_coreEventsEvents2['default'].INTERNAL_MANIFEST_LOADED, {
                        manifest: null,
                        error: new _voError2['default'](MANIFEST_LOADER_ERROR_PARSING_FAILURE, MANIFEST_LOADER_MESSAGE_PARSING_FAILURE)
                    });
                }
            },
            error: function error(xhr, statusText, errorText) {
                eventBus.trigger(_coreEventsEvents2['default'].INTERNAL_MANIFEST_LOADED, {
                    manifest: null,
                    error: new _voError2['default'](MANIFEST_LOADER_ERROR_LOADING_FAILURE, 'Failed loading manifest: ' + url + ', ' + errorText)
                });
            }
        });
    }

    function reset() {
        eventBus.off(_coreEventsEvents2['default'].XLINK_READY, onXlinkReady, instance);

        if (xlinkController) {
            xlinkController.reset();
            xlinkController = null;
        }

        if (xhrLoader) {
            xhrLoader.abort();
            xhrLoader = null;
        }

        if (mssHandler) {
            mssHandler.reset();
        }
    }

    instance = {
        load: load,
        reset: reset
    };

    setup();

    return instance;
}

ManifestLoader.__dashjs_factory_name = 'ManifestLoader';

var factory = _coreFactoryMaker2['default'].getClassFactory(ManifestLoader);
factory.MANIFEST_LOADER_ERROR_PARSING_FAILURE = MANIFEST_LOADER_ERROR_PARSING_FAILURE;
factory.MANIFEST_LOADER_ERROR_LOADING_FAILURE = MANIFEST_LOADER_ERROR_LOADING_FAILURE;
exports['default'] = factory;
module.exports = exports['default'];
//# sourceMappingURL=ManifestLoader.js.map


/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreEventBus = __webpack_require__(27);

var _coreEventBus2 = _interopRequireDefault(_coreEventBus);

var _coreEventsEvents = __webpack_require__(22);

var _coreEventsEvents2 = _interopRequireDefault(_coreEventsEvents);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _modelsMediaPlayerModel = __webpack_require__(67);

var _modelsMediaPlayerModel2 = _interopRequireDefault(_modelsMediaPlayerModel);

var _coreDebug = __webpack_require__(30);

var _coreDebug2 = _interopRequireDefault(_coreDebug);

function ManifestUpdater() {

    var context = this.context;
    var log = (0, _coreDebug2['default'])(context).getInstance().log;
    var eventBus = (0, _coreEventBus2['default'])(context).getInstance();

    var instance = undefined,
        refreshDelay = undefined,
        refreshTimer = undefined,
        isPaused = undefined,
        isUpdating = undefined,
        manifestLoader = undefined,
        manifestModel = undefined,
        dashManifestModel = undefined,
        mediaPlayerModel = undefined;

    function setConfig(config) {
        if (!config) return;

        if (config.manifestModel) {
            manifestModel = config.manifestModel;
        }
        if (config.dashManifestModel) {
            dashManifestModel = config.dashManifestModel;
        }
    }

    function initialize(loader) {
        manifestLoader = loader;
        refreshDelay = NaN;
        refreshTimer = null;
        isUpdating = false;
        isPaused = true;
        mediaPlayerModel = (0, _modelsMediaPlayerModel2['default'])(context).getInstance();

        eventBus.on(_coreEventsEvents2['default'].STREAMS_COMPOSED, onStreamsComposed, this);
        eventBus.on(_coreEventsEvents2['default'].PLAYBACK_STARTED, onPlaybackStarted, this);
        eventBus.on(_coreEventsEvents2['default'].PLAYBACK_PAUSED, onPlaybackPaused, this);
        eventBus.on(_coreEventsEvents2['default'].INTERNAL_MANIFEST_LOADED, onManifestLoaded, this);
    }

    function setManifest(manifest) {
        update(manifest);
    }

    function getManifestLoader() {
        return manifestLoader;
    }

    function reset() {

        eventBus.off(_coreEventsEvents2['default'].PLAYBACK_STARTED, onPlaybackStarted, this);
        eventBus.off(_coreEventsEvents2['default'].PLAYBACK_PAUSED, onPlaybackPaused, this);
        eventBus.off(_coreEventsEvents2['default'].STREAMS_COMPOSED, onStreamsComposed, this);
        eventBus.off(_coreEventsEvents2['default'].INTERNAL_MANIFEST_LOADED, onManifestLoaded, this);
        stopManifestRefreshTimer();
        isPaused = true;
        isUpdating = false;
        refreshDelay = NaN;
        mediaPlayerModel = null;
    }

    function stopManifestRefreshTimer() {
        if (refreshTimer !== null) {
            clearInterval(refreshTimer);
            refreshTimer = null;
        }
    }

    function startManifestRefreshTimer() {
        stopManifestRefreshTimer();
        if (!isNaN(refreshDelay)) {
            log('Refresh manifest in ' + refreshDelay + ' seconds.');
            refreshTimer = setTimeout(onRefreshTimer, refreshDelay * 1000);
        }
    }

    function refreshManifest() {
        isUpdating = true;
        var manifest = manifestModel.getValue();
        var url = manifest.url;
        var location = dashManifestModel.getLocation(manifest);
        if (location) {
            url = location;
        }
        manifestLoader.load(url);
    }

    function update(manifest) {

        manifestModel.setValue(manifest);

        var date = new Date();
        var latencyOfLastUpdate = (date.getTime() - manifest.loadedTime.getTime()) / 1000;
        refreshDelay = dashManifestModel.getManifestUpdatePeriod(manifest, latencyOfLastUpdate);

        eventBus.trigger(_coreEventsEvents2['default'].MANIFEST_UPDATED, { manifest: manifest });
        log('Manifest has been refreshed at ' + date + '[' + date.getTime() / 1000 + '] ');

        if (!isPaused) {
            startManifestRefreshTimer();
        }
    }

    function onRefreshTimer() {
        if (isPaused && !mediaPlayerModel.getScheduleWhilePaused() || isUpdating) return;
        refreshManifest();
    }

    function onManifestLoaded(e) {
        if (!e.error) {
            update(e.manifest);
        }
    }

    function onPlaybackStarted() /*e*/{
        isPaused = false;
        startManifestRefreshTimer();
    }

    function onPlaybackPaused() /*e*/{
        isPaused = true;
        stopManifestRefreshTimer();
    }

    function onStreamsComposed() /*e*/{
        // When streams are ready we can consider manifest update completed. Resolve the update promise.
        isUpdating = false;
    }

    instance = {
        initialize: initialize,
        setManifest: setManifest,
        getManifestLoader: getManifestLoader,
        refreshManifest: refreshManifest,
        setConfig: setConfig,
        reset: reset
    };

    return instance;
}
ManifestUpdater.__dashjs_factory_name = 'ManifestUpdater';
exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(ManifestUpdater);
module.exports = exports['default'];
//# sourceMappingURL=ManifestUpdater.js.map


/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _MediaPlayer = __webpack_require__(590);

var _MediaPlayer2 = _interopRequireDefault(_MediaPlayer);

function MediaPlayerFactory() {

    /**
     * mime-type identifier for any source content to be accepted as a dash manifest by the create() method.
     * @type {string}
     */
    var SUPPORTED_MIME_TYPE = 'application/dash+xml';

    /**
     *  A new MediaPlayer is instantiated for the supplied videoElement and optional source and context.  If no context is provided,
     *  a default DashContext is used. If no source is provided, the videoElement is interrogated to extract the first source whose
     *  type is application/dash+xml.
     * The autoplay property of the videoElement is preserved. Any preload attribute is ignored. This method should be called after the page onLoad event is dispatched.
     * @param {HTMLMediaElement} video
     * @param {HTMLSourceElement} source
     * @param {Object} context
     * @returns {MediaPlayer|null}
     */
    function create(video, source, context) {
        if (!video || video.nodeName !== 'VIDEO') return null;

        if (video._dashjs_player) return video._dashjs_player;

        var player;
        var videoID = video.id || video.name || 'video element';

        source = source || [].slice.call(video.querySelectorAll('source')).filter(function (s) {
            return s.type == SUPPORTED_MIME_TYPE;
        })[0];
        if (!source && video.src) {
            source = document.createElement('source');
            source.src = video.src;
        } else if (!source && !video.src) {
            return null;
        }

        context = context || {};
        player = (0, _MediaPlayer2['default'])(context).create();
        player.initialize(video, source.src, video.autoplay);
        player.getDebug().log('Converted ' + videoID + ' to dash.js player and added content: ' + source.src);

        // Store a reference to the player on the video element so it can be gotten at for debugging and so we know its
        // already been setup.
        video._dashjs_player = player;

        return player;
    }

    /**
     * Searches the provided scope for all instances of the indicated selector. If no scope is provided, document is used. If no selector is
     * specified, [data-dashjs-player] is used. The declarative setup also looks for source elements with the type attribute set to 'application/dash+xml'.
     * It then looks for those video elements which have a source element defined with a type matching 'application/dash+xml'.
     * A new MediaPlayer is instantiated for each matching video element and the appropriate source is assigned.
     * The autoplay property of the video element is preserved. Any preload attribute is ignored. This method should be called after the page onLoad event is dispatched.
     * Returns an array holding all the MediaPlayer instances that were added by this method.
     * @param {string} selector - CSS selector
     * @param {Object} scope
     * @returns {Array} an array of MediaPlayer objects
     */
    function createAll(selector, scope) {
        var aPlayers = [];
        selector = selector || '[data-dashjs-player]';
        scope = scope || document;
        var videos = scope.querySelectorAll(selector);
        for (var i = 0; i < videos.length; i++) {
            var player = create(videos[i], null);
            aPlayers.push(player);
        }

        var sources = scope.querySelectorAll('source[type="' + SUPPORTED_MIME_TYPE + '"]');
        for (var i = 0; i < sources.length; i++) {
            var video = findVideo(sources[i]);
            var player = create(video, null);
            aPlayers.push(player);
        }

        return aPlayers;
    }

    function findVideo(_x) {
        var _again = true;

        _function: while (_again) {
            var el = _x;
            _again = false;

            if (el.nodeName.toLowerCase() === 'video') {
                return el;
            } else {
                _x = el.parentNode;
                _again = true;
                continue _function;
            }
        }
    }

    return {
        create: create,
        createAll: createAll
    };
}

var instance = MediaPlayerFactory();
var loadInterval = undefined;

function loadHandler() {
    window.removeEventListener('load', loadHandler);
    instance.createAll();
}

function loadIntervalHandler() {
    if (window.dashjs) {
        window.clearInterval(loadInterval);
        instance.createAll();
    }
}

var avoidAutoCreate = typeof window !== 'undefined' && window && window.dashjs && window.dashjs.skipAutoCreate;

if (!avoidAutoCreate && typeof window !== 'undefined' && window && window.addEventListener) {
    if (window.document.readyState === 'complete') {
        if (window.dashjs) {
            instance.createAll();
        } else {
            // If loaded asynchronously, window.readyState may be 'complete' even if dashjs hasn't loaded yet
            loadInterval = window.setInterval(loadIntervalHandler, 500);
        }
    } else {
        window.addEventListener('load', loadHandler);
    }
}

exports['default'] = instance;
module.exports = exports['default'];
//# sourceMappingURL=MediaPlayerFactory.js.map


/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _utilsLiveEdgeFinder = __webpack_require__(409);

var _utilsLiveEdgeFinder2 = _interopRequireDefault(_utilsLiveEdgeFinder);

var _StreamProcessor = __webpack_require__(1349);

var _StreamProcessor2 = _interopRequireDefault(_StreamProcessor);

var _controllersMediaController = __webpack_require__(188);

var _controllersMediaController2 = _interopRequireDefault(_controllersMediaController);

var _controllersEventController = __webpack_require__(1353);

var _controllersEventController2 = _interopRequireDefault(_controllersEventController);

var _controllersFragmentController = __webpack_require__(1354);

var _controllersFragmentController2 = _interopRequireDefault(_controllersFragmentController);

var _controllersAbrController = __webpack_require__(159);

var _controllersAbrController2 = _interopRequireDefault(_controllersAbrController);

var _modelsVideoModel = __webpack_require__(240);

var _modelsVideoModel2 = _interopRequireDefault(_modelsVideoModel);

var _modelsMetricsModel = __webpack_require__(135);

var _modelsMetricsModel2 = _interopRequireDefault(_modelsMetricsModel);

var _controllersPlaybackController = __webpack_require__(161);

var _controllersPlaybackController2 = _interopRequireDefault(_controllersPlaybackController);

var _dashDashHandler = __webpack_require__(1323);

var _dashDashHandler2 = _interopRequireDefault(_dashDashHandler);

var _dashSegmentBaseLoader = __webpack_require__(1324);

var _dashSegmentBaseLoader2 = _interopRequireDefault(_dashSegmentBaseLoader);

var _dashWebmSegmentBaseLoader = __webpack_require__(1325);

var _dashWebmSegmentBaseLoader2 = _interopRequireDefault(_dashWebmSegmentBaseLoader);

var _dashDashMetrics = __webpack_require__(157);

var _dashDashMetrics2 = _interopRequireDefault(_dashDashMetrics);

var _coreEventBus = __webpack_require__(27);

var _coreEventBus2 = _interopRequireDefault(_coreEventBus);

var _coreEventsEvents = __webpack_require__(22);

var _coreEventsEvents2 = _interopRequireDefault(_coreEventsEvents);

var _coreDebug = __webpack_require__(30);

var _coreDebug2 = _interopRequireDefault(_coreDebug);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _textTextController = __webpack_require__(189);

var _textTextController2 = _interopRequireDefault(_textTextController);

function Stream(config) {

    var DATA_UPDATE_FAILED_ERROR_CODE = 1;

    var context = this.context;
    var log = (0, _coreDebug2['default'])(context).getInstance().log;
    var eventBus = (0, _coreEventBus2['default'])(context).getInstance();

    var manifestModel = config.manifestModel;
    var manifestUpdater = config.manifestUpdater;
    var adapter = config.adapter;
    var capabilities = config.capabilities;
    var errHandler = config.errHandler;
    var timelineConverter = config.timelineConverter;
    var baseURLController = config.baseURLController;

    var instance = undefined,
        streamProcessors = undefined,
        isStreamActivated = undefined,
        isMediaInitialized = undefined,
        streamInfo = undefined,
        updateError = undefined,
        isUpdating = undefined,
        initialized = undefined,
        protectionController = undefined,
        liveEdgeFinder = undefined,
        playbackController = undefined,
        mediaController = undefined,
        fragmentController = undefined,
        eventController = undefined,
        abrController = undefined,
        textController = undefined;

    function setup() {
        streamProcessors = [];
        isStreamActivated = false;
        isMediaInitialized = false;
        streamInfo = null;
        updateError = {};
        isUpdating = false;
        initialized = false;

        liveEdgeFinder = (0, _utilsLiveEdgeFinder2['default'])(context).getInstance();
        playbackController = (0, _controllersPlaybackController2['default'])(context).getInstance();
        abrController = (0, _controllersAbrController2['default'])(context).getInstance();
        mediaController = (0, _controllersMediaController2['default'])(context).getInstance();
        fragmentController = (0, _controllersFragmentController2['default'])(context).create();
        textController = (0, _textTextController2['default'])(context).getInstance();

        eventBus.on(_coreEventsEvents2['default'].BUFFERING_COMPLETED, onBufferingCompleted, instance);
        eventBus.on(_coreEventsEvents2['default'].DATA_UPDATE_COMPLETED, onDataUpdateCompleted, instance);
    }

    function initialize(StreamInfo, ProtectionController) {
        streamInfo = StreamInfo;
        protectionController = ProtectionController;
        if (protectionController) {
            eventBus.on(_coreEventsEvents2['default'].KEY_ERROR, onProtectionError, instance);
            eventBus.on(_coreEventsEvents2['default'].SERVER_CERTIFICATE_UPDATED, onProtectionError, instance);
            eventBus.on(_coreEventsEvents2['default'].LICENSE_REQUEST_COMPLETE, onProtectionError, instance);
            eventBus.on(_coreEventsEvents2['default'].KEY_SYSTEM_SELECTED, onProtectionError, instance);
            eventBus.on(_coreEventsEvents2['default'].KEY_SESSION_CREATED, onProtectionError, instance);
        }
    }

    /**
     * Activates Stream by re-initializing some of its components
     * @param {MediaSource} mediaSource
     * @memberof Stream#
     */
    function activate(mediaSource) {
        if (!isStreamActivated) {
            eventBus.on(_coreEventsEvents2['default'].CURRENT_TRACK_CHANGED, onCurrentTrackChanged, instance);
            initializeMedia(mediaSource);
            isStreamActivated = true;
        }
        //else { // TODO Check track change mode but why is this here. commented it out for now to check.
        //    createBuffers();
        //}
    }

    /**
     * Partially resets some of the Stream elements
     * @memberof Stream#
     */
    function deactivate() {
        var ln = streamProcessors.length;
        for (var i = 0; i < ln; i++) {
            streamProcessors[i].reset();
        }
        streamProcessors = [];
        isStreamActivated = false;
        isMediaInitialized = false;
        clearEventController();
        eventBus.off(_coreEventsEvents2['default'].CURRENT_TRACK_CHANGED, onCurrentTrackChanged, instance);
    }

    function reset() {

        if (playbackController) {
            playbackController.pause();
            playbackController = null;
        }

        if (fragmentController) {
            fragmentController.reset();
            fragmentController = null;
        }

        deactivate();
        mediaController = null;
        abrController = null;
        manifestUpdater = null;
        manifestModel = null;
        adapter = null;
        capabilities = null;
        log = null;
        errHandler = null;
        isUpdating = false;
        initialized = false;
        updateError = {};

        eventBus.off(_coreEventsEvents2['default'].DATA_UPDATE_COMPLETED, onDataUpdateCompleted, instance);
        eventBus.off(_coreEventsEvents2['default'].BUFFERING_COMPLETED, onBufferingCompleted, instance);
        eventBus.off(_coreEventsEvents2['default'].KEY_ERROR, onProtectionError, instance);
        eventBus.off(_coreEventsEvents2['default'].SERVER_CERTIFICATE_UPDATED, onProtectionError, instance);
        eventBus.off(_coreEventsEvents2['default'].LICENSE_REQUEST_COMPLETE, onProtectionError, instance);
        eventBus.off(_coreEventsEvents2['default'].KEY_SYSTEM_SELECTED, onProtectionError, instance);
        eventBus.off(_coreEventsEvents2['default'].KEY_SESSION_CREATED, onProtectionError, instance);
    }

    function getDuration() {
        return streamInfo.duration;
    }

    function getStartTime() {
        return streamInfo.start;
    }

    function getStreamIndex() {
        return streamInfo.index;
    }

    function getId() {
        return streamInfo.id;
    }

    function getStreamInfo() {
        return streamInfo;
    }

    function hasMedia(type) {
        return getMediaInfo(type) !== null;
    }

    /**
     * @param {string} type
     * @returns {Array}
     * @memberof Stream#
     */
    function getBitrateListFor(type) {
        var mediaInfo = getMediaInfo(type);
        return abrController.getBitrateList(mediaInfo);
    }

    function startEventController() {
        if (eventController) {
            eventController.start();
        }
    }

    function clearEventController() {
        if (eventController) {
            eventController.clear();
        }
    }

    function isActivated() {
        return isStreamActivated;
    }

    function isInitialized() {
        return initialized;
    }

    function onProtectionError(event) {
        if (event.error) {
            errHandler.mediaKeySessionError(event.error);
            log(event.error);
            reset();
        }
    }

    function getMimeTypeOrType(mediaInfo) {
        return mediaInfo.type === 'text' ? mediaInfo.mimeType : mediaInfo.type;
    }

    function isMediaSupported(mediaInfo, mediaSource, manifest) {
        var type = mediaInfo.type;
        var codec, msg;

        if (type === 'muxed' && mediaInfo) {
            msg = 'Multiplexed representations are intentionally not supported, as they are not compliant with the DASH-AVC/264 guidelines';
            log(msg);
            errHandler.manifestError(msg, 'multiplexedrep', manifestModel.getValue());
            return false;
        }

        if (type === 'text' || type === 'fragmentedText' || type === 'embeddedText') return true;

        codec = mediaInfo.codec;
        log(type + ' codec: ' + codec);

        if (!!mediaInfo.contentProtection && !capabilities.supportsEncryptedMedia()) {
            errHandler.capabilityError('encryptedmedia');
        } else if (!capabilities.supportsCodec((0, _modelsVideoModel2['default'])(context).getInstance().getElement(), codec)) {
            msg = type + 'Codec (' + codec + ') is not supported.';
            errHandler.manifestError(msg, 'codec', manifest);
            log(msg);
            return false;
        }

        return true;
    }

    function onCurrentTrackChanged(e) {
        if (e.newMediaInfo.streamInfo.id !== streamInfo.id) return;

        var processor = getProcessorForMediaInfo(e.oldMediaInfo);
        if (!processor) return;

        var currentTime = playbackController.getTime();
        var buffer = processor.getBuffer();
        var mediaInfo = e.newMediaInfo;
        var manifest = manifestModel.getValue();
        var idx = streamProcessors.indexOf(processor);
        var mediaSource = processor.getMediaSource();

        if (mediaInfo.type !== 'fragmentedText') {
            processor.reset(true);
            createStreamProcessor(mediaInfo, manifest, mediaSource, { buffer: buffer, replaceIdx: idx, currentTime: currentTime });
            playbackController.seek(playbackController.getTime());
        } else {
            processor.updateMediaInfo(manifest, mediaInfo);
        }
    }

    function isWebM(mimeType) {
        var type = mimeType.split('/')[1];

        return 'webm' === type.toLowerCase();
    }

    function createIndexHandler(mediaInfo) {

        var segmentBaseLoader = isWebM(mediaInfo.mimeType) ? (0, _dashWebmSegmentBaseLoader2['default'])(context).getInstance() : (0, _dashSegmentBaseLoader2['default'])(context).getInstance();
        segmentBaseLoader.setConfig({
            baseURLController: baseURLController,
            metricsModel: (0, _modelsMetricsModel2['default'])(context).getInstance()
        });
        segmentBaseLoader.initialize();

        var handler = (0, _dashDashHandler2['default'])(context).create({
            segmentBaseLoader: segmentBaseLoader,
            timelineConverter: timelineConverter,
            dashMetrics: (0, _dashDashMetrics2['default'])(context).getInstance(),
            metricsModel: (0, _modelsMetricsModel2['default'])(context).getInstance(),
            baseURLController: baseURLController
        });

        return handler;
    }

    function createStreamProcessor(mediaInfo, manifest, mediaSource, optionalSettings) {
        var streamProcessor = (0, _StreamProcessor2['default'])(context).create({
            indexHandler: createIndexHandler(mediaInfo),
            timelineConverter: timelineConverter,
            adapter: adapter,
            manifestModel: manifestModel
        });

        var allMediaForType = adapter.getAllMediaInfoForType(manifest, streamInfo, mediaInfo.type);
        streamProcessor.initialize(getMimeTypeOrType(mediaInfo), fragmentController, mediaSource, instance, eventController);
        abrController.updateTopQualityIndex(mediaInfo);

        if (optionalSettings) {
            streamProcessor.setBuffer(optionalSettings.buffer);
            streamProcessor.getIndexHandler().setCurrentTime(optionalSettings.currentTime);
            streamProcessors[optionalSettings.replaceIdx] = streamProcessor;
        } else {
            streamProcessors.push(streamProcessor);
        }

        if (mediaInfo.type === 'text' || mediaInfo.type === 'fragmentedText') {
            var idx;
            for (var i = 0; i < allMediaForType.length; i++) {
                if (allMediaForType[i].index === mediaInfo.index) {
                    idx = i;
                }
                streamProcessor.updateMediaInfo(manifest, allMediaForType[i]); //creates text tracks for all adaptations in one stream processor
            }
            if (mediaInfo.type === 'fragmentedText') {
                streamProcessor.updateMediaInfo(manifest, allMediaForType[idx]); //sets the initial media info
            }
        } else {
                streamProcessor.updateMediaInfo(manifest, mediaInfo);
            }
    }

    function initializeMediaForType(type, mediaSource) {
        var manifest = manifestModel.getValue();
        var allMediaForType = adapter.getAllMediaInfoForType(manifest, streamInfo, type);

        var mediaInfo = null;
        var initialMediaInfo;

        if (!allMediaForType || allMediaForType.length === 0) {
            log('No ' + type + ' data.');
            return;
        }

        for (var i = 0, ln = allMediaForType.length; i < ln; i++) {
            mediaInfo = allMediaForType[i];

            if (type === 'embeddedText') {
                textController.addEmbeddedTrack(mediaInfo);
            } else {
                if (!isMediaSupported(mediaInfo, mediaSource, manifest)) continue;

                if (mediaController.isMultiTrackSupportedByType(mediaInfo.type)) {
                    mediaController.addTrack(mediaInfo, streamInfo);
                }
            }
        }

        if (type === 'embeddedText' || mediaController.getTracksFor(type, streamInfo).length === 0) {
            return;
        }

        mediaController.checkInitialMediaSettingsForType(type, streamInfo);
        initialMediaInfo = mediaController.getCurrentTrackFor(type, streamInfo);

        // TODO : How to tell index handler live/duration?
        // TODO : Pass to controller and then pass to each method on handler?

        createStreamProcessor(initialMediaInfo, manifest, mediaSource);
    }

    function initializeMedia(mediaSource) {
        var manifest = manifestModel.getValue();
        var events;

        eventController = (0, _controllersEventController2['default'])(context).getInstance();
        eventController.initialize();
        eventController.setConfig({
            manifestModel: manifestModel,
            manifestUpdater: manifestUpdater
        });
        events = adapter.getEventsFor(manifest, streamInfo);
        eventController.addInlineEvents(events);

        isUpdating = true;
        initializeMediaForType('video', mediaSource);
        initializeMediaForType('audio', mediaSource);
        initializeMediaForType('text', mediaSource);
        initializeMediaForType('fragmentedText', mediaSource);
        initializeMediaForType('embeddedText', mediaSource);
        initializeMediaForType('muxed', mediaSource);

        createBuffers();

        //TODO. Consider initialization of TextSourceBuffer here if embeddedText, but no sideloadedText.

        isMediaInitialized = true;
        isUpdating = false;

        if (streamProcessors.length === 0) {
            var msg = 'No streams to play.';
            errHandler.manifestError(msg, 'nostreams', manifest);
            log(msg);
        } else {
            liveEdgeFinder.initialize(timelineConverter, streamProcessors[0]);
            //log("Playback initialized!");
            checkIfInitializationCompleted();
        }
    }

    function checkIfInitializationCompleted() {
        var ln = streamProcessors.length;
        var hasError = !!updateError.audio || !!updateError.video;
        var error = hasError ? new Error(DATA_UPDATE_FAILED_ERROR_CODE, 'Data update failed', null) : null;
        var i = 0;

        for (i; i < ln; i++) {
            if (streamProcessors[i].isUpdating() || isUpdating) return;
        }

        initialized = true;
        if (!isMediaInitialized) return;
        if (protectionController) {
            protectionController.initialize(manifestModel.getValue(), getMediaInfo('audio'), getMediaInfo('video'));
        }
        eventBus.trigger(_coreEventsEvents2['default'].STREAM_INITIALIZED, { streamInfo: streamInfo, error: error });
    }

    function getMediaInfo(type) {
        var ln = streamProcessors.length;
        var mediaCtrl = null;

        for (var i = 0; i < ln; i++) {
            mediaCtrl = streamProcessors[i];

            if (mediaCtrl.getType() === type) return mediaCtrl.getMediaInfo();
        }

        return null;
    }

    function createBuffers() {
        for (var i = 0, ln = streamProcessors.length; i < ln; i++) {
            streamProcessors[i].createBuffer();
        }
    }

    function onBufferingCompleted(e) {
        if (e.streamInfo !== streamInfo) return;

        var processors = getProcessors();
        var ln = processors.length;
        var i = 0;

        // if there is at least one buffer controller that has not completed buffering yet do nothing
        for (i; i < ln; i++) {
            if (!processors[i].isBufferingCompleted()) return;
        }

        eventBus.trigger(_coreEventsEvents2['default'].STREAM_BUFFERING_COMPLETED, { streamInfo: streamInfo });
    }

    function onDataUpdateCompleted(e) {
        var sp = e.sender.getStreamProcessor();

        if (sp.getStreamInfo() !== streamInfo) return;

        updateError[sp.getType()] = e.error;
        checkIfInitializationCompleted();
    }

    function getProcessorForMediaInfo(mediaInfo) {
        if (!mediaInfo) return false;

        var processors = getProcessors();

        return processors.filter(function (processor) {
            return processor.getType() === mediaInfo.type;
        })[0];
    }

    function getProcessors() {
        var ln = streamProcessors.length;
        var arr = [];
        var i = 0;

        var type, controller;

        for (i; i < ln; i++) {
            controller = streamProcessors[i];
            type = controller.getType();

            if (type === 'audio' || type === 'video' || type === 'fragmentedText') {
                arr.push(controller);
            }
        }

        return arr;
    }

    function updateData(updatedStreamInfo) {

        log('Manifest updated... updating data system wide.');

        var manifest = manifestModel.getValue();

        isStreamActivated = false;
        isUpdating = true;
        initialized = false;
        streamInfo = updatedStreamInfo;

        if (eventController) {
            var events = adapter.getEventsFor(manifest, streamInfo);
            eventController.addInlineEvents(events);
        }

        for (var i = 0, ln = streamProcessors.length; i < ln; i++) {
            var streamProcessor = streamProcessors[i];
            var mediaInfo = adapter.getMediaInfoForType(manifest, streamInfo, streamProcessor.getType());
            abrController.updateTopQualityIndex(mediaInfo);
            streamProcessor.updateMediaInfo(manifest, mediaInfo);
        }

        isUpdating = false;
        checkIfInitializationCompleted();
    }

    instance = {
        initialize: initialize,
        activate: activate,
        deactivate: deactivate,
        getDuration: getDuration,
        getStartTime: getStartTime,
        getStreamIndex: getStreamIndex,
        getId: getId,
        getStreamInfo: getStreamInfo,
        hasMedia: hasMedia,
        getBitrateListFor: getBitrateListFor,
        startEventController: startEventController,
        isActivated: isActivated,
        isInitialized: isInitialized,
        updateData: updateData,
        reset: reset,
        getProcessors: getProcessors
    };

    setup();
    return instance;
}

Stream.__dashjs_factory_name = 'Stream';
exports['default'] = _coreFactoryMaker2['default'].getClassFactory(Stream);
module.exports = exports['default'];
//# sourceMappingURL=Stream.js.map


/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _controllersAbrController = __webpack_require__(159);

var _controllersAbrController2 = _interopRequireDefault(_controllersAbrController);

var _controllersBufferController = __webpack_require__(160);

var _controllersBufferController2 = _interopRequireDefault(_controllersBufferController);

var _controllersStreamController = __webpack_require__(398);

var _controllersStreamController2 = _interopRequireDefault(_controllersStreamController);

var _controllersMediaController = __webpack_require__(188);

var _controllersMediaController2 = _interopRequireDefault(_controllersMediaController);

var _textTextBufferController = __webpack_require__(1406);

var _textTextBufferController2 = _interopRequireDefault(_textTextBufferController);

var _controllersScheduleController = __webpack_require__(1356);

var _controllersScheduleController2 = _interopRequireDefault(_controllersScheduleController);

var _modelsMediaPlayerModel = __webpack_require__(67);

var _modelsMediaPlayerModel2 = _interopRequireDefault(_modelsMediaPlayerModel);

var _modelsMetricsModel = __webpack_require__(135);

var _modelsMetricsModel2 = _interopRequireDefault(_modelsMetricsModel);

var _FragmentLoader = __webpack_require__(1344);

var _FragmentLoader2 = _interopRequireDefault(_FragmentLoader);

var _utilsRequestModifier = __webpack_require__(327);

var _utilsRequestModifier2 = _interopRequireDefault(_utilsRequestModifier);

var _controllersSourceBufferController = __webpack_require__(322);

var _controllersSourceBufferController2 = _interopRequireDefault(_controllersSourceBufferController);

var _textTextController = __webpack_require__(189);

var _textTextController2 = _interopRequireDefault(_textTextController);

var _dashModelsDashManifestModel = __webpack_require__(158);

var _dashModelsDashManifestModel2 = _interopRequireDefault(_dashModelsDashManifestModel);

var _dashDashMetrics = __webpack_require__(157);

var _dashDashMetrics2 = _interopRequireDefault(_dashDashMetrics);

var _dashControllersRepresentationController = __webpack_require__(1326);

var _dashControllersRepresentationController2 = _interopRequireDefault(_dashControllersRepresentationController);

var _utilsErrorHandler = __webpack_require__(136);

var _utilsErrorHandler2 = _interopRequireDefault(_utilsErrorHandler);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

function StreamProcessor(config) {

    var context = this.context;

    var indexHandler = config.indexHandler;
    var timelineConverter = config.timelineConverter;
    var adapter = config.adapter;
    var manifestModel = config.manifestModel;

    var instance = undefined,
        dynamic = undefined,
        mediaInfo = undefined,
        type = undefined,
        mediaInfoArr = undefined,
        stream = undefined,
        eventController = undefined,
        abrController = undefined,
        bufferController = undefined,
        scheduleController = undefined,
        representationController = undefined,
        fragmentController = undefined,
        fragmentLoader = undefined,
        fragmentModel = undefined;

    function setup() {
        mediaInfoArr = [];
    }

    function initialize(Type, FragmentController, mediaSource, Stream, EventController) {

        type = Type;
        stream = Stream;
        eventController = EventController;
        fragmentController = FragmentController;
        dynamic = stream.getStreamInfo().manifestInfo.isDynamic;

        indexHandler.initialize(this);

        abrController = (0, _controllersAbrController2['default'])(context).getInstance();
        abrController.initialize(type, this);

        bufferController = createBufferControllerForType(Type);
        scheduleController = (0, _controllersScheduleController2['default'])(context).create({
            metricsModel: (0, _modelsMetricsModel2['default'])(context).getInstance(),
            manifestModel: manifestModel,
            adapter: adapter,
            dashMetrics: (0, _dashDashMetrics2['default'])(context).getInstance(),
            dashManifestModel: (0, _dashModelsDashManifestModel2['default'])(context).getInstance(),
            timelineConverter: timelineConverter,
            mediaPlayerModel: (0, _modelsMediaPlayerModel2['default'])(context).getInstance()
        });

        bufferController.initialize(type, mediaSource, this);
        scheduleController.initialize(type, this);

        fragmentLoader = (0, _FragmentLoader2['default'])(context).create({
            metricsModel: (0, _modelsMetricsModel2['default'])(context).getInstance(),
            errHandler: (0, _utilsErrorHandler2['default'])(context).getInstance(),
            requestModifier: (0, _utilsRequestModifier2['default'])(context).getInstance()
        });

        fragmentModel = scheduleController.getFragmentModel();
        fragmentModel.setLoader(fragmentLoader);

        representationController = (0, _dashControllersRepresentationController2['default'])(context).create();
        representationController.initialize(this);
    }

    function reset(errored) {

        indexHandler.reset();

        if (bufferController) {
            bufferController.reset(errored);
            bufferController = null;
        }

        if (scheduleController) {
            scheduleController.reset();
            scheduleController = null;
        }

        if (representationController) {
            representationController.reset();
            representationController = null;
        }

        fragmentController = null;
        fragmentLoader = null;

        eventController = null;
        stream = null;
        dynamic = null;
        mediaInfo = null;
        mediaInfoArr = [];
        type = null;
    }

    function isUpdating() {
        return representationController.isUpdating();
    }

    function getType() {
        return type;
    }

    function getABRController() {
        return abrController;
    }

    function getRepresentationController() {
        return representationController;
    }

    function getFragmentLoader() {
        return fragmentLoader;
    }

    function getIndexHandler() {
        return indexHandler;
    }

    function getFragmentController() {
        return fragmentController;
    }

    function getBuffer() {
        return bufferController.getBuffer();
    }

    function setBuffer(buffer) {
        bufferController.setBuffer(buffer);
    }

    function getBufferController() {
        return bufferController;
    }

    function getFragmentModel() {
        return fragmentModel;
    }

    function getStreamInfo() {
        return stream ? stream.getStreamInfo() : null;
    }

    function updateMediaInfo(manifest, newMediaInfo) {
        if (newMediaInfo !== mediaInfo && (!newMediaInfo || !mediaInfo || newMediaInfo.type === mediaInfo.type)) {
            mediaInfo = newMediaInfo;
        }
        if (mediaInfoArr.indexOf(newMediaInfo) === -1) {
            mediaInfoArr.push(newMediaInfo);
        }
        adapter.updateData(manifest, this);
    }

    function getMediaInfoArr() {
        return mediaInfoArr;
    }

    function getMediaInfo() {
        return mediaInfo;
    }

    function getMediaSource() {
        return bufferController.getMediaSource();
    }

    function getScheduleController() {
        return scheduleController;
    }

    function getEventController() {
        return eventController;
    }

    function start() {
        scheduleController.start();
    }

    function stop() {
        scheduleController.stop();
    }

    function getCurrentRepresentationInfo() {
        return adapter.getCurrentRepresentationInfo(manifestModel.getValue(), representationController);
    }

    function getRepresentationInfoForQuality(quality) {
        return adapter.getRepresentationInfoForQuality(manifestModel.getValue(), representationController, quality);
    }

    function isBufferingCompleted() {
        return bufferController.getIsBufferingCompleted();
    }

    function createBuffer() {
        return bufferController.getBuffer() || bufferController.createBuffer(mediaInfo);
    }

    function isDynamic() {
        return dynamic;
    }

    function createBufferControllerForType(type) {
        var controller = null;

        if (type === 'video' || type === 'audio') {
            controller = (0, _controllersBufferController2['default'])(context).create({
                metricsModel: (0, _modelsMetricsModel2['default'])(context).getInstance(),
                manifestModel: manifestModel,
                sourceBufferController: (0, _controllersSourceBufferController2['default'])(context).getInstance(),
                errHandler: (0, _utilsErrorHandler2['default'])(context).getInstance(),
                streamController: (0, _controllersStreamController2['default'])(context).getInstance(),
                mediaController: (0, _controllersMediaController2['default'])(context).getInstance(),
                adapter: adapter,
                textController: (0, _textTextController2['default'])(context).getInstance()
            });
        } else {
            controller = (0, _textTextBufferController2['default'])(context).create({
                type: type,
                metricsModel: (0, _modelsMetricsModel2['default'])(context).getInstance(),
                manifestModel: manifestModel,
                sourceBufferController: (0, _controllersSourceBufferController2['default'])(context).getInstance(),
                errHandler: (0, _utilsErrorHandler2['default'])(context).getInstance(),
                streamController: (0, _controllersStreamController2['default'])(context).getInstance(),
                mediaController: (0, _controllersMediaController2['default'])(context).getInstance(),
                adapter: adapter,
                textController: (0, _textTextController2['default'])(context).getInstance()
            });
        }

        return controller;
    }

    instance = {
        initialize: initialize,
        isUpdating: isUpdating,
        getType: getType,
        getBufferController: getBufferController,
        getABRController: getABRController,
        getFragmentLoader: getFragmentLoader,
        getFragmentModel: getFragmentModel,
        getScheduleController: getScheduleController,
        getEventController: getEventController,
        getFragmentController: getFragmentController,
        getRepresentationController: getRepresentationController,
        getIndexHandler: getIndexHandler,
        getCurrentRepresentationInfo: getCurrentRepresentationInfo,
        getRepresentationInfoForQuality: getRepresentationInfoForQuality,
        isBufferingCompleted: isBufferingCompleted,
        createBuffer: createBuffer,
        getStreamInfo: getStreamInfo,
        updateMediaInfo: updateMediaInfo,
        getMediaInfoArr: getMediaInfoArr,
        getMediaInfo: getMediaInfo,
        getMediaSource: getMediaSource,
        getBuffer: getBuffer,
        setBuffer: setBuffer,
        start: start,
        stop: stop,
        isDynamic: isDynamic,
        reset: reset
    };

    setup();
    return instance;
}
StreamProcessor.__dashjs_factory_name = 'StreamProcessor';
exports['default'] = _coreFactoryMaker2['default'].getClassFactory(StreamProcessor);
module.exports = exports['default'];
//# sourceMappingURL=StreamProcessor.js.map


/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _voError = __webpack_require__(111);

var _voError2 = _interopRequireDefault(_voError);

var _XHRLoader = __webpack_require__(239);

var _XHRLoader2 = _interopRequireDefault(_XHRLoader);

var _voMetricsHTTPRequest = __webpack_require__(84);

var _voTextRequest = __webpack_require__(599);

var _voTextRequest2 = _interopRequireDefault(_voTextRequest);

var _coreEventBus = __webpack_require__(27);

var _coreEventBus2 = _interopRequireDefault(_coreEventBus);

var _coreEventsEvents = __webpack_require__(22);

var _coreEventsEvents2 = _interopRequireDefault(_coreEventsEvents);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var XLINK_LOADER_ERROR_LOADING_FAILURE = 1;

function XlinkLoader(config) {

    var RESOLVE_TO_ZERO = 'urn:mpeg:dash:resolve-to-zero:2013';

    var context = this.context;
    var eventBus = (0, _coreEventBus2['default'])(context).getInstance();

    var xhrLoader = (0, _XHRLoader2['default'])(context).create({
        errHandler: config.errHandler,
        metricsModel: config.metricsModel,
        requestModifier: config.requestModifier
    });

    var instance = undefined;

    function load(url, element, resolveObject) {
        var report = function report(content, resolveToZero) {
            element.resolved = true;
            element.resolvedContent = content ? content : null;

            eventBus.trigger(_coreEventsEvents2['default'].XLINK_ELEMENT_LOADED, {
                element: element,
                resolveObject: resolveObject,
                error: content || resolveToZero ? null : new _voError2['default'](XLINK_LOADER_ERROR_LOADING_FAILURE, 'Failed loading Xlink element: ' + url)
            });
        };

        if (url === RESOLVE_TO_ZERO) {
            report(null, true);
        } else {
            var request = new _voTextRequest2['default'](url, _voMetricsHTTPRequest.HTTPRequest.XLINK_TYPE);

            xhrLoader.load({
                request: request,
                success: function success(data) {
                    report(data);
                },
                error: function error() {
                    report(null);
                }
            });
        }
    }

    function reset() {
        if (xhrLoader) {
            xhrLoader.abort();
            xhrLoader = null;
        }
    }

    instance = {
        load: load,
        reset: reset
    };

    return instance;
}

XlinkLoader.__dashjs_factory_name = 'XlinkLoader';

var factory = _coreFactoryMaker2['default'].getClassFactory(XlinkLoader);
factory.XLINK_LOADER_ERROR_LOADING_FAILURE = XLINK_LOADER_ERROR_LOADING_FAILURE;
exports['default'] = factory;
module.exports = exports['default'];
//# sourceMappingURL=XlinkLoader.js.map


/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _modelsBaseURLTreeModel = __webpack_require__(1378);

var _modelsBaseURLTreeModel2 = _interopRequireDefault(_modelsBaseURLTreeModel);

var _utilsBaseURLSelector = __webpack_require__(1408);

var _utilsBaseURLSelector2 = _interopRequireDefault(_utilsBaseURLSelector);

var _utilsURLUtils = __webpack_require__(242);

var _utilsURLUtils2 = _interopRequireDefault(_utilsURLUtils);

var _dashVoBaseURL = __webpack_require__(587);

var _dashVoBaseURL2 = _interopRequireDefault(_dashVoBaseURL);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _coreEventBus = __webpack_require__(27);

var _coreEventBus2 = _interopRequireDefault(_coreEventBus);

var _coreEventsEvents = __webpack_require__(22);

var _coreEventsEvents2 = _interopRequireDefault(_coreEventsEvents);

function BaseURLController() {

    var instance = undefined;

    var context = this.context;
    var eventBus = (0, _coreEventBus2['default'])(context).getInstance();
    var urlUtils = (0, _utilsURLUtils2['default'])(context).getInstance();

    var baseURLTreeModel = undefined,
        baseURLSelector = undefined;

    function onBlackListChanged(e) {
        baseURLTreeModel.invalidateSelectedIndexes(e.entry);
    }

    function setup() {
        baseURLTreeModel = (0, _modelsBaseURLTreeModel2['default'])(context).create();
        baseURLSelector = (0, _utilsBaseURLSelector2['default'])(context).create();

        eventBus.on(_coreEventsEvents2['default'].SERVICE_LOCATION_BLACKLIST_CHANGED, onBlackListChanged, instance);
    }

    function setConfig(config) {
        if (config.baseURLTreeModel) {
            baseURLTreeModel = config.baseURLTreeModel;
        }

        if (config.baseURLSelector) {
            baseURLSelector = config.baseURLSelector;
        }
    }

    function update(manifest) {
        baseURLTreeModel.update(manifest);
        baseURLSelector.chooseSelectorFromManifest(manifest);
    }

    function resolve(path) {
        var baseUrls = baseURLTreeModel.getForPath(path);

        var baseUrl = baseUrls.reduce(function (p, c) {
            var b = baseURLSelector.select(c);

            if (b) {
                if (!urlUtils.isRelative(b.url)) {
                    p.url = b.url;
                    p.serviceLocation = b.serviceLocation;
                } else {
                    p.url = urlUtils.resolve(b.url, p.url);
                }
            } else {
                return new _dashVoBaseURL2['default']();
            }

            return p;
        }, new _dashVoBaseURL2['default']());

        if (!urlUtils.isRelative(baseUrl.url)) {
            return baseUrl;
        }
    }

    function reset() {
        baseURLTreeModel.reset();
        baseURLSelector.reset();
    }

    function initialize(data) {
        update(data);
    }

    instance = {
        reset: reset,
        initialize: initialize,
        resolve: resolve,
        setConfig: setConfig
    };

    setup();

    return instance;
}

BaseURLController.__dashjs_factory_name = 'BaseURLController';
exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(BaseURLController);
module.exports = exports['default'];
//# sourceMappingURL=BaseURLController.js.map


/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _coreEventBus = __webpack_require__(27);

var _coreEventBus2 = _interopRequireDefault(_coreEventBus);

function BlackListController(config) {

    var blacklist = [];

    var eventBus = (0, _coreEventBus2['default'])(this.context).getInstance();
    var updateEventName = config.updateEventName;
    var loadFailedEventName = config.loadFailedEventName;

    function contains(query) {
        if (!blacklist.length || !query || !query.length) {
            return false;
        }

        return blacklist.indexOf(query) !== -1;
    }

    function add(entry) {
        if (blacklist.indexOf(entry) !== -1) {
            return;
        }

        blacklist.push(entry);

        eventBus.trigger(updateEventName, {
            entry: entry
        });
    }

    function onLoadFailed(e) {
        if (e.error) {
            add(e.request.serviceLocation);
        }
    }

    function setup() {
        if (loadFailedEventName) {
            eventBus.on(loadFailedEventName, onLoadFailed, this);
        }
    }

    function reset() {
        blacklist = [];
    }

    setup();

    return {
        add: add,
        contains: contains,
        reset: reset
    };
}

BlackListController.__dashjs_factory_name = 'BlackListController';
exports['default'] = _coreFactoryMaker2['default'].getClassFactory(BlackListController);
module.exports = exports['default'];
//# sourceMappingURL=BlacklistController.js.map


/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _controllersPlaybackController = __webpack_require__(161);

var _controllersPlaybackController2 = _interopRequireDefault(_controllersPlaybackController);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _coreDebug = __webpack_require__(30);

var _coreDebug2 = _interopRequireDefault(_coreDebug);

var _coreEventBus = __webpack_require__(27);

var _coreEventBus2 = _interopRequireDefault(_coreEventBus);

function EventController() {

    var MPD_RELOAD_SCHEME = 'urn:mpeg:dash:event:2012';
    var MPD_RELOAD_VALUE = 1;

    var context = this.context;
    var log = (0, _coreDebug2['default'])(context).getInstance().log;
    var eventBus = (0, _coreEventBus2['default'])(context).getInstance();

    var instance = undefined,
        inlineEvents = undefined,
        // Holds all Inline Events not triggered yet
    inbandEvents = undefined,
        // Holds all Inband Events not triggered yet
    activeEvents = undefined,
        // Holds all Events currently running
    eventInterval = undefined,
        // variable holding the setInterval
    refreshDelay = undefined,
        // refreshTime for the setInterval
    presentationTimeThreshold = undefined,
        manifestModel = undefined,
        manifestUpdater = undefined,
        playbackController = undefined,
        isStarted = undefined;

    function initialize() {
        isStarted = false;
        inlineEvents = {};
        inbandEvents = {};
        activeEvents = {};
        eventInterval = null;
        refreshDelay = 100;
        presentationTimeThreshold = refreshDelay / 1000;
        playbackController = (0, _controllersPlaybackController2['default'])(context).getInstance();
    }

    function clear() {
        if (eventInterval !== null && isStarted) {
            clearInterval(eventInterval);
            eventInterval = null;
            isStarted = false;
        }
    }

    function start() {
        log('Start Event Controller');
        if (!isStarted && !isNaN(refreshDelay)) {
            isStarted = true;
            eventInterval = setInterval(onEventTimer, refreshDelay);
        }
    }

    /**
     * Add events to the eventList. Events that are not in the mpd anymore but not triggered yet will still be deleted
     * @param {Array.<Object>} values
     */
    function addInlineEvents(values) {
        inlineEvents = {};

        if (values) {
            for (var i = 0; i < values.length; i++) {
                var event = values[i];
                inlineEvents[event.id] = event;
                log('Add inline event with id ' + event.id);
            }
        }
        log('Added ' + values.length + ' inline events');
    }

    /**
     * i.e. processing of any one event message box with the same id is sufficient
     * @param {Array.<Object>} values
     */
    function addInbandEvents(values) {
        for (var i = 0; i < values.length; i++) {
            var event = values[i];
            if (!(event.id in inbandEvents)) {
                inbandEvents[event.id] = event;
                log('Add inband event with id ' + event.id);
            } else {
                log('Repeated event with id ' + event.id);
            }
        }
    }

    /**
     * Remove events which are over from the list
     */
    function removeEvents() {
        if (activeEvents) {
            var currentVideoTime = playbackController.getTime();
            var eventIds = Object.keys(activeEvents);

            for (var i = 0; i < eventIds.length; i++) {
                var eventId = eventIds[i];
                var curr = activeEvents[eventId];
                if (curr !== null && (curr.duration + curr.presentationTime) / curr.eventStream.timescale < currentVideoTime) {
                    log('Remove Event ' + eventId + ' at time ' + currentVideoTime);
                    curr = null;
                    delete activeEvents[eventId];
                }
            }
        }
    }

    /**
     * Iterate through the eventList and trigger/remove the events
     */
    function onEventTimer() {
        triggerEvents(inbandEvents);
        triggerEvents(inlineEvents);
        removeEvents();
    }

    function refreshManifest() {
        var manifest = manifestModel.getValue();
        var url = manifest.url;

        if (manifest.hasOwnProperty('Location')) {
            url = manifest.Location;
        }
        log('Refresh manifest @ ' + url);
        manifestUpdater.getManifestLoader().load(url);
    }

    function triggerEvents(events) {
        var currentVideoTime = playbackController.getTime();
        var presentationTime;

        /* == Trigger events that are ready == */
        if (events) {
            var eventIds = Object.keys(events);
            for (var i = 0; i < eventIds.length; i++) {
                var eventId = eventIds[i];
                var curr = events[eventId];

                if (curr !== undefined) {
                    presentationTime = curr.presentationTime / curr.eventStream.timescale;
                    if (presentationTime === 0 || presentationTime <= currentVideoTime && presentationTime + presentationTimeThreshold > currentVideoTime) {
                        log('Start Event ' + eventId + ' at ' + currentVideoTime);
                        if (curr.duration > 0) {
                            activeEvents[eventId] = curr;
                        }
                        if (curr.eventStream.schemeIdUri == MPD_RELOAD_SCHEME && curr.eventStream.value == MPD_RELOAD_VALUE) {
                            refreshManifest();
                        } else {
                            eventBus.trigger(curr.eventStream.schemeIdUri, { event: curr });
                        }
                        delete events[eventId];
                    }
                }
            }
        }
    }

    function setConfig(config) {
        if (!config) return;

        if (config.manifestModel) {
            manifestModel = config.manifestModel;
        }

        if (config.manifestUpdater) {
            manifestUpdater = config.manifestUpdater;
        }
    }

    function reset() {
        clear();
        inlineEvents = null;
        inbandEvents = null;
        activeEvents = null;
        playbackController = null;
    }

    instance = {
        initialize: initialize,
        addInlineEvents: addInlineEvents,
        addInbandEvents: addInbandEvents,
        clear: clear,
        start: start,
        setConfig: setConfig,
        reset: reset
    };

    return instance;
}

EventController.__dashjs_factory_name = 'EventController';
exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(EventController);
module.exports = exports['default'];
//# sourceMappingURL=EventController.js.map


/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _voMetricsHTTPRequest = __webpack_require__(84);

var _voDataChunk = __webpack_require__(1418);

var _voDataChunk2 = _interopRequireDefault(_voDataChunk);

var _modelsFragmentModel = __webpack_require__(324);

var _modelsFragmentModel2 = _interopRequireDefault(_modelsFragmentModel);

var _modelsMetricsModel = __webpack_require__(135);

var _modelsMetricsModel2 = _interopRequireDefault(_modelsMetricsModel);

var _coreEventBus = __webpack_require__(27);

var _coreEventBus2 = _interopRequireDefault(_coreEventBus);

var _coreEventsEvents = __webpack_require__(22);

var _coreEventsEvents2 = _interopRequireDefault(_coreEventsEvents);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _coreDebug = __webpack_require__(30);

var _coreDebug2 = _interopRequireDefault(_coreDebug);

function FragmentController() /*config*/{

    var context = this.context;
    var log = (0, _coreDebug2['default'])(context).getInstance().log;
    var eventBus = (0, _coreEventBus2['default'])(context).getInstance();

    var instance = undefined,
        fragmentModels = undefined;

    function setup() {
        fragmentModels = {};
        eventBus.on(_coreEventsEvents2['default'].FRAGMENT_LOADING_COMPLETED, onFragmentLoadingCompleted, instance);
    }

    function getModel(type) {
        var model = fragmentModels[type];
        if (!model) {
            model = (0, _modelsFragmentModel2['default'])(context).create({ metricsModel: (0, _modelsMetricsModel2['default'])(context).getInstance() });
            fragmentModels[type] = model;
        }

        return model;
    }

    function isInitializationRequest(request) {
        return request && request.type && request.type === _voMetricsHTTPRequest.HTTPRequest.INIT_SEGMENT_TYPE;
    }

    function reset() {
        eventBus.off(_coreEventsEvents2['default'].FRAGMENT_LOADING_COMPLETED, onFragmentLoadingCompleted, this);
        for (var model in fragmentModels) {
            fragmentModels[model].reset();
        }
        fragmentModels = {};
    }

    function createDataChunk(bytes, request, streamId) {
        var chunk = new _voDataChunk2['default']();

        chunk.streamId = streamId;
        chunk.mediaInfo = request.mediaInfo;
        chunk.segmentType = request.type;
        chunk.start = request.startTime;
        chunk.duration = request.duration;
        chunk.end = chunk.start + chunk.duration;
        chunk.bytes = bytes;
        chunk.index = request.index;
        chunk.quality = request.quality;
        chunk.representationId = request.representationId;

        return chunk;
    }

    function onFragmentLoadingCompleted(e) {
        if (fragmentModels[e.request.mediaType] !== e.sender) return;

        var request = e.request;
        var bytes = e.response;
        var isInit = isInitializationRequest(request);
        var streamInfo = request.mediaInfo.streamInfo;

        if (!bytes || !streamInfo) {
            log('No ' + request.mediaType + ' bytes to push or stream is inactive.');
            return;
        }

        var chunk = createDataChunk(bytes, request, streamInfo.id);
        eventBus.trigger(isInit ? _coreEventsEvents2['default'].INIT_FRAGMENT_LOADED : _coreEventsEvents2['default'].MEDIA_FRAGMENT_LOADED, { chunk: chunk, fragmentModel: e.sender });
    }

    instance = {
        getModel: getModel,
        isInitializationRequest: isInitializationRequest,
        reset: reset
    };

    setup();

    return instance;
}

FragmentController.__dashjs_factory_name = 'FragmentController';
exports['default'] = _coreFactoryMaker2['default'].getClassFactory(FragmentController);
module.exports = exports['default'];
//# sourceMappingURL=FragmentController.js.map


/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

function MediaSourceController() {

    var instance = undefined;

    function createMediaSource() {

        var hasWebKit = ('WebKitMediaSource' in window);
        var hasMediaSource = ('MediaSource' in window);

        if (hasMediaSource) {
            return new MediaSource();
        } else if (hasWebKit) {
            return new WebKitMediaSource();
        }

        return null;
    }

    function attachMediaSource(source, videoModel) {

        var objectURL = window.URL.createObjectURL(source);

        videoModel.setSource(objectURL);

        return objectURL;
    }

    function detachMediaSource(videoModel) {
        videoModel.setSource(null);
    }

    function setDuration(source, value) {

        if (source.duration != value) source.duration = value;

        return source.duration;
    }

    function signalEndOfStream(source) {

        var buffers = source.sourceBuffers;
        var ln = buffers.length;
        var i = 0;

        if (source.readyState !== 'open') return;

        for (i; i < ln; i++) {
            if (buffers[i].updating) return;
            if (buffers[i].buffered.length === 0) return;
        }

        source.endOfStream();
    }

    instance = {
        createMediaSource: createMediaSource,
        attachMediaSource: attachMediaSource,
        detachMediaSource: detachMediaSource,
        setDuration: setDuration,
        signalEndOfStream: signalEndOfStream
    };

    return instance;
}

MediaSourceController.__dashjs_factory_name = 'MediaSourceController';
exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(MediaSourceController);
module.exports = exports['default'];
//# sourceMappingURL=MediaSourceController.js.map


/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _voMetricsPlayList = __webpack_require__(600);

var _PlaybackController = __webpack_require__(161);

var _PlaybackController2 = _interopRequireDefault(_PlaybackController);

var _AbrController = __webpack_require__(159);

var _AbrController2 = _interopRequireDefault(_AbrController);

var _BufferController = __webpack_require__(160);

var _BufferController2 = _interopRequireDefault(_BufferController);

var _MediaController = __webpack_require__(188);

var _MediaController2 = _interopRequireDefault(_MediaController);

var _rulesSchedulingBufferLevelRule = __webpack_require__(1402);

var _rulesSchedulingBufferLevelRule2 = _interopRequireDefault(_rulesSchedulingBufferLevelRule);

var _rulesSchedulingNextFragmentRequestRule = __webpack_require__(1403);

var _rulesSchedulingNextFragmentRequestRule2 = _interopRequireDefault(_rulesSchedulingNextFragmentRequestRule);

var _textTextController = __webpack_require__(189);

var _textTextController2 = _interopRequireDefault(_textTextController);

var _modelsFragmentModel = __webpack_require__(324);

var _modelsFragmentModel2 = _interopRequireDefault(_modelsFragmentModel);

var _controllersSourceBufferController = __webpack_require__(322);

var _controllersSourceBufferController2 = _interopRequireDefault(_controllersSourceBufferController);

var _utilsLiveEdgeFinder = __webpack_require__(409);

var _utilsLiveEdgeFinder2 = _interopRequireDefault(_utilsLiveEdgeFinder);

var _coreEventBus = __webpack_require__(27);

var _coreEventBus2 = _interopRequireDefault(_coreEventBus);

var _coreEventsEvents = __webpack_require__(22);

var _coreEventsEvents2 = _interopRequireDefault(_coreEventsEvents);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _controllersStreamController = __webpack_require__(398);

var _controllersStreamController2 = _interopRequireDefault(_controllersStreamController);

var _coreDebug = __webpack_require__(30);

var _coreDebug2 = _interopRequireDefault(_coreDebug);

function ScheduleController(config) {

    var context = this.context;
    var log = (0, _coreDebug2['default'])(context).getInstance().log;
    var eventBus = (0, _coreEventBus2['default'])(context).getInstance();
    var metricsModel = config.metricsModel;
    var manifestModel = config.manifestModel;
    var adapter = config.adapter;
    var dashMetrics = config.dashMetrics;
    var dashManifestModel = config.dashManifestModel;
    var timelineConverter = config.timelineConverter;
    var mediaPlayerModel = config.mediaPlayerModel;

    var instance = undefined,
        type = undefined,
        fragmentModel = undefined,
        isDynamic = undefined,
        currentRepresentationInfo = undefined,
        initialRequest = undefined,
        isStopped = undefined,
        playListMetrics = undefined,
        playListTraceMetrics = undefined,
        playListTraceMetricsClosed = undefined,
        isFragmentProcessingInProgress = undefined,
        timeToLoadDelay = undefined,
        scheduleTimeout = undefined,
        seekTarget = undefined,
        playbackController = undefined,
        mediaController = undefined,
        abrController = undefined,
        streamProcessor = undefined,
        streamController = undefined,
        fragmentController = undefined,
        bufferController = undefined,
        bufferLevelRule = undefined,
        nextFragmentRequestRule = undefined,
        scheduleWhilePaused = undefined,
        lastQualityIndex = undefined,
        topQualityIndex = undefined,
        lastInitQuality = undefined,
        replaceRequestArray = undefined;

    function setup() {
        initialRequest = true;
        lastInitQuality = NaN;
        lastQualityIndex = NaN;
        topQualityIndex = {};
        replaceRequestArray = [];
        isStopped = true;
        playListMetrics = null;
        playListTraceMetrics = null;
        playListTraceMetricsClosed = true;
        isFragmentProcessingInProgress = false;
        timeToLoadDelay = 0;
        seekTarget = NaN;
    }

    function initialize(Type, StreamProcessor) {
        type = Type;
        streamProcessor = StreamProcessor;
        playbackController = (0, _PlaybackController2['default'])(context).getInstance();
        mediaController = (0, _MediaController2['default'])(context).getInstance();
        abrController = (0, _AbrController2['default'])(context).getInstance();
        streamController = (0, _controllersStreamController2['default'])(context).getInstance();
        fragmentController = streamProcessor.getFragmentController();
        bufferController = streamProcessor.getBufferController();
        fragmentModel = fragmentController.getModel(type);
        isDynamic = streamProcessor.isDynamic();
        scheduleWhilePaused = mediaPlayerModel.getScheduleWhilePaused();

        bufferLevelRule = (0, _rulesSchedulingBufferLevelRule2['default'])(context).create({
            dashMetrics: dashMetrics,
            metricsModel: metricsModel,
            textController: (0, _textTextController2['default'])(context).getInstance()
        });

        nextFragmentRequestRule = (0, _rulesSchedulingNextFragmentRequestRule2['default'])(context).create({
            adapter: adapter,
            sourceBufferController: (0, _controllersSourceBufferController2['default'])(context).getInstance(),
            textController: (0, _textTextController2['default'])(context).getInstance()
        });

        if (dashManifestModel.getIsTextTrack(type)) {
            eventBus.on(_coreEventsEvents2['default'].TIMED_TEXT_REQUESTED, onTimedTextRequested, this);
        }

        //eventBus.on(Events.LIVE_EDGE_SEARCH_COMPLETED, onLiveEdgeSearchCompleted, this);
        eventBus.on(_coreEventsEvents2['default'].QUALITY_CHANGE_REQUESTED, onQualityChanged, this);
        eventBus.on(_coreEventsEvents2['default'].DATA_UPDATE_STARTED, onDataUpdateStarted, this);
        eventBus.on(_coreEventsEvents2['default'].DATA_UPDATE_COMPLETED, onDataUpdateCompleted, this);
        eventBus.on(_coreEventsEvents2['default'].FRAGMENT_LOADING_COMPLETED, onFragmentLoadingCompleted, this);
        eventBus.on(_coreEventsEvents2['default'].STREAM_COMPLETED, onStreamCompleted, this);
        eventBus.on(_coreEventsEvents2['default'].STREAM_INITIALIZED, onStreamInitialized, this);
        eventBus.on(_coreEventsEvents2['default'].BUFFER_LEVEL_STATE_CHANGED, onBufferLevelStateChanged, this);
        eventBus.on(_coreEventsEvents2['default'].BUFFER_CLEARED, onBufferCleared, this);
        eventBus.on(_coreEventsEvents2['default'].BYTES_APPENDED, onBytesAppended, this);
        eventBus.on(_coreEventsEvents2['default'].INIT_REQUESTED, onInitRequested, this);
        eventBus.on(_coreEventsEvents2['default'].QUOTA_EXCEEDED, onQuotaExceeded, this);
        eventBus.on(_coreEventsEvents2['default'].PLAYBACK_SEEKING, onPlaybackSeeking, this);
        eventBus.on(_coreEventsEvents2['default'].PLAYBACK_STARTED, onPlaybackStarted, this);
        eventBus.on(_coreEventsEvents2['default'].PLAYBACK_RATE_CHANGED, onPlaybackRateChanged, this);
        eventBus.on(_coreEventsEvents2['default'].PLAYBACK_TIME_UPDATED, onPlaybackTimeUpdated, this);
        eventBus.on(_coreEventsEvents2['default'].URL_RESOLUTION_FAILED, onURLResolutionFailed, this);
        eventBus.on(_coreEventsEvents2['default'].FRAGMENT_LOADING_ABANDONED, onFragmentLoadingAbandoned, this);
    }

    function start() {
        if (!currentRepresentationInfo || bufferController.getIsBufferingCompleted()) return;
        addPlaylistTraceMetrics();
        isStopped = false;

        if (initialRequest) {
            initialRequest = false;
        }

        startScheduleTimer(0);

        log('Schedule controller starting for ' + type);
    }

    function stop() {
        if (isStopped) return;
        isStopped = true;
        clearTimeout(scheduleTimeout);
        log('Schedule controller stopping for ' + type);
    }

    function hasTopQualityChanged(type, id) {

        topQualityIndex[id] = topQualityIndex[id] || {};
        var newTopQualityIndex = abrController.getTopQualityIndexFor(type, id);

        if (topQualityIndex[id][type] != newTopQualityIndex) {
            log('Top quality' + type + ' index has changed from ' + topQualityIndex[id][type] + ' to ' + newTopQualityIndex);
            topQualityIndex[id][type] = newTopQualityIndex;
            return true;
        }
        return false;
    }

    function schedule() {

        if (isStopped || isFragmentProcessingInProgress || !bufferController || playbackController.isPaused() && !scheduleWhilePaused) return;

        validateExecutedFragmentRequest();

        var isReplacement = replaceRequestArray.length > 0;
        if (isReplacement || hasTopQualityChanged(currentRepresentationInfo.mediaInfo.type, streamProcessor.getStreamInfo().id) || bufferLevelRule.execute(streamProcessor, type, streamController.isVideoTrackPresent())) {

            var getNextFragment = function getNextFragment() {
                if (currentRepresentationInfo.quality !== lastInitQuality) {
                    lastInitQuality = currentRepresentationInfo.quality;
                    bufferController.switchInitData(streamProcessor.getStreamInfo().id, currentRepresentationInfo.id);
                } else {
                    var replacement = replaceRequestArray.shift();

                    if (fragmentController.isInitializationRequest(replacement)) {
                        //to be sure the specific init segment had not already been loaded.
                        bufferController.switchInitData(replacement.mediaInfo.streamInfo.id, replacement.representationId);
                    } else {
                        var request = nextFragmentRequestRule.execute(streamProcessor, replacement);
                        if (request) {
                            fragmentModel.executeRequest(request);
                        } else {
                            //Use case - Playing at the bleeding live edge and frag is not available yet. Cycle back around.
                            isFragmentProcessingInProgress = false;
                            startScheduleTimer(500);
                        }
                    }
                }
            };

            isFragmentProcessingInProgress = true;
            if (isReplacement) {
                getNextFragment();
            } else {
                abrController.getPlaybackQuality(streamProcessor);
                getNextFragment();
            }
        } else {
            startScheduleTimer(500);
        }
    }

    function validateExecutedFragmentRequest() {
        //Validate that the fragment request executed and appended into the source buffer is as
        // good of quality as the current quality and is the correct media track.
        var safeBufferLevel = currentRepresentationInfo.fragmentDuration * 1.5;
        var request = fragmentModel.getRequests({ state: _modelsFragmentModel2['default'].FRAGMENT_MODEL_EXECUTED, time: playbackController.getTime() + safeBufferLevel, threshold: 0 })[0];

        if (request && replaceRequestArray.indexOf(request) === -1 && !dashManifestModel.getIsTextTrack(type)) {
            if (!mediaController.isCurrentTrack(request.mediaInfo) || mediaPlayerModel.getFastSwitchEnabled() && request.quality < currentRepresentationInfo.quality && bufferController.getBufferLevel() >= safeBufferLevel && abrController.getAbandonmentStateFor(type) !== _AbrController2['default'].ABANDON_LOAD) {
                replaceRequest(request);
                log('Reloading outdated fragment at index: ', request.index);
            } else if (request.quality > currentRepresentationInfo.quality) {
                //The buffer has better quality it in then what we would request so set append point to end of buffer!!
                setSeekTarget(playbackController.getTime() + bufferController.getBufferLevel());
            }
        }
    }

    function startScheduleTimer(value) {
        clearTimeout(scheduleTimeout);
        scheduleTimeout = setTimeout(schedule, value);
    }

    function onInitRequested(e) {
        if (!e.sender || e.sender.getStreamProcessor() !== streamProcessor) return;
        getInitRequest(currentRepresentationInfo.quality);
    }

    function getInitRequest(quality) {
        lastInitQuality = quality;

        var request = adapter.getInitRequest(streamProcessor, quality);
        if (request) {
            isFragmentProcessingInProgress = true;
            fragmentModel.executeRequest(request);
        }
    }

    function replaceRequest(request) {
        replaceRequestArray.push(request);
    }

    function onQualityChanged(e) {
        if (type !== e.mediaType || streamProcessor.getStreamInfo().id !== e.streamInfo.id) return;

        currentRepresentationInfo = streamProcessor.getRepresentationInfoForQuality(e.newQuality);

        if (currentRepresentationInfo === null || currentRepresentationInfo === undefined) {
            throw new Error('Unexpected error! - currentRepresentationInfo is null or undefined');
        }

        clearPlayListTraceMetrics(new Date(), _voMetricsPlayList.PlayListTrace.REPRESENTATION_SWITCH_STOP_REASON);
        addPlaylistTraceMetrics();
    }

    function completeQualityChange(trigger) {
        if (playbackController) {
            var item = fragmentModel.getRequests({ state: _modelsFragmentModel2['default'].FRAGMENT_MODEL_EXECUTED, time: playbackController.getTime(), threshold: 0 })[0];
            if (item && playbackController.getTime() >= item.startTime) {
                if (item.quality !== lastQualityIndex && trigger) {
                    eventBus.trigger(_coreEventsEvents2['default'].QUALITY_CHANGE_RENDERED, { mediaType: type, oldQuality: lastQualityIndex, newQuality: item.quality });
                }
                lastQualityIndex = item.quality;
            }
        }
    }

    function onDataUpdateCompleted(e) {
        if (e.error || e.sender.getStreamProcessor() !== streamProcessor) return;
        currentRepresentationInfo = adapter.convertDataToTrack(manifestModel.getValue(), e.currentRepresentation);
    }

    function onStreamInitialized(e) {
        if (e.error || streamProcessor.getStreamInfo().id !== e.streamInfo.id) return;
        currentRepresentationInfo = streamProcessor.getCurrentRepresentationInfo();

        if (isDynamic && initialRequest) {
            timelineConverter.setTimeSyncCompleted(true);
            setLiveEdgeSeekTarget();
        }

        if (isStopped) {
            start();
        }
    }

    function setLiveEdgeSeekTarget() {
        var liveEdge = (0, _utilsLiveEdgeFinder2['default'])(context).getInstance().getLiveEdge();
        var dvrWindowSize = currentRepresentationInfo.mediaInfo.streamInfo.manifestInfo.DVRWindowSize / 2;
        var startTime = liveEdge - playbackController.computeLiveDelay(currentRepresentationInfo.fragmentDuration, dvrWindowSize);
        var request = adapter.getFragmentRequestForTime(streamProcessor, currentRepresentationInfo, startTime, { ignoreIsFinished: true });
        seekTarget = playbackController.getLiveStartTime();
        if (isNaN(seekTarget) || request.startTime > seekTarget) {
            playbackController.setLiveStartTime(request.startTime);
            seekTarget = request.startTime;
        }

        var manifestUpdateInfo = dashMetrics.getCurrentManifestUpdate(metricsModel.getMetricsFor('stream'));
        metricsModel.updateManifestUpdateInfo(manifestUpdateInfo, {
            currentTime: seekTarget,
            presentationStartTime: liveEdge,
            latency: liveEdge - seekTarget,
            clientTimeOffset: timelineConverter.getClientTimeOffset()
        });
    }

    function onStreamCompleted(e) {
        if (e.fragmentModel !== fragmentModel) return;
        stop();
        isFragmentProcessingInProgress = false;
        log('Stream is complete');
    }

    function onFragmentLoadingCompleted(e) {
        if (e.sender !== fragmentModel) return;

        if (dashManifestModel.getIsTextTrack(type)) {
            isFragmentProcessingInProgress = false;
        }

        if (e.error && e.request.serviceLocation && !isStopped) {
            replaceRequest(e.request);
            isFragmentProcessingInProgress = false;
            startScheduleTimer(0);
        }
    }

    function onPlaybackTimeUpdated() {
        completeQualityChange(true);
    }

    function onBytesAppended(e) {
        if (e.sender.getStreamProcessor() !== streamProcessor) return;
        isFragmentProcessingInProgress = false;
        startScheduleTimer(0);
    }

    function onFragmentLoadingAbandoned(e) {
        if (e.streamProcessor !== streamProcessor) return;
        replaceRequest(e.request);
        isFragmentProcessingInProgress = false;
        startScheduleTimer(0);
    }

    function onDataUpdateStarted(e) {
        if (e.sender.getStreamProcessor() !== streamProcessor) return;
        stop();
    }

    function onBufferCleared(e) {
        if (e.sender.getStreamProcessor() !== streamProcessor) return;
        // after the data has been removed from the buffer we should remove the requests from the list of
        // the executed requests for which playback time is inside the time interval that has been removed from the buffer
        fragmentModel.removeExecutedRequestsBeforeTime(e.to);

        if (e.hasEnoughSpaceToAppend && isStopped) {
            start();
        }
    }

    function onBufferLevelStateChanged(e) {
        if (e.sender.getStreamProcessor() === streamProcessor && e.state === _BufferController2['default'].BUFFER_EMPTY && !playbackController.isSeeking()) {
            log('Buffer is empty! Stalling!');
            clearPlayListTraceMetrics(new Date(), _voMetricsPlayList.PlayListTrace.REBUFFERING_REASON);
        }
    }

    function onQuotaExceeded(e) {
        if (e.sender.getStreamProcessor() !== streamProcessor) return;
        stop();
    }

    function onURLResolutionFailed() {
        fragmentModel.abortRequests();
        stop();
    }

    function onTimedTextRequested(e) {
        if (e.sender.getStreamProcessor() !== streamProcessor) return;
        getInitRequest(e.index);
    }

    function onPlaybackStarted() {
        if (isStopped || !scheduleWhilePaused) {
            start();
        }
    }

    function onPlaybackSeeking(e) {

        seekTarget = e.seekTime;
        setTimeToLoadDelay(0);

        if (isStopped) {
            start();
        }

        var manifestUpdateInfo = dashMetrics.getCurrentManifestUpdate(metricsModel.getMetricsFor('stream'));
        var latency = currentRepresentationInfo.DVRWindow ? currentRepresentationInfo.DVRWindow.end - playbackController.getTime() : NaN;
        metricsModel.updateManifestUpdateInfo(manifestUpdateInfo, { latency: latency });
    }

    function onPlaybackRateChanged(e) {
        if (playListTraceMetrics) {
            playListTraceMetrics.playbackspeed = e.playbackRate.toString();
        }
    }

    function getSeekTarget() {
        return seekTarget;
    }

    function setSeekTarget(value) {
        seekTarget = value;
    }

    function getFragmentModel() {
        return fragmentModel;
    }

    function setTimeToLoadDelay(value) {
        timeToLoadDelay = value;
    }

    function getTimeToLoadDelay() {
        return timeToLoadDelay;
    }

    function getStreamProcessor() {
        return streamProcessor;
    }

    function getBufferTarget() {
        return bufferLevelRule.getBufferTarget(streamProcessor, type, streamController.isVideoTrackPresent());
    }

    function setPlayList(playList) {
        playListMetrics = playList;
    }

    function finalisePlayList(time, reason) {
        clearPlayListTraceMetrics(time, reason);
        playListMetrics = null;
    }

    function clearPlayListTraceMetrics(endTime, stopreason) {
        if (playListMetrics && playListTraceMetricsClosed === false) {
            var startTime = playListTraceMetrics.start;
            var duration = endTime.getTime() - startTime.getTime();
            playListTraceMetrics.duration = duration;
            playListTraceMetrics.stopreason = stopreason;
            playListMetrics.trace.push(playListTraceMetrics);
            playListTraceMetricsClosed = true;
        }
    }

    function addPlaylistTraceMetrics() {
        if (playListMetrics && playListTraceMetricsClosed === true && currentRepresentationInfo) {
            playListTraceMetricsClosed = false;
            playListTraceMetrics = new _voMetricsPlayList.PlayListTrace();
            playListTraceMetrics.representationid = currentRepresentationInfo.id;
            playListTraceMetrics.start = new Date();
            playListTraceMetrics.mstart = playbackController.getTime() * 1000;
            playListTraceMetrics.playbackspeed = playbackController.getPlaybackRate().toString();
        }
    }

    function reset() {
        //eventBus.off(Events.LIVE_EDGE_SEARCH_COMPLETED, onLiveEdgeSearchCompleted, this);
        eventBus.off(_coreEventsEvents2['default'].DATA_UPDATE_STARTED, onDataUpdateStarted, this);
        eventBus.off(_coreEventsEvents2['default'].DATA_UPDATE_COMPLETED, onDataUpdateCompleted, this);
        eventBus.off(_coreEventsEvents2['default'].BUFFER_LEVEL_STATE_CHANGED, onBufferLevelStateChanged, this);
        eventBus.off(_coreEventsEvents2['default'].QUALITY_CHANGE_REQUESTED, onQualityChanged, this);
        eventBus.off(_coreEventsEvents2['default'].FRAGMENT_LOADING_COMPLETED, onFragmentLoadingCompleted, this);
        eventBus.off(_coreEventsEvents2['default'].STREAM_COMPLETED, onStreamCompleted, this);
        eventBus.off(_coreEventsEvents2['default'].STREAM_INITIALIZED, onStreamInitialized, this);
        eventBus.off(_coreEventsEvents2['default'].QUOTA_EXCEEDED, onQuotaExceeded, this);
        eventBus.off(_coreEventsEvents2['default'].BYTES_APPENDED, onBytesAppended, this);
        eventBus.off(_coreEventsEvents2['default'].BUFFER_CLEARED, onBufferCleared, this);
        eventBus.off(_coreEventsEvents2['default'].INIT_REQUESTED, onInitRequested, this);
        eventBus.off(_coreEventsEvents2['default'].PLAYBACK_RATE_CHANGED, onPlaybackRateChanged, this);
        eventBus.off(_coreEventsEvents2['default'].PLAYBACK_SEEKING, onPlaybackSeeking, this);
        eventBus.off(_coreEventsEvents2['default'].PLAYBACK_STARTED, onPlaybackStarted, this);
        eventBus.off(_coreEventsEvents2['default'].PLAYBACK_TIME_UPDATED, onPlaybackTimeUpdated, this);
        eventBus.off(_coreEventsEvents2['default'].URL_RESOLUTION_FAILED, onURLResolutionFailed, this);
        eventBus.off(_coreEventsEvents2['default'].FRAGMENT_LOADING_ABANDONED, onFragmentLoadingAbandoned, this);
        if (dashManifestModel.getIsTextTrack(type)) {
            eventBus.off(_coreEventsEvents2['default'].TIMED_TEXT_REQUESTED, onTimedTextRequested, this);
        }

        stop();
        completeQualityChange(false);
        isFragmentProcessingInProgress = false;
        timeToLoadDelay = 0;
        seekTarget = NaN;
        playbackController = null;
        playListMetrics = null;
    }

    instance = {
        initialize: initialize,
        getStreamProcessor: getStreamProcessor,
        getSeekTarget: getSeekTarget,
        setSeekTarget: setSeekTarget,
        getFragmentModel: getFragmentModel,
        setTimeToLoadDelay: setTimeToLoadDelay,
        getTimeToLoadDelay: getTimeToLoadDelay,
        replaceRequest: replaceRequest,
        start: start,
        stop: stop,
        reset: reset,
        setPlayList: setPlayList,
        getBufferTarget: getBufferTarget,
        finalisePlayList: finalisePlayList
    };

    setup();

    return instance;
}

ScheduleController.__dashjs_factory_name = 'ScheduleController';
exports['default'] = _coreFactoryMaker2['default'].getClassFactory(ScheduleController);
module.exports = exports['default'];
//# sourceMappingURL=ScheduleController.js.map


/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _voError = __webpack_require__(111);

var _voError2 = _interopRequireDefault(_voError);

var _coreEventBus = __webpack_require__(27);

var _coreEventBus2 = _interopRequireDefault(_coreEventBus);

var _coreEventsEvents = __webpack_require__(22);

var _coreEventsEvents2 = _interopRequireDefault(_coreEventsEvents);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _coreDebug = __webpack_require__(30);

var _coreDebug2 = _interopRequireDefault(_coreDebug);

var TIME_SYNC_FAILED_ERROR_CODE = 1;
var HTTP_TIMEOUT_MS = 5000;

function TimeSyncController() {

    var context = this.context;
    var log = (0, _coreDebug2['default'])(context).getInstance().log;
    var eventBus = (0, _coreEventBus2['default'])(context).getInstance();

    var instance = undefined,
        offsetToDeviceTimeMs = undefined,
        isSynchronizing = undefined,
        isInitialised = undefined,
        useManifestDateHeaderTimeSource = undefined,
        handlers = undefined,
        metricsModel = undefined,
        dashMetrics = undefined;

    function initialize(timingSources, useManifestDateHeader) {
        useManifestDateHeaderTimeSource = useManifestDateHeader;
        offsetToDeviceTimeMs = 0;
        isSynchronizing = false;
        isInitialised = false;

        // a list of known schemeIdUris and a method to call with @value
        handlers = {
            'urn:mpeg:dash:utc:http-head:2014': httpHeadHandler,
            'urn:mpeg:dash:utc:http-xsdate:2014': httpHandler.bind(null, xsdatetimeDecoder),
            'urn:mpeg:dash:utc:http-iso:2014': httpHandler.bind(null, iso8601Decoder),
            'urn:mpeg:dash:utc:direct:2014': directHandler,

            // some specs referencing early ISO23009-1 drafts incorrectly use
            // 2012 in the URI, rather than 2014. support these for now.
            'urn:mpeg:dash:utc:http-head:2012': httpHeadHandler,
            'urn:mpeg:dash:utc:http-xsdate:2012': httpHandler.bind(null, xsdatetimeDecoder),
            'urn:mpeg:dash:utc:http-iso:2012': httpHandler.bind(null, iso8601Decoder),
            'urn:mpeg:dash:utc:direct:2012': directHandler,

            // it isn't clear how the data returned would be formatted, and
            // no public examples available so http-ntp not supported for now.
            // presumably you would do an arraybuffer type xhr and decode the
            // binary data returned but I would want to see a sample first.
            'urn:mpeg:dash:utc:http-ntp:2014': notSupportedHandler,

            // not clear how this would be supported in javascript (in browser)
            'urn:mpeg:dash:utc:ntp:2014': notSupportedHandler,
            'urn:mpeg:dash:utc:sntp:2014': notSupportedHandler
        };

        if (!getIsSynchronizing()) {
            attemptSync(timingSources);
            setIsInitialised(true);
        }
    }

    function setConfig(config) {
        if (!config) return;

        if (config.metricsModel) {
            metricsModel = config.metricsModel;
        }

        if (config.dashMetrics) {
            dashMetrics = config.dashMetrics;
        }
    }

    function getOffsetToDeviceTimeMs() {
        return getOffsetMs();
    }

    function setIsSynchronizing(value) {
        isSynchronizing = value;
    }

    function getIsSynchronizing() {
        return isSynchronizing;
    }

    function setIsInitialised(value) {
        isInitialised = value;
    }

    function setOffsetMs(value) {
        offsetToDeviceTimeMs = value;
    }

    function getOffsetMs() {
        return offsetToDeviceTimeMs;
    }

    // takes xsdatetime and returns milliseconds since UNIX epoch
    // may not be necessary as xsdatetime is very similar to ISO 8601
    // which is natively understood by javascript Date parser
    function alternateXsdatetimeDecoder(xsdatetimeStr) {
        // taken from DashParser - should probably refactor both uses
        var SECONDS_IN_MIN = 60;
        var MINUTES_IN_HOUR = 60;
        var MILLISECONDS_IN_SECONDS = 1000;
        var datetimeRegex = /^([0-9]{4})-([0-9]{2})-([0-9]{2})T([0-9]{2}):([0-9]{2})(?::([0-9]*)(\.[0-9]*)?)?(?:([+\-])([0-9]{2})([0-9]{2}))?/;

        var utcDate, timezoneOffset;

        var match = datetimeRegex.exec(xsdatetimeStr);

        // If the string does not contain a timezone offset different browsers can interpret it either
        // as UTC or as a local time so we have to parse the string manually to normalize the given date value for
        // all browsers
        utcDate = Date.UTC(parseInt(match[1], 10), parseInt(match[2], 10) - 1, // months start from zero
        parseInt(match[3], 10), parseInt(match[4], 10), parseInt(match[5], 10), match[6] && (parseInt(match[6], 10) || 0), match[7] && parseFloat(match[7]) * MILLISECONDS_IN_SECONDS || 0);
        // If the date has timezone offset take it into account as well
        if (match[9] && match[10]) {
            timezoneOffset = parseInt(match[9], 10) * MINUTES_IN_HOUR + parseInt(match[10], 10);
            utcDate += (match[8] === '+' ? -1 : +1) * timezoneOffset * SECONDS_IN_MIN * MILLISECONDS_IN_SECONDS;
        }

        return new Date(utcDate).getTime();
    }

    // try to use the built in parser, since xsdate is a constrained ISO8601
    // which is supported natively by Date.parse. if that fails, try a
    // regex-based version used elsewhere in this application.
    function xsdatetimeDecoder(xsdatetimeStr) {
        var parsedDate = Date.parse(xsdatetimeStr);

        if (isNaN(parsedDate)) {
            parsedDate = alternateXsdatetimeDecoder(xsdatetimeStr);
        }

        return parsedDate;
    }

    // takes ISO 8601 timestamp and returns milliseconds since UNIX epoch
    function iso8601Decoder(isoStr) {
        return Date.parse(isoStr);
    }

    // takes RFC 1123 timestamp (which is same as ISO8601) and returns
    // milliseconds since UNIX epoch
    function rfc1123Decoder(dateStr) {
        return Date.parse(dateStr);
    }

    function notSupportedHandler(url, onSuccessCB, onFailureCB) {
        onFailureCB();
    }

    function directHandler(xsdatetimeStr, onSuccessCB, onFailureCB) {
        var time = xsdatetimeDecoder(xsdatetimeStr);

        if (!isNaN(time)) {
            onSuccessCB(time);
            return;
        }

        onFailureCB();
    }

    function httpHandler(decoder, url, onSuccessCB, onFailureCB, isHeadRequest) {
        var oncomplete, onload;
        var complete = false;
        var req = new XMLHttpRequest();

        var verb = isHeadRequest ? 'HEAD' : 'GET';
        var urls = url.match(/\S+/g);

        // according to ISO 23009-1, url could be a white-space
        // separated list of URLs. just handle one at a time.
        url = urls.shift();

        oncomplete = function () {
            if (complete) {
                return;
            }

            // we only want to pass through here once per xhr,
            // regardless of whether the load was successful.
            complete = true;

            // if there are more urls to try, call self.
            if (urls.length) {
                httpHandler(decoder, urls.join(' '), onSuccessCB, onFailureCB, isHeadRequest);
            } else {
                onFailureCB();
            }
        };

        onload = function () {
            var time, result;

            if (req.status === 200) {
                time = isHeadRequest ? req.getResponseHeader('Date') : req.response;

                result = decoder(time);

                // decoder returns NaN if non-standard input
                if (!isNaN(result)) {
                    onSuccessCB(result);
                    complete = true;
                }
            }
        };

        req.open(verb, url);
        req.timeout = HTTP_TIMEOUT_MS || 0;
        req.onload = onload;
        req.onloadend = oncomplete;
        req.send();
    }

    function httpHeadHandler(url, onSuccessCB, onFailureCB) {
        httpHandler(rfc1123Decoder, url, onSuccessCB, onFailureCB, true);
    }

    function checkForDateHeader() {
        var metrics = metricsModel.getReadOnlyMetricsFor('stream');
        var dateHeaderValue = dashMetrics.getLatestMPDRequestHeaderValueByID(metrics, 'Date');
        var dateHeaderTime = dateHeaderValue !== null ? new Date(dateHeaderValue).getTime() : Number.NaN;

        if (!isNaN(dateHeaderTime)) {
            setOffsetMs(dateHeaderTime - new Date().getTime());
            completeTimeSyncSequence(false, dateHeaderTime / 1000, offsetToDeviceTimeMs);
        } else {
            completeTimeSyncSequence(true);
        }
    }

    function completeTimeSyncSequence(failed, time, offset) {
        setIsSynchronizing(false);
        eventBus.trigger(_coreEventsEvents2['default'].TIME_SYNCHRONIZATION_COMPLETED, { time: time, offset: offset, error: failed ? new _voError2['default'](TIME_SYNC_FAILED_ERROR_CODE) : null });
    }

    function attemptSync(sources, sourceIndex) {

        // if called with no sourceIndex, use zero (highest priority)
        var index = sourceIndex || 0;

        // the sources should be ordered in priority from the manifest.
        // try each in turn, from the top, until either something
        // sensible happens, or we run out of sources to try.
        var source = sources[index];

        // callback to emit event to listeners
        var onComplete = function onComplete(time, offset) {
            var failed = !time || !offset;
            if (failed && useManifestDateHeaderTimeSource) {
                //Before falling back to binary search , check if date header exists on MPD. if so, use for a time source.
                checkForDateHeader();
            } else {
                completeTimeSyncSequence(failed, time, offset);
            }
        };

        setIsSynchronizing(true);

        if (source) {
            // check if there is a handler for this @schemeIdUri
            if (handlers.hasOwnProperty(source.schemeIdUri)) {
                // if so, call it with its @value
                handlers[source.schemeIdUri](source.value, function (serverTime) {
                    // the timing source returned something useful
                    var deviceTime = new Date().getTime();
                    var offset = serverTime - deviceTime;

                    setOffsetMs(offset);

                    log('Local time:      ' + new Date(deviceTime));
                    log('Server time:     ' + new Date(serverTime));
                    log('Difference (ms): ' + offset);

                    onComplete(serverTime, offset);
                }, function () {
                    // the timing source was probably uncontactable
                    // or returned something we can't use - try again
                    // with the remaining sources
                    attemptSync(sources, index + 1);
                });
            } else {
                // an unknown schemeIdUri must have been found
                // try again with the remaining sources
                attemptSync(sources, index + 1);
            }
        } else {
            // no valid time source could be found, just use device time
            setOffsetMs(0);
            onComplete();
        }
    }

    function reset() {
        setIsInitialised(false);
        setIsSynchronizing(false);
    }

    instance = {
        initialize: initialize,
        getOffsetToDeviceTimeMs: getOffsetToDeviceTimeMs,
        setConfig: setConfig,
        reset: reset
    };

    return instance;
}

TimeSyncController.__dashjs_factory_name = 'TimeSyncController';
var factory = _coreFactoryMaker2['default'].getSingletonFactory(TimeSyncController);
factory.TIME_SYNC_FAILED_ERROR_CODE = TIME_SYNC_FAILED_ERROR_CODE;
factory.HTTP_TIMEOUT_MS = HTTP_TIMEOUT_MS;
exports['default'] = factory;
module.exports = exports['default'];
//# sourceMappingURL=TimeSyncController.js.map


/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _XlinkLoader = __webpack_require__(1350);

var _XlinkLoader2 = _interopRequireDefault(_XlinkLoader);

var _coreEventBus = __webpack_require__(27);

var _coreEventBus2 = _interopRequireDefault(_coreEventBus);

var _coreEventsEvents = __webpack_require__(22);

var _coreEventsEvents2 = _interopRequireDefault(_coreEventsEvents);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _externalsXml2json = __webpack_require__(393);

var _externalsXml2json2 = _interopRequireDefault(_externalsXml2json);

var _utilsURLUtils = __webpack_require__(242);

var _utilsURLUtils2 = _interopRequireDefault(_utilsURLUtils);

var RESOLVE_TYPE_ONLOAD = 'onLoad';
var RESOLVE_TYPE_ONACTUATE = 'onActuate';
var ELEMENT_TYPE_PERIOD = 'Period';
var ELEMENT_TYPE_ADAPTATIONSET = 'AdaptationSet';
var ELEMENT_TYPE_EVENTSTREAM = 'EventStream';
var RESOLVE_TO_ZERO = 'urn:mpeg:dash:resolve-to-zero:2013';

function XlinkController(config) {

    var context = this.context;
    var eventBus = (0, _coreEventBus2['default'])(context).getInstance();
    var urlUtils = (0, _utilsURLUtils2['default'])(context).getInstance();

    var instance = undefined,
        matchers = undefined,
        iron = undefined,
        manifest = undefined,
        converter = undefined,
        xlinkLoader = undefined;

    function setup() {
        eventBus.on(_coreEventsEvents2['default'].XLINK_ELEMENT_LOADED, onXlinkElementLoaded, instance);

        xlinkLoader = (0, _XlinkLoader2['default'])(context).create({
            errHandler: config.errHandler,
            metricsModel: config.metricsModel,
            requestModifier: config.requestModifier
        });
    }

    function setMatchers(value) {
        matchers = value;
    }

    function setIron(value) {
        iron = value;
    }

    /**
     * <p>Triggers the resolution of the xlink.onLoad attributes in the manifest file </p>
     * @param {Object} mpd - the manifest
     */
    function resolveManifestOnLoad(mpd) {
        var elements;
        // First resolve all periods, so unnecessary requests inside onLoad Periods with Default content are avoided
        converter = new _externalsXml2json2['default']({
            escapeMode: false,
            attributePrefix: '',
            arrayAccessForm: 'property',
            emptyNodeForm: 'object',
            stripWhitespaces: false,
            enableToStringFunc: false,
            ignoreRoot: true,
            matchers: matchers
        });

        manifest = mpd;
        elements = getElementsToResolve(manifest.Period_asArray, manifest, ELEMENT_TYPE_PERIOD, RESOLVE_TYPE_ONLOAD);
        resolve(elements, ELEMENT_TYPE_PERIOD, RESOLVE_TYPE_ONLOAD);
    }

    function reset() {
        eventBus.off(_coreEventsEvents2['default'].XLINK_ELEMENT_LOADED, onXlinkElementLoaded, instance);

        if (xlinkLoader) {
            xlinkLoader.reset();
            xlinkLoader = null;
        }
    }

    function resolve(elements, type, resolveType) {
        var resolveObject = {};
        var element, url, i;

        resolveObject.elements = elements;
        resolveObject.type = type;
        resolveObject.resolveType = resolveType;
        // If nothing to resolve, directly call allElementsLoaded
        if (resolveObject.elements.length === 0) {
            onXlinkAllElementsLoaded(resolveObject);
        }
        for (i = 0; i < resolveObject.elements.length; i++) {
            element = resolveObject.elements[i];
            if (urlUtils.isHTTPURL(element.url)) {
                url = element.url;
            } else {
                url = element.originalContent.BaseURL + element.url;
            }
            xlinkLoader.load(url, element, resolveObject);
        }
    }

    function onXlinkElementLoaded(event) {
        var element, resolveObject, index;

        var openingTag = '<response>';
        var closingTag = '</response>';
        var mergedContent = '';

        element = event.element;
        resolveObject = event.resolveObject;
        // if the element resolved into content parse the content
        if (element.resolvedContent) {
            // we add a parent elements so the converter is able to parse multiple elements of the same type which are not wrapped inside a container
            index = element.resolvedContent.indexOf('>') + 1; //find the closing position of the xml tag
            mergedContent = element.resolvedContent.substr(0, index) + openingTag + element.resolvedContent.substr(index) + closingTag;
            element.resolvedContent = converter.xml_str2json(mergedContent);
        }
        if (isResolvingFinished(resolveObject)) {
            onXlinkAllElementsLoaded(resolveObject);
        }
    }

    // We got to wait till all elements of the current queue are resolved before merging back
    function onXlinkAllElementsLoaded(resolveObject) {
        var elements = [];
        var i, obj;

        mergeElementsBack(resolveObject);
        if (resolveObject.resolveType === RESOLVE_TYPE_ONACTUATE) {
            eventBus.trigger(_coreEventsEvents2['default'].XLINK_READY, { manifest: manifest });
        }
        if (resolveObject.resolveType === RESOLVE_TYPE_ONLOAD) {
            switch (resolveObject.type) {
                // Start resolving the other elements. We can do Adaptation Set and EventStream in parallel
                case ELEMENT_TYPE_PERIOD:
                    for (i = 0; i < manifest[ELEMENT_TYPE_PERIOD + '_asArray'].length; i++) {
                        obj = manifest[ELEMENT_TYPE_PERIOD + '_asArray'][i];
                        if (obj.hasOwnProperty(ELEMENT_TYPE_ADAPTATIONSET + '_asArray')) {
                            elements = elements.concat(getElementsToResolve(obj[ELEMENT_TYPE_ADAPTATIONSET + '_asArray'], obj, ELEMENT_TYPE_ADAPTATIONSET, RESOLVE_TYPE_ONLOAD));
                        }
                        if (obj.hasOwnProperty(ELEMENT_TYPE_EVENTSTREAM + '_asArray')) {
                            elements = elements.concat(getElementsToResolve(obj[ELEMENT_TYPE_EVENTSTREAM + '_asArray'], obj, ELEMENT_TYPE_EVENTSTREAM, RESOLVE_TYPE_ONLOAD));
                        }
                    }
                    resolve(elements, ELEMENT_TYPE_ADAPTATIONSET, RESOLVE_TYPE_ONLOAD);
                    break;
                case ELEMENT_TYPE_ADAPTATIONSET:
                    // TODO: Resolve SegmentList here
                    eventBus.trigger(_coreEventsEvents2['default'].XLINK_READY, { manifest: manifest });
                    break;
            }
        }
    }

    // Returns the elements with the specific resolve Type
    function getElementsToResolve(elements, parentElement, type, resolveType) {
        var toResolve = [];
        var element, i, xlinkObject;
        // first remove all the resolve-to-zero elements
        for (i = elements.length - 1; i >= 0; i--) {
            element = elements[i];
            if (element.hasOwnProperty('xlink:href') && element['xlink:href'] === RESOLVE_TO_ZERO) {
                elements.splice(i, 1);
            }
        }
        // now get the elements with the right resolve type
        for (i = 0; i < elements.length; i++) {
            element = elements[i];
            if (element.hasOwnProperty('xlink:href') && element.hasOwnProperty('xlink:actuate') && element['xlink:actuate'] === resolveType) {
                xlinkObject = createXlinkObject(element['xlink:href'], parentElement, type, i, resolveType, element);
                toResolve.push(xlinkObject);
            }
        }
        return toResolve;
    }

    function mergeElementsBack(resolveObject) {
        var resolvedElements = [];
        var element, type, obj, i, j, k;
        // Start merging back from the end because of index shifting. Note that the elements with the same parent have to be ordered by index ascending
        for (i = resolveObject.elements.length - 1; i >= 0; i--) {
            element = resolveObject.elements[i];
            type = element.type + '_asArray';

            // Element couldn't be resolved or is TODO Inappropriate target: Remove all Xlink attributes
            if (!element.resolvedContent || isInappropriateTarget()) {
                delete element.originalContent['xlink:actuate'];
                delete element.originalContent['xlink:href'];
                resolvedElements.push(element.originalContent);
            }
            // Element was successfully resolved
            else if (element.resolvedContent) {
                    for (j = 0; j < element.resolvedContent[type].length; j++) {
                        //TODO Contains another Xlink attribute with xlink:actuate set to onload. Remove all xLink attributes
                        obj = element.resolvedContent[type][j];
                        resolvedElements.push(obj);
                    }
                }
            // Replace the old elements in the parent with the resolved ones
            element.parentElement[type].splice(element.index, 1);
            for (k = 0; k < resolvedElements.length; k++) {
                element.parentElement[type].splice(element.index + k, 0, resolvedElements[k]);
            }
            resolvedElements = [];
        }
        if (resolveObject.elements.length > 0) {
            iron.run(manifest);
        }
    }

    function createXlinkObject(url, parentElement, type, index, resolveType, originalContent) {
        return {
            url: url,
            parentElement: parentElement,
            type: type,
            index: index,
            resolveType: resolveType,
            originalContent: originalContent,
            resolvedContent: null,
            resolved: false
        };
    }

    // Check if all pending requests are finished
    function isResolvingFinished(elementsToResolve) {
        var i, obj;
        for (i = 0; i < elementsToResolve.elements.length; i++) {
            obj = elementsToResolve.elements[i];
            if (obj.resolved === false) {
                return false;
            }
        }
        return true;
    }

    // TODO : Do some syntax check here if the target is valid or not
    function isInappropriateTarget() {
        return false;
    }

    instance = {
        resolveManifestOnLoad: resolveManifestOnLoad,
        setMatchers: setMatchers,
        setIron: setIron,
        reset: reset
    };

    setup();
    return instance;
}

XlinkController.__dashjs_factory_name = 'XlinkController';
exports['default'] = _coreFactoryMaker2['default'].getClassFactory(XlinkController);
module.exports = exports['default'];
//# sourceMappingURL=XlinkController.js.map


/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _utilsDVBErrorsTranslator = __webpack_require__(1370);

var _utilsDVBErrorsTranslator2 = _interopRequireDefault(_utilsDVBErrorsTranslator);

var _MetricsReportingEvents = __webpack_require__(323);

var _MetricsReportingEvents2 = _interopRequireDefault(_MetricsReportingEvents);

var _controllersMetricsCollectionController = __webpack_require__(1360);

var _controllersMetricsCollectionController2 = _interopRequireDefault(_controllersMetricsCollectionController);

var _metricsMetricsHandlerFactory = __webpack_require__(591);

var _metricsMetricsHandlerFactory2 = _interopRequireDefault(_metricsMetricsHandlerFactory);

var _reportingReportingFactory = __webpack_require__(592);

var _reportingReportingFactory2 = _interopRequireDefault(_reportingReportingFactory);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

function MetricsReporting() {

    var context = this.context;
    var instance = undefined;

    var dvbErrorsTranslator = undefined;

    /**
     * Create a MetricsCollectionController, and a DVBErrorsTranslator
     * @param {Object} config - dependancies from owner
     * @return {MetricsCollectionController} Metrics Collection Controller
     */
    function createMetricsReporting(config) {
        dvbErrorsTranslator = (0, _utilsDVBErrorsTranslator2['default'])(context).getInstance({
            eventBus: config.eventBus,
            metricsModel: config.metricsModel
        });

        return (0, _controllersMetricsCollectionController2['default'])(context).create(config);
    }

    /**
     * Get the ReportingFactory to allow new reporters to be registered
     * @return {ReportingFactory} Reporting Factory
     */
    function getReportingFactory() {
        return (0, _reportingReportingFactory2['default'])(context).getInstance();
    }

    /**
     * Get the MetricsHandlerFactory to allow new handlers to be registered
     * @return {MetricsHandlerFactory} Metrics Handler Factory
     */
    function getMetricsHandlerFactory() {
        return (0, _metricsMetricsHandlerFactory2['default'])(context).getInstance();
    }

    instance = {
        createMetricsReporting: createMetricsReporting,
        getReportingFactory: getReportingFactory,
        getMetricsHandlerFactory: getMetricsHandlerFactory
    };

    return instance;
}

MetricsReporting.__dashjs_factory_name = 'MetricsReporting';
var factory = _coreFactoryMaker2['default'].getClassFactory(MetricsReporting);
factory.events = _MetricsReportingEvents2['default'];
exports['default'] = factory;
module.exports = exports['default'];
//# sourceMappingURL=MetricsReporting.js.map


/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _MetricsController = __webpack_require__(1361);

var _MetricsController2 = _interopRequireDefault(_MetricsController);

var _utilsManifestParsing = __webpack_require__(1371);

var _utilsManifestParsing2 = _interopRequireDefault(_utilsManifestParsing);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _MetricsReportingEvents = __webpack_require__(323);

var _MetricsReportingEvents2 = _interopRequireDefault(_MetricsReportingEvents);

var _coreEventsEvents = __webpack_require__(22);

var _coreEventsEvents2 = _interopRequireDefault(_coreEventsEvents);

function MetricsCollectionController(config) {

    var metricsControllers = {};

    var context = this.context;
    var eventBus = config.eventBus;

    function update(e) {
        if (e.error) {
            return;
        }

        // start by assuming all existing controllers need removing
        var controllersToRemove = Object.keys(metricsControllers);

        var metrics = (0, _utilsManifestParsing2['default'])(context).getInstance({
            dashManifestModel: config.dashManifestModel
        }).getMetrics(e.manifest);

        metrics.forEach(function (m) {
            var key = JSON.stringify(m);

            if (!metricsControllers.hasOwnProperty(key)) {
                try {
                    var controller = (0, _MetricsController2['default'])(context).create(config);
                    controller.initialize(m);
                    metricsControllers[key] = controller;
                } catch (e) {
                    // fail quietly
                }
            } else {
                    // we still need this controller - delete from removal list
                    controllersToRemove.splice(key, 1);
                }
        });

        // now remove the unwanted controllers
        controllersToRemove.forEach(function (c) {
            metricsControllers[c].reset();
            delete metricsControllers[c];
        });

        eventBus.trigger(_MetricsReportingEvents2['default'].METRICS_INITIALISATION_COMPLETE);
    }

    function reset() {
        Object.keys(metricsControllers).forEach(function (key) {
            metricsControllers[key].reset();
        });

        metricsControllers = {};
    }

    function setup() {

        eventBus.on(_coreEventsEvents2['default'].MANIFEST_UPDATED, update);
        eventBus.on(_coreEventsEvents2['default'].STREAM_TEARDOWN_COMPLETE, reset);
    }

    setup();

    // don't export any actual methods
    return {};
}

MetricsCollectionController.__dashjs_factory_name = 'MetricsCollectionController';
exports['default'] = _coreFactoryMaker2['default'].getClassFactory(MetricsCollectionController);
module.exports = exports['default'];
//# sourceMappingURL=MetricsCollectionController.js.map


/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _RangeController = __webpack_require__(1363);

var _RangeController2 = _interopRequireDefault(_RangeController);

var _ReportingController = __webpack_require__(1364);

var _ReportingController2 = _interopRequireDefault(_ReportingController);

var _MetricsHandlersController = __webpack_require__(1362);

var _MetricsHandlersController2 = _interopRequireDefault(_MetricsHandlersController);

function MetricsController(config) {

    var metricsHandlersController = undefined,
        reportingController = undefined,
        rangeController = undefined,
        instance = undefined;

    var context = this.context;

    function initialize(metricsEntry) {
        try {
            rangeController = (0, _RangeController2['default'])(context).create({
                mediaElement: config.mediaElement
            });

            rangeController.initialize(metricsEntry.Range);

            reportingController = (0, _ReportingController2['default'])(context).create({
                log: config.log
            });

            reportingController.initialize(metricsEntry.Reporting, rangeController);

            metricsHandlersController = (0, _MetricsHandlersController2['default'])(context).create({
                log: config.log,
                eventBus: config.eventBus
            });

            metricsHandlersController.initialize(metricsEntry.metrics, reportingController);
        } catch (e) {
            reset();
            throw e;
        }
    }

    function reset() {
        if (metricsHandlersController) {
            metricsHandlersController.reset();
        }

        if (reportingController) {
            reportingController.reset();
        }

        if (rangeController) {
            rangeController.reset();
        }
    }

    instance = {
        initialize: initialize,
        reset: reset
    };

    return instance;
}

MetricsController.__dashjs_factory_name = 'MetricsController';
exports['default'] = _coreFactoryMaker2['default'].getClassFactory(MetricsController);
module.exports = exports['default'];
//# sourceMappingURL=MetricsController.js.map


/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _metricsMetricsHandlerFactory = __webpack_require__(591);

var _metricsMetricsHandlerFactory2 = _interopRequireDefault(_metricsMetricsHandlerFactory);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _MediaPlayerEvents = __webpack_require__(238);

var _MediaPlayerEvents2 = _interopRequireDefault(_MediaPlayerEvents);

function MetricsHandlersController(config) {
    var handlers = [];

    var instance = undefined;
    var context = this.context;
    var eventBus = config.eventBus;

    var metricsHandlerFactory = (0, _metricsMetricsHandlerFactory2['default'])(context).getInstance({
        log: config.log,
        eventBus: config.eventBus
    });

    function handle(e) {
        handlers.forEach(function (handler) {
            handler.handleNewMetric(e.metric, e.value, e.mediaType);
        });
    }

    function initialize(metrics, reportingController) {
        metrics.split(',').forEach(function (m, midx, ms) {
            var handler;

            // there is a bug in ISO23009-1 where the metrics attribute
            // is a comma-separated list but HttpList key can contain a
            // comma enclosed by ().
            if (m.indexOf('(') !== -1 && m.indexOf(')') === -1) {
                var nextm = ms[midx + 1];

                if (nextm && nextm.indexOf('(') === -1 && nextm.indexOf(')') !== -1) {
                    m += ',' + nextm;

                    // delete the next metric so forEach does not visit.
                    delete ms[midx + 1];
                }
            }

            handler = metricsHandlerFactory.create(m, reportingController);

            if (handler) {
                handlers.push(handler);
            }
        });

        eventBus.on(_MediaPlayerEvents2['default'].METRIC_ADDED, handle, instance);

        eventBus.on(_MediaPlayerEvents2['default'].METRIC_UPDATED, handle, instance);
    }

    function reset() {
        eventBus.off(_MediaPlayerEvents2['default'].METRIC_ADDED, handle, instance);

        eventBus.off(_MediaPlayerEvents2['default'].METRIC_UPDATED, handle, instance);

        handlers.forEach(function (handler) {
            return handler.reset();
        });

        handlers = [];
    }

    instance = {
        initialize: initialize,
        reset: reset
    };

    return instance;
}

MetricsHandlersController.__dashjs_factory_name = 'MetricsHandlersController';
exports['default'] = _coreFactoryMaker2['default'].getClassFactory(MetricsHandlersController);
module.exports = exports['default'];
//# sourceMappingURL=MetricsHandlersController.js.map


/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _utilsCustomTimeRanges = __webpack_require__(598);

var _utilsCustomTimeRanges2 = _interopRequireDefault(_utilsCustomTimeRanges);

function RangeController(config) {

    var useWallClockTime = false;
    var context = this.context;
    var instance = undefined,
        ranges = undefined;

    var mediaElement = config.mediaElement;

    function initialize(rs) {
        if (rs && rs.length) {
            rs.forEach(function (r) {
                var start = r.starttime;
                var end = start + r.duration;

                ranges.add(start, end);
            });

            useWallClockTime = !!rs[0]._useWallClockTime;
        }
    }

    function reset() {
        ranges.clear();
    }

    function setup() {
        ranges = (0, _utilsCustomTimeRanges2['default'])(context).create();
    }

    function isEnabled() {
        var numRanges = ranges.length;
        var time;

        if (!numRanges) {
            return true;
        }

        // When not present, DASH Metrics reporting is requested
        // for the whole duration of the content.
        time = useWallClockTime ? new Date().getTime() / 1000 : mediaElement.currentTime;

        for (var i = 0; i < numRanges; i += 1) {
            var start = ranges.start(i);
            var end = ranges.end(i);

            if (start <= time && time < end) {
                return true;
            }
        }

        return false;
    }

    instance = {
        initialize: initialize,
        reset: reset,
        isEnabled: isEnabled
    };

    setup();

    return instance;
}

RangeController.__dashjs_factory_name = 'RangeController';
exports['default'] = _coreFactoryMaker2['default'].getClassFactory(RangeController);
module.exports = exports['default'];
//# sourceMappingURL=RangeController.js.map


/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _reportingReportingFactory = __webpack_require__(592);

var _reportingReportingFactory2 = _interopRequireDefault(_reportingReportingFactory);

function ReportingController(config) {

    var reporters = [];
    var instance = undefined;

    var reportingFactory = (0, _reportingReportingFactory2['default'])(this.context).getInstance({
        log: config.log
    });

    function initialize(reporting, rangeController) {
        // "if multiple Reporting elements are present, it is expected that
        // the client processes one of the recognized reporting schemes."
        // to ignore this, and support multiple Reporting per Metric,
        // simply change the 'some' below to 'forEach'
        reporting.some(function (r) {
            var reporter = reportingFactory.create(r, rangeController);

            if (reporter) {
                reporters.push(reporter);
                return true;
            }
        });
    }

    function reset() {
        reporters.forEach(function (r) {
            return r.reset();
        });
        reporters = [];
    }

    function report(type, vos) {
        reporters.forEach(function (r) {
            return r.report(type, vos);
        });
    }

    instance = {
        initialize: initialize,
        reset: reset,
        report: report
    };

    return instance;
}

ReportingController.__dashjs_factory_name = 'ReportingController';
exports['default'] = _coreFactoryMaker2['default'].getClassFactory(ReportingController);
module.exports = exports['default'];
//# sourceMappingURL=ReportingController.js.map


/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _utilsHandlerHelpers = __webpack_require__(593);

var _utilsHandlerHelpers2 = _interopRequireDefault(_utilsHandlerHelpers);

function BufferLevelHandler() {

    var instance = undefined,
        reportingController = undefined,
        n = undefined,
        name = undefined,
        interval = undefined,
        lastReportedTime = undefined;

    var context = this.context;
    var handlerHelpers = (0, _utilsHandlerHelpers2['default'])(context).getInstance();

    var storedVOs = [];

    function getLowestBufferLevelVO() {
        try {
            return Object.keys(storedVOs).map(function (key) {
                return storedVOs[key];
            }).reduce(function (a, b) {
                return a.level < b.level ? a : b;
            });
        } catch (e) {
            return;
        }
    }

    function intervalCallback() {
        var vo = getLowestBufferLevelVO();

        if (vo) {
            if (lastReportedTime !== vo.t) {
                lastReportedTime = vo.t;
                reportingController.report(name, vo);
            }
        }
    }

    function initialize(basename, rc, n_ms) {
        if (rc) {
            // this will throw if n is invalid, to be
            // caught by the initialize caller.
            n = handlerHelpers.validateN(n_ms);
            reportingController = rc;
            name = handlerHelpers.reconstructFullMetricName(basename, n_ms);
            interval = setInterval(intervalCallback, n);
        }
    }

    function reset() {
        clearInterval(interval);
        interval = null;
        n = 0;
        reportingController = null;
        lastReportedTime = null;
    }

    function handleNewMetric(metric, vo, type) {
        if (metric === 'BufferLevel') {
            storedVOs[type] = vo;
        }
    }

    instance = {
        initialize: initialize,
        reset: reset,
        handleNewMetric: handleNewMetric
    };

    return instance;
}

BufferLevelHandler.__dashjs_factory_name = 'BufferLevelHandler';
exports['default'] = _coreFactoryMaker2['default'].getClassFactory(BufferLevelHandler);
module.exports = exports['default'];
//# sourceMappingURL=BufferLevelHandler.js.map


/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _MetricsReportingEvents = __webpack_require__(323);

var _MetricsReportingEvents2 = _interopRequireDefault(_MetricsReportingEvents);

function DVBErrorsHandler(config) {

    var instance = undefined,
        reportingController = undefined;

    var eventBus = config.eventBus;

    function onInitialisationComplete() {
        // we only want to report this once per call to initialize
        eventBus.off(_MetricsReportingEvents2['default'].METRICS_INITIALISATION_COMPLETE, onInitialisationComplete, this);

        // Note: A Player becoming a reporting Player is itself
        // something which is recorded by the DVBErrors metric.
        eventBus.trigger(_MetricsReportingEvents2['default'].BECAME_REPORTING_PLAYER);
    }

    function initialize(unused, rc) {
        if (rc) {
            reportingController = rc;

            eventBus.on(_MetricsReportingEvents2['default'].METRICS_INITIALISATION_COMPLETE, onInitialisationComplete, this);
        }
    }

    function reset() {
        reportingController = null;
    }

    function handleNewMetric(metric, vo) {
        // simply pass metric straight through
        if (metric === 'DVBErrors') {
            if (reportingController) {
                reportingController.report(metric, vo);
            }
        }
    }

    instance = {
        initialize: initialize,
        reset: reset,
        handleNewMetric: handleNewMetric
    };

    return instance;
}

exports['default'] = _coreFactoryMaker2['default'].getClassFactory(DVBErrorsHandler);
module.exports = exports['default'];
//# sourceMappingURL=DVBErrorsHandler.js.map


/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

function GenericMetricHandler() {

    var instance = undefined,
        metricName = undefined,
        reportingController = undefined;

    function initialize(name, rc) {
        metricName = name;
        reportingController = rc;
    }

    function reset() {
        reportingController = null;
        metricName = undefined;
    }

    function handleNewMetric(metric, vo) {
        // simply pass metric straight through
        if (metric === metricName) {
            if (reportingController) {
                reportingController.report(metricName, vo);
            }
        }
    }

    instance = {
        initialize: initialize,
        reset: reset,
        handleNewMetric: handleNewMetric
    };

    return instance;
}

GenericMetricHandler.__dashjs_factory_name = 'GenericMetricHandler';
exports['default'] = _coreFactoryMaker2['default'].getClassFactory(GenericMetricHandler);
module.exports = exports['default'];
//# sourceMappingURL=GenericMetricHandler.js.map


/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _utilsHandlerHelpers = __webpack_require__(593);

var _utilsHandlerHelpers2 = _interopRequireDefault(_utilsHandlerHelpers);

function HttpListHandler() {

    var instance = undefined,
        reportingController = undefined,
        n = undefined,
        type = undefined,
        name = undefined,
        interval = undefined;

    var storedVos = [];

    var handlerHelpers = (0, _utilsHandlerHelpers2['default'])(this.context).getInstance();

    function intervalCallback() {
        var vos = storedVos;

        if (vos.length) {
            if (reportingController) {
                reportingController.report(name, vos);
            }
        }

        storedVos = [];
    }

    function initialize(basename, rc, n_ms, requestType) {
        if (rc) {

            // this will throw if n is invalid, to be
            // caught by the initialize caller.
            n = handlerHelpers.validateN(n_ms);

            reportingController = rc;

            if (requestType && requestType.length) {
                type = requestType;
            }

            name = handlerHelpers.reconstructFullMetricName(basename, n_ms, requestType);

            interval = setInterval(intervalCallback, n);
        }
    }

    function reset() {
        clearInterval(interval);
        interval = null;
        n = null;
        type = null;
        storedVos = [];
        reportingController = null;
    }

    function handleNewMetric(metric, vo) {
        if (metric === 'HttpList') {
            if (!type || type === vo.type) {
                storedVos.push(vo);
            }
        }
    }

    instance = {
        initialize: initialize,
        reset: reset,
        handleNewMetric: handleNewMetric
    };

    return instance;
}

HttpListHandler.__dashjs_factory_name = 'HttpListHandler';
exports['default'] = _coreFactoryMaker2['default'].getClassFactory(HttpListHandler);
module.exports = exports['default'];
//# sourceMappingURL=HttpListHandler.js.map


/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _utilsMetricSerialiser = __webpack_require__(1372);

var _utilsMetricSerialiser2 = _interopRequireDefault(_utilsMetricSerialiser);

var _utilsRNG = __webpack_require__(1373);

var _utilsRNG2 = _interopRequireDefault(_utilsRNG);

function DVBReporting() {
    var instance = undefined;

    var context = this.context;
    var metricSerialiser = (0, _utilsMetricSerialiser2['default'])(context).getInstance();
    var randomNumberGenerator = (0, _utilsRNG2['default'])(context).getInstance();

    var USE_DRAFT_DVB_SPEC = true;
    var isReportingPlayer = false;
    var reportingPlayerStatusDecided = false;
    var reportingUrl = null;
    var rangeController = null;
    var allowPendingRequestsToCompleteOnReset = true;
    var pendingRequests = [];

    function doGetRequest(url, successCB, failureCB) {
        var req = new XMLHttpRequest();
        var oncomplete = function oncomplete() {
            var reqIndex = pendingRequests.indexOf(req);

            if (reqIndex === -1) {
                return;
            } else {
                pendingRequests.splice(reqIndex, 1);
            }

            if (req.status >= 200 && req.status < 300) {
                if (successCB) {
                    successCB();
                }
            } else {
                if (failureCB) {
                    failureCB();
                }
            }
        };

        pendingRequests.push(req);

        try {
            req.open('GET', url);
            req.onloadend = oncomplete;
            req.onerror = oncomplete;
            req.send();
        } catch (e) {
            req.onerror();
        }
    }

    function report(type, vos) {
        if (!Array.isArray(vos)) {
            vos = [vos];
        }

        // If the Player is not a reporting Player, then the Player shall
        // not report any errors.
        // ... In addition to any time restrictions specified by a Range
        // element within the Metrics element.
        if (isReportingPlayer && rangeController.isEnabled()) {

            // This reporting mechanism operates by creating one HTTP GET
            // request for every entry in the top level list of the metric.
            vos.forEach(function (vo) {
                var url = metricSerialiser.serialise(vo);

                // this has been proposed for errata
                if (USE_DRAFT_DVB_SPEC && type !== 'DVBErrors') {
                    url = 'metricname=' + type + '&' + url;
                }

                // Take the value of the @reportingUrl attribute, append a
                // question mark ('?') character and then append the string
                // created in the previous step.
                url = reportingUrl + '?' + url;

                // Make an HTTP GET request to the URL contained within the
                // string created in the previous step.
                doGetRequest(url, null, function () {
                    // If the Player is unable to make the report, for
                    // example because the @reportingUrl is invalid, the
                    // host cannot be reached, or an HTTP status code other
                    // than one in the 200 series is received, the Player
                    // shall cease being a reporting Player for the
                    // duration of the MPD.
                    isReportingPlayer = false;
                });
            });
        }
    }

    function initialize(entry, rc) {
        var probability;

        rangeController = rc;

        reportingUrl = entry['dvb:reportingUrl'];

        // If a required attribute is missing, the Reporting descriptor may
        // be ignored by the Player
        if (!reportingUrl) {
            throw new Error('required parameter missing (dvb:reportingUrl)');
        }

        // A Player's status, as a reporting Player or not, shall remain
        // static for the duration of the MPD, regardless of MPD updates.
        // (i.e. only calling reset (or failure) changes this state)
        if (!reportingPlayerStatusDecided) {
            // NOTE: DVB spec has a typo where it incorrectly references the
            // priority attribute, which should be probability
            probability = entry['dvb:probability'] || entry['dvb:priority'] || 0;
            // If the @priority attribute is set to 1000, it shall be a reporting Player.
            // If the @priority attribute is missing, the Player shall not be a reporting Player.
            // For any other value of the @probability attribute, it shall decide at random whether to be a
            // reporting Player, such that the probability of being one is @probability/1000.
            if (probability && (probability === 1000 || probability / 1000 >= randomNumberGenerator.random())) {
                isReportingPlayer = true;
            }

            reportingPlayerStatusDecided = true;
        }
    }

    function reset() {
        if (!allowPendingRequestsToCompleteOnReset) {
            pendingRequests.forEach(function (req) {
                return req.abort();
            });
            pendingRequests = [];
        }

        reportingPlayerStatusDecided = false;
        isReportingPlayer = false;
        reportingUrl = null;
        rangeController = null;
    }

    instance = {
        report: report,
        initialize: initialize,
        reset: reset
    };

    return instance;
}

DVBReporting.__dashjs_factory_name = 'DVBReporting';
exports['default'] = _coreFactoryMaker2['default'].getClassFactory(DVBReporting);
module.exports = exports['default'];
//# sourceMappingURL=DVBReporting.js.map


/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _voDVBErrors = __webpack_require__(1374);

var _voDVBErrors2 = _interopRequireDefault(_voDVBErrors);

var _coreEventsEvents = __webpack_require__(22);

var _coreEventsEvents2 = _interopRequireDefault(_coreEventsEvents);

var _MediaPlayerEvents = __webpack_require__(238);

var _MediaPlayerEvents2 = _interopRequireDefault(_MediaPlayerEvents);

var _MetricsReportingEvents = __webpack_require__(323);

var _MetricsReportingEvents2 = _interopRequireDefault(_MetricsReportingEvents);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

function DVBErrorsTranslator(config) {

    var instance = undefined;
    var eventBus = config.eventBus;
    var metricModel = config.metricsModel;
    var mpd = undefined;

    function report(vo) {
        var o = new _voDVBErrors2['default']();

        if (!mpd) {
            return;
        }

        for (var key in vo) {
            if (vo.hasOwnProperty(key)) {
                o[key] = vo[key];
            }
        }

        if (!o.mpdurl) {
            o.mpdurl = mpd.originalUrl || mpd.url;
        }

        if (!o.terror) {
            o.terror = new Date();
        }

        metricModel.addDVBErrors(o);
    }

    function onManifestUpdate(e) {
        if (e.error) {
            return;
        }

        mpd = e.manifest;
    }

    function onServiceLocationChanged(e) {
        report({
            errorcode: _voDVBErrors2['default'].BASE_URL_CHANGED,
            servicelocation: e.entry
        });
    }

    function onBecameReporter() {
        report({
            errorcode: _voDVBErrors2['default'].BECAME_REPORTER
        });
    }

    function handleHttpMetric(vo) {
        if (vo.responsecode === 0 || // connection failure - unknown
        vo.responsecode >= 400 || // HTTP error status code
        vo.responsecode < 100 || // unknown status codes
        vo.responsecode >= 600) {
            // unknown status codes
            report({
                errorcode: vo.responsecode || _voDVBErrors2['default'].CONNECTION_ERROR,
                url: vo.url,
                terror: vo.tresponse,
                servicelocation: vo._serviceLocation
            });
        }
    }

    function onMetricEvent(e) {
        switch (e.metric) {
            case 'HttpList':
                handleHttpMetric(e.value);
                break;
            default:
                break;
        }
    }

    function onPlaybackError(e) {
        var reason = e.error ? e.error.code : 0;
        var errorcode;

        switch (reason) {
            case MediaError.MEDIA_ERR_NETWORK:
                errorcode = _voDVBErrors2['default'].CONNECTION_ERROR;
                break;
            case MediaError.MEDIA_ERR_DECODE:
                errorcode = _voDVBErrors2['default'].CORRUPT_MEDIA_OTHER;
                break;
            default:
                return;
        }

        report({
            errorcode: errorcode
        });
    }

    function initialise() {
        eventBus.on(_coreEventsEvents2['default'].MANIFEST_UPDATED, onManifestUpdate, instance);
        eventBus.on(_coreEventsEvents2['default'].SERVICE_LOCATION_BLACKLIST_CHANGED, onServiceLocationChanged, instance);
        eventBus.on(_MediaPlayerEvents2['default'].METRIC_ADDED, onMetricEvent, instance);
        eventBus.on(_MediaPlayerEvents2['default'].METRIC_UPDATED, onMetricEvent, instance);
        eventBus.on(_MediaPlayerEvents2['default'].PLAYBACK_ERROR, onPlaybackError, instance);
        eventBus.on(_MetricsReportingEvents2['default'].BECAME_REPORTING_PLAYER, onBecameReporter, instance);
    }

    function reset() {
        eventBus.off(_coreEventsEvents2['default'].MANIFEST_UPDATED, onManifestUpdate, instance);
        eventBus.off(_coreEventsEvents2['default'].SERVICE_LOCATION_BLACKLIST_CHANGED, onServiceLocationChanged, instance);
        eventBus.off(_MediaPlayerEvents2['default'].METRIC_ADDED, onMetricEvent, instance);
        eventBus.off(_MediaPlayerEvents2['default'].METRIC_UPDATED, onMetricEvent, instance);
        eventBus.off(_MediaPlayerEvents2['default'].PLAYBACK_ERROR, onPlaybackError, instance);
        eventBus.off(_MetricsReportingEvents2['default'].BECAME_REPORTING_PLAYER, onBecameReporter, instance);
    }

    instance = {
        initialise: initialise,
        reset: reset
    };

    initialise();

    return instance;
}

DVBErrorsTranslator.__dashjs_factory_name = 'DVBErrorsTranslator';
exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(DVBErrorsTranslator);
module.exports = exports['default'];
//# sourceMappingURL=DVBErrorsTranslator.js.map


/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _voMetrics = __webpack_require__(1375);

var _voMetrics2 = _interopRequireDefault(_voMetrics);

var _voRange = __webpack_require__(1376);

var _voRange2 = _interopRequireDefault(_voRange);

var _voReporting = __webpack_require__(1377);

var _voReporting2 = _interopRequireDefault(_voReporting);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

function ManifestParsing(config) {
    var instance = undefined;
    var dashManifestModel = config.dashManifestModel;

    function getMetricsRangeStartTime(manifest, dynamic, range) {
        var mpd = dashManifestModel.getMpd(manifest);
        var periods;
        var presentationStartTime = 0;
        var reportingStartTime;

        if (dynamic) {
            // For services with MPD@type='dynamic', the start time is
            // indicated in wall clock time by adding the value of this
            // attribute to the value of the MPD@availabilityStartTime
            // attribute.
            presentationStartTime = mpd.availabilityStartTime.getTime() / 1000;
        } else {
            // For services with MPD@type='static', the start time is indicated
            // in Media Presentation time and is relative to the PeriodStart
            // time of the first Period in this MPD.
            periods = this.getRegularPeriods(manifest, mpd);

            if (periods.length) {
                presentationStartTime = periods[0].start;
            }
        }

        // When not present, DASH Metrics collection is
        // requested from the beginning of content
        // consumption.
        reportingStartTime = presentationStartTime;

        if (range && range.hasOwnProperty('starttime')) {
            reportingStartTime += range.starttime;
        }

        return reportingStartTime;
    }

    function getMetrics(manifest) {
        var metrics = [];

        if (manifest.Metrics_asArray) {
            manifest.Metrics_asArray.forEach(function (metric) {
                var metricEntry = new _voMetrics2['default']();
                var isDynamic = dashManifestModel.getIsDynamic(manifest);

                if (metric.hasOwnProperty('metrics')) {
                    metricEntry.metrics = metric.metrics;
                } else {
                    //console.log("Invalid Metrics. metrics must be set. Ignoring.");
                    return;
                }

                if (metric.Range_asArray) {
                    metric.Range_asArray.forEach(function (range) {
                        var rangeEntry = new _voRange2['default']();

                        rangeEntry.starttime = getMetricsRangeStartTime(manifest, isDynamic, range);

                        if (range.hasOwnProperty('duration')) {
                            rangeEntry.duration = range.duration;
                        } else {
                            // if not present, the value is identical to the
                            // Media Presentation duration.
                            rangeEntry.duration = dashManifestModel.getDuration(manifest);
                        }

                        rangeEntry._useWallClockTime = isDynamic;

                        metricEntry.Range.push(rangeEntry);
                    });
                }

                if (metric.Reporting_asArray) {
                    metric.Reporting_asArray.forEach(function (reporting) {
                        var reportingEntry = new _voReporting2['default']();

                        if (reporting.hasOwnProperty('schemeIdUri')) {
                            reportingEntry.schemeIdUri = reporting.schemeIdUri;
                        } else {
                            // Invalid Reporting. schemeIdUri must be set. Ignore.
                            return;
                        }

                        for (var prop in reporting) {
                            if (reporting.hasOwnProperty(prop)) {
                                reportingEntry[prop] = reporting[prop];
                            }
                        }

                        metricEntry.Reporting.push(reportingEntry);
                    });
                } else {
                    // Invalid Metrics. At least one reporting must be present. Ignore
                    return;
                }

                metrics.push(metricEntry);
            });
        }

        return metrics;
    }

    instance = {
        getMetrics: getMetrics
    };

    return instance;
}

ManifestParsing.__dashjs_factory_name = 'ManifestParsing';
exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(ManifestParsing);
module.exports = exports['default'];
//# sourceMappingURL=ManifestParsing.js.map


/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

function MetricSerialiser() {

    // For each entry in the top level list within the metric (in the case
    // of the DVBErrors metric each entry corresponds to an "error event"
    // described in clause 10.8.4) the Player shall:
    function serialise(metric) {
        var pairs = [];
        var obj = [];
        var key, value;

        // Take each (key, value) pair from the metric entry and create a
        // string consisting of the name of the key, followed by an equals
        // ('=') character, followed by the string representation of the
        // value. The string representation of the value is created based
        // on the type of the value following the instructions in Table 22.
        for (key in metric) {
            if (metric.hasOwnProperty(key) && key.indexOf('_') !== 0) {
                value = metric[key];

                // we want to ensure that keys still end up in the report
                // even if there is no value
                if (value === undefined || value === null) {
                    value = '';
                }

                // DVB A168 10.12.4 Table 22
                if (Array.isArray(value)) {
                    // if trace or similar is null, do not include in output
                    if (!value.length) {
                        continue;
                    }

                    obj = [];

                    value.forEach(function (v) {
                        var isBuiltIn = Object.prototype.toString.call(v).slice(8, -1) !== 'Object';

                        obj.push(isBuiltIn ? v : serialise(v));
                    });

                    value = obj.map(encodeURIComponent).join(',');
                } else if (typeof value === 'string') {
                    value = encodeURIComponent(value);
                } else if (value instanceof Date) {
                    value = value.toISOString();
                } else if (typeof value === 'number') {
                    value = Math.round(value);
                }

                pairs.push(key + '=' + value);
            }
        }

        // Concatenate the strings created in the previous step with an
        // ampersand ('&') character between each one.
        return pairs.join('&');
    }

    return {
        serialise: serialise
    };
}

MetricSerialiser.__dashjs_factory_name = 'MetricSerialiser';
exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(MetricSerialiser);
module.exports = exports['default'];
//# sourceMappingURL=MetricSerialiser.js.map


/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

function RNG() {

    // check whether secure random numbers are available. if not, revert to
    // using Math.random
    var crypto = window.crypto || window.msCrypto;

    // could just as easily use any other array type by changing line below
    var ArrayType = Uint32Array;
    var MAX_VALUE = Math.pow(2, ArrayType.BYTES_PER_ELEMENT * 8) - 1;

    // currently there is only one client for this code, and that only uses
    // a single random number per initialisation. may want to increase this
    // number if more consumers in the future
    var NUM_RANDOM_NUMBERS = 10;

    var randomNumbers = undefined,
        index = undefined,
        instance = undefined;

    function initialise() {
        if (crypto) {
            if (!randomNumbers) {
                randomNumbers = new ArrayType(NUM_RANDOM_NUMBERS);
            }
            crypto.getRandomValues(randomNumbers);
            index = 0;
        }
    }

    function rand(min, max) {
        var r;

        if (!min) {
            min = 0;
        }

        if (!max) {
            max = 1;
        }

        if (crypto) {
            if (index === randomNumbers.length) {
                initialise();
            }

            r = randomNumbers[index] / MAX_VALUE;
            index += 1;
        } else {
            r = Math.random();
        }

        return r * (max - min) + min;
    }

    instance = {
        random: rand
    };

    initialise();

    return instance;
}

RNG.__dashjs_factory_name = 'RNG';
exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(RNG);
module.exports = exports['default'];
//# sourceMappingURL=RNG.js.map


/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @class
 * @ignore
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var DVBErrors = function DVBErrors() {
    _classCallCheck(this, DVBErrors);

    this.mpdurl = null;
    // String - Absolute URL from which the MPD was originally
    // retrieved (MPD updates will not change this value).

    this.errorcode = null;
    // String - The value of errorcode depends upon the type
    // of error being reported. For an error listed in the
    // ErrorType column below the value is as described in the
    // Value column.
    //
    // ErrorType                                            Value
    // ---------                                            -----
    // HTTP error status code                               HTTP status code
    // Unknown HTTP status code                             HTTP status code
    // SSL connection failed                                "SSL" followed by SSL alert value
    // DNS resolution failed                                "C00"
    // Host unreachable                                     "C01"
    // Connection refused                                   "C02"
    // Connection error – Not otherwise specified           "C03"
    // Corrupt media – ISO BMFF container cannot be parsed  "M00"
    // Corrupt media – Not otherwise specified              "M01"
    // Changing Base URL in use due to errors               "F00"
    // Becoming an error reporting Player                   "S00"

    this.terror = null;
    // Real-Time - Date and time at which error occurred in UTC,
    // formatted as a combined date and time according to ISO 8601.

    this.url = null;
    // String - Absolute URL from which data was being requested
    // when this error occurred. If the error report is in relation
    // to corrupt media or changing BaseURL, this may be a null
    // string if the URL from which the media was obtained or
    // which led to the change of BaseURL is no longer known.

    this.ipaddress = null;
    // String - IP Address which the host name in "url" resolved to.
    // If the error report is in relation to corrupt media or
    // changing BaseURL, this may be a null string if the URL
    // from which the media was obtained or which led to the
    // change of BaseURL is no longer known.

    this.servicelocation = null;
    // String - The value of the serviceLocation field in the
    // BaseURL being used. In the event of this report indicating
    // a change of BaseURL this is the value from the BaseURL
    // being moved from.
};

DVBErrors.SSL_CONNECTION_FAILED_PREFIX = 'SSL';
DVBErrors.DNS_RESOLUTION_FAILED = 'C00';
DVBErrors.HOST_UNREACHABLE = 'C01';
DVBErrors.CONNECTION_REFUSED = 'C02';
DVBErrors.CONNECTION_ERROR = 'C03';
DVBErrors.CORRUPT_MEDIA_ISOBMFF = 'M00';
DVBErrors.CORRUPT_MEDIA_OTHER = 'M01';
DVBErrors.BASE_URL_CHANGED = 'F00';
DVBErrors.BECAME_REPORTER = 'S00';

exports['default'] = DVBErrors;
module.exports = exports['default'];
//# sourceMappingURL=DVBErrors.js.map


/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @class
 * @ignore
 */


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var Metrics = function Metrics() {
  _classCallCheck(this, Metrics);

  this.metrics = '';
  this.Range = [];
  this.Reporting = [];
};

exports['default'] = Metrics;
module.exports = exports['default'];
//# sourceMappingURL=Metrics.js.map


/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @class
 * @ignore
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Range = function Range() {
  _classCallCheck(this, Range);

  // as defined in ISO23009-1
  this.starttime = 0;
  this.duration = Infinity;

  // for internal use
  this._useWallClockTime = false;
};

exports["default"] = Range;
module.exports = exports["default"];
//# sourceMappingURL=Range.js.map


/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @class
 * @ignore
 */


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var Reporting = function Reporting() {
  _classCallCheck(this, Reporting);

  // Reporting is a DescriptorType and doesn't have any additional fields
  this.schemeIdUri = '';
  this.value = '';
};

exports['default'] = Reporting;
module.exports = exports['default'];
//# sourceMappingURL=Reporting.js.map


/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _dashModelsDashManifestModel = __webpack_require__(158);

var _dashModelsDashManifestModel2 = _interopRequireDefault(_dashModelsDashManifestModel);

var _utilsObjectUtils = __webpack_require__(1412);

var _utilsObjectUtils2 = _interopRequireDefault(_utilsObjectUtils);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var DEFAULT_INDEX = NaN;

var Node = function Node(_baseUrls, _selectedIdx) {
    _classCallCheck(this, Node);

    this.data = {
        baseUrls: _baseUrls || null,
        selectedIdx: _selectedIdx || DEFAULT_INDEX
    };
    this.children = [];
};

function BaseURLTreeModel() {

    var instance = undefined;
    var root = undefined;

    var context = this.context;
    var dashManifestModel = (0, _dashModelsDashManifestModel2['default'])(context).getInstance();
    var objectUtils = (0, _utilsObjectUtils2['default'])(context).getInstance();

    function setup() {
        root = new Node();
    }

    function updateChildData(node, index, element) {
        var baseUrls = dashManifestModel.getBaseURLsFromElement(element);

        if (!node[index]) {
            node[index] = new Node(baseUrls);
        } else {
            if (!objectUtils.areSimpleEquivalent(baseUrls, node[index].data.baseUrls)) {
                node[index].data.baseUrls = baseUrls;
                node[index].data.selectedIdx = DEFAULT_INDEX;
            }
        }
    }

    function getBaseURLCollectionsFromManifest(manifest) {
        var baseUrls = dashManifestModel.getBaseURLsFromElement(manifest);

        if (!objectUtils.areSimpleEquivalent(baseUrls, root.data.baseUrls)) {
            root.data.baseUrls = baseUrls;
            root.data.selectedIdx = DEFAULT_INDEX;
        }

        if (manifest.Period_asArray) {
            manifest.Period_asArray.forEach(function (p, pi) {
                updateChildData(root.children, pi, p);

                if (p.AdaptationSet_asArray) {
                    p.AdaptationSet_asArray.forEach(function (a, ai) {
                        updateChildData(root.children[pi].children, ai, a);

                        if (a.Representation_asArray) {
                            a.Representation_asArray.sort(dashManifestModel.getRepresentationSortFunction()).forEach(function (r, ri) {
                                updateChildData(root.children[pi].children[ai].children, ri, r);
                            });
                        }
                    });
                }
            });
        }
    }

    function walk(callback, node) {
        var target = node || root;

        callback(target.data);

        if (target.children) {
            target.children.forEach(function (child) {
                return walk(callback, child);
            });
        }
    }

    function invalidateSelectedIndexes(serviceLocation) {
        walk(function (data) {
            if (!isNaN(data.selectedIdx)) {
                if (serviceLocation === data.baseUrls[data.selectedIdx].serviceLocation) {
                    data.selectedIdx = DEFAULT_INDEX;
                }
            }
        });
    }

    function update(manifest) {
        getBaseURLCollectionsFromManifest(manifest);
    }

    function reset() {
        root = new Node();
    }

    function getForPath(path) {
        var target = root;
        var nodes = [target.data];

        path.forEach(function (p) {
            target = target.children[p];

            if (target) {
                nodes.push(target.data);
            }
        });

        return nodes.filter(function (n) {
            return n.baseUrls.length;
        });
    }

    instance = {
        reset: reset,
        update: update,
        getForPath: getForPath,
        invalidateSelectedIndexes: invalidateSelectedIndexes
    };

    setup();

    return instance;
}

BaseURLTreeModel.__dashjs_factory_name = 'BaseURLTreeModel';
exports['default'] = _coreFactoryMaker2['default'].getClassFactory(BaseURLTreeModel);
module.exports = exports['default'];
//# sourceMappingURL=BaseURLTreeModel.js.map


/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
  value: true
});

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _coreEventsEventsBase = __webpack_require__(319);

var _coreEventsEventsBase2 = _interopRequireDefault(_coreEventsEventsBase);

/**
 * @class
 *
 */

var ProtectionEvents = (function (_EventsBase) {
  _inherits(ProtectionEvents, _EventsBase);

  /**
   * @description Public facing external events to be used when including protection package.
   * All public events will be aggregated into the MediaPlayerEvents Class and can be accessed
   * via MediaPlayer.events.  public_ is the prefix that we use to move event names to MediaPlayerEvents.
   */

  function ProtectionEvents() {
    _classCallCheck(this, ProtectionEvents);

    _get(Object.getPrototypeOf(ProtectionEvents.prototype), 'constructor', this).call(this);

    /**
     * Event ID for events delivered when the protection set receives
     * a key message from the CDM
     *
     * @ignore
     */
    this.INTERNAL_KEY_MESSAGE = 'internalKeyMessage';

    /**
     * Event ID for events delivered when a key system selection procedure
     * completes
     * @ignore
     */
    this.INTERNAL_KEY_SYSTEM_SELECTED = 'internalKeySystemSelected';

    /**
     * Event ID for events delivered when a new key has been added
     *
     * @constant
     * @deprecated The latest versions of the EME specification no longer
     * use this event.  {@MediaPlayer.models.protectionModel.eventList.KEY_STATUSES_CHANGED}
     * is preferred.
     * @event ProtectionEvents#KEY_ADDED
     */
    this.KEY_ADDED = 'public_keyAdded';
    /**
     * Event ID for events delivered when an error is encountered by the CDM
     * while processing a license server response message
     * @event ProtectionEvents#KEY_ERROR
     */
    this.KEY_ERROR = 'public_keyError';

    /**
     * Event ID for events delivered when the protection set receives
     * a key message from the CDM
     * @event ProtectionEvents#KEY_MESSAGE
     */
    this.KEY_MESSAGE = 'public_keyMessage';

    /**
     * Event ID for events delivered when a key session close
     * process has completed
     * @event ProtectionEvents#KEY_SESSION_CLOSED
     */
    this.KEY_SESSION_CLOSED = 'public_keySessionClosed';

    /**
     * Event ID for events delivered when a new key sessions creation
     * process has completed
     * @event ProtectionEvents#KEY_SESSION_CREATED
     */
    this.KEY_SESSION_CREATED = 'public_keySessionCreated';

    /**
     * Event ID for events delivered when a key session removal
     * process has completed
     * @event ProtectionEvents#KEY_SESSION_REMOVED
     */
    this.KEY_SESSION_REMOVED = 'public_keySessionRemoved';

    /**
     * Event ID for events delivered when the status of one or more
     * decryption keys has changed
     * @event ProtectionEvents#KEY_STATUSES_CHANGED
     */
    this.KEY_STATUSES_CHANGED = 'public_keyStatusesChanged';

    /**
     * Event ID for events delivered when a key system access procedure
     * has completed
     * @ignore
     */
    this.KEY_SYSTEM_ACCESS_COMPLETE = 'keySystemAccessComplete';

    /**
     * Event ID for events delivered when a key system selection procedure
     * completes
     * @event ProtectionEvents#KEY_SYSTEM_SELECTED
     */
    this.KEY_SYSTEM_SELECTED = 'public_keySystemSelected';

    /**
     * Event ID for events delivered when a license request procedure
     * has completed
     * @event ProtectionEvents#LICENSE_REQUEST_COMPLETE
     */
    this.LICENSE_REQUEST_COMPLETE = 'public_licenseRequestComplete';

    /**
     * Event ID for needkey/encrypted events
     * @ignore
     */
    this.NEED_KEY = 'needkey';

    /**
     * Event ID for events delivered when the Protection system is detected and created.
     * @event ProtectionEvents#PROTECTION_CREATED
     */
    this.PROTECTION_CREATED = 'public_protectioncreated';

    /**
     * Event ID for events delivered when the Protection system is destroyed.
     * @event ProtectionEvents#PROTECTION_DESTROYED
     */
    this.PROTECTION_DESTROYED = 'public_protectiondestroyed';

    /**
     * Event ID for events delivered when a new server certificate has
     * been delivered to the CDM
     * @ignore
     */
    this.SERVER_CERTIFICATE_UPDATED = 'serverCertificateUpdated';

    /**
     * Event ID for events delivered when the process of shutting down
     * a protection set has completed
     * @ignore
     */
    this.TEARDOWN_COMPLETE = 'protectionTeardownComplete';

    /**
     * Event ID for events delivered when a HTMLMediaElement has been
     * associated with the protection set
     * @ignore
     */
    this.VIDEO_ELEMENT_SELECTED = 'videoElementSelected';
  }

  return ProtectionEvents;
})(_coreEventsEventsBase2['default']);

var protectionEvents = new ProtectionEvents();
exports['default'] = protectionEvents;
module.exports = exports['default'];
//# sourceMappingURL=ProtectionEvents.js.map


/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _CommonEncryption = __webpack_require__(241);

var _CommonEncryption2 = _interopRequireDefault(_CommonEncryption);

var _coreEventsEvents = __webpack_require__(22);

var _coreEventsEvents2 = _interopRequireDefault(_coreEventsEvents);

var _voMediaCapability = __webpack_require__(1391);

var _voMediaCapability2 = _interopRequireDefault(_voMediaCapability);

var _voKeySystemConfiguration = __webpack_require__(403);

var _voKeySystemConfiguration2 = _interopRequireDefault(_voKeySystemConfiguration);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _Protection = __webpack_require__(594);

var _Protection2 = _interopRequireDefault(_Protection);

/**
 * @module ProtectionController
 * @description Provides access to media protection information and functionality.  Each
 * ProtectionController manages a single {@link MediaPlayer.models.ProtectionModel}
 * which encapsulates a set of protection information (EME APIs, selected key system,
 * key sessions).  The APIs of ProtectionController mostly align with the latest EME
 * APIs.  Key system selection is mostly automated when combined with app-overrideable
 * functionality provided in {@link ProtectionKeyController}.
 * @todo ProtectionController does almost all of its tasks automatically after init() is
 * called.  Applications might want more control over this process and want to go through
 * each step manually (key system selection, session creation, session maintenance).
 * @param {Object} config
 */

function ProtectionController(config) {

    var protectionKeyController = config.protectionKeyController;
    var protectionModel = config.protectionModel;
    var adapter = config.adapter;
    var eventBus = config.eventBus;
    var log = config.log;

    var instance = undefined,
        keySystems = undefined,
        pendingNeedKeyData = undefined,
        audioInfo = undefined,
        videoInfo = undefined,
        protDataSet = undefined,
        initialized = undefined,
        sessionType = undefined,
        robustnessLevel = undefined,
        keySystem = undefined;

    function setup() {
        keySystems = protectionKeyController.getKeySystems();
        pendingNeedKeyData = [];
        initialized = false;
        sessionType = 'temporary';
        robustnessLevel = '';

        _coreEventsEvents2['default'].extend(_Protection2['default'].events);
    }

    /**
     * Initialize this protection system with a given manifest and optional audio
     * and video stream information.
     *
     * @param {Object} manifest the json version of the manifest XML document for the
     * desired content.  Applications can download their manifest using
     * {@link module:MediaPlayer#retrieveManifest}
     * @param {StreamInfo} [aInfo] audio stream information
     * @param {StreamInfo} [vInfo] video stream information
     * @memberof module:ProtectionController
     * @instance
     * @todo This API will change when we have better support for allowing applications
     * to select different adaptation sets for playback.  Right now it is clunky for
     * applications to create {@link StreamInfo} with the right information,
     */
    function initialize(manifest, aInfo, vInfo) {

        // TODO: We really need to do much more here... We need to be smarter about knowing
        // which adaptation sets for which we have initialized, including the default key ID
        // value from the ContentProtection elements so we know whether or not we still need to
        // select key systems and acquire keys.
        if (!initialized) {

            var streamInfo;

            if (!aInfo && !vInfo) {
                // Look for ContentProtection elements.  InitData can be provided by either the
                // dash264drm:Pssh ContentProtection format or a DRM-specific format.
                streamInfo = adapter.getStreamsInfo(manifest)[0]; // TODO: Single period only for now. See TODO above
            }

            audioInfo = aInfo || (streamInfo ? adapter.getMediaInfoForType(manifest, streamInfo, 'audio') : null);
            videoInfo = vInfo || (streamInfo ? adapter.getMediaInfoForType(manifest, streamInfo, 'video') : null);

            var mediaInfo = videoInfo ? videoInfo : audioInfo; // We could have audio or video only

            // ContentProtection elements are specified at the AdaptationSet level, so the CP for audio
            // and video will be the same.  Just use one valid MediaInfo object
            var supportedKS = protectionKeyController.getSupportedKeySystemsFromContentProtection(mediaInfo.contentProtection);
            if (supportedKS && supportedKS.length > 0) {
                selectKeySystem(supportedKS, true);
            }

            initialized = true;
        }
    }

    /**
     * Create a new key session associated with the given initialization data from
     * the MPD or from the PSSH box in the media
     *
     * @param {ArrayBuffer} initData the initialization data
     * @memberof module:ProtectionController
     * @instance
     * @fires ProtectionController#KeySessionCreated
     * @todo In older versions of the EME spec, there was a one-to-one relationship between
     * initialization data and key sessions.  That is no longer true in the latest APIs.  This
     * API will need to modified (and a new "generateRequest(keySession, initData)" API created)
     * to come up to speed with the latest EME standard
     */
    function createKeySession(initData) {
        var initDataForKS = _CommonEncryption2['default'].getPSSHForKeySystem(keySystem, initData);
        if (initDataForKS) {

            // Check for duplicate initData
            var currentInitData = protectionModel.getAllInitData();
            for (var i = 0; i < currentInitData.length; i++) {
                if (protectionKeyController.initDataEquals(initDataForKS, currentInitData[i])) {
                    log('DRM: Ignoring initData because we have already seen it!');
                    return;
                }
            }
            try {
                protectionModel.createKeySession(initDataForKS, sessionType);
            } catch (error) {
                eventBus.trigger(_coreEventsEvents2['default'].KEY_SESSION_CREATED, { data: null, error: 'Error creating key session! ' + error.message });
            }
        } else {
            eventBus.trigger(_coreEventsEvents2['default'].KEY_SESSION_CREATED, { data: null, error: 'Selected key system is ' + keySystem.systemString + '.  needkey/encrypted event contains no initData corresponding to that key system!' });
        }
    }

    /**
     * Loads a key session with the given session ID from persistent storage.  This
     * essentially creates a new key session
     *
     * @param {string} sessionID
     * @memberof module:ProtectionController
     * @instance
     * @fires ProtectionController#KeySessionCreated
     */
    function loadKeySession(sessionID) {
        protectionModel.loadKeySession(sessionID);
    }

    /**
     * Removes the given key session from persistent storage and closes the session
     * as if {@link ProtectionController#closeKeySession}
     * was called
     *
     * @param {SessionToken} sessionToken the session
     * token
     * @memberof module:ProtectionController
     * @instance
     * @fires ProtectionController#KeySessionRemoved
     * @fires ProtectionController#KeySessionClosed
     */
    function removeKeySession(sessionToken) {
        protectionModel.removeKeySession(sessionToken);
    }

    /**
     * Closes the key session and releases all associated decryption keys.  These
     * keys will no longer be available for decrypting media
     *
     * @param {SessionToken} sessionToken the session
     * token
     * @memberof module:ProtectionController
     * @instance
     * @fires ProtectionController#KeySessionClosed
     */
    function closeKeySession(sessionToken) {
        protectionModel.closeKeySession(sessionToken);
    }

    /**
     * Sets a server certificate for use by the CDM when signing key messages
     * intended for a particular license server.  This will fire
     * an error event if a key system has not yet been selected.
     *
     * @param {ArrayBuffer} serverCertificate a CDM-specific license server
     * certificate
     * @memberof module:ProtectionController
     * @instance
     * @fires ProtectionController#ServerCertificateUpdated
     */
    function setServerCertificate(serverCertificate) {
        protectionModel.setServerCertificate(serverCertificate);
    }

    /**
     * Associate this protection system with the given HTMLMediaElement.  This
     * causes the system to register for needkey/encrypted events from the given
     * element and provides a destination for setting of MediaKeys
     *
     * @param {HTMLMediaElement} element the media element to which the protection
     * system should be associated
     * @memberof module:ProtectionController
     * @instance
     */
    function setMediaElement(element) {
        if (element) {
            protectionModel.setMediaElement(element);
            eventBus.on(_coreEventsEvents2['default'].NEED_KEY, onNeedKey, this);
            eventBus.on(_coreEventsEvents2['default'].INTERNAL_KEY_MESSAGE, onKeyMessage, this);
        } else if (element === null) {
            protectionModel.setMediaElement(element);
            eventBus.off(_coreEventsEvents2['default'].NEED_KEY, onNeedKey, this);
            eventBus.off(_coreEventsEvents2['default'].INTERNAL_KEY_MESSAGE, onKeyMessage, this);
        }
    }

    /**
     * Sets the session type to use when creating key sessions.  Either "temporary" or
     * "persistent-license".  Default is "temporary".
     *
     * @param {string} value the session type
     * @memberof module:ProtectionController
     * @instance
     */
    function setSessionType(value) {
        sessionType = value;
    }

    /**
     * Sets the robustness level for video and audio capabilities. Optional to remove Chrome warnings.
     * Possible values are SW_SECURE_CRYPTO, SW_SECURE_DECODE, HW_SECURE_CRYPTO, HW_SECURE_CRYPTO, HW_SECURE_DECODE, HW_SECURE_ALL.
     *
     * @param {string} level the robustness level
     * @memberof module:ProtectionController
     * @instance
     */
    function setRobustnessLevel(level) {
        robustnessLevel = level;
    }

    /**
     * Attach KeySystem-specific data to use for license acquisition with EME
     *
     * @param {Object} data an object containing property names corresponding to
     * key system name strings (e.g. "org.w3.clearkey") and associated values
     * being instances of {@link ProtectionData}
     * @memberof module:ProtectionController
     * @instance
     */
    function setProtectionData(data) {
        protDataSet = data;
    }

    /**
     * Destroys all protection data associated with this protection set.  This includes
     * deleting all key sessions.  In the case of persistent key sessions, the sessions
     * will simply be unloaded and not deleted.  Additionally, if this protection set is
     * associated with a HTMLMediaElement, it will be detached from that element.
     *
     * @memberof module:ProtectionController
     * @instance
     */
    function reset() {
        setMediaElement(null);

        keySystem = undefined; //TODO-Refactor look at why undefined is needed for this. refactor

        if (protectionModel) {
            protectionModel.reset();
            protectionModel = null;
        }
    }

    ///////////////
    // Private
    ///////////////

    function getProtData(keySystem) {
        var protData = null;
        var keySystemString = keySystem.systemString;

        if (protDataSet) {
            protData = keySystemString in protDataSet ? protDataSet[keySystemString] : null;
        }
        return protData;
    }

    function selectKeySystem(supportedKS, fromManifest) {

        var self = this;

        // Build our request object for requestKeySystemAccess
        var audioCapabilities = [];
        var videoCapabilities = [];

        if (videoInfo) {
            videoCapabilities.push(new _voMediaCapability2['default'](videoInfo.codec, robustnessLevel));
        }
        if (audioInfo) {
            audioCapabilities.push(new _voMediaCapability2['default'](audioInfo.codec, robustnessLevel));
        }
        var ksConfig = new _voKeySystemConfiguration2['default'](audioCapabilities, videoCapabilities, 'optional', sessionType === 'temporary' ? 'optional' : 'required', [sessionType]);
        var requestedKeySystems = [];

        var ksIdx;
        if (keySystem) {
            // We have a key system
            for (ksIdx = 0; ksIdx < supportedKS.length; ksIdx++) {
                if (keySystem === supportedKS[ksIdx].ks) {
                    var _ret = (function () {

                        requestedKeySystems.push({ ks: supportedKS[ksIdx].ks, configs: [ksConfig] });

                        // Ensure that we would be granted key system access using the key
                        // system and codec information
                        var onKeySystemAccessComplete = function onKeySystemAccessComplete(event) {
                            eventBus.off(_coreEventsEvents2['default'].KEY_SYSTEM_ACCESS_COMPLETE, onKeySystemAccessComplete, self);
                            if (event.error) {
                                if (!fromManifest) {
                                    eventBus.trigger(_coreEventsEvents2['default'].KEY_SYSTEM_SELECTED, { error: 'DRM: KeySystem Access Denied! -- ' + event.error });
                                }
                            } else {
                                log('DRM: KeySystem Access Granted');
                                eventBus.trigger(_coreEventsEvents2['default'].KEY_SYSTEM_SELECTED, { data: event.data });
                                createKeySession(supportedKS[ksIdx].initData);
                            }
                        };
                        eventBus.on(_coreEventsEvents2['default'].KEY_SYSTEM_ACCESS_COMPLETE, onKeySystemAccessComplete, self);
                        protectionModel.requestKeySystemAccess(requestedKeySystems);
                        return 'break';
                    })();

                    if (_ret === 'break') break;
                }
            }
        } else if (keySystem === undefined) {
            // First time through, so we need to select a key system
            keySystem = null;
            pendingNeedKeyData.push(supportedKS);

            // Add all key systems to our request list since we have yet to select a key system
            for (var i = 0; i < supportedKS.length; i++) {
                requestedKeySystems.push({ ks: supportedKS[i].ks, configs: [ksConfig] });
            }

            var keySystemAccess;
            var onKeySystemAccessComplete = function onKeySystemAccessComplete(event) {
                eventBus.off(_coreEventsEvents2['default'].KEY_SYSTEM_ACCESS_COMPLETE, onKeySystemAccessComplete, self);
                if (event.error) {
                    keySystem = undefined;
                    eventBus.off(_coreEventsEvents2['default'].INTERNAL_KEY_SYSTEM_SELECTED, onKeySystemSelected, self);

                    if (!fromManifest) {
                        eventBus.trigger(_coreEventsEvents2['default'].KEY_SYSTEM_SELECTED, { data: null, error: 'DRM: KeySystem Access Denied! -- ' + event.error });
                    }
                } else {
                    keySystemAccess = event.data;
                    log('DRM: KeySystem Access Granted (' + keySystemAccess.keySystem.systemString + ')!  Selecting key system...');
                    protectionModel.selectKeySystem(keySystemAccess);
                }
            };
            var onKeySystemSelected = function onKeySystemSelected(event) {
                eventBus.off(_coreEventsEvents2['default'].INTERNAL_KEY_SYSTEM_SELECTED, onKeySystemSelected, self);
                eventBus.off(_coreEventsEvents2['default'].KEY_SYSTEM_ACCESS_COMPLETE, onKeySystemAccessComplete, self);
                if (!event.error) {
                    keySystem = protectionModel.getKeySystem();
                    eventBus.trigger(_coreEventsEvents2['default'].KEY_SYSTEM_SELECTED, { data: keySystemAccess });
                    for (var i = 0; i < pendingNeedKeyData.length; i++) {
                        for (ksIdx = 0; ksIdx < pendingNeedKeyData[i].length; ksIdx++) {
                            if (keySystem === pendingNeedKeyData[i][ksIdx].ks) {
                                createKeySession(pendingNeedKeyData[i][ksIdx].initData);
                                break;
                            }
                        }
                    }
                } else {
                    keySystem = undefined;
                    if (!fromManifest) {
                        eventBus.trigger(_coreEventsEvents2['default'].KEY_SYSTEM_SELECTED, { data: null, error: 'DRM: Error selecting key system! -- ' + event.error });
                    }
                }
            };
            eventBus.on(_coreEventsEvents2['default'].INTERNAL_KEY_SYSTEM_SELECTED, onKeySystemSelected, self);
            eventBus.on(_coreEventsEvents2['default'].KEY_SYSTEM_ACCESS_COMPLETE, onKeySystemAccessComplete, self);
            protectionModel.requestKeySystemAccess(requestedKeySystems);
        } else {
            // We are in the process of selecting a key system, so just save the data
            pendingNeedKeyData.push(supportedKS);
        }
    }

    function sendLicenseRequestCompleteEvent(data, error) {
        eventBus.trigger(_coreEventsEvents2['default'].LICENSE_REQUEST_COMPLETE, { data: data, error: error });
    }

    function onKeyMessage(e) {
        log('DRM: onKeyMessage');
        if (e.error) {
            log(e.error);
            return;
        }

        // Dispatch event to applications indicating we received a key message
        var keyMessage = e.data;
        eventBus.trigger(_coreEventsEvents2['default'].KEY_MESSAGE, { data: keyMessage });
        var messageType = keyMessage.messageType ? keyMessage.messageType : 'license-request';
        var message = keyMessage.message;
        var sessionToken = keyMessage.sessionToken;
        var protData = getProtData(keySystem);
        var keySystemString = keySystem.systemString;
        var licenseServerData = protectionKeyController.getLicenseServer(keySystem, protData, messageType);
        var eventData = { sessionToken: sessionToken, messageType: messageType };

        // Message not destined for license server
        if (!licenseServerData) {
            log('DRM: License server request not required for this message (type = ' + e.data.messageType + ').  Session ID = ' + sessionToken.getSessionID());
            sendLicenseRequestCompleteEvent(eventData);
            return;
        }

        // Perform any special handling for ClearKey
        if (protectionKeyController.isClearKey(keySystem)) {
            var clearkeys = protectionKeyController.processClearKeyLicenseRequest(protData, message);
            if (clearkeys) {
                log('DRM: ClearKey license request handled by application!');
                sendLicenseRequestCompleteEvent(eventData);
                protectionModel.updateKeySession(sessionToken, clearkeys);
                return;
            }
        }

        // All remaining key system scenarios require a request to a remote license server
        var xhr = new XMLHttpRequest();

        // Determine license server URL
        var url = null;
        if (protData && protData.serverURL) {
            var serverURL = protData.serverURL;
            if (typeof serverURL === 'string' && serverURL !== '') {
                url = serverURL;
            } else if (typeof serverURL === 'object' && serverURL.hasOwnProperty(messageType)) {
                url = serverURL[messageType];
            }
        } else if (protData && protData.laURL && protData.laURL !== '') {
            // TODO: Deprecated!
            url = protData.laURL;
        } else {
            url = keySystem.getLicenseServerURLFromInitData(_CommonEncryption2['default'].getPSSHData(sessionToken.initData));
            if (!url) {
                url = e.data.laURL;
            }
        }
        // Possibly update or override the URL based on the message
        url = licenseServerData.getServerURLFromMessage(url, message, messageType);

        // Ensure valid license server URL
        if (!url) {
            sendLicenseRequestCompleteEvent(eventData, 'DRM: No license server URL specified!');
            return;
        }

        xhr.open(licenseServerData.getHTTPMethod(messageType), url, true);
        xhr.responseType = licenseServerData.getResponseType(keySystemString, messageType);
        xhr.onload = function () {
            if (this.status == 200) {
                sendLicenseRequestCompleteEvent(eventData);
                protectionModel.updateKeySession(sessionToken, licenseServerData.getLicenseMessage(this.response, keySystemString, messageType));
            } else {
                sendLicenseRequestCompleteEvent(eventData, 'DRM: ' + keySystemString + ' update, XHR status is "' + this.statusText + '" (' + this.status + '), expected to be 200. readyState is ' + this.readyState + '.  Response is ' + (this.response ? licenseServerData.getErrorResponse(this.response, keySystemString, messageType) : 'NONE'));
            }
        };
        xhr.onabort = function () {
            sendLicenseRequestCompleteEvent(eventData, 'DRM: ' + keySystemString + ' update, XHR aborted. status is "' + this.statusText + '" (' + this.status + '), readyState is ' + this.readyState);
        };
        xhr.onerror = function () {
            sendLicenseRequestCompleteEvent(eventData, 'DRM: ' + keySystemString + ' update, XHR error. status is "' + this.statusText + '" (' + this.status + '), readyState is ' + this.readyState);
        };

        // Set optional XMLHttpRequest headers from protection data and message
        var updateHeaders = function updateHeaders(headers) {
            var key;
            if (headers) {
                for (key in headers) {
                    if ('authorization' === key.toLowerCase()) {
                        xhr.withCredentials = true;
                    }
                    xhr.setRequestHeader(key, headers[key]);
                }
            }
        };
        if (protData) {
            updateHeaders(protData.httpRequestHeaders);
        }
        updateHeaders(keySystem.getRequestHeadersFromMessage(message));

        // Set withCredentials property from protData
        if (protData && protData.withCredentials) {
            xhr.withCredentials = true;
        }

        xhr.send(keySystem.getLicenseRequestFromMessage(message));
    }

    function onNeedKey(event) {
        log('DRM: onNeedKey');
        // Ignore non-cenc initData
        if (event.key.initDataType !== 'cenc') {
            log('DRM:  Only \'cenc\' initData is supported!  Ignoring initData of type: ' + event.key.initDataType);
            return;
        }

        // Some browsers return initData as Uint8Array (IE), some as ArrayBuffer (Chrome).
        // Convert to ArrayBuffer
        var abInitData = event.key.initData;
        if (ArrayBuffer.isView(abInitData)) {
            abInitData = abInitData.buffer;
        }

        log('DRM: initData:', String.fromCharCode.apply(null, new Uint8Array(abInitData)));

        var supportedKS = protectionKeyController.getSupportedKeySystems(abInitData, protDataSet);
        if (supportedKS.length === 0) {
            log('DRM: Received needkey event with initData, but we don\'t support any of the key systems!');
            return;
        }

        selectKeySystem(supportedKS, false);
    }

    instance = {
        initialize: initialize,
        createKeySession: createKeySession,
        loadKeySession: loadKeySession,
        removeKeySession: removeKeySession,
        closeKeySession: closeKeySession,
        setServerCertificate: setServerCertificate,
        setMediaElement: setMediaElement,
        setSessionType: setSessionType,
        setRobustnessLevel: setRobustnessLevel,
        setProtectionData: setProtectionData,
        reset: reset
    };

    setup();
    return instance;
}

ProtectionController.__dashjs_factory_name = 'ProtectionController';
exports['default'] = _coreFactoryMaker2['default'].getClassFactory(ProtectionController);
module.exports = exports['default'];
//# sourceMappingURL=ProtectionController.js.map


/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _voKeyPair = __webpack_require__(596);

var _voKeyPair2 = _interopRequireDefault(_voKeyPair);

var _voClearKeyKeySet = __webpack_require__(595);

var _voClearKeyKeySet2 = _interopRequireDefault(_voClearKeyKeySet);

var _CommonEncryption = __webpack_require__(241);

var _CommonEncryption2 = _interopRequireDefault(_CommonEncryption);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var uuid = '1077efec-c0b2-4d02-ace3-3c1e52e2fb4b';
var systemString = 'org.w3.clearkey';
var schemeIdURI = 'urn:uuid:' + uuid;

function KeySystemClearKey() {

    var instance = undefined;
    /**
     * Returns desired clearkeys (as specified in the CDM message) from protection data
     *
     * @param {ProtectionData} protectionData the protection data
     * @param {ArrayBuffer} message the ClearKey CDM message
     * @returns {ClearKeyKeySet} the key set or null if none found
     * @throws {Error} if a keyID specified in the CDM message was not found in the
     * protection data
     * @memberof KeySystemClearKey
     */
    function getClearKeysFromProtectionData(protectionData, message) {
        var clearkeySet = null;
        if (protectionData) {
            // ClearKey is the only system that does not require a license server URL, so we
            // handle it here when keys are specified in protection data
            var jsonMsg = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(message)));
            var keyPairs = [];
            for (var i = 0; i < jsonMsg.kids.length; i++) {
                var clearkeyID = jsonMsg.kids[i];
                var clearkey = protectionData.clearkeys.hasOwnProperty(clearkeyID) ? protectionData.clearkeys[clearkeyID] : null;
                if (!clearkey) {
                    throw new Error('DRM: ClearKey keyID (' + clearkeyID + ') is not known!');
                }
                // KeyIDs from CDM are not base64 padded.  Keys may or may not be padded
                keyPairs.push(new _voKeyPair2['default'](clearkeyID, clearkey));
            }
            clearkeySet = new _voClearKeyKeySet2['default'](keyPairs);
        }
        return clearkeySet;
    }

    function getInitData(cp) {
        return _CommonEncryption2['default'].parseInitDataFromContentProtection(cp);
    }

    function getRequestHeadersFromMessage() /*message*/{
        return null;
    }

    function getLicenseRequestFromMessage(message) {
        return new Uint8Array(message);
    }

    function getLicenseServerURLFromInitData() /*initData*/{
        return null;
    }

    instance = {
        uuid: uuid,
        schemeIdURI: schemeIdURI,
        systemString: systemString,
        getInitData: getInitData,
        getRequestHeadersFromMessage: getRequestHeadersFromMessage,
        getLicenseRequestFromMessage: getLicenseRequestFromMessage,
        getLicenseServerURLFromInitData: getLicenseServerURLFromInitData,
        getClearKeysFromProtectionData: getClearKeysFromProtectionData
    };

    return instance;
}

KeySystemClearKey.__dashjs_factory_name = 'KeySystemClearKey';
exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(KeySystemClearKey);
module.exports = exports['default'];
//# sourceMappingURL=KeySystemClearKey.js.map


/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * Microsoft PlayReady DRM
 *
 * @class
 * @implements KeySystem
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _CommonEncryption = __webpack_require__(241);

var _CommonEncryption2 = _interopRequireDefault(_CommonEncryption);

var _voError = __webpack_require__(111);

var _voError2 = _interopRequireDefault(_voError);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _externalsBase64 = __webpack_require__(392);

var _externalsBase642 = _interopRequireDefault(_externalsBase64);

var uuid = '9a04f079-9840-4286-ab92-e65be0885f95';
var systemString = 'com.microsoft.playready';
var schemeIdURI = 'urn:uuid:' + uuid;

function KeySystemPlayReady() {

    var instance = undefined;
    var messageFormat = 'utf16';

    function getRequestHeadersFromMessage(message) {
        var msg, xmlDoc;
        var headers = {};
        var parser = new DOMParser();
        var dataview = messageFormat === 'utf16' ? new Uint16Array(message) : new Uint8Array(message);

        msg = String.fromCharCode.apply(null, dataview);
        xmlDoc = parser.parseFromString(msg, 'application/xml');

        var headerNameList = xmlDoc.getElementsByTagName('name');
        var headerValueList = xmlDoc.getElementsByTagName('value');
        for (var i = 0; i < headerNameList.length; i++) {
            headers[headerNameList[i].childNodes[0].nodeValue] = headerValueList[i].childNodes[0].nodeValue;
        }
        // some versions of the PlayReady CDM return 'Content' instead of 'Content-Type'.
        // this is NOT w3c conform and license servers may reject the request!
        // -> rename it to proper w3c definition!
        if (headers.hasOwnProperty('Content')) {
            headers['Content-Type'] = headers.Content;
            delete headers.Content;
        }
        return headers;
    }

    function getLicenseRequestFromMessage(message) {
        var msg, xmlDoc;
        var licenseRequest = null;
        var parser = new DOMParser();
        var dataview = messageFormat === 'utf16' ? new Uint16Array(message) : new Uint8Array(message);

        msg = String.fromCharCode.apply(null, dataview);
        xmlDoc = parser.parseFromString(msg, 'application/xml');

        if (xmlDoc.getElementsByTagName('Challenge')[0]) {
            var Challenge = xmlDoc.getElementsByTagName('Challenge')[0].childNodes[0].nodeValue;
            if (Challenge) {
                licenseRequest = _externalsBase642['default'].decode(Challenge);
            }
        }
        return licenseRequest;
    }

    function getLicenseServerURLFromInitData(initData) {
        if (initData) {
            var data = new DataView(initData);
            var numRecords = data.getUint16(4, true);
            var offset = 6;
            var parser = new DOMParser();

            for (var i = 0; i < numRecords; i++) {
                // Parse the PlayReady Record header
                var recordType = data.getUint16(offset, true);
                offset += 2;
                var recordLength = data.getUint16(offset, true);
                offset += 2;
                if (recordType !== 0x0001) {
                    offset += recordLength;
                    continue;
                }

                var recordData = initData.slice(offset, offset + recordLength);
                var record = String.fromCharCode.apply(null, new Uint16Array(recordData));
                var xmlDoc = parser.parseFromString(record, 'application/xml');

                // First try <LA_URL>
                if (xmlDoc.getElementsByTagName('LA_URL')[0]) {
                    var laurl = xmlDoc.getElementsByTagName('LA_URL')[0].childNodes[0].nodeValue;
                    if (laurl) {
                        return laurl;
                    }
                }

                // Optionally, try <LUI_URL>
                if (xmlDoc.getElementsByTagName('LUI_URL')[0]) {
                    var luiurl = xmlDoc.getElementsByTagName('LUI_URL')[0].childNodes[0].nodeValue;
                    if (luiurl) {
                        return luiurl;
                    }
                }
            }
        }

        return null;
    }

    function getInitData(cpData) {
        // * desc@ getInitData
        // *   generate PSSH data from PROHeader defined in MPD file
        // *   PSSH format:
        // *   size (4)
        // *   box type(PSSH) (8)
        // *   Protection SystemID (16)
        // *   protection system data size (4) - length of decoded PROHeader
        // *   decoded PROHeader data from MPD file
        var PSSHBoxType = new Uint8Array([0x70, 0x73, 0x73, 0x68, 0x00, 0x00, 0x00, 0x00]); //'PSSH' 8 bytes
        var playreadySystemID = new Uint8Array([0x9a, 0x04, 0xf0, 0x79, 0x98, 0x40, 0x42, 0x86, 0xab, 0x92, 0xe6, 0x5b, 0xe0, 0x88, 0x5f, 0x95]);

        var byteCursor = 0;
        var uint8arraydecodedPROHeader = null;

        var PROSize, PSSHSize, PSSHBoxBuffer, PSSHBox, PSSHData;

        // Handle common encryption PSSH
        if ('pssh' in cpData) {
            return _CommonEncryption2['default'].parseInitDataFromContentProtection(cpData);
        }
        // Handle native MS PlayReady ContentProtection elements
        if ('pro' in cpData) {
            uint8arraydecodedPROHeader = _externalsBase642['default'].decodeArray(cpData.pro.__text);
        } else if ('prheader' in cpData) {
            uint8arraydecodedPROHeader = _externalsBase642['default'].decodeArray(cpData.prheader.__text);
        } else {
            return null;
        }

        PROSize = uint8arraydecodedPROHeader.length;
        PSSHSize = 0x4 + PSSHBoxType.length + playreadySystemID.length + 0x4 + PROSize;

        PSSHBoxBuffer = new ArrayBuffer(PSSHSize);

        PSSHBox = new Uint8Array(PSSHBoxBuffer);
        PSSHData = new DataView(PSSHBoxBuffer);

        PSSHData.setUint32(byteCursor, PSSHSize);
        byteCursor += 0x4;

        PSSHBox.set(PSSHBoxType, byteCursor);
        byteCursor += PSSHBoxType.length;

        PSSHBox.set(playreadySystemID, byteCursor);
        byteCursor += playreadySystemID.length;

        PSSHData.setUint32(byteCursor, PROSize);
        byteCursor += 0x4;

        PSSHBox.set(uint8arraydecodedPROHeader, byteCursor);
        byteCursor += PROSize;

        return PSSHBox.buffer;
    }

    /**
     * It seems that some PlayReady implementations return their XML-based CDM
     * messages using UTF16, while others return them as UTF8.  Use this function
     * to modify the message format to expect when parsing CDM messages.
     *
     * @param {string} format the expected message format.  Either "utf8" or "utf16".
     * @throws {Error} Specified message format is not one of "utf8" or "utf16"
     */
    function setPlayReadyMessageFormat(format) {
        if (format !== 'utf8' && format !== 'utf16') {
            throw new _voError2['default']('Illegal PlayReady message format! -- ' + format);
        }
        messageFormat = format;
    }

    instance = {
        uuid: uuid,
        schemeIdURI: schemeIdURI,
        systemString: systemString,
        getInitData: getInitData,
        getRequestHeadersFromMessage: getRequestHeadersFromMessage,
        getLicenseRequestFromMessage: getLicenseRequestFromMessage,
        getLicenseServerURLFromInitData: getLicenseServerURLFromInitData,
        setPlayReadyMessageFormat: setPlayReadyMessageFormat
    };

    return instance;
}

KeySystemPlayReady.__dashjs_factory_name = 'KeySystemPlayReady';
exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(KeySystemPlayReady);
module.exports = exports['default'];
//# sourceMappingURL=KeySystemPlayReady.js.map


/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * Google Widevine DRM
 *
 * @class
 * @implements MediaPlayer.dependencies.protection.KeySystem
 */



Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _CommonEncryption = __webpack_require__(241);

var _CommonEncryption2 = _interopRequireDefault(_CommonEncryption);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var uuid = 'edef8ba9-79d6-4ace-a3c8-27dcd51d21ed';
var systemString = 'com.widevine.alpha';
var schemeIdURI = 'urn:uuid:' + uuid;

function KeySystemWidevine() {

    var instance = undefined;

    function getInitData(cp) {
        return _CommonEncryption2['default'].parseInitDataFromContentProtection(cp);
    }

    function getRequestHeadersFromMessage() /*message*/{
        return null;
    }

    function getLicenseRequestFromMessage(message) {
        return new Uint8Array(message);
    }

    function getLicenseServerURLFromInitData() /*initData*/{
        return null;
    }

    instance = {
        uuid: uuid,
        schemeIdURI: schemeIdURI,
        systemString: systemString,
        getInitData: getInitData,
        getRequestHeadersFromMessage: getRequestHeadersFromMessage,
        getLicenseRequestFromMessage: getLicenseRequestFromMessage,
        getLicenseServerURLFromInitData: getLicenseServerURLFromInitData
    };

    return instance;
}

KeySystemWidevine.__dashjs_factory_name = 'KeySystemWidevine';
exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(KeySystemWidevine);
module.exports = exports['default'];
//# sourceMappingURL=KeySystemWidevine.js.map


/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * Initial implementation of EME
 *
 * Implemented by Google Chrome prior to v36
 *
 * @implements ProtectionModel
 * @class
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _controllersProtectionKeyController = __webpack_require__(326);

var _controllersProtectionKeyController2 = _interopRequireDefault(_controllersProtectionKeyController);

var _voNeedKey = __webpack_require__(404);

var _voNeedKey2 = _interopRequireDefault(_voNeedKey);

var _voKeyError = __webpack_require__(400);

var _voKeyError2 = _interopRequireDefault(_voKeyError);

var _voKeyMessage = __webpack_require__(401);

var _voKeyMessage2 = _interopRequireDefault(_voKeyMessage);

var _voKeySystemConfiguration = __webpack_require__(403);

var _voKeySystemConfiguration2 = _interopRequireDefault(_voKeySystemConfiguration);

var _voKeySystemAccess = __webpack_require__(402);

var _voKeySystemAccess2 = _interopRequireDefault(_voKeySystemAccess);

var _coreEventsEvents = __webpack_require__(22);

var _coreEventsEvents2 = _interopRequireDefault(_coreEventsEvents);

var _utilsErrorHandler = __webpack_require__(136);

var _utilsErrorHandler2 = _interopRequireDefault(_utilsErrorHandler);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

function ProtectionModel_01b(config) {

    var context = this.context;
    var eventBus = config.eventBus; //Need to pass in here so we can use same instance since this is optional module
    var log = config.log;
    var api = config.api;

    var instance = undefined,
        videoElement = undefined,
        keySystem = undefined,
        protectionKeyController = undefined,
        errHandler = undefined,

    // With this version of the EME APIs, sessionIDs are not assigned to
    // sessions until the first key message is received.  We are assuming
    // that in the case of multiple sessions, key messages will be received
    // in the order that generateKeyRequest() is called.
    // Holding spot for newly-created sessions until we determine whether or
    // not the CDM supports sessionIDs
    pendingSessions = undefined,

    // List of sessions that have been initialized.  Only the first position will
    // be used in the case that the CDM does not support sessionIDs
    sessions = undefined,

    // Not all CDMs support the notion of sessionIDs.  Without sessionIDs
    // there is no way for us to differentiate between sessions, therefore
    // we must only allow a single session.  Once we receive the first key
    // message we can set this flag to determine if more sessions are allowed
    moreSessionsAllowed = undefined,

    // This is our main event handler for all desired HTMLMediaElement events
    // related to EME.  These events are translated into our API-independent
    // versions of the same events
    eventHandler = undefined;

    function setup() {
        videoElement = null;
        keySystem = null;
        pendingSessions = [];
        sessions = [];
        protectionKeyController = (0, _controllersProtectionKeyController2['default'])(context).getInstance();
        errHandler = (0, _utilsErrorHandler2['default'])(context).getInstance();
        eventHandler = createEventHandler();
    }

    function reset() {
        if (videoElement) {
            removeEventListeners();
        }
        for (var i = 0; i < sessions.length; i++) {
            closeKeySession(sessions[i]);
        }
        eventBus.trigger(_coreEventsEvents2['default'].TEARDOWN_COMPLETE);
    }

    function getKeySystem() {
        return keySystem;
    }

    function getAllInitData() {
        var retVal = [];
        for (var i = 0; i < pendingSessions.length; i++) {
            retVal.push(pendingSessions[i].initData);
        }
        for (var i = 0; i < sessions.length; i++) {
            retVal.push(sessions[i].initData);
        }
        return retVal;
    }

    function requestKeySystemAccess(ksConfigurations) {
        var ve = videoElement;
        if (!ve) {
            // Must have a video element to do this capability tests
            ve = document.createElement('video');
        }

        // Try key systems in order, first one with supported key system configuration
        // is used
        var found = false;
        for (var ksIdx = 0; ksIdx < ksConfigurations.length; ksIdx++) {
            var systemString = ksConfigurations[ksIdx].ks.systemString;
            var configs = ksConfigurations[ksIdx].configs;
            var supportedAudio = null;
            var supportedVideo = null;

            // Try key system configs in order, first one with supported audio/video
            // is used
            for (var configIdx = 0; configIdx < configs.length; configIdx++) {
                //var audios = configs[configIdx].audioCapabilities;
                var videos = configs[configIdx].videoCapabilities;
                // Look for supported video container/codecs
                if (videos && videos.length !== 0) {
                    supportedVideo = []; // Indicates that we have a requested video config
                    for (var videoIdx = 0; videoIdx < videos.length; videoIdx++) {
                        if (ve.canPlayType(videos[videoIdx].contentType, systemString) !== '') {
                            supportedVideo.push(videos[videoIdx]);
                        }
                    }
                }

                // No supported audio or video in this configuration OR we have
                // requested audio or video configuration that is not supported
                if (!supportedAudio && !supportedVideo || supportedAudio && supportedAudio.length === 0 || supportedVideo && supportedVideo.length === 0) {
                    continue;
                }

                // This configuration is supported
                found = true;
                var ksConfig = new _voKeySystemConfiguration2['default'](supportedAudio, supportedVideo);
                var ks = protectionKeyController.getKeySystemBySystemString(systemString);
                eventBus.trigger(_coreEventsEvents2['default'].KEY_SYSTEM_ACCESS_COMPLETE, { data: new _voKeySystemAccess2['default'](ks, ksConfig) });
                break;
            }
        }
        if (!found) {
            eventBus.trigger(_coreEventsEvents2['default'].KEY_SYSTEM_ACCESS_COMPLETE, { error: 'Key system access denied! -- No valid audio/video content configurations detected!' });
        }
    }

    function selectKeySystem(keySystemAccess) {
        keySystem = keySystemAccess.keySystem;
        eventBus.trigger(_coreEventsEvents2['default'].INTERNAL_KEY_SYSTEM_SELECTED);
    }

    function setMediaElement(mediaElement) {
        if (videoElement === mediaElement) {
            return;
        }

        // Replacing the previous element
        if (videoElement) {
            removeEventListeners();
        }

        videoElement = mediaElement;

        // Only if we are not detaching from the existing element
        if (videoElement) {
            videoElement.addEventListener(api.keyerror, eventHandler);
            videoElement.addEventListener(api.needkey, eventHandler);
            videoElement.addEventListener(api.keymessage, eventHandler);
            videoElement.addEventListener(api.keyadded, eventHandler);
            eventBus.trigger(_coreEventsEvents2['default'].VIDEO_ELEMENT_SELECTED);
        }
    }

    function createKeySession(initData /*, keySystemType */) {

        if (!keySystem) {
            throw new Error('Can not create sessions until you have selected a key system');
        }

        // Determine if creating a new session is allowed
        if (moreSessionsAllowed || sessions.length === 0) {

            var newSession = { // Implements SessionToken
                sessionID: null,
                initData: initData,
                getSessionID: function getSessionID() {
                    return this.sessionID;
                },

                getExpirationTime: function getExpirationTime() {
                    return NaN;
                },

                getSessionType: function getSessionType() {
                    return 'temporary';
                }
            };
            pendingSessions.push(newSession);

            // Send our request to the CDM
            videoElement[api.generateKeyRequest](keySystem.systemString, new Uint8Array(initData));

            return newSession;
        } else {
            throw new Error('Multiple sessions not allowed!');
        }
    }

    function updateKeySession(sessionToken, message) {
        var sessionID = sessionToken.sessionID;
        if (!protectionKeyController.isClearKey(keySystem)) {
            // Send our request to the CDM
            videoElement[api.addKey](keySystem.systemString, new Uint8Array(message), sessionToken.initData, sessionID);
        } else {
            // For clearkey, message is a ClearKeyKeySet
            for (var i = 0; i < message.keyPairs.length; i++) {
                videoElement[api.addKey](keySystem.systemString, message.keyPairs[i].key, message.keyPairs[i].keyID, sessionID);
            }
        }
    }

    function closeKeySession(sessionToken) {
        // Send our request to the CDM
        videoElement[api.cancelKeyRequest](keySystem.systemString, sessionToken.sessionID);
    }

    function setServerCertificate() /*serverCertificate*/{/* Not supported */}
    function loadKeySession() /*sessionID*/{/* Not supported */}
    function removeKeySession() /*sessionToken*/{/* Not supported */}

    function createEventHandler() {
        return {
            handleEvent: function handleEvent(event) {
                var sessionToken = null;
                switch (event.type) {

                    case api.needkey:
                        var initData = ArrayBuffer.isView(event.initData) ? event.initData.buffer : event.initData;
                        eventBus.trigger(_coreEventsEvents2['default'].NEED_KEY, { key: new _voNeedKey2['default'](initData, 'cenc') });
                        break;

                    case api.keyerror:
                        sessionToken = findSessionByID(sessions, event.sessionId);
                        if (!sessionToken) {
                            sessionToken = findSessionByID(pendingSessions, event.sessionId);
                        }

                        if (sessionToken) {
                            var msg = '';
                            switch (event.errorCode.code) {
                                case 1:
                                    msg += 'MEDIA_KEYERR_UNKNOWN - An unspecified error occurred. This value is used for errors that don\'t match any of the other codes.';
                                    break;
                                case 2:
                                    msg += 'MEDIA_KEYERR_CLIENT - The Key System could not be installed or updated.';
                                    break;
                                case 3:
                                    msg += 'MEDIA_KEYERR_SERVICE - The message passed into update indicated an error from the license service.';
                                    break;
                                case 4:
                                    msg += 'MEDIA_KEYERR_OUTPUT - There is no available output device with the required characteristics for the content protection system.';
                                    break;
                                case 5:
                                    msg += 'MEDIA_KEYERR_HARDWARECHANGE - A hardware configuration change caused a content protection error.';
                                    break;
                                case 6:
                                    msg += 'MEDIA_KEYERR_DOMAIN - An error occurred in a multi-device domain licensing configuration. The most common error is a failure to join the domain.';
                                    break;
                            }
                            msg += '  System Code = ' + event.systemCode;
                            // TODO: Build error string based on key error
                            eventBus.trigger(_coreEventsEvents2['default'].KEY_ERROR, { data: new _voKeyError2['default'](sessionToken, msg) });
                        } else {
                            log('No session token found for key error');
                        }
                        break;

                    case api.keyadded:
                        sessionToken = findSessionByID(sessions, event.sessionId);
                        if (!sessionToken) {
                            sessionToken = findSessionByID(pendingSessions, event.sessionId);
                        }

                        if (sessionToken) {
                            log('DRM: Key added.');
                            eventBus.trigger(_coreEventsEvents2['default'].KEY_ADDED, { data: sessionToken }); //TODO not sure anything is using sessionToken? why there?
                        } else {
                                log('No session token found for key added');
                            }
                        break;

                    case api.keymessage:

                        // If this CDM does not support session IDs, we will be limited
                        // to a single session
                        moreSessionsAllowed = event.sessionId !== null && event.sessionId !== undefined;

                        // SessionIDs supported
                        if (moreSessionsAllowed) {

                            // Attempt to find an uninitialized token with this sessionID
                            sessionToken = findSessionByID(sessions, event.sessionId);
                            if (!sessionToken && pendingSessions.length > 0) {

                                // This is the first message for our latest session, so set the
                                // sessionID and add it to our list
                                sessionToken = pendingSessions.shift();
                                sessions.push(sessionToken);
                                sessionToken.sessionID = event.sessionId;
                            }
                        } else if (pendingSessions.length > 0) {
                            // SessionIDs not supported

                            sessionToken = pendingSessions.shift();
                            sessions.push(sessionToken);

                            if (pendingSessions.length !== 0) {
                                errHandler.mediaKeyMessageError('Multiple key sessions were creates with a user-agent that does not support sessionIDs!! Unpredictable behavior ahead!');
                            }
                        }

                        if (sessionToken) {
                            var message = ArrayBuffer.isView(event.message) ? event.message.buffer : event.message;

                            // For ClearKey, the spec mandates that you pass this message to the
                            // addKey method, so we always save it to the token since there is no
                            // way to tell which key system is in use
                            sessionToken.keyMessage = message;
                            eventBus.trigger(_coreEventsEvents2['default'].INTERNAL_KEY_MESSAGE, { data: new _voKeyMessage2['default'](sessionToken, message, event.defaultURL) });
                        } else {
                            log('No session token found for key message');
                        }
                        break;
                }
            }
        };
    }

    /**
     * Helper function to retrieve the stored session token based on a given
     * sessionID value
     *
     * @param {Array} sessionArray - the array of sessions to search
     * @param {*} sessionID - the sessionID to search for
     * @returns {*} the session token with the given sessionID
     */
    function findSessionByID(sessionArray, sessionID) {

        if (!sessionID || !sessionArray) {
            return null;
        } else {
            var len = sessionArray.length;
            for (var i = 0; i < len; i++) {
                if (sessionArray[i].sessionID == sessionID) {
                    return sessionArray[i];
                }
            }
            return null;
        }
    }

    function removeEventListeners() {
        videoElement.removeEventListener(api.keyerror, eventHandler);
        videoElement.removeEventListener(api.needkey, eventHandler);
        videoElement.removeEventListener(api.keymessage, eventHandler);
        videoElement.removeEventListener(api.keyadded, eventHandler);
    }

    instance = {
        getAllInitData: getAllInitData,
        requestKeySystemAccess: requestKeySystemAccess,
        getKeySystem: getKeySystem,
        selectKeySystem: selectKeySystem,
        setMediaElement: setMediaElement,
        createKeySession: createKeySession,
        updateKeySession: updateKeySession,
        closeKeySession: closeKeySession,
        setServerCertificate: setServerCertificate,
        loadKeySession: loadKeySession,
        removeKeySession: removeKeySession,
        reset: reset
    };

    setup();

    return instance;
}

ProtectionModel_01b.__dashjs_factory_name = 'ProtectionModel_01b';
exports['default'] = _coreFactoryMaker2['default'].getClassFactory(ProtectionModel_01b);
module.exports = exports['default'];
//# sourceMappingURL=ProtectionModel_01b.js.map


/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * Most recent EME implementation
 *
 * Implemented by Google Chrome v36+ (Windows, OSX, Linux)
 *
 * @implements ProtectionModel
 * @class
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _controllersProtectionKeyController = __webpack_require__(326);

var _controllersProtectionKeyController2 = _interopRequireDefault(_controllersProtectionKeyController);

var _voNeedKey = __webpack_require__(404);

var _voNeedKey2 = _interopRequireDefault(_voNeedKey);

var _voKeyError = __webpack_require__(400);

var _voKeyError2 = _interopRequireDefault(_voKeyError);

var _voKeyMessage = __webpack_require__(401);

var _voKeyMessage2 = _interopRequireDefault(_voKeyMessage);

var _voKeySystemAccess = __webpack_require__(402);

var _voKeySystemAccess2 = _interopRequireDefault(_voKeySystemAccess);

var _coreEventsEvents = __webpack_require__(22);

var _coreEventsEvents2 = _interopRequireDefault(_coreEventsEvents);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

function ProtectionModel_21Jan2015(config) {

    var context = this.context;
    var eventBus = config.eventBus; //Need to pass in here so we can use same instance since this is optional module
    var log = config.log;

    var instance, keySystem, videoElement, mediaKeys, sessions, eventHandler, protectionKeyController;

    function setup() {
        keySystem = null;
        videoElement = null;
        mediaKeys = null;
        sessions = [];
        protectionKeyController = (0, _controllersProtectionKeyController2['default'])(context).getInstance();
        eventHandler = createEventHandler();
    }

    function reset() {
        var numSessions = sessions.length;
        var session;

        if (numSessions !== 0) {
            // Called when we are done closing a session.  Success or fail
            var done = function done(session) {
                removeSession(session);
                if (sessions.length === 0) {
                    if (videoElement) {
                        videoElement.removeEventListener('encrypted', eventHandler);
                        videoElement.setMediaKeys(null).then(function () {
                            eventBus.trigger(_coreEventsEvents2['default'].TEARDOWN_COMPLETE);
                        });
                    } else {
                        eventBus.trigger(_coreEventsEvents2['default'].TEARDOWN_COMPLETE);
                    }
                }
            };
            for (var i = 0; i < numSessions; i++) {
                session = sessions[i];
                (function (s) {
                    // Override closed promise resolver
                    session.session.closed.then(function () {
                        done(s);
                    });
                    // Close the session and handle errors, otherwise promise
                    // resolver above will be called
                    closeKeySessionInternal(session)['catch'](function () {
                        done(s);
                    });
                })(session);
            }
        } else {
            eventBus.trigger(_coreEventsEvents2['default'].TEARDOWN_COMPLETE);
        }
    }

    function getKeySystem() {
        return keySystem;
    }

    function getAllInitData() {
        var retVal = [];
        for (var i = 0; i < sessions.length; i++) {
            retVal.push(sessions[i].initData);
        }
        return retVal;
    }

    function requestKeySystemAccess(ksConfigurations) {
        requestKeySystemAccessInternal(ksConfigurations, 0);
    }

    function selectKeySystem(keySystemAccess) {
        keySystemAccess.mksa.createMediaKeys().then(function (mkeys) {
            keySystem = keySystemAccess.keySystem;
            mediaKeys = mkeys;
            if (videoElement) {
                videoElement.setMediaKeys(mediaKeys);
            }
            eventBus.trigger(_coreEventsEvents2['default'].INTERNAL_KEY_SYSTEM_SELECTED);
        })['catch'](function () {
            eventBus.trigger(_coreEventsEvents2['default'].INTERNAL_KEY_SYSTEM_SELECTED, { error: 'Error selecting keys system (' + keySystemAccess.keySystem.systemString + ')! Could not create MediaKeys -- TODO' });
        });
    }

    function setMediaElement(mediaElement) {
        if (videoElement === mediaElement) return;

        // Replacing the previous element
        if (videoElement) {
            videoElement.removeEventListener('encrypted', eventHandler);
            videoElement.setMediaKeys(null);
        }

        videoElement = mediaElement;

        // Only if we are not detaching from the existing element
        if (videoElement) {
            videoElement.addEventListener('encrypted', eventHandler);
            if (mediaKeys) {
                videoElement.setMediaKeys(mediaKeys);
            }
        }
    }

    function setServerCertificate(serverCertificate) {
        if (!keySystem || !mediaKeys) {
            throw new Error('Can not set server certificate until you have selected a key system');
        }
        mediaKeys.setServerCertificate(serverCertificate).then(function () {
            log('DRM: License server certificate successfully updated.');
            eventBus.trigger(_coreEventsEvents2['default'].SERVER_CERTIFICATE_UPDATED);
        })['catch'](function (error) {
            eventBus.trigger(_coreEventsEvents2['default'].SERVER_CERTIFICATE_UPDATED, { error: 'Error updating server certificate -- ' + error.name });
        });
    }

    function createKeySession(initData, sessionType) {

        if (!keySystem || !mediaKeys) {
            throw new Error('Can not create sessions until you have selected a key system');
        }

        var session = mediaKeys.createSession(sessionType);
        var sessionToken = createSessionToken(session, initData, sessionType);

        // Generate initial key request
        session.generateRequest('cenc', initData).then(function () {
            log('DRM: Session created.  SessionID = ' + sessionToken.getSessionID());
            eventBus.trigger(_coreEventsEvents2['default'].KEY_SESSION_CREATED, { data: sessionToken });
        })['catch'](function (error) {
            // TODO: Better error string
            removeSession(sessionToken);
            eventBus.trigger(_coreEventsEvents2['default'].KEY_SESSION_CREATED, { data: null, error: 'Error generating key request -- ' + error.name });
        });
    }

    function updateKeySession(sessionToken, message) {

        var session = sessionToken.session;

        // Send our request to the key session
        if (protectionKeyController.isClearKey(keySystem)) {
            message = message.toJWK();
        }
        session.update(message)['catch'](function (error) {
            eventBus.trigger(_coreEventsEvents2['default'].KEY_ERROR, { data: new _voKeyError2['default'](sessionToken, 'Error sending update() message! ' + error.name) });
        });
    }

    function loadKeySession(sessionID) {
        if (!keySystem || !mediaKeys) {
            throw new Error('Can not load sessions until you have selected a key system');
        }

        var session = mediaKeys.createSession();

        // Load persisted session data into our newly created session object
        session.load(sessionID).then(function (success) {
            if (success) {
                var sessionToken = createSessionToken(session);
                log('DRM: Session created.  SessionID = ' + sessionToken.getSessionID());
                eventBus.trigger(_coreEventsEvents2['default'].KEY_SESSION_CREATED, { data: sessionToken });
            } else {
                eventBus.trigger(_coreEventsEvents2['default'].KEY_SESSION_CREATED, { data: null, error: 'Could not load session! Invalid Session ID (' + sessionID + ')' });
            }
        })['catch'](function (error) {
            eventBus.trigger(_coreEventsEvents2['default'].KEY_SESSION_CREATED, { data: null, error: 'Could not load session (' + sessionID + ')! ' + error.name });
        });
    }

    function removeKeySession(sessionToken) {
        var session = sessionToken.session;

        session.remove().then(function () {
            log('DRM: Session removed.  SessionID = ' + sessionToken.getSessionID());
            eventBus.trigger(_coreEventsEvents2['default'].KEY_SESSION_REMOVED, { data: sessionToken.getSessionID() });
        }, function (error) {
            eventBus.trigger(_coreEventsEvents2['default'].KEY_SESSION_REMOVED, { data: null, error: 'Error removing session (' + sessionToken.getSessionID() + '). ' + error.name });
        });
    }

    function closeKeySession(sessionToken) {
        // Send our request to the key session
        closeKeySessionInternal(sessionToken)['catch'](function (error) {
            removeSession(sessionToken);
            eventBus.trigger(_coreEventsEvents2['default'].KEY_SESSION_CLOSED, { data: null, error: 'Error closing session (' + sessionToken.getSessionID() + ') ' + error.name });
        });
    }

    function requestKeySystemAccessInternal(ksConfigurations, idx) {
        (function (i) {
            var keySystem = ksConfigurations[i].ks;
            var configs = ksConfigurations[i].configs;
            navigator.requestMediaKeySystemAccess(keySystem.systemString, configs).then(function (mediaKeySystemAccess) {

                // Chrome 40 does not currently implement MediaKeySystemAccess.getConfiguration()
                var configuration = typeof mediaKeySystemAccess.getConfiguration === 'function' ? mediaKeySystemAccess.getConfiguration() : null;
                var keySystemAccess = new _voKeySystemAccess2['default'](keySystem, configuration);
                keySystemAccess.mksa = mediaKeySystemAccess;
                eventBus.trigger(_coreEventsEvents2['default'].KEY_SYSTEM_ACCESS_COMPLETE, { data: keySystemAccess });
            })['catch'](function () {
                if (++i < ksConfigurations.length) {
                    requestKeySystemAccessInternal(ksConfigurations, i);
                } else {
                    eventBus.trigger(_coreEventsEvents2['default'].KEY_SYSTEM_ACCESS_COMPLETE, { error: 'Key system access denied!' });
                }
            });
        })(idx);
    }

    function closeKeySessionInternal(sessionToken) {
        var session = sessionToken.session;

        // Remove event listeners
        session.removeEventListener('keystatuseschange', sessionToken);
        session.removeEventListener('message', sessionToken);

        // Send our request to the key session
        return session.close();
    }

    // This is our main event handler for all desired HTMLMediaElement events
    // related to EME.  These events are translated into our API-independent
    // versions of the same events
    function createEventHandler() {
        return {
            handleEvent: function handleEvent(event) {
                switch (event.type) {

                    case 'encrypted':
                        if (event.initData) {
                            var initData = ArrayBuffer.isView(event.initData) ? event.initData.buffer : event.initData;
                            eventBus.trigger(_coreEventsEvents2['default'].NEED_KEY, { key: new _voNeedKey2['default'](initData, event.initDataType) });
                        }
                        break;
                }
            }
        };
    }

    function removeSession(token) {
        // Remove from our session list
        for (var i = 0; i < sessions.length; i++) {
            if (sessions[i] === token) {
                sessions.splice(i, 1);
                break;
            }
        }
    }

    // Function to create our session token objects which manage the EME
    // MediaKeySession and session-specific event handler
    function createSessionToken(session, initData, sessionType) {

        var token = { // Implements SessionToken
            session: session,
            initData: initData,

            // This is our main event handler for all desired MediaKeySession events
            // These events are translated into our API-independent versions of the
            // same events
            handleEvent: function handleEvent(event) {
                switch (event.type) {
                    case 'keystatuseschange':
                        eventBus.trigger(_coreEventsEvents2['default'].KEY_STATUSES_CHANGED, { data: this });
                        break;

                    case 'message':
                        var message = ArrayBuffer.isView(event.message) ? event.message.buffer : event.message;
                        eventBus.trigger(_coreEventsEvents2['default'].INTERNAL_KEY_MESSAGE, { data: new _voKeyMessage2['default'](this, message, undefined, event.messageType) });
                        break;
                }
            },

            getSessionID: function getSessionID() {
                return session.sessionId;
            },

            getExpirationTime: function getExpirationTime() {
                return session.expiration;
            },

            getKeyStatuses: function getKeyStatuses() {
                return session.keyStatuses;
            },

            getSessionType: function getSessionType() {
                return sessionType;
            }
        };

        // Add all event listeners
        session.addEventListener('keystatuseschange', token);
        session.addEventListener('message', token);

        // Register callback for session closed Promise
        session.closed.then(function () {
            removeSession(token);
            log('DRM: Session closed.  SessionID = ' + token.getSessionID());
            eventBus.trigger(_coreEventsEvents2['default'].KEY_SESSION_CLOSED, { data: token.getSessionID() });
        });

        // Add to our session list
        sessions.push(token);

        return token;
    }

    instance = {
        getAllInitData: getAllInitData,
        requestKeySystemAccess: requestKeySystemAccess,
        getKeySystem: getKeySystem,
        selectKeySystem: selectKeySystem,
        setMediaElement: setMediaElement,
        setServerCertificate: setServerCertificate,
        createKeySession: createKeySession,
        updateKeySession: updateKeySession,
        loadKeySession: loadKeySession,
        removeKeySession: removeKeySession,
        closeKeySession: closeKeySession,
        reset: reset
    };

    setup();

    return instance;
}

ProtectionModel_21Jan2015.__dashjs_factory_name = 'ProtectionModel_21Jan2015';
exports['default'] = _coreFactoryMaker2['default'].getClassFactory(ProtectionModel_21Jan2015);
module.exports = exports['default'];
//# sourceMappingURL=ProtectionModel_21Jan2015.js.map


/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * Implementation of the EME APIs as of the 3 Feb 2014 state of the specification.
 *
 * Implemented by Internet Explorer 11 (Windows 8.1)
 *
 * @implements ProtectionModel
 * @class
 */



Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _controllersProtectionKeyController = __webpack_require__(326);

var _controllersProtectionKeyController2 = _interopRequireDefault(_controllersProtectionKeyController);

var _voNeedKey = __webpack_require__(404);

var _voNeedKey2 = _interopRequireDefault(_voNeedKey);

var _voKeyError = __webpack_require__(400);

var _voKeyError2 = _interopRequireDefault(_voKeyError);

var _voKeyMessage = __webpack_require__(401);

var _voKeyMessage2 = _interopRequireDefault(_voKeyMessage);

var _voKeySystemConfiguration = __webpack_require__(403);

var _voKeySystemConfiguration2 = _interopRequireDefault(_voKeySystemConfiguration);

var _voKeySystemAccess = __webpack_require__(402);

var _voKeySystemAccess2 = _interopRequireDefault(_voKeySystemAccess);

var _coreEventsEvents = __webpack_require__(22);

var _coreEventsEvents2 = _interopRequireDefault(_coreEventsEvents);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

function ProtectionModel_3Feb2014(config) {

    var context = this.context;
    var eventBus = config.eventBus; //Need to pass in here so we can use same instance since this is optional module
    var log = config.log;
    var api = config.api;

    var instance = undefined,
        videoElement = undefined,
        keySystem = undefined,
        mediaKeys = undefined,
        keySystemAccess = undefined,
        sessions = undefined,
        eventHandler = undefined,
        protectionKeyController = undefined;

    function setup() {
        videoElement = null;
        keySystem = null;
        mediaKeys = null;
        keySystemAccess = null;
        sessions = [];
        protectionKeyController = (0, _controllersProtectionKeyController2['default'])(context).getInstance();
        eventHandler = createEventHandler();
    }

    function reset() {
        try {
            for (var i = 0; i < sessions.length; i++) {
                closeKeySession(sessions[i]);
            }
            if (videoElement) {
                videoElement.removeEventListener(api.needkey, eventHandler);
            }
            eventBus.trigger(_coreEventsEvents2['default'].TEARDOWN_COMPLETE);
        } catch (error) {
            eventBus.trigger(_coreEventsEvents2['default'].TEARDOWN_COMPLETE, { error: 'Error tearing down key sessions and MediaKeys! -- ' + error.message });
        }
    }

    function getKeySystem() {
        return keySystem;
    }

    function getAllInitData() {
        var retVal = [];
        for (var i = 0; i < sessions.length; i++) {
            retVal.push(sessions[i].initData);
        }
        return retVal;
    }

    function requestKeySystemAccess(ksConfigurations) {

        // Try key systems in order, first one with supported key system configuration
        // is used
        var found = false;
        for (var ksIdx = 0; ksIdx < ksConfigurations.length; ksIdx++) {
            var systemString = ksConfigurations[ksIdx].ks.systemString;
            var configs = ksConfigurations[ksIdx].configs;
            var supportedAudio = null;
            var supportedVideo = null;

            // Try key system configs in order, first one with supported audio/video
            // is used
            for (var configIdx = 0; configIdx < configs.length; configIdx++) {
                var audios = configs[configIdx].audioCapabilities;
                var videos = configs[configIdx].videoCapabilities;

                // Look for supported audio container/codecs
                if (audios && audios.length !== 0) {
                    supportedAudio = []; // Indicates that we have a requested audio config
                    for (var audioIdx = 0; audioIdx < audios.length; audioIdx++) {
                        if (window[api.MediaKeys].isTypeSupported(systemString, audios[audioIdx].contentType)) {
                            supportedAudio.push(audios[audioIdx]);
                        }
                    }
                }

                // Look for supported video container/codecs
                if (videos && videos.length !== 0) {
                    supportedVideo = []; // Indicates that we have a requested video config
                    for (var videoIdx = 0; videoIdx < videos.length; videoIdx++) {
                        if (window[api.MediaKeys].isTypeSupported(systemString, videos[videoIdx].contentType)) {
                            supportedVideo.push(videos[videoIdx]);
                        }
                    }
                }

                // No supported audio or video in this configuration OR we have
                // requested audio or video configuration that is not supported
                if (!supportedAudio && !supportedVideo || supportedAudio && supportedAudio.length === 0 || supportedVideo && supportedVideo.length === 0) {
                    continue;
                }

                // This configuration is supported
                found = true;
                var ksConfig = new _voKeySystemConfiguration2['default'](supportedAudio, supportedVideo);
                var ks = protectionKeyController.getKeySystemBySystemString(systemString);
                eventBus.trigger(_coreEventsEvents2['default'].KEY_SYSTEM_ACCESS_COMPLETE, { data: new _voKeySystemAccess2['default'](ks, ksConfig) });
                break;
            }
        }
        if (!found) {
            eventBus.trigger(_coreEventsEvents2['default'].KEY_SYSTEM_ACCESS_COMPLETE, { error: 'Key system access denied! -- No valid audio/video content configurations detected!' });
        }
    }

    function selectKeySystem(ksAccess) {
        try {
            mediaKeys = ksAccess.mediaKeys = new window[api.MediaKeys](ksAccess.keySystem.systemString);
            keySystem = ksAccess.keySystem;
            keySystemAccess = ksAccess;
            if (videoElement) {
                setMediaKeys();
            }
            eventBus.trigger(_coreEventsEvents2['default'].INTERNAL_KEY_SYSTEM_SELECTED);
        } catch (error) {
            eventBus.trigger(_coreEventsEvents2['default'].INTERNAL_KEY_SYSTEM_SELECTED, { error: 'Error selecting keys system (' + keySystem.systemString + ')! Could not create MediaKeys -- TODO' });
        }
    }

    function setMediaElement(mediaElement) {
        if (videoElement === mediaElement) return;

        // Replacing the previous element
        if (videoElement) {
            videoElement.removeEventListener(api.needkey, eventHandler);
        }

        videoElement = mediaElement;

        // Only if we are not detaching from the existing element
        if (videoElement) {
            videoElement.addEventListener(api.needkey, eventHandler);
            if (mediaKeys) {
                setMediaKeys();
            }
        }
    }

    function createKeySession(initData /*, keySystemType */) {

        if (!keySystem || !mediaKeys || !keySystemAccess) {
            throw new Error('Can not create sessions until you have selected a key system');
        }

        // Use the first video capability for the contentType.
        // TODO:  Not sure if there is a way to concatenate all capability data into a RFC6386-compatible format

        // If player is trying to playback Audio only stream - don't error out.
        var capabilities = null;

        if (keySystemAccess.ksConfiguration.videoCapabilities !== null && keySystemAccess.ksConfiguration.videoCapabilities.length > 0) capabilities = keySystemAccess.ksConfiguration.videoCapabilities[0];

        if (capabilities === null && keySystemAccess.ksConfiguration.audioCapabilities !== null && keySystemAccess.ksConfiguration.audioCapabilities.length > 0) capabilities = keySystemAccess.ksConfiguration.audioCapabilities[0];

        if (capabilities === null) throw new Error('Can not create sessions for unknown content types.');

        var contentType = capabilities.contentType;
        var session = mediaKeys.createSession(contentType, new Uint8Array(initData));
        var sessionToken = createSessionToken(session, initData);

        // Add all event listeners
        session.addEventListener(api.error, sessionToken);
        session.addEventListener(api.message, sessionToken);
        session.addEventListener(api.ready, sessionToken);
        session.addEventListener(api.close, sessionToken);

        // Add to our session list
        sessions.push(sessionToken);
        log('DRM: Session created.  SessionID = ' + sessionToken.getSessionID());
        eventBus.trigger(_coreEventsEvents2['default'].KEY_SESSION_CREATED, { data: sessionToken });
    }

    function updateKeySession(sessionToken, message) {

        var session = sessionToken.session;

        if (!protectionKeyController.isClearKey(keySystem)) {
            // Send our request to the key session
            session.update(new Uint8Array(message));
        } else {
            // For clearkey, message is a ClearKeyKeySet
            session.update(new Uint8Array(message.toJWK()));
        }
    }

    /**
     * Close the given session and release all associated keys.  Following
     * this call, the sessionToken becomes invalid
     *
     * @param {Object} sessionToken - the session token
     */
    function closeKeySession(sessionToken) {

        var session = sessionToken.session;

        // Remove event listeners
        session.removeEventListener(api.error, sessionToken);
        session.removeEventListener(api.message, sessionToken);
        session.removeEventListener(api.ready, sessionToken);
        session.removeEventListener(api.close, sessionToken);

        // Remove from our session list
        for (var i = 0; i < sessions.length; i++) {
            if (sessions[i] === sessionToken) {
                sessions.splice(i, 1);
                break;
            }
        }

        // Send our request to the key session
        session[api.release]();
    }

    function setServerCertificate() /*serverCertificate*/{/* Not supported */}
    function loadKeySession() /*sessionID*/{/* Not supported */}
    function removeKeySession() /*sessionToken*/{/* Not supported */}

    function createEventHandler() {
        return {
            handleEvent: function handleEvent(event) {
                switch (event.type) {

                    case api.needkey:
                        if (event.initData) {
                            var initData = ArrayBuffer.isView(event.initData) ? event.initData.buffer : event.initData;
                            eventBus.trigger(_coreEventsEvents2['default'].NEED_KEY, { key: new _voNeedKey2['default'](initData, 'cenc') });
                        }
                        break;
                }
            }
        };
    }

    // IE11 does not let you set MediaKeys until it has entered a certain
    // readyState, so we need this logic to ensure we don't set the keys
    // too early
    function setMediaKeys() {
        var boundDoSetKeys = null;
        var doSetKeys = function doSetKeys() {
            videoElement.removeEventListener('loadedmetadata', boundDoSetKeys);
            videoElement[api.setMediaKeys](mediaKeys);
            eventBus.trigger(_coreEventsEvents2['default'].VIDEO_ELEMENT_SELECTED);
        };
        if (videoElement.readyState >= 1) {
            doSetKeys();
        } else {
            boundDoSetKeys = doSetKeys.bind(this);
            videoElement.addEventListener('loadedmetadata', boundDoSetKeys);
        }
    }

    // Function to create our session token objects which manage the EME
    // MediaKeySession and session-specific event handler
    function createSessionToken(keySession, initData) {
        return {
            // Implements SessionToken
            session: keySession,
            initData: initData,

            getSessionID: function getSessionID() {
                return this.session.sessionId;
            },

            getExpirationTime: function getExpirationTime() {
                return NaN;
            },

            getSessionType: function getSessionType() {
                return 'temporary';
            },
            // This is our main event handler for all desired MediaKeySession events
            // These events are translated into our API-independent versions of the
            // same events
            handleEvent: function handleEvent(event) {
                switch (event.type) {

                    case api.error:
                        var errorStr = 'KeyError'; // TODO: Make better string from event
                        eventBus.trigger(_coreEventsEvents2['default'].KEY_ERROR, { data: new _voKeyError2['default'](this, errorStr) });
                        break;
                    case api.message:
                        var message = ArrayBuffer.isView(event.message) ? event.message.buffer : event.message;
                        eventBus.trigger(_coreEventsEvents2['default'].INTERNAL_KEY_MESSAGE, { data: new _voKeyMessage2['default'](this, message, event.destinationURL) });
                        break;
                    case api.ready:
                        log('DRM: Key added.');
                        eventBus.trigger(_coreEventsEvents2['default'].KEY_ADDED);
                        break;

                    case api.close:
                        log('DRM: Session closed.  SessionID = ' + this.getSessionID());
                        eventBus.trigger(_coreEventsEvents2['default'].KEY_SESSION_CLOSED, { data: this.getSessionID() });
                        break;
                }
            }
        };
    }

    instance = {
        getAllInitData: getAllInitData,
        requestKeySystemAccess: requestKeySystemAccess,
        getKeySystem: getKeySystem,
        selectKeySystem: selectKeySystem,
        setMediaElement: setMediaElement,
        createKeySession: createKeySession,
        updateKeySession: updateKeySession,
        closeKeySession: closeKeySession,
        setServerCertificate: setServerCertificate,
        loadKeySession: loadKeySession,
        removeKeySession: removeKeySession,
        reset: reset
    };

    setup();

    return instance;
}

ProtectionModel_3Feb2014.__dashjs_factory_name = 'ProtectionModel_3Feb2014';
exports['default'] = _coreFactoryMaker2['default'].getClassFactory(ProtectionModel_3Feb2014);
module.exports = exports['default'];
//# sourceMappingURL=ProtectionModel_3Feb2014.js.map


/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * CableLabs ClearKey license server implementation
 *
 * For testing purposes and evaluating potential uses for ClearKey, we have developed
 * a dirt-simple API for requesting ClearKey licenses from a remote server.
 *
 * @implements LicenseServer
 * @class
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _voKeyPair = __webpack_require__(596);

var _voKeyPair2 = _interopRequireDefault(_voKeyPair);

var _voClearKeyKeySet = __webpack_require__(595);

var _voClearKeyKeySet2 = _interopRequireDefault(_voClearKeyKeySet);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

function ClearKey() {

    var instance = undefined;

    function getServerURLFromMessage(url, message /*, messageType*/) {
        // Build ClearKey server query string
        var jsonMsg = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(message)));
        url += '/?';
        for (var i = 0; i < jsonMsg.kids.length; i++) {
            url += jsonMsg.kids[i] + '&';
        }
        url = url.substring(0, url.length - 1);
        return url;
    }

    function getHTTPMethod() /*messageType*/{
        return 'GET';
    }

    function getResponseType() /*keySystemStr*/{
        return 'json';
    }

    function getLicenseMessage(serverResponse /*, keySystemStr, messageType*/) {
        if (!serverResponse.hasOwnProperty('keys')) {
            return null;
        }
        var keyPairs = [];
        for (var i = 0; i < serverResponse.keys.length; i++) {
            var keypair = serverResponse.keys[i];
            var keyid = keypair.kid.replace(/=/g, '');
            var key = keypair.k.replace(/=/g, '');

            keyPairs.push(new _voKeyPair2['default'](keyid, key));
        }
        return new _voClearKeyKeySet2['default'](keyPairs);
    }

    function getErrorResponse(serverResponse /*, keySystemStr, messageType*/) {
        return String.fromCharCode.apply(null, new Uint8Array(serverResponse));
    }

    instance = {
        getServerURLFromMessage: getServerURLFromMessage,
        getHTTPMethod: getHTTPMethod,
        getResponseType: getResponseType,
        getLicenseMessage: getLicenseMessage,
        getErrorResponse: getErrorResponse
    };

    return instance;
}

ClearKey.__dashjs_factory_name = 'ClearKey';
exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(ClearKey);
module.exports = exports['default'];
//# sourceMappingURL=ClearKey.js.map


/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * CastLabs DRMToday License Server implementation
 *
 * @implements LicenseServer
 * @class
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _externalsBase64 = __webpack_require__(392);

var _externalsBase642 = _interopRequireDefault(_externalsBase64);

function DRMToday() {

    var keySystems = {
        'com.widevine.alpha': {
            responseType: 'json',
            getLicenseMessage: function getLicenseMessage(response) {
                return _externalsBase642['default'].decodeArray(response.license);
            },
            getErrorResponse: function getErrorResponse(response) {
                return response;
            }
        },
        'com.microsoft.playready': {
            responseType: 'arraybuffer',
            getLicenseMessage: function getLicenseMessage(response) {
                return response;
            },
            getErrorResponse: function getErrorResponse(response) {
                return String.fromCharCode.apply(null, new Uint8Array(response));
            }
        }
    };

    var instance = undefined;

    function getServerURLFromMessage(url /*, message, messageType*/) {
        return url;
    }

    function getHTTPMethod() /*messageType*/{
        return 'POST';
    }

    function getResponseType(keySystemStr /*, messageType*/) {
        return keySystems[keySystemStr].responseType;
    }

    function getLicenseMessage(serverResponse, keySystemStr /*, messageType*/) {
        return keySystems[keySystemStr].getLicenseMessage(serverResponse);
    }

    function getErrorResponse(serverResponse, keySystemStr /*, messageType*/) {
        return keySystems[keySystemStr].getErrorResponse(serverResponse);
    }

    instance = {
        getServerURLFromMessage: getServerURLFromMessage,
        getHTTPMethod: getHTTPMethod,
        getResponseType: getResponseType,
        getLicenseMessage: getLicenseMessage,
        getErrorResponse: getErrorResponse
    };

    return instance;
}

DRMToday.__dashjs_factory_name = 'DRMToday';
exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(DRMToday);
module.exports = exports['default'];
//# sourceMappingURL=DRMToday.js.map


/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * Microsoft PlayReady Test License Server
 *
 * For testing content that uses the PlayReady test server at
 *
 * @implements LicenseServer
 * @class
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

function PlayReady() {

    var instance = undefined;

    function getServerURLFromMessage(url /*, message, messageType*/) {
        return url;
    }

    function getHTTPMethod() /*messageType*/{
        return 'POST';
    }

    function getResponseType() /*keySystemStr, messageType*/{
        return 'arraybuffer';
    }

    function getLicenseMessage(serverResponse /*, keySystemStr, messageType*/) {
        return serverResponse;
    }

    function getErrorResponse(serverResponse /*, keySystemStr, messageType*/) {
        return String.fromCharCode.apply(null, new Uint8Array(serverResponse));
    }

    instance = {
        getServerURLFromMessage: getServerURLFromMessage,
        getHTTPMethod: getHTTPMethod,
        getResponseType: getResponseType,
        getLicenseMessage: getLicenseMessage,
        getErrorResponse: getErrorResponse
    };

    return instance;
}

PlayReady.__dashjs_factory_name = 'PlayReady';
exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(PlayReady);
module.exports = exports['default'];
//# sourceMappingURL=PlayReady.js.map


/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

function Widevine() {

    var instance = undefined;

    function getServerURLFromMessage(url /*, message, messageType*/) {
        return url;
    }

    function getHTTPMethod() /*messageType*/{
        return 'POST';
    }

    function getResponseType() /*keySystemStr, messageType*/{
        return 'arraybuffer';
    }

    function getLicenseMessage(serverResponse /*, keySystemStr, messageType*/) {
        return serverResponse;
    }

    function getErrorResponse(serverResponse /*, keySystemStr, messageType*/) {
        return String.fromCharCode.apply(null, new Uint8Array(serverResponse));
    }

    instance = {
        getServerURLFromMessage: getServerURLFromMessage,
        getHTTPMethod: getHTTPMethod,
        getResponseType: getResponseType,
        getLicenseMessage: getLicenseMessage,
        getErrorResponse: getErrorResponse
    };

    return instance;
}

Widevine.__dashjs_factory_name = 'Widevine';
exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(Widevine);
module.exports = exports['default'];
//# sourceMappingURL=Widevine.js.map


/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @classdesc A media capability
 * @ignore
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MediaCapability =
/**
 * @param {string} contentType MIME type and codecs (RFC6386)
 * @param {string} robustness
 * @class
 * @ignore
 */
function MediaCapability(contentType, robustness) {
  _classCallCheck(this, MediaCapability);

  this.contentType = contentType;
  this.robustness = robustness;
};

exports["default"] = MediaCapability;
module.exports = exports["default"];
//# sourceMappingURL=MediaCapability.js.map


/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreFactoryMakerJs = __webpack_require__(9);

var _coreFactoryMakerJs2 = _interopRequireDefault(_coreFactoryMakerJs);

function DroppedFramesHistory() {

    var values = [];
    var lastDroppedFrames = 0;
    var lastTotalFrames = 0;

    function push(index, playbackQuality) {
        var intervalDroppedFrames = playbackQuality.droppedVideoFrames - lastDroppedFrames;
        lastDroppedFrames = playbackQuality.droppedVideoFrames;

        var intervalTotalFrames = playbackQuality.totalVideoFrames - lastTotalFrames;
        lastTotalFrames = playbackQuality.totalVideoFrames;

        if (!values[index]) {
            values[index] = { droppedVideoFrames: intervalDroppedFrames, totalVideoFrames: intervalTotalFrames };
        } else {
            values[index].droppedVideoFrames += intervalDroppedFrames;
            values[index].totalVideoFrames += intervalTotalFrames;
        }
    }

    function getDroppedFrameHistory() {
        return values;
    }

    function reset(playbackQuality) {
        values = [];
        lastDroppedFrames = playbackQuality.droppedVideoFrames;
        lastTotalFrames = playbackQuality.totalVideoFrames;
    }

    return {
        push: push,
        getFrameHistory: getDroppedFrameHistory,
        reset: reset
    };
}

DroppedFramesHistory.__dashjs_factory_name = 'DroppedFramesHistory';
var factory = _coreFactoryMakerJs2['default'].getClassFactory(DroppedFramesHistory);
exports['default'] = factory;
module.exports = exports['default'];
//# sourceMappingURL=DroppedFramesHistory.js.map


/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

function RulesContext(config) {

    var instance = undefined;
    var representationInfo = config.streamProcessor.getCurrentRepresentationInfo();
    var sp = config.streamProcessor;
    var currentValue = config.currentValue;
    var playbackIndex = config.playbackIndex;
    var switchHistory = config.switchHistory;
    var droppedFramesHistory = config.droppedFramesHistory;
    var currentRequest = config.currentRequest;
    var richBuffer = config.hasRichBuffer;

    function getStreamInfo() {
        return representationInfo.mediaInfo.streamInfo;
    }

    function getMediaInfo() {
        return representationInfo.mediaInfo;
    }

    function getTrackInfo() {
        return representationInfo;
    }

    function getCurrentValue() {
        return currentValue;
    }

    function getManifestInfo() {
        return representationInfo.mediaInfo.streamInfo.manifestInfo;
    }

    function getStreamProcessor() {
        return sp;
    }

    function getPlaybackIndex() {
        return playbackIndex;
    }

    function getSwitchHistory() {
        return switchHistory;
    }

    function getDroppedFramesHistory() {
        return droppedFramesHistory;
    }

    function getCurrentRequest() {
        return currentRequest;
    }

    function hasRichBuffer() {
        return richBuffer;
    }

    instance = {
        getCurrentValue: getCurrentValue,
        getManifestInfo: getManifestInfo,
        getMediaInfo: getMediaInfo,
        getPlaybackIndex: getPlaybackIndex,
        getDroppedFramesHistory: getDroppedFramesHistory,
        getCurrentRequest: getCurrentRequest,
        getSwitchHistory: getSwitchHistory,
        getStreamInfo: getStreamInfo,
        getStreamProcessor: getStreamProcessor,
        getTrackInfo: getTrackInfo,
        hasRichBuffer: hasRichBuffer
    };

    return instance;
}

RulesContext.__dashjs_factory_name = 'RulesContext';
exports['default'] = _coreFactoryMaker2['default'].getClassFactory(RulesContext);
module.exports = exports['default'];
//# sourceMappingURL=RulesContext.js.map


/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreFactoryMakerJs = __webpack_require__(9);

var _coreFactoryMakerJs2 = _interopRequireDefault(_coreFactoryMakerJs);

var SWITCH_REQUEST_HISTORY_DEPTH = 8; // must be > SwitchHistoryRule SAMPLE_SIZE to enable rule

function SwitchRequestHistory() {
    var switchRequests = []; // running total
    var srHistory = []; // history of each switch

    function push(switchRequest) {
        if (!switchRequests[switchRequest.oldValue]) {
            switchRequests[switchRequest.oldValue] = { noDrops: 0, drops: 0, dropSize: 0 };
        }

        // Set switch details
        var indexDiff = switchRequest.newValue - switchRequest.oldValue;
        var drop = indexDiff < 0 ? 1 : 0;
        var dropSize = drop ? -indexDiff : 0;
        var noDrop = drop ? 0 : 1;

        // Update running totals
        switchRequests[switchRequest.oldValue].drops += drop;
        switchRequests[switchRequest.oldValue].dropSize += dropSize;
        switchRequests[switchRequest.oldValue].noDrops += noDrop;

        // Save to history
        srHistory.push({ idx: switchRequest.oldValue, noDrop: noDrop, drop: drop, dropSize: dropSize });

        // Shift earliest switch off srHistory and readjust to keep depth of running totals constant
        if (srHistory.length > SWITCH_REQUEST_HISTORY_DEPTH) {
            var srHistoryFirst = srHistory.shift();
            switchRequests[srHistoryFirst.idx].drops -= srHistoryFirst.drop;
            switchRequests[srHistoryFirst.idx].dropSize -= srHistoryFirst.dropSize;
            switchRequests[srHistoryFirst.idx].noDrops -= srHistoryFirst.noDrop;
        }
    }

    function getSwitchRequests() {
        return switchRequests;
    }

    function reset() {
        switchRequests = [];
        srHistory = [];
    }

    return {
        push: push,
        getSwitchRequests: getSwitchRequests,
        reset: reset
    };
}

SwitchRequestHistory.__dashjs_factory_name = 'SwitchRequestHistory';
var factory = _coreFactoryMakerJs2['default'].getClassFactory(SwitchRequestHistory);
exports['default'] = factory;
module.exports = exports['default'];
//# sourceMappingURL=SwitchRequestHistory.js.map


/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _ThroughputRule = __webpack_require__(1401);

var _ThroughputRule2 = _interopRequireDefault(_ThroughputRule);

var _InsufficientBufferRule = __webpack_require__(1399);

var _InsufficientBufferRule2 = _interopRequireDefault(_InsufficientBufferRule);

var _AbandonRequestsRule = __webpack_require__(1396);

var _AbandonRequestsRule2 = _interopRequireDefault(_AbandonRequestsRule);

var _DroppedFramesRuleJs = __webpack_require__(1398);

var _DroppedFramesRuleJs2 = _interopRequireDefault(_DroppedFramesRuleJs);

var _SwitchHistoryRuleJs = __webpack_require__(1400);

var _SwitchHistoryRuleJs2 = _interopRequireDefault(_SwitchHistoryRuleJs);

var _BolaRule = __webpack_require__(597);

var _BolaRule2 = _interopRequireDefault(_BolaRule);

var _BolaAbandonRule = __webpack_require__(1397);

var _BolaAbandonRule2 = _interopRequireDefault(_BolaAbandonRule);

var _modelsMediaPlayerModel = __webpack_require__(67);

var _modelsMediaPlayerModel2 = _interopRequireDefault(_modelsMediaPlayerModel);

var _modelsMetricsModel = __webpack_require__(135);

var _modelsMetricsModel2 = _interopRequireDefault(_modelsMetricsModel);

var _dashDashMetrics = __webpack_require__(157);

var _dashDashMetrics2 = _interopRequireDefault(_dashDashMetrics);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _SwitchRequestJs = __webpack_require__(128);

var _SwitchRequestJs2 = _interopRequireDefault(_SwitchRequestJs);

var QUALITY_SWITCH_RULES = 'qualitySwitchRules';
var ABANDON_FRAGMENT_RULES = 'abandonFragmentRules';

function ABRRulesCollection() {

    var context = this.context;

    var instance = undefined,
        qualitySwitchRules = undefined,
        abandonFragmentRules = undefined;

    function initialize() {
        qualitySwitchRules = [];
        abandonFragmentRules = [];

        var metricsModel = (0, _modelsMetricsModel2['default'])(context).getInstance();
        var dashMetrics = (0, _dashDashMetrics2['default'])(context).getInstance();
        var mediaPlayerModel = (0, _modelsMediaPlayerModel2['default'])(context).getInstance();

        if (mediaPlayerModel.getBufferOccupancyABREnabled()) {
            qualitySwitchRules.push((0, _BolaRule2['default'])(context).create({
                metricsModel: metricsModel,
                dashMetrics: dashMetrics
            }));
            abandonFragmentRules.push((0, _BolaAbandonRule2['default'])(context).create({
                metricsModel: metricsModel,
                dashMetrics: dashMetrics
            }));
        } else {
            qualitySwitchRules.push((0, _ThroughputRule2['default'])(context).create({
                metricsModel: metricsModel,
                dashMetrics: dashMetrics
            }));

            qualitySwitchRules.push((0, _InsufficientBufferRule2['default'])(context).create({ metricsModel: metricsModel }));
            qualitySwitchRules.push((0, _SwitchHistoryRuleJs2['default'])(context).create());
            qualitySwitchRules.push((0, _DroppedFramesRuleJs2['default'])(context).create());
            abandonFragmentRules.push((0, _AbandonRequestsRule2['default'])(context).create());
        }
    }

    function getRules(type) {
        switch (type) {
            case QUALITY_SWITCH_RULES:
                return qualitySwitchRules;
            case ABANDON_FRAGMENT_RULES:
                return abandonFragmentRules;
            default:
                return null;
        }
    }

    function getActiveRules(srArray) {
        return srArray.filter(function (sr) {
            return sr.value > _SwitchRequestJs2['default'].NO_CHANGE;
        });
    }

    function getMinSwitchRequest(srArray) {
        if (srArray.length === 0) {
            return;
        }
        return srArray.reduce(function (a, b) {
            return a.value < b.value ? a : b;
        });
    }

    function getMaxQuality(rulesContext) {
        var switchRequestArray = qualitySwitchRules.map(function (rule) {
            return rule.getMaxIndex(rulesContext);
        });
        var activeRules = getActiveRules(switchRequestArray);
        var maxQuality = getMinSwitchRequest(activeRules);

        return maxQuality || (0, _SwitchRequestJs2['default'])(context).create();
    }

    function shouldAbandonFragment(rulesContext) {
        var abandonRequestArray = abandonFragmentRules.map(function (rule) {
            return rule.shouldAbandon(rulesContext);
        });
        var activeRules = getActiveRules(abandonRequestArray);
        var shouldAbandon = getMinSwitchRequest(activeRules);

        return shouldAbandon || (0, _SwitchRequestJs2['default'])(context).create();
    }

    instance = {
        initialize: initialize,
        getRules: getRules,
        getMaxQuality: getMaxQuality,
        shouldAbandonFragment: shouldAbandonFragment
    };

    return instance;
}

ABRRulesCollection.__dashjs_factory_name = 'ABRRulesCollection';
var factory = _coreFactoryMaker2['default'].getSingletonFactory(ABRRulesCollection);
factory.QUALITY_SWITCH_RULES = QUALITY_SWITCH_RULES;
factory.ABANDON_FRAGMENT_RULES = ABANDON_FRAGMENT_RULES;
exports['default'] = factory;
module.exports = exports['default'];
//# sourceMappingURL=ABRRulesCollection.js.map


/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _SwitchRequest = __webpack_require__(128);

var _SwitchRequest2 = _interopRequireDefault(_SwitchRequest);

var _modelsMediaPlayerModel = __webpack_require__(67);

var _modelsMediaPlayerModel2 = _interopRequireDefault(_modelsMediaPlayerModel);

var _dashDashMetrics = __webpack_require__(157);

var _dashDashMetrics2 = _interopRequireDefault(_dashDashMetrics);

var _modelsMetricsModel = __webpack_require__(135);

var _modelsMetricsModel2 = _interopRequireDefault(_modelsMetricsModel);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _coreDebug = __webpack_require__(30);

var _coreDebug2 = _interopRequireDefault(_coreDebug);

function AbandonRequestsRule() {

    var ABANDON_MULTIPLIER = 1.8;
    var GRACE_TIME_THRESHOLD = 500;
    var MIN_LENGTH_TO_AVERAGE = 5;

    var context = this.context;
    var log = (0, _coreDebug2['default'])(context).getInstance().log;

    var fragmentDict = undefined,
        abandonDict = undefined,
        throughputArray = undefined,
        mediaPlayerModel = undefined,
        dashMetrics = undefined,
        metricsModel = undefined;

    function setup() {
        fragmentDict = {};
        abandonDict = {};
        throughputArray = [];
        mediaPlayerModel = (0, _modelsMediaPlayerModel2['default'])(context).getInstance();
        dashMetrics = (0, _dashDashMetrics2['default'])(context).getInstance();
        metricsModel = (0, _modelsMetricsModel2['default'])(context).getInstance();
    }

    function setFragmentRequestDict(type, id) {
        fragmentDict[type] = fragmentDict[type] || {};
        fragmentDict[type][id] = fragmentDict[type][id] || {};
    }

    function storeLastRequestThroughputByType(type, throughput) {
        throughputArray[type] = throughputArray[type] || [];
        throughputArray[type].push(throughput);
    }

    function shouldAbandon(rulesContext) {

        var mediaInfo = rulesContext.getMediaInfo();
        var mediaType = mediaInfo.type;
        var req = rulesContext.getCurrentRequest();
        var switchRequest = (0, _SwitchRequest2['default'])(context).create(_SwitchRequest2['default'].NO_CHANGE, { name: AbandonRequestsRule.__dashjs_factory_name });

        if (!isNaN(req.index)) {

            setFragmentRequestDict(mediaType, req.index);

            var stableBufferTime = mediaPlayerModel.getStableBufferTime();
            var bufferLevel = dashMetrics.getCurrentBufferLevel(metricsModel.getReadOnlyMetricsFor(mediaType));
            if (bufferLevel > stableBufferTime) {
                return switchRequest;
            }

            var fragmentInfo = fragmentDict[mediaType][req.index];
            if (fragmentInfo === null || req.firstByteDate === null || abandonDict.hasOwnProperty(fragmentInfo.id)) {
                return switchRequest;
            }

            //setup some init info based on first progress event
            if (fragmentInfo.firstByteTime === undefined) {
                throughputArray[mediaType] = [];
                fragmentInfo.firstByteTime = req.firstByteDate.getTime();
                fragmentInfo.segmentDuration = req.duration;
                fragmentInfo.bytesTotal = req.bytesTotal;
                fragmentInfo.id = req.index;
            }
            fragmentInfo.bytesLoaded = req.bytesLoaded;
            fragmentInfo.elapsedTime = new Date().getTime() - fragmentInfo.firstByteTime;

            if (fragmentInfo.bytesLoaded > 0 && fragmentInfo.elapsedTime > 0) {
                storeLastRequestThroughputByType(mediaType, Math.round(fragmentInfo.bytesLoaded * 8 / fragmentInfo.elapsedTime));
            }

            if (throughputArray[mediaType].length >= MIN_LENGTH_TO_AVERAGE && fragmentInfo.elapsedTime > GRACE_TIME_THRESHOLD && fragmentInfo.bytesLoaded < fragmentInfo.bytesTotal) {

                var totalSampledValue = throughputArray[mediaType].reduce(function (a, b) {
                    return a + b;
                }, 0);
                fragmentInfo.measuredBandwidthInKbps = Math.round(totalSampledValue / throughputArray[mediaType].length);
                fragmentInfo.estimatedTimeOfDownload = +(fragmentInfo.bytesTotal * 8 / fragmentInfo.measuredBandwidthInKbps / 1000).toFixed(2);
                //log("id:",fragmentInfo.id, "kbps:", fragmentInfo.measuredBandwidthInKbps, "etd:",fragmentInfo.estimatedTimeOfDownload, fragmentInfo.bytesLoaded);

                if (fragmentInfo.estimatedTimeOfDownload < fragmentInfo.segmentDuration * ABANDON_MULTIPLIER || rulesContext.getTrackInfo().quality === 0) {
                    return switchRequest;
                } else if (!abandonDict.hasOwnProperty(fragmentInfo.id)) {

                    var abrController = rulesContext.getStreamProcessor().getABRController();
                    var bytesRemaining = fragmentInfo.bytesTotal - fragmentInfo.bytesLoaded;
                    var bitrateList = abrController.getBitrateList(mediaInfo);
                    var newQuality = abrController.getQualityForBitrate(mediaInfo, fragmentInfo.measuredBandwidthInKbps * mediaPlayerModel.getBandwidthSafetyFactor());
                    var estimateOtherBytesTotal = fragmentInfo.bytesTotal * bitrateList[newQuality].bitrate / bitrateList[abrController.getQualityFor(mediaType, mediaInfo.streamInfo)].bitrate;

                    if (bytesRemaining > estimateOtherBytesTotal) {
                        switchRequest.value = newQuality;
                        switchRequest.reason.throughput = fragmentInfo.measuredBandwidthInKbps;
                        switchRequest.reason.fragmentID = fragmentInfo.id;
                        abandonDict[fragmentInfo.id] = fragmentInfo;
                        log('AbandonRequestsRule ( ', mediaType, 'frag id', fragmentInfo.id, ') is asking to abandon and switch to quality to ', newQuality, ' measured bandwidth was', fragmentInfo.measuredBandwidthInKbps);
                        delete fragmentDict[mediaType][fragmentInfo.id];
                    }
                }
            } else if (fragmentInfo.bytesLoaded === fragmentInfo.bytesTotal) {
                delete fragmentDict[mediaType][fragmentInfo.id];
            }
        }

        return switchRequest;
    }

    function reset() {
        setup();
    }

    var instance = {
        shouldAbandon: shouldAbandon,
        reset: reset
    };

    setup();

    return instance;
}

AbandonRequestsRule.__dashjs_factory_name = 'AbandonRequestsRule';
exports['default'] = _coreFactoryMaker2['default'].getClassFactory(AbandonRequestsRule);
module.exports = exports['default'];
//# sourceMappingURL=AbandonRequestsRule.js.map


/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2016, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _SwitchRequest = __webpack_require__(128);

var _SwitchRequest2 = _interopRequireDefault(_SwitchRequest);

var _modelsMediaPlayerModel = __webpack_require__(67);

var _modelsMediaPlayerModel2 = _interopRequireDefault(_modelsMediaPlayerModel);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _coreDebug = __webpack_require__(30);

var _coreDebug2 = _interopRequireDefault(_coreDebug);

var _BolaRule = __webpack_require__(597);

var _BolaRule2 = _interopRequireDefault(_BolaRule);

function BolaAbandonRule(config) {

    // do not abandon during the grace period
    var GRACE_PERIOD_MS = 500;
    var POOR_LATENCY_MS = 200;

    var context = this.context;
    var log = (0, _coreDebug2['default'])(context).getInstance().log;
    var dashMetrics = config.dashMetrics;
    var metricsModel = config.metricsModel;

    var instance = undefined,
        abandonDict = undefined,
        mediaPlayerModel = undefined;

    function setup() {
        abandonDict = {};
        mediaPlayerModel = (0, _modelsMediaPlayerModel2['default'])(context).getInstance();
    }

    function rememberAbandon(mediaType, index, quality) {
        // if this is called, then canStillAbandon(mediaType, index, quality) should have returned true
        abandonDict[mediaType] = { index: index, quality: quality };
    }

    function canAbandon(mediaType, index, quality) {
        var a = abandonDict[mediaType];
        if (!a) return true;
        return index !== a.index || quality < a.quality;
    }

    function shouldAbandon(rulesContext) {
        var mediaInfo = rulesContext.getMediaInfo();
        var mediaType = mediaInfo.type;
        var metrics = metricsModel.getReadOnlyMetricsFor(mediaType);
        var request = rulesContext.getCurrentRequest();
        var switchRequest = (0, _SwitchRequest2['default'])(context).create(_SwitchRequest2['default'].NO_CHANGE, { name: BolaAbandonRule.__dashjs_factory_name });

        if (metrics.BolaState.length === 0) {
            // should not arrive here - we shouldn't be downloading a fragment before BOLA is initialized
            log('WARNING: executing BolaAbandonRule before initializing BolaRule');
            abandonDict[mediaType] = null;
            return switchRequest;
        }

        var bolaState = metrics.BolaState[0]._s;
        // TODO: does changing bolaState conform to coding style, or should we clone?

        var index = request.index;
        var quality = request.quality;

        if (isNaN(index) || quality === 0 || !canAbandon(mediaType, index, quality) || !request.firstByteDate) {
            return switchRequest;
        }

        var nowMs = Date.now();
        var elapsedTimeMs = nowMs - request.firstByteDate.getTime();

        var bytesLoaded = request.bytesLoaded;
        var bytesTotal = request.bytesTotal;
        var bytesRemaining = bytesTotal - bytesLoaded;
        var durationS = request.duration;

        var bufferLevel = dashMetrics.getCurrentBufferLevel(metrics) ? dashMetrics.getCurrentBufferLevel(metrics) : 0.0;
        var effectiveBufferLevel = bufferLevel + bolaState.placeholderBuffer;

        var estimateThroughput = 8 * bytesLoaded / (0.001 * elapsedTimeMs); // throughput in bits per second
        var estimateThroughputBSF = bolaState.bandwidthSafetyFactor * estimateThroughput;
        var latencyS = 0.001 * (request.firstByteDate.getTime() - request.requestStartDate.getTime());
        if (latencyS < 0.001 * POOR_LATENCY_MS) {
            latencyS = 0.001 * POOR_LATENCY_MS;
        }
        var estimateTotalTimeS = latencyS + 8 * bytesTotal / estimateThroughputBSF;

        var diagnosticMessage = '';
        if (_BolaRule2['default'].BOLA_DEBUG) diagnosticMessage = 'index=' + index + ' quality=' + quality + ' bytesLoaded/bytesTotal=' + bytesLoaded + '/' + bytesTotal + ' bufferLevel=' + bufferLevel + ' timeSince1stByte=' + (elapsedTimeMs / 1000).toFixed(3) + ' estThroughput=' + (estimateThroughputBSF / 1000000).toFixed(3) + ' latency=' + latencyS.toFixed(3);

        var estimateOtherBytesTotal = bytesTotal * bolaState.bitrates[0] / bolaState.bitrates[quality];
        var estimateBytesRemainingAfterLatency = bytesRemaining - latencyS * estimateThroughputBSF / 8;
        if (estimateBytesRemainingAfterLatency < 1) {
            estimateBytesRemainingAfterLatency = 1;
        }

        if (elapsedTimeMs < GRACE_PERIOD_MS || bytesRemaining <= estimateOtherBytesTotal || bufferLevel > bolaState.bufferTarget || estimateBytesRemainingAfterLatency <= estimateOtherBytesTotal || estimateTotalTimeS <= durationS) {
            // Do not abandon during first GRACE_PERIOD_MS.
            // Do not abandon if we need to download less bytes than the size of the lowest quality fragment.
            // Do not abandon if buffer level is above bufferTarget because the schedule controller will not download anything anyway.
            // Do not abandon if after latencyS bytesRemaining is estimated to drop below size of lowest quality fragment.
            // Do not abandon if fragment takes less than 1 fragment duration to download.
            return switchRequest;
        }

        // If we abandon, there will be latencyS time before we get first byte at lower quality.
        // By that time, the no-abandon option would have downloaded some more, and the buffer level would have depleted some more.
        // Introducing this latencyS cushion also helps avoid extra abandonment, especially with close bitrates.

        var effectiveBufferAfterLatency = effectiveBufferLevel - latencyS;
        if (effectiveBufferAfterLatency < 0) {
            effectiveBufferAfterLatency = 0;
        }

        // if we end up abandoning, we should not consider starting a download that would require more bytes than the remaining bytes in currently downloading fragment
        var maxDroppedQuality = 0;
        while (maxDroppedQuality + 1 < quality && bytesTotal * bolaState.bitrates[maxDroppedQuality + 1] / bolaState.bitrates[quality] < estimateBytesRemainingAfterLatency) {

            ++maxDroppedQuality;
        }

        var newQuality = quality;

        if (bolaState.state === _BolaRule2['default'].BOLA_STATE_STARTUP) {
            // We are not yet using the BOLA buffer rules - use different abandonment logic.

            // if we are here then we failed the test that estimateTotalTimeS <= durationS, so we abandon

            // search for quality that matches the throughput
            newQuality = 0;
            for (var i = 0; i <= maxDroppedQuality; ++i) {
                estimateOtherBytesTotal = bytesTotal * bolaState.bitrates[i] / bolaState.bitrates[quality];
                if (8 * estimateOtherBytesTotal / durationS > estimateThroughputBSF) {
                    // chunks at quality i or higher need a greater throughput
                    break;
                }
                newQuality = i;
            }
        } else {
            // bolaState.state === BolaRule.BOLA_STATE_STEADY
            // check if we should abandon using BOLA utility criteria

            var score = (bolaState.Vp * (bolaState.utilities[quality] + bolaState.gp) - effectiveBufferAfterLatency) / estimateBytesRemainingAfterLatency;

            for (var i = 0; i <= maxDroppedQuality; ++i) {
                estimateOtherBytesTotal = bytesTotal * bolaState.bitrates[i] / bolaState.bitrates[quality];
                var s = (bolaState.Vp * (bolaState.utilities[i] + bolaState.gp) - effectiveBufferAfterLatency) / estimateOtherBytesTotal;
                if (s > score) {
                    newQuality = i;
                    score = s;
                }
            }
        }

        // Perform check for rebuffer avoidance - now use real buffer level as opposed to effective buffer level.
        var safeByteSize = bolaState.rebufferSafetyFactor * estimateThroughput * (bufferLevel - latencyS) / 8;

        if (newQuality === quality && estimateBytesRemainingAfterLatency > safeByteSize) {
            newQuality = maxDroppedQuality;
        }

        if (newQuality === quality) {
            // no change
            return switchRequest;
        }

        // newQuality < quality, we are abandoning
        while (newQuality > 0) {
            estimateOtherBytesTotal = bytesTotal * bolaState.bitrates[newQuality] / bolaState.bitrates[quality];
            if (estimateOtherBytesTotal <= safeByteSize) {
                break;
            }
            --newQuality;
        }

        // deflate placeholder buffer - we want to be conservative after abandoning
        var wantBufferLevel = NaN;
        if (newQuality > 0) {
            // deflate to point where score for newQuality is just getting better than for (newQuality - 1)
            var u = bolaState.utilities[newQuality];
            var u1 = bolaState.utilities[newQuality - 1];
            var s = bolaState.bitrates[newQuality];
            var s1 = bolaState.bitrates[newQuality - 1];
            wantBufferLevel = bolaState.Vp * ((s * u1 - s1 * u) / (s - s1) + bolaState.gp);
        } else {
            // deflate to point where score for (newQuality + 1) is just getting better than for newQuality
            var u = bolaState.utilities[0];
            var u1 = bolaState.utilities[1];
            var s = bolaState.bitrates[0];
            var s1 = bolaState.bitrates[1];
            wantBufferLevel = bolaState.Vp * ((s * u1 - s1 * u) / (s - s1) + bolaState.gp);
            // then reduce one fragment duration to be conservative
            wantBufferLevel -= durationS;
        }
        if (effectiveBufferLevel > wantBufferLevel) {
            bolaState.placeholderBuffer = wantBufferLevel - bufferLevel;
            if (bolaState.placeholderBuffer < 0) bolaState.placeholderBuffer = 0;
        }

        bolaState.lastQuality = newQuality;
        metricsModel.updateBolaState(mediaType, bolaState);

        if (_BolaRule2['default'].BOLA_DEBUG) log('BolaDebug ' + mediaType + ' BolaAbandonRule abandon to ' + newQuality + ' - ' + diagnosticMessage);

        rememberAbandon(mediaType, index, quality);
        switchRequest.value = newQuality;
        switchRequest.reason.state = bolaState.state;
        switchRequest.reason.throughput = estimateThroughput;
        switchRequest.reason.bufferLevel = bufferLevel;
        // following entries used for tuning algorithm
        switchRequest.reason.bytesLoaded = request.bytesLoaded;
        switchRequest.reason.bytesTotal = request.bytesTotal;
        switchRequest.reason.elapsedTimeMs = elapsedTimeMs;

        return switchRequest;
    }

    function reset() {
        abandonDict = {};
    }

    instance = {
        shouldAbandon: shouldAbandon,
        reset: reset
    };

    setup();

    return instance;
}

BolaAbandonRule.__dashjs_factory_name = 'BolaAbandonRule';
exports['default'] = _coreFactoryMaker2['default'].getClassFactory(BolaAbandonRule);
module.exports = exports['default'];
//# sourceMappingURL=BolaAbandonRule.js.map


/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreFactoryMakerJs = __webpack_require__(9);

var _coreFactoryMakerJs2 = _interopRequireDefault(_coreFactoryMakerJs);

var _SwitchRequestJs = __webpack_require__(128);

var _SwitchRequestJs2 = _interopRequireDefault(_SwitchRequestJs);

var _coreDebug = __webpack_require__(30);

var _coreDebug2 = _interopRequireDefault(_coreDebug);

function DroppedFramesRule() {
    var context = this.context;
    var log = (0, _coreDebug2['default'])(context).getInstance().log;

    var DROPPED_PERCENTAGE_FORBID = 0.15;
    var GOOD_SAMPLE_SIZE = 375; //Don't apply the rule until this many frames have been rendered(and counted under those indices).

    function getMaxIndex(rulesContext) {
        var droppedFramesHistory = rulesContext.getDroppedFramesHistory();
        if (droppedFramesHistory) {
            var dfh = droppedFramesHistory.getFrameHistory();
            var droppedFrames = 0;
            var totalFrames = 0;
            var maxIndex = _SwitchRequestJs2['default'].NO_CHANGE;
            for (var i = 1; i < dfh.length; i++) {
                //No point in measuring dropped frames for the zeroeth index.
                if (dfh[i]) {
                    droppedFrames = dfh[i].droppedVideoFrames;
                    totalFrames = dfh[i].totalVideoFrames;

                    if (totalFrames > GOOD_SAMPLE_SIZE && droppedFrames / totalFrames > DROPPED_PERCENTAGE_FORBID) {
                        maxIndex = i - 1;
                        log('DroppedFramesRule, index: ' + maxIndex + ' Dropped Frames: ' + droppedFrames + ' Total Frames: ' + totalFrames);
                        break;
                    }
                }
            }
            return (0, _SwitchRequestJs2['default'])(context).create(maxIndex, { droppedFrames: droppedFrames });
        }

        return (0, _SwitchRequestJs2['default'])(context).create();
    }

    return {
        getMaxIndex: getMaxIndex
    };
}

DroppedFramesRule.__dashjs_factory_name = 'DroppedFramesRule';
var factory = _coreFactoryMakerJs2['default'].getClassFactory(DroppedFramesRule);

exports['default'] = factory;
module.exports = exports['default'];
//# sourceMappingURL=DroppedFramesRule.js.map


/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _controllersBufferController = __webpack_require__(160);

var _controllersBufferController2 = _interopRequireDefault(_controllersBufferController);

var _coreEventBus = __webpack_require__(27);

var _coreEventBus2 = _interopRequireDefault(_coreEventBus);

var _coreEventsEvents = __webpack_require__(22);

var _coreEventsEvents2 = _interopRequireDefault(_coreEventsEvents);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _coreDebug = __webpack_require__(30);

var _coreDebug2 = _interopRequireDefault(_coreDebug);

var _SwitchRequestJs = __webpack_require__(128);

var _SwitchRequestJs2 = _interopRequireDefault(_SwitchRequestJs);

function InsufficientBufferRule(config) {

    var context = this.context;
    var log = (0, _coreDebug2['default'])(context).getInstance().log;
    var eventBus = (0, _coreEventBus2['default'])(context).getInstance();

    var metricsModel = config.metricsModel;

    var instance = undefined,
        bufferStateDict = undefined,
        lastSwitchTime = undefined,
        waitToSwitchTime = undefined;

    function setup() {
        bufferStateDict = {};
        lastSwitchTime = 0;
        waitToSwitchTime = 1000;
        eventBus.on(_coreEventsEvents2['default'].PLAYBACK_SEEKING, onPlaybackSeeking, instance);
    }

    function getMaxIndex(rulesContext) {
        var now = new Date().getTime();
        var mediaType = rulesContext.getMediaInfo().type;
        var metrics = metricsModel.getReadOnlyMetricsFor(mediaType);
        var lastBufferStateVO = metrics.BufferState.length > 0 ? metrics.BufferState[metrics.BufferState.length - 1] : null;
        var switchRequest = (0, _SwitchRequestJs2['default'])(context).create();

        if (now - lastSwitchTime < waitToSwitchTime || lastBufferStateVO === null) {
            return switchRequest;
        }

        setBufferInfo(mediaType, lastBufferStateVO.state);
        // After the sessions first buffer loaded event , if we ever have a buffer empty event we want to switch all the way down.
        if (lastBufferStateVO.state === _controllersBufferController2['default'].BUFFER_EMPTY && bufferStateDict[mediaType].firstBufferLoadedEvent !== undefined) {
            log('Switch to index 0; buffer is empty.');
            switchRequest.value = 0;
            switchRequest.reason = 'InsufficientBufferRule: Buffer is empty';
        }

        lastSwitchTime = now;
        return switchRequest;
    }

    function setBufferInfo(type, state) {
        bufferStateDict[type] = bufferStateDict[type] || {};
        bufferStateDict[type].state = state;
        if (state === _controllersBufferController2['default'].BUFFER_LOADED && !bufferStateDict[type].firstBufferLoadedEvent) {
            bufferStateDict[type].firstBufferLoadedEvent = true;
        }
    }

    function onPlaybackSeeking() {
        bufferStateDict = {};
    }

    function reset() {
        eventBus.off(_coreEventsEvents2['default'].PLAYBACK_SEEKING, onPlaybackSeeking, instance);
        bufferStateDict = {};
        lastSwitchTime = 0;
    }

    instance = {
        getMaxIndex: getMaxIndex,
        reset: reset
    };

    setup();

    return instance;
}

InsufficientBufferRule.__dashjs_factory_name = 'InsufficientBufferRule';
exports['default'] = _coreFactoryMaker2['default'].getClassFactory(InsufficientBufferRule);
module.exports = exports['default'];
//# sourceMappingURL=InsufficientBufferRule.js.map


/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreFactoryMakerJs = __webpack_require__(9);

var _coreFactoryMakerJs2 = _interopRequireDefault(_coreFactoryMakerJs);

var _coreDebug = __webpack_require__(30);

var _coreDebug2 = _interopRequireDefault(_coreDebug);

var _SwitchRequestJs = __webpack_require__(128);

var _SwitchRequestJs2 = _interopRequireDefault(_SwitchRequestJs);

function SwitchHistoryRule() {
    var context = this.context;
    var log = (0, _coreDebug2['default'])(context).getInstance().log;

    //MAX_SWITCH is the number of drops made. It doesn't consider the size of the drop.
    var MAX_SWITCH = 0.075;

    //Before this number of switch requests(no switch or actual), don't apply the rule.
    //must be < SwitchRequestHistory SWITCH_REQUEST_HISTORY_DEPTH to enable rule
    var SAMPLE_SIZE = 6;

    function getMaxIndex(rulesContext) {
        var switchRequestHistory = rulesContext.getSwitchHistory();
        var switchRequests = switchRequestHistory.getSwitchRequests();
        var drops = 0;
        var noDrops = 0;
        var dropSize = 0;
        var switchRequest = (0, _SwitchRequestJs2['default'])(context).create();

        for (var i = 0; i < switchRequests.length; i++) {
            if (switchRequests[i] !== undefined) {
                drops += switchRequests[i].drops;
                noDrops += switchRequests[i].noDrops;
                dropSize += switchRequests[i].dropSize;

                if (drops + noDrops >= SAMPLE_SIZE && drops / noDrops > MAX_SWITCH) {
                    switchRequest.value = i > 0 ? i - 1 : 0;
                    switchRequest.reason = { index: switchRequest.value, drops: drops, noDrops: noDrops, dropSize: dropSize };
                    log('Switch history rule index: ' + switchRequest.value + ' samples: ' + (drops + noDrops) + ' drops: ' + drops);
                    break;
                }
            }
        }

        return switchRequest;
    }

    return {
        getMaxIndex: getMaxIndex
    };
}

SwitchHistoryRule.__dashjs_factory_name = 'SwitchRequest';
var factory = _coreFactoryMakerJs2['default'].getClassFactory(SwitchHistoryRule);

exports['default'] = factory;
module.exports = exports['default'];
//# sourceMappingURL=SwitchHistoryRule.js.map


/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _controllersBufferController = __webpack_require__(160);

var _controllersBufferController2 = _interopRequireDefault(_controllersBufferController);

var _controllersAbrController = __webpack_require__(159);

var _controllersAbrController2 = _interopRequireDefault(_controllersAbrController);

var _modelsMediaPlayerModel = __webpack_require__(67);

var _modelsMediaPlayerModel2 = _interopRequireDefault(_modelsMediaPlayerModel);

var _voMetricsHTTPRequest = __webpack_require__(84);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _coreDebug = __webpack_require__(30);

var _coreDebug2 = _interopRequireDefault(_coreDebug);

var _SwitchRequestJs = __webpack_require__(128);

var _SwitchRequestJs2 = _interopRequireDefault(_SwitchRequestJs);

function ThroughputRule(config) {

    var MAX_MEASUREMENTS_TO_KEEP = 20;
    var AVERAGE_THROUGHPUT_SAMPLE_AMOUNT_LIVE = 3;
    var AVERAGE_THROUGHPUT_SAMPLE_AMOUNT_VOD = 4;
    var AVERAGE_LATENCY_SAMPLES = AVERAGE_THROUGHPUT_SAMPLE_AMOUNT_VOD;
    var CACHE_LOAD_THRESHOLD_VIDEO = 50;
    var CACHE_LOAD_THRESHOLD_AUDIO = 5;
    var CACHE_LOAD_THRESHOLD_LATENCY = 50;
    var THROUGHPUT_DECREASE_SCALE = 1.3;
    var THROUGHPUT_INCREASE_SCALE = 1.3;

    var context = this.context;
    var log = (0, _coreDebug2['default'])(context).getInstance().log;
    var dashMetrics = config.dashMetrics;
    var metricsModel = config.metricsModel;

    var throughputArray = undefined,
        latencyArray = undefined,
        mediaPlayerModel = undefined;

    function setup() {
        throughputArray = [];
        latencyArray = [];
        mediaPlayerModel = (0, _modelsMediaPlayerModel2['default'])(context).getInstance();
    }

    function storeLastRequestThroughputByType(type, throughput) {
        throughputArray[type] = throughputArray[type] || [];
        throughputArray[type].push(throughput);
    }

    function storeLatency(mediaType, latency) {
        if (!latencyArray[mediaType]) {
            latencyArray[mediaType] = [];
        }
        latencyArray[mediaType].push(latency);

        if (latencyArray[mediaType].length > AVERAGE_LATENCY_SAMPLES) {
            return latencyArray[mediaType].shift();
        }

        return undefined;
    }

    function getAverageLatency(mediaType) {
        var average = undefined;
        if (latencyArray[mediaType] && latencyArray[mediaType].length > 0) {
            average = latencyArray[mediaType].reduce(function (a, b) {
                return a + b;
            }) / latencyArray[mediaType].length;
        }

        return average;
    }

    function getSample(type, isDynamic) {
        var size = Math.min(throughputArray[type].length, isDynamic ? AVERAGE_THROUGHPUT_SAMPLE_AMOUNT_LIVE : AVERAGE_THROUGHPUT_SAMPLE_AMOUNT_VOD);
        var sampleArray = throughputArray[type].slice(size * -1, throughputArray[type].length);
        if (sampleArray.length > 1) {
            sampleArray.reduce(function (a, b) {
                if (a * THROUGHPUT_INCREASE_SCALE <= b || a >= b * THROUGHPUT_DECREASE_SCALE) {
                    size++;
                }
                return b;
            });
        }
        size = Math.min(throughputArray[type].length, size);
        return throughputArray[type].slice(size * -1, throughputArray[type].length);
    }

    function getAverageThroughput(type, isDynamic) {
        var sample = getSample(type, isDynamic);
        var averageThroughput = 0;
        if (sample.length > 0) {
            var totalSampledValue = sample.reduce(function (a, b) {
                return a + b;
            }, 0);
            averageThroughput = totalSampledValue / sample.length;
        }
        if (throughputArray[type].length >= MAX_MEASUREMENTS_TO_KEEP) {
            throughputArray[type].shift();
        }
        return averageThroughput / 1000 * mediaPlayerModel.getBandwidthSafetyFactor();
    }

    function isCachedResponse(latency, downloadTime, mediaType) {
        var ret = false;

        if (latency < CACHE_LOAD_THRESHOLD_LATENCY) {
            ret = true;
        }

        if (!ret) {
            switch (mediaType) {
                case 'video':
                    ret = downloadTime < CACHE_LOAD_THRESHOLD_VIDEO;
                    break;
                case 'audio':
                    ret = downloadTime < CACHE_LOAD_THRESHOLD_AUDIO;
                    break;
                default:
                    break;
            }
        }

        return ret;
    }

    function getMaxIndex(rulesContext) {
        var mediaInfo = rulesContext.getMediaInfo();
        var mediaType = mediaInfo.type;
        var metrics = metricsModel.getReadOnlyMetricsFor(mediaType);
        var streamProcessor = rulesContext.getStreamProcessor();
        var abrController = streamProcessor.getABRController();
        var isDynamic = streamProcessor.isDynamic();
        var lastRequest = dashMetrics.getCurrentHttpRequest(metrics);
        var bufferStateVO = metrics.BufferState.length > 0 ? metrics.BufferState[metrics.BufferState.length - 1] : null;
        var hasRichBuffer = rulesContext.hasRichBuffer();
        var switchRequest = (0, _SwitchRequestJs2['default'])(context).create();

        if (!metrics || !lastRequest || lastRequest.type !== _voMetricsHTTPRequest.HTTPRequest.MEDIA_SEGMENT_TYPE || !bufferStateVO || hasRichBuffer) {
            return switchRequest;
        }

        var downloadTimeInMilliseconds = undefined;
        var latencyTimeInMilliseconds = undefined;

        if (lastRequest.trace && lastRequest.trace.length) {

            latencyTimeInMilliseconds = lastRequest.tresponse.getTime() - lastRequest.trequest.getTime() || 1;
            downloadTimeInMilliseconds = lastRequest._tfinish.getTime() - lastRequest.tresponse.getTime() || 1; //Make sure never 0 we divide by this value. Avoid infinity!

            var bytes = lastRequest.trace.reduce(function (a, b) {
                return a + b.b[0];
            }, 0);

            var lastRequestThroughput = Math.round(bytes * 8 / (downloadTimeInMilliseconds / 1000));

            var throughput = undefined;
            var latency = undefined;
            //Prevent cached fragment loads from skewing the average throughput value - allow first even if cached to set allowance for ABR rules..
            if (isCachedResponse(latencyTimeInMilliseconds, downloadTimeInMilliseconds, mediaType)) {
                if (!throughputArray[mediaType] || !latencyArray[mediaType]) {
                    throughput = lastRequestThroughput / 1000;
                    latency = latencyTimeInMilliseconds;
                } else {
                    throughput = getAverageThroughput(mediaType, isDynamic);
                    latency = getAverageLatency(mediaType);
                }
            } else {
                storeLastRequestThroughputByType(mediaType, lastRequestThroughput);
                throughput = getAverageThroughput(mediaType, isDynamic);
                storeLatency(mediaType, latencyTimeInMilliseconds);
                latency = getAverageLatency(mediaType, isDynamic);
            }

            abrController.setAverageThroughput(mediaType, throughput);

            if (abrController.getAbandonmentStateFor(mediaType) !== _controllersAbrController2['default'].ABANDON_LOAD) {

                if (bufferStateVO.state === _controllersBufferController2['default'].BUFFER_LOADED || isDynamic) {
                    switchRequest.value = abrController.getQualityForBitrate(mediaInfo, throughput, latency);
                    streamProcessor.getScheduleController().setTimeToLoadDelay(0);
                    log('ThroughputRule requesting switch to index: ', switchRequest.value, 'type: ', mediaType, 'Average throughput', Math.round(throughput), 'kbps');
                    switchRequest.reason = { throughput: throughput, latency: latency };
                }
            }
        }
        return switchRequest;
    }

    function reset() {
        setup();
    }

    var instance = {
        getMaxIndex: getMaxIndex,
        reset: reset
    };

    setup();
    return instance;
}

ThroughputRule.__dashjs_factory_name = 'ThroughputRule';
exports['default'] = _coreFactoryMaker2['default'].getClassFactory(ThroughputRule);
module.exports = exports['default'];
//# sourceMappingURL=ThroughputRule.js.map


/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _modelsMediaPlayerModel = __webpack_require__(67);

var _modelsMediaPlayerModel2 = _interopRequireDefault(_modelsMediaPlayerModel);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

function BufferLevelRule(config) {

    var context = this.context;
    var dashMetrics = config.dashMetrics;
    var metricsModel = config.metricsModel;
    var textController = config.textController;

    var mediaPlayerModel = undefined;

    function setup() {
        mediaPlayerModel = (0, _modelsMediaPlayerModel2['default'])(context).getInstance();
    }

    function execute(streamProcessor, type, videoTrackPresent) {
        var bufferLevel = dashMetrics.getCurrentBufferLevel(metricsModel.getReadOnlyMetricsFor(type));
        return bufferLevel < getBufferTarget(streamProcessor, type, videoTrackPresent);
    }

    function getBufferTarget(streamProcessor, type, videoTrackPresent) {
        var bufferTarget = NaN;
        var representationInfo = streamProcessor.getCurrentRepresentationInfo();
        if (type === 'fragmentedText') {
            bufferTarget = textController.getAllTracksAreDisabled() ? 0 : representationInfo.fragmentDuration;
        } else if (type === 'audio' && videoTrackPresent) {
            var videoBufferLevel = dashMetrics.getCurrentBufferLevel(metricsModel.getReadOnlyMetricsFor('video'));
            bufferTarget = Math.floor(Math.max(videoBufferLevel, representationInfo.fragmentDuration));
        } else {
            var streamInfo = representationInfo.mediaInfo.streamInfo;
            var abrController = streamProcessor.getABRController();
            if (abrController.isPlayingAtTopQuality(streamInfo)) {
                var isLongFormContent = streamInfo.manifestInfo.duration >= mediaPlayerModel.getLongFormContentDurationThreshold();
                bufferTarget = isLongFormContent ? mediaPlayerModel.getBufferTimeAtTopQualityLongForm() : mediaPlayerModel.getBufferTimeAtTopQuality();
            } else {
                bufferTarget = mediaPlayerModel.getStableBufferTime();
            }
        }

        return bufferTarget;
    }

    var instance = {
        execute: execute,
        getBufferTarget: getBufferTarget
    };

    setup();
    return instance;
}

BufferLevelRule.__dashjs_factory_name = 'BufferLevelRule';
exports['default'] = _coreFactoryMaker2['default'].getClassFactory(BufferLevelRule);
module.exports = exports['default'];
//# sourceMappingURL=BufferLevelRule.js.map


/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreDebug = __webpack_require__(30);

var _coreDebug2 = _interopRequireDefault(_coreDebug);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

function NextFragmentRequestRule(config) {

    var context = this.context;
    var log = (0, _coreDebug2['default'])(context).getInstance().log;
    var adapter = config.adapter;
    var sourceBufferController = config.sourceBufferController;
    var textController = config.textController;

    function execute(streamProcessor, requestToReplace) {

        var representationInfo = streamProcessor.getCurrentRepresentationInfo();
        var mediaInfo = representationInfo.mediaInfo;
        var mediaType = mediaInfo.type;
        var scheduleController = streamProcessor.getScheduleController();
        var seekTarget = scheduleController.getSeekTarget();
        var hasSeekTarget = !isNaN(seekTarget);
        var buffer = streamProcessor.getBuffer();

        var time = hasSeekTarget ? seekTarget : adapter.getIndexHandlerTime(streamProcessor);

        if (isNaN(time) || mediaType === 'fragmentedText' && textController.getAllTracksAreDisabled()) {
            return null;
        }

        if (hasSeekTarget) {
            scheduleController.setSeekTarget(NaN);
        }

        /**
         * This is critical for IE/Safari/EDGE
         * */
        if (buffer) {
            var range = sourceBufferController.getBufferRange(streamProcessor.getBuffer(), time);
            if (range !== null) {
                log('Prior to making a request for time, NextFragmentRequestRule is aligning index handler\'s currentTime with bufferedRange.end.', time, ' was changed to ', range.end);
                time = range.end;
            }
        }

        var request = undefined;
        if (requestToReplace) {
            time = requestToReplace.startTime + requestToReplace.duration / 2;
            request = adapter.getFragmentRequestForTime(streamProcessor, representationInfo, time, { timeThreshold: 0, ignoreIsFinished: true });
        } else {
            request = adapter.getFragmentRequestForTime(streamProcessor, representationInfo, time, { keepIdx: !hasSeekTarget });
            if (request && streamProcessor.getFragmentModel().isFragmentLoaded(request)) {
                request = adapter.getNextFragmentRequest(streamProcessor, representationInfo);
            }
            if (request) {
                adapter.setIndexHandlerTime(streamProcessor, request.startTime + request.duration);
                request.delayLoadingTime = new Date().getTime() + scheduleController.getTimeToLoadDelay();
                scheduleController.setTimeToLoadDelay(0);
            }
        }

        return request;
    }

    var instance = {
        execute: execute
    };

    return instance;
}

NextFragmentRequestRule.__dashjs_factory_name = 'NextFragmentRequestRule';
exports['default'] = _coreFactoryMaker2['default'].getClassFactory(NextFragmentRequestRule);
module.exports = exports['default'];
//# sourceMappingURL=NextFragmentRequestRule.js.map


/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

function EmbeddedTextHtmlRender() {

    var captionId = 0;
    var instance = undefined;

    /* HTML Rendering functions */
    function checkIndent(chars) {
        var line = '';

        for (var c = 0; c < chars.length; ++c) {
            var uc = chars[c];
            line += uc.uchar;
        }

        var l = line.length;
        var ll = line.replace(/^\s+/, '').length;
        return l - ll;
    }

    function getRegionProperties(region) {
        return 'left: ' + region.x * 3.125 + '%; top: ' + region.y1 * 6.66 + '%; width: ' + (100 - region.x * 3.125) + '%; height: ' + Math.max(region.y2 - 1 - region.y1, 1) * 6.66 + '%; align-items: flex-start; overflow: visible; -webkit-writing-mode: horizontal-tb;';
    }

    function createRGB(color) {
        if (color === 'red') {
            return 'rgb(255, 0, 0)';
        } else if (color === 'green') {
            return 'rgb(0, 255, 0)';
        } else if (color === 'blue') {
            return 'rgb(0, 0, 255)';
        } else if (color === 'cyan') {
            return 'rgb(0, 255, 255)';
        } else if (color === 'magenta') {
            return 'rgb(255, 0, 255)';
        } else if (color === 'yellow') {
            return 'rgb(255, 255, 0)';
        } else if (color === 'white') {
            return 'rgb(255, 255, 255)';
        } else if (color === 'black') {
            return 'rgb(0, 0, 0)';
        }
        return color;
    }

    function getStyle(videoElement, style) {
        var fontSize = videoElement.videoHeight / 15.0;
        if (style) {
            return 'font-size: ' + fontSize + 'px; font-family: Menlo, Consolas, \'Cutive Mono\', monospace; color: ' + (style.foreground ? createRGB(style.foreground) : 'rgb(255, 255, 255)') + '; font-style: ' + (style.italics ? 'italic' : 'normal') + '; text-decoration: ' + (style.underline ? 'underline' : 'none') + '; white-space: pre; background-color: ' + (style.background ? createRGB(style.background) : 'transparent') + ';';
        } else {
            return 'font-size: ' + fontSize + 'px; font-family: Menlo, Consolas, \'Cutive Mono\', monospace; justify-content: flex-start; text-align: left; color: rgb(255, 255, 255); font-style: normal; white-space: pre; line-height: normal; font-weight: normal; text-decoration: none; width: 100%; display: flex;';
        }
    }

    function ltrim(s) {
        var trimmed = s.replace(/^\s+/g, '');
        return trimmed;
    }
    function rtrim(s) {
        var trimmed = s.replace(/\s+$/g, '');
        return trimmed;
    }

    function createHTMLCaptionsFromScreen(videoElement, startTime, endTime, captionScreen) {

        var currRegion = null;
        var existingRegion = null;
        var lastRowHasText = false;
        var lastRowIndentL = -1;
        var currP = { start: startTime, end: endTime, spans: [] };
        var currentStyle = 'style_cea608_white_black';
        var seenRegions = {};
        var styleStates = {};
        var regions = [];
        var r = undefined,
            s = undefined;

        for (r = 0; r < 15; ++r) {
            var row = captionScreen.rows[r];
            var line = '';
            var prevPenState = null;

            if (false === row.isEmpty()) {
                /* Row is not empty */

                /* Get indentation of this row */
                var rowIndent = checkIndent(row.chars);

                /* Create a new region is there is none */
                if (currRegion === null) {
                    currRegion = { x: rowIndent, y1: r, y2: r + 1, p: [] };
                }

                /* Check if indentation has changed and we had text of last row */
                if (rowIndent !== lastRowIndentL && lastRowHasText) {
                    currRegion.p.push(currP);
                    currP = { start: startTime, end: endTime, spans: [] };
                    currRegion.y2 = r;
                    currRegion.name = 'region_' + currRegion.x + '_' + currRegion.y1 + '_' + currRegion.y2;
                    if (false === seenRegions.hasOwnProperty(currRegion.name)) {
                        regions.push(currRegion);
                        seenRegions[currRegion.name] = currRegion;
                    } else {
                        existingRegion = seenRegions[currRegion.name];
                        existingRegion.p.contat(currRegion.p);
                    }

                    currRegion = { x: rowIndent, y1: r, y2: r + 1, p: [] };
                }

                for (var c = 0; c < row.chars.length; ++c) {
                    var uc = row.chars[c];
                    var currPenState = uc.penState;
                    if (prevPenState === null || !currPenState.equals(prevPenState)) {
                        if (line.trim().length > 0) {
                            currP.spans.push({ name: currentStyle, line: line, row: r });
                            line = '';
                        }

                        var currPenStateString = 'style_cea608_' + currPenState.foreground + '_' + currPenState.background;
                        if (currPenState.underline) {
                            currPenStateString += '_underline';
                        }
                        if (currPenState.italics) {
                            currPenStateString += '_italics';
                        }

                        if (!styleStates.hasOwnProperty(currPenStateString)) {
                            styleStates[currPenStateString] = JSON.parse(JSON.stringify(currPenState));
                        }

                        prevPenState = currPenState;

                        currentStyle = currPenStateString;
                    }

                    line += uc.uchar;
                }

                if (line.trim().length > 0) {
                    currP.spans.push({ name: currentStyle, line: line, row: r });
                }

                lastRowHasText = true;
                lastRowIndentL = rowIndent;
            } else {
                /* Row is empty */
                lastRowHasText = false;
                lastRowIndentL = -1;

                if (currRegion) {
                    currRegion.p.push(currP);
                    currP = { start: startTime, end: endTime, spans: [] };
                    currRegion.y2 = r;
                    currRegion.name = 'region_' + currRegion.x + '_' + currRegion.y1 + '_' + currRegion.y2;
                    if (false === seenRegions.hasOwnProperty(currRegion.name)) {
                        regions.push(currRegion);
                        seenRegions[currRegion.name] = currRegion;
                    } else {
                        existingRegion = seenRegions[currRegion.name];
                        existingRegion.p.contat(currRegion.p);
                    }

                    currRegion = null;
                }
            }
        }

        if (currRegion) {
            currRegion.p.push(currP);
            currRegion.y2 = r + 1;
            currRegion.name = 'region_' + currRegion.x + '_' + currRegion.y1 + '_' + currRegion.y2;
            if (false === seenRegions.hasOwnProperty(currRegion.name)) {
                regions.push(currRegion);
                seenRegions[currRegion.name] = currRegion;
            } else {
                existingRegion = seenRegions[currRegion.name];
                existingRegion.p.contat(currRegion.p);
            }

            currRegion = null;
        }

        //log(styleStates);
        //log(regions);

        var captionsArray = [];

        /* Loop thru regions */
        for (r = 0; r < regions.length; ++r) {
            var region = regions[r];

            var cueID = 'sub_cea608_' + captionId++;
            var finalDiv = document.createElement('div');
            finalDiv.id = cueID;
            var cueRegionProperties = getRegionProperties(region);
            finalDiv.style.cssText = 'position: absolute; margin: 0; display: flex; box-sizing: border-box; pointer-events: none;' + cueRegionProperties;

            var bodyDiv = document.createElement('div');
            bodyDiv.className = 'paragraph bodyStyle';
            bodyDiv.style.cssText = getStyle(videoElement);

            var cueUniWrapper = document.createElement('div');
            cueUniWrapper.className = 'cueUniWrapper';
            cueUniWrapper.style.cssText = 'unicode-bidi: normal; direction: ltr;';

            for (var p = 0; p < region.p.length; ++p) {
                var ptag = region.p[p];
                var lastSpanRow = 0;
                for (s = 0; s < ptag.spans.length; ++s) {
                    var span = ptag.spans[s];
                    if (span.line.length > 0) {
                        if (s !== 0 && lastSpanRow != span.row) {
                            var brElement = document.createElement('br');
                            brElement.className = 'lineBreak';
                            cueUniWrapper.appendChild(brElement);
                        }
                        var sameRow = false;
                        if (lastSpanRow === span.row) {
                            sameRow = true;
                        }
                        lastSpanRow = span.row;
                        var spanStyle = styleStates[span.name];
                        var spanElement = document.createElement('span');
                        spanElement.className = 'spanPadding ' + span.name + ' customSpanColor';
                        spanElement.style.cssText = getStyle(videoElement, spanStyle);
                        if (s !== 0 && sameRow) {
                            if (s === ptag.spans.length - 1) {
                                spanElement.textContent = rtrim(span.line);
                            } else {
                                spanElement.textContent = span.line;
                            }
                        } else {
                            if (s === 0) {
                                if (ptag.spans.length > 1) {
                                    /* Check if next text is on same row */
                                    if (span.row === ptag.spans[1].row) {
                                        /* Next element on same row, trim start */
                                        spanElement.textContent = ltrim(span.line);
                                    } else {
                                        /* Different rows, trim */
                                        spanElement.textContent = span.line.trim();
                                    }
                                } else {
                                    spanElement.textContent = span.line.trim();
                                }
                            } else {
                                spanElement.textContent = span.line.trim();
                            }
                        }
                        cueUniWrapper.appendChild(spanElement);
                    }
                }
            }

            bodyDiv.appendChild(cueUniWrapper);

            finalDiv.appendChild(bodyDiv);

            var fontSize = { 'bodyStyle': ['%', 90] };
            for (s in styleStates) {
                if (styleStates.hasOwnProperty(s)) {
                    fontSize[s] = ['%', 90];
                }
            }

            captionsArray.push({ type: 'html',
                start: startTime,
                end: endTime,
                cueHTMLElement: finalDiv,
                cueID: cueID,
                cellResolution: [32, 15],
                isFromCEA608: true,
                regions: regions,
                regionID: region.name,
                videoHeight: videoElement.videoHeight,
                videoWidth: videoElement.videoWidth,
                fontSize: fontSize,
                lineHeight: {},
                linePadding: {}
            });
        }
        return captionsArray;
    }

    instance = {
        createHTMLCaptionsFromScreen: createHTMLCaptionsFromScreen
    };
    return instance;
}

EmbeddedTextHtmlRender.__dashjs_factory_name = 'EmbeddedTextHtmlRender';
exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(EmbeddedTextHtmlRender);
module.exports = exports['default'];
//# sourceMappingURL=EmbeddedTextHtmlRender.js.map


/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreEventBus = __webpack_require__(27);

var _coreEventBus2 = _interopRequireDefault(_coreEventBus);

var _coreEventsEvents = __webpack_require__(22);

var _coreEventsEvents2 = _interopRequireDefault(_coreEventsEvents);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _utilsInitCache = __webpack_require__(408);

var _utilsInitCache2 = _interopRequireDefault(_utilsInitCache);

function NotFragmentedTextBufferController(config) {

    var context = this.context;
    var eventBus = (0, _coreEventBus2['default'])(context).getInstance();

    var sourceBufferController = config.sourceBufferController;
    var errHandler = config.errHandler;

    var instance = undefined,
        isBufferingCompleted = undefined,
        initialized = undefined,
        mediaSource = undefined,
        buffer = undefined,
        type = undefined,
        streamProcessor = undefined,
        representationController = undefined,
        initCache = undefined;

    function setup() {

        initialized = false;
        mediaSource = null;
        buffer = null;
        type = null;
        streamProcessor = null;
        representationController = null;
        isBufferingCompleted = false;

        eventBus.on(_coreEventsEvents2['default'].DATA_UPDATE_COMPLETED, onDataUpdateCompleted, this);
        eventBus.on(_coreEventsEvents2['default'].INIT_FRAGMENT_LOADED, onInitFragmentLoaded, this);
    }

    function initialize(Type, source, StreamProcessor) {
        type = Type;
        setMediaSource(source);
        streamProcessor = StreamProcessor;
        representationController = streamProcessor.getRepresentationController();
        initCache = (0, _utilsInitCache2['default'])(context).getInstance();
    }

    /**
     * @param {MediaInfo }mediaInfo
     * @returns {Object} SourceBuffer object
     * @memberof BufferController#
     */
    function createBuffer(mediaInfo) {
        try {
            buffer = sourceBufferController.createSourceBuffer(mediaSource, mediaInfo);

            if (!initialized) {
                if (buffer.hasOwnProperty('initialize')) {
                    buffer.initialize(type, this);
                }
                initialized = true;
            }
        } catch (e) {
            errHandler.mediaSourceError('Error creating ' + type + ' source buffer.');
        }

        return buffer;
    }

    function getType() {
        return type;
    }

    function getBuffer() {
        return buffer;
    }

    function setBuffer(value) {
        buffer = value;
    }

    function setMediaSource(value) {
        mediaSource = value;
    }

    function getMediaSource() {
        return mediaSource;
    }

    function setStreamProcessor(value) {
        streamProcessor = value;
    }

    function getStreamProcessor() {
        return streamProcessor;
    }

    function getBufferLevel() {
        return 0;
    }

    function getCriticalBufferLevel() {
        return 0;
    }

    function reset(errored) {

        eventBus.off(_coreEventsEvents2['default'].DATA_UPDATE_COMPLETED, onDataUpdateCompleted, this);
        eventBus.off(_coreEventsEvents2['default'].INIT_FRAGMENT_LOADED, onInitFragmentLoaded, this);

        if (!errored) {
            sourceBufferController.abort(mediaSource, buffer);
            sourceBufferController.removeSourceBuffer(mediaSource, buffer);
        }
    }

    function onDataUpdateCompleted(e) {
        if (e.sender.getStreamProcessor() !== streamProcessor) {
            return;
        }

        eventBus.trigger(_coreEventsEvents2['default'].TIMED_TEXT_REQUESTED, {
            index: 0,
            sender: e.sender
        }); //TODO make index dynamic if referring to MP?
    }

    function onInitFragmentLoaded(e) {
        if (e.fragmentModel !== streamProcessor.getFragmentModel() || !e.chunk.bytes) {
            return;
        }

        sourceBufferController.append(buffer, e.chunk);
    }

    function getIsBufferingCompleted() {
        return isBufferingCompleted;
    }

    function switchInitData(streamId, quality) {
        var chunk = initCache.extract(streamId, type, quality);
        if (chunk) {
            sourceBufferController.append(chunk);
        } else {
            eventBus.trigger(_coreEventsEvents2['default'].INIT_REQUESTED, {
                sender: instance
            });
        }
    }

    instance = {
        initialize: initialize,
        createBuffer: createBuffer,
        getType: getType,
        getStreamProcessor: getStreamProcessor,
        setStreamProcessor: setStreamProcessor,
        getBuffer: getBuffer,
        setBuffer: setBuffer,
        getBufferLevel: getBufferLevel,
        getCriticalBufferLevel: getCriticalBufferLevel,
        setMediaSource: setMediaSource,
        getMediaSource: getMediaSource,
        getIsBufferingCompleted: getIsBufferingCompleted,
        switchInitData: switchInitData,
        reset: reset
    };

    setup();

    return instance;
}

NotFragmentedTextBufferController.__dashjs_factory_name = 'NotFragmentedTextBufferController';
exports['default'] = _coreFactoryMaker2['default'].getClassFactory(NotFragmentedTextBufferController);
module.exports = exports['default'];
//# sourceMappingURL=NotFragmentedTextBufferController.js.map


/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _controllersBufferController = __webpack_require__(160);

var _controllersBufferController2 = _interopRequireDefault(_controllersBufferController);

var _NotFragmentedTextBufferController = __webpack_require__(1405);

var _NotFragmentedTextBufferController2 = _interopRequireDefault(_NotFragmentedTextBufferController);

function TextBufferController(config) {

    var context = this.context;

    var _BufferControllerImpl = undefined;

    var instance = undefined;

    function setup(config) {

        // according to text type, we create corresponding buffer controller
        if (config.type === 'fragmentedText') {

            // in this case, internal buffer ocntroller is a classical BufferController object
            _BufferControllerImpl = (0, _controllersBufferController2['default'])(context).create({
                metricsModel: config.metricsModel,
                manifestModel: config.manifestModel,
                sourceBufferController: config.sourceBufferController,
                errHandler: config.errHandler,
                streamController: config.streamController,
                mediaController: config.mediaController,
                adapter: config.adapter,
                textController: config.textController
            });
        } else {

            // in this case, internal buffer controller is a not fragmented text controller  object
            _BufferControllerImpl = (0, _NotFragmentedTextBufferController2['default'])(context).create({
                errHandler: config.errHandler,
                sourceBufferController: config.sourceBufferController
            });
        }
    }

    function initialize(Type, source, StreamProcessor) {
        return _BufferControllerImpl.initialize(Type, source, StreamProcessor);
    }

    /**
     * @param {MediaInfo }mediaInfo
     * @returns {Object} SourceBuffer object
     * @memberof BufferController#
     */
    function createBuffer(mediaInfo) {
        return _BufferControllerImpl.createBuffer(mediaInfo);
    }

    function getType() {
        return _BufferControllerImpl.getType();
    }

    function getBuffer() {
        return _BufferControllerImpl.getBuffer();
    }

    function setBuffer(value) {
        _BufferControllerImpl.setBuffer(value);
    }

    function getMediaSource() {
        return _BufferControllerImpl.getMediaSource();
    }

    function setMediaSource(value) {
        _BufferControllerImpl.setMediaSource(value);
    }

    function setStreamProcessor(streamProcessor) {
        _BufferControllerImpl.setStreamProcessor(streamProcessor);
    }

    function getStreamProcessor() {
        _BufferControllerImpl.getStreamProcessor();
    }

    function getBufferLevel() {
        return _BufferControllerImpl.getBufferLevel();
    }

    function getCriticalBufferLevel() {
        return _BufferControllerImpl.getCriticalBufferLevel();
    }

    function reset(errored) {
        _BufferControllerImpl.reset(errored);
    }

    function getIsBufferingCompleted() {
        return _BufferControllerImpl.getIsBufferingCompleted();
    }

    function switchInitData(streamId, quality) {
        _BufferControllerImpl.switchInitData(streamId, quality);
    }

    instance = {
        initialize: initialize,
        createBuffer: createBuffer,
        getType: getType,
        getStreamProcessor: getStreamProcessor,
        setStreamProcessor: setStreamProcessor,
        getBuffer: getBuffer,
        setBuffer: setBuffer,
        getBufferLevel: getBufferLevel,
        getCriticalBufferLevel: getCriticalBufferLevel,
        setMediaSource: setMediaSource,
        getMediaSource: getMediaSource,
        getIsBufferingCompleted: getIsBufferingCompleted,
        switchInitData: switchInitData,
        reset: reset
    };

    setup(config);

    return instance;
}

TextBufferController.__dashjs_factory_name = 'TextBufferController';
exports['default'] = _coreFactoryMaker2['default'].getClassFactory(TextBufferController);
exports['default'] = _coreFactoryMaker2['default'].getClassFactory(TextBufferController);
module.exports = exports['default'];
//# sourceMappingURL=TextBufferController.js.map


/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _voTextTrackInfo = __webpack_require__(1425);

var _voTextTrackInfo2 = _interopRequireDefault(_voTextTrackInfo);

var _dashUtilsFragmentedTextBoxParser = __webpack_require__(1335);

var _dashUtilsFragmentedTextBoxParser2 = _interopRequireDefault(_dashUtilsFragmentedTextBoxParser);

var _utilsBoxParser = __webpack_require__(406);

var _utilsBoxParser2 = _interopRequireDefault(_utilsBoxParser);

var _utilsCustomTimeRanges = __webpack_require__(598);

var _utilsCustomTimeRanges2 = _interopRequireDefault(_utilsCustomTimeRanges);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _coreDebug = __webpack_require__(30);

var _coreDebug2 = _interopRequireDefault(_coreDebug);

var _modelsVideoModel = __webpack_require__(240);

var _modelsVideoModel2 = _interopRequireDefault(_modelsVideoModel);

var _TextTracks = __webpack_require__(405);

var _TextTracks2 = _interopRequireDefault(_TextTracks);

var _EmbeddedTextHtmlRender = __webpack_require__(1404);

var _EmbeddedTextHtmlRender2 = _interopRequireDefault(_EmbeddedTextHtmlRender);

var _codemIsoboxer = __webpack_require__(582);

var _codemIsoboxer2 = _interopRequireDefault(_codemIsoboxer);

var _externalsCea608Parser = __webpack_require__(583);

var _externalsCea608Parser2 = _interopRequireDefault(_externalsCea608Parser);

var _coreEventBus = __webpack_require__(27);

var _coreEventBus2 = _interopRequireDefault(_coreEventBus);

var _coreEventsEvents = __webpack_require__(22);

var _coreEventsEvents2 = _interopRequireDefault(_coreEventsEvents);

function TextSourceBuffer() {

    var context = this.context;
    var log = (0, _coreDebug2['default'])(context).getInstance().log;
    var eventBus = (0, _coreEventBus2['default'])(context).getInstance();
    var embeddedInitialized = false;

    var instance = undefined,
        boxParser = undefined,
        errHandler = undefined,
        dashManifestModel = undefined,
        mediaController = undefined,
        parser = undefined,
        vttParser = undefined,
        ttmlParser = undefined,
        fragmentedTextBoxParser = undefined,
        mediaInfos = undefined,
        textTracks = undefined,
        isFragmented = undefined,
        fragmentModel = undefined,
        initializationSegmentReceived = undefined,
        timescale = undefined,
        fragmentedTracks = undefined,
        videoModel = undefined,
        streamController = undefined,
        firstSubtitleStart = undefined,
        currFragmentedTrackIdx = undefined,
        embeddedTracks = undefined,
        embeddedInitializationSegmentReceived = undefined,
        embeddedTimescale = undefined,
        embeddedLastSequenceNumber = undefined,
        embeddedSequenceNumbers = undefined,
        embeddedCea608FieldParsers = undefined,
        embeddedTextHtmlRender = undefined;

    function initialize(type, bufferController) {
        parser = null;
        fragmentModel = null;
        initializationSegmentReceived = false;
        timescale = NaN;
        fragmentedTracks = [];
        firstSubtitleStart = null;

        if (!embeddedInitialized) {
            initEmbedded();
        }

        var streamProcessor = bufferController.getStreamProcessor();

        mediaInfos = streamProcessor.getMediaInfoArr();
        textTracks.setConfig({
            videoModel: videoModel
        });
        textTracks.initialize();
        isFragmented = !dashManifestModel.getIsTextTrack(type);
        boxParser = (0, _utilsBoxParser2['default'])(context).getInstance();
        fragmentedTextBoxParser = (0, _dashUtilsFragmentedTextBoxParser2['default'])(context).getInstance();
        fragmentedTextBoxParser.setConfig({
            boxParser: boxParser
        });

        if (isFragmented) {
            fragmentModel = streamProcessor.getFragmentModel();
            this.buffered = (0, _utilsCustomTimeRanges2['default'])(context).create();
            fragmentedTracks = mediaController.getTracksFor('fragmentedText', streamController.getActiveStreamInfo());
            var currFragTrack = mediaController.getCurrentTrackFor('fragmentedText', streamController.getActiveStreamInfo());
            for (var i = 0; i < fragmentedTracks.length; i++) {
                if (fragmentedTracks[i] === currFragTrack) {
                    currFragmentedTrackIdx = i;
                    break;
                }
            }
        }
    }

    function abort() {
        textTracks.deleteAllTextTracks();
        parser = null;
        fragmentedTextBoxParser = null;
        mediaInfos = null;
        textTracks = null;
        isFragmented = false;
        fragmentModel = null;
        initializationSegmentReceived = false;
        timescale = NaN;
        fragmentedTracks = [];
        videoModel = null;
        streamController = null;
        embeddedInitialized = false;
        embeddedTracks = null;
    }

    function onVideoChunkReceived(e) {
        var chunk = e.chunk;

        if (chunk.mediaInfo.embeddedCaptions) {
            append(chunk.bytes, chunk);
        }
    }

    function initEmbedded() {
        embeddedTracks = [];
        mediaInfos = [];
        videoModel = (0, _modelsVideoModel2['default'])(context).getInstance();
        textTracks = (0, _TextTracks2['default'])(context).getInstance();
        textTracks.setConfig({
            videoModel: videoModel
        });
        textTracks.initialize();
        boxParser = (0, _utilsBoxParser2['default'])(context).getInstance();
        fragmentedTextBoxParser = (0, _dashUtilsFragmentedTextBoxParser2['default'])(context).getInstance();
        fragmentedTextBoxParser.setConfig({
            boxParser: boxParser
        });
        isFragmented = false;
        currFragmentedTrackIdx = null;
        embeddedInitializationSegmentReceived = false;
        embeddedTimescale = 0;
        embeddedCea608FieldParsers = [];
        embeddedSequenceNumbers = [];
        embeddedLastSequenceNumber = null;
        embeddedInitialized = true;
        embeddedTextHtmlRender = (0, _EmbeddedTextHtmlRender2['default'])(context).getInstance();

        eventBus.on(_coreEventsEvents2['default'].VIDEO_CHUNK_RECEIVED, onVideoChunkReceived, this);
    }

    function resetEmbedded() {
        eventBus.off(_coreEventsEvents2['default'].VIDEO_CHUNK_RECEIVED, onVideoChunkReceived, this);
        if (textTracks !== null) {
            textTracks.deleteAllTextTracks();
        }
        embeddedInitialized = false;
        embeddedTracks = [];
        embeddedCea608FieldParsers = [null, null];
        embeddedSequenceNumbers = [];
        embeddedLastSequenceNumber = null;
    }

    function addEmbeddedTrack(mediaInfo) {
        if (!embeddedInitialized) {
            initEmbedded();
        }
        if (mediaInfo.id === 'CC1' || mediaInfo.id === 'CC3') {
            embeddedTracks.push(mediaInfo);
        } else {
            log('Warning: Embedded track ' + mediaInfo.id + ' not supported!');
        }
    }

    function setConfig(config) {
        if (!config) {
            return;
        }
        if (config.errHandler) {
            errHandler = config.errHandler;
        }
        if (config.dashManifestModel) {
            dashManifestModel = config.dashManifestModel;
        }
        if (config.mediaController) {
            mediaController = config.mediaController;
        }
        if (config.videoModel) {
            videoModel = config.videoModel;
        }
        if (config.streamController) {
            streamController = config.streamController;
        }
        if (config.textTracks) {
            textTracks = config.textTracks;
        }
        if (config.vttParser) {
            vttParser = config.vttParser;
        }
        if (config.ttmlParser) {
            ttmlParser = config.ttmlParser;
        }
    }

    function getConfig() {
        var config = {
            errHandler: errHandler,
            dashManifestModel: dashManifestModel,
            mediaController: mediaController,
            videoModel: videoModel,
            fragmentModel: fragmentModel,
            streamController: streamController,
            textTracks: textTracks,
            isFragmented: isFragmented,
            embeddedTracks: embeddedTracks,
            fragmentedTracks: fragmentedTracks
        };

        return config;
    }

    function setCurrentFragmentedTrackIdx(idx) {
        currFragmentedTrackIdx = idx;
    }

    function append(bytes, chunk) {
        var result, sampleList, i, j, k, samplesInfo, ccContent;
        var mediaInfo = chunk.mediaInfo;
        var mediaType = mediaInfo.type;
        var mimeType = mediaInfo.mimeType;
        var codecType = mediaInfo.codec || mimeType;
        if (!codecType) {
            log('No text type defined');
            return;
        }

        function createTextTrackFromMediaInfo(captionData, mediaInfo) {
            var textTrackInfo = new _voTextTrackInfo2['default']();
            var trackKindMap = {
                subtitle: 'subtitles',
                caption: 'captions'
            }; //Dash Spec has no "s" on end of KIND but HTML needs plural.
            var getKind = function getKind() {
                var kind = mediaInfo.roles.length > 0 ? trackKindMap[mediaInfo.roles[0]] : trackKindMap.caption;
                kind = kind === trackKindMap.caption || kind === trackKindMap.subtitle ? kind : trackKindMap.caption;
                return kind;
            };

            var checkTTML = function checkTTML() {
                var ttml = false;
                if (mediaInfo.codec && mediaInfo.codec.search('stpp') >= 0) {
                    ttml = true;
                }
                if (mediaInfo.mimeType && mediaInfo.mimeType.search('ttml') >= 0) {
                    ttml = true;
                }
                return ttml;
            };

            textTrackInfo.captionData = captionData;
            textTrackInfo.lang = mediaInfo.lang;
            textTrackInfo.label = mediaInfo.id; // AdaptationSet id (an unsigned int)
            textTrackInfo.index = mediaInfo.index; // AdaptationSet index in manifest
            textTrackInfo.isTTML = checkTTML();
            textTrackInfo.video = videoModel.getElement();
            textTrackInfo.defaultTrack = getIsDefault(mediaInfo);
            textTrackInfo.isFragmented = isFragmented;
            textTrackInfo.isEmbedded = mediaInfo.isEmbedded ? true : false;
            textTrackInfo.kind = getKind();
            textTrackInfo.roles = mediaInfo.roles;
            var totalNrTracks = (mediaInfos ? mediaInfos.length : 0) + embeddedTracks.length;
            textTracks.addTextTrack(textTrackInfo, totalNrTracks);
        }

        if (mediaType === 'fragmentedText') {
            if (!initializationSegmentReceived) {
                initializationSegmentReceived = true;
                for (i = 0; i < mediaInfos.length; i++) {
                    createTextTrackFromMediaInfo(null, mediaInfos[i]);
                }
                timescale = fragmentedTextBoxParser.getMediaTimescaleFromMoov(bytes);
            } else {
                samplesInfo = fragmentedTextBoxParser.getSamplesInfo(bytes);
                sampleList = samplesInfo.sampleList;
                if (!firstSubtitleStart && sampleList.length > 0) {
                    firstSubtitleStart = sampleList[0].cts - chunk.start * timescale;
                }
                if (codecType.search('stpp') >= 0) {
                    parser = parser !== null ? parser : getParser(codecType);
                    for (i = 0; i < sampleList.length; i++) {
                        var _sample = sampleList[i];
                        var sampleStart = _sample.cts;
                        var sampleRelStart = sampleStart - firstSubtitleStart;
                        this.buffered.add(sampleRelStart / timescale, (sampleRelStart + _sample.duration) / timescale);
                        var dataView = new DataView(bytes, _sample.offset, _sample.subSizes[0]);
                        ccContent = _codemIsoboxer2['default'].Utils.dataViewToString(dataView, 'utf-8');
                        var images = [];
                        var subOffset = _sample.offset + _sample.subSizes[0];
                        for (j = 1; j < _sample.subSizes.length; j++) {
                            var inData = new Uint8Array(bytes, subOffset, _sample.subSizes[j]);
                            var raw = String.fromCharCode.apply(null, inData);
                            images.push(raw);
                            subOffset += _sample.subSizes[j];
                        }
                        try {
                            result = parser.parse(ccContent, sampleStart / timescale, (sampleStart + _sample.duration) / timescale, images);
                            textTracks.addCaptions(currFragmentedTrackIdx, firstSubtitleStart / timescale, result);
                        } catch (e) {
                            log('TTML parser error: ' + e.message);
                        }
                    }
                } else {
                    // WebVTT case
                    var captionArray = [];
                    for (i = 0; i < sampleList.length; i++) {
                        var sample = sampleList[i];
                        sample.cts -= firstSubtitleStart;
                        this.buffered.add(sample.cts / timescale, (sample.cts + sample.duration) / timescale);
                        var sampleData = bytes.slice(sample.offset, sample.offset + sample.size);
                        // There are boxes inside the sampleData, so we need a ISOBoxer to get at it.
                        var sampleBoxes = _codemIsoboxer2['default'].parseBuffer(sampleData);

                        for (j = 0; j < sampleBoxes.boxes.length; j++) {
                            var box1 = sampleBoxes.boxes[j];
                            log('VTT box1: ' + box1.type);
                            if (box1.type === 'vtte') {
                                continue; //Empty box
                            }
                            if (box1.type === 'vttc') {
                                log('VTT vttc boxes.length = ' + box1.boxes.length);
                                for (k = 0; k < box1.boxes.length; k++) {
                                    var box2 = box1.boxes[k];
                                    log('VTT box2: ' + box2.type);
                                    if (box2.type === 'payl') {
                                        var cue_text = box2.cue_text;
                                        log('VTT cue_text = ' + cue_text);
                                        var start_time = sample.cts / timescale;
                                        var end_time = (sample.cts + sample.duration) / timescale;
                                        captionArray.push({
                                            start: start_time,
                                            end: end_time,
                                            data: cue_text,
                                            styles: {}
                                        });
                                        log('VTT ' + start_time + '-' + end_time + ' : ' + cue_text);
                                    }
                                }
                            }
                        }
                    }
                    if (captionArray.length > 0) {
                        textTracks.addCaptions(currFragmentedTrackIdx, 0, captionArray);
                    }
                }
            }
        } else if (mediaType === 'text') {
            var dataView = new DataView(bytes, 0, bytes.byteLength);
            ccContent = _codemIsoboxer2['default'].Utils.dataViewToString(dataView, 'utf-8');

            try {
                result = getParser(codecType).parse(ccContent);
                createTextTrackFromMediaInfo(result, mediaInfo);
            } catch (e) {
                errHandler.timedTextError(e, 'parse', ccContent);
            }
        } else if (mediaType === 'video') {
            //embedded text
            if (chunk.segmentType === 'InitializationSegment') {
                if (embeddedTimescale === 0) {
                    embeddedTimescale = fragmentedTextBoxParser.getMediaTimescaleFromMoov(bytes);
                    for (i = 0; i < embeddedTracks.length; i++) {
                        createTextTrackFromMediaInfo(null, embeddedTracks[i]);
                    }
                }
            } else {
                // MediaSegment
                if (embeddedTimescale === 0) {
                    log('CEA-608: No timescale for embeddedTextTrack yet');
                    return;
                }
                var makeCueAdderForIndex = function makeCueAdderForIndex(self, trackIndex) {
                    function newCue(startTime, endTime, captionScreen) {
                        var captionsArray = null;
                        if (videoModel.getTTMLRenderingDiv()) {
                            captionsArray = embeddedTextHtmlRender.createHTMLCaptionsFromScreen(videoModel.getElement(), startTime, endTime, captionScreen);
                        } else {
                            var text = captionScreen.getDisplayText();
                            //log("CEA text: " + startTime + "-" + endTime + "  '" + text + "'");
                            captionsArray = [{
                                start: startTime,
                                end: endTime,
                                data: text,
                                styles: {}
                            }];
                        }
                        if (captionsArray) {
                            textTracks.addCaptions(trackIndex, 0, captionsArray);
                        }
                    }
                    return newCue;
                };

                samplesInfo = fragmentedTextBoxParser.getSamplesInfo(bytes);
                var sequenceNumber = samplesInfo.sequenceNumber;

                if (!embeddedCea608FieldParsers[0] && !embeddedCea608FieldParsers[1]) {
                    // Time to setup the CEA-608 parsing
                    var field = undefined,
                        handler = undefined,
                        trackIdx = undefined;
                    for (i = 0; i < embeddedTracks.length; i++) {
                        if (embeddedTracks[i].id === 'CC1') {
                            field = 0;
                            trackIdx = textTracks.getTrackIdxForId('CC1');
                        } else if (embeddedTracks[i].id === 'CC3') {
                            field = 1;
                            trackIdx = textTracks.getTrackIdxForId('CC3');
                        }
                        if (trackIdx === -1) {
                            log('CEA-608: data before track is ready.');
                            return;
                        }
                        handler = makeCueAdderForIndex(this, trackIdx);
                        embeddedCea608FieldParsers[i] = new _externalsCea608Parser2['default'].Cea608Parser(i, {
                            'newCue': handler
                        }, null);
                    }
                }

                if (embeddedTimescale && embeddedSequenceNumbers.indexOf(sequenceNumber) == -1) {
                    if (embeddedLastSequenceNumber !== null && sequenceNumber !== embeddedLastSequenceNumber + 1) {
                        for (i = 0; i < embeddedCea608FieldParsers.length; i++) {
                            if (embeddedCea608FieldParsers[i]) {
                                embeddedCea608FieldParsers[i].reset();
                            }
                        }
                    }
                    var allCcData = extractCea608Data(bytes);

                    for (var fieldNr = 0; fieldNr < embeddedCea608FieldParsers.length; fieldNr++) {
                        var ccData = allCcData.fields[fieldNr];
                        var fieldParser = embeddedCea608FieldParsers[fieldNr];
                        if (fieldParser) {
                            /*if (ccData.length > 0 ) {
                                log("CEA-608 adding Data to field " + fieldNr + " " + ccData.length + "bytes");
                            }*/
                            for (i = 0; i < ccData.length; i++) {
                                fieldParser.addData(ccData[i][0] / embeddedTimescale, ccData[i][1]);
                            }
                            if (allCcData.endTime) {
                                fieldParser.cueSplitAtTime(allCcData.endTime / embeddedTimescale);
                            }
                        }
                    }
                    embeddedLastSequenceNumber = sequenceNumber;
                    embeddedSequenceNumbers.push(sequenceNumber);
                }
            }
        }
    }
    /**
     * Extract CEA-608 data from a buffer of data.
     * @param {ArrayBuffer} data
     * @returns {Object|null} ccData corresponding to one segment.
     */
    function extractCea608Data(data) {

        var isoFile = boxParser.parse(data);
        var moof = isoFile.getBox('moof');
        var tfdt = isoFile.getBox('tfdt');
        var tfhd = isoFile.getBox('tfhd'); //Can have a base_data_offset and other default values
        //log("tfhd: " + tfhd);
        //var saio = isoFile.getBox('saio'); // Offset possibly
        //var saiz = isoFile.getBox('saiz'); // Possible sizes
        var truns = isoFile.getBoxes('trun'); //
        var trun = null;

        if (truns.length === 0) {
            return null;
        }
        trun = truns[0];
        if (truns.length > 1) {
            log('Warning: Too many truns');
        }
        var baseOffset = moof.offset + trun.data_offset;
        //Doublecheck that trun.offset == moof.size + 8
        var sampleCount = trun.sample_count;
        var startPos = baseOffset;
        var baseSampleTime = tfdt.baseMediaDecodeTime;
        var raw = new DataView(data);
        var allCcData = {
            'startTime': null,
            'endTime': null,
            fields: [[], []]
        };
        var accDuration = 0;
        for (var i = 0; i < sampleCount; i++) {
            var sample = trun.samples[i];
            if (sample.sample_duration === undefined) {
                sample.sample_duration = tfhd.default_sample_duration;
            }
            if (sample.sample_size === undefined) {
                sample.sample_size = tfhd.default_sample_size;
            }
            if (sample.sample_composition_time_offset === undefined) {
                sample.sample_composition_time_offset = 0;
            }
            var sampleTime = baseSampleTime + accDuration + sample.sample_composition_time_offset;
            var cea608Ranges = _externalsCea608Parser2['default'].findCea608Nalus(raw, startPos, sample.sample_size);
            for (var j = 0; j < cea608Ranges.length; j++) {
                var ccData = _externalsCea608Parser2['default'].extractCea608DataFromRange(raw, cea608Ranges[j]);
                for (var k = 0; k < 2; k++) {
                    if (ccData[k].length > 0) {
                        allCcData.fields[k].push([sampleTime, ccData[k]]);
                    }
                }
            }

            accDuration += sample.sample_duration;
            startPos += sample.sample_size;
        }

        // Sort by sampleTime ascending order
        allCcData.fields[0].sort(function (a, b) {
            return a[0] - b[0];
        });
        allCcData.fields[1].sort(function (a, b) {
            return a[0] - b[0];
        });

        var endSampleTime = baseSampleTime + accDuration;
        allCcData.startTime = baseSampleTime;
        allCcData.endTime = endSampleTime;
        return allCcData;
    }

    function getIsDefault(mediaInfo) {
        //TODO How to tag default. currently same order as listed in manifest.
        // Is there a way to mark a text adaptation set as the default one? DASHIF meeting talk about using role which is being used for track KIND
        // Eg subtitles etc. You can have multiple role tags per adaptation Not defined in the spec yet.
        var isDefault = false;
        if (embeddedTracks.length > 1 && mediaInfo.isEmbedded) {
            isDefault = mediaInfo.id && mediaInfo.id === 'CC1'; // CC1 if both CC1 and CC3 exist
        } else if (embeddedTracks.length === 1) {
                if (mediaInfo.id && mediaInfo.id.substring(0, 2) === 'CC') {
                    // Either CC1 or CC3
                    isDefault = true;
                }
            } else if (embeddedTracks.length === 0) {
                isDefault = mediaInfo.index === mediaInfos[0].index;
            }
        return isDefault;
    }

    function getParser(codecType) {
        var parser;
        if (codecType.search('vtt') >= 0) {
            parser = vttParser;
        } else if (codecType.search('ttml') >= 0 || codecType.search('stpp') >= 0) {
            parser = ttmlParser;
            parser.setConfig({
                videoModel: videoModel
            });
        }
        return parser;
    }

    instance = {
        initialize: initialize,
        append: append,
        abort: abort,
        addEmbeddedTrack: addEmbeddedTrack,
        resetEmbedded: resetEmbedded,
        setConfig: setConfig,
        getConfig: getConfig,
        setCurrentFragmentedTrackIdx: setCurrentFragmentedTrackIdx
    };

    return instance;
}

TextSourceBuffer.__dashjs_factory_name = 'TextSourceBuffer';
exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(TextSourceBuffer);
module.exports = exports['default'];
//# sourceMappingURL=TextSourceBuffer.js.map


/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreEventBus = __webpack_require__(27);

var _coreEventBus2 = _interopRequireDefault(_coreEventBus);

var _coreEventsEvents = __webpack_require__(22);

var _coreEventsEvents2 = _interopRequireDefault(_coreEventsEvents);

var _dashModelsDashManifestModel = __webpack_require__(158);

var _dashModelsDashManifestModel2 = _interopRequireDefault(_dashModelsDashManifestModel);

var _controllersBlacklistController = __webpack_require__(1352);

var _controllersBlacklistController2 = _interopRequireDefault(_controllersBlacklistController);

var _baseUrlResolutionDVBSelector = __webpack_require__(1416);

var _baseUrlResolutionDVBSelector2 = _interopRequireDefault(_baseUrlResolutionDVBSelector);

var _baseUrlResolutionBasicSelector = __webpack_require__(1415);

var _baseUrlResolutionBasicSelector2 = _interopRequireDefault(_baseUrlResolutionBasicSelector);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var URL_RESOLUTION_FAILED_GENERIC_ERROR_CODE = 1;
var URL_RESOLUTION_FAILED_GENERIC_ERROR_MESSAGE = 'Failed to resolve a valid URL';

function BaseURLSelector() {

    var context = this.context;
    var eventBus = (0, _coreEventBus2['default'])(context).getInstance();
    var dashManifestModel = (0, _dashModelsDashManifestModel2['default'])(context).getInstance();

    var instance = undefined,
        serviceLocationBlacklistController = undefined,
        basicSelector = undefined,
        dvbSelector = undefined,
        selector = undefined;

    function setup() {
        serviceLocationBlacklistController = (0, _controllersBlacklistController2['default'])(context).create({
            updateEventName: _coreEventsEvents2['default'].SERVICE_LOCATION_BLACKLIST_CHANGED,
            loadFailedEventName: _coreEventsEvents2['default'].FRAGMENT_LOADING_COMPLETED
        });

        basicSelector = (0, _baseUrlResolutionBasicSelector2['default'])(context).create({
            blacklistController: serviceLocationBlacklistController
        });

        dvbSelector = (0, _baseUrlResolutionDVBSelector2['default'])(context).create({
            blacklistController: serviceLocationBlacklistController
        });

        selector = basicSelector;
    }

    function setConfig(config) {
        if (config.selector) {
            selector = config.selector;
        }
    }

    function chooseSelectorFromManifest(manifest) {
        if (dashManifestModel.getIsDVB(manifest)) {
            selector = dvbSelector;
        } else {
            selector = basicSelector;
        }
    }

    function select(data) {
        var baseUrls = data.baseUrls;
        var selectedIdx = data.selectedIdx;

        // Once a random selection has been carried out amongst a group of BaseURLs with the same
        // @priority attribute value, then that choice should be re-used if the selection needs to be made again
        // unless the blacklist has been modified or the available BaseURLs have changed.
        if (!isNaN(selectedIdx)) {
            return baseUrls[selectedIdx];
        }

        var selectedBaseUrl = selector.select(baseUrls);

        if (!selectedBaseUrl) {
            eventBus.trigger(_coreEventsEvents2['default'].URL_RESOLUTION_FAILED, {
                error: new Error(URL_RESOLUTION_FAILED_GENERIC_ERROR_CODE, URL_RESOLUTION_FAILED_GENERIC_ERROR_MESSAGE)
            });

            return;
        }

        data.selectedIdx = baseUrls.indexOf(selectedBaseUrl);

        return selectedBaseUrl;
    }

    function reset() {
        serviceLocationBlacklistController.reset();
    }

    instance = {
        chooseSelectorFromManifest: chooseSelectorFromManifest,
        select: select,
        reset: reset,
        setConfig: setConfig
    };

    setup();

    return instance;
}

BaseURLSelector.__dashjs_factory_name = 'BaseURLSelector';
var factory = _coreFactoryMaker2['default'].getClassFactory(BaseURLSelector);
factory.URL_RESOLUTION_FAILED_GENERIC_ERROR_CODE = URL_RESOLUTION_FAILED_GENERIC_ERROR_CODE;
factory.URL_RESOLUTION_FAILED_GENERIC_ERROR_MESSAGE = URL_RESOLUTION_FAILED_GENERIC_ERROR_MESSAGE;
exports['default'] = factory;
module.exports = exports['default'];
//# sourceMappingURL=BaseURLSelector.js.map


/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

function Capabilities() {

    var instance = undefined,
        encryptedMediaSupported = undefined;

    function setup() {
        encryptedMediaSupported = false;
    }

    function supportsMediaSource() {
        var hasWebKit = ('WebKitMediaSource' in window);
        var hasMediaSource = ('MediaSource' in window);

        return hasWebKit || hasMediaSource;
    }

    /**
     * Returns whether Encrypted Media Extensions are supported on this
     * user agent
     *
     * @return {boolean} true if EME is supported, false otherwise
     */
    function supportsEncryptedMedia() {
        return encryptedMediaSupported;
    }

    function setEncryptedMediaSupported(value) {
        encryptedMediaSupported = value;
    }

    function supportsCodec(element, codec) {
        var canPlay = element.canPlayType(codec);
        return canPlay === 'probably' || canPlay === 'maybe';
    }

    instance = {
        supportsMediaSource: supportsMediaSource,
        supportsEncryptedMedia: supportsEncryptedMedia,
        supportsCodec: supportsCodec,
        setEncryptedMediaSupported: setEncryptedMediaSupported
    };

    setup();

    return instance;
}
Capabilities.__dashjs_factory_name = 'Capabilities';
exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(Capabilities);
module.exports = exports['default'];
//# sourceMappingURL=Capabilities.js.map


/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _voError = __webpack_require__(111);

var _voError2 = _interopRequireDefault(_voError);

/**
 * Creates an instance of an EBMLParser class which implements a large subset
 * of the functionality required to parse Matroska EBML
 *
 * @param {Object} config object with data member which is the buffer to parse
 */
function EBMLParser(config) {

    var instance = undefined;

    var data = new DataView(config.data);
    var pos = 0;

    function getPos() {
        return pos;
    }

    function setPos(value) {
        pos = value;
    }

    /**
     * Consumes an EBML tag from the data stream.
     *
     * @param {Object} tag to parse, A tag is an object with at least a {number} tag and
     * {boolean} required flag.
     * @param {boolean} test whether or not the function should throw if a required
     * tag is not found
     * @return {boolean} whether or not the tag was found
     * @throws will throw an exception if a required tag is not found and test
     * param is false or undefined, or if the stream is malformed.
     * @memberof EBMLParser
     */
    function consumeTag(tag, test) {
        var found = true;
        var bytesConsumed = 0;
        var p1 = undefined;
        var p2 = undefined;

        if (test === undefined) {
            test = false;
        }

        if (tag.tag > 0xFFFFFF) {
            if (data.getUint32(pos) !== tag.tag) {
                found = false;
            }
            bytesConsumed = 4;
        } else if (tag.tag > 0xFFFF) {
            // 3 bytes
            p1 = data.getUint16(pos);
            p2 = data.getUint8(pos + 2);

            // shift p1 over a byte and add p2
            if (p1 * 256 + p2 !== tag.tag) {
                found = false;
            }
            bytesConsumed = 3;
        } else if (tag.tag > 0xFF) {
            if (data.getUint16(pos) !== tag.tag) {
                found = false;
            }
            bytesConsumed = 2;
        } else {
            if (data.getUint8(pos) !== tag.tag) {
                found = false;
            }
            bytesConsumed = 1;
        }

        if (!found && tag.required && !test) {
            throw new _voError2['default']('required tag not found');
        }

        if (found) {
            pos += bytesConsumed;
        }

        return found;
    }

    /**
     * Consumes an EBML tag from the data stream.   If the tag is found then this
     * function will also remove the size field which follows the tag from the
     * data stream.
     *
     * @param {Object} tag to parse, A tag is an object with at least a {number} tag and
     * {boolean} required flag.
     * @param {boolean} test whether or not the function should throw if a required
     * tag is not found
     * @return {boolean} whether or not the tag was found
     * @throws will throw an exception if a required tag is not found and test
     * param is false or undefined, or if the stream is malformedata.
     * @memberof EBMLParser
     */
    function consumeTagAndSize(tag, test) {
        var found = consumeTag(tag, test);

        if (found) {
            getMatroskaCodedNum();
        }

        return found;
    }

    /**
     * Consumes an EBML tag from the data stream.   If the tag is found then this
     * function will also remove the size field which follows the tag from the
     * data stream.  It will use the value of the size field to parse a binary
     * field, using a parser defined in the tag itself
     *
     * @param {Object} tag to parse, A tag is an object with at least a {number} tag,
     * {boolean} required flag, and a parse function which takes a size parameter
     * @return {boolean} whether or not the tag was found
     * @throws will throw an exception if a required tag is not found,
     * or if the stream is malformed
     * @memberof EBMLParser
     */
    function parseTag(tag) {
        var size = undefined;

        consumeTag(tag);
        size = getMatroskaCodedNum();
        return instance[tag.parse](size);
    }

    /**
     * Consumes an EBML tag from the data stream.   If the tag is found then this
     * function will also remove the size field which follows the tag from the
     * data stream.  It will use the value of the size field to skip over the
     * entire section of EBML encapsulated by the tag.
     *
     * @param {Object} tag to parse, A tag is an object with at least a {number} tag, and
     * {boolean} required flag
     * @param {boolean} test a flag to indicate if an exception should be thrown
     * if a required tag is not found
     * @return {boolean} whether or not the tag was found
     * @throws will throw an exception if a required tag is not found and test is
     * false or undefined or if the stream is malformed
     * @memberof EBMLParser
     */
    function skipOverElement(tag, test) {
        var found = consumeTag(tag, test);
        var headerSize = undefined;

        if (found) {
            headerSize = getMatroskaCodedNum();
            pos += headerSize;
        }

        return found;
    }

    /**
     * Returns and consumes a number encoded according to the Matroska EBML
     * specification from the bitstream.
     *
     * @param {boolean} retainMSB whether or not to retain the Most Significant Bit (the
     * first 1). this is usually true when reading Tag IDs.
     * @return {number} the decoded number
     * @throws will throw an exception if the bit stream is malformed or there is
     * not enough data
     * @memberof EBMLParser
     */
    function getMatroskaCodedNum(retainMSB) {
        var bytesUsed = 1;
        var mask = 0x80;
        var maxBytes = 8;
        var extraBytes = -1;
        var num = 0;
        var ch = data.getUint8(pos);
        var i = undefined;

        for (i = 0; i < maxBytes; i += 1) {
            if ((ch & mask) === mask) {
                num = retainMSB === undefined ? ch & ~mask : ch;
                extraBytes = i;
                break;
            }
            mask >>= 1;
        }

        for (i = 0; i < extraBytes; i += 1, bytesUsed += 1) {
            num = num << 8 | 0xff & data.getUint8(pos + bytesUsed);
        }

        pos += bytesUsed;

        return num;
    }

    /**
     * Returns and consumes a float from the bitstream.
     *
     * @param {number} size 4 or 8 byte floats are supported
     * @return {number} the decoded number
     * @throws will throw an exception if the bit stream is malformed or there is
     * not enough data
     * @memberof EBMLParser
     */
    function getMatroskaFloat(size) {
        var outFloat = undefined;

        switch (size) {
            case 4:
                outFloat = data.getFloat32(pos);
                pos += 4;
                break;
            case 8:
                outFloat = data.getFloat64(pos);
                pos += 8;
                break;
        }
        return outFloat;
    }

    /**
     * Consumes and returns an unsigned int from the bitstream.
     *
     * @param {number} size 1 to 8 bytes
     * @return {number} the decoded number
     * @throws will throw an exception if the bit stream is malformed or there is
     * not enough data
     * @memberof EBMLParser
     */
    function getMatroskaUint(size) {
        var val = 0;
        var i = undefined;

        for (i = 0; i < size; i += 1) {
            val <<= 8;
            val |= data.getUint8(pos + i) & 0xff;
        }

        pos += size;
        return val;
    }

    /**
     * Tests whether there is more data in the bitstream for parsing
     *
     * @return {boolean} whether there is more data to parse
     * @memberof EBMLParser
     */
    function moreData() {
        return pos < data.byteLength;
    }

    instance = {
        getPos: getPos,
        setPos: setPos,
        consumeTag: consumeTag,
        consumeTagAndSize: consumeTagAndSize,
        parseTag: parseTag,
        skipOverElement: skipOverElement,
        getMatroskaCodedNum: getMatroskaCodedNum,
        getMatroskaFloat: getMatroskaFloat,
        getMatroskaUint: getMatroskaUint,
        moreData: moreData
    };

    return instance;
}

EBMLParser.__dashjs_factory_name = 'EBMLParser';
exports['default'] = _coreFactoryMaker2['default'].getClassFactory(EBMLParser);
module.exports = exports['default'];
//# sourceMappingURL=EBMLParser.js.map


/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _voIsoBox = __webpack_require__(1420);

var _voIsoBox2 = _interopRequireDefault(_voIsoBox);

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

function IsoFile() {

    var instance = undefined,
        parsedIsoFile = undefined,
        commonProps = undefined,
        sidxProps = undefined,
        sidxRefProps = undefined,
        emsgProps = undefined,
        mdhdProps = undefined,
        mfhdProps = undefined,
        subsProps = undefined,
        tfhdProps = undefined,
        tfdtProps = undefined,
        trunProps = undefined,
        trunSampleProps = undefined;

    /**
    * @param {string} type
    * @returns {IsoBox|null}
    * @memberof IsoFile#
    */
    function getBox(type) {
        if (!type || !parsedIsoFile || !parsedIsoFile.boxes || parsedIsoFile.boxes.length === 0) return null;

        return convertToDashIsoBox(parsedIsoFile.fetch(type));
    }

    /**
    * @param {string} type
    * @returns {Array} array of {@link IsoBox}
    * @memberof IsoFile#
    */
    function getBoxes(type) {
        var boxData = parsedIsoFile.fetchAll(type);
        var boxes = [];
        var box;

        for (var i = 0, ln = boxData.length; i < ln; i++) {
            box = convertToDashIsoBox(boxData[i]);

            if (box) {
                boxes.push(box);
            }
        }

        return boxes;
    }

    /**
    * @param {string} value
    * @memberof IsoFile#
    */
    function setData(value) {
        parsedIsoFile = value;
    }

    /**
    * @returns {IsoBox|null}
    * @memberof IsoFile#
    */
    function getLastBox() {
        if (!parsedIsoFile || !parsedIsoFile.boxes || !parsedIsoFile.boxes.length) return null;

        var type = parsedIsoFile.boxes[parsedIsoFile.boxes.length - 1].type;
        var boxes = getBoxes(type);

        return boxes[boxes.length - 1];
    }

    /**
    * @returns {number}
    * @memberof IsoFile#
    */
    function getOffset() {
        return parsedIsoFile._cursor.offset;
    }

    function setup() {
        commonProps = {
            offset: '_offset',
            size: 'size',
            type: 'type'
        };

        sidxProps = {
            references: 'references',
            timescale: 'timescale',
            earliest_presentation_time: 'earliest_presentation_time',
            first_offset: 'first_offset'
        };

        sidxRefProps = {
            reference_type: 'reference_type',
            referenced_size: 'referenced_size',
            subsegment_duration: 'subsegment_duration'
        };

        emsgProps = {
            id: 'id',
            value: 'value',
            timescale: 'timescale',
            scheme_id_uri: 'scheme_id_uri',
            presentation_time_delta: 'presentation_time_delta',
            event_duration: 'event_duration',
            message_data: 'message_data'
        };

        mdhdProps = {
            timescale: 'timescale'
        };

        mfhdProps = {
            sequence_number: 'sequence_number'
        };

        subsProps = {
            entry_count: 'entry_count',
            entries: 'entries'
        };

        tfhdProps = {
            base_data_offset: 'base_data_offset',
            sample_description_index: 'sample_description_index',
            default_sample_duration: 'default_sample_duration',
            default_sample_size: 'default_sample_size',
            default_sample_flags: 'default_sample_flags',
            flags: 'flags'
        };

        tfdtProps = {
            version: 'version',
            baseMediaDecodeTime: 'baseMediaDecodeTime',
            flags: 'flags'
        };

        trunProps = {
            sample_count: 'sample_count',
            first_sample_flags: 'first_sample_flags',
            data_offset: 'data_offset',
            flags: 'flags',
            samples: 'samples'
        };

        trunSampleProps = {
            sample_size: 'sample_size',
            sample_duration: 'sample_duration',
            sample_composition_time_offset: 'sample_composition_time_offset'
        };
    }

    function copyProps(from, to, props) {
        for (var prop in props) {
            to[prop] = from[props[prop]];
        }
    }

    function convertToDashIsoBox(boxData) {
        if (!boxData) return null;

        var box = new _voIsoBox2['default']();
        var i, ln;

        copyProps(boxData, box, commonProps);

        if (boxData.hasOwnProperty('_incomplete')) {
            box.isComplete = !boxData._incomplete;
        }

        switch (box.type) {
            case 'sidx':
                copyProps(boxData, box, sidxProps);
                if (box.references) {
                    for (i = 0, ln = box.references.length; i < ln; i++) {
                        copyProps(boxData.references[i], box.references[i], sidxRefProps);
                    }
                }
                break;
            case 'emsg':
                copyProps(boxData, box, emsgProps);
                break;
            case 'mdhd':
                copyProps(boxData, box, mdhdProps);
                break;
            case 'mfhd':
                copyProps(boxData, box, mfhdProps);
                break;
            case 'subs':
                copyProps(boxData, box, subsProps);
                break;
            case 'tfhd':
                copyProps(boxData, box, tfhdProps);
                break;
            case 'tfdt':
                copyProps(boxData, box, tfdtProps);
                break;
            case 'trun':
                copyProps(boxData, box, trunProps);
                if (box.samples) {
                    for (i = 0, ln = box.samples.length; i < ln; i++) {
                        copyProps(boxData.samples[i], box.samples[i], trunSampleProps);
                    }
                }
                break;
        }

        return box;
    }

    instance = {
        getBox: getBox,
        getBoxes: getBoxes,
        setData: setData,
        getLastBox: getLastBox,
        getOffset: getOffset
    };

    setup();

    return instance;
}
IsoFile.__dashjs_factory_name = 'IsoFile';
exports['default'] = _coreFactoryMaker2['default'].getClassFactory(IsoFile);
module.exports = exports['default'];
//# sourceMappingURL=IsoFile.js.map


/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

/**
 * @module ObjectUtils
 * @description Provides utility functions for objects
 */
function ObjectUtils() {

  var instance = undefined;

  /**
   * Returns true if objects resolve to the same string. Only really useful
   * when the user controls the object generation
   * @return {boolean}
   * @param {object} obj1
   * @param {object} obj2
   * @memberof module:ObjectUtils
   * @instance
   */
  function areSimpleEquivalent(obj1, obj2) {
    return JSON.stringify(obj1) === JSON.stringify(obj2);
  }

  instance = {
    areSimpleEquivalent: areSimpleEquivalent
  };

  return instance;
}

ObjectUtils.__dashjs_factory_name = 'ObjectUtils';
exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(ObjectUtils);
module.exports = exports['default'];
//# sourceMappingURL=ObjectUtils.js.map


/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _externalsXml2json = __webpack_require__(393);

var _externalsXml2json2 = _interopRequireDefault(_externalsXml2json);

var _coreDebug = __webpack_require__(30);

var _coreDebug2 = _interopRequireDefault(_coreDebug);

var SECONDS_IN_HOUR = 60 * 60; // Expression of an hour in seconds
var SECONDS_IN_MIN = 60; // Expression of a minute in seconds

function TTMLParser() {

    var context = this.context;
    var log = (0, _coreDebug2['default'])(context).getInstance().log;

    /*
     * This TTML parser follows "EBU-TT-D SUBTITLING DISTRIBUTION FORMAT - tech3380" spec - https://tech.ebu.ch/docs/tech/tech3380.pdf.
     * */
    var instance = undefined,
        timingRegex = undefined,
        ttml = undefined,
        // contains the whole ttml document received
    ttmlStyling = undefined,
        // contains the styling information from the document (from head following EBU-TT-D)
    ttmlLayout = undefined,
        // contains the positioning information from the document (from head following EBU-TT-D)
    fontSize = undefined,
        lineHeight = undefined,
        linePadding = undefined,
        defaultLayoutProperties = undefined,
        defaultStyleProperties = undefined,
        fontFamilies = undefined,
        textAlign = undefined,
        multiRowAlign = undefined,
        wrapOption = undefined,
        unicodeBidi = undefined,
        displayAlign = undefined,
        writingMode = undefined,
        videoModel = undefined,
        converter = undefined;

    var cueCounter = 0; // Used to give every cue a unique ID.

    function setConfig(config) {
        if (!config) return;

        if (config.videoModel) {
            videoModel = config.videoModel;
        }
    }

    /**
     * Get the begin-end interval if present, or null otherwise.
     *
     * @param {Object} element - TTML element which may have begin and end attributes
     */
    function getInterval(element) {
        if (element.hasOwnProperty('begin') && element.hasOwnProperty('end')) {
            var beginTime = parseTimings(element.begin);
            var endTime = parseTimings(element.end);
            return [beginTime, endTime];
        } else {
            return null;
        }
    }

    function getCueID() {
        var id = 'cue_TTML_' + cueCounter;
        cueCounter++;
        return id;
    }

    /*
    * Create list of intervals where spans start and end. Empty list if no times.
    * Clip to interval using startInterval and endInterval and add these two times.
    * Also support case when startInterval/endInteval not given (sideloaded file)
    *
    * @param {Array} spans - array of span elements
    */
    function createSpanIntervalList(spans, startInterval, endInterval) {

        var spanChangeTimes = [];
        var spanChangeTimeStrings = [];
        var cue_intervals = [];

        function addSpanTime(span, name) {
            if (span.hasOwnProperty(name)) {
                var timeString = span[name];
                if (spanChangeTimeStrings.indexOf(timeString) < 0) {
                    spanChangeTimeStrings.push(timeString);
                }
            }
        }

        for (var i = 0; i < spans.length; i++) {
            var span = spans[i];
            addSpanTime(span, 'begin');
            addSpanTime(span, 'end');
        }
        if (spanChangeTimeStrings.length === 0) {
            return cue_intervals; // No span timing so no intervals.
        }

        if (typeof startInterval !== 'undefined' && typeof endInterval !== 'undefined') {
            for (var i = 0; i < spanChangeTimeStrings.length; i++) {
                var changeTime = parseTimings(spanChangeTimeStrings[i]);
                if (startInterval < changeTime && changeTime < endInterval) {
                    spanChangeTimes.push(changeTime);
                }
            }
            spanChangeTimes.push(startInterval);
            spanChangeTimes.push(endInterval);
        } else {
            for (var i = 0; i < spanChangeTimeStrings.length; i++) {
                spanChangeTimes.push(parseTimings(spanChangeTimeStrings[i]));
            }
        }
        spanChangeTimes.sort(function (a, b) {
            return a - b;
        });
        for (var i = 0; i < spanChangeTimes.length - 1; i++) {
            cue_intervals.push([spanChangeTimes[i], spanChangeTimes[i + 1]]);
        }
        return cue_intervals;
    }

    function clipStartTime(startTime, intervalStart) {
        if (typeof intervalStart !== 'undefined') {
            if (startTime < intervalStart) {
                startTime = intervalStart;
            }
        }
        return startTime;
    }

    function clipEndTime(endTime, intervalEnd) {
        if (typeof intervalEnd !== 'undefined') {
            if (endTime > intervalEnd) {
                endTime = intervalEnd;
            }
        }
        return endTime;
    }

    /*
     * Get interval from entity that has begin and end properties.
     * If intervalStart and intervalEnd defined, use them to clip the interval.
     * Return null if no overlap with interval
     */
    function getClippedInterval(entity, intervalStart, intervalEnd) {
        var startTime = parseTimings(entity.begin);
        var endTime = parseTimings(entity.end);
        startTime = clipStartTime(startTime, intervalStart);
        endTime = clipEndTime(endTime, intervalEnd);
        if (typeof intervalStart !== 'undefined' && typeof intervalEnd !== 'undefined') {
            if (endTime < intervalStart || startTime > intervalEnd) {
                log('TTML: Cue ' + startTime + '-' + endTime + ' outside interval ' + intervalStart + '-' + intervalEnd);
                return null;
            }
        }
        return [startTime, endTime];
    }

    /*
     * Check if entity timing has some overlap with interval
     */
    function inIntervalOrNoTiming(entity, interval) {
        var inInterval = true;
        if (entity.hasOwnProperty('span')) {
            var entityInterval = getInterval(entity.span);
            if (entityInterval !== null) {
                //Timing
                inInterval = entityInterval[0] < interval[1] && entityInterval[1] > interval[0];
            }
        }
        return inInterval;
    }

    /**
     * Parse the raw data and process it to return the HTML element representing the cue.
     * Return the region to be processed and controlled (hide/show) by the caption controller.
     * @param {string} data - raw data received from the TextSourceBuffer
     * @param {number} intervalStart
     * @param {number} intervalEnd
     * @param {array} imageArray - images represented as binary strings
     */

    function parse(data, intervalStart, intervalEnd, imageArray) {
        var tt = undefined,
            // Top element
        head = undefined,
            // head in tt
        body = undefined,
            // body in tt
        ttExtent = undefined,
            // extent attribute of tt element
        type = undefined,
            i = undefined;

        var errorMsg = '';

        // Parse the TTML in a JSON object.
        ttml = converter.xml_str2json(data);

        if (!ttml) {
            throw new Error('TTML document could not be parsed');
        }

        if (videoModel.getTTMLRenderingDiv()) {
            type = 'html';
        }

        // Check the document and compare to the specification (TTML and EBU-TT-D).
        tt = ttml.tt;
        if (!tt) {
            throw new Error('TTML document lacks tt element');
        }

        // Get the namespace if there is one defined in the JSON object.
        var ttNS = getNamespacePrefix(tt, 'http://www.w3.org/ns/ttml');

        // Remove the namespace before each node if it exists:
        if (ttNS) {
            removeNamespacePrefix(tt, ttNS);
        }

        ttExtent = tt['tts:extent']; // Should check that tts is right namespace.

        head = tt.head;
        if (!head) {
            throw new Error('TTML document lacks head element');
        }
        if (head.layout) {
            ttmlLayout = head.layout.region_asArray; //Mandatory in EBU-TT-D
        }
        if (head.styling) {
            ttmlStyling = head.styling.style_asArray; // Mandatory in EBU-TT-D
        }

        var imageDataUrls = {};

        if (imageArray) {
            for (i = 0; i < imageArray.length; i++) {
                var key = 'urn:mpeg:14496-30:subs:' + (i + 1).toString();
                var dataUrl = 'data:image/png;base64,' + btoa(imageArray[i]);
                imageDataUrls[key] = dataUrl;
            }
        }

        if (head.metadata) {
            var embeddedImages = head.metadata.image_asArray; // Handle embedded images
            if (embeddedImages) {
                for (i = 0; i < embeddedImages.length; i++) {
                    var key = '#' + embeddedImages[i]['xml:id'];
                    var imageType = embeddedImages[i].imagetype.toLowerCase();
                    var dataUrl = 'data:image/' + imageType + ';base64,' + embeddedImages[i].__text;
                    imageDataUrls[key] = dataUrl;
                }
            }
        }

        body = tt.body;
        if (!body) {
            throw new Error('TTML document lacks body element');
        }

        // Extract the cellResolution information
        var cellResolution = getCellResolution();

        // Recover the video width and height displayed by the player.
        var videoWidth = videoModel.getElement().clientWidth;
        var videoHeight = videoModel.getElement().clientHeight;

        // Compute the CellResolution unit in order to process properties using sizing (fontSize, linePadding, etc).
        var cellUnit = [videoWidth / cellResolution[0], videoHeight / cellResolution[1]];
        defaultStyleProperties['font-size'] = cellUnit[1] + 'px;';

        var regions = [];
        if (ttmlLayout) {
            for (i = 0; i < ttmlLayout.length; i++) {
                regions.push(processRegion(JSON.parse(JSON.stringify(ttmlLayout[i])), cellUnit));
            }
        }

        // Get the namespace prefix.
        var nsttp = getNamespacePrefix(ttml.tt, 'http://www.w3.org/ns/ttml#parameter');

        // Set the framerate.
        if (tt.hasOwnProperty(nsttp + ':frameRate')) {
            tt.frameRate = parseInt(tt[nsttp + ':frameRate'], 10);
        }
        var captionArray = [];
        // Extract the div
        var divs = tt.body_asArray[0].__children;

        // Timing is either on div, paragraph or span level.

        for (var k = 0; k < divs.length; k++) {
            var div = divs[k].div;
            var divInterval = null; // This is mainly for image subtitles.

            if (null !== (divInterval = getInterval(div))) {
                // Timing on div level is not allowed by EBU-TT-D.
                // We only use it for SMPTE-TT image subtitle profile.

                // Layout should be defined by a region. Given early test material, we also support that it is on
                // div level
                var layout = undefined;
                if (div.region) {
                    var region = findRegionFromID(ttmlLayout, div.region);
                    layout = getRelativePositioning(region, ttExtent);
                }
                if (!layout) {
                    layout = getRelativePositioning(div, ttExtent);
                }

                var imgKey = div['smpte:backgroundImage'];
                if (imgKey !== undefined && imageDataUrls[imgKey] !== undefined) {
                    captionArray.push({
                        start: divInterval[0],
                        end: divInterval[1],
                        id: getCueID(),
                        data: imageDataUrls[imgKey],
                        type: 'image',
                        layout: layout
                    });
                }
                continue; // Next div
            }

            var paragraphs = div.p_asArray;
            // Check if cues is not empty or undefined.
            if (divInterval === null && (!paragraphs || paragraphs.length === 0)) {
                errorMsg = 'TTML has div that contains no timing and no paragraphs.';
                log(errorMsg);
                return captionArray;
            }

            for (var j2 = 0; j2 < paragraphs.length; j2++) {
                var paragraph = paragraphs[j2];
                var spans = paragraph.span_asArray;
                var cueIntervals = [];
                // For timing, the overall goal is to find the intervals where there should be cues
                // The timing may either be on paragraph or span level.
                if (paragraph.hasOwnProperty('begin') && paragraph.hasOwnProperty('end')) {
                    // Timing on paragraph level
                    var clippedInterval = getClippedInterval(paragraph, intervalStart, intervalEnd);
                    if (clippedInterval !== null) {
                        cueIntervals.push(clippedInterval);
                    }
                } else {
                    // Timing must be on span level
                    cueIntervals = createSpanIntervalList(spans, intervalStart, intervalEnd);
                }
                if (cueIntervals.length === 0) {
                    errorMsg = 'TTML: Empty paragraph';
                    continue; // Nothing in this paragraph
                }

                var paragraphChildren = paragraph.__children;

                for (var i2 = 0; i2 < cueIntervals.length; i2++) {
                    var interval = cueIntervals[i2];
                    var childrenInInterval = [];
                    for (var k2 = 0; k2 < paragraphChildren.length; k2++) {
                        var child = paragraphChildren[k2];
                        if (inIntervalOrNoTiming(child, interval)) {
                            childrenInInterval.push(child);
                        }
                    }
                    if (childrenInInterval.length === 0) {
                        continue; // No children to render
                    }

                    if (type === 'html') {
                        lineHeight = {};
                        linePadding = {};
                        fontSize = {};

                        /**
                         * Find the region defined for the cue.
                         */
                        // properties to be put in the "captionRegion" HTML element.
                        var cueRegionProperties = constructCueRegion(paragraph, div, cellUnit);

                        /**
                         * Find the style defined for the cue.
                         */
                        // properties to be put in the "paragraph" HTML element.
                        var cueStyleProperties = constructCueStyle(paragraph, cellUnit);

                        /**
                         * /!\ Create the cue HTML Element containing the whole cue.
                         */
                        var styleIDs = cueStyleProperties[1];
                        cueStyleProperties = cueStyleProperties[0];

                        // Final cue HTML element.
                        var cueParagraph = document.createElement('div');
                        cueParagraph.className = styleIDs;

                        // Create a wrapper containing the cue information about unicodeBidi and direction
                        // as they need to be defined on at this level.
                        // We append to the wrapper the cue itself.
                        var cueDirUniWrapper = constructCue(childrenInInterval, cellUnit);
                        cueDirUniWrapper.className = 'cueDirUniWrapper';

                        // If the style defines these two properties, we place them in cueContainer
                        // and delete them from the cue style so it is not added afterwards to the final cue.
                        if (arrayContains('unicode-bidi', cueStyleProperties)) {
                            cueDirUniWrapper.style.cssText += getPropertyFromArray('unicode-bidi', cueStyleProperties);
                            deletePropertyFromArray('unicode-bidi', cueStyleProperties);
                        }
                        if (arrayContains('direction', cueStyleProperties)) {
                            cueDirUniWrapper.style.cssText += getPropertyFromArray('direction', cueStyleProperties);
                            deletePropertyFromArray('direction', cueStyleProperties);
                        }

                        // Apply the linePadding property if it is specified in the cue style.
                        if (arrayContains('padding-left', cueStyleProperties) && arrayContains('padding-right', cueStyleProperties)) {
                            cueDirUniWrapper.innerHTML = applyLinePadding(cueDirUniWrapper, cueStyleProperties);
                        }

                        /**
                         * Clean and set the style and region for the cue to be returned.
                         */

                        // Remove the line padding property from being added at the "paragraph" element level.
                        if (arrayContains('padding-left', cueStyleProperties) && arrayContains('padding-right', cueStyleProperties)) {
                            deletePropertyFromArray('padding-left', cueStyleProperties);
                            deletePropertyFromArray('padding-right', cueStyleProperties);
                        }

                        // Remove the ID of the region from being added at the "paragraph" element level.
                        var regionID = '';
                        if (arrayContains('regionID', cueRegionProperties)) {
                            var wholeRegionID = getPropertyFromArray('regionID', cueRegionProperties);
                            regionID = wholeRegionID.slice(wholeRegionID.indexOf(':') + 1, wholeRegionID.length - 1);
                        }

                        // We link the p style to the finale cueParagraph element.
                        if (cueStyleProperties) {
                            cueParagraph.style.cssText = cueStyleProperties.join(' ') + 'display:flex;';
                        }
                        // We define the CSS style for the cue region.
                        if (cueRegionProperties) {
                            cueRegionProperties = cueRegionProperties.join(' ');
                        }

                        // We then place the cue wrapper inside the paragraph element.
                        cueParagraph.appendChild(cueDirUniWrapper);

                        // Final cue.
                        var finalCue = document.createElement('div');
                        finalCue.appendChild(cueParagraph);
                        finalCue.id = getCueID();
                        finalCue.style.cssText = 'position: absolute; margin: 0; display: flex; box-sizing: border-box; pointer-events: none;' + cueRegionProperties;

                        if (Object.keys(fontSize).length === 0) {
                            fontSize.defaultFontSize = '100';
                        }

                        // We add all the cue information in captionArray.
                        captionArray.push({
                            start: interval[0],
                            end: interval[1],
                            type: 'html',
                            cueHTMLElement: finalCue,
                            regions: regions,
                            regionID: regionID,
                            cueID: finalCue.id,
                            videoHeight: videoHeight,
                            videoWidth: videoWidth,
                            cellResolution: cellResolution,
                            fontSize: fontSize || {
                                defaultFontSize: '100'
                            },
                            lineHeight: lineHeight,
                            linePadding: linePadding
                        });
                    } else {
                        var text = '';
                        var textElements = childrenInInterval;
                        if (textElements.length) {
                            textElements.forEach(function (el) {
                                if (el.hasOwnProperty('span')) {
                                    var spanElements = el.span.__children;
                                    spanElements.forEach(function (spanEl) {
                                        // If metadata is present, do not process.
                                        if (spanElements.hasOwnProperty('metadata')) {
                                            return;
                                        }
                                        // If the element is a string
                                        if (spanEl.hasOwnProperty('#text')) {
                                            text += spanEl['#text'].replace(/[\r\n]+/gm, ' ').trim();
                                            // If the element is a 'br' tag
                                        } else if ('br' in spanEl) {
                                                // Create a br element.
                                                text += '\n';
                                            }
                                    });
                                } else if (el.hasOwnProperty('br')) {
                                    text += '\n';
                                } else {
                                    text += el['#text'].replace(/[\r\n]+/gm, ' ').trim();
                                }
                            });
                        }

                        captionArray.push({
                            start: interval[0],
                            end: interval[1],
                            data: text,
                            type: 'text'
                        });
                    }
                }
            }
        }

        if (errorMsg !== '') {
            log(errorMsg);
        }

        if (captionArray.length > 0) {
            return captionArray;
        } else {
            // This seems too strong given that there are segments with no TTML subtitles
            throw new Error(errorMsg);
        }
    }

    function setup() {
        /*
         * This TTML parser follows "EBU-TT-D SUBTITLING DISTRIBUTION FORMAT - tech3380" spec - https://tech.ebu.ch/docs/tech/tech3380.pdf.
         * */
        timingRegex = /^([0-9][0-9]+):([0-5][0-9]):([0-5][0-9])|(60)(\.([0-9])+)?$/; // Regex defining the time
        fontSize = {};
        lineHeight = {};
        linePadding = {};
        defaultLayoutProperties = {
            'top': 'auto;',
            'left': 'auto;',
            'width': '90%;',
            'height': '10%;',
            'align-items': 'flex-start;',
            'overflow': 'visible;',
            '-ms-writing-mode': 'lr-tb, horizontal-tb;',
            '-webkit-writing-mode': 'horizontal-tb;',
            '-moz-writing-mode': 'horizontal-tb;',
            'writing-mode': 'horizontal-tb;'
        };
        defaultStyleProperties = {
            'color': 'rgb(255,255,255);',
            'direction': 'ltr;',
            'font-family': 'monospace, sans-serif;',
            'font-style': 'normal;',
            'line-height': 'normal;',
            'font-weight': 'normal;',
            'text-align': 'start;',
            'justify-content': 'flex-start;',
            'text-decoration': 'none;',
            'unicode-bidi': 'normal;',
            'white-space': 'normal;',
            'width': '100%;'
        };
        fontFamilies = {
            monospace: 'font-family: monospace;',
            sansSerif: 'font-family: sans-serif;',
            serif: 'font-family: serif;',
            monospaceSansSerif: 'font-family: monospace, sans-serif;',
            monospaceSerif: 'font-family: monospace, serif;',
            proportionalSansSerif: 'font-family: Arial;',
            proportionalSerif: 'font-family: Times New Roman;',
            'default': 'font-family: monospace, sans-serif;'
        };
        textAlign = {
            right: ['justify-content: flex-end;', 'text-align: right;'],
            start: ['justify-content: flex-start;', 'text-align: start;'],
            center: ['justify-content: center;', 'text-align: center;'],
            end: ['justify-content: flex-end;', 'text-align: end;'],
            left: ['justify-content: flex-start;', 'text-align: left;']
        };
        multiRowAlign = {
            start: 'text-align: start;',
            center: 'text-align: center;',
            end: 'text-align: end;',
            auto: ''
        };
        wrapOption = {
            wrap: 'white-space: normal;',
            noWrap: 'white-space: nowrap;'
        };
        unicodeBidi = {
            normal: 'unicode-bidi: normal;',
            embed: 'unicode-bidi: embed;',
            bidiOverride: 'unicode-bidi: bidi-override;'
        };
        displayAlign = {
            before: 'align-items: flex-start;',
            center: 'align-items: center;',
            after: 'align-items: flex-end;'
        };
        writingMode = {
            lrtb: '-webkit-writing-mode: horizontal-tb;' + 'writing-mode: horizontal-tb;',
            rltb: '-webkit-writing-mode: horizontal-tb;' + 'writing-mode: horizontal-tb;' + 'direction: rtl;' + 'unicode-bidi: bidi-override;',
            tbrl: '-webkit-writing-mode: vertical-rl;' + 'writing-mode: vertical-rl;' + '-webkit-text-orientation: upright;' + 'text-orientation: upright;',
            tblr: '-webkit-writing-mode: vertical-lr;' + 'writing-mode: vertical-lr;' + '-webkit-text-orientation: upright;' + 'text-orientation: upright;',
            lr: '-webkit-writing-mode: horizontal-tb;' + 'writing-mode: horizontal-tb;',
            rl: '-webkit-writing-mode: horizontal-tb;' + 'writing-mode: horizontal-tb;' + 'direction: rtl;',
            tb: '-webkit-writing-mode: vertical-rl;' + 'writing-mode: vertical-rl;' + '-webkit-text-orientation: upright;' + 'text-orientation: upright;'
        };
        converter = new _externalsXml2json2['default']({
            escapeMode: false,
            attributePrefix: '',
            arrayAccessForm: 'property',
            emptyNodeForm: 'object',
            stripWhitespaces: false,
            enableToStringFunc: false,
            matchers: []
        });
    }

    function parseTimings(timingStr) {
        // Test if the time provided by the caption is valid.
        var test = timingRegex.test(timingStr);
        var timeParts, parsedTime, frameRate;

        if (!test) {
            // Return NaN so it will throw an exception at internalParse if the time is incorrect.
            return NaN;
        }

        timeParts = timingStr.split(':');

        // Process the timings by decomposing it and converting it in numbers.
        parsedTime = parseFloat(timeParts[0]) * SECONDS_IN_HOUR + parseFloat(timeParts[1]) * SECONDS_IN_MIN + parseFloat(timeParts[2]);

        // In case a frameRate is provided, we adjust the parsed time.
        if (timeParts[3]) {
            frameRate = ttml.tt.frameRate;
            if (frameRate && !isNaN(frameRate)) {
                parsedTime += parseFloat(timeParts[3]) / frameRate;
            } else {
                return NaN;
            }
        }
        return parsedTime;
    }

    function getNamespacePrefix(json, ns) {
        // Obtain the namespace prefix.
        var r = Object.keys(json).filter(function (k) {
            return (k.split(':')[0] === 'xmlns' || k.split(':')[1] === 'xmlns') && json[k] === ns;
        }).map(function (k) {
            return k.split(':')[2] || k.split(':')[1];
        });
        if (r.length != 1) {
            return null;
        }
        return r[0];
    }

    function removeNamespacePrefix(json, nsPrefix) {
        for (var key in json) {
            if (json.hasOwnProperty(key)) {
                if ((typeof json[key] === 'object' || json[key] instanceof Object) && !Array.isArray(json[key])) {
                    removeNamespacePrefix(json[key], nsPrefix);
                } else if (Array.isArray(json[key])) {
                    for (var i = 0; i < json[key].length; i++) {
                        removeNamespacePrefix(json[key][i], nsPrefix);
                    }
                }
                var fullNsPrefix = nsPrefix + ':';
                var nsPrefixPos = key.indexOf(fullNsPrefix);
                if (nsPrefixPos >= 0) {
                    var newKey = key.slice(nsPrefixPos + fullNsPrefix.length);
                    json[newKey] = json[key];
                    delete json[key];
                }
            }
        }
    }

    // backgroundColor = background-color, convert from camelCase to dash.
    function camelCaseToDash(key) {
        return key.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
    }

    // Convert an RGBA value written in Hex to rgba(v,v,v,a).
    function convertHexToRGBA(rgba) {
        // Get the hexadecimal value without the #.
        var hex = rgba.slice(1);
        // Separate the values in pairs.
        var hexMatrice = hex.match(/.{2}/g);
        // Convert the alpha value in decimal between 0 and 1.
        var alpha = parseFloat(parseInt(parseInt(hexMatrice[3], 16) / 255 * 1000, 10) / 1000);
        // Get the standard RGB value.
        var rgb = hexMatrice.slice(0, 3).map(function (i) {
            return parseInt(i, 16);
        });
        // Return the RGBA value for CSS.
        return 'rgba(' + rgb.join(',') + ',' + alpha + ');';
    }

    // Convert an RGBA value written in TTML rgba(v,v,v,a => 0 to 255) to CSS rgba(v,v,v,a => 0 to 1).
    function convertAlphaValue(rgbaTTML) {
        var rgba = undefined,
            alpha = undefined,
            resu = undefined;

        rgba = rgbaTTML.replace(/^(rgb|rgba)\(/, '').replace(/\)$/, '').replace(/\s/g, '').split(',');
        alpha = parseInt(rgba[rgba.length - 1], 10) / 255;
        resu = 'rgba(' + rgba[0] + ',' + rgba[1] + ',' + rgba[2] + ',' + alpha + ');';

        return resu;
    }

    // Return whether or not an array contains a certain text
    function arrayContains(text, array) {
        for (var i = 0; i < array.length; i++) {
            if (array[i].indexOf(text) > -1) {
                return true;
            }
        }
        return false;
    }

    // Return the whole value that contains "text"
    function getPropertyFromArray(text, array) {
        for (var i = 0; i < array.length; i++) {
            if (array[i].indexOf(text) > -1) {
                return array[i];
            }
        }
        return null;
    }

    // Delete a a property from an array.
    function deletePropertyFromArray(property, array) {
        array.splice(array.indexOf(getPropertyFromArray(property, array)), 1);
    }

    function mergeArrays(primeArray, arrayToAdd) {
        for (var i = 0; i < primeArray.length; i++) {
            for (var j = 0; j < arrayToAdd.length; j++) {
                // Take only the name of the property
                if (primeArray[i]) {
                    if (primeArray[i].split(':')[0].indexOf(arrayToAdd[j].split(':')[0]) > -1) {
                        primeArray.splice(i, 1);
                    }
                }
            }
        }
        return primeArray.concat(arrayToAdd);
    }

    function getSizeTypeAndDefinition(cueStyleElement) {
        var returnTab = new Array(2);
        var startRef = cueStyleElement.indexOf(':') === -1 ? 0 : cueStyleElement.indexOf(':');
        var endRef = undefined;
        if (cueStyleElement.indexOf('%') === -1) {
            if (cueStyleElement.indexOf('c') === -1) {
                if (cueStyleElement.indexOf('p') === -1) {
                    returnTab[0] = returnTab[1] = null;
                } else {
                    returnTab[0] = 'p';
                    endRef = cueStyleElement.indexOf('p');
                }
            } else {
                returnTab[0] = 'c';
                endRef = cueStyleElement.indexOf('c');
            }
        } else {
            returnTab[0] = '%';
            endRef = cueStyleElement.indexOf('%');
        }
        returnTab[1] = cueStyleElement.slice(startRef, endRef);
        return returnTab;
    }

    /**
     * Processing of styling information:
     * - processStyle: return an array of strings with the cue style under a CSS style form.
     * - findStyleFromID: Return the unprocessed style from TTMLStyling corresponding to the ID researched.
     * - getProcessedStyle: Return the processed style(s) from the ID(s) received in entry.
     * **/

    // Compute the style properties to return an array with the cleaned properties.
    function processStyle(cueStyle, cellUnit, includeRegionStyles) {
        var properties = [];
        var valueFtSizeInPx, valueLHSizeInPx;

        // Clean up from the xml2json parsing:
        for (var key in cueStyle) {
            if (cueStyle.hasOwnProperty(key)) {
                //Clean the properties from the parsing.
                var newKey = key.replace('ebutts:', '');
                newKey = newKey.replace('xml:', '');
                newKey = newKey.replace('tts:', '');

                // Clean the properties' names.
                newKey = camelCaseToDash(newKey);
                cueStyle[newKey] = cueStyle[key];
                delete cueStyle[key];
            }
        }

        // Line padding is computed from the cellResolution.
        if ('line-padding' in cueStyle) {
            var valuePadding = parseFloat(cueStyle['line-padding'].slice(cueStyle['line-padding'].indexOf(':') + 1, cueStyle['line-padding'].indexOf('c')));
            if ('id' in cueStyle) {
                linePadding[cueStyle.id] = valuePadding;
            }
            var valuePaddingInPx = valuePadding * cellUnit[0] + 'px;';
            properties.push('padding-left:' + valuePaddingInPx);
            properties.push('padding-right:' + valuePaddingInPx);
        }
        // Font size is computed from the cellResolution.
        if ('font-size' in cueStyle) {
            var fontSizeTab = getSizeTypeAndDefinition(cueStyle['font-size']);
            var valueFtSize = parseFloat(fontSizeTab[1]);
            if ('id' in cueStyle) {
                fontSize[cueStyle.id] = fontSizeTab;
            }

            if (fontSizeTab[0] === '%') {
                valueFtSizeInPx = valueFtSize / 100 * cellUnit[1] + 'px;';
            } else if (fontSizeTab[0] === 'c') {
                valueFtSizeInPx = valueFtSize * cellUnit[1] + 'px;';
            }

            properties.push('font-size:' + valueFtSizeInPx);
        }
        // Line height is computed from the cellResolution.
        if ('line-height' in cueStyle) {
            if (cueStyle['line-height'] === 'normal') {
                properties.push('line-height: normal;');
            } else {
                var LineHeightTab = getSizeTypeAndDefinition(cueStyle['line-height']);
                var valueLHSize = parseFloat(LineHeightTab[1]);
                if ('id' in cueStyle) {
                    lineHeight[cueStyle.id] = LineHeightTab;
                }

                if (LineHeightTab[0] === '%') {
                    valueLHSizeInPx = valueLHSize / 100 * cellUnit[1] + 'px;';
                } else if (LineHeightTab[0] === 'c') {
                    valueLHSizeInPx = valueLHSize * cellUnit[1] + 'px;';
                }

                properties.push('line-height:' + valueLHSizeInPx);
            }
        }
        // Font-family can be specified by a generic family name or a custom family name.
        if ('font-family' in cueStyle) {
            if (cueStyle['font-family'] in fontFamilies) {
                properties.push(fontFamilies[cueStyle['font-family']]);
            } else {
                properties.push('font-family:' + cueStyle['font-family'] + ';');
            }
        }
        // Text align needs to be set from two properties:
        // The standard text-align CSS property.
        // The justify-content property as we use flex boxes.
        if ('text-align' in cueStyle) {
            if (cueStyle['text-align'] in textAlign) {
                properties.push(textAlign[cueStyle['text-align']][0]);
                properties.push(textAlign[cueStyle['text-align']][1]);
            }
        }
        // Multi Row align is set only by the text-align property.
        // TODO: TO CHECK
        if ('multi-row-align' in cueStyle) {
            if (arrayContains('text-align', properties) && cueStyle['multi-row-align'] != 'auto') {
                deletePropertyFromArray('text-align', properties);
            }
            if (cueStyle['multi-row-align'] in multiRowAlign) {
                properties.push(multiRowAlign[cueStyle['multi-row-align']]);
            }
        }
        // Background color can be specified from hexadecimal (RGB or RGBA) value.
        var rgbaValue;
        if ('background-color' in cueStyle) {
            if (cueStyle['background-color'].indexOf('#') > -1 && cueStyle['background-color'].length - 1 === 8) {
                rgbaValue = convertHexToRGBA(cueStyle['background-color']);
            } else if (cueStyle['background-color'].indexOf('rgba') > -1) {
                rgbaValue = convertAlphaValue(cueStyle['background-color']);
            } else {
                rgbaValue = cueStyle['background-color'] + ';';
            }
            properties.push('background-color: ' + rgbaValue);
        }
        // Color can be specified from hexadecimal (RGB or RGBA) value.
        if ('color' in cueStyle) {
            if (cueStyle.color.indexOf('#') > -1 && cueStyle.color.length - 1 === 8) {
                rgbaValue = convertHexToRGBA(cueStyle.color);
            } else if (cueStyle.color.indexOf('rgba') > -1) {
                rgbaValue = convertAlphaValue(cueStyle.color);
            } else {
                rgbaValue = cueStyle.color + ';';
            }
            properties.push('color: ' + rgbaValue);
        }
        // Wrap option is determined by the white-space CSS property.
        if ('wrap-option' in cueStyle) {
            if (cueStyle['wrap-option'] in wrapOption) {
                properties.push(wrapOption[cueStyle['wrap-option']]);
            } else {
                properties.push('white-space:' + cueStyle['wrap-option']);
            }
        }
        // Unicode bidi is determined by the unicode-bidi CSS property.
        if ('unicode-bidi' in cueStyle) {
            if (cueStyle['unicode-bidi'] in unicodeBidi) {
                properties.push(unicodeBidi[cueStyle['unicode-bidi']]);
            } else {
                properties.push('unicode-bidi:' + cueStyle['unicode-bidi']);
            }
        }

        // Standard properties identical to CSS.

        if ('font-style' in cueStyle) {
            properties.push('font-style:' + cueStyle['font-style'] + ';');
        }
        if ('font-weight' in cueStyle) {
            properties.push('font-weight:' + cueStyle['font-weight'] + ';');
        }
        if ('direction' in cueStyle) {
            properties.push('direction:' + cueStyle.direction + ';');
        }
        if ('text-decoration' in cueStyle) {
            properties.push('text-decoration:' + cueStyle['text-decoration'] + ';');
        }

        if (includeRegionStyles) {
            properties = properties.concat(processRegion(cueStyle, cellUnit));
        }

        // Handle white-space preserve
        if (ttml.tt.hasOwnProperty('xml:space')) {
            if (ttml.tt['xml:space'] === 'preserve') {
                properties.push('white-space: pre;');
            }
        }

        return properties;
    }

    // Find the style set by comparing the style IDs available.
    // Return null if no style is found
    function findStyleFromID(ttmlStyling, cueStyleID) {
        // For every styles available, search the corresponding style in ttmlStyling.
        for (var j = 0; j < ttmlStyling.length; j++) {
            var currStyle = ttmlStyling[j];
            if (currStyle['xml:id'] === cueStyleID || currStyle.id === cueStyleID) {
                // Return the style corresponding to the ID in parameter.
                return currStyle;
            }
        }
        return null;
    }
    // Return the computed style from a certain ID.
    function getProcessedStyle(reference, cellUnit, includeRegionStyles) {
        var styles = [];
        var ids = reference.match(/\S+/g);
        ids.forEach(function (id) {
            // Find the style for each id received.
            var cueStyle = findStyleFromID(ttmlStyling, id);
            if (cueStyle) {
                // Process the style for the cue in CSS form.
                // Send a copy of the style object, so it does not modify the original by cleaning it.
                var stylesFromId = processStyle(JSON.parse(JSON.stringify(cueStyle)), cellUnit, includeRegionStyles);
                styles = styles.concat(stylesFromId);
            }
        });
        return styles;
    }

    // Calculate relative left, top, width, height from extent and origin in percent.
    // Return object with {left, top, width, height} as numbers in percent or null.
    function getRelativePositioning(element, ttExtent) {

        var pairRe = /([\d\.]+)(%|px)\s+([\d\.]+)(%|px)/;

        if ('tts:extent' in element && 'tts:origin' in element) {
            var extentParts = pairRe.exec(element['tts:extent']);
            var originParts = pairRe.exec(element['tts:origin']);
            if (extentParts === null || originParts === null) {
                log('Bad extent or origin: ' + element['tts:extent'] + ' ' + element['tts:origin']);
                return null;
            }
            var width = parseFloat(extentParts[1]);
            var height = parseFloat(extentParts[3]);
            var left = parseFloat(originParts[1]);
            var _top = parseFloat(originParts[3]);

            if (ttExtent) {
                // Should give overall scale in pixels
                var ttExtentParts = pairRe.exec(ttExtent);
                if (ttExtentParts === null || ttExtentParts[2] !== 'px' || ttExtentParts[4] !== 'px') {
                    log('Bad tt.extent: ' + ttExtent);
                    return null;
                }
                var exWidth = parseFloat(ttExtentParts[1]);
                var exHeight = parseFloat(ttExtentParts[3]);
                if (extentParts[2] === 'px') {
                    width = width / exWidth * 100;
                }
                if (extentParts[4] === 'px') {
                    height = height / exHeight * 100;
                }
                if (originParts[2] === 'px') {
                    left = left / exWidth * 100;
                }
                if (originParts[4] === 'px') {
                    _top = _top / exHeight * 100;
                }
            }
            return { 'left': left, 'top': _top, 'width': width, 'height': height };
        } else {
            return null;
        }
    }

    /**
     * Processing of layout information:
     * - processRegion: return an array of strings with the cue region under a CSS style form.
     * - findRegionFromID: Return the unprocessed region from TTMLLayout corresponding to the ID researched.
     * - getProcessedRegion: Return the processed region(s) from the ID(s) received in entry.
     ***/

    // Compute the region properties to return an array with the cleaned properties.
    function processRegion(cueRegion, cellUnit) {
        var properties = [];

        // Clean up from the xml2json parsing:
        for (var key in cueRegion) {
            //Clean the properties from the parsing.
            var newKey = key.replace('tts:', '');
            newKey = newKey.replace('xml:', '');

            // Clean the properties' names.
            newKey = camelCaseToDash(newKey);
            cueRegion[newKey] = cueRegion[key];
            if (newKey !== key) {
                delete cueRegion[key];
            }
        }
        // Extent property corresponds to width and height
        if ('extent' in cueRegion) {
            var coordsExtent = cueRegion.extent.split(/\s/);
            properties.push('width: ' + coordsExtent[0] + ';');
            properties.push('height: ' + coordsExtent[1] + ';');
        }
        // Origin property corresponds to top and left
        if ('origin' in cueRegion) {
            var coordsOrigin = cueRegion.origin.split(/\s/);
            properties.push('left: ' + coordsOrigin[0] + ';');
            properties.push('top: ' + coordsOrigin[1] + ';');
        }
        // DisplayAlign property corresponds to vertical-align
        if ('display-align' in cueRegion) {
            properties.push(displayAlign[cueRegion['display-align']]);
        }
        // WritingMode is not yet implemented (for CSS3, to come)
        if ('writing-mode' in cueRegion) {
            properties.push(writingMode[cueRegion['writing-mode']]);
        }
        // Style will give to the region the style properties from the style selected
        if ('style' in cueRegion) {
            var styleFromID = getProcessedStyle(cueRegion.style, cellUnit, true);
            properties = properties.concat(styleFromID);
        }

        // Standard properties identical to CSS.

        if ('padding' in cueRegion) {
            properties.push('padding:' + cueRegion.padding + ';');
        }
        if ('overflow' in cueRegion) {
            properties.push('overflow:' + cueRegion.overflow + ';');
        }
        if ('show-background' in cueRegion) {
            properties.push('show-background:' + cueRegion['show-background'] + ';');
        }
        if ('id' in cueRegion) {
            properties.push('regionID:' + cueRegion.id + ';');
        }

        return properties;
    }

    // Find the region set by comparing the region IDs available.
    // Return null if no region is found
    function findRegionFromID(ttmlLayout, cueRegionID) {
        // For every region available, search the corresponding style in ttmlLayout.
        for (var j = 0; j < ttmlLayout.length; j++) {
            var currReg = ttmlLayout[j];
            if (currReg['xml:id'] === cueRegionID || currReg.id === cueRegionID) {
                // Return the region corresponding to the ID in parameter.
                return currReg;
            }
        }
        return null;
    }

    // Return the computed region from a certain ID.
    function getProcessedRegion(reference, cellUnit) {
        var regions = [];
        var ids = reference.match(/\S+/g);
        ids.forEach(function (id) {
            // Find the region for each id received.
            var cueRegion = findRegionFromID(ttmlLayout, id);
            if (cueRegion) {
                // Process the region for the cue in CSS form.
                // Send a copy of the style object, so it does not modify the original by cleaning it.
                var regionsFromId = processRegion(JSON.parse(JSON.stringify(cueRegion)), cellUnit);
                regions = regions.concat(regionsFromId);
            }
        });
        return regions;
    }

    //Return the cellResolution defined by the TTML document.
    function getCellResolution() {
        var defaultCellResolution = [32, 15]; // Default cellResolution.
        if (ttml.tt.hasOwnProperty('ttp:cellResolution')) {
            return ttml.tt['ttp:cellResolution'].split(' ').map(parseFloat);
        } else {
            return defaultCellResolution;
        }
    }

    // Return the cue wrapped into a span specifying its linePadding.
    function applyLinePadding(cueHTML, cueStyle) {
        // Extract the linePadding property from cueStyleProperties.
        var linePaddingLeft = getPropertyFromArray('padding-left', cueStyle);
        var linePaddingRight = getPropertyFromArray('padding-right', cueStyle);
        var linePadding = linePaddingLeft.concat(' ' + linePaddingRight + ' ');

        // Declaration of the HTML elements to be used in the cue innerHTML construction.
        var outerHTMLBeforeBr = '';
        var outerHTMLAfterBr = '';
        var cueInnerHTML = '';

        // List all the nodes of the subtitle.
        var nodeList = Array.prototype.slice.call(cueHTML.children);
        // Take a br element as reference.
        var brElement = cueHTML.getElementsByClassName('lineBreak')[0];
        // First index of the first br element.
        var idx = nodeList.indexOf(brElement);
        // array of all the br element indices
        var indices = [];
        // Find all the indices of the br elements.
        while (idx != -1) {
            indices.push(idx);
            idx = nodeList.indexOf(brElement, idx + 1);
        }

        // Strings for the cue innerHTML construction.
        var spanStringEnd = '<\/span>';
        var br = '<br>';
        var clonePropertyString = '<span' + ' class="spanPadding" ' + 'style="-webkit-box-decoration-break: clone; box-decoration-break: clone; ';

        // If br elements are found:
        if (indices.length) {
            // For each index of a br element we compute the HTML coming before and/or after it.
            indices.forEach(function (i, index) {
                // If this is the first line break, we compute the HTML of the element coming before.
                if (index === 0) {
                    var styleBefore = '';
                    // for each element coming before the line break, we add its HTML.
                    for (var j = 0; j < i; j++) {
                        outerHTMLBeforeBr += nodeList[j].outerHTML;
                        // If this is the first element, we add its style to the wrapper.
                        if (j === 0) {
                            styleBefore = linePadding.concat(nodeList[j].style.cssText);
                        }
                    }
                    // The before element will comprises the clone property (for line wrapping), the style that
                    // need to be applied (ex: background-color) and the rest og the HTML.
                    outerHTMLBeforeBr = clonePropertyString + styleBefore + '">' + outerHTMLBeforeBr;
                }
                // For every element of the list, we compute the element coming after the line break.s
                var styleAfter = '';
                // for each element coming after the line break, we add its HTML.
                for (var k = i + 1; k < nodeList.length; k++) {
                    outerHTMLAfterBr += nodeList[k].outerHTML;
                    // If this is the last element, we add its style to the wrapper.
                    if (k === nodeList.length - 1) {
                        styleAfter += linePadding.concat(nodeList[k].style.cssText);
                    }
                }

                // The before element will comprises the clone property (for line wrapping), the style that
                // need to be applied (ex: background-color) and the rest og the HTML.
                outerHTMLAfterBr = clonePropertyString + styleAfter + '">' + outerHTMLAfterBr;

                // For each line break we must add the before and/or after element to the final cue as well as
                // the line break when needed.
                if (outerHTMLBeforeBr && outerHTMLAfterBr && index === indices.length - 1) {
                    cueInnerHTML += outerHTMLBeforeBr + spanStringEnd + br + outerHTMLAfterBr + spanStringEnd;
                } else if (outerHTMLBeforeBr && outerHTMLAfterBr && index !== indices.length - 1) {
                    cueInnerHTML += outerHTMLBeforeBr + spanStringEnd + br + outerHTMLAfterBr + spanStringEnd + br;
                } else if (outerHTMLBeforeBr && !outerHTMLAfterBr) {
                    cueInnerHTML += outerHTMLBeforeBr + spanStringEnd;
                } else if (!outerHTMLBeforeBr && outerHTMLAfterBr && index === indices.length - 1) {
                    cueInnerHTML += outerHTMLAfterBr + spanStringEnd;
                } else if (!outerHTMLBeforeBr && outerHTMLAfterBr && index !== indices.length - 1) {
                    cueInnerHTML += outerHTMLAfterBr + spanStringEnd + br;
                }
            });
        } else {
            // If there is no line break in the subtitle, we simply wrap cue in a span indicating the linePadding.
            var style = '';
            for (var k = 0; k < nodeList.length; k++) {
                style += nodeList[k].style.cssText;
            }
            cueInnerHTML = clonePropertyString + linePadding + style + '">' + cueHTML.innerHTML + spanStringEnd;
        }
        return cueInnerHTML;
    }

    /*
    * Create the cue element
     * I. The cues are text only:
     *      i) The cue contains a 'br' element
     *      ii) The cue contains a span element
     *      iii) The cue contains text
     */

    function constructCue(cueElements, cellUnit) {
        var cue = document.createElement('div');
        cueElements.forEach(function (el) {
            // If metadata is present, do not process.
            if (el.hasOwnProperty('metadata')) {
                return;
            }

            /**
             * If the p element contains spans: create the span elements.
             */
            if (el.hasOwnProperty('span')) {

                // Stock the span subtitles in an array (in case there are only one value).
                var spanElements = el.span.__children;

                // Create the span element.
                var spanHTMLElement = document.createElement('span');
                // Extract the style of the span.
                if (el.span.hasOwnProperty('style')) {
                    var spanStyle = getProcessedStyle(el.span.style, cellUnit);
                    spanHTMLElement.className = 'spanPadding ' + el.span.style;
                    spanHTMLElement.style.cssText = spanStyle.join(' ');
                }

                // if the span has more than one element, we check for each of them their nature (br or text).
                spanElements.forEach(function (spanEl) {
                    // If metadata is present, do not process.
                    if (spanElements.hasOwnProperty('metadata')) {
                        return;
                    }
                    // If the element is a string
                    if (spanEl.hasOwnProperty('#text')) {
                        var textNode = document.createTextNode(spanEl['#text']);
                        spanHTMLElement.appendChild(textNode);
                        // If the element is a 'br' tag
                    } else if ('br' in spanEl) {
                            // To handle br inside span we need to add the current span
                            // to the cue and then create a br and add that the cue
                            // then create a new span that we use for the next line of
                            // text, that is a copy of the current span

                            // Add the current span to the cue, only if it has childNodes (text)
                            if (spanHTMLElement.hasChildNodes()) {
                                cue.appendChild(spanHTMLElement);
                            }

                            // Create a br and add that to the cue
                            var brEl = document.createElement('br');
                            brEl.className = 'lineBreak';
                            cue.appendChild(brEl);

                            // Create an replacement span and copy the style and classname from the old one
                            var newSpanHTMLElement = document.createElement('span');
                            newSpanHTMLElement.className = spanHTMLElement.className;
                            newSpanHTMLElement.style.cssText = spanHTMLElement.style.cssText;

                            // Replace the current span with the one we just created
                            spanHTMLElement = newSpanHTMLElement;
                        }
                });
                // We append the element to the cue container.
                cue.appendChild(spanHTMLElement);
            }

            /**
             * Create a br element if there is one in the cue.
             */
            else if (el.hasOwnProperty('br')) {
                    // We append the line break to the cue container.
                    var brEl = document.createElement('br');
                    brEl.className = 'lineBreak';
                    cue.appendChild(brEl);
                }

                /**
                 * Add the text that is not in any inline element
                 */
                else if (el.hasOwnProperty('#text')) {
                        // Add the text to an individual span element (to add line padding if it is defined).
                        var textNode = document.createElement('span');
                        textNode.textContent = el['#text'];

                        // We append the element to the cue container.
                        cue.appendChild(textNode);
                    }
        });
        return cue;
    }

    function constructCueRegion(cue, div, cellUnit) {
        var cueRegionProperties = []; // properties to be put in the "captionRegion" HTML element
        // Obtain the region ID(s) assigned to the cue.
        var pRegionID = cue.region;
        // If div has a region.
        var divRegionID = div.region;

        var divRegion;
        var pRegion;

        // If the div element reference a region.
        if (divRegionID) {
            divRegion = getProcessedRegion(divRegionID, cellUnit);
        }
        // If the p element reference a region.
        if (pRegionID) {
            pRegion = cueRegionProperties.concat(getProcessedRegion(pRegionID, cellUnit));
            if (divRegion) {
                cueRegionProperties = mergeArrays(divRegion, pRegion);
            } else {
                cueRegionProperties = pRegion;
            }
        } else if (divRegion) {
            cueRegionProperties = divRegion;
        }

        // Add initial/default values to what's not defined in the layout:
        applyDefaultProperties(cueRegionProperties, defaultLayoutProperties);

        return cueRegionProperties;
    }

    function constructCueStyle(cue, cellUnit) {
        var cueStyleProperties = []; // properties to be put in the "paragraph" HTML element
        // Obtain the style ID(s) assigned to the cue.
        var pStyleID = cue.style;
        // If body has a style.
        var bodyStyleID = ttml.tt.body.style;
        // If div has a style.
        var divStyleID = ttml.tt.body.div.style;

        var bodyStyle;
        var divStyle;
        var pStyle;
        var styleIDs = '';

        // If the body element reference a style.
        if (bodyStyleID) {
            bodyStyle = getProcessedStyle(bodyStyleID, cellUnit);
            styleIDs = 'paragraph ' + bodyStyleID;
        }

        // If the div element reference a style.
        if (divStyleID) {
            divStyle = getProcessedStyle(divStyleID, cellUnit);
            if (bodyStyle) {
                divStyle = mergeArrays(bodyStyle, divStyle);
                styleIDs += ' ' + divStyleID;
            } else {
                styleIDs = 'paragraph ' + divStyleID;
            }
        }

        // If the p element reference a style.
        if (pStyleID) {
            pStyle = getProcessedStyle(pStyleID, cellUnit);
            if (bodyStyle && divStyle) {
                cueStyleProperties = mergeArrays(divStyle, pStyle);
                styleIDs += ' ' + pStyleID;
            } else if (bodyStyle) {
                cueStyleProperties = mergeArrays(bodyStyle, pStyle);
                styleIDs += ' ' + pStyleID;
            } else if (divStyle) {
                cueStyleProperties = mergeArrays(divStyle, pStyle);
                styleIDs += ' ' + pStyleID;
            } else {
                cueStyleProperties = pStyle;
                styleIDs = 'paragraph ' + pStyleID;
            }
        } else if (bodyStyle && !divStyle) {
            cueStyleProperties = bodyStyle;
        } else if (!bodyStyle && divStyle) {
            cueStyleProperties = divStyle;
        }

        // Add initial/default values to what's not defined in the styling:
        applyDefaultProperties(cueStyleProperties, defaultStyleProperties);

        return [cueStyleProperties, styleIDs];
    }

    function applyDefaultProperties(array, defaultProperties) {
        for (var key in defaultProperties) {
            if (defaultProperties.hasOwnProperty(key)) {
                if (!arrayContains(key, array)) {
                    array.push(key + ':' + defaultProperties[key]);
                }
            }
        }
    }

    instance = {
        parse: parse,
        setConfig: setConfig
    };

    setup();
    return instance;
}
TTMLParser.__dashjs_factory_name = 'TTMLParser';
exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(TTMLParser);
module.exports = exports['default'];
//# sourceMappingURL=TTMLParser.js.map


/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

var _coreDebug = __webpack_require__(30);

var _coreDebug2 = _interopRequireDefault(_coreDebug);

function VTTParser() {
    var context = this.context;
    var log = (0, _coreDebug2['default'])(context).getInstance().log;

    var instance = undefined,
        regExNewLine = undefined,
        regExToken = undefined,
        regExWhiteSpace = undefined,
        regExWhiteSpaceWordBoundary = undefined;

    function setup() {
        regExNewLine = /(?:\r\n|\r|\n)/gm;
        regExToken = /-->/;
        regExWhiteSpace = /(^[\s]+|[\s]+$)/g;
        regExWhiteSpaceWordBoundary = /\s\b/g;
    }

    function parse(data) {
        var captionArray = [];
        var len, lastStartTime;

        data = data.split(regExNewLine);
        len = data.length;
        lastStartTime = -1;

        for (var i = 0; i < len; i++) {
            var item = data[i];

            if (item.length > 0 && item !== 'WEBVTT') {
                if (item.match(regExToken)) {
                    var attributes = parseItemAttributes(item);
                    var cuePoints = attributes.cuePoints;
                    var styles = attributes.styles;
                    var text = getSublines(data, i + 1);
                    var startTime = convertCuePointTimes(cuePoints[0].replace(regExWhiteSpace, ''));
                    var endTime = convertCuePointTimes(cuePoints[1].replace(regExWhiteSpace, ''));

                    if (!isNaN(startTime) && !isNaN(endTime) && startTime >= lastStartTime && endTime > startTime) {
                        if (text !== '') {
                            lastStartTime = startTime;
                            //TODO Make VO external so other parsers can use.
                            captionArray.push({
                                start: startTime,
                                end: endTime,
                                data: text,
                                styles: styles
                            });
                        } else {
                            log('Skipping cue due to empty/malformed cue text');
                        }
                    } else {
                        log('Skipping cue due to incorrect cue timing');
                    }
                }
            }
        }

        return captionArray;
    }

    function convertCuePointTimes(time) {
        var timeArray = time.split(':');
        var len = timeArray.length - 1;

        time = parseInt(timeArray[len - 1], 10) * 60 + parseFloat(timeArray[len]);

        if (len === 2) {
            time += parseInt(timeArray[0], 10) * 3600;
        }

        return time;
    }

    function parseItemAttributes(data) {
        var vttCuePoints = data.split(regExToken);
        var arr = vttCuePoints[1].split(regExWhiteSpaceWordBoundary);
        arr.shift(); //remove first array index it is empty...
        vttCuePoints[1] = arr[0];
        arr.shift();
        return { cuePoints: vttCuePoints, styles: getCaptionStyles(arr) };
    }

    function getCaptionStyles(arr) {
        var styleObject = {};
        arr.forEach(function (element) {
            if (element.split(/:/).length > 1) {
                var val = element.split(/:/)[1];
                if (val && val.search(/%/) != -1) {
                    val = parseInt(val.replace(/%/, ''), 10);
                }
                if (element.match(/align/) || element.match(/A/)) {
                    styleObject.align = val;
                }
                if (element.match(/line/) || element.match(/L/)) {
                    styleObject.line = val;
                }
                if (element.match(/position/) || element.match(/P/)) {
                    styleObject.position = val;
                }
                if (element.match(/size/) || element.match(/S/)) {
                    styleObject.size = val;
                }
            }
        });

        return styleObject;
    }

    /*
    * VTT can have multiple lines to display per cuepoint.
    */
    function getSublines(data, idx) {
        var i = idx;

        var subline = '';
        var lineData = '';
        var lineCount;

        while (data[i] !== '' && i < data.length) {
            i++;
        }

        lineCount = i - idx;
        if (lineCount > 1) {
            for (var j = 0; j < lineCount; j++) {
                lineData = data[idx + j];
                if (!lineData.match(regExToken)) {
                    subline += lineData;
                    if (j !== lineCount - 1) {
                        subline += '\n';
                    }
                } else {
                    // caption text should not have '-->' in it
                    subline = '';
                    break;
                }
            }
        } else {
            lineData = data[idx];
            if (!lineData.match(regExToken)) subline = lineData;
        }
        return subline;
    }

    instance = {
        parse: parse
    };

    setup();
    return instance;
}
VTTParser.__dashjs_factory_name = 'VTTParser';
exports['default'] = _coreFactoryMaker2['default'].getSingletonFactory(VTTParser);
module.exports = exports['default'];
//# sourceMappingURL=VTTParser.js.map


/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */



Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

function BasicSelector(config) {

    var instance = undefined;

    var blacklistController = config.blacklistController;

    function select(baseUrls) {
        var index = 0;
        var selectedBaseUrl;

        if (baseUrls && baseUrls.some(function (baseUrl, idx) {
            index = idx;

            return !blacklistController.contains(baseUrl.serviceLocation);
        })) {
            selectedBaseUrl = baseUrls[index];
        }

        return selectedBaseUrl;
    }

    instance = {
        select: select
    };

    return instance;
}

BasicSelector.__dashjs_factory_name = 'BasicSelector';
exports['default'] = _coreFactoryMaker2['default'].getClassFactory(BasicSelector);
module.exports = exports['default'];
//# sourceMappingURL=BasicSelector.js.map


/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _coreFactoryMaker = __webpack_require__(9);

var _coreFactoryMaker2 = _interopRequireDefault(_coreFactoryMaker);

function DVBSelector(config) {

    var instance = undefined;

    var blacklistController = config.blacklistController;

    function getNonBlacklistedBaseUrls(urls) {
        var removedPriorities = [];

        var samePrioritiesFilter = function samePrioritiesFilter(el) {
            if (removedPriorities.length) {
                if (el.dvb_priority && removedPriorities.indexOf(el.dvb_priority) !== -1) {
                    return false;
                }
            }

            return true;
        };

        var serviceLocationFilter = function serviceLocationFilter(baseUrl) {
            if (blacklistController.contains(baseUrl.serviceLocation)) {
                // whenever a BaseURL is removed from the available list of
                // BaseURLs, any other BaseURL with the same @priority
                // value as the BaseURL being removed shall also be removed
                if (baseUrl.dvb_priority) {
                    removedPriorities.push(baseUrl.dvb_priority);
                }

                // all URLs in the list which have a @serviceLocation
                // attribute matching an entry in the blacklist shall be
                // removed from the available list of BaseURLs
                return false;
            }

            return true;
        };

        return urls.filter(serviceLocationFilter).filter(samePrioritiesFilter);
    }

    function selectByWeight(availableUrls) {
        var prioritySorter = function prioritySorter(a, b) {
            var diff = a.dvb_priority - b.dvb_priority;
            return isNaN(diff) ? 0 : diff;
        };

        var topPriorityFilter = function topPriorityFilter(baseUrl, idx, arr) {
            return !idx || arr[0].dvb_priority && baseUrl.dvb_priority && arr[0].dvb_priority === baseUrl.dvb_priority;
        };

        var totalWeight = 0;
        var cumulWeights = [];
        var idx = 0;
        var rn;
        var urls;

        // It shall begin by taking the set of resolved BaseURLs present or inherited at the current
        // position in the MPD, resolved and filtered as described in 10.8.2.1, that have the lowest
        // @priority attribute value.
        urls = availableUrls.sort(prioritySorter).filter(topPriorityFilter);

        if (urls.length) {
            if (urls.length > 1) {
                // If there is more than one BaseURL with this lowest @priority attribute value then the Player
                // shall select one of them at random such that the probability of each BaseURL being chosen
                // is proportional to the value of its @weight attribute. The method described in RFC 2782
                // [26] or picking from a number of weighted entries is suitable for this, but there may be other
                // algorithms which achieve the same effect.

                // add all the weights together, storing the accumulated weight per entry
                urls.forEach(function (baseUrl) {
                    totalWeight += baseUrl.dvb_weight;
                    cumulWeights.push(totalWeight);
                });

                // pick a random number between zero and totalWeight
                rn = Math.floor(Math.random() * (totalWeight - 1));

                // select the index for the range rn falls within
                cumulWeights.every(function (limit, index) {
                    idx = index;

                    if (rn < limit) {
                        return false;
                    }

                    return true;
                });
            }

            return urls[idx];
        }
    }

    function select(baseUrls) {
        return baseUrls && selectByWeight(getNonBlacklistedBaseUrls(baseUrls));
    }

    instance = {
        select: select
    };

    return instance;
}

DVBSelector.__dashjs_factory_name = 'DVBSelector';
exports['default'] = _coreFactoryMaker2['default'].getClassFactory(DVBSelector);
module.exports = exports['default'];
//# sourceMappingURL=DVBSelector.js.map


/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @class
 * @ignore
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BitrateInfo = function BitrateInfo() {
  _classCallCheck(this, BitrateInfo);

  this.mediaType = null;
  this.bitrate = null;
  this.width = null;
  this.height = null;
  this.qualityIndex = NaN;
};

exports["default"] = BitrateInfo;
module.exports = exports["default"];
//# sourceMappingURL=BitrateInfo.js.map


/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 * @ignore
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DataChunk =
//Represents a data structure that keep all the necessary info about a single init/media segment
function DataChunk() {
  _classCallCheck(this, DataChunk);

  this.streamId = null;
  this.mediaInfo = null;
  this.segmentType = null;
  this.quality = NaN;
  this.index = NaN;
  this.bytes = null;
  this.start = NaN;
  this.end = NaN;
  this.duration = NaN;
  this.representationId = null;
};

exports["default"] = DataChunk;
module.exports = exports["default"];
//# sourceMappingURL=DataChunk.js.map


/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @class
 * @ignore
 */


Object.defineProperty(exports, '__esModule', {
  value: true
});

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _FragmentRequest2 = __webpack_require__(190);

var _FragmentRequest3 = _interopRequireDefault(_FragmentRequest2);

var HeadRequest = (function (_FragmentRequest) {
  _inherits(HeadRequest, _FragmentRequest);

  function HeadRequest(url) {
    _classCallCheck(this, HeadRequest);

    _get(Object.getPrototypeOf(HeadRequest.prototype), 'constructor', this).call(this);
    this.url = url || null;
    this.checkForExistenceOnly = true;
  }

  return HeadRequest;
})(_FragmentRequest3['default']);

exports['default'] = HeadRequest;
module.exports = exports['default'];
//# sourceMappingURL=HeadRequest.js.map


/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @class
 * @ignore
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var IsoBox = function IsoBox() {
  _classCallCheck(this, IsoBox);

  this.offset = NaN;
  this.type = null;
  this.size = NaN;
  this.isComplete = true;
};

exports["default"] = IsoBox;
module.exports = exports["default"];
//# sourceMappingURL=IsoBox.js.map


/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @class
 * @ignore
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ManifestInfo = function ManifestInfo() {
  _classCallCheck(this, ManifestInfo);

  this.DVRWindowSize = NaN;
  this.loadedTime = null;
  this.availableFrom = null;
  this.minBufferTime = NaN;
  this.duration = NaN;
  this.isDynamic = false;
  this.maxFragmentDuration = null;
};

exports["default"] = ManifestInfo;
module.exports = exports["default"];
//# sourceMappingURL=ManifestInfo.js.map


/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @class
 * @ignore
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MediaInfo = function MediaInfo() {
  _classCallCheck(this, MediaInfo);

  this.id = null;
  this.index = null;
  this.type = null;
  this.streamInfo = null;
  this.representationCount = 0;
  this.lang = null;
  this.viewpoint = null;
  this.accessibility = null;
  this.audioChannelConfiguration = null;
  this.roles = null;
  this.codec = null;
  this.mimeType = null;
  this.contentProtection = null;
  this.isText = false;
  this.KID = null;
  this.bitrateList = null;
};

exports["default"] = MediaInfo;
module.exports = exports["default"];
//# sourceMappingURL=MediaInfo.js.map


/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @class
 * @ignore
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MetricsList = function MetricsList() {
  _classCallCheck(this, MetricsList);

  this.TcpList = [];
  this.HttpList = [];
  this.RepSwitchList = [];
  this.BufferLevel = [];
  this.BufferState = [];
  this.PlayList = [];
  this.DroppedFrames = [];
  this.SchedulingInfo = [];
  this.DVRInfo = [];
  this.ManifestUpdate = [];
  this.RequestsQueue = null;
  this.DVBErrors = [];
  this.BolaState = [];
};

exports["default"] = MetricsList;
module.exports = exports["default"];
//# sourceMappingURL=MetricsList.js.map


/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @class
 * @ignore
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StreamInfo = function StreamInfo() {
  _classCallCheck(this, StreamInfo);

  this.id = null;
  this.index = null;
  this.start = NaN;
  this.duration = NaN;
  this.manifestInfo = null;
  this.isLast = true;
  this.isFirst = true;
};

exports["default"] = StreamInfo;
module.exports = exports["default"];
//# sourceMappingURL=StreamInfo.js.map


/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @class
 * @ignore
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TextTrackInfo = function TextTrackInfo() {
  _classCallCheck(this, TextTrackInfo);

  this.video = null;
  this.captionData = null;
  this.label = null;
  this.lang = null;
  this.defaultTrack = false;
  this.kind = null;
  this.isFragmented = false;
  this.isEmbedded = false;
};

exports["default"] = TextTrackInfo;
module.exports = exports["default"];
//# sourceMappingURL=TextTrackInfo.js.map


/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @class
 * @ignore
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TrackInfo = function TrackInfo() {
  _classCallCheck(this, TrackInfo);

  this.id = null;
  this.quality = null;
  this.DVRWindow = null;
  this.fragmentDuration = null;
  this.mediaInfo = null;
  this.MSETimeOffset = null;
};

exports["default"] = TrackInfo;
module.exports = exports["default"];
//# sourceMappingURL=TrackInfo.js.map


/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @class
 * @ignore
 */


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var URIFragmentData = function URIFragmentData() {
    _classCallCheck(this, URIFragmentData);

    this.t = null;
    this.xywh = null;
    this.track = null;
    this.id = null;
    this.s = null;
};

exports["default"] = URIFragmentData;

/*
    From Spec http://www.w3.org/TR/media-frags/

    temporal (t)     - This dimension denotes a specific time range in the original media, such as "starting at second 10, continuing until second 20";
    spatial  (xywh)  - this dimension denotes a specific range of pixels in the original media, such as "a rectangle with size (100,100) with its top-left at coordinate (10,10)";
                       Media fragments support also addressing the media along two additional dimensions (in the advanced version defined in Media Fragments 1.0 URI (advanced)):
    track    (track) - this dimension denotes one or more tracks in the original media, such as "the english audio and the video track";
    id       (id)    - this dimension denotes a named temporal fragment within the original media, such as "chapter 2", and can be seen as a convenient way of specifying a temporal fragment.


    ## Note
    Akamai is purposing to add #s=X to the ISO standard.
        - (X) Value would be a start time to seek to at startup instead of starting at 0 or live edge
        - Allows for seeking back before the start time unlike a temporal clipping.
*/
module.exports = exports["default"];
//# sourceMappingURL=URIFragmentData.js.map


/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2016, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @class
 * @ignore
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BolaState = function BolaState() {
  _classCallCheck(this, BolaState);

  /**
   * number
   * @private
   */
  this._s = undefined;
};

exports["default"] = BolaState;
module.exports = exports["default"];
//# sourceMappingURL=BolaState.js.map


/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @class
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BufferLevel =
/**
 * @description This Object holds reference to the current buffer level and the time it was recorded.
 */
function BufferLevel() {
  _classCallCheck(this, BufferLevel);

  /**
   * Real-Time | Time of the measurement of the buffer level.
   * @public
   */
  this.t = null;
  /**
   * Level of the buffer in milliseconds. Indicates the playout duration for which
   * media data of all active media components is available starting from the
   * current playout time.
   * @public
   */
  this.level = null;
};

exports["default"] = BufferLevel;
module.exports = exports["default"];
//# sourceMappingURL=BufferLevel.js.map


/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */


Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _controllersBufferController = __webpack_require__(160);

var _controllersBufferController2 = _interopRequireDefault(_controllersBufferController);

/**
 * @class
 */

var BufferState =
/**
 * @description This Object holds reference to the current buffer state of the video element.
 */
function BufferState() {
  _classCallCheck(this, BufferState);

  /**
   * The Buffer Level Target determined by the BufferLevelRule.
   * @public
   */
  this.target = null;
  /**
   * Current buffer state. Will be BufferController.BUFFER_EMPTY or BufferController.BUFFER_LOADED.
   * @public
   */
  this.state = _controllersBufferController2['default'].BUFFER_EMPTY;
};

exports['default'] = BufferState;
module.exports = exports['default'];
//# sourceMappingURL=BufferState.js.map


/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @class
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DVRInfo =
/**
 * @description This Object holds reference to DVR availability window information.
 */
function DVRInfo() {
  _classCallCheck(this, DVRInfo);

  /**
   * The current time of the video element when this was created.
   * @public
   */
  this.time = null;
  /**
   * The current Segment Availability Range as an object with start and end properties.
   * It's delta defined by the timeShiftBufferDepth MPD attribute.
   * @public
   */
  this.range = null;
  /**
   * Reference to the internal ManifestInfo.js VO.
   * @public
   */
  this.manifestInfo = null;
};

exports["default"] = DVRInfo;
module.exports = exports["default"];
//# sourceMappingURL=DVRInfo.js.map


/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @class
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DroppedFrames =
/**
 * @description This Object holds reference to DroppedFrames count and the time it was recorded.
 */
function DroppedFrames() {
  _classCallCheck(this, DroppedFrames);

  /**
   * Real-Time | Time of the measurement of the dropped frames.
   * @public
   */
  this.time = null;
  /**
   * Number of dropped frames
   * @public
   */
  this.droppedFrames = null;
};

exports["default"] = DroppedFrames;
module.exports = exports["default"];
//# sourceMappingURL=DroppedFrames.js.map


/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @classdesc This Object holds reference to the manifest update information.
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ManifestUpdate =
/**
 * @class
 */
function ManifestUpdate() {
  _classCallCheck(this, ManifestUpdate);

  /**
   * Media Type Video | Audio | FragmentedText
   * @public
   */
  this.mediaType = null;
  /**
   * MPD Type static | dynamic
   * @public
   */
  this.type = null;
  /**
   * When this manifest update was requested
   * @public
   */
  this.requestTime = null;
  /**
   * When this manifest update was received
   * @public
   */
  this.fetchTime = null;
  /**
   * Calculated Availability Start time of the stream.
   * @public
   */
  this.availabilityStartTime = null;
  /**
   * the seek point (liveEdge for dynamic, Stream[0].startTime for static)
   * @public
   */
  this.presentationStartTime = 0;
  /**
   * The calculated difference between the server and client wall clock time
   * @public
   */
  this.clientTimeOffset = 0;
  /**
   * Actual element.currentTime
   * @public
   */
  this.currentTime = null;
  /**
   * Actual element.ranges
   * @public
   */
  this.buffered = null;
  /**
   * Static is fixed value of zero. dynamic should be ((Now-@availabilityStartTime) - elementCurrentTime)
   * @public
   */
  this.latency = 0;
  /**
   * Array holding list of StreamInfo VO Objects
   * @public
   */
  this.streamInfo = [];
  /**
   * Array holding list of TrackInfo VO Objects
   * @public
   */
  this.trackInfo = [];
}

/**
 * @classdesc This Object holds reference to the current period's stream information when the manifest was updated.
 */
;

var ManifestUpdateStreamInfo =
/**
 * @class
 */
function ManifestUpdateStreamInfo() {
  _classCallCheck(this, ManifestUpdateStreamInfo);

  /**
   * Stream@id
   * @public
   */
  this.id = null;
  /**
   * Period Index
   * @public
   */
  this.index = null;
  /**
   * Stream@start
   * @public
   */
  this.start = null;
  /**
   * Stream@duration
   * @public
   */
  this.duration = null;
}

/**
 * @classdesc This Object holds reference to the current representation's info when the manifest was updated.
 */
;

var ManifestUpdateTrackInfo =
/**
 * @class
 */
function ManifestUpdateTrackInfo() {
  _classCallCheck(this, ManifestUpdateTrackInfo);

  /**
   * Track@id
   * @public
   */
  this.id = null;
  /**
   * Representation Index
   * @public
   */
  this.index = null;
  /**
   * Media Type Video | Audio | FragmentedText
   * @public
   */
  this.mediaType = null;
  /**
   * Which reprenset
   * @public
   */
  this.streamIndex = null;
  /**
   * Holds reference to @presentationTimeOffset
   * @public
   */
  this.presentationTimeOffset = null;
  /**
   * Holds reference to @startNumber
   * @public
   */
  this.startNumber = null;
  /**
   * list|template|timeline
   * @public
   */
  this.fragmentInfoType = null;
};

exports.ManifestUpdate = ManifestUpdate;
exports.ManifestUpdateStreamInfo = ManifestUpdateStreamInfo;
exports.ManifestUpdateTrackInfo = ManifestUpdateTrackInfo;
//# sourceMappingURL=ManifestUpdate.js.map


/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @class
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RepresentationSwitch =
/**
 * @description This Object holds reference to the info at quality switch between two representations.
 */
function RepresentationSwitch() {
  _classCallCheck(this, RepresentationSwitch);

  /**
   * Time of the switch event.
   * @public
   */
  this.t = null;
  /**
   * The media presentation time of the earliest access unit
   * (out of all media content components) played out from
   * the Representation.
   *
   * @public
   */
  this.mt = null;
  /**
   * Value of Representation@id identifying the switch-to Representation.
   * @public
   */
  this.to = null;
  /**
   * If not present, this metrics concerns the Representation as a whole.
   * If present, lto indicates the value of SubRepresentation@level within
   * Representation identifying the switch-to level of the Representation.
   *
   * @public
   */
  this.lto = null;
};

exports["default"] = RepresentationSwitch;
module.exports = exports["default"];
//# sourceMappingURL=RepresentationSwitch.js.map


/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @class
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RequestsQueue =
/**
 * @description This Object holds reference to Fragment Model's request queues
 */
function RequestsQueue() {
  _classCallCheck(this, RequestsQueue);

  /**
   * Array of all of the requests that have begun to load
   * This request may not make it into the executed queue if it is abandon due to ABR rules for example.
   * @public
   */
  this.loadingRequests = [];
  /**
   * Array of the The requests that have completed
   * @public
   */
  this.executedRequests = [];
};

exports["default"] = RequestsQueue;
module.exports = exports["default"];
//# sourceMappingURL=RequestsQueue.js.map


/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @class
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SchedulingInfo =
/**
 * @description This Object holds reference to the index handling of the current fragment being loaded or executed.
 */
function SchedulingInfo() {
  _classCallCheck(this, SchedulingInfo);

  /**
   * Type of stream Audio | Video | FragmentedText
   * @public
   */
  this.mediaType = null;
  /**
   * Time of the scheduling event.
   * @public
   */
  this.t = null;

  /**
   * Type of fragment (initialization | media)
   * @public
   */
  this.type = null;
  /**
   * Presentation start time of fragment
   * @public
   */
  this.startTime = null;
  /**
   * Availability start time of fragment
   * @public
   */
  this.availabilityStartTime = null;
  /**
   * Duration of fragment
   * @public
   */
  this.duration = null;
  /**
   * Bit Rate Quality of fragment
   * @public
   */
  this.quality = null;
  /**
   * Range of fragment
   * @public
   */
  this.range = null;

  /**
   * Current state of fragment
   * @public
   */
  this.state = null;
};

exports["default"] = SchedulingInfo;
module.exports = exports["default"];
//# sourceMappingURL=SchedulingInfo.js.map


/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2013, Dash Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  * Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  * Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 * @class
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TCPConnection =
/**
 * @description This Object holds reference to the current tcp connection
 */
function TCPConnection() {
  _classCallCheck(this, TCPConnection);

  /**
   * Identifier of the TCP connection on which the HTTP request was sent.
   * @public
   */
  this.tcpid = null;
  /**
   * IP Address of the interface over which the client is receiving the TCP data.
   * @public
   */
  this.dest = null;
  /**
   * Real-Time | The time at which the connection was opened (sending time of the initial SYN or connect socket operation).
   * @public
   */
  this.topen = null;
  /**
   * Real-Time | The time at which the connection was closed (sending or reception time of FIN or RST or close socket operation).
   * @public
   */
  this.tclose = null;
  /**
   * Connect time in ms (time from sending the initial SYN to receiving the ACK or completion of the connect socket operation).
   * @public
   */
  this.tconnect = null;
};

exports["default"] = TCPConnection;
module.exports = exports["default"];
//# sourceMappingURL=TCPConnection.js.map


/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * HLS config
 */


Object.defineProperty(exports, "__esModule", {
      value: true
});
exports.hlsDefaultConfig = undefined;

var _abrController = __webpack_require__(1439);

var _abrController2 = _interopRequireDefault(_abrController);

var _bufferController = __webpack_require__(1442);

var _bufferController2 = _interopRequireDefault(_bufferController);

var _capLevelController = __webpack_require__(1443);

var _capLevelController2 = _interopRequireDefault(_capLevelController);

var _fpsController = __webpack_require__(1444);

var _fpsController2 = _interopRequireDefault(_fpsController);

var _xhrLoader = __webpack_require__(1477);

var _xhrLoader2 = _interopRequireDefault(_xhrLoader);

var _audioTrackController = __webpack_require__(1441);

var _audioTrackController2 = _interopRequireDefault(_audioTrackController);

var _audioStreamController = __webpack_require__(1440);

var _audioStreamController2 = _interopRequireDefault(_audioStreamController);

var _cues = __webpack_require__(1472);

var _cues2 = _interopRequireDefault(_cues);

var _timelineController = __webpack_require__(1450);

var _timelineController2 = _interopRequireDefault(_timelineController);

var _subtitleTrackController = __webpack_require__(1449);

var _subtitleTrackController2 = _interopRequireDefault(_subtitleTrackController);

var _subtitleStreamController = __webpack_require__(1448);

var _subtitleStreamController2 = _interopRequireDefault(_subtitleStreamController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//#endif

//#endif

//#if subtitle

//import FetchLoader from './utils/fetch-loader';
//#if altaudio
var hlsDefaultConfig = exports.hlsDefaultConfig = {
      autoStartLoad: true, // used by stream-controller
      startPosition: -1, // used by stream-controller
      defaultAudioCodec: undefined, // used by stream-controller
      debug: false, // used by logger
      capLevelOnFPSDrop: false, // used by fps-controller
      capLevelToPlayerSize: false, // used by cap-level-controller
      initialLiveManifestSize: 1, // used by stream-controller
      maxBufferLength: 30, // used by stream-controller
      maxBufferSize: 60 * 1000 * 1000, // used by stream-controller
      maxBufferHole: 0.5, // used by stream-controller
      maxSeekHole: 2, // used by stream-controller
      lowBufferWatchdogPeriod: 0.5, // used by stream-controller
      highBufferWatchdogPeriod: 3, // used by stream-controller
      nudgeOffset: 0.1, // used by stream-controller
      nudgeMaxRetry: 3, // used by stream-controller
      maxFragLookUpTolerance: 0.2, // used by stream-controller
      liveSyncDurationCount: 3, // used by stream-controller
      liveMaxLatencyDurationCount: Infinity, // used by stream-controller
      liveSyncDuration: undefined, // used by stream-controller
      liveMaxLatencyDuration: undefined, // used by stream-controller
      maxMaxBufferLength: 600, // used by stream-controller
      enableWorker: true, // used by demuxer
      enableSoftwareAES: true, // used by decrypter
      manifestLoadingTimeOut: 10000, // used by playlist-loader
      manifestLoadingMaxRetry: 1, // used by playlist-loader
      manifestLoadingRetryDelay: 1000, // used by playlist-loader
      manifestLoadingMaxRetryTimeout: 64000, // used by playlist-loader
      startLevel: undefined, // used by level-controller
      levelLoadingTimeOut: 10000, // used by playlist-loader
      levelLoadingMaxRetry: 4, // used by playlist-loader
      levelLoadingRetryDelay: 1000, // used by playlist-loader
      levelLoadingMaxRetryTimeout: 64000, // used by playlist-loader
      fragLoadingTimeOut: 20000, // used by fragment-loader
      fragLoadingMaxRetry: 6, // used by fragment-loader
      fragLoadingRetryDelay: 1000, // used by fragment-loader
      fragLoadingMaxRetryTimeout: 64000, // used by fragment-loader
      fragLoadingLoopThreshold: 3, // used by stream-controller
      startFragPrefetch: false, // used by stream-controller
      fpsDroppedMonitoringPeriod: 5000, // used by fps-controller
      fpsDroppedMonitoringThreshold: 0.2, // used by fps-controller
      appendErrorMaxRetry: 3, // used by buffer-controller
      loader: _xhrLoader2.default,
      //loader: FetchLoader,
      fLoader: undefined,
      pLoader: undefined,
      xhrSetup: undefined,
      fetchSetup: undefined,
      abrController: _abrController2.default,
      bufferController: _bufferController2.default,
      capLevelController: _capLevelController2.default,
      fpsController: _fpsController2.default,
      //#if altaudio
      audioStreamController: _audioStreamController2.default,
      audioTrackController: _audioTrackController2.default,
      //#endif
      //#if subtitle
      subtitleStreamController: _subtitleStreamController2.default,
      subtitleTrackController: _subtitleTrackController2.default,
      timelineController: _timelineController2.default,
      cueHandler: _cues2.default,
      enableCEA708Captions: true, // used by timeline-controller
      enableWebVTT: true, // used by timeline-controller
      captionsTextTrack1Label: 'English', // used by timeline-controller
      captionsTextTrack1LanguageCode: 'en', // used by timeline-controller
      captionsTextTrack2Label: 'Spanish', // used by timeline-controller
      captionsTextTrack2LanguageCode: 'es', // used by timeline-controller
      //#endif
      stretchShortVideoTrack: false, // used by mp4-remuxer
      forceKeyFrameOnDiscontinuity: true, // used by ts-demuxer
      abrEwmaFastLive: 3, // used by abr-controller
      abrEwmaSlowLive: 9, // used by abr-controller
      abrEwmaFastVoD: 3, // used by abr-controller
      abrEwmaSlowVoD: 9, // used by abr-controller
      abrEwmaDefaultEstimate: 5e5, // 500 kbps  // used by abr-controller
      abrBandWidthFactor: 0.95, // used by abr-controller
      abrBandWidthUpFactor: 0.7, // used by abr-controller
      abrMaxWithRealBitrate: false, // used by abr-controller
      maxStarvationDelay: 4, // used by abr-controller
      maxLoadingDelay: 4, // used by abr-controller
      minAutoBitrate: 0 // used by hls
};

/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events = __webpack_require__(39);

var _events2 = _interopRequireDefault(_events);

var _eventHandler = __webpack_require__(68);

var _eventHandler2 = _interopRequireDefault(_eventHandler);

var _bufferHelper = __webpack_require__(332);

var _bufferHelper2 = _interopRequireDefault(_bufferHelper);

var _errors = __webpack_require__(63);

var _logger = __webpack_require__(31);

var _ewmaBandwidthEstimator = __webpack_require__(1473);

var _ewmaBandwidthEstimator2 = _interopRequireDefault(_ewmaBandwidthEstimator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * simple ABR Controller
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  - compute next level based on last fragment bw heuristics
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  - implement an abandon rules triggered if we have less than 2 frag buffered and if computed bw shows that we risk buffer stalling
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var AbrController = function (_EventHandler) {
  _inherits(AbrController, _EventHandler);

  function AbrController(hls) {
    _classCallCheck(this, AbrController);

    var _this = _possibleConstructorReturn(this, (AbrController.__proto__ || Object.getPrototypeOf(AbrController)).call(this, hls, _events2.default.FRAG_LOADING, _events2.default.FRAG_LOADED, _events2.default.FRAG_BUFFERED, _events2.default.ERROR));

    _this.lastLoadedFragLevel = 0;
    _this._nextAutoLevel = -1;
    _this.hls = hls;
    _this.onCheck = _this._abandonRulesCheck.bind(_this);
    return _this;
  }

  _createClass(AbrController, [{
    key: 'destroy',
    value: function destroy() {
      this.clearTimer();
      _eventHandler2.default.prototype.destroy.call(this);
    }
  }, {
    key: 'onFragLoading',
    value: function onFragLoading(data) {
      var frag = data.frag;
      if (frag.type === 'main') {
        if (!this.timer) {
          this.timer = setInterval(this.onCheck, 100);
        }
        // lazy init of bw Estimator, rationale is that we use different params for Live/VoD
        // so we need to wait for stream manifest / playlist type to instantiate it.
        if (!this._bwEstimator) {
          var hls = this.hls,
              level = data.frag.level,
              isLive = hls.levels[level].details.live,
              config = hls.config,
              ewmaFast = void 0,
              ewmaSlow = void 0;

          if (isLive) {
            ewmaFast = config.abrEwmaFastLive;
            ewmaSlow = config.abrEwmaSlowLive;
          } else {
            ewmaFast = config.abrEwmaFastVoD;
            ewmaSlow = config.abrEwmaSlowVoD;
          }
          this._bwEstimator = new _ewmaBandwidthEstimator2.default(hls, ewmaSlow, ewmaFast, config.abrEwmaDefaultEstimate);
        }
        this.fragCurrent = frag;
      }
    }
  }, {
    key: '_abandonRulesCheck',
    value: function _abandonRulesCheck() {
      /*
        monitor fragment retrieval time...
        we compute expected time of arrival of the complete fragment.
        we compare it to expected time of buffer starvation
      */
      var hls = this.hls,
          v = hls.media,
          frag = this.fragCurrent,
          loader = frag.loader,
          minAutoLevel = hls.minAutoLevel;

      // if loader has been destroyed or loading has been aborted, stop timer and return
      if (!loader || loader.stats && loader.stats.aborted) {
        _logger.logger.warn('frag loader destroy or aborted, disarm abandonRules');
        this.clearTimer();
        return;
      }
      var stats = loader.stats;
      /* only monitor frag retrieval time if
      (video not paused OR first fragment being loaded(ready state === HAVE_NOTHING = 0)) AND autoswitching enabled AND not lowest level (=> means that we have several levels) */
      if (v && (!v.paused && v.playbackRate !== 0 || !v.readyState) && frag.autoLevel && frag.level) {
        var requestDelay = performance.now() - stats.trequest,
            playbackRate = Math.abs(v.playbackRate);
        // monitor fragment load progress after half of expected fragment duration,to stabilize bitrate
        if (requestDelay > 500 * frag.duration / playbackRate) {
          var levels = hls.levels,
              loadRate = Math.max(1, stats.bw ? stats.bw / 8 : stats.loaded * 1000 / requestDelay),
              // byte/s; at least 1 byte/s to avoid division by zero
          // compute expected fragment length using frag duration and level bitrate. also ensure that expected len is gte than already loaded size
          level = levels[frag.level],
              levelBitrate = level.realBitrate ? Math.max(level.realBitrate, level.bitrate) : level.bitrate,
              expectedLen = stats.total ? stats.total : Math.max(stats.loaded, Math.round(frag.duration * levelBitrate / 8)),
              pos = v.currentTime,
              fragLoadedDelay = (expectedLen - stats.loaded) / loadRate,
              bufferStarvationDelay = (_bufferHelper2.default.bufferInfo(v, pos, hls.config.maxBufferHole).end - pos) / playbackRate;
          // consider emergency switch down only if we have less than 2 frag buffered AND
          // time to finish loading current fragment is bigger than buffer starvation delay
          // ie if we risk buffer starvation if bw does not increase quickly
          if (bufferStarvationDelay < 2 * frag.duration / playbackRate && fragLoadedDelay > bufferStarvationDelay) {
            var fragLevelNextLoadedDelay = void 0,
                nextLoadLevel = void 0;
            // lets iterate through lower level and try to find the biggest one that could avoid rebuffering
            // we start from current level - 1 and we step down , until we find a matching level
            for (nextLoadLevel = frag.level - 1; nextLoadLevel > minAutoLevel; nextLoadLevel--) {
              // compute time to load next fragment at lower level
              // 0.8 : consider only 80% of current bw to be conservative
              // 8 = bits per byte (bps/Bps)
              var levelNextBitrate = levels[nextLoadLevel].realBitrate ? Math.max(levels[nextLoadLevel].realBitrate, levels[nextLoadLevel].bitrate) : levels[nextLoadLevel].bitrate;
              fragLevelNextLoadedDelay = frag.duration * levelNextBitrate / (8 * 0.8 * loadRate);
              if (fragLevelNextLoadedDelay < bufferStarvationDelay) {
                // we found a lower level that be rebuffering free with current estimated bw !
                break;
              }
            }
            // only emergency switch down if it takes less time to load new fragment at lowest level instead
            // of finishing loading current one ...
            if (fragLevelNextLoadedDelay < fragLoadedDelay) {
              _logger.logger.warn('loading too slow, abort fragment loading and switch to level ' + nextLoadLevel + ':fragLoadedDelay[' + nextLoadLevel + ']<fragLoadedDelay[' + (frag.level - 1) + '];bufferStarvationDelay:' + fragLevelNextLoadedDelay.toFixed(1) + '<' + fragLoadedDelay.toFixed(1) + ':' + bufferStarvationDelay.toFixed(1));
              // force next load level in auto mode
              hls.nextLoadLevel = nextLoadLevel;
              // update bw estimate for this fragment before cancelling load (this will help reducing the bw)
              this._bwEstimator.sample(requestDelay, stats.loaded);
              //abort fragment loading
              loader.abort();
              // stop abandon rules timer
              this.clearTimer();
              hls.trigger(_events2.default.FRAG_LOAD_EMERGENCY_ABORTED, { frag: frag, stats: stats });
            }
          }
        }
      }
    }
  }, {
    key: 'onFragLoaded',
    value: function onFragLoaded(data) {
      var frag = data.frag;
      if (frag.type === 'main' && !isNaN(frag.sn)) {
        // stop monitoring bw once frag loaded
        this.clearTimer();
        // store level id after successful fragment load
        this.lastLoadedFragLevel = frag.level;
        // reset forced auto level value so that next level will be selected
        this._nextAutoLevel = -1;

        // compute level average bitrate
        if (this.hls.config.abrMaxWithRealBitrate) {
          var level = this.hls.levels[frag.level];
          var loadedBytes = (level.loaded ? level.loaded.bytes : 0) + data.stats.loaded;
          var loadedDuration = (level.loaded ? level.loaded.duration : 0) + data.frag.duration;
          level.loaded = { bytes: loadedBytes, duration: loadedDuration };
          level.realBitrate = Math.round(8 * loadedBytes / loadedDuration);
        }
        // if fragment has been loaded to perform a bitrate test,
        if (data.frag.bitrateTest) {
          var stats = data.stats;
          stats.tparsed = stats.tbuffered = stats.tload;
          this.onFragBuffered(data);
        }
      }
    }
  }, {
    key: 'onFragBuffered',
    value: function onFragBuffered(data) {
      var stats = data.stats,
          frag = data.frag;
      // only update stats on first frag buffering
      // if same frag is loaded multiple times, it might be in browser cache, and loaded quickly
      // and leading to wrong bw estimation
      // on bitrate test, also only update stats once (if tload = tbuffered == on FRAG_LOADED)
      if (stats.aborted !== true && frag.loadCounter === 1 && frag.type === 'main' && !isNaN(frag.sn) && (!frag.bitrateTest || stats.tload === stats.tbuffered)) {
        // use tparsed-trequest instead of tbuffered-trequest to compute fragLoadingProcessing; rationale is that  buffer appending only happens once media is attached
        // in case we use config.startFragPrefetch while media is not attached yet, fragment might be parsed while media not attached yet, but it will only be buffered on media attached
        // as a consequence it could happen really late in the process. meaning that appending duration might appears huge ... leading to underestimated throughput estimation
        var fragLoadingProcessingMs = stats.tparsed - stats.trequest;
        _logger.logger.log('latency/loading/parsing/append/kbps:' + Math.round(stats.tfirst - stats.trequest) + '/' + Math.round(stats.tload - stats.tfirst) + '/' + Math.round(stats.tparsed - stats.tload) + '/' + Math.round(stats.tbuffered - stats.tparsed) + '/' + Math.round(8 * stats.loaded / (stats.tbuffered - stats.trequest)));
        this._bwEstimator.sample(fragLoadingProcessingMs, stats.loaded);
        stats.bwEstimate = this._bwEstimator.getEstimate();
        // if fragment has been loaded to perform a bitrate test, (hls.startLevel = -1), store bitrate test delay duration
        if (frag.bitrateTest) {
          this.bitrateTestDelay = fragLoadingProcessingMs / 1000;
        } else {
          this.bitrateTestDelay = 0;
        }
      }
    }
  }, {
    key: 'onError',
    value: function onError(data) {
      // stop timer in case of frag loading error
      switch (data.details) {
        case _errors.ErrorDetails.FRAG_LOAD_ERROR:
        case _errors.ErrorDetails.FRAG_LOAD_TIMEOUT:
          this.clearTimer();
          break;
        default:
          break;
      }
    }
  }, {
    key: 'clearTimer',
    value: function clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    // return next auto level

  }, {
    key: '_findBestLevel',
    value: function _findBestLevel(currentLevel, currentFragDuration, currentBw, minAutoLevel, maxAutoLevel, maxFetchDuration, bwFactor, bwUpFactor, levels) {
      for (var i = maxAutoLevel; i >= minAutoLevel; i--) {
        var levelInfo = levels[i],
            levelDetails = levelInfo.details,
            avgDuration = levelDetails ? levelDetails.totalduration / levelDetails.fragments.length : currentFragDuration,
            live = levelDetails ? levelDetails.live : false,
            adjustedbw = void 0;
        // follow algorithm captured from stagefright :
        // https://android.googlesource.com/platform/frameworks/av/+/master/media/libstagefright/httplive/LiveSession.cpp
        // Pick the highest bandwidth stream below or equal to estimated bandwidth.
        // consider only 80% of the available bandwidth, but if we are switching up,
        // be even more conservative (70%) to avoid overestimating and immediately
        // switching back.
        if (i <= currentLevel) {
          adjustedbw = bwFactor * currentBw;
        } else {
          adjustedbw = bwUpFactor * currentBw;
        }
        var bitrate = levels[i].realBitrate ? Math.max(levels[i].realBitrate, levels[i].bitrate) : levels[i].bitrate,
            fetchDuration = bitrate * avgDuration / adjustedbw;

        _logger.logger.trace('level/adjustedbw/bitrate/avgDuration/maxFetchDuration/fetchDuration: ' + i + '/' + Math.round(adjustedbw) + '/' + bitrate + '/' + avgDuration + '/' + maxFetchDuration + '/' + fetchDuration);
        // if adjusted bw is greater than level bitrate AND
        if (adjustedbw > bitrate && (
        // fragment fetchDuration unknown OR live stream OR fragment fetchDuration less than max allowed fetch duration, then this level matches
        // we don't account for max Fetch Duration for live streams, this is to avoid switching down when near the edge of live sliding window ...
        !fetchDuration || live || fetchDuration < maxFetchDuration)) {
          // as we are looping from highest to lowest, this will return the best achievable quality level

          return i;
        }
      }
      // not enough time budget even with quality level 0 ... rebuffering might happen
      return -1;
    }
  }, {
    key: 'nextAutoLevel',
    get: function get() {
      var forcedAutoLevel = this._nextAutoLevel;
      var bwEstimator = this._bwEstimator;
      // in case next auto level has been forced, and bw not available or not reliable, return forced value
      if (forcedAutoLevel !== -1 && (!bwEstimator || !bwEstimator.canEstimate())) {
        return forcedAutoLevel;
      }
      // compute next level using ABR logic
      var nextABRAutoLevel = this._nextABRAutoLevel;
      // if forced auto level has been defined, use it to cap ABR computed quality level
      if (forcedAutoLevel !== -1) {
        nextABRAutoLevel = Math.min(forcedAutoLevel, nextABRAutoLevel);
      }
      return nextABRAutoLevel;
    },
    set: function set(nextLevel) {
      this._nextAutoLevel = nextLevel;
    }
  }, {
    key: '_nextABRAutoLevel',
    get: function get() {
      var hls = this.hls,
          maxAutoLevel = hls.maxAutoLevel,
          levels = hls.levels,
          config = hls.config,
          minAutoLevel = hls.minAutoLevel;
      var v = hls.media,
          currentLevel = this.lastLoadedFragLevel,
          currentFragDuration = this.fragCurrent ? this.fragCurrent.duration : 0,
          pos = v ? v.currentTime : 0,

      // playbackRate is the absolute value of the playback rate; if v.playbackRate is 0, we use 1 to load as
      // if we're playing back at the normal rate.
      playbackRate = v && v.playbackRate !== 0 ? Math.abs(v.playbackRate) : 1.0,
          avgbw = this._bwEstimator ? this._bwEstimator.getEstimate() : config.abrEwmaDefaultEstimate,

      // bufferStarvationDelay is the wall-clock time left until the playback buffer is exhausted.
      bufferStarvationDelay = (_bufferHelper2.default.bufferInfo(v, pos, config.maxBufferHole).end - pos) / playbackRate;

      // First, look to see if we can find a level matching with our avg bandwidth AND that could also guarantee no rebuffering at all
      var bestLevel = this._findBestLevel(currentLevel, currentFragDuration, avgbw, minAutoLevel, maxAutoLevel, bufferStarvationDelay, config.abrBandWidthFactor, config.abrBandWidthUpFactor, levels);
      if (bestLevel >= 0) {
        return bestLevel;
      } else {
        _logger.logger.trace('rebuffering expected to happen, lets try to find a quality level minimizing the rebuffering');
        // not possible to get rid of rebuffering ... let's try to find level that will guarantee less than maxStarvationDelay of rebuffering
        // if no matching level found, logic will return 0
        var maxStarvationDelay = currentFragDuration ? Math.min(currentFragDuration, config.maxStarvationDelay) : config.maxStarvationDelay,
            bwFactor = config.abrBandWidthFactor,
            bwUpFactor = config.abrBandWidthUpFactor;
        if (bufferStarvationDelay === 0) {
          // in case buffer is empty, let's check if previous fragment was loaded to perform a bitrate test
          var bitrateTestDelay = this.bitrateTestDelay;
          if (bitrateTestDelay) {
            // if it is the case, then we need to adjust our max starvation delay using maxLoadingDelay config value
            // max video loading delay used in  automatic start level selection :
            // in that mode ABR controller will ensure that video loading time (ie the time to fetch the first fragment at lowest quality level +
            // the time to fetch the fragment at the appropriate quality level is less than ```maxLoadingDelay``` )
            // cap maxLoadingDelay and ensure it is not bigger 'than bitrate test' frag duration
            var maxLoadingDelay = currentFragDuration ? Math.min(currentFragDuration, config.maxLoadingDelay) : config.maxLoadingDelay;
            maxStarvationDelay = maxLoadingDelay - bitrateTestDelay;
            _logger.logger.trace('bitrate test took ' + Math.round(1000 * bitrateTestDelay) + 'ms, set first fragment max fetchDuration to ' + Math.round(1000 * maxStarvationDelay) + ' ms');
            // don't use conservative factor on bitrate test
            bwFactor = bwUpFactor = 1;
          }
        }
        bestLevel = this._findBestLevel(currentLevel, currentFragDuration, avgbw, minAutoLevel, maxAutoLevel, bufferStarvationDelay + maxStarvationDelay, bwFactor, bwUpFactor, levels);
        return Math.max(bestLevel, 0);
      }
    }
  }]);

  return AbrController;
}(_eventHandler2.default);

exports.default = AbrController;

/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _binarySearch = __webpack_require__(608);

var _binarySearch2 = _interopRequireDefault(_binarySearch);

var _bufferHelper = __webpack_require__(332);

var _bufferHelper2 = _interopRequireDefault(_bufferHelper);

var _demuxer = __webpack_require__(604);

var _demuxer2 = _interopRequireDefault(_demuxer);

var _events = __webpack_require__(39);

var _events2 = _interopRequireDefault(_events);

var _eventHandler = __webpack_require__(68);

var _eventHandler2 = _interopRequireDefault(_eventHandler);

var _levelHelper = __webpack_require__(607);

var _levelHelper2 = _interopRequireDefault(_levelHelper);

var _timeRanges = __webpack_require__(609);

var _timeRanges2 = _interopRequireDefault(_timeRanges);

var _errors = __webpack_require__(63);

var _logger = __webpack_require__(31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Audio Stream Controller
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */

var State = {
  STOPPED: 'STOPPED',
  STARTING: 'STARTING',
  IDLE: 'IDLE',
  PAUSED: 'PAUSED',
  KEY_LOADING: 'KEY_LOADING',
  FRAG_LOADING: 'FRAG_LOADING',
  FRAG_LOADING_WAITING_RETRY: 'FRAG_LOADING_WAITING_RETRY',
  WAITING_TRACK: 'WAITING_TRACK',
  PARSING: 'PARSING',
  PARSED: 'PARSED',
  BUFFER_FLUSHING: 'BUFFER_FLUSHING',
  ENDED: 'ENDED',
  ERROR: 'ERROR',
  WAITING_INIT_PTS: 'WAITING_INIT_PTS'
};

var AudioStreamController = function (_EventHandler) {
  _inherits(AudioStreamController, _EventHandler);

  function AudioStreamController(hls) {
    _classCallCheck(this, AudioStreamController);

    var _this = _possibleConstructorReturn(this, (AudioStreamController.__proto__ || Object.getPrototypeOf(AudioStreamController)).call(this, hls, _events2.default.MEDIA_ATTACHED, _events2.default.MEDIA_DETACHING, _events2.default.AUDIO_TRACKS_UPDATED, _events2.default.AUDIO_TRACK_SWITCHING, _events2.default.AUDIO_TRACK_LOADED, _events2.default.KEY_LOADED, _events2.default.FRAG_LOADED, _events2.default.FRAG_PARSING_INIT_SEGMENT, _events2.default.FRAG_PARSING_DATA, _events2.default.FRAG_PARSED, _events2.default.ERROR, _events2.default.BUFFER_CREATED, _events2.default.BUFFER_APPENDED, _events2.default.BUFFER_FLUSHED, _events2.default.INIT_PTS_FOUND));

    _this.config = hls.config;
    _this.audioCodecSwap = false;
    _this.ticks = 0;
    _this._state = State.STOPPED;
    _this.ontick = _this.tick.bind(_this);
    _this.initPTS = [];
    _this.waitingFragment = null;
    return _this;
  }

  _createClass(AudioStreamController, [{
    key: 'destroy',
    value: function destroy() {
      this.stopLoad();
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      _eventHandler2.default.prototype.destroy.call(this);
      this.state = State.STOPPED;
    }

    //Signal that video PTS was found

  }, {
    key: 'onInitPtsFound',
    value: function onInitPtsFound(data) {
      var demuxerId = data.id,
          cc = data.frag.cc,
          initPTS = data.initPTS;
      if (demuxerId === 'main') {
        //Always update the new INIT PTS
        //Can change due level switch
        this.initPTS[cc] = initPTS;
        _logger.logger.log('InitPTS for cc:' + cc + ' found from video track:' + initPTS);

        //If we are waiting we need to demux/remux the waiting frag
        //With the new initPTS
        if (this.state === State.WAITING_INIT_PTS) {
          _logger.logger.log('sending pending audio frag to demuxer');
          this.state = State.FRAG_LOADING;
          //We have audio frag waiting or video pts
          //Let process it
          this.onFragLoaded(this.waitingFragment);
          //Lets clean the waiting frag
          this.waitingFragment = null;
        }
      }
    }
  }, {
    key: 'startLoad',
    value: function startLoad(startPosition) {
      if (this.tracks) {
        var lastCurrentTime = this.lastCurrentTime;
        this.stopLoad();
        if (!this.timer) {
          this.timer = setInterval(this.ontick, 100);
        }
        this.fragLoadError = 0;
        if (lastCurrentTime > 0 && startPosition === -1) {
          _logger.logger.log('audio:override startPosition with lastCurrentTime @' + lastCurrentTime.toFixed(3));
          this.state = State.IDLE;
        } else {
          this.lastCurrentTime = this.startPosition ? this.startPosition : startPosition;
          this.state = State.STARTING;
        }
        this.nextLoadPosition = this.startPosition = this.lastCurrentTime;
        this.tick();
      } else {
        this.startPosition = startPosition;
        this.state = State.STOPPED;
      }
    }
  }, {
    key: 'stopLoad',
    value: function stopLoad() {
      var frag = this.fragCurrent;
      if (frag) {
        if (frag.loader) {
          frag.loader.abort();
        }
        this.fragCurrent = null;
      }
      this.fragPrevious = null;
      if (this.demuxer) {
        this.demuxer.destroy();
        this.demuxer = null;
      }
      this.state = State.STOPPED;
    }
  }, {
    key: 'tick',
    value: function tick() {
      this.ticks++;
      if (this.ticks === 1) {
        this.doTick();
        if (this.ticks > 1) {
          setTimeout(this.tick, 1);
        }
        this.ticks = 0;
      }
    }
  }, {
    key: 'doTick',
    value: function doTick() {
      var pos,
          track,
          trackDetails,
          hls = this.hls,
          config = hls.config;
      //logger.log('audioStream:' + this.state);
      switch (this.state) {
        case State.ERROR:
        //don't do anything in error state to avoid breaking further ...
        case State.PAUSED:
        //don't do anything in paused state either ...
        case State.BUFFER_FLUSHING:
          break;
        case State.STARTING:
          this.state = State.WAITING_TRACK;
          this.loadedmetadata = false;
          break;
        case State.IDLE:
          var tracks = this.tracks;
          // audio tracks not received => exit loop
          if (!tracks) {
            break;
          }
          // if video not attached AND
          // start fragment already requested OR start frag prefetch disable
          // exit loop
          // => if media not attached but start frag prefetch is enabled and start frag not requested yet, we will not exit loop
          if (!this.media && (this.startFragRequested || !config.startFragPrefetch)) {
            break;
          }
          // determine next candidate fragment to be loaded, based on current position and
          //  end of buffer position
          // if we have not yet loaded any fragment, start loading from start position
          if (this.loadedmetadata) {
            pos = this.media.currentTime;
          } else {
            pos = this.nextLoadPosition;
          }
          var media = this.mediaBuffer ? this.mediaBuffer : this.media,
              bufferInfo = _bufferHelper2.default.bufferInfo(media, pos, config.maxBufferHole),
              bufferLen = bufferInfo.len,
              bufferEnd = bufferInfo.end,
              fragPrevious = this.fragPrevious,
              maxBufLen = config.maxMaxBufferLength,
              audioSwitch = this.audioSwitch,
              trackId = this.trackId;

          // if buffer length is less than maxBufLen try to load a new fragment
          if ((bufferLen < maxBufLen || audioSwitch) && trackId < tracks.length) {
            trackDetails = tracks[trackId].details;
            // if track info not retrieved yet, switch state and wait for track retrieval
            if (typeof trackDetails === 'undefined') {
              this.state = State.WAITING_TRACK;
              break;
            }

            // we just got done loading the final fragment, check if we need to finalize media stream
            if (!audioSwitch && !trackDetails.live && fragPrevious && fragPrevious.sn === trackDetails.endSN) {
              // if we are not seeking or if we are seeking but everything (almost) til the end is buffered, let's signal eos
              // we don't compare exactly media.duration === bufferInfo.end as there could be some subtle media duration difference when switching
              // between different renditions. using half frag duration should help cope with these cases.
              if (!this.media.seeking || this.media.duration - bufferEnd < fragPrevious.duration / 2) {
                // Finalize the media stream
                this.hls.trigger(_events2.default.BUFFER_EOS, { type: 'audio' });
                this.state = State.ENDED;
                break;
              }
            }

            // find fragment index, contiguous with end of buffer position
            var fragments = trackDetails.fragments,
                fragLen = fragments.length,
                start = fragments[0].start,
                end = fragments[fragLen - 1].start + fragments[fragLen - 1].duration,
                frag = void 0;

            // When switching audio track, reload audio as close as possible to currentTime
            if (audioSwitch) {
              if (trackDetails.live && !trackDetails.PTSKnown) {
                _logger.logger.log('switching audiotrack, live stream, unknown PTS,load first fragment');
                bufferEnd = 0;
              } else {
                bufferEnd = pos;
                // if currentTime (pos) is less than alt audio playlist start time, it means that alt audio is ahead of currentTime
                if (trackDetails.PTSKnown && pos < start) {
                  // if everything is buffered from pos to start or if audio buffer upfront, let's seek to start
                  if (bufferInfo.end > start || bufferInfo.nextStart) {
                    _logger.logger.log('alt audio track ahead of main track, seek to start of alt audio track');
                    this.media.currentTime = start + 0.05;
                  } else {
                    return;
                  }
                }
              }
            }
            if (trackDetails.initSegment && !trackDetails.initSegment.data) {
              frag = trackDetails.initSegment;
            }
            // if bufferEnd before start of playlist, load first fragment
            else if (bufferEnd <= start) {
                frag = fragments[0];
                if (trackDetails.live && frag.loadIdx && frag.loadIdx === this.fragLoadIdx) {
                  // we just loaded this first fragment, and we are still lagging behind the start of the live playlist
                  // let's force seek to start
                  var nextBuffered = bufferInfo.nextStart ? bufferInfo.nextStart : start;
                  _logger.logger.log('no alt audio available @currentTime:' + this.media.currentTime + ', seeking @' + (nextBuffered + 0.05));
                  this.media.currentTime = nextBuffered + 0.05;
                  return;
                }
              } else {
                var foundFrag = void 0;
                var maxFragLookUpTolerance = config.maxFragLookUpTolerance;
                var fragNext = fragPrevious ? fragments[fragPrevious.sn - fragments[0].sn + 1] : undefined;
                var fragmentWithinToleranceTest = function fragmentWithinToleranceTest(candidate) {
                  // offset should be within fragment boundary - config.maxFragLookUpTolerance
                  // this is to cope with situations like
                  // bufferEnd = 9.991
                  // frag[Ø] : [0,10]
                  // frag[1] : [10,20]
                  // bufferEnd is within frag[0] range ... although what we are expecting is to return frag[1] here
                  //              frag start               frag start+duration
                  //                  |-----------------------------|
                  //              <--->                         <--->
                  //  ...--------><-----------------------------><---------....
                  // previous frag         matching fragment         next frag
                  //  return -1             return 0                 return 1
                  //logger.log(`level/sn/start/end/bufEnd:${level}/${candidate.sn}/${candidate.start}/${(candidate.start+candidate.duration)}/${bufferEnd}`);
                  // Set the lookup tolerance to be small enough to detect the current segment - ensures we don't skip over very small segments
                  var candidateLookupTolerance = Math.min(maxFragLookUpTolerance, candidate.duration);
                  if (candidate.start + candidate.duration - candidateLookupTolerance <= bufferEnd) {
                    return 1;
                  } // if maxFragLookUpTolerance will have negative value then don't return -1 for first element
                  else if (candidate.start - candidateLookupTolerance > bufferEnd && candidate.start) {
                      return -1;
                    }
                  return 0;
                };

                if (bufferEnd < end) {
                  if (bufferEnd > end - maxFragLookUpTolerance) {
                    maxFragLookUpTolerance = 0;
                  }
                  // Prefer the next fragment if it's within tolerance
                  if (fragNext && !fragmentWithinToleranceTest(fragNext)) {
                    foundFrag = fragNext;
                  } else {
                    foundFrag = _binarySearch2.default.search(fragments, fragmentWithinToleranceTest);
                  }
                } else {
                  // reach end of playlist
                  foundFrag = fragments[fragLen - 1];
                }
                if (foundFrag) {
                  frag = foundFrag;
                  start = foundFrag.start;
                  //logger.log('find SN matching with pos:' +  bufferEnd + ':' + frag.sn);
                  if (fragPrevious && frag.level === fragPrevious.level && frag.sn === fragPrevious.sn) {
                    if (frag.sn < trackDetails.endSN) {
                      frag = fragments[frag.sn + 1 - trackDetails.startSN];
                      _logger.logger.log('SN just loaded, load next one: ' + frag.sn);
                    } else {
                      frag = null;
                    }
                  }
                }
              }
            if (frag) {
              //logger.log('      loading frag ' + i +',pos/bufEnd:' + pos.toFixed(3) + '/' + bufferEnd.toFixed(3));
              if (frag.decryptdata && frag.decryptdata.uri != null && frag.decryptdata.key == null) {
                _logger.logger.log('Loading key for ' + frag.sn + ' of [' + trackDetails.startSN + ' ,' + trackDetails.endSN + '],track ' + trackId);
                this.state = State.KEY_LOADING;
                hls.trigger(_events2.default.KEY_LOADING, { frag: frag });
              } else {
                _logger.logger.log('Loading ' + frag.sn + ' of [' + trackDetails.startSN + ' ,' + trackDetails.endSN + '],track ' + trackId + ', currentTime:' + pos + ',bufferEnd:' + bufferEnd.toFixed(3));
                // ensure that we are not reloading the same fragments in loop ...
                if (this.fragLoadIdx !== undefined) {
                  this.fragLoadIdx++;
                } else {
                  this.fragLoadIdx = 0;
                }
                if (frag.loadCounter) {
                  frag.loadCounter++;
                  var maxThreshold = config.fragLoadingLoopThreshold;
                  // if this frag has already been loaded 3 times, and if it has been reloaded recently
                  if (frag.loadCounter > maxThreshold && Math.abs(this.fragLoadIdx - frag.loadIdx) < maxThreshold) {
                    hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.MEDIA_ERROR, details: _errors.ErrorDetails.FRAG_LOOP_LOADING_ERROR, fatal: false, frag: frag });
                    return;
                  }
                } else {
                  frag.loadCounter = 1;
                }
                frag.loadIdx = this.fragLoadIdx;
                this.fragCurrent = frag;
                this.startFragRequested = true;
                if (!isNaN(frag.sn)) {
                  this.nextLoadPosition = frag.start + frag.duration;
                }
                hls.trigger(_events2.default.FRAG_LOADING, { frag: frag });
                this.state = State.FRAG_LOADING;
              }
            }
          }
          break;
        case State.WAITING_TRACK:
          track = this.tracks[this.trackId];
          // check if playlist is already loaded
          if (track && track.details) {
            this.state = State.IDLE;
          }
          break;
        case State.FRAG_LOADING_WAITING_RETRY:
          var now = performance.now();
          var retryDate = this.retryDate;
          media = this.media;
          var isSeeking = media && media.seeking;
          // if current time is gt than retryDate, or if media seeking let's switch to IDLE state to retry loading
          if (!retryDate || now >= retryDate || isSeeking) {
            _logger.logger.log('audioStreamController: retryDate reached, switch back to IDLE state');
            this.state = State.IDLE;
          }
          break;
        case State.WAITING_INIT_PTS:
        case State.STOPPED:
        case State.FRAG_LOADING:
        case State.PARSING:
        case State.PARSED:
        case State.ENDED:
          break;
        default:
          break;
      }
    }
  }, {
    key: 'onMediaAttached',
    value: function onMediaAttached(data) {
      var media = this.media = this.mediaBuffer = data.media;
      this.onvseeking = this.onMediaSeeking.bind(this);
      this.onvended = this.onMediaEnded.bind(this);
      media.addEventListener('seeking', this.onvseeking);
      media.addEventListener('ended', this.onvended);
      var config = this.config;
      if (this.tracks && config.autoStartLoad) {
        this.startLoad(config.startPosition);
      }
    }
  }, {
    key: 'onMediaDetaching',
    value: function onMediaDetaching() {
      var media = this.media;
      if (media && media.ended) {
        _logger.logger.log('MSE detaching and video ended, reset startPosition');
        this.startPosition = this.lastCurrentTime = 0;
      }

      // reset fragment loading counter on MSE detaching to avoid reporting FRAG_LOOP_LOADING_ERROR after error recovery
      var tracks = this.tracks;
      if (tracks) {
        // reset fragment load counter
        tracks.forEach(function (track) {
          if (track.details) {
            track.details.fragments.forEach(function (fragment) {
              fragment.loadCounter = undefined;
            });
          }
        });
      }
      // remove video listeners
      if (media) {
        media.removeEventListener('seeking', this.onvseeking);
        media.removeEventListener('ended', this.onvended);
        this.onvseeking = this.onvseeked = this.onvended = null;
      }
      this.media = this.mediaBuffer = null;
      this.loadedmetadata = false;
      this.stopLoad();
    }
  }, {
    key: 'onMediaSeeking',
    value: function onMediaSeeking() {
      if (this.state === State.ENDED) {
        // switch to IDLE state to check for potential new fragment
        this.state = State.IDLE;
      }
      if (this.media) {
        this.lastCurrentTime = this.media.currentTime;
      }
      // avoid reporting fragment loop loading error in case user is seeking several times on same position
      if (this.fragLoadIdx !== undefined) {
        this.fragLoadIdx += 2 * this.config.fragLoadingLoopThreshold;
      }
      // tick to speed up processing
      this.tick();
    }
  }, {
    key: 'onMediaEnded',
    value: function onMediaEnded() {
      // reset startPosition and lastCurrentTime to restart playback @ stream beginning
      this.startPosition = this.lastCurrentTime = 0;
    }
  }, {
    key: 'onAudioTracksUpdated',
    value: function onAudioTracksUpdated(data) {
      _logger.logger.log('audio tracks updated');
      this.tracks = data.audioTracks;
    }
  }, {
    key: 'onAudioTrackSwitching',
    value: function onAudioTrackSwitching(data) {
      // if any URL found on new audio track, it is an alternate audio track
      var altAudio = !!data.url;
      this.trackId = data.id;
      this.state = State.IDLE;

      this.fragCurrent = null;
      this.state = State.PAUSED;
      this.waitingFragment = null;
      // destroy useless demuxer when switching audio to main
      if (!altAudio) {
        if (this.demuxer) {
          this.demuxer.destroy();
          this.demuxer = null;
        }
      } else {
        // switching to audio track, start timer if not already started
        if (!this.timer) {
          this.timer = setInterval(this.ontick, 100);
        }
      }

      //should we switch tracks ?
      if (altAudio) {
        this.audioSwitch = true;
        //main audio track are handled by stream-controller, just do something if switching to alt audio track
        this.state = State.IDLE;
        // increase fragment load Index to avoid frag loop loading error after buffer flush
        if (this.fragLoadIdx !== undefined) {
          this.fragLoadIdx += 2 * this.config.fragLoadingLoopThreshold;
        }
      }
      this.tick();
    }
  }, {
    key: 'onAudioTrackLoaded',
    value: function onAudioTrackLoaded(data) {
      var newDetails = data.details,
          trackId = data.id,
          track = this.tracks[trackId],
          duration = newDetails.totalduration,
          sliding = 0;

      _logger.logger.log('track ' + trackId + ' loaded [' + newDetails.startSN + ',' + newDetails.endSN + '],duration:' + duration);

      if (newDetails.live) {
        var curDetails = track.details;
        if (curDetails && newDetails.fragments.length > 0) {
          // we already have details for that level, merge them
          _levelHelper2.default.mergeDetails(curDetails, newDetails);
          sliding = newDetails.fragments[0].start;
          // TODO
          //this.liveSyncPosition = this.computeLivePosition(sliding, curDetails);
          if (newDetails.PTSKnown) {
            _logger.logger.log('live audio playlist sliding:' + sliding.toFixed(3));
          } else {
            _logger.logger.log('live audio playlist - outdated PTS, unknown sliding');
          }
        } else {
          newDetails.PTSKnown = false;
          _logger.logger.log('live audio playlist - first load, unknown sliding');
        }
      } else {
        newDetails.PTSKnown = false;
      }
      track.details = newDetails;

      // compute start position
      if (!this.startFragRequested) {
        // compute start position if set to -1. use it straight away if value is defined
        if (this.startPosition === -1) {
          // first, check if start time offset has been set in playlist, if yes, use this value
          var startTimeOffset = newDetails.startTimeOffset;
          if (!isNaN(startTimeOffset)) {
            _logger.logger.log('start time offset found in playlist, adjust startPosition to ' + startTimeOffset);
            this.startPosition = startTimeOffset;
          } else {
            this.startPosition = 0;
          }
        }
        this.nextLoadPosition = this.startPosition;
      }
      // only switch batck to IDLE state if we were waiting for track to start downloading a new fragment
      if (this.state === State.WAITING_TRACK) {
        this.state = State.IDLE;
      }
      //trigger handler right now
      this.tick();
    }
  }, {
    key: 'onKeyLoaded',
    value: function onKeyLoaded() {
      if (this.state === State.KEY_LOADING) {
        this.state = State.IDLE;
        this.tick();
      }
    }
  }, {
    key: 'onFragLoaded',
    value: function onFragLoaded(data) {
      var fragCurrent = this.fragCurrent,
          fragLoaded = data.frag;
      if (this.state === State.FRAG_LOADING && fragCurrent && fragLoaded.type === 'audio' && fragLoaded.level === fragCurrent.level && fragLoaded.sn === fragCurrent.sn) {
        var track = this.tracks[this.trackId],
            details = track.details,
            duration = details.totalduration,
            trackId = fragCurrent.level,
            sn = fragCurrent.sn,
            cc = fragCurrent.cc,
            audioCodec = this.config.defaultAudioCodec || track.audioCodec || 'mp4a.40.2',
            stats = this.stats = data.stats;
        if (sn === 'initSegment') {
          this.state = State.IDLE;

          stats.tparsed = stats.tbuffered = performance.now();
          details.initSegment.data = data.payload;
          this.hls.trigger(_events2.default.FRAG_BUFFERED, { stats: stats, frag: fragCurrent, id: 'audio' });
          this.tick();
        } else {
          this.state = State.PARSING;
          // transmux the MPEG-TS data to ISO-BMFF segments
          this.appended = false;
          if (!this.demuxer) {
            this.demuxer = new _demuxer2.default(this.hls, 'audio');
          }
          //Check if we have video initPTS
          // If not we need to wait for it
          var initPTS = this.initPTS[cc];
          var initSegmentData = details.initSegment ? details.initSegment.data : [];
          if (details.initSegment || initPTS !== undefined) {
            this.pendingBuffering = true;
            _logger.logger.log('Demuxing ' + sn + ' of [' + details.startSN + ' ,' + details.endSN + '],track ' + trackId);
            // time Offset is accurate if level PTS is known, or if playlist is not sliding (not live)
            var accurateTimeOffset = false; //details.PTSKnown || !details.live;
            this.demuxer.push(data.payload, initSegmentData, audioCodec, null, fragCurrent, duration, accurateTimeOffset, initPTS);
          } else {
            _logger.logger.log('unknown video PTS for continuity counter ' + cc + ', waiting for video PTS before demuxing audio frag ' + sn + ' of [' + details.startSN + ' ,' + details.endSN + '],track ' + trackId);
            this.waitingFragment = data;
            this.state = State.WAITING_INIT_PTS;
          }
        }
      }
      this.fragLoadError = 0;
    }
  }, {
    key: 'onFragParsingInitSegment',
    value: function onFragParsingInitSegment(data) {
      var fragCurrent = this.fragCurrent;
      var fragNew = data.frag;
      if (fragCurrent && data.id === 'audio' && fragNew.sn === fragCurrent.sn && fragNew.level === fragCurrent.level && this.state === State.PARSING) {
        var tracks = data.tracks,
            track = void 0;

        // delete any video track found on audio demuxer
        if (tracks.video) {
          delete tracks.video;
        }

        // include levelCodec in audio and video tracks
        track = tracks.audio;
        if (track) {
          track.levelCodec = 'mp4a.40.2';
          track.id = data.id;
          this.hls.trigger(_events2.default.BUFFER_CODECS, tracks);
          _logger.logger.log('audio track:audio,container:' + track.container + ',codecs[level/parsed]=[' + track.levelCodec + '/' + track.codec + ']');
          var initSegment = track.initSegment;
          if (initSegment) {
            var appendObj = { type: 'audio', data: initSegment, parent: 'audio', content: 'initSegment' };
            if (this.audioSwitch) {
              this.pendingData = [appendObj];
            } else {
              this.appended = true;
              // arm pending Buffering flag before appending a segment
              this.pendingBuffering = true;
              this.hls.trigger(_events2.default.BUFFER_APPENDING, appendObj);
            }
          }
          //trigger handler right now
          this.tick();
        }
      }
    }
  }, {
    key: 'onFragParsingData',
    value: function onFragParsingData(data) {
      var _this2 = this;

      var fragCurrent = this.fragCurrent;
      var fragNew = data.frag;
      if (fragCurrent && data.id === 'audio' && data.type === 'audio' && fragNew.sn === fragCurrent.sn && fragNew.level === fragCurrent.level && this.state === State.PARSING) {
        var trackId = this.trackId,
            track = this.tracks[trackId],
            hls = this.hls;

        if (isNaN(data.endPTS)) {
          data.endPTS = data.startPTS + fragCurrent.duration;
          data.endDTS = data.startDTS + fragCurrent.duration;
        }

        _logger.logger.log('parsed ' + data.type + ',PTS:[' + data.startPTS.toFixed(3) + ',' + data.endPTS.toFixed(3) + '],DTS:[' + data.startDTS.toFixed(3) + '/' + data.endDTS.toFixed(3) + '],nb:' + data.nb);
        _levelHelper2.default.updateFragPTSDTS(track.details, fragCurrent, data.startPTS, data.endPTS);

        var audioSwitch = this.audioSwitch,
            media = this.media,
            appendOnBufferFlush = false;
        //Only flush audio from old audio tracks when PTS is known on new audio track
        if (audioSwitch && media) {
          if (media.readyState) {
            var currentTime = media.currentTime;
            _logger.logger.log('switching audio track : currentTime:' + currentTime);
            if (currentTime >= data.startPTS) {
              _logger.logger.log('switching audio track : flushing all audio');
              this.state = State.BUFFER_FLUSHING;
              hls.trigger(_events2.default.BUFFER_FLUSHING, { startOffset: 0, endOffset: Number.POSITIVE_INFINITY, type: 'audio' });
              appendOnBufferFlush = true;
              //Lets announce that the initial audio track switch flush occur
              this.audioSwitch = false;
              hls.trigger(_events2.default.AUDIO_TRACK_SWITCHED, { id: trackId });
            }
          } else {
            //Lets announce that the initial audio track switch flush occur
            this.audioSwitch = false;
            hls.trigger(_events2.default.AUDIO_TRACK_SWITCHED, { id: trackId });
          }
        }

        var pendingData = this.pendingData;
        if (!this.audioSwitch) {
          [data.data1, data.data2].forEach(function (buffer) {
            if (buffer && buffer.length) {
              pendingData.push({ type: data.type, data: buffer, parent: 'audio', content: 'data' });
            }
          });
          if (!appendOnBufferFlush && pendingData.length) {
            pendingData.forEach(function (appendObj) {
              // only append in PARSING state (rationale is that an appending error could happen synchronously on first segment appending)
              // in that case it is useless to append following segments
              if (_this2.state === State.PARSING) {
                // arm pending Buffering flag before appending a segment
                _this2.pendingBuffering = true;
                _this2.hls.trigger(_events2.default.BUFFER_APPENDING, appendObj);
              }
            });
            this.pendingData = [];
            this.appended = true;
          }
        }
        //trigger handler right now
        this.tick();
      }
    }
  }, {
    key: 'onFragParsed',
    value: function onFragParsed(data) {
      var fragCurrent = this.fragCurrent;
      var fragNew = data.frag;
      if (fragCurrent && data.id === 'audio' && fragNew.sn === fragCurrent.sn && fragNew.level === fragCurrent.level && this.state === State.PARSING) {
        this.stats.tparsed = performance.now();
        this.state = State.PARSED;
        this._checkAppendedParsed();
      }
    }
  }, {
    key: 'onBufferCreated',
    value: function onBufferCreated(data) {
      var audioTrack = data.tracks.audio;
      if (audioTrack) {
        this.mediaBuffer = audioTrack.buffer;
        this.loadedmetadata = true;
      }
    }
  }, {
    key: 'onBufferAppended',
    value: function onBufferAppended(data) {
      if (data.parent === 'audio') {
        var state = this.state;
        if (state === State.PARSING || state === State.PARSED) {
          // check if all buffers have been appended
          this.pendingBuffering = data.pending > 0;
          this._checkAppendedParsed();
        }
      }
    }
  }, {
    key: '_checkAppendedParsed',
    value: function _checkAppendedParsed() {
      //trigger handler right now
      if (this.state === State.PARSED && (!this.appended || !this.pendingBuffering)) {
        var frag = this.fragCurrent,
            stats = this.stats,
            hls = this.hls;
        if (frag) {
          this.fragPrevious = frag;
          stats.tbuffered = performance.now();
          hls.trigger(_events2.default.FRAG_BUFFERED, { stats: stats, frag: frag, id: 'audio' });
          var media = this.mediaBuffer ? this.mediaBuffer : this.media;
          _logger.logger.log('audio buffered : ' + _timeRanges2.default.toString(media.buffered));
          if (this.audioSwitch && this.appended) {
            this.audioSwitch = false;
            hls.trigger(_events2.default.AUDIO_TRACK_SWITCHED, { id: this.trackId });
          }
          this.state = State.IDLE;
        }
        this.tick();
      }
    }
  }, {
    key: 'onError',
    value: function onError(data) {
      var frag = data.frag;
      // don't handle frag error not related to audio fragment
      if (frag && frag.type !== 'audio') {
        return;
      }
      switch (data.details) {
        case _errors.ErrorDetails.FRAG_LOAD_ERROR:
        case _errors.ErrorDetails.FRAG_LOAD_TIMEOUT:
          if (!data.fatal) {
            var loadError = this.fragLoadError;
            if (loadError) {
              loadError++;
            } else {
              loadError = 1;
            }
            var config = this.config;
            if (loadError <= config.fragLoadingMaxRetry) {
              this.fragLoadError = loadError;
              // reset load counter to avoid frag loop loading error
              frag.loadCounter = 0;
              // exponential backoff capped to config.fragLoadingMaxRetryTimeout
              var delay = Math.min(Math.pow(2, loadError - 1) * config.fragLoadingRetryDelay, config.fragLoadingMaxRetryTimeout);
              _logger.logger.warn('audioStreamController: frag loading failed, retry in ' + delay + ' ms');
              this.retryDate = performance.now() + delay;
              // retry loading state
              this.state = State.FRAG_LOADING_WAITING_RETRY;
            } else {
              _logger.logger.error('audioStreamController: ' + data.details + ' reaches max retry, redispatch as fatal ...');
              // switch error to fatal
              data.fatal = true;
              this.state = State.ERROR;
            }
          }
          break;
        case _errors.ErrorDetails.FRAG_LOOP_LOADING_ERROR:
        case _errors.ErrorDetails.AUDIO_TRACK_LOAD_ERROR:
        case _errors.ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT:
        case _errors.ErrorDetails.KEY_LOAD_ERROR:
        case _errors.ErrorDetails.KEY_LOAD_TIMEOUT:
          //  when in ERROR state, don't switch back to IDLE state in case a non-fatal error is received
          if (this.state !== State.ERROR) {
            // if fatal error, stop processing, otherwise move to IDLE to retry loading
            this.state = data.fatal ? State.ERROR : State.IDLE;
            _logger.logger.warn('audioStreamController: ' + data.details + ' while loading frag,switch to ' + this.state + ' state ...');
          }
          break;
        case _errors.ErrorDetails.BUFFER_FULL_ERROR:
          // if in appending state
          if (data.parent === 'audio' && (this.state === State.PARSING || this.state === State.PARSED)) {
            var media = this.mediaBuffer,
                currentTime = this.media.currentTime,
                mediaBuffered = media && _bufferHelper2.default.isBuffered(media, currentTime) && _bufferHelper2.default.isBuffered(media, currentTime + 0.5);
            // reduce max buf len if current position is buffered
            if (mediaBuffered) {
              var _config = this.config;
              if (_config.maxMaxBufferLength >= _config.maxBufferLength) {
                // reduce max buffer length as it might be too high. we do this to avoid loop flushing ...
                _config.maxMaxBufferLength /= 2;
                _logger.logger.warn('audio:reduce max buffer length to ' + _config.maxMaxBufferLength + 's');
                // increase fragment load Index to avoid frag loop loading error after buffer flush
                this.fragLoadIdx += 2 * _config.fragLoadingLoopThreshold;
              }
              this.state = State.IDLE;
            } else {
              // current position is not buffered, but browser is still complaining about buffer full error
              // this happens on IE/Edge, refer to https://github.com/video-dev/hls.js/pull/708
              // in that case flush the whole audio buffer to recover
              _logger.logger.warn('buffer full error also media.currentTime is not buffered, flush audio buffer');
              this.fragCurrent = null;
              // flush everything
              this.state = State.BUFFER_FLUSHING;
              this.hls.trigger(_events2.default.BUFFER_FLUSHING, { startOffset: 0, endOffset: Number.POSITIVE_INFINITY, type: 'audio' });
            }
          }
          break;
        default:
          break;
      }
    }
  }, {
    key: 'onBufferFlushed',
    value: function onBufferFlushed() {
      var _this3 = this;

      var pendingData = this.pendingData;
      if (pendingData && pendingData.length) {
        _logger.logger.log('appending pending audio data on Buffer Flushed');
        pendingData.forEach(function (appendObj) {
          _this3.hls.trigger(_events2.default.BUFFER_APPENDING, appendObj);
        });
        this.appended = true;
        this.pendingData = [];
        this.state = State.PARSED;
      } else {
        // move to IDLE once flush complete. this should trigger new fragment loading
        this.state = State.IDLE;
        // reset reference to frag
        this.fragPrevious = null;
        this.tick();
      }
    }
  }, {
    key: 'state',
    set: function set(nextState) {
      if (this.state !== nextState) {
        var previousState = this.state;
        this._state = nextState;
        _logger.logger.log('audio stream:' + previousState + '->' + nextState);
      }
    },
    get: function get() {
      return this._state;
    }
  }]);

  return AudioStreamController;
}(_eventHandler2.default);

exports.default = AudioStreamController;

/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events = __webpack_require__(39);

var _events2 = _interopRequireDefault(_events);

var _eventHandler = __webpack_require__(68);

var _eventHandler2 = _interopRequireDefault(_eventHandler);

var _logger = __webpack_require__(31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * audio track controller
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */

var AudioTrackController = function (_EventHandler) {
  _inherits(AudioTrackController, _EventHandler);

  function AudioTrackController(hls) {
    _classCallCheck(this, AudioTrackController);

    var _this = _possibleConstructorReturn(this, (AudioTrackController.__proto__ || Object.getPrototypeOf(AudioTrackController)).call(this, hls, _events2.default.MANIFEST_LOADING, _events2.default.MANIFEST_LOADED, _events2.default.AUDIO_TRACK_LOADED));

    _this.ticks = 0;
    _this.ontick = _this.tick.bind(_this);
    return _this;
  }

  _createClass(AudioTrackController, [{
    key: 'destroy',
    value: function destroy() {
      _eventHandler2.default.prototype.destroy.call(this);
    }
  }, {
    key: 'tick',
    value: function tick() {
      this.ticks++;
      if (this.ticks === 1) {
        this.doTick();
        if (this.ticks > 1) {
          setTimeout(this.tick, 1);
        }
        this.ticks = 0;
      }
    }
  }, {
    key: 'doTick',
    value: function doTick() {
      this.updateTrack(this.trackId);
    }
  }, {
    key: 'onManifestLoading',
    value: function onManifestLoading() {
      // reset audio tracks on manifest loading
      this.tracks = [];
      this.trackId = -1;
    }
  }, {
    key: 'onManifestLoaded',
    value: function onManifestLoaded(data) {
      var _this2 = this;

      var tracks = data.audioTracks || [];
      var defaultFound = false;
      this.tracks = tracks;
      this.hls.trigger(_events2.default.AUDIO_TRACKS_UPDATED, { audioTracks: tracks });
      // loop through available audio tracks and autoselect default if needed
      var id = 0;
      tracks.forEach(function (track) {
        if (track.default) {
          _this2.audioTrack = id;
          defaultFound = true;
          return;
        }
        id++;
      });
      if (defaultFound === false && tracks.length) {
        _logger.logger.log('no default audio track defined, use first audio track as default');
        this.audioTrack = 0;
      }
    }
  }, {
    key: 'onAudioTrackLoaded',
    value: function onAudioTrackLoaded(data) {
      if (data.id < this.tracks.length) {
        _logger.logger.log('audioTrack ' + data.id + ' loaded');
        this.tracks[data.id].details = data.details;
        // check if current playlist is a live playlist
        if (data.details.live && !this.timer) {
          // if live playlist we will have to reload it periodically
          // set reload period to playlist target duration
          this.timer = setInterval(this.ontick, 1000 * data.details.targetduration);
        }
        if (!data.details.live && this.timer) {
          // playlist is not live and timer is armed : stopping it
          clearInterval(this.timer);
          this.timer = null;
        }
      }
    }

    /** get alternate audio tracks list from playlist **/

  }, {
    key: 'setAudioTrackInternal',
    value: function setAudioTrackInternal(newId) {
      // check if level idx is valid
      if (newId >= 0 && newId < this.tracks.length) {
        // stopping live reloading timer if any
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
        this.trackId = newId;
        _logger.logger.log('switching to audioTrack ' + newId);
        var audioTrack = this.tracks[newId],
            hls = this.hls,
            type = audioTrack.type,
            url = audioTrack.url,
            eventObj = { id: newId, type: type, url: url };
        // keep AUDIO_TRACK_SWITCH for legacy reason
        hls.trigger(_events2.default.AUDIO_TRACK_SWITCH, eventObj);
        hls.trigger(_events2.default.AUDIO_TRACK_SWITCHING, eventObj);
        // check if we need to load playlist for this audio Track
        var details = audioTrack.details;
        if (url && (details === undefined || details.live === true)) {
          // track not retrieved yet, or live playlist we need to (re)load it
          _logger.logger.log('(re)loading playlist for audioTrack ' + newId);
          hls.trigger(_events2.default.AUDIO_TRACK_LOADING, { url: url, id: newId });
        }
      }
    }
  }, {
    key: 'updateTrack',
    value: function updateTrack(newId) {
      // check if level idx is valid
      if (newId >= 0 && newId < this.tracks.length) {
        // stopping live reloading timer if any
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
        this.trackId = newId;
        _logger.logger.log('updating audioTrack ' + newId);
        var audioTrack = this.tracks[newId],
            url = audioTrack.url;
        // check if we need to load playlist for this audio Track
        var details = audioTrack.details;
        if (url && (details === undefined || details.live === true)) {
          // track not retrieved yet, or live playlist we need to (re)load it
          _logger.logger.log('(re)loading playlist for audioTrack ' + newId);
          this.hls.trigger(_events2.default.AUDIO_TRACK_LOADING, { url: url, id: newId });
        }
      }
    }
  }, {
    key: 'audioTracks',
    get: function get() {
      return this.tracks;
    }

    /** get index of the selected audio track (index in audio track lists) **/

  }, {
    key: 'audioTrack',
    get: function get() {
      return this.trackId;
    }

    /** select an audio track, based on its index in audio track lists**/
    ,
    set: function set(audioTrackId) {
      if (this.trackId !== audioTrackId || this.tracks[audioTrackId].details === undefined) {
        this.setAudioTrackInternal(audioTrackId);
      }
    }
  }]);

  return AudioTrackController;
}(_eventHandler2.default);

exports.default = AudioTrackController;

/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events = __webpack_require__(39);

var _events2 = _interopRequireDefault(_events);

var _eventHandler = __webpack_require__(68);

var _eventHandler2 = _interopRequireDefault(_eventHandler);

var _logger = __webpack_require__(31);

var _errors = __webpack_require__(63);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Buffer Controller
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */

var BufferController = function (_EventHandler) {
  _inherits(BufferController, _EventHandler);

  function BufferController(hls) {
    _classCallCheck(this, BufferController);

    // the value that we have set mediasource.duration to
    // (the actual duration may be tweaked slighly by the browser)
    var _this = _possibleConstructorReturn(this, (BufferController.__proto__ || Object.getPrototypeOf(BufferController)).call(this, hls, _events2.default.MEDIA_ATTACHING, _events2.default.MEDIA_DETACHING, _events2.default.MANIFEST_PARSED, _events2.default.BUFFER_RESET, _events2.default.BUFFER_APPENDING, _events2.default.BUFFER_CODECS, _events2.default.BUFFER_EOS, _events2.default.BUFFER_FLUSHING, _events2.default.LEVEL_PTS_UPDATED, _events2.default.LEVEL_UPDATED));

    _this._msDuration = null;
    // the value that we want to set mediaSource.duration to
    _this._levelDuration = null;

    // Source Buffer listeners
    _this.onsbue = _this.onSBUpdateEnd.bind(_this);
    _this.onsbe = _this.onSBUpdateError.bind(_this);
    _this.pendingTracks = {};
    _this.tracks = {};
    return _this;
  }

  _createClass(BufferController, [{
    key: 'destroy',
    value: function destroy() {
      _eventHandler2.default.prototype.destroy.call(this);
    }
  }, {
    key: 'onLevelPtsUpdated',
    value: function onLevelPtsUpdated(data) {
      var type = data.type;
      var audioTrack = this.tracks.audio;

      // Adjusting `SourceBuffer.timestampOffset` (desired point in the timeline where the next frames should be appended)
      // in Chrome browser when we detect MPEG audio container and time delta between level PTS and `SourceBuffer.timestampOffset`
      // is greater than 100ms (this is enough to handle seek for VOD or level change for LIVE videos). At the time of change we issue
      // `SourceBuffer.abort()` and adjusting `SourceBuffer.timestampOffset` if `SourceBuffer.updating` is false or awaiting `updateend`
      // event if SB is in updating state.
      // More info here: https://github.com/video-dev/hls.js/issues/332#issuecomment-257986486

      if (type === 'audio' && audioTrack && audioTrack.container === 'audio/mpeg') {
        // Chrome audio mp3 track
        var audioBuffer = this.sourceBuffer.audio;
        var delta = Math.abs(audioBuffer.timestampOffset - data.start);

        // adjust timestamp offset if time delta is greater than 100ms
        if (delta > 0.1) {
          var updating = audioBuffer.updating;

          try {
            audioBuffer.abort();
          } catch (err) {
            updating = true;
            _logger.logger.warn('can not abort audio buffer: ' + err);
          }

          if (!updating) {
            _logger.logger.warn('change mpeg audio timestamp offset from ' + audioBuffer.timestampOffset + ' to ' + data.start);
            audioBuffer.timestampOffset = data.start;
          } else {
            this.audioTimestampOffset = data.start;
          }
        }
      }
    }
  }, {
    key: 'onManifestParsed',
    value: function onManifestParsed(data) {
      var audioExpected = data.audio,
          videoExpected = data.video,
          sourceBufferNb = 0;
      // in case of alt audio 2 BUFFER_CODECS events will be triggered, one per stream controller
      // sourcebuffers will be created all at once when the expected nb of tracks will be reached
      // in case alt audio is not used, only one BUFFER_CODEC event will be fired from main stream controller
      // it will contain the expected nb of source buffers, no need to compute it
      if (data.altAudio && (audioExpected || videoExpected)) {
        sourceBufferNb = (audioExpected ? 1 : 0) + (videoExpected ? 1 : 0);
        _logger.logger.log(sourceBufferNb + ' sourceBuffer(s) expected');
      }
      this.sourceBufferNb = sourceBufferNb;
    }
  }, {
    key: 'onMediaAttaching',
    value: function onMediaAttaching(data) {
      var media = this.media = data.media;
      if (media) {
        // setup the media source
        var ms = this.mediaSource = new MediaSource();
        //Media Source listeners
        this.onmso = this.onMediaSourceOpen.bind(this);
        this.onmse = this.onMediaSourceEnded.bind(this);
        this.onmsc = this.onMediaSourceClose.bind(this);
        ms.addEventListener('sourceopen', this.onmso);
        ms.addEventListener('sourceended', this.onmse);
        ms.addEventListener('sourceclose', this.onmsc);
        // link video and media Source
        media.src = URL.createObjectURL(ms);
      }
    }
  }, {
    key: 'onMediaDetaching',
    value: function onMediaDetaching() {
      _logger.logger.log('media source detaching');
      var ms = this.mediaSource;
      if (ms) {
        if (ms.readyState === 'open') {
          try {
            // endOfStream could trigger exception if any sourcebuffer is in updating state
            // we don't really care about checking sourcebuffer state here,
            // as we are anyway detaching the MediaSource
            // let's just avoid this exception to propagate
            ms.endOfStream();
          } catch (err) {
            _logger.logger.warn('onMediaDetaching:' + err.message + ' while calling endOfStream');
          }
        }
        ms.removeEventListener('sourceopen', this.onmso);
        ms.removeEventListener('sourceended', this.onmse);
        ms.removeEventListener('sourceclose', this.onmsc);

        // Detach properly the MediaSource from the HTMLMediaElement as
        // suggested in https://github.com/w3c/media-source/issues/53.
        if (this.media) {
          URL.revokeObjectURL(this.media.src);
          this.media.removeAttribute('src');
          this.media.load();
        }

        this.mediaSource = null;
        this.media = null;
        this.pendingTracks = {};
        this.tracks = {};
        this.sourceBuffer = {};
        this.flushRange = [];
        this.segments = [];
        this.appended = 0;
      }
      this.onmso = this.onmse = this.onmsc = null;
      this.hls.trigger(_events2.default.MEDIA_DETACHED);
    }
  }, {
    key: 'onMediaSourceOpen',
    value: function onMediaSourceOpen() {
      _logger.logger.log('media source opened');
      this.hls.trigger(_events2.default.MEDIA_ATTACHED, { media: this.media });
      var mediaSource = this.mediaSource;
      if (mediaSource) {
        // once received, don't listen anymore to sourceopen event
        mediaSource.removeEventListener('sourceopen', this.onmso);
      }
      this.checkPendingTracks();
    }
  }, {
    key: 'checkPendingTracks',
    value: function checkPendingTracks() {
      // if any buffer codecs pending, check if we have enough to create sourceBuffers
      var pendingTracks = this.pendingTracks,
          pendingTracksNb = Object.keys(pendingTracks).length;
      // if any pending tracks and (if nb of pending tracks gt or equal than expected nb or if unknown expected nb)
      if (pendingTracksNb && (this.sourceBufferNb <= pendingTracksNb || this.sourceBufferNb === 0)) {
        // ok, let's create them now !
        this.createSourceBuffers(pendingTracks);
        this.pendingTracks = {};
        // append any pending segments now !
        this.doAppending();
      }
    }
  }, {
    key: 'onMediaSourceClose',
    value: function onMediaSourceClose() {
      _logger.logger.log('media source closed');
    }
  }, {
    key: 'onMediaSourceEnded',
    value: function onMediaSourceEnded() {
      _logger.logger.log('media source ended');
    }
  }, {
    key: 'onSBUpdateEnd',
    value: function onSBUpdateEnd() {
      // update timestampOffset
      if (this.audioTimestampOffset) {
        var audioBuffer = this.sourceBuffer.audio;
        _logger.logger.warn('change mpeg audio timestamp offset from ' + audioBuffer.timestampOffset + ' to ' + this.audioTimestampOffset);
        audioBuffer.timestampOffset = this.audioTimestampOffset;
        delete this.audioTimestampOffset;
      }

      if (this._needsFlush) {
        this.doFlush();
      }

      if (this._needsEos) {
        this.checkEos();
      }
      this.appending = false;
      var parent = this.parent;
      // count nb of pending segments waiting for appending on this sourcebuffer
      var pending = this.segments.reduce(function (counter, segment) {
        return segment.parent === parent ? counter + 1 : counter;
      }, 0);
      this.hls.trigger(_events2.default.BUFFER_APPENDED, { parent: parent, pending: pending });

      // don't append in flushing mode
      if (!this._needsFlush) {
        this.doAppending();
      }

      this.updateMediaElementDuration();
    }
  }, {
    key: 'onSBUpdateError',
    value: function onSBUpdateError(event) {
      _logger.logger.error('sourceBuffer error:', event);
      // according to http://www.w3.org/TR/media-source/#sourcebuffer-append-error
      // this error might not always be fatal (it is fatal if decode error is set, in that case
      // it will be followed by a mediaElement error ...)
      this.hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.MEDIA_ERROR, details: _errors.ErrorDetails.BUFFER_APPENDING_ERROR, fatal: false });
      // we don't need to do more than that, as accordin to the spec, updateend will be fired just after
    }
  }, {
    key: 'onBufferReset',
    value: function onBufferReset() {
      var sourceBuffer = this.sourceBuffer;
      for (var type in sourceBuffer) {
        var sb = sourceBuffer[type];
        try {
          this.mediaSource.removeSourceBuffer(sb);
          sb.removeEventListener('updateend', this.onsbue);
          sb.removeEventListener('error', this.onsbe);
        } catch (err) {}
      }
      this.sourceBuffer = {};
      this.flushRange = [];
      this.segments = [];
      this.appended = 0;
    }
  }, {
    key: 'onBufferCodecs',
    value: function onBufferCodecs(tracks) {
      // if source buffer(s) not created yet, appended buffer tracks in this.pendingTracks
      // if sourcebuffers already created, do nothing ...
      if (Object.keys(this.sourceBuffer).length === 0) {
        for (var trackName in tracks) {
          this.pendingTracks[trackName] = tracks[trackName];
        }
        var mediaSource = this.mediaSource;
        if (mediaSource && mediaSource.readyState === 'open') {
          // try to create sourcebuffers if mediasource opened
          this.checkPendingTracks();
        }
      }
    }
  }, {
    key: 'createSourceBuffers',
    value: function createSourceBuffers(tracks) {
      var sourceBuffer = this.sourceBuffer,
          mediaSource = this.mediaSource;

      for (var trackName in tracks) {
        if (!sourceBuffer[trackName]) {
          var track = tracks[trackName];
          // use levelCodec as first priority
          var codec = track.levelCodec || track.codec;
          var mimeType = track.container + ';codecs=' + codec;
          _logger.logger.log('creating sourceBuffer(' + mimeType + ')');
          try {
            var sb = sourceBuffer[trackName] = mediaSource.addSourceBuffer(mimeType);
            sb.addEventListener('updateend', this.onsbue);
            sb.addEventListener('error', this.onsbe);
            this.tracks[trackName] = { codec: codec, container: track.container };
            track.buffer = sb;
          } catch (err) {
            _logger.logger.error('error while trying to add sourceBuffer:' + err.message);
            this.hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.MEDIA_ERROR, details: _errors.ErrorDetails.BUFFER_ADD_CODEC_ERROR, fatal: false, err: err, mimeType: mimeType });
          }
        }
      }
      this.hls.trigger(_events2.default.BUFFER_CREATED, { tracks: tracks });
    }
  }, {
    key: 'onBufferAppending',
    value: function onBufferAppending(data) {
      if (!this._needsFlush) {
        if (!this.segments) {
          this.segments = [data];
        } else {
          this.segments.push(data);
        }
        this.doAppending();
      }
    }
  }, {
    key: 'onBufferAppendFail',
    value: function onBufferAppendFail(data) {
      _logger.logger.error('sourceBuffer error:', data.event);
      // according to http://www.w3.org/TR/media-source/#sourcebuffer-append-error
      // this error might not always be fatal (it is fatal if decode error is set, in that case
      // it will be followed by a mediaElement error ...)
      this.hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.MEDIA_ERROR, details: _errors.ErrorDetails.BUFFER_APPENDING_ERROR, fatal: false });
    }

    // on BUFFER_EOS mark matching sourcebuffer(s) as ended and trigger checkEos()

  }, {
    key: 'onBufferEos',
    value: function onBufferEos(data) {
      var sb = this.sourceBuffer;
      var dataType = data.type;
      for (var type in sb) {
        if (!dataType || type === dataType) {
          if (!sb[type].ended) {
            sb[type].ended = true;
            _logger.logger.log(type + ' sourceBuffer now EOS');
          }
        }
      }
      this.checkEos();
    }

    // if all source buffers are marked as ended, signal endOfStream() to MediaSource.

  }, {
    key: 'checkEos',
    value: function checkEos() {
      var sb = this.sourceBuffer,
          mediaSource = this.mediaSource;
      if (!mediaSource || mediaSource.readyState !== 'open') {
        this._needsEos = false;
        return;
      }
      for (var type in sb) {
        var sbobj = sb[type];
        if (!sbobj.ended) {
          return;
        }
        if (sbobj.updating) {
          this._needsEos = true;
          return;
        }
      }
      _logger.logger.log('all media data available, signal endOfStream() to MediaSource and stop loading fragment');
      //Notify the media element that it now has all of the media data
      try {
        mediaSource.endOfStream();
      } catch (e) {
        _logger.logger.warn('exception while calling mediaSource.endOfStream()');
      }
      this._needsEos = false;
    }
  }, {
    key: 'onBufferFlushing',
    value: function onBufferFlushing(data) {
      this.flushRange.push({ start: data.startOffset, end: data.endOffset, type: data.type });
      // attempt flush immediatly
      this.flushBufferCounter = 0;
      this.doFlush();
    }
  }, {
    key: 'onLevelUpdated',
    value: function onLevelUpdated(event) {
      var details = event.details;
      if (details.fragments.length === 0) {
        return;
      }
      this._levelDuration = details.totalduration + details.fragments[0].start;
      this.updateMediaElementDuration();
    }

    // https://github.com/video-dev/hls.js/issues/355

  }, {
    key: 'updateMediaElementDuration',
    value: function updateMediaElementDuration() {
      var media = this.media,
          mediaSource = this.mediaSource,
          sourceBuffer = this.sourceBuffer,
          levelDuration = this._levelDuration;
      if (levelDuration === null || !media || !mediaSource || !sourceBuffer || media.readyState === 0 || mediaSource.readyState !== 'open') {
        return;
      }
      for (var type in sourceBuffer) {
        if (sourceBuffer[type].updating) {
          // can't set duration whilst a buffer is updating
          return;
        }
      }
      if (this._msDuration === null) {
        // initialise to the value that the media source is reporting
        this._msDuration = mediaSource.duration;
      }
      var duration = media.duration;
      // levelDuration was the last value we set.
      // not using mediaSource.duration as the browser may tweak this value
      // only update mediasource duration if its value increase, this is to avoid
      // flushing already buffered portion when switching between quality level
      if (levelDuration > this._msDuration && levelDuration > duration || duration === Infinity || isNaN(duration)) {
        _logger.logger.log('Updating mediasource duration to ' + levelDuration.toFixed(3));
        this._msDuration = mediaSource.duration = levelDuration;
      }
    }
  }, {
    key: 'doFlush',
    value: function doFlush() {
      // loop through all buffer ranges to flush
      while (this.flushRange.length) {
        var range = this.flushRange[0];
        // flushBuffer will abort any buffer append in progress and flush Audio/Video Buffer
        if (this.flushBuffer(range.start, range.end, range.type)) {
          // range flushed, remove from flush array
          this.flushRange.shift();
          this.flushBufferCounter = 0;
        } else {
          this._needsFlush = true;
          // avoid looping, wait for SB update end to retrigger a flush
          return;
        }
      }
      if (this.flushRange.length === 0) {
        // everything flushed
        this._needsFlush = false;

        // let's recompute this.appended, which is used to avoid flush looping
        var appended = 0;
        var sourceBuffer = this.sourceBuffer;
        try {
          for (var type in sourceBuffer) {
            appended += sourceBuffer[type].buffered.length;
          }
        } catch (error) {
          // error could be thrown while accessing buffered, in case sourcebuffer has already been removed from MediaSource
          // this is harmess at this stage, catch this to avoid reporting an internal exception
          _logger.logger.error('error while accessing sourceBuffer.buffered');
        }
        this.appended = appended;
        this.hls.trigger(_events2.default.BUFFER_FLUSHED);
      }
    }
  }, {
    key: 'doAppending',
    value: function doAppending() {
      var hls = this.hls,
          sourceBuffer = this.sourceBuffer,
          segments = this.segments;
      if (Object.keys(sourceBuffer).length) {
        if (this.media.error) {
          this.segments = [];
          _logger.logger.error('trying to append although a media error occured, flush segment and abort');
          return;
        }
        if (this.appending) {
          //logger.log(`sb appending in progress`);
          return;
        }
        if (segments && segments.length) {
          var segment = segments.shift();
          try {
            var type = segment.type,
                sb = sourceBuffer[type];
            if (sb) {
              if (!sb.updating) {
                // reset sourceBuffer ended flag before appending segment
                sb.ended = false;
                //logger.log(`appending ${segment.content} ${type} SB, size:${segment.data.length}, ${segment.parent}`);
                this.parent = segment.parent;
                sb.appendBuffer(segment.data);
                this.appendError = 0;
                this.appended++;
                this.appending = true;
              } else {
                segments.unshift(segment);
              }
            } else {
              // in case we don't have any source buffer matching with this segment type,
              // it means that Mediasource fails to create sourcebuffer
              // discard this segment, and trigger update end
              this.onSBUpdateEnd();
            }
          } catch (err) {
            // in case any error occured while appending, put back segment in segments table
            _logger.logger.error('error while trying to append buffer:' + err.message);
            segments.unshift(segment);
            var event = { type: _errors.ErrorTypes.MEDIA_ERROR, parent: segment.parent };
            if (err.code !== 22) {
              if (this.appendError) {
                this.appendError++;
              } else {
                this.appendError = 1;
              }
              event.details = _errors.ErrorDetails.BUFFER_APPEND_ERROR;
              /* with UHD content, we could get loop of quota exceeded error until
                browser is able to evict some data from sourcebuffer. retrying help recovering this
              */
              if (this.appendError > hls.config.appendErrorMaxRetry) {
                _logger.logger.log('fail ' + hls.config.appendErrorMaxRetry + ' times to append segment in sourceBuffer');
                segments = [];
                event.fatal = true;
                hls.trigger(_events2.default.ERROR, event);
                return;
              } else {
                event.fatal = false;
                hls.trigger(_events2.default.ERROR, event);
              }
            } else {
              // QuotaExceededError: http://www.w3.org/TR/html5/infrastructure.html#quotaexceedederror
              // let's stop appending any segments, and report BUFFER_FULL_ERROR error
              this.segments = [];
              event.details = _errors.ErrorDetails.BUFFER_FULL_ERROR;
              event.fatal = false;
              hls.trigger(_events2.default.ERROR, event);
              return;
            }
          }
        }
      }
    }

    /*
      flush specified buffered range,
      return true once range has been flushed.
      as sourceBuffer.remove() is asynchronous, flushBuffer will be retriggered on sourceBuffer update end
    */

  }, {
    key: 'flushBuffer',
    value: function flushBuffer(startOffset, endOffset, typeIn) {
      var sb,
          i,
          bufStart,
          bufEnd,
          flushStart,
          flushEnd,
          sourceBuffer = this.sourceBuffer;
      if (Object.keys(sourceBuffer).length) {
        _logger.logger.log('flushBuffer,pos/start/end: ' + this.media.currentTime.toFixed(3) + '/' + startOffset + '/' + endOffset);
        // safeguard to avoid infinite looping : don't try to flush more than the nb of appended segments
        if (this.flushBufferCounter < this.appended) {
          for (var type in sourceBuffer) {
            // check if sourcebuffer type is defined (typeIn): if yes, let's only flush this one
            // if no, let's flush all sourcebuffers
            if (typeIn && type !== typeIn) {
              continue;
            }
            sb = sourceBuffer[type];
            // we are going to flush buffer, mark source buffer as 'not ended'
            sb.ended = false;
            if (!sb.updating) {
              try {
                for (i = 0; i < sb.buffered.length; i++) {
                  bufStart = sb.buffered.start(i);
                  bufEnd = sb.buffered.end(i);
                  // workaround firefox not able to properly flush multiple buffered range.
                  if (navigator.userAgent.toLowerCase().indexOf('firefox') !== -1 && endOffset === Number.POSITIVE_INFINITY) {
                    flushStart = startOffset;
                    flushEnd = endOffset;
                  } else {
                    flushStart = Math.max(bufStart, startOffset);
                    flushEnd = Math.min(bufEnd, endOffset);
                  }
                  /* sometimes sourcebuffer.remove() does not flush
                     the exact expected time range.
                     to avoid rounding issues/infinite loop,
                     only flush buffer range of length greater than 500ms.
                  */
                  if (Math.min(flushEnd, bufEnd) - flushStart > 0.5) {
                    this.flushBufferCounter++;
                    _logger.logger.log('flush ' + type + ' [' + flushStart + ',' + flushEnd + '], of [' + bufStart + ',' + bufEnd + '], pos:' + this.media.currentTime);
                    sb.remove(flushStart, flushEnd);
                    return false;
                  }
                }
              } catch (e) {
                _logger.logger.warn('exception while accessing sourcebuffer, it might have been removed from MediaSource');
              }
            } else {
              //logger.log('abort ' + type + ' append in progress');
              // this will abort any appending in progress
              //sb.abort();
              _logger.logger.warn('cannot flush, sb updating in progress');
              return false;
            }
          }
        } else {
          _logger.logger.warn('abort flushing too many retries');
        }
        _logger.logger.log('buffer flushed');
      }
      // everything flushed !
      return true;
    }
  }]);

  return BufferController;
}(_eventHandler2.default);

exports.default = BufferController;

/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events = __webpack_require__(39);

var _events2 = _interopRequireDefault(_events);

var _eventHandler = __webpack_require__(68);

var _eventHandler2 = _interopRequireDefault(_eventHandler);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * cap stream level to media size dimension controller
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */

var CapLevelController = function (_EventHandler) {
  _inherits(CapLevelController, _EventHandler);

  function CapLevelController(hls) {
    _classCallCheck(this, CapLevelController);

    return _possibleConstructorReturn(this, (CapLevelController.__proto__ || Object.getPrototypeOf(CapLevelController)).call(this, hls, _events2.default.FPS_DROP_LEVEL_CAPPING, _events2.default.MEDIA_ATTACHING, _events2.default.MANIFEST_PARSED));
  }

  _createClass(CapLevelController, [{
    key: 'destroy',
    value: function destroy() {
      if (this.hls.config.capLevelToPlayerSize) {
        this.media = this.restrictedLevels = null;
        this.autoLevelCapping = Number.POSITIVE_INFINITY;
        if (this.timer) {
          this.timer = clearInterval(this.timer);
        }
      }
    }
  }, {
    key: 'onFpsDropLevelCapping',
    value: function onFpsDropLevelCapping(data) {
      if (!this.restrictedLevels) {
        this.restrictedLevels = [];
      }
      if (!this.isLevelRestricted(data.droppedLevel)) {
        this.restrictedLevels.push(data.droppedLevel);
      }
    }
  }, {
    key: 'onMediaAttaching',
    value: function onMediaAttaching(data) {
      this.media = data.media instanceof HTMLVideoElement ? data.media : null;
    }
  }, {
    key: 'onManifestParsed',
    value: function onManifestParsed(data) {
      var hls = this.hls;
      if (hls.config.capLevelToPlayerSize) {
        this.autoLevelCapping = Number.POSITIVE_INFINITY;
        this.levels = data.levels;
        hls.firstLevel = this.getMaxLevel(data.firstLevel);
        clearInterval(this.timer);
        this.timer = setInterval(this.detectPlayerSize.bind(this), 1000);
        this.detectPlayerSize();
      }
    }
  }, {
    key: 'detectPlayerSize',
    value: function detectPlayerSize() {
      if (this.media) {
        var levelsLength = this.levels ? this.levels.length : 0;
        if (levelsLength) {
          var hls = this.hls;
          hls.autoLevelCapping = this.getMaxLevel(levelsLength - 1);
          if (hls.autoLevelCapping > this.autoLevelCapping) {
            // if auto level capping has a higher value for the previous one, flush the buffer using nextLevelSwitch
            // usually happen when the user go to the fullscreen mode.
            hls.streamController.nextLevelSwitch();
          }
          this.autoLevelCapping = hls.autoLevelCapping;
        }
      }
    }

    /*
    * returns level should be the one with the dimensions equal or greater than the media (player) dimensions (so the video will be downscaled)
    */

  }, {
    key: 'getMaxLevel',
    value: function getMaxLevel(capLevelIndex) {
      var result = 0,
          i = void 0,
          level = void 0,
          mWidth = this.mediaWidth,
          mHeight = this.mediaHeight,
          lWidth = 0,
          lHeight = 0;

      for (i = 0; i <= capLevelIndex; i++) {
        level = this.levels[i];
        if (this.isLevelRestricted(i)) {
          break;
        }
        result = i;
        lWidth = level.width;
        lHeight = level.height;
        if (mWidth <= lWidth || mHeight <= lHeight) {
          break;
        }
      }
      return result;
    }
  }, {
    key: 'isLevelRestricted',
    value: function isLevelRestricted(level) {
      return this.restrictedLevels && this.restrictedLevels.indexOf(level) !== -1 ? true : false;
    }
  }, {
    key: 'contentScaleFactor',
    get: function get() {
      var pixelRatio = 1;
      try {
        pixelRatio = window.devicePixelRatio;
      } catch (e) {}
      return pixelRatio;
    }
  }, {
    key: 'mediaWidth',
    get: function get() {
      var width = void 0;
      var media = this.media;
      if (media) {
        width = media.width || media.clientWidth || media.offsetWidth;
        width *= this.contentScaleFactor;
      }
      return width;
    }
  }, {
    key: 'mediaHeight',
    get: function get() {
      var height = void 0;
      var media = this.media;
      if (media) {
        height = media.height || media.clientHeight || media.offsetHeight;
        height *= this.contentScaleFactor;
      }
      return height;
    }
  }]);

  return CapLevelController;
}(_eventHandler2.default);

exports.default = CapLevelController;

/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events = __webpack_require__(39);

var _events2 = _interopRequireDefault(_events);

var _eventHandler = __webpack_require__(68);

var _eventHandler2 = _interopRequireDefault(_eventHandler);

var _logger = __webpack_require__(31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * FPS Controller
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */

var FPSController = function (_EventHandler) {
  _inherits(FPSController, _EventHandler);

  function FPSController(hls) {
    _classCallCheck(this, FPSController);

    return _possibleConstructorReturn(this, (FPSController.__proto__ || Object.getPrototypeOf(FPSController)).call(this, hls, _events2.default.MEDIA_ATTACHING));
  }

  _createClass(FPSController, [{
    key: 'destroy',
    value: function destroy() {
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.isVideoPlaybackQualityAvailable = false;
    }
  }, {
    key: 'onMediaAttaching',
    value: function onMediaAttaching(data) {
      var config = this.hls.config;
      if (config.capLevelOnFPSDrop) {
        var video = this.video = data.media instanceof HTMLVideoElement ? data.media : null;
        if (typeof video.getVideoPlaybackQuality === 'function') {
          this.isVideoPlaybackQualityAvailable = true;
        }
        clearInterval(this.timer);
        this.timer = setInterval(this.checkFPSInterval.bind(this), config.fpsDroppedMonitoringPeriod);
      }
    }
  }, {
    key: 'checkFPS',
    value: function checkFPS(video, decodedFrames, droppedFrames) {
      var currentTime = performance.now();
      if (decodedFrames) {
        if (this.lastTime) {
          var currentPeriod = currentTime - this.lastTime,
              currentDropped = droppedFrames - this.lastDroppedFrames,
              currentDecoded = decodedFrames - this.lastDecodedFrames,
              droppedFPS = 1000 * currentDropped / currentPeriod,
              hls = this.hls;
          hls.trigger(_events2.default.FPS_DROP, { currentDropped: currentDropped, currentDecoded: currentDecoded, totalDroppedFrames: droppedFrames });
          if (droppedFPS > 0) {
            //logger.log('checkFPS : droppedFPS/decodedFPS:' + droppedFPS/(1000 * currentDecoded / currentPeriod));
            if (currentDropped > hls.config.fpsDroppedMonitoringThreshold * currentDecoded) {
              var currentLevel = hls.currentLevel;
              _logger.logger.warn('drop FPS ratio greater than max allowed value for currentLevel: ' + currentLevel);
              if (currentLevel > 0 && (hls.autoLevelCapping === -1 || hls.autoLevelCapping >= currentLevel)) {
                currentLevel = currentLevel - 1;
                hls.trigger(_events2.default.FPS_DROP_LEVEL_CAPPING, { level: currentLevel, droppedLevel: hls.currentLevel });
                hls.autoLevelCapping = currentLevel;
                hls.streamController.nextLevelSwitch();
              }
            }
          }
        }
        this.lastTime = currentTime;
        this.lastDroppedFrames = droppedFrames;
        this.lastDecodedFrames = decodedFrames;
      }
    }
  }, {
    key: 'checkFPSInterval',
    value: function checkFPSInterval() {
      var video = this.video;
      if (video) {
        if (this.isVideoPlaybackQualityAvailable) {
          var videoPlaybackQuality = video.getVideoPlaybackQuality();
          this.checkFPS(video, videoPlaybackQuality.totalVideoFrames, videoPlaybackQuality.droppedVideoFrames);
        } else {
          this.checkFPS(video, video.webkitDecodedFrameCount, video.webkitDroppedFrameCount);
        }
      }
    }
  }]);

  return FPSController;
}(_eventHandler2.default);

exports.default = FPSController;

/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events = __webpack_require__(39);

var _events2 = _interopRequireDefault(_events);

var _eventHandler = __webpack_require__(68);

var _eventHandler2 = _interopRequireDefault(_eventHandler);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * id3 metadata track controller
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */

var ID3TrackController = function (_EventHandler) {
  _inherits(ID3TrackController, _EventHandler);

  function ID3TrackController(hls) {
    _classCallCheck(this, ID3TrackController);

    var _this = _possibleConstructorReturn(this, (ID3TrackController.__proto__ || Object.getPrototypeOf(ID3TrackController)).call(this, hls, _events2.default.MEDIA_ATTACHED, _events2.default.MEDIA_DETACHING, _events2.default.FRAG_PARSING_METADATA));

    _this.id3Track = undefined;
    _this.media = undefined;
    return _this;
  }

  _createClass(ID3TrackController, [{
    key: 'destroy',
    value: function destroy() {
      _eventHandler2.default.prototype.destroy.call(this);
    }

    // Add ID3 metatadata text track.

  }, {
    key: 'onMediaAttached',
    value: function onMediaAttached(data) {
      this.media = data.media;
      if (!this.media) {
        return;
      }

      this.id3Track = this.media.addTextTrack('metadata', 'id3');
      this.id3Track.mode = 'hidden';
    }
  }, {
    key: 'onMediaDetaching',
    value: function onMediaDetaching() {
      this.media = undefined;
    }
  }, {
    key: 'onFragParsingMetadata',
    value: function onFragParsingMetadata(data) {
      var fragment = data.frag;
      var samples = data.samples;
      var startTime = fragment.start;
      var endTime = fragment.start + fragment.duration;
      // Give a slight bump to the endTime if it's equal to startTime to avoid a SyntaxError in IE
      if (startTime === endTime) {
        endTime += 0.0001;
      }

      // Attempt to recreate Safari functionality by creating
      // WebKitDataCue objects when available and store the decoded
      // ID3 data in the value property of the cue
      var Cue = window.WebKitDataCue || window.VTTCue || window.TextTrackCue;

      for (var i = 0; i < samples.length; i++) {
        var id3Frame = this.parseID3Frame(samples[i].data);
        var frame = this.decodeID3Frame(id3Frame);
        if (frame) {
          var cue = new Cue(startTime, endTime, '');
          cue.value = frame;
          this.id3Track.addCue(cue);
        }
      }
    }
  }, {
    key: 'parseID3Frame',
    value: function parseID3Frame(data) {
      if (data.length < 21) {
        return undefined;
      }

      /* http://id3.org/id3v2.3.0
      [0]     = 'I'
      [1]     = 'D'
      [2]     = '3'
      [3,4]   = {Version}
      [5]     = {Flags}
      [6-9]   = {ID3 Size}
      [10-13] = {Frame ID}
      [14-17] = {Frame Size}
      [18,19] = {Frame Flags}
      */
      if (data[0] === 73 && // I
      data[1] === 68 && // D
      data[2] === 51) {
        // 3

        var type = String.fromCharCode(data[10], data[11], data[12], data[13]);
        data = data.subarray(20);
        return { type: type, data: data };
      }
    }
  }, {
    key: 'decodeID3Frame',
    value: function decodeID3Frame(frame) {
      if (frame.type === 'TXXX') {
        return this.decodeTxxxFrame(frame);
      } else if (frame.type === 'PRIV') {
        return this.decodePrivFrame(frame);
      } else if (frame.type[0] === 'T') {
        return this.decodeTextFrame(frame);
      } else {
        return undefined;
      }
    }
  }, {
    key: 'decodeTxxxFrame',
    value: function decodeTxxxFrame(frame) {
      /*
      Format:
      [0]   = {Text Encoding}
      [1-?] = {Description}\0{Value}
      */

      if (frame.size < 2) {
        return undefined;
      }

      if (frame.data[0] !== 3) {
        //only support UTF-8
        return undefined;
      }

      var index = 1;
      var description = this.utf8ArrayToStr(frame.data.subarray(index));

      index += description.length + 1;
      var value = this.utf8ArrayToStr(frame.data.subarray(index));

      return { key: 'TXXX', description: description, data: value };
    }
  }, {
    key: 'decodeTextFrame',
    value: function decodeTextFrame(frame) {
      /*
      Format:
      [0]   = {Text Encoding}
      [1-?] = {Value}
      */

      if (frame.size < 2) {
        return undefined;
      }

      if (frame.data[0] !== 3) {
        //only support UTF-8
        return undefined;
      }

      var data = frame.data.subarray(1);
      return { key: frame.type, data: this.utf8ArrayToStr(data) };
    }
  }, {
    key: 'decodePrivFrame',
    value: function decodePrivFrame(frame) {
      /*
      Format: <text string>\0<binary data>
      */

      if (frame.size < 2) {
        return undefined;
      }

      var owner = this.utf8ArrayToStr(frame.data);
      var privateData = frame.data.subarray(owner.length + 1);

      return { key: 'PRIV', info: owner, data: privateData.buffer };
    }

    // http://stackoverflow.com/questions/8936984/uint8array-to-string-in-javascript/22373197
    // http://www.onicos.com/staff/iz/amuse/javascript/expert/utf.txt
    /* utf.js - UTF-8 <=> UTF-16 convertion
     *
     * Copyright (C) 1999 Masanao Izumo <iz@onicos.co.jp>
     * Version: 1.0
     * LastModified: Dec 25 1999
     * This library is free.  You can redistribute it and/or modify it.
     */

  }, {
    key: 'utf8ArrayToStr',
    value: function utf8ArrayToStr(array) {

      var char2 = void 0;
      var char3 = void 0;
      var out = '';
      var i = 0;
      var length = array.length;

      while (i < length) {
        var c = array[i++];
        switch (c >> 4) {
          case 0:
            return out;
          case 1:case 2:case 3:case 4:case 5:case 6:case 7:
            // 0xxxxxxx
            out += String.fromCharCode(c);
            break;
          case 12:case 13:
            // 110x xxxx   10xx xxxx
            char2 = array[i++];
            out += String.fromCharCode((c & 0x1F) << 6 | char2 & 0x3F);
            break;
          case 14:
            // 1110 xxxx  10xx xxxx  10xx xxxx
            char2 = array[i++];
            char3 = array[i++];
            out += String.fromCharCode((c & 0x0F) << 12 | (char2 & 0x3F) << 6 | (char3 & 0x3F) << 0);
            break;
        }
      }

      return out;
    }
  }]);

  return ID3TrackController;
}(_eventHandler2.default);

exports.default = ID3TrackController;

/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events = __webpack_require__(39);

var _events2 = _interopRequireDefault(_events);

var _eventHandler = __webpack_require__(68);

var _eventHandler2 = _interopRequireDefault(_eventHandler);

var _logger = __webpack_require__(31);

var _errors = __webpack_require__(63);

var _bufferHelper = __webpack_require__(332);

var _bufferHelper2 = _interopRequireDefault(_bufferHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Level Controller
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */

var LevelController = function (_EventHandler) {
  _inherits(LevelController, _EventHandler);

  function LevelController(hls) {
    _classCallCheck(this, LevelController);

    var _this = _possibleConstructorReturn(this, (LevelController.__proto__ || Object.getPrototypeOf(LevelController)).call(this, hls, _events2.default.MANIFEST_LOADED, _events2.default.LEVEL_LOADED, _events2.default.FRAG_LOADED, _events2.default.ERROR));

    _this.ontick = _this.tick.bind(_this);
    _this._manualLevel = -1;
    return _this;
  }

  _createClass(LevelController, [{
    key: 'destroy',
    value: function destroy() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this._manualLevel = -1;
    }
  }, {
    key: 'startLoad',
    value: function startLoad() {
      this.canload = true;
      var levels = this._levels;
      // clean up live level details to force reload them, and reset load errors
      if (levels) {
        levels.forEach(function (level) {
          level.loadError = 0;
          var levelDetails = level.details;
          if (levelDetails && levelDetails.live) {
            level.details = undefined;
          }
        });
      }
      // speed up live playlist refresh if timer exists
      if (this.timer) {
        this.tick();
      }
    }
  }, {
    key: 'stopLoad',
    value: function stopLoad() {
      this.canload = false;
    }
  }, {
    key: 'onManifestLoaded',
    value: function onManifestLoaded(data) {
      var levels0 = [],
          levels = [],
          bitrateStart,
          bitrateSet = {},
          videoCodecFound = false,
          audioCodecFound = false,
          hls = this.hls,
          brokenmp4inmp3 = /chrome|firefox/.test(navigator.userAgent.toLowerCase()),
          checkSupported = function checkSupported(type, codec) {
        return MediaSource.isTypeSupported(type + '/mp4;codecs=' + codec);
      };

      // regroup redundant level together
      data.levels.forEach(function (level) {
        if (level.videoCodec) {
          videoCodecFound = true;
        }
        // erase audio codec info if browser does not support mp4a.40.34. demuxer will autodetect codec and fallback to mpeg/audio
        if (brokenmp4inmp3 && level.audioCodec && level.audioCodec.indexOf('mp4a.40.34') !== -1) {
          level.audioCodec = undefined;
        }
        if (level.audioCodec || level.attrs && level.attrs.AUDIO) {
          audioCodecFound = true;
        }
        var redundantLevelId = bitrateSet[level.bitrate];
        if (redundantLevelId === undefined) {
          bitrateSet[level.bitrate] = levels0.length;
          level.url = [level.url];
          level.urlId = 0;
          levels0.push(level);
        } else {
          levels0[redundantLevelId].url.push(level.url);
        }
      });

      // remove audio-only level if we also have levels with audio+video codecs signalled
      if (videoCodecFound && audioCodecFound) {
        levels0.forEach(function (level) {
          if (level.videoCodec) {
            levels.push(level);
          }
        });
      } else {
        levels = levels0;
      }
      // only keep level with supported audio/video codecs
      levels = levels.filter(function (level) {
        var audioCodec = level.audioCodec,
            videoCodec = level.videoCodec;
        return (!audioCodec || checkSupported('audio', audioCodec)) && (!videoCodec || checkSupported('video', videoCodec));
      });

      if (levels.length) {
        // start bitrate is the first bitrate of the manifest
        bitrateStart = levels[0].bitrate;
        // sort level on bitrate
        levels.sort(function (a, b) {
          return a.bitrate - b.bitrate;
        });
        this._levels = levels;
        // find index of first level in sorted levels
        for (var i = 0; i < levels.length; i++) {
          if (levels[i].bitrate === bitrateStart) {
            this._firstLevel = i;
            _logger.logger.log('manifest loaded,' + levels.length + ' level(s) found, first bitrate:' + bitrateStart);
            break;
          }
        }
        hls.trigger(_events2.default.MANIFEST_PARSED, { levels: levels, firstLevel: this._firstLevel, stats: data.stats, audio: audioCodecFound, video: videoCodecFound, altAudio: data.audioTracks.length > 0 });
      } else {
        hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.MEDIA_ERROR, details: _errors.ErrorDetails.MANIFEST_INCOMPATIBLE_CODECS_ERROR, fatal: true, url: hls.url, reason: 'no level with compatible codecs found in manifest' });
      }
      return;
    }
  }, {
    key: 'setLevelInternal',
    value: function setLevelInternal(newLevel) {
      var levels = this._levels;
      var hls = this.hls;
      // check if level idx is valid
      if (newLevel >= 0 && newLevel < levels.length) {
        // stopping live reloading timer if any
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }
        if (this._level !== newLevel) {
          _logger.logger.log('switching to level ' + newLevel);
          this._level = newLevel;
          var levelProperties = levels[newLevel];
          levelProperties.level = newLevel;
          // LEVEL_SWITCH to be deprecated in next major release
          hls.trigger(_events2.default.LEVEL_SWITCH, levelProperties);
          hls.trigger(_events2.default.LEVEL_SWITCHING, levelProperties);
        }
        var level = levels[newLevel],
            levelDetails = level.details;
        // check if we need to load playlist for this level
        if (!levelDetails || levelDetails.live === true) {
          // level not retrieved yet, or live playlist we need to (re)load it
          var urlId = level.urlId;
          hls.trigger(_events2.default.LEVEL_LOADING, { url: level.url[urlId], level: newLevel, id: urlId });
        }
      } else {
        // invalid level id given, trigger error
        hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.OTHER_ERROR, details: _errors.ErrorDetails.LEVEL_SWITCH_ERROR, level: newLevel, fatal: false, reason: 'invalid level idx' });
      }
    }
  }, {
    key: 'onError',
    value: function onError(data) {
      if (data.fatal) {
        return;
      }

      var details = data.details,
          hls = this.hls,
          levelId = void 0,
          level = void 0,
          levelError = false;
      // try to recover not fatal errors
      switch (details) {
        case _errors.ErrorDetails.FRAG_LOAD_ERROR:
        case _errors.ErrorDetails.FRAG_LOAD_TIMEOUT:
        case _errors.ErrorDetails.FRAG_LOOP_LOADING_ERROR:
        case _errors.ErrorDetails.KEY_LOAD_ERROR:
        case _errors.ErrorDetails.KEY_LOAD_TIMEOUT:
          levelId = data.frag.level;
          break;
        case _errors.ErrorDetails.LEVEL_LOAD_ERROR:
        case _errors.ErrorDetails.LEVEL_LOAD_TIMEOUT:
          levelId = data.context.level;
          levelError = true;
          break;
        case _errors.ErrorDetails.REMUX_ALLOC_ERROR:
          levelId = data.level;
          break;
        default:
          break;
      }
      /* try to switch to a redundant stream if any available.
       * if no redundant stream available, emergency switch down (if in auto mode and current level not 0)
       * otherwise, we cannot recover this network error ...
       */
      if (levelId !== undefined) {
        level = this._levels[levelId];
        if (!level.loadError) {
          level.loadError = 1;
        } else {
          level.loadError++;
        }
        // if any redundant streams available and if we haven't try them all (level.loadError is reseted on successful frag/level load.
        // if level.loadError reaches nbRedundantLevel it means that we tried them all, no hope  => let's switch down
        var nbRedundantLevel = level.url.length;
        if (nbRedundantLevel > 1 && level.loadError < nbRedundantLevel) {
          level.urlId = (level.urlId + 1) % nbRedundantLevel;
          level.details = undefined;
          _logger.logger.warn('level controller,' + details + ' for level ' + levelId + ': switching to redundant stream id ' + level.urlId);
        } else {
          // we could try to recover if in auto mode and current level not lowest level (0)
          var recoverable = this._manualLevel === -1 && levelId;
          if (recoverable) {
            _logger.logger.warn('level controller,' + details + ': switch-down for next fragment');
            hls.nextAutoLevel = Math.max(0, levelId - 1);
          } else if (level && level.details && level.details.live) {
            _logger.logger.warn('level controller,' + details + ' on live stream, discard');
            if (levelError) {
              // reset this._level so that another call to set level() will retrigger a frag load
              this._level = undefined;
            }
            // other errors are handled by stream controller
          } else if (details === _errors.ErrorDetails.LEVEL_LOAD_ERROR || details === _errors.ErrorDetails.LEVEL_LOAD_TIMEOUT) {
            var media = hls.media,

            // 0.5 : tolerance needed as some browsers stalls playback before reaching buffered end
            mediaBuffered = media && _bufferHelper2.default.isBuffered(media, media.currentTime) && _bufferHelper2.default.isBuffered(media, media.currentTime + 0.5);
            if (mediaBuffered) {
              var retryDelay = hls.config.levelLoadingRetryDelay;
              _logger.logger.warn('level controller,' + details + ', but media buffered, retry in ' + retryDelay + 'ms');
              this.timer = setTimeout(this.ontick, retryDelay);
              // boolean used to inform stream controller not to switch back to IDLE on non fatal error
              data.levelRetry = true;
            } else {
              _logger.logger.error('cannot recover ' + details + ' error');
              this._level = undefined;
              // stopping live reloading timer if any
              if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
              }
              // switch error to fatal
              data.fatal = true;
            }
          }
        }
      }
    }

    // reset level load error counter on successful frag loaded

  }, {
    key: 'onFragLoaded',
    value: function onFragLoaded(data) {
      var fragLoaded = data.frag;
      if (fragLoaded && fragLoaded.type === 'main') {
        var level = this._levels[fragLoaded.level];
        if (level) {
          level.loadError = 0;
        }
      }
    }
  }, {
    key: 'onLevelLoaded',
    value: function onLevelLoaded(data) {
      var levelId = data.level;
      // only process level loaded events matching with expected level
      if (levelId === this._level) {
        var curLevel = this._levels[levelId];
        // reset level load error counter on successful level loaded
        curLevel.loadError = 0;
        var newDetails = data.details;
        // if current playlist is a live playlist, arm a timer to reload it
        if (newDetails.live) {
          var reloadInterval = 1000 * (newDetails.averagetargetduration ? newDetails.averagetargetduration : newDetails.targetduration),
              curDetails = curLevel.details;
          if (curDetails && newDetails.endSN === curDetails.endSN) {
            // follow HLS Spec, If the client reloads a Playlist file and finds that it has not
            // changed then it MUST wait for a period of one-half the target
            // duration before retrying.
            reloadInterval /= 2;
            _logger.logger.log('same live playlist, reload twice faster');
          }
          // decrement reloadInterval with level loading delay
          reloadInterval -= performance.now() - data.stats.trequest;
          // in any case, don't reload more than every second
          reloadInterval = Math.max(1000, Math.round(reloadInterval));
          _logger.logger.log('live playlist, reload in ' + reloadInterval + ' ms');
          this.timer = setTimeout(this.ontick, reloadInterval);
        } else {
          this.timer = null;
        }
      }
    }
  }, {
    key: 'tick',
    value: function tick() {
      var levelId = this._level;
      if (levelId !== undefined && this.canload) {
        var level = this._levels[levelId];
        if (level && level.url) {
          var urlId = level.urlId;
          this.hls.trigger(_events2.default.LEVEL_LOADING, { url: level.url[urlId], level: levelId, id: urlId });
        }
      }
    }
  }, {
    key: 'levels',
    get: function get() {
      return this._levels;
    }
  }, {
    key: 'level',
    get: function get() {
      return this._level;
    },
    set: function set(newLevel) {
      var levels = this._levels;
      if (levels && levels.length > newLevel) {
        if (this._level !== newLevel || levels[newLevel].details === undefined) {
          this.setLevelInternal(newLevel);
        }
      }
    }
  }, {
    key: 'manualLevel',
    get: function get() {
      return this._manualLevel;
    },
    set: function set(newLevel) {
      this._manualLevel = newLevel;
      if (this._startLevel === undefined) {
        this._startLevel = newLevel;
      }
      if (newLevel !== -1) {
        this.level = newLevel;
      }
    }
  }, {
    key: 'firstLevel',
    get: function get() {
      return this._firstLevel;
    },
    set: function set(newLevel) {
      this._firstLevel = newLevel;
    }
  }, {
    key: 'startLevel',
    get: function get() {
      // hls.startLevel takes precedence over config.startLevel
      // if none of these values are defined, fallback on this._firstLevel (first quality level appearing in variant manifest)
      if (this._startLevel === undefined) {
        var configStartLevel = this.hls.config.startLevel;
        if (configStartLevel !== undefined) {
          return configStartLevel;
        } else {
          return this._firstLevel;
        }
      } else {
        return this._startLevel;
      }
    },
    set: function set(newLevel) {
      this._startLevel = newLevel;
    }
  }, {
    key: 'nextLoadLevel',
    get: function get() {
      if (this._manualLevel !== -1) {
        return this._manualLevel;
      } else {
        return this.hls.nextAutoLevel;
      }
    },
    set: function set(nextLevel) {
      this.level = nextLevel;
      if (this._manualLevel === -1) {
        this.hls.nextAutoLevel = nextLevel;
      }
    }
  }]);

  return LevelController;
}(_eventHandler2.default);

exports.default = LevelController;

/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _binarySearch = __webpack_require__(608);

var _binarySearch2 = _interopRequireDefault(_binarySearch);

var _bufferHelper = __webpack_require__(332);

var _bufferHelper2 = _interopRequireDefault(_bufferHelper);

var _demuxer = __webpack_require__(604);

var _demuxer2 = _interopRequireDefault(_demuxer);

var _events = __webpack_require__(39);

var _events2 = _interopRequireDefault(_events);

var _eventHandler = __webpack_require__(68);

var _eventHandler2 = _interopRequireDefault(_eventHandler);

var _levelHelper = __webpack_require__(607);

var _levelHelper2 = _interopRequireDefault(_levelHelper);

var _timeRanges = __webpack_require__(609);

var _timeRanges2 = _interopRequireDefault(_timeRanges);

var _errors = __webpack_require__(63);

var _logger = __webpack_require__(31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Stream Controller
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */

var State = {
  STOPPED: 'STOPPED',
  IDLE: 'IDLE',
  KEY_LOADING: 'KEY_LOADING',
  FRAG_LOADING: 'FRAG_LOADING',
  FRAG_LOADING_WAITING_RETRY: 'FRAG_LOADING_WAITING_RETRY',
  WAITING_LEVEL: 'WAITING_LEVEL',
  PARSING: 'PARSING',
  PARSED: 'PARSED',
  BUFFER_FLUSHING: 'BUFFER_FLUSHING',
  ENDED: 'ENDED',
  ERROR: 'ERROR'
};

var StreamController = function (_EventHandler) {
  _inherits(StreamController, _EventHandler);

  function StreamController(hls) {
    _classCallCheck(this, StreamController);

    var _this = _possibleConstructorReturn(this, (StreamController.__proto__ || Object.getPrototypeOf(StreamController)).call(this, hls, _events2.default.MEDIA_ATTACHED, _events2.default.MEDIA_DETACHING, _events2.default.MANIFEST_LOADING, _events2.default.MANIFEST_PARSED, _events2.default.LEVEL_LOADED, _events2.default.KEY_LOADED, _events2.default.FRAG_LOADED, _events2.default.FRAG_LOAD_EMERGENCY_ABORTED, _events2.default.FRAG_PARSING_INIT_SEGMENT, _events2.default.FRAG_PARSING_DATA, _events2.default.FRAG_PARSED, _events2.default.ERROR, _events2.default.AUDIO_TRACK_SWITCHING, _events2.default.AUDIO_TRACK_SWITCHED, _events2.default.BUFFER_CREATED, _events2.default.BUFFER_APPENDED, _events2.default.BUFFER_FLUSHED));

    _this.config = hls.config;
    _this.audioCodecSwap = false;
    _this.ticks = 0;
    _this._state = State.STOPPED;
    _this.ontick = _this.tick.bind(_this);
    return _this;
  }

  _createClass(StreamController, [{
    key: 'destroy',
    value: function destroy() {
      this.stopLoad();
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      _eventHandler2.default.prototype.destroy.call(this);
      this.state = State.STOPPED;
    }
  }, {
    key: 'startLoad',
    value: function startLoad(startPosition) {
      if (this.levels) {
        var lastCurrentTime = this.lastCurrentTime,
            hls = this.hls;
        this.stopLoad();
        if (!this.timer) {
          this.timer = setInterval(this.ontick, 100);
        }
        this.level = -1;
        this.fragLoadError = 0;
        if (!this.startFragRequested) {
          // determine load level
          var startLevel = hls.startLevel;
          if (startLevel === -1) {
            // -1 : guess start Level by doing a bitrate test by loading first fragment of lowest quality level
            startLevel = 0;
            this.bitrateTest = true;
          }
          // set new level to playlist loader : this will trigger start level load
          // hls.nextLoadLevel remains until it is set to a new value or until a new frag is successfully loaded
          this.level = hls.nextLoadLevel = startLevel;
          this.loadedmetadata = false;
        }
        // if startPosition undefined but lastCurrentTime set, set startPosition to last currentTime
        if (lastCurrentTime > 0 && startPosition === -1) {
          _logger.logger.log('override startPosition with lastCurrentTime @' + lastCurrentTime.toFixed(3));
          startPosition = lastCurrentTime;
        }
        this.state = State.IDLE;
        this.nextLoadPosition = this.startPosition = this.lastCurrentTime = startPosition;
        this.tick();
      } else {
        this.forceStartLoad = true;
        this.state = State.STOPPED;
      }
    }
  }, {
    key: 'stopLoad',
    value: function stopLoad() {
      var frag = this.fragCurrent;
      if (frag) {
        if (frag.loader) {
          frag.loader.abort();
        }
        this.fragCurrent = null;
      }
      this.fragPrevious = null;
      if (this.demuxer) {
        this.demuxer.destroy();
        this.demuxer = null;
      }
      this.state = State.STOPPED;
      this.forceStartLoad = false;
    }
  }, {
    key: 'tick',
    value: function tick() {
      this.ticks++;
      if (this.ticks === 1) {
        this.doTick();
        if (this.ticks > 1) {
          setTimeout(this.tick, 1);
        }
        this.ticks = 0;
      }
    }
  }, {
    key: 'doTick',
    value: function doTick() {
      switch (this.state) {
        case State.ERROR:
          //don't do anything in error state to avoid breaking further ...
          break;
        case State.BUFFER_FLUSHING:
          // in buffer flushing state, reset fragLoadError counter
          this.fragLoadError = 0;
          break;
        case State.IDLE:
          this._doTickIdle();
          break;
        case State.WAITING_LEVEL:
          var level = this.levels[this.level];
          // check if playlist is already loaded
          if (level && level.details) {
            this.state = State.IDLE;
          }
          break;
        case State.FRAG_LOADING_WAITING_RETRY:
          var now = performance.now();
          var retryDate = this.retryDate;
          // if current time is gt than retryDate, or if media seeking let's switch to IDLE state to retry loading
          if (!retryDate || now >= retryDate || this.media && this.media.seeking) {
            _logger.logger.log('mediaController: retryDate reached, switch back to IDLE state');
            this.state = State.IDLE;
          }
          break;
        case State.ERROR:
        case State.STOPPED:
        case State.FRAG_LOADING:
        case State.PARSING:
        case State.PARSED:
        case State.ENDED:
          break;
        default:
          break;
      }
      // check buffer
      this._checkBuffer();
      // check/update current fragment
      this._checkFragmentChanged();
    }

    // Ironically the "idle" state is the on we do the most logic in it seems ....
    // NOTE: Maybe we could rather schedule a check for buffer length after half of the currently
    //       played segment, or on pause/play/seek instead of naively checking every 100ms?

  }, {
    key: '_doTickIdle',
    value: function _doTickIdle() {
      var hls = this.hls,
          config = hls.config,
          media = this.media;

      // if video not attached AND
      // start fragment already requested OR start frag prefetch disable
      // exit loop
      // => if start level loaded and media not attached but start frag prefetch is enabled and start frag not requested yet, we will not exit loop
      if (this.levelLastLoaded !== undefined && !media && (this.startFragRequested || !config.startFragPrefetch)) {
        return;
      }

      // if we have not yet loaded any fragment, start loading from start position
      var pos = void 0;
      if (this.loadedmetadata) {
        pos = media.currentTime;
      } else {
        pos = this.nextLoadPosition;
      }
      // determine next load level
      var level = hls.nextLoadLevel,
          levelInfo = this.levels[level];

      if (!levelInfo) {
        return;
      }

      var levelBitrate = levelInfo.bitrate,
          maxBufLen = void 0;

      // compute max Buffer Length that we could get from this load level, based on level bitrate. don't buffer more than 60 MB and more than 30s
      if (levelBitrate) {
        maxBufLen = Math.max(8 * config.maxBufferSize / levelBitrate, config.maxBufferLength);
      } else {
        maxBufLen = config.maxBufferLength;
      }
      maxBufLen = Math.min(maxBufLen, config.maxMaxBufferLength);

      // determine next candidate fragment to be loaded, based on current position and end of buffer position
      // ensure up to `config.maxMaxBufferLength` of buffer upfront

      var bufferInfo = _bufferHelper2.default.bufferInfo(this.mediaBuffer ? this.mediaBuffer : media, pos, config.maxBufferHole),
          bufferLen = bufferInfo.len;
      // Stay idle if we are still with buffer margins
      if (bufferLen >= maxBufLen) {
        return;
      }

      // if buffer length is less than maxBufLen try to load a new fragment ...
      _logger.logger.trace('buffer length of ' + bufferLen.toFixed(3) + ' is below max of ' + maxBufLen.toFixed(3) + '. checking for more payload ...');

      // set next load level : this will trigger a playlist load if needed
      this.level = hls.nextLoadLevel = level;

      var levelDetails = levelInfo.details;
      // if level info not retrieved yet, switch state and wait for level retrieval
      // if live playlist, ensure that new playlist has been refreshed to avoid loading/try to load
      // a useless and outdated fragment (that might even introduce load error if it is already out of the live playlist)
      if (typeof levelDetails === 'undefined' || levelDetails.live && this.levelLastLoaded !== level) {
        this.state = State.WAITING_LEVEL;
        return;
      }

      // we just got done loading the final fragment, check if we need to finalize media stream
      var fragPrevious = this.fragPrevious;
      if (!levelDetails.live && fragPrevious && fragPrevious.sn === levelDetails.endSN) {
        // fragPrevious is last fragment. retrieve level duration using last frag start offset + duration
        // real duration might be lower than initial duration if there are drifts between real frag duration and playlist signaling
        var duration = Math.min(media.duration, fragPrevious.start + fragPrevious.duration);
        // if everything (almost) til the end is buffered, let's signal eos
        // we don't compare exactly media.duration === bufferInfo.end as there could be some subtle media duration difference (audio/video offsets...)
        // tolerate up to one frag duration to cope with these cases.
        // also cope with almost zero last frag duration (max last frag duration with 200ms) refer to https://github.com/video-dev/hls.js/pull/657
        if (duration - Math.max(bufferInfo.end, fragPrevious.start) <= Math.max(0.2, fragPrevious.duration)) {
          // Finalize the media stream
          var data = {};
          if (this.altAudio) {
            data.type = 'video';
          }
          this.hls.trigger(_events2.default.BUFFER_EOS, data);
          this.state = State.ENDED;
          return;
        }
      }

      // if we have the levelDetails for the selected variant, lets continue enrichen our stream (load keys/fragments or trigger EOS, etc..)
      this._fetchPayloadOrEos(pos, bufferInfo, levelDetails);
    }
  }, {
    key: '_fetchPayloadOrEos',
    value: function _fetchPayloadOrEos(pos, bufferInfo, levelDetails) {
      var fragPrevious = this.fragPrevious,
          level = this.level,
          fragments = levelDetails.fragments,
          fragLen = fragments.length;

      // empty playlist
      if (fragLen === 0) {
        return;
      }

      // find fragment index, contiguous with end of buffer position
      var start = fragments[0].start,
          end = fragments[fragLen - 1].start + fragments[fragLen - 1].duration,
          bufferEnd = bufferInfo.end,
          frag = void 0;

      if (levelDetails.initSegment && !levelDetails.initSegment.data) {
        frag = levelDetails.initSegment;
      } else {
        // in case of live playlist we need to ensure that requested position is not located before playlist start
        if (levelDetails.live) {
          var initialLiveManifestSize = this.config.initialLiveManifestSize;
          if (fragLen < initialLiveManifestSize) {
            _logger.logger.warn('Can not start playback of a level, reason: not enough fragments ' + fragLen + ' < ' + initialLiveManifestSize);
            return;
          }

          frag = this._ensureFragmentAtLivePoint(levelDetails, bufferEnd, start, end, fragPrevious, fragments, fragLen);
          // if it explicitely returns null don't load any fragment and exit function now
          if (frag === null) {
            return;
          }
        } else {
          // VoD playlist: if bufferEnd before start of playlist, load first fragment
          if (bufferEnd < start) {
            frag = fragments[0];
          }
        }
      }
      if (!frag) {
        frag = this._findFragment(start, fragPrevious, fragLen, fragments, bufferEnd, end, levelDetails);
      }
      if (frag) {
        this._loadFragmentOrKey(frag, level, levelDetails, pos, bufferEnd);
      }
      return;
    }
  }, {
    key: '_ensureFragmentAtLivePoint',
    value: function _ensureFragmentAtLivePoint(levelDetails, bufferEnd, start, end, fragPrevious, fragments, fragLen) {
      var config = this.hls.config,
          media = this.media;

      var frag = void 0;

      // check if requested position is within seekable boundaries :
      //logger.log(`start/pos/bufEnd/seeking:${start.toFixed(3)}/${pos.toFixed(3)}/${bufferEnd.toFixed(3)}/${this.media.seeking}`);
      var maxLatency = config.liveMaxLatencyDuration !== undefined ? config.liveMaxLatencyDuration : config.liveMaxLatencyDurationCount * levelDetails.targetduration;

      if (bufferEnd < Math.max(start - config.maxFragLookUpTolerance, end - maxLatency)) {
        var liveSyncPosition = this.liveSyncPosition = this.computeLivePosition(start, levelDetails);
        _logger.logger.log('buffer end: ' + bufferEnd.toFixed(3) + ' is located too far from the end of live sliding playlist, reset currentTime to : ' + liveSyncPosition.toFixed(3));
        bufferEnd = liveSyncPosition;
        if (media && media.readyState && media.duration > liveSyncPosition) {
          media.currentTime = liveSyncPosition;
        }
      }

      // if end of buffer greater than live edge, don't load any fragment
      // this could happen if live playlist intermittently slides in the past.
      // level 1 loaded [182580161,182580167]
      // level 1 loaded [182580162,182580169]
      // Loading 182580168 of [182580162 ,182580169],level 1 ..
      // Loading 182580169 of [182580162 ,182580169],level 1 ..
      // level 1 loaded [182580162,182580168] <============= here we should have bufferEnd > end. in that case break to avoid reloading 182580168
      // level 1 loaded [182580164,182580171]
      //
      // don't return null in case media not loaded yet (readystate === 0)
      if (levelDetails.PTSKnown && bufferEnd > end && media && media.readyState) {
        return null;
      }

      if (this.startFragRequested && !levelDetails.PTSKnown) {
        /* we are switching level on live playlist, but we don't have any PTS info for that quality level ...
           try to load frag matching with next SN.
           even if SN are not synchronized between playlists, loading this frag will help us
           compute playlist sliding and find the right one after in case it was not the right consecutive one */
        if (fragPrevious) {
          var targetSN = fragPrevious.sn + 1;
          if (targetSN >= levelDetails.startSN && targetSN <= levelDetails.endSN) {
            frag = fragments[targetSN - levelDetails.startSN];
            _logger.logger.log('live playlist, switching playlist, load frag with next SN: ' + frag.sn);
          }
        }
        if (!frag) {
          /* we have no idea about which fragment should be loaded.
             so let's load mid fragment. it will help computing playlist sliding and find the right one
          */
          frag = fragments[Math.min(fragLen - 1, Math.round(fragLen / 2))];
          _logger.logger.log('live playlist, switching playlist, unknown, load middle frag : ' + frag.sn);
        }
      }
      return frag;
    }
  }, {
    key: '_findFragment',
    value: function _findFragment(start, fragPrevious, fragLen, fragments, bufferEnd, end, levelDetails) {
      var config = this.hls.config;
      var frag = void 0;
      var foundFrag = void 0;
      var maxFragLookUpTolerance = config.maxFragLookUpTolerance;
      var fragNext = fragPrevious ? fragments[fragPrevious.sn - fragments[0].sn + 1] : undefined;
      var fragmentWithinToleranceTest = function fragmentWithinToleranceTest(candidate) {
        // offset should be within fragment boundary - config.maxFragLookUpTolerance
        // this is to cope with situations like
        // bufferEnd = 9.991
        // frag[Ø] : [0,10]
        // frag[1] : [10,20]
        // bufferEnd is within frag[0] range ... although what we are expecting is to return frag[1] here
        //              frag start               frag start+duration
        //                  |-----------------------------|
        //              <--->                         <--->
        //  ...--------><-----------------------------><---------....
        // previous frag         matching fragment         next frag
        //  return -1             return 0                 return 1
        //logger.log(`level/sn/start/end/bufEnd:${level}/${candidate.sn}/${candidate.start}/${(candidate.start+candidate.duration)}/${bufferEnd}`);
        // Set the lookup tolerance to be small enough to detect the current segment - ensures we don't skip over very small segments
        var candidateLookupTolerance = Math.min(maxFragLookUpTolerance, candidate.duration);
        if (candidate.start + candidate.duration - candidateLookupTolerance <= bufferEnd) {
          return 1;
        } // if maxFragLookUpTolerance will have negative value then don't return -1 for first element
        else if (candidate.start - candidateLookupTolerance > bufferEnd && candidate.start) {
            return -1;
          }
        return 0;
      };

      if (bufferEnd < end) {
        if (bufferEnd > end - maxFragLookUpTolerance) {
          maxFragLookUpTolerance = 0;
        }
        // Prefer the next fragment if it's within tolerance
        if (fragNext && !fragmentWithinToleranceTest(fragNext)) {
          foundFrag = fragNext;
        } else {
          foundFrag = _binarySearch2.default.search(fragments, fragmentWithinToleranceTest);
        }
      } else {
        // reach end of playlist
        foundFrag = fragments[fragLen - 1];
      }
      if (foundFrag) {
        frag = foundFrag;
        var curSNIdx = frag.sn - levelDetails.startSN;
        var sameLevel = fragPrevious && frag.level === fragPrevious.level;
        var prevFrag = fragments[curSNIdx - 1];
        var nextFrag = fragments[curSNIdx + 1];
        //logger.log('find SN matching with pos:' +  bufferEnd + ':' + frag.sn);
        if (sameLevel && frag.sn === fragPrevious.sn) {
          if (frag.sn < levelDetails.endSN) {
            var deltaPTS = fragPrevious.deltaPTS;
            // if there is a significant delta between audio and video, larger than max allowed hole,
            // and if previous remuxed fragment did not start with a keyframe. (fragPrevious.dropped)
            // let's try to load previous fragment again to get last keyframe
            // then we will reload again current fragment (that way we should be able to fill the buffer hole ...)
            if (deltaPTS && deltaPTS > config.maxBufferHole && fragPrevious.dropped && curSNIdx) {
              frag = prevFrag;
              _logger.logger.warn('SN just loaded, with large PTS gap between audio and video, maybe frag is not starting with a keyframe ? load previous one to try to overcome this');
              // decrement previous frag load counter to avoid frag loop loading error when next fragment will get reloaded
              fragPrevious.loadCounter--;
            } else {
              frag = nextFrag;
              _logger.logger.log('SN just loaded, load next one: ' + frag.sn);
            }
          } else {
            frag = null;
          }
        } else if (frag.dropped && !sameLevel) {
          // Only backtrack a max of 1 consecutive fragment to prevent sliding back too far when little or no frags start with keyframes
          if (nextFrag && nextFrag.backtracked) {
            _logger.logger.warn('Already backtracked from fragment ' + (curSNIdx + 1) + ', will not backtrack to fragment ' + curSNIdx + '. Loading fragment ' + (curSNIdx + 1));
            frag = nextFrag;
          } else {
            // If a fragment has dropped frames and it's in a different level/sequence, load the previous fragment to try and find the keyframe
            // Reset the dropped count now since it won't be reset until we parse the fragment again, which prevents infinite backtracking on the same segment
            _logger.logger.warn('Loaded fragment with dropped frames, backtracking 1 segment to find a keyframe');
            frag.dropped = 0;
            if (prevFrag) {
              if (prevFrag.loadCounter) {
                prevFrag.loadCounter--;
              }
              frag = prevFrag;
            } else {
              frag = null;
            }
          }
        }
      }
      return frag;
    }
  }, {
    key: '_loadFragmentOrKey',
    value: function _loadFragmentOrKey(frag, level, levelDetails, pos, bufferEnd) {
      var hls = this.hls,
          config = hls.config;

      //logger.log('loading frag ' + i +',pos/bufEnd:' + pos.toFixed(3) + '/' + bufferEnd.toFixed(3));
      if (frag.decryptdata && frag.decryptdata.uri != null && frag.decryptdata.key == null) {
        _logger.logger.log('Loading key for ' + frag.sn + ' of [' + levelDetails.startSN + ' ,' + levelDetails.endSN + '],level ' + level);
        this.state = State.KEY_LOADING;
        hls.trigger(_events2.default.KEY_LOADING, { frag: frag });
      } else {
        _logger.logger.log('Loading ' + frag.sn + ' of [' + levelDetails.startSN + ' ,' + levelDetails.endSN + '],level ' + level + ', currentTime:' + pos.toFixed(3) + ',bufferEnd:' + bufferEnd.toFixed(3));
        // ensure that we are not reloading the same fragments in loop ...
        if (this.fragLoadIdx !== undefined) {
          this.fragLoadIdx++;
        } else {
          this.fragLoadIdx = 0;
        }
        if (frag.loadCounter) {
          frag.loadCounter++;
          var maxThreshold = config.fragLoadingLoopThreshold;
          // if this frag has already been loaded 3 times, and if it has been reloaded recently
          if (frag.loadCounter > maxThreshold && Math.abs(this.fragLoadIdx - frag.loadIdx) < maxThreshold) {
            hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.MEDIA_ERROR, details: _errors.ErrorDetails.FRAG_LOOP_LOADING_ERROR, fatal: false, frag: frag });
            return;
          }
        } else {
          frag.loadCounter = 1;
        }
        frag.loadIdx = this.fragLoadIdx;
        this.fragCurrent = frag;
        this.startFragRequested = true;
        if (!isNaN(frag.sn)) {
          this.nextLoadPosition = frag.start + frag.duration;
        }
        frag.autoLevel = hls.autoLevelEnabled;
        frag.bitrateTest = this.bitrateTest;
        hls.trigger(_events2.default.FRAG_LOADING, { frag: frag });
        // lazy demuxer init, as this could take some time ... do it during frag loading
        if (!this.demuxer) {
          this.demuxer = new _demuxer2.default(hls, 'main');
        }
        this.state = State.FRAG_LOADING;
        return;
      }
    }
  }, {
    key: 'getBufferedFrag',
    value: function getBufferedFrag(position) {
      return _binarySearch2.default.search(this._bufferedFrags, function (frag) {
        if (position < frag.startPTS) {
          return -1;
        } else if (position > frag.endPTS) {
          return 1;
        }
        return 0;
      });
    }
  }, {
    key: 'followingBufferedFrag',
    value: function followingBufferedFrag(frag) {
      if (frag) {
        // try to get range of next fragment (500ms after this range)
        return this.getBufferedFrag(frag.endPTS + 0.5);
      }
      return null;
    }
  }, {
    key: '_checkFragmentChanged',
    value: function _checkFragmentChanged() {
      var fragPlayingCurrent,
          currentTime,
          video = this.media;
      if (video && video.readyState && video.seeking === false) {
        currentTime = video.currentTime;
        /* if video element is in seeked state, currentTime can only increase.
          (assuming that playback rate is positive ...)
          As sometimes currentTime jumps back to zero after a
          media decode error, check this, to avoid seeking back to
          wrong position after a media decode error
        */
        if (currentTime > video.playbackRate * this.lastCurrentTime) {
          this.lastCurrentTime = currentTime;
        }
        if (_bufferHelper2.default.isBuffered(video, currentTime)) {
          fragPlayingCurrent = this.getBufferedFrag(currentTime);
        } else if (_bufferHelper2.default.isBuffered(video, currentTime + 0.1)) {
          /* ensure that FRAG_CHANGED event is triggered at startup,
            when first video frame is displayed and playback is paused.
            add a tolerance of 100ms, in case current position is not buffered,
            check if current pos+100ms is buffered and use that buffer range
            for FRAG_CHANGED event reporting */
          fragPlayingCurrent = this.getBufferedFrag(currentTime + 0.1);
        }
        if (fragPlayingCurrent) {
          var fragPlaying = fragPlayingCurrent;
          if (fragPlaying !== this.fragPlaying) {
            this.hls.trigger(_events2.default.FRAG_CHANGED, { frag: fragPlaying });
            var fragPlayingLevel = fragPlaying.level;
            if (!this.fragPlaying || this.fragPlaying.level !== fragPlayingLevel) {
              this.hls.trigger(_events2.default.LEVEL_SWITCHED, { level: fragPlayingLevel });
            }
            this.fragPlaying = fragPlaying;
          }
        }
      }
    }

    /*
      on immediate level switch :
       - pause playback if playing
       - cancel any pending load request
       - and trigger a buffer flush
    */

  }, {
    key: 'immediateLevelSwitch',
    value: function immediateLevelSwitch() {
      _logger.logger.log('immediateLevelSwitch');
      if (!this.immediateSwitch) {
        this.immediateSwitch = true;
        var media = this.media,
            previouslyPaused = void 0;
        if (media) {
          previouslyPaused = media.paused;
          media.pause();
        } else {
          // don't restart playback after instant level switch in case media not attached
          previouslyPaused = true;
        }
        this.previouslyPaused = previouslyPaused;
      }
      var fragCurrent = this.fragCurrent;
      if (fragCurrent && fragCurrent.loader) {
        fragCurrent.loader.abort();
      }
      this.fragCurrent = null;
      // increase fragment load Index to avoid frag loop loading error after buffer flush
      this.fragLoadIdx += 2 * this.config.fragLoadingLoopThreshold;
      // flush everything
      this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
    }

    /*
       on immediate level switch end, after new fragment has been buffered :
        - nudge video decoder by slightly adjusting video currentTime (if currentTime buffered)
        - resume the playback if needed
    */

  }, {
    key: 'immediateLevelSwitchEnd',
    value: function immediateLevelSwitchEnd() {
      var media = this.media;
      if (media && media.buffered.length) {
        this.immediateSwitch = false;
        if (_bufferHelper2.default.isBuffered(media, media.currentTime)) {
          // only nudge if currentTime is buffered
          media.currentTime -= 0.0001;
        }
        if (!this.previouslyPaused) {
          media.play();
        }
      }
    }
  }, {
    key: 'nextLevelSwitch',
    value: function nextLevelSwitch() {
      /* try to switch ASAP without breaking video playback :
         in order to ensure smooth but quick level switching,
        we need to find the next flushable buffer range
        we should take into account new segment fetch time
      */
      var media = this.media;
      // ensure that media is defined and that metadata are available (to retrieve currentTime)
      if (media && media.readyState) {
        var fetchdelay = void 0,
            fragPlayingCurrent = void 0,
            nextBufferedFrag = void 0;
        // increase fragment load Index to avoid frag loop loading error after buffer flush
        this.fragLoadIdx += 2 * this.config.fragLoadingLoopThreshold;
        fragPlayingCurrent = this.getBufferedFrag(media.currentTime);
        if (fragPlayingCurrent && fragPlayingCurrent.startPTS > 1) {
          // flush buffer preceding current fragment (flush until current fragment start offset)
          // minus 1s to avoid video freezing, that could happen if we flush keyframe of current video ...
          this.flushMainBuffer(0, fragPlayingCurrent.startPTS - 1);
        }
        if (!media.paused) {
          // add a safety delay of 1s
          var nextLevelId = this.hls.nextLoadLevel,
              nextLevel = this.levels[nextLevelId],
              fragLastKbps = this.fragLastKbps;
          if (fragLastKbps && this.fragCurrent) {
            fetchdelay = this.fragCurrent.duration * nextLevel.bitrate / (1000 * fragLastKbps) + 1;
          } else {
            fetchdelay = 0;
          }
        } else {
          fetchdelay = 0;
        }
        //logger.log('fetchdelay:'+fetchdelay);
        // find buffer range that will be reached once new fragment will be fetched
        nextBufferedFrag = this.getBufferedFrag(media.currentTime + fetchdelay);
        if (nextBufferedFrag) {
          // we can flush buffer range following this one without stalling playback
          nextBufferedFrag = this.followingBufferedFrag(nextBufferedFrag);
          if (nextBufferedFrag) {
            // if we are here, we can also cancel any loading/demuxing in progress, as they are useless
            var fragCurrent = this.fragCurrent;
            if (fragCurrent && fragCurrent.loader) {
              fragCurrent.loader.abort();
            }
            this.fragCurrent = null;
            // flush position is the start position of this new buffer
            this.flushMainBuffer(nextBufferedFrag.startPTS, Number.POSITIVE_INFINITY);
          }
        }
      }
    }
  }, {
    key: 'flushMainBuffer',
    value: function flushMainBuffer(startOffset, endOffset) {
      this.state = State.BUFFER_FLUSHING;
      var flushScope = { startOffset: startOffset, endOffset: endOffset };
      // if alternate audio tracks are used, only flush video, otherwise flush everything
      if (this.altAudio) {
        flushScope.type = 'video';
      }
      this.hls.trigger(_events2.default.BUFFER_FLUSHING, flushScope);
    }
  }, {
    key: 'onMediaAttached',
    value: function onMediaAttached(data) {
      var media = this.media = this.mediaBuffer = data.media;
      this.onvseeking = this.onMediaSeeking.bind(this);
      this.onvseeked = this.onMediaSeeked.bind(this);
      this.onvended = this.onMediaEnded.bind(this);
      media.addEventListener('seeking', this.onvseeking);
      media.addEventListener('seeked', this.onvseeked);
      media.addEventListener('ended', this.onvended);
      var config = this.config;
      if (this.levels && config.autoStartLoad) {
        this.hls.startLoad(config.startPosition);
      }
    }
  }, {
    key: 'onMediaDetaching',
    value: function onMediaDetaching() {
      var media = this.media;
      if (media && media.ended) {
        _logger.logger.log('MSE detaching and video ended, reset startPosition');
        this.startPosition = this.lastCurrentTime = 0;
      }

      // reset fragment loading counter on MSE detaching to avoid reporting FRAG_LOOP_LOADING_ERROR after error recovery
      var levels = this.levels;
      if (levels) {
        // reset fragment load counter
        levels.forEach(function (level) {
          if (level.details) {
            level.details.fragments.forEach(function (fragment) {
              fragment.loadCounter = undefined;
              fragment.backtracked = undefined;
            });
          }
        });
      }
      // remove video listeners
      if (media) {
        media.removeEventListener('seeking', this.onvseeking);
        media.removeEventListener('seeked', this.onvseeked);
        media.removeEventListener('ended', this.onvended);
        this.onvseeking = this.onvseeked = this.onvended = null;
      }
      this.media = this.mediaBuffer = null;
      this.loadedmetadata = false;
      this.stopLoad();
    }
  }, {
    key: 'onMediaSeeking',
    value: function onMediaSeeking() {
      var media = this.media,
          currentTime = media ? media.currentTime : undefined,
          config = this.config;
      if (!isNaN(currentTime)) {
        _logger.logger.log('media seeking to ' + currentTime.toFixed(3));
      }
      var mediaBuffer = this.mediaBuffer ? this.mediaBuffer : media;
      var bufferInfo = _bufferHelper2.default.bufferInfo(mediaBuffer, currentTime, this.config.maxBufferHole);
      if (this.state === State.FRAG_LOADING) {
        var fragCurrent = this.fragCurrent;
        // check if we are seeking to a unbuffered area AND if frag loading is in progress
        if (bufferInfo.len === 0 && fragCurrent) {
          var tolerance = config.maxFragLookUpTolerance,
              fragStartOffset = fragCurrent.start - tolerance,
              fragEndOffset = fragCurrent.start + fragCurrent.duration + tolerance;
          // check if we seek position will be out of currently loaded frag range : if out cancel frag load, if in, don't do anything
          if (currentTime < fragStartOffset || currentTime > fragEndOffset) {
            if (fragCurrent.loader) {
              _logger.logger.log('seeking outside of buffer while fragment load in progress, cancel fragment load');
              fragCurrent.loader.abort();
            }
            this.fragCurrent = null;
            this.fragPrevious = null;
            // switch to IDLE state to load new fragment
            this.state = State.IDLE;
          } else {
            _logger.logger.log('seeking outside of buffer but within currently loaded fragment range');
          }
        }
      } else if (this.state === State.ENDED) {
        // if seeking to unbuffered area, clean up fragPrevious
        if (bufferInfo.len === 0) {
          this.fragPrevious = 0;
        }
        // switch to IDLE state to check for potential new fragment
        this.state = State.IDLE;
      }
      if (media) {
        this.lastCurrentTime = currentTime;
      }
      // avoid reporting fragment loop loading error in case user is seeking several times on same position
      if (this.state !== State.FRAG_LOADING && this.fragLoadIdx !== undefined) {
        this.fragLoadIdx += 2 * config.fragLoadingLoopThreshold;
      }
      // in case seeking occurs although no media buffered, adjust startPosition and nextLoadPosition to seek target
      if (!this.loadedmetadata) {
        this.nextLoadPosition = this.startPosition = currentTime;
      }
      // tick to speed up processing
      this.tick();
    }
  }, {
    key: 'onMediaSeeked',
    value: function onMediaSeeked() {
      var media = this.media,
          currentTime = media ? media.currentTime : undefined;
      if (!isNaN(currentTime)) {
        _logger.logger.log('media seeked to ' + currentTime.toFixed(3));
      }
      // tick to speed up FRAGMENT_PLAYING triggering
      this.tick();
    }
  }, {
    key: 'onMediaEnded',
    value: function onMediaEnded() {
      _logger.logger.log('media ended');
      // reset startPosition and lastCurrentTime to restart playback @ stream beginning
      this.startPosition = this.lastCurrentTime = 0;
    }
  }, {
    key: 'onManifestLoading',
    value: function onManifestLoading() {
      // reset buffer on manifest loading
      _logger.logger.log('trigger BUFFER_RESET');
      this.hls.trigger(_events2.default.BUFFER_RESET);
      this._bufferedFrags = [];
      this.stalled = false;
      this.startPosition = this.lastCurrentTime = 0;
    }
  }, {
    key: 'onManifestParsed',
    value: function onManifestParsed(data) {
      var aac = false,
          heaac = false,
          codec;
      data.levels.forEach(function (level) {
        // detect if we have different kind of audio codecs used amongst playlists
        codec = level.audioCodec;
        if (codec) {
          if (codec.indexOf('mp4a.40.2') !== -1) {
            aac = true;
          }
          if (codec.indexOf('mp4a.40.5') !== -1) {
            heaac = true;
          }
        }
      });
      this.audioCodecSwitch = aac && heaac;
      if (this.audioCodecSwitch) {
        _logger.logger.log('both AAC/HE-AAC audio found in levels; declaring level codec as HE-AAC');
      }
      this.levels = data.levels;
      this.startLevelLoaded = false;
      this.startFragRequested = false;
      var config = this.config;
      if (config.autoStartLoad || this.forceStartLoad) {
        this.hls.startLoad(config.startPosition);
      }
    }
  }, {
    key: 'onLevelLoaded',
    value: function onLevelLoaded(data) {
      var newDetails = data.details,
          newLevelId = data.level,
          curLevel = this.levels[newLevelId],
          duration = newDetails.totalduration,
          sliding = 0;

      _logger.logger.log('level ' + newLevelId + ' loaded [' + newDetails.startSN + ',' + newDetails.endSN + '],duration:' + duration);
      this.levelLastLoaded = newLevelId;

      if (newDetails.live) {
        var curDetails = curLevel.details;
        if (curDetails && newDetails.fragments.length > 0) {
          // we already have details for that level, merge them
          _levelHelper2.default.mergeDetails(curDetails, newDetails);
          sliding = newDetails.fragments[0].start;
          this.liveSyncPosition = this.computeLivePosition(sliding, curDetails);
          if (newDetails.PTSKnown) {
            _logger.logger.log('live playlist sliding:' + sliding.toFixed(3));
          } else {
            _logger.logger.log('live playlist - outdated PTS, unknown sliding');
          }
        } else {
          newDetails.PTSKnown = false;
          _logger.logger.log('live playlist - first load, unknown sliding');
        }
      } else {
        newDetails.PTSKnown = false;
      }
      // override level info
      curLevel.details = newDetails;
      this.hls.trigger(_events2.default.LEVEL_UPDATED, { details: newDetails, level: newLevelId });

      if (this.startFragRequested === false) {
        // compute start position if set to -1. use it straight away if value is defined
        if (this.startPosition === -1 || this.lastCurrentTime === -1) {
          // first, check if start time offset has been set in playlist, if yes, use this value
          var startTimeOffset = newDetails.startTimeOffset;
          if (!isNaN(startTimeOffset)) {
            if (startTimeOffset < 0) {
              _logger.logger.log('negative start time offset ' + startTimeOffset + ', count from end of last fragment');
              startTimeOffset = sliding + duration + startTimeOffset;
            }
            _logger.logger.log('start time offset found in playlist, adjust startPosition to ' + startTimeOffset);
            this.startPosition = startTimeOffset;
          } else {
            // if live playlist, set start position to be fragment N-this.config.liveSyncDurationCount (usually 3)
            if (newDetails.live) {
              this.startPosition = this.computeLivePosition(sliding, newDetails);
              _logger.logger.log('configure startPosition to ' + this.startPosition);
            } else {
              this.startPosition = 0;
            }
          }
          this.lastCurrentTime = this.startPosition;
        }
        this.nextLoadPosition = this.startPosition;
      }
      // only switch batck to IDLE state if we were waiting for level to start downloading a new fragment
      if (this.state === State.WAITING_LEVEL) {
        this.state = State.IDLE;
      }
      //trigger handler right now
      this.tick();
    }
  }, {
    key: 'onKeyLoaded',
    value: function onKeyLoaded() {
      if (this.state === State.KEY_LOADING) {
        this.state = State.IDLE;
        this.tick();
      }
    }
  }, {
    key: 'onFragLoaded',
    value: function onFragLoaded(data) {
      var fragCurrent = this.fragCurrent,
          fragLoaded = data.frag;
      if (this.state === State.FRAG_LOADING && fragCurrent && fragLoaded.type === 'main' && fragLoaded.level === fragCurrent.level && fragLoaded.sn === fragCurrent.sn) {
        var stats = data.stats,
            currentLevel = this.levels[fragCurrent.level],
            details = currentLevel.details;
        _logger.logger.log('Loaded  ' + fragCurrent.sn + ' of [' + details.startSN + ' ,' + details.endSN + '],level ' + fragCurrent.level);
        // reset frag bitrate test in any case after frag loaded event
        this.bitrateTest = false;
        this.stats = stats;
        // if this frag was loaded to perform a bitrate test AND if hls.nextLoadLevel is greater than 0
        // then this means that we should be able to load a fragment at a higher quality level
        if (fragLoaded.bitrateTest === true && this.hls.nextLoadLevel) {
          // switch back to IDLE state ... we just loaded a fragment to determine adequate start bitrate and initialize autoswitch algo
          this.state = State.IDLE;
          this.startFragRequested = false;
          stats.tparsed = stats.tbuffered = performance.now();
          this.hls.trigger(_events2.default.FRAG_BUFFERED, { stats: stats, frag: fragCurrent, id: 'main' });
          this.tick();
        } else if (fragLoaded.sn === 'initSegment') {
          this.state = State.IDLE;
          stats.tparsed = stats.tbuffered = performance.now();
          details.initSegment.data = data.payload;
          this.hls.trigger(_events2.default.FRAG_BUFFERED, { stats: stats, frag: fragCurrent, id: 'main' });
          this.tick();
        } else {
          this.state = State.PARSING;
          // transmux the MPEG-TS data to ISO-BMFF segments
          var duration = details.totalduration,
              level = fragCurrent.level,
              sn = fragCurrent.sn,
              audioCodec = this.config.defaultAudioCodec || currentLevel.audioCodec;
          if (this.audioCodecSwap) {
            _logger.logger.log('swapping playlist audio codec');
            if (audioCodec === undefined) {
              audioCodec = this.lastAudioCodec;
            }
            if (audioCodec) {
              if (audioCodec.indexOf('mp4a.40.5') !== -1) {
                audioCodec = 'mp4a.40.2';
              } else {
                audioCodec = 'mp4a.40.5';
              }
            }
          }
          this.pendingBuffering = true;
          this.appended = false;
          _logger.logger.log('Parsing ' + sn + ' of [' + details.startSN + ' ,' + details.endSN + '],level ' + level + ', cc ' + fragCurrent.cc);
          var demuxer = this.demuxer;
          if (!demuxer) {
            demuxer = this.demuxer = new _demuxer2.default(this.hls, 'main');
          }
          // time Offset is accurate if level PTS is known, or if playlist is not sliding (not live) and if media is not seeking (this is to overcome potential timestamp drifts between playlists and fragments)
          var media = this.media;
          var mediaSeeking = media && media.seeking;
          var accurateTimeOffset = !mediaSeeking && (details.PTSKnown || !details.live);
          var initSegmentData = details.initSegment ? details.initSegment.data : [];
          demuxer.push(data.payload, initSegmentData, audioCodec, currentLevel.videoCodec, fragCurrent, duration, accurateTimeOffset, undefined);
        }
      }
      this.fragLoadError = 0;
    }
  }, {
    key: 'onFragParsingInitSegment',
    value: function onFragParsingInitSegment(data) {
      var fragCurrent = this.fragCurrent;
      var fragNew = data.frag;
      if (fragCurrent && data.id === 'main' && fragNew.sn === fragCurrent.sn && fragNew.level === fragCurrent.level && this.state === State.PARSING) {
        var tracks = data.tracks,
            trackName,
            track;

        // if audio track is expected to come from audio stream controller, discard any coming from main
        if (tracks.audio && this.altAudio) {
          delete tracks.audio;
        }
        // include levelCodec in audio and video tracks
        track = tracks.audio;
        if (track) {
          var audioCodec = this.levels[this.level].audioCodec,
              ua = navigator.userAgent.toLowerCase();
          if (audioCodec && this.audioCodecSwap) {
            _logger.logger.log('swapping playlist audio codec');
            if (audioCodec.indexOf('mp4a.40.5') !== -1) {
              audioCodec = 'mp4a.40.2';
            } else {
              audioCodec = 'mp4a.40.5';
            }
          }
          // in case AAC and HE-AAC audio codecs are signalled in manifest
          // force HE-AAC , as it seems that most browsers prefers that way,
          // except for mono streams OR on FF
          // these conditions might need to be reviewed ...
          if (this.audioCodecSwitch) {
            // don't force HE-AAC if mono stream
            if (track.metadata.channelCount !== 1 &&
            // don't force HE-AAC if firefox
            ua.indexOf('firefox') === -1) {
              audioCodec = 'mp4a.40.5';
            }
          }
          // HE-AAC is broken on Android, always signal audio codec as AAC even if variant manifest states otherwise
          if (ua.indexOf('android') !== -1 && track.container !== 'audio/mpeg') {
            // Exclude mpeg audio
            audioCodec = 'mp4a.40.2';
            _logger.logger.log('Android: force audio codec to ' + audioCodec);
          }
          track.levelCodec = audioCodec;
          track.id = data.id;
        }
        track = tracks.video;
        if (track) {
          track.levelCodec = this.levels[this.level].videoCodec;
          track.id = data.id;
        }
        this.hls.trigger(_events2.default.BUFFER_CODECS, tracks);
        // loop through tracks that are going to be provided to bufferController
        for (trackName in tracks) {
          track = tracks[trackName];
          _logger.logger.log('main track:' + trackName + ',container:' + track.container + ',codecs[level/parsed]=[' + track.levelCodec + '/' + track.codec + ']');
          var initSegment = track.initSegment;
          if (initSegment) {
            this.appended = true;
            // arm pending Buffering flag before appending a segment
            this.pendingBuffering = true;
            this.hls.trigger(_events2.default.BUFFER_APPENDING, { type: trackName, data: initSegment, parent: 'main', content: 'initSegment' });
          }
        }
        //trigger handler right now
        this.tick();
      }
    }
  }, {
    key: 'onFragParsingData',
    value: function onFragParsingData(data) {
      var _this2 = this;

      var fragCurrent = this.fragCurrent;
      var fragNew = data.frag;
      if (fragCurrent && data.id === 'main' && fragNew.sn === fragCurrent.sn && fragNew.level === fragCurrent.level && !(data.type === 'audio' && this.altAudio) && // filter out main audio if audio track is loaded through audio stream controller
      this.state === State.PARSING) {
        var level = this.levels[this.level],
            frag = fragCurrent;
        if (isNaN(data.endPTS)) {
          data.endPTS = data.startPTS + fragCurrent.duration;
          data.endDTS = data.startDTS + fragCurrent.duration;
        }

        _logger.logger.log('Parsed ' + data.type + ',PTS:[' + data.startPTS.toFixed(3) + ',' + data.endPTS.toFixed(3) + '],DTS:[' + data.startDTS.toFixed(3) + '/' + data.endDTS.toFixed(3) + '],nb:' + data.nb + ',dropped:' + (data.dropped || 0));

        // Detect gaps in a fragment  and try to fix it by finding a keyframe in the previous fragment (see _findFragments)
        if (data.type === 'video') {
          frag.dropped = data.dropped;
          if (frag.dropped) {
            if (!frag.backtracked) {
              // Return back to the IDLE state without appending to buffer
              // Causes findFragments to backtrack a segment and find the keyframe
              // Audio fragments arriving before video sets the nextLoadPosition, causing _findFragments to skip the backtracked fragment
              frag.backtracked = true;
              this.nextLoadPosition = data.startPTS;
              this.state = State.IDLE;
              this.tick();
              return;
            } else {
              _logger.logger.warn('Already backtracked on this fragment, appending with the gap');
            }
          } else {
            // Only reset the backtracked flag if we've loaded the frag without any dropped frames
            frag.backtracked = false;
          }
        }

        var drift = _levelHelper2.default.updateFragPTSDTS(level.details, frag, data.startPTS, data.endPTS, data.startDTS, data.endDTS),
            hls = this.hls;
        hls.trigger(_events2.default.LEVEL_PTS_UPDATED, { details: level.details, level: this.level, drift: drift, type: data.type, start: data.startPTS, end: data.endPTS });

        // has remuxer dropped video frames located before first keyframe ?
        [data.data1, data.data2].forEach(function (buffer) {
          // only append in PARSING state (rationale is that an appending error could happen synchronously on first segment appending)
          // in that case it is useless to append following segments
          if (buffer && buffer.length && _this2.state === State.PARSING) {
            _this2.appended = true;
            // arm pending Buffering flag before appending a segment
            _this2.pendingBuffering = true;
            hls.trigger(_events2.default.BUFFER_APPENDING, { type: data.type, data: buffer, parent: 'main', content: 'data' });
          }
        });
        //trigger handler right now
        this.tick();
      }
    }
  }, {
    key: 'onFragParsed',
    value: function onFragParsed(data) {
      var fragCurrent = this.fragCurrent;
      var fragNew = data.frag;
      if (fragCurrent && data.id === 'main' && fragNew.sn === fragCurrent.sn && fragNew.level === fragCurrent.level && this.state === State.PARSING) {
        this.stats.tparsed = performance.now();
        this.state = State.PARSED;
        this._checkAppendedParsed();
      }
    }
  }, {
    key: 'onAudioTrackSwitching',
    value: function onAudioTrackSwitching(data) {
      // if any URL found on new audio track, it is an alternate audio track
      var altAudio = !!data.url,
          trackId = data.id;
      // if we switch on main audio, ensure that main fragment scheduling is synced with media.buffered
      // don't do anything if we switch to alt audio: audio stream controller is handling it.
      // we will just have to change buffer scheduling on audioTrackSwitched
      if (!altAudio) {
        if (this.mediaBuffer !== this.media) {
          _logger.logger.log('switching on main audio, use media.buffered to schedule main fragment loading');
          this.mediaBuffer = this.media;
          var fragCurrent = this.fragCurrent;
          // we need to refill audio buffer from main: cancel any frag loading to speed up audio switch
          if (fragCurrent.loader) {
            _logger.logger.log('switching to main audio track, cancel main fragment load');
            fragCurrent.loader.abort();
          }
          this.fragCurrent = null;
          this.fragPrevious = null;
          // destroy demuxer to force init segment generation (following audio switch)
          if (this.demuxer) {
            this.demuxer.destroy();
            this.demuxer = null;
          }
          // switch to IDLE state to load new fragment
          this.state = State.IDLE;
        }
        var hls = this.hls;
        // switching to main audio, flush all audio and trigger track switched
        hls.trigger(_events2.default.BUFFER_FLUSHING, { startOffset: 0, endOffset: Number.POSITIVE_INFINITY, type: 'audio' });
        hls.trigger(_events2.default.AUDIO_TRACK_SWITCHED, { id: trackId });
        this.altAudio = false;
      }
    }
  }, {
    key: 'onAudioTrackSwitched',
    value: function onAudioTrackSwitched(data) {
      var trackId = data.id,
          altAudio = !!this.hls.audioTracks[trackId].url;
      if (altAudio) {
        var videoBuffer = this.videoBuffer;
        // if we switched on alternate audio, ensure that main fragment scheduling is synced with video sourcebuffer buffered
        if (videoBuffer && this.mediaBuffer !== videoBuffer) {
          _logger.logger.log('switching on alternate audio, use video.buffered to schedule main fragment loading');
          this.mediaBuffer = videoBuffer;
        }
      }
      this.altAudio = altAudio;
      this.tick();
    }
  }, {
    key: 'onBufferCreated',
    value: function onBufferCreated(data) {
      var tracks = data.tracks,
          mediaTrack = void 0,
          name = void 0,
          alternate = false;
      for (var type in tracks) {
        var track = tracks[type];
        if (track.id === 'main') {
          name = type;
          mediaTrack = track;
          // keep video source buffer reference
          if (type === 'video') {
            this.videoBuffer = tracks[type].buffer;
          }
        } else {
          alternate = true;
        }
      }
      if (alternate && mediaTrack) {
        _logger.logger.log('alternate track found, use ' + name + '.buffered to schedule main fragment loading');
        this.mediaBuffer = mediaTrack.buffer;
      } else {
        this.mediaBuffer = this.media;
      }
    }
  }, {
    key: 'onBufferAppended',
    value: function onBufferAppended(data) {
      if (data.parent === 'main') {
        var state = this.state;
        if (state === State.PARSING || state === State.PARSED) {
          // check if all buffers have been appended
          this.pendingBuffering = data.pending > 0;
          this._checkAppendedParsed();
        }
      }
    }
  }, {
    key: '_checkAppendedParsed',
    value: function _checkAppendedParsed() {
      //trigger handler right now
      if (this.state === State.PARSED && (!this.appended || !this.pendingBuffering)) {
        var frag = this.fragCurrent;
        if (frag) {
          var media = this.mediaBuffer ? this.mediaBuffer : this.media;
          _logger.logger.log('main buffered : ' + _timeRanges2.default.toString(media.buffered));
          // filter fragments potentially evicted from buffer. this is to avoid memleak on live streams
          var bufferedFrags = this._bufferedFrags.filter(function (frag) {
            return _bufferHelper2.default.isBuffered(media, (frag.startPTS + frag.endPTS) / 2);
          });
          // push new range
          bufferedFrags.push(frag);
          // sort frags, as we use BinarySearch for lookup in getBufferedFrag ...
          this._bufferedFrags = bufferedFrags.sort(function (a, b) {
            return a.startPTS - b.startPTS;
          });
          this.fragPrevious = frag;
          var stats = this.stats;
          stats.tbuffered = performance.now();
          // we should get rid of this.fragLastKbps
          this.fragLastKbps = Math.round(8 * stats.total / (stats.tbuffered - stats.tfirst));
          this.hls.trigger(_events2.default.FRAG_BUFFERED, { stats: stats, frag: frag, id: 'main' });
          this.state = State.IDLE;
        }
        this.tick();
      }
    }
  }, {
    key: 'onError',
    value: function onError(data) {
      var frag = data.frag || this.fragCurrent;
      // don't handle frag error not related to main fragment
      if (frag && frag.type !== 'main') {
        return;
      }
      var media = this.media,

      // 0.5 : tolerance needed as some browsers stalls playback before reaching buffered end
      mediaBuffered = media && _bufferHelper2.default.isBuffered(media, media.currentTime) && _bufferHelper2.default.isBuffered(media, media.currentTime + 0.5);
      switch (data.details) {
        case _errors.ErrorDetails.FRAG_LOAD_ERROR:
        case _errors.ErrorDetails.FRAG_LOAD_TIMEOUT:
        case _errors.ErrorDetails.KEY_LOAD_ERROR:
        case _errors.ErrorDetails.KEY_LOAD_TIMEOUT:
          if (!data.fatal) {
            var loadError = this.fragLoadError;
            if (loadError) {
              loadError++;
            } else {
              loadError = 1;
            }
            var config = this.config;
            // keep retrying / don't raise fatal network error if current position is buffered or if in automode with current level not 0
            if (loadError <= config.fragLoadingMaxRetry || mediaBuffered || frag.autoLevel && frag.level) {
              this.fragLoadError = loadError;
              // reset load counter to avoid frag loop loading error
              frag.loadCounter = 0;
              // exponential backoff capped to config.fragLoadingMaxRetryTimeout
              var delay = Math.min(Math.pow(2, loadError - 1) * config.fragLoadingRetryDelay, config.fragLoadingMaxRetryTimeout);
              _logger.logger.warn('mediaController: frag loading failed, retry in ' + delay + ' ms');
              this.retryDate = performance.now() + delay;
              // retry loading state
              // if loadedmetadata is not set, it means that we are emergency switch down on first frag
              // in that case, reset startFragRequested flag
              if (!this.loadedmetadata) {
                this.startFragRequested = false;
                this.nextLoadPosition = this.startPosition;
              }
              this.state = State.FRAG_LOADING_WAITING_RETRY;
            } else {
              _logger.logger.error('mediaController: ' + data.details + ' reaches max retry, redispatch as fatal ...');
              // switch error to fatal
              data.fatal = true;
              this.state = State.ERROR;
            }
          }
          break;
        case _errors.ErrorDetails.FRAG_LOOP_LOADING_ERROR:
          if (!data.fatal) {
            // if buffer is not empty
            if (mediaBuffered) {
              // try to reduce max buffer length : rationale is that we could get
              // frag loop loading error because of buffer eviction
              this._reduceMaxBufferLength(frag.duration);
              this.state = State.IDLE;
            } else {
              // buffer empty. report as fatal if in manual mode or if lowest level.
              // level controller takes care of emergency switch down logic
              if (!frag.autoLevel || frag.level === 0) {
                // switch error to fatal
                data.fatal = true;
                this.state = State.ERROR;
              }
            }
          }
          break;
        case _errors.ErrorDetails.LEVEL_LOAD_ERROR:
        case _errors.ErrorDetails.LEVEL_LOAD_TIMEOUT:
          if (this.state !== State.ERROR) {
            if (data.fatal) {
              // if fatal error, stop processing
              this.state = State.ERROR;
              _logger.logger.warn('streamController: ' + data.details + ',switch to ' + this.state + ' state ...');
            } else {
              // in case of non fatal error while loading level, if level controller is not retrying to load level , switch back to IDLE
              if (!data.levelRetry && this.state === State.WAITING_LEVEL) {
                this.state = State.IDLE;
              }
            }
          }
          break;
        case _errors.ErrorDetails.BUFFER_FULL_ERROR:
          // if in appending state
          if (data.parent === 'main' && (this.state === State.PARSING || this.state === State.PARSED)) {
            // reduce max buf len if current position is buffered
            if (mediaBuffered) {
              this._reduceMaxBufferLength(this.config.maxBufferLength);
              this.state = State.IDLE;
            } else {
              // current position is not buffered, but browser is still complaining about buffer full error
              // this happens on IE/Edge, refer to https://github.com/video-dev/hls.js/pull/708
              // in that case flush the whole buffer to recover
              _logger.logger.warn('buffer full error also media.currentTime is not buffered, flush everything');
              this.fragCurrent = null;
              // flush everything
              this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
            }
          }
          break;
        default:
          break;
      }
    }
  }, {
    key: '_reduceMaxBufferLength',
    value: function _reduceMaxBufferLength(minLength) {
      var config = this.config;
      if (config.maxMaxBufferLength >= minLength) {
        // reduce max buffer length as it might be too high. we do this to avoid loop flushing ...
        config.maxMaxBufferLength /= 2;
        _logger.logger.warn('main:reduce max buffer length to ' + config.maxMaxBufferLength + 's');
        // increase fragment load Index to avoid frag loop loading error after buffer flush
        this.fragLoadIdx += 2 * config.fragLoadingLoopThreshold;
      }
    }
  }, {
    key: '_checkBuffer',
    value: function _checkBuffer() {
      var media = this.media;
      // if ready state different from HAVE_NOTHING (numeric value 0), we are allowed to seek
      if (media && media.readyState) {
        var currentTime = media.currentTime,
            mediaBuffer = this.mediaBuffer ? this.mediaBuffer : media,
            buffered = mediaBuffer.buffered;
        // adjust currentTime to start position on loaded metadata
        if (!this.loadedmetadata && buffered.length) {
          this.loadedmetadata = true;
          // only adjust currentTime if different from startPosition or if startPosition not buffered
          // at that stage, there should be only one buffered range, as we reach that code after first fragment has been buffered
          var startPosition = media.seeking ? currentTime : this.startPosition,
              startPositionBuffered = _bufferHelper2.default.isBuffered(mediaBuffer, startPosition);
          // if currentTime not matching with expected startPosition or startPosition not buffered
          if (currentTime !== startPosition || !startPositionBuffered) {
            _logger.logger.log('target start position:' + startPosition);
            // if startPosition not buffered, let's seek to buffered.start(0)
            if (!startPositionBuffered) {
              startPosition = buffered.start(0);
              _logger.logger.log('target start position not buffered, seek to buffered.start(0) ' + startPosition);
            }
            _logger.logger.log('adjust currentTime from ' + currentTime + ' to ' + startPosition);
            media.currentTime = startPosition;
          }
        } else if (this.immediateSwitch) {
          this.immediateLevelSwitchEnd();
        } else {
          var bufferInfo = _bufferHelper2.default.bufferInfo(media, currentTime, 0),
              expectedPlaying = !(media.paused || // not playing when media is paused
          media.ended || // not playing when media is ended
          media.buffered.length === 0),
              // not playing if nothing buffered
          jumpThreshold = 0.5,
              // tolerance needed as some browsers stalls playback before reaching buffered range end
          playheadMoving = currentTime !== this.lastCurrentTime,
              config = this.config;

          if (playheadMoving) {
            // played moving, but was previously stalled => now not stuck anymore
            if (this.stallReported) {
              _logger.logger.warn('playback not stuck anymore @' + currentTime + ', after ' + Math.round(performance.now() - this.stalled) + 'ms');
              this.stallReported = false;
            }
            this.stalled = undefined;
            this.nudgeRetry = 0;
          } else {
            // playhead not moving
            if (expectedPlaying) {
              // playhead not moving BUT media expected to play
              var tnow = performance.now();
              var hls = this.hls;
              if (!this.stalled) {
                // stall just detected, store current time
                this.stalled = tnow;
                this.stallReported = false;
              } else {
                // playback already stalled, check stalling duration
                // if stalling for more than a given threshold, let's try to recover
                var stalledDuration = tnow - this.stalled;
                var bufferLen = bufferInfo.len;
                var nudgeRetry = this.nudgeRetry || 0;
                // have we reached stall deadline ?
                if (bufferLen <= jumpThreshold && stalledDuration > config.lowBufferWatchdogPeriod * 1000) {
                  // report stalled error once
                  if (!this.stallReported) {
                    this.stallReported = true;
                    _logger.logger.warn('playback stalling in low buffer @' + currentTime);
                    hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.MEDIA_ERROR, details: _errors.ErrorDetails.BUFFER_STALLED_ERROR, fatal: false, buffer: bufferLen });
                  }
                  // if buffer len is below threshold, try to jump to start of next buffer range if close
                  // no buffer available @ currentTime, check if next buffer is close (within a config.maxSeekHole second range)
                  var nextBufferStart = bufferInfo.nextStart,
                      delta = nextBufferStart - currentTime;
                  if (nextBufferStart && delta < config.maxSeekHole && delta > 0) {
                    this.nudgeRetry = ++nudgeRetry;
                    var nudgeOffset = nudgeRetry * config.nudgeOffset;
                    // next buffer is close ! adjust currentTime to nextBufferStart
                    // this will ensure effective video decoding
                    _logger.logger.log('adjust currentTime from ' + media.currentTime + ' to next buffered @ ' + nextBufferStart + ' + nudge ' + nudgeOffset);
                    media.currentTime = nextBufferStart + nudgeOffset;
                    // reset stalled so to rearm watchdog timer
                    this.stalled = undefined;
                    hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.MEDIA_ERROR, details: _errors.ErrorDetails.BUFFER_SEEK_OVER_HOLE, fatal: false, hole: nextBufferStart + nudgeOffset - currentTime });
                  }
                } else if (bufferLen > jumpThreshold && stalledDuration > config.highBufferWatchdogPeriod * 1000) {
                  // report stalled error once
                  if (!this.stallReported) {
                    this.stallReported = true;
                    _logger.logger.warn('playback stalling in high buffer @' + currentTime);
                    hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.MEDIA_ERROR, details: _errors.ErrorDetails.BUFFER_STALLED_ERROR, fatal: false, buffer: bufferLen });
                  }
                  // reset stalled so to rearm watchdog timer
                  this.stalled = undefined;
                  this.nudgeRetry = ++nudgeRetry;
                  if (nudgeRetry < config.nudgeMaxRetry) {
                    var _currentTime = media.currentTime;
                    var targetTime = _currentTime + nudgeRetry * config.nudgeOffset;
                    _logger.logger.log('adjust currentTime from ' + _currentTime + ' to ' + targetTime);
                    // playback stalled in buffered area ... let's nudge currentTime to try to overcome this
                    media.currentTime = targetTime;
                    hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.MEDIA_ERROR, details: _errors.ErrorDetails.BUFFER_NUDGE_ON_STALL, fatal: false });
                  } else {
                    _logger.logger.error('still stuck in high buffer @' + currentTime + ' after ' + config.nudgeMaxRetry + ', raise fatal error');
                    hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.MEDIA_ERROR, details: _errors.ErrorDetails.BUFFER_STALLED_ERROR, fatal: true });
                  }
                }
              }
            }
          }
        }
      }
    }
  }, {
    key: 'onFragLoadEmergencyAborted',
    value: function onFragLoadEmergencyAborted() {
      this.state = State.IDLE;
      // if loadedmetadata is not set, it means that we are emergency switch down on first frag
      // in that case, reset startFragRequested flag
      if (!this.loadedmetadata) {
        this.startFragRequested = false;
        this.nextLoadPosition = this.startPosition;
      }
      this.tick();
    }
  }, {
    key: 'onBufferFlushed',
    value: function onBufferFlushed() {
      /* after successful buffer flushing, filter flushed fragments from bufferedFrags
        use mediaBuffered instead of media (so that we will check against video.buffered ranges in case of alt audio track)
      */
      var media = this.mediaBuffer ? this.mediaBuffer : this.media;
      this._bufferedFrags = this._bufferedFrags.filter(function (frag) {
        return _bufferHelper2.default.isBuffered(media, (frag.startPTS + frag.endPTS) / 2);
      });

      // increase fragment load Index to avoid frag loop loading error after buffer flush
      this.fragLoadIdx += 2 * this.config.fragLoadingLoopThreshold;
      // move to IDLE once flush complete. this should trigger new fragment loading
      this.state = State.IDLE;
      // reset reference to frag
      this.fragPrevious = null;
    }
  }, {
    key: 'swapAudioCodec',
    value: function swapAudioCodec() {
      this.audioCodecSwap = !this.audioCodecSwap;
    }
  }, {
    key: 'computeLivePosition',
    value: function computeLivePosition(sliding, levelDetails) {
      var targetLatency = this.config.liveSyncDuration !== undefined ? this.config.liveSyncDuration : this.config.liveSyncDurationCount * levelDetails.targetduration;
      return sliding + Math.max(0, levelDetails.totalduration - targetLatency);
    }
  }, {
    key: 'state',
    set: function set(nextState) {
      if (this.state !== nextState) {
        var previousState = this.state;
        this._state = nextState;
        _logger.logger.log('main stream:' + previousState + '->' + nextState);
        this.hls.trigger(_events2.default.STREAM_STATE_TRANSITION, { previousState: previousState, nextState: nextState });
      }
    },
    get: function get() {
      return this._state;
    }
  }, {
    key: 'currentLevel',
    get: function get() {
      var media = this.media;
      if (media) {
        var frag = this.getBufferedFrag(media.currentTime);
        if (frag) {
          return frag.level;
        }
      }
      return -1;
    }
  }, {
    key: 'nextBufferedFrag',
    get: function get() {
      var media = this.media;
      if (media) {
        // first get end range of current fragment
        return this.followingBufferedFrag(this.getBufferedFrag(media.currentTime));
      } else {
        return null;
      }
    }
  }, {
    key: 'nextLevel',
    get: function get() {
      var frag = this.nextBufferedFrag;
      if (frag) {
        return frag.level;
      } else {
        return -1;
      }
    }
  }, {
    key: 'liveSyncPosition',
    get: function get() {
      return this._liveSyncPosition;
    },
    set: function set(value) {
      this._liveSyncPosition = value;
    }
  }]);

  return StreamController;
}(_eventHandler2.default);

exports.default = StreamController;

/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events = __webpack_require__(39);

var _events2 = _interopRequireDefault(_events);

var _eventHandler = __webpack_require__(68);

var _eventHandler2 = _interopRequireDefault(_eventHandler);

var _logger = __webpack_require__(31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Subtitle Stream Controller
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */

var SubtitleStreamController = function (_EventHandler) {
  _inherits(SubtitleStreamController, _EventHandler);

  function SubtitleStreamController(hls) {
    _classCallCheck(this, SubtitleStreamController);

    var _this = _possibleConstructorReturn(this, (SubtitleStreamController.__proto__ || Object.getPrototypeOf(SubtitleStreamController)).call(this, hls, _events2.default.ERROR, _events2.default.SUBTITLE_TRACKS_UPDATED, _events2.default.SUBTITLE_TRACK_SWITCH, _events2.default.SUBTITLE_TRACK_LOADED, _events2.default.SUBTITLE_FRAG_PROCESSED));

    _this.config = hls.config;
    _this.vttFragSNsProcessed = {};
    _this.vttFragQueues = undefined;
    _this.currentlyProcessing = null;
    _this.currentTrackId = -1;
    return _this;
  }

  _createClass(SubtitleStreamController, [{
    key: 'destroy',
    value: function destroy() {
      _eventHandler2.default.prototype.destroy.call(this);
    }

    // Remove all queued items and create a new, empty queue for each track.

  }, {
    key: 'clearVttFragQueues',
    value: function clearVttFragQueues() {
      var _this2 = this;

      this.vttFragQueues = {};
      this.tracks.forEach(function (track) {
        _this2.vttFragQueues[track.id] = [];
      });
    }

    // If no frag is being processed and queue isn't empty, initiate processing of next frag in line.

  }, {
    key: 'nextFrag',
    value: function nextFrag() {
      if (this.currentlyProcessing === null && this.currentTrackId > -1 && this.vttFragQueues[this.currentTrackId].length) {
        var frag = this.currentlyProcessing = this.vttFragQueues[this.currentTrackId].shift();
        this.hls.trigger(_events2.default.FRAG_LOADING, { frag: frag });
      }
    }

    // When fragment has finished processing, add sn to list of completed if successful.

  }, {
    key: 'onSubtitleFragProcessed',
    value: function onSubtitleFragProcessed(data) {
      if (data.success) {
        this.vttFragSNsProcessed[data.frag.trackId].push(data.frag.sn);
      }
      this.currentlyProcessing = null;
      this.nextFrag();
    }

    // If something goes wrong, procede to next frag, if we were processing one.

  }, {
    key: 'onError',
    value: function onError(data) {
      var frag = data.frag;
      // don't handle frag error not related to subtitle fragment
      if (frag && frag.type !== 'subtitle') {
        return;
      }
      if (this.currentlyProcessing) {
        this.currentlyProcessing = null;
        this.nextFrag();
      }
    }

    // Got all new subtitle tracks.

  }, {
    key: 'onSubtitleTracksUpdated',
    value: function onSubtitleTracksUpdated(data) {
      var _this3 = this;

      _logger.logger.log('subtitle tracks updated');
      this.tracks = data.subtitleTracks;
      this.clearVttFragQueues();
      this.vttFragSNsProcessed = {};
      this.tracks.forEach(function (track) {
        _this3.vttFragSNsProcessed[track.id] = [];
      });
    }
  }, {
    key: 'onSubtitleTrackSwitch',
    value: function onSubtitleTrackSwitch(data) {
      this.currentTrackId = data.id;
      this.clearVttFragQueues();
    }

    // Got a new set of subtitle fragments.

  }, {
    key: 'onSubtitleTrackLoaded',
    value: function onSubtitleTrackLoaded(data) {
      var processedFragSNs = this.vttFragSNsProcessed[data.id],
          fragQueue = this.vttFragQueues[data.id],
          currentFragSN = !!this.currentlyProcessing ? this.currentlyProcessing.sn : -1;

      var alreadyProcessed = function alreadyProcessed(frag) {
        return processedFragSNs.indexOf(frag.sn) > -1;
      };

      var alreadyInQueue = function alreadyInQueue(frag) {
        return fragQueue.some(function (fragInQueue) {
          return fragInQueue.sn === frag.sn;
        });
      };

      // Add all fragments that haven't been, aren't currently being and aren't waiting to be processed, to queue.
      data.details.fragments.forEach(function (frag) {
        if (!(alreadyProcessed(frag) || frag.sn === currentFragSN || alreadyInQueue(frag))) {
          // Frags don't know their subtitle track ID, so let's just add that...
          frag.trackId = data.id;
          fragQueue.push(frag);
        }
      });

      this.nextFrag();
    }
  }]);

  return SubtitleStreamController;
}(_eventHandler2.default);

exports.default = SubtitleStreamController;

/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events = __webpack_require__(39);

var _events2 = _interopRequireDefault(_events);

var _eventHandler = __webpack_require__(68);

var _eventHandler2 = _interopRequireDefault(_eventHandler);

var _logger = __webpack_require__(31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * audio track controller
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */

function filterSubtitleTracks(textTrackList) {
  var tracks = [];
  for (var i = 0; i < textTrackList.length; i++) {
    if (textTrackList[i].kind === 'subtitles') {
      tracks.push(textTrackList[i]);
    }
  }
  return tracks;
}

var SubtitleTrackController = function (_EventHandler) {
  _inherits(SubtitleTrackController, _EventHandler);

  function SubtitleTrackController(hls) {
    _classCallCheck(this, SubtitleTrackController);

    var _this = _possibleConstructorReturn(this, (SubtitleTrackController.__proto__ || Object.getPrototypeOf(SubtitleTrackController)).call(this, hls, _events2.default.MEDIA_ATTACHED, _events2.default.MEDIA_DETACHING, _events2.default.MANIFEST_LOADING, _events2.default.MANIFEST_LOADED, _events2.default.SUBTITLE_TRACK_LOADED));

    _this.tracks = [];
    _this.trackId = -1;
    _this.media = undefined;
    return _this;
  }

  _createClass(SubtitleTrackController, [{
    key: 'destroy',
    value: function destroy() {
      _eventHandler2.default.prototype.destroy.call(this);
    }

    // Listen for subtitle track change, then extract the current track ID.

  }, {
    key: 'onMediaAttached',
    value: function onMediaAttached(data) {
      var _this2 = this;

      this.media = data.media;
      if (!this.media) {
        return;
      }

      this.media.textTracks.addEventListener('change', function () {
        // Media is undefined when switching streams via loadSource()
        if (!_this2.media) {
          return;
        }

        var trackId = -1;
        var tracks = filterSubtitleTracks(_this2.media.textTracks);
        for (var id = 0; id < tracks.length; id++) {
          if (tracks[id].mode === 'showing') {
            trackId = id;
          }
        }
        // Setting current subtitleTrack will invoke code.
        _this2.subtitleTrack = trackId;
      });
    }
  }, {
    key: 'onMediaDetaching',
    value: function onMediaDetaching() {
      // TODO: Remove event listeners.
      this.media = undefined;
    }

    // Reset subtitle tracks on manifest loading

  }, {
    key: 'onManifestLoading',
    value: function onManifestLoading() {
      this.tracks = [];
      this.trackId = -1;
    }

    // Fired whenever a new manifest is loaded.

  }, {
    key: 'onManifestLoaded',
    value: function onManifestLoaded(data) {
      var _this3 = this;

      var tracks = data.subtitles || [];
      var defaultFound = false;
      this.tracks = tracks;
      this.trackId = -1;
      this.hls.trigger(_events2.default.SUBTITLE_TRACKS_UPDATED, { subtitleTracks: tracks });

      // loop through available subtitle tracks and autoselect default if needed
      // TODO: improve selection logic to handle forced, etc
      tracks.forEach(function (track) {
        if (track.default) {
          _this3.subtitleTrack = track.id;
          defaultFound = true;
        }
      });
    }

    // Trigger subtitle track playlist reload.

  }, {
    key: 'onTick',
    value: function onTick() {
      var trackId = this.trackId;
      var subtitleTrack = this.tracks[trackId];
      if (!subtitleTrack) {
        return;
      }

      var details = subtitleTrack.details;
      // check if we need to load playlist for this subtitle Track
      if (details === undefined || details.live === true) {
        // track not retrieved yet, or live playlist we need to (re)load it
        _logger.logger.log('(re)loading playlist for subtitle track ' + trackId);
        this.hls.trigger(_events2.default.SUBTITLE_TRACK_LOADING, { url: subtitleTrack.url, id: trackId });
      }
    }
  }, {
    key: 'onSubtitleTrackLoaded',
    value: function onSubtitleTrackLoaded(data) {
      var _this4 = this;

      if (data.id < this.tracks.length) {
        _logger.logger.log('subtitle track ' + data.id + ' loaded');
        this.tracks[data.id].details = data.details;
        // check if current playlist is a live playlist
        if (data.details.live && !this.timer) {
          // if live playlist we will have to reload it periodically
          // set reload period to playlist target duration
          this.timer = setInterval(function () {
            _this4.onTick();
          }, 1000 * data.details.targetduration, this);
        }
        if (!data.details.live && this.timer) {
          // playlist is not live and timer is armed : stopping it
          clearInterval(this.timer);
          this.timer = null;
        }
      }
    }

    /** get alternate subtitle tracks list from playlist **/

  }, {
    key: 'setSubtitleTrackInternal',
    value: function setSubtitleTrackInternal(newId) {
      // check if level idx is valid
      if (newId >= 0 && newId < this.tracks.length) {
        // stopping live reloading timer if any
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
        this.trackId = newId;
        _logger.logger.log('switching to subtitle track ' + newId);
        var subtitleTrack = this.tracks[newId];
        this.hls.trigger(_events2.default.SUBTITLE_TRACK_SWITCH, { id: newId });
        // check if we need to load playlist for this subtitle Track
        var details = subtitleTrack.details;
        if (details === undefined || details.live === true) {
          // track not retrieved yet, or live playlist we need to (re)load it
          _logger.logger.log('(re)loading playlist for subtitle track ' + newId);
          this.hls.trigger(_events2.default.SUBTITLE_TRACK_LOADING, { url: subtitleTrack.url, id: newId });
        }
      }
    }
  }, {
    key: 'subtitleTracks',
    get: function get() {
      return this.tracks;
    }

    /** get index of the selected subtitle track (index in subtitle track lists) **/

  }, {
    key: 'subtitleTrack',
    get: function get() {
      return this.trackId;
    }

    /** select a subtitle track, based on its index in subtitle track lists**/
    ,
    set: function set(subtitleTrackId) {
      if (this.trackId !== subtitleTrackId) {
        // || this.tracks[subtitleTrackId].details === undefined) {
        this.setSubtitleTrackInternal(subtitleTrackId);
      }
    }
  }]);

  return SubtitleTrackController;
}(_eventHandler2.default);

exports.default = SubtitleTrackController;

/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events = __webpack_require__(39);

var _events2 = _interopRequireDefault(_events);

var _eventHandler = __webpack_require__(68);

var _eventHandler2 = _interopRequireDefault(_eventHandler);

var _cea608Parser = __webpack_require__(1471);

var _cea608Parser2 = _interopRequireDefault(_cea608Parser);

var _webvttParser = __webpack_require__(1476);

var _webvttParser2 = _interopRequireDefault(_webvttParser);

var _logger = __webpack_require__(31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Timeline Controller
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */

function clearCurrentCues(track) {
  if (track && track.cues) {
    while (track.cues.length > 0) {
      track.removeCue(track.cues[0]);
    }
  }
}

function reuseVttTextTrack(inUseTrack, manifestTrack) {
  return inUseTrack && inUseTrack.label === manifestTrack.name && !(inUseTrack.textTrack1 || inUseTrack.textTrack2);
}

function intersection(x1, x2, y1, y2) {
  return Math.min(x2, y2) - Math.max(x1, y1);
}

var TimelineController = function (_EventHandler) {
  _inherits(TimelineController, _EventHandler);

  function TimelineController(hls) {
    _classCallCheck(this, TimelineController);

    var _this = _possibleConstructorReturn(this, (TimelineController.__proto__ || Object.getPrototypeOf(TimelineController)).call(this, hls, _events2.default.MEDIA_ATTACHING, _events2.default.MEDIA_DETACHING, _events2.default.FRAG_PARSING_USERDATA, _events2.default.MANIFEST_LOADING, _events2.default.MANIFEST_LOADED, _events2.default.FRAG_LOADED, _events2.default.LEVEL_SWITCHING, _events2.default.INIT_PTS_FOUND));

    _this.hls = hls;
    _this.config = hls.config;
    _this.enabled = true;
    _this.Cues = hls.config.cueHandler;
    _this.textTracks = [];
    _this.tracks = [];
    _this.unparsedVttFrags = [];
    _this.initPTS = undefined;
    _this.cueRanges = [];

    if (_this.config.enableCEA708Captions) {
      var self = _this;
      var sendAddTrackEvent = function sendAddTrackEvent(track, media) {
        var e = null;
        try {
          e = new window.Event('addtrack');
        } catch (err) {
          //for IE11
          e = document.createEvent('Event');
          e.initEvent('addtrack', false, false);
        }
        e.track = track;
        media.dispatchEvent(e);
      };

      var channel1 = {
        'newCue': function newCue(startTime, endTime, screen) {
          if (!self.textTrack1) {
            //Enable reuse of existing text track.
            var existingTrack1 = self.getExistingTrack('1');
            if (!existingTrack1) {
              var textTrack1 = self.createTextTrack('captions', self.config.captionsTextTrack1Label, self.config.captionsTextTrack1LanguageCode);
              if (textTrack1) {
                textTrack1.textTrack1 = true;
                self.textTrack1 = textTrack1;
              }
            } else {
              self.textTrack1 = existingTrack1;
              clearCurrentCues(self.textTrack1);

              sendAddTrackEvent(self.textTrack1, self.media);
            }
          }
          self.addCues('textTrack1', startTime, endTime, screen);
        }
      };

      var channel2 = {
        'newCue': function newCue(startTime, endTime, screen) {
          if (!self.textTrack2) {
            //Enable reuse of existing text track.
            var existingTrack2 = self.getExistingTrack('2');
            if (!existingTrack2) {
              var textTrack2 = self.createTextTrack('captions', self.config.captionsTextTrack2Label, self.config.captionsTextTrack1LanguageCode);
              if (textTrack2) {
                textTrack2.textTrack2 = true;
                self.textTrack2 = textTrack2;
              }
            } else {
              self.textTrack2 = existingTrack2;
              clearCurrentCues(self.textTrack2);

              sendAddTrackEvent(self.textTrack2, self.media);
            }
          }
          self.addCues('textTrack2', startTime, endTime, screen);
        }
      };

      _this.cea608Parser = new _cea608Parser2.default(0, channel1, channel2);
    }
    return _this;
  }

  _createClass(TimelineController, [{
    key: 'addCues',
    value: function addCues(channel, startTime, endTime, screen) {
      // skip cues which overlap more than 50% with previously parsed time ranges
      var ranges = this.cueRanges;
      var merged = false;
      for (var i = ranges.length; i--;) {
        var cueRange = ranges[i];
        var overlap = intersection(cueRange[0], cueRange[1], startTime, endTime);
        if (overlap >= 0) {
          cueRange[0] = Math.min(cueRange[0], startTime);
          cueRange[1] = Math.max(cueRange[1], endTime);
          merged = true;
          if (overlap / (endTime - startTime) > 0.5) {
            return;
          }
        }
      }
      if (!merged) {
        ranges.push([startTime, endTime]);
      }
      this.Cues.newCue(this[channel], startTime, endTime, screen);
    }

    // Triggered when an initial PTS is found; used for synchronisation of WebVTT.

  }, {
    key: 'onInitPtsFound',
    value: function onInitPtsFound(data) {
      var _this2 = this;

      if (typeof this.initPTS === 'undefined') {
        this.initPTS = data.initPTS;
      }

      // Due to asynchrony, initial PTS may arrive later than the first VTT fragments are loaded.
      // Parse any unparsed fragments upon receiving the initial PTS.
      if (this.unparsedVttFrags.length) {
        this.unparsedVttFrags.forEach(function (frag) {
          _this2.onFragLoaded(frag);
        });
        this.unparsedVttFrags = [];
      }
    }
  }, {
    key: 'getExistingTrack',
    value: function getExistingTrack(channelNumber) {
      var media = this.media;
      if (media) {
        for (var i = 0; i < media.textTracks.length; i++) {
          var textTrack = media.textTracks[i];
          var propName = 'textTrack' + channelNumber;
          if (textTrack[propName] === true) {
            return textTrack;
          }
        }
      }
      return null;
    }
  }, {
    key: 'createTextTrack',
    value: function createTextTrack(kind, label, lang) {
      var media = this.media;
      if (media) {
        return media.addTextTrack(kind, label, lang);
      }
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      _eventHandler2.default.prototype.destroy.call(this);
    }
  }, {
    key: 'onMediaAttaching',
    value: function onMediaAttaching(data) {
      this.media = data.media;
    }
  }, {
    key: 'onMediaDetaching',
    value: function onMediaDetaching() {
      clearCurrentCues(this.textTrack1);
      clearCurrentCues(this.textTrack2);
    }
  }, {
    key: 'onManifestLoading',
    value: function onManifestLoading() {
      this.lastSn = -1; // Detect discontiguity in fragment parsing
      this.prevCC = -1;
      this.vttCCs = { ccOffset: 0, presentationOffset: 0 }; // Detect discontinuity in subtitle manifests

      // clear outdated subtitles
      var media = this.media;
      if (media) {
        var textTracks = media.textTracks;
        if (textTracks) {
          for (var i = 0; i < textTracks.length; i++) {
            clearCurrentCues(textTracks[i]);
          }
        }
      }
    }
  }, {
    key: 'onManifestLoaded',
    value: function onManifestLoaded(data) {
      var _this3 = this;

      this.textTracks = [];
      this.unparsedVttFrags = this.unparsedVttFrags || [];
      this.initPTS = undefined;
      this.cueRanges = [];

      if (this.config.enableWebVTT) {
        this.tracks = data.subtitles || [];
        var inUseTracks = this.media ? this.media.textTracks : [];

        this.tracks.forEach(function (track, index) {
          var textTrack = void 0;
          if (index < inUseTracks.length) {
            var inUseTrack = inUseTracks[index];
            // Reuse tracks with the same label, but do not reuse 608/708 tracks
            if (reuseVttTextTrack(inUseTrack, track)) {
              textTrack = inUseTrack;
            }
          }
          if (!textTrack) {
            textTrack = _this3.createTextTrack('subtitles', track.name, track.lang);
          }
          textTrack.mode = track.default ? 'showing' : 'hidden';
          _this3.textTracks.push(textTrack);
        });
      }
    }
  }, {
    key: 'onLevelSwitching',
    value: function onLevelSwitching() {
      this.enabled = this.hls.currentLevel.closedCaptions !== 'NONE';
    }
  }, {
    key: 'onFragLoaded',
    value: function onFragLoaded(data) {
      var frag = data.frag,
          payload = data.payload;
      if (frag.type === 'main') {
        var sn = frag.sn;
        // if this frag isn't contiguous, clear the parser so cues with bad start/end times aren't added to the textTrack
        if (sn !== this.lastSn + 1) {
          var cea608Parser = this.cea608Parser;
          if (cea608Parser) {
            cea608Parser.reset();
          }
        }
        this.lastSn = sn;
      }
      // If fragment is subtitle type, parse as WebVTT.
      else if (frag.type === 'subtitle') {
          if (payload.byteLength) {
            // We need an initial synchronisation PTS. Store fragments as long as none has arrived.
            if (typeof this.initPTS === 'undefined') {
              this.unparsedVttFrags.push(data);
              return;
            }
            var vttCCs = this.vttCCs;
            if (!vttCCs[frag.cc]) {
              vttCCs[frag.cc] = { start: frag.start, prevCC: this.prevCC, new: true };
              this.prevCC = frag.cc;
            }
            var textTracks = this.textTracks,
                hls = this.hls;

            // Parse the WebVTT file contents.
            _webvttParser2.default.parse(payload, this.initPTS, vttCCs, frag.cc, function (cues) {
              var currentTrack = textTracks[frag.trackId];
              // Add cues and trigger event with success true.
              cues.forEach(function (cue) {
                // Sometimes there are cue overlaps on segmented vtts so the same
                // cue can appear more than once in different vtt files.
                // This avoid showing duplicated cues with same timecode and text.
                if (!currentTrack.cues.getCueById(cue.id)) {
                  currentTrack.addCue(cue);
                }
              });
              hls.trigger(_events2.default.SUBTITLE_FRAG_PROCESSED, { success: true, frag: frag });
            }, function (e) {
              // Something went wrong while parsing. Trigger event with success false.
              _logger.logger.log('Failed to parse VTT cue: ' + e);
              hls.trigger(_events2.default.SUBTITLE_FRAG_PROCESSED, { success: false, frag: frag });
            });
          } else {
            // In case there is no payload, finish unsuccessfully.
            this.hls.trigger(_events2.default.SUBTITLE_FRAG_PROCESSED, { success: false, frag: frag });
          }
        }
    }
  }, {
    key: 'onFragParsingUserdata',
    value: function onFragParsingUserdata(data) {
      // push all of the CEA-708 messages into the interpreter
      // immediately. It will create the proper timestamps based on our PTS value
      if (this.enabled && this.config.enableCEA708Captions) {
        for (var i = 0; i < data.samples.length; i++) {
          var ccdatas = this.extractCea608Data(data.samples[i].bytes);
          this.cea608Parser.addData(data.samples[i].pts, ccdatas);
        }
      }
    }
  }, {
    key: 'extractCea608Data',
    value: function extractCea608Data(byteArray) {
      var count = byteArray[0] & 31;
      var position = 2;
      var tmpByte, ccbyte1, ccbyte2, ccValid, ccType;
      var actualCCBytes = [];

      for (var j = 0; j < count; j++) {
        tmpByte = byteArray[position++];
        ccbyte1 = 0x7F & byteArray[position++];
        ccbyte2 = 0x7F & byteArray[position++];
        ccValid = (4 & tmpByte) !== 0;
        ccType = 3 & tmpByte;

        if (ccbyte1 === 0 && ccbyte2 === 0) {
          continue;
        }

        if (ccValid) {
          if (ccType === 0) // || ccType === 1
            {
              actualCCBytes.push(ccbyte1);
              actualCCBytes.push(ccbyte2);
            }
        }
      }
      return actualCCBytes;
    }
  }]);

  return TimelineController;
}(_eventHandler2.default);

exports.default = TimelineController;

/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AESCrypto = function () {
  function AESCrypto(subtle, iv) {
    _classCallCheck(this, AESCrypto);

    this.subtle = subtle;
    this.aesIV = iv;
  }

  _createClass(AESCrypto, [{
    key: 'decrypt',
    value: function decrypt(data, key) {
      return this.subtle.decrypt({ name: 'AES-CBC', iv: this.aesIV }, key, data);
    }
  }]);

  return AESCrypto;
}();

exports.default = AESCrypto;

/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AESDecryptor = function () {
  function AESDecryptor() {
    _classCallCheck(this, AESDecryptor);

    // Static after running initTable
    this.rcon = [0x0, 0x1, 0x2, 0x4, 0x8, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];
    this.subMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)];
    this.invSubMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)];
    this.sBox = new Uint32Array(256);
    this.invSBox = new Uint32Array(256);

    // Changes during runtime
    this.key = new Uint32Array(0);

    this.initTable();
  }

  // Using view.getUint32() also swaps the byte order.


  _createClass(AESDecryptor, [{
    key: 'uint8ArrayToUint32Array_',
    value: function uint8ArrayToUint32Array_(arrayBuffer) {
      var view = new DataView(arrayBuffer);
      var newArray = new Uint32Array(4);
      for (var i = 0; i < 4; i++) {
        newArray[i] = view.getUint32(i * 4);
      }
      return newArray;
    }
  }, {
    key: 'initTable',
    value: function initTable() {
      var sBox = this.sBox;
      var invSBox = this.invSBox;
      var subMix = this.subMix;
      var subMix0 = subMix[0];
      var subMix1 = subMix[1];
      var subMix2 = subMix[2];
      var subMix3 = subMix[3];
      var invSubMix = this.invSubMix;
      var invSubMix0 = invSubMix[0];
      var invSubMix1 = invSubMix[1];
      var invSubMix2 = invSubMix[2];
      var invSubMix3 = invSubMix[3];

      var d = new Uint32Array(256);
      var x = 0;
      var xi = 0;
      var i = 0;
      for (i = 0; i < 256; i++) {
        if (i < 128) {
          d[i] = i << 1;
        } else {
          d[i] = i << 1 ^ 0x11b;
        }
      }

      for (i = 0; i < 256; i++) {
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        sBox[x] = sx;
        invSBox[sx] = x;

        // Compute multiplication
        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4];

        // Compute sub/invSub bytes, mix columns tables
        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        subMix0[x] = t << 24 | t >>> 8;
        subMix1[x] = t << 16 | t >>> 16;
        subMix2[x] = t << 8 | t >>> 24;
        subMix3[x] = t;

        // Compute inv sub bytes, inv mix columns tables
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        invSubMix0[sx] = t << 24 | t >>> 8;
        invSubMix1[sx] = t << 16 | t >>> 16;
        invSubMix2[sx] = t << 8 | t >>> 24;
        invSubMix3[sx] = t;

        // Compute next counter
        if (!x) {
          x = xi = 1;
        } else {
          x = x2 ^ d[d[d[x8 ^ x2]]];
          xi ^= d[d[xi]];
        }
      }
    }
  }, {
    key: 'expandKey',
    value: function expandKey(keyBuffer) {
      // convert keyBuffer to Uint32Array
      var key = this.uint8ArrayToUint32Array_(keyBuffer);
      var sameKey = true;
      var offset = 0;

      while (offset < key.length && sameKey) {
        sameKey = key[offset] === this.key[offset];
        offset++;
      }

      if (sameKey) {
        return;
      }

      this.key = key;
      var keySize = this.keySize = key.length;

      if (keySize !== 4 && keySize !== 6 && keySize !== 8) {
        throw new Error('Invalid aes key size=' + keySize);
      }

      var ksRows = this.ksRows = (keySize + 6 + 1) * 4;
      var ksRow = void 0;
      var invKsRow = void 0;

      var keySchedule = this.keySchedule = new Uint32Array(ksRows);
      var invKeySchedule = this.invKeySchedule = new Uint32Array(ksRows);
      var sbox = this.sBox;
      var rcon = this.rcon;

      var invSubMix = this.invSubMix;
      var invSubMix0 = invSubMix[0];
      var invSubMix1 = invSubMix[1];
      var invSubMix2 = invSubMix[2];
      var invSubMix3 = invSubMix[3];

      var prev = void 0;
      var t = void 0;

      for (ksRow = 0; ksRow < ksRows; ksRow++) {
        if (ksRow < keySize) {
          prev = keySchedule[ksRow] = key[ksRow];
          continue;
        }
        t = prev;

        if (ksRow % keySize === 0) {
          // Rot word
          t = t << 8 | t >>> 24;

          // Sub word
          t = sbox[t >>> 24] << 24 | sbox[t >>> 16 & 0xff] << 16 | sbox[t >>> 8 & 0xff] << 8 | sbox[t & 0xff];

          // Mix Rcon
          t ^= rcon[ksRow / keySize | 0] << 24;
        } else if (keySize > 6 && ksRow % keySize === 4) {
          // Sub word
          t = sbox[t >>> 24] << 24 | sbox[t >>> 16 & 0xff] << 16 | sbox[t >>> 8 & 0xff] << 8 | sbox[t & 0xff];
        }

        keySchedule[ksRow] = prev = (keySchedule[ksRow - keySize] ^ t) >>> 0;
      }

      for (invKsRow = 0; invKsRow < ksRows; invKsRow++) {
        ksRow = ksRows - invKsRow;
        if (invKsRow & 3) {
          t = keySchedule[ksRow];
        } else {
          t = keySchedule[ksRow - 4];
        }

        if (invKsRow < 4 || ksRow <= 4) {
          invKeySchedule[invKsRow] = t;
        } else {
          invKeySchedule[invKsRow] = invSubMix0[sbox[t >>> 24]] ^ invSubMix1[sbox[t >>> 16 & 0xff]] ^ invSubMix2[sbox[t >>> 8 & 0xff]] ^ invSubMix3[sbox[t & 0xff]];
        }

        invKeySchedule[invKsRow] = invKeySchedule[invKsRow] >>> 0;
      }
    }

    // Adding this as a method greatly improves performance.

  }, {
    key: 'networkToHostOrderSwap',
    value: function networkToHostOrderSwap(word) {
      return word << 24 | (word & 0xff00) << 8 | (word & 0xff0000) >> 8 | word >>> 24;
    }
  }, {
    key: 'decrypt',
    value: function decrypt(inputArrayBuffer, offset, aesIV) {
      var nRounds = this.keySize + 6;
      var invKeySchedule = this.invKeySchedule;
      var invSBOX = this.invSBox;

      var invSubMix = this.invSubMix;
      var invSubMix0 = invSubMix[0];
      var invSubMix1 = invSubMix[1];
      var invSubMix2 = invSubMix[2];
      var invSubMix3 = invSubMix[3];

      var initVector = this.uint8ArrayToUint32Array_(aesIV);
      var initVector0 = initVector[0];
      var initVector1 = initVector[1];
      var initVector2 = initVector[2];
      var initVector3 = initVector[3];

      var inputInt32 = new Int32Array(inputArrayBuffer);
      var outputInt32 = new Int32Array(inputInt32.length);

      var t0 = void 0,
          t1 = void 0,
          t2 = void 0,
          t3 = void 0;
      var s0 = void 0,
          s1 = void 0,
          s2 = void 0,
          s3 = void 0;
      var inputWords0 = void 0,
          inputWords1 = void 0,
          inputWords2 = void 0,
          inputWords3 = void 0;

      var ksRow, i;
      var swapWord = this.networkToHostOrderSwap;

      while (offset < inputInt32.length) {
        inputWords0 = swapWord(inputInt32[offset]);
        inputWords1 = swapWord(inputInt32[offset + 1]);
        inputWords2 = swapWord(inputInt32[offset + 2]);
        inputWords3 = swapWord(inputInt32[offset + 3]);

        s0 = inputWords0 ^ invKeySchedule[0];
        s1 = inputWords3 ^ invKeySchedule[1];
        s2 = inputWords2 ^ invKeySchedule[2];
        s3 = inputWords1 ^ invKeySchedule[3];

        ksRow = 4;

        // Iterate through the rounds of decryption
        for (i = 1; i < nRounds; i++) {
          t0 = invSubMix0[s0 >>> 24] ^ invSubMix1[s1 >> 16 & 0xff] ^ invSubMix2[s2 >> 8 & 0xff] ^ invSubMix3[s3 & 0xff] ^ invKeySchedule[ksRow];
          t1 = invSubMix0[s1 >>> 24] ^ invSubMix1[s2 >> 16 & 0xff] ^ invSubMix2[s3 >> 8 & 0xff] ^ invSubMix3[s0 & 0xff] ^ invKeySchedule[ksRow + 1];
          t2 = invSubMix0[s2 >>> 24] ^ invSubMix1[s3 >> 16 & 0xff] ^ invSubMix2[s0 >> 8 & 0xff] ^ invSubMix3[s1 & 0xff] ^ invKeySchedule[ksRow + 2];
          t3 = invSubMix0[s3 >>> 24] ^ invSubMix1[s0 >> 16 & 0xff] ^ invSubMix2[s1 >> 8 & 0xff] ^ invSubMix3[s2 & 0xff] ^ invKeySchedule[ksRow + 3];
          // Update state
          s0 = t0;
          s1 = t1;
          s2 = t2;
          s3 = t3;

          ksRow = ksRow + 4;
        }

        // Shift rows, sub bytes, add round key
        t0 = invSBOX[s0 >>> 24] << 24 ^ invSBOX[s1 >> 16 & 0xff] << 16 ^ invSBOX[s2 >> 8 & 0xff] << 8 ^ invSBOX[s3 & 0xff] ^ invKeySchedule[ksRow];
        t1 = invSBOX[s1 >>> 24] << 24 ^ invSBOX[s2 >> 16 & 0xff] << 16 ^ invSBOX[s3 >> 8 & 0xff] << 8 ^ invSBOX[s0 & 0xff] ^ invKeySchedule[ksRow + 1];
        t2 = invSBOX[s2 >>> 24] << 24 ^ invSBOX[s3 >> 16 & 0xff] << 16 ^ invSBOX[s0 >> 8 & 0xff] << 8 ^ invSBOX[s1 & 0xff] ^ invKeySchedule[ksRow + 2];
        t3 = invSBOX[s3 >>> 24] << 24 ^ invSBOX[s0 >> 16 & 0xff] << 16 ^ invSBOX[s1 >> 8 & 0xff] << 8 ^ invSBOX[s2 & 0xff] ^ invKeySchedule[ksRow + 3];
        ksRow = ksRow + 3;

        // Write
        outputInt32[offset] = swapWord(t0 ^ initVector0);
        outputInt32[offset + 1] = swapWord(t3 ^ initVector1);
        outputInt32[offset + 2] = swapWord(t2 ^ initVector2);
        outputInt32[offset + 3] = swapWord(t1 ^ initVector3);

        // reset initVector to last 4 unsigned int
        initVector0 = inputWords0;
        initVector1 = inputWords1;
        initVector2 = inputWords2;
        initVector3 = inputWords3;

        offset = offset + 4;
      }

      return outputInt32.buffer;
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.key = undefined;
      this.keySize = undefined;
      this.ksRows = undefined;

      this.sBox = undefined;
      this.invSBox = undefined;
      this.subMix = undefined;
      this.invSubMix = undefined;
      this.keySchedule = undefined;
      this.invKeySchedule = undefined;

      this.rcon = undefined;
    }
  }]);

  return AESDecryptor;
}();

exports.default = AESDecryptor;

/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FastAESKey = function () {
  function FastAESKey(subtle, key) {
    _classCallCheck(this, FastAESKey);

    this.subtle = subtle;
    this.key = key;
  }

  _createClass(FastAESKey, [{
    key: 'expandKey',
    value: function expandKey() {
      return this.subtle.importKey('raw', this.key, { name: 'AES-CBC' }, false, ['encrypt', 'decrypt']);
    }
  }]);

  return FastAESKey;
}();

exports.default = FastAESKey;

/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * AAC demuxer
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */


var _adts = __webpack_require__(602);

var _adts2 = _interopRequireDefault(_adts);

var _logger = __webpack_require__(31);

var _id = __webpack_require__(605);

var _id2 = _interopRequireDefault(_id);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AACDemuxer = function () {
  function AACDemuxer(observer, remuxer, config) {
    _classCallCheck(this, AACDemuxer);

    this.observer = observer;
    this.config = config;
    this.remuxer = remuxer;
  }

  _createClass(AACDemuxer, [{
    key: 'resetInitSegment',
    value: function resetInitSegment(initSegment, audioCodec, videoCodec, duration) {
      this._audioTrack = { container: 'audio/adts', type: 'audio', id: -1, sequenceNumber: 0, isAAC: true, samples: [], len: 0, manifestCodec: audioCodec, duration: duration, inputTimeScale: 90000 };
    }
  }, {
    key: 'resetTimeStamp',
    value: function resetTimeStamp() {}
  }, {
    key: 'append',


    // feed incoming data to the front of the parsing pipeline
    value: function append(data, timeOffset, contiguous, accurateTimeOffset) {
      var track,
          id3 = new _id2.default(data),
          pts = 90 * id3.timeStamp,
          config,
          frameLength,
          frameDuration,
          frameIndex,
          offset,
          headerLength,
          stamp,
          length,
          aacSample;

      track = this._audioTrack;

      // Look for ADTS header
      for (offset = id3.length, length = data.length; offset < length - 1; offset++) {
        if (data[offset] === 0xff && (data[offset + 1] & 0xf6) === 0xf0) {
          break;
        }
      }

      if (!track.samplerate) {
        config = _adts2.default.getAudioConfig(this.observer, data, offset, track.manifestCodec);
        track.config = config.config;
        track.samplerate = config.samplerate;
        track.channelCount = config.channelCount;
        track.codec = config.codec;
        _logger.logger.log('parsed codec:' + track.codec + ',rate:' + config.samplerate + ',nb channel:' + config.channelCount);
      }
      frameIndex = 0;
      frameDuration = 1024 * 90000 / track.samplerate;
      while (offset + 5 < length) {
        // The protection skip bit tells us if we have 2 bytes of CRC data at the end of the ADTS header
        headerLength = !!(data[offset + 1] & 0x01) ? 7 : 9;
        // retrieve frame size
        frameLength = (data[offset + 3] & 0x03) << 11 | data[offset + 4] << 3 | (data[offset + 5] & 0xE0) >>> 5;
        frameLength -= headerLength;
        //stamp = pes.pts;

        if (frameLength > 0 && offset + headerLength + frameLength <= length) {
          stamp = pts + frameIndex * frameDuration;
          //logger.log(`AAC frame, offset/length/total/pts:${offset+headerLength}/${frameLength}/${data.byteLength}/${(stamp/90).toFixed(0)}`);
          aacSample = { unit: data.subarray(offset + headerLength, offset + headerLength + frameLength), pts: stamp, dts: stamp };
          track.samples.push(aacSample);
          track.len += frameLength;
          offset += frameLength + headerLength;
          frameIndex++;
          // look for ADTS header (0xFFFx)
          for (; offset < length - 1; offset++) {
            if (data[offset] === 0xff && (data[offset + 1] & 0xf6) === 0xf0) {
              break;
            }
          }
        } else {
          break;
        }
      }
      this.remuxer.remux(track, { samples: [] }, { samples: [{ pts: pts, dts: pts, data: id3.payload }], inputTimeScale: 90000 }, { samples: [] }, timeOffset, contiguous, accurateTimeOffset);
    }
  }, {
    key: 'destroy',
    value: function destroy() {}
  }], [{
    key: 'probe',
    value: function probe(data) {
      // check if data contains ID3 timestamp and ADTS sync word
      var id3 = new _id2.default(data),
          offset,
          length;
      if (id3.hasTimeStamp) {
        // Look for ADTS header | 1111 1111 | 1111 X00X | where X can be either 0 or 1
        // Layer bits (position 14 and 15) in header should be always 0 for ADTS
        // More info https://wiki.multimedia.cx/index.php?title=ADTS
        for (offset = id3.length, length = Math.min(data.length - 1, offset + 100); offset < length; offset++) {
          if (data[offset] === 0xff && (data[offset + 1] & 0xf6) === 0xf0) {
            //logger.log('ADTS sync word found !');
            return true;
          }
        }
      }
      return false;
    }
  }]);

  return AACDemuxer;
}();

exports.default = AACDemuxer;

/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _demuxerInline = __webpack_require__(603);

var _demuxerInline2 = _interopRequireDefault(_demuxerInline);

var _events = __webpack_require__(39);

var _events2 = _interopRequireDefault(_events);

var _logger = __webpack_require__(31);

var _events3 = __webpack_require__(410);

var _events4 = _interopRequireDefault(_events3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* demuxer web worker.
 *  - listen to worker message, and trigger DemuxerInline upon reception of Fragments.
 *  - provides MP4 Boxes back to main thread using [transferable objects](https://developers.google.com/web/updates/2011/12/Transferable-Objects-Lightning-Fast) in order to minimize message passing overhead.
 */

var DemuxerWorker = function DemuxerWorker(self) {
  // observer setup
  var observer = new _events4.default();
  observer.trigger = function trigger(event) {
    for (var _len = arguments.length, data = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      data[_key - 1] = arguments[_key];
    }

    observer.emit.apply(observer, [event, event].concat(data));
  };

  observer.off = function off(event) {
    for (var _len2 = arguments.length, data = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      data[_key2 - 1] = arguments[_key2];
    }

    observer.removeListener.apply(observer, [event].concat(data));
  };

  var forwardMessage = function forwardMessage(ev, data) {
    self.postMessage({ event: ev, data: data });
  };

  self.addEventListener('message', function (ev) {
    var data = ev.data;
    //console.log('demuxer cmd:' + data.cmd);
    switch (data.cmd) {
      case 'init':
        var config = JSON.parse(data.config);
        self.demuxer = new _demuxerInline2.default(observer, data.typeSupported, config, data.vendor);
        try {
          (0, _logger.enableLogs)(config.debug === true);
        } catch (err) {
          console.warn('demuxerWorker: unable to enable logs');
        }
        // signal end of worker init
        forwardMessage('init', null);
        break;
      case 'demux':
        self.demuxer.push(data.data, data.decryptdata, data.initSegment, data.audioCodec, data.videoCodec, data.timeOffset, data.discontinuity, data.trackSwitch, data.contiguous, data.duration, data.accurateTimeOffset, data.defaultInitPTS);
        break;
      default:
        break;
    }
  });

  // forward events to main thread
  observer.on(_events2.default.FRAG_DECRYPTED, forwardMessage);
  observer.on(_events2.default.FRAG_PARSING_INIT_SEGMENT, forwardMessage);
  observer.on(_events2.default.FRAG_PARSED, forwardMessage);
  observer.on(_events2.default.ERROR, forwardMessage);
  observer.on(_events2.default.FRAG_PARSING_METADATA, forwardMessage);
  observer.on(_events2.default.FRAG_PARSING_USERDATA, forwardMessage);
  observer.on(_events2.default.INIT_PTS_FOUND, forwardMessage);

  // special case for FRAG_PARSING_DATA: pass data1/data2 as transferable object (no copy)
  observer.on(_events2.default.FRAG_PARSING_DATA, function (ev, data) {
    var transferable = [];
    var message = { event: ev, data: data };
    if (data.data1) {
      message.data1 = data.data1.buffer;
      transferable.push(data.data1.buffer);
      delete data.data1;
    }
    if (data.data2) {
      message.data2 = data.data2.buffer;
      transferable.push(data.data2.buffer);
      delete data.data2;
    }
    self.postMessage(message, transferable);
  });
};

exports.default = DemuxerWorker;

/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Parser for exponential Golomb codes, a variable-bitwidth number encoding scheme used by h264.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     */

var _logger = __webpack_require__(31);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ExpGolomb = function () {
  function ExpGolomb(data) {
    _classCallCheck(this, ExpGolomb);

    this.data = data;
    // the number of bytes left to examine in this.data
    this.bytesAvailable = data.byteLength;
    // the current word being examined
    this.word = 0; // :uint
    // the number of bits left to examine in the current word
    this.bitsAvailable = 0; // :uint
  }

  // ():void


  _createClass(ExpGolomb, [{
    key: 'loadWord',
    value: function loadWord() {
      var data = this.data,
          bytesAvailable = this.bytesAvailable,
          position = data.byteLength - bytesAvailable,
          workingBytes = new Uint8Array(4),
          availableBytes = Math.min(4, bytesAvailable);
      if (availableBytes === 0) {
        throw new Error('no bytes available');
      }
      workingBytes.set(data.subarray(position, position + availableBytes));
      this.word = new DataView(workingBytes.buffer).getUint32(0);
      // track the amount of this.data that has been processed
      this.bitsAvailable = availableBytes * 8;
      this.bytesAvailable -= availableBytes;
    }

    // (count:int):void

  }, {
    key: 'skipBits',
    value: function skipBits(count) {
      var skipBytes; // :int
      if (this.bitsAvailable > count) {
        this.word <<= count;
        this.bitsAvailable -= count;
      } else {
        count -= this.bitsAvailable;
        skipBytes = count >> 3;
        count -= skipBytes >> 3;
        this.bytesAvailable -= skipBytes;
        this.loadWord();
        this.word <<= count;
        this.bitsAvailable -= count;
      }
    }

    // (size:int):uint

  }, {
    key: 'readBits',
    value: function readBits(size) {
      var bits = Math.min(this.bitsAvailable, size),
          // :uint
      valu = this.word >>> 32 - bits; // :uint
      if (size > 32) {
        _logger.logger.error('Cannot read more than 32 bits at a time');
      }
      this.bitsAvailable -= bits;
      if (this.bitsAvailable > 0) {
        this.word <<= bits;
      } else if (this.bytesAvailable > 0) {
        this.loadWord();
      }
      bits = size - bits;
      if (bits > 0 && this.bitsAvailable) {
        return valu << bits | this.readBits(bits);
      } else {
        return valu;
      }
    }

    // ():uint

  }, {
    key: 'skipLZ',
    value: function skipLZ() {
      var leadingZeroCount; // :uint
      for (leadingZeroCount = 0; leadingZeroCount < this.bitsAvailable; ++leadingZeroCount) {
        if (0 !== (this.word & 0x80000000 >>> leadingZeroCount)) {
          // the first bit of working word is 1
          this.word <<= leadingZeroCount;
          this.bitsAvailable -= leadingZeroCount;
          return leadingZeroCount;
        }
      }
      // we exhausted word and still have not found a 1
      this.loadWord();
      return leadingZeroCount + this.skipLZ();
    }

    // ():void

  }, {
    key: 'skipUEG',
    value: function skipUEG() {
      this.skipBits(1 + this.skipLZ());
    }

    // ():void

  }, {
    key: 'skipEG',
    value: function skipEG() {
      this.skipBits(1 + this.skipLZ());
    }

    // ():uint

  }, {
    key: 'readUEG',
    value: function readUEG() {
      var clz = this.skipLZ(); // :uint
      return this.readBits(clz + 1) - 1;
    }

    // ():int

  }, {
    key: 'readEG',
    value: function readEG() {
      var valu = this.readUEG(); // :int
      if (0x01 & valu) {
        // the number is odd if the low order bit is set
        return 1 + valu >>> 1; // add 1 to make it even, and divide by 2
      } else {
        return -1 * (valu >>> 1); // divide by two then make it negative
      }
    }

    // Some convenience functions
    // :Boolean

  }, {
    key: 'readBoolean',
    value: function readBoolean() {
      return 1 === this.readBits(1);
    }

    // ():int

  }, {
    key: 'readUByte',
    value: function readUByte() {
      return this.readBits(8);
    }

    // ():int

  }, {
    key: 'readUShort',
    value: function readUShort() {
      return this.readBits(16);
    }
    // ():int

  }, {
    key: 'readUInt',
    value: function readUInt() {
      return this.readBits(32);
    }

    /**
     * Advance the ExpGolomb decoder past a scaling list. The scaling
     * list is optionally transmitted as part of a sequence parameter
     * set and is not relevant to transmuxing.
     * @param count {number} the number of entries in this scaling list
     * @see Recommendation ITU-T H.264, Section 7.3.2.1.1.1
     */

  }, {
    key: 'skipScalingList',
    value: function skipScalingList(count) {
      var lastScale = 8,
          nextScale = 8,
          j,
          deltaScale;
      for (j = 0; j < count; j++) {
        if (nextScale !== 0) {
          deltaScale = this.readEG();
          nextScale = (lastScale + deltaScale + 256) % 256;
        }
        lastScale = nextScale === 0 ? lastScale : nextScale;
      }
    }

    /**
     * Read a sequence parameter set and return some interesting video
     * properties. A sequence parameter set is the H264 metadata that
     * describes the properties of upcoming video frames.
     * @param data {Uint8Array} the bytes of a sequence parameter set
     * @return {object} an object with configuration parsed from the
     * sequence parameter set, including the dimensions of the
     * associated video frames.
     */

  }, {
    key: 'readSPS',
    value: function readSPS() {
      var frameCropLeftOffset = 0,
          frameCropRightOffset = 0,
          frameCropTopOffset = 0,
          frameCropBottomOffset = 0,
          profileIdc,
          profileCompat,
          levelIdc,
          numRefFramesInPicOrderCntCycle,
          picWidthInMbsMinus1,
          picHeightInMapUnitsMinus1,
          frameMbsOnlyFlag,
          scalingListCount,
          i,
          readUByte = this.readUByte.bind(this),
          readBits = this.readBits.bind(this),
          readUEG = this.readUEG.bind(this),
          readBoolean = this.readBoolean.bind(this),
          skipBits = this.skipBits.bind(this),
          skipEG = this.skipEG.bind(this),
          skipUEG = this.skipUEG.bind(this),
          skipScalingList = this.skipScalingList.bind(this);

      readUByte();
      profileIdc = readUByte(); // profile_idc
      profileCompat = readBits(5); // constraint_set[0-4]_flag, u(5)
      skipBits(3); // reserved_zero_3bits u(3),
      levelIdc = readUByte(); //level_idc u(8)
      skipUEG(); // seq_parameter_set_id
      // some profiles have more optional data we don't need
      if (profileIdc === 100 || profileIdc === 110 || profileIdc === 122 || profileIdc === 244 || profileIdc === 44 || profileIdc === 83 || profileIdc === 86 || profileIdc === 118 || profileIdc === 128) {
        var chromaFormatIdc = readUEG();
        if (chromaFormatIdc === 3) {
          skipBits(1); // separate_colour_plane_flag
        }
        skipUEG(); // bit_depth_luma_minus8
        skipUEG(); // bit_depth_chroma_minus8
        skipBits(1); // qpprime_y_zero_transform_bypass_flag
        if (readBoolean()) {
          // seq_scaling_matrix_present_flag
          scalingListCount = chromaFormatIdc !== 3 ? 8 : 12;
          for (i = 0; i < scalingListCount; i++) {
            if (readBoolean()) {
              // seq_scaling_list_present_flag[ i ]
              if (i < 6) {
                skipScalingList(16);
              } else {
                skipScalingList(64);
              }
            }
          }
        }
      }
      skipUEG(); // log2_max_frame_num_minus4
      var picOrderCntType = readUEG();
      if (picOrderCntType === 0) {
        readUEG(); //log2_max_pic_order_cnt_lsb_minus4
      } else if (picOrderCntType === 1) {
        skipBits(1); // delta_pic_order_always_zero_flag
        skipEG(); // offset_for_non_ref_pic
        skipEG(); // offset_for_top_to_bottom_field
        numRefFramesInPicOrderCntCycle = readUEG();
        for (i = 0; i < numRefFramesInPicOrderCntCycle; i++) {
          skipEG(); // offset_for_ref_frame[ i ]
        }
      }
      skipUEG(); // max_num_ref_frames
      skipBits(1); // gaps_in_frame_num_value_allowed_flag
      picWidthInMbsMinus1 = readUEG();
      picHeightInMapUnitsMinus1 = readUEG();
      frameMbsOnlyFlag = readBits(1);
      if (frameMbsOnlyFlag === 0) {
        skipBits(1); // mb_adaptive_frame_field_flag
      }
      skipBits(1); // direct_8x8_inference_flag
      if (readBoolean()) {
        // frame_cropping_flag
        frameCropLeftOffset = readUEG();
        frameCropRightOffset = readUEG();
        frameCropTopOffset = readUEG();
        frameCropBottomOffset = readUEG();
      }
      var pixelRatio = [1, 1];
      if (readBoolean()) {
        // vui_parameters_present_flag
        if (readBoolean()) {
          // aspect_ratio_info_present_flag
          var aspectRatioIdc = readUByte();
          switch (aspectRatioIdc) {
            case 1:
              pixelRatio = [1, 1];break;
            case 2:
              pixelRatio = [12, 11];break;
            case 3:
              pixelRatio = [10, 11];break;
            case 4:
              pixelRatio = [16, 11];break;
            case 5:
              pixelRatio = [40, 33];break;
            case 6:
              pixelRatio = [24, 11];break;
            case 7:
              pixelRatio = [20, 11];break;
            case 8:
              pixelRatio = [32, 11];break;
            case 9:
              pixelRatio = [80, 33];break;
            case 10:
              pixelRatio = [18, 11];break;
            case 11:
              pixelRatio = [15, 11];break;
            case 12:
              pixelRatio = [64, 33];break;
            case 13:
              pixelRatio = [160, 99];break;
            case 14:
              pixelRatio = [4, 3];break;
            case 15:
              pixelRatio = [3, 2];break;
            case 16:
              pixelRatio = [2, 1];break;
            case 255:
              {
                pixelRatio = [readUByte() << 8 | readUByte(), readUByte() << 8 | readUByte()];
                break;
              }
          }
        }
      }
      return {
        width: Math.ceil((picWidthInMbsMinus1 + 1) * 16 - frameCropLeftOffset * 2 - frameCropRightOffset * 2),
        height: (2 - frameMbsOnlyFlag) * (picHeightInMapUnitsMinus1 + 1) * 16 - (frameMbsOnlyFlag ? 2 : 4) * (frameCropTopOffset + frameCropBottomOffset),
        pixelRatio: pixelRatio
      };
    }
  }, {
    key: 'readSliceType',
    value: function readSliceType() {
      // skip NALu type
      this.readUByte();
      // discard first_mb_in_slice
      this.readUEG();
      // return slice_type
      return this.readUEG();
    }
  }]);

  return ExpGolomb;
}();

exports.default = ExpGolomb;

/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * MP3 demuxer
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */


var _id = __webpack_require__(605);

var _id2 = _interopRequireDefault(_id);

var _mpegaudio = __webpack_require__(606);

var _mpegaudio2 = _interopRequireDefault(_mpegaudio);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MP3Demuxer = function () {
  function MP3Demuxer(observer, remuxer, config) {
    _classCallCheck(this, MP3Demuxer);

    this.observer = observer;
    this.config = config;
    this.remuxer = remuxer;
  }

  _createClass(MP3Demuxer, [{
    key: 'resetInitSegment',
    value: function resetInitSegment(initSegment, audioCodec, videoCodec, duration) {
      this._audioTrack = { container: 'audio/mpeg', type: 'audio', id: -1, sequenceNumber: 0, isAAC: false, samples: [], len: 0, manifestCodec: audioCodec, duration: duration, inputTimeScale: 90000 };
    }
  }, {
    key: 'resetTimeStamp',
    value: function resetTimeStamp() {}
  }, {
    key: 'append',


    // feed incoming data to the front of the parsing pipeline
    value: function append(data, timeOffset, contiguous, accurateTimeOffset) {
      var id3 = new _id2.default(data);
      var pts = 90 * id3.timeStamp;
      var afterID3 = id3.length;
      var offset, length;

      // Look for MPEG header
      for (offset = afterID3, length = data.length; offset < length - 1; offset++) {
        if (data[offset] === 0xff && (data[offset + 1] & 0xe0) === 0xe0 && (data[offset + 1] & 0x06) !== 0x00) {
          break;
        }
      }

      _mpegaudio2.default.parse(this._audioTrack, data, id3.length, pts);

      this.remuxer.remux(this._audioTrack, { samples: [] }, { samples: [{ pts: pts, dts: pts, data: id3.payload }], inputTimeScale: 90000 }, { samples: [] }, timeOffset, contiguous, accurateTimeOffset);
    }
  }, {
    key: 'destroy',
    value: function destroy() {}
  }], [{
    key: 'probe',
    value: function probe(data) {
      // check if data contains ID3 timestamp and MPEG sync word
      var id3 = new _id2.default(data),
          offset,
          length;
      if (id3.hasTimeStamp) {
        // Look for MPEG header | 1111 1111 | 111X XYZX | where X can be either 0 or 1 and Y or Z should be 1
        // Layer bits (position 14 and 15) in header should be always different from 0 (Layer I or Layer II or Layer III)
        // More info http://www.mp3-tech.org/programmer/frame_header.html
        for (offset = id3.length, length = Math.min(data.length - 1, offset + 100); offset < length; offset++) {
          if (data[offset] === 0xff && (data[offset + 1] & 0xe0) === 0xe0 && (data[offset + 1] & 0x06) !== 0x00) {
            //logger.log('MPEG sync word found !');
            return true;
          }
        }
      }
      return false;
    }
  }]);

  return MP3Demuxer;
}();

exports.default = MP3Demuxer;

/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * MP4 demuxer
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
//import {logger} from '../utils/logger';


var _events = __webpack_require__(39);

var _events2 = _interopRequireDefault(_events);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MP4Demuxer = function () {
  function MP4Demuxer(observer, remuxer) {
    _classCallCheck(this, MP4Demuxer);

    this.observer = observer;
    this.remuxer = remuxer;
  }

  _createClass(MP4Demuxer, [{
    key: 'resetTimeStamp',
    value: function resetTimeStamp() {}
  }, {
    key: 'resetInitSegment',
    value: function resetInitSegment(initSegment, audioCodec, videoCodec, duration) {
      //jshint unused:false
      var initData = this.initData = MP4Demuxer.parseInitSegment(initSegment);
      var tracks = {};
      if (initData.audio) {
        tracks.audio = { container: 'audio/mp4', codec: audioCodec, initSegment: initSegment };
      }
      if (initData.video) {
        tracks.video = { container: 'video/mp4', codec: videoCodec, initSegment: initSegment };
      }
      this.observer.trigger(_events2.default.FRAG_PARSING_INIT_SEGMENT, { tracks: tracks });
    }
  }, {
    key: 'append',


    // feed incoming data to the front of the parsing pipeline
    value: function append(data, timeOffset, contiguous, accurateTimeOffset) {
      var initData = this.initData;
      var startDTS = MP4Demuxer.startDTS(initData, data);
      this.remuxer.remux(initData.audio, initData.video, null, null, startDTS, contiguous, accurateTimeOffset, data);
    }
  }, {
    key: 'destroy',
    value: function destroy() {}
  }], [{
    key: 'probe',
    value: function probe(data) {
      if (data.length >= 8) {
        var dataType = MP4Demuxer.bin2str(data.subarray(4, 8));
        return ['moof', 'ftyp', 'styp'].indexOf(dataType) >= 0;
      }
      return false;
    }
  }, {
    key: 'bin2str',
    value: function bin2str(buffer) {
      return String.fromCharCode.apply(null, buffer);
    }

    // Find the data for a box specified by its path

  }, {
    key: 'findBox',
    value: function findBox(data, path) {
      var results = [],
          i,
          size,
          type,
          end,
          subresults;

      if (!path.length) {
        // short-circuit the search for empty paths
        return null;
      }

      for (i = 0; i < data.byteLength;) {
        size = data[i] << 24;
        size |= data[i + 1] << 16;
        size |= data[i + 2] << 8;
        size |= data[i + 3];

        type = MP4Demuxer.bin2str(data.subarray(i + 4, i + 8));

        end = size > 1 ? i + size : data.byteLength;

        if (type === path[0]) {
          if (path.length === 1) {
            // this is the end of the path and we've found the box we were
            // looking for
            results.push(data.subarray(i + 8, end));
          } else {
            // recursively search for the next box along the path
            subresults = MP4Demuxer.findBox(data.subarray(i + 8, end), path.slice(1));
            if (subresults.length) {
              results = results.concat(subresults);
            }
          }
        }
        i = end;
      }

      // we've finished searching all of data
      return results;
    }

    /**
     * Parses an MP4 initialization segment and extracts stream type and
     * timescale values for any declared tracks. Timescale values indicate the
     * number of clock ticks per second to assume for time-based values
     * elsewhere in the MP4.
     *
     * To determine the start time of an MP4, you need two pieces of
     * information: the timescale unit and the earliest base media decode
     * time. Multiple timescales can be specified within an MP4 but the
     * base media decode time is always expressed in the timescale from
     * the media header box for the track:
     * ```
     * moov > trak > mdia > mdhd.timescale
     * moov > trak > mdia > hdlr
     * ```
     * @param init {Uint8Array} the bytes of the init segment
     * @return {object} a hash of track type to timescale values or null if
     * the init segment is malformed.
     */

  }, {
    key: 'parseInitSegment',
    value: function parseInitSegment(initSegment) {
      var result = [];
      var traks = MP4Demuxer.findBox(initSegment, ['moov', 'trak']);

      traks.forEach(function (trak) {
        var tkhd = MP4Demuxer.findBox(trak, ['tkhd'])[0];
        if (tkhd) {
          var version = tkhd[0];
          var index = version === 0 ? 12 : 20;
          var trackId = tkhd[index] << 24 | tkhd[index + 1] << 16 | tkhd[index + 2] << 8 | tkhd[index + 3];

          trackId = trackId < 0 ? 4294967296 + trackId : trackId;

          var mdhd = MP4Demuxer.findBox(trak, ['mdia', 'mdhd'])[0];
          if (mdhd) {
            version = mdhd[0];
            index = version === 0 ? 12 : 20;
            var timescale = mdhd[index] << 24 | mdhd[index + 1] << 16 | mdhd[index + 2] << 8 | mdhd[index + 3];

            var hdlr = MP4Demuxer.findBox(trak, ['mdia', 'hdlr'])[0];
            if (hdlr) {
              var hdlrType = MP4Demuxer.bin2str(hdlr.subarray(8, 12));
              var type = { 'soun': 'audio', 'vide': 'video' }[hdlrType];
              if (type) {
                result[trackId] = { timescale: timescale, type: type };
                result[type] = { timescale: timescale, id: trackId };
              }
            }
          }
        }
      });
      return result;
    }

    /**
     * Determine the base media decode start time, in seconds, for an MP4
     * fragment. If multiple fragments are specified, the earliest time is
     * returned.
     *
     * The base media decode time can be parsed from track fragment
     * metadata:
     * ```
     * moof > traf > tfdt.baseMediaDecodeTime
     * ```
     * It requires the timescale value from the mdhd to interpret.
     *
     * @param timescale {object} a hash of track ids to timescale values.
     * @return {number} the earliest base media decode start time for the
     * fragment, in seconds
     */

  }, {
    key: 'startDTS',
    value: function startDTS(initData, fragment) {
      var trafs, baseTimes, result;

      // we need info from two childrend of each track fragment box
      trafs = MP4Demuxer.findBox(fragment, ['moof', 'traf']);

      // determine the start times for each track
      baseTimes = [].concat.apply([], trafs.map(function (traf) {
        return MP4Demuxer.findBox(traf, ['tfhd']).map(function (tfhd) {
          var id, scale, baseTime;

          // get the track id from the tfhd
          id = tfhd[4] << 24 | tfhd[5] << 16 | tfhd[6] << 8 | tfhd[7];
          // assume a 90kHz clock if no timescale was specified
          scale = initData[id].timescale || 90e3;

          // get the base media decode time from the tfdt
          baseTime = MP4Demuxer.findBox(traf, ['tfdt']).map(function (tfdt) {
            var version, result;

            version = tfdt[0];
            result = tfdt[4] << 24 | tfdt[5] << 16 | tfdt[6] << 8 | tfdt[7];
            if (version === 1) {
              result *= Math.pow(2, 32);
              result += tfdt[8] << 24 | tfdt[9] << 16 | tfdt[10] << 8 | tfdt[11];
            }
            return result;
          })[0];
          baseTime = baseTime || Infinity;

          // convert base time to seconds
          return baseTime / scale;
        });
      }));

      // return the minimum
      result = Math.min.apply(null, baseTimes);
      return isFinite(result) ? result : 0;
    }
  }]);

  return MP4Demuxer;
}();

exports.default = MP4Demuxer;

/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * SAMPLE-AES decrypter
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     */

var _decrypter = __webpack_require__(601);

var _decrypter2 = _interopRequireDefault(_decrypter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SampleAesDecrypter = function () {
  function SampleAesDecrypter(observer, config, decryptdata, discardEPB) {
    _classCallCheck(this, SampleAesDecrypter);

    this.decryptdata = decryptdata;
    this.discardEPB = discardEPB;
    this.decrypter = new _decrypter2.default(observer, config);
  }

  _createClass(SampleAesDecrypter, [{
    key: 'decryptBuffer',
    value: function decryptBuffer(encryptedData, callback) {
      this.decrypter.decrypt(encryptedData, this.decryptdata.key.buffer, this.decryptdata.iv.buffer, callback);
    }

    // AAC - encrypt all full 16 bytes blocks starting from offset 16

  }, {
    key: 'decryptAacSample',
    value: function decryptAacSample(samples, sampleIndex, callback, sync) {
      var curUnit = samples[sampleIndex].unit;
      var encryptedData = curUnit.subarray(16, curUnit.length - curUnit.length % 16);
      var encryptedBuffer = encryptedData.buffer.slice(encryptedData.byteOffset, encryptedData.byteOffset + encryptedData.length);

      var localthis = this;
      this.decryptBuffer(encryptedBuffer, function (decryptedData) {
        decryptedData = new Uint8Array(decryptedData);
        curUnit.set(decryptedData, 16);

        if (!sync) {
          localthis.decryptAacSamples(samples, sampleIndex + 1, callback);
        }
      });
    }
  }, {
    key: 'decryptAacSamples',
    value: function decryptAacSamples(samples, sampleIndex, callback) {
      for (;; sampleIndex++) {
        if (sampleIndex >= samples.length) {
          callback();
          return;
        }

        if (samples[sampleIndex].unit.length < 32) {
          continue;
        }

        var sync = this.decrypter.isSync();

        this.decryptAacSample(samples, sampleIndex, callback, sync);

        if (!sync) {
          return;
        }
      }
    }

    // AVC - encrypt one 16 bytes block out of ten, starting from offset 32

  }, {
    key: 'getAvcEncryptedData',
    value: function getAvcEncryptedData(decodedData) {
      var encryptedDataLen = Math.floor((decodedData.length - 48) / 160) * 16 + 16;
      var encryptedData = new Int8Array(encryptedDataLen);
      var outputPos = 0;
      for (var inputPos = 32; inputPos <= decodedData.length - 16; inputPos += 160, outputPos += 16) {
        encryptedData.set(decodedData.subarray(inputPos, inputPos + 16), outputPos);
      }
      return encryptedData;
    }
  }, {
    key: 'getAvcDecryptedUnit',
    value: function getAvcDecryptedUnit(decodedData, decryptedData) {
      decryptedData = new Uint8Array(decryptedData);
      var inputPos = 0;
      for (var outputPos = 32; outputPos <= decodedData.length - 16; outputPos += 160, inputPos += 16) {
        decodedData.set(decryptedData.subarray(inputPos, inputPos + 16), outputPos);
      }
      return decodedData;
    }
  }, {
    key: 'decryptAvcSample',
    value: function decryptAvcSample(samples, sampleIndex, unitIndex, callback, curUnit, sync) {
      var decodedData = this.discardEPB(curUnit.data);
      var encryptedData = this.getAvcEncryptedData(decodedData);
      var localthis = this;

      this.decryptBuffer(encryptedData.buffer, function (decryptedData) {
        curUnit.data = localthis.getAvcDecryptedUnit(decodedData, decryptedData);

        if (!sync) {
          localthis.decryptAvcSamples(samples, sampleIndex, unitIndex + 1, callback);
        }
      });
    }
  }, {
    key: 'decryptAvcSamples',
    value: function decryptAvcSamples(samples, sampleIndex, unitIndex, callback) {
      for (;; sampleIndex++, unitIndex = 0) {
        if (sampleIndex >= samples.length) {
          callback();
          return;
        }

        var curUnits = samples[sampleIndex].units;
        for (;; unitIndex++) {
          if (unitIndex >= curUnits.length) {
            break;
          }

          var curUnit = curUnits[unitIndex];
          if (curUnit.length <= 48 || curUnit.type !== 1 && curUnit.type !== 5) {
            continue;
          }

          var sync = this.decrypter.isSync();

          this.decryptAvcSample(samples, sampleIndex, unitIndex, callback, curUnit, sync);

          if (!sync) {
            return;
          }
        }
      }
    }
  }]);

  return SampleAesDecrypter;
}();

exports.default = SampleAesDecrypter;

/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * highly optimized TS demuxer:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * parse PAT, PMT
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * extract PES packet from audio and video PIDs
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * extract AVC/H264 NAL units and AAC/ADTS samples from PES packet
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * trigger the remuxer upon parsing completion
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * it also tries to workaround as best as it can audio codec switch (HE-AAC to AAC and vice versa), without having to restart the MediaSource.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * it also controls the remuxing process :
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * upon discontinuity or level switch detection, it will also notifies the remuxer so that it can reset its state.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     */

// import Hex from '../utils/hex';


var _adts = __webpack_require__(602);

var _adts2 = _interopRequireDefault(_adts);

var _mpegaudio = __webpack_require__(606);

var _mpegaudio2 = _interopRequireDefault(_mpegaudio);

var _events = __webpack_require__(39);

var _events2 = _interopRequireDefault(_events);

var _expGolomb = __webpack_require__(1456);

var _expGolomb2 = _interopRequireDefault(_expGolomb);

var _sampleAes = __webpack_require__(1459);

var _sampleAes2 = _interopRequireDefault(_sampleAes);

var _logger = __webpack_require__(31);

var _errors = __webpack_require__(63);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TSDemuxer = function () {
  function TSDemuxer(observer, remuxer, config, typeSupported) {
    _classCallCheck(this, TSDemuxer);

    this.observer = observer;
    this.config = config;
    this.typeSupported = typeSupported;
    this.remuxer = remuxer;
    this.sampleAes = null;
  }

  _createClass(TSDemuxer, [{
    key: 'setDecryptData',
    value: function setDecryptData(decryptdata) {
      if (decryptdata != null && decryptdata.key != null && decryptdata.method === 'SAMPLE-AES') {
        this.sampleAes = new _sampleAes2.default(this.observer, this.config, decryptdata, this.discardEPB);
      } else {
        this.sampleAes = null;
      }
    }
  }, {
    key: 'resetInitSegment',
    value: function resetInitSegment(initSegment, audioCodec, videoCodec, duration) {
      this.pmtParsed = false;
      this._pmtId = -1;
      this._avcTrack = { container: 'video/mp2t', type: 'video', id: -1, inputTimeScale: 90000, sequenceNumber: 0, samples: [], len: 0, dropped: 0 };
      this._audioTrack = { container: 'video/mp2t', type: 'audio', id: -1, inputTimeScale: 90000, duration: duration, sequenceNumber: 0, samples: [], len: 0, isAAC: true };
      this._id3Track = { type: 'id3', id: -1, inputTimeScale: 90000, sequenceNumber: 0, samples: [], len: 0 };
      this._txtTrack = { type: 'text', id: -1, inputTimeScale: 90000, sequenceNumber: 0, samples: [], len: 0 };
      // flush any partial content
      this.aacOverFlow = null;
      this.aacLastPTS = null;
      this.avcSample = null;
      this.audioCodec = audioCodec;
      this.videoCodec = videoCodec;
      this._duration = duration;
    }
  }, {
    key: 'resetTimeStamp',
    value: function resetTimeStamp() {}

    // feed incoming data to the front of the parsing pipeline

  }, {
    key: 'append',
    value: function append(data, timeOffset, contiguous, accurateTimeOffset) {
      var start,
          len = data.length,
          stt,
          pid,
          atf,
          offset,
          pes,
          unknownPIDs = false;
      this.contiguous = contiguous;
      var pmtParsed = this.pmtParsed,
          avcTrack = this._avcTrack,
          audioTrack = this._audioTrack,
          id3Track = this._id3Track,
          avcId = avcTrack.id,
          audioId = audioTrack.id,
          id3Id = id3Track.id,
          pmtId = this._pmtId,
          avcData = avcTrack.pesData,
          audioData = audioTrack.pesData,
          id3Data = id3Track.pesData,
          parsePAT = this._parsePAT,
          parsePMT = this._parsePMT,
          parsePES = this._parsePES,
          parseAVCPES = this._parseAVCPES.bind(this),
          parseAACPES = this._parseAACPES.bind(this),
          parseMPEGPES = this._parseMPEGPES.bind(this),
          parseID3PES = this._parseID3PES.bind(this);

      // don't parse last TS packet if incomplete
      len -= len % 188;
      // loop through TS packets
      for (start = 0; start < len; start += 188) {
        if (data[start] === 0x47) {
          stt = !!(data[start + 1] & 0x40);
          // pid is a 13-bit field starting at the last bit of TS[1]
          pid = ((data[start + 1] & 0x1f) << 8) + data[start + 2];
          atf = (data[start + 3] & 0x30) >> 4;
          // if an adaption field is present, its length is specified by the fifth byte of the TS packet header.
          if (atf > 1) {
            offset = start + 5 + data[start + 4];
            // continue if there is only adaptation field
            if (offset === start + 188) {
              continue;
            }
          } else {
            offset = start + 4;
          }
          switch (pid) {
            case avcId:
              if (stt) {
                if (avcData && (pes = parsePES(avcData))) {
                  parseAVCPES(pes, false);
                }
                avcData = { data: [], size: 0 };
              }
              if (avcData) {
                avcData.data.push(data.subarray(offset, start + 188));
                avcData.size += start + 188 - offset;
              }
              break;
            case audioId:
              if (stt) {
                if (audioData && (pes = parsePES(audioData))) {
                  if (audioTrack.isAAC) {
                    parseAACPES(pes);
                  } else {
                    parseMPEGPES(pes);
                  }
                }
                audioData = { data: [], size: 0 };
              }
              if (audioData) {
                audioData.data.push(data.subarray(offset, start + 188));
                audioData.size += start + 188 - offset;
              }
              break;
            case id3Id:
              if (stt) {
                if (id3Data && (pes = parsePES(id3Data))) {
                  parseID3PES(pes);
                }
                id3Data = { data: [], size: 0 };
              }
              if (id3Data) {
                id3Data.data.push(data.subarray(offset, start + 188));
                id3Data.size += start + 188 - offset;
              }
              break;
            case 0:
              if (stt) {
                offset += data[offset] + 1;
              }
              pmtId = this._pmtId = parsePAT(data, offset);
              break;
            case pmtId:
              if (stt) {
                offset += data[offset] + 1;
              }
              var parsedPIDs = parsePMT(data, offset, this.typeSupported.mpeg === true || this.typeSupported.mp3 === true, this.sampleAes != null);

              // only update track id if track PID found while parsing PMT
              // this is to avoid resetting the PID to -1 in case
              // track PID transiently disappears from the stream
              // this could happen in case of transient missing audio samples for example
              avcId = parsedPIDs.avc;
              if (avcId > 0) {
                avcTrack.id = avcId;
              }
              audioId = parsedPIDs.audio;
              if (audioId > 0) {
                audioTrack.id = audioId;
                audioTrack.isAAC = parsedPIDs.isAAC;
              }
              id3Id = parsedPIDs.id3;
              if (id3Id > 0) {
                id3Track.id = id3Id;
              }
              if (unknownPIDs && !pmtParsed) {
                _logger.logger.log('reparse from beginning');
                unknownPIDs = false;
                // we set it to -188, the += 188 in the for loop will reset start to 0
                start = -188;
              }
              pmtParsed = this.pmtParsed = true;
              break;
            case 17:
            case 0x1fff:
              break;
            default:
              unknownPIDs = true;
              break;
          }
        } else {
          this.observer.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.MEDIA_ERROR, details: _errors.ErrorDetails.FRAG_PARSING_ERROR, fatal: false, reason: 'TS packet did not start with 0x47' });
        }
      }
      // try to parse last PES packets
      if (avcData && (pes = parsePES(avcData))) {
        parseAVCPES(pes, true);
        avcTrack.pesData = null;
      } else {
        // either avcData null or PES truncated, keep it for next frag parsing
        avcTrack.pesData = avcData;
      }

      if (audioData && (pes = parsePES(audioData))) {
        if (audioTrack.isAAC) {
          parseAACPES(pes);
        } else {
          parseMPEGPES(pes);
        }
        audioTrack.pesData = null;
      } else {
        if (audioData && audioData.size) {
          _logger.logger.log('last AAC PES packet truncated,might overlap between fragments');
        }
        // either audioData null or PES truncated, keep it for next frag parsing
        audioTrack.pesData = audioData;
      }

      if (id3Data && (pes = parsePES(id3Data))) {
        parseID3PES(pes);
        id3Track.pesData = null;
      } else {
        // either id3Data null or PES truncated, keep it for next frag parsing
        id3Track.pesData = id3Data;
      }

      if (this.sampleAes == null) {
        this.remuxer.remux(audioTrack, avcTrack, id3Track, this._txtTrack, timeOffset, contiguous, accurateTimeOffset);
      } else {
        this.decryptAndRemux(audioTrack, avcTrack, id3Track, this._txtTrack, timeOffset, contiguous, accurateTimeOffset);
      }
    }
  }, {
    key: 'decryptAndRemux',
    value: function decryptAndRemux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset) {
      if (audioTrack.samples && audioTrack.isAAC) {
        var localthis = this;
        this.sampleAes.decryptAacSamples(audioTrack.samples, 0, function () {
          localthis.decryptAndRemuxAvc(audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset);
        });
      } else {
        this.decryptAndRemuxAvc(audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset);
      }
    }
  }, {
    key: 'decryptAndRemuxAvc',
    value: function decryptAndRemuxAvc(audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset) {
      if (videoTrack.samples) {
        var localthis = this;
        this.sampleAes.decryptAvcSamples(videoTrack.samples, 0, 0, function () {
          localthis.remuxer.remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset);
        });
      } else {
        this.remuxer.remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset);
      }
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this._initPTS = this._initDTS = undefined;
      this._duration = 0;
    }
  }, {
    key: '_parsePAT',
    value: function _parsePAT(data, offset) {
      // skip the PSI header and parse the first PMT entry
      return (data[offset + 10] & 0x1F) << 8 | data[offset + 11];
      //logger.log('PMT PID:'  + this._pmtId);
    }
  }, {
    key: '_parsePMT',
    value: function _parsePMT(data, offset, mpegSupported, isSampleAes) {
      var sectionLength,
          tableEnd,
          programInfoLength,
          pid,
          result = { audio: -1, avc: -1, id3: -1, isAAC: true };
      sectionLength = (data[offset + 1] & 0x0f) << 8 | data[offset + 2];
      tableEnd = offset + 3 + sectionLength - 4;
      // to determine where the table is, we have to figure out how
      // long the program info descriptors are
      programInfoLength = (data[offset + 10] & 0x0f) << 8 | data[offset + 11];
      // advance the offset to the first entry in the mapping table
      offset += 12 + programInfoLength;
      while (offset < tableEnd) {
        pid = (data[offset + 1] & 0x1F) << 8 | data[offset + 2];
        switch (data[offset]) {
          case 0xcf:
            // SAMPLE-AES AAC
            if (!isSampleAes) {
              _logger.logger.log('unkown stream type:' + data[offset]);
              break;
            }
          /* falls through */

          // ISO/IEC 13818-7 ADTS AAC (MPEG-2 lower bit-rate audio)
          case 0x0f:
            //logger.log('AAC PID:'  + pid);
            if (result.audio === -1) {
              result.audio = pid;
            }
            break;

          // Packetized metadata (ID3)
          case 0x15:
            //logger.log('ID3 PID:'  + pid);
            if (result.id3 === -1) {
              result.id3 = pid;
            }
            break;

          case 0xdb:
            // SAMPLE-AES AVC
            if (!isSampleAes) {
              _logger.logger.log('unkown stream type:' + data[offset]);
              break;
            }
          /* falls through */

          // ITU-T Rec. H.264 and ISO/IEC 14496-10 (lower bit-rate video)
          case 0x1b:
            //logger.log('AVC PID:'  + pid);
            if (result.avc === -1) {
              result.avc = pid;
            }
            break;

          // ISO/IEC 11172-3 (MPEG-1 audio)
          // or ISO/IEC 13818-3 (MPEG-2 halved sample rate audio)
          case 0x03:
          case 0x04:
            //logger.log('MPEG PID:'  + pid);
            if (!mpegSupported) {
              _logger.logger.log('MPEG audio found, not supported in this browser for now');
            } else if (result.audio === -1) {
              result.audio = pid;
              result.isAAC = false;
            }
            break;

          case 0x24:
            _logger.logger.warn('HEVC stream type found, not supported for now');
            break;

          default:
            _logger.logger.log('unkown stream type:' + data[offset]);
            break;
        }
        // move to the next table entry
        // skip past the elementary stream descriptors, if present
        offset += ((data[offset + 3] & 0x0F) << 8 | data[offset + 4]) + 5;
      }
      return result;
    }
  }, {
    key: '_parsePES',
    value: function _parsePES(stream) {
      var i = 0,
          frag,
          pesFlags,
          pesPrefix,
          pesLen,
          pesHdrLen,
          pesData,
          pesPts,
          pesDts,
          payloadStartOffset,
          data = stream.data;
      // safety check
      if (!stream || stream.size === 0) {
        return null;
      }

      // we might need up to 19 bytes to read PES header
      // if first chunk of data is less than 19 bytes, let's merge it with following ones until we get 19 bytes
      // usually only one merge is needed (and this is rare ...)
      while (data[0].length < 19 && data.length > 1) {
        var newData = new Uint8Array(data[0].length + data[1].length);
        newData.set(data[0]);
        newData.set(data[1], data[0].length);
        data[0] = newData;
        data.splice(1, 1);
      }
      //retrieve PTS/DTS from first fragment
      frag = data[0];
      pesPrefix = (frag[0] << 16) + (frag[1] << 8) + frag[2];
      if (pesPrefix === 1) {
        pesLen = (frag[4] << 8) + frag[5];
        // if PES parsed length is not zero and greater than total received length, stop parsing. PES might be truncated
        // minus 6 : PES header size
        if (pesLen && pesLen > stream.size - 6) {
          return null;
        }
        pesFlags = frag[7];
        if (pesFlags & 0xC0) {
          /* PES header described here : http://dvd.sourceforge.net/dvdinfo/pes-hdr.html
              as PTS / DTS is 33 bit we cannot use bitwise operator in JS,
              as Bitwise operators treat their operands as a sequence of 32 bits */
          pesPts = (frag[9] & 0x0E) * 536870912 + // 1 << 29
          (frag[10] & 0xFF) * 4194304 + // 1 << 22
          (frag[11] & 0xFE) * 16384 + // 1 << 14
          (frag[12] & 0xFF) * 128 + // 1 << 7
          (frag[13] & 0xFE) / 2;
          // check if greater than 2^32 -1
          if (pesPts > 4294967295) {
            // decrement 2^33
            pesPts -= 8589934592;
          }
          if (pesFlags & 0x40) {
            pesDts = (frag[14] & 0x0E) * 536870912 + // 1 << 29
            (frag[15] & 0xFF) * 4194304 + // 1 << 22
            (frag[16] & 0xFE) * 16384 + // 1 << 14
            (frag[17] & 0xFF) * 128 + // 1 << 7
            (frag[18] & 0xFE) / 2;
            // check if greater than 2^32 -1
            if (pesDts > 4294967295) {
              // decrement 2^33
              pesDts -= 8589934592;
            }
            if (pesPts - pesDts > 60 * 90000) {
              _logger.logger.warn(Math.round((pesPts - pesDts) / 90000) + 's delta between PTS and DTS, align them');
              pesPts = pesDts;
            }
          } else {
            pesDts = pesPts;
          }
        }
        pesHdrLen = frag[8];
        // 9 bytes : 6 bytes for PES header + 3 bytes for PES extension
        payloadStartOffset = pesHdrLen + 9;

        stream.size -= payloadStartOffset;
        //reassemble PES packet
        pesData = new Uint8Array(stream.size);
        for (var j = 0, dataLen = data.length; j < dataLen; j++) {
          frag = data[j];
          var len = frag.byteLength;
          if (payloadStartOffset) {
            if (payloadStartOffset > len) {
              // trim full frag if PES header bigger than frag
              payloadStartOffset -= len;
              continue;
            } else {
              // trim partial frag if PES header smaller than frag
              frag = frag.subarray(payloadStartOffset);
              len -= payloadStartOffset;
              payloadStartOffset = 0;
            }
          }
          pesData.set(frag, i);
          i += len;
        }
        if (pesLen) {
          // payload size : remove PES header + PES extension
          pesLen -= pesHdrLen + 3;
        }
        return { data: pesData, pts: pesPts, dts: pesDts, len: pesLen };
      } else {
        return null;
      }
    }
  }, {
    key: 'pushAccesUnit',
    value: function pushAccesUnit(avcSample, avcTrack) {
      if (avcSample.units.length && avcSample.frame) {
        var samples = avcTrack.samples;
        var nbSamples = samples.length;
        // only push AVC sample if starting with a keyframe is not mandatory OR
        //    if keyframe already found in this fragment OR
        //       keyframe found in last fragment (track.sps) AND
        //          samples already appended (we already found a keyframe in this fragment) OR fragment is contiguous
        if (!this.config.forceKeyFrameOnDiscontinuity || avcSample.key === true || avcTrack.sps && (nbSamples || this.contiguous)) {
          avcSample.id = nbSamples;
          samples.push(avcSample);
        } else {
          // dropped samples, track it
          avcTrack.dropped++;
        }
      }
      if (avcSample.debug.length) {
        _logger.logger.log(avcSample.pts + '/' + avcSample.dts + ':' + avcSample.debug);
      }
    }
  }, {
    key: '_parseAVCPES',
    value: function _parseAVCPES(pes, last) {
      var _this = this;

      //logger.log('parse new PES');
      var track = this._avcTrack,
          units = this._parseAVCNALu(pes.data),
          debug = false,
          expGolombDecoder,
          avcSample = this.avcSample,
          push,
          i;
      //free pes.data to save up some memory
      pes.data = null;

      units.forEach(function (unit) {
        switch (unit.type) {
          //NDR
          case 1:
            push = true;
            if (debug && avcSample) {
              avcSample.debug += 'NDR ';
            }
            avcSample.frame = true;
            // retrieve slice type by parsing beginning of NAL unit (follow H264 spec, slice_header definition) to detect keyframe embedded in NDR
            var data = unit.data;
            if (data.length > 4) {
              var sliceType = new _expGolomb2.default(data).readSliceType();
              // 2 : I slice, 4 : SI slice, 7 : I slice, 9: SI slice
              // SI slice : A slice that is coded using intra prediction only and using quantisation of the prediction samples.
              // An SI slice can be coded such that its decoded samples can be constructed identically to an SP slice.
              // I slice: A slice that is not an SI slice that is decoded using intra prediction only.
              //if (sliceType === 2 || sliceType === 7) {
              if (sliceType === 2 || sliceType === 4 || sliceType === 7 || sliceType === 9) {
                avcSample.key = true;
              }
            }
            break;
          //IDR
          case 5:
            push = true;
            // handle PES not starting with AUD
            if (!avcSample) {
              avcSample = _this.avcSample = _this._createAVCSample(true, pes.pts, pes.dts, '');
            }
            if (debug) {
              avcSample.debug += 'IDR ';
            }
            avcSample.key = true;
            avcSample.frame = true;
            break;
          //SEI
          case 6:
            push = true;
            if (debug && avcSample) {
              avcSample.debug += 'SEI ';
            }
            expGolombDecoder = new _expGolomb2.default(_this.discardEPB(unit.data));

            // skip frameType
            expGolombDecoder.readUByte();

            var payloadType = 0;
            var payloadSize = 0;
            var endOfCaptions = false;
            var b = 0;

            while (!endOfCaptions && expGolombDecoder.bytesAvailable > 1) {
              payloadType = 0;
              do {
                b = expGolombDecoder.readUByte();
                payloadType += b;
              } while (b === 0xFF);

              // Parse payload size.
              payloadSize = 0;
              do {
                b = expGolombDecoder.readUByte();
                payloadSize += b;
              } while (b === 0xFF);

              // TODO: there can be more than one payload in an SEI packet...
              // TODO: need to read type and size in a while loop to get them all
              if (payloadType === 4 && expGolombDecoder.bytesAvailable !== 0) {

                endOfCaptions = true;

                var countryCode = expGolombDecoder.readUByte();

                if (countryCode === 181) {
                  var providerCode = expGolombDecoder.readUShort();

                  if (providerCode === 49) {
                    var userStructure = expGolombDecoder.readUInt();

                    if (userStructure === 0x47413934) {
                      var userDataType = expGolombDecoder.readUByte();

                      // Raw CEA-608 bytes wrapped in CEA-708 packet
                      if (userDataType === 3) {
                        var firstByte = expGolombDecoder.readUByte();
                        var secondByte = expGolombDecoder.readUByte();

                        var totalCCs = 31 & firstByte;
                        var byteArray = [firstByte, secondByte];

                        for (i = 0; i < totalCCs; i++) {
                          // 3 bytes per CC
                          byteArray.push(expGolombDecoder.readUByte());
                          byteArray.push(expGolombDecoder.readUByte());
                          byteArray.push(expGolombDecoder.readUByte());
                        }

                        _this._insertSampleInOrder(_this._txtTrack.samples, { type: 3, pts: pes.pts, bytes: byteArray });
                      }
                    }
                  }
                }
              } else if (payloadSize < expGolombDecoder.bytesAvailable) {
                for (i = 0; i < payloadSize; i++) {
                  expGolombDecoder.readUByte();
                }
              }
            }
            break;
          //SPS
          case 7:
            push = true;
            if (debug && avcSample) {
              avcSample.debug += 'SPS ';
            }
            if (!track.sps) {
              expGolombDecoder = new _expGolomb2.default(unit.data);
              var config = expGolombDecoder.readSPS();
              track.width = config.width;
              track.height = config.height;
              track.pixelRatio = config.pixelRatio;
              track.sps = [unit.data];
              track.duration = _this._duration;
              var codecarray = unit.data.subarray(1, 4);
              var codecstring = 'avc1.';
              for (i = 0; i < 3; i++) {
                var h = codecarray[i].toString(16);
                if (h.length < 2) {
                  h = '0' + h;
                }
                codecstring += h;
              }
              track.codec = codecstring;
            }
            break;
          //PPS
          case 8:
            push = true;
            if (debug && avcSample) {
              avcSample.debug += 'PPS ';
            }
            if (!track.pps) {
              track.pps = [unit.data];
            }
            break;
          // AUD
          case 9:
            push = false;
            if (avcSample) {
              _this.pushAccesUnit(avcSample, track);
            }
            avcSample = _this.avcSample = _this._createAVCSample(false, pes.pts, pes.dts, debug ? 'AUD ' : '');
            break;
          // Filler Data
          case 12:
            push = false;
            break;
          default:
            push = false;
            if (avcSample) {
              avcSample.debug += 'unknown NAL ' + unit.type + ' ';
            }
            break;
        }
        if (avcSample && push) {
          var _units = avcSample.units;
          _units.push(unit);
        }
      });
      // if last PES packet, push samples
      if (last && avcSample) {
        this.pushAccesUnit(avcSample, track);
        this.avcSample = null;
      }
    }
  }, {
    key: '_createAVCSample',
    value: function _createAVCSample(key, pts, dts, debug) {
      return { key: key, pts: pts, dts: dts, units: [], debug: debug };
    }
  }, {
    key: '_insertSampleInOrder',
    value: function _insertSampleInOrder(arr, data) {
      var len = arr.length;
      if (len > 0) {
        if (data.pts >= arr[len - 1].pts) {
          arr.push(data);
        } else {
          for (var pos = len - 1; pos >= 0; pos--) {
            if (data.pts < arr[pos].pts) {
              arr.splice(pos, 0, data);
              break;
            }
          }
        }
      } else {
        arr.push(data);
      }
    }
  }, {
    key: '_getLastNalUnit',
    value: function _getLastNalUnit() {
      var avcSample = this.avcSample,
          lastUnit = void 0;
      // try to fallback to previous sample if current one is empty
      if (!avcSample || avcSample.units.length === 0) {
        var track = this._avcTrack,
            samples = track.samples;
        avcSample = samples[samples.length - 1];
      }
      if (avcSample) {
        var units = avcSample.units;
        lastUnit = units[units.length - 1];
      }
      return lastUnit;
    }
  }, {
    key: '_parseAVCNALu',
    value: function _parseAVCNALu(array) {
      var i = 0,
          len = array.byteLength,
          value,
          overflow,
          track = this._avcTrack,
          state = track.naluState || 0,
          lastState = state;
      var units = [],
          unit,
          unitType,
          lastUnitStart = -1,
          lastUnitType;
      //logger.log('PES:' + Hex.hexDump(array));

      if (state === -1) {
        // special use case where we found 3 or 4-byte start codes exactly at the end of previous PES packet
        lastUnitStart = 0;
        // NALu type is value read from offset 0
        lastUnitType = array[0] & 0x1f;
        state = 0;
        i = 1;
      }

      while (i < len) {
        value = array[i++];
        // optimization. state 0 and 1 are the predominant case. let's handle them outside of the switch/case
        if (!state) {
          state = value ? 0 : 1;
          continue;
        }
        if (state === 1) {
          state = value ? 0 : 2;
          continue;
        }
        // here we have state either equal to 2 or 3
        if (!value) {
          state = 3;
        } else if (value === 1) {
          if (lastUnitStart >= 0) {
            unit = { data: array.subarray(lastUnitStart, i - state - 1), type: lastUnitType };
            //logger.log('pushing NALU, type/size:' + unit.type + '/' + unit.data.byteLength);
            units.push(unit);
          } else {
            // lastUnitStart is undefined => this is the first start code found in this PES packet
            // first check if start code delimiter is overlapping between 2 PES packets,
            // ie it started in last packet (lastState not zero)
            // and ended at the beginning of this PES packet (i <= 4 - lastState)
            var lastUnit = this._getLastNalUnit();
            if (lastUnit) {
              if (lastState && i <= 4 - lastState) {
                // start delimiter overlapping between PES packets
                // strip start delimiter bytes from the end of last NAL unit
                // check if lastUnit had a state different from zero
                if (lastUnit.state) {
                  // strip last bytes
                  lastUnit.data = lastUnit.data.subarray(0, lastUnit.data.byteLength - lastState);
                }
              }
              // If NAL units are not starting right at the beginning of the PES packet, push preceding data into previous NAL unit.
              overflow = i - state - 1;
              if (overflow > 0) {
                //logger.log('first NALU found with overflow:' + overflow);
                var tmp = new Uint8Array(lastUnit.data.byteLength + overflow);
                tmp.set(lastUnit.data, 0);
                tmp.set(array.subarray(0, overflow), lastUnit.data.byteLength);
                lastUnit.data = tmp;
              }
            }
          }
          // check if we can read unit type
          if (i < len) {
            unitType = array[i] & 0x1f;
            //logger.log('find NALU @ offset:' + i + ',type:' + unitType);
            lastUnitStart = i;
            lastUnitType = unitType;
            state = 0;
          } else {
            // not enough byte to read unit type. let's read it on next PES parsing
            state = -1;
          }
        } else {
          state = 0;
        }
      }
      if (lastUnitStart >= 0 && state >= 0) {
        unit = { data: array.subarray(lastUnitStart, len), type: lastUnitType, state: state };
        units.push(unit);
        //logger.log('pushing NALU, type/size/state:' + unit.type + '/' + unit.data.byteLength + '/' + state);
      }
      // no NALu found
      if (units.length === 0) {
        // append pes.data to previous NAL unit
        var _lastUnit = this._getLastNalUnit();
        if (_lastUnit) {
          var _tmp = new Uint8Array(_lastUnit.data.byteLength + array.byteLength);
          _tmp.set(_lastUnit.data, 0);
          _tmp.set(array, _lastUnit.data.byteLength);
          _lastUnit.data = _tmp;
        }
      }
      track.naluState = state;
      return units;
    }

    /**
     * remove Emulation Prevention bytes from a RBSP
     */

  }, {
    key: 'discardEPB',
    value: function discardEPB(data) {
      var length = data.byteLength,
          EPBPositions = [],
          i = 1,
          newLength,
          newData;

      // Find all `Emulation Prevention Bytes`
      while (i < length - 2) {
        if (data[i] === 0 && data[i + 1] === 0 && data[i + 2] === 0x03) {
          EPBPositions.push(i + 2);
          i += 2;
        } else {
          i++;
        }
      }

      // If no Emulation Prevention Bytes were found just return the original
      // array
      if (EPBPositions.length === 0) {
        return data;
      }

      // Create a new array to hold the NAL unit data
      newLength = length - EPBPositions.length;
      newData = new Uint8Array(newLength);
      var sourceIndex = 0;

      for (i = 0; i < newLength; sourceIndex++, i++) {
        if (sourceIndex === EPBPositions[0]) {
          // Skip this byte
          sourceIndex++;
          // Remove this position index
          EPBPositions.shift();
        }
        newData[i] = data[sourceIndex];
      }
      return newData;
    }
  }, {
    key: '_parseAACPES',
    value: function _parseAACPES(pes) {
      var track = this._audioTrack,
          data = pes.data,
          pts = pes.pts,
          startOffset = 0,
          aacOverFlow = this.aacOverFlow,
          aacLastPTS = this.aacLastPTS,
          config,
          frameLength,
          frameDuration,
          frameIndex,
          offset,
          headerLength,
          stamp,
          len,
          aacSample;
      if (aacOverFlow) {
        var tmp = new Uint8Array(aacOverFlow.byteLength + data.byteLength);
        tmp.set(aacOverFlow, 0);
        tmp.set(data, aacOverFlow.byteLength);
        //logger.log(`AAC: append overflowing ${aacOverFlow.byteLength} bytes to beginning of new PES`);
        data = tmp;
      }
      // look for ADTS header (0xFFFx)
      for (offset = startOffset, len = data.length; offset < len - 1; offset++) {
        if (data[offset] === 0xff && (data[offset + 1] & 0xf0) === 0xf0) {
          break;
        }
      }
      // if ADTS header does not start straight from the beginning of the PES payload, raise an error
      if (offset) {
        var reason, fatal;
        if (offset < len - 1) {
          reason = 'AAC PES did not start with ADTS header,offset:' + offset;
          fatal = false;
        } else {
          reason = 'no ADTS header found in AAC PES';
          fatal = true;
        }
        _logger.logger.warn('parsing error:' + reason);
        this.observer.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.MEDIA_ERROR, details: _errors.ErrorDetails.FRAG_PARSING_ERROR, fatal: fatal, reason: reason });
        if (fatal) {
          return;
        }
      }
      if (!track.samplerate) {
        var audioCodec = this.audioCodec;
        config = _adts2.default.getAudioConfig(this.observer, data, offset, audioCodec);
        track.config = config.config;
        track.samplerate = config.samplerate;
        track.channelCount = config.channelCount;
        track.codec = config.codec;
        track.manifestCodec = config.manifestCodec;
        _logger.logger.log('parsed codec:' + track.codec + ',rate:' + config.samplerate + ',nb channel:' + config.channelCount);
      }
      frameIndex = 0;
      frameDuration = 1024 * 90000 / track.samplerate;

      // if last AAC frame is overflowing, we should ensure timestamps are contiguous:
      // first sample PTS should be equal to last sample PTS + frameDuration
      if (aacOverFlow && aacLastPTS) {
        var newPTS = aacLastPTS + frameDuration;
        if (Math.abs(newPTS - pts) > 1) {
          _logger.logger.log('AAC: align PTS for overlapping frames by ' + Math.round((newPTS - pts) / 90));
          pts = newPTS;
        }
      }

      while (offset + 5 < len) {
        // The protection skip bit tells us if we have 2 bytes of CRC data at the end of the ADTS header
        headerLength = !!(data[offset + 1] & 0x01) ? 7 : 9;
        // retrieve frame size
        frameLength = (data[offset + 3] & 0x03) << 11 | data[offset + 4] << 3 | (data[offset + 5] & 0xE0) >>> 5;
        frameLength -= headerLength;
        //stamp = pes.pts;

        if (frameLength > 0 && offset + headerLength + frameLength <= len) {
          stamp = pts + frameIndex * frameDuration;
          //logger.log(`AAC frame, offset/length/total/pts:${offset+headerLength}/${frameLength}/${data.byteLength}/${(stamp/90).toFixed(0)}`);
          aacSample = { unit: data.subarray(offset + headerLength, offset + headerLength + frameLength), pts: stamp, dts: stamp };
          track.samples.push(aacSample);
          track.len += frameLength;
          offset += frameLength + headerLength;
          frameIndex++;
          // look for ADTS header (0xFFFx)
          for (; offset < len - 1; offset++) {
            if (data[offset] === 0xff && (data[offset + 1] & 0xf0) === 0xf0) {
              break;
            }
          }
        } else {
          break;
        }
      }
      if (offset < len) {
        aacOverFlow = data.subarray(offset, len);
        //logger.log(`AAC: overflow detected:${len-offset}`);
      } else {
        aacOverFlow = null;
      }
      this.aacOverFlow = aacOverFlow;
      this.aacLastPTS = stamp;
    }
  }, {
    key: '_parseMPEGPES',
    value: function _parseMPEGPES(pes) {
      _mpegaudio2.default.parse(this._audioTrack, pes.data, 0, pes.pts);
    }
  }, {
    key: '_parseID3PES',
    value: function _parseID3PES(pes) {
      this._id3Track.samples.push(pes);
    }
  }], [{
    key: 'probe',
    value: function probe(data) {
      // a TS fragment should contain at least 3 TS packets, a PAT, a PMT, and one PID, each starting with 0x47
      if (data.length >= 3 * 188 && data[0] === 0x47 && data[188] === 0x47 && data[2 * 188] === 0x47) {
        return true;
      } else {
        return false;
      }
    }
  }]);

  return TSDemuxer;
}();

exports.default = TSDemuxer;

/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 *  AAC helper
 */

var AAC = function () {
  function AAC() {
    _classCallCheck(this, AAC);
  }

  _createClass(AAC, null, [{
    key: 'getSilentFrame',
    value: function getSilentFrame(codec, channelCount) {
      switch (codec) {
        case 'mp4a.40.2':
          if (channelCount === 1) {
            return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x23, 0x80]);
          } else if (channelCount === 2) {
            return new Uint8Array([0x21, 0x00, 0x49, 0x90, 0x02, 0x19, 0x00, 0x23, 0x80]);
          } else if (channelCount === 3) {
            return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x20, 0x84, 0x01, 0x26, 0x40, 0x08, 0x64, 0x00, 0x8e]);
          } else if (channelCount === 4) {
            return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x20, 0x84, 0x01, 0x26, 0x40, 0x08, 0x64, 0x00, 0x80, 0x2c, 0x80, 0x08, 0x02, 0x38]);
          } else if (channelCount === 5) {
            return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x20, 0x84, 0x01, 0x26, 0x40, 0x08, 0x64, 0x00, 0x82, 0x30, 0x04, 0x99, 0x00, 0x21, 0x90, 0x02, 0x38]);
          } else if (channelCount === 6) {
            return new Uint8Array([0x00, 0xc8, 0x00, 0x80, 0x20, 0x84, 0x01, 0x26, 0x40, 0x08, 0x64, 0x00, 0x82, 0x30, 0x04, 0x99, 0x00, 0x21, 0x90, 0x02, 0x00, 0xb2, 0x00, 0x20, 0x08, 0xe0]);
          }
          break;
        // handle HE-AAC below (mp4a.40.5 / mp4a.40.29)
        default:
          if (channelCount === 1) {
            // ffmpeg -y -f lavfi -i "aevalsrc=0:d=0.05" -c:a libfdk_aac -profile:a aac_he -b:a 4k output.aac && hexdump -v -e '16/1 "0x%x," "\n"' -v output.aac
            return new Uint8Array([0x1, 0x40, 0x22, 0x80, 0xa3, 0x4e, 0xe6, 0x80, 0xba, 0x8, 0x0, 0x0, 0x0, 0x1c, 0x6, 0xf1, 0xc1, 0xa, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5e]);
          } else if (channelCount === 2) {
            // ffmpeg -y -f lavfi -i "aevalsrc=0|0:d=0.05" -c:a libfdk_aac -profile:a aac_he_v2 -b:a 4k output.aac && hexdump -v -e '16/1 "0x%x," "\n"' -v output.aac
            return new Uint8Array([0x1, 0x40, 0x22, 0x80, 0xa3, 0x5e, 0xe6, 0x80, 0xba, 0x8, 0x0, 0x0, 0x0, 0x0, 0x95, 0x0, 0x6, 0xf1, 0xa1, 0xa, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5e]);
          } else if (channelCount === 3) {
            // ffmpeg -y -f lavfi -i "aevalsrc=0|0|0:d=0.05" -c:a libfdk_aac -profile:a aac_he_v2 -b:a 4k output.aac && hexdump -v -e '16/1 "0x%x," "\n"' -v output.aac
            return new Uint8Array([0x1, 0x40, 0x22, 0x80, 0xa3, 0x5e, 0xe6, 0x80, 0xba, 0x8, 0x0, 0x0, 0x0, 0x0, 0x95, 0x0, 0x6, 0xf1, 0xa1, 0xa, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5a, 0x5e]);
          }
          break;
      }
      return null;
    }
  }]);

  return AAC;
}();

exports.default = AAC;

/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * HLS interface
 */


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _urlToolkit = __webpack_require__(614);

var _urlToolkit2 = _interopRequireDefault(_urlToolkit);

var _events = __webpack_require__(39);

var _events2 = _interopRequireDefault(_events);

var _errors = __webpack_require__(63);

var _playlistLoader = __webpack_require__(1466);

var _playlistLoader2 = _interopRequireDefault(_playlistLoader);

var _fragmentLoader = __webpack_require__(1464);

var _fragmentLoader2 = _interopRequireDefault(_fragmentLoader);

var _keyLoader = __webpack_require__(1465);

var _keyLoader2 = _interopRequireDefault(_keyLoader);

var _streamController = __webpack_require__(1447);

var _streamController2 = _interopRequireDefault(_streamController);

var _levelController = __webpack_require__(1446);

var _levelController2 = _interopRequireDefault(_levelController);

var _id3TrackController = __webpack_require__(1445);

var _id3TrackController2 = _interopRequireDefault(_id3TrackController);

var _logger = __webpack_require__(31);

var _events3 = __webpack_require__(410);

var _events4 = _interopRequireDefault(_events3);

var _config = __webpack_require__(1438);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Hls = function () {
  _createClass(Hls, null, [{
    key: 'isSupported',
    value: function isSupported() {
      window.MediaSource = window.MediaSource || window.WebKitMediaSource;
      window.SourceBuffer = window.SourceBuffer || window.WebKitSourceBuffer;

      var isTypeSupported = window.MediaSource && typeof window.MediaSource.isTypeSupported === 'function' && window.MediaSource.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"');
      var hasSupportedSourceBuffer = window.SourceBuffer && window.SourceBuffer.prototype && typeof window.SourceBuffer.prototype.appendBuffer === 'function' && typeof window.SourceBuffer.prototype.remove === 'function';
      var isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1;

      // safari does not expose SourceBuffer globally so checking SourceBuffer.prototype is impossible
      return isTypeSupported && (hasSupportedSourceBuffer || isSafari);
    }
  }, {
    key: 'version',
    get: function get() {
      // replaced with browserify-versionify transform
      return '__VERSION__';
    }
  }, {
    key: 'Events',
    get: function get() {
      return _events2.default;
    }
  }, {
    key: 'ErrorTypes',
    get: function get() {
      return _errors.ErrorTypes;
    }
  }, {
    key: 'ErrorDetails',
    get: function get() {
      return _errors.ErrorDetails;
    }
  }, {
    key: 'DefaultConfig',
    get: function get() {
      if (!Hls.defaultConfig) {
        return _config.hlsDefaultConfig;
      }
      return Hls.defaultConfig;
    },
    set: function set(defaultConfig) {
      Hls.defaultConfig = defaultConfig;
    }
  }]);

  function Hls() {
    var _this = this;

    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Hls);

    var defaultConfig = Hls.DefaultConfig;

    if ((config.liveSyncDurationCount || config.liveMaxLatencyDurationCount) && (config.liveSyncDuration || config.liveMaxLatencyDuration)) {
      throw new Error('Illegal hls.js config: don\'t mix up liveSyncDurationCount/liveMaxLatencyDurationCount and liveSyncDuration/liveMaxLatencyDuration');
    }

    for (var prop in defaultConfig) {
      if (prop in config) {
        continue;
      }
      config[prop] = defaultConfig[prop];
    }

    if (config.liveMaxLatencyDurationCount !== undefined && config.liveMaxLatencyDurationCount <= config.liveSyncDurationCount) {
      throw new Error('Illegal hls.js config: "liveMaxLatencyDurationCount" must be gt "liveSyncDurationCount"');
    }

    if (config.liveMaxLatencyDuration !== undefined && (config.liveMaxLatencyDuration <= config.liveSyncDuration || config.liveSyncDuration === undefined)) {
      throw new Error('Illegal hls.js config: "liveMaxLatencyDuration" must be gt "liveSyncDuration"');
    }

    (0, _logger.enableLogs)(config.debug);
    this.config = config;
    this._autoLevelCapping = -1;
    // observer setup
    var observer = this.observer = new _events4.default();
    observer.trigger = function trigger(event) {
      for (var _len = arguments.length, data = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        data[_key - 1] = arguments[_key];
      }

      observer.emit.apply(observer, [event, event].concat(data));
    };

    observer.off = function off(event) {
      for (var _len2 = arguments.length, data = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        data[_key2 - 1] = arguments[_key2];
      }

      observer.removeListener.apply(observer, [event].concat(data));
    };
    this.on = observer.on.bind(observer);
    this.off = observer.off.bind(observer);
    this.trigger = observer.trigger.bind(observer);

    // core controllers and network loaders
    var abrController = this.abrController = new config.abrController(this);
    var bufferController = new config.bufferController(this);
    var capLevelController = new config.capLevelController(this);
    var fpsController = new config.fpsController(this);
    var playListLoader = new _playlistLoader2.default(this);
    var fragmentLoader = new _fragmentLoader2.default(this);
    var keyLoader = new _keyLoader2.default(this);
    var id3TrackController = new _id3TrackController2.default(this);

    // network controllers
    var levelController = this.levelController = new _levelController2.default(this);
    var streamController = this.streamController = new _streamController2.default(this);
    var networkControllers = [levelController, streamController];

    // optional audio stream controller
    var Controller = config.audioStreamController;
    if (Controller) {
      networkControllers.push(new Controller(this));
    }
    this.networkControllers = networkControllers;

    var coreComponents = [playListLoader, fragmentLoader, keyLoader, abrController, bufferController, capLevelController, fpsController, id3TrackController];

    // optional audio track and subtitle controller
    Controller = config.audioTrackController;
    if (Controller) {
      var audioTrackController = new Controller(this);
      this.audioTrackController = audioTrackController;
      coreComponents.push(audioTrackController);
    }

    Controller = config.subtitleTrackController;
    if (Controller) {
      var subtitleTrackController = new Controller(this);
      this.subtitleTrackController = subtitleTrackController;
      coreComponents.push(subtitleTrackController);
    }

    // optional subtitle controller
    [config.subtitleStreamController, config.timelineController].forEach(function (Controller) {
      if (Controller) {
        coreComponents.push(new Controller(_this));
      }
    });
    this.coreComponents = coreComponents;
  }

  _createClass(Hls, [{
    key: 'destroy',
    value: function destroy() {
      _logger.logger.log('destroy');
      this.trigger(_events2.default.DESTROYING);
      this.detachMedia();
      this.coreComponents.concat(this.networkControllers).forEach(function (component) {
        component.destroy();
      });
      this.url = null;
      this.observer.removeAllListeners();
      this._autoLevelCapping = -1;
    }
  }, {
    key: 'attachMedia',
    value: function attachMedia(media) {
      _logger.logger.log('attachMedia');
      this.media = media;
      this.trigger(_events2.default.MEDIA_ATTACHING, { media: media });
    }
  }, {
    key: 'detachMedia',
    value: function detachMedia() {
      _logger.logger.log('detachMedia');
      this.trigger(_events2.default.MEDIA_DETACHING);
      this.media = null;
    }
  }, {
    key: 'loadSource',
    value: function loadSource(url) {
      url = _urlToolkit2.default.buildAbsoluteURL(window.location.href, url, { alwaysNormalize: true });
      _logger.logger.log('loadSource:' + url);
      this.url = url;
      // when attaching to a source URL, trigger a playlist load
      this.trigger(_events2.default.MANIFEST_LOADING, { url: url });
    }
  }, {
    key: 'startLoad',
    value: function startLoad() {
      var startPosition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;

      _logger.logger.log('startLoad(' + startPosition + ')');
      this.networkControllers.forEach(function (controller) {
        controller.startLoad(startPosition);
      });
    }
  }, {
    key: 'stopLoad',
    value: function stopLoad() {
      _logger.logger.log('stopLoad');
      this.networkControllers.forEach(function (controller) {
        controller.stopLoad();
      });
    }
  }, {
    key: 'swapAudioCodec',
    value: function swapAudioCodec() {
      _logger.logger.log('swapAudioCodec');
      this.streamController.swapAudioCodec();
    }
  }, {
    key: 'recoverMediaError',
    value: function recoverMediaError() {
      _logger.logger.log('recoverMediaError');
      var media = this.media;
      this.detachMedia();
      this.attachMedia(media);
    }

    /** Return all quality levels **/

  }, {
    key: 'levels',
    get: function get() {
      return this.levelController.levels;
    }

    /** Return current playback quality level **/

  }, {
    key: 'currentLevel',
    get: function get() {
      return this.streamController.currentLevel;
    }

    /* set quality level immediately (-1 for automatic level selection) */
    ,
    set: function set(newLevel) {
      _logger.logger.log('set currentLevel:' + newLevel);
      this.loadLevel = newLevel;
      this.streamController.immediateLevelSwitch();
    }

    /** Return next playback quality level (quality level of next fragment) **/

  }, {
    key: 'nextLevel',
    get: function get() {
      return this.streamController.nextLevel;
    }

    /* set quality level for next fragment (-1 for automatic level selection) */
    ,
    set: function set(newLevel) {
      _logger.logger.log('set nextLevel:' + newLevel);
      this.levelController.manualLevel = newLevel;
      this.streamController.nextLevelSwitch();
    }

    /** Return the quality level of current/last loaded fragment **/

  }, {
    key: 'loadLevel',
    get: function get() {
      return this.levelController.level;
    }

    /* set quality level for current/next loaded fragment (-1 for automatic level selection) */
    ,
    set: function set(newLevel) {
      _logger.logger.log('set loadLevel:' + newLevel);
      this.levelController.manualLevel = newLevel;
    }

    /** Return the quality level of next loaded fragment **/

  }, {
    key: 'nextLoadLevel',
    get: function get() {
      return this.levelController.nextLoadLevel;
    }

    /** set quality level of next loaded fragment **/
    ,
    set: function set(level) {
      this.levelController.nextLoadLevel = level;
    }

    /** Return first level (index of first level referenced in manifest)
    **/

  }, {
    key: 'firstLevel',
    get: function get() {
      return Math.max(this.levelController.firstLevel, this.minAutoLevel);
    }

    /** set first level (index of first level referenced in manifest)
    **/
    ,
    set: function set(newLevel) {
      _logger.logger.log('set firstLevel:' + newLevel);
      this.levelController.firstLevel = newLevel;
    }

    /** Return start level (level of first fragment that will be played back)
        if not overrided by user, first level appearing in manifest will be used as start level
        if -1 : automatic start level selection, playback will start from level matching download bandwidth (determined from download of first segment)
    **/

  }, {
    key: 'startLevel',
    get: function get() {
      return this.levelController.startLevel;
    }

    /** set  start level (level of first fragment that will be played back)
        if not overrided by user, first level appearing in manifest will be used as start level
        if -1 : automatic start level selection, playback will start from level matching download bandwidth (determined from download of first segment)
    **/
    ,
    set: function set(newLevel) {
      _logger.logger.log('set startLevel:' + newLevel);
      var hls = this;
      // if not in automatic start level detection, ensure startLevel is greater than minAutoLevel
      if (newLevel !== -1) {
        newLevel = Math.max(newLevel, hls.minAutoLevel);
      }
      hls.levelController.startLevel = newLevel;
    }

    /** Return the capping/max level value that could be used by automatic level selection algorithm **/

  }, {
    key: 'autoLevelCapping',
    get: function get() {
      return this._autoLevelCapping;
    }

    /** set the capping/max level value that could be used by automatic level selection algorithm **/
    ,
    set: function set(newLevel) {
      _logger.logger.log('set autoLevelCapping:' + newLevel);
      this._autoLevelCapping = newLevel;
    }

    /* check if we are in automatic level selection mode */

  }, {
    key: 'autoLevelEnabled',
    get: function get() {
      return this.levelController.manualLevel === -1;
    }

    /* return manual level */

  }, {
    key: 'manualLevel',
    get: function get() {
      return this.levelController.manualLevel;
    }

    /* return min level selectable in auto mode according to config.minAutoBitrate */

  }, {
    key: 'minAutoLevel',
    get: function get() {
      var hls = this,
          levels = hls.levels,
          minAutoBitrate = hls.config.minAutoBitrate,
          len = levels ? levels.length : 0;
      for (var i = 0; i < len; i++) {
        var levelNextBitrate = levels[i].realBitrate ? Math.max(levels[i].realBitrate, levels[i].bitrate) : levels[i].bitrate;
        if (levelNextBitrate > minAutoBitrate) {
          return i;
        }
      }
      return 0;
    }

    /* return max level selectable in auto mode according to autoLevelCapping */

  }, {
    key: 'maxAutoLevel',
    get: function get() {
      var hls = this;
      var levels = hls.levels;
      var autoLevelCapping = hls.autoLevelCapping;
      var maxAutoLevel = void 0;
      if (autoLevelCapping === -1 && levels && levels.length) {
        maxAutoLevel = levels.length - 1;
      } else {
        maxAutoLevel = autoLevelCapping;
      }
      return maxAutoLevel;
    }

    // return next auto level

  }, {
    key: 'nextAutoLevel',
    get: function get() {
      var hls = this;
      // ensure next auto level is between  min and max auto level
      return Math.min(Math.max(hls.abrController.nextAutoLevel, hls.minAutoLevel), hls.maxAutoLevel);
    }

    // this setter is used to force next auto level
    // this is useful to force a switch down in auto mode : in case of load error on level N, hls.js can set nextAutoLevel to N-1 for example)
    // forced value is valid for one fragment. upon succesful frag loading at forced level, this value will be resetted to -1 by ABR controller
    ,
    set: function set(nextLevel) {
      var hls = this;
      hls.abrController.nextAutoLevel = Math.max(hls.minAutoLevel, nextLevel);
    }

    /** get alternate audio tracks list from playlist **/

  }, {
    key: 'audioTracks',
    get: function get() {
      var audioTrackController = this.audioTrackController;
      return audioTrackController ? audioTrackController.audioTracks : [];
    }

    /** get index of the selected audio track (index in audio track lists) **/

  }, {
    key: 'audioTrack',
    get: function get() {
      var audioTrackController = this.audioTrackController;
      return audioTrackController ? audioTrackController.audioTrack : -1;
    }

    /** select an audio track, based on its index in audio track lists**/
    ,
    set: function set(audioTrackId) {
      var audioTrackController = this.audioTrackController;
      if (audioTrackController) {
        audioTrackController.audioTrack = audioTrackId;
      }
    }
  }, {
    key: 'liveSyncPosition',
    get: function get() {
      return this.streamController.liveSyncPosition;
    }

    /** get alternate subtitle tracks list from playlist **/

  }, {
    key: 'subtitleTracks',
    get: function get() {
      var subtitleTrackController = this.subtitleTrackController;
      return subtitleTrackController ? subtitleTrackController.subtitleTracks : [];
    }

    /** get index of the selected subtitle track (index in subtitle track lists) **/

  }, {
    key: 'subtitleTrack',
    get: function get() {
      var subtitleTrackController = this.subtitleTrackController;
      return subtitleTrackController ? subtitleTrackController.subtitleTrack : -1;
    }

    /** select an subtitle track, based on its index in subtitle track lists**/
    ,
    set: function set(subtitleTrackId) {
      var subtitleTrackController = this.subtitleTrackController;
      if (subtitleTrackController) {
        subtitleTrackController.subtitleTrack = subtitleTrackId;
      }
    }
  }]);

  return Hls;
}();

exports.default = Hls;

/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// This is mostly for support of the es6 module export
// syntax with the babel compiler, it looks like it doesnt support
// function exports like we are used to in node/commonjs
module.exports = __webpack_require__(1462).default;

/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events = __webpack_require__(39);

var _events2 = _interopRequireDefault(_events);

var _eventHandler = __webpack_require__(68);

var _eventHandler2 = _interopRequireDefault(_eventHandler);

var _errors = __webpack_require__(63);

var _logger = __webpack_require__(31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Fragment Loader
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */

var FragmentLoader = function (_EventHandler) {
  _inherits(FragmentLoader, _EventHandler);

  function FragmentLoader(hls) {
    _classCallCheck(this, FragmentLoader);

    var _this = _possibleConstructorReturn(this, (FragmentLoader.__proto__ || Object.getPrototypeOf(FragmentLoader)).call(this, hls, _events2.default.FRAG_LOADING));

    _this.loaders = {};
    return _this;
  }

  _createClass(FragmentLoader, [{
    key: 'destroy',
    value: function destroy() {
      var loaders = this.loaders;
      for (var loaderName in loaders) {
        var loader = loaders[loaderName];
        if (loader) {
          loader.destroy();
        }
      }
      this.loaders = {};
      _eventHandler2.default.prototype.destroy.call(this);
    }
  }, {
    key: 'onFragLoading',
    value: function onFragLoading(data) {
      var frag = data.frag,
          type = frag.type,
          loader = this.loaders[type],
          config = this.hls.config;

      frag.loaded = 0;
      if (loader) {
        _logger.logger.warn('abort previous fragment loader for type:' + type);
        loader.abort();
      }
      loader = this.loaders[type] = frag.loader = typeof config.fLoader !== 'undefined' ? new config.fLoader(config) : new config.loader(config);

      var loaderContext = void 0,
          loaderConfig = void 0,
          loaderCallbacks = void 0;
      loaderContext = { url: frag.url, frag: frag, responseType: 'arraybuffer', progressData: false };
      var start = frag.byteRangeStartOffset,
          end = frag.byteRangeEndOffset;
      if (!isNaN(start) && !isNaN(end)) {
        loaderContext.rangeStart = start;
        loaderContext.rangeEnd = end;
      }
      loaderConfig = { timeout: config.fragLoadingTimeOut, maxRetry: 0, retryDelay: 0, maxRetryDelay: config.fragLoadingMaxRetryTimeout };
      loaderCallbacks = { onSuccess: this.loadsuccess.bind(this), onError: this.loaderror.bind(this), onTimeout: this.loadtimeout.bind(this), onProgress: this.loadprogress.bind(this) };
      loader.load(loaderContext, loaderConfig, loaderCallbacks);
    }
  }, {
    key: 'loadsuccess',
    value: function loadsuccess(response, stats, context) {
      var payload = response.data,
          frag = context.frag;
      // detach fragment loader on load success
      frag.loader = undefined;
      this.loaders[frag.type] = undefined;
      this.hls.trigger(_events2.default.FRAG_LOADED, { payload: payload, frag: frag, stats: stats });
    }
  }, {
    key: 'loaderror',
    value: function loaderror(response, context) {
      var loader = context.loader;
      if (loader) {
        loader.abort();
      }
      this.loaders[context.type] = undefined;
      this.hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.NETWORK_ERROR, details: _errors.ErrorDetails.FRAG_LOAD_ERROR, fatal: false, frag: context.frag, response: response });
    }
  }, {
    key: 'loadtimeout',
    value: function loadtimeout(stats, context) {
      var loader = context.loader;
      if (loader) {
        loader.abort();
      }
      this.loaders[context.type] = undefined;
      this.hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.NETWORK_ERROR, details: _errors.ErrorDetails.FRAG_LOAD_TIMEOUT, fatal: false, frag: context.frag });
    }

    // data will be used for progressive parsing

  }, {
    key: 'loadprogress',
    value: function loadprogress(stats, context, data) {
      // jshint ignore:line
      var frag = context.frag;
      frag.loaded = stats.loaded;
      this.hls.trigger(_events2.default.FRAG_LOAD_PROGRESS, { frag: frag, stats: stats });
    }
  }]);

  return FragmentLoader;
}(_eventHandler2.default);

exports.default = FragmentLoader;

/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events = __webpack_require__(39);

var _events2 = _interopRequireDefault(_events);

var _eventHandler = __webpack_require__(68);

var _eventHandler2 = _interopRequireDefault(_eventHandler);

var _errors = __webpack_require__(63);

var _logger = __webpack_require__(31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Decrypt key Loader
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */

var KeyLoader = function (_EventHandler) {
  _inherits(KeyLoader, _EventHandler);

  function KeyLoader(hls) {
    _classCallCheck(this, KeyLoader);

    var _this = _possibleConstructorReturn(this, (KeyLoader.__proto__ || Object.getPrototypeOf(KeyLoader)).call(this, hls, _events2.default.KEY_LOADING));

    _this.loaders = {};
    _this.decryptkey = null;
    _this.decrypturl = null;
    return _this;
  }

  _createClass(KeyLoader, [{
    key: 'destroy',
    value: function destroy() {
      for (var loaderName in this.loaders) {
        var loader = this.loaders[loaderName];
        if (loader) {
          loader.destroy();
        }
      }
      this.loaders = {};
      _eventHandler2.default.prototype.destroy.call(this);
    }
  }, {
    key: 'onKeyLoading',
    value: function onKeyLoading(data) {
      var frag = data.frag,
          type = frag.type,
          loader = this.loaders[type],
          decryptdata = frag.decryptdata,
          uri = decryptdata.uri;
      // if uri is different from previous one or if decrypt key not retrieved yet
      if (uri !== this.decrypturl || this.decryptkey === null) {
        var config = this.hls.config;

        if (loader) {
          _logger.logger.warn('abort previous key loader for type:' + type);
          loader.abort();
        }
        frag.loader = this.loaders[type] = new config.loader(config);
        this.decrypturl = uri;
        this.decryptkey = null;

        var loaderContext = void 0,
            loaderConfig = void 0,
            loaderCallbacks = void 0;
        loaderContext = { url: uri, frag: frag, responseType: 'arraybuffer' };
        loaderConfig = { timeout: config.fragLoadingTimeOut, maxRetry: config.fragLoadingMaxRetry, retryDelay: config.fragLoadingRetryDelay, maxRetryDelay: config.fragLoadingMaxRetryTimeout };
        loaderCallbacks = { onSuccess: this.loadsuccess.bind(this), onError: this.loaderror.bind(this), onTimeout: this.loadtimeout.bind(this) };
        frag.loader.load(loaderContext, loaderConfig, loaderCallbacks);
      } else if (this.decryptkey) {
        // we already loaded this key, return it
        decryptdata.key = this.decryptkey;
        this.hls.trigger(_events2.default.KEY_LOADED, { frag: frag });
      }
    }
  }, {
    key: 'loadsuccess',
    value: function loadsuccess(response, stats, context) {
      var frag = context.frag;
      this.decryptkey = frag.decryptdata.key = new Uint8Array(response.data);
      // detach fragment loader on load success
      frag.loader = undefined;
      this.loaders[frag.type] = undefined;
      this.hls.trigger(_events2.default.KEY_LOADED, { frag: frag });
    }
  }, {
    key: 'loaderror',
    value: function loaderror(response, context) {
      var frag = context.frag,
          loader = frag.loader;
      if (loader) {
        loader.abort();
      }
      this.loaders[context.type] = undefined;
      this.hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.NETWORK_ERROR, details: _errors.ErrorDetails.KEY_LOAD_ERROR, fatal: false, frag: frag, response: response });
    }
  }, {
    key: 'loadtimeout',
    value: function loadtimeout(stats, context) {
      var frag = context.frag,
          loader = frag.loader;
      if (loader) {
        loader.abort();
      }
      this.loaders[context.type] = undefined;
      this.hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.NETWORK_ERROR, details: _errors.ErrorDetails.KEY_LOAD_TIMEOUT, fatal: false, frag: frag });
    }
  }]);

  return KeyLoader;
}(_eventHandler2.default);

exports.default = KeyLoader;

/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Playlist Loader
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     */

var _urlToolkit = __webpack_require__(614);

var _urlToolkit2 = _interopRequireDefault(_urlToolkit);

var _events = __webpack_require__(39);

var _events2 = _interopRequireDefault(_events);

var _eventHandler = __webpack_require__(68);

var _eventHandler2 = _interopRequireDefault(_eventHandler);

var _errors = __webpack_require__(63);

var _attrList = __webpack_require__(1470);

var _attrList2 = _interopRequireDefault(_attrList);

var _logger = __webpack_require__(31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// https://regex101.com is your friend
var MASTER_PLAYLIST_REGEX = /#EXT-X-STREAM-INF:([^\n\r]*)[\r\n]+([^\r\n]+)/g;
var MASTER_PLAYLIST_MEDIA_REGEX = /#EXT-X-MEDIA:(.*)/g;
var LEVEL_PLAYLIST_REGEX_FAST = /#EXTINF:(\d*(?:\.\d+)?)(?:,(.*))?|(?!#)(\S.+)|#EXT-X-BYTERANGE: *(.+)|#EXT-X-PROGRAM-DATE-TIME:(.+)|#.*/g;
var LEVEL_PLAYLIST_REGEX_SLOW = /(?:(?:#(EXTM3U))|(?:#EXT-X-(PLAYLIST-TYPE):(.+))|(?:#EXT-X-(MEDIA-SEQUENCE): *(\d+))|(?:#EXT-X-(TARGETDURATION): *(\d+))|(?:#EXT-X-(KEY):(.+))|(?:#EXT-X-(START):(.+))|(?:#EXT-X-(ENDLIST))|(?:#EXT-X-(DISCONTINUITY-SEQ)UENCE:(\d+))|(?:#EXT-X-(DIS)CONTINUITY))|(?:#EXT-X-(VERSION):(\d+))|(?:#EXT-X-(MAP):(.+))|(?:(#)(.*):(.*))|(?:(#)(.*))(?:.*)\r?\n?/;

var LevelKey = function () {
  function LevelKey() {
    _classCallCheck(this, LevelKey);

    this.method = null;
    this.key = null;
    this.iv = null;
    this._uri = null;
  }

  _createClass(LevelKey, [{
    key: 'uri',
    get: function get() {
      if (!this._uri && this.reluri) {
        this._uri = _urlToolkit2.default.buildAbsoluteURL(this.baseuri, this.reluri, { alwaysNormalize: true });
      }
      return this._uri;
    }
  }]);

  return LevelKey;
}();

var Fragment = function () {
  function Fragment() {
    _classCallCheck(this, Fragment);

    this._url = null;
    this._byteRange = null;
    this._decryptdata = null;
    this.tagList = [];
  }

  _createClass(Fragment, [{
    key: 'createInitializationVector',


    /**
     * Utility method for parseLevelPlaylist to create an initialization vector for a given segment
     * @returns {Uint8Array}
     */
    value: function createInitializationVector(segmentNumber) {
      var uint8View = new Uint8Array(16);

      for (var i = 12; i < 16; i++) {
        uint8View[i] = segmentNumber >> 8 * (15 - i) & 0xff;
      }

      return uint8View;
    }

    /**
     * Utility method for parseLevelPlaylist to get a fragment's decryption data from the currently parsed encryption key data
     * @param levelkey - a playlist's encryption info
     * @param segmentNumber - the fragment's segment number
     * @returns {*} - an object to be applied as a fragment's decryptdata
     */

  }, {
    key: 'fragmentDecryptdataFromLevelkey',
    value: function fragmentDecryptdataFromLevelkey(levelkey, segmentNumber) {
      var decryptdata = levelkey;

      if (levelkey && levelkey.method && levelkey.uri && !levelkey.iv) {
        decryptdata = new LevelKey();
        decryptdata.method = levelkey.method;
        decryptdata.baseuri = levelkey.baseuri;
        decryptdata.reluri = levelkey.reluri;
        decryptdata.iv = this.createInitializationVector(segmentNumber);
      }

      return decryptdata;
    }
  }, {
    key: 'cloneObj',
    value: function cloneObj(obj) {
      return JSON.parse(JSON.stringify(obj));
    }
  }, {
    key: 'url',
    get: function get() {
      if (!this._url && this.relurl) {
        this._url = _urlToolkit2.default.buildAbsoluteURL(this.baseurl, this.relurl, { alwaysNormalize: true });
      }
      return this._url;
    },
    set: function set(value) {
      this._url = value;
    }
  }, {
    key: 'programDateTime',
    get: function get() {
      if (!this._programDateTime && this.rawProgramDateTime) {
        this._programDateTime = new Date(Date.parse(this.rawProgramDateTime));
      }
      return this._programDateTime;
    }
  }, {
    key: 'byteRange',
    get: function get() {
      if (!this._byteRange) {
        var byteRange = this._byteRange = [];
        if (this.rawByteRange) {
          var params = this.rawByteRange.split('@', 2);
          if (params.length === 1) {
            var lastByteRangeEndOffset = this.lastByteRangeEndOffset;
            byteRange[0] = lastByteRangeEndOffset ? lastByteRangeEndOffset : 0;
          } else {
            byteRange[0] = parseInt(params[1]);
          }
          byteRange[1] = parseInt(params[0]) + byteRange[0];
        }
      }
      return this._byteRange;
    }
  }, {
    key: 'byteRangeStartOffset',
    get: function get() {
      return this.byteRange[0];
    }
  }, {
    key: 'byteRangeEndOffset',
    get: function get() {
      return this.byteRange[1];
    }
  }, {
    key: 'decryptdata',
    get: function get() {
      if (!this._decryptdata) {
        this._decryptdata = this.fragmentDecryptdataFromLevelkey(this.levelkey, this.sn);
      }
      return this._decryptdata;
    }
  }]);

  return Fragment;
}();

var PlaylistLoader = function (_EventHandler) {
  _inherits(PlaylistLoader, _EventHandler);

  function PlaylistLoader(hls) {
    _classCallCheck(this, PlaylistLoader);

    var _this = _possibleConstructorReturn(this, (PlaylistLoader.__proto__ || Object.getPrototypeOf(PlaylistLoader)).call(this, hls, _events2.default.MANIFEST_LOADING, _events2.default.LEVEL_LOADING, _events2.default.AUDIO_TRACK_LOADING, _events2.default.SUBTITLE_TRACK_LOADING));

    _this.loaders = {};
    return _this;
  }

  _createClass(PlaylistLoader, [{
    key: 'destroy',
    value: function destroy() {
      for (var loaderName in this.loaders) {
        var loader = this.loaders[loaderName];
        if (loader) {
          loader.destroy();
        }
      }
      this.loaders = {};
      _eventHandler2.default.prototype.destroy.call(this);
    }
  }, {
    key: 'onManifestLoading',
    value: function onManifestLoading(data) {
      this.load(data.url, { type: 'manifest' });
    }
  }, {
    key: 'onLevelLoading',
    value: function onLevelLoading(data) {
      this.load(data.url, { type: 'level', level: data.level, id: data.id });
    }
  }, {
    key: 'onAudioTrackLoading',
    value: function onAudioTrackLoading(data) {
      this.load(data.url, { type: 'audioTrack', id: data.id });
    }
  }, {
    key: 'onSubtitleTrackLoading',
    value: function onSubtitleTrackLoading(data) {
      this.load(data.url, { type: 'subtitleTrack', id: data.id });
    }
  }, {
    key: 'load',
    value: function load(url, context) {
      var loader = this.loaders[context.type];
      if (loader) {
        var loaderContext = loader.context;
        if (loaderContext && loaderContext.url === url) {
          _logger.logger.trace('playlist request ongoing');
          return;
        } else {
          _logger.logger.warn('abort previous loader for type:' + context.type);
          loader.abort();
        }
      }
      var config = this.hls.config,
          retry = void 0,
          timeout = void 0,
          retryDelay = void 0,
          maxRetryDelay = void 0;
      if (context.type === 'manifest') {
        retry = config.manifestLoadingMaxRetry;
        timeout = config.manifestLoadingTimeOut;
        retryDelay = config.manifestLoadingRetryDelay;
        maxRetryDelay = config.manifestLoadingMaxRetryTimeout;
      } else {
        retry = config.levelLoadingMaxRetry;
        timeout = config.levelLoadingTimeOut;
        retryDelay = config.levelLoadingRetryDelay;
        maxRetryDelay = config.levelLoadingMaxRetryTimeout;
        _logger.logger.log('loading playlist for ' + context.type + ' ' + (context.level || context.id));
      }
      loader = this.loaders[context.type] = context.loader = typeof config.pLoader !== 'undefined' ? new config.pLoader(config) : new config.loader(config);
      context.url = url;
      context.responseType = '';

      var loaderConfig = void 0,
          loaderCallbacks = void 0;
      loaderConfig = { timeout: timeout, maxRetry: retry, retryDelay: retryDelay, maxRetryDelay: maxRetryDelay };
      loaderCallbacks = { onSuccess: this.loadsuccess.bind(this), onError: this.loaderror.bind(this), onTimeout: this.loadtimeout.bind(this) };
      loader.load(context, loaderConfig, loaderCallbacks);
    }
  }, {
    key: 'resolve',
    value: function resolve(url, baseUrl) {
      return _urlToolkit2.default.buildAbsoluteURL(baseUrl, url, { alwaysNormalize: true });
    }
  }, {
    key: 'parseMasterPlaylist',
    value: function parseMasterPlaylist(string, baseurl) {
      var levels = [],
          result = void 0;
      MASTER_PLAYLIST_REGEX.lastIndex = 0;
      while ((result = MASTER_PLAYLIST_REGEX.exec(string)) != null) {
        var level = {};

        var attrs = level.attrs = new _attrList2.default(result[1]);
        level.url = this.resolve(result[2], baseurl);

        var resolution = attrs.decimalResolution('RESOLUTION');
        if (resolution) {
          level.width = resolution.width;
          level.height = resolution.height;
        }
        level.bitrate = attrs.decimalInteger('AVERAGE-BANDWIDTH') || attrs.decimalInteger('BANDWIDTH');
        level.name = attrs.NAME;

        var codecs = attrs.CODECS;
        if (codecs) {
          codecs = codecs.split(/[ ,]+/);
          for (var i = 0; i < codecs.length; i++) {
            var codec = codecs[i];
            if (codec.indexOf('avc1') !== -1) {
              level.videoCodec = this.avc1toavcoti(codec);
            } else {
              level.audioCodec = codec;
            }
          }
        }

        levels.push(level);
      }
      return levels;
    }
  }, {
    key: 'parseMasterPlaylistMedia',
    value: function parseMasterPlaylistMedia(string, baseurl, type) {
      var result = void 0,
          medias = [],
          id = 0;
      MASTER_PLAYLIST_MEDIA_REGEX.lastIndex = 0;
      while ((result = MASTER_PLAYLIST_MEDIA_REGEX.exec(string)) != null) {
        var media = {};
        var attrs = new _attrList2.default(result[1]);
        if (attrs.TYPE === type) {
          media.groupId = attrs['GROUP-ID'];
          media.name = attrs.NAME;
          media.type = type;
          media.default = attrs.DEFAULT === 'YES';
          media.autoselect = attrs.AUTOSELECT === 'YES';
          media.forced = attrs.FORCED === 'YES';
          if (attrs.URI) {
            media.url = this.resolve(attrs.URI, baseurl);
          }
          media.lang = attrs.LANGUAGE;
          if (!media.name) {
            media.name = media.lang;
          }
          media.id = id++;
          medias.push(media);
        }
      }
      return medias;
    }
  }, {
    key: 'avc1toavcoti',
    value: function avc1toavcoti(codec) {
      var result,
          avcdata = codec.split('.');
      if (avcdata.length > 2) {
        result = avcdata.shift() + '.';
        result += parseInt(avcdata.shift()).toString(16);
        result += ('000' + parseInt(avcdata.shift()).toString(16)).substr(-4);
      } else {
        result = codec;
      }
      return result;
    }
  }, {
    key: 'parseLevelPlaylist',
    value: function parseLevelPlaylist(string, baseurl, id, type) {
      var currentSN = 0,
          totalduration = 0,
          level = { type: null, version: null, url: baseurl, fragments: [], live: true, startSN: 0 },
          levelkey = new LevelKey(),
          cc = 0,
          prevFrag = null,
          frag = new Fragment(),
          result,
          i;

      LEVEL_PLAYLIST_REGEX_FAST.lastIndex = 0;

      while ((result = LEVEL_PLAYLIST_REGEX_FAST.exec(string)) !== null) {
        var duration = result[1];
        if (duration) {
          // INF
          frag.duration = parseFloat(duration);
          // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
          var title = (' ' + result[2]).slice(1);
          frag.title = title ? title : null;
          frag.tagList.push(title ? ['INF', duration, title] : ['INF', duration]);
        } else if (result[3]) {
          // url
          if (!isNaN(frag.duration)) {
            var sn = currentSN++;
            frag.type = type;
            frag.start = totalduration;
            frag.levelkey = levelkey;
            frag.sn = sn;
            frag.level = id;
            frag.cc = cc;
            frag.baseurl = baseurl;
            // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
            frag.relurl = (' ' + result[3]).slice(1);

            level.fragments.push(frag);
            prevFrag = frag;
            totalduration += frag.duration;

            frag = new Fragment();
          }
        } else if (result[4]) {
          // X-BYTERANGE
          frag.rawByteRange = (' ' + result[4]).slice(1);
          if (prevFrag) {
            var lastByteRangeEndOffset = prevFrag.byteRangeEndOffset;
            if (lastByteRangeEndOffset) {
              frag.lastByteRangeEndOffset = lastByteRangeEndOffset;
            }
          }
        } else if (result[5]) {
          // PROGRAM-DATE-TIME
          // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
          frag.rawProgramDateTime = (' ' + result[5]).slice(1);
          frag.tagList.push(['PROGRAM-DATE-TIME', frag.rawProgramDateTime]);
        } else {
          result = result[0].match(LEVEL_PLAYLIST_REGEX_SLOW);
          for (i = 1; i < result.length; i++) {
            if (result[i] !== undefined) {
              break;
            }
          }

          // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
          var value1 = (' ' + result[i + 1]).slice(1);
          var value2 = (' ' + result[i + 2]).slice(1);

          switch (result[i]) {
            case '#':
              frag.tagList.push(value2 ? [value1, value2] : [value1]);
              break;
            case 'PLAYLIST-TYPE':
              level.type = value1.toUpperCase();
              break;
            case 'MEDIA-SEQUENCE':
              currentSN = level.startSN = parseInt(value1);
              break;
            case 'TARGETDURATION':
              level.targetduration = parseFloat(value1);
              break;
            case 'VERSION':
              level.version = parseInt(value1);
              break;
            case 'EXTM3U':
              break;
            case 'ENDLIST':
              level.live = false;
              break;
            case 'DIS':
              cc++;
              frag.tagList.push(['DIS']);
              break;
            case 'DISCONTINUITY-SEQ':
              cc = parseInt(value1);
              break;
            case 'KEY':
              // https://tools.ietf.org/html/draft-pantos-http-live-streaming-08#section-3.4.4
              var decryptparams = value1;
              var keyAttrs = new _attrList2.default(decryptparams);
              var decryptmethod = keyAttrs.enumeratedString('METHOD'),
                  decrypturi = keyAttrs.URI,
                  decryptiv = keyAttrs.hexadecimalInteger('IV');
              if (decryptmethod) {
                levelkey = new LevelKey();
                if (decrypturi && ['AES-128', 'SAMPLE-AES'].indexOf(decryptmethod) >= 0) {
                  levelkey.method = decryptmethod;
                  // URI to get the key
                  levelkey.baseuri = baseurl;
                  levelkey.reluri = decrypturi;
                  levelkey.key = null;
                  // Initialization Vector (IV)
                  levelkey.iv = decryptiv;
                }
              }
              break;
            case 'START':
              var startParams = value1;
              var startAttrs = new _attrList2.default(startParams);
              var startTimeOffset = startAttrs.decimalFloatingPoint('TIME-OFFSET');
              //TIME-OFFSET can be 0
              if (!isNaN(startTimeOffset)) {
                level.startTimeOffset = startTimeOffset;
              }
              break;
            case 'MAP':
              var mapAttrs = new _attrList2.default(value1);
              frag.relurl = mapAttrs.URI;
              frag.rawByteRange = mapAttrs.BYTERANGE;
              frag.baseurl = baseurl;
              frag.level = id;
              frag.type = type;
              frag.sn = 'initSegment';
              level.initSegment = frag;
              frag = new Fragment();
              break;
            default:
              _logger.logger.warn('line parsed but not handled: ' + result);
              break;
          }
        }
      }
      frag = prevFrag;
      //logger.log('found ' + level.fragments.length + ' fragments');
      if (frag && !frag.relurl) {
        level.fragments.pop();
        totalduration -= frag.duration;
      }
      level.totalduration = totalduration;
      level.averagetargetduration = totalduration / level.fragments.length;
      level.endSN = currentSN - 1;
      return level;
    }
  }, {
    key: 'loadsuccess',
    value: function loadsuccess(response, stats, context) {
      var string = response.data,
          url = response.url,
          type = context.type,
          id = context.id,
          level = context.level,
          hls = this.hls;

      this.loaders[type] = undefined;
      // responseURL not supported on some browsers (it is used to detect URL redirection)
      // data-uri mode also not supported (but no need to detect redirection)
      if (url === undefined || url.indexOf('data:') === 0) {
        // fallback to initial URL
        url = context.url;
      }
      stats.tload = performance.now();
      //stats.mtime = new Date(target.getResponseHeader('Last-Modified'));
      if (string.indexOf('#EXTM3U') === 0) {
        if (string.indexOf('#EXTINF:') > 0) {
          var isLevel = type !== 'audioTrack' && type !== 'subtitleTrack',
              levelId = !isNaN(level) ? level : !isNaN(id) ? id : 0,
              levelDetails = this.parseLevelPlaylist(string, url, levelId, type === 'audioTrack' ? 'audio' : type === 'subtitleTrack' ? 'subtitle' : 'main');
          levelDetails.tload = stats.tload;
          if (type === 'manifest') {
            // first request, stream manifest (no master playlist), fire manifest loaded event with level details
            hls.trigger(_events2.default.MANIFEST_LOADED, { levels: [{ url: url, details: levelDetails }], audioTracks: [], url: url, stats: stats });
          }
          stats.tparsed = performance.now();
          if (levelDetails.targetduration) {
            if (isLevel) {
              hls.trigger(_events2.default.LEVEL_LOADED, { details: levelDetails, level: level || 0, id: id || 0, stats: stats });
            } else {
              if (type === 'audioTrack') {
                hls.trigger(_events2.default.AUDIO_TRACK_LOADED, { details: levelDetails, id: id, stats: stats });
              } else if (type === 'subtitleTrack') {
                hls.trigger(_events2.default.SUBTITLE_TRACK_LOADED, { details: levelDetails, id: id, stats: stats });
              }
            }
          } else {
            hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.NETWORK_ERROR, details: _errors.ErrorDetails.MANIFEST_PARSING_ERROR, fatal: true, url: url, reason: 'invalid targetduration' });
          }
        } else {
          var levels = this.parseMasterPlaylist(string, url);
          // multi level playlist, parse level info
          if (levels.length) {
            var audioTracks = this.parseMasterPlaylistMedia(string, url, 'AUDIO');
            var subtitles = this.parseMasterPlaylistMedia(string, url, 'SUBTITLES');
            if (audioTracks.length) {
              // check if we have found an audio track embedded in main playlist (audio track without URI attribute)
              var embeddedAudioFound = false;
              audioTracks.forEach(function (audioTrack) {
                if (!audioTrack.url) {
                  embeddedAudioFound = true;
                }
              });
              // if no embedded audio track defined, but audio codec signaled in quality level, we need to signal this main audio track
              // this could happen with playlists with alt audio rendition in which quality levels (main) contains both audio+video. but with mixed audio track not signaled
              if (embeddedAudioFound === false && levels[0].audioCodec && !levels[0].attrs.AUDIO) {
                _logger.logger.log('audio codec signaled in quality level, but no embedded audio track signaled, create one');
                audioTracks.unshift({ type: 'main', name: 'main' });
              }
            }
            hls.trigger(_events2.default.MANIFEST_LOADED, { levels: levels, audioTracks: audioTracks, subtitles: subtitles, url: url, stats: stats });
          } else {
            hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.NETWORK_ERROR, details: _errors.ErrorDetails.MANIFEST_PARSING_ERROR, fatal: true, url: url, reason: 'no level found in manifest' });
          }
        }
      } else {
        hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.NETWORK_ERROR, details: _errors.ErrorDetails.MANIFEST_PARSING_ERROR, fatal: true, url: url, reason: 'no EXTM3U delimiter' });
      }
    }
  }, {
    key: 'loaderror',
    value: function loaderror(response, context) {
      var details,
          fatal,
          loader = context.loader;
      switch (context.type) {
        case 'manifest':
          details = _errors.ErrorDetails.MANIFEST_LOAD_ERROR;
          fatal = true;
          break;
        case 'level':
          details = _errors.ErrorDetails.LEVEL_LOAD_ERROR;
          fatal = false;
          break;
        case 'audioTrack':
          details = _errors.ErrorDetails.AUDIO_TRACK_LOAD_ERROR;
          fatal = false;
          break;
      }
      if (loader) {
        loader.abort();
        this.loaders[context.type] = undefined;
      }
      this.hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.NETWORK_ERROR, details: details, fatal: fatal, url: loader.url, loader: loader, response: response, context: context });
    }
  }, {
    key: 'loadtimeout',
    value: function loadtimeout(stats, context) {
      var details,
          fatal,
          loader = context.loader;
      switch (context.type) {
        case 'manifest':
          details = _errors.ErrorDetails.MANIFEST_LOAD_TIMEOUT;
          fatal = true;
          break;
        case 'level':
          details = _errors.ErrorDetails.LEVEL_LOAD_TIMEOUT;
          fatal = false;
          break;
        case 'audioTrack':
          details = _errors.ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT;
          fatal = false;
          break;
      }
      if (loader) {
        loader.abort();
        this.loaders[context.type] = undefined;
      }
      this.hls.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.NETWORK_ERROR, details: details, fatal: fatal, url: loader.url, loader: loader, context: context });
    }
  }]);

  return PlaylistLoader;
}(_eventHandler2.default);

exports.default = PlaylistLoader;

/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Generate MP4 Box
*/

//import Hex from '../utils/hex';

var UINT32_MAX = Math.pow(2, 32) - 1;

var MP4 = function () {
  function MP4() {
    _classCallCheck(this, MP4);
  }

  _createClass(MP4, null, [{
    key: 'init',
    value: function init() {
      MP4.types = {
        avc1: [], // codingname
        avcC: [],
        btrt: [],
        dinf: [],
        dref: [],
        esds: [],
        ftyp: [],
        hdlr: [],
        mdat: [],
        mdhd: [],
        mdia: [],
        mfhd: [],
        minf: [],
        moof: [],
        moov: [],
        mp4a: [],
        '.mp3': [],
        mvex: [],
        mvhd: [],
        pasp: [],
        sdtp: [],
        stbl: [],
        stco: [],
        stsc: [],
        stsd: [],
        stsz: [],
        stts: [],
        tfdt: [],
        tfhd: [],
        traf: [],
        trak: [],
        trun: [],
        trex: [],
        tkhd: [],
        vmhd: [],
        smhd: []
      };

      var i;
      for (i in MP4.types) {
        if (MP4.types.hasOwnProperty(i)) {
          MP4.types[i] = [i.charCodeAt(0), i.charCodeAt(1), i.charCodeAt(2), i.charCodeAt(3)];
        }
      }

      var videoHdlr = new Uint8Array([0x00, // version 0
      0x00, 0x00, 0x00, // flags
      0x00, 0x00, 0x00, 0x00, // pre_defined
      0x76, 0x69, 0x64, 0x65, // handler_type: 'vide'
      0x00, 0x00, 0x00, 0x00, // reserved
      0x00, 0x00, 0x00, 0x00, // reserved
      0x00, 0x00, 0x00, 0x00, // reserved
      0x56, 0x69, 0x64, 0x65, 0x6f, 0x48, 0x61, 0x6e, 0x64, 0x6c, 0x65, 0x72, 0x00 // name: 'VideoHandler'
      ]);

      var audioHdlr = new Uint8Array([0x00, // version 0
      0x00, 0x00, 0x00, // flags
      0x00, 0x00, 0x00, 0x00, // pre_defined
      0x73, 0x6f, 0x75, 0x6e, // handler_type: 'soun'
      0x00, 0x00, 0x00, 0x00, // reserved
      0x00, 0x00, 0x00, 0x00, // reserved
      0x00, 0x00, 0x00, 0x00, // reserved
      0x53, 0x6f, 0x75, 0x6e, 0x64, 0x48, 0x61, 0x6e, 0x64, 0x6c, 0x65, 0x72, 0x00 // name: 'SoundHandler'
      ]);

      MP4.HDLR_TYPES = {
        'video': videoHdlr,
        'audio': audioHdlr
      };

      var dref = new Uint8Array([0x00, // version 0
      0x00, 0x00, 0x00, // flags
      0x00, 0x00, 0x00, 0x01, // entry_count
      0x00, 0x00, 0x00, 0x0c, // entry_size
      0x75, 0x72, 0x6c, 0x20, // 'url' type
      0x00, // version 0
      0x00, 0x00, 0x01 // entry_flags
      ]);

      var stco = new Uint8Array([0x00, // version
      0x00, 0x00, 0x00, // flags
      0x00, 0x00, 0x00, 0x00 // entry_count
      ]);

      MP4.STTS = MP4.STSC = MP4.STCO = stco;

      MP4.STSZ = new Uint8Array([0x00, // version
      0x00, 0x00, 0x00, // flags
      0x00, 0x00, 0x00, 0x00, // sample_size
      0x00, 0x00, 0x00, 0x00]);
      MP4.VMHD = new Uint8Array([0x00, // version
      0x00, 0x00, 0x01, // flags
      0x00, 0x00, // graphicsmode
      0x00, 0x00, 0x00, 0x00, 0x00, 0x00 // opcolor
      ]);
      MP4.SMHD = new Uint8Array([0x00, // version
      0x00, 0x00, 0x00, // flags
      0x00, 0x00, // balance
      0x00, 0x00 // reserved
      ]);

      MP4.STSD = new Uint8Array([0x00, // version 0
      0x00, 0x00, 0x00, // flags
      0x00, 0x00, 0x00, 0x01]); // entry_count

      var majorBrand = new Uint8Array([105, 115, 111, 109]); // isom
      var avc1Brand = new Uint8Array([97, 118, 99, 49]); // avc1
      var minorVersion = new Uint8Array([0, 0, 0, 1]);

      MP4.FTYP = MP4.box(MP4.types.ftyp, majorBrand, minorVersion, majorBrand, avc1Brand);
      MP4.DINF = MP4.box(MP4.types.dinf, MP4.box(MP4.types.dref, dref));
    }
  }, {
    key: 'box',
    value: function box(type) {
      var payload = Array.prototype.slice.call(arguments, 1),
          size = 8,
          i = payload.length,
          len = i,
          result;
      // calculate the total size we need to allocate
      while (i--) {
        size += payload[i].byteLength;
      }
      result = new Uint8Array(size);
      result[0] = size >> 24 & 0xff;
      result[1] = size >> 16 & 0xff;
      result[2] = size >> 8 & 0xff;
      result[3] = size & 0xff;
      result.set(type, 4);
      // copy the payload into the result
      for (i = 0, size = 8; i < len; i++) {
        // copy payload[i] array @ offset size
        result.set(payload[i], size);
        size += payload[i].byteLength;
      }
      return result;
    }
  }, {
    key: 'hdlr',
    value: function hdlr(type) {
      return MP4.box(MP4.types.hdlr, MP4.HDLR_TYPES[type]);
    }
  }, {
    key: 'mdat',
    value: function mdat(data) {
      return MP4.box(MP4.types.mdat, data);
    }
  }, {
    key: 'mdhd',
    value: function mdhd(timescale, duration) {
      duration *= timescale;
      var upperWordDuration = Math.floor(duration / (UINT32_MAX + 1));
      var lowerWordDuration = Math.floor(duration % (UINT32_MAX + 1));
      return MP4.box(MP4.types.mdhd, new Uint8Array([0x01, // version 1
      0x00, 0x00, 0x00, // flags
      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x02, // creation_time
      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x03, // modification_time
      timescale >> 24 & 0xFF, timescale >> 16 & 0xFF, timescale >> 8 & 0xFF, timescale & 0xFF, // timescale
      upperWordDuration >> 24, upperWordDuration >> 16 & 0xFF, upperWordDuration >> 8 & 0xFF, upperWordDuration & 0xFF, lowerWordDuration >> 24, lowerWordDuration >> 16 & 0xFF, lowerWordDuration >> 8 & 0xFF, lowerWordDuration & 0xFF, 0x55, 0xc4, // 'und' language (undetermined)
      0x00, 0x00]));
    }
  }, {
    key: 'mdia',
    value: function mdia(track) {
      return MP4.box(MP4.types.mdia, MP4.mdhd(track.timescale, track.duration), MP4.hdlr(track.type), MP4.minf(track));
    }
  }, {
    key: 'mfhd',
    value: function mfhd(sequenceNumber) {
      return MP4.box(MP4.types.mfhd, new Uint8Array([0x00, 0x00, 0x00, 0x00, // flags
      sequenceNumber >> 24, sequenceNumber >> 16 & 0xFF, sequenceNumber >> 8 & 0xFF, sequenceNumber & 0xFF]));
    }
  }, {
    key: 'minf',
    value: function minf(track) {
      if (track.type === 'audio') {
        return MP4.box(MP4.types.minf, MP4.box(MP4.types.smhd, MP4.SMHD), MP4.DINF, MP4.stbl(track));
      } else {
        return MP4.box(MP4.types.minf, MP4.box(MP4.types.vmhd, MP4.VMHD), MP4.DINF, MP4.stbl(track));
      }
    }
  }, {
    key: 'moof',
    value: function moof(sn, baseMediaDecodeTime, track) {
      return MP4.box(MP4.types.moof, MP4.mfhd(sn), MP4.traf(track, baseMediaDecodeTime));
    }
    /**
     * @param tracks... (optional) {array} the tracks associated with this movie
     */

  }, {
    key: 'moov',
    value: function moov(tracks) {
      var i = tracks.length,
          boxes = [];

      while (i--) {
        boxes[i] = MP4.trak(tracks[i]);
      }

      return MP4.box.apply(null, [MP4.types.moov, MP4.mvhd(tracks[0].timescale, tracks[0].duration)].concat(boxes).concat(MP4.mvex(tracks)));
    }
  }, {
    key: 'mvex',
    value: function mvex(tracks) {
      var i = tracks.length,
          boxes = [];

      while (i--) {
        boxes[i] = MP4.trex(tracks[i]);
      }
      return MP4.box.apply(null, [MP4.types.mvex].concat(boxes));
    }
  }, {
    key: 'mvhd',
    value: function mvhd(timescale, duration) {
      duration *= timescale;
      var upperWordDuration = Math.floor(duration / (UINT32_MAX + 1));
      var lowerWordDuration = Math.floor(duration % (UINT32_MAX + 1));
      var bytes = new Uint8Array([0x01, // version 1
      0x00, 0x00, 0x00, // flags
      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x02, // creation_time
      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x03, // modification_time
      timescale >> 24 & 0xFF, timescale >> 16 & 0xFF, timescale >> 8 & 0xFF, timescale & 0xFF, // timescale
      upperWordDuration >> 24, upperWordDuration >> 16 & 0xFF, upperWordDuration >> 8 & 0xFF, upperWordDuration & 0xFF, lowerWordDuration >> 24, lowerWordDuration >> 16 & 0xFF, lowerWordDuration >> 8 & 0xFF, lowerWordDuration & 0xFF, 0x00, 0x01, 0x00, 0x00, // 1.0 rate
      0x01, 0x00, // 1.0 volume
      0x00, 0x00, // reserved
      0x00, 0x00, 0x00, 0x00, // reserved
      0x00, 0x00, 0x00, 0x00, // reserved
      0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x40, 0x00, 0x00, 0x00, // transformation: unity matrix
      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // pre_defined
      0xff, 0xff, 0xff, 0xff // next_track_ID
      ]);
      return MP4.box(MP4.types.mvhd, bytes);
    }
  }, {
    key: 'sdtp',
    value: function sdtp(track) {
      var samples = track.samples || [],
          bytes = new Uint8Array(4 + samples.length),
          flags,
          i;
      // leave the full box header (4 bytes) all zero
      // write the sample table
      for (i = 0; i < samples.length; i++) {
        flags = samples[i].flags;
        bytes[i + 4] = flags.dependsOn << 4 | flags.isDependedOn << 2 | flags.hasRedundancy;
      }

      return MP4.box(MP4.types.sdtp, bytes);
    }
  }, {
    key: 'stbl',
    value: function stbl(track) {
      return MP4.box(MP4.types.stbl, MP4.stsd(track), MP4.box(MP4.types.stts, MP4.STTS), MP4.box(MP4.types.stsc, MP4.STSC), MP4.box(MP4.types.stsz, MP4.STSZ), MP4.box(MP4.types.stco, MP4.STCO));
    }
  }, {
    key: 'avc1',
    value: function avc1(track) {
      var sps = [],
          pps = [],
          i,
          data,
          len;
      // assemble the SPSs

      for (i = 0; i < track.sps.length; i++) {
        data = track.sps[i];
        len = data.byteLength;
        sps.push(len >>> 8 & 0xFF);
        sps.push(len & 0xFF);
        sps = sps.concat(Array.prototype.slice.call(data)); // SPS
      }

      // assemble the PPSs
      for (i = 0; i < track.pps.length; i++) {
        data = track.pps[i];
        len = data.byteLength;
        pps.push(len >>> 8 & 0xFF);
        pps.push(len & 0xFF);
        pps = pps.concat(Array.prototype.slice.call(data));
      }

      var avcc = MP4.box(MP4.types.avcC, new Uint8Array([0x01, // version
      sps[3], // profile
      sps[4], // profile compat
      sps[5], // level
      0xfc | 3, // lengthSizeMinusOne, hard-coded to 4 bytes
      0xE0 | track.sps.length // 3bit reserved (111) + numOfSequenceParameterSets
      ].concat(sps).concat([track.pps.length // numOfPictureParameterSets
      ]).concat(pps))),
          // "PPS"
      width = track.width,
          height = track.height,
          hSpacing = track.pixelRatio[0],
          vSpacing = track.pixelRatio[1];
      //console.log('avcc:' + Hex.hexDump(avcc));
      return MP4.box(MP4.types.avc1, new Uint8Array([0x00, 0x00, 0x00, // reserved
      0x00, 0x00, 0x00, // reserved
      0x00, 0x01, // data_reference_index
      0x00, 0x00, // pre_defined
      0x00, 0x00, // reserved
      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // pre_defined
      width >> 8 & 0xFF, width & 0xff, // width
      height >> 8 & 0xFF, height & 0xff, // height
      0x00, 0x48, 0x00, 0x00, // horizresolution
      0x00, 0x48, 0x00, 0x00, // vertresolution
      0x00, 0x00, 0x00, 0x00, // reserved
      0x00, 0x01, // frame_count
      0x12, 0x64, 0x61, 0x69, 0x6C, //dailymotion/hls.js
      0x79, 0x6D, 0x6F, 0x74, 0x69, 0x6F, 0x6E, 0x2F, 0x68, 0x6C, 0x73, 0x2E, 0x6A, 0x73, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // compressorname
      0x00, 0x18, // depth = 24
      0x11, 0x11]), // pre_defined = -1
      avcc, MP4.box(MP4.types.btrt, new Uint8Array([0x00, 0x1c, 0x9c, 0x80, // bufferSizeDB
      0x00, 0x2d, 0xc6, 0xc0, // maxBitrate
      0x00, 0x2d, 0xc6, 0xc0])), // avgBitrate
      MP4.box(MP4.types.pasp, new Uint8Array([hSpacing >> 24, // hSpacing
      hSpacing >> 16 & 0xFF, hSpacing >> 8 & 0xFF, hSpacing & 0xFF, vSpacing >> 24, // vSpacing
      vSpacing >> 16 & 0xFF, vSpacing >> 8 & 0xFF, vSpacing & 0xFF])));
    }
  }, {
    key: 'esds',
    value: function esds(track) {
      var configlen = track.config.length;
      return new Uint8Array([0x00, // version 0
      0x00, 0x00, 0x00, // flags

      0x03, // descriptor_type
      0x17 + configlen, // length
      0x00, 0x01, //es_id
      0x00, // stream_priority

      0x04, // descriptor_type
      0x0f + configlen, // length
      0x40, //codec : mpeg4_audio
      0x15, // stream_type
      0x00, 0x00, 0x00, // buffer_size
      0x00, 0x00, 0x00, 0x00, // maxBitrate
      0x00, 0x00, 0x00, 0x00, // avgBitrate

      0x05 // descriptor_type
      ].concat([configlen]).concat(track.config).concat([0x06, 0x01, 0x02])); // GASpecificConfig)); // length + audio config descriptor
    }
  }, {
    key: 'mp4a',
    value: function mp4a(track) {
      var samplerate = track.samplerate;
      return MP4.box(MP4.types.mp4a, new Uint8Array([0x00, 0x00, 0x00, // reserved
      0x00, 0x00, 0x00, // reserved
      0x00, 0x01, // data_reference_index
      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // reserved
      0x00, track.channelCount, // channelcount
      0x00, 0x10, // sampleSize:16bits
      0x00, 0x00, 0x00, 0x00, // reserved2
      samplerate >> 8 & 0xFF, samplerate & 0xff, //
      0x00, 0x00]), MP4.box(MP4.types.esds, MP4.esds(track)));
    }
  }, {
    key: 'mp3',
    value: function mp3(track) {
      var samplerate = track.samplerate;
      return MP4.box(MP4.types['.mp3'], new Uint8Array([0x00, 0x00, 0x00, // reserved
      0x00, 0x00, 0x00, // reserved
      0x00, 0x01, // data_reference_index
      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // reserved
      0x00, track.channelCount, // channelcount
      0x00, 0x10, // sampleSize:16bits
      0x00, 0x00, 0x00, 0x00, // reserved2
      samplerate >> 8 & 0xFF, samplerate & 0xff, //
      0x00, 0x00]));
    }
  }, {
    key: 'stsd',
    value: function stsd(track) {
      if (track.type === 'audio') {
        if (!track.isAAC && track.codec === 'mp3') {
          return MP4.box(MP4.types.stsd, MP4.STSD, MP4.mp3(track));
        }
        return MP4.box(MP4.types.stsd, MP4.STSD, MP4.mp4a(track));
      } else {
        return MP4.box(MP4.types.stsd, MP4.STSD, MP4.avc1(track));
      }
    }
  }, {
    key: 'tkhd',
    value: function tkhd(track) {
      var id = track.id,
          duration = track.duration * track.timescale,
          width = track.width,
          height = track.height,
          upperWordDuration = Math.floor(duration / (UINT32_MAX + 1)),
          lowerWordDuration = Math.floor(duration % (UINT32_MAX + 1));
      return MP4.box(MP4.types.tkhd, new Uint8Array([0x01, // version 1
      0x00, 0x00, 0x07, // flags
      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x02, // creation_time
      0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x03, // modification_time
      id >> 24 & 0xFF, id >> 16 & 0xFF, id >> 8 & 0xFF, id & 0xFF, // track_ID
      0x00, 0x00, 0x00, 0x00, // reserved
      upperWordDuration >> 24, upperWordDuration >> 16 & 0xFF, upperWordDuration >> 8 & 0xFF, upperWordDuration & 0xFF, lowerWordDuration >> 24, lowerWordDuration >> 16 & 0xFF, lowerWordDuration >> 8 & 0xFF, lowerWordDuration & 0xFF, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, // reserved
      0x00, 0x00, // layer
      0x00, 0x00, // alternate_group
      0x00, 0x00, // non-audio track volume
      0x00, 0x00, // reserved
      0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x01, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x40, 0x00, 0x00, 0x00, // transformation: unity matrix
      width >> 8 & 0xFF, width & 0xFF, 0x00, 0x00, // width
      height >> 8 & 0xFF, height & 0xFF, 0x00, 0x00 // height
      ]));
    }
  }, {
    key: 'traf',
    value: function traf(track, baseMediaDecodeTime) {
      var sampleDependencyTable = MP4.sdtp(track),
          id = track.id,
          upperWordBaseMediaDecodeTime = Math.floor(baseMediaDecodeTime / (UINT32_MAX + 1)),
          lowerWordBaseMediaDecodeTime = Math.floor(baseMediaDecodeTime % (UINT32_MAX + 1));
      return MP4.box(MP4.types.traf, MP4.box(MP4.types.tfhd, new Uint8Array([0x00, // version 0
      0x00, 0x00, 0x00, // flags
      id >> 24, id >> 16 & 0XFF, id >> 8 & 0XFF, id & 0xFF])), MP4.box(MP4.types.tfdt, new Uint8Array([0x01, // version 1
      0x00, 0x00, 0x00, // flags
      upperWordBaseMediaDecodeTime >> 24, upperWordBaseMediaDecodeTime >> 16 & 0XFF, upperWordBaseMediaDecodeTime >> 8 & 0XFF, upperWordBaseMediaDecodeTime & 0xFF, lowerWordBaseMediaDecodeTime >> 24, lowerWordBaseMediaDecodeTime >> 16 & 0XFF, lowerWordBaseMediaDecodeTime >> 8 & 0XFF, lowerWordBaseMediaDecodeTime & 0xFF])), MP4.trun(track, sampleDependencyTable.length + 16 + // tfhd
      20 + // tfdt
      8 + // traf header
      16 + // mfhd
      8 + // moof header
      8), // mdat header
      sampleDependencyTable);
    }

    /**
     * Generate a track box.
     * @param track {object} a track definition
     * @return {Uint8Array} the track box
     */

  }, {
    key: 'trak',
    value: function trak(track) {
      track.duration = track.duration || 0xffffffff;
      return MP4.box(MP4.types.trak, MP4.tkhd(track), MP4.mdia(track));
    }
  }, {
    key: 'trex',
    value: function trex(track) {
      var id = track.id;
      return MP4.box(MP4.types.trex, new Uint8Array([0x00, // version 0
      0x00, 0x00, 0x00, // flags
      id >> 24, id >> 16 & 0XFF, id >> 8 & 0XFF, id & 0xFF, // track_ID
      0x00, 0x00, 0x00, 0x01, // default_sample_description_index
      0x00, 0x00, 0x00, 0x00, // default_sample_duration
      0x00, 0x00, 0x00, 0x00, // default_sample_size
      0x00, 0x01, 0x00, 0x01 // default_sample_flags
      ]));
    }
  }, {
    key: 'trun',
    value: function trun(track, offset) {
      var samples = track.samples || [],
          len = samples.length,
          arraylen = 12 + 16 * len,
          array = new Uint8Array(arraylen),
          i,
          sample,
          duration,
          size,
          flags,
          cts;
      offset += 8 + arraylen;
      array.set([0x00, // version 0
      0x00, 0x0f, 0x01, // flags
      len >>> 24 & 0xFF, len >>> 16 & 0xFF, len >>> 8 & 0xFF, len & 0xFF, // sample_count
      offset >>> 24 & 0xFF, offset >>> 16 & 0xFF, offset >>> 8 & 0xFF, offset & 0xFF // data_offset
      ], 0);
      for (i = 0; i < len; i++) {
        sample = samples[i];
        duration = sample.duration;
        size = sample.size;
        flags = sample.flags;
        cts = sample.cts;
        array.set([duration >>> 24 & 0xFF, duration >>> 16 & 0xFF, duration >>> 8 & 0xFF, duration & 0xFF, // sample_duration
        size >>> 24 & 0xFF, size >>> 16 & 0xFF, size >>> 8 & 0xFF, size & 0xFF, // sample_size
        flags.isLeading << 2 | flags.dependsOn, flags.isDependedOn << 6 | flags.hasRedundancy << 4 | flags.paddingValue << 1 | flags.isNonSync, flags.degradPrio & 0xF0 << 8, flags.degradPrio & 0x0F, // sample_flags
        cts >>> 24 & 0xFF, cts >>> 16 & 0xFF, cts >>> 8 & 0xFF, cts & 0xFF // sample_composition_time_offset
        ], 12 + 16 * i);
      }
      return MP4.box(MP4.types.trun, array);
    }
  }, {
    key: 'initSegment',
    value: function initSegment(tracks) {
      if (!MP4.types) {
        MP4.init();
      }
      var movie = MP4.moov(tracks),
          result;
      result = new Uint8Array(MP4.FTYP.byteLength + movie.byteLength);
      result.set(MP4.FTYP);
      result.set(movie, MP4.FTYP.byteLength);
      return result;
    }
  }]);

  return MP4;
}();

exports.default = MP4;

/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * fMP4 remuxer
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     */

var _aac = __webpack_require__(1461);

var _aac2 = _interopRequireDefault(_aac);

var _events = __webpack_require__(39);

var _events2 = _interopRequireDefault(_events);

var _logger = __webpack_require__(31);

var _mp4Generator = __webpack_require__(1467);

var _mp4Generator2 = _interopRequireDefault(_mp4Generator);

var _errors = __webpack_require__(63);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// 10 seconds
var MAX_SILENT_FRAME_DURATION = 10 * 1000;

var MP4Remuxer = function () {
  function MP4Remuxer(observer, config, typeSupported, vendor) {
    _classCallCheck(this, MP4Remuxer);

    this.observer = observer;
    this.config = config;
    this.typeSupported = typeSupported;
    var userAgent = navigator.userAgent;
    this.isSafari = vendor && vendor.indexOf('Apple') > -1 && userAgent && !userAgent.match('CriOS');
    this.ISGenerated = false;
  }

  _createClass(MP4Remuxer, [{
    key: 'destroy',
    value: function destroy() {}
  }, {
    key: 'resetTimeStamp',
    value: function resetTimeStamp(defaultTimeStamp) {
      this._initPTS = this._initDTS = defaultTimeStamp;
    }
  }, {
    key: 'resetInitSegment',
    value: function resetInitSegment() {
      this.ISGenerated = false;
    }
  }, {
    key: 'remux',
    value: function remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset) {
      // generate Init Segment if needed
      if (!this.ISGenerated) {
        this.generateIS(audioTrack, videoTrack, timeOffset);
      }

      if (this.ISGenerated) {
        // Purposefully remuxing audio before video, so that remuxVideo can use nextAudioPts, which is
        // calculated in remuxAudio.
        //logger.log('nb AAC samples:' + audioTrack.samples.length);
        if (audioTrack.samples.length) {
          // if initSegment was generated without video samples, regenerate it again
          if (!audioTrack.timescale) {
            _logger.logger.warn('regenerate InitSegment as audio detected');
            this.generateIS(audioTrack, videoTrack, timeOffset);
          }
          var audioData = this.remuxAudio(audioTrack, timeOffset, contiguous, accurateTimeOffset);
          //logger.log('nb AVC samples:' + videoTrack.samples.length);
          if (videoTrack.samples.length) {
            var audioTrackLength = void 0;
            if (audioData) {
              audioTrackLength = audioData.endPTS - audioData.startPTS;
            }
            // if initSegment was generated without video samples, regenerate it again
            if (!videoTrack.timescale) {
              _logger.logger.warn('regenerate InitSegment as video detected');
              this.generateIS(audioTrack, videoTrack, timeOffset);
            }
            this.remuxVideo(videoTrack, timeOffset, contiguous, audioTrackLength);
          }
        } else {
          var videoData = void 0;
          //logger.log('nb AVC samples:' + videoTrack.samples.length);
          if (videoTrack.samples.length) {
            videoData = this.remuxVideo(videoTrack, timeOffset, contiguous);
          }
          if (videoData && audioTrack.codec) {
            this.remuxEmptyAudio(audioTrack, timeOffset, contiguous, videoData);
          }
        }
      }
      //logger.log('nb ID3 samples:' + audioTrack.samples.length);
      if (id3Track.samples.length) {
        this.remuxID3(id3Track, timeOffset);
      }
      //logger.log('nb ID3 samples:' + audioTrack.samples.length);
      if (textTrack.samples.length) {
        this.remuxText(textTrack, timeOffset);
      }
      //notify end of parsing
      this.observer.trigger(_events2.default.FRAG_PARSED);
    }
  }, {
    key: 'generateIS',
    value: function generateIS(audioTrack, videoTrack, timeOffset) {
      var observer = this.observer,
          audioSamples = audioTrack.samples,
          videoSamples = videoTrack.samples,
          typeSupported = this.typeSupported,
          container = 'audio/mp4',
          tracks = {},
          data = { tracks: tracks },
          computePTSDTS = this._initPTS === undefined,
          initPTS,
          initDTS;

      if (computePTSDTS) {
        initPTS = initDTS = Infinity;
      }
      if (audioTrack.config && audioSamples.length) {
        // let's use audio sampling rate as MP4 time scale.
        // rationale is that there is a integer nb of audio frames per audio sample (1024 for AAC)
        // using audio sampling rate here helps having an integer MP4 frame duration
        // this avoids potential rounding issue and AV sync issue
        audioTrack.timescale = audioTrack.samplerate;
        _logger.logger.log('audio sampling rate : ' + audioTrack.samplerate);
        if (!audioTrack.isAAC) {
          if (typeSupported.mpeg) {
            // Chrome and Safari
            container = 'audio/mpeg';
            audioTrack.codec = '';
          } else if (typeSupported.mp3) {
            // Firefox
            audioTrack.codec = 'mp3';
          }
        }
        tracks.audio = {
          container: container,
          codec: audioTrack.codec,
          initSegment: !audioTrack.isAAC && typeSupported.mpeg ? new Uint8Array() : _mp4Generator2.default.initSegment([audioTrack]),
          metadata: {
            channelCount: audioTrack.channelCount
          }
        };
        if (computePTSDTS) {
          // remember first PTS of this demuxing context. for audio, PTS = DTS
          initPTS = initDTS = audioSamples[0].pts - audioTrack.inputTimeScale * timeOffset;
        }
      }

      if (videoTrack.sps && videoTrack.pps && videoSamples.length) {
        // let's use input time scale as MP4 video timescale
        // we use input time scale straight away to avoid rounding issues on frame duration / cts computation
        var inputTimeScale = videoTrack.inputTimeScale;
        videoTrack.timescale = inputTimeScale;
        tracks.video = {
          container: 'video/mp4',
          codec: videoTrack.codec,
          initSegment: _mp4Generator2.default.initSegment([videoTrack]),
          metadata: {
            width: videoTrack.width,
            height: videoTrack.height
          }
        };
        if (computePTSDTS) {
          initPTS = Math.min(initPTS, videoSamples[0].pts - inputTimeScale * timeOffset);
          initDTS = Math.min(initDTS, videoSamples[0].dts - inputTimeScale * timeOffset);
          this.observer.trigger(_events2.default.INIT_PTS_FOUND, { initPTS: initPTS });
        }
      }

      if (Object.keys(tracks).length) {
        observer.trigger(_events2.default.FRAG_PARSING_INIT_SEGMENT, data);
        this.ISGenerated = true;
        if (computePTSDTS) {
          this._initPTS = initPTS;
          this._initDTS = initDTS;
        }
      } else {
        observer.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.MEDIA_ERROR, details: _errors.ErrorDetails.FRAG_PARSING_ERROR, fatal: false, reason: 'no audio/video samples found' });
      }
    }
  }, {
    key: 'remuxVideo',
    value: function remuxVideo(track, timeOffset, contiguous, audioTrackLength) {
      var offset = 8,
          timeScale = track.timescale,
          mp4SampleDuration,
          mdat,
          moof,
          firstPTS,
          firstDTS,
          nextDTS,
          lastPTS,
          lastDTS,
          inputSamples = track.samples,
          outputSamples = [],
          nbSamples = inputSamples.length,
          ptsNormalize = this._PTSNormalize,
          initDTS = this._initDTS;

      // for (let i = 0; i < track.samples.length; i++) {
      //   let avcSample = track.samples[i];
      //   let units = avcSample.units;
      //   let unitsString = '';
      //   for (let j = 0; j < units.length ; j++) {
      //     unitsString += units[j].type + ',';
      //     if (units[j].data.length < 500) {
      //       unitsString += Hex.hexDump(units[j].data);
      //     }
      //   }
      //   logger.log(avcSample.pts + '/' + avcSample.dts + ',' + unitsString + avcSample.units.length);
      // }

      // sort video samples by DTS then PTS then demux id order
      inputSamples.sort(function (a, b) {
        var deltadts = a.dts - b.dts;
        var deltapts = a.pts - b.pts;
        return deltadts ? deltadts : deltapts ? deltapts : a.id - b.id;
      });

      // handle broken streams with PTS < DTS, tolerance up 200ms (18000 in 90kHz timescale)
      var PTSDTSshift = inputSamples.reduce(function (prev, curr) {
        return Math.max(Math.min(prev, curr.pts - curr.dts), -18000);
      }, 0);
      if (PTSDTSshift < 0) {
        _logger.logger.warn('PTS < DTS detected in video samples, shifting DTS by ' + Math.round(PTSDTSshift / 90) + ' ms to overcome this issue');
        for (var i = 0; i < inputSamples.length; i++) {
          inputSamples[i].dts += PTSDTSshift;
        }
      }

      // PTS is coded on 33bits, and can loop from -2^32 to 2^32
      // ptsNormalize will make PTS/DTS value monotonic, we use last known DTS value as reference value
      var nextAvcDts = void 0;
      // contiguous fragments are consecutive fragments from same quality level (same level, new SN = old SN + 1)
      if (contiguous) {
        // if parsed fragment is contiguous with last one, let's use last DTS value as reference
        nextAvcDts = this.nextAvcDts;
      } else {
        // if not contiguous, let's use target timeOffset
        nextAvcDts = timeOffset * timeScale;
      }

      // compute first DTS and last DTS, normalize them against reference value
      var sample = inputSamples[0];
      firstDTS = Math.max(ptsNormalize(sample.dts - initDTS, nextAvcDts), 0);
      firstPTS = Math.max(ptsNormalize(sample.pts - initDTS, nextAvcDts), 0);

      // check timestamp continuity accross consecutive fragments (this is to remove inter-fragment gap/hole)
      var delta = Math.round((firstDTS - nextAvcDts) / 90);
      // if fragment are contiguous, detect hole/overlapping between fragments
      if (contiguous) {
        if (delta) {
          if (delta > 1) {
            _logger.logger.log('AVC:' + delta + ' ms hole between fragments detected,filling it');
          } else if (delta < -1) {
            _logger.logger.log('AVC:' + -delta + ' ms overlapping between fragments detected');
          }
          // remove hole/gap : set DTS to next expected DTS
          firstDTS = nextAvcDts;
          inputSamples[0].dts = firstDTS + initDTS;
          // offset PTS as well, ensure that PTS is smaller or equal than new DTS
          firstPTS = Math.max(firstPTS - delta, nextAvcDts);
          inputSamples[0].pts = firstPTS + initDTS;
          _logger.logger.log('Video/PTS/DTS adjusted: ' + Math.round(firstPTS / 90) + '/' + Math.round(firstDTS / 90) + ',delta:' + delta + ' ms');
        }
      }
      nextDTS = firstDTS;

      // compute lastPTS/lastDTS
      sample = inputSamples[inputSamples.length - 1];
      lastDTS = Math.max(ptsNormalize(sample.dts - initDTS, nextAvcDts), 0);
      lastPTS = Math.max(ptsNormalize(sample.pts - initDTS, nextAvcDts), 0);
      lastPTS = Math.max(lastPTS, lastDTS);

      var isSafari = this.isSafari;
      // on Safari let's signal the same sample duration for all samples
      // sample duration (as expected by trun MP4 boxes), should be the delta between sample DTS
      // set this constant duration as being the avg delta between consecutive DTS.
      if (isSafari) {
        mp4SampleDuration = Math.round((lastDTS - firstDTS) / (inputSamples.length - 1));
      }

      var nbNalu = 0,
          naluLen = 0;
      for (var _i = 0; _i < nbSamples; _i++) {
        // compute total/avc sample length and nb of NAL units
        var _sample = inputSamples[_i],
            units = _sample.units,
            nbUnits = units.length,
            sampleLen = 0;
        for (var j = 0; j < nbUnits; j++) {
          sampleLen += units[j].data.length;
        }
        naluLen += sampleLen;
        nbNalu += nbUnits;
        _sample.length = sampleLen;

        // normalize PTS/DTS
        if (isSafari) {
          // sample DTS is computed using a constant decoding offset (mp4SampleDuration) between samples
          _sample.dts = firstDTS + _i * mp4SampleDuration;
        } else {
          // ensure sample monotonic DTS
          _sample.dts = Math.max(ptsNormalize(_sample.dts - initDTS, nextAvcDts), firstDTS);
        }
        // we normalize PTS against nextAvcDts, we also substract initDTS (some streams don't start @ PTS O)
        // and we ensure that computed value is greater or equal than sample DTS
        _sample.pts = Math.max(ptsNormalize(_sample.pts - initDTS, nextAvcDts), _sample.dts);
      }

      /* concatenate the video data and construct the mdat in place
        (need 8 more bytes to fill length and mpdat type) */
      var mdatSize = naluLen + 4 * nbNalu + 8;
      try {
        mdat = new Uint8Array(mdatSize);
      } catch (err) {
        this.observer.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.MUX_ERROR, details: _errors.ErrorDetails.REMUX_ALLOC_ERROR, fatal: false, bytes: mdatSize, reason: 'fail allocating video mdat ' + mdatSize });
        return;
      }
      var view = new DataView(mdat.buffer);
      view.setUint32(0, mdatSize);
      mdat.set(_mp4Generator2.default.types.mdat, 4);

      for (var _i2 = 0; _i2 < nbSamples; _i2++) {
        var avcSample = inputSamples[_i2],
            avcSampleUnits = avcSample.units,
            mp4SampleLength = 0,
            compositionTimeOffset = void 0;
        // convert NALU bitstream to MP4 format (prepend NALU with size field)
        for (var _j = 0, _nbUnits = avcSampleUnits.length; _j < _nbUnits; _j++) {
          var unit = avcSampleUnits[_j],
              unitData = unit.data,
              unitDataLen = unit.data.byteLength;
          view.setUint32(offset, unitDataLen);
          offset += 4;
          mdat.set(unitData, offset);
          offset += unitDataLen;
          mp4SampleLength += 4 + unitDataLen;
        }

        if (!isSafari) {
          // expected sample duration is the Decoding Timestamp diff of consecutive samples
          if (_i2 < nbSamples - 1) {
            mp4SampleDuration = inputSamples[_i2 + 1].dts - avcSample.dts;
          } else {
            var config = this.config,
                lastFrameDuration = avcSample.dts - inputSamples[_i2 > 0 ? _i2 - 1 : _i2].dts;
            if (config.stretchShortVideoTrack) {
              // In some cases, a segment's audio track duration may exceed the video track duration.
              // Since we've already remuxed audio, and we know how long the audio track is, we look to
              // see if the delta to the next segment is longer than the minimum of maxBufferHole and
              // maxSeekHole. If so, playback would potentially get stuck, so we artificially inflate
              // the duration of the last frame to minimize any potential gap between segments.
              var maxBufferHole = config.maxBufferHole,
                  maxSeekHole = config.maxSeekHole,
                  gapTolerance = Math.floor(Math.min(maxBufferHole, maxSeekHole) * timeScale),
                  deltaToFrameEnd = (audioTrackLength ? firstPTS + audioTrackLength * timeScale : this.nextAudioPts) - avcSample.pts;
              if (deltaToFrameEnd > gapTolerance) {
                // We subtract lastFrameDuration from deltaToFrameEnd to try to prevent any video
                // frame overlap. maxBufferHole/maxSeekHole should be >> lastFrameDuration anyway.
                mp4SampleDuration = deltaToFrameEnd - lastFrameDuration;
                if (mp4SampleDuration < 0) {
                  mp4SampleDuration = lastFrameDuration;
                }
                _logger.logger.log('It is approximately ' + deltaToFrameEnd / 90 + ' ms to the next segment; using duration ' + mp4SampleDuration / 90 + ' ms for the last video frame.');
              } else {
                mp4SampleDuration = lastFrameDuration;
              }
            } else {
              mp4SampleDuration = lastFrameDuration;
            }
          }
          compositionTimeOffset = Math.round(avcSample.pts - avcSample.dts);
        } else {
          compositionTimeOffset = Math.max(0, mp4SampleDuration * Math.round((avcSample.pts - avcSample.dts) / mp4SampleDuration));
        }

        //console.log('PTS/DTS/initDTS/normPTS/normDTS/relative PTS : ${avcSample.pts}/${avcSample.dts}/${initDTS}/${ptsnorm}/${dtsnorm}/${(avcSample.pts/4294967296).toFixed(3)}');
        outputSamples.push({
          size: mp4SampleLength,
          // constant duration
          duration: mp4SampleDuration,
          cts: compositionTimeOffset,
          flags: {
            isLeading: 0,
            isDependedOn: 0,
            hasRedundancy: 0,
            degradPrio: 0,
            dependsOn: avcSample.key ? 2 : 1,
            isNonSync: avcSample.key ? 0 : 1
          }
        });
      }
      // next AVC sample DTS should be equal to last sample DTS + last sample duration (in PES timescale)
      this.nextAvcDts = lastDTS + mp4SampleDuration;
      var dropped = track.dropped;
      track.len = 0;
      track.nbNalu = 0;
      track.dropped = 0;
      if (outputSamples.length && navigator.userAgent.toLowerCase().indexOf('chrome') > -1) {
        var flags = outputSamples[0].flags;
        // chrome workaround, mark first sample as being a Random Access Point to avoid sourcebuffer append issue
        // https://code.google.com/p/chromium/issues/detail?id=229412
        flags.dependsOn = 2;
        flags.isNonSync = 0;
      }
      track.samples = outputSamples;
      moof = _mp4Generator2.default.moof(track.sequenceNumber++, firstDTS, track);
      track.samples = [];

      var data = {
        data1: moof,
        data2: mdat,
        startPTS: firstPTS / timeScale,
        endPTS: (lastPTS + mp4SampleDuration) / timeScale,
        startDTS: firstDTS / timeScale,
        endDTS: this.nextAvcDts / timeScale,
        type: 'video',
        nb: outputSamples.length,
        dropped: dropped
      };
      this.observer.trigger(_events2.default.FRAG_PARSING_DATA, data);
      return data;
    }
  }, {
    key: 'remuxAudio',
    value: function remuxAudio(track, timeOffset, contiguous, accurateTimeOffset) {
      var inputTimeScale = track.inputTimeScale,
          mp4timeScale = track.timescale,
          scaleFactor = inputTimeScale / mp4timeScale,
          mp4SampleDuration = track.isAAC ? 1024 : 1152,
          inputSampleDuration = mp4SampleDuration * scaleFactor,
          ptsNormalize = this._PTSNormalize,
          initDTS = this._initDTS,
          rawMPEG = !track.isAAC && this.typeSupported.mpeg;

      var view,
          offset = rawMPEG ? 0 : 8,
          audioSample,
          mp4Sample,
          unit,
          mdat,
          moof,
          firstPTS,
          firstDTS,
          lastDTS,
          pts,
          dts,
          ptsnorm,
          dtsnorm,
          outputSamples = [],
          inputSamples = [],
          fillFrame,
          newStamp,
          nextAudioPts;

      track.samples.sort(function (a, b) {
        return a.pts - b.pts;
      });
      inputSamples = track.samples;

      // for audio samples, also consider consecutive fragments as being contiguous (even if a level switch occurs),
      // for sake of clarity:
      // consecutive fragments are frags with
      //  - less than 100ms gaps between new time offset (if accurate) and next expected PTS OR
      //  - less than 20 audio frames distance
      // contiguous fragments are consecutive fragments from same quality level (same level, new SN = old SN + 1)
      // this helps ensuring audio continuity
      // and this also avoids audio glitches/cut when switching quality, or reporting wrong duration on first audio frame

      nextAudioPts = this.nextAudioPts;
      contiguous |= inputSamples.length && nextAudioPts && (accurateTimeOffset && Math.abs(timeOffset - nextAudioPts / inputTimeScale) < 0.1 || Math.abs(inputSamples[0].pts - nextAudioPts - initDTS) < 20 * inputSampleDuration);

      if (!contiguous) {
        // if fragments are not contiguous, let's use timeOffset to compute next Audio PTS
        nextAudioPts = timeOffset * inputTimeScale;
      }
      // If the audio track is missing samples, the frames seem to get "left-shifted" within the
      // resulting mp4 segment, causing sync issues and leaving gaps at the end of the audio segment.
      // In an effort to prevent this from happening, we inject frames here where there are gaps.
      // When possible, we inject a silent frame; when that's not possible, we duplicate the last
      // frame.

      // only inject/drop audio frames in case time offset is accurate
      if (accurateTimeOffset && track.isAAC) {
        for (var i = 0, nextPtsNorm = nextAudioPts; i < inputSamples.length;) {
          // First, let's see how far off this frame is from where we expect it to be
          var sample = inputSamples[i],
              ptsNorm = ptsNormalize(sample.pts - initDTS, nextAudioPts),
              delta = ptsNorm - nextPtsNorm;

          var duration = Math.abs(1000 * delta / inputTimeScale);

          // If we're overlapping by more than a duration, drop this sample
          if (delta <= -inputSampleDuration) {
            _logger.logger.warn('Dropping 1 audio frame @ ' + (nextPtsNorm / inputTimeScale).toFixed(3) + 's due to ' + duration + ' ms overlap.');
            inputSamples.splice(i, 1);
            track.len -= sample.unit.length;
            // Don't touch nextPtsNorm or i
          }

          // Insert missing frames if:
          // 1: We're more than one frame away
          // 2: Not more than MAX_SILENT_FRAME_DURATION away
          // 3: currentTime (aka nextPtsNorm) is not 0
          else if (delta >= inputSampleDuration && duration < MAX_SILENT_FRAME_DURATION && nextPtsNorm) {
              var missing = Math.round(delta / inputSampleDuration);
              _logger.logger.warn('Injecting ' + missing + ' audio frame @ ' + (nextPtsNorm / inputTimeScale).toFixed(3) + 's due to ' + Math.round(1000 * delta / inputTimeScale) + ' ms gap.');
              for (var j = 0; j < missing; j++) {
                newStamp = nextPtsNorm + initDTS;
                newStamp = Math.max(newStamp, initDTS);
                fillFrame = _aac2.default.getSilentFrame(track.manifestCodec || track.codec, track.channelCount);
                if (!fillFrame) {
                  _logger.logger.log('Unable to get silent frame for given audio codec; duplicating last frame instead.');
                  fillFrame = sample.unit.subarray();
                }
                inputSamples.splice(i, 0, { unit: fillFrame, pts: newStamp, dts: newStamp });
                track.len += fillFrame.length;
                nextPtsNorm += inputSampleDuration;
                i += 1;
              }

              // Adjust sample to next expected pts
              sample.pts = sample.dts = nextPtsNorm + initDTS;
              nextPtsNorm += inputSampleDuration;
              i += 1;
            }
            // Otherwise, just adjust pts
            else {
                if (Math.abs(delta) > 0.1 * inputSampleDuration) {
                  // logger.log(`Invalid frame delta ${Math.round(ptsNorm - nextPtsNorm + inputSampleDuration)} at PTS ${Math.round(ptsNorm / 90)} (should be ${Math.round(inputSampleDuration)}).`);
                }
                nextPtsNorm += inputSampleDuration;
                if (i === 0) {
                  sample.pts = sample.dts = initDTS + nextAudioPts;
                } else {
                  sample.pts = sample.dts = inputSamples[i - 1].pts + inputSampleDuration;
                }
                i += 1;
              }
        }
      }

      for (var _j2 = 0, _nbSamples = inputSamples.length; _j2 < _nbSamples; _j2++) {
        audioSample = inputSamples[_j2];
        unit = audioSample.unit;
        pts = audioSample.pts - initDTS;
        dts = audioSample.dts - initDTS;
        //logger.log(`Audio/PTS:${Math.round(pts/90)}`);
        // if not first sample
        if (lastDTS !== undefined) {
          ptsnorm = ptsNormalize(pts, lastDTS);
          dtsnorm = ptsNormalize(dts, lastDTS);
          mp4Sample.duration = Math.round((dtsnorm - lastDTS) / scaleFactor);
        } else {
          ptsnorm = ptsNormalize(pts, nextAudioPts);
          dtsnorm = ptsNormalize(dts, nextAudioPts);
          var _delta = Math.round(1000 * (ptsnorm - nextAudioPts) / inputTimeScale),
              numMissingFrames = 0;
          // if fragment are contiguous, detect hole/overlapping between fragments
          // contiguous fragments are consecutive fragments from same quality level (same level, new SN = old SN + 1)
          if (contiguous && track.isAAC) {
            // log delta
            if (_delta) {
              if (_delta > 0 && _delta < MAX_SILENT_FRAME_DURATION) {
                numMissingFrames = Math.round((ptsnorm - nextAudioPts) / inputSampleDuration);
                _logger.logger.log(_delta + ' ms hole between AAC samples detected,filling it');
                if (numMissingFrames > 0) {
                  fillFrame = _aac2.default.getSilentFrame(track.manifestCodec || track.codec, track.channelCount);
                  if (!fillFrame) {
                    fillFrame = unit.subarray();
                  }
                  track.len += numMissingFrames * fillFrame.length;
                }
                // if we have frame overlap, overlapping for more than half a frame duraion
              } else if (_delta < -12) {
                // drop overlapping audio frames... browser will deal with it
                _logger.logger.log('drop overlapping AAC sample, expected/parsed/delta:' + (nextAudioPts / inputTimeScale).toFixed(3) + 's/' + (ptsnorm / inputTimeScale).toFixed(3) + 's/' + -_delta + 'ms');
                track.len -= unit.byteLength;
                continue;
              }
              // set PTS/DTS to expected PTS/DTS
              ptsnorm = dtsnorm = nextAudioPts;
            }
          }
          // remember first PTS of our audioSamples, ensure value is positive
          firstPTS = Math.max(0, ptsnorm);
          firstDTS = Math.max(0, dtsnorm);
          if (track.len > 0) {
            /* concatenate the audio data and construct the mdat in place
              (need 8 more bytes to fill length and mdat type) */

            var mdatSize = rawMPEG ? track.len : track.len + 8;
            try {
              mdat = new Uint8Array(mdatSize);
            } catch (err) {
              this.observer.trigger(_events2.default.ERROR, { type: _errors.ErrorTypes.MUX_ERROR, details: _errors.ErrorDetails.REMUX_ALLOC_ERROR, fatal: false, bytes: mdatSize, reason: 'fail allocating audio mdat ' + mdatSize });
              return;
            }
            if (!rawMPEG) {
              view = new DataView(mdat.buffer);
              view.setUint32(0, mdatSize);
              mdat.set(_mp4Generator2.default.types.mdat, 4);
            }
          } else {
            // no audio samples
            return;
          }
          for (var _i3 = 0; _i3 < numMissingFrames; _i3++) {
            newStamp = ptsnorm - (numMissingFrames - _i3) * inputSampleDuration;
            fillFrame = _aac2.default.getSilentFrame(track.manifestCodec || track.codec, track.channelCount);
            if (!fillFrame) {
              _logger.logger.log('Unable to get silent frame for given audio codec; duplicating this frame instead.');
              fillFrame = unit.subarray();
            }
            mdat.set(fillFrame, offset);
            offset += fillFrame.byteLength;
            mp4Sample = {
              size: fillFrame.byteLength,
              cts: 0,
              duration: 1024,
              flags: {
                isLeading: 0,
                isDependedOn: 0,
                hasRedundancy: 0,
                degradPrio: 0,
                dependsOn: 1
              }
            };
            outputSamples.push(mp4Sample);
          }
        }
        mdat.set(unit, offset);
        var unitLen = unit.byteLength;
        offset += unitLen;
        //console.log('PTS/DTS/initDTS/normPTS/normDTS/relative PTS : ${audioSample.pts}/${audioSample.dts}/${initDTS}/${ptsnorm}/${dtsnorm}/${(audioSample.pts/4294967296).toFixed(3)}');
        mp4Sample = {
          size: unitLen,
          cts: 0,
          duration: 0,
          flags: {
            isLeading: 0,
            isDependedOn: 0,
            hasRedundancy: 0,
            degradPrio: 0,
            dependsOn: 1
          }
        };
        outputSamples.push(mp4Sample);
        lastDTS = dtsnorm;
      }
      var lastSampleDuration = 0;
      var nbSamples = outputSamples.length;
      //set last sample duration as being identical to previous sample
      if (nbSamples >= 2) {
        lastSampleDuration = outputSamples[nbSamples - 2].duration;
        mp4Sample.duration = lastSampleDuration;
      }
      if (nbSamples) {
        // next audio sample PTS should be equal to last sample PTS + duration
        this.nextAudioPts = ptsnorm + scaleFactor * lastSampleDuration;
        //logger.log('Audio/PTS/PTSend:' + audioSample.pts.toFixed(0) + '/' + this.nextAacDts.toFixed(0));
        track.len = 0;
        track.samples = outputSamples;
        if (rawMPEG) {
          moof = new Uint8Array();
        } else {
          moof = _mp4Generator2.default.moof(track.sequenceNumber++, firstDTS / scaleFactor, track);
        }
        track.samples = [];
        var audioData = {
          data1: moof,
          data2: mdat,
          startPTS: firstPTS / inputTimeScale,
          endPTS: this.nextAudioPts / inputTimeScale,
          startDTS: firstDTS / inputTimeScale,
          endDTS: (dtsnorm + scaleFactor * lastSampleDuration) / inputTimeScale,
          type: 'audio',
          nb: nbSamples
        };
        this.observer.trigger(_events2.default.FRAG_PARSING_DATA, audioData);
        return audioData;
      }
      return null;
    }
  }, {
    key: 'remuxEmptyAudio',
    value: function remuxEmptyAudio(track, timeOffset, contiguous, videoData) {
      var inputTimeScale = track.inputTimeScale,
          mp4timeScale = track.samplerate ? track.samplerate : inputTimeScale,
          scaleFactor = inputTimeScale / mp4timeScale,
          nextAudioPts = this.nextAudioPts,


      // sync with video's timestamp
      startDTS = (nextAudioPts !== undefined ? nextAudioPts : videoData.startDTS * inputTimeScale) + this._initDTS,
          endDTS = videoData.endDTS * inputTimeScale + this._initDTS,

      // one sample's duration value
      sampleDuration = 1024,
          frameDuration = scaleFactor * sampleDuration,


      // samples count of this segment's duration
      nbSamples = Math.ceil((endDTS - startDTS) / frameDuration),


      // silent frame
      silentFrame = _aac2.default.getSilentFrame(track.manifestCodec || track.codec, track.channelCount);

      _logger.logger.warn('remux empty Audio');
      // Can't remux if we can't generate a silent frame...
      if (!silentFrame) {
        _logger.logger.trace('Unable to remuxEmptyAudio since we were unable to get a silent frame for given audio codec!');
        return;
      }

      var samples = [];
      for (var i = 0; i < nbSamples; i++) {
        var stamp = startDTS + i * frameDuration;
        samples.push({ unit: silentFrame, pts: stamp, dts: stamp });
        track.len += silentFrame.length;
      }
      track.samples = samples;

      this.remuxAudio(track, timeOffset, contiguous);
    }
  }, {
    key: 'remuxID3',
    value: function remuxID3(track, timeOffset) {
      var length = track.samples.length,
          sample;
      var inputTimeScale = track.inputTimeScale;
      var initPTS = this._initPTS;
      var initDTS = this._initDTS;
      // consume samples
      if (length) {
        for (var index = 0; index < length; index++) {
          sample = track.samples[index];
          // setting id3 pts, dts to relative time
          // using this._initPTS and this._initDTS to calculate relative time
          sample.pts = (sample.pts - initPTS) / inputTimeScale;
          sample.dts = (sample.dts - initDTS) / inputTimeScale;
        }
        this.observer.trigger(_events2.default.FRAG_PARSING_METADATA, {
          samples: track.samples
        });
      }

      track.samples = [];
      timeOffset = timeOffset;
    }
  }, {
    key: 'remuxText',
    value: function remuxText(track, timeOffset) {
      track.samples.sort(function (a, b) {
        return a.pts - b.pts;
      });

      var length = track.samples.length,
          sample;
      var inputTimeScale = track.inputTimeScale;
      var initPTS = this._initPTS;
      // consume samples
      if (length) {
        for (var index = 0; index < length; index++) {
          sample = track.samples[index];
          // setting text pts, dts to relative time
          // using this._initPTS and this._initDTS to calculate relative time
          sample.pts = (sample.pts - initPTS) / inputTimeScale;
        }
        this.observer.trigger(_events2.default.FRAG_PARSING_USERDATA, {
          samples: track.samples
        });
      }

      track.samples = [];
      timeOffset = timeOffset;
    }
  }, {
    key: '_PTSNormalize',
    value: function _PTSNormalize(value, reference) {
      var offset;
      if (reference === undefined) {
        return value;
      }
      if (reference < value) {
        // - 2^33
        offset = -8589934592;
      } else {
        // + 2^33
        offset = 8589934592;
      }
      /* PTS is 33bit (from 0 to 2^33 -1)
        if diff between value and reference is bigger than half of the amplitude (2^32) then it means that
        PTS looping occured. fill the gap */
      while (Math.abs(value - reference) > 4294967296) {
        value += offset;
      }
      return value;
    }
  }]);

  return MP4Remuxer;
}();

exports.default = MP4Remuxer;

/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * passthrough remuxer
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     */


var _events = __webpack_require__(39);

var _events2 = _interopRequireDefault(_events);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PassThroughRemuxer = function () {
  function PassThroughRemuxer(observer) {
    _classCallCheck(this, PassThroughRemuxer);

    this.observer = observer;
  }

  _createClass(PassThroughRemuxer, [{
    key: 'destroy',
    value: function destroy() {}
  }, {
    key: 'resetTimeStamp',
    value: function resetTimeStamp() {}
  }, {
    key: 'resetInitSegment',
    value: function resetInitSegment() {}
  }, {
    key: 'remux',
    value: function remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, contiguous, accurateTimeOffset, rawData) {
      var observer = this.observer;
      var streamType = '';
      if (audioTrack) {
        streamType += 'audio';
      }
      if (videoTrack) {
        streamType += 'video';
      }
      observer.trigger(_events2.default.FRAG_PARSING_DATA, {
        data1: rawData,
        startPTS: timeOffset,
        startDTS: timeOffset,
        type: streamType,
        nb: 1,
        dropped: 0
      });
      //notify end of parsing
      observer.trigger(_events2.default.FRAG_PARSED);
    }
  }]);

  return PassThroughRemuxer;
}();

exports.default = PassThroughRemuxer;

/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DECIMAL_RESOLUTION_REGEX = /^(\d+)x(\d+)$/;
var ATTR_LIST_REGEX = /\s*(.+?)\s*=((?:\".*?\")|.*?)(?:,|$)/g;

// adapted from https://github.com/kanongil/node-m3u8parse/blob/master/attrlist.js

var AttrList = function () {
  function AttrList(attrs) {
    _classCallCheck(this, AttrList);

    if (typeof attrs === 'string') {
      attrs = AttrList.parseAttrList(attrs);
    }
    for (var attr in attrs) {
      if (attrs.hasOwnProperty(attr)) {
        this[attr] = attrs[attr];
      }
    }
  }

  _createClass(AttrList, [{
    key: 'decimalInteger',
    value: function decimalInteger(attrName) {
      var intValue = parseInt(this[attrName], 10);
      if (intValue > Number.MAX_SAFE_INTEGER) {
        return Infinity;
      }
      return intValue;
    }
  }, {
    key: 'hexadecimalInteger',
    value: function hexadecimalInteger(attrName) {
      if (this[attrName]) {
        var stringValue = (this[attrName] || '0x').slice(2);
        stringValue = (stringValue.length & 1 ? '0' : '') + stringValue;

        var value = new Uint8Array(stringValue.length / 2);
        for (var i = 0; i < stringValue.length / 2; i++) {
          value[i] = parseInt(stringValue.slice(i * 2, i * 2 + 2), 16);
        }
        return value;
      } else {
        return null;
      }
    }
  }, {
    key: 'hexadecimalIntegerAsNumber',
    value: function hexadecimalIntegerAsNumber(attrName) {
      var intValue = parseInt(this[attrName], 16);
      if (intValue > Number.MAX_SAFE_INTEGER) {
        return Infinity;
      }
      return intValue;
    }
  }, {
    key: 'decimalFloatingPoint',
    value: function decimalFloatingPoint(attrName) {
      return parseFloat(this[attrName]);
    }
  }, {
    key: 'enumeratedString',
    value: function enumeratedString(attrName) {
      return this[attrName];
    }
  }, {
    key: 'decimalResolution',
    value: function decimalResolution(attrName) {
      var res = DECIMAL_RESOLUTION_REGEX.exec(this[attrName]);
      if (res === null) {
        return undefined;
      }
      return {
        width: parseInt(res[1], 10),
        height: parseInt(res[2], 10)
      };
    }
  }], [{
    key: 'parseAttrList',
    value: function parseAttrList(input) {
      var match,
          attrs = {};
      ATTR_LIST_REGEX.lastIndex = 0;
      while ((match = ATTR_LIST_REGEX.exec(input)) !== null) {
        var value = match[2],
            quote = '"';

        if (value.indexOf(quote) === 0 && value.lastIndexOf(quote) === value.length - 1) {
          value = value.slice(1, -1);
        }
        attrs[match[1]] = value;
      }
      return attrs;
    }
  }]);

  return AttrList;
}();

exports.default = AttrList;

/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 *
 * This code was ported from the dash.js project at:
 *   https://github.com/Dash-Industry-Forum/dash.js/blob/development/externals/cea608-parser.js
 *   https://github.com/Dash-Industry-Forum/dash.js/commit/8269b26a761e0853bb21d78780ed945144ecdd4d#diff-71bc295a2d6b6b7093a1d3290d53a4b2
 *
 * The original copyright appears below:
 *
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2015-2016, DASH Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  1. Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  2. Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */
/**
 *  Exceptions from regular ASCII. CodePoints are mapped to UTF-16 codes
 */

var specialCea608CharsCodes = {
    0x2a: 0xe1, // lowercase a, acute accent
    0x5c: 0xe9, // lowercase e, acute accent
    0x5e: 0xed, // lowercase i, acute accent
    0x5f: 0xf3, // lowercase o, acute accent
    0x60: 0xfa, // lowercase u, acute accent
    0x7b: 0xe7, // lowercase c with cedilla
    0x7c: 0xf7, // division symbol
    0x7d: 0xd1, // uppercase N tilde
    0x7e: 0xf1, // lowercase n tilde
    0x7f: 0x2588, // Full block
    // THIS BLOCK INCLUDES THE 16 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
    // THAT COME FROM HI BYTE=0x11 AND LOW BETWEEN 0x30 AND 0x3F
    // THIS MEANS THAT \x50 MUST BE ADDED TO THE VALUES
    0x80: 0xae, // Registered symbol (R)
    0x81: 0xb0, // degree sign
    0x82: 0xbd, // 1/2 symbol
    0x83: 0xbf, // Inverted (open) question mark
    0x84: 0x2122, // Trademark symbol (TM)
    0x85: 0xa2, // Cents symbol
    0x86: 0xa3, // Pounds sterling
    0x87: 0x266a, // Music 8'th note
    0x88: 0xe0, // lowercase a, grave accent
    0x89: 0x20, // transparent space (regular)
    0x8a: 0xe8, // lowercase e, grave accent
    0x8b: 0xe2, // lowercase a, circumflex accent
    0x8c: 0xea, // lowercase e, circumflex accent
    0x8d: 0xee, // lowercase i, circumflex accent
    0x8e: 0xf4, // lowercase o, circumflex accent
    0x8f: 0xfb, // lowercase u, circumflex accent
    // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
    // THAT COME FROM HI BYTE=0x12 AND LOW BETWEEN 0x20 AND 0x3F
    0x90: 0xc1, // capital letter A with acute
    0x91: 0xc9, // capital letter E with acute
    0x92: 0xd3, // capital letter O with acute
    0x93: 0xda, // capital letter U with acute
    0x94: 0xdc, // capital letter U with diaresis
    0x95: 0xfc, // lowercase letter U with diaeresis
    0x96: 0x2018, // opening single quote
    0x97: 0xa1, // inverted exclamation mark
    0x98: 0x2a, // asterisk
    0x99: 0x2019, // closing single quote
    0x9a: 0x2501, // box drawings heavy horizontal
    0x9b: 0xa9, // copyright sign
    0x9c: 0x2120, // Service mark
    0x9d: 0x2022, // (round) bullet
    0x9e: 0x201c, // Left double quotation mark
    0x9f: 0x201d, // Right double quotation mark
    0xa0: 0xc0, // uppercase A, grave accent
    0xa1: 0xc2, // uppercase A, circumflex
    0xa2: 0xc7, // uppercase C with cedilla
    0xa3: 0xc8, // uppercase E, grave accent
    0xa4: 0xca, // uppercase E, circumflex
    0xa5: 0xcb, // capital letter E with diaresis
    0xa6: 0xeb, // lowercase letter e with diaresis
    0xa7: 0xce, // uppercase I, circumflex
    0xa8: 0xcf, // uppercase I, with diaresis
    0xa9: 0xef, // lowercase i, with diaresis
    0xaa: 0xd4, // uppercase O, circumflex
    0xab: 0xd9, // uppercase U, grave accent
    0xac: 0xf9, // lowercase u, grave accent
    0xad: 0xdb, // uppercase U, circumflex
    0xae: 0xab, // left-pointing double angle quotation mark
    0xaf: 0xbb, // right-pointing double angle quotation mark
    // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
    // THAT COME FROM HI BYTE=0x13 AND LOW BETWEEN 0x20 AND 0x3F
    0xb0: 0xc3, // Uppercase A, tilde
    0xb1: 0xe3, // Lowercase a, tilde
    0xb2: 0xcd, // Uppercase I, acute accent
    0xb3: 0xcc, // Uppercase I, grave accent
    0xb4: 0xec, // Lowercase i, grave accent
    0xb5: 0xd2, // Uppercase O, grave accent
    0xb6: 0xf2, // Lowercase o, grave accent
    0xb7: 0xd5, // Uppercase O, tilde
    0xb8: 0xf5, // Lowercase o, tilde
    0xb9: 0x7b, // Open curly brace
    0xba: 0x7d, // Closing curly brace
    0xbb: 0x5c, // Backslash
    0xbc: 0x5e, // Caret
    0xbd: 0x5f, // Underscore
    0xbe: 0x7c, // Pipe (vertical line)
    0xbf: 0x223c, // Tilde operator
    0xc0: 0xc4, // Uppercase A, umlaut
    0xc1: 0xe4, // Lowercase A, umlaut
    0xc2: 0xd6, // Uppercase O, umlaut
    0xc3: 0xf6, // Lowercase o, umlaut
    0xc4: 0xdf, // Esszett (sharp S)
    0xc5: 0xa5, // Yen symbol
    0xc6: 0xa4, // Generic currency sign
    0xc7: 0x2503, // Box drawings heavy vertical
    0xc8: 0xc5, // Uppercase A, ring
    0xc9: 0xe5, // Lowercase A, ring
    0xca: 0xd8, // Uppercase O, stroke
    0xcb: 0xf8, // Lowercase o, strok
    0xcc: 0x250f, // Box drawings heavy down and right
    0xcd: 0x2513, // Box drawings heavy down and left
    0xce: 0x2517, // Box drawings heavy up and right
    0xcf: 0x251b // Box drawings heavy up and left
};

/**
 * Utils
 */
var getCharForByte = function getCharForByte(byte) {
    var charCode = byte;
    if (specialCea608CharsCodes.hasOwnProperty(byte)) {
        charCode = specialCea608CharsCodes[byte];
    }
    return String.fromCharCode(charCode);
};

var NR_ROWS = 15,
    NR_COLS = 100;
// Tables to look up row from PAC data
var rowsLowCh1 = { 0x11: 1, 0x12: 3, 0x15: 5, 0x16: 7, 0x17: 9, 0x10: 11, 0x13: 12, 0x14: 14 };
var rowsHighCh1 = { 0x11: 2, 0x12: 4, 0x15: 6, 0x16: 8, 0x17: 10, 0x13: 13, 0x14: 15 };
var rowsLowCh2 = { 0x19: 1, 0x1A: 3, 0x1D: 5, 0x1E: 7, 0x1F: 9, 0x18: 11, 0x1B: 12, 0x1C: 14 };
var rowsHighCh2 = { 0x19: 2, 0x1A: 4, 0x1D: 6, 0x1E: 8, 0x1F: 10, 0x1B: 13, 0x1C: 15 };

var backgroundColors = ['white', 'green', 'blue', 'cyan', 'red', 'yellow', 'magenta', 'black', 'transparent'];

/**
 * Simple logger class to be able to write with time-stamps and filter on level.
 */
var logger = {
    verboseFilter: { 'DATA': 3, 'DEBUG': 3, 'INFO': 2, 'WARNING': 2, 'TEXT': 1, 'ERROR': 0 },
    time: null,
    verboseLevel: 0, // Only write errors
    setTime: function setTime(newTime) {
        this.time = newTime;
    },
    log: function log(severity, msg) {
        var minLevel = this.verboseFilter[severity];
        if (this.verboseLevel >= minLevel) {
            console.log(this.time + ' [' + severity + '] ' + msg);
        }
    }
};

var numArrayToHexArray = function numArrayToHexArray(numArray) {
    var hexArray = [];
    for (var j = 0; j < numArray.length; j++) {
        hexArray.push(numArray[j].toString(16));
    }
    return hexArray;
};

var PenState = function () {
    function PenState(foreground, underline, italics, background, flash) {
        _classCallCheck(this, PenState);

        this.foreground = foreground || 'white';
        this.underline = underline || false;
        this.italics = italics || false;
        this.background = background || 'black';
        this.flash = flash || false;
    }

    _createClass(PenState, [{
        key: 'reset',
        value: function reset() {
            this.foreground = 'white';
            this.underline = false;
            this.italics = false;
            this.background = 'black';
            this.flash = false;
        }
    }, {
        key: 'setStyles',
        value: function setStyles(styles) {
            var attribs = ['foreground', 'underline', 'italics', 'background', 'flash'];
            for (var i = 0; i < attribs.length; i++) {
                var style = attribs[i];
                if (styles.hasOwnProperty(style)) {
                    this[style] = styles[style];
                }
            }
        }
    }, {
        key: 'isDefault',
        value: function isDefault() {
            return this.foreground === 'white' && !this.underline && !this.italics && this.background === 'black' && !this.flash;
        }
    }, {
        key: 'equals',
        value: function equals(other) {
            return this.foreground === other.foreground && this.underline === other.underline && this.italics === other.italics && this.background === other.background && this.flash === other.flash;
        }
    }, {
        key: 'copy',
        value: function copy(newPenState) {
            this.foreground = newPenState.foreground;
            this.underline = newPenState.underline;
            this.italics = newPenState.italics;
            this.background = newPenState.background;
            this.flash = newPenState.flash;
        }
    }, {
        key: 'toString',
        value: function toString() {
            return 'color=' + this.foreground + ', underline=' + this.underline + ', italics=' + this.italics + ', background=' + this.background + ', flash=' + this.flash;
        }
    }]);

    return PenState;
}();

/**
 * Unicode character with styling and background.
 * @constructor
 */


var StyledUnicodeChar = function () {
    function StyledUnicodeChar(uchar, foreground, underline, italics, background, flash) {
        _classCallCheck(this, StyledUnicodeChar);

        this.uchar = uchar || ' '; // unicode character
        this.penState = new PenState(foreground, underline, italics, background, flash);
    }

    _createClass(StyledUnicodeChar, [{
        key: 'reset',
        value: function reset() {
            this.uchar = ' ';
            this.penState.reset();
        }
    }, {
        key: 'setChar',
        value: function setChar(uchar, newPenState) {
            this.uchar = uchar;
            this.penState.copy(newPenState);
        }
    }, {
        key: 'setPenState',
        value: function setPenState(newPenState) {
            this.penState.copy(newPenState);
        }
    }, {
        key: 'equals',
        value: function equals(other) {
            return this.uchar === other.uchar && this.penState.equals(other.penState);
        }
    }, {
        key: 'copy',
        value: function copy(newChar) {
            this.uchar = newChar.uchar;
            this.penState.copy(newChar.penState);
        }
    }, {
        key: 'isEmpty',
        value: function isEmpty() {
            return this.uchar === ' ' && this.penState.isDefault();
        }
    }]);

    return StyledUnicodeChar;
}();

/**
 * CEA-608 row consisting of NR_COLS instances of StyledUnicodeChar.
 * @constructor
 */


var Row = function () {
    function Row() {
        _classCallCheck(this, Row);

        this.chars = [];
        for (var i = 0; i < NR_COLS; i++) {
            this.chars.push(new StyledUnicodeChar());
        }
        this.pos = 0;
        this.currPenState = new PenState();
    }

    _createClass(Row, [{
        key: 'equals',
        value: function equals(other) {
            var equal = true;
            for (var i = 0; i < NR_COLS; i++) {
                if (!this.chars[i].equals(other.chars[i])) {
                    equal = false;
                    break;
                }
            }
            return equal;
        }
    }, {
        key: 'copy',
        value: function copy(other) {
            for (var i = 0; i < NR_COLS; i++) {
                this.chars[i].copy(other.chars[i]);
            }
        }
    }, {
        key: 'isEmpty',
        value: function isEmpty() {
            var empty = true;
            for (var i = 0; i < NR_COLS; i++) {
                if (!this.chars[i].isEmpty()) {
                    empty = false;
                    break;
                }
            }
            return empty;
        }

        /**
         *  Set the cursor to a valid column.
         */

    }, {
        key: 'setCursor',
        value: function setCursor(absPos) {
            if (this.pos !== absPos) {
                this.pos = absPos;
            }
            if (this.pos < 0) {
                logger.log('ERROR', 'Negative cursor position ' + this.pos);
                this.pos = 0;
            } else if (this.pos > NR_COLS) {
                logger.log('ERROR', 'Too large cursor position ' + this.pos);
                this.pos = NR_COLS;
            }
        }

        /**
         * Move the cursor relative to current position.
         */

    }, {
        key: 'moveCursor',
        value: function moveCursor(relPos) {
            var newPos = this.pos + relPos;
            if (relPos > 1) {
                for (var i = this.pos + 1; i < newPos + 1; i++) {
                    this.chars[i].setPenState(this.currPenState);
                }
            }
            this.setCursor(newPos);
        }

        /**
         * Backspace, move one step back and clear character.
         */

    }, {
        key: 'backSpace',
        value: function backSpace() {
            this.moveCursor(-1);
            this.chars[this.pos].setChar(' ', this.currPenState);
        }
    }, {
        key: 'insertChar',
        value: function insertChar(byte) {
            if (byte >= 0x90) {
                //Extended char
                this.backSpace();
            }
            var char = getCharForByte(byte);
            if (this.pos >= NR_COLS) {
                logger.log('ERROR', 'Cannot insert ' + byte.toString(16) + ' (' + char + ') at position ' + this.pos + '. Skipping it!');
                return;
            }
            this.chars[this.pos].setChar(char, this.currPenState);
            this.moveCursor(1);
        }
    }, {
        key: 'clearFromPos',
        value: function clearFromPos(startPos) {
            var i;
            for (i = startPos; i < NR_COLS; i++) {
                this.chars[i].reset();
            }
        }
    }, {
        key: 'clear',
        value: function clear() {
            this.clearFromPos(0);
            this.pos = 0;
            this.currPenState.reset();
        }
    }, {
        key: 'clearToEndOfRow',
        value: function clearToEndOfRow() {
            this.clearFromPos(this.pos);
        }
    }, {
        key: 'getTextString',
        value: function getTextString() {
            var chars = [];
            var empty = true;
            for (var i = 0; i < NR_COLS; i++) {
                var char = this.chars[i].uchar;
                if (char !== ' ') {
                    empty = false;
                }
                chars.push(char);
            }
            if (empty) {
                return '';
            } else {
                return chars.join('');
            }
        }
    }, {
        key: 'setPenStyles',
        value: function setPenStyles(styles) {
            this.currPenState.setStyles(styles);
            var currChar = this.chars[this.pos];
            currChar.setPenState(this.currPenState);
        }
    }]);

    return Row;
}();

/**
 * Keep a CEA-608 screen of 32x15 styled characters
 * @constructor
*/


var CaptionScreen = function () {
    function CaptionScreen() {
        _classCallCheck(this, CaptionScreen);

        this.rows = [];
        for (var i = 0; i < NR_ROWS; i++) {
            this.rows.push(new Row()); // Note that we use zero-based numbering (0-14)
        }
        this.currRow = NR_ROWS - 1;
        this.nrRollUpRows = null;
        this.reset();
    }

    _createClass(CaptionScreen, [{
        key: 'reset',
        value: function reset() {
            for (var i = 0; i < NR_ROWS; i++) {
                this.rows[i].clear();
            }
            this.currRow = NR_ROWS - 1;
        }
    }, {
        key: 'equals',
        value: function equals(other) {
            var equal = true;
            for (var i = 0; i < NR_ROWS; i++) {
                if (!this.rows[i].equals(other.rows[i])) {
                    equal = false;
                    break;
                }
            }
            return equal;
        }
    }, {
        key: 'copy',
        value: function copy(other) {
            for (var i = 0; i < NR_ROWS; i++) {
                this.rows[i].copy(other.rows[i]);
            }
        }
    }, {
        key: 'isEmpty',
        value: function isEmpty() {
            var empty = true;
            for (var i = 0; i < NR_ROWS; i++) {
                if (!this.rows[i].isEmpty()) {
                    empty = false;
                    break;
                }
            }
            return empty;
        }
    }, {
        key: 'backSpace',
        value: function backSpace() {
            var row = this.rows[this.currRow];
            row.backSpace();
        }
    }, {
        key: 'clearToEndOfRow',
        value: function clearToEndOfRow() {
            var row = this.rows[this.currRow];
            row.clearToEndOfRow();
        }

        /**
         * Insert a character (without styling) in the current row.
         */

    }, {
        key: 'insertChar',
        value: function insertChar(char) {
            var row = this.rows[this.currRow];
            row.insertChar(char);
        }
    }, {
        key: 'setPen',
        value: function setPen(styles) {
            var row = this.rows[this.currRow];
            row.setPenStyles(styles);
        }
    }, {
        key: 'moveCursor',
        value: function moveCursor(relPos) {
            var row = this.rows[this.currRow];
            row.moveCursor(relPos);
        }
    }, {
        key: 'setCursor',
        value: function setCursor(absPos) {
            logger.log('INFO', 'setCursor: ' + absPos);
            var row = this.rows[this.currRow];
            row.setCursor(absPos);
        }
    }, {
        key: 'setPAC',
        value: function setPAC(pacData) {
            logger.log('INFO', 'pacData = ' + JSON.stringify(pacData));
            var newRow = pacData.row - 1;
            if (this.nrRollUpRows && newRow < this.nrRollUpRows - 1) {
                newRow = this.nrRollUpRows - 1;
            }

            //Make sure this only affects Roll-up Captions by checking this.nrRollUpRows
            if (this.nrRollUpRows && this.currRow !== newRow) {
                //clear all rows first
                for (var i = 0; i < NR_ROWS; i++) {
                    this.rows[i].clear();
                }

                //Copy this.nrRollUpRows rows from lastOutputScreen and place it in the newRow location
                //topRowIndex - the start of rows to copy (inclusive index)
                var topRowIndex = this.currRow + 1 - this.nrRollUpRows;
                //We only copy if the last position was already shown.
                //We use the cueStartTime value to check this.
                var lastOutputScreen = this.lastOutputScreen;
                if (lastOutputScreen) {
                    var prevLineTime = lastOutputScreen.rows[topRowIndex].cueStartTime;
                    if (prevLineTime && prevLineTime < logger.time) {
                        for (var _i = 0; _i < this.nrRollUpRows; _i++) {
                            this.rows[newRow - this.nrRollUpRows + _i + 1].copy(lastOutputScreen.rows[topRowIndex + _i]);
                        }
                    }
                }
            }

            this.currRow = newRow;
            var row = this.rows[this.currRow];
            if (pacData.indent !== null) {
                var indent = pacData.indent;
                var prevPos = Math.max(indent - 1, 0);
                row.setCursor(pacData.indent);
                pacData.color = row.chars[prevPos].penState.foreground;
            }
            var styles = { foreground: pacData.color, underline: pacData.underline, italics: pacData.italics, background: 'black', flash: false };
            this.setPen(styles);
        }

        /**
         * Set background/extra foreground, but first do back_space, and then insert space (backwards compatibility).
         */

    }, {
        key: 'setBkgData',
        value: function setBkgData(bkgData) {

            logger.log('INFO', 'bkgData = ' + JSON.stringify(bkgData));
            this.backSpace();
            this.setPen(bkgData);
            this.insertChar(0x20); //Space
        }
    }, {
        key: 'setRollUpRows',
        value: function setRollUpRows(nrRows) {
            this.nrRollUpRows = nrRows;
        }
    }, {
        key: 'rollUp',
        value: function rollUp() {
            if (this.nrRollUpRows === null) {
                logger.log('DEBUG', 'roll_up but nrRollUpRows not set yet');
                return; //Not properly setup
            }
            logger.log('TEXT', this.getDisplayText());
            var topRowIndex = this.currRow + 1 - this.nrRollUpRows;
            var topRow = this.rows.splice(topRowIndex, 1)[0];
            topRow.clear();
            this.rows.splice(this.currRow, 0, topRow);
            logger.log('INFO', 'Rolling up');
            //logger.log('TEXT', this.get_display_text())
        }

        /**
         * Get all non-empty rows with as unicode text.
         */

    }, {
        key: 'getDisplayText',
        value: function getDisplayText(asOneRow) {
            asOneRow = asOneRow || false;
            var displayText = [];
            var text = '';
            var rowNr = -1;
            for (var i = 0; i < NR_ROWS; i++) {
                var rowText = this.rows[i].getTextString();
                if (rowText) {
                    rowNr = i + 1;
                    if (asOneRow) {
                        displayText.push('Row ' + rowNr + ': \'' + rowText + '\'');
                    } else {
                        displayText.push(rowText.trim());
                    }
                }
            }
            if (displayText.length > 0) {
                if (asOneRow) {
                    text = '[' + displayText.join(' | ') + ']';
                } else {
                    text = displayText.join('\n');
                }
            }
            return text;
        }
    }, {
        key: 'getTextAndFormat',
        value: function getTextAndFormat() {
            return this.rows;
        }
    }]);

    return CaptionScreen;
}();

//var modes = ['MODE_ROLL-UP', 'MODE_POP-ON', 'MODE_PAINT-ON', 'MODE_TEXT'];

var Cea608Channel = function () {
    function Cea608Channel(channelNumber, outputFilter) {
        _classCallCheck(this, Cea608Channel);

        this.chNr = channelNumber;
        this.outputFilter = outputFilter;
        this.mode = null;
        this.verbose = 0;
        this.displayedMemory = new CaptionScreen();
        this.nonDisplayedMemory = new CaptionScreen();
        this.lastOutputScreen = new CaptionScreen();
        this.currRollUpRow = this.displayedMemory.rows[NR_ROWS - 1];
        this.writeScreen = this.displayedMemory;
        this.mode = null;
        this.cueStartTime = null; // Keeps track of where a cue started.
    }

    _createClass(Cea608Channel, [{
        key: 'reset',
        value: function reset() {
            this.mode = null;
            this.displayedMemory.reset();
            this.nonDisplayedMemory.reset();
            this.lastOutputScreen.reset();
            this.currRollUpRow = this.displayedMemory.rows[NR_ROWS - 1];
            this.writeScreen = this.displayedMemory;
            this.mode = null;
            this.cueStartTime = null;
            this.lastCueEndTime = null;
        }
    }, {
        key: 'getHandler',
        value: function getHandler() {
            return this.outputFilter;
        }
    }, {
        key: 'setHandler',
        value: function setHandler(newHandler) {
            this.outputFilter = newHandler;
        }
    }, {
        key: 'setPAC',
        value: function setPAC(pacData) {
            this.writeScreen.setPAC(pacData);
        }
    }, {
        key: 'setBkgData',
        value: function setBkgData(bkgData) {
            this.writeScreen.setBkgData(bkgData);
        }
    }, {
        key: 'setMode',
        value: function setMode(newMode) {
            if (newMode === this.mode) {
                return;
            }
            this.mode = newMode;
            logger.log('INFO', 'MODE=' + newMode);
            if (this.mode === 'MODE_POP-ON') {
                this.writeScreen = this.nonDisplayedMemory;
            } else {
                this.writeScreen = this.displayedMemory;
                this.writeScreen.reset();
            }
            if (this.mode !== 'MODE_ROLL-UP') {
                this.displayedMemory.nrRollUpRows = null;
                this.nonDisplayedMemory.nrRollUpRows = null;
            }
            this.mode = newMode;
        }
    }, {
        key: 'insertChars',
        value: function insertChars(chars) {
            for (var i = 0; i < chars.length; i++) {
                this.writeScreen.insertChar(chars[i]);
            }
            var screen = this.writeScreen === this.displayedMemory ? 'DISP' : 'NON_DISP';
            logger.log('INFO', screen + ': ' + this.writeScreen.getDisplayText(true));
            if (this.mode === 'MODE_PAINT-ON' || this.mode === 'MODE_ROLL-UP') {
                logger.log('TEXT', 'DISPLAYED: ' + this.displayedMemory.getDisplayText(true));
                this.outputDataUpdate();
            }
        }
    }, {
        key: 'ccRCL',
        value: function ccRCL() {
            // Resume Caption Loading (switch mode to Pop On)
            logger.log('INFO', 'RCL - Resume Caption Loading');
            this.setMode('MODE_POP-ON');
        }
    }, {
        key: 'ccBS',
        value: function ccBS() {
            // BackSpace
            logger.log('INFO', 'BS - BackSpace');
            if (this.mode === 'MODE_TEXT') {
                return;
            }
            this.writeScreen.backSpace();
            if (this.writeScreen === this.displayedMemory) {
                this.outputDataUpdate();
            }
        }
    }, {
        key: 'ccAOF',
        value: function ccAOF() {
            // Reserved (formerly Alarm Off)
            return;
        }
    }, {
        key: 'ccAON',
        value: function ccAON() {
            // Reserved (formerly Alarm On)
            return;
        }
    }, {
        key: 'ccDER',
        value: function ccDER() {
            // Delete to End of Row
            logger.log('INFO', 'DER- Delete to End of Row');
            this.writeScreen.clearToEndOfRow();
            this.outputDataUpdate();
        }
    }, {
        key: 'ccRU',
        value: function ccRU(nrRows) {
            //Roll-Up Captions-2,3,or 4 Rows
            logger.log('INFO', 'RU(' + nrRows + ') - Roll Up');
            this.writeScreen = this.displayedMemory;
            this.setMode('MODE_ROLL-UP');
            this.writeScreen.setRollUpRows(nrRows);
        }
    }, {
        key: 'ccFON',
        value: function ccFON() {
            //Flash On
            logger.log('INFO', 'FON - Flash On');
            this.writeScreen.setPen({ flash: true });
        }
    }, {
        key: 'ccRDC',
        value: function ccRDC() {
            // Resume Direct Captioning (switch mode to PaintOn)
            logger.log('INFO', 'RDC - Resume Direct Captioning');
            this.setMode('MODE_PAINT-ON');
        }
    }, {
        key: 'ccTR',
        value: function ccTR() {
            // Text Restart in text mode (not supported, however)
            logger.log('INFO', 'TR');
            this.setMode('MODE_TEXT');
        }
    }, {
        key: 'ccRTD',
        value: function ccRTD() {
            // Resume Text Display in Text mode (not supported, however)
            logger.log('INFO', 'RTD');
            this.setMode('MODE_TEXT');
        }
    }, {
        key: 'ccEDM',
        value: function ccEDM() {
            // Erase Displayed Memory
            logger.log('INFO', 'EDM - Erase Displayed Memory');
            this.displayedMemory.reset();
            this.outputDataUpdate();
        }
    }, {
        key: 'ccCR',
        value: function ccCR() {
            // Carriage Return
            logger.log('CR - Carriage Return');
            this.writeScreen.rollUp();
            this.outputDataUpdate();
        }
    }, {
        key: 'ccENM',
        value: function ccENM() {
            //Erase Non-Displayed Memory
            logger.log('INFO', 'ENM - Erase Non-displayed Memory');
            this.nonDisplayedMemory.reset();
        }
    }, {
        key: 'ccEOC',
        value: function ccEOC() {
            //End of Caption (Flip Memories)
            logger.log('INFO', 'EOC - End Of Caption');
            if (this.mode === 'MODE_POP-ON') {
                var tmp = this.displayedMemory;
                this.displayedMemory = this.nonDisplayedMemory;
                this.nonDisplayedMemory = tmp;
                this.writeScreen = this.nonDisplayedMemory;
                logger.log('TEXT', 'DISP: ' + this.displayedMemory.getDisplayText());
            }
            this.outputDataUpdate();
        }
    }, {
        key: 'ccTO',
        value: function ccTO(nrCols) {
            // Tab Offset 1,2, or 3 columns
            logger.log('INFO', 'TO(' + nrCols + ') - Tab Offset');
            this.writeScreen.moveCursor(nrCols);
        }
    }, {
        key: 'ccMIDROW',
        value: function ccMIDROW(secondByte) {
            // Parse MIDROW command
            var styles = { flash: false };
            styles.underline = secondByte % 2 === 1;
            styles.italics = secondByte >= 0x2e;
            if (!styles.italics) {
                var colorIndex = Math.floor(secondByte / 2) - 0x10;
                var colors = ['white', 'green', 'blue', 'cyan', 'red', 'yellow', 'magenta'];
                styles.foreground = colors[colorIndex];
            } else {
                styles.foreground = 'white';
            }
            logger.log('INFO', 'MIDROW: ' + JSON.stringify(styles));
            this.writeScreen.setPen(styles);
        }
    }, {
        key: 'outputDataUpdate',
        value: function outputDataUpdate() {
            var t = logger.time;
            if (t === null) {
                return;
            }
            if (this.outputFilter) {
                if (this.outputFilter.updateData) {
                    this.outputFilter.updateData(t, this.displayedMemory);
                }
                if (this.cueStartTime === null && !this.displayedMemory.isEmpty()) {
                    // Start of a new cue
                    this.cueStartTime = t;
                } else {
                    if (!this.displayedMemory.equals(this.lastOutputScreen)) {
                        if (this.outputFilter.newCue) {
                            this.outputFilter.newCue(this.cueStartTime, t, this.lastOutputScreen);
                        }
                        this.cueStartTime = this.displayedMemory.isEmpty() ? null : t;
                    }
                }
                this.lastOutputScreen.copy(this.displayedMemory);
            }
        }
    }, {
        key: 'cueSplitAtTime',
        value: function cueSplitAtTime(t) {
            if (this.outputFilter) {
                if (!this.displayedMemory.isEmpty()) {
                    if (this.outputFilter.newCue) {
                        this.outputFilter.newCue(this.cueStartTime, t, this.displayedMemory);
                    }
                    this.cueStartTime = t;
                }
            }
        }
    }]);

    return Cea608Channel;
}();

var Cea608Parser = function () {
    function Cea608Parser(field, out1, out2) {
        _classCallCheck(this, Cea608Parser);

        this.field = field || 1;
        this.outputs = [out1, out2];
        this.channels = [new Cea608Channel(1, out1), new Cea608Channel(2, out2)];
        this.currChNr = -1; // Will be 1 or 2
        this.lastCmdA = null; // First byte of last command
        this.lastCmdB = null; // Second byte of last command
        this.bufferedData = [];
        this.startTime = null;
        this.lastTime = null;
        this.dataCounters = { 'padding': 0, 'char': 0, 'cmd': 0, 'other': 0 };
    }

    _createClass(Cea608Parser, [{
        key: 'getHandler',
        value: function getHandler(index) {
            return this.channels[index].getHandler();
        }
    }, {
        key: 'setHandler',
        value: function setHandler(index, newHandler) {
            this.channels[index].setHandler(newHandler);
        }

        /**
         * Add data for time t in forms of list of bytes (unsigned ints). The bytes are treated as pairs.
         */

    }, {
        key: 'addData',
        value: function addData(t, byteList) {
            var cmdFound,
                a,
                b,
                charsFound = false;

            this.lastTime = t;
            logger.setTime(t);

            for (var i = 0; i < byteList.length; i += 2) {
                a = byteList[i] & 0x7f;
                b = byteList[i + 1] & 0x7f;
                if (a === 0 && b === 0) {
                    this.dataCounters.padding += 2;
                    continue;
                } else {
                    logger.log('DATA', '[' + numArrayToHexArray([byteList[i], byteList[i + 1]]) + '] -> (' + numArrayToHexArray([a, b]) + ')');
                }
                cmdFound = this.parseCmd(a, b);
                if (!cmdFound) {
                    cmdFound = this.parseMidrow(a, b);
                }
                if (!cmdFound) {
                    cmdFound = this.parsePAC(a, b);
                }
                if (!cmdFound) {
                    cmdFound = this.parseBackgroundAttributes(a, b);
                }
                if (!cmdFound) {
                    charsFound = this.parseChars(a, b);
                    if (charsFound) {
                        if (this.currChNr && this.currChNr >= 0) {
                            var channel = this.channels[this.currChNr - 1];
                            channel.insertChars(charsFound);
                        } else {
                            logger.log('WARNING', 'No channel found yet. TEXT-MODE?');
                        }
                    }
                }
                if (cmdFound) {
                    this.dataCounters.cmd += 2;
                } else if (charsFound) {
                    this.dataCounters.char += 2;
                } else {
                    this.dataCounters.other += 2;
                    logger.log('WARNING', 'Couldn\'t parse cleaned data ' + numArrayToHexArray([a, b]) + ' orig: ' + numArrayToHexArray([byteList[i], byteList[i + 1]]));
                }
            }
        }

        /**
         * Parse Command.
         * @returns {Boolean} Tells if a command was found
         */

    }, {
        key: 'parseCmd',
        value: function parseCmd(a, b) {
            var chNr = null;

            var cond1 = (a === 0x14 || a === 0x1C) && 0x20 <= b && b <= 0x2F;
            var cond2 = (a === 0x17 || a === 0x1F) && 0x21 <= b && b <= 0x23;
            if (!(cond1 || cond2)) {
                return false;
            }

            if (a === this.lastCmdA && b === this.lastCmdB) {
                this.lastCmdA = null;
                this.lastCmdB = null; // Repeated commands are dropped (once)
                logger.log('DEBUG', 'Repeated command (' + numArrayToHexArray([a, b]) + ') is dropped');
                return true;
            }

            if (a === 0x14 || a === 0x17) {
                chNr = 1;
            } else {
                chNr = 2; // (a === 0x1C || a=== 0x1f)
            }

            var channel = this.channels[chNr - 1];

            if (a === 0x14 || a === 0x1C) {
                if (b === 0x20) {
                    channel.ccRCL();
                } else if (b === 0x21) {
                    channel.ccBS();
                } else if (b === 0x22) {
                    channel.ccAOF();
                } else if (b === 0x23) {
                    channel.ccAON();
                } else if (b === 0x24) {
                    channel.ccDER();
                } else if (b === 0x25) {
                    channel.ccRU(2);
                } else if (b === 0x26) {
                    channel.ccRU(3);
                } else if (b === 0x27) {
                    channel.ccRU(4);
                } else if (b === 0x28) {
                    channel.ccFON();
                } else if (b === 0x29) {
                    channel.ccRDC();
                } else if (b === 0x2A) {
                    channel.ccTR();
                } else if (b === 0x2B) {
                    channel.ccRTD();
                } else if (b === 0x2C) {
                    channel.ccEDM();
                } else if (b === 0x2D) {
                    channel.ccCR();
                } else if (b === 0x2E) {
                    channel.ccENM();
                } else if (b === 0x2F) {
                    channel.ccEOC();
                }
            } else {
                //a == 0x17 || a == 0x1F
                channel.ccTO(b - 0x20);
            }
            this.lastCmdA = a;
            this.lastCmdB = b;
            this.currChNr = chNr;
            return true;
        }

        /**
         * Parse midrow styling command
         * @returns {Boolean}
         */

    }, {
        key: 'parseMidrow',
        value: function parseMidrow(a, b) {
            var chNr = null;

            if ((a === 0x11 || a === 0x19) && 0x20 <= b && b <= 0x2f) {
                if (a === 0x11) {
                    chNr = 1;
                } else {
                    chNr = 2;
                }
                if (chNr !== this.currChNr) {
                    logger.log('ERROR', 'Mismatch channel in midrow parsing');
                    return false;
                }
                var channel = this.channels[chNr - 1];
                channel.ccMIDROW(b);
                logger.log('DEBUG', 'MIDROW (' + numArrayToHexArray([a, b]) + ')');
                return true;
            }
            return false;
        }
        /**
         * Parse Preable Access Codes (Table 53).
         * @returns {Boolean} Tells if PAC found
         */

    }, {
        key: 'parsePAC',
        value: function parsePAC(a, b) {

            var chNr = null;
            var row = null;

            var case1 = (0x11 <= a && a <= 0x17 || 0x19 <= a && a <= 0x1F) && 0x40 <= b && b <= 0x7F;
            var case2 = (a === 0x10 || a === 0x18) && 0x40 <= b && b <= 0x5F;
            if (!(case1 || case2)) {
                return false;
            }

            if (a === this.lastCmdA && b === this.lastCmdB) {
                this.lastCmdA = null;
                this.lastCmdB = null;
                return true; // Repeated commands are dropped (once)
            }

            chNr = a <= 0x17 ? 1 : 2;

            if (0x40 <= b && b <= 0x5F) {
                row = chNr === 1 ? rowsLowCh1[a] : rowsLowCh2[a];
            } else {
                // 0x60 <= b <= 0x7F
                row = chNr === 1 ? rowsHighCh1[a] : rowsHighCh2[a];
            }
            var pacData = this.interpretPAC(row, b);
            var channel = this.channels[chNr - 1];
            channel.setPAC(pacData);
            this.lastCmdA = a;
            this.lastCmdB = b;
            this.currChNr = chNr;
            return true;
        }

        /**
         * Interpret the second byte of the pac, and return the information.
         * @returns {Object} pacData with style parameters.
         */

    }, {
        key: 'interpretPAC',
        value: function interpretPAC(row, byte) {
            var pacIndex = byte;
            var pacData = { color: null, italics: false, indent: null, underline: false, row: row };

            if (byte > 0x5F) {
                pacIndex = byte - 0x60;
            } else {
                pacIndex = byte - 0x40;
            }
            pacData.underline = (pacIndex & 1) === 1;
            if (pacIndex <= 0xd) {
                pacData.color = ['white', 'green', 'blue', 'cyan', 'red', 'yellow', 'magenta', 'white'][Math.floor(pacIndex / 2)];
            } else if (pacIndex <= 0xf) {
                pacData.italics = true;
                pacData.color = 'white';
            } else {
                pacData.indent = Math.floor((pacIndex - 0x10) / 2) * 4;
            }
            return pacData; // Note that row has zero offset. The spec uses 1.
        }

        /**
         * Parse characters.
         * @returns An array with 1 to 2 codes corresponding to chars, if found. null otherwise.
         */

    }, {
        key: 'parseChars',
        value: function parseChars(a, b) {

            var channelNr = null,
                charCodes = null,
                charCode1 = null;

            if (a >= 0x19) {
                channelNr = 2;
                charCode1 = a - 8;
            } else {
                channelNr = 1;
                charCode1 = a;
            }
            if (0x11 <= charCode1 && charCode1 <= 0x13) {
                // Special character
                var oneCode = b;
                if (charCode1 === 0x11) {
                    oneCode = b + 0x50;
                } else if (charCode1 === 0x12) {
                    oneCode = b + 0x70;
                } else {
                    oneCode = b + 0x90;
                }
                logger.log('INFO', 'Special char \'' + getCharForByte(oneCode) + '\' in channel ' + channelNr);
                charCodes = [oneCode];
            } else if (0x20 <= a && a <= 0x7f) {
                charCodes = b === 0 ? [a] : [a, b];
            }
            if (charCodes) {
                var hexCodes = numArrayToHexArray(charCodes);
                logger.log('DEBUG', 'Char codes =  ' + hexCodes.join(','));
                this.lastCmdA = null;
                this.lastCmdB = null;
            }
            return charCodes;
        }

        /**
        * Parse extended background attributes as well as new foreground color black.
        * @returns{Boolean} Tells if background attributes are found
        */

    }, {
        key: 'parseBackgroundAttributes',
        value: function parseBackgroundAttributes(a, b) {
            var bkgData, index, chNr, channel;

            var case1 = (a === 0x10 || a === 0x18) && 0x20 <= b && b <= 0x2f;
            var case2 = (a === 0x17 || a === 0x1f) && 0x2d <= b && b <= 0x2f;
            if (!(case1 || case2)) {
                return false;
            }
            bkgData = {};
            if (a === 0x10 || a === 0x18) {
                index = Math.floor((b - 0x20) / 2);
                bkgData.background = backgroundColors[index];
                if (b % 2 === 1) {
                    bkgData.background = bkgData.background + '_semi';
                }
            } else if (b === 0x2d) {
                bkgData.background = 'transparent';
            } else {
                bkgData.foreground = 'black';
                if (b === 0x2f) {
                    bkgData.underline = true;
                }
            }
            chNr = a < 0x18 ? 1 : 2;
            channel = this.channels[chNr - 1];
            channel.setBkgData(bkgData);
            this.lastCmdA = null;
            this.lastCmdB = null;
            return true;
        }

        /**
         * Reset state of parser and its channels.
         */

    }, {
        key: 'reset',
        value: function reset() {
            for (var i = 0; i < this.channels.length; i++) {
                if (this.channels[i]) {
                    this.channels[i].reset();
                }
            }
            this.lastCmdA = null;
            this.lastCmdB = null;
        }

        /**
         * Trigger the generation of a cue, and the start of a new one if displayScreens are not empty.
         */

    }, {
        key: 'cueSplitAtTime',
        value: function cueSplitAtTime(t) {
            for (var i = 0; i < this.channels.length; i++) {
                if (this.channels[i]) {
                    this.channels[i].cueSplitAtTime(t);
                }
            }
        }
    }]);

    return Cea608Parser;
}();

exports.default = Cea608Parser;

/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vttparser = __webpack_require__(610);

var Cues = {

  newCue: function newCue(track, startTime, endTime, captionScreen) {
    var row;
    var cue;
    var indenting;
    var indent;
    var text;
    var VTTCue = window.VTTCue || window.TextTrackCue;

    for (var r = 0; r < captionScreen.rows.length; r++) {
      row = captionScreen.rows[r];
      indenting = true;
      indent = 0;
      text = '';

      if (!row.isEmpty()) {
        for (var c = 0; c < row.chars.length; c++) {
          if (row.chars[c].uchar.match(/\s/) && indenting) {
            indent++;
          } else {
            text += row.chars[c].uchar;
            indenting = false;
          }
        }
        //To be used for cleaning-up orphaned roll-up captions
        row.cueStartTime = startTime;

        // Give a slight bump to the endTime if it's equal to startTime to avoid a SyntaxError in IE
        if (startTime === endTime) {
          endTime += 0.0001;
        }

        cue = new VTTCue(startTime, endTime, (0, _vttparser.fixLineBreaks)(text.trim()));

        if (indent >= 16) {
          indent--;
        } else {
          indent++;
        }

        // VTTCue.line get's flakey when using controls, so let's now include line 13&14
        // also, drop line 1 since it's to close to the top
        if (navigator.userAgent.match(/Firefox\//)) {
          cue.line = r + 1;
        } else {
          cue.line = r > 7 ? r - 2 : r + 1;
        }
        cue.align = 'left';
        // Clamp the position between 0 and 100 - if out of these bounds, Firefox throws an exception and captions break
        cue.position = Math.max(0, Math.min(100, 100 * (indent / 32) + (navigator.userAgent.match(/Firefox\//) ? 50 : 0)));
        track.addCue(cue);
      }
    }
  }

};

module.exports = Cues;

/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * EWMA Bandwidth Estimator
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *  - heavily inspired from shaka-player
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Tracks bandwidth samples and estimates available bandwidth.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Based on the minimum of two exponentially-weighted moving averages with
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * different half-lives.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _ewma = __webpack_require__(1474);

var _ewma2 = _interopRequireDefault(_ewma);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EwmaBandWidthEstimator = function () {
  function EwmaBandWidthEstimator(hls, slow, fast, defaultEstimate) {
    _classCallCheck(this, EwmaBandWidthEstimator);

    this.hls = hls;
    this.defaultEstimate_ = defaultEstimate;
    this.minWeight_ = 0.001;
    this.minDelayMs_ = 50;
    this.slow_ = new _ewma2.default(slow);
    this.fast_ = new _ewma2.default(fast);
  }

  _createClass(EwmaBandWidthEstimator, [{
    key: 'sample',
    value: function sample(durationMs, numBytes) {
      durationMs = Math.max(durationMs, this.minDelayMs_);
      var bandwidth = 8000 * numBytes / durationMs,

      //console.log('instant bw:'+ Math.round(bandwidth));
      // we weight sample using loading duration....
      weight = durationMs / 1000;
      this.fast_.sample(weight, bandwidth);
      this.slow_.sample(weight, bandwidth);
    }
  }, {
    key: 'canEstimate',
    value: function canEstimate() {
      var fast = this.fast_;
      return fast && fast.getTotalWeight() >= this.minWeight_;
    }
  }, {
    key: 'getEstimate',
    value: function getEstimate() {
      if (this.canEstimate()) {
        //console.log('slow estimate:'+ Math.round(this.slow_.getEstimate()));
        //console.log('fast estimate:'+ Math.round(this.fast_.getEstimate()));
        // Take the minimum of these two estimates.  This should have the effect of
        // adapting down quickly, but up more slowly.
        return Math.min(this.fast_.getEstimate(), this.slow_.getEstimate());
      } else {
        return this.defaultEstimate_;
      }
    }
  }, {
    key: 'destroy',
    value: function destroy() {}
  }]);

  return EwmaBandWidthEstimator;
}();

exports.default = EwmaBandWidthEstimator;

/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 * compute an Exponential Weighted moving average
 * - https://en.wikipedia.org/wiki/Moving_average#Exponential_moving_average
 *  - heavily inspired from shaka-player
 */

var EWMA = function () {

  //  About half of the estimated value will be from the last |halfLife| samples by weight.
  function EWMA(halfLife) {
    _classCallCheck(this, EWMA);

    // Larger values of alpha expire historical data more slowly.
    this.alpha_ = halfLife ? Math.exp(Math.log(0.5) / halfLife) : 0;
    this.estimate_ = 0;
    this.totalWeight_ = 0;
  }

  _createClass(EWMA, [{
    key: "sample",
    value: function sample(weight, value) {
      var adjAlpha = Math.pow(this.alpha_, weight);
      this.estimate_ = value * (1 - adjAlpha) + adjAlpha * this.estimate_;
      this.totalWeight_ += weight;
    }
  }, {
    key: "getTotalWeight",
    value: function getTotalWeight() {
      return this.totalWeight_;
    }
  }, {
    key: "getEstimate",
    value: function getEstimate() {
      if (this.alpha_) {
        var zeroFactor = 1 - Math.pow(this.alpha_, this.totalWeight_);
        return this.estimate_ / zeroFactor;
      } else {
        return this.estimate_;
      }
    }
  }]);

  return EWMA;
}();

exports.default = EWMA;

/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

/**
 * Copyright 2013 vtt.js Contributors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

exports.default = function () {
  if (typeof window !== 'undefined' && window.VTTCue) {
    return window.VTTCue;
  }

  var autoKeyword = 'auto';
  var directionSetting = {
    '': true,
    lr: true,
    rl: true
  };
  var alignSetting = {
    start: true,
    middle: true,
    end: true,
    left: true,
    right: true
  };

  function findDirectionSetting(value) {
    if (typeof value !== 'string') {
      return false;
    }
    var dir = directionSetting[value.toLowerCase()];
    return dir ? value.toLowerCase() : false;
  }

  function findAlignSetting(value) {
    if (typeof value !== 'string') {
      return false;
    }
    var align = alignSetting[value.toLowerCase()];
    return align ? value.toLowerCase() : false;
  }

  function extend(obj) {
    var i = 1;
    for (; i < arguments.length; i++) {
      var cobj = arguments[i];
      for (var p in cobj) {
        obj[p] = cobj[p];
      }
    }

    return obj;
  }

  function VTTCue(startTime, endTime, text) {
    var cue = this;
    var isIE8 = function () {
      if (typeof navigator === 'undefined') {
        return;
      }
      return (/MSIE\s8\.0/.test(navigator.userAgent)
      );
    }();
    var baseObj = {};

    if (isIE8) {
      cue = document.createElement('custom');
    } else {
      baseObj.enumerable = true;
    }

    /**
     * Shim implementation specific properties. These properties are not in
     * the spec.
     */

    // Lets us know when the VTTCue's data has changed in such a way that we need
    // to recompute its display state. This lets us compute its display state
    // lazily.
    cue.hasBeenReset = false;

    /**
     * VTTCue and TextTrackCue properties
     * http://dev.w3.org/html5/webvtt/#vttcue-interface
     */

    var _id = '';
    var _pauseOnExit = false;
    var _startTime = startTime;
    var _endTime = endTime;
    var _text = text;
    var _region = null;
    var _vertical = '';
    var _snapToLines = true;
    var _line = 'auto';
    var _lineAlign = 'start';
    var _position = 50;
    var _positionAlign = 'middle';
    var _size = 50;
    var _align = 'middle';

    Object.defineProperty(cue, 'id', extend({}, baseObj, {
      get: function get() {
        return _id;
      },
      set: function set(value) {
        _id = '' + value;
      }
    }));

    Object.defineProperty(cue, 'pauseOnExit', extend({}, baseObj, {
      get: function get() {
        return _pauseOnExit;
      },
      set: function set(value) {
        _pauseOnExit = !!value;
      }
    }));

    Object.defineProperty(cue, 'startTime', extend({}, baseObj, {
      get: function get() {
        return _startTime;
      },
      set: function set(value) {
        if (typeof value !== 'number') {
          throw new TypeError('Start time must be set to a number.');
        }
        _startTime = value;
        this.hasBeenReset = true;
      }
    }));

    Object.defineProperty(cue, 'endTime', extend({}, baseObj, {
      get: function get() {
        return _endTime;
      },
      set: function set(value) {
        if (typeof value !== 'number') {
          throw new TypeError('End time must be set to a number.');
        }
        _endTime = value;
        this.hasBeenReset = true;
      }
    }));

    Object.defineProperty(cue, 'text', extend({}, baseObj, {
      get: function get() {
        return _text;
      },
      set: function set(value) {
        _text = '' + value;
        this.hasBeenReset = true;
      }
    }));

    Object.defineProperty(cue, 'region', extend({}, baseObj, {
      get: function get() {
        return _region;
      },
      set: function set(value) {
        _region = value;
        this.hasBeenReset = true;
      }
    }));

    Object.defineProperty(cue, 'vertical', extend({}, baseObj, {
      get: function get() {
        return _vertical;
      },
      set: function set(value) {
        var setting = findDirectionSetting(value);
        // Have to check for false because the setting an be an empty string.
        if (setting === false) {
          throw new SyntaxError('An invalid or illegal string was specified.');
        }
        _vertical = setting;
        this.hasBeenReset = true;
      }
    }));

    Object.defineProperty(cue, 'snapToLines', extend({}, baseObj, {
      get: function get() {
        return _snapToLines;
      },
      set: function set(value) {
        _snapToLines = !!value;
        this.hasBeenReset = true;
      }
    }));

    Object.defineProperty(cue, 'line', extend({}, baseObj, {
      get: function get() {
        return _line;
      },
      set: function set(value) {
        if (typeof value !== 'number' && value !== autoKeyword) {
          throw new SyntaxError('An invalid number or illegal string was specified.');
        }
        _line = value;
        this.hasBeenReset = true;
      }
    }));

    Object.defineProperty(cue, 'lineAlign', extend({}, baseObj, {
      get: function get() {
        return _lineAlign;
      },
      set: function set(value) {
        var setting = findAlignSetting(value);
        if (!setting) {
          throw new SyntaxError('An invalid or illegal string was specified.');
        }
        _lineAlign = setting;
        this.hasBeenReset = true;
      }
    }));

    Object.defineProperty(cue, 'position', extend({}, baseObj, {
      get: function get() {
        return _position;
      },
      set: function set(value) {
        if (value < 0 || value > 100) {
          throw new Error('Position must be between 0 and 100.');
        }
        _position = value;
        this.hasBeenReset = true;
      }
    }));

    Object.defineProperty(cue, 'positionAlign', extend({}, baseObj, {
      get: function get() {
        return _positionAlign;
      },
      set: function set(value) {
        var setting = findAlignSetting(value);
        if (!setting) {
          throw new SyntaxError('An invalid or illegal string was specified.');
        }
        _positionAlign = setting;
        this.hasBeenReset = true;
      }
    }));

    Object.defineProperty(cue, 'size', extend({}, baseObj, {
      get: function get() {
        return _size;
      },
      set: function set(value) {
        if (value < 0 || value > 100) {
          throw new Error('Size must be between 0 and 100.');
        }
        _size = value;
        this.hasBeenReset = true;
      }
    }));

    Object.defineProperty(cue, 'align', extend({}, baseObj, {
      get: function get() {
        return _align;
      },
      set: function set(value) {
        var setting = findAlignSetting(value);
        if (!setting) {
          throw new SyntaxError('An invalid or illegal string was specified.');
        }
        _align = setting;
        this.hasBeenReset = true;
      }
    }));

    /**
     * Other <track> spec defined properties
     */

    // http://www.whatwg.org/specs/web-apps/current-work/multipage/the-video-element.html#text-track-cue-display-state
    cue.displayState = undefined;

    if (isIE8) {
      return cue;
    }
  }

  /**
   * VTTCue methods
   */

  VTTCue.prototype.getCueAsHTML = function () {
    // Assume WebVTT.convertCueToDOMTree is on the global.
    var WebVTT = window.WebVTT;
    return WebVTT.convertCueToDOMTree(window, this.text);
  };

  return VTTCue;
}();

/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vttparser = __webpack_require__(610);

var _vttparser2 = _interopRequireDefault(_vttparser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// String.prototype.startsWith is not supported in IE11
var startsWith = function startsWith(inputString, searchString, position) {
    return inputString.substr(position || 0, searchString.length) === searchString;
};

var cueString2millis = function cueString2millis(timeString) {
    var ts = parseInt(timeString.substr(-3));
    var secs = parseInt(timeString.substr(-6, 2));
    var mins = parseInt(timeString.substr(-9, 2));
    var hours = timeString.length > 9 ? parseInt(timeString.substr(0, timeString.indexOf(':'))) : 0;

    if (isNaN(ts) || isNaN(secs) || isNaN(mins) || isNaN(hours)) {
        return -1;
    }

    ts += 1000 * secs;
    ts += 60 * 1000 * mins;
    ts += 60 * 60 * 1000 * hours;

    return ts;
};

// From https://github.com/darkskyapp/string-hash
var hash = function hash(text) {
    var hash = 5381;
    var i = text.length;
    while (i) {
        hash = hash * 33 ^ text.charCodeAt(--i);
    }
    return (hash >>> 0).toString();
};

var calculateOffset = function calculateOffset(vttCCs, cc, presentationTime) {
    var currCC = vttCCs[cc];
    var prevCC = vttCCs[currCC.prevCC];

    // This is the first discontinuity or cues have been processed since the last discontinuity
    // Offset = current discontinuity time
    if (!prevCC || !prevCC.new && currCC.new) {
        vttCCs.ccOffset = vttCCs.presentationOffset = currCC.start;
        currCC.new = false;
        return;
    }

    // There have been discontinuities since cues were last parsed.
    // Offset = time elapsed
    while (prevCC && prevCC.new) {
        vttCCs.ccOffset += currCC.start - prevCC.start;
        currCC.new = false;
        currCC = prevCC;
        prevCC = vttCCs[currCC.prevCC];
    }

    vttCCs.presentationOffset = presentationTime;
};

var WebVTTParser = {
    parse: function parse(vttByteArray, syncPTS, vttCCs, cc, callBack, errorCallBack) {
        // Convert byteArray into string, replacing any somewhat exotic linefeeds with "\n", then split on that character.
        var re = /\r\n|\n\r|\n|\r/g;
        var vttLines = String.fromCharCode.apply(null, new Uint8Array(vttByteArray)).trim().replace(re, '\n').split('\n');
        var cueTime = '00:00.000';
        var mpegTs = 0;
        var localTime = 0;
        var presentationTime = 0;
        var cues = [];
        var parsingError = void 0;
        var inHeader = true;
        // let VTTCue = VTTCue || window.TextTrackCue;

        // Create parser object using VTTCue with TextTrackCue fallback on certain browsers.
        var parser = new _vttparser2.default();

        parser.oncue = function (cue) {
            // Adjust cue timing; clamp cues to start no earlier than - and drop cues that don't end after - 0 on timeline.
            var currCC = vttCCs[cc];
            var cueOffset = vttCCs.ccOffset;

            // Update offsets for new discontinuities
            if (currCC && currCC.new) {
                if (localTime) {
                    // When local time is provided, offset = discontinuity start time - local time
                    cueOffset = vttCCs.ccOffset = currCC.start;
                } else {
                    calculateOffset(vttCCs, cc, presentationTime);
                }
            }

            if (presentationTime) {
                // If we have MPEGTS, offset = presentation time + discontinuity offset
                cueOffset = presentationTime + vttCCs.ccOffset - vttCCs.presentationOffset;
            }

            cue.startTime += cueOffset - localTime;
            cue.endTime += cueOffset - localTime;

            // Create a unique hash id for a cue based on start/end times and text.
            // This helps timeline-controller to avoid showing repeated captions.
            cue.id = hash(cue.startTime) + hash(cue.endTime) + hash(cue.text);

            // Fix encoding of special characters. TODO: Test with all sorts of weird characters.
            cue.text = decodeURIComponent(escape(cue.text));
            if (cue.endTime > 0) {
                cues.push(cue);
            }
        };

        parser.onparsingerror = function (e) {
            parsingError = e;
        };

        parser.onflush = function () {
            if (parsingError && errorCallBack) {
                errorCallBack(parsingError);
                return;
            }
            callBack(cues);
        };

        // Go through contents line by line.
        vttLines.forEach(function (line) {
            if (inHeader) {
                // Look for X-TIMESTAMP-MAP in header.
                if (startsWith(line, 'X-TIMESTAMP-MAP=')) {
                    // Once found, no more are allowed anyway, so stop searching.
                    inHeader = false;
                    // Extract LOCAL and MPEGTS.
                    line.substr(16).split(',').forEach(function (timestamp) {
                        if (startsWith(timestamp, 'LOCAL:')) {
                            cueTime = timestamp.substr(6);
                        } else if (startsWith(timestamp, 'MPEGTS:')) {
                            mpegTs = parseInt(timestamp.substr(7));
                        }
                    });
                    try {
                        // Calculate subtitle offset in milliseconds.
                        // If sync PTS is less than zero, we have a 33-bit wraparound, which is fixed by adding 2^33 = 8589934592.
                        syncPTS = syncPTS < 0 ? syncPTS + 8589934592 : syncPTS;
                        // Adjust MPEGTS by sync PTS.
                        mpegTs -= syncPTS;
                        // Convert cue time to seconds
                        localTime = cueString2millis(cueTime) / 1000;
                        // Convert MPEGTS to seconds from 90kHz.
                        presentationTime = mpegTs / 90000;

                        if (localTime === -1) {
                            parsingError = new Error('Malformed X-TIMESTAMP-MAP: ' + line);
                        }
                    } catch (e) {
                        parsingError = new Error('Malformed X-TIMESTAMP-MAP: ' + line);
                    }
                    // Return without parsing X-TIMESTAMP-MAP line.
                    return;
                } else if (line === '') {
                    inHeader = false;
                }
            }
            // Parse line by default.
            parser.parse(line + '\n');
        });

        parser.flush();
    }
};

module.exports = WebVTTParser;

/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * XHR based logger
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     */

var _logger = __webpack_require__(31);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var XhrLoader = function () {
  function XhrLoader(config) {
    _classCallCheck(this, XhrLoader);

    if (config && config.xhrSetup) {
      this.xhrSetup = config.xhrSetup;
    }
  }

  _createClass(XhrLoader, [{
    key: 'destroy',
    value: function destroy() {
      this.abort();
      this.loader = null;
    }
  }, {
    key: 'abort',
    value: function abort() {
      var loader = this.loader;
      if (loader && loader.readyState !== 4) {
        this.stats.aborted = true;
        loader.abort();
      }

      window.clearTimeout(this.requestTimeout);
      this.requestTimeout = null;
      window.clearTimeout(this.retryTimeout);
      this.retryTimeout = null;
    }
  }, {
    key: 'load',
    value: function load(context, config, callbacks) {
      this.context = context;
      this.config = config;
      this.callbacks = callbacks;
      this.stats = { trequest: performance.now(), retry: 0 };
      this.retryDelay = config.retryDelay;
      this.loadInternal();
    }
  }, {
    key: 'loadInternal',
    value: function loadInternal() {
      var xhr,
          context = this.context;

      if (typeof XDomainRequest !== 'undefined') {
        xhr = this.loader = new XDomainRequest();
      } else {
        xhr = this.loader = new XMLHttpRequest();
      }
      var stats = this.stats;
      stats.tfirst = 0;
      stats.loaded = 0;
      var xhrSetup = this.xhrSetup;

      try {
        if (xhrSetup) {
          try {
            xhrSetup(xhr, context.url);
          } catch (e) {
            // fix xhrSetup: (xhr, url) => {xhr.setRequestHeader("Content-Language", "test");}
            // not working, as xhr.setRequestHeader expects xhr.readyState === OPEN
            xhr.open('GET', context.url, true);
            xhrSetup(xhr, context.url);
          }
        }
        if (!xhr.readyState) {
          xhr.open('GET', context.url, true);
        }
      } catch (e) {
        // IE11 throws an exception on xhr.open if attempting to access an HTTP resource over HTTPS
        this.callbacks.onError({ code: xhr.status, text: e.message }, context);
        return;
      }

      if (context.rangeEnd) {
        xhr.setRequestHeader('Range', 'bytes=' + context.rangeStart + '-' + (context.rangeEnd - 1));
      }
      xhr.onreadystatechange = this.readystatechange.bind(this);
      xhr.onprogress = this.loadprogress.bind(this);
      xhr.responseType = context.responseType;

      // setup timeout before we perform request
      this.requestTimeout = window.setTimeout(this.loadtimeout.bind(this), this.config.timeout);
      xhr.send();
    }
  }, {
    key: 'readystatechange',
    value: function readystatechange(event) {
      var xhr = event.currentTarget,
          readyState = xhr.readyState,
          stats = this.stats,
          context = this.context,
          config = this.config;

      // don't proceed if xhr has been aborted
      if (stats.aborted) {
        return;
      }

      // >= HEADERS_RECEIVED
      if (readyState >= 2) {
        // clear xhr timeout and rearm it if readyState less than 4
        window.clearTimeout(this.requestTimeout);
        if (stats.tfirst === 0) {
          stats.tfirst = Math.max(performance.now(), stats.trequest);
        }
        if (readyState === 4) {
          var status = xhr.status;
          // http status between 200 to 299 are all successful
          if (status >= 200 && status < 300) {
            stats.tload = Math.max(stats.tfirst, performance.now());
            var data = void 0,
                len = void 0;
            if (context.responseType === 'arraybuffer') {
              data = xhr.response;
              len = data.byteLength;
            } else {
              data = xhr.responseText;
              len = data.length;
            }
            stats.loaded = stats.total = len;
            var response = { url: xhr.responseURL, data: data };
            this.callbacks.onSuccess(response, stats, context);
          } else {
            // if max nb of retries reached or if http status between 400 and 499 (such error cannot be recovered, retrying is useless), return error
            if (stats.retry >= config.maxRetry || status >= 400 && status < 499) {
              _logger.logger.error(status + ' while loading ' + context.url);
              this.callbacks.onError({ code: status, text: xhr.statusText }, context);
            } else {
              // retry
              _logger.logger.warn(status + ' while loading ' + context.url + ', retrying in ' + this.retryDelay + '...');
              // aborts and resets internal state
              this.destroy();
              // schedule retry
              this.retryTimeout = window.setTimeout(this.loadInternal.bind(this), this.retryDelay);
              // set exponential backoff
              this.retryDelay = Math.min(2 * this.retryDelay, config.maxRetryDelay);
              stats.retry++;
            }
          }
        } else {
          // readyState >= 2 AND readyState !==4 (readyState = HEADERS_RECEIVED || LOADING) rearm timeout as xhr not finished yet
          this.requestTimeout = window.setTimeout(this.loadtimeout.bind(this), config.timeout);
        }
      }
    }
  }, {
    key: 'loadtimeout',
    value: function loadtimeout() {
      _logger.logger.warn('timeout while loading ' + this.context.url);
      this.callbacks.onTimeout(this.stats, this.context);
    }
  }, {
    key: 'loadprogress',
    value: function loadprogress(event) {
      var stats = this.stats;
      stats.loaded = event.loaded;
      if (event.lengthComputable) {
        stats.total = event.total;
      }
      var onProgress = this.callbacks.onProgress;
      if (onProgress) {
        // last args is to provide on progress data
        onProgress(stats, this.context, null);
      }
    }
  }]);

  return XhrLoader;
}();

exports.default = XhrLoader;

/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(184),
    isArguments = __webpack_require__(185),
    isArray = __webpack_require__(40);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(15);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(643);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(36);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KEYCODES = {
  ESCAPE: 27
};

var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    _classCallCheck(this, Portal);

    var _this = _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).call(this));

    _this.state = { active: false };
    _this.handleWrapperClick = _this.handleWrapperClick.bind(_this);
    _this.closePortal = _this.closePortal.bind(_this);
    _this.handleOutsideMouseClick = _this.handleOutsideMouseClick.bind(_this);
    _this.handleKeydown = _this.handleKeydown.bind(_this);
    _this.portal = null;
    _this.node = null;
    return _this;
  }

  _createClass(Portal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.closeOnEsc) {
        document.addEventListener('keydown', this.handleKeydown);
      }

      if (this.props.closeOnOutsideClick) {
        document.addEventListener('mouseup', this.handleOutsideMouseClick);
        document.addEventListener('touchstart', this.handleOutsideMouseClick);
      }

      if (this.props.isOpened) {
        this.openPortal();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      // portal's 'is open' state is handled through the prop isOpened
      if (typeof newProps.isOpened !== 'undefined') {
        if (newProps.isOpened) {
          if (this.state.active) {
            this.renderPortal(newProps);
          } else {
            this.openPortal(newProps);
          }
        }
        if (!newProps.isOpened && this.state.active) {
          this.closePortal();
        }
      }

      // portal handles its own 'is open' state
      if (typeof newProps.isOpened === 'undefined' && this.state.active) {
        this.renderPortal(newProps);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.closeOnEsc) {
        document.removeEventListener('keydown', this.handleKeydown);
      }

      if (this.props.closeOnOutsideClick) {
        document.removeEventListener('mouseup', this.handleOutsideMouseClick);
        document.removeEventListener('touchstart', this.handleOutsideMouseClick);
      }

      this.closePortal(true);
    }
  }, {
    key: 'handleWrapperClick',
    value: function handleWrapperClick(e) {
      e.preventDefault();
      e.stopPropagation();
      if (this.state.active) {
        return;
      }
      this.openPortal();
    }
  }, {
    key: 'openPortal',
    value: function openPortal() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      this.setState({ active: true });
      this.renderPortal(props);
      this.props.onOpen(this.node);
    }
  }, {
    key: 'closePortal',
    value: function closePortal() {
      var _this2 = this;

      var isUnmounted = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var resetPortalState = function resetPortalState() {
        if (_this2.node) {
          _reactDom2.default.unmountComponentAtNode(_this2.node);
          document.body.removeChild(_this2.node);
        }
        _this2.portal = null;
        _this2.node = null;
        if (isUnmounted !== true) {
          _this2.setState({ active: false });
        }
      };

      if (this.state.active) {
        if (this.props.beforeClose) {
          this.props.beforeClose(this.node, resetPortalState);
        } else {
          resetPortalState();
        }

        this.props.onClose();
      }
    }
  }, {
    key: 'handleOutsideMouseClick',
    value: function handleOutsideMouseClick(e) {
      if (!this.state.active) {
        return;
      }

      var root = (0, _reactDom.findDOMNode)(this.portal);
      if (root.contains(e.target) || e.button && e.button !== 0) {
        return;
      }

      e.stopPropagation();
      this.closePortal();
    }
  }, {
    key: 'handleKeydown',
    value: function handleKeydown(e) {
      if (e.keyCode === KEYCODES.ESCAPE && this.state.active) {
        this.closePortal();
      }
    }
  }, {
    key: 'renderPortal',
    value: function renderPortal(props) {
      if (!this.node) {
        this.node = document.createElement('div');
        document.body.appendChild(this.node);
      }

      var children = props.children;
      // https://gist.github.com/jimfb/d99e0678e9da715ccf6454961ef04d1b
      if (typeof props.children.type === 'function') {
        children = _react2.default.cloneElement(props.children, { closePortal: this.closePortal });
      }

      this.portal = _reactDom2.default.unstable_renderSubtreeIntoContainer(this, children, this.node, this.props.onUpdate);
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.openByClickOn) {
        return _react2.default.cloneElement(this.props.openByClickOn, { onClick: this.handleWrapperClick });
      }
      return null;
    }
  }]);

  return Portal;
}(_react2.default.Component);

exports.default = Portal;


Portal.propTypes = {
  children: _propTypes2.default.element.isRequired,
  openByClickOn: _propTypes2.default.element,
  closeOnEsc: _propTypes2.default.bool,
  closeOnOutsideClick: _propTypes2.default.bool,
  isOpened: _propTypes2.default.bool,
  onOpen: _propTypes2.default.func,
  onClose: _propTypes2.default.func,
  beforeClose: _propTypes2.default.func,
  onUpdate: _propTypes2.default.func
};

Portal.defaultProps = {
  onOpen: function onOpen() {},
  onClose: function onClose() {},
  onUpdate: function onUpdate() {}
};
module.exports = exports['default'];


/***/ }),
/* 1480 */,
/* 1481 */
/***/ (function(module, exports) {

/**
 * Decimal adjustment of a number.
 *
 * @param {String}  type  The type of adjustment.
 * @param {Number}  value The number.
 * @param {Integer} exp   The exponent (the 10 logarithm of the adjustment base).
 * @returns {Number} The adjusted value.
 */
var decimalAdjust = exports.decimalAdjust = function(type, value, exp) {
    // If the exp is undefined or zero...
    if (typeof exp === 'undefined' || +exp === 0) {
        return Math[type](value);
    }
    value = +value;
    exp = +exp;
    // If the value is not a number or the exp is not an integer...
    if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
        return NaN;
    }
    // Shift
    value = value.toString().split('e');
    value = Math[type](+(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp)));
    // Shift back
    value = value.toString().split('e');
    return +(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp));
}

module.exports = {
    round10: function(value, exp) {
        return decimalAdjust('round', value, exp);
    },
    floor10: function(value, exp) {
        return decimalAdjust('floor', value, exp);
    },
    ceil10: function(value, exp) {
        return decimalAdjust('ceil', value, exp);
    },
};

module.exports.polyfill = function() {
    // Decimal round
    if (!Math.round10) {
        Math.round10 = module.exports.round10;
    }
    // Decimal floor
    if (!Math.floor10) {
        Math.floor10 = module.exports.floor10;
    }
    // Decimal ceil
    if (!Math.ceil10) {
        Math.ceil10 = module.exports.ceil10;
    }
};


/***/ }),
/* 1482 */,
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1294);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./header-mobile.styl", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./header-mobile.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1295);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./header.styl", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./header.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1296);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./modal-mobile.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./modal-mobile.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1298);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./loading-spinner.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./loading-spinner.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1299);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./preview-prompt.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./preview-prompt.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1300);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./icon.styl", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./icon.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1301);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./action-button.styl", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./action-button.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1302);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./control-button.styl", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./control-button.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1303);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./controls.styl", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./controls.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1304);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./fullscreen.styl", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./fullscreen.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1305);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./play.styl", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./play.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1306);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./progress.styl", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./progress.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1307);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./time.styl", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./time.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1308);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./volume.styl", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./volume.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1309);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./info-overlay.styl", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./info-overlay.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1310);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./info.styl", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./info.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1312);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./overlay-actions.styl", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./overlay-actions.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1313);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./overlay.styl", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./overlay.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1314);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./player.styl", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./player.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1315);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./progress-bar.styl", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./progress-bar.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1316);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./scrollbar-wrapper.styl", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./scrollbar-wrapper.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1317);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./social-button.styl", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./social-button.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1318);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./social-share.styl", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./social-share.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1319);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/index.js??ref--3-2!./fontello-codes.css", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--3-1!../../../../../node_modules/postcss-loader/index.js??ref--3-2!./fontello-codes.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1507 */,
/* 1508 */
/***/ (function(module, exports) {

module.exports = "data:application/font-woff;base64,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"

/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(1510));
//# sourceMappingURL=index.js.map

/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = __webpack_require__(192);
function getNativeEventsHandlers(vidi) {
    // Verifies the vidi instance is still connected to the HTMLVideoElement
    function verifyVideoAndCall(callback) {
        var videoElement = vidi.getVideoElement();
        videoElement && callback(videoElement);
    }
    return {
        loadstart: function () {
            verifyVideoAndCall(function () { return vidi.emit('loadstart', vidi.getPlaybackState()); });
        },
        durationchange: function () {
            verifyVideoAndCall(function (videoElement) { return vidi.emit('durationchange', videoElement.duration); });
        },
        timeupdate: function () {
            verifyVideoAndCall(function (videoElement) { return vidi.emit('timeupdate', videoElement.currentTime); });
        },
        ratechange: function () {
            verifyVideoAndCall(function (videoElement) { return vidi.emit('ratechange', videoElement.playbackRate); });
        },
        volumechange: function () {
            verifyVideoAndCall(function (videoElement) { return vidi.emit('volumechange', { volume: videoElement.volume, muted: videoElement.muted }); });
        },
        play: function () {
            verifyVideoAndCall(function () { return vidi.emit('statuschange', types_1.PlaybackStatus.PLAYING_BUFFERING); });
        },
        playing: function () {
            verifyVideoAndCall(function () { return vidi.emit('statuschange', types_1.PlaybackStatus.PLAYING); });
        },
        pause: function () {
            verifyVideoAndCall(function () { return vidi.emit('statuschange', types_1.PlaybackStatus.PAUSED); });
        },
        seeking: function () {
            verifyVideoAndCall(function (videoElement) {
                if (videoElement.paused) {
                    vidi.emit('statuschange', types_1.PlaybackStatus.PAUSED_BUFFERING);
                }
                else {
                    vidi.emit('statuschange', types_1.PlaybackStatus.PLAYING_BUFFERING);
                }
            });
        },
        seeked: function () {
            verifyVideoAndCall(function (videoElement) {
                if (videoElement.paused) {
                    vidi.emit('statuschange', types_1.PlaybackStatus.PAUSED);
                }
                else {
                    vidi.emit('statuschange', types_1.PlaybackStatus.PLAYING);
                }
            });
        },
        ended: function () {
            verifyVideoAndCall(function () { return vidi.emit('statuschange', types_1.PlaybackStatus.ENDED); });
        },
        error: function (errorEvent) {
            verifyVideoAndCall(function (videoElement) {
                var videoError = videoElement.error;
                var errorType = videoError instanceof MediaError ? types_1.Errors.SRC_LOAD_ERROR : types_1.Errors.UNKNOWN_ERROR;
                vidi.emit('error', errorType, videoElement.src, videoError || errorEvent);
            });
        }
    };
}
exports.getNativeEventsHandlers = getNativeEventsHandlers;
//# sourceMappingURL=native-events-handlers.js.map

/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = __webpack_require__(192);
var extensionsMap = Object.create(null);
extensionsMap.mp4 = types_1.MediaStreamTypes.MP4;
extensionsMap.webm = types_1.MediaStreamTypes.WEBM;
extensionsMap.m3u8 = types_1.MediaStreamTypes.HLS;
extensionsMap.mpd = types_1.MediaStreamTypes.DASH;
var anchorElement = document.createElement('a');
function detectStreamType(url) {
    anchorElement.href = url;
    var streamType = extensionsMap[getExtFromPath(anchorElement.pathname)];
    if (!streamType) {
        throw new Error("Vidi: cannot auto-detect url '" + url + "'. Please specify type manually using the MediaStream interface.");
    }
    else {
        return streamType;
    }
}
exports.detectStreamType = detectStreamType;
function getExtFromPath(path) {
    return path.split('.').pop();
}
exports.getExtFromPath = getExtFromPath;
//# sourceMappingURL=detect-stream-type.js.map

/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(1515));
__export(__webpack_require__(1511));
__export(__webpack_require__(1517));
//# sourceMappingURL=index.js.map

/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = __webpack_require__(192);
var dashjs_1 = __webpack_require__(1321);
var DashEvents = dashjs_1.MediaPlayer['events'];
var DashStream = (function () {
    function DashStream(mediaStreams, emit) {
        var _this = this;
        this.emit = emit;
        this.dashPlayer = null;
        this.mediaStream = null;
        this.onError = function (errorEvent) {
            if (!errorEvent) {
                return;
            }
            if (errorEvent.error === 'manifestError' || (errorEvent.error === 'download' && errorEvent.event.id === 'manifest')) {
                _this.emit('error', types_1.Errors.SRC_LOAD_ERROR, _this.mediaStream && _this.mediaStream.url, errorEvent);
            }
        };
        this.onStreamInitialized = function () {
            _this.emit('levels', _this.getMediaLevels());
        };
        if (mediaStreams.length === 1) {
            this.mediaStream = mediaStreams[0];
        }
        else {
            throw new Error("Vidi can only handle a single DASH stream. Received " + mediaStreams.length + " streams.");
        }
    }
    DashStream.prototype.attach = function (videoElement, initialBitrate) {
        if (!this.mediaStream) {
            return;
        }
        this.dashPlayer = dashjs_1.MediaPlayer().create();
        this.dashPlayer.getDebug().setLogToBrowserConsole(false);
        this.dashPlayer.on(DashEvents.STREAM_INITIALIZED, this.onStreamInitialized);
        this.dashPlayer.on(DashEvents.ERROR, this.onError);
        this.dashPlayer.initialize(videoElement, this.mediaStream.url, videoElement.autoplay);
        if (initialBitrate) {
            this.dashPlayer.setInitialBitrateFor('video', initialBitrate);
        }
    };
    DashStream.prototype.detach = function (videoElement) {
        if (!this.mediaStream) {
            return;
        }
        this.dashPlayer.reset();
        this.dashPlayer.off(DashEvents.STREAM_INITIALIZED, this.onStreamInitialized);
        this.dashPlayer.off(DashEvents.ERROR, this.onError);
        this.dashPlayer = null;
    };
    DashStream.prototype.getMediaStreamDeliveryType = function () {
        return types_1.MediaStreamDeliveryType.ADAPTIVE_VIA_MSE;
    };
    DashStream.prototype.setMediaLevel = function (newLevel, videoElement) {
        // TODO
    };
    DashStream.prototype.getMediaLevels = function () {
        if (!this.dashPlayer) {
            return [];
        }
        var bitrates = this.dashPlayer.getBitrateInfoListFor('video') || [];
        return bitrates.map(function (bitrateInfo) {
            return { bitrate: bitrateInfo.bitrate, width: bitrateInfo.width, height: bitrateInfo.height };
        });
    };
    DashStream.isSupported = function (env) {
        return env.MSE;
    };
    ;
    DashStream.canPlay = function (mediaType) {
        return mediaType === types_1.MediaStreamTypes.DASH;
    };
    return DashStream;
}());
exports.DashStream = DashStream;
//# sourceMappingURL=dash-stream.js.map

/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var HlsJs = __webpack_require__(1463);
var types_1 = __webpack_require__(192);
var HlsStream = (function () {
    function HlsStream(mediaStreams, emit) {
        var _this = this;
        this.emit = emit;
        this.hls = null;
        this.videoElement = null;
        this.mediaStream = null;
        this.attachOnPlay = function () {
            if (!_this.videoElement) {
                return;
            }
            _this.hls.startLoad();
            _this.videoElement.removeEventListener('play', _this.attachOnPlay);
        };
        this.onManifestParsed = function (eventType, _a) {
            var _b = _a.levels, levels = _b === void 0 ? [] : _b, _c = _a.firstLevel, firstLevel = _c === void 0 ? -1 : _c;
            var mediaLevels = levels.map(function (level) {
                return { bitrate: level.bitrate, width: level.width, height: level.height, name: level.name };
            });
            _this.emit('levels', mediaLevels);
            if (firstLevel >= 0) {
                _this.emit('currentLevel', firstLevel);
            }
        };
        this.onError = function (type, errorEvent) {
            if (errorEvent && (errorEvent.details === 'manifestParsingError' || errorEvent.details === 'manifestLoadError')) {
                _this.emit('error', types_1.Errors.SRC_LOAD_ERROR, _this.mediaStream && _this.mediaStream.url, errorEvent);
            }
        };
        if (mediaStreams.length === 1) {
            this.mediaStream = mediaStreams[0];
        }
        else {
            throw new Error("Vidi can only handle a single HLS stream. Received " + mediaStreams.length + " streams.");
        }
    }
    HlsStream.prototype.attach = function (videoElement, initialBitrate) {
        if (!this.mediaStream) {
            return;
        }
        this.videoElement = videoElement;
        var config = { abrEwmaDefaultEstimate: initialBitrate * 1000 };
        if (videoElement.preload === 'none') {
            config.autoStartLoad = false;
            videoElement.addEventListener('play', this.attachOnPlay);
        }
        this.hls = new HlsJs(config);
        this.hls.on(HlsJs.Events.MANIFEST_PARSED, this.onManifestParsed);
        this.hls.on(HlsJs.Events.ERROR, this.onError);
        this.hls.loadSource(this.mediaStream.url);
        this.hls.attachMedia(videoElement);
    };
    HlsStream.prototype.detach = function (videoElement) {
        if (!this.mediaStream) {
            return;
        }
        this.hls.off(HlsJs.Events.MANIFEST_PARSED, this.onManifestParsed);
        this.hls.off(HlsJs.Events.ERROR, this.onError);
        this.hls.destroy();
        this.hls = null;
        videoElement.removeEventListener('play', this.attachOnPlay);
        this.videoElement = null;
    };
    HlsStream.prototype.getMediaStreamDeliveryType = function () {
        return types_1.MediaStreamDeliveryType.ADAPTIVE_VIA_MSE;
    };
    HlsStream.prototype.setMediaLevel = function (newLevel, videoElement) {
        // TODO
    };
    HlsStream.isSupported = function (env) {
        return env.MSE && HlsJs.isSupported();
    };
    ;
    HlsStream.canPlay = function (mediaType) {
        return mediaType === types_1.MediaStreamTypes.HLS;
    };
    return HlsStream;
}());
exports.HlsStream = HlsStream;
//# sourceMappingURL=hls-stream.js.map

/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(1514));
__export(__webpack_require__(1513));
__export(__webpack_require__(1516));
// export * from './shaka-stream';
//# sourceMappingURL=index.js.map

/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function getNativeStreamCreator(streamType, deliveryType) {
    var NativeStream = (function () {
        function NativeStream(mediaStreams, emit) {
            this.mediaStreams = mediaStreams;
            this.emit = emit;
            this.currentLevel = 0;
        }
        NativeStream.prototype.attach = function (videoElement) {
            videoElement.src = this.mediaStreams[this.currentLevel].url;
            this.emit('levels', this.mediaStreams.map(function (mediaStream) {
                return { name: mediaStream.name || mediaStream.url };
            }));
            this.emit('currentLevel', this.currentLevel);
        };
        NativeStream.prototype.detach = function (videoElement) {
            videoElement.src = '';
        };
        NativeStream.prototype.getMediaStreamDeliveryType = function () {
            return deliveryType;
        };
        NativeStream.isSupported = function (env) {
            return env[streamType];
        };
        ;
        NativeStream.canPlay = function (mediaType) {
            return mediaType === streamType;
        };
        NativeStream.prototype.setMediaLevel = function (newLevel, videoElement) {
            if (newLevel < this.mediaStreams.length) {
                this.currentLevel = newLevel;
                var timeBeforeSwitch = videoElement.currentTime;
                videoElement.src = this.mediaStreams[this.currentLevel].url;
                videoElement.currentTime = timeBeforeSwitch;
                this.emit('currentLevel', this.currentLevel);
            }
        };
        return NativeStream;
    }());
    return NativeStream;
}
exports.getNativeStreamCreator = getNativeStreamCreator;
//# sourceMappingURL=native-stream.js.map

/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function resolvePlayableStreams(mediaStreams, playableStreamCreators, emit) {
    var playableStreams = [];
    var groupedStreams = groupStreamsByMediaType(mediaStreams);
    Object.keys(groupedStreams).forEach(function (mediaType) {
        var mediaStreams = groupedStreams[mediaType];
        for (var i = 0; i < playableStreamCreators.length; ++i) {
            var playableStreamCreator = playableStreamCreators[i];
            if (playableStreamCreator.canPlay(mediaType)) {
                playableStreams.push(new playableStreamCreator(mediaStreams, emit));
                break;
            }
        }
        ;
    });
    playableStreams.sort(function (firstStream, secondStream) {
        return secondStream.getMediaStreamDeliveryType() - firstStream.getMediaStreamDeliveryType();
    });
    return playableStreams;
}
exports.resolvePlayableStreams = resolvePlayableStreams;
function groupStreamsByMediaType(mediaStreams) {
    var typeMap = {};
    mediaStreams.forEach(function (mediaStream) {
        var currentValue = typeMap[mediaStream.type];
        if (!Array.isArray(typeMap[mediaStream.type])) {
            typeMap[mediaStream.type] = [];
        }
        typeMap[mediaStream.type].push(mediaStream);
    });
    return typeMap;
}
//# sourceMappingURL=playback-resolution.js.map

/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Errors = {
    SRC_LOAD_ERROR: 'SRC_LOAD_ERROR',
    UNKNOWN_ERROR: 'UNKNOWN_ERROR'
};
//# sourceMappingURL=errors.js.map

/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var eventemitter3_1 = __webpack_require__(637);
var VidiEmitter = (function (_super) {
    __extends(VidiEmitter, _super);
    function VidiEmitter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return VidiEmitter;
}(eventemitter3_1.EventEmitter));
exports.VidiEmitter = VidiEmitter;
//# sourceMappingURL=events.js.map

/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaStreamTypes = {
    MP4: 'MP4',
    WEBM: 'WEBM',
    HLS: 'HLS',
    DASH: 'DASH'
};
var MediaStreamDeliveryType;
(function (MediaStreamDeliveryType) {
    MediaStreamDeliveryType[MediaStreamDeliveryType["NATIVE_PROGRESSIVE"] = 0] = "NATIVE_PROGRESSIVE";
    MediaStreamDeliveryType[MediaStreamDeliveryType["ADAPTIVE_VIA_MSE"] = 1] = "ADAPTIVE_VIA_MSE";
    MediaStreamDeliveryType[MediaStreamDeliveryType["NATIVE_ADAPTIVE"] = 2] = "NATIVE_ADAPTIVE";
})(MediaStreamDeliveryType = exports.MediaStreamDeliveryType || (exports.MediaStreamDeliveryType = {}));
;
//# sourceMappingURL=media-stream.js.map

/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var PlaybackStatus;
(function (PlaybackStatus) {
    /**
     * Video is currently paused.
     */
    PlaybackStatus[PlaybackStatus["PAUSED"] = 0] = "PAUSED";
    /**
     * Video is paused, but the player is buffering (for example, on seek when paused).
     */
    PlaybackStatus[PlaybackStatus["PAUSED_BUFFERING"] = 1] = "PAUSED_BUFFERING";
    /**
     * Video is playing.
     */
    PlaybackStatus[PlaybackStatus["PLAYING"] = 2] = "PLAYING";
    /**
     * Video is trying to play, but is buffering.
     * This can happen due to a seek or an insufficient network connectivity speed.
     */
    PlaybackStatus[PlaybackStatus["PLAYING_BUFFERING"] = 3] = "PLAYING_BUFFERING";
    /**
     * Video has ended. Same as paused, but the playhead is at the end of the stream.
     */
    PlaybackStatus[PlaybackStatus["ENDED"] = 4] = "ENDED";
})(PlaybackStatus = exports.PlaybackStatus || (exports.PlaybackStatus = {}));
/**
 * An object that implements [[PlaybackState]] with UI-friendly defaults.
 */
exports.defaultPlaybackState = {
    duration: 0,
    currentTime: 0,
    status: PlaybackStatus.PAUSED,
    playbackRate: 1,
    volume: 1,
    muted: false
};
//# sourceMappingURL=playback-state.js.map

/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * `true` if we are running inside a web browser, `false` otherwise (e.g. running inside Node.js).
 */
exports.isBrowser = typeof window !== 'undefined';
/**
 * This is a map which lists native support of formats and APIs.
 * It gets filled during runtime with the relevant values to the current environment.
 */
exports.NativeEnvironmentSupport = {
    MSE: false,
    HLS: false,
    DASH: false,
    MP4: false,
    WEBM: false
};
function detectEnvironment() {
    if (!exports.isBrowser) {
        return; // Not in a browser
    }
    exports.NativeEnvironmentSupport.MSE = ('WebKitMediaSource' in window) || ('MediaSource' in window);
    var video = document.createElement('video');
    if (typeof video.canPlayType !== 'function') {
        return; // env doesn't support HTMLMediaElement (e.g PhantomJS)
    }
    if (video.canPlayType('application/x-mpegURL') || video.canPlayType('application/vnd.apple.mpegURL')) {
        exports.NativeEnvironmentSupport.HLS = true;
    }
    if (video.canPlayType('application/dash+xml')) {
        exports.NativeEnvironmentSupport.DASH = true;
    }
    if (video.canPlayType('video/mp4')) {
        exports.NativeEnvironmentSupport.MP4 = true;
    }
    if (video.canPlayType('video/webm')) {
        exports.NativeEnvironmentSupport.WEBM = true;
    }
}
detectEnvironment(); // Run once
//# sourceMappingURL=environment-detection.js.map

/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(1522));
//# sourceMappingURL=index.js.map

/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = __webpack_require__(1509);
var types_1 = __webpack_require__(192);
var media_streams_1 = __webpack_require__(1512);
var utils_1 = __webpack_require__(1523);
var DEFAULT_INITIAL_BITRATE = 1750; // 1750kbps, can be modified via Vidi.setInitialBitrate()
/**
 * The main `vidi` class.
 *
 * Each instance manages playback for a single HTMLVideoElement, onto which sources can be loaded.
 */
var Vidi = (function (_super) {
    __extends(Vidi, _super);
    /**
     * Constructor for creating Vidi instances
     *
     * @param nativeVideoEl is an optional parameter and is a shorthand for:
     * ```ts
     * const vidi = new Vidi();
     * vidi.setVideoElement(nativeVideoEl);
     * ```
     */
    function Vidi(nativeVideoEl) {
        if (nativeVideoEl === void 0) { nativeVideoEl = null; }
        var _this = _super.call(this) || this;
        _this.initialBitrate = DEFAULT_INITIAL_BITRATE;
        _this.nativeEventHandlers = events_1.getNativeEventsHandlers(_this);
        _this.playableStreamCreators = [];
        _this.videoElement = null;
        _this.currentSrc = null;
        _this.playableStreams = null;
        _this.attachedStream = null;
        _this.onNativeEvent = _this.onNativeEvent.bind(_this);
        var streamCreators = [
            media_streams_1.getNativeStreamCreator(types_1.MediaStreamTypes.HLS, types_1.MediaStreamDeliveryType.NATIVE_ADAPTIVE),
            media_streams_1.HlsStream,
            media_streams_1.DashStream,
            media_streams_1.getNativeStreamCreator(types_1.MediaStreamTypes.MP4, types_1.MediaStreamDeliveryType.NATIVE_PROGRESSIVE),
            media_streams_1.getNativeStreamCreator(types_1.MediaStreamTypes.WEBM, types_1.MediaStreamDeliveryType.NATIVE_PROGRESSIVE) // Native WebM (Chrome, Firefox)
        ];
        // Only add supported handlers 
        streamCreators.forEach(function (streamCreator) { return streamCreator.isSupported(utils_1.NativeEnvironmentSupport) && _this.playableStreamCreators.push(streamCreator); });
        _this.setVideoElement(nativeVideoEl);
        return _this;
    }
    Object.defineProperty(Vidi.prototype, "src", {
        /**
         * Getter for the src.
         *
         * @returns The currently set [[MediaSource]] on this vidi instance.
         */
        get: function () {
            return this.currentSrc;
        },
        /**
         * Sets a new `src` for playback.
         * If a `<video>` element is already attached, this will initiate loading of the new `src` into it.
         *
         * @param src The new [[MediaSource]].
         *
         */
        set: function (src) {
            if (src === this.currentSrc) {
                return;
            }
            this.detachCurrentStream();
            this.currentSrc = src;
            this.resolvePlayableStreams();
            this.connectStreamToVideo();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Attaches the `vidi` instance to a new `<video>` element.
     * If a previous element was set, `vidi` will detach from it.
     * If a `src` is already set, this will also trigger loading the `src` into the new element.
     *
     * @param nativeVideoEl The new `<video>` element to attach to.
     */
    Vidi.prototype.setVideoElement = function (nativeVideoEl) {
        if (this.videoElement === nativeVideoEl) {
            return;
        }
        this.removeNativeVideoListeners(this.videoElement);
        this.detachCurrentStream();
        this.videoElement = nativeVideoEl;
        this.addNativeVideoListeners(this.videoElement);
        this.connectStreamToVideo();
    };
    /**
     * @returns The currently attached `<video>` element.
     */
    Vidi.prototype.getVideoElement = function () {
        return this.videoElement;
    };
    /**
     * @returns If a `<video>` element is attached, it returns the current [[PlaybackState]] as an object.
     * Otherwise, returns [[defaultPlaybackState]].
     *
     *
     */
    Vidi.prototype.getPlaybackState = function () {
        if (!this.videoElement) {
            return types_1.defaultPlaybackState;
        }
        var playbackState = {
            currentTime: this.videoElement.currentTime,
            duration: this.videoElement.duration || 0,
            muted: this.videoElement.muted,
            playbackRate: this.videoElement.playbackRate,
            status: this.videoElement.paused ? types_1.PlaybackStatus.PAUSED : types_1.PlaybackStatus.PLAYING,
            volume: this.videoElement.volume
        };
        return playbackState;
    };
    /**
     * Same as calling the native `play()` method on the attached `<video>` node,
     * but also handles exceptions and Promise rejections (depending on the browser),
     * and exposes them via the `error` event.
     *
     * *Does nothing when no `<video>` is attached.*
     */
    Vidi.prototype.play = function () {
        if (!this.videoElement) {
            return;
        }
        // Errors will be exposed by the native error handler of vidi
        try {
            var res = this.videoElement.play();
            if (res && res.catch) {
                res.catch(function () { });
            }
        }
        catch (e) {
        }
    };
    /**
     * Same as calling the native `pause()` method on the attached `<video>` node,
     * but also handles exceptions and Promise rejections (depending on the browser),
     * and exposes them via the `error` event.
     *
     * *Does nothing when no `<video>` is attached.*
     */
    Vidi.prototype.pause = function () {
        if (!this.videoElement) {
            return;
        }
        // Errors will be exposed by the native error handler of vidi
        try {
            var res = this.videoElement.pause();
            if (res && res.catch) {
                res.catch(function () { });
            }
        }
        catch (e) {
        }
    };
    /**
     * Sets the preferred initial bitrate for adaptive playback.
     * This will only affect playback via MSE-based libraries, where we have
     * the ability to specify it. Native adaptive playback will not be
     * affected and will still use the browser's default behavior.
     */
    Vidi.prototype.setInitialBitrate = function (bitrate) {
        this.initialBitrate = bitrate;
    };
    /**
     * Sets the current level for the
     */
    Vidi.prototype.setMediaLevel = function (index) {
        if (this.attachedStream && this.videoElement) {
            this.attachedStream.setMediaLevel(index, this.videoElement);
        }
    };
    // Private helpers
    Vidi.prototype.autoDetectSourceTypes = function (mediaSources) {
        return mediaSources.map(function (mediaSource) {
            if (typeof mediaSource === 'string') {
                return { url: mediaSource, type: media_streams_1.detectStreamType(mediaSource) };
            }
            else {
                return mediaSource;
            }
        });
    };
    Vidi.prototype.resolvePlayableStreams = function () {
        if (!this.currentSrc) {
            this.playableStreams = [];
            return;
        }
        var mediaSources = new Array().concat(this.currentSrc);
        var mediaStreams = this.autoDetectSourceTypes(mediaSources);
        this.playableStreams = media_streams_1.resolvePlayableStreams(mediaStreams, this.playableStreamCreators, this.emit.bind(this));
    };
    Vidi.prototype.connectStreamToVideo = function () {
        if (!this.playableStreams || !this.videoElement) {
            return;
        }
        if (this.playableStreams.length > 0) {
            // Use the first PlayableStream for now
            // Later, we can use the others as fallback
            this.attachedStream = this.playableStreams[0];
            this.attachedStream.attach(this.videoElement, this.initialBitrate);
        }
    };
    Vidi.prototype.detachCurrentStream = function () {
        if (this.attachedStream && this.videoElement) {
            this.attachedStream.detach(this.videoElement);
            this.attachedStream = null;
        }
    };
    Vidi.prototype.addNativeVideoListeners = function (videoElement) {
        var _this = this;
        if (!videoElement) {
            return;
        }
        Object.keys(this.nativeEventHandlers).forEach(function (e) { return videoElement.addEventListener(e, _this.onNativeEvent); });
    };
    Vidi.prototype.removeNativeVideoListeners = function (videoElement) {
        var _this = this;
        if (!videoElement) {
            return;
        }
        Object.keys(this.nativeEventHandlers).forEach(function (e) { return videoElement.removeEventListener(e, _this.onNativeEvent); });
    };
    Vidi.prototype.onNativeEvent = function (event) {
        if (event.target !== this.videoElement) {
            return;
        }
        var handler = this.nativeEventHandlers[event.type];
        if (handler) {
            handler(event);
        }
        else {
            throw "Received a native event without an handler: " + event.type;
        }
    };
    return Vidi;
}(types_1.VidiEmitter));
Vidi.PlaybackStatus = types_1.PlaybackStatus;
Vidi.MediaStreamTypes = types_1.MediaStreamTypes;
Vidi.Errors = types_1.Errors;
exports.Vidi = Vidi;
//# sourceMappingURL=vidi.js.map

/***/ }),
/* 1525 */
/***/ (function(module, exports) {

var bundleFn = arguments[3];
var sources = arguments[4];
var cache = arguments[5];

var stringify = JSON.stringify;

module.exports = function (fn, options) {
    var wkey;
    var cacheKeys = Object.keys(cache);

    for (var i = 0, l = cacheKeys.length; i < l; i++) {
        var key = cacheKeys[i];
        var exp = cache[key].exports;
        // Using babel as a transpiler to use esmodule, the export will always
        // be an object with the default export as a property of it. To ensure
        // the existing api and babel esmodule exports are both supported we
        // check for both
        if (exp === fn || exp && exp.default === fn) {
            wkey = key;
            break;
        }
    }

    if (!wkey) {
        wkey = Math.floor(Math.pow(16, 8) * Math.random()).toString(16);
        var wcache = {};
        for (var i = 0, l = cacheKeys.length; i < l; i++) {
            var key = cacheKeys[i];
            wcache[key] = key;
        }
        sources[wkey] = [
            Function(['require','module','exports'], '(' + fn + ')(self)'),
            wcache
        ];
    }
    var skey = Math.floor(Math.pow(16, 8) * Math.random()).toString(16);

    var scache = {}; scache[wkey] = wkey;
    sources[skey] = [
        Function(['require'], (
            // try to call default if defined to also support babel esmodule
            // exports
            'var f = require(' + stringify(wkey) + ');' +
            '(f.default ? f.default : f)(self);'
        )),
        scache
    ];

    var workerSources = {};
    resolveSources(skey);

    function resolveSources(key) {
        workerSources[key] = true;

        for (var depPath in sources[key][1]) {
            var depKey = sources[key][1][depPath];
            if (!workerSources[depKey]) {
                resolveSources(depKey);
            }
        }
    }

    var src = '(' + bundleFn + ')({'
        + Object.keys(workerSources).map(function (key) {
            return stringify(key) + ':['
                + sources[key][0]
                + ',' + stringify(sources[key][1]) + ']'
            ;
        }).join(',')
        + '},{},[' + stringify(skey) + '])'
    ;

    var URL = window.URL || window.webkitURL || window.mozURL || window.msURL;

    var blob = new Blob([src], { type: 'text/javascript' });
    if (options && options.bare) { return blob; }
    var workerUrl = URL.createObjectURL(blob);
    var worker = new Worker(workerUrl);
    worker.objectURL = workerUrl;
    return worker;
};


/***/ }),
/* 1526 */,
/* 1527 */,
/* 1528 */,
/* 1529 */,
/* 1530 */,
/* 1531 */,
/* 1532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PaymentEventProxy; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_widget_constants_payment_message_proxy__ = __webpack_require__(1204);







var PaymentEventProxy = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(PaymentEventProxy, _React$Component);

  function PaymentEventProxy() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, PaymentEventProxy);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PaymentEventProxy.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(PaymentEventProxy)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(PaymentEventProxy, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('message', this.proxyEvent, false);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('message', this.proxyEvent, false);
    }
  }, {
    key: 'proxyEvent',
    value: function proxyEvent(event) {
      if (_.get(event, 'data.completed', false)) {
        for (var i = 0; i < window.parent.frames.length; i += 1) {
          var frame = window.parent.frames[i];
          frame.postMessage({
            id: __WEBPACK_IMPORTED_MODULE_5_widget_constants_payment_message_proxy__["a" /* default */].ID,
            message: event.data
          }, window.location.origin);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return PaymentEventProxy;
}(React.Component);



/***/ }),
/* 1533 */,
/* 1534 */,
/* 1535 */,
/* 1536 */,
/* 1537 */,
/* 1538 */,
/* 1539 */,
/* 1540 */,
/* 1541 */,
/* 1542 */,
/* 1543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isVisible */
/* harmony export (immutable) */ __webpack_exports__["a"] = renderOpenVideoWithoutPreviewButtonText;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_translations_overlay_common_translations__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_ui_selectors_video_preview__ = __webpack_require__(624);
/* eslint-disable react/prop-types */




/**
 * Is open video without preview button visible
 * @param props {Object}
 * @param props.video {Object}
 * @return {Boolean}
 */
function isVisible(_ref) {
  var video = _ref.video;

  return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_ui_selectors_video_preview__["c" /* isPreviewEnabled */])(video);
}

/**
 * Open video without preview button text
 * @param props {Object}
 * @param props.video {Object}
 * @param props.translation {Object} default commonTranslations.startWatching
 * @return {React.Component}
 */
function renderOpenVideoWithoutPreviewButtonText(props) {
  if (!isVisible(props)) {
    return null;
  }
  var translation = props.translation || __WEBPACK_IMPORTED_MODULE_1_shared_translations_overlay_common_translations__["a" /* default */].startWatching;
  return React.createElement(__WEBPACK_IMPORTED_MODULE_0_react_intl__["a" /* FormattedMessage */], translation);
}

/***/ }),
/* 1544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isVisible */
/* harmony export (immutable) */ __webpack_exports__["a"] = renderSignInToWatchButtonText;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_translations_overlay_common_translations__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__video_sign_in_to_watch_button_text__ = __webpack_require__(713);



/**
 * Is video sign in to play button visible
 * @param props {Object}
 * @param props.channel {Object}
 * @param props.video {Object}
 * @return {Boolean}
 */
var isVisible = __WEBPACK_IMPORTED_MODULE_1__video_sign_in_to_watch_button_text__["b" /* isVisible */];

/**
 * Video sign in to play button text
 * @param props {Object}
 * @param props.channel {Object}
 * @param props.video {Object}
 * @param props.translation {Object} default is commonTranslations.startWatching
 * @return {React.Component}
 */
function renderSignInToWatchButtonText(props) {
  props.translation = props.translation || __WEBPACK_IMPORTED_MODULE_0_shared_translations_overlay_common_translations__["a" /* default */].startWatching;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__video_sign_in_to_watch_button_text__["a" /* default */])(props);
}

/***/ }),
/* 1545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* defineMessages */])({
  proceedPaypal: {
    id: 'widget.payments.proceed-paypal',
    defaultMessage: 'Proceed with PayPal'
  },
  subscriptionMonth: {
    id: 'widget.payments.subscription-month',
    defaultMessage: 'Subscription {price}/month'
  },
  purchase: {
    id: 'widget.payments.purchase',
    defaultMessage: 'Purchase {price}'
  },
  rent: {
    id: 'widget.payments.rent',
    defaultMessage: 'Rent {price}'
  },
  singleVideoStreaming: {
    id: 'widget.payments.single-video-streaming',
    defaultMessage: '1 video streaming'
  },
  streamingPeriod: {
    id: 'widget.payments.streaming-period',
    defaultMessage: '{period} hours streaming period starts when you hit the "play" button'
  },
  singleVideo: {
    id: 'widget.payments.single-video',
    defaultMessage: '1 video'
  },
  onePayment: {
    id: 'widget.payments.one-payment',
    defaultMessage: 'One time payment'
  },
  unlimitedStreaming: {
    id: 'widget.payments.unlimitedStreaming',
    defaultMessage: 'Unlimited streaming'
  },
  instantAccess: {
    id: 'widget.payments.instant-access',
    defaultMessage: 'Instant access to new videos'
  },
  monthlyPayment: {
    id: 'widget.payments.monthly-payment',
    defaultMessage: 'Recurring monthly payment (you can cancel this anytime)'
  },
  subscribeToChannel: {
    id: 'widget.payments.subscribe-to-channel',
    defaultMessage: 'Subscribe to channel'
  },
  cancelSubscription: {
    id: 'widget.payments.cancel-subscription',
    defaultMessage: 'Cancel subscription'
  },
  subscribedSince: {
    id: 'widget.payments.subscribed-since',
    defaultMessage: 'Subscribed since {date}. {price}/month'
  },
  memberOnlyBenefits: {
    id: 'widget.payments.member-only-benefits',
    defaultMessage: 'Here\'s what you\'ll get:'
  }
}));

/***/ }),
/* 1546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OverlayStripBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__base_overlay__ = __webpack_require__(1203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_components_icon_icon__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_components_button_button__ = __webpack_require__(35);






var _class, _temp;





var OverlayStripBase = (_temp = _class = function (_BaseOverlay) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(OverlayStripBase, _BaseOverlay);

  function OverlayStripBase() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, OverlayStripBase);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (OverlayStripBase.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(OverlayStripBase)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(OverlayStripBase, [{
    key: 'stopPropagation',
    value: function stopPropagation(event) {
      event.stopPropagation();
    }
  }, {
    key: 'playButton',
    get: function get() {
      var playButtonText = this.playButtonText;

      if (!playButtonText) {
        return null;
      }

      return React.createElement(
        'a',
        { href: '',
          styleName: 'button play-button',
          'data-hook': 'playButton',
          onClick: this.playSelectedVideo,
          className: 'qa-widget-overlay-play-button' },
        React.createElement(__WEBPACK_IMPORTED_MODULE_6_shared_components_icon_icon__["b" /* RoundedIcon */], { styleName: 'icon play-icon',
          name: 'arrow-right-filled' }),
        React.createElement(
          'span',
          { styleName: 'text' },
          playButtonText
        )
      );
    }
  }, {
    key: 'playNextButton',
    get: function get() {
      var playNextButtonText = this.playNextButtonText;

      if (!playNextButtonText) {
        return null;
      }

      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_7_shared_components_button_button__["f" /* GenericButton */],
        { styleName: 'button',
          className: 'qa-widget-player-play-next-button',
          onClick: this.playNextVideo },
        React.createElement(
          'span',
          { styleName: 'text' },
          playNextButtonText
        ),
        React.createElement(__WEBPACK_IMPORTED_MODULE_6_shared_components_icon_icon__["a" /* default */], { styleName: 'icon next-icon',
          name: 'arrow-right' })
      );
    }
  }, {
    key: 'subscribeButton',
    get: function get() {
      var subscribeButtonText = this.subscribeButtonText;

      if (!subscribeButtonText) {
        return null;
      }

      return React.createElement(
        'a',
        { href: '',
          styleName: 'button',
          'data-hook': 'subscribeButton',
          className: 'qa-widget-overlay-subscribe-button',
          onClick: this.openSubscription },
        React.createElement(
          'span',
          { styleName: 'text' },
          subscribeButtonText
        )
      );
    }
  }, {
    key: 'purchaseButton',
    get: function get() {
      var purchaseButtonText = this.purchaseButtonText;

      if (!purchaseButtonText) {
        return null;
      }

      return React.createElement(
        'a',
        { href: '',
          styleName: 'button',
          onClick: this.openPurchase,
          'data-hook': 'purchaseButton',
          className: 'qa-widget-overlay-buy-from-button' },
        React.createElement(
          'span',
          { styleName: 'text' },
          purchaseButtonText
        )
      );
    }
  }]);

  return OverlayStripBase;
}(__WEBPACK_IMPORTED_MODULE_5__base_overlay__["a" /* default */]), _class.displayName = 'OverlayStripBase', _class.propTypes = {
  selectNextVideo: React.PropTypes.func,
  areAllVideosVisible: React.PropTypes.bool,
  toggleVisibilityAllVideos: React.PropTypes.func,
  togglePause: React.PropTypes.func,
  showChannelInfo: React.PropTypes.func
}, _class.defaultProps = {
  selectNextVideo: _.noop,
  toggleVisibilityAllVideos: _.noop,
  togglePause: _.noop,
  showChannelInfo: _.noop
}, _temp);


/***/ }),
/* 1547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StripTitle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_text_overflow_clamp__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_text_overflow_clamp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_text_overflow_clamp__);






var _class, _temp;




var StripTitle = (_temp = _class = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(StripTitle, _React$Component);

  function StripTitle() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, StripTitle);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (StripTitle.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(StripTitle)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(StripTitle, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.clamp();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.clamp();
    }
  }, {
    key: 'clamp',
    value: function clamp() {
      __WEBPACK_IMPORTED_MODULE_6_text_overflow_clamp___default()(this.title, this.props.clampOptions);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          text = _props.text;


      return React.createElement(
        'div',
        { ref: function ref(node) {
            return _this2.title = node;
          },
          className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, 'qa-widget-overlay-title'),
          'data-hook': 'title',
          title: text },
        text
      );
    }
  }]);

  return StripTitle;
}(React.Component), _class.propTypes = {
  text: React.PropTypes.string,
  clampOptions: React.PropTypes.object,
  className: React.PropTypes.string
}, _class.defaultProps = {
  clampOptions: {}
}, _temp);


/***/ }),
/* 1548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PlayerWithStatAndBI; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_widget_player_widget__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_widget_player_widget_components_new_player_player__ = __webpack_require__(1596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_widget_utils_overlay_buttons_utils__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_widget_ui_selectors_video_access__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_shared_ui_selectors_video_video_origin__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_widget_selectors_get_video_urls__ = __webpack_require__(1552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_shared_selectors_experiments__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_shared_selectors_app_settings__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_widget_selectors_current_site_user__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_widget_redux_client_actions_video_urls_fetch__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_widget_redux_server_actions_stats_report__ = __webpack_require__(1212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_shared_constants_stats_events__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_i18n_translations__ = __webpack_require__(555);








var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp2;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}






















var VIDI_ERRORS = {
  SRC_LOAD_ERROR: 'SRC_LOAD_ERROR',
  UNKNOWN_ERROR: 'UNKNOWN_ERROR'
};

/*
 * PlayerWrapper does these while wrapping VODPlayer:
 * - sends BI
 * - logs statistics
 * - checks memberOnly setting
 */
var PlayerWithStatAndBI = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_redux__["a" /* connect */])(function (state, props) {
  return {
    videoUrls: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_widget_selectors_get_video_urls__["a" /* default */])(state, props),
    appSettings: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17_shared_selectors_app_settings__["a" /* getAllSettings */])(state),
    newPlayerEnabled: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_shared_selectors_experiments__["a" /* isNewPlayerEnabled */])(state),
    currentSiteUser: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18_widget_selectors_current_site_user__["a" /* getCurrentSiteUser */])(state)
  };
}, {
  reportStats: __WEBPACK_IMPORTED_MODULE_20_widget_redux_server_actions_stats_report__["a" /* default */],
  fetchVideoUrls: __WEBPACK_IMPORTED_MODULE_19_widget_redux_client_actions_video_urls_fetch__["a" /* default */]
}), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_shared_utils_wix_connect__["c" /* VODBiEvents */])(), _dec(_class = _dec2(_class = (_class2 = (_temp2 = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(PlayerWithStatAndBI, _React$Component);

  function PlayerWithStatAndBI() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, PlayerWithStatAndBI);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = PlayerWithStatAndBI.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(PlayerWithStatAndBI)).call.apply(_ref, [this].concat(args))), _this), _this.reloadCounts = {}, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(PlayerWithStatAndBI, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.checkVideoUrls(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.checkVideoUrls(nextProps);
    }
  }, {
    key: 'checkVideoUrls',
    value: function checkVideoUrls(_ref2) {
      var fetchVideoUrls = _ref2.fetchVideoUrls,
          videoItem = _ref2.videoItem,
          videoUrls = _ref2.videoUrls;

      // TODO: Need to move this logic out of view
      // See the same in SlidableListWithLazyLoad
      if (!videoUrls && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_shared_ui_selectors_video_video_origin__["b" /* isExternalVideo */])(videoItem)) {
        if (!videoItem.memberOnly || this.isUserLogged) {
          fetchVideoUrls(videoItem);
        }
      }
    }
  }, {
    key: 'reloadVideoUrls',
    value: function reloadVideoUrls(error) {
      if (!error) {
        return;
      }

      var _props = this.props,
          fetchVideoUrls = _props.fetchVideoUrls,
          videoItem = _props.videoItem;
      var id = videoItem.id;


      this.reloadCounts[id] = this.reloadCounts[id] || 0;
      this.reloadCounts[id] += 1;

      if (this.reloadCounts[id] > 1) {
        return;
      }

      if (error === VIDI_ERRORS.SRC_LOAD_ERROR) {
        fetchVideoUrls(videoItem, true);
      }
    }
  }, {
    key: 'onPlayStart',
    value: function onPlayStart() {
      this.props.onPlayStart();
      this.sendVidStartPlayBI();
    }
  }, {
    key: 'onEnded',
    value: function onEnded() {
      this.sendVidPlayedBI();

      var _props2 = this.props,
          onEnded = _props2.onEnded,
          reportStats = _props2.reportStats,
          channelData = _props2.channelData,
          videoItem = _props2.videoItem,
          currentSiteUser = _props2.currentSiteUser;

      onEnded();

      var event = void 0;
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_widget_ui_selectors_video_access__["b" /* canAccessFullVideo */])(channelData, videoItem, currentSiteUser)) {
        event = __WEBPACK_IMPORTED_MODULE_21_shared_constants_stats_events__["a" /* default */].VIDEO_PLAY_COMPLETE;
      } else {
        event = __WEBPACK_IMPORTED_MODULE_21_shared_constants_stats_events__["a" /* default */].VIDEO_PLAY_TRAILER;
      }

      reportStats(event, {
        channel: channelData,
        videoItem: videoItem
      });
    }
  }, {
    key: 'sendVidStartPlayBI',
    value: function sendVidStartPlayBI() {
      var button = this.props.mainOrThumbnailLocation;

      this.sendBI('widget.vid.start.play', { button: button });
    }
  }, {
    key: 'sendVidPlayedBI',
    value: function sendVidPlayedBI() {
      var button = this.props.mainOrThumbnailLocation;

      this.sendBI('widget.vid.played', { button: button });
    }
  }, {
    key: 'sendBIForShowActions',
    value: function sendBIForShowActions(actionsList) {
      if (_.includes(actionsList, __WEBPACK_IMPORTED_MODULE_9_widget_player_widget__["a" /* OVERLAY_ACTION_TYPES */].BUY_RENT)) {
        this.sendBuyBI('widget.vid.buy.displayed');
      }
      if (_.includes(actionsList, __WEBPACK_IMPORTED_MODULE_9_widget_player_widget__["a" /* OVERLAY_ACTION_TYPES */].INFO)) {
        this.sendBI('widget.vid.info.displayed');
      }
      if (_.includes(actionsList, __WEBPACK_IMPORTED_MODULE_9_widget_player_widget__["a" /* OVERLAY_ACTION_TYPES */].SHARE)) {
        this.sendBI('widget.vid.share.displayed');
      }
    }
  }, {
    key: 'sendBIForActionClicked',
    value: function sendBIForActionClicked(actionName, params) {
      if (actionName === __WEBPACK_IMPORTED_MODULE_9_widget_player_widget__["a" /* OVERLAY_ACTION_TYPES */].INFO) {
        this.sendBI('widget.vid.info.clicked');
      } else if (actionName === __WEBPACK_IMPORTED_MODULE_9_widget_player_widget__["a" /* OVERLAY_ACTION_TYPES */].BUY_RENT) {
        this.sendBuyBI('widget.vid.buy.clicked');
      } else if (actionName === __WEBPACK_IMPORTED_MODULE_9_widget_player_widget__["a" /* OVERLAY_ACTION_TYPES */].SHARE) {
        var _props3 = this.props,
            _reportStats = _props3.reportStats,
            channelData = _props3.channelData,
            videoItem = _props3.videoItem;


        _reportStats(__WEBPACK_IMPORTED_MODULE_21_shared_constants_stats_events__["a" /* default */].VIDEO_SHARE, {
          channel: channelData,
          videoItem: videoItem,
          network: {
            name: params.networkName
          }
        });

        this.sendBI('widget.vid.share.clicked', {
          button: params.networkName
        });
      }
    }
  }, {
    key: 'sendBI',
    value: function sendBI(name, params) {
      var _props4 = this.props,
          channelData = _props4.channelData,
          videoItem = _props4.videoItem,
          biEvent = _props4.biEvent;
      var id = videoItem.id,
          videoSource = videoItem.videoSource;


      biEvent(name, _.assign({}, params, {
        channelID: channelData.id,
        videoID: id,
        videoType: videoSource
      }));
    }
  }, {
    key: 'sendBuyBI',
    value: function sendBuyBI(name) {
      var _props5 = this.props,
          videoItem = _props5.videoItem,
          channelData = _props5.channelData,
          button = _props5.mainOrThumbnailLocation;


      var buyType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_widget_utils_overlay_buttons_utils__["g" /* getBuyButtonDisplayType */])(channelData, videoItem);

      this.sendBI(name, {
        buyType: buyType,
        button: button
      });
    }
  }, {
    key: 'sendBIForFullScreenClicked',
    value: function sendBIForFullScreenClicked(isFullScreen) {
      if (!isFullScreen) {
        this.sendBI('widget.vid.fullScreen.clicked');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props6 = this.props,
          size = _props6.size,
          channelData = _props6.channelData,
          videoItem = _props6.videoItem,
          memberOnlyOverlay = _props6.memberOnlyOverlay,
          canShowChannelCover = _props6.canShowChannelCover,
          width = _props6.width,
          height = _props6.height,
          appSettings = _props6.appSettings,
          onMemberSignUp = _props6.onMemberSignUp,
          newPlayerEnabled = _props6.newPlayerEnabled;


      var props = _.omit(this.props, 'newPlayerEnabled', 'size', 'reportStats');
      var PlayerComponent = newPlayerEnabled ? __WEBPACK_IMPORTED_MODULE_10_widget_player_widget_components_new_player_player__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_9_widget_player_widget__["b" /* Player */];
      if (!videoItem.memberOnly || this.isUserLogged) {
        return React.createElement(PlayerComponent, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, props, size, {
          isFetchDisabled: true,
          translations: __WEBPACK_IMPORTED_MODULE_22_i18n_translations__["a" /* translations */],
          onPlayStart: this.onPlayStart,
          onEnded: this.onEnded,
          onError: this.reloadVideoUrls,
          onShowActions: this.sendBIForShowActions,
          onActionClicked: this.sendBIForActionClicked,
          onFullScreenClicked: this.sendBIForFullScreenClicked }));
      }

      return React.cloneElement(memberOnlyOverlay, {
        showChannelCover: canShowChannelCover,
        videoItem: videoItem,
        width: width,
        height: height,
        appSettings: appSettings,
        channelData: channelData,
        onPlayClick: onMemberSignUp
      });
    }
  }, {
    key: 'isUserLogged',
    get: function get() {
      var currentSiteUser = this.props.currentSiteUser;


      return Boolean(currentSiteUser);
    }
  }]);

  return PlayerWithStatAndBI;
}(React.Component), _class3.propTypes = {
  width: React.PropTypes.number,
  height: React.PropTypes.number,
  videoUrls: React.PropTypes.object,
  videoItem: React.PropTypes.object,
  //remove after new player
  channelData: React.PropTypes.object,
  size: React.PropTypes.object,
  simple: React.PropTypes.bool,
  mobileMode: React.PropTypes.bool,
  overlay: React.PropTypes.any,
  onFullScreenChanged: React.PropTypes.func,
  openPreviewPrompt: React.PropTypes.func,
  onPlayStart: React.PropTypes.func,
  onEnded: React.PropTypes.func,
  reportStats: React.PropTypes.func,
  fetchVideoUrls: React.PropTypes.func,
  biEvent: React.PropTypes.func,
  appSettings: React.PropTypes.object,
  canShowChannelCover: React.PropTypes.bool,
  mainOrThumbnailLocation: React.PropTypes.string,
  muted: React.PropTypes.bool,
  loop: React.PropTypes.bool,
  showInitialOverlay: React.PropTypes.bool,
  currentSiteUser: React.PropTypes.object,
  memberOnlyOverlay: React.PropTypes.node,
  onMemberSignUp: React.PropTypes.func,
  currentTime: React.PropTypes.number,
  newPlayerEnabled: React.PropTypes.bool
}, _class3.defaultProps = {
  openPreviewPrompt: _.noop,
  onPlayStart: _.noop,
  onEnded: _.noop,
  onMemberSignUp: _.noop,
  mainOrThumbnailLocation: 'main',
  simple: false,
  mobileMode: false
}, _temp2), (_applyDecoratedDescriptor(_class2.prototype, 'reloadVideoUrls', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'reloadVideoUrls'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onPlayStart', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'onPlayStart'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onEnded', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'onEnded'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'sendBIForShowActions', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'sendBIForShowActions'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'sendBIForActionClicked', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'sendBIForActionClicked'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'sendBIForFullScreenClicked', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'sendBIForFullScreenClicked'), _class2.prototype)), _class2)) || _class) || _class);


/***/ }),
/* 1549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReloadStorage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_debounce__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_utils_wix_sdk__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_widget_utils_reload__ = __webpack_require__(437);







var _desc, _value, _class, _class2, _temp2;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}







var RELOAD_STORAGE_READY = 'reloadStorageReady';
var currentInstanceId = __WEBPACK_IMPORTED_MODULE_8_shared_utils_wix_sdk__["a" /* default */].Utils.getInstanceId();

// TODO: enhance this to look like real storage with get/set/remove methods

/*
 * Since after UOU login or logout, whole site rebuilds, and there is no nice solution in WixSDK for this case.
 * This is workaround, that use persistent events in Wix.PubSub. Anytime we let user login or logout, we also
 * stores data, that we want to path into "next state" of widget after it's reloaded. But since we use
 * persistent events, they are stored in same sequence as we publish them until site is closed or manually refreshed.
 * But we need only last one, that's why we use @debounce for method `processRetrievedData`
 */
var ReloadStorage = (_class = (_temp2 = _class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ReloadStorage, _React$Component);

  function ReloadStorage() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ReloadStorage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = ReloadStorage.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(ReloadStorage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isProcessing: true
    }, _this.lastEventData = {}, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ReloadStorage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_widget_utils_reload__["a" /* storeForReload */])(RELOAD_STORAGE_READY);
      __WEBPACK_IMPORTED_MODULE_8_shared_utils_wix_sdk__["a" /* default */].PubSub.subscribe(__WEBPACK_IMPORTED_MODULE_9_widget_utils_reload__["b" /* REFRESH_EVENT */], this.saveEventData, true);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unsubscribe();
    }
  }, {
    key: 'unsubscribe',
    value: function unsubscribe() {
      __WEBPACK_IMPORTED_MODULE_8_shared_utils_wix_sdk__["a" /* default */].PubSub.unsubscribe(__WEBPACK_IMPORTED_MODULE_9_widget_utils_reload__["b" /* REFRESH_EVENT */], this.saveEventData);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_widget_utils_reload__["a" /* storeForReload */])(null);
    }
  }, {
    key: 'saveEventData',
    value: function saveEventData(_ref2) {
      var data = _ref2.data;

      if (!data || data.stored !== RELOAD_STORAGE_READY) {
        this.lastEventData = data || {};
      }
      this.retrieveDataAfterReload();
    }
  }, {
    key: 'retrieveDataAfterReload',
    value: function retrieveDataAfterReload() {
      var onReload = this.props.onReload;
      var _lastEventData = this.lastEventData,
          stored = _lastEventData.stored,
          instanceId = _lastEventData.instanceId;


      if (instanceId === currentInstanceId && stored) {
        onReload(stored);
      }

      this.setState({ isProcessing: false });
      this.lastEventData = {};
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;


      if (!children || this.state.isProcessing) {
        return null;
      }

      return children;
    }
  }]);

  return ReloadStorage;
}(React.Component), _class2.propTypes = {
  onReload: React.PropTypes.func,

  children: React.PropTypes.element
}, _class2.defaultProps = {
  onReload: _.noop
}, _temp2), (_applyDecoratedDescriptor(_class.prototype, 'saveEventData', [__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'saveEventData'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'retrieveDataAfterReload', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_debounce___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'retrieveDataAfterReload'), _class.prototype)), _class);


/***/ }),
/* 1550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClearVideoUrlsCacheOnPayment; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_debounce__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_components_payment_events_payment_events__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_widget_redux_client_actions_video_urls_clear__ = __webpack_require__(1210);







var _dec, _class, _desc, _value, _class2, _class3, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}








var ClearVideoUrlsCacheOnPayment = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["a" /* connect */])(null, {
  clearVideoUrlsCacheForAll: __WEBPACK_IMPORTED_MODULE_10_widget_redux_client_actions_video_urls_clear__["a" /* clearVideoUrlsCacheForAll */],
  clearVideoUrlsCacheForItem: __WEBPACK_IMPORTED_MODULE_10_widget_redux_client_actions_video_urls_clear__["b" /* clearVideoUrlsCacheForItem */]
}), _dec(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ClearVideoUrlsCacheOnPayment, _React$Component);

  function ClearVideoUrlsCacheOnPayment() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ClearVideoUrlsCacheOnPayment);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ClearVideoUrlsCacheOnPayment.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(ClearVideoUrlsCacheOnPayment)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ClearVideoUrlsCacheOnPayment, [{
    key: 'clearVideoUrlsCacheForAll',
    value: function clearVideoUrlsCacheForAll() {
      this.props.clearVideoUrlsCacheForAll();
    }
  }, {
    key: 'clearVideoUrlsCacheForItem',
    value: function clearVideoUrlsCacheForItem(data) {
      this.props.clearVideoUrlsCacheForItem(data.itemId);
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(__WEBPACK_IMPORTED_MODULE_9_shared_components_payment_events_payment_events__["a" /* default */], { onSubscription: this.clearVideoUrlsCacheForAll,
        onSubscriptionCancel: this.clearVideoUrlsCacheForAll,
        onRent: this.clearVideoUrlsCacheForItem,
        onSale: this.clearVideoUrlsCacheForItem });
    }
  }]);

  return ClearVideoUrlsCacheOnPayment;
}(React.Component), _class3.propTypes = {
  clearVideoUrlsCacheForAll: React.PropTypes.func,
  clearVideoUrlsCacheForItem: React.PropTypes.func
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'clearVideoUrlsCacheForAll', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a, __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_debounce___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'clearVideoUrlsCacheForAll'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'clearVideoUrlsCacheForItem', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'clearVideoUrlsCacheForItem'), _class2.prototype)), _class2)) || _class);


/***/ }),
/* 1551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UpdateWidgetSize; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_debounce__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_selectors_app_settings__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_widget_redux_client_actions_app_settings__ = __webpack_require__(352);







var _dec, _class, _desc, _value, _class2, _class3, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}









var UpdateWidgetSize = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["a" /* connect */])(function (state) {
  return {
    // lazyVideoLists is needed to trigger height calculations
    // TODO: move resizing logic to view
    lazyVideoLists: state.lazyVideoLists,
    requestedWidgetSize: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_shared_selectors_app_settings__["e" /* getRequestedWidgetSize */])(state)
  };
}, {
  updateAppSettings: __WEBPACK_IMPORTED_MODULE_10_widget_redux_client_actions_app_settings__["a" /* updateAppSettings */]
}), _dec(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(UpdateWidgetSize, _React$Component);

  function UpdateWidgetSize() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, UpdateWidgetSize);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (UpdateWidgetSize.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(UpdateWidgetSize)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(UpdateWidgetSize, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.updateWidgetSize();
      window.addEventListener('resize', this.updateWidgetSize);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return !_.isEqual(this.props.lazyVideoLists, nextProps.lazyVideoLists);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.updateWidgetSize();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateWidgetSize);
    }
  }, {
    key: 'updateWidgetSize',
    value: function updateWidgetSize() {
      if (this.props.disabled) {
        return;
      }

      var _props = this.props,
          requestedWidgetSize = _props.requestedWidgetSize,
          updateAppSettings = _props.updateAppSettings;

      var widgetSize = {
        width: window.innerWidth,
        height: window.innerHeight
      };

      if (!widgetSize.width || _.isEqual(requestedWidgetSize, widgetSize)) {
        return;
      }

      // TODO: move to separate action
      updateAppSettings({
        requestedWidgetSize: widgetSize
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return UpdateWidgetSize;
}(React.Component), _class3.propTypes = {
  requestedWidgetSize: React.PropTypes.object,
  lazyVideoLists: React.PropTypes.object,
  disabled: React.PropTypes.bool,
  updateAppSettings: React.PropTypes.func
}, _class3.defaultProps = {
  disabled: false
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'updateWidgetSize', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a, __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_debounce___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'updateWidgetSize'), _class2.prototype)), _class2)) || _class);


/***/ }),
/* 1552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_widget_constants_ulrs_cache_status__ = __webpack_require__(1205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reselect__);



var getUrlsCache = function getUrlsCache(state) {
  return state.videoUrlsCache;
};
var getVideoItem = function getVideoItem(_, props) {
  return props.videoItem;
};
var getVideoUrls = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([getUrlsCache, getVideoItem], function (cache, videoItem) {
  if (!videoItem) {
    return null;
  }

  var videoUrlsFromCache = cache[videoItem.id];

  if (videoUrlsFromCache && videoUrlsFromCache.status === __WEBPACK_IMPORTED_MODULE_0_widget_constants_ulrs_cache_status__["a" /* default */].RESOLVED) {
    return videoUrlsFromCache.urls;
  }

  return null;
});

/* harmony default export */ __webpack_exports__["a"] = (getVideoUrls);

/***/ }),
/* 1553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_default_settings__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_widget_utils_not_for_preview__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_sdk__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_utils_performance__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_widget_utils_payments__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_utils_performance_types__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_widget_ui_selectors_video_access__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_shared_utils_bi_video_overlay_events_params__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_widget_utils_videos_sizes__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_shared_bi_bi__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_shared_utils_open_overlay__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_shared_components_modal_modal__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_shared_utils_request_login__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_shared_bi_send_bi_event__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_shared_constants_events__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_shared_constants_view_modes__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_shared_constants_search_query_fields__ = __webpack_require__(1247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_shared_components_spinner_loading_spinner__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_shared_components_resized_image_resized_image__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_widget_components_no_content_no_videos_content_no_videos_content__ = __webpack_require__(1828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_widget_components_payments_payments__ = __webpack_require__(1831);







var _dec, _desc, _value, _class, _class2, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}




























var BaseView = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_shared_bi_send_bi_event__["a" /* withBiEvent */])('widget.signIn.clicked'), (_class = (_temp = _class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(BaseView, _React$Component);

  function BaseView(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, BaseView);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (BaseView.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(BaseView)).call(this, props));

    _this.isOpenedBiSent = false;
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(BaseView, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.updateInitialVideosLoadedState();
      // TODO: move to HOC after moving canShowChannelCover and paused to Redux Store
      __WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_sdk__["a" /* default */].addEventListener(__WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_sdk__["a" /* default */].Events.SETTINGS_UPDATED, this.reloadOnDashboardClosing);
      __WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_sdk__["a" /* default */].addEventListener(__WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_sdk__["a" /* default */].Events.PAGE_NAVIGATION, this.stopPlaybackOnPageChange);
      __WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_sdk__["a" /* default */].addEventListener(__WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_sdk__["a" /* default */].Events.EDIT_MODE_CHANGE, this.reset);
      __WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_sdk__["a" /* default */].addEventListener(__WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_sdk__["a" /* default */].Events.EDIT_MODE_CHANGE, __WEBPACK_IMPORTED_MODULE_18_shared_components_modal_modal__["a" /* closeModal */]);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.updateInitialVideosLoadedState(nextProps);

      if (__WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_sdk__["a" /* default */].Utils.getViewMode() === __WEBPACK_IMPORTED_MODULE_22_shared_constants_view_modes__["a" /* default */].EDITOR && this.hasChangesInAppSettings(nextProps)) {
        this.reset(nextProps);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props = this.props,
          currentChannelId = _props.currentChannelId,
          mainVideoId = _props.mainVideoId;


      this.logOpenedBIEvent();

      // TODO: move to HOC after move canShowChannelCover to Redux Store
      if (currentChannelId !== prevProps.currentChannelId) {
        this.reset();
      }

      if (prevProps.mainVideoId && mainVideoId !== prevProps.mainVideoId) {
        __WEBPACK_IMPORTED_MODULE_16_shared_bi_bi__["a" /* default */].logWidgetSystem('video.select.rendered', { previousEventName: 'video.select.requested' });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      __WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_sdk__["a" /* default */].removeEventListener(__WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_sdk__["a" /* default */].Events.SETTINGS_UPDATED, this.reloadOnDashboardClosing);
      __WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_sdk__["a" /* default */].removeEventListener(__WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_sdk__["a" /* default */].Events.PAGE_NAVIGATION, this.stopPlaybackOnPageChange);
      __WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_sdk__["a" /* default */].removeEventListener(__WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_sdk__["a" /* default */].Events.EDIT_MODE_CHANGE, this.reset);
      __WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_sdk__["a" /* default */].addEventListener(__WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_sdk__["a" /* default */].Events.EDIT_MODE_CHANGE, __WEBPACK_IMPORTED_MODULE_18_shared_components_modal_modal__["a" /* closeModal */]);
    }
  }, {
    key: 'hasChangesInAppSettings',
    value: function hasChangesInAppSettings(nextProps) {
      var _nextProps$appSetting = nextProps.appSettings,
          nextBooleans = _nextProps$appSetting.booleans,
          nextNumbers = _nextProps$appSetting.numbers;
      var _props$appSettings = this.props.appSettings,
          thisBooleans = _props$appSettings.booleans,
          thisNumbers = _props$appSettings.numbers;

      return !_.isEqual(nextBooleans, thisBooleans) || !_.isEqual(nextNumbers, thisNumbers);
    }
  }, {
    key: 'updateInitialVideosLoadedState',
    value: function updateInitialVideosLoadedState() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      if (!this.state.isInitialVideosLoaded && !props.isVideosFetching) {
        this.setState({ isInitialVideosLoaded: true });
      }
    }
  }, {
    key: 'permitSearch',
    value: function permitSearch(searchQuery) {
      var searchQueryField = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_23_shared_constants_search_query_fields__["a" /* default */].QUERY;

      this.props.updateSearch({ searchQuery: searchQuery, searchQueryField: searchQueryField });
    }
  }, {
    key: 'showSearchLayout',
    value: function showSearchLayout() {
      this.setState({ searchLayout: true });
    }
  }, {
    key: 'logOpenedBIEvent',
    value: function logOpenedBIEvent() {
      var _this2 = this;

      var _props2 = this.props,
          appSettings = _props2.appSettings,
          channelData = _props2.channelData;

      var videoItem = this.mainVideo;

      if (!this.isUIBlockingDataLoaded || this.isOpenedBiSent) {
        return;
      }

      this.isOpenedBiSent = true;

      _.delay(function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_shared_utils_performance__["a" /* addSingleMeasurement */])(__WEBPACK_IMPORTED_MODULE_12_shared_utils_performance_types__["a" /* default */].appFullyRendered);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_shared_utils_performance__["b" /* sendPerformanceInfo */])();

        _this2.props.biEvent('widget.opened', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_shared_utils_bi_video_overlay_events_params__["a" /* getOpenedEventParams */])(appSettings, channelData, videoItem, _this2.canShowChannelCover));
      });
    }
  }, {
    key: 'storeDataForReload',
    value: function storeDataForReload() {
      return null;
    }

    // TODO: move to channel action callbacks after moving storeDataForReload to data-component

  }, {
    key: 'showLogInForm',
    value: function showLogInForm() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19_shared_utils_request_login__["a" /* requestLogin */])({ isLogin: true }).then(this.storeDataForReload);
    }

    // TODO: move to channel action callbacks after moving storeDataForReload to data-component

  }, {
    key: 'logOut',
    value: function logOut() {
      __WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_sdk__["a" /* default */].logOutCurrentMember();
      this.storeDataForReload();
    }
  }, {
    key: 'openAccountInfoAtOverlay',
    value: function openAccountInfoAtOverlay() {
      var channelData = this.props.channelData;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17_shared_utils_open_overlay__["a" /* openFullScreenOverlay */])('#/account-info/' + channelData.id);
    }
  }, {
    key: 'clearSearch',
    value: function clearSearch() {
      var currentCategory = this.state.currentCategory;


      if (currentCategory) {
        this.permitSearch(currentCategory, __WEBPACK_IMPORTED_MODULE_23_shared_constants_search_query_fields__["a" /* default */].CATEGORY);
      } else {
        this.permitSearch('');
      }

      this.setSearchBarValue('');
    }
  }, {
    key: 'searchByQuery',
    value: function searchByQuery(searchQuery) {
      __WEBPACK_IMPORTED_MODULE_16_shared_bi_bi__["a" /* default */].logWidgetSystem('videoList.searchByQuery.requested');
      this.permitSearch(searchQuery, __WEBPACK_IMPORTED_MODULE_23_shared_constants_search_query_fields__["a" /* default */].QUERY);
      this.setState({
        searchBarValue: searchQuery,
        currentCategory: null
      });
    }
  }, {
    key: 'setSearchBarValue',
    value: function setSearchBarValue(searchBarValue) {
      this.setState({ searchBarValue: searchBarValue });
    }
  }, {
    key: 'searchByCategory',
    value: function searchByCategory(currentCategory) {
      __WEBPACK_IMPORTED_MODULE_16_shared_bi_bi__["a" /* default */].logWidgetSystem('videoList.searchByCategory.requested');
      this.permitSearch(currentCategory, __WEBPACK_IMPORTED_MODULE_23_shared_constants_search_query_fields__["a" /* default */].CATEGORY);
      this.setState({
        currentCategory: currentCategory,
        searchBarValue: ''
      });
    }
  }, {
    key: 'searchByTag',
    value: function searchByTag(tag) {
      __WEBPACK_IMPORTED_MODULE_16_shared_bi_bi__["a" /* default */].logWidgetSystem('videoList.searchByTag.requested');
      this.setTagsFocusState(false);
      this.permitSearch(tag, __WEBPACK_IMPORTED_MODULE_23_shared_constants_search_query_fields__["a" /* default */].TAG);
      this.setState({
        searchBarValue: tag,
        currentCategory: null
      });
      this.sendTagClickedBI();
    }
  }, {
    key: 'handleTagsFocus',
    value: function handleTagsFocus() {
      this.setTagsFocusState(true);
    }
  }, {
    key: 'handleTagsBlur',
    value: function handleTagsBlur() {
      this.setTagsFocusState(false);
    }
  }, {
    key: 'setTagsFocusState',
    value: function setTagsFocusState(isFocused) {
      var _this3 = this;

      this.setState({
        isTagFocused: isFocused
      });

      if (!isFocused) {
        setTimeout(function () {
          return _this3.hideSearchLayout();
        }, 0);
      }
    }
  }, {
    key: 'handleSearchInputFocus',
    value: function handleSearchInputFocus() {
      this.setSearchInputFocusState(true);
    }
  }, {
    key: 'handleSearchInputBlur',
    value: function handleSearchInputBlur() {
      this.setSearchInputFocusState(false);
    }
  }, {
    key: 'setSearchInputFocusState',
    value: function setSearchInputFocusState(isFocused) {
      var _this4 = this;

      this.setState({
        isSearchInputFocused: isFocused
      });

      if (isFocused) {
        this.showSearchLayout();
      } else {
        if (this.hasNoSearchResults) {
          this.clearSearch();
        }
        setTimeout(function () {
          return _this4.hideSearchLayout();
        }, 0);
      }
    }
  }, {
    key: 'hideSearchLayout',
    value: function hideSearchLayout() {
      var _state = this.state,
          isTagFocused = _state.isTagFocused,
          isSearchInputFocused = _state.isSearchInputFocused;

      if (!isTagFocused && !isSearchInputFocused) {
        this.setState({
          searchLayout: false
        });
      }
    }
  }, {
    key: 'sendTagClickedBI',
    value: function sendTagClickedBI() {
      this.props.biEvent('widget.tags.clicked');
    }
  }, {
    key: 'openPurchase',
    value: function openPurchase() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27_widget_components_payments_payments__["a" /* openPurchase */])(this.mainVideo.id);
    }
  }, {
    key: 'openSubscription',
    value: function openSubscription() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27_widget_components_payments_payments__["b" /* openSubscription */])(this.props.biEvent);
    }
  }, {
    key: 'selectVideo',
    value: function selectVideo(_ref) {
      var id = _ref.id;

      this.props.selectVideo(id);
    }
  }, {
    key: 'playSelectedVideo',
    value: function playSelectedVideo() {
      var id = this.props.mainVideoId;


      this.playVideo({ id: id });
    }
  }, {
    key: 'playPrevVideo',
    value: function playPrevVideo() {
      var id = this.props.prevVideoId;


      if (id) {
        this.playVideo({ id: id });
      }
    }
  }, {
    key: 'playNextVideo',
    value: function playNextVideo() {
      var id = this.props.nextVideoId;


      if (id) {
        this.playVideo({ id: id });
      }
    }
  }, {
    key: 'playVideo',
    value: function playVideo(_ref2) {
      var id = _ref2.id;
      var _props3 = this.props,
          videoByIds = _props3.videoByIds,
          channelData = _props3.channelData,
          currentSiteUser = _props3.currentSiteUser,
          selectVideo = _props3.selectVideo,
          playVideo = _props3.playVideo;

      var videoItem = videoByIds[id];
      var isPlayAllowed = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_widget_ui_selectors_video_access__["a" /* canPlayFullOrPreview */])(channelData, videoItem, currentSiteUser);

      if (isPlayAllowed) {
        playVideo(videoItem.id);
      } else {
        selectVideo(videoItem.id);
      }
    }
  }, {
    key: 'selectNextVideo',
    value: function selectNextVideo() {
      var id = this.props.nextVideoId;

      if (id) {
        this.selectVideo({ id: id });
      }
    }
  }, {
    key: 'selectPrevVideo',
    value: function selectPrevVideo() {
      var id = this.props.prevVideoId;

      if (id) {
        this.selectVideo({ id: id });
      }
    }
  }, {
    key: 'setFullScreenState',
    value: function setFullScreenState(isInFullScreen) {
      // in full screen in mobile the innerWidth becomes bigger that is should be, so exit.
      // Seems like this is viewer issue because site itself becomes wider than 320px.
      this.setState({ isInFullScreen: isInFullScreen });
    }
  }, {
    key: 'reloadData',
    value: function reloadData() {
      var _props4 = this.props,
          channel = _props4.channel,
          channelPaymentData = _props4.channelPaymentData,
          fetchVideos = _props4.fetchVideos;


      this.setState({
        isInitialVideosLoaded: false
      });
      channel.fetch();
      channelPaymentData.fetch();
      fetchVideos();
    }

    // TODO: rename to cancelSubscription

  }, {
    key: 'processSubscriptionCancel',
    value: function processSubscriptionCancel() {
      var _props5 = this.props,
          _props5$appSettings = _props5.appSettings,
          siteUrl = _props5$appSettings.siteUrl,
          instance = _props5$appSettings.instance,
          currentChannelId = _props5.currentChannelId;

      __WEBPACK_IMPORTED_MODULE_16_shared_bi_bi__["a" /* default */].logWidgetSystem('channel.unsubscribe.requested');
      __WEBPACK_IMPORTED_MODULE_11_widget_utils_payments__["a" /* default */].cancelSubscription(currentChannelId, siteUrl, instance);
    }
  }, {
    key: 'reset',
    value: function reset() {
      var _props6 = this.props,
          resetSearch = _props6.resetSearch,
          resetSelectedVideo = _props6.resetSelectedVideo;


      resetSearch();
      resetSelectedVideo();
    }
  }, {
    key: 'reloadOnDashboardClosing',
    value: function reloadOnDashboardClosing(event) {
      if (event === __WEBPACK_IMPORTED_MODULE_21_shared_constants_events__["a" /* default */].DASHBOARD.CLOSED) {
        this.reloadData();
        this.reset();
      }
    }
  }, {
    key: 'setCurrentVideoFromPayment',
    value: function setCurrentVideoFromPayment(paymentEvent) {
      if (paymentEvent.itemId) {
        this.selectVideo({
          id: paymentEvent.itemId
        });
      }
    }
  }, {
    key: 'stopPlaybackOnPageChange',
    value: function stopPlaybackOnPageChange(_ref3) {
      var wasAppOnPage = _ref3.wasAppOnPage;

      if (wasAppOnPage && this.props.isVideoPlaying) {
        this.props.pauseVideo();
      }
    }
  }, {
    key: 'playerSize',
    get: function get() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_widget_utils_videos_sizes__["c" /* playerSize */])(this.props.appSettings.requestedWidgetSize.width);
    }
  }, {
    key: 'mainVideo',
    get: function get() {
      var _props7 = this.props,
          mainVideoId = _props7.mainVideoId,
          videoByIds = _props7.videoByIds;

      return videoByIds[mainVideoId];
    }
  }, {
    key: 'isCategorySelected',
    get: function get() {
      return this.props.searchQueryField === __WEBPACK_IMPORTED_MODULE_23_shared_constants_search_query_fields__["a" /* default */].CATEGORY;
    }
  }, {
    key: 'hasNoSearchResults',
    get: function get() {
      var _props8 = this.props,
          videoIdsByPageNumber = _props8.videoIdsByPageNumber,
          searchQuery = _props8.searchQuery,
          isVideosFetching = _props8.isVideosFetching;

      return !isVideosFetching && searchQuery && !videoIdsByPageNumber.length;
    }
  }, {
    key: 'canShowChannelCover',
    get: function get() {
      return this.props.canShowChannelCover;
    }
  }, {
    key: 'isMainItemChannelCover',
    get: function get() {
      return this.props.appSettings.numbers.mainItemType === __WEBPACK_IMPORTED_MODULE_6_default_settings__["a" /* mainItemTypeValues */].CHANNEL_COVER;
    }
  }, {
    key: 'isChannelCoverShown',
    get: function get() {
      return this.canShowChannelCover && this.isMainItemChannelCover;
    }

    // TODO: move to redux store
    // https://jira.wixpress.com/browse/VOD-292

  }, {
    key: 'noVideoPlayerOverlay',
    get: function get() {
      return React.createElement('div', null);
    }
  }, {
    key: 'noVideosPlayerContent',
    get: function get() {
      var channelData = this.props.channelData;
      var _playerSize = this.playerSize,
          width = _playerSize.width,
          height = _playerSize.height;


      if (!this.isMainItemChannelCover) {
        return React.createElement(__WEBPACK_IMPORTED_MODULE_26_widget_components_no_content_no_videos_content_no_videos_content__["a" /* default */], { width: width,
          height: height });
      }

      var coverUrl = channelData.customCoverUrl || channelData.coverUrl;
      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_25_shared_components_resized_image_resized_image__["a" /* default */],
        { styleName: 'overlay-only',
          src: coverUrl,
          width: width,
          height: height },
        this.noVideoPlayerOverlay
      );
    }
  }, {
    key: 'isUIBlockingDataLoaded',
    get: function get() {
      var _props9 = this.props,
          channelData = _props9.channelData,
          isCurrentSiteUserFetching = _props9.isCurrentSiteUserFetching,
          channelPaymentData = _props9.channelPaymentData,
          channelVideo = _props9.channelVideo;


      return !_.isEmpty(channelData) && !isCurrentSiteUserFetching && !channelPaymentData.isFetching && !channelVideo.isFetching && this.state.isInitialVideosLoaded;
    }
  }, {
    key: 'spinner',
    get: function get() {
      return React.createElement(
        'div',
        { styleName: 'spinner-container' },
        React.createElement(__WEBPACK_IMPORTED_MODULE_24_shared_components_spinner_loading_spinner__["a" /* default */], { styleName: 'spinner' })
      );
    }
  }]);

  return BaseView;
}(React.Component), _class2.propTypes = {
  mainVideoId: React.PropTypes.string.isRequired,
  isVideoPlaying: React.PropTypes.bool.isRequired,
  playVideo: React.PropTypes.func.isRequired,
  pauseVideo: React.PropTypes.func.isRequired,
  selectVideo: React.PropTypes.func.isRequired,
  resetSelectedVideo: React.PropTypes.func.isRequired,
  currentChannelId: React.PropTypes.string.isRequired,
  canShowChannelCover: React.PropTypes.bool.isRequired,
  prevVideoId: React.PropTypes.string,
  nextVideoId: React.PropTypes.string,
  channelData: React.PropTypes.object.isRequired,
  videoByIds: React.PropTypes.object.isRequired,
  fetchVideos: React.PropTypes.func.isRequired,
  isVideosFetching: React.PropTypes.bool.isRequired,
  channel: React.PropTypes.object.isRequired,
  currentSiteUser: React.PropTypes.object.isRequired,
  isCurrentSiteUserFetching: React.PropTypes.bool,
  channelVideo: React.PropTypes.object.isRequired,
  channelPaymentData: React.PropTypes.object.isRequired,
  videoIdsByPageNumber: React.PropTypes.array,
  appSettings: React.PropTypes.object.isRequired,
  updateSearch: React.PropTypes.func,
  resetSearch: React.PropTypes.func,
  searchQuery: React.PropTypes.string,
  searchQueryField: React.PropTypes.string,
  biEvent: React.PropTypes.func
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'showLogInForm', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a, _dec, __WEBPACK_IMPORTED_MODULE_7_widget_utils_not_for_preview__["a" /* notForPreview */]], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'showLogInForm'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'logOut', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'logOut'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'openAccountInfoAtOverlay', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'openAccountInfoAtOverlay'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'clearSearch', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'clearSearch'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'searchByQuery', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'searchByQuery'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setSearchBarValue', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'setSearchBarValue'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'searchByCategory', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'searchByCategory'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'searchByTag', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'searchByTag'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTagsFocus', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'handleTagsFocus'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTagsBlur', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'handleTagsBlur'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleSearchInputFocus', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'handleSearchInputFocus'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleSearchInputBlur', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'handleSearchInputBlur'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'openPurchase', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'openPurchase'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'openSubscription', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'openSubscription'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'selectVideo', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'selectVideo'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'playSelectedVideo', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'playSelectedVideo'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'playPrevVideo', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'playPrevVideo'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'playNextVideo', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'playNextVideo'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'selectNextVideo', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'selectNextVideo'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'selectPrevVideo', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'selectPrevVideo'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setFullScreenState', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'setFullScreenState'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'processSubscriptionCancel', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'processSubscriptionCancel'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'reset', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'reset'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'reloadOnDashboardClosing', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'reloadOnDashboardClosing'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setCurrentVideoFromPayment', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'setCurrentVideoFromPayment'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'stopPlaybackOnPageChange', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'stopPlaybackOnPageChange'), _class.prototype)), _class));


/***/ }),
/* 1554 */,
/* 1555 */,
/* 1556 */,
/* 1557 */,
/* 1558 */,
/* 1559 */,
/* 1560 */,
/* 1561 */,
/* 1562 */,
/* 1563 */,
/* 1564 */,
/* 1565 */,
/* 1566 */,
/* 1567 */,
/* 1568 */,
/* 1569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  id: 'f3931bf8acb84c52ae31d8ed51e3ce9e',
  title: 'Wix Demo Channel'
});

/***/ }),
/* 1570 */,
/* 1571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  LOGIN: 'login',
  SIGN_UP: 'signup'
});

/***/ }),
/* 1572 */,
/* 1573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NAMES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getPublic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_redux_helpers_create_async_actions__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_utils_adapters_vod__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_redux_helpers_normalized__ = __webpack_require__(49);






var ACTIONS = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_redux_helpers_create_async_actions__["a" /* default */])('SERVER.CHANNEL.VIDEO.GET');
var NAMES = ACTIONS.NAMES;
var START = ACTIONS.START,
    SUCCESS = ACTIONS.SUCCESS,
    FAIL = ACTIONS.FAIL;


function getVideo(method, channelId, videoId) {

  return function (dispatch) {
    var params = { channelId: channelId, videoId: videoId };
    dispatch(START(params));

    var promise = __WEBPACK_IMPORTED_MODULE_2_shared_utils_adapters_vod__["a" /* default */].listItems[method](channelId, videoId);

    return promise.then(function (response) {
      response = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, response, {
        data: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_redux_helpers_normalized__["d" /* normalizeVideo */])(response.data)
      });

      dispatch(SUCCESS(params, response));
      return response;
    }, function (response) {
      dispatch(FAIL(params, response, { analytics: { type: 'error', name: 'shared.channel.video.get' } }));
    });
  };
}

/* unused harmony default export */ var _unused_webpack_default_export = (_.partial(getVideo, 'get'));

var getPublic = _.partial(getVideo, 'getPublic');

/***/ }),
/* 1574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getConfiguration */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getApplicationName; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);


var getConfiguration = function getConfiguration(state) {
  return state.configuration;
};

var getApplicationName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getConfiguration], function (configuration) {
  return _.get(configuration, 'applicationName');
});

/***/ }),
/* 1575 */,
/* 1576 */,
/* 1577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vidi__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vidi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vidi__);



var getVideoUrls = function getVideoUrls(props) {
  return props.videoUrls;
};

function toVidiTypes(url, type) {
  if (/mp4/i.test(type)) {
    return { url: url, type: __WEBPACK_IMPORTED_MODULE_1_vidi___default.a.MediaStreamTypes.MP4, name: /[0-9]+p/i.exec(type)[0] };
  }
  if (/mpd/i.test(type)) {
    return { url: url, type: __WEBPACK_IMPORTED_MODULE_1_vidi___default.a.MediaStreamTypes.DASH };
  }
  if (/m3u8/i.test(type)) {
    return { url: url, type: __WEBPACK_IMPORTED_MODULE_1_vidi___default.a.MediaStreamTypes.HLS };
  }
  if (/webm/i.test(type)) {
    return { url: url, type: __WEBPACK_IMPORTED_MODULE_1_vidi___default.a.MediaStreamTypes.WEBM };
  }
  return null;
}

var getVidiUrls = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getVideoUrls], function (videoUrls) {
  return _.map(videoUrls, toVidiTypes);
});

/* harmony default export */ __webpack_exports__["a"] = (getVidiUrls);

/***/ }),
/* 1578 */,
/* 1579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export colorToRGBA */
/* harmony export (immutable) */ __webpack_exports__["a"] = makeRGBA;
/* unused harmony export isLight */
/* unused harmony export lighten */
/* unused harmony export darken */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);

function colorToRGBA(color) {
  var rgba = void 0;

  if (color.charAt(0) === '#') {
    color = color.slice(1);
  }

  if (color.length === 6) {
    rgba = _.map(color.match(/../g), function (pair) {
      return parseInt(pair, 16);
    });
    rgba.push(1);
    return rgba;
  }

  if (color.length === 3) {
    rgba = _.map(color.match(/./g), function (pair) {
      return parseInt(pair + pair, 16);
    });
    rgba.push(1);
    return rgba;
  }

  rgba = _(color).replace(/^rgba?\(/, '').replace(/\)$/, '').split(',').map(function (value) {
    return Number(value);
  });

  if (rgba.length === 3) {
    rgba.push(1);
  }

  return rgba;
}

function makeRGBA(color, opacity) {
  var colorRGBA = colorToRGBA(color);
  colorRGBA[3] = (_.isFunction(opacity) ? opacity(colorRGBA[3]) : opacity).toFixed(2);
  return 'rgba(' + colorRGBA.join(',') + ')';
}

/**
 * Converts an HSL color value to RGB. Conversion formula
 * adapted from http://en.wikipedia.org/wiki/HSL_color_space.
 * Assumes h, s, and l are contained in the set [0, 1] and
 * returns r, g, and b in the set [0, 255].
 *
 * @param   {number}  h       The hue
 * @param   {number}  s       The saturation
 * @param   {number}  l       The lightness
 * @return  {Array}           The RGB representation
 */
function hslToRgb(h, s, l) {
  var r = void 0;
  var g = void 0;
  var b = void 0;

  function hue2rgb(p, q, t) {
    if (t < 0) {
      t += 1;
    }
    if (t > 1) {
      t -= 1;
    }
    if (t < 1 / 6) {
      return p + (q - p) * 6 * t;
    }
    if (t < 1 / 2) {
      return q;
    }
    if (t < 2 / 3) {
      return p + (q - p) * (2 / 3 - t) * 6;
    }
    return p;
  }

  if (s === 0) {
    // achromatic
    r = g = b = l;
  } else {

    var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    var p = 2 * l - q;
    r = hue2rgb(p, q, h + 1 / 3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1 / 3);
  }

  return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
}

/**
 * Converts an RGB color value to HSL. Conversion formula
 * adapted from http://en.wikipedia.org/wiki/HSL_color_space.
 * Assumes r, g, and b are contained in the set [0, 255] and
 * returns h, s, and l in the set [0, 1].
 *
 * @param   {number}  r       The red color value
 * @param   {number}  g       The green color value
 * @param   {number}  b       The blue color value
 * @return  {Array}           The HSL representation
 */
function rgbToHsl(r, g, b) {
  r /= 255;
  g /= 255;
  b /= 255;
  var max = Math.max(r, g, b);
  var min = Math.min(r, g, b);
  var h = void 0;
  var s = void 0;
  var l = (max + min) / 2;

  if (max === min) {
    // achromatic
    h = s = 0;
  } else {
    var d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
      default:
        break;
    }
    h /= 6;
  }

  return [h, s, l];
}

function isLight(color) {
  var _colorToRGBA = colorToRGBA(color),
      _colorToRGBA2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_colorToRGBA, 3),
      r = _colorToRGBA2[0],
      g = _colorToRGBA2[1],
      b = _colorToRGBA2[2];

  var _rgbToHsl = rgbToHsl(r, g, b),
      _rgbToHsl2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_rgbToHsl, 3),
      lightness = _rgbToHsl2[2];

  return lightness < 0.25;
}

function lightenDarken(color, percent) {
  var _colorToRGBA3 = colorToRGBA(color),
      _colorToRGBA4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_colorToRGBA3, 3),
      r = _colorToRGBA4[0],
      g = _colorToRGBA4[1],
      b = _colorToRGBA4[2];

  var _rgbToHsl3 = rgbToHsl(r, g, b),
      _rgbToHsl4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_rgbToHsl3, 3),
      h = _rgbToHsl4[0],
      s = _rgbToHsl4[1],
      l = _rgbToHsl4[2];

  return 'rgb(' + hslToRgb(h, s, l - l * percent / 100).join(',') + ')';
}

function lighten(color, percent) {
  return lightenDarken(color, percent);
}

function darken(color, percent) {
  return lightenDarken(color, -percent);
}

/***/ }),
/* 1580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonsGroup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_utils_memoized_partial__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_selectors_app_settings__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__button__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__buttons_group_styl__ = __webpack_require__(1662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__buttons_group_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__buttons_group_styl__);







var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp2;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}














var ButtonsGroup = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["a" /* connect */])(function (state) {
  return {
    isRounded: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_shared_selectors_app_settings__["b" /* areElementsRounded */])(state)
  };
}), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_13__buttons_group_styl___default.a), _dec(_class = _dec2(_class = (_class2 = (_temp2 = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ButtonsGroup, _React$Component);

  function ButtonsGroup() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ButtonsGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = ButtonsGroup.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(ButtonsGroup)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      currentActive: null
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ButtonsGroup, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var buttons = this.props.buttons;
      var defaultActive = this.props.defaultActive;


      if (!buttons.length) {
        return;
      }

      if (!defaultActive) {
        defaultActive = _.get(buttons, '[0].key');
      }

      this.handleClick(defaultActive);
    }
  }, {
    key: 'handleClick',
    value: function handleClick(key) {
      var currentActive = this.state.currentActive;
      var onChange = this.props.onChange;


      if (currentActive !== key) {
        this.setState({
          currentActive: key
        });

        onChange(key);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          isRounded = _props.isRounded,
          buttons = _props.buttons,
          className = _props.className;


      if (!buttons.length) {
        return null;
      }

      var styleNames = __WEBPACK_IMPORTED_MODULE_7_classnames___default()('buttons-wrapper', {
        rounded: isRounded
      });

      return React.createElement(
        'div',
        { styleName: styleNames,
          className: className },
        this.buttonList
      );
    }
  }, {
    key: 'buttonList',
    get: function get() {
      var _this2 = this;

      var _props2 = this.props,
          buttons = _props2.buttons,
          disableTheme = _props2.disableTheme;
      var currentActive = this.state.currentActive;


      return _.map(buttons, function (button) {
        if (!button) {
          return null;
        }

        var key = button.key,
            label = button.label,
            className = button.className;

        var active = key === currentActive;
        var styleNames = __WEBPACK_IMPORTED_MODULE_7_classnames___default()('button', {
          'disable-theme': disableTheme,
          active: active
        });

        return React.createElement(
          __WEBPACK_IMPORTED_MODULE_12__button__["a" /* default */],
          { styleName: styleNames,
            key: key,
            onClick: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_shared_utils_memoized_partial__["a" /* default */])(_this2.handleClick, key),
            className: className },
          label
        );
      });
    }
  }]);

  return ButtonsGroup;
}(React.Component), _class3.propTypes = {
  buttons: React.PropTypes.arrayOf(React.PropTypes.shape({
    label: React.PropTypes.any,
    key: React.PropTypes.string
  })),
  disableTheme: React.PropTypes.bool,
  defaultActive: React.PropTypes.string,
  onChange: React.PropTypes.func,
  isRounded: React.PropTypes.bool,
  className: React.PropTypes.string
}, _class3.defaultProps = {
  onChange: _.noop,
  disableTheme: false
}, _temp2), (_applyDecoratedDescriptor(_class2.prototype, 'handleClick', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handleClick'), _class2.prototype)), _class2)) || _class) || _class);


/***/ }),
/* 1581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SubscribeShownBIOverlay; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__base_overlay__ = __webpack_require__(1203);






var _class, _temp;



var SubscribeShownBIOverlay = (_temp = _class = function (_BaseOverlay) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(SubscribeShownBIOverlay, _BaseOverlay);

  function SubscribeShownBIOverlay() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SubscribeShownBIOverlay);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SubscribeShownBIOverlay.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(SubscribeShownBIOverlay)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(SubscribeShownBIOverlay, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // do not add BI param for not channel without video
      if (this.props.videoItem && this.subscribeButtonText) {
        this.props.biEvent('widget.subscription.displayed', { whereDisplayed: 'cover' });
      }
    }
  }]);

  return SubscribeShownBIOverlay;
}(__WEBPACK_IMPORTED_MODULE_5__base_overlay__["a" /* default */]), _class.displayName = 'SubscribeShownBIOverlay', _temp);


/***/ }),
/* 1582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OverlayMemberOnlyMobileNoTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return OverlayMemberOnlyMobile; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_selectors_app_settings__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_widget_components_player_overlay_base_member_only_overlay__ = __webpack_require__(1730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__member_only_styl__ = __webpack_require__(1892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__member_only_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__member_only_styl__);






var _dec, _class, _class2, _temp, _dec2, _dec3, _class3, _class4, _temp2;











var OverlayMemberOnlyMobileBase = function (_OverlayMemberOnlyBas) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(OverlayMemberOnlyMobileBase, _OverlayMemberOnlyBas);

  function OverlayMemberOnlyMobileBase() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, OverlayMemberOnlyMobileBase);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (OverlayMemberOnlyMobileBase.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(OverlayMemberOnlyMobileBase)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(OverlayMemberOnlyMobileBase, [{
    key: 'title',
    get: function get() {
      if (!this.props.canShowMainItemTitle) {
        return null;
      }

      var titleText = this.titleText;

      if (!titleText) {
        return null;
      }

      return React.createElement(
        'div',
        { styleName: 'title' },
        React.createElement(
          'span',
          { styleName: 'title-text' },
          titleText
        )
      );
    }
  }, {
    key: 'buttons',
    get: function get() {
      return React.createElement(
        'div',
        { styleName: 'buttons' },
        this.playButton
      );
    }
  }]);

  return OverlayMemberOnlyMobileBase;
}(__WEBPACK_IMPORTED_MODULE_8_widget_components_player_overlay_base_member_only_overlay__["a" /* default */]);

var OverlayMemberOnlyMobileNoTitle = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_shared_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_9__member_only_styl___default.a), _dec(_class = (_temp = _class2 = function (_OverlayMemberOnlyMob) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(OverlayMemberOnlyMobileNoTitle, _OverlayMemberOnlyMob);

  function OverlayMemberOnlyMobileNoTitle() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, OverlayMemberOnlyMobileNoTitle);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (OverlayMemberOnlyMobileNoTitle.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(OverlayMemberOnlyMobileNoTitle)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(OverlayMemberOnlyMobileNoTitle, [{
    key: 'buttonStyleName',
    get: function get() {
      return 'button simple-play-button';
    }
  }, {
    key: 'title',
    get: function get() {
      return null;
    }
  }, {
    key: 'publisher',
    get: function get() {
      return null;
    }
  }]);

  return OverlayMemberOnlyMobileNoTitle;
}(OverlayMemberOnlyMobileBase), _class2.displayName = 'OverlayMemberOnlyMobileNoTitle', _temp)) || _class);

var OverlayMemberOnlyMobile = (_dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["a" /* connect */])(function (state) {
  return {
    canShowMainItemTitle: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_shared_selectors_app_settings__["c" /* canShowMainItemTitle */])(state),
    canShowMainItemPublisher: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_shared_selectors_app_settings__["d" /* canShowMainItemPublisher */])(state)
  };
}), _dec3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_shared_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_9__member_only_styl___default.a), _dec2(_class3 = _dec3(_class3 = (_temp2 = _class4 = function (_OverlayMemberOnlyMob2) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(OverlayMemberOnlyMobile, _OverlayMemberOnlyMob2);

  function OverlayMemberOnlyMobile() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, OverlayMemberOnlyMobile);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (OverlayMemberOnlyMobile.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(OverlayMemberOnlyMobile)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(OverlayMemberOnlyMobile, [{
    key: 'buttonStyleName',
    get: function get() {
      return 'button simple-play-button';
    }
  }]);

  return OverlayMemberOnlyMobile;
}(OverlayMemberOnlyMobileBase), _class4.displayName = 'OverlayMemberOnlyMobile', _temp2)) || _class3) || _class3);


/***/ }),
/* 1583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DesktopPlayer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__player_wrapper__ = __webpack_require__(1548);







var _class, _temp;



var DesktopPlayer = (_temp = _class = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(DesktopPlayer, _React$Component);

  function DesktopPlayer() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, DesktopPlayer);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (DesktopPlayer.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(DesktopPlayer)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(DesktopPlayer, [{
    key: 'render',
    value: function render() {
      var props = _.omit(this.props, 'mobileMode');

      return React.createElement(__WEBPACK_IMPORTED_MODULE_6__player_wrapper__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        mobileMode: false }));
    }
  }]);

  return DesktopPlayer;
}(React.Component), _class.propTypes = _.omit(__WEBPACK_IMPORTED_MODULE_6__player_wrapper__["a" /* default */].propTypes, 'mobileMode'), _temp);


/***/ }),
/* 1584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tags; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_utils_layout_helpers__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_utils_wix_sdk__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_constants_device_types__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_widget_components_tags_cloud_tags_cloud__ = __webpack_require__(1836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__tags_styl__ = __webpack_require__(1898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__tags_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__tags_styl__);








var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}















var Tags = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_redux__["a" /* connect */])(function (state) {
  return {
    isVisible: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_shared_utils_layout_helpers__["c" /* isTagsVisible */])(state.appSettings)
  };
}), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_shared_utils_wix_connect__["c" /* VODBiEvents */])(), _dec3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_15__tags_styl___default.a), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Tags, _React$Component);

  function Tags() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Tags);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Tags.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Tags)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Tags, [{
    key: 'sendTagSelectedBI',
    value: function sendTagSelectedBI() {
      this.props.biEvent('widget.tags.selected');
    }
  }, {
    key: 'onTagClick',
    value: function onTagClick(tag) {
      this.sendTagSelectedBI();
      this.props.onTagClick(tag);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          tagClassName = _props.tagClassName,
          roundedTagClassName = _props.roundedTagClassName,
          isVisible = _props.isVisible,
          onTagFocus = _props.onTagFocus,
          onTagBlur = _props.onTagBlur;


      var tagClassNames = __WEBPACK_IMPORTED_MODULE_9_classnames___default()(__WEBPACK_IMPORTED_MODULE_15__tags_styl___default.a.tag, tagClassName, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_15__tags_styl___default.a.mobile, __WEBPACK_IMPORTED_MODULE_12_shared_utils_wix_sdk__["a" /* default */].Utils.getDeviceType() === __WEBPACK_IMPORTED_MODULE_13_shared_constants_device_types__["a" /* default */].MOBILE));

      if (!isVisible) {
        return null;
      }

      return React.createElement(__WEBPACK_IMPORTED_MODULE_14_widget_components_tags_cloud_tags_cloud__["a" /* default */], { className: className,
        tagClassName: tagClassNames,
        roundedTagClassName: roundedTagClassName,
        tags: this.tagList,
        onTagBlur: onTagBlur,
        onTagFocus: onTagFocus,
        onTagClick: this.onTagClick });
    }
  }, {
    key: 'tagList',
    get: function get() {
      return _.map(this.props.tags || [], 'value');
    }
  }]);

  return Tags;
}(React.Component), _class3.propTypes = {
  tags: React.PropTypes.array,
  className: React.PropTypes.string,
  tagClassName: React.PropTypes.string,
  roundedTagClassName: React.PropTypes.string,
  onTagFocus: React.PropTypes.func,
  onTagClick: React.PropTypes.func,
  onTagBlur: React.PropTypes.func,
  biEvent: React.PropTypes.func,
  isVisible: React.PropTypes.bool
}, _class3.defaultProps = {
  onTagClick: _.noop
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onTagClick', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'onTagClick'), _class2.prototype)), _class2)) || _class) || _class) || _class);


/***/ }),
/* 1585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_widget_player_widget_components_icon_icon__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__action_button_styl__ = __webpack_require__(1663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__action_button_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__action_button_styl__);







var _dec, _class, _desc, _value, _class2, _class3, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}










var ActionButton = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_10__action_button_styl___default.a), _dec(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ActionButton, _React$Component);

  function ActionButton() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ActionButton);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ActionButton.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(ActionButton)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ActionButton, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.attachNativeEvents();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unattachNativeEvents();
    }
  }, {
    key: 'handleClick',
    value: function handleClick(event) {
      event.stopPropagation();
      event.preventDefault();

      this.props.onClick();
    }
  }, {
    key: 'setActionNodeRef',
    value: function setActionNodeRef(node) {
      this.node = node;
    }
  }, {
    key: 'attachNativeEvents',
    value: function attachNativeEvents() {
      this.node.addEventListener('click', this.handleClick);
    }
  }, {
    key: 'unattachNativeEvents',
    value: function unattachNativeEvents() {
      this.node.removeEventListener('click', this.handleClick);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          rounded = _props.rounded,
          label = _props.label,
          icon = _props.icon,
          className = _props.className,
          isInFullScreen = _props.isInFullScreen;


      var styleNames = __WEBPACK_IMPORTED_MODULE_7_classnames___default()('action-button', icon, {
        rounded: rounded,
        'with-label': Boolean(label),
        'at-full-screen': isInFullScreen
      });

      return React.createElement(
        'a',
        { href: '',
          styleName: styleNames,
          className: className,
          onClick: this.handleClick,
          ref: this.setActionNodeRef },
        this.label,
        React.createElement(__WEBPACK_IMPORTED_MODULE_9_widget_player_widget_components_icon_icon__["a" /* default */], { styleName: 'icon',
          name: icon })
      );
    }
  }, {
    key: 'label',
    get: function get() {
      var label = this.props.label;

      if (!label) {
        return null;
      }

      return React.createElement(
        'span',
        { styleName: 'label' },
        label
      );
    }
  }]);

  return ActionButton;
}(React.Component), _class3.propTypes = {
  isInFullScreen: React.PropTypes.bool,
  rounded: React.PropTypes.bool,
  icon: React.PropTypes.string,
  label: React.PropTypes.any,
  onClick: React.PropTypes.func,
  children: React.PropTypes.element,
  className: React.PropTypes.string
}, _class3.defaultProps = {
  rounded: false,
  onClick: _.noop
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'handleClick', [__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handleClick'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setActionNodeRef', [__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'setActionNodeRef'), _class2.prototype)), _class2)) || _class);


/***/ }),
/* 1586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClosableOverlay; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_widget_player_widget_components_icon_icon__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__closable_overlay_styl__ = __webpack_require__(1664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__closable_overlay_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__closable_overlay_styl__);







var _dec, _class, _desc, _value, _class2, _class3, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}










//Don't use this overlay anywhere except player. It subscribe to native events instead of react's on purpose.
var ClosableOverlay = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_10__closable_overlay_styl___default.a), _dec(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ClosableOverlay, _React$Component);

  function ClosableOverlay() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ClosableOverlay);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ClosableOverlay.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(ClosableOverlay)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ClosableOverlay, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var closeOnBodyClick = this.props.closeOnBodyClick;


      if (closeOnBodyClick) {
        this.overlayNode.addEventListener('click', this.close);
      }

      this.overlayNode.addEventListener('click', this.stopPropagation);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var closeOnBodyClick = this.props.closeOnBodyClick;


      if (closeOnBodyClick) {
        this.overlayNode.removeEventListener('click', this.close);
      }

      this.overlayNode.removeEventListener('click', this.stopPropagation);
    }
  }, {
    key: 'stopPropagation',
    value: function stopPropagation(event) {
      event.stopPropagation();
      event.preventDefault();
    }
  }, {
    key: 'close',
    value: function close(event) {
      this.stopPropagation(event);
      var onClose = this.props.onClose;


      onClose();
    }
  }, {
    key: 'setOverlayNodeRef',
    value: function setOverlayNodeRef(node) {
      this.overlayNode = node;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          isFullWidth = _props.isFullWidth,
          isInFullScreen = _props.isInFullScreen,
          posterUrl = _props.posterUrl;


      var styleNames = __WEBPACK_IMPORTED_MODULE_6_classnames___default()('info-overlay', {
        'full-width': isFullWidth
      });

      var contentStyleNames = __WEBPACK_IMPORTED_MODULE_6_classnames___default()('content', {
        'full-screen': isInFullScreen,
        half: !isFullWidth && !posterUrl
      });

      return React.createElement(
        'div',
        { styleName: styleNames,
          ref: this.setOverlayNodeRef },
        this.closeButton,
        React.createElement(
          'div',
          { styleName: contentStyleNames },
          children
        )
      );
    }
  }, {
    key: 'closeButton',
    get: function get() {
      var isInFullScreen = this.props.isInFullScreen;


      var iconName = isInFullScreen ? 'thin-x' : 'exit';
      var styleName = __WEBPACK_IMPORTED_MODULE_6_classnames___default()('close', {
        'close-fullscreen': isInFullScreen
      });

      return React.createElement(__WEBPACK_IMPORTED_MODULE_9_widget_player_widget_components_icon_icon__["a" /* default */], { styleName: styleName,
        onClick: this.close,
        name: iconName });
    }
  }]);

  return ClosableOverlay;
}(React.Component), _class3.propTypes = {
  closeOnBodyClick: React.PropTypes.bool,
  noPoster: React.PropTypes.bool,
  posterUrl: React.PropTypes.string,
  isFullWidth: React.PropTypes.bool,
  isInFullScreen: React.PropTypes.bool,
  onClose: React.PropTypes.func,
  children: React.PropTypes.any
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'stopPropagation', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'stopPropagation'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'close', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'close'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setOverlayNodeRef', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'setOverlayNodeRef'), _class2.prototype)), _class2)) || _class);


/***/ }),
/* 1587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InfoOverlayInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_text_overflow_clamp__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_text_overflow_clamp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_text_overflow_clamp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_widget_player_widget_utils_resize_image__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_settings__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_widget_player_widget_components_scrollbar_wrapper_scrollbar_wrapper__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__info_styl__ = __webpack_require__(1665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__info_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__info_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__player_info_overlay_info_translations__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_shared_translations_crew__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_shared_translations_genres__ = __webpack_require__(558);








var _dec, _class, _desc, _value, _class2, _class3, _temp2;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}



















var POSTER_SIZE = {
  width: 303,
  height: 449
};

var POSTER_SIZE_FULLSCREEN = {
  width: 450,
  height: 667
};

var InfoOverlayInfo = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_15__info_styl___default.a), _dec(_class = (_class2 = (_temp2 = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(InfoOverlayInfo, _React$Component);

  function InfoOverlayInfo() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, InfoOverlayInfo);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = InfoOverlayInfo.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(InfoOverlayInfo)).call.apply(_ref, [this].concat(args))), _this), _this.title = null, _this.info = null, _this.posterEl = null, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(InfoOverlayInfo, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.clamp();

      window.addEventListener('resize', this.setPosterSize);
      this.setPosterSize();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.clamp();
      this.setPosterSize();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.setPosterSize);
    }
  }, {
    key: 'savePosterRef',
    value: function savePosterRef(node) {
      this.posterEl = node;
    }
  }, {
    key: 'saveTitleRef',
    value: function saveTitleRef(node) {
      this.title = node;
    }
  }, {
    key: 'clamp',
    value: function clamp() {
      __WEBPACK_IMPORTED_MODULE_9_text_overflow_clamp___default()(this.title, { lineClamp: 3 });
    }
  }, {
    key: 'getRoles',
    value: function getRoles(rolesType) {
      var roles = this.props[rolesType];


      if (!roles || !roles.length) {
        return null;
      }

      var roleElements = _.map(roles, function (_ref2, index) {
        var role = _ref2.role,
            name = _ref2.name;

        if (rolesType === 'crew') {
          role = React.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["a" /* FormattedMessage */], __WEBPACK_IMPORTED_MODULE_17_shared_translations_crew__["a" /* default */][role]);
        }

        return React.createElement(
          'div',
          { key: index,
            styleName: 'role-item',
            className: 'qa-overlay-info-' + rolesType },
          React.createElement(
            'div',
            { styleName: 'role' },
            role
          ),
          React.createElement(
            'div',
            { styleName: 'name' },
            name
          )
        );
      });

      return React.createElement(
        'div',
        { styleName: 'roles-wrapper' },
        React.createElement(
          'div',
          { styleName: 'roles-title' },
          React.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["a" /* FormattedMessage */], __WEBPACK_IMPORTED_MODULE_16__player_info_overlay_info_translations__["a" /* default */][rolesType])
        ),
        roleElements
      );
    }
  }, {
    key: 'setPosterSize',
    value: function setPosterSize() {
      var isInFullScreen = this.props.isInFullScreen;

      this.updatePosterStyle(isInFullScreen ? POSTER_SIZE_FULLSCREEN : POSTER_SIZE);
    }
  }, {
    key: 'updatePosterStyle',
    value: function updatePosterStyle(_ref3) {
      var width = _ref3.width,
          height = _ref3.height;

      var poster = this.posterEl;

      if (!poster) {
        return null;
      }

      poster.style.width = Math.floor(poster.offsetHeight / height * width) + 'px';
    }
  }, {
    key: 'getPosterImage',
    value: function getPosterImage(width, height, className) {
      var _props = this.props,
          posterUrl = _props.posterUrl,
          isInFullScreen = _props.isInFullScreen;
      var hosts = __WEBPACK_IMPORTED_MODULE_13_shared_settings__["a" /* default */].hosts;


      if (!posterUrl) {
        return null;
      }

      var resizedPosterUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_widget_player_widget_utils_resize_image__["a" /* default */])(posterUrl, width * 2, height * 2);

      return React.createElement('div', { ref: this.savePosterRef,
        styleName: __WEBPACK_IMPORTED_MODULE_8_classnames___default()('poster', className, { fullscreen: isInFullScreen }),
        className: 'qa-overlay-info-poster',
        style: { backgroundImage: 'url(' + hosts.image + resizedPosterUrl + ')' } });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          title = _props2.title,
          isInFullScreen = _props2.isInFullScreen;


      var styleNames = __WEBPACK_IMPORTED_MODULE_8_classnames___default()('wrapper', {
        'full-screen': isInFullScreen
      });

      return React.createElement(
        'div',
        { styleName: styleNames,
          className: 'qa-player-overlay-info' },
        this.poster,
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_14_widget_player_widget_components_scrollbar_wrapper_scrollbar_wrapper__["a" /* default */],
          { styleName: 'scrollbar-wrapper' },
          React.createElement(
            'div',
            { styleName: 'main-info' },
            React.createElement(
              'div',
              { ref: this.saveTitleRef,
                styleName: 'title',
                className: 'qa-overlay-info-title',
                title: title },
              title
            ),
            React.createElement(
              'div',
              { styleName: 'info' },
              this.publisher,
              this.genres,
              this.duration
            ),
            this.description,
            this.fullScreenPoster,
            this.getRoles('cast'),
            this.getRoles('crew'),
            this.compactPoster
          )
        )
      );
    }
  }, {
    key: 'compactPoster',
    get: function get() {
      var _props3 = this.props,
          posterUrl = _props3.posterUrl,
          title = _props3.title;


      if (!posterUrl) {
        return null;
      }

      var resizedPosterUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_widget_player_widget_utils_resize_image__["a" /* default */])(posterUrl, POSTER_SIZE.width * 2, POSTER_SIZE.height * 2);

      var hosts = __WEBPACK_IMPORTED_MODULE_13_shared_settings__["a" /* default */].hosts;


      return React.createElement('img', { styleName: 'poster poster-compact',
        className: 'qa-overlay-info-poster-compact',
        src: '' + hosts.image + resizedPosterUrl,
        alt: title });
    }
  }, {
    key: 'poster',
    get: function get() {
      var isInFullScreen = this.props.isInFullScreen;


      if (isInFullScreen) {
        return null;
      }

      return this.getPosterImage(POSTER_SIZE.width, POSTER_SIZE.height);
    }
  }, {
    key: 'fullScreenPoster',
    get: function get() {
      var isInFullScreen = this.props.isInFullScreen;


      if (!isInFullScreen) {
        return null;
      }

      return this.getPosterImage(POSTER_SIZE_FULLSCREEN.width, POSTER_SIZE_FULLSCREEN.height);
    }
  }, {
    key: 'publisher',
    get: function get() {
      var publisher = this.props.publisher;


      if (!publisher) {
        return null;
      }

      return React.createElement(
        'div',
        { styleName: 'info-item',
          className: 'qa-overlay-info-publisher' },
        React.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["a" /* FormattedMessage */], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_16__player_info_overlay_info_translations__["a" /* default */].publisher, {
          values: { author: publisher } }))
      );
    }
  }, {
    key: 'genres',
    get: function get() {
      var genre = this.props.genre;


      if (!genre) {
        return null;
      }

      return React.createElement(
        'div',
        { styleName: 'info-item',
          className: 'qa-overlay-info-genres' },
        React.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["a" /* FormattedMessage */], __WEBPACK_IMPORTED_MODULE_18_shared_translations_genres__["a" /* default */][genre])
      );
    }
  }, {
    key: 'duration',
    get: function get() {
      var durationStr = this.props.durationStr;


      if (!durationStr) {
        return null;
      }

      return React.createElement(
        'div',
        { styleName: 'info-item',
          className: 'qa-overlay-info-duration' },
        ' ' + durationStr
      );
    }
  }, {
    key: 'description',
    get: function get() {
      var description = this.props.description;


      if (!description) {
        return null;
      }

      return React.createElement(
        'div',
        { styleName: 'description',
          className: 'qa-overlay-info-description' },
        description
      );
    }
  }]);

  return InfoOverlayInfo;
}(React.Component), _class3.propTypes = {
  title: React.PropTypes.string,
  publisher: React.PropTypes.string,
  posterUrl: React.PropTypes.string,
  description: React.PropTypes.string,
  durationStr: React.PropTypes.string,
  genre: React.PropTypes.string,
  cast: React.PropTypes.array,
  crew: React.PropTypes.array,
  isInFullScreen: React.PropTypes.bool
}, _temp2), (_applyDecoratedDescriptor(_class2.prototype, 'savePosterRef', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'savePosterRef'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'saveTitleRef', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'saveTitleRef'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setPosterSize', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'setPosterSize'), _class2.prototype)), _class2)) || _class);


/***/ }),
/* 1588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PlayerAPIFacade; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_video_player_react__ = __webpack_require__(1221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_video_player_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_video_player_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_data_components_data_component__ = __webpack_require__(423);








var _desc, _value, _class;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}






var UI_EVENTS = __WEBPACK_IMPORTED_MODULE_8_video_player_react__["Player"].UI_EVENTS,
    VIDEO_EVENTS = __WEBPACK_IMPORTED_MODULE_8_video_player_react__["Player"].VIDEO_EVENTS;
var PlayerAPIFacade = (_class = function (_DataComponent) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(PlayerAPIFacade, _DataComponent);

  function PlayerAPIFacade(props) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, PlayerAPIFacade);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PlayerAPIFacade.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(PlayerAPIFacade)).call(this, props));

    _this.state = {
      isVideoEnded: false,
      isVideoPaused: true,
      isMouseOnPlayer: false,
      isPlayerInFullScreen: false
    };

    _this.bindEvents();
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(PlayerAPIFacade, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEvents();
    }
  }, {
    key: 'bindEvents',
    value: function bindEvents() {
      var eventEmitter = this.props.eventEmitter;


      eventEmitter.on(UI_EVENTS.CONTROL_BLOCK_SHOW_TRIGGERED, this.setShowControlsState);
      eventEmitter.on(UI_EVENTS.CONTROL_BLOCK_HIDE_TRIGGERED, this.setHideControlsState);

      eventEmitter.on(VIDEO_EVENTS.PLAYBACK_STATUS_CHANGED, this.setPlaybackStatusState);

      eventEmitter.on(UI_EVENTS.FULLSCREEN_STATUS_CHANGED, this.setFullScreenState);
    }
  }, {
    key: 'unbindEvents',
    value: function unbindEvents() {
      var eventEmitter = this.props.eventEmitter;


      eventEmitter.off(UI_EVENTS.CONTROL_BLOCK_SHOW_TRIGGERED, this.setShowControlsState);
      eventEmitter.off(UI_EVENTS.CONTROL_BLOCK_HIDE_TRIGGERED, this.setHideControlsState);

      eventEmitter.off(VIDEO_EVENTS.PLAYBACK_STATUS_CHANGED, this.setPlaybackStatusState);

      eventEmitter.off(UI_EVENTS.FULLSCREEN_STATUS_CHANGED, this.setFullScreenState);
    }
  }, {
    key: 'setPlaybackStatusState',
    value: function setPlaybackStatusState(playbackStatus) {
      var STATUSES = this.props.engine.STATUSES;

      this.setState({
        isVideoEnded: playbackStatus === STATUSES.ENDED,
        isVideoPaused: playbackStatus === STATUSES.PAUSED
      });
    }
  }, {
    key: 'setShowControlsState',
    value: function setShowControlsState() {
      this.setState({
        isControlsShown: true
      });
    }
  }, {
    key: 'setHideControlsState',
    value: function setHideControlsState() {
      this.setState({
        isControlsShown: false
      });
    }
  }, {
    key: 'setFullScreenState',
    value: function setFullScreenState(isInFullScreen) {
      this.setState({
        isPlayerInFullScreen: isInFullScreen
      });
    }
  }, {
    key: 'exitFullScreen',
    value: function exitFullScreen() {
      var eventEmitter = this.props.eventEmitter;


      eventEmitter.emit(UI_EVENTS.FULLSCREEN_EXIT_TRIGGERED);
    }
  }, {
    key: 'pauseVideo',
    value: function pauseVideo() {
      var engine = this.props.engine;


      engine.pause();
    }
  }, {
    key: 'childProps',
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.state, {
        pauseVideo: this.pauseVideo,
        exitFullScreen: this.exitFullScreen
      });
    }
  }]);

  return PlayerAPIFacade;
}(__WEBPACK_IMPORTED_MODULE_9_shared_data_components_data_component__["a" /* default */]), (_applyDecoratedDescriptor(_class.prototype, 'setPlaybackStatusState', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'setPlaybackStatusState'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setShowControlsState', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'setShowControlsState'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setHideControlsState', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'setHideControlsState'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setFullScreenState', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'setFullScreenState'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'exitFullScreen', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'exitFullScreen'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'pauseVideo', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'pauseVideo'), _class.prototype)), _class);


/***/ }),
/* 1589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getPurchaseStatusConfig;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__player_overlay_actions_translations__ = __webpack_require__(545);


function getPurchaseStatusConfig(_ref) {
  var dgsInfo = _ref.dgsInfo;

  var saleInfo = _.get(dgsInfo, 'sale');

  if (!saleInfo) {
    return null;
  }

  return {
    translationData: {
      props: __WEBPACK_IMPORTED_MODULE_0__player_overlay_actions_translations__["a" /* default */].saleInfo
    }
  };
}

/***/ }),
/* 1590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getRentStatusConfig;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__player_overlay_actions_translations__ = __webpack_require__(545);


function getRentStatusConfig(_ref) {
  var dgsInfo = _ref.dgsInfo;

  var rentInfo = _.get(dgsInfo, 'rent');

  if (!rentInfo || !rentInfo.expirationTs) {
    return null;
  }

  return {
    translationData: {
      expirationDate: rentInfo.expirationTs * 1000,
      props: __WEBPACK_IMPORTED_MODULE_0__player_overlay_actions_translations__["a" /* default */].rented
    }
  };
}

/***/ }),
/* 1591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InfoOverlayShare; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_utils_get_url_to_video__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_widget_constants_social_networks__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_widget_player_widget_components_social_share_social_share__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__share_styl__ = __webpack_require__(1667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__share_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__share_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__player_info_overlay_share_translations__ = __webpack_require__(630);






var _dec, _class, _class2, _temp;














var InfoOverlayShare = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_10__share_styl___default.a), _dec(_class = (_temp = _class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(InfoOverlayShare, _React$Component);

  function InfoOverlayShare() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, InfoOverlayShare);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (InfoOverlayShare.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(InfoOverlayShare)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(InfoOverlayShare, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          onShare = _props.onShare,
          areElementsRounded = _props.areElementsRounded,
          siteUrl = _props.siteUrl,
          compId = _props.compId,
          id = _props.id,
          title = _props.title,
          description = _props.description,
          coverUrl = _props.coverUrl;


      var networksClassNames = _.pick(__WEBPACK_IMPORTED_MODULE_10__share_styl___default.a, _.values(__WEBPACK_IMPORTED_MODULE_8_widget_constants_social_networks__["a" /* default */]));

      var contentToShare = {
        title: title,
        description: description,
        coverUrl: coverUrl,
        siteUrl: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_shared_utils_get_url_to_video__["a" /* default */])({ id: id }, { siteUrl: siteUrl, compId: compId })
      };

      return React.createElement(
        'div',
        { styleName: 'share-overlay',
          className: 'qa-player-overlay-share' },
        React.createElement(
          'div',
          { styleName: 'title' },
          React.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */], __WEBPACK_IMPORTED_MODULE_11__player_info_overlay_share_translations__["a" /* default */].share)
        ),
        React.createElement(__WEBPACK_IMPORTED_MODULE_9_widget_player_widget_components_social_share_social_share__["a" /* default */], { networks: _.values(__WEBPACK_IMPORTED_MODULE_8_widget_constants_social_networks__["a" /* default */]),
          areElementsRounded: areElementsRounded,
          content: contentToShare,
          onShare: onShare,
          styleName: 'social-icons',
          buttonClassName: __WEBPACK_IMPORTED_MODULE_10__share_styl___default.a['share-icon'],
          linkClassName: __WEBPACK_IMPORTED_MODULE_10__share_styl___default.a['share-link'],
          networksClassNames: networksClassNames })
      );
    }
  }]);

  return InfoOverlayShare;
}(React.Component), _class2.propTypes = {
  id: React.PropTypes.string,
  title: React.PropTypes.string,
  description: React.PropTypes.string,
  coverUrl: React.PropTypes.string,

  siteUrl: React.PropTypes.string,
  compId: React.PropTypes.string,

  areElementsRounded: React.PropTypes.bool,

  onShare: React.PropTypes.func
}, _temp)) || _class);


/***/ }),
/* 1592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Title; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__title_styl__ = __webpack_require__(1668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__title_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__title_styl__);






var _dec, _class, _class2, _temp;







var Title = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_7__title_styl___default.a), _dec(_class = (_temp = _class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Title, _React$Component);

  function Title() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Title);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Title.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Title)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Title, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isInFullScreen = _props.isInFullScreen,
          title = _props.title;


      var styleNames = __WEBPACK_IMPORTED_MODULE_5_classnames___default()('wrapper', {
        'at-full-screen': isInFullScreen
      });

      return React.createElement(
        'div',
        { styleName: styleNames },
        React.createElement(
          'span',
          { styleName: 'title',
            className: 'qa-overlay-title',
            'data-hook': 'playerTitle' },
          title
        )
      );
    }
  }]);

  return Title;
}(React.Component), _class2.propTypes = {
  title: React.PropTypes.string,
  isInFullScreen: React.PropTypes.bool
}, _temp)) || _class);


/***/ }),
/* 1593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UIWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_selectors_app_settings__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__selectors_rent_status__ = __webpack_require__(1590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__selectors_purchase_status__ = __webpack_require__(1589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_widget_views_desktop_compact_components_player_overlay_ui_selectors_video_overlay_paid_access_button_config__ = __webpack_require__(1293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__title_title__ = __webpack_require__(1592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__action_button_action_button__ = __webpack_require__(1585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__closable_overlay_closable_overlay__ = __webpack_require__(1586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__info_info__ = __webpack_require__(1587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__share_share__ = __webpack_require__(1591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_widget_views_desktop_compact_components_animate_animate__ = __webpack_require__(1292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ui_wrapper_styl__ = __webpack_require__(1669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ui_wrapper_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__ui_wrapper_styl__);








var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}






















var INFO_OVERLAY_CONTENT = {
  VIDEO_INFO: 'videoInfo',
  SHARE_VIDEO: 'shareVideo'
};

var UIWrapper = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_redux__["a" /* connect */])(function (state) {
  return {
    siteUrl: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_shared_selectors_app_settings__["f" /* getSiteUrl */])(state),
    compId: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_shared_selectors_app_settings__["g" /* getCompId */])(state),
    areElementsRounded: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_shared_selectors_app_settings__["b" /* areElementsRounded */])(state),
    canShowFullInfo: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_shared_selectors_app_settings__["h" /* canShowFullInfo */])(state),
    canShareVideo: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_shared_selectors_app_settings__["i" /* canShareVideo */])(state)
  };
}), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_22__ui_wrapper_styl___default.a), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(UIWrapper, _React$Component);

  function UIWrapper(props) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, UIWrapper);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (UIWrapper.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(UIWrapper)).call(this, props));

    _this._hideTimeout = null;

    _this.state = {
      isMainContentHidden: props.isControlsShown,
      overlayContent: null
    };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(UIWrapper, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.shouldMainContentBeHidden(nextProps);
      this.shouldCloseInfoOverlay(nextProps);
    }
  }, {
    key: 'shouldMainContentBeHidden',
    value: function shouldMainContentBeHidden(nextProps) {
      var isMainContentHidden = this.state.isMainContentHidden;
      var isControlsShown = nextProps.isControlsShown;


      if (isControlsShown) {
        if (isMainContentHidden) {
          this.show();
        }
      } else {
        this.hide();
      }
    }
  }, {
    key: 'shouldCloseInfoOverlay',
    value: function shouldCloseInfoOverlay(nextProps) {
      var id = nextProps.videoItem.id,
          isVideoEnded = nextProps.isVideoEnded;


      if (this.props.videoItem.id !== id || isVideoEnded) {
        this.resetOverlayContent();
      }
    }
  }, {
    key: 'show',
    value: function show() {
      this.setState({
        isMainContentHidden: false
      });
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.setState({
        isMainContentHidden: true
      });
    }
  }, {
    key: 'showVideoInfoOverlay',
    value: function showVideoInfoOverlay() {
      var onVideoInfoShow = this.props.onVideoInfoShow;


      this.setState({
        overlayContent: INFO_OVERLAY_CONTENT.VIDEO_INFO
      });

      onVideoInfoShow();
    }
  }, {
    key: 'showShareVideoOverlay',
    value: function showShareVideoOverlay() {
      var onShareVideoShow = this.props.onShareVideoShow;


      this.setState({
        overlayContent: INFO_OVERLAY_CONTENT.SHARE_VIDEO
      });

      onShareVideoShow();
    }
  }, {
    key: 'resetOverlayContent',
    value: function resetOverlayContent() {
      this.setState({
        overlayContent: null
      });
    }
  }, {
    key: 'proxySubscribeRequest',
    value: function proxySubscribeRequest() {
      var _props = this.props,
          onSubscribeRequest = _props.onSubscribeRequest,
          pauseVideo = _props.pauseVideo,
          exitFullScreen = _props.exitFullScreen;


      exitFullScreen();
      pauseVideo();
      onSubscribeRequest();
    }
  }, {
    key: 'proxyPurchaseRequest',
    value: function proxyPurchaseRequest() {
      var _props2 = this.props,
          onPurchaseRequest = _props2.onPurchaseRequest,
          pauseVideo = _props2.pauseVideo,
          exitFullScreen = _props2.exitFullScreen;


      exitFullScreen();
      pauseVideo();
      onPurchaseRequest();
    }
  }, {
    key: 'renderActionButton',
    value: function renderActionButton(icon, label, onClick, className) {
      var _props3 = this.props,
          areElementsRounded = _props3.areElementsRounded,
          isPlayerInFullScreen = _props3.isPlayerInFullScreen;


      return React.createElement(__WEBPACK_IMPORTED_MODULE_17__action_button_action_button__["a" /* default */], { styleName: 'action-button',
        className: className,
        icon: icon,
        label: label,
        onClick: onClick,
        isInFullScreen: isPlayerInFullScreen,
        rounded: areElementsRounded });
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'section',
        null,
        this.mainContent,
        this.overlay
      );
    }
  }, {
    key: 'rentStatus',
    get: function get() {
      var videoItem = this.props.videoItem;

      var rentStatusConfig = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__selectors_rent_status__["a" /* default */])(videoItem);

      if (!rentStatusConfig) {
        return null;
      }

      var _rentStatusConfig$tra = rentStatusConfig.translationData,
          expirationDate = _rentStatusConfig$tra.expirationDate,
          props = _rentStatusConfig$tra.props;


      var date = React.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["g" /* FormattedDate */], { value: expirationDate,
        month: 'short',
        day: 'numeric' });

      var label = React.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["a" /* FormattedMessage */], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, props, {
        values: { date: date } }));

      return this.renderActionButton('timer', label);
    }
  }, {
    key: 'purchaseStatus',
    get: function get() {
      var videoItem = this.props.videoItem;

      var purchaseStatusConfig = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__selectors_purchase_status__["a" /* default */])(videoItem);

      if (!purchaseStatusConfig) {
        return null;
      }

      var props = purchaseStatusConfig.translationData.props;


      var label = React.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["a" /* FormattedMessage */], props);

      return this.renderActionButton('film', label);
    }
  }, {
    key: 'paidAccessAction',
    get: function get() {
      var _props4 = this.props,
          videoItem = _props4.videoItem,
          channelData = _props4.channelData;

      var paidAccessButtonConfig = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_widget_views_desktop_compact_components_player_overlay_ui_selectors_video_overlay_paid_access_button_config__["a" /* default */])({
        videoItem: videoItem,
        channelData: channelData,
        onPurchaseRequest: this.proxyPurchaseRequest,
        onSubscriptionRequest: this.proxySubscribeRequest
      });

      if (!paidAccessButtonConfig) {
        return null;
      }

      var _paidAccessButtonConf = paidAccessButtonConfig.translationData,
          priceModel = _paidAccessButtonConf.priceModel,
          props = _paidAccessButtonConf.props,
          callback = paidAccessButtonConfig.callback;


      var price = React.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["f" /* FormattedNumber */], { value: priceModel.price,
        style: 'currency',
        currency: priceModel.currency });

      var label = React.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["a" /* FormattedMessage */], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, props, {
        values: { price: price } }));

      return this.renderActionButton('buy-rent', label, callback, 'qa-widget-overlay-buy-rent-button');
    }
  }, {
    key: 'videoAccessIndicator',
    get: function get() {
      return this.purchaseStatus || this.rentStatus || this.paidAccessAction;
    }
  }, {
    key: 'infoAction',
    get: function get() {
      var canShowFullInfo = this.props.canShowFullInfo;


      if (!canShowFullInfo) {
        return null;
      }

      return this.renderActionButton('info', null, this.showVideoInfoOverlay, 'qa-widget-overlay-info-button');
    }
  }, {
    key: 'shareAction',
    get: function get() {
      var canShareVideo = this.props.canShareVideo;


      if (!canShareVideo) {
        return null;
      }

      return this.renderActionButton('share', null, this.showShareVideoOverlay, 'qa-widget-overlay-share-button');
    }
  }, {
    key: 'mainContent',
    get: function get() {
      var _props5 = this.props,
          title = _props5.videoItem.title,
          isPlayerInFullScreen = _props5.isPlayerInFullScreen;
      var isMainContentHidden = this.state.isMainContentHidden;


      var styleNames = __WEBPACK_IMPORTED_MODULE_9_classnames___default()('main-content-inner', {
        'at-full-screen': isPlayerInFullScreen
      });

      return React.createElement(
        'section',
        { styleName: 'main-content-wrapper' },
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_21_widget_views_desktop_compact_components_animate_animate__["a" /* default */],
          { type: 'fade-in-out',
            styleName: 'main-content',
            when: !isMainContentHidden },
          React.createElement(
            'div',
            { styleName: styleNames },
            React.createElement(__WEBPACK_IMPORTED_MODULE_16__title_title__["a" /* default */], { title: title,
              isInFullScreen: isPlayerInFullScreen }),
            React.createElement(
              'div',
              { styleName: 'actions',
                className: 'qa-player-overlay-actions' },
              this.videoAccessIndicator,
              this.infoAction,
              this.shareAction
            )
          )
        )
      );
    }
  }, {
    key: 'overlay',
    get: function get() {
      var overlayContent = this.state.overlayContent;
      var _props6 = this.props,
          _props6$videoItem = _props6.videoItem,
          id = _props6$videoItem.id,
          posterUrl = _props6$videoItem.posterUrl,
          coverUrl = _props6$videoItem.coverUrl,
          title = _props6$videoItem.title,
          description = _props6$videoItem.description,
          publisher = _props6$videoItem.publisher,
          durationStr = _props6$videoItem.durationStr,
          genre = _props6$videoItem.genre,
          cast = _props6$videoItem.cast,
          crew = _props6$videoItem.crew,
          onShareRequest = _props6.onShareRequest,
          isPlayerInFullScreen = _props6.isPlayerInFullScreen,
          siteUrl = _props6.siteUrl,
          compId = _props6.compId,
          areElementsRounded = _props6.areElementsRounded;


      var styleNames = __WEBPACK_IMPORTED_MODULE_9_classnames___default()('info-overlay-wrapper', {
        active: overlayContent
      });

      return React.createElement(
        'section',
        { styleName: styleNames },
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_21_widget_views_desktop_compact_components_animate_animate__["a" /* default */],
          { type: 'fade-in-out',
            styleName: 'info-overlay',
            when: overlayContent === INFO_OVERLAY_CONTENT.VIDEO_INFO },
          React.createElement(
            __WEBPACK_IMPORTED_MODULE_18__closable_overlay_closable_overlay__["a" /* default */],
            { onClose: this.resetOverlayContent,
              isInFullScreen: isPlayerInFullScreen,
              posterUrl: posterUrl },
            React.createElement(__WEBPACK_IMPORTED_MODULE_19__info_info__["a" /* default */], { title: title,
              description: description,
              posterUrl: posterUrl,
              publisher: publisher,
              genre: genre,
              durationStr: durationStr,
              cast: cast,
              crew: crew,
              isInFullScreen: isPlayerInFullScreen })
          )
        ),
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_21_widget_views_desktop_compact_components_animate_animate__["a" /* default */],
          { type: 'fade-in-out',
            styleName: 'info-overlay',
            when: overlayContent === INFO_OVERLAY_CONTENT.SHARE_VIDEO },
          React.createElement(
            __WEBPACK_IMPORTED_MODULE_18__closable_overlay_closable_overlay__["a" /* default */],
            { onClose: this.resetOverlayContent,
              isInFullScreen: isPlayerInFullScreen,
              closeOnBodyClick: true,
              isFullWidth: true },
            React.createElement(__WEBPACK_IMPORTED_MODULE_20__share_share__["a" /* default */], { id: id,
              title: title,
              description: description,
              coverUrl: coverUrl,
              siteUrl: siteUrl,
              compId: compId,
              areElementsRounded: areElementsRounded,
              onShare: onShareRequest,
              isInFullScreen: isPlayerInFullScreen })
          )
        )
      );
    }
  }]);

  return UIWrapper;
}(React.Component), _class3.propTypes = {
  appSettings: React.PropTypes.object,
  channelData: React.PropTypes.object,
  videoItem: React.PropTypes.object,

  onSubscribeRequest: React.PropTypes.func,
  onPurchaseRequest: React.PropTypes.func,
  onShareRequest: React.PropTypes.func,
  onVideoInfoShow: React.PropTypes.func,
  onShareVideoShow: React.PropTypes.func,

  siteUrl: React.PropTypes.string,
  compId: React.PropTypes.string,
  areElementsRounded: React.PropTypes.bool,
  canShowFullInfo: React.PropTypes.bool,
  canShareVideo: React.PropTypes.bool,

  isVideoPaused: React.PropTypes.bool,
  isVideoEnded: React.PropTypes.bool,
  isControlsShown: React.PropTypes.bool,
  isPlayerInFullScreen: React.PropTypes.bool,
  exitFullScreen: React.PropTypes.func,
  pauseVideo: React.PropTypes.func
}, _class3.defaultProps = {
  onSubscribeRequest: _.noop,
  onPurchaseRequest: _.noop,
  onShareRequest: _.noop,
  onVideoInfoShow: _.noop,
  onShareVideoShow: _.noop
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'show', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'show'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'hide', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'hide'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'showVideoInfoOverlay', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'showVideoInfoOverlay'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'showShareVideoOverlay', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'showShareVideoOverlay'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'resetOverlayContent', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'resetOverlayContent'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'proxySubscribeRequest', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'proxySubscribeRequest'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'proxyPurchaseRequest', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'proxyPurchaseRequest'), _class2.prototype)), _class2)) || _class) || _class);


/***/ }),
/* 1594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExternalPlayer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_constants_video_sources__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__player_video_external_vimeo__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__player_video_external_youtube__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__player_video_external_facebook__ = __webpack_require__(631);









var _playersMap, _desc, _value, _class, _class2, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}









var fullScreenChangeEventsList = ['fullscreenchange', 'mozfullscreenchange', 'webkitfullscreenchange', 'msfullscreenchange'];

var playersMap = (_playersMap = {}, __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_playersMap, __WEBPACK_IMPORTED_MODULE_9_shared_constants_video_sources__["a" /* default */].YOUTUBE, __WEBPACK_IMPORTED_MODULE_11__player_video_external_youtube__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_playersMap, __WEBPACK_IMPORTED_MODULE_9_shared_constants_video_sources__["a" /* default */].VIMEO, __WEBPACK_IMPORTED_MODULE_10__player_video_external_vimeo__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_playersMap, __WEBPACK_IMPORTED_MODULE_9_shared_constants_video_sources__["a" /* default */].FACEBOOK, __WEBPACK_IMPORTED_MODULE_12__player_video_external_facebook__["a" /* default */]), _playersMap);

var ExternalPlayer = (_class = (_temp = _class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(ExternalPlayer, _React$Component);

  function ExternalPlayer() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ExternalPlayer);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ExternalPlayer.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(ExternalPlayer)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(ExternalPlayer, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.addFullscreenEventHandler();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeFullscreenEventHandler();
    }
  }, {
    key: 'handleFullscreenChange',
    value: function handleFullscreenChange() {
      this.props.onFullScreenChanged(this.isInFullScreen);
    }
  }, {
    key: 'addFullscreenEventHandler',
    value: function addFullscreenEventHandler() {
      var _this2 = this;

      _.forEach(fullScreenChangeEventsList, function (eventName) {
        return document.addEventListener(eventName, _this2.handleFullscreenChange);
      });
    }
  }, {
    key: 'removeFullscreenEventHandler',
    value: function removeFullscreenEventHandler() {
      var _this3 = this;

      _.forEach(fullScreenChangeEventsList, function (eventName) {
        return document.removeEventListener(eventName, _this3.handleFullscreenChange);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var videoItem = this.props.videoItem;


      if (!videoItem) {
        return null;
      }

      var id = videoItem.id,
          externalId = videoItem.externalId,
          mediaExternUrl = videoItem.mediaExternUrl,
          videoSource = videoItem.videoSource;


      var props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.props, {
        showControls: true,
        src: mediaExternUrl
      });

      var ExternalPlayer = playersMap[videoSource];

      if (!ExternalPlayer) {
        return null;
      }

      return React.createElement(ExternalPlayer, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, props, {
        key: id || externalId }));
    }
  }, {
    key: 'isInFullScreen',
    get: function get() {
      return Boolean(document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement);
    }
  }]);

  return ExternalPlayer;
}(React.Component), _class2.propTypes = {
  onFullScreenChanged: React.PropTypes.func,

  videoItem: React.PropTypes.object.isRequired,
  width: React.PropTypes.number,
  height: React.PropTypes.number,
  className: React.PropTypes.string
}, _class2.defaultProps = {
  onFullScreenChanged: _.noop
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'handleFullscreenChange', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'handleFullscreenChange'), _class.prototype)), _class);


/***/ }),
/* 1595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InternalPlayer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_selectors_vidi_urls__ = __webpack_require__(1577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_widget_constants_video_playback_status__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_widget_selectors_video_playback_status__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_components_spinner_loading_spinner__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_player_api_facade__ = __webpack_require__(1588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_ui_wrapper__ = __webpack_require__(1593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_widget_redux_client_actions_change_playback_status__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_video_player_react__ = __webpack_require__(1221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_video_player_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_video_player_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_progress_bar_styl__ = __webpack_require__(1666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_progress_bar_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_progress_bar_styl__);







var _dec, _class, _desc, _value, _class2, _class3, _temp2;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}




















__WEBPACK_IMPORTED_MODULE_15_video_player_react__["Player"].DefaultControls.ProgressControl.View.extendStyleNames(__WEBPACK_IMPORTED_MODULE_16__components_progress_bar_styl___default.a);

var InternalPlayer = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_redux__["a" /* connect */])(function (state, props) {
  return {
    isVideoPlayRequested: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_widget_selectors_video_playback_status__["c" /* isVideoPlayRequested */])(state),
    isVideoPauseRequested: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_widget_selectors_video_playback_status__["d" /* isVideoPauseRequested */])(state),
    vidiUrls: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_shared_selectors_vidi_urls__["a" /* default */])(props)
  };
}, {
  setPlaybackStatus: __WEBPACK_IMPORTED_MODULE_14_widget_redux_client_actions_change_playback_status__["b" /* setPlaybackStatus */]
}), _dec(_class = (_class2 = (_temp2 = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(InternalPlayer, _React$Component);

  function InternalPlayer() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, InternalPlayer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = InternalPlayer.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(InternalPlayer)).call.apply(_ref, [this].concat(args))), _this), _this._beenPlayed = false, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(InternalPlayer, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      this.checkIfNewUrls(newProps);
    }

    //Need to refactor in future

  }, {
    key: 'checkIfNewUrls',
    value: function checkIfNewUrls(newProps) {
      var vidiUrls = this.props.vidiUrls;
      var newVidiUrls = newProps.vidiUrls;


      if (!_.isEqual(vidiUrls, newVidiUrls)) {
        this._beenPlayed = false;
      }
    }
  }, {
    key: 'proxyFullScreenEnter',
    value: function proxyFullScreenEnter() {
      this.props.onFullScreenChanged(true);
    }
  }, {
    key: 'proxyFullScreenExit',
    value: function proxyFullScreenExit() {
      this.props.onFullScreenChanged(false);
    }
  }, {
    key: 'setPlayStatus',
    value: function setPlayStatus() {
      var _props = this.props,
          onPlayStart = _props.onPlayStart,
          onResume = _props.onResume,
          setPlaybackStatus = _props.setPlaybackStatus;


      if (this._beenPlayed) {
        onResume();
      } else {
        onPlayStart();
        this._beenPlayed = true;
      }

      setPlaybackStatus(__WEBPACK_IMPORTED_MODULE_9_widget_constants_video_playback_status__["a" /* default */].PLAYING);
    }
  }, {
    key: 'setPauseStatus',
    value: function setPauseStatus() {
      var setPlaybackStatus = this.props.setPlaybackStatus;


      setPlaybackStatus(__WEBPACK_IMPORTED_MODULE_9_widget_constants_video_playback_status__["a" /* default */].PAUSED);
    }
  }, {
    key: 'setEndStatus',
    value: function setEndStatus() {
      var _props2 = this.props,
          setPlaybackStatus = _props2.setPlaybackStatus,
          onEnded = _props2.onEnded;


      onEnded();
      setPlaybackStatus(__WEBPACK_IMPORTED_MODULE_9_widget_constants_video_playback_status__["a" /* default */].ENDED);
    }
  }, {
    key: 'render',
    value: function render() {
      var vidiUrls = this.props.vidiUrls;


      if (_.isEmpty(vidiUrls)) {
        return React.createElement(__WEBPACK_IMPORTED_MODULE_11_shared_components_spinner_loading_spinner__["a" /* default */], null);
      }

      return this.video;
    }
  }, {
    key: 'additionalUI',
    get: function get() {
      var _props3 = this.props,
          videoItem = _props3.videoItem,
          channelData = _props3.channelData,
          appSettings = _props3.appSettings,
          onActionClicked = _props3.onActionClicked,
          onPurchaseClick = _props3.onPurchaseClick,
          onSubscribeClick = _props3.onSubscribeClick,
          mobileMode = _props3.mobileMode;


      if (mobileMode) {
        return null;
      }

      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_12__components_player_api_facade__["a" /* default */],
        null,
        React.createElement(__WEBPACK_IMPORTED_MODULE_13__components_ui_wrapper__["a" /* default */], { appSettings: appSettings,
          videoItem: videoItem,
          channelData: channelData,
          mobileMode: mobileMode,
          onActionClicked: onActionClicked,
          onPurchaseRequest: onPurchaseClick,
          onSubscribeRequest: onSubscribeClick })
      );
    }
  }, {
    key: 'video',
    get: function get() {
      var _props4 = this.props,
          width = _props4.width,
          height = _props4.height,
          vidiUrls = _props4.vidiUrls,
          isVideoPlayRequested = _props4.isVideoPlayRequested,
          isVideoPauseRequested = _props4.isVideoPauseRequested,
          playAtFullScreen = _props4.playAtFullScreen,
          onError = _props4.onError;

      //TODO: Check preload as API of Wrapper

      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_15_video_player_react___default.a,
        { preload: 'metadata',
          width: width,
          height: height,
          shouldTriggerPlay: isVideoPlayRequested,
          shouldTriggerPause: isVideoPauseRequested,
          onError: onError,
          onPlay: this.setPlayStatus,
          onPause: this.setPauseStatus,
          onEnd: this.setEndStatus,
          onFullScreenEnter: this.proxyFullScreenEnter,
          onFullScreenExit: this.proxyFullScreenExit,
          isInFullScreen: playAtFullScreen,
          src: vidiUrls },
        this.additionalUI
      );
    }
  }]);

  return InternalPlayer;
}(React.Component), _class3.propTypes = {
  appSettings: React.PropTypes.object,
  channelData: React.PropTypes.object,
  videoItem: React.PropTypes.object,

  children: React.PropTypes.any,
  vidiUrls: React.PropTypes.array,
  className: React.PropTypes.string,
  mobileMode: React.PropTypes.bool,
  playAtFullScreen: React.PropTypes.bool,

  width: React.PropTypes.number,
  height: React.PropTypes.number,

  onPlayStart: React.PropTypes.func,
  onResume: React.PropTypes.func,
  onEnded: React.PropTypes.func,

  onError: React.PropTypes.func,
  onSubscribeClick: React.PropTypes.func,
  onPurchaseClick: React.PropTypes.func,
  onFullScreenClicked: React.PropTypes.func,
  onFullScreenChanged: React.PropTypes.func,
  onActionClicked: React.PropTypes.func,

  isVideoPlayRequested: React.PropTypes.bool,
  isVideoPauseRequested: React.PropTypes.bool,

  setPlaybackStatus: React.PropTypes.func
}, _class3.defaultProps = {
  onPlayStart: _.noop,
  onResume: _.noop,
  onEnded: _.noop,

  onError: _.noop,
  onFullScreenClicked: _.noop,
  onFullScreenChanged: _.noop,

  width: 640,
  height: 360
}, _temp2), (_applyDecoratedDescriptor(_class2.prototype, 'proxyFullScreenEnter', [__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'proxyFullScreenEnter'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'proxyFullScreenExit', [__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'proxyFullScreenExit'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setPlayStatus', [__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'setPlayStatus'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setPauseStatus', [__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'setPauseStatus'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setEndStatus', [__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'setEndStatus'), _class2.prototype)), _class2)) || _class);


/***/ }),
/* 1596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Player; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_default_settings__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_widget_selectors_video_playback_status__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__player_external__ = __webpack_require__(1594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__player_internal__ = __webpack_require__(1595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_components_resized_image_resized_image__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__player_styl__ = __webpack_require__(1670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__player_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__player_styl__);






var _dec, _dec2, _class, _class2, _temp;















var Player = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["a" /* connect */])(function (state) {
  return {
    isVideoPlayingOptimistic: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_widget_selectors_video_playback_status__["a" /* isVideoPlayingOptimistic */])(state),
    isVideoPausedOptimistic: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_widget_selectors_video_playback_status__["b" /* isVideoPausedOptimistic */])(state)
  };
}), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_12__player_styl___default.a), _dec(_class = _dec2(_class = (_temp = _class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Player, _React$Component);

  function Player() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Player);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Player.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Player)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Player, [{
    key: 'shouldShowInitialOverlay',
    value: function shouldShowInitialOverlay() {
      var _props = this.props,
          isVideoPlayingOptimistic = _props.isVideoPlayingOptimistic,
          isVideoPausedOptimistic = _props.isVideoPausedOptimistic;

      return !isVideoPlayingOptimistic && !isVideoPausedOptimistic;
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'section',
        { styleName: 'player',
          style: this.styles },
        this.overlay,
        React.createElement(
          'div',
          { styleName: 'player-wrapper' },
          this.player
        )
      );
    }
  }, {
    key: 'showChannelCover',
    get: function get() {
      var _props2 = this.props,
          appSettings = _props2.appSettings,
          canShowChannelCover = _props2.canShowChannelCover;

      return canShowChannelCover && appSettings.numbers.mainItemType === __WEBPACK_IMPORTED_MODULE_7_default_settings__["a" /* mainItemTypeValues */].CHANNEL_COVER;
    }
  }, {
    key: 'posterUrl',
    get: function get() {
      var _props3 = this.props,
          videoItem = _props3.videoItem,
          channelData = _props3.channelData;
      var customCoverUrl = videoItem.customCoverUrl;
      var coverUrl = videoItem.coverUrl;


      coverUrl = customCoverUrl || coverUrl;

      if (this.showChannelCover) {
        coverUrl = channelData.customCoverUrl || channelData.coverUrl || coverUrl;
      }

      return coverUrl;
    }
  }, {
    key: 'initialOverlay',
    get: function get() {
      var children = this.props.children;


      if (!children) {
        return null;
      }

      var channelData = this.props.channelData;

      var originProps = _.pick(this.props, 'showChannelCover', 'appSettings', 'videoItem');

      return React.cloneElement(children, _.assign({
        channelData: channelData,
        showChannelCover: this.showChannelCover
      }, originProps));
    }
  }, {
    key: 'poster',
    get: function get() {
      var mediaExternUrl = this.props.videoItem.mediaExternUrl;

      var isExternal = Boolean(mediaExternUrl);

      var _props4 = this.props,
          simple = _props4.simple,
          showPoster = _props4.showPoster,
          width = _props4.width,
          height = _props4.height;


      if (!showPoster) {
        return null;
      }

      if (simple && isExternal) {
        return null;
      }

      var posterUrl = this.posterUrl;

      if (!posterUrl) {
        return null;
      }

      return React.createElement(__WEBPACK_IMPORTED_MODULE_11_shared_components_resized_image_resized_image__["a" /* default */], { styleName: 'cover-image',
        src: posterUrl,
        width: width,
        height: height });
    }
  }, {
    key: 'overlay',
    get: function get() {
      if (!this.shouldShowInitialOverlay()) {
        return null;
      }

      return React.createElement(
        'div',
        { styleName: 'overlay',
          style: this.styles },
        this.initialOverlay,
        this.poster
      );
    }
  }, {
    key: 'styles',
    get: function get() {
      var _props5 = this.props,
          width = _props5.width,
          height = _props5.height;

      return {
        width: width,
        height: height
      };
    }
  }, {
    key: 'player',
    get: function get() {
      var mediaExternUrl = this.props.videoItem.mediaExternUrl;

      var isExternal = Boolean(mediaExternUrl);

      var PlayerComponent = isExternal ? __WEBPACK_IMPORTED_MODULE_9__player_external__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_10__player_internal__["a" /* default */];

      var props = _.omit(this.props, 'intl', 'styles');

      return React.createElement(PlayerComponent, props);
    }
  }]);

  return Player;
}(React.Component), _class2.propTypes = {
  appSettings: React.PropTypes.object,
  channelData: React.PropTypes.object,
  videoItem: React.PropTypes.object.isRequired,

  canShowChannelCover: React.PropTypes.bool,
  isVideoPlayingOptimistic: React.PropTypes.bool,
  isVideoPausedOptimistic: React.PropTypes.bool,
  showPoster: React.PropTypes.bool,
  simple: React.PropTypes.bool,

  children: React.PropTypes.any,

  width: React.PropTypes.number,
  height: React.PropTypes.number
}, _class2.defaultProps = {
  showPoster: true
}, _temp)) || _class) || _class);


/***/ }),
/* 1597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bi_handlers_selected_video__ = __webpack_require__(1598);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__bi_handlers_selected_video__["a" /* default */]));

/***/ }),
/* 1598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_bi_bi__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_selectors_app_settings__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_selectors_channels__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_selectors_videos__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_widget_ui_selectors_selected_video_id__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_utils_bi_video_overlay_events_params__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_widget_data_components_paginated_channel_videos__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_widget_redux_client_actions_select_video__ = __webpack_require__(206);












/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_8_widget_redux_client_actions_select_video__["c" /* SELECTED_VIDEO_ACTIONS */].SET, function (_ref) {
  var sendBiEvent = _ref.sendBiEvent,
      state = _ref.state,
      action = _ref.action,
      previousState = _ref.previousState;

  if (action.payload === previousState.selectedVideoId) {
    return;
  }

  __WEBPACK_IMPORTED_MODULE_1_shared_bi_bi__["a" /* default */].logWidgetSystem('video.select.requested');

  sendBiEvent('widget.VidSelected.displayed', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_shared_utils_bi_video_overlay_events_params__["c" /* getVideoSelectedEventParams */])({
    appSettings: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_selectors_app_settings__["a" /* getAllSettings */])(state),
    channelData: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_shared_selectors_channels__["a" /* getChannelForWidget */])(state),
    videoItem: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_selectors_videos__["a" /* getVideosGroupedByIds */])(state)[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_widget_ui_selectors_selected_video_id__["a" /* getMainVideoId */])(state, __WEBPACK_IMPORTED_MODULE_7_widget_data_components_paginated_channel_videos__["a" /* DATA_KEY */])]
  }));
}));

/***/ }),
/* 1599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_default_settings__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_settings__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_widget_redux_client_actions_app_settings__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_default_settings_default_settings_v1__ = __webpack_require__(1240);










var initialSettings = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
  booleans: {},
  colors: {},
  fonts: {},
  numbers: {},
  requestedWidgetSize: {
    width: window.innerWidth,
    height: window.innerHeight
  }
}, __WEBPACK_IMPORTED_MODULE_4_shared_settings__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_5_widget_redux_client_actions_app_settings__["c" /* APP_SETTINGS_UPDATE */], function (state, _ref) {
  var payload = _ref.payload;

  var currentSettings = _.merge({}, state, payload);
  var isNewInstallation = !_.get(currentSettings, 'fonts.channelId');
  var isCurrentSettingsV1 = _.get(currentSettings, 'numbers.settingsVersion') === 1;

  return _.merge({}, initialSettings, isNewInstallation || isCurrentSettingsV1 ? __WEBPACK_IMPORTED_MODULE_6_default_settings_default_settings_v1__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_3_default_settings__["c" /* default */], currentSettings);
}), null));

/***/ }),
/* 1600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_utils_wix_sdk__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_utils_attempt__ = __webpack_require__(163);




/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["handleActions"])({}, {
  compId: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_utils_attempt__["a" /* attempt */])(__WEBPACK_IMPORTED_MODULE_1_shared_utils_wix_sdk__["a" /* default */].Utils.getOrigCompId) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_utils_attempt__["a" /* attempt */])(__WEBPACK_IMPORTED_MODULE_1_shared_utils_wix_sdk__["a" /* default */].Utils.getCompId),
  channelID: function channelID(state) {
    return state.currentChannelId;
  }, // cb will be called on each event send with current global state
  iss: 1,
  application: 'Widget'
}));

/***/ }),
/* 1601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__payment_info__ = __webpack_require__(1603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__info__ = __webpack_require__(1602);





/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])({
  paymentInfo: __WEBPACK_IMPORTED_MODULE_1__payment_info__["a" /* default */],
  info: __WEBPACK_IMPORTED_MODULE_2__info__["a" /* default */]
}));

/***/ }),
/* 1602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_redux_server_actions_channel_get__ = __webpack_require__(251);





var PATH_TO_CHANNELS = 'response.data.entities.channels';
var defaultState = {};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["handleActions"])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_2_shared_redux_server_actions_channel_get__["b" /* NAMES */].SUCCESS, function (state, _ref) {
  var payload = _ref.payload;

  var channels = _.get(payload, PATH_TO_CHANNELS);
  var channelData = _.values(channels)[0];

  return channelData || state;
}), defaultState));

/***/ }),
/* 1603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_redux_server_actions_channel_payment_js__ = __webpack_require__(1200);





var PATH_TO_CHANNELS = 'response.data.entities.channels';
var defaultState = {};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["handleActions"])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_2_shared_redux_server_actions_channel_payment_js__["b" /* NAMES */].SUCCESS, function (state, _ref) {
  var payload = _ref.payload;

  var channels = _.get(payload, PATH_TO_CHANNELS);
  var channelPaymentData = _.values(channels)[0];

  return channelPaymentData || {};
}), defaultState));

/***/ }),
/* 1604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_widget_redux_client_actions_channel_videos_lazy_load__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_redux_server_actions_channel_videos_list__ = __webpack_require__(149);



var _handleActions;






var paginatedVideosDefaults = {
  videoIds: [],
  nextVideosCursor: null,
  category: null // TODO: combine category and nextVideoCursor in one property
};

function saveIds(state, _ref) {
  var payload = _ref.payload;

  var ids = _(state.videoIds).concat(payload.response.data.result).uniq().value();

  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state, {
    videoIds: ids,
    nextVideosCursor: payload.response.paging.cursor
  });
}

function resetVideos(state) {
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state, {
    videoIds: paginatedVideosDefaults.videoIds,
    nextVideosCursor: paginatedVideosDefaults.nextVideosCursor
  });
}

function setCategory(state, _ref2) {
  var payload = _ref2.payload;

  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state, {
    category: payload
  });
}

function resetCategory(state) {
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state, {
    category: paginatedVideosDefaults.category
  });
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])((_handleActions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_3_widget_redux_client_actions_channel_videos_lazy_load__["c" /* NAMES */].VIDEOS_RESET, resetVideos), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_3_widget_redux_client_actions_channel_videos_lazy_load__["c" /* NAMES */].CATEGORY_UPDATE, setCategory), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_3_widget_redux_client_actions_channel_videos_lazy_load__["c" /* NAMES */].CATEGORY_RESET, resetCategory), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_4_shared_redux_server_actions_channel_videos_list__["b" /* NAMES */].SUCCESS, saveIds), _handleActions), paginatedVideosDefaults));

/***/ }),
/* 1605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["handleActions"])({}, {}));

/***/ }),
/* 1606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_constants_demo_channel__ = __webpack_require__(1569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_widget_redux_client_actions_app_settings__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_redux_server_actions_channel_get__ = __webpack_require__(251);


var _handleActions;








var prevChannelIdFromSettings = void 0;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["handleActions"])((_handleActions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_3_widget_redux_client_actions_app_settings__["c" /* APP_SETTINGS_UPDATE */], function (state, _ref) {
  var payload = _ref.payload;

  if (!payload.fonts) {
    return state;
  }

  // For a case when user had channel and then removed it, so it falls back to demoId
  // When any setting in appSettings changes, it retries to fetch deleted channel, that
  // said goes into finite loop of GET/FAIL actions.
  var nextChannelId = _.get(payload, 'fonts.channelId');

  if (prevChannelIdFromSettings === nextChannelId) {
    return state || __WEBPACK_IMPORTED_MODULE_2_shared_constants_demo_channel__["a" /* default */].id;
  }

  prevChannelIdFromSettings = nextChannelId;

  return prevChannelIdFromSettings || state || __WEBPACK_IMPORTED_MODULE_2_shared_constants_demo_channel__["a" /* default */].id;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_4_shared_redux_server_actions_channel_get__["b" /* NAMES */].FAIL, function (state, _ref2) {
  var payload = _ref2.payload;

  if (_.get(payload, 'response.error.code') === -7710) {
    return __WEBPACK_IMPORTED_MODULE_2_shared_constants_demo_channel__["a" /* default */].id;
  }

  return state;
}), _handleActions), null));

/***/ }),
/* 1607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_widget_redux_server_actions_current_site_user_get__ = __webpack_require__(1211);





/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["handleActions"])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_2_widget_redux_server_actions_current_site_user_get__["b" /* NAMES */].SUCCESS, function (state, _ref) {
  var response = _ref.payload.response;

  if (!response) {
    return null;
  }

  if (response.authResponse) {
    response = response.data;
  }

  return response;
}), null));

/***/ }),
/* 1608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var defaultState = {
  channels: {},
  videos: {}
};

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var _ref = arguments[1];
  var payload = _ref.payload;

  var entities = _.get(payload, 'response.data.entities');

  if (entities) {
    state = _.mergeWith({}, state, entities, function (a, b) {
      if (_.isArray(a)) {
        return b;
      }
    });
  }

  return state;
});

/***/ }),
/* 1609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_redux_server_actions_channel_videos_list__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_widget_redux_client_actions_app_settings__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_redux_server_actions_channel_get__ = __webpack_require__(251);


var _handleActions;






var defaultState = null;
var oldChannelId = null;

function resetOnChannelIdChange(state, _ref) {
  var payload = _ref.payload;

  var channelId = _.get(payload, 'fonts.channelId');
  if (channelId && oldChannelId !== channelId) {
    oldChannelId = channelId;
    return defaultState;
  }
  return state;
}

function saveVideoId(state, _ref2) {
  var payload = _ref2.payload;

  if (state) {
    return state;
  }
  return _.get(payload, 'response.data.result[0]', null);
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["handleActions"])((_handleActions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_2_shared_redux_server_actions_channel_videos_list__["b" /* NAMES */].SUCCESS, saveVideoId), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_3_widget_redux_client_actions_app_settings__["c" /* APP_SETTINGS_UPDATE */], resetOnChannelIdChange), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_4_shared_redux_server_actions_channel_get__["b" /* NAMES */].START, function () {
  return defaultState;
}), _handleActions), defaultState));

/***/ }),
/* 1610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_widget_redux_client_actions_select_video__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_widget_redux_client_actions_change_playback_status__ = __webpack_require__(164);


var _handleActions;






function markAsTouched() {
  return true;
}

function markAsNotTouched() {
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["handleActions"])((_handleActions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_2_widget_redux_client_actions_select_video__["c" /* SELECTED_VIDEO_ACTIONS */].SET, markAsTouched), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_2_widget_redux_client_actions_select_video__["c" /* SELECTED_VIDEO_ACTIONS */].RESET, markAsNotTouched), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_3_widget_redux_client_actions_change_playback_status__["c" /* NAMES */].REQUEST_PLAY, markAsTouched), _handleActions), false));

/***/ }),
/* 1611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_widget_redux_client_actions_paginated_channel_videos__ = __webpack_require__(1209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_redux_server_actions_channel_videos_list__ = __webpack_require__(149);



var _handleActions;






// TODO: refactor

var options = {
  perUIPage: 4,
  currentUIPage: 0
};

/*
 TODO: deprecate this structure, instead use:
  {
    idChunks: [],
    currentUIPage: 0,
    loadedUIPagesCount: 0,
  }
 */
var paginatedVideos = {
  idChunks: [],
  ids: [],
  prevPageIds: [],
  nextPageIds: [],
  currentUIPage: 0,
  loadedUIPagesCount: 0
};

function update(state, _ref) {
  var _ref$payload = _ref.payload,
      payload = _ref$payload === undefined ? {} : _ref$payload;

  options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, options, payload);
  var _options = options,
      currentUIPage = _options.currentUIPage;


  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state, {
    currentUIPage: currentUIPage,
    ids: state.idChunks[currentUIPage] || [],
    prevPageIds: state.idChunks[currentUIPage - 1] || [],
    nextPageIds: state.idChunks[currentUIPage + 1] || [],
    loadedUIPagesCount: state.idChunks.length
  });
}

function saveIds(state, _ref2) {
  var payload = _ref2.payload;
  var _options2 = options,
      perUIPage = _options2.perUIPage;

  var ids = payload.response.data.result;

  var idChunks = _(state.idChunks).flatten().concat(ids).uniq().chunk(perUIPage).value();

  return update(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state, {
    idChunks: idChunks
  }), {});
}

function reset(state, _ref3) {
  var payload = _ref3.payload;
  var perUIPage = payload.perUIPage;


  return update(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state, {
    idChunks: []
  }), {
    payload: {
      currentUIPage: 0,
      perUIPage: perUIPage
    }
  });
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])((_handleActions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_3_widget_redux_client_actions_paginated_channel_videos__["a" /* NAMES */].UPDATE, update), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_4_shared_redux_server_actions_channel_videos_list__["b" /* NAMES */].SUCCESS, saveIds), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_3_widget_redux_client_actions_paginated_channel_videos__["a" /* NAMES */].RESET, reset), _handleActions), paginatedVideos));

/***/ }),
/* 1612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_constants_search_query_fields__ = __webpack_require__(1247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_widget_redux_client_actions_search__ = __webpack_require__(1290);



var _handleActions;






var DEFAULT_STATE = {
  searchQuery: '',
  searchQueryField: __WEBPACK_IMPORTED_MODULE_3_shared_constants_search_query_fields__["a" /* default */].QUERY
};

var updateSearch = function updateSearch(state, _ref) {
  var payload = _ref.payload;
  var searchQuery = payload.searchQuery,
      searchQueryField = payload.searchQueryField;

  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state, {
    searchQuery: searchQuery,
    searchQueryField: searchQueryField
  });
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])((_handleActions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_4_widget_redux_client_actions_search__["a" /* NAMES */].UPDATE_SEARCH, updateSearch), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_4_widget_redux_client_actions_search__["a" /* NAMES */].RESET_SEARCH, function () {
  return DEFAULT_STATE;
}), _handleActions), DEFAULT_STATE));

/***/ }),
/* 1613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_widget_redux_client_actions_select_video__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_widget_redux_client_actions_change_playback_status__ = __webpack_require__(164);


var _handleActions;






function resetSelectedVideoID() {
  return null;
}

function setSelectedVideoID(state, _ref) {
  var payload = _ref.payload;

  return payload || null;
}

function setVideoIdFromPlayAction(state, _ref2) {
  var payload = _ref2.payload;

  return payload || state;
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["handleActions"])((_handleActions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_2_widget_redux_client_actions_select_video__["c" /* SELECTED_VIDEO_ACTIONS */].SET, setSelectedVideoID), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_2_widget_redux_client_actions_select_video__["c" /* SELECTED_VIDEO_ACTIONS */].RESET, resetSelectedVideoID), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_3_widget_redux_client_actions_change_playback_status__["c" /* NAMES */].REQUEST_PLAY, setVideoIdFromPlayAction), _handleActions), null));

/***/ }),
/* 1614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_widget_redux_client_actions_change_playback_status__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_widget_redux_client_actions_select_video__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_widget_constants_video_playback_status__ = __webpack_require__(369);


var _handleActions;








var defaultState = __WEBPACK_IMPORTED_MODULE_4_widget_constants_video_playback_status__["a" /* default */].INITIAL;

var setPlayRequestedStatus = function setPlayRequestedStatus() {
  return __WEBPACK_IMPORTED_MODULE_4_widget_constants_video_playback_status__["a" /* default */].PLAY_REQUESTED;
};
var setPlayStatus = function setPlayStatus() {
  return __WEBPACK_IMPORTED_MODULE_4_widget_constants_video_playback_status__["a" /* default */].PLAYING;
};
var setPauseStatus = function setPauseStatus(state) {
  // fix toggling pause for player
  // if video is switched, we are reset playback status, but old player did this too
  // TODO: remove after using videoPlaybackStatus at player instead of props.paused
  if (state === __WEBPACK_IMPORTED_MODULE_4_widget_constants_video_playback_status__["a" /* default */].INITIAL) {
    return state;
  }
  return __WEBPACK_IMPORTED_MODULE_4_widget_constants_video_playback_status__["a" /* default */].PAUSED;
};
var setPauseRequestedStatus = function setPauseRequestedStatus() {
  return __WEBPACK_IMPORTED_MODULE_4_widget_constants_video_playback_status__["a" /* default */].PAUSE_REQUESTED;
};
var setEndedStatus = function setEndedStatus() {
  return __WEBPACK_IMPORTED_MODULE_4_widget_constants_video_playback_status__["a" /* default */].ENDED;
};
var resetStatus = function resetStatus() {
  return __WEBPACK_IMPORTED_MODULE_4_widget_constants_video_playback_status__["a" /* default */].INITIAL;
};

var setStatus = function setStatus(state, _ref) {
  var status = _ref.payload;
  return status;
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["handleActions"])((_handleActions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_2_widget_redux_client_actions_change_playback_status__["c" /* NAMES */].PLAY, setPlayStatus), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_2_widget_redux_client_actions_change_playback_status__["c" /* NAMES */].REQUEST_PLAY, setPlayRequestedStatus), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_2_widget_redux_client_actions_change_playback_status__["c" /* NAMES */].PAUSE, setPauseStatus), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_2_widget_redux_client_actions_change_playback_status__["c" /* NAMES */].REQUEST_PAUSE, setPauseRequestedStatus), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_2_widget_redux_client_actions_change_playback_status__["c" /* NAMES */].RESET, resetStatus), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_2_widget_redux_client_actions_change_playback_status__["c" /* NAMES */].END, setEndedStatus), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_2_widget_redux_client_actions_change_playback_status__["c" /* NAMES */].SET, setStatus), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_3_widget_redux_client_actions_select_video__["c" /* SELECTED_VIDEO_ACTIONS */].SET, resetStatus), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_3_widget_redux_client_actions_select_video__["c" /* SELECTED_VIDEO_ACTIONS */].RESET, resetStatus), _handleActions), defaultState));

/***/ }),
/* 1615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_widget_redux_client_actions_video_urls_fetch__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_widget_redux_client_actions_video_urls_clear__ = __webpack_require__(1210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_widget_constants_ulrs_cache_status__ = __webpack_require__(1205);



var _handleActions;








var defaultState = {};

function setPending(state, _ref) {
  var payload = _ref.payload;
  var id = payload.params.videoItem.id;


  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, id, {
    status: __WEBPACK_IMPORTED_MODULE_5_widget_constants_ulrs_cache_status__["a" /* default */].PENDING
  }));
}

function removeOnFail(state, _ref2) {
  var payload = _ref2.payload;
  var id = payload.params.videoItem.id;


  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, id, {
    status: __WEBPACK_IMPORTED_MODULE_5_widget_constants_ulrs_cache_status__["a" /* default */].FAILED
  }));
}

function saveToCache(state, _ref3) {
  var payload = _ref3.payload;

  var urls = payload.response;
  var id = payload.params.videoItem.id;

  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, id, {
    status: __WEBPACK_IMPORTED_MODULE_5_widget_constants_ulrs_cache_status__["a" /* default */].RESOLVED,
    urls: urls
  }));
}

function clearCacheForItem(state, _ref4) {
  var payload = _ref4.payload;

  var id = payload;

  return _.omit(state, id);
}

function clearCache() {
  return {};
}

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["handleActions"])((_handleActions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_3_widget_redux_client_actions_video_urls_fetch__["b" /* NAMES */].START, setPending), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_3_widget_redux_client_actions_video_urls_fetch__["b" /* NAMES */].SUCCESS, saveToCache), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_3_widget_redux_client_actions_video_urls_fetch__["b" /* NAMES */].FAIL, removeOnFail), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_4_widget_redux_client_actions_video_urls_clear__["c" /* NAMES */].ALL, clearCache), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_handleActions, __WEBPACK_IMPORTED_MODULE_4_widget_redux_client_actions_video_urls_clear__["c" /* NAMES */].FOR_ITEM, clearCacheForItem), _handleActions), defaultState));

/***/ }),
/* 1616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = configureStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_thunk__ = __webpack_require__(1162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_thunk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_thunk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__root_reducer__ = __webpack_require__(1618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__performance_middleware__ = __webpack_require__(1617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_bi_bi_middleware__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_widget_redux_bi_middleware_bi_handlers__ = __webpack_require__(1597);








function configureStore() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  // Compose final middleware and use devtools extension in debug environment
  var middlewares = [__WEBPACK_IMPORTED_MODULE_1_redux_thunk___default.a, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_bi_bi_middleware__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5_widget_redux_bi_middleware_bi_handlers__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_3__performance_middleware__["a" /* default */]];

  if (false) {
    var reduxLogger = require('redux-logger').createLogger({
      collapsed: true,
      diff: true
    });
    middlewares.push(reduxLogger);
  }

  var middleware = __WEBPACK_IMPORTED_MODULE_0_redux__["applyMiddleware"].apply(undefined, middlewares);

  if (false) {
    if (window.devToolsExtension) {
      var devTools = window.devToolsExtension();
      middleware = compose(middleware, devTools);
    }
  }

  // Create final store and subscribe router in debug env ie. for devtools
  var store = middleware(__WEBPACK_IMPORTED_MODULE_0_redux__["createStore"])(__WEBPACK_IMPORTED_MODULE_2__root_reducer__["a" /* default */], initialState);

  if (false) {
    module.hot.accept('./root-reducer', function () {
      var nextRootReducer = require('./root-reducer').default;
      store.replaceReducer(nextRootReducer);
    });
  }
  return store;
}

/***/ }),
/* 1617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_utils_wix_sdk__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_utils_performance__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_utils_performance_types__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_constants_application_names__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_selectors_configuration__ = __webpack_require__(1574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_redux_server_actions_channel_get__ = __webpack_require__(251);








var middleware = function middleware(store) {
  return function (next) {
    return function (action) {
      var result = next(action); // eslint-disable-line callback-return

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_shared_selectors_configuration__["a" /* getApplicationName */])(store.getState()) !== __WEBPACK_IMPORTED_MODULE_3_shared_constants_application_names__["a" /* default */].WIDGET) {
        return result;
      }

      switch (action.type) {
        case __WEBPACK_IMPORTED_MODULE_5_shared_redux_server_actions_channel_get__["b" /* NAMES */].START:
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_utils_performance__["a" /* addSingleMeasurement */])(__WEBPACK_IMPORTED_MODULE_2_shared_utils_performance_types__["a" /* default */].appFirstPreview);
          __WEBPACK_IMPORTED_MODULE_0_shared_utils_wix_sdk__["a" /* default */].Performance.applicationLoadingStep(0, 'loading preview');
          break;
        case __WEBPACK_IMPORTED_MODULE_5_shared_redux_server_actions_channel_get__["b" /* NAMES */].SUCCESS:
          __WEBPACK_IMPORTED_MODULE_0_shared_utils_wix_sdk__["a" /* default */].Performance.applicationLoadingStep(1, 'loading content');
          break;
        default:
          break;
      }

      return result;
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (middleware);

/***/ }),
/* 1618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_multireducer__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_multireducer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_multireducer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_widget_redux_client_reducers_entities__ = __webpack_require__(1608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_redux_client_reducers_channels__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_redux_client_reducers_videos__ = __webpack_require__(1253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_redux_client_reducers_channel_videos__ = __webpack_require__(1250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_widget_redux_client_reducers_configuration__ = __webpack_require__(1605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_widget_redux_client_reducers_app_settings__ = __webpack_require__(1599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_widget_redux_client_reducers_paginated_channel_videos__ = __webpack_require__(1611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_widget_redux_client_reducers_current_channel_id__ = __webpack_require__(1606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_widget_redux_client_reducers_search__ = __webpack_require__(1612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_widget_redux_client_reducers_channel_info__ = __webpack_require__(1601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_widget_redux_client_reducers_channel_videos_lazy_load__ = __webpack_require__(1604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_widget_redux_client_reducers_current_site_user__ = __webpack_require__(1607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_widget_redux_client_reducers_first_channel_video_id__ = __webpack_require__(1609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_widget_redux_client_reducers_bi_default_params__ = __webpack_require__(1600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_widget_redux_client_reducers_video_urls_cache__ = __webpack_require__(1615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_shared_redux_client_reducers_experiments__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_widget_data_components_next_channel_videos__ = __webpack_require__(1262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_widget_data_components_paginated_channel_videos__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_widget_redux_client_reducers_selected_video_id__ = __webpack_require__(1613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_widget_redux_client_reducers_video_playback_status__ = __webpack_require__(1614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_widget_redux_client_reducers_is_videos_touched__ = __webpack_require__(1610);


var _multireducer;




























/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_redux__["combineReducers"])({
  routing: __WEBPACK_IMPORTED_MODULE_3_react_router_redux__["routerReducer"],
  search: __WEBPACK_IMPORTED_MODULE_12_widget_redux_client_reducers_search__["a" /* default */],

  entities: __WEBPACK_IMPORTED_MODULE_4_widget_redux_client_reducers_entities__["a" /* default */],
  channels: __WEBPACK_IMPORTED_MODULE_5_shared_redux_client_reducers_channels__["a" /* default */],
  videos: __WEBPACK_IMPORTED_MODULE_6_shared_redux_client_reducers_videos__["a" /* default */],
  channelVideos: __WEBPACK_IMPORTED_MODULE_7_shared_redux_client_reducers_channel_videos__["a" /* default */],
  currentChannelId: __WEBPACK_IMPORTED_MODULE_11_widget_redux_client_reducers_current_channel_id__["a" /* default */],
  channelInfo: __WEBPACK_IMPORTED_MODULE_13_widget_redux_client_reducers_channel_info__["a" /* default */],
  currentSiteUser: __WEBPACK_IMPORTED_MODULE_15_widget_redux_client_reducers_current_site_user__["a" /* default */],
  firstChannelVideoId: __WEBPACK_IMPORTED_MODULE_16_widget_redux_client_reducers_first_channel_video_id__["a" /* default */],
  lazyVideoLists: __WEBPACK_IMPORTED_MODULE_2_multireducer___default()((_multireducer = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_multireducer, __WEBPACK_IMPORTED_MODULE_21_widget_data_components_paginated_channel_videos__["a" /* DATA_KEY */], __WEBPACK_IMPORTED_MODULE_10_widget_redux_client_reducers_paginated_channel_videos__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_multireducer, 'mobileSearch', __WEBPACK_IMPORTED_MODULE_14_widget_redux_client_reducers_channel_videos_lazy_load__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_multireducer, 'mobileWidget', __WEBPACK_IMPORTED_MODULE_14_widget_redux_client_reducers_channel_videos_lazy_load__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_multireducer, 'mobileOverlay', __WEBPACK_IMPORTED_MODULE_14_widget_redux_client_reducers_channel_videos_lazy_load__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_multireducer, __WEBPACK_IMPORTED_MODULE_20_widget_data_components_next_channel_videos__["b" /* DATA_KEY */], __WEBPACK_IMPORTED_MODULE_14_widget_redux_client_reducers_channel_videos_lazy_load__["a" /* default */]), _multireducer)),
  videoUrlsCache: __WEBPACK_IMPORTED_MODULE_18_widget_redux_client_reducers_video_urls_cache__["a" /* default */],
  selectedVideoId: __WEBPACK_IMPORTED_MODULE_22_widget_redux_client_reducers_selected_video_id__["a" /* default */],
  videoPlaybackStatus: __WEBPACK_IMPORTED_MODULE_23_widget_redux_client_reducers_video_playback_status__["a" /* default */],
  isVideosTouched: __WEBPACK_IMPORTED_MODULE_24_widget_redux_client_reducers_is_videos_touched__["a" /* default */],

  configuration: __WEBPACK_IMPORTED_MODULE_8_widget_redux_client_reducers_configuration__["a" /* default */],
  appSettings: __WEBPACK_IMPORTED_MODULE_9_widget_redux_client_reducers_app_settings__["a" /* default */],
  experiments: __WEBPACK_IMPORTED_MODULE_19_shared_redux_client_reducers_experiments__["a" /* default */],
  biDefaultParams: __WEBPACK_IMPORTED_MODULE_17_widget_redux_client_reducers_bi_default_params__["a" /* default */]
}));

/***/ }),
/* 1619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* defineMessages */])({
  noSearchResults: {
    id: 'widget.home-view.no-search-results',
    defaultMessage: 'No search results'
  },
  thisChannelIsComingSoon: {
    id: 'widget.this-channel-is-coming-soon',
    defaultMessage: 'This channel is coming soon!'
  }
}));

/***/ }),
/* 1620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getCallbackFromProps;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_widget_ui_selectors_video_access__ = __webpack_require__(94);


function getCallbackFromProps(props, fullAccessAction) {
  if (fullAccessAction === __WEBPACK_IMPORTED_MODULE_0_widget_ui_selectors_video_access__["c" /* FULL_ACCESS_ACTION_NAMES */].SUBSCRIBE) {
    return props.onSubscriptionRequest;
  } else if (fullAccessAction) {
    return props.onPurchaseRequest;
  }

  return _.noop;
}

/***/ }),
/* 1621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTranslationData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_widget_ui_selectors_video_access__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_widget_components_overlay_texts_purchase_button_text__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_utils_deal_info_helpers__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_translations_overlay_common_translations__ = __webpack_require__(134);








function getTranslationData(fullAccessAction, channel, video) {
  switch (fullAccessAction) {
    case __WEBPACK_IMPORTED_MODULE_0_widget_ui_selectors_video_access__["c" /* FULL_ACCESS_ACTION_NAMES */].BUY:
      return {
        props: __WEBPACK_IMPORTED_MODULE_1_widget_components_overlay_texts_purchase_button_text__["b" /* DEFAULT_TRANSLATIONS */][fullAccessAction],
        priceModel: __WEBPACK_IMPORTED_MODULE_2_shared_utils_deal_info_helpers__["b" /* getSalePriceInfo */](video.dealInfo)
      };
    case __WEBPACK_IMPORTED_MODULE_0_widget_ui_selectors_video_access__["c" /* FULL_ACCESS_ACTION_NAMES */].RENT:
      return {
        props: __WEBPACK_IMPORTED_MODULE_1_widget_components_overlay_texts_purchase_button_text__["b" /* DEFAULT_TRANSLATIONS */][fullAccessAction],
        priceModel: __WEBPACK_IMPORTED_MODULE_2_shared_utils_deal_info_helpers__["c" /* getRentPriceInfo */](video.dealInfo)
      };
    case __WEBPACK_IMPORTED_MODULE_0_widget_ui_selectors_video_access__["c" /* FULL_ACCESS_ACTION_NAMES */].BUY_OR_RENT:
      return {
        props: __WEBPACK_IMPORTED_MODULE_1_widget_components_overlay_texts_purchase_button_text__["b" /* DEFAULT_TRANSLATIONS */][fullAccessAction],
        priceModel: __WEBPACK_IMPORTED_MODULE_2_shared_utils_deal_info_helpers__["d" /* getMinPriceInfo */](video.dealInfo)
      };
    case __WEBPACK_IMPORTED_MODULE_0_widget_ui_selectors_video_access__["c" /* FULL_ACCESS_ACTION_NAMES */].SUBSCRIBE:
      return {
        props: __WEBPACK_IMPORTED_MODULE_3_shared_translations_overlay_common_translations__["a" /* default */].getSubscription,
        priceModel: __WEBPACK_IMPORTED_MODULE_2_shared_utils_deal_info_helpers__["a" /* getSubscriptionPriceInfo */](channel.dealInfo)
      };
    default:
      return null;
  }
}

/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
    ResizeSensor: __webpack_require__(1213),
    ElementQueries: __webpack_require__(1623)
};


/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Copyright Marc J. Schmidt. See the LICENSE file at the top-level
 * directory of this distribution and at
 * https://github.com/marcj/css-element-queries/blob/master/LICENSE.
 */
;
(function (root, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1213)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports === "object") {
        module.exports = factory(require('./ResizeSensor.js'));
    } else {
        root.ElementQueries = factory(root.ResizeSensor);
    }
}(this, function (ResizeSensor) {

    /**
     *
     * @type {Function}
     * @constructor
     */
    var ElementQueries = function() {

        var trackingActive = false;
        var elements = [];

        /**
         *
         * @param element
         * @returns {Number}
         */
        function getEmSize(element) {
            if (!element) {
                element = document.documentElement;
            }
            var fontSize = window.getComputedStyle(element, null).fontSize;
            return parseFloat(fontSize) || 16;
        }

        /**
         *
         * @copyright https://github.com/Mr0grog/element-query/blob/master/LICENSE
         *
         * @param {HTMLElement} element
         * @param {*} value
         * @returns {*}
         */
        function convertToPx(element, value) {
            var numbers = value.split(/\d/);
            var units = numbers[numbers.length-1];
            value = parseFloat(value);
            switch (units) {
                case "px":
                    return value;
                case "em":
                    return value * getEmSize(element);
                case "rem":
                    return value * getEmSize();
                // Viewport units!
                // According to http://quirksmode.org/mobile/tableViewport.html
                // documentElement.clientWidth/Height gets us the most reliable info
                case "vw":
                    return value * document.documentElement.clientWidth / 100;
                case "vh":
                    return value * document.documentElement.clientHeight / 100;
                case "vmin":
                case "vmax":
                    var vw = document.documentElement.clientWidth / 100;
                    var vh = document.documentElement.clientHeight / 100;
                    var chooser = Math[units === "vmin" ? "min" : "max"];
                    return value * chooser(vw, vh);
                default:
                    return value;
                // for now, not supporting physical units (since they are just a set number of px)
                // or ex/ch (getting accurate measurements is hard)
            }
        }

        /**
         *
         * @param {HTMLElement} element
         * @constructor
         */
        function SetupInformation(element) {
            this.element = element;
            this.options = {};
            var key, option, width = 0, height = 0, value, actualValue, attrValues, attrValue, attrName;

            /**
             * @param {Object} option {mode: 'min|max', property: 'width|height', value: '123px'}
             */
            this.addOption = function(option) {
                var idx = [option.mode, option.property, option.value].join(',');
                this.options[idx] = option;
            };

            var attributes = ['min-width', 'min-height', 'max-width', 'max-height'];

            /**
             * Extracts the computed width/height and sets to min/max- attribute.
             */
            this.call = function() {
                // extract current dimensions
                width = this.element.offsetWidth;
                height = this.element.offsetHeight;

                attrValues = {};

                for (key in this.options) {
                    if (!this.options.hasOwnProperty(key)){
                        continue;
                    }
                    option = this.options[key];

                    value = convertToPx(this.element, option.value);

                    actualValue = option.property == 'width' ? width : height;
                    attrName = option.mode + '-' + option.property;
                    attrValue = '';

                    if (option.mode == 'min' && actualValue >= value) {
                        attrValue += option.value;
                    }

                    if (option.mode == 'max' && actualValue <= value) {
                        attrValue += option.value;
                    }

                    if (!attrValues[attrName]) attrValues[attrName] = '';
                    if (attrValue && -1 === (' '+attrValues[attrName]+' ').indexOf(' ' + attrValue + ' ')) {
                        attrValues[attrName] += ' ' + attrValue;
                    }
                }

                for (var k in attributes) {
                    if(!attributes.hasOwnProperty(k)) continue;

                    if (attrValues[attributes[k]]) {
                        this.element.setAttribute(attributes[k], attrValues[attributes[k]].substr(1));
                    } else {
                        this.element.removeAttribute(attributes[k]);
                    }
                }
            };
        }

        /**
         * @param {HTMLElement} element
         * @param {Object}      options
         */
        function setupElement(element, options) {
            if (element.elementQueriesSetupInformation) {
                element.elementQueriesSetupInformation.addOption(options);
            } else {
                element.elementQueriesSetupInformation = new SetupInformation(element);
                element.elementQueriesSetupInformation.addOption(options);
                element.elementQueriesSensor = new ResizeSensor(element, function() {
                    element.elementQueriesSetupInformation.call();
                });
            }
            element.elementQueriesSetupInformation.call();

            if (trackingActive && elements.indexOf(element) < 0) {
                elements.push(element);
            }
        }

        /**
         * @param {String} selector
         * @param {String} mode min|max
         * @param {String} property width|height
         * @param {String} value
         */
        var allQueries = {};
        function queueQuery(selector, mode, property, value) {
            if (typeof(allQueries[mode]) == 'undefined') allQueries[mode] = {};
            if (typeof(allQueries[mode][property]) == 'undefined') allQueries[mode][property] = {};
            if (typeof(allQueries[mode][property][value]) == 'undefined') allQueries[mode][property][value] = selector;
            else allQueries[mode][property][value] += ','+selector;
        }

        function getQuery() {
            var query;
            if (document.querySelectorAll) query = document.querySelectorAll.bind(document);
            if (!query && 'undefined' !== typeof $$) query = $$;
            if (!query && 'undefined' !== typeof jQuery) query = jQuery;

            if (!query) {
                throw 'No document.querySelectorAll, jQuery or Mootools\'s $$ found.';
            }

            return query;
        }

        /**
         * Start the magic. Go through all collected rules (readRules()) and attach the resize-listener.
         */
        function findElementQueriesElements() {
            var query = getQuery();

            for (var mode in allQueries) if (allQueries.hasOwnProperty(mode)) {

                for (var property in allQueries[mode]) if (allQueries[mode].hasOwnProperty(property)) {
                    for (var value in allQueries[mode][property]) if (allQueries[mode][property].hasOwnProperty(value)) {
                        var elements = query(allQueries[mode][property][value]);
                        for (var i = 0, j = elements.length; i < j; i++) {
                            setupElement(elements[i], {
                                mode: mode,
                                property: property,
                                value: value
                            });
                        }
                    }
                }

            }
        }

        /**
         *
         * @param {HTMLElement} element
         */
        function attachResponsiveImage(element) {
            var children = [];
            var rules = [];
            var sources = [];
            var defaultImageId = 0;
            var lastActiveImage = -1;
            var loadedImages = [];

            for (var i in element.children) {
                if(!element.children.hasOwnProperty(i)) continue;

                if (element.children[i].tagName && element.children[i].tagName.toLowerCase() === 'img') {
                    children.push(element.children[i]);

                    var minWidth = element.children[i].getAttribute('min-width') || element.children[i].getAttribute('data-min-width');
                    //var minHeight = element.children[i].getAttribute('min-height') || element.children[i].getAttribute('data-min-height');
                    var src = element.children[i].getAttribute('data-src') || element.children[i].getAttribute('url');

                    sources.push(src);

                    var rule = {
                        minWidth: minWidth
                    };

                    rules.push(rule);

                    if (!minWidth) {
                        defaultImageId = children.length - 1;
                        element.children[i].style.display = 'block';
                    } else {
                        element.children[i].style.display = 'none';
                    }
                }
            }

            lastActiveImage = defaultImageId;

            function check() {
                var imageToDisplay = false, i;

                for (i in children){
                    if(!children.hasOwnProperty(i)) continue;

                    if (rules[i].minWidth) {
                        if (element.offsetWidth > rules[i].minWidth) {
                            imageToDisplay = i;
                        }
                    }
                }

                if (!imageToDisplay) {
                    //no rule matched, show default
                    imageToDisplay = defaultImageId;
                }

                if (lastActiveImage != imageToDisplay) {
                    //image change

                    if (!loadedImages[imageToDisplay]){
                        //image has not been loaded yet, we need to load the image first in memory to prevent flash of
                        //no content

                        var image = new Image();
                        image.onload = function() {
                            children[imageToDisplay].src = sources[imageToDisplay];

                            children[lastActiveImage].style.display = 'none';
                            children[imageToDisplay].style.display = 'block';

                            loadedImages[imageToDisplay] = true;

                            lastActiveImage = imageToDisplay;
                        };

                        image.src = sources[imageToDisplay];
                    } else {
                        children[lastActiveImage].style.display = 'none';
                        children[imageToDisplay].style.display = 'block';
                        lastActiveImage = imageToDisplay;
                    }
                } else {
                    //make sure for initial check call the .src is set correctly
                    children[imageToDisplay].src = sources[imageToDisplay];
                }
            }

            element.resizeSensor = new ResizeSensor(element, check);
            check();

            if (trackingActive) {
                elements.push(element);
            }
        }

        function findResponsiveImages(){
            var query = getQuery();

            var elements = query('[data-responsive-image],[responsive-image]');
            for (var i = 0, j = elements.length; i < j; i++) {
                attachResponsiveImage(elements[i]);
            }
        }

        var regex = /,?[\s\t]*([^,\n]*?)((?:\[[\s\t]*?(?:min|max)-(?:width|height)[\s\t]*?[~$\^]?=[\s\t]*?"[^"]*?"[\s\t]*?])+)([^,\n\s\{]*)/mgi;
        var attrRegex = /\[[\s\t]*?(min|max)-(width|height)[\s\t]*?[~$\^]?=[\s\t]*?"([^"]*?)"[\s\t]*?]/mgi;
        /**
         * @param {String} css
         */
        function extractQuery(css) {
            var match;
            var smatch;
            css = css.replace(/'/g, '"');
            while (null !== (match = regex.exec(css))) {
                smatch = match[1] + match[3];
                attrs = match[2];

                while (null !== (attrMatch = attrRegex.exec(attrs))) {
                    queueQuery(smatch, attrMatch[1], attrMatch[2], attrMatch[3]);
                }
            }
        }

        /**
         * @param {CssRule[]|String} rules
         */
        function readRules(rules) {
            var selector = '';
            if (!rules) {
                return;
            }
            if ('string' === typeof rules) {
                rules = rules.toLowerCase();
                if (-1 !== rules.indexOf('min-width') || -1 !== rules.indexOf('max-width')) {
                    extractQuery(rules);
                }
            } else {
                for (var i = 0, j = rules.length; i < j; i++) {
                    if (1 === rules[i].type) {
                        selector = rules[i].selectorText || rules[i].cssText;
                        if (-1 !== selector.indexOf('min-height') || -1 !== selector.indexOf('max-height')) {
                            extractQuery(selector);
                        }else if(-1 !== selector.indexOf('min-width') || -1 !== selector.indexOf('max-width')) {
                            extractQuery(selector);
                        }
                    } else if (4 === rules[i].type) {
                        readRules(rules[i].cssRules || rules[i].rules);
                    }
                }
            }
        }

        var defaultCssInjected = false;

        /**
         * Searches all css rules and setups the event listener to all elements with element query rules..
         *
         * @param {Boolean} withTracking allows and requires you to use detach, since we store internally all used elements
         *                               (no garbage collection possible if you don not call .detach() first)
         */
        this.init = function(withTracking) {
            trackingActive = typeof withTracking === 'undefined' ? false : withTracking;

            for (var i = 0, j = document.styleSheets.length; i < j; i++) {
                try {
                    readRules(document.styleSheets[i].cssRules || document.styleSheets[i].rules || document.styleSheets[i].cssText);
                } catch(e) {
                    if (e.name !== 'SecurityError') {
                        throw e;
                    }
                }
            }

            if (!defaultCssInjected) {
                var style = document.createElement('style');
                style.type = 'text/css';
                style.innerHTML = '[responsive-image] > img, [data-responsive-image] {overflow: hidden; padding: 0; } [responsive-image] > img, [data-responsive-image] > img { width: 100%;}';
                document.getElementsByTagName('head')[0].appendChild(style);
                defaultCssInjected = true;
            }

            findElementQueriesElements();
            findResponsiveImages();
        };

        /**
         *
         * @param {Boolean} withTracking allows and requires you to use detach, since we store internally all used elements
         *                               (no garbage collection possible if you don not call .detach() first)
         */
        this.update = function(withTracking) {
            this.init(withTracking);
        };

        this.detach = function() {
            if (!this.withTracking) {
                throw 'withTracking is not enabled. We can not detach elements since we don not store it.' +
                'Use ElementQueries.withTracking = true; before domready or call ElementQueryes.update(true).';
            }

            var element;
            while (element = elements.pop()) {
                ElementQueries.detach(element);
            }

            elements = [];
        };
    };

    /**
     *
     * @param {Boolean} withTracking allows and requires you to use detach, since we store internally all used elements
     *                               (no garbage collection possible if you don not call .detach() first)
     */
    ElementQueries.update = function(withTracking) {
        ElementQueries.instance.update(withTracking);
    };

    /**
     * Removes all sensor and elementquery information from the element.
     *
     * @param {HTMLElement} element
     */
    ElementQueries.detach = function(element) {
        if (element.elementQueriesSetupInformation) {
            //element queries
            element.elementQueriesSensor.detach();
            delete element.elementQueriesSetupInformation;
            delete element.elementQueriesSensor;

        } else if (element.resizeSensor) {
            //responsive image

            element.resizeSensor.detach();
            delete element.resizeSensor;
        } else {
            //console.log('detached already', element);
        }
    };

    ElementQueries.withTracking = false;

    ElementQueries.init = function() {
        if (!ElementQueries.instance) {
            ElementQueries.instance = new ElementQueries();
        }

        ElementQueries.instance.init(ElementQueries.withTracking);
    };

    var domLoaded = function (callback) {
        /* Internet Explorer */
        /*@cc_on
         @if (@_win32 || @_win64)
         document.write('<script id="ieScriptLoad" defer src="//:"><\/script>');
         document.getElementById('ieScriptLoad').onreadystatechange = function() {
         if (this.readyState == 'complete') {
         callback();
         }
         };
         @end @*/
        /* Mozilla, Chrome, Opera */
        if (document.addEventListener) {
            document.addEventListener('DOMContentLoaded', callback, false);
        }
        /* Safari, iCab, Konqueror */
        else if (/KHTML|WebKit|iCab/i.test(navigator.userAgent)) {
            var DOMLoadTimer = setInterval(function () {
                if (/loaded|complete/i.test(document.readyState)) {
                    callback();
                    clearInterval(DOMLoadTimer);
                }
            }, 10);
        }
        /* Other web browsers */
        else window.onload = callback;
    };

    ElementQueries.listen = function() {
        domLoaded(ElementQueries.init);
    };

    // make available to common module loader
    if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
        module.exports = ElementQueries;
    }
    else {
        window.ElementQueries = ElementQueries;
        ElementQueries.listen();
    }

    return ElementQueries;

}));


/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".controls__icon__2tdnX{cursor:pointer;transition-duration:.2s;transition-property:opacity;opacity:1}.controls__icon__2tdnX:hover{opacity:.7}.controls__hidden__L3uTh{visibility:hidden!important;width:0!important;height:0!important;margin:0!important;padding:0!important;opacity:0!important}.controls__button__1HFJW{font-size:16px;line-height:24px;display:-ms-flexbox;display:flex;box-sizing:border-box;height:36px;padding:0 23px;cursor:pointer;transition:background-color .1s linear,border-color .1s linear,color .1s linear;text-align:center;color:#fff;border:1px solid #fff;border-radius:18px;outline:none;background-color:#fff;-ms-flex-align:center;align-items:center;-webkit-font-smoothing:antialiased}.controls__button__1HFJW:hover{border-color:#4eb7f5;background-color:#4eb7f5}.controls__button__1HFJW:active{border-color:#fff;background-color:#fff}.controls__controls-block__V8gh-{position:absolute;z-index:10;right:0;bottom:0;left:0}.controls__controls-block__V8gh-::-moz-focus-inner{border:0}.controls__controls-wrapper__1Lfdg{z-index:10;outline:none}.controls__controls-wrapper__1Lfdg .controls__gradient-background__NZ9v9{height:182px;background-image:linear-gradient(180deg,transparent,rgba(91,88,88,.03) 16%,rgba(43,41,41,.09) 39%,rgba(0,0,0,.15) 67%,rgba(0,0,0,.3));background-size:100% 182px}.controls__controls-wrapper__1Lfdg .controls__controls__xbsWJ,.controls__controls-wrapper__1Lfdg .controls__gradient-background__NZ9v9{position:absolute;z-index:3;right:0;bottom:0;left:0;visibility:hidden;transition:opacity .2s,visibility .2s;opacity:0}.controls__controls-wrapper__1Lfdg .controls__controls__xbsWJ{display:-ms-flexbox;display:flex;width:100%;max-width:100%;height:25px;margin-bottom:13px;padding-top:10px;-ms-flex-align:center;align-items:center}div[data-hook=player-container][data-in-full-screen~=true] .controls__controls-wrapper__1Lfdg .controls__controls__xbsWJ{margin-bottom:25px}div[data-hook=player-container][max-width~=\"550px\"] .controls__controls-wrapper__1Lfdg .controls__controls__xbsWJ{margin-bottom:7px}.controls__controls-wrapper__1Lfdg.controls__activated__1n-k_ .controls__controls__xbsWJ,.controls__controls-wrapper__1Lfdg.controls__activated__1n-k_ .controls__gradient-background__NZ9v9,.controls__controls-wrapper__1Lfdg.controls__video-paused__232wZ .controls__controls__xbsWJ,.controls__controls-wrapper__1Lfdg.controls__video-paused__232wZ .controls__gradient-background__NZ9v9{visibility:visible;opacity:1}", ""]);

// exports
exports.locals = {
	"icon": "controls__icon__2tdnX",
	"hidden": "controls__hidden__L3uTh",
	"button": "controls__button__1HFJW",
	"controls-block": "controls__controls-block__V8gh-",
	"controlsBlock": "controls__controls-block__V8gh-",
	"controls-wrapper": "controls__controls-wrapper__1Lfdg",
	"controlsWrapper": "controls__controls-wrapper__1Lfdg",
	"gradient-background": "controls__gradient-background__NZ9v9",
	"gradientBackground": "controls__gradient-background__NZ9v9",
	"controls": "controls__controls__xbsWJ",
	"activated": "controls__activated__1n-k_",
	"video-paused": "controls__video-paused__232wZ",
	"videoPaused": "controls__video-paused__232wZ"
};

/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".full-screen__icon__2und-{cursor:pointer;transition-duration:.2s;transition-property:opacity;opacity:1}.full-screen__icon__2und-:hover{opacity:.7}.full-screen__hidden__2HI9W{visibility:hidden!important;width:0!important;height:0!important;margin:0!important;padding:0!important;opacity:0!important}.full-screen__button__3-ecL{font-size:16px;line-height:24px;display:-ms-flexbox;display:flex;box-sizing:border-box;height:36px;padding:0 23px;cursor:pointer;transition:background-color .1s linear,border-color .1s linear,color .1s linear;text-align:center;color:#fff;border:1px solid #fff;border-radius:18px;outline:none;background-color:#fff;-ms-flex-align:center;align-items:center;-webkit-font-smoothing:antialiased}.full-screen__button__3-ecL:hover{border-color:#4eb7f5;background-color:#4eb7f5}.full-screen__button__3-ecL:active{border-color:#fff;background-color:#fff}.full-screen__full-screen-control__1P_tG{position:relative;display:-ms-flexbox;display:flex;margin-right:18px;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}div[data-hook=player-container][max-width~=\"550px\"] .full-screen__full-screen-control__1P_tG{margin-right:12px}div[data-hook=player-container][data-in-full-screen~=true] .full-screen__full-screen-control__1P_tG{margin-right:30px}.full-screen__full-screen-toggle__1yHcz{width:14px;min-width:14px;height:14px;min-height:14px;transition:transform .2s;background-image:url(" + __webpack_require__(1683) + ");background-size:14px 14px}div[data-hook=player-container][data-in-full-screen~=true] .full-screen__full-screen-toggle__1yHcz{width:21px;min-width:21px;height:21px;min-height:21px;background-size:21px 21px}.full-screen__full-screen-toggle__1yHcz:hover{transform:scale(1.2)}.full-screen__full-screen-toggle__1yHcz.full-screen__in-full-screen__2i2_L{background-image:url(" + __webpack_require__(1682) + ")}.full-screen__full-screen-toggle__1yHcz.full-screen__in-full-screen__2i2_L:hover{transform:scale(.8)}", ""]);

// exports
exports.locals = {
	"icon": "full-screen__icon__2und-",
	"hidden": "full-screen__hidden__2HI9W",
	"button": "full-screen__button__3-ecL",
	"full-screen-control": "full-screen__full-screen-control__1P_tG",
	"fullScreenControl": "full-screen__full-screen-control__1P_tG",
	"full-screen-toggle": "full-screen__full-screen-toggle__1yHcz",
	"fullScreenToggle": "full-screen__full-screen-toggle__1yHcz",
	"in-full-screen": "full-screen__in-full-screen__2i2_L",
	"inFullScreen": "full-screen__in-full-screen__2i2_L"
};

/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".play__icon__3AqQA{cursor:pointer;transition-duration:.2s;transition-property:opacity;opacity:1}.play__icon__3AqQA:hover{opacity:.7}.play__hidden__JvNOm{visibility:hidden!important;width:0!important;height:0!important;margin:0!important;padding:0!important;opacity:0!important}.play__button__2_nDK{font-size:16px;line-height:24px;display:-ms-flexbox;display:flex;box-sizing:border-box;height:36px;padding:0 23px;cursor:pointer;transition:background-color .1s linear,border-color .1s linear,color .1s linear;text-align:center;color:#fff;border:1px solid #fff;border-radius:18px;outline:none;background-color:#fff;-ms-flex-align:center;align-items:center;-webkit-font-smoothing:antialiased}.play__button__2_nDK:hover{border-color:#4eb7f5;background-color:#4eb7f5}.play__button__2_nDK:active{border-color:#fff;background-color:#fff}.play__play-control__2yV7x{position:relative;display:-ms-flexbox;display:flex;box-sizing:border-box;width:11px;height:15px;margin-right:18px;margin-left:18px;-ms-flex-align:center;align-items:center;-ms-flex-pack:start;justify-content:flex-start}div[data-hook=player-container][data-in-full-screen~=true] .play__play-control__2yV7x{width:16px;height:21px;margin-right:30px;margin-left:30px}div[data-hook=player-container][max-width~=\"550px\"] .play__play-control__2yV7x{margin-left:12px}.play__playback-toggle__1OH86{width:10px;min-width:10px;height:14px;min-height:14px;background-image:url(" + __webpack_require__(1685) + ");background-size:10px 14px}div[data-hook=player-container][data-in-full-screen~=true] .play__playback-toggle__1OH86{width:15px;min-width:15px;height:21px;min-height:21px;background-size:15px 21px}div[data-hook=player-container][data-in-full-screen~=true] .play__playback-toggle__1OH86.play__paused__37724{width:16px;min-width:16px;background-size:16px 21px}.play__playback-toggle__1OH86.play__paused__37724{width:11px;min-width:11px;background-image:url(" + __webpack_require__(1686) + ");background-size:11px 14px}", ""]);

// exports
exports.locals = {
	"icon": "play__icon__3AqQA",
	"hidden": "play__hidden__JvNOm",
	"button": "play__button__2_nDK",
	"play-control": "play__play-control__2yV7x",
	"playControl": "play__play-control__2yV7x",
	"playback-toggle": "play__playback-toggle__1OH86",
	"playbackToggle": "play__playback-toggle__1OH86",
	"paused": "play__paused__37724"
};

/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".progress__icon__1GvuR{cursor:pointer;transition-duration:.2s;transition-property:opacity;opacity:1}.progress__icon__1GvuR:hover{opacity:.7}.progress__hidden__36jG0{visibility:hidden!important;width:0!important;height:0!important;margin:0!important;padding:0!important;opacity:0!important}.progress__button__15917{font-size:16px;line-height:24px;display:-ms-flexbox;display:flex;box-sizing:border-box;height:36px;padding:0 23px;cursor:pointer;transition:background-color .1s linear,border-color .1s linear,color .1s linear;text-align:center;color:#fff;border:1px solid #fff;border-radius:18px;outline:none;background-color:#fff;-ms-flex-align:center;align-items:center;-webkit-font-smoothing:antialiased}.progress__button__15917:hover{border-color:#4eb7f5;background-color:#4eb7f5}.progress__button__15917:active{border-color:#fff;background-color:#fff}.progress__seek-block__8HEFa{position:relative;display:inline-block;-ms-flex:1;flex:1;margin-right:18px;cursor:pointer}div[data-hook=player-container][data-in-full-screen~=true] .progress__seek-block__8HEFa{margin-right:30px}div[data-hook=player-container][max-width~=\"400px\"] .progress__seek-block__8HEFa{visibility:hidden!important;width:0!important;height:0!important;margin:0!important;padding:0!important;opacity:0!important}.progress__progress-bar__1Ol2B{position:absolute;top:50%;left:0;width:100%;height:2px;margin:-1px 0 0;padding:0;transition:none;vertical-align:top;border:none;background:transparent;-webkit-appearance:none;-moz-appearance:none;appearance:none}.progress__progress-bar__1Ol2B::-webkit-progress-bar{background:transparent}.progress__progress-bar__1Ol2B::-webkit-progress-value{transition:none;background:currentColor}.progress__progress-bar__1Ol2B::-moz-progress-bar{transition:none;background:currentColor}.progress__progress-bar__1Ol2B::-ms-fill{transition:none;border:none}.progress__progress-bar__1Ol2B[data-hook=played-indicator]::-ms-fill{display:none}.progress__progress-played__L55v0{color:#fff}.progress__progress-buffered__bbSkW{color:hsla(0,0%,100%,.25);background:hsla(0,0%,100%,.25)}.progress__progress-buffered__bbSkW::-webkit-progress-value{transition:width .2s ease}.progress__progress-buffered__bbSkW::-moz-progress-bar{transition:width .2s ease}.progress__progress-buffered__bbSkW::-ms-fill{transition:width .2s ease}.progress__seek-control__1KG_d{position:relative;z-index:2;display:block;width:100%;height:15px;margin:0;padding:0;cursor:pointer;vertical-align:middle;border:none;background:transparent;-webkit-appearance:none;-moz-appearance:none;appearance:none}.progress__seek-control__1KG_d::-webkit-slider-runnable-track{background:transparent;cursor:pointer;-webkit-user-select:none;user-select:none;border:0;border-radius:4px}.progress__seek-control__1KG_d::-webkit-slider-thumb{-webkit-appearance:none;position:relative;box-sizing:border-box;width:10px;height:10px;cursor:pointer;border:none;border-radius:100%;background:#fff}.progress__seek-control__1KG_d::-moz-range-track{background:transparent;cursor:pointer;-moz-user-select:none;user-select:none;border:0;border-radius:4px}.progress__seek-control__1KG_d::-moz-range-thumb{position:relative;box-sizing:border-box;width:10px;height:10px;cursor:pointer;border:none;border-radius:100%;background:#fff}.progress__seek-control__1KG_d::-ms-track{height:2px;color:transparent;border:0;background:transparent}.progress__seek-control__1KG_d::-ms-fill-upper{background:transparent}.progress__seek-control__1KG_d::-ms-fill-lower,.progress__seek-control__1KG_d::-ms-fill-upper{cursor:pointer;-ms-user-select:none;user-select:none;border:0;border-radius:4px}.progress__seek-control__1KG_d::-ms-fill-lower{height:2px;color:#fff;background:#fff}.progress__seek-control__1KG_d::-ms-thumb{position:relative;box-sizing:border-box;width:10px;height:10px;cursor:pointer;border:none;border-radius:100%;background:#fff}.progress__seek-control__1KG_d::-ms-tooltip{display:none}.progress__seek-control__1KG_d:focus{outline:0}.progress__seek-control__1KG_d::-moz-focus-outer{border:0}", ""]);

// exports
exports.locals = {
	"icon": "progress__icon__1GvuR",
	"hidden": "progress__hidden__36jG0",
	"button": "progress__button__15917",
	"seek-block": "progress__seek-block__8HEFa",
	"seekBlock": "progress__seek-block__8HEFa",
	"progress-bar": "progress__progress-bar__1Ol2B",
	"progressBar": "progress__progress-bar__1Ol2B",
	"progress-played": "progress__progress-played__L55v0",
	"progressPlayed": "progress__progress-played__L55v0",
	"progress-buffered": "progress__progress-buffered__bbSkW",
	"progressBuffered": "progress__progress-buffered__bbSkW",
	"seek-control": "progress__seek-control__1KG_d",
	"seekControl": "progress__seek-control__1KG_d"
};

/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".time__icon__2qlLo{cursor:pointer;transition-duration:.2s;transition-property:opacity;opacity:1}.time__icon__2qlLo:hover{opacity:.7}.time__hidden__9Y1C3{visibility:hidden!important;width:0!important;height:0!important;margin:0!important;padding:0!important;opacity:0!important}.time__button__wbvDK{font-size:16px;line-height:24px;display:-ms-flexbox;display:flex;box-sizing:border-box;height:36px;padding:0 23px;cursor:pointer;transition:background-color .1s linear,border-color .1s linear,color .1s linear;text-align:center;color:#fff;border:1px solid #fff;border-radius:18px;outline:none;background-color:#fff;-ms-flex-align:center;align-items:center;-webkit-font-smoothing:antialiased}.time__button__wbvDK:hover{border-color:#4eb7f5;background-color:#4eb7f5}.time__button__wbvDK:active{border-color:#fff;background-color:#fff}.time__time-wrapper__1uNAU{display:-ms-flexbox;display:flex;-ms-flex:0 0 auto;flex:0 0 auto;height:15px;margin-right:18px;-ms-flex-align:center;align-items:center}div[data-hook=player-container][data-in-full-screen~=true] .time__time-wrapper__1uNAU{margin-right:30px}div[data-hook=player-container][max-width~=\"300px\"] .time__time-wrapper__1uNAU{visibility:hidden!important;width:0!important;height:0!important;margin:0!important;padding:0!important;opacity:0!important}.time__time__19-gc{font-size:12px;line-height:12px;color:#fff}div[data-hook=player-container][data-in-full-screen~=true] .time__time__19-gc{font-size:14px}.time__time__19-gc.time__current__2cIPF{margin-right:5px}.time__time__19-gc.time__duration__3DkG0{margin-left:5px}", ""]);

// exports
exports.locals = {
	"icon": "time__icon__2qlLo",
	"hidden": "time__hidden__9Y1C3",
	"button": "time__button__wbvDK",
	"time-wrapper": "time__time-wrapper__1uNAU",
	"timeWrapper": "time__time-wrapper__1uNAU",
	"time": "time__time__19-gc",
	"current": "time__current__2cIPF",
	"duration": "time__duration__3DkG0"
};

/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".volume__icon__2f7O7{cursor:pointer;transition-duration:.2s;transition-property:opacity;opacity:1}.volume__icon__2f7O7:hover{opacity:.7}.volume__hidden__-aMZv{visibility:hidden!important;width:0!important;height:0!important;margin:0!important;padding:0!important;opacity:0!important}.volume__button__2H05k{font-size:16px;line-height:24px;display:-ms-flexbox;display:flex;box-sizing:border-box;height:36px;padding:0 23px;cursor:pointer;transition:background-color .1s linear,border-color .1s linear,color .1s linear;text-align:center;color:#fff;border:1px solid #fff;border-radius:18px;outline:none;background-color:#fff;-ms-flex-align:center;align-items:center;-webkit-font-smoothing:antialiased}.volume__button__2H05k:hover{border-color:#4eb7f5;background-color:#4eb7f5}.volume__button__2H05k:active{border-color:#fff;background-color:#fff}.volume__volume-control__6ZVMk{position:relative;display:-ms-flexbox;display:flex;width:18px;max-width:18px;height:25px;margin-right:18px;-ms-flex-pack:start;justify-content:flex-start;-ms-flex-align:center;align-items:center}div[data-hook=player-container][data-in-full-screen~=true] .volume__volume-control__6ZVMk{width:25px;max-width:25px;height:35px;margin-right:30px}div[data-hook=player-container][max-width~=\"300px\"] .volume__volume-control__6ZVMk{visibility:hidden!important;width:0!important;height:0!important;margin:0!important;padding:0!important;opacity:0!important}.volume__volume-control__6ZVMk:hover .volume__container__31vLK{visibility:visible;opacity:1}.volume__mute-button__3XN5i{width:17px;min-width:17px;height:14px;min-height:14px;background-image:url(" + __webpack_require__(1688) + ");background-size:17px 14px}div[data-hook=player-container][data-in-full-screen~=true] .volume__mute-button__3XN5i{width:25px;min-width:25px;height:21px;min-height:21px;background-size:25px 21px}.volume__mute-button__3XN5i.volume__half-volume__1sRu2{background-image:url(" + __webpack_require__(1689) + ")}.volume__mute-button__3XN5i.volume__muted__zJZny{background-image:url(" + __webpack_require__(1687) + ")}.volume__container__31vLK{font-size:10px;position:absolute;top:-82px;left:-5px;visibility:hidden;padding:9px 3px;transition:opacity .2s,visibility .2s;opacity:0;background-color:rgba(0,0,0,.5)}div[data-hook=player-container][data-in-full-screen~=true] .volume__container__31vLK{top:-122px;left:-7px}.volume__content__p8DVD{position:relative;box-sizing:content-box;width:2px;height:60px;padding:2px 7px}div[data-hook=player-container][data-in-full-screen~=true] .volume__content__p8DVD{width:2px;height:100px;padding:2px 12px}.volume__input-wrapper__Z-xTd{position:relative;width:100%;height:100%;background-color:hsla(0,0%,100%,.5)}.volume__filled-progress__3QSfu{position:absolute;bottom:0;left:0;width:100%;background-color:#fff}.volume__filled-progress__3QSfu:before{position:absolute;top:-4px;right:-4px;width:10px;height:10px;content:\"\";border-radius:50%;background-color:#fff}.volume__volume-input__39Ybn{position:absolute;top:0;right:-5px;bottom:0;left:-5px;width:12px;height:100%;margin:0;padding:0;cursor:pointer;-ms-writing-mode:bt-lr;opacity:0;border:0;outline:none;-webkit-appearance:slider-vertical}", ""]);

// exports
exports.locals = {
	"icon": "volume__icon__2f7O7",
	"hidden": "volume__hidden__-aMZv",
	"button": "volume__button__2H05k",
	"volume-control": "volume__volume-control__6ZVMk",
	"volumeControl": "volume__volume-control__6ZVMk",
	"container": "volume__container__31vLK",
	"mute-button": "volume__mute-button__3XN5i",
	"muteButton": "volume__mute-button__3XN5i",
	"half-volume": "volume__half-volume__1sRu2",
	"halfVolume": "volume__half-volume__1sRu2",
	"muted": "volume__muted__zJZny",
	"content": "volume__content__p8DVD",
	"input-wrapper": "volume__input-wrapper__Z-xTd",
	"inputWrapper": "volume__input-wrapper__Z-xTd",
	"filled-progress": "volume__filled-progress__3QSfu",
	"filledProgress": "volume__filled-progress__3QSfu",
	"volume-input": "volume__volume-input__39Ybn",
	"volumeInput": "volume__volume-input__39Ybn"
};

/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".loader__icon__3uaZQ{cursor:pointer;transition-duration:.2s;transition-property:opacity;opacity:1}.loader__icon__3uaZQ:hover{opacity:.7}.loader__hidden__31Nw1{visibility:hidden!important;width:0!important;height:0!important;margin:0!important;padding:0!important;opacity:0!important}.loader__button__96O6l{font-size:16px;line-height:24px;display:-ms-flexbox;display:flex;box-sizing:border-box;height:36px;padding:0 23px;cursor:pointer;transition:background-color .1s linear,border-color .1s linear,color .1s linear;text-align:center;color:#fff;border:1px solid #fff;border-radius:18px;outline:none;background-color:#fff;-ms-flex-align:center;align-items:center;-webkit-font-smoothing:antialiased}.loader__button__96O6l:hover{border-color:#4eb7f5;background-color:#4eb7f5}.loader__button__96O6l:active{border-color:#fff;background-color:#fff}.loader__loader__1Iq1S{position:absolute;z-index:90;top:50%;left:50%;clip:rect(0,48px,48px,24px);width:42px;height:42px;margin-top:-21px;margin-left:-21px;animation:loader__rotate__1PKvd 1s linear infinite;color:#fff}.loader__loader__1Iq1S:after{clip:rect(4px,48px,48px,24px);animation:loader__clip__3XQav 1s linear infinite}.loader__loader__1Iq1S:after,.loader__loader__1Iq1S:before{position:absolute;top:0;right:0;bottom:0;left:0;content:\"\";border:3px solid currentColor;border-radius:50%}.loader__loader__1Iq1S:before{clip:rect(0,48px,48px,24px);animation:loader__clip-reverse__Lw3FV 1s linear infinite}@keyframes loader__clip__3XQav{50%{clip:rect(42px,48px,48px,24px);animation-timing-function:ease-in-out}}@keyframes loader__clip-reverse__Lw3FV{50%{clip:rect(0,48px,9px,24px);transform:rotate(135deg);animation-timing-function:ease-in-out}}@keyframes loader__rotate__1PKvd{0%{transform:rotate(0);animation-timing-function:ease-out}45%{transform:rotate(18deg);color:#fff}55%{transform:rotate(54deg)}to{transform:rotate(1turn)}}", ""]);

// exports
exports.locals = {
	"icon": "loader__icon__3uaZQ",
	"hidden": "loader__hidden__31Nw1",
	"button": "loader__button__96O6l",
	"loader": "loader__loader__1Iq1S",
	"rotate": "loader__rotate__1PKvd",
	"clip": "loader__clip__3XQav",
	"clip-reverse": "loader__clip-reverse__Lw3FV",
	"clipReverse": "loader__clip-reverse__Lw3FV"
};

/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".overlay__icon__2TBYW{cursor:pointer;transition-duration:.2s;transition-property:opacity}.overlay__icon__2TBYW:hover{opacity:.7}.overlay__hidden__djsvp{visibility:hidden!important;width:0!important;height:0!important;margin:0!important;padding:0!important;opacity:0!important}.overlay__button__1khXw{font-size:16px;line-height:24px;display:-ms-flexbox;display:flex;box-sizing:border-box;height:36px;padding:0 23px;cursor:pointer;transition:background-color .1s linear,border-color .1s linear,color .1s linear;text-align:center;color:#fff;border:1px solid #fff;border-radius:18px;outline:none;background-color:#fff;-ms-flex-align:center;align-items:center;-webkit-font-smoothing:antialiased}.overlay__button__1khXw:hover{border-color:#4eb7f5;background-color:#4eb7f5}.overlay__button__1khXw:active{border-color:#fff;background-color:#fff}.overlay__overlay__w5Gh_{position:absolute;z-index:100;top:0;right:0;bottom:0;left:0;display:-ms-flexbox;display:flex;width:100%;height:100%;background:#000 no-repeat 50%;background-size:cover;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.overlay__icon__2TBYW{width:71px;height:71px;opacity:1;background-image:url(" + __webpack_require__(1684) + ");background-size:100%}.overlay__icon__2TBYW:hover{opacity:.8}", ""]);

// exports
exports.locals = {
	"icon": "overlay__icon__2TBYW",
	"hidden": "overlay__hidden__djsvp",
	"button": "overlay__button__1khXw",
	"overlay": "overlay__overlay__w5Gh_"
};

/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".screen__icon-container__2IAwc{position:absolute;z-index:1;top:0;right:0;bottom:0;left:0}.screen__icon-container__2IAwc,.screen__icon-container__2IAwc .screen__icon__3ZvpB{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.screen__icon-container__2IAwc .screen__icon__3ZvpB{font-size:9px;line-height:9px;position:relative;animation-name:screen__fade-out__zUQUX;animation-duration:.5s;opacity:0;border-radius:100px;background-color:rgba(0,0,0,.5)}.screen__icon-container__2IAwc .screen__animated-icon__2lV3R{animation-name:screen__icon-size__23_l0;animation-duration:.5s}.screen__icon-container__2IAwc .screen__play-icon__4-PXY{position:relative;left:3px}.screen__icon-container__2IAwc .screen__pause-icon__vx5ln{margin:5px 0}.screen__icon-container__2IAwc .screen__seconds__1Msme{position:absolute;top:0;right:0;bottom:0;left:0;display:-ms-flexbox;display:flex;min-width:5px;min-height:8px;color:#fff;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.screen__icon-container__2IAwc .screen__seconds__1Msme span{display:block}@keyframes screen__icon-size__23_l0{0%{width:22px;height:22px}to{width:30px;height:30px}}@keyframes screen__fade-out__zUQUX{0%{width:22px;height:22px;padding:19px;opacity:.9}to{font-size:14px;line-height:14px;width:30px;height:30px;padding:25px;opacity:0}}.screen__screen-block___8IMN{position:absolute;z-index:5;top:0;right:0;bottom:0;left:0;width:100%;height:100%}", ""]);

// exports
exports.locals = {
	"icon-container": "screen__icon-container__2IAwc",
	"iconContainer": "screen__icon-container__2IAwc",
	"icon": "screen__icon__3ZvpB",
	"fade-out": "screen__fade-out__zUQUX",
	"fadeOut": "screen__fade-out__zUQUX",
	"animated-icon": "screen__animated-icon__2lV3R",
	"animatedIcon": "screen__animated-icon__2lV3R",
	"icon-size": "screen__icon-size__23_l0",
	"iconSize": "screen__icon-size__23_l0",
	"play-icon": "screen__play-icon__4-PXY",
	"playIcon": "screen__play-icon__4-PXY",
	"pause-icon": "screen__pause-icon__vx5ln",
	"pauseIcon": "screen__pause-icon__vx5ln",
	"seconds": "screen__seconds__1Msme",
	"screen-block": "screen__screen-block___8IMN",
	"screenBlock": "screen__screen-block___8IMN"
};

/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".ui__icon__2sFhw{cursor:pointer;transition-duration:.2s;transition-property:opacity;opacity:1}.ui__icon__2sFhw:hover{opacity:.7}.ui__hidden__28cIY{visibility:hidden!important;width:0!important;height:0!important;margin:0!important;padding:0!important;opacity:0!important}.ui__button__3Yi76{font-size:16px;line-height:24px;display:-ms-flexbox;display:flex;box-sizing:border-box;height:36px;padding:0 23px;cursor:pointer;transition:background-color .1s linear,border-color .1s linear,color .1s linear;text-align:center;color:#fff;border:1px solid #fff;border-radius:18px;outline:none;background-color:#fff;-ms-flex-align:center;align-items:center;-webkit-font-smoothing:antialiased}.ui__button__3Yi76:hover{border-color:#4eb7f5;background-color:#4eb7f5}.ui__button__3Yi76:active{border-color:#fff;background-color:#fff}.ui__video-wrapper__1V2_4{font-family:HelveticaNeueW01-45Ligh,HelveticaNeueW02-45Ligh,HelveticaNeueW10-45Ligh,Helvetica Neue,Helvetica,Arial,\\\\30E1\\30A4\\30EA\\30AA,meiryo,\\\\30D2\\30E9\\30AE\\30CE\\89D2\\30B4 pro w3,hiragino kaku gothic pro;line-height:0;position:relative;height:inherit}.ui__video-wrapper__1V2_4 :focus{outline:none}.ui__video-wrapper__1V2_4 ::-moz-focus-inner{border:0}.ui__video-wrapper__1V2_4 .ui__inner-wrapper__1lv-E{position:absolute;top:0;right:0;bottom:0;left:0;display:-ms-flexbox;display:flex;width:100%;height:100%;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;outline:none;background-color:#000;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.ui__video-wrapper__1V2_4 video{position:relative;z-index:0;width:100%;height:100%;outline:none}.ui__video-wrapper__1V2_4 .ui__full-screen-control__2A8-9{display:none}.ui__full-screen__T330_{width:100%!important;height:100%!important}", ""]);

// exports
exports.locals = {
	"icon": "ui__icon__2sFhw",
	"hidden": "ui__hidden__28cIY",
	"button": "ui__button__3Yi76",
	"video-wrapper": "ui__video-wrapper__1V2_4",
	"videoWrapper": "ui__video-wrapper__1V2_4",
	"inner-wrapper": "ui__inner-wrapper__1lv-E",
	"innerWrapper": "ui__inner-wrapper__1lv-E",
	"full-screen-control": "ui__full-screen-control__2A8-9",
	"fullScreenControl": "ui__full-screen-control__2A8-9",
	"full-screen": "ui__full-screen__T330_",
	"fullScreen": "ui__full-screen__T330_"
};

/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".scrollbar-wrapper__scrollbar-wrapper__22rMo{overflow-x:hidden;overflow-y:hidden;width:100%;height:100%}.scrollbar-wrapper__scrollbar-wrapper__22rMo.scrollbar-wrapper__scroll-x__1yQww{overflow-x:auto}.scrollbar-wrapper__scrollbar-wrapper__22rMo.scrollbar-wrapper__scroll-y__hcVgc{overflow-y:auto}.scrollbar-wrapper__scrollbar-wrapper__22rMo.scrollbar-wrapper__only-on-hover__K-Qsr{overflow-x:hidden;overflow-y:hidden}.scrollbar-wrapper__scrollbar-wrapper__22rMo.scrollbar-wrapper__only-on-hover__K-Qsr.scrollbar-wrapper__scroll-x__1yQww:hover{overflow-x:auto}.scrollbar-wrapper__scrollbar-wrapper__22rMo.scrollbar-wrapper__only-on-hover__K-Qsr.scrollbar-wrapper__scroll-y__hcVgc:hover{overflow-y:auto}.scrollbar-wrapper__scrollbar-wrapper__22rMo::-webkit-scrollbar{background:transparent}.scrollbar-wrapper__scrollbar-wrapper__22rMo::-webkit-scrollbar:vertical{width:14px}.scrollbar-wrapper__scrollbar-wrapper__22rMo::-webkit-scrollbar:horizontal{height:14px}.scrollbar-wrapper__scrollbar-wrapper__22rMo::-webkit-scrollbar-thumb{background-clip:padding-box;border:4px solid transparent;border-radius:999px;transition:background-color .2s}@media screen and (-webkit-min-device-pixel-ratio:0){.scrollbar-wrapper__scrollbar-wrapper__22rMo{margin-right:-14px}}.scrollbar-wrapper__widget__W7yJG::-webkit-scrollbar-thumb{background-color:-wix-colors-buttonsAndLinksColor-30}.scrollbar-wrapper__widget__W7yJG::-webkit-scrollbar-thumb:hover{background-color:-wix-colors-buttonsAndLinksColor-50}.scrollbar-wrapper__widget__W7yJG::-webkit-scrollbar-thumb:active{background-color:-wix-colors-buttonsAndLinksColor}.scrollbar-wrapper__backoffice__2b6qW::-webkit-scrollbar-thumb{background-color:rgba(115,183,242,.3)}.scrollbar-wrapper__backoffice__2b6qW::-webkit-scrollbar-thumb:hover{background-color:rgba(115,183,242,.5)}.scrollbar-wrapper__backoffice__2b6qW::-webkit-scrollbar-thumb:active{background-color:#73b7f2}", ""]);

// exports
exports.locals = {
	"scrollbar-wrapper": "scrollbar-wrapper__scrollbar-wrapper__22rMo",
	"scrollbarWrapper": "scrollbar-wrapper__scrollbar-wrapper__22rMo",
	"scroll-x": "scrollbar-wrapper__scroll-x__1yQww",
	"scrollX": "scrollbar-wrapper__scroll-x__1yQww",
	"scroll-y": "scrollbar-wrapper__scroll-y__hcVgc",
	"scrollY": "scrollbar-wrapper__scroll-y__hcVgc",
	"only-on-hover": "scrollbar-wrapper__only-on-hover__K-Qsr",
	"onlyOnHover": "scrollbar-wrapper__only-on-hover__K-Qsr",
	"widget": "scrollbar-wrapper__widget__W7yJG",
	"backoffice": "scrollbar-wrapper__backoffice__2b6qW"
};

/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".button__button__2_pCL{position:relative;display:inline-block;height:40px;padding:0 30px;vertical-align:middle;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family;text-decoration:-wix-fonts-textFont-decoration;font-size:14px;line-height:1;text-align:center;text-decoration:none;border-radius:0;border:none;background-color:-wix-colors-buttonsAndLinksColor;color:-wix-colors-mainButtonTextColor;outline:none;-ms-touch-action:manipulation;touch-action:manipulation;cursor:pointer;white-space:nowrap;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;transition:opacity .2s}.button__button__2_pCL span{position:relative;z-index:1}.button__button__2_pCL:before{content:\"\";position:absolute;top:0;left:0;right:0;bottom:0;z-index:0;border-radius:inherit;background:#000;transition:opacity .2s;opacity:0}.button__button__2_pCL:hover:before{opacity:.1}.button__button__2_pCL:active:before{opacity:.2}.button__disable-theme___BRVx{color:#fff;background:#000}.button__disable-theme___BRVx:before{content:none}.button__disable-theme___BRVx:hover{opacity:.75}.button__rounded__2umQf{border-radius:999px}", ""]);

// exports
exports.locals = {
	"button": "button__button__2_pCL",
	"disable-theme": "button__disable-theme___BRVx",
	"disableTheme": "button__disable-theme___BRVx",
	"rounded": "button__rounded__2umQf"
};

/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".buttons-group__buttons-wrapper__J2bRF{display:-ms-flexbox;display:flex}.buttons-group__button__NUZnP{-ms-flex:1 1 auto;flex:1 1 auto;width:50%;height:32px;padding:0;background-color:-wix-colors-backgroundColor;border-top:1px solid -wix-colors-buttonsAndLinksColor-50;border-bottom:1px solid -wix-colors-buttonsAndLinksColor-50;color:-wix-colors-textColor;text-align:center}.buttons-group__button__NUZnP:first-child{border-left:1px solid -wix-colors-buttonsAndLinksColor-50}.buttons-group__button__NUZnP:last-child{border-right:1px solid -wix-colors-buttonsAndLinksColor-50}.buttons-group__button__NUZnP:hover{background-color:-wix-colors-buttonsAndLinksColor-50}.buttons-group__button__NUZnP:hover:before{opacity:0}.buttons-group__button__NUZnP.buttons-group__disable-theme__1xTv0{border-color:#000;background:#fff;color:#000}.buttons-group__button__NUZnP.buttons-group__disable-theme__1xTv0:hover{background:#ececec}.buttons-group__button__NUZnP.buttons-group__active__3h2HA{background-color:-wix-colors-buttonsAndLinksColor;color:-wix-colors-mainButtonTextColor}.buttons-group__button__NUZnP.buttons-group__active__3h2HA.buttons-group__disable-theme__1xTv0{background:#000;color:#fff}.buttons-group__button__NUZnP.buttons-group__active__3h2HA.buttons-group__disable-theme__1xTv0:hover{opacity:.75}.buttons-group__rounded__ZZ6sM .buttons-group__button__NUZnP:first-child{border-radius:999px 0 0 999px}.buttons-group__rounded__ZZ6sM .buttons-group__button__NUZnP:last-child{border-radius:0 999px 999px 0}", ""]);

// exports
exports.locals = {
	"buttons-wrapper": "buttons-group__buttons-wrapper__J2bRF",
	"buttonsWrapper": "buttons-group__buttons-wrapper__J2bRF",
	"button": "buttons-group__button__NUZnP",
	"disable-theme": "buttons-group__disable-theme__1xTv0",
	"disableTheme": "buttons-group__disable-theme__1xTv0",
	"active": "buttons-group__active__3h2HA",
	"rounded": "buttons-group__rounded__ZZ6sM"
};

/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".action-button__action-button__2yPHK{display:-ms-inline-flexbox;display:inline-flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:30px;height:30px;color:#fff;font-size:14px;text-decoration:none;white-space:nowrap;background-color:rgba(0,0,0,.5);transition:background-color .2s;margin-bottom:12px}.action-button__action-button__2yPHK:focus{outline:none;text-decoration:none}.action-button__action-button__2yPHK:hover{background-color:#000;text-decoration:none}.action-button__action-button__2yPHK:active{background:#000;text-decoration:none}.action-button__action-button__2yPHK.action-button__rounded__2KmEe{border-radius:999px}.action-button__action-button__2yPHK.action-button__with-label__yfb5c{width:auto;padding:0 12px}.action-button__action-button__2yPHK.action-button__at-full-screen__yE1Xd{width:42px;height:42px;font-size:18px;margin-bottom:18px}.action-button__action-button__2yPHK.action-button__at-full-screen__yE1Xd.action-button__with-label__yfb5c{width:auto;padding:0 15px}.action-button__label__1rON_{margin-right:8px;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family,Helvetica Neue,ruble,Helvetica,Arial,sans-serif;text-decoration:-wix-fonts-textFont-decoration;font-size:12px}.action-button__at-full-screen__yE1Xd .action-button__label__1rON_{font-size:18px;margin-right:10px}@media (max-width:550px){.action-button__action-button__2yPHK.action-button__with-label__yfb5c{width:30px}.action-button__label__1rON_{display:none}}@media (max-width:401px){.action-button__action-button__2yPHK{width:24px;height:24px;font-size:10px;margin-bottom:6px}.action-button__action-button__2yPHK.action-button__with-label__yfb5c{width:24px}}@media (max-width:350px){.action-button__info__J6iyt{display:none}}", ""]);

// exports
exports.locals = {
	"action-button": "action-button__action-button__2yPHK",
	"actionButton": "action-button__action-button__2yPHK",
	"rounded": "action-button__rounded__2KmEe",
	"with-label": "action-button__with-label__yfb5c",
	"withLabel": "action-button__with-label__yfb5c",
	"at-full-screen": "action-button__at-full-screen__yE1Xd",
	"atFullScreen": "action-button__at-full-screen__yE1Xd",
	"label": "action-button__label__1rON_",
	"info": "action-button__info__J6iyt"
};

/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".closable-overlay__info-overlay__2ur6S{position:absolute;top:0;left:0;right:0;bottom:0;z-index:150;transition:opacity .2s;line-height:normal}.closable-overlay__close__1ltA7{position:absolute;z-index:180;top:17px;right:17px;overflow:hidden;color:hsla(0,0%,100%,.7);font-size:20px;cursor:pointer}.closable-overlay__close-fullscreen__3hHWY{font-size:41px}.closable-overlay__content__W5Act{position:absolute;top:0;left:0;right:0;bottom:0;z-index:170;color:#fff;background-color:rgba(0,0,0,.85)}.closable-overlay__content__W5Act.closable-overlay__half__TYtRF{left:50%}.closable-overlay__content__W5Act.closable-overlay__full-screen__1pFIl{left:calc(100% - 630px)}@media (max-width:639px){.closable-overlay__info-overlay__2ur6S{width:100%;max-width:480px;left:auto}.closable-overlay__info-overlay__2ur6S.closable-overlay__full-width__3ijtd{max-width:none}.closable-overlay__content__W5Act.closable-overlay__full-screen__1pFIl,.closable-overlay__content__W5Act.closable-overlay__half__TYtRF{left:0}}", ""]);

// exports
exports.locals = {
	"info-overlay": "closable-overlay__info-overlay__2ur6S",
	"infoOverlay": "closable-overlay__info-overlay__2ur6S",
	"close": "closable-overlay__close__1ltA7",
	"close-fullscreen": "closable-overlay__close-fullscreen__3hHWY",
	"closeFullscreen": "closable-overlay__close-fullscreen__3hHWY",
	"content": "closable-overlay__content__W5Act",
	"half": "closable-overlay__half__TYtRF",
	"full-screen": "closable-overlay__full-screen__1pFIl",
	"fullScreen": "closable-overlay__full-screen__1pFIl",
	"full-width": "closable-overlay__full-width__3ijtd",
	"fullWidth": "closable-overlay__full-width__3ijtd"
};

/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".info__wrapper__1UnWi{display:-ms-flexbox;display:flex;height:100%;padding:0 0 0 40px;font-size:14px;overflow:hidden}.info__scrollbar-wrapper__2oitt{-ms-flex-positive:1;flex-grow:1;overflow-x:hidden;overflow-y:scroll;overflow-y:overlay;-ms-overflow-style:-ms-autohiding-scrollbar}.info__scrollbar-wrapper__2oitt::-webkit-scrollbar-thumb{background-color:#636565}.info__scrollbar-wrapper__2oitt::-webkit-scrollbar-thumb:active,.info__scrollbar-wrapper__2oitt::-webkit-scrollbar-thumb:hover{background-color:#fff}.info__poster__GN6m5{display:block;-ms-flex:0 0 auto;flex:0 0 auto;margin:40px 40px 40px 0;background:50% no-repeat;background-size:cover}.info__poster__GN6m5.info__fullscreen__3G8oY,.info__poster__GN6m5.info__poster-compact__2lwXc{display:none;margin:0}.info__main-info__1gpSM{width:100%;padding:40px 40px 0 0}.info__title__20vhc{font-size:16px;line-height:20px}.info__info__1iui5,.info__title__20vhc{margin-bottom:20px;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family,Helvetica Neue,ruble,Helvetica,Arial,sans-serif;text-decoration:-wix-fonts-textFont-decoration}.info__info__1iui5{line-height:14px;display:-ms-flexbox;display:flex}.info__info-item__29brh{margin-right:13px;padding-right:13px;border-right:1px solid #fff;text-transform:capitalize;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.info__info-item__29brh:last-child{margin-right:0;padding-right:0;border:none}.info__description__TtQAC{margin-bottom:20px;color:hsla(0,0%,100%,.7);font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family,Helvetica Neue,ruble,Helvetica,Arial,sans-serif;text-decoration:-wix-fonts-textFont-decoration;white-space:pre-wrap;line-height:20px}.info__roles-wrapper__142n6{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:20px;padding-top:20px;border-top:1px solid hsla(0,0%,100%,.2);color:#fff}.info__roles-title__2s-Ik{width:100%;font-size:12px;color:hsla(0,0%,100%,.5);text-transform:uppercase}.info__role-item__3ekUD{-ms-flex:1 1 auto;flex:1 1 auto;width:45%;margin-top:20px;margin-right:5px}.info__role__1RNr7{margin-bottom:5px}.info__name__2X0ve,.info__role__1RNr7{text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.info__name__2X0ve{font-style:italic}.info__full-screen__3KdJ2{padding:80px 70px 40px 90px}.info__full-screen__3KdJ2 .info__main-info__1gpSM{padding:0 20px 0 0}.info__full-screen__3KdJ2 .info__title__20vhc{margin-bottom:30px;font-size:42px;line-height:46px}.info__full-screen__3KdJ2 .info__description__TtQAC{margin-bottom:40px}.info__full-screen__3KdJ2 .info__roles-wrapper__142n6{margin-bottom:40px;padding-top:40px}.info__full-screen__3KdJ2 .info__roles-title__2s-Ik{margin-bottom:5px}.info__full-screen__3KdJ2 .info__poster__GN6m5.info__fullscreen__3G8oY{display:block;margin:40px 40px 40px 0}@media (max-width:639px){.info__wrapper__1UnWi{padding:0 0 0 30px}.info__main-info__1gpSM{padding:40px 30px 0 0}.info__poster__GN6m5{display:none;margin:30px 30px 30px 0}.info__poster__GN6m5.info__poster-compact__2lwXc{display:block;width:100%;padding:20px 0;border-top:1px solid hsla(0,0%,100%,.2)}}@media (max-width:469px){.info__role-item__3ekUD{width:100%}}", ""]);

// exports
exports.locals = {
	"wrapper": "info__wrapper__1UnWi",
	"scrollbar-wrapper": "info__scrollbar-wrapper__2oitt",
	"scrollbarWrapper": "info__scrollbar-wrapper__2oitt",
	"poster": "info__poster__GN6m5",
	"fullscreen": "info__fullscreen__3G8oY",
	"poster-compact": "info__poster-compact__2lwXc",
	"posterCompact": "info__poster-compact__2lwXc",
	"main-info": "info__main-info__1gpSM",
	"mainInfo": "info__main-info__1gpSM",
	"title": "info__title__20vhc",
	"info": "info__info__1iui5",
	"info-item": "info__info-item__29brh",
	"infoItem": "info__info-item__29brh",
	"description": "info__description__TtQAC",
	"roles-wrapper": "info__roles-wrapper__142n6",
	"rolesWrapper": "info__roles-wrapper__142n6",
	"roles-title": "info__roles-title__2s-Ik",
	"rolesTitle": "info__roles-title__2s-Ik",
	"role-item": "info__role-item__3ekUD",
	"roleItem": "info__role-item__3ekUD",
	"role": "info__role__1RNr7",
	"name": "info__name__2X0ve",
	"full-screen": "info__full-screen__3KdJ2",
	"fullScreen": "info__full-screen__3KdJ2"
};

/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".progress-bar__progress-played__3a623{color:-wix-colors-buttonsAndLinksColor}", ""]);

// exports
exports.locals = {
	"progress-played": "progress-bar__progress-played__3a623",
	"progressPlayed": "progress-bar__progress-played__3a623"
};

/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".share__share-overlay__ZsLR2{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;-ms-flex-direction:column;flex-direction:column;height:100%}.share__title__9c6X5{margin-bottom:20px;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family;text-decoration:-wix-fonts-textFont-decoration;font-size:16px}.share__social-icons__dWfZ7{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:325px}.share__share-icon__2wieD{color:#fff;height:60px;font-size:34px;text-decoration:none}.share__share-icon__2wieD:active,.share__share-icon__2wieD:hover{color:#f74b4c}.share__share-link__1TrbO{padding-left:20px;padding-right:20px}.share__link__2NUM5:hover{color:-wix-colors-buttonsAndLinksColor}.share__tumblr__2uBnF:hover{color:#34465d}.share__pinterest__hxs3n:hover{color:#bd081c}.share__facebook__3mfMF:hover{color:#3b5999}.share__twitter__3x-I0:hover{color:#55acee}", ""]);

// exports
exports.locals = {
	"share-overlay": "share__share-overlay__ZsLR2",
	"shareOverlay": "share__share-overlay__ZsLR2",
	"title": "share__title__9c6X5",
	"social-icons": "share__social-icons__dWfZ7",
	"socialIcons": "share__social-icons__dWfZ7",
	"share-icon": "share__share-icon__2wieD",
	"shareIcon": "share__share-icon__2wieD",
	"share-link": "share__share-link__1TrbO",
	"shareLink": "share__share-link__1TrbO",
	"link": "share__link__2NUM5",
	"tumblr": "share__tumblr__2uBnF",
	"pinterest": "share__pinterest__hxs3n",
	"facebook": "share__facebook__3mfMF",
	"twitter": "share__twitter__3x-I0"
};

/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".title__wrapper__woEWb{z-index:100;margin-top:18px;margin-left:18px;transition:opacity .2s,visibility .2s;color:#fff;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family;text-decoration:-wix-fonts-textFont-decoration}.title__title__3sCDq{font-size:14px;line-height:14px}.title__at-full-screen__kyDGZ .title__title__3sCDq{top:24px;left:24px;right:276px;font-size:20px;line-height:20px}@media (max-width:551px){.title__title__3sCDq{font-size:16px}}@media (max-width:401px){.title__title__3sCDq{font-size:14px}}@media (max-width:300px){.title__wrapper__woEWb{margin-left:12px;margin-right:12px}.title__title__3sCDq{font-size:12px}}", ""]);

// exports
exports.locals = {
	"wrapper": "title__wrapper__woEWb",
	"title": "title__title__3sCDq",
	"at-full-screen": "title__at-full-screen__kyDGZ",
	"atFullScreen": "title__at-full-screen__kyDGZ"
};

/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".ui-wrapper__main-content-wrapper__2Iddh{position:absolute;left:0;right:0;top:0;z-index:11}.ui-wrapper__info-overlay-wrapper__QocKc{position:absolute;top:0;left:0;right:0;bottom:0;z-index:8}.ui-wrapper__info-overlay-wrapper__QocKc.ui-wrapper__active__17oB9{z-index:12}.ui-wrapper__info-overlay__1Oz0c,.ui-wrapper__main-content__6hk6v{max-width:none;max-height:none;position:static;transition:.2s,opacity .2s;transition-timing-function:ease}.ui-wrapper__main-content-inner__npQUs{position:absolute;left:0;right:0;top:0;min-height:75px;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;background:linear-gradient(0deg,transparent,rgba(0,0,0,.6)) no-repeat;background-size:100% 75px}.ui-wrapper__main-content-inner__npQUs.ui-wrapper__at-full-screen__25ahx .ui-wrapper__actions__1wkwo{margin-left:100px}.ui-wrapper__actions__1wkwo{z-index:100;margin-top:12px;margin-right:12px;margin-left:36px;display:-ms-flexbox;display:flex;-ms-flex-align:end;align-items:flex-end;-ms-flex-direction:column;flex-direction:column;transition:opacity .2s,visibility .2s}@media (max-width:300px){.ui-wrapper__actions__1wkwo{display:none}}", ""]);

// exports
exports.locals = {
	"main-content-wrapper": "ui-wrapper__main-content-wrapper__2Iddh",
	"mainContentWrapper": "ui-wrapper__main-content-wrapper__2Iddh",
	"info-overlay-wrapper": "ui-wrapper__info-overlay-wrapper__QocKc",
	"infoOverlayWrapper": "ui-wrapper__info-overlay-wrapper__QocKc",
	"active": "ui-wrapper__active__17oB9",
	"info-overlay": "ui-wrapper__info-overlay__1Oz0c",
	"infoOverlay": "ui-wrapper__info-overlay__1Oz0c",
	"main-content": "ui-wrapper__main-content__6hk6v",
	"mainContent": "ui-wrapper__main-content__6hk6v",
	"main-content-inner": "ui-wrapper__main-content-inner__npQUs",
	"mainContentInner": "ui-wrapper__main-content-inner__npQUs",
	"at-full-screen": "ui-wrapper__at-full-screen__25ahx",
	"atFullScreen": "ui-wrapper__at-full-screen__25ahx",
	"actions": "ui-wrapper__actions__1wkwo"
};

/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".player__overlay__1_w45{z-index:125;background-color:#000}.player__overlay__1_w45,.player__player__Upu_1{position:relative}.player__player__Upu_1{background:#000}.player__player__Upu_1 .player__player-wrapper__3Msyw{position:absolute;width:100%;height:100%;top:0}", ""]);

// exports
exports.locals = {
	"overlay": "player__overlay__1_w45",
	"player": "player__player__Upu_1",
	"player-wrapper": "player__player-wrapper__3Msyw",
	"playerWrapper": "player__player-wrapper__3Msyw"
};

/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".animate__fade-in__38FRS,.animate__fade-in-out__2L0Lh{position:relative;height:inherit;opacity:0;visibility:hidden;transition:opacity .3s ease-in-out;max-width:0;max-height:0;overflow:hidden}.animate__fade-in-out__2L0Lh.animate__active__3j9wN,.animate__fade-in__38FRS.animate__active__3j9wN{max-width:none;max-height:none;opacity:1;visibility:visible}.animate__fade-in-out__2L0Lh{transition:visibility 0s .3s,opacity .3s;transition-timing-function:ease-in-out}.animate__fade-in-out__2L0Lh.animate__active__3j9wN{transition-delay:0s}", ""]);

// exports
exports.locals = {
	"fade-in": "animate__fade-in__38FRS",
	"fadeIn": "animate__fade-in__38FRS",
	"fade-in-out": "animate__fade-in-out__2L0Lh",
	"fadeInOut": "animate__fade-in-out__2L0Lh",
	"active": "animate__active__3j9wN"
};

/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

var basePickBy = __webpack_require__(1647),
    hasIn = __webpack_require__(565);

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return basePickBy(object, paths, function(value, path) {
    return hasIn(object, path);
  });
}

module.exports = basePick;


/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(361),
    baseSet = __webpack_require__(1648),
    castPath = __webpack_require__(261);

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

module.exports = basePickBy;


/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(360),
    castPath = __webpack_require__(261),
    isIndex = __webpack_require__(246),
    isObject = __webpack_require__(41),
    toKey = __webpack_require__(191);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(1650),
    overRest = __webpack_require__(563),
    setToString = __webpack_require__(564);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(1214);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

var basePick = __webpack_require__(1646),
    flatRest = __webpack_require__(1649);

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = flatRest(function(object, paths) {
  return object == null ? {} : basePick(object, paths);
});

module.exports = pick;


/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = bindActionCreators;

var _redux = __webpack_require__(83);

var _wrapDispatch = __webpack_require__(1218);

var _wrapDispatch2 = _interopRequireDefault(_wrapDispatch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function bindActionCreators(actionCreators, dispatch, reducerKey) {
  var wrappedDispatch = (0, _wrapDispatch2.default)(dispatch, reducerKey);
  return (0, _redux.bindActionCreators)(actionCreators, wrappedDispatch);
}

/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var initAction = { type: '@@multireducer/INIT' };

exports.default = initAction;

/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = mapValues;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Maps all the values in the given object through the given function
 * and saves them, by key, to a result object
 */
function mapValues(obj, fn) {
  return Object.keys(obj).reduce(function (accumulator, key) {
    return _extends({}, accumulator, _defineProperty({}, key, fn(obj[key], key)));
  }, {});
}

/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = plainMultireducer;

var _mapValues = __webpack_require__(1654);

var _mapValues2 = _interopRequireDefault(_mapValues);

var _key = __webpack_require__(1216);

var _key2 = _interopRequireDefault(_key);

var _initAction = __webpack_require__(1653);

var _initAction2 = _interopRequireDefault(_initAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function plainMultireducer(reducers, reducerKey) {
  var isCustomMountPoint = void 0;
  if (typeof reducers === 'function') {
    if (!reducerKey) {
      throw new Error('No key specified for custom mounting of reducer');
    } else {
      isCustomMountPoint = true;
    }
  }

  var initialState = isCustomMountPoint ? reducers(undefined, _initAction2.default) : (0, _mapValues2.default)(reducers, function (reducer) {
    return reducer(undefined, _initAction2.default);
  });

  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    if (action && action.meta && action.meta[_key2.default]) {
      var actionReducerKey = action.meta[_key2.default];

      // custom mount point
      if (isCustomMountPoint && reducerKey === actionReducerKey) {
        return reducers(state, action);
      }

      // usual multireducer mounting
      var reducer = reducers[actionReducerKey];

      if (reducer) {
        return _extends({}, state, _defineProperty({}, actionReducerKey, reducer(state[actionReducerKey], action)));
      }
    }

    return state;
  };
}

/***/ }),
/* 1656 */,
/* 1657 */,
/* 1658 */,
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1634);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./scrollbar-wrapper.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./scrollbar-wrapper.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1660 */,
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1635);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./button.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./button.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1636);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./buttons-group.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./buttons-group.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1637);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./action-button.styl", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./action-button.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1638);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./closable-overlay.styl", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./closable-overlay.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1639);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./info.styl", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./info.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1640);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./progress-bar.styl", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./progress-bar.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1641);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./share.styl", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./share.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1642);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./title.styl", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./title.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1643);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./ui-wrapper.styl", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./ui-wrapper.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1644);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./player.styl", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./player.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1645);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./animate.styl", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./animate.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1624);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../css-loader/index.js??ref--6-1!../../../../../postcss-loader/index.js??ref--6-2!../../../../../sass-loader/lib/loader.js!./controls.scss", function() {
			var newContent = require("!!../../../../../css-loader/index.js??ref--6-1!../../../../../postcss-loader/index.js??ref--6-2!../../../../../sass-loader/lib/loader.js!./controls.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1625);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../css-loader/index.js??ref--6-1!../../../../../../postcss-loader/index.js??ref--6-2!../../../../../../sass-loader/lib/loader.js!./full-screen.scss", function() {
			var newContent = require("!!../../../../../../css-loader/index.js??ref--6-1!../../../../../../postcss-loader/index.js??ref--6-2!../../../../../../sass-loader/lib/loader.js!./full-screen.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1626);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../css-loader/index.js??ref--6-1!../../../../../../postcss-loader/index.js??ref--6-2!../../../../../../sass-loader/lib/loader.js!./play.scss", function() {
			var newContent = require("!!../../../../../../css-loader/index.js??ref--6-1!../../../../../../postcss-loader/index.js??ref--6-2!../../../../../../sass-loader/lib/loader.js!./play.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1627);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../css-loader/index.js??ref--6-1!../../../../../../postcss-loader/index.js??ref--6-2!../../../../../../sass-loader/lib/loader.js!./progress.scss", function() {
			var newContent = require("!!../../../../../../css-loader/index.js??ref--6-1!../../../../../../postcss-loader/index.js??ref--6-2!../../../../../../sass-loader/lib/loader.js!./progress.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1628);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../css-loader/index.js??ref--6-1!../../../../../../postcss-loader/index.js??ref--6-2!../../../../../../sass-loader/lib/loader.js!./time.scss", function() {
			var newContent = require("!!../../../../../../css-loader/index.js??ref--6-1!../../../../../../postcss-loader/index.js??ref--6-2!../../../../../../sass-loader/lib/loader.js!./time.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1677 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1629);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../css-loader/index.js??ref--6-1!../../../../../../postcss-loader/index.js??ref--6-2!../../../../../../sass-loader/lib/loader.js!./volume.scss", function() {
			var newContent = require("!!../../../../../../css-loader/index.js??ref--6-1!../../../../../../postcss-loader/index.js??ref--6-2!../../../../../../sass-loader/lib/loader.js!./volume.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1630);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../css-loader/index.js??ref--6-1!../../../../../postcss-loader/index.js??ref--6-2!../../../../../sass-loader/lib/loader.js!./loader.scss", function() {
			var newContent = require("!!../../../../../css-loader/index.js??ref--6-1!../../../../../postcss-loader/index.js??ref--6-2!../../../../../sass-loader/lib/loader.js!./loader.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1631);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../css-loader/index.js??ref--6-1!../../../../../postcss-loader/index.js??ref--6-2!../../../../../sass-loader/lib/loader.js!./overlay.scss", function() {
			var newContent = require("!!../../../../../css-loader/index.js??ref--6-1!../../../../../postcss-loader/index.js??ref--6-2!../../../../../sass-loader/lib/loader.js!./overlay.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1632);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../css-loader/index.js??ref--6-1!../../../../../postcss-loader/index.js??ref--6-2!../../../../../sass-loader/lib/loader.js!./screen.scss", function() {
			var newContent = require("!!../../../../../css-loader/index.js??ref--6-1!../../../../../postcss-loader/index.js??ref--6-2!../../../../../sass-loader/lib/loader.js!./screen.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1633);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../css-loader/index.js??ref--6-1!../../../../postcss-loader/index.js??ref--6-2!../../../../sass-loader/lib/loader.js!./ui.scss", function() {
			var newContent = require("!!../../../../css-loader/index.js??ref--6-1!../../../../postcss-loader/index.js??ref--6-2!../../../../sass-loader/lib/loader.js!./ui.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1682 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMSIgaGVpZ2h0PSIyMSIgdmlld0JveD0iMCAwIDIxIDIxIj4KICAgIDxwYXRoIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTQgMjFoMnYtNkgwdjJoNHY0ek02IDBINHY0SDB2Mmg2VjB6bTkgNmg2VjRoLTRWMGgtMnY2em0yIDExaDR2LTJoLTZ2Nmgydi00eiIvPgo8L3N2Zz4K"

/***/ }),
/* 1683 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE0IDE0Ij4KICAgIDxwYXRoIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTIgMTBIMHY0aDR2LTJIMnYtMnpNMCAxdjNoMlYyaDJWMEgwdjF6bTE0LTFoLTR2MmgydjJoMlYwem0tMiAxMmgtMnYyaDR2LTRoLTJ2MnoiLz4KPC9zdmc+Cg=="

/***/ }),
/* 1684 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNzFweCIgaGVpZ2h0PSI3MXB4IiB2aWV3Qm94PSIwIDAgNzEgNzEiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQxLjIgKDM1Mzk3KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5QbGF5X0NvdmVyXzJweDwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJQbGF5X0NvdmVyXzJweCI+CiAgICAgICAgICAgIDxjaXJjbGUgaWQ9Ik92YWwiIGZpbGwtb3BhY2l0eT0iMC4yIiBmaWxsPSIjMDAwMDAwIiBjeD0iMzUuNSIgY3k9IjM1LjUiIHI9IjM1LjUiPjwvY2lyY2xlPgogICAgICAgICAgICA8cGF0aCBkPSJNMzUuNSw2OSBDNTQuMDAxNTM5MSw2OSA2OSw1NC4wMDE1MzkxIDY5LDM1LjUgQzY5LDE2Ljk5ODQ2MDkgNTQuMDAxNTM5MSwyIDM1LjUsMiBDMTYuOTk4NDYwOSwyIDIsMTYuOTk4NDYwOSAyLDM1LjUgQzIsNTQuMDAxNTM5MSAxNi45OTg0NjA5LDY5IDM1LjUsNjkgWiBNMzUuNSw3MSBDMTUuODkzODkxNCw3MSAwLDU1LjEwNjEwODYgMCwzNS41IEMwLDE1Ljg5Mzg5MTQgMTUuODkzODkxNCwwIDM1LjUsMCBDNTUuMTA2MTA4NiwwIDcxLDE1Ljg5Mzg5MTQgNzEsMzUuNSBDNzEsNTUuMTA2MTA4NiA1NS4xMDYxMDg2LDcxIDM1LjUsNzEgWiIgaWQ9Ik92YWwiIGZpbGw9IiNGRkZGRkYiPjwvcGF0aD4KICAgICAgICAgICAgPHBvbHlnb24gaWQ9IlRyaWFuZ2xlIiBmaWxsPSIjRkZGRkZGIiBwb2ludHM9IjQ4IDM1LjUgMjggNDcgMjggMjQiPjwvcG9seWdvbj4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),
/* 1685 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDEwIDE0Ij4KICAgIDxwYXRoIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTcgMGgzdjE0SDdWMHpNMCAwaDN2MTRIMFYweiIvPgo8L3N2Zz4K"

/***/ }),
/* 1686 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMSIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDExIDE0Ij4KICAgIDxwYXRoIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTS4wNzkgMEwwIDE0bDEwLjUtNy4xODF6Ii8+Cjwvc3ZnPgo="

/***/ }),
/* 1687 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxMyIgdmlld0JveD0iMCAwIDE3IDE0Ij4KICAgIDxnIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTAgMy45MTloMi45OTN2NS45N0gwVjMuOTJ6bTIuOTk1LS4wMTVMNyAuOTI0djEyTDIuOTk1IDkuODgydi01Ljk4eiIvPgogICAgICAgIDxwYXRoIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTEzIDYuMjU3bC0yLjA1LTIuMDUtLjc0My43NDNMMTIuMjU3IDdsLTIuMDUgMi4wNS43NDMuNzQzTDEzIDcuNzQzbDIuMDUgMi4wNS43NDMtLjc0M0wxMy43NDMgN2wyLjA1LTIuMDUtLjc0My0uNzQzTDEzIDYuMjU3eiIvPgogICAgPC9nPgo8L3N2Zz4K"

/***/ }),
/* 1688 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNyIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE3IDE0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZmlsbD0iI0ZGRiIgZD0iTTAgMy45MTloMi45OTN2NS45N0gwVjMuOTJ6bTIuOTk1LS4wMTVMNyAuOTI0djEyTDIuOTk1IDkuODgydi01Ljk4eiIvPgogICAgICAgIDxwYXRoIHN0cm9rZT0iI0ZGRiIgZD0iTTEyLjc5MyAxMy43MTZhOS42MDcgOS42MDcgMCAwIDAgMC0xMy41ODZNOS44NTMgMTAuODM3YTUuNDUgNS40NSAwIDAgMCAwLTcuNzA3Ii8+CiAgICA8L2c+Cjwvc3ZnPgo="

/***/ }),
/* 1689 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNyIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE3IDE0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZmlsbD0iI0ZGRiIgZD0iTTAgMy45MTloMi45OTN2NS45N0gwVjMuOTJ6bTIuOTk1LS4wMTVMNyAuOTI0djEyTDIuOTk1IDkuODgydi01Ljk4eiIvPgogICAgICAgIDxwYXRoIHN0cm9rZT0iI0ZGRiIgZD0iTTkuODUzIDEwLjgzN2E1LjQ1IDUuNDUgMCAwIDAgMC03LjcwNyIvPgogICAgPC9nPgo8L3N2Zz4K"

/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(2);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(3);

var _inherits3 = _interopRequireDefault(_inherits2);

var _isString2 = __webpack_require__(248);

var _isString3 = _interopRequireDefault(_isString2);

var _noop2 = __webpack_require__(1215);

var _noop3 = _interopRequireDefault(_noop2);

var _pick2 = __webpack_require__(1651);

var _pick3 = _interopRequireDefault(_pick2);

var _isEqual2 = __webpack_require__(566);

var _isEqual3 = _interopRequireDefault(_isEqual2);

var _react = __webpack_require__(15);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(36);

var _videoPlayer = __webpack_require__(1223);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Wrapper = function (_React$Component) {
  (0, _inherits3.default)(Wrapper, _React$Component);

  function Wrapper(props) {
    (0, _classCallCheck3.default)(this, Wrapper);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Wrapper.__proto__ || (0, _getPrototypeOf2.default)(Wrapper)).call(this, props));

    _this.containerForCustomUI = document.createElement('div');

    _this.callProperPlaybackCallback = _this.callProperPlaybackCallback.bind(_this);
    _this.setPlayerNodeRef = _this.setPlayerNodeRef.bind(_this);
    _this.setChildrenContainerNodeRef = _this.setChildrenContainerNodeRef.bind(_this);
    _this.processFullScreenCallbackChange = _this.processFullScreenCallbackChange.bind(_this);

    _this.createPlayerInstance(props);
    _this.attachCallbacks(props);
    return _this;
  }

  (0, _createClass3.default)(Wrapper, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.appendPlayerNode();
      this.appendChildNodeToWrapper();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.updatePlayerBasicProps(nextProps);
      this.updatePlaybackStatus(nextProps);
      this.updatePlayerUI(nextProps);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unAttachCallbacks();
      this.player.destroy();
      this.containerForCustomUI = null;
    }
  }, {
    key: 'createPlayerInstance',
    value: function createPlayerInstance(props) {
      var size = (0, _pick3.default)(props, ['width', 'height']);

      var onPlaybackAnomaly = props.onPlaybackAnomaly;

      var logger = false;

      if (onPlaybackAnomaly) {
        logger = {
          callback: onPlaybackAnomaly
        };
      }

      var overlay = props.overlay || false;

      this.player = new Wrapper._Player((0, _extends3.default)({
        size: size
      }, (0, _pick3.default)(props, ['src', 'preload', 'autoPlay', 'loop', 'muted', 'volume', 'controls', 'playInline', 'loader', 'screen']), {
        overlay: overlay,
        logger: logger
      }));

      if (props.shouldTriggerPlay && props.shouldTriggerPause) {
        console.warn('VideoPlayerWrapper: shouldTriggerPause and shouldTriggerPause both true'); // eslint-disable-line no-console
      } else {
        if (props.shouldTriggerPlay) {
          this.player.play();
          if (props.isInFullScreen) {
            this.player.enterFullScreen();
          }
        }

        if (props.shouldTriggerPause) {
          this.player.pause();
        }
      }

      this.player.ui.screen.view.appendComponentNode(this.containerForCustomUI);
    }
  }, {
    key: 'attachCallbacks',
    value: function attachCallbacks(props) {
      this.player.on(_videoPlayer.VIDEO_EVENTS.ERROR, props.onError);
      this.player.on(_videoPlayer.VIDEO_EVENTS.STATE_CHANGED, this.callProperPlaybackCallback);

      this.player.on(_videoPlayer.UI_EVENTS.MUTE_STATUS_TRIGGERED, props.onMuteStatusChange);
      this.player.on(_videoPlayer.UI_EVENTS.VOLUME_CHANGE_TRIGGERED, props.onVolumeLevelChange);
      this.player.on(_videoPlayer.UI_EVENTS.FULLSCREEN_STATUS_CHANGED, this.processFullScreenCallbackChange);
    }
  }, {
    key: 'processFullScreenCallbackChange',
    value: function processFullScreenCallbackChange(status) {
      if (status) {
        this.props.onFullScreenEnter();
      } else {
        this.props.onFullScreenExit();
      }
    }
  }, {
    key: 'unAttachCallbacks',
    value: function unAttachCallbacks() {
      var props = this.props;


      this.player.off(_videoPlayer.VIDEO_EVENTS.ERROR, props.onError);
      this.player.off(_videoPlayer.VIDEO_EVENTS.STATE_CHANGED, this.callProperPlaybackCallback);

      this.player.off(_videoPlayer.UI_EVENTS.MUTE_STATUS_TRIGGERED, props.onMuteStatusChange);
      this.player.off(_videoPlayer.UI_EVENTS.VOLUME_CHANGE_TRIGGERED, props.onVolumeLevelChange);
      this.player.off(_videoPlayer.UI_EVENTS.FULLSCREEN_STATUS_CHANGED, this.processFullScreenCallbackChange);
    }
  }, {
    key: 'callProperPlaybackCallback',
    value: function callProperPlaybackCallback(_ref) {
      var state = _ref.nextState;
      var STATES = this.player._engine.STATES;

      if (state === STATES.PLAYING) {
        this.props.onPlay();
      }

      if (state === STATES.PAUSED) {
        this.props.onPause();
      }

      if (state === STATES.ENDED) {
        this.props.onEnd();
      }
    }
  }, {
    key: 'updatePlaybackStatus',
    value: function updatePlaybackStatus(_ref2) {
      var shouldTriggerPlay = _ref2.shouldTriggerPlay,
          shouldTriggerPause = _ref2.shouldTriggerPause,
          isInFullScreen = _ref2.isInFullScreen;

      if (shouldTriggerPlay && shouldTriggerPause) {
        console.warn('VideoPlayerWrapper: shouldTriggerPause and shouldTriggerPause both true'); // eslint-disable-line no-console

        return null;
      }

      if (shouldTriggerPlay && this.props.shouldTriggerPlay !== shouldTriggerPlay) {
        this.player.play();

        if (isInFullScreen && !this.player.isInFullScreen) {
          this.player.enterFullScreen();
        }
      }

      if (shouldTriggerPause && this.props.shouldTriggerPause !== shouldTriggerPause) {
        this.player.pause();
      }
    }
  }, {
    key: 'updatePlayerBasicProps',
    value: function updatePlayerBasicProps(_ref3) {
      var src = _ref3.src,
          autoPlay = _ref3.autoPlay,
          muted = _ref3.muted,
          loop = _ref3.loop,
          volume = _ref3.volume,
          preload = _ref3.preload,
          playInline = _ref3.playInline;

      if (!(0, _isEqual3.default)(this.props.src, src)) {
        this.player.setSrc(src);
      }

      if (this.props.autoPlay !== autoPlay) {
        this.player.setAutoPlay(autoPlay);
      }

      if (this.props.muted !== muted) {
        this.player.setMute(muted);
      }

      if (this.props.loop !== loop) {
        this.player.setLoop(loop);
      }

      if (this.props.volume !== volume) {
        this.player.setVolume(volume);
      }

      if (this.props.preload !== preload) {
        this.player.setPreload(preload);
      }

      if (this.props.playInline !== playInline) {
        this.player.setPlayInline(playInline);
      }
    }
  }, {
    key: 'updatePlayerUI',
    value: function updatePlayerUI(_ref4) {
      var width = _ref4.width,
          height = _ref4.height,
          isInFullScreen = _ref4.isInFullScreen;

      if (this.props.width !== width) {
        this.player.ui.setWidth(width);
      }

      if (this.props.height !== height) {
        this.player.ui.setHeight(height);
      }

      if (this.props.isInFullScreen !== isInFullScreen) {
        if (isInFullScreen) {
          this.player.enterFullScreen();
        } else {
          this.player.exitFullScreen();
        }
      }
    }
  }, {
    key: 'setPlayerNodeRef',
    value: function setPlayerNodeRef(node) {
      this.playerNode = node;
    }
  }, {
    key: 'setChildrenContainerNodeRef',
    value: function setChildrenContainerNodeRef(node) {
      this.childrenContainerNode = node;
    }
  }, {
    key: 'appendPlayerNode',
    value: function appendPlayerNode() {
      this.playerNode.appendChild(this.player.node);
    }
  }, {
    key: 'appendChildNodeToWrapper',
    value: function appendChildNodeToWrapper() {
      this.containerForCustomUI.appendChild(this.childrenContainerNode);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'section',
        null,
        _react2.default.createElement('section', { ref: this.setPlayerNodeRef }),
        _react2.default.createElement(
          'section',
          { ref: this.setChildrenContainerNodeRef },
          this.extendedChildren
        )
      );
    }
  }, {
    key: 'extendedChildren',
    get: function get() {
      var _this2 = this;

      var children = this.props.children;


      return _react2.default.Children.map(children, function (child) {
        if ((0, _isString3.default)(child.type)) {
          return child;
        }
        return _react2.default.cloneElement(child, {
          eventEmitter: _this2.player._eventEmitter,
          engine: _this2.player._engine,
          ui: _this2.player.ui
        });
      });
    }
  }]);
  return Wrapper;
}(_react2.default.Component);

Wrapper._Player = _videoPlayer.Player;
Wrapper.propTypes = {
  width: _propTypes.number,
  height: _propTypes.number,

  src: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.array]),

  autoPlay: _propTypes.bool,
  muted: _propTypes.bool,
  loop: _propTypes.bool,
  volume: _propTypes.number,
  preload: _propTypes.string,
  playInline: _propTypes.bool,

  overlay: _propTypes.any,
  loader: _propTypes.any,
  screen: _propTypes.any,
  controls: _propTypes.any,

  shouldTriggerPlay: _propTypes.bool,
  shouldTriggerPause: _propTypes.bool,
  isInFullScreen: _propTypes.bool,

  onPlaybackAnomaly: _propTypes.func,

  onPlay: _propTypes.func,
  onPause: _propTypes.func,
  onEnd: _propTypes.func,
  onMuteStatusChange: _propTypes.func,
  onVolumeLevelChange: _propTypes.func,
  onFullScreenEnter: _propTypes.func,
  onFullScreenExit: _propTypes.func
};
Wrapper.defaultProps = {
  onPlay: _noop3.default,
  onPause: _noop3.default,
  onEnd: _noop3.default,

  onPlaybackAnomaly: _noop3.default,

  onMuteStatusChange: _noop3.default,
  onFullScreenEnter: _noop3.default,
  onFullScreenExit: _noop3.default,
  onVolumeLevelChange: _noop3.default
};
exports.default = Wrapper;
//# sourceMappingURL=wrapper.js.map


/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var keyboardAllowed = typeof Element !== 'undefined' && 'ALLOW_KEYBOARD_INPUT' in Element;

var fnMap = [['requestFullscreen', 'exitFullscreen', 'fullscreenElement', 'fullscreenEnabled', 'fullscreenchange', 'fullscreenerror'],
// new WebKit
['webkitRequestFullscreen', 'webkitExitFullscreen', 'webkitFullscreenElement', 'webkitFullscreenEnabled', 'webkitfullscreenchange', 'webkitfullscreenerror'],
// old WebKit (Safari 5.1)
['webkitRequestFullScreen', 'webkitCancelFullScreen', 'webkitCurrentFullScreenElement', 'webkitCancelFullScreen', 'webkitfullscreenchange', 'webkitfullscreenerror'], ['mozRequestFullScreen', 'mozCancelFullScreen', 'mozFullScreenElement', 'mozFullScreenEnabled', 'mozfullscreenchange', 'mozfullscreenerror'], ['msRequestFullscreen', 'msExitFullscreen', 'msFullscreenElement', 'msFullscreenEnabled', 'MSFullscreenChange', 'MSFullscreenError']];

/* ignore coverage */
function getFullScreenFn() {
  var ret = {};

  for (var i = 0; i < fnMap.length; i += 1) {
    if (fnMap[i][1] in document) {
      for (var j = 0; j < fnMap[i].length; j += 1) {
        ret[fnMap[0][j]] = fnMap[i][j];
      }
      return ret;
    }
  }

  return false;
}

var DesktopFullScreen = function () {
  function DesktopFullScreen(elem, callback) {
    _classCallCheck(this, DesktopFullScreen);

    this._elem = elem;
    this._callback = callback;
    this._fullscreenFn = getFullScreenFn();

    this._bindEvents();
  }

  _createClass(DesktopFullScreen, [{
    key: '_bindEvents',
    value: function _bindEvents() {
      document.addEventListener(this._fullscreenFn.fullscreenchange, this._callback);
    }
  }, {
    key: '_unbindEvents',
    value: function _unbindEvents() {
      document.removeEventListener(this._fullscreenFn.fullscreenchange, this._callback);
    }
  }, {
    key: 'request',
    value: function request() {
      if (!this.isEnabled) {
        return;
      }

      var request = this._fullscreenFn.requestFullscreen;

      // Work around Safari 5.1 bug: reports support for
      // keyboard in fullscreen even though it doesn't.
      // Browser sniffing, since the alternative with
      // setTimeout is even worse.

      if (/5\.1[.\d]* Safari/.test(navigator.userAgent)) {
        this._elem[request]();
      } else {
        this._elem[request](keyboardAllowed && Element.ALLOW_KEYBOARD_INPUT);
      }
    }
  }, {
    key: 'exit',
    value: function exit() {
      document[this._fullscreenFn.exitFullscreen]();
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this._unbindEvents();

      delete this._elem;
      delete this._callback;
    }
  }, {
    key: 'isAPIExist',
    get: function get() {
      return Boolean(this._fullscreenFn);
    }
  }, {
    key: 'isInFullScreen',
    get: function get() {
      return Boolean(document[this._fullscreenFn.fullscreenElement]);
    }
  }, {
    key: 'isEnabled',
    get: function get() {
      return Boolean(document[this._fullscreenFn.fullscreenEnabled]);
    }
  }]);

  return DesktopFullScreen;
}();

exports.default = DesktopFullScreen;
//# sourceMappingURL=desktop.js.map


/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _deviceDetection = __webpack_require__(1234);

var _desktop = __webpack_require__(1691);

var _desktop2 = _interopRequireDefault(_desktop);

var _ios = __webpack_require__(1693);

var _ios2 = _interopRequireDefault(_ios);

var _ui = __webpack_require__(153);

var _ui2 = _interopRequireDefault(_ui);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FullScreenManager = function () {
  function FullScreenManager(_ref) {
    var eventEmitter = _ref.eventEmitter,
        engine = _ref.engine,
        ui = _ref.ui;

    _classCallCheck(this, FullScreenManager);

    this._eventEmitter = eventEmitter;

    this._onChange = this._onChange.bind(this);

    if (_deviceDetection.iPhone || _deviceDetection.iPod || _deviceDetection.iPad) {
      this._helper = new _ios2.default(engine.getNode(), this._onChange);
    } else {
      this._helper = new _desktop2.default(ui.view.getNode(), this._onChange);
    }

    this._bindEvents();
  }

  _createClass(FullScreenManager, [{
    key: '_onChange',
    value: function _onChange() {
      this._eventEmitter.emit(_ui2.default.FULLSCREEN_STATUS_CHANGED, this._helper.isInFullScreen);
    }
  }, {
    key: '_bindEvents',
    value: function _bindEvents() {
      this._eventEmitter.on(_ui2.default.FULLSCREEN_ENTER_TRIGGERED, this.enterFullScreen, this);
      this._eventEmitter.on(_ui2.default.FULLSCREEN_EXIT_TRIGGERED, this.exitFullScreen, this);
    }
  }, {
    key: '_unbindEvents',
    value: function _unbindEvents() {
      this._eventEmitter.off(_ui2.default.FULLSCREEN_ENTER_TRIGGERED, this.enterFullScreen, this);
      this._eventEmitter.off(_ui2.default.FULLSCREEN_EXIT_TRIGGERED, this.exitFullScreen, this);
    }
  }, {
    key: 'enterFullScreen',
    value: function enterFullScreen() {
      this._helper.request();
    }
  }, {
    key: 'exitFullScreen',
    value: function exitFullScreen() {
      this._helper.exit();
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this._unbindEvents();

      this._helper.destroy();
    }
  }, {
    key: 'isInFullScreen',
    get: function get() {
      return this._helper.isInFullScreen;
    }
  }]);

  return FullScreenManager;
}();

exports.default = FullScreenManager;
//# sourceMappingURL=full-screen.js.map


/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HAVE_METADATA = 1;

var isFullScreenRequested = false;

var IOSFullScreen = function () {
  function IOSFullScreen(elem, callback) {
    _classCallCheck(this, IOSFullScreen);

    this._elem = elem;
    this._callback = callback;

    this._bindEvents();
  }

  _createClass(IOSFullScreen, [{
    key: '_bindEvents',
    value: function _bindEvents() {
      this._elem.addEventListener('webkitbeginfullscreen', this._callback);
      this._elem.addEventListener('webkitendfullscreen', this._callback);
    }
  }, {
    key: '_unbindEvents',
    value: function _unbindEvents() {
      this._elem.removeEventListener('webkitbeginfullscreen', this._callback);
      this._elem.removeEventListener('webkitendfullscreen', this._callback);

      this._elem.removeEventListener('loadedmetadata', this._enterWhenHasMetaData);
    }
  }, {
    key: '_enterWhenHasMetaData',
    value: function _enterWhenHasMetaData() {
      this._elem.removeEventListener('loadedmetadata', this._enterWhenHasMetaData);

      isFullScreenRequested = false;

      this._elem.webkitEnterFullscreen();
    }
  }, {
    key: 'request',
    value: function request() {
      if (!this.isEnabled || this.isInFullScreen) {
        return false;
      }

      try {
        this._elem.webkitEnterFullscreen();
      } catch (e) {
        if (this._elem.readyState < HAVE_METADATA) {
          if (isFullScreenRequested) {
            return;
          }
          this._elem.addEventListener('loadedmetadata', this._enterWhenHasMetaData);
          isFullScreenRequested = true;
        }
      }
    }
  }, {
    key: 'exit',
    value: function exit() {
      if (!this.isAPIExist || !this.isInFullScreen) {
        return false;
      }

      this._elem.webkitExitFullscreen();
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this._unbindEvents();

      delete this._elem;
      delete this._callback;
    }
  }, {
    key: 'isAPIExist',
    get: function get() {
      return Boolean(this._elem && this._elem.webkitSupportsFullscreen);
    }
  }, {
    key: 'isInFullScreen',
    get: function get() {
      return Boolean(this._elem && this._elem.webkitDisplayingFullscreen);
    }
  }, {
    key: 'isEnabled',
    get: function get() {
      return this.isAPIExist;
    }
  }]);

  return IOSFullScreen;
}();

exports.default = IOSFullScreen;
//# sourceMappingURL=ios.js.map


/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _eventemitter = __webpack_require__(637);

var _eventemitter2 = _interopRequireDefault(_eventemitter);

var _deviceDetection = __webpack_require__(1234);

var _ui = __webpack_require__(1705);

var _ui2 = _interopRequireDefault(_ui);

var _playbackEngine = __webpack_require__(1224);

var _playbackEngine2 = _interopRequireDefault(_playbackEngine);

var _anomalyBloodhound = __webpack_require__(1222);

var _anomalyBloodhound2 = _interopRequireDefault(_anomalyBloodhound);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Player = function () {
  function Player(config) {
    _classCallCheck(this, Player);

    this._config = config;

    var _config = this._config,
        preload = _config.preload,
        autoPlay = _config.autoPlay,
        loop = _config.loop,
        muted = _config.muted,
        volume = _config.volume,
        src = _config.src,
        size = _config.size,
        playInline = _config.playInline,
        controls = _config.controls,
        overlay = _config.overlay,
        loader = _config.loader,
        logger = _config.logger,
        screen = _config.screen,
        _config$customUI = _config.customUI,
        customUI = _config$customUI === undefined ? {} : _config$customUI;


    this.play = this.play.bind(this);
    this.pause = this.pause.bind(this);

    this._eventEmitter = new _eventemitter2.default();
    this._engine = new _playbackEngine2.default({
      eventEmitter: this._eventEmitter
    });

    this._createUI(size, controls, overlay, loader, screen, customUI);

    if (logger) {
      this._anomalyBloodhound = new _anomalyBloodhound2.default({
        eventEmitter: this._eventEmitter,
        engine: this._engine,
        config: logger
      });
    }

    this.setPreload(preload);

    if (autoPlay) {
      this.setAutoPlay(true);
    }

    if (loop) {
      this.setLoop(true);
    }

    if (muted) {
      this.setMute(true);
    }

    if (volume) {
      this.setVolume(volume);
    }

    if (playInline) {
      this.setPlayInline(playInline);
    }

    if (src) {
      this.setSrc(src);
    }
  }

  _createClass(Player, [{
    key: '_createUI',
    value: function _createUI(size, controls, overlay, loader, screen, customUI) {
      var config = _extends({}, size, {
        overlay: overlay,
        screen: screen,
        customUI: customUI
      });

      if (_deviceDetection.iPhone || _deviceDetection.iPod || _deviceDetection.Android) {
        config.screen = _extends({}, screen, {
          indicateScreenClick: false,
          disableClickProcessing: true,
          nativeControls: true
        });
        config.loader = false;
        config.controls = false;
      } else {
        config.loader = loader;
        config.controls = controls;
      }

      this.ui = new _ui2.default({
        engine: this._engine,
        eventEmitter: this._eventEmitter,
        config: config
      });
    }
  }, {
    key: 'setAutoPlay',
    value: function setAutoPlay(isAutoPlay) {
      this._engine.setAutoPlay(isAutoPlay);
    }
  }, {
    key: 'getAutoPlay',
    value: function getAutoPlay() {
      return this._engine.getAutoPlay();
    }
  }, {
    key: 'setLoop',
    value: function setLoop(isLoop) {
      this._engine.setLoop(isLoop);
    }
  }, {
    key: 'getLoop',
    value: function getLoop() {
      return this._engine.getLoop();
    }
  }, {
    key: 'setMute',
    value: function setMute(isMuted) {
      this._engine.setMute(isMuted);
    }
  }, {
    key: 'getMute',
    value: function getMute() {
      return this._engine.getMute();
    }
  }, {
    key: 'setVolume',
    value: function setVolume(volume) {
      this._engine.setVolume(volume);
    }
  }, {
    key: 'getVolume',
    value: function getVolume() {
      return this._engine.getVolume();
    }
  }, {
    key: 'setPreload',
    value: function setPreload(preload) {
      this._engine.setPreload(preload);
    }
  }, {
    key: 'getPreload',
    value: function getPreload() {
      return this._engine.getPreload();
    }
  }, {
    key: 'setSrc',
    value: function setSrc(src) {
      this._engine.setSrc(src);
    }
  }, {
    key: 'setPlayInline',
    value: function setPlayInline(isPlayInline) {
      this._engine.setPlayInline(isPlayInline);
    }
  }, {
    key: 'getPlayInline',
    value: function getPlayInline() {
      this._engine.getPlayInline();
    }
  }, {
    key: 'on',
    value: function on(name, callback) {
      this._eventEmitter.on(name, callback);
    }
  }, {
    key: 'off',
    value: function off(name, callback) {
      this._eventEmitter.off(name, callback);
    }
  }, {
    key: 'play',
    value: function play() {
      this._engine.play();
    }
  }, {
    key: 'pause',
    value: function pause() {
      this._engine.pause();
    }
  }, {
    key: '_unbindAllEvents',
    value: function _unbindAllEvents() {
      var _this = this;

      var eventsName = this._eventEmitter.eventNames();

      eventsName.forEach(function (eventName) {
        _this._eventEmitter.removeAllListeners(eventName);
      });
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.ui.destroy();
      delete this.ui;

      this._unbindAllEvents();
      delete this._eventEmitter;

      this._engine.destroy();
      delete this._engine;

      if (this._anomalyBloodhound) {
        this._anomalyBloodhound.destroy();
        delete this._anomalyBloodhound;
      }
    }
  }, {
    key: 'node',
    get: function get() {
      if (!this.ui) {
        return;
      }

      return this.ui.node;
    }
  }]);

  return Player;
}();

exports.default = Player;
//# sourceMappingURL=player.js.map


/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jbone = __webpack_require__(151);

var _jbone2 = _interopRequireDefault(_jbone);

var _view = __webpack_require__(155);

var _view2 = _interopRequireDefault(_view);

var _controls = __webpack_require__(1672);

var _controls2 = _interopRequireDefault(_controls);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ControlsView = function (_View) {
  _inherits(ControlsView, _View);

  function ControlsView(config) {
    _classCallCheck(this, ControlsView);

    var _this = _possibleConstructorReturn(this, (ControlsView.__proto__ || Object.getPrototypeOf(ControlsView)).call(this, config));

    var callbacks = config.callbacks;


    _this._callbacks = callbacks;
    _this.$node = (0, _jbone2.default)('<div>', {
      class: _this.styleNames['controls-block'],
      'data-hook': 'controls-block',
      tabIndex: 0
    });

    _this.$wrapper = (0, _jbone2.default)('<div>', {
      class: _this.styleNames['controls-wrapper'],
      tabIndex: 0
    });

    var background = (0, _jbone2.default)('<div>', {
      class: _this.styleNames['gradient-background']
    });

    _this.$controlsContainer = (0, _jbone2.default)('<div>', {
      class: _this.styleNames.controls,
      'data-hook': 'controls-container'
    });

    _this.$wrapper.append(background).append(_this.$controlsContainer);

    _this.$node.append(_this.$wrapper);

    _this._bindEvents();
    return _this;
  }

  _createClass(ControlsView, [{
    key: '_preventClickPropagation',
    value: function _preventClickPropagation(e) {
      e.stopPropagation();
    }
  }, {
    key: '_bindEvents',
    value: function _bindEvents() {
      this.$controlsContainer[0].addEventListener('click', this._preventClickPropagation);
      this.$controlsContainer[0].addEventListener('mousemove', this._callbacks.onControlsBlockMouseMove);
      this.$controlsContainer[0].addEventListener('mouseleave', this._callbacks.onControlsBlockMouseOut);
    }
  }, {
    key: '_unbindEvents',
    value: function _unbindEvents() {
      this.$controlsContainer[0].removeEventListener('click', this._preventClickPropagation);
      this.$controlsContainer[0].removeEventListener('mousemove', this._callbacks.onControlsBlockMouseMove);
      this.$controlsContainer[0].removeEventListener('mouseleave', this._callbacks.onControlsBlockMouseOut);
    }
  }, {
    key: 'show',
    value: function show() {
      this.$node.toggleClass(this.styleNames.hidden, false);
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.$node.toggleClass(this.styleNames.hidden, true);
    }
  }, {
    key: 'getNode',
    value: function getNode() {
      return this.$node[0];
    }
  }, {
    key: 'appendControlNode',
    value: function appendControlNode(node) {
      this.$controlsContainer.append(node);
    }
  }, {
    key: 'showControlsBlock',
    value: function showControlsBlock() {
      this.$wrapper.toggleClass(this.styleNames.activated, true);
    }
  }, {
    key: 'hideControlsBlock',
    value: function hideControlsBlock() {
      this.$wrapper.toggleClass(this.styleNames.activated, false);
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this._unbindEvents();
      this.$node.remove();

      delete this.$wrapper;
      delete this.$controlsContainer;
      delete this.$node;
    }
  }]);

  return ControlsView;
}(_view2.default);

ControlsView.extendStyleNames(_controls2.default);

exports.default = ControlsView;
//# sourceMappingURL=controls.view.js.map


/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _progress = __webpack_require__(1228);

var _progress2 = _interopRequireDefault(_progress);

var _play = __webpack_require__(1227);

var _play2 = _interopRequireDefault(_play);

var _time = __webpack_require__(1229);

var _time2 = _interopRequireDefault(_time);

var _volume = __webpack_require__(1230);

var _volume2 = _interopRequireDefault(_volume);

var _fullScreen = __webpack_require__(1226);

var _fullScreen2 = _interopRequireDefault(_fullScreen);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  PlayControl: _play2.default,
  ProgressControl: _progress2.default,
  TimeControl: _time2.default,
  VolumeControl: _volume2.default,
  FullscreenControl: _fullScreen2.default
};
//# sourceMappingURL=default-controls.js.map


/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jbone = __webpack_require__(151);

var _jbone2 = _interopRequireDefault(_jbone);

var _view = __webpack_require__(155);

var _view2 = _interopRequireDefault(_view);

var _fullScreen = __webpack_require__(1673);

var _fullScreen2 = _interopRequireDefault(_fullScreen);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var translations = {
  enterFullScreen: 'Full screen',
  exitFullScreen: 'Exit Full screen'
};

var FullScreenView = function (_View) {
  _inherits(FullScreenView, _View);

  function FullScreenView(config) {
    _classCallCheck(this, FullScreenView);

    var _this = _possibleConstructorReturn(this, (FullScreenView.__proto__ || Object.getPrototypeOf(FullScreenView)).call(this, config));

    var callbacks = config.callbacks;


    _this._callbacks = callbacks;
    _this.$node = (0, _jbone2.default)('<div>', {
      class: _this.styleNames['full-screen-control'],
      'data-hook': 'full-screen-control',
      'data-tooltip-pos': 'up'
    });

    _this.$toggleFullScreenControl = (0, _jbone2.default)('<div>', {
      class: _this.styleNames['full-screen-toggle'] + ' ' + _this.styleNames.icon,
      'data-hook': 'full-screen-button'
    });

    _this.$node.append(_this.$toggleFullScreenControl);

    _this.setState({ isInFullScreen: false });
    _this._bindEvents();
    return _this;
  }

  _createClass(FullScreenView, [{
    key: '_bindEvents',
    value: function _bindEvents() {
      this.$toggleFullScreenControl[0].addEventListener('click', this._callbacks.onToggleFullScreenButtonClick);
    }
  }, {
    key: '_unbindEvents',
    value: function _unbindEvents() {
      this.$toggleFullScreenControl[0].removeEventListener('click', this._callbacks.onToggleFullScreenButtonClick);
    }
  }, {
    key: 'setState',
    value: function setState(_ref) {
      var isInFullScreen = _ref.isInFullScreen;

      this.$toggleFullScreenControl.toggleClass(this.styleNames['in-full-screen'], isInFullScreen);
      this.$node.attr('data-tooltip', isInFullScreen ? this.translations.exitFullScreen : this.translations.enterFullScreen);
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.$node.toggleClass(this.styleNames.hidden, true);
    }
  }, {
    key: 'show',
    value: function show() {
      this.$node.toggleClass(this.styleNames.hidden, false);
    }
  }, {
    key: 'getNode',
    value: function getNode() {
      return this.$node[0];
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this._unbindEvents();
      this.$node.remove();

      delete this.$toggleFullScreenControl;
      delete this.$node;
    }
  }]);

  return FullScreenView;
}(_view2.default);

FullScreenView.extendStyleNames(_fullScreen2.default);
FullScreenView.extendTranslations(translations);

exports.default = FullScreenView;
//# sourceMappingURL=full-screen.view.js.map


/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jbone = __webpack_require__(151);

var _jbone2 = _interopRequireDefault(_jbone);

var _view = __webpack_require__(155);

var _view2 = _interopRequireDefault(_view);

var _play = __webpack_require__(1674);

var _play2 = _interopRequireDefault(_play);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PlayView = function (_View) {
  _inherits(PlayView, _View);

  function PlayView(config) {
    _classCallCheck(this, PlayView);

    var _this = _possibleConstructorReturn(this, (PlayView.__proto__ || Object.getPrototypeOf(PlayView)).call(this, config));

    var callbacks = config.callbacks;


    _this._callbacks = callbacks;
    _this.$node = (0, _jbone2.default)('<div>', {
      class: _this.styleNames['play-control'],
      'data-hook': 'playback-control'
    });

    _this.$playbackControl = (0, _jbone2.default)('<div>', {
      class: _this.styleNames['playback-toggle'] + ' ' + _this.styleNames.icon,
      'data-hook': 'toggle-playback-button'
    });

    _this.$node.append(_this.$playbackControl);

    _this._bindEvents();
    return _this;
  }

  _createClass(PlayView, [{
    key: '_bindEvents',
    value: function _bindEvents() {
      this.$playbackControl[0].addEventListener('click', this._callbacks.onTogglePlaybackButtonClick);
    }
  }, {
    key: '_unbindEvents',
    value: function _unbindEvents() {
      this.$playbackControl[0].removeEventListener('click', this._callbacks.onTogglePlaybackButtonClick);
    }
  }, {
    key: 'setState',
    value: function setState(_ref) {
      var isPlaying = _ref.isPlaying;

      this.$playbackControl.toggleClass(this.styleNames.paused, !isPlaying);
    }
  }, {
    key: 'show',
    value: function show() {
      this.$node.toggleClass(this.styleNames.hidden, false);
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.$node.toggleClass(this.styleNames.hidden, true);
    }
  }, {
    key: 'getNode',
    value: function getNode() {
      return this.$node[0];
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this._unbindEvents();
      this.$node.remove();

      delete this.$playbackControl;
      delete this.$node;
    }
  }]);

  return PlayView;
}(_view2.default);

PlayView.extendStyleNames(_play2.default);

exports.default = PlayView;
//# sourceMappingURL=play.view.js.map


/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jbone = __webpack_require__(151);

var _jbone2 = _interopRequireDefault(_jbone);

var _view = __webpack_require__(155);

var _view2 = _interopRequireDefault(_view);

var _progress = __webpack_require__(1675);

var _progress2 = _interopRequireDefault(_progress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProgressView = function (_View) {
  _inherits(ProgressView, _View);

  function ProgressView(config) {
    _classCallCheck(this, ProgressView);

    var _this = _possibleConstructorReturn(this, (ProgressView.__proto__ || Object.getPrototypeOf(ProgressView)).call(this, config));

    var callbacks = config.callbacks;


    _this._callbacks = callbacks;
    _this.$node = (0, _jbone2.default)('<div>', {
      class: _this.styleNames['seek-block'],
      'data-hook': 'progress-control'
    });

    _this.$played = (0, _jbone2.default)('<progress>', {
      class: _this.styleNames['progress-bar'] + ' ' + _this.styleNames['progress-played'],
      'data-hook': 'played-indicator',
      role: 'played',
      max: 100,
      value: 0
    });

    _this.$buffered = (0, _jbone2.default)('<progress>', {
      class: _this.styleNames['progress-bar'] + ' ' + _this.styleNames['progress-buffered'],
      'data-hook': 'buffered-indicator',
      role: 'buffered',
      max: 100,
      value: 0
    });

    _this.$input = (0, _jbone2.default)('<input>', {
      class: _this.styleNames['seek-control'],
      'data-hook': 'seek-input',
      type: 'range',
      min: 0,
      max: 100,
      step: 0.1,
      value: 0
    });

    _this.$node.append(_this.$buffered).append(_this.$played).append(_this.$input);

    _this._bindCallbacks();
    _this._bindEvents();
    return _this;
  }

  _createClass(ProgressView, [{
    key: '_onMouseInteractionStart',
    value: function _onMouseInteractionStart(e) {
      if (e.button > 1) {
        return;
      }

      this._callbacks.onUserInteractionStart();
    }
  }, {
    key: '_onMouseInteractionEnd',
    value: function _onMouseInteractionEnd(e) {
      if (e.button > 1) {
        return;
      }

      this._callbacks.onUserInteractionEnd();
    }
  }, {
    key: '_onInputValueChange',
    value: function _onInputValueChange() {
      var value = this.$input.val();
      this.$played.attr('value', value);
      this._callbacks.onChangePlayedProgress(value);
    }
  }, {
    key: '_bindCallbacks',
    value: function _bindCallbacks() {
      this._onMouseInteractionStart = this._onMouseInteractionStart.bind(this);
      this._onMouseInteractionEnd = this._onMouseInteractionEnd.bind(this);
      this._onInputValueChange = this._onInputValueChange.bind(this);
    }
  }, {
    key: '_bindEvents',
    value: function _bindEvents() {
      this.$input[0].addEventListener('input', this._onInputValueChange);
      this.$input[0].addEventListener('change', this._onInputValueChange);

      this.$node[0].addEventListener('mousedown', this._onMouseInteractionStart);
      this.$node[0].addEventListener('mouseup', this._onMouseInteractionEnd);
    }
  }, {
    key: '_unbindEvents',
    value: function _unbindEvents() {
      this.$input[0].removeEventListener('input', this._onInputValueChange);
      this.$input[0].removeEventListener('change', this._onInputValueChange);

      this.$node[0].removeEventListener('mousedown', this._onMouseInteractionStart);
      this.$node[0].removeEventListener('mouseup', this._onMouseInteractionEnd);
    }
  }, {
    key: '_updatePlayed',
    value: function _updatePlayed(percent) {
      this.$input.val(percent);
      this.$input.attr('value', percent);
      this.$played.attr('value', percent);
    }
  }, {
    key: '_updateBuffered',
    value: function _updateBuffered(percent) {
      this.$buffered.attr('value', percent);
    }
  }, {
    key: 'setState',
    value: function setState(_ref) {
      var played = _ref.played,
          buffered = _ref.buffered;

      played !== undefined && this._updatePlayed(played);
      buffered !== undefined && this._updateBuffered(buffered);
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.$node.toggleClass(this.styleNames.hidden, true);
    }
  }, {
    key: 'show',
    value: function show() {
      this.$node.toggleClass(this.styleNames.hidden, false);
    }
  }, {
    key: 'getNode',
    value: function getNode() {
      return this.$node[0];
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this._unbindEvents();
      this.$node.remove();

      delete this.$input;
      delete this.$played;
      delete this.$buffered;
      delete this.$node;
    }
  }]);

  return ProgressView;
}(_view2.default);

ProgressView.extendStyleNames(_progress2.default);

exports.default = ProgressView;
//# sourceMappingURL=progress.view.js.map


/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.formatTime = formatTime;

var _jbone = __webpack_require__(151);

var _jbone2 = _interopRequireDefault(_jbone);

var _view = __webpack_require__(155);

var _view2 = _interopRequireDefault(_view);

var _time = __webpack_require__(1676);

var _time2 = _interopRequireDefault(_time);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function formatTime(seconds) {
  var date = new Date(null);
  seconds = isNaN(seconds) || !isFinite(seconds) ? 0 : Math.floor(seconds);
  date.setSeconds(seconds);

  // get HH:mm:ss part, remove hours if they are "00:"
  return date.toISOString().substr(11, 8).replace(/^00:/, '');
}

var TimeView = function (_View) {
  _inherits(TimeView, _View);

  function TimeView(config) {
    _classCallCheck(this, TimeView);

    var _this = _possibleConstructorReturn(this, (TimeView.__proto__ || Object.getPrototypeOf(TimeView)).call(this, config));

    _this.$node = (0, _jbone2.default)('<div>', {
      class: _this.styleNames['time-wrapper'],
      'data-hook': 'time-control'
    });

    _this.$currentTime = (0, _jbone2.default)('<span>', {
      class: _this.styleNames.current + ' ' + _this.styleNames.time,
      'data-hook': 'current-time-indicator'
    });

    _this.$divider = (0, _jbone2.default)('<span>', {
      class: _this.styleNames.time
    }).html('/');

    _this.$durationTime = (0, _jbone2.default)('<span>', {
      class: _this.styleNames.duration + ' ' + _this.styleNames.time,
      'data-hook': 'duration-time-indicator'
    });

    _this.$node.append(_this.$currentTime).append(_this.$divider).append(_this.$durationTime);
    return _this;
  }

  _createClass(TimeView, [{
    key: 'setState',
    value: function setState(_ref) {
      var duration = _ref.duration,
          current = _ref.current;

      duration !== undefined && this._setDurationTime(duration);
      current !== undefined && this._setCurrentTime(current);
    }
  }, {
    key: '_setDurationTime',
    value: function _setDurationTime(duration) {
      this.$durationTime.html(formatTime(duration));
    }
  }, {
    key: '_setCurrentTime',
    value: function _setCurrentTime(current) {
      this.$currentTime.html(formatTime(current));
    }
  }, {
    key: 'show',
    value: function show() {
      this.$node.toggleClass(this.styleNames.hidden, false);
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.$node.toggleClass(this.styleNames.hidden, true);
    }
  }, {
    key: 'getNode',
    value: function getNode() {
      return this.$node[0];
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.$node.remove();

      delete this.$currentTime;
      delete this.$divider;
      delete this.$durationTime;
      delete this.$node;
    }
  }]);

  return TimeView;
}(_view2.default);

TimeView.extendStyleNames(_time2.default);

exports.default = TimeView;
//# sourceMappingURL=time.view.js.map


/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jbone = __webpack_require__(151);

var _jbone2 = _interopRequireDefault(_jbone);

var _view = __webpack_require__(155);

var _view2 = _interopRequireDefault(_view);

var _volume = __webpack_require__(1677);

var _volume2 = _interopRequireDefault(_volume);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_VOLUME_ICON_RANGE = 30;

var VolumeView = function (_View) {
  _inherits(VolumeView, _View);

  function VolumeView(config) {
    _classCallCheck(this, VolumeView);

    var _this = _possibleConstructorReturn(this, (VolumeView.__proto__ || Object.getPrototypeOf(VolumeView)).call(this, config));

    var callbacks = config.callbacks;


    _this._callbacks = callbacks;
    _this.$node = (0, _jbone2.default)('<div>', {
      class: _this.styleNames['volume-control'],
      'data-hook': 'volume-control'
    });

    _this.$muteControl = (0, _jbone2.default)('<div>', {
      class: _this.styleNames['mute-button'] + ' ' + _this.styleNames.icon,
      'data-hook': 'mute-button'
    });

    _this.$container = (0, _jbone2.default)('<div>', {
      class: _this.styleNames.container
    });

    var $content = (0, _jbone2.default)('<div>', {
      class: _this.styleNames.content
    });

    var $inputWrapper = (0, _jbone2.default)('<div>', {
      class: _this.styleNames['input-wrapper']
    });

    _this.$filledProgress = (0, _jbone2.default)('<div>', {
      class: _this.styleNames['filled-progress']
    });

    _this.$input = (0, _jbone2.default)('<input>', {
      class: '' + _this.styleNames['volume-input'],
      'data-hook': 'volume-input',
      orient: 'vertical',
      type: 'range',
      min: 0,
      max: 100,
      step: 0.1,
      value: 0
    });

    $inputWrapper.append(_this.$filledProgress).append(_this.$input);

    $content.append($inputWrapper);
    _this.$container.append($content);

    _this.$node.append(_this.$muteControl).append(_this.$container);

    _this._bindEvents();
    return _this;
  }

  _createClass(VolumeView, [{
    key: '_onInputChange',
    value: function _onInputChange() {
      this._callbacks.onVolumeLevelChangeFromInput(this.$input.val());
    }
  }, {
    key: '_onWheel',
    value: function _onWheel(e) {
      e.preventDefault();

      if (!e.deltaY) {
        return;
      }

      this._callbacks.onVolumeLevelChangeFromWheel(e.deltaY);
    }
  }, {
    key: '_preventClickPropagation',
    value: function _preventClickPropagation(event) {
      event.stopPropagation();
    }
  }, {
    key: '_bindEvents',
    value: function _bindEvents() {
      this._onInputChange = this._onInputChange.bind(this);
      this._onWheel = this._onWheel.bind(this);

      this.$node[0].addEventListener('wheel', this._onWheel);

      this.$container[0].addEventListener('click', this._preventClickPropagation);

      this.$input[0].addEventListener('change', this._onInputChange);

      this.$input[0].addEventListener('input', this._onInputChange);

      this.$muteControl[0].addEventListener('click', this._callbacks.onToggleMuteClick);
    }
  }, {
    key: '_unbindEvents',
    value: function _unbindEvents() {
      this.$node[0].removeEventListener('wheel', this._onWheel);

      this.$container[0].removeEventListener('click', this._preventClickPropagation);

      this.$input[0].removeEventListener('change', this._onInputChange);

      this.$input[0].removeEventListener('input', this._onInputChange);

      this.$muteControl[0].removeEventListener('click', this._callbacks.onToggleMuteClick);
    }
  }, {
    key: 'setState',
    value: function setState(_ref) {
      var volume = _ref.volume,
          isMuted = _ref.isMuted;

      volume !== undefined && this._setVolumeLevel(volume);
      isMuted !== undefined && this._setMuteStatus(isMuted);
    }
  }, {
    key: '_setVolumeLevel',
    value: function _setVolumeLevel(volume) {
      this.$input.val(volume);
      this.$input.attr('value', volume);
      this.$filledProgress.attr('style', 'height:' + volume + '%;');

      if (volume >= MAX_VOLUME_ICON_RANGE) {
        this.$muteControl.toggleClass(this.styleNames['half-volume'], false);
      } else {
        this.$muteControl.toggleClass(this.styleNames['half-volume'], true);
      }
    }
  }, {
    key: '_setMuteStatus',
    value: function _setMuteStatus(isMuted) {
      this.$muteControl.toggleClass(this.styleNames.muted, isMuted);
    }
  }, {
    key: 'show',
    value: function show() {
      this.$node.toggleClass(_volume2.default.hidden, false);
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.$node.toggleClass(_volume2.default.hidden, true);
    }
  }, {
    key: 'getNode',
    value: function getNode() {
      return this.$node[0];
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this._unbindEvents();
      this.$node.remove();

      delete this.$input;
      delete this.$muteControl;
      delete this.$filledProgress;
      delete this.$container;
      delete this.$node;
    }
  }]);

  return VolumeView;
}(_view2.default);

VolumeView.extendStyleNames(_volume2.default);

exports.default = VolumeView;
//# sourceMappingURL=volume.view.js.map


/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jbone = __webpack_require__(151);

var _jbone2 = _interopRequireDefault(_jbone);

var _view = __webpack_require__(155);

var _view2 = _interopRequireDefault(_view);

var _loader = __webpack_require__(1678);

var _loader2 = _interopRequireDefault(_loader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoaderView = function (_View) {
  _inherits(LoaderView, _View);

  function LoaderView(config) {
    _classCallCheck(this, LoaderView);

    var _this = _possibleConstructorReturn(this, (LoaderView.__proto__ || Object.getPrototypeOf(LoaderView)).call(this, config));

    _this.$node = (0, _jbone2.default)('<div>', {
      class: _this.styleNames.loader,
      'data-hook': 'loader'
    });
    return _this;
  }

  _createClass(LoaderView, [{
    key: 'getNode',
    value: function getNode() {
      return this.$node[0];
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.$node.toggleClass(this.styleNames.hidden, true);
    }
  }, {
    key: 'show',
    value: function show() {
      this.$node.toggleClass(this.styleNames.hidden, false);
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.$node.remove();

      delete this.$node;
    }
  }]);

  return LoaderView;
}(_view2.default);

LoaderView.extendStyleNames(_loader2.default);

exports.default = LoaderView;
//# sourceMappingURL=loader.view.js.map


/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jbone = __webpack_require__(151);

var _jbone2 = _interopRequireDefault(_jbone);

var _view = __webpack_require__(155);

var _view2 = _interopRequireDefault(_view);

var _overlay = __webpack_require__(1679);

var _overlay2 = _interopRequireDefault(_overlay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OverlayView = function (_View) {
  _inherits(OverlayView, _View);

  function OverlayView(config) {
    _classCallCheck(this, OverlayView);

    var _this = _possibleConstructorReturn(this, (OverlayView.__proto__ || Object.getPrototypeOf(OverlayView)).call(this, config));

    var callbacks = config.callbacks,
        src = config.src;


    _this._callbacks = callbacks;

    _this.$node = (0, _jbone2.default)('<div>', {
      'data-hook': 'overlay'
    });

    _this.$content = (0, _jbone2.default)('<div>', {
      class: _this.styleNames.overlay
    });

    if (src) {
      _this.$content.css('background-image', 'url(\'' + src + '\')');
    }

    _this.$playButton = (0, _jbone2.default)('<div>', {
      class: _this.styleNames.icon
    });

    _this.$content.append(_this.$playButton);

    _this.$node.append(_this.$content);

    _this._bindEvents();
    return _this;
  }

  _createClass(OverlayView, [{
    key: '_bindEvents',
    value: function _bindEvents() {
      this.$playButton[0].addEventListener('click', this._callbacks.onPlayClick);
    }
  }, {
    key: 'getNode',
    value: function getNode() {
      return this.$node[0];
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.$node.toggleClass(this.styleNames.hidden, true);
    }
  }, {
    key: 'show',
    value: function show() {
      this.$node.toggleClass(this.styleNames.hidden, false);
    }
  }, {
    key: 'setBackgroundSrc',
    value: function setBackgroundSrc(src) {
      this.$content.css('background-image', 'url(\'' + src + '\')');
    }
  }, {
    key: '_unbindEvents',
    value: function _unbindEvents() {
      this.$playButton[0].removeEventListener('click', this._callbacks.onPlayClick);
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this._unbindEvents();

      this.$node.remove();

      delete this.$content;
      delete this.$playButton;
      delete this.$node;
    }
  }]);

  return OverlayView;
}(_view2.default);

OverlayView.extendStyleNames(_overlay2.default);

exports.default = OverlayView;
//# sourceMappingURL=overlay.view.js.map


/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jbone = __webpack_require__(151);

var _jbone2 = _interopRequireDefault(_jbone);

var _view = __webpack_require__(155);

var _view2 = _interopRequireDefault(_view);

var _screen = __webpack_require__(1680);

var _screen2 = _interopRequireDefault(_screen);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SECONDS_COUNT = 5;

var ScreenView = function (_View) {
  _inherits(ScreenView, _View);

  function ScreenView(config) {
    _classCallCheck(this, ScreenView);

    var _this = _possibleConstructorReturn(this, (ScreenView.__proto__ || Object.getPrototypeOf(ScreenView)).call(this, config));

    var callbacks = config.callbacks,
        nativeControls = config.nativeControls,
        indicateScreenClick = config.indicateScreenClick;


    _this._nativeControls = nativeControls;
    _this._indicateScreenClick = indicateScreenClick;

    _this._callbacks = callbacks;
    _this.$node = (0, _jbone2.default)('<div>', {
      class: _this.styleNames['screen-block'],
      'data-hook': 'screen-block',
      tabIndex: 0
    });

    if (_this._indicateScreenClick) {
      _this.$iconContainer = (0, _jbone2.default)('<div>', {
        class: '' + _this.styleNames['icon-container']
      });

      _this.$node.append(_this.$iconContainer);
    }

    _this.playIcon = '<div class="' + _this.styleNames.icon + '"><svg class="' + _this.styleNames['play-icon'] + ' ' + _this.styleNames['animated-icon'] + '" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 14"><path fill="#FFF" fill-rule="evenodd" d="M.079 0L0 14l10.5-7.181z"/></svg></div>';
    _this.pauseIcon = '<div class="' + _this.styleNames.icon + '"><svg class="' + _this.styleNames['pause-icon'] + ' ' + _this.styleNames['animated-icon'] + '"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 14"><path fill="#FFF" fill-rule="evenodd" d="M7 0h3v14H7V0zM0 0h3v14H0V0z"/></svg></div>';
    _this.forwardIcon = '<div class="' + _this.styleNames.icon + '"><div class="' + _this.styleNames.seconds + '"><span>' + SECONDS_COUNT + '</span></div><svg class="' + _this.styleNames['forward-icon'] + ' ' + _this.styleNames['animated-icon'] + '" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 34"><path fill="#FFF" fill-rule="evenodd" d="M17 0c4.59 0 8.84 1.87 11.9 4.93V1.7h3.4v10.2H22.1V8.5h5.44C24.99 5.27 21.25 3.4 17 3.4 9.52 3.4 3.4 9.52 3.4 17c0 7.48 6.12 13.6 13.6 13.6 7.48 0 13.6-6.12 13.6-13.6H34c0 9.35-7.65 17-17 17S0 26.35 0 17 7.65 0 17 0z"/></svg></div>';
    _this.rewindIcon = '<div class="' + _this.styleNames.icon + '"><div class="' + _this.styleNames.seconds + '"><span>' + SECONDS_COUNT + '</span></div><svg class="' + _this.styleNames['rewind-icon'] + ' ' + _this.styleNames['animated-icon'] + '" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 34"><path fill="#FFF" fill-rule="evenodd" d="M17 0C12.41 0 8.16 1.87 5.1 4.93V1.7H1.7v10.2h10.2V8.5H6.46C9.01 5.27 12.75 3.4 17 3.4c7.48 0 13.6 6.12 13.6 13.6 0 7.48-6.12 13.6-13.6 13.6-7.48 0-13.6-6.12-13.6-13.6H0c0 9.35 7.65 17 17 17s17-7.65 17-17S26.35 0 17 0z"/></svg></div>';
    _this.descreaseVolumeIcon = '<div class="' + _this.styleNames.icon + '"><svg class="' + _this.styleNames['decrease-volume-icon'] + ' ' + _this.styleNames['animated-icon'] + '" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 14"><g fill="none" fill-rule="evenodd"><path fill="#FFF" d="M0 3.919h2.993v5.97H0V3.92zm2.995-.015L7 .924v12L2.995 9.882v-5.98z"/><path stroke="#FFF" d="M9.853 10.837a5.45 5.45 0 0 0 0-7.707"/></g></svg></div>';
    _this.increaseVolumeIcon = '<div class="' + _this.styleNames.icon + '"><svg class="' + _this.styleNames['increase-volume-icon'] + ' ' + _this.styleNames['animated-icon'] + '" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 14"><g fill="none" fill-rule="evenodd"><path fill="#FFF" d="M0 3.919h2.993v5.97H0V3.92zm2.995-.015L7 .924v12L2.995 9.882v-5.98z"/><path stroke="#FFF" d="M12.793 13.716a9.607 9.607 0 0 0 0-13.586M9.853 10.837a5.45 5.45 0 0 0 0-7.707"/></g></svg></div>';

    _this._bindEvents();
    return _this;
  }

  _createClass(ScreenView, [{
    key: '_bindEvents',
    value: function _bindEvents() {
      this.$node[0].addEventListener('click', this._callbacks.onWrapperMouseClick);
      this.$node[0].addEventListener('keydown', this._callbacks.onWrapperKeyPress);
    }
  }, {
    key: 'focusOnNode',
    value: function focusOnNode() {
      this.$node[0].focus();
    }
  }, {
    key: 'activatePlayIcon',
    value: function activatePlayIcon() {
      this.$iconContainer.html(this.playIcon);
    }
  }, {
    key: 'activatePauseIcon',
    value: function activatePauseIcon() {
      this.$iconContainer.html(this.pauseIcon);
    }
  }, {
    key: 'activateForwardIcon',
    value: function activateForwardIcon() {
      this.$iconContainer.html(this.forwardIcon);
    }
  }, {
    key: 'activateRewindIcon',
    value: function activateRewindIcon() {
      this.$iconContainer.html(this.rewindIcon);
    }
  }, {
    key: 'activateIncreaseVolumeIcon',
    value: function activateIncreaseVolumeIcon() {
      this.$iconContainer.html(this.increaseVolumeIcon);
    }
  }, {
    key: 'activateDecreaseVolumeIcon',
    value: function activateDecreaseVolumeIcon() {
      this.$iconContainer.html(this.descreaseVolumeIcon);
    }
  }, {
    key: 'deactivateIcon',
    value: function deactivateIcon() {
      this.$iconContainer.html('');
    }
  }, {
    key: 'show',
    value: function show() {
      this.$node.toggleClass(this.styleNames.hidden, false);
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.$node.toggleClass(this.styleNames.hidden, true);
    }
  }, {
    key: 'getNode',
    value: function getNode() {
      return this.$node[0];
    }
  }, {
    key: 'appendPlaybackViewNode',
    value: function appendPlaybackViewNode(node) {
      this.$node.append(node);
      if (this._nativeControls) {
        node.setAttribute('controls', 'true');
      }
    }
  }, {
    key: '_unbindEvents',
    value: function _unbindEvents() {
      this.$node[0].removeEventListener('click', this._callbacks.onWrapperMouseClick);
      this.$node[0].removeEventListener('keypress', this._callbacks.onWrapperKeyPress);
    }
  }, {
    key: 'appendComponentNode',
    value: function appendComponentNode(node) {
      this.$node.append(node);
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this._unbindEvents();
      this.$node.remove();

      delete this.$node;
    }
  }]);

  return ScreenView;
}(_view2.default);

ScreenView.extendStyleNames(_screen2.default);

exports.default = ScreenView;
//# sourceMappingURL=screen.view.js.map


/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _cssElementQueries = __webpack_require__(1622);

var _ui = __webpack_require__(153);

var _ui2 = _interopRequireDefault(_ui);

var _ui3 = __webpack_require__(1706);

var _ui4 = _interopRequireDefault(_ui3);

var _overlay = __webpack_require__(1232);

var _overlay2 = _interopRequireDefault(_overlay);

var _controls = __webpack_require__(1225);

var _controls2 = _interopRequireDefault(_controls);

var _loader = __webpack_require__(1231);

var _loader2 = _interopRequireDefault(_loader);

var _screen = __webpack_require__(1233);

var _screen2 = _interopRequireDefault(_screen);

var _fullScreen = __webpack_require__(1692);

var _fullScreen2 = _interopRequireDefault(_fullScreen);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DEFAULT_CONFIG = {
  overlay: false,
  customUI: {}
};

var PlayerUI = function () {
  function PlayerUI(_ref) {
    var engine = _ref.engine,
        eventEmitter = _ref.eventEmitter,
        config = _ref.config;

    _classCallCheck(this, PlayerUI);

    this._eventEmitter = eventEmitter;
    this._engine = engine;
    this.config = _extends({}, DEFAULT_CONFIG, config);
    this.isHidden = false;

    this._bindCallbacks();
    this._initUI();

    this._initComponents();
    this._initCustomUI();

    this._bindEvents();

    _cssElementQueries.ElementQueries.listen();

    this._fullScreen = new _fullScreen2.default({
      eventEmitter: this._eventEmitter,
      engine: this._engine,
      ui: this
    });
  }

  _createClass(PlayerUI, [{
    key: '_bindCallbacks',
    value: function _bindCallbacks() {
      this._proxyMouseEnter = this._proxyMouseEnter.bind(this);
      this._proxyMouseMove = this._proxyMouseMove.bind(this);
      this._proxyMouseLeave = this._proxyMouseLeave.bind(this);
    }
  }, {
    key: '_bindEvents',
    value: function _bindEvents() {
      this._eventEmitter.on(_ui2.default.FULLSCREEN_STATUS_CHANGED, this.view.setFullScreenStatus, this.view);
    }
  }, {
    key: '_unbindEvents',
    value: function _unbindEvents() {
      this._eventEmitter.off(_ui2.default.FULLSCREEN_STATUS_CHANGED, this.view.setFullScreenStatus, this.view);
    }
  }, {
    key: '_initUI',
    value: function _initUI() {
      var _config = this.config,
          width = _config.width,
          height = _config.height;

      var config = {
        width: width,
        height: height,
        callbacks: {
          onMouseEnter: this._proxyMouseEnter,
          onMouseMove: this._proxyMouseMove,
          onMouseLeave: this._proxyMouseLeave
        }
      };

      this.view = new _ui4.default(config);
    }
  }, {
    key: '_initComponents',
    value: function _initComponents() {
      this._initOverlay();

      this._initLoader();

      this._initScreen();

      this._initControls();
    }
  }, {
    key: '_initScreen',
    value: function _initScreen() {
      this.screen = new _screen2.default({
        config: this.config.screen,
        engine: this._engine,
        ui: this,
        eventEmitter: this._eventEmitter
      });

      this.view.appendComponentNode(this.screen.node);
    }
  }, {
    key: '_initOverlay',
    value: function _initOverlay() {
      var config = this.config.overlay;

      if (config === false) {
        return;
      }

      if (typeof config === 'function') {
        this.overlay = new config({
          engine: this._engine,
          eventEmitter: this._eventEmitter,
          ui: this
        });

        this.view.appendComponentNode(this.overlay.getNode());
      } else {
        this.overlay = new _overlay2.default({
          engine: this._engine,
          eventEmitter: this._eventEmitter,
          config: this.config.overlay,
          ui: this
        });

        this.view.appendComponentNode(this.overlay.node);
      }
    }
  }, {
    key: '_initLoader',
    value: function _initLoader() {
      var config = this.config.loader;

      if (config === false) {
        return;
      }

      this.loader = new _loader2.default({
        engine: this._engine,
        eventEmitter: this._eventEmitter,
        config: this.config.loader,
        ui: this
      });

      this.view.appendComponentNode(this.loader.node);
    }
  }, {
    key: '_initControls',
    value: function _initControls() {
      var config = this.config.controls;

      if (config === false) {
        return;
      }

      this.controls = new _controls2.default({
        engine: this._engine,
        eventEmitter: this._eventEmitter,
        ui: this,
        config: config
      });

      this.screen.view.appendComponentNode(this.controls.node);
    }
  }, {
    key: '_initCustomUI',
    value: function _initCustomUI() {
      var _this = this;

      this.customComponents = {};
      var keys = Object.keys(this.config.customUI);
      keys.forEach(function (key) {
        var component = new _this.config.customUI[key]({
          engine: _this._engine,
          eventEmitter: _this._eventEmitter,
          ui: _this
        });

        _this.customComponents[key] = component;

        _this.screen.view.appendComponentNode(component.getNode());
      });
    }
  }, {
    key: '_proxyMouseEnter',
    value: function _proxyMouseEnter() {
      this._eventEmitter.emit(_ui2.default.MOUSE_ENTER_ON_PLAYER_TRIGGERED);
    }
  }, {
    key: '_proxyMouseMove',
    value: function _proxyMouseMove() {
      this._eventEmitter.emit(_ui2.default.MOUSE_MOVE_ON_PLAYER_TRIGGERED);
    }
  }, {
    key: '_proxyMouseLeave',
    value: function _proxyMouseLeave() {
      this._eventEmitter.emit(_ui2.default.MOUSE_LEAVE_ON_PLAYER_TRIGGERED);
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.isHidden = true;
      this.view.hide();
    }
  }, {
    key: 'show',
    value: function show() {
      this.isHidden = false;
      this.view.show();
    }
  }, {
    key: 'setWidth',
    value: function setWidth(width) {
      this.view.setWidth(width);
    }
  }, {
    key: 'setHeight',
    value: function setHeight(height) {
      this.view.setHeight(height);
    }
  }, {
    key: 'enterFullScreen',
    value: function enterFullScreen() {
      this._fullScreen.enterFullScreen();
    }
  }, {
    key: 'exitFullScreen',
    value: function exitFullScreen() {
      this._fullScreen.exitFullScreen();
    }
  }, {
    key: 'isInFullScreen',
    value: function isInFullScreen() {
      return this._fullScreen.isInFullScreen;
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this._unbindEvents();

      if (this.controls) {
        this.controls.destroy();
        delete this.controls;
      }

      if (this.screen) {
        this.screen.destroy();
        delete this.screen;
      }

      if (this.overlay) {
        this.overlay.destroy();
        delete this.overlay;
      }

      if (this.loader) {
        this.loader.destroy();
        delete this.loader;
      }

      this.view.destroy();
      delete this.view;

      this._fullScreen.destroy();
      delete this._fullScreen;

      delete this._eventEmitter;
      delete this._engine;
      delete this.config;
    }
  }, {
    key: 'node',
    get: function get() {
      return this.view.getNode();
    }
  }]);

  return PlayerUI;
}();

exports.default = PlayerUI;
//# sourceMappingURL=ui.controler.js.map


/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jbone = __webpack_require__(151);

var _jbone2 = _interopRequireDefault(_jbone);

var _view = __webpack_require__(155);

var _view2 = _interopRequireDefault(_view);

var _ui = __webpack_require__(1681);

var _ui2 = _interopRequireDefault(_ui);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PlayerUIView = function (_View) {
  _inherits(PlayerUIView, _View);

  function PlayerUIView(config) {
    _classCallCheck(this, PlayerUIView);

    var _this = _possibleConstructorReturn(this, (PlayerUIView.__proto__ || Object.getPrototypeOf(PlayerUIView)).call(this, config));

    var width = config.width,
        height = config.height,
        callbacks = config.callbacks;


    _this._inFullScreen = false;

    _this._callbacks = callbacks;

    _this.$node = (0, _jbone2.default)('<div>', {
      class: _this.styleNames['video-wrapper'],
      'data-hook': 'player-container'
    });

    _this.$innerWrapper = (0, _jbone2.default)('<div>', {
      class: _this.styleNames['inner-wrapper']
    });

    _this.setWidth(width);
    _this.setHeight(height);

    _this.$node.append(_this.$innerWrapper);

    _this._bindCallbacks();

    _this._bindEvents();
    return _this;
  }

  _createClass(PlayerUIView, [{
    key: '_bindCallbacks',
    value: function _bindCallbacks() {
      this._proxyMouseEnterOnNode = this._proxyMouseEnterOnNode.bind(this);
      this._proxyMouseMoveOnNode = this._proxyMouseMoveOnNode.bind(this);
      this._proxyMouseLeaveOnNode = this._proxyMouseLeaveOnNode.bind(this);
    }
  }, {
    key: '_bindEvents',
    value: function _bindEvents() {
      this.$node[0].addEventListener('mouseenter', this._proxyMouseEnterOnNode);
      this.$node[0].addEventListener('mousemove', this._proxyMouseMoveOnNode);
      this.$node[0].addEventListener('mouseleave', this._proxyMouseLeaveOnNode);
    }
  }, {
    key: '_unbindEvents',
    value: function _unbindEvents() {
      this.$node[0].removeEventListener('mouseenter', this._proxyMouseEnterOnNode);
      this.$node[0].removeEventListener('mousemove', this._proxyMouseMoveOnNode);
      this.$node[0].removeEventListener('mouseleave', this._proxyMouseLeaveOnNode);
    }
  }, {
    key: '_proxyMouseEnterOnNode',
    value: function _proxyMouseEnterOnNode() {
      this._callbacks.onMouseEnter();
    }
  }, {
    key: '_proxyMouseMoveOnNode',
    value: function _proxyMouseMoveOnNode() {
      this._callbacks.onMouseMove();
    }
  }, {
    key: '_proxyMouseLeaveOnNode',
    value: function _proxyMouseLeaveOnNode() {
      this._callbacks.onMouseLeave();
    }
  }, {
    key: 'setWidth',
    value: function setWidth(width) {
      if (!width) {
        return;
      }

      this._width = width;

      this.$node.css({
        width: this._width + 'px'
      });
    }
  }, {
    key: 'setHeight',
    value: function setHeight(height) {
      if (!height) {
        return;
      }

      this._height = height;

      this.$node.css({
        height: this._height + 'px'
      });
    }
  }, {
    key: 'show',
    value: function show() {
      this.$node.toggleClass(this.styleNames.hidden, false);
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.$node.toggleClass(this.styleNames.hidden, true);
    }
  }, {
    key: 'appendComponentNode',
    value: function appendComponentNode(node) {
      this.$innerWrapper.append(node);
    }
  }, {
    key: 'getNode',
    value: function getNode() {
      return this.$node[0];
    }
  }, {
    key: 'setFullScreenStatus',
    value: function setFullScreenStatus(isFullScreen) {
      if (isFullScreen) {
        this.$node.attr('data-in-full-screen', true);
      } else {
        this.$node.removeAttr('data-in-full-screen');
      }
      this.$node.toggleClass(this.styleNames['full-screen'], isFullScreen);
      this._inFullScreen = isFullScreen;
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this._unbindEvents();
      this.$node.remove();

      delete this.$node;
    }
  }]);

  return PlayerUIView;
}(_view2.default);

PlayerUIView.extendStyleNames(_ui2.default);

exports.default = PlayerUIView;
//# sourceMappingURL=ui.view.js.map


/***/ }),
/* 1707 */,
/* 1708 */,
/* 1709 */,
/* 1710 */,
/* 1711 */,
/* 1712 */,
/* 1713 */,
/* 1714 */,
/* 1715 */,
/* 1716 */,
/* 1717 */,
/* 1718 */,
/* 1719 */,
/* 1720 */,
/* 1721 */,
/* 1722 */,
/* 1723 */,
/* 1724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getVideoCoverUrl;
function getVideoCoverUrl(videoItem) {
  var coverUrl = videoItem.coverUrl,
      customCoverUrl = videoItem.customCoverUrl;

  return customCoverUrl || coverUrl;
}

/***/ }),
/* 1725 */,
/* 1726 */,
/* 1727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MobileSpinnerOverlay; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_components_spinner_loading_spinner__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mobile_spinner_overlay_styl__ = __webpack_require__(1887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mobile_spinner_overlay_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__mobile_spinner_overlay_styl__);






var _dec, _class;







var MobileSpinnerOverlay = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_7__mobile_spinner_overlay_styl___default.a), _dec(_class = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MobileSpinnerOverlay, _React$Component);

  function MobileSpinnerOverlay() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, MobileSpinnerOverlay);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (MobileSpinnerOverlay.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(MobileSpinnerOverlay)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(MobileSpinnerOverlay, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { styleName: 'spinner-container' },
        React.createElement(__WEBPACK_IMPORTED_MODULE_6_shared_components_spinner_loading_spinner__["a" /* default */], { styleName: 'spinner' })
      );
    }
  }]);

  return MobileSpinnerOverlay;
}(React.Component)) || _class);


/***/ }),
/* 1728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Nav; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_components_button_button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_static_images_arrow_right_svg__ = __webpack_require__(2693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__nav_styl__ = __webpack_require__(3263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__nav_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__nav_styl__);







var _dec, _class, _desc, _value, _class2, _class3, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}










var Nav = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_11__nav_styl___default.a), _dec(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Nav, _React$Component);

  function Nav() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Nav);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Nav.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Nav)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Nav, [{
    key: 'handleNextClick',
    value: function handleNextClick() {
      var _props = this.props,
          isDisabled = _props.isDisabled,
          onNextClick = _props.onNextClick;

      if (isDisabled) {
        return;
      }
      onNextClick();
    }
  }, {
    key: 'handlePrevClick',
    value: function handlePrevClick() {
      var _props2 = this.props,
          isDisabled = _props2.isDisabled,
          onPrevClick = _props2.onPrevClick;

      if (isDisabled) {
        return;
      }
      onPrevClick();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          isPrevVisible = _props3.isPrevVisible,
          isNextVisible = _props3.isNextVisible,
          dataHook = _props3.dataHook;


      return React.createElement(
        'div',
        { 'data-hook': dataHook },
        isPrevVisible && this.prevButton,
        isNextVisible && this.nextButton
      );
    }
  }, {
    key: 'arrowIcon',
    get: function get() {
      var customArrowIcon = this.props.customArrowIcon;

      return customArrowIcon || React.createElement(__WEBPACK_IMPORTED_MODULE_10_static_images_arrow_right_svg__["a" /* default */], null);
    }
  }, {
    key: 'prevButton',
    get: function get() {
      var prevButtonClassName = this.props.prevButtonClassName;


      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_9_shared_components_button_button__["f" /* GenericButton */],
        { onClick: this.handlePrevClick,
          className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()('qa-prev-button', prevButtonClassName),
          'data-hook': 'prev-button',
          styleName: 'prev-button' },
        this.arrowIcon
      );
    }
  }, {
    key: 'nextButton',
    get: function get() {
      var nextButtonClassName = this.props.nextButtonClassName;


      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_9_shared_components_button_button__["f" /* GenericButton */],
        { onClick: this.handleNextClick,
          className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()('qa-next-button', nextButtonClassName),
          'data-hook': 'next-button',
          styleName: 'next-button' },
        this.arrowIcon
      );
    }
  }]);

  return Nav;
}(React.Component), _class3.propTypes = {
  prevButtonClassName: React.PropTypes.string,
  nextButtonClassName: React.PropTypes.string,

  customArrowIcon: React.PropTypes.element,

  isPrevVisible: React.PropTypes.bool,
  isNextVisible: React.PropTypes.bool,
  isDisabled: React.PropTypes.bool,

  onPrevClick: React.PropTypes.func.isRequired,
  onNextClick: React.PropTypes.func.isRequired,

  dataHook: React.PropTypes.string
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'handleNextClick', [__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handleNextClick'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handlePrevClick', [__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handlePrevClick'), _class2.prototype)), _class2)) || _class);


/***/ }),
/* 1729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PaymentForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_text_overflow_clamp__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_text_overflow_clamp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_text_overflow_clamp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_utils_deal_info_helpers__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_shared_utils_get_url_to_video__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_shared_bi_bi__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_widget_utils_not_for_preview__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_widget_utils_payments__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_shared_selectors_videos__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_shared_selectors_app_settings__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_widget_selectors_current_site_user__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_shared_components_modal_modal__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_shared_selectors_channels__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_shared_components_resized_image_resized_image__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_shared_components_icon_icon__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_widget_components_button_buttons_group__ = __webpack_require__(1580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_widget_components_account_account_form__ = __webpack_require__(1825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_shared_constants_payments__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__payment_form_styl__ = __webpack_require__(1890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__payment_form_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__payment_form_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__translations__ = __webpack_require__(1545);









var _biInfoEventNames, _biPurchaseEventNames, _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}































var COVER_WIDTH = 314;
var COVER_HEIGHT = 177;

var biInfoEventNames = (_biInfoEventNames = {}, __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_biInfoEventNames, __WEBPACK_IMPORTED_MODULE_28_shared_constants_payments__["a" /* PAYMENT_TYPE */].MEMBER_ONLY, 'video.memberOnlyInfo.fullscreenModal.rendered'), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_biInfoEventNames, __WEBPACK_IMPORTED_MODULE_28_shared_constants_payments__["a" /* PAYMENT_TYPE */].PURCHASE, 'video.purchaseInfo.fullscreenModal.rendered'), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_biInfoEventNames, __WEBPACK_IMPORTED_MODULE_28_shared_constants_payments__["a" /* PAYMENT_TYPE */].RENT, 'video.purchaseInfo.fullscreenModal.rendered'), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_biInfoEventNames, __WEBPACK_IMPORTED_MODULE_28_shared_constants_payments__["a" /* PAYMENT_TYPE */].SUBSCRIPTION, 'channel.subscribeInfo.fullscreenModal.rendered'), _biInfoEventNames);

var biPurchaseEventNames = (_biPurchaseEventNames = {}, __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_biPurchaseEventNames, __WEBPACK_IMPORTED_MODULE_28_shared_constants_payments__["a" /* PAYMENT_TYPE */].PURCHASE, 'video.purchase.requested'), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_biPurchaseEventNames, __WEBPACK_IMPORTED_MODULE_28_shared_constants_payments__["a" /* PAYMENT_TYPE */].RENT, 'video.purchase.requested'), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_biPurchaseEventNames, __WEBPACK_IMPORTED_MODULE_28_shared_constants_payments__["a" /* PAYMENT_TYPE */].SUBSCRIPTION, 'channel.subscribe.requested'), _biPurchaseEventNames);

var PaymentForm = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_react_redux__["a" /* connect */])(function (state) {
  return {
    channelData: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23_shared_selectors_channels__["a" /* getChannelForWidget */])(state),
    videoByIds: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19_shared_selectors_videos__["a" /* getVideosGroupedByIds */])(state),
    currentSiteUser: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_widget_selectors_current_site_user__["a" /* getCurrentSiteUser */])(state),
    appSettings: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_shared_selectors_app_settings__["a" /* getAllSettings */])(state)
  };
}), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_shared_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_29__payment_form_styl___default.a), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(PaymentForm, _React$Component);

  function PaymentForm(props) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, PaymentForm);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PaymentForm.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(PaymentForm)).call(this, props));

    var paymentType = _this.props.paymentType;


    if (!_this.getDealInfoByType(paymentType)) {
      if (paymentType === __WEBPACK_IMPORTED_MODULE_28_shared_constants_payments__["a" /* PAYMENT_TYPE */].PURCHASE) {
        paymentType = __WEBPACK_IMPORTED_MODULE_28_shared_constants_payments__["a" /* PAYMENT_TYPE */].RENT;
      } else if (paymentType === __WEBPACK_IMPORTED_MODULE_28_shared_constants_payments__["a" /* PAYMENT_TYPE */].RENT) {
        paymentType = __WEBPACK_IMPORTED_MODULE_28_shared_constants_payments__["a" /* PAYMENT_TYPE */].PURCHASE;
      } else {
        paymentType = null;
      }
    }

    _this.state = {
      paymentType: paymentType
    };

    if (!_this.getDealInfoByType(paymentType)) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_shared_components_modal_modal__["a" /* closeModal */])();
    }
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(PaymentForm, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var paymentType = this.props.paymentType;


      this.clamp();

      window.addEventListener('message', this.paymentComplete, false);
      __WEBPACK_IMPORTED_MODULE_15_shared_bi_bi__["a" /* default */].logWidgetSystem(biInfoEventNames[paymentType]);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.clamp();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('message', this.paymentComplete, false);
    }
  }, {
    key: 'clamp',
    value: function clamp() {
      __WEBPACK_IMPORTED_MODULE_12_text_overflow_clamp___default()(this.titleNode, { lineClamp: 2 });
    }
  }, {
    key: 'paymentComplete',
    value: function paymentComplete(event) {
      var isCompleted = _.get(event, 'data.completed');

      if (_.isBoolean(isCompleted)) {
        var paymentType = this.props.paymentType;


        if (paymentType === __WEBPACK_IMPORTED_MODULE_28_shared_constants_payments__["a" /* PAYMENT_TYPE */].SUBSCRIPTION) {
          var result = isCompleted ? 'success' : 'failed';

          this.props.biEvent('widget.subscriptionPopUp.Completed', { result: result });
        }

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_shared_components_modal_modal__["a" /* closeModal */])();
      }
    }
  }, {
    key: 'openPaymentPopup',
    value: function openPaymentPopup() {
      var _props = this.props,
          appSettings = _props.appSettings,
          videoId = _props.videoId,
          currentSiteUser = _props.currentSiteUser,
          channelData = _props.channelData;
      var paymentType = this.state.paymentType;
      var siteUrl = appSettings.siteUrl,
          instance = appSettings.instance;


      __WEBPACK_IMPORTED_MODULE_15_shared_bi_bi__["a" /* default */].logWidgetSystem(biPurchaseEventNames[paymentType]);

      var paymentOptions = {
        memberId: currentSiteUser.id,
        channelId: channelData.id,
        type: paymentType,
        ref: siteUrl,
        instance: instance
      };

      if (paymentType !== __WEBPACK_IMPORTED_MODULE_28_shared_constants_payments__["a" /* PAYMENT_TYPE */].SUBSCRIPTION) {
        paymentOptions.refItemId = videoId;
        paymentOptions.ref = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_shared_utils_get_url_to_video__["a" /* default */])(this.video, appSettings);
      }

      __WEBPACK_IMPORTED_MODULE_18_widget_utils_payments__["a" /* default */].paypal(paymentOptions);
    }
  }, {
    key: 'updatePaymentType',
    value: function updatePaymentType(paymentType) {
      this.setState({
        paymentType: paymentType
      });
    }
  }, {
    key: 'getDealInfoByType',
    value: function getDealInfoByType(type) {
      switch (type) {
        case __WEBPACK_IMPORTED_MODULE_28_shared_constants_payments__["a" /* PAYMENT_TYPE */].PURCHASE:
          return __WEBPACK_IMPORTED_MODULE_13_shared_utils_deal_info_helpers__["b" /* getSalePriceInfo */](this.video.dealInfo);
        case __WEBPACK_IMPORTED_MODULE_28_shared_constants_payments__["a" /* PAYMENT_TYPE */].RENT:
          return __WEBPACK_IMPORTED_MODULE_13_shared_utils_deal_info_helpers__["c" /* getRentPriceInfo */](this.video.dealInfo);
        case __WEBPACK_IMPORTED_MODULE_28_shared_constants_payments__["a" /* PAYMENT_TYPE */].MEMBER_ONLY:
          return {};
        default:
        case __WEBPACK_IMPORTED_MODULE_28_shared_constants_payments__["a" /* PAYMENT_TYPE */].SUBSCRIPTION:
          return __WEBPACK_IMPORTED_MODULE_13_shared_utils_deal_info_helpers__["a" /* getSubscriptionPriceInfo */](this.props.channelData.dealInfo);
      }
    }
  }, {
    key: 'getSinglePaymentType',
    value: function getSinglePaymentType(paymentDealInfo) {
      return React.createElement(
        'div',
        { styleName: 'single-button-text' },
        this.getPaymentTextByDealInfo(paymentDealInfo)
      );
    }
  }, {
    key: 'getPaymentTextByDealInfo',
    value: function getPaymentTextByDealInfo(paymentDealInfo) {
      if (!paymentDealInfo) {
        return null;
      }

      switch (paymentDealInfo.type) {
        case __WEBPACK_IMPORTED_MODULE_28_shared_constants_payments__["a" /* PAYMENT_TYPE */].PURCHASE:
          return React.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_30__translations__["a" /* default */].purchase, {
            values: {
              price: React.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["f" /* FormattedNumber */], { value: paymentDealInfo.price,
                style: 'currency',
                currency: paymentDealInfo.currency })
            } }));
        case __WEBPACK_IMPORTED_MODULE_28_shared_constants_payments__["a" /* PAYMENT_TYPE */].RENT:
          return React.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_30__translations__["a" /* default */].rent, {
            values: {
              price: React.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["f" /* FormattedNumber */], { value: paymentDealInfo.price,
                style: 'currency',
                currency: paymentDealInfo.currency })
            } }));
        default:
        case __WEBPACK_IMPORTED_MODULE_28_shared_constants_payments__["a" /* PAYMENT_TYPE */].SUBSCRIPTION:
          return React.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_30__translations__["a" /* default */].subscriptionMonth, {
            values: {
              price: React.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["f" /* FormattedNumber */], { value: paymentDealInfo.price,
                style: 'currency',
                currency: paymentDealInfo.currency })
            } }));
      }
    }
  }, {
    key: 'getCoverUrlFrom',
    value: function getCoverUrlFrom(item) {
      return item.customCoverUrl || item.coverUrl;
    }
  }, {
    key: 'handleUserLogin',
    value: function handleUserLogin() {
      var paymentType = this.state.paymentType;
      var _props2 = this.props,
          onUserLogin = _props2.onUserLogin,
          onBeforePageRefresh = _props2.onBeforePageRefresh;


      onUserLogin();

      onBeforePageRefresh({
        paymentType: paymentType,
        selectedVideoId: this.video.id
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          formatMessage = _props3.intl.formatMessage,
          onUserLogout = _props3.onUserLogout,
          className = _props3.className;
      var paymentType = this.state.paymentType;


      if (!this.video && paymentType !== __WEBPACK_IMPORTED_MODULE_28_shared_constants_payments__["a" /* PAYMENT_TYPE */].SUBSCRIPTION) {
        return null;
      }

      return React.createElement(
        'section',
        { styleName: 'wrapper',
          className: __WEBPACK_IMPORTED_MODULE_11_classnames___default()('qa-widget-payments-form', className) },
        React.createElement(
          'div',
          { styleName: 'subscribe-part' },
          React.createElement(__WEBPACK_IMPORTED_MODULE_24_shared_components_resized_image_resized_image__["a" /* default */], { styleName: 'image',
            src: this.coverUrl,
            width: COVER_WIDTH,
            height: COVER_HEIGHT }),
          React.createElement(
            'div',
            { styleName: 'content' },
            this.title,
            React.createElement(
              'div',
              { styleName: 'type-wrapper' },
              this.paymentTypeWrapper
            ),
            React.createElement(
              'div',
              { styleName: 'permissions-wrapper' },
              this.permissions
            )
          )
        ),
        React.createElement(
          'div',
          { styleName: 'auth-part' },
          React.createElement(__WEBPACK_IMPORTED_MODULE_27_widget_components_account_account_form__["a" /* default */], { proceedText: formatMessage(__WEBPACK_IMPORTED_MODULE_30__translations__["a" /* default */].proceedPaypal),
            paymentType: paymentType,
            proceedAction: this.openPaymentPopup,
            onUserLogin: this.handleUserLogin,
            onUserLogout: onUserLogout })
        )
      );
    }
  }, {
    key: 'title',
    get: function get() {
      var _this2 = this;

      var paymentType = this.state.paymentType;


      var title = void 0;
      if (paymentType === __WEBPACK_IMPORTED_MODULE_28_shared_constants_payments__["a" /* PAYMENT_TYPE */].SUBSCRIPTION) {
        title = this.props.channelData.title;
      } else {
        title = this.video.title;
      }

      return React.createElement(
        'div',
        { ref: function ref(node) {
            return _this2.titleNode = node;
          },
          styleName: 'title',
          title: title },
        title
      );
    }
  }, {
    key: 'video',
    get: function get() {
      var _props4 = this.props,
          videoId = _props4.videoId,
          videoByIds = _props4.videoByIds;

      return videoByIds[videoId];
    }
  }, {
    key: 'subscription',
    get: function get() {
      var subscriptionInfo = __WEBPACK_IMPORTED_MODULE_13_shared_utils_deal_info_helpers__["a" /* getSubscriptionPriceInfo */](this.props.channelData.dealInfo);
      return this.getSinglePaymentType(subscriptionInfo);
    }
  }, {
    key: 'buttons',
    get: function get() {
      var paymentType = this.state.paymentType;


      var rentDealInfo = __WEBPACK_IMPORTED_MODULE_13_shared_utils_deal_info_helpers__["c" /* getRentPriceInfo */](this.video.dealInfo);
      var purchaseDealInfo = __WEBPACK_IMPORTED_MODULE_13_shared_utils_deal_info_helpers__["b" /* getSalePriceInfo */](this.video.dealInfo);

      if (!rentDealInfo || !purchaseDealInfo) {
        return this.getSinglePaymentType(rentDealInfo || purchaseDealInfo);
      }

      var buttons = [{
        label: this.getPaymentTextByDealInfo(rentDealInfo),
        key: __WEBPACK_IMPORTED_MODULE_28_shared_constants_payments__["a" /* PAYMENT_TYPE */].RENT,
        className: 'qa-widget-payment-form-rent-button'
      }, {
        label: this.getPaymentTextByDealInfo(purchaseDealInfo),
        key: __WEBPACK_IMPORTED_MODULE_28_shared_constants_payments__["a" /* PAYMENT_TYPE */].PURCHASE,
        className: 'qa-widget-payment-form-purchase-button'
      }];

      return React.createElement(__WEBPACK_IMPORTED_MODULE_26_widget_components_button_buttons_group__["a" /* default */], { styleName: 'buttons',
        buttons: buttons,
        defaultActive: paymentType,
        disableTheme: true,
        onChange: this.updatePaymentType });
    }
  }, {
    key: 'paymentTypeWrapper',
    get: function get() {
      var paymentType = this.state.paymentType;


      if (paymentType === __WEBPACK_IMPORTED_MODULE_28_shared_constants_payments__["a" /* PAYMENT_TYPE */].SUBSCRIPTION) {
        return this.subscription;
      }

      if (paymentType === __WEBPACK_IMPORTED_MODULE_28_shared_constants_payments__["a" /* PAYMENT_TYPE */].MEMBER_ONLY) {
        return this.memberOnlyBenefits;
      }

      return this.buttons;
    }
  }, {
    key: 'memberOnlyBenefits',
    get: function get() {
      return React.createElement(
        'div',
        { styleName: 'single-button-text' },
        React.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], __WEBPACK_IMPORTED_MODULE_30__translations__["a" /* default */].memberOnlyBenefits)
      );
    }
  }, {
    key: 'permissions',
    get: function get() {
      var paymentType = this.state.paymentType;

      var dealInfo = this.getDealInfoByType(paymentType);

      return _.map(__WEBPACK_IMPORTED_MODULE_28_shared_constants_payments__["b" /* PAYMENT_PERMS */][paymentType], function (permTitle) {
        return React.createElement(
          'div',
          { styleName: 'permission',
            key: permTitle },
          React.createElement(__WEBPACK_IMPORTED_MODULE_25_shared_components_icon_icon__["a" /* default */], { styleName: 'icon',
            name: 'arrow-right-filled' }),
          React.createElement(__WEBPACK_IMPORTED_MODULE_8_react_intl__["a" /* FormattedMessage */], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_30__translations__["a" /* default */][permTitle], {
            values: dealInfo }))
        );
      });
    }
  }, {
    key: 'coverUrl',
    get: function get() {
      switch (this.state.paymentType) {
        case __WEBPACK_IMPORTED_MODULE_28_shared_constants_payments__["a" /* PAYMENT_TYPE */].PURCHASE:
        case __WEBPACK_IMPORTED_MODULE_28_shared_constants_payments__["a" /* PAYMENT_TYPE */].RENT:
        case __WEBPACK_IMPORTED_MODULE_28_shared_constants_payments__["a" /* PAYMENT_TYPE */].MEMBER_ONLY:
          return this.getCoverUrlFrom(this.video);
        default:
          return this.getCoverUrlFrom(this.props.channelData);
      }
    }
  }]);

  return PaymentForm;
}(React.Component), _class3.propTypes = {
  paymentType: React.PropTypes.oneOf([__WEBPACK_IMPORTED_MODULE_28_shared_constants_payments__["a" /* PAYMENT_TYPE */].SUBSCRIPTION, __WEBPACK_IMPORTED_MODULE_28_shared_constants_payments__["a" /* PAYMENT_TYPE */].PURCHASE, __WEBPACK_IMPORTED_MODULE_28_shared_constants_payments__["a" /* PAYMENT_TYPE */].RENT, __WEBPACK_IMPORTED_MODULE_28_shared_constants_payments__["a" /* PAYMENT_TYPE */].MEMBER_ONLY]),
  channelData: React.PropTypes.object,
  videoByIds: React.PropTypes.object,
  currentSiteUser: React.PropTypes.object,
  appSettings: React.PropTypes.object,
  biEvent: React.PropTypes.func,
  className: React.PropTypes.string,
  videoId: React.PropTypes.string,
  onUserLogin: React.PropTypes.func,
  onUserLogout: React.PropTypes.func,
  onBeforePageRefresh: React.PropTypes.func,

  intl: __WEBPACK_IMPORTED_MODULE_8_react_intl__["e" /* intlShape */]
}, _class3.defaultProps = {
  onUserLogin: _.noop,
  onUserLogout: _.noop,
  onBeforePageRefresh: _.noop
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'paymentComplete', [__WEBPACK_IMPORTED_MODULE_10_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'paymentComplete'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'openPaymentPopup', [__WEBPACK_IMPORTED_MODULE_10_core_decorators_lib_autobind___default.a, __WEBPACK_IMPORTED_MODULE_17_widget_utils_not_for_preview__["a" /* notForPreview */]], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'openPaymentPopup'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'updatePaymentType', [__WEBPACK_IMPORTED_MODULE_10_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'updatePaymentType'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleUserLogin', [__WEBPACK_IMPORTED_MODULE_10_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handleUserLogin'), _class2.prototype)), _class2)) || _class) || _class);


/***/ }),
/* 1730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OverlayMemberOnlyBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_widget_utils_not_for_preview__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_components_resized_image_resized_image__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_widget_components_player_overlay_bi_subscribe_shown_bi_overlay__ = __webpack_require__(1581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_widget_components_button_button__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_components_icon_icon__ = __webpack_require__(46);







var _desc, _value, _class, _class2, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}










var OverlayMemberOnlyBase = (_class = (_temp = _class2 = function (_SubscribeShownBIOver) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(OverlayMemberOnlyBase, _SubscribeShownBIOver);

  function OverlayMemberOnlyBase() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, OverlayMemberOnlyBase);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (OverlayMemberOnlyBase.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(OverlayMemberOnlyBase)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(OverlayMemberOnlyBase, [{
    key: 'callPlayCallback',
    value: function callPlayCallback() {
      var _props = this.props,
          id = _props.videoItem.id,
          onPlayClick = _props.onPlayClick;

      onPlayClick(id);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          width = _props2.width,
          height = _props2.height;

      var styles = this.getOpacityStyles();

      return React.createElement(
        'div',
        { styleName: 'wrapper' },
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_8_shared_components_resized_image_resized_image__["a" /* default */],
          { src: this.coverUrl,
            width: width,
            height: height },
          React.createElement(
            'div',
            { style: styles,
              styleName: 'overlay',
              className: className },
            this.title,
            this.publisher,
            this.buttons
          )
        )
      );
    }
  }, {
    key: 'publisher',
    get: function get() {
      if (!this.props.canShowMainItemPublisher) {
        return null;
      }

      var publisherText = this.publisherText;

      if (!publisherText) {
        return null;
      }

      return React.createElement(
        'div',
        { styleName: 'publisher' },
        React.createElement(
          'span',
          { styleName: 'publisher-text' },
          publisherText
        )
      );
    }
  }, {
    key: 'buttonStyleName',
    get: function get() {
      return 'button';
    }
  }, {
    key: 'playButton',
    get: function get() {
      var playButtonText = this.playButtonText;

      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_10_widget_components_button_button__["a" /* default */],
        { styleName: this.buttonStyleName,
          onClick: this.callPlayCallback },
        React.createElement(__WEBPACK_IMPORTED_MODULE_11_shared_components_icon_icon__["a" /* default */], { styleName: 'play-icon',
          name: 'arrow-right-filled' }),
        React.createElement(
          'span',
          null,
          playButtonText
        )
      );
    }
  }, {
    key: 'subscribeButton',
    get: function get() {
      var subscribeButtonText = this.subscribeButtonText;

      if (!subscribeButtonText) {
        return null;
      }

      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_10_widget_components_button_button__["a" /* default */],
        { styleName: this.buttonStyleName,
          className: 'qa-widget-overlay-subscribe-button',
          onClick: this.openSubscription },
        subscribeButtonText
      );
    }
  }, {
    key: 'buttons',
    get: function get() {
      return React.createElement(
        'div',
        { styleName: 'buttons' },
        this.playButton,
        this.subscribeButton
      );
    }
  }, {
    key: 'coverUrl',
    get: function get() {
      var _props3 = this.props,
          videoItem = _props3.videoItem,
          channelData = _props3.channelData;


      var coverUrl = videoItem.customCoverUrl || videoItem.coverUrl;

      if (this.isChannelCoverView) {
        coverUrl = channelData.customCoverUrl || channelData.coverUrl || coverUrl;
      }

      return coverUrl;
    }
  }]);

  return OverlayMemberOnlyBase;
}(__WEBPACK_IMPORTED_MODULE_9_widget_components_player_overlay_bi_subscribe_shown_bi_overlay__["a" /* default */]), _class2.displayName = 'OverlayMemberOnlyBase', _class2.propTypes = {
  width: React.PropTypes.number,
  height: React.PropTypes.number
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'callPlayCallback', [__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default.a, __WEBPACK_IMPORTED_MODULE_7_widget_utils_not_for_preview__["a" /* notForPreview */]], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'callPlayCallback'), _class.prototype)), _class);


/***/ }),
/* 1731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SimpleVideoThumbnail; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_components_resized_image_resized_image__ = __webpack_require__(113);







var _class, _temp, _class2, _temp2;



var _propTypes = {
  thumbnailUrl: React.PropTypes.string.isRequired,
  width: React.PropTypes.number,
  height: React.PropTypes.number,
  className: React.PropTypes.string
};

var _defaultProps = {
  width: 160,
  height: 104
};

var SimpleThumbnail = (_temp = _class = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(SimpleThumbnail, _React$Component);

  function SimpleThumbnail() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, SimpleThumbnail);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SimpleThumbnail.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(SimpleThumbnail)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(SimpleThumbnail, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          thumbnailUrl = _props.thumbnailUrl,
          className = _props.className;

      var size = _.pick(this.props, 'width', 'height');

      return React.createElement(__WEBPACK_IMPORTED_MODULE_6_shared_components_resized_image_resized_image__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ src: thumbnailUrl,
        className: className
      }, size));
    }
  }]);

  return SimpleThumbnail;
}(React.Component), _class.propTypes = _propTypes, _class.defaultProps = _defaultProps, _temp);



var SimpleVideoThumbnail = (_temp2 = _class2 = function (_React$Component2) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(SimpleVideoThumbnail, _React$Component2);

  function SimpleVideoThumbnail() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, SimpleVideoThumbnail);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SimpleVideoThumbnail.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(SimpleVideoThumbnail)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(SimpleVideoThumbnail, [{
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          _props2$video = _props2.video,
          coverUrl = _props2$video.coverUrl,
          customCoverUrl = _props2$video.customCoverUrl,
          width = _props2.width,
          height = _props2.height,
          className = _props2.className;


      return React.createElement(SimpleThumbnail, { thumbnailUrl: customCoverUrl || coverUrl,
        className: className,
        width: width,
        height: height });
    }
  }]);

  return SimpleVideoThumbnail;
}(React.Component), _class2.propTypes = {
  video: React.PropTypes.object.isRequired,
  width: React.PropTypes.number,
  height: React.PropTypes.number,
  className: React.PropTypes.string
}, _class2.defaultProps = _defaultProps, _temp2);

/***/ }),
/* 1732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppSettingsLoader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_utils_update_css__ = __webpack_require__(1256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_decorators_lib_debounce__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_decorators_lib_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_decorators_lib_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_utils_wix_sdk__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_widget_redux_client_actions_app_settings__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_data_components_data_component__ = __webpack_require__(423);







var _dec, _class, _desc, _value, _class2, _class3, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}












var AppSettingsLoader = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["a" /* connect */])(null, {
  updateAppSettings: __WEBPACK_IMPORTED_MODULE_11_widget_redux_client_actions_app_settings__["a" /* updateAppSettings */],
  fetchAppSettings: __WEBPACK_IMPORTED_MODULE_11_widget_redux_client_actions_app_settings__["b" /* fetchAppSettings */]
}), _dec(_class = (_class2 = (_temp = _class3 = function (_DataComponent) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(AppSettingsLoader, _DataComponent);

  function AppSettingsLoader() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, AppSettingsLoader);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AppSettingsLoader.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(AppSettingsLoader)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(AppSettingsLoader, [{
    key: 'handleEditModeChanging',
    value: function handleEditModeChanging(_ref) {
      var editMode = _ref.editMode;

      this.props.updateAppSettings({ editMode: editMode });
    }
  }, {
    key: 'handleSettingsChanging',
    value: function handleSettingsChanging(styleParams) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_shared_utils_update_css__["a" /* updateCSS */])(styleParams);
      this.props.updateAppSettings(styleParams);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.props.fetchAppSettings().then(function () {
        __WEBPACK_IMPORTED_MODULE_10_shared_utils_wix_sdk__["a" /* default */].addEventListener(__WEBPACK_IMPORTED_MODULE_10_shared_utils_wix_sdk__["a" /* default */].Events.STYLE_PARAMS_CHANGE, _this2.handleSettingsChanging);
        __WEBPACK_IMPORTED_MODULE_10_shared_utils_wix_sdk__["a" /* default */].addEventListener(__WEBPACK_IMPORTED_MODULE_10_shared_utils_wix_sdk__["a" /* default */].Events.EDIT_MODE_CHANGE, _this2.handleEditModeChanging);
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      __WEBPACK_IMPORTED_MODULE_10_shared_utils_wix_sdk__["a" /* default */].removeEventListener(__WEBPACK_IMPORTED_MODULE_10_shared_utils_wix_sdk__["a" /* default */].Events.STYLE_PARAMS_CHANGE, this.handleSettingsChanging);
      __WEBPACK_IMPORTED_MODULE_10_shared_utils_wix_sdk__["a" /* default */].removeEventListener(__WEBPACK_IMPORTED_MODULE_10_shared_utils_wix_sdk__["a" /* default */].Events.EDIT_MODE_CHANGE, this.handleEditModeChanging);
    }
  }, {
    key: 'childProps',
    get: function get() {
      return {};
    }
  }]);

  return AppSettingsLoader;
}(__WEBPACK_IMPORTED_MODULE_12_shared_data_components_data_component__["a" /* default */]), _class3.displayName = 'AppSettingsLoader', _class3.propTypes = {
  updateAppSettings: React.PropTypes.func
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'handleEditModeChanging', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a, __WEBPACK_IMPORTED_MODULE_9_core_decorators_lib_debounce___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handleEditModeChanging'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleSettingsChanging', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a, __WEBPACK_IMPORTED_MODULE_9_core_decorators_lib_debounce___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handleSettingsChanging'), _class2.prototype)), _class2)) || _class);


/***/ }),
/* 1733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChannelLoader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_selectors_channels__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_redux_server_actions_channel_get__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_data_components_data_loader__ = __webpack_require__(236);






var _dec, _class, _class2, _temp2;








var ChannelLoader = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["a" /* connect */])(function (state) {
  return {
    isFetching: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_shared_selectors_channels__["c" /* isFetching */])(state)
  };
}, {
  getChannel: __WEBPACK_IMPORTED_MODULE_7_shared_redux_server_actions_channel_get__["a" /* getPublic */]
}), _dec(_class = (_temp2 = _class2 = function (_DataLoader) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ChannelLoader, _DataLoader);

  function ChannelLoader() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ChannelLoader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = ChannelLoader.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ChannelLoader)).call.apply(_ref, [this].concat(args))), _this), _this.dependencies = ['channelId'], _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ChannelLoader, [{
    key: 'loadData',
    value: function loadData() {
      var _props = this.props,
          channelId = _props.channelId,
          getChannel = _props.getChannel;


      if (!channelId) {
        return;
      }

      // TODO: move getChannel code here
      return getChannel(channelId);
    }
  }, {
    key: 'childProps',
    get: function get() {
      var isFetching = this.props.isFetching;

      return {
        channel: { isFetching: isFetching, fetch: this.loadDataDebounced }
      };
    }
  }]);

  return ChannelLoader;
}(__WEBPACK_IMPORTED_MODULE_8_shared_data_components_data_loader__["a" /* default */]), _class2.displayName = 'ChannelLoader', _class2.propTypes = {
  getChannel: React.PropTypes.func,
  channelId: React.PropTypes.string
}, _temp2)) || _class);


/***/ }),
/* 1734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CurrentSiteUser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_widget_redux_server_actions_current_site_user_get__ = __webpack_require__(1211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_data_components_data_loader__ = __webpack_require__(236);







var _dec, _class, _desc, _value, _class2, _class3, _temp2;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}








var CurrentSiteUser = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["a" /* connect */])(null, {
  fetchCurrentSiteUser: __WEBPACK_IMPORTED_MODULE_8_widget_redux_server_actions_current_site_user_get__["a" /* default */]
}), _dec(_class = (_class2 = (_temp2 = _class3 = function (_DataLoader) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(CurrentSiteUser, _DataLoader);

  function CurrentSiteUser() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, CurrentSiteUser);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = CurrentSiteUser.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(CurrentSiteUser)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isFetching: false
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(CurrentSiteUser, [{
    key: 'setFetchingState',
    value: function setFetchingState() {
      this.setState({
        isFetching: false
      });
    }
  }, {
    key: 'unsetFetchingState',
    value: function unsetFetchingState() {
      this.setState({
        isFetching: false
      });
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      this.setFetchingState();
      var loadingPromise = this.props.fetchCurrentSiteUser();
      loadingPromise.then(this.unsetFetchingState, this.unsetFetchingState);

      return loadingPromise;
    }
  }, {
    key: 'childProps',
    get: function get() {
      return {
        isCurrentSiteUserFetching: this.state.isFetching
      };
    }
  }]);

  return CurrentSiteUser;
}(__WEBPACK_IMPORTED_MODULE_9_shared_data_components_data_loader__["a" /* default */]), _class3.displayName = 'CurrentSiteUser', _class3.propTypes = {
  fetchCurrentSiteUser: React.PropTypes.func
}, _temp2), (_applyDecoratedDescriptor(_class2.prototype, 'setFetchingState', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'setFetchingState'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'unsetFetchingState', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'unsetFetchingState'), _class2.prototype)), _class2)) || _class);


/***/ }),
/* 1735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UpdateChannelPublishedState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_redux_server_actions_channel_update__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_sdk__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_data_components_data_component__ = __webpack_require__(423);







var _dec, _class, _desc, _value, _class2, _class3, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}









var UpdateChannelPublishedState = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["a" /* connect */])(function (state) {
  return {
    currentChannelId: state.currentChannelId
  };
}, {
  updateChannel: __WEBPACK_IMPORTED_MODULE_8_shared_redux_server_actions_channel_update__["b" /* default */]
}), _dec(_class = (_class2 = (_temp = _class3 = function (_DataComponent) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(UpdateChannelPublishedState, _DataComponent);

  function UpdateChannelPublishedState() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, UpdateChannelPublishedState);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (UpdateChannelPublishedState.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(UpdateChannelPublishedState)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(UpdateChannelPublishedState, [{
    key: 'handleSitePublish',
    value: function handleSitePublish() {
      var _props = this.props,
          currentChannelId = _props.currentChannelId,
          updateChannel = _props.updateChannel;


      if (!currentChannelId) {
        return;
      }

      updateChannel({
        id: currentChannelId,
        onPublishedSite: true
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      __WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_sdk__["a" /* default */].addEventListener(__WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_sdk__["a" /* default */].Events.SITE_PUBLISHED, this.handleSitePublish);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      __WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_sdk__["a" /* default */].removeEventListener(__WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_sdk__["a" /* default */].Events.SITE_PUBLISHED, this.handleSitePublish);
    }
  }, {
    key: 'childProps',
    get: function get() {
      return {};
    }
  }]);

  return UpdateChannelPublishedState;
}(__WEBPACK_IMPORTED_MODULE_10_shared_data_components_data_component__["a" /* default */]), _class3.displayName = 'UpdateChannelPublishedState', _class3.propTypes = {
  currentChannelId: React.PropTypes.string,
  updateChannel: React.PropTypes.func
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'handleSitePublish', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handleSitePublish'), _class2.prototype)), _class2)) || _class);


/***/ }),
/* 1736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VISIT_CHANNEL */
/* unused harmony export OPEN_VIDEO_PAGE */
/* harmony export (immutable) */ __webpack_exports__["b"] = visitChannel;
/* harmony export (immutable) */ __webpack_exports__["a"] = openVideoPage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_utils_open_overlay__ = __webpack_require__(258);



var VISIT_CHANNEL = 'CLIENT.VISIT-CHANNEL';
var VISIT_CHANNEL_ACTION = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(VISIT_CHANNEL);

var OPEN_VIDEO_PAGE = 'CLIENT.OPEN.VIDEO-PAGE';
var OPEN_VIDEO_PAGE_ACTION = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(OPEN_VIDEO_PAGE);

function visitChannel() {
  return function (dispatch) {
    dispatch(VISIT_CHANNEL_ACTION());

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_utils_open_overlay__["e" /* openMobileOverlay */])();
  };
}

function openVideoPage(videoId) {
  return function (dispatch) {
    dispatch(OPEN_VIDEO_PAGE_ACTION());

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_utils_open_overlay__["e" /* openMobileOverlay */])('#/video/' + videoId);
  };
}

/***/ }),
/* 1737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = isExpandOnClick;
/* harmony export (immutable) */ __webpack_exports__["c"] = isAlwaysShow;
/* harmony export (immutable) */ __webpack_exports__["a"] = isNeverShow;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_default_settings__ = __webpack_require__(64);


function isExpandOnClick(status) {
  return status === __WEBPACK_IMPORTED_MODULE_0_default_settings__["k" /* channelVideoListValues */].EXPAND_ON_CLICK;
}

function isAlwaysShow(status) {
  return status === __WEBPACK_IMPORTED_MODULE_0_default_settings__["k" /* channelVideoListValues */].ALWAYS_SHOW;
}

function isNeverShow(status) {
  return Number(status) === __WEBPACK_IMPORTED_MODULE_0_default_settings__["k" /* channelVideoListValues */].NEVER_SHOW;
}

/***/ }),
/* 1738 */,
/* 1739 */,
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = decorate;

var _utils = __webpack_require__(259);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

var defineProperty = Object.defineProperty;


function handleDescriptor(target, key, descriptor, _ref) {
  var _ref2 = _toArray(_ref),
      decorator = _ref2[0],
      args = _ref2.slice(1);

  var configurable = descriptor.configurable,
      enumerable = descriptor.enumerable,
      writable = descriptor.writable;

  var originalGet = descriptor.get;
  var originalSet = descriptor.set;
  var originalValue = descriptor.value;
  var isGetter = !!originalGet;

  return {
    configurable: configurable,
    enumerable: enumerable,
    get: function get() {
      var fn = isGetter ? originalGet.call(this) : originalValue;
      var value = decorator.call.apply(decorator, [this, fn].concat(_toConsumableArray(args)));

      if (isGetter) {
        return value;
      } else {
        var desc = {
          configurable: configurable,
          enumerable: enumerable
        };

        desc.value = value;
        desc.writable = writable;

        defineProperty(this, key, desc);

        return value;
      }
    },

    set: isGetter ? originalSet : (0, _utils.createDefaultSetter)()
  };
}

function decorate() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return (0, _utils.decorate)(handleDescriptor, args);
}

/***/ }),
/* 1741 */,
/* 1742 */,
/* 1743 */,
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof module === "object" && module.exports) {
    module.exports = factory();
  } else {
    root.Scrollparent = factory();
  }
}(this, function () {
  var regex = /(auto|scroll)/;

  var parents = function (node, ps) {
    if (node.parentNode === null) { return ps; }

    return parents(node.parentNode, ps.concat([node]));
  };

  var style = function (node, prop) {
    return getComputedStyle(node, null).getPropertyValue(prop);
  };

  var overflow = function (node) {
    return style(node, "overflow") + style(node, "overflow-y") + style(node, "overflow-x");
  };

  var scroll = function (node) {
   return regex.test(overflow(node));
  };

  var scrollParent = function (node) {
    if (!(node instanceof HTMLElement || node instanceof SVGElement)) {
      return ;
    }

    var ps = parents(node.parentNode, []);

    for (var i = 0; i < ps.length; i += 1) {
      if (scroll(ps[i])) {
        return ps[i];
      }
    }

    return document.scrollingElement || document.documentElement;
  };

  return scrollParent;
}));


/***/ }),
/* 1745 */,
/* 1746 */,
/* 1747 */,
/* 1748 */,
/* 1749 */,
/* 1750 */,
/* 1751 */,
/* 1752 */,
/* 1753 */,
/* 1754 */,
/* 1755 */,
/* 1756 */,
/* 1757 */,
/* 1758 */,
/* 1759 */,
/* 1760 */,
/* 1761 */,
/* 1762 */,
/* 1763 */,
/* 1764 */,
/* 1765 */,
/* 1766 */,
/* 1767 */,
/* 1768 */,
/* 1769 */,
/* 1770 */,
/* 1771 */,
/* 1772 */,
/* 1773 */,
/* 1774 */,
/* 1775 */,
/* 1776 */,
/* 1777 */,
/* 1778 */,
/* 1779 */,
/* 1780 */,
/* 1781 */,
/* 1782 */,
/* 1783 */,
/* 1784 */,
/* 1785 */,
/* 1786 */,
/* 1787 */,
/* 1788 */,
/* 1789 */,
/* 1790 */,
/* 1791 */,
/* 1792 */,
/* 1793 */,
/* 1794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClampText; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_text_overflow_clamp__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_text_overflow_clamp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_text_overflow_clamp__);






var _class, _temp;



var ClampText = (_temp = _class = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ClampText, _React$PureComponent);

  function ClampText() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ClampText);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ClampText.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ClampText)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ClampText, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.clamp();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.clamp();
    }
  }, {
    key: 'clamp',
    value: function clamp() {
      var clampOptions = _.omit(this.props, 'children');

      __WEBPACK_IMPORTED_MODULE_5_text_overflow_clamp___default()(this._textNode, clampOptions);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          children = _props.children;


      return React.createElement(
        'p',
        { ref: function ref(node) {
            return _this2._textNode = node;
          },
          className: className,
          style: { margin: 0, padding: 0 } },
        children
      );
    }
  }]);

  return ClampText;
}(React.PureComponent), _class.propTypes = {
  className: React.PropTypes.string,
  children: React.PropTypes.string,
  lineClamp: React.PropTypes.number,
  truncateText: React.PropTypes.string,
  textAlign: React.PropTypes.string
}, _class.defaultProps = {
  lineClamp: 2,
  truncateText: '',
  textAlign: ''
}, _temp);


/***/ }),
/* 1795 */,
/* 1796 */,
/* 1797 */,
/* 1798 */,
/* 1799 */,
/* 1800 */,
/* 1801 */,
/* 1802 */,
/* 1803 */,
/* 1804 */,
/* 1805 */,
/* 1806 */,
/* 1807 */,
/* 1808 */,
/* 1809 */,
/* 1810 */,
/* 1811 */,
/* 1812 */,
/* 1813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getSearchQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getSearchQueryField; });
var getSearchQuery = function getSearchQuery(state) {
  return state.search.searchQuery;
};
var getSearchQueryField = function getSearchQueryField(state) {
  return state.search.searchQueryField;
};

/***/ }),
/* 1814 */,
/* 1815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export optionShape */
var optionShape = React.PropTypes.shape({
  value: React.PropTypes.any,
  label: React.PropTypes.string
});

/* harmony default export */ __webpack_exports__["a"] = (React.PropTypes.arrayOf(optionShape));

/***/ }),
/* 1816 */,
/* 1817 */,
/* 1818 */,
/* 1819 */,
/* 1820 */,
/* 1821 */,
/* 1822 */,
/* 1823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccountButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_utils_wix_sdk__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_selectors_app_settings__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_widget_selectors_current_site_user__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_shared_ui_selectors_channel_pricing__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_shared_constants_events__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_shared_bi_bi__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_shared_components_button_button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_shared_constants_popout__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__account_info_button_account_info_button__ = __webpack_require__(2494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__account_info_button_with_tooltip_account_button_with_tooltip__ = __webpack_require__(2493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__account_button_styl__ = __webpack_require__(2054);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__account_button_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__account_button_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_widget_components_account_translations__ = __webpack_require__(1257);







var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

























var AccountButton = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_redux__["a" /* connect */])(function (state, ownProps) {
  return {
    appSettings: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_shared_selectors_app_settings__["a" /* getAllSettings */])(state),
    userEmail: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_widget_selectors_current_site_user__["b" /* getCurrentUserEmail */])(state),
    isSubscriptionEnabled: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_shared_ui_selectors_channel_pricing__["a" /* isSubscriptionEnabled */])(ownProps.channelData)
  };
}), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_21__account_button_styl___default.a), _dec(_class = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_react_intl__["d" /* injectIntl */])(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(AccountButton, _React$Component);

  function AccountButton() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, AccountButton);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AccountButton.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(AccountButton)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(AccountButton, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      __WEBPACK_IMPORTED_MODULE_10_shared_utils_wix_sdk__["a" /* default */].PubSub.subscribe(__WEBPACK_IMPORTED_MODULE_15_shared_constants_events__["a" /* default */].SESSION.LOGOUT_USER, this.handleLogoutEvent);
      __WEBPACK_IMPORTED_MODULE_10_shared_utils_wix_sdk__["a" /* default */].PubSub.subscribe(__WEBPACK_IMPORTED_MODULE_15_shared_constants_events__["a" /* default */].PAYMENT.CANCEL_SUBSCRIPTION, this.handleSubscriptionCancelEvent);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unsubscribeLogoutEvent();
      this.unsubscribeSubscriptionEvent();
    }
  }, {
    key: 'handleLogoutEvent',
    value: function handleLogoutEvent() {
      this.props.onLogoutClick();
      this.unsubscribeLogoutEvent();
    }
  }, {
    key: 'handleSubscriptionCancelEvent',
    value: function handleSubscriptionCancelEvent() {
      this.props.onSubscriptionCancelClick();
      this.unsubscribeSubscriptionEvent();
    }
  }, {
    key: 'handleAccountButtonClicked',
    value: function handleAccountButtonClicked() {
      this.props.onClick();
      __WEBPACK_IMPORTED_MODULE_16_shared_bi_bi__["a" /* default */].logWidgetSystem('user.info.fullscreenModal.requested');
    }
  }, {
    key: 'unsubscribeLogoutEvent',
    value: function unsubscribeLogoutEvent() {
      __WEBPACK_IMPORTED_MODULE_10_shared_utils_wix_sdk__["a" /* default */].PubSub.unsubscribe(__WEBPACK_IMPORTED_MODULE_15_shared_constants_events__["a" /* default */].SESSION.LOGOUT_USER, this.handleLogoutEvent);
    }
  }, {
    key: 'unsubscribeSubscriptionEvent',
    value: function unsubscribeSubscriptionEvent() {
      __WEBPACK_IMPORTED_MODULE_10_shared_utils_wix_sdk__["a" /* default */].PubSub.unsubscribe(__WEBPACK_IMPORTED_MODULE_15_shared_constants_events__["a" /* default */].PAYMENT.CANCEL_SUBSCRIPTION, this.handleSubscriptionCancelEvent);
    }
  }, {
    key: 'renderLoginButton',
    value: function renderLoginButton() {
      var _props = this.props,
          className = _props.className,
          onLoginClick = _props.onLoginClick;


      return React.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()('qa-sign-in', className) },
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_17_shared_components_button_button__["e" /* LinkButton */],
          { styleName: 'account-button',
            onClick: onLoginClick,
            'data-hook': 'loginButton' },
          this.formatMessage(__WEBPACK_IMPORTED_MODULE_22_widget_components_account_translations__["a" /* default */].signIn)
        )
      );
    }
  }, {
    key: 'renderAccountButtonWithTooltip',
    value: function renderAccountButtonWithTooltip() {
      var _props2 = this.props,
          infoButtonClassName = _props2.infoButtonClassName,
          infoButtonTooltipClassName = _props2.infoButtonTooltipClassName,
          infoButtonPopoutTriangleClassName = _props2.infoButtonPopoutTriangleClassName,
          userEmail = _props2.userEmail,
          tooltipSide = _props2.tooltipSide,
          onLogoutClick = _props2.onLogoutClick;


      return React.createElement(__WEBPACK_IMPORTED_MODULE_20__account_info_button_with_tooltip_account_button_with_tooltip__["a" /* default */], { className: infoButtonClassName,
        popoutClassName: infoButtonTooltipClassName,
        popoutTriangleClassName: infoButtonPopoutTriangleClassName,
        logoutLabel: this.formatMessage(__WEBPACK_IMPORTED_MODULE_22_widget_components_account_translations__["a" /* default */].logout),
        tooltipSide: tooltipSide,
        userEmail: userEmail,
        onLogoutClick: onLogoutClick,
        dataHook: 'infoButtonWithTooltip' });
    }
  }, {
    key: 'renderAccountButtonSimple',
    value: function renderAccountButtonSimple() {
      var infoButtonClassName = this.props.infoButtonClassName;


      return React.createElement(__WEBPACK_IMPORTED_MODULE_19__account_info_button_account_info_button__["a" /* default */], { className: infoButtonClassName,
        onClick: this.handleAccountButtonClicked });
    }
  }, {
    key: 'renderAccountButton',
    value: function renderAccountButton() {
      var isSubscriptionEnabled = this.props.isSubscriptionEnabled;


      return isSubscriptionEnabled ? this.renderAccountButtonSimple() : this.renderAccountButtonWithTooltip();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          className = _props3.className,
          userEmail = _props3.userEmail;


      if (!userEmail) {
        return this.renderLoginButton();
      }

      return React.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()('qa-account', className),
          styleName: 'account-info-button-wrapper' },
        this.renderAccountButton()
      );
    }
  }, {
    key: 'formatMessage',
    get: function get() {
      return this.props.intl.formatMessage;
    }
  }]);

  return AccountButton;
}(React.Component), _class3.propTypes = {
  className: React.PropTypes.string,
  infoButtonClassName: React.PropTypes.string,
  infoButtonTooltipClassName: React.PropTypes.string,
  infoButtonPopoutTriangleClassName: React.PropTypes.string,

  appSettings: React.PropTypes.object,
  userEmail: React.PropTypes.string,
  intl: __WEBPACK_IMPORTED_MODULE_9_react_intl__["e" /* intlShape */],

  onLoginClick: React.PropTypes.func,
  onLogoutClick: React.PropTypes.func,
  //click on a simple logout button
  onClick: React.PropTypes.func,
  onSubscriptionCancelClick: React.PropTypes.func,
  onSubscribeClick: React.PropTypes.func,
  tooltipSide: React.PropTypes.oneOf(_.values(__WEBPACK_IMPORTED_MODULE_18_shared_constants_popout__["a" /* sides */])),

  isSubscriptionEnabled: React.PropTypes.bool
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'handleLogoutEvent', [__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handleLogoutEvent'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleSubscriptionCancelEvent', [__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handleSubscriptionCancelEvent'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleAccountButtonClicked', [__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handleAccountButtonClicked'), _class2.prototype)), _class2)) || _class) || _class) || _class);


/***/ }),
/* 1824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccountInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_components_button_button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__account_info_styl__ = __webpack_require__(1885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__account_info_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__account_info_styl__);






var _dec, _class, _class2, _temp;






var AccountInfo = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_7__account_info_styl___default.a), _dec(_class = (_temp = _class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(AccountInfo, _React$Component);

  function AccountInfo() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AccountInfo);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AccountInfo.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(AccountInfo)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(AccountInfo, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          userEmail = _props.userEmail,
          logoutLabel = _props.logoutLabel,
          onLogoutClick = _props.onLogoutClick;
      var content = this.content;


      return React.createElement(
        'div',
        { styleName: 'container' },
        React.createElement(
          'div',
          { styleName: 'user-email',
            className: 'qa-account-button-user-email' },
          userEmail
        ),
        content,
        React.createElement(
          'div',
          { styleName: 'logout-wrapper' },
          React.createElement(
            __WEBPACK_IMPORTED_MODULE_6_shared_components_button_button__["e" /* LinkButton */],
            { styleName: 'logout',
              'data-hook': 'accountInfoLogoutButton',
              className: 'qa-account-button-user-logout',
              onClick: onLogoutClick },
            logoutLabel
          )
        )
      );
    }
  }, {
    key: 'content',
    get: function get() {
      var children = this.props.children;

      return children ? React.createElement(
        'div',
        null,
        children
      ) : null;
    }
  }]);

  return AccountInfo;
}(React.Component), _class2.propTypes = {
  userEmail: React.PropTypes.string,
  logoutLabel: React.PropTypes.string,
  children: React.PropTypes.any,

  onLogoutClick: React.PropTypes.func
}, _temp)) || _class);


/***/ }),
/* 1825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccountForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_utils_wix_sdk__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_widget_selectors_current_site_user__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_utils_request_login__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_bi_send_bi_event__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_shared_constants_payments__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_shared_components_button_button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_widget_components_button_button__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__account_form_styl__ = __webpack_require__(1886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__account_form_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__account_form_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__translations__ = __webpack_require__(1257);







var _dec, _dec2, _dec3, _dec4, _class, _desc, _value, _class2, _class3, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}





















var AccountForm = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_redux__["a" /* connect */])(function (state) {
  return {
    currentSiteUser: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_widget_selectors_current_site_user__["a" /* getCurrentSiteUser */])(state)
  };
}), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_17__account_form_styl___default.a), _dec3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_shared_bi_send_bi_event__["a" /* withBiEvent */])('widget.signup.clicked'), _dec4 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_shared_bi_send_bi_event__["a" /* withBiEvent */])('widget.signIn.clicked'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_intl__["d" /* injectIntl */])(_class = _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(AccountForm, _React$Component);

  function AccountForm() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, AccountForm);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AccountForm.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(AccountForm)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(AccountForm, [{
    key: 'clickSignUpButtonHandler',
    value: function clickSignUpButtonHandler() {
      var onUserLogin = this.props.onUserLogin;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_shared_utils_request_login__["a" /* requestLogin */])().then(onUserLogin);
    }
  }, {
    key: 'clickSignInButtonHandler',
    value: function clickSignInButtonHandler() {
      var onUserLogin = this.props.onUserLogin;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_shared_utils_request_login__["a" /* requestLogin */])({ isLogin: true }).then(onUserLogin);
    }
  }, {
    key: 'clickLogOutButtonHandler',
    value: function clickLogOutButtonHandler() {
      __WEBPACK_IMPORTED_MODULE_10_shared_utils_wix_sdk__["a" /* default */].logOutCurrentMember();
      this.props.onUserLogout();
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'section',
        { styleName: 'wrapper' },
        this.activity,
        this.proceedButton
      );
    }
  }, {
    key: 'activity',
    get: function get() {
      var _props = this.props,
          currentSiteUser = _props.currentSiteUser,
          paymentType = _props.paymentType;


      if (paymentType === __WEBPACK_IMPORTED_MODULE_14_shared_constants_payments__["a" /* PAYMENT_TYPE */].MEMBER_ONLY) {
        return this.memberOnlyActivity;
      }

      if (currentSiteUser) {
        return this.signedActivity;
      }

      return this.signInActivity;
    }
  }, {
    key: 'memberOnlyActivity',
    get: function get() {
      return React.createElement(
        'div',
        { styleName: 'content-wrapper' },
        React.createElement(
          'header',
          { styleName: 'header' },
          React.createElement(
            'div',
            null,
            React.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */], __WEBPACK_IMPORTED_MODULE_18__translations__["a" /* default */].signInToWatch1)
          ),
          React.createElement(
            'div',
            null,
            React.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */], __WEBPACK_IMPORTED_MODULE_18__translations__["a" /* default */].signInToWatch2)
          )
        ),
        this.signUpBlock
      );
    }
  }, {
    key: 'signInActivity',
    get: function get() {
      return React.createElement(
        'div',
        { styleName: 'content-wrapper' },
        React.createElement(
          'header',
          { styleName: 'header' },
          React.createElement(
            'div',
            null,
            React.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */], __WEBPACK_IMPORTED_MODULE_18__translations__["a" /* default */].signInToComplete1)
          ),
          React.createElement(
            'div',
            null,
            React.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */], __WEBPACK_IMPORTED_MODULE_18__translations__["a" /* default */].signInToComplete2)
          )
        ),
        this.signUpBlock
      );
    }
  }, {
    key: 'signUpBlock',
    get: function get() {
      var formatMessage = this.props.intl.formatMessage;

      var haveAccountMessage = formatMessage(__WEBPACK_IMPORTED_MODULE_18__translations__["a" /* default */].haveAccount) + ' ';

      return React.createElement(
        'div',
        null,
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_16_widget_components_button_button__["a" /* default */],
          { styleName: 'sign-up-button',
            className: 'qa-widget-payment-signup-button',
            onClick: this.clickSignUpButtonHandler,
            disableTheme: true,
            'data-hook': 'signUpButton' },
          React.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */], __WEBPACK_IMPORTED_MODULE_18__translations__["a" /* default */].signUp)
        ),
        React.createElement(
          'div',
          { styleName: 'sign-in-wrapper' },
          haveAccountMessage,
          React.createElement(
            __WEBPACK_IMPORTED_MODULE_15_shared_components_button_button__["e" /* LinkButton */],
            { onClick: this.clickSignInButtonHandler,
              styleName: 'sign-in-button',
              'data-hook': 'signInButton' },
            React.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */], __WEBPACK_IMPORTED_MODULE_18__translations__["a" /* default */].signIn)
          )
        )
      );
    }
  }, {
    key: 'signedActivity',
    get: function get() {
      var currentSiteUser = this.props.currentSiteUser;


      return React.createElement(
        'div',
        { styleName: 'content-wrapper',
          'data-hook': 'signedWrapper' },
        React.createElement(
          'header',
          { styleName: 'header' },
          React.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */], __WEBPACK_IMPORTED_MODULE_18__translations__["a" /* default */].readyAction)
        ),
        React.createElement(
          'div',
          { styleName: 'signed-message' },
          React.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */], __WEBPACK_IMPORTED_MODULE_18__translations__["a" /* default */].signedAs)
        ),
        React.createElement(
          'div',
          null,
          currentSiteUser.email
        ),
        React.createElement(
          'div',
          { styleName: 'signed-message' },
          React.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */], __WEBPACK_IMPORTED_MODULE_18__translations__["a" /* default */].notYourAccount),
          ' ',
          React.createElement(
            __WEBPACK_IMPORTED_MODULE_15_shared_components_button_button__["e" /* LinkButton */],
            { onClick: this.clickLogOutButtonHandler,
              styleName: 'logout-button' },
            React.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */], __WEBPACK_IMPORTED_MODULE_18__translations__["a" /* default */].logout)
          )
        )
      );
    }
  }, {
    key: 'proceedButton',
    get: function get() {
      var _props2 = this.props,
          currentSiteUser = _props2.currentSiteUser,
          proceedText = _props2.proceedText,
          proceedAction = _props2.proceedAction;


      if (!currentSiteUser || !proceedText) {
        return null;
      }

      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_16_widget_components_button_button__["a" /* default */],
        { styleName: 'proceed-button',
          onClick: proceedAction,
          disableTheme: true },
        proceedText
      );
    }
  }]);

  return AccountForm;
}(React.Component), _class3.propTypes = {
  proceedText: React.PropTypes.any,
  proceedAction: React.PropTypes.func,
  currentSiteUser: React.PropTypes.object,
  onUserLogin: React.PropTypes.func,
  onUserLogout: React.PropTypes.func,
  paymentType: React.PropTypes.oneOf([__WEBPACK_IMPORTED_MODULE_14_shared_constants_payments__["a" /* PAYMENT_TYPE */].SUBSCRIPTION, __WEBPACK_IMPORTED_MODULE_14_shared_constants_payments__["a" /* PAYMENT_TYPE */].PURCHASE, __WEBPACK_IMPORTED_MODULE_14_shared_constants_payments__["a" /* PAYMENT_TYPE */].RENT, __WEBPACK_IMPORTED_MODULE_14_shared_constants_payments__["a" /* PAYMENT_TYPE */].MEMBER_ONLY]),
  intl: __WEBPACK_IMPORTED_MODULE_7_react_intl__["e" /* intlShape */]
}, _class3.defaultProps = {
  proceedAction: _.noop,
  onUserLogin: _.noop,
  onUserLogout: _.noop,
  centered: false
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'clickSignUpButtonHandler', [__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default.a, _dec3], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'clickSignUpButtonHandler'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'clickSignInButtonHandler', [__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default.a, _dec4], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'clickSignInButtonHandler'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'clickLogOutButtonHandler', [__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'clickLogOutButtonHandler'), _class2.prototype)), _class2)) || _class) || _class) || _class);


/***/ }),
/* 1826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChannelInfoButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_utils_run_once__ = __webpack_require__(2000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_components_button_button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_components_icon_icon__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_utils_layout_helpers__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__channel_actions_styl__ = __webpack_require__(2055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__channel_actions_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__channel_actions_styl__);







var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}












var ChannelInfoButton = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_redux__["a" /* connect */])(function (state) {
  return {
    isVisible: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_shared_utils_layout_helpers__["g" /* isChannelInfoVisible */])(state.appSettings)
  };
}), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_shared_utils_wix_connect__["c" /* VODBiEvents */])(), _dec3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_13__channel_actions_styl___default.a), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ChannelInfoButton, _React$Component);

  function ChannelInfoButton() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ChannelInfoButton);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ChannelInfoButton.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(ChannelInfoButton)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ChannelInfoButton, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.sendAboutInfoDisplayedBI();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.sendAboutInfoDisplayedBI();
    }
  }, {
    key: 'sendAboutInfoDisplayedBI',
    value: function sendAboutInfoDisplayedBI() {
      if (this.props.isVisible) {
        this.doSendAboutInfoDisplayedBI();
      }
    }
  }, {
    key: 'doSendAboutInfoDisplayedBI',
    value: function doSendAboutInfoDisplayedBI() {
      this.props.biEvent('widget.aboutCh.displayed');
    }
  }, {
    key: 'sendClickedBI',
    value: function sendClickedBI() {
      this.props.biEvent('widget.aboutCh.clicked');
    }
  }, {
    key: 'handleClick',
    value: function handleClick(event) {
      this.sendClickedBI();
      this.props.onClick(event);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          isVisible = _props.isVisible,
          dataHook = _props.dataHook;


      if (!isVisible) {
        return null;
      }

      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_10_shared_components_button_button__["e" /* LinkButton */],
        { className: 'qa-info-button ' + className,
          styleName: 'action info',
          'data-hook': dataHook,
          onClick: this.handleClick },
        React.createElement(__WEBPACK_IMPORTED_MODULE_11_shared_components_icon_icon__["a" /* default */], { styleName: 'back-button',
          name: 'info-1' })
      );
    }
  }]);

  return ChannelInfoButton;
}(React.Component), _class3.propTypes = {
  isVisible: React.PropTypes.bool,
  channelData: React.PropTypes.object,
  className: React.PropTypes.string,
  onClick: React.PropTypes.func,
  biEvent: React.PropTypes.func,
  dataHook: React.PropTypes.string
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'doSendAboutInfoDisplayedBI', [__WEBPACK_IMPORTED_MODULE_9_shared_utils_run_once__["a" /* default */]], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'doSendAboutInfoDisplayedBI'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleClick', [__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handleClick'), _class2.prototype)), _class2)) || _class) || _class) || _class);


/***/ }),
/* 1827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContentSlider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__content_slider_styl__ = __webpack_require__(3256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__content_slider_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__content_slider_styl__);






var _dec, _class, _class2, _temp;




var ContentSlider = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_6__content_slider_styl___default.a), _dec(_class = (_temp = _class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ContentSlider, _React$Component);

  function ContentSlider() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ContentSlider);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ContentSlider.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ContentSlider)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ContentSlider, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className;


      return React.createElement(
        'section',
        { styleName: 'container',
          className: className },
        React.createElement(
          'div',
          { styleName: 'content',
            'data-hook': 'contentSliderContent',
            style: this.currentPageOffset },
          children
        )
      );
    }
  }, {
    key: 'currentPageOffset',
    get: function get() {
      var _props2 = this.props,
          currentPageNumber = _props2.currentPageNumber,
          width = _props2.width;

      return {
        transform: 'translate3d(' + -1 * currentPageNumber * width + 'px, 0, 0)'
      };
    }
  }]);

  return ContentSlider;
}(React.Component), _class2.propTypes = {
  className: React.PropTypes.string,
  currentPageNumber: React.PropTypes.number,
  width: React.PropTypes.number.isRequired,
  children: React.PropTypes.any
}, _temp)) || _class);


/***/ }),
/* 1828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_components_icon_icon__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__no_videos_content_styl__ = __webpack_require__(1888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__no_videos_content_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__no_videos_content_styl__);



var NoVideosContent = function NoVideosContent(_ref) {
  var width = _ref.width,
      height = _ref.height;
  return React.createElement(
    'div',
    { className: __WEBPACK_IMPORTED_MODULE_1__no_videos_content_styl___default.a['no-videos'],
      style: { width: width, height: height },
      'data-hook': 'noPlayer' },
    React.createElement(__WEBPACK_IMPORTED_MODULE_0_shared_components_icon_icon__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_1__no_videos_content_styl___default.a.play,
      name: 'arrow-right-filled' })
  );
};

NoVideosContent.propTypes = {
  width: React.PropTypes.number,
  height: React.PropTypes.number
};

/* harmony default export */ __webpack_exports__["a"] = (NoVideosContent);

/***/ }),
/* 1829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__page_list_styl__ = __webpack_require__(3264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__page_list_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__page_list_styl__);







var _desc, _value, _class, _class2, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}




var PRE_RENDERED_COUNT = 1;

var PageList = (_class = (_temp = _class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(PageList, _React$Component);

  function PageList() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, PageList);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PageList.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(PageList)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(PageList, [{
    key: 'shouldRenderPage',
    value: function shouldRenderPage(pageIndex) {
      var currentPageNumber = this.props.currentPageNumber;

      return Math.abs(currentPageNumber - pageIndex) <= PRE_RENDERED_COUNT;
    }
  }, {
    key: 'renderPageItems',
    value: function renderPageItems(pageIds, index) {
      var renderItem = this.props.renderItem;

      return this.shouldRenderPage(index) ? _.map(pageIds, renderItem) : null;
    }
  }, {
    key: 'renderPage',
    value: function renderPage(items, pageNumber) {
      var pageWidth = this.props.pageWidth;


      return React.createElement(
        'div',
        { key: pageNumber,
          className: __WEBPACK_IMPORTED_MODULE_7__page_list_styl___default.a.page,
          style: { width: pageWidth } },
        this.renderPageItems(items, pageNumber)
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var itemsByPageNumber = this.props.itemsByPageNumber;


      return React.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_7__page_list_styl___default.a.container },
        _.map(itemsByPageNumber, this.renderPage)
      );
    }
  }]);

  return PageList;
}(React.Component), _class2.propTypes = {
  currentPageNumber: React.PropTypes.number,
  pageWidth: React.PropTypes.number,
  itemsByPageNumber: React.PropTypes.arrayOf(React.PropTypes.array),
  renderItem: React.PropTypes.func
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'renderPage', [__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'renderPage'), _class.prototype)), _class);


/***/ }),
/* 1830 */,
/* 1831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return openSubscription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return openPurchase; });
/* unused harmony export openRent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_widget_utils_not_for_preview__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_components_modal_modal__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_widget_utils_reload__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_components_modal_header_header__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_constants_payments__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__payment_form__ = __webpack_require__(1729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__payments_styl__ = __webpack_require__(1891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__payments_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__payments_styl__);












var storeDataForReload = function storeDataForReload(_ref) {
  var paymentType = _ref.paymentType,
      selectedVideoId = _ref.selectedVideoId;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_widget_utils_reload__["a" /* storeForReload */])({
    openedModalType: paymentType,
    selectedVideoId: selectedVideoId
  });
};

var openSubscription = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_widget_utils_not_for_preview__["a" /* notForPreview */])(function (biEvent) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_components_modal_modal__["b" /* openModal */])({
    Header: __WEBPACK_IMPORTED_MODULE_4_shared_components_modal_header_header__["d" /* EmptyModalHeader */],
    windowClassName: __WEBPACK_IMPORTED_MODULE_7__payments_styl___default.a['auth-window'],
    className: __WEBPACK_IMPORTED_MODULE_7__payments_styl___default.a['auth-modal'],
    contentClassName: __WEBPACK_IMPORTED_MODULE_7__payments_styl___default.a['auth-modal-content'],
    closeOnOverlayClick: true,
    content: React.createElement(__WEBPACK_IMPORTED_MODULE_6__payment_form__["a" /* default */], { paymentType: __WEBPACK_IMPORTED_MODULE_5_shared_constants_payments__["a" /* PAYMENT_TYPE */].SUBSCRIPTION,
      onBeforePageRefresh: storeDataForReload })
  }).catch(function (reason) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_components_modal_modal__["e" /* isClose */])(reason)) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(reason);
    }
    biEvent('widget.subscriptionPopUp.Completed', { result: 'canceled', errorMsg: '' });
  });
});

var openPurchase = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_widget_utils_not_for_preview__["a" /* notForPreview */])(function (videoId) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_components_modal_modal__["b" /* openModal */])({
    Header: __WEBPACK_IMPORTED_MODULE_4_shared_components_modal_header_header__["d" /* EmptyModalHeader */],
    windowClassName: __WEBPACK_IMPORTED_MODULE_7__payments_styl___default.a['auth-window'],
    className: __WEBPACK_IMPORTED_MODULE_7__payments_styl___default.a['auth-modal'],
    contentClassName: __WEBPACK_IMPORTED_MODULE_7__payments_styl___default.a['auth-modal-content'],
    closeOnOverlayClick: true,
    content: React.createElement(__WEBPACK_IMPORTED_MODULE_6__payment_form__["a" /* default */], { paymentType: __WEBPACK_IMPORTED_MODULE_5_shared_constants_payments__["a" /* PAYMENT_TYPE */].PURCHASE,
      videoId: videoId,
      onBeforePageRefresh: storeDataForReload })
  }).catch(__WEBPACK_IMPORTED_MODULE_2_shared_components_modal_modal__["c" /* closeCatcher */]);
});

var openRent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_widget_utils_not_for_preview__["a" /* notForPreview */])(function (videoId) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_shared_components_modal_modal__["b" /* openModal */])({
    Header: __WEBPACK_IMPORTED_MODULE_4_shared_components_modal_header_header__["d" /* EmptyModalHeader */],
    windowClassName: __WEBPACK_IMPORTED_MODULE_7__payments_styl___default.a['auth-window'],
    className: __WEBPACK_IMPORTED_MODULE_7__payments_styl___default.a['auth-modal'],
    contentClassName: __WEBPACK_IMPORTED_MODULE_7__payments_styl___default.a['auth-modal-content'],
    closeOnOverlayClick: true,
    content: React.createElement(__WEBPACK_IMPORTED_MODULE_6__payment_form__["a" /* default */], { paymentType: __WEBPACK_IMPORTED_MODULE_5_shared_constants_payments__["a" /* PAYMENT_TYPE */].RENT,
      videoId: videoId,
      onBeforePageRefresh: storeDataForReload })
  }).catch(__WEBPACK_IMPORTED_MODULE_2_shared_components_modal_modal__["c" /* closeCatcher */]);
});

/***/ }),
/* 1832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OverlayStripMemberOnly; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_widget_utils_not_for_preview__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_selectors_app_settings__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__strip_base__ = __webpack_require__(1546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_components_icon_icon__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_components_button_button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_shared_components_resized_image_resized_image__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__member_only_styl__ = __webpack_require__(1893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__member_only_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__member_only_styl__);







var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}
















var OverlayStripMemberOnly = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["a" /* connect */])(function (state) {
  return {
    canShowMainItemTitle: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_shared_selectors_app_settings__["c" /* canShowMainItemTitle */])(state),
    canShowMainItemPublisher: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_shared_selectors_app_settings__["d" /* canShowMainItemPublisher */])(state)
  };
}), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_shared_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_15__member_only_styl___default.a), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_OverlayStripBase) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(OverlayStripMemberOnly, _OverlayStripBase);

  function OverlayStripMemberOnly() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, OverlayStripMemberOnly);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (OverlayStripMemberOnly.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(OverlayStripMemberOnly)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(OverlayStripMemberOnly, [{
    key: 'callPlayCallback',
    value: function callPlayCallback() {
      var _props = this.props,
          id = _props.videoItem.id,
          onPlayClick = _props.onPlayClick;

      onPlayClick(id);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          width = _props2.width,
          height = _props2.height;


      return React.createElement(
        'div',
        { styleName: 'wrapper' },
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_14_shared_components_resized_image_resized_image__["a" /* default */],
          { src: this.coverUrl,
            width: width,
            height: height },
          React.createElement(
            'div',
            { styleName: 'overlay',
              className: className },
            React.createElement(
              'div',
              { styleName: 'content' },
              React.createElement(
                'div',
                { styleName: 'top-content',
                  className: 'qa-player-overlay' },
                this.publisher,
                this.title,
                this.buttons
              )
            )
          )
        )
      );
    }
  }, {
    key: 'playButton',
    get: function get() {
      var playButtonText = this.playButtonText;

      if (!playButtonText) {
        return null;
      }

      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_13_shared_components_button_button__["f" /* GenericButton */],
        { styleName: 'button play-button',
          onClick: this.callPlayCallback,
          className: 'qa-widget-overlay-play-button' },
        React.createElement(__WEBPACK_IMPORTED_MODULE_12_shared_components_icon_icon__["b" /* RoundedIcon */], { styleName: 'icon play-icon',
          name: 'arrow-right-filled' }),
        React.createElement(
          'span',
          { styleName: 'text' },
          playButtonText
        )
      );
    }
  }, {
    key: 'buttons',
    get: function get() {
      var buttonsWrapperClassName = this.props.buttonsWrapperClassName;


      return React.createElement(
        'div',
        { styleName: 'buttons-wrapper',
          className: buttonsWrapperClassName },
        this.playButton
      );
    }
  }, {
    key: 'coverUrl',
    get: function get() {
      var _props3 = this.props,
          videoItem = _props3.videoItem,
          channelData = _props3.channelData;


      var coverUrl = videoItem.customCoverUrl || videoItem.coverUrl;

      if (this.isChannelCoverView) {
        coverUrl = channelData.customCoverUrl || channelData.coverUrl || coverUrl;
      }

      return coverUrl;
    }
  }]);

  return OverlayStripMemberOnly;
}(__WEBPACK_IMPORTED_MODULE_11__strip_base__["a" /* default */]), _class3.displayName = 'OverlayStripMemberOnly', _class3.propTypes = {
  width: React.PropTypes.number,
  height: React.PropTypes.number,
  buttonsWrapperClassName: React.PropTypes.string
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'callPlayCallback', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a, __WEBPACK_IMPORTED_MODULE_9_widget_utils_not_for_preview__["a" /* notForPreview */]], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'callPlayCallback'), _class2.prototype)), _class2)) || _class) || _class);


/***/ }),
/* 1833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OverlayStrip; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_selectors_app_settings__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__strip_base__ = __webpack_require__(1546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__strip_styl__ = __webpack_require__(1894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__strip_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__strip_styl__);






var _dec, _dec2, _class, _class2, _temp;











var OverlayStrip = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["a" /* connect */])(function (state) {
  return {
    canShowMainItemTitle: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_shared_selectors_app_settings__["c" /* canShowMainItemTitle */])(state),
    canShowMainItemPublisher: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_shared_selectors_app_settings__["d" /* canShowMainItemPublisher */])(state)
  };
}), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_shared_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_9__strip_styl___default.a), _dec(_class = _dec2(_class = (_temp = _class2 = function (_OverlayStripBase) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(OverlayStrip, _OverlayStripBase);

  function OverlayStrip() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, OverlayStrip);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (OverlayStrip.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(OverlayStrip)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(OverlayStrip, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          channelData = _props.channelData,
          className = _props.className;


      if (!channelData) {
        return null;
      }

      var styles = this.getOpacityStyles();

      return React.createElement(
        'div',
        { style: styles,
          styleName: 'overlay',
          className: className,
          'data-hook': 'playerOverlay',
          onClick: this.playSelectedVideo },
        React.createElement(
          'div',
          { styleName: 'content' },
          React.createElement(
            'div',
            { styleName: 'top-content',
              className: 'qa-player-overlay' },
            this.publisher,
            this.title,
            this.buttons
          )
        )
      );
    }
  }, {
    key: 'buttons',
    get: function get() {
      var _props2 = this.props,
          videoItem = _props2.videoItem,
          buttonsWrapperClassName = _props2.buttonsWrapperClassName;


      if (!videoItem) {
        return null;
      }

      return React.createElement(
        'div',
        { styleName: 'buttons-wrapper',
          className: buttonsWrapperClassName },
        this.playButton,
        this.subscribeButton || this.purchaseButton,
        this.playNextButton
      );
    }
  }]);

  return OverlayStrip;
}(__WEBPACK_IMPORTED_MODULE_8__strip_base__["a" /* default */]), _class2.displayName = 'OverlayStrip', _class2.propTypes = {
  buttonsWrapperClassName: React.PropTypes.string
}, _temp)) || _class) || _class);


/***/ }),
/* 1834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getContentToShare;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ShareChannel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_widget_player_widget__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_utils_layout_helpers__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_selectors_app_settings__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_widget_redux_server_actions_stats_report__ = __webpack_require__(1212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_constants_stats_events__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_widget_components_preview_prompt_preview_prompt__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_shared_components_icon_icon__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__share_channel_styl__ = __webpack_require__(3274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__share_channel_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__share_channel_styl__);







var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}



















function getContentToShare(channelData, appSettings) {
  if (!channelData) {
    return {};
  }

  var siteUrl = appSettings.siteUrl;
  var title = channelData.title,
      description = channelData.description;

  var coverUrl = channelData.customCoverUrl || channelData.coverUrl;

  return {
    siteUrl: siteUrl,
    title: title,
    description: description,
    coverUrl: coverUrl
  };
}

var ShareChannel = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_redux__["a" /* connect */])(function (state) {
  return {
    appSettings: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_shared_selectors_app_settings__["a" /* getAllSettings */])(state)
  };
}, {
  reportStats: __WEBPACK_IMPORTED_MODULE_12_widget_redux_server_actions_stats_report__["a" /* default */]
}), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_connect__["c" /* VODBiEvents */])(), _dec3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_16__share_channel_styl___default.a), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ShareChannel, _React$Component);

  function ShareChannel() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ShareChannel);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ShareChannel.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(ShareChannel)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ShareChannel, [{
    key: 'sendSharedBI',
    value: function sendSharedBI(networkName) {
      this.props.biEvent('widget.share.clicked', { typeShare: networkName });
    }
  }, {
    key: 'sendStatsReport',
    value: function sendStatsReport(name) {
      var _props = this.props,
          reportStats = _props.reportStats,
          channel = _props.channelData;


      reportStats(__WEBPACK_IMPORTED_MODULE_13_shared_constants_stats_events__["a" /* default */].CHANNEL_SHARE, {
        network: {
          name: name
        },
        channel: channel
      });
    }
  }, {
    key: 'handleShare',
    value: function handleShare(networkName) {
      this.sendSharedBI(networkName);
      this.sendStatsReport(networkName);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          appSettings = _props2.appSettings,
          className = _props2.className,
          buttonsClassName = _props2.buttonsClassName,
          channelData = _props2.channelData;


      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_shared_utils_layout_helpers__["h" /* isChannelShareVisible */])(appSettings)) {
        return null;
      }

      var contentToShare = getContentToShare(channelData, appSettings);
      return React.createElement(
        'section',
        { styleName: 'share-container',
          className: 'qa-share-channel ' + className },
        React.createElement(__WEBPACK_IMPORTED_MODULE_7_widget_player_widget__["c" /* SocialShare */], { styleName: 'share-buttons',
          className: buttonsClassName,
          buttonClassName: __WEBPACK_IMPORTED_MODULE_16__share_channel_styl___default.a['share-button'],
          networksClassNames: this.networksClassNames,
          onShare: this.handleShare,
          networks: ['facebook', 'twitter', 'pinterest', 'tumblr'],
          content: contentToShare,
          appSettings: appSettings,
          openPreviewPrompt: __WEBPACK_IMPORTED_MODULE_14_widget_components_preview_prompt_preview_prompt__["a" /* openPreviewPrompt */] }),
        React.createElement(__WEBPACK_IMPORTED_MODULE_15_shared_components_icon_icon__["a" /* default */], { name: 'share',
          styleName: 'share' })
      );
    }
  }, {
    key: 'networksClassNames',
    get: function get() {
      return _.pick(__WEBPACK_IMPORTED_MODULE_16__share_channel_styl___default.a, 'facebook', 'twitter', 'pinterest', 'tumblr');
    }
  }]);

  return ShareChannel;
}(React.Component), _class3.propTypes = {
  className: React.PropTypes.string,
  buttonsClassName: React.PropTypes.string,
  channelData: React.PropTypes.object,
  appSettings: React.PropTypes.object,
  reportStats: React.PropTypes.func,
  biEvent: React.PropTypes.func
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'handleShare', [__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handleShare'), _class2.prototype)), _class2)) || _class) || _class) || _class);


/***/ }),
/* 1835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tag; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__tag_styl__ = __webpack_require__(1896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__tag_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__tag_styl__);








var _dec, _class, _desc, _value, _class2, _class3, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}








var Tag = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_10__tag_styl___default.a), _dec(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Tag, _React$Component);

  function Tag() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Tag);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Tag.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Tag)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Tag, [{
    key: 'handleClick',
    value: function handleClick(event) {
      event.preventDefault();

      var _props = this.props,
          onClick = _props.onClick,
          text = _props.text;


      onClick(text);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          text = _props2.text,
          className = _props2.className,
          roundedClassName = _props2.roundedClassName,
          rounded = _props2.rounded,
          onFocus = _props2.onFocus,
          onBlur = _props2.onBlur;


      var styleNames = __WEBPACK_IMPORTED_MODULE_8_classnames___default()('tag', {
        rounded: rounded
      });
      var classNames = __WEBPACK_IMPORTED_MODULE_8_classnames___default()(className, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, roundedClassName, rounded && roundedClassName));

      return React.createElement(
        'a',
        { href: '#',
          styleName: styleNames,
          className: classNames,
          onClick: this.handleClick,
          onFocus: onFocus,
          onBlur: onBlur },
        React.createElement(
          'span',
          { styleName: 'inner' },
          text
        )
      );
    }
  }]);

  return Tag;
}(React.Component), _class3.propTypes = {
  text: React.PropTypes.string.isRequired,
  className: React.PropTypes.string,
  roundedClassName: React.PropTypes.string,
  onFocus: React.PropTypes.func,
  onClick: React.PropTypes.func,
  onBlur: React.PropTypes.func,
  rounded: React.PropTypes.bool
}, _class3.defaultProps = {
  onFocus: _.noop,
  onClick: _.noop,
  onBlur: _.noop,
  rounded: false
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'handleClick', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handleClick'), _class2.prototype)), _class2)) || _class);


/***/ }),
/* 1836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TagsCloud; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_selectors_app_settings__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__tag_tag__ = __webpack_require__(1835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__tags_cloud_styl__ = __webpack_require__(1897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__tags_cloud_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__tags_cloud_styl__);






var _dec, _dec2, _class, _class2, _temp;












var TagsCloud = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["a" /* connect */])(function (state) {
  return {
    isRounded: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_shared_selectors_app_settings__["b" /* areElementsRounded */])(state)
  };
}), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_10__tags_cloud_styl___default.a), _dec(_class = _dec2(_class = (_temp = _class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(TagsCloud, _React$Component);

  function TagsCloud() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, TagsCloud);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TagsCloud.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(TagsCloud)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(TagsCloud, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          tags = _props.tags,
          isRounded = _props.isRounded,
          className = _props.className,
          tagClassName = _props.tagClassName,
          roundedTagClassName = _props.roundedTagClassName,
          onTagClick = _props.onTagClick,
          onTagFocus = _props.onTagFocus,
          onTagBlur = _props.onTagBlur;


      var classNames = __WEBPACK_IMPORTED_MODULE_6_classnames___default()(__WEBPACK_IMPORTED_MODULE_10__tags_cloud_styl___default.a.tag, tagClassName);

      return React.createElement(
        'div',
        { className: className,
          styleName: 'tags-cloud',
          'data-hook': 'tags-cloud' },
        _.map(tags, function (tag) {
          return React.createElement(__WEBPACK_IMPORTED_MODULE_9__tag_tag__["a" /* default */], { key: tag,
            className: classNames,
            roundedClassName: roundedTagClassName,
            text: tag,
            rounded: isRounded,
            onClick: onTagClick,
            onFocus: onTagFocus,
            onBlur: onTagBlur });
        })
      );
    }
  }]);

  return TagsCloud;
}(React.Component), _class2.propTypes = {
  tags: React.PropTypes.arrayOf(React.PropTypes.string).isRequired,
  onTagFocus: React.PropTypes.func,
  onTagClick: React.PropTypes.func,
  onTagBlur: React.PropTypes.func,
  className: React.PropTypes.string,
  tagClassName: React.PropTypes.string,
  roundedTagClassName: React.PropTypes.string,
  isRounded: React.PropTypes.bool
}, _class2.defaultProps = {
  onTagClick: _.noop
}, _temp)) || _class) || _class);


/***/ }),
/* 1837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SetInitialWidgetSize; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_selectors_app_settings__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_widget_redux_client_actions_app_settings__ = __webpack_require__(352);







var _dec, _class, _desc, _value, _class2, _class3, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}








// If iFrame was hidden during loading, window.innerWidth can be = 0
// need to wait for setting real window.innerWidth

var SetInitialWidgetSize = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["a" /* connect */])(function (state) {
  return {
    requestedWidgetSize: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_shared_selectors_app_settings__["e" /* getRequestedWidgetSize */])(state),
    isSizeWasSet: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_shared_selectors_app_settings__["k" /* getIsInitialWidgetSizeWasSet */])(state)
  };
}, {
  updateAppSettings: __WEBPACK_IMPORTED_MODULE_9_widget_redux_client_actions_app_settings__["a" /* updateAppSettings */]
}), _dec(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(SetInitialWidgetSize, _React$Component);

  function SetInitialWidgetSize() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, SetInitialWidgetSize);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SetInitialWidgetSize.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(SetInitialWidgetSize)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(SetInitialWidgetSize, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.isSizeWasSet) {
        return;
      }
      this.updateWidgetSizeInterval = setInterval(this.updateWidgetSize, 200);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.updateWidgetSizeInterval);
    }
  }, {
    key: 'updateWidgetSize',
    value: function updateWidgetSize() {
      var widgetSize = {
        width: window.innerWidth,
        height: window.innerHeight
      };

      if (!widgetSize.width) {
        return;
      }

      clearInterval(this.updateWidgetSizeInterval);
      var _props = this.props,
          requestedWidgetSize = _props.requestedWidgetSize,
          updateAppSettings = _props.updateAppSettings;

      if (_.isEqual(requestedWidgetSize, widgetSize)) {
        return;
      }

      updateAppSettings({
        requestedWidgetSize: widgetSize
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return SetInitialWidgetSize;
}(React.Component), _class3.propTypes = {
  requestedWidgetSize: React.PropTypes.object,
  updateAppSettings: React.PropTypes.func,
  isSizeWasSet: React.PropTypes.bool
}, _class3.defaultProps = {
  disabled: false
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'updateWidgetSize', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'updateWidgetSize'), _class2.prototype)), _class2)) || _class);


/***/ }),
/* 1838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InFrameActionCallbacks; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_bi_send_bi_event__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_widget_utils_not_for_preview__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_widget_redux_client_actions_change_playback_status__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_widget_redux_client_actions_select_video__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_utils_open_overlay__ = __webpack_require__(258);







var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}












var InFrameActionCallbacks = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["a" /* connect */])(null, {
  playVideo: __WEBPACK_IMPORTED_MODULE_10_widget_redux_client_actions_change_playback_status__["a" /* playVideo */],
  selectVideo: __WEBPACK_IMPORTED_MODULE_11_widget_redux_client_actions_select_video__["a" /* selectVideo */]
}), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_shared_bi_send_bi_event__["a" /* withBiEvent */])('widget.vid.clicked', function () {
  var _props = this.props,
      channelId = _props.channelId,
      videoId = _props.videoId,
      videoSource = _props.videoSource;


  return {
    channelID: channelId,
    videoID: videoId,
    videoType: videoSource
  };
}), _dec(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(InFrameActionCallbacks, _React$Component);

  function InFrameActionCallbacks() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, InFrameActionCallbacks);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (InFrameActionCallbacks.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(InFrameActionCallbacks)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(InFrameActionCallbacks, [{
    key: 'selectVideo',
    value: function selectVideo() {
      var _props2 = this.props,
          selectVideo = _props2.selectVideo,
          videoId = _props2.videoId;

      selectVideo(videoId);
    }
  }, {
    key: 'playVideo',
    value: function playVideo() {
      var _props3 = this.props,
          playVideo = _props3.playVideo,
          videoId = _props3.videoId;

      playVideo(videoId);
    }
  }, {
    key: 'showVideoAtOverlay',
    value: function showVideoAtOverlay() {
      var _props4 = this.props,
          channelId = _props4.channelId,
          videoId = _props4.videoId;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_shared_utils_open_overlay__["a" /* openFullScreenOverlay */])('#/channel/' + channelId + '/video/' + videoId);
    }
  }, {
    key: 'showVideoMemberOnlyInfo',
    value: function showVideoMemberOnlyInfo() {
      var _props5 = this.props,
          channelId = _props5.channelId,
          videoId = _props5.videoId;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_shared_utils_open_overlay__["b" /* openFullScreenMemberOnlyOverlay */])(channelId, videoId);
    }
  }, {
    key: 'showVideoPurchaseInfo',
    value: function showVideoPurchaseInfo() {
      var _props6 = this.props,
          channelId = _props6.channelId,
          videoId = _props6.videoId;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_shared_utils_open_overlay__["d" /* openFullScreenPurchaseOverlay */])(channelId, videoId);
    }
  }, {
    key: 'showChannelSubscriptionInfoAtOverlay',
    value: function showChannelSubscriptionInfoAtOverlay() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_shared_utils_open_overlay__["c" /* openFullScreenSubscribeOverlay */])(this.props.channelId);
    }
  }, {
    key: 'handleSelectVideo',
    value: function handleSelectVideo() {
      this.props.onBeforeClick();
      this.selectVideo();
    }
  }, {
    key: 'handlePlayVideo',
    value: function handlePlayVideo() {
      this.props.onBeforePlayRequested();
      this.playVideo();
    }
  }, {
    key: 'render',
    value: function render() {
      return React.cloneElement(this.props.children, {
        onClick: this.handleSelectVideo,
        onPlayRequest: this.handlePlayVideo,
        onPlayMemberOnlyRequest: this.showVideoMemberOnlyInfo,
        onPlayWithoutPreviewRequest: this.showVideoAtOverlay,
        onPurchaseRequest: this.showVideoPurchaseInfo,
        onSubscriptionRequest: this.showChannelSubscriptionInfoAtOverlay
      });
    }
  }]);

  return InFrameActionCallbacks;
}(React.Component), _class3.propTypes = {
  children: React.PropTypes.element.isRequired,
  selectVideo: React.PropTypes.func.isRequired,
  playVideo: React.PropTypes.func.isRequired,
  onBeforeClick: React.PropTypes.func,
  onBeforePlayRequested: React.PropTypes.func,
  channelId: React.PropTypes.string,
  videoId: React.PropTypes.string,
  videoSource: React.PropTypes.string
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'selectVideo', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'selectVideo'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'playVideo', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a, _dec2], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'playVideo'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'showVideoAtOverlay', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a, __WEBPACK_IMPORTED_MODULE_9_widget_utils_not_for_preview__["a" /* notForPreview */]], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'showVideoAtOverlay'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'showVideoMemberOnlyInfo', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a, __WEBPACK_IMPORTED_MODULE_9_widget_utils_not_for_preview__["a" /* notForPreview */]], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'showVideoMemberOnlyInfo'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'showVideoPurchaseInfo', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a, __WEBPACK_IMPORTED_MODULE_9_widget_utils_not_for_preview__["a" /* notForPreview */]], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'showVideoPurchaseInfo'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'showChannelSubscriptionInfoAtOverlay', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a, __WEBPACK_IMPORTED_MODULE_9_widget_utils_not_for_preview__["a" /* notForPreview */]], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'showChannelSubscriptionInfoAtOverlay'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleSelectVideo', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handleSelectVideo'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handlePlayVideo', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handlePlayVideo'), _class2.prototype)), _class2)) || _class);


/***/ }),
/* 1839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_widget_components_preview_prompt_preview_prompt__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_utils_open_overlay__ = __webpack_require__(258);








function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}









// TODO move openPurchase openSubscription to view and use Player instead
// in the future, all functions like this will be combined to HOCs and will be used as wrappers at views
var extendWithFullScreenBuy = function extendWithFullScreenBuy(PlayerComponent) {
  var _dec, _class, _desc, _value, _class2, _class3, _temp;

  var FullScreenBuyExtensions = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_shared_utils_wix_connect__["a" /* WixConnect */])(), _dec(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(FullScreenBuyExtensions, _React$Component);

    function FullScreenBuyExtensions() {
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, FullScreenBuyExtensions);

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (FullScreenBuyExtensions.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(FullScreenBuyExtensions)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(FullScreenBuyExtensions, [{
      key: 'openPurchase',
      value: function openPurchase() {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_widget_components_preview_prompt_preview_prompt__["b" /* isPreviewMode */])()) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_widget_components_preview_prompt_preview_prompt__["a" /* openPreviewPrompt */])();
          return;
        }

        var _props = this.props,
            videoItem = _props.videoItem,
            channelData = _props.channelData;

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_shared_utils_open_overlay__["d" /* openFullScreenPurchaseOverlay */])(channelData.id, videoItem.id);
      }
    }, {
      key: 'openSubscription',
      value: function openSubscription() {
        var _this2 = this;

        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_widget_components_preview_prompt_preview_prompt__["b" /* isPreviewMode */])()) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_widget_components_preview_prompt_preview_prompt__["a" /* openPreviewPrompt */])();
          return;
        }

        var channelData = this.props.channelData;


        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_shared_utils_open_overlay__["c" /* openFullScreenSubscribeOverlay */])(channelData.id, function () {
          _this2.props.biEvent('widget.subscriptionPopUp.Completed', { result: 'canceled', errorMsg: '' });
        });
      }
    }, {
      key: 'render',
      value: function render() {

        var props = _.omit(this.props, 'onPurchaseClick', 'onSubscribeClick');

        return React.createElement(PlayerComponent, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, props, {
          onPurchaseClick: this.openPurchase,
          onSubscribeClick: this.openSubscription }));
      }
    }]);

    return FullScreenBuyExtensions;
  }(React.Component), _class3.propTypes = {
    canShowChannelCover: React.PropTypes.bool,
    onMemberSignUp: React.PropTypes.func,
    isUserLogged: React.PropTypes.bool,
    memberOnlyOverlay: React.PropTypes.any,
    videoItem: React.PropTypes.object,
    channelData: React.PropTypes.object,

    biEvent: React.PropTypes.func
  }, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'openPurchase', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'openPurchase'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'openSubscription', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'openSubscription'), _class2.prototype)), _class2)) || _class);


  return FullScreenBuyExtensions;
};

/* harmony default export */ __webpack_exports__["a"] = (extendWithFullScreenBuy);

/***/ }),
/* 1840 */,
/* 1841 */,
/* 1842 */,
/* 1843 */,
/* 1844 */,
/* 1845 */,
/* 1846 */,
/* 1847 */,
/* 1848 */,
/* 1849 */,
/* 1850 */,
/* 1851 */,
/* 1852 */,
/* 1853 */,
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".dropdown__dropdown__2jxjf{box-sizing:border-box;position:relative;min-width:125px}.dropdown__dropdown__2jxjf,.dropdown__label__2Xv0e{display:-ms-inline-flexbox;display:inline-flex}.dropdown__label__2Xv0e{-ms-flex-align:center;align-items:center;width:100%;height:32px;padding:0 14px;border:1px solid transparent;background:#fff;transition:color .2s,border .2s,background .2s;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.dropdown__placeholder__3JIye{color:#7a92a5}.dropdown__value__2B3cc{-ms-flex:1 1 auto;flex:1 1 auto;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.dropdown__triangle-down__2yGFu{margin-left:10px;font-size:6px;text-decoration:none;transform:translateY(1px);transition:transform .2s,color .2s}.dropdown__options__3hkzk{position:absolute;z-index:1000;top:0;width:auto;min-width:100%;min-height:0;border-radius:0;box-shadow:0 0 16px 0 rgba(0,0,0,.14);opacity:0;transition:opacity .2s}.dropdown__options__3hkzk.dropdown__stick-to-left__Lcuif{left:0}.dropdown__options__3hkzk.dropdown__stick-to-center__17foU{left:50%;transform:translate(-50%)}.dropdown__options__3hkzk.dropdown__stick-to-right__2Lkru{right:0}.dropdown__options__3hkzk.dropdown__stick-to-bottom__1r2g1{top:auto;left:0;right:0;bottom:0}.dropdown__options__3hkzk.dropdown__single__3qysp{margin-top:-12px}.dropdown__options__3hkzk.dropdown__single__3qysp .dropdown__options-inner__2N4Ef{padding:12px 0}.dropdown__options-inner__2N4Ef{overflow:hidden;min-height:0;height:100%;padding:0;border-radius:0;background:#fff;box-shadow:none}.dropdown__option__2Buwd{height:32px;white-space:nowrap;background:#fff;transition:background-color .2s,color .2s;cursor:pointer}.dropdown__category__2bYvC,.dropdown__option__2Buwd{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;padding:0 17px}.dropdown__category__2bYvC{height:28px;background:#f0f4f7;color:#7a92a5;font-size:12px;text-transform:uppercase}.dropdown__rounded__10vBZ .dropdown__label__2Xv0e,.dropdown__rounded__10vBZ .dropdown__options__3hkzk,.dropdown__rounded__10vBZ .dropdown__options-inner__2N4Ef{border-radius:16px}.dropdown__hide-popout__3J5up .dropdown__options__3hkzk{visibility:hidden}.dropdown__open__3HGHX .dropdown__options__3hkzk{opacity:1}.dropdown__backoffice__10nGo{color:#2b5672}.dropdown__backoffice__10nGo .dropdown__label__2Xv0e{border-color:#c6e2f7;border-radius:6px}.dropdown__backoffice__10nGo .dropdown__label__2Xv0e:hover{border-color:#c6e2f7;background:#eaf7ff}.dropdown__backoffice__10nGo .dropdown__triangle-down__2yGFu{color:#3899ec}.dropdown__backoffice__10nGo .dropdown__options__3hkzk,.dropdown__backoffice__10nGo .dropdown__options-inner__2N4Ef{border-radius:8px}.dropdown__backoffice__10nGo .dropdown__option__2Buwd{color:#2b5672}.dropdown__backoffice__10nGo .dropdown__option__2Buwd:hover{background:#eaf7ff}.dropdown__backoffice__10nGo .dropdown__selected__bjlwd,.dropdown__backoffice__10nGo .dropdown__selected__bjlwd:hover{color:#fff;background:#3899ec}.dropdown__widget__1mB8k{font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family;text-decoration:-wix-fonts-textFont-decoration}.dropdown__widget__1mB8k .dropdown__label__2Xv0e{color:-wix-colors-textColor-70;background:transparent;border-width:0 0 1px;border-color:-wix-colors-textColor-60}.dropdown__widget__1mB8k.dropdown__open__3HGHX .dropdown__label__2Xv0e,.dropdown__widget__1mB8k:hover .dropdown__label__2Xv0e{color:-wix-colors-textColor;border-color:-wix-colors-textColor}.dropdown__widget__1mB8k .dropdown__triangle-down__2yGFu{color:-wix-colors-textColor-60}.dropdown__widget__1mB8k.dropdown__open__3HGHX .dropdown__triangle-down__2yGFu,.dropdown__widget__1mB8k:hover .dropdown__triangle-down__2yGFu{color:-wix-colors-textColor}.dropdown__widget__1mB8k .dropdown__options__3hkzk{top:100%;padding:13px 0 0;background-color:-wix-colors-backgroundColor-100}.dropdown__widget__1mB8k .dropdown__options__3hkzk.dropdown__single__3qysp{margin-top:0}.dropdown__widget__1mB8k .dropdown__options-inner__2N4Ef{border:0;background-color:transparent}.dropdown__widget__1mB8k .dropdown__option__2Buwd,.dropdown__widget__1mB8k .dropdown__selected__bjlwd{padding:0 14px;background-color:transparent;color:-wix-colors-textColor}.dropdown__widget__1mB8k .dropdown__option__2Buwd:hover,.dropdown__widget__1mB8k .dropdown__selected__bjlwd:hover{color:-wix-colors-buttonsAndLinksColor}.dropdown__widget__1mB8k.dropdown__strip__3f4zP .dropdown__label__2Xv0e{color:#fff;border-color:#fff;transition:color .2s,border-color .2s}.dropdown__widget__1mB8k.dropdown__strip__3f4zP.dropdown__open__3HGHX .dropdown__label__2Xv0e,.dropdown__widget__1mB8k.dropdown__strip__3f4zP:hover .dropdown__label__2Xv0e{color:hsla(0,0%,100%,.7);border-color:hsla(0,0%,100%,.7)}.dropdown__widget__1mB8k.dropdown__strip__3f4zP .dropdown__triangle-down__2yGFu{transition:color .2s;color:#fff}.dropdown__widget__1mB8k.dropdown__strip__3f4zP.dropdown__open__3HGHX .dropdown__triangle-down__2yGFu,.dropdown__widget__1mB8k.dropdown__strip__3f4zP:hover .dropdown__triangle-down__2yGFu{color:hsla(0,0%,100%,.7)}.dropdown__widget__1mB8k.dropdown__strip__3f4zP .dropdown__options__3hkzk{background-color:rgba(0,0,0,.8)}.dropdown__widget__1mB8k.dropdown__strip__3f4zP .dropdown__option__2Buwd{color:#fff}.dropdown__widget__1mB8k.dropdown__strip__3f4zP .dropdown__option__2Buwd:hover{color:hsla(0,0%,100%,.5)}.dropdown__bare__1DGyU{min-width:0;color:inherit;font:inherit}.dropdown__bare__1DGyU .dropdown__label__2Xv0e{padding:0;border:none;border-radius:0;background:none}.dropdown__bare__1DGyU .dropdown__label__2Xv0e:hover{color:#3899ec}.dropdown__bare__1DGyU .dropdown__triangle-down__2yGFu{margin-left:7px;color:#0099ef;font-size:5px}.dropdown__bare__1DGyU .dropdown__options__3hkzk,.dropdown__bare__1DGyU .dropdown__options-inner__2N4Ef{border-radius:8px}.dropdown__bare__1DGyU .dropdown__options__3hkzk{top:calc(100% + 4px)}.dropdown__bare__1DGyU .dropdown__options-inner__2N4Ef{padding-top:10px;border:none}.dropdown__bare__1DGyU .dropdown__option__2Buwd:hover{background:#eaf7ff}.dropdown__bare__1DGyU .dropdown__selected__bjlwd,.dropdown__bare__1DGyU .dropdown__selected__bjlwd:hover{color:#fff;background:#0099ef}.dropdown__bare__1DGyU.dropdown__open__3HGHX .dropdown__triangle-down__2yGFu{transform:rotate(180deg)}.dropdown__disabled__1ehYS{pointer-events:none}.dropdown__disabled__1ehYS .dropdown__label__2Xv0e{border-color:#c9c9c9;color:#c9c9c9}.dropdown__disabled__1ehYS .dropdown__triangle-down__2yGFu{color:#c9c9c9}", ""]);

// exports
exports.locals = {
	"dropdown": "dropdown__dropdown__2jxjf",
	"label": "dropdown__label__2Xv0e",
	"placeholder": "dropdown__placeholder__3JIye",
	"value": "dropdown__value__2B3cc",
	"triangle-down": "dropdown__triangle-down__2yGFu",
	"triangleDown": "dropdown__triangle-down__2yGFu",
	"options": "dropdown__options__3hkzk",
	"stick-to-left": "dropdown__stick-to-left__Lcuif",
	"stickToLeft": "dropdown__stick-to-left__Lcuif",
	"stick-to-center": "dropdown__stick-to-center__17foU",
	"stickToCenter": "dropdown__stick-to-center__17foU",
	"stick-to-right": "dropdown__stick-to-right__2Lkru",
	"stickToRight": "dropdown__stick-to-right__2Lkru",
	"stick-to-bottom": "dropdown__stick-to-bottom__1r2g1",
	"stickToBottom": "dropdown__stick-to-bottom__1r2g1",
	"single": "dropdown__single__3qysp",
	"options-inner": "dropdown__options-inner__2N4Ef",
	"optionsInner": "dropdown__options-inner__2N4Ef",
	"option": "dropdown__option__2Buwd",
	"category": "dropdown__category__2bYvC",
	"rounded": "dropdown__rounded__10vBZ",
	"hide-popout": "dropdown__hide-popout__3J5up",
	"hidePopout": "dropdown__hide-popout__3J5up",
	"open": "dropdown__open__3HGHX",
	"backoffice": "dropdown__backoffice__10nGo",
	"selected": "dropdown__selected__bjlwd",
	"widget": "dropdown__widget__1mB8k",
	"strip": "dropdown__strip__3f4zP",
	"bare": "dropdown__bare__1DGyU",
	"disabled": "dropdown__disabled__1ehYS"
};

/***/ }),
/* 1855 */,
/* 1856 */,
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".account-info__container__3Olzn>div{border-bottom:1px solid #a0a09f}.account-info__container__3Olzn>div:last-child{border:none}.account-info__user-email__2a1VZ{padding:25px 20px 10px;color:#000;font-size:14px}.account-info__logout-wrapper__1LnAr{display:-ms-flexbox;display:flex;-ms-flex-pack:end;justify-content:flex-end;padding:20px;line-height:14px}.account-info__logout__3yvUV{font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family,Helvetica Neue,ruble,Helvetica,Arial,sans-serif;text-decoration:-wix-fonts-textFont-decoration;color:#000;text-decoration:underline;font-size:14px}.account-info__logout__3yvUV:active,.account-info__logout__3yvUV:focus,.account-info__logout__3yvUV:hover{opacity:.7}", ""]);

// exports
exports.locals = {
	"container": "account-info__container__3Olzn",
	"user-email": "account-info__user-email__2a1VZ",
	"userEmail": "account-info__user-email__2a1VZ",
	"logout-wrapper": "account-info__logout-wrapper__1LnAr",
	"logoutWrapper": "account-info__logout-wrapper__1LnAr",
	"logout": "account-info__logout__3yvUV"
};

/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".account-form__wrapper__3VePL{-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-align:stretch;align-items:stretch;height:100%;min-height:400px;color:#000;font-family:HelveticaNeueW01-45Ligh,HelveticaNeueW02-45Ligh,HelveticaNeueW10-45Ligh,Helvetica Neue,ruble,Helvetica,Arial,sans-serif;font-size:14px;font-weight:300;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family;text-decoration:-wix-fonts-textFont-decoration;text-align:center}.account-form__content-wrapper__2WYI1,.account-form__wrapper__3VePL{display:-ms-flexbox;display:flex}.account-form__content-wrapper__2WYI1{-ms-flex:1 1 auto;flex:1 1 auto;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.account-form__header__1uNJm{font-family:HelveticaNeueW01-45Ligh,HelveticaNeueW02-45Ligh,HelveticaNeueW10-45Ligh,Helvetica Neue,ruble,Helvetica,Arial,sans-serif;font-size:18px;font-weight:300}.account-form__proceed-button__1RX20{-ms-flex-item-align:center;-ms-grid-row-align:center;align-self:center;margin-bottom:32px}.account-form__sign-up-button___-9r7{margin-top:24px}.account-form__signed-message__3hjDS{margin-top:32px}.account-form__sign-in-wrapper__3Ct2U{margin-top:24px}.account-form__logout-button__1ql1f,.account-form__sign-in-button__34CYm{color:#000;text-decoration:underline}[data-layout=\"1\"] .account-form__logout-button__1ql1f,[data-layout=\"1\"] .account-form__sign-in-button__34CYm{color:-wix-colors-buttonsAndLinksColor;text-decoration:none}", ""]);

// exports
exports.locals = {
	"wrapper": "account-form__wrapper__3VePL",
	"content-wrapper": "account-form__content-wrapper__2WYI1",
	"contentWrapper": "account-form__content-wrapper__2WYI1",
	"header": "account-form__header__1uNJm",
	"proceed-button": "account-form__proceed-button__1RX20",
	"proceedButton": "account-form__proceed-button__1RX20",
	"sign-up-button": "account-form__sign-up-button___-9r7",
	"signUpButton": "account-form__sign-up-button___-9r7",
	"signed-message": "account-form__signed-message__3hjDS",
	"signedMessage": "account-form__signed-message__3hjDS",
	"sign-in-wrapper": "account-form__sign-in-wrapper__3Ct2U",
	"signInWrapper": "account-form__sign-in-wrapper__3Ct2U",
	"logout-button": "account-form__logout-button__1ql1f",
	"logoutButton": "account-form__logout-button__1ql1f",
	"sign-in-button": "account-form__sign-in-button__34CYm",
	"signInButton": "account-form__sign-in-button__34CYm"
};

/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".mobile-spinner-overlay__spinner-container__27NHn{position:absolute;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.mobile-spinner-overlay__spinner-container__27NHn .mobile-spinner-overlay__spinner__9D1NY{color:#555;color:-wix-colors-buttonsAndLinksColor}[data-layout=\"2\"] .mobile-spinner-overlay__spinner-container__27NHn .mobile-spinner-overlay__spinner__9D1NY{color:-wix-colors-mobileButtonsBackgroundColor}", ""]);

// exports
exports.locals = {
	"spinner-container": "mobile-spinner-overlay__spinner-container__27NHn",
	"spinnerContainer": "mobile-spinner-overlay__spinner-container__27NHn",
	"spinner": "mobile-spinner-overlay__spinner__9D1NY"
};

/***/ }),
/* 1860 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".no-videos-content__no-videos__3X7Qh{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;pointer-events:none}[data-view-mode=editor] .no-videos-content__no-videos__3X7Qh{background-color:-wix-colors-emptyPlayerBgEditor}[data-view-mode=preview] .no-videos-content__no-videos__3X7Qh,[data-view-mode=site] .no-videos-content__no-videos__3X7Qh{background-color:-wix-colors-emptyPlayerBgSite}.no-videos-content__no-videos__3X7Qh .no-videos-content__play__34hzq{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:51px;height:51px;border:1px solid transparent;border-radius:50%;font-size:22px}[data-view-mode=editor] .no-videos-content__no-videos__3X7Qh .no-videos-content__play__34hzq{border-color:-wix-colors-emptyPlayIconEditor;color:-wix-colors-emptyPlayIconEditor}[data-view-mode=preview] .no-videos-content__no-videos__3X7Qh .no-videos-content__play__34hzq,[data-view-mode=site] .no-videos-content__no-videos__3X7Qh .no-videos-content__play__34hzq{border-color:-wix-colors-emptyPlayIconSite;color:-wix-colors-emptyPlayIconSite}.no-videos-content__no-videos__3X7Qh .no-videos-content__play__34hzq:before{transform:translate(3px,1px)}", ""]);

// exports
exports.locals = {
	"no-videos": "no-videos-content__no-videos__3X7Qh",
	"noVideos": "no-videos-content__no-videos__3X7Qh",
	"play": "no-videos-content__play__34hzq"
};

/***/ }),
/* 1861 */,
/* 1862 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".payment-form__wrapper__1LYZT{display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-align:stretch;align-items:stretch;width:630px;min-height:425px}.payment-form__auth-part__1ipfG,.payment-form__subscribe-part__2nEoD{-ms-flex:1 1 auto;flex:1 1 auto;width:50%}.payment-form__subscribe-part__2nEoD{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;border-right:1px solid -wix-colors-textColor-10;color:#000;font-family:HelveticaNeueW01-45Ligh,HelveticaNeueW02-45Ligh,HelveticaNeueW10-45Ligh,Helvetica Neue,ruble,Helvetica,Arial,sans-serif;font-size:14px;font-weight:300;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family;text-decoration:-wix-fonts-textFont-decoration}.payment-form__image__2r3I1{-ms-flex:0 0 auto;flex:0 0 auto;margin:0;padding:0;border-bottom:1px solid -wix-colors-textColor-10}.payment-form__content__3l4rc{-ms-flex:1 1 auto;flex:1 1 auto;margin:32px 30px 14px}.payment-form__title__-SN64{text-overflow:ellipsis;overflow:hidden;white-space:nowrap;font-family:HelveticaNeueW01-45Ligh,HelveticaNeueW02-45Ligh,HelveticaNeueW10-45Ligh,Helvetica Neue,ruble,Helvetica,Arial,sans-serif;font-size:18px;font-weight:300}.payment-form__type-wrapper__3-8rh{margin:33px 0 24px}.payment-form__type-wrapper__3-8rh .payment-form__single-button-text__3E9jQ{color:#000;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family;text-decoration:-wix-fonts-textFont-decoration;font-size:18px}.payment-form__type-wrapper__3-8rh .payment-form__buttons__MfkU3{margin-top:2px}.payment-form__permissions-wrapper__2B1CD{font-family:HelveticaNeueW01-45Ligh,HelveticaNeueW02-45Ligh,HelveticaNeueW10-45Ligh,Helvetica Neue,ruble,Helvetica,Arial,sans-serif;font-size:14px;font-weight:300}.payment-form__permission__31u4v{display:-ms-flexbox;display:flex;-ms-flex-align:start;align-items:flex-start;line-height:14px;margin-bottom:14px}.payment-form__permission__31u4v.payment-form__small__36ujw{margin-bottom:16px}.payment-form__icon__uSTpz{-ms-flex:0 0 auto;flex:0 0 auto;margin-right:10px;font-size:10px;color:#d5d5d5}", ""]);

// exports
exports.locals = {
	"wrapper": "payment-form__wrapper__1LYZT",
	"auth-part": "payment-form__auth-part__1ipfG",
	"authPart": "payment-form__auth-part__1ipfG",
	"subscribe-part": "payment-form__subscribe-part__2nEoD",
	"subscribePart": "payment-form__subscribe-part__2nEoD",
	"image": "payment-form__image__2r3I1",
	"content": "payment-form__content__3l4rc",
	"title": "payment-form__title__-SN64",
	"type-wrapper": "payment-form__type-wrapper__3-8rh",
	"typeWrapper": "payment-form__type-wrapper__3-8rh",
	"single-button-text": "payment-form__single-button-text__3E9jQ",
	"singleButtonText": "payment-form__single-button-text__3E9jQ",
	"buttons": "payment-form__buttons__MfkU3",
	"permissions-wrapper": "payment-form__permissions-wrapper__2B1CD",
	"permissionsWrapper": "payment-form__permissions-wrapper__2B1CD",
	"permission": "payment-form__permission__31u4v",
	"small": "payment-form__small__36ujw",
	"icon": "payment-form__icon__uSTpz"
};

/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".payments__auth-window__ldVqP{min-width:630px;border-radius:0}@media screen and (max-height:738px){.payments__auth-window__ldVqP{max-height:calc(100% - 60px)}}.payments__auth-modal__1rUcq{background-color:-wix-colors-backgroundColor-95}.payments__auth-modal-content__QNIen{height:100%;padding:0}", ""]);

// exports
exports.locals = {
	"auth-window": "payments__auth-window__ldVqP",
	"authWindow": "payments__auth-window__ldVqP",
	"auth-modal": "payments__auth-modal__1rUcq",
	"authModal": "payments__auth-modal__1rUcq",
	"auth-modal-content": "payments__auth-modal-content__QNIen",
	"authModalContent": "payments__auth-modal-content__QNIen"
};

/***/ }),
/* 1864 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".member-only__overlay__3r4Ii{position:absolute;top:0;left:0;right:0;bottom:0;z-index:120;-ms-flex-direction:column;flex-direction:column;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-align:stretch;align-items:stretch;color:#fff;text-align:center}.member-only__overlay__3r4Ii,.member-only__title__31aFH{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center}.member-only__title__31aFH{font-weight:-wix-fonts-titleFont-weight;font-style:-wix-fonts-titleFont-style;font-family:-wix-fonts-titleFont-family;text-decoration:-wix-fonts-titleFont-decoration;font-size:20px;padding-left:15px;padding-right:15px;width:100%}.member-only__title__31aFH+.member-only__publisher__2RgRa{margin-top:4px}.member-only__preview-text__3nbYA{font-size:14px;margin-left:10px}.member-only__publisher__2RgRa{font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family;text-decoration:-wix-fonts-textFont-decoration;font-size:13px;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;width:100%}.member-only__publisher__2RgRa+.member-only__buttons__3WNAt,.member-only__title__31aFH+.member-only__buttons__3WNAt{margin-top:25px}.member-only__buttons__3WNAt{display:-ms-flexbox;display:flex;width:100%;-ms-flex-pack:center;justify-content:center}.member-only__button__1CnEt,.member-only__buttons__3WNAt{white-space:nowrap}.member-only__button__1CnEt{margin:0 5px;padding:0 15px;text-overflow:ellipsis;overflow:hidden;-webkit-transform:translateZ(0)}.member-only__simple-play-button__1jyyJ{background:none;color:#fff}.member-only__simple-play-button__1jyyJ:before{background:none}.member-only__simple-play-button__1jyyJ .member-only__play-icon__IKRZH{top:0;display:-ms-inline-flexbox;display:inline-flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:30px;height:30px;margin-right:10px;padding-top:2px;padding-left:2px;border:1px solid #fff;border-radius:50%;font-size:10px;color:#fff;background:none}.member-only__overlay__3r4Ii .member-only__title__31aFH .member-only__preview-text__3nbYA{display:none}.member-only__publisher-text__2uZA2,.member-only__title-text__1dfJX{text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.member-only__next-icon__1j_qR,.member-only__play-icon__IKRZH{font-size:14px}.member-only__play-icon__IKRZH{margin-right:11px}.member-only__next-icon__1j_qR{margin-left:11px}.member-only__wrapper__1b8aA{display:-ms-flexbox;display:flex;position:relative;background-color:#000}.member-only__overlay__3r4Ii{position:relative;height:100%}", ""]);

// exports
exports.locals = {
	"overlay": "member-only__overlay__3r4Ii",
	"title": "member-only__title__31aFH",
	"publisher": "member-only__publisher__2RgRa",
	"preview-text": "member-only__preview-text__3nbYA",
	"previewText": "member-only__preview-text__3nbYA",
	"buttons": "member-only__buttons__3WNAt",
	"button": "member-only__button__1CnEt",
	"simple-play-button": "member-only__simple-play-button__1jyyJ",
	"simplePlayButton": "member-only__simple-play-button__1jyyJ",
	"play-icon": "member-only__play-icon__IKRZH",
	"playIcon": "member-only__play-icon__IKRZH",
	"publisher-text": "member-only__publisher-text__2uZA2",
	"publisherText": "member-only__publisher-text__2uZA2",
	"title-text": "member-only__title-text__1dfJX",
	"titleText": "member-only__title-text__1dfJX",
	"next-icon": "member-only__next-icon__1j_qR",
	"nextIcon": "member-only__next-icon__1j_qR",
	"wrapper": "member-only__wrapper__1b8aA"
};

/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".member-only__overlay__1dU6a{position:absolute;top:0;left:0;right:0;bottom:0;z-index:120;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:stretch;align-items:stretch;color:#fff}.member-only__content__3Tocq{-ms-flex:1 1 auto;flex:1 1 auto}.member-only__content__3Tocq,.member-only__top-content__3QV10{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;align-items:center;width:100%}.member-only__top-content__3QV10{-ms-flex-pack:center;justify-content:center;-ms-flex:1 1 auto;flex:1 1 auto;max-width:920px}.member-only__top-content__3QV10 .member-only__title__1CdDm{width:100%;margin-bottom:25px;font-weight:-wix-fonts-titleFont-weight;font-style:-wix-fonts-titleFont-style;font-family:-wix-fonts-titleFont-family;text-decoration:-wix-fonts-titleFont-decoration;font-size:-wix-fonts-titleFont-size;line-height:normal;text-align:center}.member-only__top-content__3QV10 .member-only__title__1CdDm .member-only__preview-text__3kdz6{margin-left:10px;font-size:14px}.member-only__top-content__3QV10 .member-only__publisher__2xxtz{margin-bottom:30px;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family;text-decoration:-wix-fonts-textFont-decoration;text-align:center;font-size:18px}.member-only__buttons-wrapper__1nrwq{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;height:40px}.member-only__buttons-wrapper__1nrwq:first-child{margin-top:107px}.member-only__buttons-wrapper__1nrwq .member-only__button__1cQ-J{font-size:18px;white-space:nowrap;line-height:37px}.member-only__buttons-wrapper__1nrwq .member-only__button__1cQ-J+.member-only__button__1cQ-J{margin-left:54px}.member-only__rounded-icon__9aKnA{width:37px;height:37px;padding-left:2px;border-color:#fff;border-width:2px}.member-only__button__1cQ-J{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;height:40px;padding:0;transition:opacity .2s;color:inherit;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family;text-decoration:none;border-radius:0}.member-only__button__1cQ-J:hover{opacity:.7}.member-only__button__1cQ-J.member-only__bordered__3wjiL{border:1px solid #fff;background:transparent}.member-only__button__1cQ-J .member-only__icon__3H3Dn{font-size:14px}.member-only__button__1cQ-J .member-only__text__jktvD{margin-bottom:-4px;border-bottom:2px solid #fff;line-height:normal}.member-only__play-icon__3-zW7{}@media only screen and (max-width:320px){.member-only__overlay__1dU6a .member-only__buttons__Kjip2{margin-top:25px}.member-only__overlay__1dU6a .member-only__buttons__Kjip2 .member-only__button__1cQ-J{margin:0 5px}}.member-only__button__1cQ-J .member-only__next-icon__2G_RT,.member-only__button__1cQ-J .member-only__play-icon__3-zW7{font-size:14px}.member-only__button__1cQ-J .member-only__play-icon__3-zW7{margin-right:11px}.member-only__button__1cQ-J .member-only__next-icon__2G_RT{margin-left:11px}@media only screen and (max-width:320px){.member-only__button__1cQ-J .member-only__play-icon__3-zW7{font-size:10px}}.member-only__wrapper__37ZTg{background-color:#000}.member-only__overlay__1dU6a{background-color:rgba(0,0,0,.6)}.member-only__play-button__3cS24{display:inline}", ""]);

// exports
exports.locals = {
	"overlay": "member-only__overlay__1dU6a",
	"content": "member-only__content__3Tocq",
	"top-content": "member-only__top-content__3QV10",
	"topContent": "member-only__top-content__3QV10",
	"title": "member-only__title__1CdDm",
	"preview-text": "member-only__preview-text__3kdz6",
	"previewText": "member-only__preview-text__3kdz6",
	"publisher": "member-only__publisher__2xxtz",
	"buttons-wrapper": "member-only__buttons-wrapper__1nrwq",
	"buttonsWrapper": "member-only__buttons-wrapper__1nrwq",
	"button": "member-only__button__1cQ-J",
	"rounded-icon": "member-only__rounded-icon__9aKnA",
	"roundedIcon": "member-only__rounded-icon__9aKnA",
	"bordered": "member-only__bordered__3wjiL",
	"icon": "member-only__icon__3H3Dn",
	"text": "member-only__text__jktvD",
	"play-icon": "member-only__play-icon__3-zW7 member-only__rounded-icon__9aKnA",
	"playIcon": "member-only__play-icon__3-zW7 member-only__rounded-icon__9aKnA",
	"buttons": "member-only__buttons__Kjip2",
	"next-icon": "member-only__next-icon__2G_RT",
	"nextIcon": "member-only__next-icon__2G_RT",
	"wrapper": "member-only__wrapper__37ZTg",
	"play-button": "member-only__play-button__3cS24",
	"playButton": "member-only__play-button__3cS24"
};

/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".strip__overlay__3GEmh{position:absolute;top:0;left:0;right:0;bottom:0;z-index:120;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:stretch;align-items:stretch;color:#fff}.strip__content__2ApdC{-ms-flex:1 1 auto;flex:1 1 auto}.strip__content__2ApdC,.strip__top-content__2Pie3{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;align-items:center;width:100%}.strip__top-content__2Pie3{-ms-flex-pack:center;justify-content:center;-ms-flex:1 1 auto;flex:1 1 auto;max-width:920px}.strip__top-content__2Pie3 .strip__title__1sC3v{width:100%;margin-bottom:25px;font-weight:-wix-fonts-titleFont-weight;font-style:-wix-fonts-titleFont-style;font-family:-wix-fonts-titleFont-family;text-decoration:-wix-fonts-titleFont-decoration;font-size:-wix-fonts-titleFont-size;line-height:normal;text-align:center}.strip__top-content__2Pie3 .strip__title__1sC3v .strip__preview-text__E5w0g{margin-left:10px;font-size:14px}.strip__top-content__2Pie3 .strip__publisher__3T-OD{margin-bottom:30px;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family;text-decoration:-wix-fonts-textFont-decoration;text-align:center;font-size:18px}.strip__buttons-wrapper__JmhF4{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;height:40px}.strip__buttons-wrapper__JmhF4:first-child{margin-top:107px}.strip__buttons-wrapper__JmhF4 .strip__button__1N2zb{font-size:18px;white-space:nowrap;line-height:37px}.strip__buttons-wrapper__JmhF4 .strip__button__1N2zb+.strip__button__1N2zb{margin-left:54px}.strip__rounded-icon__2R6RW{width:37px;height:37px;padding-left:2px;border-color:#fff;border-width:2px}.strip__button__1N2zb{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;height:40px;padding:0;transition:opacity .2s;color:inherit;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family;text-decoration:none;border-radius:0}.strip__button__1N2zb:hover{opacity:.7}.strip__button__1N2zb.strip__bordered__D68tD{border:1px solid #fff;background:transparent}.strip__button__1N2zb .strip__icon__PwH89{font-size:14px}.strip__button__1N2zb .strip__text__2syKz{margin-bottom:-4px;border-bottom:2px solid #fff;line-height:normal}.strip__play-icon__3-SeF{}@media only screen and (max-width:320px){.strip__overlay__3GEmh .strip__buttons__2HyzH{margin-top:25px}.strip__overlay__3GEmh .strip__buttons__2HyzH .strip__button__1N2zb{margin:0 5px}}.strip__button__1N2zb .strip__next-icon__2oVLP,.strip__button__1N2zb .strip__play-icon__3-SeF{font-size:14px}.strip__button__1N2zb .strip__play-icon__3-SeF{margin-right:11px}.strip__button__1N2zb .strip__next-icon__2oVLP{margin-left:11px}@media only screen and (max-width:320px){.strip__button__1N2zb .strip__play-icon__3-SeF{font-size:10px}}", ""]);

// exports
exports.locals = {
	"overlay": "strip__overlay__3GEmh",
	"content": "strip__content__2ApdC",
	"top-content": "strip__top-content__2Pie3",
	"topContent": "strip__top-content__2Pie3",
	"title": "strip__title__1sC3v",
	"preview-text": "strip__preview-text__E5w0g",
	"previewText": "strip__preview-text__E5w0g",
	"publisher": "strip__publisher__3T-OD",
	"buttons-wrapper": "strip__buttons-wrapper__JmhF4",
	"buttonsWrapper": "strip__buttons-wrapper__JmhF4",
	"button": "strip__button__1N2zb",
	"rounded-icon": "strip__rounded-icon__2R6RW",
	"roundedIcon": "strip__rounded-icon__2R6RW",
	"bordered": "strip__bordered__D68tD",
	"icon": "strip__icon__PwH89",
	"text": "strip__text__2syKz",
	"play-icon": "strip__play-icon__3-SeF strip__rounded-icon__2R6RW",
	"playIcon": "strip__play-icon__3-SeF strip__rounded-icon__2R6RW",
	"buttons": "strip__buttons__2HyzH",
	"next-icon": "strip__next-icon__2oVLP",
	"nextIcon": "strip__next-icon__2oVLP"
};

/***/ }),
/* 1867 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".tag__tag__5e4t5{display:-ms-inline-flexbox;display:inline-flex;-ms-flex-align:center;align-items:center;height:28px;padding:0 12px;border:1px solid -wix-colors-textColor;color:-wix-colors-textColor;font-size:12px;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family;text-decoration:-wix-fonts-textFont-decoration;text-decoration:none;transition:border .2s,color .2s,border-radius .2s}.tag__tag__5e4t5:hover{color:-wix-colors-textColor-70}.tag__rounded__1nygW{border-radius:999px}.tag__inner__4CUYN{text-overflow:ellipsis;overflow:hidden;white-space:nowrap}", ""]);

// exports
exports.locals = {
	"tag": "tag__tag__5e4t5",
	"rounded": "tag__rounded__1nygW",
	"inner": "tag__inner__4CUYN"
};

/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".tags-cloud__tag__jxy8M{margin-right:4px;margin-bottom:4px}", ""]);

// exports
exports.locals = {
	"tag": "tags-cloud__tag__jxy8M"
};

/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".tags__tag__22NL0{margin-right:15px;margin-bottom:15px;border:1px solid -wix-colors-textColor;border-radius:15px}.tags__tag__22NL0.tags__mobile__rikMp{color:#000}", ""]);

// exports
exports.locals = {
	"tag": "tags__tag__22NL0",
	"mobile": "tags__mobile__rikMp"
};

/***/ }),
/* 1870 */,
/* 1871 */,
/* 1872 */,
/* 1873 */,
/* 1874 */,
/* 1875 */,
/* 1876 */,
/* 1877 */,
/* 1878 */,
/* 1879 */,
/* 1880 */,
/* 1881 */,
/* 1882 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1854);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./dropdown.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./dropdown.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1883 */,
/* 1884 */,
/* 1885 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1857);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./account-info.styl", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./account-info.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1886 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1858);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./account-form.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./account-form.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1887 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1859);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./mobile-spinner-overlay.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./mobile-spinner-overlay.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1888 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1860);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./no-videos-content.styl", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./no-videos-content.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1889 */,
/* 1890 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1862);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./payment-form.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./payment-form.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1891 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1863);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./payments.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./payments.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1892 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1864);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./member-only.styl", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./member-only.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1893 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1865);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./member-only.styl", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./member-only.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1894 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1866);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./strip.styl", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./strip.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1895 */,
/* 1896 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1867);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./tag.styl", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./tag.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1897 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1868);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./tags-cloud.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./tags-cloud.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1898 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1869);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./tags.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./tags.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1899 */,
/* 1900 */,
/* 1901 */,
/* 1902 */,
/* 1903 */,
/* 1904 */,
/* 1905 */,
/* 1906 */,
/* 1907 */,
/* 1908 */,
/* 1909 */,
/* 1910 */,
/* 1911 */,
/* 1912 */,
/* 1913 */,
/* 1914 */,
/* 1915 */,
/* 1916 */,
/* 1917 */,
/* 1918 */,
/* 1919 */,
/* 1920 */,
/* 1921 */,
/* 1922 */,
/* 1923 */,
/* 1924 */,
/* 1925 */,
/* 1926 */,
/* 1927 */,
/* 1928 */,
/* 1929 */,
/* 1930 */,
/* 1931 */,
/* 1932 */,
/* 1933 */,
/* 1934 */,
/* 1935 */,
/* 1936 */,
/* 1937 */,
/* 1938 */,
/* 1939 */,
/* 1940 */,
/* 1941 */,
/* 1942 */,
/* 1943 */,
/* 1944 */,
/* 1945 */,
/* 1946 */,
/* 1947 */,
/* 1948 */,
/* 1949 */,
/* 1950 */,
/* 1951 */,
/* 1952 */,
/* 1953 */,
/* 1954 */,
/* 1955 */,
/* 1956 */,
/* 1957 */,
/* 1958 */,
/* 1959 */,
/* 1960 */,
/* 1961 */,
/* 1962 */,
/* 1963 */,
/* 1964 */,
/* 1965 */,
/* 1966 */,
/* 1967 */,
/* 1968 */,
/* 1969 */,
/* 1970 */,
/* 1971 */,
/* 1972 */,
/* 1973 */,
/* 1974 */,
/* 1975 */,
/* 1976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ElementSwitcher; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__measure__ = __webpack_require__(2448);








var _desc, _value, _class, _class2, _temp2;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}





function childrenKeys(props) {
  return React.Children.map(props.children, function (child) {
    return child.key;
  });
}

// FIXME: looks like it doesn't work at all, and I don't see a good way to fix it.
// Need to talk with Product Owner and redesign all places that related for this logic
var ElementSwitcher = (_class = (_temp2 = _class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(ElementSwitcher, _React$Component);

  function ElementSwitcher() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ElementSwitcher);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = ElementSwitcher.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(ElementSwitcher)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      width: null
    }, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(ElementSwitcher, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // Correct solution would be to check width of prev and next children but
      // to simplify and to speed up keys are used instead
      var nextKeys = childrenKeys(nextProps).join('++');
      var prevKeys = childrenKeys(this.props).join('++');

      if (nextProps.maxWidth !== this.props.maxWidth || nextKeys !== prevKeys) {
        this.setState({ width: null });
      }
    }
  }, {
    key: 'onMeasure',
    value: function onMeasure(dimensions) {
      var width = _.get(dimensions, 'width');
      if (width !== 0 && width !== this.state.width) {
        this.setState({ width: width });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          maxWidth = _props.maxWidth,
          children = _props.children,
          shouldAlwaysMeasure = _props.shouldAlwaysMeasure;

      var width = this.state.width;

      var _React$Children$toArr = React.Children.toArray(children),
          _React$Children$toArr2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_React$Children$toArr, 2),
          normal = _React$Children$toArr2[0],
          small = _React$Children$toArr2[1];

      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_8__measure__["a" /* default */],
        { onMeasure: this.onMeasure,
          shouldMeasure: shouldAlwaysMeasure || width === null },
        width && width > maxWidth ? small : normal
      );
    }
  }]);

  return ElementSwitcher;
}(React.Component), _class2.propTypes = {
  children: React.PropTypes.any,
  maxWidth: React.PropTypes.number,
  shouldAlwaysMeasure: React.PropTypes.bool
}, _temp2), (_applyDecoratedDescriptor(_class.prototype, 'onMeasure', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'onMeasure'), _class.prototype)), _class);


/***/ }),
/* 1977 */,
/* 1978 */,
/* 1979 */,
/* 1980 */,
/* 1981 */,
/* 1982 */,
/* 1983 */,
/* 1984 */,
/* 1985 */,
/* 1986 */,
/* 1987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return COMPACT_NUMBER_OF_ROWS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COMPACT_VIDEOS_IN_ROW; });
var COMPACT_NUMBER_OF_ROWS = 2;
var COMPACT_VIDEOS_IN_ROW = 2;

/***/ }),
/* 1988 */,
/* 1989 */,
/* 1990 */,
/* 1991 */,
/* 1992 */,
/* 1993 */,
/* 1994 */,
/* 1995 */,
/* 1996 */,
/* 1997 */,
/* 1998 */,
/* 1999 */,
/* 2000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = runOnce;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

function runOnce(target, key, descriptor) {
  var originMethod = target[key];
  var hasBeenCalled = false;

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, descriptor, {
    value: function value() {
      if (hasBeenCalled) {
        return;
      }
      hasBeenCalled = true;
      return originMethod.apply(this, arguments);
    }
  });
}

/***/ }),
/* 2001 */,
/* 2002 */,
/* 2003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Categories; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_intl__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_decorators_lib_decorate__ = __webpack_require__(1740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_decorators_lib_decorate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_decorators_lib_decorate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_components_dropdown_dropdown__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__categories_styl__ = __webpack_require__(3254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__categories_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__categories_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__translations__ = __webpack_require__(2497);








var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}













var Categories = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_shared_utils_wix_connect__["a" /* WixConnect */])(), _dec2 = __WEBPACK_IMPORTED_MODULE_9_core_decorators_lib_decorate___default()(_.memoize), _dec(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Categories, _React$Component);

  function Categories() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Categories);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Categories.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Categories)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Categories, [{
    key: 'getOptions',
    value: function getOptions(list) {
      var options = _.map(list, function (value) {
        return { label: value, value: value };
      });
      return [{
        label: this.props.intl.formatMessage(__WEBPACK_IMPORTED_MODULE_13__translations__["a" /* default */].allVideos),
        value: null
      }].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(options));
    }
  }, {
    key: 'sendCategorySelectedBI',
    value: function sendCategorySelectedBI() {
      this.props.biEvent('widget.categories.selected');
    }
  }, {
    key: 'sendCategoriesClickedBI',
    value: function sendCategoriesClickedBI() {
      this.props.biEvent('widget.categories.clicked');
    }
  }, {
    key: 'handleChange',
    value: function handleChange(value) {
      this.sendCategorySelectedBI();
      this.props.onCategorySelect(value);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          selectedCategory = _props.selectedCategory,
          DropdownClass = _props.DropdownClass,
          height = _props.height,
          list = _props.list;


      return React.createElement(DropdownClass, { className: className + ' qa-widget-categories',
        dataHook: 'categories-dropdown',
        optionsClassName: __WEBPACK_IMPORTED_MODULE_12__categories_styl___default.a.options,
        optionClassName: __WEBPACK_IMPORTED_MODULE_12__categories_styl___default.a.option,
        height: height,
        onChange: this.handleChange,
        onOpen: this.sendCategoriesClickedBI,
        value: selectedCategory,
        options: this.getOptions(list) });
    }
  }]);

  return Categories;
}(React.Component), _class3.propTypes = {
  className: React.PropTypes.string,
  list: React.PropTypes.arrayOf(React.PropTypes.string),
  onCategorySelect: React.PropTypes.func,
  selectedCategory: React.PropTypes.string,
  height: React.PropTypes.number,
  biEvent: React.PropTypes.func,
  intl: __WEBPACK_IMPORTED_MODULE_8_react_intl__["e" /* intlShape */],
  DropdownClass: React.PropTypes.func
}, _class3.defaultProps = {
  selectedCategory: null,
  DropdownClass: __WEBPACK_IMPORTED_MODULE_11_shared_components_dropdown_dropdown__["a" /* WidgetDropdown */]
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'getOptions', [_dec2], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'getOptions'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'sendCategoriesClickedBI', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'sendCategoriesClickedBI'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleChange', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handleChange'), _class2.prototype)), _class2)) || _class);


/***/ }),
/* 2004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChannelSubscriptionButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_widget_components_overlay_texts_channel_subscribe_button_text__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__channel_subscription_label__ = __webpack_require__(2005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_components_button_button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_ui_selectors_channel_pricing__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__channel_actions_styl__ = __webpack_require__(2055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__channel_actions_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__channel_actions_styl__);






var _dec, _dec2, _class, _class2, _temp;












var ChannelSubscriptionButton = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["a" /* connect */])(function (state, ownProps) {
  return {
    dealInfo: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_shared_ui_selectors_channel_pricing__["c" /* getDealInfo */])(ownProps),
    isVisible: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_widget_components_overlay_texts_channel_subscribe_button_text__["a" /* isVisible */])({ channel: ownProps.channelData })
  };
}), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_11__channel_actions_styl___default.a), _dec(_class = _dec2(_class = (_temp = _class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ChannelSubscriptionButton, _React$Component);

  function ChannelSubscriptionButton() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ChannelSubscriptionButton);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ChannelSubscriptionButton.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ChannelSubscriptionButton)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ChannelSubscriptionButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isVisible = _props.isVisible,
          dealInfo = _props.dealInfo,
          className = _props.className,
          onClick = _props.onClick;


      if (!isVisible) {
        return null;
      }

      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_9_shared_components_button_button__["e" /* LinkButton */],
        { className: 'qa-channel-subscription ' + className,
          styleName: 'action subscribe',
          onClick: onClick },
        React.createElement(__WEBPACK_IMPORTED_MODULE_8__channel_subscription_label__["a" /* default */], { dealInfo: dealInfo,
          isVisible: isVisible })
      );
    }
  }]);

  return ChannelSubscriptionButton;
}(React.Component), _class2.propTypes = {
  channelData: React.PropTypes.object,
  dealInfo: React.PropTypes.array,
  className: React.PropTypes.string,
  onClick: React.PropTypes.func,
  isVisible: React.PropTypes.bool
}, _temp)) || _class) || _class);


/***/ }),
/* 2005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChannelSubscriptionLabel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_utils_deal_info_helpers__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__translations__ = __webpack_require__(2499);







var _dec, _class, _class2, _temp;







var ChannelSubscriptionLabel = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["a" /* connect */])(function (state, ownProps) {
  return {
    subscriptionPriceInfo: __WEBPACK_IMPORTED_MODULE_8_shared_utils_deal_info_helpers__["a" /* getSubscriptionPriceInfo */](ownProps.dealInfo)
  };
}), _dec(_class = (_temp = _class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ChannelSubscriptionLabel, _React$Component);

  function ChannelSubscriptionLabel() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ChannelSubscriptionLabel);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ChannelSubscriptionLabel.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(ChannelSubscriptionLabel)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ChannelSubscriptionLabel, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          subscriptionPriceInfo = _props.subscriptionPriceInfo,
          className = _props.className;


      var values = {
        price: React.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["f" /* FormattedNumber */], { value: subscriptionPriceInfo.price,
          style: 'currency',
          currency: subscriptionPriceInfo.currency })
      };

      return React.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_9__translations__["a" /* default */].subscribe, {
        className: className,
        values: values }));
    }
  }]);

  return ChannelSubscriptionLabel;
}(React.Component), _class2.propTypes = {
  subscriptionPriceInfo: React.PropTypes.object,
  dealInfo: React.PropTypes.array,
  className: React.PropTypes.string
}, _temp)) || _class);


/***/ }),
/* 2006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EmptySearchResults; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_search_svg__ = __webpack_require__(2701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__empty_search_results_styl__ = __webpack_require__(3258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__empty_search_results_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__empty_search_results_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_widget_translations__ = __webpack_require__(1619);







var _dec, _class, _class2, _temp;










var EmptySearchResults = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_9__empty_search_results_styl___default.a), _dec(_class = (_temp = _class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(EmptySearchResults, _React$Component);

  function EmptySearchResults() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, EmptySearchResults);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (EmptySearchResults.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(EmptySearchResults)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(EmptySearchResults, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: this.props.className,
          styleName: 'no-search-wrapper' },
        React.createElement(__WEBPACK_IMPORTED_MODULE_8__images_search_svg__["a" /* default */], { styleName: 'no-search-icon' }),
        React.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_10_widget_translations__["a" /* default */].noSearchResults, {
          styleName: 'no-search-text' }))
      );
    }
  }]);

  return EmptySearchResults;
}(React.Component), _class2.propTypes = {
  className: React.PropTypes.string
}, _temp)) || _class);


/***/ }),
/* 2007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PaymentsBiHandler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_bi_bi__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_components_payment_events_payment_events__ = __webpack_require__(381);









var PaymentsBiHandler = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(PaymentsBiHandler, _React$Component);

  function PaymentsBiHandler() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, PaymentsBiHandler);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PaymentsBiHandler.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(PaymentsBiHandler)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(PaymentsBiHandler, [{
    key: 'logPaymentSucceeded',
    value: function logPaymentSucceeded() {
      __WEBPACK_IMPORTED_MODULE_5_shared_bi_bi__["a" /* default */].logWidgetSystem('video.purchase.succeeded');
    }
  }, {
    key: 'logSubscribeSucceeded',
    value: function logSubscribeSucceeded() {
      __WEBPACK_IMPORTED_MODULE_5_shared_bi_bi__["a" /* default */].logWidgetSystem('channel.subscribe.succeeded');
    }
  }, {
    key: 'logUnsubscribeSucceeded',
    value: function logUnsubscribeSucceeded() {
      __WEBPACK_IMPORTED_MODULE_5_shared_bi_bi__["a" /* default */].logWidgetSystem('channel.unsubscribe.succeeded');
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(__WEBPACK_IMPORTED_MODULE_6_shared_components_payment_events_payment_events__["a" /* default */], { onSale: this.logPaymentSucceeded,
        onRent: this.logPaymentSucceeded,
        onSubscription: this.logSubscribeSucceeded,
        onSubscriptionCancel: this.logUnsubscribeSucceeded });
    }
  }]);

  return PaymentsBiHandler;
}(React.Component);



/***/ }),
/* 2008 */,
/* 2009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* defineMessages */])({
  viewChannel: {
    id: 'widget.mobile.overlay-button.visit-channel',
    defaultMessage: 'Visit channel'
  },
  signIn: {
    id: 'widget.mobile.overlay-button.sign-in',
    defaultMessage: 'Sign in'
  },
  subscribeShortText: {
    id: 'widget.mobile.overlay-button.subscribe.short',
    defaultMessage: 'Subscribe'
  }
}));

/***/ }),
/* 2010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClassicSearchBar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StripSearchBar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_components_icon_icon__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_components_button_button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__classic_search_bar_styl__ = __webpack_require__(3272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__classic_search_bar_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__classic_search_bar_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__strip_search_bar_styl__ = __webpack_require__(3273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__strip_search_bar_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__strip_search_bar_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__translations__ = __webpack_require__(2517);







var _desc, _value, _class, _class2, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}















var SearchBar = (_class = (_temp = _class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(SearchBar, _React$Component);

  function SearchBar(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, SearchBar);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SearchBar.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(SearchBar)).call(this, props));

    _this.state = {
      currentValue: props.value,
      focused: false
    };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(SearchBar, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.value !== this.props.value) {
        this.setState({ currentValue: nextProps.value });
      }
    }
  }, {
    key: 'updateValue',
    value: function updateValue() {
      var value = this.input.value;

      this.props.onChange(value);
      this.setState({ currentValue: value });
    }
  }, {
    key: 'searchOnEnter',
    value: function searchOnEnter(event) {
      var keyCode = event.nativeEvent.keyCode;
      var value = this.input.value;

      // check if Enter

      if (keyCode === 13) {
        this.sendSearchBI(value);
        this.permitSearch();
      }
    }
  }, {
    key: 'sendSearchBI',
    value: function sendSearchBI(searchQuery) {
      if (searchQuery !== '') {
        this.props.biEvent('widget.search.clicked');
      }
    }
  }, {
    key: 'setFocused',
    value: function setFocused(focused) {
      var _this2 = this;

      // Don`t hide if click outside with new value passed to props
      setTimeout(function () {
        return _this2.setState({ focused: focused });
      }, 0);
    }
  }, {
    key: 'permitSearch',
    value: function permitSearch() {
      var onSearch = this.props.onSearch;
      var value = this.input.value;

      this.setFocused(true);

      onSearch(value);
    }
  }, {
    key: 'closeSearch',
    value: function closeSearch() {
      this.input.value = '';
      this.setState({
        currentValue: '',
        focused: false
      });
      this.props.onClose('');
    }
  }, {
    key: 'handleFocus',
    value: function handleFocus(event) {
      this.props.onFocus(event);
      this.setFocused(true);
    }
  }, {
    key: 'handleBlur',
    value: function handleBlur(event) {
      this.props.onBlur(event);
      this.setFocused(false);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          formatMessage = _props.intl.formatMessage,
          className = _props.className;

      var placeholder = formatMessage(__WEBPACK_IMPORTED_MODULE_14__translations__["a" /* default */].searchVideo);

      return React.createElement(
        'div',
        { className: className,
          styleName: this.styleNames },
        React.createElement(
          'div',
          { styleName: 'background-text' },
          placeholder
        ),
        React.createElement('input', { type: 'text',
          styleName: 'input search-bar',
          className: 'qa-search-bar-input',
          'data-hook': 'search-bar-input',
          value: this.state.currentValue,
          onKeyPress: this.searchOnEnter,
          onFocus: this.handleFocus,
          onBlur: this.handleBlur,
          onChange: this.updateValue,
          ref: function ref(node) {
            return _this3.input = node;
          },
          placeholder: placeholder }),
        React.createElement(__WEBPACK_IMPORTED_MODULE_10_shared_components_icon_icon__["a" /* default */], { styleName: 'search-icon',
          name: 'search-bar' }),
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_11_shared_components_button_button__["e" /* LinkButton */],
          { styleName: 'close-search',
            onClick: this.closeSearch },
          React.createElement(__WEBPACK_IMPORTED_MODULE_10_shared_components_icon_icon__["a" /* default */], { name: 'clear-search' })
        ),
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_11_shared_components_button_button__["e" /* LinkButton */],
          { styleName: 'permit-search',
            onClick: this.permitSearch },
          React.createElement(__WEBPACK_IMPORTED_MODULE_10_shared_components_icon_icon__["a" /* default */], { name: 'permit-search' })
        )
      );
    }
  }, {
    key: 'styleNames',
    get: function get() {
      var _state = this.state,
          currentValue = _state.currentValue,
          focused = _state.focused;
      var value = this.props.value;


      return __WEBPACK_IMPORTED_MODULE_8_classnames___default()('container', {
        'has-value': currentValue,
        'has-submitted-value': value,
        changed: value !== currentValue,
        focused: focused
      });
    }
  }]);

  return SearchBar;
}(React.Component), _class2.propTypes = {
  onChange: React.PropTypes.func,
  onSearch: React.PropTypes.func,
  onClose: React.PropTypes.func,
  onFocus: React.PropTypes.func,
  onBlur: React.PropTypes.func,
  biEvent: React.PropTypes.func,
  className: React.PropTypes.string,
  value: React.PropTypes.string,
  intl: __WEBPACK_IMPORTED_MODULE_7_react_intl__["e" /* intlShape */]
}, _class2.defaultProps = {
  value: '',
  onChange: _.noop,
  onSearch: _.noop,
  onClose: _.noop,
  onFocus: _.noop,
  onBlur: _.noop,
  onKeyPress: _.noop
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'updateValue', [__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'updateValue'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'searchOnEnter', [__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'searchOnEnter'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'permitSearch', [__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'permitSearch'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'closeSearch', [__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'closeSearch'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleFocus', [__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'handleFocus'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleBlur', [__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'handleBlur'), _class.prototype)), _class);


var ClassicSearchBar = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_12__classic_search_bar_styl___default.a)(SearchBar);
var StripSearchBar = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_13__strip_search_bar_styl___default.a)(SearchBar);

/***/ }),
/* 2011 */,
/* 2012 */,
/* 2013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export OPEN_SUBSCRIBE_OVERLAY */
/* unused harmony export OPEN_BUY_VIDEO_OVERLAY */
/* harmony export (immutable) */ __webpack_exports__["b"] = openSubscribeOverlay;
/* harmony export (immutable) */ __webpack_exports__["a"] = openBuyVideoOverlay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_utils_open_overlay__ = __webpack_require__(258);




var OPEN_SUBSCRIBE_OVERLAY = 'OPEN.SUBSCRIBE-OVERLAY';
var OPEN_SUBSCRIBE_OVERLAY_ACTION = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(OPEN_SUBSCRIBE_OVERLAY);

var OPEN_BUY_VIDEO_OVERLAY = 'OPEN.BUY-VIDEO-OVERLAY';
var OPEN_BUY_VIDEO_OVERLAY_ACTION = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["createAction"])(OPEN_BUY_VIDEO_OVERLAY);

function openSubscribeOverlay() {
  return function (dispatch) {
    dispatch(OPEN_SUBSCRIBE_OVERLAY_ACTION());

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_utils_open_overlay__["e" /* openMobileOverlay */])('#/channel/subscribe');
  };
}

function openBuyVideoOverlay(videoId) {
  return function (dispatch) {
    dispatch(OPEN_BUY_VIDEO_OVERLAY_ACTION());

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_utils_open_overlay__["e" /* openMobileOverlay */])('#/video/' + videoId + '/purchase');
  };
}

/***/ }),
/* 2014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_selectors_app_settings__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_utils_get_query_params__ = __webpack_require__(626);





var getQueryParams = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([__WEBPACK_IMPORTED_MODULE_1_shared_selectors_app_settings__["f" /* getSiteUrl */]], __WEBPACK_IMPORTED_MODULE_2_shared_utils_get_query_params__["a" /* default */]);

var getVideoIdFromUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getQueryParams, __WEBPACK_IMPORTED_MODULE_1_shared_selectors_app_settings__["g" /* getCompId */]], function (queryParams, compId) {

  if (!compId || compId !== queryParams['wix-vod-comp-id']) {
    return null;
  }

  return queryParams['wix-vod-video-id'];
});

/* harmony default export */ __webpack_exports__["a"] = (getVideoIdFromUrl);

/***/ }),
/* 2015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = decorate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_utils_get_component_display_name__ = __webpack_require__(237);







function decorate(Wrapper) {
  return function (DecoratedComponent) {
    var _class, _temp;

    return _temp = _class = function (_React$Component) {
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(_class, _React$Component);

      function _class() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, _class);

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_class.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(_class)).apply(this, arguments));
      }

      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(_class, [{
        key: 'render',
        value: function render() {
          return React.createElement(
            Wrapper,
            this.props,
            React.createElement(DecoratedComponent, this.props)
          );
        }
      }]);

      return _class;
    }(React.Component), _class.displayName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_shared_utils_get_component_display_name__["a" /* default */])(Wrapper) + '(' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_shared_utils_get_component_display_name__["a" /* default */])(DecoratedComponent) + ')', _temp;
  };
}

/***/ }),
/* 2016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return OverlayBase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VideoOverlay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChannelOverlay; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_selectors_app_settings__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_ui_selectors_video_cover__ = __webpack_require__(1724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_shared_ui_selectors_channel_cover__ = __webpack_require__(2473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_widget_components_player_overlay_title_title__ = __webpack_require__(1547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_shared_components_resized_image_resized_image__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ui_selectors_video_overlay_play_button_config__ = __webpack_require__(2017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ui_selectors_channel_overlay_play_button_config__ = __webpack_require__(2545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ui_selectors_video_overlay_paid_access_button_config__ = __webpack_require__(1293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ui_selectors_channel_overlay_paid_access_button_config__ = __webpack_require__(2542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_static_images_play_svg__ = __webpack_require__(2697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_static_images_paid_svg__ = __webpack_require__(2696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__overlay_styl__ = __webpack_require__(3287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__overlay_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__overlay_styl__);








var _desc, _value, _class, _class2, _temp, _dec, _dec2, _class3, _class4, _temp2, _dec3, _dec4, _class5, _class6, _temp3;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}
























var OverlayBase = (_class = (_temp = _class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(OverlayBase, _React$Component);

  function OverlayBase() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, OverlayBase);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (OverlayBase.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(OverlayBase)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(OverlayBase, [{
    key: 'handlePlayButtonClick',
    value: function handlePlayButtonClick(event) {
      event.stopPropagation();
      var playButtonConfig = this.props.playButtonConfig;

      playButtonConfig.callback();
    }
  }, {
    key: 'renderPlayButton',
    value: function renderPlayButton() {
      var _props = this.props,
          playButtonConfig = _props.playButtonConfig,
          isMainActionsOnlyIcons = _props.isMainActionsOnlyIcons;


      if (!playButtonConfig) {
        return null;
      }

      var translationData = playButtonConfig.translationData;


      var styleNames = __WEBPACK_IMPORTED_MODULE_9_classnames___default()('button', 'play-button', {
        'only-icon': isMainActionsOnlyIcons
      });

      return React.createElement(
        'a',
        { href: '#',
          styleName: styleNames,
          onClick: this.handlePlayButtonClick,
          className: 'qa-widget-overlay-play-button',
          'data-hook': 'playButton' },
        React.createElement(__WEBPACK_IMPORTED_MODULE_21_static_images_play_svg__["a" /* default */], { styleName: 'icon' }),
        React.createElement(
          'span',
          { styleName: 'text' },
          React.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["a" /* FormattedMessage */], translationData.props)
        )
      );
    }
  }, {
    key: 'handlePaidAccessButtonClick',
    value: function handlePaidAccessButtonClick(event) {
      event.stopPropagation();
      var paidAccessButtonConfig = this.props.paidAccessButtonConfig;

      paidAccessButtonConfig.callback();
    }
  }, {
    key: 'renderPaidAccessButton',
    value: function renderPaidAccessButton() {
      var _props2 = this.props,
          isMainActionsOnlyIcons = _props2.isMainActionsOnlyIcons,
          paidAccessButtonConfig = _props2.paidAccessButtonConfig;


      if (!paidAccessButtonConfig) {
        return null;
      }

      var translationData = paidAccessButtonConfig.translationData;
      var _translationData$pric = translationData.priceModel,
          price = _translationData$pric.price,
          currency = _translationData$pric.currency;


      var values = {
        price: React.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["f" /* FormattedNumber */], { value: price,
          style: 'currency',
          currency: currency })
      };

      var styleNames = __WEBPACK_IMPORTED_MODULE_9_classnames___default()('button', 'paid-access-button', {
        'only-icon': isMainActionsOnlyIcons
      });

      return React.createElement(
        'a',
        { href: '#',
          styleName: styleNames,
          onClick: this.handlePaidAccessButtonClick,
          className: 'qa-widget-overlay-buy-from-button',
          'data-hook': 'paidAccessButton' },
        React.createElement(__WEBPACK_IMPORTED_MODULE_22_static_images_paid_svg__["a" /* default */], { styleName: 'icon' }),
        React.createElement(
          'span',
          { styleName: 'text' },
          React.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["a" /* FormattedMessage */], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, translationData.props, {
            values: values }))
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          channelData = _props3.channelData,
          videoItem = _props3.videoItem,
          className = _props3.className;


      if (!channelData || !videoItem) {
        return null;
      }

      return React.createElement(
        'div',
        { styleName: 'container',
          className: className },
        this.cover,
        React.createElement(
          'div',
          { style: this.opacityStyles,
            styleName: 'content' },
          React.createElement(
            'div',
            { styleName: 'top-content',
              dir: 'ltr' },
            React.createElement(
              'div',
              { styleName: 'title-block' },
              this.title
            ),
            this.buttons
          )
        )
      );
    }
  }, {
    key: 'opacityStyles',
    get: function get() {
      var mainItemOverlayOpacity = this.props.mainItemOverlayOpacity;

      var opacity = _.round(mainItemOverlayOpacity / 100, 2);

      return {
        backgroundColor: 'rgba(0,0,0,' + opacity + ')'
      };
    }
  }, {
    key: 'clampOptions',
    get: function get() {
      return { lineClamp: 2 };
    }

    // Is differs between channel and video and realized at parent class

  }, {
    key: 'titleText',
    get: function get() {
      return null;
    }

    // Is differs between channel and video and realized at parent class

  }, {
    key: 'coverUrl',
    get: function get() {
      return null;
    }
  }, {
    key: 'title',
    get: function get() {
      if (!this.props.canShowMainItemTitle) {
        return null;
      }

      var titleText = this.titleText;

      if (!titleText) {
        return null;
      }

      return React.createElement(__WEBPACK_IMPORTED_MODULE_15_widget_components_player_overlay_title_title__["a" /* default */], { styleName: 'title',
        text: titleText,
        clampOptions: this.clampOptions });
    }
  }, {
    key: 'buttons',
    get: function get() {
      var play = this.renderPlayButton();
      var paidAccess = this.renderPaidAccessButton();

      return React.createElement(
        'div',
        { styleName: 'buttons-wrapper' },
        play,
        paidAccess
      );
    }
  }, {
    key: 'cover',
    get: function get() {
      var _props4 = this.props,
          width = _props4.width,
          height = _props4.height;


      return React.createElement(__WEBPACK_IMPORTED_MODULE_16_shared_components_resized_image_resized_image__["a" /* default */], { src: this.coverUrl,
        styleName: 'cover',
        width: width,
        height: height });
    }
  }]);

  return OverlayBase;
}(React.Component), _class2.propTypes = {
  width: React.PropTypes.number,
  height: React.PropTypes.number,

  className: React.PropTypes.string,
  channelData: React.PropTypes.object,
  videoItem: React.PropTypes.object,

  mainItemOverlayOpacity: React.PropTypes.number,
  canShowMainItemTitle: React.PropTypes.bool,
  isMainActionsOnlyIcons: React.PropTypes.bool,

  playButtonConfig: React.PropTypes.object,
  paidAccessButtonConfig: React.PropTypes.object,

  onPlayRequest: React.PropTypes.func,
  onPlayMemberOnlyRequest: React.PropTypes.func,
  onPlayWithoutPreviewRequest: React.PropTypes.func,
  onSubscriptionRequest: React.PropTypes.func,
  onPurchaseRequest: React.PropTypes.func
}, _class2.defaultProps = {
  showChannelCover: false,
  onPlayRequest: _.noop,
  onPlayMemberOnlyRequest: _.noop,
  onPlayWithoutPreviewRequest: _.noop,
  onPurchaseRequest: _.noop,
  onSubscriptionRequest: _.noop
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'handlePlayButtonClick', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'handlePlayButtonClick'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handlePaidAccessButtonClick', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'handlePaidAccessButtonClick'), _class.prototype)), _class);

var VideoOverlay = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_redux__["a" /* connect */])(function (state, ownProps) {
  return {
    playButtonConfig: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__ui_selectors_video_overlay_play_button_config__["a" /* default */])(ownProps),
    paidAccessButtonConfig: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__ui_selectors_video_overlay_paid_access_button_config__["a" /* default */])(ownProps),
    mainItemOverlayOpacity: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_shared_selectors_app_settings__["C" /* getMainItemOverlayOpacity */])(state),
    canShowMainItemTitle: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_shared_selectors_app_settings__["c" /* canShowMainItemTitle */])(state),
    isMainActionsOnlyIcons: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_shared_selectors_app_settings__["D" /* isCompactMainActionsOnlyIcons */])(state)
  };
}), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_23__overlay_styl___default.a), _dec(_class3 = _dec2(_class3 = (_temp2 = _class4 = function (_OverlayBase) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(VideoOverlay, _OverlayBase);

  function VideoOverlay() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, VideoOverlay);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (VideoOverlay.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(VideoOverlay)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(VideoOverlay, [{
    key: 'titleText',
    get: function get() {
      var videoItem = this.props.videoItem;


      return videoItem.title;
    }
  }, {
    key: 'coverUrl',
    get: function get() {
      var videoItem = this.props.videoItem;


      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_shared_ui_selectors_video_cover__["a" /* getVideoCoverUrl */])(videoItem);
    }
  }]);

  return VideoOverlay;
}(OverlayBase), _class4.displayName = 'VideoOverlay', _temp2)) || _class3) || _class3);

var ChannelOverlay = (_dec3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_redux__["a" /* connect */])(function (state, ownProps) {
  return {
    playButtonConfig: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__ui_selectors_channel_overlay_play_button_config__["a" /* default */])(ownProps),
    paidAccessButtonConfig: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__ui_selectors_channel_overlay_paid_access_button_config__["a" /* default */])(ownProps),
    mainItemOverlayOpacity: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_shared_selectors_app_settings__["C" /* getMainItemOverlayOpacity */])(state),
    canShowMainItemTitle: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_shared_selectors_app_settings__["c" /* canShowMainItemTitle */])(state),
    isMainActionsOnlyIcons: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_shared_selectors_app_settings__["D" /* isCompactMainActionsOnlyIcons */])(state)
  };
}), _dec4 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_23__overlay_styl___default.a), _dec3(_class5 = _dec4(_class5 = (_temp3 = _class6 = function (_OverlayBase2) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(ChannelOverlay, _OverlayBase2);

  function ChannelOverlay() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ChannelOverlay);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ChannelOverlay.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(ChannelOverlay)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(ChannelOverlay, [{
    key: 'titleText',
    get: function get() {
      var channelData = this.props.channelData;


      return channelData.title;
    }
  }, {
    key: 'coverUrl',
    get: function get() {
      var _props5 = this.props,
          channelData = _props5.channelData,
          videoItem = _props5.videoItem;


      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_shared_ui_selectors_channel_cover__["a" /* getChannelCoverUrl */])(channelData) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_shared_ui_selectors_video_cover__["a" /* getVideoCoverUrl */])(videoItem);
    }
  }]);

  return ChannelOverlay;
}(OverlayBase), _class6.displayName = 'ChannelOverlay', _temp3)) || _class5) || _class5);

/***/ }),
/* 2017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getPlayButtonConfig;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_widget_ui_selectors_video_access__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translation_data__ = __webpack_require__(2549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__callback__ = __webpack_require__(2548);





function getPlayButtonConfig(props) {
  var channelData = props.channelData,
      videoItem = props.videoItem,
      currentSiteUser = props.currentSiteUser;


  var availableVideoType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_widget_ui_selectors_video_access__["f" /* getAvailableVideoType */])(channelData, videoItem, currentSiteUser);
  var fullAccessAction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_widget_ui_selectors_video_access__["d" /* getFullAccessActionName */])(channelData, videoItem, currentSiteUser);

  var callback = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__callback__["a" /* default */])(props, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_widget_ui_selectors_video_access__["a" /* canPlayFullOrPreview */])(channelData, videoItem, currentSiteUser), fullAccessAction);

  var translationData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__translation_data__["a" /* default */])(availableVideoType, fullAccessAction);

  if (translationData) {
    return {
      callback: callback,
      translationData: translationData
    };
  }

  return null;
}

/***/ }),
/* 2018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* defineMessages */])({
  shareButtonTooltip: {
    id: 'widget.compact-view.components.action-bar.share-tooltip-button',
    defaultMessage: 'Share'
  },
  shareThisChannel: {
    id: 'widget.compact-view.components.action-bar.share-this-channel',
    defaultMessage: 'Share this Channel'
  },
  channelInfoTooltip: {
    id: 'widget.compact-view.components.action-bar.channel-info-tooltip',
    defaultMessage: 'Channel Info'
  },
  close: {
    id: 'widget.compact-view.components.action-bar.close',
    defaultMessage: 'Close'
  }
}));

/***/ }),
/* 2019 */,
/* 2020 */,
/* 2021 */,
/* 2022 */,
/* 2023 */,
/* 2024 */,
/* 2025 */,
/* 2026 */,
/* 2027 */,
/* 2028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 2029 */,
/* 2030 */,
/* 2031 */,
/* 2032 */,
/* 2033 */,
/* 2034 */,
/* 2035 */,
/* 2036 */,
/* 2037 */,
/* 2038 */,
/* 2039 */,
/* 2040 */,
/* 2041 */,
/* 2042 */,
/* 2043 */,
/* 2044 */,
/* 2045 */,
/* 2046 */,
/* 2047 */,
/* 2048 */,
/* 2049 */,
/* 2050 */,
/* 2051 */,
/* 2052 */,
/* 2053 */,
/* 2054 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2901);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./account-button.styl", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./account-button.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2055 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2906);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./channel-actions.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./channel-actions.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 2056 */,
/* 2057 */,
/* 2058 */,
/* 2059 */,
/* 2060 */,
/* 2061 */,
/* 2062 */,
/* 2063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_redux__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_containers_root__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_widget_routes__ = __webpack_require__(2528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_widget_redux_configure_store__ = __webpack_require__(1616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_env_setup_env__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_analytics_new_relic__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_utils_performance__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_constants_application_names__ = __webpack_require__(1245);












__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_shared_analytics_new_relic__["b" /* initNewRelic */])({ application: __WEBPACK_IMPORTED_MODULE_9_shared_constants_application_names__["a" /* default */].WIDGET });
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_shared_utils_performance__["a" /* addSingleMeasurement */])('appRenderStart');
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_shared_env_setup_env__["a" /* setupEnv */])();

var store = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_widget_redux_configure_store__["a" /* default */])({
  configuration: {
    applicationName: __WEBPACK_IMPORTED_MODULE_9_shared_constants_application_names__["a" /* default */].WIDGET
  }
});
var history = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_router_redux__["syncHistoryWithStore"])(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* hashHistory */], store);

// Render the React application to the DOM
ReactDOM.render(React.createElement(__WEBPACK_IMPORTED_MODULE_3_shared_containers_root__["a" /* default */], { history: history,
  routes: __WEBPACK_IMPORTED_MODULE_4_widget_routes__["a" /* default */],
  store: store }), document.getElementById('root'));

/***/ }),
/* 2064 */,
/* 2065 */,
/* 2066 */,
/* 2067 */,
/* 2068 */,
/* 2069 */,
/* 2070 */,
/* 2071 */,
/* 2072 */,
/* 2073 */,
/* 2074 */,
/* 2075 */,
/* 2076 */,
/* 2077 */,
/* 2078 */,
/* 2079 */,
/* 2080 */,
/* 2081 */,
/* 2082 */,
/* 2083 */,
/* 2084 */,
/* 2085 */,
/* 2086 */,
/* 2087 */,
/* 2088 */,
/* 2089 */,
/* 2090 */,
/* 2091 */,
/* 2092 */,
/* 2093 */,
/* 2094 */,
/* 2095 */,
/* 2096 */,
/* 2097 */,
/* 2098 */,
/* 2099 */,
/* 2100 */,
/* 2101 */,
/* 2102 */,
/* 2103 */,
/* 2104 */,
/* 2105 */,
/* 2106 */,
/* 2107 */,
/* 2108 */,
/* 2109 */,
/* 2110 */,
/* 2111 */,
/* 2112 */,
/* 2113 */,
/* 2114 */,
/* 2115 */,
/* 2116 */,
/* 2117 */,
/* 2118 */,
/* 2119 */,
/* 2120 */,
/* 2121 */,
/* 2122 */,
/* 2123 */,
/* 2124 */,
/* 2125 */,
/* 2126 */,
/* 2127 */,
/* 2128 */,
/* 2129 */,
/* 2130 */,
/* 2131 */,
/* 2132 */,
/* 2133 */,
/* 2134 */,
/* 2135 */,
/* 2136 */,
/* 2137 */,
/* 2138 */,
/* 2139 */,
/* 2140 */,
/* 2141 */,
/* 2142 */,
/* 2143 */,
/* 2144 */,
/* 2145 */,
/* 2146 */,
/* 2147 */,
/* 2148 */,
/* 2149 */,
/* 2150 */,
/* 2151 */,
/* 2152 */,
/* 2153 */,
/* 2154 */,
/* 2155 */,
/* 2156 */,
/* 2157 */,
/* 2158 */,
/* 2159 */,
/* 2160 */,
/* 2161 */,
/* 2162 */,
/* 2163 */,
/* 2164 */,
/* 2165 */,
/* 2166 */,
/* 2167 */,
/* 2168 */,
/* 2169 */,
/* 2170 */,
/* 2171 */,
/* 2172 */,
/* 2173 */,
/* 2174 */,
/* 2175 */,
/* 2176 */,
/* 2177 */,
/* 2178 */,
/* 2179 */,
/* 2180 */,
/* 2181 */,
/* 2182 */,
/* 2183 */,
/* 2184 */,
/* 2185 */,
/* 2186 */,
/* 2187 */,
/* 2188 */,
/* 2189 */,
/* 2190 */,
/* 2191 */,
/* 2192 */,
/* 2193 */,
/* 2194 */,
/* 2195 */,
/* 2196 */,
/* 2197 */,
/* 2198 */,
/* 2199 */,
/* 2200 */,
/* 2201 */,
/* 2202 */,
/* 2203 */,
/* 2204 */,
/* 2205 */,
/* 2206 */,
/* 2207 */,
/* 2208 */,
/* 2209 */,
/* 2210 */,
/* 2211 */,
/* 2212 */,
/* 2213 */,
/* 2214 */,
/* 2215 */,
/* 2216 */,
/* 2217 */,
/* 2218 */,
/* 2219 */,
/* 2220 */,
/* 2221 */,
/* 2222 */,
/* 2223 */,
/* 2224 */,
/* 2225 */,
/* 2226 */,
/* 2227 */,
/* 2228 */,
/* 2229 */,
/* 2230 */,
/* 2231 */,
/* 2232 */,
/* 2233 */,
/* 2234 */,
/* 2235 */,
/* 2236 */,
/* 2237 */,
/* 2238 */,
/* 2239 */,
/* 2240 */,
/* 2241 */,
/* 2242 */,
/* 2243 */,
/* 2244 */,
/* 2245 */,
/* 2246 */,
/* 2247 */,
/* 2248 */,
/* 2249 */,
/* 2250 */,
/* 2251 */,
/* 2252 */,
/* 2253 */,
/* 2254 */,
/* 2255 */,
/* 2256 */,
/* 2257 */,
/* 2258 */,
/* 2259 */,
/* 2260 */,
/* 2261 */,
/* 2262 */,
/* 2263 */,
/* 2264 */,
/* 2265 */,
/* 2266 */,
/* 2267 */,
/* 2268 */,
/* 2269 */,
/* 2270 */,
/* 2271 */,
/* 2272 */,
/* 2273 */,
/* 2274 */,
/* 2275 */,
/* 2276 */,
/* 2277 */,
/* 2278 */,
/* 2279 */,
/* 2280 */,
/* 2281 */,
/* 2282 */,
/* 2283 */,
/* 2284 */,
/* 2285 */,
/* 2286 */,
/* 2287 */,
/* 2288 */,
/* 2289 */,
/* 2290 */,
/* 2291 */,
/* 2292 */,
/* 2293 */,
/* 2294 */,
/* 2295 */,
/* 2296 */,
/* 2297 */,
/* 2298 */,
/* 2299 */,
/* 2300 */,
/* 2301 */,
/* 2302 */,
/* 2303 */,
/* 2304 */,
/* 2305 */,
/* 2306 */,
/* 2307 */,
/* 2308 */,
/* 2309 */,
/* 2310 */,
/* 2311 */,
/* 2312 */,
/* 2313 */,
/* 2314 */,
/* 2315 */,
/* 2316 */,
/* 2317 */,
/* 2318 */,
/* 2319 */,
/* 2320 */,
/* 2321 */,
/* 2322 */,
/* 2323 */,
/* 2324 */,
/* 2325 */,
/* 2326 */,
/* 2327 */,
/* 2328 */,
/* 2329 */,
/* 2330 */,
/* 2331 */,
/* 2332 */,
/* 2333 */,
/* 2334 */,
/* 2335 */,
/* 2336 */,
/* 2337 */,
/* 2338 */,
/* 2339 */,
/* 2340 */,
/* 2341 */,
/* 2342 */,
/* 2343 */,
/* 2344 */,
/* 2345 */,
/* 2346 */,
/* 2347 */,
/* 2348 */,
/* 2349 */,
/* 2350 */,
/* 2351 */,
/* 2352 */,
/* 2353 */,
/* 2354 */,
/* 2355 */,
/* 2356 */,
/* 2357 */,
/* 2358 */,
/* 2359 */,
/* 2360 */,
/* 2361 */,
/* 2362 */,
/* 2363 */,
/* 2364 */,
/* 2365 */,
/* 2366 */,
/* 2367 */,
/* 2368 */,
/* 2369 */,
/* 2370 */,
/* 2371 */,
/* 2372 */,
/* 2373 */,
/* 2374 */,
/* 2375 */,
/* 2376 */,
/* 2377 */,
/* 2378 */,
/* 2379 */,
/* 2380 */,
/* 2381 */,
/* 2382 */,
/* 2383 */,
/* 2384 */,
/* 2385 */,
/* 2386 */,
/* 2387 */,
/* 2388 */,
/* 2389 */,
/* 2390 */,
/* 2391 */,
/* 2392 */,
/* 2393 */,
/* 2394 */,
/* 2395 */,
/* 2396 */,
/* 2397 */,
/* 2398 */,
/* 2399 */,
/* 2400 */,
/* 2401 */,
/* 2402 */,
/* 2403 */,
/* 2404 */,
/* 2405 */,
/* 2406 */,
/* 2407 */,
/* 2408 */,
/* 2409 */,
/* 2410 */,
/* 2411 */,
/* 2412 */,
/* 2413 */,
/* 2414 */,
/* 2415 */,
/* 2416 */,
/* 2417 */,
/* 2418 */,
/* 2419 */,
/* 2420 */,
/* 2421 */,
/* 2422 */,
/* 2423 */,
/* 2424 */,
/* 2425 */,
/* 2426 */,
/* 2427 */,
/* 2428 */,
/* 2429 */,
/* 2430 */,
/* 2431 */,
/* 2432 */,
/* 2433 */,
/* 2434 */,
/* 2435 */,
/* 2436 */,
/* 2437 */,
/* 2438 */,
/* 2439 */,
/* 2440 */,
/* 2441 */,
/* 2442 */,
/* 2443 */,
/* 2444 */,
/* 2445 */,
/* 2446 */,
/* 2447 */,
/* 2448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Measure; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_utils_node__ = __webpack_require__(2486);






var _class, _temp;



var Measure = (_temp = _class = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Measure, _React$Component);

  function Measure(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Measure);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Measure.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Measure)).call(this, props));

    _this._node = null;
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Measure, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.measure();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.shouldMeasure) {
        this.measure();
      }
    }
  }, {
    key: 'measure',
    value: function measure() {
      if (!this.props.shouldMeasure) {
        return;
      }

      this.props.onMeasure({ width: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_shared_utils_node__["a" /* getWidth */])(this._node) });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var children = this.props.children;

      return React.cloneElement(React.Children.only(children), { ref: function ref(_ref) {
          return _this2._node = _ref;
        } });
    }
  }]);

  return Measure;
}(React.Component), _class.propTypes = {
  shouldMeasure: React.PropTypes.bool,
  onMeasure: React.PropTypes.func,
  children: React.PropTypes.element
}, _class.defaultProps = {
  shouldMeasure: true,
  onMeasure: _.noop
}, _temp);


/***/ }),
/* 2449 */,
/* 2450 */,
/* 2451 */,
/* 2452 */,
/* 2453 */,
/* 2454 */,
/* 2455 */,
/* 2456 */,
/* 2457 */,
/* 2458 */,
/* 2459 */,
/* 2460 */,
/* 2461 */,
/* 2462 */,
/* 2463 */,
/* 2464 */,
/* 2465 */,
/* 2466 */,
/* 2467 */,
/* 2468 */,
/* 2469 */,
/* 2470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* defineMessages */])({
  next: {
    id: 'shared.navigation.next-page',
    defaultMessage: 'Next'
  },
  prev: {
    id: 'shared.navigation.previous-page',
    defaultMessage: 'Prev'
  }
}));

/***/ }),
/* 2471 */,
/* 2472 */,
/* 2473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getChannelCoverUrl;
function getChannelCoverUrl(channelData) {
  var coverUrl = channelData.coverUrl,
      customCoverUrl = channelData.customCoverUrl;

  return customCoverUrl || coverUrl;
}

/***/ }),
/* 2474 */,
/* 2475 */,
/* 2476 */,
/* 2477 */,
/* 2478 */,
/* 2479 */,
/* 2480 */,
/* 2481 */,
/* 2482 */,
/* 2483 */,
/* 2484 */,
/* 2485 */,
/* 2486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getWidth;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_utils_attempt__ = __webpack_require__(163);


function getWidth(node) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_utils_attempt__["a" /* attempt */])(function () {
    return node.getBoundingClientRect().width;
  }, 0);
}

/***/ }),
/* 2487 */,
/* 2488 */,
/* 2489 */,
/* 2490 */,
/* 2491 */,
/* 2492 */,
/* 2493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccountButtonWithTooltip; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_components_tooltip_tooltip__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_constants_popout__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__account_info_account_info__ = __webpack_require__(1824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__account_button_with_tooltip_styl__ = __webpack_require__(3251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__account_button_with_tooltip_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__account_button_with_tooltip_styl__);






var _class, _temp;









var AccountButtonWithTooltip = (_temp = _class = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(AccountButtonWithTooltip, _React$Component);

  function AccountButtonWithTooltip() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AccountButtonWithTooltip);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AccountButtonWithTooltip.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(AccountButtonWithTooltip)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(AccountButtonWithTooltip, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          logoutLabel = _props.logoutLabel,
          userEmail = _props.userEmail,
          onLogoutClick = _props.onLogoutClick,
          className = _props.className,
          tooltipSide = _props.tooltipSide,
          popoutClassName = _props.popoutClassName,
          popoutTriangleClassName = _props.popoutTriangleClassName;


      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_6_shared_components_tooltip_tooltip__["a" /* default */],
        { preventHideOnHover: true,
          popoutSide: tooltipSide,
          iconName: 'avatar',
          className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(__WEBPACK_IMPORTED_MODULE_9__account_button_with_tooltip_styl___default.a['account-info-button'], className),
          popoutClassName: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(__WEBPACK_IMPORTED_MODULE_9__account_button_with_tooltip_styl___default.a.popout, popoutClassName),
          popoutInnerClassName: __WEBPACK_IMPORTED_MODULE_9__account_button_with_tooltip_styl___default.a['popout-inner'],
          popoutTriangleClassName: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(__WEBPACK_IMPORTED_MODULE_9__account_button_with_tooltip_styl___default.a['popout-triangle'], popoutTriangleClassName) },
        React.createElement(__WEBPACK_IMPORTED_MODULE_8__account_info_account_info__["a" /* default */], { logoutLabel: logoutLabel,
          userEmail: userEmail,
          onLogoutClick: onLogoutClick })
      );
    }
  }]);

  return AccountButtonWithTooltip;
}(React.Component), _class.propTypes = {
  className: React.PropTypes.string,
  popoutClassName: React.PropTypes.string,
  popoutTriangleClassName: React.PropTypes.string,
  logoutLabel: React.PropTypes.string,
  userEmail: React.PropTypes.string,
  tooltipSide: React.PropTypes.oneOf(_.values(__WEBPACK_IMPORTED_MODULE_7_shared_constants_popout__["a" /* sides */])),

  onLogoutClick: React.PropTypes.func,
  onClick: React.PropTypes.func
}, _class.defaultProps = {
  tooltipSide: __WEBPACK_IMPORTED_MODULE_7_shared_constants_popout__["a" /* sides */].TOP
}, _temp);


/***/ }),
/* 2494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccountInfoButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_components_icon_icon__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__account_button_styl__ = __webpack_require__(2054);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__account_button_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__account_button_styl__);






var _class, _temp;






var AccountInfoButton = (_temp = _class = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(AccountInfoButton, _React$Component);

  function AccountInfoButton() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AccountInfoButton);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AccountInfoButton.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(AccountInfoButton)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(AccountInfoButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          onClick = _props.onClick;


      return React.createElement(__WEBPACK_IMPORTED_MODULE_6_shared_components_icon_icon__["a" /* default */], { name: 'avatar',
        'data-hook': 'simpleInfoButton',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(__WEBPACK_IMPORTED_MODULE_7__account_button_styl___default.a['account-info-button'], className),
        onClick: onClick });
    }
  }]);

  return AccountInfoButton;
}(React.Component), _class.propTypes = {
  className: React.PropTypes.string,
  onClick: React.PropTypes.func
}, _temp);


/***/ }),
/* 2495 */,
/* 2496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AnimateCrossfade; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__animate_crossfade_styl__ = __webpack_require__(3253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__animate_crossfade_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__animate_crossfade_styl__);








var _desc, _value, _class, _class2, _temp2;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}





var AnimateCrossfade = (_class = (_temp2 = _class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(AnimateCrossfade, _React$Component);

  function AnimateCrossfade() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, AnimateCrossfade);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = AnimateCrossfade.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(AnimateCrossfade)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      nextIndex: 0,
      children: []
    }, _this.prevIndex = null, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(AnimateCrossfade, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.handlePropsUpdate(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.handlePropsUpdate(nextProps);
    }
  }, {
    key: 'handlePropsUpdate',
    value: function handlePropsUpdate(_ref2) {
      var _this2 = this;

      var currentIdIndex = _ref2.currentIdIndex;

      this.prevIndex = this.props.currentIdIndex;
      var children = this.props.children;
      // Because of canShowChannelCover stuff

      setTimeout(function () {
        _this2.setState({
          children: children,
          nextIndex: currentIdIndex
        });
      });
    }
  }, {
    key: 'isActive',
    value: function isActive(slideIndex) {
      return slideIndex === this.state.nextIndex;
    }
  }, {
    key: 'isPrevActive',
    value: function isPrevActive(slideIndex) {
      return slideIndex === this.prevIndex;
    }
  }, {
    key: 'handleTransitionEnd',
    value: function handleTransitionEnd() {
      // Because of canShowChannelCover stuff
      this.setState({
        children: this.props.children
      });
    }
  }, {
    key: 'renderWrappedSlide',
    value: function renderWrappedSlide(slide, slideIndex) {
      var _classnames;

      var className = __WEBPACK_IMPORTED_MODULE_8_classnames___default()(__WEBPACK_IMPORTED_MODULE_9__animate_crossfade_styl___default.a.slide, (_classnames = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, __WEBPACK_IMPORTED_MODULE_9__animate_crossfade_styl___default.a.active, this.isActive(slideIndex)), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classnames, __WEBPACK_IMPORTED_MODULE_9__animate_crossfade_styl___default.a.prevActive, this.isPrevActive(slideIndex)), _classnames));

      return React.createElement(
        'div',
        { className: className,
          onTransitionEnd: this.handleTransitionEnd,
          key: slideIndex },
        slide
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_9__animate_crossfade_styl___default.a.container },
        _.map(this.state.children, this.renderWrappedSlide)
      );
    }
  }]);

  return AnimateCrossfade;
}(React.Component), _class2.propTypes = {
  children: React.PropTypes.any,
  currentIdIndex: React.PropTypes.number
}, _class2.defaultProps = {
  children: [],
  currentIdIndex: 0
}, _temp2), (_applyDecoratedDescriptor(_class.prototype, 'handleTransitionEnd', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'handleTransitionEnd'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'renderWrappedSlide', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'renderWrappedSlide'), _class.prototype)), _class);


/***/ }),
/* 2497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* defineMessages */])({
  allVideos: {
    id: 'widget.categories.all-videos',
    defaultMessage: 'All Categories'
  }
}));

/***/ }),
/* 2498 */,
/* 2499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* defineMessages */])({
  subscribe: {
    id: 'widget.channel-actions.subscribe',
    defaultMessage: 'Subscribe {price}/month'
  }
}));

/***/ }),
/* 2500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CoverWithOverlay; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_widget_ui_selectors_video_access__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_selectors_channels__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_widget_selectors_current_site_user__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_ui_selectors_video_video_origin__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_widget_selectors_get_video_urls__ = __webpack_require__(1552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_widget_redux_client_actions_mobile_overlay_openners_payment_pages_actions__ = __webpack_require__(2013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_widget_redux_client_actions_mobile_overlay_openners_main_openners__ = __webpack_require__(1736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_widget_components_player_cover_player_cover__ = __webpack_require__(2509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_widget_components_player_overlay_mobile_three_rows_widget_three_rows_widget__ = __webpack_require__(2514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__mobile_cover_with_overlay_styl__ = __webpack_require__(3257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__mobile_cover_with_overlay_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__mobile_cover_with_overlay_styl__);







var _dec, _class, _desc, _value, _class2, _class3, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}


















var CoverWithOverlay = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["a" /* connect */])(function (state, props) {
  return {
    channelData: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_shared_selectors_channels__["a" /* getChannelForWidget */])(state),
    currentSiteUser: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_widget_selectors_current_site_user__["a" /* getCurrentSiteUser */])(state),
    videoUrls: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_widget_selectors_get_video_urls__["a" /* default */])(state, props)
  };
}, function (dispatch, _ref) {
  var videoItem = _ref.videoItem;
  return {
    onBuyVideoClick: function onBuyVideoClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_widget_redux_client_actions_mobile_overlay_openners_payment_pages_actions__["a" /* openBuyVideoOverlay */])(videoItem.id));
    },
    onOpenVideoClick: function onOpenVideoClick() {
      return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_widget_redux_client_actions_mobile_overlay_openners_main_openners__["a" /* openVideoPage */])(videoItem.id));
    }
  };
}), _dec(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(CoverWithOverlay, _React$Component);

  function CoverWithOverlay() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, CoverWithOverlay);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CoverWithOverlay.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(CoverWithOverlay)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(CoverWithOverlay, [{
    key: 'onPlayClick',
    value: function onPlayClick() {
      var _props = this.props,
          onPlayClick = _props.onPlayClick,
          channelData = _props.channelData,
          videoItem = _props.videoItem,
          currentSiteUser = _props.currentSiteUser,
          onMemberSignUp = _props.onMemberSignUp,
          videoUrls = _props.videoUrls;


      var accessActionName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_widget_ui_selectors_video_access__["d" /* getFullAccessActionName */])(channelData, videoItem, currentSiteUser);

      if (accessActionName === __WEBPACK_IMPORTED_MODULE_8_widget_ui_selectors_video_access__["c" /* FULL_ACCESS_ACTION_NAMES */].SIGN_IN) {
        onMemberSignUp();
        return;
      }

      if (!videoUrls && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_shared_ui_selectors_video_video_origin__["b" /* isExternalVideo */])(videoItem)) {
        return;
      }

      onPlayClick();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          videoItem = _props2.videoItem,
          showChannelCover = _props2.showChannelCover,
          onOpenVideoClick = _props2.onOpenVideoClick,
          onBuyVideoClick = _props2.onBuyVideoClick,
          onSignInRequested = _props2.onSignInRequested,
          itemWidth = _props2.itemWidth,
          itemHeight = _props2.itemHeight,
          className = _props2.className;


      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_15_widget_components_player_cover_player_cover__["a" /* PlayerCover */],
        { videoItem: videoItem,
          className: className,
          coverWidth: itemWidth,
          coverHeight: itemHeight,
          showChannelCover: showChannelCover },
        React.createElement(__WEBPACK_IMPORTED_MODULE_16_widget_components_player_overlay_mobile_three_rows_widget_three_rows_widget__["a" /* default */], { videoItem: videoItem,
          className: __WEBPACK_IMPORTED_MODULE_17__mobile_cover_with_overlay_styl___default.a['slidable-overlay'],
          showChannelCover: showChannelCover,
          onSignInRequested: onSignInRequested,
          onOpenVideoClick: onOpenVideoClick,
          onBuyVideoClick: onBuyVideoClick,
          onPlayClick: this.onPlayClick })
      );
    }
  }]);

  return CoverWithOverlay;
}(React.Component), _class3.propTypes = {
  channelData: React.PropTypes.object,
  canShowChannelCover: React.PropTypes.bool,
  onBuyVideoClick: React.PropTypes.func,
  onOpenVideoClick: React.PropTypes.func,
  onSignInRequested: React.PropTypes.func,

  videoItem: React.PropTypes.object,
  showChannelCover: React.PropTypes.bool,
  className: React.PropTypes.string,
  itemWidth: React.PropTypes.number,
  itemHeight: React.PropTypes.number,
  currentSiteUser: React.PropTypes.object,
  onPlayClick: React.PropTypes.func,
  onMemberSignUp: React.PropTypes.func,
  videoUrls: React.PropTypes.object
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onPlayClick', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'onPlayClick'), _class2.prototype)), _class2)) || _class);


/***/ }),
/* 2501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_utils_run_once__ = __webpack_require__(2000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_widget_components_mobile_carousel_visible_on_screen__ = __webpack_require__(2506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__first_time_track_animation_styl__ = __webpack_require__(3259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__first_time_track_animation_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__first_time_track_animation_styl__);









function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}










var firstTimeTrackAnimation = function firstTimeTrackAnimation(WrappedComponent) {
  var _class, _desc, _value, _class2, _class3, _temp2;

  var FirstTimeTrackAnimation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_widget_components_mobile_carousel_visible_on_screen__["a" /* visibleInViewPort */])(_class = (_class2 = (_temp2 = _class3 = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(FirstTimeTrackAnimation, _React$Component);

    function FirstTimeTrackAnimation() {
      var _ref;

      var _temp, _this, _ret;

      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, FirstTimeTrackAnimation);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = FirstTimeTrackAnimation.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(FirstTimeTrackAnimation)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        isTrackStarted: false
      }, _this._alreadyWasShown = false, _temp), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(FirstTimeTrackAnimation, [{
      key: 'updateTrackStarted',
      value: function updateTrackStarted() {
        this.setState({
          isTrackStarted: true
        });
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            trackClassName = _props.trackClassName,
            isVisibleInViewport = _props.isVisibleInViewport;
        var isTrackStarted = this.state.isTrackStarted;

        // If track was already started than don't add track class name because it lead to a bug on iOS
        // https://trello.com/c/wGyLqjFd

        var shouldApplyAnimationClassName = !isTrackStarted && (this._alreadyWasShown || isVisibleInViewport);

        var mergedTrackClassName = __WEBPACK_IMPORTED_MODULE_8_classnames___default()(trackClassName, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_12__first_time_track_animation_styl___default.a['start-animation'], shouldApplyAnimationClassName));

        if (shouldApplyAnimationClassName) {
          this._alreadyWasShown = true;
        }

        return React.createElement(WrappedComponent, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.props, {
          onUserStartedTracking: this.updateTrackStarted,
          trackClassName: mergedTrackClassName }));
      }
    }]);

    return FirstTimeTrackAnimation;
  }(React.Component), _class3.propTypes = {
    isVisibleInViewport: React.PropTypes.bool,
    trackClassName: React.PropTypes.string
  }, _class3.defaultProps = {
    isVisibleInViewport: false
  }, _temp2), (_applyDecoratedDescriptor(_class2.prototype, 'updateTrackStarted', [__WEBPACK_IMPORTED_MODULE_9_core_decorators_lib_autobind___default.a, __WEBPACK_IMPORTED_MODULE_10_shared_utils_run_once__["a" /* default */]], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'updateTrackStarted'), _class2.prototype)), _class2)) || _class;

  FirstTimeTrackAnimation.WixWrappedComponent = WrappedComponent;

  return FirstTimeTrackAnimation;
};

/* harmony default export */ __webpack_exports__["a"] = (firstTimeTrackAnimation);

/***/ }),
/* 2502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CarouselButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_components_icon_icon__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__buttons_styl__ = __webpack_require__(3260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__buttons_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__buttons_styl__);







var _dec, _class, _desc, _value, _class2, _class3, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}










var CarouselButton = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_10__buttons_styl___default.a), _dec(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(CarouselButton, _React$Component);

  function CarouselButton() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, CarouselButton);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CarouselButton.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(CarouselButton)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(CarouselButton, [{
    key: 'handleClick',
    value: function handleClick(event) {
      event.preventDefault();
      this.props.onClick(event);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          direction = _props.direction,
          isActive = _props.isActive;


      var styleNames = __WEBPACK_IMPORTED_MODULE_7_classnames___default()('button-container', direction, {
        inactive: isActive === false
      });

      return React.createElement(
        'div',
        { styleName: styleNames,
          onClick: this.handleClick },
        React.createElement(
          'div',
          { styleName: 'button' },
          React.createElement(__WEBPACK_IMPORTED_MODULE_9_shared_components_icon_icon__["a" /* default */], { styleName: 'triangle-' + direction,
            name: 'triangle-right' })
        )
      );
    }
  }]);

  return CarouselButton;
}(React.Component), _class3.propTypes = {
  direction: React.PropTypes.string,
  isActive: React.PropTypes.bool,
  onClick: React.PropTypes.func.isRequired
}, _class3.defaultProps = {
  direction: 'left',
  isActive: true
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'handleClick', [__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handleClick'), _class2.prototype)), _class2)) || _class);


/***/ }),
/* 2503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MobileCarousel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_lib_ReactTransitionEvents__ = __webpack_require__(3076);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_lib_ReactTransitionEvents___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_lib_ReactTransitionEvents__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__sizes__ = __webpack_require__(2504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__buttons__ = __webpack_require__(2502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__track__ = __webpack_require__(2505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mobile_carousel_styl__ = __webpack_require__(3261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mobile_carousel_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__mobile_carousel_styl__);








var _dec, _class, _desc, _value, _class2, _class3, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}












/*
 Mobile carousel is inspired by https://github.com/akiran/react-slick/tree/master/src
*/

function getTrackCSS(_ref) {
  var slideCount = _ref.slideCount,
      slidesToShow = _ref.slidesToShow,
      slideWidth = _ref.slideWidth,
      left = _ref.left;

  var trackWidth = (slideCount + 2 * slidesToShow) * slideWidth;

  return {
    opacity: 1,
    width: trackWidth,
    WebkitTransform: 'translate3d(' + left + 'px, 0px, 0px)',
    transform: 'translate3d(' + left + 'px, 0px, 0px)',
    transition: '',
    WebkitTransition: '',
    msTransform: 'translateX(' + left + 'px)'
  };
}

function getTrackAnimateCSS(spec) {
  var style = getTrackCSS(spec);
  // useCSS is true by default so it can be undefined
  style.WebkitTransition = '-webkit-transform \'' + spec.speed + 'ms ' + spec.cssEase;
  style.transition = 'transform ' + spec.speed + 'ms ' + spec.cssEase;
  return style;
}

function calcSwipeDirection(touchObject) {
  var xDist = touchObject.startX - touchObject.curX;
  var yDist = touchObject.startY - touchObject.curY;
  var r = Math.atan2(yDist, xDist);

  var swipeAngle = Math.round(r * 180 / Math.PI);
  if (swipeAngle < 0) {
    swipeAngle = 360 - Math.abs(swipeAngle);
  }
  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
    return 'left';
  }
  if (swipeAngle >= 135 && swipeAngle <= 225) {
    return 'right';
  }

  return 'vertical';
}

var MobileCarousel = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_13__mobile_carousel_styl___default.a), _dec(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(MobileCarousel, _React$Component);

  function MobileCarousel(props) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, MobileCarousel);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (MobileCarousel.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(MobileCarousel)).call(this, props));

    _this._touchObject = {
      startX: 0,
      startY: 0,
      curX: 0,
      curY: 0
    };


    _this._currentSlide = props.initialSlide;

    _this.state = {
      slideWidth: null
    };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(MobileCarousel, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.update();
      window.addEventListener('resize', this.update);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.update);
    }
  }, {
    key: 'update',
    value: function update() {
      var _this2 = this;

      if (!this.wrapper) {
        return;
      }

      var _props = this.props,
          slidesToShow = _props.slidesToShow,
          slidesPreviewWidth = _props.slidesPreviewWidth;

      var listWidth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__sizes__["a" /* getWidth */])(this.list);
      var trackWidth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__sizes__["a" /* getWidth */])(this.track);
      var slideWidth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__sizes__["b" /* getSlideWidth */])(this.wrapper, slidesToShow, { slidesPreviewWidth: slidesPreviewWidth });

      this.setState({
        slideWidth: slideWidth,
        listWidth: listWidth,
        trackWidth: trackWidth
      }, function () {
        var targetLeft = _this2.getTrackLeft(_this2._currentSlide, slideWidth, slidesPreviewWidth);
        // getCSS function needs previously set state
        var trackStyle = getTrackCSS(_.assign({
          left: targetLeft,
          slideCount: _this2.getSlidesCount()
        }, _this2.props, _this2.state));

        _this2.setTrackStyle(trackStyle);
      });
    }
  }, {
    key: 'getTrackLeft',
    value: function getTrackLeft(slideIndex, slideWidth, slidesPreviewWidth) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__sizes__["c" /* getTrackLeft */])(this.getSlidesCount(), this.props.slidesToShow, slideIndex, slideWidth, slidesPreviewWidth);
    }
  }, {
    key: 'setTrackStyle',
    value: function setTrackStyle(style) {
      _.assign(this.track.style, style);
    }
  }, {
    key: 'swipeStart',
    value: function swipeStart(e) {
      var posX = _.isUndefined(e.touches) ? e.clientX : e.touches[0].pageX;
      var posY = _.isUndefined(e.touches) ? e.clientY : e.touches[0].pageY;

      this._dragging = true;
      this._animating = false;
      this._swipeStarted = false;

      this._touchObject = {
        startX: posX,
        startY: posY,
        curX: posX,
        curY: posY
      };
    }
  }, {
    key: 'getSlidesCount',
    value: function getSlidesCount() {
      return React.Children.count(this.props.children);
    }
  }, {
    key: 'swipeMove',
    value: function swipeMove(e) {
      if (!this._dragging) {
        return;
      }
      if (this._animating) {
        return;
      }

      var touchObject = _.clone(this._touchObject);
      var slideWidth = this.state.slideWidth;
      var _props2 = this.props,
          slidesToShow = _props2.slidesToShow,
          slidesPreviewWidth = _props2.slidesPreviewWidth,
          onUserStartedTracking = _props2.onUserStartedTracking;

      var currentSlide = this._currentSlide;

      var curLeft = this.getTrackLeft(currentSlide, slideWidth, slidesPreviewWidth);
      touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
      touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
      touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));

      var positionOffset = touchObject.curX > touchObject.startX ? 1 : -1;

      var slidesCount = this.getSlidesCount();
      var swipeDirection = calcSwipeDirection.call(this, touchObject);
      var touchSwipeLength = touchObject.swipeLength;

      if (currentSlide === 0 && swipeDirection === 'right' || currentSlide >= slidesCount - slidesToShow && swipeDirection === 'left') {
        touchSwipeLength = touchObject.swipeLength * this.props.edgeFriction;
      }

      var swipeLeft = curLeft + touchSwipeLength * positionOffset;
      this._touchObject = touchObject;

      var trackStyle = getTrackCSS(_.assign({
        left: swipeLeft,
        slideCount: this.getSlidesCount()
      }, this.props, this.state));

      this.setTrackStyle(trackStyle);

      if (this._swipeStarted) {
        // prevent vertical scrolling in browsers what doesn't support passive touch events
        // https://developers.google.com/web/updates/2016/06/passive-event-listeners
        e.preventDefault();
        return;
      }

      if (touchObject.swipeLength > 4) {
        this._swipeStarted = true;
        onUserStartedTracking();
      }
    }
  }, {
    key: 'calcSlidesToScroll',
    value: function calcSlidesToScroll(swipeLength) {
      var _state = this.state,
          slideWidth = _state.slideWidth,
          listWidth = _state.listWidth;
      var touchThreshold = this.props.touchThreshold;

      var minSwipe = listWidth / touchThreshold;
      var slidesCount = Math.floor(swipeLength / slideWidth);
      var lastSlideLength = swipeLength % slideWidth;
      if (lastSlideLength > minSwipe) {
        slidesCount += 1;
      }
      return slidesCount;
    }
  }, {
    key: 'swipeEnd',
    value: function swipeEnd(e) {
      if (!this._dragging) {
        return;
      }
      var touchObject = this._touchObject;
      var minSwipe = this.state.listWidth / this.props.touchThreshold;
      var swipeDirection = calcSwipeDirection.call(this, touchObject);
      var currentSlide = this._currentSlide;

      // reset the state of touch related state variables.
      this._dragging = false;
      this._touchObject = {};
      // Fix for #13
      if (!touchObject.swipeLength) {
        return;
      }
      if (touchObject.swipeLength > minSwipe) {
        var slidesToScroll = this.calcSlidesToScroll(touchObject.swipeLength);
        e.preventDefault();
        if (swipeDirection === 'left') {
          this.slideHandler(currentSlide + slidesToScroll);
        } else if (swipeDirection === 'right') {
          this.slideHandler(currentSlide - slidesToScroll);
        } else {
          this.slideHandler(currentSlide);
        }
      } else {
        // Adjust the track back to it's original position.
        var currentLeft = this.getTrackLeft(currentSlide, this.state.slideWidth, this.props.slidesPreviewWidth);

        this.setTrackStyle(getTrackAnimateCSS(_.assign({
          left: currentLeft,
          slideCount: this.getSlidesCount()
        }, this.props, this.state)));
      }
    }
  }, {
    key: 'slideHandler',
    value: function slideHandler(index) {
      var _this3 = this;

      // Functionality of animateSlide and postSlide is merged into this function

      if (this.props.waitForAnimate && this._animating) {
        return;
      }

      var currentSlide = void 0;
      var slideCount = this.getSlidesCount();
      var targetSlide = index;

      if (targetSlide < 0) {
        currentSlide = 0;
      } else if (targetSlide > slideCount - this.props.slidesToShow) {
        currentSlide = slideCount - this.props.slidesToShow;
      } else {
        currentSlide = targetSlide;
      }

      var targetLeft = this.getTrackLeft(currentSlide, this.state.slideWidth, this.props.slidesPreviewWidth);

      if (this.props.beforeChange) {
        this.props.beforeChange(this._currentSlide, currentSlide);
      }

      // Slide Transition happens here.
      // animated transition happens to target Slide and
      // non - animated transition happens to current Slide

      var nextStateChanges = {
        trackStyle: getTrackCSS(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
          left: targetLeft,
          slideCount: this.getSlidesCount()
        }, this.props, this.state)),
        swipeLeft: null
      };

      var callback = function callback() {
        _this3._animating = false;
        _this3.setTrackStyle(nextStateChanges.trackStyle);
        _this3.props.afterChange(currentSlide);
        __WEBPACK_IMPORTED_MODULE_8_react_lib_ReactTransitionEvents___default.a.removeEndEventListener(_this3.track, callback);
      };

      this._animating = true;
      var trackStyle = getTrackAnimateCSS(_.assign({
        left: targetLeft,
        slideCount: this.getSlidesCount()
      }, this.props, this.state));
      this.setTrackStyle(trackStyle);

      this._currentSlide = currentSlide;
      __WEBPACK_IMPORTED_MODULE_8_react_lib_ReactTransitionEvents___default.a.addEndEventListener(this.track, callback);
    }
  }, {
    key: 'changeSlide',
    value: function changeSlide(_ref2) {
      var action = _ref2.action,
          slideIndex = _ref2.slideIndex;

      var slideOffset = void 0;
      var targetSlide = void 0;
      var slideCount = this.getSlidesCount();
      var currentSlide = this._currentSlide;
      var slidesToScroll = this.props.slidesToScroll;
      var unevenOffset = slideCount % slidesToScroll !== 0;
      var indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;

      if (action === 'previous') {
        slideOffset = indexOffset === 0 ? slidesToScroll : this.props.slidesToShow - indexOffset;
        targetSlide = currentSlide - slideOffset;
      } else if (action === 'next') {
        slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
        targetSlide = currentSlide + slideOffset;
      } else if (action === 'index') {
        targetSlide = slideIndex;
        if (targetSlide === currentSlide) {
          return;
        }
      }

      this.slideHandler(targetSlide);
    }
  }, {
    key: 'handlePrevButtonClick',
    value: function handlePrevButtonClick() {
      this.changeSlide({ action: 'previous' });
    }
  }, {
    key: 'handleNextButtonClick',
    value: function handleNextButtonClick() {
      this.changeSlide({ action: 'next' });
    }
  }, {
    key: 'renderChildren',
    value: function renderChildren() {
      var slideWidth = this.state.slideWidth;
      var _props3 = this.props,
          getHeight = _props3.getHeight,
          children = _props3.children;


      if (!slideWidth) {
        return null;
      }

      return React.Children.map(children, function (elem) {
        return React.cloneElement(elem, {
          width: slideWidth,
          height: getHeight(elem, slideWidth)
        });
      });
    }
  }, {
    key: 'getTrackRef',
    value: function getTrackRef(node) {
      this.track = node;
    }
  }, {
    key: 'setWrapper',
    value: function setWrapper(node) {
      this.wrapper = node;
      this.update();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var trackProps = {
        cssEase: this.props.cssEase,
        speed: this.props.speed,
        currentSlide: this._currentSlide,
        slideWidth: this.state.slideWidth,
        slidesToShow: this.props.slidesToShow,
        slideCount: this.getSlidesCount(),
        trackStyle: this.state.trackStyle
      };

      var _props4 = this.props,
          className = _props4.className,
          trackClassName = _props4.trackClassName;


      return React.createElement(
        'div',
        { ref: this.setWrapper,
          styleName: 'container',
          className: className },
        React.createElement(
          'div',
          { ref: function ref(node) {
              return _this4.list = node;
            },
            className: 'slick-list',
            onMouseDown: this.swipeStart,
            onMouseMove: this.swipeMove,
            onMouseUp: this.swipeEnd,
            onMouseLeave: this.swipeEnd,
            onTouchStart: this.swipeStart,
            onTouchMove: this.swipeMove,
            onTouchEnd: this.swipeEnd,
            onTouchCancel: this.swipeEnd },
          React.createElement(
            __WEBPACK_IMPORTED_MODULE_12__track__["a" /* default */],
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ getRef: this.getTrackRef,
              className: trackClassName
            }, trackProps),
            this.renderChildren()
          )
        ),
        this.buttons
      );
    }
  }, {
    key: 'buttons',
    get: function get() {
      var _props5 = this.props,
          showButtons = _props5.showButtons,
          slidesToShow = _props5.slidesToShow;

      var currentSlide = this._currentSlide;

      if (!showButtons) {
        return null;
      }

      var slidesCount = this.getSlidesCount();

      return [React.createElement(__WEBPACK_IMPORTED_MODULE_11__buttons__["a" /* default */], { key: 'prev',
        direction: 'left',
        onClick: this.handlePrevButtonClick,
        isActive: currentSlide > 0 }), React.createElement(__WEBPACK_IMPORTED_MODULE_11__buttons__["a" /* default */], { key: 'next',
        direction: 'right',
        onClick: this.handleNextButtonClick,
        isActive: currentSlide < slidesCount - slidesToShow })];
    }
  }]);

  return MobileCarousel;
}(React.Component), _class3.propTypes = {
  totalCount: React.PropTypes.number,
  slidesToShow: React.PropTypes.number,
  afterChange: React.PropTypes.func,
  children: React.PropTypes.any,
  className: React.PropTypes.string,
  touchThreshold: React.PropTypes.number,
  slidesToScroll: React.PropTypes.number,
  initialSlide: React.PropTypes.number,
  slidesPreviewWidth: React.PropTypes.number,
  cssEase: React.PropTypes.string,
  edgeFriction: React.PropTypes.number,
  speed: React.PropTypes.number,
  getHeight: React.PropTypes.func,
  beforeChange: React.PropTypes.func,
  waitForAnimate: React.PropTypes.bool,
  showButtons: React.PropTypes.bool,
  trackClassName: React.PropTypes.string,
  onUserStartedTracking: React.PropTypes.func
}, _class3.defaultProps = {
  className: '',
  cssEase: 'ease',
  easing: 'linear',
  edgeFriction: 0.35,
  initialSlide: 0,
  slidesToScroll: 1,
  speed: 500,
  getHeight: _.constant(200),
  slidesToShow: 3,
  touchThreshold: 5,
  useCSS: true,
  waitForAnimate: true,
  afterChange: _.noop,
  beforeChange: _.noop,
  onUserStartedTracking: _.noop,
  slidesPreviewWidth: 0,
  showButtons: true
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'update', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'update'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'swipeStart', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'swipeStart'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'getSlidesCount', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'getSlidesCount'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'swipeMove', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'swipeMove'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'swipeEnd', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'swipeEnd'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handlePrevButtonClick', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handlePrevButtonClick'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleNextButtonClick', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handleNextButtonClick'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'renderChildren', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'renderChildren'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'getTrackRef', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'getTrackRef'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setWrapper', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'setWrapper'), _class2.prototype)), _class2)) || _class);


/***/ }),
/* 2504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getSlideWidth;
/* harmony export (immutable) */ __webpack_exports__["a"] = getWidth;
/* harmony export (immutable) */ __webpack_exports__["c"] = getTrackLeft;
function getSlideWidth(carouselElem, slidesToShow) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$slidesPreviewWid = _ref.slidesPreviewWidth,
      slidesPreviewWidth = _ref$slidesPreviewWid === undefined ? 0 : _ref$slidesPreviewWid;

  return (getWidth(carouselElem) - 2 * slidesPreviewWidth) / slidesToShow;
}

function getWidth(elem) {
  return elem ? elem.getBoundingClientRect().width || elem.offsetWidth : 0;
}

function getTrackLeft(slidesCount, slidesPerPage, slideIndex, slideWidth, slidesPreviewWidth) {
  if (slideIndex === 0) {
    return 0;
  }

  if (slideIndex >= slidesCount - slidesPerPage) {
    return slideIndex * slideWidth * -1 + 2 * slidesPreviewWidth;
  }

  return slideIndex * slideWidth * -1 + slidesPreviewWidth;
}

/***/ }),
/* 2505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Track; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__track_styl__ = __webpack_require__(3262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__track_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__track_styl__);






var _dec, _class, _class2, _temp;





var getSlideClasses = function getSlideClasses(spec) {

  var index = void 0;
  if (spec.rtl) {
    index = spec.slideCount - 1 - spec.index;
  } else {
    index = spec.index;
  }

  var centerOffset = void 0;
  var slickActive = void 0;
  var slickCenter = void 0;
  var slickCloned = index < 0 || index >= spec.slideCount;
  if (spec.centerMode) {
    centerOffset = Math.floor(spec.slidesToShow / 2);
    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
      slickActive = true;
    }
  } else {
    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
  }
  return __WEBPACK_IMPORTED_MODULE_6_classnames___default()({
    'slick-slide': true,
    'slick-active': slickActive,
    'slick-center': slickCenter,
    'slick-cloned': slickCloned
  });
};

var getSlideStyle = function getSlideStyle(spec) {
  var style = {
    width: spec.slideWidth,
    flexShrink: 0
  };

  return style;
};

var getKey = function getKey(child, fallbackKey) {
  return (
    // key could be a zero
    child.key === null || _.isUndefined(child.key) ? fallbackKey : child.key
  );
};

var renderSlides = function renderSlides(spec) {
  var slides = [];
  var preCloneSlides = [];
  var postCloneSlides = [];

  React.Children.forEach(spec.children, function (child, index) {
    var childStyle = getSlideStyle(_.assign({}, spec, { index: index }));
    var slickClasses = getSlideClasses(_.assign({ index: index }, spec));

    var cssClasses = void 0;
    if (child.props.className) {
      cssClasses = __WEBPACK_IMPORTED_MODULE_6_classnames___default()(slickClasses, child.props.className);
    } else {
      cssClasses = slickClasses;
    }

    slides.push(React.cloneElement(child, {
      key: 'original' + getKey(child, index),
      'data-index': index,
      className: cssClasses,
      style: _.assign({}, child.props.style || {}, childStyle)
    }));
  });

  return preCloneSlides.concat(slides, postCloneSlides);
};

var Track = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_7__track_styl___default.a), _dec(_class = (_temp = _class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Track, _React$Component);

  function Track() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Track);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Track.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Track)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Track, [{
    key: 'render',
    value: function render() {
      var slides = renderSlides(this.props);
      var _props = this.props,
          trackStyle = _props.trackStyle,
          getRef = _props.getRef,
          className = _props.className;


      return React.createElement(
        'div',
        { ref: getRef,
          styleName: 'slick-track',
          className: className,
          style: trackStyle },
        slides
      );
    }
  }]);

  return Track;
}(React.Component), _class2.propTypes = {
  trackStyle: React.PropTypes.object,
  getRef: React.PropTypes.func,
  className: React.PropTypes.string
}, _class2.defaultProps = {
  getRef: _.noop
}, _temp)) || _class);


/***/ }),
/* 2506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return visibleInViewPort; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_utils_wix_sdk__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_debounce__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_widget_utils_widget__ = __webpack_require__(2529);








function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}






var visibleInViewPort = function visibleInViewPort(WrappedComponent) {
  var _dec, _desc, _value, _class;

  var VisibleInViewPort = (_dec = __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_debounce___default()(400), (_class = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(VisibleInViewPort, _React$Component);

    function VisibleInViewPort() {
      var _ref;

      var _temp, _this, _ret;

      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, VisibleInViewPort);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = VisibleInViewPort.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(VisibleInViewPort)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        isVisible: false
      }, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(VisibleInViewPort, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        this.check();
        __WEBPACK_IMPORTED_MODULE_7_shared_utils_wix_sdk__["a" /* default */].addEventListener(__WEBPACK_IMPORTED_MODULE_7_shared_utils_wix_sdk__["a" /* default */].Events.SCROLL, this.check);
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        __WEBPACK_IMPORTED_MODULE_7_shared_utils_wix_sdk__["a" /* default */].removeEventListener(__WEBPACK_IMPORTED_MODULE_7_shared_utils_wix_sdk__["a" /* default */].Events.SCROLL, this.check);
      }
    }, {
      key: 'check',
      value: function check() {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_widget_utils_widget__["a" /* isMobileWidgetVisibleInViewPort */])().then(this.updateVisibility);
      }
    }, {
      key: 'updateVisibility',
      value: function updateVisibility(newIsVisible) {
        if (newIsVisible !== this.state.isVisible) {
          this.setState({
            isVisible: newIsVisible
          });
        }
      }
    }, {
      key: 'render',
      value: function render() {
        return React.createElement(WrappedComponent, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.props, {
          isVisibleInViewport: this.state.isVisible }));
      }
    }]);

    return VisibleInViewPort;
  }(React.Component), (_applyDecoratedDescriptor(_class.prototype, 'check', [__WEBPACK_IMPORTED_MODULE_9_core_decorators_lib_autobind___default.a, _dec], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'check'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateVisibility', [__WEBPACK_IMPORTED_MODULE_9_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'updateVisibility'), _class.prototype)), _class));


  VisibleInViewPort.WixWrappedComponent = WrappedComponent;

  return VisibleInViewPort;
};

/***/ }),
/* 2507 */,
/* 2508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getPlayerCoverUrl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_widget_utils_overlay_buttons_utils__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_selectors_channels__ = __webpack_require__(71);




var getVideo = function getVideo(state, props) {
  return props.videoItem;
};
var getShowChannelCover = function getShowChannelCover(state, props) {
  return props.showChannelCover;
};
var getSettings = function getSettings(state) {
  return state.appSettings;
};

var getPlayerCoverUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getSettings, __WEBPACK_IMPORTED_MODULE_2_shared_selectors_channels__["a" /* getChannelForWidget */], getVideo, getShowChannelCover], function (settings, channel, video, showChannelCover) {
  var customCoverUrl = video.customCoverUrl,
      coverUrl = video.coverUrl;


  var url = customCoverUrl || coverUrl;

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_widget_utils_overlay_buttons_utils__["a" /* shouldShowChannelCover */])(settings, showChannelCover)) {
    url = channel.customCoverUrl || channel.coverUrl || url;
  }

  return url;
});

/***/ }),
/* 2509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PlayerCover; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_components_resized_image_resized_image__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__player_cover_selector__ = __webpack_require__(2508);






var _dec, _class, _class2, _temp;





var PlayerCover = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["a" /* connect */])(function (state, props) {
  return {
    coverUrl: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__player_cover_selector__["a" /* getPlayerCoverUrl */])(state, props)
  };
}), _dec(_class = (_temp = _class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(PlayerCover, _React$Component);

  function PlayerCover() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, PlayerCover);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PlayerCover.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(PlayerCover)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(PlayerCover, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          coverUrl = _props.coverUrl,
          children = _props.children,
          coverWidth = _props.coverWidth,
          coverHeight = _props.coverHeight;


      if (!coverUrl) {
        return null;
      }

      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_6_shared_components_resized_image_resized_image__["a" /* default */],
        { className: className,
          src: coverUrl,
          width: coverWidth,
          height: coverHeight },
        children
      );
    }
  }]);

  return PlayerCover;
}(React.Component), _class2.propTypes = {
  coverUrl: React.PropTypes.string,
  coverWidth: React.PropTypes.number,
  coverHeight: React.PropTypes.number,
  className: React.PropTypes.string,
  children: React.PropTypes.any,
  showChannelCover: React.PropTypes.bool
}, _temp)) || _class);

/***/ }),
/* 2510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OverlayClassicCenter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_selectors_app_settings__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__bi_subscribe_shown_bi_overlay__ = __webpack_require__(1581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_widget_components_button_button__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_components_icon_icon__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__classic_styl__ = __webpack_require__(3266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__classic_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__classic_styl__);






var _dec, _dec2, _class, _class2, _temp;













var OverlayClassicCenter = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["a" /* connect */])(function (state) {
  return {
    canShowMainItemTitle: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_shared_selectors_app_settings__["c" /* canShowMainItemTitle */])(state),
    canShowMainItemPublisher: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_shared_selectors_app_settings__["d" /* canShowMainItemPublisher */])(state)
  };
}), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_shared_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_11__classic_styl___default.a), _dec(_class = _dec2(_class = (_temp = _class2 = function (_SubscribeShownBIOver) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(OverlayClassicCenter, _SubscribeShownBIOver);

  function OverlayClassicCenter() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, OverlayClassicCenter);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (OverlayClassicCenter.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(OverlayClassicCenter)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(OverlayClassicCenter, [{
    key: 'render',
    value: function render() {
      var className = this.props.className;


      var styles = this.getOpacityStyles();

      return React.createElement(
        'div',
        { style: styles,
          styleName: 'overlay',
          className: 'qa-player-overlay ' + className,
          'data-hook': 'playerOverlay',
          onClick: this.playSelectedVideo },
        this.title,
        this.publisher,
        this.buttons
      );
    }
  }, {
    key: 'playButton',
    get: function get() {
      var playButtonText = this.playButtonText;

      if (!playButtonText) {
        return null;
      }

      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_9_widget_components_button_button__["a" /* default */],
        { className: 'qa-widget-overlay-play-button',
          styleName: 'button',
          onClick: this.playSelectedVideo },
        React.createElement(__WEBPACK_IMPORTED_MODULE_10_shared_components_icon_icon__["a" /* default */], { styleName: 'play-icon',
          name: 'arrow-right-filled' }),
        React.createElement(
          'span',
          null,
          playButtonText
        )
      );
    }
  }, {
    key: 'playNextButton',
    get: function get() {
      var playNextButtonText = this.playNextButtonText;

      if (!playNextButtonText) {
        return null;
      }

      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_9_widget_components_button_button__["a" /* default */],
        { styleName: 'button',
          onClick: this.playNextVideo },
        playNextButtonText,
        React.createElement(__WEBPACK_IMPORTED_MODULE_10_shared_components_icon_icon__["a" /* default */], { styleName: 'next-icon',
          name: 'arrow-right' })
      );
    }
  }, {
    key: 'subscribeButton',
    get: function get() {
      var subscribeButtonText = this.subscribeButtonText;

      if (!subscribeButtonText) {
        return null;
      }

      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_9_widget_components_button_button__["a" /* default */],
        { styleName: 'button',
          className: 'qa-widget-overlay-subscribe-button',
          onClick: this.openSubscription },
        subscribeButtonText
      );
    }
  }, {
    key: 'purchaseButton',
    get: function get() {
      var purchaseButtonText = this.purchaseButtonText;

      if (!purchaseButtonText) {
        return null;
      }

      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_9_widget_components_button_button__["a" /* default */],
        { className: 'qa-widget-overlay-buy-from-button',
          styleName: 'button',
          onClick: this.openPurchase },
        purchaseButtonText
      );
    }
  }, {
    key: 'buttons',
    get: function get() {
      if (!this.props.videoItem) {
        return null;
      }

      return React.createElement(
        'div',
        { styleName: 'buttons' },
        this.playButton,
        this.subscribeButton || this.purchaseButton,
        this.playNextButton
      );
    }
  }]);

  return OverlayClassicCenter;
}(__WEBPACK_IMPORTED_MODULE_8__bi_subscribe_shown_bi_overlay__["a" /* default */]), _class2.displayName = 'OverlayClassicCenter', _temp)) || _class) || _class);


/***/ }),
/* 2511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OverlayMemberOnly; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_selectors_app_settings__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_widget_components_player_overlay_base_member_only_overlay__ = __webpack_require__(1730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__member_only_styl__ = __webpack_require__(3267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__member_only_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__member_only_styl__);





var _dec, _dec2, _class, _class2, _temp;











var OverlayMemberOnly = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["a" /* connect */])(function (state) {
  return {
    canShowMainItemTitle: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_shared_selectors_app_settings__["c" /* canShowMainItemTitle */])(state),
    canShowMainItemPublisher: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_shared_selectors_app_settings__["d" /* canShowMainItemPublisher */])(state)
  };
}), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_shared_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_8__member_only_styl___default.a), _dec(_class = _dec2(_class = (_temp = _class2 = function (_OverlayMemberOnlyBas) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(OverlayMemberOnly, _OverlayMemberOnlyBas);

  function OverlayMemberOnly() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, OverlayMemberOnly);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (OverlayMemberOnly.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(OverlayMemberOnly)).apply(this, arguments));
  }

  return OverlayMemberOnly;
}(__WEBPACK_IMPORTED_MODULE_7_widget_components_player_overlay_base_member_only_overlay__["a" /* default */]), _class2.displayName = 'OverlayMemberOnly', _temp)) || _class) || _class);


/***/ }),
/* 2512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BottomButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SubscribeBottomButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__bottom_buttons_styl__ = __webpack_require__(3269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__bottom_buttons_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__bottom_buttons_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__translations__ = __webpack_require__(2009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_components_button_button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_components_element_switcher_element_switcher__ = __webpack_require__(1976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_components_icon_icon__ = __webpack_require__(46);







var _class, _temp;










var BottomButton = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_8__bottom_buttons_styl___default.a)(function (props) {
  return React.createElement(__WEBPACK_IMPORTED_MODULE_10_shared_components_button_button__["f" /* GenericButton */], __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, _.omit(props, 'dataHook'), {
    styleName: 'bottom-button' }));
});

var SubscribeBottomButton = (_temp = _class = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(SubscribeBottomButton, _React$Component);

  function SubscribeBottomButton() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SubscribeBottomButton);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SubscribeBottomButton.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(SubscribeBottomButton)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(SubscribeBottomButton, [{
    key: 'render',
    value: function render() {
      var buttonProps = _.omit(this.props, 'maxWidth', 'dispatch', 'forceShortText');

      return React.createElement(
        BottomButton,
        buttonProps,
        this.content
      );
    }
  }, {
    key: 'icon',
    get: function get() {
      return React.createElement(__WEBPACK_IMPORTED_MODULE_12_shared_components_icon_icon__["a" /* default */], { name: 'paid',
        className: __WEBPACK_IMPORTED_MODULE_8__bottom_buttons_styl___default.a['paid-icon'] });
    }
  }, {
    key: 'shortLabel',
    get: function get() {
      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_11_shared_components_element_switcher_element_switcher__["a" /* default */],
        { maxWidth: this.props.maxWidth },
        React.createElement(
          'span',
          null,
          this.icon,
          React.createElement(__WEBPACK_IMPORTED_MODULE_7_react_intl__["a" /* FormattedMessage */], __WEBPACK_IMPORTED_MODULE_9__translations__["a" /* default */].subscribeShortText)
        ),
        this.icon
      );
    }
  }, {
    key: 'content',
    get: function get() {
      var _props = this.props,
          maxWidth = _props.maxWidth,
          children = _props.children,
          forceShortText = _props.forceShortText;

      if (forceShortText) {
        return this.shortLabel;
      }

      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_11_shared_components_element_switcher_element_switcher__["a" /* default */],
        { maxWidth: maxWidth },
        children,
        this.shortLabel
      );
    }
  }]);

  return SubscribeBottomButton;
}(React.Component), _class.propTypes = {
  maxWidth: React.PropTypes.number,
  forceShortText: React.PropTypes.bool,
  children: React.PropTypes.any
}, _temp);

/***/ }),
/* 2513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PlayButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PurchaseButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__middle_buttons_styl__ = __webpack_require__(3270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__middle_buttons_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__middle_buttons_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_components_button_button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_components_icon_icon__ = __webpack_require__(46);






var PlayButton = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_1__middle_buttons_styl___default.a)(function (_ref) {
  var onClick = _ref.onClick,
      children = _ref.children;
  return React.createElement(
    __WEBPACK_IMPORTED_MODULE_2_shared_components_button_button__["f" /* GenericButton */],
    { renderAsLink: true,
      styleName: 'play',
      onClick: onClick,
      className: 'qa-widget-overlay-play-button' },
    React.createElement(__WEBPACK_IMPORTED_MODULE_3_shared_components_icon_icon__["b" /* RoundedIcon */], { styleName: 'icon play-icon',
      name: 'arrow-right-filled' }),
    React.createElement(
      'span',
      { styleName: 'text' },
      children
    )
  );
});

var PurchaseButton = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_1__middle_buttons_styl___default.a)(function (_ref2) {
  var onClick = _ref2.onClick,
      children = _ref2.children;
  return React.createElement(
    __WEBPACK_IMPORTED_MODULE_2_shared_components_button_button__["f" /* GenericButton */],
    { renderAsLink: true,
      styleName: 'purchase',
      onClick: onClick,
      className: 'qa-widget-overlay-play-button' },
    React.createElement(
      'span',
      { styleName: 'text' },
      children
    )
  );
});

/***/ }),
/* 2514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ThreeRowsWidgetOverlay; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_widget_utils_video_list__ = __webpack_require__(1737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_utils_layout_helpers__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_widget_utils_overlay_buttons_utils__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_widget_redux_client_actions_mobile_overlay_openners_payment_pages_actions__ = __webpack_require__(2013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_widget_redux_client_actions_mobile_overlay_openners_main_openners__ = __webpack_require__(1736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_shared_selectors_channels__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_widget_selectors_current_site_user__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_shared_selectors_app_settings__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__bi_subscribe_shown_bi_overlay__ = __webpack_require__(1581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_shared_bi_send_bi_event__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__buttons_middle_buttons__ = __webpack_require__(2513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__buttons_bottom_buttons__ = __webpack_require__(2512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_widget_components_player_overlay_base_overlay__ = __webpack_require__(1203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_widget_components_overlay_texts_video_play_button_text__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_widget_components_overlay_texts_video_sign_in_to_watch_button_text__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_widget_components_overlay_texts_channel_play_button_text__ = __webpack_require__(1258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_widget_components_overlay_texts_channel_sign_in_to_watch_button_text__ = __webpack_require__(1544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_widget_components_overlay_texts_channel_open_video_without_preview_button_text__ = __webpack_require__(1543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_widget_components_overlay_texts_purchase_button_text__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_widget_components_overlay_texts_channel_subscribe_button_text__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_shared_components_clamp_text_clamp_text__ = __webpack_require__(1794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__three_rows_widget_styl__ = __webpack_require__(3271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__three_rows_widget_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__three_rows_widget_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__translations__ = __webpack_require__(2009);








var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}





































var WIDGET_PADDING = 30;
var MARGIN_BETWEEN_BOTTOM_BUTTONS = 20;
var BOTTOM_BUTTON_PADDING = 16;
var MAX_SINGLE_BUTTON_CONTENT_WIDTH = window.innerWidth - 2 * WIDGET_PADDING - 2 * BOTTOM_BUTTON_PADDING;
var MAX_TWO_BUTTONS_CONTENT_WIDTH = MAX_SINGLE_BUTTON_CONTENT_WIDTH - MARGIN_BETWEEN_BOTTOM_BUTTONS;

var ThreeRowsWidgetOverlay = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_redux__["a" /* connect */])(function (state) {
  var channelData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17_shared_selectors_channels__["a" /* getChannelForWidget */])(state);
  var appSettings = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19_shared_selectors_app_settings__["a" /* getAllSettings */])(state);
  var isVideoListHiddenInStrip = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19_shared_selectors_app_settings__["t" /* isStripLayout */])(state) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_widget_utils_video_list__["a" /* isNeverShow */])(state.appSettings.numbers.videoListVisibility);
  var isVideoListHiddenInCompact = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19_shared_selectors_app_settings__["r" /* isCompactLayout */])(state) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19_shared_selectors_app_settings__["u" /* canShowVideoList */])(state);

  return {
    channelData: channelData,
    appSettings: appSettings,
    isChannelCover: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_widget_utils_overlay_buttons_utils__["h" /* mainItemIsChannelCover */])(appSettings),
    isSignInVisible: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_shared_utils_layout_helpers__["e" /* isSignInVisible */])(appSettings),
    isVideoListHidden: isVideoListHiddenInStrip || isVideoListHiddenInCompact,
    canShowMainItemTitle: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19_shared_selectors_app_settings__["c" /* canShowMainItemTitle */])(state),
    isSingleVideoAtChannel: channelData.videosCount === 1,
    currentSiteUser: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18_widget_selectors_current_site_user__["a" /* getCurrentSiteUser */])(state),
    isRounded: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19_shared_selectors_app_settings__["b" /* areElementsRounded */])(state)
  };
}, {
  onVisitChannelClick: __WEBPACK_IMPORTED_MODULE_16_widget_redux_client_actions_mobile_overlay_openners_main_openners__["b" /* visitChannel */],
  onSubscribeClick: __WEBPACK_IMPORTED_MODULE_15_widget_redux_client_actions_mobile_overlay_openners_payment_pages_actions__["b" /* openSubscribeOverlay */]
}), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_shared_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_33__three_rows_widget_styl___default.a), _dec3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_shared_bi_send_bi_event__["a" /* withBiEvent */])('widget.exploreThisChannel.clicked'), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_SubscribeShownBIOver) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(ThreeRowsWidgetOverlay, _SubscribeShownBIOver);

  function ThreeRowsWidgetOverlay() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ThreeRowsWidgetOverlay);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ThreeRowsWidgetOverlay.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(ThreeRowsWidgetOverlay)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(ThreeRowsWidgetOverlay, [{
    key: 'handleVisitChannelClick',
    value: function handleVisitChannelClick() {
      this.props.onVisitChannelClick();
    }
  }, {
    key: 'renderSubscribeButton',
    value: function renderSubscribeButton() {
      var hasButtonBeside = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var text = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31_widget_components_overlay_texts_channel_subscribe_button_text__["b" /* default */])(this.buttonTextProps);

      if (!text) {
        return null;
      }

      var styleName = __WEBPACK_IMPORTED_MODULE_9_classnames___default()('bottom-button');
      var maxWidth = hasButtonBeside ? MAX_TWO_BUTTONS_CONTENT_WIDTH : MAX_SINGLE_BUTTON_CONTENT_WIDTH;

      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_23__buttons_bottom_buttons__["a" /* SubscribeBottomButton */],
        { styleName: styleName,
          key: 'subscribe-button',
          forceShortText: hasButtonBeside,
          maxWidth: maxWidth,
          onClick: this.props.onSubscribeClick },
        text
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var className = this.props.className;


      return React.createElement(
        'div',
        { styleName: 'overlay',
          className: className },
        React.createElement(
          'div',
          { styleName: 'main' },
          React.createElement(
            'div',
            { styleName: 'title' },
            this.title
          ),
          React.createElement(
            'div',
            { styleName: 'play-container' },
            this.playButton || this.signInToWatchButton || this.openVideoButton || this.purchaseButton
          )
        ),
        this.bottomButtonsBlock
      );
    }
  }, {
    key: 'canOpenChannelPage',
    get: function get() {
      var isSingleVideoAtChannel = this.props.isSingleVideoAtChannel;


      return this.isChannelCoverView && !isSingleVideoAtChannel;
    }
  }, {
    key: 'title',
    get: function get() {
      var _props = this.props,
          onOpenVideoClick = _props.onOpenVideoClick,
          onVisitChannelClick = _props.onVisitChannelClick,
          canShowMainItemTitle = _props.canShowMainItemTitle;


      if (!canShowMainItemTitle) {
        return null;
      }

      var titleText = this.titleText;

      if (!titleText) {
        return null;
      }

      return React.createElement(
        'span',
        { onClick: this.canOpenChannelPage ? onVisitChannelClick : onOpenVideoClick,
          styleName: 'title-text' },
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_32_shared_components_clamp_text_clamp_text__["a" /* default */],
          { lineClamp: 2 },
          titleText
        )
      );
    }
  }, {
    key: 'playButton',
    get: function get() {
      var text = this.isChannelCoverView ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27_widget_components_overlay_texts_channel_play_button_text__["a" /* default */])(this.buttonTextProps) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25_widget_components_overlay_texts_video_play_button_text__["a" /* default */])(this.buttonTextProps);

      if (!text) {
        return null;
      }

      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_22__buttons_middle_buttons__["a" /* PlayButton */],
        { onClick: this.props.onPlayClick },
        text
      );
    }
  }, {
    key: 'signInToWatchButton',
    get: function get() {
      var text = this.isChannelCoverView ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28_widget_components_overlay_texts_channel_sign_in_to_watch_button_text__["a" /* default */])(this.buttonTextProps) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_widget_components_overlay_texts_video_sign_in_to_watch_button_text__["a" /* default */])(this.buttonTextProps);

      if (!text) {
        return null;
      }

      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_22__buttons_middle_buttons__["a" /* PlayButton */],
        { onClick: this.props.onPlayClick },
        text
      );
    }
  }, {
    key: 'openVideoButton',
    get: function get() {
      if (!this.isChannelCoverView) {
        return null;
      }

      var text = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29_widget_components_overlay_texts_channel_open_video_without_preview_button_text__["a" /* default */])(this.buttonTextProps);

      if (!text) {
        return null;
      }

      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_22__buttons_middle_buttons__["a" /* PlayButton */],
        { onClick: this.props.onOpenVideoClick },
        text
      );
    }
  }, {
    key: 'purchaseButton',
    get: function get() {
      var text = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30_widget_components_overlay_texts_purchase_button_text__["a" /* default */])(this.buttonTextProps);

      if (!text) {
        return null;
      }

      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_22__buttons_middle_buttons__["b" /* PurchaseButton */],
        { onClick: this.props.onBuyVideoClick },
        text
      );
    }
  }, {
    key: 'signInButton',
    get: function get() {
      var _props2 = this.props,
          isSignInVisible = _props2.isSignInVisible,
          currentSiteUser = _props2.currentSiteUser,
          onSignInRequested = _props2.onSignInRequested;


      if (!isSignInVisible || currentSiteUser) {
        return null;
      }

      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_23__buttons_bottom_buttons__["b" /* BottomButton */],
        { styleName: 'bottom-button',
          dataHook: 'mobileSignInButton',
          key: 'sign-in-button',
          onClick: onSignInRequested },
        React.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["a" /* FormattedMessage */], __WEBPACK_IMPORTED_MODULE_34__translations__["a" /* default */].signIn)
      );
    }
  }, {
    key: 'visitChannelButton',
    get: function get() {
      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_23__buttons_bottom_buttons__["b" /* BottomButton */],
        { styleName: 'bottom-button',
          key: 'visit-channel-button',
          onClick: this.handleVisitChannelClick },
        React.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["a" /* FormattedMessage */], __WEBPACK_IMPORTED_MODULE_34__translations__["a" /* default */].viewChannel)
      );
    }
  }, {
    key: 'bottomButtons',
    get: function get() {
      var _isChannelSubscribeButtonVisible = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31_widget_components_overlay_texts_channel_subscribe_button_text__["a" /* isVisible */])(this.buttonTextProps);
      var _props3 = this.props,
          isVideoListHidden = _props3.isVideoListHidden,
          isSingleVideoAtChannel = _props3.isSingleVideoAtChannel;


      if (isVideoListHidden || isSingleVideoAtChannel) {
        var signInButton = this.signInButton;

        if (!signInButton && !_isChannelSubscribeButtonVisible) {
          return [];
        }

        return _.compact([signInButton, this.renderSubscribeButton(Boolean(signInButton))]);
      }

      var visitChannelButton = this.visitChannelButton;

      if (!visitChannelButton && !_isChannelSubscribeButtonVisible) {
        return [];
      }

      return _.compact([visitChannelButton, this.renderSubscribeButton(Boolean(visitChannelButton))]);
    }
  }, {
    key: 'bottomButtonsBlock',
    get: function get() {
      var bottomButtons = this.bottomButtons;

      if (_.isEmpty(bottomButtons)) {
        return null;
      }

      var isRounded = this.props.isRounded;


      var styleNames = __WEBPACK_IMPORTED_MODULE_9_classnames___default()('buttons', {
        single: bottomButtons.length === 1,
        rounded: isRounded
      });

      return React.createElement(
        'div',
        { styleName: styleNames },
        bottomButtons
      );
    }
  }]);

  return ThreeRowsWidgetOverlay;
}(__WEBPACK_IMPORTED_MODULE_20__bi_subscribe_shown_bi_overlay__["a" /* default */]), _class3.displayName = 'ThreeRowsWidgetOverlay', _class3.propTypes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_24_widget_components_player_overlay_base_overlay__["a" /* default */].propTypes, {
  onSubscribeClick: React.PropTypes.func,
  onVisitChannelClick: React.PropTypes.func,
  onBuyVideoClick: React.PropTypes.func,
  onPlayClick: React.PropTypes.func,
  onOpenVideoClick: React.PropTypes.func,
  onSignInRequested: React.PropTypes.func.isRequired,
  bottomButtons: React.PropTypes.array,
  middleButton: React.PropTypes.object,

  isChannelCover: React.PropTypes.bool,
  isSignInVisible: React.PropTypes.bool,
  isVideoListHidden: React.PropTypes.bool,
  canShowMainItemTitle: React.PropTypes.bool,
  isSingleVideoAtChannel: React.PropTypes.bool,
  isRounded: React.PropTypes.bool
}), _class3.defaultProps = {
  onSubscribeClick: _.noop,
  onVisitChannelClick: _.noop
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'handleVisitChannelClick', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a, _dec3], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handleVisitChannelClick'), _class2.prototype)), _class2)) || _class) || _class);


/***/ }),
/* 2515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FullScreenModalPlayer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_widget_selectors_current_site_user__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__desktop_player__ = __webpack_require__(1583);







var _dec, _class, _class2, _temp;







var FullScreenModalPlayer = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["a" /* connect */])(function (state) {
  return {
    currentSiteUser: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_widget_selectors_current_site_user__["a" /* getCurrentSiteUser */])(state)
  };
}), _dec(_class = (_temp = _class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(FullScreenModalPlayer, _React$Component);

  function FullScreenModalPlayer() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, FullScreenModalPlayer);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (FullScreenModalPlayer.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(FullScreenModalPlayer)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(FullScreenModalPlayer, [{
    key: 'render',
    value: function render() {
      var props = _.omit(this.props, 'mobileMode', // can't do this
      'playAtFullScreen', // can't do this
      'showInitialOverlay', // can't do this
      'showControls', // can't do this
      'showPoster', // can't do this
      'currentTime', // can't do this
      'paused', // can't do this
      'muted' // can't do this
      );

      // For now there is no sense in DesktopPlayer but probably will be needed when implementing video background
      return React.createElement(__WEBPACK_IMPORTED_MODULE_8__desktop_player__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        playAtFullScreen: false,
        showInitialOverlay: true,
        showControls: true,
        showPoster: true,
        paused: true }));
    }
  }]);

  return FullScreenModalPlayer;
}(React.Component), _class2.propTypes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _.omit(__WEBPACK_IMPORTED_MODULE_8__desktop_player__["a" /* default */].propTypes, ['playAtFullScreen', 'showInitialOverlay', 'showControls', 'showPoster', 'paused', 'muted', 'currentTime', 'onFullScreenChanged']), {
  currentSiteUser: React.PropTypes.object
}), _temp)) || _class);


/***/ }),
/* 2516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_widget_components_players_mobile_player__ = __webpack_require__(1260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_widget_redux_client_actions_mobile_overlay_openners_main_openners__ = __webpack_require__(1736);








function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}






var withOpenVideoPageWhenEnds = function withOpenVideoPageWhenEnds(WrappedPlayer) {
  var _dec, _class, _desc, _value, _class2, _class3, _temp;

  var WithOpenVideoPage = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_redux__["a" /* connect */])(null, function (dispatch, _ref) {
    var videoItem = _ref.videoItem;
    return {
      openVideoPage: function openVideoPage() {
        return dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_widget_redux_client_actions_mobile_overlay_openners_main_openners__["a" /* openVideoPage */])(videoItem.id));
      }
    };
  }), _dec(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(WithOpenVideoPage, _React$Component);

    function WithOpenVideoPage() {
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, WithOpenVideoPage);

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (WithOpenVideoPage.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(WithOpenVideoPage)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(WithOpenVideoPage, [{
      key: 'onPlayStart',
      value: function onPlayStart() {
        this.props.onPlayStart();
        this._needToOpenVideoPage = true;
      }
    }, {
      key: 'onResume',
      value: function onResume() {
        this.props.onResume();
        this._needToOpenVideoPage = true;
      }
    }, {
      key: 'onEnded',
      value: function onEnded() {
        if (!this._needToOpenVideoPage) {
          return;
        }

        var _props = this.props,
            onEnded = _props.onEnded,
            openVideoPage = _props.openVideoPage;

        this._needToOpenVideoPage = false;
        onEnded();
        openVideoPage();
      }
    }, {
      key: 'onFullScreenChanged',
      value: function onFullScreenChanged(isOpened) {
        if (isOpened || !this._needToOpenVideoPage) {
          return;
        }

        var _props2 = this.props,
            onFullScreenChanged = _props2.onFullScreenChanged,
            openVideoPage = _props2.openVideoPage;

        this._needToOpenVideoPage = false;
        onFullScreenChanged(isOpened);
        openVideoPage();
      }
    }, {
      key: 'render',
      value: function render() {
        return React.createElement(WrappedPlayer, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.props, {
          onPlayStart: this.onPlayStart,
          onResume: this.onResume,
          onEnded: this.onEnded,
          onFullScreenChanged: this.onFullScreenChanged }));
      }
    }]);

    return WithOpenVideoPage;
  }(React.Component), _class3.propTypes = WrappedPlayer.propTypes, _class3.defaultProps = {
    onPlayStart: _.noop,
    onEnded: _.noop,
    onResume: _.noop,
    onFullScreenChanged: _.noop
  }, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onPlayStart', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'onPlayStart'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onResume', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'onResume'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onEnded', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'onEnded'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onFullScreenChanged', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'onFullScreenChanged'), _class2.prototype)), _class2)) || _class);


  return WithOpenVideoPage;
};

var MainWidgetMobilePlayer = withOpenVideoPageWhenEnds(__WEBPACK_IMPORTED_MODULE_9_widget_components_players_mobile_player__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (MainWidgetMobilePlayer);

/***/ }),
/* 2517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* defineMessages */])({
  searchVideo: {
    id: 'widget.search-bar.search-video',
    defaultMessage: 'Search video...'
  }
}));

/***/ }),
/* 2518 */,
/* 2519 */,
/* 2520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SlidableListWithLazyLoad; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_debounce__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_widget_components_mobile_carousel_mobile_carousel__ = __webpack_require__(2503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_widget_components_first_time_track_animation_first_time_track_animation__ = __webpack_require__(2501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_selectors_videos__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_widget_selectors_current_site_user__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_ui_selectors_video_video_origin__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_widget_redux_client_actions_video_urls_fetch__ = __webpack_require__(715);







var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}













// TODO: separate lazy load logic. Separate fetching urls for next video.
/*
 This component is performance dependable. Please avoid @ui because it leads to extra render while swiping
 */
var SlidableListWithLazyLoad = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["a" /* connect */])(function (state) {
  return {
    videoIds: state.lazyVideoLists.mobileWidget.videoIds,
    videoByIds: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_shared_selectors_videos__["a" /* getVideosGroupedByIds */])(state),
    currentSiteUser: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_widget_selectors_current_site_user__["a" /* getCurrentSiteUser */])(state)
  };
}, {
  fetchVideoUrls: __WEBPACK_IMPORTED_MODULE_14_widget_redux_client_actions_video_urls_fetch__["a" /* default */]
}), _dec2 = __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_debounce___default()(50), _dec(_class = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_widget_components_first_time_track_animation_first_time_track_animation__["a" /* default */])(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(SlidableListWithLazyLoad, _React$Component);

  function SlidableListWithLazyLoad() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, SlidableListWithLazyLoad);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SlidableListWithLazyLoad.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(SlidableListWithLazyLoad)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(SlidableListWithLazyLoad, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.preloadUrls(nextProps.videoByIds);
    }
  }, {
    key: 'preloadUrls',
    value: function preloadUrls(videos) {
      var _this2 = this;

      _.forEach(videos, function (videoItem) {
        return _this2.fetchUrlsForVideo(videoItem);
      });
    }
  }, {
    key: 'fetchUrlsForVideo',
    value: function fetchUrlsForVideo(videoItem) {
      var _props = this.props,
          fetchVideoUrls = _props.fetchVideoUrls,
          currentSiteUser = _props.currentSiteUser;

      // TODO: Need to move this logic out of view
      // See the same in PlayerWrapper

      if (videoItem) {
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_shared_ui_selectors_video_video_origin__["b" /* isExternalVideo */])(videoItem)) {
          if (!videoItem.memberOnly || currentSiteUser) {
            fetchVideoUrls(videoItem);
          }
        }
      }
    }
  }, {
    key: 'afterChange',
    value: function afterChange(leftVisibleSlideIndex) {
      var _props2 = this.props,
          loadMore = _props2.loadMore,
          onCurrentSlideChanged = _props2.onCurrentSlideChanged;

      var slidesShown = leftVisibleSlideIndex + 3;

      loadMore(slidesShown);
      onCurrentSlideChanged(leftVisibleSlideIndex);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          className = _props3.className,
          itemHeight = _props3.itemHeight,
          trackClassName = _props3.trackClassName,
          onUserStartedTracking = _props3.onUserStartedTracking,
          children = _props3.children;


      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_9_widget_components_mobile_carousel_mobile_carousel__["a" /* default */],
        { afterChange: this.afterChange,
          getHeight: _.constant(itemHeight),
          showButtons: false,
          onUserStartedTracking: onUserStartedTracking,
          slidesToShow: 1,
          trackClassName: trackClassName,
          className: className,
          initialSlide: this.selectedIndex },
        children
      );
    }
  }, {
    key: 'selectedIndex',
    get: function get() {
      var _props4 = this.props,
          videoIds = _props4.videoIds,
          selectedVideoId = _props4.selectedVideoId;


      var selectedVideoIndex = _.indexOf(videoIds, selectedVideoId);
      return selectedVideoIndex < 0 ? 0 : selectedVideoIndex;
    }
  }]);

  return SlidableListWithLazyLoad;
}(React.Component), _class3.propTypes = {
  videoIds: React.PropTypes.array,
  videoByIds: React.PropTypes.object,
  onUserStartedTracking: React.PropTypes.func,
  className: React.PropTypes.string,
  trackClassName: React.PropTypes.string,
  currentSiteUser: React.PropTypes.object,

  loadMore: React.PropTypes.func,
  itemHeight: React.PropTypes.number,
  onCurrentSlideChanged: React.PropTypes.func,
  fetchVideoUrls: React.PropTypes.func,
  selectedVideoId: React.PropTypes.string,
  children: React.PropTypes.arrayOf(React.PropTypes.element)
}, _class3.defaultProps = {
  onCurrentSlideChanged: _.noop
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'afterChange', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a, _dec2], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'afterChange'), _class2.prototype)), _class2)) || _class) || _class);


/***/ }),
/* 2521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClickableThumbnail; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_text_overflow_clamp__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_text_overflow_clamp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_text_overflow_clamp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_utils_deal_info_helpers__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_default_settings__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_shared_selectors_app_settings__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_shared_components_icon_icon__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__simple__ = __webpack_require__(1731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__thumbnail_styl__ = __webpack_require__(3275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__thumbnail_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__thumbnail_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__translations__ = __webpack_require__(2522);








var _dec, _dec2, _class, _class2, _temp, _dec3, _class3, _desc, _value, _class4, _class5, _temp2;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}



















var _propTypes = {
  videoItem: React.PropTypes.object.isRequired,
  isSelected: React.PropTypes.bool,
  nowPlaying: React.PropTypes.bool,
  watched: React.PropTypes.bool,
  width: React.PropTypes.number,
  height: React.PropTypes.number,
  intl: __WEBPACK_IMPORTED_MODULE_9_react_intl__["e" /* intlShape */],
  className: React.PropTypes.string,
  isTitleVisible: React.PropTypes.bool,
  isPublisherVisible: React.PropTypes.bool,
  isPreviewHover: React.PropTypes.bool,
  isDescriptionVisibleOnHoverOnly: React.PropTypes.bool,
  isDescriptionOnVideo: React.PropTypes.bool
};

var _defaultProps = {
  current: false,
  watched: false,
  width: 160,
  height: 104
};

var Thumbnail = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react_redux__["a" /* connect */])(function (state) {
  return {
    isTitleVisible: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_shared_selectors_app_settings__["F" /* canShowVideoListItemTitle */])(state),
    isPublisherVisible: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_shared_selectors_app_settings__["l" /* canShowVideoListItemPublisher */])(state),
    isPreviewHover: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_shared_selectors_app_settings__["y" /* isPreviewHover */])(state),
    isDescriptionVisibleOnHoverOnly: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_shared_selectors_app_settings__["G" /* isVideosListInfoShownOnHover */])(state),
    isDescriptionOnVideo: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_shared_selectors_app_settings__["H" /* getVideoInfoPosition */])(state) === __WEBPACK_IMPORTED_MODULE_13_default_settings__["b" /* infoPositionValues */].ON_VIDEOS
  };
}), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_shared_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_18__thumbnail_styl___default.a), _dec(_class = _dec2(_class = (_temp = _class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Thumbnail, _React$Component);

  function Thumbnail() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Thumbnail);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Thumbnail.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Thumbnail)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Thumbnail, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.clamp();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.clamp();
    }
  }, {
    key: 'clamp',
    value: function clamp() {
      // description bellow thumbnail with dynamic height is not supported by classic size calculation
      if (this.props.isDescriptionOnVideo) {
        __WEBPACK_IMPORTED_MODULE_11_text_overflow_clamp___default()(this.titleNode, { lineClamp: 2 });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          videoItem = _props.videoItem,
          isSelected = _props.isSelected,
          nowPlaying = _props.nowPlaying,
          width = _props.width,
          height = _props.height,
          intl = _props.intl,
          className = _props.className,
          isDescriptionVisibleOnHoverOnly = _props.isDescriptionVisibleOnHoverOnly,
          isDescriptionOnVideo = _props.isDescriptionOnVideo,
          isPreviewHover = _props.isPreviewHover;
      var title = videoItem.title,
          durationStr = videoItem.durationStr;
      var formatMessage = intl.formatMessage;


      var wrapperStyleNames = __WEBPACK_IMPORTED_MODULE_10_classnames___default()('wrapper', {
        selected: isSelected,
        'now-playing': nowPlaying,
        'description-on-video': isDescriptionOnVideo,
        'description-on-hover': isDescriptionVisibleOnHoverOnly,
        'preview-hover': isPreviewHover
      });

      return React.createElement(
        'span',
        { styleName: wrapperStyleNames,
          style: { width: width },
          className: className },
        React.createElement(
          'span',
          { styleName: 'thumbnail',
            title: title,
            'data-duration': durationStr,
            'data-now-playing': formatMessage(__WEBPACK_IMPORTED_MODULE_19__translations__["a" /* default */].nowPlaying) },
          React.createElement(__WEBPACK_IMPORTED_MODULE_17__simple__["a" /* SimpleVideoThumbnail */], { video: videoItem,
            width: width,
            height: height }),
          this.purchaseIcon,
          this.watchedIcon,
          isDescriptionOnVideo && this.description
        ),
        !isDescriptionOnVideo && this.description
      );
    }
  }, {
    key: 'title',
    get: function get() {
      var _this2 = this;

      var _props2 = this.props,
          videoItem = _props2.videoItem,
          isTitleVisible = _props2.isTitleVisible;
      var title = videoItem.title;

      if (!isTitleVisible) {
        return null;
      }

      return React.createElement(
        'span',
        { ref: function ref(node) {
            return _this2.titleNode = node;
          },
          styleName: 'title',
          title: title },
        title
      );
    }
  }, {
    key: 'publisher',
    get: function get() {
      var _props3 = this.props,
          videoItem = _props3.videoItem,
          isPublisherVisible = _props3.isPublisherVisible;
      var publisher = videoItem.publisher;


      if (!isPublisherVisible) {
        return null;
      }

      return React.createElement(
        'span',
        { styleName: 'publisher',
          title: publisher },
        publisher
      );
    }
  }, {
    key: 'description',
    get: function get() {
      var title = this.title;
      var publisher = this.publisher;
      if (!title && !publisher) {
        return null;
      }

      return React.createElement(
        'span',
        { styleName: 'description' },
        title,
        publisher
      );
    }
  }, {
    key: 'purchaseIcon',
    get: function get() {
      var minVideoPrice = __WEBPACK_IMPORTED_MODULE_12_shared_utils_deal_info_helpers__["d" /* getMinPriceInfo */](this.props.videoItem.dealInfo);
      if (!minVideoPrice || this.props.watched) {
        return null;
      }

      return React.createElement(
        'span',
        { styleName: 'purchase-icon' },
        React.createElement(__WEBPACK_IMPORTED_MODULE_16_shared_components_icon_icon__["a" /* default */], { name: 'paid' })
      );
    }
  }, {
    key: 'watchedIcon',
    get: function get() {
      if (!this.props.watched) {
        return null;
      }

      return React.createElement(
        'span',
        { styleName: 'watched-icon' },
        React.createElement(__WEBPACK_IMPORTED_MODULE_16_shared_components_icon_icon__["a" /* default */], { name: 'eye' })
      );
    }
  }]);

  return Thumbnail;
}(React.Component), _class2.propTypes = _propTypes, _class2.defaultProps = _defaultProps, _temp)) || _class) || _class);


var ClickableThumbnail = (_dec3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_shared_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_18__thumbnail_styl___default.a), _dec3(_class3 = (_class4 = (_temp2 = _class5 = function (_React$Component2) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(ClickableThumbnail, _React$Component2);

  function ClickableThumbnail() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ClickableThumbnail);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ClickableThumbnail.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(ClickableThumbnail)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(ClickableThumbnail, [{
    key: 'handleClick',
    value: function handleClick(event) {
      event.preventDefault();

      var _props4 = this.props,
          onClick = _props4.onClick,
          videoItem = _props4.videoItem;

      onClick(videoItem);
    }
  }, {
    key: 'render',
    value: function render() {
      var props = _.pick(this.props, _.keys(_propTypes));
      var _props5 = props,
          className = _props5.className;

      props = _.omit(props, 'className', 'styles', 'dataHook');

      return React.createElement(
        'a',
        { href: '',
          styleName: 'clickable',
          className: className,
          'data-hook': this.props.dataHook,
          onClick: this.handleClick },
        React.createElement(Thumbnail, props)
      );
    }
  }]);

  return ClickableThumbnail;
}(React.Component), _class5.propTypes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _propTypes, {
  videoItem: React.PropTypes.object.isRequired,
  onClick: React.PropTypes.func.isRequired,
  dataHook: React.PropTypes.string
}), _class5.defaultProps = _defaultProps, _temp2), (_applyDecoratedDescriptor(_class4.prototype, 'handleClick', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class4.prototype, 'handleClick'), _class4.prototype)), _class4)) || _class3);

/***/ }),
/* 2522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* defineMessages */])({
  nowPlaying: {
    id: 'thumbnail.now-playing',
    defaultMessage: 'Now Playing'
  }
}));

/***/ }),
/* 2523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PrevButton;
/* harmony export (immutable) */ __webpack_exports__["b"] = NextButton;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_prev_svg__ = __webpack_require__(2702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__nav_button_styl__ = __webpack_require__(3276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__nav_button_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__nav_button_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_translations_navigation__ = __webpack_require__(2470);








var _dec, _class, _desc, _value, _class2, _class3, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}













var GenericNavButton = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_12__nav_button_styl___default.a), _dec(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(GenericNavButton, _React$Component);

  function GenericNavButton() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, GenericNavButton);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (GenericNavButton.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(GenericNavButton)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(GenericNavButton, [{
    key: 'handleClick',
    value: function handleClick() {
      var _props = this.props,
          disabled = _props.disabled,
          onClick = _props.onClick;

      if (!disabled) {
        return onClick();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          name = _props2.name,
          disabled = _props2.disabled;


      var styleNames = __WEBPACK_IMPORTED_MODULE_8_classnames___default()('nav-button', name, {
        disabled: disabled
      });

      return React.createElement(
        'button',
        { onClick: this.handleClick,
          styleName: styleNames },
        React.createElement(__WEBPACK_IMPORTED_MODULE_11__images_prev_svg__["a" /* default */], { styleName: 'nav-arrow' }),
        React.createElement(
          'div',
          { styleName: 'nav-text' },
          React.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */], __WEBPACK_IMPORTED_MODULE_13_shared_translations_navigation__["a" /* default */][name])
        )
      );
    }
  }]);

  return GenericNavButton;
}(React.Component), _class3.propTypes = {
  name: React.PropTypes.string.isRequired,
  onClick: React.PropTypes.func,
  disabled: React.PropTypes.bool
}, _class3.defaultProps = {
  rounded: false
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'handleClick', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handleClick'), _class2.prototype)), _class2)) || _class);


function PrevButton(props) {
  return React.createElement(GenericNavButton, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
    name: 'prev' }));
}

function NextButton(props) {
  return React.createElement(GenericNavButton, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
    name: 'next' }));
}

/***/ }),
/* 2524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ThumbnailOverlayStripBase */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ThumbnailOverlayStrip; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_selectors_app_settings__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_widget_components_player_overlay_strip_strip_base__ = __webpack_require__(1546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_components_element_switcher_element_switcher__ = __webpack_require__(1976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_components_icon_icon__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_components_button_button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__thumbnail_overlay_styl__ = __webpack_require__(3277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__thumbnail_overlay_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__thumbnail_overlay_styl__);







var _class, _temp, _dec, _dec2, _dec3, _class2;















var THUMB_PADDING = 24;

var ThumbnailOverlayStripBase = (_temp = _class = function (_OverlayStripBase) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ThumbnailOverlayStripBase, _OverlayStripBase);

  function ThumbnailOverlayStripBase(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ThumbnailOverlayStripBase);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ThumbnailOverlayStripBase.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(ThumbnailOverlayStripBase)).call(this, props));

    var durationStr = _this.props.videoItem.durationStr;


    _this.clampOptions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this.clampOptions, {
      truncateText: ' / ' + durationStr,
      textAlign: 'center'
    });
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ThumbnailOverlayStripBase, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          channelData = _props.channelData,
          videoItem = _props.videoItem,
          className = _props.className,
          isPreviewHover = _props.isPreviewHover,
          isTitleAlwaysShown = _props.isTitleAlwaysShown,
          isTitleNeverShown = _props.isTitleNeverShown;


      if (!channelData || !videoItem) {
        return null;
      }

      var styleNames = __WEBPACK_IMPORTED_MODULE_7_classnames___default()('overlay-wrapper', {
        'preview-hover': isPreviewHover,
        visible: isTitleAlwaysShown || isTitleNeverShown
      });

      return React.createElement(
        'div',
        { styleName: styleNames,
          className: className },
        React.createElement('div', { styleName: 'background' }),
        React.createElement(
          'div',
          { styleName: 'content' },
          React.createElement(
            'div',
            { styleName: 'top-content',
              dir: 'ltr' },
            this.titleBlock,
            this.buttons
          )
        )
      );
    }
  }, {
    key: 'titleText',
    get: function get() {
      return this.props.videoItem.title;
    }
  }, {
    key: 'shouldShowTitle',
    get: function get() {
      return true;
    }
  }, {
    key: 'titleBlock',
    get: function get() {
      if (this.props.isTitleNeverShown) {
        return null;
      }

      return React.createElement(
        'div',
        { styleName: 'title-block' },
        this.title
      );
    }
  }, {
    key: 'smallPlayButton',
    get: function get() {
      if (!this.playButtonText) {
        return null;
      }

      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_13_shared_components_button_button__["f" /* GenericButton */],
        { styleName: 'button play-button',
          onClick: this.playSelectedVideo },
        React.createElement(__WEBPACK_IMPORTED_MODULE_12_shared_components_icon_icon__["b" /* RoundedIcon */], { styleName: 'icon play-icon',
          name: 'arrow-right-filled' })
      );
    }
  }, {
    key: 'smallSubscribeButton',
    get: function get() {
      if (!this.subscribeButtonText) {
        return null;
      }

      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_13_shared_components_button_button__["f" /* GenericButton */],
        { styleName: 'button small-subscribe-button',
          onClick: this.openSubscription },
        React.createElement(__WEBPACK_IMPORTED_MODULE_12_shared_components_icon_icon__["b" /* RoundedIcon */], { styleName: 'icon paid-icon',
          name: 'paid' })
      );
    }
  }, {
    key: 'smallPurchaseButton',
    get: function get() {
      if (!this.purchaseButtonText) {
        return null;
      }

      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_13_shared_components_button_button__["f" /* GenericButton */],
        { styleName: 'button small-buy-button',
          onClick: this.openPurchase },
        React.createElement(__WEBPACK_IMPORTED_MODULE_12_shared_components_icon_icon__["b" /* RoundedIcon */], { styleName: 'icon paid-icon',
          name: 'paid' })
      );
    }
  }, {
    key: 'normalButtons',
    get: function get() {
      var play = this.playButton;
      var subscribe = this.subscribeButton;
      var purchase = this.purchaseButton;

      var key = '' + (play ? '1' : '') + (subscribe ? '2' : '') + (purchase ? '3' : '');

      return React.createElement(
        'div',
        { styleName: 'buttons-wrapper',
          key: key },
        play,
        subscribe || purchase
      );
    }
  }, {
    key: 'smallButtons',
    get: function get() {
      return React.createElement(
        'section',
        { styleName: 'buttons-wrapper' },
        this.smallPlayButton,
        this.smallSubscribeButton || this.smallPurchaseButton
      );
    }
  }, {
    key: 'buttons',
    get: function get() {
      var _props2 = this.props,
          width = _props2.width,
          isOnlySmallButtons = _props2.isOnlySmallButtons;


      if (isOnlySmallButtons) {
        return this.smallButtons;
      }

      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_11_shared_components_element_switcher_element_switcher__["a" /* default */],
        { maxWidth: width - 2 * THUMB_PADDING },
        this.normalButtons,
        this.smallButtons
      );
    }
  }]);

  return ThumbnailOverlayStripBase;
}(__WEBPACK_IMPORTED_MODULE_10_widget_components_player_overlay_strip_strip_base__["a" /* default */]), _class.displayName = 'ThumbnailOverlayStrip', _class.propTypes = {
  isPreviewHover: React.PropTypes.bool,
  isTitleAlwaysShown: React.PropTypes.bool,
  isTitleNeverShown: React.PropTypes.bool
}, _temp);

var ThumbnailOverlayStrip = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["a" /* connect */])(function (state) {
  return {
    isPreviewHover: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_shared_selectors_app_settings__["y" /* isPreviewHover */])(state),
    isTitleAlwaysShown: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_shared_selectors_app_settings__["A" /* isVideosListInfoAlwaysShown */])(state),
    isTitleNeverShown: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_shared_selectors_app_settings__["B" /* isVideosListInfoNeverShown */])(state)
  };
}), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_shared_utils_wix_connect__["c" /* VODBiEvents */])(), _dec3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_14__thumbnail_overlay_styl___default.a), _dec(_class2 = _dec2(_class2 = _dec3(_class2 = function (_ThumbnailOverlayStri) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ThumbnailOverlayStrip, _ThumbnailOverlayStri);

  function ThumbnailOverlayStrip() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ThumbnailOverlayStrip);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ThumbnailOverlayStrip.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(ThumbnailOverlayStrip)).apply(this, arguments));
  }

  return ThumbnailOverlayStrip;
}(ThumbnailOverlayStripBase)) || _class2) || _class2) || _class2);


/***/ }),
/* 2525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DesktopLayout; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_default_settings__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_widget_utils_videos_sizes__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_bi_bi_unhandled_error_logger__ = __webpack_require__(1196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_constants_compact_layout__ = __webpack_require__(1987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_selectors_channels__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_selectors_app_settings__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_widget_selectors_video_id_from_url__ = __webpack_require__(2014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_selectors_search__ = __webpack_require__(1813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_widget_ui_selectors_selected_video_id__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_widget_redux_client_actions_select_video__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_shared_components_tooltip_tooltip_popout__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_shared_components_modal_modal__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_shared_bi_bi_handler__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_shared_data_components_experiments__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_widget_data_components_app_settings__ = __webpack_require__(1732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_widget_data_components_update_channel_published_state__ = __webpack_require__(1735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_widget_data_components_channel__ = __webpack_require__(1733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_widget_data_components_payment_info__ = __webpack_require__(1208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_widget_data_components_channel_video__ = __webpack_require__(1206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_widget_data_components_paginated_channel_videos__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_widget_data_components_next_channel_videos__ = __webpack_require__(1262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_widget_data_components_current_site_user__ = __webpack_require__(1734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_widget_data_components_reload_channel_payment_data_on_payment__ = __webpack_require__(1263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_widget_data_components_clear_video_urls_cache_on_payment__ = __webpack_require__(1550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_widget_data_components_set_initial_widget_size__ = __webpack_require__(1837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_shared_components_payment_events_proxy__ = __webpack_require__(1532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_widget_components_payments_bi_handler__ = __webpack_require__(2007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_shared_styles_core_styl__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_shared_styles_core_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_shared_styles_core_styl__);






var _dec, _class, _class2, _temp;






































var DesktopLayout = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["a" /* connect */])(function (state) {
  return {
    appSettings: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_shared_selectors_app_settings__["a" /* getAllSettings */])(state),
    selectedVideoId: state.selectedVideoId,
    channelData: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_shared_selectors_channels__["a" /* getChannelForWidget */])(state),
    currentChannelId: state.currentChannelId,
    mainVideoId: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_widget_ui_selectors_selected_video_id__["a" /* getMainVideoId */])(state, __WEBPACK_IMPORTED_MODULE_25_widget_data_components_paginated_channel_videos__["a" /* DATA_KEY */]),
    numberOfRows: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_shared_selectors_app_settings__["I" /* getNumberOfRows */])(state),
    videoIdFromUrl: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_widget_selectors_video_id_from_url__["a" /* default */])(state),
    searchQuery: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__shared_selectors_search__["a" /* getSearchQuery */])(state),
    searchQueryField: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__shared_selectors_search__["b" /* getSearchQueryField */])(state),
    editMode: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_shared_selectors_app_settings__["w" /* getEditMode */])(state),
    isInitialWidgetSizeWasSet: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_shared_selectors_app_settings__["k" /* getIsInitialWidgetSizeWasSet */])(state),
    layout: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_shared_selectors_app_settings__["j" /* getChannelLayout */])(state)
  };
}, {
  selectVideo: __WEBPACK_IMPORTED_MODULE_15_widget_redux_client_actions_select_video__["a" /* selectVideo */]
}), _dec(_class = (_temp = _class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(DesktopLayout, _React$Component);

  function DesktopLayout() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DesktopLayout);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (DesktopLayout.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(DesktopLayout)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(DesktopLayout, [{
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      var videoIdFromUrl = nextProps.videoIdFromUrl,
          selectedVideoId = nextProps.selectedVideoId;

      if (videoIdFromUrl && !selectedVideoId) {
        this.props.selectVideo(videoIdFromUrl);
      }
    }

    // Todo: move to loader or reducer

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          currentChannelId = _props.currentChannelId,
          appSettings = _props.appSettings,
          editMode = _props.editMode,
          layout = _props.layout;


      return React.createElement(
        'div',
        { 'data-layout': layout,
          'data-view-mode': editMode },
        React.createElement(__WEBPACK_IMPORTED_MODULE_30_widget_data_components_set_initial_widget_size__["a" /* default */], null),
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_19_shared_data_components_experiments__["a" /* default */],
          null,
          React.createElement(__WEBPACK_IMPORTED_MODULE_18_shared_bi_bi_handler__["b" /* default */], null),
          React.createElement(__WEBPACK_IMPORTED_MODULE_8_shared_bi_bi_unhandled_error_logger__["a" /* default */], null),
          React.createElement(__WEBPACK_IMPORTED_MODULE_32_widget_components_payments_bi_handler__["a" /* default */], null),
          React.createElement(__WEBPACK_IMPORTED_MODULE_20_widget_data_components_app_settings__["a" /* default */], null),
          React.createElement(__WEBPACK_IMPORTED_MODULE_21_widget_data_components_update_channel_published_state__["a" /* default */], { channelId: currentChannelId }),
          this.content,
          React.createElement(__WEBPACK_IMPORTED_MODULE_17_shared_components_modal_modal__["g" /* default */], { settings: appSettings }),
          React.createElement(__WEBPACK_IMPORTED_MODULE_16_shared_components_tooltip_tooltip_popout__["c" /* default */], null)
        )
      );
    }
  }, {
    key: 'videosPerPage',
    get: function get() {
      var _props2 = this.props,
          appSettings = _props2.appSettings,
          numberOfRows = _props2.numberOfRows,
          channelData = _props2.channelData;
      var _appSettings$numbers = appSettings.numbers,
          videosInRow = _appSettings$numbers.videosInRow,
          channelLayout = _appSettings$numbers.channelLayout;

      var isStrip = channelLayout === __WEBPACK_IMPORTED_MODULE_6_default_settings__["d" /* channelLayoutValues */].STRIP;
      var isCompact = channelLayout === __WEBPACK_IMPORTED_MODULE_6_default_settings__["d" /* channelLayoutValues */].COMPACT;

      if (isCompact) {
        return __WEBPACK_IMPORTED_MODULE_9_shared_constants_compact_layout__["b" /* COMPACT_NUMBER_OF_ROWS */] * __WEBPACK_IMPORTED_MODULE_9_shared_constants_compact_layout__["a" /* COMPACT_VIDEOS_IN_ROW */];
      }

      if (isStrip) {
        return videosInRow * numberOfRows;
      }

      var allVideosCount = channelData && channelData.videosCount;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_widget_utils_videos_sizes__["g" /* videosPerPage */])(appSettings.requestedWidgetSize, videosInRow, allVideosCount, appSettings, channelData || {});
    }
  }, {
    key: 'content',
    get: function get() {
      var _props3 = this.props,
          children = _props3.children,
          appSettings = _props3.appSettings,
          mainVideoId = _props3.mainVideoId,
          videoIdFromUrl = _props3.videoIdFromUrl,
          currentChannelId = _props3.currentChannelId,
          selectedVideoId = _props3.selectedVideoId,
          isInitialWidgetSizeWasSet = _props3.isInitialWidgetSizeWasSet;


      if (!appSettings || !currentChannelId || !isInitialWidgetSizeWasSet) {
        return null;
      }

      var _props4 = this.props,
          searchQuery = _props4.searchQuery,
          searchQueryField = _props4.searchQueryField;

      var nextChannelVideosVideoId = selectedVideoId || videoIdFromUrl || mainVideoId;

      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_22_widget_data_components_channel__["a" /* default */],
        { channelId: currentChannelId },
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_25_widget_data_components_paginated_channel_videos__["b" /* default */],
          { channelId: currentChannelId,
            videosPerUIPage: this.videosPerPage,
            searchQuery: searchQuery,
            searchQueryField: searchQueryField,
            as: __WEBPACK_IMPORTED_MODULE_25_widget_data_components_paginated_channel_videos__["a" /* DATA_KEY */] },
          React.createElement(
            __WEBPACK_IMPORTED_MODULE_24_widget_data_components_channel_video__["a" /* default */],
            { channelId: currentChannelId,
              videoId: videoIdFromUrl },
            React.createElement(
              __WEBPACK_IMPORTED_MODULE_26_widget_data_components_next_channel_videos__["a" /* default */],
              { channelId: currentChannelId,
                currentVideoId: nextChannelVideosVideoId },
              React.createElement(
                __WEBPACK_IMPORTED_MODULE_27_widget_data_components_current_site_user__["a" /* default */],
                null,
                React.createElement(
                  __WEBPACK_IMPORTED_MODULE_23_widget_data_components_payment_info__["a" /* default */],
                  { channelId: currentChannelId },
                  children,
                  React.createElement(__WEBPACK_IMPORTED_MODULE_31_shared_components_payment_events_proxy__["a" /* default */], null),
                  React.createElement(__WEBPACK_IMPORTED_MODULE_28_widget_data_components_reload_channel_payment_data_on_payment__["a" /* default */], null),
                  React.createElement(__WEBPACK_IMPORTED_MODULE_29_widget_data_components_clear_video_urls_cache_on_payment__["a" /* default */], null)
                )
              )
            )
          )
        )
      );
    }
  }]);

  return DesktopLayout;
}(React.Component), _class2.propTypes = {
  selectedVideoId: React.PropTypes.string,
  children: React.PropTypes.element,
  currentChannelId: React.PropTypes.string,
  mainVideoId: React.PropTypes.string,
  videoIdFromUrl: React.PropTypes.string,
  channelData: React.PropTypes.object,
  appSettings: React.PropTypes.object,
  selectVideo: React.PropTypes.func,
  numberOfRows: React.PropTypes.number,
  searchQuery: React.PropTypes.string,
  searchQueryField: React.PropTypes.string,
  editMode: React.PropTypes.string,
  isInitialWidgetSizeWasSet: React.PropTypes.bool,
  layout: React.PropTypes.number
}, _temp)) || _class);


/***/ }),
/* 2526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MobileLayout; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_components_tooltip_tooltip_popout__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_components_modal_modal__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_bi_bi_unhandled_error_logger__ = __webpack_require__(1196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_widget_components_mobile_spinner_overlay_mobile_spinner_overlay__ = __webpack_require__(1727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_widget_redux_client_actions_select_video__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_bi_bi_handler__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_data_components_experiments__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_widget_data_components_app_settings__ = __webpack_require__(1732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_widget_data_components_update_channel_published_state__ = __webpack_require__(1735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_widget_data_components_update_widget_size__ = __webpack_require__(1551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_widget_data_components_channel__ = __webpack_require__(1733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_widget_data_components_payment_info__ = __webpack_require__(1208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_widget_data_components_channel_video__ = __webpack_require__(1206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_widget_data_components_lazy_channel_videos__ = __webpack_require__(1207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_widget_data_components_current_site_user__ = __webpack_require__(1734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_widget_data_components_reload_channel_payment_data_on_payment__ = __webpack_require__(1263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_widget_data_components_clear_video_urls_cache_on_payment__ = __webpack_require__(1550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_shared_components_payment_events_proxy__ = __webpack_require__(1532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_widget_components_payments_bi_handler__ = __webpack_require__(2007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_shared_selectors_app_settings__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_widget_selectors_video_id_from_url__ = __webpack_require__(2014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__widget_height_by_content_sync__ = __webpack_require__(2527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_shared_styles_core_styl__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_shared_styles_core_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_shared_styles_core_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__mobile_styl__ = __webpack_require__(3278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__mobile_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__mobile_styl__);






var _dec, _dec2, _class, _class2, _temp;



































var MobileLayout = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["a" /* connect */])(function (state) {
  return {
    appSettings: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_shared_selectors_app_settings__["a" /* getAllSettings */])(state),
    videosInRow: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_shared_selectors_app_settings__["v" /* getVideosInRowCount */])(state),
    currentChannelId: state.currentChannelId,
    layout: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_shared_selectors_app_settings__["j" /* getChannelLayout */])(state),
    editMode: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_shared_selectors_app_settings__["w" /* getEditMode */])(state),
    selectedVideoId: state.selectedVideoId,
    videoIdFromUrl: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27_widget_selectors_video_id_from_url__["a" /* default */])(state)
  };
}, {
  selectVideo: __WEBPACK_IMPORTED_MODULE_11_widget_redux_client_actions_select_video__["a" /* selectVideo */]
}), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_shared_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_30__mobile_styl___default.a), _dec(_class = _dec2(_class = (_temp = _class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MobileLayout, _React$Component);

  function MobileLayout() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, MobileLayout);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (MobileLayout.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(MobileLayout)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(MobileLayout, [{
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      var videoIdFromUrl = nextProps.videoIdFromUrl,
          selectedVideoId = nextProps.selectedVideoId;

      if (videoIdFromUrl && !selectedVideoId) {
        this.props.selectVideo(videoIdFromUrl);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          currentChannelId = _props.currentChannelId,
          appSettings = _props.appSettings,
          layout = _props.layout,
          editMode = _props.editMode;


      return React.createElement(
        'div',
        { styleName: 'container',
          'data-layout': layout,
          'data-view-mode': editMode },
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_13_shared_data_components_experiments__["a" /* default */],
          null,
          React.createElement(__WEBPACK_IMPORTED_MODULE_12_shared_bi_bi_handler__["b" /* default */], null),
          React.createElement(__WEBPACK_IMPORTED_MODULE_9_shared_bi_bi_unhandled_error_logger__["a" /* default */], null),
          React.createElement(__WEBPACK_IMPORTED_MODULE_25_widget_components_payments_bi_handler__["a" /* default */], null),
          React.createElement(__WEBPACK_IMPORTED_MODULE_14_widget_data_components_app_settings__["a" /* default */], null),
          React.createElement(__WEBPACK_IMPORTED_MODULE_15_widget_data_components_update_channel_published_state__["a" /* default */], { channelId: currentChannelId }),
          React.createElement(__WEBPACK_IMPORTED_MODULE_16_widget_data_components_update_widget_size__["a" /* default */], null),
          this.content,
          React.createElement(__WEBPACK_IMPORTED_MODULE_8_shared_components_modal_modal__["f" /* MobileModal */], { settings: appSettings }),
          React.createElement(__WEBPACK_IMPORTED_MODULE_7_shared_components_tooltip_tooltip_popout__["c" /* default */], null)
        )
      );
    }
  }, {
    key: 'content',
    get: function get() {
      var _props2 = this.props,
          children = _props2.children,
          appSettings = _props2.appSettings,
          currentChannelId = _props2.currentChannelId,
          videoIdFromUrl = _props2.videoIdFromUrl,
          videosInRow = _props2.videosInRow;


      if (!appSettings || !currentChannelId) {
        return React.createElement(__WEBPACK_IMPORTED_MODULE_10_widget_components_mobile_spinner_overlay_mobile_spinner_overlay__["a" /* default */], null);
      }

      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_28__widget_height_by_content_sync__["a" /* default */],
        null,
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_17_widget_data_components_channel__["a" /* default */],
          { channelId: currentChannelId },
          React.createElement(
            __WEBPACK_IMPORTED_MODULE_20_widget_data_components_lazy_channel_videos__["a" /* default */],
            { channelId: currentChannelId,
              as: __WEBPACK_IMPORTED_MODULE_20_widget_data_components_lazy_channel_videos__["d" /* MOBILE_WIDGET_DATA_KEY */],
              numberToLoadMore: videosInRow * 3 },
            React.createElement(
              __WEBPACK_IMPORTED_MODULE_19_widget_data_components_channel_video__["a" /* default */],
              { channelId: currentChannelId,
                videoId: videoIdFromUrl },
              React.createElement(
                __WEBPACK_IMPORTED_MODULE_21_widget_data_components_current_site_user__["a" /* default */],
                null,
                React.createElement(
                  __WEBPACK_IMPORTED_MODULE_18_widget_data_components_payment_info__["a" /* default */],
                  { channelId: currentChannelId },
                  children,
                  React.createElement(__WEBPACK_IMPORTED_MODULE_24_shared_components_payment_events_proxy__["a" /* default */], null),
                  React.createElement(__WEBPACK_IMPORTED_MODULE_22_widget_data_components_reload_channel_payment_data_on_payment__["a" /* default */], null),
                  React.createElement(__WEBPACK_IMPORTED_MODULE_23_widget_data_components_clear_video_urls_cache_on_payment__["a" /* default */], null)
                )
              )
            )
          )
        )
      );
    }
  }]);

  return MobileLayout;
}(React.Component), _class2.propTypes = {
  children: React.PropTypes.element,
  currentChannelId: React.PropTypes.string,
  selectedVideoId: React.PropTypes.string,
  videoIdFromUrl: React.PropTypes.string,
  appSettings: React.PropTypes.object,
  layout: React.PropTypes.number,
  editMode: React.PropTypes.string,
  videosInRow: React.PropTypes.number,
  selectVideo: React.PropTypes.func
}, _temp)) || _class) || _class);


/***/ }),
/* 2527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WidgetHeightByContentSync; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_debounce__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_sdk__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_selectors_app_settings__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_constants_view_modes__ = __webpack_require__(194);







var _dec, _class, _desc, _value, _class2, _class3, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}











var WidgetHeightByContentSync = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["a" /* connect */])(function (state) {
  return {
    // lazyVideoLists is needed to trigger height calculations
    lazyVideoLists: state.lazyVideoLists,
    appSettings: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_shared_selectors_app_settings__["a" /* getAllSettings */])(state)
  };
}), _dec(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(WidgetHeightByContentSync, _React$Component);

  function WidgetHeightByContentSync() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, WidgetHeightByContentSync);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (WidgetHeightByContentSync.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(WidgetHeightByContentSync)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(WidgetHeightByContentSync, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.updateTPAParentIfNeeded();
      window.addEventListener('resize', this.updateTPAParentIfNeeded);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.updateTPAParentIfNeeded();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateTPAParentIfNeeded);
    }
  }, {
    key: 'updateTPAParentIfNeeded',
    value: function updateTPAParentIfNeeded() {
      if (!this.container) {
        return;
      }

      var newHeight = Math.ceil(this.container.scrollHeight);

      // Width is not checked, only height
      if (newHeight === 0) {
        return;
      }

      // Getting real bounding rect for our component
      __WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_sdk__["a" /* default */].getBoundingRectAndOffsets().then(function (data) {
        var rect = data.rect;


        if (rect.height !== newHeight) {
          if (__WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_sdk__["a" /* default */].Utils.getViewMode() === __WEBPACK_IMPORTED_MODULE_11_shared_constants_view_modes__["a" /* default */].EDITOR) {
            // this is for editor
            __WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_sdk__["a" /* default */].resizeComponent({ height: newHeight });

            // fix TPA bug. TODO remove
            __WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_sdk__["a" /* default */].setHeight(newHeight);
          } else {
            // this is for viewer
            __WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_sdk__["a" /* default */].setHeight(newHeight);
          }
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          appSettings = _props.appSettings,
          children = _props.children;

      var widgetWidth = _.get(appSettings, 'requestedWidgetSize.width');

      if (!widgetWidth) {
        return null;
      }

      return React.createElement(
        'div',
        { ref: function ref(node) {
            return _this2.container = node;
          },
          style: { width: widgetWidth } },
        children
      );
    }
  }]);

  return WidgetHeightByContentSync;
}(React.Component), _class3.propTypes = {
  appSettings: React.PropTypes.object,
  children: React.PropTypes.any
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'updateTPAParentIfNeeded', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a, __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_debounce___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'updateTPAParentIfNeeded'), _class2.prototype)), _class2)) || _class);


/***/ }),
/* 2528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_utils_wix_sdk__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_constants_device_types__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_views_not_found_view_not_found_view__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_widget_layouts_desktop_desktop__ = __webpack_require__(2525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_widget_layouts_mobile_mobile__ = __webpack_require__(2526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_widget_views_desktop_desktop_views_switcher__ = __webpack_require__(2557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_widget_views_mobile_mobile__ = __webpack_require__(2562);












var MOBILE_ROUTE_PREFIX = '/mobile';

function getUrlDeviceType(location) {
  return _.startsWith(location.pathname, MOBILE_ROUTE_PREFIX) ? __WEBPACK_IMPORTED_MODULE_2_shared_constants_device_types__["a" /* default */].MOBILE : __WEBPACK_IMPORTED_MODULE_2_shared_constants_device_types__["a" /* default */].DESKTOP;
}

function requireRedirectToMobile(nextState, replace) {
  if (__WEBPACK_IMPORTED_MODULE_1_shared_utils_wix_sdk__["a" /* default */].Utils.getDeviceType() === __WEBPACK_IMPORTED_MODULE_2_shared_constants_device_types__["a" /* default */].MOBILE && getUrlDeviceType(nextState.location) !== __WEBPACK_IMPORTED_MODULE_2_shared_constants_device_types__["a" /* default */].MOBILE) {
    replace('/mobile');
  }
}

function onEnterMobile() {
  // TODO: set full width
}

/* harmony default export */ __webpack_exports__["a"] = (React.createElement(
  __WEBPACK_IMPORTED_MODULE_0_react_router__["b" /* Route */],
  { path: '/' },
  React.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react_router__["b" /* Route */],
    { onEnter: requireRedirectToMobile,
      component: __WEBPACK_IMPORTED_MODULE_4_widget_layouts_desktop_desktop__["a" /* default */] },
    React.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["c" /* IndexRoute */], { component: __WEBPACK_IMPORTED_MODULE_6_widget_views_desktop_desktop_views_switcher__["a" /* default */] })
  ),
  React.createElement(
    __WEBPACK_IMPORTED_MODULE_0_react_router__["b" /* Route */],
    { path: MOBILE_ROUTE_PREFIX,
      onEnter: onEnterMobile,
      component: __WEBPACK_IMPORTED_MODULE_5_widget_layouts_mobile_mobile__["a" /* default */] },
    React.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["c" /* IndexRoute */], { component: __WEBPACK_IMPORTED_MODULE_7_widget_views_mobile_mobile__["a" /* default */] })
  ),
  React.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["b" /* Route */], { path: '/404',
    component: __WEBPACK_IMPORTED_MODULE_3_shared_views_not_found_view_not_found_view__["a" /* default */] }),
  React.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["d" /* Redirect */], { from: '*',
    to: '/404' })
));

/***/ }),
/* 2529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isMobileWidgetVisibleInViewPort;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_utils_wix_sdk__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_utils_device_screen__ = __webpack_require__(385);



function isMobileWidgetVisibleInViewPort() {
  return __WEBPACK_IMPORTED_MODULE_0_shared_utils_wix_sdk__["a" /* default */].getBoundingRectAndOffsets().then(function (data) {
    var _data$rect = data.rect,
        top = _data$rect.top,
        bottom = _data$rect.bottom;

    var _getScreenSizeByUserA = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_utils_device_screen__["c" /* getScreenSizeByUserAgent */])(),
        width = _getScreenSizeByUserA.width,
        height = _getScreenSizeByUserA.height;

    var screenHeight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_utils_device_screen__["d" /* isLandscape */])() ? width : height;

    return top <= 0 && bottom >= screenHeight || top >= 0 && bottom <= screenHeight;
  });
}

/***/ }),
/* 2530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClassicView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_get__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_decorators_lib_debounce__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_decorators_lib_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_decorators_lib_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_shared_analytics_new_relic__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_shared_utils_layout_helpers__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_shared_utils_wix_sdk__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_widget_utils_reload__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_shared_utils_device_screen__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_shared_utils_open_overlay__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_widget_utils_videos_sizes__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_widget_redux_client_actions_select_video__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_widget_redux_client_actions_change_playback_status__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_widget_selectors_current_site_user__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__redux_client_actions_search__ = __webpack_require__(1290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_widget_ui_selectors_selected_video_id__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_shared_selectors_app_settings__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_shared_selectors_videos__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_widget_selectors_video_playback_status__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__shared_selectors_search__ = __webpack_require__(1813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_shared_bi_bi__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_widget_data_components_paginated_channel_videos__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_shared_constants_payments__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_shared_constants_view_modes__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_widget_views_base__ = __webpack_require__(1553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_widget_components_players_desktop_player__ = __webpack_require__(1583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_widget_components_players_mobile_player__ = __webpack_require__(1260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_widget_components_preview_prompt_preview_prompt__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_widget_components_share_channel_share_channel__ = __webpack_require__(1834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_widget_components_account_account_button_account_button__ = __webpack_require__(1823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_widget_components_channel_actions_channel_info_button__ = __webpack_require__(1826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_widget_components_channel_actions_channel_subscription_button__ = __webpack_require__(2004);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_widget_components_categories_categories__ = __webpack_require__(2003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_widget_components_tags_tags__ = __webpack_require__(1584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_widget_components_search_bar_search_bar__ = __webpack_require__(2010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_widget_views_desktop_classic_components_videos_videos__ = __webpack_require__(2532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_widget_components_player_overlay_classic_center__ = __webpack_require__(2510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_widget_components_player_overlay_classic_member_only__ = __webpack_require__(2511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_shared_components_scrollbar_wrapper_scrollbar_wrapper__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_widget_data_components_update_widget_size__ = __webpack_require__(1551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_shared_components_payment_events_payment_events__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_widget_components_empty_search_results_empty_search_results__ = __webpack_require__(2006);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_widget_components_reload_storage_reload_storage__ = __webpack_require__(1549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__classic_styl__ = __webpack_require__(3279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__classic_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54__classic_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_widget_translations__ = __webpack_require__(1619);










var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}



























































var DEFAULT_STATE = {
  isInFullScreen: false,
  isTagFocused: false,
  isSearchInputFocused: false,
  searchLayout: false,
  currentCategory: null
};

var ClassicView = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_react_redux__["a" /* connect */])(function (state, ownProps) {
  return {
    mainVideoId: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26_widget_ui_selectors_selected_video_id__["a" /* getMainVideoId */])(state, __WEBPACK_IMPORTED_MODULE_32_widget_data_components_paginated_channel_videos__["a" /* DATA_KEY */]),
    isVideoPlaying: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29_widget_selectors_video_playback_status__["a" /* isVideoPlayingOptimistic */])(state),
    isVideoPaused: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29_widget_selectors_video_playback_status__["b" /* isVideoPausedOptimistic */])(state),
    currentChannelId: state.currentChannelId,
    canShowChannelCover: !state.isVideosTouched,
    appSettings: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27_shared_selectors_app_settings__["a" /* getAllSettings */])(state),
    currentSiteUser: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24_widget_selectors_current_site_user__["a" /* getCurrentSiteUser */])(state),
    firstChannelVideoId: state.firstChannelVideoId,

    videoIdsByPageNumber: ownProps.paginatedChannelVideos.idChunks,
    currentVideosPageNumber: ownProps.paginatedChannelVideos.currentUIPage,
    prevVideoId: ownProps.nextChannelVideos.prevId,
    nextVideoId: ownProps.nextChannelVideos.nextId,
    goToPrevVideosPage: ownProps.paginatedChannelVideos.goBack,
    goToNextVideosPage: ownProps.paginatedChannelVideos.goForward,
    goToFirstVideosPage: ownProps.paginatedChannelVideos.toFirstPage,
    videoByIds: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28_shared_selectors_videos__["a" /* getVideosGroupedByIds */])(state),
    videosPerPage: ownProps.paginatedChannelVideos.ids && ownProps.paginatedChannelVideos.ids.length,
    fetchVideos: ownProps.paginatedChannelVideos.fetch,
    isVideosFetching: ownProps.paginatedChannelVideos.isFetching,

    isSignInVisible: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_shared_utils_layout_helpers__["e" /* isSignInVisible */])(state.appSettings),
    isSearchBarVisible: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_shared_utils_layout_helpers__["b" /* isClassicLayoutSearchBarVisible */])(state.appSettings, ownProps.channelData),
    isSearchInputVisible: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_shared_utils_layout_helpers__["i" /* isSearchInputVisible */])(state.appSettings, ownProps.channelData),
    isCategoriesDropdownVisible: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_shared_utils_layout_helpers__["f" /* isCategoriesDropdownVisible */])(state.appSettings, ownProps.channelData),

    searchQuery: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__shared_selectors_search__["a" /* getSearchQuery */])(state),
    searchQueryField: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30__shared_selectors_search__["b" /* getSearchQueryField */])(state)
  };
}, {
  selectVideo: __WEBPACK_IMPORTED_MODULE_22_widget_redux_client_actions_select_video__["a" /* selectVideo */],
  resetSelectedVideo: __WEBPACK_IMPORTED_MODULE_22_widget_redux_client_actions_select_video__["b" /* resetSelectedVideo */],
  playVideo: __WEBPACK_IMPORTED_MODULE_23_widget_redux_client_actions_change_playback_status__["a" /* playVideo */],
  pauseVideo: __WEBPACK_IMPORTED_MODULE_23_widget_redux_client_actions_change_playback_status__["e" /* pauseVideo */],
  updateSearch: __WEBPACK_IMPORTED_MODULE_25__redux_client_actions_search__["b" /* updateSearch */],
  resetSearch: __WEBPACK_IMPORTED_MODULE_25__redux_client_actions_search__["c" /* resetSearch */]
}), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_shared_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_54__classic_styl___default.a), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_BaseView) {
  __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits___default()(ClassicView, _BaseView);

  function ClassicView(props) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, ClassicView);

    var _this = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ClassicView.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(ClassicView)).call(this, props));

    _this.state = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, DEFAULT_STATE, {
      searchBarValue: props.searchQuery,
      isInitialVideosLoaded: false
    });

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_shared_analytics_new_relic__["a" /* getNewRelic */])().setCustomAttribute('layout', 'classic');
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(ClassicView, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_get___default()(ClassicView.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(ClassicView.prototype), 'componentDidMount', this).call(this);
      this.setUtmostWidgetSize();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_get___default()(ClassicView.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(ClassicView.prototype), 'componentDidUpdate', this).call(this, prevProps);

      var _props = this.props,
          appSettings = _props.appSettings,
          channelData = _props.channelData;


      if (appSettings.numbers.videosInRow !== prevProps.appSettings.numbers.videosInRow || appSettings.numbers.videoInfoPosition !== prevProps.appSettings.numbers.videoInfoPosition || !_.isEqual(appSettings.booleans, prevProps.appSettings.booleans) || channelData !== prevProps.channelData || !_.isEqual(appSettings.requestedWidgetSize, prevProps.appSettings.requestedWidgetSize)) {
        this.setUtmostWidgetSize();
      }
    }
  }, {
    key: 'setUtmostWidgetSize',
    value: function setUtmostWidgetSize() {
      var _props2 = this.props,
          appSettings = _props2.appSettings,
          channelData = _props2.channelData;


      if (!appSettings || !channelData) {
        return;
      }

      var videosInRow = appSettings.numbers.videosInRow;
      var initialWidth = window.innerWidth;
      var initialHeight = window.innerHeight;
      var width = Math.min(Math.max(initialWidth, __WEBPACK_IMPORTED_MODULE_21_widget_utils_videos_sizes__["a" /* MIN_WIDGET_WIDTH */]), __WEBPACK_IMPORTED_MODULE_21_widget_utils_videos_sizes__["f" /* MAX_WIDGET_WIDTH */]);
      var height = initialHeight;

      var allVideosCount = channelData.videosCount;

      // what videos rows need to be displayed
      var perPage = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_widget_utils_videos_sizes__["g" /* videosPerPage */])({
        width: width,
        height: height
      }, videosInRow, allVideosCount, appSettings, channelData);
      var rowsCount = Math.ceil(Math.min(perPage, allVideosCount) / videosInRow);

      if (rowsCount <= 0) {
        rowsCount = 1;
      }

      // widget height for this rows count
      height = Math.ceil(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_widget_utils_videos_sizes__["h" /* classicLayoutWidgetHeight */])(width, videosInRow, allVideosCount, rowsCount, appSettings, channelData));

      if (width !== initialWidth || height !== initialHeight) {
        if (__WEBPACK_IMPORTED_MODULE_17_shared_utils_wix_sdk__["a" /* default */].Utils.getViewMode() === __WEBPACK_IMPORTED_MODULE_34_shared_constants_view_modes__["a" /* default */].EDITOR) {
          // editor
          __WEBPACK_IMPORTED_MODULE_17_shared_utils_wix_sdk__["a" /* default */].resizeComponent({ width: width, height: height });
        } else {
          // viewer
          __WEBPACK_IMPORTED_MODULE_17_shared_utils_wix_sdk__["a" /* default */].resizeWindow(width, height);
        }
        // fix TPA bug. TODO remove
        __WEBPACK_IMPORTED_MODULE_17_shared_utils_wix_sdk__["a" /* default */].setHeight(height);
      }
    }
  }, {
    key: 'reset',
    value: function reset() {
      __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_get___default()(ClassicView.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(ClassicView.prototype), 'reset', this).call(this);

      this.setState(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, DEFAULT_STATE, {
        searchBarValue: ''
      }));
      this.props.goToFirstVideosPage();
    }
  }, {
    key: 'handleThumbnailClick',
    value: function handleThumbnailClick(videoItem) {
      this.scrollToWidgetTop();
      this.selectVideo(videoItem);
    }
  }, {
    key: 'scrollToWidgetTop',
    value: function scrollToWidgetTop() {
      var compId = this.props.appSettings.compId;

      __WEBPACK_IMPORTED_MODULE_17_shared_utils_wix_sdk__["a" /* default */].navigateToComponent(compId);
    }
  }, {
    key: 'handleSlideToPrev',
    value: function handleSlideToPrev() {
      __WEBPACK_IMPORTED_MODULE_31_shared_bi_bi__["a" /* default */].logWidgetSystem('videoList.changePage.requested');
      this.props.goToPrevVideosPage();
    }
  }, {
    key: 'handleSlideToNext',
    value: function handleSlideToNext() {
      __WEBPACK_IMPORTED_MODULE_31_shared_bi_bi__["a" /* default */].logWidgetSystem('videoList.changePage.requested');
      this.props.goToNextVideosPage();
    }
  }, {
    key: 'showChannelInfo',
    value: function showChannelInfo(event) {
      event.preventDefault();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_shared_utils_open_overlay__["f" /* openFullScreenChannelOverlay */])(this.props.channelData.id);
    }
  }, {
    key: 'openSubscription',
    value: function openSubscription() {
      var _this2 = this;

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_38_widget_components_preview_prompt_preview_prompt__["b" /* isPreviewMode */])()) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_38_widget_components_preview_prompt_preview_prompt__["a" /* openPreviewPrompt */])();
        return;
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_shared_utils_open_overlay__["c" /* openFullScreenSubscribeOverlay */])(this.props.channelData.id, function () {
        _this2.props.biEvent('widget.subscriptionPopUp.Completed', { result: 'canceled', errorMsg: '' });
      });
    }
  }, {
    key: 'openMemberOnly',
    value: function openMemberOnly(id) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_shared_utils_open_overlay__["b" /* openFullScreenMemberOnlyOverlay */])(this.props.channelData.id, id);
    }
  }, {
    key: 'storeDataForReload',
    value: function storeDataForReload() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18_widget_utils_reload__["a" /* storeForReload */])({
        selectedVideoId: this.props.mainVideoId
      });
    }
  }, {
    key: 'processDataFromStorage',
    value: function processDataFromStorage(_ref) {
      var _PAYMENT_TYPE$PURCHAS;

      var selectedVideoId = _ref.selectedVideoId,
          autoplay = _ref.autoplay,
          openedModalType = _ref.openedModalType;

      if (autoplay) {
        this.playVideo({ id: selectedVideoId });
      } else {
        this.selectVideo({ id: selectedVideoId });
      }

      var modalOpener = (_PAYMENT_TYPE$PURCHAS = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_PAYMENT_TYPE$PURCHAS, __WEBPACK_IMPORTED_MODULE_33_shared_constants_payments__["a" /* PAYMENT_TYPE */].PURCHASE, this.openPurchase), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_PAYMENT_TYPE$PURCHAS, __WEBPACK_IMPORTED_MODULE_33_shared_constants_payments__["a" /* PAYMENT_TYPE */].SUBSCRIPTION, this.openSubscription), _PAYMENT_TYPE$PURCHAS)[openedModalType];

      if (modalOpener) {
        modalOpener();
      }
    }
  }, {
    key: 'renderPlayerForCurrentDevice',
    value: function renderPlayerForCurrentDevice(videoItem) {
      var _props3 = this.props,
          channelData = _props3.channelData,
          isVideoPlaying = _props3.isVideoPlaying;

      var commonProps = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
        styleName: 'player',
        className: 'qa-widget-player',
        videoItem: videoItem,
        channelData: channelData
      }, this.playerSize, {
        paused: !isVideoPlaying,
        canShowChannelCover: this.canShowChannelCover,
        onPurchaseClick: this.openPurchase,
        onSubscribeClick: this.openSubscription,
        openPreviewPrompt: __WEBPACK_IMPORTED_MODULE_38_widget_components_preview_prompt_preview_prompt__["a" /* openPreviewPrompt */],
        onMemberSignUp: this.openMemberOnly,
        memberOnlyOverlay: React.createElement(__WEBPACK_IMPORTED_MODULE_48_widget_components_player_overlay_classic_member_only__["a" /* default */], null),
        children: this.playerOverlay,
        onFullScreenChanged: this.setFullScreenState
      });

      var PlayerComponent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19_shared_utils_device_screen__["a" /* isMobile */])() || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19_shared_utils_device_screen__["b" /* isTablet */])() ? __WEBPACK_IMPORTED_MODULE_37_widget_components_players_mobile_player__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_36_widget_components_players_desktop_player__["a" /* default */];

      return React.createElement(PlayerComponent, commonProps);
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.isUIBlockingDataLoaded) {
        return this.spinner;
      }

      var appSettings = this.props.appSettings;

      var widgetSize = _.get(appSettings, 'requestedWidgetSize');

      return React.createElement(
        'section',
        { styleName: 'container',
          style: widgetSize,
          className: 'qa-widget-container',
          'data-channel-layout': 'classic' },
        React.createElement(__WEBPACK_IMPORTED_MODULE_50_widget_data_components_update_widget_size__["a" /* default */], { disabled: this.state.isInFullScreen }),
        React.createElement(__WEBPACK_IMPORTED_MODULE_53_widget_components_reload_storage_reload_storage__["a" /* default */], { onReload: this.processDataFromStorage }),
        this.header,
        this.player,
        this.content,
        React.createElement(__WEBPACK_IMPORTED_MODULE_51_shared_components_payment_events_payment_events__["a" /* default */], { onRent: this.setCurrentVideoFromPayment,
          onSale: this.setCurrentVideoFromPayment,
          onSubscription: this.reset,
          onSubscriptionCancel: this.reset })
      );
    }
  }, {
    key: 'listThumbnailSize',
    get: function get() {
      var appSettings = this.props.appSettings;

      var widgetWidth = appSettings.requestedWidgetSize.width;
      var videosInRow = appSettings.numbers.videosInRow;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_widget_utils_videos_sizes__["i" /* listThumbnailSize */])(widgetWidth, videosInRow);
    }

    // TODO: move to data component

  }, {
    key: 'tagList',
    get: function get() {
      return _.get(this.props, 'channelData.statsInfo.tags') || [];
    }
  }, {
    key: 'categoriesList',
    get: function get() {
      var categoriesStats = _.get(this.props, 'channelData.statsInfo.categories') || [];
      return _.map(categoriesStats, 'value');
    }
  }, {
    key: 'tags',
    get: function get() {
      var _state = this.state,
          searchLayout = _state.searchLayout,
          searchBarValue = _state.searchBarValue;

      var tags = this.tagList;

      if (!tags.length || !searchLayout || searchBarValue) {
        return null;
      }

      return React.createElement(
        'div',
        { styleName: 'tags-wrapper' },
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_49_shared_components_scrollbar_wrapper_scrollbar_wrapper__["a" /* WidgetScrollbarWrapper */],
          null,
          React.createElement(__WEBPACK_IMPORTED_MODULE_44_widget_components_tags_tags__["a" /* default */], { styleName: 'tags',
            onTagFocus: this.handleTagsFocus,
            onTagBlur: this.handleTagsBlur,
            onTagClick: this.searchByTag,
            tags: tags })
        )
      );
    }
  }, {
    key: 'noSearchResults',
    get: function get() {
      var _state2 = this.state,
          searchBarValue = _state2.searchBarValue,
          searchLayout = _state2.searchLayout;


      if (!this.hasNoSearchResults || searchLayout && !searchBarValue) {
        return null;
      }

      return React.createElement(__WEBPACK_IMPORTED_MODULE_52_widget_components_empty_search_results_empty_search_results__["a" /* default */], null);
    }
  }, {
    key: 'videosList',
    get: function get() {
      var _props4 = this.props,
          channelData = _props4.channelData,
          searchQuery = _props4.searchQuery,
          currentSiteUser = _props4.currentSiteUser,
          videoIdsByPageNumber = _props4.videoIdsByPageNumber,
          currentVideosPageNumber = _props4.currentVideosPageNumber,
          videosPerPage = _props4.videosPerPage,
          isVideosFetching = _props4.isVideosFetching;
      var searchLayout = this.state.searchLayout;


      var searchBlockShown = searchLayout && !searchQuery && this.tagList.length;

      var noVideosLoaded = !videoIdsByPageNumber.length;

      if (!isVideosFetching && channelData.videosCount === 0) {
        return React.createElement(
          'div',
          { styleName: 'coming-soon' },
          React.createElement(__WEBPACK_IMPORTED_MODULE_10_react_intl__["a" /* FormattedMessage */], __WEBPACK_IMPORTED_MODULE_55_widget_translations__["a" /* default */].thisChannelIsComingSoon)
        );
      }

      if (isVideosFetching && noVideosLoaded || !this.mainVideo || searchBlockShown) {
        return null;
      }

      return React.createElement(__WEBPACK_IMPORTED_MODULE_46_widget_views_desktop_classic_components_videos_videos__["a" /* default */], { styleName: 'videos',
        containerWidth: this.playerSize.width,
        videoIdsByPageNumber: videoIdsByPageNumber,
        currentVideosPageNumber: currentVideosPageNumber,
        onSlideToNext: this.handleSlideToNext,
        onSlideToPrev: this.handleSlideToPrev,
        channelData: channelData,
        currentSiteUser: currentSiteUser,
        videosPerPage: videosPerPage,
        onThumbnailClick: this.handleThumbnailClick,
        thumbnailSize: this.listThumbnailSize,
        isSelectedVideoIndicationDisabled: this.isChannelCoverShown });
    }
  }, {
    key: 'search',
    get: function get() {
      var _props5 = this.props,
          isSearchInputVisible = _props5.isSearchInputVisible,
          searchQuery = _props5.searchQuery;


      if (!isSearchInputVisible) {
        return null;
      }

      var value = this.isCategorySelected ? '' : searchQuery;

      return React.createElement(__WEBPACK_IMPORTED_MODULE_45_widget_components_search_bar_search_bar__["a" /* ClassicSearchBar */], { value: value,
        onFocus: this.handleSearchInputFocus,
        onBlur: this.handleSearchInputBlur,
        onChange: this.setSearchBarValue,
        onSearch: this.searchByQuery,
        onClose: this.clearSearch,
        styleName: 'search' });
    }
  }, {
    key: 'categories',
    get: function get() {
      var _props6 = this.props,
          isCategoriesDropdownVisible = _props6.isCategoriesDropdownVisible,
          searchQuery = _props6.searchQuery;


      if (!isCategoriesDropdownVisible) {
        return null;
      }

      var _state3 = this.state,
          searchLayout = _state3.searchLayout,
          currentCategory = _state3.currentCategory,
          searchBarValue = _state3.searchBarValue;


      if (searchLayout || !this.isCategorySelected && (searchBarValue || searchQuery)) {
        return null;
      }

      return React.createElement(__WEBPACK_IMPORTED_MODULE_43_widget_components_categories_categories__["a" /* default */], { styleName: 'categories',
        list: this.categoriesList,
        onCategorySelect: this.searchByCategory,
        selectedCategory: currentCategory });
    }
  }, {
    key: 'content',
    get: function get() {
      var styleNames = __WEBPACK_IMPORTED_MODULE_9_classnames___default()('content', {
        'no-search-bar': !this.props.isSearchBarVisible
      });

      return React.createElement(
        'section',
        { styleName: styleNames,
          className: 'qa-widget-content' },
        React.createElement(
          'div',
          { styleName: 'search-line',
            className: 'qa-widget-search-line' },
          this.search,
          this.categories
        ),
        this.tags,
        this.videosList,
        this.noSearchResults
      );
    }
  }, {
    key: 'channelTitle',
    get: function get() {
      var _props7 = this.props,
          channelData = _props7.channelData,
          appSettings = _props7.appSettings;

      return appSettings.booleans.showChannelTitle ? channelData.title : null;
    }
  }, {
    key: 'signInButton',
    get: function get() {
      var _props8 = this.props,
          isSignInVisible = _props8.isSignInVisible,
          channelData = _props8.channelData;


      if (!isSignInVisible) {
        return null;
      }

      return React.createElement(__WEBPACK_IMPORTED_MODULE_40_widget_components_account_account_button_account_button__["a" /* default */], { styleName: 'action',
        className: 'qa-widget-channel-account',
        tooltipSide: 'bottom',
        infoButtonClassName: __WEBPACK_IMPORTED_MODULE_54__classic_styl___default.a['account-button'],
        channelData: channelData,
        onClick: this.openAccountInfoAtOverlay,
        onLoginClick: this.showLogInForm,
        onLogoutClick: this.logOut,
        onSubscribeClick: this.openSubscription,
        onSubscriptionCancelClick: this.processSubscriptionCancel });
    }
  }, {
    key: 'header',
    get: function get() {
      var _props9 = this.props,
          appSettings = _props9.appSettings,
          channelData = _props9.channelData;

      var styleNames = __WEBPACK_IMPORTED_MODULE_9_classnames___default()('header', {
        'empty-header': !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_shared_utils_layout_helpers__["a" /* isClassicLayoutHeaderVisible */])(appSettings, channelData)
      });
      var channelTitle = this.channelTitle;

      return React.createElement(
        'section',
        { styleName: styleNames,
          className: 'qa-widget-header' },
        React.createElement(
          'div',
          { styleName: 'channel-name',
            title: channelTitle },
          channelTitle
        ),
        React.createElement(__WEBPACK_IMPORTED_MODULE_39_widget_components_share_channel_share_channel__["b" /* default */], { styleName: 'action',
          channelData: channelData }),
        React.createElement(__WEBPACK_IMPORTED_MODULE_41_widget_components_channel_actions_channel_info_button__["a" /* default */], { styleName: 'action',
          channelData: channelData,
          onClick: this.showChannelInfo }),
        React.createElement(__WEBPACK_IMPORTED_MODULE_42_widget_components_channel_actions_channel_subscription_button__["a" /* default */], { styleName: 'action',
          channelData: channelData,
          onClick: this.openSubscription }),
        this.signInButton
      );
    }
  }, {
    key: 'player',
    get: function get() {
      var videoItem = this.mainVideo;

      if (videoItem) {
        return this.renderPlayerForCurrentDevice(videoItem);
      }
      return this.noVideosPlayerContent;
    }
  }, {
    key: 'noVideoPlayerOverlay',
    get: function get() {
      var _props10 = this.props,
          appSettings = _props10.appSettings,
          channelData = _props10.channelData;


      var props = {
        appSettings: appSettings,
        channelData: channelData,
        showChannelCover: true,
        videoItem: {}
      };

      return React.createElement(__WEBPACK_IMPORTED_MODULE_47_widget_components_player_overlay_classic_center__["a" /* default */], props);
    }
  }, {
    key: 'playerOverlay',
    get: function get() {
      var videoItem = this.mainVideo;
      var _props11 = this.props,
          appSettings = _props11.appSettings,
          channelData = _props11.channelData;

      var props = {
        appSettings: appSettings,
        channelData: channelData,
        videoItem: videoItem,
        showChannelCover: this.canShowChannelCover,
        nextVideoId: this.props.nextVideoId,
        playSelectedVideo: this.playSelectedVideo,
        playNextVideo: this.playNextVideo
      };

      return React.createElement(__WEBPACK_IMPORTED_MODULE_47_widget_components_player_overlay_classic_center__["a" /* default */], props);
    }
  }]);

  return ClassicView;
}(__WEBPACK_IMPORTED_MODULE_35_widget_views_base__["a" /* default */]), _class3.displayName = 'ClassicView', _class3.propTypes = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_35_widget_views_base__["a" /* default */].propTypes, {
  isSearchBarVisible: React.PropTypes.bool,
  isSearchInputVisible: React.PropTypes.bool,
  isCategoriesDropdownVisible: React.PropTypes.bool,
  isSignInVisible: React.PropTypes.bool,
  videosPerPage: React.PropTypes.number,
  searchQuery: React.PropTypes.string,
  searchQueryField: React.PropTypes.string
}), _temp), (_applyDecoratedDescriptor(_class2.prototype, 'setUtmostWidgetSize', [__WEBPACK_IMPORTED_MODULE_11_core_decorators_lib_autobind___default.a, __WEBPACK_IMPORTED_MODULE_12_core_decorators_lib_debounce___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'setUtmostWidgetSize'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'reset', [__WEBPACK_IMPORTED_MODULE_11_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'reset'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleThumbnailClick', [__WEBPACK_IMPORTED_MODULE_11_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handleThumbnailClick'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'scrollToWidgetTop', [__WEBPACK_IMPORTED_MODULE_11_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'scrollToWidgetTop'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleSlideToPrev', [__WEBPACK_IMPORTED_MODULE_11_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handleSlideToPrev'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleSlideToNext', [__WEBPACK_IMPORTED_MODULE_11_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handleSlideToNext'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'showChannelInfo', [__WEBPACK_IMPORTED_MODULE_11_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'showChannelInfo'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'openSubscription', [__WEBPACK_IMPORTED_MODULE_11_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'openSubscription'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'openMemberOnly', [__WEBPACK_IMPORTED_MODULE_11_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'openMemberOnly'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'storeDataForReload', [__WEBPACK_IMPORTED_MODULE_11_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'storeDataForReload'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'processDataFromStorage', [__WEBPACK_IMPORTED_MODULE_11_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'processDataFromStorage'), _class2.prototype)), _class2)) || _class) || _class);


/***/ }),
/* 2531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VideoListItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_widget_components_thumbnail_thumbnail__ = __webpack_require__(2521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__video_list_item_styl__ = __webpack_require__(3280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__video_list_item_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__video_list_item_styl__);







var _dec, _class, _class2, _temp;








var VideoListItem = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_9__video_list_item_styl___default.a), _dec(_class = (_temp = _class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(VideoListItem, _React$Component);

  function VideoListItem() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, VideoListItem);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (VideoListItem.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(VideoListItem)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(VideoListItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          channelData = _props.channelData,
          videoItem = _props.videoItem,
          width = _props.width,
          height = _props.height,
          onClick = _props.onClick,
          isSelected = _props.isSelected,
          isPlaying = _props.isPlaying,
          isLastInRow = _props.isLastInRow;


      return React.createElement(
        'div',
        { styleName: 'video-list-item',
          className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_9__video_list_item_styl___default.a['is-last'], isLastInRow)),
          style: { width: width } },
        React.createElement(__WEBPACK_IMPORTED_MODULE_8_widget_components_thumbnail_thumbnail__["a" /* ClickableThumbnail */], { width: width,
          height: height,
          onClick: onClick,
          isSelected: isSelected,
          nowPlaying: isSelected && isPlaying,
          channelData: channelData,
          videoItem: videoItem,
          dataHook: 'videoListThumbWrapper' })
      );
    }
  }]);

  return VideoListItem;
}(React.Component), _class2.propTypes = {
  className: React.PropTypes.string,
  onClick: React.PropTypes.func,

  isPlaying: React.PropTypes.bool,
  isSelected: React.PropTypes.bool,
  isLastInRow: React.PropTypes.bool,

  channelData: React.PropTypes.object,
  videoItem: React.PropTypes.object,

  width: React.PropTypes.number,
  height: React.PropTypes.number
}, _temp)) || _class);


/***/ }),
/* 2532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Videos; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_selectors_videos__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_widget_selectors_video_playback_status__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_widget_ui_selectors_selected_video_id__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_selectors_app_settings__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_shared_bi_bi__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_widget_data_components_paginated_channel_videos__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_widget_components_content_slider_content_slider__ = __webpack_require__(1827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_widget_components_page_list_page_list__ = __webpack_require__(1829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_widget_components_videos_list_nav_button_nav_button__ = __webpack_require__(2523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_widget_views_desktop_classic_components_videos_video_list_item_video_list_item__ = __webpack_require__(2531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__videos_styl__ = __webpack_require__(3281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__videos_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__videos_styl__);








var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}




















var Videos = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_redux__["a" /* connect */])(function (state) {
  return {
    videoByIds: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_shared_selectors_videos__["a" /* getVideosGroupedByIds */])(state),
    isVideoPlaying: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_widget_selectors_video_playback_status__["a" /* isVideoPlayingOptimistic */])(state),
    selectedVideoId: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_widget_ui_selectors_selected_video_id__["a" /* getMainVideoId */])(state, __WEBPACK_IMPORTED_MODULE_15_widget_data_components_paginated_channel_videos__["a" /* DATA_KEY */]),
    videosInRow: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_shared_selectors_app_settings__["v" /* getVideosInRowCount */])(state)
  };
}), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_20__videos_styl___default.a), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Videos, _React$Component);

  function Videos() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Videos);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Videos.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Videos)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Videos, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var currentVideosPageNumber = _ref.currentVideosPageNumber;

      if (currentVideosPageNumber !== this.props.currentVideosPageNumber) {
        __WEBPACK_IMPORTED_MODULE_14_shared_bi_bi__["a" /* default */].logWidgetSystem('videoList.changePage.rendered', { previousEventName: 'videoList.changePage.requested' });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      __WEBPACK_IMPORTED_MODULE_14_shared_bi_bi__["a" /* default */].logWidgetSystem('videoList.searchByQuery.rendered', {
        previousEventName: 'videoList.searchByQuery.requested'
      });
      __WEBPACK_IMPORTED_MODULE_14_shared_bi_bi__["a" /* default */].logWidgetSystem('videoList.searchByTag.rendered', {
        previousEventName: 'videoList.searchByTag.requested'
      });
      __WEBPACK_IMPORTED_MODULE_14_shared_bi_bi__["a" /* default */].logWidgetSystem('videoList.searchByCategory.rendered', {
        previousEventName: 'videoList.searchByCategory.requested'
      });
    }
  }, {
    key: 'renderVideoItem',
    value: function renderVideoItem(videoId, videoIndex) {
      var _props = this.props,
          channelData = _props.channelData,
          videoByIds = _props.videoByIds,
          thumbnailSize = _props.thumbnailSize,
          onThumbnailClick = _props.onThumbnailClick,
          selectedVideoId = _props.selectedVideoId,
          isSelectedVideoIndicationDisabled = _props.isSelectedVideoIndicationDisabled,
          isVideoPlaying = _props.isVideoPlaying,
          videosInRow = _props.videosInRow;


      var videoItem = videoByIds[videoId];
      var isVideoSelected = selectedVideoId === videoId && !isSelectedVideoIndicationDisabled;
      var isLastInRow = (videoIndex + 1) % videosInRow === 0;

      return React.createElement(__WEBPACK_IMPORTED_MODULE_19_widget_views_desktop_classic_components_videos_video_list_item_video_list_item__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, thumbnailSize, {
        onClick: onThumbnailClick,
        channelData: channelData,
        videoItem: videoItem,
        isLastInRow: isLastInRow,
        isSelected: isVideoSelected,
        isPlaying: isVideoPlaying,
        key: videoId }));
    }
  }, {
    key: 'hasPage',
    value: function hasPage(pageNum) {
      var videoIdsByPageNumber = this.props.videoIdsByPageNumber;

      return Boolean(videoIdsByPageNumber[pageNum]);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          currentVideosPageNumber = _props2.currentVideosPageNumber,
          videoIdsByPageNumber = _props2.videoIdsByPageNumber,
          containerWidth = _props2.containerWidth,
          className = _props2.className,
          onSlideToNext = _props2.onSlideToNext,
          onSlideToPrev = _props2.onSlideToPrev;


      return React.createElement(
        'section',
        { styleName: 'container',
          className: className },
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_16_widget_components_content_slider_content_slider__["a" /* default */],
          { styleName: 'slider-container',
            width: containerWidth,
            currentPageNumber: currentVideosPageNumber },
          React.createElement(__WEBPACK_IMPORTED_MODULE_17_widget_components_page_list_page_list__["a" /* default */], { pageWidth: containerWidth,
            currentPageNumber: currentVideosPageNumber,
            itemsByPageNumber: videoIdsByPageNumber,
            renderItem: this.renderVideoItem })
        ),
        React.createElement(
          'div',
          { styleName: 'buttons' },
          React.createElement(__WEBPACK_IMPORTED_MODULE_18_widget_components_videos_list_nav_button_nav_button__["a" /* PrevButton */], { disabled: !this.isPrevPageVisible,
            onClick: onSlideToPrev }),
          React.createElement(__WEBPACK_IMPORTED_MODULE_18_widget_components_videos_list_nav_button_nav_button__["b" /* NextButton */], { disabled: !this.isNextPageVisible,
            onClick: onSlideToNext })
        )
      );
    }
  }, {
    key: 'isPrevPageVisible',
    get: function get() {
      var currentVideosPageNumber = this.props.currentVideosPageNumber;

      return this.hasPage(currentVideosPageNumber - 1);
    }
  }, {
    key: 'isNextPageVisible',
    get: function get() {
      var currentVideosPageNumber = this.props.currentVideosPageNumber;

      return this.hasPage(currentVideosPageNumber + 1);
    }
  }]);

  return Videos;
}(React.Component), _class3.propTypes = {
  className: React.PropTypes.string,

  channelData: React.PropTypes.object,

  containerWidth: React.PropTypes.number,

  videoByIds: React.PropTypes.object,
  videoIdsByPageNumber: React.PropTypes.array,

  thumbnailSize: React.PropTypes.shape({
    width: React.PropTypes.number,
    height: React.PropTypes.number
  }),

  videosInRow: React.PropTypes.number,
  videosPerPage: React.PropTypes.number,

  onSlideToPrev: React.PropTypes.func,
  onSlideToNext: React.PropTypes.func,
  onThumbnailClick: React.PropTypes.func,

  selectedVideoId: React.PropTypes.string,
  isSelectedVideoIndicationDisabled: React.PropTypes.bool,
  isVideoPlaying: React.PropTypes.bool,

  currentVideosPageNumber: React.PropTypes.number
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'renderVideoItem', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'renderVideoItem'), _class2.prototype)), _class2)) || _class) || _class);


/***/ }),
/* 2533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChannelActionCallbacks; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_bi_bi__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_widget_utils_not_for_preview__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_utils_open_overlay__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_widget_utils_payments__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_selectors_app_settings__ = __webpack_require__(42);







var _dec, _class, _desc, _value, _class2, _class3, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}












var ChannelActionCallbacks = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["a" /* connect */])(function (store) {
  return {
    siteUrl: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_shared_selectors_app_settings__["f" /* getSiteUrl */])(store),
    instance: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_shared_selectors_app_settings__["m" /* getInstance */])(store)
  };
}), _dec(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ChannelActionCallbacks, _React$Component);

  function ChannelActionCallbacks() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ChannelActionCallbacks);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ChannelActionCallbacks.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(ChannelActionCallbacks)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ChannelActionCallbacks, [{
    key: 'showChannelInfoAtOverlay',
    value: function showChannelInfoAtOverlay() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_shared_utils_open_overlay__["f" /* openFullScreenChannelOverlay */])(this.props.channelId);
    }
  }, {
    key: 'showChannelSubscriptionInfoAtOverlay',
    value: function showChannelSubscriptionInfoAtOverlay() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_shared_utils_open_overlay__["c" /* openFullScreenSubscribeOverlay */])(this.props.channelId);
    }
  }, {
    key: 'cancelChannelSubscription',
    value: function cancelChannelSubscription() {
      var _props = this.props,
          siteUrl = _props.siteUrl,
          instance = _props.instance,
          channelId = _props.channelId;

      __WEBPACK_IMPORTED_MODULE_8_shared_bi_bi__["a" /* default */].logWidgetSystem('channel.unsubscribe.requested');
      __WEBPACK_IMPORTED_MODULE_11_widget_utils_payments__["a" /* default */].cancelSubscription(channelId, siteUrl, instance);
    }
  }, {
    key: 'render',
    value: function render() {
      return React.cloneElement(this.props.children, {
        onInfoRequest: this.showChannelInfoAtOverlay,
        onSubscriptionRequest: this.showChannelSubscriptionInfoAtOverlay,
        onSubscriptionCancelRequest: this.cancelChannelSubscription
      });
    }
  }]);

  return ChannelActionCallbacks;
}(React.Component), _class3.propTypes = {
  children: React.PropTypes.element.isRequired,
  channelId: React.PropTypes.string,
  siteUrl: React.PropTypes.string,
  instance: React.PropTypes.string
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'showChannelInfoAtOverlay', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'showChannelInfoAtOverlay'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'showChannelSubscriptionInfoAtOverlay', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a, __WEBPACK_IMPORTED_MODULE_9_widget_utils_not_for_preview__["a" /* notForPreview */]], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'showChannelSubscriptionInfoAtOverlay'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'cancelChannelSubscription', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a, __WEBPACK_IMPORTED_MODULE_9_widget_utils_not_for_preview__["a" /* notForPreview */]], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'cancelChannelSubscription'), _class2.prototype)), _class2)) || _class);


/***/ }),
/* 2534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InFrameMobileActionCallbacks; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_bi_send_bi_event__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_widget_utils_decorate__ = __webpack_require__(2015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_widget_redux_client_actions_change_playback_status__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_widget_redux_client_actions_select_video__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__in_frame__ = __webpack_require__(1838);








var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}











var InFrameMobileActionCallbacks = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_redux__["a" /* connect */])(null, {
  playVideo: __WEBPACK_IMPORTED_MODULE_11_widget_redux_client_actions_change_playback_status__["a" /* playVideo */],
  selectVideo: __WEBPACK_IMPORTED_MODULE_12_widget_redux_client_actions_select_video__["a" /* selectVideo */]
}), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_widget_utils_decorate__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_13__in_frame__["a" /* default */]), _dec3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_shared_bi_send_bi_event__["a" /* withBiEvent */])('widget.vid.clicked', function () {
  var _props = this.props,
      channelId = _props.channelId,
      videoId = _props.videoId,
      videoSource = _props.videoSource;


  return {
    channelID: channelId,
    videoID: videoId,
    videoType: videoSource
  };
}), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(InFrameMobileActionCallbacks, _React$Component);

  function InFrameMobileActionCallbacks() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, InFrameMobileActionCallbacks);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (InFrameMobileActionCallbacks.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(InFrameMobileActionCallbacks)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(InFrameMobileActionCallbacks, [{
    key: 'selectVideo',
    value: function selectVideo() {
      var _props2 = this.props,
          selectVideo = _props2.selectVideo,
          videoId = _props2.videoId;

      selectVideo(videoId);
    }
  }, {
    key: 'playVideo',
    value: function playVideo() {
      var _props3 = this.props,
          playVideo = _props3.playVideo,
          videoId = _props3.videoId;

      playVideo(videoId);
    }
  }, {
    key: 'handlePlayRequest',
    value: function handlePlayRequest() {
      var _props4 = this.props,
          isMainVideo = _props4.isMainVideo,
          onBeforePlayRequested = _props4.onBeforePlayRequested,
          onBeforeClick = _props4.onBeforeClick;

      var handler = isMainVideo ? _.flow(onBeforePlayRequested, this.playVideo) : _.flow(onBeforeClick, this.selectVideo);

      handler();
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;

      var inFrameActions = _.omit(this.props, this.propTypes);

      return React.cloneElement(children, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, inFrameActions, {
        onPlayRequest: this.handlePlayRequest
      }));
    }
  }]);

  return InFrameMobileActionCallbacks;
}(React.Component), _class3.propTypes = {
  children: React.PropTypes.element.isRequired,
  selectVideo: React.PropTypes.func.isRequired,
  playVideo: React.PropTypes.func.isRequired,
  onBeforeClick: React.PropTypes.func,
  onBeforePlayRequested: React.PropTypes.func,
  channelId: React.PropTypes.string,
  videoId: React.PropTypes.string,
  videoSource: React.PropTypes.string,
  isMainVideo: React.PropTypes.bool
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'selectVideo', [__WEBPACK_IMPORTED_MODULE_9_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'selectVideo'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'playVideo', [__WEBPACK_IMPORTED_MODULE_9_core_decorators_lib_autobind___default.a, _dec3], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'playVideo'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handlePlayRequest', [__WEBPACK_IMPORTED_MODULE_9_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handlePlayRequest'), _class2.prototype)), _class2)) || _class) || _class);


/***/ }),
/* 2535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InOverlayActionCallbacks; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_bi_send_bi_event__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_widget_utils_decorate__ = __webpack_require__(2015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_widget_utils_not_for_preview__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_widget_redux_client_actions_select_video__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_utils_open_overlay__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__in_frame__ = __webpack_require__(1838);








var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}













// In Expanded View mode click on a thumbnail should select video in widget, not show overlay.
// Overlay is only used to play videos in compact layout.
var InOverlayActionCallbacks = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_redux__["a" /* connect */])(null, {
  selectVideo: __WEBPACK_IMPORTED_MODULE_12_widget_redux_client_actions_select_video__["a" /* selectVideo */]
}), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_widget_utils_decorate__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_14__in_frame__["a" /* default */]), _dec3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_shared_bi_send_bi_event__["a" /* withBiEvent */])('widget.vid.clicked', function () {
  var _props = this.props,
      channelId = _props.channelId,
      videoId = _props.videoId,
      videoSource = _props.videoSource;


  return {
    channelID: channelId,
    videoID: videoId,
    videoType: videoSource
  };
}), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(InOverlayActionCallbacks, _React$Component);

  function InOverlayActionCallbacks() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, InOverlayActionCallbacks);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (InOverlayActionCallbacks.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(InOverlayActionCallbacks)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(InOverlayActionCallbacks, [{
    key: 'showVideoAtOverlay',
    value: function showVideoAtOverlay() {
      var _props2 = this.props,
          channelId = _props2.channelId,
          videoId = _props2.videoId;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_shared_utils_open_overlay__["a" /* openFullScreenOverlay */])('#/channel/' + channelId + '/video/' + videoId);
    }
  }, {
    key: 'playVideoAtOverlay',
    value: function playVideoAtOverlay() {
      var _props3 = this.props,
          channelId = _props3.channelId,
          videoId = _props3.videoId;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_shared_utils_open_overlay__["a" /* openFullScreenOverlay */])('#/channel/' + channelId + '/video/' + videoId + '?autoplay=true');
    }
  }, {
    key: 'render',
    value: function render() {
      var inFrameActions = _.omit(this.props, this.propTypes);

      return React.cloneElement(this.props.children, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, inFrameActions, {
        onPlayRequest: this.playVideoAtOverlay,
        onPlayWithoutPreviewRequest: this.showVideoAtOverlay
      }));
    }
  }]);

  return InOverlayActionCallbacks;
}(React.Component), _class3.propTypes = {
  children: React.PropTypes.element.isRequired,
  channelId: React.PropTypes.string,
  videoId: React.PropTypes.string,
  videoSource: React.PropTypes.string,

  selectVideo: React.PropTypes.func,
  onSelectOrPlay: React.PropTypes.func
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'showVideoAtOverlay', [__WEBPACK_IMPORTED_MODULE_9_core_decorators_lib_autobind___default.a, __WEBPACK_IMPORTED_MODULE_11_widget_utils_not_for_preview__["a" /* notForPreview */]], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'showVideoAtOverlay'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'playVideoAtOverlay', [__WEBPACK_IMPORTED_MODULE_9_core_decorators_lib_autobind___default.a, _dec3, __WEBPACK_IMPORTED_MODULE_11_widget_utils_not_for_preview__["a" /* notForPreview */]], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'playVideoAtOverlay'), _class2.prototype)), _class2)) || _class) || _class);


/***/ }),
/* 2536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PlayerActionCallbacks; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_widget_utils_not_for_preview__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_utils_open_overlay__ = __webpack_require__(258);







var _desc, _value, _class, _class2, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}







var PlayerActionCallbacks = (_class = (_temp = _class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(PlayerActionCallbacks, _React$Component);

  function PlayerActionCallbacks() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, PlayerActionCallbacks);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PlayerActionCallbacks.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(PlayerActionCallbacks)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(PlayerActionCallbacks, [{
    key: 'showPurchaseInfoAtOverlay',
    value: function showPurchaseInfoAtOverlay() {
      var _props = this.props,
          channelId = _props.channelId,
          videoId = _props.videoId;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_shared_utils_open_overlay__["d" /* openFullScreenPurchaseOverlay */])(channelId, videoId);
    }
  }, {
    key: 'showChannelSubscriptionInfoAtOverlay',
    value: function showChannelSubscriptionInfoAtOverlay() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_shared_utils_open_overlay__["c" /* openFullScreenSubscribeOverlay */])(this.props.channelId);
    }
  }, {
    key: 'render',
    value: function render() {
      return React.cloneElement(this.props.children, {
        // TODO: rename to onPurchaseRequest and onSubscriptionRequest
        onPurchaseClick: this.showPurchaseInfoAtOverlay,
        onSubscribeClick: this.showChannelSubscriptionInfoAtOverlay
      });
    }
  }]);

  return PlayerActionCallbacks;
}(React.Component), _class2.propTypes = {
  children: React.PropTypes.element.isRequired,
  channelId: React.PropTypes.string,
  videoId: React.PropTypes.string
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'showPurchaseInfoAtOverlay', [__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default.a, __WEBPACK_IMPORTED_MODULE_7_widget_utils_not_for_preview__["a" /* notForPreview */]], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'showPurchaseInfoAtOverlay'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'showChannelSubscriptionInfoAtOverlay', [__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default.a, __WEBPACK_IMPORTED_MODULE_7_widget_utils_not_for_preview__["a" /* notForPreview */]], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class.prototype, 'showChannelSubscriptionInfoAtOverlay'), _class.prototype)), _class);


/***/ }),
/* 2537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CompactView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_bi_send_bi_event__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_analytics_new_relic__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_selectors_app_settings__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_widget_components_overlay_texts_channel_subscribe_button_text__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_shared_utils_open_overlay__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_shared_utils_device_screen__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_widget_utils_videos_sizes__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_widget_ui_selectors_selected_video_id__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_widget_ui_selectors_video_access__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_widget_selectors_video_playback_status__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_shared_selectors_videos__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_widget_selectors_current_site_user__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_widget_views_desktop_compact_ui_selectors_ui_selectors__ = __webpack_require__(2556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_widget_data_components_paginated_channel_videos__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_shared_constants_compact_layout__ = __webpack_require__(1987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_shared_constants_stats_events__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_widget_redux_client_actions_select_video__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_widget_redux_client_actions_change_playback_status__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_widget_redux_server_actions_stats_report__ = __webpack_require__(1212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_widget_components_preview_prompt_preview_prompt__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_shared_bi_bi__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_widget_views_base__ = __webpack_require__(1553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_widget_data_components_update_widget_size__ = __webpack_require__(1551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_shared_components_payment_events_payment_events__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_widget_components_reload_storage_reload_storage__ = __webpack_require__(1549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_widget_views_desktop_compact_components_resize_widget_by_content_resize_widget_by_content__ = __webpack_require__(2550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_widget_components_players_mobile_player__ = __webpack_require__(1260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_widget_components_players_desktop_player__ = __webpack_require__(1583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_widget_views_desktop_compact_components_videos_videos__ = __webpack_require__(2554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_widget_views_desktop_compact_components_closable_overlay_closable_overlay__ = __webpack_require__(2540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_widget_views_desktop_compact_components_share_channel_share_channel__ = __webpack_require__(2551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_widget_views_desktop_compact_components_player_overlay_overlay__ = __webpack_require__(2016);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_widget_views_desktop_compact_components_channel_actions_channel_actions__ = __webpack_require__(2539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_widget_views_desktop_compact_components_action_bar_action_bar__ = __webpack_require__(2538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_widget_components_nav_nav__ = __webpack_require__(1728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_widget_components_animate_crossfade_animate_crossfade__ = __webpack_require__(2496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__actions_overlay_action_callbacks_in_frame__ = __webpack_require__(1838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__actions_overlay_action_callbacks_in_frame_mobile__ = __webpack_require__(2534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__actions_overlay_action_callbacks_in_overlay__ = __webpack_require__(2535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__actions_channel_action_callbacks__ = __webpack_require__(2533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__actions_player_action_callbacks__ = __webpack_require__(2536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_widget_views_desktop_compact_components_animate_animate__ = __webpack_require__(1292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__compact_styl__ = __webpack_require__(3282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__compact_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__compact_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_static_images_action_bar_arrow_right_svg__ = __webpack_require__(2692);








var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class, _desc, _value, _class2, _class3, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}






























































var DEFAULT_STATE = {
  areAllVideosVisible: false,
  isShareOverlayVisible: false,
  isInFullScreen: false
};

var IS_MOBILE_DEVICE = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_shared_utils_device_screen__["a" /* isMobile */])() || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_shared_utils_device_screen__["b" /* isTablet */])();
var MIN_WIDGET_WIDTH = 400;
var MAX_WIDGET_WIDTH = 980;

var ACTION_BAR_OPENED_HEIGHT = 60;
var ACTION_BAR_CLOSED_HEIGHT = 40;

function OverlayActionsCallbacks(store) {
  if (IS_MOBILE_DEVICE) {
    return __WEBPACK_IMPORTED_MODULE_47__actions_overlay_action_callbacks_in_frame_mobile__["a" /* default */];
  }

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_shared_selectors_app_settings__["x" /* isCompactPlayInFrame */])(store)) {
    return __WEBPACK_IMPORTED_MODULE_46__actions_overlay_action_callbacks_in_frame__["a" /* default */];
  }

  return __WEBPACK_IMPORTED_MODULE_48__actions_overlay_action_callbacks_in_overlay__["a" /* default */];
}

var CompactView = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_react_redux__["a" /* connect */])(function (store, ownProps) {
  return {
    isVideoPaused: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19_widget_selectors_video_playback_status__["b" /* isVideoPausedOptimistic */])(store),
    isVideoPlaying: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19_widget_selectors_video_playback_status__["a" /* isVideoPlayingOptimistic */])(store),
    isPlayInFrame: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_shared_selectors_app_settings__["x" /* isCompactPlayInFrame */])(store),
    mainVideoId: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17_widget_ui_selectors_selected_video_id__["a" /* getMainVideoId */])(store, __WEBPACK_IMPORTED_MODULE_23_widget_data_components_paginated_channel_videos__["a" /* DATA_KEY */]),
    selectedVideoId: store.selectedVideoId,

    videoIdsByPageNumber: ownProps.paginatedChannelVideos.idChunks,
    currentVideosPageNumber: ownProps.paginatedChannelVideos.currentUIPage,
    goToPrevVideosPage: ownProps.paginatedChannelVideos.goBack,
    goToNextVideosPage: ownProps.paginatedChannelVideos.goForward,
    goToFirstVideosPage: ownProps.paginatedChannelVideos.toFirstPage,

    prevVideoId: ownProps.nextChannelVideos.prevId,
    nextVideoId: ownProps.nextChannelVideos.nextId,
    loadedVideoIds: ownProps.nextChannelVideos.loadedVideoIds,
    currentIdIndex: ownProps.nextChannelVideos.currentIdIndex,

    videoByIds: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_shared_selectors_videos__["a" /* getVideosGroupedByIds */])(store),
    fetchVideos: ownProps.paginatedChannelVideos.fetch,
    isVideosFetching: ownProps.paginatedChannelVideos.isFetching,

    appSettings: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_shared_selectors_app_settings__["a" /* getAllSettings */])(store),
    siteUrl: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_shared_selectors_app_settings__["f" /* getSiteUrl */])(store),
    requestedWidgetSize: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_shared_selectors_app_settings__["e" /* getRequestedWidgetSize */])(store),

    currentSiteUser: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_widget_selectors_current_site_user__["a" /* getCurrentSiteUser */])(store),
    canShowChannelCover: !store.isVideosTouched,
    canShowChannelInfo: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_shared_selectors_app_settings__["o" /* canShowChannelInfo */])(store),
    canShowChannelShare: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_shared_selectors_app_settings__["s" /* canShowChannelShare */])(store),
    canShowVideoList: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_shared_selectors_app_settings__["u" /* canShowVideoList */])(store),
    canShowSignIn: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_shared_selectors_app_settings__["n" /* canShowSignIn */])(store),
    canShowSubscriptionButton: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_widget_components_overlay_texts_channel_subscribe_button_text__["a" /* isVisible */])({ channel: ownProps.channelData }),
    isPreviewHover: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_shared_selectors_app_settings__["y" /* isPreviewHover */])(store),
    isVideoListPreviewHover: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_shared_selectors_app_settings__["z" /* isVideoListPreviewHover */])(store),
    isActionBarVisible: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_widget_views_desktop_compact_ui_selectors_ui_selectors__["a" /* isActionBarVisible */])(store),

    OverlayActionsCallbacks: OverlayActionsCallbacks(store)
  };
}, {
  selectVideo: __WEBPACK_IMPORTED_MODULE_26_widget_redux_client_actions_select_video__["a" /* selectVideo */],
  playVideo: __WEBPACK_IMPORTED_MODULE_27_widget_redux_client_actions_change_playback_status__["a" /* playVideo */],
  pauseVideo: __WEBPACK_IMPORTED_MODULE_27_widget_redux_client_actions_change_playback_status__["e" /* pauseVideo */],
  resetSelectedVideo: __WEBPACK_IMPORTED_MODULE_26_widget_redux_client_actions_select_video__["b" /* resetSelectedVideo */],
  resetPlaybackStatus: __WEBPACK_IMPORTED_MODULE_27_widget_redux_client_actions_change_playback_status__["d" /* resetPlaybackStatus */],
  reportStats: __WEBPACK_IMPORTED_MODULE_28_widget_redux_server_actions_stats_report__["a" /* default */]
}), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_shared_utils_wix_connect__["c" /* VODBiEvents */])(), _dec3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_52__compact_styl___default.a), _dec4 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_shared_bi_send_bi_event__["a" /* withBiEvent */])('widget.actionBar.open.click'), _dec5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_shared_bi_send_bi_event__["a" /* withBiEvent */])('widget.share.clicked', function (networkName) {
  return {
    typeShare: networkName
  };
}), _dec6 = __WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default()(), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = (_temp = _class3 = function (_BaseView) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(CompactView, _BaseView);

  function CompactView(props) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, CompactView);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CompactView.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(CompactView)).call(this, props));

    _this.state = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, DEFAULT_STATE, {
      isInitialVideosLoaded: false
    });

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_shared_analytics_new_relic__["a" /* getNewRelic */])().setCustomAttribute('layout', 'compact');
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(CompactView, [{
    key: 'reset',
    value: function reset() {
      this.setState(DEFAULT_STATE);
      this.props.resetSelectedVideo();
      this.props.goToFirstVideosPage();
    }
  }, {
    key: 'showAllVideos',
    value: function showAllVideos() {
      this.props.resetPlaybackStatus();
      this.setState({
        areAllVideosVisible: true
      });
      __WEBPACK_IMPORTED_MODULE_30_shared_bi_bi__["a" /* default */].logWidgetSystem('videoList.show.requested');
    }
  }, {
    key: 'hideAllVideos',
    value: function hideAllVideos() {
      this.setState({
        areAllVideosVisible: false
      });
    }
  }, {
    key: 'toggleShareOverlay',
    value: function toggleShareOverlay() {
      this.setState({
        isShareOverlayVisible: !this.state.isShareOverlayVisible
      });
    }
  }, {
    key: 'hideShareOverlay',
    value: function hideShareOverlay() {
      this.setState({
        isShareOverlayVisible: false
      });
    }
  }, {
    key: 'reportChannelSharedStats',
    value: function reportChannelSharedStats(networkName) {
      var _props = this.props,
          reportStats = _props.reportStats,
          channelData = _props.channelData;


      reportStats(__WEBPACK_IMPORTED_MODULE_25_shared_constants_stats_events__["a" /* default */].CHANNEL_SHARE, {
        network: {
          name: networkName
        },
        channel: channelData
      });
    }
  }, {
    key: 'renderMainItemSlider',
    value: function renderMainItemSlider() {
      var currentIdIndex = this.props.currentIdIndex;


      if (!this.mainVideo) {
        // TODO Move to component
        // each initial state need to be a single component
        return this.noVideosPlayerContent;
      }

      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_45_widget_components_animate_crossfade_animate_crossfade__["a" /* default */],
        { currentIdIndex: currentIdIndex > -1 ? currentIdIndex : 0 },
        this.renderMainItemSliderContent()
      );
    }
  }, {
    key: 'renderMainItemSliderNav',
    value: function renderMainItemSliderNav() {
      var _props2 = this.props,
          canShowVideoList = _props2.canShowVideoList,
          isActionBarVisible = _props2.isActionBarVisible,
          prevVideoId = _props2.prevVideoId,
          nextVideoId = _props2.nextVideoId;


      if (!canShowVideoList && isActionBarVisible) {
        return null;
      }

      return React.createElement(__WEBPACK_IMPORTED_MODULE_44_widget_components_nav_nav__["a" /* default */], { prevButtonClassName: __WEBPACK_IMPORTED_MODULE_52__compact_styl___default.a['nav-button-prev'],
        nextButtonClassName: __WEBPACK_IMPORTED_MODULE_52__compact_styl___default.a['nav-button-next'],
        isPrevVisible: Boolean(prevVideoId),
        isNextVisible: Boolean(nextVideoId),
        onNextClick: this.selectNextVideo,
        onPrevClick: this.selectPrevVideo });
    }
  }, {
    key: 'renderMainItemSliderContent',
    value: function renderMainItemSliderContent() {
      var _this2 = this;

      var _props3 = this.props,
          loadedVideoIds = _props3.loadedVideoIds,
          currentIdIndex = _props3.currentIdIndex,
          mainVideoId = _props3.mainVideoId;

      var videoIdsToRender = loadedVideoIds.length ? loadedVideoIds : [mainVideoId];
      var isCurrentOrPrevOrNext = function isCurrentOrPrevOrNext(index) {
        return Math.abs(currentIdIndex - index) <= 1;
      };

      return _.map(videoIdsToRender, function (videoId, index) {
        return isCurrentOrPrevOrNext(index) ? _this2.renderPlayerOverlay(videoId) : React.createElement('div', { key: videoId });
      });
    }
  }, {
    key: 'isVideoItemAtChannelCover',
    value: function isVideoItemAtChannelCover(videoId) {
      return this.isMainItemChannelCover && videoId === this.mainVideo.id;
    }
  }, {
    key: 'isAtChannelCover',
    value: function isAtChannelCover(videoId) {
      return this.canShowChannelCover && this.isVideoItemAtChannelCover(videoId);
    }
  }, {
    key: 'renderPlayerOverlay',
    value: function renderPlayerOverlay(videoId) {
      var _playerSize = this.playerSize,
          width = _playerSize.width,
          height = _playerSize.height;
      var _props4 = this.props,
          channelData = _props4.channelData,
          OverlayActionsCallbacks = _props4.OverlayActionsCallbacks,
          currentSiteUser = _props4.currentSiteUser,
          videoByIds = _props4.videoByIds;

      var Overlay = this.isAtChannelCover(videoId) ? __WEBPACK_IMPORTED_MODULE_41_widget_views_desktop_compact_components_player_overlay_overlay__["a" /* ChannelOverlay */] : __WEBPACK_IMPORTED_MODULE_41_widget_views_desktop_compact_components_player_overlay_overlay__["b" /* VideoOverlay */];
      var videoItem = videoByIds[videoId];

      if (!videoItem) {
        return null;
      }

      return React.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_52__compact_styl___default.a['video-overlay-container'],
          key: videoId },
        React.createElement(
          OverlayActionsCallbacks,
          { isMainVideo: true,
            onBeforeClick: this.hideAllVideos,
            onBeforePlayRequested: this.hideAllVideos,
            channelId: channelData.id,
            videoId: videoItem.id,
            videoSource: videoItem.videoSource },
          React.createElement(Overlay, { currentSiteUser: currentSiteUser,
            width: width,
            height: height,
            channelData: channelData,
            videoItem: videoItem })
        )
      );
    }
  }, {
    key: 'handleSlideToPrev',
    value: function handleSlideToPrev() {
      __WEBPACK_IMPORTED_MODULE_30_shared_bi_bi__["a" /* default */].logWidgetSystem('videoList.changePage.requested');
      this.props.goToPrevVideosPage();
    }
  }, {
    key: 'handleSlideToNext',
    value: function handleSlideToNext() {
      __WEBPACK_IMPORTED_MODULE_30_shared_bi_bi__["a" /* default */].logWidgetSystem('videoList.changePage.requested');
      this.props.goToNextVideosPage();
    }
  }, {
    key: 'handleActionBarContainerClick',
    value: function handleActionBarContainerClick() {
      this.hideAllVideos();
      this.hideShareOverlay();
    }
  }, {
    key: 'handleShareRequest',
    value: function handleShareRequest(clickEvent) {
      clickEvent.stopPropagation();
      this.toggleShareOverlay();
    }
  }, {
    key: 'processDataFromStorage',
    value: function processDataFromStorage(data) {
      // TODO: get rid of this in view
      var selectedVideoId = data.selectedVideoId,
          openOverlay = data.openOverlay,
          autoplay = data.autoplay;
      var _props5 = this.props,
          selectVideo = _props5.selectVideo,
          resetSelectedVideo = _props5.resetSelectedVideo,
          channelData = _props5.channelData,
          isPlayInFrame = _props5.isPlayInFrame,
          playVideo = _props5.playVideo;


      if (!selectedVideoId) {
        resetSelectedVideo();
        return;
      }

      if ((isPlayInFrame || IS_MOBILE_DEVICE) && autoplay) {
        playVideo(selectedVideoId);
      } else {
        selectVideo(selectedVideoId);
      }

      if (!isPlayInFrame && openOverlay) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_shared_utils_open_overlay__["a" /* openFullScreenOverlay */])('#/channel/' + channelData.id + '/video/' + selectedVideoId + '?autoplay=' + autoplay);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.isUIBlockingDataLoaded) {
        return this.spinner;
      }

      var _props6 = this.props,
          isVideoPlaying = _props6.isVideoPlaying,
          isVideoPaused = _props6.isVideoPaused;


      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_35_widget_views_desktop_compact_components_resize_widget_by_content_resize_widget_by_content__["a" /* default */],
        null,
        React.createElement(
          'section',
          { styleName: 'container',
            ref: this.setContainerEl,
            className: 'qa-widget-container' },
          React.createElement(__WEBPACK_IMPORTED_MODULE_32_widget_data_components_update_widget_size__["a" /* default */], { disabled: this.state.isInFullScreen }),
          React.createElement(__WEBPACK_IMPORTED_MODULE_34_widget_components_reload_storage_reload_storage__["a" /* default */], { onReload: this.processDataFromStorage }),
          React.createElement(
            'div',
            { styleName: 'content',
              style: this.playerContentSize },
            React.createElement(
              __WEBPACK_IMPORTED_MODULE_51_widget_views_desktop_compact_components_animate_animate__["a" /* default */],
              { type: 'fade-in',
                dataHook: 'videoList',
                styleName: 'videos-in-animation',
                when: this.isVideoListVisible },
              this.videos
            ),
            React.createElement(
              __WEBPACK_IMPORTED_MODULE_51_widget_views_desktop_compact_components_animate_animate__["a" /* default */],
              { type: 'fade-in',
                dataHook: 'playerContent',
                when: !this.isVideoListVisible },
              this.player,
              !isVideoPlaying && !isVideoPaused && this.renderMainItemSlider(),
              !isVideoPlaying && !isVideoPaused && this.renderMainItemSliderNav()
            ),
            this.shareChannelOverlay
          ),
          this.actionBar,
          React.createElement(__WEBPACK_IMPORTED_MODULE_33_shared_components_payment_events_payment_events__["a" /* default */], { onRent: this.setCurrentVideoFromPayment,
            onSale: this.setCurrentVideoFromPayment,
            onSubscription: this.reset,
            onSubscriptionCancel: this.reset })
        )
      );
    }
  }, {
    key: 'shareButtons',
    get: function get() {
      var _props7 = this.props,
          appSettings = _props7.appSettings,
          channelData = _props7.channelData;
      var isShareOverlayVisible = this.state.isShareOverlayVisible;


      if (!isShareOverlayVisible) {
        return null;
      }

      return React.createElement(__WEBPACK_IMPORTED_MODULE_40_widget_views_desktop_compact_components_share_channel_share_channel__["a" /* default */], { channelData: channelData,
        appSettings: appSettings,
        onShare: this.reportChannelSharedStats });
    }
  }, {
    key: 'shareChannelOverlay',
    get: function get() {
      var canShowChannelShare = this.props.canShowChannelShare;
      var isShareOverlayVisible = this.state.isShareOverlayVisible;


      if (!canShowChannelShare) {
        return null;
      }

      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_51_widget_views_desktop_compact_components_animate_animate__["a" /* default */],
        { styleName: 'share-channel-overlay',
          type: 'fade-in-out',
          when: isShareOverlayVisible },
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_39_widget_views_desktop_compact_components_closable_overlay_closable_overlay__["a" /* default */],
          { onClose: this.hideShareOverlay },
          this.shareButtons
        )
      );
    }
  }, {
    key: 'player',
    get: function get() {
      var videoItem = this.mainVideo;

      if (!videoItem) {
        return null;
      }

      var _playerContentSize = this.playerContentSize,
          width = _playerContentSize.width,
          height = _playerContentSize.height;
      var _props8 = this.props,
          channelData = _props8.channelData,
          isPlayInFrame = _props8.isPlayInFrame,
          isVideoPlaying = _props8.isVideoPlaying,
          isVideoPaused = _props8.isVideoPaused,
          currentSiteUser = _props8.currentSiteUser;


      var isPlayAllowed = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18_widget_ui_selectors_video_access__["a" /* canPlayFullOrPreview */])(channelData, videoItem, currentSiteUser);
      if (!isPlayAllowed) {
        return null;
      }

      var playerProps = {
        videoItem: videoItem,
        channelData: channelData,
        width: width,
        height: height,
        openPreviewPrompt: __WEBPACK_IMPORTED_MODULE_29_widget_components_preview_prompt_preview_prompt__["a" /* openPreviewPrompt */],
        onFullScreenChanged: this.setFullScreenState,
        paused: !isVideoPlaying
      };

      var callbackProps = {
        channelId: channelData.id,
        videoId: videoItem.id
      };

      if (IS_MOBILE_DEVICE) {
        return React.createElement(
          __WEBPACK_IMPORTED_MODULE_50__actions_player_action_callbacks__["a" /* default */],
          callbackProps,
          React.createElement(__WEBPACK_IMPORTED_MODULE_36_widget_components_players_mobile_player__["a" /* default */], playerProps)
        );
      }
      //(isVideoPlaying || isVideoPaused) condition is only for performance reasons
      if (isPlayInFrame && (isVideoPlaying || isVideoPaused)) {
        return React.createElement(
          __WEBPACK_IMPORTED_MODULE_50__actions_player_action_callbacks__["a" /* default */],
          callbackProps,
          React.createElement(__WEBPACK_IMPORTED_MODULE_37_widget_components_players_desktop_player__["a" /* default */], playerProps)
        );
      }

      return null;
    }
  }, {
    key: 'playerContentSize',
    get: function get() {
      var canShowVideoList = this.props.canShowVideoList;


      if (!canShowVideoList) {
        return this.playerSize;
      }

      var _playerSize2 = this.playerSize,
          width = _playerSize2.width,
          height = _playerSize2.height;

      return {
        width: width,
        height: height - (this.actionBarHeight - ACTION_BAR_CLOSED_HEIGHT)
      };
    }
  }, {
    key: 'playerSize',
    get: function get() {
      var requestedWidgetSize = this.props.requestedWidgetSize;

      var width = Math.min(Math.max(requestedWidgetSize.width, MIN_WIDGET_WIDTH), MAX_WIDGET_WIDTH);
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_widget_utils_videos_sizes__["c" /* playerSize */])(width, 0);
    }
  }, {
    key: 'actionBarHeight',
    get: function get() {
      return this.areActionsVisible ? ACTION_BAR_OPENED_HEIGHT : ACTION_BAR_CLOSED_HEIGHT;
    }
  }, {
    key: 'thumbnailSize',
    get: function get() {
      var _playerSize3 = this.playerSize,
          width = _playerSize3.width,
          height = _playerSize3.height;


      return {
        width: width / __WEBPACK_IMPORTED_MODULE_24_shared_constants_compact_layout__["a" /* COMPACT_VIDEOS_IN_ROW */],
        height: (height - (ACTION_BAR_OPENED_HEIGHT - ACTION_BAR_CLOSED_HEIGHT)) / __WEBPACK_IMPORTED_MODULE_24_shared_constants_compact_layout__["b" /* COMPACT_NUMBER_OF_ROWS */]
      };
    }
  }, {
    key: 'videos',
    get: function get() {
      var _props9 = this.props,
          channelData = _props9.channelData,
          videoIdsByPageNumber = _props9.videoIdsByPageNumber,
          currentVideosPageNumber = _props9.currentVideosPageNumber,
          canShowVideoList = _props9.canShowVideoList,
          OverlayActionsCallbacks = _props9.OverlayActionsCallbacks;


      if (!canShowVideoList) {
        return null;
      }

      return React.createElement(__WEBPACK_IMPORTED_MODULE_38_widget_views_desktop_compact_components_videos_videos__["a" /* default */], { containerWidth: this.playerContentSize.width,
        channelData: channelData,
        videoIdsByPageNumber: videoIdsByPageNumber,
        currentVideosPageNumber: currentVideosPageNumber,
        onSlideToPrev: this.handleSlideToPrev,
        onSlideToNext: this.handleSlideToNext,
        onBeforeClick: this.hideAllVideos,
        onBeforePlayRequested: this.hideAllVideos,
        OverlayActionsCallbacks: OverlayActionsCallbacks,
        thumbnailSize: this.thumbnailSize });
    }
  }, {
    key: 'actionBarNav',
    get: function get() {
      var _props10 = this.props,
          canShowVideoList = _props10.canShowVideoList,
          nextVideoId = _props10.nextVideoId,
          prevVideoId = _props10.prevVideoId;


      if (canShowVideoList) {
        return null;
      }

      return React.createElement(__WEBPACK_IMPORTED_MODULE_44_widget_components_nav_nav__["a" /* default */], { nextButtonClassName: __WEBPACK_IMPORTED_MODULE_52__compact_styl___default.a['action-bar-nav-button'],
        prevButtonClassName: __WEBPACK_IMPORTED_MODULE_52__compact_styl___default.a['action-bar-nav-button'],
        isPrevVisible: Boolean(prevVideoId),
        isNextVisible: Boolean(nextVideoId),
        onNextClick: this.selectNextVideo,
        onPrevClick: this.selectPrevVideo,
        dataHook: 'actionBarNav',
        customArrowIcon: React.createElement(__WEBPACK_IMPORTED_MODULE_53_static_images_action_bar_arrow_right_svg__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_52__compact_styl___default.a['action-bar-nav-icon'] }) });
    }
  }, {
    key: 'actionBar',
    get: function get() {
      var isActionBarVisible = this.props.isActionBarVisible;


      if (!isActionBarVisible) {
        return null;
      }

      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_43_widget_views_desktop_compact_components_action_bar_action_bar__["a" /* default */],
        { height: this.actionBarHeight,
          areActionsVisible: this.areActionsVisible,
          onActionsContainerClick: this.handleActionBarContainerClick,
          onMenuClick: this.showAllVideos,
          onButtonsClick: this.hideShareOverlay },
        this.actions,
        this.actionBarNav
      );
    }
  }, {
    key: 'actions',
    get: function get() {
      var _props11 = this.props,
          channelData = _props11.channelData,
          canShowVideoList = _props11.canShowVideoList,
          canShowSignIn = _props11.canShowSignIn,
          canShowChannelShare = _props11.canShowChannelShare,
          canShowChannelInfo = _props11.canShowChannelInfo,
          canShowSubscriptionButton = _props11.canShowSubscriptionButton;


      return (
        // TODO onUserLogin, onUserLogOut - etc. make BaseAccountButton dumb to only
        // call callbacks provided to it aka onUserLoginRequested...
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_49__actions_channel_action_callbacks__["a" /* default */],
          { channelId: channelData.id },
          React.createElement(__WEBPACK_IMPORTED_MODULE_42_widget_views_desktop_compact_components_channel_actions_channel_actions__["a" /* default */], { channelData: channelData,
            canShowSignIn: canShowSignIn,
            canShowChannelShare: canShowChannelShare,
            canShowChannelInfo: canShowChannelInfo,
            canShowCloseButton: canShowVideoList,
            canShowSubscriptionButton: canShowSubscriptionButton,

            onShareRequest: this.handleShareRequest,
            onCloseRequest: this.hideAllVideos,
            onLogInRequest: this.showLogInForm,
            onLogOutRequest: this.logOut,
            onAccountInfoAtOverlayRequest: this.openAccountInfoAtOverlay })
        )
      );
    }
  }, {
    key: 'isVideoListVisible',
    get: function get() {
      var areAllVideosVisible = this.state.areAllVideosVisible;
      var _props12 = this.props,
          isVideoListPreviewHover = _props12.isVideoListPreviewHover,
          isPreviewHover = _props12.isPreviewHover,
          canShowVideoList = _props12.canShowVideoList;

      if (!canShowVideoList) {
        return false;
      }
      return areAllVideosVisible || isVideoListPreviewHover || isPreviewHover;
    }
  }, {
    key: 'areActionsVisible',
    get: function get() {
      var canShowVideoList = this.props.canShowVideoList;

      return !canShowVideoList || this.isVideoListVisible;
    }
  }]);

  return CompactView;
}(__WEBPACK_IMPORTED_MODULE_31_widget_views_base__["a" /* default */]), _class3.displayName = 'CompactView', _class3.propTypes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_31_widget_views_base__["a" /* default */].propTypes, {
  mainVideoId: React.PropTypes.string,
  channelVideoIds: React.PropTypes.arrayOf(React.PropTypes.string),

  prevPageVideosIds: React.PropTypes.arrayOf(React.PropTypes.string),
  nextPageVideosIds: React.PropTypes.arrayOf(React.PropTypes.string),
  loadedVideoIds: React.PropTypes.array,
  currentIdIndex: React.PropTypes.number,

  isActionBarVisible: React.PropTypes.bool,
  canShowChannelShare: React.PropTypes.bool,
  canShowChannelInfo: React.PropTypes.bool,
  canShowVideoList: React.PropTypes.bool,
  canShowSignIn: React.PropTypes.bool,
  isPreviewHover: React.PropTypes.bool,
  isVideoListPreviewHover: React.PropTypes.bool,

  OverlayActionsCallbacks: React.PropTypes.func,

  resetPlaybackStatus: React.PropTypes.func,
  resetSelectedVideo: React.PropTypes.func,
  reportStats: React.PropTypes.func
}), _temp), (_applyDecoratedDescriptor(_class2.prototype, 'reset', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'reset'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'showAllVideos', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a, _dec4], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'showAllVideos'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'hideAllVideos', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'hideAllVideos'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'toggleShareOverlay', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'toggleShareOverlay'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'hideShareOverlay', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'hideShareOverlay'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'reportChannelSharedStats', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a, _dec5], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'reportChannelSharedStats'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'renderMainItemSlider', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'renderMainItemSlider'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'renderPlayerOverlay', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'renderPlayerOverlay'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleSlideToPrev', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handleSlideToPrev'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleSlideToNext', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handleSlideToNext'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleActionBarContainerClick', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handleActionBarContainerClick'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleShareRequest', [__WEBPACK_IMPORTED_MODULE_7_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handleShareRequest'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'processDataFromStorage', [_dec6], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'processDataFromStorage'), _class2.prototype)), _class2)) || _class) || _class) || _class);


/***/ }),
/* 2538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionBar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_widget_views_desktop_compact_components_menu_button_menu_button__ = __webpack_require__(2541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_widget_views_desktop_compact_components_animate_animate__ = __webpack_require__(1292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__action_bar_styl__ = __webpack_require__(3283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__action_bar_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__action_bar_styl__);







var _dec, _class, _desc, _value, _class2, _class3, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}









var ActionBar = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_10__action_bar_styl___default.a), _dec(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ActionBar, _React$Component);

  function ActionBar() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ActionBar);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ActionBar.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(ActionBar)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ActionBar, [{
    key: 'handleButtonsClick',
    value: function handleButtonsClick(event) {
      event.stopPropagation();
      this.props.onButtonsClick();
    }
  }, {
    key: 'renderButtons',
    value: function renderButtons() {
      var _props = this.props,
          onActionsContainerClick = _props.onActionsContainerClick,
          children = _props.children;


      return React.createElement(
        'div',
        { onClick: onActionsContainerClick,
          className: __WEBPACK_IMPORTED_MODULE_10__action_bar_styl___default.a['clickable-container'] },
        React.createElement(
          'div',
          { styleName: 'buttons',
            onClick: this.handleButtonsClick },
          children
        )
      );
    }
  }, {
    key: 'renderMenuButton',
    value: function renderMenuButton() {
      var onMenuClick = this.props.onMenuClick;


      return React.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_10__action_bar_styl___default.a['clickable-container'],
          onClick: onMenuClick },
        React.createElement(__WEBPACK_IMPORTED_MODULE_8_widget_views_desktop_compact_components_menu_button_menu_button__["a" /* default */], { styleName: 'menu-button' })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          areActionsVisible = _props2.areActionsVisible,
          height = _props2.height;


      return React.createElement(
        'section',
        { style: { height: height },
          styleName: 'actions' },
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_9_widget_views_desktop_compact_components_animate_animate__["a" /* default */],
          { activeClassName: __WEBPACK_IMPORTED_MODULE_10__action_bar_styl___default.a['actions-wrapper'],
            dataHook: 'compactActions',
            type: 'fade-in',
            when: areActionsVisible },
          this.renderButtons()
        ),
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_9_widget_views_desktop_compact_components_animate_animate__["a" /* default */],
          { type: 'fade-in',
            activeClassName: __WEBPACK_IMPORTED_MODULE_10__action_bar_styl___default.a['menu-button-wrapper'],
            dataHook: 'menuButtonWrapper',
            when: !areActionsVisible },
          this.renderMenuButton()
        )
      );
    }
  }]);

  return ActionBar;
}(React.Component), _class3.propTypes = {
  children: React.PropTypes.any,
  height: React.PropTypes.number,
  areActionsVisible: React.PropTypes.bool,

  onActionsContainerClick: React.PropTypes.func,

  onMenuClick: React.PropTypes.func,
  onButtonsClick: React.PropTypes.func
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'handleButtonsClick', [__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handleButtonsClick'), _class2.prototype)), _class2)) || _class);


/***/ }),
/* 2539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChannelActions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_components_icon_icon__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__with_tooltip_with_tooltip__ = __webpack_require__(2555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_widget_components_channel_actions_channel_info_button__ = __webpack_require__(1826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_widget_components_channel_actions_channel_subscription_label__ = __webpack_require__(2005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_widget_components_account_account_button_account_button__ = __webpack_require__(1823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__translations__ = __webpack_require__(2018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__channel_actions_styl__ = __webpack_require__(3284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__channel_actions_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__channel_actions_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_shared_constants_popout__ = __webpack_require__(61);






var _dec, _class, _class2, _temp;















var ChannelActions = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_13__channel_actions_styl___default.a), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_intl__["d" /* injectIntl */])(_class = _dec(_class = (_temp = _class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ChannelActions, _React$Component);

  function ChannelActions() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ChannelActions);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ChannelActions.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ChannelActions)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ChannelActions, [{
    key: 'wrapWithTooltip',
    value: function wrapWithTooltip(content, tooltipMessage) {
      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_8__with_tooltip_with_tooltip__["a" /* default */],
        { tooltip: tooltipMessage,
          className: __WEBPACK_IMPORTED_MODULE_13__channel_actions_styl___default.a.item,
          innerClassName: __WEBPACK_IMPORTED_MODULE_13__channel_actions_styl___default.a['tooltip-inner'] },
        content
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'nav',
        { styleName: 'container' },
        this.shareButton,
        this.channelInfoButton,
        this.channelSubscriptionButton,
        this.membershipActions,
        this.closeButton
      );
    }
  }, {
    key: 'formatMessage',
    get: function get() {
      return this.props.intl.formatMessage;
    }
  }, {
    key: 'shareButton',
    get: function get() {
      var _props = this.props,
          canShowChannelShare = _props.canShowChannelShare,
          onShareRequest = _props.onShareRequest;


      if (!canShowChannelShare) {
        return null;
      }

      var tooltipMessage = this.formatMessage(__WEBPACK_IMPORTED_MODULE_12__translations__["a" /* default */].shareButtonTooltip);
      var content = React.createElement(__WEBPACK_IMPORTED_MODULE_7_shared_components_icon_icon__["a" /* default */], { name: 'share',
        'data-hook': 'shareChannelButton',
        className: __WEBPACK_IMPORTED_MODULE_13__channel_actions_styl___default.a.icon,
        onClick: onShareRequest });

      return this.wrapWithTooltip(content, tooltipMessage);
    }
  }, {
    key: 'channelInfoButton',
    get: function get() {
      var _props2 = this.props,
          channelData = _props2.channelData,
          onInfoRequest = _props2.onInfoRequest,
          canShowChannelInfo = _props2.canShowChannelInfo;


      if (!canShowChannelInfo) {
        return null;
      }

      var tooltipMessage = this.formatMessage(__WEBPACK_IMPORTED_MODULE_12__translations__["a" /* default */].channelInfoTooltip);
      var content = React.createElement(__WEBPACK_IMPORTED_MODULE_9_widget_components_channel_actions_channel_info_button__["a" /* default */], { dataHook: 'channelInfoButton',
        className: __WEBPACK_IMPORTED_MODULE_13__channel_actions_styl___default.a.icon + ' ' + __WEBPACK_IMPORTED_MODULE_13__channel_actions_styl___default.a['icon-channel-info'],
        channelData: channelData,
        onClick: onInfoRequest });

      return this.wrapWithTooltip(content, tooltipMessage);
    }
  }, {
    key: 'channelSubscriptionButton',
    get: function get() {
      var _props3 = this.props,
          channelData = _props3.channelData,
          onSubscriptionRequest = _props3.onSubscriptionRequest,
          canShowSubscriptionButton = _props3.canShowSubscriptionButton;


      if (!canShowSubscriptionButton) {
        return null;
      }

      var tooltipMessage = React.createElement(__WEBPACK_IMPORTED_MODULE_10_widget_components_channel_actions_channel_subscription_label__["a" /* default */], { dealInfo: channelData.dealInfo,
        styleName: 'channel-subscription-tooltip-content' });
      var content = React.createElement(__WEBPACK_IMPORTED_MODULE_7_shared_components_icon_icon__["a" /* default */], { name: 'paid',
        'data-hook': 'subscriptionButton',
        className: __WEBPACK_IMPORTED_MODULE_13__channel_actions_styl___default.a.icon + ' ' + __WEBPACK_IMPORTED_MODULE_13__channel_actions_styl___default.a['icon-paid'],
        onClick: onSubscriptionRequest });

      return this.wrapWithTooltip(content, tooltipMessage);
    }
  }, {
    key: 'membershipActions',
    get: function get() {
      var _props4 = this.props,
          channelData = _props4.channelData,
          onSubscriptionRequest = _props4.onSubscriptionRequest,
          onSubscriptionCancelRequest = _props4.onSubscriptionCancelRequest,
          onAccountInfoAtOverlayRequest = _props4.onAccountInfoAtOverlayRequest,
          canShowSignIn = _props4.canShowSignIn,
          onLogInRequest = _props4.onLogInRequest,
          onLogOutRequest = _props4.onLogOutRequest;


      if (!canShowSignIn) {
        return null;
      }

      return React.createElement(__WEBPACK_IMPORTED_MODULE_11_widget_components_account_account_button_account_button__["a" /* default */], { styleName: 'item icon',
        infoButtonClassName: __WEBPACK_IMPORTED_MODULE_13__channel_actions_styl___default.a['icon-account-info'],
        infoButtonTooltipClassName: __WEBPACK_IMPORTED_MODULE_13__channel_actions_styl___default.a['button-account-tooltip'],
        infoButtonPopoutTriangleClassName: __WEBPACK_IMPORTED_MODULE_13__channel_actions_styl___default.a['button-account-tooltip-triangle'],
        channelData: channelData,
        popoutSide: __WEBPACK_IMPORTED_MODULE_14_shared_constants_popout__["a" /* sides */].TOP,
        onClick: onAccountInfoAtOverlayRequest,
        onLoginClick: onLogInRequest,
        onLogoutClick: onLogOutRequest,
        onSubscribeClick: onSubscriptionRequest,
        onSubscriptionCancelClick: onSubscriptionCancelRequest });
    }
  }, {
    key: 'closeButtonWithTooltip',
    get: function get() {
      var onCloseRequest = this.props.onCloseRequest;


      var tooltipMessage = this.formatMessage(__WEBPACK_IMPORTED_MODULE_12__translations__["a" /* default */].close);
      var content = React.createElement(__WEBPACK_IMPORTED_MODULE_7_shared_components_icon_icon__["a" /* default */], { name: 'exit',
        'data-hook': 'closeActionBar',
        styleName: 'icon icon-close',
        onClick: onCloseRequest });

      return this.wrapWithTooltip(content, tooltipMessage);
    }
  }, {
    key: 'closeButtonWithLabel',
    get: function get() {
      var onCloseRequest = this.props.onCloseRequest;


      var label = this.formatMessage(__WEBPACK_IMPORTED_MODULE_12__translations__["a" /* default */].close);

      return React.createElement(
        'div',
        { styleName: 'item',
          onClick: onCloseRequest,
          'data-hook': 'closeActionBar' },
        React.createElement(
          'div',
          { className: __WEBPACK_IMPORTED_MODULE_13__channel_actions_styl___default.a.icon },
          React.createElement(__WEBPACK_IMPORTED_MODULE_7_shared_components_icon_icon__["a" /* default */], { name: 'exit',
            styleName: 'icon icon-close with-label' }),
          React.createElement(
            'span',
            { styleName: 'label' },
            label
          )
        )
      );
    }
  }, {
    key: 'closeButton',
    get: function get() {
      var canShowCloseButton = this.props.canShowCloseButton;


      if (!canShowCloseButton) {
        return null;
      }

      var shareButton = this.shareButton,
          channelInfoButton = this.channelInfoButton,
          channelSubscriptionButton = this.channelSubscriptionButton,
          membershipActions = this.membershipActions,
          closeButtonWithTooltip = this.closeButtonWithTooltip,
          closeButtonWithLabel = this.closeButtonWithLabel;


      var buttonsExceptClose = [shareButton, channelInfoButton, channelSubscriptionButton, membershipActions];

      return _.some(buttonsExceptClose) ? closeButtonWithTooltip : closeButtonWithLabel;
    }
  }]);

  return ChannelActions;
}(React.Component), _class2.propTypes = {
  channelData: React.PropTypes.object,
  intl: __WEBPACK_IMPORTED_MODULE_5_react_intl__["e" /* intlShape */],

  canShowCloseButton: React.PropTypes.bool,
  canShowChannelShare: React.PropTypes.bool,
  canShowChannelInfo: React.PropTypes.bool,
  canShowSignIn: React.PropTypes.bool,
  canShowSubscriptionButton: React.PropTypes.bool,

  onShareRequest: React.PropTypes.func,
  onInfoRequest: React.PropTypes.func,
  onAccountInfoAtOverlayRequest: React.PropTypes.func,
  onSubscriptionRequest: React.PropTypes.func,
  onLogInRequest: React.PropTypes.func,
  onLogOutRequest: React.PropTypes.func,
  onSubscriptionCancelRequest: React.PropTypes.func,
  onCloseRequest: React.PropTypes.func
}, _temp)) || _class) || _class);


/***/ }),
/* 2540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClosableOverlay; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_widget_player_widget_components_icon_icon__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__closable_overlay_styl__ = __webpack_require__(3285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__closable_overlay_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__closable_overlay_styl__);






var _dec, _class, _class2, _temp;







var ClosableOverlay = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_7__closable_overlay_styl___default.a), _dec(_class = (_temp = _class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ClosableOverlay, _React$Component);

  function ClosableOverlay() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ClosableOverlay);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ClosableOverlay.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ClosableOverlay)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ClosableOverlay, [{
    key: 'render',
    value: function render() {
      var children = this.props.children;


      return React.createElement(
        'div',
        { styleName: 'overlay' },
        this.closeButton,
        React.createElement(
          'div',
          { styleName: 'content' },
          children
        )
      );
    }
  }, {
    key: 'closeButton',
    get: function get() {
      var onClose = this.props.onClose;


      return React.createElement(__WEBPACK_IMPORTED_MODULE_6_widget_player_widget_components_icon_icon__["a" /* default */], { styleName: 'close',
        'data-hook': 'closeOverlay',
        name: 'exit',
        onClick: onClose });
    }
  }]);

  return ClosableOverlay;
}(React.Component), _class2.propTypes = {
  children: React.PropTypes.any,
  onClose: React.PropTypes.func
}, _temp)) || _class);


/***/ }),
/* 2541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MenuButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_static_images_menu_svg__ = __webpack_require__(2695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__menu_button_styl__ = __webpack_require__(3286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__menu_button_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__menu_button_styl__);






var _dec, _class, _class2, _temp;






var MenuButton = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_7__menu_button_styl___default.a), _dec(_class = (_temp = _class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MenuButton, _React$Component);

  function MenuButton() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, MenuButton);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (MenuButton.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(MenuButton)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(MenuButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          onClick = _props.onClick,
          className = _props.className;


      return React.createElement(
        'button',
        { onClick: onClick,
          'data-hook': 'menuButton',
          className: className,
          styleName: 'button icon' },
        React.createElement(__WEBPACK_IMPORTED_MODULE_6_static_images_menu_svg__["a" /* default */], null)
      );
    }
  }]);

  return MenuButton;
}(React.Component), _class2.propTypes = {
  onClick: React.PropTypes.func,
  className: React.PropTypes.func
}, _temp)) || _class);


/***/ }),
/* 2542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getPaidAccessButtonConfig;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_widget_ui_selectors_channel_access__ = __webpack_require__(1291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translation_data__ = __webpack_require__(2544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__callback__ = __webpack_require__(2543);





function getPaidAccessButtonConfig(props) {
  var channelData = props.channelData;


  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_widget_ui_selectors_channel_access__["b" /* canSubscribeToChannel */])(channelData)) {
    return null;
  }

  var callback = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__callback__["a" /* default */])(props);
  var translationData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__translation_data__["a" /* default */])(channelData);

  return {
    callback: callback,
    translationData: translationData
  };
}

/***/ }),
/* 2543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getCallbackFromProps;
function getCallbackFromProps(props) {
  return props.onSubscriptionRequest;
}

/***/ }),
/* 2544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTranslationData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_utils_deal_info_helpers__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_translations_overlay_common_translations__ = __webpack_require__(134);




function getTranslationData(channel) {
  return {
    props: __WEBPACK_IMPORTED_MODULE_1_shared_translations_overlay_common_translations__["a" /* default */].getSubscription,
    priceModel: __WEBPACK_IMPORTED_MODULE_0_shared_utils_deal_info_helpers__["a" /* getSubscriptionPriceInfo */](channel.dealInfo)
  };
}

/***/ }),
/* 2545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getPlayButtonConfig;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_widget_ui_selectors_video_access__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translation_data__ = __webpack_require__(2547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__callback__ = __webpack_require__(2546);





function getPlayButtonConfig(props) {
  var channelData = props.channelData,
      videoItem = props.videoItem,
      currentSiteUser = props.currentSiteUser;


  var availableVideoType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_widget_ui_selectors_video_access__["f" /* getAvailableVideoType */])(channelData, videoItem, currentSiteUser);
  var fullAccessAction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_widget_ui_selectors_video_access__["d" /* getFullAccessActionName */])(channelData, videoItem, currentSiteUser);

  var callback = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__callback__["a" /* default */])(props, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_widget_ui_selectors_video_access__["a" /* canPlayFullOrPreview */])(channelData, videoItem, currentSiteUser), fullAccessAction);
  var translationData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__translation_data__["a" /* default */])(availableVideoType, fullAccessAction);

  return {
    callback: callback,
    translationData: translationData
  };
}

/***/ }),
/* 2546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getCallbackForAction;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_widget_ui_selectors_video_access__ = __webpack_require__(94);


function getCallbackForAction(props, canPlayFullOrPreview, fullAccessAction) {
  if (canPlayFullOrPreview) {
    return props.onPlayRequest;
  } else if (fullAccessAction === __WEBPACK_IMPORTED_MODULE_0_widget_ui_selectors_video_access__["c" /* FULL_ACCESS_ACTION_NAMES */].SIGN_IN) {
    return props.onPlayMemberOnlyRequest;
  }

  return props.onPlayWithoutPreviewRequest;
}

/***/ }),
/* 2547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTranslationData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_widget_ui_selectors_video_access__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_widget_components_overlay_texts_channel_play_button_text__ = __webpack_require__(1258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_translations_overlay_common_translations__ = __webpack_require__(134);






function getTranslationData(availableVideoType, fullAccessAction) {
  if (availableVideoType) {
    return {
      props: __WEBPACK_IMPORTED_MODULE_1_widget_components_overlay_texts_channel_play_button_text__["b" /* DEFAULT_TRANSLATIONS */][availableVideoType]
    };
  } else if (fullAccessAction === __WEBPACK_IMPORTED_MODULE_0_widget_ui_selectors_video_access__["c" /* FULL_ACCESS_ACTION_NAMES */].SIGN_IN) {
    return {
      props: __WEBPACK_IMPORTED_MODULE_2_shared_translations_overlay_common_translations__["a" /* default */].startWatching
    };
  }

  return {
    props: __WEBPACK_IMPORTED_MODULE_2_shared_translations_overlay_common_translations__["a" /* default */].startWatching
  };
}

/***/ }),
/* 2548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getCallbackFromProps;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_widget_ui_selectors_video_access__ = __webpack_require__(94);


function getCallbackFromProps(props, canPlayFullOrPreview, fullAccessAction) {
  if (canPlayFullOrPreview) {
    return props.onPlayRequest;
  } else if (fullAccessAction === __WEBPACK_IMPORTED_MODULE_0_widget_ui_selectors_video_access__["c" /* FULL_ACCESS_ACTION_NAMES */].SIGN_IN) {
    return props.onPlayMemberOnlyRequest;
  }

  return _.noop;
}

/***/ }),
/* 2549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTranslationData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_widget_ui_selectors_video_access__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_widget_components_overlay_texts_video_play_button_text__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_translations_overlay_common_translations__ = __webpack_require__(134);






function getTranslationData(availableVideoType, fullAccessAction) {
  if (availableVideoType) {
    return {
      props: __WEBPACK_IMPORTED_MODULE_1_widget_components_overlay_texts_video_play_button_text__["b" /* DEFAULT_TRANSLATIONS */][availableVideoType]
    };
  } else if (fullAccessAction === __WEBPACK_IMPORTED_MODULE_0_widget_ui_selectors_video_access__["c" /* FULL_ACCESS_ACTION_NAMES */].SIGN_IN) {
    return {
      props: __WEBPACK_IMPORTED_MODULE_2_shared_translations_overlay_common_translations__["a" /* default */].playVideo
    };
  }

  return null;
}

/***/ }),
/* 2550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResizeWidgetByContent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_utils_wix_sdk__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_constants_view_modes__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_selectors_app_settings__ = __webpack_require__(42);







var _dec, _class, _desc, _value, _class2, _class3, _temp2;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}









// TODO use at mobile, classic & strip too
var ResizeWidgetByContent = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_redux__["a" /* connect */])(function (state) {
  return {
    requestedWidgetSize: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_shared_selectors_app_settings__["e" /* getRequestedWidgetSize */])(state)
  };
}), _dec(_class = (_class2 = (_temp2 = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ResizeWidgetByContent, _React$Component);

  function ResizeWidgetByContent() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ResizeWidgetByContent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = ResizeWidgetByContent.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(ResizeWidgetByContent)).call.apply(_ref, [this].concat(args))), _this), _this.interval = null, _this.containerEl = null, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ResizeWidgetByContent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.interval = setInterval(this.updateSize, 300);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.interval);
    }
  }, {
    key: 'updateSize',
    value: function updateSize() {
      var newSize = this.containerSize;
      var requestedWidgetSize = this.props.requestedWidgetSize;

      if (!newSize.width || !newSize.height || !requestedWidgetSize.width || _.isEqual(requestedWidgetSize, newSize)) {
        return;
      }

      this.currentContentSize = newSize;
      if (__WEBPACK_IMPORTED_MODULE_8_shared_utils_wix_sdk__["a" /* default */].Utils.getViewMode() === __WEBPACK_IMPORTED_MODULE_9_shared_constants_view_modes__["a" /* default */].EDITOR) {
        // editor
        __WEBPACK_IMPORTED_MODULE_8_shared_utils_wix_sdk__["a" /* default */].resizeComponent(newSize);
      } else {
        // viewer
        __WEBPACK_IMPORTED_MODULE_8_shared_utils_wix_sdk__["a" /* default */].resizeWindow(newSize.width, newSize.height);
      }
      // fix TPA bug. TODO remove
      __WEBPACK_IMPORTED_MODULE_8_shared_utils_wix_sdk__["a" /* default */].setHeight(newSize.height, { overflow: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return React.createElement(
        'div',
        { ref: function ref(node) {
            return _this2.containerEl = node;
          },
          style: { display: 'inline-block' } },
        this.props.children
      );
    }
  }, {
    key: 'containerSize',
    get: function get() {
      return {
        width: Math.ceil(_.get(this.containerEl, 'clientWidth', 0)),
        height: Math.ceil(_.get(this.containerEl, 'clientHeight', 0))
      };
    }
  }]);

  return ResizeWidgetByContent;
}(React.Component), _class3.propTypes = {
  requestedWidgetSize: React.PropTypes.shape({
    width: React.PropTypes.number,
    height: React.PropTypes.number
  }),
  children: React.PropTypes.element
}, _temp2), (_applyDecoratedDescriptor(_class2.prototype, 'updateSize', [__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'updateSize'), _class2.prototype)), _class2)) || _class);


/***/ }),
/* 2551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ShareChannel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_widget_components_share_channel_share_channel__ = __webpack_require__(1834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_widget_constants_social_networks__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_widget_player_widget_components_social_share_social_share__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_widget_player_widget_components_player_info_overlay_share_share_styl__ = __webpack_require__(1220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_widget_player_widget_components_player_info_overlay_share_share_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_widget_player_widget_components_player_info_overlay_share_share_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__translations__ = __webpack_require__(2018);






var _dec, _class, _class2, _temp;














var ShareChannel = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_10_widget_player_widget_components_player_info_overlay_share_share_styl___default.a), _dec(_class = (_temp = _class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ShareChannel, _React$Component);

  function ShareChannel() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ShareChannel);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ShareChannel.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ShareChannel)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ShareChannel, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          appSettings = _props.appSettings,
          channelData = _props.channelData,
          onShare = _props.onShare;

      var networksClassNames = _.pick(__WEBPACK_IMPORTED_MODULE_10_widget_player_widget_components_player_info_overlay_share_share_styl___default.a, _.values(__WEBPACK_IMPORTED_MODULE_8_widget_constants_social_networks__["a" /* default */]));
      var contentToShare = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_widget_components_share_channel_share_channel__["a" /* getContentToShare */])(channelData, appSettings);

      return React.createElement(
        'div',
        { styleName: 'share-overlay',
          'data-hook': 'shareChannelOverlay' },
        React.createElement(
          'div',
          { styleName: 'title' },
          React.createElement(__WEBPACK_IMPORTED_MODULE_5_react_intl__["a" /* FormattedMessage */], __WEBPACK_IMPORTED_MODULE_11__translations__["a" /* default */].shareThisChannel)
        ),
        React.createElement(__WEBPACK_IMPORTED_MODULE_9_widget_player_widget_components_social_share_social_share__["a" /* default */], { appSettings: appSettings,
          networks: _.values(__WEBPACK_IMPORTED_MODULE_8_widget_constants_social_networks__["a" /* default */]),
          content: contentToShare,
          styleName: 'social-icons',
          onShare: onShare,
          buttonClassName: __WEBPACK_IMPORTED_MODULE_10_widget_player_widget_components_player_info_overlay_share_share_styl___default.a['share-icon'],
          popoutOuterClassName: __WEBPACK_IMPORTED_MODULE_10_widget_player_widget_components_player_info_overlay_share_share_styl___default.a['popout-outer'],
          popoutInnerClassName: __WEBPACK_IMPORTED_MODULE_10_widget_player_widget_components_player_info_overlay_share_share_styl___default.a['popout-inner'],
          linkClassName: __WEBPACK_IMPORTED_MODULE_10_widget_player_widget_components_player_info_overlay_share_share_styl___default.a['share-link'],
          networksClassNames: networksClassNames })
      );
    }
  }]);

  return ShareChannel;
}(React.Component), _class2.propTypes = {
  channelData: React.PropTypes.object,
  appSettings: React.PropTypes.object,
  onShare: React.PropTypes.func.isRequired
}, _temp)) || _class);


/***/ }),
/* 2552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VideoThumbnailOverlay; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_selectors_app_settings__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_widget_views_desktop_compact_components_player_overlay_ui_selectors_video_overlay_play_button_config__ = __webpack_require__(2017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_widget_views_desktop_compact_components_player_overlay_ui_selectors_video_overlay_paid_access_button_config__ = __webpack_require__(1293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_ui_selectors_video_cover__ = __webpack_require__(1724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_widget_views_desktop_compact_components_player_overlay_overlay__ = __webpack_require__(2016);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__video_thumbnail_overlay_styl__ = __webpack_require__(3288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__video_thumbnail_overlay_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__video_thumbnail_overlay_styl__);






var _dec, _dec2, _class, _class2, _temp;














var VideoThumbnailOverlay = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_redux__["a" /* connect */])(function (state, ownProps) {
  return {
    playButtonConfig: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_widget_views_desktop_compact_components_player_overlay_ui_selectors_video_overlay_play_button_config__["a" /* default */])(ownProps),
    paidAccessButtonConfig: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_widget_views_desktop_compact_components_player_overlay_ui_selectors_video_overlay_paid_access_button_config__["a" /* default */])(ownProps),
    canShowMainItemTitle: true,
    isMainActionsOnlyIcons: true,

    isPreviewHover: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_shared_selectors_app_settings__["y" /* isPreviewHover */])(state),
    isOverlayAlwaysShown: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_shared_selectors_app_settings__["A" /* isVideosListInfoAlwaysShown */])(state),
    isOverlayNeverShown: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_shared_selectors_app_settings__["B" /* isVideosListInfoNeverShown */])(state)
  };
}), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_13__video_thumbnail_overlay_styl___default.a), _dec(_class = _dec2(_class = (_temp = _class2 = function (_OverlayBase) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(VideoThumbnailOverlay, _OverlayBase);

  function VideoThumbnailOverlay() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, VideoThumbnailOverlay);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (VideoThumbnailOverlay.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(VideoThumbnailOverlay)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(VideoThumbnailOverlay, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          channelData = _props.channelData,
          videoItem = _props.videoItem,
          className = _props.className,
          isOverlayNeverShown = _props.isOverlayNeverShown,
          isOverlayAlwaysShown = _props.isOverlayAlwaysShown,
          isPreviewHover = _props.isPreviewHover,
          onClick = _props.onClick;


      if (!channelData || !videoItem) {
        return null;
      }

      var styleNames = __WEBPACK_IMPORTED_MODULE_6_classnames___default()('container', {
        'always-hidden': isOverlayNeverShown,
        'always-visible': isOverlayAlwaysShown,
        'preview-hover': isPreviewHover
      });

      return React.createElement(
        'div',
        { styleName: 'wrapper',
          onClick: onClick,
          'data-hook': 'videoListThumb' },
        this.cover,
        React.createElement(
          'div',
          { styleName: styleNames,
            className: className },
          React.createElement(
            'div',
            { styleName: 'content' },
            React.createElement(
              'div',
              { styleName: 'top-content',
                dir: 'ltr' },
              React.createElement(
                'div',
                { styleName: 'title-block' },
                this.title
              ),
              this.buttons
            )
          )
        )
      );
    }
  }, {
    key: 'titleText',
    get: function get() {
      var videoItem = this.props.videoItem;


      return videoItem.title;
    }
  }, {
    key: 'coverUrl',
    get: function get() {
      var videoItem = this.props.videoItem;


      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_shared_ui_selectors_video_cover__["a" /* getVideoCoverUrl */])(videoItem);
    }
  }]);

  return VideoThumbnailOverlay;
}(__WEBPACK_IMPORTED_MODULE_12_widget_views_desktop_compact_components_player_overlay_overlay__["c" /* OverlayBase */]), _class2.displayName = 'VideoThumbnailOverlay', _class2.propTypes = {
  onClick: React.PropTypes.func,
  isPreviewHover: React.PropTypes.bool,
  isOverlayAlwaysShown: React.PropTypes.bool,
  isOverlayNeverShown: React.PropTypes.bool
}, _temp)) || _class) || _class);


/***/ }),
/* 2553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VideoListItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_widget_views_desktop_compact_components_video_thumbnail_overlay_video_thumbnail_overlay__ = __webpack_require__(2552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__video_list_item_styl__ = __webpack_require__(3289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__video_list_item_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__video_list_item_styl__);






var _dec, _class, _class2, _temp;







// Fix for css-modules:
// Need to be separated component with css-modules decorator instead of plain jsx to provide proper styles
var VideoListItem = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_7__video_list_item_styl___default.a), _dec(_class = (_temp = _class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(VideoListItem, _React$Component);

  function VideoListItem() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, VideoListItem);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (VideoListItem.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(VideoListItem)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(VideoListItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          channelData = _props.channelData,
          videoItem = _props.videoItem,
          width = _props.width,
          height = _props.height,
          OverlayActionsCallbacks = _props.OverlayActionsCallbacks,
          onBeforeClick = _props.onBeforeClick,
          onBeforePlayRequested = _props.onBeforePlayRequested;


      return React.createElement(
        'div',
        { styleName: 'container',
          style: { height: height, width: width },
          'data-hook': 'videoListThumbWrapper' },
        React.createElement(
          OverlayActionsCallbacks,
          { channelId: channelData.id,
            videoId: videoItem.id,
            videoSource: videoItem.videoSource,
            onBeforeClick: onBeforeClick,
            onBeforePlayRequested: onBeforePlayRequested },
          React.createElement(__WEBPACK_IMPORTED_MODULE_6_widget_views_desktop_compact_components_video_thumbnail_overlay_video_thumbnail_overlay__["a" /* default */], { width: width,
            height: height,
            channelData: channelData,
            videoItem: videoItem })
        )
      );
    }
  }]);

  return VideoListItem;
}(React.Component), _class2.propTypes = {
  OverlayActionsCallbacks: React.PropTypes.func,
  onBeforeClick: React.PropTypes.func,
  onBeforePlayRequested: React.PropTypes.func,

  channelData: React.PropTypes.object,
  videoItem: React.PropTypes.object,

  width: React.PropTypes.number,
  height: React.PropTypes.number
}, _temp)) || _class);


/***/ }),
/* 2554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Videos; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_selectors_videos__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_bi_bi__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_widget_components_content_slider_content_slider__ = __webpack_require__(1827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_widget_components_page_list_page_list__ = __webpack_require__(1829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_widget_components_nav_nav__ = __webpack_require__(1728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_widget_views_desktop_compact_components_videos_video_list_item_video_list_item__ = __webpack_require__(2553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__videos_styl__ = __webpack_require__(3290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__videos_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__videos_styl__);








var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}















var Videos = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_redux__["a" /* connect */])(function (state) {
  return {
    videoByIds: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_shared_selectors_videos__["a" /* getVideosGroupedByIds */])(state)
  };
}), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_16__videos_styl___default.a), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Videos, _React$Component);

  function Videos() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Videos);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Videos.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Videos)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Videos, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var currentVideosPageNumber = _ref.currentVideosPageNumber;

      if (currentVideosPageNumber !== this.props.currentVideosPageNumber) {
        __WEBPACK_IMPORTED_MODULE_11_shared_bi_bi__["a" /* default */].logWidgetSystem('videoList.changePage.rendered', { previousEventName: 'videoList.changePage.requested' });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      __WEBPACK_IMPORTED_MODULE_11_shared_bi_bi__["a" /* default */].logWidgetSystem('videoList.show.rendered', { previousEventName: 'videoList.show.requested' });
    }
  }, {
    key: 'renderVideoItem',
    value: function renderVideoItem(videoId) {
      var _props = this.props,
          channelData = _props.channelData,
          videoByIds = _props.videoByIds,
          thumbnailSize = _props.thumbnailSize,
          OverlayActionsCallbacks = _props.OverlayActionsCallbacks,
          onBeforeClick = _props.onBeforeClick,
          onBeforePlayRequested = _props.onBeforePlayRequested;


      var videoItem = videoByIds[videoId];

      return React.createElement(__WEBPACK_IMPORTED_MODULE_15_widget_views_desktop_compact_components_videos_video_list_item_video_list_item__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, thumbnailSize, {
        OverlayActionsCallbacks: OverlayActionsCallbacks,
        onBeforeClick: onBeforeClick,
        onBeforePlayRequested: onBeforePlayRequested,
        channelData: channelData,
        videoItem: videoItem,
        key: videoId }));
    }
  }, {
    key: 'hasPage',
    value: function hasPage(pageNum) {
      var videoIdsByPageNumber = this.props.videoIdsByPageNumber;

      return Boolean(videoIdsByPageNumber[pageNum]);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          currentVideosPageNumber = _props2.currentVideosPageNumber,
          videoIdsByPageNumber = _props2.videoIdsByPageNumber,
          containerWidth = _props2.containerWidth,
          onSlideToPrev = _props2.onSlideToPrev,
          onSlideToNext = _props2.onSlideToNext;


      return React.createElement(
        'section',
        { styleName: 'container' },
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_12_widget_components_content_slider_content_slider__["a" /* default */],
          { width: containerWidth,
            currentPageNumber: currentVideosPageNumber },
          React.createElement(__WEBPACK_IMPORTED_MODULE_13_widget_components_page_list_page_list__["a" /* default */], { pageWidth: containerWidth,
            currentPageNumber: currentVideosPageNumber,
            itemsByPageNumber: videoIdsByPageNumber,
            renderItem: this.renderVideoItem })
        ),
        React.createElement(__WEBPACK_IMPORTED_MODULE_14_widget_components_nav_nav__["a" /* default */], { prevButtonClassName: __WEBPACK_IMPORTED_MODULE_16__videos_styl___default.a['prev-button'],
          nextButtonClassName: __WEBPACK_IMPORTED_MODULE_16__videos_styl___default.a['next-button'],
          onPrevClick: onSlideToPrev,
          onNextClick: onSlideToNext,
          isPrevVisible: this.isPrevPageVisible,
          isNextVisible: this.isNextPageVisible })
      );
    }
  }, {
    key: 'isPrevPageVisible',
    get: function get() {
      var currentVideosPageNumber = this.props.currentVideosPageNumber;

      return this.hasPage(currentVideosPageNumber - 1);
    }
  }, {
    key: 'isNextPageVisible',
    get: function get() {
      var currentVideosPageNumber = this.props.currentVideosPageNumber;

      return this.hasPage(currentVideosPageNumber + 1);
    }
  }]);

  return Videos;
}(React.Component), _class3.propTypes = {
  OverlayActionsCallbacks: React.PropTypes.func,

  channelData: React.PropTypes.object,

  containerWidth: React.PropTypes.number,

  videoByIds: React.PropTypes.object,
  videoIdsByPageNumber: React.PropTypes.array,

  thumbnailSize: React.PropTypes.shape({
    width: React.PropTypes.number,
    height: React.PropTypes.number
  }),

  onSlideToPrev: React.PropTypes.func,
  onSlideToNext: React.PropTypes.func,
  onBeforeClick: React.PropTypes.func,
  onBeforePlayRequested: React.PropTypes.func,

  currentVideosPageNumber: React.PropTypes.number
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'renderVideoItem', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'renderVideoItem'), _class2.prototype)), _class2)) || _class) || _class);


/***/ }),
/* 2555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WithTooltip; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__with_tooltip_styl__ = __webpack_require__(3291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__with_tooltip_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__with_tooltip_styl__);






var _dec, _class, _class2, _temp;





var WithTooltip = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_6__with_tooltip_styl___default.a), _dec(_class = (_temp = _class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(WithTooltip, _React$Component);

  function WithTooltip() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, WithTooltip);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (WithTooltip.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(WithTooltip)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(WithTooltip, [{
    key: 'renderTooltip',
    value: function renderTooltip() {
      var _props = this.props,
          tooltip = _props.tooltip,
          innerClassName = _props.innerClassName;


      return React.createElement(
        'span',
        { styleName: 'tooltip' },
        React.createElement(
          'span',
          { className: innerClassName,
            styleName: 'tooltip-inner' },
          tooltip
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          tooltip = _props2.tooltip,
          children = _props2.children,
          className = _props2.className;


      if (!children) {
        return null;
      }

      return React.createElement(
        'span',
        { className: className,
          styleName: 'with-tooltip' },
        tooltip && this.renderTooltip(),
        children
      );
    }
  }]);

  return WithTooltip;
}(React.Component), _class2.propTypes = {
  children: React.PropTypes.any,
  tooltip: React.PropTypes.any,
  className: React.PropTypes.string,
  innerClassName: React.PropTypes.string
}, _temp)) || _class);


/***/ }),
/* 2556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isActionBarVisible; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_selectors_app_settings__ = __webpack_require__(42);



var isActionBarVisible = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_1_shared_selectors_app_settings__["E" /* canShowActionBar */], __WEBPACK_IMPORTED_MODULE_1_shared_selectors_app_settings__["u" /* canShowVideoList */], function (isActionBarVisible, isVideoListVisible) {
  return isActionBarVisible || isVideoListVisible;
});

/***/ }),
/* 2557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DesktopViewsSwitcher; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_default_settings__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_selectors_app_settings__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_selectors_channels__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_widget_views_desktop_classic_classic__ = __webpack_require__(2530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_widget_views_desktop_strip_strip__ = __webpack_require__(2560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_widget_views_desktop_compact_compact__ = __webpack_require__(2537);







var _VIEWS_BY_LAYOUT_TYPE, _dec, _class, _class2, _temp;











var VIEWS_BY_LAYOUT_TYPES = (_VIEWS_BY_LAYOUT_TYPE = {}, __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_VIEWS_BY_LAYOUT_TYPE, __WEBPACK_IMPORTED_MODULE_7_default_settings__["d" /* channelLayoutValues */].STRIP, __WEBPACK_IMPORTED_MODULE_11_widget_views_desktop_strip_strip__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_VIEWS_BY_LAYOUT_TYPE, __WEBPACK_IMPORTED_MODULE_7_default_settings__["d" /* channelLayoutValues */].CLASSIC, __WEBPACK_IMPORTED_MODULE_10_widget_views_desktop_classic_classic__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_VIEWS_BY_LAYOUT_TYPE, __WEBPACK_IMPORTED_MODULE_7_default_settings__["d" /* channelLayoutValues */].COMPACT, __WEBPACK_IMPORTED_MODULE_12_widget_views_desktop_compact_compact__["a" /* default */]), _VIEWS_BY_LAYOUT_TYPE);

var DesktopViewsSwitcher = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_redux__["a" /* connect */])(function (state) {
  return {
    layout: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_shared_selectors_app_settings__["j" /* getChannelLayout */])(state),
    channelData: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_shared_selectors_channels__["a" /* getChannelForWidget */])(state)
  };
}), _dec(_class = (_temp = _class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(DesktopViewsSwitcher, _React$Component);

  function DesktopViewsSwitcher() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DesktopViewsSwitcher);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (DesktopViewsSwitcher.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(DesktopViewsSwitcher)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(DesktopViewsSwitcher, [{
    key: 'render',
    value: function render() {
      var layout = this.props.layout;


      if (!layout) {
        return null;
      }

      // TODO: remove if don`t needed
      if (_.isEmpty(this.props.channelData)) {
        return null;
      }

      var View = VIEWS_BY_LAYOUT_TYPES[layout] || __WEBPACK_IMPORTED_MODULE_10_widget_views_desktop_classic_classic__["a" /* default */];
      return React.createElement(View, this.props);
    }
  }]);

  return DesktopViewsSwitcher;
}(React.Component), _class2.propTypes = {
  layout: React.PropTypes.number,
  channelData: React.PropTypes.object
}, _temp)) || _class);


/***/ }),
/* 2558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VideoListItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_widget_components_videos_list_strip_thumbnail_overlay_thumbnail_overlay__ = __webpack_require__(2524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_widget_components_thumbnail_simple__ = __webpack_require__(1731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__video_list_item_styl__ = __webpack_require__(3292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__video_list_item_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__video_list_item_styl__);







var _dec, _class, _desc, _value, _class2, _class3, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}









var VideoListItem = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_10__video_list_item_styl___default.a), _dec(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(VideoListItem, _React$Component);

  function VideoListItem() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, VideoListItem);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (VideoListItem.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(VideoListItem)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(VideoListItem, [{
    key: 'handleClick',
    value: function handleClick() {
      var _props = this.props,
          videoItem = _props.videoItem,
          onClick = _props.onClick;

      onClick(videoItem);
    }
  }, {
    key: 'handlePlayClick',
    value: function handlePlayClick() {
      var _props2 = this.props,
          videoItem = _props2.videoItem,
          onPlayRequest = _props2.onPlayRequest;

      onPlayRequest(videoItem);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          channelData = _props3.channelData,
          videoItem = _props3.videoItem,
          width = _props3.width,
          height = _props3.height,
          appSettings = _props3.appSettings;


      return React.createElement(
        'div',
        { styleName: 'container',
          onClick: this.handleClick,
          style: { height: height, width: width },
          'data-hook': 'videoListThumbWrapper' },
        React.createElement(__WEBPACK_IMPORTED_MODULE_9_widget_components_thumbnail_simple__["a" /* SimpleVideoThumbnail */], { video: videoItem,
          width: width,
          height: height }),
        React.createElement(__WEBPACK_IMPORTED_MODULE_8_widget_components_videos_list_strip_thumbnail_overlay_thumbnail_overlay__["a" /* default */], { styleName: 'overlay',
          channelData: channelData,
          videoItem: videoItem,
          width: width,
          appSettings: appSettings,
          playSelectedVideo: this.handlePlayClick })
      );
    }
  }]);

  return VideoListItem;
}(React.Component), _class3.propTypes = {
  appSettings: React.PropTypes.object,
  channelData: React.PropTypes.object,
  videoItem: React.PropTypes.object,

  width: React.PropTypes.number,
  height: React.PropTypes.number,

  onPlayRequest: React.PropTypes.func,
  onClick: React.PropTypes.func
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'handleClick', [__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handleClick'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handlePlayClick', [__WEBPACK_IMPORTED_MODULE_6_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handlePlayClick'), _class2.prototype)), _class2)) || _class);


/***/ }),
/* 2559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Videos; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_selectors_videos__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_selectors_app_settings__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_bi_bi__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_widget_components_content_slider_content_slider__ = __webpack_require__(1827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_widget_components_page_list_page_list__ = __webpack_require__(1829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_widget_components_nav_nav__ = __webpack_require__(1728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_widget_views_desktop_strip_components_videos_video_list_item_video_list_item__ = __webpack_require__(2558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__videos_styl__ = __webpack_require__(3293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__videos_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__videos_styl__);








var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}
















var Videos = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_redux__["a" /* connect */])(function (state) {
  return {
    videoByIds: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_shared_selectors_videos__["a" /* getVideosGroupedByIds */])(state),
    appSettings: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_shared_selectors_app_settings__["a" /* getAllSettings */])(state)
  };
}), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_shared_utils_wix_connect__["b" /* VODCSSModules */])(__WEBPACK_IMPORTED_MODULE_17__videos_styl___default.a), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Videos, _React$Component);

  function Videos() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Videos);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Videos.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Videos)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Videos, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      __WEBPACK_IMPORTED_MODULE_12_shared_bi_bi__["a" /* default */].logWidgetSystem('videoList.show.rendered', { previousEventName: 'videoList.show.requested' });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var currentVideosPageNumber = _ref.currentVideosPageNumber;

      if (currentVideosPageNumber !== this.props.currentVideosPageNumber) {
        __WEBPACK_IMPORTED_MODULE_12_shared_bi_bi__["a" /* default */].logWidgetSystem('videoList.changePage.rendered', { previousEventName: 'videoList.changePage.requested' });
      }
    }
  }, {
    key: 'renderVideoItem',
    value: function renderVideoItem(videoId) {
      var _props = this.props,
          channelData = _props.channelData,
          videoByIds = _props.videoByIds,
          thumbnailSize = _props.thumbnailSize,
          appSettings = _props.appSettings,
          onThumbnailClick = _props.onThumbnailClick,
          onPlayRequest = _props.onPlayRequest;


      return React.createElement(__WEBPACK_IMPORTED_MODULE_16_widget_views_desktop_strip_components_videos_video_list_item_video_list_item__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, thumbnailSize, {
        channelData: channelData,
        videoItem: videoByIds[videoId],
        appSettings: appSettings,
        key: videoId,
        onClick: onThumbnailClick,
        onPlayRequest: onPlayRequest }));
    }
  }, {
    key: 'hasPage',
    value: function hasPage(pageNum) {
      var videoIdsByPageNumber = this.props.videoIdsByPageNumber;

      return Boolean(videoIdsByPageNumber[pageNum]);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          currentVideosPageNumber = _props2.currentVideosPageNumber,
          videoIdsByPageNumber = _props2.videoIdsByPageNumber,
          containerWidth = _props2.containerWidth,
          onSlideToPrev = _props2.onSlideToPrev,
          onSlideToNext = _props2.onSlideToNext;


      return React.createElement(
        'section',
        { styleName: 'container' },
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_13_widget_components_content_slider_content_slider__["a" /* default */],
          { width: containerWidth,
            currentPageNumber: currentVideosPageNumber },
          React.createElement(__WEBPACK_IMPORTED_MODULE_14_widget_components_page_list_page_list__["a" /* default */], { pageWidth: containerWidth,
            currentPageNumber: currentVideosPageNumber,
            itemsByPageNumber: videoIdsByPageNumber,
            renderItem: this.renderVideoItem })
        ),
        React.createElement(__WEBPACK_IMPORTED_MODULE_15_widget_components_nav_nav__["a" /* default */], { prevButtonClassName: __WEBPACK_IMPORTED_MODULE_17__videos_styl___default.a['prev-button'],
          nextButtonClassName: __WEBPACK_IMPORTED_MODULE_17__videos_styl___default.a['next-button'],
          onPrevClick: onSlideToPrev,
          onNextClick: onSlideToNext,
          isPrevVisible: this.isPrevPageVisible,
          isNextVisible: this.isNextPageVisible })
      );
    }
  }, {
    key: 'isPrevPageVisible',
    get: function get() {
      var currentVideosPageNumber = this.props.currentVideosPageNumber;

      return this.hasPage(currentVideosPageNumber - 1);
    }
  }, {
    key: 'isNextPageVisible',
    get: function get() {
      var currentVideosPageNumber = this.props.currentVideosPageNumber;

      return this.hasPage(currentVideosPageNumber + 1);
    }
  }]);

  return Videos;
}(React.Component), _class3.propTypes = {
  appSettings: React.PropTypes.object,
  channelData: React.PropTypes.object,

  containerWidth: React.PropTypes.number,

  videoByIds: React.PropTypes.object,
  videoIdsByPageNumber: React.PropTypes.array,

  thumbnailSize: React.PropTypes.shape({
    width: React.PropTypes.number,
    height: React.PropTypes.number
  }),

  onSlideToPrev: React.PropTypes.func,
  onSlideToNext: React.PropTypes.func,
  onPlayRequest: React.PropTypes.func,
  onThumbnailClick: React.PropTypes.func,

  currentVideosPageNumber: React.PropTypes.number
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'renderVideoItem', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'renderVideoItem'), _class2.prototype)), _class2)) || _class) || _class);


/***/ }),
/* 2560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StripView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_get__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_utils_deal_info_helpers__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_shared_analytics_new_relic__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_shared_utils_wix_sdk__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_shared_utils_device_screen__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_shared_utils_open_overlay__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_widget_utils_reload__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_widget_utils_videos_sizes__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_widget_utils_video_list__ = __webpack_require__(1737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_shared_utils_layout_helpers__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_widget_components_overlay_texts_channel_subscribe_button_text__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_widget_redux_client_actions_select_video__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_widget_redux_client_actions_change_playback_status__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__redux_client_actions_search__ = __webpack_require__(1290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_widget_ui_selectors_selected_video_id__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_widget_selectors_video_playback_status__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_shared_selectors_app_settings__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_shared_selectors_videos__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__shared_selectors_search__ = __webpack_require__(1813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_widget_selectors_current_site_user__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_shared_bi_bi__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_widget_data_components_paginated_channel_videos__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_widget_views_base__ = __webpack_require__(1553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_shared_components_icon_icon__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_shared_components_button_button__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_shared_components_dropdown_dropdown__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_widget_data_components_update_widget_size__ = __webpack_require__(1551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_widget_components_account_account_button_account_button__ = __webpack_require__(1823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_widget_components_channel_actions_channel_info_button__ = __webpack_require__(1826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_widget_components_channel_actions_channel_subscription_button__ = __webpack_require__(2004);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_widget_components_share_channel_share_channel__ = __webpack_require__(1834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_widget_components_players_fs_modal_player__ = __webpack_require__(2515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_widget_components_players_mobile_player__ = __webpack_require__(1260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_widget_views_desktop_strip_player_fs_buy_extensions__ = __webpack_require__(1839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_widget_components_categories_categories__ = __webpack_require__(2003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_widget_components_tags_tags__ = __webpack_require__(1584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_widget_components_nav_nav__ = __webpack_require__(1728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_widget_components_search_bar_search_bar__ = __webpack_require__(2010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_widget_views_desktop_strip_components_videos_videos__ = __webpack_require__(2559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_widget_components_player_overlay_strip_strip__ = __webpack_require__(1833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_widget_components_player_overlay_strip_member_only__ = __webpack_require__(1832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_shared_components_payment_events_payment_events__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_widget_components_empty_search_results_empty_search_results__ = __webpack_require__(2006);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_widget_components_button_button__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_shared_constants_view_modes__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_widget_components_reload_storage_reload_storage__ = __webpack_require__(1549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__strip_styl__ = __webpack_require__(3294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__strip_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59__strip_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__translations__ = __webpack_require__(2561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_widget_translations__ = __webpack_require__(1619);










var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

































































var SEARCH_LINE_HEIGHT = 42;
var FIXED_NO_SEARCH_RESULT_MIN_HEIGHT = 350;
var IS_MOBILE_DEVICE = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17_shared_utils_device_screen__["a" /* isMobile */])() || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17_shared_utils_device_screen__["b" /* isTablet */])();
var DEFAULT_STATE = {
  isTagFocused: false,
  isSearchInputFocused: false,
  searchLayout: false,
  currentCategory: null,
  areAllVideosVisible: false,
  isInFullScreen: false
};

var StripPlayer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_46_widget_views_desktop_strip_player_fs_buy_extensions__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_44_widget_components_players_fs_modal_player__["a" /* default */]);

var StripView = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_react_redux__["a" /* connect */])(function (state, ownProps) {
  return {
    mainVideoId: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27_widget_ui_selectors_selected_video_id__["a" /* getMainVideoId */])(state, __WEBPACK_IMPORTED_MODULE_34_widget_data_components_paginated_channel_videos__["a" /* DATA_KEY */]),
    isVideoPlaying: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_28_widget_selectors_video_playback_status__["a" /* isVideoPlayingOptimistic */])(state),
    currentChannelId: state.currentChannelId,
    canShowChannelCover: !state.isVideosTouched,
    appSettings: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29_shared_selectors_app_settings__["a" /* getAllSettings */])(state),
    firstChannelVideoId: state.firstChannelVideoId,

    videoIdsByPageNumber: ownProps.paginatedChannelVideos.idChunks,
    currentVideosPageNumber: ownProps.paginatedChannelVideos.currentUIPage,
    prevVideoId: ownProps.nextChannelVideos.prevId,
    nextVideoId: ownProps.nextChannelVideos.nextId,
    goToPrevVideosPage: ownProps.paginatedChannelVideos.goBack,
    goToNextVideosPage: ownProps.paginatedChannelVideos.goForward,
    goToFirstVideosPage: ownProps.paginatedChannelVideos.toFirstPage,
    videoByIds: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_30_shared_selectors_videos__["a" /* getVideosGroupedByIds */])(state),
    fetchVideos: ownProps.paginatedChannelVideos.fetch,
    isVideosFetching: ownProps.paginatedChannelVideos.isFetching,
    currentSiteUser: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32_widget_selectors_current_site_user__["a" /* getCurrentSiteUser */])(state),

    isSignInVisible: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_shared_utils_layout_helpers__["e" /* isSignInVisible */])(state.appSettings),
    isSearchInputVisible: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_shared_utils_layout_helpers__["i" /* isSearchInputVisible */])(state.appSettings, ownProps.channelData),
    isCategoriesDropdownVisible: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_shared_utils_layout_helpers__["f" /* isCategoriesDropdownVisible */])(state.appSettings, ownProps.channelData),

    searchQuery: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31__shared_selectors_search__["a" /* getSearchQuery */])(state),
    searchQueryField: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_31__shared_selectors_search__["b" /* getSearchQueryField */])(state)
  };
}, {
  selectVideo: __WEBPACK_IMPORTED_MODULE_24_widget_redux_client_actions_select_video__["a" /* selectVideo */],
  resetSelectedVideo: __WEBPACK_IMPORTED_MODULE_24_widget_redux_client_actions_select_video__["b" /* resetSelectedVideo */],
  playVideo: __WEBPACK_IMPORTED_MODULE_25_widget_redux_client_actions_change_playback_status__["a" /* playVideo */],
  pauseVideo: __WEBPACK_IMPORTED_MODULE_25_widget_redux_client_actions_change_playback_status__["e" /* pauseVideo */],
  updateSearch: __WEBPACK_IMPORTED_MODULE_26__redux_client_actions_search__["b" /* updateSearch */],
  resetSearch: __WEBPACK_IMPORTED_MODULE_26__redux_client_actions_search__["c" /* resetSearch */]
}), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_shared_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_59__strip_styl___default.a), _dec3 = __WEBPACK_IMPORTED_MODULE_11_core_decorators_lib_autobind___default()(), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_BaseView) {
  __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits___default()(StripView, _BaseView);

  function StripView(props) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, StripView);

    var _this = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (StripView.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(StripView)).call(this, props));

    _this.containerEl = null;
    _this.resizeByContentInterval = null;
    _this.currentContentHeight = 0;


    _this.state = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
      searchBarValue: props.searchQuery,
      isInitialVideosLoaded: false
    }, DEFAULT_STATE, _this.getDefaultPlayerConfig(props));

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_shared_analytics_new_relic__["a" /* getNewRelic */])().setCustomAttribute('layout', 'strip');
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(StripView, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_get___default()(StripView.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(StripView.prototype), 'componentDidMount', this).call(this);
      this.resizeByContentInterval = setInterval(this.resizeByContent, 300);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_get___default()(StripView.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(StripView.prototype), 'componentWillReceiveProps', this).call(this, nextProps);
      if (__WEBPACK_IMPORTED_MODULE_16_shared_utils_wix_sdk__["a" /* default */].Utils.getViewMode() === __WEBPACK_IMPORTED_MODULE_57_shared_constants_view_modes__["a" /* default */].EDITOR && this.hasPreviewBecameActive(nextProps)) {
        this.reset(nextProps);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_get___default()(StripView.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(StripView.prototype), 'componentWillUnmount', this).call(this);
      clearInterval(this.resizeByContentInterval);
    }
  }, {
    key: 'isVideoPreviewMode',
    value: function isVideoPreviewMode() {
      // TODO: clean up video preview
      return false;
    }
  }, {
    key: 'getDefaultPlayerConfig',
    value: function getDefaultPlayerConfig() {
      return {
        // TODO: move to selector or method. Probably will be used with isWidgetTouched (old canShowChannelCover)
        isVideoPreview: false
      };
    }
  }, {
    key: 'handleSlideToPrev',
    value: function handleSlideToPrev() {
      __WEBPACK_IMPORTED_MODULE_33_shared_bi_bi__["a" /* default */].logWidgetSystem('videoList.changePage.requested');
      this.props.goToPrevVideosPage();
    }
  }, {
    key: 'handleSlideToNext',
    value: function handleSlideToNext() {
      __WEBPACK_IMPORTED_MODULE_33_shared_bi_bi__["a" /* default */].logWidgetSystem('videoList.changePage.requested');
      this.props.goToNextVideosPage();
    }
  }, {
    key: 'handleThumbnailClick',
    value: function handleThumbnailClick(video) {
      if (video.id !== this.props.mainVideoId || this.canShowChannelCover) {
        this.selectVideo({
          id: video.id
        });
      }
    }
  }, {
    key: 'reset',
    value: function reset() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_get___default()(StripView.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(StripView.prototype), 'reset', this).call(this);

      this.setState(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
        searchBarValue: ''
      }, DEFAULT_STATE, this.getDefaultPlayerConfig(props)));
      this.props.goToFirstVideosPage();
    }
  }, {
    key: 'setContainerEl',
    value: function setContainerEl(el) {
      this.containerEl = el;
    }
  }, {
    key: 'resizeByContent',
    value: function resizeByContent() {
      var height = Math.ceil(this.contentHeight);
      if (!height || height === this.currentContentHeight) {
        return;
      }

      this.currentContentHeight = height;
      __WEBPACK_IMPORTED_MODULE_16_shared_utils_wix_sdk__["a" /* default */].setHeight(height, { overflow: false });
    }
  }, {
    key: 'hasPreviewBecameActive',
    value: function hasPreviewBecameActive(nextProps) {
      // TODO: rename to videoAsBackground
      return !this.state.isVideoPreview && this.isVideoPreviewMode(nextProps);
    }
  }, {
    key: 'storeDataForReload',
    value: function storeDataForReload() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19_widget_utils_reload__["a" /* storeForReload */])({
        selectedVideoId: this.props.mainVideoId
      });
    }
  }, {
    key: 'showChannelInfo',
    value: function showChannelInfo(event) {
      event.preventDefault();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18_shared_utils_open_overlay__["f" /* openFullScreenChannelOverlay */])(this.props.channelData.id);
    }
  }, {
    key: 'openMembership',
    value: function openMembership() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18_shared_utils_open_overlay__["b" /* openFullScreenMemberOnlyOverlay */])(this.props.channelData.id, this.mainVideo.id);
    }
  }, {
    key: 'processDataFromStorage',
    value: function processDataFromStorage(data) {
      var selectedVideoId = data.selectedVideoId,
          openOverlay = data.openOverlay,
          autoplay = data.autoplay;
      var _props = this.props,
          selectVideo = _props.selectVideo,
          resetSelectedVideo = _props.resetSelectedVideo;


      if (!selectedVideoId) {
        resetSelectedVideo();
        return;
      }

      selectVideo(selectedVideoId);
      this.toggleVisibilityAllVideos();
      if (openOverlay) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18_shared_utils_open_overlay__["a" /* openFullScreenOverlay */])('#/channel/' + this.props.channelData.id + '/video/' + selectedVideoId + '?autoplay=' + autoplay);
      }
    }
  }, {
    key: 'playVideo',
    value: function playVideo(videoData) {
      var _props2 = this.props,
          currentSiteUser = _props2.currentSiteUser,
          channelData = _props2.channelData,
          mainVideoId = _props2.mainVideoId;
      var id = videoData.id,
          memberOnly = videoData.memberOnly;


      if (IS_MOBILE_DEVICE) {
        // we can`t start playing for not rendered player because of browser restriction
        if (id === mainVideoId) {
          return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_get___default()(StripView.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(StripView.prototype), 'playVideo', this).call(this, videoData);
        }
        return this.onThumbnailClicked(videoData);
      }

      if (!memberOnly || memberOnly && currentSiteUser) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18_shared_utils_open_overlay__["a" /* openFullScreenOverlay */])('#/channel/' + channelData.id + '/video/' + id + '?autoplay=true');
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18_shared_utils_open_overlay__["b" /* openFullScreenMemberOnlyOverlay */])(channelData.id, id);
      }
    }
  }, {
    key: 'getPlayerOverlay',
    value: function getPlayerOverlay(videoItem) {
      var _props3 = this.props,
          appSettings = _props3.appSettings,
          channelData = _props3.channelData;

      var hasBottomContent = this.hasBottomContent;

      var buttonsWrapperClassName = __WEBPACK_IMPORTED_MODULE_10_classnames___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_59__strip_styl___default.a['buttons-wrapper-no-margin'], !hasBottomContent));

      return React.createElement(__WEBPACK_IMPORTED_MODULE_52_widget_components_player_overlay_strip_strip__["a" /* default */], { styleName: 'player-overlay',
        buttonsWrapperClassName: buttonsWrapperClassName,
        channelData: channelData,
        appSettings: appSettings,
        videoItem: videoItem,
        showChannelCover: this.canShowChannelCover,
        playSelectedVideo: this.playVideo,
        playNextVideo: this.playNextVideo,
        areAllVideosVisible: this.shouldRenderVideos,
        toggleVisibilityAllVideos: this.handleUserToggleVisibilityAllVideos,
        showChannelInfo: this.showChannelInfo });
    }
  }, {
    key: 'handleUserToggleVisibilityAllVideos',
    value: function handleUserToggleVisibilityAllVideos() {
      if (!this.state.areAllVideosVisible) {
        __WEBPACK_IMPORTED_MODULE_33_shared_bi_bi__["a" /* default */].logWidgetSystem('videoList.show.requested');
      }
      this.toggleVisibilityAllVideos();
    }
  }, {
    key: 'toggleVisibilityAllVideos',
    value: function toggleVisibilityAllVideos() {
      this.setState({
        areAllVideosVisible: !this.state.areAllVideosVisible
      });
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.isUIBlockingDataLoaded) {
        return this.spinner;
      }

      return React.createElement(
        'section',
        { styleName: 'container',
          ref: this.setContainerEl,
          className: 'qa-widget-container' },
        React.createElement(__WEBPACK_IMPORTED_MODULE_39_widget_data_components_update_widget_size__["a" /* default */], { disabled: this.state.isInFullScreen }),
        React.createElement(__WEBPACK_IMPORTED_MODULE_58_widget_components_reload_storage_reload_storage__["a" /* default */], { onReload: this.processDataFromStorage }),
        this.playerContainer,
        this.videos,
        React.createElement(__WEBPACK_IMPORTED_MODULE_54_shared_components_payment_events_payment_events__["a" /* default */], { onRent: this.setCurrentVideoFromPayment,
          onSale: this.setCurrentVideoFromPayment,
          onSubscription: this.reset,
          onSubscriptionCancel: this.reset })
      );
    }
  }, {
    key: 'shouldRenderVideos',
    get: function get() {
      var appSettings = this.props.appSettings;


      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_widget_utils_video_list__["b" /* isExpandOnClick */])(appSettings.numbers.videoListVisibility) ? this.state.areAllVideosVisible : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_widget_utils_video_list__["c" /* isAlwaysShow */])(appSettings.numbers.videoListVisibility);
    }
  }, {
    key: 'shouldRenderAllVideosButton',
    get: function get() {
      var appSettings = this.props.appSettings;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_widget_utils_video_list__["b" /* isExpandOnClick */])(appSettings.numbers.videoListVisibility) && !this.state.areAllVideosVisible;
    }
  }, {
    key: 'listThumbnailSize',
    get: function get() {
      var widgetWidth = window.innerWidth;
      var videosInRow = this.props.appSettings.numbers.videosInRow;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_widget_utils_videos_sizes__["j" /* stripLayoutThumbnailSize */])(widgetWidth, videosInRow);
    }
  }, {
    key: 'videosListHeight',
    get: function get() {
      var _props4 = this.props,
          appSettings = _props4.appSettings,
          channelData = _props4.channelData;
      var _appSettings$numbers = appSettings.numbers,
          videosInRow = _appSettings$numbers.videosInRow,
          numberOfRows = _appSettings$numbers.numberOfRows;

      var videosCount = Math.min(channelData.videosCount, videosInRow * numberOfRows);

      return this.listThumbnailSize.height * Math.ceil(videosCount / videosInRow);
    }
  }, {
    key: 'contentHeight',
    get: function get() {
      if (!this.containerEl) {
        return 0;
      }
      return this.containerEl.clientHeight;
    }
  }, {
    key: 'widgetHeight',
    get: function get() {
      return _.get(this.props, 'appSettings.requestedWidgetSize.height');
    }
  }, {
    key: 'tagList',
    get: function get() {
      return _.get(this.props, 'channelData.statsInfo.tags') || [];
    }
  }, {
    key: 'categoriesList',
    get: function get() {
      var categoriesStats = _.get(this.props, 'channelData.statsInfo.categories') || [];
      return _.map(categoriesStats, 'value');
    }
  }, {
    key: 'tags',
    get: function get() {
      var _state = this.state,
          searchLayout = _state.searchLayout,
          searchBarValue = _state.searchBarValue;


      var tags = this.tagList;

      if (!tags.length || !searchLayout && !searchBarValue || this.props.searchQuery) {
        return null;
      }

      return React.createElement(__WEBPACK_IMPORTED_MODULE_48_widget_components_tags_tags__["a" /* default */], { styleName: 'tags',
        onTagFocus: this.handleTagsFocus,
        onTagBlur: this.handleTagsBlur,
        onTagClick: this.searchByTag,
        tags: tags });
    }
  }, {
    key: 'noSearchResults',
    get: function get() {
      if (!this.hasNoSearchResults) {
        return null;
      }

      var styleNames = __WEBPACK_IMPORTED_MODULE_10_classnames___default()('no-search-results', {
        stretched: this.videosListHeight < FIXED_NO_SEARCH_RESULT_MIN_HEIGHT
      });

      return React.createElement(__WEBPACK_IMPORTED_MODULE_55_widget_components_empty_search_results_empty_search_results__["a" /* default */], { styleName: styleNames });
    }
  }, {
    key: 'videosList',
    get: function get() {
      var _props5 = this.props,
          channelData = _props5.channelData,
          videoIdsByPageNumber = _props5.videoIdsByPageNumber,
          currentVideosPageNumber = _props5.currentVideosPageNumber,
          isVideosFetching = _props5.isVideosFetching;

      var noVideosLoaded = !videoIdsByPageNumber.length;

      if (isVideosFetching && noVideosLoaded || !this.mainVideo) {
        return null;
      }

      return React.createElement(__WEBPACK_IMPORTED_MODULE_51_widget_views_desktop_strip_components_videos_videos__["a" /* default */], { styleName: 'videos',
        containerWidth: this.playerSize.width,
        videoIdsByPageNumber: videoIdsByPageNumber,
        currentVideosPageNumber: currentVideosPageNumber,
        onSlideToNext: this.handleSlideToNext,
        onSlideToPrev: this.handleSlideToPrev,
        channelData: channelData,
        onPlayRequest: this.playVideo,
        onThumbnailClick: this.handleThumbnailClick,
        thumbnailSize: this.listThumbnailSize });
    }
  }, {
    key: 'closeVideosButton',
    get: function get() {
      var appSettings = this.props.appSettings;
      var _appSettings$booleans = appSettings.booleans,
          showChannelShare = _appSettings$booleans.showChannelShare,
          showChannelInfo = _appSettings$booleans.showChannelInfo,
          showSignIn = _appSettings$booleans.showSignIn;

      var isAllActionsDisabled = !showChannelShare && !showChannelInfo && !this.canSubscribe && !showSignIn;

      if (!this.shouldRenderVideos || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_widget_utils_video_list__["c" /* isAlwaysShow */])(appSettings.numbers.videoListVisibility)) {
        return null;
      }

      var extendedCloseButton = React.createElement(
        'span',
        null,
        React.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */], __WEBPACK_IMPORTED_MODULE_60__translations__["a" /* default */].close),
        React.createElement(__WEBPACK_IMPORTED_MODULE_36_shared_components_icon_icon__["a" /* default */], { styleName: 'small-close-icon',
          name: 'add' })
      );

      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_37_shared_components_button_button__["e" /* LinkButton */],
        { styleName: 'action',
          onClick: this.handleUserToggleVisibilityAllVideos },
        isAllActionsDisabled ? extendedCloseButton : React.createElement(__WEBPACK_IMPORTED_MODULE_36_shared_components_icon_icon__["a" /* default */], { styleName: 'normal-close-icon',
          name: 'add' })
      );
    }
  }, {
    key: 'categories',
    get: function get() {
      var _props6 = this.props,
          isCategoriesDropdownVisible = _props6.isCategoriesDropdownVisible,
          appSettings = _props6.appSettings,
          searchQuery = _props6.searchQuery;


      if (!isCategoriesDropdownVisible) {
        return null;
      }

      var _state2 = this.state,
          searchLayout = _state2.searchLayout,
          currentCategory = _state2.currentCategory,
          searchBarValue = _state2.searchBarValue;
      var videoListVisibility = appSettings.numbers.videoListVisibility;
      var showChannelCategories = appSettings.booleans.showChannelCategories;


      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_widget_utils_video_list__["a" /* isNeverShow */])(videoListVisibility) || searchLayout || !this.isCategorySelected && (searchQuery || searchBarValue) || !showChannelCategories) {
        return null;
      }

      return React.createElement(__WEBPACK_IMPORTED_MODULE_47_widget_components_categories_categories__["a" /* default */], { styleName: 'categories',
        DropdownClass: __WEBPACK_IMPORTED_MODULE_38_shared_components_dropdown_dropdown__["b" /* StripWidgetDropdown */],
        height: SEARCH_LINE_HEIGHT,
        list: this.categoriesList,
        onCategorySelect: this.searchByCategory,
        selectedCategory: currentCategory });
    }
  }, {
    key: 'shareChannel',
    get: function get() {
      return React.createElement(__WEBPACK_IMPORTED_MODULE_43_widget_components_share_channel_share_channel__["b" /* default */], { channelData: this.props.channelData,
        buttonsClassName: __WEBPACK_IMPORTED_MODULE_59__strip_styl___default.a['share-buttons'],
        styleName: 'share-channel action' });
    }
  }, {
    key: 'canSubscribe',
    get: function get() {
      var channelData = this.props.channelData;

      var subscriptionPriceInfo = __WEBPACK_IMPORTED_MODULE_13_shared_utils_deal_info_helpers__["a" /* getSubscriptionPriceInfo */](channelData.dealInfo);

      return !_.get(channelData, 'dgsInfo.subscription') && subscriptionPriceInfo;
    }
  }, {
    key: 'signInButton',
    get: function get() {
      var _props7 = this.props,
          isSignInVisible = _props7.isSignInVisible,
          channelData = _props7.channelData;


      if (!isSignInVisible) {
        return null;
      }

      return React.createElement(__WEBPACK_IMPORTED_MODULE_40_widget_components_account_account_button_account_button__["a" /* default */], { styleName: 'action',
        className: 'qa-widget-channel-account',
        infoButtonClassName: __WEBPACK_IMPORTED_MODULE_59__strip_styl___default.a['account-button'],
        channelData: channelData,
        onClick: this.openAccountInfoAtOverlay,
        onLoginClick: this.showLogInForm,
        onLogoutClick: this.logOut,
        onSubscribeClick: this.openSubscription,
        onSubscriptionCancelClick: this.processSubscriptionCancel });
    }
  }, {
    key: 'channelActions',
    get: function get() {
      var _props8 = this.props,
          channelData = _props8.channelData,
          searchQuery = _props8.searchQuery,
          appSettings = _props8.appSettings;
      var _state3 = this.state,
          searchLayout = _state3.searchLayout,
          searchBarValue = _state3.searchBarValue;


      var value = this.isCategorySelected ? '' : searchQuery;

      if (searchLayout || value || searchBarValue) {
        return null;
      }

      var closeVideoButton = this.closeVideosButton;

      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_shared_utils_layout_helpers__["h" /* isChannelShareVisible */])(appSettings) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_shared_utils_layout_helpers__["g" /* isChannelInfoVisible */])(appSettings) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23_widget_components_overlay_texts_channel_subscribe_button_text__["a" /* isVisible */])({ channel: channelData }) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_shared_utils_layout_helpers__["e" /* isSignInVisible */])(appSettings) && !closeVideoButton) {
        return null;
      }

      return React.createElement(
        'div',
        { styleName: 'channel-actions',
          className: 'qa-widget-channel-actions' },
        this.shareChannel,
        React.createElement(__WEBPACK_IMPORTED_MODULE_41_widget_components_channel_actions_channel_info_button__["a" /* default */], { styleName: 'action',
          className: 'qa-widget-channel-info',
          channelData: channelData,
          onClick: this.showChannelInfo }),
        React.createElement(__WEBPACK_IMPORTED_MODULE_42_widget_components_channel_actions_channel_subscription_button__["a" /* default */], { styleName: 'action',
          className: 'qa-widget-overlay-subscribe-button',
          channelData: channelData,
          onClick: this.openSubscription }),
        this.signInButton,
        closeVideoButton
      );
    }
  }, {
    key: 'searchBar',
    get: function get() {
      var _props9 = this.props,
          isSearchInputVisible = _props9.isSearchInputVisible,
          appSettings = _props9.appSettings,
          searchQuery = _props9.searchQuery;


      if (!isSearchInputVisible) {
        return null;
      }

      var _state4 = this.state,
          searchLayout = _state4.searchLayout,
          searchBarValue = _state4.searchBarValue;

      var value = this.isCategorySelected ? '' : searchQuery;
      var isExpanded = searchLayout || value || searchBarValue;
      var booleans = appSettings.booleans,
          numbers = appSettings.numbers;
      var videoListVisibility = numbers.videoListVisibility;
      var showSearch = booleans.showSearch;


      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_widget_utils_video_list__["a" /* isNeverShow */])(videoListVisibility) || !showSearch) {
        return null;
      }

      return React.createElement(__WEBPACK_IMPORTED_MODULE_50_widget_components_search_bar_search_bar__["b" /* StripSearchBar */], { styleName: __WEBPACK_IMPORTED_MODULE_10_classnames___default()('search', { expanded: isExpanded }),
        className: 'qa-widget-searchbar',
        value: value,
        onFocus: this.handleSearchInputFocus,
        onBlur: this.handleSearchInputBlur,
        onChange: this.setSearchBarValue,
        onClose: this.clearSearch,
        onSearch: this.searchByQuery });
    }
  }, {
    key: 'searchLine',
    get: function get() {
      var searchBar = this.searchBar;
      var categories = this.categories;
      var channelActions = this.channelActions;
      var _props10 = this.props,
          appSettings = _props10.appSettings,
          isVideoPlaying = _props10.isVideoPlaying;


      if (!this.shouldRenderVideos && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_widget_utils_video_list__["a" /* isNeverShow */])(appSettings.numbers.videoListVisibility) || IS_MOBILE_DEVICE && isVideoPlaying || !searchBar && !categories && !channelActions) {
        return null;
      }

      return React.createElement(
        'div',
        { styleName: 'search-line',
          className: 'qa-widget-search-line' },
        channelActions,
        searchBar,
        categories
      );
    }
  }, {
    key: 'allVideosButton',
    get: function get() {
      var isVideoPlaying = this.props.isVideoPlaying;

      if (!this.shouldRenderAllVideosButton || IS_MOBILE_DEVICE && isVideoPlaying) {
        return null;
      }

      return React.createElement(
        'div',
        { styleName: 'all-videos' },
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_56_widget_components_button_button__["a" /* default */],
          { styleName: 'button',
            disableTheme: true,
            'data-hook': 'allVideos',
            className: 'qa-widget-overlay-all-videos-button',
            onClick: this.handleUserToggleVisibilityAllVideos },
          React.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */], __WEBPACK_IMPORTED_MODULE_60__translations__["a" /* default */].allVideos),
          React.createElement(__WEBPACK_IMPORTED_MODULE_36_shared_components_icon_icon__["a" /* default */], { name: 'add',
            styleName: 'icon' })
        )
      );
    }
  }, {
    key: 'videos',
    get: function get() {
      var channelData = this.props.channelData;


      if (!channelData || !this.shouldRenderVideos) {
        return null;
      }

      if (!channelData.videosCount) {
        return React.createElement(
          'div',
          { styleName: 'coming-soon',
            style: { minHeight: this.listThumbnailSize.height } },
          React.createElement(__WEBPACK_IMPORTED_MODULE_9_react_intl__["a" /* FormattedMessage */], __WEBPACK_IMPORTED_MODULE_61_widget_translations__["a" /* default */].thisChannelIsComingSoon)
        );
      }

      return React.createElement(
        'div',
        { styleName: 'videos-container',
          style: { height: this.videosListHeight } },
        this.videosList,
        this.noSearchResults
      );
    }
  }, {
    key: 'playerSize',
    get: function get() {
      var appSettings = this.props.appSettings;
      var width = appSettings.requestedWidgetSize.width;

      return {
        width: width,
        height: Math.round(width / 2.39)
      };
    }
  }, {
    key: 'hasBottomContent',
    get: function get() {
      // TODO move hasBottomContent to selector|method
      var allVideosButton = this.allVideosButton;
      var searchLine = this.searchLine;
      return Boolean(allVideosButton || searchLine);
    }
  }, {
    key: 'noVideoPlayerOverlay',
    get: function get() {
      var _props11 = this.props,
          appSettings = _props11.appSettings,
          channelData = _props11.channelData;

      var hasBottomContent = this.hasBottomContent;

      var buttonsWrapperClassName = __WEBPACK_IMPORTED_MODULE_10_classnames___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_59__strip_styl___default.a['buttons-wrapper-no-margin'], !hasBottomContent));

      var props = {
        appSettings: appSettings,
        channelData: channelData,
        buttonsWrapperClassName: buttonsWrapperClassName,
        styleName: 'player-overlay',
        showChannelCover: true,
        areAllVideosVisible: false,
        videoItem: {}
      };

      return React.createElement(__WEBPACK_IMPORTED_MODULE_52_widget_components_player_overlay_strip_strip__["a" /* default */], props);
    }
  }, {
    key: 'playerOverlayNav',
    get: function get() {
      var _props12 = this.props,
          prevVideoId = _props12.prevVideoId,
          nextVideoId = _props12.nextVideoId;


      return React.createElement(__WEBPACK_IMPORTED_MODULE_49_widget_components_nav_nav__["a" /* default */], { prevButtonClassName: __WEBPACK_IMPORTED_MODULE_59__strip_styl___default.a['prev-button'],
        nextButtonClassName: __WEBPACK_IMPORTED_MODULE_59__strip_styl___default.a['next-button'],
        onPrevClick: this.selectPrevVideo,
        onNextClick: this.selectNextVideo,
        isPrevVisible: Boolean(prevVideoId),
        isNextVisible: Boolean(nextVideoId) });
    }
  }, {
    key: 'memberOnlyOverlay',
    get: function get() {
      var hasBottomContent = this.hasBottomContent;

      var buttonsWrapperClassName = __WEBPACK_IMPORTED_MODULE_10_classnames___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_59__strip_styl___default.a['buttons-wrapper-no-margin'], !hasBottomContent));

      return React.createElement(__WEBPACK_IMPORTED_MODULE_53_widget_components_player_overlay_strip_member_only__["a" /* default */], { className: __WEBPACK_IMPORTED_MODULE_59__strip_styl___default.a['player-overlay'],
        buttonsWrapperClassName: buttonsWrapperClassName });
    }
  }, {
    key: 'player',
    get: function get() {
      var mainVideo = this.mainVideo;
      var _playerSize = this.playerSize,
          width = _playerSize.width,
          height = _playerSize.height;
      var _props13 = this.props,
          channelData = _props13.channelData,
          isVideoPlaying = _props13.isVideoPlaying;


      var playerProps = {
        videoItem: mainVideo,
        key: mainVideo.id,
        channelData: channelData,
        width: width, height: height,
        canShowChannelCover: this.canShowChannelCover,
        styleName: 'player',
        className: 'qa-widget-player',
        memberOnlyOverlay: this.memberOnlyOverlay,
        onMemberSignUp: this.openMembership,
        onFullScreenChanged: this.setFullScreenState
      };

      if (IS_MOBILE_DEVICE) {
        return React.createElement(
          __WEBPACK_IMPORTED_MODULE_45_widget_components_players_mobile_player__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, playerProps, {
            paused: !isVideoPlaying }),
          this.getPlayerOverlay(mainVideo)
        );
      }

      return React.createElement(
        StripPlayer,
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, playerProps, {
          onMemberSignUp: this.openMembership }),
        this.getPlayerOverlay(mainVideo)
      );
    }
  }, {
    key: 'playerContainer',
    get: function get() {
      var mainVideo = this.mainVideo;

      if (!mainVideo) {
        return React.createElement(
          'div',
          { styleName: 'player-container' },
          this.noVideosPlayerContent,
          this.allVideosButton,
          this.searchLine
        );
      }

      var hasBottomContent = this.hasBottomContent;

      return React.createElement(
        'div',
        { styleName: __WEBPACK_IMPORTED_MODULE_10_classnames___default()('player-container', { 'with-bottom-padding': hasBottomContent }),
          'data-channel-layout': 'strip' },
        this.player,
        this.playerOverlayNav,
        this.allVideosButton,
        this.searchLine
      );
    }
  }]);

  return StripView;
}(__WEBPACK_IMPORTED_MODULE_35_widget_views_base__["a" /* default */]), _class3.displayName = 'StripView', _class3.propTypes = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_35_widget_views_base__["a" /* default */].propTypes, {
  isSearchInputVisible: React.PropTypes.bool,
  isCategoriesDropdownVisible: React.PropTypes.bool
}), _temp), (_applyDecoratedDescriptor(_class2.prototype, 'handleSlideToPrev', [__WEBPACK_IMPORTED_MODULE_11_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handleSlideToPrev'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleSlideToNext', [__WEBPACK_IMPORTED_MODULE_11_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handleSlideToNext'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleThumbnailClick', [__WEBPACK_IMPORTED_MODULE_11_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handleThumbnailClick'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'reset', [__WEBPACK_IMPORTED_MODULE_11_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'reset'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'setContainerEl', [__WEBPACK_IMPORTED_MODULE_11_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'setContainerEl'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'resizeByContent', [__WEBPACK_IMPORTED_MODULE_11_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'resizeByContent'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'storeDataForReload', [__WEBPACK_IMPORTED_MODULE_11_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'storeDataForReload'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'showChannelInfo', [__WEBPACK_IMPORTED_MODULE_11_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'showChannelInfo'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'openMembership', [__WEBPACK_IMPORTED_MODULE_11_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'openMembership'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'processDataFromStorage', [_dec3], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'processDataFromStorage'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'playVideo', [__WEBPACK_IMPORTED_MODULE_11_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'playVideo'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'handleUserToggleVisibilityAllVideos', [__WEBPACK_IMPORTED_MODULE_11_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'handleUserToggleVisibilityAllVideos'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'toggleVisibilityAllVideos', [__WEBPACK_IMPORTED_MODULE_11_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'toggleVisibilityAllVideos'), _class2.prototype)), _class2)) || _class) || _class);


/***/ }),
/* 2561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_intl__["b" /* defineMessages */])({
  allVideos: {
    id: 'widget.strip-view.all-videos',
    defaultMessage: 'All Videos'
  },
  close: {
    id: 'widget.strip-view.close',
    defaultMessage: 'Close'
  }
}));

/***/ }),
/* 2562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MobileView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_shared_analytics_new_relic__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shared_bi_bi__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_utils_wix_connect__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shared_utils_memoized_partial__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_shared_utils_open_overlay__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_widget_utils_videos_sizes__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_widget_utils_reload__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_widget_ui_selectors_video_access__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_shared_selectors_app_settings__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_shared_selectors_videos__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_widget_ui_selectors_selected_video_id__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_widget_selectors_video_playback_status__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_shared_selectors_channels__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_widget_selectors_current_site_user__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__ui_selectors_can_play_video_in_frame__ = __webpack_require__(2563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_widget_redux_client_actions_mobile_overlay_openners_main_openners__ = __webpack_require__(1736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_widget_redux_client_actions_select_video__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_widget_redux_client_actions_change_playback_status__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_widget_data_components_lazy_channel_videos__ = __webpack_require__(1207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_widget_views_base__ = __webpack_require__(1553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_widget_components_players_main_widget_mobile_player__ = __webpack_require__(2516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_widget_components_slidable_list_with_lazy_load_slidable_list_with_lazy_load__ = __webpack_require__(2520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_shared_components_payment_events_payment_events__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_widget_components_reload_storage_reload_storage__ = __webpack_require__(1549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_widget_components_cover_with_overlay_mobile_cover_with_overlay__ = __webpack_require__(2500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__mobile_styl__ = __webpack_require__(3295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__mobile_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__mobile_styl__);








var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}





































var MobileView = (_dec = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_redux__["a" /* connect */])(function (state, ownProps) {
  return {
    isVideoPlaying: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_widget_selectors_video_playback_status__["a" /* isVideoPlayingOptimistic */])(state),
    currentChannelId: state.currentChannelId,
    canShowChannelCover: !state.isVideosTouched,
    appSettings: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17_shared_selectors_app_settings__["a" /* getAllSettings */])(state),
    videoByIds: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18_shared_selectors_videos__["a" /* getVideosGroupedByIds */])(state),
    firstChannelVideoId: state.firstChannelVideoId,
    videoIds: state.lazyVideoLists.mobileWidget.videoIds,
    fetchVideos: ownProps.lazyChannelVideos.loadFirstPage,
    isVideosFetching: ownProps.lazyChannelVideos.isFetching,
    channelData: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_shared_selectors_channels__["a" /* getChannelForWidget */])(state),
    currentSiteUser: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_widget_selectors_current_site_user__["a" /* getCurrentSiteUser */])(state),

    mainVideoId: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19_widget_ui_selectors_selected_video_id__["a" /* getMainVideoId */])(state, __WEBPACK_IMPORTED_MODULE_27_widget_data_components_lazy_channel_videos__["d" /* MOBILE_WIDGET_DATA_KEY */]),
    canPlayVideoInFrame: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__ui_selectors_can_play_video_in_frame__["a" /* canPlayVideoInFrame */])(state, __WEBPACK_IMPORTED_MODULE_27_widget_data_components_lazy_channel_videos__["d" /* MOBILE_WIDGET_DATA_KEY */])
  };
}, {
  openVideoPage: __WEBPACK_IMPORTED_MODULE_24_widget_redux_client_actions_mobile_overlay_openners_main_openners__["a" /* openVideoPage */],
  selectVideo: __WEBPACK_IMPORTED_MODULE_25_widget_redux_client_actions_select_video__["a" /* selectVideo */],
  resetSelectedVideo: __WEBPACK_IMPORTED_MODULE_25_widget_redux_client_actions_select_video__["b" /* resetSelectedVideo */],
  playVideo: __WEBPACK_IMPORTED_MODULE_26_widget_redux_client_actions_change_playback_status__["a" /* playVideo */],
  pauseVideo: __WEBPACK_IMPORTED_MODULE_26_widget_redux_client_actions_change_playback_status__["e" /* pauseVideo */]
}), _dec2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_shared_utils_wix_connect__["a" /* WixConnect */])(__WEBPACK_IMPORTED_MODULE_34__mobile_styl___default.a), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_BaseView) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(MobileView, _BaseView);

  function MobileView(props) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, MobileView);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (MobileView.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(MobileView)).call(this, props));

    _this.state = {
      isInitialVideosLoaded: false
    };

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_shared_analytics_new_relic__["a" /* getNewRelic */])().setCustomAttribute('layout', 'mobile');
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(MobileView, [{
    key: 'openMemberOnlyPage',
    value: function openMemberOnlyPage(id) {
      __WEBPACK_IMPORTED_MODULE_10_shared_bi_bi__["a" /* default */].logWidgetSystem('video.memberOnlyInfo.mobileOverlay.requested');
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_shared_utils_open_overlay__["e" /* openMobileOverlay */])('#/membership/' + id);
    }
  }, {
    key: 'processDataFromStorage',
    value: function processDataFromStorage(_ref) {
      var selectedVideoId = _ref.selectedVideoId;

      if (selectedVideoId) {
        this.selectVideo({ id: selectedVideoId });
      }
    }
  }, {
    key: 'storeDataForReload',
    value: function storeDataForReload() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_widget_utils_reload__["a" /* storeForReload */])({
        selectedVideoId: this.props.mainVideoId
      });
    }
  }, {
    key: 'playSelectedVideo',
    value: function playSelectedVideo() {
      var _props = this.props,
          channelData = _props.channelData,
          currentSiteUser = _props.currentSiteUser,
          selectVideo = _props.selectVideo,
          playVideo = _props.playVideo,
          biEvent = _props.biEvent;


      var videoItem = this.mainVideo;
      var id = videoItem.id,
          videoSource = videoItem.videoSource;

      var isPlayAllowed = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_widget_ui_selectors_video_access__["a" /* canPlayFullOrPreview */])(channelData, videoItem, currentSiteUser);

      if (isPlayAllowed) {
        biEvent('widget.vid.clicked', {
          channelID: channelData.id,
          videoID: id,
          videoType: videoSource
        });

        playVideo(videoItem.id);
      } else {
        selectVideo(videoItem.id);
      }
    }
  }, {
    key: 'onCurrentSlideChanged',
    value: function onCurrentSlideChanged(newIndex) {
      var videoIds = this.props.videoIds;

      this.selectVideo({ id: videoIds[newIndex] });
    }
  }, {
    key: 'onCoverPlayClickInNewUI',
    value: function onCoverPlayClickInNewUI() {
      // TODO: move to action
      var _props2 = this.props,
          canPlayVideoInFrame = _props2.canPlayVideoInFrame,
          openVideoPage = _props2.openVideoPage,
          mainVideoId = _props2.mainVideoId;

      if (canPlayVideoInFrame) {
        this.playSelectedVideo();
      } else {
        openVideoPage(mainVideoId);
      }
    }
  }, {
    key: 'renderCoverForCarousel',
    value: function renderCoverForCarousel(videoItem, index, className) {
      var _playerSize = this.playerSize,
          width = _playerSize.width,
          height = _playerSize.height;

      var featuredVideoId = _.get(this.props.channelData, 'featuredItem');
      var isInitialVideo = featuredVideoId ? featuredVideoId === videoItem.id : index === 0;
      var showChannelCover = this.canShowChannelCover && isInitialVideo;

      return React.createElement(__WEBPACK_IMPORTED_MODULE_33_widget_components_cover_with_overlay_mobile_cover_with_overlay__["a" /* default */], { videoItem: videoItem,
        className: className,
        showChannelCover: showChannelCover,
        itemWidth: width,
        itemHeight: height,
        onSignInRequested: this.showLogInForm,
        onPlayClick: this.onCoverPlayClickInNewUI,
        onMemberSignUp: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_shared_utils_memoized_partial__["a" /* default */])(this.openMemberOnlyPage, videoItem.id) });
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.props.resetSelectedVideo();
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.isUIBlockingDataLoaded) {
        return this.spinner;
      }

      return React.createElement(
        'section',
        { styleName: 'container',
          className: 'qa-widget-container' },
        React.createElement(__WEBPACK_IMPORTED_MODULE_31_shared_components_payment_events_payment_events__["a" /* default */], { onSubscription: this.reset,
          onSubscriptionCancel: this.reset }),
        this.mainUI
      );
    }
  }, {
    key: 'mainVideoList',
    get: function get() {
      return this.props.lazyChannelVideos;
    }
  }, {
    key: 'playerSize',
    get: function get() {
      var appSettings = this.props.appSettings;

      var widgetWidth = appSettings.requestedWidgetSize.width;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_widget_utils_videos_sizes__["e" /* playerSizeMobileMainItemForNewUX */])(widgetWidth);
    }
  }, {
    key: 'noVideoPlayerOverlay',
    get: function get() {
      var _playerSize2 = this.playerSize,
          width = _playerSize2.width,
          height = _playerSize2.height;
      var _props3 = this.props,
          appSettings = _props3.appSettings,
          channelData = _props3.channelData;


      var props = {
        appSettings: appSettings,
        channelData: channelData,
        showChannelCover: true,
        videoItem: {}
      };

      return React.createElement(__WEBPACK_IMPORTED_MODULE_33_widget_components_cover_with_overlay_mobile_cover_with_overlay__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, props, {
        itemWidth: width,
        itemHeight: height }));
    }
  }, {
    key: 'coversListForCarousel',
    get: function get() {
      var _this2 = this;

      var _props4 = this.props,
          videoIds = _props4.videoIds,
          videoByIds = _props4.videoByIds;


      return _.map(videoIds, function (videoId, index) {
        return React.createElement(
          'div',
          { key: videoId },
          _this2.renderCoverForCarousel(videoByIds[videoId], index, __WEBPACK_IMPORTED_MODULE_34__mobile_styl___default.a['overlay-item-topmost'])
        );
      });
    }
  }, {
    key: 'singleItemCover',
    get: function get() {
      var videoItem = this.mainVideo;
      return React.createElement(
        'div',
        { styleName: 'single-item-cover' },
        this.renderCoverForCarousel(videoItem, 0)
      );
    }
  }, {
    key: 'coversList',
    get: function get() {
      var loadMore = this.mainVideoList.loadMore;
      var videoIds = this.props.videoIds;

      var videoItem = this.mainVideo;

      if (_.size(videoIds) === 1) {
        return this.singleItemCover;
      }

      return React.createElement(
        __WEBPACK_IMPORTED_MODULE_32_widget_components_reload_storage_reload_storage__["a" /* default */],
        { onReload: this.processDataFromStorage },
        React.createElement(
          __WEBPACK_IMPORTED_MODULE_30_widget_components_slidable_list_with_lazy_load_slidable_list_with_lazy_load__["a" /* default */],
          { loadMore: loadMore,
            itemHeight: this.playerSize.height,
            styleName: 'players-list-slidable',
            onCurrentSlideChanged: this.onCurrentSlideChanged,
            selectedVideoId: videoItem && videoItem.id },
          this.coversListForCarousel
        )
      );
    }
  }, {
    key: 'mainUI',
    get: function get() {
      var _props5 = this.props,
          isVideoPlaying = _props5.isVideoPlaying,
          channelData = _props5.channelData,
          canPlayVideoInFrame = _props5.canPlayVideoInFrame;
      var _playerSize3 = this.playerSize,
          width = _playerSize3.width,
          height = _playerSize3.height;

      var videoItem = this.mainVideo;

      if (!videoItem) {
        return this.noVideosPlayerContent;
      }

      return React.createElement(
        'div',
        { 'data-hook': 'main-ui',
          styleName: 'new-mobile-ui-container',
          style: { width: width, height: height } },
        React.createElement(
          'div',
          { styleName: 'real-player-placeholder' },
          canPlayVideoInFrame && React.createElement(__WEBPACK_IMPORTED_MODULE_29_widget_components_players_main_widget_mobile_player__["a" /* default */], { videoItem: videoItem,
            channelData: channelData,
            width: width,
            height: height,
            showPoster: false,
            paused: !isVideoPlaying,
            onMemberSignUp: this.openMemberOnlyPage })
        ),
        this.coversList
      );
    }
  }]);

  return MobileView;
}(__WEBPACK_IMPORTED_MODULE_28_widget_views_base__["a" /* default */]), _class3.displayName = 'MobileView', _class3.propTypes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_28_widget_views_base__["a" /* default */].propTypes, {
  lazyChannelVideos: React.PropTypes.object,
  openVideoPage: React.PropTypes.func,
  canPlayVideoInFrame: React.PropTypes.bool,
  biEvent: React.PropTypes.func
}), _temp), (_applyDecoratedDescriptor(_class2.prototype, 'openMemberOnlyPage', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'openMemberOnlyPage'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'processDataFromStorage', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'processDataFromStorage'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'storeDataForReload', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'storeDataForReload'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'playSelectedVideo', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'playSelectedVideo'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onCurrentSlideChanged', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'onCurrentSlideChanged'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onCoverPlayClickInNewUI', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'onCoverPlayClickInNewUI'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'reset', [__WEBPACK_IMPORTED_MODULE_8_core_decorators_lib_autobind___default.a], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'reset'), _class2.prototype)), _class2)) || _class) || _class);


/***/ }),
/* 2563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return canPlayVideoInFrame; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_widget_selectors_current_site_user__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_widget_ui_selectors_selected_video_id__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_shared_selectors_channels__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_widget_ui_selectors_video_access__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_ui_selectors_video_video_origin__ = __webpack_require__(112);







var getVideos = function getVideos(state) {
  return state.entities.videos;
};

/**
* @param state
* @param listType
* @returns main video item
*/
var getMainVideo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getVideos, __WEBPACK_IMPORTED_MODULE_2_widget_ui_selectors_selected_video_id__["a" /* getMainVideoId */]], function (videos, mainVideoId) {
  return mainVideoId && videos[mainVideoId];
});

/**
 * @param state
 * @param listType
 * @returns {Boolean}
 */
var canPlayVideoInFrame = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([__WEBPACK_IMPORTED_MODULE_3_shared_selectors_channels__["a" /* getChannelForWidget */], getMainVideo, __WEBPACK_IMPORTED_MODULE_1_widget_selectors_current_site_user__["a" /* getCurrentSiteUser */]], function (channel, mainVideo, currentSiteUser) {
  return Boolean(mainVideo && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_shared_ui_selectors_video_video_origin__["a" /* isVideoFromComputer */])(mainVideo) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_widget_ui_selectors_video_access__["a" /* canPlayFullOrPreview */])(channel, mainVideo, currentSiteUser));
});

/***/ }),
/* 2564 */,
/* 2565 */,
/* 2566 */,
/* 2567 */,
/* 2568 */,
/* 2569 */,
/* 2570 */,
/* 2571 */,
/* 2572 */,
/* 2573 */,
/* 2574 */,
/* 2575 */,
/* 2576 */,
/* 2577 */,
/* 2578 */,
/* 2579 */,
/* 2580 */,
/* 2581 */,
/* 2582 */,
/* 2583 */,
/* 2584 */,
/* 2585 */,
/* 2586 */,
/* 2587 */,
/* 2588 */,
/* 2589 */,
/* 2590 */,
/* 2591 */,
/* 2592 */,
/* 2593 */,
/* 2594 */,
/* 2595 */,
/* 2596 */,
/* 2597 */,
/* 2598 */,
/* 2599 */,
/* 2600 */,
/* 2601 */,
/* 2602 */,
/* 2603 */,
/* 2604 */,
/* 2605 */,
/* 2606 */,
/* 2607 */,
/* 2608 */,
/* 2609 */,
/* 2610 */,
/* 2611 */,
/* 2612 */,
/* 2613 */,
/* 2614 */,
/* 2615 */,
/* 2616 */,
/* 2617 */,
/* 2618 */,
/* 2619 */,
/* 2620 */,
/* 2621 */,
/* 2622 */,
/* 2623 */,
/* 2624 */,
/* 2625 */,
/* 2626 */,
/* 2627 */,
/* 2628 */,
/* 2629 */,
/* 2630 */,
/* 2631 */,
/* 2632 */,
/* 2633 */,
/* 2634 */,
/* 2635 */,
/* 2636 */,
/* 2637 */,
/* 2638 */,
/* 2639 */,
/* 2640 */,
/* 2641 */,
/* 2642 */,
/* 2643 */,
/* 2644 */,
/* 2645 */,
/* 2646 */,
/* 2647 */,
/* 2648 */,
/* 2649 */,
/* 2650 */,
/* 2651 */,
/* 2652 */,
/* 2653 */,
/* 2654 */,
/* 2655 */,
/* 2656 */,
/* 2657 */,
/* 2658 */,
/* 2659 */,
/* 2660 */,
/* 2661 */,
/* 2662 */,
/* 2663 */,
/* 2664 */,
/* 2665 */,
/* 2666 */,
/* 2667 */,
/* 2668 */,
/* 2669 */,
/* 2670 */,
/* 2671 */,
/* 2672 */,
/* 2673 */,
/* 2674 */,
/* 2675 */,
/* 2676 */,
/* 2677 */,
/* 2678 */,
/* 2679 */,
/* 2680 */,
/* 2681 */,
/* 2682 */,
/* 2683 */,
/* 2684 */,
/* 2685 */,
/* 2686 */,
/* 2687 */,
/* 2688 */,
/* 2689 */,
/* 2690 */,
/* 2691 */,
/* 2692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SVG; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);








var SVG = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(SVG, _React$Component);

  function SVG() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, SVG);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SVG.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(SVG)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(SVG, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "svg",
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ width: "10", height: "17", viewBox: "0 0 10 17", xmlns: "http://www.w3.org/2000/svg" }, this.props),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("path", { d: "M1.211 16l7.213-7.391L1 1", strokeWidth: "2", stroke: "#FFF", fill: "none", fillRule: "evenodd" })
      );
    }
  }]);

  return SVG;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);



/***/ }),
/* 2693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SVG; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);








var SVG = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(SVG, _React$Component);

  function SVG() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, SVG);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SVG.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(SVG)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(SVG, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "svg",
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ viewBox: "0 0 53 100", xmlns: "http://www.w3.org/2000/svg" }, this.props),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("path", { d: "M5.16 99.14l-3.01-3.01L48.6 50.11 2.15 4.3l3.01-3.01 49.46 48.82" })
      );
    }
  }]);

  return SVG;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);



/***/ }),
/* 2694 */,
/* 2695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SVG; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);








var SVG = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(SVG, _React$Component);

  function SVG() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, SVG);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SVG.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(SVG)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(SVG, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "svg",
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ width: "22", height: "12", viewBox: "0 0 22 12", xmlns: "http://www.w3.org/2000/svg" }, this.props),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("path", { d: "M0 7h22V5H0v2zm0 5h22v-2H0v2zM0 2h22V0H0v2z", fillRule: "evenodd" })
      );
    }
  }]);

  return SVG;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);



/***/ }),
/* 2696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SVG; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);








var SVG = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(SVG, _React$Component);

  function SVG() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, SVG);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SVG.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(SVG)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(SVG, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "svg",
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ width: "56", height: "56", viewBox: "0 0 56 56", xmlns: "http://www.w3.org/2000/svg" }, this.props),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "g",
          { fill: "#FFF", fillRule: "evenodd" },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("path", { d: "M28 53c13.807 0 25-11.193 25-25S41.807 3 28 3 3 14.193 3 28s11.193 25 25 25zm0 3C12.536 56 0 43.464 0 28S12.536 0 28 0s28 12.536 28 28-12.536 28-28 28z" }),
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("path", { d: "M29.637 36.249L29.71 40h-2.957l.072-3.63C24.181 36.1 22.68 34.688 22 34.082l2.012-2.83c.727.678 2.302 1.737 4.267 1.737 1.382 0 2.06-.659 2.06-1.532 0-.97-.776-1.396-2.641-2.246l-1.456-.662c-2.52-1.116-3.563-2.624-3.563-4.565 0-2.62 1.939-4.892 4.46-5.352L27.043 15H30l-.072 3.629c2.327.39 3.417 1.863 3.613 2.132l-2.11 2.628a4.46 4.46 0 0 0-3.152-1.317c-1.261 0-1.916.687-1.916 1.585 0 .994.897 1.546 2.425 2.248l1.188.544C32.74 27.709 34 28.959 34 31.263c0 2.183-1.454 4.428-4.363 4.986" })
        )
      );
    }
  }]);

  return SVG;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);



/***/ }),
/* 2697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SVG; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);








var SVG = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(SVG, _React$Component);

  function SVG() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, SVG);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SVG.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(SVG)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(SVG, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "svg",
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ width: "56", height: "56", viewBox: "0 0 56 56", xmlns: "http://www.w3.org/2000/svg" }, this.props),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          "g",
          { fill: "#FFF", fillRule: "evenodd" },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("path", { d: "M28 53c13.807 0 25-11.193 25-25S41.807 3 28 3 3 14.193 3 28s11.193 25 25 25zm0 3C12.536 56 0 43.464 0 28S12.536 0 28 0s28 12.536 28 28-12.536 28-28 28z" }),
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("path", { d: "M37.232 27.91L22 36.82V19z" })
        )
      );
    }
  }]);

  return SVG;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);



/***/ }),
/* 2698 */,
/* 2699 */,
/* 2700 */,
/* 2701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SVG; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);








var SVG = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(SVG, _React$Component);

  function SVG() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, SVG);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SVG.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(SVG)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(SVG, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "svg",
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ xmlns: "http://www.w3.org/2000/svg", width: "36", height: "37", viewBox: "0 0 36 37" }, this.props),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("path", { className: "cls-1", d: "M16.47 33.13a16.575 16.575 0 1 1 16.47-16.57 16.538 16.538 0 0 1-16.47 16.57zm0-31.75a15.18 15.18 0 1 0 15.09 15.18A15.144 15.144 0 0 0 16.47 1.38zm18.51 35.61l-8.61-9.48 1.02-.94L36 36.04z" })
      );
    }
  }]);

  return SVG;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);



/***/ }),
/* 2702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SVG; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);








var SVG = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(SVG, _React$Component);

  function SVG() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, SVG);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SVG.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(SVG)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(SVG, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        "svg",
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 30 9" }, this.props),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("path", { d: "M24 0v4H0v1h24v4l6-4.5z" })
      );
    }
  }]);

  return SVG;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);



/***/ }),
/* 2703 */,
/* 2704 */,
/* 2705 */,
/* 2706 */,
/* 2707 */,
/* 2708 */,
/* 2709 */,
/* 2710 */,
/* 2711 */,
/* 2712 */,
/* 2713 */,
/* 2714 */,
/* 2715 */,
/* 2716 */,
/* 2717 */,
/* 2718 */,
/* 2719 */,
/* 2720 */,
/* 2721 */,
/* 2722 */,
/* 2723 */,
/* 2724 */,
/* 2725 */,
/* 2726 */,
/* 2727 */,
/* 2728 */,
/* 2729 */,
/* 2730 */,
/* 2731 */,
/* 2732 */,
/* 2733 */,
/* 2734 */,
/* 2735 */,
/* 2736 */,
/* 2737 */,
/* 2738 */,
/* 2739 */,
/* 2740 */,
/* 2741 */,
/* 2742 */,
/* 2743 */,
/* 2744 */,
/* 2745 */,
/* 2746 */,
/* 2747 */,
/* 2748 */,
/* 2749 */,
/* 2750 */,
/* 2751 */,
/* 2752 */,
/* 2753 */,
/* 2754 */,
/* 2755 */,
/* 2756 */,
/* 2757 */,
/* 2758 */,
/* 2759 */,
/* 2760 */,
/* 2761 */,
/* 2762 */,
/* 2763 */,
/* 2764 */,
/* 2765 */,
/* 2766 */,
/* 2767 */,
/* 2768 */,
/* 2769 */,
/* 2770 */,
/* 2771 */,
/* 2772 */,
/* 2773 */,
/* 2774 */,
/* 2775 */,
/* 2776 */,
/* 2777 */,
/* 2778 */,
/* 2779 */,
/* 2780 */,
/* 2781 */,
/* 2782 */,
/* 2783 */,
/* 2784 */,
/* 2785 */,
/* 2786 */,
/* 2787 */,
/* 2788 */,
/* 2789 */,
/* 2790 */,
/* 2791 */,
/* 2792 */,
/* 2793 */,
/* 2794 */,
/* 2795 */,
/* 2796 */,
/* 2797 */,
/* 2798 */,
/* 2799 */,
/* 2800 */,
/* 2801 */,
/* 2802 */,
/* 2803 */,
/* 2804 */,
/* 2805 */,
/* 2806 */,
/* 2807 */,
/* 2808 */,
/* 2809 */,
/* 2810 */,
/* 2811 */,
/* 2812 */,
/* 2813 */,
/* 2814 */,
/* 2815 */,
/* 2816 */,
/* 2817 */,
/* 2818 */,
/* 2819 */,
/* 2820 */,
/* 2821 */,
/* 2822 */,
/* 2823 */,
/* 2824 */,
/* 2825 */,
/* 2826 */,
/* 2827 */,
/* 2828 */,
/* 2829 */,
/* 2830 */,
/* 2831 */,
/* 2832 */,
/* 2833 */,
/* 2834 */,
/* 2835 */,
/* 2836 */,
/* 2837 */,
/* 2838 */,
/* 2839 */,
/* 2840 */,
/* 2841 */,
/* 2842 */,
/* 2843 */,
/* 2844 */,
/* 2845 */,
/* 2846 */,
/* 2847 */,
/* 2848 */,
/* 2849 */,
/* 2850 */,
/* 2851 */,
/* 2852 */,
/* 2853 */,
/* 2854 */,
/* 2855 */,
/* 2856 */,
/* 2857 */,
/* 2858 */,
/* 2859 */,
/* 2860 */,
/* 2861 */,
/* 2862 */,
/* 2863 */,
/* 2864 */,
/* 2865 */,
/* 2866 */,
/* 2867 */,
/* 2868 */,
/* 2869 */,
/* 2870 */,
/* 2871 */,
/* 2872 */,
/* 2873 */,
/* 2874 */,
/* 2875 */,
/* 2876 */,
/* 2877 */,
/* 2878 */,
/* 2879 */,
/* 2880 */,
/* 2881 */,
/* 2882 */,
/* 2883 */,
/* 2884 */,
/* 2885 */,
/* 2886 */,
/* 2887 */,
/* 2888 */,
/* 2889 */,
/* 2890 */,
/* 2891 */,
/* 2892 */,
/* 2893 */,
/* 2894 */,
/* 2895 */,
/* 2896 */,
/* 2897 */,
/* 2898 */,
/* 2899 */,
/* 2900 */,
/* 2901 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".account-button__account-button__255Go{font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family,Helvetica Neue,ruble,Helvetica,Arial,sans-serif;text-decoration:-wix-fonts-textFont-decoration;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;height:20px;line-height:20px;border-radius:0;color:inherit;font-size:14px}.account-button__account-button__255Go:hover{opacity:.7}.account-button__account-info-button-wrapper__1CPFI{-ms-flex-positive:0;flex-grow:0;height:20px;line-height:20px;border-radius:0}.account-button__account-info-button__2CtHg{font-size:28px;background:none;color:inherit;cursor:pointer}.account-button__account-info-button__2CtHg:hover{background:none;opacity:.7}", ""]);

// exports
exports.locals = {
	"account-button": "account-button__account-button__255Go",
	"accountButton": "account-button__account-button__255Go",
	"account-info-button-wrapper": "account-button__account-info-button-wrapper__1CPFI",
	"accountInfoButtonWrapper": "account-button__account-info-button-wrapper__1CPFI",
	"account-info-button": "account-button__account-info-button__2CtHg",
	"accountInfoButton": "account-button__account-info-button__2CtHg"
};

/***/ }),
/* 2902 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".account-button-with-tooltip__popout__twyng{width:325px;padding-bottom:25px}.account-button-with-tooltip__popout-inner__1AfgD{padding:0;background-color:#fff}.account-button-with-tooltip__popout-triangle__h8G5H{background-color:#fff;margin-bottom:25px}.account-button-with-tooltip__account-info-button__3wRVM{font-size:28px;background:none;color:-wix-colors-buttonsAndLinksColor-80}.account-button-with-tooltip__account-info-button__3wRVM:hover{background:none;color:-wix-colors-buttonsAndLinksColor}", ""]);

// exports
exports.locals = {
	"popout": "account-button-with-tooltip__popout__twyng",
	"popout-inner": "account-button-with-tooltip__popout-inner__1AfgD",
	"popoutInner": "account-button-with-tooltip__popout-inner__1AfgD",
	"popout-triangle": "account-button-with-tooltip__popout-triangle__h8G5H",
	"popoutTriangle": "account-button-with-tooltip__popout-triangle__h8G5H",
	"account-info-button": "account-button-with-tooltip__account-info-button__3wRVM",
	"accountInfoButton": "account-button-with-tooltip__account-info-button__3wRVM"
};

/***/ }),
/* 2903 */,
/* 2904 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".animate-crossfade__container__1bxep{height:100%}.animate-crossfade__slide__3tef7{position:absolute;top:0;left:0;right:0;bottom:0;opacity:0}.animate-crossfade__active__1RNyD,.animate-crossfade__prevActive__18Q_F{opacity:1}.animate-crossfade__active__1RNyD{position:absolute;top:0;left:0;right:0;bottom:0;transition:opacity .3s ease-in-out;z-index:126}", ""]);

// exports
exports.locals = {
	"container": "animate-crossfade__container__1bxep",
	"slide": "animate-crossfade__slide__3tef7",
	"active": "animate-crossfade__active__1RNyD",
	"prevActive": "animate-crossfade__prevActive__18Q_F"
};

/***/ }),
/* 2905 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".categories__option__2GZ1t,.categories__options__35IOB{width:100%}.categories__option__2GZ1t{display:block;overflow:hidden;text-overflow:ellipsis}", ""]);

// exports
exports.locals = {
	"option": "categories__option__2GZ1t",
	"options": "categories__options__35IOB"
};

/***/ }),
/* 2906 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".channel-actions__action__3ss81{-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;height:20px;line-height:20px;border-radius:0;color:-wix-colors-buttonsAndLinksColor-80;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family;text-decoration:-wix-fonts-textFont-decoration;font-size:14px}.channel-actions__action__3ss81.channel-actions__info__1tBNe:hover .channel-actions__icon__3FzAR,.channel-actions__action__3ss81:hover{color:-wix-colors-buttonsAndLinksColor-100}.channel-actions__action__3ss81.channel-actions__info__1tBNe .channel-actions__icon__3FzAR{color:-wix-colors-buttonsAndLinksColor-80;font-size:15px}", ""]);

// exports
exports.locals = {
	"action": "channel-actions__action__3ss81",
	"info": "channel-actions__info__1tBNe",
	"icon": "channel-actions__icon__3FzAR"
};

/***/ }),
/* 2907 */,
/* 2908 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".content-slider__container__3jZhg{position:relative;overflow:hidden;-ms-flex-positive:1;flex-grow:1;height:100%}.content-slider__content__2L919{position:absolute;left:0;top:0;bottom:0;transition:transform .5s}", ""]);

// exports
exports.locals = {
	"container": "content-slider__container__3jZhg",
	"content": "content-slider__content__2L919"
};

/***/ }),
/* 2909 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".mobile-cover-with-overlay__slidable-overlay__3oGOi{position:absolute;top:0;left:0;right:0;bottom:0;z-index:130}", ""]);

// exports
exports.locals = {
	"slidable-overlay": "mobile-cover-with-overlay__slidable-overlay__3oGOi",
	"slidableOverlay": "mobile-cover-with-overlay__slidable-overlay__3oGOi"
};

/***/ }),
/* 2910 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".empty-search-results__no-search-wrapper__1vg37{-ms-flex-positive:1;flex-grow:1;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;padding:36px 0 54px;color:-wix-colors-buttonsAndLinksColor;opacity:.5}.empty-search-results__no-search-icon__2AZs7{margin-bottom:15px;heigth:37px;font-size:36px}.empty-search-results__no-search-icon__2AZs7 path{fill:-wix-colors-buttonsAndLinksColor}.empty-search-results__no-search-text__3ofiu{font-size:16px}", ""]);

// exports
exports.locals = {
	"no-search-wrapper": "empty-search-results__no-search-wrapper__1vg37",
	"noSearchWrapper": "empty-search-results__no-search-wrapper__1vg37",
	"no-search-icon": "empty-search-results__no-search-icon__2AZs7",
	"noSearchIcon": "empty-search-results__no-search-icon__2AZs7",
	"no-search-text": "empty-search-results__no-search-text__3ofiu",
	"noSearchText": "empty-search-results__no-search-text__3ofiu"
};

/***/ }),
/* 2911 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".first-time-track-animation__start-animation__1RYLB{position:relative;animation:first-time-track-animation__reveal-swipe-option__fc2EF 1.3s}@keyframes first-time-track-animation__reveal-swipe-option__fc2EF{0%,to{animation-timing-function:ease-out;left:0}85%{animation-timing-function:linear;left:-60px}}", ""]);

// exports
exports.locals = {
	"start-animation": "first-time-track-animation__start-animation__1RYLB",
	"startAnimation": "first-time-track-animation__start-animation__1RYLB",
	"reveal-swipe-option": "first-time-track-animation__reveal-swipe-option__fc2EF",
	"revealSwipeOption": "first-time-track-animation__reveal-swipe-option__fc2EF"
};

/***/ }),
/* 2912 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".buttons__button-container__3uW6n{position:absolute;top:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}.buttons__button-container__3uW6n.buttons__inactive__3ngqj{opacity:.3}.buttons__button-container__3uW6n:before{content:\" \";position:absolute;top:0;bottom:0;width:15px}.buttons__button-container__3uW6n.buttons__left__zSv1l{left:0}.buttons__button-container__3uW6n.buttons__left__zSv1l:before{background:linear-gradient(90deg,rgba(0,0,0,.4),hsla(0,0%,100%,0));left:0}.buttons__button-container__3uW6n.buttons__left__zSv1l .buttons__button__2RPO-{transform:scaleX(-1);margin-left:10px}.buttons__button-container__3uW6n.buttons__right__3qYSz{right:0}.buttons__button-container__3uW6n.buttons__right__3qYSz:before{background:linear-gradient(270deg,rgba(0,0,0,.4),hsla(0,0%,100%,0));right:0}.buttons__button-container__3uW6n.buttons__right__3qYSz .buttons__button__2RPO-{margin-right:10px}.buttons__button__2RPO-{color:#fff;font-size:8px}", ""]);

// exports
exports.locals = {
	"button-container": "buttons__button-container__3uW6n",
	"buttonContainer": "buttons__button-container__3uW6n",
	"inactive": "buttons__inactive__3ngqj",
	"left": "buttons__left__zSv1l",
	"button": "buttons__button__2RPO-",
	"right": "buttons__right__3qYSz"
};

/***/ }),
/* 2913 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".mobile-carousel__container__13BgB{position:relative;overflow:hidden;-ms-touch-action:pan-y pinch-zoom;touch-action:pan-y pinch-zoom}.mobile-carousel__slick-track__5QJA1{display:-ms-flexbox;display:flex}", ""]);

// exports
exports.locals = {
	"container": "mobile-carousel__container__13BgB",
	"slick-track": "mobile-carousel__slick-track__5QJA1",
	"slickTrack": "mobile-carousel__slick-track__5QJA1"
};

/***/ }),
/* 2914 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".track__slick-track__2vOSc{display:-ms-flexbox;display:flex}", ""]);

// exports
exports.locals = {
	"slick-track": "track__slick-track__2vOSc",
	"slickTrack": "track__slick-track__2vOSc"
};

/***/ }),
/* 2915 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".nav__next-button__1jjJF,.nav__prev-button__3nw53{position:absolute;z-index:126;top:50%;border-radius:0;transition:opacity .2s,visibility .2s;opacity:1;padding:10px;width:38px;height:50px;margin-top:-25px}.nav__next-button__1jjJF>svg,.nav__prev-button__3nw53>svg{fill:#fff}.nav__next-button__1jjJF:active,.nav__next-button__1jjJF:focus,.nav__next-button__1jjJF:hover,.nav__prev-button__3nw53:active,.nav__prev-button__3nw53:focus,.nav__prev-button__3nw53:hover{opacity:.7}.nav__prev-button__3nw53{transform:scaleX(-1);filter:FlipH;-ms-filter:\"FlipH\";left:0}.nav__next-button__1jjJF{right:0}", ""]);

// exports
exports.locals = {
	"next-button": "nav__next-button__1jjJF",
	"nextButton": "nav__next-button__1jjJF",
	"prev-button": "nav__prev-button__3nw53",
	"prevButton": "nav__prev-button__3nw53"
};

/***/ }),
/* 2916 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".page-list__container__2zTvT{position:relative;width:100%;height:100%}.page-list__container__2zTvT,.page-list__page__t5R9x{display:-ms-flexbox;display:flex}.page-list__page__t5R9x{-ms-flex-line-pack:start;align-content:flex-start;-ms-flex-wrap:wrap;flex-wrap:wrap}", ""]);

// exports
exports.locals = {
	"container": "page-list__container__2zTvT",
	"page": "page-list__page__t5R9x"
};

/***/ }),
/* 2917 */,
/* 2918 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".classic__overlay__2yQY8,.classic__overlay-bottom__3i5r5{z-index:120;position:absolute;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;color:#fff}.classic__overlay-bottom__3i5r5 .classic__title__31O8o,.classic__overlay__2yQY8 .classic__title__31O8o{width:calc(100% - 180px);margin-left:90px;margin-right:90px;padding:0;font-weight:-wix-fonts-titleFont-weight;font-style:-wix-fonts-titleFont-style;font-family:-wix-fonts-titleFont-family;text-decoration:-wix-fonts-titleFont-decoration;font-size:-wix-fonts-titleFont-size}.classic__overlay-bottom__3i5r5 .classic__title__31O8o+.classic__publisher__3rh6X,.classic__overlay__2yQY8 .classic__title__31O8o+.classic__publisher__3rh6X{margin-top:10px}.classic__overlay-bottom__3i5r5 .classic__title__31O8o .classic__preview-text__2tIBi,.classic__overlay__2yQY8 .classic__title__31O8o .classic__preview-text__2tIBi{font-size:14px;margin-left:10px}.classic__overlay-bottom__3i5r5 .classic__publisher__3rh6X,.classic__overlay__2yQY8 .classic__publisher__3rh6X{width:100%;padding-left:95px;padding-right:95px;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family;text-decoration:-wix-fonts-textFont-decoration;font-size:18px;line-height:24px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.classic__overlay-bottom__3i5r5 .classic__buttons__3UyyT:not(:first-child),.classic__overlay__2yQY8 .classic__buttons__3UyyT:not(:first-child){margin-top:36px}.classic__overlay-bottom__3i5r5 .classic__buttons__3UyyT .classic__button__3HMCZ,.classic__overlay__2yQY8 .classic__buttons__3UyyT .classic__button__3HMCZ{margin:0 8px 0 7px}.classic__overlay__2yQY8 .classic__title__31O8o .classic__preview-text__2tIBi{display:none}.classic__overlay__2yQY8{top:0;-ms-flex-direction:column;flex-direction:column;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-pack:center;justify-content:center;-ms-flex-align:stretch;align-items:stretch;color:#fff;text-align:center}.classic__overlay-bottom__3i5r5{position:absolute;left:0;right:0;bottom:0;height:183px;display:-ms-flexbox;display:flex;box-sizing:border-box;padding:61px 30px 0;-ms-flex-align:center;align-items:center;background:linear-gradient(0deg,rgba(0,0,0,.5),transparent)}.classic__overlay-bottom__3i5r5 .classic__play-button__2QHTJ{margin-right:30px;padding:0;width:60px;height:60px;border-radius:50%;border:1px solid #fff;text-align:center;background:transparent;outline:none;-ms-touch-action:manipulation;touch-action:manipulation;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;color:#fff;-ms-flex:0 0 auto;flex:0 0 auto}.classic__overlay-bottom__3i5r5 .classic__play-button__2QHTJ .classic__play-icon__2yBDd{font-size:22px;margin-left:5px}.classic__overlay-bottom__3i5r5 .classic__info__k75sW{-ms-flex:1;flex:1;text-align:left;overflow:hidden;margin-right:40px}.classic__overlay-bottom__3i5r5 .classic__info__k75sW .classic__publisher__3rh6X,.classic__overlay-bottom__3i5r5 .classic__info__k75sW .classic__title__31O8o{padding-left:0;padding-right:0;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}@media only screen and (max-width:320px){.classic__overlay-bottom__3i5r5 .classic__buttons__3UyyT,.classic__overlay__2yQY8 .classic__buttons__3UyyT{margin-top:25px}.classic__overlay-bottom__3i5r5 .classic__buttons__3UyyT .classic__button__3HMCZ,.classic__overlay__2yQY8 .classic__buttons__3UyyT .classic__button__3HMCZ{margin:0 5px}}.classic__button__3HMCZ .classic__next-icon__3btb8,.classic__button__3HMCZ .classic__play-icon__2yBDd{font-size:14px}.classic__button__3HMCZ .classic__play-icon__2yBDd{margin-right:11px}.classic__button__3HMCZ .classic__next-icon__3btb8{margin-left:11px}@media only screen and (max-width:320px){.classic__button__3HMCZ .classic__play-icon__2yBDd{font-size:10px}}", ""]);

// exports
exports.locals = {
	"overlay": "classic__overlay__2yQY8",
	"overlay-bottom": "classic__overlay-bottom__3i5r5",
	"overlayBottom": "classic__overlay-bottom__3i5r5",
	"title": "classic__title__31O8o",
	"publisher": "classic__publisher__3rh6X",
	"preview-text": "classic__preview-text__2tIBi",
	"previewText": "classic__preview-text__2tIBi",
	"buttons": "classic__buttons__3UyyT",
	"button": "classic__button__3HMCZ",
	"play-button": "classic__play-button__2QHTJ",
	"playButton": "classic__play-button__2QHTJ",
	"play-icon": "classic__play-icon__2yBDd",
	"playIcon": "classic__play-icon__2yBDd",
	"info": "classic__info__k75sW",
	"next-icon": "classic__next-icon__3btb8",
	"nextIcon": "classic__next-icon__3btb8"
};

/***/ }),
/* 2919 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".member-only__overlay__LCmbA,.member-only__overlay-bottom__dZ6dm{z-index:120;position:absolute;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;color:#fff}.member-only__overlay-bottom__dZ6dm .member-only__title__1qOy6,.member-only__overlay__LCmbA .member-only__title__1qOy6{width:calc(100% - 180px);margin-left:90px;margin-right:90px;padding:0;font-weight:-wix-fonts-titleFont-weight;font-style:-wix-fonts-titleFont-style;font-family:-wix-fonts-titleFont-family;text-decoration:-wix-fonts-titleFont-decoration;font-size:-wix-fonts-titleFont-size}.member-only__overlay-bottom__dZ6dm .member-only__title__1qOy6+.member-only__publisher___ZYs8,.member-only__overlay__LCmbA .member-only__title__1qOy6+.member-only__publisher___ZYs8{margin-top:10px}.member-only__overlay-bottom__dZ6dm .member-only__title__1qOy6 .member-only__preview-text__1AZgr,.member-only__overlay__LCmbA .member-only__title__1qOy6 .member-only__preview-text__1AZgr{font-size:14px;margin-left:10px}.member-only__overlay-bottom__dZ6dm .member-only__publisher___ZYs8,.member-only__overlay__LCmbA .member-only__publisher___ZYs8{width:100%;padding-left:95px;padding-right:95px;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family;text-decoration:-wix-fonts-textFont-decoration;font-size:18px;line-height:24px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.member-only__overlay-bottom__dZ6dm .member-only__buttons__3Mwj7:not(:first-child),.member-only__overlay__LCmbA .member-only__buttons__3Mwj7:not(:first-child){margin-top:36px}.member-only__overlay-bottom__dZ6dm .member-only__buttons__3Mwj7 .member-only__button__1CgYY,.member-only__overlay__LCmbA .member-only__buttons__3Mwj7 .member-only__button__1CgYY{margin:0 8px 0 7px}.member-only__overlay__LCmbA .member-only__title__1qOy6 .member-only__preview-text__1AZgr{display:none}.member-only__overlay__LCmbA{top:0;-ms-flex-direction:column;flex-direction:column;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-pack:center;justify-content:center;-ms-flex-align:stretch;align-items:stretch;color:#fff;text-align:center}.member-only__overlay-bottom__dZ6dm{position:absolute;left:0;right:0;bottom:0;height:183px;display:-ms-flexbox;display:flex;box-sizing:border-box;padding:61px 30px 0;-ms-flex-align:center;align-items:center;background:linear-gradient(0deg,rgba(0,0,0,.5),transparent)}.member-only__overlay-bottom__dZ6dm .member-only__play-button__2hhbB{margin-right:30px;padding:0;width:60px;height:60px;border-radius:50%;border:1px solid #fff;text-align:center;background:transparent;outline:none;-ms-touch-action:manipulation;touch-action:manipulation;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;color:#fff;-ms-flex:0 0 auto;flex:0 0 auto}.member-only__overlay-bottom__dZ6dm .member-only__play-button__2hhbB .member-only__play-icon__jvNCn{font-size:22px;margin-left:5px}.member-only__overlay-bottom__dZ6dm .member-only__info__2RYGB{-ms-flex:1;flex:1;text-align:left;overflow:hidden;margin-right:40px}.member-only__overlay-bottom__dZ6dm .member-only__info__2RYGB .member-only__publisher___ZYs8,.member-only__overlay-bottom__dZ6dm .member-only__info__2RYGB .member-only__title__1qOy6{padding-left:0;padding-right:0;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}@media only screen and (max-width:320px){.member-only__overlay-bottom__dZ6dm .member-only__buttons__3Mwj7,.member-only__overlay__LCmbA .member-only__buttons__3Mwj7{margin-top:25px}.member-only__overlay-bottom__dZ6dm .member-only__buttons__3Mwj7 .member-only__button__1CgYY,.member-only__overlay__LCmbA .member-only__buttons__3Mwj7 .member-only__button__1CgYY{margin:0 5px}}.member-only__button__1CgYY .member-only__next-icon__2sNTd,.member-only__button__1CgYY .member-only__play-icon__jvNCn{font-size:14px}.member-only__button__1CgYY .member-only__play-icon__jvNCn{margin-right:11px}.member-only__button__1CgYY .member-only__next-icon__2sNTd{margin-left:11px}@media only screen and (max-width:320px){.member-only__button__1CgYY .member-only__play-icon__jvNCn{font-size:10px}}.member-only__wrapper__2Nx5p{display:-ms-flexbox;display:flex;position:relative;background-color:#000}.member-only__overlay__LCmbA{position:relative;height:100%}", ""]);

// exports
exports.locals = {
	"overlay": "member-only__overlay__LCmbA",
	"overlay-bottom": "member-only__overlay-bottom__dZ6dm",
	"overlayBottom": "member-only__overlay-bottom__dZ6dm",
	"title": "member-only__title__1qOy6",
	"publisher": "member-only__publisher___ZYs8",
	"preview-text": "member-only__preview-text__1AZgr",
	"previewText": "member-only__preview-text__1AZgr",
	"buttons": "member-only__buttons__3Mwj7",
	"button": "member-only__button__1CgYY",
	"play-button": "member-only__play-button__2hhbB",
	"playButton": "member-only__play-button__2hhbB",
	"play-icon": "member-only__play-icon__jvNCn",
	"playIcon": "member-only__play-icon__jvNCn",
	"info": "member-only__info__2RYGB",
	"next-icon": "member-only__next-icon__2sNTd",
	"nextIcon": "member-only__next-icon__2sNTd",
	"wrapper": "member-only__wrapper__2Nx5p"
};

/***/ }),
/* 2920 */,
/* 2921 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".bottom-buttons__bottom-button__be5nU{background-color:rgba(0,0,0,.2);border:1px solid #fff;border-radius:0;height:38px;font-size:12px;color:#fff}.bottom-buttons__bottom-button__be5nU+.bottom-buttons__bottom-button__be5nU{border-left:none}.bottom-buttons__paid-icon__2LM3h{margin-right:5px;font-size:14px}", ""]);

// exports
exports.locals = {
	"bottom-button": "bottom-buttons__bottom-button__be5nU",
	"bottomButton": "bottom-buttons__bottom-button__be5nU",
	"paid-icon": "bottom-buttons__paid-icon__2LM3h",
	"paidIcon": "bottom-buttons__paid-icon__2LM3h"
};

/***/ }),
/* 2922 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".middle-buttons__play__3JrgR,.middle-buttons__purchase__40Ju-{overflow:hidden;height:auto;padding:0;border-radius:0;border:none;font-size:14px;color:#fff}.middle-buttons__icon__3ryEt{width:30px;height:30px;border-width:2px;border-color:#fff;margin-right:7px}.middle-buttons__play-icon__Oo-HK:before{transform:scale(.8);left:2px;position:relative}.middle-buttons__text__3QiaB{width:100%;border-bottom:1px solid #fff;line-height:normal;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.middle-buttons__purchase__40Ju- .middle-buttons__text__3QiaB{display:inline-block}", ""]);

// exports
exports.locals = {
	"play": "middle-buttons__play__3JrgR",
	"purchase": "middle-buttons__purchase__40Ju-",
	"icon": "middle-buttons__icon__3ryEt",
	"play-icon": "middle-buttons__play-icon__Oo-HK",
	"playIcon": "middle-buttons__play-icon__Oo-HK",
	"text": "middle-buttons__text__3QiaB"
};

/***/ }),
/* 2923 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".three-rows-widget__overlay__znYzv{-ms-flex-pack:justify;justify-content:space-between;padding:0 20px;background-color:rgba(0,0,0,.4)}.three-rows-widget__main__2_JJ_,.three-rows-widget__overlay__znYzv{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;align-items:center}.three-rows-widget__main__2_JJ_{width:100%;-ms-flex-positive:1;flex-grow:1;-ms-flex-pack:center;justify-content:center}.three-rows-widget__play-container__1avGK{width:100%;text-align:center;overflow:hidden}.three-rows-widget__title__pAPcg+.three-rows-widget__play-container__1avGK{margin-top:10px}.three-rows-widget__title__pAPcg{text-align:center;width:100%}.three-rows-widget__title-text__4WcOj{width:150px;font-size:22px;color:#fff;white-space:normal}.three-rows-widget__buttons__1A-PL{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;width:100%;margin-bottom:25px}.three-rows-widget__bottom-button__2EZIk{-ms-flex:1 1 100%;flex:1 1 100%;max-width:50%}.three-rows-widget__single__1gMwO .three-rows-widget__bottom-button__2EZIk{-ms-flex:0 1 auto;flex:0 1 auto;max-width:100%;min-width:calc(50% + 20px)}.three-rows-widget__rounded__2OqRg .three-rows-widget__bottom-button__2EZIk:first-child{border-top-left-radius:6px;border-bottom-left-radius:6px}.three-rows-widget__rounded__2OqRg .three-rows-widget__bottom-button__2EZIk:last-child{border-top-right-radius:6px;border-bottom-right-radius:6px}", ""]);

// exports
exports.locals = {
	"overlay": "three-rows-widget__overlay__znYzv",
	"main": "three-rows-widget__main__2_JJ_",
	"play-container": "three-rows-widget__play-container__1avGK",
	"playContainer": "three-rows-widget__play-container__1avGK",
	"title": "three-rows-widget__title__pAPcg",
	"title-text": "three-rows-widget__title-text__4WcOj",
	"titleText": "three-rows-widget__title-text__4WcOj",
	"buttons": "three-rows-widget__buttons__1A-PL",
	"bottom-button": "three-rows-widget__bottom-button__2EZIk",
	"bottomButton": "three-rows-widget__bottom-button__2EZIk",
	"single": "three-rows-widget__single__1gMwO",
	"rounded": "three-rows-widget__rounded__2OqRg"
};

/***/ }),
/* 2924 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".classic-search-bar__container__3k3EG{position:relative;transition:width .2s}.classic-search-bar__container__3k3EG.classic-search-bar__focused__3Y_-G .classic-search-bar__input__1Waxq,.classic-search-bar__container__3k3EG.classic-search-bar__focused__3Y_-G .classic-search-bar__input__1Waxq:hover,.classic-search-bar__container__3k3EG.classic-search-bar__has-submitted-value__qm3Os .classic-search-bar__input__1Waxq,.classic-search-bar__container__3k3EG.classic-search-bar__has-submitted-value__qm3Os .classic-search-bar__input__1Waxq:hover{outline:none;box-shadow:none;background-color:-wix-colors-textColor-10;padding:0 38px}.classic-search-bar__container__3k3EG.classic-search-bar__focused__3Y_-G .classic-search-bar__input__1Waxq::-webkit-input-placeholder,.classic-search-bar__container__3k3EG.classic-search-bar__focused__3Y_-G .classic-search-bar__input__1Waxq:hover::-webkit-input-placeholder,.classic-search-bar__container__3k3EG.classic-search-bar__has-submitted-value__qm3Os .classic-search-bar__input__1Waxq::-webkit-input-placeholder,.classic-search-bar__container__3k3EG.classic-search-bar__has-submitted-value__qm3Os .classic-search-bar__input__1Waxq:hover::-webkit-input-placeholder{color:-wix-colors-textColor-70}.classic-search-bar__container__3k3EG.classic-search-bar__focused__3Y_-G .classic-search-bar__input__1Waxq:-ms-input-placeholder,.classic-search-bar__container__3k3EG.classic-search-bar__focused__3Y_-G .classic-search-bar__input__1Waxq:hover:-ms-input-placeholder,.classic-search-bar__container__3k3EG.classic-search-bar__has-submitted-value__qm3Os .classic-search-bar__input__1Waxq:-ms-input-placeholder,.classic-search-bar__container__3k3EG.classic-search-bar__has-submitted-value__qm3Os .classic-search-bar__input__1Waxq:hover:-ms-input-placeholder{color:-wix-colors-textColor-70}.classic-search-bar__container__3k3EG.classic-search-bar__focused__3Y_-G .classic-search-bar__input__1Waxq::placeholder,.classic-search-bar__container__3k3EG.classic-search-bar__focused__3Y_-G .classic-search-bar__input__1Waxq:hover::placeholder,.classic-search-bar__container__3k3EG.classic-search-bar__has-submitted-value__qm3Os .classic-search-bar__input__1Waxq::placeholder,.classic-search-bar__container__3k3EG.classic-search-bar__has-submitted-value__qm3Os .classic-search-bar__input__1Waxq:hover::placeholder{color:-wix-colors-textColor-70}.classic-search-bar__container__3k3EG.classic-search-bar__focused__3Y_-G .classic-search-bar__input__1Waxq::-moz-selection,.classic-search-bar__container__3k3EG.classic-search-bar__focused__3Y_-G .classic-search-bar__input__1Waxq:hover::-moz-selection,.classic-search-bar__container__3k3EG.classic-search-bar__has-submitted-value__qm3Os .classic-search-bar__input__1Waxq::-moz-selection,.classic-search-bar__container__3k3EG.classic-search-bar__has-submitted-value__qm3Os .classic-search-bar__input__1Waxq:hover::-moz-selection{background-color:-wix-colors-textColor-20}.classic-search-bar__container__3k3EG.classic-search-bar__focused__3Y_-G .classic-search-bar__input__1Waxq::selection,.classic-search-bar__container__3k3EG.classic-search-bar__focused__3Y_-G .classic-search-bar__input__1Waxq:hover::selection,.classic-search-bar__container__3k3EG.classic-search-bar__has-submitted-value__qm3Os .classic-search-bar__input__1Waxq::selection,.classic-search-bar__container__3k3EG.classic-search-bar__has-submitted-value__qm3Os .classic-search-bar__input__1Waxq:hover::selection{background-color:-wix-colors-textColor-20}.classic-search-bar__container__3k3EG.classic-search-bar__focused__3Y_-G .classic-search-bar__search-icon__2PWlq,.classic-search-bar__container__3k3EG.classic-search-bar__has-submitted-value__qm3Os .classic-search-bar__search-icon__2PWlq{left:12px}.classic-search-bar__container__3k3EG.classic-search-bar__focused__3Y_-G .classic-search-bar__close-search__2Mxjh,.classic-search-bar__container__3k3EG.classic-search-bar__has-submitted-value__qm3Os .classic-search-bar__close-search__2Mxjh{display:block}.classic-search-bar__container__3k3EG.classic-search-bar__has-submitted-value__qm3Os .classic-search-bar__input__1Waxq,.classic-search-bar__container__3k3EG.classic-search-bar__has-value__unZ14 .classic-search-bar__input__1Waxq{background-color:-wix-colors-textColor-10;padding:0 38px}.classic-search-bar__container__3k3EG.classic-search-bar__has-submitted-value__qm3Os .classic-search-bar__close-search__2Mxjh,.classic-search-bar__container__3k3EG.classic-search-bar__has-value__unZ14 .classic-search-bar__close-search__2Mxjh{display:block}.classic-search-bar__container__3k3EG.classic-search-bar__has-submitted-value__qm3Os .classic-search-bar__search-icon__2PWlq,.classic-search-bar__container__3k3EG.classic-search-bar__has-value__unZ14 .classic-search-bar__search-icon__2PWlq{left:12px}.classic-search-bar__container__3k3EG.classic-search-bar__changed__1qUCi .classic-search-bar__close-search__2Mxjh{display:none}.classic-search-bar__container__3k3EG.classic-search-bar__changed__1qUCi .classic-search-bar__permit-search__2ZoGw,.classic-search-bar__container__3k3EG.classic-search-bar__changed__1qUCi:not(.classic-search-bar__has-value__unZ14) .classic-search-bar__close-search__2Mxjh{display:block}.classic-search-bar__container__3k3EG.classic-search-bar__changed__1qUCi:not(.classic-search-bar__has-value__unZ14) .classic-search-bar__permit-search__2ZoGw{display:none}.classic-search-bar__container__3k3EG .classic-search-bar__close-search__2Mxjh,.classic-search-bar__container__3k3EG .classic-search-bar__permit-search__2ZoGw,.classic-search-bar__container__3k3EG .classic-search-bar__search-icon__2PWlq{position:absolute;top:0;line-height:42px;font-size:15px;color:-wix-colors-textColor}.classic-search-bar__container__3k3EG .classic-search-bar__search-icon__2PWlq{left:0;transition:left .2s}.classic-search-bar__container__3k3EG .classic-search-bar__close-search__2Mxjh,.classic-search-bar__container__3k3EG .classic-search-bar__permit-search__2ZoGw{display:none;right:14px;cursor:pointer}.classic-search-bar__container__3k3EG .classic-search-bar__background-text__3exoc,.classic-search-bar__container__3k3EG .classic-search-bar__input__1Waxq{border:none;background:transparent;outline:none;color:-wix-colors-textColor;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family;text-decoration:-wix-fonts-textFont-decoration;width:100%;margin:0;line-height:42px;height:42px;padding:0 26px;box-sizing:border-box}.classic-search-bar__container__3k3EG .classic-search-bar__background-text__3exoc{white-space:nowrap;visibility:hidden}.classic-search-bar__container__3k3EG .classic-search-bar__input__1Waxq{top:0;left:0;right:0;bottom:0;position:absolute;transition:padding .2s,background .2s}.classic-search-bar__container__3k3EG .classic-search-bar__input__1Waxq:hover::-webkit-input-placeholder{color:-wix-colors-textColor}.classic-search-bar__container__3k3EG .classic-search-bar__input__1Waxq:hover:-ms-input-placeholder{color:-wix-colors-textColor}.classic-search-bar__container__3k3EG .classic-search-bar__input__1Waxq:hover::placeholder{color:-wix-colors-textColor}.classic-search-bar__container__3k3EG .classic-search-bar__input__1Waxq::-webkit-input-placeholder{color:-wix-colors-textColor-70;transition:color .2s}.classic-search-bar__container__3k3EG .classic-search-bar__input__1Waxq:-ms-input-placeholder{color:-wix-colors-textColor-70;transition:color .2s}.classic-search-bar__container__3k3EG .classic-search-bar__input__1Waxq::placeholder{color:-wix-colors-textColor-70;transition:color .2s}.classic-search-bar__container__3k3EG .classic-search-bar__input__1Waxq::-moz-selection{background-color:-wix-colors-textColor-10}.classic-search-bar__container__3k3EG .classic-search-bar__input__1Waxq::selection{background-color:-wix-colors-textColor-10}", ""]);

// exports
exports.locals = {
	"container": "classic-search-bar__container__3k3EG",
	"focused": "classic-search-bar__focused__3Y_-G",
	"input": "classic-search-bar__input__1Waxq",
	"has-submitted-value": "classic-search-bar__has-submitted-value__qm3Os",
	"hasSubmittedValue": "classic-search-bar__has-submitted-value__qm3Os",
	"search-icon": "classic-search-bar__search-icon__2PWlq",
	"searchIcon": "classic-search-bar__search-icon__2PWlq",
	"close-search": "classic-search-bar__close-search__2Mxjh",
	"closeSearch": "classic-search-bar__close-search__2Mxjh",
	"has-value": "classic-search-bar__has-value__unZ14",
	"hasValue": "classic-search-bar__has-value__unZ14",
	"changed": "classic-search-bar__changed__1qUCi",
	"permit-search": "classic-search-bar__permit-search__2ZoGw",
	"permitSearch": "classic-search-bar__permit-search__2ZoGw",
	"background-text": "classic-search-bar__background-text__3exoc",
	"backgroundText": "classic-search-bar__background-text__3exoc"
};

/***/ }),
/* 2925 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".strip-search-bar__container__2Bs8y{position:relative;transition:width .2s}.strip-search-bar__container__2Bs8y.strip-search-bar__focused__17qlH .strip-search-bar__input__23fei,.strip-search-bar__container__2Bs8y.strip-search-bar__focused__17qlH .strip-search-bar__input__23fei:hover,.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__input__23fei,.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__input__23fei:hover{outline:none;box-shadow:none;background-color:-wix-colors-textColor-10;padding:0 38px}.strip-search-bar__container__2Bs8y.strip-search-bar__focused__17qlH .strip-search-bar__input__23fei::-webkit-input-placeholder,.strip-search-bar__container__2Bs8y.strip-search-bar__focused__17qlH .strip-search-bar__input__23fei:hover::-webkit-input-placeholder,.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__input__23fei::-webkit-input-placeholder,.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__input__23fei:hover::-webkit-input-placeholder{color:-wix-colors-textColor-70}.strip-search-bar__container__2Bs8y.strip-search-bar__focused__17qlH .strip-search-bar__input__23fei:-ms-input-placeholder,.strip-search-bar__container__2Bs8y.strip-search-bar__focused__17qlH .strip-search-bar__input__23fei:hover:-ms-input-placeholder,.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__input__23fei:-ms-input-placeholder,.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__input__23fei:hover:-ms-input-placeholder{color:-wix-colors-textColor-70}.strip-search-bar__container__2Bs8y.strip-search-bar__focused__17qlH .strip-search-bar__input__23fei::placeholder,.strip-search-bar__container__2Bs8y.strip-search-bar__focused__17qlH .strip-search-bar__input__23fei:hover::placeholder,.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__input__23fei::placeholder,.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__input__23fei:hover::placeholder{color:-wix-colors-textColor-70}.strip-search-bar__container__2Bs8y.strip-search-bar__focused__17qlH .strip-search-bar__input__23fei::-moz-selection,.strip-search-bar__container__2Bs8y.strip-search-bar__focused__17qlH .strip-search-bar__input__23fei:hover::-moz-selection,.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__input__23fei::-moz-selection,.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__input__23fei:hover::-moz-selection{background-color:-wix-colors-textColor-20}.strip-search-bar__container__2Bs8y.strip-search-bar__focused__17qlH .strip-search-bar__input__23fei::selection,.strip-search-bar__container__2Bs8y.strip-search-bar__focused__17qlH .strip-search-bar__input__23fei:hover::selection,.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__input__23fei::selection,.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__input__23fei:hover::selection{background-color:-wix-colors-textColor-20}.strip-search-bar__container__2Bs8y.strip-search-bar__focused__17qlH .strip-search-bar__search-icon__CEJsT,.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__search-icon__CEJsT{left:12px}.strip-search-bar__container__2Bs8y.strip-search-bar__focused__17qlH .strip-search-bar__close-search__2xqmR,.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__close-search__2xqmR{display:block}.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__input__23fei,.strip-search-bar__container__2Bs8y.strip-search-bar__has-value__1u8v3 .strip-search-bar__input__23fei{background-color:-wix-colors-textColor-10;padding:0 38px}.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__close-search__2xqmR,.strip-search-bar__container__2Bs8y.strip-search-bar__has-value__1u8v3 .strip-search-bar__close-search__2xqmR{display:block}.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__search-icon__CEJsT,.strip-search-bar__container__2Bs8y.strip-search-bar__has-value__1u8v3 .strip-search-bar__search-icon__CEJsT{left:12px}.strip-search-bar__container__2Bs8y.strip-search-bar__changed__12eU2 .strip-search-bar__close-search__2xqmR{display:none}.strip-search-bar__container__2Bs8y.strip-search-bar__changed__12eU2 .strip-search-bar__permit-search__Wb-Ni,.strip-search-bar__container__2Bs8y.strip-search-bar__changed__12eU2:not(.strip-search-bar__has-value__1u8v3) .strip-search-bar__close-search__2xqmR{display:block}.strip-search-bar__container__2Bs8y.strip-search-bar__changed__12eU2:not(.strip-search-bar__has-value__1u8v3) .strip-search-bar__permit-search__Wb-Ni{display:none}.strip-search-bar__container__2Bs8y .strip-search-bar__close-search__2xqmR,.strip-search-bar__container__2Bs8y .strip-search-bar__permit-search__Wb-Ni,.strip-search-bar__container__2Bs8y .strip-search-bar__search-icon__CEJsT{position:absolute;top:0;line-height:42px;font-size:15px;color:-wix-colors-textColor}.strip-search-bar__container__2Bs8y .strip-search-bar__search-icon__CEJsT{left:0;transition:left .2s}.strip-search-bar__container__2Bs8y .strip-search-bar__close-search__2xqmR,.strip-search-bar__container__2Bs8y .strip-search-bar__permit-search__Wb-Ni{display:none;right:14px;cursor:pointer}.strip-search-bar__container__2Bs8y .strip-search-bar__background-text__3YC9i,.strip-search-bar__container__2Bs8y .strip-search-bar__input__23fei{border:none;background:transparent;outline:none;color:-wix-colors-textColor;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family;text-decoration:-wix-fonts-textFont-decoration;width:100%;margin:0;line-height:42px;height:42px;padding:0 26px;box-sizing:border-box}.strip-search-bar__container__2Bs8y .strip-search-bar__background-text__3YC9i{white-space:nowrap;visibility:hidden}.strip-search-bar__container__2Bs8y .strip-search-bar__input__23fei{top:0;left:0;right:0;bottom:0;position:absolute;transition:padding .2s,background .2s}.strip-search-bar__container__2Bs8y .strip-search-bar__input__23fei:hover::-webkit-input-placeholder{color:-wix-colors-textColor}.strip-search-bar__container__2Bs8y .strip-search-bar__input__23fei:hover:-ms-input-placeholder{color:-wix-colors-textColor}.strip-search-bar__container__2Bs8y .strip-search-bar__input__23fei:hover::placeholder{color:-wix-colors-textColor}.strip-search-bar__container__2Bs8y .strip-search-bar__input__23fei::-webkit-input-placeholder{color:-wix-colors-textColor-70}.strip-search-bar__container__2Bs8y .strip-search-bar__input__23fei:-ms-input-placeholder{color:-wix-colors-textColor-70}.strip-search-bar__container__2Bs8y .strip-search-bar__input__23fei::placeholder{color:-wix-colors-textColor-70}.strip-search-bar__container__2Bs8y .strip-search-bar__input__23fei::-moz-selection{background-color:-wix-colors-textColor-10}.strip-search-bar__container__2Bs8y .strip-search-bar__input__23fei::selection{background-color:-wix-colors-textColor-10}.strip-search-bar__container__2Bs8y.strip-search-bar__focused__17qlH .strip-search-bar__input__23fei,.strip-search-bar__container__2Bs8y.strip-search-bar__focused__17qlH .strip-search-bar__input__23fei:hover,.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__input__23fei,.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__input__23fei:hover{background-color:transparent;border-bottom-color:#fff}.strip-search-bar__container__2Bs8y.strip-search-bar__focused__17qlH .strip-search-bar__input__23fei::-webkit-input-placeholder,.strip-search-bar__container__2Bs8y.strip-search-bar__focused__17qlH .strip-search-bar__input__23fei:hover::-webkit-input-placeholder,.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__input__23fei::-webkit-input-placeholder,.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__input__23fei:hover::-webkit-input-placeholder{color:hsla(0,0%,100%,.7)}.strip-search-bar__container__2Bs8y.strip-search-bar__focused__17qlH .strip-search-bar__input__23fei:-ms-input-placeholder,.strip-search-bar__container__2Bs8y.strip-search-bar__focused__17qlH .strip-search-bar__input__23fei:hover:-ms-input-placeholder,.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__input__23fei:-ms-input-placeholder,.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__input__23fei:hover:-ms-input-placeholder{color:hsla(0,0%,100%,.7)}.strip-search-bar__container__2Bs8y.strip-search-bar__focused__17qlH .strip-search-bar__input__23fei::placeholder,.strip-search-bar__container__2Bs8y.strip-search-bar__focused__17qlH .strip-search-bar__input__23fei:hover::placeholder,.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__input__23fei::placeholder,.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__input__23fei:hover::placeholder{color:hsla(0,0%,100%,.7)}.strip-search-bar__container__2Bs8y.strip-search-bar__focused__17qlH .strip-search-bar__input__23fei::-moz-selection,.strip-search-bar__container__2Bs8y.strip-search-bar__focused__17qlH .strip-search-bar__input__23fei:hover::-moz-selection,.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__input__23fei::-moz-selection,.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__input__23fei:hover::-moz-selection{background-color:hsla(0,0%,100%,.2)}.strip-search-bar__container__2Bs8y.strip-search-bar__focused__17qlH .strip-search-bar__input__23fei::selection,.strip-search-bar__container__2Bs8y.strip-search-bar__focused__17qlH .strip-search-bar__input__23fei:hover::selection,.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__input__23fei::selection,.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__input__23fei:hover::selection{background-color:hsla(0,0%,100%,.2)}.strip-search-bar__container__2Bs8y.strip-search-bar__has-submitted-value__39_c- .strip-search-bar__input__23fei,.strip-search-bar__container__2Bs8y.strip-search-bar__has-value__1u8v3 .strip-search-bar__input__23fei{background-color:transparent;border-bottom-color:#fff}.strip-search-bar__container__2Bs8y .strip-search-bar__close-search__2xqmR,.strip-search-bar__container__2Bs8y .strip-search-bar__permit-search__Wb-Ni,.strip-search-bar__container__2Bs8y .strip-search-bar__search-icon__CEJsT{color:#fff}.strip-search-bar__container__2Bs8y .strip-search-bar__input__23fei{color:#fff;background-color:transparent;border-bottom:1px solid hsla(0,0%,100%,.7)}.strip-search-bar__container__2Bs8y .strip-search-bar__input__23fei:hover::-webkit-input-placeholder{color:hsla(0,0%,100%,.7)}.strip-search-bar__container__2Bs8y .strip-search-bar__input__23fei:hover:-ms-input-placeholder{color:hsla(0,0%,100%,.7)}.strip-search-bar__container__2Bs8y .strip-search-bar__input__23fei:hover::placeholder{color:hsla(0,0%,100%,.7)}.strip-search-bar__container__2Bs8y .strip-search-bar__input__23fei::-webkit-input-placeholder{color:#fff;transition:color .2s}.strip-search-bar__container__2Bs8y .strip-search-bar__input__23fei:-ms-input-placeholder{color:#fff;transition:color .2s}.strip-search-bar__container__2Bs8y .strip-search-bar__input__23fei::placeholder{color:#fff;transition:color .2s}.strip-search-bar__container__2Bs8y .strip-search-bar__input__23fei::-moz-selection{background-color:hsla(0,0%,100%,.1)}.strip-search-bar__container__2Bs8y .strip-search-bar__input__23fei::selection{background-color:hsla(0,0%,100%,.1)}", ""]);

// exports
exports.locals = {
	"container": "strip-search-bar__container__2Bs8y",
	"focused": "strip-search-bar__focused__17qlH",
	"input": "strip-search-bar__input__23fei",
	"has-submitted-value": "strip-search-bar__has-submitted-value__39_c-",
	"hasSubmittedValue": "strip-search-bar__has-submitted-value__39_c-",
	"search-icon": "strip-search-bar__search-icon__CEJsT",
	"searchIcon": "strip-search-bar__search-icon__CEJsT",
	"close-search": "strip-search-bar__close-search__2xqmR",
	"closeSearch": "strip-search-bar__close-search__2xqmR",
	"has-value": "strip-search-bar__has-value__1u8v3",
	"hasValue": "strip-search-bar__has-value__1u8v3",
	"changed": "strip-search-bar__changed__12eU2",
	"permit-search": "strip-search-bar__permit-search__Wb-Ni",
	"permitSearch": "strip-search-bar__permit-search__Wb-Ni",
	"background-text": "strip-search-bar__background-text__3YC9i",
	"backgroundText": "strip-search-bar__background-text__3YC9i"
};

/***/ }),
/* 2926 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".share-channel__share-container__2vZmS{display:-ms-flexbox;display:flex;position:relative;color:-wix-colors-buttonsAndLinksColor-80}.share-channel__share-container__2vZmS:hover{color:-wix-colors-buttonsAndLinksColor-100}.share-channel__share-container__2vZmS:hover .share-channel__share-buttons__bMm5z{transition:opacity .3s ease .15s,margin .3s;opacity:1;margin-left:0}.share-channel__share-container__2vZmS:hover .share-channel__share__2UXlw{opacity:.5}.share-channel__share__2UXlw{cursor:pointer;font-size:13px;height:13px}.share-channel__share-buttons__bMm5z{color:-wix-colors-buttonsAndLinksColor-100;display:-ms-flexbox;display:flex;-ms-flex-line-pack:justify;align-content:space-between;width:110px;height:13px;padding-right:18px;margin-left:-110px;opacity:0;transition-property:opacity,margin;transition-duration:.3s;transition-delay:.5s}.share-channel__share-button__2oGPJ{cursor:pointer;font-size:13px}.share-channel__facebook__-WkQU:hover{color:#3b5999}.share-channel__twitter__N9wMI:hover{color:#55acee}.share-channel__pinterest__31poE:hover{color:#bd081c}.share-channel__tumblr__1iIpB:hover{color:#34465d}", ""]);

// exports
exports.locals = {
	"share-container": "share-channel__share-container__2vZmS",
	"shareContainer": "share-channel__share-container__2vZmS",
	"share-buttons": "share-channel__share-buttons__bMm5z",
	"shareButtons": "share-channel__share-buttons__bMm5z",
	"share": "share-channel__share__2UXlw",
	"share-button": "share-channel__share-button__2oGPJ",
	"shareButton": "share-channel__share-button__2oGPJ",
	"facebook": "share-channel__facebook__-WkQU",
	"twitter": "share-channel__twitter__N9wMI",
	"pinterest": "share-channel__pinterest__31poE",
	"tumblr": "share-channel__tumblr__1iIpB"
};

/***/ }),
/* 2927 */,
/* 2928 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".thumbnail__wrapper__1Qdhq{-ms-flex-direction:column;flex-direction:column}.thumbnail__thumbnail__3osrE,.thumbnail__wrapper__1Qdhq{display:-ms-inline-flexbox;display:inline-flex}.thumbnail__thumbnail__3osrE{position:relative}.thumbnail__thumbnail__3osrE:hover .thumbnail__purchase-icon__aGsy1,.thumbnail__thumbnail__3osrE:hover .thumbnail__watched-icon__2ddb5,.thumbnail__thumbnail__3osrE:hover:before{opacity:1}.thumbnail__thumbnail__3osrE:before{content:attr(data-duration);display:-ms-inline-flexbox;display:inline-flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;z-index:2;box-sizing:border-box;min-width:60px;max-width:calc(100% - 23px);height:23px;padding-left:8px;padding-right:8px;color:#fff;font-size:12px;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family;text-decoration:-wix-fonts-textFont-decoration;background-color:rgba(0,0,0,.6);transition:width .2s,opacity .2s}.thumbnail__thumbnail__3osrE:after,.thumbnail__thumbnail__3osrE:before{position:absolute;left:0;bottom:0;opacity:0}.thumbnail__thumbnail__3osrE:after{content:\"\";top:0;right:0;border:solid -wix-colors-buttonsAndLinksColor;z-index:3;transition:opacity .2s}.thumbnail__selected__1OxPt .thumbnail__purchase-icon__aGsy1,.thumbnail__selected__1OxPt .thumbnail__watched-icon__2ddb5{right:2px;bottom:2px;width:21px;height:21px;padding-top:2px;padding-left:2px;opacity:1}.thumbnail__selected__1OxPt.thumbnail__description-on-video__2TAN5 .thumbnail__description__1_IJr{left:2px;top:2px;right:2px;bottom:2px;padding:6px}.thumbnail__selected__1OxPt .thumbnail__thumbnail__3osrE:after{opacity:1}.thumbnail__selected__1OxPt .thumbnail__thumbnail__3osrE:before{left:2px;bottom:2px;height:21px;padding-top:2px;min-width:56px;max-width:calc(100% - 25px);display:-ms-inline-flexbox;display:inline-flex;padding-left:6px;padding-right:6px;opacity:1}.thumbnail__now-playing__3hK0E .thumbnail__thumbnail__3osrE:before,.thumbnail__now-playing__3hK0E .thumbnail__thumbnail__3osrE:hover:before{content:attr(data-now-playing);display:-ms-inline-flexbox;display:inline-flex}.thumbnail__purchase-icon__aGsy1,.thumbnail__watched-icon__2ddb5{position:absolute;z-index:2;right:0;bottom:0;display:-ms-inline-flexbox;display:inline-flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:23px;height:23px;box-sizing:border-box;color:#fff;font-size:13px;background-color:rgba(0,0,0,.6);opacity:0;transition:opacity .2s}.thumbnail__description__1_IJr{margin-top:8px;font-size:14px;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family;text-decoration:-wix-fonts-textFont-decoration;overflow:hidden}.thumbnail__publisher__2eTEk,.thumbnail__title__xnLPG{display:block;height:18px;line-height:18px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.thumbnail__title__xnLPG{color:-wix-colors-textColor}.thumbnail__publisher__2eTEk{color:-wix-colors-textColor-50}.thumbnail__description-on-video__2TAN5.thumbnail__description-on-hover__1-9dd.thumbnail__preview-hover__3PWbX .thumbnail__description__1_IJr,.thumbnail__description-on-video__2TAN5.thumbnail__description-on-hover__1-9dd:hover .thumbnail__description__1_IJr{opacity:1}.thumbnail__description-on-video__2TAN5.thumbnail__description-on-hover__1-9dd .thumbnail__description__1_IJr{opacity:0;background-color:rgba(0,0,0,.5);transition:opacity .2s}.thumbnail__description-on-video__2TAN5 .thumbnail__description__1_IJr{position:absolute;z-index:1;left:0;right:0;bottom:0;top:0;margin:0;padding:8px;font-size:12px;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family;text-decoration:-wix-fonts-textFont-decoration;background:linear-gradient(0deg,transparent,rgba(0,0,0,.351)) no-repeat;background-size:100% 40px}.thumbnail__description-on-video__2TAN5 .thumbnail__title__xnLPG{height:auto;max-height:28px;line-height:normal;color:#fff;overflow:visible}.thumbnail__description-on-video__2TAN5 .thumbnail__publisher__2eTEk{display:none}.thumbnail__clickable__1gOu1{display:-ms-inline-flexbox;display:inline-flex;text-decoration:none}", ""]);

// exports
exports.locals = {
	"wrapper": "thumbnail__wrapper__1Qdhq",
	"thumbnail": "thumbnail__thumbnail__3osrE",
	"purchase-icon": "thumbnail__purchase-icon__aGsy1",
	"purchaseIcon": "thumbnail__purchase-icon__aGsy1",
	"watched-icon": "thumbnail__watched-icon__2ddb5",
	"watchedIcon": "thumbnail__watched-icon__2ddb5",
	"selected": "thumbnail__selected__1OxPt",
	"description-on-video": "thumbnail__description-on-video__2TAN5",
	"descriptionOnVideo": "thumbnail__description-on-video__2TAN5",
	"description": "thumbnail__description__1_IJr",
	"now-playing": "thumbnail__now-playing__3hK0E",
	"nowPlaying": "thumbnail__now-playing__3hK0E",
	"publisher": "thumbnail__publisher__2eTEk",
	"title": "thumbnail__title__xnLPG",
	"description-on-hover": "thumbnail__description-on-hover__1-9dd",
	"descriptionOnHover": "thumbnail__description-on-hover__1-9dd",
	"preview-hover": "thumbnail__preview-hover__3PWbX",
	"previewHover": "thumbnail__preview-hover__3PWbX",
	"clickable": "thumbnail__clickable__1gOu1"
};

/***/ }),
/* 2929 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".nav-button__nav-button__26ZQn{display:inline-block;padding:0;outline:none;border:none;background:none;transition:opacity .2s,visibility .2s}.nav-button__nav-button__26ZQn .nav-button__nav-text__GQz68{display:inline-block;margin:0 13px;color:-wix-colors-textColor;text-decoration:-wix-fonts-textFont-decoration;font-size:14px;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family}.nav-button__nav-button__26ZQn .nav-button__nav-arrow__2Z8JX{width:30px;height:9px;fill:-wix-colors-textColor}.nav-button__nav-button__26ZQn:hover{opacity:.7}.nav-button__nav-button__26ZQn.nav-button__disabled__3wnrx,.nav-button__nav-button__26ZQn.nav-button__disabled__3wnrx:hover{visibility:hidden;opacity:0}.nav-button__nav-button__26ZQn+.nav-button__nav-button__26ZQn{margin-left:10px}.nav-button__nav-button__26ZQn polygon{fill:-wix-colors-textColor}.nav-button__nav-button__26ZQn.nav-button__prev__24p06 .nav-button__nav-arrow__2Z8JX{transform:rotate(180deg)}.nav-button__nav-button__26ZQn.nav-button__next__1rwow{direction:rtl}", ""]);

// exports
exports.locals = {
	"nav-button": "nav-button__nav-button__26ZQn",
	"navButton": "nav-button__nav-button__26ZQn",
	"nav-text": "nav-button__nav-text__GQz68",
	"navText": "nav-button__nav-text__GQz68",
	"nav-arrow": "nav-button__nav-arrow__2Z8JX",
	"navArrow": "nav-button__nav-arrow__2Z8JX",
	"disabled": "nav-button__disabled__3wnrx",
	"prev": "nav-button__prev__24p06",
	"next": "nav-button__next__1rwow"
};

/***/ }),
/* 2930 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".thumbnail-overlay__overlay__1nyI8{position:absolute;top:0;left:0;right:0;bottom:0;z-index:120;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:stretch;align-items:stretch;color:#fff}.thumbnail-overlay__content__2MZkG{-ms-flex:1 1 auto;flex:1 1 auto}.thumbnail-overlay__content__2MZkG,.thumbnail-overlay__top-content__3DNWA{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;align-items:center}.thumbnail-overlay__top-content__3DNWA{-ms-flex-pack:center;justify-content:center;-ms-flex:1 1 auto;flex:1 1 auto;max-width:920px}.thumbnail-overlay__top-content__3DNWA .thumbnail-overlay__title__qAwro{width:100%;margin-bottom:25px;font-weight:-wix-fonts-titleFont-weight;font-style:-wix-fonts-titleFont-style;font-family:-wix-fonts-titleFont-family;text-decoration:-wix-fonts-titleFont-decoration;font-size:-wix-fonts-titleFont-size;line-height:normal;text-align:center}.thumbnail-overlay__top-content__3DNWA .thumbnail-overlay__title__qAwro .thumbnail-overlay__preview-text__4n7ex{margin-left:10px;font-size:14px}.thumbnail-overlay__top-content__3DNWA .thumbnail-overlay__publisher__1-LXl{margin-bottom:30px;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family;text-decoration:-wix-fonts-textFont-decoration;text-align:center;font-size:18px}.thumbnail-overlay__buttons-wrapper__2mXOL{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;height:40px}.thumbnail-overlay__buttons-wrapper__2mXOL:first-child{margin-top:107px}.thumbnail-overlay__buttons-wrapper__2mXOL .thumbnail-overlay__button__rlddz{font-size:18px;white-space:nowrap;line-height:37px}.thumbnail-overlay__buttons-wrapper__2mXOL .thumbnail-overlay__button__rlddz+.thumbnail-overlay__button__rlddz{margin-left:54px}.thumbnail-overlay__rounded-icon__ppGhV{width:37px;height:37px;padding-left:2px;border-color:#fff;border-width:2px}.thumbnail-overlay__button__rlddz{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;height:40px;padding:0;transition:opacity .2s;color:inherit;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family;text-decoration:none;border-radius:0}.thumbnail-overlay__button__rlddz:hover{opacity:.7}.thumbnail-overlay__button__rlddz.thumbnail-overlay__bordered__3ASn8{border:1px solid #fff;background:transparent}.thumbnail-overlay__button__rlddz .thumbnail-overlay__text__1a-yV{margin-bottom:-4px;border-bottom:2px solid #fff;line-height:normal}.thumbnail-overlay__play-icon__-w10y{}@media only screen and (max-width:320px){.thumbnail-overlay__overlay__1nyI8 .thumbnail-overlay__buttons__2EwyB{margin-top:25px}.thumbnail-overlay__overlay__1nyI8 .thumbnail-overlay__buttons__2EwyB .thumbnail-overlay__button__rlddz{margin:0 5px}}.thumbnail-overlay__button__rlddz .thumbnail-overlay__next-icon__26WPJ,.thumbnail-overlay__button__rlddz .thumbnail-overlay__play-icon__-w10y{font-size:14px}.thumbnail-overlay__button__rlddz .thumbnail-overlay__play-icon__-w10y{margin-right:11px}.thumbnail-overlay__button__rlddz .thumbnail-overlay__next-icon__26WPJ{margin-left:11px}@media only screen and (max-width:320px){.thumbnail-overlay__button__rlddz .thumbnail-overlay__play-icon__-w10y{font-size:10px}}.thumbnail-overlay__overlay-wrapper__1O3Ad{position:absolute;top:0;left:0;right:0;bottom:0;z-index:1;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:stretch;align-items:stretch;color:#fff}.thumbnail-overlay__overlay-wrapper__1O3Ad.thumbnail-overlay__preview-hover__R0mUO .thumbnail-overlay__background__2-yEm,.thumbnail-overlay__overlay-wrapper__1O3Ad.thumbnail-overlay__visible__1U0vQ .thumbnail-overlay__background__2-yEm,.thumbnail-overlay__overlay-wrapper__1O3Ad:hover .thumbnail-overlay__background__2-yEm{background-color:rgba(0,0,0,.5)}.thumbnail-overlay__overlay-wrapper__1O3Ad.thumbnail-overlay__preview-hover__R0mUO .thumbnail-overlay__content__2MZkG,.thumbnail-overlay__overlay-wrapper__1O3Ad.thumbnail-overlay__visible__1U0vQ .thumbnail-overlay__content__2MZkG,.thumbnail-overlay__overlay-wrapper__1O3Ad:hover .thumbnail-overlay__content__2MZkG{transform:translateZ(0);opacity:1}.thumbnail-overlay__overlay-wrapper__1O3Ad.thumbnail-overlay__visible__1U0vQ:hover .thumbnail-overlay__button__rlddz,.thumbnail-overlay__overlay-wrapper__1O3Ad.thumbnail-overlay__visible__1U0vQ:hover .thumbnail-overlay__title-block__13rfX{opacity:.7}.thumbnail-overlay__overlay-wrapper__1O3Ad.thumbnail-overlay__visible__1U0vQ:hover .thumbnail-overlay__button__rlddz:active,.thumbnail-overlay__overlay-wrapper__1O3Ad.thumbnail-overlay__visible__1U0vQ:hover .thumbnail-overlay__button__rlddz:focus,.thumbnail-overlay__overlay-wrapper__1O3Ad.thumbnail-overlay__visible__1U0vQ:hover .thumbnail-overlay__button__rlddz:hover{opacity:1}.thumbnail-overlay__overlay-wrapper__1O3Ad.thumbnail-overlay__preview-hover__R0mUO .thumbnail-overlay__background__2-yEm,.thumbnail-overlay__overlay-wrapper__1O3Ad.thumbnail-overlay__preview-hover__R0mUO .thumbnail-overlay__content__2MZkG,.thumbnail-overlay__overlay-wrapper__1O3Ad.thumbnail-overlay__preview-hover__R0mUO .thumbnail-overlay__title-block__13rfX{transition-delay:.3s}.thumbnail-overlay__background__2-yEm{position:absolute;top:0;left:0;right:0;bottom:0;background-color:transparent;transition:background-color .45s ease-in-out}.thumbnail-overlay__content__2MZkG{padding:0;opacity:0;transform:translate3d(0,30px,0);transition:opacity .45s,transform .65s}.thumbnail-overlay__content__2MZkG,.thumbnail-overlay__top-content__3DNWA{width:100%}.thumbnail-overlay__top-content__3DNWA .thumbnail-overlay__title-block__13rfX{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;width:100%;white-space:nowrap;transition:opacity .2s}.thumbnail-overlay__top-content__3DNWA .thumbnail-overlay__title__qAwro{width:calc(100% - 32px);max-width:100%;height:auto;margin:0 16px 14px;font-weight:-wix-fonts-videoInfoFont-weight;font-style:-wix-fonts-videoInfoFont-style;text-decoration:-wix-fonts-videoInfoFont-decoration;font-size:-wix-fonts-videoInfoFont-size}.thumbnail-overlay__top-content__3DNWA .thumbnail-overlay__title__qAwro .thumbnail-overlay__preview-text__4n7ex{display:none}.thumbnail-overlay__top-content__3DNWA .thumbnail-overlay__publisher__1-LXl{width:100%;font-size:14px;margin-bottom:10px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.thumbnail-overlay__top-content__3DNWA .thumbnail-overlay__buttons-wrapper__2mXOL{height:30px}.thumbnail-overlay__top-content__3DNWA .thumbnail-overlay__buttons-wrapper__2mXOL:first-child{margin-top:0}.thumbnail-overlay__top-content__3DNWA .thumbnail-overlay__buttons-wrapper__2mXOL .thumbnail-overlay__button__rlddz{font-size:14px;font-weight:700;line-height:28px}.thumbnail-overlay__top-content__3DNWA .thumbnail-overlay__buttons-wrapper__2mXOL .thumbnail-overlay__button__rlddz+.thumbnail-overlay__button__rlddz{margin-left:28px}.thumbnail-overlay__top-content__3DNWA .thumbnail-overlay__buttons-wrapper__2mXOL .thumbnail-overlay__button__rlddz.thumbnail-overlay__small-buy-button__Sw8f4{margin-left:4px}.thumbnail-overlay__small-buttons__34VwV{visibility:hidden}.thumbnail-overlay__paid-icon__1wbap{}.thumbnail-overlay__paid-icon__1wbap:before{left:-1px;position:relative}.thumbnail-overlay__play-icon__-w10y:before{transform:scale(.8)}.thumbnail-overlay__button__rlddz{height:30px}.thumbnail-overlay__button__rlddz .thumbnail-overlay__icon__2gzrz{font-size:14px}.thumbnail-overlay__button__rlddz .thumbnail-overlay__paid-icon__1wbap,.thumbnail-overlay__button__rlddz .thumbnail-overlay__play-icon__-w10y{width:28px;height:28px}", ""]);

// exports
exports.locals = {
	"overlay": "thumbnail-overlay__overlay__1nyI8",
	"content": "thumbnail-overlay__content__2MZkG",
	"top-content": "thumbnail-overlay__top-content__3DNWA",
	"topContent": "thumbnail-overlay__top-content__3DNWA",
	"title": "thumbnail-overlay__title__qAwro",
	"preview-text": "thumbnail-overlay__preview-text__4n7ex",
	"previewText": "thumbnail-overlay__preview-text__4n7ex",
	"publisher": "thumbnail-overlay__publisher__1-LXl",
	"buttons-wrapper": "thumbnail-overlay__buttons-wrapper__2mXOL",
	"buttonsWrapper": "thumbnail-overlay__buttons-wrapper__2mXOL",
	"button": "thumbnail-overlay__button__rlddz",
	"rounded-icon": "thumbnail-overlay__rounded-icon__ppGhV",
	"roundedIcon": "thumbnail-overlay__rounded-icon__ppGhV",
	"bordered": "thumbnail-overlay__bordered__3ASn8",
	"text": "thumbnail-overlay__text__1a-yV",
	"play-icon": "thumbnail-overlay__play-icon__-w10y thumbnail-overlay__rounded-icon__ppGhV",
	"playIcon": "thumbnail-overlay__play-icon__-w10y thumbnail-overlay__rounded-icon__ppGhV",
	"buttons": "thumbnail-overlay__buttons__2EwyB",
	"next-icon": "thumbnail-overlay__next-icon__26WPJ",
	"nextIcon": "thumbnail-overlay__next-icon__26WPJ",
	"overlay-wrapper": "thumbnail-overlay__overlay-wrapper__1O3Ad",
	"overlayWrapper": "thumbnail-overlay__overlay-wrapper__1O3Ad",
	"preview-hover": "thumbnail-overlay__preview-hover__R0mUO",
	"previewHover": "thumbnail-overlay__preview-hover__R0mUO",
	"background": "thumbnail-overlay__background__2-yEm",
	"visible": "thumbnail-overlay__visible__1U0vQ",
	"title-block": "thumbnail-overlay__title-block__13rfX",
	"titleBlock": "thumbnail-overlay__title-block__13rfX",
	"small-buy-button": "thumbnail-overlay__small-buy-button__Sw8f4",
	"smallBuyButton": "thumbnail-overlay__small-buy-button__Sw8f4",
	"small-buttons": "thumbnail-overlay__small-buttons__34VwV",
	"smallButtons": "thumbnail-overlay__small-buttons__34VwV",
	"paid-icon": "thumbnail-overlay__paid-icon__1wbap thumbnail-overlay__rounded-icon__ppGhV",
	"paidIcon": "thumbnail-overlay__paid-icon__1wbap thumbnail-overlay__rounded-icon__ppGhV",
	"icon": "thumbnail-overlay__icon__2gzrz"
};

/***/ }),
/* 2931 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".mobile__container__19cXa{background-color:-wix-colors-backgroundColor;box-sizing:border-box}", ""]);

// exports
exports.locals = {
	"container": "mobile__container__19cXa"
};

/***/ }),
/* 2932 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".classic__spinner-container__1Q6ZD{position:absolute;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;background-color:-wix-colors-backgroundColor}.classic__spinner__347tM{color:-wix-colors-buttonsAndLinksColor}.classic__container__1jqwh{-ms-flex-direction:column;flex-direction:column;background-color:-wix-colors-backgroundColor;padding:0 20px 20px;box-sizing:border-box}.classic__container__1jqwh,.classic__header__atND2{display:-ms-flexbox;display:flex}.classic__header__atND2{height:55px;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between}.classic__empty-header__1q6EO{height:20px}.classic__channel-name__6j6Ar{font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family;text-decoration:-wix-fonts-textFont-decoration;font-size:18px;margin-right:20px;color:-wix-colors-textColor;-ms-flex-positive:1;flex-grow:1;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.classic__action__3Pkox{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;padding:0 20px;height:20px;border-right:1px solid -wix-colors-textColor-20;color:-wix-colors-buttonsAndLinksColor-80}.classic__action__3Pkox:hover{color:-wix-colors-buttonsAndLinksColor}.classic__action__3Pkox:last-child{padding-right:0;border-right:none}.classic__player-wrapper__S5v5r{position:relative}.classic__player__O-T8Z{-ms-flex:0 0 auto;flex:0 0 auto}.classic__content__2PN0E,.classic__player__O-T8Z{display:-ms-flexbox;display:flex}.classic__content__2PN0E{-ms-flex-direction:column;flex-direction:column;margin-top:15px;-ms-flex:1;flex:1}.classic__no-search-bar__2LNDE{margin-top:5px}.classic__search-line__1fzGA{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:end;justify-content:flex-end;font-family:HelveticaNeueW01-55Roma,HelveticaNeueW02-55Roma,HelveticaNeueW10-55Roma,Helvetica Neue,ruble,Helvetica,Arial,sans-serif;font-size:14px;line-height:32px;-ms-flex:0 0 auto;flex:0 0 auto}.classic__search__2CJtk{-ms-flex:1;flex:1}.classic__categories__3wMY9{height:32px;width:162px;margin:5px 0}.classic__tags-wrapper__3ykcY{overflow:hidden;height:100%;padding-top:12px}.classic__tags__3dhpP,.classic__videos__3dhsr{position:relative;-ms-flex:1;flex:1}.classic__videos__3dhsr{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:justify;justify-content:space-between;overflow:hidden;margin-top:15px}.classic__channel-info-modal__oBZBG{background-color:-wix-colors-backgroundColor-95}.classic__channel-info-window__3vb1H{border-radius:0;max-height:656px;height:100%;width:624px}@media screen and (max-height:738px){.classic__channel-info-window__3vb1H{max-height:calc(100% - 60px)}}.classic__channel-info-modal-content__1icrk{height:100%;padding:0}.classic__coming-soon__8PRei{-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;-ms-flex:1;flex:1;color:-wix-colors-textColor;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family;text-decoration:-wix-fonts-textFont-decoration;font-size:20px}.classic__coming-soon__8PRei,.classic__overlay-only__1Z-_S{display:-ms-flexbox;display:flex}.classic__overlay-only__1Z-_S{position:relative}[data-view-mode=editor] .classic__overlay-only__1Z-_S{background-color:-wix-colors-emptyPlayerBgEditor}[data-view-mode=preview] .classic__overlay-only__1Z-_S,[data-view-mode=site] .classic__overlay-only__1Z-_S{background-color:-wix-colors-emptyPlayerBgSite}", ""]);

// exports
exports.locals = {
	"spinner-container": "classic__spinner-container__1Q6ZD",
	"spinnerContainer": "classic__spinner-container__1Q6ZD",
	"spinner": "classic__spinner__347tM",
	"container": "classic__container__1jqwh",
	"header": "classic__header__atND2",
	"empty-header": "classic__empty-header__1q6EO",
	"emptyHeader": "classic__empty-header__1q6EO",
	"channel-name": "classic__channel-name__6j6Ar",
	"channelName": "classic__channel-name__6j6Ar",
	"action": "classic__action__3Pkox",
	"player-wrapper": "classic__player-wrapper__S5v5r",
	"playerWrapper": "classic__player-wrapper__S5v5r",
	"player": "classic__player__O-T8Z",
	"content": "classic__content__2PN0E",
	"no-search-bar": "classic__no-search-bar__2LNDE",
	"noSearchBar": "classic__no-search-bar__2LNDE",
	"search-line": "classic__search-line__1fzGA",
	"searchLine": "classic__search-line__1fzGA",
	"search": "classic__search__2CJtk",
	"categories": "classic__categories__3wMY9",
	"tags-wrapper": "classic__tags-wrapper__3ykcY",
	"tagsWrapper": "classic__tags-wrapper__3ykcY",
	"tags": "classic__tags__3dhpP",
	"videos": "classic__videos__3dhsr",
	"channel-info-modal": "classic__channel-info-modal__oBZBG",
	"channelInfoModal": "classic__channel-info-modal__oBZBG",
	"channel-info-window": "classic__channel-info-window__3vb1H",
	"channelInfoWindow": "classic__channel-info-window__3vb1H",
	"channel-info-modal-content": "classic__channel-info-modal-content__1icrk",
	"channelInfoModalContent": "classic__channel-info-modal-content__1icrk",
	"coming-soon": "classic__coming-soon__8PRei",
	"comingSoon": "classic__coming-soon__8PRei",
	"overlay-only": "classic__overlay-only__1Z-_S",
	"overlayOnly": "classic__overlay-only__1Z-_S"
};

/***/ }),
/* 2933 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".video-list-item__video-list-item__1CKII{position:relative;margin-right:10px;margin-bottom:10px}.video-list-item__video-list-item__1CKII.video-list-item__is-last__2KzKB{margin-right:0}", ""]);

// exports
exports.locals = {
	"video-list-item": "video-list-item__video-list-item__1CKII",
	"videoListItem": "video-list-item__video-list-item__1CKII",
	"is-last": "video-list-item__is-last__2KzKB",
	"isLast": "video-list-item__is-last__2KzKB"
};

/***/ }),
/* 2934 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".videos__container__1DBOF{margin-top:15px;height:100%}.videos__slider-container__3JEm3{overflow:visible}.videos__thumbnail-wrapper__2EUaA{position:relative;overflow:hidden}.videos__buttons__25xer{display:-ms-flexbox;display:flex;-ms-flex:0 0 auto;flex:0 0 auto;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between;width:100%;line-height:18px;height:18px;margin-top:14px;margin-bottom:5px}.videos__next-button__1QE64,.videos__prev-button__3Xlpb{background-color:rgba(0,0,0,.8)}.videos__next-button__1QE64>svg,.videos__prev-button__3Xlpb>svg{width:9px;height:18px}", ""]);

// exports
exports.locals = {
	"container": "videos__container__1DBOF",
	"slider-container": "videos__slider-container__3JEm3",
	"sliderContainer": "videos__slider-container__3JEm3",
	"thumbnail-wrapper": "videos__thumbnail-wrapper__2EUaA",
	"thumbnailWrapper": "videos__thumbnail-wrapper__2EUaA",
	"buttons": "videos__buttons__25xer",
	"next-button": "videos__next-button__1QE64",
	"nextButton": "videos__next-button__1QE64",
	"prev-button": "videos__prev-button__3Xlpb",
	"prevButton": "videos__prev-button__3Xlpb"
};

/***/ }),
/* 2935 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".compact__spinner-container__3f9bN{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.compact__share-channel-overlay__3d3wA{z-index:126}.compact__share-channel-overlay__3d3wA,.compact__spinner-container__3f9bN{position:absolute;top:0;left:0;right:0;bottom:0}.compact__spinner-container__3f9bN{background-color:-wix-colors-backgroundColor}.compact__spinner__33deO{color:-wix-colors-buttonsAndLinksColor}.compact__videos-in-animation__3BUuy{transition-delay:.2s}.compact__content__2Xv97{position:relative;background-color:-wix-colors-backgroundColor-100;transition:height .2s linear}.compact__content__2Xv97:before{position:absolute;top:0;left:0;right:0;bottom:0;content:\"\";background-color:-wix-colors-buttonsAndLinksColor-15}.compact__nav-button-next__3ik1z,.compact__nav-button-prev__3zLzf{width:auto;opacity:0;background-color:transparent;z-index:130;padding:0;transition:opacity .2s,color .2s}.compact__nav-button-next__3ik1z>svg,.compact__nav-button-prev__3zLzf>svg{width:23px;height:46px}:hover .compact__nav-button-next__3ik1z,:hover .compact__nav-button-prev__3zLzf{opacity:1}.compact__nav-button-prev__3zLzf{margin-left:30px}.compact__nav-button-next__3ik1z{margin-right:30px}@media (max-width:549px){.compact__nav-button-next__3ik1z>svg,.compact__nav-button-prev__3zLzf>svg{width:16px;height:30px}.compact__nav-button-prev__3zLzf{margin-left:20px}.compact__nav-button-next__3ik1z{margin-right:20px}}.compact__action-bar-nav-button__3j5h5{width:74px;border:none;padding:0}.compact__action-bar-nav-button__3j5h5>svg path{stroke:-wix-colors-buttonsAndLinksColor}.compact__action-bar-nav-icon__3CeDO{font-weight:800}.compact__video-overlay-container__cXrTu{position:relative;width:100%;height:100%}", ""]);

// exports
exports.locals = {
	"spinner-container": "compact__spinner-container__3f9bN",
	"spinnerContainer": "compact__spinner-container__3f9bN",
	"share-channel-overlay": "compact__share-channel-overlay__3d3wA",
	"shareChannelOverlay": "compact__share-channel-overlay__3d3wA",
	"spinner": "compact__spinner__33deO",
	"videos-in-animation": "compact__videos-in-animation__3BUuy",
	"videosInAnimation": "compact__videos-in-animation__3BUuy",
	"content": "compact__content__2Xv97",
	"nav-button-next": "compact__nav-button-next__3ik1z",
	"navButtonNext": "compact__nav-button-next__3ik1z",
	"nav-button-prev": "compact__nav-button-prev__3zLzf",
	"navButtonPrev": "compact__nav-button-prev__3zLzf",
	"action-bar-nav-button": "compact__action-bar-nav-button__3j5h5",
	"actionBarNavButton": "compact__action-bar-nav-button__3j5h5",
	"action-bar-nav-icon": "compact__action-bar-nav-icon__3CeDO",
	"actionBarNavIcon": "compact__action-bar-nav-icon__3CeDO",
	"video-overlay-container": "compact__video-overlay-container__cXrTu",
	"videoOverlayContainer": "compact__video-overlay-container__cXrTu"
};

/***/ }),
/* 2936 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".action-bar__clickable-container__17w7F{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;-ms-flex-positive:1;flex-grow:1;height:100%}.action-bar__menu-button-wrapper__1QIyl{width:100%}.action-bar__menu-button__13mIq{display:block}.action-bar__actions__bkO6Z{background-color:-wix-colors-backgroundColor;color:-wix-colors-buttonsAndLinksColor;transition:height .2s linear}.action-bar__actions__bkO6Z,.action-bar__actions-wrapper__1ujRd{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.action-bar__actions-wrapper__1ujRd{overflow:visible;position:relative;width:100%}.action-bar__buttons__3Tt6_{height:26px}", ""]);

// exports
exports.locals = {
	"clickable-container": "action-bar__clickable-container__17w7F",
	"clickableContainer": "action-bar__clickable-container__17w7F",
	"menu-button-wrapper": "action-bar__menu-button-wrapper__1QIyl",
	"menuButtonWrapper": "action-bar__menu-button-wrapper__1QIyl",
	"menu-button": "action-bar__menu-button__13mIq",
	"menuButton": "action-bar__menu-button__13mIq",
	"actions": "action-bar__actions__bkO6Z",
	"actions-wrapper": "action-bar__actions-wrapper__1ujRd",
	"actionsWrapper": "action-bar__actions-wrapper__1ujRd",
	"buttons": "action-bar__buttons__3Tt6_"
};

/***/ }),
/* 2937 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".channel-actions__channel-subscription-tooltip-content__3Kiag{color:inherit}.channel-actions__container__JiwW8{height:100%}.channel-actions__container__JiwW8,.channel-actions__icon__2DWnx,.channel-actions__item__yjhWX{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.channel-actions__label__2ixoS{font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family,Helvetica Neue,ruble,Helvetica,Arial,sans-serif;text-decoration:-wix-fonts-textFont-decoration;line-height:60px;margin-left:5px}.channel-actions__icon__2DWnx,.channel-actions__label__2ixoS{font-size:14px}.channel-actions__icon__2DWnx{padding:0 16px;color:inherit;height:inherit}.channel-actions__icon__2DWnx:hover{opacity:.6}.channel-actions__icon-account-info__1EllN{font-size:16px}.channel-actions__button-account-tooltip__3WPJS{padding-bottom:0}.channel-actions__button-account-tooltip-triangle__2Q6oK{margin-bottom:0}.channel-actions__icon-close__1-MZv{font-size:12px}.channel-actions__icon-close__1-MZv.channel-actions__with-label__o_g9P{padding-right:0}.channel-actions__icon-channel-info__32duj,.channel-actions__icon-paid__1OB7D{font-size:16px}.channel-actions__tooltip-inner__9XuCy{font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family,Helvetica Neue,ruble,Helvetica,Arial,sans-serif;text-decoration:-wix-fonts-textFont-decoration;font-size:12px}.channel-actions__item__yjhWX{position:relative;cursor:pointer;height:100%}.channel-actions__item__yjhWX:after{content:\"\";position:absolute;top:50%;right:0;width:1px;height:16px;margin-top:-8px;background:-wix-colors-buttonsAndLinksColor-30}.channel-actions__item__yjhWX:last-child:after{content:none}", ""]);

// exports
exports.locals = {
	"channel-subscription-tooltip-content": "channel-actions__channel-subscription-tooltip-content__3Kiag",
	"channelSubscriptionTooltipContent": "channel-actions__channel-subscription-tooltip-content__3Kiag",
	"container": "channel-actions__container__JiwW8",
	"icon": "channel-actions__icon__2DWnx",
	"item": "channel-actions__item__yjhWX",
	"label": "channel-actions__label__2ixoS",
	"icon-account-info": "channel-actions__icon-account-info__1EllN",
	"iconAccountInfo": "channel-actions__icon-account-info__1EllN",
	"button-account-tooltip": "channel-actions__button-account-tooltip__3WPJS",
	"buttonAccountTooltip": "channel-actions__button-account-tooltip__3WPJS",
	"button-account-tooltip-triangle": "channel-actions__button-account-tooltip-triangle__2Q6oK",
	"buttonAccountTooltipTriangle": "channel-actions__button-account-tooltip-triangle__2Q6oK",
	"icon-close": "channel-actions__icon-close__1-MZv",
	"iconClose": "channel-actions__icon-close__1-MZv",
	"with-label": "channel-actions__with-label__o_g9P",
	"withLabel": "channel-actions__with-label__o_g9P",
	"icon-channel-info": "channel-actions__icon-channel-info__32duj",
	"iconChannelInfo": "channel-actions__icon-channel-info__32duj",
	"icon-paid": "channel-actions__icon-paid__1OB7D",
	"iconPaid": "channel-actions__icon-paid__1OB7D",
	"tooltip-inner": "channel-actions__tooltip-inner__9XuCy",
	"tooltipInner": "channel-actions__tooltip-inner__9XuCy"
};

/***/ }),
/* 2938 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".closable-overlay__background-overlay__3XGbj,.closable-overlay__content__3Y1RC,.closable-overlay__overlay__1466f{position:absolute;top:0;left:0;right:0;bottom:0}.closable-overlay__overlay__1466f{z-index:10}.closable-overlay__close__1rl6s{position:absolute;z-index:2;top:32px;right:32px;overflow:hidden;color:#fff;font-size:12px;cursor:pointer}.closable-overlay__close__1rl6s:hover{opacity:.6}@media (max-width:549px){.closable-overlay__close__1rl6s{top:20px;right:20px}}.closable-overlay__content__3Y1RC{z-index:1;color:#fff;background-color:rgba(0,0,0,.8)}", ""]);

// exports
exports.locals = {
	"background-overlay": "closable-overlay__background-overlay__3XGbj",
	"backgroundOverlay": "closable-overlay__background-overlay__3XGbj",
	"content": "closable-overlay__content__3Y1RC",
	"overlay": "closable-overlay__overlay__1466f",
	"close": "closable-overlay__close__1rl6s"
};

/***/ }),
/* 2939 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".menu-button__button__3uWSE{background:none;border:none;outline:none;padding:0;height:100%;cursor:pointer}.menu-button__icon__170gY{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;width:60px;height:100%}.menu-button__icon__170gY svg{fill:-wix-colors-buttonsAndLinksColor;width:22px;margin:0 auto}.menu-button__icon__170gY:hover{opacity:.7}", ""]);

// exports
exports.locals = {
	"button": "menu-button__button__3uWSE",
	"icon": "menu-button__icon__170gY"
};

/***/ }),
/* 2940 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".overlay__container__2o26I{position:absolute;top:0;left:0;right:0;bottom:0;z-index:125;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;background-color:rgba(0,0,0,.5);-ms-flex-align:stretch;align-items:stretch;color:#fff}.overlay__container__2o26I.overlay__visible__3Fsv4:hover .overlay__button__1kaGh,.overlay__container__2o26I.overlay__visible__3Fsv4:hover .overlay__title-block__3MKEV{opacity:.7}.overlay__container__2o26I.overlay__visible__3Fsv4:hover .overlay__button__1kaGh:active,.overlay__container__2o26I.overlay__visible__3Fsv4:hover .overlay__button__1kaGh:focus,.overlay__container__2o26I.overlay__visible__3Fsv4:hover .overlay__button__1kaGh:hover{opacity:1}.overlay__cover__cGSxS{position:absolute;top:0;left:0;right:0;bottom:0;background-color:#000}.overlay__content__3Cx11{-ms-flex:1 1 auto;flex:1 1 auto;padding:0;opacity:1;z-index:2}.overlay__content__3Cx11,.overlay__top-content__yHsji{width:100%;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;align-items:center}.overlay__top-content__yHsji{-ms-flex-pack:center;justify-content:center;-ms-flex:1 1 auto;flex:1 1 auto}.overlay__title-block__3MKEV{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;width:100%;white-space:nowrap;transition:opacity .2s;padding:0 90px;text-align:center}.overlay__title__ARp4n{width:calc(100% - 32px);height:auto;margin:0 16px 14px;font-size:-wix-fonts-titleFont-size;line-height:1.5;font-weight:-wix-fonts-titleFont-weight;font-style:-wix-fonts-titleFont-style;font-family:-wix-fonts-titleFont-family,Helvetica Neue,ruble,Helvetica,Arial,sans-serif;text-decoration:-wix-fonts-titleFont-decoration;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.overlay__buttons-wrapper__2q845{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;height:auto;width:100%}.overlay__buttons-wrapper__2q845:first-child{margin-top:0}.overlay__button__1kaGh{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;line-height:37px;height:40px;padding:0;transition:opacity .2s;color:inherit;font-size:18px;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family,Helvetica Neue,ruble,Helvetica,Arial,sans-serif;text-decoration:none;border-radius:0}.overlay__button__1kaGh .overlay__text__GfFGg{margin-bottom:-4px;border-bottom:2px solid #fff;line-height:normal}.overlay__button__1kaGh+.overlay__button__1kaGh{margin-left:35px}.overlay__icon__v-Zng{font-size:14px;width:37px;height:37px;padding-left:2px;border-color:#fff;border-width:2px;margin-right:0;text-decoration:none}.overlay__icon__v-Zng+.overlay__text__GfFGg{margin-left:11px}.overlay__only-icon__3kcU6{height:56px}.overlay__only-icon__3kcU6 .overlay__icon__v-Zng{display:-ms-flexbox;display:flex;font-size:24px;width:56px;height:56px}.overlay__only-icon__3kcU6 .overlay__text__GfFGg{display:none}.overlay__button__1kaGh .overlay__text__GfFGg{white-space:nowrap}.overlay__button__1kaGh+.overlay__button__1kaGh{margin-left:20px}@media (max-width:700px){.overlay__title-block__3MKEV{padding:0 90px}}@media (max-width:549px){.overlay__title-block__3MKEV{padding:0 66px}.overlay__title__ARp4n{font-size:28px}.overlay__only-icon__3kcU6{height:42px}.overlay__only-icon__3kcU6 .overlay__icon__v-Zng{font-size:18px;width:42px;height:42px}}@media (max-width:449px){.overlay__text__GfFGg{display:none}}@media (max-width:400px){.overlay__title__ARp4n{font-size:20px}.overlay__button__1kaGh+.overlay__button__1kaGh{margin-left:18px}.overlay__button__1kaGh .overlay__icon__v-Zng{width:42px;height:42px}.overlay__button__1kaGh .overlay__icon__v-Zng,.overlay__button__1kaGh .overlay__paid-icon__PPftE{display:-ms-flexbox;display:flex}}", ""]);

// exports
exports.locals = {
	"container": "overlay__container__2o26I",
	"visible": "overlay__visible__3Fsv4",
	"button": "overlay__button__1kaGh",
	"title-block": "overlay__title-block__3MKEV",
	"titleBlock": "overlay__title-block__3MKEV",
	"cover": "overlay__cover__cGSxS",
	"content": "overlay__content__3Cx11",
	"top-content": "overlay__top-content__yHsji",
	"topContent": "overlay__top-content__yHsji",
	"title": "overlay__title__ARp4n",
	"buttons-wrapper": "overlay__buttons-wrapper__2q845",
	"buttonsWrapper": "overlay__buttons-wrapper__2q845",
	"text": "overlay__text__GfFGg",
	"icon": "overlay__icon__v-Zng",
	"only-icon": "overlay__only-icon__3kcU6",
	"onlyIcon": "overlay__only-icon__3kcU6",
	"paid-icon": "overlay__paid-icon__PPftE",
	"paidIcon": "overlay__paid-icon__PPftE"
};

/***/ }),
/* 2941 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".video-thumbnail-overlay__container__1fYwm{position:absolute;top:0;left:0;right:0;bottom:0;z-index:125;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;background-color:rgba(0,0,0,.5);-ms-flex-align:stretch;align-items:stretch;color:#fff}.video-thumbnail-overlay__container__1fYwm.video-thumbnail-overlay__visible__1dMFA:hover .video-thumbnail-overlay__button__3_eXo,.video-thumbnail-overlay__container__1fYwm.video-thumbnail-overlay__visible__1dMFA:hover .video-thumbnail-overlay__title-block__2pMWB{opacity:.7}.video-thumbnail-overlay__container__1fYwm.video-thumbnail-overlay__visible__1dMFA:hover .video-thumbnail-overlay__button__3_eXo:active,.video-thumbnail-overlay__container__1fYwm.video-thumbnail-overlay__visible__1dMFA:hover .video-thumbnail-overlay__button__3_eXo:focus,.video-thumbnail-overlay__container__1fYwm.video-thumbnail-overlay__visible__1dMFA:hover .video-thumbnail-overlay__button__3_eXo:hover{opacity:1}.video-thumbnail-overlay__cover__2VdRr{position:absolute;top:0;left:0;right:0;bottom:0;background-color:#000}.video-thumbnail-overlay__content__hibx4{-ms-flex:1 1 auto;flex:1 1 auto;padding:0;opacity:1;z-index:2}.video-thumbnail-overlay__content__hibx4,.video-thumbnail-overlay__top-content__2aHtF{width:100%;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;align-items:center}.video-thumbnail-overlay__top-content__2aHtF{-ms-flex-pack:center;justify-content:center;-ms-flex:1 1 auto;flex:1 1 auto}.video-thumbnail-overlay__title-block__2pMWB{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;width:100%;white-space:nowrap;transition:opacity .2s;padding:0 90px;text-align:center}.video-thumbnail-overlay__title__n2gWg{width:calc(100% - 32px);height:auto;margin:0 16px 14px;font-size:-wix-fonts-titleFont-size;line-height:1.5;font-weight:-wix-fonts-titleFont-weight;font-style:-wix-fonts-titleFont-style;font-family:-wix-fonts-titleFont-family,Helvetica Neue,ruble,Helvetica,Arial,sans-serif;text-decoration:-wix-fonts-titleFont-decoration;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.video-thumbnail-overlay__buttons-wrapper__1SAYK{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;height:auto;width:100%}.video-thumbnail-overlay__buttons-wrapper__1SAYK:first-child{margin-top:0}.video-thumbnail-overlay__button__3_eXo{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;line-height:37px;height:40px;padding:0;transition:opacity .2s;color:inherit;font-size:18px;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family,Helvetica Neue,ruble,Helvetica,Arial,sans-serif;border-radius:0}.video-thumbnail-overlay__button__3_eXo .video-thumbnail-overlay__text__3E9xN{margin-bottom:-4px;border-bottom:2px solid #fff;line-height:normal}.video-thumbnail-overlay__button__3_eXo+.video-thumbnail-overlay__button__3_eXo{margin-left:35px}.video-thumbnail-overlay__icon__3D1QS{font-size:14px;width:37px;height:37px;padding-left:2px;border-color:#fff;border-width:2px;margin-right:0;text-decoration:none}.video-thumbnail-overlay__icon__3D1QS+.video-thumbnail-overlay__text__3E9xN{margin-left:11px}.video-thumbnail-overlay__only-icon__Fe-hF{height:56px}.video-thumbnail-overlay__only-icon__Fe-hF .video-thumbnail-overlay__icon__3D1QS{display:-ms-flexbox;display:flex;font-size:24px;width:56px;height:56px}.video-thumbnail-overlay__only-icon__Fe-hF .video-thumbnail-overlay__text__3E9xN{display:none}.video-thumbnail-overlay__content__hibx4{transition:transform .65s}.video-thumbnail-overlay__container__1fYwm{opacity:0;transition:opacity .45s}.video-thumbnail-overlay__container__1fYwm .video-thumbnail-overlay__content__hibx4{transform:translate3d(0,30px,0)}.video-thumbnail-overlay__container__1fYwm:hover{opacity:1}.video-thumbnail-overlay__container__1fYwm:hover .video-thumbnail-overlay__content__hibx4{transform:translateZ(0)}.video-thumbnail-overlay__container__1fYwm.video-thumbnail-overlay__always-hidden__eMcYU{opacity:1}.video-thumbnail-overlay__container__1fYwm.video-thumbnail-overlay__always-hidden__eMcYU .video-thumbnail-overlay__content__hibx4{transform:translateZ(0)}.video-thumbnail-overlay__container__1fYwm.video-thumbnail-overlay__always-hidden__eMcYU .video-thumbnail-overlay__title-block__2pMWB{display:none}.video-thumbnail-overlay__container__1fYwm.video-thumbnail-overlay__always-visible__tkNhj,.video-thumbnail-overlay__container__1fYwm.video-thumbnail-overlay__preview-hover__38fgf{opacity:1}.video-thumbnail-overlay__container__1fYwm.video-thumbnail-overlay__always-visible__tkNhj .video-thumbnail-overlay__content__hibx4,.video-thumbnail-overlay__container__1fYwm.video-thumbnail-overlay__preview-hover__38fgf .video-thumbnail-overlay__content__hibx4{transform:translateZ(0)}.video-thumbnail-overlay__container__1fYwm.video-thumbnail-overlay__preview-hover__38fgf{transition-delay:.3s}.video-thumbnail-overlay__title-block__2pMWB{padding:0}.video-thumbnail-overlay__title__n2gWg{margin:0;font-weight:-wix-fonts-videoInfoFont-weight;font-style:-wix-fonts-videoInfoFont-style;text-decoration:-wix-fonts-videoInfoFont-decoration;font-size:-wix-fonts-videoInfoFont-size;font-family:-wix-fonts-videoInfoFont-family}.video-thumbnail-overlay__button__3_eXo{height:auto;border:0;text-decoration:none}.video-thumbnail-overlay__button__3_eXo+.video-thumbnail-overlay__button__3_eXo{margin-left:20px}.video-thumbnail-overlay__icon__3D1QS{margin:0}@media (min-width:800px){.video-thumbnail-overlay__buttons-wrapper__1SAYK,.video-thumbnail-overlay__only-icon__Fe-hF{height:56px}.video-thumbnail-overlay__button__3_eXo .video-thumbnail-overlay__icon__3D1QS,.video-thumbnail-overlay__only-icon__Fe-hF .video-thumbnail-overlay__icon__3D1QS{font-size:28px;width:56px;height:56px}.video-thumbnail-overlay__title-block__2pMWB{padding:0 30px}.video-thumbnail-overlay__title__n2gWg{margin-bottom:24px;font-size:18px;line-height:24px}}@media (max-width:799px){.video-thumbnail-overlay__buttons-wrapper__1SAYK,.video-thumbnail-overlay__only-icon__Fe-hF{height:42px}.video-thumbnail-overlay__button__3_eXo .video-thumbnail-overlay__icon__3D1QS,.video-thumbnail-overlay__only-icon__Fe-hF .video-thumbnail-overlay__icon__3D1QS{font-size:21px;width:42px;height:42px}.video-thumbnail-overlay__title__n2gWg{margin-bottom:18px;font-size:16px;line-height:22px}}@media (max-width:599px){.video-thumbnail-overlay__title-block__2pMWB{padding:0 20px}.video-thumbnail-overlay__title__n2gWg{margin-bottom:8px}}@media (max-width:549px){.video-thumbnail-overlay__buttons-wrapper__1SAYK,.video-thumbnail-overlay__only-icon__Fe-hF{height:36px}.video-thumbnail-overlay__button__3_eXo .video-thumbnail-overlay__icon__3D1QS,.video-thumbnail-overlay__only-icon__Fe-hF .video-thumbnail-overlay__icon__3D1QS{font-size:18px;width:36px;height:36px}.video-thumbnail-overlay__title__n2gWg{font-size:14px;line-height:19px;margin-bottom:10px}.video-thumbnail-overlay__button__3_eXo+.video-thumbnail-overlay__button__3_eXo{margin-left:16px}}@media (max-width:449px){.video-thumbnail-overlay__buttons-wrapper__1SAYK,.video-thumbnail-overlay__only-icon__Fe-hF{height:26px}.video-thumbnail-overlay__button__3_eXo .video-thumbnail-overlay__icon__3D1QS,.video-thumbnail-overlay__only-icon__Fe-hF .video-thumbnail-overlay__icon__3D1QS{font-size:13px;width:26px;height:26px}.video-thumbnail-overlay__title-block__2pMWB{padding:0 14px}.video-thumbnail-overlay__title__n2gWg{font-size:12px;line-height:17px}.video-thumbnail-overlay__button__3_eXo+.video-thumbnail-overlay__button__3_eXo{margin-left:12px}}", ""]);

// exports
exports.locals = {
	"container": "video-thumbnail-overlay__container__1fYwm",
	"visible": "video-thumbnail-overlay__visible__1dMFA",
	"button": "video-thumbnail-overlay__button__3_eXo",
	"title-block": "video-thumbnail-overlay__title-block__2pMWB",
	"titleBlock": "video-thumbnail-overlay__title-block__2pMWB",
	"cover": "video-thumbnail-overlay__cover__2VdRr",
	"content": "video-thumbnail-overlay__content__hibx4",
	"top-content": "video-thumbnail-overlay__top-content__2aHtF",
	"topContent": "video-thumbnail-overlay__top-content__2aHtF",
	"title": "video-thumbnail-overlay__title__n2gWg",
	"buttons-wrapper": "video-thumbnail-overlay__buttons-wrapper__1SAYK",
	"buttonsWrapper": "video-thumbnail-overlay__buttons-wrapper__1SAYK",
	"text": "video-thumbnail-overlay__text__3E9xN",
	"icon": "video-thumbnail-overlay__icon__3D1QS",
	"only-icon": "video-thumbnail-overlay__only-icon__Fe-hF",
	"onlyIcon": "video-thumbnail-overlay__only-icon__Fe-hF",
	"always-hidden": "video-thumbnail-overlay__always-hidden__eMcYU",
	"alwaysHidden": "video-thumbnail-overlay__always-hidden__eMcYU",
	"always-visible": "video-thumbnail-overlay__always-visible__tkNhj",
	"alwaysVisible": "video-thumbnail-overlay__always-visible__tkNhj",
	"preview-hover": "video-thumbnail-overlay__preview-hover__38fgf",
	"previewHover": "video-thumbnail-overlay__preview-hover__38fgf"
};

/***/ }),
/* 2942 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".video-list-item__container__3KYEP{position:relative;overflow:hidden}", ""]);

// exports
exports.locals = {
	"container": "video-list-item__container__3KYEP"
};

/***/ }),
/* 2943 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".videos__container__ar8oZ{height:100%}.videos__thumbnail-wrapper__olWOu{position:relative;overflow:hidden}.videos__next-button__1doGS,.videos__prev-button__2BpIN{background-color:rgba(0,0,0,.8)}.videos__next-button__1doGS>svg,.videos__prev-button__2BpIN>svg{width:9px;height:18px}", ""]);

// exports
exports.locals = {
	"container": "videos__container__ar8oZ",
	"thumbnail-wrapper": "videos__thumbnail-wrapper__olWOu",
	"thumbnailWrapper": "videos__thumbnail-wrapper__olWOu",
	"next-button": "videos__next-button__1doGS",
	"nextButton": "videos__next-button__1doGS",
	"prev-button": "videos__prev-button__2BpIN",
	"prevButton": "videos__prev-button__2BpIN"
};

/***/ }),
/* 2944 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".with-tooltip__with-tooltip__1PYnY{display:-ms-flexbox;display:flex;position:relative;height:inherit;cursor:pointer}.with-tooltip__with-tooltip__1PYnY:focus{outline:none}.with-tooltip__with-tooltip__1PYnY:hover .with-tooltip__tooltip__1kRZn{display:inline}.with-tooltip__tooltip__1kRZn{box-sizing:border-box;display:none;position:absolute;z-index:126;top:-50px;padding-bottom:28px;left:50%;transform:translateX(-50%);text-align:center}.with-tooltip__tooltip-inner__15qpC{display:inline-block;padding:0 13px;background-color:#000;color:#fff;height:22px;line-height:22px;white-space:nowrap}", ""]);

// exports
exports.locals = {
	"with-tooltip": "with-tooltip__with-tooltip__1PYnY",
	"withTooltip": "with-tooltip__with-tooltip__1PYnY",
	"tooltip": "with-tooltip__tooltip__1kRZn",
	"tooltip-inner": "with-tooltip__tooltip-inner__15qpC",
	"tooltipInner": "with-tooltip__tooltip-inner__15qpC"
};

/***/ }),
/* 2945 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".video-list-item__container__16cqH{position:relative;overflow:hidden}", ""]);

// exports
exports.locals = {
	"container": "video-list-item__container__16cqH"
};

/***/ }),
/* 2946 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".videos__container__2qYPc{width:100%;height:100%;position:relative}.videos__thumbnail-wrapper__1tnmS{position:relative;overflow:hidden}.videos__next-button__1qqmh,.videos__prev-button__248HZ{background-color:rgba(0,0,0,.8);height:66px;width:50px;margin-top:-33px}.videos__next-button__1qqmh:hover,.videos__prev-button__248HZ:hover{opacity:1}.videos__next-button__1qqmh:hover>svg,.videos__prev-button__248HZ:hover>svg{opacity:1;transition:opacity .3s ease-in-out}.videos__next-button__1qqmh>svg,.videos__prev-button__248HZ>svg{opacity:.5;width:12px;height:24px}", ""]);

// exports
exports.locals = {
	"container": "videos__container__2qYPc",
	"thumbnail-wrapper": "videos__thumbnail-wrapper__1tnmS",
	"thumbnailWrapper": "videos__thumbnail-wrapper__1tnmS",
	"next-button": "videos__next-button__1qqmh",
	"nextButton": "videos__next-button__1qqmh",
	"prev-button": "videos__prev-button__248HZ",
	"prevButton": "videos__prev-button__248HZ"
};

/***/ }),
/* 2947 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".strip__spinner-container__20e7q{position:absolute;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;background-color:-wix-colors-backgroundColor}.strip__spinner__3-0Ki{color:-wix-colors-buttonsAndLinksColor}.strip__container__1Le9k{background-color:-wix-colors-backgroundColor}.strip__next-button__vuxYg,.strip__prev-button__1psB_{opacity:0;transition:opacity .5s;pointer-events:none}.strip__next-button__vuxYg>svg,.strip__prev-button__1psB_>svg{height:35px}.strip__prev-button__1psB_{left:54px}.strip__next-button__vuxYg{right:54px}.strip__player-container__1RBRo{position:relative}.strip__player-container__1RBRo:hover .strip__next-button__vuxYg,.strip__player-container__1RBRo:hover .strip__prev-button__1psB_{opacity:1;pointer-events:auto}.strip__player-container__1RBRo.strip__with-bottom-padding__WB03Z .strip__player-overlay__3KjSC{padding-bottom:107px}.strip__player-container__1RBRo .strip__player__3Nfpi{display:-ms-flexbox;display:flex}.strip__player-container__1RBRo .strip__all-videos__IR5KO,.strip__player-container__1RBRo .strip__search-line__1WJsh,.strip__player-container__1RBRo .strip__tags__3kzhE{position:absolute;left:54px;right:54px;z-index:130}.strip__player-container__1RBRo .strip__search-line__1WJsh{bottom:63px;height:42px;display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:justify;justify-content:space-between;font-family:HelveticaNeueW01-55Roma,HelveticaNeueW02-55Roma,HelveticaNeueW10-55Roma,Helvetica Neue,ruble,Helvetica,Arial,sans-serif;font-size:14px;line-height:32px}.strip__player-container__1RBRo .strip__search-line__1WJsh .strip__categories__1xAHd,.strip__player-container__1RBRo .strip__search-line__1WJsh .strip__search__30zKo{position:absolute;bottom:0}.strip__player-container__1RBRo .strip__search-line__1WJsh .strip__search__30zKo{left:0;min-width:146px}.strip__player-container__1RBRo .strip__search-line__1WJsh .strip__search__30zKo.strip__expanded__pHpgj{width:100%}.strip__player-container__1RBRo .strip__search-line__1WJsh .strip__categories__1xAHd{right:0;min-width:162px}.strip__player-container__1RBRo .strip__search-line__1WJsh .strip__channel-actions__25Qq7{display:-ms-flexbox;display:flex;-ms-flex:1;flex:1;line-height:1;padding:11px 0;-ms-flex-pack:center;justify-content:center}.strip__player-container__1RBRo .strip__tags__3kzhE{bottom:0;overflow:hidden;padding:0 48px;height:63px}.strip__player-container__1RBRo .strip__all-videos__IR5KO{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;bottom:56px}.strip__player-container__1RBRo .strip__all-videos__IR5KO .strip__button__1AiZE{height:51px;padding:0 24px;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family;border:1px solid #fff;background:transparent;transition:opacity .2s}.strip__player-container__1RBRo .strip__all-videos__IR5KO .strip__button__1AiZE:hover{opacity:.7}.strip__player-container__1RBRo .strip__all-videos__IR5KO .strip__button__1AiZE .strip__icon__28alZ{margin-left:13px;font-size:14px}.strip__videos-container__35A73{display:-ms-flexbox;display:flex}.strip__videos-container__35A73 .strip__videos__wSAcA{overflow:hidden}.strip__no-search-results__4GHnY{margin:100px auto auto;-ms-flex-positive:0;flex-grow:0}.strip__no-search-results__4GHnY.strip__stretched__2Y01z{margin:auto;-ms-flex-positive:1;flex-grow:1}.strip__account-button__mzall{color:#fff}.strip__account-button__mzall:hover{color:hsla(0,0%,100%,.7)}.strip__action__3Uzm-{padding-right:20px;border-radius:0;color:#fff;transition:color .2s;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family}.strip__action__3Uzm-:hover{color:hsla(0,0%,100%,.7)}.strip__action__3Uzm-+.strip__action__3Uzm-{padding-left:20px;border-left:1px solid #fff}.strip__action__3Uzm-:last-child{padding-right:0}.strip__normal-close-icon__3fTx3{display:inline-block;transform:rotate(45deg)}.strip__small-close-icon__1EPkw{margin-left:5px;display:inline-block;transform:rotate(45deg) scale(.8)}.strip__share-channel__3XzRo{margin-top:1px;line-height:19px}.strip__share-buttons__3yZM2{position:absolute;right:30px;color:#fff}.strip__channel-info-modal__Yanna{background-color:-wix-colors-backgroundColor-95}.strip__channel-info-window__1x5CA{border-radius:0;max-height:678px;height:100%}@media screen and (max-height:738px){.strip__channel-info-window__1x5CA{max-height:calc(100% - 60px)}}.strip__channel-info-modal-content__2kdFr{height:100%}.strip__overlay-only__1n94U{display:-ms-flexbox;display:flex;position:relative;background-position:50%;background-size:cover}[data-view-mode=editor] .strip__overlay-only__1n94U{background-color:-wix-colors-emptyPlayerBgEditor}[data-view-mode=preview] .strip__overlay-only__1n94U,[data-view-mode=site] .strip__overlay-only__1n94U{background-color:-wix-colors-emptyPlayerBgSite}.strip__coming-soon__3agPK{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;color:-wix-colors-textColor;font-weight:-wix-fonts-textFont-weight;font-style:-wix-fonts-textFont-style;font-family:-wix-fonts-textFont-family;text-decoration:-wix-fonts-textFont-decoration;font-size:20px}.strip__buttons-wrapper-no-margin__2Gf4G:first-child{margin-top:0}", ""]);

// exports
exports.locals = {
	"spinner-container": "strip__spinner-container__20e7q",
	"spinnerContainer": "strip__spinner-container__20e7q",
	"spinner": "strip__spinner__3-0Ki",
	"container": "strip__container__1Le9k",
	"next-button": "strip__next-button__vuxYg",
	"nextButton": "strip__next-button__vuxYg",
	"prev-button": "strip__prev-button__1psB_",
	"prevButton": "strip__prev-button__1psB_",
	"player-container": "strip__player-container__1RBRo",
	"playerContainer": "strip__player-container__1RBRo",
	"with-bottom-padding": "strip__with-bottom-padding__WB03Z",
	"withBottomPadding": "strip__with-bottom-padding__WB03Z",
	"player-overlay": "strip__player-overlay__3KjSC",
	"playerOverlay": "strip__player-overlay__3KjSC",
	"player": "strip__player__3Nfpi",
	"all-videos": "strip__all-videos__IR5KO",
	"allVideos": "strip__all-videos__IR5KO",
	"search-line": "strip__search-line__1WJsh",
	"searchLine": "strip__search-line__1WJsh",
	"tags": "strip__tags__3kzhE",
	"categories": "strip__categories__1xAHd",
	"search": "strip__search__30zKo",
	"expanded": "strip__expanded__pHpgj",
	"channel-actions": "strip__channel-actions__25Qq7",
	"channelActions": "strip__channel-actions__25Qq7",
	"button": "strip__button__1AiZE",
	"icon": "strip__icon__28alZ",
	"videos-container": "strip__videos-container__35A73",
	"videosContainer": "strip__videos-container__35A73",
	"videos": "strip__videos__wSAcA",
	"no-search-results": "strip__no-search-results__4GHnY",
	"noSearchResults": "strip__no-search-results__4GHnY",
	"stretched": "strip__stretched__2Y01z",
	"account-button": "strip__account-button__mzall",
	"accountButton": "strip__account-button__mzall",
	"action": "strip__action__3Uzm-",
	"normal-close-icon": "strip__normal-close-icon__3fTx3",
	"normalCloseIcon": "strip__normal-close-icon__3fTx3",
	"small-close-icon": "strip__small-close-icon__1EPkw",
	"smallCloseIcon": "strip__small-close-icon__1EPkw",
	"share-channel": "strip__share-channel__3XzRo",
	"shareChannel": "strip__share-channel__3XzRo",
	"share-buttons": "strip__share-buttons__3yZM2",
	"shareButtons": "strip__share-buttons__3yZM2",
	"channel-info-modal": "strip__channel-info-modal__Yanna",
	"channelInfoModal": "strip__channel-info-modal__Yanna",
	"channel-info-window": "strip__channel-info-window__1x5CA",
	"channelInfoWindow": "strip__channel-info-window__1x5CA",
	"channel-info-modal-content": "strip__channel-info-modal-content__2kdFr",
	"channelInfoModalContent": "strip__channel-info-modal-content__2kdFr",
	"overlay-only": "strip__overlay-only__1n94U",
	"overlayOnly": "strip__overlay-only__1n94U",
	"coming-soon": "strip__coming-soon__3agPK",
	"comingSoon": "strip__coming-soon__3agPK",
	"buttons-wrapper-no-margin": "strip__buttons-wrapper-no-margin__2Gf4G",
	"buttonsWrapperNoMargin": "strip__buttons-wrapper-no-margin__2Gf4G"
};

/***/ }),
/* 2948 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(false);
// imports


// module
exports.push([module.i, ".mobile__spinner-container__2Edq0{position:absolute;top:0;left:0;right:0;bottom:0;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.mobile__spinner__2Hber{color:-wix-colors-buttonsAndLinksColor}[data-layout=\"2\"] .mobile__spinner__2Hber{color:-wix-colors-mobileButtonsBackgroundColor}.mobile__container__K1HRY .mobile__box__3jUP3{display:inline-block;width:70px;height:50px}.mobile__container__K1HRY .mobile__header__18TAh{height:48px;padding:0 15px}.mobile__container__K1HRY .mobile__player-wrapper__28A-w{position:relative}.mobile__container__K1HRY .mobile__player-wrapper__28A-w .mobile__player__14Am3,.mobile__overlay-only__1R8CQ{display:-ms-flexbox;display:flex}.mobile__overlay-only__1R8CQ{position:relative}[data-view-mode=editor] .mobile__overlay-only__1R8CQ{background-color:-wix-colors-emptyPlayerBgEditor}[data-view-mode=preview] .mobile__overlay-only__1R8CQ,[data-view-mode=site] .mobile__overlay-only__1R8CQ{background-color:-wix-colors-emptyPlayerBgSite}.mobile__overlay-item-topmost__1TZxe{-ms-flex-negative:0;flex-shrink:0;position:relative}.mobile__new-mobile-ui-container__1XhG6{position:relative;background-color:#000}.mobile__real-player-placeholder__skeku{position:absolute;left:0;right:0;z-index:0}.mobile__players-list-slidable__ZTq1C{position:absolute;left:0;right:0;z-index:10}.mobile__single-item-cover__3Z3S3{position:relative}", ""]);

// exports
exports.locals = {
	"spinner-container": "mobile__spinner-container__2Edq0",
	"spinnerContainer": "mobile__spinner-container__2Edq0",
	"spinner": "mobile__spinner__2Hber",
	"container": "mobile__container__K1HRY",
	"box": "mobile__box__3jUP3",
	"header": "mobile__header__18TAh",
	"player-wrapper": "mobile__player-wrapper__28A-w",
	"playerWrapper": "mobile__player-wrapper__28A-w",
	"player": "mobile__player__14Am3",
	"overlay-only": "mobile__overlay-only__1R8CQ",
	"overlayOnly": "mobile__overlay-only__1R8CQ",
	"overlay-item-topmost": "mobile__overlay-item-topmost__1TZxe",
	"overlayItemTopmost": "mobile__overlay-item-topmost__1TZxe",
	"new-mobile-ui-container": "mobile__new-mobile-ui-container__1XhG6",
	"newMobileUiContainer": "mobile__new-mobile-ui-container__1XhG6",
	"real-player-placeholder": "mobile__real-player-placeholder__skeku",
	"realPlayerPlaceholder": "mobile__real-player-placeholder__skeku",
	"players-list-slidable": "mobile__players-list-slidable__ZTq1C",
	"playersListSlidable": "mobile__players-list-slidable__ZTq1C",
	"single-item-cover": "mobile__single-item-cover__3Z3S3",
	"singleItemCover": "mobile__single-item-cover__3Z3S3"
};

/***/ }),
/* 2949 */,
/* 2950 */,
/* 2951 */,
/* 2952 */,
/* 2953 */,
/* 2954 */,
/* 2955 */,
/* 2956 */,
/* 2957 */,
/* 2958 */,
/* 2959 */,
/* 2960 */,
/* 2961 */,
/* 2962 */,
/* 2963 */,
/* 2964 */,
/* 2965 */,
/* 2966 */,
/* 2967 */,
/* 2968 */,
/* 2969 */,
/* 2970 */,
/* 2971 */,
/* 2972 */,
/* 2973 */,
/* 2974 */,
/* 2975 */,
/* 2976 */,
/* 2977 */,
/* 2978 */,
/* 2979 */,
/* 2980 */,
/* 2981 */,
/* 2982 */,
/* 2983 */,
/* 2984 */,
/* 2985 */,
/* 2986 */,
/* 2987 */,
/* 2988 */,
/* 2989 */,
/* 2990 */,
/* 2991 */,
/* 2992 */,
/* 2993 */,
/* 2994 */,
/* 2995 */,
/* 2996 */,
/* 2997 */,
/* 2998 */,
/* 2999 */,
/* 3000 */,
/* 3001 */,
/* 3002 */,
/* 3003 */,
/* 3004 */,
/* 3005 */,
/* 3006 */,
/* 3007 */,
/* 3008 */,
/* 3009 */,
/* 3010 */,
/* 3011 */,
/* 3012 */,
/* 3013 */,
/* 3014 */,
/* 3015 */,
/* 3016 */,
/* 3017 */,
/* 3018 */,
/* 3019 */,
/* 3020 */,
/* 3021 */,
/* 3022 */,
/* 3023 */,
/* 3024 */,
/* 3025 */,
/* 3026 */,
/* 3027 */,
/* 3028 */,
/* 3029 */,
/* 3030 */,
/* 3031 */,
/* 3032 */,
/* 3033 */,
/* 3034 */,
/* 3035 */,
/* 3036 */,
/* 3037 */,
/* 3038 */,
/* 3039 */,
/* 3040 */,
/* 3041 */,
/* 3042 */,
/* 3043 */,
/* 3044 */,
/* 3045 */,
/* 3046 */,
/* 3047 */,
/* 3048 */,
/* 3049 */,
/* 3050 */,
/* 3051 */,
/* 3052 */,
/* 3053 */,
/* 3054 */,
/* 3055 */,
/* 3056 */,
/* 3057 */,
/* 3058 */,
/* 3059 */,
/* 3060 */,
/* 3061 */,
/* 3062 */,
/* 3063 */,
/* 3064 */,
/* 3065 */,
/* 3066 */,
/* 3067 */,
/* 3068 */,
/* 3069 */,
/* 3070 */,
/* 3071 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(2028);

/**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};

  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
  prefixes['Moz' + styleProp] = 'moz' + eventName;
  prefixes['ms' + styleProp] = 'MS' + eventName;
  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();

  return prefixes;
}

/**
 * A list of event names to a configurable list of vendor prefixes.
 */
var vendorPrefixes = {
  animationend: makePrefixMap('Animation', 'AnimationEnd'),
  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
  animationstart: makePrefixMap('Animation', 'AnimationStart'),
  transitionend: makePrefixMap('Transition', 'TransitionEnd')
};

/**
 * Event names that have already been detected and prefixed (if applicable).
 */
var prefixedEventNames = {};

/**
 * Element to check for prefixes on.
 */
var style = {};

/**
 * Bootstrap if a DOM exists.
 */
if (ExecutionEnvironment.canUseDOM) {
  style = document.createElement('div').style;

  // On some platforms, in particular some releases of Android 4.x,
  // the un-prefixed "animation" and "transition" properties are defined on the
  // style object but the events that fire will still be prefixed, so we need
  // to check if the un-prefixed events are usable, and if not remove them from the map.
  if (!('AnimationEvent' in window)) {
    delete vendorPrefixes.animationend.animation;
    delete vendorPrefixes.animationiteration.animation;
    delete vendorPrefixes.animationstart.animation;
  }

  // Same as above
  if (!('TransitionEvent' in window)) {
    delete vendorPrefixes.transitionend.transition;
  }
}

/**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  } else if (!vendorPrefixes[eventName]) {
    return eventName;
  }

  var prefixMap = vendorPrefixes[eventName];

  for (var styleProp in prefixMap) {
    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
      return prefixedEventNames[eventName] = prefixMap[styleProp];
    }
  }

  return '';
}

module.exports = getVendorPrefixedEventName;

/***/ }),
/* 3072 */,
/* 3073 */,
/* 3074 */,
/* 3075 */,
/* 3076 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(2028);

var getVendorPrefixedEventName = __webpack_require__(3071);

var endEvents = [];

function detectEvents() {
  var animEnd = getVendorPrefixedEventName('animationend');
  var transEnd = getVendorPrefixedEventName('transitionend');

  if (animEnd) {
    endEvents.push(animEnd);
  }

  if (transEnd) {
    endEvents.push(transEnd);
  }
}

if (ExecutionEnvironment.canUseDOM) {
  detectEvents();
}

// We use the raw {add|remove}EventListener() call because EventListener
// does not know how to remove event listeners and we really should
// clean up. Also, these events are not triggered in older browsers
// so we should be A-OK here.

function addEventListener(node, eventName, eventListener) {
  node.addEventListener(eventName, eventListener, false);
}

function removeEventListener(node, eventName, eventListener) {
  node.removeEventListener(eventName, eventListener, false);
}

var ReactTransitionEvents = {
  addEndEventListener: function (node, eventListener) {
    if (endEvents.length === 0) {
      // If CSS transitions are not supported, trigger an "end animation"
      // event immediately.
      window.setTimeout(eventListener, 0);
      return;
    }
    endEvents.forEach(function (endEvent) {
      addEventListener(node, endEvent, eventListener);
    });
  },

  removeEndEventListener: function (node, eventListener) {
    if (endEvents.length === 0) {
      return;
    }
    endEvents.forEach(function (endEvent) {
      removeEventListener(node, endEvent, eventListener);
    });
  }
};

module.exports = ReactTransitionEvents;

/***/ }),
/* 3077 */,
/* 3078 */,
/* 3079 */,
/* 3080 */,
/* 3081 */,
/* 3082 */,
/* 3083 */,
/* 3084 */,
/* 3085 */,
/* 3086 */,
/* 3087 */,
/* 3088 */,
/* 3089 */,
/* 3090 */,
/* 3091 */,
/* 3092 */,
/* 3093 */,
/* 3094 */,
/* 3095 */,
/* 3096 */,
/* 3097 */,
/* 3098 */,
/* 3099 */,
/* 3100 */,
/* 3101 */,
/* 3102 */,
/* 3103 */,
/* 3104 */,
/* 3105 */,
/* 3106 */,
/* 3107 */,
/* 3108 */,
/* 3109 */,
/* 3110 */,
/* 3111 */,
/* 3112 */,
/* 3113 */,
/* 3114 */,
/* 3115 */,
/* 3116 */,
/* 3117 */,
/* 3118 */,
/* 3119 */,
/* 3120 */,
/* 3121 */,
/* 3122 */,
/* 3123 */,
/* 3124 */,
/* 3125 */,
/* 3126 */,
/* 3127 */,
/* 3128 */,
/* 3129 */,
/* 3130 */,
/* 3131 */,
/* 3132 */,
/* 3133 */,
/* 3134 */,
/* 3135 */,
/* 3136 */,
/* 3137 */,
/* 3138 */,
/* 3139 */,
/* 3140 */,
/* 3141 */,
/* 3142 */,
/* 3143 */,
/* 3144 */,
/* 3145 */,
/* 3146 */,
/* 3147 */,
/* 3148 */,
/* 3149 */,
/* 3150 */,
/* 3151 */,
/* 3152 */,
/* 3153 */,
/* 3154 */,
/* 3155 */,
/* 3156 */,
/* 3157 */,
/* 3158 */,
/* 3159 */,
/* 3160 */,
/* 3161 */,
/* 3162 */,
/* 3163 */,
/* 3164 */,
/* 3165 */,
/* 3166 */,
/* 3167 */,
/* 3168 */,
/* 3169 */,
/* 3170 */,
/* 3171 */,
/* 3172 */,
/* 3173 */,
/* 3174 */,
/* 3175 */,
/* 3176 */,
/* 3177 */,
/* 3178 */,
/* 3179 */,
/* 3180 */,
/* 3181 */,
/* 3182 */,
/* 3183 */,
/* 3184 */,
/* 3185 */,
/* 3186 */,
/* 3187 */,
/* 3188 */,
/* 3189 */,
/* 3190 */,
/* 3191 */,
/* 3192 */,
/* 3193 */,
/* 3194 */,
/* 3195 */,
/* 3196 */,
/* 3197 */,
/* 3198 */,
/* 3199 */,
/* 3200 */,
/* 3201 */,
/* 3202 */,
/* 3203 */,
/* 3204 */,
/* 3205 */,
/* 3206 */,
/* 3207 */,
/* 3208 */,
/* 3209 */,
/* 3210 */,
/* 3211 */,
/* 3212 */,
/* 3213 */,
/* 3214 */,
/* 3215 */,
/* 3216 */,
/* 3217 */,
/* 3218 */,
/* 3219 */,
/* 3220 */,
/* 3221 */,
/* 3222 */,
/* 3223 */,
/* 3224 */,
/* 3225 */,
/* 3226 */,
/* 3227 */,
/* 3228 */,
/* 3229 */,
/* 3230 */,
/* 3231 */,
/* 3232 */,
/* 3233 */,
/* 3234 */,
/* 3235 */,
/* 3236 */,
/* 3237 */,
/* 3238 */,
/* 3239 */,
/* 3240 */,
/* 3241 */,
/* 3242 */,
/* 3243 */,
/* 3244 */,
/* 3245 */,
/* 3246 */,
/* 3247 */,
/* 3248 */,
/* 3249 */,
/* 3250 */,
/* 3251 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2902);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./account-button-with-tooltip.styl", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./account-button-with-tooltip.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3252 */,
/* 3253 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2904);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./animate-crossfade.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./animate-crossfade.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3254 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2905);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./categories.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./categories.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3255 */,
/* 3256 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2908);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./content-slider.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./content-slider.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3257 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2909);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./mobile-cover-with-overlay.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./mobile-cover-with-overlay.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3258 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2910);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./empty-search-results.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./empty-search-results.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3259 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2911);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./first-time-track-animation.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./first-time-track-animation.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3260 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2912);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./buttons.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./buttons.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3261 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2913);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./mobile-carousel.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./mobile-carousel.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3262 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2914);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./track.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./track.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3263 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2915);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./nav.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./nav.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3264 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2916);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./page-list.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./page-list.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3265 */,
/* 3266 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2918);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./classic.styl", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./classic.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3267 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2919);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./member-only.styl", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./member-only.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3268 */,
/* 3269 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2921);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./bottom-buttons.styl", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./bottom-buttons.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3270 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2922);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./middle-buttons.styl", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./middle-buttons.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3271 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2923);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./three-rows-widget.styl", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./three-rows-widget.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3272 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2924);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./classic-search-bar.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./classic-search-bar.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3273 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2925);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./strip-search-bar.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./strip-search-bar.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3274 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2926);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./share-channel.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./share-channel.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3275 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2928);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./thumbnail.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./thumbnail.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3276 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2929);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./nav-button.styl", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./nav-button.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3277 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2930);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./thumbnail-overlay.styl", function() {
			var newContent = require("!!../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./thumbnail-overlay.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3278 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2931);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./mobile.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./mobile.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3279 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2932);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./classic.styl", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./classic.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3280 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2933);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./video-list-item.styl", function() {
			var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./video-list-item.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3281 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2934);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./videos.styl", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./videos.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3282 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2935);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./compact.styl", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./compact.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3283 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2936);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./action-bar.styl", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./action-bar.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3284 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2937);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./channel-actions.styl", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./channel-actions.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3285 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2938);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./closable-overlay.styl", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./closable-overlay.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3286 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2939);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./menu-button.styl", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./menu-button.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3287 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2940);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./overlay.styl", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./overlay.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3288 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2941);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./video-thumbnail-overlay.styl", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./video-thumbnail-overlay.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3289 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2942);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./video-list-item.styl", function() {
			var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./video-list-item.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3290 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2943);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./videos.styl", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./videos.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3291 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2944);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./with-tooltip.styl", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./with-tooltip.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3292 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2945);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./video-list-item.styl", function() {
			var newContent = require("!!../../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./video-list-item.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3293 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2946);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./videos.styl", function() {
			var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../../../node_modules/stylus-loader/index.js??ref--2-3!./videos.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3294 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2947);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./strip.styl", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../../node_modules/stylus-loader/index.js??ref--2-3!./strip.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3295 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2948);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(8)(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./mobile.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js??ref--2-3!./mobile.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3296 */,
/* 3297 */,
/* 3298 */,
/* 3299 */,
/* 3300 */,
/* 3301 */,
/* 3302 */,
/* 3303 */,
/* 3304 */,
/* 3305 */,
/* 3306 */,
/* 3307 */,
/* 3308 */,
/* 3309 */,
/* 3310 */,
/* 3311 */,
/* 3312 */,
/* 3313 */,
/* 3314 */,
/* 3315 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2063);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// widget/widget.js